const stepsGeojson: any[] = [];


type coordinate_I = number[]

interface geometry_I {
  type: string,
  coordinates: coordinate_I[],
}

interface feature_I {
  type: string,
  properties: any,
  geometry: geometry_I
}

interface geojson_I {
  type: string,
  features: feature_I[],
}

let day1: geojson_I = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "Dunkerque - Zuydcoote - 10.3km",
        "track-length": "10349",
        "filtered ascend": "17",
        "plain-ascend": "4",
        "total-time": "1707",
        "total-energy": "170273",
        "cost": "13083",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["2368194", "51031860", "3", "43", "3050", "0", "0", "0", "0", "highway=pedestrian surface=asphalt", "", "4", "458"],
          ["2368846", "51032406", "3", "102", "3050", "0", "57", "0", "0", "highway=pedestrian", "", "17", "1771"],
          ["2368882", "51032408", "3", "3", "5050", "0", "91", "0", "0", "reversedirection=yes highway=footway", "highway=crossing wheelchair=yes crossing=unknown", "19", "1773"],
          ["2368888", "51032355", "3", "6", "1150", "0", "91", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes", "highway=give_way direction=forward", "20", "1852"],
          ["2368930", "51032276", "3", "11", "1150", "0", "3", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes", "", "22", "2000"],
          ["2369065", "51032221", "3", "13", "1150", "0", "11", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=give_way direction=backward", "23", "2165"],
          ["2369205", "51032226", "3", "11", "1150", "0", "6", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "24", "2270"],
          ["2370008", "51032325", "2", "58", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=traffic_signals traffic_signals:direction=forward", "30", "2836"],
          ["2370033", "51032328", "2", "2", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "30", "2857"],
          ["2370447", "51032206", "3", "36", "1150", "0", "11", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "35", "3332"],
          ["2370942", "51031974", "4", "44", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "", "43", "4154"],
          ["2371497", "51031954", "6", "42", "1650", "0", "6", "0", "0", "highway=secondary oneway=yes", "highway=traffic_signals traffic_signals:direction=forward", "53", "5162"],
          ["2371538", "51031959", "6", "3", "1650", "0", "0", "0", "0", "highway=secondary oneway=yes", "highway=crossing crossing=unknown", "54", "5240"],
          ["2371746", "51031996", "6", "16", "1650", "0", "4", "0", "0", "highway=secondary oneway=yes", "", "58", "5666"],
          ["2371713", "51032144", "6", "5", "21050", "0", "53", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "", "62", "5767"],
          ["2371746", "51031996", "6", "5", "1050", "0", "0", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "", "62", "5815"],
          ["2371631", "51032002", "6", "9", "1150", "0", "127", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "63", "5904"],
          ["2371578", "51032610", "5", "70", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "71", "6631"],
          ["2371531", "51032681", "5", "9", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "72", "6737"],
          ["2372395", "51035504", "8", "325", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "133", "12835"],
          ["2377931", "51039480", "6", "624", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "235", "23080"],
          ["2378056", "51039436", "6", "11", "1650", "0", "86", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "237", "23287"],
          ["2378182", "51039423", "6", "10", "1650", "0", "6", "0", "0", "highway=secondary oneway=yes", "", "239", "23479"],
          ["2378358", "51039599", "6", "25", "1150", "0", "41", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "243", "23923"],
          ["2378608", "51039863", "6", "35", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=uncontrolled", "249", "24484"],
          ["2378794", "51040041", "6", "25", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=uncontrolled", "253", "24890"],
          ["2379538", "51040458", "7", "73", "1150", "0", "1", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "267", "26313"],
          ["2380391", "51040599", "9", "64", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=traffic_signals traffic_signals:direction=forward", "284", "28021"],
          ["2380478", "51040608", "9", "7", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "286", "28195"],
          ["2380804", "51040645", "9", "24", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "292", "28759"],
          ["2381485", "51040720", "8", "49", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "", "302", "29744"],
          ["2382180", "51040689", "8", "50", "1050", "0", "3", "0", "0", "highway=cycleway oneway=yes", "highway=crossing crossing=unknown", "310", "30618"],
          ["2382396", "51040699", "8", "16", "1050", "0", "0", "0", "0", "highway=cycleway oneway=yes", "", "313", "30867"],
          ["2383093", "51040789", "7", "52", "1050", "0", "1", "0", "0", "highway=cycleway oneway=no", "", "320", "31623"],
          ["2385644", "51040922", "6", "183", "1050", "0", "3", "0", "0", "highway=cycleway oneway=yes", "", "347", "34229"],
          ["2385641", "51040948", "6", "3", "1150", "0", "74", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "347", "34273"],
          ["2385630", "51041049", "6", "12", "1150", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "349", "34450"],
          ["2385633", "51041016", "6", "4", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "349", "34487"],
          ["2385735", "51041021", "6", "8", "1150", "0", "92", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "350", "34563"],
          ["2386839", "51041071", "5", "80", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "358", "35355"],
          ["2387143", "51041085", "6", "22", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "361", "35647"],
          ["2388663", "51041156", "9", "107", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=traffic_signals traffic_signals:direction=forward", "389", "38514"],
          ["2388820", "51041163", "9", "12", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "392", "38759"],
          ["2389098", "51041180", "9", "21", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "highway=crossing crossing=unknown", "396", "39150"],
          ["2390152", "51041340", "8", "78", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "", "408", "40341"],
          ["2393262", "51042106", "8", "238", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "446", "44206"],
          ["2394776", "51042487", "8", "116", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "467", "46259"],
          ["2396189", "51042846", "7", "108", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "483", "47886"],
          ["2397000", "51043049", "7", "62", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "", "493", "48874"],
          ["2397471", "51043163", "7", "36", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes oneway=yes", "highway=crossing crossing=uncontrolled", "499", "49493"],
          ["2397735", "51043229", "7", "21", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes oneway=yes", "highway=crossing crossing=uncontrolled", "503", "49841"],
          ["2398191", "51043346", "7", "35", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes oneway=yes", "", "508", "50350"],
          ["2400684", "51043977", "8", "190", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "542", "53739"],
          ["2401153", "51044094", "8", "36", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "548", "54397"],
          ["2403598", "51044708", "8", "185", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "581", "57686"],
          ["2403833", "51044767", "8", "19", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "584", "57997"],
          ["2408036", "51045821", "8", "320", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "639", "63450"],
          ["2411632", "51046721", "11", "273", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "703", "69832"],
          ["2412141", "51046847", "10", "41", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "709", "70459"],
          ["2413991", "51047313", "9", "140", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "728", "72353"],
          ["2416645", "51047980", "10", "202", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "764", "75940"],
          ["2416827", "51048025", "10", "14", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=traffic_signals", "766", "76179"],
          ["2416952", "51048056", "10", "10", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "768", "76349"],
          ["2420036", "51048836", "10", "235", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "806", "80132"],
          ["2420873", "51049043", "9", "64", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=uncontrolled", "816", "81149"],
          ["2423244", "51049632", "9", "180", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "842", "83830"],
          ["2423654", "51049737", "9", "32", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "848", "84357"],
          ["2426503", "51050453", "7", "216", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "878", "87369"],
          ["2426804", "51050528", "7", "24", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "882", "87753"],
          ["2428949", "51051071", "7", "163", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "909", "90526"],
          ["2429227", "51051143", "7", "22", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "913", "90896"],
          ["2431223", "51051456", "8", "147", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "highway=crossing crossing=unknown", "940", "93566"],
          ["2431395", "51051449", "7", "14", "1150", "0", "4", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes oneway=yes", "", "942", "93792"],
          ["2431446", "51051423", "7", "90", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt junction=roundabout", "", "955", "95087"],
          ["2431509", "51051325", "7", "12", "1650", "0", "16", "0", "0", "highway=secondary surface=asphalt oneway=yes", "highway=crossing crossing=unknown", "956", "95199"],
          ["2431609", "51051173", "6", "19", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "958", "95375"],
          ["2431896", "51050566", "6", "74", "1150", "0", "1", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "railway=level_crossing", "965", "96122"],
          ["2431955", "51050489", "6", "11", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "967", "96235"],
          ["2468847", "51058705", "5", "2774", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=designated bicycle=designated route_bicycle_icn=yes", "", "1424", "142022"],
          ["2468603", "51058679", "5", "1", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated route_bicycle_icn=yes", "", "1424", "142032"],
          ["2468487", "51058506", "4", "23", "1050", "0", "34", "0", "0", "highway=path surface=concrete bicycle=designated", "", "1427", "142240"],
          ["2470776", "51057926", "4", "187", "1650", "0", "126", "0", "0", "reversedirection=yes highway=secondary surface=asphalt cycleway=lane", "", "1450", "144586"],
          ["2471279", "51057661", "4", "47", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "1457", "145297"],
          ["2472429", "51057417", "5", "91", "1150", "0", "1", "0", "0", "reversedirection=yes highway=residential", "", "1473", "146889"],
          ["2475326", "51057911", "7", "214", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "1505", "150120"],
          ["2477088", "51058324", "7", "133", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt cycleway=lane", "", "1528", "152360"],
          ["2481852", "51060274", "4", "406", "1150", "0", "0", "0", "0", "highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=lane oneway=no", "", "1586", "158146"],
          ["2483458", "51061071", "5", "144", "1150", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=lane oneway=no", "", "1614", "160948"],
          ["2483588", "51061135", "5", "12", "1150", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "1616", "161152"],
          ["2486637", "51062315", "6", "257", "1150", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "1666", "166194"],
          ["2489895", "51064174", "3", "303", "1150", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "1707", "170277"]
        ],
        "times": [0, 4.587, 5.166, 7.324, 7.694, 8.22, 8.884, 9.825, 13.524, 14.693, 15.486, 16.424, 17.715, 19.785, 20.579, 21.519, 22.061, 22.883, 23.436, 23.713, 24.181, 24.756, 29.689, 30.416, 30.627, 31.806, 32.825, 34.339, 35.377, 40.771, 43.601, 45.297, 47.673, 48.602, 53.678, 54.457, 56.356, 57.677, 58.714, 62.446, 62.926, 63.219, 63.814, 65.408, 68.962, 69.954, 71.09, 72.144, 72.983, 73.884, 79.105, 80.405, 109.732, 111.771, 115.303, 133.118, 134.73, 135.493, 145.799, 152.144, 155.716, 159.041, 160.45, 165.049, 169.983, 173.819, 179.538, 182.345, 186.408, 188.868, 192.039, 192.916, 208.083, 220.315, 222.965, 224.258, 225.843, 235.548, 237.619, 238.552, 239.546, 242.113, 243.984, 249.595, 251.701, 253.652, 255.938, 257.511, 260.109, 264.462, 267.883, 271.856, 273.636, 284.954, 286.693, 289.572, 292.337, 294.422, 302.182, 309.113, 310.923, 313.407, 314.975, 317.208, 318.774, 320.973, 331.686, 332.733, 344.291, 345.288, 347.021, 347.459, 348.635, 349.228, 349.597, 350.354, 350.841, 357.823, 358.275, 359.812, 361.199, 387.345, 389.86, 392.312, 394.183, 396.22, 401.738, 403.927, 408.123, 410.729, 412.902, 420.609, 433.834, 440.005, 444.632, 446.772, 465.105, 467.308, 469.056, 482.479, 483.572, 493.452, 499.648, 501.36, 503.125, 508.21, 520.114, 526.194, 542.099, 546.327, 548.68, 572.363, 581.569, 583.203, 584.677, 600.703, 612.697, 637.601, 639.203, 642.808, 689.801, 703.004, 705.718, 707.837, 709.279, 719.909, 728.214, 733.072, 736.735, 764.087, 766.474, 768.176, 777.165, 788.649, 806.009, 807.332, 816.175, 818.105, 842.986, 845.779, 848.251, 851.723, 878.37, 880.283, 882.206, 909.937, 912.126, 913.64, 917.399, 921.724, 924.855, 928.84, 933.581, 940.338, 941.628, 942.599, 943.055, 943.36, 943.971, 944.584, 945.163, 945.745, 946.368, 947.148, 947.932, 948.771, 949.61, 950.281, 951.177, 952.25, 953.318, 953.41, 953.781, 954.329, 954.703, 955.082, 955.361, 955.549, 956.667, 958.427, 961.592, 962.923, 963.883, 964.539, 965.21, 965.893, 966.473, 967.029, 967.793, 988.558, 1001.101, 1004.133, 1050.068, 1135.038, 1149.154, 1166.521, 1178.62, 1187.313, 1209.302, 1216.047, 1233.125, 1237.322, 1253.862, 1254.746, 1255.043, 1255.505, 1258.182, 1260.608, 1313.224, 1325.677, 1339.884, 1358.292, 1412.011, 1423.07, 1424.714, 1424.855, 1424.951, 1426.044, 1426.936, 1427.027, 1428.646, 1429.549, 1430.695, 1432.59, 1434.378, 1436.601, 1438.533, 1441.645, 1445.303, 1450.48, 1455.439, 1457.592, 1459.457, 1461.96, 1464.465, 1466.604, 1468.198, 1469.143, 1470.456, 1472.13, 1473.512, 1476.417, 1478.241, 1482.074, 1485.734, 1495.415, 1505.806, 1510.902, 1528.207, 1531.114, 1534.157, 1536.396, 1549.323, 1557.274, 1561.806, 1570.579, 1574.925, 1581.272, 1586.061, 1596.845, 1612.979, 1614.075, 1616.114, 1617.926, 1631.794, 1635.919, 1640.363, 1650.397, 1662.001, 1663.751, 1666.533, 1670.202, 1673.152, 1676.432, 1684.719, 1686.569, 1689.069, 1693.088, 1707.363]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [2.368358, 51.031491, 3.25],
          [2.368194, 51.031860, 3.75],
          [2.368175, 51.031903, 3.75],
          [2.368107, 51.032055, 3.75],
          [2.368106, 51.032074, 3.75],
          [2.368124, 51.032107, 4.0],
          [2.368178, 51.032128, 4.0],
          [2.368265, 51.032146, 4.0],
          [2.368646, 51.032211, 3.75],
          [2.368767, 51.032235, 3.5],
          [2.368830, 51.032270, 3.5],
          [2.368860, 51.032322, 3.5],
          [2.368846, 51.032406, 3.25],
          [2.368882, 51.032408, 3.25],
          [2.368888, 51.032355, 3.25],
          [2.368910, 51.032301, 3.25],
          [2.368930, 51.032276, 3.25],
          [2.368981, 51.032242, 3.25],
          [2.369031, 51.032229, 3.25],
          [2.369065, 51.032221, 3.25],
          [2.369132, 51.032219, 3.25],
          [2.369205, 51.032226, 3.25],
          [2.369914, 51.032313, 2.5],
          [2.370008, 51.032325, 2.25],
          [2.370033, 51.032328, 2.25],
          [2.370168, 51.032326, 2.75],
          [2.370259, 51.032299, 3.0],
          [2.370378, 51.032239, 3.25],
          [2.370447, 51.032206, 3.5],
          [2.370786, 51.032048, 4.25],
          [2.370942, 51.031974, 4.75],
          [2.371044, 51.031946, 5.0],
          [2.371180, 51.031933, 5.5],
          [2.371227, 51.031932, 5.5],
          [2.371497, 51.031954, 6.0],
          [2.371538, 51.031959, 6.25],
          [2.371637, 51.031967, 6.5],
          [2.371703, 51.031979, 6.5],
          [2.371746, 51.031996, 6.5],
          [2.371737, 51.032034, 6.25],
          [2.371746, 51.031996, 6.5],
          [2.371709, 51.032002, 6.5],
          [2.371631, 51.032002, 6.5],
          [2.371621, 51.032139, 6.25],
          [2.371597, 51.032451, 5.75],
          [2.371606, 51.032525, 5.75],
          [2.371578, 51.032610, 5.75],
          [2.371531, 51.032681, 5.75],
          [2.371490, 51.032729, 5.75],
          [2.371524, 51.032784, 6.0],
          [2.371624, 51.033086, 6.5],
          [2.371648, 51.033152, 6.75],
          [2.371985, 51.034189, 8.75],
          [2.372018, 51.034303, 8.25],
          [2.372094, 51.034566, 6.75],
          [2.372395, 51.035504, 8.0],
          [2.372419, 51.035576, 8.25],
          [2.372432, 51.035606, 8.5],
          [2.372849, 51.036215, 7.0],
          [2.373233, 51.036738, 4.0],
          [2.373444, 51.036988, 3.75],
          [2.373622, 51.037184, 4.0],
          [2.373689, 51.037256, 4.25],
          [2.373940, 51.037470, 4.5],
          [2.374203, 51.037659, 5.0],
          [2.374408, 51.037799, 5.0],
          [2.374784, 51.038025, 4.5],
          [2.375006, 51.038146, 3.75],
          [2.375318, 51.038305, 3.75],
          [2.375497, 51.038386, 4.0],
          [2.375725, 51.038440, 4.5],
          [2.375787, 51.038461, 4.5],
          [2.376640, 51.038737, 5.75],
          [2.377275, 51.038922, 6.75],
          [2.377408, 51.038981, 6.75],
          [2.377470, 51.039018, 6.75],
          [2.377533, 51.039069, 6.5],
          [2.377931, 51.039480, 6.25],
          [2.378056, 51.039436, 6.5],
          [2.378123, 51.039423, 6.5],
          [2.378182, 51.039423, 6.75],
          [2.378283, 51.039522, 6.5],
          [2.378358, 51.039599, 6.25],
          [2.378608, 51.039863, 6.0],
          [2.378702, 51.039956, 6.0],
          [2.378794, 51.040041, 6.0],
          [2.378904, 51.040145, 6.0],
          [2.378978, 51.040203, 6.25],
          [2.379118, 51.040287, 6.5],
          [2.379353, 51.040396, 7.0],
          [2.379538, 51.040458, 7.5],
          [2.379743, 51.040513, 8.0],
          [2.379827, 51.040530, 8.25],
          [2.380391, 51.040599, 9.0],
          [2.380478, 51.040608, 9.0],
          [2.380637, 51.040626, 9.0],
          [2.380804, 51.040645, 9.0],
          [2.380938, 51.040660, 8.75],
          [2.381485, 51.040720, 8.75],
          [2.382036, 51.040692, 8.5],
          [2.382180, 51.040689, 8.25],
          [2.382396, 51.040699, 8.0],
          [2.382525, 51.040703, 8.0],
          [2.382725, 51.040727, 7.75],
          [2.382876, 51.040746, 7.5],
          [2.383093, 51.040789, 7.25],
          [2.384163, 51.040832, 7.0],
          [2.384250, 51.040836, 7.0],
          [2.385390, 51.040891, 6.5],
          [2.385482, 51.040896, 6.25],
          [2.385644, 51.040922, 6.25],
          [2.385641, 51.040948, 6.25],
          [2.385633, 51.041016, 6.25],
          [2.385630, 51.041045, 6.25],
          [2.385633, 51.041016, 6.25],
          [2.385735, 51.041021, 6.25],
          [2.385796, 51.041023, 6.25],
          [2.386793, 51.041069, 5.25],
          [2.386839, 51.041071, 5.25],
          [2.387001, 51.041079, 5.75],
          [2.387143, 51.041085, 6.0],
          [2.388493, 51.041149, 9.5],
          [2.388663, 51.041156, 9.25],
          [2.388820, 51.041163, 9.25],
          [2.388951, 51.041170, 9.0],
          [2.389098, 51.041180, 9.0],
          [2.389599, 51.041236, 8.25],
          [2.389780, 51.041264, 8.25],
          [2.390152, 51.041340, 8.0],
          [2.390374, 51.041392, 8.0],
          [2.390552, 51.041435, 8.0],
          [2.391285, 51.041612, 7.25],
          [2.392331, 51.041876, 7.75],
          [2.392788, 51.041991, 8.0],
          [2.393119, 51.042070, 8.25],
          [2.393262, 51.042106, 8.5],
          [2.394615, 51.042447, 8.25],
          [2.394776, 51.042487, 8.25],
          [2.394912, 51.042521, 8.0],
          [2.396099, 51.042823, 7.5],
          [2.396189, 51.042846, 7.5],
          [2.397000, 51.043049, 7.5],
          [2.397471, 51.043163, 7.75],
          [2.397595, 51.043193, 7.75],
          [2.397735, 51.043229, 7.5],
          [2.398191, 51.043346, 7.0],
          [2.399076, 51.043571, 7.75],
          [2.399500, 51.043682, 8.0],
          [2.400684, 51.043977, 8.0],
          [2.400987, 51.044052, 8.25],
          [2.401153, 51.044094, 8.25],
          [2.402844, 51.044520, 8.5],
          [2.403598, 51.044708, 8.25],
          [2.403725, 51.044740, 8.25],
          [2.403833, 51.044767, 8.25],
          [2.405260, 51.045125, 7.75],
          [2.406164, 51.045351, 8.0],
          [2.407914, 51.045791, 8.5],
          [2.408036, 51.045821, 8.25],
          [2.408361, 51.045901, 7.75],
          [2.410713, 51.046495, 11.5],
          [2.411632, 51.046721, 11.75],
          [2.411847, 51.046774, 11.25],
          [2.412021, 51.046817, 11.0],
          [2.412141, 51.046847, 10.75],
          [2.413267, 51.047129, 9.5],
          [2.413991, 51.047313, 9.75],
          [2.414396, 51.047415, 9.75],
          [2.414693, 51.047490, 9.75],
          [2.416645, 51.047980, 10.5],
          [2.416827, 51.048025, 10.5],
          [2.416952, 51.048056, 10.5],
          [2.417647, 51.048230, 10.5],
          [2.418534, 51.048456, 10.5],
          [2.420036, 51.048836, 10.0],
          [2.420131, 51.048860, 10.0],
          [2.420873, 51.049043, 9.75],
          [2.421025, 51.049081, 9.75],
          [2.423244, 51.049632, 9.0],
          [2.423469, 51.049688, 9.0],
          [2.423654, 51.049737, 9.0],
          [2.423922, 51.049808, 9.0],
          [2.426503, 51.050453, 7.25],
          [2.426650, 51.050489, 7.25],
          [2.426804, 51.050528, 7.25],
          [2.428949, 51.051071, 7.5],
          [2.429115, 51.051112, 7.5],
          [2.429227, 51.051143, 7.5],
          [2.429504, 51.051213, 7.75],
          [2.429801, 51.051280, 8.0],
          [2.430035, 51.051316, 8.0],
          [2.430345, 51.051346, 8.0],
          [2.430683, 51.051383, 8.25],
          [2.431223, 51.051456, 8.0],
          [2.431325, 51.051459, 7.75],
          [2.431395, 51.051449, 7.75],
          [2.431424, 51.051432, 7.5],
          [2.431446, 51.051423, 7.5],
          [2.431495, 51.051413, 7.5],
          [2.431545, 51.051412, 7.5],
          [2.431594, 51.051421, 7.25],
          [2.431637, 51.051438, 7.25],
          [2.431664, 51.051459, 7.5],
          [2.431687, 51.051492, 7.5],
          [2.431691, 51.051528, 7.5],
          [2.431675, 51.051563, 7.75],
          [2.431641, 51.051592, 7.75],
          [2.431594, 51.051612, 7.75],
          [2.431537, 51.051621, 8.0],
          [2.431454, 51.051612, 8.0],
          [2.431398, 51.051584, 8.0],
          [2.431392, 51.051581, 8.0],
          [2.431367, 51.051554, 8.0],
          [2.431357, 51.051507, 7.75],
          [2.431369, 51.051476, 7.75],
          [2.431395, 51.051449, 7.75],
          [2.431424, 51.051432, 7.5],
          [2.431446, 51.051423, 7.5],
          [2.431509, 51.051325, 7.25],
          [2.431609, 51.051173, 6.75],
          [2.431701, 51.050880, 6.0],
          [2.431752, 51.050773, 6.0],
          [2.431795, 51.050704, 6.0],
          [2.431826, 51.050656, 6.0],
          [2.431860, 51.050612, 6.0],
          [2.431896, 51.050566, 6.0],
          [2.431921, 51.050533, 6.0],
          [2.431955, 51.050489, 6.0],
          [2.432026, 51.050536, 6.0],
          [2.434271, 51.051205, 5.75],
          [2.435424, 51.051530, 5.0],
          [2.435700, 51.051548, 5.0],
          [2.439003, 51.052543, 6.0],
          [2.444957, 51.054336, 7.75],
          [2.445784, 51.054563, 8.75],
          [2.446758, 51.054804, 9.75],
          [2.447817, 51.055013, 8.5],
          [2.448676, 51.055109, 7.75],
          [2.450577, 51.055352, 8.0],
          [2.451084, 51.055370, 8.5],
          [2.452734, 51.055401, 7.5],
          [2.453149, 51.055431, 6.75],
          [2.455162, 51.055653, 4.75],
          [2.455239, 51.055676, 4.5],
          [2.455259, 51.055684, 4.5],
          [2.455313, 51.055706, 4.5],
          [2.455611, 51.055866, 4.25],
          [2.455911, 51.055937, 4.25],
          [2.460812, 51.056424, 4.5],
          [2.461965, 51.056598, 4.0],
          [2.463207, 51.056885, 3.75],
          [2.464390, 51.057202, 5.0],
          [2.467469, 51.058321, 7.0],
          [2.468456, 51.058662, 5.75],
          [2.468603, 51.058679, 5.75],
          [2.468611, 51.058679, 5.5],
          [2.468603, 51.058679, 5.75],
          [2.468518, 51.058595, 5.25],
          [2.468489, 51.058513, 4.75],
          [2.468487, 51.058506, 4.75],
          [2.468715, 51.058533, 4.75],
          [2.468842, 51.058540, 4.75],
          [2.468987, 51.058539, 4.75],
          [2.469232, 51.058526, 4.5],
          [2.469450, 51.058493, 4.5],
          [2.469677, 51.058438, 4.75],
          [2.469855, 51.058377, 4.75],
          [2.470113, 51.058272, 5.0],
          [2.470388, 51.058136, 5.0],
          [2.470776, 51.057926, 4.75],
          [2.471125, 51.057735, 4.75],
          [2.471279, 51.057661, 4.75],
          [2.471427, 51.057607, 4.75],
          [2.471612, 51.057543, 5.0],
          [2.471798, 51.057489, 5.0],
          [2.471946, 51.057451, 5.25],
          [2.472069, 51.057434, 5.25],
          [2.472127, 51.057428, 5.5],
          [2.472215, 51.057421, 5.5],
          [2.472330, 51.057416, 5.5],
          [2.472429, 51.057417, 5.75],
          [2.472627, 51.057429, 6.0],
          [2.472742, 51.057442, 6.0],
          [2.472965, 51.057480, 6.5],
          [2.473190, 51.057520, 6.5],
          [2.474351, 51.057728, 7.0],
          [2.475326, 51.057911, 7.25],
          [2.475790, 51.058009, 7.0],
          [2.477088, 51.058324, 7.75],
          [2.477323, 51.058391, 7.25],
          [2.477600, 51.058494, 6.5],
          [2.477809, 51.058585, 6.0],
          [2.479067, 51.059210, 5.0],
          [2.479633, 51.059470, 5.0],
          [2.479969, 51.059594, 5.0],
          [2.480717, 51.059833, 4.5],
          [2.481058, 51.059949, 4.5],
          [2.481535, 51.060136, 4.5],
          [2.481852, 51.060274, 4.75],
          [2.482467, 51.060564, 5.5],
          [2.483396, 51.061039, 5.75],
          [2.483458, 51.061071, 5.75],
          [2.483588, 51.061135, 5.5],
          [2.483692, 51.061190, 5.75],
          [2.484500, 51.061566, 6.25],
          [2.484737, 51.061667, 6.5],
          [2.484955, 51.061745, 7.5],
          [2.485525, 51.061923, 7.5],
          [2.486339, 51.062189, 7.0],
          [2.486450, 51.062231, 7.0],
          [2.486637, 51.062315, 6.75],
          [2.486865, 51.062436, 7.0],
          [2.487030, 51.062546, 7.0],
          [2.487194, 51.062672, 7.0],
          [2.487617, 51.063036, 6.75],
          [2.487725, 51.063117, 6.5],
          [2.487887, 51.063222, 6.25],
          [2.488223, 51.063392, 5.5],
          [2.489760, 51.064111, 3.25]
        ]
      }
    }
  ]
}


let day2: geojson_I = {
  type: "FeatureCollection",
  features: [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "Zuydcoote - Stene - 45.9km",
        "track-length": "45933",
        "filtered ascend": "120",
        "plain-ascend": "46",
        "total-time": "7273",
        "total-energy": "709663",
        "cost": "80135",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["2489895", "51064174", "3", "2", "1150", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "0", "18"],
          ["2489059", "51064717", "6", "86", "1050", "0", "100", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "13", "1335"],
          ["2489037", "51064730", "6", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "nodeaccessgranted=yes railway=level_crossing", "13", "1397"],
          ["2488910", "51064810", "7", "13", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "", "16", "1696"],
          ["2488451", "51065241", "8", "61", "1050", "0", "13", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "34", "3426"],
          ["2488397", "51065257", "8", "5", "1150", "0", "59", "0", "0", "highway=residential", "", "35", "3549"],
          ["2488451", "51065241", "8", "6", "1150", "0", "4", "0", "0", "reversedirection=yes highway=residential", "", "36", "3603"],
          ["2489143", "51065516", "7", "61", "1050", "0", "86", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "41", "4160"],
          ["2489244", "51065810", "6", "39", "1050", "0", "15", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "45", "4540"],
          ["2488897", "51066450", "8", "76", "1050", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing", "56", "5654"],
          ["2487911", "51068398", "11", "231", "1050", "0", "22", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "107", "10788"],
          ["2486650", "51070734", "8", "473", "1150", "0", "189", "0", "0", "highway=residential surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "179", "17941"],
          ["2486323", "51071390", "8", "78", "1150", "0", "92", "0", "0", "reversedirection=yes highway=residential surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "191", "19171"],
          ["2486199", "51071385", "8", "1", "3050", "0", "68", "0", "0", "highway=pedestrian", "", "191", "19187"],
          ["2486323", "51071390", "-8192", "1", "3050", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian", "", "191", "19197"],
          ["2486650", "51070734", "8", "78", "1150", "0", "68", "0", "0", "highway=residential surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "200", "20028"],
          ["2486739", "51070562", "9", "21", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt access=yes foot=yes bicycle=yes oneway=yes oneway:bicycle=yes", "", "203", "20303"],
          ["2487911", "51068398", "11", "257", "1050", "0", "6", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=yes", "", "251", "25129"],
          ["2488897", "51066450", "8", "231", "1050", "0", "92", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing", "281", "28170"],
          ["2489244", "51065810", "6", "76", "1050", "0", "0", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "290", "29103"],
          ["2489143", "51065516", "7", "39", "1050", "0", "14", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "highway=crossing crossing=unknown", "296", "29653"],
          ["2488910", "51064810", "7", "122", "1050", "0", "29", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "317", "31793"],
          ["2489037", "51064730", "6", "13", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "nodeaccessgranted=yes railway=level_crossing", "319", "31967"],
          ["2489059", "51064717", "6", "3", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "", "320", "32008"],
          ["2489227", "51064627", "6", "2", "1050", "0", "0", "0", "0", "highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "320", "32034"],
          ["2489059", "51064717", "6", "2", "1050", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "320", "32053"],
          ["2511769", "51069680", "7", "1698", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated route_bicycle_icn=yes", "", "596", "59634"],
          ["2511807", "51069602", "7", "1", "1050", "0", "91", "0", "0", "highway=footway bicycle=yes", "", "596", "59651"],
          ["2511769", "51069680", "7", "1", "1050", "0", "0", "0", "0", "reversedirection=yes highway=footway bicycle=yes", "", "596", "59661"],
          ["2511875", "51069722", "7", "9", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated route_bicycle_icn=yes", "nodeaccessgranted=yes railway=crossing", "597", "59748"],
          ["2513025", "51070088", "6", "97", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated route_bicycle_icn=yes", "", "607", "60720"],
          ["2512978", "51070118", "6", "1", "1150", "0", "57", "0", "0", "highway=residential surface=asphalt access=destination foot=yes bicycle=yes cycleway=no oneway=no", "", "607", "60729"],
          ["2513025", "51070088", "6", "1", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt access=destination foot=yes bicycle=yes cycleway=no oneway=no", "", "607", "60739"],
          ["2515937", "51070449", "6", "210", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt access=destination foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "632", "63264"],
          ["2515969", "51070453", "6", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt access=destination foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "nodeaccessgranted=yes highway=stop direction=backward", "633", "63310"],
          ["2515986", "51070455", "6", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt access=destination foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "", "633", "63341"],
          ["2516060", "51070465", "6", "6", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt access=destination foot=yes bicycle=yes cycleway=no oneway=no", "", "634", "63434"],
          ["2516079", "51070418", "6", "7", "1050", "0", "86", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no", "", "635", "63509"],
          ["2519319", "51070942", "5", "240", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_icn=yes", "", "663", "66341"],
          ["2519305", "51070993", "5", "2", "1050", "0", "84", "0", "0", "reversedirection=yes highway=footway bicycle=yes", "", "663", "66373"],
          ["2519319", "51070942", "5", "2", "1050", "0", "0", "0", "0", "highway=footway bicycle=yes", "", "663", "66391"],
          ["2519355", "51070847", "5", "11", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_icn=yes", "nodeaccessgranted=yes railway=crossing", "664", "66492"],
          ["2519368", "51070813", "4", "4", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_icn=yes", "nodeaccessgranted=yes railway=crossing", "665", "66528"],
          ["2519409", "51070711", "4", "13", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_icn=yes", "", "666", "66651"],
          ["2519054", "51070650", "4", "1", "1350", "0", "89", "0", "0", "reversedirection=yes highway=service bicycle=yes", "", "666", "66660"],
          ["2519409", "51070711", "4", "1", "1350", "0", "0", "0", "0", "highway=service bicycle=yes", "", "666", "66670"],
          ["2520630", "51070830", "4", "89", "1000", "0", "0", "0", "0", "highway=service bicycle=yes route_bicycle_icn=yes", "", "676", "67638"],
          ["2555142", "51076090", "4", "2506", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated route_bicycle_icn=yes", "", "1070", "107063"],
          ["2555259", "51075886", "4", "25", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes", "nodeaccessgranted=yes highway=crossing", "1072", "107306"],
          ["2555276", "51075855", "4", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes", "nodeaccessgranted=yes highway=give_way direction=backward", "1073", "107347"],
          ["2555294", "51075831", "3", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes", "", "1073", "107377"],
          ["2555367", "51075850", "4", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=no oneway=no route_bicycle_icn=yes", "", "1074", "107445"],
          ["2555467", "51075872", "4", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary route_bicycle_ncn=yes", "", "1075", "107524"],
          ["2558389", "51076110", "3", "94", "1000", "0", "0", "0", "0", "highway=secondary oneway=yes route_bicycle_rcn=yes", "", "1084", "108499"],
          ["2556748", "51075978", "3", "2", "31000", "0", "0", "0", "0", "reversedirection=yes highway=secondary oneway=yes route_bicycle_rcn=yes", "", "1086", "108499"],
          ["2556722", "51076091", "3", "13", "1350", "0", "88", "0", "0", "highway=unclassified", "", "1087", "108627"],
          ["2557516", "51076129", "3", "1", "31000", "0", "0", "0", "0", "reversedirection=yes highway=secondary oneway=yes route_bicycle_rcn=yes", "", "1088", "108627"],
          ["2555467", "51075872", "4", "94", "1000", "0", "0", "0", "0", "highway=secondary oneway=yes route_bicycle_rcn=yes", "", "1098", "109711"],
          ["2555517", "51075800", "3", "9", "1000", "0", "0", "0", "0", "highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1099", "109804"],
          ["2555647", "51075627", "3", "22", "1000", "0", "0", "0", "0", "highway=service surface=concrete foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1102", "110016"],
          ["2559478", "51070757", "0", "607", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=concrete foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1188", "118619"],
          ["2559537", "51070770", "0", "5", "1000", "0", "0", "0", "0", "highway=path surface=compacted foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "1188", "118702"],
          ["2561842", "51070501", "0", "197", "1000", "0", "0", "0", "0", "highway=path surface=compacted foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1215", "121318"],
          ["2562045", "51070518", "0", "15", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1217", "121518"],
          ["2566664", "51071090", "0", "332", "1000", "0", "0", "0", "0", "highway=path surface=compacted foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "1258", "125674"],
          ["2566762", "51071123", "-1", "8", "1000", "0", "0", "0", "0", "highway=path surface=compacted foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1259", "125796"],
          ["2592335", "51073843", "0", "1826", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1571", "156979"],
          ["2595967", "51073759", "1", "262", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=chicane", "1622", "162038"],
          ["2599312", "51074062", "3", "259", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1660", "165905"],
          ["2603222", "51075053", "3", "312", "1000", "0", "0", "0", "0", "highway=residential surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "1713", "171197"],
          ["2603391", "51075087", "4", "13", "1000", "0", "0", "0", "0", "highway=residential surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "1716", "171465"],
          ["2603372", "51075229", "4", "17", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "1718", "171642"],
          ["2603145", "51077120", "3", "213", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "1744", "174236"],
          ["2603125", "51077282", "3", "20", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1747", "174537"],
          ["2603120", "51077310", "3", "4", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1747", "174594"],
          ["2603116", "51077344", "3", "4", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1748", "174652"],
          ["2603064", "51077614", "2", "32", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "1752", "175082"],
          ["2603039", "51077728", "2", "13", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1754", "175262"],
          ["2603070", "51077812", "2", "10", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "1755", "175404"],
          ["2602933", "51078440", "2", "72", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1766", "176447"],
          ["2602856", "51078808", "2", "42", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1772", "177054"],
          ["2602787", "51079049", "2", "34", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1777", "177568"],
          ["2602759", "51079126", "2", "9", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "1778", "177707"],
          ["2602333", "51080932", "2", "205", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1812", "181033"],
          ["2602316", "51081036", "2", "13", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "1814", "181264"],
          ["2602304", "51081077", "2", "5", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "1815", "181358"],
          ["2602048", "51081852", "3", "90", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1833", "183198"],
          ["2601714", "51083131", "2", "145", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1856", "185476"],
          ["2601061", "51085494", "4", "269", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1908", "190715"],
          ["2600801", "51086107", "7", "74", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1928", "192693"],
          ["2600020", "51086947", "10", "114", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1950", "194909"],
          ["2600024", "51086987", "10", "5", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1951", "195001"],
          ["2600015", "51087040", "10", "6", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1952", "195110"],
          ["2591400", "51092102", "11", "833", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2107", "210550"],
          ["2589453", "51093250", "8", "188", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes oneway:bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "2128", "212633"],
          ["2588938", "51093458", "8", "44", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes oneway:bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2134", "213242"],
          ["2588586", "51093544", "8", "27", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes oneway:bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2138", "213637"],
          ["2588639", "51093630", "8", "11", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=shared_lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "2139", "213801"],
          ["2588736", "51095396", "8", "200", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=shared_lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "2172", "217067"],
          ["2588741", "51095492", "8", "11", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=shared_lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "2174", "217267"],
          ["2588754", "51095578", "8", "10", "1000", "0", "0", "0", "0", "highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "2176", "217448"],
          ["2588886", "51096269", "9", "78", "1000", "0", "0", "0", "0", "highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=mini_roundabout", "2191", "218965"],
          ["2588911", "51096298", "9", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2192", "219039"],
          ["2588723", "51096349", "9", "6", "1350", "0", "98", "0", "0", "reversedirection=yes highway=service", "", "2193", "219149"],
          ["2588911", "51096298", "9", "6", "1350", "0", "0", "0", "0", "highway=service", "", "2193", "219205"],
          ["2592234", "51099982", "11", "494", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "2274", "227258"],
          ["2590698", "51102734", "13", "342", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "2336", "233497"],
          ["2590615", "51102819", "13", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "2338", "233696"],
          ["2590600", "51102833", "13", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "2339", "233730"],
          ["2590693", "51102869", "13", "8", "3050", "0", "93", "0", "0", "highway=primary surface=asphalt", "highway=crossing crossing=unknown", "2340", "233863"],
          ["2591105", "51103028", "12", "35", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt", "", "2343", "234228"],
          ["2593210", "51103848", "10", "175", "3050", "0", "0", "0", "0", "highway=primary", "highway=crossing crossing=unknown", "2363", "236136"],
          ["2593549", "51103982", "10", "30", "3050", "0", "0", "0", "0", "highway=primary", "highway=crossing crossing=unknown", "2366", "236442"],
          ["2594687", "51104425", "9", "95", "3050", "0", "0", "0", "0", "highway=primary", "highway=crossing", "2376", "237506"],
          ["2595687", "51104810", "9", "85", "3050", "0", "0", "0", "0", "highway=primary", "highway=crossing crossing=unknown", "2386", "238457"],
          ["2597103", "51105214", "11", "112", "3050", "0", "0", "0", "0", "highway=primary", "", "2403", "240134"],
          ["2597191", "51105208", "11", "7", "3050", "0", "6", "0", "0", "highway=primary oneway=yes", "railway=level_crossing", "2403", "240204"],
          ["2598519", "51105184", "10", "95", "3050", "0", "1", "0", "0", "highway=primary oneway=yes", "highway=crossing", "2413", "241221"],
          ["2598690", "51105180", "10", "12", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "", "2415", "241361"],
          ["2601494", "51105734", "7", "222", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2439", "243756"],
          ["2601542", "51105741", "7", "4", "1000", "0", "0", "0", "0", "highway=cycleway surface=compacted route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "2439", "243803"],
          ["2602272", "51106043", "6", "62", "1000", "0", "0", "0", "0", "highway=cycleway surface=compacted route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2447", "244569"],
          ["2605903", "51107848", "7", "329", "1000", "0", "0", "0", "0", "highway=path surface=compacted foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2502", "250050"],
          ["2606565", "51108134", "7", "64", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2510", "250878"],
          ["2608026", "51108406", "7", "110", "1000", "0", "0", "0", "0", "highway=cycleway surface=paved foot=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2524", "252257"],
          ["2608017", "51108438", "7", "4", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2524", "252315"],
          ["2611448", "51110368", "12", "340", "3050", "0", "89", "0", "0", "highway=primary oneway=yes", "highway=traffic_signals", "2570", "256836"],
          ["2611463", "51110382", "12", "2", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=traffic_signals", "2570", "256863"],
          ["2611699", "51110559", "11", "27", "3050", "0", "3", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=traffic_signals", "2574", "257237"],
          ["2612550", "51110987", "11", "81", "3050", "0", "2", "0", "0", "highway=primary oneway=yes", "highway=crossing", "2583", "258138"],
          ["2613659", "51111223", "11", "85", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=zebra", "2592", "259084"],
          ["2617635", "51111248", "10", "285", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing", "2625", "262368"],
          ["2617753", "51111253", "10", "9", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "", "2626", "262489"],
          ["2621216", "51111648", "9", "250", "3050", "0", "1", "0", "0", "highway=primary surface=asphalt oneway=yes", "", "2659", "265793"],
          ["2623679", "51112413", "11", "196", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=traffic_signals", "2686", "268482"],
          ["2623715", "51112426", "11", "3", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=traffic_signals", "2686", "268530"],
          ["2629262", "51115556", "11", "534", "3050", "0", "3", "0", "0", "highway=primary oneway=yes", "highway=crossing", "2758", "275696"],
          ["2631445", "51117957", "11", "316", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=unknown", "2799", "279821"],
          ["2632559", "51119194", "11", "161", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=unknown", "2821", "282009"],
          ["2632902", "51119609", "11", "54", "3050", "0", "2", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=unknown", "2828", "282684"],
          ["2633582", "51119976", "12", "64", "3050", "0", "1", "0", "0", "highway=primary oneway=yes", "highway=traffic_signals", "2836", "283491"],
          ["2633633", "51119997", "12", "5", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=traffic_signals", "2837", "283550"],
          ["2634016", "51120139", "12", "21", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "", "2839", "283805"],
          ["2633857", "51120079", "12", "2", "53050", "0", "0", "0", "0", "reversedirection=yes highway=primary oneway=yes", "", "2841", "283805"],
          ["2633948", "51119997", "12", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=opposite oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "2842", "283923"],
          ["2633976", "51119972", "12", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=opposite oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "2842", "283963"],
          ["2634883", "51119155", "11", "111", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=opposite oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2853", "285042"],
          ["2634980", "51119198", "11", "9", "1150", "0", "90", "0", "0", "reversedirection=yes highway=residential", "highway=crossing crossing=unknown", "2854", "285138"],
          ["2634781", "51120432", "12", "172", "1150", "0", "56", "0", "0", "reversedirection=yes highway=residential", "", "2873", "287091"],
          ["2634016", "51120139", "12", "1", "53050", "0", "100", "0", "0", "reversedirection=yes highway=primary oneway=yes", "", "2874", "287094"],
          ["2635110", "51120555", "12", "28", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=bus_stop", "2877", "287374"],
          ["2635329", "51120637", "12", "18", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=unknown", "2879", "287563"],
          ["2637234", "51121269", "10", "152", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=unknown", "2895", "289176"],
          ["2640951", "51121319", "11", "271", "3050", "0", "2", "0", "0", "highway=primary oneway=yes", "highway=crossing", "2926", "292328"],
          ["2641868", "51121251", "10", "66", "3050", "0", "4", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=traffic_signals", "2934", "293046"],
          ["2642143", "51121234", "10", "20", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=traffic_signals", "2936", "293268"],
          ["2644971", "51121230", "10", "202", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "", "2961", "295799"],
          ["2645130", "51121246", "10", "13", "1000", "0", "0", "0", "0", "highway=primary oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "2963", "295947"],
          ["2655632", "51123686", "6", "790", "1000", "0", "0", "0", "0", "highway=primary oneway=yes route_bicycle_rcn=yes", "", "3066", "306277"],
          ["2659329", "51124546", "4", "281", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "3107", "310425"],
          ["2659466", "51124576", "4", "11", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "3109", "310607"],
          ["2659582", "51124599", "5", "9", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "highway=crossing crossing=traffic_signals", "3111", "310766"],
          ["2660028", "51124695", "5", "33", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "", "3117", "311378"],
          ["2660215", "51124745", "5", "15", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "", "3120", "311651"],
          ["2660592", "51124856", "5", "30", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "", "3125", "312211"],
          ["2669873", "51131506", "10", "1015", "3050", "0", "1", "0", "0", "highway=primary oneway=yes", "highway=crossing", "3294", "329126"],
          ["2671568", "51132050", "10", "135", "3050", "0", "1", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=traffic_signals", "3312", "330879"],
          ["2671753", "51132106", "10", "15", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=traffic_signals", "3314", "331071"],
          ["2671944", "51132176", "10", "16", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing crossing=traffic_signals", "3315", "331237"],
          ["2672311", "51132292", "10", "29", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "", "3318", "331532"],
          ["2673049", "51132524", "9", "60", "1050", "0", "1", "0", "0", "highway=cycleway oneway=yes", "", "3325", "332212"],
          ["2673570", "51132672", "10", "41", "3050", "0", "6", "0", "0", "highway=primary oneway=yes", "highway=crossing", "3330", "332739"],
          ["2674623", "51132946", "12", "82", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing", "3348", "334512"],
          ["2678606", "51133658", "10", "303", "3050", "0", "7", "0", "0", "highway=primary oneway=yes", "highway=crossing", "3402", "339872"],
          ["2683248", "51133965", "6", "337", "3050", "0", "1", "0", "0", "highway=primary oneway=yes", "", "3441", "343752"],
          ["2686090", "51134734", "7", "223", "1050", "0", "36", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "", "3471", "346837"],
          ["2686148", "51134752", "7", "5", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no", "", "3472", "346924"],
          ["2696269", "51138892", "6", "856", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes route_bicycle_rcn=yes", "", "3604", "360089"],
          ["2696664", "51139021", "6", "32", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "", "3611", "360781"],
          ["2696229", "51138867", "6", "10", "5050", "0", "179", "0", "0", "highway=footway surface=paved", "", "3618", "360921"],
          ["2696664", "51139021", "6", "10", "5050", "0", "84", "0", "0", "reversedirection=yes highway=footway surface=paved", "", "3625", "360921"],
          ["2700320", "51140078", "5", "290", "1050", "0", "88", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "highway=crossing crossing=traffic_signals", "3664", "364861"],
          ["2706174", "51142209", "10", "478", "1050", "0", "24", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "highway=crossing crossing=traffic_signals", "3746", "373101"],
          ["2706230", "51142235", "10", "5", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "", "3747", "373185"],
          ["2706239", "51142254", "10", "3", "1050", "0", "18", "0", "0", "highway=cycleway oneway=yes", "highway=crossing crossing=traffic_signals", "3748", "373235"],
          ["2706484", "51142364", "10", "23", "1050", "0", "45", "0", "0", "highway=cycleway oneway=yes", "", "3752", "373660"],
          ["2711588", "51144610", "10", "439", "1050", "0", "16", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "", "3826", "381106"],
          ["2712126", "51144845", "11", "46", "3050", "0", "4", "0", "0", "highway=primary oneway=yes", "highway=traffic_signals", "3833", "381750"],
          ["2712260", "51144889", "12", "12", "3050", "0", "1", "0", "0", "highway=primary oneway=yes", "", "3834", "381900"],
          ["2713743", "51145556", "17", "129", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "highway=crossing", "3872", "385656"],
          ["2716286", "51146654", "10", "218", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "highway=crossing", "3897", "388201"],
          ["2716580", "51146787", "10", "27", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "", "3900", "388466"],
          ["2716933", "51146940", "11", "30", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=traffic_signals", "3904", "388822"],
          ["2716987", "51146963", "11", "5", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "highway=crossing", "3904", "388884"],
          ["2718256", "51147491", "13", "109", "3050", "0", "2", "0", "0", "highway=primary oneway=yes", "", "3922", "390669"],
          ["2718363", "51147537", "13", "10", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "highway=crossing", "3923", "390772"],
          ["2720886", "51148590", "11", "214", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes", "highway=crossing", "3946", "393094"],
          ["2722231", "51149161", "11", "116", "3050", "0", "2", "0", "0", "highway=primary surface=asphalt oneway=yes", "highway=crossing", "3960", "394442"],
          ["2722266", "51149166", "11", "3", "3050", "0", "1", "0", "0", "highway=primary surface=asphalt oneway=yes", "", "3960", "394482"],
          ["2722331", "51149171", "12", "5", "3050", "0", "0", "0", "0", "highway=primary oneway=yes", "", "3961", "394555"],
          ["2722625", "51149183", "11", "26", "3050", "0", "0", "0", "0", "highway=primary bicycle=use_sidepath junction=roundabout", "railway=level_crossing", "3965", "394919"],
          ["2722649", "51149217", "11", "5", "3050", "0", "0", "0", "0", "highway=primary bicycle=use_sidepath junction=roundabout", "railway=level_crossing", "3965", "394991"],
          ["2722607", "51149328", "11", "15", "3050", "0", "0", "0", "0", "highway=primary bicycle=use_sidepath junction=roundabout", "", "3967", "395209"],
          ["2722648", "51149424", "11", "12", "1150", "0", "26", "0", "0", "highway=residential oneway=yes", "highway=crossing crossing=unknown", "3969", "395387"],
          ["2723410", "51149759", "12", "67", "1150", "0", "21", "0", "0", "highway=residential", "", "3978", "396266"],
          ["2723651", "51149944", "12", "27", "3050", "0", "5", "0", "0", "highway=pedestrian", "", "3981", "396565"],
          ["2723835", "51150088", "12", "21", "1000", "0", "0", "0", "0", "highway=pedestrian bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3984", "396827"],
          ["2723875", "51150150", "12", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3985", "396936"],
          ["2723925", "51150178", "12", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=gravel route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=block foot=yes bicycle=yes", "3985", "397006"],
          ["2725014", "51150868", "12", "114", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=gravel route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=block foot=yes bicycle=yes", "4005", "398996"],
          ["2725110", "51150862", "12", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=gravel route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4006", "399081"],
          ["2725297", "51150998", "10", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4008", "399288"],
          ["2727285", "51149848", "2", "190", "1000", "0", "0", "0", "0", "highway=cycleway surface=sett route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "4024", "399519"],
          ["2727345", "51149895", "2", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4025", "399608"],
          ["2727367", "51149912", "2", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4025", "399646"],
          ["2727542", "51150012", "2", "19", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway bicycle=dismount route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=dismount", "4027", "399896"],
          ["2728348", "51149638", "0", "78", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway bicycle=dismount route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4038", "400993"],
          ["2728245", "51149726", "0", "41", "1000", "0", "0", "0", "0", "highway=footway bicycle=dismount oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes foot=yes bicycle=yes", "4042", "401403"],
          ["2727099", "51151123", "1", "182", "5670", "0", "0", "0", "10000", "reversedirection=yes foot=yes bicycle=yes route=ferry route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes foot=yes bicycle=yes", "4165", "401741"],
          ["2727265", "51151060", "1", "17", "1000", "0", "0", "0", "0", "highway=footway bicycle=dismount oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4167", "401889"],
          ["2726756", "51151625", "1", "91", "1000", "0", "0", "0", "0", "highway=footway bicycle=dismount route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "4176", "402863"],
          ["2726783", "51151641", "6", "3", "1000", "0", "0", "0", "0", "highway=footway bicycle=dismount route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4178", "403003"],
          ["2732990", "51153048", "5", "508", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4264", "411631"],
          ["2732761", "51153294", "5", "1", "9050", "0", "101", "0", "0", "highway=path surface=sand foot=yes vehicle=no", "", "4265", "411637"],
          ["2732990", "51153048", "5", "1", "9050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=sand foot=yes vehicle=no", "", "4265", "411637"],
          ["2741311", "51148146", "3", "864", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4396", "424664"],
          ["2742939", "51147953", "3", "147", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4417", "426762"],
          ["2743273", "51149620", "2", "191", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4440", "429070"],
          ["2748390", "51154831", "3", "768", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4554", "440463"],
          ["2747435", "51155306", "3", "3", "1150", "0", "94", "0", "0", "highway=residential", "", "4554", "440507"],
          ["2748390", "51154831", "3", "3", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "", "4554", "440535"],
          ["2748759", "51154645", "3", "34", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "4558", "440861"],
          ["2748850", "51154601", "3", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "4559", "440955"],
          ["2748923", "51154565", "2", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "4559", "441028"],
          ["2749040", "51154509", "2", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "4561", "441145"],
          ["2750589", "51153742", "2", "139", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4576", "442682"],
          ["2751069", "51153500", "2", "44", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "4581", "443147"],
          ["2757156", "51150349", "4", "555", "1150", "0", "9", "0", "0", "highway=residential oneway=yes", "", "4676", "452714"],
          ["2757179", "51150280", "5", "8", "1150", "0", "3", "0", "0", "highway=residential", "", "4678", "452889"],
          ["2757434", "51150318", "5", "19", "1150", "0", "82", "0", "0", "reversedirection=yes highway=residential", "", "4682", "453292"],
          ["2757918", "51150059", "6", "45", "5150", "0", "40", "0", "0", "reversedirection=yes highway=residential oneway=yes", "", "4716", "454348"],
          ["2763074", "51154758", "4", "640", "1650", "0", "86", "0", "0", "highway=secondary cycleway=lane", "highway=crossing", "4808", "463579"],
          ["2768407", "51159027", "5", "611", "1650", "0", "0", "0", "0", "highway=secondary cycleway=lane", "", "4917", "474485"],
          ["2769015", "51159414", "4", "62", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane", "", "4927", "475468"],
          ["2769163", "51159502", "4", "15", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane route_bicycle_rcn=yes", "", "4929", "475681"],
          ["2811004", "51180275", "0", "3756", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane", "", "5509", "533635"],
          ["2812126", "51180487", "-1", "85", "1650", "0", "18", "0", "0", "highway=secondary oneway=yes", "", "5519", "534687"],
          ["2812564", "51180713", "0", "61", "1650", "0", "0", "0", "0", "highway=secondary junction=roundabout", "", "5526", "535401"],
          ["2812996", "51181189", "0", "63", "1650", "0", "20", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "5537", "536413"],
          ["2815907", "51182636", "0", "262", "1650", "0", "2", "0", "0", "reversedirection=yes highway=secondary cycleway=track", "", "5572", "539935"],
          ["2818636", "51183961", "2", "243", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt", "", "5616", "544361"],
          ["2820852", "51185140", "3", "208", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary", "highway=traffic_signals", "5650", "547736"],
          ["2821300", "51185297", "3", "6", "1650", "0", "0", "0", "0", "highway=secondary", "", "5651", "547817"],
          ["2820852", "51185140", "3", "6", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary", "highway=traffic_signals", "5651", "547875"],
          ["2820559", "51185494", "4", "45", "1450", "0", "92", "0", "0", "highway=tertiary", "", "5656", "548368"],
          ["2818881", "51187345", "9", "239", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt", "", "5712", "553936"],
          ["2818538", "51187662", "10", "43", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "5725", "555276"],
          ["2818448", "51187746", "11", "12", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "5729", "555620"],
          ["2818379", "51187820", "11", "10", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "5732", "555910"],
          ["2817652", "51188597", "14", "101", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes railway=level_crossing", "5781", "560811"],
          ["2817642", "51188608", "14", "2", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "5781", "560852"],
          ["2817211", "51189028", "14", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "5782", "560912"],
          ["2817642", "51188608", "14", "3", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "5782", "560940"],
          ["2819044", "51189246", "15", "123", "1450", "0", "103", "0", "0", "highway=tertiary", "railway=level_crossing", "5797", "562432"],
          ["2820257", "51190214", "11", "142", "1450", "0", "6", "0", "0", "highway=tertiary", "", "5811", "563872"],
          ["2824883", "51192300", "-8192", "402", "1450", "0", "2", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "", "5862", "568642"],
          ["2824781", "51192405", "-8192", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_ncn=yes", "", "5864", "568868"],
          ["2875683", "51214939", "4", "4364", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6608", "643259"],
          ["2876823", "51215561", "5", "106", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6619", "644437"],
          ["2876978", "51215209", "5", "42", "1050", "0", "120", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "railway=level_crossing", "6627", "645198"],
          ["2876987", "51215173", "5", "5", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "railway=level_crossing", "6628", "645290"],
          ["2877005", "51215087", "5", "11", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "6630", "645492"],
          ["2877603", "51215147", "7", "43", "3050", "0", "90", "0", "0", "highway=primary oneway=yes", "", "6641", "646568"],
          ["2877718", "51215152", "8", "9", "1000", "0", "0", "0", "0", "highway=primary oneway=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing", "6643", "646837"],
          ["2880760", "51215741", "6", "229", "1000", "0", "0", "0", "0", "highway=primary oneway=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=traffic_signals", "6694", "651893"],
          ["2880800", "51215760", "6", "4", "1000", "0", "0", "0", "0", "highway=primary oneway=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "6694", "651931"],
          ["2881016", "51215842", "6", "18", "1000", "0", "0", "0", "0", "highway=primary oneway=yes route_bicycle_ncn=yes", "", "6696", "652107"],
          ["2881053", "51215802", "6", "6", "1150", "0", "91", "0", "0", "highway=residential", "highway=crossing crossing=traffic_signals", "6697", "652166"],
          ["2881072", "51215781", "6", "3", "1150", "0", "0", "0", "0", "highway=residential", "highway=traffic_signals traffic_signals:direction=backward", "6697", "652196"],
          ["2881370", "51215465", "6", "41", "1150", "0", "0", "0", "0", "highway=residential", "", "6701", "652610"],
          ["2882071", "51214743", "6", "100", "1150", "0", "45", "0", "0", "highway=residential oneway=yes", "", "6714", "653870"],
          ["2882405", "51214392", "6", "46", "1150", "0", "21", "0", "0", "highway=residential", "", "6720", "654539"],
          ["2883042", "51213724", "4", "90", "1150", "0", "26", "0", "0", "highway=residential oneway=yes", "", "6732", "655714"],
          ["2883580", "51213177", "5", "74", "1150", "0", "9", "0", "0", "reversedirection=yes highway=residential", "highway=traffic_signals", "6743", "656838"],
          ["2883496", "51213139", "5", "8", "1150", "0", "83", "0", "0", "reversedirection=yes highway=secondary surface=asphalt access=yes foot=yes bicycle=yes cycleway=lane oneway=no", "", "6745", "656965"],
          ["2885200", "51211577", "4", "214", "1150", "0", "91", "0", "0", "highway=residential oneway=yes", "", "6777", "660158"],
          ["2888659", "51207729", "3", "511", "1150", "0", "3", "0", "0", "highway=residential", "", "6857", "668230"],
          ["2889052", "51208097", "2", "50", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "6865", "668983"],
          ["2904720", "51208248", "4", "1284", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "7099", "692399"],
          ["2904836", "51208159", "4", "13", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "7101", "692597"],
          ["2906153", "51207221", "2", "141", "1000", "0", "0", "0", "0", "highway=residential oneway=yes oneway:bicycle=no route_bicycle_rcn=yes", "", "7118", "694344"],
          ["2908161", "51204302", "3", "370", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "7180", "700501"],
          ["2908416", "51204196", "3", "54", "1000", "0", "0", "0", "0", "highway=residential junction=roundabout route_bicycle_rcn=yes", "", "7191", "701625"],
          ["2914805", "51202715", "2", "492", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "7272", "709677"],
          ["2914764", "51202592", "2", "2", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "7272", "709708"]
        ],
        "times": [0, 0.184, 5.478, 6.895, 10.01, 13.356, 13.97, 16.964, 31.309, 32.849, 34.254, 35.485, 35.577, 36.026, 36.485, 36.765, 39.872, 41.595, 42.175, 43.071, 43.686, 43.962, 44.526, 45.397, 56.533, 58.07, 106.472, 107.341, 107.861, 108.381, 116.93, 127.299, 165.415, 175.912, 177.856, 179.384, 188.799, 190.561, 191.687, 191.848, 191.94, 192.593, 193.658, 200.254, 203.004, 248.945, 249.977, 251.261, 251.809, 252.72, 280.04, 281.666, 290.991, 292.215, 293.042, 294.3, 295.577, 296.492, 299.437, 306.718, 307.318, 308.312, 309.578, 310.827, 317.886, 319.628, 320.036, 320.295, 320.486, 341.105, 360.923, 362.831, 370.85, 384.173, 472.269, 488.623, 512.377, 544.476, 563.073, 573.714, 590.19, 596.277, 596.451, 596.547, 597.42, 598.946, 599.137, 604.276, 606.107, 606.198, 607.137, 607.233, 607.325, 607.603, 607.966, 625.226, 632.573, 633.035, 633.344, 634.272, 634.564, 635.026, 635.309, 635.499, 637.717, 638.748, 641.687, 663.343, 663.66, 663.844, 664.848, 665.212, 665.77, 666.438, 666.535, 666.627, 668.246, 669.251, 671.266, 676.309, 676.434, 677.109, 678.105, 696.707, 704.179, 706.324, 720.849, 722.326, 729.474, 753.076, 784.283, 792.424, 826.586, 928.805, 942.439, 963.937, 1049.5, 1070.346, 1070.536, 1072.963, 1073.374, 1073.674, 1073.774, 1074.351, 1075.142, 1078.323, 1082.365, 1084.696, 1084.893, 1086.182, 1087.46, 1088.118, 1088.21, 1090.026, 1091.513, 1098.952, 1099.89, 1102.007, 1109.544, 1140.34, 1156.941, 1159.263, 1177.267, 1188.025, 1188.857, 1189.356, 1197.914, 1199.004, 1199.28, 1199.766, 1200.362, 1211.096, 1211.952, 1212.7, 1213.586, 1214.229, 1215.01, 1217.008, 1228.678, 1243.624, 1257.921, 1258.569, 1259.789, 1260.864, 1262.876, 1308.773, 1337.831, 1372.865, 1391.947, 1407.314, 1439.042, 1455.05, 1458.215, 1515.66, 1571.613, 1582.652, 1593.892, 1598.682, 1602.533, 1605.944, 1614.475, 1622.197, 1636.838, 1639.861, 1642.155, 1643.734, 1643.918, 1644.861, 1646.246, 1652.227, 1654.012, 1659.415, 1660.861, 1662.752, 1664.981, 1668.058, 1673.529, 1677.058, 1679.113, 1681.958, 1688.132, 1699.549, 1700.578, 1705.703, 1712.21, 1713.78, 1714.821, 1716.463, 1716.666, 1718.235, 1721.683, 1725.123, 1726.319, 1744.164, 1746.414, 1747.171, 1747.744, 1748.32, 1748.754, 1751.394, 1752.619, 1754.424, 1755.839, 1760.062, 1766.266, 1772.326, 1773.369, 1773.819, 1774.572, 1775.481, 1776.242, 1777.007, 1777.467, 1778.856, 1782.4, 1808.86, 1810.866, 1812.117, 1813.362, 1814.426, 1815.372, 1817.619, 1819.599, 1831.597, 1833.761, 1848.333, 1856.547, 1861.685, 1869.683, 1890.772, 1901.508, 1907.668, 1908.932, 1911.145, 1912.076, 1914.509, 1915.693, 1921.175, 1926.904, 1928.708, 1933.203, 1936.697, 1937.499, 1939.53, 1942.174, 1949.752, 1950.122, 1950.86, 1951.778, 1952.875, 1953.849, 2012.867, 2033.742, 2073.052, 2080.015, 2082.497, 2088.266, 2090.636, 2092.982, 2102.871, 2106.829, 2107.25, 2121.745, 2128.083, 2129.422, 2130.65, 2131.898, 2134.164, 2138.109, 2139.755, 2140.964, 2149.099, 2156.469, 2172.408, 2174.417, 2176.227, 2187.468, 2191.393, 2192.131, 2193.233, 2193.79, 2196.154, 2198.627, 2201.045, 2221.359, 2235.701, 2242.522, 2247.127, 2253.505, 2256.37, 2257.746, 2260.529, 2260.992, 2262.103, 2264.41, 2266.72, 2269.448, 2272.127, 2274.306, 2279.05, 2282.913, 2285.421, 2287.222, 2292.083, 2296.767, 2303.91, 2307.314, 2313.786, 2317.659, 2332.197, 2336.684, 2338.681, 2339.014, 2340.347, 2340.972, 2343.993, 2351.105, 2352.774, 2354.49, 2361.944, 2363.071, 2363.953, 2364.457, 2365.073, 2366.133, 2375.798, 2376.771, 2379.944, 2381.655, 2382.152, 2386.281, 2387.605, 2391.289, 2398.355, 2400.397, 2401.237, 2403.048, 2403.751, 2404.345, 2405.261, 2409.168, 2413.918, 2415.322, 2416.044, 2417.397, 2422.192, 2423.535, 2424.247, 2424.803, 2425.919, 2427.34, 2429.811, 2437.767, 2438.564, 2439.262, 2439.734, 2447.386, 2452.962, 2455.948, 2458.663, 2471.447, 2494.992, 2499.897, 2502.192, 2504.486, 2505.426, 2506.361, 2506.917, 2508.67, 2510.478, 2511.752, 2513.422, 2520.355, 2521.455, 2522.244, 2524.262, 2524.844, 2527.354, 2529.793, 2532.911, 2535.753, 2537.627, 2542.548, 2545.297, 2548.033, 2548.416, 2550.583, 2553.835, 2559.924, 2562.817, 2566.713, 2567.337, 2570.044, 2570.32, 2572.424, 2574.051, 2576.701, 2577.779, 2577.963, 2578.809, 2581.341, 2583.069, 2583.386, 2585.394, 2586.995, 2589.977, 2592.518, 2594.579, 2595.172, 2601.386, 2603.3, 2608.431, 2610.694, 2615.894, 2622.377, 2625.357, 2626.566, 2630.058, 2633.823, 2641.182, 2651.141, 2655.318, 2659.608, 2662.865, 2664.132, 2670.782, 2675.956, 2676.695, 2686.494, 2686.966, 2688.862, 2690.293, 2695.236, 2703.394, 2708.763, 2715.682, 2719.784, 2720.815, 2725.099, 2735.991, 2744.01, 2755.342, 2757.369, 2757.552, 2758.62, 2759.735, 2762.779, 2765.5, 2769.414, 2773.494, 2778.022, 2780.933, 2792.599, 2794.286, 2797.658, 2799.875, 2802.586, 2814.806, 2821.755, 2823.978, 2826.324, 2828.501, 2831.924, 2832.679, 2834.412, 2836.568, 2837.157, 2839.475, 2839.713, 2841.012, 2842.189, 2842.594, 2853.382, 2853.683, 2854.334, 2855.004, 2856.399, 2857.098, 2858.225, 2860.971, 2861.179, 2872.892, 2873.862, 2874.558, 2874.65, 2877.364, 2879.252, 2880.354, 2888.369, 2892.888, 2895.069, 2895.382, 2897.104, 2898.523, 2902.292, 2905.138, 2907.723, 2909.503, 2910.9, 2912.102, 2915.41, 2916.92, 2918.59, 2926.893, 2928.02, 2928.906, 2934.071, 2936.015, 2936.292, 2938.424, 2943.916, 2946.631, 2949.783, 2951.632, 2955.547, 2961.594, 2962.238, 2963.077, 2966.211, 2975.607, 2986.774, 2991.026, 2993.037, 3005.022, 3033.073, 3066.363, 3080.052, 3082.333, 3089.411, 3097.422, 3099.389, 3101.101, 3107.842, 3109.659, 3111.249, 3117.373, 3120.096, 3121.716, 3125.702, 3125.889, 3127.865, 3131.721, 3135.978, 3143.56, 3151.552, 3160.645, 3199.738, 3229.59, 3238.973, 3246.941, 3248.009, 3252.793, 3255.735, 3259.834, 3264.002, 3267.681, 3269.684, 3275.279, 3280.809, 3286.033, 3292.992, 3294.83, 3302.823, 3303.805, 3305.971, 3312.357, 3314.283, 3314.808, 3315.935, 3318.885, 3322.027, 3323.066, 3324.134, 3324.861, 3325.684, 3328.377, 3330.958, 3332.14, 3335.183, 3338.444, 3348.686, 3351.131, 3353.089, 3358.159, 3361.965, 3363.088, 3368.906, 3376.057, 3377.643, 3380.278, 3383.617, 3388.542, 3392.906, 3395.443, 3396.52, 3397.89, 3399.201, 3401.682, 3402.272, 3403.39, 3405.32, 3413.28, 3419.313, 3422.082, 3424.857, 3427.507, 3432.745, 3437.519, 3437.889, 3441.071, 3441.848, 3442.751, 3450.143, 3457.104, 3458.979, 3461.161, 3468.772, 3470.695, 3471.914, 3472.783, 3497.849, 3512.243, 3530.319, 3536.172, 3537.535, 3541.247, 3543.108, 3549.543, 3552.427, 3560.313, 3577.635, 3589.609, 3598.583, 3604.411, 3611.33, 3612.798, 3618.613, 3623.826, 3625.135, 3626.304, 3627.787, 3633.177, 3639.575, 3646.942, 3650.831, 3652.722, 3657.246, 3658.167, 3662.218, 3663.224, 3664.095, 3664.533, 3665.087, 3667.623, 3678.963, 3693.117, 3697.407, 3719.967, 3720.641, 3746.926, 3747.764, 3748.268, 3750.236, 3751.947, 3752.513, 3753.077, 3753.827, 3824.609, 3826.97, 3830.034, 3833.417, 3833.892, 3834.911, 3849.523, 3869.283, 3872.46, 3888.72, 3896.801, 3897.891, 3899.529, 3900.546, 3904.103, 3904.727, 3905.931, 3907.229, 3921.109, 3922.577, 3923.604, 3935.044, 3938.586, 3939.77, 3945.885, 3946.82, 3947.4, 3958.959, 3960.296, 3960.702, 3961.425, 3962.113, 3962.667, 3963.365, 3963.928, 3964.494, 3965.064, 3965.782, 3966.36, 3966.94, 3967.965, 3969.295, 3969.742, 3975.832, 3977.099, 3978.537, 3979.393, 3981.52, 3984.142, 3985.236, 3985.928, 3988.142, 3999.592, 4003.496, 4004.692, 4005.828, 4006.682, 4008.75, 4010.445, 4024.125, 4025.01, 4025.394, 4027.223, 4027.489, 4027.89, 4028.428, 4038.454, 4038.856, 4040.099, 4041.366, 4041.657, 4042.955, 4044.921, 4094.41, 4143.531, 4163.016, 4164.457, 4165.746, 4166.954, 4167.222, 4167.586, 4174.906, 4176.963, 4178.366, 4188.842, 4194.274, 4241.146, 4244.794, 4253.609, 4264.637, 4265.342, 4265.986, 4267.021, 4304.891, 4307.201, 4334.456, 4340.423, 4342.486, 4346.287, 4354.981, 4365.01, 4369.394, 4372.829, 4381.291, 4386.306, 4391.039, 4396.246, 4409.072, 4412.415, 4414.359, 4417.226, 4418.578, 4421.011, 4428.2, 4440.118, 4440.302, 4445.786, 4452.715, 4454.192, 4455.086, 4455.373, 4554.224, 4554.663, 4554.95, 4558.21, 4559.149, 4559.871, 4561.042, 4574.998, 4576.415, 4581.062, 4586.916, 4609.864, 4662.11, 4675.674, 4676.711, 4678.464, 4679.541, 4682.489, 4716.521, 4717.412, 4720.849, 4724.582, 4728.135, 4734.424, 4747.168, 4767.311, 4781.714, 4795.35, 4808.133, 4808.831, 4843.782, 4856.443, 4872.073, 4872.813, 4877.561, 4895.92, 4899.356, 4914.668, 4917.886, 4921.371, 4923.322, 4926.673, 4927.713, 4928.701, 4929.843, 4932.328, 4940.098, 4953.636, 4966.686, 4974.712, 4979.983, 5007.705, 5028.644, 5040, 5058.052, 5066.174, 5077.199, 5095.163, 5100.318, 5111.751, 5134.755, 5174.646, 5195.233, 5205.783, 5220.705, 5239.776, 5252.368, 5258.708, 5273.141, 5281.762, 5299.107, 5312.941, 5348.627, 5364.003, 5372.315, 5374.793, 5383.323, 5391.692, 5402.203, 5412.974, 5432.859, 5470.453, 5470.952, 5509.345, 5512.861, 5516.429, 5518.083, 5519.058, 5519.865, 5520.486, 5520.908, 5521.662, 5522.434, 5523.501, 5524.106, 5525.217, 5526.354, 5526.997, 5527.909, 5529.372, 5537.125, 5540.223, 5546.492, 5547.235, 5555.142, 5560.309, 5567.479, 5572.336, 5574.69, 5593.567, 5610.211, 5616.588, 5629.616, 5632.979, 5634.853, 5637.638, 5640.77, 5645.474, 5650.33, 5651.143, 5651.72, 5656.649, 5670.538, 5699.85, 5712.319, 5725.711, 5729.158, 5732.056, 5781.055, 5781.463, 5781.869, 5782.071, 5782.163, 5782.348, 5793.981, 5797.266, 5798.533, 5801.27, 5803.628, 5804.563, 5811.664, 5814.387, 5817.586, 5820.561, 5825.716, 5862.056, 5862.859, 5863.503, 5864.31, 5866.09, 5868.098, 5875.348, 5879.46, 5880.3, 6052.333, 6062.992, 6098.343, 6233.825, 6295.479, 6314.799, 6346.478, 6368.483, 6372.859, 6528.011, 6531.213, 6551.753, 6591.19, 6606.087, 6608.188, 6619.97, 6622.134, 6626.839, 6627.581, 6628.503, 6629.604, 6630.518, 6636.529, 6641.279, 6643.963, 6664.305, 6670.479, 6674.728, 6679.675, 6683.382, 6686.545, 6688.821, 6694.24, 6694.516, 6694.891, 6696.65, 6697.241, 6697.542, 6701.687, 6702.91, 6706.342, 6713.029, 6714.284, 6717.573, 6720.969, 6722.929, 6731.347, 6732.719, 6733.976, 6734.54, 6735.108, 6743.96, 6745.23, 6751.979, 6758.947, 6762.06, 6767.975, 6772.72, 6777.151, 6789.791, 6794.892, 6798.861, 6802.843, 6807.241, 6812.387, 6815.911, 6817.324, 6823.763, 6837.268, 6844.494, 6857.873, 6863.196, 6865.395, 6873.595, 6879.296, 6880.531, 6887.682, 6909.114, 6913.627, 6921.19, 6929.549, 6935.604, 6967.054, 6979.963, 6982.329, 6985.388, 6987.527, 6989.828, 7010.585, 7019.904, 7028.647, 7032.354, 7038.234, 7054.399, 7062.088, 7076.097, 7080.764, 7090.155, 7091.453, 7093.862, 7096.949, 7099.52, 7101.498, 7103.383, 7109.536, 7118.963, 7126.847, 7134.951, 7141.807, 7145.731, 7150.008, 7155.8, 7165.812, 7177.385, 7180.538, 7182.178, 7183.392, 7184.393, 7184.989, 7186.173, 7187.429, 7188.537, 7189.629, 7190.708, 7191.773, 7200.894, 7202.002, 7202.479, 7218.772, 7219.593, 7226.844, 7228.739, 7238.074, 7242.093, 7244.35, 7246.786, 7258.073, 7262.747, 7267.797, 7270.42, 7272.275, 7272.586]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [2.489877, 51.064166, 3.25],
          [2.489895, 51.064174, 3.25],
          [2.489487, 51.064450, 4.75],
          [2.489398, 51.064512, 5.0],
          [2.489227, 51.064627, 5.75],
          [2.489059, 51.064717, 6.5],
          [2.489037, 51.064730, 6.5],
          [2.488910, 51.064810, 7.0],
          [2.488466, 51.065148, 8.5],
          [2.488444, 51.065191, 8.5],
          [2.488451, 51.065241, 8.25],
          [2.488397, 51.065257, 8.5],
          [2.488397, 51.065257, 8.5],
          [2.488451, 51.065241, 8.25],
          [2.488482, 51.065273, 8.25],
          [2.488505, 51.065285, 8.25],
          [2.488934, 51.065434, 7.25],
          [2.489143, 51.065516, 7.0],
          [2.489203, 51.065551, 6.75],
          [2.489268, 51.065612, 6.75],
          [2.489278, 51.065659, 6.75],
          [2.489284, 51.065685, 6.75],
          [2.489275, 51.065732, 6.75],
          [2.489244, 51.065810, 6.75],
          [2.488897, 51.066450, 8.5],
          [2.488856, 51.066527, 8.5],
          [2.487908, 51.068342, 11.25],
          [2.487896, 51.068382, 11.25],
          [2.487911, 51.068398, 11.25],
          [2.487936, 51.068411, 11.25],
          [2.488542, 51.068579, 11.5],
          [2.489341, 51.068799, 11.25],
          [2.487787, 51.071047, 9.0],
          [2.486940, 51.070807, 9.0],
          [2.486784, 51.070763, 9.0],
          [2.486650, 51.070734, 8.75],
          [2.486396, 51.071241, 8.75],
          [2.486352, 51.071332, 8.75],
          [2.486323, 51.071390, 8.75],
          [2.486318, 51.071389, 8.75],
          [2.486323, 51.071390],
          [2.486352, 51.071332],
          [2.486396, 51.071241],
          [2.486650, 51.070734, 8.75],
          [2.486739, 51.070562, 9.0],
          [2.487809, 51.068483, 11.0],
          [2.487847, 51.068436, 11.0],
          [2.487911, 51.068398, 11.25],
          [2.487896, 51.068382, 11.25],
          [2.487908, 51.068342, 11.25],
          [2.488856, 51.066527, 8.5],
          [2.488897, 51.066450, 8.5],
          [2.489244, 51.065810, 6.75],
          [2.489275, 51.065732, 6.75],
          [2.489284, 51.065685, 6.75],
          [2.489268, 51.065612, 6.75],
          [2.489203, 51.065551, 6.75],
          [2.489143, 51.065516, 7.0],
          [2.488934, 51.065434, 7.25],
          [2.488505, 51.065285, 8.25],
          [2.488482, 51.065273, 8.25],
          [2.488451, 51.065241, 8.25],
          [2.488444, 51.065191, 8.5],
          [2.488466, 51.065148, 8.5],
          [2.488910, 51.064810, 7.0],
          [2.489037, 51.064730, 6.5],
          [2.489059, 51.064717, 6.5],
          [2.489071, 51.064710, 6.25],
          [2.489059, 51.064717, 6.5],
          [2.491811, 51.065469, 3.5],
          [2.493522, 51.065900, 3.25],
          [2.493781, 51.065965, 3.25],
          [2.494697, 51.066121, 3.75],
          [2.495847, 51.066296, 4.5],
          [2.503168, 51.067362, 4.5],
          [2.504772, 51.067678, 3.5],
          [2.506407, 51.068121, 4.25],
          [2.508475, 51.068767, 5.25],
          [2.509564, 51.069113, 6.5],
          [2.510197, 51.069301, 7.0],
          [2.511346, 51.069595, 7.0],
          [2.511769, 51.069680, 7.25],
          [2.511770, 51.069676, 7.0],
          [2.511769, 51.069680, 7.25],
          [2.511875, 51.069722, 7.25],
          [2.512044, 51.069789, 7.25],
          [2.512062, 51.069797, 7.5],
          [2.512753, 51.069952, 7.0],
          [2.512967, 51.070012, 6.75],
          [2.512973, 51.070014, 6.75],
          [2.513025, 51.070088, 6.75],
          [2.513019, 51.070091, 6.75],
          [2.513025, 51.070088, 6.75],
          [2.513059, 51.070078, 6.75],
          [2.513109, 51.070078, 6.5],
          [2.515256, 51.070359, 6.5],
          [2.515937, 51.070449, 6.25],
          [2.515969, 51.070453, 6.25],
          [2.515986, 51.070455, 6.25],
          [2.516060, 51.070465, 6.25],
          [2.516063, 51.070456, 6.0],
          [2.516079, 51.070418, 6.0],
          [2.516120, 51.070423, 6.0],
          [2.516125, 51.070406, 6.0],
          [2.516436, 51.070454, 5.75],
          [2.516561, 51.070504, 5.5],
          [2.516940, 51.070589, 5.5],
          [2.519319, 51.070942, 5.25],
          [2.519316, 51.070951, 5.25],
          [2.519319, 51.070942, 5.25],
          [2.519355, 51.070847, 5.0],
          [2.519368, 51.070813, 4.75],
          [2.519385, 51.070769, 4.75],
          [2.519409, 51.070711, 4.75],
          [2.519401, 51.070709, 4.75],
          [2.519409, 51.070711, 4.75],
          [2.519638, 51.070742, 4.75],
          [2.519774, 51.070754, 4.75],
          [2.520040, 51.070742, 4.75],
          [2.520630, 51.070830, 4.75],
          [2.520629, 51.070834, 4.75],
          [2.520627, 51.070890, 5.0],
          [2.520737, 51.070937, 5.0],
          [2.522577, 51.071197, 6.25],
          [2.523037, 51.071270, 7.5],
          [2.523145, 51.071309, 8.0],
          [2.525072, 51.071610, 7.5],
          [2.525164, 51.071658, 7.75],
          [2.525819, 51.071770, 7.25],
          [2.528146, 51.072144, 6.25],
          [2.530915, 51.072560, 5.75],
          [2.531712, 51.072659, 5.0],
          [2.534341, 51.073059, 6.0],
          [2.543001, 51.074351, 5.25],
          [2.544289, 51.074543, 4.5],
          [2.546308, 51.074857, 4.0],
          [2.553715, 51.075937, 3.0],
          [2.555128, 51.076088, 4.0],
          [2.555142, 51.076090, 4.25],
          [2.555259, 51.075886, 4.0],
          [2.555276, 51.075855, 4.0],
          [2.555294, 51.075831, 3.75],
          [2.555296, 51.075831, 3.75],
          [2.555367, 51.075850, 4.0],
          [2.555467, 51.075872, 4.0],
          [2.555888, 51.075912, 4.0],
          [2.556399, 51.075951, 3.5],
          [2.556748, 51.075978, 3.25],
          [2.556763, 51.075979, 3.25],
          [2.556748, 51.075978, 3.25],
          [2.556722, 51.076091, 3.5],
          [2.556729, 51.076091, 3.5],
          [2.556722, 51.076091, 3.5],
          [2.556464, 51.076070, 3.5],
          [2.556275, 51.076046, 3.75],
          [2.555467, 51.075872, 4.0],
          [2.555517, 51.075800, 3.75],
          [2.555647, 51.075627, 3.5],
          [2.556155, 51.074970, 1.5],
          [2.557799, 51.072890, -0.75],
          [2.558378, 51.072179, 0.25],
          [2.558487, 51.072086, 0.25],
          [2.559070, 51.071281, 0.5],
          [2.559478, 51.070757, 0.25],
          [2.559537, 51.070770, 0.25],
          [2.559566, 51.070777, 0.25],
          [2.559881, 51.070419, 0.75],
          [2.559931, 51.070385, 0.75],
          [2.559981, 51.070366, 0.75],
          [2.560041, 51.070361, 1.0],
          [2.560116, 51.070370, 1.0],
          [2.561459, 51.070550, 0.5],
          [2.561557, 51.070551, 0.25],
          [2.561640, 51.070540, 0.25],
          [2.561711, 51.070507, 0.25],
          [2.561769, 51.070499, 0.25],
          [2.561842, 51.070501, 0.25],
          [2.562045, 51.070518, 0.25],
          [2.563214, 51.070659, 0.0],
          [2.565133, 51.070891, 0.0],
          [2.566612, 51.071078, -0.75],
          [2.566664, 51.071090, -0.75],
          [2.566762, 51.071123, -1.0],
          [2.566852, 51.071113, -1.0],
          [2.567032, 51.071129, -1.0],
          [2.570591, 51.071563, 0.0],
          [2.572896, 51.071846, 0.25],
          [2.575881, 51.072210, 0.0],
          [2.577268, 51.072390, 0.75],
          [2.578478, 51.072546, 0.75],
          [2.581483, 51.072895, -0.5],
          [2.582704, 51.073054, 0.0],
          [2.582958, 51.073071, 0.0],
          [2.587642, 51.073459, 0.25],
          [2.592335, 51.073843, 0.25],
          [2.593117, 51.073893, 1.0],
          [2.593934, 51.073937, 1.25],
          [2.594294, 51.073950, 1.25],
          [2.594571, 51.073945, 1.5],
          [2.594799, 51.073923, 1.75],
          [2.595382, 51.073843, 2.0],
          [2.595967, 51.073759, 1.75],
          [2.597175, 51.073560, 1.5],
          [2.597410, 51.073532, 1.75],
          [2.597585, 51.073521, 1.75],
          [2.597707, 51.073522, 1.75],
          [2.597729, 51.073523, 1.75],
          [2.597866, 51.073536, 1.75],
          [2.598045, 51.073577, 1.75],
          [2.598686, 51.073769, 2.25],
          [2.598833, 51.073827, 2.5],
          [2.599220, 51.074009, 3.0],
          [2.599312, 51.074062, 3.0],
          [2.599398, 51.074144, 3.25],
          [2.599509, 51.074234, 3.25],
          [2.599679, 51.074347, 3.25],
          [2.600057, 51.074537, 3.0],
          [2.600321, 51.074653, 2.75],
          [2.600487, 51.074715, 2.5],
          [2.600739, 51.074775, 2.5],
          [2.601263, 51.074844, 2.75],
          [2.602192, 51.074929, 3.0],
          [2.602262, 51.074939, 3.0],
          [2.602683, 51.074964, 3.0],
          [2.603118, 51.075032, 3.75],
          [2.603222, 51.075053, 3.75],
          [2.603288, 51.075062, 4.0],
          [2.603391, 51.075087, 4.0],
          [2.603390, 51.075094, 4.0],
          [2.603372, 51.075229, 4.25],
          [2.603350, 51.075502, 4.5],
          [2.603322, 51.075741, 4.75],
          [2.603313, 51.075820, 4.75],
          [2.603145, 51.077120, 3.5],
          [2.603131, 51.077246, 3.25],
          [2.603125, 51.077282, 3.25],
          [2.603120, 51.077310, 3.0],
          [2.603116, 51.077344, 3.0],
          [2.603112, 51.077364, 3.0],
          [2.603080, 51.077536, 2.5],
          [2.603064, 51.077614, 2.5],
          [2.603039, 51.077728, 2.5],
          [2.603070, 51.077812, 2.5],
          [2.603007, 51.078064, 2.5],
          [2.602933, 51.078440, 2.25],
          [2.602856, 51.078808, 2.0],
          [2.602844, 51.078864, 2.0],
          [2.602866, 51.078883, 2.0],
          [2.602886, 51.078926, 2.0],
          [2.602882, 51.078971, 2.0],
          [2.602857, 51.079008, 2.0],
          [2.602814, 51.079039, 2.0],
          [2.602787, 51.079049, 2.0],
          [2.602759, 51.079126, 2.0],
          [2.602718, 51.079338, 1.75],
          [2.602338, 51.080772, 2.0],
          [2.602353, 51.080879, 2.0],
          [2.602333, 51.080932, 2.25],
          [2.602323, 51.080991, 2.25],
          [2.602316, 51.081036, 2.25],
          [2.602304, 51.081077, 2.5],
          [2.602265, 51.081182, 2.5],
          [2.602204, 51.081259, 2.75],
          [2.602073, 51.081759, 3.25],
          [2.602048, 51.081852, 3.25],
          [2.601846, 51.082650, 2.5],
          [2.601714, 51.083131, 2.0],
          [2.601637, 51.083417, 2.0],
          [2.601533, 51.083814, 2.5],
          [2.601299, 51.084705, 3.25],
          [2.601160, 51.085198, 3.75],
          [2.601084, 51.085444, 4.5],
          [2.601061, 51.085494, 4.5],
          [2.601073, 51.085583, 4.75],
          [2.601058, 51.085615, 5.0],
          [2.600968, 51.085683, 5.25],
          [2.600940, 51.085724, 5.25],
          [2.600877, 51.085896, 6.0],
          [2.600806, 51.086058, 6.75],
          [2.600801, 51.086107, 7.0],
          [2.600735, 51.086221, 7.5],
          [2.600676, 51.086303, 7.75],
          [2.600632, 51.086365, 8.25],
          [2.600517, 51.086497, 9.0],
          [2.600376, 51.086622, 9.75],
          [2.600023, 51.086902, 10.75],
          [2.600021, 51.086918, 10.75],
          [2.600020, 51.086947, 10.75],
          [2.600024, 51.086987, 10.75],
          [2.600015, 51.087040, 10.75],
          [2.599983, 51.087074, 11.0],
          [2.597478, 51.088555, 14.0],
          [2.596308, 51.089215, 14.25],
          [2.593715, 51.090754, 13.5],
          [2.593332, 51.091044, 13.5],
          [2.593189, 51.091131, 13.75],
          [2.592871, 51.091314, 14.0],
          [2.592715, 51.091376, 14.0],
          [2.592568, 51.091443, 14.0],
          [2.591774, 51.091937, 12.0],
          [2.591439, 51.092105, 11.5],
          [2.591400, 51.092102, 11.75],
          [2.589972, 51.092940, 9.25],
          [2.589453, 51.093250, 8.0],
          [2.589347, 51.093310, 8.0],
          [2.589248, 51.093361, 8.0],
          [2.589141, 51.093401, 8.0],
          [2.588938, 51.093458, 8.0],
          [2.588586, 51.093544, 8.0],
          [2.588639, 51.093630, 8.0],
          [2.588682, 51.093689, 8.0],
          [2.588680, 51.094175, 7.75],
          [2.588688, 51.094575, 8.0],
          [2.588736, 51.095396, 8.25],
          [2.588741, 51.095492, 8.5],
          [2.588754, 51.095578, 8.5],
          [2.588832, 51.096084, 9.0],
          [2.588886, 51.096269, 9.0],
          [2.588911, 51.096298, 9.0],
          [2.588837, 51.096317, 9.0],
          [2.588911, 51.096298, 9.0],
          [2.589063, 51.096489, 9.0],
          [2.589236, 51.096655, 9.0],
          [2.589411, 51.096791, 9.25],
          [2.590292, 51.097396, 12.0],
          [2.590824, 51.097819, 13.0],
          [2.591114, 51.098044, 13.0],
          [2.591327, 51.098216, 12.75],
          [2.591689, 51.098530, 11.75],
          [2.591863, 51.098658, 11.75],
          [2.591903, 51.098731, 11.75],
          [2.591921, 51.098891, 11.75],
          [2.591926, 51.098934, 11.75],
          [2.591989, 51.099034, 11.5],
          [2.592107, 51.099236, 11.25],
          [2.592167, 51.099430, 11.25],
          [2.592202, 51.099644, 11.25],
          [2.592220, 51.099838, 11.25],
          [2.592234, 51.099982, 11.25],
          [2.592264, 51.100289, 11.25],
          [2.592261, 51.100525, 11.25],
          [2.592237, 51.100669, 11.25],
          [2.592218, 51.100768, 11.25],
          [2.592152, 51.101026, 11.5],
          [2.592046, 51.101254, 11.75],
          [2.591840, 51.101559, 12.25],
          [2.591737, 51.101680, 12.75],
          [2.591487, 51.101911, 12.75],
          [2.591336, 51.102058, 12.75],
          [2.590879, 51.102549, 13.75],
          [2.590698, 51.102734, 13.25],
          [2.590615, 51.102819, 13.0],
          [2.590600, 51.102833, 13.0],
          [2.590693, 51.102869, 13.0],
          [2.590731, 51.102884, 12.75],
          [2.591105, 51.103028, 12.75],
          [2.591854, 51.103319, 12.75],
          [2.592034, 51.103390, 12.0],
          [2.592223, 51.103462, 11.5],
          [2.593068, 51.103792, 10.5],
          [2.593210, 51.103848, 10.5],
          [2.593313, 51.103888, 10.5],
          [2.593369, 51.103909, 10.5],
          [2.593436, 51.103938, 10.5],
          [2.593549, 51.103982, 10.5],
          [2.594595, 51.104389, 9.75],
          [2.594687, 51.104425, 9.5],
          [2.594983, 51.104537, 9.5],
          [2.595191, 51.104617, 9.5],
          [2.595248, 51.104640, 9.5],
          [2.595687, 51.104810, 9.75],
          [2.595816, 51.104862, 9.75],
          [2.596115, 51.104968, 10.5],
          [2.596590, 51.105112, 11.5],
          [2.596737, 51.105145, 11.5],
          [2.596845, 51.105169, 11.5],
          [2.597103, 51.105214, 11.25],
          [2.597191, 51.105208, 11.25],
          [2.597268, 51.105212, 11.0],
          [2.597396, 51.105218, 11.0],
          [2.597929, 51.105212, 10.5],
          [2.598519, 51.105184, 10.25],
          [2.598690, 51.105180, 10.0],
          [2.598733, 51.105135, 10.0],
          [2.598889, 51.105126, 10.0],
          [2.599458, 51.105116, 9.5],
          [2.599606, 51.105125, 9.25],
          [2.599685, 51.105133, 9.0],
          [2.599760, 51.105142, 9.0],
          [2.599912, 51.105171, 8.75],
          [2.600106, 51.105211, 8.5],
          [2.600417, 51.105318, 8.25],
          [2.601330, 51.105702, 7.25],
          [2.601415, 51.105730, 7.0],
          [2.601494, 51.105734, 7.0],
          [2.601542, 51.105741, 7.0],
          [2.602272, 51.106043, 6.75],
          [2.602798, 51.106245, 6.25],
          [2.603069, 51.106358, 6.0],
          [2.603310, 51.106470, 5.75],
          [2.604158, 51.106926, 6.5],
          [2.605471, 51.107649, 7.25],
          [2.605765, 51.107799, 7.5],
          [2.605903, 51.107848, 7.75],
          [2.606054, 51.107905, 7.5],
          [2.606076, 51.107943, 7.75],
          [2.606080, 51.107979, 7.75],
          [2.606108, 51.108012, 7.75],
          [2.606333, 51.108078, 7.75],
          [2.606565, 51.108134, 7.5],
          [2.606712, 51.108171, 7.5],
          [2.606911, 51.108209, 7.5],
          [2.607645, 51.108345, 7.75],
          [2.607752, 51.108352, 7.75],
          [2.607830, 51.108365, 7.5],
          [2.608026, 51.108406, 7.5],
          [2.608017, 51.108438, 7.75],
          [2.608260, 51.108480, 7.5],
          [2.608480, 51.108532, 7.5],
          [2.608724, 51.108610, 7.75],
          [2.608942, 51.108689, 7.75],
          [2.609171, 51.108773, 8.0],
          [2.609744, 51.109011, 7.25],
          [2.610014, 51.109153, 7.0],
          [2.610223, 51.109278, 7.5],
          [2.610255, 51.109298, 7.75],
          [2.610437, 51.109430, 8.25],
          [2.610633, 51.109591, 9.25],
          [2.610902, 51.109831, 10.25],
          [2.611018, 51.109942, 10.5],
          [2.611273, 51.110185, 11.75],
          [2.611289, 51.110220, 11.75],
          [2.611448, 51.110368, 12.0],
          [2.611463, 51.110382, 12.0],
          [2.611608, 51.110472, 12.0],
          [2.611699, 51.110559, 11.75],
          [2.611853, 51.110690, 11.75],
          [2.611929, 51.110738, 11.5],
          [2.611946, 51.110749, 11.5],
          [2.612042, 51.110798, 11.5],
          [2.612338, 51.110925, 11.25],
          [2.612550, 51.110987, 11.0],
          [2.612589, 51.110998, 11.0],
          [2.612847, 51.111077, 11.0],
          [2.613038, 51.111121, 11.25],
          [2.613375, 51.111190, 11.5],
          [2.613659, 51.111223, 11.25],
          [2.613895, 51.111231, 11.0],
          [2.613954, 51.111228, 10.75],
          [2.614947, 51.111180, 9.25],
          [2.615194, 51.111176, 9.25],
          [2.615782, 51.111197, 9.5],
          [2.616085, 51.111208, 10.0],
          [2.616644, 51.111233, 10.75],
          [2.617319, 51.111236, 10.5],
          [2.617635, 51.111248, 10.0],
          [2.617753, 51.111253, 10.0],
          [2.618158, 51.111272, 9.25],
          [2.618561, 51.111328, 9.25],
          [2.619261, 51.111380, 9.5],
          [2.620150, 51.111485, 9.5],
          [2.620727, 51.111554, 9.5],
          [2.621216, 51.111648, 9.75],
          [2.621525, 51.111734, 10.0],
          [2.621688, 51.111779, 10.25],
          [2.622378, 51.111982, 11.0],
          [2.622846, 51.112108, 11.25],
          [2.622897, 51.112127, 11.25],
          [2.623679, 51.112413, 11.25],
          [2.623715, 51.112426, 11.25],
          [2.623856, 51.112480, 11.25],
          [2.623953, 51.112520, 11.25],
          [2.624369, 51.112696, 10.5],
          [2.625367, 51.113121, 9.5],
          [2.625834, 51.113338, 10.0],
          [2.626398, 51.113645, 9.5],
          [2.626699, 51.113813, 9.5],
          [2.626814, 51.113877, 9.5],
          [2.627214, 51.114125, 9.75],
          [2.628023, 51.114652, 10.0],
          [2.628529, 51.115015, 10.0],
          [2.629064, 51.115418, 11.0],
          [2.629172, 51.115478, 11.0],
          [2.629176, 51.115481, 11.0],
          [2.629262, 51.115556, 11.25],
          [2.629347, 51.115629, 11.25],
          [2.629580, 51.115826, 11.25],
          [2.629752, 51.116014, 10.75],
          [2.630048, 51.116290, 9.75],
          [2.630309, 51.116595, 9.0],
          [2.630532, 51.116869, 9.5],
          [2.630705, 51.117083, 10.25],
          [2.631135, 51.117632, 12.0],
          [2.631209, 51.117704, 12.0],
          [2.631360, 51.117853, 12.0],
          [2.631445, 51.117957, 11.75],
          [2.631556, 51.118093, 11.5],
          [2.632104, 51.118694, 11.5],
          [2.632559, 51.119194, 11.75],
          [2.632652, 51.119345, 11.5],
          [2.632765, 51.119494, 11.5],
          [2.632902, 51.119609, 11.75],
          [2.633119, 51.119760, 12.0],
          [2.633174, 51.119788, 12.0],
          [2.633360, 51.119882, 12.5],
          [2.633582, 51.119976, 12.75],
          [2.633633, 51.119997, 12.75],
          [2.633857, 51.120079, 12.75],
          [2.633878, 51.120086, 12.5],
          [2.633857, 51.120079, 12.75],
          [2.633948, 51.119997, 12.75],
          [2.633976, 51.119972, 12.75],
          [2.634883, 51.119155, 11.75],
          [2.634898, 51.119162, 11.75],
          [2.634980, 51.119198, 11.75],
          [2.635062, 51.119234, 11.75],
          [2.635201, 51.119321, 11.75],
          [2.635257, 51.119366, 11.5],
          [2.635360, 51.119451, 11.5],
          [2.635575, 51.119658, 11.25],
          [2.635565, 51.119667, 11.25],
          [2.634823, 51.120375, 12.25],
          [2.634781, 51.120432, 12.25],
          [2.634770, 51.120427, 12.25],
          [2.634781, 51.120432, 12.25],
          [2.635110, 51.120555, 12.5],
          [2.635329, 51.120637, 12.25],
          [2.635442, 51.120680, 12.25],
          [2.636419, 51.121045, 10.5],
          [2.636892, 51.121192, 10.5],
          [2.637200, 51.121262, 10.75],
          [2.637234, 51.121269, 10.75],
          [2.637443, 51.121316, 10.75],
          [2.637596, 51.121354, 11.0],
          [2.637946, 51.121418, 11.75],
          [2.638198, 51.121448, 12.0],
          [2.638542, 51.121491, 12.5],
          [2.638757, 51.121514, 12.5],
          [2.638922, 51.121520, 12.5],
          [2.639058, 51.121526, 12.5],
          [2.639412, 51.121520, 12.75],
          [2.639555, 51.121494, 12.75],
          [2.639787, 51.121454, 13.0],
          [2.640951, 51.121319, 11.75],
          [2.641091, 51.121306, 11.5],
          [2.641193, 51.121312, 11.25],
          [2.641868, 51.121251, 10.5],
          [2.642103, 51.121236, 10.25],
          [2.642143, 51.121234, 10.25],
          [2.642445, 51.121220, 10.25],
          [2.643200, 51.121213, 9.75],
          [2.643528, 51.121213, 9.75],
          [2.643875, 51.121214, 9.75],
          [2.644061, 51.121204, 9.75],
          [2.644434, 51.121204, 10.0],
          [2.644971, 51.121230, 10.25],
          [2.645015, 51.121234, 10.25],
          [2.645130, 51.121246, 10.25],
          [2.645542, 51.121290, 10.5],
          [2.646736, 51.121433, 9.5],
          [2.648359, 51.121705, 7.0],
          [2.648739, 51.121781, 7.0],
          [2.648913, 51.121819, 7.0],
          [2.650140, 51.122087, 8.5],
          [2.652581, 51.122741, 8.25],
          [2.655632, 51.123686, 6.5],
          [2.656598, 51.123985, 7.0],
          [2.656762, 51.124028, 7.0],
          [2.657432, 51.124168, 6.0],
          [2.658429, 51.124365, 3.75],
          [2.658622, 51.124412, 4.0],
          [2.658776, 51.124437, 4.25],
          [2.659329, 51.124546, 4.75],
          [2.659466, 51.124576, 4.75],
          [2.659582, 51.124599, 5.0],
          [2.660028, 51.124695, 5.25],
          [2.660215, 51.124745, 5.25],
          [2.660324, 51.124773, 5.25],
          [2.660592, 51.124856, 5.5],
          [2.660595, 51.124857, 5.5],
          [2.660850, 51.124935, 5.75],
          [2.661253, 51.125096, 6.0],
          [2.661639, 51.125270, 6.0],
          [2.662211, 51.125605, 6.0],
          [2.662668, 51.125951, 6.25],
          [2.663027, 51.126312, 7.0],
          [2.664405, 51.127763, 8.25],
          [2.665405, 51.128821, 9.5],
          [2.665824, 51.129250, 9.25],
          [2.666212, 51.129605, 9.25],
          [2.666294, 51.129679, 9.5],
          [2.666674, 51.129975, 9.75],
          [2.666918, 51.130150, 9.25],
          [2.667277, 51.130381, 8.75],
          [2.667642, 51.130597, 8.25],
          [2.667952, 51.130768, 8.25],
          [2.668106, 51.130853, 8.25],
          [2.668520, 51.131045, 8.75],
          [2.668891, 51.131188, 9.25],
          [2.669242, 51.131306, 9.5],
          [2.669646, 51.131434, 10.25],
          [2.669873, 51.131506, 10.75],
          [2.670642, 51.131749, 11.5],
          [2.670723, 51.131785, 11.5],
          [2.670913, 51.131849, 11.25],
          [2.671568, 51.132050, 10.5],
          [2.671753, 51.132106, 10.25],
          [2.671799, 51.132123, 10.25],
          [2.671944, 51.132176, 10.25],
          [2.672311, 51.132292, 10.25],
          [2.672684, 51.132385, 10.0],
          [2.672799, 51.132414, 10.0],
          [2.672912, 51.132451, 10.0],
          [2.672980, 51.132481, 10.0],
          [2.673049, 51.132524, 9.75],
          [2.673331, 51.132602, 9.75],
          [2.673570, 51.132672, 10.0],
          [2.673667, 51.132701, 10.25],
          [2.673893, 51.132766, 10.75],
          [2.674114, 51.132812, 11.25],
          [2.674623, 51.132946, 12.75],
          [2.674740, 51.132966, 13.25],
          [2.674829, 51.132976, 13.5],
          [2.675034, 51.133020, 14.25],
          [2.675195, 51.133058, 14.25],
          [2.675237, 51.133076, 14.25],
          [2.675570, 51.133156, 13.75],
          [2.676100, 51.133290, 13.0],
          [2.676206, 51.133322, 13.0],
          [2.676397, 51.133398, 12.75],
          [2.676641, 51.133464, 13.0],
          [2.677034, 51.133552, 12.75],
          [2.677417, 51.133615, 12.5],
          [2.677648, 51.133646, 12.25],
          [2.677758, 51.133655, 11.75],
          [2.677958, 51.133672, 11.5],
          [2.678157, 51.133681, 11.25],
          [2.678529, 51.133658, 10.5],
          [2.678606, 51.133658, 10.5],
          [2.678749, 51.133658, 10.5],
          [2.679002, 51.133673, 10.5],
          [2.680016, 51.133622, 9.75],
          [2.680726, 51.133594, 9.25],
          [2.681032, 51.133599, 9.0],
          [2.681339, 51.133616, 8.75],
          [2.681613, 51.133639, 8.75],
          [2.682178, 51.133722, 8.25],
          [2.682731, 51.133835, 7.25],
          [2.682779, 51.133845, 7.25],
          [2.683248, 51.133965, 6.25],
          [2.683349, 51.133951, 6.25],
          [2.683458, 51.133982, 6.25],
          [2.684323, 51.134236, 6.0],
          [2.684979, 51.134415, 6.25],
          [2.685135, 51.134472, 6.25],
          [2.685296, 51.134532, 6.5],
          [2.685850, 51.134684, 7.0],
          [2.686002, 51.134708, 7.0],
          [2.686090, 51.134734, 7.0],
          [2.686148, 51.134752, 7.0],
          [2.687868, 51.135256, 7.5],
          [2.688758, 51.135591, 8.25],
          [2.690448, 51.136246, 6.25],
          [2.691191, 51.136534, 5.5],
          [2.691345, 51.136583, 5.25],
          [2.691754, 51.136742, 5.0],
          [2.691926, 51.136810, 5.25],
          [2.692462, 51.137015, 5.75],
          [2.692679, 51.137110, 5.75],
          [2.693309, 51.137361, 5.5],
          [2.694516, 51.138002, 5.5],
          [2.695367, 51.138498, 4.75],
          [2.695923, 51.138754, 5.5],
          [2.696269, 51.138892, 6.0],
          [2.696664, 51.139021, 6.5],
          [2.696671, 51.139011, 6.5],
          [2.696582, 51.138982, 6.25],
          [2.696671, 51.139011, 6.5],
          [2.696664, 51.139021, 6.5],
          [2.696802, 51.139076, 6.25],
          [2.696975, 51.139154, 6.0],
          [2.697585, 51.139311, 6.25],
          [2.698233, 51.139466, 6.25],
          [2.698872, 51.139635, 6.5],
          [2.699183, 51.139726, 6.5],
          [2.699339, 51.139757, 6.5],
          [2.699716, 51.139874, 6.25],
          [2.699799, 51.139885, 6.25],
          [2.700137, 51.140020, 5.75],
          [2.700222, 51.140044, 5.75],
          [2.700295, 51.140069, 5.75],
          [2.700320, 51.140078, 5.75],
          [2.700375, 51.140077, 5.5],
          [2.700600, 51.140151, 5.5],
          [2.701685, 51.140537, 4.5],
          [2.702750, 51.140928, 5.0],
          [2.703064, 51.141037, 5.0],
          [2.704179, 51.141436, 7.25],
          [2.704259, 51.141465, 7.5],
          [2.706174, 51.142209, 10.0],
          [2.706230, 51.142235, 10.0],
          [2.706239, 51.142254, 10.0],
          [2.706367, 51.142304, 10.25],
          [2.706475, 51.142345, 10.5],
          [2.706484, 51.142364, 10.5],
          [2.706502, 51.142385, 10.5],
          [2.706540, 51.142401, 10.5],
          [2.711467, 51.144514, 10.25],
          [2.711588, 51.144610, 10.25],
          [2.711775, 51.144691, 10.75],
          [2.712126, 51.144845, 11.75],
          [2.712168, 51.144857, 11.75],
          [2.712260, 51.144889, 12.0],
          [2.712925, 51.145194, 15.0],
          [2.713616, 51.145501, 17.25],
          [2.713743, 51.145556, 17.5],
          [2.715239, 51.146203, 14.0],
          [2.716149, 51.146594, 11.0],
          [2.716286, 51.146654, 10.75],
          [2.716478, 51.146733, 10.75],
          [2.716580, 51.146787, 10.75],
          [2.716933, 51.146940, 11.25],
          [2.716987, 51.146963, 11.25],
          [2.717096, 51.146992, 11.5],
          [2.717203, 51.147032, 11.75],
          [2.718087, 51.147417, 12.75],
          [2.718256, 51.147491, 13.0],
          [2.718363, 51.147537, 13.0],
          [2.719544, 51.148037, 12.5],
          [2.719966, 51.148216, 12.5],
          [2.720094, 51.148266, 12.5],
          [2.720773, 51.148543, 11.75],
          [2.720886, 51.148590, 11.75],
          [2.720950, 51.148618, 11.75],
          [2.722110, 51.149130, 11.75],
          [2.722231, 51.149161, 11.75],
          [2.722266, 51.149166, 11.75],
          [2.722331, 51.149171, 12.0],
          [2.722375, 51.149148, 11.75],
          [2.722427, 51.149135, 11.75],
          [2.722484, 51.149132, 11.75],
          [2.722539, 51.149140, 11.75],
          [2.722587, 51.149157, 11.75],
          [2.722625, 51.149183, 11.75],
          [2.722649, 51.149217, 11.75],
          [2.722657, 51.149251, 11.75],
          [2.722651, 51.149279, 11.75],
          [2.722607, 51.149328, 11.75],
          [2.722638, 51.149398, 11.75],
          [2.722648, 51.149424, 11.75],
          [2.723105, 51.149634, 11.75],
          [2.723247, 51.149699, 12.0],
          [2.723410, 51.149759, 12.0],
          [2.723482, 51.149813, 12.0],
          [2.723651, 51.149944, 12.0],
          [2.723835, 51.150088, 12.25],
          [2.723875, 51.150150, 12.5],
          [2.723925, 51.150178, 12.5],
          [2.724006, 51.150290, 13.0],
          [2.724566, 51.150707, 13.75],
          [2.724816, 51.150837, 13.5],
          [2.724911, 51.150858, 13.0],
          [2.725014, 51.150868, 12.75],
          [2.725110, 51.150862, 12.0],
          [2.725297, 51.150998, 10.5],
          [2.725489, 51.150886, 9.25],
          [2.727285, 51.149848, 2.75],
          [2.727345, 51.149895, 2.5],
          [2.727367, 51.149912, 2.5],
          [2.727493, 51.149999, 2.5],
          [2.727517, 51.149995, 2.5],
          [2.727542, 51.150012, 2.5],
          [2.727577, 51.150036, 2.5],
          [2.728315, 51.149616, 2.5],
          [2.728348, 51.149638, 0.5],
          [2.728224, 51.149707, 0.5],
          [2.728087, 51.149785, 0.75],
          [2.728109, 51.149801, 0.5],
          [2.728245, 51.149726, 0.5],
          [2.728274, 51.149744, 0.25],
          [2.727774, 51.150321, 0.0],
          [2.727271, 51.150904, 0.0],
          [2.727073, 51.151103, 1.75],
          [2.727088, 51.151115, 1.75],
          [2.727099, 51.151123, 1.75],
          [2.727236, 51.151041, 1.0],
          [2.727265, 51.151060, 1.0],
          [2.727297, 51.151081, 1.0],
          [2.726588, 51.151516, 1.0],
          [2.726756, 51.151625, 1.0],
          [2.726783, 51.151641, 6.5],
          [2.727428, 51.151237, 2.25],
          [2.727802, 51.151381, 2.5],
          [2.731123, 51.152664, 5.75],
          [2.731373, 51.152717, 6.25],
          [2.731996, 51.152777, 6.5],
          [2.732990, 51.153048, 5.25],
          [2.732985, 51.153052, 5.25],
          [2.732990, 51.153048, 5.25],
          [2.733059, 51.152967, 5.25],
          [2.734844, 51.150600, 4.25],
          [2.734939, 51.150488, 4.5],
          [2.736891, 51.150086, 5.5],
          [2.737421, 51.149997, 5.0],
          [2.737615, 51.149998, 4.75],
          [2.738014, 51.149981, 4.25],
          [2.738747, 51.149770, 4.5],
          [2.739544, 51.149508, 4.5],
          [2.739865, 51.149380, 4.5],
          [2.740093, 51.149263, 4.5],
          [2.740463, 51.148847, 4.25],
          [2.740703, 51.148592, 4.0],
          [2.740984, 51.148367, 3.75],
          [2.741311, 51.148146, 3.75],
          [2.742137, 51.147697, 4.0],
          [2.742414, 51.147678, 4.0],
          [2.742662, 51.147755, 3.75],
          [2.742939, 51.147953, 3.25],
          [2.742979, 51.148061, 3.25],
          [2.743006, 51.148249, 3.25],
          [2.743003, 51.148785, 3.0],
          [2.743270, 51.149610, 2.25],
          [2.743273, 51.149620, 2.25],
          [2.742792, 51.149972, 2.5],
          [2.742353, 51.150311, 3.25],
          [2.742282, 51.150384, 3.25],
          [2.742282, 51.150431, 3.25],
          [2.742283, 51.150454, 3.5],
          [2.748390, 51.154831, 3.5],
          [2.748360, 51.154845, 3.25],
          [2.748390, 51.154831, 3.5],
          [2.748759, 51.154645, 3.0],
          [2.748850, 51.154601, 3.0],
          [2.748923, 51.154565, 2.75],
          [2.749040, 51.154509, 2.75],
          [2.750425, 51.153823, 2.25],
          [2.750589, 51.153742, 2.25],
          [2.751069, 51.153500, 2.25],
          [2.751503, 51.153196, 2.5],
          [2.753300, 51.152299, 2.25],
          [2.756459, 51.150713, 3.5],
          [2.757129, 51.150381, 4.75],
          [2.757156, 51.150349, 4.75],
          [2.757179, 51.150280, 5.0],
          [2.757249, 51.150285, 5.0],
          [2.757434, 51.150318, 5.0],
          [2.757918, 51.150059, 6.25],
          [2.757956, 51.150084, 6.0],
          [2.758294, 51.150315, 6.0],
          [2.758625, 51.150559, 5.5],
          [2.758913, 51.150791, 5.0],
          [2.759358, 51.151213, 4.25],
          [2.760145, 51.151970, 4.25],
          [2.761202, 51.152983, 3.75],
          [2.761851, 51.153603, 4.0],
          [2.762477, 51.154203, 4.0],
          [2.763050, 51.154734, 4.25],
          [2.763074, 51.154758, 4.25],
          [2.764519, 51.156145, 5.0],
          [2.765108, 51.156695, 5.0],
          [2.765732, 51.157293, 5.75],
          [2.765764, 51.157319, 5.75],
          [2.765987, 51.157501, 5.75],
          [2.767175, 51.158274, 5.0],
          [2.767389, 51.158410, 4.75],
          [2.768239, 51.158925, 5.5],
          [2.768407, 51.159027, 5.75],
          [2.768603, 51.159154, 5.5],
          [2.768717, 51.159224, 5.25],
          [2.768947, 51.159371, 4.75],
          [2.769015, 51.159414, 4.75],
          [2.769083, 51.159455, 4.5],
          [2.769163, 51.159502, 4.5],
          [2.769350, 51.159617, 4.0],
          [2.770208, 51.160147, 2.5],
          [2.771532, 51.160996, 1.0],
          [2.772365, 51.161515, 1.0],
          [2.772909, 51.161825, 0.75],
          [2.773303, 51.162015, 0.5],
          [2.774969, 51.162820, 1.5],
          [2.776704, 51.163664, 0.0],
          [2.777555, 51.164079, -0.5],
          [2.778645, 51.164585, 0.5],
          [2.779122, 51.164816, 0.75],
          [2.779771, 51.165138, 1.0],
          [2.780962, 51.165708, 0.75],
          [2.781534, 51.165982, 0.75],
          [2.782654, 51.166519, 0.0],
          [2.784258, 51.167292, 0.75],
          [2.786937, 51.168603, 0.75],
          [2.788495, 51.169365, 0.0],
          [2.789284, 51.169750, -0.5],
          [2.790462, 51.170327, -1.0],
          [2.791558, 51.170857, 0.0],
          [2.792263, 51.171197, 0.5],
          [2.792914, 51.171511, 1.0],
          [2.794088, 51.172077, 1.5],
          [2.794739, 51.172385, 1.0],
          [2.795991, 51.172994, 1.0],
          [2.796926, 51.173446, 1.0],
          [2.799471, 51.174671, 0.5],
          [2.800531, 51.175205, 0.25],
          [2.801064, 51.175464, 0.5],
          [2.801333, 51.175594, 1.0],
          [2.802133, 51.175972, 1.0],
          [2.802859, 51.176326, 0.5],
          [2.803742, 51.176743, 0.0],
          [2.804433, 51.177078, 0.75],
          [2.805476, 51.177593, 2.0],
          [2.808127, 51.178880, 1.0],
          [2.808159, 51.178896, 1.0],
          [2.811004, 51.180275, 0.0],
          [2.811319, 51.180360, -0.5],
          [2.811650, 51.180428, -0.75],
          [2.811884, 51.180476, -1.0],
          [2.812019, 51.180505, -1.0],
          [2.812126, 51.180487, -1.0],
          [2.812187, 51.180460, -1.0],
          [2.812237, 51.180448, -1.0],
          [2.812323, 51.180441, -1.0],
          [2.812411, 51.180450, -1.0],
          [2.812519, 51.180492, -0.75],
          [2.812560, 51.180525, -0.75],
          [2.812601, 51.180593, -0.75],
          [2.812593, 51.180672, -0.75],
          [2.812564, 51.180713, -0.75],
          [2.812580, 51.180770, -0.75],
          [2.812655, 51.180853, -0.75],
          [2.812996, 51.181189, 0.25],
          [2.813154, 51.181295, 0.5],
          [2.813531, 51.181473, 0.75],
          [2.813575, 51.181493, 0.75],
          [2.814418, 51.181879, 1.0],
          [2.814890, 51.182107, 0.75],
          [2.815534, 51.182446, 0.0],
          [2.815907, 51.182636, 0.25],
          [2.816066, 51.182714, 0.5],
          [2.817257, 51.183296, 1.0],
          [2.818282, 51.183783, 1.5],
          [2.818636, 51.183961, 2.0],
          [2.819226, 51.184299, 3.0],
          [2.819375, 51.184396, 3.0],
          [2.819560, 51.184517, 3.25],
          [2.819801, 51.184658, 3.75],
          [2.820050, 51.184800, 4.0],
          [2.820431, 51.184981, 4.0],
          [2.820852, 51.185140, 3.75],
          [2.820923, 51.185164, 3.5],
          [2.820852, 51.185140, 3.75],
          [2.820559, 51.185494, 4.0],
          [2.819932, 51.186192, 5.0],
          [2.819206, 51.186977, 7.5],
          [2.818881, 51.187345, 9.25],
          [2.818538, 51.187662, 10.75],
          [2.818448, 51.187746, 11.0],
          [2.818379, 51.187820, 11.25],
          [2.817652, 51.188597, 14.5],
          [2.817642, 51.188608, 14.5],
          [2.817633, 51.188619, 14.5],
          [2.817625, 51.188626, 14.5],
          [2.817633, 51.188619, 14.5],
          [2.817642, 51.188608, 14.5],
          [2.818782, 51.189120, 15.0],
          [2.819044, 51.189246, 15.0],
          [2.819195, 51.189297, 13.5],
          [2.819502, 51.189462, 12.25],
          [2.819696, 51.189640, 11.5],
          [2.819772, 51.189711, 11.5],
          [2.820257, 51.190214, 11.5],
          [2.820446, 51.190368, 11.5],
          [2.820857, 51.190612, 6.75],
          [2.821260, 51.190779, 6.75],
          [2.821858, 51.191026],
          [2.824883, 51.192300],
          [2.824847, 51.192337],
          [2.824818, 51.192367],
          [2.824781, 51.192405],
          [2.824909, 51.192458],
          [2.825150, 51.192559],
          [2.825876, 51.192918],
          [2.826240, 51.193077],
          [2.826341, 51.193121],
          [2.839210, 51.198679],
          [2.840465, 51.199222],
          [2.843039, 51.200352],
          [2.852514, 51.204502],
          [2.856845, 51.206363, 0.5],
          [2.858191, 51.206949, 0.5],
          [2.859236, 51.207409, 4.75],
          [2.860369, 51.207882, 4.75],
          [2.860616, 51.207991, 4.75],
          [2.871227, 51.212710, 4.75],
          [2.871446, 51.212807, 4.75],
          [2.872820, 51.213476, 4.75],
          [2.873922, 51.213984, 10.25],
          [2.875423, 51.214798, 5.0],
          [2.875683, 51.214939, 4.25],
          [2.876823, 51.215561, 5.0],
          [2.876894, 51.215456, 5.25],
          [2.876976, 51.215243, 5.75],
          [2.876978, 51.215209, 5.75],
          [2.876987, 51.215173, 5.75],
          [2.876993, 51.215126, 5.75],
          [2.877005, 51.215087, 5.75],
          [2.877369, 51.215133, 6.75],
          [2.877603, 51.215147, 7.75],
          [2.877718, 51.215152, 8.25],
          [2.878410, 51.215198, 10.75],
          [2.878702, 51.215234, 10.25],
          [2.878947, 51.215269, 9.75],
          [2.879310, 51.215336, 9.0],
          [2.879653, 51.215407, 8.0],
          [2.879978, 51.215489, 7.25],
          [2.880203, 51.215552, 7.0],
          [2.880723, 51.215728, 6.75],
          [2.880760, 51.215741, 6.75],
          [2.880800, 51.215760, 6.75],
          [2.881016, 51.215842, 6.75],
          [2.881053, 51.215802, 6.5],
          [2.881072, 51.215781, 6.5],
          [2.881370, 51.215465, 6.0],
          [2.881368, 51.215372, 6.0],
          [2.881586, 51.215156, 6.0],
          [2.881964, 51.214769, 6.0],
          [2.882071, 51.214743, 6.0],
          [2.882227, 51.214562, 6.0],
          [2.882405, 51.214392, 6.0],
          [2.882425, 51.214279, 6.0],
          [2.882924, 51.213770, 4.75],
          [2.883042, 51.213724, 4.75],
          [2.883103, 51.213662, 4.75],
          [2.883130, 51.213634, 4.75],
          [2.883158, 51.213606, 4.75],
          [2.883580, 51.213177, 5.0],
          [2.883496, 51.213139, 5.0],
          [2.883847, 51.212833, 5.0],
          [2.884218, 51.212509, 4.75],
          [2.884410, 51.212353, 4.25],
          [2.884755, 51.212032, 3.75],
          [2.885028, 51.211800, 3.75],
          [2.885200, 51.211577, 4.0],
          [2.885452, 51.210899, 4.0],
          [2.885480, 51.210622, 4.0],
          [2.885538, 51.210410, 4.0],
          [2.885620, 51.210206, 4.0],
          [2.885755, 51.209971, 3.75],
          [2.885946, 51.209698, 3.5],
          [2.886111, 51.209509, 3.25],
          [2.886186, 51.209434, 3.0],
          [2.886593, 51.209110, 2.75],
          [2.887426, 51.208553, 3.0],
          [2.887897, 51.208238, 2.5],
          [2.888659, 51.207729, 3.0],
          [2.888952, 51.207980, 2.5],
          [2.889052, 51.208097, 2.25],
          [2.889689, 51.207750, 1.75],
          [2.890213, 51.207540, 1.0],
          [2.890336, 51.207529, 1.0],
          [2.891062, 51.207628, 0.75],
          [2.893422, 51.207196, -1.0],
          [2.893833, 51.207118, -1.25],
          [2.894548, 51.207053, -1.5],
          [2.895269, 51.207039, -1.25],
          [2.895386, 51.207262, 0.0],
          [2.895801, 51.208128, 1.75],
          [2.896497, 51.207710, 2.0],
          [2.896640, 51.207645, 2.0],
          [2.896858, 51.207596, 2.0],
          [2.897023, 51.207580, 2.0],
          [2.897200, 51.207610, 2.0],
          [2.898247, 51.208094, 3.5],
          [2.898809, 51.208279, 3.75],
          [2.899368, 51.208419, 4.0],
          [2.899613, 51.208455, 4.25],
          [2.900010, 51.208473, 4.5],
          [2.901340, 51.208503, 4.0],
          [2.901981, 51.208489, 4.0],
          [2.903038, 51.208423, 4.5],
          [2.903355, 51.208453, 5.0],
          [2.904044, 51.208443, 5.0],
          [2.904142, 51.208430, 5.0],
          [2.904309, 51.208377, 4.75],
          [2.904505, 51.208282, 4.75],
          [2.904720, 51.208248, 4.5],
          [2.904836, 51.208159, 4.25],
          [2.904946, 51.208076, 4.0],
          [2.905457, 51.207731, 2.5],
          [2.906153, 51.207221, 2.0],
          [2.906602, 51.206876, 2.5],
          [2.907018, 51.206576, 3.0],
          [2.907381, 51.206318, 3.0],
          [2.907588, 51.206149, 2.75],
          [2.907728, 51.205937, 2.75],
          [2.907807, 51.205610, 2.5],
          [2.907975, 51.204958, 1.5],
          [2.908104, 51.204429, 2.75],
          [2.908161, 51.204302, 3.25],
          [2.908095, 51.204252, 3.25],
          [2.908081, 51.204200, 3.25],
          [2.908096, 51.204165, 3.25],
          [2.908116, 51.204146, 3.25],
          [2.908177, 51.204114, 3.25],
          [2.908257, 51.204104, 3.5],
          [2.908314, 51.204112, 3.75],
          [2.908363, 51.204132, 3.75],
          [2.908398, 51.204161, 3.75],
          [2.908416, 51.204196, 3.75],
          [2.909237, 51.204084, 2.5],
          [2.909325, 51.204067, 2.5],
          [2.909355, 51.204054, 2.5],
          [2.910905, 51.203827, 2.0],
          [2.910967, 51.203828, 2.0],
          [2.911477, 51.203761, 2.75],
          [2.911606, 51.203743, 2.75],
          [2.912263, 51.203646, 3.0],
          [2.912565, 51.203587, 2.75],
          [2.912715, 51.203534, 2.75],
          [2.912880, 51.203461, 2.5],
          [2.913719, 51.203089, 2.25],
          [2.914066, 51.202950, 2.25],
          [2.914442, 51.202805, 2.25],
          [2.914648, 51.202743, 2.25],
          [2.914805, 51.202715, 2.0],
          [2.914800, 51.202701, 2.0],
        ]
      }
    }
  ]
}

let day3: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "Stene - Knokke - 45.7km",
        "track-length": "45742",
        "filtered ascend": "77",
        "plain-ascend": "33",
        "total-time": "7248",
        "total-energy": "691980",
        "cost": "56129",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["2914805", "51202715", "2", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "0", "46"],
          ["2915526", "51203225", "2", "95", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "11", "1105"],
          ["2921796", "51205932", "2", "543", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "99", "9945"],
          ["2921818", "51205989", "2", "7", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "100", "10066"],
          ["2922061", "51206131", "2", "29", "1000", "0", "0", "0", "0", "highway=residential junction=roundabout route_bicycle_rcn=yes", "", "105", "10548"],
          ["2929322", "51209542", "2", "638", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "213", "21388"],
          ["2929319", "51209648", "2", "12", "1150", "0", "37", "0", "0", "highway=residential", "", "216", "21606"],
          ["2930246", "51209983", "3", "78", "1150", "0", "41", "0", "0", "reversedirection=yes highway=residential surface=asphalt bicycle=use_sidepath", "", "231", "23165"],
          ["2932131", "51210401", "4", "145", "1150", "0", "1", "0", "0", "reversedirection=yes highway=residential cycleway=track", "highway=crossing", "249", "24967"],
          ["2934879", "51211188", "2", "218", "1150", "0", "2", "0", "0", "reversedirection=yes highway=residential cycleway=track", "", "279", "27927"],
          ["2935361", "51211551", "2", "53", "1050", "0", "0", "0", "0", "highway=cycleway", "", "286", "28687"],
          ["2934871", "51212907", "2", "171", "1150", "0", "69", "0", "0", "reversedirection=yes highway=residential", "", "306", "30635"],
          ["2934909", "51213192", "3", "32", "1150", "0", "5", "0", "0", "highway=residential oneway=yes", "", "311", "31159"],
          ["2935370", "51216681", "3", "397", "1150", "0", "23", "0", "0", "highway=residential oneway=yes oneway:bicycle=no", "", "382", "38220"],
          ["2935802", "51216939", "3", "43", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "386", "38651"],
          ["2935634", "51216973", "3", "13", "1650", "0", "133", "0", "0", "reversedirection=yes highway=secondary cycleway=lane", "highway=crossing", "387", "38776"],
          ["2934662", "51217265", "3", "79", "1650", "0", "10", "0", "0", "reversedirection=yes highway=secondary cycleway=lane", "", "396", "39612"],
          ["2934574", "51217551", "3", "45", "1050", "0", "106", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "400", "40051"],
          ["2935818", "51218592", "4", "207", "1050", "0", "127", "0", "0", "reversedirection=yes highway=cycleway", "", "425", "42524"],
          ["2935411", "51218804", "4", "1", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "425", "42539"],
          ["2935818", "51218592", "4", "1", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "425", "42548"],
          ["2935840", "51218610", "3", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=stop direction=unknown", "425", "42575"],
          ["2935878", "51218642", "3", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing wheelchair=yes crossing=uncontrolled", "426", "42620"],
          ["2935922", "51218672", "3", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=stop direction=unknown", "426", "42667"],
          ["2936091", "51218799", "3", "19", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "428", "42846"],
          ["2936139", "51218831", "3", "2", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_rcn=yes", "", "428", "42865"],
          ["2936091", "51218799", "3", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete route_bicycle_rcn=yes", "", "428", "42884"],
          ["2937222", "51219897", "3", "252", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "458", "45836"],
          ["2937075", "51219968", "3", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "459", "45991"],
          ["2937079", "51220127", "3", "25", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "462", "46286"],
          ["2937123", "51220156", "3", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "463", "46351"],
          ["2938448", "51220461", "2", "115", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "477", "47752"],
          ["2939135", "51221281", "5", "106", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "496", "49631"],
          ["2939381", "51221590", "7", "39", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "506", "50643"],
          ["2940461", "51222939", "4", "168", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "530", "53031"],
          ["2940278", "51222905", "4", "1", "1050", "0", "151", "0", "0", "reversedirection=yes highway=cycleway", "", "530", "53048"],
          ["2940461", "51222939", "4", "1", "1050", "0", "0", "0", "0", "highway=cycleway", "", "530", "53057"],
          ["2940663", "51223191", "3", "32", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "533", "53343"],
          ["2940824", "51223388", "2", "25", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "535", "53570"],
          ["2940903", "51223510", "2", "16", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes oneway=no route_bicycle_ncn=yes", "", "537", "53721"],
          ["2941185", "51226947", "5", "395", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_ncn=yes", "", "611", "61129"],
          ["2941152", "51226946", "5", "1", "1050", "0", "88", "0", "0", "highway=cycleway", "", "611", "61147"],
          ["2941185", "51226947", "5", "1", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "611", "61156"],
          ["2941272", "51226950", "6", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "612", "61224"],
          ["2941413", "51226955", "6", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "613", "61328"],
          ["2941474", "51226957", "6", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "613", "61384"],
          ["2941515", "51226958", "6", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "614", "61418"],
          ["2941577", "51226960", "6", "1", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "", "614", "61429"],
          ["2941515", "51226958", "6", "1", "1050", "0", "0", "0", "0", "highway=cycleway foot=yes", "highway=crossing crossing=traffic_signals", "614", "61439"],
          ["2941177", "51229258", "6", "258", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "649", "64913"],
          ["2941242", "51229273", "6", "1", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_rcn=yes", "", "649", "64929"],
          ["2941177", "51229258", "6", "1", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "649", "64939"],
          ["2941047", "51229253", "6", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "650", "65029"],
          ["2940905", "51229248", "6", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "651", "65121"],
          ["2940810", "51229244", "6", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes foot=no bicycle=yes railway=crossing", "651", "65185"],
          ["2940756", "51229236", "5", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes foot=no bicycle=yes railway=crossing", "652", "65221"],
          ["2940365", "51229145", "5", "36", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "", "655", "65557"],
          ["2940635", "51229163", "5", "1", "1150", "0", "140", "0", "0", "highway=residential", "", "655", "65567"],
          ["2940365", "51229145", "5", "1", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "", "655", "65576"],
          ["2931158", "51235646", "5", "971", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "808", "80881"],
          ["2930585", "51236050", "5", "62", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "815", "81549"],
          ["2929596", "51236368", "7", "81", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "825", "82577"],
          ["2927481", "51236161", "7", "160", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "847", "84740"],
          ["2925773", "51236543", "6", "133", "1350", "0", "134", "0", "0", "reversedirection=yes highway=service", "", "861", "86132"],
          ["2924439", "51237736", "4", "172", "1350", "0", "23", "0", "0", "highway=service", "", "879", "87918"],
          ["2928742", "51237420", "6", "359", "1350", "0", "81", "0", "0", "reversedirection=yes highway=service bicycle=yes vehicle=no", "", "929", "92968"],
          ["2932762", "51239251", "-8192", "365", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones bicycle=yes vehicle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "972", "97233"],
          ["2952523", "51246821", "-8192", "1624", "1000", "0", "0", "0", "0", "highway=path surface=paved foot=designated bicycle=designated vehicle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1224", "122492"],
          ["2952761", "51246253", "9", "89", "1000", "0", "0", "0", "0", "highway=path surface=paved bicycle=yes vehicle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1233", "123293"],
          ["2952960", "51245664", "7", "100", "1000", "0", "0", "0", "0", "highway=footway foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1241", "124158"],
          ["2953238", "51245506", "6", "35", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "1245", "124466"],
          ["2953265", "51245474", "5", "5", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "1245", "124508"],
          ["2953437", "51245446", "5", "20", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1247", "124684"],
          ["2953461", "51245243", "4", "29", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1249", "124945"],
          ["2953510", "51245173", "4", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "1250", "125030"],
          ["2953529", "51245146", "4", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1251", "125067"],
          ["2957663", "51246668", "5", "342", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=no oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "1299", "129909"],
          ["2957691", "51246674", "5", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=no oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1299", "129959"],
          ["2957788", "51246700", "5", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=no oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1301", "130101"],
          ["2957899", "51246728", "5", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=no oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1303", "130271"],
          ["2961849", "51247974", "5", "314", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1343", "134293"],
          ["2963506", "51248612", "5", "138", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1361", "136143"],
          ["2965220", "51249296", "4", "144", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1378", "137813"],
          ["2966455", "51249656", "4", "96", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1389", "138927"],
          ["2967296", "51249888", "4", "65", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1397", "139761"],
          ["2968548", "51250235", "3", "97", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1410", "141053"],
          ["2974973", "51252007", "3", "494", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing wheelchair=yes crossing=uncontrolled", "1482", "148203"],
          ["2975019", "51252020", "3", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1483", "148268"],
          ["2975601", "51252208", "3", "48", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "1490", "149057"],
          ["2980760", "51253611", "4", "398", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1558", "155802"],
          ["2980893", "51253687", "4", "13", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "1559", "155963"],
          ["2984182", "51254884", "5", "269", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1604", "160414"],
          ["2989363", "51256336", "3", "403", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1656", "165610"],
          ["2993389", "51258083", "4", "347", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1720", "171974"],
          ["2994428", "51259035", "3", "131", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "1741", "174070"],
          ["2995433", "51260391", "4", "167", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1767", "176766"],
          ["2998487", "51261206", "2", "249", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1808", "180842"],
          ["2997994", "51261020", "2", "43", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1813", "181271"],
          ["2998028", "51260980", "2", "6", "1050", "0", "82", "0", "0", "highway=cycleway oneway=no", "", "1813", "181334"],
          ["3000024", "51261540", "3", "156", "1450", "0", "98", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath", "traffic_calming=choker", "1835", "183567"],
          ["3002032", "51261960", "2", "150", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath", "", "1851", "185162"],
          ["3001986", "51261998", "2", "6", "1050", "0", "115", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "1852", "185240"],
          ["3004537", "51262756", "4", "207", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1891", "189144"],
          ["3004773", "51262795", "5", "18", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1893", "189327"],
          ["3005089", "51262862", "5", "25", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1896", "189608"],
          ["3008237", "51263649", "6", "244", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "1928", "192858"],
          ["3016475", "51266228", "7", "656", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2035", "203489"],
          ["3021178", "51267825", "9", "388", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2104", "210383"],
          ["3025203", "51269256", "8", "338", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2150", "215070"],
          ["3025248", "51269220", "8", "1", "1050", "0", "97", "0", "0", "highway=cycleway", "", "2151", "215086"],
          ["3025203", "51269256", "8", "1", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "2151", "215095"],
          ["3026044", "51269751", "8", "81", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2160", "215991"],
          ["3027910", "51270717", "8", "172", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=stop direction=unknown", "2182", "218254"],
          ["3027968", "51270710", "7", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2183", "218301"],
          ["3028048", "51270750", "7", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "2184", "218376"],
          ["3028130", "51270791", "7", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2184", "218452"],
          ["3029656", "51271456", "8", "135", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "2200", "220007"],
          ["3030701", "51271707", "8", "80", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing wheelchair=yes crossing=uncontrolled", "2210", "221057"],
          ["3031400", "51271875", "8", "53", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2219", "221893"],
          ["3031496", "51271898", "8", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2220", "222022"],
          ["3033211", "51272222", "8", "3", "3050", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones bicycle=yes", "", "2220", "222067"],
          ["3031496", "51271898", "8", "3", "3050", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones bicycle=yes", "", "2221", "222096"],
          ["3033419", "51272304", "6", "166", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "2238", "223867"],
          ["3033448", "51272312", "6", "3", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "2239", "223905"],
          ["3033640", "51272361", "6", "15", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "2241", "224096"],
          ["3033771", "51272396", "6", "10", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2242", "224235"],
          ["3033895", "51272449", "6", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "2244", "224391"],
          ["3033926", "51272462", "6", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "2244", "224433"],
          ["3036091", "51272951", "6", "186", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2273", "227295"],
          ["3042344", "51275731", "8", "550", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2353", "235332"],
          ["3042434", "51275774", "8", "8", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2354", "235415"],
          ["3042704", "51275700", "8", "23", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2356", "235654"],
          ["3052729", "51281688", "8", "1066", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2537", "253736"],
          ["3054107", "51282529", "7", "135", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2554", "255447"],
          ["3054225", "51282597", "6", "12", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "2556", "255592"],
          ["3054213", "51282609", "6", "1", "5050", "0", "73", "0", "0", "reversedirection=yes highway=footway surface=asphalt", "", "2556", "255592"],
          ["3054225", "51282597", "6", "1", "5050", "0", "0", "0", "0", "highway=footway surface=asphalt", "highway=crossing crossing=unmarked", "2557", "255592"],
          ["3057289", "51283691", "5", "253", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "2588", "258660"],
          ["3058743", "51283915", "5", "105", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "2606", "260493"],
          ["3062654", "51286457", "3", "420", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "2671", "266996"],
          ["3063746", "51287376", "4", "128", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "2692", "269101"],
          ["3066345", "51289037", "7", "263", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2755", "275388"],
          ["3067584", "51289298", "6", "97", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2769", "276838"],
          ["3070000", "51289608", "4", "178", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2793", "279164"],
          ["3072856", "51290837", "6", "245", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "2838", "283704"],
          ["3074061", "51294489", "5", "476", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2917", "291605"],
          ["3073973", "51294589", "5", "13", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2919", "291832"],
          ["3073833", "51294776", "6", "26", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2923", "292251"],
          ["3076352", "51296405", "2", "257", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "2950", "294941"],
          ["3076447", "51296619", "2", "28", "1000", "0", "0", "0", "0", "highway=path route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "2955", "295377"],
          ["3076237", "51296618", "2", "15", "1000", "0", "0", "0", "0", "highway=primary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2957", "295601"],
          ["3076339", "51296744", "2", "16", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "2960", "295877"],
          ["3077155", "51297788", "4", "131", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2986", "298505"],
          ["3077306", "51297744", "4", "12", "5050", "0", "98", "0", "0", "highway=path", "", "2995", "298691"],
          ["3077421", "51297935", "4", "7", "5050", "0", "96", "0", "0", "reversedirection=yes highway=path", "", "3000", "298795"],
          ["3077306", "51297744", "4", "7", "5050", "0", "0", "0", "0", "highway=path", "", "3004", "298795"],
          ["3077155", "51297788", "4", "12", "5050", "0", "96", "0", "0", "reversedirection=yes highway=path", "", "3012", "298795"],
          ["3077263", "51298066", "4", "33", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3016", "299150"],
          ["3077161", "51299441", "2", "156", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3034", "300955"],
          ["3077308", "51300178", "5", "86", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3052", "302772"],
          ["3077604", "51300392", "5", "33", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3060", "303587"],
          ["3078076", "51299996", "5", "29", "1150", "0", "99", "0", "0", "highway=residential", "", "3066", "304124"],
          ["3077604", "51300392", "5", "29", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "", "3069", "304438"],
          ["3078458", "51300777", "7", "74", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3081", "305709"],
          ["3079103", "51301053", "9", "57", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3094", "306934"],
          ["3079245", "51301098", "9", "12", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "3096", "307201"],
          ["3079169", "51301179", "9", "11", "1150", "0", "95", "0", "0", "reversedirection=yes highway=residential", "railway=level_crossing", "3099", "307473"],
          ["3079146", "51301202", "9", "4", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "railway=level_crossing", "3100", "307575"],
          ["3079080", "51301280", "10", "10", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "", "3103", "307842"],
          ["3079212", "51301318", "10", "11", "1150", "0", "95", "0", "0", "highway=residential oneway=yes", "highway=crossing", "3106", "308140"],
          ["3079623", "51301419", "11", "32", "1150", "0", "2", "0", "0", "highway=residential oneway=yes", "highway=crossing", "3115", "309046"],
          ["3081775", "51302037", "10", "166", "1150", "0", "2", "0", "0", "highway=residential oneway=yes", "", "3149", "312431"],
          ["3081380", "51302465", "10", "56", "1150", "0", "90", "0", "0", "reversedirection=yes highway=residential", "", "3155", "313063"],
          ["3083505", "51303215", "8", "172", "1150", "0", "91", "0", "0", "highway=living_street surface=paving_stones bicycle=yes vehicle=no oneway=yes oneway:bicycle=no", "", "3171", "314622"],
          ["3083902", "51302756", "10", "59", "1150", "0", "93", "0", "0", "highway=residential oneway=yes", "", "3179", "315493"],
          ["3083850", "51302705", "10", "11", "1150", "0", "180", "0", "0", "highway=residential", "railway=level_crossing", "3181", "315627"],
          ["3083872", "51302681", "10", "4", "1150", "0", "0", "0", "0", "highway=residential", "railway=level_crossing", "3181", "315666"],
          ["3083952", "51302595", "10", "12", "1150", "0", "0", "0", "0", "highway=residential", "", "3182", "315793"],
          ["3085046", "51302956", "8", "87", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3191", "316632"],
          ["3086311", "51303153", "5", "120", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3203", "317844"],
          ["3098980", "51307164", "3", "994", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3345", "332114"],
          ["3101292", "51307868", "2", "180", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3372", "334769"],
          ["3104274", "51308787", "3", "233", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3414", "338961"],
          ["3107280", "51309708", "3", "235", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3453", "342844"],
          ["3107430", "51309756", "3", "12", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3455", "343062"],
          ["3112840", "51309694", "2", "399", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3521", "349710"],
          ["3112891", "51309684", "2", "4", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3522", "349776"],
          ["3112977", "51309423", "2", "38", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "3528", "350418"],
          ["3113027", "51309413", "2", "4", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3529", "350483"],
          ["3113081", "51309404", "2", "4", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=unknown", "3530", "350549"],
          ["3113101", "51309401", "2", "2", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=unknown", "3530", "350581"],
          ["3117057", "51308768", "0", "305", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3573", "354833"],
          ["3117376", "51308688", "0", "24", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "3577", "355305"],
          ["3120573", "51309338", "2", "259", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3631", "360675"],
          ["3121245", "51309639", "3", "64", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3641", "361722"],
          ["3121581", "51309701", "3", "26", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "3645", "362035"],
          ["3122199", "51309660", "4", "45", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_lcn=yes", "", "3651", "362693"],
          ["3122504", "51309613", "3", "22", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3654", "363009"],
          ["3123628", "51309449", "3", "81", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3666", "364193"],
          ["3123854", "51309415", "3", "17", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3669", "364455"],
          ["3124417", "51309337", "3", "41", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3675", "365100"],
          ["3124587", "51309311", "3", "13", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3677", "365308"],
          ["3124781", "51309280", "3", "14", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing wheelchair=yes crossing=uncontrolled", "3680", "365548"],
          ["3127018", "51308954", "5", "161", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3712", "368789"],
          ["3127914", "51308826", "4", "65", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3723", "369833"],
          ["3128443", "51308794", "4", "39", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_lcn=yes", "", "3728", "370407"],
          ["3128817", "51308823", "4", "27", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing crossing=traffic_signals", "3732", "370819"],
          ["3129395", "51308925", "4", "43", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing crossing=traffic_signals", "3739", "371493"],
          ["3131044", "51309209", "3", "120", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing wheelchair=yes crossing=uncontrolled", "3758", "373338"],
          ["3131586", "51309302", "3", "40", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing crossing=uncontrolled", "3764", "374002"],
          ["3132248", "51309421", "4", "48", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing wheelchair=yes crossing=uncontrolled", "3773", "374847"],
          ["3132433", "51309454", "4", "14", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing crossing=uncontrolled", "3775", "375090"],
          ["3132616", "51309487", "4", "14", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing wheelchair=yes crossing=uncontrolled", "3778", "375332"],
          ["3135242", "51309933", "4", "191", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=traffic_signals traffic_signals:direction=unknown", "3812", "378732"],
          ["3135403", "51310017", "4", "17", "1050", "0", "19", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "", "3814", "379022"],
          ["3135518", "51309919", "4", "4", "1650", "0", "122", "0", "0", "highway=secondary surface=asphalt bicycle=use_sidepath", "", "3815", "379085"],
          ["3135403", "51310017", "4", "4", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt bicycle=use_sidepath", "", "3815", "379123"],
          ["3135426", "51310111", "4", "11", "1050", "0", "26", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "", "3817", "379231"],
          ["3133516", "51311725", "3", "226", "1050", "0", "27", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "highway=crossing crossing=uncontrolled", "3844", "381936"],
          ["3133406", "51311818", "3", "13", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "", "3846", "382164"],
          ["3133354", "51311865", "3", "7", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=no oneway=yes", "", "3847", "382287"],
          ["3133309", "51311844", "3", "4", "5350", "0", "93", "0", "0", "reversedirection=yes highway=service oneway=yes", "", "3850", "382328"],
          ["3132871", "51312226", "5", "54", "3050", "0", "90", "0", "0", "highway=primary surface=asphalt bicycle=use_sidepath oneway=yes", "highway=traffic_signals traffic_signals:direction=unknown", "3862", "383519"],
          ["3132835", "51312284", "5", "7", "3050", "0", "2", "0", "0", "highway=primary surface=asphalt bicycle=use_sidepath oneway=yes", "highway=crossing crossing=traffic_signals", "3863", "383591"],
          ["3132904", "51312456", "6", "22", "3050", "0", "10", "0", "0", "highway=primary surface=asphalt bicycle=use_sidepath oneway=yes", "", "3865", "383849"],
          ["3133136", "51312602", "6", "23", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "3868", "384125"],
          ["3133391", "51312773", "5", "27", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "3871", "384429"],
          ["3133439", "51312804", "5", "5", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "3872", "384485"],
          ["3133518", "51312849", "5", "8", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "3872", "384577"],
          ["3136099", "51313307", "5", "194", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3899", "387269"],
          ["3136671", "51313363", "5", "42", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3908", "388124"],
          ["3137685", "51313320", "5", "78", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=designated crossing=uncontrolled", "3923", "389600"],
          ["3138495", "51313545", "4", "71", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3934", "390711"],
          ["3140709", "51313767", "3", "159", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3956", "392975"],
          ["3140838", "51313785", "3", "10", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing foot=no bicycle=yes crossing=uncontrolled", "3958", "393124"],
          ["3143326", "51314506", "3", "195", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing wheelchair=yes crossing=uncontrolled", "3989", "396267"],
          ["3145556", "51316163", "2", "248", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "4031", "400422"],
          ["3145571", "51316182", "2", "3", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "4031", "400462"],
          ["3146093", "51317082", "3", "108", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4049", "402270"],
          ["3146494", "51317082", "3", "2", "5050", "0", "66", "0", "0", "reversedirection=yes highway=footway", "", "4051", "402291"],
          ["3146093", "51317082", "3", "2", "5050", "0", "0", "0", "0", "highway=footway", "", "4052", "402291"],
          ["3146569", "51318398", "3", "152", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "4071", "404172"],
          ["3147167", "51319181", "8", "99", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4101", "407156"],
          ["3153571", "51320809", "2", "515", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=unknown", "4168", "413934"],
          ["3153673", "51320827", "2", "8", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "4170", "414046"],
          ["3153848", "51320861", "2", "13", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4171", "414231"],
          ["3155606", "51321397", "3", "138", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=traffic_signals", "4196", "416662"],
          ["3177263", "51326404", "4", "1620", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes", "", "4444", "441524"],
          ["3177583", "51326456", "3", "24", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=yes route_bicycle_ncn=yes", "", "4448", "441878"],
          ["3181241", "51326775", "4", "265", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes", "", "4493", "446362"],
          ["3184797", "51327166", "3", "257", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4533", "450339"],
          ["3184969", "51327184", "3", "13", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "4535", "450557"],
          ["3191382", "51327850", "5", "457", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "4620", "459098"],
          ["3192080", "51327925", "5", "50", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "4629", "459946"],
          ["3194710", "51328226", "7", "188", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "4670", "464046"],
          ["3196229", "51328379", "7", "108", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "4691", "466214"],
          ["3196719", "51328427", "7", "36", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4698", "466863"],
          ["3197504", "51328553", "5", "57", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4705", "467591"],
          ["3198113", "51328613", "4", "43", "1000", "0", "0", "0", "0", "highway=cycleway surface=wood route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4710", "468045"],
          ["3198635", "51328514", "4", "40", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4714", "468511"],
          ["3198934", "51328364", "4", "29", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes", "nodeaccessgranted=yes railway=crossing", "4718", "468880"],
          ["3198994", "51328309", "3", "9", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes", "", "4719", "468994"],
          ["3199038", "51328313", "3", "4", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "4720", "469045"],
          ["3199179", "51328329", "3", "11", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "", "4721", "469189"],
          ["3199203", "51328358", "3", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=stop direction=unknown", "4722", "469242"],
          ["3199223", "51328382", "3", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unknown", "4722", "469296"],
          ["3199277", "51328446", "4", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=stop direction=unknown", "4723", "469425"],
          ["3199320", "51328497", "4", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "4724", "469527"],
          ["3199516", "51328598", "4", "22", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "4728", "469853"],
          ["3199587", "51328600", "4", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_ncn=yes", "", "4728", "469928"],
          ["3203110", "51329100", "6", "260", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes", "", "4782", "475256"],
          ["3204102", "51329440", "6", "83", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=yes route_bicycle_ncn=yes", "", "4796", "476664"],
          ["3204073", "51329463", "6", "4", "5050", "0", "86", "0", "0", "highway=footway", "highway=crossing crossing=uncontrolled", "4799", "476692"],
          ["3204145", "51329505", "6", "8", "1450", "0", "82", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "", "4800", "476798"],
          ["3204558", "51329753", "5", "43", "1150", "0", "19", "0", "0", "highway=residential oneway=yes", "railway=level_crossing", "4804", "477199"],
          ["3206329", "51331429", "5", "226", "1150", "0", "3", "0", "0", "highway=residential oneway=yes", "highway=traffic_signals traffic_signals:direction=unknown", "4835", "480304"],
          ["3206381", "51331483", "5", "8", "1150", "0", "0", "0", "0", "highway=residential oneway=yes", "", "4836", "480417"],
          ["3206416", "51331469", "5", "3", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4836", "480460"],
          ["3206795", "51331834", "4", "50", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "4843", "481176"],
          ["3209125", "51334169", "4", "310", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes oneway=yes route_bicycle_ncn=yes", "", "4890", "485873"],
          ["3213385", "51335862", "1", "363", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes", "", "4948", "491676"],
          ["3218944", "51337128", "6", "450", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5030", "499828"],
          ["3219051", "51337200", "6", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "5032", "500052"],
          ["3219092", "51337223", "6", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5033", "500126"],
          ["3219198", "51337178", "5", "9", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5034", "500281"],
          ["3219173", "51337152", "5", "4", "3050", "0", "85", "0", "0", "highway=primary bicycle=use_sidepath oneway=yes", "highway=crossing crossing=uncontrolled", "5035", "500350"],
          ["3219079", "51337040", "6", "15", "3050", "0", "0", "0", "0", "highway=primary bicycle=use_sidepath oneway=yes", "", "5038", "500624"],
          ["3218903", "51336495", "6", "62", "3050", "0", "4", "0", "0", "highway=primary surface=asphalt bicycle=use_sidepath oneway=yes", "", "5048", "501657"],
          ["3218790", "51336560", "6", "11", "1350", "0", "147", "0", "0", "reversedirection=yes highway=service", "", "5049", "501768"],
          ["3221029", "51332643", "3", "477", "1050", "0", "151", "0", "0", "highway=cycleway oneway=yes", "", "5116", "508443"],
          ["3221174", "51332625", "3", "12", "1050", "0", "85", "0", "0", "reversedirection=yes highway=cycleway", "railway=crossing", "5118", "508594"],
          ["3221226", "51332619", "3", "4", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "railway=crossing", "5118", "508645"],
          ["3221507", "51332603", "3", "22", "1050", "0", "12", "0", "0", "reversedirection=yes highway=cycleway", "", "5121", "508936"],
          ["3221814", "51332888", "4", "40", "1050", "0", "18", "0", "0", "highway=cycleway oneway=no", "", "5128", "509606"],
          ["3228950", "51332435", "5", "639", "1050", "0", "63", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no", "", "5234", "520289"],
          ["3229061", "51332457", "5", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "5236", "520429"],
          ["3230494", "51332750", "4", "106", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5251", "521961"],
          ["3235758", "51333618", "2", "387", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_ncn=yes", "", "5300", "526851"],
          ["3235932", "51333414", "3", "34", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes", "", "5306", "527442"],
          ["3236268", "51332821", "3", "74", "1050", "0", "9", "0", "0", "highway=cycleway oneway=yes", "", "5319", "528725"],
          ["3236346", "51332831", "3", "6", "1050", "0", "89", "0", "0", "reversedirection=yes highway=footway bicycle=yes", "highway=crossing crossing=uncontrolled", "5319", "528784"],
          ["3236405", "51332839", "3", "5", "1050", "0", "0", "0", "0", "reversedirection=yes highway=footway bicycle=yes", "highway=crossing crossing=uncontrolled", "5320", "528835"],
          ["3236492", "51332850", "3", "7", "1050", "0", "0", "0", "0", "reversedirection=yes highway=footway bicycle=yes", "", "5321", "528910"],
          ["3236061", "51333560", "3", "89", "1050", "0", "100", "0", "0", "highway=cycleway oneway=yes", "", "5331", "529897"],
          ["3234534", "51335865", "2", "312", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes", "", "5375", "534353"],
          ["3233094", "51338244", "4", "288", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt oneway=no route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "5428", "539680"],
          ["3232998", "51338808", "4", "64", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt oneway=no route_bicycle_ncn=yes", "", "5440", "540868"],
          ["3233018", "51339289", "5", "56", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_ncn=yes", "", "5447", "541536"],
          ["3233077", "51339294", "5", "5", "1150", "0", "77", "0", "0", "highway=residential", "highway=give_way", "5448", "541601"],
          ["3233210", "51339320", "5", "11", "1150", "0", "6", "0", "0", "highway=residential", "", "5449", "541746"],
          ["3234289", "51339322", "6", "82", "1350", "0", "104", "0", "0", "highway=service", "", "5462", "543027"],
          ["3234364", "51338909", "5", "7", "1350", "0", "86", "0", "0", "reversedirection=yes highway=service", "", "5463", "543141"],
          ["3234289", "51339322", "6", "7", "1350", "0", "0", "0", "0", "highway=service", "", "5464", "543208"],
          ["3234201", "51339318", "6", "7", "1350", "0", "86", "0", "0", "reversedirection=yes highway=service", "", "5464", "543278"],
          ["3233848", "51339725", "8", "53", "1350", "0", "39", "0", "0", "highway=service", "", "5473", "544103"],
          ["3233942", "51339766", "9", "8", "1150", "0", "68", "0", "0", "highway=residential", "", "5474", "544272"],
          ["3233901", "51339814", "9", "2", "5050", "0", "79", "0", "0", "reversedirection=yes highway=footway", "", "5476", "544304"],
          ["3233942", "51339766", "9", "2", "5050", "0", "0", "0", "0", "highway=footway", "", "5477", "544304"],
          ["3234599", "51339977", "10", "52", "1150", "0", "88", "0", "0", "highway=residential", "", "5483", "544940"],
          ["3235333", "51340137", "10", "57", "1150", "0", "1", "0", "0", "highway=residential oneway=yes", "", "5491", "545726"],
          ["3235314", "51340193", "10", "7", "5050", "0", "89", "0", "0", "reversedirection=yes highway=footway foot=yes bicycle=no", "", "5496", "545774"],
          ["3235227", "51340433", "10", "28", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=paved foot=yes bicycle=no", "", "5514", "545780"],
          ["3235223", "51340730", "10", "42", "5050", "0", "183", "0", "0", "highway=footway surface=paving_stones foot=yes bicycle=no", "", "5542", "545780"],
          ["3234538", "51340631", "8", "49", "1150", "0", "89", "0", "0", "highway=residential surface=asphalt bicycle=use_sidepath oneway=yes", "", "5546", "546199"],
          ["3234513", "51340698", "7", "8", "1050", "0", "89", "0", "0", "highway=cycleway", "", "5547", "546272"],
          ["3240712", "51341556", "12", "445", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5608", "552329"],
          ["3254922", "51343249", "10", "1032", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "5773", "568839"],
          ["3265135", "51345551", "12", "826", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5939", "585500"],
          ["3276224", "51348475", "9", "844", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6064", "597998"],
          ["3277526", "51348876", "9", "2", "1050", "0", "0", "0", "0", "highway=cycleway", "", "6065", "598024"],
          ["3276224", "51348475", "-8192", "2", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "6065", "598043"],
          ["3276314", "51348409", "-8192", "10", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6066", "598137"],
          ["3276421", "51348351", "-8192", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes barrier=bollard", "6067", "598235"],
          ["3278360", "51347325", "9", "180", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6085", "600106"],
          ["3278278", "51347268", "9", "4", "1350", "0", "129", "0", "0", "highway=service", "", "6086", "600145"],
          ["3278360", "51347325", "9", "4", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service", "", "6086", "600182"],
          ["3279116", "51347495", "9", "58", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6092", "600804"],
          ["3279571", "51347622", "9", "4", "5000", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6095", "600804"],
          ["3279116", "51347495", "9", "4", "1000", "0", "0", "0", "0", "highway=residential oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6096", "600841"],
          ["3279225", "51347217", "8", "32", "1000", "0", "0", "0", "0", "highway=residential oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=give_way", "6098", "601121"],
          ["3279229", "51347016", "8", "24", "1000", "0", "0", "0", "0", "highway=residential oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6101", "601339"],
          ["3279229", "51346974", "8", "5", "1000", "0", "0", "0", "0", "highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6101", "601386"],
          ["3278949", "51346979", "8", "3", "5050", "0", "92", "0", "0", "reversedirection=yes highway=cycleway oneway=yes", "", "6103", "601386"],
          ["3279229", "51346974", "8", "3", "1050", "0", "0", "0", "0", "highway=cycleway oneway=yes", "", "6103", "601413"],
          ["3284774", "51346670", "8", "396", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6160", "607118"],
          ["3284758", "51346684", "8", "2", "53050", "0", "142", "0", "0", "reversedirection=yes highway=primary bicycle=use_sidepath oneway=yes", "", "6162", "607139"],
          ["3284774", "51346670", "8", "2", "3050", "0", "0", "0", "0", "highway=primary bicycle=use_sidepath oneway=yes", "", "6162", "607158"],
          ["3286169", "51346804", "8", "113", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6174", "608333"],
          ["3286211", "51346805", "8", "3", "1000", "0", "0", "0", "0", "highway=secondary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "6174", "608362"],
          ["3286315", "51346818", "8", "8", "1000", "0", "0", "0", "0", "highway=secondary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6175", "608442"],
          ["3286907", "51346782", "9", "42", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "6179", "608920"],
          ["3288056", "51346730", "9", "81", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "6190", "610002"],
          ["3288121", "51346727", "9", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "6191", "610074"],
          ["3288258", "51346721", "9", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6192", "610221"],
          ["3288386", "51346641", "8", "14", "1000", "0", "0", "0", "0", "highway=secondary foot=no oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6195", "610424"],
          ["3288484", "51346629", "8", "7", "1000", "0", "0", "0", "0", "highway=tertiary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "6196", "610523"],
          ["3289196", "51346587", "8", "51", "1000", "0", "0", "0", "0", "highway=tertiary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "6202", "611193"],
          ["3289350", "51346600", "7", "11", "1000", "0", "0", "0", "0", "highway=tertiary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6204", "611334"],
          ["3289514", "51346711", "7", "35", "1000", "0", "0", "0", "0", "highway=tertiary junction=roundabout route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6207", "611720"],
          ["3295292", "51350054", "9", "568", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "6296", "620563"],
          ["3295620", "51350367", "9", "45", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6303", "621283"],
          ["3295832", "51350385", "9", "19", "1000", "0", "0", "0", "0", "highway=tertiary junction=roundabout route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6305", "621468"],
          ["3295998", "51350375", "8", "12", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=track route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "6306", "621588"],
          ["3304878", "51350413", "6", "622", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=track route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6393", "630303"],
          ["3304591", "51353203", "7", "319", "1150", "0", "167", "0", "0", "reversedirection=yes highway=residential", "", "6444", "635415"],
          ["3312896", "51352129", "6", "770", "1150", "0", "199", "0", "0", "highway=residential", "", "6551", "646108"],
          ["3316754", "51354927", "5", "423", "1150", "0", "5", "0", "0", "highway=residential oneway=no", "", "6612", "652164"],
          ["3316882", "51355399", "5", "56", "1150", "0", "22", "0", "0", "reversedirection=yes highway=residential surface=asphalt oneway=no", "", "6621", "653093"],
          ["3316994", "51355449", "5", "10", "1050", "0", "11", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "6623", "653259"],
          ["3317686", "51355014", "4", "72", "1050", "0", "82", "0", "0", "highway=cycleway surface=paved", "", "6632", "654175"],
          ["3317587", "51354943", "4", "11", "1050", "0", "92", "0", "0", "highway=cycleway oneway=no", "", "6633", "654291"],
          ["3318021", "51354758", "4", "22", "1450", "0", "100", "0", "0", "highway=tertiary bicycle=use_sidepath oneway=no", "", "6636", "654528"],
          ["3317587", "51354943", "4", "22", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary bicycle=use_sidepath oneway=no", "", "6638", "654746"],
          ["3317686", "51355014", "4", "11", "1050", "0", "100", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "6639", "654862"],
          ["3317906", "51354912", "4", "20", "1050", "0", "82", "0", "0", "highway=cycleway surface=paved", "", "6641", "655076"],
          ["3318560", "51355687", "4", "104", "5050", "0", "127", "0", "0", "reversedirection=yes highway=path", "", "6710", "655076"],
          ["3321298", "51356293", "5", "249", "5050", "0", "109", "0", "0", "highway=path surface=sand", "traffic_calming=table", "6880", "655751"],
          ["3321398", "51356302", "5", "8", "5050", "0", "0", "0", "0", "reversedirection=yes highway=path", "", "6886", "655869"],
          ["3320912", "51355523", "5", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6888", "656035"],
          ["3322480", "51357575", "4", "172", "1000", "0", "0", "0", "0", "highway=cycleway surface=paved foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6907", "657968"],
          ["3322389", "51357613", "4", "6", "1050", "0", "88", "0", "0", "reversedirection=yes highway=cycleway foot=designated bicycle=designated", "", "6908", "658044"],
          ["3322480", "51357575", "4", "6", "1050", "0", "0", "0", "0", "highway=cycleway foot=designated bicycle=designated", "", "6909", "658099"],
          ["3324430", "51356823", "4", "161", "1000", "0", "0", "0", "0", "highway=cycleway foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6928", "660033"],
          ["3332567", "51358350", "4", "601", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7017", "668963"],
          ["3344456", "51357912", "8", "1200", "1000", "0", "0", "0", "0", "highway=path surface=compacted foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7234", "690618"],
          ["3344329", "51357951", "9", "1", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=compacted foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7234", "690628"],
          ["3345405", "51355077", "5", "163", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved route_bicycle_rcn=yes", "", "7248", "692033"],
          ["3344361", "51357775", "5", "1", "1000", "0", "0", "0", "0", "highway=cycleway surface=paved route_bicycle_rcn=yes", "", "7248", "692042"]
        ],
        "times": [0, 0.463, 1.656, 3.062, 3.899, 5.647, 11.049, 13.263, 27.391, 39.966, 60.105, 88.182, 96.901, 97.954, 99.449, 100.664, 101.876, 102.567, 103.861, 104.672, 105.484, 107.168, 113.661, 132.212, 137.984, 170.135, 173.386, 213.88, 216.055, 219.494, 222.888, 229.829, 231.278, 231.648, 232.734, 233.347, 236.271, 239.354, 246.786, 249.519, 249.659, 250.924, 264.665, 268.022, 270.757, 276.516, 279.251, 286.851, 288.347, 289.959, 291.475, 294.079, 295.74, 297.722, 298.324, 299.355, 303.251, 304.6, 306.333, 311.569, 315.296, 316.583, 324.336, 326.285, 343.276, 349.74, 352.335, 361.356, 363.479, 375.921, 376.866, 382.167, 382.306, 386.484, 386.7, 387.731, 393.828, 394.942, 396.093, 396.328, 396.884, 397.455, 397.639, 398.2, 399.664, 400.48, 400.584, 407.151, 411.085, 414.707, 415.853, 416.591, 417.147, 417.814, 418.302, 419.002, 425.21, 425.351, 425.443, 425.711, 426.166, 426.63, 428.421, 428.617, 428.801, 432.729, 433.125, 433.526, 433.618, 434.083, 434.575, 435.077, 436.045, 449.377, 452.753, 453.617, 454.027, 454.304, 454.867, 455.445, 456.136, 457.47, 458.324, 459.09, 459.875, 460.331, 460.91, 461.498, 461.975, 462.822, 463.47, 464.259, 464.79, 465.191, 466.273, 466.921, 472.241, 473.06, 474.027, 474.446, 474.722, 477.479, 480.452, 494.855, 496.267, 497.265, 504.143, 506.388, 530.258, 530.42, 530.512, 533.37, 535.643, 535.739, 536.201, 537.156, 544.502, 546.554, 547.624, 548.475, 549.063, 550.388, 553.028, 553.981, 554.832, 568.986, 611.216, 611.398, 611.49, 612.167, 613.207, 613.766, 614.106, 614.22, 614.312, 622.599, 636.646, 649.055, 649.215, 649.307, 650.215, 651.129, 651.77, 652.132, 653.063, 653.447, 654.495, 654.586, 655.494, 655.587, 655.679, 656.238, 664.211, 692.551, 727.815, 745.696, 779.178, 808.664, 809.501, 809.871, 813.468, 815.342, 815.569, 816.22, 820.524, 824.661, 825.437, 825.628, 831.849, 834.158, 836.975, 841.539, 845.372, 846.512, 847.247, 847.37, 849.081, 850.555, 851.077, 851.261, 852.494, 856.355, 858.562, 861.164, 862.476, 863.291, 863.646, 864.015, 865.456, 873.32, 878.143, 879.025, 879.152, 883.117, 884.54, 885.793, 898.058, 904.952, 907.873, 910.812, 912.778, 914.915, 917.553, 926.669, 928.167, 929.332, 929.516, 930.15, 931.089, 932.066, 936.123, 940.327, 940.707, 943.832, 947.349, 949.06, 954.568, 958.123, 962.214, 966.701, 972.158, 991.92, 1008.089, 1009.997, 1024.195, 1030.522, 1115.624, 1187.959, 1202.233, 1218.774, 1220.8, 1224.746, 1225.224, 1225.686, 1226.544, 1228.876, 1229.888, 1230.52, 1230.612, 1231.464, 1233.305, 1236.326, 1236.973, 1237.446, 1239.953, 1241.341, 1241.97, 1243.791, 1244.618, 1245.045, 1245.468, 1245.887, 1246.782, 1247.228, 1248.029, 1248.744, 1249.11, 1249.836, 1250.021, 1250.682, 1251.055, 1251.625, 1251.72, 1259.81, 1260.641, 1272.731, 1282.367, 1295.453, 1298.215, 1298.99, 1299.457, 1299.955, 1301.376, 1303.076, 1310.551, 1314.247, 1319.623, 1326.379, 1328.25, 1336.549, 1341.782, 1343.298, 1351.897, 1352.851, 1361.784, 1367.439, 1368.47, 1372.133, 1377.818, 1378.177, 1378.297, 1378.481, 1388.495, 1389.617, 1396.135, 1397.958, 1409.152, 1410.882, 1411.347, 1446.674, 1446.989, 1455.933, 1458.588, 1475.239, 1475.883, 1477.174, 1482.373, 1483.026, 1486.797, 1488.443, 1490.917, 1494.392, 1496.382, 1506.691, 1531.758, 1535.918, 1550.804, 1556.703, 1558.364, 1559.966, 1561.712, 1576.466, 1582.007, 1603.207, 1603.783, 1604.474, 1611.413, 1620.837, 1625.998, 1634.526, 1636.907, 1641.114, 1648.553, 1651.208, 1656.427, 1659.732, 1677.899, 1687.873, 1690.029, 1696.813, 1698.739, 1711.888, 1720.063, 1723.495, 1729.597, 1735.246, 1741.018, 1754.756, 1767.973, 1772.243, 1773.897, 1775.323, 1776.829, 1778.52, 1780.456, 1787.831, 1789.563, 1791.505, 1794.522, 1799.095, 1800.639, 1802.499, 1807.219, 1808.73, 1808.822, 1809.761, 1813.022, 1813.65, 1817.227, 1818.737, 1826.236, 1829.87, 1835.979, 1836.318, 1837.638, 1839.183, 1848.313, 1851.921, 1852.701, 1854.833, 1861.526, 1862.707, 1872.406, 1875.164, 1877.436, 1880.449, 1890.078, 1891.09, 1891.46, 1891.741, 1893.566, 1894.852, 1896.373, 1898.077, 1899.805, 1906.624, 1910.828, 1912.836, 1914.328, 1921.926, 1923.831, 1927.639, 1928.871, 1940.67, 1947.845, 1988.696, 1990.689, 1992.991, 1998.956, 2004.861, 2007.181, 2008.5, 2010.649, 2012.985, 2021.673, 2023.234, 2035.168, 2039.959, 2042.442, 2051.322, 2063.909, 2067.304, 2071.182, 2078.24, 2088.443, 2092.319, 2096.955, 2102.028, 2104.106, 2113.302, 2117.862, 2119.467, 2121.3, 2122.553, 2129.506, 2150.971, 2151.128, 2151.223, 2155.448, 2160.172, 2166.516, 2173.629, 2178.853, 2182.394, 2182.802, 2182.901, 2183.27, 2184.028, 2184.782, 2189.181, 2189.855, 2193.465, 2194.953, 2196.487, 2197.858, 2200.333, 2201.626, 2206.533, 2209.232, 2210.829, 2212.006, 2219.185, 2220.477, 2220.932, 2221.219, 2221.901, 2223.516, 2223.913, 2224.315, 2224.931, 2225.637, 2228.865, 2234.299, 2235.241, 2235.928, 2236.865, 2237.461, 2238.189, 2238.929, 2239.303, 2241.217, 2242.605, 2244.16, 2244.589, 2248.18, 2250.476, 2255.544, 2257.279, 2261.938, 2262.904, 2263.55, 2264.358, 2265.979, 2267.116, 2268.094, 2269.013, 2270.465, 2272.724, 2273.206, 2273.967, 2277.244, 2278.374, 2290.847, 2291.707, 2292.72, 2303.765, 2306.436, 2318.481, 2322.303, 2328.909, 2339.026, 2341.992, 2345.25, 2347.984, 2349.623, 2350.785, 2352.019, 2352.674, 2353.108, 2353.571, 2354.392, 2355.306, 2356.039, 2356.791, 2362.907, 2374.848, 2376.529, 2393.846, 2399.388, 2402.706, 2408.524, 2413.069, 2417.832, 2427.007, 2429.453, 2431.721, 2434.129, 2435.894, 2438.369, 2443.026, 2493.139, 2497.858, 2500.302, 2502.921, 2508.434, 2511.626, 2514.589, 2516.368, 2517.204, 2525.444, 2532.44, 2535.898, 2537.564, 2547.792, 2554.669, 2556.116, 2556.799, 2557.443, 2558.166, 2561.066, 2562.64, 2573.55, 2578.399, 2582.963, 2586.278, 2588.117, 2606.447, 2609.15, 2611.345, 2614.362, 2616.625, 2620.157, 2623.107, 2626.79, 2629.859, 2636.757, 2643.425, 2647.919, 2651.323, 2661.482, 2666.558, 2671.476, 2683.553, 2692.517, 2707.027, 2713.038, 2716.661, 2732.832, 2751.629, 2755.373, 2757.361, 2759.232, 2761.119, 2763.059, 2764.721, 2769.017, 2769.874, 2771.103, 2782.214, 2784.567, 2786.586, 2788.805, 2793.12, 2818.218, 2819.59, 2821.132, 2838.521, 2840.601, 2844.911, 2859.597, 2861.616, 2863.45, 2865.119, 2866.367, 2872.148, 2892.882, 2894.597, 2896.324, 2898.54, 2899.814, 2902.86, 2917.533, 2919.802, 2920.846, 2922.33, 2923.436, 2923.992, 2927.768, 2933.138, 2940.568, 2944.172, 2946.479, 2950.886, 2951.469, 2954.451, 2955.242, 2957.489, 2960.241, 2966.783, 2978.978, 2984.227, 2986.527, 2995.317, 3000.433, 3004.954, 3012.775, 3014.407, 3016.329, 3018.453, 3019.354, 3020.934, 3024.014, 3030.182, 3031.615, 3034.378, 3035.817, 3042.748, 3046.086, 3049.735, 3052.543, 3058.323, 3060.687, 3066.062, 3069.199, 3071.91, 3081.904, 3082.636, 3083.548, 3088.25, 3094.156, 3096.83, 3099.543, 3100.57, 3103.231, 3106.216, 3113.024, 3115.268, 3134.255, 3147.91, 3149.114, 3149.8, 3155.43, 3155.548, 3169.625, 3169.9, 3171.027, 3179.734, 3180.499, 3180.689, 3181.075, 3181.468, 3182.73, 3191.124, 3193.746, 3194.64, 3195.498, 3196.356, 3196.828, 3197.604, 3198.473, 3199.34, 3200.24, 3201.984, 3203.239, 3203.684, 3204.997, 3207.118, 3210.231, 3229.212, 3233.497, 3263.527, 3306.601, 3345.938, 3372.483, 3384.189, 3392.552, 3398.454, 3414.4, 3437.974, 3444.471, 3451.771, 3453.234, 3455.41, 3461.308, 3464.754, 3467.815, 3471.154, 3475.498, 3478.976, 3482.574, 3487.123, 3490.881, 3494.226, 3498.104, 3502.331, 3505.028, 3521.876, 3522.531, 3523.93, 3524.746, 3525.564, 3526.962, 3527.486, 3528.954, 3529.608, 3530.263, 3530.59, 3531.41, 3532.23, 3533.052, 3533.874, 3535.357, 3536.346, 3537.337, 3538.164, 3547.496, 3549.694, 3558.966, 3561.324, 3567.122, 3573.102, 3577.824, 3582.787, 3585.226, 3587.983, 3594.618, 3598.715, 3601.331, 3602.61, 3605.936, 3611.125, 3613.3, 3617.418, 3627.217, 3629.656, 3631.51, 3633.474, 3635.791, 3637.504, 3638.824, 3639.947, 3640.523, 3641.978, 3643.228, 3644.584, 3645.116, 3647.988, 3649.013, 3651.689, 3654.849, 3666.672, 3669.292, 3675.746, 3677.824, 3680.222, 3707.312, 3712.627, 3723.074, 3725.539, 3727.015, 3728.81, 3730.628, 3732.929, 3735.885, 3739.673, 3758.122, 3764.763, 3773.209, 3775.641, 3778.063, 3793.624, 3812.057, 3812.589, 3813.475, 3814.962, 3815.583, 3815.966, 3817.051, 3818.183, 3818.5, 3841.65, 3843.327, 3843.481, 3844.095, 3846.375, 3847.597, 3850.469, 3855.378, 3861.701, 3862.375, 3863.096, 3863.758, 3864.583, 3865.67, 3868.436, 3871.468, 3872.031, 3872.952, 3874.427, 3875.894, 3877.24, 3878.875, 3880.265, 3889.013, 3893.921, 3899.869, 3902.463, 3908.416, 3910.982, 3916.722, 3917.284, 3918.961, 3919.516, 3922.27, 3923.179, 3923.858, 3925.044, 3925.891, 3926.568, 3927.52, 3927.998, 3932.393, 3934.285, 3936.36, 3940.819, 3950.885, 3956.917, 3958.405, 3964.035, 3965.821, 3970.885, 3976.813, 3980.088, 3984.045, 3986.927, 3989.832, 3992.77, 3998.343, 4006.773, 4011.293, 4016.175, 4019.944, 4021.942, 4026.913, 4029.158, 4031.38, 4031.781, 4034.083, 4038.785, 4044.53, 4049.858, 4051.294, 4052.594, 4056.102, 4061.516, 4063.659, 4067.333, 4071.393, 4073.73, 4077.67, 4089.322, 4101.23, 4104.424, 4108.106, 4109.677, 4114.128, 4117.137, 4117.646, 4121.435, 4122.759, 4123.222, 4125.031, 4128.32, 4129.849, 4131.362, 4133.217, 4134.134, 4136.552, 4139.779, 4149.912, 4155.688, 4161.534, 4166.137, 4168.996, 4170.115, 4171.964, 4175.025, 4176.289, 4188.878, 4196.269, 4200.064, 4211.278, 4224.595, 4228.031, 4231.545, 4250.451, 4258.027, 4272.287, 4300.227, 4348.443, 4356.402, 4369.133, 4419.053, 4420.439, 4421.806, 4437.458, 4444.874, 4448.417, 4452.189, 4454.919, 4477.715, 4491.042, 4491.739, 4492.436, 4493.25, 4494.391, 4496.844, 4510.962, 4530.167, 4531.339, 4532.176, 4533.014, 4535.191, 4536.029, 4544.349, 4545.746, 4548.876, 4553.599, 4562.1, 4567.145, 4569.969, 4595.469, 4620.604, 4626.707, 4629.075, 4631.948, 4659.174, 4665.106, 4670.069, 4674.45, 4691.747, 4694.874, 4697.054, 4698.235, 4701.791, 4705.519, 4710.06, 4710.518, 4711.073, 4714.712, 4717.104, 4717.493, 4718.409, 4719.291, 4719.546, 4720.06, 4721.101, 4721.496, 4722.027, 4722.563, 4723.855, 4724.873, 4726.194, 4726.787, 4727.083, 4728.129, 4728.881, 4730.008, 4730.654, 4731.787, 4755.267, 4755.79, 4757.834, 4767.943, 4779.62, 4782.158, 4784.65, 4789.404, 4792.191, 4794.357, 4795.762, 4796.233, 4799.066, 4799.854, 4800.131, 4801.198, 4802.035, 4804.138, 4811.033, 4825.734, 4831.655, 4833.385, 4835.187, 4836.316, 4836.743, 4837.891, 4839.932, 4843.901, 4845.358, 4848.782, 4850.354, 4865.066, 4887.26, 4890.863, 4893.358, 4895.515, 4897.509, 4904.34, 4907.643, 4916.029, 4919.579, 4926.108, 4932.25, 4939.651, 4947.372, 4948.886, 4949.401, 4949.813, 4950.228, 4951.282, 4952.221, 4952.763, 4953.309, 4955.252, 4957.242, 4957.962, 4958.688, 4959.566, 4960.155, 4960.712, 4961.355, 4961.923, 4962.406, 4964.513, 4978.202, 4987.232, 4993.157, 4996.713, 5002.327, 5009.214, 5018.935, 5026.715, 5027.745, 5028.696, 5029.83, 5030.395, 5031.517, 5032.632, 5033.372, 5034.921, 5035.609, 5038.351, 5040.881, 5045.695, 5047.812, 5048.682, 5049.788, 5052.104, 5054.681, 5058.779, 5060.986, 5063.189, 5074.231, 5075.003, 5088.956, 5094.323, 5105.726, 5109.642, 5111.004, 5112.851, 5115.32, 5116.54, 5117.287, 5118.046, 5118.559, 5119.207, 5120.924, 5121.462, 5122.278, 5125.253, 5126.845, 5128.163, 5129.284, 5130.675, 5131.938, 5133.39, 5135.355, 5137.065, 5139.082, 5141.049, 5143.555, 5145.108, 5146.416, 5147.704, 5149.282, 5150.453, 5151.805, 5162.992, 5169.994, 5170.934, 5171.888, 5172.993, 5173.551, 5187.737, 5222.02, 5234.984, 5236.387, 5247.946, 5251.697, 5254.99, 5259.919, 5266.101, 5268.129, 5269.876, 5272.345, 5279.381, 5287.75, 5293.682, 5295.027, 5296.633, 5300.068, 5300.582, 5301.609, 5302.977, 5303.831, 5304.854, 5306.493, 5307.268, 5308.71, 5310.333, 5318.667, 5319.318, 5319.913, 5320.419, 5321.175, 5321.837, 5327.939, 5328.978, 5330.575, 5331.044, 5331.498, 5331.726, 5332.072, 5333.009, 5333.727, 5334.238, 5334.625, 5335.313, 5335.868, 5336.567, 5337.698, 5338.644, 5339.682, 5340.208, 5340.739, 5352.566, 5358.173, 5372.071, 5373.989, 5374.63, 5375.595, 5378.178, 5401.216, 5409.739, 5413.062, 5418.369, 5423.076, 5427.066, 5428.864, 5436.746, 5440.748, 5441.787, 5442.157, 5443.597, 5447.424, 5448.07, 5448.856, 5449.519, 5451.386, 5452.326, 5453.189, 5453.915, 5461.116, 5462.333, 5463.472, 5464.146, 5464.839, 5466.719, 5467.743, 5469.453, 5473.087, 5474.776, 5476.245, 5477.534, 5483.894, 5486.435, 5488.826, 5491.754, 5496.708, 5497.416, 5512.383, 5514.962, 5529.985, 5535.369, 5542.75, 5546.939, 5547.661, 5552.829, 5561.446, 5576.431, 5601.147, 5608.236, 5627.498, 5633.328, 5635.331, 5648.378, 5661.792, 5675.861, 5677.158, 5685.828, 5731.9, 5756.221, 5765.084, 5767.373, 5768.124, 5770.044, 5773.335, 5775.003, 5805.475, 5814.579, 5828.448, 5846.061, 5895.587, 5898.747, 5910.336, 5914.613, 5915.808, 5919.043, 5936.239, 5939.912, 5943.087, 5977.452, 5985.851, 6019.785, 6025.826, 6027.635, 6046.119, 6047.698, 6058.193, 6064.881, 6065.147, 6065.331, 6066.274, 6067.255, 6078.229, 6078.86, 6084.439, 6085.569, 6085.958, 6086.353, 6086.722, 6087.288, 6087.966, 6092.938, 6095.657, 6096.027, 6098.833, 6099.021, 6099.39, 6099.666, 6101.009, 6101.476, 6103.423, 6103.699, 6107.06, 6107.441, 6109.549, 6115.288, 6133.145, 6141.013, 6156.312, 6159.859, 6160.74, 6162.178, 6162.362, 6162.996, 6163.46, 6170.207, 6170.448, 6170.818, 6171.769, 6172.278, 6172.692, 6173.113, 6173.559, 6174.116, 6174.399, 6175.202, 6179.986, 6181.847, 6190.802, 6191.523, 6192.982, 6194.312, 6195.014, 6196.006, 6198.05, 6202.702, 6204.12, 6204.513, 6204.908, 6205.307, 6205.813, 6206.068, 6206.252, 6206.531, 6206.908, 6207.292, 6207.583, 6207.978, 6208.682, 6209.111, 6209.668, 6209.951, 6210.792, 6213.501, 6217.465, 6223.899, 6229.348, 6230.997, 6233.834, 6237.716, 6244.518, 6249.881, 6257.129, 6264.172, 6268.226, 6269.499, 6273.636, 6282.098, 6291.092, 6296.401, 6299.47, 6301.342, 6303.042, 6303.598, 6303.881, 6304.265, 6304.655, 6305.05, 6305.453, 6306.648, 6316.588, 6358.446, 6360.719, 6393.134, 6393.785, 6403.396, 6405.111, 6412.318, 6418.985, 6438.647, 6443.954, 6444.338, 6444.895, 6445.64, 6448.335, 6457.419, 6461.265, 6463.012, 6487.803, 6490.069, 6492.237, 6509.558, 6510.9, 6537.633, 6540.506, 6541.933, 6546.325, 6548.802, 6551.815, 6553.286, 6554.803, 6556.162, 6557.817, 6563.006, 6563.662, 6585.464, 6586.759, 6594.952, 6612.371, 6614.521, 6616.509, 6618.999, 6620.494, 6621.659, 6623.323, 6627.992, 6628.492, 6629.909, 6632.477, 6633.643, 6636.011, 6638.193, 6639.354, 6641.493, 6642.163, 6652.273, 6661.708, 6667.812, 6672.332, 6700.515, 6710.567, 6728.199, 6734.354, 6739.199, 6745.443, 6754.491, 6773.413, 6784.536, 6799.043, 6828.236, 6857.184, 6869.321, 6880.933, 6886.777, 6887.517, 6888.436, 6888.899, 6889.291, 6896.103, 6901.465, 6907.771, 6908.523, 6909.08, 6911.486, 6928.414, 6929.373, 6931.743, 6932.615, 6935.745, 6937.137, 6943.606, 6954.322, 7004.079, 7007.759, 7017.708, 7020.774, 7024.832, 7030.046, 7066.658, 7078.13, 7086.8, 7088.883, 7139.631, 7144.866, 7163.023, 7165.502, 7166.633, 7167.307, 7168.343, 7169.351, 7170.039, 7170.529, 7173.341, 7185.988, 7218.024, 7223.077, 7228.228, 7231.258, 7234.117, 7234.227, 7234.322, 7234.881, 7235.34, 7236.351, 7236.533, 7248.379, 7248.471]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [2.914793, 51.202679, 2.0],
          [2.914805, 51.202715, 2.0],
          [2.914648, 51.202743, 2.25],
          [2.914773, 51.202837, 2.0],
          [2.914846, 51.202892, 2.0],
          [2.915018, 51.202983, 2.0],
          [2.915526, 51.203225, 2.0],
          [2.915761, 51.203204, 2.0],
          [2.916756, 51.203667, 2.75],
          [2.917621, 51.204074, 2.75],
          [2.919189, 51.204811, 2.0],
          [2.921061, 51.205685, 2.25],
          [2.921616, 51.205940, 2.5],
          [2.921692, 51.205946, 2.5],
          [2.921796, 51.205932, 2.75],
          [2.921818, 51.205989, 2.5],
          [2.921907, 51.205996, 2.5],
          [2.921949, 51.206008, 2.5],
          [2.922026, 51.206055, 2.25],
          [2.922052, 51.206091, 2.25],
          [2.922061, 51.206131, 2.25],
          [2.922161, 51.206197, 2.0],
          [2.922702, 51.206451, 1.25],
          [2.924130, 51.207119, 1.25],
          [2.924501, 51.207293, 1.5],
          [2.926583, 51.208266, 1.75],
          [2.926788, 51.208361, 2.0],
          [2.929322, 51.209542, 2.5],
          [2.929319, 51.209648, 2.75],
          [2.929524, 51.209741, 3.0],
          [2.929726, 51.209810, 3.25],
          [2.930135, 51.209926, 3.75],
          [2.930209, 51.209964, 3.75],
          [2.930246, 51.209983, 3.75],
          [2.930361, 51.210037, 4.0],
          [2.930433, 51.210060, 4.0],
          [2.930783, 51.210146, 4.0],
          [2.931111, 51.210215, 4.25],
          [2.931864, 51.210352, 4.25],
          [2.932126, 51.210400, 4.0],
          [2.932131, 51.210401, 4.0],
          [2.932250, 51.210424, 4.0],
          [2.933774, 51.210717, 3.0],
          [2.934039, 51.210791, 3.0],
          [2.934257, 51.210862, 2.75],
          [2.934699, 51.211071, 2.5],
          [2.934879, 51.211188, 2.25],
          [2.935361, 51.211551, 2.0],
          [2.935395, 51.211636, 2.0],
          [2.935364, 51.211771, 2.0],
          [2.935246, 51.211873, 2.0],
          [2.935008, 51.212024, 2.0],
          [2.934887, 51.212135, 1.75],
          [2.934813, 51.212278, 1.75],
          [2.934812, 51.212315, 1.75],
          [2.934812, 51.212413, 1.75],
          [2.934843, 51.212716, 2.5],
          [2.934917, 51.212796, 2.5],
          [2.934871, 51.212907, 2.75],
          [2.934909, 51.213192, 3.5],
          [2.934939, 51.213363, 4.0],
          [2.934916, 51.213418, 4.0],
          [2.934963, 51.213802, 4.0],
          [2.935000, 51.213890, 4.0],
          [2.935100, 51.214645, 4.75],
          [2.935130, 51.214921, 5.25],
          [2.935141, 51.215032, 5.25],
          [2.935210, 51.215474, 5.0],
          [2.935201, 51.215574, 5.0],
          [2.935294, 51.216306, 4.25],
          [2.935323, 51.216351, 4.25],
          [2.935370, 51.216681, 3.75],
          [2.935370, 51.216681, 3.5],
          [2.935802, 51.216939, 3.5],
          [2.935775, 51.216944, 3.5],
          [2.935634, 51.216973, 3.5],
          [2.934843, 51.217135, 3.25],
          [2.934743, 51.217192, 3.0],
          [2.934662, 51.217265, 3.0],
          [2.934674, 51.217270, 3.0],
          [2.934741, 51.217297, 3.0],
          [2.934798, 51.217330, 3.0],
          [2.934800, 51.217349, 3.0],
          [2.934767, 51.217395, 3.0],
          [2.934646, 51.217500, 3.0],
          [2.934574, 51.217551, 3.0],
          [2.934582, 51.217554, 3.0],
          [2.935293, 51.217815, 3.75],
          [2.935704, 51.217940, 3.5],
          [2.936111, 51.218026, 3.0],
          [2.936217, 51.218058, 3.0],
          [2.936275, 51.218093, 2.75],
          [2.936312, 51.218144, 2.75],
          [2.936315, 51.218198, 2.75],
          [2.936302, 51.218240, 2.75],
          [2.936261, 51.218289, 2.75],
          [2.935818, 51.218592, 4.0],
          [2.935809, 51.218596, 4.0],
          [2.935818, 51.218592, 4.0],
          [2.935840, 51.218610, 3.75],
          [2.935878, 51.218642, 3.75],
          [2.935922, 51.218672, 3.75],
          [2.936091, 51.218799, 3.5],
          [2.936103, 51.218807, 3.5],
          [2.936091, 51.218799, 3.5],
          [2.936622, 51.218598, 2.5],
          [2.936673, 51.218588, 2.5],
          [2.936723, 51.218587, 2.5],
          [2.936736, 51.218587, 2.5],
          [2.936806, 51.218595, 2.5],
          [2.936861, 51.218613, 2.75],
          [2.936904, 51.218637, 2.75],
          [2.936959, 51.218703, 3.0],
          [2.937530, 51.219513, 3.5],
          [2.937667, 51.219705, 3.25],
          [2.937683, 51.219749, 3.25],
          [2.937683, 51.219775, 3.0],
          [2.937683, 51.219795, 3.0],
          [2.937643, 51.219833, 3.0],
          [2.937583, 51.219862, 3.0],
          [2.937496, 51.219876, 3.0],
          [2.937319, 51.219879, 3.0],
          [2.937222, 51.219897, 3.0],
          [2.937139, 51.219932, 3.0],
          [2.937075, 51.219968, 3.0],
          [2.937040, 51.219988, 3.0],
          [2.937008, 51.220022, 3.0],
          [2.937005, 51.220058, 3.0],
          [2.937022, 51.220085, 3.0],
          [2.937079, 51.220127, 3.0],
          [2.937123, 51.220156, 3.25],
          [2.937187, 51.220191, 3.25],
          [2.937235, 51.220207, 3.25],
          [2.937273, 51.220211, 3.25],
          [2.937370, 51.220189, 3.25],
          [2.937427, 51.220185, 3.0],
          [2.938007, 51.220186, 2.75],
          [2.938085, 51.220195, 2.75],
          [2.938173, 51.220215, 2.75],
          [2.938202, 51.220230, 2.75],
          [2.938228, 51.220243, 2.75],
          [2.938448, 51.220461, 2.5],
          [2.938641, 51.220661, 2.75],
          [2.939095, 51.221233, 5.25],
          [2.939135, 51.221281, 5.5],
          [2.939165, 51.221320, 5.5],
          [2.939328, 51.221528, 6.75],
          [2.939381, 51.221590, 7.25],
          [2.940461, 51.222939, 4.25],
          [2.940450, 51.222936, 4.25],
          [2.940461, 51.222939, 4.25],
          [2.940663, 51.223191, 3.5],
          [2.940824, 51.223388, 2.75],
          [2.940824, 51.223388, 2.75],
          [2.940850, 51.223428, 2.75],
          [2.940903, 51.223510, 2.75],
          [2.941231, 51.224068, 2.75],
          [2.941313, 51.224221, 2.25],
          [2.941346, 51.224295, 2.25],
          [2.941328, 51.224355, 2.25],
          [2.941334, 51.224393, 2.0],
          [2.941349, 51.224484, 2.0],
          [2.941339, 51.224677, 1.75],
          [2.941365, 51.224738, 1.5],
          [2.941370, 51.224793, 1.5],
          [2.941324, 51.225556, 2.75],
          [2.941185, 51.226947, 5.75],
          [2.941183, 51.226946, 5.75],
          [2.941185, 51.226947, 5.75],
          [2.941272, 51.226950, 6.0],
          [2.941413, 51.226955, 6.25],
          [2.941474, 51.226957, 6.5],
          [2.941515, 51.226958, 6.5],
          [2.941526, 51.226958, 6.5],
          [2.941515, 51.226958, 6.5],
          [2.941392, 51.227651, 6.5],
          [2.941274, 51.228555, 7.0],
          [2.941177, 51.229258, 6.75],
          [2.941181, 51.229258, 6.75],
          [2.941177, 51.229258, 6.75],
          [2.941047, 51.229253, 6.5],
          [2.940905, 51.229248, 6.25],
          [2.940810, 51.229244, 6.0],
          [2.940756, 51.229236, 5.75],
          [2.940624, 51.229235, 5.75],
          [2.940581, 51.229226, 5.75],
          [2.940427, 51.229217, 5.5],
          [2.940425, 51.229217, 5.5],
          [2.940365, 51.229145, 5.25],
          [2.940373, 51.229145, 5.25],
          [2.940365, 51.229145, 5.25],
          [2.940327, 51.229191, 5.25],
          [2.939605, 51.229695, 5.0],
          [2.937762, 51.230996, 5.25],
          [2.935490, 51.232615, 4.0],
          [2.934524, 51.233314, 4.25],
          [2.932841, 51.234437, 5.25],
          [2.931158, 51.235646, 5.0],
          [2.931108, 51.235678, 5.0],
          [2.931079, 51.235698, 5.0],
          [2.930729, 51.235933, 5.0],
          [2.930585, 51.236050, 5.0],
          [2.930570, 51.236053, 5.0],
          [2.930479, 51.236072, 5.0],
          [2.929996, 51.236227, 5.75],
          [2.929646, 51.236323, 6.75],
          [2.929608, 51.236356, 6.75],
          [2.929596, 51.236368, 7.0],
          [2.928903, 51.236415, 8.25],
          [2.928679, 51.236419, 8.5],
          [2.928436, 51.236405, 8.75],
          [2.927997, 51.236347, 8.25],
          [2.927593, 51.236260, 7.5],
          [2.927502, 51.236213, 7.25],
          [2.927481, 51.236161, 7.0],
          [2.927469, 51.236162, 7.0],
          [2.927215, 51.236184, 7.0],
          [2.927067, 51.236260, 7.25],
          [2.927009, 51.236254, 7.0],
          [2.926990, 51.236253, 7.0],
          [2.926820, 51.236277, 7.0],
          [2.926359, 51.236441, 7.0],
          [2.926096, 51.236508, 6.75],
          [2.925773, 51.236543, 6.5],
          [2.925620, 51.236555, 6.5],
          [2.925536, 51.236569, 6.25],
          [2.925511, 51.236581, 6.25],
          [2.925477, 51.236599, 6.25],
          [2.925365, 51.236713, 6.25],
          [2.924796, 51.237378, 4.5],
          [2.924455, 51.237675, 4.5],
          [2.924439, 51.237736, 4.5],
          [2.924450, 51.237741, 4.5],
          [2.924920, 51.237943],
          [2.925081, 51.237987],
          [2.925227, 51.238010],
          [2.926659, 51.238120],
          [2.927255, 51.238173],
          [2.927512, 51.238183],
          [2.927763, 51.238160],
          [2.927912, 51.238115],
          [2.928043, 51.238037],
          [2.928165, 51.237920],
          [2.928554, 51.237495, 6.75],
          [2.928630, 51.237440, 6.75],
          [2.928720, 51.237423, 6.75],
          [2.928742, 51.237420, 6.75],
          [2.928764, 51.237474, 6.5],
          [2.928761, 51.237559, 6.5],
          [2.928782, 51.237646, 6.5],
          [2.929142, 51.237897, 6.5],
          [2.929510, 51.238101, 6.5],
          [2.929543, 51.238117, 6.5],
          [2.929902, 51.238295],
          [2.930277, 51.238454],
          [2.930489, 51.238544],
          [2.931102, 51.238791],
          [2.931460, 51.238919],
          [2.931883, 51.238996],
          [2.932312, 51.239093],
          [2.932762, 51.239251],
          [2.934312, 51.239839],
          [2.935528, 51.240258],
          [2.935770, 51.240342],
          [2.937299, 51.240934],
          [2.937784, 51.241123],
          [2.943985, 51.243552],
          [2.949220, 51.245594],
          [2.950241, 51.246005],
          [2.952024, 51.246725],
          [2.952187, 51.246763],
          [2.952523, 51.246821],
          [2.952561, 51.246818],
          [2.952620, 51.246815],
          [2.952715, 51.246773],
          [2.952933, 51.246628, 11.75],
          [2.952989, 51.246556, 12.0],
          [2.952989, 51.246510, 11.5],
          [2.952990, 51.246503, 11.5],
          [2.952928, 51.246429, 10.75],
          [2.952761, 51.246253, 9.25],
          [2.952527, 51.245970, 8.75],
          [2.952495, 51.245911, 8.75],
          [2.952510, 51.245872, 8.75],
          [2.952718, 51.245655, 7.5],
          [2.952913, 51.245718, 7.5],
          [2.952960, 51.245664, 7.0],
          [2.953099, 51.245503, 6.25],
          [2.953211, 51.245538, 6.0],
          [2.953238, 51.245506, 6.0],
          [2.953265, 51.245474, 5.75],
          [2.953294, 51.245439, 5.5],
          [2.953410, 51.245478, 5.75],
          [2.953437, 51.245446, 5.5],
          [2.953497, 51.245377, 5.25],
          [2.953433, 51.245326, 5.0],
          [2.953415, 51.245301, 5.0],
          [2.953461, 51.245243, 4.75],
          [2.953472, 51.245227, 4.75],
          [2.953510, 51.245173, 4.75],
          [2.953529, 51.245146, 4.5],
          [2.953596, 51.245168, 4.5],
          [2.953599, 51.245170, 4.75],
          [2.954386, 51.245438, 6.0],
          [2.954455, 51.245462, 6.0],
          [2.955479, 51.245811, 6.0],
          [2.956319, 51.246098, 5.5],
          [2.957461, 51.246488, 5.0],
          [2.957590, 51.246626, 5.0],
          [2.957625, 51.246658, 5.0],
          [2.957663, 51.246668, 5.0],
          [2.957691, 51.246674, 5.25],
          [2.957788, 51.246700, 5.5],
          [2.957899, 51.246728, 5.75],
          [2.958385, 51.246809, 6.25],
          [2.958629, 51.246893, 6.0],
          [2.959325, 51.247132, 5.5],
          [2.960158, 51.247414, 4.25],
          [2.960362, 51.247462, 4.25],
          [2.961100, 51.247715, 4.75],
          [2.961690, 51.247917, 5.5],
          [2.961849, 51.247974, 5.25],
          [2.962699, 51.248279, 5.0],
          [2.962778, 51.248307, 5.0],
          [2.963506, 51.248612, 5.0],
          [2.963929, 51.248806, 5.0],
          [2.964052, 51.248862, 5.0],
          [2.964505, 51.249048, 4.5],
          [2.965148, 51.249275, 4.25],
          [2.965184, 51.249285, 4.25],
          [2.965195, 51.249288, 4.25],
          [2.965220, 51.249296, 4.25],
          [2.966348, 51.249625, 4.75],
          [2.966455, 51.249656, 4.5],
          [2.967124, 51.249840, 4.25],
          [2.967296, 51.249888, 4.0],
          [2.968400, 51.250194, 3.5],
          [2.968548, 51.250235, 3.5],
          [2.968582, 51.250244, 3.75],
          [2.971254, 51.250999, 4.25],
          [2.971273, 51.251004, 4.0],
          [2.972448, 51.251321, 3.25],
          [2.972736, 51.251387, 3.25],
          [2.974409, 51.251853, 3.0],
          [2.974459, 51.251866, 3.0],
          [2.974559, 51.251892, 3.0],
          [2.974973, 51.252007, 3.0],
          [2.975019, 51.252020, 3.0],
          [2.975309, 51.252099, 3.0],
          [2.975417, 51.252157, 3.0],
          [2.975601, 51.252208, 3.0],
          [2.975873, 51.252283, 3.0],
          [2.976032, 51.252292, 3.0],
          [2.976875, 51.252521, 2.75],
          [2.978428, 51.252947, 4.0],
          [2.978738, 51.253032, 4.0],
          [2.979871, 51.253343, 4.0],
          [2.980597, 51.253543, 4.25],
          [2.980760, 51.253611, 4.25],
          [2.980893, 51.253687, 4.25],
          [2.981034, 51.253755, 4.5],
          [2.982172, 51.254180, 5.0],
          [2.982586, 51.254334, 5.0],
          [2.984037, 51.254833, 5.5],
          [2.984101, 51.254856, 5.75],
          [2.984182, 51.254884, 5.75],
          [2.985078, 51.255107, 5.0],
          [2.986194, 51.255383, 4.0],
          [2.986771, 51.255526, 3.25],
          [2.987583, 51.255709, 3.5],
          [2.987795, 51.255770, 3.25],
          [2.988161, 51.255876, 3.25],
          [2.988767, 51.256091, 3.25],
          [2.988941, 51.256183, 3.5],
          [2.989363, 51.256336, 3.0],
          [2.989678, 51.256422, 2.5],
          [2.991136, 51.256948, 2.75],
          [2.991791, 51.257203, 3.25],
          [2.991939, 51.257242, 3.25],
          [2.992324, 51.257425, 3.75],
          [2.992415, 51.257492, 3.75],
          [2.992993, 51.257813, 5.0],
          [2.993389, 51.258083, 4.75],
          [2.993550, 51.258199, 4.75],
          [2.993865, 51.258462, 4.25],
          [2.994147, 51.258725, 4.0],
          [2.994428, 51.259035, 3.5],
          [2.995037, 51.259856, 3.0],
          [2.995433, 51.260391, 4.0],
          [2.995563, 51.260546, 4.5],
          [2.995628, 51.260598, 4.5],
          [2.995697, 51.260636, 4.5],
          [2.995782, 51.260669, 4.75],
          [2.995879, 51.260694, 4.75],
          [2.996015, 51.260712, 4.5],
          [2.996637, 51.260752, 4.0],
          [2.996787, 51.260767, 3.75],
          [2.996963, 51.260790, 3.5],
          [2.997243, 51.260837, 3.25],
          [2.997704, 51.260925, 2.75],
          [2.997840, 51.260959, 2.75],
          [2.997994, 51.261020, 2.75],
          [2.998368, 51.261173, 2.75],
          [2.998487, 51.261206, 2.75],
          [2.998487, 51.261206, 2.75],
          [2.998368, 51.261173, 2.75],
          [2.997994, 51.261020, 2.75],
          [2.998028, 51.260980, 2.5],
          [2.998412, 51.261134, 2.5],
          [2.998564, 51.261175, 2.75],
          [2.999278, 51.261319, 3.0],
          [2.999569, 51.261395, 3.25],
          [3.000024, 51.261540, 3.5],
          [3.000038, 51.261544, 3.5],
          [3.000213, 51.261597, 3.5],
          [3.000424, 51.261643, 3.25],
          [3.001645, 51.261867, 2.25],
          [3.002032, 51.261960, 2.25],
          [3.001986, 51.261998, 2.25],
          [3.002188, 51.262062, 2.25],
          [3.002711, 51.262254, 2.75],
          [3.002765, 51.262297, 3.0],
          [3.003299, 51.262530, 4.0],
          [3.003454, 51.262588, 4.25],
          [3.003587, 51.262623, 4.25],
          [3.003775, 51.262659, 4.5],
          [3.004393, 51.262757, 4.75],
          [3.004453, 51.262754, 4.75],
          [3.004501, 51.262752, 4.75],
          [3.004537, 51.262756, 4.75],
          [3.004773, 51.262795, 5.0],
          [3.004927, 51.262820, 5.0],
          [3.005089, 51.262862, 5.25],
          [3.005270, 51.262909, 5.25],
          [3.005437, 51.262938, 5.5],
          [3.005984, 51.263129, 6.0],
          [3.006340, 51.263229, 5.75],
          [3.006606, 51.263304, 5.75],
          [3.006785, 51.263346, 6.0],
          [3.007621, 51.263484, 6.25],
          [3.007799, 51.263521, 6.25],
          [3.008146, 51.263620, 6.25],
          [3.008237, 51.263649, 6.5],
          [3.009004, 51.263899, 7.5],
          [3.009489, 51.264011, 7.75],
          [3.012553, 51.264621, 8.0],
          [3.012689, 51.264662, 8.25],
          [3.012819, 51.264726, 8.5],
          [3.013128, 51.264909, 8.75],
          [3.013542, 51.265037, 8.5],
          [3.013728, 51.265083, 8.25],
          [3.013904, 51.265127, 8.25],
          [3.014187, 51.265212, 8.0],
          [3.014454, 51.265308, 8.0],
          [3.015217, 51.265655, 8.5],
          [3.015335, 51.265716, 8.5],
          [3.016475, 51.266228, 7.0],
          [3.016876, 51.266396, 7.0],
          [3.017059, 51.266482, 7.25],
          [3.017523, 51.266752, 8.25],
          [3.018117, 51.267114, 9.0],
          [3.018299, 51.267206, 9.0],
          [3.018538, 51.267300, 9.0],
          [3.019048, 51.267443, 8.75],
          [3.019867, 51.267650, 8.5],
          [3.020166, 51.267703, 8.75],
          [3.020510, 51.267742, 9.0],
          [3.020897, 51.267790, 9.0],
          [3.021178, 51.267825, 9.25],
          [3.022302, 51.267970, 9.0],
          [3.022836, 51.268037, 8.25],
          [3.023016, 51.268071, 7.75],
          [3.023221, 51.268129, 7.5],
          [3.023351, 51.268182, 7.25],
          [3.023865, 51.268473, 8.0],
          [3.025203, 51.269256, 8.5],
          [3.025207, 51.269252, 8.25],
          [3.025203, 51.269256, 8.5],
          [3.025624, 51.269507, 8.5],
          [3.026044, 51.269751, 8.5],
          [3.026551, 51.270036, 8.5],
          [3.027065, 51.270305, 8.75],
          [3.027472, 51.270513, 8.25],
          [3.027867, 51.270714, 8.25],
          [3.027910, 51.270717, 8.0],
          [3.027913, 51.270716, 7.75],
          [3.027968, 51.270710, 7.75],
          [3.028048, 51.270750, 7.75],
          [3.028130, 51.270791, 7.5],
          [3.028565, 51.271032, 7.75],
          [3.028630, 51.271068, 8.0],
          [3.028965, 51.271248, 8.75],
          [3.029099, 51.271305, 8.75],
          [3.029240, 51.271353, 8.75],
          [3.029379, 51.271391, 8.5],
          [3.029656, 51.271456, 8.0],
          [3.029795, 51.271490, 7.75],
          [3.030310, 51.271613, 7.75],
          [3.030563, 51.271674, 8.0],
          [3.030701, 51.271707, 8.0],
          [3.030803, 51.271732, 8.0],
          [3.031400, 51.271875, 8.25],
          [3.031496, 51.271898, 8.25],
          [3.031533, 51.271905, 8.0],
          [3.031496, 51.271898, 8.25],
          [3.031551, 51.271940, 8.25],
          [3.031564, 51.272090, 7.75],
          [3.031578, 51.272116, 7.75],
          [3.031617, 51.272142, 7.75],
          [3.031697, 51.272160, 7.75],
          [3.031785, 51.272168, 7.5],
          [3.032214, 51.272203, 7.25],
          [3.032924, 51.272305, 6.5],
          [3.033027, 51.272320, 6.5],
          [3.033108, 51.272316, 6.25],
          [3.033204, 51.272295, 6.25],
          [3.033268, 51.272284, 6.25],
          [3.033343, 51.272284, 6.25],
          [3.033419, 51.272304, 6.25],
          [3.033448, 51.272312, 6.25],
          [3.033640, 51.272361, 6.25],
          [3.033771, 51.272396, 6.5],
          [3.033895, 51.272449, 6.5],
          [3.033926, 51.272462, 6.5],
          [3.034177, 51.272570, 7.0],
          [3.034331, 51.272640, 7.0],
          [3.034653, 51.272800, 7.25],
          [3.034766, 51.272847, 7.25],
          [3.035112, 51.272941, 7.25],
          [3.035190, 51.272945, 7.0],
          [3.035238, 51.272935, 7.0],
          [3.035286, 51.272910, 7.0],
          [3.035358, 51.272838, 7.0],
          [3.035434, 51.272804, 7.0],
          [3.035507, 51.272806, 7.0],
          [3.035580, 51.272821, 6.75],
          [3.035709, 51.272852, 6.5],
          [3.036031, 51.272931, 6.0],
          [3.036091, 51.272951, 6.0],
          [3.036127, 51.273019, 5.75],
          [3.036535, 51.273189, 5.0],
          [3.036657, 51.273249, 5.0],
          [3.037704, 51.273806, 5.5],
          [3.037772, 51.273828, 5.5],
          [3.037853, 51.273855, 5.5],
          [3.038571, 51.274137, 6.5],
          [3.038716, 51.274212, 6.75],
          [3.039359, 51.274545, 7.25],
          [3.039598, 51.274644, 7.25],
          [3.040087, 51.274815, 6.75],
          [3.041329, 51.275252, 6.0],
          [3.041618, 51.275380, 5.75],
          [3.041859, 51.275495, 6.5],
          [3.042058, 51.275565, 7.0],
          [3.042124, 51.275633, 7.25],
          [3.042179, 51.275673, 7.5],
          [3.042240, 51.275704, 7.75],
          [3.042269, 51.275710, 8.0],
          [3.042284, 51.275714, 8.0],
          [3.042344, 51.275731, 8.0],
          [3.042434, 51.275774, 8.5],
          [3.042527, 51.275725, 8.25],
          [3.042611, 51.275698, 8.25],
          [3.042704, 51.275700, 8.25],
          [3.043286, 51.275790, 9.5],
          [3.044595, 51.276040, 8.0],
          [3.044757, 51.276072, 8.0],
          [3.046819, 51.276479, 8.25],
          [3.047313, 51.276599, 8.0],
          [3.047621, 51.276691, 7.5],
          [3.048146, 51.276868, 7.25],
          [3.048511, 51.277011, 7.25],
          [3.048833, 51.277158, 7.75],
          [3.049477, 51.277469, 7.5],
          [3.049635, 51.277548, 7.5],
          [3.049759, 51.277625, 7.75],
          [3.049871, 51.277715, 8.0],
          [3.049932, 51.277780, 8.25],
          [3.050003, 51.277872, 8.5],
          [3.050078, 51.278023, 9.5],
          [3.050476, 51.279389, 12.25],
          [3.050551, 51.279623, 12.0],
          [3.050607, 51.279749, 11.75],
          [3.050678, 51.279894, 11.5],
          [3.050883, 51.280200, 11.25],
          [3.051033, 51.280369, 11.0],
          [3.051191, 51.280525, 10.75],
          [3.051292, 51.280614, 10.5],
          [3.051340, 51.280658, 10.5],
          [3.051909, 51.281102, 9.75],
          [3.052356, 51.281457, 9.5],
          [3.052599, 51.281611, 9.25],
          [3.052729, 51.281688, 8.75],
          [3.053532, 51.282179, 8.25],
          [3.054107, 51.282529, 7.25],
          [3.054225, 51.282597, 6.75],
          [3.054217, 51.282604, 6.75],
          [3.054225, 51.282597, 6.75],
          [3.054306, 51.282643, 6.5],
          [3.054676, 51.282855, 5.0],
          [3.054876, 51.282956, 4.5],
          [3.056032, 51.283390, 5.0],
          [3.056464, 51.283525, 5.25],
          [3.056840, 51.283616, 5.5],
          [3.057131, 51.283670, 5.25],
          [3.057289, 51.283691, 5.25],
          [3.058743, 51.283915, 5.75],
          [3.058966, 51.283936, 5.75],
          [3.059138, 51.283958, 5.75],
          [3.059386, 51.284011, 5.5],
          [3.059573, 51.284063, 5.25],
          [3.059852, 51.284155, 5.25],
          [3.060098, 51.284247, 5.0],
          [3.060364, 51.284359, 5.25],
          [3.060570, 51.284463, 5.25],
          [3.060983, 51.284705, 5.5],
          [3.061324, 51.284974, 5.5],
          [3.061552, 51.285179, 5.25],
          [3.061693, 51.285336, 5.25],
          [3.062112, 51.285881, 4.75],
          [3.062344, 51.286162, 4.25],
          [3.062654, 51.286457, 3.25],
          [3.063387, 51.287074, 3.25],
          [3.063746, 51.287376, 4.75],
          [3.064203, 51.287759, 6.25],
          [3.064412, 51.287917, 6.75],
          [3.064543, 51.288002, 7.0],
          [3.065176, 51.288368, 7.75],
          [3.066125, 51.288911, 7.75],
          [3.066345, 51.289037, 7.5],
          [3.066471, 51.289102, 7.25],
          [3.066607, 51.289157, 7.0],
          [3.066749, 51.289204, 7.0],
          [3.066923, 51.289241, 6.75],
          [3.067070, 51.289265, 6.75],
          [3.067503, 51.289293, 6.25],
          [3.067584, 51.289298, 6.25],
          [3.067700, 51.289305, 6.0],
          [3.068990, 51.289381, 4.75],
          [3.069220, 51.289404, 4.75],
          [3.069427, 51.289436, 4.5],
          [3.069631, 51.289486, 4.5],
          [3.070000, 51.289608, 4.5],
          [3.071629, 51.290160, 5.75],
          [3.071719, 51.290197, 5.75],
          [3.071817, 51.290246, 5.75],
          [3.072856, 51.290837, 6.0],
          [3.072976, 51.290906, 6.0],
          [3.073238, 51.291057, 6.0],
          [3.074185, 51.291604, 5.75],
          [3.074311, 51.291688, 5.5],
          [3.074393, 51.291770, 5.75],
          [3.074448, 51.291848, 5.75],
          [3.074474, 51.291906, 6.0],
          [3.074537, 51.292159, 6.5],
          [3.074841, 51.293340, 5.5],
          [3.074852, 51.293433, 5.25],
          [3.074844, 51.293528, 5.25],
          [3.074801, 51.293643, 5.25],
          [3.074762, 51.293702, 5.25],
          [3.074633, 51.293846, 5.25],
          [3.074061, 51.294489, 5.75],
          [3.073973, 51.294589, 5.75],
          [3.073935, 51.294633, 5.75],
          [3.073857, 51.294680, 6.0],
          [3.073844, 51.294731, 6.0],
          [3.073833, 51.294776, 6.0],
          [3.074215, 51.295073, 4.75],
          [3.074788, 51.295483, 3.0],
          [3.075486, 51.295976, 2.0],
          [3.075793, 51.296161, 2.0],
          [3.075990, 51.296258, 2.0],
          [3.076352, 51.296405, 2.25],
          [3.076326, 51.296435, 2.25],
          [3.076451, 51.296577, 2.5],
          [3.076447, 51.296619, 2.5],
          [3.076237, 51.296618, 2.25],
          [3.076339, 51.296744, 2.75],
          [3.076567, 51.297014, 3.25],
          [3.076961, 51.297493, 3.75],
          [3.077106, 51.297703, 4.0],
          [3.077155, 51.297788, 4.25],
          [3.077306, 51.297744, 4.25],
          [3.077339, 51.297798, 4.25],
          [3.077306, 51.297744, 4.25],
          [3.077155, 51.297788, 4.25],
          [3.077229, 51.297917, 4.25],
          [3.077263, 51.298066, 4.5],
          [3.077299, 51.298211, 4.75],
          [3.077307, 51.298271, 4.75],
          [3.077313, 51.298376, 4.75],
          [3.077274, 51.298607, 4.0],
          [3.077196, 51.299162, 2.0],
          [3.077183, 51.299265, 2.25],
          [3.077161, 51.299441, 2.75],
          [3.077151, 51.299520, 3.25],
          [3.077126, 51.299820, 4.25],
          [3.077163, 51.299950, 4.75],
          [3.077231, 51.300083, 5.0],
          [3.077308, 51.300178, 5.25],
          [3.077507, 51.300336, 5.75],
          [3.077604, 51.300392, 5.75],
          [3.077848, 51.300186, 5.0],
          [3.077604, 51.300392, 5.75],
          [3.077846, 51.300504, 6.25],
          [3.078458, 51.300777, 7.75],
          [3.078495, 51.300793, 7.75],
          [3.078552, 51.300817, 7.75],
          [3.078815, 51.300929, 8.25],
          [3.079103, 51.301053, 9.0],
          [3.079245, 51.301098, 9.0],
          [3.079169, 51.301179, 9.5],
          [3.079146, 51.301202, 9.75],
          [3.079080, 51.301280, 10.0],
          [3.079212, 51.301318, 10.25],
          [3.079515, 51.301405, 10.75],
          [3.079623, 51.301419, 11.0],
          [3.080564, 51.301681, 11.5],
          [3.081691, 51.302007, 10.0],
          [3.081775, 51.302037, 10.25],
          [3.081748, 51.302065, 10.25],
          [3.081380, 51.302465, 10.75],
          [3.081380, 51.302465, 10.75],
          [3.083341, 51.303155, 8.25],
          [3.083360, 51.303162, 8.0],
          [3.083505, 51.303215, 8.0],
          [3.083902, 51.302756, 10.0],
          [3.083841, 51.302735, 10.0],
          [3.083827, 51.302730, 10.25],
          [3.083850, 51.302705, 10.25],
          [3.083872, 51.302681, 10.25],
          [3.083952, 51.302595, 10.5],
          [3.085046, 51.302956, 8.5],
          [3.085418, 51.302946, 7.5],
          [3.085480, 51.302882, 7.0],
          [3.085581, 51.302832, 6.5],
          [3.085689, 51.302802, 6.25],
          [3.085746, 51.302788, 6.0],
          [3.085834, 51.302820, 6.0],
          [3.085955, 51.302848, 5.75],
          [3.086063, 51.302892, 5.5],
          [3.086146, 51.302949, 5.5],
          [3.086207, 51.303082, 5.75],
          [3.086311, 51.303153, 5.75],
          [3.086349, 51.303169, 5.5],
          [3.086487, 51.303231, 5.25],
          [3.086726, 51.303323, 4.75],
          [3.087048, 51.303437, 5.0],
          [3.088959, 51.304067, 4.25],
          [3.089494, 51.304243, 4.25],
          [3.092381, 51.305137, 4.0],
          [3.095925, 51.306229, 3.25],
          [3.098980, 51.307164, 3.25],
          [3.101292, 51.307868, 2.25],
          [3.102075, 51.308112, 3.0],
          [3.102764, 51.308325, 2.25],
          [3.103239, 51.308468, 2.25],
          [3.104274, 51.308787, 3.25],
          [3.106193, 51.309375, 2.5],
          [3.106679, 51.309531, 2.5],
          [3.107182, 51.309678, 3.0],
          [3.107280, 51.309708, 3.0],
          [3.107430, 51.309756, 3.0],
          [3.107873, 51.309890, 2.75],
          [3.108175, 51.309967, 2.25],
          [3.108439, 51.310025, 2.25],
          [3.108692, 51.310070, 2.75],
          [3.108994, 51.310111, 3.25],
          [3.109234, 51.310137, 3.5],
          [3.109475, 51.310152, 3.75],
          [3.109768, 51.310159, 4.0],
          [3.110012, 51.310158, 4.25],
          [3.110257, 51.310149, 3.75],
          [3.110588, 51.310123, 3.25],
          [3.110984, 51.310072, 2.75],
          [3.111244, 51.310029, 2.5],
          [3.112840, 51.309694, 2.25],
          [3.112891, 51.309684, 2.25],
          [3.112922, 51.309616, 2.5],
          [3.112926, 51.309577, 2.25],
          [3.112920, 51.309536, 2.25],
          [3.112882, 51.309470, 2.5],
          [3.112864, 51.309449, 2.5],
          [3.112977, 51.309423, 2.25],
          [3.113027, 51.309413, 2.25],
          [3.113081, 51.309404, 2.25],
          [3.113101, 51.309401, 2.25],
          [3.113164, 51.309393, 2.25],
          [3.113227, 51.309395, 2.25],
          [3.113286, 51.309409, 2.25],
          [3.113339, 51.309436, 2.25],
          [3.113405, 51.309495, 2.25],
          [3.113467, 51.309529, 2.25],
          [3.113536, 51.309547, 2.25],
          [3.113602, 51.309547, 2.25],
          [3.114653, 51.309327, 0.25],
          [3.114894, 51.309279, -0.25],
          [3.115894, 51.309059, -0.75],
          [3.116111, 51.309011, -0.75],
          [3.116609, 51.308888, -0.5],
          [3.117057, 51.308768, 0.0],
          [3.117376, 51.308688, 0.5],
          [3.117678, 51.308628, 1.0],
          [3.117832, 51.308609, 1.25],
          [3.117992, 51.308595, 1.5],
          [3.118365, 51.308587, 2.0],
          [3.118609, 51.308596, 2.0],
          [3.118766, 51.308612, 2.0],
          [3.118845, 51.308621, 2.0],
          [3.119063, 51.308660, 2.0],
          [3.119405, 51.308746, 2.0],
          [3.119545, 51.308794, 1.75],
          [3.119812, 51.308910, 1.75],
          [3.120318, 51.309219, 2.25],
          [3.120475, 51.309279, 2.25],
          [3.120573, 51.309338, 2.25],
          [3.120665, 51.309402, 2.5],
          [3.120749, 51.309488, 2.5],
          [3.120838, 51.309541, 2.5],
          [3.120911, 51.309584, 2.5],
          [3.120986, 51.309603, 2.5],
          [3.121056, 51.309621, 2.75],
          [3.121245, 51.309639, 3.0],
          [3.121384, 51.309678, 3.25],
          [3.121527, 51.309700, 3.5],
          [3.121581, 51.309701, 3.75],
          [3.121859, 51.309701, 4.0],
          [3.121952, 51.309695, 4.0],
          [3.122199, 51.309660, 4.0],
          [3.122504, 51.309613, 3.75],
          [3.123628, 51.309449, 3.5],
          [3.123854, 51.309415, 3.5],
          [3.124417, 51.309337, 3.5],
          [3.124587, 51.309311, 3.5],
          [3.124781, 51.309280, 3.75],
          [3.126620, 51.309010, 4.75],
          [3.127018, 51.308954, 5.0],
          [3.127914, 51.308826, 4.5],
          [3.128143, 51.308799, 4.0],
          [3.128281, 51.308793, 4.0],
          [3.128443, 51.308794, 4.0],
          [3.128608, 51.308801, 4.0],
          [3.128817, 51.308823, 4.0],
          [3.129076, 51.308866, 4.0],
          [3.129395, 51.308925, 4.0],
          [3.131044, 51.309209, 3.75],
          [3.131586, 51.309302, 3.75],
          [3.132248, 51.309421, 4.0],
          [3.132433, 51.309454, 4.0],
          [3.132616, 51.309487, 4.0],
          [3.133863, 51.309705, 4.0],
          [3.135242, 51.309933, 4.5],
          [3.135276, 51.309939, 4.5],
          [3.135336, 51.309952, 4.5],
          [3.135403, 51.310017, 4.25],
          [3.135432, 51.309991, 4.0],
          [3.135403, 51.310017, 4.25],
          [3.135426, 51.310111, 4.25],
          [3.135338, 51.310184, 4.25],
          [3.135312, 51.310205, 4.25],
          [3.133641, 51.311615, 3.0],
          [3.133550, 51.311695, 3.0],
          [3.133542, 51.311702, 3.0],
          [3.133516, 51.311725, 3.0],
          [3.133406, 51.311818, 3.5],
          [3.133354, 51.311865, 3.5],
          [3.133309, 51.311844, 3.5],
          [3.133125, 51.311998, 4.5],
          [3.132925, 51.312177, 5.25],
          [3.132871, 51.312226, 5.5],
          [3.132835, 51.312284, 5.75],
          [3.132829, 51.312331, 6.0],
          [3.132845, 51.312385, 6.25],
          [3.132904, 51.312456, 6.25],
          [3.133136, 51.312602, 6.0],
          [3.133391, 51.312773, 5.25],
          [3.133439, 51.312804, 5.0],
          [3.133518, 51.312849, 5.0],
          [3.133653, 51.312928, 4.75],
          [3.133796, 51.312989, 4.5],
          [3.133942, 51.313038, 4.25],
          [3.134124, 51.313082, 4.25],
          [3.134277, 51.313109, 4.0],
          [3.135231, 51.313223, 4.0],
          [3.135661, 51.313266, 4.5],
          [3.136099, 51.313307, 5.25],
          [3.136272, 51.313323, 5.5],
          [3.136671, 51.313363, 5.75],
          [3.136847, 51.313334, 5.75],
          [3.137267, 51.313382, 5.75],
          [3.137298, 51.313385, 5.75],
          [3.137414, 51.313393, 5.75],
          [3.137445, 51.313389, 5.75],
          [3.137615, 51.313315, 5.75],
          [3.137685, 51.313320, 5.75],
          [3.137731, 51.313333, 5.5],
          [3.137751, 51.313386, 5.5],
          [3.137788, 51.313423, 5.5],
          [3.137826, 51.313442, 5.5],
          [3.137902, 51.313451, 5.25],
          [3.137933, 51.313455, 5.25],
          [3.138328, 51.313502, 5.0],
          [3.138495, 51.313545, 4.75],
          [3.138681, 51.313563, 4.75],
          [3.139108, 51.313603, 4.5],
          [3.140119, 51.313701, 4.0],
          [3.140709, 51.313767, 3.75],
          [3.140838, 51.313785, 3.75],
          [3.141315, 51.313869, 4.0],
          [3.141461, 51.313900, 4.0],
          [3.141872, 51.314001, 4.0],
          [3.142335, 51.314132, 4.0],
          [3.142600, 51.314217, 3.75],
          [3.142905, 51.314330, 3.75],
          [3.143120, 51.314418, 3.75],
          [3.143326, 51.314506, 3.75],
          [3.143518, 51.314595, 4.0],
          [3.143813, 51.314745, 4.75],
          [3.144168, 51.314950, 5.75],
          [3.144359, 51.315073, 5.75],
          [3.144601, 51.315245, 5.25],
          [3.144834, 51.315423, 4.25],
          [3.144960, 51.315529, 3.75],
          [3.145321, 51.315882, 2.0],
          [3.145450, 51.316028, 2.0],
          [3.145556, 51.316163, 2.25],
          [3.145571, 51.316182, 2.25],
          [3.145668, 51.316311, 2.5],
          [3.145839, 51.316557, 2.75],
          [3.145990, 51.316843, 3.0],
          [3.146093, 51.317082, 3.5],
          [3.146119, 51.317082, 3.25],
          [3.146093, 51.317082, 3.5],
          [3.146188, 51.317360, 4.0],
          [3.146285, 51.317749, 4.0],
          [3.146338, 51.317897, 3.75],
          [3.146440, 51.318141, 3.5],
          [3.146569, 51.318398, 3.5],
          [3.146631, 51.318502, 4.5],
          [3.146713, 51.318633, 5.75],
          [3.146919, 51.318911, 7.5],
          [3.147167, 51.319181, 8.5],
          [3.147308, 51.319245, 7.75],
          [3.147474, 51.319363, 7.25],
          [3.147581, 51.319404, 6.75],
          [3.147854, 51.319630, 5.75],
          [3.148068, 51.319778, 5.25],
          [3.148101, 51.319798, 5.0],
          [3.148413, 51.319983, 4.75],
          [3.148520, 51.320040, 4.75],
          [3.148573, 51.320068, 4.75],
          [3.148774, 51.320164, 5.0],
          [3.149128, 51.320315, 5.0],
          [3.149281, 51.320369, 5.0],
          [3.149443, 51.320416, 4.75],
          [3.149646, 51.320466, 4.5],
          [3.149752, 51.320486, 4.25],
          [3.150045, 51.320536, 3.75],
          [3.150404, 51.320577, 4.0],
          [3.151524, 51.320650, 3.5],
          [3.152146, 51.320684, 3.0],
          [3.152786, 51.320713, 2.5],
          [3.153286, 51.320767, 2.0],
          [3.153571, 51.320809, 2.0],
          [3.153673, 51.320827, 2.0],
          [3.153848, 51.320861, 2.0],
          [3.154125, 51.320927, 2.0],
          [3.154222, 51.320956, 2.25],
          [3.155124, 51.321247, 2.75],
          [3.155606, 51.321397, 3.25],
          [3.155838, 51.321470, 3.5],
          [3.156508, 51.321677, 4.0],
          [3.157401, 51.321955, 4.0],
          [3.157844, 51.322094, 4.0],
          [3.158282, 51.322222, 3.5],
          [3.160418, 51.322812, 2.5],
          [3.160983, 51.322967, 3.0],
          [3.161984, 51.323215, 3.5],
          [3.164190, 51.323752, 3.25],
          [3.168929, 51.324905, 2.75],
          [3.169597, 51.325056, 3.0],
          [3.170659, 51.325253, 3.0],
          [3.174437, 51.325920, 4.0],
          [3.174546, 51.325936, 4.0],
          [3.174737, 51.325966, 4.25],
          [3.176589, 51.326293, 4.25],
          [3.177263, 51.326404, 4.0],
          [3.177583, 51.326456, 3.75],
          [3.177977, 51.326507, 3.0],
          [3.178287, 51.326540, 2.5],
          [3.180067, 51.326718, 4.0],
          [3.181121, 51.326821, 4.25],
          [3.181167, 51.326818, 4.25],
          [3.181203, 51.326802, 4.25],
          [3.181241, 51.326775, 4.0],
          [3.181334, 51.326782, 4.0],
          [3.181546, 51.326797, 4.0],
          [3.182971, 51.326929, 3.25],
          [3.184625, 51.327096, 3.25],
          [3.184705, 51.327116, 3.25],
          [3.184757, 51.327136, 3.25],
          [3.184797, 51.327166, 3.25],
          [3.184969, 51.327184, 3.25],
          [3.185038, 51.327191, 3.25],
          [3.185700, 51.327258, 3.5],
          [3.185808, 51.327269, 3.5],
          [3.186059, 51.327294, 3.5],
          [3.186460, 51.327336, 3.25],
          [3.187147, 51.327408, 3.5],
          [3.187504, 51.327449, 4.0],
          [3.187689, 51.327477, 4.25],
          [3.189402, 51.327648, 4.75],
          [3.191382, 51.327850, 5.0],
          [3.191890, 51.327898, 5.0],
          [3.192080, 51.327925, 5.0],
          [3.192308, 51.327961, 5.0],
          [3.193975, 51.328132, 6.5],
          [3.194387, 51.328190, 7.0],
          [3.194710, 51.328226, 7.5],
          [3.194989, 51.328254, 7.75],
          [3.196229, 51.328379, 7.75],
          [3.196457, 51.328404, 7.75],
          [3.196620, 51.328418, 7.75],
          [3.196719, 51.328427, 7.5],
          [3.197072, 51.328462, 6.75],
          [3.197504, 51.328553, 5.5],
          [3.198113, 51.328613, 4.25],
          [3.198163, 51.328616, 4.25],
          [3.198225, 51.328609, 4.0],
          [3.198635, 51.328514, 4.0],
          [3.198867, 51.328429, 4.0],
          [3.198894, 51.328415, 4.0],
          [3.198934, 51.328364, 4.0],
          [3.198974, 51.328314, 3.75],
          [3.198994, 51.328309, 3.75],
          [3.199038, 51.328313, 3.75],
          [3.199138, 51.328322, 3.75],
          [3.199179, 51.328329, 3.75],
          [3.199203, 51.328358, 3.75],
          [3.199223, 51.328382, 3.75],
          [3.199277, 51.328446, 4.0],
          [3.199320, 51.328497, 4.0],
          [3.199372, 51.328562, 4.0],
          [3.199397, 51.328589, 4.0],
          [3.199416, 51.328595, 4.0],
          [3.199516, 51.328598, 4.0],
          [3.199587, 51.328600, 4.0],
          [3.199623, 51.328656, 4.25],
          [3.199653, 51.328683, 4.25],
          [3.199727, 51.328719, 4.25],
          [3.201264, 51.328898, 5.5],
          [3.201294, 51.328901, 5.5],
          [3.201444, 51.328915, 5.75],
          [3.202147, 51.328988, 6.25],
          [3.202933, 51.329073, 6.75],
          [3.203110, 51.329100, 6.75],
          [3.203278, 51.329135, 6.75],
          [3.203629, 51.329234, 6.5],
          [3.203827, 51.329308, 6.25],
          [3.203984, 51.329375, 6.0],
          [3.204076, 51.329426, 6.0],
          [3.204102, 51.329440, 6.0],
          [3.204073, 51.329463, 6.0],
          [3.204124, 51.329492, 6.0],
          [3.204145, 51.329505, 6.0],
          [3.204302, 51.329536, 5.5],
          [3.204390, 51.329589, 5.5],
          [3.204558, 51.329753, 5.25],
          [3.205042, 51.330219, 5.25],
          [3.205790, 51.330943, 6.0],
          [3.206116, 51.331261, 5.25],
          [3.206230, 51.331334, 5.25],
          [3.206329, 51.331429, 5.0],
          [3.206381, 51.331483, 5.0],
          [3.206416, 51.331469, 5.0],
          [3.206475, 51.331527, 5.0],
          [3.206578, 51.331626, 5.0],
          [3.206795, 51.331834, 4.75],
          [3.206871, 51.331906, 4.75],
          [3.207000, 51.332096, 4.75],
          [3.207069, 51.332182, 4.5],
          [3.207984, 51.333096, 3.25],
          [3.208960, 51.334032, 3.75],
          [3.209125, 51.334169, 4.0],
          [3.209246, 51.334265, 4.0],
          [3.209361, 51.334355, 3.75],
          [3.209479, 51.334429, 3.75],
          [3.209894, 51.334688, 3.75],
          [3.210104, 51.334811, 3.5],
          [3.210628, 51.335073, 4.0],
          [3.210850, 51.335164, 4.25],
          [3.211314, 51.335338, 4.0],
          [3.211776, 51.335482, 4.0],
          [3.212382, 51.335631, 3.75],
          [3.213232, 51.335828, 2.0],
          [3.213385, 51.335862, 1.75],
          [3.213406, 51.335836, 1.75],
          [3.213433, 51.335819, 2.0],
          [3.213470, 51.335816, 2.0],
          [3.213569, 51.335842, 1.75],
          [3.213644, 51.335878, 1.75],
          [3.213688, 51.335892, 1.75],
          [3.213736, 51.335892, 1.75],
          [3.213918, 51.335858, 1.75],
          [3.214094, 51.335903, 1.75],
          [3.214146, 51.335921, 1.75],
          [3.214208, 51.335937, 1.75],
          [3.214283, 51.335959, 1.75],
          [3.214333, 51.335974, 1.75],
          [3.214333, 51.336014, 1.75],
          [3.214349, 51.336068, 1.5],
          [3.214383, 51.336108, 1.5],
          [3.214430, 51.336137, 1.5],
          [3.214682, 51.336220, 1.75],
          [3.215821, 51.336606, 3.0],
          [3.216370, 51.336771, 4.25],
          [3.216690, 51.336858, 5.0],
          [3.216901, 51.336906, 5.0],
          [3.217244, 51.336971, 5.25],
          [3.217674, 51.337032, 5.5],
          [3.218225, 51.337107, 6.25],
          [3.218730, 51.337175, 6.25],
          [3.218793, 51.337178, 6.25],
          [3.218853, 51.337169, 6.0],
          [3.218924, 51.337143, 6.0],
          [3.218944, 51.337128, 6.0],
          [3.218996, 51.337162, 6.0],
          [3.219051, 51.337200, 6.0],
          [3.219092, 51.337223, 6.0],
          [3.219198, 51.337178, 5.75],
          [3.219173, 51.337152, 5.75],
          [3.219079, 51.337040, 6.0],
          [3.219035, 51.336920, 6.0],
          [3.218931, 51.336689, 6.0],
          [3.218910, 51.336584, 6.0],
          [3.218903, 51.336495, 6.25],
          [3.218790, 51.336560, 6.25],
          [3.218786, 51.336387, 6.75],
          [3.218801, 51.336222, 7.25],
          [3.218861, 51.335996, 7.75],
          [3.218913, 51.335886, 8.0],
          [3.218978, 51.335785, 8.0],
          [3.219607, 51.334938, 5.5],
          [3.219638, 51.334900, 5.5],
          [3.220142, 51.334223, 5.75],
          [3.220384, 51.333962, 5.5],
          [3.220859, 51.333345, 5.0],
          [3.221015, 51.333117, 4.5],
          [3.221044, 51.333031, 4.25],
          [3.221059, 51.332911, 4.0],
          [3.221049, 51.332732, 3.5],
          [3.221029, 51.332643, 3.25],
          [3.221102, 51.332634, 3.25],
          [3.221174, 51.332625, 3.25],
          [3.221226, 51.332619, 3.25],
          [3.221283, 51.332612, 3.25],
          [3.221466, 51.332593, 3.25],
          [3.221507, 51.332603, 3.25],
          [3.221560, 51.332643, 3.25],
          [3.221667, 51.332786, 4.0],
          [3.221737, 51.332848, 4.25],
          [3.221814, 51.332888, 4.5],
          [3.221882, 51.332911, 4.5],
          [3.221951, 51.332944, 4.75],
          [3.222025, 51.332966, 5.0],
          [3.222116, 51.332984, 5.0],
          [3.222236, 51.332990, 5.25],
          [3.222337, 51.332984, 5.25],
          [3.222452, 51.332966, 5.5],
          [3.222570, 51.332937, 5.5],
          [3.222703, 51.332895, 5.75],
          [3.222758, 51.332853, 5.75],
          [3.222785, 51.332804, 5.75],
          [3.222781, 51.332752, 5.75],
          [3.222730, 51.332691, 5.5],
          [3.222707, 51.332641, 5.5],
          [3.222717, 51.332587, 5.5],
          [3.223148, 51.332020, 4.75],
          [3.223462, 51.331601, 3.75],
          [3.223526, 51.331556, 3.5],
          [3.223608, 51.331524, 3.5],
          [3.223712, 51.331507, 3.5],
          [3.223768, 51.331505, 3.5],
          [3.224905, 51.331574, 4.5],
          [3.227353, 51.332095, 5.25],
          [3.228950, 51.332435, 5.75],
          [3.229061, 51.332457, 5.75],
          [3.230122, 51.332684, 5.25],
          [3.230494, 51.332750, 4.75],
          [3.230824, 51.332788, 4.5],
          [3.231403, 51.332842, 3.5],
          [3.232162, 51.332913, 2.5],
          [3.232382, 51.332938, 2.5],
          [3.232564, 51.332966, 2.25],
          [3.232825, 51.333014, 2.25],
          [3.233564, 51.333162, 1.75],
          [3.234670, 51.333385, 1.5],
          [3.235231, 51.333491, 2.25],
          [3.235343, 51.333518, 2.25],
          [3.235461, 51.333555, 2.5],
          [3.235721, 51.333610, 2.75],
          [3.235758, 51.333618, 2.75],
          [3.235752, 51.333569, 2.75],
          [3.235744, 51.333503, 2.75],
          [3.235739, 51.333463, 2.75],
          [3.235819, 51.333449, 2.75],
          [3.235932, 51.333414, 3.0],
          [3.235973, 51.333397, 3.25],
          [3.236048, 51.333356, 3.5],
          [3.236107, 51.333297, 3.5],
          [3.236247, 51.332881, 3.0],
          [3.236268, 51.332821, 3.0],
          [3.236346, 51.332831, 3.25],
          [3.236405, 51.332839, 3.25],
          [3.236492, 51.332850, 3.5],
          [3.236473, 51.332902, 3.5],
          [3.236304, 51.333394, 4.0],
          [3.236244, 51.333463, 3.75],
          [3.236107, 51.333544, 3.5],
          [3.236061, 51.333560, 3.5],
          [3.236023, 51.333573, 3.25],
          [3.236005, 51.333586, 3.25],
          [3.235999, 51.333610, 3.25],
          [3.236019, 51.333678, 3.25],
          [3.236041, 51.333722, 3.25],
          [3.236063, 51.333746, 3.5],
          [3.236089, 51.333761, 3.5],
          [3.236147, 51.333776, 3.75],
          [3.236193, 51.333774, 3.75],
          [3.236198, 51.333816, 3.75],
          [3.236208, 51.333880, 3.75],
          [3.236112, 51.333898, 3.5],
          [3.236021, 51.333939, 3.25],
          [3.235983, 51.333965, 3.25],
          [3.235954, 51.333995, 3.25],
          [3.235443, 51.334721, 2.75],
          [3.235239, 51.335013, 3.0],
          [3.234720, 51.335745, 2.75],
          [3.234652, 51.335841, 2.75],
          [3.234619, 51.335863, 2.75],
          [3.234534, 51.335865, 2.75],
          [3.234451, 51.335992, 2.75],
          [3.233701, 51.337040, 3.25],
          [3.233441, 51.337406, 3.75],
          [3.233354, 51.337542, 4.0],
          [3.233226, 51.337777, 4.0],
          [3.233144, 51.337983, 4.25],
          [3.233109, 51.338166, 4.25],
          [3.233094, 51.338244, 4.5],
          [3.233023, 51.338608, 4.5],
          [3.232998, 51.338808, 4.25],
          [3.233013, 51.338853, 4.25],
          [3.233023, 51.338882, 4.25],
          [3.233015, 51.339015, 4.25],
          [3.233018, 51.339289, 5.25],
          [3.233077, 51.339294, 5.25],
          [3.233151, 51.339300, 5.25],
          [3.233210, 51.339320, 5.25],
          [3.233397, 51.339244, 4.5],
          [3.233479, 51.339276, 5.0],
          [3.233561, 51.339289, 5.25],
          [3.233624, 51.339299, 5.25],
          [3.234201, 51.339318, 6.0],
          [3.234289, 51.339322, 6.0],
          [3.234299, 51.339263, 5.75],
          [3.234289, 51.339322, 6.0],
          [3.234201, 51.339318, 6.0],
          [3.234059, 51.339425, 6.75],
          [3.234000, 51.339485, 7.0],
          [3.233939, 51.339574, 7.75],
          [3.233848, 51.339725, 8.75],
          [3.233942, 51.339766, 9.0],
          [3.233928, 51.339781, 9.0],
          [3.233942, 51.339766, 9.0],
          [3.234599, 51.339977, 10.25],
          [3.234847, 51.340049, 10.0],
          [3.235078, 51.340102, 10.0],
          [3.235333, 51.340137, 10.5],
          [3.235314, 51.340193, 10.5],
          [3.235311, 51.340201, 10.5],
          [3.235238, 51.340400, 10.5],
          [3.235227, 51.340433, 10.5],
          [3.235156, 51.340629, 10.5],
          [3.235256, 51.340642, 11.0],
          [3.235223, 51.340730, 10.75],
          [3.234538, 51.340631, 8.0],
          [3.234513, 51.340698, 7.5],
          [3.235227, 51.340796, 7.5],
          [3.236351, 51.340952],
          [3.237952, 51.341166],
          [3.240065, 51.341463, 12.75],
          [3.240712, 51.341556, 12.25],
          [3.242405, 51.341799, 12.25],
          [3.242883, 51.341861, 12.25],
          [3.243050, 51.341866, 12.25],
          [3.244152, 51.341806, 12.25],
          [3.245283, 51.341742, 12.25],
          [3.246421, 51.341662, 12.5],
          [3.246524, 51.341666, 12.25],
          [3.247245, 51.341788, 12.25],
          [3.251036, 51.342478, 12.25],
          [3.253032, 51.342835, 12.25],
          [3.254455, 51.343094, 8.0],
          [3.254632, 51.343128, 8.75],
          [3.254676, 51.343143, 9.0],
          [3.254784, 51.343179, 9.5],
          [3.254922, 51.343249, 10.25],
          [3.254978, 51.343289, 10.75],
          [3.256130, 51.344193, 10.75],
          [3.256817, 51.344368, 10.75],
          [3.258349, 51.344756, 8.75],
          [3.259801, 51.345125, 8.75],
          [3.261718, 51.345685, 13.0],
          [3.261942, 51.345755, 12.75],
          [3.262776, 51.346041, 12.75],
          [3.263123, 51.346090, 12.75],
          [3.263210, 51.346069, 12.75],
          [3.263457, 51.346011, 12.75],
          [3.264836, 51.345589, 12.5],
          [3.265135, 51.345551, 12.5],
          [3.265396, 51.345582, 12.5],
          [3.268135, 51.346253, 12.5],
          [3.268789, 51.346420, 12.5],
          [3.271441, 51.347136, 12.5],
          [3.271939, 51.347266, 12.25],
          [3.272179, 51.347329, 12.25],
          [3.274218, 51.347881, 12.25],
          [3.274338, 51.347914, 12.25],
          [3.275580, 51.348278, 9.5],
          [3.276224, 51.348475, 9.5],
          [3.276245, 51.348481, 9.25],
          [3.276224, 51.348475],
          [3.276314, 51.348409],
          [3.276421, 51.348351],
          [3.277441, 51.347799, 12.0],
          [3.277484, 51.347775, 11.75],
          [3.278182, 51.347398, 10.0],
          [3.278306, 51.347335, 9.5],
          [3.278360, 51.347325, 9.5],
          [3.278327, 51.347302, 9.5],
          [3.278360, 51.347325, 9.5],
          [3.278445, 51.347326, 9.5],
          [3.278530, 51.347339, 9.5],
          [3.279116, 51.347495, 9.75],
          [3.279166, 51.347508, 9.75],
          [3.279116, 51.347495, 9.75],
          [3.279225, 51.347217, 8.75],
          [3.279230, 51.347202, 8.75],
          [3.279235, 51.347173, 8.5],
          [3.279241, 51.347148, 8.5],
          [3.279229, 51.347016, 8.0],
          [3.279229, 51.346974, 8.0],
          [3.279198, 51.346974, 8.0],
          [3.279229, 51.346974, 8.0],
          [3.279758, 51.346958, 7.25],
          [3.279809, 51.346957, 7.0],
          [3.280119, 51.346953, 7.0],
          [3.280886, 51.346923, 6.75],
          [3.282714, 51.346858, 7.25],
          [3.283317, 51.346832, 7.75],
          [3.284492, 51.346781, 8.0],
          [3.284712, 51.346670, 8.0],
          [3.284774, 51.346670, 8.0],
          [3.284764, 51.346678, 8.0],
          [3.284774, 51.346670, 8.0],
          [3.284865, 51.346667, 7.75],
          [3.284933, 51.346665, 7.75],
          [3.285810, 51.346636, 8.0],
          [3.285832, 51.346640, 8.0],
          [3.285882, 51.346651, 8.0],
          [3.286006, 51.346677, 8.0],
          [3.286063, 51.346689, 8.25],
          [3.286088, 51.346719, 8.25],
          [3.286120, 51.346740, 8.25],
          [3.286162, 51.346754, 8.5],
          [3.286169, 51.346804, 8.5],
          [3.286211, 51.346805, 8.5],
          [3.286315, 51.346818, 8.75],
          [3.286907, 51.346782, 9.0],
          [3.287119, 51.346769, 9.0],
          [3.288056, 51.346730, 9.0],
          [3.288121, 51.346727, 9.0],
          [3.288258, 51.346721, 9.0],
          [3.288327, 51.346653, 9.0],
          [3.288386, 51.346641, 8.75],
          [3.288484, 51.346629, 8.75],
          [3.288687, 51.346610, 8.5],
          [3.289196, 51.346587, 8.0],
          [3.289350, 51.346600, 7.75],
          [3.289377, 51.346583, 7.75],
          [3.289414, 51.346571, 7.75],
          [3.289451, 51.346568, 7.75],
          [3.289498, 51.346574, 7.5],
          [3.289516, 51.346581, 7.5],
          [3.289538, 51.346591, 7.5],
          [3.289560, 51.346610, 7.5],
          [3.289573, 51.346640, 7.5],
          [3.289567, 51.346670, 7.5],
          [3.289549, 51.346691, 7.5],
          [3.289514, 51.346711, 7.5],
          [3.289566, 51.346759, 7.5],
          [3.289578, 51.346790, 7.75],
          [3.289652, 51.346826, 7.75],
          [3.289682, 51.346844, 7.75],
          [3.289797, 51.346859, 7.5],
          [3.290127, 51.346973, 7.5],
          [3.290622, 51.347144, 7.5],
          [3.291307, 51.347413, 7.25],
          [3.291793, 51.347621, 7.25],
          [3.291931, 51.347684, 7.25],
          [3.292151, 51.347783, 7.5],
          [3.292424, 51.347907, 7.75],
          [3.292817, 51.348098, 8.5],
          [3.293111, 51.348250, 8.75],
          [3.293478, 51.348473, 9.0],
          [3.293824, 51.348717, 9.0],
          [3.294028, 51.348867, 9.0],
          [3.294087, 51.348910, 9.0],
          [3.294285, 51.349070, 9.0],
          [3.294670, 51.349423, 9.0],
          [3.295059, 51.349820, 9.0],
          [3.295292, 51.350054, 9.0],
          [3.295383, 51.350202, 9.0],
          [3.295440, 51.350291, 9.0],
          [3.295551, 51.350338, 9.0],
          [3.295620, 51.350367, 9.0],
          [3.295650, 51.350350, 9.0],
          [3.295700, 51.350338, 9.0],
          [3.295754, 51.350341, 9.0],
          [3.295801, 51.350358, 9.0],
          [3.295832, 51.350385, 9.0],
          [3.295998, 51.350375, 8.75],
          [3.297456, 51.350381, 8.0],
          [3.301697, 51.350398, 6.0],
          [3.301901, 51.350399, 6.0],
          [3.304789, 51.350412, 6.0],
          [3.304878, 51.350413, 6.0],
          [3.304905, 51.351255, 5.25],
          [3.304907, 51.351380, 5.25],
          [3.304905, 51.351845, 5.5],
          [3.304884, 51.352167, 6.5],
          [3.304852, 51.352949, 7.75],
          [3.304852, 51.353186, 7.75],
          [3.304834, 51.353187, 7.75],
          [3.304749, 51.353192, 7.75],
          [3.304852, 51.353186, 7.75],
          [3.304852, 51.352949, 7.75],
          [3.304884, 51.352167, 6.5],
          [3.304905, 51.351845, 5.5],
          [3.305109, 51.351843, 5.5],
          [3.307722, 51.351831, 6.75],
          [3.307927, 51.351805, 6.5],
          [3.308134, 51.351781, 6.25],
          [3.309512, 51.351430, 6.75],
          [3.309621, 51.351431, 6.75],
          [3.311817, 51.351440, 7.0],
          [3.312052, 51.351472, 7.0],
          [3.312147, 51.351520, 6.75],
          [3.312629, 51.351763, 6.75],
          [3.312831, 51.351907, 6.75],
          [3.312896, 51.352129, 6.5],
          [3.312920, 51.352228, 6.5],
          [3.312960, 51.352331, 6.5],
          [3.313003, 51.352419, 6.25],
          [3.313077, 51.352518, 6.25],
          [3.313355, 51.352852, 5.75],
          [3.313402, 51.352881, 5.75],
          [3.315029, 51.353894, 5.25],
          [3.315109, 51.353943, 5.25],
          [3.315564, 51.354222, 5.75],
          [3.316754, 51.354927, 5.0],
          [3.316803, 51.355033, 5.0],
          [3.316834, 51.355136, 5.0],
          [3.316848, 51.355267, 5.0],
          [3.316842, 51.355346, 5.0],
          [3.316882, 51.355399, 5.0],
          [3.316994, 51.355449, 5.0],
          [3.317244, 51.355263, 5.0],
          [3.317268, 51.355247, 5.0],
          [3.317409, 51.355157, 5.0],
          [3.317686, 51.355014, 4.75],
          [3.317587, 51.354943, 4.75],
          [3.317838, 51.354835, 4.5],
          [3.317587, 51.354943, 4.75],
          [3.317686, 51.355014, 4.75],
          [3.317906, 51.354912, 4.5],
          [3.317912, 51.354920, 4.5],
          [3.317899, 51.355054, 4.5],
          [3.317958, 51.355167, 4.25],
          [3.318016, 51.355234, 4.25],
          [3.318059, 51.355283, 4.25],
          [3.318407, 51.355596, 4.0],
          [3.318560, 51.355687, 4.0],
          [3.318561, 51.355920, 4.0],
          [3.318571, 51.355997, 4.0],
          [3.318615, 51.356051, 4.25],
          [3.318715, 51.356088, 4.25],
          [3.318888, 51.356101, 4.25],
          [3.319290, 51.356133, 4.25],
          [3.319476, 51.356043, 3.75],
          [3.319766, 51.355991, 3.5],
          [3.320370, 51.356036, 3.75],
          [3.320857, 51.356234, 4.5],
          [3.321073, 51.356285, 4.75],
          [3.321298, 51.356293, 5.25],
          [3.321398, 51.356302, 5.5],
          [3.321371, 51.356276, 5.25],
          [3.321347, 51.356236, 5.25],
          [3.321371, 51.356276, 5.25],
          [3.321398, 51.356302, 5.5],
          [3.321758, 51.356784, 5.75],
          [3.322061, 51.357163, 4.75],
          [3.322480, 51.357575, 4.0],
          [3.322408, 51.357604, 4.0],
          [3.322480, 51.357575, 4.0],
          [3.322783, 51.357454, 3.5],
          [3.324430, 51.356823, 4.25],
          [3.324506, 51.356800, 4.25],
          [3.324830, 51.356772, 4.75],
          [3.324943, 51.356770, 4.75],
          [3.325311, 51.356790, 5.0],
          [3.325461, 51.356811, 5.0],
          [3.326128, 51.356956, 4.75],
          [3.327454, 51.357244, 4.75],
          [3.331159, 51.358073, 6.75],
          [3.331476, 51.358141, 6.25],
          [3.332567, 51.358350, 4.75],
          [3.332856, 51.358411, 4.75],
          [3.333233, 51.358490, 4.75],
          [3.333634, 51.358604, 5.25],
          [3.336406, 51.359961, 4.0],
          [3.337131, 51.360299, 4.5],
          [3.337623, 51.360541, 5.0],
          [3.337762, 51.360574, 5.0],
          [3.341436, 51.360744, 6.25],
          [3.341855, 51.360757, 6.25],
          [3.343239, 51.360826, 6.75],
          [3.343415, 51.360809, 7.0],
          [3.343482, 51.360790, 7.0],
          [3.343567, 51.360767, 7.25],
          [3.343658, 51.360708, 7.5],
          [3.343728, 51.360645, 7.75],
          [3.343762, 51.360601, 7.75],
          [3.343777, 51.360575, 8.0],
          [3.343798, 51.360410, 8.75],
          [3.343747, 51.359907, 10.5],
          [3.343608, 51.358830, 12.0],
          [3.343620, 51.358562, 11.75],
          [3.343816, 51.358264, 11.0],
          [3.344029, 51.358077, 9.75],
          [3.344329, 51.357951, 9.0],
          [3.344334, 51.357949, 8.75],
          [3.344329, 51.357951, 9.0],
          [3.344312, 51.357906, 8.75],
          [3.344320, 51.357868, 8.5],
          [3.344361, 51.357775, 8.25],
          [3.344367, 51.357758, 8.0],
          [3.344836, 51.356546, 5.5],
          [3.344836, 51.356546, 5.75]
        ]
      }
    }
  ]
}

let day4: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "brouter_trekking_0",
        "track-length": "61881",
        "filtered ascend": "103",
        "plain-ascend": "25",
        "total-time": "13747",
        "total-energy": "929024",
        "cost": "111289",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["3345410", "51355063", "3", "172", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes", "15", "1577"],
          ["3345504", "51354813", "3", "30", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes", "20", "2020"],
          ["3347440", "51352277", "2", "333", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved route_bicycle_rcn=yes", "", "67", "6755"],
          ["3347469", "51352226", "2", "7", "1050", "0", "31", "0", "0", "reversedirection=yes highway=cycleway surface=paved", "", "68", "6843"],
          ["3347726", "51352297", "2", "2", "1350", "0", "96", "0", "0", "highway=unclassified oneway=no", "", "68", "6868"],
          ["3347469", "51352226", "2", "2", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=no", "", "68", "6887"],
          ["3347440", "51352277", "2", "7", "1050", "0", "96", "0", "0", "highway=cycleway surface=paved", "", "69", "6952"],
          ["3354337", "51357160", "1", "868", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved route_bicycle_rcn=yes", "", "195", "19532"],
          ["3354506", "51357226", "1", "16", "1000", "0", "0", "0", "0", "highway=cycleway surface=fine_gravel foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "196", "19695"],
          ["3354575", "51357248", "1", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=fine_gravel foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "197", "19754"],
          ["3354993", "51357162", "1", "36", "1000", "0", "0", "0", "0", "highway=cycleway surface=fine_gravel foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "201", "20115"],
          ["3353040", "51359021", "1", "5", "5650", "0", "176", "0", "0", "highway=service tracktype=grade2 surface=unpaved access=no foot=yes", "", "204", "20115"],
          ["3354993", "51357162", "1", "5", "5650", "0", "0", "0", "0", "reversedirection=yes highway=service tracktype=grade2 surface=unpaved access=no foot=yes", "", "207", "20115"],
          ["3355824", "51356517", "1", "71", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service tracktype=grade2 surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "215", "20893"],
          ["3355558", "51356696", "2", "5", "1000", "0", "0", "0", "0", "highway=service tracktype=grade2 surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "215", "20941"],
          ["3357173", "51356278", "1", "71", "5350", "0", "173", "0", "0", "highway=service tracktype=grade2 surface=paved access=no foot=yes", "", "263", "20941"],
          ["3355558", "51356696", "2", "71", "5350", "0", "0", "0", "0", "reversedirection=yes highway=service tracktype=grade2 surface=paved access=no foot=yes", "", "310", "20941"],
          ["3360351", "51354639", "1", "409", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service tracktype=grade2 surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "372", "27147"],
          ["3361288", "51354270", "1", "78", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service tracktype=grade2 surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "385", "28418"],
          ["3363678", "51353436", "1", "194", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "420", "31900"],
          ["3363693", "51353412", "2", "3", "5050", "0", "10", "0", "0", "highway=path surface=fine_gravel foot=yes", "barrier=kissing_gate foot=yes", "422", "31928"],
          ["3363729", "51353397", "2", "4", "5050", "0", "16", "0", "0", "highway=path surface=fine_gravel foot=yes", "", "424", "31937"],
          ["3363956", "51353044", "2", "44", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "429", "32382"],
          ["3364584", "51349571", "1", "395", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "480", "37446"],
          ["3367889", "51344984", "1", "568", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "571", "46637"],
          ["3368838", "51344557", "1", "94", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "583", "47810"],
          ["3368953", "51344562", "1", "9", "1350", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes", "", "584", "47935"],
          ["3368838", "51344557", "1", "10", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service surface=fine_gravel access=no foot=yes bicycle=yes", "", "585", "48029"],
          ["3375455", "51347503", "1", "573", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "675", "56952"],
          ["3377571", "51349487", "2", "288", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "712", "60733"],
          ["3377287", "51349703", "2", "33", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "716", "61115"],
          ["3377255", "51349718", "2", "3", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "717", "61152"],
          ["3375776", "51350897", "0", "171", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "737", "63243"],
          ["3374173", "51352131", "1", "182", "1000", "0", "0", "0", "0", "highway=service surface=unpaved access=no foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "768", "66326"],
          ["3374490", "51353726", "0", "185", "1000", "0", "0", "0", "0", "highway=service surface=unpaved access=no foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "800", "69535"],
          ["3374745", "51354187", "0", "55", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "808", "70317"],
          ["3374851", "51354735", "0", "13", "5650", "0", "2", "0", "0", "highway=service surface=unpaved access=no foot=yes", "", "817", "70359"],
          ["3374745", "51354187", "0", "13", "5650", "0", "0", "0", "0", "reversedirection=yes highway=service surface=unpaved access=no foot=yes", "", "826", "70359"],
          ["3375885", "51356766", "1", "303", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "870", "74809"],
          ["3375989", "51357045", "2", "32", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "879", "75644"],
          ["3378116", "51358117", "2", "202", "1000", "0", "0", "0", "0", "highway=service surface=fine_gravel access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "916", "79386"],
          ["3378122", "51358214", "2", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "917", "79505"],
          ["3377622", "51361968", "2", "433", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "978", "85615"],
          ["3377583", "51361998", "2", "4", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "979", "85678"],
          ["3377622", "51361968", "2", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "979", "85715"],
          ["3377800", "51361968", "2", "13", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "980", "85835"],
          ["3377883", "51362005", "2", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_icn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "981", "85913"],
          ["3378111", "51362486", "2", "57", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes oneway=no route_bicycle_icn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "987", "86512"],
          ["3380665", "51373232", "2", "1220", "1050", "0", "32", "0", "0", "highway=cycleway foot=yes oneway=no", "", "1177", "105483"],
          ["3380854", "51373901", "3", "76", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "nodeaccessgranted=yes traffic_calming=bump", "1194", "107237"],
          ["3381365", "51375947", "6", "232", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane oneway=no", "", "1249", "112676"],
          ["3381724", "51377156", "6", "140", "1450", "0", "10", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "", "1281", "115918"],
          ["3381006", "51377368", "6", "19", "1350", "0", "64", "0", "0", "reversedirection=yes highway=service surface=asphalt", "", "1284", "116200"],
          ["3381724", "51377156", "6", "19", "1350", "0", "37", "0", "0", "highway=service surface=asphalt", "", "1286", "116384"],
          ["3382507", "51377126", "6", "58", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paved oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1292", "117042"],
          ["3382818", "51377322", "6", "33", "1000", "0", "0", "0", "0", "highway=tertiary surface=paved oneway=no smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "1296", "117441"],
          ["3382746", "51377352", "6", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1297", "117528"],
          ["3392595", "51380425", "6", "805", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1430", "130786"],
          ["3396390", "51381217", "10", "303", "1050", "0", "24", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "", "1481", "135896"],
          ["3397828", "51381587", "8", "116", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1495", "137291"],
          ["3403747", "51382712", "6", "445", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1561", "143946"],
          ["3403756", "51382615", "6", "4", "1050", "0", "120", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "", "1562", "144007"],
          ["3403747", "51382712", "-8192", "4", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "", "1562", "144044"],
          ["3417686", "51387270", "4", "1133", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1739", "161699"],
          ["3417561", "51387480", "4", "3", "40000", "0", "84", "0", "0", "reversedirection=yes highway=steps surface=sand", "", "1741", "161699"],
          ["3417686", "51387270", "4", "3", "40000", "0", "0", "0", "0", "highway=steps surface=sand", "", "1743", "161699"],
          ["3430654", "51390035", "10", "1059", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1939", "181304"],
          ["3433317", "51386731", "2", "450", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "1996", "186764"],
          ["3433787", "51385444", "1", "147", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2016", "188769"],
          ["3447784", "51387965", "4", "1296", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2232", "210431"],
          ["3455123", "51391338", "3", "734", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2354", "222604"],
          ["3457357", "51392264", "5", "192", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2387", "225879"],
          ["3457660", "51392601", "5", "44", "1000", "0", "0", "0", "0", "highway=path tracktype=grade2 foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2395", "226669"],
          ["3468870", "51394532", "5", "894", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2546", "241777"],
          ["3492023", "51399482", "2", "1822", "1000", "0", "0", "0", "0", "highway=path tracktype=grade1 surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2842", "271365"],
          ["3499298", "51401554", "3", "603", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2946", "281842"],
          ["3502273", "51401743", "2", "209", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "2979", "285146"],
          ["3502366", "51401751", "2", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2981", "285259"],
          ["3502513", "51401787", "2", "11", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "2982", "285438"],
          ["3504224", "51405302", "1", "485", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3058", "292952"],
          ["3509341", "51406130", "2", "386", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "3123", "299517"],
          ["3526030", "51405777", "0", "1231", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "3324", "319630"],
          ["3526140", "51405804", "0", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "3326", "319777"],
          ["3538312", "51404695", "6", "876", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3461", "333316"],
          ["3539749", "51404601", "4", "103", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=sand foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3473", "334478"],
          ["3547651", "51401049", "3", "939", "1000", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3619", "349128"],
          ["3548022", "51401221", "3", "35", "5000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated oneway=yes route_bicycle_rcn=yes", "", "3642", "349128"],
          ["3548509", "51401627", "3", "43", "5050", "0", "188", "0", "0", "highway=footway surface=paved bicycle=dismount", "", "3671", "349128"],
          ["3548067", "51401199", "3", "47", "5050", "0", "94", "0", "0", "reversedirection=yes highway=footway surface=paved bicycle=dismount", "", "3702", "349128"],
          ["3548672", "51401708", "3", "72", "1000", "0", "0", "0", "0", "highway=path surface=paved foot=yes bicycle=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes wheelchair=yes", "3711", "350007"],
          ["3597974", "51444105", "0", "6338", "5670", "0", "0", "0", "10000", "reversedirection=yes foot=yes bicycle=yes route=ferry route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8236", "407536"],
          ["3597193", "51444076", "0", "55", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=yes bicycle=dismount route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8243", "408197"],
          ["3596743", "51443986", "0", "40", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8247", "408639"],
          ["3595835", "51443613", "1", "86", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "8258", "409770"],
          ["3595682", "51443346", "1", "35", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8263", "410279"],
          ["3595615", "51443178", "1", "20", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8266", "410577"],
          ["3595544", "51443049", "1", "17", "1000", "0", "0", "0", "0", "highway=service surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8269", "410829"],
          ["3594581", "51443236", "0", "79", "1050", "0", "174", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes", "", "8277", "411625"],
          ["3594516", "51443146", "0", "13", "9050", "0", "33", "0", "0", "reversedirection=yes highway=footway surface=metal bicycle=dismount", "", "8285", "411634"],
          ["3594479", "51443080", "0", "20", "5050", "0", "169", "0", "0", "reversedirection=yes highway=footway surface=paving_stones bicycle=dismount", "", "8298", "411634"],
          ["3594326", "51442862", "0", "29", "9050", "0", "37", "0", "0", "reversedirection=yes highway=footway surface=metal bicycle=dismount", "", "8317", "411634"],
          ["3596218", "51442291", "0", "155", "1050", "0", "60", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "", "8334", "413315"],
          ["3596000", "51441499", "1", "97", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "8345", "414379"],
          ["3596114", "51441377", "0", "16", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8346", "414533"],
          ["3595967", "51441442", "0", "3", "1350", "0", "172", "0", "0", "highway=unclassified surface=asphalt", "", "8347", "414563"],
          ["3596114", "51441377", "0", "3", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt", "", "8347", "414591"],
          ["3596210", "51441342", "0", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8348", "414664"],
          ["3596101", "51441037", "0", "52", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=lift_gate foot=yes bicycle=yes", "8353", "415181"],
          ["3579451", "51440790", "4", "1255", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8540", "433901"],
          ["3576874", "51440328", "5", "191", "5050", "0", "150", "0", "0", "highway=footway surface=paving_stones", "", "8670", "433948"],
          ["3576732", "51440481", "5", "21", "40000", "0", "70", "0", "0", "reversedirection=yes highway=steps surface=paving_stones", "", "8684", "433958"],
          ["3576710", "51440518", "5", "6", "5050", "0", "1", "0", "0", "reversedirection=yes highway=footway surface=paving_stones", "", "8688", "433958"],
          ["3576572", "51440492", "5", "1", "5050", "0", "83", "0", "0", "reversedirection=yes highway=footway", "", "8689", "433958"],
          ["3577484", "51440700", "5", "60", "5050", "0", "4", "0", "0", "highway=footway", "barrier=bollard foot=yes", "8729", "433958"],
          ["3578701", "51440936", "5", "90", "1150", "0", "4", "0", "0", "highway=living_street", "", "8743", "435389"],
          ["3578749", "51440882", "5", "2", "1150", "0", "78", "0", "0", "highway=living_street surface=paving_stones oneway=yes oneway:bicycle=no", "", "8743", "435416"],
          ["3578279", "51441399", "4", "62", "1150", "0", "0", "0", "0", "reversedirection=yes highway=living_street surface=paving_stones oneway=yes oneway:bicycle=no", "", "8749", "435988"],
          ["3578172", "51441519", "4", "16", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones", "", "8751", "436149"],
          ["3578245", "51441523", "4", "2", "1150", "0", "126", "0", "0", "highway=residential surface=paving_stones", "", "8751", "436169"],
          ["3578172", "51441519", "4", "2", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones", "", "8751", "436188"],
          ["3577808", "51442199", "4", "84", "1150", "0", "25", "0", "0", "highway=residential surface=paving_stones", "", "8760", "437086"],
          ["3574635", "51440825", "1", "277", "1150", "0", "93", "0", "0", "reversedirection=yes highway=residential surface=paving_stones", "", "8789", "439976"],
          ["3574163", "51440605", "3", "44", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones cycleway=opposite oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8797", "440742"],
          ["3574293", "51440369", "3", "31", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8800", "441071"],
          ["3574803", "51439791", "2", "75", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones cycleway=no oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8808", "441882"],
          ["3574720", "51439828", "2", "3", "40000", "0", "175", "0", "0", "reversedirection=yes highway=steps surface=paving_stones", "", "8810", "441882"],
          ["3574803", "51439791", "2", "3", "40000", "0", "0", "0", "0", "highway=steps surface=paving_stones", "", "8812", "441882"],
          ["3574867", "51439776", "1", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes horse=yes crossing=uncontrolled", "8812", "441928"],
          ["3575078", "51439529", "0", "65", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8818", "442528"],
          ["3574784", "51439695", "1", "28", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes horse=yes crossing=uncontrolled", "8821", "442842"],
          ["3557245", "51450450", "3", "1837", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9099", "470588"],
          ["3557208", "51450621", "3", "20", "5150", "0", "2", "0", "0", "reversedirection=yes highway=residential oneway=yes", "", "9112", "470588"],
          ["3556357", "51450586", "2", "65", "1150", "0", "147", "0", "0", "reversedirection=yes highway=residential", "", "9118", "471213"],
          ["3556293", "51450519", "2", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9119", "471305"],
          ["3550020", "51452192", "0", "543", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9191", "478483"],
          ["3528849", "51463713", "4", "2068", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=mini_roundabout", "9529", "512255"],
          ["3528827", "51463667", "4", "5", "9050", "0", "157", "0", "0", "reversedirection=yes highway=footway surface=gravel foot=destination", "", "9532", "512334"],
          ["3528849", "51463713", "4", "5", "9050", "0", "0", "0", "0", "highway=footway surface=gravel foot=destination", "highway=mini_roundabout", "9535", "512334"],
          ["3528321", "51463761", "5", "43", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9540", "512821"],
          ["3522413", "51470242", "5", "890", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "9684", "527223"],
          ["3522459", "51470259", "5", "4", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9685", "527278"],
          ["3522431", "51470334", "5", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "9686", "527396"],
          ["3520841", "51473171", "6", "345", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9748", "533576"],
          ["3521346", "51473686", "3", "78", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9758", "534620"],
          ["3520901", "51473617", "5", "32", "1350", "0", "179", "0", "0", "highway=service surface=paved", "", "9764", "535140"],
          ["3520664", "51473625", "5", "17", "5050", "0", "4", "0", "0", "reversedirection=yes highway=footway surface=paved", "", "9776", "535353"],
          ["3520695", "51473303", "5", "12", "5050", "0", "100", "0", "0", "highway=footway", "", "9784", "535497"],
          ["3520664", "51473625", "5", "12", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "", "9792", "535497"],
          ["3520901", "51473617", "5", "17", "5050", "0", "100", "0", "0", "highway=footway surface=paved", "", "9803", "535497"],
          ["3521346", "51473686", "3", "32", "1350", "0", "4", "0", "0", "reversedirection=yes highway=service surface=paved", "", "9806", "535769"],
          ["3522946", "51473982", "1", "118", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9817", "536867"],
          ["3522483", "51474789", "2", "97", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9828", "538016"],
          ["3519985", "51478986", "3", "559", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9902", "545346"],
          ["3513001", "51485955", "5", "985", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10043", "559525"],
          ["3512661", "51486754", "5", "93", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10059", "561060"],
          ["3502599", "51491657", "17", "971", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10266", "581740"],
          ["3499820", "51495285", "9", "464", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10334", "588573"],
          ["3495977", "51498351", "6", "467", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10400", "595164"],
          ["3486943", "51501023", "0", "918", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10542", "609394"],
          ["3486828", "51501051", "0", "10", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "10543", "609492"],
          ["3485705", "51501606", "0", "102", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10555", "610648"],
          ["3484745", "51501733", "0", "71", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10564", "611596"],
          ["3483702", "51501862", "0", "76", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "10577", "612886"],
          ["3483519", "51501885", "0", "13", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10579", "613095"],
          ["3480832", "51501684", "2", "196", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10617", "616877"],
          ["3480935", "51501547", "2", "5", "1150", "0", "88", "0", "0", "reversedirection=yes highway=residential", "", "10618", "616993"],
          ["3480832", "51501684", "2", "5", "1150", "0", "0", "0", "0", "highway=residential", "", "10619", "617039"],
          ["3480139", "51501728", "3", "52", "1000", "0", "0", "0", "0", "highway=primary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "10624", "617629"],
          ["3478557", "51502971", "2", "180", "1000", "0", "0", "0", "0", "highway=primary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10650", "620194"],
          ["3478070", "51503213", "2", "46", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "10656", "620769"],
          ["3474857", "51504730", "3", "282", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10707", "625912"],
          ["3474723", "51504791", "3", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "10709", "626115"],
          ["3473064", "51505564", "2", "144", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10728", "627970"],
          ["3470588", "51506343", "3", "207", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10771", "632302"],
          ["3463920", "51509420", "6", "587", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10867", "641920"],
          ["3456289", "51512888", "7", "694", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10994", "654630"],
          ["3453492", "51515047", "7", "337", "1000", "0", "0", "0", "0", "highway=cycleway surface=compacted foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11050", "660158"],
          ["3451033", "51515954", "3", "206", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11081", "663303"],
          ["3449060", "51519677", "3", "504", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11164", "671593"],
          ["3448980", "51520325", "4", "74", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11176", "672767"],
          ["3446983", "51521937", "2", "251", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11211", "676250"],
          ["3441392", "51525590", "3", "653", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11327", "687939"],
          ["3440826", "51526409", "4", "104", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11345", "689673"],
          ["3440489", "51526345", "4", "25", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11348", "690003"],
          ["3437719", "51526663", "3", "203", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11374", "692585"],
          ["3434874", "51527538", "1", "258", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11409", "696099"],
          ["3435331", "51532734", "0", "584", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11496", "704802"],
          ["3436350", "51537770", "0", "570", "1000", "0", "0", "0", "0", "highway=service route_bicycle_rcn=yes", "", "11592", "714377"],
          ["3455535", "51548581", "3", "1895", "1350", "0", "2", "0", "0", "highway=service", "", "11897", "744869"],
          ["3457271", "51548641", "3", "127", "1350", "0", "84", "0", "0", "reversedirection=yes highway=service", "", "11918", "747003"],
          ["3459902", "51549072", "4", "190", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt cycleway=lane route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=swing_gate access=permissive", "11955", "750652"],
          ["3460311", "51548939", "3", "39", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt cycleway=lane route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=backward", "11961", "751308"],
          ["3460321", "51548926", "3", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt cycleway=lane route_bicycle_rcn=yes", "", "11961", "751337"],
          ["3462091", "51549373", "3", "134", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11982", "753405"],
          ["3477078", "51556300", "5", "1313", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12216", "776810"],
          ["3477116", "51556253", "4", "6", "5050", "0", "85", "0", "0", "highway=path", "", "12220", "776829"],
          ["3476037", "51555945", "4", "14", "3050", "0", "93", "0", "0", "reversedirection=yes highway=primary foot=use_sidepath bicycle=use_sidepath", "", "12222", "777030"],
          ["3477116", "51556253", "4", "14", "3050", "0", "0", "0", "0", "highway=primary foot=use_sidepath bicycle=use_sidepath", "", "12224", "777162"],
          ["3477078", "51556300", "5", "6", "5050", "0", "93", "0", "0", "reversedirection=yes highway=path", "", "12228", "777162"],
          ["3493157", "51561918", "6", "1308", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12455", "799893"],
          ["3494350", "51562168", "5", "88", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=asphalt cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12469", "801258"],
          ["3494372", "51562174", "5", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12469", "801289"],
          ["3495934", "51562893", "5", "136", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=asphalt cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12491", "803462"],
          ["3496166", "51563021", "5", "22", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=concrete cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12495", "803876"],
          ["3497128", "51563557", "7", "91", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=sett cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12515", "805868"],
          ["3498365", "51563930", "7", "99", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=paving_stones cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12535", "807861"],
          ["3499040", "51564170", "7", "55", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=concrete cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12544", "808851"],
          ["3509332", "51565962", "5", "758", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12667", "821088"],
          ["3519237", "51568504", "3", "758", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12787", "833139"],
          ["3519232", "51568633", "3", "15", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=designated oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12790", "833398"],
          ["3518974", "51568663", "3", "19", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12793", "833734"],
          ["3516702", "51571766", "7", "385", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "12863", "840678"],
          ["3516875", "51571878", "7", "18", "1000", "0", "0", "0", "0", "highway=path foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "12865", "840956"],
          ["3530782", "51576175", "9", "1104", "1000", "0", "0", "0", "0", "highway=path foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "13060", "860390"],
          ["3534119", "51577075", "7", "268", "1000", "0", "0", "0", "0", "highway=path foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "13095", "863961"],
          ["3536871", "51577765", "7", "221", "1000", "0", "0", "0", "0", "highway=path surface=gravel foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "13127", "867107"],
          ["3543748", "51578610", "7", "507", "1000", "0", "0", "0", "0", "highway=path surface=gravel foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "13213", "875675"],
          ["3545209", "51578944", "6", "109", "1000", "0", "0", "0", "0", "highway=path surface=gravel foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "13228", "877215"],
          ["3545304", "51578975", "6", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=gravel foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "13229", "877328"],
          ["3551676", "51579801", "4", "475", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=gravel foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "13302", "884630"],
          ["3556365", "51580109", "4", "339", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "13358", "890218"],
          ["3567626", "51580251", "7", "803", "1000", "0", "0", "0", "0", "highway=service surface=paving_stones foot=yes bicycle=yes vehicle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "13517", "906101"],
          ["3579383", "51581499", "1", "833", "1000", "0", "0", "0", "0", "highway=service surface=paving_stones foot=yes bicycle=yes vehicle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "13635", "917877"],
          ["3582866", "51581827", "1", "248", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes", "", "13676", "922011"],
          ["3587465", "51580971", "0", "226", "1450", "0", "2", "0", "0", "reversedirection=yes highway=tertiary", "", "13701", "924529"],
          ["3585790", "51581279", "0", "11", "1450", "0", "0", "0", "0", "highway=tertiary", "", "13702", "924632"],
          ["3585776", "51581247", "0", "4", "1350", "0", "92", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones", "highway=give_way direction=forward", "13702", "924670"],
          ["3584650", "51578370", "2", "264", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones", "", "13746", "929070"]
        ],
        "times": [0, 15.482, 15.772, 16.062, 19.907, 20.207, 20.508, 54.247, 54.581, 55.044, 55.612, 62.63, 64.804, 65.553, 66.569, 67.553, 68.431, 68.685, 68.869, 69.525, 70.794, 72.339, 76.317, 85.79, 96.337, 97.521, 98.567, 103.04, 131.609, 162.448, 163.448, 165.449, 167.803, 169.386, 173.616, 178.045, 179.857, 181.178, 181.657, 182.545, 183.568, 195.302, 195.711, 195.988, 196.935, 197.521, 197.92, 198.122, 198.585, 199.374, 201.133, 204.467, 207.693, 214.898, 215.48, 215.96, 261.838, 263.198, 264.486, 310.568, 313.936, 316.501, 325.527, 354.143, 363.583, 371.971, 372.614, 373.097, 385.326, 409.293, 413.486, 418.417, 420.14, 422.284, 422.999, 424.932, 426.764, 429.058, 429.386, 429.717, 431.073, 442.588, 447.291, 473.893, 476.636, 479.396, 480.008, 480.621, 482.785, 485.89, 509.364, 537.545, 540.44, 545.872, 550.827, 562.187, 563.087, 567.051, 571.683, 571.92, 572.262, 574.983, 577.874, 579.778, 581.75, 583.648, 584.894, 584.986, 585.83, 588.022, 590.745, 610.153, 612.832, 615.219, 624.745, 640.945, 666.763, 671.946, 674.418, 674.77, 675.056, 675.444, 700.887, 704.089, 707.156, 707.432, 708.966, 709.74, 711.362, 712.427, 712.863, 713.194, 716.321, 716.685, 717.051, 722.748, 735.752, 736.853, 737.484, 737.959, 761.431, 768.788, 775.606, 782.674, 788.049, 800.868, 808.684, 817.753, 826.242, 832.795, 837.423, 842.764, 855.432, 860.825, 869.909, 870.729, 871.601, 879.078, 883.767, 887.843, 900.933, 905.977, 909.591, 911.852, 913.666, 915.446, 915.755, 916.489, 917.681, 919.263, 921.036, 922.326, 924.047, 924.509, 927.933, 939.274, 964.397, 969.975, 970.799, 972.284, 973.11, 975.914, 977.014, 977.645, 978.753, 979.388, 979.757, 980.396, 980.959, 981.342, 981.731, 987.031, 987.72, 991.989, 1011.924, 1084.727, 1096.145, 1100.17, 1110.634, 1152.079, 1168.098, 1174.083, 1175.52, 1176.333, 1177.412, 1194.944, 1208.284, 1221.704, 1235.068, 1249.324, 1266.166, 1276.283, 1278.946, 1280.802, 1281.737, 1282.915, 1283.508, 1284.104, 1284.553, 1284.83, 1285.204, 1285.584, 1286.394, 1287.123, 1289.646, 1291.278, 1292.978, 1293.853, 1294.698, 1296.966, 1297.832, 1301.984, 1302.447, 1303.275, 1307.074, 1314.399, 1315.202, 1316.208, 1328.152, 1330.196, 1333.851, 1336.741, 1338.842, 1345.451, 1348.557, 1354.658, 1360.001, 1365.227, 1368.399, 1370.158, 1371.443, 1375.81, 1379.561, 1383.171, 1387.789, 1397.404, 1399.434, 1401.967, 1405.629, 1410.529, 1415.261, 1419.869, 1422.226, 1424.382, 1426.522, 1430.408, 1439.342, 1440.348, 1447.752, 1449.305, 1450.398, 1455.301, 1456.26, 1457.703, 1472.221, 1473.542, 1474.533, 1476.353, 1481.496, 1484.389, 1485.15, 1486.496, 1490.458, 1491.474, 1492.903, 1495.449, 1495.881, 1498.198, 1506.415, 1509.151, 1511.58, 1513.532, 1516.309, 1518.442, 1522.064, 1527.026, 1537.172, 1540.979, 1545.867, 1547.966, 1554.375, 1555.978, 1558.95, 1561.988, 1562.602, 1562.972, 1564.511, 1567.772, 1571.025, 1572.379, 1573.643, 1575.07, 1578.165, 1581.681, 1582.981, 1594.978, 1599.093, 1600.371, 1601.654, 1604.737, 1608.54, 1613.068, 1617.387, 1623.209, 1628.904, 1635.208, 1639.595, 1644.78, 1646.984, 1654.189, 1657.686, 1668.673, 1671.523, 1677.812, 1679.083, 1680.707, 1683.571, 1689.068, 1693.023, 1695.779, 1698.127, 1706.666, 1712.65, 1714.379, 1716.119, 1717.985, 1719.848, 1725.261, 1726.275, 1727.963, 1730.664, 1735.891, 1737.07, 1737.576, 1738.447, 1739.504, 1741.526, 1743.477, 1744.863, 1746.081, 1749.663, 1754.878, 1757.176, 1761.019, 1762.831, 1764.511, 1766.207, 1776.291, 1778.416, 1780.856, 1785.029, 1795.939, 1806.782, 1808.393, 1809.523, 1816.817, 1818.655, 1820.662, 1823.025, 1825.919, 1827.44, 1828.945, 1834.299, 1835.752, 1837.017, 1839.348, 1840.773, 1842.723, 1846.765, 1850.943, 1853.019, 1858.868, 1862.118, 1864.336, 1866.379, 1868.25, 1870.287, 1872.831, 1874.356, 1877.402, 1881.289, 1883.821, 1886.015, 1888.207, 1890.567, 1892.757, 1895.788, 1900.502, 1903.531, 1907.568, 1910.258, 1912.444, 1914.63, 1915.975, 1919.001, 1920.346, 1923.203, 1924.212, 1925.556, 1930.43, 1937.992, 1939.504, 1941.664, 1943.184, 1944.588, 1947.234, 1948.324, 1949.566, 1950.974, 1953.857, 1955.443, 1956.781, 1958.31, 1996.212, 2016.259, 2023.272, 2026.395, 2028.869, 2031.515, 2034.5, 2037.154, 2039.964, 2041.272, 2042.939, 2046.778, 2057.107, 2059.083, 2070.518, 2091.584, 2101.963, 2103.767, 2107.719, 2110.05, 2112.407, 2137.318, 2149.444, 2183.037, 2185.625, 2188.204, 2189.973, 2192.075, 2193.907, 2195.759, 2197.785, 2201.665, 2205.649, 2207.36, 2211.971, 2214.079, 2216.503, 2232.867, 2235.241, 2242.341, 2249.9, 2255.695, 2257.809, 2260.037, 2260.836, 2261.392, 2262.184, 2263.653, 2264.689, 2268.106, 2270.029, 2271.596, 2273.852, 2276.098, 2278.304, 2282.65, 2305.5, 2327.281, 2338.935, 2344.983, 2354.591, 2355.13, 2355.675, 2370.142, 2372.048, 2373.431, 2375.088, 2387.341, 2395.236, 2398.583, 2402.077, 2403.814, 2410.885, 2416.189, 2417.212, 2418.575, 2420.277, 2423.504, 2424.861, 2426.387, 2427.742, 2430.449, 2431.802, 2437.544, 2438.556, 2439.568, 2441.592, 2447.994, 2450.183, 2452.371, 2454.896, 2465.156, 2468.182, 2473.057, 2476.755, 2479.444, 2481.797, 2486.503, 2492.888, 2494.064, 2495.408, 2506.498, 2512.546, 2518.427, 2520.947, 2528.003, 2537.412, 2539.932, 2543.124, 2546.316, 2548.668, 2551.188, 2553.708, 2556.564, 2558.076, 2559.588, 2560.764, 2561.94, 2564.124, 2571.517, 2573.869, 2593.189, 2596.213, 2599.405, 2602.093, 2603.773, 2605.117, 2606.629, 2610.661, 2614.189, 2615.365, 2616.374, 2619.565, 2622.254, 2624.606, 2631.326, 2648.294, 2654.006, 2655.518, 2660.222, 2681.727, 2692.479, 2698.695, 2708.943, 2718.352, 2721.208, 2721.3, 2722.048, 2722.528, 2722.919, 2723.72, 2725.83, 2727.973, 2729.394, 2730.989, 2732.382, 2733.68, 2736.5, 2737.606, 2739.435, 2744.237, 2747.245, 2748.772, 2752.646, 2758.501, 2761.069, 2762.683, 2763.816, 2764.952, 2767.069, 2773.628, 2774.452, 2775.112, 2789.554, 2821.025, 2828.916, 2842.183, 2844.871, 2846.551, 2847.558, 2849.406, 2853.773, 2855.285, 2857.637, 2859.317, 2867.549, 2878.301, 2880.989, 2885.692, 2886.868, 2888.549, 2889.725, 2895.269, 2898.292, 2899.301, 2905.685, 2914.757, 2916.941, 2918.285, 2928.197, 2937.791, 2938.63, 2944.911, 2946.953, 2958.234, 2979.981, 2981.114, 2982.901, 2984.587, 2985.978, 2987.635, 2989.461, 2989.959, 2991.587, 2996.273, 2999.27, 3001.762, 3003.824, 3005.74, 3007.667, 3025.125, 3028.478, 3032.901, 3036.618, 3045.007, 3049.062, 3050.426, 3051.74, 3053.073, 3058.039, 3066.844, 3070.503, 3073.342, 3075.279, 3076.662, 3085.402, 3087.973, 3096.859, 3123.674, 3126.739, 3129.117, 3131.832, 3132.849, 3136.911, 3138.94, 3141.305, 3142.635, 3144.052, 3145.238, 3149.286, 3152.192, 3155.512, 3157.906, 3160.802, 3162.354, 3164.075, 3167.773, 3169.301, 3171.12, 3175.061, 3178.131, 3182.006, 3183.581, 3185.052, 3186.69, 3188.543, 3189.32, 3190.257, 3191.984, 3193.882, 3196.112, 3199.002, 3201.913, 3203.701, 3205.234, 3208.807, 3212.438, 3216.596, 3221.452, 3226.683, 3230.468, 3233.937, 3239.577, 3241.406, 3248.506, 3251.419, 3254.119, 3259.54, 3263.786, 3269.916, 3272.936, 3275.445, 3288.717, 3292.035, 3295.66, 3304.249, 3305.322, 3314.913, 3322.02, 3323.488, 3324.795, 3326.269, 3328.24, 3333.849, 3337.162, 3341.649, 3350.654, 3353.328, 3361.864, 3364.21, 3368.401, 3374.942, 3377.351, 3380.784, 3385.091, 3389.679, 3393.301, 3397.961, 3407.939, 3415.114, 3418.025, 3421.117, 3424.555, 3431.312, 3437.578, 3448.387, 3461.653, 3468.141, 3468.886, 3472.692, 3473.271, 3477.442, 3481.435, 3484.772, 3486.995, 3488.845, 3495.203, 3497.8, 3500.903, 3504.209, 3509.483, 3518.427, 3521.878, 3530.314, 3541.64, 3543.811, 3545.148, 3546.821, 3547.824, 3548.475, 3549.535, 3550.953, 3552.886, 3554.823, 3555.412, 3556.74, 3560.034, 3563.666, 3566.05, 3568.497, 3571.301, 3573.104, 3576.929, 3581.147, 3584.18, 3587.762, 3595.407, 3602.904, 3619.177, 3619.754, 3626.311, 3632.921, 3642.848, 3644.846, 3671.849, 3698.07, 3700.07, 3702.744, 3709.431, 3711.532, 5280.262, 6518.918, 7754.715, 7843.343, 8155.688, 8207.149, 8236.499, 8243.111, 8243.763, 8245.222, 8246.639, 8247.531, 8248.277, 8249.374, 8250.685, 8251.845, 8253.029, 8254.594, 8258.835, 8259.882, 8260.733, 8261.736, 8262.313, 8263.919, 8266.896, 8267.953, 8269.323, 8269.415, 8273.502, 8276.535, 8276.719, 8277.092, 8277.375, 8281.992, 8285.896, 8288.51, 8289.82, 8292.399, 8298.241, 8298.885, 8307.967, 8317.824, 8318.032, 8318.872, 8318.968, 8334.634, 8335.1, 8341.544, 8341.831, 8343.162, 8344.293, 8345.279, 8346.82, 8347.12, 8347.396, 8348.126, 8349.606, 8350.582, 8351.7, 8353.301, 8353.965, 8356.63, 8362.352, 8363.161, 8364.192, 8365.07, 8365.877, 8366.921, 8368.67, 8369.58, 8371.107, 8376.956, 8377.359, 8388.898, 8395.722, 8396.541, 8401.719, 8414.155, 8416.947, 8419.724, 8423.691, 8430.373, 8435.706, 8467.915, 8491.553, 8494.268, 8497.437, 8504.574, 8509.924, 8513.522, 8514.312, 8514.471, 8515.216, 8516.28, 8518.873, 8522.056, 8524.124, 8525.77, 8526.028, 8526.679, 8528.037, 8529.366, 8532.573, 8535.289, 8535.963, 8536.999, 8540.373, 8540.468, 8543.095, 8553.685, 8667.373, 8670.95, 8671.666, 8684.663, 8686.634, 8688.608, 8689.263, 8689.912, 8699.646, 8720.316, 8729.178, 8738.888, 8741.866, 8743.488, 8743.763, 8743.946, 8749.474, 8750.184, 8751.087, 8751.292, 8751.476, 8751.836, 8752.55, 8753.265, 8760.271, 8760.461, 8765.03, 8765.847, 8767.912, 8775.614, 8778.107, 8785.471, 8786.993, 8788.126, 8789.353, 8794.572, 8795.293, 8797.017, 8797.397, 8797.954, 8799.356, 8800.299, 8803.891, 8807.034, 8808.417, 8810.396, 8812.33, 8812.782, 8813.14, 8814.342, 8814.618, 8816.389, 8816.737, 8816.992, 8817.338, 8817.507, 8817.69, 8818.051, 8818.417, 8818.789, 8818.978, 8819.534, 8821.926, 8831.99, 8834.152, 8834.336, 8850.678, 8862.448, 8865.294, 8869.454, 8870.06, 8870.336, 8871.091, 8872.106, 8885.078, 8886.121, 8887.021, 8888.389, 8889.727, 8891.572, 8892.33, 8893.18, 8894.125, 8895.061, 8908.383, 8908.542, 8913.207, 8916.329, 8918.691, 8922.387, 8928.83, 8929.48, 8964.511, 8982.092, 8987.714, 8999.582, 9002.021, 9005.895, 9007.655, 9028.739, 9038.979, 9044.405, 9049.858, 9058.175, 9066.378, 9073.456, 9084.278, 9090.783, 9093.409, 9097.02, 9098.104, 9099.351, 9112.444, 9115.562, 9118.089, 9118.689, 9118.893, 9119.617, 9120.434, 9121.062, 9121.471, 9124.389, 9125.961, 9129.312, 9137.681, 9138.734, 9140.045, 9141.831, 9142.118, 9143.24, 9144.193, 9146.519, 9149.771, 9162.585, 9167.367, 9170.705, 9178.829, 9188.305, 9191.381, 9195.368, 9211.222, 9212.876, 9214.863, 9218.265, 9220.548, 9221.564, 9223.477, 9224.818, 9226.78, 9227.847, 9235.802, 9243.936, 9249.159, 9262.725, 9268.366, 9274.753, 9279.786, 9284.627, 9287.982, 9293.397, 9295.65, 9298.412, 9300.132, 9310.014, 9311.553, 9321.76, 9323.023, 9324.818, 9326.146, 9327.489, 9329.253, 9333.896, 9334.834, 9336.421, 9339.569, 9342.75, 9344.066, 9348.646, 9350.072, 9353.28, 9364.355, 9365.007, 9365.926, 9366.939, 9368.184, 9374.271, 9380.003, 9381.463, 9388.634, 9397.306, 9400.699, 9402.815, 9419.31, 9429.179, 9434.461, 9440.488, 9445.545, 9448.842, 9451.013, 9454.235, 9457.071, 9458.833, 9460.586, 9464.192, 9469.634, 9472.781, 9477.771, 9482.57, 9495.255, 9500.171, 9504.283, 9507.113, 9510.67, 9515.46, 9518.577, 9522.837, 9525.904, 9529.073, 9532.741, 9535.967, 9538.5, 9539.199, 9540.837, 9544.047, 9549.234, 9551.884, 9554.689, 9557.473, 9561.52, 9566.532, 9572.256, 9579.246, 9586.36, 9593.675, 9599.842, 9624.432, 9633.17, 9635.534, 9635.917, 9638.001, 9638.656, 9649.184, 9656.032, 9659.316, 9661.418, 9679.017, 9681.768, 9683.363, 9684.843, 9685.389, 9686.566, 9688.348, 9690.996, 9694.786, 9702.485, 9703.843, 9714.979, 9727.674, 9740.482, 9742.514, 9745.379, 9748.363, 9751.728, 9754.933, 9756.899, 9758.794, 9764, 9776.307, 9784.979, 9792.748, 9803.724, 9806.443, 9813.669, 9816.775, 9817.426, 9819.593, 9821.179, 9828.909, 9839.416, 9839.918, 9840.205, 9840.887, 9844.709, 9849.809, 9854.475, 9855.577, 9855.943, 9856.521, 9857.111, 9859.626, 9861.14, 9864.135, 9866.773, 9868.751, 9873.316, 9874.637, 9887.812, 9894.006, 9899.003, 9900.062, 9900.465, 9901.549, 9902.198, 9903.451, 9905.493, 9908.158, 9919.138, 9922.506, 9925.631, 9936.312, 9952.13, 9954.408, 9954.503, 9955.477, 9958.902, 9964.132, 9967.05, 9971.12, 9976.886, 9993.312, 10003.823, 10010.266, 10012.585, 10013.001, 10015.844, 10021.27, 10022.776, 10025.381, 10027.77, 10029.818, 10032.724, 10035.026, 10036.423, 10040.107, 10043.966, 10048.992, 10053.903, 10059.312, 10070.074, 10081.52, 10097.242, 10101.994, 10108.161, 10110.072, 10112.553, 10119.373, 10129.191, 10131.766, 10132.744, 10135.037, 10137.591, 10145.92, 10149.604, 10151.954, 10156.581, 10160.943, 10167.886, 10169.757, 10171.276, 10174.547, 10176.887, 10178.401, 10192.385, 10198.61, 10204.854, 10211.438, 10216.136, 10221.319, 10237.964, 10243.861, 10247.808, 10266.069, 10278.692, 10281.417, 10286.846, 10290.132, 10292.874, 10296.529, 10302.092, 10305.314, 10307.817, 10310.47, 10313.271, 10314.886, 10317.679, 10318.9, 10320.103, 10321.37, 10324.106, 10326.778, 10329.203, 10329.432, 10331.539, 10334.382, 10335.995, 10342.235, 10344.082, 10345.364, 10346.729, 10351.119, 10352.009, 10354.525, 10355.933, 10357.823, 10359.175, 10361.439, 10362.873, 10365.561, 10366.961, 10369.965, 10372.635, 10374.05, 10378.688, 10381.316, 10385.01, 10387.086, 10394.502, 10398.994, 10400.281, 10410.884, 10433.702, 10437.789, 10442.579, 10448.177, 10457.845, 10465.473, 10472.194, 10474.327, 10477.208, 10479.461, 10483.981, 10486.368, 10488.424, 10490.964, 10494.014, 10502.947, 10504.404, 10513.157, 10521.442, 10528.905, 10529.462, 10530.105, 10534.695, 10540.854, 10541.056, 10542.57, 10542.965, 10543.545, 10546.327, 10549.502, 10552.557, 10553.42, 10555.107, 10558.675, 10559.604, 10561.502, 10563.029, 10564.585, 10568.815, 10571.43, 10575.758, 10577.48, 10579.578, 10582.987, 10584.032, 10585.248, 10588.189, 10593.665, 10606.594, 10611.419, 10612.293, 10612.727, 10614.784, 10617.395, 10618.55, 10619.013, 10620.57, 10621.879, 10623.305, 10624.905, 10626.82, 10628.067, 10634.886, 10641.173, 10644.845, 10648.123, 10650.56, 10652.654, 10655.105, 10655.769, 10656.304, 10660.617, 10699.931, 10707.73, 10709.76, 10728.312, 10732.574, 10735.002, 10736.703, 10738.373, 10754.648, 10758.255, 10760.644, 10767.768, 10771.632, 10780.141, 10785.306, 10794.2, 10800.475, 10803.705, 10806.734, 10821.11, 10824.766, 10829.866, 10831.571, 10833.805, 10837.347, 10843.359, 10847.782, 10860.164, 10862.673, 10867.8, 10878.793, 10882.267, 10884.811, 10887.259, 10890.313, 10899.514, 10901.095, 10902.047, 10903.145, 10904.649, 10906.068, 10909.171, 10911.787, 10914.753, 10920.979, 10925.819, 10928.559, 10933.092, 10936.809, 10944.479, 10949.713, 10960.416, 10961.71, 10964.734, 10966.263, 10978.374, 10979.771, 10981.446, 10989.103, 10991.038, 10994.883, 10997.254, 10998.438, 11001.302, 11002.263, 11003.064, 11004.029, 11006.232, 11009.137, 11018.65, 11020.029, 11020.898, 11026.211, 11026.813, 11027.395, 11028.016, 11028.771, 11029.667, 11033.882, 11035.229, 11038.288, 11043.448, 11046.325, 11048.048, 11050.154, 11060.599, 11062.882, 11064.729, 11072.951, 11078.102, 11079.991, 11081.608, 11089.464, 11090.676, 11091.909, 11094.023, 11098.394, 11100.303, 11102.207, 11105.418, 11109.966, 11110.888, 11111.958, 11115.009, 11120.309, 11122.846, 11134.018, 11135.563, 11138.357, 11144.339, 11149.887, 11154.538, 11155.283, 11155.732, 11156.333, 11164.494, 11167.775, 11171.985, 11176.23, 11183.709, 11188.513, 11191.839, 11193.365, 11194.924, 11195.362, 11197.791, 11198.943, 11200.312, 11209.287, 11211.053, 11215.023, 11220.84, 11228.895, 11236.302, 11240.365, 11242.453, 11246.347, 11253.328, 11257.438, 11261.156, 11264.151, 11266.596, 11269.358, 11272.67, 11274.495, 11278.238, 11286.553, 11289.025, 11298.221, 11309.923, 11317.053, 11327.933, 11328.576, 11334.88, 11345.268, 11347.35, 11348.572, 11351.313, 11351.646, 11352.437, 11355.629, 11359.223, 11362.938, 11374.388, 11375.731, 11376.786, 11380.609, 11385.616, 11394.611, 11394.882, 11395.697, 11398.341, 11400.025, 11402.712, 11404.514, 11406.667, 11407.216, 11409.523, 11410.614, 11418.785, 11436.235, 11451.78, 11459.741, 11466.238, 11472.587, 11486.655, 11496.552, 11497.224, 11551.976, 11592.295, 11616.319, 11638.496, 11649.584, 11652.272, 11655.814, 11662.408, 11671.039, 11682.742, 11695.332, 11716.987, 11747.674, 11767.828, 11790.34, 11799.958, 11835.821, 11850.21, 11861.444, 11868.157, 11883.94, 11897.209, 11899.057, 11899.896, 11913, 11918.544, 11922.071, 11932.655, 11955.034, 11956.427, 11958.444, 11959.883, 11961.593, 11961.881, 11969.169, 11980.467, 11982.557, 11990.178, 12000.396, 12011.824, 12023.785, 12029.062, 12034.146, 12039.025, 12052.43, 12054.1, 12061.727, 12071.485, 12126.758, 12139.283, 12143.707, 12150.343, 12156.106, 12176.879, 12180.439, 12194.246, 12200.432, 12204.061, 12216.586, 12220.772, 12222.777, 12224.098, 12228.089, 12239.355, 12251.418, 12286.997, 12292.53, 12298.212, 12300.773, 12324.838, 12330.85, 12340.167, 12347.258, 12350.773, 12356.135, 12363.011, 12370.897, 12380.433, 12389.662, 12400.103, 12404.254, 12408.531, 12418.767, 12421.44, 12425.106, 12433.899, 12436.763, 12442.526, 12448.313, 12453.104, 12455.387, 12464.636, 12469.041, 12469.349, 12472.136, 12477.452, 12488.034, 12491.075, 12495.217, 12499.401, 12505.722, 12515.133, 12520.392, 12522.739, 12530.169, 12535.06, 12536.249, 12542.95, 12544.954, 12546.124, 12551.369, 12559.947, 12566.557, 12578.101, 12580.045, 12582.629, 12585.953, 12587.258, 12591.564, 12592.638, 12597.141, 12598.525, 12599.227, 12600.503, 12602.087, 12603.64, 12605.99, 12617.763, 12630.033, 12667.318, 12694.191, 12701.669, 12708.39, 12715.042, 12744.081, 12757.773, 12760.249, 12762.439, 12763.783, 12768.774, 12772.119, 12775.469, 12779.305, 12784.149, 12787.81, 12788.976, 12790.399, 12792.7, 12793.757, 12795.631, 12807.423, 12810.221, 12827.222, 12839.369, 12846.097, 12848.601, 12856.805, 12860.066, 12863.181, 12865.962, 12880.972, 12893.138, 12898.693, 12917.639, 12918.388, 12920.062, 12929.083, 12942.142, 12968.881, 12985.295, 12991.942, 12993.632, 12998.848, 13016.468, 13018.464, 13021.795, 13023.964, 13026.635, 13029.978, 13040.504, 13057.156, 13059.074, 13060.291, 13066.009, 13072.314, 13074.702, 13076.673, 13081.061, 13084.49, 13087.216, 13090.156, 13093.785, 13095.992, 13103.479, 13104.688, 13106.247, 13107.043, 13107.849, 13109.351, 13111.306, 13113.45, 13117.275, 13119.536, 13122.446, 13127.448, 13129.992, 13137.037, 13148.333, 13155.466, 13161.976, 13189.87, 13208.702, 13211.06, 13213.12, 13220.494, 13226.446, 13228.513, 13229.641, 13234.582, 13236.529, 13238.304, 13241.062, 13244.155, 13246.552, 13251.328, 13256.257, 13258.968, 13260.781, 13262.462, 13265.236, 13267.024, 13270.077, 13274.943, 13276.632, 13278.491, 13283.866, 13288.337, 13290.689, 13298.446, 13302.656, 13306.614, 13314.255, 13316.924, 13322.591, 13328.176, 13330.395, 13338.764, 13341.842, 13347.542, 13355.884, 13357.325, 13358.534, 13363.303, 13366.317, 13371.087, 13379.531, 13385.025, 13390.526, 13424.312, 13426.788, 13431.744, 13443.458, 13447.164, 13475.863, 13478.203, 13516.875, 13517.318, 13545.932, 13608.298, 13627.888, 13630.16, 13632.606, 13633.752, 13635.062, 13636.213, 13637.692, 13640.001, 13647.953, 13661.929, 13669.816, 13672.716, 13675.268, 13676.395, 13677.376, 13679.918, 13686.638, 13699.843, 13701.571, 13702.603, 13702.988, 13746.675, 13746.988]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [3.344831, 51.356559, 5.75],
          [3.345405, 51.355077, 3.0],
          [3.345410, 51.355063, 3.0],
          [3.345417, 51.355047, 3.0],
          [3.345500, 51.354823, 3.0],
          [3.345504, 51.354813, 3.0],
          [3.345508, 51.354804, 3.0],
          [3.346179, 51.352962, 3.0],
          [3.346190, 51.352949, 3.0],
          [3.346224, 51.352911, 3.0],
          [3.346275, 51.352877, 3.0],
          [3.346998, 51.352482, 2.75],
          [3.347186, 51.352374, 2.75],
          [3.347236, 51.352335, 2.75],
          [3.347335, 51.352302, 2.75],
          [3.347440, 51.352277, 2.5],
          [3.347469, 51.352226, 2.5],
          [3.347489, 51.352231, 2.5],
          [3.347469, 51.352226, 2.5],
          [3.347440, 51.352277, 2.5],
          [3.347603, 51.352319, 2.5],
          [3.347782, 51.352381, 2.5],
          [3.348231, 51.352570, 2.0],
          [3.349152, 51.352928, 2.0],
          [3.350091, 51.353265, 1.75],
          [3.350186, 51.353303, 1.75],
          [3.350249, 51.353341, 1.75],
          [3.350447, 51.353581, 1.5],
          [3.352590, 51.354405, 1.75],
          [3.354920, 51.355288, 1.5],
          [3.354981, 51.355323, 1.5],
          [3.355079, 51.355402, 1.5],
          [3.355163, 51.355517, 1.25],
          [3.355182, 51.355600, 1.25],
          [3.355219, 51.355843, 1.0],
          [3.355270, 51.356080, 1.25],
          [3.355270, 51.356175, 1.25],
          [3.355254, 51.356245, 1.25],
          [3.355230, 51.356297, 1.5],
          [3.355177, 51.356370, 1.5],
          [3.355108, 51.356442, 1.5],
          [3.354337, 51.357160, 1.5],
          [3.354363, 51.357171, 1.5],
          [3.354393, 51.357183, 1.5],
          [3.354506, 51.357226, 1.5],
          [3.354575, 51.357248, 1.5],
          [3.354625, 51.357265, 1.5],
          [3.354650, 51.357266, 1.5],
          [3.354712, 51.357271, 1.5],
          [3.354814, 51.357254, 1.75],
          [3.354993, 51.357162, 1.75],
          [3.354954, 51.357198, 1.75],
          [3.354993, 51.357162, 1.75],
          [3.355558, 51.356696, 2.0],
          [3.355598, 51.356668, 1.75],
          [3.355558, 51.356696, 2.0],
          [3.356443, 51.356435, 1.75],
          [3.356464, 51.356430, 1.75],
          [3.356443, 51.356435, 1.75],
          [3.355558, 51.356696, 2.0],
          [3.355824, 51.356517, 1.75],
          [3.356030, 51.356397, 1.75],
          [3.356766, 51.356085, 2.0],
          [3.359003, 51.355192, 1.75],
          [3.359682, 51.354918, 1.75],
          [3.360312, 51.354655, 1.5],
          [3.360351, 51.354639, 1.5],
          [3.360387, 51.354625, 1.5],
          [3.361288, 51.354270, 1.5],
          [3.362850, 51.353734, 2.25],
          [3.363177, 51.353638, 2.0],
          [3.363568, 51.353496, 1.75],
          [3.363678, 51.353436, 1.75],
          [3.363693, 51.353412, 2.0],
          [3.363700, 51.353408, 2.0],
          [3.363729, 51.353397, 2.0],
          [3.363847, 51.353244, 2.0],
          [3.363945, 51.353062, 2.0],
          [3.363956, 51.353044, 2.0],
          [3.363963, 51.353022, 2.0],
          [3.363994, 51.352923, 2.0],
          [3.364295, 51.352127, 1.75],
          [3.364322, 51.351834, 1.75],
          [3.364505, 51.349892, 1.75],
          [3.364529, 51.349741, 1.75],
          [3.364576, 51.349598, 1.75],
          [3.364584, 51.349571, 1.5],
          [3.364596, 51.349544, 1.5],
          [3.364644, 51.349427, 1.5],
          [3.364747, 51.349259, 1.25],
          [3.365548, 51.348193, 2.0],
          [3.366462, 51.346941, 2.5],
          [3.366574, 51.346807, 2.5],
          [3.366822, 51.346569, 2.5],
          [3.367026, 51.346322, 2.25],
          [3.367407, 51.345717, 2.0],
          [3.367435, 51.345671, 1.75],
          [3.367643, 51.345344, 1.75],
          [3.367878, 51.344999, 1.5],
          [3.367889, 51.344984, 1.5],
          [3.367901, 51.344966, 1.25],
          [3.368029, 51.344783, 1.25],
          [3.368260, 51.344634, 1.0],
          [3.368441, 51.344574, 1.0],
          [3.368649, 51.344555, 1.0],
          [3.368838, 51.344557, 1.0],
          [3.368953, 51.344562, 1.0],
          [3.368953, 51.344562, 1.0],
          [3.368838, 51.344557, 1.0],
          [3.369112, 51.344640, 1.0],
          [3.369417, 51.344771, 0.75],
          [3.371286, 51.345648, 0.0],
          [3.371497, 51.345721, 0.0],
          [3.371692, 51.345776, 0.0],
          [3.372342, 51.346063, 0.25],
          [3.373194, 51.346465, 1.5],
          [3.374957, 51.347240, 1.0],
          [3.375276, 51.347399, 1.25],
          [3.375413, 51.347481, 1.25],
          [3.375428, 51.347488, 1.25],
          [3.375455, 51.347503, 1.5],
          [3.375493, 51.347529, 1.5],
          [3.377326, 51.348768, 2.25],
          [3.377536, 51.348888, 2.25],
          [3.377695, 51.349017, 2.25],
          [3.377722, 51.349038, 2.25],
          [3.377729, 51.349181, 2.25],
          [3.377726, 51.349252, 2.0],
          [3.377667, 51.349386, 2.0],
          [3.377597, 51.349460, 2.0],
          [3.377571, 51.349487, 2.0],
          [3.377549, 51.349504, 2.0],
          [3.377310, 51.349685, 2.0],
          [3.377287, 51.349703, 2.0],
          [3.377255, 51.349718, 2.0],
          [3.376856, 51.350021, 2.0],
          [3.375823, 51.350804, 0.75],
          [3.375769, 51.350849, 0.75],
          [3.375763, 51.350877, 0.75],
          [3.375776, 51.350897, 0.75],
          [3.374329, 51.351822, 0.75],
          [3.374173, 51.352131, 1.5],
          [3.374076, 51.352424, 1.75],
          [3.374061, 51.352731, 2.0],
          [3.374113, 51.352973, 2.0],
          [3.374490, 51.353726, 0.75],
          [3.374745, 51.354187, 0.25],
          [3.374767, 51.354303, 0.0],
          [3.374745, 51.354187, 0.25],
          [3.375041, 51.354699, 0.0],
          [3.375178, 51.355018, 0.0],
          [3.375305, 51.355372, -0.25],
          [3.375551, 51.356131, -0.25],
          [3.375732, 51.356380, 0.25],
          [3.375875, 51.356739, 1.25],
          [3.375885, 51.356766, 1.25],
          [3.375898, 51.356801, 1.5],
          [3.375989, 51.357045, 2.5],
          [3.376042, 51.357185, 3.0],
          [3.376139, 51.357295, 3.5],
          [3.376618, 51.357459, 4.75],
          [3.376852, 51.357552, 4.25],
          [3.377338, 51.357744, 3.25],
          [3.377605, 51.357866, 2.75],
          [3.377815, 51.357973, 2.25],
          [3.378004, 51.358079, 2.0],
          [3.378034, 51.358095, 2.0],
          [3.378116, 51.358117, 2.0],
          [3.378122, 51.358214, 2.0],
          [3.378205, 51.358326, 2.0],
          [3.378259, 51.358449, 2.0],
          [3.378277, 51.358530, 2.25],
          [3.378272, 51.358645, 2.25],
          [3.378271, 51.358681, 2.25],
          [3.378226, 51.358961, 2.75],
          [3.378019, 51.359688, 3.25],
          [3.377720, 51.361215, 2.75],
          [3.377697, 51.361518, 2.75],
          [3.377686, 51.361556, 2.75],
          [3.377627, 51.361627, 2.75],
          [3.377612, 51.361665, 2.75],
          [3.377579, 51.361825, 2.5],
          [3.377569, 51.361884, 2.5],
          [3.377574, 51.361917, 2.5],
          [3.377622, 51.361968, 2.5],
          [3.377586, 51.361995, 2.5],
          [3.377622, 51.361968, 2.5],
          [3.377719, 51.361960, 2.25],
          [3.377800, 51.361968, 2.25],
          [3.377853, 51.361976, 2.25],
          [3.377883, 51.362005, 2.25],
          [3.378083, 51.362441, 2.0],
          [3.378111, 51.362486, 2.0],
          [3.378185, 51.362789, 2.0],
          [3.378536, 51.364045, 2.0],
          [3.379521, 51.367909, 2.0],
          [3.379683, 51.368601, 1.25],
          [3.379741, 51.368828, 1.25],
          [3.379959, 51.369674, 1.25],
          [3.380538, 51.372129, 1.0],
          [3.380676, 51.372892, 1.75],
          [3.380732, 51.373135, 2.5],
          [3.380737, 51.373190, 2.5],
          [3.380720, 51.373215, 2.5],
          [3.380665, 51.373232, 2.75],
          [3.380854, 51.373901, 3.5],
          [3.380988, 51.374441, 4.0],
          [3.381128, 51.374961, 4.75],
          [3.381242, 51.375435, 5.75],
          [3.381365, 51.375947, 6.5],
          [3.381501, 51.376505, 7.75],
          [3.381584, 51.376915, 7.75],
          [3.381618, 51.377025, 7.75],
          [3.381672, 51.377124, 6.75],
          [3.381724, 51.377156, 6.75],
          [3.381723, 51.377223, 6.5],
          [3.381719, 51.377252, 6.5],
          [3.381694, 51.377277, 6.5],
          [3.381653, 51.377282, 6.5],
          [3.381694, 51.377277, 6.5],
          [3.381719, 51.377252, 6.5],
          [3.381723, 51.377223, 6.5],
          [3.381724, 51.377156, 6.75],
          [3.381809, 51.377170, 6.75],
          [3.382123, 51.377136, 6.75],
          [3.382309, 51.377118, 6.75],
          [3.382507, 51.377126, 6.75],
          [3.382581, 51.377156, 6.75],
          [3.382647, 51.377193, 6.5],
          [3.382818, 51.377322, 6.25],
          [3.382746, 51.377352, 6.25],
          [3.383013, 51.377658, 5.0],
          [3.383048, 51.377697, 5.0],
          [3.383104, 51.377766, 4.75],
          [3.383574, 51.377964, 4.25],
          [3.384316, 51.378299, 4.25],
          [3.384395, 51.378312, 4.5],
          [3.384491, 51.378319, 4.75],
          [3.385554, 51.378553, 4.75],
          [3.385716, 51.378598, 4.75],
          [3.385994, 51.378692, 4.75],
          [3.386221, 51.378757, 4.75],
          [3.386388, 51.378789, 4.75],
          [3.386690, 51.378841, 7.25],
          [3.386852, 51.378876, 7.0],
          [3.387215, 51.378936, 6.75],
          [3.387587, 51.378979, 6.5],
          [3.388015, 51.379017, 6.0],
          [3.388283, 51.379053, 5.75],
          [3.388426, 51.379085, 5.75],
          [3.388519, 51.379113, 5.75],
          [3.388850, 51.379232, 5.75],
          [3.389092, 51.379363, 5.75],
          [3.389335, 51.379485, 5.75],
          [3.389684, 51.379597, 5.75],
          [3.390438, 51.379733, 6.0],
          [3.390569, 51.379788, 6.25],
          [3.390733, 51.379836, 6.5],
          [3.390949, 51.379915, 6.75],
          [3.391261, 51.380014, 6.75],
          [3.391586, 51.380089, 6.75],
          [3.391900, 51.380184, 6.75],
          [3.392051, 51.380237, 6.75],
          [3.392184, 51.380295, 6.75],
          [3.392329, 51.380336, 6.75],
          [3.392595, 51.380425, 6.75],
          [3.393045, 51.380578, 8.25],
          [3.393166, 51.380619, 8.75],
          [3.393783, 51.380815, 10.5],
          [3.393906, 51.380841, 10.5],
          [3.394000, 51.380849, 10.5],
          [3.394439, 51.380834, 10.5],
          [3.394519, 51.380837, 10.5],
          [3.394629, 51.380858, 10.5],
          [3.395662, 51.381327, 10.5],
          [3.395762, 51.381356, 10.5],
          [3.395846, 51.381356, 10.5],
          [3.395987, 51.381324, 10.5],
          [3.396390, 51.381217, 10.5],
          [3.396745, 51.381297, 8.25],
          [3.396810, 51.381335, 8.0],
          [3.396917, 51.381415, 8.0],
          [3.397330, 51.381542, 8.0],
          [3.397424, 51.381566, 8.0],
          [3.397570, 51.381582, 8.0],
          [3.397828, 51.381587, 8.25],
          [3.397869, 51.381588, 8.25],
          [3.398066, 51.381618, 8.5],
          [3.398766, 51.381768, 8.5],
          [3.398987, 51.381828, 8.5],
          [3.399175, 51.381887, 8.5],
          [3.399329, 51.381924, 8.5],
          [3.399566, 51.381952, 8.5],
          [3.399741, 51.381957, 8.5],
          [3.400039, 51.381988, 8.5],
          [3.400457, 51.382022, 8.5],
          [3.401279, 51.382201, 8.5],
          [3.401715, 51.382353, 6.25],
          [3.402220, 51.382517, 6.25],
          [3.402442, 51.382532, 6.25],
          [3.403088, 51.382551, 6.25],
          [3.403236, 51.382563, 6.25],
          [3.403490, 51.382644, 6.25],
          [3.403747, 51.382712, 6.25],
          [3.403749, 51.382685, 6.25],
          [3.403747, 51.382712],
          [3.403956, 51.382750],
          [3.404363, 51.382848],
          [3.404736, 51.382927],
          [3.404878, 51.382951],
          [3.404996, 51.382985],
          [3.405124, 51.383031, 8.5],
          [3.405416, 51.383115, 8.5],
          [3.405762, 51.383152, 8.5],
          [3.405878, 51.383180, 8.5],
          [3.406900, 51.383475, 8.5],
          [3.407242, 51.383560, 8.5],
          [3.407350, 51.383580, 8.5],
          [3.407453, 51.383607, 8.5],
          [3.407767, 51.383720, 7.0],
          [3.408111, 51.383822, 7.5],
          [3.408452, 51.383908, 8.25],
          [3.408789, 51.383979, 8.25],
          [3.409207, 51.384091, 8.5],
          [3.409637, 51.384183, 8.5],
          [3.410017, 51.384299, 9.25],
          [3.410317, 51.384355, 9.25],
          [3.410659, 51.384450, 9.25],
          [3.410787, 51.384495, 9.5],
          [3.411158, 51.384676, 10.0],
          [3.411373, 51.384737, 10.0],
          [3.412172, 51.384915, 9.75],
          [3.412354, 51.384972, 10.0],
          [3.412762, 51.385131, 10.0],
          [3.412853, 51.385144, 10.0],
          [3.412960, 51.385173, 10.0],
          [3.413137, 51.385260, 10.0],
          [3.413486, 51.385448, 9.75],
          [3.413804, 51.385591, 9.0],
          [3.414080, 51.385688, 8.0],
          [3.414344, 51.385793, 7.0],
          [3.415324, 51.386239, 5.25],
          [3.415789, 51.386469, 6.0],
          [3.415898, 51.386537, 6.25],
          [3.416016, 51.386599, 6.25],
          [3.416138, 51.386651, 6.5],
          [3.416262, 51.386697, 6.5],
          [3.416677, 51.386818, 6.5],
          [3.416750, 51.386840, 6.5],
          [3.416870, 51.386888, 6.5],
          [3.417044, 51.386979, 6.5],
          [3.417354, 51.387171, 6.5],
          [3.417436, 51.387206, 6.5],
          [3.417467, 51.387219, 6.5],
          [3.417575, 51.387239, 4.5],
          [3.417686, 51.387270, 4.75],
          [3.417673, 51.387290, 4.5],
          [3.417686, 51.387270, 4.75],
          [3.417840, 51.387328, 5.25],
          [3.417927, 51.387398, 5.75],
          [3.418145, 51.387607, 5.75],
          [3.418429, 51.387890, 5.75],
          [3.418582, 51.387986, 5.75],
          [3.418872, 51.388126, 5.75],
          [3.419011, 51.388173, 5.75],
          [3.419163, 51.388198, 5.75],
          [3.419310, 51.388203, 5.75],
          [3.419788, 51.388200, 8.5],
          [3.419881, 51.388205, 9.0],
          [3.419972, 51.388221, 9.75],
          [3.420110, 51.388273, 10.0],
          [3.420494, 51.388478, 10.0],
          [3.420922, 51.388745, 10.0],
          [3.421002, 51.388773, 10.0],
          [3.421068, 51.388787, 10.0],
          [3.421543, 51.388856, 10.0],
          [3.421663, 51.388879, 10.0],
          [3.421778, 51.388919, 10.0],
          [3.421918, 51.388980, 10.0],
          [3.422084, 51.389058, 10.0],
          [3.422165, 51.389104, 10.0],
          [3.422243, 51.389153, 10.0],
          [3.422497, 51.389359, 10.0],
          [3.422570, 51.389407, 10.0],
          [3.422640, 51.389442, 10.0],
          [3.422787, 51.389511, 10.0],
          [3.422891, 51.389539, 10.0],
          [3.423034, 51.389556, 10.0],
          [3.423361, 51.389580, 10.0],
          [3.423696, 51.389586, 10.0],
          [3.423854, 51.389580, 10.0],
          [3.424325, 51.389521, 10.0],
          [3.424594, 51.389502, 10.0],
          [3.424773, 51.389501, 10.0],
          [3.424933, 51.389516, 10.0],
          [3.425076, 51.389538, 10.0],
          [3.425233, 51.389571, 10.0],
          [3.425424, 51.389630, 10.0],
          [3.425530, 51.389673, 10.0],
          [3.425734, 51.389771, 10.0],
          [3.426010, 51.389870, 10.0],
          [3.426206, 51.389922, 10.0],
          [3.426377, 51.389959, 10.0],
          [3.426551, 51.389988, 10.0],
          [3.426747, 51.390010, 10.0],
          [3.426930, 51.390018, 10.0],
          [3.427177, 51.390012, 10.0],
          [3.427566, 51.389978, 10.0],
          [3.427814, 51.389973, 10.0],
          [3.428155, 51.389987, 10.0],
          [3.428380, 51.390001, 10.0],
          [3.428554, 51.390025, 10.0],
          [3.428721, 51.390061, 10.0],
          [3.428822, 51.390094, 10.0],
          [3.429020, 51.390185, 10.0],
          [3.429110, 51.390216, 10.0],
          [3.429340, 51.390261, 10.0],
          [3.429421, 51.390266, 10.0],
          [3.429534, 51.390268, 10.0],
          [3.429937, 51.390207, 10.0],
          [3.430539, 51.390063, 10.0],
          [3.430654, 51.390035, 10.0],
          [3.431014, 51.389973, 4.5],
          [3.431269, 51.389918, 4.0],
          [3.431479, 51.389854, 3.75],
          [3.431824, 51.389715, 3.75],
          [3.431933, 51.389655, 3.75],
          [3.432041, 51.389579, 3.75],
          [3.432151, 51.389486, 3.75],
          [3.432317, 51.389294, 3.75],
          [3.432387, 51.389195, 3.75],
          [3.432457, 51.389067, 1.0],
          [3.432522, 51.388924, 1.0],
          [3.433317, 51.386731, 2.75],
          [3.433787, 51.385444, 1.5],
          [3.433920, 51.385070, 1.5],
          [3.433995, 51.384910, 1.5],
          [3.434087, 51.384796, 1.5],
          [3.434207, 51.384684, 1.5],
          [3.434373, 51.384572, 1.5],
          [3.434531, 51.384494, 1.75],
          [3.434726, 51.384428, 1.75],
          [3.434818, 51.384403, 2.0],
          [3.434928, 51.384382, 2.0],
          [3.435218, 51.384361, 2.0],
          [3.435993, 51.384344, 2.25],
          [3.436275, 51.384339, 2.5],
          [3.437596, 51.384331, 2.75],
          [3.439906, 51.384354, 1.75],
          [3.440816, 51.384347, 1.75],
          [3.440961, 51.384354, 1.75],
          [3.441294, 51.384396, 1.75],
          [3.441499, 51.384430, 1.5],
          [3.441691, 51.384472, 1.5],
          [3.443399, 51.384895, 2.5],
          [3.444341, 51.385127, 2.5],
          [3.446607, 51.385728, 3.5],
          [3.446793, 51.385788, 3.5],
          [3.446967, 51.385854, 3.5],
          [3.447087, 51.385911, 3.25],
          [3.447211, 51.385990, 3.25],
          [3.447312, 51.386068, 3.0],
          [3.447404, 51.386153, 3.0],
          [3.447484, 51.386250, 3.0],
          [3.447597, 51.386466, 2.75],
          [3.447639, 51.386697, 2.75],
          [3.447639, 51.386790, 2.75],
          [3.447618, 51.387020, 3.25],
          [3.447588, 51.387120, 3.25],
          [3.447625, 51.387231, 3.5],
          [3.447784, 51.387965, 4.0],
          [3.447776, 51.388067, 4.25],
          [3.447786, 51.388379, 4.5],
          [3.447822, 51.388691, 5.0],
          [3.447901, 51.388922, 5.25],
          [3.447942, 51.389009, 5.0],
          [3.447953, 51.389099, 5.25],
          [3.447964, 51.389129, 5.25],
          [3.447982, 51.389148, 5.0],
          [3.447933, 51.389166, 5.25],
          [3.447868, 51.389210, 5.5],
          [3.447855, 51.389253, 5.5],
          [3.447866, 51.389413, 5.25],
          [3.447908, 51.389508, 5.0],
          [3.447958, 51.389573, 5.0],
          [3.448076, 51.389658, 5.0],
          [3.448235, 51.389719, 5.0],
          [3.448386, 51.389764, 5.25],
          [3.448702, 51.389843, 5.25],
          [3.450443, 51.390247, 5.25],
          [3.452178, 51.390649, 5.25],
          [3.453196, 51.390884, 4.75],
          [3.453981, 51.391065, 4.75],
          [3.455123, 51.391338, 3.75],
          [3.455135, 51.391364, 4.0],
          [3.455172, 51.391390, 4.0],
          [3.456316, 51.391775, 4.5],
          [3.456429, 51.391832, 4.75],
          [3.456495, 51.391886, 4.75],
          [3.456578, 51.391946, 5.0],
          [3.457357, 51.392264, 5.25],
          [3.457660, 51.392601, 5.25],
          [3.457791, 51.392747, 5.25],
          [3.457951, 51.392892, 5.25],
          [3.458017, 51.392967, 5.25],
          [3.458251, 51.393302, 5.25],
          [3.458407, 51.393559, 5.25],
          [3.458441, 51.393606, 5.25],
          [3.458512, 51.393661, 5.25],
          [3.458613, 51.393724, 5.25],
          [3.458819, 51.393826, 5.25],
          [3.458915, 51.393862, 5.25],
          [3.459025, 51.393891, 5.25],
          [3.459123, 51.393908, 5.25],
          [3.459350, 51.393920, 5.25],
          [3.459457, 51.393917, 5.25],
          [3.459936, 51.393866, 5.25],
          [3.460020, 51.393865, 5.25],
          [3.460103, 51.393870, 5.25],
          [3.460270, 51.393896, 5.25],
          [3.460771, 51.394009, 5.25],
          [3.460947, 51.394040, 5.25],
          [3.461119, 51.394055, 5.25],
          [3.461330, 51.394063, 5.25],
          [3.462199, 51.394084, 5.25],
          [3.462444, 51.394072, 5.25],
          [3.462845, 51.394026, 5.25],
          [3.463150, 51.394004, 5.25],
          [3.463367, 51.394001, 5.25],
          [3.463553, 51.394012, 5.25],
          [3.463940, 51.394044, 5.25],
          [3.464437, 51.394173, 5.25],
          [3.464533, 51.394190, 5.25],
          [3.464645, 51.394201, 5.25],
          [3.465577, 51.394243, 5.25],
          [3.466076, 51.394282, 5.25],
          [3.466567, 51.394310, 5.25],
          [3.466768, 51.394338, 5.25],
          [3.467345, 51.394447, 5.25],
          [3.468128, 51.394537, 5.25],
          [3.468336, 51.394552, 5.25],
          [3.468600, 51.394551, 5.25],
          [3.468870, 51.394532, 5.25],
          [3.469061, 51.394516, 5.25],
          [3.469262, 51.394486, 5.25],
          [3.469456, 51.394439, 5.25],
          [3.469668, 51.394378, 5.25],
          [3.469777, 51.394354, 5.25],
          [3.469902, 51.394347, 5.25],
          [3.469997, 51.394357, 5.25],
          [3.470087, 51.394372, 5.25],
          [3.470252, 51.394414, 5.25],
          [3.470788, 51.394612, 5.25],
          [3.470946, 51.394683, 5.25],
          [3.472157, 51.395374, 5.25],
          [3.472360, 51.395467, 5.25],
          [3.472588, 51.395547, 5.25],
          [3.472796, 51.395601, 5.25],
          [3.472931, 51.395625, 5.25],
          [3.473041, 51.395633, 5.25],
          [3.473168, 51.395628, 5.25],
          [3.473492, 51.395568, 5.25],
          [3.473772, 51.395501, 5.25],
          [3.473865, 51.395488, 5.25],
          [3.473946, 51.395489, 5.25],
          [3.474200, 51.395539, 5.25],
          [3.474397, 51.395596, 5.25],
          [3.474577, 51.395639, 5.25],
          [3.475125, 51.395731, 5.25],
          [3.476531, 51.395942, 5.25],
          [3.476999, 51.395998, 5.25],
          [3.477121, 51.396007, 5.25],
          [3.477522, 51.396015, 5.25],
          [3.479359, 51.396024, 5.25],
          [3.480273, 51.396056, 5.25],
          [3.480778, 51.396152, 5.25],
          [3.481597, 51.396329, 5.25],
          [3.482350, 51.396500, 5.25],
          [3.482576, 51.396541, 5.25],
          [3.482579, 51.396542],
          [3.482678, 51.396567],
          [3.482732, 51.396595],
          [3.482766, 51.396623],
          [3.482814, 51.396680],
          [3.482903, 51.396844],
          [3.483071, 51.396974],
          [3.483187, 51.397044],
          [3.483336, 51.397112],
          [3.483470, 51.397157],
          [3.483595, 51.397185],
          [3.483878, 51.397232],
          [3.483980, 51.397263],
          [3.484130, 51.397326],
          [3.484508, 51.397504],
          [3.484749, 51.397599],
          [3.484851, 51.397655],
          [3.485167, 51.397757],
          [3.485643, 51.397900],
          [3.485845, 51.397949],
          [3.485972, 51.397970],
          [3.486064, 51.397972],
          [3.486154, 51.397968],
          [3.486330, 51.397943],
          [3.486858, 51.397817],
          [3.486917, 51.397806],
          [3.486971, 51.397804],
          [3.488067, 51.398163],
          [3.490423, 51.398969],
          [3.491018, 51.399165, 2.5],
          [3.492023, 51.399482, 2.5],
          [3.492216, 51.399544, 2.5],
          [3.492333, 51.399596, 2.5],
          [3.492384, 51.399630, 2.5],
          [3.492461, 51.399713, 2.5],
          [3.492587, 51.399925, 2.5],
          [3.492650, 51.399990, 2.5],
          [3.492781, 51.400082, 2.5],
          [3.492893, 51.400136, 2.5],
          [3.493491, 51.400363, 2.5],
          [3.494306, 51.400627, 2.5],
          [3.494487, 51.400702, 2.5],
          [3.494792, 51.400856, 2.5],
          [3.494874, 51.400891, 2.5],
          [3.494998, 51.400932, 2.5],
          [3.495081, 51.400951, 2.5],
          [3.495533, 51.401025, 2.5],
          [3.495771, 51.401073, 2.5],
          [3.495843, 51.401100, 2.5],
          [3.496259, 51.401311, 2.5],
          [3.496921, 51.401548, 2.5],
          [3.497081, 51.401593, 2.5],
          [3.497185, 51.401606, 2.5],
          [3.498031, 51.401621, 2.5],
          [3.498642, 51.401594, 3.75],
          [3.498687, 51.401591, 3.75],
          [3.499152, 51.401554, 3.5],
          [3.499298, 51.401554, 3.5],
          [3.499998, 51.401611, 4.5],
          [3.502273, 51.401743, 2.25],
          [3.502366, 51.401751, 2.25],
          [3.502513, 51.401787, 2.25],
          [3.502657, 51.401825, 2.0],
          [3.502747, 51.401878, 2.0],
          [3.502814, 51.401953, 2.25],
          [3.502846, 51.402045, 2.25],
          [3.502845, 51.402069, 2.25],
          [3.502844, 51.402204, 2.75],
          [3.502757, 51.402530, 3.5],
          [3.502670, 51.402710, 3.75],
          [3.502528, 51.402827, 3.75],
          [3.502434, 51.402919, 4.0],
          [3.502412, 51.403018, 4.0],
          [3.502463, 51.403115, 4.0],
          [3.502995, 51.403921, 4.5],
          [3.503161, 51.404027, 5.0],
          [3.503292, 51.404174, 5.75],
          [3.503343, 51.404326, 5.5],
          [3.503330, 51.404823, 4.25],
          [3.503335, 51.405082, 3.75],
          [3.503370, 51.405161, 3.5],
          [3.503451, 51.405226, 3.25],
          [3.503587, 51.405263, 2.75],
          [3.504224, 51.405302, 1.75],
          [3.505366, 51.405333, 0.5],
          [3.505744, 51.405372, 0.75],
          [3.505985, 51.405445, 1.0],
          [3.506095, 51.405517, 1.25],
          [3.506174, 51.405569, 1.5],
          [3.506509, 51.405830, 2.75],
          [3.506650, 51.405885, 2.75],
          [3.507260, 51.405980, 2.75],
          [3.509341, 51.406130, 2.75],
          [3.509589, 51.406156, 2.75],
          [3.509787, 51.406163, 2.75],
          [3.509994, 51.406101, 2.75],
          [3.510068, 51.406093, 2.75],
          [3.510399, 51.406098, 2.75],
          [3.510565, 51.406080, 2.75],
          [3.510742, 51.406031, 2.75],
          [3.510874, 51.406011, 1.75],
          [3.511015, 51.406029, 1.5],
          [3.511122, 51.406061, 1.5],
          [3.511503, 51.406195, 1.25],
          [3.511779, 51.406236, 1.5],
          [3.512071, 51.406260, 1.75],
          [3.512279, 51.406252, 1.75],
          [3.512517, 51.406209, 1.75],
          [3.512631, 51.406195, 2.0],
          [3.512767, 51.406187, 2.0],
          [3.513030, 51.406195, 2.5],
          [3.513137, 51.406212, 2.5],
          [3.513249, 51.406241, 2.75],
          [3.513515, 51.406299, 2.75],
          [3.513729, 51.406323, 2.75],
          [3.514041, 51.406323, 2.5],
          [3.514166, 51.406311, 2.5],
          [3.514290, 51.406290, 2.25],
          [3.514416, 51.406257, 2.25],
          [3.514567, 51.406225, 2.0],
          [3.514625, 51.406220, 2.0],
          [3.514706, 51.406230, 2.0],
          [3.514834, 51.406272, 2.0],
          [3.514971, 51.406336, 2.0],
          [3.515138, 51.406394, 2.0],
          [3.515379, 51.406435, 2.0],
          [3.515627, 51.406446, 2.0],
          [3.515774, 51.406467, 2.0],
          [3.515909, 51.406496, 1.75],
          [3.516228, 51.406541, 1.75],
          [3.516554, 51.406561, 1.75],
          [3.516921, 51.406574, 1.75],
          [3.517346, 51.406569, 1.75],
          [3.517801, 51.406552, 1.75],
          [3.518125, 51.406560, 1.75],
          [3.518414, 51.406576, 1.75],
          [3.518878, 51.406656, 1.75],
          [3.519031, 51.406669, 1.75],
          [3.519565, 51.406663, 2.25],
          [3.519782, 51.406677, 2.25],
          [3.519997, 51.406678, 2.25],
          [3.520373, 51.406652, 2.75],
          [3.520683, 51.406645, 2.75],
          [3.521094, 51.406659, 3.25],
          [3.521294, 51.406655, 3.5],
          [3.521459, 51.406643, 3.5],
          [3.522837, 51.406400, 1.25],
          [3.523160, 51.406322, 0.75],
          [3.523515, 51.406250, 0.75],
          [3.524300, 51.406092, 0.75],
          [3.524381, 51.406071, 0.75],
          [3.525206, 51.405893, 0.75],
          [3.525794, 51.405763, 0.75],
          [3.525921, 51.405760, 0.75],
          [3.526030, 51.405777, 0.75],
          [3.526140, 51.405804, 0.75],
          [3.526300, 51.405812, 0.75],
          [3.526781, 51.405791, 0.75],
          [3.527057, 51.405778, 0.75],
          [3.527441, 51.405805, 0.75],
          [3.528210, 51.405857, 0.75],
          [3.528425, 51.405842, 0.75],
          [3.529072, 51.405642, 0.75],
          [3.529250, 51.405584, 0.75],
          [3.529580, 51.405510, 0.75],
          [3.530119, 51.405431, 0.75],
          [3.530463, 51.405382],
          [3.530906, 51.405338],
          [3.531410, 51.405316],
          [3.531904, 51.405311],
          [3.532270, 51.405270],
          [3.532717, 51.405213],
          [3.533634, 51.405138],
          [3.534272, 51.405099],
          [3.534520, 51.405075],
          [3.534784, 51.405041],
          [3.535081, 51.405016],
          [3.535650, 51.404956, 6.5],
          [3.536233, 51.404875, 6.0],
          [3.537205, 51.404779, 6.0],
          [3.538312, 51.404695, 6.25],
          [3.538980, 51.404637, 5.25],
          [3.539091, 51.404628, 5.25],
          [3.539682, 51.404631, 4.25],
          [3.539749, 51.404601, 4.0],
          [3.540154, 51.404810, 4.5],
          [3.540389, 51.405054, 4.5],
          [3.540582, 51.405233, 4.5],
          [3.540744, 51.405330, 4.5],
          [3.540898, 51.405385, 4.5],
          [3.541476, 51.405499, 4.5],
          [3.541716, 51.405500, 4.5],
          [3.542000, 51.405509, 4.5],
          [3.542297, 51.405476, 4.5],
          [3.542737, 51.405388, 4.5],
          [3.543464, 51.405203, 4.5],
          [3.543716, 51.405110, 4.5],
          [3.544198, 51.404775, 4.5],
          [3.544797, 51.404301, 4.5],
          [3.544938, 51.404230, 4.5],
          [3.545039, 51.404200, 4.5],
          [3.545175, 51.404178, 4.5],
          [3.545256, 51.404174, 4.5],
          [3.545348, 51.404170],
          [3.545505, 51.404172],
          [3.545702, 51.404152],
          [3.545928, 51.404082],
          [3.546072, 51.403959],
          [3.546111, 51.403924],
          [3.546164, 51.403838],
          [3.546156, 51.403607],
          [3.546167, 51.403371],
          [3.546159, 51.403225],
          [3.546210, 51.403081],
          [3.546379, 51.402953],
          [3.546393, 51.402847],
          [3.546245, 51.402643],
          [3.546155, 51.402408, 1.25],
          [3.546151, 51.402248, 1.5],
          [3.546183, 51.402076, 1.75],
          [3.546422, 51.401748, 2.0],
          [3.546738, 51.401486, 2.5],
          [3.547592, 51.401076, 3.25],
          [3.547651, 51.401049, 3.5],
          [3.547764, 51.401096, 3.5],
          [3.547893, 51.401121, 3.5],
          [3.548022, 51.401221, 3.25],
          [3.547998, 51.401232, 3.25],
          [3.548357, 51.401510, 3.25],
          [3.547998, 51.401232, 3.25],
          [3.548022, 51.401221, 3.25],
          [3.548067, 51.401199, 3.25],
          [3.548559, 51.401587, 3.25],
          [3.548672, 51.401708, 3.25],
          [3.563905, 51.419015, 3.25],
          [3.581328, 51.430147, 3.25],
          [3.601670, 51.439082, 3.25],
          [3.602035, 51.440166, 3.25],
          [3.599482, 51.443747, 3.25],
          [3.598619, 51.444091, 3.25],
          [3.597974, 51.444105, 0.0],
          [3.597193, 51.444076, 0.25],
          [3.597135, 51.444072, 0.25],
          [3.596985, 51.444064, 0.25],
          [3.596782, 51.444054, 0.25],
          [3.596743, 51.443986, 0.25],
          [3.596741, 51.443931, 0.5],
          [3.596668, 51.443855, 0.5],
          [3.596576, 51.443783, 0.75],
          [3.596485, 51.443735, 1.0],
          [3.596377, 51.443696, 1.0],
          [3.596237, 51.443662, 1.25],
          [3.595835, 51.443613, 1.25],
          [3.595782, 51.443560, 1.25],
          [3.595778, 51.443508, 1.0],
          [3.595773, 51.443453, 1.0],
          [3.595761, 51.443426, 1.0],
          [3.595682, 51.443346, 1.0],
          [3.595615, 51.443178, 1.0],
          [3.595593, 51.443123, 1.0],
          [3.595547, 51.443055, 1.0],
          [3.595544, 51.443049, 1.0],
          [3.595007, 51.443184, 1.0],
          [3.594635, 51.443281, 0.5],
          [3.594617, 51.443286, 0.5],
          [3.594592, 51.443254, 0.5],
          [3.594581, 51.443236, 0.5],
          [3.594515, 51.443194, 0.5],
          [3.594516, 51.443146, 0.5],
          [3.594548, 51.443127, 0.5],
          [3.594565, 51.443116, 0.5],
          [3.594602, 51.443095, 0.5],
          [3.594487, 51.443081, 0.5],
          [3.594479, 51.443080, 0.5],
          [3.594339, 51.442993, 0.5],
          [3.594326, 51.442862, 0.5],
          [3.594324, 51.442849, 0.5],
          [3.594319, 51.442777, 0.5],
          [3.594319, 51.442777, 0.5],
          [3.596218, 51.442291, 0.5],
          [3.596206, 51.442271, 0.5],
          [3.595921, 51.441795, 1.25],
          [3.595908, 51.441772, 1.5],
          [3.595917, 51.441664, 1.75],
          [3.595949, 51.441575, 1.5],
          [3.596000, 51.441499, 1.0],
          [3.596114, 51.441377, 0.5],
          [3.596085, 51.441389, 0.5],
          [3.596114, 51.441377, 0.5],
          [3.596210, 51.441342, 0.25],
          [3.596390, 51.441262, 0.0],
          [3.596363, 51.441175, 0.0],
          [3.596288, 51.441089, 0.0],
          [3.596101, 51.441037, 0.0],
          [3.596021, 51.441019, 0.0],
          [3.595736, 51.440923, 0.0],
          [3.595229, 51.440675, 0.0],
          [3.595156, 51.440658, 0.0],
          [3.595012, 51.440624],
          [3.594893, 51.440608],
          [3.594790, 51.440601],
          [3.594660, 51.440609],
          [3.594443, 51.440641],
          [3.594346, 51.440665],
          [3.594200, 51.440734],
          [3.593724, 51.441013, 2.0],
          [3.593698, 51.441023, 2.0],
          [3.593002, 51.441286, 3.75],
          [3.592606, 51.441417, 4.25],
          [3.592562, 51.441427, 4.25],
          [3.592211, 51.441506, 4.25],
          [3.591156, 51.441699, 3.5],
          [3.590939, 51.441739, 3.75],
          [3.590720, 51.441758, 3.75],
          [3.590394, 51.441777, 3.75],
          [3.589844, 51.441771, 3.75],
          [3.589354, 51.441725, 3.25],
          [3.586405, 51.441288, 2.75],
          [3.584602, 51.441029, 3.25],
          [3.584358, 51.440999, 2.75],
          [3.584047, 51.440940, 2.25],
          [3.583379, 51.440826, 2.25],
          [3.582902, 51.440753, 2.25],
          [3.582580, 51.440723, 2.25],
          [3.582523, 51.440713, 2.25],
          [3.582517, 51.440713, 2.25],
          [3.582413, 51.440715],
          [3.582266, 51.440704],
          [3.581917, 51.440662],
          [3.581528, 51.440634],
          [3.581288, 51.440606],
          [3.581116, 51.440587],
          [3.581091, 51.440587],
          [3.580997, 51.440588],
          [3.580821, 51.440644, 2.5],
          [3.580672, 51.440703, 2.5],
          [3.580312, 51.440806, 2.75],
          [3.580045, 51.440885, 3.0],
          [3.579965, 51.440889, 3.0],
          [3.579828, 51.440871, 3.25],
          [3.579460, 51.440792, 3.75],
          [3.579451, 51.440790, 4.0],
          [3.579426, 51.440820, 4.25],
          [3.579212, 51.440778, 4.25],
          [3.576931, 51.440339, 5.0],
          [3.576874, 51.440328, 5.25],
          [3.576870, 51.440332, 5.25],
          [3.576732, 51.440481, 5.25],
          [3.576721, 51.440500, 5.25],
          [3.576710, 51.440518, 5.25],
          [3.576704, 51.440517, 5.0],
          [3.576710, 51.440518, 5.25],
          [3.576915, 51.440557, 5.0],
          [3.577338, 51.440637, 5.25],
          [3.577484, 51.440700, 5.5],
          [3.578277, 51.440853, 6.75],
          [3.578543, 51.440897, 6.25],
          [3.578701, 51.440936, 5.75],
          [3.578710, 51.440925, 5.75],
          [3.578701, 51.440936, 5.75],
          [3.578279, 51.441399, 4.75],
          [3.578234, 51.441448, 4.5],
          [3.578172, 51.441519, 4.25],
          [3.578193, 51.441520, 4.25],
          [3.578172, 51.441519, 4.25],
          [3.578125, 51.441536, 4.0],
          [3.578057, 51.441584, 3.75],
          [3.578005, 51.441648, 3.5],
          [3.577812, 51.442185, 4.25],
          [3.577808, 51.442199, 4.5],
          [3.577135, 51.442103, 3.75],
          [3.577030, 51.442079, 3.5],
          [3.576785, 51.441985, 3.25],
          [3.576089, 51.441601, 3.25],
          [3.575824, 51.441456, 3.5],
          [3.575023, 51.440988, 1.75],
          [3.574871, 51.440906, 1.5],
          [3.574759, 51.440862, 1.5],
          [3.574635, 51.440825, 1.75],
          [3.574249, 51.440697, 3.0],
          [3.574213, 51.440670, 3.25],
          [3.574163, 51.440605, 3.5],
          [3.574161, 51.440589, 3.5],
          [3.574158, 51.440543, 3.5],
          [3.574231, 51.440431, 3.75],
          [3.574293, 51.440369, 3.75],
          [3.574506, 51.440119, 3.75],
          [3.574690, 51.439890, 3.0],
          [3.574803, 51.439791, 2.0],
          [3.574778, 51.439801, 2.0],
          [3.574803, 51.439791, 2.0],
          [3.574867, 51.439776, 1.75],
          [3.574921, 51.439764, 1.5],
          [3.575103, 51.439751, 1.5],
          [3.575133, 51.439750, 1.5],
          [3.575304, 51.439624, 1.25],
          [3.575298, 51.439599, 1.0],
          [3.575292, 51.439579, 0.75],
          [3.575263, 51.439559, 0.75],
          [3.575242, 51.439547, 0.5],
          [3.575224, 51.439536, 0.5],
          [3.575174, 51.439520, 0.25],
          [3.575125, 51.439520, 0.25],
          [3.575078, 51.439529, 0.25],
          [3.575054, 51.439534, 0.25],
          [3.574979, 51.439574, 0.25],
          [3.574784, 51.439695, 1.5],
          [3.574423, 51.440001, 4.25],
          [3.574327, 51.440058, 4.25],
          [3.574314, 51.440067, 4.25],
          [3.572232, 51.440400, 4.0],
          [3.570840, 51.440631, 2.5],
          [3.570609, 51.440683, 2.5],
          [3.570288, 51.440801, 2.5],
          [3.570250, 51.440821, 2.25],
          [3.570219, 51.440838, 2.25],
          [3.570155, 51.440890, 2.25],
          [3.570085, 51.440968, 2.5],
          [3.569622, 51.441756, 3.5],
          [3.569602, 51.441816, 3.5],
          [3.569604, 51.441862, 3.5],
          [3.569610, 51.441985, 3.75],
          [3.569575, 51.442091, 3.75],
          [3.569468, 51.442226, 3.75],
          [3.569402, 51.442273, 3.5],
          [3.569321, 51.442318, 3.25],
          [3.569239, 51.442377, 3.0],
          [3.569171, 51.442437, 2.75],
          [3.568568, 51.443329, 3.25],
          [3.568569, 51.443335, 3.25],
          [3.568629, 51.443648, 5.0],
          [3.568521, 51.443795, 6.0],
          [3.568386, 51.443852, 6.5],
          [3.568170, 51.443929, 6.75],
          [3.567734, 51.444114, 6.25],
          [3.567654, 51.444149, 6.25],
          [3.564731, 51.445658, 6.25],
          [3.563950, 51.446065, 8.5],
          [3.563636, 51.446248, 8.0],
          [3.562951, 51.446651, 8.0],
          [3.562846, 51.446738, 8.25],
          [3.562621, 51.446936, 7.0],
          [3.562519, 51.447029, 6.75],
          [3.561645, 51.448184, 6.75],
          [3.561480, 51.448441, 9.75],
          [3.561156, 51.448677, 7.25],
          [3.560773, 51.448939, 6.5],
          [3.560335, 51.449181, 8.0],
          [3.559930, 51.449373, 8.75],
          [3.559426, 51.449584, 7.75],
          [3.558674, 51.449869, 8.0],
          [3.558221, 51.450085, 7.75],
          [3.557963, 51.450188, 6.25],
          [3.557435, 51.450296, 4.0],
          [3.557303, 51.450346, 3.75],
          [3.557245, 51.450450, 3.25],
          [3.557208, 51.450621, 3.0],
          [3.556757, 51.450625, 2.25],
          [3.556373, 51.450630, 2.0],
          [3.556357, 51.450586, 2.0],
          [3.556347, 51.450571, 2.0],
          [3.556293, 51.450519, 2.0],
          [3.556202, 51.450546, 1.75],
          [3.556123, 51.450559, 1.75],
          [3.556076, 51.450557, 1.5],
          [3.555703, 51.450483, 1.25],
          [3.555526, 51.450442, 1.25],
          [3.555171, 51.450340, 1.25],
          [3.554574, 51.450152, 2.75],
          [3.554495, 51.450139, 2.75],
          [3.554409, 51.450134, 3.0],
          [3.554286, 51.450141, 3.25],
          [3.554244, 51.450144, 3.5],
          [3.554117, 51.450192, 3.75],
          [3.554023, 51.450238, 3.75],
          [3.553831, 51.450363, 4.0],
          [3.553594, 51.450529, 4.25],
          [3.552772, 51.451134, 4.25],
          [3.552469, 51.451332, 4.25],
          [3.552237, 51.451434, 4.5],
          [3.551676, 51.451652, 4.75],
          [3.550314, 51.452138, 0.25],
          [3.550020, 51.452192, 0.0],
          [3.549673, 51.452252, 0.25],
          [3.548465, 51.452456, 1.0],
          [3.548330, 51.452470, 0.75],
          [3.548163, 51.452470, 0.75],
          [3.547841, 51.452500, 0.25],
          [3.547624, 51.452529, 0.0],
          [3.547533, 51.452551, 0.0],
          [3.547357, 51.452590, 0.0],
          [3.547248, 51.452625, 0.0],
          [3.547103, 51.452687, 0.0],
          [3.547030, 51.452729, 0.0],
          [3.546546, 51.453069, 0.0],
          [3.545797, 51.453596, -0.25],
          [3.545405, 51.453854, 0.0],
          [3.544760, 51.454291, 1.75],
          [3.544438, 51.454465, 1.75],
          [3.544056, 51.454636, 2.0],
          [3.543703, 51.454726, 2.0],
          [3.543374, 51.454798, 2.25],
          [3.543103, 51.454819, 2.0],
          [3.542730, 51.454968, 2.0],
          [3.542609, 51.455052, 2.0],
          [3.542479, 51.455165, 2.0],
          [3.542395, 51.455228, 2.0],
          [3.541859, 51.455500, 2.75],
          [3.541761, 51.455534, 2.75],
          [3.541044, 51.455734, 2.75],
          [3.540956, 51.455764, 2.75],
          [3.540849, 51.455811, 2.75],
          [3.540770, 51.455865, 2.0],
          [3.540720, 51.455930, 2.0],
          [3.540668, 51.456014, 2.25],
          [3.540472, 51.456334, 3.5],
          [3.540414, 51.456381, 3.75],
          [3.540311, 51.456448, 4.0],
          [3.540160, 51.456589, 4.5],
          [3.540034, 51.456722, 4.75],
          [3.539992, 51.456786, 4.5],
          [3.539893, 51.457052, 4.0],
          [3.539847, 51.457136, 3.75],
          [3.539657, 51.457294, 3.75],
          [3.538982, 51.457737, 4.0],
          [3.538961, 51.457762, 4.0],
          [3.538961, 51.457807, 3.75],
          [3.538999, 51.457860, 3.5],
          [3.538898, 51.457898, 3.25],
          [3.538163, 51.458183, 3.0],
          [3.537597, 51.458347, 3.5],
          [3.537468, 51.458386, 3.75],
          [3.536888, 51.458839, 1.75],
          [3.536063, 51.459360, 0.0],
          [3.535747, 51.459485, 0.0],
          [3.535569, 51.459568, 0.0],
          [3.534529, 51.460078, 1.25],
          [3.534025, 51.460446, 1.5],
          [3.533684, 51.460568, 1.75],
          [3.533358, 51.460751, 2.0],
          [3.533037, 51.460881, 2.0],
          [3.532871, 51.460997, 2.0],
          [3.532760, 51.461068, 2.0],
          [3.532542, 51.461141, 2.0],
          [3.532342, 51.461199, 2.0],
          [3.532223, 51.461236, 2.0],
          [3.532154, 51.461306, 2.0],
          [3.532019, 51.461479, 1.75],
          [3.531760, 51.461719, 1.75],
          [3.531595, 51.461853, 1.75],
          [3.531326, 51.461992, 2.5],
          [3.531088, 51.462149, 2.5],
          [3.530354, 51.462610, 2.25],
          [3.530110, 51.462793, 2.5],
          [3.529927, 51.462959, 2.5],
          [3.529787, 51.463061, 2.75],
          [3.529606, 51.463167, 3.0],
          [3.529360, 51.463284, 3.5],
          [3.529219, 51.463362, 3.75],
          [3.529045, 51.463498, 3.75],
          [3.528934, 51.463598, 4.0],
          [3.528849, 51.463713, 4.0],
          [3.528830, 51.463673, 4.0],
          [3.528849, 51.463713, 4.0],
          [3.528520, 51.463671, 4.5],
          [3.528441, 51.463678, 4.75],
          [3.528321, 51.463761, 5.0],
          [3.528137, 51.463919, 5.5],
          [3.528022, 51.464167, 6.25],
          [3.527969, 51.464291, 6.25],
          [3.527943, 51.464428, 6.25],
          [3.527951, 51.464580, 6.0],
          [3.527971, 51.464840, 5.25],
          [3.527945, 51.465162, 5.0],
          [3.527823, 51.465442, 5.75],
          [3.527593, 51.465683, 6.75],
          [3.527327, 51.465905, 7.25],
          [3.526969, 51.466151, 7.0],
          [3.526546, 51.466404, 6.0],
          [3.525056, 51.467185, 6.75],
          [3.524392, 51.467476, 6.25],
          [3.524263, 51.467574, 6.25],
          [3.524234, 51.467597, 6.5],
          [3.524095, 51.467747, 6.75],
          [3.524050, 51.467786, 6.75],
          [3.523626, 51.468438, 7.25],
          [3.523274, 51.468977, 5.0],
          [3.523067, 51.469183, 4.75],
          [3.522945, 51.469304, 5.0],
          [3.522297, 51.469996, 6.75],
          [3.522225, 51.470114, 6.75],
          [3.522281, 51.470193, 6.25],
          [3.522413, 51.470242, 5.5],
          [3.522459, 51.470259, 5.5],
          [3.522431, 51.470334, 5.25],
          [3.522387, 51.470455, 5.0],
          [3.522190, 51.470570, 5.25],
          [3.521990, 51.470790, 4.75],
          [3.521840, 51.471370, 3.5],
          [3.521804, 51.471462, 3.25],
          [3.521570, 51.472060, 4.25],
          [3.521300, 51.472440, 6.5],
          [3.520985, 51.472852, 7.0],
          [3.520931, 51.472918, 7.0],
          [3.520866, 51.473037, 6.75],
          [3.520841, 51.473171, 6.5],
          [3.520845, 51.473362, 5.75],
          [3.520941, 51.473558, 5.25],
          [3.521129, 51.473637, 4.5],
          [3.521346, 51.473686, 3.75],
          [3.520901, 51.473617, 5.25],
          [3.520664, 51.473625, 5.75],
          [3.520674, 51.473518, 5.75],
          [3.520664, 51.473625, 5.75],
          [3.520901, 51.473617, 5.25],
          [3.521346, 51.473686, 3.75],
          [3.522445, 51.473872, 2.25],
          [3.522861, 51.473963, 1.5],
          [3.522946, 51.473982, 1.5],
          [3.522852, 51.474170, 1.5],
          [3.522733, 51.474279, 1.5],
          [3.522483, 51.474789, 2.0],
          [3.522212, 51.475328, 2.75],
          [3.522189, 51.475350, 2.75],
          [3.522171, 51.475368, 3.0],
          [3.522094, 51.475406, 3.0],
          [3.521693, 51.475522, 4.0],
          [3.521320, 51.475661, 5.0],
          [3.520983, 51.475732, 5.5],
          [3.520914, 51.475746, 5.5],
          [3.520894, 51.475755, 5.5],
          [3.520833, 51.475786, 5.75],
          [3.520802, 51.475830, 5.75],
          [3.520776, 51.476050, 5.5],
          [3.520729, 51.476168, 5.5],
          [3.520535, 51.476370, 5.25],
          [3.520392, 51.476556, 5.0],
          [3.520369, 51.476700, 4.75],
          [3.520399, 51.477037, 4.5],
          [3.520410, 51.477158, 4.5],
          [3.520402, 51.478150, 5.25],
          [3.520370, 51.478528, 4.75],
          [3.520244, 51.478877, 3.75],
          [3.520162, 51.478920, 3.75],
          [3.520122, 51.478929, 3.75],
          [3.520016, 51.478952, 3.75],
          [3.519985, 51.478986, 3.5],
          [3.519924, 51.479061, 3.25],
          [3.519714, 51.479053, 3.5],
          [3.519569, 51.479201, 3.25],
          [3.519093, 51.479814, 3.25],
          [3.518971, 51.479992, 3.25],
          [3.518793, 51.480252, 3.25],
          [3.518231, 51.481161, 2.25],
          [3.517629, 51.482051, 2.0],
          [3.517474, 51.482115, 2.25],
          [3.517463, 51.482120, 2.5],
          [3.517353, 51.482175, 2.5],
          [3.516996, 51.482300, 3.25],
          [3.516591, 51.482475, 4.0],
          [3.516417, 51.482602, 4.0],
          [3.516226, 51.482826, 3.5],
          [3.515996, 51.483179, 3.0],
          [3.515448, 51.484087, 3.25],
          [3.515076, 51.484508, 4.0],
          [3.514893, 51.484742, 4.75],
          [3.514907, 51.484839, 4.75],
          [3.514899, 51.484854, 4.75],
          [3.514780, 51.484938, 5.0],
          [3.514643, 51.485151, 5.0],
          [3.514584, 51.485212, 4.75],
          [3.514422, 51.485284, 4.75],
          [3.514153, 51.485407, 5.0],
          [3.513888, 51.485438, 5.0],
          [3.513555, 51.485419, 5.25],
          [3.513310, 51.485462, 5.25],
          [3.513183, 51.485493, 5.5],
          [3.513085, 51.485724, 5.25],
          [3.513001, 51.485955, 5.25],
          [3.512898, 51.486232, 5.5],
          [3.512817, 51.486486, 5.75],
          [3.512661, 51.486754, 5.75],
          [3.511922, 51.487137, 5.5],
          [3.511235, 51.487624, 5.25],
          [3.510478, 51.488108, 6.5],
          [3.510184, 51.488171, 7.0],
          [3.509830, 51.488190, 7.75],
          [3.509575, 51.488204, 8.5],
          [3.509303, 51.488242, 9.0],
          [3.508669, 51.488525, 8.5],
          [3.507691, 51.488946, 7.25],
          [3.507430, 51.489052, 6.5],
          [3.507335, 51.489079, 6.5],
          [3.507079, 51.489112, 6.25],
          [3.506802, 51.489206, 5.75],
          [3.506288, 51.489463, 7.5],
          [3.506090, 51.489498, 8.75],
          [3.506051, 51.489578, 8.75],
          [3.505870, 51.489679, 9.5],
          [3.505824, 51.489858, 8.75],
          [3.505762, 51.490310, 7.0],
          [3.505698, 51.490416, 7.0],
          [3.505626, 51.490500, 6.75],
          [3.505449, 51.490666, 6.75],
          [3.505257, 51.490735, 6.75],
          [3.505129, 51.490745, 7.25],
          [3.504524, 51.490730, 10.25],
          [3.504280, 51.490753, 11.25],
          [3.504032, 51.490798, 11.75],
          [3.503784, 51.490854, 12.25],
          [3.503621, 51.490933, 12.25],
          [3.503422, 51.491016, 12.5],
          [3.502958, 51.491173, 15.25],
          [3.502826, 51.491245, 16.25],
          [3.502772, 51.491318, 16.5],
          [3.502599, 51.491657, 17.75],
          [3.502422, 51.491977, 17.5],
          [3.502368, 51.492051, 17.25],
          [3.502210, 51.492196, 17.5],
          [3.502122, 51.492290, 17.5],
          [3.502052, 51.492393, 17.0],
          [3.501952, 51.492586, 16.0],
          [3.501587, 51.492905, 14.75],
          [3.501404, 51.493103, 14.25],
          [3.501274, 51.493264, 13.75],
          [3.501146, 51.493442, 13.5],
          [3.501042, 51.493651, 12.75],
          [3.501017, 51.493792, 11.75],
          [3.500949, 51.494071, 10.0],
          [3.500901, 51.494184, 9.25],
          [3.500839, 51.494294, 9.25],
          [3.500758, 51.494394, 9.25],
          [3.500569, 51.494597, 9.0],
          [3.500378, 51.494780, 8.75],
          [3.500196, 51.494929, 8.75],
          [3.500180, 51.494942, 8.5],
          [3.500001, 51.495103, 8.5],
          [3.499820, 51.495285, 9.25],
          [3.499718, 51.495349, 10.0],
          [3.499429, 51.495577, 11.0],
          [3.499357, 51.495646, 11.0],
          [3.499314, 51.495702, 11.0],
          [3.499286, 51.495765, 10.75],
          [3.499253, 51.496126, 8.25],
          [3.499234, 51.496194, 8.0],
          [3.499117, 51.496415, 6.75],
          [3.499009, 51.496530, 6.0],
          [3.498797, 51.496673, 4.75],
          [3.498633, 51.496751, 4.5],
          [3.498350, 51.496860, 4.25],
          [3.498184, 51.496908, 4.75],
          [3.497923, 51.496965, 5.5],
          [3.497808, 51.496999, 6.0],
          [3.497610, 51.497093, 6.25],
          [3.497467, 51.497192, 6.5],
          [3.497405, 51.497248, 6.5],
          [3.497206, 51.497509, 5.5],
          [3.497062, 51.497633, 5.5],
          [3.496823, 51.497803, 5.25],
          [3.496675, 51.497890, 5.0],
          [3.496277, 51.498133, 6.25],
          [3.496040, 51.498306, 6.0],
          [3.495977, 51.498351, 6.25],
          [3.495464, 51.498423, 8.25],
          [3.494161, 51.498590, 8.75],
          [3.493870, 51.498604, 8.5],
          [3.493483, 51.498607, 8.25],
          [3.493037, 51.498623, 8.25],
          [3.492207, 51.498681, 8.0],
          [3.491483, 51.498722, 7.5],
          [3.490686, 51.498791, 6.0],
          [3.490447, 51.498806, 5.75],
          [3.490117, 51.498812, 5.5],
          [3.489870, 51.498818, 5.25],
          [3.489386, 51.498825, 5.25],
          [3.489138, 51.498851, 5.0],
          [3.488934, 51.498881, 5.0],
          [3.488694, 51.498931, 5.0],
          [3.488436, 51.499018, 5.0],
          [3.487743, 51.499267, 5.25],
          [3.487639, 51.499304, 5.25],
          [3.486911, 51.499562, 4.75],
          [3.486242, 51.499787, 4.75],
          [3.485671, 51.499949, 5.0],
          [3.485606, 51.499987, 5.0],
          [3.485627, 51.500041, 4.75],
          [3.486138, 51.500406, 3.0],
          [3.486825, 51.500883, 0.75],
          [3.486837, 51.500897, 0.75],
          [3.486943, 51.501023, 0.75],
          [3.486890, 51.501027, 0.75],
          [3.486828, 51.501051, 0.5],
          [3.486536, 51.501210, 0.5],
          [3.486233, 51.501375, 0.5],
          [3.485955, 51.501521, 0.25],
          [3.485885, 51.501555, 0.25],
          [3.485705, 51.501606, 0.0],
          [3.485318, 51.501643, 0.0],
          [3.485220, 51.501649, 0.0],
          [3.485034, 51.501675, 0.0],
          [3.484895, 51.501710, 0.0],
          [3.484745, 51.501733, 0.0],
          [3.484391, 51.501782, 0.5],
          [3.484186, 51.501810, 0.75],
          [3.483843, 51.501847, 0.75],
          [3.483702, 51.501862, 0.75],
          [3.483519, 51.501885, 0.5],
          [3.483228, 51.501920, 0.5],
          [3.483151, 51.501924, 0.75],
          [3.483051, 51.501928, 0.75],
          [3.482812, 51.501924, 0.75],
          [3.482393, 51.501892, 1.0],
          [3.481464, 51.501810, 1.5],
          [3.481142, 51.501785, 2.0],
          [3.481089, 51.501773, 2.25],
          [3.481062, 51.501767, 2.25],
          [3.480963, 51.501724, 2.5],
          [3.480832, 51.501684, 2.75],
          [3.480859, 51.501647, 2.75],
          [3.480832, 51.501684, 2.75],
          [3.480634, 51.501650, 3.25],
          [3.480467, 51.501649, 3.25],
          [3.480303, 51.501676, 3.5],
          [3.480139, 51.501728, 3.5],
          [3.479974, 51.501810, 3.5],
          [3.479875, 51.501875, 3.25],
          [3.479435, 51.502242, 3.25],
          [3.479120, 51.502510, 4.0],
          [3.478891, 51.502649, 3.75],
          [3.478696, 51.502821, 3.0],
          [3.478557, 51.502971, 2.25],
          [3.478375, 51.503079, 1.75],
          [3.478137, 51.503162, 2.0],
          [3.478102, 51.503191, 2.0],
          [3.478070, 51.503213, 2.0],
          [3.477811, 51.503359, 3.0],
          [3.475369, 51.504480, 3.75],
          [3.474857, 51.504730, 3.75],
          [3.474723, 51.504791, 3.75],
          [3.473064, 51.505564, 2.0],
          [3.472756, 51.505556, 2.75],
          [3.472596, 51.505559, 3.0],
          [3.472496, 51.505568, 3.25],
          [3.472395, 51.505586, 3.25],
          [3.471507, 51.505827, 4.25],
          [3.471314, 51.505897, 4.5],
          [3.471201, 51.505960, 4.5],
          [3.470849, 51.506224, 4.0],
          [3.470588, 51.506343, 3.75],
          [3.469917, 51.506611, 3.25],
          [3.469542, 51.506751, 3.5],
          [3.468840, 51.506993, 3.25],
          [3.468329, 51.507230, 2.5],
          [3.468080, 51.507350, 2.5],
          [3.467863, 51.507446, 2.75],
          [3.467066, 51.507812, 4.0],
          [3.466841, 51.507909, 4.0],
          [3.466272, 51.508156, 4.25],
          [3.466116, 51.508232, 4.5],
          [3.465963, 51.508318, 5.25],
          [3.465750, 51.508462, 5.5],
          [3.465385, 51.508727, 5.25],
          [3.465101, 51.508893, 5.25],
          [3.464352, 51.509251, 6.0],
          [3.464211, 51.509314, 6.25],
          [3.463920, 51.509420, 6.75],
          [3.463404, 51.509546, 8.25],
          [3.463255, 51.509609, 8.5],
          [3.463148, 51.509669, 8.5],
          [3.463060, 51.509738, 8.5],
          [3.462963, 51.509829, 8.5],
          [3.462474, 51.510375, 6.0],
          [3.462361, 51.510465, 5.25],
          [3.462279, 51.510505, 5.0],
          [3.462179, 51.510541, 5.0],
          [3.462029, 51.510579, 5.0],
          [3.461879, 51.510600, 5.0],
          [3.461577, 51.510640, 5.25],
          [3.461354, 51.510680, 5.5],
          [3.461101, 51.510735, 5.5],
          [3.460648, 51.510873, 6.0],
          [3.460308, 51.510963, 6.25],
          [3.460120, 51.511023, 6.25],
          [3.459775, 51.511174, 5.5],
          [3.459483, 51.511286, 5.5],
          [3.459039, 51.511522, 6.25],
          [3.458819, 51.511649, 7.5],
          [3.458320, 51.511981, 7.25],
          [3.458263, 51.512023, 7.0],
          [3.458102, 51.512174, 6.0],
          [3.458006, 51.512248, 5.75],
          [3.457310, 51.512669, 6.75],
          [3.457219, 51.512703, 6.75],
          [3.457097, 51.512729, 7.0],
          [3.456662, 51.512773, 8.25],
          [3.456551, 51.512799, 8.0],
          [3.456289, 51.512888, 7.5],
          [3.456119, 51.512955, 7.25],
          [3.456062, 51.512998, 7.25],
          [3.455952, 51.513143, 7.0],
          [3.455914, 51.513186, 7.0],
          [3.455874, 51.513216, 7.0],
          [3.455817, 51.513251, 7.0],
          [3.455681, 51.513313, 7.5],
          [3.455522, 51.513397, 7.75],
          [3.454980, 51.513735, 7.5],
          [3.454902, 51.513798, 7.0],
          [3.454874, 51.513843, 6.75],
          [3.454874, 51.514269, 5.0],
          [3.454862, 51.514308, 5.0],
          [3.454839, 51.514346, 4.75],
          [3.454801, 51.514379, 5.0],
          [3.454742, 51.514413, 5.0],
          [3.454671, 51.514448, 5.0],
          [3.454343, 51.514576, 5.75],
          [3.454256, 51.514618, 6.0],
          [3.454089, 51.514716, 6.5],
          [3.453846, 51.514883, 6.75],
          [3.453705, 51.514968, 7.0],
          [3.453610, 51.515008, 7.25],
          [3.453492, 51.515047, 7.25],
          [3.452603, 51.515226, 6.25],
          [3.452431, 51.515277, 6.25],
          [3.452296, 51.515341, 6.0],
          [3.451822, 51.515632, 6.5],
          [3.451379, 51.515804, 5.5],
          [3.451190, 51.515871, 4.5],
          [3.451033, 51.515954, 3.75],
          [3.450354, 51.516395, 3.25],
          [3.450281, 51.516458, 3.5],
          [3.450242, 51.516521, 4.0],
          [3.450207, 51.516618, 4.5],
          [3.450158, 51.516833, 4.5],
          [3.450107, 51.516921, 4.5],
          [3.450022, 51.517002, 4.5],
          [3.449839, 51.517144, 4.0],
          [3.449469, 51.517338, 3.25],
          [3.449397, 51.517381, 3.0],
          [3.449332, 51.517434, 3.0],
          [3.449184, 51.517597, 3.25],
          [3.449045, 51.517831, 4.25],
          [3.448977, 51.517921, 4.75],
          [3.449072, 51.518287, 6.0],
          [3.449070, 51.518337, 6.25],
          [3.449038, 51.518438, 6.0],
          [3.448850, 51.518664, 5.75],
          [3.448644, 51.518913, 5.25],
          [3.448448, 51.519173, 4.5],
          [3.448436, 51.519215, 4.5],
          [3.448439, 51.519234, 4.5],
          [3.448461, 51.519263, 4.5],
          [3.449060, 51.519677, 3.5],
          [3.449024, 51.519869, 3.75],
          [3.449014, 51.520094, 4.0],
          [3.448980, 51.520325, 4.0],
          [3.448854, 51.520697, 4.25],
          [3.448809, 51.520985, 3.5],
          [3.448651, 51.521203, 2.5],
          [3.448550, 51.521294, 2.0],
          [3.448435, 51.521389, 1.5],
          [3.448396, 51.521411, 1.25],
          [3.448125, 51.521572, 1.0],
          [3.448006, 51.521630, 1.25],
          [3.447864, 51.521683, 1.5],
          [3.447118, 51.521893, 2.75],
          [3.446983, 51.521937, 2.75],
          [3.446687, 51.522078, 2.5],
          [3.446223, 51.522354, 1.5],
          [3.445646, 51.522670, 1.75],
          [3.445083, 51.522865, 2.0],
          [3.444728, 51.522927, 1.75],
          [3.444538, 51.522947, 1.5],
          [3.444154, 51.522933, 1.25],
          [3.443528, 51.522886, 1.5],
          [3.443189, 51.522905, 1.75],
          [3.442940, 51.522948, 2.5],
          [3.442764, 51.522991, 2.75],
          [3.442642, 51.523044, 3.0],
          [3.442514, 51.523111, 3.25],
          [3.442391, 51.523206, 3.5],
          [3.442363, 51.523267, 3.5],
          [3.442318, 51.523413, 3.5],
          [3.442227, 51.523749, 3.75],
          [3.442210, 51.523854, 3.75],
          [3.442107, 51.524265, 3.75],
          [3.441854, 51.524719, 4.5],
          [3.441697, 51.525008, 4.75],
          [3.441392, 51.525590, 3.75],
          [3.441346, 51.525591, 3.75],
          [3.441066, 51.525909, 3.5],
          [3.440826, 51.526409, 4.0],
          [3.440668, 51.526378, 4.0],
          [3.440489, 51.526345, 4.0],
          [3.440132, 51.526288, 4.25],
          [3.440091, 51.526288, 4.25],
          [3.440007, 51.526310, 4.25],
          [3.439645, 51.526400, 4.0],
          [3.439254, 51.526464, 4.0],
          [3.438871, 51.526513, 4.0],
          [3.437719, 51.526663, 3.75],
          [3.437607, 51.526642, 3.75],
          [3.437508, 51.526633, 3.75],
          [3.437166, 51.526678, 3.75],
          [3.436717, 51.526732, 3.75],
          [3.435777, 51.526828, 2.75],
          [3.435755, 51.526831, 2.5],
          [3.435680, 51.526840, 2.5],
          [3.435399, 51.526872, 2.25],
          [3.435247, 51.526934, 2.0],
          [3.435079, 51.527069, 2.0],
          [3.435007, 51.527174, 2.0],
          [3.434937, 51.527303, 1.75],
          [3.434929, 51.527331, 1.75],
          [3.434874, 51.527538, 1.75],
          [3.434856, 51.527635, 1.5],
          [3.434789, 51.528329, 0.75],
          [3.434821, 51.529513, 0.75],
          [3.434835, 51.530364, 0.75],
          [3.434853, 51.530787, 0.75],
          [3.434904, 51.531134, 0.75],
          [3.434975, 51.531471, 0.75],
          [3.435197, 51.532213, 0.75],
          [3.435331, 51.532734, 0.75],
          [3.435277, 51.532745, 0.75],
          [3.435638, 51.535662, 0.75],
          [3.436350, 51.537770, 0.75],
          [3.436644, 51.539037, 0.75],
          [3.437077, 51.540188, 0.75],
          [3.437389, 51.540747, 0.75],
          [3.437499, 51.540871, 0.75],
          [3.437749, 51.541150],
          [3.438211, 51.541566],
          [3.438836, 51.541978],
          [3.439691, 51.542423, 3.75],
          [3.440624, 51.542824, 3.75],
          [3.442238, 51.543437, 3.75],
          [3.444502, 51.544277, 3.75],
          [3.445982, 51.544818, 3.75],
          [3.447631, 51.545445, 3.75],
          [3.448419, 51.545762, 3.0],
          [3.451029, 51.546922, 3.0],
          [3.452043, 51.547364, 3.0],
          [3.452836, 51.547696, 3.0],
          [3.453319, 51.547883, 3.0],
          [3.454515, 51.548271, 3.0],
          [3.455535, 51.548581, 3.0],
          [3.455638, 51.548512, 3.0],
          [3.455706, 51.548498, 3.0],
          [3.456813, 51.548604, 3.0],
          [3.457271, 51.548641, 3.0],
          [3.457561, 51.548685, 3.0],
          [3.458435, 51.548812, 3.0],
          [3.459902, 51.549072, 4.0],
          [3.459997, 51.549088, 4.5],
          [3.460141, 51.549082, 4.25],
          [3.460240, 51.549032, 3.75],
          [3.460311, 51.548939, 3.25],
          [3.460321, 51.548926, 3.25],
          [3.460994, 51.549057, 3.25],
          [3.461941, 51.549316, 3.25],
          [3.462091, 51.549373, 3.25],
          [3.462587, 51.549583, 3.75],
          [3.463186, 51.549860, 4.25],
          [3.463800, 51.550216, 4.5],
          [3.464445, 51.550640, 4.5],
          [3.464745, 51.550832, 4.5],
          [3.465078, 51.551016, 4.25],
          [3.465469, 51.551174, 3.75],
          [3.466671, 51.551696, 3.0],
          [3.466791, 51.551748, 2.75],
          [3.467346, 51.552017, 2.75],
          [3.467886, 51.552300, 3.75],
          [3.470454, 51.553712, 6.25],
          [3.471305, 51.554118, 6.0],
          [3.471628, 51.554265, 5.75],
          [3.472205, 51.554522, 4.75],
          [3.472696, 51.554728, 4.5],
          [3.474218, 51.555347, 5.0],
          [3.474447, 51.555441, 5.25],
          [3.475264, 51.555764, 6.0],
          [3.475722, 51.555921, 5.5],
          [3.476009, 51.556010, 5.25],
          [3.477078, 51.556300, 5.0],
          [3.477116, 51.556253, 4.5],
          [3.476942, 51.556203, 4.5],
          [3.477116, 51.556253, 4.5],
          [3.477078, 51.556300, 5.0],
          [3.478575, 51.556706, 3.75],
          [3.480129, 51.557146, 1.0],
          [3.482578, 51.557880, 2.25],
          [3.483027, 51.558027, 1.75],
          [3.483441, 51.558208, 1.75],
          [3.483613, 51.558293, 1.75],
          [3.484944, 51.558983, 2.75],
          [3.485352, 51.559164, 2.75],
          [3.485949, 51.559398, 3.25],
          [3.486433, 51.559564, 3.25],
          [3.486701, 51.559638, 3.0],
          [3.487119, 51.559744, 3.0],
          [3.487668, 51.559865, 3.0],
          [3.488300, 51.560015, 3.0],
          [3.488942, 51.560233, 3.5],
          [3.489443, 51.560490, 4.0],
          [3.489930, 51.560778, 4.75],
          [3.490138, 51.560885, 5.0],
          [3.490328, 51.560994, 5.5],
          [3.490753, 51.561252, 6.0],
          [3.490879, 51.561313, 6.0],
          [3.491056, 51.561399, 6.25],
          [3.491594, 51.561608, 6.0],
          [3.491781, 51.561661, 6.0],
          [3.492187, 51.561762, 6.0],
          [3.492617, 51.561851, 6.0],
          [3.492976, 51.561928, 6.0],
          [3.493157, 51.561918, 6.0],
          [3.493959, 51.562086, 5.5],
          [3.494350, 51.562168, 5.25],
          [3.494372, 51.562174, 5.25],
          [3.494611, 51.562256, 5.0],
          [3.495030, 51.562453, 4.75],
          [3.495761, 51.562788, 5.25],
          [3.495934, 51.562893, 5.5],
          [3.496166, 51.563021, 5.75],
          [3.496354, 51.563147, 6.25],
          [3.496656, 51.563313, 6.75],
          [3.497128, 51.563557, 7.0],
          [3.497413, 51.563697, 7.0],
          [3.497557, 51.563749, 7.0],
          [3.498057, 51.563846, 7.25],
          [3.498365, 51.563930, 7.5],
          [3.498438, 51.563956, 7.5],
          [3.498894, 51.564118, 7.25],
          [3.499040, 51.564170, 7.0],
          [3.499130, 51.564182, 7.0],
          [3.499602, 51.564291, 6.5],
          [3.500345, 51.564456, 6.5],
          [3.500867, 51.564564, 6.75],
          [3.501903, 51.564738, 6.25],
          [3.502084, 51.564749, 6.0],
          [3.502324, 51.564780, 5.75],
          [3.502661, 51.564839, 5.25],
          [3.502790, 51.564857, 5.0],
          [3.503324, 51.564951, 3.75],
          [3.503450, 51.564941, 3.75],
          [3.503916, 51.565008, 4.0],
          [3.504057, 51.565019, 4.0],
          [3.504122, 51.565014, 4.0],
          [3.504240, 51.565025, 4.0],
          [3.504392, 51.565032, 4.0],
          [3.504480, 51.565094, 4.25],
          [3.504650, 51.565166, 4.25],
          [3.505638, 51.565293, 4.5],
          [3.506653, 51.565430, 4.5],
          [3.509332, 51.565962, 5.5],
          [3.510982, 51.566288, 6.75],
          [3.511742, 51.566404, 5.5],
          [3.512401, 51.566583, 5.0],
          [3.513031, 51.566794, 4.5],
          [3.515766, 51.567691, 3.25],
          [3.516962, 51.568081, 2.5],
          [3.517160, 51.568136, 2.5],
          [3.517331, 51.568192, 2.5],
          [3.517418, 51.568232, 2.75],
          [3.517763, 51.568348, 3.0],
          [3.518013, 51.568416, 3.0],
          [3.518261, 51.568463, 3.25],
          [3.518554, 51.568500, 3.25],
          [3.518931, 51.568516, 3.25],
          [3.519237, 51.568504, 3.0],
          [3.519237, 51.568564, 3.0],
          [3.519232, 51.568633, 3.25],
          [3.519055, 51.568662, 3.25],
          [3.518974, 51.568663, 3.25],
          [3.518928, 51.568744, 3.5],
          [3.518580, 51.569126, 4.75],
          [3.518397, 51.569329, 5.5],
          [3.517879, 51.570048, 8.0],
          [3.517545, 51.570551, 8.5],
          [3.517403, 51.570838, 8.75],
          [3.517320, 51.570951, 8.5],
          [3.516928, 51.571393, 7.5],
          [3.516810, 51.571588, 7.0],
          [3.516702, 51.571766, 7.0],
          [3.516875, 51.571878, 7.25],
          [3.517931, 51.572208, 8.0],
          [3.518563, 51.572510, 9.0],
          [3.518897, 51.572642, 9.0],
          [3.520144, 51.572956, 9.5],
          [3.520188, 51.572967, 9.5],
          [3.520302, 51.572991, 9.5],
          [3.520900, 51.573171, 9.75],
          [3.521828, 51.573188, 10.25],
          [3.524033, 51.573757, 9.5],
          [3.525192, 51.574191, 9.75],
          [3.525719, 51.574348, 9.5],
          [3.525852, 51.574388, 9.25],
          [3.526212, 51.574630, 8.75],
          [3.527685, 51.575032, 9.0],
          [3.527828, 51.575076, 9.0],
          [3.528061, 51.575168, 9.0],
          [3.528202, 51.575234, 9.0],
          [3.528348, 51.575340, 9.0],
          [3.528569, 51.575450, 9.0],
          [3.529439, 51.575670, 8.75],
          [3.530558, 51.576115, 9.25],
          [3.530697, 51.576150, 9.25],
          [3.530782, 51.576175, 9.25],
          [3.531307, 51.576175, 8.75],
          [3.531899, 51.576302, 8.25],
          [3.532115, 51.576323, 8.25],
          [3.532241, 51.576397, 8.25],
          [3.532569, 51.576564, 8.0],
          [3.532788, 51.576723, 7.75],
          [3.533108, 51.576871, 7.75],
          [3.533473, 51.576957, 7.75],
          [3.533893, 51.576996, 8.0],
          [3.534119, 51.577075, 7.75],
          [3.534872, 51.577235, 7.75],
          [3.534943, 51.577300, 7.5],
          [3.535077, 51.577366, 7.25],
          [3.535150, 51.577378, 7.25],
          [3.535228, 51.577369, 7.25],
          [3.535365, 51.577341, 7.25],
          [3.535561, 51.577344, 7.25],
          [3.535757, 51.577388, 7.25],
          [3.536077, 51.577494, 7.25],
          [3.536209, 51.577597, 7.25],
          [3.536432, 51.577694, 7.25],
          [3.536871, 51.577765, 7.25],
          [3.537029, 51.577872, 7.0],
          [3.537634, 51.578066, 6.75],
          [3.538574, 51.578144, 7.25],
          [3.539160, 51.578093, 7.25],
          [3.539804, 51.578051, 6.5],
          [3.541831, 51.578332, 7.75],
          [3.543487, 51.578443, 7.5],
          [3.543602, 51.578552, 7.25],
          [3.543748, 51.578610, 7.25],
          [3.544437, 51.578814, 6.5],
          [3.545020, 51.578910, 6.25],
          [3.545209, 51.578944, 6.25],
          [3.545304, 51.578975, 6.0],
          [3.545751, 51.579086, 6.0],
          [3.545926, 51.579086, 6.0],
          [3.546076, 51.579063, 6.25],
          [3.546270, 51.578997, 6.5],
          [3.546489, 51.578911, 6.5],
          [3.546682, 51.578900, 6.5],
          [3.547076, 51.578950, 6.5],
          [3.547481, 51.578999, 6.5],
          [3.547714, 51.579019, 6.25],
          [3.547869, 51.579043, 6.0],
          [3.548012, 51.579079, 6.0],
          [3.548265, 51.579117, 5.75],
          [3.548434, 51.579136, 5.75],
          [3.548680, 51.579202, 6.0],
          [3.549093, 51.579266, 6.0],
          [3.549248, 51.579274, 5.75],
          [3.549420, 51.579283, 5.75],
          [3.549894, 51.579408, 5.5],
          [3.550266, 51.579515, 5.5],
          [3.550467, 51.579562, 5.5],
          [3.551223, 51.579724, 4.75],
          [3.551676, 51.579801, 4.0],
          [3.552082, 51.579831, 4.0],
          [3.552788, 51.579846, 4.25],
          [3.553007, 51.579881, 4.5],
          [3.553456, 51.579940, 4.75],
          [3.553899, 51.579980, 4.75],
          [3.554064, 51.580002, 5.0],
          [3.554761, 51.579990, 4.75],
          [3.554981, 51.580042, 5.0],
          [3.555413, 51.580118, 5.0],
          [3.556159, 51.580177, 4.5],
          [3.556273, 51.580145, 4.5],
          [3.556365, 51.580109, 4.25],
          [3.556808, 51.580130, 4.25],
          [3.557040, 51.580166, 4.75],
          [3.557358, 51.580228, 5.25],
          [3.557851, 51.580285, 6.25],
          [3.558164, 51.580289, 6.75],
          [3.558453, 51.580280, 7.25],
          [3.560370, 51.580180, 8.0],
          [3.560550, 51.580160, 8.25],
          [3.560881, 51.580084, 8.5],
          [3.561770, 51.579880, 8.25],
          [3.562040, 51.579850, 8.5],
          [3.563572, 51.579755, 10.25],
          [3.563750, 51.579770, 10.25],
          [3.567588, 51.580247, 8.0],
          [3.567626, 51.580251, 7.75],
          [3.569744, 51.580517, 9.0],
          [3.576738, 51.581387, 1.25],
          [3.578788, 51.581549, 1.75],
          [3.578981, 51.581559, 1.75],
          [3.579190, 51.581540, 1.75],
          [3.579284, 51.581520, 1.75],
          [3.579383, 51.581499, 1.75],
          [3.579459, 51.581534, 1.75],
          [3.579565, 51.581569, 1.75],
          [3.579755, 51.581601, 1.75],
          [3.580443, 51.581646, 1.75],
          [3.581591, 51.581703, 2.0],
          [3.582240, 51.581767, 2.0],
          [3.582477, 51.581805, 2.0],
          [3.582682, 51.581826, 2.0],
          [3.582866, 51.581827, 1.75],
          [3.582994, 51.581813, 1.75],
          [3.583341, 51.581737, 1.25],
          [3.584190, 51.581550, 0.75],
          [3.585790, 51.581279, 0.0],
          [3.585934, 51.581252, 0.0],
          [3.585790, 51.581279, 0.0],
          [3.585776, 51.581247, 0.0],
          [3.584914, 51.578958, 2.5],
          [3.584909, 51.578949, 2.25]
        ]
      }
    }
  ]
}

let day5: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "Vrouwenpolder - Renesse - 31.1km",
        "track-length": "31061",
        "filtered ascend": "54",
        "plain-ascend": "16",
        "total-time": "5142",
        "total-energy": "511387",
        "cost": "35417",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["3585776", "51581247", "0", "267", "1350", "0", "0", "0", "0", "highway=unclassified surface=paving_stones", "highway=give_way direction=forward", "29", "2991"],
          ["3585790", "51581279", "0", "4", "1350", "0", "0", "0", "0", "highway=unclassified surface=paving_stones", "", "30", "3050"],
          ["3602265", "51579226", "1", "1176", "1450", "0", "92", "0", "0", "reversedirection=yes highway=tertiary", "", "222", "22239"],
          ["3602266", "51579252", "1", "3", "1350", "0", "79", "0", "0", "highway=unclassified", "highway=give_way direction=backward", "222", "22267"],
          ["3603457", "51583241", "1", "458", "1350", "0", "13", "0", "0", "highway=unclassified", "", "289", "28955"],
          ["3602420", "51583390", "0", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "291", "29165"],
          ["3603457", "51583241", "1", "12", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "292", "29282"],
          ["3605597", "51586112", "3", "583", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "388", "38899"],
          ["3607391", "51586188", "1", "138", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "410", "41070"],
          ["3610621", "51587598", "2", "279", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "458", "45810"],
          ["3612427", "51587558", "3", "127", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "482", "48278"],
          ["3616246", "51586981", "6", "280", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "547", "54713"],
          ["3620656", "51586137", "4", "326", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "599", "59997"],
          ["3626288", "51585810", "7", "404", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "677", "67787"],
          ["3625995", "51585802", "7", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "678", "67814"],
          ["3626045", "51585426", "6", "44", "40000", "0", "95", "0", "0", "reversedirection=yes highway=steps", "", "706", "67814"],
          ["3627592", "51585219", "5", "152", "1350", "0", "119", "0", "0", "reversedirection=yes highway=service", "", "722", "69391"],
          ["3628084", "51585610", "-8192", "64", "1050", "0", "122", "0", "0", "reversedirection=yes highway=cycleway", "", "728", "70053"],
          ["3662570", "51589564", "3", "2499", "1050", "0", "10", "0", "0", "highway=cycleway", "", "1130", "110215"],
          ["3663579", "51590654", "4", "149", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "1149", "112150"],
          ["3663636", "51590682", "4", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "1150", "112245"],
          ["3662662", "51591076", "5", "102", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt bicycle=yes route_bicycle_rcn=yes", "", "1163", "113512"],
          ["3664059", "51591804", "6", "129", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1185", "115710"],
          ["3668305", "51594423", "6", "438", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=use_sidepath route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1249", "122092"],
          ["3671106", "51595713", "3", "245", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1286", "125864"],
          ["3681661", "51598777", "6", "828", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1434", "140645"],
          ["3682134", "51600620", "-8192", "212", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1462", "143470"],
          ["3682185", "51600927", "-8192", "37", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1468", "144006"],
          ["3682193", "51600987", "-8192", "7", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1469", "144110"],
          ["3683532", "51617775", "5", "1887", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1780", "175229"],
          ["3683894", "51618481", "2", "84", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "1788", "175996"],
          ["3684092", "51618858", "2", "48", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "1793", "176533"],
          ["3684298", "51618986", "3", "20", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1795", "176775"],
          ["3685152", "51618979", "4", "61", "1350", "0", "27", "0", "0", "reversedirection=yes highway=unclassified", "", "1804", "177601"],
          ["3695809", "51629816", "4", "1487", "1350", "0", "114", "0", "0", "highway=unclassified", "barrier=cycle_barrier", "2035", "200764"],
          ["3695235", "51630203", "6", "60", "1350", "0", "0", "0", "0", "highway=unclassified", "barrier=bollard", "2043", "201517"],
          ["3694970", "51630366", "6", "26", "1350", "0", "0", "0", "0", "highway=unclassified", "barrier=bollard", "2046", "201886"],
          ["3694226", "51630888", "5", "78", "1350", "0", "0", "0", "0", "highway=unclassified", "", "2056", "202851"],
          ["3702665", "51636555", "7", "861", "1000", "0", "0", "0", "0", "highway=unclassified bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "2196", "216828"],
          ["3714110", "51642204", "8", "1079", "1000", "0", "0", "0", "0", "highway=unclassified bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2371", "234339"],
          ["3719838", "51649384", "8", "893", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2517", "248939"],
          ["3722127", "51652501", "8", "386", "1000", "0", "0", "0", "0", "highway=unclassified bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2584", "255668"],
          ["3722514", "51663345", "8", "1219", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2787", "275938"],
          ["3722490", "51663638", "8", "37", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2793", "276560"],
          ["3722230", "51666442", "-8192", "315", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2836", "280857"],
          ["3723713", "51671454", "0", "573", "1000", "0", "0", "0", "0", "highway=unclassified bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=forward", "2919", "289097"],
          ["3723695", "51671549", "0", "11", "1000", "0", "0", "0", "0", "highway=unclassified bicycle=designated route_bicycle_rcn=yes", "", "2920", "289220"],
          ["3723688", "51671623", "0", "9", "1050", "0", "0", "0", "0", "highway=unclassified bicycle=designated", "highway=give_way direction=backward", "2921", "289320"],
          ["3725556", "51680383", "0", "1107", "1050", "0", "39", "0", "0", "highway=unclassified bicycle=designated", "", "3088", "306078"],
          ["3725445", "51680451", "0", "11", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "3090", "306267"],
          ["3731579", "51684761", "0", "656", "1050", "0", "104", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no", "", "3194", "316614"],
          ["3731230", "51684960", "0", "33", "1050", "0", "2", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no", "", "3197", "316940"],
          ["3727455", "51687431", "2", "384", "1450", "0", "7", "0", "0", "highway=tertiary cycleway=lane", "", "3263", "323498"],
          ["3726877", "51687129", "2", "17", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3265", "323784"],
          ["3728743", "51688260", "3", "147", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3285", "325711"],
          ["3729255", "51688611", "2", "53", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3293", "326503"],
          ["3732395", "51690749", "2", "334", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3346", "331878"],
          ["3736914", "51694142", "2", "535", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3437", "340929"],
          ["3733081", "51700721", "12", "806", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3629", "360191"],
          ["3731693", "51701550", "14", "135", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3650", "362246"],
          ["3731882", "51707097", "9", "636", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3750", "372244"],
          ["3731901", "51707142", "9", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3751", "372373"],
          ["3730033", "51707899", "7", "160", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3778", "375013"],
          ["3728327", "51708648", "6", "145", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3796", "376830"],
          ["3722871", "51712610", "3", "599", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3889", "386151"],
          ["3727651", "51718415", "3", "978", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4044", "401678"],
          ["3727845", "51718490", "3", "16", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4047", "401963"],
          ["3727362", "51718950", "3", "65", "1000", "0", "0", "0", "0", "highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4058", "403051"],
          ["3726344", "51721130", "4", "285", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4113", "408519"],
          ["3718820", "51729044", "8", "1095", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4345", "431768"],
          ["3718247", "51729737", "5", "88", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4352", "432503"],
          ["3740864", "51734591", "6", "1723", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=fine_gravel foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4639", "461149"],
          ["3766568", "51739430", "4", "2088", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=fine_gravel route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4998", "497049"],
          ["3771862", "51740455", "5", "387", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5065", "503732"],
          ["3774989", "51740732", "5", "226", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5102", "507430"],
          ["3774874", "51740914", "5", "23", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5105", "507803"],
          ["3778343", "51741272", "6", "205", "1000", "0", "0", "0", "0", "highway=cycleway surface=fine_gravel foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5141", "511404"]
        ],
        "times": [0, 0.48, 29.911, 30.497, 30.644, 43.339, 60.292, 98.547, 144.49, 181.525, 188.611, 196.524, 209.085, 219.275, 222.115, 222.391, 222.671, 226.728, 234.822, 250.729, 287.034, 287.932, 288.649, 289.543, 291.145, 291.643, 291.929, 292.81, 293.313, 302.833, 315.812, 316.849, 317.595, 319.25, 320.382, 322.654, 324.773, 368.045, 386.055, 387.524, 388.354, 388.972, 391.004, 392.205, 393.869, 394.787, 395.812, 400.873, 402.703, 405.885, 407.066, 407.959, 410.674, 446.429, 448.106, 450.609, 455.124, 458.074, 472.92, 482.754, 502.741, 511.818, 520.162, 539.192, 541.103, 542.615, 543.927, 545.32, 547.087, 563.746, 593.265, 595.565, 597.423, 598.203, 599.085, 599.923, 603.72, 605.251, 607.874, 611.242, 614.469, 617.31, 619.37, 621.375, 624.187, 628.938, 632.482, 635.816, 643.262, 646.329, 649.956, 652.159, 655.666, 662.364, 667.957, 677.186, 677.81, 678.086, 692.213, 700.564, 706.362, 706.453, 709.491, 711.284, 713.201, 715.239, 717.516, 718.261, 718.89, 719.074, 721.4, 722.122, 722.331, 724.239, 725.355, 726.09, 726.735, 727.282, 727.952, 728.749, 732.111, 732.203, 734.419, 735.976, 742.631, 749.749, 764.789, 835.325, 863.726, 872.011, 880.841, 899.565, 913.334, 930.784, 938.962, 943.79, 953.538, 958.248, 963.33, 1086.519, 1105.776, 1122.247, 1130.356, 1130.879, 1132.199, 1133.863, 1135.175, 1141.302, 1143.528, 1145.093, 1145.669, 1147.989, 1148.612, 1149.08, 1149.707, 1150.649, 1151.688, 1152.434, 1153.035, 1153.127, 1153.415, 1158.82, 1162.031, 1163.325, 1168.583, 1181.993, 1184.64, 1185.303, 1187.486, 1190.166, 1194.796, 1196.084, 1199.811, 1202.583, 1205.532, 1208.658, 1212.241, 1213.5, 1215.309, 1218.558, 1222.967, 1227.447, 1229.243, 1230.653, 1235.409, 1238.383, 1240.318, 1242.282, 1243.81, 1246.779, 1247.823, 1249.121, 1259.721, 1262.357, 1270.971, 1280.302, 1286.839, 1292.412, 1294.375, 1306.162, 1324.852, 1329.046, 1334.679, 1356.972, 1365.18, 1383.023, 1401.53, 1415.14, 1423.877, 1427.069, 1428.917, 1434.63, 1438.326, 1440.006, 1444.038, 1445.55, 1450.596, 1460.254, 1462.883, 1464.159, 1466.615, 1468.236, 1469.278, 1492.421, 1512.905, 1576.056, 1730.951, 1732.967, 1740.695, 1743.215, 1749.767, 1755.479, 1765.391, 1768.679, 1773.035, 1777.716, 1780.462, 1782.261, 1785.043, 1787.269, 1788.13, 1788.623, 1790.769, 1791.216, 1791.784, 1793.501, 1795.241, 1795.915, 1798.931, 1801.486, 1802.716, 1804.174, 1807.468, 1808.316, 1809.139, 1810.223, 1811.459, 1811.554, 1818.024, 1819.424, 1823.34, 1826.336, 1835.118, 1845.967, 1849.076, 1851.701, 1854.867, 1861.558, 1876.244, 1883.965, 1884.934, 1887.401, 1888.884, 1897.212, 1909.815, 1917.178, 1932.846, 1947.57, 1959.242, 1968.858, 1983.532, 1992.328, 2000.559, 2007.554, 2017.049, 2034.511, 2035.761, 2036.473, 2043.293, 2046.979, 2056.626, 2058.693, 2144.005, 2196.389, 2198.308, 2200.755, 2232.713, 2235.934, 2239.668, 2258.245, 2278.14, 2294.709, 2315.003, 2317.523, 2320.546, 2323.57, 2328.441, 2338.185, 2353.504, 2358.641, 2358.832, 2359.995, 2361.317, 2363.011, 2364.232, 2365.85, 2371.494, 2513.836, 2517.487, 2527.15, 2533.167, 2539.361, 2547.959, 2576.126, 2584.781, 2591.604, 2598.839, 2608.042, 2618.561, 2632.023, 2635.362, 2645.734, 2648.414, 2665.68, 2680.461, 2704.315, 2775.044, 2786.301, 2787.477, 2789.157, 2792.181, 2793.693, 2796.213, 2806.052, 2824.859, 2833.364, 2836.662, 2847.448, 2858.813, 2869.681, 2877.952, 2908.54, 2916.823, 2919.057, 2920.287, 2921.281, 2923.475, 2924.926, 2926.299, 2927.71, 2930.096, 2932.292, 2935.554, 2991.115, 3000.509, 3009.928, 3017.841, 3025.062, 3028.604, 3030.011, 3031.063, 3031.155, 3031.903, 3032.705, 3038.717, 3050.773, 3074.974, 3079.005, 3083.174, 3088.86, 3090.745, 3095.187, 3106.649, 3133.861, 3152.163, 3159.621, 3166.692, 3189.9, 3190.727, 3191.72, 3193.21, 3193.568, 3194.207, 3197.057, 3197.476, 3198.659, 3226.728, 3245.444, 3263.054, 3265.913, 3267.525, 3271.561, 3285.163, 3293.081, 3306.358, 3306.843, 3311.14, 3312.386, 3313.954, 3315.531, 3322.928, 3328.887, 3340.264, 3343.572, 3346.83, 3352.321, 3355.862, 3359.787, 3362.309, 3364.419, 3368.653, 3371.958, 3375.149, 3381.982, 3383.109, 3386.831, 3388.977, 3393.035, 3399.071, 3403.621, 3406.828, 3418.875, 3422.907, 3433.498, 3437.333, 3438.277, 3440.278, 3444.847, 3456.51, 3462.976, 3467.418, 3476.171, 3483.193, 3524.394, 3529.096, 3551.504, 3560.014, 3571.398, 3582.472, 3599.895, 3604.293, 3609.407, 3614.59, 3623.715, 3628.744, 3629.911, 3641.795, 3649.189, 3650.468, 3662.026, 3671.707, 3684.238, 3690.067, 3695.324, 3702.369, 3704.476, 3715.225, 3731.753, 3741.755, 3743.823, 3746.802, 3748.243, 3750.429, 3751.713, 3754.623, 3759.946, 3763.939, 3771.068, 3776.126, 3778.117, 3792.084, 3796.285, 3802.339, 3812.276, 3817.572, 3826.052, 3827.463, 3828.261, 3829.251, 3830.038, 3831.911, 3834.155, 3838.867, 3843.491, 3848.571, 3851.642, 3854.292, 3864.406, 3876.165, 3877.99, 3881.388, 3882.482, 3887.223, 3888.425, 3889.484, 3894.6, 3897.169, 3899.018, 3900.824, 3901.35, 3923.393, 3943.198, 3959.783, 3961.996, 3963.458, 3964.988, 3969.674, 3982.885, 3986.403, 3990.323, 3994.632, 3998.118, 4033.532, 4044.729, 4047.582, 4049.353, 4055.806, 4058.464, 4059.295, 4060.46, 4061.292, 4063.292, 4064.959, 4070.974, 4073.216, 4078.287, 4080.378, 4082.98, 4085.914, 4094.991, 4097.779, 4101.912, 4103.917, 4104.908, 4105.89, 4111.636, 4113.133, 4136.123, 4139.378, 4266.648, 4269.272, 4270.385, 4275.341, 4291.56, 4294.49, 4305.899, 4310.62, 4315.539, 4323.523, 4327.495, 4329.379, 4331.202, 4335.239, 4339.175, 4343.745, 4345.585, 4349.298, 4350.602, 4352.942, 4357.425, 4380.3, 4390.292, 4399.516, 4414.191, 4428.895, 4446.868, 4453.18, 4465.241, 4472.406, 4480.974, 4517.364, 4531.972, 4540.202, 4545.913, 4557.672, 4582.703, 4589.123, 4592.473, 4599.556, 4605.933, 4621.582, 4626.991, 4639.384, 4643.105, 4646.983, 4648.358, 4651.521, 4653.41, 4653.652, 4661.894, 4663.564, 4664.548, 4690.546, 4703.417, 4717.861, 4727.327, 4731.521, 4735.905, 4741.797, 4747.353, 4753.611, 4756.425, 4759.911, 4772.248, 4780.2, 4786.283, 4790.35, 4792.735, 4794.44, 4796.657, 4800.126, 4801.777, 4805.829, 4808.924, 4813.73, 4818.048, 4849.25, 4852.588, 4857.496, 4860.537, 4866.534, 4873.167, 4882.614, 4890.105, 4901.26, 4909.026, 4911.753, 4916.809, 4922.196, 4923.762, 4932.448, 4937.569, 4941.051, 4944.4, 4952.337, 4956.582, 4960.486, 4963.72, 4970.69, 4974.101, 4977.37, 4980.514, 4981.21, 4981.905, 4984.364, 4985.474, 4986.673, 4988.09, 4989.215, 4990.309, 4991.179, 4992.142, 4992.754, 4994.643, 4996.467, 4997.536, 4998.349, 5004.739, 5013.616, 5026.542, 5051.078, 5063.912, 5065.169, 5067.226, 5070.418, 5085.924, 5088.359, 5099.586, 5100.676, 5102.15, 5104.691, 5105.885, 5116.081, 5122.188, 5127.046, 5141.888]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [3.584896, 51.578920, 2.25],
          [3.584914, 51.578958, 2.5],
          [3.585776, 51.581247, 0.0],
          [3.585790, 51.581279, 0.0],
          [3.585790, 51.581278, 0.0],
          [3.587465, 51.580971, 0.0],
          [3.588760, 51.580740, 0.75],
          [3.592045, 51.580221, 0.25],
          [3.595830, 51.579740, 0.5],
          [3.599031, 51.579384, 0.25],
          [3.599590, 51.579319, 0.5],
          [3.600193, 51.579258, 0.75],
          [3.601200, 51.579210, 0.75],
          [3.602004, 51.579211, 1.0],
          [3.602227, 51.579223, 1.0],
          [3.602265, 51.579226, 1.0],
          [3.602266, 51.579252, 1.0],
          [3.602284, 51.579611, 1.0],
          [3.602445, 51.580197, 1.0],
          [3.602775, 51.581281, 0.5],
          [3.603328, 51.583165, 0.75],
          [3.603364, 51.583201, 1.0],
          [3.603400, 51.583223, 1.0],
          [3.603457, 51.583241, 1.0],
          [3.603344, 51.583274, 1.0],
          [3.603308, 51.583278, 0.75],
          [3.603344, 51.583274, 1.0],
          [3.603457, 51.583241, 1.0],
          [3.603526, 51.583239, 1.0],
          [3.604651, 51.583038, 1.0],
          [3.605986, 51.582859, 0.75],
          [3.606084, 51.582857, 0.75],
          [3.606144, 51.582863, 0.75],
          [3.606293, 51.582895, 0.75],
          [3.606376, 51.582926, 1.0],
          [3.606518, 51.583005, 1.0],
          [3.606478, 51.583110, 1.0],
          [3.605783, 51.585349, 1.25],
          [3.605554, 51.586012, 3.0],
          [3.605557, 51.586070, 3.0],
          [3.605574, 51.586095, 3.0],
          [3.605597, 51.586112, 3.0],
          [3.605703, 51.586162, 3.0],
          [3.605776, 51.586186, 3.0],
          [3.605893, 51.586204, 2.75],
          [3.605963, 51.586207, 2.75],
          [3.606036, 51.586200, 2.5],
          [3.606505, 51.586109, 1.75],
          [3.606684, 51.586087, 1.5],
          [3.606990, 51.586082, 1.5],
          [3.607098, 51.586091, 1.5],
          [3.607178, 51.586107, 1.5],
          [3.607391, 51.586188, 1.5],
          [3.609800, 51.587417, 1.75],
          [3.609909, 51.587462, 1.75],
          [3.610084, 51.587513, 2.0],
          [3.610407, 51.587583, 2.25],
          [3.610621, 51.587598, 2.5],
          [3.611762, 51.587578, 2.5],
          [3.612427, 51.587558, 3.25],
          [3.613493, 51.587491, 5.0],
          [3.614017, 51.587452, 5.5],
          [3.614522, 51.587386, 5.75],
          [3.615764, 51.587139, 6.0],
          [3.615891, 51.587102, 6.0],
          [3.615965, 51.587058, 6.0],
          [3.616040, 51.587030, 6.0],
          [3.616127, 51.587002, 6.25],
          [3.616246, 51.586981, 6.25],
          [3.617486, 51.586767, 6.25],
          [3.620170, 51.586319, 5.25],
          [3.620349, 51.586284, 5.25],
          [3.620505, 51.586239, 5.0],
          [3.620556, 51.586216, 5.0],
          [3.620612, 51.586178, 4.75],
          [3.620656, 51.586137, 4.5],
          [3.620886, 51.586257, 5.5],
          [3.620980, 51.586297, 5.75],
          [3.621143, 51.586353, 6.0],
          [3.621333, 51.586401, 6.5],
          [3.621522, 51.586430, 6.75],
          [3.621686, 51.586444, 7.0],
          [3.621813, 51.586448, 7.0],
          [3.621937, 51.586441, 7.0],
          [3.622115, 51.586417, 7.0],
          [3.622466, 51.586352, 6.5],
          [3.622748, 51.586288, 6.25],
          [3.623023, 51.586216, 6.0],
          [3.623683, 51.586030, 5.5],
          [3.623926, 51.585973, 5.75],
          [3.624209, 51.585920, 6.0],
          [3.624377, 51.585896, 6.25],
          [3.624611, 51.585871, 6.75],
          [3.625084, 51.585836, 6.75],
          [3.625403, 51.585820, 7.75],
          [3.625995, 51.585802, 7.75],
          [3.626024, 51.585802, 7.75],
          [3.625995, 51.585802, 7.75],
          [3.625991, 51.585605, 7.25],
          [3.625990, 51.585495, 7.0],
          [3.626045, 51.585426, 6.75],
          [3.626050, 51.585419, 6.5],
          [3.626257, 51.585150, 5.75],
          [3.626483, 51.585220, 5.75],
          [3.626706, 51.585289, 5.75],
          [3.626926, 51.585357, 5.75],
          [3.627167, 51.585430, 5.75],
          [3.627246, 51.585448, 5.75],
          [3.627304, 51.585448, 5.75],
          [3.627340, 51.585437, 5.75],
          [3.627511, 51.585254, 5.75],
          [3.627592, 51.585219, 5.75],
          [3.627600, 51.585233, 5.75],
          [3.627691, 51.585397],
          [3.627751, 51.585486],
          [3.627805, 51.585534],
          [3.627861, 51.585568],
          [3.627912, 51.585585],
          [3.627985, 51.585601],
          [3.628084, 51.585610],
          [3.628475, 51.585598],
          [3.628482, 51.585598],
          [3.628804, 51.585629],
          [3.628989, 51.585695],
          [3.629680, 51.585962],
          [3.630341, 51.586194],
          [3.631656, 51.586562],
          [3.637929, 51.588320],
          [3.640390, 51.588892],
          [3.641059, 51.589053],
          [3.641779, 51.589192],
          [3.643332, 51.589450],
          [3.644486, 51.589608, 2.5],
          [3.645646, 51.589745, 3.75],
          [3.646255, 51.589797, 3.75],
          [3.646654, 51.589806, 3.5],
          [3.647512, 51.589759, 3.25],
          [3.647896, 51.589744, 3.5],
          [3.648268, 51.589744, 4.0],
          [3.658921, 51.589832, 3.25],
          [3.660478, 51.589813, 3.5],
          [3.661932, 51.589663, 3.25],
          [3.662570, 51.589564, 3.5],
          [3.662582, 51.589588, 3.5],
          [3.662645, 51.589706, 3.5],
          [3.662740, 51.589834, 3.75],
          [3.662827, 51.589925, 3.75],
          [3.663253, 51.590251, 4.25],
          [3.663419, 51.590343, 4.25],
          [3.663488, 51.590424, 4.25],
          [3.663504, 51.590455, 4.25],
          [3.663520, 51.590581, 4.5],
          [3.663541, 51.590613, 4.5],
          [3.663564, 51.590625, 4.5],
          [3.663579, 51.590654, 4.5],
          [3.663636, 51.590682, 4.5],
          [3.663708, 51.590713, 4.25],
          [3.663740, 51.590748, 4.25],
          [3.663735, 51.590776, 4.25],
          [3.663735, 51.590779, 4.25],
          [3.663718, 51.590800, 4.5],
          [3.663135, 51.590982, 5.25],
          [3.662796, 51.591064, 5.0],
          [3.662662, 51.591076, 5.0],
          [3.663055, 51.591264, 5.5],
          [3.663845, 51.591701, 6.25],
          [3.664021, 51.591786, 6.0],
          [3.664059, 51.591804, 6.0],
          [3.664206, 51.591880, 5.75],
          [3.664339, 51.592002, 5.75],
          [3.664527, 51.592225, 5.75],
          [3.664595, 51.592282, 5.75],
          [3.664764, 51.592452, 5.75],
          [3.664921, 51.592569, 5.75],
          [3.665094, 51.592681, 5.75],
          [3.665302, 51.592786, 5.75],
          [3.665547, 51.592920, 5.5],
          [3.665617, 51.592967, 5.5],
          [3.665798, 51.593087, 5.5],
          [3.666105, 51.593277, 5.5],
          [3.666441, 51.593556, 5.25],
          [3.666700, 51.593810, 5.5],
          [3.666809, 51.593905, 5.5],
          [3.666912, 51.593967, 5.5],
          [3.667270, 51.594128, 5.75],
          [3.667475, 51.594234, 5.75],
          [3.667615, 51.594298, 5.5],
          [3.667774, 51.594351, 5.5],
          [3.667903, 51.594384, 5.5],
          [3.668148, 51.594386, 6.0],
          [3.668232, 51.594394, 6.0],
          [3.668305, 51.594423, 6.25],
          [3.668984, 51.594816, 5.75],
          [3.669142, 51.594909, 5.75],
          [3.669714, 51.595209, 5.75],
          [3.670394, 51.595480, 5.75],
          [3.671106, 51.595713, 3.75],
          [3.671624, 51.595892, 3.75],
          [3.671793, 51.595952, 3.75],
          [3.672784, 51.596285, 3.75],
          [3.673672, 51.596619, 6.25],
          [3.673894, 51.596709, 6.25],
          [3.674202, 51.596845, 6.25],
          [3.675624, 51.597366, 6.25],
          [3.676224, 51.597568, 6.25],
          [3.677581, 51.597969, 6.25],
          [3.679084, 51.598281, 6.25],
          [3.680191, 51.598494, 6.25],
          [3.680858, 51.598687, 6.25],
          [3.681066, 51.598789, 6.25],
          [3.681185, 51.598847, 6.25],
          [3.681661, 51.598777, 6.25],
          [3.681771, 51.598962, 6.25],
          [3.681814, 51.599040, 6.25],
          [3.681897, 51.599244, 6.25],
          [3.681912, 51.599321, 6.25],
          [3.681999, 51.599766],
          [3.682099, 51.600459],
          [3.682134, 51.600620],
          [3.682199, 51.600689],
          [3.682219, 51.600838],
          [3.682185, 51.600927],
          [3.682193, 51.600987],
          [3.682376, 51.602312],
          [3.682510, 51.603408],
          [3.682981, 51.606769],
          [3.684106, 51.615023],
          [3.684116, 51.615126],
          [3.684106, 51.615532],
          [3.684080, 51.615663],
          [3.684013, 51.616005],
          [3.683889, 51.616298],
          [3.683596, 51.616792, 8.5],
          [3.683519, 51.616975, 8.0],
          [3.683464, 51.617240, 7.75],
          [3.683464, 51.617559, 7.0],
          [3.683532, 51.617775, 5.75],
          [3.683604, 51.617929, 4.75],
          [3.683773, 51.618194, 3.0],
          [3.683871, 51.618406, 2.25],
          [3.683894, 51.618481, 2.25],
          [3.683902, 51.618522, 2.25],
          [3.683924, 51.618700, 2.5],
          [3.683932, 51.618733, 2.5],
          [3.683959, 51.618766, 2.5],
          [3.684092, 51.618858, 2.75],
          [3.684212, 51.618942, 3.0],
          [3.684298, 51.618986, 3.25],
          [3.684647, 51.618973, 4.25],
          [3.684905, 51.618964, 4.75],
          [3.685011, 51.618960, 5.0],
          [3.685152, 51.618979, 4.75],
          [3.685500, 51.619076, 3.75],
          [3.685587, 51.619108, 3.5],
          [3.685660, 51.619143, 3.25],
          [3.685736, 51.619205, 3.25],
          [3.685774, 51.619286, 3.25],
          [3.685776, 51.619291, 3.5],
          [3.685830, 51.619722, 5.0],
          [3.685857, 51.619805, 5.0],
          [3.686060, 51.620043, 4.5],
          [3.686182, 51.620239, 4.0],
          [3.686474, 51.620872, 3.0],
          [3.686814, 51.621498, 3.25],
          [3.686881, 51.621660, 3.5],
          [3.686908, 51.621786, 3.75],
          [3.686920, 51.621929, 4.25],
          [3.686923, 51.622199, 4.75],
          [3.686966, 51.622710, 6.0],
          [3.687065, 51.622976, 6.5],
          [3.687098, 51.623063, 6.75],
          [3.687222, 51.623246, 7.0],
          [3.687293, 51.623350, 7.0],
          [3.687794, 51.623961, 5.75],
          [3.688490, 51.624704, 5.5],
          [3.688887, 51.625098, 5.25],
          [3.689918, 51.626030, 4.0],
          [3.690582, 51.626562, 5.0],
          [3.691133, 51.626982, 5.25],
          [3.691721, 51.627398, 4.5],
          [3.692502, 51.627914, 5.25],
          [3.692974, 51.628211, 5.5],
          [3.693502, 51.628518, 5.0],
          [3.693981, 51.628789, 4.75],
          [3.694681, 51.629168, 4.25],
          [3.695875, 51.629772, 4.5],
          [3.695809, 51.629816, 4.75],
          [3.695775, 51.629838, 4.75],
          [3.695235, 51.630203, 6.0],
          [3.694970, 51.630366, 6.25],
          [3.694226, 51.630888, 5.0],
          [3.694372, 51.630987, 5.0],
          [3.699780, 51.634674, 5.75],
          [3.702665, 51.636555, 7.0],
          [3.702773, 51.636623, 7.0],
          [3.702924, 51.636719, 6.75],
          [3.705333, 51.638247, 4.5],
          [3.705534, 51.638374, 4.5],
          [3.705757, 51.638520, 4.5],
          [3.706767, 51.639166, 5.0],
          [3.708000, 51.639955, 4.75],
          [3.708991, 51.640596, 4.75],
          [3.710209, 51.641367, 4.75],
          [3.710365, 51.641453, 4.75],
          [3.710553, 51.641557, 4.75],
          [3.710784, 51.641624, 4.75],
          [3.711188, 51.641666, 4.75],
          [3.712013, 51.641599, 4.75],
          [3.712869, 51.641514, 6.75],
          [3.713121, 51.641514, 7.75],
          [3.713140, 51.641514, 8.0],
          [3.713286, 51.641532, 8.5],
          [3.713431, 51.641576, 8.5],
          [3.713607, 51.641664, 8.0],
          [3.713706, 51.641740, 8.0],
          [3.713810, 51.641847, 8.0],
          [3.714110, 51.642204, 8.0],
          [3.719703, 51.649213, 8.0],
          [3.719838, 51.649384, 8.0],
          [3.720150, 51.649863, 8.0],
          [3.720355, 51.650153, 8.0],
          [3.720578, 51.650448, 8.0],
          [3.720919, 51.650875, 7.75],
          [3.721834, 51.652039, 8.75],
          [3.722127, 51.652501, 8.25],
          [3.722321, 51.652886, 8.0],
          [3.722496, 51.653278, 8.0],
          [3.722672, 51.653776, 8.0],
          [3.722838, 51.654341, 8.0],
          [3.722907, 51.655062, 8.0],
          [3.722937, 51.655235, 8.0],
          [3.722975, 51.655787, 8.0],
          [3.722977, 51.655929, 8.0],
          [3.722925, 51.656854, 8.0],
          [3.722860, 51.657640, 8.0],
          [3.722791, 51.658914, 8.0],
          [3.722548, 51.662692, 8.0],
          [3.722519, 51.663286, 8.0],
          [3.722514, 51.663345, 8.0],
          [3.722570, 51.663424, 8.0],
          [3.722559, 51.663580, 8.0],
          [3.722490, 51.663638, 8.0],
          [3.722479, 51.663771, 8.0],
          [3.722414, 51.664582],
          [3.722277, 51.665810],
          [3.722237, 51.666271],
          [3.722230, 51.666442],
          [3.722244, 51.667025, 6.0],
          [3.722318, 51.667747, 5.0],
          [3.722454, 51.668281, 5.75],
          [3.722578, 51.668678, 6.0],
          [3.723460, 51.670660, 3.5],
          [3.723700, 51.671290, 1.25],
          [3.723713, 51.671454, 0.75],
          [3.723695, 51.671549, 0.25],
          [3.723688, 51.671623, 0.0],
          [3.723689, 51.671786, 0.0],
          [3.723734, 51.671882, 0.0],
          [3.723804, 51.671964, 0.0],
          [3.723898, 51.672039, 0.0],
          [3.724081, 51.672142, 0.0],
          [3.724222, 51.672250, 0.0],
          [3.724384, 51.672427, 0.0],
          [3.726138, 51.675505, -1.0],
          [3.726507, 51.675949, -0.75],
          [3.726948, 51.676397, -1.0],
          [3.727343, 51.676727, -0.75],
          [3.727711, 51.676996, -0.5],
          [3.727885, 51.677134, -0.5],
          [3.727913, 51.677196, -0.5],
          [3.727901, 51.677245, -0.5],
          [3.727900, 51.677250, -0.5],
          [3.727877, 51.677312, -0.5],
          [3.727823, 51.677375, -0.25],
          [3.727402, 51.677755, 0.0],
          [3.726673, 51.678395, 0.0],
          [3.726180, 51.679800, -0.25],
          [3.726040, 51.679980, 0.0],
          [3.725857, 51.680163, 0.0],
          [3.725556, 51.680383, 0.0],
          [3.725445, 51.680451, 0.0],
          [3.725700, 51.680614, 0.0],
          [3.726931, 51.681404, -1.0],
          [3.728362, 51.682385, 0.0],
          [3.729368, 51.683015, 0.5],
          [3.729781, 51.683266, 0.75],
          [3.730142, 51.683501, 1.0],
          [3.731569, 51.684537, 0.0],
          [3.731615, 51.684564, 0.0],
          [3.731653, 51.684609, 0.0],
          [3.731665, 51.684682, 0.0],
          [3.731640, 51.684718, -0.25],
          [3.731579, 51.684761, -0.25],
          [3.731264, 51.684932, -0.25],
          [3.731230, 51.684960, -0.25],
          [3.731097, 51.685009, -0.25],
          [3.729333, 51.685983, 1.75],
          [3.728350, 51.686690, 2.0],
          [3.727455, 51.687431, 2.0],
          [3.727277, 51.687337, 2.0],
          [3.727455, 51.687431, 2.0],
          [3.727851, 51.687646, 2.25],
          [3.728743, 51.688260, 3.0],
          [3.729255, 51.688611, 2.75],
          [3.730045, 51.689174, 2.75],
          [3.730068, 51.689193, 2.75],
          [3.730232, 51.689416, 2.5],
          [3.730330, 51.689448, 2.5],
          [3.730459, 51.689479, 2.5],
          [3.730564, 51.689527, 2.5],
          [3.731048, 51.689861, 2.0],
          [3.731409, 51.690130, 2.0],
          [3.731988, 51.690588, 2.5],
          [3.732157, 51.690705, 2.75],
          [3.732395, 51.690749, 2.75],
          [3.732802, 51.690750, 3.0],
          [3.733052, 51.690752, 3.25],
          [3.733286, 51.690822, 3.75],
          [3.733409, 51.690886, 3.75],
          [3.733499, 51.690965, 3.5],
          [3.733669, 51.691180, 2.75],
          [3.733830, 51.691345, 2.5],
          [3.734089, 51.691453, 2.25],
          [3.734627, 51.691637, 2.5],
          [3.734705, 51.691663, 2.5],
          [3.734985, 51.691771, 2.5],
          [3.735129, 51.691855, 2.25],
          [3.735382, 51.692057, 1.75],
          [3.735736, 51.692407, 1.0],
          [3.735926, 51.692652, 1.25],
          [3.736022, 51.692819, 1.5],
          [3.736355, 51.693375, 2.0],
          [3.736462, 51.693569, 2.0],
          [3.736761, 51.693996, 2.75],
          [3.736914, 51.694142, 2.75],
          [3.736860, 51.694164, 2.75],
          [3.736813, 51.694242, 3.0],
          [3.736721, 51.694426, 3.25],
          [3.736569, 51.694928, 3.5],
          [3.736436, 51.695199, 3.75],
          [3.736358, 51.695398, 3.75],
          [3.736301, 51.695765, 4.25],
          [3.736171, 51.696020, 5.0],
          [3.735379, 51.696914, 7.75],
          [3.735196, 51.697073, 8.25],
          [3.734488, 51.697480, 11.0],
          [3.734271, 51.697664, 12.0],
          [3.734083, 51.697933, 13.0],
          [3.733971, 51.698221, 13.75],
          [3.733593, 51.699187, 11.25],
          [3.733580, 51.699433, 11.0],
          [3.733486, 51.699714, 11.0],
          [3.733359, 51.699986, 11.0],
          [3.733137, 51.700406, 11.5],
          [3.733098, 51.700621, 12.0],
          [3.733081, 51.700721, 12.25],
          [3.732263, 51.701220, 14.0],
          [3.731753, 51.701490, 14.0],
          [3.731693, 51.701550, 14.0],
          [3.731580, 51.702780, 8.5],
          [3.731720, 51.703500, 7.0],
          [3.731800, 51.704340, 6.5],
          [3.731910, 51.704750, 5.5],
          [3.732040, 51.705110, 5.0],
          [3.732230, 51.705480, 5.75],
          [3.732250, 51.705590, 5.75],
          [3.732121, 51.706031, 7.0],
          [3.731973, 51.706517, 9.0],
          [3.731801, 51.706811, 9.75],
          [3.731775, 51.706875, 9.75],
          [3.731796, 51.706974, 9.75],
          [3.731833, 51.707016, 9.75],
          [3.731882, 51.707097, 9.5],
          [3.731901, 51.707142, 9.5],
          [3.731729, 51.707169, 9.75],
          [3.731387, 51.707242, 9.75],
          [3.731141, 51.707338, 9.5],
          [3.730640, 51.707624, 8.5],
          [3.730204, 51.707826, 7.75],
          [3.730033, 51.707899, 7.5],
          [3.728605, 51.708512, 6.25],
          [3.728327, 51.708648, 6.5],
          [3.727979, 51.708859, 6.75],
          [3.727354, 51.709186, 6.75],
          [3.727083, 51.709383, 7.0],
          [3.726748, 51.709673, 7.75],
          [3.726668, 51.709707, 7.75],
          [3.726617, 51.709713, 7.75],
          [3.726570, 51.709741, 7.75],
          [3.726536, 51.709761, 7.75],
          [3.726532, 51.709837, 8.0],
          [3.726441, 51.709917, 8.0],
          [3.726168, 51.710083, 7.5],
          [3.725849, 51.710261, 7.0],
          [3.725470, 51.710450, 6.75],
          [3.725288, 51.710582, 6.75],
          [3.725097, 51.710665, 6.75],
          [3.724241, 51.711423, 4.0],
          [3.723572, 51.712021, 3.5],
          [3.723498, 51.712117, 3.5],
          [3.723338, 51.712278, 3.5],
          [3.723277, 51.712326, 3.5],
          [3.722988, 51.712520, 3.5],
          [3.722940, 51.712577, 3.25],
          [3.722871, 51.712610, 3.25],
          [3.723164, 51.712866, 3.0],
          [3.723242, 51.713024, 2.5],
          [3.723268, 51.713142, 2.25],
          [3.723258, 51.713261, 2.0],
          [3.723236, 51.713294, 2.0],
          [3.722261, 51.714770, 2.5],
          [3.721814, 51.715731, 3.0],
          [3.721330, 51.716520, 3.25],
          [3.721292, 51.716618, 3.5],
          [3.721282, 51.716688, 3.5],
          [3.721337, 51.716756, 3.25],
          [3.721642, 51.716888, 3.5],
          [3.722638, 51.717234, 3.25],
          [3.722898, 51.717318, 3.25],
          [3.723200, 51.717359, 3.5],
          [3.723524, 51.717388, 3.75],
          [3.723781, 51.717433, 3.75],
          [3.726736, 51.718215, 3.0],
          [3.727651, 51.718415, 3.0],
          [3.727845, 51.718490, 3.25],
          [3.727768, 51.718560, 3.25],
          [3.727550, 51.718880, 3.0],
          [3.727362, 51.718950, 3.0],
          [3.727328, 51.718981, 3.0],
          [3.727376, 51.719034, 3.0],
          [3.727420, 51.719060, 3.0],
          [3.727492, 51.719157, 3.0],
          [3.727499, 51.719241, 3.0],
          [3.727329, 51.719526, 3.25],
          [3.727289, 51.719622, 3.5],
          [3.727262, 51.719855, 3.75],
          [3.727238, 51.719951, 3.75],
          [3.727177, 51.720057, 4.0],
          [3.727054, 51.720159, 4.0],
          [3.726612, 51.720425, 4.5],
          [3.726480, 51.720520, 4.5],
          [3.726302, 51.720652, 4.75],
          [3.726245, 51.720727, 4.75],
          [3.726242, 51.720771, 4.75],
          [3.726254, 51.720809, 4.75],
          [3.726380, 51.721066, 4.75],
          [3.726344, 51.721130, 4.75],
          [3.725438, 51.722410, 3.5],
          [3.725326, 51.722580, 3.25],
          [3.721772, 51.727579, 8.75],
          [3.721681, 51.727684, 8.75],
          [3.721616, 51.727719, 8.75],
          [3.721342, 51.727788, 9.75],
          [3.720658, 51.727927, 11.75],
          [3.720528, 51.727943, 12.0],
          [3.720056, 51.727945, 13.25],
          [3.719858, 51.727955, 13.75],
          [3.719661, 51.727991, 14.0],
          [3.719370, 51.728082, 14.75],
          [3.719233, 51.728141, 15.0],
          [3.719188, 51.728178, 15.0],
          [3.719161, 51.728223, 15.0],
          [3.719082, 51.728333, 15.0],
          [3.718916, 51.728461, 14.0],
          [3.718760, 51.728859, 10.25],
          [3.718820, 51.729044, 8.5],
          [3.718474, 51.729397, 6.5],
          [3.718387, 51.729515, 6.0],
          [3.718247, 51.729737, 5.25],
          [3.718771, 51.729986, 5.0],
          [3.721072, 51.730657, 5.0],
          [3.721862, 51.730916, 5.0],
          [3.722958, 51.731277],
          [3.724511, 51.731541, 2.5],
          [3.725699, 51.731866, 2.5],
          [3.726684, 51.732087, 4.5],
          [3.727107, 51.732135, 4.5],
          [3.728097, 51.732413, 3.5],
          [3.728698, 51.732515, 3.5],
          [3.729388, 51.732681, 3.5],
          [3.732311, 51.733398, 3.5],
          [3.733405, 51.733769, 3.5],
          [3.734069, 51.733918, 3.5],
          [3.734498, 51.734063, 3.5],
          [3.735417, 51.734309, 3.5],
          [3.737439, 51.734772, 3.5],
          [3.737881, 51.734898, 4.0],
          [3.738101, 51.734927, 4.5],
          [3.738230, 51.734708, 5.75],
          [3.738450, 51.734564, 6.25],
          [3.739515, 51.734487, 5.75],
          [3.739974, 51.734495, 5.25],
          [3.740864, 51.734591, 6.0],
          [3.741146, 51.734621, 6.0],
          [3.741421, 51.734502, 5.5],
          [3.741519, 51.734460, 5.25],
          [3.741784, 51.734326, 4.5],
          [3.741928, 51.734215, 3.75],
          [3.741940, 51.734206, 3.75],
          [3.742932, 51.734292, 3.0],
          [3.743131, 51.734280, 2.5],
          [3.743235, 51.734292, 2.5],
          [3.745394, 51.734944, 3.25],
          [3.745094, 51.735379, 5.0],
          [3.745832, 51.735711, 5.5],
          [3.746486, 51.735890, 5.25],
          [3.746800, 51.735952, 5.25],
          [3.747167, 51.735966, 5.0],
          [3.747604, 51.736067, 5.25],
          [3.747961, 51.736183, 5.75],
          [3.748458, 51.736228, 5.5],
          [3.748696, 51.736209, 5.25],
          [3.748970, 51.736283, 5.25],
          [3.749859, 51.736647, 5.25],
          [3.750407, 51.736858, 5.5],
          [3.750789, 51.737022, 5.75],
          [3.751108, 51.737102, 5.5],
          [3.751312, 51.737121, 5.25],
          [3.751473, 51.737101, 4.75],
          [3.751684, 51.737030, 4.25],
          [3.752017, 51.736889, 3.75],
          [3.752154, 51.736950, 4.0],
          [3.752502, 51.737042, 4.25],
          [3.752737, 51.737112, 4.5],
          [3.753044, 51.737232, 5.0],
          [3.753308, 51.737314, 5.5],
          [3.755276, 51.737786, 6.25],
          [3.755481, 51.737871, 6.5],
          [3.755832, 51.737957, 6.5],
          [3.756030, 51.738032, 6.5],
          [3.756485, 51.738147, 6.5],
          [3.756946, 51.738286, 6.75],
          [3.757667, 51.738445, 6.75],
          [3.758259, 51.738560, 6.75],
          [3.759163, 51.738688, 6.75],
          [3.759982, 51.738771, 5.5],
          [3.760246, 51.738782, 5.5],
          [3.760717, 51.738870, 5.5],
          [3.761172, 51.738997, 5.5],
          [3.761307, 51.739027, 5.5],
          [3.761970, 51.739178, 6.0],
          [3.762302, 51.739269, 6.5],
          [3.762487, 51.739350, 7.0],
          [3.762689, 51.739412, 7.0],
          [3.763246, 51.739507, 7.0],
          [3.763527, 51.739578, 7.25],
          [3.763798, 51.739628, 7.25],
          [3.764036, 51.739663, 7.25],
          [3.764580, 51.739777, 7.0],
          [3.764838, 51.739859, 6.75],
          [3.765057, 51.739974, 6.75],
          [3.765236, 51.740087, 7.0],
          [3.765293, 51.740093, 7.0],
          [3.765349, 51.740086, 7.0],
          [3.765529, 51.739984, 6.25],
          [3.765595, 51.739933, 6.0],
          [3.765651, 51.739868, 5.75],
          [3.765754, 51.739797, 5.5],
          [3.765818, 51.739732, 5.25],
          [3.765848, 51.739657, 5.0],
          [3.765893, 51.739603, 5.0],
          [3.765980, 51.739567, 4.75],
          [3.766040, 51.739551, 4.75],
          [3.766199, 51.739464, 4.75],
          [3.766378, 51.739419, 4.75],
          [3.766490, 51.739413, 4.75],
          [3.766568, 51.739430, 4.75],
          [3.767161, 51.739529, 5.0],
          [3.767942, 51.739669, 5.0],
          [3.769010, 51.739930, 5.0],
          [3.770570, 51.740250, 6.25],
          [3.771760, 51.740430, 5.5],
          [3.771862, 51.740455, 5.5],
          [3.772031, 51.740496, 5.5],
          [3.772303, 51.740549, 5.5],
          [3.773549, 51.740615, 6.0],
          [3.773751, 51.740621, 6.0],
          [3.774824, 51.740656, 5.25],
          [3.774917, 51.740661, 5.25],
          [3.774989, 51.740732, 5.0],
          [3.774901, 51.740860, 5.25],
          [3.774874, 51.740914, 5.5],
          [3.775680, 51.740990, 5.75],
          [3.776201, 51.741025, 5.5],
          [3.776643, 51.741072, 5.25],
          [3.777779, 51.741205, 6.0]
        ]
      }
    }
  ]
}

let day6: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "6 - Renesse - Hook of Holland - 66.8km",
        "track-length": "71180",
        "filtered ascend": "97",
        "plain-ascend": "22",
        "total-time": "17004",
        "total-energy": "1092729",
        "cost": "131196",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["3780498", "51741513", "7", "192", "1000", "0", "0", "0", "0", "highway=cycleway surface=fine_gravel foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "26", "2669"],
          ["3783484", "51741862", "7", "218", "1000", "0", "0", "0", "0", "highway=cycleway surface=fine_gravel foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "62", "6242"],
          ["3783892", "51741684", "7", "38", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "68", "6875"],
          ["3785651", "51741874", "6", "126", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt access=yes foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "88", "8848"],
          ["3789758", "51741513", "4", "295", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes bicycle=yes cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "130", "13073"],
          ["3795699", "51740144", "0", "441", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt bicycle=designated cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "189", "18992"],
          ["3804022", "51739235", "1", "587", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes bicycle=designated cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "289", "28994"],
          ["3811187", "51738979", "2", "500", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt bicycle=designated cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "379", "38002"],
          ["3814939", "51739080", "5", "273", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "440", "44079"],
          ["3817762", "51738838", "6", "199", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "477", "47740"],
          ["3823312", "51739130", "7", "405", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "561", "56205"],
          ["3823190", "51739296", "8", "21", "5050", "0", "168", "0", "0", "reversedirection=yes highway=footway surface=paved", "", "576", "56396"],
          ["3823312", "51739130", "7", "22", "5050", "0", "2", "0", "0", "highway=footway surface=paved", "", "591", "56396"],
          ["3840292", "51757507", "5", "2592", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=bad route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "995", "96873"],
          ["3848849", "51759946", "6", "654", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1112", "108537"],
          ["3849331", "51760103", "6", "38", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1119", "109204"],
          ["3853777", "51762979", "6", "483", "1350", "0", "240", "0", "0", "highway=unclassified", "", "1200", "117378"],
          ["3869686", "51784830", "7", "2688", "5350", "0", "85", "0", "0", "highway=unclassified surface=asphalt bicycle=no", "", "3119", "141511"],
          ["3869805", "51785028", "7", "24", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt", "", "3125", "142030"],
          ["3869659", "51785064", "7", "11", "5050", "0", "88", "0", "0", "reversedirection=yes highway=footway", "", "3133", "142183"],
          ["3870605", "51787356", "7", "267", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid access=yes", "3182", "147086"],
          ["3871000", "51788520", "5", "134", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3198", "148733"],
          ["3871213", "51788807", "5", "36", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3203", "149250"],
          ["3874629", "51790302", "2", "304", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3250", "153915"],
          ["3873511", "51791465", "3", "153", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3272", "156111"],
          ["3870385", "51798590", "1", "877", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "3417", "170627"],
          ["3870446", "51798671", "1", "11", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3419", "170800"],
          ["3864373", "51803974", "0", "901", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3567", "185636"],
          ["3862700", "51807600", "0", "425", "1000", "0", "0", "0", "0", "highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3637", "192609"],
          ["3862632", "51807638", "0", "7", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "3638", "192733"],
          ["3864720", "51811158", "1", "467", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "3708", "199750"],
          ["3870718", "51813921", "1", "530", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3800", "208900"],
          ["3877112", "51816940", "1", "560", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "3893", "218206"],
          ["3879985", "51818054", "1", "237", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3933", "222242"],
          ["3883401", "51818860", "1", "272", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "3982", "227089"],
          ["3889933", "51820933", "1", "518", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4066", "235575"],
          ["3889976", "51821032", "1", "12", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "4068", "235753"],
          ["3930016", "51829123", "9", "3208", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4654", "294309"],
          ["3933039", "51828581", "3", "245", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4681", "297065"],
          ["3933066", "51828494", "2", "10", "1050", "0", "1", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt", "", "4682", "297181"],
          ["3932773", "51828423", "2", "12", "1350", "0", "73", "0", "0", "highway=service oneway=yes", "", "4684", "297325"],
          ["3933066", "51828494", "2", "12", "5350", "0", "0", "0", "0", "reversedirection=yes highway=service oneway=yes", "", "4692", "297325"],
          ["3933039", "51828581", "3", "10", "1050", "0", "73", "0", "0", "highway=cycleway surface=asphalt", "", "4693", "297431"],
          ["3933877", "51827902", "1", "116", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4705", "298670"],
          ["3933914", "51827837", "1", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cycle_barrier bicycle=yes", "4706", "298768"],
          ["3936025", "51822154", "3", "658", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cycle_barrier bicycle=yes", "4821", "310261"],
          ["3936044", "51822126", "3", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4822", "310329"],
          ["3937427", "51820842", "3", "195", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4853", "313468"],
          ["3937500", "51820452", "3", "15", "1350", "0", "91", "0", "0", "reversedirection=yes highway=service tracktype=grade1", "", "4856", "313714"],
          ["3937427", "51820842", "3", "15", "1350", "0", "0", "0", "0", "highway=service tracktype=grade1", "", "4857", "313856"],
          ["3938551", "51820916", "3", "78", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4867", "314821"],
          ["3943027", "51819941", "3", "356", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4921", "320278"],
          ["3949317", "51822199", "1", "521", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5000", "328118"],
          ["3958707", "51826131", "3", "788", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5143", "342503"],
          ["3959059", "51822972", "0", "484", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5209", "349116"],
          ["3965727", "51814932", "-1", "1062", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5381", "366270"],
          ["3965576", "51814452", "-1", "75", "1350", "0", "95", "0", "0", "reversedirection=yes highway=unclassified", "", "5394", "367593"],
          ["3965727", "51814932", "-1", "75", "1350", "0", "95", "0", "0", "highway=unclassified", "", "5402", "368407"],
          ["3973564", "51816905", "0", "588", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5500", "378174"],
          ["3975145", "51817646", "1", "165", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5531", "381306"],
          ["3976097", "51817861", "2", "73", "1000", "0", "0", "0", "0", "highway=residential access=no foot=yes bicycle=yes vehicle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "5547", "382886"],
          ["3976172", "51817879", "2", "6", "1000", "0", "0", "0", "0", "highway=residential access=no foot=yes bicycle=yes vehicle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5548", "383019"],
          ["3977193", "51818164", "3", "78", "1000", "0", "0", "0", "0", "highway=residential access=no foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5569", "385025"],
          ["3977557", "51818178", "3", "26", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5575", "385621"],
          ["3977620", "51817832", "3", "41", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5581", "386295"],
          ["3977470", "51817777", "3", "13", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5582", "386420"],
          ["3977470", "51817728", "3", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "5583", "386479"],
          ["3977515", "51817465", "2", "30", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5586", "386777"],
          ["3978621", "51817076", "2", "103", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5600", "388122"],
          ["3978905", "51816491", "1", "68", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5608", "388924"],
          ["3982697", "51816738", "0", "340", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5650", "393171"],
          ["3982905", "51816683", "0", "16", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "5652", "393401"],
          ["3983016", "51816847", "0", "15", "1050", "0", "90", "0", "0", "highway=cycleway", "", "5655", "393634"],
          ["3982905", "51816683", "0", "15", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "5656", "393771"],
          ["3982697", "51816738", "0", "16", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "5658", "393933"],
          ["3982984", "51817303", "1", "92", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5670", "395164"],
          ["3982831", "51817715", "1", "48", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5678", "395929"],
          ["3982932", "51817726", "1", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "5678", "396008"],
          ["4002404", "51826825", "0", "1752", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5961", "424258"],
          ["4001532", "51831768", "0", "566", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6050", "433135"],
          ["4001726", "51832599", "2", "98", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6069", "435078"],
          ["4001360", "51832835", "2", "15", "1000", "0", "0", "0", "0", "highway=service access=destination bicycle=yes route_bicycle_rcn=yes", "", "6072", "435392"],
          ["4001726", "51832599", "2", "15", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service access=destination bicycle=yes route_bicycle_rcn=yes", "", "6074", "435534"],
          ["4007168", "51829758", "1", "516", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6150", "443167"],
          ["4010611", "51831665", "3", "320", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6205", "448704"],
          ["4011052", "51831916", "4", "42", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6214", "449601"],
          ["4011652", "51832177", "5", "63", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6226", "450818"],
          ["4037063", "51821099", "2", "2227", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6580", "486137"],
          ["4037278", "51820960", "2", "22", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6583", "486452"],
          ["4037246", "51820796", "2", "19", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_rcn=yes", "", "6586", "486735"],
          ["4037278", "51820960", "2", "19", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "", "6587", "486916"],
          ["4038543", "51821977", "2", "146", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6604", "488601"],
          ["4040040", "51823090", "0", "163", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6625", "490692"],
          ["4040970", "51823791", "0", "102", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6640", "492231"],
          ["4041976", "51824599", "5", "120", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "6676", "495760"],
          ["4043341", "51825157", "7", "150", "1050", "0", "101", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "6715", "499721"],
          ["4043444", "51825536", "7", "45", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service", "", "6726", "500834"],
          ["4042722", "51825611", "9", "51", "1350", "0", "90", "0", "0", "highway=service", "", "6743", "502485"],
          ["4042649", "51825467", "8", "1", "1350", "0", "77", "0", "0", "reversedirection=yes highway=service", "", "6743", "502511"],
          ["4042722", "51825611", "9", "1", "1350", "0", "0", "0", "0", "highway=service", "", "6743", "502521"],
          ["4043444", "51825536", "9", "51", "1350", "0", "77", "0", "0", "reversedirection=yes highway=service", "", "6749", "503056"],
          ["4043341", "51825157", "9", "45", "1350", "0", "90", "0", "0", "highway=service", "", "6754", "503607"],
          ["4041976", "51824599", "5", "150", "1050", "0", "13", "0", "0", "highway=cycleway oneway=no", "", "6770", "505155"],
          ["4041763", "51824675", "6", "17", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_rcn=yes", "", "6773", "505445"],
          ["4041988", "51825094", "8", "50", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "6786", "506834"],
          ["4044771", "51828927", "2", "476", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6875", "515596"],
          ["4054854", "51836415", "6", "1085", "1000", "0", "0", "0", "0", "highway=unclassified surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7060", "534119"],
          ["4058521", "51838683", "9", "360", "1000", "0", "0", "0", "0", "highway=unclassified cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "7136", "541753"],
          ["4074550", "51844377", "5", "1293", "1000", "0", "0", "0", "0", "highway=unclassified cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7332", "561280"],
          ["4085987", "51846563", "0", "852", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7456", "573678"],
          ["4084825", "51845433", "0", "166", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt foot=yes cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7479", "576047"],
          ["4084844", "51845250", "0", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified foot=yes cycleway=lane route_bicycle_rcn=yes", "", "7483", "576378"],
          ["4084825", "51845433", "0", "23", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes cycleway=lane route_bicycle_rcn=yes", "", "7485", "576599"],
          ["4084400", "51846500", "1", "123", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7502", "578337"],
          ["4083817", "51848077", "0", "181", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7529", "581019"],
          ["4084306", "51849941", "0", "230", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7562", "584298"],
          ["4073023", "51866041", "0", "2385", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7956", "623688"],
          ["4071395", "51865788", "0", "127", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7977", "625858"],
          ["4062123", "51868470", "2", "823", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8129", "641020"],
          ["4059771", "51872057", "4", "438", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8197", "647852"],
          ["4057935", "51872162", "8", "133", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8241", "652257"],
          ["4053871", "51874453", "6", "422", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8305", "658638"],
          ["4048857", "51876562", "7", "436", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8390", "667099"],
          ["4048435", "51877075", "6", "70", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8399", "668039"],
          ["4047940", "51877012", "6", "12", "1350", "0", "92", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=no", "", "8401", "668197"],
          ["4048435", "51877075", "6", "12", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt oneway=no", "", "8402", "668309"],
          ["4051003", "51877073", "5", "185", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8425", "670632"],
          ["4050734", "51878137", "5", "126", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard bicycle=yes", "8440", "672115"],
          ["4053282", "51879320", "4", "242", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard bicycle=yes", "8470", "675101"],
          ["4053334", "51879344", "4", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8470", "675178"],
          ["4053389", "51879371", "4", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard bicycle=yes", "8471", "675254"],
          ["4053875", "51879869", "4", "89", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard bicycle=yes", "8485", "676632"],
          ["4053967", "51879884", "4", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "", "8486", "676748"],
          ["4054099", "51879934", "4", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard bicycle=yes", "8488", "676946"],
          ["4054623", "51884881", "3", "755", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard bicycle=yes", "8598", "687957"],
          ["4056555", "51887146", "2", "332", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt access=destination foot=yes bicycle=yes cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8672", "695304"],
          ["4059457", "51887105", "0", "227", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt access=yes foot=yes bicycle=yes cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8697", "697848"],
          ["4064514", "51890086", "0", "538", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8780", "706161"],
          ["4064558", "51890129", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "8781", "706268"],
          ["4070571", "51895621", "0", "841", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "8915", "719624"],
          ["4070654", "51898949", "7", "435", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=destination bicycle=yes cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9029", "731034"],
          ["4069918", "51901215", "7", "272", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9081", "736254"],
          ["4070023", "51901714", "4", "59", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9087", "736869"],
          ["4070441", "51903746", "5", "315", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9135", "741657"],
          ["4077852", "51908839", "7", "860", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9274", "755557"],
          ["4077531", "51909113", "7", "38", "1000", "0", "0", "0", "0", "highway=unclassified surface=cobblestone foot=yes bicycle=yes cycleway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "9279", "756014"],
          ["4065869", "51915142", "4", "1098", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9446", "772766"],
          ["4064362", "51915563", "5", "117", "1000", "0", "0", "0", "0", "highway=cycleway surface=cobblestone route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "9468", "774918"],
          ["4064251", "51915663", "5", "14", "1000", "0", "0", "0", "0", "highway=cycleway surface=cobblestone route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9470", "775192"],
          ["4064131", "51915644", "5", "9", "1350", "0", "76", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones", "", "9472", "775365"],
          ["4062859", "51915424", "5", "29", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt", "", "9478", "775945"],
          ["4064131", "51915644", "5", "29", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt", "", "9481", "776217"],
          ["4064251", "51915663", "5", "9", "1350", "0", "0", "0", "0", "highway=unclassified surface=paving_stones", "", "9482", "776309"],
          ["4064223", "51915731", "5", "8", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9482", "776392"],
          ["4062789", "51915539", "6", "106", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes barrier=bollard", "9497", "777877"],
          ["4040941", "51926315", "4", "1945", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "9814", "809553"],
          ["4040902", "51926396", "4", "10", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "9815", "809701"],
          ["4040506", "51926551", "4", "40", "1350", "0", "105", "0", "0", "highway=unclassified surface=asphalt oneway=no", "", "9820", "810171"],
          ["4037852", "51926150", "5", "194", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "9846", "812770"],
          ["4037810", "51926005", "5", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no route_bicycle_rcn=yes", "", "9847", "812872"],
          ["4037852", "51926150", "5", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no route_bicycle_rcn=yes", "", "9848", "812928"],
          ["4018922", "51931388", "5", "1444", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "10081", "836296"],
          ["4018244", "51931538", "6", "51", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "10095", "837637"],
          ["4018182", "51931552", "6", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "10096", "837774"],
          ["4017187", "51931791", "7", "20", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_rcn=yes", "", "10102", "838356"],
          ["4018182", "51931552", "6", "20", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_rcn=yes", "", "10104", "838535"],
          ["4018199", "51931584", "6", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "10104", "838573"],
          ["4018280", "51931707", "6", "17", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "10106", "838733"],
          ["4018783", "51932221", "4", "72", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "10112", "839394"],
          ["4018888", "51932395", "4", "23", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "10115", "839627"],
          ["4019066", "51932691", "4", "36", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "10119", "840031"],
          ["4019141", "51932826", "3", "18", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "10121", "840223"],
          ["4016811", "51937880", "2", "622", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10217", "849840"],
          ["4015589", "51939887", "2", "239", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals barrier=lift_gate access=yes traffic_signals:direction=backward", "10257", "853824"],
          ["4015534", "51939977", "2", "12", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals barrier=lift_gate access=yes traffic_signals:direction=forward", "10259", "854025"],
          ["4016462", "51951778", "-8192", "1525", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10531", "881283"],
          ["4021027", "51952986", "-8192", "352", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10586", "886761"],
          ["4019261", "51956183", "1", "381", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10631", "891225"],
          ["4018347", "51957355", "5", "150", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "10668", "894931"],
          ["4018181", "51957644", "5", "36", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "10677", "895913"],
          ["4045826", "51966095", "0", "4111", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11377", "965858"],
          ["4046003", "51966054", "0", "13", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no", "", "11379", "966076"],
          ["4045668", "51966094", "0", "21", "1350", "0", "179", "0", "0", "reversedirection=yes highway=service", "", "11383", "966429"],
          ["4046003", "51966054", "-8192", "21", "1350", "0", "98", "0", "0", "highway=service", "", "11385", "966630"],
          ["4045826", "51966095", "-8192", "13", "1050", "0", "81", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no", "", "11386", "966763"],
          ["4045976", "51966364", "-8192", "32", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11389", "967117"],
          ["4046158", "51966703", "-8192", "40", "1000", "0", "0", "0", "0", "highway=path route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11394", "967610"],
          ["4125194", "51977046", "2", "6850", "5670", "0", "0", "0", "10000", "reversedirection=yes foot=yes bicycle=yes route=ferry route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16276", "1027330"],
          ["4125354", "51977230", "2", "24", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paved route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16281", "1027818"],
          ["4125441", "51977323", "2", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=metal smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "16284", "1028054"],
          ["4125516", "51977408", "2", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=metal smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16285", "1028176"],
          ["4125536", "51977431", "2", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones smoothness=intermediate route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16285", "1028205"],
          ["4126717", "51977058", "5", "97", "1000", "0", "0", "0", "0", "highway=unclassified surface=paving_stones bicycle=yes oneway=yes smoothness=intermediate route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16300", "1029657"],
          ["4126676", "51977131", "5", "9", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones bicycle=yes smoothness=intermediate route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16301", "1029829"],
          ["4126802", "51977153", "5", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "16303", "1030018"],
          ["4126922", "51977291", "5", "20", "1050", "0", "72", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good", "railway=crossing", "16307", "1030390"],
          ["4127077", "51977369", "5", "14", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good", "railway=crossing", "16309", "1030645"],
          ["4126693", "51978077", "5", "93", "1050", "0", "27", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good", "", "16326", "1032290"],
          ["4126840", "51978376", "5", "51", "5050", "0", "37", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "16362", "1032764"],
          ["4130966", "51980329", "4", "367", "1050", "0", "1", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "", "16428", "1039350"],
          ["4131241", "51980297", "3", "21", "1050", "0", "78", "0", "0", "reversedirection=yes highway=cycleway", "", "16431", "1039618"],
          ["4131339", "51980460", "3", "7", "1050", "0", "67", "0", "0", "highway=cycleway oneway=yes", "", "16432", "1039703"],
          ["4131241", "51980297", "3", "7", "5050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=yes", "", "16436", "1039703"],
          ["4129143", "51984859", "2", "589", "1050", "0", "137", "0", "0", "highway=cycleway", "", "16513", "1047401"],
          ["4128149", "51984505", "2", "13", "1050", "0", "74", "0", "0", "highway=cycleway oneway=no", "", "16515", "1047605"],
          ["4129561", "51985006", "1", "47", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "16520", "1048061"],
          ["4131028", "51986482", "2", "198", "1050", "0", "46", "0", "0", "highway=cycleway oneway=no", "", "16547", "1050831"],
          ["4130854", "51986558", "2", "15", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "16550", "1051071"],
          ["4130767", "51986603", "2", "8", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "16551", "1051199"],
          ["4130976", "51986994", "1", "49", "1050", "0", "106", "0", "0", "highway=cycleway oneway=no", "highway=crossing crossing=uncontrolled", "16559", "1051960"],
          ["4131211", "51986912", "1", "20", "1450", "0", "94", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "", "16562", "1052275"],
          ["4131195", "51986800", "1", "10", "21450", "0", "83", "0", "0", "reversedirection=yes highway=tertiary oneway=yes", "", "16569", "1052350"],
          ["4131188", "51986972", "1", "17", "1450", "0", "4", "0", "0", "highway=tertiary oneway=yes", "", "16571", "1052511"],
          ["4131045", "51987043", "1", "13", "1450", "0", "19", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "highway=crossing crossing=uncontrolled", "16572", "1052642"],
          ["4130787", "51987123", "2", "21", "1450", "0", "4", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "", "16574", "1052872"],
          ["4127888", "51987878", "2", "222", "1450", "0", "4", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt bicycle=use_sidepath", "", "16608", "1056205"],
          ["4127247", "51988125", "3", "54", "1450", "0", "9", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "", "16618", "1057267"],
          ["4127180", "51988047", "3", "10", "1350", "0", "93", "0", "0", "reversedirection=yes highway=unclassified", "", "16620", "1057459"],
          ["4127524", "51987946", "3", "3", "1450", "0", "94", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "", "16621", "1057516"],
          ["4127180", "51988047", "3", "3", "21450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "", "16623", "1057516"],
          ["4127684", "51989709", "2", "209", "1350", "0", "102", "0", "0", "highway=unclassified", "", "16648", "1060016"],
          ["4127544", "51989909", "2", "26", "1350", "0", "0", "0", "0", "highway=service access=destination", "barrier=lift_gate", "16651", "1060370"],
          ["4127408", "51990104", "1", "24", "1350", "0", "0", "0", "0", "highway=service access=destination", "highway=crossing", "16654", "1060691"],
          ["4126210", "51991838", "1", "211", "1350", "0", "0", "0", "0", "highway=service surface=asphalt access=destination bicycle=yes", "highway=crossing", "16686", "1063844"],
          ["4125967", "51992412", "2", "72", "1350", "0", "7", "0", "0", "highway=service surface=asphalt access=destination bicycle=yes", "", "16700", "1065222"],
          ["4126726", "51993269", "0", "117", "1350", "0", "107", "0", "0", "highway=service surface=asphalt access=destination foot=yes bicycle=yes", "", "16716", "1066826"],
          ["4126800", "51993240", "0", "7", "1350", "0", "83", "0", "0", "highway=service surface=paving_stones access=destination bicycle=yes", "barrier=gate access=destination motor_vehicle=no", "16717", "1066921"],
          ["4126830", "51993229", "0", "3", "1350", "0", "0", "0", "0", "highway=service surface=paving_stones access=destination bicycle=yes", "", "16717", "1066962"],
          ["4127161", "51993592", "0", "22", "5050", "0", "262", "0", "0", "reversedirection=yes highway=footway surface=paving_stones", "", "16732", "1067025"],
          ["4126830", "51993229", "0", "22", "5050", "0", "132", "0", "0", "highway=footway surface=paving_stones", "", "16747", "1067025"],
          ["4126800", "51993240", "0", "3", "1350", "0", "130", "0", "0", "reversedirection=yes highway=service surface=paving_stones access=destination bicycle=yes", "barrier=gate access=destination motor_vehicle=no", "16747", "1067056"],
          ["4126726", "51993269", "0", "7", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service surface=paving_stones access=destination bicycle=yes", "", "16748", "1067128"],
          ["4126687", "51993288", "0", "4", "1350", "0", "0", "0", "0", "highway=service cycleway=shared_lane", "barrier=bollard", "16748", "1067169"],
          ["4126405", "51993420", "1", "25", "1350", "0", "0", "0", "0", "highway=service cycleway=shared_lane", "barrier=bollard", "16751", "1067502"],
          ["4126288", "51993475", "1", "11", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt", "", "16753", "1067653"],
          ["4127036", "51994155", "3", "93", "1050", "0", "85", "0", "0", "highway=cycleway cycleway=shared_lane", "", "16766", "1068932"],
          ["4126032", "51993589", "3", "94", "1050", "0", "177", "0", "0", "reversedirection=yes highway=cycleway", "", "16776", "1069931"],
          ["4123945", "51994463", "5", "176", "1050", "0", "69", "0", "0", "highway=cycleway surface=asphalt", "", "16802", "1072598"],
          ["4124324", "51994624", "5", "3", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16803", "1072651"],
          ["4123681", "51994272", "5", "31", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16806", "1072945"],
          ["4118003", "51991214", "5", "532", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "16887", "1081030"],
          ["4110096", "51987424", "3", "706", "1050", "0", "89", "0", "0", "reversedirection=yes highway=cycleway", "", "17004", "1092753"]
        ],
        "times": [0, 4.245, 9.025, 14.489, 26.685, 32.085, 33.476, 35.236, 36.723, 40.665, 45.597, 50.061, 51.884, 56.204, 58.864, 62.422, 63.978, 65.357, 68.753, 70.705, 81.498, 88.478, 95.184, 101.591, 105.723, 113.306, 116.627, 119.364, 128.658, 130.304, 130.721, 141.641, 153.225, 164.301, 179.084, 189.9, 197.466, 201.689, 261.724, 277.386, 289.92, 295.073, 305.869, 335.84, 349.476, 357.224, 360.296, 368.936, 379.993, 381.145, 382.477, 384.091, 405.43, 417.829, 421.81, 434.353, 440.753, 459.739, 468.144, 473.513, 477.358, 480.269, 483.422, 514.931, 535.06, 538.389, 540.698, 543.114, 545.285, 547.419, 549.9, 552.714, 554.637, 556.553, 559.485, 560.099, 561.99, 576.991, 577.635, 591.087, 591.95, 602.055, 603.713, 617.783, 620.711, 622.182, 623.492, 628.94, 648.169, 668.385, 719.108, 741.705, 749.579, 754.502, 757.593, 765.183, 771.048, 779.051, 798.067, 815.925, 829.188, 830.315, 840.691, 862.705, 875.053, 894.509, 908.438, 927.579, 985.681, 995.819, 1037.571, 1068.845, 1094.122, 1112.458, 1119.124, 1122.421, 1131.701, 1138.006, 1165.738, 1195.828, 1198.18, 1200.868, 1266.626, 1318.673, 1372.996, 1446.366, 1507.718, 1589.123, 1813.543, 2084.432, 2441.546, 2555.946, 2564.515, 2605.227, 2660.957, 2800.971, 2941.928, 3092.849, 3119.883, 3125.076, 3133.083, 3137.731, 3144.104, 3158.435, 3165.947, 3173.078, 3182.115, 3187.335, 3193.568, 3198.58, 3203.744, 3207.326, 3210.504, 3216.856, 3224.358, 3231.456, 3237.71, 3243.985, 3249.019, 3250.396, 3270.22, 3272.345, 3273.985, 3278.338, 3293.616, 3323.95, 3379.578, 3383.628, 3385.652, 3387.741, 3392, 3395.112, 3417.494, 3418.438, 3419.228, 3422.229, 3435.025, 3449.411, 3461.67, 3464.139, 3471.392, 3480.142, 3482.891, 3485.362, 3488.766, 3503.086, 3505.316, 3515.889, 3529.599, 3532.338, 3546.509, 3547.453, 3548.4, 3549.351, 3550.146, 3551.195, 3552.477, 3553.486, 3559.569, 3567.564, 3571.389, 3577.518, 3582.333, 3584.833, 3608.301, 3616.924, 3630.631, 3637.285, 3638.527, 3641.348, 3643.945, 3645.233, 3646.009, 3647.382, 3648.805, 3649.536, 3650.279, 3651.799, 3652.706, 3655.237, 3704.25, 3705.411, 3706.573, 3708.7, 3710.111, 3711.691, 3717.785, 3721.065, 3733.189, 3741.109, 3742.702, 3753.48, 3760.009, 3778.923, 3787.574, 3798.044, 3800.189, 3817.922, 3821.667, 3830.138, 3836.142, 3862.473, 3877.82, 3893.255, 3894.89, 3904.849, 3910.281, 3913.66, 3924.717, 3931.434, 3933.609, 3936.639, 3944.625, 3963.808, 3966.699, 3968.489, 3970.58, 3972.083, 3973.016, 3974.683, 3978.117, 3982.075, 3983.392, 3984.876, 3986.286, 3989.265, 3993.092, 3995.341, 3997.582, 4001.7, 4004.434, 4033.309, 4060.646, 4061.954, 4063.593, 4065.137, 4065.758, 4066.343, 4066.931, 4067.523, 4068.714, 4069.464, 4090.149, 4090.974, 4091.799, 4092.263, 4101.589, 4106.761, 4110.817, 4124.237, 4132.234, 4141.559, 4150.646, 4157.453, 4165.415, 4168.963, 4170.286, 4176.224, 4182.168, 4189.807, 4190.432, 4191.687, 4192.791, 4193.582, 4195.275, 4199.231, 4200.301, 4202.008, 4203.696, 4205.683, 4207.442, 4209.753, 4229.821, 4240.597, 4245.538, 4259.794, 4270.475, 4275.114, 4285.75, 4301.975, 4304.658, 4307.854, 4310.627, 4320.846, 4355.248, 4362.029, 4366.521, 4368.049, 4368.918, 4369.647, 4380.422, 4387.565, 4403.104, 4406.116, 4409.663, 4413.53, 4417.704, 4437.238, 4453.229, 4458.524, 4460.199, 4465.633, 4472.24, 4477.815, 4482.805, 4489.945, 4497.757, 4504.366, 4514.814, 4517.479, 4521.381, 4523.666, 4529.066, 4535.445, 4543.857, 4546.995, 4583.441, 4587.11, 4590.924, 4604.934, 4608.083, 4618.447, 4633.333, 4651.732, 4654.203, 4661.149, 4664.137, 4665.312, 4666.465, 4677.938, 4678.788, 4679.733, 4680.509, 4681.76, 4682.921, 4684.361, 4692.13, 4693.192, 4694.181, 4694.936, 4695.709, 4696.249, 4696.774, 4704.027, 4704.856, 4705.581, 4706.565, 4707.191, 4713.006, 4717.708, 4732.498, 4747.303, 4763.624, 4793.728, 4800.595, 4807.41, 4813.169, 4821.471, 4822.158, 4827.295, 4829.379, 4831.474, 4835.459, 4837.328, 4840.159, 4842.861, 4848.981, 4853.544, 4856.003, 4857.42, 4864.411, 4867.073, 4869, 4871.118, 4876.993, 4880.712, 4882.284, 4883.845, 4885.432, 4888.827, 4892.158, 4895.711, 4906.228, 4908.235, 4910.244, 4911.583, 4921.638, 4922.267, 4927.669, 4950.187, 4952.308, 4954.601, 4956.454, 4958.324, 4960.1, 4961.513, 4963.974, 4978.855, 4981.971, 4990.286, 5000.03, 5008.967, 5025.059, 5040.457, 5075.515, 5082.81, 5119.578, 5134.334, 5143.867, 5147.772, 5150.08, 5154.996, 5166.161, 5172.761, 5174.847, 5186.943, 5209.988, 5214.1, 5222.942, 5235.988, 5238.282, 5240.473, 5241.659, 5243.912, 5244.976, 5247.897, 5249.387, 5251.045, 5253.204, 5255.708, 5279.78, 5307.967, 5310.273, 5312.42, 5316.396, 5333.258, 5347.534, 5350.151, 5352.778, 5355.91, 5378.163, 5379.001, 5379.84, 5380.679, 5381.517, 5386.255, 5390.421, 5392.32, 5393.936, 5394.745, 5395.208, 5396.198, 5397.332, 5400.076, 5402.89, 5404.266, 5414.833, 5431.677, 5446.611, 5454.415, 5462.421, 5476.102, 5500.549, 5509.022, 5514.654, 5525.097, 5531.865, 5534.863, 5539.007, 5541.37, 5547.658, 5548.986, 5569.041, 5575.007, 5580.225, 5580.421, 5581.261, 5581.741, 5582.309, 5582.989, 5583.587, 5586.56, 5592.998, 5595.349, 5596.765, 5600.011, 5608.029, 5614.794, 5615.581, 5616.378, 5616.47, 5617.01, 5617.564, 5618.132, 5622.105, 5634.312, 5638.672, 5643.046, 5647.659, 5648.695, 5649.59, 5650.491, 5652.785, 5655.116, 5656.486, 5658.102, 5658.628, 5659.163, 5659.707, 5663.614, 5664.938, 5666.08, 5670.413, 5673.422, 5676.266, 5677.605, 5678.068, 5678.857, 5679.363, 5680.192, 5681.812, 5682.711, 5687.284, 5694.399, 5700.654, 5709.989, 5738.106, 5742.929, 5767.159, 5772.152, 5773.964, 5785.487, 5788.761, 5850.634, 5857.063, 5890.634, 5896.175, 5899.622, 5904.572, 5913.537, 5948.571, 5961.333, 5963.141, 5964.076, 5964.951, 5970.713, 5972.657, 5975.335, 5978.28, 6014.289, 6034.481, 6047.96, 6050.099, 6052.034, 6054.461, 6064.208, 6066.714, 6069.527, 6072.666, 6074.083, 6075.115, 6076.12, 6077.389, 6081.633, 6106.516, 6110.83, 6115.387, 6124.733, 6136.934, 6138.903, 6144.388, 6149.369, 6150.4, 6151.728, 6153.34, 6157.733, 6159.196, 6179.126, 6205.751, 6209.819, 6214.716, 6224.859, 6225.075, 6225.945, 6226.884, 6230.147, 6243.258, 6251.25, 6260.237, 6272.39, 6279.477, 6285.566, 6290.168, 6296.057, 6300.184, 6310.475, 6314.736, 6321.457, 6327.811, 6332.032, 6338.102, 6341.562, 6349.418, 6362.936, 6372.125, 6378.811, 6386.755, 6394.977, 6406.259, 6408.148, 6409.177, 6410.204, 6411.969, 6412.774, 6413.684, 6428.445, 6430.984, 6432.065, 6433.32, 6434.656, 6435.792, 6438.227, 6449.352, 6462.17, 6474.428, 6496.902, 6500.161, 6503.558, 6511.641, 6513.379, 6515.166, 6516.852, 6517.934, 6520.136, 6527.676, 6533.464, 6540.21, 6544.549, 6563.182, 6565.169, 6569.185, 6571.846, 6577.015, 6577.656, 6578.305, 6578.83, 6580.027, 6580.702, 6581.86, 6583.178, 6583.917, 6584.959, 6586.01, 6586.66, 6587.33, 6587.82, 6591.266, 6593.58, 6599.492, 6600.517, 6604.664, 6611.25, 6624.228, 6625.571, 6634.883, 6640.954, 6645.622, 6648.76, 6651.306, 6660.172, 6666.666, 6672.128, 6676.237, 6684.629, 6686.551, 6688.42, 6690.018, 6692.243, 6694.787, 6696.805, 6700.029, 6704.844, 6714.47, 6715.838, 6717.703, 6722.98, 6726.967, 6743.468, 6743.73, 6743.826, 6749.172, 6751.174, 6753.782, 6754.683, 6755.143, 6758.026, 6759.557, 6760.723, 6761.567, 6762.605, 6763.59, 6764.302, 6765.139, 6766.039, 6770.16, 6773.065, 6786.947, 6808.706, 6829.682, 6849.644, 6858.077, 6864.045, 6869.254, 6872.294, 6872.46, 6875.282, 7060.5, 7087.766, 7126.857, 7136.83, 7155.423, 7173.541, 7195.539, 7206.197, 7213.293, 7220.246, 7236.091, 7249.721, 7263.538, 7278.199, 7288.999, 7289.645, 7290.292, 7302.484, 7314.62, 7332.086, 7342.279, 7346.776, 7351.149, 7356.885, 7362.087, 7366.795, 7371.575, 7378.229, 7386.166, 7390.504, 7398.53, 7407.133, 7411.945, 7415.936, 7420.698, 7425.849, 7430.513, 7438.002, 7441.905, 7443.322, 7445.888, 7448.608, 7452.221, 7456.048, 7468.185, 7470.393, 7472.188, 7474.005, 7476.152, 7477.081, 7479.733, 7483.051, 7483.235, 7485.259, 7489.981, 7502.637, 7520.521, 7525.32, 7529.456, 7531.439, 7532.854, 7534.843, 7536.863, 7537.953, 7539.206, 7542.393, 7550.745, 7554.31, 7560.438, 7562.242, 7564.504, 7567.794, 7570.327, 7572.42, 7598.077, 7601.879, 7606.357, 7611.729, 7614.482, 7618.057, 7620.354, 7621.964, 7623.896, 7625.099, 7629.308, 7632.431, 7633.985, 7635.275, 7638.012, 7642.98, 7673.215, 7678.757, 7692.41, 7705.427, 7712.646, 7719.76, 7723.915, 7726.421, 7742.773, 7775.524, 7784.306, 7788.911, 7794.165, 7796.308, 7798.936, 7801.888, 7806.286, 7809.581, 7813.358, 7816.2, 7819.557, 7832.317, 7834.029, 7835.44, 7838.445, 7840.68, 7844.867, 7860.288, 7865.763, 7871.757, 7875.429, 7876.846, 7878.597, 7879.991, 7884.339, 7886.878, 7892, 7896.508, 7906.783, 7918.405, 7928.468, 7953.09, 7956.094, 7958.07, 7962.804, 7970.594, 7972.827, 7975.225, 7977.794, 7979.247, 7981.999, 7995.955, 8011.42, 8020.662, 8033.498, 8038.242, 8042.53, 8045.029, 8047.09, 8050.969, 8053.418, 8056.028, 8058.613, 8060.622, 8063.323, 8065.632, 8068.101, 8072.928, 8078.39, 8080.286, 8083.838, 8087.024, 8088.255, 8089.904, 8091.667, 8103.137, 8105.455, 8107.515, 8112.161, 8115.322, 8120.841, 8123.882, 8128.005, 8129.401, 8147.075, 8155.941, 8157.409, 8162.144, 8167.618, 8182.316, 8197.722, 8236.477, 8237.623, 8241.754, 8242.864, 8246.643, 8248.867, 8250.952, 8251.918, 8258.329, 8263.601, 8268.672, 8279.059, 8284.698, 8292.806, 8298.058, 8300.281, 8301.018, 8305.56, 8307.354, 8308.959, 8317.508, 8325.633, 8336.157, 8337.369, 8339.959, 8342.538, 8360.36, 8370.696, 8378.789, 8381.019, 8384.322, 8388.899, 8389.317, 8390.161, 8391.729, 8392.409, 8393.789, 8396.2, 8397.9, 8399.56, 8401.137, 8402.264, 8402.827, 8405.115, 8410.239, 8415.141, 8425.489, 8426.218, 8427.328, 8427.725, 8430.133, 8433.68, 8435.665, 8437.594, 8439.455, 8440.317, 8445.299, 8448.137, 8449.565, 8452.893, 8454.582, 8457.029, 8464.32, 8465.829, 8470.174, 8470.936, 8471.702, 8472.934, 8473.863, 8476.363, 8476.835, 8477.465, 8477.938, 8480.161, 8482.724, 8483.792, 8484.559, 8485.021, 8485.483, 8486.64, 8487.466, 8488.624, 8502.148, 8512.779, 8533.628, 8536.749, 8538.96, 8544.882, 8548.936, 8558.378, 8560.399, 8562.196, 8567.098, 8573.073, 8575.97, 8578.141, 8580.813, 8583.647, 8588.048, 8598.722, 8606.025, 8608.603, 8644.664, 8648.366, 8650.511, 8652.622, 8656.51, 8660.08, 8663.846, 8667.978, 8669.939, 8670.738, 8671.518, 8672.17, 8676.076, 8676.824, 8677.666, 8697.608, 8704.577, 8711.575, 8724.284, 8726.629, 8727.949, 8730.611, 8734.091, 8737.645, 8741.988, 8743.445, 8747.703, 8751.221, 8752.67, 8755.768, 8757.483, 8772.998, 8780.729, 8781.807, 8784.127, 8788.638, 8800.758, 8803.9, 8807.177, 8810.044, 8813.697, 8817.231, 8821.122, 8822.426, 8823.653, 8826.139, 8831.04, 8841.542, 8844.585, 8848.357, 8854.542, 8869.22, 8878.288, 8880.23, 8901.487, 8911.879, 8915.346, 8917.372, 8918.104, 8919.016, 8921.188, 8922.917, 8924.744, 8926.74, 8929.46, 8932.107, 8934.495, 8936.837, 8950.325, 8953.287, 8954.386, 8955.479, 9027.47, 9029.423, 9041.775, 9054.812, 9059.415, 9064.666, 9073.815, 9076.552, 9079.706, 9081.618, 9082.361, 9083.509, 9087.764, 9088.746, 9091.055, 9093.187, 9094.48, 9096.016, 9097.063, 9099.047, 9100.926, 9103.742, 9106.113, 9107.387, 9109.432, 9120.119, 9131.938, 9135.646, 9141.359, 9145.664, 9150.144, 9152.429, 9154.931, 9160.279, 9166.222, 9168.358, 9170.983, 9173.799, 9176.986, 9188.409, 9194.886, 9203.584, 9215.522, 9218.657, 9222.939, 9226.228, 9232.516, 9239.983, 9248.863, 9250.96, 9259.797, 9261.646, 9268.558, 9273.197, 9274.616, 9279.193, 9287.388, 9289.523, 9292.147, 9294.707, 9304.231, 9320.955, 9326.963, 9332.752, 9334.18, 9343.348, 9365.85, 9381.007, 9385.951, 9391.873, 9401.379, 9412.729, 9429.829, 9436.4, 9439.374, 9442.355, 9446.675, 9451.172, 9453.307, 9456.834, 9459.447, 9463.554, 9468.199, 9469.576, 9470.938, 9472.669, 9478.462, 9481.188, 9482.101, 9482.938, 9488.043, 9496.998, 9497.788, 9500.942, 9503.699, 9504.627, 9505.872, 9517.569, 9528.659, 9556.532, 9566.742, 9571.118, 9572.13, 9643.054, 9660.726, 9692.635, 9709.205, 9714.241, 9721.586, 9731.871, 9739.767, 9746.053, 9753.162, 9760.836, 9765.958, 9796.72, 9799.061, 9803.396, 9804.656, 9806.01, 9807.922, 9809.865, 9812.009, 9814.497, 9815.974, 9818.071, 9818.525, 9818.988, 9819.91, 9820.676, 9822.593, 9825.321, 9830.81, 9836.761, 9838.182, 9842.864, 9844.941, 9846.654, 9847.68, 9848.236, 9849.332, 9852.918, 9856.354, 9859.955, 9868.419, 9883.238, 9895.028, 9909.482, 9937.268, 9982.949, 10014.519, 10019.979, 10025.465, 10028.761, 10057.024, 10076.509, 10081.89, 10086.452, 10091.028, 10095.304, 10096.666, 10102.487, 10104.276, 10104.652, 10105.035, 10105.792, 10106.26, 10106.535, 10107.169, 10108.107, 10108.668, 10112.869, 10114.466, 10114.776, 10115.195, 10119.233, 10119.44, 10119.755, 10120.395, 10121.157, 10124.749, 10127.628, 10130.94, 10134.276, 10139.434, 10142.094, 10165.682, 10172.804, 10179.128, 10186.976, 10191.702, 10195.848, 10202.821, 10203.624, 10205.235, 10206.043, 10207.177, 10208.801, 10209.777, 10212.719, 10213.374, 10217.319, 10252.125, 10257.161, 10258.001, 10259.176, 10264.549, 10265.893, 10310.181, 10329.915, 10378.197, 10382.067, 10382.797, 10384.97, 10386.316, 10387.461, 10388.974, 10390.286, 10391.773, 10394.166, 10394.714, 10415.629, 10420.543, 10424.939, 10430.51, 10435.567, 10440.789, 10445.166, 10449.372, 10453.409, 10457.781, 10461.984, 10465.346, 10468.708, 10477.278, 10492.8, 10498.129, 10507.286, 10513.331, 10516.786, 10521.083, 10525.562, 10529.055, 10531.721, 10537.062, 10539.402, 10550.283, 10555.745, 10560.364, 10569.743, 10581.105, 10582.16, 10583.504, 10584.598, 10585.849, 10586.499, 10587.857, 10588.564, 10592.726, 10600.232, 10602.811, 10604.349, 10606.745, 10631.121, 10636.184, 10642.955, 10660.691, 10662.725, 10666.594, 10668.178, 10671.914, 10675.947, 10677.994, 10678.927, 10679.619, 10680.984, 10682.547, 10690.851, 10713.093, 10718.216, 10734.515, 10737.605, 10739.127, 10784.75, 10798.606, 10834.464, 10841.886, 10847.621, 10854.858, 10860.963, 10867.163, 10873.143, 10886.062, 10896.179, 10907.097, 10921.977, 10926.21, 10928.897, 10961.045, 10964.392, 10968.259, 10995.406, 11000.976, 11006.014, 11009.05, 11011.038, 11012.887, 11014.513, 11016.06, 11016.793, 11017.256, 11018.462, 11019.555, 11021.435, 11022.496, 11023.604, 11024.713, 11025.824, 11030.447, 11042.104, 11091.325, 11102.923, 11117.726, 11135.903, 11166.544, 11227.065, 11246.929, 11256.414, 11259.696, 11262.557, 11314.992, 11365.73, 11373.963, 11375.307, 11377.322, 11379.507, 11380.179, 11383.035, 11384.647, 11385.043, 11386.372, 11389.914, 11394.848, 11435.175, 11521.809, 11577.469, 11668.173, 12040.548, 12661.662, 13100.517, 13110.522, 13239.102, 13336.278, 13437.693, 13790.771, 13962.309, 13993.757, 14065.231, 14083.101, 14106.66, 14153.441, 14299.627, 14419.588, 14479.619, 15306.575, 15535.294, 15643.936, 15723.987, 15773.305, 16099.944, 16185.714, 16255.597, 16276.766, 16281.641, 16284.001, 16284.195, 16285.227, 16285.516, 16287.719, 16291.705, 16293.67, 16297.901, 16300.032, 16301.752, 16303.641, 16304.39, 16306.063, 16307.355, 16309.915, 16310.822, 16311.545, 16312.086, 16312.806, 16320.257, 16326.357, 16342.015, 16344.15, 16346.287, 16351.272, 16357.021, 16362.814, 16377.483, 16383.852, 16388.494, 16391.174, 16393.521, 16399.156, 16402.34, 16406.568, 16412.193, 16413.93, 16419.867, 16426.299, 16428.66, 16429.062, 16430.223, 16431.344, 16431.826, 16432.189, 16434.123, 16436.732, 16437.664, 16438.67, 16439.012, 16439.705, 16439.938, 16442.967, 16445.838, 16448.34, 16457.025, 16469.105, 16472.697, 16475.779, 16478.391, 16480.684, 16484.303, 16485.697, 16487.605, 16503.863, 16505.143, 16507.074, 16513.699, 16515.744, 16516.967, 16517.953, 16520.297, 16521.877, 16523.541, 16525.887, 16535.592, 16546.561, 16547.992, 16549.588, 16550.391, 16551.676, 16552.805, 16554.326, 16558.188, 16559.281, 16561.328, 16562.436, 16569.533, 16570.469, 16571.146, 16572.455, 16573.613, 16574.756, 16576.416, 16579.158, 16582.184, 16585.635, 16588.211, 16590.854, 16597.355, 16608.074, 16609.895, 16613.578, 16618.693, 16620.609, 16621.178, 16623.111, 16624.059, 16624.719, 16626.945, 16627.371, 16634.057, 16636.211, 16638.053, 16639.674, 16641.754, 16648.111, 16648.811, 16651.648, 16654.857, 16657.369, 16686.391, 16688.312, 16690.051, 16691.719, 16693.486, 16696.576, 16697.385, 16698.387, 16700.17, 16704.346, 16713.023, 16713.664, 16714.488, 16716.211, 16717.156, 16717.566, 16722.434, 16725.918, 16732.896, 16739.365, 16742.621, 16747.207, 16747.51, 16748.227, 16748.646, 16751.541, 16751.971, 16753.199, 16753.486, 16766.084, 16766.275, 16776.262, 16777.389, 16791.229, 16791.877, 16802.93, 16803.463, 16803.74, 16806.396, 16813.197, 16821.625, 16825.596, 16837.826, 16842.438, 16846.936, 16860.525, 16870.391, 16882.863, 16884.301, 16885.809, 16887.238, 16888.664, 16890.744, 16895.678, 16901.236, 16903.77, 16908.988, 16913.896, 16918.838, 16923.719, 16936.945, 16940.521, 16944.314, 16948.111, 16959.963, 16965.564, 16967.822, 16980.271, 16985.107, 16989.818, 16997.369, 17000.201, 17004.447]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [3.777786, 51.741206, 6.0],
          [3.778343, 51.741272, 6.5],
          [3.778886, 51.741320, 6.75],
          [3.779424, 51.741376, 7.0],
          [3.780498, 51.741513, 7.25],
          [3.780956, 51.741565, 7.25],
          [3.781073, 51.741547, 7.0],
          [3.781244, 51.741538, 6.75],
          [3.781377, 51.741554, 6.75],
          [3.781728, 51.741621, 6.75],
          [3.782144, 51.741692, 7.0],
          [3.782527, 51.741697, 7.0],
          [3.782683, 51.741711, 7.0],
          [3.783041, 51.741757, 7.0],
          [3.783244, 51.741793, 7.25],
          [3.783484, 51.741862, 7.5],
          [3.783541, 51.741799, 7.25],
          [3.783630, 51.741762, 7.25],
          [3.783892, 51.741684, 7.0],
          [3.784032, 51.741734, 7.0],
          [3.785054, 51.741827, 6.5],
          [3.785651, 51.741874, 6.75],
          [3.786192, 51.741919, 7.0],
          [3.786753, 51.741930, 6.75],
          [3.787112, 51.741930, 6.75],
          [3.787860, 51.741869, 6.0],
          [3.788227, 51.741813, 5.0],
          [3.788542, 51.741758, 4.5],
          [3.789571, 51.741554, 4.0],
          [3.789722, 51.741518, 4.0],
          [3.789758, 51.741513, 4.0],
          [3.790974, 51.741263, 2.75],
          [3.792382, 51.740976, 1.5],
          [3.793442, 51.740711, 0.75],
          [3.794751, 51.740367, 0.5],
          [3.795699, 51.740144, 0.25],
          [3.796386, 51.740024, 0.0],
          [3.796759, 51.739978, 0.0],
          [3.801846, 51.739436, 0.25],
          [3.803055, 51.739310, 0.75],
          [3.804022, 51.739235, 1.0],
          [3.804438, 51.739211, 1.0],
          [3.805321, 51.739174, 1.0],
          [3.807668, 51.739118, 1.5],
          [3.808867, 51.739061, 1.25],
          [3.809468, 51.739015, 1.75],
          [3.809693, 51.739003, 2.0],
          [3.810326, 51.738988, 2.25],
          [3.811187, 51.738979, 2.25],
          [3.811198, 51.739026, 2.5],
          [3.811242, 51.739073, 2.5],
          [3.811334, 51.739100, 2.75],
          [3.812625, 51.739156, 4.0],
          [3.813346, 51.739174, 5.0],
          [3.813594, 51.739170, 5.0],
          [3.814481, 51.739120, 5.0],
          [3.814939, 51.739080, 5.25],
          [3.816629, 51.738931, 4.5],
          [3.817194, 51.738918, 5.5],
          [3.817532, 51.738889, 6.0],
          [3.817762, 51.738838, 6.25],
          [3.817905, 51.738876, 7.0],
          [3.818061, 51.738892, 7.5],
          [3.819976, 51.738941, 7.5],
          [3.821352, 51.739086, 8.5],
          [3.821611, 51.739025, 8.0],
          [3.821774, 51.739083, 8.25],
          [3.821928, 51.739126, 8.75],
          [3.822080, 51.739151, 8.75],
          [3.822236, 51.739158, 8.75],
          [3.822414, 51.739154, 8.75],
          [3.822628, 51.739126, 8.5],
          [3.822736, 51.739190, 8.5],
          [3.822866, 51.739234, 8.5],
          [3.823120, 51.739206, 8.25],
          [3.823162, 51.739196, 8.0],
          [3.823312, 51.739130, 7.75],
          [3.823190, 51.739296, 8.25],
          [3.823190, 51.739296, 8.25],
          [3.823312, 51.739130, 7.75],
          [3.823385, 51.739196, 7.75],
          [3.824051, 51.739872, 7.75],
          [3.824109, 51.739968, 8.0],
          [3.824341, 51.740875, 7.75],
          [3.824340, 51.741028, 7.75],
          [3.824467, 51.741029, 7.75],
          [3.824573, 51.741033, 7.75],
          [3.824592, 51.741342, 7.5],
          [3.824752, 51.742411, 7.5],
          [3.824926, 51.743485, 7.5],
          [3.825361, 51.746185, 7.5],
          [3.825608, 51.747929, 4.0],
          [3.825686, 51.748383, 4.0],
          [3.825762, 51.748657, 4.0],
          [3.825868, 51.748863, 2.75],
          [3.826077, 51.749344, 2.75],
          [3.826260, 51.749678, 2.75],
          [3.826507, 51.750115, 2.75],
          [3.827158, 51.751099, 2.75],
          [3.827879, 51.751946, 2.75],
          [3.828458, 51.752553, 2.75],
          [3.828541, 51.752639],
          [3.829352, 51.753284, 3.75],
          [3.830841, 51.754303, 3.75],
          [3.831646, 51.754744, 3.75],
          [3.832987, 51.755378, 3.75],
          [3.833997, 51.755780, 3.75],
          [3.835445, 51.756255, 3.75],
          [3.839519, 51.757301, 5.25],
          [3.840292, 51.757507, 5.25],
          [3.843585, 51.758351, 5.25],
          [3.845700, 51.758900, 6.25],
          [3.847600, 51.759500, 6.25],
          [3.848849, 51.759946, 6.75],
          [3.849331, 51.760103, 6.75],
          [3.849191, 51.760240, 6.75],
          [3.849839, 51.760497, 6.75],
          [3.850270, 51.760692, 6.75],
          [3.852068, 51.761654, 6.75],
          [3.853938, 51.762760, 6.75],
          [3.853938, 51.762880, 6.75],
          [3.853777, 51.762979, 6.75],
          [3.854657, 51.763590, 6.75],
          [3.855292, 51.764142, 5.0],
          [3.855965, 51.764703, 4.75],
          [3.856704, 51.765425, 8.25],
          [3.857340, 51.766086, 7.0],
          [3.858056, 51.767003, 7.0],
          [3.859711, 51.769631, 7.0],
          [3.861695, 51.772806, 7.0],
          [3.864356, 51.777065],
          [3.865287, 51.778390],
          [3.865357, 51.778487],
          [3.865717, 51.778939],
          [3.866280, 51.779544, 5.0],
          [3.867449, 51.781104, 6.25],
          [3.868457, 51.782750, 6.5],
          [3.869497, 51.784527, 6.5],
          [3.869686, 51.784830, 7.25],
          [3.869805, 51.785028, 7.75],
          [3.869659, 51.785064, 7.5],
          [3.869821, 51.785237, 7.75],
          [3.869982, 51.785516, 7.75],
          [3.870311, 51.786120, 8.25],
          [3.870429, 51.786450, 8.5],
          [3.870507, 51.786785, 8.5],
          [3.870605, 51.787356, 7.25],
          [3.870665, 51.787708, 6.5],
          [3.870839, 51.788179, 5.25],
          [3.871000, 51.788520, 5.0],
          [3.871213, 51.788807, 5.25],
          [3.871373, 51.788992, 5.25],
          [3.871560, 51.789150, 5.0],
          [3.871916, 51.789399, 5.5],
          [3.872320, 51.789646, 6.0],
          [3.872749, 51.789845, 6.25],
          [3.873199, 51.789998, 6.0],
          [3.873857, 51.790148, 4.5],
          [3.874495, 51.790245, 3.0],
          [3.874629, 51.790302, 2.75],
          [3.873654, 51.791399, 3.25],
          [3.873511, 51.791465, 3.25],
          [3.873402, 51.791519, 3.25],
          [3.873219, 51.791740, 3.0],
          [3.872762, 51.792499, 3.25],
          [3.871478, 51.794028, 2.75],
          [3.869700, 51.796200, 5.0],
          [3.869600, 51.796400, 4.75],
          [3.869600, 51.796500, 4.75],
          [3.869700, 51.796600, 4.25],
          [3.870000, 51.796800, 3.75],
          [3.870100, 51.797000, 3.25],
          [3.870385, 51.798590, 1.75],
          [3.870403, 51.798635, 1.75],
          [3.870446, 51.798671, 1.75],
          [3.870518, 51.798836, 1.5],
          [3.869602, 51.799116, 2.25],
          [3.868529, 51.799358, 2.5],
          [3.867580, 51.799819, 1.5],
          [3.867391, 51.799902, 1.5],
          [3.866821, 51.800114, 1.5],
          [3.866236, 51.800294, 2.25],
          [3.866055, 51.800344, 2.5],
          [3.865916, 51.800393, 2.75],
          [3.865753, 51.800501, 2.75],
          [3.865050, 51.801117, 2.25],
          [3.864931, 51.801209, 2.0],
          [3.864353, 51.801589, 2.5],
          [3.863727, 51.802176, 2.5],
          [3.863610, 51.802309, 2.25],
          [3.863060, 51.803081, 1.75],
          [3.863033, 51.803126, 1.75],
          [3.863017, 51.803174, 1.75],
          [3.863014, 51.803225, 1.75],
          [3.863029, 51.803265, 1.75],
          [3.863071, 51.803314, 1.5],
          [3.863148, 51.803375, 1.25],
          [3.863213, 51.803412, 1.25],
          [3.863744, 51.803669, 0.5],
          [3.864373, 51.803974, 0.5],
          [3.864192, 51.804148, 0.75],
          [3.864077, 51.804500, 0.5],
          [3.864000, 51.804800, 0.0],
          [3.863935, 51.804939, 0.0],
          [3.863385, 51.806140, 0.5],
          [3.863177, 51.806604, 0.25],
          [3.862900, 51.807300, 0.5],
          [3.862700, 51.807600, 0.75],
          [3.862632, 51.807638, 0.75],
          [3.862472, 51.807730, 0.75],
          [3.862206, 51.807885, 1.0],
          [3.862112, 51.807973, 1.0],
          [3.862079, 51.808024, 1.0],
          [3.862033, 51.808127, 1.0],
          [3.862012, 51.808231, 1.0],
          [3.862012, 51.808283, 1.0],
          [3.862024, 51.808335, 1.0],
          [3.862073, 51.808437, 1.0],
          [3.862108, 51.808487, 1.0],
          [3.862233, 51.808627, 1.25],
          [3.864493, 51.810995, 1.25],
          [3.864539, 51.811042, 1.25],
          [3.864596, 51.811083, 1.25],
          [3.864720, 51.811158, 1.5],
          [3.864800, 51.811200, 1.5],
          [3.864916, 51.811232, 1.5],
          [3.865389, 51.811332, 1.5],
          [3.865638, 51.811400, 1.5],
          [3.866445, 51.811679, 2.0],
          [3.866909, 51.811945, 2.0],
          [3.866983, 51.812011, 2.0],
          [3.867513, 51.812489, 1.75],
          [3.867894, 51.812719, 2.0],
          [3.869064, 51.813368, 2.0],
          [3.869743, 51.813605, 1.75],
          [3.870566, 51.813864, 1.75],
          [3.870718, 51.813921, 1.75],
          [3.871823, 51.814588, 1.75],
          [3.872042, 51.814709, 2.0],
          [3.872600, 51.815000, 1.75],
          [3.873000, 51.815200, 1.75],
          [3.875131, 51.816118, 0.75],
          [3.876138, 51.816546, 1.25],
          [3.877112, 51.816940, 1.75],
          [3.877209, 51.816981, 1.75],
          [3.877967, 51.817279, 1.25],
          [3.878424, 51.817442, 0.75],
          [3.878669, 51.817539, 1.0],
          [3.879374, 51.817816, 1.75],
          [3.879827, 51.817991, 1.75],
          [3.879985, 51.818054, 1.5],
          [3.880193, 51.818136, 1.75],
          [3.880715, 51.818342, 2.0],
          [3.882023, 51.818853, 2.0],
          [3.882222, 51.818922, 2.25],
          [3.882344, 51.818957, 2.25],
          [3.882484, 51.818987, 2.5],
          [3.882597, 51.819001, 2.5],
          [3.882665, 51.819000, 2.5],
          [3.882793, 51.818994, 2.5],
          [3.883067, 51.818968, 2.25],
          [3.883401, 51.818860, 1.75],
          [3.883480, 51.818908, 2.0],
          [3.883585, 51.818951, 2.0],
          [3.883687, 51.818983, 2.25],
          [3.883913, 51.819025, 2.25],
          [3.884229, 51.819041, 2.25],
          [3.884412, 51.819063, 2.25],
          [3.884588, 51.819103, 2.25],
          [3.884884, 51.819208, 2.25],
          [3.885067, 51.819277, 2.5],
          [3.887124, 51.820030, 2.5],
          [3.889425, 51.820866, 1.5],
          [3.889525, 51.820897, 1.5],
          [3.889659, 51.820930, 1.5],
          [3.889788, 51.820952, 1.25],
          [3.889834, 51.820954, 1.25],
          [3.889883, 51.820950, 1.0],
          [3.889933, 51.820933, 1.0],
          [3.889957, 51.820964, 1.0],
          [3.889976, 51.821032, 1.0],
          [3.889974, 51.821070, 1.0],
          [3.889836, 51.822303, 0.75],
          [3.889840, 51.822340, 0.75],
          [3.889869, 51.822377, 0.75],
          [3.889898, 51.822396, 0.5],
          [3.890659, 51.822635, 0.5],
          [3.891084, 51.822740, 0.5],
          [3.891379, 51.822796, 1.0],
          [3.892340, 51.822930, 1.5],
          [3.892909, 51.823022, 1.75],
          [3.893530, 51.823142, 2.25],
          [3.894247, 51.823293, 1.75],
          [3.894798, 51.823396, 1.75],
          [3.895445, 51.823510, 1.75],
          [3.895743, 51.823548, 1.75],
          [3.895902, 51.823549, 0.25],
          [3.896530, 51.823515, 0.5],
          [3.897116, 51.823500, 0.5],
          [3.897839, 51.823511, 0.5],
          [3.897891, 51.823516, 0.5],
          [3.897996, 51.823541, 0.5],
          [3.898062, 51.823583, 0.5],
          [3.898121, 51.823596, 0.5],
          [3.898224, 51.823649, 0.75],
          [3.898408, 51.823809, 1.0],
          [3.898459, 51.823848, 1.0],
          [3.898545, 51.823898, 1.25],
          [3.898653, 51.823942, 1.25],
          [3.898785, 51.823975, 1.5],
          [3.898906, 51.823996, 1.5],
          [3.899073, 51.824010, 1.5],
          [3.900892, 51.824116, 0.75],
          [3.901959, 51.824165, 0.0],
          [3.902421, 51.824181, 0.0],
          [3.903702, 51.824196, 0.0],
          [3.904633, 51.824219, 0.0],
          [3.905027, 51.824207, 0.0],
          [3.905645, 51.824161, 1.75],
          [3.906767, 51.824071, 1.75],
          [3.906962, 51.824053, 1.75],
          [3.907199, 51.824022, 1.75],
          [3.907413, 51.823999, 1.75],
          [3.908310, 51.823924, 1.25],
          [3.910911, 51.823709, 2.25],
          [3.911543, 51.823658, 1.75],
          [3.911968, 51.823626, 1.5],
          [3.912107, 51.823627, 1.5],
          [3.912188, 51.823633, 1.25],
          [3.912249, 51.823646, 1.25],
          [3.913251, 51.823946, 0.75],
          [3.913857, 51.824128, 0.75],
          [3.914860, 51.824429, 2.0],
          [3.915053, 51.824488, 2.25],
          [3.915278, 51.824542, 2.5],
          [3.915513, 51.824596, 2.75],
          [3.915773, 51.824639, 3.0],
          [3.916735, 51.824791, 4.75],
          [3.917600, 51.824920, 5.5],
          [3.917901, 51.824931, 6.0],
          [3.917996, 51.824942, 6.0],
          [3.918004, 51.825124, 6.5],
          [3.918039, 51.825371, 6.5],
          [3.918158, 51.825567, 6.75],
          [3.918322, 51.825738, 6.75],
          [3.918664, 51.825945, 7.0],
          [3.919114, 51.826146, 7.0],
          [3.919600, 51.826279, 6.75],
          [3.920406, 51.826537, 6.5],
          [3.920512, 51.826655, 6.5],
          [3.920609, 51.826839, 6.75],
          [3.920713, 51.826933, 6.75],
          [3.921080, 51.827084, 6.75],
          [3.921580, 51.827184, 6.75],
          [3.922212, 51.827224, 7.25],
          [3.922433, 51.827270, 7.25],
          [3.924685, 51.827952, 8.5],
          [3.924970, 51.828016, 8.5],
          [3.925270, 51.828062, 8.5],
          [3.926388, 51.828144, 8.75],
          [3.926642, 51.828178, 8.75],
          [3.927404, 51.828426, 8.75],
          [3.928701, 51.828804, 8.0],
          [3.929858, 51.829098, 9.5],
          [3.930016, 51.829123, 9.75],
          [3.930527, 51.828797, 8.0],
          [3.930766, 51.828646, 7.25],
          [3.930902, 51.828618, 6.75],
          [3.931034, 51.828611, 6.5],
          [3.932781, 51.828715, 4.25],
          [3.932863, 51.828715, 4.0],
          [3.932945, 51.828695, 3.75],
          [3.932995, 51.828658, 3.5],
          [3.933039, 51.828581, 3.25],
          [3.933066, 51.828494, 2.75],
          [3.932912, 51.828456, 2.75],
          [3.933066, 51.828494, 2.75],
          [3.933039, 51.828581, 3.25],
          [3.933156, 51.828607, 3.25],
          [3.933252, 51.828617, 3.0],
          [3.933343, 51.828615, 3.0],
          [3.933405, 51.828601, 2.75],
          [3.933454, 51.828574, 2.5],
          [3.933749, 51.827977, 1.5],
          [3.933809, 51.827932, 1.5],
          [3.933877, 51.827902, 1.5],
          [3.933914, 51.827837, 1.5],
          [3.933934, 51.827803, 1.5],
          [3.934063, 51.827460, 2.0],
          [3.934154, 51.827193, 2.0],
          [3.934585, 51.826294, 1.5],
          [3.934771, 51.825609, 2.25],
          [3.935037, 51.824836, 2.5],
          [3.935642, 51.823389, 2.75],
          [3.935744, 51.823077, 3.25],
          [3.935783, 51.822772, 3.5],
          [3.935794, 51.822516, 3.75],
          [3.936025, 51.822154, 3.75],
          [3.936044, 51.822126, 3.5],
          [3.936226, 51.821889, 3.5],
          [3.936315, 51.821790, 3.25],
          [3.936417, 51.821693, 3.25],
          [3.936653, 51.821519, 3.0],
          [3.936730, 51.821429, 3.0],
          [3.936810, 51.821279, 3.0],
          [3.936873, 51.821132, 3.0],
          [3.937031, 51.820809, 3.0],
          [3.937427, 51.820842, 3.0],
          [3.937451, 51.820710, 3.0],
          [3.937427, 51.820842, 3.0],
          [3.938263, 51.820896, 3.75],
          [3.938551, 51.820916, 3.75],
          [3.938741, 51.820920, 3.75],
          [3.938946, 51.820914, 3.75],
          [3.939536, 51.820852, 3.5],
          [3.939934, 51.820849, 3.0],
          [3.940105, 51.820836, 2.75],
          [3.940259, 51.820814, 3.0],
          [3.940406, 51.820783, 3.0],
          [3.940700, 51.820704, 3.0],
          [3.941001, 51.820641, 3.0],
          [3.941325, 51.820597, 3.0],
          [3.942233, 51.820531, 3.25],
          [3.942401, 51.820508, 3.25],
          [3.942549, 51.820465, 3.25],
          [3.942631, 51.820417, 3.25],
          [3.943027, 51.819941, 3.25],
          [3.943075, 51.819947, 3.0],
          [3.943481, 51.820114, 3.0],
          [3.945319, 51.820966, 2.0],
          [3.945491, 51.821013, 2.0],
          [3.945692, 51.821020, 2.0],
          [3.945847, 51.820996, 1.75],
          [3.946008, 51.820963, 1.75],
          [3.946174, 51.820955, 1.5],
          [3.946310, 51.820979, 1.25],
          [3.946522, 51.821066, 1.0],
          [3.947735, 51.821550, 1.0],
          [3.947961, 51.821673, 0.75],
          [3.948624, 51.821918, 0.75],
          [3.949317, 51.822199, 1.0],
          [3.949851, 51.822421, 1.75],
          [3.950896, 51.822934, 1.5],
          [3.951783, 51.823359, 2.25],
          [3.953475, 51.824246, 3.75],
          [3.953977, 51.824476, 3.5],
          [3.956800, 51.825500, 3.25],
          [3.957982, 51.825872, 3.0],
          [3.958707, 51.826131, 3.0],
          [3.958945, 51.825967, 2.75],
          [3.959170, 51.825813, 2.75],
          [3.959648, 51.825509, 2.25],
          [3.960677, 51.824746, 1.0],
          [3.961083, 51.824411, 0.5],
          [3.961240, 51.824328, 0.25],
          [3.960500, 51.823800, 0.5],
          [3.959059, 51.822972, 0.75],
          [3.959267, 51.822814, 1.0],
          [3.959651, 51.822492, 1.5],
          [3.960366, 51.821913, 0.75],
          [3.960479, 51.821801, 0.5],
          [3.960558, 51.821677, 0.25],
          [3.960587, 51.821612, 0.25],
          [3.960593, 51.821482, 0.25],
          [3.960569, 51.821421, 0.25],
          [3.960456, 51.821272, 0.25],
          [3.960416, 51.821202, 0.5],
          [3.960389, 51.821117, 0.5],
          [3.960385, 51.821002, 0.5],
          [3.960422, 51.820861, 0.25],
          [3.960937, 51.819681, 0.75],
          [3.961646, 51.818095, 0.0],
          [3.961715, 51.817986, 0.0],
          [3.961807, 51.817890, 0.0],
          [3.962032, 51.817731, 0.0],
          [3.963177, 51.817089, -0.25],
          [3.964263, 51.816482, -1.0],
          [3.964427, 51.816384, -1.0],
          [3.964569, 51.816278, -1.0],
          [3.964711, 51.816133, -1.0],
          [3.965514, 51.815041, -1.0],
          [3.965551, 51.815005, -1.0],
          [3.965603, 51.814974, -1.0],
          [3.965661, 51.814949, -1.0],
          [3.965727, 51.814932, -1.0],
          [3.966058, 51.814848, -0.5],
          [3.965931, 51.814650, -0.75],
          [3.965848, 51.814568, -0.75],
          [3.965745, 51.814517, -1.0],
          [3.965687, 51.814495, -1.0],
          [3.965745, 51.814517, -1.0],
          [3.965848, 51.814568, -0.75],
          [3.965931, 51.814650, -0.75],
          [3.966058, 51.814848, -0.5],
          [3.965727, 51.814932, -1.0],
          [3.965845, 51.814988, -0.75],
          [3.966835, 51.815224, -0.5],
          [3.968550, 51.815551, -1.25],
          [3.969794, 51.815821, -1.25],
          [3.970428, 51.815973, -1.25],
          [3.971063, 51.816144, -1.25],
          [3.972071, 51.816445, -1.0],
          [3.973564, 51.816905, 0.0],
          [3.974206, 51.817088, 0.0],
          [3.974610, 51.817190, 0.25],
          [3.975277, 51.817347, 1.0],
          [3.975145, 51.817646, 1.0],
          [3.975341, 51.817685, 1.25],
          [3.975606, 51.817738, 1.5],
          [3.975751, 51.817766, 1.75],
          [3.976097, 51.817861, 2.25],
          [3.976172, 51.817879, 2.25],
          [3.977193, 51.818164, 3.5],
          [3.977557, 51.818178, 3.75],
          [3.977607, 51.817951, 3.5],
          [3.977607, 51.817948, 3.5],
          [3.977609, 51.817868, 3.5],
          [3.977620, 51.817832, 3.5],
          [3.977545, 51.817818, 3.25],
          [3.977470, 51.817777, 3.25],
          [3.977470, 51.817728, 3.25],
          [3.977515, 51.817465, 2.75],
          [3.978228, 51.817382, 3.5],
          [3.978449, 51.817332, 3.5],
          [3.978572, 51.817304, 3.5],
          [3.978621, 51.817076, 2.75],
          [3.978905, 51.816491, 1.75],
          [3.979131, 51.816015, 1.0],
          [3.979151, 51.815971, 1.0],
          [3.979190, 51.815933, 1.0],
          [3.979191, 51.815933, 1.0],
          [3.979247, 51.815904, 0.75],
          [3.979315, 51.815887, 0.75],
          [3.979388, 51.815883, 0.75],
          [3.979950, 51.815992, 0.25],
          [3.981296, 51.816241, 0.5],
          [3.981729, 51.816341, 0.25],
          [3.982137, 51.816476, 0.0],
          [3.982518, 51.816626, 0.0],
          [3.982597, 51.816661, 0.0],
          [3.982653, 51.816696, 0.0],
          [3.982697, 51.816738, 0.0],
          [3.982905, 51.816683, -0.25],
          [3.982988, 51.816807, 0.0],
          [3.982905, 51.816683, -0.25],
          [3.982697, 51.816738, 0.0],
          [3.982719, 51.816773, 0.0],
          [3.982727, 51.816809, 0.0],
          [3.982718, 51.816846, 0.0],
          [3.982592, 51.817109, 0.5],
          [3.982580, 51.817191, 0.5],
          [3.982588, 51.817258, 0.75],
          [3.982984, 51.817303, 1.0],
          [3.982925, 51.817460, 1.25],
          [3.982870, 51.817606, 1.25],
          [3.982845, 51.817675, 1.25],
          [3.982831, 51.817715, 1.25],
          [3.982932, 51.817726, 1.5],
          [3.982990, 51.817732, 1.5],
          [3.983102, 51.817730, 1.5],
          [3.983301, 51.817696, 1.5],
          [3.983413, 51.817695, 1.5],
          [3.983997, 51.817743, 1.0],
          [3.984907, 51.817849, 0.0],
          [3.985569, 51.817967, 0.0],
          [3.986375, 51.818145, 0.5],
          [3.988784, 51.818696, 0.25],
          [3.989099, 51.818866, 0.25],
          [3.991065, 51.819322, 0.25],
          [3.991475, 51.819501, -0.5],
          [3.991620, 51.819575, -0.75],
          [3.992463, 51.820154, -1.5],
          [3.992581, 51.820318, -1.0],
          [3.995669, 51.822407, 1.0],
          [3.996130, 51.822600, 0.75],
          [3.998434, 51.824198, -1.0],
          [3.998693, 51.824458, -1.0],
          [3.998869, 51.824612, -1.0],
          [3.999173, 51.824797, -1.0],
          [3.999771, 51.825100, -1.0],
          [4.001715, 51.826392, -0.5],
          [4.002404, 51.826825, 0.0],
          [4.002322, 51.826898, 0.0],
          [4.002327, 51.826972, 0.0],
          [4.002359, 51.827047, 0.0],
          [4.002364, 51.827522, 0.0],
          [4.002398, 51.827661, 0.0],
          [4.002483, 51.827840, 0.0],
          [4.002559, 51.828027, 0.0],
          [4.002169, 51.830002, 0.5],
          [4.001963, 51.830958, 1.0],
          [4.001612, 51.831667, 0.75],
          [4.001532, 51.831768, 0.75],
          [4.001595, 51.831853, 1.0],
          [4.001619, 51.831962, 1.25],
          [4.001617, 51.832387, 1.75],
          [4.001641, 51.832502, 1.75],
          [4.001726, 51.832599, 2.25],
          [4.001575, 51.832696, 2.25],
          [4.001726, 51.832599, 2.25],
          [4.001840, 51.832653, 2.5],
          [4.001958, 51.832674, 2.75],
          [4.002113, 51.832653, 2.75],
          [4.002511, 51.832496, 3.0],
          [4.004958, 51.831454, 1.0],
          [4.005256, 51.831331, 1.25],
          [4.005530, 51.831193, 1.5],
          [4.005966, 51.830871, 2.0],
          [4.006472, 51.830371, 2.0],
          [4.006558, 51.830297, 2.0],
          [4.006815, 51.830069, 2.0],
          [4.007081, 51.829834, 1.5],
          [4.007168, 51.829758, 1.5],
          [4.007325, 51.829820, 1.75],
          [4.007496, 51.829900, 1.75],
          [4.007931, 51.830120, 1.5],
          [4.008054, 51.830189, 1.5],
          [4.009544, 51.831043, 1.75],
          [4.010611, 51.831665, 3.75],
          [4.010817, 51.831790, 4.25],
          [4.011052, 51.831916, 4.75],
          [4.011665, 51.832020, 5.25],
          [4.011665, 51.832020, 5.25],
          [4.011680, 51.832100, 5.5],
          [4.011652, 51.832177, 5.75],
          [4.012039, 51.832197, 6.25],
          [4.013244, 51.831955, 6.75],
          [4.013883, 51.831800, 7.0],
          [4.014551, 51.831621, 7.25],
          [4.015410, 51.831346, 7.5],
          [4.015950, 51.831129, 7.0],
          [4.016464, 51.830901, 6.25],
          [4.016843, 51.830722, 6.0],
          [4.017267, 51.830489, 6.0],
          [4.017572, 51.830305, 5.5],
          [4.018525, 51.829769, 3.75],
          [4.018858, 51.829608, 4.0],
          [4.019376, 51.829372, 4.0],
          [4.019893, 51.829159, 3.75],
          [4.020212, 51.829047, 4.0],
          [4.020661, 51.828900, 4.25],
          [4.021080, 51.828765, 4.75],
          [4.021907, 51.828561, 5.0],
          [4.023206, 51.828251, 4.75],
          [4.024231, 51.827974, 3.0],
          [4.024956, 51.827741, 2.0],
          [4.025789, 51.827423, 1.0],
          [4.026435, 51.827138, 1.5],
          [4.027162, 51.826768, 2.0],
          [4.027314, 51.826741, 2.0],
          [4.027380, 51.826716, 2.0],
          [4.027432, 51.826681, 2.0],
          [4.027558, 51.826624, 1.75],
          [4.027589, 51.826590, 1.75],
          [4.027609, 51.826538, 1.5],
          [4.028572, 51.826048, 2.0],
          [4.028734, 51.825983, 2.25],
          [4.028817, 51.825977, 2.25],
          [4.028903, 51.825948, 2.25],
          [4.028965, 51.825910, 2.5],
          [4.029012, 51.825871, 2.5],
          [4.029087, 51.825770, 2.5],
          [4.029737, 51.825494, 3.0],
          [4.030436, 51.825157, 3.5],
          [4.031117, 51.824806, 3.75],
          [4.032491, 51.824110, 3.75],
          [4.032674, 51.824002, 4.0],
          [4.032851, 51.823880, 4.0],
          [4.033265, 51.823560, 4.0],
          [4.033361, 51.823504, 4.0],
          [4.033502, 51.823480, 3.75],
          [4.033624, 51.823430, 3.5],
          [4.033687, 51.823386, 3.5],
          [4.033721, 51.823261, 3.25],
          [4.034195, 51.822898, 3.0],
          [4.034499, 51.822682, 3.75],
          [4.034795, 51.822522, 5.0],
          [4.034935, 51.822418, 5.75],
          [4.035777, 51.821794, 5.25],
          [4.035881, 51.821709, 4.75],
          [4.036150, 51.821502, 3.75],
          [4.036353, 51.821361, 3.0],
          [4.036793, 51.821092, 2.5],
          [4.036844, 51.821068, 2.5],
          [4.036910, 51.821057, 2.5],
          [4.036962, 51.821060, 2.5],
          [4.037063, 51.821099, 2.5],
          [4.037109, 51.821069, 2.5],
          [4.037188, 51.821018, 2.75],
          [4.037278, 51.820960, 2.75],
          [4.037249, 51.820920, 2.75],
          [4.037235, 51.820864, 2.75],
          [4.037244, 51.820804, 2.75],
          [4.037235, 51.820864, 2.75],
          [4.037249, 51.820920, 2.75],
          [4.037278, 51.820960, 2.75],
          [4.037615, 51.821194, 2.25],
          [4.037831, 51.821329, 2.0],
          [4.038289, 51.821674, 2.0],
          [4.038360, 51.821727, 2.0],
          [4.038543, 51.821977, 2.0],
          [4.038952, 51.822296, 2.0],
          [4.039966, 51.823029, 0.75],
          [4.040040, 51.823090, 0.5],
          [4.040647, 51.823543, 0.0],
          [4.040970, 51.823791, 0.5],
          [4.041241, 51.823907, 1.25],
          [4.041377, 51.823993, 1.75],
          [4.041463, 51.824072, 2.0],
          [4.041655, 51.824276, 3.75],
          [4.041844, 51.824392, 4.5],
          [4.041923, 51.824515, 5.25],
          [4.041976, 51.824599, 5.75],
          [4.042378, 51.824506, 5.0],
          [4.042488, 51.824489, 4.75],
          [4.042602, 51.824481, 4.75],
          [4.042702, 51.824484, 4.75],
          [4.042842, 51.824506, 4.75],
          [4.042974, 51.824546, 5.0],
          [4.043069, 51.824600, 5.0],
          [4.043172, 51.824694, 5.5],
          [4.043251, 51.824837, 6.25],
          [4.043330, 51.825120, 7.0],
          [4.043341, 51.825157, 7.0],
          [4.043356, 51.825211, 7.0],
          [4.043406, 51.825394, 7.0],
          [4.043444, 51.825536, 7.0],
          [4.042722, 51.825611, 9.0],
          [4.042719, 51.825605, 8.75],
          [4.042722, 51.825611, 9.0],
          [4.043444, 51.825536, 9.0],
          [4.043406, 51.825394, 9.0],
          [4.043356, 51.825211, 9.0],
          [4.043341, 51.825157, 9.0],
          [4.043330, 51.825120, 7.0],
          [4.043251, 51.824837, 6.25],
          [4.043172, 51.824694, 5.5],
          [4.043069, 51.824600, 5.0],
          [4.042974, 51.824546, 5.0],
          [4.042842, 51.824506, 4.75],
          [4.042702, 51.824484, 4.75],
          [4.042602, 51.824481, 4.75],
          [4.042488, 51.824489, 4.75],
          [4.042378, 51.824506, 5.0],
          [4.041976, 51.824599, 5.75],
          [4.041763, 51.824675, 6.5],
          [4.041988, 51.825094, 8.75],
          [4.042368, 51.825752, 10.0],
          [4.042854, 51.826648, 9.5],
          [4.043250, 51.827355, 11.25],
          [4.043523, 51.827741, 10.75],
          [4.043839, 51.828122, 9.0],
          [4.044132, 51.828403, 9.0],
          [4.044451, 51.828676, 4.5],
          [4.044465, 51.828686, 4.25],
          [4.044771, 51.828927, 2.5],
          [4.054854, 51.836415, 6.5],
          [4.056434, 51.837481, 6.5],
          [4.057944, 51.838376, 9.25],
          [4.058521, 51.838683, 9.5],
          [4.059648, 51.839285, 9.5],
          [4.060983, 51.839945, 9.0],
          [4.062573, 51.840691, 8.75],
          [4.063374, 51.841024, 8.5],
          [4.064209, 51.841373, 8.25],
          [4.064909, 51.841648, 8.0],
          [4.066589, 51.842260, 6.75],
          [4.067759, 51.842643, 6.25],
          [4.068824, 51.842976, 6.5],
          [4.070122, 51.843340, 5.75],
          [4.071030, 51.843574, 5.75],
          [4.071082, 51.843587, 5.75],
          [4.071123, 51.843597, 5.75],
          [4.072072, 51.843828, 6.0],
          [4.073213, 51.844095, 5.0],
          [4.074550, 51.844377, 5.75],
          [4.075276, 51.844529, 6.25],
          [4.075635, 51.844580, 6.0],
          [4.076018, 51.844620, 5.75],
          [4.076575, 51.844661, 5.25],
          [4.077063, 51.844705, 5.25],
          [4.077473, 51.844774, 5.25],
          [4.077945, 51.844880, 4.5],
          [4.078595, 51.845079, 4.0],
          [4.079294, 51.845251, 4.25],
          [4.079647, 51.845306, 4.5],
          [4.080328, 51.845389, 4.5],
          [4.080966, 51.845484, 5.0],
          [4.081299, 51.845551, 5.25],
          [4.081558, 51.845631, 5.5],
          [4.081967, 51.845771, 4.25],
          [4.082485, 51.845979, 3.0],
          [4.082988, 51.846158, 2.25],
          [4.083705, 51.846444, 2.0],
          [4.084050, 51.846568, 2.0],
          [4.084193, 51.846591, 1.5],
          [4.084595, 51.846658, 0.75],
          [4.085027, 51.846673, 0.0],
          [4.085531, 51.846635, 0.0],
          [4.085987, 51.846563, 0.0],
          [4.085627, 51.845793, 0.0],
          [4.085542, 51.845669, 0.0],
          [4.085436, 51.845588, 0.0],
          [4.085313, 51.845521, 0.0],
          [4.085136, 51.845474, 0.0],
          [4.085058, 51.845464, 0.0],
          [4.084825, 51.845433, 0.0],
          [4.084844, 51.845250, 0.0],
          [4.084844, 51.845250, 0.0],
          [4.084825, 51.845433, 0.0],
          [4.084700, 51.845800, 0.25],
          [4.084400, 51.846500, 1.25],
          [4.083978, 51.847506, 1.0],
          [4.083877, 51.847805, 0.25],
          [4.083817, 51.848077, -0.25],
          [4.083739, 51.848196, -0.5],
          [4.083719, 51.848286, -0.75],
          [4.083710, 51.848414, -0.75],
          [4.083719, 51.848539, -0.5],
          [4.083816, 51.848551, -0.25],
          [4.083921, 51.848554, -0.25],
          [4.083937, 51.848724, 0.0],
          [4.084002, 51.849092, 0.75],
          [4.084058, 51.849263, 0.5],
          [4.084239, 51.849811, 0.0],
          [4.084306, 51.849941, 0.0],
          [4.084412, 51.850095, 0.0],
          [4.084615, 51.850286, 0.0],
          [4.084787, 51.850418, 0.0],
          [4.084947, 51.850519, -0.25],
          [4.086783, 51.851502, 0.0],
          [4.087052, 51.851616, 0.0],
          [4.087352, 51.851761, 0.0],
          [4.087741, 51.851969, -0.5],
          [4.087955, 51.852062, -0.75],
          [4.088261, 51.852164, -0.75],
          [4.088448, 51.852237, -1.0],
          [4.088556, 51.852303, -1.0],
          [4.088664, 51.852398, -1.0],
          [4.088700, 51.852461, -1.0],
          [4.088795, 51.852681, -0.75],
          [4.088857, 51.852834, -0.5],
          [4.088871, 51.852913, -0.5],
          [4.088853, 51.852973, -0.25],
          [4.088773, 51.853097, -0.25],
          [4.088600, 51.853300, 0.0],
          [4.087321, 51.854364, 0.75],
          [4.086961, 51.854570, 0.5],
          [4.086175, 51.855210, 0.0],
          [4.085500, 51.855800, 0.0],
          [4.085100, 51.856100, 0.0],
          [4.084719, 51.856403, 0.0],
          [4.084506, 51.856574, 0.0],
          [4.084367, 51.856682, -0.25],
          [4.083400, 51.857500, -0.75],
          [4.081900, 51.858800, 0.0],
          [4.081400, 51.859200, -0.5],
          [4.081135, 51.859393, -0.5],
          [4.080845, 51.859581, 0.0],
          [4.080715, 51.859651, 0.0],
          [4.080555, 51.859708, 0.5],
          [4.080370, 51.859741, 0.75],
          [4.080100, 51.859741, 1.25],
          [4.079907, 51.859732, 1.5],
          [4.079666, 51.859789, 1.25],
          [4.079513, 51.859871, 1.25],
          [4.079400, 51.860000, 1.25],
          [4.078926, 51.860713, 0.0],
          [4.078915, 51.860810, 0.0],
          [4.078919, 51.860884, 0.0],
          [4.078982, 51.861048, 0.0],
          [4.078975, 51.861172, 0.0],
          [4.078900, 51.861400, 0.0],
          [4.078097, 51.862072, 0.0],
          [4.077800, 51.862300, 0.0],
          [4.077371, 51.862472, 0.0],
          [4.077090, 51.862548, 0.0],
          [4.076900, 51.862600, 0.0],
          [4.076700, 51.862700, -0.25],
          [4.076600, 51.862800, -0.5],
          [4.076600, 51.863200, -1.5],
          [4.076500, 51.863400, -1.75],
          [4.076200, 51.863700, -1.25],
          [4.075900, 51.863900, -1.0],
          [4.075303, 51.864409, -1.25],
          [4.074600, 51.864900, -1.25],
          [4.074156, 51.865245, -0.25],
          [4.073228, 51.865967, 0.75],
          [4.073023, 51.866041, 0.75],
          [4.072860, 51.866047, 0.5],
          [4.072512, 51.865950, 0.75],
          [4.071953, 51.865756, 0.75],
          [4.071785, 51.865726, 0.75],
          [4.071588, 51.865722, 0.75],
          [4.071395, 51.865788, 0.5],
          [4.071267, 51.865778, 0.5],
          [4.071013, 51.865745, 0.25],
          [4.069768, 51.865571, 0.25],
          [4.068726, 51.865438, 1.5],
          [4.068137, 51.865396, 2.25],
          [4.067409, 51.865387, 3.25],
          [4.067120, 51.865379, 3.5],
          [4.066864, 51.865401, 3.75],
          [4.066726, 51.865437, 3.75],
          [4.066622, 51.865490, 3.5],
          [4.066476, 51.865665, 3.0],
          [4.066361, 51.865760, 3.0],
          [4.066193, 51.865844, 3.0],
          [4.066029, 51.865909, 3.25],
          [4.065893, 51.865953, 3.25],
          [4.065731, 51.866026, 3.5],
          [4.065626, 51.866118, 3.25],
          [4.065537, 51.866224, 3.25],
          [4.065348, 51.866470, 2.75],
          [4.065120, 51.866796, 2.0],
          [4.065010, 51.866901, 1.75],
          [4.064763, 51.867041, 2.0],
          [4.064567, 51.867184, 2.0],
          [4.064485, 51.867230, 2.0],
          [4.064369, 51.867270, 2.25],
          [4.064246, 51.867299, 2.5],
          [4.063548, 51.867416, 3.75],
          [4.063419, 51.867467, 3.75],
          [4.063321, 51.867523, 3.75],
          [4.063109, 51.867736, 3.0],
          [4.062929, 51.867861, 3.0],
          [4.062577, 51.868080, 2.75],
          [4.062394, 51.868197, 2.75],
          [4.062185, 51.868400, 2.5],
          [4.062123, 51.868470, 2.5],
          [4.061230, 51.869359, 2.25],
          [4.060925, 51.869739, 2.75],
          [4.060830, 51.869859, 3.0],
          [4.060619, 51.870209, 3.25],
          [4.060437, 51.870571, 3.25],
          [4.060091, 51.871309, 4.25],
          [4.059771, 51.872057, 4.5],
          [4.058253, 51.872027, 8.0],
          [4.058170, 51.872039, 8.0],
          [4.057935, 51.872162, 8.0],
          [4.057891, 51.872199, 8.0],
          [4.057705, 51.872357, 7.75],
          [4.057627, 51.872460, 7.75],
          [4.057550, 51.872560, 7.5],
          [4.057502, 51.872603, 7.5],
          [4.057182, 51.872981, 6.5],
          [4.056884, 51.873304, 5.75],
          [4.056615, 51.873591, 5.75],
          [4.056086, 51.874127, 5.75],
          [4.055618, 51.874331, 5.25],
          [4.054846, 51.874375, 5.25],
          [4.054424, 51.874377, 5.75],
          [4.054260, 51.874386, 6.0],
          [4.054207, 51.874395, 6.0],
          [4.053871, 51.874453, 6.0],
          [4.053727, 51.874448, 6.0],
          [4.053609, 51.874479, 6.0],
          [4.053003, 51.874635, 6.25],
          [4.052575, 51.874839, 7.0],
          [4.051970, 51.875221, 6.5],
          [4.051897, 51.875257, 6.5],
          [4.051731, 51.875339, 6.5],
          [4.051545, 51.875397, 6.5],
          [4.050562, 51.875657, 8.25],
          [4.050185, 51.875930, 9.25],
          [4.049766, 51.876213, 8.5],
          [4.049621, 51.876282, 8.25],
          [4.049340, 51.876378, 7.5],
          [4.048901, 51.876498, 7.0],
          [4.048864, 51.876510, 7.0],
          [4.048857, 51.876562, 7.0],
          [4.048834, 51.876655, 7.0],
          [4.048791, 51.876685, 6.75],
          [4.048680, 51.876729, 6.75],
          [4.048537, 51.876861, 6.5],
          [4.048466, 51.876968, 6.25],
          [4.048435, 51.877075, 6.0],
          [4.048267, 51.877053, 6.0],
          [4.048435, 51.877075, 6.0],
          [4.048433, 51.877125, 5.75],
          [4.048762, 51.877141, 5.75],
          [4.049394, 51.877105, 6.0],
          [4.049907, 51.877077, 6.25],
          [4.051003, 51.877073, 5.75],
          [4.050998, 51.877113, 5.75],
          [4.050997, 51.877180, 5.5],
          [4.050996, 51.877204, 5.25],
          [4.050991, 51.877428, 5.25],
          [4.050967, 51.877721, 5.25],
          [4.050931, 51.877865, 5.25],
          [4.050819, 51.877978, 5.5],
          [4.050741, 51.878087, 5.5],
          [4.050734, 51.878137, 5.75],
          [4.050761, 51.878423, 6.0],
          [4.050936, 51.878552, 5.75],
          [4.051054, 51.878589, 5.5],
          [4.051517, 51.878739, 4.75],
          [4.051754, 51.878793, 4.25],
          [4.052091, 51.878820, 4.25],
          [4.052847, 51.879109, 4.25],
          [4.052976, 51.879152, 4.5],
          [4.053282, 51.879320, 4.75],
          [4.053334, 51.879344, 4.75],
          [4.053389, 51.879371, 4.75],
          [4.053487, 51.879409, 4.75],
          [4.053565, 51.879426, 4.75],
          [4.053792, 51.879428, 4.75],
          [4.053827, 51.879439, 4.75],
          [4.053853, 51.879463, 4.75],
          [4.053858, 51.879489, 4.75],
          [4.053829, 51.879608, 4.75],
          [4.053780, 51.879755, 4.5],
          [4.053797, 51.879810, 4.5],
          [4.053821, 51.879845, 4.5],
          [4.053846, 51.879861, 4.5],
          [4.053875, 51.879869, 4.5],
          [4.053967, 51.879884, 4.75],
          [4.054028, 51.879900, 4.75],
          [4.054099, 51.879934, 4.75],
          [4.054846, 51.880538, 4.5],
          [4.054751, 51.881279, 3.0],
          [4.056165, 51.882598, 0.75],
          [4.056380, 51.882715, 0.75],
          [4.056552, 51.882778, 0.75],
          [4.056972, 51.882951, 1.0],
          [4.057176, 51.883119, 1.0],
          [4.057126, 51.883614, 1.0],
          [4.057041, 51.883700, 1.0],
          [4.056928, 51.883752, 1.25],
          [4.056497, 51.883796, 0.75],
          [4.055650, 51.883885, 0.5],
          [4.055290, 51.883937, 0.25],
          [4.055060, 51.884025, 0.0],
          [4.054884, 51.884179, 0.25],
          [4.054798, 51.884328, 1.0],
          [4.054724, 51.884522, 1.75],
          [4.054623, 51.884881, 3.25],
          [4.054571, 51.885101, 4.25],
          [4.054598, 51.885171, 4.5],
          [4.055261, 51.886077, 5.75],
          [4.055265, 51.886249, 5.75],
          [4.055230, 51.886340, 6.0],
          [4.055230, 51.886430, 6.0],
          [4.055314, 51.886616, 5.75],
          [4.055457, 51.886799, 5.25],
          [4.055750, 51.886968, 4.5],
          [4.056151, 51.887148, 3.5],
          [4.056350, 51.887225, 3.0],
          [4.056450, 51.887223, 2.75],
          [4.056521, 51.887189, 2.5],
          [4.056555, 51.887146, 2.25],
          [4.056845, 51.886840, 1.0],
          [4.056918, 51.886802, 1.0],
          [4.057016, 51.886785, 0.75],
          [4.059457, 51.887105, -0.25],
          [4.059470, 51.887478, 0.0],
          [4.059432, 51.887850, 0.0],
          [4.060464, 51.888074, 0.0],
          [4.060658, 51.888101, 0.0],
          [4.060853, 51.888129, 0.0],
          [4.061211, 51.888213, -0.25],
          [4.061621, 51.888367, -0.75],
          [4.061973, 51.888537, -0.75],
          [4.062307, 51.888742, -0.5],
          [4.062383, 51.888816, -0.25],
          [4.062507, 51.889039, 0.0],
          [4.062608, 51.889223, 0.0],
          [4.062667, 51.889288, 0.0],
          [4.062824, 51.889415, 0.25],
          [4.062936, 51.889470, 0.25],
          [4.063968, 51.889854, 0.75],
          [4.064514, 51.890086, 0.5],
          [4.064558, 51.890129, 0.75],
          [4.064678, 51.890219, 0.75],
          [4.064761, 51.890421, 1.0],
          [4.064879, 51.890923, 1.75],
          [4.064935, 51.891065, 1.5],
          [4.065034, 51.891207, 1.5],
          [4.065160, 51.891338, 1.25],
          [4.065350, 51.891497, 1.0],
          [4.065557, 51.891639, 1.0],
          [4.065823, 51.891765, 1.0],
          [4.065931, 51.891789, 1.0],
          [4.066035, 51.891803, 0.75],
          [4.066274, 51.891821, 0.5],
          [4.066795, 51.891828, 0.0],
          [4.067768, 51.891816, 0.25],
          [4.068024, 51.891818, 0.5],
          [4.068293, 51.891889, 0.75],
          [4.068602, 51.892081, 1.25],
          [4.069006, 51.892775, 1.0],
          [4.069255, 51.893301, 0.25],
          [4.069341, 51.893480, 0.0],
          [4.070117, 51.894976, 0.0],
          [4.070435, 51.895468, 0.5],
          [4.070571, 51.895621, 0.5],
          [4.070651, 51.895699, 0.75],
          [4.070694, 51.895715, 0.75],
          [4.070752, 51.895724, 0.75],
          [4.070920, 51.895716, 0.75],
          [4.071048, 51.895720, 1.0],
          [4.071160, 51.895749, 1.25],
          [4.071261, 51.895807, 1.25],
          [4.071355, 51.895908, 1.5],
          [4.071385, 51.896022, 1.5],
          [4.071363, 51.896124, 1.5],
          [4.071288, 51.896217, 1.5],
          [4.070713, 51.896716, 1.75],
          [4.070595, 51.896831, 1.75],
          [4.070559, 51.896879, 1.75],
          [4.070540, 51.896928, 1.75],
          [4.070723, 51.898880, 7.25],
          [4.070654, 51.898949, 7.5],
          [4.070300, 51.899300, 9.0],
          [4.069900, 51.899800, 8.75],
          [4.069800, 51.900000, 8.75],
          [4.069782, 51.900264, 8.5],
          [4.069853, 51.900737, 8.5],
          [4.069869, 51.900882, 8.25],
          [4.069886, 51.901085, 7.5],
          [4.069918, 51.901215, 7.0],
          [4.069870, 51.901252, 6.75],
          [4.069878, 51.901340, 6.25],
          [4.070023, 51.901714, 4.75],
          [4.069932, 51.901767, 4.75],
          [4.069715, 51.901891, 4.5],
          [4.069506, 51.902002, 4.25],
          [4.069386, 51.902056, 4.25],
          [4.069284, 51.902136, 4.5],
          [4.069239, 51.902195, 4.5],
          [4.069190, 51.902314, 4.75],
          [4.069091, 51.902413, 4.75],
          [4.068915, 51.902522, 5.0],
          [4.068784, 51.902621, 5.0],
          [4.068776, 51.902690, 5.0],
          [4.068857, 51.902785, 5.25],
          [4.069500, 51.903188, 5.25],
          [4.070180, 51.903646, 5.25],
          [4.070441, 51.903746, 5.25],
          [4.070754, 51.903953, 5.5],
          [4.070838, 51.904147, 5.75],
          [4.071010, 51.904315, 6.0],
          [4.071024, 51.904511, 6.0],
          [4.070984, 51.904721, 5.75],
          [4.070739, 51.905080, 6.0],
          [4.070655, 51.905468, 6.0],
          [4.070674, 51.905596, 6.0],
          [4.070823, 51.905724, 6.0],
          [4.071069, 51.905834, 5.5],
          [4.071371, 51.905927, 5.25],
          [4.072465, 51.906215, 5.0],
          [4.073082, 51.906392, 4.5],
          [4.073763, 51.906613, 5.0],
          [4.074356, 51.906894, 6.5],
          [4.074481, 51.906993, 6.75],
          [4.074532, 51.907162, 6.75],
          [4.074599, 51.907297, 6.75],
          [4.074986, 51.907421, 7.0],
          [4.075455, 51.907601, 7.0],
          [4.076101, 51.907900, 6.25],
          [4.076252, 51.907964, 6.25],
          [4.076963, 51.908348, 5.25],
          [4.077114, 51.908399, 5.5],
          [4.077485, 51.908614, 6.5],
          [4.077713, 51.908754, 6.75],
          [4.077852, 51.908839, 7.25],
          [4.077531, 51.909113, 7.75],
          [4.076987, 51.909562, 7.5],
          [4.076823, 51.909652, 7.25],
          [4.076595, 51.909739, 7.25],
          [4.076398, 51.909814, 7.75],
          [4.075833, 51.910083, 8.5],
          [4.074373, 51.910777, 6.75],
          [4.074022, 51.910996, 7.0],
          [4.073715, 51.911210, 7.25],
          [4.073646, 51.911259, 7.25],
          [4.073195, 51.911660, 7.0],
          [4.072203, 51.912913, 6.0],
          [4.071753, 51.913449, 7.5],
          [4.071459, 51.913623, 7.0],
          [4.070945, 51.913850, 5.75],
          [4.070011, 51.914161, 5.0],
          [4.068888, 51.914494, 4.25],
          [4.067267, 51.914887, 4.0],
          [4.066718, 51.914995, 4.0],
          [4.066480, 51.915051, 4.0],
          [4.066238, 51.915091, 4.0],
          [4.065869, 51.915142, 4.0],
          [4.065496, 51.915194, 4.0],
          [4.065335, 51.915226, 4.25],
          [4.065082, 51.915314, 4.25],
          [4.064902, 51.915364, 4.5],
          [4.064643, 51.915454, 4.75],
          [4.064362, 51.915563, 5.0],
          [4.064290, 51.915606, 5.0],
          [4.064251, 51.915663, 5.0],
          [4.064131, 51.915644, 5.0],
          [4.063726, 51.915574, 5.25],
          [4.064131, 51.915644, 5.0],
          [4.064251, 51.915663, 5.0],
          [4.064223, 51.915731, 5.0],
          [4.063617, 51.915651, 5.25],
          [4.062815, 51.915503, 6.0],
          [4.062789, 51.915539, 6.0],
          [4.062672, 51.915707, 5.75],
          [4.062519, 51.915830, 5.75],
          [4.062455, 51.915864, 5.75],
          [4.062372, 51.915914, 5.75],
          [4.061453, 51.916350, 5.25],
          [4.060575, 51.916817, 4.5],
          [4.058471, 51.918011, 3.5],
          [4.057778, 51.918413, 3.25],
          [4.057478, 51.918595, 3.0],
          [4.057408, 51.918637, 2.75],
          [4.052491, 51.921096, 2.75],
          [4.051348, 51.921663, 3.0],
          [4.048664, 51.922996, 3.75],
          [4.047249, 51.923644, 2.75],
          [4.046776, 51.923883, 1.0],
          [4.046164, 51.924171, 1.25],
          [4.045603, 51.924445, 2.75],
          [4.045141, 51.924647, 3.0],
          [4.044715, 51.924848, 2.5],
          [4.044253, 51.925091, 2.5],
          [4.043755, 51.925317, 2.75],
          [4.043377, 51.925462, 2.5],
          [4.042018, 51.925883, 5.0],
          [4.041862, 51.925915, 5.25],
          [4.041583, 51.925961, 5.75],
          [4.041504, 51.925976, 5.75],
          [4.041419, 51.925995, 5.5],
          [4.041304, 51.926048, 5.5],
          [4.041201, 51.926123, 5.25],
          [4.041117, 51.926221, 5.0],
          [4.040941, 51.926315, 4.75],
          [4.040902, 51.926396, 4.5],
          [4.040709, 51.926383, 4.5],
          [4.040681, 51.926395, 4.5],
          [4.040625, 51.926421, 4.5],
          [4.040541, 51.926487, 4.25],
          [4.040506, 51.926551, 4.25],
          [4.040253, 51.926498, 4.25],
          [4.039919, 51.926442, 4.5],
          [4.039351, 51.926308, 4.75],
          [4.038748, 51.926189, 4.5],
          [4.038614, 51.926168, 4.5],
          [4.038166, 51.926130, 4.5],
          [4.037991, 51.926138, 4.75],
          [4.037852, 51.926150, 5.0],
          [4.037838, 51.926102, 5.0],
          [4.037852, 51.926150, 5.0],
          [4.037698, 51.926174, 5.25],
          [4.037279, 51.926291, 5.5],
          [4.036936, 51.926410, 5.5],
          [4.036582, 51.926557, 5.0],
          [4.035666, 51.926916, 3.75],
          [4.034348, 51.927482, 3.75],
          [4.033573, 51.927763, 4.5],
          [4.032773, 51.928016, 5.75],
          [4.030585, 51.928700, 4.75],
          [4.026948, 51.929779, 4.5],
          [4.024309, 51.930518, 4.0],
          [4.023871, 51.930625, 4.0],
          [4.023420, 51.930716, 4.0],
          [4.023124, 51.930762, 3.75],
          [4.020200, 51.931146, 2.25],
          [4.019200, 51.931328, 4.75],
          [4.018922, 51.931388, 5.25],
          [4.018683, 51.931440, 5.5],
          [4.018457, 51.931490, 6.0],
          [4.018244, 51.931538, 6.25],
          [4.018182, 51.931552, 6.5],
          [4.017920, 51.931614, 7.0],
          [4.018182, 51.931552, 6.5],
          [4.018199, 51.931584, 6.5],
          [4.018213, 51.931610, 6.5],
          [4.018253, 51.931673, 6.25],
          [4.018280, 51.931707, 6.0],
          [4.018297, 51.931728, 5.75],
          [4.018377, 51.931761, 5.5],
          [4.018494, 51.931803, 5.5],
          [4.018543, 51.931838, 5.25],
          [4.018783, 51.932221, 4.25],
          [4.018864, 51.932350, 4.0],
          [4.018873, 51.932369, 4.0],
          [4.018888, 51.932395, 4.0],
          [4.019066, 51.932691, 4.0],
          [4.019073, 51.932701, 3.25],
          [4.019085, 51.932719, 3.25],
          [4.019110, 51.932768, 3.25],
          [4.019141, 51.932826, 3.25],
          [4.019287, 51.933089, 3.25],
          [4.019370, 51.933285, 3.25],
          [4.019404, 51.933506, 3.25],
          [4.019411, 51.933721, 3.25],
          [4.019339, 51.934060, 2.75],
          [4.019272, 51.934221, 2.75],
          [4.018475, 51.935519, 2.75],
          [4.018210, 51.935869, 2.75],
          [4.017948, 51.936162, 2.75],
          [4.017650, 51.936534, 2.75],
          [4.017532, 51.936717, 3.75],
          [4.017400, 51.936900, 3.25],
          [4.017170, 51.937266, 2.75],
          [4.017121, 51.937289, 2.75],
          [4.016994, 51.937324, 2.75],
          [4.016935, 51.937324, 2.75],
          [4.016900, 51.937377, 2.75],
          [4.016848, 51.937457, 2.75],
          [4.016832, 51.937506, 2.75],
          [4.016926, 51.937651, 2.75],
          [4.016929, 51.937681, 2.75],
          [4.016811, 51.937880, 2.75],
          [4.015737, 51.939634, 2.75],
          [4.015589, 51.939887, 2.75],
          [4.015565, 51.939926, 2.75],
          [4.015534, 51.939977, 2.75],
          [4.015365, 51.940241, 2.75],
          [4.015325, 51.940307, 2.75],
          [4.014413, 51.941815, 5.5],
          [4.013661, 51.943044, 3.75],
          [4.012624, 51.944766, 6.5],
          [4.012516, 51.944935, 6.75],
          [4.012478, 51.944951, 6.75],
          [4.012330, 51.944989, 6.75],
          [4.012247, 51.945017, 7.0],
          [4.012198, 51.945061, 7.0],
          [4.012159, 51.945124, 7.0],
          [4.012122, 51.945180, 7.0],
          [4.012192, 51.945231, 7.0],
          [4.012260, 51.945337, 7.0],
          [4.012260, 51.945362, 7.0],
          [4.011664, 51.946338, 7.0],
          [4.011550, 51.946583, 7.0],
          [4.011475, 51.946805, 7.0],
          [4.011416, 51.947096, 7.0],
          [4.011412, 51.947357, 7.0],
          [4.011444, 51.947628, 7.0],
          [4.011510, 51.947853, 7.0],
          [4.011596, 51.948064, 7.0],
          [4.011709, 51.948267, 7.0],
          [4.011850, 51.948478, 7.0],
          [4.012020, 51.948671, 7.0],
          [4.012172, 51.948820, 7.0],
          [4.012332, 51.948960, 7.0],
          [4.012776, 51.949324, 7.0],
          [4.014016, 51.950338],
          [4.014348, 51.950561],
          [4.014841, 51.950964],
          [4.015192, 51.951212],
          [4.015414, 51.951341],
          [4.015695, 51.951484],
          [4.016008, 51.951617],
          [4.016267, 51.951717],
          [4.016462, 51.951778],
          [4.016885, 51.951895],
          [4.017073, 51.951938],
          [4.017949, 51.952139, 7.25],
          [4.018230, 51.952204, 9.0],
          [4.018466, 51.952258, 9.25],
          [4.019272, 51.952444, 7.5],
          [4.020629, 51.952761, 5.0],
          [4.020725, 51.952786, 5.0],
          [4.020839, 51.952826, 5.0],
          [4.020922, 51.952868, 5.0],
          [4.020984, 51.952937, 5.0],
          [4.021027, 51.952986],
          [4.021042, 51.953105],
          [4.021027, 51.953166],
          [4.020849, 51.953487, 4.75],
          [4.020517, 51.954040, 4.0],
          [4.020444, 51.954219, 3.75],
          [4.020406, 51.954318, 3.75],
          [4.020318, 51.954474, 3.5],
          [4.019261, 51.956183, 1.5],
          [4.019115, 51.956398, 2.25],
          [4.018921, 51.956656, 2.75],
          [4.018598, 51.957188, 4.5],
          [4.018540, 51.957241, 4.75],
          [4.018384, 51.957308, 5.25],
          [4.018347, 51.957355, 5.25],
          [4.018287, 51.957459, 5.75],
          [4.018217, 51.957582, 5.75],
          [4.018181, 51.957644, 5.75],
          [4.018163, 51.957676, 5.5],
          [4.018160, 51.957696, 5.5],
          [4.018178, 51.957748, 5.5],
          [4.018173, 51.957808, 5.5],
          [4.017927, 51.958198, 4.75],
          [4.017243, 51.959618, 3.0],
          [4.017067, 51.959930, 2.25],
          [4.016585, 51.960726, 3.0],
          [4.016509, 51.960856, 3.5],
          [4.016469, 51.960921, 3.5],
          [4.015195, 51.962989, 4.0],
          [4.014693, 51.963791, 3.0],
          [4.013665, 51.965497, 3.75],
          [4.013476, 51.965868, 3.75],
          [4.013342, 51.966177, 3.5],
          [4.013174, 51.966643, 2.5],
          [4.013075, 51.967027, 2.25],
          [4.013004, 51.967413, 2.0],
          [4.012962, 51.967745, 2.25],
          [4.012927, 51.968358, 3.0],
          [4.012954, 51.968782, 3.75],
          [4.013006, 51.969182, 4.75],
          [4.013156, 51.969854, 4.5],
          [4.013170, 51.970055, 4.5],
          [4.013189, 51.970165, 5.0],
          [4.013352, 51.970910, 9.0],
          [4.013380, 51.971002, 9.25],
          [4.013410, 51.971103, 9.75],
          [4.013667, 51.971893, 10.75],
          [4.013771, 51.972125, 10.25],
          [4.013910, 51.972365, 9.75],
          [4.014023, 51.972535, 9.0],
          [4.014131, 51.972649, 8.5],
          [4.014258, 51.972751, 8.0],
          [4.014391, 51.972837, 7.5],
          [4.014548, 51.972914, 7.0],
          [4.014624, 51.972943, 6.5],
          [4.014682, 51.972966, 6.5],
          [4.014845, 51.973015, 6.25],
          [4.015010, 51.973049, 5.75],
          [4.015283, 51.973077, 5.5],
          [4.015437, 51.973082, 5.25],
          [4.015595, 51.973078, 5.25],
          [4.015753, 51.973065, 5.0],
          [4.015894, 51.973042, 4.75],
          [4.016511, 51.972907, 4.0],
          [4.017606, 51.972651, 5.0],
          [4.022266, 51.971570, 3.0],
          [4.023248, 51.971334, 3.0],
          [4.024582, 51.971038, 2.5],
          [4.026332, 51.970630, 1.75],
          [4.028287, 51.970202, 3.25],
          [4.032763, 51.969129, 4.25],
          [4.035144, 51.968573, 0.75],
          [4.036079, 51.968355, 0.0],
          [4.036346, 51.968280, 0.25],
          [4.036570, 51.968229, 0.5],
          [4.040807, 51.967243, 0.5],
          [4.044910, 51.966293, 0.5],
          [4.045567, 51.966137, 0.5],
          [4.045670, 51.966136, 0.5],
          [4.045826, 51.966095, 0.5],
          [4.046003, 51.966054, 0.5],
          [4.045989, 51.966021, 0.5],
          [4.045764, 51.966072, 0.5],
          [4.045989, 51.966021],
          [4.046003, 51.966054],
          [4.045826, 51.966095],
          [4.045976, 51.966364],
          [4.046158, 51.966703],
          [4.046681, 51.967104],
          [4.048383, 51.967444],
          [4.049509, 51.967507],
          [4.051266, 51.967183],
          [4.058332, 51.965503],
          [4.070435, 51.963255],
          [4.079341, 51.962996],
          [4.079537, 51.963030],
          [4.082172, 51.963493],
          [4.083588, 51.964352],
          [4.084725, 51.965410],
          [4.087032, 51.969608],
          [4.088373, 51.971590],
          [4.088781, 51.971894],
          [4.089875, 51.972476],
          [4.090201, 51.972571],
          [4.090669, 51.972707],
          [4.091646, 51.972846],
          [4.094650, 51.972998],
          [4.097085, 51.972899],
          [4.098265, 51.972727],
          [4.113725, 51.968633],
          [4.118266, 51.969233],
          [4.120232, 51.969841],
          [4.121190, 51.970650],
          [4.121548, 51.971222],
          [4.123660, 51.975107],
          [4.124302, 51.976105, 0.25],
          [4.125057, 51.976802, 2.0],
          [4.125194, 51.977046, 2.0],
          [4.125354, 51.977230, 2.25],
          [4.125441, 51.977323, 2.25],
          [4.125446, 51.977329, 2.25],
          [4.125516, 51.977408, 2.5],
          [4.125536, 51.977431, 2.5],
          [4.125802, 51.977343, 2.75],
          [4.126162, 51.977217, 3.75],
          [4.126301, 51.977145, 4.0],
          [4.126574, 51.977026, 4.75],
          [4.126717, 51.977058, 5.0],
          [4.126676, 51.977131, 5.0],
          [4.126802, 51.977153, 5.0],
          [4.126805, 51.977182, 5.0],
          [4.126855, 51.977250, 5.0],
          [4.126922, 51.977291, 5.0],
          [4.127077, 51.977369, 5.0],
          [4.127130, 51.977388, 5.0],
          [4.127156, 51.977411, 5.0],
          [4.127159, 51.977429, 5.0],
          [4.127145, 51.977457, 5.0],
          [4.126924, 51.977806, 5.0],
          [4.126693, 51.978077, 5.0],
          [4.126540, 51.978250, 4.75],
          [4.126541, 51.978269, 4.75],
          [4.126565, 51.978287, 4.75],
          [4.126647, 51.978314, 4.75],
          [4.126748, 51.978349, 5.0],
          [4.126840, 51.978376, 5.25],
          [4.127596, 51.978624, 6.75],
          [4.127923, 51.978731, 7.25],
          [4.128148, 51.978813, 7.75],
          [4.128267, 51.978869, 7.75],
          [4.128364, 51.978925, 7.75],
          [4.128630, 51.979099, 7.5],
          [4.128784, 51.979211, 7.25],
          [4.129059, 51.979368, 6.75],
          [4.129513, 51.979614, 5.75],
          [4.129655, 51.979682, 5.5],
          [4.130256, 51.979925, 4.5],
          [4.130804, 51.980210, 4.25],
          [4.130966, 51.980329, 4.0],
          [4.130998, 51.980318, 4.0],
          [4.131115, 51.980299, 3.75],
          [4.131241, 51.980297, 3.5],
          [4.131254, 51.980325, 3.25],
          [4.131265, 51.980344, 3.25],
          [4.131254, 51.980325, 3.25],
          [4.131241, 51.980297, 3.5],
          [4.131115, 51.980299, 3.75],
          [4.130998, 51.980318, 4.0],
          [4.130966, 51.980329, 4.0],
          [4.130981, 51.980380, 4.0],
          [4.130990, 51.980394, 4.0],
          [4.131101, 51.980614, 3.75],
          [4.131144, 51.980810, 3.75],
          [4.131167, 51.980985, 3.5],
          [4.131246, 51.981683, 2.0],
          [4.131398, 51.982542, 1.25],
          [4.131417, 51.982756, 1.5],
          [4.131401, 51.982925, 1.75],
          [4.131361, 51.983059, 1.75],
          [4.131303, 51.983174, 1.75],
          [4.131165, 51.983347, 1.75],
          [4.131087, 51.983410, 1.5],
          [4.130917, 51.983549, 1.5],
          [4.129720, 51.984435, 2.25],
          [4.129652, 51.984484, 2.25],
          [4.129544, 51.984567, 2.25],
          [4.129143, 51.984859, 2.0],
          [4.128990, 51.984804, 2.0],
          [4.129143, 51.984859, 2.0],
          [4.129264, 51.984902, 2.0],
          [4.129561, 51.985006, 1.5],
          [4.129573, 51.985136, 1.5],
          [4.129630, 51.985264, 1.5],
          [4.129777, 51.985417, 1.5],
          [4.130350, 51.985914, 2.0],
          [4.130966, 51.986415, 2.0],
          [4.131028, 51.986482, 2.0],
          [4.130913, 51.986533, 2.0],
          [4.130854, 51.986558, 2.0],
          [4.130767, 51.986603, 2.0],
          [4.130816, 51.986649, 2.0],
          [4.130879, 51.986730, 1.75],
          [4.130910, 51.986952, 1.75],
          [4.130976, 51.986994, 1.75],
          [4.131122, 51.986921, 1.75],
          [4.131211, 51.986912, 1.75],
          [4.131199, 51.986831, 1.75],
          [4.131211, 51.986912, 1.75],
          [4.131188, 51.986972, 1.75],
          [4.131045, 51.987043, 1.75],
          [4.130916, 51.987098, 1.75],
          [4.130787, 51.987123, 2.0],
          [4.130611, 51.987179, 2.0],
          [4.130302, 51.987227, 2.0],
          [4.129975, 51.987256, 2.0],
          [4.129635, 51.987316, 2.0],
          [4.129399, 51.987365, 2.0],
          [4.129164, 51.987430, 2.0],
          [4.128610, 51.987637, 1.75],
          [4.127888, 51.987878, 2.75],
          [4.127794, 51.987940, 2.75],
          [4.127565, 51.988012, 3.25],
          [4.127247, 51.988125, 3.25],
          [4.127180, 51.988047, 3.25],
          [4.127217, 51.988035, 3.25],
          [4.127180, 51.988047, 3.25],
          [4.127247, 51.988125, 3.25],
          [4.127289, 51.988174, 3.0],
          [4.127441, 51.988357, 2.75],
          [4.127464, 51.988386, 3.0],
          [4.127909, 51.988839, 2.75],
          [4.128012, 51.988971, 2.75],
          [4.128036, 51.989090, 2.75],
          [4.128018, 51.989194, 2.75],
          [4.127949, 51.989315, 2.75],
          [4.127684, 51.989709, 2.25],
          [4.127660, 51.989743, 2.25],
          [4.127544, 51.989909, 2.0],
          [4.127408, 51.990104, 1.75],
          [4.127298, 51.990255, 1.5],
          [4.126210, 51.991838, 1.5],
          [4.126147, 51.991927, 1.75],
          [4.126096, 51.992005, 1.75],
          [4.126052, 51.992072, 2.0],
          [4.126002, 51.992144, 2.25],
          [4.125925, 51.992265, 2.5],
          [4.125916, 51.992300, 2.5],
          [4.125924, 51.992339, 2.5],
          [4.125967, 51.992412, 2.5],
          [4.126100, 51.992600, 2.25],
          [4.126677, 51.993109, 0.25],
          [4.126669, 51.993146, 0.0],
          [4.126621, 51.993181, 0.25],
          [4.126726, 51.993269, 0.0],
          [4.126800, 51.993240, 0.0],
          [4.126830, 51.993229, 0.0],
          [4.126837, 51.993291, 0.0],
          [4.126783, 51.993317, 0.0],
          [4.126876, 51.993385, 0.0],
          [4.126783, 51.993317, 0.0],
          [4.126837, 51.993291, 0.0],
          [4.126830, 51.993229, 0.0],
          [4.126800, 51.993240, 0.0],
          [4.126726, 51.993269, 0.0],
          [4.126687, 51.993288, 0.0],
          [4.126440, 51.993404, 1.0],
          [4.126405, 51.993420, 1.25],
          [4.126313, 51.993462, 1.5],
          [4.126288, 51.993475, 1.75],
          [4.127028, 51.994147, 3.25],
          [4.127036, 51.994155, 3.5],
          [4.126032, 51.993589, 3.0],
          [4.125931, 51.993630, 3.0],
          [4.124713, 51.994140, 5.0],
          [4.124669, 51.994160, 5.0],
          [4.123945, 51.994463, 5.5],
          [4.123970, 51.994474, 5.5],
          [4.123945, 51.994463, 5.5],
          [4.123681, 51.994272, 5.25],
          [4.123057, 51.993893, 5.25],
          [4.122446, 51.993568, 6.0],
          [4.122188, 51.993430, 6.25],
          [4.121261, 51.992901, 5.25],
          [4.120960, 51.992686, 5.0],
          [4.120737, 51.992461, 5.0],
          [4.119725, 51.992131, 5.5],
          [4.118987, 51.991785, 5.0],
          [4.118147, 51.991380, 5.25],
          [4.118066, 51.991341, 5.5],
          [4.118070, 51.991268, 5.25],
          [4.118003, 51.991214, 5.5],
          [4.117939, 51.991155, 5.5],
          [4.117784, 51.991138, 5.75],
          [4.117593, 51.990949, 6.0],
          [4.117368, 51.990696, 5.5],
          [4.117174, 51.990631, 5.25],
          [4.116713, 51.990454, 4.5],
          [4.116306, 51.990319, 4.75],
          [4.115943, 51.990212, 5.25],
          [4.115603, 51.990089, 5.25],
          [4.114670, 51.989713, 5.25],
          [4.114459, 51.989579, 5.25],
          [4.114236, 51.989457, 5.5],
          [4.114004, 51.989354, 5.75],
          [4.113350, 51.989121, 6.75],
          [4.113044, 51.988953, 6.5],
          [4.112881, 51.988921, 6.5],
          [4.111880, 51.988472, 5.25],
          [4.111498, 51.988298, 5.0],
          [4.111173, 51.988118, 5.0],
          [4.110717, 51.987739, 4.5],
          [4.110526, 51.987612, 4.25],
          [4.110148, 51.987447, 3.75]
        ]
      }
    }
  ]
}

let day7: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "8 - Hook of Holland - Noordwijk - 53.4km",
        "track-length": "53395",
        "filtered ascend": "94",
        "plain-ascend": "2",
        "total-time": "9227",
        "total-energy": "884963",
        "cost": "60029",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["4109040", "51986999", "3", "94", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "9", "980"],
          ["4105167", "51987597", "3", "331", "1050", "0", "27", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good", "", "54", "5418"],
          ["4104675", "51987405", "3", "41", "1350", "0", "88", "0", "0", "reversedirection=yes highway=unclassified", "", "58", "5855"],
          ["4104378", "51987288", "3", "25", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_lcn=yes", "", "61", "6152"],
          ["4103525", "51986966", "3", "1", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified", "", "61", "6164"],
          ["4104378", "51987288", "3", "1", "1350", "0", "0", "0", "0", "highway=unclassified", "", "61", "6173"],
          ["4105169", "51986906", "5", "70", "1000", "0", "0", "0", "0", "highway=unclassified surface=paving_stones oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_lcn=yes", "", "70", "7079"],
          ["4105324", "51986825", "5", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_lcn=yes", "", "72", "7277"],
          ["4110758", "51984348", "3", "503", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_lcn=yes", "", "142", "14294"],
          ["4110683", "51984295", "3", "4", "5050", "0", "95", "0", "0", "highway=path surface=sand foot=yes", "", "145", "14355"],
          ["4110758", "51984348", "3", "4", "5050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=sand foot=yes", "", "148", "14355"],
          ["4112508", "51983507", "6", "153", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_lcn=yes", "", "171", "16700"],
          ["4113371", "51983075", "6", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_lcn=yes", "", "172", "16770"],
          ["4112508", "51983507", "6", "4", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_lcn=yes", "", "172", "16807"],
          ["4112957", "51983882", "6", "52", "1450", "0", "86", "0", "0", "highway=tertiary", "railway=level_crossing", "178", "17342"],
          ["4121209", "51989648", "6", "893", "1450", "0", "48", "0", "0", "highway=tertiary", "", "326", "32135"],
          ["4121327", "51989629", "6", "9", "1450", "0", "1", "0", "0", "highway=tertiary bicycle=use_sidepath", "", "327", "32265"],
          ["4121380", "51989731", "6", "12", "5000", "0", "0", "0", "0", "reversedirection=yes highway=service oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "335", "32321"],
          ["4121537", "51989895", "6", "22", "5000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "351", "32526"],
          ["4121746", "51990006", "6", "12", "5350", "0", "4", "0", "0", "reversedirection=yes highway=service surface=asphalt foot=yes oneway=yes", "", "360", "32637"],
          ["4121537", "51989895", "6", "12", "1350", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes oneway=yes", "", "361", "32750"],
          ["4121406", "51989941", "7", "11", "1000", "0", "0", "0", "0", "highway=service foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes motor_vehicle=no", "362", "32862"],
          ["4118003", "51991214", "5", "277", "1000", "0", "0", "0", "0", "highway=service foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "396", "36280"],
          ["4117401", "51991440", "5", "4", "1350", "0", "0", "0", "0", "highway=service surface=concrete foot=yes", "", "397", "36347"],
          ["4118003", "51991214", "5", "4", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service surface=concrete foot=yes", "", "397", "36384"],
          ["4123681", "51994272", "5", "532", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "478", "44418"],
          ["4132532", "52000700", "7", "961", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "649", "61561"],
          ["4133675", "52000287", "6", "92", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "661", "62745"],
          ["4133425", "51999690", "4", "70", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt cycleway=lane route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "668", "63447"],
          ["4133396", "51999507", "3", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt cycleway=lane route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "670", "63633"],
          ["4133392", "51999360", "2", "11", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt cycleway=lane", "", "671", "63728"],
          ["4133396", "51999507", "3", "11", "1350", "0", "0", "0", "0", "highway=service surface=asphalt cycleway=lane", "", "672", "63843"],
          ["4133511", "51999524", "3", "9", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "673", "63941"],
          ["4147459", "52009870", "0", "1534", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "918", "88432"],
          ["4147674", "52010018", "0", "23", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "921", "88734"],
          ["4148787", "52009770", "0", "9", "5050", "0", "56", "0", "0", "highway=bridleway foot=yes", "", "927", "88749"],
          ["4147674", "52010018", "0", "9", "5050", "0", "0", "0", "0", "reversedirection=yes highway=bridleway foot=yes", "", "933", "88749"],
          ["4150349", "52016292", "3", "727", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1059", "101343"],
          ["4150834", "52016937", "-8192", "80", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1071", "102551"],
          ["4149440", "52016715", "-8192", "134", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1087", "104197"],
          ["4148329", "52017219", "-8192", "96", "1000", "0", "0", "0", "0", "highway=cycleway surface=paved foot=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1102", "105646"],
          ["4165795", "52027362", "2", "1814", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=permissive oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1369", "132366"],
          ["4168570", "52029290", "3", "308", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1416", "137121"],
          ["4173075", "52031364", "2", "393", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1477", "143209"],
          ["4170723", "52032698", "6", "238", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=permissive bicycle=permissive oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1521", "147629"],
          ["4171331", "52034530", "6", "286", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes bicycle=permissive oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=zebra", "1566", "152106"],
          ["4183912", "52043805", "3", "1361", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1783", "173748"],
          ["4197426", "52054134", "-8192", "1496", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2027", "198211"],
          ["4218426", "52065990", "7", "2071", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2372", "232664"],
          ["4218720", "52065791", "5", "34", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved foot=permissive route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2375", "232954"],
          ["4218841", "52065840", "5", "10", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_icn=yes route_bicycle_ncn=yes", "", "2376", "233045"],
          ["4218945", "52065886", "5", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_icn=yes route_bicycle_ncn=yes", "", "2376", "233127"],
          ["4222152", "52068697", "12", "441", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2474", "242901"],
          ["4222558", "52068898", "11", "37", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2479", "243426"],
          ["4225847", "52071089", "9", "344", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=use_sidepath route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2527", "248158"],
          ["4246752", "52087851", "11", "2668", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "3016", "297094"],
          ["4258764", "52094527", "11", "1196", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3216", "317075"],
          ["4259955", "52095102", "8", "106", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3226", "318098"],
          ["4262427", "52093090", "7", "282", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3263", "321788"],
          ["4263534", "52093560", "4", "93", "1150", "0", "79", "0", "0", "highway=residential surface=concrete", "", "3274", "322861"],
          ["4263607", "52093591", "4", "7", "1050", "0", "1", "0", "0", "highway=cycleway surface=paving_stones", "", "3274", "322947"],
          ["4264399", "52092933", "6", "93", "1050", "0", "78", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones", "", "3291", "324647"],
          ["4264938", "52092479", "6", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3294", "324873"],
          ["4264399", "52092933", "6", "12", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3295", "324985"],
          ["4269317", "52097406", "5", "622", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3388", "334264"],
          ["4272240", "52099586", "6", "317", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3445", "339993"],
          ["4272391", "52099652", "7", "13", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3448", "340299"],
          ["4272621", "52099580", "7", "19", "1000", "0", "0", "0", "0", "highway=cycleway junction=roundabout route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3452", "340756"],
          ["4272718", "52099585", "8", "7", "1000", "0", "0", "0", "0", "highway=cycleway junction=roundabout route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3454", "340938"],
          ["4272825", "52099942", "8", "52", "1000", "0", "0", "0", "0", "highway=cycleway junction=roundabout route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3468", "342333"],
          ["4272737", "52099968", "8", "7", "1000", "0", "0", "0", "0", "highway=cycleway junction=roundabout route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3470", "342494"],
          ["4272670", "52099894", "8", "3", "1650", "0", "84", "0", "0", "highway=secondary surface=asphalt bicycle=use_sidepath oneway=yes", "", "3471", "342557"],
          ["4272737", "52099968", "8", "3", "31650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt bicycle=use_sidepath oneway=yes", "highway=crossing", "3472", "342557"],
          ["4272409", "52099917", "7", "26", "1000", "0", "0", "0", "0", "highway=cycleway junction=roundabout route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3475", "342797"],
          ["4272234", "52099941", "7", "14", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3476", "342928"],
          ["4270704", "52100791", "8", "143", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=yes oneway:bicycle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3496", "344921"],
          ["4269877", "52101284", "8", "81", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt cycleway=opposite oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3510", "346263"],
          ["4269840", "52101381", "8", "12", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3511", "346442"],
          ["4269126", "52101292", "5", "51", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3517", "346991"],
          ["4265824", "52102876", "6", "289", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3562", "351473"],
          ["4265533", "52103132", "-8192", "41", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3567", "351973"],
          ["4278047", "52111513", "11", "1291", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3785", "373814"],
          ["4278071", "52111522", "12", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3786", "373876"],
          ["4278812", "52111626", "15", "58", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3810", "376322"],
          ["4279278", "52111509", "16", "36", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3825", "377844"],
          ["4279556", "52111689", "18", "28", "1150", "0", "69", "0", "0", "highway=residential", "", "3838", "379145"],
          ["4279239", "52111910", "15", "36", "5050", "0", "182", "0", "0", "highway=footway", "", "3865", "379895"],
          ["4278995", "52111717", "15", "29", "5050", "0", "188", "0", "0", "reversedirection=yes highway=footway", "barrier=bollard", "3886", "380312"],
          ["4278971", "52111658", "16", "7", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "", "3892", "380448"],
          ["4278995", "52111717", "15", "7", "5050", "0", "0", "0", "0", "highway=footway", "barrier=bollard", "3896", "380448"],
          ["4279239", "52111910", "15", "29", "5050", "0", "8", "0", "0", "highway=footway", "", "3914", "380448"],
          ["4279556", "52111689", "18", "36", "5050", "0", "272", "0", "0", "reversedirection=yes highway=footway", "", "3939", "380636"],
          ["4279278", "52111509", "16", "28", "1150", "0", "90", "0", "0", "reversedirection=yes highway=residential", "", "3943", "380999"],
          ["4279505", "52111403", "16", "20", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3946", "381258"],
          ["4280114", "52110965", "12", "69", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "3952", "381941"],
          ["4280148", "52110954", "12", "3", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3953", "381968"],
          ["4280318", "52110850", "11", "17", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "3954", "382113"],
          ["4280332", "52110841", "11", "2", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3954", "382130"],
          ["4280397", "52110854", "11", "5", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "3955", "382176"],
          ["4280590", "52110919", "12", "16", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "3956", "382341"],
          ["4282174", "52111894", "16", "155", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "3993", "385984"],
          ["4282229", "52111926", "16", "6", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "3994", "386099"],
          ["4282243", "52111935", "16", "2", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3994", "386138"],
          ["4282437", "52111961", "16", "14", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "3997", "386403"],
          ["4282495", "52111992", "16", "6", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "3998", "386515"],
          ["4284286", "52113955", "15", "272", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "4042", "390900"],
          ["4284327", "52113984", "15", "5", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "4043", "390976"],
          ["4284400", "52114030", "15", "8", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "4044", "391106"],
          ["4284446", "52114065", "15", "6", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=unknown", "4045", "391203"],
          ["4284960", "52114355", "15", "49", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4054", "392051"],
          ["4285341", "52114715", "14", "51", "1050", "0", "3", "0", "0", "highway=cycleway oneway=yes", "", "4060", "392715"],
          ["4287556", "52116113", "12", "218", "1150", "0", "7", "0", "0", "highway=residential oneway=yes", "", "4084", "395103"],
          ["4288275", "52116485", "11", "68", "1050", "0", "17", "0", "0", "highway=cycleway oneway=yes", "railway=unknown", "4094", "396113"],
          ["4289025", "52116893", "11", "70", "1050", "0", "0", "0", "0", "highway=cycleway oneway=yes", "railway=unknown", "4104", "397134"],
          ["4289114", "52116962", "11", "10", "1050", "0", "0", "0", "0", "highway=cycleway oneway=yes", "railway=unknown", "4106", "397283"],
          ["4289150", "52116996", "11", "5", "1050", "0", "0", "0", "0", "highway=cycleway oneway=yes", "railway=unknown", "4107", "397358"],
          ["4289268", "52117238", "11", "31", "1050", "0", "6", "0", "0", "highway=cycleway oneway=yes", "", "4111", "397846"],
          ["4289395", "52117333", "11", "14", "1350", "0", "17", "0", "0", "highway=service", "entrance=main", "4114", "398091"],
          ["4295591", "52120829", "17", "577", "1350", "0", "17", "0", "0", "highway=service", "", "4253", "412028"],
          ["4289395", "52117333", "11", "577", "1350", "0", "16", "0", "0", "reversedirection=yes highway=service", "entrance=main", "4332", "419929"],
          ["4289268", "52117238", "11", "14", "1350", "0", "1", "0", "0", "reversedirection=yes highway=service", "", "4334", "420099"],
          ["4287865", "52116489", "11", "130", "1050", "0", "18", "0", "0", "highway=cycleway oneway=yes", "", "4352", "421901"],
          ["4287887", "52116463", "11", "4", "1150", "0", "33", "0", "0", "reversedirection=yes highway=residential surface=paving_stones", "", "4353", "421962"],
          ["4287921", "52116414", "11", "6", "5150", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes", "railway=unknown", "4357", "422010"],
          ["4287933", "52116398", "11", "2", "5150", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes", "", "4358", "422026"],
          ["4287920", "52116373", "11", "3", "5150", "0", "23", "0", "0", "reversedirection=yes highway=residential bicycle=use_sidepath oneway=yes", "railway=unknown", "4360", "422051"],
          ["4287709", "52116211", "12", "25", "5150", "0", "6", "0", "0", "reversedirection=yes highway=residential bicycle=use_sidepath oneway=yes", "", "4378", "422292"],
          ["4287828", "52114484", "11", "200", "1150", "0", "102", "0", "0", "reversedirection=yes highway=residential surface=asphalt cycleway=opposite oneway=yes", "", "4406", "425058"],
          ["4287645", "52113957", "12", "60", "1150", "0", "1", "0", "0", "highway=residential surface=asphalt oneway=yes oneway:bicycle=no", "", "4415", "425943"],
          ["4287627", "52113901", "12", "7", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt oneway=yes", "", "4416", "426051"],
          ["4287907", "52113824", "12", "5", "31650", "0", "70", "0", "0", "reversedirection=yes highway=secondary surface=asphalt bicycle=use_sidepath oneway=yes", "", "4419", "426072"],
          ["4286383", "52114115", "14", "94", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=use_sidepath oneway=yes", "", "4432", "427352"],
          ["4286346", "52114010", "13", "12", "5050", "0", "88", "0", "0", "reversedirection=yes highway=footway", "", "4441", "427429"],
          ["4286330", "52113956", "13", "7", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "", "4442", "427537"],
          ["4293559", "52112872", "11", "515", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4522", "435573"],
          ["4294089", "52112761", "10", "1", "1050", "0", "0", "0", "0", "highway=cycleway oneway=yes", "", "4522", "435585"],
          ["4293559", "52112872", "11", "1", "5050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=yes", "", "4523", "435585"],
          ["4293667", "52113084", "11", "27", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4526", "435862"],
          ["4293972", "52114075", "6", "116", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4537", "436953"],
          ["4305443", "52117476", "7", "886", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4675", "450790"],
          ["4305484", "52117388", "7", "9", "5050", "0", "141", "0", "0", "highway=bridleway", "", "4681", "450880"],
          ["4305443", "52117476", "7", "9", "5050", "0", "0", "0", "0", "reversedirection=yes highway=bridleway", "", "4687", "450880"],
          ["4305494", "52117536", "6", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4688", "450955"],
          ["4305612", "52118014", "5", "56", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "4693", "451484"],
          ["4305795", "52124953", "5", "814", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "4823", "464490"],
          ["4311215", "52129522", "6", "650", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4932", "475330"],
          ["4311270", "52129553", "6", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "4933", "475422"],
          ["4317619", "52131639", "12", "504", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5047", "486841"],
          ["4317649", "52131625", "12", "3", "5050", "0", "67", "0", "0", "highway=footway", "", "5049", "486901"],
          ["4314871", "52130937", "9", "146", "5050", "0", "109", "0", "0", "highway=footway surface=fine_gravel", "", "5152", "488037"],
          ["4317649", "52131625", "12", "146", "5050", "0", "1", "0", "0", "reversedirection=yes highway=footway surface=fine_gravel", "", "5256", "489041"],
          ["4317619", "52131639", "12", "3", "5050", "0", "108", "0", "0", "reversedirection=yes highway=footway", "", "5258", "489079"],
          ["4328605", "52133858", "4", "817", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5368", "500152"],
          ["4357284", "52157292", "10", "3491", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "5975", "560867"],
          ["4357849", "52157903", "13", "80", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "5996", "562943"],
          ["4362596", "52160723", "13", "466", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6098", "573122"],
          ["4362651", "52160768", "13", "7", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6099", "573213"],
          ["4361319", "52161116", "12", "100", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6112", "574521"],
          ["4361214", "52161829", "11", "97", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=stop", "6126", "575921"],
          ["4362534", "52165032", "17", "406", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6219", "585215"],
          ["4363520", "52169926", "10", "921", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6351", "598384"],
          ["4378039", "52186907", "12", "2327", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6764", "639732"],
          ["4386907", "52195443", "9", "1229", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt cycleway=segregated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6951", "658422"],
          ["4386479", "52195583", "10", "34", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6960", "659292"],
          ["4386112", "52195718", "10", "30", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6967", "660020"],
          ["4386386", "52196697", "8", "121", "1000", "0", "0", "0", "0", "highway=tertiary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6986", "661947"],
          ["4388425", "52198868", "6", "280", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7028", "666106"],
          ["4390695", "52200824", "8", "272", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7082", "671568"],
          ["4391195", "52201395", "7", "73", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7093", "672616"],
          ["4392319", "52203088", "5", "208", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7120", "675369"],
          ["4393582", "52204450", "7", "176", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=kerb", "7155", "678833"],
          ["4393641", "52204569", "7", "15", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7158", "679107"],
          ["4393792", "52204929", "7", "45", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7166", "679893"],
          ["4394256", "52205277", "7", "51", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7175", "680842"],
          ["4394384", "52205373", "7", "15", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=kerb", "7178", "681113"],
          ["4395162", "52206199", "7", "107", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7197", "683043"],
          ["4395853", "52207001", "6", "103", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "7215", "684801"],
          ["4396677", "52207991", "9", "126", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=yes", "7239", "687265"],
          ["4397410", "52208919", "9", "116", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=yes", "7263", "689646"],
          ["4398185", "52209551", "9", "96", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7279", "691258"],
          ["4398480", "52209521", "9", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7284", "691699"],
          ["4399160", "52209379", "9", "51", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7293", "692646"],
          ["4401386", "52211033", "5", "246", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7324", "695744"],
          ["4402131", "52211312", "9", "62", "1000", "0", "0", "0", "0", "highway=residential cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7344", "697764"],
          ["4402410", "52211546", "11", "34", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes horse=yes crossing=unmarked", "7357", "699086"],
          ["4402338", "52211571", "11", "6", "1000", "0", "0", "0", "0", "highway=cycleway foot=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes horse=yes", "7360", "699323"],
          ["4402297", "52211586", "11", "4", "1000", "0", "0", "0", "0", "highway=cycleway foot=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7361", "699476"],
          ["4403032", "52212512", "10", "124", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7392", "702564"],
          ["4420389", "52233166", "15", "2743", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7884", "751650"],
          ["4428587", "52240569", "21", "1062", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=bump", "8087", "771947"],
          ["4430237", "52241301", "12", "143", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8101", "773221"],
          ["4430781", "52241624", "12", "54", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8106", "773807"],
          ["4430143", "52242126", "11", "73", "1000", "0", "0", "0", "0", "highway=secondary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8115", "774617"],
          ["4429378", "52243106", "9", "125", "1000", "0", "0", "0", "0", "highway=secondary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8129", "776078"],
          ["4429112", "52243981", "8", "141", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "8146", "777744"],
          ["4429922", "52244751", "8", "104", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "8161", "779288"],
          ["4430693", "52245520", "6", "104", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "8174", "780567"],
          ["4431508", "52246346", "10", "108", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "8204", "783542"],
          ["4432361", "52247276", "9", "120", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "8230", "786142"],
          ["4433481", "52248582", "7", "166", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "8252", "788383"],
          ["4434636", "52248951", "8", "122", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8272", "790352"],
          ["4434734", "52249042", "8", "13", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "8274", "790600"],
          ["4435449", "52249745", "8", "93", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=bump", "8290", "792190"],
          ["4436053", "52250277", "7", "73", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8302", "793331"],
          ["4437174", "52250928", "8", "107", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=bump", "8321", "795285"],
          ["4438290", "52251902", "7", "136", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8342", "797321"],
          ["4462829", "52276514", "5", "3433", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8924", "855586"],
          ["4468161", "52272624", "14", "578", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=no route_bicycle_rcn=yes", "", "9057", "868832"],
          ["4468284", "52272739", "14", "7", "5050", "0", "150", "0", "0", "reversedirection=yes highway=bridleway", "", "9062", "868943"],
          ["4468161", "52272624", "14", "7", "5050", "0", "0", "0", "0", "highway=bridleway", "", "9066", "868943"],
          ["4468193", "52272559", "14", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=no route_bicycle_rcn=yes", "", "9067", "869019"],
          ["4468483", "52271497", "11", "121", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=no", "", "9078", "870173"],
          ["4467098", "52269875", "5", "210", "1050", "0", "17", "0", "0", "reversedirection=yes highway=cycleway foot=no", "", "9099", "872206"],
          ["4467568", "52269497", "3", "56", "1050", "0", "8", "0", "0", "reversedirection=yes highway=cycleway", "", "9104", "872731"],
          ["4467629", "52269536", "3", "7", "1450", "0", "88", "0", "0", "highway=tertiary surface=asphalt oneway=yes", "", "9105", "872797"],
          ["4467262", "52269772", "4", "33", "1650", "0", "85", "0", "0", "highway=secondary surface=asphalt foot=no bicycle=use_sidepath", "", "9109", "873199"],
          ["4467568", "52269576", "3", "26", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt foot=no bicycle=use_sidepath", "", "9111", "873421"],
          ["4467505", "52269533", "3", "7", "1450", "0", "83", "0", "0", "highway=tertiary surface=asphalt oneway=yes", "", "9112", "873485"],
          ["4470219", "52267831", "1", "267", "1050", "0", "88", "0", "0", "reversedirection=yes highway=cycleway", "", "9141", "876438"],
          ["4470948", "52267346", "0", "75", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "", "9153", "877608"],
          ["4471023", "52267386", "1", "7", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_rcn=yes", "", "9154", "877727"],
          ["4474890", "52269709", "1", "372", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_rcn=yes", "", "9209", "883208"],
          ["4476808", "52270988", "0", "118", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "9227", "884986"]
        ],
        "times": [0, 0.463, 1.031, 1.81, 7.609, 9.8, 10.951, 12.781, 15.567, 18.786, 24.661, 25.335, 25.828, 26.331, 47.845, 53.337, 54.177, 56.765, 58.547, 60.422, 61.516, 61.639, 61.731, 70.792, 72.767, 75.214, 84.852, 85.508, 86.225, 86.781, 88.897, 90.184, 100.362, 108.497, 114.083, 120.652, 134.609, 142.922, 145.851, 148.43, 169.419, 171.884, 172.585, 172.954, 178.301, 180.037, 197.421, 235.05, 239.632, 248.67, 251.057, 281.021, 297.834, 302.259, 310.895, 320.064, 322.123, 324.534, 326.206, 327.506, 335.927, 351.654, 360.232, 361.359, 362.483, 370.519, 378.835, 379.751, 381.692, 394.822, 396.66, 397.328, 397.698, 398.43, 399.314, 400.096, 408.165, 417.401, 428.675, 433.257, 438.558, 455.986, 460.171, 468.471, 478.016, 482.781, 488.536, 492.428, 494.183, 498.021, 500.62, 502.691, 533.907, 542.554, 556.292, 565.717, 568.113, 569.479, 573.825, 581.623, 590.19, 592.841, 596.123, 600.562, 604.209, 616.996, 621.949, 635.799, 649.445, 650.441, 659.763, 661.277, 664.84, 668.303, 670.162, 671.107, 672.26, 673.238, 673.907, 686.129, 689.779, 702.242, 703.55, 713.06, 727.103, 748.538, 756.183, 759.488, 760.997, 765.926, 771.511, 793.716, 797.425, 833.982, 837.876, 841.423, 848.56, 873.112, 898.199, 902.008, 905.26, 910.717, 917.064, 918.134, 919.817, 921.145, 927.388, 933.206, 948.954, 953.355, 970.225, 981.029, 993.095, 1000.784, 1046.633, 1059.127, 1069.303, 1071.211, 1072.744, 1073.382, 1074.254, 1075.149, 1076.184, 1077.369, 1079.965, 1080.605, 1081.122, 1081.775, 1083.642, 1085.146, 1087.672, 1095.341, 1102.154, 1103.416, 1112.396, 1157.777, 1169.841, 1196.782, 1216.899, 1230.168, 1233.359, 1236.047, 1238.399, 1252.174, 1252.825, 1278.153, 1282.385, 1290.603, 1316.221, 1321.422, 1323.1, 1325.114, 1327.799, 1329.814, 1329.998, 1331.231, 1332.224, 1334.654, 1335.434, 1336.463, 1337.283, 1337.879, 1340.731, 1341.503, 1342.154, 1343.346, 1346.77, 1348.761, 1354.652, 1356.107, 1357.218, 1359.19, 1361.284, 1363.587, 1369.342, 1374.408, 1402.164, 1403.73, 1404.99, 1405.939, 1406.892, 1409.447, 1410.249, 1411.053, 1412.828, 1413.799, 1415.748, 1416.889, 1421.75, 1423.82, 1430.682, 1448.441, 1462.692, 1463.606, 1474.951, 1476.318, 1477.761, 1478.838, 1486.774, 1488.74, 1491.025, 1493.32, 1495.424, 1497.658, 1502.745, 1504.655, 1506.437, 1507.608, 1510.052, 1521.949, 1531.533, 1536.322, 1538.473, 1538.657, 1539.124, 1539.988, 1540.606, 1541.377, 1548.151, 1549.87, 1553.443, 1555.147, 1566.716, 1581.59, 1584.858, 1586.633, 1588.611, 1596.41, 1607.445, 1618.063, 1622.28, 1628.187, 1630.084, 1642.058, 1651.368, 1662.935, 1673.022, 1682.862, 1690.792, 1695.962, 1701.793, 1732.332, 1746.694, 1759.972, 1765.671, 1771.541, 1783.122, 1808.312, 1813.688, 1845.272, 1863.08, 1867.112, 1878.705, 1887.105, 1898.025, 1908.777, 1918.185, 1922.553, 1927.594, 1949.098, 1953.97, 1962.034, 1969.931, 1972.283, 1975.979, 1978.835, 1982.531, 1996.979, 2013.275, 2014.402, 2015.384, 2017.355, 2018.671, 2020.391, 2024.704, 2026.141, 2027.748, 2028.703, 2030.089, 2035.413, 2048.179, 2056.042, 2072.139, 2074.627, 2077.12, 2082.116, 2086.622, 2088.962, 2091.136, 2099.507, 2101.853, 2103.865, 2106.548, 2107.722, 2108.896, 2113.762, 2117.79, 2144.489, 2162.968, 2165.992, 2169.184, 2171.536, 2207.489, 2234.705, 2262.93, 2268.978, 2274.69, 2289.978, 2304.595, 2306.443, 2308.963, 2312.995, 2319.715, 2322.907, 2324.083, 2326.435, 2327.779, 2338.195, 2342.254, 2344.425, 2345.469, 2347.232, 2352.393, 2356.793, 2359.968, 2361.176, 2363.242, 2367.016, 2368.62, 2368.897, 2369.692, 2370.24, 2371.395, 2372.269, 2372.794, 2373.152, 2375.17, 2376.077, 2376.898, 2381.366, 2384.274, 2385.264, 2385.924, 2386.584, 2387.741, 2411.125, 2415.272, 2419.52, 2424.767, 2439.805, 2441.295, 2444.654, 2446.817, 2448.72, 2472.138, 2474.61, 2475.851, 2478.506, 2479.859, 2482.627, 2484.903, 2488.704, 2491.57, 2502.08, 2504.416, 2505.901, 2507.459, 2510.801, 2513.768, 2524.117, 2526.363, 2527.169, 2528.137, 2530.082, 2534.484, 2535.303, 2536.123, 2537.272, 2538.753, 2546.025, 2547.187, 2548.681, 2550.344, 2553.673, 2557.009, 2574.281, 2589.484, 2593.033, 2600.937, 2604.778, 2608.83, 2612.389, 2613.031, 2615.971, 2633.216, 2654.335, 2660.998, 2663.467, 2666.009, 2676.718, 2681.765, 2683.268, 2684.92, 2688.559, 2694.262, 2703.504, 2706.737, 2712.512, 2719.238, 2725.122, 2727.283, 2729.656, 2735.481, 2743.433, 2751.263, 2756.445, 2763.98, 2766.278, 2767.718, 2769.474, 2771.184, 2774.699, 2780.922, 2817.53, 2840.536, 2842.634, 2844.45, 2846.814, 2855.277, 2858.216, 2860.978, 2864.786, 2865.832, 2872.253, 2883.008, 2902.83, 2910.977, 2914.587, 2919.188, 2924.503, 2931.124, 2933.743, 2936.301, 2938.594, 2947.301, 2949.714, 2976.451, 2978.653, 2982.563, 2985.614, 2987.295, 2989.191, 2992.23, 2998.37, 3003.36, 3007.451, 3011.678, 3016.438, 3017.199, 3023.967, 3028.284, 3039.191, 3043.624, 3047.885, 3052.734, 3056.218, 3058.905, 3062.903, 3068.245, 3078.254, 3088.194, 3092.325, 3096.471, 3097.801, 3100.347, 3102.028, 3103.269, 3105.908, 3107.698, 3110.045, 3111.666, 3118.081, 3119.535, 3121.286, 3123.799, 3130.482, 3131.516, 3133.349, 3139.193, 3143.884, 3151.979, 3158.66, 3162.732, 3165.806, 3170.173, 3177.628, 3187.778, 3191.699, 3194.172, 3195.155, 3198.461, 3200.229, 3202.323, 3203.686, 3212.877, 3216.21, 3216.82, 3218.87, 3226.444, 3233.725, 3241.573, 3248.193, 3263.338, 3266.342, 3274.067, 3274.553, 3274.922, 3284.424, 3285.119, 3291.92, 3294.18, 3295.306, 3296.489, 3297.309, 3297.939, 3302.002, 3310.812, 3314.876, 3315.722, 3316.708, 3339.222, 3341.523, 3357.989, 3359.016, 3369.617, 3388.081, 3399.796, 3427.308, 3432.301, 3437.71, 3445.364, 3448.426, 3449.796, 3451.236, 3452.993, 3454.819, 3456.446, 3457.857, 3459.234, 3461.513, 3465.821, 3467.36, 3468.766, 3470.371, 3471.003, 3472.954, 3473.517, 3473.886, 3474.618, 3475.349, 3476.009, 3476.664, 3485.75, 3496.589, 3507.802, 3509.059, 3510.007, 3511.8, 3516.323, 3517.289, 3526.947, 3543.553, 3551.605, 3554.72, 3561.591, 3562.104, 3564.495, 3565.24, 3565.912, 3566.305, 3566.704, 3567.109, 3567.624, 3578.389, 3591.997, 3599.959, 3600.913, 3610.433, 3617.814, 3633.914, 3641.764, 3650.637, 3653.989, 3658.516, 3668.415, 3672.276, 3679.328, 3683.694, 3687.389, 3689.405, 3689.573, 3693.1, 3695.784, 3698.622, 3704.406, 3708.808, 3740.662, 3748.172, 3757.84, 3764.262, 3769.155, 3772.189, 3774.716, 3785.497, 3786.109, 3788.594, 3790.874, 3800.543, 3804.438, 3810.567, 3815.824, 3820.478, 3825.786, 3838.793, 3846.65, 3856.353, 3860.008, 3865.033, 3865.751, 3883.238, 3886.903, 3892.113, 3896.558, 3899.728, 3914.949, 3915.592, 3920.191, 3923.549, 3932.694, 3939.919, 3943.546, 3946.136, 3946.767, 3947.992, 3949.88, 3951.539, 3952.968, 3953.237, 3954.688, 3954.86, 3955.312, 3956.213, 3956.966, 3980.967, 3993.387, 3994.541, 3994.923, 3997.574, 3998.697, 4005.509, 4009.312, 4010.364, 4011.609, 4013.578, 4015.636, 4017.198, 4017.814, 4024.646, 4026.144, 4036.476, 4037.489, 4038.657, 4042.537, 4043.296, 4044.597, 4045.574, 4049.397, 4054.054, 4055.343, 4057.321, 4058.623, 4059.036, 4060.69, 4068.657, 4084.56, 4085.459, 4086.365, 4087.124, 4089.583, 4090.76, 4091.949, 4093.3, 4094.663, 4100.389, 4103.405, 4104.136, 4104.872, 4106.358, 4107.107, 4108.315, 4109.379, 4111.991, 4112.865, 4114.435, 4119.855, 4129.052, 4191.57, 4202.734, 4216.935, 4224.473, 4249.531, 4253.272, 4253.781, 4254.058, 4256.19, 4269.698, 4285.2, 4298.853, 4310.348, 4325.117, 4329.746, 4332.785, 4333.892, 4334.487, 4335.951, 4340.212, 4342.805, 4350.85, 4351.299, 4352.502, 4353.107, 4357.375, 4358.798, 4360.933, 4366.627, 4378.83, 4379.696, 4381.596, 4382.285, 4382.974, 4396.023, 4406.487, 4415.338, 4416.41, 4419.912, 4420.392, 4423.828, 4430.101, 4432.715, 4441.195, 4442.282, 4469.474, 4511.846, 4513.442, 4515.206, 4518.096, 4521.531, 4522.64, 4522.758, 4523.408, 4523.987, 4524.983, 4526.171, 4531.425, 4532.053, 4533.149, 4535.111, 4536.736, 4537.085, 4538.189, 4538.811, 4539.545, 4556.177, 4559.198, 4561.895, 4570.885, 4627.905, 4659.882, 4669.262, 4672.818, 4675.406, 4681.858, 4687.677, 4688.422, 4689.644, 4690.689, 4691.355, 4693.716, 4709.626, 4714.415, 4720.267, 4735.734, 4743.6, 4749.473, 4758.833, 4772.263, 4779.962, 4787.308, 4788.561, 4799.333, 4805.578, 4808.459, 4811.1, 4813.7, 4814.62, 4816.812, 4819.186, 4820.775, 4821.902, 4823.77, 4825.12, 4834.75, 4838.126, 4850.526, 4854.414, 4858.223, 4873.599, 4878.739, 4887.501, 4890.026, 4892.046, 4900.571, 4908.05, 4922.802, 4927.515, 4932.162, 4933.078, 4946.981, 4952.28, 4955.821, 4975.811, 4980.255, 5000.716, 5010.373, 5025.897, 5032.438, 5037.917, 5043.005, 5047.245, 5049.485, 5062.758, 5075.963, 5107.797, 5152.65, 5198.927, 5230.253, 5243.082, 5256.02, 5258.193, 5261.934, 5263.215, 5264.64, 5266.442, 5268.401, 5274.677, 5276.319, 5282.237, 5285.354, 5293.269, 5305.987, 5312.631, 5335.619, 5345.385, 5347.887, 5348.483, 5353.806, 5367.916, 5368.916, 5371.252, 5375.159, 5378.345, 5382.023, 5384.201, 5388.963, 5395.051, 5401.158, 5412.88, 5420.615, 5442.216, 5456.484, 5472.035, 5484.579, 5490.494, 5493.887, 5496.212, 5499.661, 5508.029, 5511.573, 5513.228, 5516.333, 5525.614, 5529.938, 5539.57, 5544.886, 5547.324, 5550.264, 5562.549, 5564.753, 5565.123, 5566.994, 5569.46, 5571.691, 5574.214, 5575.889, 5577.683, 5579.257, 5592.485, 5601.11, 5611.083, 5632.012, 5651.741, 5655.879, 5677.235, 5683.928, 5690.63, 5695.54, 5697.587, 5701.162, 5703.88, 5711.933, 5714.748, 5716.728, 5719.062, 5723.347, 5748.943, 5769.964, 5780.435, 5786.797, 5789.12, 5790.15, 5791.58, 5794.896, 5803.104, 5809.055, 5821.286, 5827.283, 5866.1, 5873.298, 5880.608, 5920.193, 5932.368, 5941.035, 5942.946, 5950.8, 5951.469, 5954.285, 5959.567, 5971.215, 5975.99, 5988.909, 5996.738, 6010.064, 6018.896, 6026.233, 6037.575, 6056.356, 6062.583, 6073.365, 6075.722, 6078.087, 6089.066, 6094.023, 6096.485, 6098.503, 6099.414, 6108.297, 6112.489, 6114.628, 6115.448, 6116.278, 6118.674, 6120.356, 6121.126, 6121.899, 6123.143, 6125.358, 6126.487, 6127.2, 6127.877, 6128.837, 6129.81, 6131.717, 6132.995, 6136.59, 6147.515, 6164.659, 6165.547, 6174.554, 6178.731, 6184.188, 6194.942, 6197.344, 6201.864, 6205.554, 6211.04, 6216.092, 6218.293, 6219.407, 6220.636, 6221.648, 6230.315, 6233.758, 6235.174, 6236.397, 6240.154, 6248.63, 6251.813, 6254.675, 6262.327, 6263.467, 6265.001, 6266.548, 6267.482, 6268.891, 6269.897, 6272.246, 6276.84, 6281.71, 6284.351, 6287.189, 6295.392, 6300.206, 6303.402, 6309.984, 6312.114, 6313.706, 6316.835, 6317.783, 6319.135, 6322.583, 6328.719, 6334.77, 6339.384, 6342.728, 6345.708, 6349.253, 6351.081, 6351.941, 6353.004, 6357.628, 6359.115, 6360.578, 6363.238, 6365.854, 6368.618, 6373.969, 6375.602, 6382.172, 6384.981, 6387.134, 6388.792, 6391.616, 6393.613, 6399.598, 6401.077, 6409.739, 6411.006, 6412.042, 6419.25, 6420.423, 6421.499, 6423.104, 6424.169, 6426.995, 6429.1, 6431.065, 6433.529, 6438.364, 6447.288, 6450.689, 6454.708, 6459.742, 6464.243, 6467.183, 6470.277, 6481.203, 6489.58, 6493.455, 6496.636, 6499.178, 6504.059, 6509.202, 6522.466, 6527.848, 6532.513, 6539.848, 6543.57, 6546.287, 6553.269, 6560.466, 6569.916, 6574.379, 6578.496, 6580.543, 6582.028, 6583.786, 6593.11, 6598.102, 6602.177, 6607.002, 6615.028, 6620.917, 6627.159, 6631.078, 6636.524, 6639.637, 6642.285, 6649.147, 6659.16, 6668.389, 6669.953, 6671.512, 6676.622, 6681.172, 6687.453, 6702.663, 6711.717, 6715.168, 6718.859, 6726.454, 6730.792, 6733.468, 6738.254, 6742.539, 6750.642, 6757.456, 6764.512, 6772.167, 6774.908, 6779.31, 6787.072, 6792.956, 6798.933, 6802.41, 6808.446, 6811.551, 6813.177, 6817.44, 6819.414, 6822.679, 6824.448, 6826.411, 6831.939, 6836.811, 6841.046, 6845.547, 6847.866, 6849.695, 6854.524, 6858.143, 6860.844, 6863.004, 6865.061, 6867.036, 6875.979, 6880.563, 6884.01, 6884.765, 6886.282, 6887.495, 6888.036, 6888.698, 6889.602, 6891, 6891.455, 6895.945, 6899.019, 6905.799, 6907.395, 6909.183, 6914.212, 6917.675, 6919.779, 6921.976, 6924.667, 6931.815, 6934.832, 6943.557, 6946.501, 6949.339, 6951.384, 6960.085, 6967.355, 6969.397, 6971.462, 6973.648, 6975.329, 6986.628, 7006.461, 7028.209, 7043.485, 7048.298, 7055.621, 7069.992, 7074.542, 7080.196, 7082.829, 7093.296, 7094.809, 7105.708, 7109.62, 7111.005, 7112.296, 7116.951, 7118.862, 7120.822, 7144.049, 7155.465, 7156.383, 7158.206, 7160.555, 7162.235, 7163.243, 7163.915, 7166.064, 7174.82, 7175.548, 7177.716, 7178.256, 7178.973, 7182.578, 7188.491, 7197.562, 7200.401, 7213.281, 7215.142, 7218.073, 7227.563, 7239.778, 7242.486, 7260.958, 7263.581, 7270.14, 7272.875, 7274.724, 7276.875, 7279.701, 7282.245, 7284.108, 7286.761, 7293.584, 7298.885, 7303.368, 7305.989, 7312.179, 7321.077, 7324.55, 7328.054, 7331.131, 7340.984, 7344.752, 7347.646, 7353.165, 7357.962, 7360.337, 7361.867, 7380.828, 7383.69, 7385.308, 7387.204, 7389.326, 7390.28, 7391.605, 7392.733, 7394.329, 7405.618, 7410.446, 7413.364, 7416.816, 7419.713, 7423.771, 7426.45, 7436.94, 7439.416, 7445.198, 7450.577, 7459.162, 7461.981, 7478.274, 7485.562, 7490.185, 7493.271, 7496.123, 7499.556, 7504.211, 7509.494, 7514.77, 7518.843, 7522.297, 7525.168, 7528.189, 7531.167, 7539.348, 7542.547, 7543.673, 7544.803, 7547.219, 7549.42, 7551.941, 7557.201, 7560.901, 7564.156, 7567.258, 7579.37, 7584.536, 7595.529, 7609.633, 7624.104, 7644.504, 7660.714, 7666.377, 7670.749, 7683.313, 7688.131, 7699.419, 7706.692, 7714.901, 7727.655, 7731.57, 7734.866, 7738.914, 7745.866, 7750.883, 7755.472, 7759.584, 7762.568, 7765.474, 7776.591, 7779.937, 7783.407, 7788.677, 7792.072, 7795.654, 7798.766, 7803.482, 7815.041, 7816.542, 7817.725, 7819.184, 7820.453, 7822.146, 7823.228, 7823.948, 7824.668, 7825.308, 7826.108, 7827.198, 7832.823, 7840.051, 7854.491, 7860.095, 7864.512, 7866.09, 7871.994, 7875.709, 7876.549, 7881.543, 7883.403, 7884.489, 7885.104, 7885.353, 7885.854, 7886.486, 7886.87, 7887.516, 7888.169, 7888.564, 7890.307, 7893.709, 7907.553, 7910.827, 7923.58, 7934.366, 7939.709, 7944.69, 7968.881, 7970.557, 7978.706, 7979.58, 7986.567, 7987.65, 8002.611, 8006.293, 8014.254, 8024.442, 8026.591, 8037.689, 8038.873, 8040.075, 8043.463, 8050.55, 8055.273, 8059.403, 8078.663, 8087.43, 8093.885, 8097.965, 8098.554, 8099.716, 8101.045, 8101.321, 8106.192, 8106.9, 8107.499, 8110.708, 8114.208, 8115.004, 8116.4, 8119.619, 8124.716, 8127.347, 8128.598, 8129.606, 8132.434, 8134.719, 8135.486, 8136.384, 8137.189, 8138.131, 8139.095, 8144.489, 8146.263, 8153.15, 8156.151, 8161.699, 8163.11, 8165.685, 8168.713, 8172.624, 8173.548, 8174.486, 8195.86, 8204.231, 8206.635, 8220.707, 8230.222, 8230.971, 8238.188, 8245.5, 8250.286, 8252.625, 8256.316, 8258.511, 8261.5, 8263.277, 8265.062, 8266.971, 8268.818, 8272.319, 8274.794, 8287.304, 8290.694, 8302.108, 8306.544, 8314.715, 8321.642, 8322.896, 8328.429, 8332.527, 8336.496, 8342.008, 8344.171, 8347.273, 8350.91, 8352.759, 8367.227, 8375.168, 8388.681, 8419.18, 8428.392, 8435.856, 8447.699, 8461.122, 8463.619, 8474.077, 8513.053, 8517.335, 8518.57, 8519.801, 8522.043, 8527.846, 8535.14, 8541.198, 8545.34, 8552.711, 8556.662, 8561.058, 8563.966, 8568.502, 8571.461, 8573.994, 8575.721, 8578.18, 8580.047, 8582.079, 8584.477, 8586.869, 8602.671, 8606.26, 8617.267, 8623.554, 8630.513, 8638.697, 8647.234, 8656.176, 8659.504, 8665.161, 8696.618, 8727.248, 8744.165, 8748.248, 8755.341, 8761.642, 8770.198, 8778.148, 8780.479, 8792.43, 8801.594, 8824.348, 8832.957, 8836.003, 8842.159, 8864.6, 8868.4, 8872.276, 8888.521, 8902.243, 8906.635, 8923.669, 8924.226, 8924.604, 8949.886, 8966.002, 9001.434, 9028.606, 9036.144, 9039.646, 9057.019, 9062.154, 9066.675, 9067.441, 9071.243, 9076.036, 9078.976, 9080.666, 9082.757, 9085.367, 9092.387, 9097.978, 9098.598, 9099.309, 9099.619, 9100.599, 9101.642, 9103.179, 9104.009, 9104.56, 9105.22, 9105.926, 9109.237, 9111.459, 9112.103, 9112.649, 9115.528, 9119.491, 9125.612, 9141.63, 9152.049, 9153.324, 9154.519, 9156.053, 9161.565, 9174.007, 9203.747, 9209.322, 9221.483, 9227.1]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [4.110144, 51.987445, 3.75],
          [4.110096, 51.987424, 3.75],
          [4.110032, 51.987396, 3.75],
          [4.109946, 51.987358, 3.75],
          [4.109288, 51.987092, 3.5],
          [4.109040, 51.986999, 3.0],
          [4.108917, 51.986968, 3.0],
          [4.108704, 51.986918, 2.75],
          [4.108392, 51.986830, 2.5],
          [4.108056, 51.986717, 2.25],
          [4.107502, 51.986541, 2.5],
          [4.107416, 51.986514, 2.75],
          [4.107350, 51.986501, 2.75],
          [4.107291, 51.986503, 2.75],
          [4.105548, 51.987244, 4.25],
          [4.105234, 51.987534, 3.5],
          [4.105167, 51.987597, 3.5],
          [4.104868, 51.987480, 3.75],
          [4.104675, 51.987405, 3.75],
          [4.104484, 51.987328, 3.75],
          [4.104378, 51.987288, 3.75],
          [4.104370, 51.987284, 3.75],
          [4.104378, 51.987288, 3.75],
          [4.105169, 51.986906, 5.25],
          [4.105324, 51.986825, 5.25],
          [4.105263, 51.986694, 5.5],
          [4.106068, 51.986142, 3.5],
          [4.106129, 51.986124, 3.5],
          [4.106201, 51.986142, 3.0],
          [4.106272, 51.986160, 3.0],
          [4.106574, 51.986236, 2.5],
          [4.106746, 51.986255, 2.5],
          [4.107812, 51.985761, 2.0],
          [4.108437, 51.985463, 2.5],
          [4.108879, 51.985261, 2.25],
          [4.109363, 51.984999, 2.0],
          [4.110314, 51.984560, 2.5],
          [4.110758, 51.984348, 3.5],
          [4.110721, 51.984321, 3.5],
          [4.110758, 51.984348, 3.5],
          [4.112359, 51.983587, 5.75],
          [4.112508, 51.983507, 6.0],
          [4.112547, 51.983487, 6.0],
          [4.112508, 51.983507, 6.0],
          [4.112957, 51.983882, 6.0],
          [4.113087, 51.983983, 6.0],
          [4.114126, 51.984838, 6.75],
          [4.116015, 51.986352, 7.25],
          [4.116225, 51.986520, 7.75],
          [4.116327, 51.986976, 7.5],
          [4.116439, 51.987060, 7.75],
          [4.118143, 51.988315, 7.25],
          [4.119269, 51.989143, 6.25],
          [4.119516, 51.989289, 6.75],
          [4.120045, 51.989369, 7.75],
          [4.120693, 51.989615, 7.0],
          [4.120842, 51.989653, 7.0],
          [4.121052, 51.989655, 6.75],
          [4.121209, 51.989648, 6.5],
          [4.121327, 51.989629, 6.25],
          [4.121380, 51.989731, 6.25],
          [4.121537, 51.989895, 6.75],
          [4.121661, 51.989961, 6.75],
          [4.121537, 51.989895, 6.75],
          [4.121406, 51.989941, 7.0],
          [4.120646, 51.990230, 7.75],
          [4.119840, 51.990530, 7.0],
          [4.119762, 51.990559, 6.75],
          [4.119569, 51.990627, 6.25],
          [4.118134, 51.991158, 5.25],
          [4.118003, 51.991214, 5.5],
          [4.117953, 51.991232, 5.5],
          [4.118003, 51.991214, 5.5],
          [4.118070, 51.991268, 5.25],
          [4.118066, 51.991341, 5.5],
          [4.118147, 51.991380, 5.25],
          [4.118987, 51.991785, 5.0],
          [4.119725, 51.992131, 5.5],
          [4.120737, 51.992461, 5.0],
          [4.120960, 51.992686, 5.0],
          [4.121261, 51.992901, 5.25],
          [4.122188, 51.993430, 6.25],
          [4.122446, 51.993568, 6.0],
          [4.123057, 51.993893, 5.25],
          [4.123681, 51.994272, 5.25],
          [4.123945, 51.994463, 5.5],
          [4.124324, 51.994624, 5.75],
          [4.124616, 51.994692, 5.75],
          [4.124736, 51.994732, 5.75],
          [4.124988, 51.994842, 5.75],
          [4.125150, 51.994932, 5.75],
          [4.125277, 51.994996, 5.75],
          [4.126844, 51.995907, 7.0],
          [4.127348, 51.996223, 7.0],
          [4.128055, 51.996708, 7.5],
          [4.128516, 51.997047, 7.75],
          [4.128632, 51.997143, 7.5],
          [4.128686, 51.997197, 7.5],
          [4.128824, 51.997386, 7.75],
          [4.129175, 51.997714, 7.75],
          [4.129565, 51.998107, 7.5],
          [4.129702, 51.998231, 7.25],
          [4.129899, 51.998384, 7.0],
          [4.130144, 51.998589, 7.0],
          [4.130333, 51.998747, 7.25],
          [4.130851, 51.999241, 8.0],
          [4.131137, 51.999404, 8.0],
          [4.131785, 52.000014, 7.75],
          [4.132532, 52.000700, 7.0],
          [4.132604, 52.000674, 7.25],
          [4.133478, 52.000358, 6.0],
          [4.133675, 52.000287, 6.0],
          [4.133530, 52.000008, 6.25],
          [4.133425, 51.999690, 4.5],
          [4.133396, 51.999507, 3.25],
          [4.133393, 51.999415, 2.5],
          [4.133396, 51.999507, 3.25],
          [4.133511, 51.999524, 3.25],
          [4.133564, 51.999564, 3.25],
          [4.134013, 52.000181, 4.75],
          [4.134173, 52.000377, 4.25],
          [4.134789, 52.001129, 3.25],
          [4.134859, 52.001194, 3.25],
          [4.135370, 52.001590, 3.75],
          [4.136249, 52.002245, 3.0],
          [4.137493, 52.003242, 2.75],
          [4.137920, 52.003612, 2.25],
          [4.138151, 52.003783, 1.5],
          [4.138200, 52.003870, 1.5],
          [4.138518, 52.004145, 1.0],
          [4.138850, 52.004395, 1.5],
          [4.140127, 52.005198, 2.0],
          [4.140348, 52.005381, 1.25],
          [4.141999, 52.007183, 1.25],
          [4.142169, 52.007344, 1.5],
          [4.142351, 52.007472, 1.75],
          [4.142752, 52.007686, 2.0],
          [4.144472, 52.008574, 1.25],
          [4.145670, 52.009179, 2.75],
          [4.145925, 52.009300, 2.5],
          [4.146188, 52.009402, 2.0],
          [4.146750, 52.009593, 0.75],
          [4.147386, 52.009824, 0.25],
          [4.147459, 52.009870, 0.25],
          [4.147581, 52.009954, 0.0],
          [4.147674, 52.010018, 0.0],
          [4.147787, 52.009992, 0.0],
          [4.147674, 52.010018, 0.0],
          [4.148276, 52.011118, 0.75],
          [4.148372, 52.011343, 1.0],
          [4.148727, 52.012210, 1.0],
          [4.148931, 52.012736, 1.25],
          [4.149130, 52.013281, 1.75],
          [4.149271, 52.013624, 2.0],
          [4.150170, 52.015652, 3.0],
          [4.150349, 52.016292, 3.0],
          [4.150715, 52.016780, 3.0],
          [4.150834, 52.016937],
          [4.150625, 52.016957],
          [4.150548, 52.016949],
          [4.150449, 52.016927],
          [4.150355, 52.016885],
          [4.150275, 52.016824],
          [4.150223, 52.016745],
          [4.150141, 52.016570],
          [4.150083, 52.016543],
          [4.150033, 52.016534],
          [4.149970, 52.016539],
          [4.149789, 52.016581],
          [4.149653, 52.016627],
          [4.149440, 52.016715],
          [4.148830, 52.016985],
          [4.148329, 52.017219],
          [4.148393, 52.017276],
          [4.149088, 52.017889],
          [4.151642, 52.020038],
          [4.152326, 52.020554],
          [4.153718, 52.021734],
          [4.154771, 52.022593],
          [4.155545, 52.023116],
          [4.155771, 52.023201],
          [4.155947, 52.023281],
          [4.156089, 52.023359],
          [4.156812, 52.023939],
          [4.156870, 52.023985],
          [4.158565, 52.025512],
          [4.158794, 52.025688],
          [4.159296, 52.026005],
          [4.160672, 52.027094],
          [4.160927, 52.027314],
          [4.161029, 52.027366],
          [4.161164, 52.027422],
          [4.161373, 52.027473],
          [4.161527, 52.027502],
          [4.161549, 52.027507],
          [4.161723, 52.027524],
          [4.161863, 52.027499, 6.75],
          [4.162128, 52.027381, 6.75],
          [4.162218, 52.027360, 6.75],
          [4.162341, 52.027366, 6.75],
          [4.162428, 52.027389, 6.75],
          [4.162481, 52.027415, 6.75],
          [4.162714, 52.027560, 6.75],
          [4.162781, 52.027591, 6.75],
          [4.162847, 52.027603, 6.75],
          [4.162972, 52.027597, 6.75],
          [4.163316, 52.027539, 6.75],
          [4.163461, 52.027523, 7.75],
          [4.164017, 52.027501, 7.0],
          [4.164157, 52.027490, 6.75],
          [4.164260, 52.027470, 6.5],
          [4.164474, 52.027402, 5.5],
          [4.164727, 52.027301, 4.25],
          [4.165033, 52.027167, 2.75],
          [4.165795, 52.027362, 2.5],
          [4.166250, 52.027632, 2.25],
          [4.168105, 52.028659, 3.25],
          [4.168189, 52.028725, 3.0],
          [4.168244, 52.028785, 3.0],
          [4.168254, 52.028836, 3.0],
          [4.168251, 52.028887, 3.0],
          [4.168201, 52.029023, 3.0],
          [4.168202, 52.029059, 3.0],
          [4.168219, 52.029100, 3.0],
          [4.168286, 52.029181, 3.0],
          [4.168338, 52.029217, 3.0],
          [4.168486, 52.029269, 3.0],
          [4.168570, 52.029290, 3.0],
          [4.168928, 52.029396, 3.25],
          [4.169074, 52.029452, 3.25],
          [4.169524, 52.029673, 3.25],
          [4.170738, 52.030306, 3.0],
          [4.171827, 52.030893, 2.0],
          [4.171890, 52.030928, 2.0],
          [4.172753, 52.031230, 2.25],
          [4.172926, 52.031291, 2.5],
          [4.173075, 52.031364, 2.5],
          [4.172962, 52.031411, 2.5],
          [4.172268, 52.031751, 3.0],
          [4.172129, 52.031832, 3.0],
          [4.171962, 52.031907, 3.25],
          [4.171815, 52.031987, 3.5],
          [4.171737, 52.032079, 3.75],
          [4.171674, 52.032170, 4.0],
          [4.171576, 52.032366, 4.75],
          [4.171557, 52.032442, 4.75],
          [4.171507, 52.032505, 5.0],
          [4.171462, 52.032536, 5.25],
          [4.171340, 52.032573, 5.5],
          [4.170723, 52.032698, 6.25],
          [4.170172, 52.032802, 6.5],
          [4.169896, 52.032901, 6.5],
          [4.169801, 52.032980, 6.25],
          [4.169790, 52.032990, 6.25],
          [4.169770, 52.033030, 6.25],
          [4.169765, 52.033103, 6.25],
          [4.169778, 52.033150, 6.5],
          [4.169816, 52.033202, 6.75],
          [4.170301, 52.033601, 6.75],
          [4.170375, 52.033705, 6.75],
          [4.170509, 52.033922, 6.75],
          [4.170613, 52.034005, 6.75],
          [4.171331, 52.034530, 6.75],
          [4.172179, 52.035173, 6.75],
          [4.172411, 52.035279, 6.75],
          [4.172564, 52.035370, 5.25],
          [4.172687, 52.035486, 5.25],
          [4.173179, 52.035905, 5.25],
          [4.173711, 52.036301, 6.5],
          [4.174236, 52.036711, 6.5],
          [4.174409, 52.036896, 6.5],
          [4.174612, 52.037171, 6.5],
          [4.174689, 52.037253, 6.5],
          [4.175370, 52.037710, 6.5],
          [4.176276, 52.038216, 3.75],
          [4.177087, 52.038743, 4.0],
          [4.177631, 52.039145, 4.5],
          [4.178144, 52.039555, 4.5],
          [4.178579, 52.039933, 4.0],
          [4.178825, 52.040163, 4.25],
          [4.179098, 52.040374, 4.75],
          [4.180915, 52.041672, 4.0],
          [4.181779, 52.042276, 3.75],
          [4.182607, 52.042870, 3.25],
          [4.182909, 52.043105, 3.5],
          [4.183256, 52.043335, 3.5],
          [4.183912, 52.043805, 3.5],
          [4.185277, 52.044858, 3.5],
          [4.185595, 52.045062, 3.5],
          [4.187277, 52.046391, 3.5],
          [4.188258, 52.047121, 3.5],
          [4.188520, 52.047256, 3.5],
          [4.189185, 52.047710, 3.5],
          [4.189657, 52.048051, 3.5],
          [4.190249, 52.048506, 3.5],
          [4.190814, 52.048956, 3.5],
          [4.191187, 52.049394, 3.5],
          [4.191434, 52.049568, 3.5],
          [4.191691, 52.049778, 3.5],
          [4.192865, 52.050666, 3.5],
          [4.193153, 52.050849, 3.5],
          [4.193662, 52.051141, 3.5],
          [4.194129, 52.051449, 3.5],
          [4.194235, 52.051553, 3.5],
          [4.194337, 52.051735, 3.5],
          [4.194442, 52.051868, 3.5],
          [4.194626, 52.052025, 3.5],
          [4.195409, 52.052624, 3.5],
          [4.196295, 52.053297, 3.5],
          [4.196399, 52.053377],
          [4.196505, 52.053436],
          [4.196724, 52.053533],
          [4.196856, 52.053599],
          [4.196990, 52.053698],
          [4.197295, 52.053949],
          [4.197363, 52.054036],
          [4.197426, 52.054134],
          [4.197464, 52.054191],
          [4.197536, 52.054266],
          [4.197895, 52.054513],
          [4.198655, 52.055090],
          [4.199080, 52.055439],
          [4.200016, 52.056103],
          [4.200172, 52.056186],
          [4.200349, 52.056263],
          [4.200719, 52.056396],
          [4.201042, 52.056524],
          [4.201187, 52.056605],
          [4.201309, 52.056693],
          [4.201695, 52.057066],
          [4.201813, 52.057158],
          [4.201949, 52.057221],
          [4.202140, 52.057294],
          [4.202213, 52.057330],
          [4.202269, 52.057372],
          [4.202504, 52.057587],
          [4.202711, 52.057753],
          [4.204357, 52.058753],
          [4.205502, 52.059443],
          [4.205674, 52.059558],
          [4.205810, 52.059706],
          [4.205929, 52.059801],
          [4.208013, 52.061228],
          [4.209598, 52.062300],
          [4.211246, 52.063405],
          [4.211577, 52.063646],
          [4.211760, 52.063925],
          [4.212694, 52.064504],
          [4.213530, 52.065087],
          [4.213641, 52.065149],
          [4.213824, 52.065215],
          [4.214126, 52.065307],
          [4.214590, 52.065517],
          [4.214840, 52.065587],
          [4.214932, 52.065593],
          [4.215128, 52.065588],
          [4.215227, 52.065568],
          [4.216047, 52.065348, 8.0],
          [4.216317, 52.065282, 8.75],
          [4.216467, 52.065255, 8.75],
          [4.216534, 52.065258, 9.0],
          [4.216643, 52.065277, 9.25],
          [4.216981, 52.065365, 9.0],
          [4.217260, 52.065465, 9.0],
          [4.217465, 52.065546, 9.0],
          [4.217542, 52.065586, 8.75],
          [4.217656, 52.065663, 8.75],
          [4.217832, 52.065822, 8.75],
          [4.217919, 52.065892, 8.5],
          [4.217943, 52.065911, 8.5],
          [4.218044, 52.065954, 8.0],
          [4.218112, 52.065974, 8.0],
          [4.218289, 52.065991, 7.5],
          [4.218426, 52.065990, 7.0],
          [4.218502, 52.065992, 6.75],
          [4.218539, 52.065970, 6.75],
          [4.218720, 52.065791, 5.75],
          [4.218841, 52.065840, 5.75],
          [4.218945, 52.065886, 5.5],
          [4.218666, 52.066166, 6.75],
          [4.218530, 52.066313, 7.5],
          [4.218503, 52.066361, 7.75],
          [4.218504, 52.066391, 7.75],
          [4.218518, 52.066418, 7.75],
          [4.218563, 52.066465, 7.75],
          [4.219474, 52.067153, 9.75],
          [4.219601, 52.067293, 10.25],
          [4.219710, 52.067413, 11.0],
          [4.219890, 52.067548, 11.25],
          [4.220371, 52.067913, 12.25],
          [4.220439, 52.067938, 12.25],
          [4.220657, 52.067934, 12.0],
          [4.220801, 52.067938, 12.0],
          [4.220911, 52.067981, 12.0],
          [4.221985, 52.068615, 12.5],
          [4.222152, 52.068697, 12.25],
          [4.222245, 52.068737, 12.0],
          [4.222453, 52.068836, 11.5],
          [4.222558, 52.068898, 11.25],
          [4.222793, 52.069020, 10.75],
          [4.222971, 52.069139, 10.25],
          [4.223277, 52.069390, 9.25],
          [4.223449, 52.069570, 9.25],
          [4.224026, 52.070172, 9.25],
          [4.224143, 52.070289, 9.25],
          [4.224226, 52.070362, 9.25],
          [4.224325, 52.070434, 9.0],
          [4.224577, 52.070570, 9.0],
          [4.224830, 52.070672, 8.75],
          [4.225653, 52.070975, 9.0],
          [4.225811, 52.071050, 9.0],
          [4.225847, 52.071089, 9.0],
          [4.225865, 52.071140, 9.0],
          [4.225841, 52.071238, 9.0],
          [4.225679, 52.071458, 9.0],
          [4.225666, 52.071497, 9.0],
          [4.225665, 52.071535, 9.0],
          [4.225693, 52.071590, 9.0],
          [4.225772, 52.071654, 9.0],
          [4.226246, 52.071911, 9.0],
          [4.226306, 52.071952, 9.0],
          [4.226371, 52.072014, 9.0],
          [4.226429, 52.072093, 9.0],
          [4.226467, 52.072264, 9.0],
          [4.226517, 52.072433, 9.0],
          [4.227298, 52.073277, 8.75],
          [4.227883, 52.074045, 8.5],
          [4.228009, 52.074234, 8.25],
          [4.228355, 52.074678, 7.75],
          [4.228530, 52.074861, 8.0],
          [4.228651, 52.075099, 7.5],
          [4.228675, 52.075357, 6.5],
          [4.228693, 52.075397, 6.5],
          [4.228911, 52.075514, 7.0],
          [4.229711, 52.075920, 9.25],
          [4.230628, 52.076362, 10.75],
          [4.230908, 52.076530, 11.25],
          [4.231000, 52.076598, 11.5],
          [4.231071, 52.076671, 11.75],
          [4.231528, 52.077213, 10.0],
          [4.231720, 52.077544, 8.75],
          [4.231798, 52.077646, 8.0],
          [4.231929, 52.077746, 7.5],
          [4.232278, 52.077936, 7.25],
          [4.232749, 52.078215, 7.25],
          [4.233354, 52.078518, 8.25],
          [4.233607, 52.078565, 8.25],
          [4.234048, 52.078726, 8.0],
          [4.234633, 52.078952, 7.25],
          [4.235117, 52.079289, 5.75],
          [4.235324, 52.079371, 5.75],
          [4.235548, 52.079425, 6.0],
          [4.236052, 52.079485, 6.5],
          [4.236637, 52.079466, 7.25],
          [4.237197, 52.079404, 7.5],
          [4.237564, 52.079349, 7.75],
          [4.238034, 52.079290, 8.5],
          [4.238176, 52.079281, 8.75],
          [4.238249, 52.079284, 9.0],
          [4.238345, 52.079304, 9.25],
          [4.238418, 52.079340, 9.25],
          [4.238547, 52.079427, 9.5],
          [4.238749, 52.079611, 9.75],
          [4.239586, 52.080545, 11.5],
          [4.240266, 52.081225, 13.5],
          [4.240349, 52.081276, 13.75],
          [4.240447, 52.081309, 13.75],
          [4.240582, 52.081341, 14.0],
          [4.241057, 52.081422, 14.5],
          [4.241208, 52.081457, 14.75],
          [4.241347, 52.081505, 15.0],
          [4.241490, 52.081594, 15.5],
          [4.241515, 52.081625, 15.5],
          [4.241671, 52.081798, 16.0],
          [4.241908, 52.082091, 16.75],
          [4.242458, 52.082701, 17.25],
          [4.242758, 52.083013, 17.0],
          [4.242905, 52.083151, 17.0],
          [4.243137, 52.083349, 16.5],
          [4.243447, 52.083579, 16.25],
          [4.243913, 52.083896, 15.5],
          [4.244103, 52.084016, 15.25],
          [4.244288, 52.084105, 15.5],
          [4.244468, 52.084179, 15.5],
          [4.245062, 52.084429, 16.0],
          [4.245232, 52.084497, 16.0],
          [4.247224, 52.085285, 15.75],
          [4.247317, 52.085390, 15.5],
          [4.247447, 52.085602, 15.25],
          [4.247503, 52.085784, 15.0],
          [4.247494, 52.085886, 14.75],
          [4.247426, 52.086001, 14.5],
          [4.247261, 52.086188, 14.0],
          [4.246990, 52.086575, 13.75],
          [4.246821, 52.086890, 13.5],
          [4.246729, 52.087177, 12.75],
          [4.246719, 52.087496, 12.0],
          [4.246752, 52.087851, 11.5],
          [4.246758, 52.087902, 11.5],
          [4.247000, 52.088300, 11.75],
          [4.247229, 52.088512, 11.75],
          [4.248215, 52.089017, 10.25],
          [4.248627, 52.089166, 10.0],
          [4.248982, 52.089354, 9.5],
          [4.249309, 52.089595, 9.5],
          [4.249514, 52.089762, 9.5],
          [4.249701, 52.089848, 9.75],
          [4.249924, 52.090019, 9.75],
          [4.250160, 52.090275, 9.75],
          [4.250725, 52.090689, 9.75],
          [4.251150, 52.091352, 8.0],
          [4.251346, 52.091538, 8.75],
          [4.251562, 52.091717, 8.75],
          [4.251647, 52.091760, 8.75],
          [4.251775, 52.091813, 10.0],
          [4.251873, 52.091833, 9.75],
          [4.251951, 52.091842, 9.75],
          [4.252130, 52.091838, 9.75],
          [4.252250, 52.091842, 9.75],
          [4.252408, 52.091861, 9.75],
          [4.252516, 52.091892, 9.5],
          [4.252871, 52.092073, 10.0],
          [4.252936, 52.092118, 10.25],
          [4.252991, 52.092172, 10.5],
          [4.253028, 52.092260, 10.75],
          [4.253182, 52.092513, 10.75],
          [4.253212, 52.092544, 10.75],
          [4.253299, 52.092604, 10.75],
          [4.253481, 52.092699, 13.0],
          [4.253599, 52.092808, 13.0],
          [4.253769, 52.093046, 13.0],
          [4.254003, 52.093231, 13.0],
          [4.254192, 52.093348, 12.75],
          [4.254380, 52.093444, 12.25],
          [4.254662, 52.093552, 12.5],
          [4.255112, 52.093705, 13.0],
          [4.256027, 52.093938, 11.75],
          [4.256396, 52.094024, 11.25],
          [4.256645, 52.094071, 11.0],
          [4.256732, 52.094081, 11.0],
          [4.257054, 52.094096, 11.0],
          [4.257220, 52.094126, 11.0],
          [4.257407, 52.094172, 11.0],
          [4.257523, 52.094203, 11.0],
          [4.258313, 52.094409, 11.0],
          [4.258764, 52.094527, 11.0],
          [4.258794, 52.094575, 10.75],
          [4.259019, 52.094679, 10.5],
          [4.259955, 52.095102, 8.5],
          [4.260455, 52.094683, 8.75],
          [4.260982, 52.094279, 8.5],
          [4.261397, 52.093966, 8.5],
          [4.262427, 52.093090, 7.25],
          [4.262690, 52.093181, 6.75],
          [4.263534, 52.093560, 4.5],
          [4.263578, 52.093581, 4.5],
          [4.263607, 52.093591, 4.5],
          [4.264071, 52.093208, 6.0],
          [4.264101, 52.093179, 6.0],
          [4.264399, 52.092933, 6.5],
          [4.264501, 52.092846, 6.5],
          [4.264399, 52.092933, 6.5],
          [4.264532, 52.092998, 6.5],
          [4.264609, 52.093050, 6.5],
          [4.264639, 52.093100, 6.5],
          [4.264761, 52.093408, 6.5],
          [4.265036, 52.094120, 5.0],
          [4.265156, 52.094432, 4.25],
          [4.265194, 52.094482, 4.25],
          [4.265259, 52.094538, 4.25],
          [4.266796, 52.095614, 4.25],
          [4.266940, 52.095713, 4.0],
          [4.267826, 52.096360, 4.5],
          [4.267881, 52.096393, 4.5],
          [4.268407, 52.096770, 5.0],
          [4.269317, 52.097406, 5.5],
          [4.269922, 52.097817, 5.75],
          [4.271411, 52.098873, 5.75],
          [4.271724, 52.099096, 5.25],
          [4.272006, 52.099313, 5.75],
          [4.272240, 52.099586, 6.75],
          [4.272391, 52.099652, 7.25],
          [4.272452, 52.099617, 7.25],
          [4.272525, 52.099593, 7.5],
          [4.272621, 52.099580, 7.75],
          [4.272718, 52.099585, 8.0],
          [4.272798, 52.099605, 8.25],
          [4.272848, 52.099626, 8.5],
          [4.272883, 52.099660, 8.5],
          [4.272906, 52.099722, 8.75],
          [4.272935, 52.099861, 8.75],
          [4.272889, 52.099906, 8.75],
          [4.272825, 52.099942, 8.5],
          [4.272737, 52.099968, 8.5],
          [4.272717, 52.099947, 8.25],
          [4.272737, 52.099968, 8.5],
          [4.272659, 52.099977, 8.25],
          [4.272604, 52.099976, 8.0],
          [4.272499, 52.099957, 7.75],
          [4.272409, 52.099917, 7.5],
          [4.272325, 52.099938, 7.5],
          [4.272234, 52.099941, 7.25],
          [4.271396, 52.100404, 7.75],
          [4.270704, 52.100791, 8.75],
          [4.269964, 52.101180, 8.75],
          [4.269902, 52.101236, 8.5],
          [4.269877, 52.101284, 8.5],
          [4.269840, 52.101381, 8.25],
          [4.269245, 52.101296, 6.25],
          [4.269126, 52.101292, 5.75],
          [4.268138, 52.101839, 4.5],
          [4.267113, 52.102358, 6.25],
          [4.266531, 52.102560, 6.25],
          [4.266329, 52.102657, 6.25],
          [4.265852, 52.102860, 6.25],
          [4.265824, 52.102876, 6.25],
          [4.265763, 52.102992, 6.25],
          [4.265730, 52.103056],
          [4.265669, 52.103095],
          [4.265628, 52.103117],
          [4.265588, 52.103129],
          [4.265533, 52.103132],
          [4.265534, 52.103173],
          [4.266430, 52.103760],
          [4.267375, 52.104366],
          [4.267867, 52.104707],
          [4.267919, 52.104750],
          [4.268435, 52.105172],
          [4.268819, 52.105490],
          [4.269678, 52.106178],
          [4.270109, 52.106503],
          [4.270594, 52.106863],
          [4.270777, 52.106993],
          [4.271045, 52.107168],
          [4.271656, 52.107535],
          [4.271927, 52.107655],
          [4.272440, 52.107848],
          [4.272770, 52.107954],
          [4.273050, 52.108051],
          [4.273187, 52.108105],
          [4.273196, 52.108109],
          [4.273449, 52.108214, 8.0],
          [4.273618, 52.108297, 8.25],
          [4.273786, 52.108391, 8.25],
          [4.274096, 52.108613, 8.25],
          [4.274273, 52.108767, 9.0],
          [4.275669, 52.110039, 9.0],
          [4.276058, 52.110352, 9.0],
          [4.276593, 52.110740, 9.0],
          [4.276960, 52.110987, 9.0],
          [4.277267, 52.111166, 9.0],
          [4.277460, 52.111268, 9.0],
          [4.277633, 52.111347, 9.0],
          [4.278047, 52.111513, 11.75],
          [4.278071, 52.111522, 12.0],
          [4.278150, 52.111487, 12.75],
          [4.278232, 52.111470, 13.25],
          [4.278528, 52.111542, 14.5],
          [4.278651, 52.111564, 15.0],
          [4.278812, 52.111626, 15.5],
          [4.278974, 52.111601, 16.0],
          [4.279118, 52.111567, 16.25],
          [4.279278, 52.111509, 16.5],
          [4.279556, 52.111689, 18.0],
          [4.279456, 52.111747, 17.25],
          [4.279346, 52.111836, 16.0],
          [4.279299, 52.111864, 15.5],
          [4.279231, 52.111905, 15.0],
          [4.279239, 52.111910, 15.0],
          [4.279014, 52.111755, 15.5],
          [4.278995, 52.111717, 15.75],
          [4.278971, 52.111658, 16.25],
          [4.278995, 52.111717, 15.75],
          [4.279014, 52.111755, 15.5],
          [4.279239, 52.111910, 15.0],
          [4.279231, 52.111905, 15.0],
          [4.279299, 52.111864, 15.5],
          [4.279346, 52.111836, 16.0],
          [4.279456, 52.111747, 17.25],
          [4.279556, 52.111689, 18.0],
          [4.279278, 52.111509, 16.5],
          [4.279505, 52.111403, 16.25],
          [4.279504, 52.111361, 16.0],
          [4.279557, 52.111269, 15.25],
          [4.279722, 52.111139, 14.25],
          [4.279919, 52.111037, 13.25],
          [4.280114, 52.110965, 12.5],
          [4.280148, 52.110954, 12.25],
          [4.280318, 52.110850, 11.5],
          [4.280332, 52.110841, 11.25],
          [4.280397, 52.110854, 11.5],
          [4.280514, 52.110877, 12.0],
          [4.280590, 52.110919, 12.25],
          [4.281536, 52.111520, 16.5],
          [4.282174, 52.111894, 16.5],
          [4.282229, 52.111926, 16.5],
          [4.282243, 52.111935, 16.5],
          [4.282437, 52.111961, 16.5],
          [4.282495, 52.111992, 16.5],
          [4.282871, 52.112205, 16.75],
          [4.283083, 52.112307, 17.0],
          [4.283133, 52.112328, 17.25],
          [4.283193, 52.112365, 17.25],
          [4.283276, 52.112421, 17.5],
          [4.283349, 52.112478, 17.75],
          [4.283359, 52.112536, 17.75],
          [4.283368, 52.112554, 17.5],
          [4.283850, 52.112890, 15.75],
          [4.283896, 52.112979, 15.5],
          [4.283988, 52.113665, 15.0],
          [4.283996, 52.113722, 15.0],
          [4.284037, 52.113784, 15.0],
          [4.284286, 52.113955, 15.0],
          [4.284327, 52.113984, 15.0],
          [4.284400, 52.114030, 15.25],
          [4.284446, 52.114065, 15.25],
          [4.284665, 52.114207, 15.5],
          [4.284960, 52.114355, 15.5],
          [4.285039, 52.114399, 15.25],
          [4.285169, 52.114483, 15.0],
          [4.285238, 52.114547, 14.75],
          [4.285252, 52.114571, 14.5],
          [4.285341, 52.114715, 14.25],
          [4.286260, 52.115287, 12.0],
          [4.287556, 52.116113, 12.25],
          [4.287632, 52.116127, 12.0],
          [4.287706, 52.116152, 12.0],
          [4.287757, 52.116183, 12.0],
          [4.287934, 52.116290, 11.75],
          [4.288007, 52.116343, 11.75],
          [4.288091, 52.116386, 11.75],
          [4.288183, 52.116435, 11.75],
          [4.288275, 52.116485, 11.75],
          [4.288709, 52.116704, 11.5],
          [4.288934, 52.116827, 11.25],
          [4.288981, 52.116859, 11.25],
          [4.289025, 52.116893, 11.25],
          [4.289114, 52.116962, 11.25],
          [4.289150, 52.116996, 11.25],
          [4.289211, 52.117050, 11.25],
          [4.289248, 52.117100, 11.25],
          [4.289268, 52.117238, 11.5],
          [4.289313, 52.117270, 11.75],
          [4.289395, 52.117333, 11.75],
          [4.289665, 52.117485, 12.5],
          [4.290113, 52.117671, 13.5],
          [4.291799, 52.118564, 18.25],
          [4.292444, 52.118947, 18.0],
          [4.293270, 52.119375, 18.5],
          [4.293923, 52.119763, 16.25],
          [4.295348, 52.120626, 17.75],
          [4.295568, 52.120760, 17.75],
          [4.295574, 52.120779, 17.75],
          [4.295568, 52.120760, 17.75],
          [4.295348, 52.120626, 17.75],
          [4.293923, 52.119763, 16.25],
          [4.293270, 52.119375, 18.5],
          [4.292444, 52.118947, 18.0],
          [4.291799, 52.118564, 18.25],
          [4.290113, 52.117671, 13.5],
          [4.289665, 52.117485, 12.5],
          [4.289395, 52.117333, 11.75],
          [4.289313, 52.117270, 11.75],
          [4.289268, 52.117238, 11.5],
          [4.289120, 52.117195, 11.5],
          [4.288753, 52.117004, 11.5],
          [4.288555, 52.116899, 11.75],
          [4.287940, 52.116570, 11.5],
          [4.287911, 52.116554, 11.5],
          [4.287865, 52.116489, 11.5],
          [4.287887, 52.116463, 11.5],
          [4.287921, 52.116414, 11.75],
          [4.287933, 52.116398, 11.75],
          [4.287920, 52.116373, 11.75],
          [4.287878, 52.116313, 11.75],
          [4.287709, 52.116211, 12.0],
          [4.287757, 52.116183, 12.0],
          [4.287862, 52.116117, 12.0],
          [4.287884, 52.116090, 12.0],
          [4.287890, 52.116056, 12.0],
          [4.287861, 52.115344, 11.75],
          [4.287828, 52.114484, 11.75],
          [4.287645, 52.113957, 12.25],
          [4.287627, 52.113901, 12.25],
          [4.287682, 52.113885, 12.0],
          [4.287627, 52.113901, 12.25],
          [4.287206, 52.114000, 12.75],
          [4.286612, 52.114087, 13.75],
          [4.286383, 52.114115, 14.0],
          [4.286346, 52.114010, 13.75],
          [4.286330, 52.113956, 13.75],
          [4.289264, 52.113594, 12.0],
          [4.292604, 52.113135, 12.75],
          [4.292728, 52.113101, 12.5],
          [4.292860, 52.113062, 12.5],
          [4.293107, 52.112999, 12.25],
          [4.293436, 52.112897, 11.5],
          [4.293559, 52.112872, 11.0],
          [4.293571, 52.112869, 10.75],
          [4.293559, 52.112872, 11.0],
          [4.293582, 52.112917, 11.0],
          [4.293623, 52.112997, 11.0],
          [4.293667, 52.113084, 11.25],
          [4.293838, 52.113551, 9.75],
          [4.293828, 52.113602, 9.5],
          [4.293798, 52.113698, 9.0],
          [4.293866, 52.113887, 7.75],
          [4.293952, 52.114048, 6.75],
          [4.293972, 52.114075, 6.5],
          [4.294061, 52.114168, 6.0],
          [4.294125, 52.114216, 6.0],
          [4.294211, 52.114264, 6.0],
          [4.296121, 52.115088, 5.0],
          [4.296386, 52.115191, 4.5],
          [4.296649, 52.115283, 4.0],
          [4.297556, 52.115503, 3.75],
          [4.302955, 52.116815, 3.5],
          [4.304465, 52.117181, 6.75],
          [4.305060, 52.117325, 7.5],
          [4.305313, 52.117378, 7.25],
          [4.305443, 52.117476, 7.0],
          [4.305475, 52.117405, 7.0],
          [4.305443, 52.117476, 7.0],
          [4.305494, 52.117536, 6.75],
          [4.305520, 52.117649, 6.5],
          [4.305538, 52.117746, 6.25],
          [4.305551, 52.117801, 6.0],
          [4.305612, 52.118014, 5.5],
          [4.305970, 52.119364, 4.25],
          [4.306022, 52.119635, 4.25],
          [4.305966, 52.119958, 4.25],
          [4.305716, 52.120717, 4.75],
          [4.305604, 52.121090, 5.0],
          [4.305539, 52.121379, 5.0],
          [4.305407, 52.121801, 5.5],
          [4.305387, 52.122427, 5.75],
          [4.305393, 52.122829, 5.5],
          [4.305283, 52.123248, 5.0],
          [4.305263, 52.123315, 5.0],
          [4.305107, 52.123848, 5.5],
          [4.305033, 52.124144, 5.75],
          [4.305028, 52.124277, 6.0],
          [4.305048, 52.124397, 6.0],
          [4.305102, 52.124513, 6.0],
          [4.305126, 52.124546, 6.0],
          [4.305208, 52.124632, 6.0],
          [4.305343, 52.124721, 5.75],
          [4.305446, 52.124774, 5.5],
          [4.305571, 52.124838, 5.5],
          [4.305795, 52.124953, 5.0],
          [4.305951, 52.125031, 4.75],
          [4.306956, 52.125534, 4.25],
          [4.307181, 52.125706, 4.5],
          [4.307775, 52.126255, 5.25],
          [4.308007, 52.126435, 4.75],
          [4.308291, 52.126624, 4.0],
          [4.309030, 52.127145, 5.75],
          [4.309298, 52.127305, 6.0],
          [4.309798, 52.127650, 5.5],
          [4.309906, 52.127761, 5.5],
          [4.309968, 52.127860, 5.5],
          [4.310085, 52.128280, 5.75],
          [4.310293, 52.128573, 6.5],
          [4.310721, 52.129135, 7.0],
          [4.310903, 52.129330, 6.75],
          [4.311215, 52.129522, 6.0],
          [4.311270, 52.129553, 6.0],
          [4.312227, 52.130078, 6.0],
          [4.312539, 52.130241, 6.5],
          [4.312798, 52.130334, 6.25],
          [4.314146, 52.130792, 6.75],
          [4.314443, 52.130880, 7.25],
          [4.315552, 52.131103, 9.0],
          [4.316020, 52.131190, 10.25],
          [4.316641, 52.131317, 12.0],
          [4.316951, 52.131390, 12.0],
          [4.317206, 52.131463, 12.25],
          [4.317436, 52.131551, 12.5],
          [4.317619, 52.131639, 12.75],
          [4.317649, 52.131625, 12.5],
          [4.317457, 52.131523, 12.25],
          [4.317242, 52.131442, 12.25],
          [4.316664, 52.131284, 12.0],
          [4.315747, 52.131106, 9.75],
          [4.316664, 52.131284, 12.0],
          [4.317242, 52.131442, 12.25],
          [4.317457, 52.131523, 12.25],
          [4.317649, 52.131625, 12.5],
          [4.317619, 52.131639, 12.75],
          [4.317889, 52.131806, 11.5],
          [4.318008, 52.131857, 11.0],
          [4.318163, 52.131891, 10.5],
          [4.318382, 52.131910, 10.0],
          [4.318633, 52.131920, 9.5],
          [4.319594, 52.131942, 7.5],
          [4.319815, 52.131986, 7.0],
          [4.320569, 52.132247, 5.75],
          [4.320926, 52.132341, 5.75],
          [4.321763, 52.132519, 5.75],
          [4.323056, 52.132769, 5.25],
          [4.323642, 52.132928, 5.25],
          [4.325653, 52.133551, 4.75],
          [4.326502, 52.133804, 4.25],
          [4.326735, 52.133853, 4.0],
          [4.326782, 52.133858, 4.0],
          [4.327288, 52.133871, 4.0],
          [4.328518, 52.133858, 4.25],
          [4.328605, 52.133858, 4.25],
          [4.328793, 52.133876, 4.25],
          [4.329106, 52.133904, 4.5],
          [4.329341, 52.133947, 4.75],
          [4.329585, 52.134036, 4.75],
          [4.329712, 52.134100, 4.75],
          [4.329959, 52.134265, 5.0],
          [4.330246, 52.134494, 5.0],
          [4.330509, 52.134746, 5.0],
          [4.330980, 52.135271, 5.0],
          [4.331298, 52.135615, 5.0],
          [4.332269, 52.136445, 5.5],
          [4.332934, 52.137028, 5.75],
          [4.333277, 52.137614, 7.0],
          [4.333507, 52.138115, 7.5],
          [4.333682, 52.138360, 7.5],
          [4.333845, 52.138489, 7.25],
          [4.333975, 52.138575, 7.0],
          [4.334221, 52.138699, 6.75],
          [4.334806, 52.138915, 7.25],
          [4.335037, 52.139005, 7.5],
          [4.335137, 52.139051, 7.5],
          [4.335265, 52.139167, 7.75],
          [4.335581, 52.139534, 8.0],
          [4.335755, 52.139707, 8.0],
          [4.336268, 52.140097, 7.75],
          [4.336620, 52.140299, 7.5],
          [4.336780, 52.140379, 7.5],
          [4.336994, 52.140462, 7.5],
          [4.337849, 52.140691, 8.25],
          [4.338005, 52.140722, 8.25],
          [4.338051, 52.140731, 8.25],
          [4.338298, 52.140765, 8.75],
          [4.338625, 52.140782, 8.5],
          [4.338926, 52.140773, 8.0],
          [4.339243, 52.140739, 7.75],
          [4.339460, 52.140743, 7.5],
          [4.339669, 52.140790, 7.25],
          [4.339840, 52.140857, 7.0],
          [4.340995, 52.141515, 7.0],
          [4.341558, 52.141912, 6.5],
          [4.342217, 52.142390, 6.0],
          [4.343278, 52.143203, 6.75],
          [4.343911, 52.144464, 5.25],
          [4.344072, 52.144712, 4.5],
          [4.345055, 52.145722, 5.0],
          [4.345345, 52.146029, 5.0],
          [4.345612, 52.146347, 5.0],
          [4.345765, 52.146606, 4.75],
          [4.345845, 52.146695, 5.0],
          [4.346025, 52.146845, 5.0],
          [4.346126, 52.146968, 5.0],
          [4.346329, 52.147344, 5.25],
          [4.346425, 52.147459, 5.5],
          [4.346497, 52.147532, 5.75],
          [4.346604, 52.147609, 5.75],
          [4.346868, 52.147748, 5.5],
          [4.348919, 52.148526, 4.75],
          [4.350310, 52.148961, 5.5],
          [4.350969, 52.149228, 6.0],
          [4.351380, 52.149408, 6.0],
          [4.351516, 52.149477, 6.0],
          [4.351631, 52.149536, 6.0],
          [4.351779, 52.149633, 5.75],
          [4.352039, 52.149903, 5.0],
          [4.352664, 52.150462, 4.5],
          [4.352927, 52.150836, 4.5],
          [4.353487, 52.151325, 5.75],
          [4.353583, 52.151598, 6.0],
          [4.353486, 52.152648, 9.0],
          [4.353585, 52.152881, 10.5],
          [4.353772, 52.153061, 11.5],
          [4.354727, 52.154066, 12.75],
          [4.355388, 52.154626, 12.0],
          [4.355899, 52.155043, 11.5],
          [4.356043, 52.155121, 11.0],
          [4.356656, 52.155552, 10.0],
          [4.356688, 52.155589, 10.0],
          [4.356890, 52.155816, 10.0],
          [4.357105, 52.156235, 9.75],
          [4.357154, 52.157027, 9.75],
          [4.357284, 52.157292, 10.0],
          [4.357595, 52.157725, 12.0],
          [4.357849, 52.157903, 13.25],
          [4.358310, 52.158130, 14.5],
          [4.358707, 52.158262, 14.75],
          [4.358993, 52.158412, 15.25],
          [4.359284, 52.158644, 16.75],
          [4.359663, 52.159013, 18.5],
          [4.359770, 52.159159, 19.0],
          [4.360384, 52.159702, 15.75],
          [4.360528, 52.159842, 14.75],
          [4.360763, 52.159936, 14.25],
          [4.361824, 52.160331, 14.0],
          [4.362243, 52.160516, 13.75],
          [4.362454, 52.160626, 13.25],
          [4.362596, 52.160723, 13.25],
          [4.362651, 52.160768, 13.0],
          [4.361735, 52.161013, 12.5],
          [4.361319, 52.161116, 12.25],
          [4.361383, 52.161251, 12.0],
          [4.361389, 52.161301, 12.0],
          [4.361355, 52.161343, 12.0],
          [4.361172, 52.161442, 12.0],
          [4.361070, 52.161509, 12.25],
          [4.361042, 52.161548, 12.25],
          [4.361037, 52.161592, 12.25],
          [4.361063, 52.161655, 12.25],
          [4.361169, 52.161767, 12.0],
          [4.361214, 52.161829, 11.75],
          [4.361242, 52.161862, 11.75],
          [4.361267, 52.161895, 11.5],
          [4.361269, 52.161955, 11.5],
          [4.361200, 52.161993, 11.5],
          [4.361058, 52.162048, 12.0],
          [4.361013, 52.162112, 12.0],
          [4.361023, 52.162333, 11.5],
          [4.361105, 52.162855, 12.5],
          [4.361135, 52.163464, 14.25],
          [4.361140, 52.163498, 14.25],
          [4.361233, 52.163830, 14.75],
          [4.361321, 52.163981, 15.0],
          [4.361441, 52.164155, 15.5],
          [4.361660, 52.164427, 17.0],
          [4.361725, 52.164484, 17.25],
          [4.361882, 52.164587, 17.25],
          [4.362036, 52.164663, 17.25],
          [4.362256, 52.164788, 17.5],
          [4.362457, 52.164919, 17.5],
          [4.362515, 52.164990, 17.75],
          [4.362534, 52.165032, 17.5],
          [4.362536, 52.165080, 17.25],
          [4.362515, 52.165116, 17.25],
          [4.361911, 52.165477, 16.0],
          [4.361665, 52.165653, 15.25],
          [4.361545, 52.165724, 14.5],
          [4.361416, 52.165782, 14.0],
          [4.360944, 52.165965, 12.5],
          [4.359913, 52.166240, 12.0],
          [4.359571, 52.166319, 11.75],
          [4.359265, 52.166360, 11.75],
          [4.358443, 52.166396, 11.5],
          [4.358334, 52.166414, 11.5],
          [4.358221, 52.166460, 11.75],
          [4.358146, 52.166527, 11.75],
          [4.358114, 52.166570, 11.75],
          [4.358136, 52.166648, 11.75],
          [4.358174, 52.166692, 12.0],
          [4.358287, 52.166790, 12.0],
          [4.358553, 52.166989, 11.75],
          [4.358888, 52.167182, 11.5],
          [4.359062, 52.167294, 11.25],
          [4.359239, 52.167427, 11.0],
          [4.359820, 52.167881, 10.0],
          [4.360137, 52.168132, 9.75],
          [4.360407, 52.168282, 9.25],
          [4.361024, 52.168583, 8.5],
          [4.361171, 52.168683, 8.5],
          [4.361260, 52.168760, 8.75],
          [4.361326, 52.168929, 9.0],
          [4.361355, 52.168976, 9.0],
          [4.361426, 52.169031, 9.25],
          [4.361639, 52.169123, 9.75],
          [4.362055, 52.169295, 9.5],
          [4.362475, 52.169499, 9.25],
          [4.362812, 52.169641, 9.25],
          [4.363039, 52.169723, 9.5],
          [4.363237, 52.169787, 9.75],
          [4.363433, 52.169873, 10.25],
          [4.363520, 52.169926, 10.25],
          [4.363529, 52.169953, 10.5],
          [4.363525, 52.169990, 10.5],
          [4.363451, 52.170168, 10.75],
          [4.363449, 52.170223, 10.75],
          [4.363460, 52.170277, 10.75],
          [4.363537, 52.170383, 10.75],
          [4.363638, 52.170485, 10.5],
          [4.363795, 52.170588, 10.25],
          [4.364079, 52.170818, 10.0],
          [4.364150, 52.170895, 10.0],
          [4.364363, 52.171226, 10.0],
          [4.364465, 52.171357, 10.0],
          [4.364554, 52.171456, 10.0],
          [4.364637, 52.171524, 10.0],
          [4.364812, 52.171627, 10.0],
          [4.364950, 52.171684, 10.0],
          [4.365500, 52.171830, 9.25],
          [4.365611, 52.171874, 9.25],
          [4.366297, 52.172361, 7.75],
          [4.366360, 52.172433, 7.5],
          [4.366379, 52.172496, 7.5],
          [4.366380, 52.172880, 8.5],
          [4.366411, 52.172934, 8.5],
          [4.366467, 52.172972, 8.75],
          [4.366564, 52.173014, 8.75],
          [4.366638, 52.173031, 8.75],
          [4.366858, 52.173063, 8.75],
          [4.367019, 52.173080, 8.75],
          [4.367184, 52.173107, 8.5],
          [4.367379, 52.173166, 8.5],
          [4.367755, 52.173320, 8.25],
          [4.368138, 52.173733, 8.5],
          [4.368298, 52.173871, 8.75],
          [4.368484, 52.173999, 9.25],
          [4.368758, 52.174155, 9.25],
          [4.368997, 52.174307, 9.25],
          [4.369099, 52.174427, 9.25],
          [4.369139, 52.174564, 9.5],
          [4.369122, 52.175090, 9.5],
          [4.368961, 52.175822, 5.75],
          [4.368883, 52.176107, 5.5],
          [4.368839, 52.176327, 5.5],
          [4.368871, 52.176496, 5.5],
          [4.369004, 52.176776, 5.75],
          [4.369154, 52.177027, 6.25],
          [4.369621, 52.177553, 7.0],
          [4.369762, 52.177790, 7.0],
          [4.369919, 52.178031, 6.5],
          [4.370102, 52.178413, 6.5],
          [4.370222, 52.178572, 7.0],
          [4.370331, 52.178662, 7.5],
          [4.370604, 52.178856, 8.25],
          [4.370919, 52.179024, 8.75],
          [4.371394, 52.179367, 8.0],
          [4.371593, 52.179577, 7.5],
          [4.371729, 52.179801, 7.25],
          [4.371719, 52.179921, 7.0],
          [4.371673, 52.180002, 7.0],
          [4.371656, 52.180095, 7.25],
          [4.371847, 52.180437, 8.75],
          [4.371956, 52.180609, 9.25],
          [4.372054, 52.180738, 9.75],
          [4.372267, 52.180834, 10.0],
          [4.372749, 52.180965, 9.75],
          [4.373218, 52.181075, 9.0],
          [4.373643, 52.181195, 9.5],
          [4.373871, 52.181303, 9.75],
          [4.374151, 52.181470, 10.0],
          [4.374278, 52.181586, 10.0],
          [4.374351, 52.181693, 10.25],
          [4.374491, 52.181952, 10.75],
          [4.374649, 52.182333, 11.25],
          [4.374783, 52.182749, 11.0],
          [4.374841, 52.182818, 10.75],
          [4.374895, 52.182882, 10.75],
          [4.375120, 52.183161, 10.0],
          [4.375391, 52.183367, 10.0],
          [4.375639, 52.183644, 10.5],
          [4.375983, 52.184179, 12.0],
          [4.376122, 52.184538, 12.25],
          [4.376155, 52.184676, 12.5],
          [4.376226, 52.184833, 12.25],
          [4.376410, 52.185199, 12.0],
          [4.376567, 52.185424, 11.5],
          [4.376686, 52.185555, 11.5],
          [4.376908, 52.185777, 11.5],
          [4.377115, 52.185953, 11.75],
          [4.377477, 52.186285, 12.0],
          [4.377773, 52.186595, 11.75],
          [4.378039, 52.186907, 12.0],
          [4.378223, 52.187218, 12.75],
          [4.378312, 52.187321, 13.0],
          [4.378477, 52.187453, 13.5],
          [4.378815, 52.187673, 13.75],
          [4.379121, 52.187839, 13.75],
          [4.379500, 52.188023, 13.25],
          [4.379701, 52.188149, 13.25],
          [4.379990, 52.188400, 13.25],
          [4.380114, 52.188529, 13.5],
          [4.380145, 52.188606, 13.5],
          [4.380174, 52.188786, 14.0],
          [4.380179, 52.188868, 14.0],
          [4.380197, 52.189121, 15.0],
          [4.380233, 52.189237, 15.25],
          [4.380291, 52.189363, 15.25],
          [4.380500, 52.189690, 15.25],
          [4.380750, 52.189960, 15.0],
          [4.381035, 52.190186, 14.5],
          [4.381344, 52.190392, 14.5],
          [4.381499, 52.190486, 14.75],
          [4.381618, 52.190540, 15.0],
          [4.381962, 52.190679, 15.0],
          [4.382224, 52.190806, 14.75],
          [4.382397, 52.190917, 14.5],
          [4.382513, 52.191029, 14.25],
          [4.382599, 52.191142, 14.25],
          [4.382714, 52.191236, 14.0],
          [4.383350, 52.191639, 13.75],
          [4.383682, 52.191831, 13.5],
          [4.383991, 52.191968, 12.75],
          [4.384068, 52.191989, 12.5],
          [4.384244, 52.191996, 12.0],
          [4.384397, 52.192016, 11.5],
          [4.384450, 52.192044, 11.25],
          [4.384490, 52.192089, 11.25],
          [4.384507, 52.192153, 11.25],
          [4.384520, 52.192253, 11.25],
          [4.384538, 52.192286, 11.0],
          [4.384975, 52.192609, 9.25],
          [4.385313, 52.192776, 8.75],
          [4.386036, 52.193146, 7.75],
          [4.386156, 52.193239, 7.5],
          [4.386229, 52.193365, 7.5],
          [4.386262, 52.193724, 7.25],
          [4.386302, 52.193948, 7.25],
          [4.386361, 52.194086, 7.0],
          [4.386447, 52.194228, 6.75],
          [4.386603, 52.194378, 6.75],
          [4.386956, 52.194693, 7.5],
          [4.386995, 52.194836, 7.75],
          [4.386980, 52.195207, 8.5],
          [4.387021, 52.195328, 8.75],
          [4.386862, 52.195376, 9.0],
          [4.386907, 52.195443, 9.25],
          [4.386479, 52.195583, 10.0],
          [4.386112, 52.195718, 10.25],
          [4.386029, 52.195775, 10.25],
          [4.385968, 52.195847, 10.0],
          [4.385933, 52.195967, 9.0],
          [4.385965, 52.196065, 8.5],
          [4.386386, 52.196697, 8.5],
          [4.387668, 52.198055, 5.5],
          [4.388425, 52.198868, 6.75],
          [4.389060, 52.199560, 6.75],
          [4.389291, 52.199789, 6.5],
          [4.389700, 52.200100, 6.5],
          [4.390200, 52.200400, 9.25],
          [4.390363, 52.200529, 9.0],
          [4.390599, 52.200714, 8.75],
          [4.390695, 52.200824, 8.5],
          [4.391195, 52.201395, 7.25],
          [4.391252, 52.201471, 7.25],
          [4.391744, 52.202138, 6.25],
          [4.391902, 52.202390, 5.5],
          [4.391938, 52.202484, 5.25],
          [4.391958, 52.202572, 5.25],
          [4.392133, 52.202877, 5.0],
          [4.392223, 52.202984, 5.0],
          [4.392319, 52.203088, 5.0],
          [4.393162, 52.203983, 6.5],
          [4.393582, 52.204450, 7.0],
          [4.393610, 52.204488, 7.0],
          [4.393641, 52.204569, 7.0],
          [4.393658, 52.204680, 7.0],
          [4.393652, 52.204764, 6.75],
          [4.393671, 52.204814, 6.75],
          [4.393694, 52.204846, 6.75],
          [4.393792, 52.204929, 7.0],
          [4.394227, 52.205255, 7.25],
          [4.394256, 52.205277, 7.25],
          [4.394363, 52.205357, 7.25],
          [4.394384, 52.205373, 7.25],
          [4.394422, 52.205400, 7.25],
          [4.394579, 52.205539, 7.5],
          [4.394813, 52.205804, 7.25],
          [4.395162, 52.206199, 7.5],
          [4.395267, 52.206318, 7.5],
          [4.395778, 52.206899, 7.5],
          [4.395853, 52.207001, 6.75],
          [4.395969, 52.207158, 6.75],
          [4.396393, 52.207641, 6.75],
          [4.396677, 52.207991, 9.25],
          [4.396747, 52.208077, 9.25],
          [4.397326, 52.208811, 9.0],
          [4.397410, 52.208919, 9.0],
          [4.397604, 52.209231, 8.75],
          [4.397711, 52.209378, 8.25],
          [4.397827, 52.209455, 8.25],
          [4.397976, 52.209515, 8.5],
          [4.398185, 52.209551, 9.0],
          [4.398360, 52.209543, 9.5],
          [4.398480, 52.209521, 9.5],
          [4.398682, 52.209524, 9.25],
          [4.399160, 52.209379, 9.25],
          [4.399388, 52.209652, 8.5],
          [4.399596, 52.209901, 8.0],
          [4.399755, 52.210034, 7.75],
          [4.400431, 52.210472, 4.25],
          [4.401198, 52.210918, 4.5],
          [4.401386, 52.211033, 5.75],
          [4.401525, 52.211117, 7.0],
          [4.401653, 52.211157, 8.0],
          [4.401997, 52.211262, 9.25],
          [4.402131, 52.211312, 9.5],
          [4.402214, 52.211361, 10.0],
          [4.402324, 52.211461, 10.75],
          [4.402410, 52.211546, 11.25],
          [4.402338, 52.211571, 11.5],
          [4.402297, 52.211586, 11.5],
          [4.402835, 52.212087, 11.0],
          [4.402892, 52.212186, 11.0],
          [4.402905, 52.212246, 11.0],
          [4.402958, 52.212318, 10.75],
          [4.403068, 52.212378, 10.5],
          [4.403090, 52.212415, 10.5],
          [4.403076, 52.212470, 10.5],
          [4.403032, 52.212512, 10.5],
          [4.402980, 52.212570, 10.75],
          [4.403086, 52.213007, 11.5],
          [4.403142, 52.213197, 11.75],
          [4.403191, 52.213308, 12.0],
          [4.403294, 52.213435, 12.0],
          [4.403394, 52.213529, 12.25],
          [4.403577, 52.213654, 12.25],
          [4.403671, 52.213748, 12.25],
          [4.403833, 52.214162, 12.75],
          [4.403905, 52.214264, 12.5],
          [4.404159, 52.214529, 12.0],
          [4.404521, 52.214784, 11.25],
          [4.405098, 52.215148, 11.25],
          [4.405203, 52.215273, 11.75],
          [4.405546, 52.215785, 13.75],
          [4.405706, 52.216076, 13.5],
          [4.405759, 52.216293, 13.25],
          [4.405863, 52.216424, 13.25],
          [4.405994, 52.216563, 12.75],
          [4.406194, 52.216739, 12.25],
          [4.406508, 52.216964, 12.0],
          [4.406782, 52.217190, 12.5],
          [4.407016, 52.217411, 12.75],
          [4.407132, 52.217590, 13.0],
          [4.407218, 52.217746, 13.0],
          [4.407326, 52.217868, 13.0],
          [4.407479, 52.217978, 13.0],
          [4.407677, 52.218083, 12.75],
          [4.408398, 52.218338, 12.0],
          [4.408623, 52.218445, 12.25],
          [4.408686, 52.218492, 12.25],
          [4.408748, 52.218538, 12.25],
          [4.408829, 52.218651, 12.5],
          [4.408848, 52.218756, 12.75],
          [4.408814, 52.218863, 13.0],
          [4.408687, 52.219053, 13.75],
          [4.408634, 52.219177, 14.25],
          [4.408635, 52.219289, 14.5],
          [4.408671, 52.219403, 14.5],
          [4.408963, 52.219782, 15.25],
          [4.409108, 52.219928, 15.75],
          [4.409724, 52.220423, 14.0],
          [4.410432, 52.220976, 14.5],
          [4.411206, 52.221725, 13.5],
          [4.411900, 52.222446, 15.25],
          [4.412723, 52.223296, 14.0],
          [4.413028, 52.223644, 12.75],
          [4.413247, 52.223929, 12.0],
          [4.413568, 52.224554, 13.25],
          [4.413702, 52.224761, 13.75],
          [4.414127, 52.225176, 14.25],
          [4.414432, 52.225430, 14.5],
          [4.414782, 52.225671, 15.25],
          [4.415349, 52.225983, 16.0],
          [4.415504, 52.226096, 16.25],
          [4.415620, 52.226208, 16.25],
          [4.415738, 52.226349, 16.5],
          [4.415902, 52.226600, 16.75],
          [4.415963, 52.226806, 16.75],
          [4.415976, 52.227009, 16.75],
          [4.416018, 52.227184, 17.0],
          [4.416080, 52.227306, 17.0],
          [4.416167, 52.227411, 17.25],
          [4.416634, 52.227835, 17.25],
          [4.416772, 52.227970, 17.25],
          [4.416905, 52.228118, 17.25],
          [4.417051, 52.228397, 16.75],
          [4.417121, 52.228579, 16.75],
          [4.417218, 52.228761, 16.75],
          [4.417341, 52.228908, 16.75],
          [4.417573, 52.229096, 17.0],
          [4.418129, 52.229438, 18.0],
          [4.418155, 52.229497, 18.25],
          [4.418152, 52.229542, 18.0],
          [4.418100, 52.229600, 17.75],
          [4.418001, 52.229647, 16.75],
          [4.417800, 52.229721, 14.75],
          [4.417647, 52.229790, 13.0],
          [4.417588, 52.229853, 12.0],
          [4.417575, 52.229931, 11.25],
          [4.417600, 52.230000, 11.0],
          [4.417663, 52.230077, 11.0],
          [4.417778, 52.230169, 11.0],
          [4.418256, 52.230593, 11.0],
          [4.418375, 52.230714, 17.25],
          [4.418829, 52.231212, 15.0],
          [4.419052, 52.231554, 13.25],
          [4.419250, 52.231896, 11.5],
          [4.419328, 52.232003, 11.25],
          [4.419614, 52.232356, 11.75],
          [4.419830, 52.232541, 11.75],
          [4.419900, 52.232600],
          [4.420182, 52.232995, 15.0],
          [4.420300, 52.233115, 15.0],
          [4.420389, 52.233166, 15.0],
          [4.420348, 52.233194, 15.0],
          [4.420339, 52.233211, 15.0],
          [4.420342, 52.233245, 15.0],
          [4.420378, 52.233278, 15.0],
          [4.420408, 52.233289, 15.0],
          [4.420473, 52.233292, 15.0],
          [4.420532, 52.233272, 15.0],
          [4.420549, 52.233257, 15.0],
          [4.420698, 52.233317, 15.0],
          [4.420879, 52.233527, 14.5],
          [4.421415, 52.234151, 15.75],
          [4.421541, 52.234300, 15.75],
          [4.422159, 52.235033, 14.5],
          [4.422622, 52.235556, 14.75],
          [4.422814, 52.235781, 15.25],
          [4.422989, 52.235987, 15.5],
          [4.423991, 52.237136, 15.0],
          [4.424063, 52.237213, 15.0],
          [4.424371, 52.237578, 15.25],
          [4.424405, 52.237616, 15.25],
          [4.424657, 52.237918, 15.5],
          [4.424692, 52.237959, 15.5],
          [4.425037, 52.238369, 17.75],
          [4.425147, 52.238499, 17.25],
          [4.425439, 52.238846, 16.75],
          [4.425830, 52.239306, 16.75],
          [4.425947, 52.239451, 14.75],
          [4.426418, 52.240007, 16.0],
          [4.426479, 52.240038, 16.75],
          [4.426538, 52.240050, 17.5],
          [4.426677, 52.240062, 19.0],
          [4.427000, 52.240100, 19.0],
          [4.427224, 52.240147, 19.0],
          [4.427433, 52.240194, 19.0],
          [4.428169, 52.240434, 21.0],
          [4.428587, 52.240569, 21.0],
          [4.429300, 52.240800, 17.5],
          [4.429867, 52.241095, 13.25],
          [4.429933, 52.241131, 12.75],
          [4.430080, 52.241208, 12.25],
          [4.430237, 52.241301, 12.25],
          [4.430261, 52.241314, 12.25],
          [4.430726, 52.241592, 12.75],
          [4.430781, 52.241624, 12.75],
          [4.430737, 52.241657, 12.75],
          [4.430482, 52.241851, 12.25],
          [4.430228, 52.242094, 11.25],
          [4.430143, 52.242126, 11.25],
          [4.430051, 52.242225, 10.75],
          [4.429855, 52.242436, 10.75],
          [4.429582, 52.242767, 10.5],
          [4.429436, 52.242943, 10.0],
          [4.429387, 52.243034, 9.5],
          [4.429378, 52.243106, 9.25],
          [4.429034, 52.243204, 8.75],
          [4.428769, 52.243303, 8.0],
          [4.428697, 52.243337, 8.0],
          [4.428635, 52.243391, 8.0],
          [4.428621, 52.243448, 8.0],
          [4.428633, 52.243513, 8.0],
          [4.428679, 52.243577, 8.0],
          [4.429009, 52.243886, 8.0],
          [4.429112, 52.243981, 8.0],
          [4.429493, 52.244334, 8.0],
          [4.429647, 52.244485, 8.0],
          [4.429922, 52.244751, 8.0],
          [4.429986, 52.244813, 8.0],
          [4.430164, 52.244996, 6.0],
          [4.430358, 52.245188, 6.0],
          [4.430594, 52.245421, 6.0],
          [4.430642, 52.245468, 6.0],
          [4.430693, 52.245520, 6.0],
          [4.431305, 52.246140, 9.25],
          [4.431508, 52.246346, 10.75],
          [4.431557, 52.246404, 11.0],
          [4.431932, 52.246800, 11.25],
          [4.432361, 52.247276, 9.5],
          [4.432396, 52.247313, 9.25],
          [4.432760, 52.247737, 8.5],
          [4.433141, 52.248191, 7.75],
          [4.433366, 52.248458, 7.75],
          [4.433481, 52.248582, 7.75],
          [4.433646, 52.248789, 7.5],
          [4.433746, 52.248907, 7.5],
          [4.433879, 52.249061, 7.5],
          [4.434001, 52.249123, 7.75],
          [4.434150, 52.249120, 7.75],
          [4.434290, 52.249072, 8.0],
          [4.434410, 52.249032, 8.25],
          [4.434636, 52.248951, 8.5],
          [4.434734, 52.249042, 8.5],
          [4.435287, 52.249585, 8.25],
          [4.435449, 52.249745, 8.0],
          [4.436053, 52.250277, 7.75],
          [4.436316, 52.250441, 8.0],
          [4.436772, 52.250701, 8.5],
          [4.437174, 52.250928, 8.5],
          [4.437239, 52.250966, 8.5],
          [4.437606, 52.251183, 8.0],
          [4.437831, 52.251373, 7.75],
          [4.438045, 52.251577, 7.5],
          [4.438290, 52.251902, 7.0],
          [4.438385, 52.252021, 7.0],
          [4.438532, 52.252185, 7.0],
          [4.438682, 52.252373, 7.0],
          [4.438736, 52.252467, 7.0],
          [4.439094, 52.252993, 8.75],
          [4.439301, 52.253255, 9.5],
          [4.439849, 52.253759, 9.25],
          [4.441062, 52.254775, 10.25],
          [4.441515, 52.255185, 10.0],
          [4.441823, 52.255537, 10.0],
          [4.442274, 52.256106, 10.0],
          [4.442809, 52.256850, 9.25],
          [4.442915, 52.256985, 9.0],
          [4.443376, 52.257639, 8.0],
          [4.444893, 52.259713, 7.75],
          [4.445063, 52.259917, 7.75],
          [4.445120, 52.259965, 8.0],
          [4.445201, 52.259991, 8.0],
          [4.445361, 52.260007, 8.25],
          [4.445757, 52.259997, 8.75],
          [4.446228, 52.259955, 9.25],
          [4.446606, 52.259954, 9.75],
          [4.446876, 52.259960, 9.75],
          [4.447388, 52.259910, 9.75],
          [4.447660, 52.259912, 10.0],
          [4.447970, 52.259944, 10.0],
          [4.448171, 52.259989, 10.0],
          [4.447999, 52.260174, 10.0],
          [4.447919, 52.260305, 10.0],
          [4.447884, 52.260413, 10.25],
          [4.447881, 52.260488, 10.25],
          [4.447905, 52.260595, 10.25],
          [4.447959, 52.260678, 10.25],
          [4.448044, 52.260760, 10.25],
          [4.448178, 52.260855, 10.0],
          [4.448328, 52.260939, 10.0],
          [4.449313, 52.261450, 10.25],
          [4.449556, 52.261569, 10.0],
          [4.450300, 52.262000, 9.75],
          [4.450669, 52.262290, 9.5],
          [4.451152, 52.262551, 9.5],
          [4.451706, 52.262816, 9.75],
          [4.452463, 52.263102, 8.75],
          [4.453141, 52.263428, 8.75],
          [4.453335, 52.263556, 9.0],
          [4.453513, 52.263818, 9.25],
          [4.454300, 52.265200, 10.0],
          [4.455202, 52.266520, 10.75],
          [4.455738, 52.267306, 11.0],
          [4.455893, 52.267500, 10.75],
          [4.456327, 52.267996, 8.5],
          [4.456700, 52.268400, 8.0],
          [4.457100, 52.268900, 8.0],
          [4.457300, 52.269400, 7.5],
          [4.457344, 52.269533, 7.5],
          [4.457558, 52.270220, 7.5],
          [4.457815, 52.270598, 8.5],
          [4.458600, 52.271300, 10.0],
          [4.458914, 52.271631, 10.0],
          [4.459063, 52.271751, 9.75],
          [4.459444, 52.272002, 9.25],
          [4.460948, 52.272964, 8.75],
          [4.461137, 52.273126, 8.75],
          [4.461231, 52.273314, 9.0],
          [4.461694, 52.274584, 6.0],
          [4.461938, 52.275195, 7.0],
          [4.462039, 52.275397, 7.0],
          [4.462777, 52.276433, 5.5],
          [4.462810, 52.276480, 5.5],
          [4.462829, 52.276514, 5.5],
          [4.464646, 52.275333, 6.75],
          [4.465525, 52.274781, 7.5],
          [4.466667, 52.274081, 10.25],
          [4.467583, 52.273527, 13.25],
          [4.467811, 52.273359, 14.25],
          [4.467883, 52.273267, 14.5],
          [4.468161, 52.272624, 14.25],
          [4.468212, 52.272672, 14.25],
          [4.468161, 52.272624, 14.25],
          [4.468193, 52.272559, 14.25],
          [4.468326, 52.272215, 13.5],
          [4.468453, 52.271782, 12.5],
          [4.468483, 52.271497, 11.0],
          [4.468469, 52.271334, 10.0],
          [4.468297, 52.271157, 9.5],
          [4.468099, 52.270966, 9.5],
          [4.467609, 52.270418, 8.25],
          [4.467126, 52.269984, 6.25],
          [4.467103, 52.269933, 6.0],
          [4.467098, 52.269875, 5.75],
          [4.467103, 52.269852, 5.75],
          [4.467174, 52.269778, 5.25],
          [4.467268, 52.269699, 4.75],
          [4.467421, 52.269587, 4.0],
          [4.467505, 52.269533, 3.75],
          [4.467568, 52.269497, 3.5],
          [4.467629, 52.269536, 3.5],
          [4.467568, 52.269576, 3.75],
          [4.467308, 52.269742, 4.75],
          [4.467568, 52.269576, 3.75],
          [4.467505, 52.269533, 3.75],
          [4.467568, 52.269497, 3.5],
          [4.467912, 52.269296, 2.5],
          [4.468376, 52.269011, 1.25],
          [4.469007, 52.268616, 0.5],
          [4.470219, 52.267831, 1.0],
          [4.470876, 52.267394, 0.75],
          [4.470948, 52.267346, 0.75],
          [4.471023, 52.267386, 1.0],
          [4.471109, 52.267438, 1.0],
          [4.471631, 52.267759, 1.5],
          [4.472756, 52.268440, 1.0],
          [4.474551, 52.269499, 1.5],
          [4.474890, 52.269709, 1.5],
          [4.475661, 52.270237, 1.0],
          [4.476042, 52.270487, 0.5]
        ]
      }
    }
  ]
}

let day9: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "9 - Noordwijkerhout - Amsterdam - 43.3km",
        "track-length": "43264",
        "filtered ascend": "45",
        "plain-ascend": "18",
        "total-time": "7516",
        "total-energy": "708621",
        "cost": "51254",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["4479582", "52272565", "1", "157", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "20", "2056"],
          ["4485696", "52275217", "2", "522", "1050", "0", "85", "0", "0", "highway=cycleway surface=asphalt", "", "111", "11101"],
          ["4491774", "52278553", "3", "561", "1350", "0", "0", "0", "0", "highway=service surface=asphalt", "", "220", "22098"],
          ["4493308", "52279395", "3", "144", "1350", "0", "0", "0", "0", "highway=service", "barrier=gate access=permissive", "242", "24281"],
          ["4494210", "52279907", "2", "85", "1350", "0", "0", "0", "0", "highway=service", "", "255", "25569"],
          ["4495421", "52279473", "2", "98", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "", "266", "26681"],
          ["4508190", "52287164", "1", "1232", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "465", "46567"],
          ["4517600", "52283600", "-1", "866", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "596", "59645"],
          ["4519295", "52285542", "1", "248", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "643", "64345"],
          ["4524092", "52281289", "0", "690", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "747", "74734"],
          ["4525525", "52282457", "1", "164", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "781", "78139"],
          ["4535583", "52277663", "0", "891", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "929", "92936"],
          ["4543125", "52285231", "0", "1011", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "1087", "108779"],
          ["4544236", "52286548", "-1", "168", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bus_trap bicycle=yes", "1112", "111276"],
          ["4544768", "52287107", "-1", "73", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1124", "112456"],
          ["4554021", "52297845", "0", "1358", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "1362", "136302"],
          ["4554453", "52297726", "0", "34", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "1368", "136877"],
          ["4554477", "52297766", "0", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "1369", "136962"],
          ["4554501", "52297801", "0", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "1370", "137046"],
          ["4554088", "52297921", "0", "33", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "1374", "137468"],
          ["4554046", "52297876", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "1375", "137527"],
          ["4554021", "52297845", "0", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "1375", "137567"],
          ["4554453", "52297726", "0", "34", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "1379", "137949"],
          ["4554477", "52297766", "0", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "1379", "138009"],
          ["4554501", "52297801", "0", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "1380", "138070"],
          ["4568174", "52313442", "-1", "1990", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "1703", "170358"],
          ["4572208", "52312553", "0", "294", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified cycleway=shared_lane route_bicycle_rcn=yes", "", "1748", "174879"],
          ["4577396", "52313674", "0", "383", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1813", "181378"],
          ["4577472", "52313678", "0", "6", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1814", "181481"],
          ["4578000", "52313700", "0", "37", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "1820", "182050"],
          ["4588641", "52313392", "1", "733", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "1950", "195109"],
          ["4588747", "52313390", "1", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "1951", "195198"],
          ["4588863", "52314942", "1", "175", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "1975", "197608"],
          ["4592359", "52313932", "0", "265", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "2014", "201428"],
          ["4596906", "52319144", "3", "724", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "2135", "213605"],
          ["4597049", "52319245", "3", "15", "1000", "0", "0", "0", "0", "highway=unclassified oneway=yes oneway:bicycle=no route_bicycle_rcn=yes", "", "2138", "213927"],
          ["4597281", "52319442", "3", "8", "1350", "0", "0", "0", "0", "highway=unclassified oneway=yes oneway:bicycle=no", "", "2140", "214095"],
          ["4597049", "52319245", "3", "8", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified oneway=yes oneway:bicycle=no", "", "2141", "214169"],
          ["4597457", "52318848", "3", "54", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "2147", "214755"],
          ["4597517", "52318767", "3", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "2148", "214876"],
          ["4597585", "52318705", "3", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "2149", "214987"],
          ["4597749", "52318585", "3", "18", "1000", "0", "0", "0", "0", "reversedirection=yes highway=living_street surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "2151", "215217"],
          ["4598760", "52317687", "1", "126", "1000", "0", "0", "0", "0", "reversedirection=yes highway=living_street surface=paving_stones oneway=yes oneway:bicycle=no smoothness=intermediate route_bicycle_rcn=yes", "", "2168", "216831"],
          ["4598897", "52317638", "1", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "2169", "216960"],
          ["4599439", "52317410", "0", "47", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "2174", "217494"],
          ["4605258", "52315904", "0", "448", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "2243", "224352"],
          ["4607909", "52318075", "0", "321", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "2286", "228719"],
          ["4609708", "52317507", "0", "138", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "2312", "231275"],
          ["4609600", "52317390", "0", "15", "1350", "0", "93", "0", "0", "reversedirection=yes highway=unclassified", "", "2314", "231502"],
          ["4610710", "52317042", "0", "18", "5050", "0", "93", "0", "0", "reversedirection=yes highway=footway", "", "2327", "231577"],
          ["4609600", "52317390", "0", "18", "5050", "0", "0", "0", "0", "highway=footway", "", "2339", "231577"],
          ["4609708", "52317507", "0", "15", "1350", "0", "93", "0", "0", "highway=unclassified", "", "2340", "231748"],
          ["4610248", "52317307", "-1", "44", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "2345", "232230"],
          ["4610707", "52317801", "0", "64", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "2355", "233212"],
          ["4610962", "52318128", "0", "41", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "2362", "233902"],
          ["4611431", "52317985", "0", "37", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "2368", "234491"],
          ["4611499", "52317973", "0", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "", "2369", "234581"],
          ["4611992", "52317976", "0", "34", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "2374", "235104"],
          ["4612207", "52318069", "0", "23", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "2377", "235436"],
          ["4631021", "52337124", "0", "2734", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_rcn=yes", "", "2830", "280716"],
          ["4632876", "52337578", "1", "145", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane oneway=yes oneway:bicycle=no route_bicycle_rcn=yes", "", "2857", "283445"],
          ["4636028", "52337969", "0", "222", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane route_bicycle_rcn=yes", "", "2892", "286964"],
          ["4636751", "52337760", "0", "55", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes route_bicycle_rcn=yes", "", "2901", "287846"],
          ["4637001", "52337096", "0", "10", "1050", "0", "20", "0", "0", "highway=cycleway surface=asphalt foot=yes", "", "2903", "288005"],
          ["4636751", "52337760", "0", "10", "1050", "0", "4", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes", "", "2904", "288098"],
          ["4636825", "52337748", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "2904", "288156"],
          ["4636927", "52337758", "0", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "2905", "288236"],
          ["4637178", "52337793", "0", "18", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "2907", "288423"],
          ["4637770", "52338244", "0", "70", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes route_bicycle_rcn=yes", "", "2916", "289325"],
          ["4647815", "52339678", "-2", "711", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=shared_lane route_bicycle_rcn=yes", "", "3022", "299943"],
          ["4647559", "52340053", "-2", "51", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=designated bicycle=designated route_bicycle_rcn=yes", "", "3028", "300492"],
          ["4647544", "52340080", "-3", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_rcn=yes", "", "3028", "300537"],
          ["4651698", "52341685", "-1", "341", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_rcn=yes", "", "3086", "306356"],
          ["4657902", "52348043", "-2", "1158", "1000", "0", "0", "0", "0", "highway=cycleway foot=designated bicycle=designated route_bicycle_rcn=yes", "", "3296", "327311"],
          ["4669520", "52352885", "0", "998", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "3467", "344434"],
          ["4669018", "52355607", "0", "341", "1050", "0", "108", "0", "0", "reversedirection=yes highway=cycleway foot=designated bicycle=designated", "", "3519", "349600"],
          ["4670166", "52355676", "0", "81", "1350", "0", "123", "0", "0", "highway=unclassified", "", "3530", "350738"],
          ["4670136", "52355744", "0", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3531", "350852"],
          ["4670115", "52355799", "0", "7", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3532", "350953"],
          ["4669814", "52356488", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3533", "351040"],
          ["4670115", "52355799", "0", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3534", "351096"],
          ["4670136", "52355744", "0", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3534", "351163"],
          ["4670166", "52355676", "0", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3535", "351241"],
          ["4676031", "52354071", "-1", "503", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3609", "358580"],
          ["4670166", "52355676", "0", "503", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3690", "366751"],
          ["4670136", "52355744", "0", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3692", "366885"],
          ["4670115", "52355799", "0", "7", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3693", "367003"],
          ["4666877", "52364555", "2", "1047", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3883", "386011"],
          ["4666862", "52364616", "2", "7", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3884", "386147"],
          ["4666157", "52367549", "0", "332", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3937", "391429"],
          ["4666133", "52367674", "0", "15", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3939", "391679"],
          ["4666107", "52367809", "0", "16", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "3942", "391931"],
          ["4666109", "52367889", "0", "9", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_rcn=yes", "", "3943", "392074"],
          ["4664254", "52367881", "0", "14", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes route_bicycle_rcn=yes", "", "3946", "392284"],
          ["4666109", "52367889", "0", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_rcn=yes", "", "3947", "392421"],
          ["4666107", "52367809", "0", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_rcn=yes", "", "3948", "392513"],
          ["4671762", "52368099", "1", "392", "1650", "0", "92", "0", "0", "highway=secondary bicycle=use_sidepath", "", "4011", "398826"],
          ["4672998", "52368266", "1", "28", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=use_sidepath", "", "4016", "399301"],
          ["4671762", "52368099", "1", "28", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt bicycle=use_sidepath", "", "4018", "399573"],
          ["4666107", "52367809", "0", "392", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary bicycle=use_sidepath", "", "4073", "405012"],
          ["4666133", "52367674", "0", "16", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "4076", "405294"],
          ["4671260", "52371092", "0", "772", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4209", "418615"],
          ["4671171", "52371104", "0", "7", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4210", "418720"],
          ["4673710", "52375246", "0", "518", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4292", "426923"],
          ["4680472", "52382870", "1", "1001", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4472", "444959"],
          ["4679970", "52382874", "1", "28", "1050", "0", "93", "0", "0", "highway=cycleway surface=asphalt", "", "4477", "445482"],
          ["4680472", "52382870", "1", "28", "1050", "0", "1", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt", "", "4480", "445763"],
          ["4688519", "52383351", "1", "565", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4569", "454657"],
          ["4695350", "52383877", "0", "477", "1050", "0", "2", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes", "", "4644", "462173"],
          ["4700324", "52383954", "0", "345", "1050", "0", "14", "0", "0", "reversedirection=yes highway=cycleway foot=designated", "", "4703", "468040"],
          ["4735846", "52385911", "0", "2601", "1050", "0", "87", "0", "0", "highway=cycleway foot=yes oneway=no", "highway=traffic_signals traffic_signals:direction=forward", "5137", "511406"],
          ["4735940", "52385967", "0", "9", "1050", "0", "2", "0", "0", "highway=cycleway foot=yes oneway=no", "", "5138", "511570"],
          ["4736178", "52386112", "0", "24", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt", "highway=traffic_signals traffic_signals:direction=backward", "5143", "512013"],
          ["4736327", "52386204", "0", "15", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt", "", "5146", "512296"],
          ["4736996", "52386209", "0", "46", "1050", "0", "26", "0", "0", "highway=cycleway", "", "5154", "513185"],
          ["4745489", "52385669", "1", "589", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified", "", "5260", "523765"],
          ["4745611", "52385655", "1", "9", "1050", "0", "0", "0", "0", "highway=cycleway", "highway=traffic_signals traffic_signals:direction=forward", "5262", "523937"],
          ["4745829", "52385628", "1", "16", "1050", "0", "0", "0", "0", "highway=cycleway", "", "5265", "524259"],
          ["4745861", "52385731", "1", "12", "1350", "0", "94", "0", "0", "highway=unclassified bicycle=use_sidepath oneway=yes", "", "5267", "524480"],
          ["4754258", "52383831", "0", "640", "7050", "0", "95", "0", "0", "highway=primary surface=asphalt bicycle=no oneway=yes", "highway=crossing bicycle=yes crossing=traffic_signals", "5718", "528868"],
          ["4754244", "52383753", "0", "9", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_rcn=yes", "", "5720", "529006"],
          ["4754606", "52383739", "0", "25", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "5724", "529376"],
          ["4756301", "52383668", "1", "117", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "5744", "531428"],
          ["4758851", "52383668", "2", "177", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "5777", "534696"],
          ["4758919", "52383668", "1", "5", "1050", "0", "15", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "highway=traffic_signals traffic_signals:direction=backward", "5778", "534781"],
          ["4759023", "52383667", "1", "8", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "", "5779", "534917"],
          ["4759132", "52383667", "1", "8", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service access=destination foot=yes bicycle=designated", "highway=traffic_signals traffic_signals:direction=forward", "5780", "535052"],
          ["4759957", "52383680", "0", "57", "1350", "0", "3", "0", "0", "reversedirection=yes highway=service access=destination foot=yes bicycle=designated", "", "5788", "535820"],
          ["4769809", "52383736", "-1", "679", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=excellent", "", "5891", "546159"],
          ["4793843", "52383884", "0", "1753", "1050", "0", "48", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "", "6171", "574166"],
          ["4793953", "52381717", "0", "26", "1050", "0", "161", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent", "", "6176", "574640"],
          ["4793843", "52383884", "0", "26", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=excellent", "", "6179", "574891"],
          ["4794299", "52384140", "0", "44", "1050", "0", "19", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "", "6184", "575375"],
          ["4802848", "52384141", "0", "585", "1050", "0", "9", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "6273", "584348"],
          ["4803038", "52384148", "0", "13", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "", "6275", "584560"],
          ["4803446", "52384156", "0", "29", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "", "6280", "585036"],
          ["4818361", "52384231", "0", "1023", "1050", "0", "1", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no", "", "6463", "603372"],
          ["4818570", "52384234", "0", "15", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "highway=traffic_signals traffic_signals:direction=forward", "6466", "603589"],
          ["4818635", "52384234", "0", "5", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "highway=crossing bicycle=yes crossing=traffic_signals", "6466", "603663"],
          ["4818825", "52384237", "0", "13", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "highway=crossing bicycle=yes crossing=traffic_signals", "6468", "603856"],
          ["4819006", "52384244", "0", "13", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "highway=traffic_signals traffic_signals:direction=backward", "6470", "604052"],
          ["4819129", "52384249", "0", "9", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "", "6472", "604189"],
          ["4834148", "52384595", "2", "1029", "1050", "0", "3", "0", "0", "highway=cycleway oneway=no", "", "6647", "621747"],
          ["4835035", "52384605", "3", "62", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "", "6661", "623112"],
          ["4838482", "52384691", "1", "240", "1050", "0", "0", "0", "0", "highway=cycleway oneway=no", "", "6698", "626843"],
          ["4839933", "52384710", "0", "106", "1050", "0", "27", "0", "0", "highway=cycleway oneway=yes", "", "6714", "628461"],
          ["4839959", "52384710", "0", "2", "1050", "0", "4", "0", "0", "highway=cycleway oneway=no", "", "6715", "628490"],
          ["4840021", "52384707", "0", "5", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "", "6715", "628561"],
          ["4843653", "52384731", "6", "251", "1050", "0", "2", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "", "6785", "635486"],
          ["4843731", "52384717", "5", "6", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=no smoothness=intermediate", "highway=traffic_signals traffic_signals:direction=forward", "6786", "635603"],
          ["4843958", "52384720", "5", "17", "1050", "0", "4", "0", "0", "highway=cycleway surface=paving_stones oneway=no smoothness=intermediate", "highway=traffic_signals traffic_signals:direction=backward", "6789", "635891"],
          ["4845218", "52384737", "1", "86", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=no smoothness=intermediate", "highway=traffic_signals traffic_signals:direction=forward", "6797", "636741"],
          ["4845434", "52384741", "1", "15", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=no smoothness=intermediate", "highway=traffic_signals traffic_signals:direction=backward", "6799", "636918"],
          ["4847226", "52384764", "2", "127", "1050", "0", "11", "0", "0", "highway=cycleway surface=paving_stones oneway=no smoothness=intermediate", "", "6818", "638876"],
          ["4847284", "52384602", "2", "19", "1050", "0", "70", "0", "0", "highway=cycleway surface=asphalt smoothness=good", "", "6820", "639065"],
          ["4847283", "52384518", "2", "10", "1050", "0", "2", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good", "", "6821", "639170"],
          ["4847399", "52384198", "2", "38", "1050", "0", "3", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "6826", "639604"],
          ["4851008", "52382599", "4", "306", "1050", "0", "8", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes smoothness=intermediate", "highway=crossing", "6880", "645039"],
          ["4851196", "52382507", "4", "17", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes smoothness=intermediate", "", "6883", "645328"],
          ["4851363", "52382454", "4", "14", "1050", "0", "4", "0", "0", "highway=cycleway oneway=yes", "", "6885", "645565"],
          ["4854338", "52380752", "3", "278", "1050", "0", "8", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "highway=crossing bicycle=yes horse=no crossing=traffic_signals", "6927", "649691"],
          ["4854693", "52380541", "4", "38", "1050", "0", "1", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "highway=crossing", "6933", "650376"],
          ["4858394", "52374714", "4", "723", "1050", "0", "32", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "highway=traffic_signals", "7055", "662557"],
          ["4859444", "52371516", "4", "376", "1050", "0", "171", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "7129", "669984"],
          ["4859521", "52371430", "4", "12", "1050", "0", "23", "0", "0", "highway=cycleway oneway=yes smoothness=good", "", "7131", "670151"],
          ["4859852", "52371411", "4", "25", "1050", "0", "66", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "", "7135", "670499"],
          ["4859915", "52371402", "4", "5", "1050", "0", "1", "0", "0", "highway=cycleway surface=asphalt smoothness=good", "highway=crossing", "7135", "670569"],
          ["4859988", "52371397", "4", "6", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good", "", "7136", "670653"],
          ["4864502", "52370252", "4", "343", "1050", "0", "16", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "7189", "675949"],
          ["4865274", "52370002", "5", "61", "1650", "0", "9", "0", "0", "highway=secondary surface=asphalt oneway=yes smoothness=good", "", "7203", "677308"],
          ["4870118", "52370815", "4", "360", "1050", "0", "15", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "highway=traffic_signals", "7265", "683565"],
          ["4870267", "52370846", "3", "12", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "7267", "683751"],
          ["4870237", "52370737", "4", "14", "1050", "0", "126", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "highway=crossing", "7270", "683995"],
          ["4872099", "52367090", "6", "438", "1050", "0", "4", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "highway=crossing", "7354", "692424"],
          ["4875172", "52362708", "5", "544", "1050", "0", "9", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "railway=unknown", "7444", "701488"],
          ["4877051", "52360090", "4", "322", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "", "7495", "706491"],
          ["4877254", "52360132", "4", "16", "1150", "0", "90", "0", "0", "highway=residential surface=asphalt", "", "7497", "706771"],
          ["4882197", "52361412", "4", "113", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "", "7516", "708635"]
        ],
        "times": [0, 3.647, 10.131, 18.161, 20.566, 21.942, 23.657, 37.164, 42.95, 56.258, 62.425, 66.52, 95.154, 111.002, 126.545, 130.169, 145.773, 186.806, 189.708, 205.717, 209.195, 210.357, 220.957, 221.871, 227.917, 236.269, 238.66, 242.783, 254.921, 255.66, 257.92, 260.945, 264.384, 266.776, 330.992, 357.929, 366.415, 404.643, 406.091, 409.53, 423.334, 446.671, 455.707, 464.286, 465.606, 467.938, 472.032, 472.279, 474.044, 476.389, 479.097, 481.859, 490.338, 499.646, 527.534, 537.543, 538.925, 542.974, 544.551, 546.614, 550.299, 553.694, 565.503, 569.73, 575.08, 581.177, 588.884, 594.382, 595.366, 596.36, 604.921, 612.936, 618.872, 627.312, 643.357, 645.399, 646.759, 663.223, 666.745, 667.621, 675.877, 678.386, 687.47, 691.71, 708.506, 708.594, 711.637, 717.357, 747.248, 771.643, 778.888, 781.291, 782.257, 784.196, 792.896, 800.318, 821.366, 825.46, 849.642, 855.027, 857.274, 907.245, 920.953, 922.903, 924.842, 926.421, 929.214, 932.337, 934.583, 935.272, 936.439, 939.03, 939.738, 940.458, 978.464, 1072.116, 1076.507, 1082.57, 1086.08, 1087.628, 1088.654, 1091.616, 1095.99, 1104.92, 1112.594, 1124.389, 1125.371, 1158.443, 1184.095, 1186.309, 1197.84, 1208.683, 1260.513, 1292.838, 1327.364, 1338.838, 1351.255, 1358.422, 1362.837, 1363.314, 1367.055, 1368.582, 1369.43, 1370.278, 1371.709, 1372.986, 1374.209, 1374.49, 1375.085, 1375.489, 1375.796, 1378.25, 1379.305, 1379.903, 1380.511, 1390.221, 1399.966, 1412.104, 1474.986, 1505.372, 1551.295, 1579.757, 1582.516, 1610.318, 1630.607, 1664.154, 1678.08, 1682.823, 1693.357, 1703.355, 1711.375, 1719.247, 1727.884, 1748.567, 1754.259, 1763.947, 1770.24, 1775.475, 1782.254, 1792.361, 1805.028, 1811.471, 1813.548, 1814.584, 1820.274, 1839.472, 1849.606, 1862.536, 1883.764, 1886.155, 1890.072, 1945.426, 1946.198, 1949.972, 1950.839, 1951.73, 1961.804, 1964.325, 1975.823, 1977.142, 1994.698, 2014.024, 2025.642, 2031.715, 2035.859, 2042.174, 2046.508, 2050.014, 2057.439, 2062.54, 2066.012, 2075.187, 2078.073, 2080.981, 2087.671, 2089.972, 2091.619, 2093.204, 2096.006, 2100.177, 2107.77, 2110.085, 2122.942, 2126.444, 2135.77, 2138.996, 2140.671, 2141.416, 2144.978, 2147.277, 2148.48, 2149.592, 2151.893, 2157.618, 2162.357, 2166.827, 2168.025, 2169.318, 2170.988, 2174.659, 2179.602, 2182.589, 2188.02, 2192.874, 2198.719, 2200.012, 2209.294, 2209.591, 2210.859, 2212.484, 2215.131, 2216.373, 2217.954, 2219.464, 2220.756, 2224.003, 2225.451, 2226.919, 2234.388, 2236.635, 2238.302, 2243.223, 2244.57, 2245.126, 2245.793, 2246.647, 2255.585, 2258.783, 2264.212, 2264.478, 2265.761, 2286.896, 2312.454, 2314.717, 2327.325, 2339.106, 2340.816, 2342.41, 2345.629, 2355.458, 2362.354, 2366.637, 2368.239, 2368.692, 2369.145, 2374.375, 2375.256, 2376.144, 2377.412, 2377.696, 2379.217, 2398.944, 2416.203, 2423.046, 2442.893, 2475.724, 2478.57, 2484.115, 2491.444, 2497.703, 2504.55, 2511.459, 2517.385, 2519.806, 2530.035, 2568.474, 2596.164, 2611.472, 2627.089, 2636.734, 2645.586, 2652.668, 2656.57, 2665.283, 2670.579, 2673.175, 2680.057, 2687.046, 2720.123, 2777.763, 2809.781, 2815.599, 2825.947, 2827.786, 2830.464, 2832.305, 2833.143, 2835.464, 2838.299, 2844.18, 2849.271, 2857.752, 2867.975, 2891.466, 2892.948, 2896.748, 2901.763, 2902.715, 2903.352, 2903.721, 2904.287, 2904.867, 2905.662, 2907.54, 2908.414, 2908.764, 2909.475, 2914.334, 2916.552, 2927.875, 2931.773, 2932.323, 2935.639, 2949.873, 2970.169, 2990.755, 3009.605, 3010.888, 3018.067, 3021.115, 3022.728, 3023.124, 3023.424, 3023.831, 3028.225, 3028.675, 3036.199, 3043.603, 3052.758, 3065.124, 3080.208, 3083.466, 3086.506, 3086.861, 3087.925, 3088.202, 3090.39, 3091.047, 3091.722, 3092.881, 3095.194, 3103.345, 3106.745, 3109.145, 3111.755, 3114.446, 3117.784, 3120.348, 3124.232, 3127.323, 3130.078, 3133.177, 3137.915, 3184.4, 3186.204, 3189.473, 3194.041, 3197.247, 3198.706, 3202.64, 3212.414, 3217.478, 3224.042, 3236.695, 3244.167, 3247.836, 3250.405, 3255.657, 3258.333, 3270.834, 3284.896, 3289.866, 3291.853, 3293.564, 3296.378, 3296.854, 3297.323, 3298.638, 3299.424, 3300.008, 3330.918, 3332.238, 3350.871, 3352.983, 3355.588, 3375.991, 3393.572, 3405.399, 3411.306, 3427.438, 3439.029, 3451.018, 3465.382, 3467.564, 3467.771, 3469.709, 3470.496, 3476.462, 3480.892, 3488.753, 3496.859, 3500.137, 3503.182, 3512.611, 3514.997, 3515.568, 3517.155, 3517.885, 3519.211, 3520.851, 3526.808, 3527.529, 3530.588, 3531.729, 3532.738, 3533.611, 3534.167, 3534.834, 3535.62, 3539.115, 3552.006, 3558.688, 3561.107, 3562.24, 3564.145, 3565.253, 3566.904, 3574.007, 3590.799, 3608.467, 3609.007, 3609.275, 3618.898, 3647.909, 3653.373, 3654.799, 3655.696, 3657.26, 3658.269, 3660.464, 3666.815, 3685.175, 3690.707, 3692.049, 3693.223, 3704.973, 3710.58, 3726.84, 3758.444, 3761.437, 3764.234, 3769.816, 3774.935, 3779.681, 3787.476, 3791.494, 3793.613, 3796.046, 3805.394, 3833.258, 3835.752, 3876.256, 3883.289, 3884.646, 3914.075, 3921.929, 3922.8, 3937.462, 3939.969, 3942.487, 3943.914, 3946.018, 3947.385, 3948.304, 3950.68, 3961.294, 3971.806, 3977.164, 3983.571, 3992.608, 4011.42, 4015.5, 4016.179, 4016.548, 4018.894, 4031.067, 4036.537, 4040.543, 4044.467, 4055.406, 4069.631, 4073.27, 4076.096, 4078.201, 4094.555, 4116.938, 4132.501, 4135.257, 4137.317, 4140.056, 4144.15, 4145.853, 4147.552, 4149.25, 4150.88, 4154.322, 4156.015, 4182.305, 4188.188, 4193.699, 4199.779, 4209.292, 4210.338, 4216.981, 4218.627, 4235.919, 4244.625, 4247.609, 4249.439, 4250.969, 4259.569, 4263.554, 4265.562, 4268.886, 4271.161, 4277.917, 4282.383, 4287.822, 4292.366, 4302.751, 4311.616, 4316.235, 4317.873, 4324.851, 4330.444, 4354.616, 4356.835, 4365.752, 4367.647, 4371.261, 4377.836, 4380.473, 4385.726, 4391.974, 4397.292, 4416.381, 4424.667, 4426.929, 4429.182, 4445.781, 4446.742, 4448.576, 4450.775, 4456.066, 4460.733, 4472.704, 4474.81, 4476.886, 4477.936, 4478.512, 4479.606, 4480.746, 4482.264, 4487.286, 4489.678, 4491.944, 4494.579, 4497.324, 4500.154, 4504.316, 4506.42, 4508.864, 4519.01, 4530.324, 4532.22, 4539.207, 4564.285, 4569.671, 4572.752, 4576.45, 4593.94, 4600.365, 4602.351, 4604.965, 4606.594, 4635.31, 4644.823, 4662.417, 4672.662, 4690.278, 4696.686, 4700.092, 4703.493, 4710.938, 4739.02, 4745.143, 4748.4, 4751.183, 4753.97, 4756.037, 4758.738, 4760.982, 4769.999, 4777.085, 4781.315, 4787.878, 4794.473, 4800.231, 4804.904, 4809.7, 4815.181, 4823.282, 4827.155, 4834.397, 4836.466, 4839.157, 4842.789, 4896.087, 4906.25, 4920.495, 4931.919, 4936.64, 4951.081, 4971.358, 4978.215, 4991.023, 5043.428, 5049.761, 5059.516, 5078.365, 5087.328, 5097.298, 5104.464, 5105.781, 5107.087, 5108.2, 5109.234, 5110.439, 5111.642, 5112.843, 5114.671, 5115.58, 5116.304, 5117.387, 5125.027, 5132.692, 5133.729, 5135.108, 5137.128, 5138.766, 5141.472, 5143.193, 5146.02, 5154.917, 5166.579, 5194.772, 5204.429, 5212.073, 5244.409, 5250.038, 5260.711, 5262.435, 5264.056, 5265.654, 5267.86, 5351.549, 5367.688, 5374.609, 5383.564, 5394.462, 5422.317, 5466.696, 5480.011, 5487.74, 5502.398, 5527.171, 5592.838, 5601.258, 5623.227, 5639.49, 5681.706, 5718.997, 5720.384, 5724.075, 5727.563, 5743.288, 5744.603, 5751.243, 5775.713, 5776.735, 5777.281, 5778.129, 5779.485, 5780.841, 5781.476, 5788.516, 5791.872, 5802.417, 5807.262, 5809.68, 5811.308, 5816.383, 5818.837, 5832.647, 5851.499, 5856.257, 5869.928, 5875.539, 5877.498, 5881.787, 5891.887, 5900.325, 5904.796, 5913.309, 5916.734, 5920.125, 5924.098, 5929.321, 5933.722, 5937.066, 5940.668, 5944.818, 5950.469, 5953.708, 5957.958, 5965.243, 5968.624, 5971.663, 5973.275, 5975.527, 5978.425, 5981.067, 5985.261, 5987.898, 5990.066, 5993.226, 5995.888, 5998.333, 6006.2, 6019.096, 6025.827, 6028.04, 6030.21, 6039.079, 6039.73, 6042.711, 6045.195, 6047.045, 6049.487, 6057.148, 6064.266, 6067.471, 6071.466, 6081.804, 6085.373, 6099.577, 6125.285, 6127.299, 6136.532, 6147.952, 6157.841, 6162.049, 6165.352, 6168.203, 6171.929, 6176.669, 6179.179, 6180.005, 6181.952, 6182.741, 6184.019, 6219.453, 6236.943, 6273.744, 6275.865, 6277.338, 6280.623, 6286.733, 6293.235, 6305.824, 6351.156, 6392.665, 6422.292, 6428.564, 6435.633, 6460.727, 6463.968, 6466.143, 6466.878, 6468.811, 6470.771, 6472.144, 6494.558, 6496.028, 6561.685, 6564.83, 6568.3, 6642.674, 6645.775, 6647.703, 6649.984, 6650.791, 6661.352, 6663.139, 6666.83, 6668.79, 6677.4, 6687.761, 6698.661, 6700.321, 6701.651, 6702.316, 6710.766, 6711.387, 6713.151, 6714.841, 6715.125, 6715.841, 6716.608, 6723.661, 6759.391, 6766.088, 6773.245, 6783.592, 6785.071, 6786.239, 6787.32, 6788.496, 6789.125, 6797.618, 6798.554, 6799.392, 6800.494, 6800.992, 6807.07, 6813.528, 6817.936, 6818.305, 6818.966, 6820.857, 6821.908, 6824.7, 6826.241, 6827.662, 6839, 6855.722, 6878.22, 6880.256, 6880.596, 6883.477, 6884.831, 6885.846, 6898.5, 6927.086, 6928.124, 6928.469, 6929.331, 6930.192, 6931.112, 6931.479, 6932.21, 6932.576, 6933.937, 6941.547, 6947.019, 6958.085, 6965.797, 6971.21, 6974.711, 6977.97, 6986.552, 6995.006, 7000.762, 7009.426, 7010.935, 7011.847, 7012.764, 7043.606, 7053.741, 7055.114, 7055.74, 7057.067, 7058.158, 7059.311, 7060.446, 7061.88, 7066.572, 7082.729, 7084.351, 7085.714, 7116.131, 7117.417, 7118.708, 7119.841, 7129.121, 7129.266, 7129.556, 7129.847, 7129.993, 7130.139, 7130.553, 7131.248, 7131.667, 7133.511, 7135.149, 7135.843, 7136.684, 7137.817, 7147.352, 7160.049, 7169.145, 7171.167, 7172.93, 7173.524, 7176.381, 7181.104, 7188.097, 7189.641, 7194.159, 7194.994, 7201.835, 7203.226, 7205.041, 7209.191, 7211.444, 7217.06, 7219.765, 7222.293, 7233.09, 7234.895, 7236.688, 7240.357, 7243.627, 7245.666, 7247.036, 7249.23, 7265.784, 7266.87, 7267.649, 7268.483, 7270.087, 7273.705, 7282.763, 7296.092, 7298.985, 7306.033, 7310.03, 7314.948, 7348.486, 7350.395, 7351.087, 7351.433, 7351.779, 7351.952, 7352.642, 7352.987, 7354.366, 7361.562, 7372.361, 7378.792, 7379.785, 7381.939, 7382.769, 7384.264, 7386.139, 7388.029, 7388.82, 7395.669, 7397.071, 7397.854, 7398.64, 7401.834, 7404.343, 7409.609, 7421.846, 7432.761, 7440.883, 7442.546, 7443.309, 7443.614, 7444.228, 7444.381, 7444.689, 7444.997, 7445.925, 7446.08, 7447.013, 7461.281, 7473.735, 7484.32, 7488.658, 7495.03, 7496.431, 7497.828, 7512.149, 7516.467]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [4.477839, 52.271693, 0.25],
          [4.478235, 52.271915, 0.25],
          [4.478868, 52.272191, 0.5],
          [4.479478, 52.272454, 1.25],
          [4.479582, 52.272565, 1.25],
          [4.479692, 52.272545, 1.5],
          [4.479830, 52.272558, 1.5],
          [4.480855, 52.272951, 1.25],
          [4.481370, 52.273100, 0.75],
          [4.482662, 52.273537, 0.0],
          [4.483095, 52.273751, 0.0],
          [4.483350, 52.273904, 0.0],
          [4.484971, 52.274841, 0.75],
          [4.485696, 52.275217, 2.5],
          [4.486305, 52.275533, 4.0],
          [4.486455, 52.275615, 4.25],
          [4.487100, 52.276000, 4.75],
          [4.489370, 52.277226, 5.0],
          [4.489551, 52.277326, 5.0],
          [4.490696, 52.277954, 4.5],
          [4.490910, 52.278077, 4.5],
          [4.490982, 52.278114, 4.5],
          [4.491774, 52.278553, 3.75],
          [4.491831, 52.278584, 3.75],
          [4.492277, 52.278821, 3.5],
          [4.492846, 52.279145, 3.5],
          [4.493024, 52.279234, 3.25],
          [4.493308, 52.279395, 3.25],
          [4.494166, 52.279882, 3.0],
          [4.494210, 52.279907, 2.75],
          [4.494401, 52.279839, 2.5],
          [4.494800, 52.279700, 2.25],
          [4.495183, 52.279556, 2.5],
          [4.495421, 52.279473, 2.75],
          [4.500277, 52.282235, 0.25],
          [4.501967, 52.283165, 1.0],
          [4.502523, 52.283490, 0.75],
          [4.504813, 52.284752, 1.5],
          [4.504900, 52.284800, 1.75],
          [4.505100, 52.284900, 2.0],
          [4.505936, 52.285486, 1.25],
          [4.506954, 52.286388, 2.0],
          [4.507451, 52.286743, 2.0],
          [4.508044, 52.287081, 1.5],
          [4.508190, 52.287164, 1.5],
          [4.508415, 52.287019, 1.5],
          [4.508782, 52.286811, 1.75],
          [4.508800, 52.286800, 1.75],
          [4.508983, 52.286754, 1.75],
          [4.509219, 52.286735, 2.0],
          [4.509475, 52.286733, 2.25],
          [4.509704, 52.286691, 2.5],
          [4.510671, 52.286438, 0.5],
          [4.511748, 52.286156, -0.75],
          [4.513800, 52.285600, 0.75],
          [4.514645, 52.285290, 0.0],
          [4.514750, 52.285250, 0.0],
          [4.515080, 52.285140, 0.0],
          [4.515200, 52.285100, 0.0],
          [4.515376, 52.285076, 0.0],
          [4.515708, 52.285069, 0.0],
          [4.515997, 52.285034, 0.0],
          [4.517093, 52.284743, -0.75],
          [4.517414, 52.284623, -0.5],
          [4.517759, 52.284483, 0.0],
          [4.518145, 52.284359, 0.5],
          [4.517846, 52.284003, 0.0],
          [4.517581, 52.283711, -0.75],
          [4.517559, 52.283652, -1.0],
          [4.517600, 52.283600, -1.0],
          [4.517991, 52.283946, 0.0],
          [4.518300, 52.284226, 0.75],
          [4.518522, 52.284472, 0.5],
          [4.518846, 52.284841, 0.5],
          [4.519295, 52.285542, 1.0],
          [4.519141, 52.285499, 0.75],
          [4.519039, 52.285472, 0.75],
          [4.518292, 52.284618, 0.25],
          [4.518372, 52.284449, 0.5],
          [4.518425, 52.284427, 0.5],
          [4.518963, 52.284203, 0.75],
          [4.519129, 52.284133, 0.75],
          [4.519862, 52.283851, 0.0],
          [4.520142, 52.283682, 0.0],
          [4.520956, 52.282730, -0.75],
          [4.520963, 52.282723, -1.0],
          [4.521249, 52.282491, -1.25],
          [4.521863, 52.282238, -1.0],
          [4.524092, 52.281289, 0.0],
          [4.524985, 52.282033, 1.5],
          [4.525353, 52.282377, 1.0],
          [4.525525, 52.282457, 1.0],
          [4.525595, 52.282436, 1.0],
          [4.525755, 52.282420, 1.0],
          [4.526505, 52.282082, 0.0],
          [4.527122, 52.281740, -0.75],
          [4.528278, 52.281110, 0.75],
          [4.528504, 52.280983, 1.25],
          [4.529553, 52.280356, 2.25],
          [4.529897, 52.280089, 1.25],
          [4.530064, 52.279986, 0.75],
          [4.534029, 52.278038, -0.75],
          [4.534946, 52.277668, 0.0],
          [4.535083, 52.277636, 0.0],
          [4.535234, 52.277618, 0.0],
          [4.535362, 52.277624, 0.0],
          [4.535583, 52.277663, 0.0],
          [4.535831, 52.277714, 0.0],
          [4.535999, 52.277748, 0.0],
          [4.536053, 52.277758, 0.0],
          [4.536209, 52.277789, 0.25],
          [4.536518, 52.277851, 0.75],
          [4.536586, 52.277880, 0.75],
          [4.536638, 52.277916, 0.75],
          [4.538600, 52.280100, -0.5],
          [4.542450, 52.284480, 0.0],
          [4.542640, 52.284679, 0.0],
          [4.542902, 52.284973, -0.25],
          [4.543051, 52.285156, -0.5],
          [4.543125, 52.285231, -0.5],
          [4.543163, 52.285280, -0.75],
          [4.543297, 52.285441, -1.0],
          [4.543491, 52.285708, -1.5],
          [4.543921, 52.286193, -1.5],
          [4.544236, 52.286548, -1.0],
          [4.544768, 52.287107, -1.25],
          [4.544809, 52.287150, -1.25],
          [4.546053, 52.288566, -0.5],
          [4.547103, 52.289760, -0.5],
          [4.547197, 52.289867, -0.75],
          [4.547739, 52.290484, -1.25],
          [4.548253, 52.291074, -1.75],
          [4.550456, 52.293528, -1.5],
          [4.551455, 52.294724, 0.0],
          [4.552713, 52.296227, 0.5],
          [4.553136, 52.296733, 0.75],
          [4.553569, 52.297277, 1.0],
          [4.553844, 52.297623, 0.75],
          [4.554021, 52.297845, 0.5],
          [4.554051, 52.297836, 0.5],
          [4.554333, 52.297757, 0.75],
          [4.554453, 52.297726, 0.75],
          [4.554477, 52.297766, 0.75],
          [4.554501, 52.297801, 0.75],
          [4.554391, 52.297834, 0.5],
          [4.554288, 52.297863, 0.5],
          [4.554117, 52.297912, 0.5],
          [4.554088, 52.297921, 0.25],
          [4.554046, 52.297876, 0.5],
          [4.554021, 52.297845, 0.5],
          [4.554051, 52.297836, 0.5],
          [4.554333, 52.297757, 0.75],
          [4.554453, 52.297726, 0.75],
          [4.554477, 52.297766, 0.75],
          [4.554501, 52.297801, 0.75],
          [4.554974, 52.298386, 0.75],
          [4.555466, 52.298972, 0.0],
          [4.556059, 52.299696, -0.75],
          [4.558626, 52.302835, -1.0],
          [4.559777, 52.304213, -0.5],
          [4.561462, 52.306307, 0.0],
          [4.562758, 52.307862, -1.25],
          [4.562873, 52.307997, -1.25],
          [4.563851, 52.309190, -0.5],
          [4.564637, 52.310084, -0.25],
          [4.565987, 52.311787, -0.75],
          [4.566562, 52.312478, -1.0],
          [4.566801, 52.312690, -1.0],
          [4.567518, 52.313134, -1.5],
          [4.568174, 52.313442, -1.0],
          [4.568757, 52.313277, -0.75],
          [4.569328, 52.313143, -0.5],
          [4.570406, 52.312891, -0.25],
          [4.572208, 52.312553, 0.75],
          [4.572700, 52.312700, 0.25],
          [4.573679, 52.313023, -1.0],
          [4.574309, 52.313206, -1.5],
          [4.574777, 52.313335, -1.25],
          [4.575286, 52.313425, -0.5],
          [4.575999, 52.313538, 0.0],
          [4.576742, 52.313621, 1.25],
          [4.577222, 52.313663, 0.75],
          [4.577396, 52.313674, 0.5],
          [4.577472, 52.313678, 0.5],
          [4.578000, 52.313700, 0.0],
          [4.579840, 52.313755, -0.25],
          [4.580892, 52.313644, -1.25],
          [4.582435, 52.313456, -2.5],
          [4.584084, 52.313388, -1.75],
          [4.584288, 52.313379, -1.75],
          [4.584615, 52.313382, -1.75],
          [4.587890, 52.313407, 1.5],
          [4.588007, 52.313408, 1.75],
          [4.588530, 52.313391, 1.75],
          [4.588641, 52.313392, 1.5],
          [4.588747, 52.313390, 1.5],
          [4.588712, 52.314105, 1.5],
          [4.588705, 52.314260, 1.5],
          [4.588863, 52.314942, 1.5],
          [4.588987, 52.314924, 1.25],
          [4.590867, 52.314379, -0.25],
          [4.592359, 52.313932, 0.0],
          [4.593172, 52.314433, -0.75],
          [4.593572, 52.314703, -1.0],
          [4.593800, 52.314900, -1.0],
          [4.593883, 52.315237, -0.75],
          [4.594005, 52.315450, -0.75],
          [4.594135, 52.315618, -0.75],
          [4.594373, 52.315966, -0.5],
          [4.594649, 52.316370, -0.25],
          [4.594800, 52.316600, 0.0],
          [4.595432, 52.317017, 0.25],
          [4.595619, 52.317128, 0.5],
          [4.595797, 52.317237, 0.5],
          [4.596200, 52.317500, 0.5],
          [4.596300, 52.317600, 0.5],
          [4.596382, 52.317664, 0.5],
          [4.596445, 52.317735, 0.75],
          [4.596261, 52.317808, 1.0],
          [4.595980, 52.317840, 1.5],
          [4.596149, 52.318123, 2.0],
          [4.596288, 52.318165, 2.0],
          [4.596539, 52.318699, 2.25],
          [4.596627, 52.318837, 2.5],
          [4.596906, 52.319144, 3.25],
          [4.597049, 52.319245, 3.25],
          [4.597117, 52.319303, 3.25],
          [4.597049, 52.319245, 3.25],
          [4.597324, 52.319000, 3.5],
          [4.597457, 52.318848, 3.5],
          [4.597517, 52.318767, 3.5],
          [4.597585, 52.318705, 3.5],
          [4.597749, 52.318585, 3.5],
          [4.598159, 52.318314, 3.5],
          [4.598482, 52.318062, 3.0],
          [4.598775, 52.317776, 2.0],
          [4.598760, 52.317687, 1.75],
          [4.598897, 52.317638, 1.5],
          [4.599017, 52.317534, 1.0],
          [4.599439, 52.317410, 0.75],
          [4.599970, 52.317280, 0.75],
          [4.600270, 52.317220, 0.75],
          [4.600790, 52.317100, 0.75],
          [4.601189, 52.317024, 1.25],
          [4.601615, 52.316933, 1.75],
          [4.601703, 52.316913, 1.75],
          [4.602517, 52.316723, 1.0],
          [4.602538, 52.316718, 0.75],
          [4.602654, 52.316689, 0.5],
          [4.602737, 52.316594, 0.25],
          [4.603005, 52.316517, -0.25],
          [4.603151, 52.316520, -0.5],
          [4.603310, 52.316473, -0.75],
          [4.603464, 52.316422, -0.75],
          [4.603540, 52.316350, -0.75],
          [4.603836, 52.316263, -0.5],
          [4.603960, 52.316227, -0.5],
          [4.604099, 52.316226, -0.5],
          [4.604650, 52.316067, 0.25],
          [4.604819, 52.316056, 0.5],
          [4.604913, 52.316009, 0.5],
          [4.605258, 52.315904, 0.5],
          [4.605369, 52.315881, 0.25],
          [4.605450, 52.315866, 0.25],
          [4.605541, 52.315872, 0.25],
          [4.605654, 52.315896, 0.0],
          [4.606456, 52.316565, -1.5],
          [4.606654, 52.316781, -1.75],
          [4.606955, 52.317117, -1.75],
          [4.606955, 52.317133, -1.75],
          [4.607062, 52.317179, -1.5],
          [4.607909, 52.318075, -0.5],
          [4.609708, 52.317507, 0.0],
          [4.609600, 52.317390, -0.5],
          [4.609831, 52.317317, -0.75],
          [4.609600, 52.317390, -0.5],
          [4.609708, 52.317507, 0.0],
          [4.609876, 52.317446, -0.25],
          [4.610248, 52.317307, -1.0],
          [4.610707, 52.317801, 0.25],
          [4.610962, 52.318128, 0.5],
          [4.611308, 52.318022, 0.25],
          [4.611431, 52.317985, 0.25],
          [4.611467, 52.317975, 0.0],
          [4.611499, 52.317973, 0.0],
          [4.611992, 52.317976, 0.0],
          [4.612068, 52.317977, -0.25],
          [4.612140, 52.317987, -0.25],
          [4.612196, 52.318054, -0.5],
          [4.612207, 52.318069, -0.5],
          [4.612223, 52.318151, -0.25],
          [4.612132, 52.319166, 0.25],
          [4.612099, 52.320133, 0.0],
          [4.612090, 52.320499, 0.0],
          [4.612057, 52.322032, 0.0],
          [4.611995, 52.323855, 0.0],
          [4.611990, 52.324000, 0.0],
          [4.612018, 52.324306, -0.25],
          [4.612091, 52.324681, 0.0],
          [4.612179, 52.325024, -0.25],
          [4.612340, 52.325463, -1.25],
          [4.612545, 52.325927, -2.0],
          [4.612751, 52.326296, -2.25],
          [4.612832, 52.326440, -2.25],
          [4.613202, 52.326947, -1.75],
          [4.614470, 52.328372, 0.0],
          [4.615500, 52.329530, 0.5],
          [4.616286, 52.330388, -0.5],
          [4.617010, 52.331180, -0.75],
          [4.617450, 52.331620, -0.75],
          [4.617907, 52.332002, -0.75],
          [4.618285, 52.332271, -0.5],
          [4.618493, 52.332410, -0.25],
          [4.619023, 52.332729, -0.5],
          [4.619389, 52.332920, -0.75],
          [4.619570, 52.333016, -1.0],
          [4.620091, 52.333249, -1.0],
          [4.620573, 52.333432, -0.5],
          [4.622801, 52.334268, 0.0],
          [4.626749, 52.335729, 1.0],
          [4.629411, 52.336714, 0.0],
          [4.629850, 52.336871, 0.0],
          [4.630641, 52.337129, 0.0],
          [4.630795, 52.337145, 0.0],
          [4.631021, 52.337124, 0.0],
          [4.631070, 52.337218, 0.0],
          [4.631100, 52.337250, 0.0],
          [4.631257, 52.337311, 0.25],
          [4.631453, 52.337353, 0.5],
          [4.631864, 52.337439, 0.75],
          [4.632243, 52.337502, 0.75],
          [4.632876, 52.337578, 1.0],
          [4.633672, 52.337670, 1.0],
          [4.635910, 52.337970, 0.0],
          [4.636028, 52.337969, 0.0],
          [4.636329, 52.337879, 0.0],
          [4.636751, 52.337760, -0.25],
          [4.636790, 52.337719, -0.25],
          [4.636799, 52.337691, -0.25],
          [4.636790, 52.337719, -0.25],
          [4.636751, 52.337760, -0.25],
          [4.636825, 52.337748, -0.25],
          [4.636927, 52.337758, -0.25],
          [4.637178, 52.337793, -0.25],
          [4.637283, 52.337809, -0.25],
          [4.637323, 52.337816, 0.0],
          [4.637383, 52.337844, 0.0],
          [4.637635, 52.338129, 0.25],
          [4.637770, 52.338244, 0.25],
          [4.638759, 52.338384, 0.75],
          [4.639047, 52.338423, 1.25],
          [4.639077, 52.338428, 1.25],
          [4.639302, 52.338456, 1.75],
          [4.640349, 52.338595, 1.75],
          [4.642546, 52.338905, -0.25],
          [4.644426, 52.339171, -0.5],
          [4.646522, 52.339452, -2.25],
          [4.646628, 52.339468, -2.25],
          [4.647310, 52.339580, -2.75],
          [4.647579, 52.339632, -2.75],
          [4.647815, 52.339678, -2.75],
          [4.647800, 52.339704, -2.75],
          [4.647788, 52.339721, -2.75],
          [4.647738, 52.339712, -2.75],
          [4.647559, 52.340053, -2.75],
          [4.647544, 52.340080, -3.0],
          [4.648278, 52.340255, -2.25],
          [4.648894, 52.340435, -2.0],
          [4.649531, 52.340667, -1.5],
          [4.650275, 52.341004, -1.0],
          [4.651327, 52.341459, -1.25],
          [4.651525, 52.341563, -1.0],
          [4.651694, 52.341675, -1.0],
          [4.651698, 52.341685, -1.0],
          [4.651698, 52.341733, -1.0],
          [4.651698, 52.341754, -1.0],
          [4.651794, 52.341957, -1.5],
          [4.651801, 52.342013, -1.75],
          [4.651808, 52.342068, -1.75],
          [4.651811, 52.342173, -2.0],
          [4.651707, 52.342378, -2.5],
          [4.650730, 52.342425, -2.0],
          [4.650390, 52.342485, -2.0],
          [4.650180, 52.342556, -2.0],
          [4.649972, 52.342666, -2.25],
          [4.649788, 52.342809, -2.75],
          [4.649581, 52.343001, -3.0],
          [4.649484, 52.343159, -3.0],
          [4.649421, 52.343416, -3.25],
          [4.649427, 52.343613, -3.25],
          [4.649476, 52.343773, -3.25],
          [4.649604, 52.343950, -3.5],
          [4.649928, 52.344176, -3.75],
          [4.651016, 52.344881, 1.5],
          [4.651028, 52.344950, 2.0],
          [4.650990, 52.345069, 2.25],
          [4.650906, 52.345253, 2.0],
          [4.651028, 52.345361, 2.25],
          [4.651106, 52.345400, 2.25],
          [4.651348, 52.345417, 2.75],
          [4.652007, 52.345449, 2.75],
          [4.652410, 52.345526, 2.25],
          [4.652907, 52.345680, 2.25],
          [4.653701, 52.346020, 2.75],
          [4.654217, 52.346247, 2.5],
          [4.654457, 52.346389, 2.25],
          [4.654600, 52.346489, 2.5],
          [4.654810, 52.346712, 2.75],
          [4.654865, 52.346839, 2.75],
          [4.655368, 52.347363, 3.0],
          [4.656489, 52.347659, 2.75],
          [4.657022, 52.347807, 1.25],
          [4.657262, 52.347874, 0.25],
          [4.657476, 52.347933, -0.25],
          [4.657902, 52.348043, -2.25],
          [4.657956, 52.348058, -2.25],
          [4.657991, 52.348090, -2.5],
          [4.658017, 52.348208, -2.75],
          [4.658047, 52.348270, -2.75],
          [4.658098, 52.348307, -3.0],
          [4.660575, 52.349473, -1.75],
          [4.660618, 52.349521, -1.25],
          [4.660809, 52.349998, 1.75],
          [4.660865, 52.350049, 2.0],
          [4.660957, 52.350096, 2.0],
          [4.662075, 52.350517, 1.75],
          [4.663118, 52.350905, 2.25],
          [4.664075, 52.351263, 1.25],
          [4.664557, 52.351441, 1.0],
          [4.666068, 52.352020, 0.0],
          [4.666820, 52.352308, 0.75],
          [4.668187, 52.352601, -1.75],
          [4.669221, 52.352821, -0.25],
          [4.669520, 52.352885, 0.0],
          [4.669540, 52.352890, 0.0],
          [4.669780, 52.352939, 0.0],
          [4.669810, 52.352993, 0.0],
          [4.669716, 52.353275, 2.0],
          [4.669640, 52.353465, 2.5],
          [4.669552, 52.353821, 2.5],
          [4.669486, 52.354286, 1.75],
          [4.669514, 52.354484, 1.25],
          [4.669486, 52.354681, 0.75],
          [4.669364, 52.355339, 0.0],
          [4.669326, 52.355481, 0.0],
          [4.669284, 52.355506, 0.0],
          [4.669128, 52.355516, 0.0],
          [4.669069, 52.355540, 0.0],
          [4.669018, 52.355607, 0.0],
          [4.669167, 52.355613, 0.0],
          [4.669793, 52.355646, -0.5],
          [4.669857, 52.355655, -0.5],
          [4.670166, 52.355676, -0.75],
          [4.670136, 52.355744, -0.75],
          [4.670115, 52.355799, -0.75],
          [4.670093, 52.355848, -0.75],
          [4.670115, 52.355799, -0.75],
          [4.670136, 52.355744, -0.75],
          [4.670166, 52.355676, -0.75],
          [4.670631, 52.355736, -0.75],
          [4.672205, 52.355992, -1.0],
          [4.672797, 52.356080, -1.0],
          [4.673000, 52.356103, -1.0],
          [4.673096, 52.356095, -1.0],
          [4.673244, 52.356060, -0.75],
          [4.673310, 52.356037, -0.5],
          [4.673413, 52.355987, -0.5],
          [4.673762, 52.355766, 0.0],
          [4.674952, 52.354878, -2.0],
          [4.675890, 52.354158, -1.75],
          [4.675917, 52.354141, -1.5],
          [4.675890, 52.354158, -1.75],
          [4.674952, 52.354878, -2.0],
          [4.673762, 52.355766, 0.0],
          [4.673413, 52.355987, -0.5],
          [4.673310, 52.356037, -0.5],
          [4.673244, 52.356060, -0.75],
          [4.673096, 52.356095, -1.0],
          [4.673000, 52.356103, -1.0],
          [4.672797, 52.356080, -1.0],
          [4.672205, 52.355992, -1.0],
          [4.670631, 52.355736, -0.75],
          [4.670166, 52.355676, -0.75],
          [4.670136, 52.355744, -0.75],
          [4.670115, 52.355799, -0.75],
          [4.669814, 52.356488, -1.5],
          [4.669730, 52.356799, -1.5],
          [4.669577, 52.357541, -0.5],
          [4.669519, 52.359469, -2.0],
          [4.669475, 52.359612, -1.75],
          [4.669420, 52.359737, -1.5],
          [4.669296, 52.359958, -1.0],
          [4.669100, 52.360156, -1.0],
          [4.668884, 52.360332, -1.0],
          [4.668384, 52.360585, -1.25],
          [4.668107, 52.360676, -1.0],
          [4.667965, 52.360716, -0.75],
          [4.667804, 52.360741, -0.5],
          [4.667716, 52.361115, 0.0],
          [4.667495, 52.362048, 1.25],
          [4.667456, 52.362158, 1.5],
          [4.666945, 52.364250, 1.25],
          [4.666877, 52.364555, 2.0],
          [4.666862, 52.364616, 2.0],
          [4.666499, 52.366226, 1.25],
          [4.666376, 52.366728, 0.25],
          [4.666360, 52.366772, 0.25],
          [4.666157, 52.367549, 0.75],
          [4.666133, 52.367674, 0.75],
          [4.666107, 52.367809, 0.5],
          [4.666109, 52.367889, 0.5],
          [4.665912, 52.367888, 0.25],
          [4.666109, 52.367889, 0.5],
          [4.666107, 52.367809, 0.5],
          [4.666418, 52.367810, 0.5],
          [4.667681, 52.367822, 0.25],
          [4.668788, 52.367838, 0.0],
          [4.669253, 52.367852, 0.5],
          [4.669711, 52.367877, 1.25],
          [4.670292, 52.367923, 2.0],
          [4.671762, 52.368099, 1.5],
          [4.672097, 52.368145, 1.5],
          [4.672144, 52.368151, 1.5],
          [4.672097, 52.368145],
          [4.671762, 52.368099, 1.5],
          [4.670292, 52.367923, 2.0],
          [4.669711, 52.367877, 1.25],
          [4.669253, 52.367852, 0.5],
          [4.668788, 52.367838, 0.0],
          [4.667681, 52.367822, 0.25],
          [4.666418, 52.367810, 0.5],
          [4.666107, 52.367809, 0.5],
          [4.666133, 52.367674, 0.75],
          [4.666291, 52.367700, 0.75],
          [4.667736, 52.367708, 0.5],
          [4.669604, 52.367705, 0.75],
          [4.670765, 52.367721, 1.5],
          [4.670987, 52.367729, 1.25],
          [4.671153, 52.367740, 1.25],
          [4.671378, 52.367766, 1.25],
          [4.671712, 52.367820, 1.25],
          [4.671844, 52.367859, 1.25],
          [4.671952, 52.367913, 1.25],
          [4.672013, 52.367986, 1.25],
          [4.672020, 52.368062, 1.5],
          [4.671961, 52.368216, 1.75],
          [4.671940, 52.368290, 1.75],
          [4.671500, 52.369637, 1.5],
          [4.671414, 52.369903, 2.0],
          [4.671392, 52.370164, 2.0],
          [4.671381, 52.370498, 1.5],
          [4.671260, 52.371092, 0.75],
          [4.671171, 52.371104, 0.75],
          [4.671212, 52.371562, -0.25],
          [4.671314, 52.371639, -0.25],
          [4.671516, 52.372314, 2.0],
          [4.671702, 52.372713, 1.75],
          [4.671748, 52.372899, 0.75],
          [4.671797, 52.373012, 0.25],
          [4.671854, 52.373105, 0.0],
          [4.672243, 52.373749, -1.5],
          [4.672416, 52.374008, -1.75],
          [4.672456, 52.374144, -2.0],
          [4.672498, 52.374356, -1.75],
          [4.672571, 52.374474, -1.5],
          [4.672871, 52.374770, -1.0],
          [4.673083, 52.374961, -1.0],
          [4.673444, 52.375105, -0.75],
          [4.673710, 52.375246, -0.5],
          [4.674199, 52.375623, -0.25],
          [4.674395, 52.376014, 0.0],
          [4.674516, 52.376225, 0.0],
          [4.674570, 52.376290, 0.0],
          [4.674749, 52.376615, 0.0],
          [4.674951, 52.376845, 0.25],
          [4.676071, 52.377769, 0.5],
          [4.676161, 52.377863, 0.5],
          [4.676510, 52.378336, 0.0],
          [4.676598, 52.378425, 0.0],
          [4.676812, 52.378589, -0.25],
          [4.677226, 52.378968, -1.25],
          [4.677372, 52.379122, -1.5],
          [4.677736, 52.379431, -2.25],
          [4.678161, 52.379719, -2.0],
          [4.678426, 52.379925, -1.25],
          [4.679232, 52.380585, -0.25],
          [4.679675, 52.380901, -0.5],
          [4.679779, 52.380991, -0.5],
          [4.679870, 52.381090, -0.5],
          [4.680335, 52.381749, 0.5],
          [4.680352, 52.381788, 0.5],
          [4.680366, 52.381864, 0.75],
          [4.680370, 52.381960, 0.75],
          [4.680323, 52.382168, 1.25],
          [4.680330, 52.382350, 1.5],
          [4.680472, 52.382870, 1.5],
          [4.680313, 52.382884, 1.5],
          [4.680152, 52.382887, 1.5],
          [4.680075, 52.382881, 1.25],
          [4.680152, 52.382887, 1.5],
          [4.680313, 52.382884, 1.5],
          [4.680472, 52.382870, 1.5],
          [4.680672, 52.382850, 1.5],
          [4.681300, 52.382767, 1.25],
          [4.681586, 52.382746, 1.0],
          [4.681843, 52.382747, 1.0],
          [4.682133, 52.382770, 1.0],
          [4.682410, 52.382810, 1.0],
          [4.682698, 52.382875, 0.75],
          [4.683096, 52.382992, 0.5],
          [4.683302, 52.383033, 0.5],
          [4.683539, 52.383061, 0.5],
          [4.684598, 52.383133, 0.0],
          [4.685665, 52.383222, 0.0],
          [4.685829, 52.383234, 0.0],
          [4.686383, 52.383275, 0.5],
          [4.688081, 52.383316, 1.5],
          [4.688519, 52.383351, 1.5],
          [4.688779, 52.383383, 1.25],
          [4.689117, 52.383423, 1.0],
          [4.690995, 52.383584, 0.0],
          [4.691686, 52.383642, -1.0],
          [4.691880, 52.383637, -1.0],
          [4.692127, 52.383612, -1.0],
          [4.692281, 52.383607, -1.0],
          [4.694555, 52.383789, 0.0],
          [4.695350, 52.383877, 0.0],
          [4.696866, 52.383964, 0.0],
          [4.697803, 52.383994, -0.25],
          [4.699299, 52.384008, 0.0],
          [4.699817, 52.383900, 0.0],
          [4.700086, 52.383906, 0.25],
          [4.700324, 52.383954, 0.5],
          [4.700846, 52.383958, 1.0],
          [4.703034, 52.383783, 1.0],
          [4.703579, 52.383749, 0.75],
          [4.703862, 52.383719, 0.75],
          [4.704091, 52.383682, 0.75],
          [4.704329, 52.383622, 0.5],
          [4.704509, 52.383567, 0.25],
          [4.704742, 52.383479, 0.0],
          [4.704934, 52.383373, -0.75],
          [4.705491, 52.383024, 0.25],
          [4.705912, 52.382830, 1.0],
          [4.706183, 52.382741, 1.25],
          [4.706639, 52.382677, 1.5],
          [4.707101, 52.382642, 1.75],
          [4.707469, 52.382657, 2.25],
          [4.707767, 52.382686, 2.5],
          [4.708041, 52.382748, 3.0],
          [4.708328, 52.382844, 3.25],
          [4.708804, 52.383070, 2.75],
          [4.709031, 52.383239, 2.0],
          [4.709770, 52.383792, 0.5],
          [4.709995, 52.383910, -0.25],
          [4.710313, 52.384031, -0.5],
          [4.710745, 52.384147, -0.75],
          [4.715553, 52.385266, -0.75],
          [4.716301, 52.385407, 0.0],
          [4.717426, 52.385593, 0.0],
          [4.718522, 52.385701, -0.75],
          [4.718945, 52.385731, -0.75],
          [4.720296, 52.385824, -1.0],
          [4.722112, 52.385948, -1.0],
          [4.722705, 52.385989, -1.0],
          [4.723859, 52.386068, -1.25],
          [4.727765, 52.386356, 0.5],
          [4.728224, 52.386384, 1.0],
          [4.729115, 52.386426, 0.25],
          [4.731399, 52.386479, -2.0],
          [4.732206, 52.386448, -2.0],
          [4.732958, 52.386385, -1.25],
          [4.733471, 52.386307, -1.0],
          [4.733573, 52.386306, -1.0],
          [4.733661, 52.386291, -1.0],
          [4.733732, 52.386268, -1.0],
          [4.733787, 52.386227, -1.25],
          [4.733869, 52.386203, -1.25],
          [4.733959, 52.386188, -1.25],
          [4.734058, 52.386173, -1.25],
          [4.734185, 52.386150, -1.0],
          [4.734248, 52.386167, -1.0],
          [4.734304, 52.386173, -1.0],
          [4.734377, 52.386163, -1.0],
          [4.734924, 52.385982, -1.0],
          [4.735530, 52.385856, -1.0],
          [4.735608, 52.385851, -1.0],
          [4.735715, 52.385863, -1.0],
          [4.735846, 52.385911, -0.75],
          [4.735940, 52.385967, -0.75],
          [4.736095, 52.386056, -0.75],
          [4.736178, 52.386112, -0.5],
          [4.736327, 52.386204, -0.5],
          [4.736996, 52.386209, -0.25],
          [4.737922, 52.386196, -0.25],
          [4.740200, 52.386182, 0.0],
          [4.740983, 52.386157, 0.25],
          [4.741541, 52.386117, 0.75],
          [4.744146, 52.385831, 0.75],
          [4.744666, 52.385772, 0.25],
          [4.745489, 52.385669, 1.0],
          [4.745611, 52.385655, 1.25],
          [4.745722, 52.385644, 1.5],
          [4.745829, 52.385628, 1.5],
          [4.745861, 52.385731, 1.25],
          [4.747478, 52.385541, 2.25],
          [4.747790, 52.385488, 1.5],
          [4.747923, 52.385452, 1.0],
          [4.748078, 52.385396, 0.75],
          [4.748247, 52.385301, 0.25],
          [4.748661, 52.385037, -0.25],
          [4.749310, 52.384625, -0.25],
          [4.749517, 52.384520, -0.25],
          [4.749648, 52.384468, -0.25],
          [4.749909, 52.384393, 1.0],
          [4.750381, 52.384294, 1.0],
          [4.751666, 52.384040, 0.0],
          [4.751834, 52.384007, 0.0],
          [4.752290, 52.383929, 0.25],
          [4.752627, 52.383903, 0.25],
          [4.753495, 52.383867, 1.0],
          [4.754258, 52.383831, 0.75],
          [4.754244, 52.383753, 0.75],
          [4.754606, 52.383739, 0.5],
          [4.754937, 52.383738, 0.5],
          [4.756211, 52.383688, 1.25],
          [4.756301, 52.383668, 1.5],
          [4.756791, 52.383668, 1.75],
          [4.758745, 52.383692, 1.75],
          [4.758820, 52.383681, 1.75],
          [4.758851, 52.383668, 2.0],
          [4.758919, 52.383668, 1.75],
          [4.759023, 52.383667, 1.75],
          [4.759132, 52.383667, 1.75],
          [4.759187, 52.383674, 1.5],
          [4.759957, 52.383680, 0.5],
          [4.760326, 52.383683, 0.0],
          [4.762201, 52.383700, -2.5],
          [4.762681, 52.383710, -2.5],
          [4.762914, 52.383709, -2.5],
          [4.763049, 52.383701, -2.25],
          [4.763491, 52.383655, -2.25],
          [4.763686, 52.383647, -2.0],
          [4.764848, 52.383660, -2.0],
          [4.766772, 52.383676, -3.0],
          [4.767192, 52.383683, -3.0],
          [4.768285, 52.383702, -2.5],
          [4.768724, 52.383705, -2.25],
          [4.768865, 52.383708, -2.0],
          [4.769169, 52.383732, -1.75],
          [4.769809, 52.383736, -1.0],
          [4.770410, 52.383736, -1.0],
          [4.770744, 52.383728, -1.0],
          [4.771483, 52.383734, -1.5],
          [4.772025, 52.383739, -2.0],
          [4.772478, 52.383704, -2.0],
          [4.772974, 52.383628, -2.25],
          [4.773573, 52.383528, -2.5],
          [4.774043, 52.383494, -2.5],
          [4.774407, 52.383484, -2.75],
          [4.774797, 52.383501, -3.0],
          [4.775185, 52.383565, -2.75],
          [4.775644, 52.383656, -2.25],
          [4.775907, 52.383701, -2.25],
          [4.776253, 52.383744, -2.25],
          [4.776864, 52.383802, -2.25],
          [4.777143, 52.383813, -2.25],
          [4.777402, 52.383806, -2.25],
          [4.777656, 52.383761, -2.25],
          [4.777944, 52.383680, -2.25],
          [4.778283, 52.383573, -2.25],
          [4.778538, 52.383458, -2.25],
          [4.778899, 52.383255, -2.5],
          [4.779120, 52.383143, -2.5],
          [4.779312, 52.383081, -2.25],
          [4.779567, 52.383019, -1.75],
          [4.779776, 52.382986, -1.5],
          [4.779959, 52.382978, -1.25],
          [4.780580, 52.382983, -1.25],
          [4.781434, 52.383016, -0.25],
          [4.781889, 52.383086, 0.0],
          [4.782021, 52.383128, 0.0],
          [4.782156, 52.383170, 0.0],
          [4.782851, 52.383414, -0.75],
          [4.782887, 52.383430, -0.75],
          [4.783316, 52.383616, -2.25],
          [4.783601, 52.383774, -2.5],
          [4.783844, 52.383844, -2.75],
          [4.784183, 52.383881, -3.0],
          [4.785122, 52.383900, -3.0],
          [4.785748, 52.383900, -2.0],
          [4.785983, 52.383851, -1.5],
          [4.786205, 52.383751, -1.0],
          [4.786633, 52.383529, 0.25],
          [4.786838, 52.383482, 0.25],
          [4.788091, 52.383484, -1.0],
          [4.790345, 52.383506, -1.0],
          [4.790517, 52.383508, -1.0],
          [4.791320, 52.383518, -1.0],
          [4.792304, 52.383521, -1.0],
          [4.793033, 52.383535, -0.25],
          [4.793331, 52.383570, 0.0],
          [4.793534, 52.383648, 0.0],
          [4.793678, 52.383745, 0.0],
          [4.793843, 52.383884, 0.0],
          [4.793854, 52.383659, 0.0],
          [4.793843, 52.383884, 0.0],
          [4.793910, 52.383943, 0.0],
          [4.794081, 52.384059, 0.0],
          [4.794159, 52.384095, 0.0],
          [4.794299, 52.384140, 0.0],
          [4.797791, 52.384182, 0.25],
          [4.799200, 52.384117, 0.75],
          [4.802848, 52.384141, -0.75],
          [4.803038, 52.384148, -0.75],
          [4.803156, 52.384152, -0.75],
          [4.803446, 52.384156, -0.75],
          [4.803978, 52.384162, -0.75],
          [4.804509, 52.384188, -0.5],
          [4.805571, 52.384252, -0.5],
          [4.808605, 52.384298, 1.5],
          [4.811877, 52.384350, 2.25],
          [4.814693, 52.384379, 1.5],
          [4.815244, 52.384384, 1.5],
          [4.815796, 52.384364, 2.0],
          [4.818032, 52.384213, 1.5],
          [4.818361, 52.384231, 0.75],
          [4.818570, 52.384234, 0.75],
          [4.818635, 52.384234, 0.75],
          [4.818825, 52.384237, 0.75],
          [4.819006, 52.384244, 0.75],
          [4.819129, 52.384249, 0.75],
          [4.821407, 52.384435, 0.0],
          [4.821527, 52.384440, 0.0],
          [4.826952, 52.384514, 1.0],
          [4.827211, 52.384497, 1.0],
          [4.827498, 52.384524, 1.0],
          [4.833777, 52.384610, 1.5],
          [4.834012, 52.384606, 1.75],
          [4.834148, 52.384595, 2.0],
          [4.834315, 52.384592, 2.0],
          [4.834372, 52.384593, 2.25],
          [4.835035, 52.384605, 3.0],
          [4.835157, 52.384609, 2.75],
          [4.835419, 52.384632, 2.75],
          [4.835568, 52.384637, 2.5],
          [4.836510, 52.384648, 1.0],
          [4.837525, 52.384669, 1.0],
          [4.838482, 52.384691, 1.25],
          [4.838622, 52.384673, 1.25],
          [4.838703, 52.384630, 1.25],
          [4.838756, 52.384619, 1.25],
          [4.839572, 52.384631, 0.75],
          [4.839628, 52.384638, 0.75],
          [4.839777, 52.384680, 0.5],
          [4.839933, 52.384710, 0.25],
          [4.839959, 52.384710, 0.25],
          [4.840021, 52.384707, 0.25],
          [4.840087, 52.384708, 0.5],
          [4.840612, 52.384717, 1.5],
          [4.842124, 52.384737, 4.25],
          [4.842556, 52.384738, 5.0],
          [4.842949, 52.384732, 6.0],
          [4.843565, 52.384741, 6.25],
          [4.843653, 52.384731, 6.0],
          [4.843731, 52.384717, 5.75],
          [4.843815, 52.384718, 5.5],
          [4.843910, 52.384719, 5.25],
          [4.843958, 52.384720, 5.0],
          [4.845218, 52.384737, 1.5],
          [4.845333, 52.384737, 1.5],
          [4.845434, 52.384741, 1.5],
          [4.845545, 52.384775, 1.5],
          [4.845597, 52.384783, 1.5],
          [4.846206, 52.384797, 2.0],
          [4.846729, 52.384794, 2.75],
          [4.847080, 52.384767, 2.75],
          [4.847128, 52.384764, 2.75],
          [4.847226, 52.384764, 2.75],
          [4.847284, 52.384602, 2.75],
          [4.847283, 52.384518, 2.75],
          [4.847335, 52.384301, 2.75],
          [4.847399, 52.384198, 2.75],
          [4.847506, 52.384127, 3.0],
          [4.848237, 52.383819, 4.5],
          [4.849365, 52.383329, 4.5],
          [4.850848, 52.382677, 4.75],
          [4.850985, 52.382610, 4.75],
          [4.851008, 52.382599, 4.75],
          [4.851196, 52.382507, 4.75],
          [4.851284, 52.382469, 4.75],
          [4.851363, 52.382454, 4.75],
          [4.852254, 52.381959, 4.25],
          [4.854338, 52.380752, 3.25],
          [4.854395, 52.380717, 3.5],
          [4.854416, 52.380705, 3.5],
          [4.854462, 52.380677, 3.5],
          [4.854509, 52.380651, 3.5],
          [4.854551, 52.380622, 3.75],
          [4.854574, 52.380611, 3.75],
          [4.854615, 52.380588, 3.75],
          [4.854630, 52.380579, 3.75],
          [4.854693, 52.380541, 4.0],
          [4.855093, 52.380315, 4.25],
          [4.855363, 52.380148, 4.5],
          [4.855841, 52.379791, 5.0],
          [4.856214, 52.379491, 4.75],
          [4.856480, 52.379236, 4.25],
          [4.856640, 52.379060, 4.0],
          [4.856789, 52.378905, 4.0],
          [4.857114, 52.378469, 4.0],
          [4.857345, 52.378031, 4.0],
          [4.857478, 52.377736, 4.0],
          [4.857640, 52.377253, 3.75],
          [4.857669, 52.377166, 3.5],
          [4.857682, 52.377113, 3.5],
          [4.857694, 52.377060, 3.5],
          [4.858268, 52.375216, 2.75],
          [4.858418, 52.374794, 3.75],
          [4.858383, 52.374740, 3.75],
          [4.858394, 52.374714, 4.0],
          [4.858413, 52.374666, 4.25],
          [4.858423, 52.374622, 4.25],
          [4.858428, 52.374579, 4.5],
          [4.858490, 52.374582, 4.5],
          [4.858512, 52.374538, 4.75],
          [4.858528, 52.374385, 5.25],
          [4.858697, 52.373850, 6.0],
          [4.858707, 52.373793, 6.0],
          [4.858732, 52.373742, 6.0],
          [4.859170, 52.372337, 5.75],
          [4.859178, 52.372270, 5.5],
          [4.859203, 52.372207, 5.5],
          [4.859228, 52.372155, 5.5],
          [4.859405, 52.371554, 4.5],
          [4.859409, 52.371549, 4.5],
          [4.859425, 52.371535, 4.5],
          [4.859441, 52.371521, 4.5],
          [4.859444, 52.371516, 4.5],
          [4.859452, 52.371512, 4.5],
          [4.859477, 52.371490, 4.25],
          [4.859496, 52.371452, 4.25],
          [4.859521, 52.371430, 4.25],
          [4.859701, 52.371450, 4.25],
          [4.859852, 52.371411, 4.0],
          [4.859915, 52.371402, 4.0],
          [4.859988, 52.371397, 4.0],
          [4.860098, 52.371388, 4.0],
          [4.861031, 52.371214, 3.75],
          [4.862174, 52.370992, 3.75],
          [4.863039, 52.370820, 3.25],
          [4.863204, 52.370757, 3.0],
          [4.863329, 52.370690, 3.0],
          [4.863369, 52.370673, 3.0],
          [4.863573, 52.370566, 3.0],
          [4.863915, 52.370422, 3.25],
          [4.864394, 52.370252, 3.75],
          [4.864502, 52.370252, 4.0],
          [4.864766, 52.370171, 4.5],
          [4.864815, 52.370154, 4.5],
          [4.865197, 52.370027, 5.0],
          [4.865274, 52.370002, 5.25],
          [4.865352, 52.369956, 5.25],
          [4.865617, 52.369910, 5.25],
          [4.865750, 52.369902, 5.5],
          [4.866073, 52.369913, 6.0],
          [4.866229, 52.369929, 6.25],
          [4.866362, 52.369952, 6.5],
          [4.867089, 52.370120, 6.0],
          [4.867215, 52.370149, 5.75],
          [4.867344, 52.370177, 5.75],
          [4.867687, 52.370269, 4.75],
          [4.868037, 52.370346, 4.0],
          [4.868260, 52.370396, 3.5],
          [4.868398, 52.370427, 3.5],
          [4.868631, 52.370479, 3.5],
          [4.870118, 52.370815, 4.0],
          [4.870204, 52.370835, 3.75],
          [4.870267, 52.370846, 3.75],
          [4.870259, 52.370810, 4.0],
          [4.870237, 52.370737, 4.25],
          [4.870225, 52.370580, 4.75],
          [4.870235, 52.370267, 6.0],
          [4.870376, 52.369699, 5.75],
          [4.870442, 52.369560, 5.25],
          [4.870722, 52.369117, 4.0],
          [4.870840, 52.368909, 4.5],
          [4.870988, 52.368685, 5.0],
          [4.871956, 52.367335, 6.0],
          [4.871995, 52.367248, 6.0],
          [4.872014, 52.367218, 6.0],
          [4.872020, 52.367207, 6.0],
          [4.872026, 52.367198, 6.0],
          [4.872028, 52.367196, 6.0],
          [4.872049, 52.367165, 6.0],
          [4.872057, 52.367149, 6.0],
          [4.872099, 52.367090, 6.0],
          [4.872356, 52.366749, 6.0],
          [4.872758, 52.366141, 5.25],
          [4.872968, 52.365815, 5.5],
          [4.873004, 52.365768, 5.5],
          [4.873115, 52.365673, 5.5],
          [4.873152, 52.365636, 5.5],
          [4.873201, 52.365568, 5.5],
          [4.873267, 52.365474, 5.25],
          [4.873306, 52.365370, 5.25],
          [4.873316, 52.365332, 5.25],
          [4.873568, 52.364965, 5.0],
          [4.873615, 52.364896, 5.0],
          [4.873641, 52.364860, 5.0],
          [4.873669, 52.364822, 5.0],
          [4.873778, 52.364670, 5.25],
          [4.873866, 52.364566, 5.5],
          [4.874025, 52.364335, 5.75],
          [4.874372, 52.363834, 6.25],
          [4.874711, 52.363355, 6.25],
          [4.875025, 52.362894, 5.25],
          [4.875083, 52.362809, 5.25],
          [4.875108, 52.362767, 5.25],
          [4.875119, 52.362757, 5.25],
          [4.875149, 52.362729, 5.25],
          [4.875152, 52.362727, 5.25],
          [4.875161, 52.362719, 5.25],
          [4.875172, 52.362708, 5.25],
          [4.875210, 52.362668, 5.25],
          [4.875213, 52.362665, 5.25],
          [4.875258, 52.362619, 5.25],
          [4.875795, 52.361858, 5.0],
          [4.876300, 52.361171, 4.5],
          [4.876700, 52.360597, 4.25],
          [4.876843, 52.360386, 4.5],
          [4.877051, 52.360090, 4.75],
          [4.877149, 52.360115, 4.75],
          [4.877254, 52.360132, 4.75],
          [4.878443, 52.360411, 4.5],
          [4.878788, 52.360503, 4.5]
        ]
      }
    }
  ]
}

let day12: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "12 - Amsterdam - Zwaag - 45.4km",
        "track-length": "45395",
        "filtered ascend": "40",
        "plain-ascend": "16",
        "total-time": "7721",
        "total-energy": "718504",
        "cost": "69937",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["4877254", "52360132", "4", "195", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "", "23", "2388"],
          ["4877051", "52360090", "4", "16", "1150", "0", "1", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "26", "2650"],
          ["4876700", "52360597", "4", "45", "5050", "0", "89", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "", "58", "2942"],
          ["4877051", "52360090", "4", "45", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "", "63", "3422"],
          ["4877254", "52360132", "4", "16", "1150", "0", "90", "0", "0", "highway=residential surface=asphalt", "", "65", "3612"],
          ["4875458", "52362675", "5", "313", "1050", "0", "95", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "", "115", "8690"],
          ["4875419", "52362773", "5", "12", "1050", "0", "7", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "railway=unknown", "117", "8897"],
          ["4875363", "52362888", "5", "18", "1050", "0", "12", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "", "120", "9206"],
          ["4874021", "52364852", "5", "241", "1050", "0", "3", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "", "161", "13299"],
          ["4873910", "52365016", "5", "21", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=intermediate", "highway=crossing crossing=uncontrolled", "165", "13616"],
          ["4873888", "52365051", "5", "5", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=intermediate", "", "165", "13692"],
          ["4872402", "52367144", "6", "261", "1050", "0", "3", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "highway=traffic_signals", "211", "18260"],
          ["4872391", "52367161", "6", "3", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "highway=crossing", "212", "18315"],
          ["4872315", "52367273", "6", "14", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "railway=crossing", "214", "18566"],
          ["4872307", "52367287", "6", "3", "1050", "0", "1", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "railway=crossing", "215", "18619"],
          ["4872302", "52367296", "6", "2", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "railway=crossing", "215", "18655"],
          ["4872290", "52367318", "6", "3", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "railway=crossing", "215", "18709"],
          ["4872247", "52367388", "6", "9", "1050", "0", "1", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "", "217", "18868"],
          ["4870567", "52370750", "4", "403", "1050", "0", "65", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate", "", "284", "25583"],
          ["4870571", "52370781", "4", "4", "1050", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "highway=crossing", "285", "25634"],
          ["4870666", "52371103", "3", "42", "1050", "0", "7", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good", "", "290", "26166"],
          ["4870410", "52371043", "3", "22", "1050", "0", "135", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "293", "26455"],
          ["4870361", "52370865", "3", "24", "1450", "0", "43", "0", "0", "highway=tertiary surface=asphalt bicycle=use_sidepath oneway=yes", "", "295", "26706"],
          ["4870698", "52370937", "3", "28", "1050", "0", "132", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "highway=crossing", "298", "27009"],
          ["4874003", "52371688", "5", "244", "1050", "0", "8", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "highway=traffic_signals", "337", "30871"],
          ["4874247", "52371788", "5", "21", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "341", "31261"],
          ["4874957", "52371926", "3", "53", "1650", "0", "22", "0", "0", "highway=secondary surface=asphalt oneway=yes smoothness=good", "", "349", "32058"],
          ["4875385", "52372024", "3", "32", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=use_sidepath oneway=yes smoothness=good", "highway=traffic_signals", "353", "32476"],
          ["4875486", "52372047", "3", "8", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=use_sidepath oneway=yes smoothness=good", "", "354", "32579"],
          ["4875510", "52372052", "3", "2", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes smoothness=good", "highway=crossing crossing=traffic_signals", "354", "32605"],
          ["4876113", "52372184", "2", "49", "1650", "0", "12", "0", "0", "highway=secondary surface=asphalt oneway=yes smoothness=good", "highway=crossing", "361", "33253"],
          ["4877272", "52372548", "2", "93", "1650", "0", "5", "0", "0", "highway=secondary surface=asphalt oneway=yes smoothness=good", "", "374", "34547"],
          ["4882696", "52373902", "9", "402", "1650", "0", "5", "0", "0", "highway=secondary surface=asphalt cycleway=lane smoothness=good", "highway=crossing", "475", "44640"],
          ["4882701", "52373915", "9", "2", "5050", "0", "37", "0", "0", "highway=footway", "railway=crossing", "476", "44675"],
          ["4882719", "52373996", "9", "5", "5050", "0", "0", "0", "0", "highway=footway", "", "480", "44760"],
          ["4882701", "52373915", "9", "5", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "railway=crossing", "483", "44760"],
          ["4882696", "52373902", "9", "2", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "highway=crossing", "484", "44760"],
          ["4882797", "52373926", "9", "8", "1650", "0", "141", "0", "0", "highway=secondary surface=asphalt cycleway=lane smoothness=good", "", "485", "44840"],
          ["4882776", "52373816", "9", "13", "1150", "0", "133", "0", "0", "highway=residential surface=asphalt oneway=yes", "highway=crossing", "487", "44970"],
          ["4882657", "52372426", "6", "158", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes smoothness=intermediate", "", "502", "46523"],
          ["4883179", "52372406", "6", "36", "1350", "0", "88", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones smoothness=intermediate", "", "506", "46903"],
          ["4884574", "52372359", "8", "96", "1350", "0", "0", "0", "0", "highway=unclassified surface=paving_stones cycleway=opposite oneway=yes oneway:bicycle=no smoothness=intermediate", "", "523", "48600"],
          ["4885172", "52372342", "9", "42", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones smoothness=intermediate", "", "531", "49401"],
          ["4886785", "52372288", "8", "111", "1350", "0", "0", "0", "0", "highway=unclassified surface=paving_stones cycleway=opposite oneway=yes oneway:bicycle=no smoothness=intermediate", "", "548", "51143"],
          ["4887260", "52372259", "8", "34", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones smoothness=intermediate", "", "554", "51709"],
          ["4887333", "52372253", "8", "6", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified smoothness=intermediate", "", "555", "51809"],
          ["4888182", "52372198", "8", "59", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones cycleway=opposite oneway=yes oneway:bicycle=no smoothness=intermediate", "", "564", "52746"],
          ["4888802", "52372186", "8", "44", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential smoothness=intermediate", "", "572", "53508"],
          ["4889406", "52372258", "9", "43", "1150", "0", "2", "0", "0", "reversedirection=yes highway=residential surface=paving_stones cycleway=opposite oneway=yes oneway:bicycle=no", "", "580", "54309"],
          ["4889517", "52372277", "10", "8", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones cycleway=opposite oneway=yes oneway:bicycle=no smoothness=good", "", "581", "54397"],
          ["4890434", "52372552", "12", "71", "1650", "0", "1", "0", "0", "highway=secondary surface=asphalt cycleway=opposite oneway=yes oneway:bicycle=no smoothness=good", "highway=crossing crossing=unknown", "593", "55622"],
          ["4890709", "52372606", "13", "23", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=opposite oneway=yes oneway:bicycle=no smoothness=good", "", "598", "56115"],
          ["4890671", "52372851", "13", "30", "1650", "0", "78", "0", "0", "highway=secondary surface=asphalt cycleway=lane oneway=yes smoothness=good", "", "602", "56477"],
          ["4890774", "52373398", "14", "65", "1050", "0", "46", "0", "0", "highway=cycleway oneway=yes", "", "611", "57390"],
          ["4890864", "52373606", "14", "26", "1050", "0", "1", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "highway=crossing crossing=unknown", "615", "57780"],
          ["4890869", "52373671", "14", "8", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good", "", "616", "57890"],
          ["4892879", "52375662", "10", "269", "1150", "0", "3", "0", "0", "highway=residential surface=asphalt access=permissive foot=no bicycle=yes oneway=yes smoothness=good", "highway=crossing", "650", "61298"],
          ["4893849", "52376304", "8", "98", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt access=permissive foot=no bicycle=yes oneway=yes smoothness=good", "highway=crossing", "660", "62364"],
          ["4895561", "52377498", "9", "182", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt access=permissive foot=no bicycle=yes oneway=yes smoothness=good", "", "690", "65330"],
          ["4896709", "52377902", "8", "95", "1050", "0", "4", "0", "0", "highway=cycleway oneway=yes smoothness=good", "", "705", "66860"],
          ["4897069", "52377974", "7", "28", "1050", "0", "0", "0", "0", "highway=cycleway oneway=yes smoothness=intermediate", "", "709", "67219"],
          ["4897054", "52377987", "7", "2", "1050", "0", "120", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "highway=traffic_signals traffic_signals:direction=backward", "709", "67243"],
          ["4896941", "52378089", "7", "16", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "", "711", "67442"],
          ["4896898", "52378139", "7", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "712", "67527"],
          ["4896848", "52378197", "7", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_rcn=yes", "", "713", "67636"],
          ["4896880", "52378222", "7", "4", "1050", "0", "54", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "highway=traffic_signals traffic_signals:direction=backward", "714", "67684"],
          ["4896936", "52378262", "6", "6", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "", "714", "67750"],
          ["4896957", "52378234", "6", "3", "5650", "0", "127", "0", "0", "highway=secondary surface=asphalt bicycle=no oneway=yes", "", "716", "67750"],
          ["4896936", "52378262", "6", "3", "31650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt bicycle=no oneway=yes", "", "718", "67750"],
          ["4897194", "52378452", "5", "29", "1050", "0", "51", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "highway=traffic_signals traffic_signals:direction=forward", "721", "68012"],
          ["4897689", "52378806", "5", "56", "1050", "0", "13", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good", "", "726", "68563"],
          ["4898071", "52379143", "4", "47", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=excellent", "", "731", "69070"],
          ["4898096", "52379140", "4", "2", "5050", "0", "52", "0", "0", "reversedirection=yes highway=footway", "", "733", "69070"],
          ["4898105", "52379149", "4", "2", "5050", "0", "58", "0", "0", "reversedirection=yes highway=footway surface=asphalt", "", "734", "69070"],
          ["4898481", "52379076", "4", "18", "7050", "0", "266", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones bicycle=no", "", "746", "69070"],
          ["4898105", "52379149", "4", "18", "7050", "0", "177", "0", "0", "highway=pedestrian surface=paving_stones bicycle=no", "", "758", "69070"],
          ["4898096", "52379140", "4", "2", "5050", "0", "89", "0", "0", "highway=footway surface=asphalt", "", "759", "69070"],
          ["4898071", "52379143", "4", "2", "5050", "0", "58", "0", "0", "highway=footway", "", "761", "69070"],
          ["4898173", "52379241", "4", "13", "1050", "0", "123", "0", "0", "highway=cycleway surface=asphalt smoothness=excellent", "", "762", "69213"],
          ["4899031", "52380115", "5", "114", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent", "", "778", "70793"],
          ["4899368", "52380454", "4", "46", "1050", "0", "11", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no", "", "784", "71384"],
          ["4899401", "52380483", "4", "4", "3050", "0", "8", "0", "0", "highway=pedestrian surface=asphalt foot=yes bicycle=yes oneway=no", "", "784", "71438"],
          ["4899449", "52380533", "4", "7", "1000", "0", "0", "0", "0", "highway=pedestrian surface=asphalt bicycle=yes oneway=no route_bicycle_rcn=yes", "", "785", "71534"],
          ["4899689", "52380597", "-8192", "20", "1000", "0", "0", "0", "0", "highway=path surface=metal foot=yes bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes wheelchair=yes", "787", "71749"],
          ["4903176", "52382141", "-8192", "309", "5670", "0", "0", "0", "10000", "reversedirection=yes foot=yes bicycle=yes route=ferry route_bicycle_rcn=yes", "nodeaccessgranted=yes wheelchair=yes", "1002", "72944"],
          ["4903407", "52382332", "-8192", "31", "1000", "0", "0", "0", "0", "highway=pedestrian surface=asphalt bicycle=dismount oneway=no smoothness=intermediate route_bicycle_rcn=yes", "", "1007", "73450"],
          ["4904404", "52382773", "2", "85", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good route_bicycle_rcn=yes", "", "1021", "74820"],
          ["4906469", "52384571", "2", "279", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_rcn=yes", "", "1061", "78780"],
          ["4909757", "52385177", "2", "246", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes oneway:bicycle=no smoothness=intermediate route_bicycle_rcn=yes", "", "1098", "82476"],
          ["4909679", "52385272", "2", "12", "40000", "0", "90", "0", "0", "highway=steps", "", "1106", "82636"],
          ["4909812", "52385473", "2", "21", "5050", "0", "24", "0", "0", "highway=footway", "", "1122", "82945"],
          ["4909679", "52385272", "2", "21", "5050", "0", "1", "0", "0", "reversedirection=yes highway=footway", "", "1135", "82945"],
          ["4909757", "52385177", "2", "12", "40000", "0", "23", "0", "0", "reversedirection=yes highway=steps", "", "1143", "82945"],
          ["4912989", "52386632", "0", "276", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes oneway:bicycle=no smoothness=intermediate route_bicycle_rcn=yes", "", "1177", "86350"],
          ["4918530", "52390791", "4", "617", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "", "1296", "98215"],
          ["4920654", "52399470", "3", "1056", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=excellent route_bicycle_rcn=yes", "", "1458", "114494"],
          ["4920376", "52399624", "3", "11", "1150", "0", "91", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "1460", "114660"],
          ["4920654", "52399470", "3", "11", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "1461", "114763"],
          ["4921174", "52399363", "2", "43", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt foot=yes smoothness=intermediate route_bicycle_rcn=yes", "", "1465", "115179"],
          ["4921358", "52399258", "2", "19", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1467", "115369"],
          ["4923906", "52403204", "1", "499", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "", "1539", "122540"],
          ["4923925", "52403266", "1", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard motor_vehicle=no", "1540", "122667"],
          ["4928611", "52410437", "1", "908", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_rcn=yes", "", "1694", "138052"],
          ["4931446", "52411947", "-2", "277", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_rcn=yes", "", "1737", "142372"],
          ["4942082", "52414076", "-1", "774", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "1872", "155805"],
          ["4947509", "52422065", "-3", "1004", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_rcn=yes", "", "2035", "172173"],
          ["4950237", "52425885", "0", "520", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "2121", "180785"],
          ["4948557", "52463491", "-2", "4251", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "2833", "251982"],
          ["4948024", "52463474", "-2", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified foot=yes route_bicycle_rcn=yes", "", "2834", "252075"],
          ["4948557", "52463491", "-2", "6", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes route_bicycle_rcn=yes", "", "2835", "252131"],
          ["4946818", "52478702", "-1", "1718", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "3119", "280595"],
          ["4948690", "52487094", "0", "946", "1350", "0", "2", "0", "0", "highway=unclassified", "", "3284", "297040"],
          ["4947375", "52493133", "0", "717", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "3395", "308199"],
          ["4946843", "52496761", "-1", "424", "1050", "0", "88", "0", "0", "highway=cycleway", "", "3464", "315048"],
          ["4946403", "52496795", "0", "13", "5050", "0", "63", "0", "0", "highway=footway bicycle=no", "", "3473", "315190"],
          ["4946843", "52496761", "-1", "13", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway bicycle=no", "", "3482", "315190"],
          ["4946878", "52496641", "-1", "14", "1050", "0", "63", "0", "0", "reversedirection=yes highway=cycleway", "", "3483", "315325"],
          ["4945686", "52496517", "-1", "85", "1050", "0", "90", "0", "0", "highway=cycleway", "", "3493", "316297"],
          ["4947461", "52499446", "0", "476", "1050", "0", "300", "0", "0", "reversedirection=yes highway=cycleway", "", "3564", "323457"],
          ["4946764", "52500129", "0", "95", "1050", "0", "4", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt", "", "3577", "324725"],
          ["4946510", "52500323", "0", "20", "1050", "0", "0", "0", "0", "highway=cycleway", "", "3580", "325017"],
          ["4946764", "52500129", "0", "20", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "3582", "325207"],
          ["4946823", "52500165", "0", "6", "1050", "0", "100", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones", "", "3582", "325268"],
          ["4946923", "52500227", "0", "10", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt", "", "3583", "325371"],
          ["4947402", "52500400", "0", "40", "1050", "0", "32", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones", "barrier=bollard", "3588", "325838"],
          ["4947404", "52500427", "0", "4", "1050", "0", "8", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones", "", "3589", "325888"],
          ["4948266", "52500614", "0", "63", "1150", "0", "56", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "3598", "326863"],
          ["4948182", "52500953", "0", "23", "1150", "0", "65", "0", "0", "highway=residential surface=paving_stones", "", "3602", "327252"],
          ["4948356", "52500657", "0", "15", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones", "", "3604", "327394"],
          ["4949163", "52500858", "1", "60", "1150", "0", "94", "0", "0", "highway=residential surface=paving_stones", "traffic_calming=table", "3611", "328092"],
          ["4949940", "52501108", "1", "60", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "traffic_calming=hump", "3619", "328904"],
          ["4951084", "52502787", "0", "242", "1150", "0", "29", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "traffic_calming=table", "3655", "332575"],
          ["4952433", "52503644", "0", "133", "1050", "0", "87", "0", "0", "highway=tertiary surface=asphalt bicycle=yes oneway=yes oneway:bicycle=no", "traffic_calming=table", "3678", "334844"],
          ["4953235", "52504149", "1", "79", "1050", "0", "0", "0", "0", "highway=tertiary surface=asphalt bicycle=yes oneway=yes oneway:bicycle=no", "", "3692", "336238"],
          ["4952993", "52504267", "1", "22", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "3694", "336469"],
          ["4952030", "52504586", "2", "75", "1450", "0", "1", "0", "0", "highway=tertiary", "", "3704", "337422"],
          ["4950303", "52505247", "2", "140", "1450", "0", "4", "0", "0", "highway=tertiary oneway=yes", "", "3725", "339490"],
          ["4950258", "52505178", "2", "2", "1450", "0", "104", "0", "0", "reversedirection=yes highway=tertiary", "", "3725", "339523"],
          ["4951173", "52507320", "1", "262", "1450", "0", "114", "0", "0", "highway=tertiary", "", "3758", "342805"],
          ["4951371", "52506705", "1", "90", "5050", "0", "260", "0", "0", "highway=footway", "", "3822", "343536"],
          ["4951173", "52507320", "1", "90", "5050", "0", "174", "0", "0", "reversedirection=yes highway=footway", "", "3883", "343575"],
          ["4951578", "52508112", "2", "97", "1450", "0", "107", "0", "0", "highway=tertiary", "", "3900", "345222"],
          ["4949811", "52506995", "0", "196", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "", "3924", "347695"],
          ["4947762", "52507677", "3", "160", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "3953", "350568"],
          ["4947310", "52507819", "3", "1", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "3953", "350587"],
          ["4947762", "52507677", "3", "1", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "3953", "350596"],
          ["4947821", "52507747", "3", "9", "3050", "0", "90", "0", "0", "highway=pedestrian surface=paving_stones", "barrier=bollard", "3954", "350681"],
          ["4948575", "52508581", "3", "107", "3050", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones", "", "3968", "352023"],
          ["4948955", "52508970", "3", "52", "3050", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones", "", "3974", "352691"],
          ["4949397", "52509418", "3", "59", "3050", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones", "barrier=bollard", "3980", "353296"],
          ["4949445", "52509472", "3", "7", "3050", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones", "", "3981", "353377"],
          ["4949504", "52509518", "3", "7", "5150", "0", "1", "0", "0", "highway=residential bicycle=no", "", "3986", "353377"],
          ["4949640", "52509431", "3", "14", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "3988", "353539"],
          ["4949831", "52509642", "2", "29", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "3991", "353877"],
          ["4950804", "52510229", "2", "96", "1050", "0", "29", "0", "0", "highway=cycleway oneway=yes", "", "4003", "355058"],
          ["4953258", "52511966", "1", "276", "1050", "0", "5", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "", "4048", "359563"],
          ["4953248", "52512144", "1", "21", "1050", "0", "80", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=yes", "", "4051", "359853"],
          ["4952823", "52512092", "1", "20", "1050", "0", "95", "0", "0", "highway=cycleway surface=asphalt oneway=yes", "", "4054", "360155"],
          ["4953062", "52512135", "1", "7", "5050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=yes", "", "4058", "360155"],
          ["4952857", "52512733", "1", "68", "1350", "0", "82", "0", "0", "highway=unclassified", "traffic_calming=table", "4065", "360859"],
          ["4952301", "52514759", "1", "230", "1350", "0", "0", "0", "0", "highway=unclassified", "traffic_calming=table", "4098", "364172"],
          ["4952269", "52514880", "1", "14", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified", "", "4100", "364373"],
          ["4960370", "52533319", "-2", "2268", "1050", "0", "184", "0", "0", "highway=cycleway surface=asphalt foot=yes", "", "4450", "399324"],
          ["4959908", "52533593", "-1", "44", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4458", "400124"],
          ["4960072", "52533728", "-1", "3", "5050", "0", "78", "0", "0", "reversedirection=yes highway=track tracktype=grade4", "", "4460", "400157"],
          ["4959908", "52533593", "-1", "3", "5050", "0", "0", "0", "0", "highway=track tracktype=grade4", "", "4462", "400157"],
          ["4959519", "52533774", "-1", "34", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4465", "400498"],
          ["4975407", "52548311", "0", "2071", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "4802", "434170"],
          ["4975083", "52548786", "0", "7", "1350", "0", "0", "0", "0", "highway=unclassified", "", "4804", "434331"],
          ["4975407", "52548311", "0", "7", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified", "traffic_calming=table", "4804", "434396"],
          ["4976287", "52548544", "0", "67", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "4811", "435086"],
          ["4980764", "52563699", "-1", "1837", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "5104", "464326"],
          ["4991856", "52570317", "0", "1064", "1350", "0", "3", "0", "0", "highway=unclassified", "", "5279", "481860"],
          ["4992241", "52571026", "0", "85", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "5294", "483347"],
          ["4997907", "52574894", "0", "603", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "5389", "492896"],
          ["4998535", "52574923", "0", "49", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "5398", "493775"],
          ["5000800", "52575889", "0", "193", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "5431", "497087"],
          ["5002799", "52576528", "0", "155", "1450", "0", "0", "0", "0", "highway=tertiary", "railway=level_crossing", "5449", "498837"],
          ["5002862", "52576548", "0", "5", "1450", "0", "0", "0", "0", "highway=tertiary", "railway=level_crossing", "5449", "498903"],
          ["5022017", "52584920", "-1", "1681", "1450", "0", "63", "0", "0", "highway=tertiary", "", "5715", "525461"],
          ["5018107", "52589620", "-1", "590", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5808", "534747"],
          ["5017193", "52590579", "-2", "125", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5827", "536653"],
          ["5013494", "52601997", "-1", "1794", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "6112", "565155"],
          ["5019283", "52612446", "-3", "1391", "1000", "0", "0", "0", "0", "highway=construction route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6334", "587371"],
          ["5015453", "52621450", "0", "1043", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=hump", "6524", "606358"],
          ["5015331", "52621667", "0", "26", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6529", "606869"],
          ["5015298", "52622183", "0", "58", "3050", "0", "4", "0", "0", "highway=track tracktype=grade3", "", "6539", "607867"],
          ["5015198", "52622782", "0", "68", "5050", "0", "2", "0", "0", "reversedirection=yes highway=path surface=grass foot=designated", "", "6587", "608379"],
          ["5015198", "52622848", "0", "5", "5050", "0", "0", "0", "0", "highway=path foot=designated", "", "6591", "608418"],
          ["5015180", "52622781", "0", "7", "5050", "0", "82", "0", "0", "reversedirection=yes highway=path foot=designated", "", "6595", "608418"],
          ["5015068", "52622778", "0", "8", "40000", "0", "0", "0", "0", "reversedirection=yes highway=steps foot=designated", "", "6600", "608418"],
          ["5015030", "52622778", "0", "3", "5050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated", "", "6602", "608418"],
          ["5015226", "52623623", "-1", "96", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6613", "609497"],
          ["5016917", "52629830", "0", "715", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6733", "621455"],
          ["5023025", "52633180", "-1", "628", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "6837", "631887"],
          ["5045578", "52641765", "-1", "1949", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7167", "664927"],
          ["5048895", "52642373", "1", "239", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "7215", "669697"],
          ["5051336", "52642040", "1", "174", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7247", "672939"],
          ["5051749", "52641948", "1", "31", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "7253", "673502"],
          ["5052273", "52641892", "2", "39", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7261", "674242"],
          ["5052307", "52641827", "2", "2", "1150", "0", "89", "0", "0", "highway=residential", "", "7261", "674282"],
          ["5052273", "52641892", "2", "2", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "", "7261", "674300"],
          ["5052243", "52641973", "2", "10", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7262", "674394"],
          ["5052199", "52642083", "2", "13", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "7263", "674528"],
          ["5051684", "52643514", "2", "165", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=lane route_bicycle_rcn=yes", "", "7285", "676660"],
          ["5051613", "52643981", "1", "53", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "7292", "677414"],
          ["5051607", "52644053", "1", "9", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt oneway=yes route_bicycle_rcn=yes", "", "7294", "677548"],
          ["5051772", "52644102", "2", "13", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "7296", "677756"],
          ["5051757", "52644337", "1", "28", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "7300", "678183"],
          ["5049501", "52645537", "0", "233", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "7333", "681462"],
          ["5049461", "52645572", "0", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "7333", "681534"],
          ["5049397", "52645631", "0", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "7335", "681650"],
          ["5047328", "52647692", "0", "287", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "7381", "686330"],
          ["5047976", "52647888", "0", "11", "1050", "0", "62", "0", "0", "highway=cycleway", "", "7383", "686517"],
          ["5047328", "52647692", "0", "11", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "7384", "686620"],
          ["5046420", "52649132", "0", "181", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "", "7406", "688836"],
          ["5046097", "52650155", "0", "119", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_rcn=yes", "", "7425", "690663"],
          ["5042657", "52659366", "-2", "1067", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "7597", "707870"],
          ["5041435", "52662732", "0", "393", "1050", "0", "44", "0", "0", "highway=cycleway", "", "7672", "715387"],
          ["5041361", "52662715", "0", "6", "1450", "0", "100", "0", "0", "reversedirection=yes highway=tertiary bicycle=use_sidepath", "", "7673", "715488"],
          ["5041244", "52662779", "0", "11", "1450", "0", "48", "0", "0", "highway=tertiary bicycle=use_sidepath", "", "7675", "715662"],
          ["5041361", "52662715", "0", "12", "1450", "0", "4", "0", "0", "reversedirection=yes highway=tertiary bicycle=use_sidepath", "", "7676", "715779"],
          ["5042173", "52662851", "0", "58", "1450", "0", "48", "0", "0", "highway=tertiary bicycle=use_sidepath", "", "7682", "716419"],
          ["5044038", "52663126", "0", "130", "1450", "0", "0", "0", "0", "highway=tertiary cycleway=lane", "", "7701", "718294"],
          ["5044363", "52663238", "0", "27", "5050", "0", "176", "0", "0", "reversedirection=yes highway=footway", "", "7720", "718525"]
        ],
        "times": [0, 9.858, 23.883, 25.194, 26.507, 51.987, 58.316, 59.186, 63.117, 64.057, 65.019, 65.878, 69.525, 72.682, 74.604, 83.67, 99.613, 115.787, 116.823, 117.168, 117.857, 118.201, 118.546, 118.718, 119.577, 119.921, 120.951, 122.665, 133.823, 144.226, 152.664, 153.442, 154.381, 161.873, 163.675, 165.042, 165.806, 172.71, 174.031, 176.148, 178.252, 180.673, 182.514, 183.975, 185.246, 191.325, 202.144, 205.626, 211.488, 212.029, 214.542, 214.899, 215.078, 215.434, 215.968, 216.501, 217.565, 218.448, 244.09, 251.542, 262.313, 270.95, 276.759, 282.715, 284.699, 285.21, 286.82, 287.326, 288.224, 288.483, 288.614, 289.137, 290.016, 290.526, 291.429, 292.083, 292.347, 292.612, 293.413, 293.953, 294.24, 294.53, 294.627, 294.922, 295.522, 295.93, 296.344, 296.553, 296.764, 296.87, 297.298, 298.172, 298.956, 308.166, 310.475, 313.745, 315.868, 326.245, 336.066, 337.199, 337.575, 339.627, 341.472, 343.015, 346.815, 348.466, 349.446, 353.621, 354.653, 354.914, 355.837, 356.638, 357.314, 358.272, 358.532, 358.663, 358.925, 359.453, 359.853, 361.39, 362.175, 364.341, 364.836, 367.651, 371.201, 373.673, 374.334, 395.818, 424.867, 428.076, 460.015, 475.23, 476.706, 480.394, 483.62, 484.915, 485.71, 485.913, 487.013, 493.692, 499.901, 502.452, 502.544, 503.009, 505.774, 506.336, 523.31, 524.349, 529.986, 531.314, 548.736, 549.899, 554.395, 555.395, 564.771, 566.386, 570.183, 572.384, 579.292, 580.401, 581.273, 584.442, 589.613, 593.521, 594.811, 595.236, 596.292, 596.711, 597.128, 598.456, 599.547, 599.916, 600.902, 602.078, 602.654, 605.417, 607.215, 611.206, 613.94, 614.518, 615.098, 616.203, 617.464, 620.178, 623.894, 625.762, 634.886, 638.935, 641.013, 641.77, 645.697, 650.273, 660.939, 668.466, 675.829, 678.011, 679.994, 682.852, 686.741, 690.59, 692.503, 694.905, 697.097, 698.624, 705.884, 707.937, 708.595, 709.479, 709.721, 709.964, 710.332, 710.579, 710.703, 711.707, 712.557, 713.05, 713.643, 714.124, 714.788, 716.806, 718.74, 719.114, 720.892, 721.361, 721.84, 722.406, 722.792, 724.638, 726.864, 729.732, 731.937, 733.286, 734.636, 739.336, 744.015, 746.699, 749.278, 753.855, 758.499, 759.83, 761.164, 762.596, 778.393, 780.624, 784.024, 784.294, 784.837, 785.796, 786.073, 786.35, 786.629, 787.949, 845.787, 881.843, 942.37, 982.094, 1002.72, 1003.697, 1005.329, 1006.147, 1006.802, 1007.786, 1015.037, 1021.48, 1023.434, 1024.723, 1032.928, 1035.407, 1041.605, 1042.4, 1043.095, 1043.684, 1054.323, 1057.107, 1059.013, 1061.085, 1061.602, 1062.569, 1063.378, 1064.137, 1070.775, 1073.955, 1075.209, 1076.547, 1078.782, 1089.967, 1091.419, 1094.522, 1098.031, 1106.748, 1113.33, 1122.086, 1129.855, 1135.691, 1143.547, 1144.576, 1146.839, 1156.594, 1172.373, 1177.589, 1180.716, 1181.952, 1191.631, 1193.179, 1194.805, 1205.71, 1238.385, 1261.15, 1265.703, 1269.378, 1269.941, 1275.116, 1277.456, 1278.384, 1280.02, 1283.415, 1287.66, 1290.833, 1292.939, 1296.215, 1300.524, 1303.168, 1323.74, 1325.347, 1326.187, 1333.313, 1341.904, 1385.38, 1399.971, 1402.354, 1404.024, 1405.59, 1406.682, 1408.623, 1411.161, 1416.172, 1421.358, 1426.741, 1435.469, 1438.25, 1440.712, 1443.193, 1445.073, 1447.006, 1448.967, 1452.552, 1454.26, 1456.733, 1458.96, 1460.617, 1461.648, 1462.882, 1463.452, 1464.036, 1465.401, 1465.806, 1466.6, 1467.007, 1467.706, 1470.684, 1472.237, 1473.626, 1474.823, 1475.68, 1477.188, 1479.933, 1482.385, 1484.206, 1490.195, 1492.972, 1499.753, 1502.834, 1508.875, 1528.401, 1530.352, 1539.41, 1540.685, 1546.468, 1548.938, 1554.08, 1558.09, 1559.896, 1562.841, 1571.317, 1579.107, 1580.082, 1580.786, 1589.621, 1591.903, 1595.905, 1603.505, 1604.885, 1606.346, 1612.557, 1620.706, 1625.17, 1626.971, 1629.382, 1632.754, 1639.184, 1641.494, 1648.161, 1656.52, 1659.375, 1661.624, 1663.118, 1666.31, 1667.271, 1669.494, 1671.092, 1674.17, 1675.991, 1682.659, 1687.203, 1694.518, 1703.518, 1705.894, 1708.624, 1710.672, 1712.738, 1715.864, 1718.299, 1719.984, 1723.656, 1725.096, 1726.755, 1728.356, 1729.931, 1732.344, 1734.894, 1737.708, 1754.033, 1757.768, 1769.462, 1772.757, 1776.406, 1783.902, 1813.296, 1821.235, 1836.381, 1839.5, 1864.112, 1870.553, 1872.015, 1879.729, 1884.84, 1895.556, 1902.304, 1907.783, 1915.488, 1933.593, 1937.33, 1947.909, 1973.275, 1982.812, 2006.582, 2008.917, 2018.613, 2021.766, 2024.156, 2027.046, 2029.175, 2034.028, 2035.688, 2040.147, 2044.473, 2047.474, 2054.541, 2058.028, 2060.8, 2068.011, 2069.533, 2071.126, 2072.89, 2073.447, 2074.85, 2076.46, 2080.783, 2119.088, 2121.801, 2129.938, 2242.781, 2247.26, 2326.867, 2332.194, 2355.746, 2371.076, 2395.314, 2403.053, 2418.462, 2443.154, 2464.664, 2489.828, 2495.533, 2522.103, 2610.48, 2613.732, 2616.193, 2642.699, 2667.517, 2669.379, 2685.777, 2694.755, 2713.925, 2724.293, 2730.469, 2737.06, 2741.108, 2754.078, 2817.925, 2822.854, 2827.695, 2833.746, 2834.673, 2835.229, 2838.108, 2848.886, 2865.06, 2886.116, 2889.134, 2926.822, 2934.742, 2941.108, 2951.973, 2970.302, 2992.452, 3033.978, 3049.421, 3062.574, 3104.587, 3116.778, 3119.85, 3142.684, 3191.286, 3275.635, 3284.3, 3297.968, 3299.139, 3303.026, 3305.74, 3316.762, 3323.725, 3327.266, 3328.237, 3345.69, 3361.232, 3383.608, 3390.271, 3394.183, 3395.88, 3403.048, 3406.571, 3408.496, 3412.917, 3427.817, 3455.455, 3457.923, 3462.052, 3464.372, 3473.725, 3482.077, 3483.424, 3490.993, 3493.143, 3495.115, 3509.189, 3510.817, 3512.123, 3514.415, 3516.715, 3523.485, 3525.641, 3547.486, 3551.973, 3552.436, 3553.981, 3555.692, 3557.154, 3559.127, 3561.577, 3563.178, 3564.734, 3568.872, 3570.415, 3572.136, 3577.418, 3580.327, 3582.236, 3582.839, 3583.875, 3584.949, 3588.045, 3588.542, 3589.044, 3598.794, 3600.147, 3602.683, 3604.1, 3611.082, 3619.201, 3622.649, 3631.014, 3634.078, 3637.82, 3645.955, 3649.032, 3650.171, 3655.911, 3678.596, 3690.962, 3692.531, 3694.848, 3704.367, 3706.588, 3725.043, 3725.373, 3725.557, 3727.38, 3728.605, 3730.103, 3731.79, 3737.498, 3737.745, 3744.427, 3745.614, 3746.688, 3749.167, 3753.397, 3755.71, 3758.197, 3769.802, 3780.485, 3786.184, 3791.172, 3801.778, 3804.609, 3810.983, 3822.234, 3833.351, 3839.303, 3841.962, 3852.079, 3856.829, 3862.278, 3872.716, 3883.714, 3884.825, 3887.225, 3891.526, 3895.894, 3900.186, 3901.182, 3904.155, 3911.809, 3916.015, 3917.625, 3919.692, 3921.207, 3922.103, 3922.614, 3923.135, 3923.665, 3924.344, 3924.92, 3930.716, 3933.425, 3953.643, 3953.833, 3953.925, 3954.768, 3958.962, 3960.853, 3968.192, 3973.159, 3974.87, 3980.914, 3981.721, 3986.428, 3988.055, 3988.855, 3989.555, 3990.268, 3991.427, 3997.103, 3998.67, 4000.246, 4003.239, 4004.698, 4006.191, 4008.25, 4010.947, 4022.839, 4033.472, 4037.601, 4038.629, 4039.657, 4040.78, 4041.905, 4042.814, 4044.833, 4046.152, 4048.283, 4049.65, 4051.184, 4053.143, 4054.208, 4058.729, 4065.768, 4074.237, 4085.862, 4098.883, 4100.899, 4103.973, 4106.445, 4107.342, 4108.253, 4115.711, 4117.682, 4130.591, 4133.58, 4133.867, 4134.648, 4136.196, 4146.839, 4148.354, 4149.782, 4160.492, 4185.039, 4193.639, 4198.226, 4199.393, 4200.54, 4202.205, 4203.311, 4204.063, 4206.294, 4207.818, 4212.819, 4223.534, 4234.501, 4238.014, 4240.591, 4280.315, 4287.637, 4292.103, 4320.417, 4327.329, 4334.48, 4336.691, 4356.001, 4359.608, 4365.756, 4369.921, 4374.26, 4377.892, 4390.554, 4391.67, 4392.595, 4393.516, 4394.065, 4394.797, 4397.181, 4398.031, 4399.306, 4399.945, 4407.156, 4439.952, 4440.789, 4441.292, 4441.962, 4443.134, 4444.14, 4447.138, 4447.773, 4448.41, 4450.366, 4458.366, 4460.527, 4462.46, 4462.834, 4465.104, 4465.868, 4473.166, 4483.671, 4496.947, 4506.967, 4509.72, 4512.224, 4523.04, 4536.078, 4539.659, 4543.761, 4551.086, 4571.65, 4574.957, 4578.143, 4585.364, 4604.291, 4606.697, 4622.994, 4638.474, 4653.606, 4658.964, 4674.912, 4688.492, 4690.877, 4694.722, 4724.333, 4733.28, 4754.093, 4761.543, 4763.833, 4766.28, 4770.62, 4782.525, 4802.532, 4804.143, 4804.793, 4805.658, 4808.222, 4811.687, 4814.93, 4817.343, 4822.059, 4823.057, 4826.012, 4865.588, 4888.055, 4890.823, 4948.329, 5005.565, 5035.095, 5039.039, 5051.487, 5057.75, 5073.533, 5086.961, 5094.722, 5103.071, 5104.067, 5109.688, 5118.551, 5137.279, 5172.364, 5178.498, 5186.007, 5190.295, 5200.476, 5231.373, 5237.442, 5252.018, 5264.297, 5279.4, 5282.723, 5286.354, 5288.507, 5290.822, 5294.263, 5296.32, 5297.69, 5298.36, 5301.549, 5308.65, 5313.783, 5317.11, 5322.298, 5325.815, 5331.604, 5340.499, 5351.135, 5358.482, 5361.539, 5369.589, 5375.223, 5381.384, 5384.518, 5386.769, 5387.978, 5389.756, 5392.349, 5393.822, 5394.738, 5396.557, 5398.542, 5400.334, 5401.759, 5406.875, 5409.172, 5412.135, 5419.417, 5431.659, 5432.144, 5434.573, 5445.599, 5449.158, 5449.819, 5468.827, 5477.155, 5492.359, 5510.825, 5519.381, 5526.399, 5530.632, 5532.842, 5534.992, 5537.631, 5540.789, 5543.449, 5545.077, 5547.127, 5551.015, 5553.306, 5556.762, 5561.497, 5573.923, 5583.833, 5590.436, 5592.192, 5594.279, 5603.355, 5604.548, 5606.489, 5608.159, 5609.512, 5609.833, 5619.618, 5621.588, 5626.097, 5628.122, 5629.641, 5635.081, 5643.87, 5653.579, 5664.434, 5668.111, 5680.947, 5713.388, 5714.431, 5715.366, 5722.151, 5737.711, 5744.042, 5771.518, 5786.14, 5790.194, 5802.224, 5808.218, 5812.471, 5818.552, 5827.273, 5845.933, 5854.923, 5859.093, 5862.665, 5864.258, 5865.193, 5867.254, 5870.405, 5878.014, 5881.394, 5884.71, 5890.532, 5894.034, 5896.073, 5897.179, 5898.87, 5904.78, 5912.848, 5914.914, 5917.771, 5919.757, 5934.664, 5940.063, 5942.105, 5950.384, 5959.64, 5964.9, 5980.857, 5997.57, 6005.656, 6035.074, 6042.26, 6045.595, 6047.264, 6050.773, 6051.609, 6052.259, 6052.736, 6053.419, 6053.9, 6054.69, 6055.196, 6060.774, 6062.703, 6069.314, 6072.568, 6075.238, 6076.664, 6079.674, 6082.427, 6088.723, 6106.268, 6112.273, 6113.944, 6115.556, 6116.762, 6118.895, 6137.475, 6155.913, 6161.751, 6167.137, 6171.775, 6180.189, 6186.976, 6198.368, 6213.651, 6217.93, 6223.617, 6225.576, 6227.197, 6228.504, 6229.839, 6238.357, 6240.993, 6252.016, 6254.599, 6257.501, 6259.815, 6264.075, 6266.492, 6269.057, 6271.757, 6274.154, 6276.695, 6278.352, 6280.385, 6285.881, 6287.657, 6288.437, 6289.312, 6290.332, 6291.371, 6292.296, 6293.432, 6309.993, 6311.311, 6313.125, 6315.108, 6321.245, 6327.239, 6334.42, 6337.765, 6341.951, 6354.188, 6361.739, 6405.678, 6422.208, 6438.273, 6450.138, 6459.908, 6469.594, 6495.976, 6512.147, 6524.264, 6529.376, 6534.896, 6539.359, 6547.208, 6552.162, 6571.297, 6587.627, 6591.181, 6594.407, 6595.702, 6600.906, 6602.868, 6603.669, 6613.655, 6618.699, 6639.805, 6662.103, 6675.5, 6679.188, 6682.548, 6695.073, 6704.286, 6712.865, 6716.668, 6729.348, 6733.209, 6744.458, 6750.167, 6752.014, 6756.715, 6760.994, 6764.847, 6771.319, 6776.876, 6783.254, 6792.496, 6798.202, 6810.525, 6816.259, 6822.111, 6837.514, 6848.244, 6852.936, 6860.197, 6871.535, 6878.538, 6883.207, 6887.101, 6893.564, 6901.665, 6914.596, 6926.337, 6928.747, 6931.171, 6934.098, 6937.369, 6939.842, 6958.468, 6961.845, 6964.207, 6966.231, 6978.189, 6981.05, 6984.246, 6997.361, 7004.804, 7014.222, 7017.391, 7020.535, 7036.171, 7038.828, 7039.931, 7041.197, 7043.747, 7045.029, 7046.155, 7047.769, 7049.226, 7051.992, 7053.789, 7061.354, 7070.976, 7077.31, 7082.322, 7089.184, 7093.707, 7097.898, 7101.756, 7103.937, 7109.139, 7123.485, 7128.226, 7132.474, 7134.293, 7143.41, 7144.923, 7147.749, 7149.632, 7151.549, 7157.618, 7167.881, 7175.98, 7191.021, 7203.463, 7208.88, 7212.078, 7215.577, 7221.044, 7226.353, 7231.369, 7234.387, 7237.168, 7243.15, 7247.994, 7252.002, 7253.623, 7257.046, 7258.545, 7259.845, 7261.031, 7261.424, 7261.608, 7262.551, 7263.884, 7265.172, 7274.559, 7285.195, 7292.736, 7294.074, 7295.032, 7296.152, 7297.664, 7299.037, 7300.421, 7301.35, 7302.594, 7303.533, 7304.79, 7310.038, 7311.853, 7313.382, 7314.77, 7316.085, 7317.481, 7318.823, 7320.43, 7322.134, 7328.701, 7330.057, 7331.366, 7333.208, 7333.927, 7335.088, 7336.409, 7338.938, 7342.132, 7343.417, 7344.546, 7346.326, 7348.764, 7350.232, 7351.868, 7355.481, 7356.14, 7358.614, 7362.518, 7368.246, 7374.405, 7378.321, 7379.001, 7380.19, 7381.888, 7383.753, 7384.784, 7386.265, 7387.94, 7389.037, 7390.171, 7391.341, 7394.798, 7401.803, 7402.719, 7403.784, 7406.94, 7408.924, 7415.757, 7422.889, 7425.209, 7430.845, 7434.002, 7440.957, 7450.745, 7459.857, 7464.683, 7472.255, 7478.141, 7484.727, 7497.41, 7507.803, 7508.757, 7509.656, 7511.929, 7524.122, 7528.536, 7532.696, 7534.794, 7536.577, 7540.736, 7542.612, 7544.993, 7546.048, 7571.7, 7577.17, 7586.694, 7597.283, 7611.356, 7614.887, 7618.819, 7620.059, 7622.878, 7632.861, 7660.021, 7663.023, 7665.609, 7669.068, 7669.912, 7671.43, 7672.441, 7673.453, 7675.194, 7675.286, 7676.358, 7676.963, 7682.76, 7701.5, 7706.487, 7720.742]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [4.879892, 52.360797, 5.25],
          [4.878443, 52.360411, 4.5],
          [4.877254, 52.360132, 4.75],
          [4.877149, 52.360115, 4.75],
          [4.877051, 52.360090, 4.75],
          [4.876843, 52.360386, 4.5],
          [4.876792, 52.360460, 4.25],
          [4.876843, 52.360386, 4.5],
          [4.877051, 52.360090, 4.75],
          [4.877149, 52.360115, 4.75],
          [4.877254, 52.360132, 4.75],
          [4.877226, 52.360185, 4.75],
          [4.877033, 52.360434, 4.25],
          [4.876898, 52.360646, 4.0],
          [4.876815, 52.360762, 4.0],
          [4.876488, 52.361224, 4.75],
          [4.875982, 52.361921, 5.5],
          [4.875458, 52.362675, 5.5],
          [4.875449, 52.362726, 5.5],
          [4.875440, 52.362740, 5.5],
          [4.875419, 52.362773, 5.5],
          [4.875412, 52.362785, 5.5],
          [4.875406, 52.362796, 5.5],
          [4.875406, 52.362797, 5.5],
          [4.875386, 52.362831, 5.5],
          [4.875384, 52.362842, 5.5],
          [4.875363, 52.362888, 5.5],
          [4.875313, 52.362966, 5.5],
          [4.874998, 52.363452, 6.0],
          [4.874636, 52.363919, 6.0],
          [4.874358, 52.364342, 5.75],
          [4.874346, 52.364380, 5.5],
          [4.874315, 52.364425, 5.5],
          [4.874021, 52.364852, 5.0],
          [4.873959, 52.364946, 5.0],
          [4.873910, 52.365016, 5.0],
          [4.873888, 52.365051, 5.0],
          [4.873624, 52.365389, 5.25],
          [4.873573, 52.365444, 5.25],
          [4.873484, 52.365535, 5.5],
          [4.873420, 52.365629, 5.5],
          [4.873347, 52.365735, 5.75],
          [4.873297, 52.365813, 5.75],
          [4.873275, 52.365881, 5.75],
          [4.873245, 52.365932, 5.75],
          [4.873042, 52.366227, 5.5],
          [4.872670, 52.366716, 5.75],
          [4.872578, 52.366878, 5.75],
          [4.872402, 52.367144, 6.0],
          [4.872391, 52.367161, 6.0],
          [4.872315, 52.367273, 6.0],
          [4.872308, 52.367284, 6.0],
          [4.872307, 52.367287, 6.0],
          [4.872302, 52.367296, 6.0],
          [4.872290, 52.367318, 6.0],
          [4.872281, 52.367342, 6.0],
          [4.872247, 52.367388, 6.0],
          [4.872187, 52.367399, 6.0],
          [4.871154, 52.368927, 4.25],
          [4.870909, 52.369305, 4.25],
          [4.870688, 52.369702, 5.75],
          [4.870603, 52.369985, 6.75],
          [4.870560, 52.370247, 6.0],
          [4.870554, 52.370622, 4.75],
          [4.870567, 52.370750, 4.25],
          [4.870571, 52.370781, 4.0],
          [4.870591, 52.370893, 3.75],
          [4.870610, 52.370918, 3.75],
          [4.870628, 52.370979, 3.75],
          [4.870632, 52.370989, 3.75],
          [4.870633, 52.370992, 3.75],
          [4.870640, 52.371019, 3.75],
          [4.870658, 52.371075, 3.5],
          [4.870666, 52.371103, 3.5],
          [4.870579, 52.371083, 3.5],
          [4.870523, 52.371070, 3.5],
          [4.870502, 52.371065, 3.5],
          [4.870478, 52.371060, 3.5],
          [4.870410, 52.371043, 3.5],
          [4.870402, 52.371015, 3.5],
          [4.870397, 52.370995, 3.75],
          [4.870391, 52.370970, 3.75],
          [4.870390, 52.370967, 3.75],
          [4.870381, 52.370942, 3.75],
          [4.870370, 52.370895, 3.75],
          [4.870361, 52.370865, 3.75],
          [4.870407, 52.370874, 3.75],
          [4.870429, 52.370879, 3.75],
          [4.870452, 52.370884, 3.75],
          [4.870463, 52.370886, 3.75],
          [4.870511, 52.370896, 3.75],
          [4.870610, 52.370918, 3.75],
          [4.870698, 52.370937, 3.75],
          [4.871736, 52.371175, 3.5],
          [4.871967, 52.371232, 3.5],
          [4.872257, 52.371297, 3.75],
          [4.872446, 52.371340, 3.75],
          [4.873227, 52.371517, 4.5],
          [4.873907, 52.371672, 5.0],
          [4.873989, 52.371682, 5.0],
          [4.874003, 52.371688, 5.0],
          [4.874126, 52.371738, 5.0],
          [4.874247, 52.371788, 5.0],
          [4.874378, 52.371788, 4.75],
          [4.874709, 52.371865, 4.25],
          [4.874866, 52.371898, 3.75],
          [4.874957, 52.371926, 3.75],
          [4.875385, 52.372024, 3.25],
          [4.875486, 52.372047, 3.0],
          [4.875510, 52.372052, 3.0],
          [4.875602, 52.372074, 3.0],
          [4.875675, 52.372090, 3.0],
          [4.875731, 52.372102, 3.0],
          [4.875827, 52.372123, 3.0],
          [4.875851, 52.372129, 2.75],
          [4.875855, 52.372129, 2.75],
          [4.875875, 52.372134, 2.75],
          [4.875919, 52.372144, 2.75],
          [4.875958, 52.372152, 2.75],
          [4.876113, 52.372184, 2.5],
          [4.876181, 52.372201, 2.5],
          [4.876408, 52.372258, 2.25],
          [4.876463, 52.372270, 2.0],
          [4.876748, 52.372345, 2.0],
          [4.877082, 52.372436, 2.25],
          [4.877230, 52.372525, 2.75],
          [4.877272, 52.372548, 2.75],
          [4.878424, 52.372836, 5.0],
          [4.879967, 52.373222, 6.0],
          [4.880202, 52.373278, 6.0],
          [4.881847, 52.373688, 8.0],
          [4.882696, 52.373902, 9.5],
          [4.882701, 52.373915, 9.5],
          [4.882709, 52.373951, 9.5],
          [4.882701, 52.373915, 9.5],
          [4.882696, 52.373902, 9.5],
          [4.882797, 52.373926, 9.75],
          [4.882794, 52.373912, 9.75],
          [4.882776, 52.373816, 9.5],
          [4.882729, 52.373195, 8.0],
          [4.882672, 52.372635, 6.5],
          [4.882657, 52.372428, 6.0],
          [4.882657, 52.372426, 6.0],
          [4.882729, 52.372423, 6.0],
          [4.883109, 52.372410, 6.5],
          [4.883179, 52.372406, 6.5],
          [4.884574, 52.372359, 8.5],
          [4.884661, 52.372356, 8.5],
          [4.885073, 52.372347, 9.0],
          [4.885172, 52.372342, 9.0],
          [4.886785, 52.372288, 8.25],
          [4.886877, 52.372282, 8.25],
          [4.887260, 52.372259, 8.25],
          [4.887333, 52.372253, 8.25],
          [4.888182, 52.372198, 8.0],
          [4.888321, 52.372193, 8.0],
          [4.888630, 52.372187, 8.25],
          [4.888802, 52.372186, 8.5],
          [4.889256, 52.372240, 9.25],
          [4.889406, 52.372258, 9.75],
          [4.889517, 52.372277, 10.0],
          [4.889836, 52.372355, 10.75],
          [4.890187, 52.372481, 12.0],
          [4.890434, 52.372552, 12.5],
          [4.890512, 52.372568, 12.75],
          [4.890535, 52.372572, 12.75],
          [4.890600, 52.372585, 12.75],
          [4.890618, 52.372588, 12.75],
          [4.890637, 52.372592, 12.75],
          [4.890709, 52.372606, 13.0],
          [4.890699, 52.372642, 13.0],
          [4.890691, 52.372673, 13.0],
          [4.890672, 52.372754, 13.25],
          [4.890671, 52.372851, 13.5],
          [4.890710, 52.372878, 13.75],
          [4.890704, 52.373070, 14.0],
          [4.890716, 52.373182, 14.25],
          [4.890774, 52.373398, 14.75],
          [4.890843, 52.373545, 14.5],
          [4.890857, 52.373571, 14.25],
          [4.890864, 52.373606, 14.25],
          [4.890869, 52.373671, 14.0],
          [4.890904, 52.373743, 14.0],
          [4.890998, 52.373921, 13.5],
          [4.891200, 52.374152, 13.0],
          [4.891319, 52.374257, 12.75],
          [4.891776, 52.374786, 12.75],
          [4.891968, 52.375009, 12.5],
          [4.892092, 52.375127, 12.0],
          [4.892142, 52.375165, 11.75],
          [4.892461, 52.375389, 11.0],
          [4.892879, 52.375662, 10.0],
          [4.893849, 52.376304, 8.5],
          [4.894421, 52.376663, 8.5],
          [4.894890, 52.376914, 9.25],
          [4.895004, 52.376987, 9.5],
          [4.895100, 52.377060, 9.5],
          [4.895229, 52.377171, 9.5],
          [4.895396, 52.377336, 9.5],
          [4.895561, 52.377498, 9.5],
          [4.895648, 52.377580, 9.5],
          [4.895772, 52.377664, 9.75],
          [4.895918, 52.377720, 9.75],
          [4.896026, 52.377753, 9.5],
          [4.896709, 52.377902, 8.75],
          [4.896920, 52.377948, 8.0],
          [4.896977, 52.377958, 8.0],
          [4.897069, 52.377974, 7.75],
          [4.897054, 52.377987, 7.5],
          [4.897044, 52.377996, 7.5],
          [4.897025, 52.378013, 7.5],
          [4.897015, 52.378023, 7.5],
          [4.897007, 52.378030, 7.5],
          [4.896941, 52.378089, 7.5],
          [4.896898, 52.378139, 7.25],
          [4.896877, 52.378164, 7.25],
          [4.896848, 52.378197, 7.0],
          [4.896880, 52.378222, 7.0],
          [4.896936, 52.378262, 6.5],
          [4.896951, 52.378241, 6.5],
          [4.896936, 52.378262, 6.5],
          [4.896969, 52.378286, 6.5],
          [4.897154, 52.378422, 5.75],
          [4.897194, 52.378452, 5.75],
          [4.897235, 52.378482, 5.75],
          [4.897302, 52.378501, 5.5],
          [4.897336, 52.378520, 5.5],
          [4.897504, 52.378647, 5.25],
          [4.897689, 52.378806, 5.0],
          [4.897905, 52.379001, 4.75],
          [4.898071, 52.379143, 4.5],
          [4.898096, 52.379140, 4.5],
          [4.898105, 52.379149, 4.5],
          [4.898183, 52.379120, 4.25],
          [4.898230, 52.379167, 4.0],
          [4.898275, 52.379150, 4.0],
          [4.898230, 52.379167, 4.0],
          [4.898183, 52.379120, 4.25],
          [4.898105, 52.379149, 4.5],
          [4.898096, 52.379140, 4.5],
          [4.898071, 52.379143, 4.5],
          [4.898173, 52.379241, 4.5],
          [4.899031, 52.380115, 5.25],
          [4.899161, 52.380249, 4.0],
          [4.899354, 52.380449, 4.0],
          [4.899368, 52.380454, 4.0],
          [4.899401, 52.380483, 4.0],
          [4.899449, 52.380533, 4.0],
          [4.899461, 52.380542, 4.0],
          [4.899480, 52.380555, 4.0],
          [4.899505, 52.380560, 4.0],
          [4.899689, 52.380597],
          [4.900355, 52.381253],
          [4.900909, 52.381562],
          [4.902057, 52.381870],
          [4.902850, 52.381987],
          [4.903176, 52.382141],
          [4.903245, 52.382171],
          [4.903362, 52.382223],
          [4.903396, 52.382258],
          [4.903409, 52.382287],
          [4.903407, 52.382332],
          [4.903928, 52.382562, 2.5],
          [4.904404, 52.382773, 2.25],
          [4.904590, 52.382788, 2.0],
          [4.904708, 52.382816, 1.75],
          [4.905352, 52.383112, 1.75],
          [4.905552, 52.383200, 1.5],
          [4.906279, 52.383520, 1.25],
          [4.906347, 52.383567, 1.25],
          [4.906385, 52.383610, 1.25],
          [4.906400, 52.383651, 1.25],
          [4.906399, 52.384237, 2.5],
          [4.906407, 52.384380, 2.75],
          [4.906431, 52.384469, 2.75],
          [4.906469, 52.384571, 2.75],
          [4.906510, 52.384565, 2.75],
          [4.906588, 52.384566, 2.5],
          [4.906656, 52.384573, 2.5],
          [4.906712, 52.384588, 2.25],
          [4.907250, 52.384809, 2.0],
          [4.907513, 52.384916, 1.75],
          [4.907628, 52.384955, 1.5],
          [4.907766, 52.384985, 1.25],
          [4.908015, 52.385013, 0.75],
          [4.909155, 52.385047, 1.0],
          [4.909285, 52.385059, 1.25],
          [4.909524, 52.385106, 1.5],
          [4.909757, 52.385177, 2.0],
          [4.909679, 52.385272, 2.0],
          [4.909711, 52.385345, 2.25],
          [4.909785, 52.385440, 2.25],
          [4.909711, 52.385345, 2.25],
          [4.909679, 52.385272, 2.0],
          [4.909757, 52.385177, 2.0],
          [4.909871, 52.385219, 2.0],
          [4.910108, 52.385320, 2.25],
          [4.911141, 52.385759, 1.25],
          [4.912581, 52.386429, 0.75],
          [4.912989, 52.386632, 0.25],
          [4.913287, 52.386690, 0.0],
          [4.913388, 52.386721, 0.25],
          [4.913896, 52.386964, 1.75],
          [4.913966, 52.387006, 2.0],
          [4.914028, 52.387054, 2.25],
          [4.914330, 52.387361, 3.25],
          [4.915675, 52.388272, 3.75],
          [4.916874, 52.389104, 4.0],
          [4.917155, 52.389300, 3.5],
          [4.917363, 52.389477, 3.25],
          [4.917393, 52.389502, 3.0],
          [4.917733, 52.389796, 2.25],
          [4.917895, 52.389935, 1.5],
          [4.917949, 52.389991, 1.25],
          [4.918024, 52.390098, 1.5],
          [4.918118, 52.390287, 2.25],
          [4.918220, 52.390493, 2.75],
          [4.918329, 52.390624, 3.0],
          [4.918407, 52.390696, 3.5],
          [4.918530, 52.390791, 4.0],
          [4.918680, 52.390906, 4.5],
          [4.918759, 52.390985, 4.5],
          [4.919219, 52.391605, 5.75],
          [4.919249, 52.391657, 5.75],
          [4.919293, 52.391733, 5.75],
          [4.919650, 52.392436, 3.5],
          [4.919962, 52.392969, 4.5],
          [4.921286, 52.395546, 3.25],
          [4.921672, 52.396270, 3.5],
          [4.921706, 52.396392, 3.5],
          [4.921747, 52.396540, 3.75],
          [4.921736, 52.396668, 3.75],
          [4.921711, 52.396751, 3.75],
          [4.921615, 52.396889, 3.75],
          [4.921483, 52.397058, 3.75],
          [4.921212, 52.397325, 4.25],
          [4.920979, 52.397555, 4.75],
          [4.920709, 52.397807, 4.5],
          [4.920318, 52.398220, 4.5],
          [4.920233, 52.398360, 4.5],
          [4.920173, 52.398488, 4.5],
          [4.920130, 52.398625, 4.25],
          [4.920118, 52.398727, 4.25],
          [4.920126, 52.398841, 4.0],
          [4.920149, 52.398948, 4.0],
          [4.920256, 52.399168, 3.5],
          [4.920339, 52.399261, 3.5],
          [4.920506, 52.399372, 3.5],
          [4.920654, 52.399470, 3.5],
          [4.920537, 52.399534, 3.5],
          [4.920654, 52.399470, 3.5],
          [4.920791, 52.399394, 3.25],
          [4.920856, 52.399373, 3.0],
          [4.920930, 52.399366, 3.0],
          [4.921126, 52.399370, 2.75],
          [4.921174, 52.399363, 2.75],
          [4.921267, 52.399332, 2.5],
          [4.921306, 52.399308, 2.5],
          [4.921358, 52.399258, 2.25],
          [4.921730, 52.399377, 2.0],
          [4.921902, 52.399437, 2.0],
          [4.922035, 52.399494, 2.0],
          [4.922136, 52.399555, 2.0],
          [4.922190, 52.399602, 2.0],
          [4.922265, 52.399695, 2.0],
          [4.922361, 52.399871, 2.0],
          [4.922410, 52.400024, 2.0],
          [4.922430, 52.400139, 2.0],
          [4.922452, 52.400470, 2.5],
          [4.922472, 52.400617, 2.5],
          [4.922569, 52.400956, 2.75],
          [4.922634, 52.401118, 2.5],
          [4.922822, 52.401446, 2.25],
          [4.923705, 52.402598, 1.25],
          [4.923752, 52.402698, 1.25],
          [4.923906, 52.403204, 1.0],
          [4.923925, 52.403266, 1.0],
          [4.924034, 52.403538, 1.5],
          [4.924093, 52.403645, 1.75],
          [4.924263, 52.403850, 2.0],
          [4.924378, 52.404018, 2.0],
          [4.924424, 52.404088, 2.25],
          [4.924472, 52.404226, 2.0],
          [4.924574, 52.404787, 0.5],
          [4.924681, 52.405315, -0.25],
          [4.924692, 52.405371, -0.25],
          [4.924701, 52.405408, -0.25],
          [4.924792, 52.405941, -0.25],
          [4.924800, 52.406061, 0.0],
          [4.924791, 52.406264, 0.25],
          [4.924786, 52.406593, 1.0],
          [4.924795, 52.406653, 1.0],
          [4.924815, 52.406710, 1.25],
          [4.924945, 52.406953, 1.5],
          [4.925075, 52.407244, 2.25],
          [4.925125, 52.407411, 2.5],
          [4.925169, 52.407472, 2.5],
          [4.925276, 52.407545, 2.5],
          [4.925437, 52.407658, 2.25],
          [4.925798, 52.407931, 1.5],
          [4.925938, 52.408046, 1.0],
          [4.926358, 52.408425, 0.25],
          [4.926912, 52.408877, -0.25],
          [4.927113, 52.409019, -0.5],
          [4.927282, 52.409119, -0.5],
          [4.927398, 52.409175, -0.75],
          [4.927688, 52.409283, -1.0],
          [4.927764, 52.409323, -1.0],
          [4.927904, 52.409423, -0.75],
          [4.927985, 52.409497, -0.5],
          [4.928111, 52.409630, -0.25],
          [4.928165, 52.409713, 0.0],
          [4.928287, 52.409980, 0.75],
          [4.928385, 52.410153, 1.0],
          [4.928611, 52.410437, 1.0],
          [4.928935, 52.410753, 1.5],
          [4.929009, 52.410834, 1.75],
          [4.929079, 52.410935, 1.75],
          [4.929141, 52.411007, 1.75],
          [4.929218, 52.411086, 1.5],
          [4.929367, 52.411217, 1.25],
          [4.929503, 52.411318, 1.0],
          [4.929616, 52.411385, 0.75],
          [4.929944, 52.411551, -0.25],
          [4.930069, 52.411618, -0.75],
          [4.930230, 52.411695, -1.0],
          [4.930383, 52.411752, -1.0],
          [4.930548, 52.411809, -1.25],
          [4.930811, 52.411889, -1.5],
          [4.931102, 52.411922, -1.75],
          [4.931446, 52.411947, -2.25],
          [4.933050, 52.412062, -1.5],
          [4.933329, 52.412082, -1.0],
          [4.934412, 52.412171, -1.75],
          [4.934733, 52.412205, -2.25],
          [4.935099, 52.412266, -2.5],
          [4.935835, 52.412421, -2.75],
          [4.938100, 52.413036, -2.0],
          [4.938637, 52.413218, -1.5],
          [4.939450, 52.413520, -0.25],
          [4.939630, 52.413570, 0.0],
          [4.941322, 52.413906, 0.0],
          [4.941955, 52.414047, -1.0],
          [4.942082, 52.414076, -1.0],
          [4.942688, 52.414253, -0.5],
          [4.943017, 52.414381, 0.0],
          [4.943633, 52.414748, 0.0],
          [4.944039, 52.415059, -0.75],
          [4.944342, 52.415356, -1.25],
          [4.944642, 52.415796, -1.5],
          [4.944951, 52.416530, 0.25],
          [4.945010, 52.416670, 0.75],
          [4.945438, 52.417571, -3.0],
          [4.946013, 52.418851, -2.5],
          [4.946229, 52.419259, -1.75],
          [4.946805, 52.420537, -2.5],
          [4.946866, 52.420653, -2.5],
          [4.947064, 52.421158, -2.5],
          [4.947110, 52.421330, -2.75],
          [4.947115, 52.421461, -2.75],
          [4.947171, 52.421612, -2.75],
          [4.947222, 52.421727, -3.0],
          [4.947424, 52.421987, -3.25],
          [4.947509, 52.422065, -3.25],
          [4.947790, 52.422255, -3.25],
          [4.948048, 52.422421, -3.0],
          [4.948242, 52.422530, -3.0],
          [4.948694, 52.422758, -2.75],
          [4.948920, 52.422859, -2.75],
          [4.949108, 52.422930, -2.75],
          [4.949740, 52.423140, -3.5],
          [4.949853, 52.423184, -3.5],
          [4.949969, 52.423245, -3.75],
          [4.950065, 52.423327, -3.75],
          [4.950108, 52.423376, -3.5],
          [4.950174, 52.423487, -3.25],
          [4.950201, 52.423609, -2.75],
          [4.950217, 52.423888, -2.25],
          [4.950265, 52.425744, -0.75],
          [4.950237, 52.425885, -0.75],
          [4.950262, 52.426267, -0.25],
          [4.950420, 52.432380, -1.0],
          [4.950420, 52.432620, -1.0],
          [4.950540, 52.436930, -1.25],
          [4.950520, 52.437230, -1.5],
          [4.950264, 52.438576, -1.75],
          [4.950085, 52.439394, -1.75],
          [4.949884, 52.440507, -1.0],
          [4.949814, 52.440843, -0.25],
          [4.949633, 52.441788, -1.5],
          [4.949410, 52.443060, -1.25],
          [4.949181, 52.444297, -1.75],
          [4.948900, 52.445640, -1.75],
          [4.948850, 52.445940, -1.75],
          [4.948599, 52.447290, -1.5],
          [4.947645, 52.452172, -2.5],
          [4.947643, 52.452346, -2.5],
          [4.947681, 52.452487, -2.75],
          [4.948322, 52.453803, -2.25],
          [4.948916, 52.455008, -2.0],
          [4.948959, 52.455103, -2.0],
          [4.949350, 52.455900, -1.75],
          [4.949606, 52.456366, -2.0],
          [4.950078, 52.457361, -2.0],
          [4.950240, 52.457960, -2.5],
          [4.950280, 52.458320, -2.75],
          [4.950298, 52.458671, -2.5],
          [4.950274, 52.458869, -2.25],
          [4.950064, 52.459524, -2.25],
          [4.948930, 52.462624, -1.25],
          [4.948832, 52.462880, -1.5],
          [4.948732, 52.463150, -1.75],
          [4.948557, 52.463491, -2.0],
          [4.948474, 52.463488, -2.0],
          [4.948557, 52.463491, -2.0],
          [4.948519, 52.463740, -1.75],
          [4.948238, 52.464423, -1.0],
          [4.947852, 52.465359, -1.0],
          [4.947395, 52.466464, -1.0],
          [4.947330, 52.466620, -1.0],
          [4.946667, 52.468534, -0.75],
          [4.946580, 52.468900, -0.25],
          [4.946530, 52.469186, 0.0],
          [4.946550, 52.469630, 0.75],
          [4.946539, 52.470614, 0.0],
          [4.946588, 52.472181, -2.25],
          [4.946663, 52.474145, -1.0],
          [4.946630, 52.474960, -1.0],
          [4.946620, 52.475554, -0.25],
          [4.946780, 52.477920, -1.25],
          [4.946857, 52.478541, -1.0],
          [4.946818, 52.478702, -1.25],
          [4.946838, 52.479890, -1.0],
          [4.947522, 52.482452, -1.0],
          [4.948584, 52.486713, 0.0],
          [4.948690, 52.487094, 0.5],
          [4.948878, 52.487818, 0.0],
          [4.948893, 52.487874, 0.0],
          [4.949005, 52.488285, -1.75],
          [4.949080, 52.488521, -1.5],
          [4.949243, 52.489162, 0.0],
          [4.949252, 52.489551, 0.0],
          [4.949203, 52.489739, 0.0],
          [4.949189, 52.489787, 0.0],
          [4.948847, 52.490723, 0.0],
          [4.948524, 52.491715, -1.0],
          [4.948167, 52.492736, -0.25],
          [4.947749, 52.492963, -0.25],
          [4.947484, 52.493078, -0.25],
          [4.947375, 52.493133, -0.25],
          [4.947688, 52.493436, 0.0],
          [4.947815, 52.493589, 0.0],
          [4.947849, 52.493684, 0.0],
          [4.947776, 52.493915, -0.25],
          [4.947529, 52.494701, -0.25],
          [4.946987, 52.496296, -1.0],
          [4.946944, 52.496426, -1.0],
          [4.946878, 52.496641, -1.0],
          [4.946843, 52.496761, -1.0],
          [4.946662, 52.496774, -0.75],
          [4.946843, 52.496761, -1.0],
          [4.946878, 52.496641, -1.0],
          [4.945919, 52.496496, -1.0],
          [4.945686, 52.496517, -1.0],
          [4.945894, 52.496556, -1.0],
          [4.947360, 52.496744, -1.0],
          [4.947492, 52.496771, -1.0],
          [4.947607, 52.496782, -1.0],
          [4.947801, 52.496811, -1.0],
          [4.947998, 52.496834, -1.0],
          [4.947824, 52.497184, -1.0],
          [4.947737, 52.497288, -1.0],
          [4.947235, 52.498361, -0.75],
          [4.947153, 52.498576, -0.5],
          [4.947140, 52.498612, -0.5],
          [4.947208, 52.498741, -0.5],
          [4.947331, 52.498855, -0.25],
          [4.947442, 52.498940, -0.25],
          [4.947533, 52.499072, 0.0],
          [4.947533, 52.499240, 0.0],
          [4.947497, 52.499345, 0.0],
          [4.947461, 52.499446, -0.25],
          [4.947346, 52.499717, -0.5],
          [4.947267, 52.499812, -0.75],
          [4.947158, 52.499898, -0.75],
          [4.946764, 52.500129, -0.75],
          [4.946580, 52.500269, -0.75],
          [4.946764, 52.500129, -0.75],
          [4.946823, 52.500165, -0.75],
          [4.946923, 52.500227, -0.75],
          [4.947025, 52.500290, -0.75],
          [4.947376, 52.500369, -0.5],
          [4.947402, 52.500400, -0.5],
          [4.947404, 52.500427, -0.5],
          [4.948266, 52.500614, 0.25],
          [4.948356, 52.500657, 0.5],
          [4.948285, 52.500777, 0.5],
          [4.948356, 52.500657, 0.5],
          [4.949163, 52.500858, 1.0],
          [4.949940, 52.501108, 1.0],
          [4.950236, 52.501232, 0.75],
          [4.950850, 52.501575, 0.75],
          [4.951024, 52.501719, 0.75],
          [4.951178, 52.501913, 0.75],
          [4.951483, 52.502325, 0.75],
          [4.951534, 52.502488, 0.75],
          [4.951483, 52.502540, 0.75],
          [4.951084, 52.502787, 0.25],
          [4.952433, 52.503644, 0.75],
          [4.953071, 52.504046, 1.5],
          [4.953235, 52.504149, 1.75],
          [4.952993, 52.504267, 1.75],
          [4.952030, 52.504586, 2.0],
          [4.951872, 52.504674, 2.25],
          [4.950303, 52.505247, 2.0],
          [4.950294, 52.505233, 2.0],
          [4.950303, 52.505247, 2.0],
          [4.950297, 52.505413, 2.0],
          [4.950400, 52.505496, 2.0],
          [4.950490, 52.505605, 2.0],
          [4.950535, 52.505730, 2.0],
          [4.950883, 52.506120, 1.5],
          [4.950892, 52.506131, 1.5],
          [4.951283, 52.506558, 1.0],
          [4.951365, 52.506613, 1.0],
          [4.951301, 52.506665, 1.0],
          [4.951215, 52.506818, 1.0],
          [4.951149, 52.507059, 1.25],
          [4.951150, 52.507193, 1.25],
          [4.951173, 52.507320, 1.5],
          [4.951401, 52.507290, 2.0],
          [4.951337, 52.507165, 1.5],
          [4.951324, 52.507097, 1.5],
          [4.951331, 52.507043, 1.5],
          [4.951387, 52.506916, 1.25],
          [4.951409, 52.506884, 1.25],
          [4.951484, 52.506827, 1.25],
          [4.951371, 52.506705, 1.0],
          [4.951484, 52.506827, 1.25],
          [4.951409, 52.506884, 1.25],
          [4.951387, 52.506916, 1.25],
          [4.951331, 52.507043, 1.5],
          [4.951324, 52.507097, 1.5],
          [4.951337, 52.507165, 1.5],
          [4.951401, 52.507290, 2.0],
          [4.951173, 52.507320, 1.5],
          [4.951204, 52.507387, 1.75],
          [4.951288, 52.507517, 2.0],
          [4.951443, 52.507714, 2.5],
          [4.951598, 52.507904, 2.75],
          [4.951578, 52.508112, 2.75],
          [4.951503, 52.508096, 2.5],
          [4.951240, 52.508048, 2.25],
          [4.950789, 52.507587, 1.0],
          [4.950540, 52.507341, 0.5],
          [4.950452, 52.507248, 0.5],
          [4.950344, 52.507140, 0.5],
          [4.950227, 52.507023, 0.5],
          [4.950135, 52.506967, 0.5],
          [4.950073, 52.506949, 0.5],
          [4.950011, 52.506950, 0.5],
          [4.949945, 52.506957, 0.5],
          [4.949865, 52.506975, 0.75],
          [4.949811, 52.506995, 0.75],
          [4.949258, 52.507171, 1.25],
          [4.949018, 52.507252, 1.25],
          [4.947762, 52.507677, 3.0],
          [4.947751, 52.507680, 3.0],
          [4.947762, 52.507677, 3.0],
          [4.947821, 52.507747, 3.0],
          [4.948079, 52.508049, 3.5],
          [4.948187, 52.508164, 3.75],
          [4.948575, 52.508581, 3.75],
          [4.948825, 52.508836, 3.75],
          [4.948955, 52.508970, 3.75],
          [4.949397, 52.509418, 3.25],
          [4.949445, 52.509472, 3.25],
          [4.949504, 52.509518, 3.0],
          [4.949640, 52.509431, 3.0],
          [4.949696, 52.509476, 2.75],
          [4.949748, 52.509517, 2.75],
          [4.949799, 52.509558, 2.75],
          [4.949831, 52.509642, 2.5],
          [4.950318, 52.509967, 2.0],
          [4.950400, 52.510072, 1.75],
          [4.950539, 52.510125, 2.0],
          [4.950804, 52.510229, 2.0],
          [4.950927, 52.510279, 1.75],
          [4.951052, 52.510340, 1.75],
          [4.951175, 52.510433, 2.0],
          [4.951310, 52.510566, 2.0],
          [4.951766, 52.511082, 2.75],
          [4.952225, 52.511547, 2.75],
          [4.952403, 52.511727, 2.75],
          [4.952449, 52.511768, 2.75],
          [4.952506, 52.511803, 2.75],
          [4.952572, 52.511840, 2.5],
          [4.952646, 52.511871, 2.5],
          [4.952713, 52.511890, 2.25],
          [4.952902, 52.511927, 2.0],
          [4.953025, 52.511946, 2.0],
          [4.953258, 52.511966, 1.5],
          [4.953254, 52.512052, 1.5],
          [4.953248, 52.512144, 1.5],
          [4.953062, 52.512135, 1.75],
          [4.952970, 52.512118, 1.75],
          [4.953062, 52.512135, 1.75],
          [4.952857, 52.512733, 1.5],
          [4.952702, 52.513300, 1.75],
          [4.952520, 52.513961, 2.0],
          [4.952301, 52.514759, 1.25],
          [4.952269, 52.514880, 1.0],
          [4.952361, 52.515061, 0.75],
          [4.952408, 52.515231, 0.0],
          [4.952447, 52.515289, 0.0],
          [4.952500, 52.515339, 0.0],
          [4.953133, 52.515746, -1.0],
          [4.953302, 52.515826, -1.0],
          [4.954187, 52.516183, 0.25],
          [4.954334, 52.516283, 0.75],
          [4.954354, 52.516297, 1.0],
          [4.954386, 52.516357, 1.0],
          [4.954418, 52.516481, 1.5],
          [4.954546, 52.517303, 0.75],
          [4.954578, 52.517400, 0.5],
          [4.954582, 52.517494, 0.5],
          [4.954736, 52.518197, 0.25],
          [4.955093, 52.519382, 1.25],
          [4.955228, 52.519801, 1.5],
          [4.955350, 52.520180, 2.0],
          [4.955384, 52.520261, 2.0],
          [4.955439, 52.520339, 1.75],
          [4.955575, 52.520423, 1.75],
          [4.955673, 52.520465, 1.75],
          [4.955750, 52.520484, 1.75],
          [4.955705, 52.520648, 1.25],
          [4.955702, 52.520756, 1.0],
          [4.955763, 52.521139, 0.5],
          [4.955901, 52.521892, 0.0],
          [4.956090, 52.522576, -0.25],
          [4.956129, 52.522766, 0.0],
          [4.956144, 52.522909, 0.0],
          [4.956165, 52.525262, -1.0],
          [4.956183, 52.525619, -0.5],
          [4.956229, 52.525841, -0.5],
          [4.956659, 52.526951, 0.75],
          [4.956788, 52.527396, -0.5],
          [4.956901, 52.527845, -0.75],
          [4.956935, 52.527970, -0.75],
          [4.957189, 52.528928, 0.0],
          [4.957237, 52.529105, 0.25],
          [4.957373, 52.529495, -1.0],
          [4.957523, 52.529801, -2.25],
          [4.957707, 52.530111, -2.75],
          [4.957901, 52.530319, -2.5],
          [4.958466, 52.530781, -1.0],
          [4.958502, 52.530827, -1.0],
          [4.958515, 52.530866, -1.0],
          [4.958513, 52.530908, -1.0],
          [4.958501, 52.530931, -1.0],
          [4.958478, 52.530956, -1.0],
          [4.958336, 52.531044, -1.25],
          [4.958301, 52.531082, -1.25],
          [4.958271, 52.531150, -1.5],
          [4.958279, 52.531184, -1.5],
          [4.958530, 52.531569, -1.75],
          [4.959636, 52.533253, -1.75],
          [4.959679, 52.533282, -1.75],
          [4.959710, 52.533294, -1.75],
          [4.959752, 52.533305, -1.75],
          [4.959840, 52.533313, -1.75],
          [4.959920, 52.533301, -1.75],
          [4.960157, 52.533223, -2.0],
          [4.960203, 52.533220, -2.0],
          [4.960250, 52.533232, -2.0],
          [4.960370, 52.533319, -2.25],
          [4.959908, 52.533593, -1.5],
          [4.959929, 52.533611, -1.5],
          [4.959908, 52.533593, -1.5],
          [4.959867, 52.533618, -1.5],
          [4.959599, 52.533738, -1.5],
          [4.959519, 52.533774, -1.25],
          [4.959959, 52.534198, -0.75],
          [4.960446, 52.534794, -1.0],
          [4.960968, 52.535490, -1.0],
          [4.961559, 52.536279, -1.5],
          [4.961740, 52.536443, -1.5],
          [4.961925, 52.536582, -1.75],
          [4.962770, 52.537050, -1.75],
          [4.963547, 52.537516, -1.0],
          [4.963770, 52.537650, -1.25],
          [4.964023, 52.537844, -1.75],
          [4.964447, 52.538260, -2.5],
          [4.965450, 52.539220, -2.0],
          [4.965624, 52.539373, -2.25],
          [4.965820, 52.539505, -2.25],
          [4.966270, 52.539730, -1.75],
          [4.967537, 52.540203, -1.5],
          [4.967690, 52.540290, -1.75],
          [4.968703, 52.541004, -2.0],
          [4.969578, 52.541647, -2.0],
          [4.970774, 52.542260, -2.75],
          [4.971098, 52.542417, -2.25],
          [4.972137, 52.542916, -2.25],
          [4.973035, 52.543358, -2.25],
          [4.973169, 52.543443, -2.25],
          [4.973376, 52.543608, -2.5],
          [4.975082, 52.545100, -3.5],
          [4.975403, 52.545428, -2.5],
          [4.976015, 52.546317, -2.5],
          [4.976230, 52.546701, -2.75],
          [4.976244, 52.546822, -2.75],
          [4.976227, 52.546939, -2.5],
          [4.976154, 52.547155, -2.5],
          [4.975833, 52.547708, -2.25],
          [4.975407, 52.548311, 0.0],
          [4.975372, 52.548362, 0.0],
          [4.975407, 52.548311, 0.0],
          [4.975524, 52.548325, 0.0],
          [4.975859, 52.548418, 0.0],
          [4.976287, 52.548544, -0.5],
          [4.976240, 52.548800, -0.75],
          [4.976150, 52.548970, -0.75],
          [4.975820, 52.549240, -1.0],
          [4.975796, 52.549306, -1.25],
          [4.975861, 52.549526, -1.75],
          [4.977066, 52.551825, -2.0],
          [4.977918, 52.553452, -2.25],
          [4.977951, 52.553604, -2.25],
          [4.977452, 52.556818, -2.75],
          [4.977050, 52.559374, -0.5],
          [4.976764, 52.560975, -1.0],
          [4.976902, 52.561178, -1.25],
          [4.977640, 52.561610, -0.75],
          [4.977930, 52.561830, -0.25],
          [4.978731, 52.562322, 0.25],
          [4.979630, 52.562880, -0.75],
          [4.980127, 52.563223, -1.0],
          [4.980662, 52.563623, -1.5],
          [4.980764, 52.563699, -1.75],
          [4.981311, 52.564031, -1.5],
          [4.981993, 52.564460, -1.25],
          [4.983248, 52.565222, -1.0],
          [4.985159, 52.566478, -0.25],
          [4.985560, 52.566730, -0.75],
          [4.986227, 52.567030, -1.75],
          [4.986582, 52.567178, -1.75],
          [4.987220, 52.567520, -1.0],
          [4.989316, 52.568517, -1.0],
          [4.989640, 52.568750, -0.75],
          [4.990336, 52.569276, -0.25],
          [4.991110, 52.569796, -1.0],
          [4.991856, 52.570317, 0.0],
          [4.991904, 52.570476, 0.0],
          [4.991970, 52.570645, 0.0],
          [4.992022, 52.570746, 0.0],
          [4.992098, 52.570852, 0.0],
          [4.992241, 52.571026, -0.5],
          [4.992384, 52.571101, -0.5],
          [4.992541, 52.571183, -0.75],
          [4.992610, 52.571221, -0.75],
          [4.992946, 52.571406, -0.75],
          [4.993439, 52.571775, 0.0],
          [4.993747, 52.572062, -0.5],
          [4.994017, 52.572213, -0.75],
          [4.994354, 52.572445, -0.5],
          [4.994601, 52.572579, -0.5],
          [4.994957, 52.572801, -0.25],
          [4.995559, 52.573174, -0.75],
          [4.996196, 52.573586, -0.5],
          [4.996557, 52.573829, 0.25],
          [4.996746, 52.573895, 0.5],
          [4.997157, 52.574130, 0.75],
          [4.997476, 52.574301, 0.75],
          [4.997823, 52.574532, 0.5],
          [4.997984, 52.574653, 0.5],
          [4.998031, 52.574763, 0.5],
          [4.997970, 52.574804, 0.5],
          [4.997907, 52.574894, 0.25],
          [4.998102, 52.574955, 0.5],
          [4.998194, 52.574985, 0.75],
          [4.998263, 52.574998, 0.75],
          [4.998379, 52.574943, 0.75],
          [4.998535, 52.574923, 0.75],
          [4.998655, 52.574969, 0.75],
          [4.998736, 52.575011, 0.75],
          [4.999016, 52.575202, 0.75],
          [4.999156, 52.575282, 0.5],
          [4.999369, 52.575375, 0.5],
          [4.999903, 52.575594, 0.5],
          [5.000800, 52.575889, 0.75],
          [5.000837, 52.575900, 0.5],
          [5.001182, 52.576001, 0.25],
          [5.002448, 52.576412, 0.0],
          [5.002799, 52.576528, -0.25],
          [5.002862, 52.576548, -0.25],
          [5.004607, 52.577079, -0.25],
          [5.005204, 52.577306, 0.0],
          [5.006400, 52.577702, -0.25],
          [5.007948, 52.578164, -0.5],
          [5.008543, 52.578353, 0.0],
          [5.009112, 52.578567, -0.75],
          [5.009470, 52.578710, -1.25],
          [5.009629, 52.578811, -1.5],
          [5.009812, 52.578887, -1.75],
          [5.010087, 52.578966, -2.25],
          [5.010432, 52.579029, -2.5],
          [5.010713, 52.579107, -2.75],
          [5.010849, 52.579187, -3.0],
          [5.011002, 52.579276, -2.75],
          [5.011302, 52.579412, -2.5],
          [5.011499, 52.579456, -2.5],
          [5.011792, 52.579486, -2.25],
          [5.012157, 52.579572, -2.0],
          [5.013041, 52.579797, -1.5],
          [5.013745, 52.580028, -1.5],
          [5.014240, 52.580246, -2.0],
          [5.014365, 52.580301, -2.0],
          [5.014541, 52.580334, -2.0],
          [5.015275, 52.580475, -1.75],
          [5.015354, 52.580507, -1.75],
          [5.015368, 52.580588, -1.25],
          [5.015395, 52.580735, -1.0],
          [5.015416, 52.580849, -1.0],
          [5.015420, 52.580869, -1.0],
          [5.015811, 52.581617, -1.75],
          [5.015882, 52.581754, -2.0],
          [5.016076, 52.582053, -2.25],
          [5.016180, 52.582180, -2.5],
          [5.016260, 52.582260, -2.25],
          [5.016630, 52.582480, -2.0],
          [5.017297, 52.582773, -2.0],
          [5.018040, 52.583100, -2.25],
          [5.018940, 52.583510, -3.0],
          [5.019207, 52.583634, -2.75],
          [5.019997, 52.584002, -2.0],
          [5.021829, 52.584862, -1.0],
          [5.021897, 52.584883, -1.0],
          [5.022017, 52.584920, -1.0],
          [5.021620, 52.585470, -1.5],
          [5.020890, 52.586650, -2.75],
          [5.020610, 52.586920, -2.25],
          [5.019640, 52.587948, -1.25],
          [5.019055, 52.588663, -1.5],
          [5.018897, 52.588845, -1.25],
          [5.018398, 52.589350, -1.0],
          [5.018107, 52.589620, -1.25],
          [5.017880, 52.589816, -1.5],
          [5.017571, 52.590116, -1.75],
          [5.017193, 52.590579, -2.0],
          [5.016610, 52.591338, -0.75],
          [5.016348, 52.591694, -0.25],
          [5.016220, 52.591881, -0.5],
          [5.016147, 52.592050, -0.5],
          [5.016148, 52.592122, -0.5],
          [5.016150, 52.592210, -0.5],
          [5.016260, 52.592370, -0.25],
          [5.016493, 52.592562, 0.0],
          [5.017077, 52.592913, 0.25],
          [5.017282, 52.593060, 0.5],
          [5.017420, 52.593210, 0.75],
          [5.017623, 52.593490, 0.75],
          [5.017699, 52.593671, 0.75],
          [5.017734, 52.593778, 0.5],
          [5.017736, 52.593839, 0.5],
          [5.017708, 52.593927, 0.75],
          [5.017588, 52.594227, 0.75],
          [5.017434, 52.594686, 0.25],
          [5.017449, 52.594809, 0.0],
          [5.017468, 52.594977, 0.0],
          [5.017488, 52.595093, 0.0],
          [5.017710, 52.595920, 0.0],
          [5.017753, 52.596231, -0.25],
          [5.017772, 52.596345, -0.25],
          [5.017825, 52.596856, -0.75],
          [5.017873, 52.597360, -0.5],
          [5.017934, 52.597638, -0.5],
          [5.018153, 52.598446, -0.25],
          [5.018401, 52.599268, 0.0],
          [5.018596, 52.599810, -1.5],
          [5.019144, 52.601219, -0.25],
          [5.019330, 52.601618, -0.75],
          [5.019409, 52.601788, -0.5],
          [5.019442, 52.601867, -0.5],
          [5.019506, 52.602046, -0.5],
          [5.019508, 52.602083, -0.5],
          [5.019483, 52.602147, -0.5],
          [5.019451, 52.602180, -0.5],
          [5.019387, 52.602221, -0.5],
          [5.019337, 52.602242, -0.75],
          [5.019239, 52.602269, -0.75],
          [5.019179, 52.602277, -0.75],
          [5.018377, 52.602230, -1.5],
          [5.018142, 52.602224, -1.25],
          [5.017498, 52.602246, -0.5],
          [5.017201, 52.602244, -0.5],
          [5.016956, 52.602227, -0.5],
          [5.016831, 52.602214, -0.5],
          [5.016546, 52.602180, -0.75],
          [5.016278, 52.602139, -1.0],
          [5.015640, 52.602080, -1.25],
          [5.014025, 52.601994, -1.0],
          [5.013494, 52.601997, -1.0],
          [5.013473, 52.602081, -1.0],
          [5.013438, 52.602229, -1.0],
          [5.013422, 52.602336, -1.0],
          [5.013437, 52.602507, -1.0],
          [5.013935, 52.604025, -3.0],
          [5.014333, 52.605005, -2.75],
          [5.014462, 52.605266, -2.25],
          [5.014601, 52.605481, -1.75],
          [5.014730, 52.605660, -1.5],
          [5.014996, 52.605975, -1.25],
          [5.015267, 52.606280, -1.75],
          [5.015759, 52.606857, -2.25],
          [5.016421, 52.607597, -2.25],
          [5.016650, 52.607810, -2.75],
          [5.016990, 52.608130, -3.5],
          [5.017119, 52.608222, -3.5],
          [5.017244, 52.608293, -3.75],
          [5.017363, 52.608338, -4.0],
          [5.017493, 52.608374, -4.0],
          [5.018237, 52.608455, -3.25],
          [5.018440, 52.608501, -3.0],
          [5.019091, 52.608727, -2.0],
          [5.019235, 52.608786, -1.75],
          [5.019372, 52.608857, -1.5],
          [5.019462, 52.608925, -1.25],
          [5.019577, 52.609067, -1.0],
          [5.019617, 52.609147, -0.75],
          [5.019647, 52.609240, -0.75],
          [5.019657, 52.609346, -0.75],
          [5.019636, 52.609438, -0.75],
          [5.019576, 52.609532, -0.75],
          [5.019517, 52.609590, -0.75],
          [5.019419, 52.609648, -0.75],
          [5.018891, 52.609822, -2.5],
          [5.018733, 52.609891, -3.0],
          [5.018685, 52.609926, -3.0],
          [5.018636, 52.609975, -3.25],
          [5.018599, 52.610039, -3.25],
          [5.018580, 52.610107, -3.25],
          [5.018584, 52.610169, -3.25],
          [5.018610, 52.610230, -3.0],
          [5.019268, 52.611153, -3.0],
          [5.019304, 52.611217, -3.0],
          [5.019327, 52.611314, -3.0],
          [5.019330, 52.611419, -3.0],
          [5.019272, 52.611749, -3.0],
          [5.019275, 52.612065, -3.0],
          [5.019283, 52.612446, -3.0],
          [5.019280, 52.612621, -3.0],
          [5.019232, 52.612839, -3.0],
          [5.018976, 52.613472, -3.0],
          [5.018833, 52.613864, -3.0],
          [5.018099, 52.615488, -0.5],
          [5.017857, 52.616196, 0.25],
          [5.017545, 52.616958, 0.25],
          [5.017289, 52.617540, 0.25],
          [5.017088, 52.618037, 0.25],
          [5.016851, 52.618524, 0.25],
          [5.016070, 52.620176, -1.5],
          [5.015725, 52.620923, -0.75],
          [5.015453, 52.621450, -0.25],
          [5.015331, 52.621667, 0.0],
          [5.015324, 52.621944, -0.25],
          [5.015298, 52.622183, -0.5],
          [5.015252, 52.622276, -0.5],
          [5.015234, 52.622337, -0.75],
          [5.015196, 52.622578, -0.75],
          [5.015198, 52.622782, -0.75],
          [5.015198, 52.622825, -0.75],
          [5.015198, 52.622782, -0.75],
          [5.015180, 52.622781, -0.75],
          [5.015068, 52.622778, -0.75],
          [5.015030, 52.622778, -0.75],
          [5.015026, 52.622847, -0.75],
          [5.015226, 52.623623, -1.0],
          [5.015283, 52.623982, -1.5],
          [5.015350, 52.625260, -1.25],
          [5.015424, 52.626226, -0.25],
          [5.015543, 52.626923, -0.25],
          [5.015599, 52.627119, -0.5],
          [5.015676, 52.627303, -0.75],
          [5.016181, 52.628005, -1.25],
          [5.016518, 52.628456, -1.0],
          [5.016745, 52.628866, -0.75],
          [5.016811, 52.629059, -0.75],
          [5.016893, 52.629651, -0.25],
          [5.016917, 52.629830, 0.0],
          [5.017036, 52.630372, 0.0],
          [5.017116, 52.630666, -0.25],
          [5.017141, 52.630760, -0.25],
          [5.017222, 52.631005, -0.25],
          [5.017339, 52.631230, -0.5],
          [5.017470, 52.631430, -0.5],
          [5.017785, 52.631749, -0.75],
          [5.018136, 52.632000, -1.0],
          [5.018620, 52.632210, -1.0],
          [5.019290, 52.632420, -0.5],
          [5.019650, 52.632550, 0.0],
          [5.020480, 52.632800, 0.25],
          [5.020930, 52.632900, 0.0],
          [5.021500, 52.632990, -0.75],
          [5.023025, 52.633180, -1.0],
          [5.023960, 52.633291, -1.0],
          [5.024265, 52.633345, 0.0],
          [5.024740, 52.633444, 0.25],
          [5.025540, 52.633628, 0.25],
          [5.026059, 52.633758, 0.25],
          [5.026404, 52.633859, 0.25],
          [5.026677, 52.633956, 0.25],
          [5.027115, 52.634152, 0.25],
          [5.027634, 52.634432, 0.25],
          [5.028530, 52.635024, -0.75],
          [5.029287, 52.635506, -0.75],
          [5.029452, 52.635592, -0.75],
          [5.029632, 52.635669, -0.75],
          [5.029863, 52.635748, -0.75],
          [5.030124, 52.635816, -0.75],
          [5.030346, 52.635856, -1.0],
          [5.031761, 52.636010, 0.0],
          [5.032042, 52.636044, -0.25],
          [5.032229, 52.636074, -0.25],
          [5.032390, 52.636107, -0.25],
          [5.033340, 52.636376, -0.25],
          [5.033573, 52.636424, -0.25],
          [5.033840, 52.636463, -0.25],
          [5.034958, 52.636596, -0.25],
          [5.035457, 52.636671, 0.75],
          [5.036130, 52.636781, 0.75],
          [5.036388, 52.636810, 0.5],
          [5.036651, 52.636809, 0.5],
          [5.038038, 52.636709, 0.25],
          [5.038283, 52.636707, 0.0],
          [5.038384, 52.636716, 0.0],
          [5.038487, 52.636733, 0.0],
          [5.038699, 52.636791, 0.0],
          [5.038794, 52.636827, 0.0],
          [5.038870, 52.636862, 0.0],
          [5.038973, 52.636923, 0.0],
          [5.039054, 52.636984, 0.0],
          [5.039177, 52.637107, 0.0],
          [5.039247, 52.637193, 0.0],
          [5.039483, 52.637573, 0.0],
          [5.039735, 52.638070, 0.0],
          [5.039931, 52.638388, 0.0],
          [5.040130, 52.638625, 0.0],
          [5.040448, 52.638937, 0.0],
          [5.040674, 52.639130, 0.0],
          [5.040897, 52.639301, 0.0],
          [5.041132, 52.639449, 0.0],
          [5.041267, 52.639524, 0.0],
          [5.041620, 52.639700, 0.0],
          [5.042445, 52.640072, 1.0],
          [5.042722, 52.640212, 1.0],
          [5.042964, 52.640351, 1.0],
          [5.043054, 52.640415, 1.0],
          [5.043599, 52.640971, -1.0],
          [5.043690, 52.641050, -1.0],
          [5.043886, 52.641179, -1.0],
          [5.044030, 52.641249, -1.0],
          [5.044180, 52.641310, -1.0],
          [5.044680, 52.641500, -1.0],
          [5.045578, 52.641765, -1.25],
          [5.046126, 52.641904, -0.25],
          [5.047160, 52.642120, 0.25],
          [5.048055, 52.642292, 0.5],
          [5.048417, 52.642351, 1.0],
          [5.048638, 52.642366, 1.0],
          [5.048895, 52.642373, 1.0],
          [5.049313, 52.642356, 1.0],
          [5.049727, 52.642319, 1.0],
          [5.050127, 52.642256, 1.0],
          [5.050348, 52.642223, 1.25],
          [5.050551, 52.642193, 1.25],
          [5.050980, 52.642115, 1.5],
          [5.051336, 52.642040, 1.5],
          [5.051631, 52.641974, 1.5],
          [5.051749, 52.641948, 1.5],
          [5.051988, 52.641891, 1.75],
          [5.052093, 52.641872, 1.75],
          [5.052193, 52.641877, 1.75],
          [5.052273, 52.641892, 2.0],
          [5.052280, 52.641877, 2.0],
          [5.052273, 52.641892, 2.0],
          [5.052243, 52.641973, 2.0],
          [5.052199, 52.642083, 2.25],
          [5.052166, 52.642181, 2.25],
          [5.051928, 52.642826, 2.5],
          [5.051684, 52.643514, 2.0],
          [5.051613, 52.643981, 1.75],
          [5.051607, 52.644053, 1.75],
          [5.051681, 52.644075, 2.0],
          [5.051772, 52.644102, 2.0],
          [5.051766, 52.644188, 1.75],
          [5.051765, 52.644264, 1.75],
          [5.051757, 52.644337, 1.75],
          [5.051810, 52.644374, 1.75],
          [5.051857, 52.644436, 1.75],
          [5.051798, 52.644469, 1.75],
          [5.051738, 52.644522, 1.75],
          [5.051508, 52.644777, 1.75],
          [5.051419, 52.644870, 1.5],
          [5.051341, 52.644937, 1.5],
          [5.051266, 52.645000, 1.5],
          [5.051170, 52.645054, 1.25],
          [5.051065, 52.645107, 1.0],
          [5.050949, 52.645156, 0.75],
          [5.050785, 52.645205, 0.25],
          [5.050591, 52.645244, 0.0],
          [5.049853, 52.645358, -0.25],
          [5.049729, 52.645399, -0.25],
          [5.049623, 52.645449, -0.5],
          [5.049501, 52.645537, -0.25],
          [5.049461, 52.645572, -0.25],
          [5.049397, 52.645631, -0.25],
          [5.049338, 52.645700, -0.25],
          [5.049269, 52.645837, 0.0],
          [5.049227, 52.646010, 0.0],
          [5.049254, 52.646078, 0.0],
          [5.049268, 52.646136, 0.0],
          [5.049220, 52.646230, 0.0],
          [5.049123, 52.646342, 0.0],
          [5.049033, 52.646390, 0.0],
          [5.048969, 52.646469, 0.0],
          [5.048813, 52.646640, 0.0],
          [5.048776, 52.646668, 0.0],
          [5.048630, 52.646769, 0.0],
          [5.048412, 52.646949, -0.25],
          [5.048073, 52.647187, -0.25],
          [5.047685, 52.647407, 0.0],
          [5.047414, 52.647529, 0.0],
          [5.047382, 52.647554, 0.0],
          [5.047348, 52.647609, 0.0],
          [5.047328, 52.647692, 0.0],
          [5.047473, 52.647735, 0.0],
          [5.047328, 52.647692, 0.0],
          [5.047250, 52.647811, 0.0],
          [5.047165, 52.647945, 0.0],
          [5.047118, 52.648025, 0.0],
          [5.046992, 52.648061, 0.0],
          [5.046874, 52.648112, 0.0],
          [5.046745, 52.648342, 0.0],
          [5.046519, 52.648807, -0.25],
          [5.046528, 52.648867, -0.5],
          [5.046515, 52.648936, -0.5],
          [5.046420, 52.649132, -0.5],
          [5.046390, 52.649250, -0.5],
          [5.046259, 52.649631, -0.25],
          [5.046148, 52.650041, -0.5],
          [5.046097, 52.650155, -0.25],
          [5.045922, 52.650413, 0.0],
          [5.045839, 52.650552, 0.25],
          [5.045703, 52.650841, 0.75],
          [5.045469, 52.651412, -0.5],
          [5.045248, 52.652014, -1.5],
          [5.045147, 52.652318, -1.75],
          [5.045024, 52.652749, -1.5],
          [5.044923, 52.653051, -1.25],
          [5.044796, 52.653373, -1.0],
          [5.044564, 52.654009, -1.0],
          [5.044329, 52.654593, -1.5],
          [5.044328, 52.654642, -1.5],
          [5.044310, 52.654693, -1.75],
          [5.044240, 52.654819, -1.75],
          [5.043983, 52.655522, -2.0],
          [5.043933, 52.655766, -2.0],
          [5.043922, 52.655992, -2.0],
          [5.043892, 52.656105, -2.0],
          [5.043860, 52.656195, -2.0],
          [5.043760, 52.656426, -2.25],
          [5.043688, 52.656521, -2.25],
          [5.043578, 52.656641, -2.5],
          [5.043550, 52.656701, -2.5],
          [5.043015, 52.658111, -2.5],
          [5.042930, 52.658376, -2.25],
          [5.042810, 52.658836, -2.0],
          [5.042657, 52.659366, -2.0],
          [5.042326, 52.660175, -2.75],
          [5.042262, 52.660351, -2.5],
          [5.042236, 52.660542, -2.25],
          [5.042206, 52.660596, -2.25],
          [5.042118, 52.660713, -2.0],
          [5.041962, 52.661141, -1.5],
          [5.041551, 52.662155, -0.5],
          [5.041511, 52.662290, -0.25],
          [5.041445, 52.662409, -0.25],
          [5.041378, 52.662573, -0.25],
          [5.041389, 52.662614, -0.5],
          [5.041455, 52.662683, -0.5],
          [5.041435, 52.662732, -0.5],
          [5.041361, 52.662715, -0.5],
          [5.041244, 52.662779, -0.75],
          [5.041244, 52.662779, -0.75],
          [5.041361, 52.662715, -0.5],
          [5.041435, 52.662732, -0.5],
          [5.042173, 52.662851, -0.5],
          [5.044038, 52.663126, 0.0],
          [5.044016, 52.663186, 0.0],
          [5.044301, 52.663228, 0.0]
        ]
      }
    }
  ]
}

let day13: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "13.1 - Zwaag - Enkhuizen - 24.7km",
        "track-length": "24737",
        "filtered ascend": "11",
        "plain-ascend": "6",
        "total-time": "4037",
        "total-energy": "399531",
        "cost": "29679",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["5044276", "52663161", "0", "4", "1150", "0", "0", "0", "0", "highway=residential cycleway=lane", "", "0", "36"],
          ["5046989", "52663541", "0", "190", "1450", "0", "91", "0", "0", "highway=tertiary cycleway=lane", "", "24", "2400"],
          ["5047861", "52663558", "0", "61", "1050", "0", "19", "0", "0", "highway=cycleway oneway=yes", "highway=crossing crossing=unknown", "33", "3355"],
          ["5054026", "52663818", "0", "429", "1050", "0", "4", "0", "0", "highway=cycleway oneway=yes", "", "106", "10662"],
          ["5054112", "52663911", "0", "12", "1050", "0", "95", "0", "0", "reversedirection=yes highway=cycleway", "", "108", "10858"],
          ["5054274", "52663853", "0", "9", "1450", "0", "91", "0", "0", "reversedirection=yes highway=tertiary bicycle=use_sidepath", "", "110", "11005"],
          ["5054112", "52663911", "0", "9", "1450", "0", "0", "0", "0", "highway=tertiary bicycle=use_sidepath", "", "110", "11089"],
          ["5054444", "52662429", "0", "177", "1050", "0", "147", "0", "0", "highway=cycleway", "", "132", "13267"],
          ["5054609", "52662191", "0", "9", "1050", "0", "1", "0", "0", "reversedirection=yes highway=cycleway surface=concrete", "", "133", "13398"],
          ["5054444", "52662429", "0", "9", "1050", "0", "1", "0", "0", "highway=cycleway surface=concrete", "", "134", "13482"],
          ["5052618", "52661903", "0", "142", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary cycleway=lane route_bicycle_rcn=yes", "", "151", "15184"],
          ["5050921", "52661545", "0", "22", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "155", "15509"],
          ["5052618", "52661903", "0", "22", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "157", "15711"],
          ["5052909", "52661092", "-1", "94", "1450", "0", "58", "0", "0", "reversedirection=yes highway=tertiary cycleway=lane", "", "166", "16673"],
          ["5052874", "52660202", "0", "109", "1450", "0", "13", "0", "0", "reversedirection=yes highway=tertiary foot=no cycleway=lane", "", "183", "18374"],
          ["5053290", "52659130", "0", "124", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary cycleway=lane", "", "207", "20743"],
          ["5053316", "52659061", "0", "8", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane", "highway=crossing crossing=unknown", "208", "20893"],
          ["5053352", "52658964", "0", "12", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=use_sidepath cycleway=lane", "", "211", "21115"],
          ["5053423", "52658974", "0", "5", "1350", "0", "90", "0", "0", "highway=service", "highway=crossing", "212", "21207"],
          ["5053387", "52659070", "0", "3", "5050", "0", "89", "0", "0", "highway=footway", "", "214", "21243"],
          ["5053423", "52658974", "0", "3", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "highway=crossing", "216", "21243"],
          ["5053352", "52658964", "0", "5", "1350", "0", "89", "0", "0", "reversedirection=yes highway=service", "", "216", "21289"],
          ["5053316", "52659061", "0", "12", "1450", "0", "90", "0", "0", "highway=tertiary surface=asphalt foot=use_sidepath cycleway=lane", "highway=crossing crossing=unknown", "217", "21406"],
          ["5053290", "52659130", "0", "8", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "", "218", "21487"],
          ["5048667", "52658482", "0", "325", "1450", "0", "90", "0", "0", "reversedirection=yes highway=tertiary cycleway=lane", "highway=crossing", "264", "26055"],
          ["5043860", "52656195", "-2", "545", "1450", "0", "112", "0", "0", "reversedirection=yes highway=tertiary cycleway=lane", "", "334", "33089"],
          ["5043662", "52656169", "-2", "12", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "", "336", "33250"],
          ["5043860", "52656195", "-2", "12", "1450", "0", "0", "0", "0", "highway=tertiary", "", "337", "33362"],
          ["5046097", "52650155", "0", "700", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "455", "45167"],
          ["5046420", "52649132", "0", "119", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "", "474", "47065"],
          ["5047328", "52647692", "0", "181", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_rcn=yes", "", "505", "50219"],
          ["5049397", "52645631", "0", "287", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "554", "55046"],
          ["5049461", "52645572", "0", "8", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "555", "55174"],
          ["5049501", "52645537", "0", "5", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "556", "55255"],
          ["5051810", "52644374", "1", "227", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "601", "59735"],
          ["5051892", "52644352", "1", "7", "21450", "0", "91", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt bicycle=no oneway=yes", "highway=traffic_signals", "606", "59837"],
          ["5052003", "52644337", "1", "3", "21450", "0", "1", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt bicycle=no oneway=yes", "", "608", "59879"],
          ["5051892", "52644352", "1", "3", "5450", "0", "0", "0", "0", "highway=tertiary surface=asphalt bicycle=no oneway=yes", "highway=traffic_signals", "610", "59879"],
          ["5051810", "52644374", "1", "7", "5450", "0", "1", "0", "0", "highway=tertiary surface=asphalt bicycle=no oneway=yes", "", "614", "59879"],
          ["5051757", "52644337", "1", "6", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "615", "59937"],
          ["5051772", "52644102", "2", "28", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "618", "60231"],
          ["5052273", "52644225", "1", "37", "1050", "0", "123", "0", "0", "highway=cycleway oneway=yes", "", "622", "60656"],
          ["5054563", "52642432", "4", "264", "3050", "0", "144", "0", "0", "highway=pedestrian oneway=yes", "", "661", "64533"],
          ["5053975", "52642301", "4", "44", "1000", "0", "0", "0", "0", "highway=tertiary oneway=yes oneway:bicycle=no route_bicycle_rcn=yes", "", "667", "65143"],
          ["5055482", "52641198", "4", "162", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "692", "67655"],
          ["5056135", "52641380", "3", "49", "3050", "0", "65", "0", "0", "highway=pedestrian", "", "700", "68431"],
          ["5056802", "52640914", "4", "70", "3050", "0", "64", "0", "0", "highway=pedestrian oneway=yes", "", "709", "69368"],
          ["5056032", "52640716", "4", "58", "3050", "0", "115", "0", "0", "reversedirection=yes highway=pedestrian", "", "716", "70069"],
          ["5058072", "52638923", "3", "250", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "754", "73810"],
          ["5059107", "52639098", "4", "75", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes horse=yes", "768", "75205"],
          ["5059167", "52639112", "4", "5", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "769", "75304"],
          ["5059425", "52639270", "5", "26", "3050", "0", "8", "0", "0", "reversedirection=yes highway=pedestrian surface=sett", "", "773", "75724"],
          ["5059464", "52639272", "5", "3", "3050", "0", "21", "0", "0", "highway=pedestrian", "", "773", "75754"],
          ["5060345", "52639347", "5", "63", "1000", "0", "0", "0", "0", "highway=living_street oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "781", "76506"],
          ["5062017", "52639603", "4", "119", "1000", "0", "0", "0", "0", "highway=living_street surface=paving_stones oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "795", "77983"],
          ["5062228", "52639643", "4", "16", "1000", "0", "0", "0", "0", "highway=living_street oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "797", "78186"],
          ["5063241", "52638132", "2", "183", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "821", "80521"],
          ["5063135", "52638096", "2", "9", "1150", "0", "84", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "", "822", "80647"],
          ["5063035", "52638069", "2", "8", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt oneway=yes oneway:bicycle=no", "", "823", "80760"],
          ["5062937", "52638043", "2", "8", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "", "824", "80883"],
          ["5062908", "52637179", "3", "100", "1150", "0", "19", "0", "0", "reversedirection=yes highway=residential surface=paving_stones cycleway=opposite oneway=yes", "", "842", "82703"],
          ["5062937", "52638043", "2", "100", "1150", "0", "4", "0", "0", "highway=residential surface=paving_stones cycleway=opposite oneway=yes", "", "853", "83750"],
          ["5063035", "52638069", "2", "8", "1150", "0", "15", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "", "854", "83839"],
          ["5063135", "52638096", "2", "8", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt oneway=yes oneway:bicycle=no", "", "855", "83931"],
          ["5063241", "52638132", "2", "9", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes oneway:bicycle=no", "", "856", "84037"],
          ["5064058", "52638837", "2", "98", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones cycleway=opposite oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "869", "85306"],
          ["5066026", "52639946", "1", "209", "1000", "0", "0", "0", "0", "highway=residential cycleway=opposite oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "895", "87986"],
          ["5065957", "52640378", "1", "49", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "902", "88634"],
          ["5066510", "52640461", "2", "39", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "908", "89217"],
          ["5066704", "52640503", "2", "15", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "910", "89451"],
          ["5068327", "52640782", "2", "116", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "931", "91507"],
          ["5068717", "52640853", "2", "28", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "936", "92007"],
          ["5068819", "52640873", "2", "8", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "937", "92149"],
          ["5069135", "52640850", "2", "27", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "942", "92622"],
          ["5070289", "52641244", "1", "93", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "956", "94059"],
          ["5082625", "52643378", "2", "878", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "1107", "109180"],
          ["5089253", "52644595", "0", "470", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1178", "116212"],
          ["5089482", "52644607", "0", "17", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1180", "116482"],
          ["5089253", "52644595", "0", "19", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1182", "116663"],
          ["5088936", "52644552", "0", "22", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1184", "116899"],
          ["5088049", "52644548", "0", "65", "1050", "0", "80", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes", "", "1192", "117666"],
          ["5096462", "52645640", "0", "591", "1050", "0", "176", "0", "0", "highway=cycleway", "highway=traffic_signals traffic_signals:direction=forward", "1284", "126864"],
          ["5096851", "52645731", "0", "30", "1050", "0", "0", "0", "0", "highway=cycleway", "highway=traffic_signals traffic_signals:direction=backward", "1290", "127493"],
          ["5119629", "52650096", "-1", "1633", "1050", "0", "3", "0", "0", "highway=cycleway", "", "1561", "154538"],
          ["5142500", "52656500", "-1", "1718", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "1853", "183747"],
          ["5142605", "52656460", "0", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "", "1854", "183911"],
          ["5145532", "52657361", "0", "224", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "1897", "188168"],
          ["5149242", "52662551", "0", "887", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "2033", "201734"],
          ["5149125", "52662706", "0", "19", "1000", "0", "0", "0", "0", "highway=unclassified oneway=yes route_bicycle_rcn=yes", "", "2036", "202055"],
          ["5149083", "52663007", "0", "44", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_rcn=yes", "", "2044", "202866"],
          ["5148903", "52662884", "0", "10", "5650", "0", "94", "0", "0", "highway=secondary bicycle=no oneway=yes", "", "2051", "202968"],
          ["5149083", "52663007", "0", "10", "31650", "0", "0", "0", "0", "reversedirection=yes highway=secondary bicycle=no oneway=yes", "", "2058", "202968"],
          ["5149272", "52662901", "0", "18", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "", "2060", "203153"],
          ["5166609", "52669014", "-1", "1378", "1000", "0", "0", "0", "0", "highway=cycleway oneway=no route_bicycle_rcn=yes", "", "2276", "224823"],
          ["5203418", "52675352", "0", "2679", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "2737", "270946"],
          ["5204064", "52675376", "0", "86", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "2753", "272479"],
          ["5227086", "52677144", "-1", "1581", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "3016", "298797"],
          ["5229747", "52677317", "-1", "183", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "3046", "301826"],
          ["5243408", "52679745", "-1", "1074", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "3230", "320250"],
          ["5243181", "52678462", "0", "140", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3253", "322543"],
          ["5245239", "52685039", "0", "820", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3390", "336186"],
          ["5248284", "52686427", "-8192", "305", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3440", "341191"],
          ["5253371", "52687151", "0", "370", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3491", "346292"],
          ["5254602", "52687308", "0", "87", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "3504", "347652"],
          ["5276691", "52695320", "0", "1867", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "3818", "379034"],
          ["5276711", "52695340", "0", "3", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "3819", "379088"],
          ["5276852", "52695472", "0", "18", "1000", "0", "0", "0", "0", "highway=cycleway route=bicycle route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=backward", "3822", "379411"],
          ["5276919", "52695532", "0", "9", "1000", "0", "0", "0", "0", "highway=cycleway route=bicycle route_bicycle_rcn=yes", "", "3824", "379571"],
          ["5289369", "52699493", "0", "1136", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "4020", "399186"],
          ["5289316", "52699533", "0", "6", "1350", "0", "120", "0", "0", "reversedirection=yes highway=unclassified", "", "4021", "399294"],
          ["5289387", "52699751", "0", "22", "5450", "0", "90", "0", "0", "highway=tertiary bicycle=no", "", "4037", "399541"]
        ],
        "times": [0, 0.369, 2.008, 13.111, 24.007, 26.751, 32.929, 33.557, 35.49, 46.431, 65.705, 70.747, 71.459, 73.057, 87.663, 95.388, 97.299, 98.684, 101.1, 103.2, 104.497, 105.472, 106.612, 108.572, 110.046, 110.886, 112.055, 112.762, 113.384, 114.02, 114.669, 118.472, 120.201, 123.177, 130.524, 131.944, 132.663, 133.677, 133.969, 134.152, 134.809, 135.192, 135.878, 139.361, 149.784, 151.036, 151.834, 152.691, 153.99, 155.076, 155.705, 156.541, 157.096, 157.925, 164.621, 166.716, 168.584, 169.186, 169.552, 173.538, 174.139, 174.743, 175.551, 183.73, 193.59, 194.857, 207.42, 208.915, 211.134, 212.052, 214.219, 216.153, 216.621, 217.785, 218.593, 223.518, 231.116, 241.162, 246.281, 257.556, 258.191, 262.579, 264.275, 266.299, 269.923, 283.173, 290.039, 292.437, 294.883, 295.907, 295.996, 296.536, 297.563, 298.636, 303.384, 315.985, 316.261, 318.597, 323.799, 334.608, 336.211, 337.337, 338.419, 339.758, 342.627, 345.989, 357.472, 359.74, 360.716, 361.694, 373.861, 386.607, 392.613, 398.045, 405.467, 411.271, 425.321, 441.114, 447.379, 450.258, 455.369, 457.495, 465.211, 472.118, 474.353, 478.057, 479.353, 480.567, 490.359, 495.305, 497.056, 498.8, 500.537, 503.306, 505.891, 507.609, 508.809, 509.494, 513.425, 519.215, 525.082, 529.442, 532.04, 532.731, 536.518, 538.233, 539.774, 542.337, 544.212, 545.404, 546.765, 550.161, 552.711, 554.155, 555.443, 556.25, 558.231, 559.869, 561.512, 570.568, 573.141, 575.836, 578.002, 580.262, 582.379, 584.436, 586.658, 589.425, 596.568, 598.218, 599.438, 601.043, 606.151, 608.339, 610.272, 614.806, 615.386, 616.282, 617.209, 618.323, 621.848, 622.571, 625.461, 632.115, 642.963, 643.378, 646.857, 648.312, 649.947, 655.148, 661.342, 666.29, 667.432, 668.588, 670.05, 677.93, 681.992, 692.55, 700.306, 706.449, 709.681, 712.83, 715.11, 715.761, 716.686, 720.344, 724.056, 731.319, 741.199, 744.929, 754.088, 755.879, 761.258, 768.041, 769.033, 772.158, 773.226, 773.525, 774.918, 776.26, 781.047, 784.001, 788.614, 795.809, 796.31, 797.844, 807.072, 809.483, 810.532, 821.179, 822.44, 823.577, 824.799, 825.413, 826.184, 827.67, 837.05, 840.035, 842.999, 844.611, 846.404, 851.443, 852.44, 853.007, 853.467, 854.362, 855.28, 856.341, 859.415, 862.454, 867.888, 869.023, 870.462, 877.614, 878.971, 880.215, 884.786, 885.52, 886.852, 888.284, 889.083, 889.452, 891.254, 893.291, 894.418, 895.818, 902.304, 903.707, 908.133, 909.219, 910.466, 917.992, 919.164, 931.033, 934.436, 936.034, 937.449, 937.978, 939.384, 939.911, 942.183, 944.966, 948.219, 950.344, 956.548, 958.017, 959.561, 960.844, 992.152, 995.134, 1010.295, 1024.023, 1025.455, 1050.041, 1078.583, 1079.47, 1086.079, 1102.035, 1107.75, 1154.522, 1170.474, 1174.619, 1178.067, 1179.65, 1180.763, 1180.947, 1181.603, 1182.573, 1184.932, 1185.687, 1186.126, 1192.605, 1195.787, 1198.839, 1203.471, 1208.186, 1215.653, 1222.39, 1226.22, 1248.43, 1252.01, 1255.144, 1264.196, 1273.657, 1282.601, 1283.015, 1284.552, 1285.847, 1288.381, 1290.85, 1291.861, 1296.208, 1298.135, 1301.356, 1308.477, 1315.304, 1323.275, 1331.963, 1357.482, 1362.842, 1363.777, 1372.011, 1407.35, 1423.742, 1514.517, 1542.243, 1545.226, 1547.318, 1552.366, 1561.26, 1564.526, 1568.134, 1569.312, 1580.781, 1589.207, 1601.387, 1621.924, 1695.152, 1732.603, 1759.213, 1771.882, 1791.962, 1799.737, 1806.034, 1812.771, 1820.887, 1845.08, 1850.943, 1853.344, 1854.989, 1859.407, 1897.555, 1910.406, 1935.667, 1960.47, 1964.499, 1968.231, 1969.843, 1972.051, 1974.508, 1976.922, 2003.356, 2003.852, 2033.207, 2036.414, 2037.855, 2040.003, 2041.145, 2042.468, 2044.524, 2051.7, 2058.222, 2059.332, 2060.063, 2064.459, 2070.212, 2075.803, 2084.563, 2095.776, 2146.525, 2163.231, 2231.19, 2242.984, 2256.958, 2263.67, 2267.383, 2269.578, 2276.754, 2279.951, 2287.769, 2297.036, 2311.863, 2319.034, 2322.376, 2330.236, 2339.269, 2351.544, 2363.23, 2365.933, 2370.109, 2373.027, 2379.94, 2384.955, 2389.364, 2395.461, 2439.43, 2444.483, 2451.048, 2467.864, 2475.977, 2481.626, 2489.375, 2498.859, 2505.026, 2513.616, 2520.481, 2523.02, 2525.533, 2529.968, 2534.176, 2537.92, 2544.297, 2548.664, 2553.418, 2559.265, 2562.659, 2567.299, 2577.776, 2584.101, 2587.798, 2591.759, 2595.633, 2599.703, 2615.198, 2620.678, 2623.856, 2630.168, 2676.645, 2679.903, 2684.002, 2729.948, 2732.953, 2735.8, 2737.954, 2739.724, 2741.485, 2745.651, 2748.183, 2750.368, 2751.04, 2751.712, 2753.29, 2755.384, 2773.989, 2814.611, 2834.554, 2840.984, 2846.212, 2851.26, 2864.389, 2885.877, 2891.62, 2913.113, 2933.613, 2945.441, 2998.087, 3008.163, 3014.465, 3016.452, 3018.334, 3044.054, 3046.74, 3053.14, 3090.768, 3099.401, 3102.717, 3109.543, 3113.765, 3122.76, 3128.135, 3141.989, 3154.985, 3177.28, 3181.854, 3192.029, 3194.332, 3198.955, 3203.764, 3205.094, 3206.424, 3209.086, 3210.79, 3212.705, 3214.431, 3216.242, 3221.464, 3230.949, 3236.296, 3247.399, 3248.368, 3251.312, 3253.257, 3253.876, 3254.143, 3255.03, 3256.528, 3257.115, 3264.94, 3269.488, 3271.961, 3304.111, 3306.155, 3308.196, 3310.11, 3311.071, 3312.128, 3320.171, 3322.701, 3324.79, 3326.243, 3327.377, 3328.839, 3329.979, 3331.938, 3334.56, 3347.337, 3376.758, 3381.634, 3383.595, 3385.014, 3386.603, 3389.061, 3390.285, 3391.505, 3392.549, 3393.07, 3394.11, 3398.426, 3400.145, 3401.688, 3403.229, 3404.084, 3405.621, 3406.815, 3408.348, 3420.221, 3423.771, 3425.966, 3426.978, 3428.159, 3430.183, 3437.766, 3437.934, 3440.343, 3442.336, 3444.12, 3444.581, 3445.82, 3450.542, 3463.079, 3470.462, 3473.185, 3485.72, 3491.347, 3501.137, 3502.651, 3504.948, 3516.967, 3523.834, 3527.106, 3534.94, 3537.22, 3541.92, 3545.759, 3553.808, 3559.615, 3562.711, 3566.973, 3571.259, 3576.061, 3581.427, 3584.766, 3596.032, 3602.763, 3609.037, 3620.546, 3626.685, 3636.201, 3643.017, 3702.031, 3705.489, 3713.844, 3732.347, 3747.598, 3754.107, 3763.852, 3767.578, 3771.052, 3773.758, 3776.97, 3777.325, 3777.679, 3779.798, 3781.729, 3783.303, 3794.608, 3799.773, 3804.176, 3805.322, 3814.186, 3817.484, 3818.21, 3818.753, 3819.295, 3821.63, 3822.523, 3824.124, 3825.187, 3828.005, 3829.12, 3830.699, 3835.422, 3845.763, 3853.869, 3862.384, 3864.963, 3872.348, 3882.555, 3892.716, 3902.087, 3910.192, 3913.012, 3914.521, 3915.586, 3917.468, 3918.576, 3919.773, 3921.868, 3927.26, 3944.534, 3946.328, 3948.288, 3949.615, 3950.931, 3953.533, 4006.242, 4017.892, 4020.251, 4021.332, 4027.817, 4035.019, 4037.178]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [5.044287, 52.663132, 0.0],
          [5.044276, 52.663161, 0.0],
          [5.044520, 52.663193, 0.0],
          [5.046005, 52.663407, 0.0],
          [5.046989, 52.663541, 0.0],
          [5.047230, 52.663501, 0.0],
          [5.047804, 52.663559, -0.25],
          [5.047861, 52.663558, -0.25],
          [5.048044, 52.663564, -0.5],
          [5.049165, 52.663659, -1.0],
          [5.050727, 52.663745, -0.25],
          [5.051134, 52.663766, 0.0],
          [5.051188, 52.663768, 0.0],
          [5.051311, 52.663772, 0.0],
          [5.052476, 52.663832, 0.25],
          [5.053113, 52.663872, 0.25],
          [5.053265, 52.663888, 0.25],
          [5.053380, 52.663890, 0.25],
          [5.053575, 52.663896, 0.25],
          [5.053759, 52.663887, 0.0],
          [5.053861, 52.663872, 0.0],
          [5.053939, 52.663852, 0.0],
          [5.054026, 52.663818, 0.0],
          [5.054112, 52.663911, 0.0],
          [5.054226, 52.663870, 0.0],
          [5.054112, 52.663911, 0.0],
          [5.054026, 52.663818, 0.0],
          [5.054076, 52.663771, 0.0],
          [5.054111, 52.663724, 0.0],
          [5.054143, 52.663680, 0.0],
          [5.054157, 52.663633, 0.0],
          [5.054146, 52.663343, 0.0],
          [5.054152, 52.663222, 0.0],
          [5.054218, 52.663027, 0.0],
          [5.054402, 52.662551, -0.25],
          [5.054423, 52.662463, -0.25],
          [5.054444, 52.662429, -0.25],
          [5.054473, 52.662370, -0.25],
          [5.054484, 52.662355, -0.25],
          [5.054473, 52.662370, -0.25],
          [5.054444, 52.662429, -0.25],
          [5.054403, 52.662418, -0.25],
          [5.054318, 52.662395, -0.25],
          [5.053870, 52.662295, -0.25],
          [5.052745, 52.662001, -0.25],
          [5.052651, 52.661953, -0.25],
          [5.052618, 52.661903, -0.5],
          [5.052544, 52.661914, -0.25],
          [5.052415, 52.661926, -0.25],
          [5.052325, 52.661903, 0.0],
          [5.052415, 52.661926, -0.25],
          [5.052544, 52.661914, -0.25],
          [5.052618, 52.661903, -0.5],
          [5.052632, 52.661829, -0.75],
          [5.052848, 52.661243, -1.25],
          [5.052909, 52.661092, -1.25],
          [5.052958, 52.660956, -1.5],
          [5.052960, 52.660917, -1.5],
          [5.052946, 52.660892, -1.5],
          [5.052742, 52.660686, -0.75],
          [5.052725, 52.660657, -0.75],
          [5.052719, 52.660624, -0.75],
          [5.052723, 52.660588, -0.5],
          [5.052874, 52.660202, 0.0],
          [5.053060, 52.659740, 0.25],
          [5.053081, 52.659686, 0.25],
          [5.053290, 52.659130, 0.75],
          [5.053316, 52.659061, 0.75],
          [5.053352, 52.658964, 0.75],
          [5.053423, 52.658974, 0.75],
          [5.053415, 52.658994, 0.75],
          [5.053423, 52.658974, 0.75],
          [5.053352, 52.658964, 0.75],
          [5.053316, 52.659061, 0.75],
          [5.053290, 52.659130, 0.75],
          [5.052596, 52.659031, 0.0],
          [5.051666, 52.658898, -0.25],
          [5.050752, 52.658767, 0.5],
          [5.050330, 52.658706, 0.75],
          [5.049280, 52.658556, 0.25],
          [5.049227, 52.658548, 0.25],
          [5.048817, 52.658502, 0.0],
          [5.048667, 52.658482, 0.0],
          [5.048493, 52.658456, 0.0],
          [5.048169, 52.658410, 0.0],
          [5.046997, 52.658241, 0.0],
          [5.046377, 52.658140, -0.25],
          [5.046162, 52.658107, -0.5],
          [5.045924, 52.658070, -0.75],
          [5.045839, 52.658044, -0.75],
          [5.045830, 52.658042, -1.0],
          [5.045771, 52.658011, -1.0],
          [5.045704, 52.657927, -1.0],
          [5.045704, 52.657834, -1.0],
          [5.045845, 52.657454, -1.0],
          [5.046179, 52.656556, -1.0],
          [5.046188, 52.656533, -1.0],
          [5.045844, 52.656484, -1.0],
          [5.045182, 52.656389, -1.0],
          [5.043860, 52.656195, -2.0],
          [5.043700, 52.656174, -2.0],
          [5.043860, 52.656195, -2.0],
          [5.043892, 52.656105, -2.0],
          [5.043922, 52.655992, -2.0],
          [5.043933, 52.655766, -2.0],
          [5.043983, 52.655522, -2.0],
          [5.044240, 52.654819, -1.75],
          [5.044310, 52.654693, -1.75],
          [5.044328, 52.654642, -1.5],
          [5.044329, 52.654593, -1.5],
          [5.044564, 52.654009, -1.0],
          [5.044796, 52.653373, -1.0],
          [5.044923, 52.653051, -1.25],
          [5.045024, 52.652749, -1.5],
          [5.045147, 52.652318, -1.75],
          [5.045248, 52.652014, -1.5],
          [5.045469, 52.651412, -0.5],
          [5.045703, 52.650841, 0.75],
          [5.045839, 52.650552, 0.25],
          [5.045922, 52.650413, 0.0],
          [5.046097, 52.650155, -0.25],
          [5.046148, 52.650041, -0.5],
          [5.046259, 52.649631, -0.25],
          [5.046390, 52.649250, -0.5],
          [5.046420, 52.649132, -0.5],
          [5.046515, 52.648936, -0.5],
          [5.046528, 52.648867, -0.5],
          [5.046519, 52.648807, -0.25],
          [5.046745, 52.648342, 0.0],
          [5.046874, 52.648112, 0.0],
          [5.046992, 52.648061, 0.0],
          [5.047118, 52.648025, 0.0],
          [5.047165, 52.647945, 0.0],
          [5.047250, 52.647811, 0.0],
          [5.047328, 52.647692, 0.0],
          [5.047348, 52.647609, 0.0],
          [5.047382, 52.647554, 0.0],
          [5.047414, 52.647529, 0.0],
          [5.047685, 52.647407, 0.0],
          [5.048073, 52.647187, -0.25],
          [5.048412, 52.646949, -0.25],
          [5.048630, 52.646769, 0.0],
          [5.048776, 52.646668, 0.0],
          [5.048813, 52.646640, 0.0],
          [5.048969, 52.646469, 0.0],
          [5.049033, 52.646390, 0.0],
          [5.049123, 52.646342, 0.0],
          [5.049220, 52.646230, 0.0],
          [5.049268, 52.646136, 0.0],
          [5.049254, 52.646078, 0.0],
          [5.049227, 52.646010, 0.0],
          [5.049269, 52.645837, 0.0],
          [5.049338, 52.645700, -0.25],
          [5.049397, 52.645631, -0.25],
          [5.049461, 52.645572, -0.25],
          [5.049501, 52.645537, -0.25],
          [5.049623, 52.645449, -0.5],
          [5.049729, 52.645399, -0.25],
          [5.049853, 52.645358, -0.25],
          [5.050591, 52.645244, 0.0],
          [5.050785, 52.645205, 0.25],
          [5.050949, 52.645156, 0.75],
          [5.051065, 52.645107, 1.0],
          [5.051170, 52.645054, 1.25],
          [5.051266, 52.645000, 1.5],
          [5.051341, 52.644937, 1.5],
          [5.051419, 52.644870, 1.5],
          [5.051508, 52.644777, 1.75],
          [5.051738, 52.644522, 1.75],
          [5.051798, 52.644469, 1.75],
          [5.051857, 52.644436, 1.75],
          [5.051810, 52.644374, 1.75],
          [5.051892, 52.644352, 1.75],
          [5.051934, 52.644346, 1.75],
          [5.051892, 52.644352, 1.75],
          [5.051810, 52.644374, 1.75],
          [5.051757, 52.644337, 1.75],
          [5.051765, 52.644264, 1.75],
          [5.051766, 52.644188, 1.75],
          [5.051772, 52.644102, 2.0],
          [5.052188, 52.644211, 1.75],
          [5.052273, 52.644225, 1.75],
          [5.052243, 52.644036, 2.0],
          [5.052620, 52.643727, 2.5],
          [5.053065, 52.643387, 4.0],
          [5.053083, 52.643375, 4.0],
          [5.053404, 52.643174, 4.75],
          [5.053534, 52.643098, 4.5],
          [5.053683, 52.643016, 4.5],
          [5.054125, 52.642739, 4.25],
          [5.054563, 52.642432, 4.25],
          [5.054062, 52.642336, 4.0],
          [5.053975, 52.642301, 4.0],
          [5.054055, 52.642254, 4.0],
          [5.054121, 52.642178, 4.0],
          [5.054676, 52.641799, 3.5],
          [5.054931, 52.641590, 3.25],
          [5.055482, 52.641198, 4.25],
          [5.056135, 52.641380, 3.75],
          [5.056495, 52.641128, 3.75],
          [5.056802, 52.640914, 4.0],
          [5.056431, 52.640809, 4.0],
          [5.056195, 52.640754, 4.25],
          [5.056126, 52.640738, 4.25],
          [5.056032, 52.640716, 4.25],
          [5.056245, 52.640468, 3.25],
          [5.056532, 52.640253, 3.0],
          [5.057053, 52.639941, 3.5],
          [5.057640, 52.639570, 4.0],
          [5.057804, 52.639403, 4.0],
          [5.058072, 52.638923, 3.75],
          [5.058232, 52.638912, 3.75],
          [5.058659, 52.638990, 4.0],
          [5.059107, 52.639098, 4.75],
          [5.059167, 52.639112, 4.75],
          [5.059315, 52.639203, 5.0],
          [5.059425, 52.639270, 5.25],
          [5.059464, 52.639272, 5.25],
          [5.059636, 52.639302, 5.5],
          [5.059801, 52.639297, 5.5],
          [5.060345, 52.639347, 5.75],
          [5.060676, 52.639380, 5.5],
          [5.061203, 52.639440, 5.0],
          [5.062017, 52.639603, 4.25],
          [5.062061, 52.639611, 4.0],
          [5.062228, 52.639643, 4.0],
          [5.062545, 52.639028, 3.5],
          [5.062652, 52.638874, 3.0],
          [5.062700, 52.638811, 3.0],
          [5.063241, 52.638132, 2.25],
          [5.063135, 52.638096, 2.25],
          [5.063035, 52.638069, 2.25],
          [5.062937, 52.638043, 2.5],
          [5.062907, 52.638014, 2.5],
          [5.062887, 52.637979, 2.5],
          [5.062876, 52.637902, 2.75],
          [5.062855, 52.637479, 3.5],
          [5.062868, 52.637334, 3.25],
          [5.062906, 52.637184, 3.25],
          [5.062868, 52.637334, 3.25],
          [5.062855, 52.637479, 3.5],
          [5.062876, 52.637902, 2.75],
          [5.062887, 52.637979, 2.5],
          [5.062907, 52.638014, 2.5],
          [5.062937, 52.638043, 2.5],
          [5.063035, 52.638069, 2.25],
          [5.063135, 52.638096, 2.25],
          [5.063241, 52.638132, 2.25],
          [5.063486, 52.638307, 2.0],
          [5.063698, 52.638476, 2.0],
          [5.063986, 52.638780, 2.0],
          [5.064058, 52.638837, 2.0],
          [5.064164, 52.638887, 2.0],
          [5.064867, 52.639154, 1.0],
          [5.064995, 52.639192, 1.0],
          [5.065115, 52.639215, 1.0],
          [5.065573, 52.639278, 1.0],
          [5.065639, 52.639292, 1.0],
          [5.065750, 52.639333, 1.0],
          [5.065836, 52.639386, 1.25],
          [5.065875, 52.639419, 1.25],
          [5.065905, 52.639446, 1.25],
          [5.065983, 52.639595, 1.5],
          [5.066050, 52.639755, 1.5],
          [5.066046, 52.639843, 1.5],
          [5.066026, 52.639946, 1.5],
          [5.065957, 52.640378, 1.75],
          [5.066102, 52.640394, 1.75],
          [5.066510, 52.640461, 2.0],
          [5.066607, 52.640481, 2.0],
          [5.066704, 52.640503, 2.0],
          [5.067330, 52.640612, 2.25],
          [5.067427, 52.640613, 2.25],
          [5.068327, 52.640782, 2.75],
          [5.068590, 52.640833, 2.75],
          [5.068717, 52.640853, 2.75],
          [5.068819, 52.640873, 2.75],
          [5.068834, 52.640853, 2.75],
          [5.068927, 52.640822, 2.75],
          [5.068962, 52.640818, 2.75],
          [5.069135, 52.640850, 2.75],
          [5.069344, 52.640899, 2.75],
          [5.069618, 52.640953, 2.5],
          [5.069782, 52.641007, 2.5],
          [5.070289, 52.641244, 1.75],
          [5.070409, 52.641209, 1.75],
          [5.070557, 52.641201, 1.5],
          [5.070679, 52.641218, 1.5],
          [5.073667, 52.641775, 1.0],
          [5.073920, 52.641824, 1.0],
          [5.075208, 52.642055, 1.0],
          [5.076357, 52.642267, 1.0],
          [5.076462, 52.642287, 1.25],
          [5.078539, 52.642666, 1.0],
          [5.080214, 52.642933, 2.75],
          [5.080282, 52.642945, 2.75],
          [5.080878, 52.643049, 2.25],
          [5.082138, 52.643287, 2.75],
          [5.082625, 52.643378, 2.5],
          [5.087117, 52.644242, 0.75],
          [5.088581, 52.644506, 0.5],
          [5.088936, 52.644552, 0.5],
          [5.089253, 52.644595, 0.25],
          [5.089393, 52.644613, 0.25],
          [5.089482, 52.644607, 0.25],
          [5.089482, 52.644607, 0.25],
          [5.089393, 52.644613, 0.25],
          [5.089253, 52.644595, 0.25],
          [5.088936, 52.644552, 0.5],
          [5.088874, 52.644601, 0.25],
          [5.088829, 52.644605, 0.25],
          [5.088049, 52.644548, 0.25],
          [5.088351, 52.644647, 0.25],
          [5.088645, 52.644714, 0.25],
          [5.089096, 52.644788, 0.25],
          [5.089566, 52.644851, 0.0],
          [5.090318, 52.644928, -0.25],
          [5.091090, 52.644996, -1.25],
          [5.091507, 52.645055, -1.5],
          [5.093830, 52.645309, -2.0],
          [5.094145, 52.645323, -2.0],
          [5.094396, 52.645342, -1.75],
          [5.095065, 52.645432, -1.25],
          [5.095757, 52.645546, -1.0],
          [5.096343, 52.645627, -0.25],
          [5.096372, 52.645628, -0.25],
          [5.096462, 52.645640, 0.0],
          [5.096541, 52.645655, 0.0],
          [5.096694, 52.645692, 0.0],
          [5.096851, 52.645731, 0.0],
          [5.096921, 52.645745, 0.0],
          [5.097191, 52.645850, 0.0],
          [5.097309, 52.645889, 0.0],
          [5.097517, 52.645959, 0.0],
          [5.098046, 52.646127, -0.25],
          [5.098594, 52.646287, -0.5],
          [5.099275, 52.646465, -0.75],
          [5.100019, 52.646637, -0.75],
          [5.101466, 52.646944, 1.0],
          [5.101933, 52.647033, 0.5],
          [5.102064, 52.647058, 0.5],
          [5.103503, 52.647325, -1.5],
          [5.106244, 52.647836, -0.25],
          [5.107809, 52.648136, -1.0],
          [5.115570, 52.649536, -1.25],
          [5.118002, 52.649969, -1.5],
          [5.118264, 52.650000, -1.75],
          [5.118464, 52.650014, -2.0],
          [5.118943, 52.650028, -2.0],
          [5.119629, 52.650096, -1.25],
          [5.119874, 52.650124, -1.0],
          [5.120134, 52.650154, -0.75],
          [5.120207, 52.650162, -0.75],
          [5.121080, 52.650276, -0.75],
          [5.121729, 52.650421, -0.75],
          [5.122550, 52.650670, -0.25],
          [5.124304, 52.651155, -1.0],
          [5.130307, 52.652842, -1.5],
          [5.133334, 52.653675, -1.5],
          [5.135611, 52.654318, -2.0],
          [5.136528, 52.654587, -1.5],
          [5.138042, 52.655032, -1.5],
          [5.138767, 52.655152, -2.0],
          [5.139328, 52.655303, -2.25],
          [5.139824, 52.655507, -2.0],
          [5.140412, 52.655763, -2.0],
          [5.141961, 52.656248, -1.0],
          [5.142370, 52.656411, -1.0],
          [5.142500, 52.656500, -1.0],
          [5.142605, 52.656460, -0.75],
          [5.142842, 52.656598, -0.5],
          [5.145532, 52.657361, 0.0],
          [5.146619, 52.657694, -0.5],
          [5.149081, 52.658409, -2.0],
          [5.151062, 52.659040, -2.0],
          [5.151381, 52.659183, -2.5],
          [5.151618, 52.659319, -2.25],
          [5.151795, 52.659420, -2.25],
          [5.151881, 52.659591, -1.75],
          [5.151895, 52.659761, -1.25],
          [5.151800, 52.659900, -1.0],
          [5.150527, 52.661219, -1.0],
          [5.150496, 52.661235, -1.0],
          [5.149242, 52.662551, -0.75],
          [5.149125, 52.662706, -0.75],
          [5.149189, 52.662756, -0.5],
          [5.149222, 52.662860, -0.5],
          [5.149272, 52.662901, -0.25],
          [5.149195, 52.662940, -0.25],
          [5.149083, 52.663007, -0.25],
          [5.148989, 52.662943, -0.5],
          [5.149083, 52.663007, -0.25],
          [5.149195, 52.662940, -0.25],
          [5.149272, 52.662901, -0.25],
          [5.149633, 52.663134, 0.25],
          [5.150021, 52.663358, 1.0],
          [5.150472, 52.663576, 0.5],
          [5.151233, 52.663887, 0.0],
          [5.152227, 52.664274, -0.5],
          [5.156514, 52.665920, -2.0],
          [5.157816, 52.666430, -2.0],
          [5.163040, 52.668401, -2.5],
          [5.163974, 52.668680, -2.5],
          [5.165031, 52.668891, -2.0],
          [5.165569, 52.668978, -2.0],
          [5.165856, 52.669002, -1.75],
          [5.166023, 52.669015, -1.75],
          [5.166609, 52.669014, -1.75],
          [5.166844, 52.669033, -1.5],
          [5.167344, 52.669170, -1.0],
          [5.167896, 52.669346, -0.5],
          [5.168891, 52.669580, -0.25],
          [5.169429, 52.669774, -0.75],
          [5.169671, 52.669873, -0.75],
          [5.170251, 52.670175, -1.25],
          [5.170890, 52.670539, -1.5],
          [5.171549, 52.670896, -0.25],
          [5.172355, 52.671364, -1.25],
          [5.172549, 52.671456, -1.25],
          [5.172854, 52.671586, -1.25],
          [5.173074, 52.671667, -1.25],
          [5.173588, 52.671831, -1.0],
          [5.174003, 52.671943, -1.25],
          [5.174375, 52.672025, -1.25],
          [5.174862, 52.672113, -1.0],
          [5.178574, 52.672648, -1.0],
          [5.179000, 52.672695, -1.0],
          [5.179565, 52.672738, -1.0],
          [5.181030, 52.672824, -1.0],
          [5.181841, 52.672889, -1.75],
          [5.182347, 52.672902, -1.5],
          [5.182924, 52.672902, -0.75],
          [5.183600, 52.672879, -0.25],
          [5.184072, 52.672875, -0.25],
          [5.184700, 52.672950, 0.0],
          [5.185203, 52.673062, 0.0],
          [5.185392, 52.673098, 0.0],
          [5.185581, 52.673127, 0.0],
          [5.185933, 52.673166, 0.0],
          [5.186322, 52.673199, -0.5],
          [5.186679, 52.673218, -0.75],
          [5.187213, 52.673235, -0.25],
          [5.187565, 52.673218, 0.0],
          [5.187929, 52.673197, 0.25],
          [5.188333, 52.673192, 0.75],
          [5.188580, 52.673208, 0.75],
          [5.188918, 52.673249, 0.75],
          [5.189790, 52.673424, 0.25],
          [5.190363, 52.673495, 0.0],
          [5.190683, 52.673541, 0.0],
          [5.191001, 52.673601, 0.25],
          [5.191319, 52.673675, 0.0],
          [5.191645, 52.673763, 0.0],
          [5.193031, 52.674185, -0.5],
          [5.193530, 52.674315, -1.0],
          [5.193827, 52.674378, -1.25],
          [5.194422, 52.674484, -1.25],
          [5.198054, 52.675021, 0.0],
          [5.198318, 52.675054, 0.0],
          [5.198663, 52.675077, 0.0],
          [5.202758, 52.675253, -0.25],
          [5.203010, 52.675280, -0.25],
          [5.203237, 52.675313, 0.0],
          [5.203418, 52.675352, -0.25],
          [5.203525, 52.675293, 0.0],
          [5.203654, 52.675262, 0.0],
          [5.203810, 52.675109, 0.5],
          [5.203975, 52.675170, 0.25],
          [5.204128, 52.675236, 0.0],
          [5.204147, 52.675268, 0.0],
          [5.204147, 52.675302, 0.0],
          [5.204064, 52.675376, -0.25],
          [5.204246, 52.675426, -0.5],
          [5.206013, 52.675503, -0.5],
          [5.209390, 52.675689, 0.0],
          [5.211127, 52.675767, 0.0],
          [5.211594, 52.675788, 0.75],
          [5.212012, 52.675810, 0.5],
          [5.212478, 52.675834, 0.0],
          [5.213861, 52.675937, -1.0],
          [5.215633, 52.676008, -0.25],
          [5.216088, 52.676045, 0.0],
          [5.217974, 52.676212, -0.25],
          [5.219653, 52.676384, 0.0],
          [5.220678, 52.676440, 0.0],
          [5.225232, 52.676899, 0.0],
          [5.226225, 52.677028, -0.75],
          [5.226896, 52.677106, -1.5],
          [5.227086, 52.677144, -1.5],
          [5.227264, 52.677139, -1.5],
          [5.229511, 52.677320, -1.0],
          [5.229747, 52.677317, -1.0],
          [5.230259, 52.677362, -0.75],
          [5.232718, 52.677525, 1.0],
          [5.233339, 52.677607, 1.5],
          [5.233613, 52.677654, 1.0],
          [5.234282, 52.677842, 0.0],
          [5.234731, 52.677931, -0.5],
          [5.235728, 52.677976, -1.0],
          [5.236253, 52.678043, -1.0],
          [5.237613, 52.678120, -1.25],
          [5.238849, 52.678247, -1.5],
          [5.240275, 52.678240, 0.5],
          [5.240603, 52.678243, 0.5],
          [5.241422, 52.678345, 0.25],
          [5.241624, 52.678354, 0.0],
          [5.242035, 52.678339, 0.0],
          [5.242461, 52.678314, 0.0],
          [5.242567, 52.678328, 0.0],
          [5.242672, 52.678351, 0.0],
          [5.242894, 52.678424, -0.5],
          [5.243018, 52.678488, -0.75],
          [5.243138, 52.678583, -1.0],
          [5.243216, 52.678684, -1.25],
          [5.243269, 52.678804, -1.5],
          [5.243320, 52.679160, -1.75],
          [5.243408, 52.679745, -1.75],
          [5.243447, 52.679433, -1.75],
          [5.243399, 52.678806, -1.75],
          [5.243388, 52.678759, -1.75],
          [5.243332, 52.678626, -1.25],
          [5.243278, 52.678551, -1.0],
          [5.243261, 52.678536, -0.75],
          [5.243278, 52.678551, -1.0],
          [5.243332, 52.678626, -1.25],
          [5.243388, 52.678759, -1.25],
          [5.243399, 52.678806, -1.25],
          [5.243447, 52.679433, -1.25],
          [5.243408, 52.679745, -1.25],
          [5.243408, 52.679900, -1.25],
          [5.243291, 52.681492, 0.0],
          [5.243303, 52.681594, 0.0],
          [5.243352, 52.681690, 0.0],
          [5.243449, 52.681770, -0.25],
          [5.243513, 52.681802, -0.25],
          [5.243603, 52.681830, -0.5],
          [5.244398, 52.681987, -1.0],
          [5.244623, 52.682043, -1.0],
          [5.244792, 52.682097, -0.75],
          [5.244904, 52.682140, -0.75],
          [5.244978, 52.682176, -0.75],
          [5.245059, 52.682232, -0.75],
          [5.245104, 52.682280, -0.75],
          [5.245165, 52.682378, -0.75],
          [5.245193, 52.682514, -0.75],
          [5.245309, 52.683475, -2.5],
          [5.245412, 52.684400, 0.0],
          [5.245426, 52.684634, 0.0],
          [5.245418, 52.684727, 0.0],
          [5.245400, 52.684797, 0.0],
          [5.245366, 52.684872, 0.0],
          [5.245295, 52.684987, 0.0],
          [5.245239, 52.685039, 0.0],
          [5.245311, 52.685081, 0.0],
          [5.245367, 52.685117, 0.0],
          [5.245381, 52.685136, 0.0],
          [5.245390, 52.685187, 0.0],
          [5.245389, 52.685406, 0.0],
          [5.245410, 52.685487, 0.0],
          [5.245447, 52.685556, 0.0],
          [5.245517, 52.685619, 0.0],
          [5.245565, 52.685647, 0.0],
          [5.245680, 52.685682, 0.0],
          [5.245775, 52.685697, 0.0],
          [5.245900, 52.685705, 0.0],
          [5.246926, 52.685727, 0.0],
          [5.247228, 52.685750, 0.0],
          [5.247401, 52.685790, 0.0],
          [5.247471, 52.685822, 0.0],
          [5.247544, 52.685859, 0.0],
          [5.247655, 52.685934, 0.0],
          [5.248045, 52.686251, 0.0],
          [5.248054, 52.686258, 0.0],
          [5.248284, 52.686427],
          [5.248461, 52.686555],
          [5.248563, 52.686677, 1.5],
          [5.248607, 52.686694, 1.5],
          [5.248759, 52.686705, 1.25],
          [5.249402, 52.686783, 0.25],
          [5.250746, 52.686970, 0.5],
          [5.251417, 52.687049, 0.75],
          [5.251643, 52.687069, 1.0],
          [5.252831, 52.687121, 0.5],
          [5.253371, 52.687151, 0.25],
          [5.254254, 52.687261, 0.25],
          [5.254394, 52.687278, 0.0],
          [5.254602, 52.687308, 0.0],
          [5.255695, 52.687462, 0.0],
          [5.256265, 52.687528, 0.25],
          [5.256520, 52.687550, 0.5],
          [5.257160, 52.687576, 0.5],
          [5.257343, 52.687578, 0.5],
          [5.257732, 52.687567, 0.5],
          [5.258089, 52.687548, 0.0],
          [5.258820, 52.687477, 0.0],
          [5.259340, 52.687433, 0.0],
          [5.259606, 52.687417, 0.0],
          [5.259986, 52.687422, 0.0],
          [5.260361, 52.687455, 0.0],
          [5.260768, 52.687526, 0.0],
          [5.261274, 52.687625, -0.5],
          [5.261584, 52.687695, -0.75],
          [5.262760, 52.687971, -1.75],
          [5.263402, 52.688142, -2.0],
          [5.263944, 52.688310, -2.0],
          [5.264822, 52.688637, -1.75],
          [5.265254, 52.688834, -1.75],
          [5.265886, 52.689207, -2.0],
          [5.266339, 52.689456, -2.0],
          [5.269888, 52.691273, -0.5],
          [5.270102, 52.691387, -0.5],
          [5.270670, 52.691717, -1.0],
          [5.272001, 52.692496, -1.5],
          [5.272781, 52.692984, -0.5],
          [5.273079, 52.693190, 0.0],
          [5.273541, 52.693539, 0.0],
          [5.273700, 52.693685, 0.0],
          [5.273845, 52.693824, 0.0],
          [5.273943, 52.693937, 0.0],
          [5.274036, 52.694088, 0.0],
          [5.274050, 52.694095, 0.0],
          [5.274074, 52.694096, 0.0],
          [5.274241, 52.694061, 0.0],
          [5.274384, 52.694036, 0.0],
          [5.274500, 52.694022, 0.0],
          [5.275231, 52.694485, -0.5],
          [5.275637, 52.694631, -0.5],
          [5.275939, 52.694788, -0.5],
          [5.276005, 52.694832, -0.5],
          [5.276403, 52.695216, -0.25],
          [5.276628, 52.695286, 0.0],
          [5.276668, 52.695302, 0.0],
          [5.276691, 52.695320, 0.0],
          [5.276711, 52.695340, 0.0],
          [5.276812, 52.695438, 0.0],
          [5.276852, 52.695472, 0.0],
          [5.276919, 52.695532, 0.0],
          [5.276860, 52.695567, 0.0],
          [5.277001, 52.695668, 0.25],
          [5.277064, 52.695703, 0.25],
          [5.277147, 52.695742, 0.5],
          [5.277431, 52.695843, 0.75],
          [5.278028, 52.696003, 1.5],
          [5.278559, 52.696069, 1.75],
          [5.279175, 52.696214, 1.5],
          [5.279377, 52.696251, 1.25],
          [5.280064, 52.696320, 0.75],
          [5.281077, 52.696410, 0.25],
          [5.281902, 52.696561, 0.75],
          [5.282666, 52.696705, 0.75],
          [5.283387, 52.696876, 0.25],
          [5.283625, 52.696949, 0.0],
          [5.283742, 52.697001, 0.0],
          [5.283807, 52.697045, 0.0],
          [5.283882, 52.697149, -0.25],
          [5.283882, 52.697214, -0.5],
          [5.283833, 52.697285, -0.75],
          [5.283767, 52.697425, -1.25],
          [5.283675, 52.697765, -1.0],
          [5.283446, 52.698579, 0.25],
          [5.283441, 52.698660, 0.25],
          [5.283465, 52.698749, 0.25],
          [5.283508, 52.698798, 0.5],
          [5.283580, 52.698835, 0.5],
          [5.283760, 52.698878, 0.5],
          [5.288191, 52.699352, 0.5],
          [5.289184, 52.699454, 0.5],
          [5.289369, 52.699493, 0.5],
          [5.289316, 52.699533, 0.75],
          [5.289395, 52.699596, 0.75],
          [5.289430, 52.699677, 0.75],
          [5.289419, 52.699694, 0.75],
          [5.294077, 52.69891, 0],
          [5.313859, 52.708402, 0],
          [5.325108, 52.838965, 0],
          [5.35496, 52.886847, 0],
          [5.358677, 52.886711, 0.25],
          [5.358922, 52.886737, 0.5],
          [5.361541, 52.887000, 3.0],
          [5.361538, 52.887011, 2.75],
          [5.361448, 52.887356, 2.0],
          [5.361447, 52.887386, 2.0],
          [5.361450, 52.887414, 1.75],
          [5.361470, 52.887438, 1.75],
          [5.361747, 52.887606, 1.75],
          [5.361190, 52.887787, 1.25],
          [5.361142, 52.887812, 1.0],
          [5.361105, 52.887842, 1.0],
          [5.361040, 52.887932, 1.0],
          [5.361009, 52.888057, 1.0],
          [5.361005, 52.888305, 1.0],
          [5.359339, 52.888330, 1.0],
          [5.359106, 52.888351, 0.75],
          [5.358916, 52.888379, 0.75],
          [5.358733, 52.888418, 0.75],
          [5.358564, 52.888488, 0.75],
          [5.358371, 52.888588, 0.5],
          [5.358284, 52.888656, 0.5],
          [5.358223, 52.888727, 0.25],
          [5.358183, 52.888813, 0.25],
          [5.358157, 52.888870, 0.25],
          [5.358154, 52.888910, 0.0],
          [5.358182, 52.888970, 0.0],
          [5.358231, 52.889027, 0.0],
          [5.358451, 52.889206, 0.0],
          [5.359121, 52.889741, -0.5],
          [5.359373, 52.890008, -0.5],
          [5.359671, 52.890521, 0.25],
          [5.360071, 52.891145, 0.75],
          [5.360259, 52.891461, 0.5],
          [5.360445, 52.891740, 0.25],
          [5.360607, 52.891906, 0.25],
          [5.360973, 52.892190, 0.0],
          [5.361173, 52.892335, -0.25],
          [5.361401, 52.892483, -0.5],
          [5.361610, 52.892593, -0.5],
          [5.361629, 52.892604, -0.75],
          [5.362048, 52.892795, -0.5],
          [5.363303, 52.893282, 0.0],
          [5.364017, 52.893577, -0.5],
          [5.364735, 52.893899, -0.5],
          [5.365379, 52.894279, -0.25],
          [5.365756, 52.894559, -0.25],
          [5.367385, 52.896122, 0.0],
          [5.368341, 52.897066, 0.0],
          [5.368746, 52.897411, 0.0],
          [5.369543, 52.897999, 0.0],
          [5.370062, 52.898340, 0.0],
          [5.371042, 52.898829, 0.0],
          [5.371467, 52.899011, 0.0],
          [5.372180, 52.899200, 0.0],
          [5.375559, 52.899776, 1.0],
          [5.376129, 52.899896, 1.5],
          [5.377421, 52.900423, 0.5],
          [5.378162, 52.900777, 0.75],
          [5.378653, 52.900916, 0.5],
          [5.379752, 52.901174, 0.0],
          [5.380926, 52.901536, 0.5],
          [5.382411, 52.901855, 0.25],
          [5.383939, 52.902359, 0.0],
          [5.384382, 52.902533, 0.0],
          [5.385363, 52.903204, 0.0],
          [5.385916, 52.903398, 0.0],
          [5.386369, 52.903567, -0.25],
          [5.386925, 52.903849, -0.25],
          [5.387480, 52.904193, 0.0],
          [5.388219, 52.904786, 0.0],
          [5.388451, 52.904914, 0.0],
          [5.388712, 52.905011, 0.0],
          [5.389246, 52.905139, 0.0],
          [5.390442, 52.905332, 0.25],
          [5.390631, 52.905359, 0.25],
          [5.390818, 52.905370, 0.25],
          [5.390963, 52.905351, 0.25],
          [5.391105, 52.905315, 0.25],
          [5.391302, 52.905244, 0.0],
          [5.391537, 52.905122, 0.0],
          [5.392050, 52.904756, 0.25],
          [5.392310, 52.904595, 0.25],
          [5.392494, 52.904502, 0.5],
          [5.392694, 52.904447, 0.5],
          [5.392921, 52.904413, 0.75],
          [5.393249, 52.904385, 1.0],
          [5.393675, 52.904390, 1.0],
          [5.393856, 52.904405, 1.0],
          [5.394194, 52.904455, 0.75],
          [5.394570, 52.904543, 0.25],
          [5.394657, 52.904572, 0.0],
          [5.394793, 52.904617, 0.0],
          [5.395200, 52.904754, -0.25],
          [5.396058, 52.905060, -0.75],
          [5.396816, 52.905318, -0.5],
          [5.396982, 52.905352, -0.5],
          [5.397130, 52.905368, -0.5],
          [5.397372, 52.905383, -0.5],
          [5.398140, 52.905410, 0.0],
          [5.398731, 52.905449, 0.0],
          [5.399348, 52.905499, -0.25],
          [5.400231, 52.905579, -0.5],
          [5.400607, 52.905625, -0.5],
          [5.400985, 52.905686, -0.25],
          [5.401225, 52.905755, 0.0],
          [5.401478, 52.905844, 0.0],
          [5.401801, 52.906001, 0.0],
          [5.402113, 52.906185, -0.25],
          [5.402661, 52.906591, -0.25],
          [5.404272, 52.907822, -1.0],
          [5.405425, 52.908655, -0.75],
          [5.406635, 52.909510, 0.0],
          [5.407893, 52.910467, -0.75],
          [5.408345, 52.910840, -1.0],
          [5.408619, 52.911094, -1.0],
          [5.408802, 52.911301, -1.0],
          [5.408986, 52.911525, -1.0],
          [5.410568, 52.913604, -0.25],
          [5.411316, 52.914631, -0.25],
          [5.411600, 52.915080, 0.0],
          [5.411740, 52.915367, 0.0],
          [5.411815, 52.915576, 0.0],
          [5.411864, 52.915777, 0.0],
          [5.411874, 52.916092, 0.0],
          [5.411803, 52.916353, 0.0],
          [5.410509, 52.918984, -0.25],
          [5.410272, 52.919289, -0.5],
          [5.409947, 52.919595, -0.75],
          [5.409847, 52.919699, -1.0],
          [5.409799, 52.919784, -1.25],
          [5.409763, 52.919871, -1.25],
          [5.409769, 52.920038, -1.5],
          [5.409885, 52.920387, -1.75],
          [5.409909, 52.920528, -1.75],
          [5.409950, 52.921450, -1.0],
          [5.409975, 52.921707, -0.75],
          [5.410250, 52.922705, 0.0],
          [5.410299, 52.922976, 0.0],
          [5.410314, 52.923411, 0.0],
          [5.410267, 52.924243, 0.5],
          [5.410267, 52.924258, 0.5],
          [5.410264, 52.924556, 0.5],
          [5.410331, 52.924784, 0.5],
          [5.410339, 52.924895, 0.5],
          [5.410287, 52.925280, 0.25],
          [5.410177, 52.926502, 1.0],
          [5.409953, 52.927477, 0.75],
          [5.409801, 52.927745, 0.25],
          [5.409452, 52.928079, 0.0],
          [5.408507, 52.928650, -0.25],
          [5.407430, 52.929250, -1.0],
          [5.406921, 52.929594, -1.0],
          [5.405696, 52.930529, -0.5],
          [5.405421, 52.930803, -0.75],
          [5.405274, 52.931014, -0.75],
          [5.404751, 52.932098, 0.0],
          [5.404510, 52.932680, 0.0],
          [5.404326, 52.933241, 0.0],
          [5.404270, 52.933411, 0.0],
          [5.404104, 52.933711, 0.0],
          [5.403726, 52.934348, 0.0],
          [5.403443, 52.934929, 0.75],
          [5.403162, 52.935588, 0.0],
          [5.403019, 52.935964, 0.0],
          [5.402851, 52.936534, 0.0],
          [5.402823, 52.936634, 0.0],
          [5.402855, 52.936765, 0.0],
          [5.402831, 52.936791, 0.0],
          [5.402761, 52.936870, 0.0],
          [5.402622, 52.937383, 0.0],
          [5.402482, 52.937966, 0.0],
          [5.402437, 52.938253, 0.0],
          [5.402406, 52.938541, 0.0],
          [5.402370, 52.939023, 0.0],
          [5.402321, 52.939464, 0.25],
          [5.402225, 52.939679, 0.5],
          [5.402140, 52.939817, 0.75],
          [5.401950, 52.940009, 1.0],
          [5.401602, 52.940260, 0.75],
          [5.400366, 52.941153, 1.0],
          [5.400932, 52.941467, 1.0],
          [5.401220, 52.941620, 1.0],
          [5.401617, 52.941841, 1.0],
          [5.401792, 52.941945, 1.25],
          [5.402020, 52.942100, 1.5],
          [5.402363, 52.942469, 1.75],
          [5.402596, 52.942718, 1.75],
          [5.402642, 52.942768, 2.0],
          [5.403050, 52.942584, 2.0],
          [5.403150, 52.942538, 2.0],
          [5.403198, 52.942519, 2.0],
          [5.403742, 52.943063, 2.0],
          [5.403821, 52.943086, 2.0],
          [5.403870, 52.943091, 2.0],
          [5.403931, 52.943085, 2.0],
          [5.403988, 52.943066, 2.0],
          [5.404638, 52.942767, 1.5],
          [5.404738, 52.942711, 1.25],
          [5.405357, 52.942232, 0.5],
          [5.405595, 52.942082, 0.25],
          [5.405716, 52.942036, 0.25],
          [5.405883, 52.941990, 0.25],
          [5.406018, 52.941962, 0.25],
          [5.406155, 52.941943, 0.25],
          [5.407046, 52.941892, 0.5],
          [5.407330, 52.941891, 0.5],
          [5.408206, 52.941906, 0.25],
          [5.408271, 52.941900, 0.25],
          [5.408443, 52.941866, 0.0],
          [5.408606, 52.941852, 0.0],
          [5.408780, 52.941864, 0.0],
          [5.409286, 52.941940, 0.25],
          [5.411104, 52.942133, -0.25],
          [5.412235, 52.942272, -1.0],
          [5.412572, 52.942324, -0.75],
          [5.413180, 52.942460, 0.0],
          [5.415134, 52.942979, 0.0],
          [5.417177, 52.943480, 0.0],
          [5.417417, 52.943513, 0.0],
          [5.417657, 52.943529, 0.0],
          [5.417757, 52.943550, 0.0],
          [5.417892, 52.943588, 0.0],
          [5.417805, 52.943728, 0.0],
          [5.417772, 52.943773, 0.0],
          [5.417733, 52.943830, 0.0],
          [5.417886, 52.943904, 0.25],
          [5.420452, 52.944569, 0.0],
          [5.420769, 52.944674, 0.0],
          [5.421025, 52.944741, 0.0],
          [5.421456, 52.944845, 0.0],
          [5.421746, 52.944904, 0.0],
          [5.424007, 52.945460, 0.0],
          [5.424393, 52.945534, 0.0],
          [5.425597, 52.945730, 0.0],
          [5.426339, 52.945845, 0.0],
          [5.428198, 52.946147, -0.75],
          [5.428440, 52.946181, -1.0],
          [5.428894, 52.946212, -1.0],
          [5.429538, 52.946224, -1.0],
          [5.429706, 52.946232, -1.25],
          [5.430149, 52.946269, -1.25],
          [5.430545, 52.946341, -1.25],
          [5.430875, 52.946433, -1.25],
          [5.431119, 52.946524, -1.25],
          [5.431290, 52.946599, -1.5],
          [5.431457, 52.946679, -1.5],
          [5.431705, 52.946826, -1.75],
          [5.431933, 52.946997, -1.5],
          [5.432262, 52.947295, -1.25],
          [5.432390, 52.947391, -1.0],
          [5.432520, 52.947462, -0.75],
          [5.432697, 52.947524, -0.75],
          [5.432872, 52.947557, -0.5],
          [5.433403, 52.947626, 0.0],
          [5.433374, 52.947701, 0.0],
          [5.433359, 52.947741, -0.25],
          [5.432173, 52.950970, -1.0],
          [5.431895, 52.951695, -0.75],
          [5.431839, 52.951889, -0.5],
          [5.431826, 52.951989, -0.5],
          [5.431847, 52.952150, -0.25],
          [5.431929, 52.952507, 0.0],
          [5.431939, 52.952610, 0.0],
          [5.431928, 52.952688, 0.0],
          [5.431904, 52.952751, -0.25],
          [5.431780, 52.952996, -0.5],
          [5.431622, 52.953271, -0.75],
          [5.431525, 52.953403, -1.0],
          [5.431245, 52.953696, -1.0],
          [5.431147, 52.953840, -1.0],
          [5.431075, 52.954002, -1.0],
          [5.429163, 52.959194, -2.0],
          [5.426456, 52.966615, 0.0],
          [5.426289, 52.967074, 0.0],
          [5.426243, 52.967309, 0.25],
          [5.426241, 52.967440, 0.25],
          [5.426292, 52.967579, 0.5],
          [5.426348, 52.967696, 0.75],
          [5.426496, 52.967858, 1.25],
          [5.426642, 52.967960, 1.5],
          [5.428225, 52.968741, 1.5],
          [5.429795, 52.969498, 0.0],
          [5.430460, 52.969818, 0.0],
          [5.432460, 52.970803, 0.75],
          [5.434144, 52.971570, 1.75],
          [5.434383, 52.971677, 2.0],
          [5.434523, 52.971740, 2.25],
          [5.434652, 52.971816, 2.25],
          [5.434569, 52.972052, 1.75],
          [5.434510, 52.972185, 1.5],
          [5.434482, 52.972220, 1.25],
          [5.434435, 52.972247, 1.25],
          [5.434344, 52.972294, 1.25],
          [5.434233, 52.972348, 1.0],
          [5.434128, 52.972368, 1.0],
          [5.433656, 52.972548, 1.0],
          [5.433642, 52.972576, 1.0],
          [5.433602, 52.972604, 1.0],
          [5.433358, 52.972703, 1.0],
          [5.433115, 52.972789, 0.5],
          [5.432509, 52.972963, 0.0],
          [5.432447, 52.973020, 0.0],
          [5.432382, 52.973056, 0.0],
          [5.432236, 52.973099, 0.0],
          [5.432098, 52.973145, -0.25],
          [5.431928, 52.973251, -0.5],
          [5.431811, 52.973347, -0.75],
          [5.431781, 52.973380, -0.75],
          [5.431722, 52.973489, -0.5],
          [5.431626, 52.973592, -0.25],
          [5.431588, 52.973667, 0.0],
          [5.431510, 52.973892, 0.0],
          [5.431388, 52.974286, 0.25],
          [5.431309, 52.974626, -0.25],
          [5.431262, 52.975070, -0.75],
          [5.431181, 52.975429, -0.75],
          [5.431044, 52.975777, -0.75],
          [5.430828, 52.976236, 0.0],
          [5.430748, 52.976550, 0.5],
          [5.430687, 52.977269, 0.25],
          [5.430685, 52.977540, 0.0],
          [5.430701, 52.977700, 0.0],
          [5.430910, 52.978500, -0.5],
          [5.431129, 52.979139, 0.0],
          [5.431390, 52.979760, -0.25],
          [5.432135, 52.981284, -0.5],
          [5.432289, 52.981581, -0.75],
          [5.432446, 52.981808, -1.0],
          [5.432605, 52.982012, -1.25],
          [5.433022, 52.982459, -1.25],
          [5.433167, 52.982658, -0.75],
          [5.433287, 52.982860, 0.0],
          [5.433383, 52.983106, 0.25],
          [5.433388, 52.983231, 0.5],
          [5.433334, 52.983614, 1.5],
          [5.433343, 52.983718, 1.75],
          [5.433438, 52.983921, 2.25],
          [5.433637, 52.984275, 2.25],
          [5.433710, 52.984347, 2.0],
          [5.433774, 52.984428, 1.75],
          [5.433928, 52.984710, 0.75],
          [5.433944, 52.984762, 0.75],
          [5.433953, 52.984840, 0.5],
          [5.433950, 52.984923, 0.25],
          [5.433913, 52.985038, 0.25],
          [5.433856, 52.985130, 0.5],
          [5.433530, 52.985487, 1.25],
          [5.433422, 52.985627, 1.5],
          [5.432860, 52.986586, 0.25],
          [5.432752, 52.986738, 0.25],
          [5.432653, 52.986854, 0.25],
          [5.432225, 52.987287, 0.25],
          [5.432014, 52.987492, 0.0],
          [5.431812, 52.987690, 0.0],
          [5.431328, 52.988230, -0.75],
          [5.431203, 52.988350, -1.0],
          [5.429955, 52.989234, -1.0],
          [5.429755, 52.989412, -1.0],
          [5.429298, 52.989853, -0.25],
          [5.429084, 52.990077, 0.0],
          [5.428993, 52.990189, 0.0],
          [5.428956, 52.990243, -0.25],
          [5.428905, 52.990353, -0.25],
          [5.428861, 52.990487, -0.5],
          [5.428749, 52.990982, -1.0],
          [5.428700, 52.991147, -1.0],
          [5.428634, 52.991299, -1.0],
          [5.428562, 52.991422, -1.0],
          [5.428302, 52.991773, -0.75],
          [5.428113, 52.992006, -0.75],
          [5.427619, 52.992586, -0.75],
          [5.427370, 52.992857, -1.0],
          [5.427079, 52.993125, -1.0],
          [5.427002, 52.993211, -1.0],
          [5.426945, 52.993315, -1.0],
          [5.426906, 52.993415, -1.0],
          [5.426886, 52.993526, -1.0],
          [5.426832, 52.994128, -1.0],
          [5.426794, 52.994325, -1.0],
          [5.426310, 52.996049, -0.25],
          [5.426286, 52.996179, -0.25],
          [5.426254, 52.996561, -0.5],
          [5.426210, 52.996730, -0.25],
          [5.426091, 52.997071, -0.25],
          [5.426006, 52.997458, 0.0],
          [5.426003, 52.997486, 0.0],
          [5.425972, 52.997730, 0.0],
          [5.425881, 52.998120, 0.0],
          [5.425883, 52.998205, 0.0],
          [5.425904, 52.998287, 0.0],
          [5.425956, 52.998380, 0.0],
          [5.426103, 52.998571, -0.5],
          [5.426149, 52.998654, -0.75],
          [5.426170, 52.998727, -0.75],
          [5.426178, 52.998809, -0.75],
          [5.426154, 52.998929, -1.0],
          [5.425960, 52.999530, -0.5],
          [5.425809, 53.000151, 0.0],
          [5.425752, 53.000417, 0.0],
          [5.425718, 53.000566, 0.0],
          [5.425832, 53.000571, 0.0],
          [5.426059, 53.000577, 0.0],
          [5.426354, 53.000574, 0.25],
          [5.426501, 53.000565, 0.5],
          [5.426639, 53.000544, 0.5],
          [5.426760, 53.000517, 0.5],
          [5.426895, 53.000477, 0.5],
          [5.427000, 53.000427, 0.5],
          [5.427119, 53.000367, 0.25],
          [5.427240, 53.000317, 0.25],
          [5.427458, 53.000258, 0.25],
          [5.427925, 53.000208, 0.0],
          [5.428434, 53.000179, 0.0],
          [5.428678, 53.000185, 0.0],
          [5.428949, 53.000210, 0.0],
          [5.429490, 53.000300, 0.0],
          [5.429687, 53.000326, 0.0],
          [5.429870, 53.000340, -0.25],
          [5.430008, 53.000339, -0.25],
          [5.430146, 53.000330, -0.25],
          [5.430279, 53.000312, -0.25],
          [5.430601, 53.000261, -0.25],
          [5.430722, 53.000269, -0.25],
          [5.430753, 53.000272, -0.25],
          [5.430881, 53.000298, -0.25],
          [5.430982, 53.000340, -0.25],
          [5.431087, 53.000398, -0.25],
          [5.431155, 53.000452, -0.5],
          [5.431206, 53.000506, -0.5],
          [5.431207, 53.000448, -0.5],
          [5.431244, 53.000276, -0.25],
          [5.431279, 53.000183, -0.5],
          [5.431327, 53.000094, -0.5],
          [5.431367, 53.000016, -0.5],
          [5.431388, 52.999978, -0.5],
          [5.431186, 53.000068, -0.25],
          [5.431021, 53.000132, -0.25],
          [5.430833, 53.000189, -0.25],
          [5.430601, 53.000261, -0.25],
          [5.430753, 53.000272, -0.25],
          [5.430881, 53.000298, -0.25],
          [5.430982, 53.000340, -0.25],
          [5.431087, 53.000398, -0.25],
          [5.431155, 53.000452, -0.5],
          [5.431206, 53.000506, -0.5],
          [5.431292, 53.000833, -0.25],
          [5.431600, 53.002000, 0.0],
          [5.431621, 53.002172, -0.25],
          [5.431610, 53.002340, -0.5],
          [5.431557, 53.002543, -1.0],
          [5.431503, 53.002706, -1.0],
          [5.431348, 53.003084, -1.0],
          [5.431158, 53.003473, -1.0],
          [5.430845, 53.004000, -1.75],
          [5.430794, 53.004137, -1.75],
          [5.430770, 53.004255, -1.75],
          [5.430739, 53.004448, -1.25],
          [5.430725, 53.004994, 0.0],
          [5.430731, 53.005072, 0.0],
          [5.430768, 53.005215, 0.0],
          [5.430798, 53.005279, 0.0],
          [5.430861, 53.005380, 0.0],
          [5.430927, 53.005466, 0.0],
          [5.430989, 53.005503, 0.0],
          [5.430927, 53.005466, 0.0],
          [5.430615, 53.005597, -0.25],
          [5.430504, 53.005635, -0.25],
          [5.430301, 53.005432, -0.5],
          [5.429387, 53.005428, -1.0],
          [5.429159, 53.005413, -1.0],
          [5.429112, 53.005421, -1.0],
          [5.429063, 53.005457, -1.0],
          [5.428880, 53.005773, -1.0],
          [5.428818, 53.005807, -1.0],
          [5.428765, 53.005818, -1.0],
          [5.427291, 53.005876, -1.0],
          [5.426720, 53.005911, -1.0],
          [5.426571, 53.005925, -1.0],
          [5.425751, 53.006075, -1.5],
          [5.425614, 53.006090, -1.5],
          [5.425489, 53.006088, -1.5],
          [5.425411, 53.006081, -1.5],
          [5.425300, 53.006062, -1.5],
          [5.424892, 53.005964, -1.75],
          [5.424825, 53.005960, -1.5],
          [5.424779, 53.005978, -1.5],
          [5.424668, 53.006133, -1.5],
          [5.424633, 53.006174, -1.5],
          [5.424082, 53.006406, -1.5],
          [5.424037, 53.006432, -1.5],
          [5.424009, 53.006471, -1.5],
          [5.423999, 53.006530, -1.75],
          [5.423962, 53.006578, -1.75],
          [5.423125, 53.007071, -1.25],
          [5.422854, 53.007215, -1.0],
          [5.422141, 53.007541, -1.0],
          [5.422113, 53.007566, -1.0],
          [5.422107, 53.007581, -1.0],
          [5.422104, 53.007695, -1.0],
          [5.422074, 53.007730, -1.0],
          [5.421891, 53.007828, -1.0],
          [5.421798, 53.007914, -1.0],
          [5.421549, 53.008053, -0.75],
          [5.421524, 53.008102, -0.75],
          [5.421533, 53.008206, -0.75],
          [5.421527, 53.008241, -0.75],
          [5.421501, 53.008282, -0.75],
          [5.421478, 53.008299, -0.75],
          [5.420252, 53.009055, -1.75],
          [5.419548, 53.009350, -1.25],
          [5.419409, 53.009418, -1.25],
          [5.419317, 53.009482, -1.25],
          [5.419232, 53.009530, -1.25],
          [5.418871, 53.009716, -1.5],
          [5.418814, 53.009751, -1.5],
          [5.418781, 53.009783, -1.5],
          [5.418667, 53.009946, -1.75],
          [5.418663, 53.009970, -1.75],
          [5.418688, 53.010026, -1.75],
          [5.418749, 53.010065, -1.75],
          [5.418994, 53.010138, -1.75],
          [5.419066, 53.010153, -1.75],
          [5.419279, 53.010178, -1.5],
          [5.419293, 53.010199, -1.5],
          [5.419294, 53.010256, -1.5],
          [5.419284, 53.010270, -1.5],
          [5.419259, 53.010285, -1.5],
          [5.417117, 53.011185, -2.0],
          [5.416801, 53.011289, -2.0],
          [5.416538, 53.011384, -1.75],
          [5.413520, 53.012682, -1.0],
          [5.413438, 53.012731, -1.25],
          [5.413407, 53.012786, -1.25],
          [5.413407, 53.012856, -1.25],
          [5.413438, 53.012932, -1.5],
          [5.413485, 53.013004, -1.5],
          [5.413546, 53.013060, -1.5],
          [5.413935, 53.013339, -1.75],
          [5.413792, 53.013410, -1.75],
          [5.413620, 53.013462, -1.75],
          [5.413487, 53.013511, -1.75],
          [5.411818, 53.014213, -1.0],
          [5.411585, 53.014330, -0.75],
          [5.410871, 53.014733, 0.0],
          [5.410566, 53.014937, 0.25],
          [5.410212, 53.015187, 0.75],
          [5.410161, 53.015183, 0.75],
          [5.410103, 53.015193, 0.75],
          [5.409732, 53.015296, 1.0],
          [5.409660, 53.015310, 1.0],
          [5.409557, 53.015317, 1.0],
          [5.409260, 53.015310, 1.25],
          [5.409080, 53.015370, 1.25],
          [5.409030, 53.015400, 1.25],
          [5.408815, 53.015480, 1.5],
          [5.408270, 53.015840, 1.75],
          [5.408270, 53.015930, 1.5],
          [5.408300, 53.016010, 1.5],
          [5.408414, 53.016116, 1.25],
          [5.408534, 53.016251, 1.0],
          [5.408588, 53.016367, 0.75],
          [5.408585, 53.016463, 0.5],
          [5.408465, 53.016509, 0.5],
          [5.408421, 53.016565, 0.25],
          [5.408375, 53.016692, 0.0],
          [5.408240, 53.016785, 0.0],
          [5.408211, 53.016806, -0.25],
          [5.408368, 53.016989, -0.5],
          [5.408580, 53.017190, -0.75],
          [5.408713, 53.017420, -1.25],
          [5.408767, 53.017667, -1.25],
          [5.408786, 53.017899, -1.0],
          [5.408866, 53.018450, -1.0],
          [5.408902, 53.019010, -1.0],
          [5.409010, 53.020000, -1.0],
          [5.409256, 53.020751, -1.75],
          [5.409499, 53.021270, -0.75],
          [5.409986, 53.022112, -0.75],
          [5.410173, 53.022462, -1.0],
          [5.410466, 53.022815, -0.75],
          [5.410657, 53.022960, -1.0],
          [5.410962, 53.023078, -1.0],
          [5.411477, 53.023217, -1.75],
          [5.411771, 53.023329, -2.0],
          [5.412010, 53.023490, -1.75],
          [5.412120, 53.023674, -1.5],
          [5.412155, 53.024016, -1.0],
          [5.412085, 53.024946, -1.0],
          [5.411991, 53.025187, -1.0],
          [5.411345, 53.026321, -2.0],
          [5.410784, 53.027455, -1.75],
          [5.410584, 53.027836, -1.5],
          [5.410130, 53.028580, -1.25],
          [5.409505, 53.029918, -1.0],
          [5.409080, 53.030599, 0.0],
          [5.408910, 53.030950, 0.25],
          [5.408784, 53.031255, 0.0],
          [5.407970, 53.032781, -1.0],
          [5.407729, 53.033328, -1.25],
          [5.407577, 53.033848, -1.0],
          [5.407485, 53.034043, -1.0],
          [5.407367, 53.034157, -1.0],
          [5.407206, 53.034354, -0.75],
          [5.406992, 53.034704, -0.25],
          [5.406040, 53.036570, -1.5],
          [5.405690, 53.037280, -1.25],
          [5.405322, 53.038089, -0.75],
          [5.405215, 53.038219, -0.75],
          [5.404740, 53.038740, -0.75],
          [5.404414, 53.039066, -0.75],
          [5.404246, 53.039280, -0.75],
          [5.404145, 53.039505, -0.5],
          [5.404161, 53.040055, 0.0],
          [5.404322, 53.040730, -0.5],
          [5.405040, 53.042696, -1.0],
          [5.405382, 53.043533, -1.25],
          [5.405773, 53.044269, -1.75],
          [5.405834, 53.044479, -1.5],
          [5.405869, 53.044684, -1.25],
          [5.405904, 53.045023, -1.0],
          [5.405837, 53.045700, -2.5],
          [5.405601, 53.047544, -0.5],
          [5.405459, 53.048313, -0.75],
          [5.404960, 53.050270, 0.25],
          [5.404904, 53.050278, 0.5],
          [5.404693, 53.050395, 1.0],
          [5.404443, 53.050491, 1.5],
          [5.404303, 53.050576, 1.75],
          [5.404170, 53.050663, 1.75],
          [5.404130, 53.050689, 2.0],
          [5.404088, 53.050765, 2.0],
          [5.404150, 53.051024, 2.0],
          [5.404278, 53.051635, 2.75],
          [5.404263, 53.051738, 2.75],
          [5.404189, 53.051884, 2.75],
          [5.403910, 53.052385, 3.5],
          [5.403858, 53.052540, 3.5],
          [5.403912, 53.052553, 3.5],
          [5.403819, 53.052710, 3.5],
          [5.403360, 53.053402, 2.75],
          [5.403128, 53.053689, 2.25],
          [5.403021, 53.053799, 2.0],
          [5.402834, 53.053992, 1.5],
          [5.402545, 53.054277, 1.0],
          [5.402480, 53.054368, 1.0],
          [5.402483, 53.054468, 1.25],
          [5.402484, 53.054515, 1.25],
          [5.402480, 53.054643, 1.5],
          [5.402479, 53.054659, 1.5],
          [5.402473, 53.054849, 1.75],
          [5.402454, 53.055107, 2.0],
          [5.402430, 53.055300, 2.25],
          [5.402438, 53.055396, 2.25],
          [5.402460, 53.055529, 2.5],
          [5.402518, 53.055877, 2.75],
          [5.402532, 53.055991, 2.75],
          [5.402560, 53.056221, 2.5],
          [5.402573, 53.056288, 2.5],
          [5.402581, 53.056347, 2.5],
          [5.402641, 53.056744, 2.0],
          [5.402666, 53.056986, 1.75],
          [5.402728, 53.057091, 1.75],
          [5.402849, 53.057071, 2.0],
          [5.402728, 53.057091, 1.75],
          [5.402473, 53.057228, 1.25],
          [5.402259, 53.057366, 1.0],
          [5.402132, 53.057463, 1.0],
          [5.402067, 53.057530, 1.0],
          [5.402027, 53.057581, 1.0],
          [5.401999, 53.057638, 1.0],
          [5.401922, 53.058058, 1.0],
          [5.402529, 53.058118, 1.0],
          [5.402572, 53.058138, 1.0],
          [5.402598, 53.058183, 1.0],
          [5.402595, 53.058247, 1.0],
          [5.402562, 53.058484, 0.5],
          [5.402543, 53.058602, 0.25],
          [5.402529, 53.058685, 0.0],
          [5.402543, 53.058602, 0.25],
          [5.402562, 53.058484, 0.5],
          [5.402595, 53.058247, 1.0],
          [5.402598, 53.058183, 1.0],
          [5.403731, 53.058252, 1.0],
          [5.403774, 53.058219, 1.0],
          [5.403820, 53.058199, 1.0],
          [5.403933, 53.058200, 1.0],
          [5.404516, 53.058235, 1.0],
          [5.405697, 53.058306, 1.0],
          [5.405684, 53.058357, 1.0],
          [5.405697, 53.058306, 1.0],
          [5.405816, 53.057850, 1.0],
          [5.405954, 53.057263, 1.25],
          [5.405985, 53.057262, 1.25],
          [5.406108, 53.057259, 1.25],
          [5.407059, 53.057299, 1.75],
          [5.407980, 53.057320, 1.25],
          [5.408301, 53.057345, 1.0],
          [5.409694, 53.057387, 1.5],
          [5.409792, 53.057380, 1.5],
          [5.409886, 53.057354, 1.5],
          [5.410137, 53.057215, 1.5],
          [5.410248, 53.057274, 1.5],
          [5.410340, 53.057320, 1.75],
          [5.410477, 53.057376, 1.75],
          [5.410523, 53.057390, 1.75],
          [5.410677, 53.057410, 1.75],
          [5.413471, 53.057510, -0.75],
          [5.413818, 53.057523, -0.25],
          [5.414202, 53.057561, 0.0],
          [5.414466, 53.057614, 0.0],
          [5.414624, 53.057654, 0.25],
          [5.414957, 53.057758, 0.25],
          [5.415286, 53.057903, 0.0],
          [5.415517, 53.058036, 0.0],
          [5.415658, 53.058132, 0.0],
          [5.415814, 53.058259, 0.0],
          [5.415915, 53.058351, 0.0],
          [5.416063, 53.058526, 0.0],
          [5.416160, 53.058695, -0.25],
          [5.416163, 53.058734, -0.5],
          [5.416146, 53.058779, -0.5],
          [5.416102, 53.058841, -0.75],
          [5.416092, 53.058947, -1.0],
          [5.416147, 53.059025, -1.25],
          [5.416323, 53.059137, -1.25],
          [5.416340, 53.059191, -1.25],
          [5.416503, 53.059191, -1.0],
          [5.416595, 53.059734, -1.0],
          [5.416716, 53.060313, -1.0],
          [5.416996, 53.061530, -1.75],
          [5.417101, 53.061935, -1.25],
          [5.417346, 53.062604, 0.0],
          [5.417794, 53.063509, -0.75],
          [5.418024, 53.063862, -0.5],
          [5.418270, 53.064240, 0.0],
          [5.418380, 53.064410, -0.25],
          [5.418546, 53.064614, -0.5],
          [5.419330, 53.065510, -0.75],
          [5.419734, 53.065903, -0.25],
          [5.420385, 53.065732, 0.0],
          [5.422000, 53.065283, -1.0],
          [5.422243, 53.065228, -1.0],
          [5.422347, 53.065221, -1.0],
          [5.422426, 53.065225, -1.0],
          [5.422495, 53.065236, -1.0],
          [5.423915, 53.065788, -1.25],
          [5.424078, 53.065868, -1.0],
          [5.424194, 53.065934, -1.0],
          [5.424296, 53.065982, -1.0],
          [5.424467, 53.066049, -0.75],
          [5.424627, 53.066089, -0.75],
          [5.424769, 53.066097, -0.75],
          [5.424938, 53.066069, -0.5],
          [5.425169, 53.066012, -0.25],
          [5.425421, 53.065938, -0.25],
          [5.425848, 53.065795, 0.0],
          [5.425850, 53.065790, 0.0]
        ]
      }
    }
  ]
}

let day14: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "14 - Wons - St.-Jacobiparochie - 39km",
        "track-length": "39033",
        "filtered ascend": "15",
        "plain-ascend": "10",
        "total-time": "6541",
        "total-energy": "644821",
        "cost": "45707",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["5425848", "53065795", "0", "12", "1350", "0", "5", "0", "0", "highway=service", "", "1", "112"],
          ["5419734", "53065911", "0", "472", "1350", "0", "43", "0", "0", "reversedirection=yes highway=unclassified", "", "72", "7277"],
          ["5423117", "53070007", "-1", "517", "1450", "0", "91", "0", "0", "highway=tertiary foot=no bicycle=use_sidepath", "", "155", "15585"],
          ["5422962", "53070022", "-1", "11", "5050", "0", "96", "0", "0", "highway=footway", "", "163", "15692"],
          ["5418329", "53064560", "0", "691", "1050", "0", "85", "0", "0", "reversedirection=yes highway=cycleway surface=paved foot=yes oneway=no", "", "284", "27815"],
          ["5417834", "53064298", "0", "49", "1050", "0", "31", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no", "", "292", "28582"],
          ["5415465", "53064855", "0", "172", "1050", "0", "92", "0", "0", "highway=cycleway surface=asphalt foot=yes", "", "320", "31358"],
          ["5415176", "53064902", "0", "21", "1050", "0", "0", "0", "0", "highway=cycleway foot=yes", "", "324", "31758"],
          ["5405425", "53064740", "-1", "671", "1050", "0", "8", "0", "0", "highway=cycleway surface=asphalt foot=yes", "", "436", "43007"],
          ["5405526", "53064120", "-1", "75", "1350", "0", "142", "0", "0", "reversedirection=yes highway=unclassified", "traffic_calming=table", "445", "43860"],
          ["5405636", "53063641", "-1", "55", "1350", "0", "2", "0", "0", "reversedirection=yes highway=unclassified", "traffic_calming=table", "452", "44543"],
          ["5397277", "53059676", "0", "922", "1350", "0", "120", "0", "0", "reversedirection=yes highway=unclassified", "", "610", "60423"],
          ["5396188", "53060298", "0", "105", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=choker", "622", "61538"],
          ["5380353", "53092630", "-1", "3909", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid access=yes horse=no", "1280", "127368"],
          ["5380449", "53092756", "-1", "16", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1283", "127636"],
          ["5383091", "53102255", "1", "1252", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "1496", "148966"],
          ["5382950", "53102180", "1", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1497", "149034"],
          ["5383091", "53102255", "-8192", "4", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1497", "149071"],
          ["5390234", "53109585", "0", "986", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1652", "164627"],
          ["5390364", "53109694", "0", "15", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1655", "164879"],
          ["5393400", "53112390", "0", "368", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1718", "171177"],
          ["5393670", "53112570", "0", "28", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1723", "171648"],
          ["5393880", "53112735", "0", "24", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "1727", "172051"],
          ["5403262", "53119541", "-8192", "1000", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "1885", "187875"],
          ["5407505", "53128057", "-8192", "999", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "2053", "204657"],
          ["5410123", "53136720", "-8192", "984", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "2218", "221189"],
          ["5411399", "53146567", "-8192", "1101", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "2403", "239687"],
          ["5412572", "53154546", "-8192", "894", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "2553", "254706"],
          ["5415782", "53162275", "-8192", "891", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "2703", "269676"],
          ["5415736", "53169375", "0", "802", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "2838", "283150"],
          ["5415727", "53169398", "0", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2838", "283200"],
          ["5415010", "53170021", "0", "90", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt bicycle=yes vehicle=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2853", "284712"],
          ["5413325", "53171180", "0", "192", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2883", "287711"],
          ["5414344", "53170987", "0", "74", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "2891", "288508"],
          ["5415331", "53170569", "0", "84", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2903", "289656"],
          ["5415602", "53170532", "0", "20", "1000", "0", "0", "0", "0", "highway=unclassified surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2906", "289969"],
          ["5415785", "53170733", "0", "32", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unknown", "2911", "290533"],
          ["5415854", "53170909", "1", "21", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "2915", "290928"],
          ["5415986", "53170997", "1", "14", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2918", "291198"],
          ["5418586", "53170966", "2", "178", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2956", "294951"],
          ["5418666", "53171574", "2", "70", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "2967", "296126"],
          ["5418712", "53171711", "2", "16", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "2970", "296385"],
          ["5418818", "53172199", "2", "57", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "2979", "297321"],
          ["5419333", "53173307", "3", "136", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3009", "300309"],
          ["5419590", "53173913", "3", "76", "1000", "0", "0", "0", "0", "highway=residential oneway=yes oneway:bicycle=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3023", "301679"],
          ["5419734", "53174575", "4", "75", "1000", "0", "0", "0", "0", "highway=living_street surface=paving_stones oneway=yes oneway:bicycle=no smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3037", "303060"],
          ["5420009", "53175524", "2", "109", "1150", "0", "0", "0", "0", "reversedirection=yes highway=living_street surface=paving_stones oneway=yes oneway:bicycle=no smoothness=intermediate", "", "3051", "304515"],
          ["5420044", "53175658", "1", "16", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "3053", "304719"],
          ["5420063", "53175765", "1", "12", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt smoothness=good", "", "3055", "304862"],
          ["5420069", "53175802", "1", "5", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "3055", "304923"],
          ["5420087", "53176099", "1", "34", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "traffic_calming=table", "3060", "305359"],
          ["5420033", "53176496", "1", "45", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "3066", "305985"],
          ["5418535", "53176423", "1", "101", "1150", "0", "90", "0", "0", "highway=residential", "", "3083", "307648"],
          ["5418490", "53176762", "1", "38", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3089", "308285"],
          ["5418483", "53176807", "1", "6", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3090", "308385"],
          ["5418479", "53176847", "1", "5", "1000", "0", "0", "0", "0", "highway=residential surface=wood smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3091", "308469"],
          ["5418472", "53176889", "1", "5", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3092", "308553"],
          ["5418412", "53177291", "1", "45", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "3099", "309308"],
          ["5419382", "53178145", "1", "123", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3120", "311373"],
          ["5419790", "53178642", "2", "72", "1000", "0", "0", "0", "0", "highway=unclassified surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes motorcar=no motorcycle=yes horse=yes wheelchair=yes", "3133", "312698"],
          ["5419729", "53178707", "1", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3135", "312850"],
          ["5419671", "53178841", "1", "16", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3137", "313108"],
          ["5419509", "53179135", "1", "35", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3143", "313670"],
          ["5419543", "53179546", "1", "50", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3151", "314517"],
          ["5419360", "53179573", "1", "14", "1050", "0", "102", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good", "highway=give_way direction=backward", "3154", "314758"],
          ["5419248", "53179573", "1", "9", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good", "highway=give_way direction=forward", "3155", "314912"],
          ["5419185", "53179579", "1", "5", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good", "", "3156", "314997"],
          ["5419381", "53179120", "1", "55", "5050", "0", "105", "0", "0", "reversedirection=yes highway=footway surface=asphalt", "", "3195", "315498"],
          ["5419556", "53178811", "1", "12", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "", "3204", "315592"],
          ["5419381", "53179120", "1", "12", "5050", "0", "0", "0", "0", "highway=footway", "", "3212", "315592"],
          ["5419185", "53179579", "1", "55", "5050", "0", "1", "0", "0", "highway=footway surface=asphalt", "", "3249", "315592"],
          ["5419248", "53179573", "1", "5", "1050", "0", "104", "0", "0", "highway=cycleway surface=asphalt smoothness=good", "highway=give_way direction=forward", "3249", "315653"],
          ["5419360", "53179573", "1", "9", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good", "highway=give_way direction=backward", "3250", "315764"],
          ["5419543", "53179546", "1", "14", "1050", "0", "11", "0", "0", "highway=cycleway surface=asphalt smoothness=good", "", "3252", "315943"],
          ["5428483", "53181132", "-1", "632", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3344", "325129"],
          ["5438769", "53181932", "0", "710", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3474", "338120"],
          ["5438771", "53182002", "0", "8", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3475", "338257"],
          ["5439386", "53183991", "0", "33", "1450", "0", "163", "0", "0", "highway=tertiary foot=use_sidepath bicycle=use_sidepath", "", "3481", "338805"],
          ["5438771", "53182002", "0", "33", "1450", "0", "78", "0", "0", "reversedirection=yes highway=tertiary foot=use_sidepath bicycle=use_sidepath", "", "3484", "339140"],
          ["5439155", "53184812", "-1", "325", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3526", "343392"],
          ["5442588", "53195017", "0", "1173", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unknown", "3729", "363635"],
          ["5434596", "53198422", "-1", "656", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3824", "373164"],
          ["5439868", "53210371", "0", "1799", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "4119", "402643"],
          ["5447543", "53218154", "0", "1011", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "4279", "418629"],
          ["5458152", "53224231", "2", "990", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "4456", "436388"],
          ["5462717", "53226034", "0", "366", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4511", "441819"],
          ["5508684", "53249316", "0", "4130", "1350", "0", "9", "0", "0", "highway=unclassified", "barrier=cattle_grid", "5193", "510099"],
          ["5515581", "53251390", "-1", "518", "1350", "0", "0", "0", "0", "highway=unclassified", "barrier=cattle_grid", "5276", "518365"],
          ["5522995", "53254670", "0", "652", "1350", "0", "1", "0", "0", "highway=unclassified", "barrier=cattle_grid", "5391", "529855"],
          ["5528775", "53257355", "0", "498", "1350", "0", "26", "0", "0", "highway=unclassified", "barrier=cattle_grid", "5471", "537907"],
          ["5533914", "53259823", "0", "451", "1350", "0", "6", "0", "0", "highway=unclassified", "barrier=cattle_grid", "5549", "545630"],
          ["5544402", "53261935", "0", "742", "1350", "0", "0", "0", "0", "highway=unclassified", "barrier=cattle_grid", "5675", "558220"],
          ["5544767", "53262053", "-1", "30", "1350", "0", "1", "0", "0", "highway=unclassified", "", "5679", "558656"],
          ["5544734", "53262167", "-1", "13", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "5681", "558833"],
          ["5550099", "53268141", "-1", "839", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "5812", "571976"],
          ["5557699", "53271577", "0", "637", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "5923", "583025"],
          ["5557954", "53271670", "0", "21", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid", "5927", "583439"],
          ["5570060", "53276118", "0", "955", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "6090", "599793"],
          ["5570178", "53276211", "0", "12", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "6092", "600002"],
          ["5570060", "53276118", "0", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "6094", "600115"],
          ["5574605", "53270552", "0", "697", "1450", "0", "77", "0", "0", "reversedirection=yes highway=tertiary", "", "6202", "610969"],
          ["5599188", "53272353", "0", "1660", "1450", "0", "86", "0", "0", "highway=tertiary", "", "6471", "637908"],
          ["5603488", "53272649", "2", "291", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6534", "644138"],
          ["5603684", "53272690", "2", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6537", "644442"],
          ["5603607", "53273155", "2", "21", "1350", "0", "69", "0", "0", "highway=unclassified", "", "6541", "644828"]
        ],
        "times": [0, 0.557, 1.127, 4.394, 6.467, 8.35, 9.682, 10.833, 12.26, 13.907, 15.002, 16.376, 18.217, 34.095, 34.91, 35.889, 37.197, 40.15, 64.476, 70.674, 72.765, 102.392, 112.885, 117.71, 124.554, 134.577, 142.761, 152.232, 155.819, 163.695, 172.354, 183.17, 189.913, 203.212, 217.044, 222.032, 242.041, 247.005, 262.082, 284.906, 285.756, 286.551, 288.309, 290.124, 291.345, 292.575, 300.279, 308.509, 320.336, 323.765, 324.329, 328.289, 336.545, 340.804, 343.84, 346.902, 351.119, 363.384, 369.685, 375.737, 412.694, 430.769, 432.348, 433.458, 434.573, 436.814, 438.424, 439.069, 439.439, 445.35, 450.859, 452.173, 453.922, 454.883, 456.136, 457.408, 466.255, 466.889, 479.813, 486.226, 487.934, 489.97, 494.891, 507.397, 514.654, 521.46, 522.553, 523.652, 524.913, 526.181, 527.538, 529.064, 530.588, 531.943, 533.127, 534.311, 535.663, 540.148, 541.569, 542.807, 547.105, 548.929, 549.925, 552.417, 553.748, 555.247, 556.67, 557.91, 559.145, 560.201, 561.429, 563.177, 565.776, 573.131, 575.479, 576.72, 578.148, 579.657, 580.93, 581.977, 585.477, 602.553, 610.968, 611.286, 612.221, 613.394, 614.519, 616.277, 619.853, 622.114, 624.149, 636.97, 641.595, 653.257, 664.833, 667.611, 673.055, 678.66, 687.217, 693.434, 701.45, 725.408, 735.504, 738.885, 745.877, 787.186, 799.587, 801.938, 803.375, 805.515, 807.641, 809.93, 811.682, 813.252, 817.762, 824.268, 826.726, 830.513, 838.728, 847.271, 856.026, 858.467, 860.942, 882.353, 892.192, 900.343, 925.115, 926.844, 932.854, 945.544, 949.81, 972.398, 983.288, 993.017, 1012.597, 1036.385, 1045.599, 1062.087, 1077.732, 1096.298, 1104.665, 1115.042, 1123.789, 1133.656, 1142.556, 1178.533, 1209.562, 1262.861, 1265.552, 1268.242, 1273.118, 1280.346, 1283.035, 1287.237, 1290.766, 1294.964, 1297.598, 1299.942, 1303.047, 1305.87, 1306.573, 1310.537, 1312.185, 1314.411, 1316.539, 1318.271, 1320.458, 1322.187, 1324.24, 1326.323, 1332.109, 1348.112, 1367.899, 1373.5, 1414.644, 1417.53, 1420.75, 1422.95, 1426.838, 1428.865, 1450.048, 1452.522, 1454.958, 1457.134, 1459.625, 1461.856, 1464.043, 1466.191, 1469.256, 1472.951, 1482.49, 1487.977, 1496.323, 1497.002, 1497.371, 1499.11, 1499.923, 1500.55, 1502.064, 1502.623, 1504.471, 1506.908, 1508.304, 1510.002, 1552.672, 1559.049, 1578.045, 1608.917, 1644.865, 1652.929, 1655.449, 1672.979, 1691.331, 1693.016, 1699.416, 1704.297, 1707.325, 1711.193, 1718.423, 1720.609, 1723.13, 1725.651, 1727.164, 1756.571, 1773.708, 1783.62, 1799.868, 1814.208, 1823.708, 1831.653, 1885.404, 1923.524, 1926.212, 1963.508, 2001.812, 2015.421, 2022.141, 2028.357, 2053.222, 2069.014, 2104.127, 2144.952, 2185.608, 2218.537, 2226.938, 2305.899, 2336.14, 2403.509, 2442.486, 2446.854, 2473.735, 2553.705, 2583.105, 2589.489, 2670.971, 2698.86, 2703.396, 2703.732, 2770.429, 2779.333, 2787.901, 2814.95, 2825.03, 2829.23, 2838.135, 2838.639, 2839.311, 2843.511, 2851.239, 2853.759, 2860.603, 2864.482, 2867.089, 2875.542, 2880.512, 2881.719, 2882.64, 2883.74, 2883.922, 2884.762, 2888.338, 2891.708, 2893.761, 2896.839, 2898.922, 2901.49, 2903.192, 2905.065, 2905.379, 2906.322, 2907.669, 2911.961, 2915.909, 2916.836, 2917.627, 2918.608, 2921.705, 2925.126, 2929.079, 2940.217, 2956.127, 2957.704, 2959.704, 2967.876, 2970.475, 2972.27, 2973.578, 2975.053, 2978.343, 2979.827, 2982.803, 3007.769, 3009.708, 3013.385, 3019.815, 3020.898, 3021.978, 3023.409, 3037.21, 3039.877, 3051.762, 3053.803, 3055.232, 3055.842, 3060.201, 3066.459, 3083.088, 3089.455, 3090.46, 3091.299, 3092.137, 3099.686, 3101.532, 3104.721, 3106.903, 3109.253, 3112.443, 3115.298, 3120.336, 3123.023, 3125.207, 3127.458, 3129.264, 3131.043, 3132.32, 3133.589, 3135.109, 3135.784, 3137.687, 3143.3, 3145.893, 3147.802, 3149.877, 3151.774, 3153.149, 3154.18, 3154.866, 3155.723, 3156.579, 3160.877, 3165.891, 3183.793, 3195.864, 3204.393, 3212.162, 3223.405, 3240.183, 3244.926, 3249.004, 3249.611, 3250.226, 3250.724, 3251.48, 3252.507, 3253.334, 3254.171, 3255.583, 3256.874, 3275.781, 3300.265, 3308.749, 3341.735, 3344.349, 3347.631, 3352.413, 3358.218, 3363.063, 3374.462, 3378.619, 3380.784, 3383.095, 3397.259, 3400.683, 3409.157, 3415.459, 3418.747, 3424.446, 3427.152, 3432.182, 3436.711, 3451.049, 3474.253, 3475.619, 3479.027, 3481.103, 3482.37, 3484.447, 3485.431, 3486.402, 3487.404, 3488.319, 3489.101, 3510.664, 3512.975, 3513.855, 3521.127, 3522.703, 3526.963, 3531.317, 3534.357, 3537.367, 3538.423, 3539.409, 3543.456, 3545.348, 3546.935, 3571.332, 3600.051, 3607.052, 3618.563, 3629.517, 3632.879, 3649.711, 3656.416, 3669.309, 3672.957, 3694.255, 3724.538, 3726.894, 3728.049, 3729.385, 3732.955, 3824.606, 3831.657, 3833.172, 3836.406, 3854.397, 3880.209, 3896.783, 3919.516, 3933.45, 3957.326, 3965.09, 3971.993, 3974.768, 3978.672, 4012.256, 4017.887, 4020.438, 4022.511, 4024.436, 4028.407, 4029.867, 4031.495, 4096.116, 4101.361, 4119.371, 4150.243, 4176.279, 4191.399, 4199.8, 4213.072, 4213.408, 4231.282, 4238.535, 4257.795, 4265.988, 4279.227, 4309.739, 4321.177, 4328.425, 4384.191, 4389.577, 4402.024, 4434.628, 4456.806, 4473.103, 4490.071, 4511.117, 4514.727, 4530.984, 4545.472, 4553.667, 4617.294, 4658.445, 4662.141, 4668.356, 4675.917, 4688.349, 4697.757, 4703.973, 4710.189, 4790.999, 4801.415, 4810.823, 4819.224, 4828.464, 4833, 4840.392, 4847.784, 4856.184, 4863.117, 4872.517, 4879.045, 4882.037, 4892.457, 4921.861, 4925.557, 4933.285, 4940.708, 4946.855, 4949.452, 4959.191, 4991.107, 4994.104, 4997.105, 5003.454, 5006.967, 5010.315, 5015.51, 5069.741, 5087.882, 5090.738, 5093.426, 5101.322, 5102.666, 5105.707, 5111.883, 5117.155, 5123.38, 5130.021, 5131.341, 5134.107, 5140.389, 5145.191, 5151.522, 5159.333, 5167.181, 5170.544, 5177.194, 5186.027, 5193.901, 5214.383, 5238.746, 5264.497, 5270.814, 5276.553, 5278.811, 5280.756, 5282.22, 5283.688, 5287.291, 5289.1, 5291.407, 5293.39, 5302.726, 5306.439, 5309.301, 5312.854, 5316.34, 5318.875, 5321.919, 5324.58, 5330.192, 5333.318, 5369.539, 5391.45, 5402.6, 5405.223, 5413.28, 5416.014, 5419.417, 5456.031, 5457.205, 5458.211, 5459.217, 5460.056, 5461.901, 5471.972, 5491.281, 5504.553, 5508.417, 5511.945, 5520.849, 5524.545, 5527.905, 5529.753, 5531.601, 5549.201, 5553.602, 5574.547, 5656.151, 5660.622, 5669.157, 5675.093, 5676.705, 5678.04, 5679.454, 5681.224, 5681.5, 5681.869, 5692.219, 5709.935, 5713.64, 5717.411, 5721.877, 5725.427, 5729.228, 5733.61, 5736.679, 5739.493, 5741.461, 5744.55, 5745.881, 5747.013, 5748.51, 5776.178, 5812.642, 5820.116, 5882.653, 5886.336, 5889.519, 5907.264, 5920.744, 5923.13, 5925.841, 5927.271, 5929.481, 5935.074, 5945.318, 5959.748, 6016.77, 6067.107, 6087.465, 6089.051, 6090.105, 6090.806, 6091.331, 6092.204, 6092.902, 6093.271, 6093.742, 6094.029, 6120.436, 6128.122, 6146.621, 6182.182, 6195.002, 6202.565, 6209.378, 6211.585, 6223.457, 6244.003, 6270.543, 6282.003, 6364.361, 6395.508, 6401.639, 6431.781, 6450.689, 6471.928, 6489.011, 6508.049, 6521.947, 6532.426, 6534.216, 6537.256, 6541.108]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [5.425925, 53.065709, 0.0],
          [5.425873, 53.065750, 0.0],
          [5.425848, 53.065795, 0.0],
          [5.425421, 53.065938, -0.25],
          [5.425169, 53.066012, -0.25],
          [5.424938, 53.066069, -0.5],
          [5.424769, 53.066097, -0.75],
          [5.424627, 53.066089, -0.75],
          [5.424467, 53.066049, -0.75],
          [5.424296, 53.065982, -1.0],
          [5.424194, 53.065934, -1.0],
          [5.424078, 53.065868, -1.0],
          [5.423915, 53.065788, -1.25],
          [5.422495, 53.065236, -1.0],
          [5.422426, 53.065225, -1.0],
          [5.422347, 53.065221, -1.0],
          [5.422243, 53.065228, -1.0],
          [5.422000, 53.065283, -1.0],
          [5.420385, 53.065732, 0.0],
          [5.419889, 53.065854, 0.0],
          [5.419734, 53.065911, -0.25],
          [5.421343, 53.067451, -1.25],
          [5.421797, 53.067909, -1.0],
          [5.421992, 53.068125, -1.0],
          [5.422245, 53.068444, -1.0],
          [5.422586, 53.068928, -1.0],
          [5.422829, 53.069354, -1.25],
          [5.423049, 53.069827, -1.0],
          [5.423117, 53.070007, -1.0],
          [5.422962, 53.070022, -1.0],
          [5.422801, 53.069577, -1.0],
          [5.422497, 53.069033, -1.0],
          [5.422283, 53.068700, -1.0],
          [5.421779, 53.068063, -1.0],
          [5.421121, 53.067406, -1.25],
          [5.420936, 53.067192, -0.75],
          [5.420275, 53.066548, 0.75],
          [5.420048, 53.066365, 0.5],
          [5.419198, 53.065556, -0.75],
          [5.418329, 53.064560, -0.25],
          [5.418290, 53.064526, -0.25],
          [5.418226, 53.064509, -0.5],
          [5.418070, 53.064490, -0.5],
          [5.417941, 53.064422, -0.75],
          [5.417877, 53.064362, -0.75],
          [5.417834, 53.064298, -0.75],
          [5.417101, 53.064490, -1.25],
          [5.416360, 53.064672, -1.25],
          [5.415465, 53.064855, -0.5],
          [5.415215, 53.064896, -0.25],
          [5.415176, 53.064902, -0.25],
          [5.414886, 53.064941, 0.0],
          [5.414102, 53.065047, -1.0],
          [5.413717, 53.065084, -1.0],
          [5.413449, 53.065102, -1.0],
          [5.413178, 53.065112, -1.0],
          [5.412759, 53.065118, -1.5],
          [5.411536, 53.065113, -1.75],
          [5.411010, 53.065102, -1.25],
          [5.410525, 53.065069, -1.0],
          [5.407496, 53.064798, -0.75],
          [5.405922, 53.064660, -0.75],
          [5.405784, 53.064648, -1.0],
          [5.405681, 53.064654, -1.0],
          [5.405593, 53.064669, -1.0],
          [5.405425, 53.064740, -1.0],
          [5.405338, 53.064676, -1.0],
          [5.405362, 53.064648, -1.0],
          [5.405384, 53.064624, -1.0],
          [5.405526, 53.064120, -1.0],
          [5.405642, 53.063722, -1.0],
          [5.405636, 53.063641, -1.0],
          [5.405534, 53.063546, -1.0],
          [5.405459, 53.063505, -1.0],
          [5.405347, 53.063469, -1.0],
          [5.405229, 53.063451, -1.0],
          [5.404400, 53.063378, -0.75],
          [5.404341, 53.063373, -0.75],
          [5.403163, 53.063270, -0.75],
          [5.402599, 53.063220, -0.75],
          [5.402455, 53.063195, -1.0],
          [5.402280, 53.063145, -1.0],
          [5.401885, 53.063014, -1.0],
          [5.400877, 53.062686, -1.0],
          [5.400297, 53.062504, -1.0],
          [5.399779, 53.062322, -1.0],
          [5.399706, 53.062284, -1.25],
          [5.399648, 53.062236, -1.25],
          [5.399600, 53.062180, -1.25],
          [5.399588, 53.062116, -1.25],
          [5.399593, 53.062046, -1.0],
          [5.399637, 53.061975, -1.0],
          [5.399710, 53.061916, -1.0],
          [5.399792, 53.061864, -1.0],
          [5.399847, 53.061811, -1.0],
          [5.399879, 53.061755, -1.0],
          [5.399893, 53.061690, -1.0],
          [5.399898, 53.061467, -0.75],
          [5.399915, 53.061402, -0.75],
          [5.399948, 53.061348, -0.75],
          [5.400121, 53.061145, -1.0],
          [5.400213, 53.061065, -1.0],
          [5.400278, 53.061030, -1.0],
          [5.400462, 53.060962, -1.0],
          [5.400537, 53.060914, -1.0],
          [5.400595, 53.060849, -1.0],
          [5.400616, 53.060782, -0.75],
          [5.400622, 53.060724, -0.75],
          [5.400606, 53.060667, -0.75],
          [5.400571, 53.060622, -0.75],
          [5.400521, 53.060577, -0.75],
          [5.400424, 53.060515, -0.75],
          [5.400255, 53.060446, -0.5],
          [5.399790, 53.060293, 0.0],
          [5.399640, 53.060237, 0.0],
          [5.399572, 53.060207, 0.25],
          [5.399505, 53.060167, 0.25],
          [5.399449, 53.060123, 0.5],
          [5.399412, 53.060083, 0.5],
          [5.399338, 53.060083, 0.5],
          [5.399118, 53.060051, 0.75],
          [5.398028, 53.059828, 1.25],
          [5.397277, 53.059676, 0.25],
          [5.397266, 53.059683, 0.25],
          [5.397179, 53.059748, 0.25],
          [5.397067, 53.059830, 0.25],
          [5.396954, 53.059896, 0.25],
          [5.396771, 53.059996, 0.0],
          [5.396401, 53.060179, -0.25],
          [5.396188, 53.060298, -0.5],
          [5.396029, 53.060408, -0.5],
          [5.395248, 53.061072, -0.25],
          [5.394999, 53.061317, -0.5],
          [5.394455, 53.061912, -0.5],
          [5.393871, 53.062452, -0.5],
          [5.393745, 53.062579, -0.5],
          [5.393518, 53.062853, -0.75],
          [5.393287, 53.063191, -1.5],
          [5.393014, 53.063680, -1.5],
          [5.392847, 53.064004, -1.25],
          [5.392679, 53.064403, -1.0],
          [5.392297, 53.065633, -1.0],
          [5.392100, 53.066182, -1.25],
          [5.392011, 53.066369, -1.5],
          [5.391814, 53.066784, -2.0],
          [5.390890, 53.068658, -0.5],
          [5.390600, 53.069216, 0.0],
          [5.390558, 53.069326, 0.0],
          [5.390543, 53.069394, 0.0],
          [5.390542, 53.069497, 0.0],
          [5.390556, 53.069598, 0.0],
          [5.390607, 53.069706, 0.0],
          [5.390664, 53.069782, 0.0],
          [5.390735, 53.069848, 0.0],
          [5.390983, 53.070018, 0.0],
          [5.391396, 53.070270, -0.25],
          [5.391509, 53.070383, -0.25],
          [5.391622, 53.070570, -0.25],
          [5.391811, 53.070969, 0.0],
          [5.391983, 53.071448, -0.5],
          [5.392105, 53.071978, -1.0],
          [5.392117, 53.072121, -1.0],
          [5.392092, 53.072263, -1.0],
          [5.391502, 53.073715, -2.75],
          [5.391253, 53.074237, -2.75],
          [5.391052, 53.074588, -2.0],
          [5.390327, 53.075329, 0.0],
          [5.390270, 53.075390, 0.0],
          [5.390158, 53.075638, 0.0],
          [5.390074, 53.076626, -2.75],
          [5.389986, 53.076855, -2.75],
          [5.389338, 53.077919, -2.25],
          [5.388915, 53.078557, -3.25],
          [5.388445, 53.079100, -3.75],
          [5.387752, 53.079765, -1.75],
          [5.387059, 53.080520, -0.25],
          [5.386747, 53.080853, 0.0],
          [5.386058, 53.081631, -0.75],
          [5.385303, 53.082585, -2.0],
          [5.384589, 53.083507, -2.0],
          [5.384240, 53.083900, -2.0],
          [5.383770, 53.084410, -2.25],
          [5.383420, 53.084890, -2.75],
          [5.383129, 53.085338, -2.0],
          [5.382937, 53.085719, -1.5],
          [5.382010, 53.087560, -2.0],
          [5.381310, 53.089045, -1.5],
          [5.379957, 53.091757, -1.5],
          [5.379947, 53.091900, -1.5],
          [5.379988, 53.092035, -1.5],
          [5.380116, 53.092278, -1.5],
          [5.380353, 53.092630, -1.5],
          [5.380449, 53.092756, -1.5],
          [5.380627, 53.092953, -1.5],
          [5.380801, 53.093100, -1.5],
          [5.380975, 53.093199, 0.0],
          [5.381109, 53.093263, -0.25],
          [5.381239, 53.093308, -0.25],
          [5.381439, 53.093365, -0.25],
          [5.381670, 53.093397, -0.75],
          [5.381718, 53.093401, -0.75],
          [5.382302, 53.093449, -0.75],
          [5.382507, 53.093492, -0.75],
          [5.382753, 53.093578, -1.0],
          [5.382958, 53.093680, -1.0],
          [5.383085, 53.093772, -1.0],
          [5.383211, 53.093895, -1.0],
          [5.383290, 53.093998, -1.0],
          [5.383347, 53.094121, -1.0],
          [5.383375, 53.094240, -0.75],
          [5.383380, 53.094523, 0.0],
          [5.383363, 53.095227, 0.75],
          [5.383358, 53.096234, 0.5],
          [5.383360, 53.096559, 0.0],
          [5.383340, 53.098597, 1.0],
          [5.383357, 53.098744, 1.0],
          [5.383400, 53.098912, 1.0],
          [5.383441, 53.099022, 1.0],
          [5.383548, 53.099215, 1.0],
          [5.383611, 53.099308, 1.0],
          [5.384559, 53.100390, 0.5],
          [5.384641, 53.100500, 0.75],
          [5.384706, 53.100605, 1.0],
          [5.384741, 53.100694, 1.25],
          [5.384767, 53.100792, 1.5],
          [5.384768, 53.100890, 1.5],
          [5.384750, 53.100987, 1.5],
          [5.384711, 53.101080, 1.5],
          [5.384616, 53.101205, 1.5],
          [5.384423, 53.101352, 1.25],
          [5.383871, 53.101717, 1.25],
          [5.383566, 53.101929, 1.25],
          [5.383091, 53.102255, 1.25],
          [5.383053, 53.102235, 1.25],
          [5.383091, 53.102255],
          [5.382917, 53.102375],
          [5.382857, 53.102427],
          [5.382817, 53.102474],
          [5.382743, 53.102585],
          [5.382730, 53.102623],
          [5.382712, 53.102758],
          [5.382734, 53.102930],
          [5.382780, 53.103023],
          [5.382870, 53.103120],
          [5.385028, 53.105222],
          [5.385343, 53.105516],
          [5.386332, 53.106351],
          [5.387942, 53.107691],
          [5.389808, 53.109244],
          [5.390234, 53.109585, -0.75],
          [5.390364, 53.109694, -0.75],
          [5.391230, 53.110420, -0.5],
          [5.392145, 53.111202, -0.5],
          [5.392215, 53.111274, -0.5],
          [5.392457, 53.111575, -0.5],
          [5.392640, 53.111810, -0.5],
          [5.392761, 53.111947, -0.5],
          [5.392960, 53.112112, -0.5],
          [5.393400, 53.112390, -0.5],
          [5.393510, 53.112480, -0.5],
          [5.393670, 53.112570, -0.5],
          [5.393783, 53.112681, -0.5],
          [5.393880, 53.112735, -0.5],
          [5.395789, 53.113801, -0.5],
          [5.396844, 53.114461, -0.5],
          [5.397488, 53.114818, -0.5],
          [5.399091, 53.115709],
          [5.400062, 53.116264],
          [5.400639, 53.116646],
          [5.401055, 53.116990],
          [5.403262, 53.119541],
          [5.404792, 53.121358],
          [5.404897, 53.121483],
          [5.405601, 53.123429],
          [5.406229, 53.125441],
          [5.406460, 53.126152],
          [5.406588, 53.126500],
          [5.406749, 53.126809],
          [5.407505, 53.128057],
          [5.407990, 53.128845],
          [5.408499, 53.130697],
          [5.409084, 53.132845],
          [5.409666, 53.134985],
          [5.410123, 53.136720],
          [5.410232, 53.137158],
          [5.410814, 53.141366],
          [5.411058, 53.142976],
          [5.411399, 53.146567],
          [5.411628, 53.148641],
          [5.411677, 53.148864],
          [5.411870, 53.150293],
          [5.412572, 53.154546],
          [5.412836, 53.156109],
          [5.412942, 53.156444],
          [5.415058, 53.160609],
          [5.415744, 53.162039],
          [5.415782, 53.162275],
          [5.415785, 53.162288],
          [5.416510, 53.165827],
          [5.416530, 53.166296],
          [5.416466, 53.166747],
          [5.416129, 53.168171],
          [5.416004, 53.168703],
          [5.415925, 53.168914],
          [5.415736, 53.169375, 0.0],
          [5.415727, 53.169398, 0.0],
          [5.415715, 53.169426, 0.0],
          [5.415541, 53.169624, 0.0],
          [5.415211, 53.169983, 0.0],
          [5.415010, 53.170021, 0.0],
          [5.414759, 53.170374, -0.25],
          [5.414609, 53.170566, -0.25],
          [5.414426, 53.170660, -0.5],
          [5.413677, 53.170931, -1.0],
          [5.413274, 53.171055, -0.75],
          [5.413249, 53.171111, -0.5],
          [5.413263, 53.171151, -0.25],
          [5.413325, 53.171180, -0.25],
          [5.413337, 53.171179, -0.25],
          [5.413463, 53.171179, -0.25],
          [5.413938, 53.171095, 0.0],
          [5.414344, 53.170987, -0.25],
          [5.414563, 53.170919, -0.25],
          [5.414845, 53.170801, 0.0],
          [5.415013, 53.170726, 0.0],
          [5.415202, 53.170616, 0.0],
          [5.415331, 53.170569, 0.25],
          [5.415495, 53.170543, 0.25],
          [5.415521, 53.170540, 0.25],
          [5.415602, 53.170532, 0.25],
          [5.415720, 53.170530, 0.5],
          [5.415785, 53.170733, 0.75],
          [5.415854, 53.170909, 1.0],
          [5.415893, 53.170947, 1.0],
          [5.415941, 53.170964, 1.25],
          [5.415986, 53.170997, 1.25],
          [5.416198, 53.170972, 1.5],
          [5.416421, 53.170955, 1.75],
          [5.416675, 53.170950, 2.0],
          [5.417488, 53.170967, 2.0],
          [5.418586, 53.170966, 2.75],
          [5.418593, 53.171029, 2.75],
          [5.418602, 53.171125, 2.5],
          [5.418666, 53.171574, 2.0],
          [5.418712, 53.171711, 2.0],
          [5.418747, 53.171805, 2.0],
          [5.418773, 53.171871, 2.0],
          [5.418782, 53.171948, 2.0],
          [5.418819, 53.172119, 2.0],
          [5.418818, 53.172199, 2.0],
          [5.419037, 53.172277, 2.0],
          [5.419285, 53.173219, 3.5],
          [5.419333, 53.173307, 3.5],
          [5.419438, 53.173478, 3.5],
          [5.419439, 53.173788, 3.75],
          [5.419523, 53.173803, 3.75],
          [5.419569, 53.173847, 3.75],
          [5.419590, 53.173913, 3.75],
          [5.419734, 53.174575, 4.0],
          [5.419786, 53.174697, 4.0],
          [5.420009, 53.175524, 2.0],
          [5.420044, 53.175658, 1.5],
          [5.420063, 53.175765, 1.0],
          [5.420069, 53.175802, 1.0],
          [5.420087, 53.176099, 1.0],
          [5.420033, 53.176496, 1.0],
          [5.418535, 53.176423, 1.5],
          [5.418490, 53.176762, 1.5],
          [5.418483, 53.176807, 1.5],
          [5.418479, 53.176847, 1.5],
          [5.418472, 53.176889, 1.5],
          [5.418412, 53.177291, 1.5],
          [5.418438, 53.177388, 1.5],
          [5.418515, 53.177552, 1.5],
          [5.418574, 53.177656, 1.5],
          [5.418657, 53.177762, 1.5],
          [5.418834, 53.177892, 1.5],
          [5.419025, 53.177992, 1.5],
          [5.419382, 53.178145, 1.5],
          [5.419563, 53.178229, 1.5],
          [5.419684, 53.178309, 1.5],
          [5.419762, 53.178388, 2.25],
          [5.419805, 53.178456, 2.25],
          [5.419828, 53.178532, 2.25],
          [5.419818, 53.178586, 2.0],
          [5.419790, 53.178642, 2.0],
          [5.419729, 53.178707, 1.75],
          [5.419716, 53.178742, 1.75],
          [5.419671, 53.178841, 1.5],
          [5.419509, 53.179135, 1.5],
          [5.419446, 53.179268, 1.5],
          [5.419439, 53.179363, 1.75],
          [5.419476, 53.179463, 1.75],
          [5.419543, 53.179546, 1.75],
          [5.419437, 53.179576, 1.75],
          [5.419360, 53.179573, 1.75],
          [5.419311, 53.179571, 1.75],
          [5.419248, 53.179573, 1.75],
          [5.419185, 53.179579, 1.75],
          [5.419185, 53.179534, 1.75],
          [5.419202, 53.179474, 1.75],
          [5.419299, 53.179261, 1.75],
          [5.419381, 53.179120, 1.5],
          [5.419436, 53.179021, 1.5],
          [5.419381, 53.179120, 1.5],
          [5.419299, 53.179261, 1.75],
          [5.419202, 53.179474, 1.75],
          [5.419185, 53.179534, 1.75],
          [5.419185, 53.179579, 1.75],
          [5.419248, 53.179573, 1.75],
          [5.419311, 53.179571, 1.75],
          [5.419360, 53.179573, 1.75],
          [5.419437, 53.179576, 1.75],
          [5.419543, 53.179546, 1.75],
          [5.419585, 53.179589, 2.0],
          [5.419638, 53.179626, 2.0],
          [5.419756, 53.179673, 2.0],
          [5.419867, 53.179705, 2.0],
          [5.422275, 53.180041, -0.5],
          [5.424303, 53.180373, 0.0],
          [5.424943, 53.180487, 0.5],
          [5.428263, 53.181096, -1.5],
          [5.428483, 53.181132, -1.5],
          [5.428763, 53.181177, -1.5],
          [5.429186, 53.181231, -1.5],
          [5.429732, 53.181271, -1.75],
          [5.430197, 53.181285, -2.0],
          [5.431215, 53.181314, -1.75],
          [5.431580, 53.181304, -1.75],
          [5.431764, 53.181303, -1.75],
          [5.431956, 53.181313, -1.5],
          [5.432815, 53.181428, 0.0],
          [5.433034, 53.181470, 0.0],
          [5.433503, 53.181607, 0.75],
          [5.433861, 53.181699, 1.0],
          [5.434063, 53.181743, 1.0],
          [5.434500, 53.181820, 0.5],
          [5.434704, 53.181848, 0.5],
          [5.435142, 53.181890, 0.25],
          [5.435531, 53.181910, 0.25],
          [5.436917, 53.181920, -0.25],
          [5.438769, 53.181932, 0.5],
          [5.438771, 53.182002, 0.5],
          [5.439059, 53.182008, 0.5],
          [5.439076, 53.182117, 0.25],
          [5.439059, 53.182008, 0.5],
          [5.438771, 53.182002, 0.5],
          [5.438772, 53.182079, 0.5],
          [5.438806, 53.182155, 0.25],
          [5.438875, 53.182219, 0.25],
          [5.438951, 53.182265, 0.25],
          [5.438987, 53.182322, 0.0],
          [5.439266, 53.183997, -1.75],
          [5.439289, 53.184138, -2.0],
          [5.439279, 53.184183, -2.0],
          [5.439103, 53.184533, -1.25],
          [5.439103, 53.184613, -1.25],
          [5.439155, 53.184812, -1.0],
          [5.439225, 53.185017, -1.0],
          [5.439267, 53.185167, -1.0],
          [5.439317, 53.185316, -1.0],
          [5.439342, 53.185365, -1.0],
          [5.439377, 53.185407, -1.25],
          [5.439612, 53.185589, -1.5],
          [5.439680, 53.185679, -1.5],
          [5.439726, 53.185764, -1.5],
          [5.440257, 53.187170, -2.0],
          [5.440766, 53.188570, -1.5],
          [5.440870, 53.188912, -1.25],
          [5.441005, 53.189408, -0.5],
          [5.441113, 53.189865, 0.0],
          [5.441124, 53.190008, 0.25],
          [5.441423, 53.190943, -0.75],
          [5.441534, 53.191270, -0.5],
          [5.441837, 53.191881, -0.25],
          [5.441903, 53.192071, -0.5],
          [5.442195, 53.193303, -1.0],
          [5.442571, 53.194801, -0.5],
          [5.442555, 53.194916, -0.25],
          [5.442560, 53.194964, 0.0],
          [5.442588, 53.195017, 0.0],
          [5.442362, 53.195113, 0.0],
          [5.434596, 53.198422, -1.25],
          [5.434702, 53.198761, -0.5],
          [5.434746, 53.198901, -0.5],
          [5.434904, 53.199138, 0.0],
          [5.436220, 53.200290, -1.25],
          [5.437710, 53.201529, -1.75],
          [5.438400, 53.202140, -0.75],
          [5.439320, 53.202970, -0.25],
          [5.440000, 53.203720, -1.25],
          [5.440819, 53.204725, -0.25],
          [5.441137, 53.205055, 0.0],
          [5.441546, 53.205382, -0.75],
          [5.441729, 53.205509, -1.0],
          [5.442023, 53.205656, -1.0],
          [5.444260, 53.206610, 0.0],
          [5.444607, 53.206809, 0.0],
          [5.444438, 53.206890, 0.0],
          [5.444296, 53.206969, -0.25],
          [5.444183, 53.207046, -0.25],
          [5.443968, 53.207236, -0.5],
          [5.443873, 53.207300, -0.75],
          [5.443752, 53.207365, -0.75],
          [5.438812, 53.209288, -0.75],
          [5.439045, 53.209529, -0.75],
          [5.439868, 53.210371, -0.75],
          [5.441241, 53.211799, -0.75],
          [5.442526, 53.212959, -0.75],
          [5.443286, 53.213622, -0.75],
          [5.443720, 53.213987, -0.75],
          [5.444342, 53.214590, -0.75],
          [5.444353, 53.214604, -0.75],
          [5.445417, 53.215868],
          [5.445737, 53.216224],
          [5.446544, 53.217177],
          [5.446909, 53.217557],
          [5.447543, 53.218154, 0.25],
          [5.448559, 53.219054, 2.25],
          [5.449153, 53.219509, 2.25],
          [5.449559, 53.219793, 2.25],
          [5.453004, 53.221911, 2.25],
          [5.453342, 53.222103, 2.25],
          [5.454216, 53.222512, 2.25],
          [5.456560, 53.223530, 2.25],
          [5.458152, 53.224231, 2.25],
          [5.459343, 53.224728, 2.25],
          [5.460609, 53.225217, 2.25],
          [5.462717, 53.226034, 0.0],
          [5.462981, 53.226173, -0.25],
          [5.464020, 53.226870, -0.25],
          [5.464902, 53.227444, -0.25],
          [5.465377, 53.227779, -0.25],
          [5.469120, 53.230330, -0.25],
          [5.471533, 53.231980, -0.25],
          [5.471746, 53.232125, -0.25],
          [5.472060, 53.232390, -0.25],
          [5.472380, 53.232740, -0.25],
          [5.472860, 53.233330, -0.25],
          [5.473345, 53.233737, -0.25],
          [5.473739, 53.233965, -0.25],
          [5.474154, 53.234175, -0.25],
          [5.479870, 53.236800, -0.25],
          [5.480550, 53.237170, -0.25],
          [5.481106, 53.237540, -0.25],
          [5.481551, 53.237891, -0.25],
          [5.481966, 53.238314, -0.25],
          [5.482136, 53.238526, -0.25],
          [5.482436, 53.238878, -0.25],
          [5.482786, 53.239206, -0.25],
          [5.483244, 53.239558, -0.25],
          [5.483642, 53.239807, 0.0],
          [5.484256, 53.240110, 0.0],
          [5.484721, 53.240303, 0.0],
          [5.485008, 53.240396, -1.0],
          [5.485836, 53.240631, -0.25],
          [5.488382, 53.240996, -0.25],
          [5.488692, 53.241035, -0.25],
          [5.489340, 53.241159, -0.25],
          [5.490001, 53.241331, -0.75],
          [5.490457, 53.241479, -0.25],
          [5.490608, 53.241566, 0.0],
          [5.491225, 53.241876, 0.0],
          [5.493542, 53.242962, -0.5],
          [5.493729, 53.243074, -0.5],
          [5.493900, 53.243188, -0.5],
          [5.494246, 53.243454, -0.5],
          [5.494453, 53.243596, -0.5],
          [5.494656, 53.243721, -0.5],
          [5.495003, 53.243895, -0.5],
          [5.499019, 53.245504, -0.5],
          [5.500347, 53.246043, -0.5],
          [5.500558, 53.246116, -0.5],
          [5.500777, 53.246161, -0.5],
          [5.501434, 53.246288, -0.5],
          [5.501535, 53.246314, -0.5],
          [5.501761, 53.246381, -0.25],
          [5.502182, 53.246528, 0.0],
          [5.502532, 53.246672, 0.0],
          [5.502947, 53.246858, 0.0],
          [5.503382, 53.247074, 0.0],
          [5.503540, 53.247152, 0.0],
          [5.503848, 53.247322, -0.25],
          [5.504465, 53.247641, -0.25],
          [5.504865, 53.247858, -0.25],
          [5.505382, 53.248113, -0.25],
          [5.506001, 53.248394, -0.25],
          [5.506610, 53.248640, -0.25],
          [5.506870, 53.248738, -0.25],
          [5.507400, 53.248920, -0.25],
          [5.508068, 53.249131, 0.0],
          [5.508684, 53.249316, 0.0],
          [5.510451, 53.249844, -0.5],
          [5.512470, 53.250456, -0.75],
          [5.514527, 53.251076, -0.75],
          [5.515120, 53.251236, -1.5],
          [5.515581, 53.251390, -1.25],
          [5.515759, 53.251449, -1.25],
          [5.515908, 53.251507, -1.25],
          [5.516010, 53.251557, -1.25],
          [5.516108, 53.251612, -1.25],
          [5.516314, 53.251758, -1.25],
          [5.516405, 53.251833, -1.25],
          [5.516505, 53.251938, -1.25],
          [5.516574, 53.252030, -1.25],
          [5.516788, 53.252405, -0.25],
          [5.516895, 53.252558, -0.25],
          [5.517000, 53.252670, -0.25],
          [5.517146, 53.252807, -0.25],
          [5.517315, 53.252937, -0.25],
          [5.517457, 53.253028, -0.25],
          [5.517641, 53.253126, -0.25],
          [5.517812, 53.253207, -0.25],
          [5.518209, 53.253356, -0.25],
          [5.518449, 53.253410, -0.25],
          [5.521259, 53.254159, 0.0],
          [5.522995, 53.254670, 0.0],
          [5.523999, 53.254973, -0.75],
          [5.524219, 53.255034, -0.75],
          [5.524888, 53.255246, -0.75],
          [5.525093, 53.255336, -0.75],
          [5.525325, 53.255452, -0.75],
          [5.527797, 53.256772, -0.75],
          [5.527880, 53.256807, -0.75],
          [5.527952, 53.256827, -0.75],
          [5.527986, 53.256870, -0.75],
          [5.528030, 53.256905, -0.75],
          [5.528145, 53.256974, -0.75],
          [5.528775, 53.257355, -0.75],
          [5.530002, 53.258080, -0.75],
          [5.530825, 53.258589, -0.75],
          [5.531038, 53.258741, -0.75],
          [5.531288, 53.258847, -0.75],
          [5.531855, 53.259180, -0.75],
          [5.532081, 53.259320, -0.75],
          [5.532299, 53.259439, -0.75],
          [5.532416, 53.259496, -0.75],
          [5.532558, 53.259537, -0.75],
          [5.533914, 53.259823, -0.25],
          [5.534265, 53.259899, -0.25],
          [5.536058, 53.260262, -0.5],
          [5.542824, 53.261581, 0.0],
          [5.543177, 53.261659, 0.0],
          [5.543861, 53.261825, 0.0],
          [5.544402, 53.261935, -0.5],
          [5.544543, 53.261967, -0.75],
          [5.544657, 53.262006, -0.75],
          [5.544767, 53.262053, -1.0],
          [5.544734, 53.262167, -1.25],
          [5.544730, 53.262183, -1.25],
          [5.544722, 53.262218, -1.25],
          [5.544599, 53.263011, -0.75],
          [5.544609, 53.264139, -0.75],
          [5.544624, 53.264346, -1.0],
          [5.544649, 53.264554, -1.0],
          [5.544700, 53.264802, -1.0],
          [5.544744, 53.264993, -1.0],
          [5.544803, 53.265182, -0.75],
          [5.544876, 53.265387, -0.5],
          [5.544950, 53.265518, -0.25],
          [5.545026, 53.265628, 0.0],
          [5.545090, 53.265703, 0.0],
          [5.545209, 53.265825, 0.0],
          [5.545267, 53.265872, 0.0],
          [5.545326, 53.265912, 0.0],
          [5.545414, 53.265959, 0.0],
          [5.547561, 53.266986, -1.25],
          [5.550099, 53.268141, -1.0],
          [5.550588, 53.268372, -0.75],
          [5.555050, 53.270400, -1.0],
          [5.555320, 53.270510, -1.0],
          [5.555535, 53.270621, -1.0],
          [5.556699, 53.271139, -0.5],
          [5.557548, 53.271505, 0.0],
          [5.557699, 53.271577, 0.0],
          [5.557876, 53.271642, 0.25],
          [5.557954, 53.271670, 0.5],
          [5.558099, 53.271712, 0.5],
          [5.558454, 53.271818, 0.75],
          [5.559166, 53.272081, 0.5],
          [5.560290, 53.272526, 0.0],
          [5.564634, 53.274143, 0.0],
          [5.568121, 53.275442, 1.0],
          [5.569823, 53.276087, 0.25],
          [5.569936, 53.276113, 0.5],
          [5.570015, 53.276111, 0.5],
          [5.570060, 53.276118, 0.5],
          [5.570091, 53.276135, 0.5],
          [5.570114, 53.276171, 0.5],
          [5.570150, 53.276194, 0.5],
          [5.570114, 53.276171, 0.5],
          [5.570091, 53.276135, 0.5],
          [5.570060, 53.276118, 0.5],
          [5.571970, 53.274290, -1.75],
          [5.572303, 53.273923, -1.5],
          [5.572984, 53.273063, -1.25],
          [5.574073, 53.271620, 0.0],
          [5.574520, 53.270980, -0.25],
          [5.574605, 53.270552, -0.5],
          [5.575189, 53.270579, -0.25],
          [5.575379, 53.270593, -0.25],
          [5.577100, 53.270720, -0.25],
          [5.579182, 53.270889, -0.75],
          [5.581470, 53.271050, -0.5],
          [5.582472, 53.271130, -0.5],
          [5.589890, 53.271688, -1.0],
          [5.592762, 53.271895, -1.25],
          [5.593366, 53.271944, -1.75],
          [5.595443, 53.272080, 0.0],
          [5.597139, 53.272204, -0.25],
          [5.599188, 53.272353, -0.75],
          [5.600583, 53.272436, -0.25],
          [5.601866, 53.272546, 1.0],
          [5.602740, 53.272602, 2.0],
          [5.603371, 53.272639, 2.75],
          [5.603488, 53.272649, 2.75],
          [5.603684, 53.272690, 2.75],
          [5.603653, 53.272876, 2.25]
        ]
      }
    }
  ]
}

let day15: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "15 - St.-Jacobiparochie - Vierhuizen - 57.3km",
        "track-length": "57294",
        "filtered ascend": "19",
        "plain-ascend": "10",
        "total-time": "12379",
        "total-energy": "890155",
        "cost": "85792",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["5603684", "53272690", "2", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1", "131"],
          ["5606970", "53272906", "1", "224", "1000", "0", "0", "0", "0", "highway=primary cycleway=lane route_bicycle_rcn=yes", "", "27", "2775"],
          ["5607959", "53272969", "0", "69", "1000", "0", "0", "0", "0", "highway=primary cycleway=lane oneway=yes route_bicycle_rcn=yes", "", "37", "3701"],
          ["5613212", "53273428", "0", "376", "1000", "0", "0", "0", "0", "highway=cycleway surface=paved foot=designated bicycle=designated oneway=yes route_bicycle_rcn=yes", "", "97", "9711"],
          ["5648061", "53275966", "0", "2362", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "494", "49408"],
          ["5652868", "53276194", "1", "336", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "558", "55811"],
          ["5657061", "53276469", "1", "284", "1000", "0", "0", "0", "0", "highway=primary route_bicycle_rcn=yes", "", "603", "60326"],
          ["5657123", "53276603", "1", "10", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "605", "60509"],
          ["5657061", "53276469", "1", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "", "606", "60603"],
          ["5657492", "53274550", "1", "205", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary route_bicycle_rcn=yes", "", "632", "63207"],
          ["5663741", "53276995", "2", "660", "1000", "0", "0", "0", "0", "highway=primary route_bicycle_rcn=yes", "", "728", "72894"],
          ["5669963", "53277538", "0", "437", "1000", "0", "0", "0", "0", "highway=cycleway oneway=yes route_bicycle_rcn=yes", "", "794", "79459"],
          ["5675788", "53278043", "0", "397", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway oneway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "861", "86160"],
          ["5675871", "53278049", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "862", "86262"],
          ["5696204", "53279387", "0", "1372", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_rcn=yes", "", "1091", "109168"],
          ["5696296", "53279304", "0", "12", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_rcn=yes", "", "1094", "109408"],
          ["5696717", "53279327", "1", "29", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt foot=use_sidepath oneway=yes smoothness=excellent route_bicycle_rcn=yes", "", "1100", "110057"],
          ["5697098", "53279270", "1", "33", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt foot=yes junction=roundabout smoothness=excellent route_bicycle_rcn=yes", "", "1107", "110742"],
          ["5700188", "53279537", "0", "211", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "1142", "114248"],
          ["5701886", "53279706", "0", "117", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=intermediate route_bicycle_rcn=yes", "", "1161", "116114"],
          ["5705568", "53279985", "0", "252", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1204", "120427"],
          ["5706259", "53280031", "0", "48", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=yes smoothness=good route_bicycle_rcn=yes", "", "1212", "121241"],
          ["5706525", "53280048", "0", "18", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=choker", "1215", "121590"],
          ["5706927", "53280077", "0", "28", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1221", "122117"],
          ["5706935", "53280034", "0", "5", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1222", "122209"],
          ["5712225", "53280384", "-1", "360", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones oneway=yes smoothness=good route_bicycle_rcn=yes", "", "1277", "127759"],
          ["5714867", "53280582", "-1", "183", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_rcn=yes", "", "1307", "130777"],
          ["5714923", "53280667", "-1", "12", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_rcn=yes", "", "1309", "130962"],
          ["5717138", "53280733", "-1", "153", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unknown", "1333", "133346"],
          ["5717152", "53280771", "-1", "5", "1350", "0", "79", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=yes oneway:bicycle=no smoothness=good", "highway=give_way direction=forward", "1334", "133433"],
          ["5720227", "53280739", "0", "216", "1350", "0", "24", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt oneway=yes oneway:bicycle=no smoothness=good", "", "1377", "137750"],
          ["5722052", "53280359", "0", "132", "1350", "0", "3", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "", "1399", "139964"],
          ["5723615", "53283259", "0", "342", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=forward", "1455", "145557"],
          ["5723625", "53283278", "0", "3", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "1456", "145611"],
          ["5727099", "53287734", "0", "554", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_rcn=yes", "", "1540", "154055"],
          ["5730025", "53287692", "-1", "199", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1569", "157007"],
          ["5735438", "53287984", "-1", "367", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1628", "162887"],
          ["5735747", "53288047", "-1", "22", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1633", "163315"],
          ["5746826", "53288052", "-1", "743", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1759", "175940"],
          ["5747674", "53294095", "-1", "680", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1866", "186685"],
          ["5758628", "53305794", "-2", "1572", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "2127", "212759"],
          ["5759844", "53305910", "-1", "84", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2141", "214176"],
          ["5762039", "53306699", "-1", "176", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2174", "217430"],
          ["5761558", "53307319", "-1", "80", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2187", "218743"],
          ["5769125", "53314992", "-1", "1022", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2361", "236129"],
          ["5779234", "53320930", "-1", "974", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2526", "252697"],
          ["5796264", "53322713", "-2", "1169", "1450", "0", "5", "0", "0", "highway=tertiary", "", "2711", "271177"],
          ["5796824", "53322548", "-2", "43", "1450", "0", "1", "0", "0", "highway=tertiary foot=use_sidepath bicycle=use_sidepath", "", "2718", "271843"],
          ["5796906", "53322520", "-2", "7", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary foot=use_sidepath bicycle=use_sidepath", "highway=give_way direction=backward", "2719", "271961"],
          ["5796923", "53322514", "-2", "2", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary foot=use_sidepath bicycle=use_sidepath", "highway=crossing crossing=unknown", "2719", "271994"],
          ["5796948", "53322509", "-2", "2", "1450", "0", "2", "0", "0", "highway=tertiary surface=asphalt smoothness=excellent", "highway=give_way direction=backward", "2720", "272028"],
          ["5797202", "53322478", "-2", "18", "1450", "0", "2", "0", "0", "highway=tertiary surface=asphalt smoothness=excellent", "", "2723", "272342"],
          ["5799036", "53322532", "0", "124", "1450", "0", "3", "0", "0", "highway=tertiary", "", "2760", "276115"],
          ["5798987", "53322481", "0", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "", "2762", "276251"],
          ["5800073", "53322318", "1", "41", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "2772", "277227"],
          ["5798987", "53322481", "0", "41", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "2775", "277588"],
          ["5803032", "53326029", "0", "510", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "2850", "285061"],
          ["5801794", "53326592", "0", "110", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "2862", "286284"],
          ["5801237", "53327110", "0", "73", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "2872", "287264"],
          ["5801313", "53327283", "0", "24", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "2876", "287623"],
          ["5804032", "53329430", "-1", "314", "1350", "0", "13", "0", "0", "highway=unclassified surface=asphalt smoothness=intermediate", "highway=give_way direction=forward", "2914", "291520"],
          ["5804080", "53329454", "-1", "5", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=intermediate", "", "2915", "291612"],
          ["5804139", "53329505", "-1", "7", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=intermediate route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=backward", "2917", "291739"],
          ["5805035", "53330585", "-1", "144", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=intermediate route_bicycle_rcn=yes", "", "2941", "294186"],
          ["5806430", "53331319", "-1", "124", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=excellent route_bicycle_rcn=yes", "", "2963", "296364"],
          ["5806366", "53331396", "-1", "11", "1050", "0", "93", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=good", "", "2964", "296519"],
          ["5803349", "53335705", "-2", "526", "1350", "0", "23", "0", "0", "highway=unclassified surface=asphalt smoothness=intermediate", "", "3033", "303383"],
          ["5801611", "53340342", "-1", "587", "1350", "0", "21", "0", "0", "highway=unclassified surface=asphalt smoothness=good", "", "3133", "313421"],
          ["5796557", "53343175", "0", "466", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3215", "321617"],
          ["5815154", "53351669", "0", "1580", "1350", "0", "91", "0", "0", "highway=unclassified surface=asphalt", "", "3473", "347393"],
          ["5815348", "53351474", "0", "8", "1350", "0", "95", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt", "", "3474", "347519"],
          ["5815307", "53351730", "0", "21", "1350", "0", "85", "0", "0", "highway=unclassified surface=asphalt", "", "3476", "347720"],
          ["5814642", "53351778", "0", "52", "1350", "0", "124", "0", "0", "highway=service", "barrier=cattle_grid foot=yes", "3482", "348290"],
          ["5811613", "53351075", "0", "221", "1350", "0", "3", "0", "0", "highway=service", "barrier=cattle_grid foot=yes", "3515", "351576"],
          ["5811228", "53351025", "0", "27", "1350", "0", "0", "0", "0", "highway=service", "", "3519", "351991"],
          ["5844356", "53361364", "1", "2533", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "3941", "394187"],
          ["5855906", "53364644", "0", "864", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4086", "408721"],
          ["5888153", "53378889", "0", "3249", "1000", "0", "0", "0", "0", "highway=unclassified access=no bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4614", "461429"],
          ["5888268", "53378886", "0", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4615", "461554"],
          ["5888296", "53379016", "0", "4", "1050", "0", "82", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt", "", "4615", "461617"],
          ["5888268", "53378886", "0", "4", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt", "", "4616", "461654"],
          ["5889893", "53377677", "-1", "189", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4636", "463712"],
          ["5890298", "53377445", "-1", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4637", "463821"],
          ["5889893", "53377677", "-1", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4638", "463895"],
          ["5889677", "53378393", "0", "85", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate access=no foot=yes bicycle=yes", "4649", "465000"],
          ["5892703", "53380139", "0", "305", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "4700", "470115"],
          ["5894243", "53380535", "0", "114", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_rcn=yes", "", "4719", "471949"],
          ["5896671", "53381130", "0", "177", "1050", "0", "11", "0", "0", "highway=cycleway surface=asphalt", "", "4748", "474887"],
          ["5968678", "53394270", "-8192", "5053", "5050", "0", "11", "0", "0", "highway=path surface=grass", "", "8338", "515887"],
          ["5968566", "53394020", "0", "29", "5050", "0", "100", "0", "0", "reversedirection=yes highway=footway", "", "8359", "516156"],
          ["5969586", "53393432", "0", "102", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "8377", "517940"],
          ["5972946", "53392182", "0", "298", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "8427", "522984"],
          ["5973210", "53392219", "0", "19", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "8429", "523186"],
          ["5985758", "53395751", "0", "933", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "8570", "537320"],
          ["5998875", "53398865", "0", "950", "1000", "0", "0", "0", "0", "highway=unclassified access=destination foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "8726", "552859"],
          ["6013534", "53401791", "-1", "1042", "1000", "0", "0", "0", "0", "highway=unclassified access=destination foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "8895", "569807"],
          ["6013826", "53401660", "0", "34", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8903", "570606"],
          ["6016805", "53402304", "0", "224", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8936", "573902"],
          ["6023307", "53400925", "0", "478", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9011", "581383"],
          ["6023701", "53401035", "0", "32", "1050", "0", "81", "0", "0", "highway=unclassified foot=yes bicycle=yes", "barrier=gate foot=yes bicycle=yes", "9017", "581947"],
          ["6027189", "53401483", "0", "238", "1050", "0", "0", "0", "0", "highway=unclassified access=destination foot=yes bicycle=yes", "barrier=cattle_grid", "9062", "586471"],
          ["6069677", "53406696", "0", "2892", "1050", "0", "1", "0", "0", "highway=unclassified access=destination foot=yes bicycle=yes", "", "9545", "634817"],
          ["6071001", "53406275", "-8192", "105", "1350", "0", "24", "0", "0", "reversedirection=yes highway=unclassified", "", "9560", "636300"],
          ["6077265", "53404796", "0", "455", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9633", "643636"],
          ["6077747", "53404790", "0", "35", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=swing_gate foot=yes bicycle=yes", "9639", "644229"],
          ["6083880", "53402839", "0", "498", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9723", "652614"],
          ["6088642", "53401887", "0", "345", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "9785", "658747"],
          ["6090867", "53401651", "0", "151", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential access=destination foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9808", "661073"],
          ["6091286", "53401575", "0", "30", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified access=destination foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "9813", "661570"],
          ["6097658", "53400387", "0", "448", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified access=destination foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "9883", "668632"],
          ["6097837", "53400327", "0", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified access=destination foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9885", "668774"],
          ["6097816", "53400239", "-1", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9886", "668876"],
          ["6099043", "53399723", "-1", "100", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "9898", "670085"],
          ["6101834", "53398575", "-1", "226", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "9931", "673380"],
          ["6103695", "53397787", "-1", "152", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "9958", "676113"],
          ["6103760", "53397731", "-1", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9960", "676249"],
          ["6107532", "53395990", "-1", "285", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10006", "680931"],
          ["6103760", "53397731", "-1", "285", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10046", "684893"],
          ["6103695", "53397787", "-1", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "10047", "685020"],
          ["6101834", "53398575", "-1", "152", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "10070", "687312"],
          ["6099043", "53399723", "-1", "226", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "10110", "691299"],
          ["6097816", "53400239", "-1", "100", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10127", "692986"],
          ["6097837", "53400327", "0", "10", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "10129", "693166"],
          ["6099305", "53400318", "0", "99", "1350", "0", "60", "0", "0", "reversedirection=yes highway=unclassified", "", "10147", "694976"],
          ["6101060", "53400500", "0", "120", "1350", "0", "3", "0", "0", "highway=unclassified", "", "10169", "697224"],
          ["6103256", "53400322", "0", "149", "1350", "0", "4", "0", "0", "reversedirection=yes highway=unclassified", "", "10194", "699675"],
          ["6110019", "53400550", "0", "451", "1350", "0", "5", "0", "0", "highway=unclassified", "barrier=gate foot=yes bicycle=yes vehicle=private", "10261", "706423"],
          ["6134903", "53401815", "0", "1670", "1350", "0", "1", "0", "0", "highway=unclassified", "", "10546", "734936"],
          ["6136652", "53402493", "0", "140", "1050", "0", "3", "0", "0", "reversedirection=yes highway=cycleway", "barrier=gate foot=yes bicycle=yes", "10565", "736752"],
          ["6155291", "53408202", "0", "1398", "1050", "0", "2", "0", "0", "reversedirection=yes highway=cycleway", "", "10797", "759970"],
          ["6156911", "53408439", "0", "111", "1050", "0", "0", "0", "0", "highway=cycleway", "", "10815", "761835"],
          ["6158786", "53408795", "0", "132", "1350", "0", "2", "0", "0", "highway=unclassified", "", "10835", "763781"],
          ["6158969", "53408724", "0", "16", "1350", "0", "13", "0", "0", "reversedirection=yes highway=unclassified", "", "10837", "764045"],
          ["6192771", "53410128", "0", "2529", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11251", "805355"],
          ["6194338", "53409623", "2", "120", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=use_sidepath oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11282", "808524"],
          ["6194738", "53409526", "3", "31", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "11289", "809234"],
          ["6198838", "53407655", "1", "349", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11347", "815047"],
          ["6200873", "53407114", "2", "151", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11374", "817716"],
          ["6201233", "53407046", "2", "26", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11379", "818150"],
          ["6210946", "53407970", "1", "671", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11492", "829474"],
          ["6211326", "53407948", "1", "27", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "", "11496", "829880"],
          ["6225713", "53410871", "1", "1014", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=permissive smoothness=good route_bicycle_rcn=yes", "", "11664", "846665"],
          ["6225707", "53410916", "1", "6", "9050", "0", "68", "0", "0", "reversedirection=yes highway=footway surface=grass", "barrier=gate foot=yes bicycle=yes", "11668", "846720"],
          ["6225614", "53411066", "1", "18", "9050", "0", "3", "0", "0", "reversedirection=yes highway=footway surface=grass", "", "11681", "846885"],
          ["6227361", "53411408", "1", "123", "9050", "0", "93", "0", "0", "highway=footway surface=grass", "barrier=stile", "11769", "848017"],
          ["6230476", "53412034", "1", "69", "9050", "0", "0", "0", "0", "highway=footway surface=grass", "", "11818", "848656"],
          ["6227361", "53411408", "-8192", "69", "9050", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=grass", "barrier=stile", "11864", "848656"],
          ["6225614", "53411066", "-8192", "123", "9050", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=grass", "", "11948", "848656"],
          ["6225707", "53410916", "-8192", "18", "9050", "0", "93", "0", "0", "highway=footway surface=grass", "barrier=gate foot=yes bicycle=yes", "11961", "848798"],
          ["6225713", "53410871", "-8192", "6", "9050", "0", "3", "0", "0", "highway=footway surface=grass", "", "11965", "848846"],
          ["6235063", "53412732", "-8192", "655", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=permissive smoothness=good route_bicycle_rcn=yes", "", "12075", "859796"],
          ["6235355", "53412789", "-8192", "21", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=permissive foot=permissive bicycle=permissive smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate access=permissive foot=permissive bicycle=permissive motor_vehicle=destination", "12078", "860147"],
          ["6253962", "53414738", "0", "1276", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=permissive foot=permissive bicycle=permissive smoothness=good route_bicycle_rcn=yes", "", "12292", "881528"],
          ["6258790", "53413580", "0", "374", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes smoothness=intermediate route_bicycle_rcn=yes", "", "12352", "887498"],
          ["6259005", "53413458", "0", "20", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=block foot=yes bicycle=yes", "12355", "887834"],
          ["6260178", "53412256", "0", "139", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "12379", "890171"]
        ],
        "times": [0, 1.32, 2.921, 4.242, 7.52, 11.75, 14.819, 15.686, 17.079, 27.757, 30.236, 34.32, 37.014, 38.343, 38.982, 50.611, 52.282, 55.307, 83.305, 85.989, 87.164, 88.339, 93.6, 95.047, 96.22, 97.107, 100.564, 115.301, 169.919, 320.41, 323.768, 326.622, 328.637, 329.813, 331.156, 333.172, 334.515, 383.865, 404.71, 411.396, 414.576, 416.418, 418.93, 420.271, 422.115, 424.126, 429.997, 455.344, 476.007, 491.126, 494.068, 495.625, 497.928, 511.854, 516.892, 524.351, 537.177, 539.223, 545.876, 549.3, 556.783, 558.095, 572.451, 575.877, 585.468, 587.668, 589.092, 590.205, 593.436, 603.249, 605.076, 606.011, 606.591, 607.895, 615.819, 629.19, 632.054, 633.709, 644.66, 654.955, 656.938, 657.861, 660.005, 672.79, 684.558, 693.303, 696.733, 699.189, 699.749, 703.67, 706.354, 711.645, 727.42, 728.905, 730.228, 731.718, 741.381, 748.24, 755.134, 765.332, 774.608, 776.193, 777.947, 779.605, 780.975, 786.877, 791.482, 792.443, 793.729, 794.535, 801.526, 830.866, 840.255, 847.88, 852.52, 855.425, 857.982, 860.193, 861.553, 862.571, 863.685, 866.567, 873.145, 879.742, 909.572, 944.461, 986.969, 1014.265, 1075.669, 1084.038, 1091.62, 1092.583, 1094.016, 1100.51, 1102.003, 1103.055, 1104.095, 1104.919, 1106.143, 1107.353, 1110.517, 1129.375, 1142.419, 1158.576, 1161.073, 1171.092, 1174.696, 1175.817, 1179.361, 1190.372, 1193.649, 1204.202, 1205.489, 1212.348, 1215.833, 1218.487, 1221.099, 1222.022, 1264.125, 1267.208, 1270.313, 1272.018, 1273.608, 1277.523, 1300.104, 1302.474, 1304.066, 1306.48, 1306.937, 1307.702, 1308.932, 1309.551, 1310.326, 1311.105, 1321.606, 1328.365, 1333.388, 1334.258, 1335.475, 1336.168, 1336.91, 1339.85, 1365.833, 1368.45, 1371.054, 1373.3, 1377.428, 1381.946, 1385.854, 1388.802, 1399.569, 1406.423, 1420.915, 1432.631, 1454.217, 1455.486, 1456.029, 1475.851, 1480.036, 1499.022, 1512.449, 1523.219, 1525.729, 1538.452, 1540.449, 1541.901, 1543.225, 1559.63, 1569.973, 1571.424, 1579.559, 1618.979, 1621.636, 1624.293, 1628.772, 1633.049, 1634.003, 1636.224, 1639.385, 1643.505, 1673.915, 1721.155, 1759.294, 1763.118, 1766.768, 1774.683, 1777.447, 1806.034, 1830.999, 1854.735, 1864.824, 1866.741, 1878.74, 1901.181, 1906.989, 1925.991, 1935.742, 1939.168, 1940.99, 1942.986, 1946.674, 1951.595, 1959.04, 1969.2, 1979.11, 1983.681, 1987.275, 1989.941, 1993.639, 1997.13, 2000.555, 2004.27, 2007.539, 2010.425, 2013.205, 2016.812, 2019.513, 2021.368, 2023.168, 2026.201, 2031.628, 2037.627, 2057.424, 2062.501, 2065.072, 2083.956, 2086.628, 2090.573, 2099.179, 2107.648, 2117.253, 2120.405, 2122.633, 2124.234, 2127.458, 2130.869, 2133.81, 2137.127, 2141.631, 2145.073, 2147.646, 2153.26, 2163.497, 2174.168, 2180.042, 2182.056, 2183.948, 2187.291, 2188.648, 2190.017, 2192.324, 2194.31, 2196.962, 2200.496, 2216.439, 2225.406, 2227.826, 2232.062, 2266.827, 2271.108, 2282.406, 2311.335, 2316.821, 2323.17, 2330.064, 2335.56, 2339.679, 2344.48, 2361.137, 2373.196, 2389.466, 2394.249, 2402.957, 2418.803, 2427.97, 2446.353, 2454.532, 2462.391, 2474.075, 2481.387, 2498.734, 2507.868, 2515.731, 2526.813, 2569.449, 2575.097, 2581.41, 2595.071, 2597.304, 2632.176, 2666.046, 2685.132, 2690.779, 2692.836, 2694.669, 2697.129, 2704.35, 2705.786, 2707.229, 2708.355, 2709.484, 2711.59, 2714.041, 2717.152, 2718.251, 2719.428, 2719.764, 2720.101, 2721.446, 2723.24, 2758.98, 2760.956, 2762.321, 2772.077, 2775.692, 2776.375, 2779.079, 2783.725, 2784.345, 2789.27, 2791.3, 2793.812, 2796.396, 2797.272, 2799.195, 2801.146, 2801.859, 2804.616, 2808.723, 2817.037, 2821.604, 2827.682, 2837.627, 2846.885, 2847.371, 2848.343, 2848.993, 2849.177, 2850.41, 2851.101, 2851.785, 2852.757, 2853.359, 2853.665, 2859.133, 2860.855, 2862.641, 2863.031, 2863.688, 2864.219, 2872.434, 2873.149, 2874.159, 2876.022, 2877.744, 2880.56, 2883.699, 2888.907, 2892.479, 2904.328, 2905.967, 2907.445, 2911.298, 2912.971, 2914.997, 2915.911, 2917.184, 2919.531, 2920.706, 2922.552, 2925.554, 2926.828, 2927.787, 2937.329, 2941.654, 2963.428, 2964.612, 2964.981, 2966.52, 2973.251, 2980.941, 2985.302, 3016.652, 3033.614, 3050.335, 3061.145, 3118.93, 3120.466, 3121.425, 3122.226, 3123.029, 3131.346, 3133.995, 3135.742, 3138.028, 3206.863, 3210.396, 3215.956, 3216.171, 3223.25, 3227.304, 3234.066, 3239.151, 3244.622, 3254.281, 3259.522, 3263.283, 3278.928, 3301.578, 3312.16, 3324.599, 3376.685, 3381.917, 3385.963, 3387.647, 3412.776, 3425.087, 3431.929, 3438.303, 3442.745, 3459.353, 3464.721, 3466.32, 3469.049, 3470.585, 3473.695, 3474.952, 3475.697, 3476.96, 3478.081, 3479.356, 3480.46, 3481.486, 3482.659, 3498.888, 3499.653, 3515.515, 3519.67, 3530.635, 3542.295, 3545.189, 3546.704, 3554.244, 3556.576, 3563.012, 3574.645, 3577.917, 3582.553, 3603.234, 3605.966, 3618.452, 3653.49, 3656.588, 3668.471, 3670.143, 3671.832, 3673.731, 3676.714, 3693.426, 3697.829, 3703.744, 3710.491, 3716.87, 3719.616, 3722.383, 3727.541, 3738.136, 3752.689, 3764.801, 3790.05, 3800.09, 3810.676, 3850.702, 3867.128, 3870.503, 3873.37, 3888.39, 3892.893, 3894.416, 3903.022, 3908.947, 3912.322, 3916.2, 3930.013, 3941.596, 3944.122, 3953.684, 3958.384, 3975.389, 3983.193, 3995.236, 4004.888, 4012.239, 4015.25, 4035.396, 4039.733, 4046.544, 4054.39, 4059.141, 4067.589, 4070.412, 4072.002, 4072.985, 4078.504, 4086.94, 4089.028, 4102.853, 4113.404, 4119.441, 4125.146, 4138.466, 4143.871, 4148.157, 4151.467, 4154.786, 4157.946, 4159.169, 4162.023, 4163.339, 4164.825, 4169.115, 4198.073, 4212.962, 4219.854, 4229.588, 4231.557, 4233.53, 4236.003, 4237.655, 4239.808, 4242.295, 4244.954, 4246.951, 4250.117, 4256.122, 4399.855, 4444.327, 4447.634, 4454.135, 4459.701, 4464.217, 4468.923, 4476.035, 4482.878, 4496.195, 4502.263, 4505.017, 4507.418, 4510.636, 4533.072, 4546.899, 4560.26, 4598.362, 4600.626, 4602.014, 4614.008, 4615.258, 4615.885, 4616.254, 4617.742, 4619.175, 4620.439, 4621.62, 4623.32, 4624.481, 4632.666, 4633.424, 4635.105, 4635.898, 4636.835, 4637.923, 4638.668, 4639.671, 4640.083, 4649.711, 4652.343, 4653.437, 4655.324, 4656.272, 4657.702, 4658.978, 4660.902, 4685.164, 4688.722, 4692.548, 4696.094, 4700.862, 4702.778, 4706.698, 4716.386, 4719.204, 4720.955, 4748.586, 4752.159, 4847.852, 4996.976, 5039.436, 5174.843, 5206.306, 5330.249, 5441.119, 5451.497, 5628.782, 5796.043, 5998.875, 6070.82, 6262.996, 6456.417, 6849.225, 6972.117, 7029.294, 7085.237, 7278.248, 7327.361, 7828.917, 7876.8, 8002.59, 8061.199, 8188.423, 8294.206, 8309.93, 8325.654, 8338.52, 8359.248, 8360.928, 8362.775, 8365.128, 8367.479, 8368.992, 8370.672, 8377.092, 8395.845, 8398.247, 8400.801, 8403.678, 8409.233, 8413.737, 8421.019, 8421.856, 8422.507, 8423.865, 8425.246, 8426.384, 8427.521, 8428.377, 8429.543, 8431.549, 8452.874, 8458.673, 8479.502, 8490.186, 8525.985, 8527.483, 8528.816, 8530.816, 8531.984, 8537.475, 8547.064, 8553.57, 8570.877, 8572.462, 8601.433, 8624.706, 8629.849, 8645.531, 8652.06, 8658.596, 8678.56, 8698.884, 8702.748, 8708.964, 8716.356, 8720.053, 8726.269, 8738.456, 8744.676, 8750.781, 8756.255, 8767.257, 8770.6, 8773.946, 8777.127, 8781.483, 8801.944, 8808.831, 8820.254, 8825.63, 8833.021, 8861.077, 8869.981, 8874.014, 8879.121, 8881.664, 8895.742, 8897.448, 8903.731, 8910.842, 8913.134, 8917.736, 8919.349, 8924.029, 8927.807, 8929.977, 8931.739, 8934.228, 8936.678, 8939.925, 8952.07, 8955.236, 8958.636, 8987.681, 9011.491, 9013.086, 9014.674, 9017.131, 9062.365, 9090.768, 9131.018, 9133.201, 9143.469, 9160.125, 9287.262, 9348.342, 9408.665, 9527.333, 9534.054, 9537.247, 9541.111, 9543.968, 9545.815, 9556.568, 9559.078, 9560.646, 9564.151, 9568.122, 9580.182, 9586.296, 9590.972, 9595.865, 9607.96, 9614.27, 9617.911, 9624.79, 9629.914, 9633.997, 9635.524, 9636.373, 9639.932, 9645.044, 9652.021, 9654.021, 9655.887, 9658.715, 9671.285, 9674.238, 9683.525, 9693.91, 9705.245, 9709.126, 9714.521, 9719.909, 9720.751, 9722.098, 9723.78, 9730.005, 9733.537, 9738.413, 9747.164, 9751.8, 9756.353, 9762.176, 9765.774, 9784.609, 9785.106, 9808.36, 9813.335, 9829.177, 9835.406, 9841.824, 9879.244, 9882.244, 9883.955, 9885.372, 9886.39, 9898.48, 9931.401, 9958.726, 9960.084, 9963.815, 9966.162, 9987.514, 9995.817, 10003.616, 10006.898, 10008.595, 10014.229, 10022.401, 10041.019, 10043.045, 10046.514, 10047.786, 10070.707, 10110.568, 10127.444, 10129.242, 10133.409, 10147.34, 10165.516, 10169.815, 10173.001, 10192.357, 10192.837, 10194.334, 10208.001, 10223.754, 10261.808, 10291.495, 10344.129, 10413.392, 10427.194, 10464.819, 10475.937, 10489.006, 10491.322, 10498.179, 10504.568, 10518.652, 10526.57, 10546.924, 10557.864, 10562.149, 10565.086, 10569.928, 10575.225, 10587.461, 10639.328, 10719.811, 10790.878, 10797.262, 10814.734, 10815.91, 10833.056, 10835.355, 10836.179, 10836.838, 10837.992, 10863.598, 10907.252, 10919.773, 10931.135, 10963.838, 11035.989, 11044.339, 11051.5, 11059.531, 11066.974, 11071.478, 11073.685, 11079.408, 11084.59, 11090.538, 11095.381, 11100.869, 11107.631, 11115.849, 11124.534, 11131.149, 11143.137, 11151.082, 11168.631, 11177.173, 11197.78, 11207.15, 11213.148, 11220.997, 11223.802, 11231.518, 11234.666, 11244.291, 11248.684, 11251.081, 11264.048, 11277.229, 11282.761, 11284.361, 11285.929, 11288.037, 11289.86, 11291.421, 11292.951, 11295.933, 11302.039, 11309.143, 11314.785, 11317.908, 11320.933, 11325.301, 11330.173, 11347.981, 11353.151, 11356.527, 11366.505, 11374.669, 11379.013, 11383.63, 11391.318, 11397.526, 11403.675, 11408.312, 11412.704, 11415.913, 11416.771, 11417.041, 11424.127, 11427.708, 11447.248, 11490.652, 11492.241, 11494.159, 11496.302, 11497.692, 11499.405, 11547.411, 11664.152, 11668.438, 11681.299, 11769.188, 11818.504, 11864.228, 11948.863, 11961.658, 11965.926, 12075.424, 12078.938, 12139.204, 12174.98, 12192.956, 12205.893, 12220.203, 12235.383, 12250.946, 12265.589, 12275.942, 12285.426, 12292.747, 12296.458, 12298.887, 12301.064, 12302.839, 12306.645, 12312.253, 12329.922, 12349.75, 12352.438, 12355.798, 12361.831, 12367.784, 12371.363, 12379.161]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [5.603488, 53.272649, 2.75],
          [5.603684, 53.272690, 2.75],
          [5.603916, 53.272705, 2.75],
          [5.604097, 53.272714, 2.5],
          [5.604560, 53.272730, 2.25],
          [5.605150, 53.272760, 1.5],
          [5.605532, 53.272794, 1.5],
          [5.605627, 53.272802, 1.5],
          [5.605787, 53.272814, 1.5],
          [5.606970, 53.272906, 1.25],
          [5.607228, 53.272901, 1.0],
          [5.607663, 53.272928, 0.75],
          [5.607959, 53.272969, 0.25],
          [5.608064, 53.272914, 0.25],
          [5.608127, 53.272911, 0.0],
          [5.609263, 53.272995, 0.5],
          [5.609395, 53.273029, 0.75],
          [5.609643, 53.273050, 1.0],
          [5.612147, 53.273202, 0.75],
          [5.612384, 53.273196, 0.75],
          [5.612486, 53.273203, 0.75],
          [5.612584, 53.273209, 0.75],
          [5.613092, 53.273244, 0.25],
          [5.613156, 53.273320, 0.0],
          [5.613196, 53.273384, 0.0],
          [5.613212, 53.273428, 0.0],
          [5.613544, 53.273449, 0.0],
          [5.615230, 53.273577, -1.0],
          [5.619682, 53.273908, 0.25],
          [5.633016, 53.274865, 0.0],
          [5.633315, 53.274865, 0.0],
          [5.633561, 53.274880, 0.0],
          [5.633705, 53.274935, 0.0],
          [5.633798, 53.274943, 0.0],
          [5.633906, 53.274951, 0.0],
          [5.634074, 53.274945, 0.0],
          [5.634185, 53.274948, 0.0],
          [5.638467, 53.275241, 0.25],
          [5.640376, 53.275376, 0.0],
          [5.640953, 53.275452, 0.0],
          [5.641188, 53.275537, 0.0],
          [5.641349, 53.275553, 0.0],
          [5.641564, 53.275565, 0.0],
          [5.641674, 53.275558, 0.0],
          [5.641820, 53.275526, 0.0],
          [5.641987, 53.275515, 0.0],
          [5.642510, 53.275529, 0.0],
          [5.644752, 53.275689, 0.0],
          [5.646556, 53.275871, 0.0],
          [5.647823, 53.275959, 0.25],
          [5.648061, 53.275966, 0.5],
          [5.648116, 53.275903, 0.75],
          [5.648284, 53.275874, 0.75],
          [5.649405, 53.275940, 0.75],
          [5.649878, 53.275969, 0.25],
          [5.650524, 53.276003, 0.5],
          [5.651333, 53.276069, 2.0],
          [5.651449, 53.276047, 2.25],
          [5.651872, 53.276071, 2.5],
          [5.652108, 53.276108, 2.25],
          [5.652778, 53.276153, 1.5],
          [5.652868, 53.276194, 1.5],
          [5.654319, 53.276304, 0.75],
          [5.654640, 53.276326, 0.75],
          [5.655580, 53.276367, 0.5],
          [5.655788, 53.276380, 0.5],
          [5.655919, 53.276388, 0.5],
          [5.656016, 53.276391, 0.5],
          [5.656296, 53.276410, 0.75],
          [5.657061, 53.276469, 1.25],
          [5.657098, 53.276548, 1.25],
          [5.657061, 53.276469, 1.25],
          [5.657057, 53.276424, 1.25],
          [5.657071, 53.276316, 1.25],
          [5.657211, 53.275687, 1.0],
          [5.657410, 53.274830, 1.0],
          [5.657455, 53.274673, 1.25],
          [5.657410, 53.274830, 1.0],
          [5.657211, 53.275687, 1.0],
          [5.657071, 53.276316, 1.25],
          [5.657057, 53.276424, 1.25],
          [5.657061, 53.276469, 1.25],
          [5.657252, 53.276483, 1.5],
          [5.658072, 53.276548, 3.0],
          [5.658946, 53.276617, 3.0],
          [5.659799, 53.276684, 2.0],
          [5.660333, 53.276727, 1.75],
          [5.660660, 53.276752, 1.75],
          [5.660731, 53.276758, 1.75],
          [5.661218, 53.276796, 1.75],
          [5.661515, 53.276820, 1.75],
          [5.662054, 53.276862, 2.0],
          [5.663611, 53.276985, 2.0],
          [5.663741, 53.276995, 2.0],
          [5.663840, 53.276961, 2.0],
          [5.663964, 53.276972, 2.0],
          [5.664901, 53.277044, 1.5],
          [5.665601, 53.277101, 1.0],
          [5.666345, 53.277149, 0.5],
          [5.667387, 53.277230, 0.25],
          [5.668280, 53.277287, 0.25],
          [5.668428, 53.277280, 0.25],
          [5.668581, 53.277285, 0.25],
          [5.668737, 53.277297, 0.0],
          [5.668846, 53.277332, 0.0],
          [5.669403, 53.277374, 0.0],
          [5.669820, 53.277404, 0.0],
          [5.669873, 53.277441, 0.0],
          [5.669931, 53.277500, 0.0],
          [5.669963, 53.277538, 0.0],
          [5.670600, 53.277567, 0.0],
          [5.673229, 53.277723, 0.0],
          [5.674058, 53.277785, 0.0],
          [5.674692, 53.277850, 0.25],
          [5.675048, 53.277901, 0.5],
          [5.675292, 53.277939, 0.25],
          [5.675494, 53.277983, 0.25],
          [5.675671, 53.278031, 0.25],
          [5.675788, 53.278043, 0.25],
          [5.675871, 53.278049, 0.25],
          [5.675961, 53.278055, 0.0],
          [5.676228, 53.278033, 0.0],
          [5.676900, 53.278040, -0.5],
          [5.677531, 53.278080, -0.5],
          [5.680080, 53.278262, 0.0],
          [5.683423, 53.278513, -0.75],
          [5.687281, 53.278783, -1.0],
          [5.689613, 53.278951, -0.75],
          [5.695030, 53.279329, -0.75],
          [5.695649, 53.279347, 0.0],
          [5.696204, 53.279387, 0.25],
          [5.696240, 53.279355, 0.25],
          [5.696296, 53.279304, 0.5],
          [5.696717, 53.279327, 1.0],
          [5.696774, 53.279277, 1.0],
          [5.696828, 53.279255, 1.0],
          [5.696890, 53.279241, 1.0],
          [5.696944, 53.279237, 1.0],
          [5.697021, 53.279247, 1.0],
          [5.697098, 53.279270, 1.0],
          [5.697300, 53.279337, 1.0],
          [5.699031, 53.279454, 0.25],
          [5.700188, 53.279537, 0.25],
          [5.701698, 53.279643, 0.0],
          [5.701886, 53.279706, 0.0],
          [5.702768, 53.279779, 0.0],
          [5.703046, 53.279808, 0.5],
          [5.703120, 53.279815, 0.5],
          [5.703378, 53.279839, 0.75],
          [5.704297, 53.279907, 0.5],
          [5.704584, 53.279925, 0.25],
          [5.705568, 53.279985, 0.0],
          [5.705678, 53.279992, 0.0],
          [5.706259, 53.280031, 0.25],
          [5.706525, 53.280048, 0.75],
          [5.706726, 53.280062, 0.75],
          [5.706927, 53.280077, 0.75],
          [5.706935, 53.280034, 0.75],
          [5.710955, 53.280304, -0.5],
          [5.711240, 53.280300, -0.75],
          [5.711542, 53.280321, -1.0],
          [5.711705, 53.280345, -1.25],
          [5.711864, 53.280360, -1.25],
          [5.712225, 53.280384, -1.0],
          [5.714212, 53.280517, -0.75],
          [5.714436, 53.280526, -1.0],
          [5.714577, 53.280522, -1.0],
          [5.714804, 53.280536, -1.25],
          [5.714833, 53.280548, -1.25],
          [5.714867, 53.280582, -1.25],
          [5.714910, 53.280641, -1.25],
          [5.714923, 53.280667, -1.25],
          [5.714966, 53.280702, -1.25],
          [5.715027, 53.280721, -1.25],
          [5.716007, 53.280775, -1.25],
          [5.716690, 53.280760, -1.75],
          [5.717138, 53.280733, -1.5],
          [5.717152, 53.280771, -1.25],
          [5.717227, 53.280814, -1.25],
          [5.717278, 53.280829, -1.25],
          [5.717333, 53.280838, -1.0],
          [5.717553, 53.280852, -0.75],
          [5.719320, 53.280938, 0.0],
          [5.719541, 53.280926, 0.0],
          [5.719749, 53.280888, 0.0],
          [5.719921, 53.280843, 0.0],
          [5.720227, 53.280739, 0.0],
          [5.720581, 53.280619, -0.25],
          [5.720885, 53.280509, -0.25],
          [5.721141, 53.280464, -0.25],
          [5.722052, 53.280359, 0.0],
          [5.722246, 53.280693, 0.0],
          [5.722678, 53.281486, -0.5],
          [5.723046, 53.282184, -1.25],
          [5.723589, 53.283207, -0.5],
          [5.723615, 53.283259, -0.25],
          [5.723625, 53.283278, -0.25],
          [5.724090, 53.284170, 0.0],
          [5.724260, 53.284380, -0.25],
          [5.725258, 53.285402, -1.0],
          [5.725822, 53.286080, -1.25],
          [5.726237, 53.286616, -1.25],
          [5.726399, 53.286824, -1.25],
          [5.726952, 53.287651, -0.75],
          [5.727099, 53.287734, -0.75],
          [5.727224, 53.287696, -0.75],
          [5.727344, 53.287682, -0.75],
          [5.728882, 53.287683, -0.5],
          [5.730025, 53.287692, -1.75],
          [5.730170, 53.287691, -1.75],
          [5.730976, 53.287703, -1.75],
          [5.734676, 53.287869, -2.0],
          [5.734904, 53.287884, -2.0],
          [5.735110, 53.287914, -1.75],
          [5.735438, 53.287984, -1.5],
          [5.735747, 53.288047, -1.25],
          [5.735811, 53.288058, -1.25],
          [5.735961, 53.288084, -1.0],
          [5.736175, 53.288110, -0.75],
          [5.736452, 53.288117, -0.5],
          [5.739383, 53.288102, -2.0],
          [5.743622, 53.288068, -2.0],
          [5.746826, 53.288052, -1.5],
          [5.746846, 53.288262, -1.75],
          [5.746892, 53.288470, -2.0],
          [5.747071, 53.288978, -2.75],
          [5.747110, 53.289139, -2.75],
          [5.747254, 53.290603, -2.0],
          [5.747422, 53.291924, -2.0],
          [5.747563, 53.293132, -1.75],
          [5.747661, 53.293964, -1.75],
          [5.747674, 53.294095, -1.75],
          [5.747764, 53.294823, -1.5],
          [5.747985, 53.296130, -1.75],
          [5.748107, 53.296483, -2.5],
          [5.748591, 53.297457, -2.0],
          [5.748910, 53.297990, -2.5],
          [5.749060, 53.298170, -2.75],
          [5.749150, 53.298253, -2.75],
          [5.749269, 53.298344, -2.75],
          [5.749489, 53.298466, -2.25],
          [5.749778, 53.298599, -1.75],
          [5.750193, 53.298777, -1.25],
          [5.750756, 53.299053, -1.0],
          [5.751330, 53.299360, -1.0],
          [5.751593, 53.299516, -1.0],
          [5.751786, 53.299647, -1.0],
          [5.751912, 53.299754, -1.0],
          [5.752028, 53.299924, -1.0],
          [5.752128, 53.300084, -1.0],
          [5.752220, 53.300258, -1.25],
          [5.752332, 53.300457, -1.5],
          [5.752463, 53.300632, -1.75],
          [5.752610, 53.300768, -1.75],
          [5.752770, 53.300895, -1.75],
          [5.753013, 53.301041, -1.75],
          [5.753187, 53.301139, -1.5],
          [5.753307, 53.301200, -1.5],
          [5.753403, 53.301263, -1.25],
          [5.753573, 53.301368, -1.25],
          [5.753842, 53.301564, -1.0],
          [5.754107, 53.301810, -1.0],
          [5.754999, 53.302718, -1.25],
          [5.755154, 53.302989, -1.5],
          [5.755260, 53.303114, -1.5],
          [5.756180, 53.303995, -1.5],
          [5.756315, 53.304095, -1.25],
          [5.756542, 53.304223, -1.0],
          [5.757113, 53.304509, -1.25],
          [5.757693, 53.304855, -1.75],
          [5.758302, 53.305280, -2.0],
          [5.758477, 53.305426, -2.0],
          [5.758545, 53.305536, -2.0],
          [5.758581, 53.305620, -2.0],
          [5.758628, 53.305794, -2.0],
          [5.758936, 53.305801, -2.0],
          [5.759189, 53.305824, -2.0],
          [5.759467, 53.305856, -1.75],
          [5.759844, 53.305910, -1.75],
          [5.760123, 53.305959, -1.75],
          [5.760327, 53.306006, -1.75],
          [5.760731, 53.306127, -1.5],
          [5.761373, 53.306377, -1.0],
          [5.762039, 53.306699, -1.0],
          [5.761754, 53.306956, -1.25],
          [5.761683, 53.307046, -1.25],
          [5.761627, 53.307140, -1.5],
          [5.761558, 53.307319, -1.5],
          [5.761547, 53.307399, -1.75],
          [5.761555, 53.307471, -1.75],
          [5.761589, 53.307601, -1.75],
          [5.761637, 53.307697, -1.5],
          [5.761742, 53.307821, -1.5],
          [5.761893, 53.307968, -1.25],
          [5.762655, 53.308604, -1.0],
          [5.763141, 53.309025, -1.5],
          [5.763264, 53.309139, -1.75],
          [5.763462, 53.309371, -2.0],
          [5.764669, 53.311069, -1.5],
          [5.764820, 53.311289, -1.75],
          [5.765263, 53.311882, -2.0],
          [5.766352, 53.312911, -0.5],
          [5.766562, 53.313127, 0.0],
          [5.766731, 53.313353, 0.75],
          [5.766897, 53.313648, 0.5],
          [5.767045, 53.313911, 0.25],
          [5.767239, 53.314093, 0.0],
          [5.767555, 53.314262, 0.0],
          [5.769125, 53.314992, -1.75],
          [5.769971, 53.315374, -1.5],
          [5.771045, 53.315829, -1.0],
          [5.771325, 53.315996, -1.0],
          [5.771768, 53.316357, -1.0],
          [5.772341, 53.317215, -1.5],
          [5.772791, 53.317655, -1.75],
          [5.773702, 53.318348, -1.0],
          [5.774166, 53.318685, -1.25],
          [5.774689, 53.319029, -1.75],
          [5.775507, 53.319507, -2.0],
          [5.776020, 53.319774, -2.0],
          [5.777256, 53.320380, -2.0],
          [5.777867, 53.320611, -1.5],
          [5.778396, 53.320758, -1.0],
          [5.779234, 53.320930, -1.0],
          [5.782304, 53.321569, 0.0],
          [5.782802, 53.321659, -0.25],
          [5.783468, 53.321726, -1.0],
          [5.784954, 53.321820, -1.75],
          [5.785302, 53.321843, -2.0],
          [5.789052, 53.322067, -1.5],
          [5.792297, 53.322270, -2.0],
          [5.793813, 53.322363, -1.5],
          [5.794361, 53.322391, -2.0],
          [5.794557, 53.322411, -2.25],
          [5.794736, 53.322436, -2.5],
          [5.794977, 53.322496, -2.75],
          [5.795639, 53.322695, -2.75],
          [5.795761, 53.322726, -2.5],
          [5.795888, 53.322743, -2.5],
          [5.795978, 53.322746, -2.5],
          [5.796081, 53.322741, -2.5],
          [5.796264, 53.322713, -2.5],
          [5.796477, 53.322668, -2.75],
          [5.796736, 53.322579, -2.75],
          [5.796824, 53.322548, -2.75],
          [5.796906, 53.322520, -2.5],
          [5.796923, 53.322514, -2.5],
          [5.796948, 53.322509, -2.5],
          [5.797055, 53.322488, -2.5],
          [5.797202, 53.322478, -2.25],
          [5.798900, 53.322545, 0.5],
          [5.799036, 53.322532, 0.75],
          [5.798987, 53.322481, 0.75],
          [5.799573, 53.322392, 1.75],
          [5.798987, 53.322481, 0.75],
          [5.799036, 53.322532, 0.75],
          [5.799278, 53.322714, 0.75],
          [5.799605, 53.323011, 0.75],
          [5.799621, 53.323050, 0.75],
          [5.800005, 53.323273, 1.0],
          [5.800182, 53.323347, 0.75],
          [5.800421, 53.323406, 0.75],
          [5.800667, 53.323453, 0.75],
          [5.800742, 53.323472, 0.75],
          [5.800898, 53.323530, 0.75],
          [5.801044, 53.323607, 0.75],
          [5.801085, 53.323636, 0.5],
          [5.801260, 53.323761, 0.5],
          [5.801472, 53.323950, 0.75],
          [5.801802, 53.324339, 1.0],
          [5.801981, 53.324547, 1.0],
          [5.802224, 53.324830, 1.0],
          [5.802659, 53.325348, 0.5],
          [5.803046, 53.325807, 0.5],
          [5.803066, 53.325831, 0.5],
          [5.803072, 53.325877, 0.5],
          [5.803068, 53.325912, 0.5],
          [5.803068, 53.325921, 0.5],
          [5.803032, 53.326029, 0.5],
          [5.802939, 53.326029, 0.5],
          [5.802839, 53.326042, 0.25],
          [5.802703, 53.326073, 0.0],
          [5.802631, 53.326099, 0.0],
          [5.802593, 53.326113, 0.0],
          [5.802119, 53.326443, 0.0],
          [5.801967, 53.326529, 0.0],
          [5.801794, 53.326592, 0.0],
          [5.801799, 53.326615, 0.0],
          [5.801807, 53.326651, 0.0],
          [5.801797, 53.326683, 0.0],
          [5.801237, 53.327110, -0.25],
          [5.801192, 53.327145, -0.25],
          [5.801236, 53.327195, -0.25],
          [5.801313, 53.327283, 0.0],
          [5.801389, 53.327370, 0.0],
          [5.801588, 53.327595, 0.0],
          [5.801802, 53.327815, 0.0],
          [5.802136, 53.328140, 0.0],
          [5.802357, 53.328341, 0.0],
          [5.803297, 53.329194, -2.0],
          [5.803387, 53.329255, -1.75],
          [5.803498, 53.329283, -1.75],
          [5.803807, 53.329336, -1.5],
          [5.803917, 53.329372, -1.25],
          [5.804032, 53.329430, -1.25],
          [5.804080, 53.329454, -1.25],
          [5.804139, 53.329505, -1.25],
          [5.804229, 53.329605, -1.25],
          [5.804259, 53.329658, -1.5],
          [5.804277, 53.329750, -1.5],
          [5.804262, 53.329917, -1.75],
          [5.804281, 53.329981, -1.75],
          [5.804312, 53.330025, -1.75],
          [5.804807, 53.330428, -1.5],
          [5.805035, 53.330585, -1.25],
          [5.806430, 53.331319, -1.25],
          [5.806367, 53.331359, -1.25],
          [5.806366, 53.331396, -1.25],
          [5.806215, 53.331502, -1.25],
          [5.805706, 53.331904, -0.75],
          [5.805392, 53.332397, -1.0],
          [5.805155, 53.332770, -1.25],
          [5.803941, 53.334823, -2.0],
          [5.803349, 53.335705, -2.0],
          [5.802772, 53.336635, -2.5],
          [5.802463, 53.337156, -2.25],
          [5.800734, 53.339923, -1.75],
          [5.800724, 53.339996, -1.75],
          [5.800744, 53.340042, -2.0],
          [5.800789, 53.340070, -2.0],
          [5.800844, 53.340092, -2.0],
          [5.801446, 53.340276, -1.5],
          [5.801611, 53.340342, -1.25],
          [5.801527, 53.340414, -1.5],
          [5.801373, 53.340497, -1.75],
          [5.796927, 53.342848, -1.0],
          [5.796736, 53.342966, -0.75],
          [5.796557, 53.343175, -0.25],
          [5.796561, 53.343176, 0.0],
          [5.797464, 53.343452, 0.0],
          [5.797889, 53.343590, 0.0],
          [5.798538, 53.343815, 0.0],
          [5.798974, 53.343979, 0.0],
          [5.799437, 53.344164, -0.25],
          [5.800281, 53.344520, -0.75],
          [5.800667, 53.344697, -0.5],
          [5.800924, 53.344817, -0.25],
          [5.801894, 53.345299, 0.25],
          [5.803436, 53.346082, 0.0],
          [5.804136, 53.346462, 0.0],
          [5.805010, 53.346963, -0.5],
          [5.808228, 53.348876, 0.0],
          [5.808569, 53.349054, 0.0],
          [5.808833, 53.349188, 0.0],
          [5.808943, 53.349236, 0.0],
          [5.810444, 53.349861, 1.0],
          [5.811450, 53.350279, 0.25],
          [5.811945, 53.350486, 0.5],
          [5.812397, 53.350663, 0.75],
          [5.812731, 53.350794, 0.5],
          [5.814005, 53.351267, 0.5],
          [5.814437, 53.351419, 0.25],
          [5.814573, 53.351453, 0.25],
          [5.814794, 53.351530, 0.0],
          [5.814912, 53.351571, 0.0],
          [5.815154, 53.351669, 0.0],
          [5.815208, 53.351614, 0.0],
          [5.815154, 53.351669, 0.0],
          [5.815307, 53.351730, 0.0],
          [5.815197, 53.351800, 0.0],
          [5.815039, 53.351834, 0.0],
          [5.814900, 53.351840, 0.0],
          [5.814772, 53.351816, 0.0],
          [5.814642, 53.351778, 0.0],
          [5.813149, 53.351253, 0.5],
          [5.813085, 53.351237, 0.25],
          [5.811613, 53.351075, 0.25],
          [5.811228, 53.351025, 0.0],
          [5.812093, 53.351365, 0.0],
          [5.812944, 53.351690, 0.25],
          [5.813150, 53.351779, 0.25],
          [5.813339, 53.351860, 0.25],
          [5.814252, 53.352298, -1.0],
          [5.814504, 53.352401, -1.25],
          [5.815175, 53.352595, -1.0],
          [5.816221, 53.352887, -0.75],
          [5.816497, 53.352979, -1.0],
          [5.816899, 53.353124, -1.25],
          [5.818285, 53.353649, -0.25],
          [5.818491, 53.353721, -0.25],
          [5.819418, 53.354010, 0.0],
          [5.821887, 53.354758, 0.75],
          [5.822103, 53.354841, 0.75],
          [5.823056, 53.355318, -0.25],
          [5.823192, 53.355370, -0.25],
          [5.823334, 53.355410, -0.25],
          [5.823517, 53.355449, -0.5],
          [5.823807, 53.355490, -0.5],
          [5.825250, 53.355636, 0.0],
          [5.825628, 53.355688, 0.0],
          [5.826126, 53.355771, 0.0],
          [5.826698, 53.355862, 0.0],
          [5.827263, 53.355970, -0.25],
          [5.827505, 53.355997, -0.25],
          [5.827728, 53.356024, 0.0],
          [5.828146, 53.356119, 0.0],
          [5.828948, 53.356323, 0.25],
          [5.829961, 53.356629, 0.75],
          [5.830967, 53.356978, 0.0],
          [5.832948, 53.357693, 0.0],
          [5.833724, 53.357965, 0.0],
          [5.834500, 53.358223, 0.25],
          [5.837342, 53.359109, 1.0],
          [5.838625, 53.359515, 1.0],
          [5.838873, 53.359613, 1.0],
          [5.839063, 53.359704, 1.0],
          [5.840133, 53.360284, 0.5],
          [5.840485, 53.360417, 0.5],
          [5.840620, 53.360450, 0.25],
          [5.841524, 53.360606, -0.5],
          [5.842062, 53.360691, -0.25],
          [5.842344, 53.360749, 0.0],
          [5.842651, 53.360832, 0.0],
          [5.843538, 53.361110, 1.0],
          [5.844356, 53.361364, 1.0],
          [5.844528, 53.361429, 1.0],
          [5.845314, 53.361626, 0.75],
          [5.845691, 53.361733, 0.75],
          [5.846980, 53.362138, 1.0],
          [5.847617, 53.362322, 0.75],
          [5.848630, 53.362561, 0.75],
          [5.849431, 53.362742, 0.75],
          [5.850026, 53.362896, 0.75],
          [5.850259, 53.362971, 0.75],
          [5.851873, 53.363556, 0.5],
          [5.852210, 53.363661, 0.5],
          [5.852799, 53.363817, 0.25],
          [5.853507, 53.363990, 0.0],
          [5.853902, 53.364104, 0.0],
          [5.854517, 53.364294, 0.5],
          [5.854708, 53.364347, 0.75],
          [5.854811, 53.364365, 1.0],
          [5.854872, 53.364366, 1.0],
          [5.855233, 53.364474, 1.25],
          [5.855906, 53.364644, 0.75],
          [5.856085, 53.364684, 0.5],
          [5.857320, 53.365050, 0.0],
          [5.858140, 53.365330, 0.25],
          [5.858630, 53.365460, 0.25],
          [5.859120, 53.365530, 0.25],
          [5.860340, 53.365660, 0.0],
          [5.860820, 53.365690, 0.0],
          [5.861180, 53.365760, 0.0],
          [5.861400, 53.365870, 0.0],
          [5.861600, 53.366000, 0.0],
          [5.861750, 53.366140, 0.0],
          [5.861800, 53.366250, 0.0],
          [5.861810, 53.366500, 0.0],
          [5.861790, 53.366600, 0.0],
          [5.861700, 53.366700, 0.0],
          [5.861400, 53.366950, 0.0],
          [5.859510, 53.368240, 0.25],
          [5.858915, 53.368998, 0.0],
          [5.858690, 53.369330, 0.25],
          [5.858213, 53.369783, 0.0],
          [5.858165, 53.369885, 0.0],
          [5.858150, 53.369990, 0.0],
          [5.858170, 53.370120, 0.0],
          [5.858198, 53.370200, 0.0],
          [5.858278, 53.370302, 0.0],
          [5.858398, 53.370410, 0.0],
          [5.858575, 53.370502, 0.0],
          [5.858724, 53.370555, 0.0],
          [5.858982, 53.370608, 0.0],
          [5.859532, 53.370672, -0.25],
          [5.871525, 53.373377, 0.0],
          [5.875258, 53.374441, -0.5],
          [5.875514, 53.374524, -0.5],
          [5.875977, 53.374706, -0.25],
          [5.876380, 53.374880, -0.5],
          [5.876703, 53.375049, -0.75],
          [5.877010, 53.375217, -0.5],
          [5.877412, 53.375481, -0.25],
          [5.877751, 53.375740, 0.0],
          [5.878405, 53.376288, 0.0],
          [5.878699, 53.376546, 0.0],
          [5.878855, 53.376655, 0.0],
          [5.879011, 53.376735, 0.0],
          [5.879263, 53.376828, -0.25],
          [5.881150, 53.377318, -0.25],
          [5.882973, 53.377792, -0.5],
          [5.884056, 53.378107, -0.25],
          [5.886667, 53.378893, 1.0],
          [5.886852, 53.378925, 1.0],
          [5.886964, 53.378931, 1.0],
          [5.888153, 53.378889, 0.25],
          [5.888268, 53.378886, 0.25],
          [5.888274, 53.378913, 0.25],
          [5.888268, 53.378886, 0.25],
          [5.888279, 53.378751, 0.0],
          [5.888323, 53.378623, -0.25],
          [5.888383, 53.378521, -0.5],
          [5.888456, 53.378429, -0.75],
          [5.888599, 53.378304, -1.0],
          [5.888708, 53.378232, -1.0],
          [5.889512, 53.377792, -1.5],
          [5.889582, 53.377771, -1.5],
          [5.889753, 53.377736, -1.5],
          [5.889822, 53.377715, -1.5],
          [5.889893, 53.377677, -1.5],
          [5.889974, 53.377630, -1.5],
          [5.889893, 53.377677, -1.5],
          [5.889962, 53.377750, -1.25],
          [5.889955, 53.377785, -1.25],
          [5.889677, 53.378393, -0.25],
          [5.889617, 53.378538, 0.0],
          [5.889604, 53.378597, 0.0],
          [5.889613, 53.378700, 0.0],
          [5.889630, 53.378748, 0.0],
          [5.889681, 53.378822, 0.0],
          [5.889737, 53.378883, 0.0],
          [5.889853, 53.378962, 0.0],
          [5.891442, 53.379719, 0.5],
          [5.891697, 53.379827, 0.5],
          [5.891997, 53.379944, 0.25],
          [5.892275, 53.380035, 0.25],
          [5.892703, 53.380139, 0.0],
          [5.892884, 53.380181, -0.25],
          [5.893234, 53.380264, -0.25],
          [5.894032, 53.380473, 0.0],
          [5.894243, 53.380535, 0.25],
          [5.894343, 53.380593, 0.25],
          [5.896671, 53.381130, 0.0],
          [5.896734, 53.381138, 0.0],
          [5.898822, 53.381429, 0.0],
          [5.901607, 53.382272, 0.5],
          [5.902456, 53.382404, 0.75],
          [5.905251, 53.382689, 0.75],
          [5.905878, 53.382792, 0.75],
          [5.908335, 53.383233, 1.5],
          [5.910518, 53.383769, 0.5],
          [5.910733, 53.383822, 0.5],
          [5.914421, 53.384439, 0.5],
          [5.917765, 53.385072, 0.75],
          [5.922026, 53.385391, 0.0],
          [5.923497, 53.385597, 0.0],
          [5.927204, 53.386440, 1.25],
          [5.931166, 53.387102, 0.0],
          [5.938747, 53.389054, 0.0],
          [5.941190, 53.389544, 0.0],
          [5.942339, 53.389725, 0.0],
          [5.943548, 53.389917],
          [5.947536, 53.390487],
          [5.948472, 53.390744],
          [5.958241, 53.393101],
          [5.959170, 53.393316],
          [5.961764, 53.393614],
          [5.962992, 53.393662],
          [5.965613, 53.393967],
          [5.967774, 53.394261],
          [5.968097, 53.394290],
          [5.968421, 53.394292],
          [5.968678, 53.394270],
          [5.968566, 53.394020, 0.0],
          [5.968706, 53.393995, 0.0],
          [5.968848, 53.393957, 0.0],
          [5.969014, 53.393892, 0.0],
          [5.969168, 53.393816, 0.0],
          [5.969248, 53.393761, 0.0],
          [5.969338, 53.393695, 0.0],
          [5.969586, 53.393432, 0.5],
          [5.970312, 53.392691, 1.0],
          [5.970428, 53.392593, 0.75],
          [5.970571, 53.392503, 1.0],
          [5.970758, 53.392412, 0.75],
          [5.971165, 53.392283, 1.0],
          [5.971493, 53.392204, 1.25],
          [5.972066, 53.392131, 1.25],
          [5.972138, 53.392126, 1.0],
          [5.972231, 53.392121, 1.0],
          [5.972437, 53.392121, 1.0],
          [5.972642, 53.392133, 0.75],
          [5.972790, 53.392153, 0.75],
          [5.972946, 53.392182, 0.5],
          [5.973050, 53.392209, 0.5],
          [5.973210, 53.392219, 0.25],
          [5.973447, 53.392283, 0.25],
          [5.975631, 53.392959, 0.0],
          [5.976118, 53.393087, 0.0],
          [5.977605, 53.393457, 0.75],
          [5.978584, 53.393721, 0.0],
          [5.981631, 53.394630, -0.25],
          [5.981755, 53.394645, -0.25],
          [5.981861, 53.394637, -0.25],
          [5.981957, 53.394724, -0.25],
          [5.982040, 53.394762, -0.25],
          [5.982452, 53.394882, 0.0],
          [5.983277, 53.395110, -0.5],
          [5.983773, 53.395238, 0.0],
          [5.985758, 53.395751, 0.75],
          [5.985890, 53.395791, 0.75],
          [5.988401, 53.396451, 0.5],
          [5.990463, 53.397003, 0.0],
          [5.990864, 53.397135, 0.0],
          [5.992120, 53.397511, 0.0],
          [5.992637, 53.397673, 0.0],
          [5.993168, 53.397807, 0.0],
          [5.994844, 53.398175, 0.0],
          [5.996551, 53.398540, 0.0],
          [5.996873, 53.398591, 0.0],
          [5.997409, 53.398652, 0.0],
          [5.998050, 53.398713, 0.0],
          [5.998362, 53.398758, 0.0],
          [5.998875, 53.398865, 0.0],
          [5.999940, 53.399086, -0.25],
          [6.000476, 53.399191, -0.25],
          [6.001000, 53.399281, -0.25],
          [6.001478, 53.399346, -0.25],
          [6.002451, 53.399456, -0.25],
          [6.002732, 53.399494, -0.25],
          [6.003015, 53.399541, -0.25],
          [6.003274, 53.399589, -0.25],
          [6.003633, 53.399667, -0.25],
          [6.005320, 53.400086, -0.25],
          [6.005894, 53.400221, -0.25],
          [6.006848, 53.400424, -0.25],
          [6.007297, 53.400512, -0.25],
          [6.007927, 53.400617, -0.25],
          [6.010354, 53.400988, -0.25],
          [6.011118, 53.401113, -0.25],
          [6.011448, 53.401177, -0.25],
          [6.012020, 53.401310, -1.75],
          [6.012263, 53.401382, -1.75],
          [6.013534, 53.401791, -1.75],
          [6.013665, 53.401836, -1.75],
          [6.013826, 53.401660, 0.5],
          [6.014117, 53.401853, 0.5],
          [6.014237, 53.401906, 0.5],
          [6.014515, 53.401987, 0.5],
          [6.014736, 53.402052],
          [6.015351, 53.402184, 0.75],
          [6.015814, 53.402312, 0.25],
          [6.016070, 53.402344, 0.25],
          [6.016280, 53.402350, 0.25],
          [6.016555, 53.402338, 0.25],
          [6.016805, 53.402304, 0.25],
          [6.017150, 53.402300, 0.25],
          [6.018700, 53.402400, -1.0],
          [6.019000, 53.402390, -1.0],
          [6.019272, 53.402325, -0.75],
          [6.021328, 53.401608, -0.25],
          [6.023307, 53.400925, -0.75],
          [6.023390, 53.400980, -0.5],
          [6.023506, 53.401008, -0.5],
          [6.023701, 53.401035, -0.5],
          [6.027189, 53.401483, 0.5],
          [6.029724, 53.401814, 0.25],
          [6.033255, 53.402264, 0.25],
          [6.033438, 53.402283, 0.25],
          [6.034230, 53.402399, 0.75],
          [6.035554, 53.402569, 1.0],
          [6.047350, 53.404050, -1.0],
          [6.052443, 53.404711, -0.25],
          [6.057698, 53.405379, -0.25],
          [6.068080, 53.406710, -0.25],
          [6.068664, 53.406761, -0.25],
          [6.068940, 53.406765, -0.25],
          [6.069277, 53.406751, -0.25],
          [6.069526, 53.406728, -0.25],
          [6.069677, 53.406696, -0.25],
          [6.070561, 53.406477, -0.25],
          [6.070911, 53.406391],
          [6.071001, 53.406275],
          [6.071459, 53.406225],
          [6.071901, 53.406127],
          [6.073075, 53.405818, -1.0],
          [6.073585, 53.405719, -0.5],
          [6.073966, 53.405669, -0.25],
          [6.074331, 53.405593, 0.0],
          [6.075224, 53.405329, 0.0],
          [6.075738, 53.405233, 0.0],
          [6.076032, 53.405168, 0.0],
          [6.076575, 53.405028, 0.0],
          [6.076975, 53.404914, 0.0],
          [6.077265, 53.404796, 0.0],
          [6.077371, 53.404843, 0.0],
          [6.077445, 53.404845, 0.0],
          [6.077747, 53.404790, 0.0],
          [6.078191, 53.404684, -0.25],
          [6.078819, 53.404603, -0.25],
          [6.078998, 53.404574, -0.5],
          [6.079151, 53.404536, -0.5],
          [6.079378, 53.404457, -0.5],
          [6.080213, 53.404062, 0.0],
          [6.080424, 53.403988, 0.0],
          [6.081139, 53.403770, 0.0],
          [6.081986, 53.403562, 0.0],
          [6.082987, 53.403542, 0.0],
          [6.083302, 53.403464, 0.0],
          [6.083647, 53.403273, 0.0],
          [6.083894, 53.403029, 0.0],
          [6.083915, 53.402986, 0.0],
          [6.083918, 53.402923, 0.0],
          [6.083880, 53.402839, 0.0],
          [6.084334, 53.402658, 0.0],
          [6.084610, 53.402582, 0.0],
          [6.085010, 53.402497, 0.0],
          [6.085638, 53.402383, 0.75],
          [6.085942, 53.402299, 1.0],
          [6.086170, 53.402166, 1.25],
          [6.086554, 53.402134, 1.75],
          [6.086802, 53.402103, 1.75],
          [6.088607, 53.401884, 0.5],
          [6.088642, 53.401887, 0.5],
          [6.090867, 53.401651, 0.0],
          [6.091286, 53.401575, 0.0],
          [6.092741, 53.401395, -0.25],
          [6.093279, 53.401303, -0.25],
          [6.093862, 53.401188, -0.5],
          [6.097176, 53.400495, -0.75],
          [6.097417, 53.400440, -0.75],
          [6.097658, 53.400387, -0.75],
          [6.097837, 53.400327, -0.75],
          [6.097816, 53.400239, -1.0],
          [6.099043, 53.399723, -1.0],
          [6.101834, 53.398575, -1.5],
          [6.103695, 53.397787, -1.0],
          [6.103760, 53.397731, -1.0],
          [6.104044, 53.397648, -1.0],
          [6.104198, 53.397579, -0.75],
          [6.105535, 53.396849, -0.75],
          [6.106213, 53.396538, -1.5],
          [6.106883, 53.396290, -1.75],
          [6.107099, 53.396189, -1.25],
          [6.106883, 53.396290, -1.75],
          [6.106213, 53.396538, -1.5],
          [6.105535, 53.396849, -0.75],
          [6.104198, 53.397579, -0.75],
          [6.104044, 53.397648, -1.0],
          [6.103760, 53.397731, -1.0],
          [6.103695, 53.397787, -1.0],
          [6.101834, 53.398575, -1.5],
          [6.099043, 53.399723, -1.0],
          [6.097816, 53.400239, -1.0],
          [6.097837, 53.400327, -0.75],
          [6.098156, 53.400376, -0.5],
          [6.099305, 53.400318, -0.5],
          [6.100718, 53.400464, 0.0],
          [6.101060, 53.400500, 0.0],
          [6.101326, 53.400482, 0.0],
          [6.102970, 53.400364, 0.0],
          [6.103040, 53.400360, 0.25],
          [6.103256, 53.400322, 0.25],
          [6.105190, 53.400380, -0.5],
          [6.106550, 53.400440, 0.0],
          [6.110019, 53.400550, -0.25],
          [6.112680, 53.400610, -0.25],
          [6.117290, 53.400780, 0.0],
          [6.123730, 53.400950, -0.75],
          [6.125200, 53.401020, -1.75],
          [6.128020, 53.401100, 0.0],
          [6.128920, 53.401170, 0.25],
          [6.129963, 53.401268, 0.5],
          [6.130152, 53.401277, 0.5],
          [6.130735, 53.401261, 0.5],
          [6.131311, 53.401273, 0.25],
          [6.132560, 53.401420, 0.25],
          [6.133280, 53.401520, 0.0],
          [6.134903, 53.401815, 0.5],
          [6.135809, 53.402150, 0.0],
          [6.136355, 53.402352, 0.0],
          [6.136652, 53.402493, 0.0],
          [6.137137, 53.402682, 0.0],
          [6.137624, 53.402871, 0.0],
          [6.138475, 53.403270, 0.75],
          [6.142657, 53.404457, 0.75],
          [6.149044, 53.406435, 0.75],
          [6.154766, 53.408087, 0.75],
          [6.155291, 53.408202, 0.75],
          [6.156811, 53.408424, 0.75],
          [6.156911, 53.408439, 0.75],
          [6.158585, 53.408781, 0.0],
          [6.158786, 53.408795, 0.0],
          [6.158850, 53.408786, 0.0],
          [6.158900, 53.408770, 0.0],
          [6.158969, 53.408724, 0.0],
          [6.160976, 53.409416, 0.0],
          [6.164476, 53.410454, 0.0],
          [6.165419, 53.410743, 0.25],
          [6.166314, 53.410999, 0.25],
          [6.168987, 53.411799, 0.0],
          [6.174789, 53.413506, 0.0],
          [6.175532, 53.413707, -0.5],
          [6.176115, 53.413853, -0.25],
          [6.176714, 53.413983, 0.25],
          [6.177279, 53.414074, 0.5],
          [6.177651, 53.414121, 0.25],
          [6.177987, 53.414165, 0.25],
          [6.178750, 53.414216, 0.25],
          [6.179357, 53.414235, 0.25],
          [6.180001, 53.414223, 0.25],
          [6.180487, 53.414204, 0.25],
          [6.181015, 53.414170, 0.25],
          [6.181652, 53.414104, 0.25],
          [6.182399, 53.414007, 0.25],
          [6.183157, 53.413860, 0.25],
          [6.183715, 53.413726, 0.25],
          [6.184668, 53.413427, 0.25],
          [6.185242, 53.413216, 0.5],
          [6.186493, 53.412701, 0.5],
          [6.187194, 53.412424, 0.0],
          [6.188786, 53.411762, 0.0],
          [6.189479, 53.411437, -0.25],
          [6.189964, 53.411244, -0.5],
          [6.190607, 53.410984, -0.75],
          [6.190821, 53.410893, -0.75],
          [6.191448, 53.410636, -1.0],
          [6.191675, 53.410537, -0.75],
          [6.192324, 53.410281, -0.25],
          [6.192612, 53.410175, 0.0],
          [6.192771, 53.410128, 0.25],
          [6.193389, 53.409947, 2.0],
          [6.194058, 53.409730, 2.5],
          [6.194338, 53.409623, 2.75],
          [6.194419, 53.409596, 2.75],
          [6.194515, 53.409590, 2.75],
          [6.194638, 53.409563, 3.0],
          [6.194738, 53.409526, 3.0],
          [6.194822, 53.409492, 3.0],
          [6.194900, 53.409450, 3.0],
          [6.195017, 53.409353, 3.0],
          [6.195431, 53.409156, 2.25],
          [6.195984, 53.408869, 1.5],
          [6.196376, 53.408643, 1.5],
          [6.196616, 53.408537, 1.5],
          [6.196831, 53.408450, 1.75],
          [6.197148, 53.408322, 1.75],
          [6.197506, 53.408178, 1.75],
          [6.198838, 53.407655, 1.75],
          [6.199219, 53.407538, 2.0],
          [6.199454, 53.407476, 2.25],
          [6.200187, 53.407265, 2.25],
          [6.200873, 53.407114, 2.0],
          [6.201233, 53.407046, 2.0],
          [6.201615, 53.406997, 2.25],
          [6.202253, 53.406925, 2.25],
          [6.202789, 53.406880, 2.25],
          [6.203346, 53.406864, 2.0],
          [6.203791, 53.406874, 1.75],
          [6.204248, 53.406896, 1.25],
          [6.204590, 53.406919, 1.0],
          [6.204667, 53.406925, 1.0],
          [6.204696, 53.406928, 0.75],
          [6.205422, 53.407018, 0.75],
          [6.205759, 53.407067, 0.75],
          [6.207209, 53.407315, 1.75],
          [6.210805, 53.407946, 2.0],
          [6.210946, 53.407970, 1.75],
          [6.211118, 53.407999, 1.75],
          [6.211326, 53.407948, 1.25],
          [6.211395, 53.408012, 1.5],
          [6.211527, 53.408056, 1.5],
          [6.215766, 53.408892, 1.25],
          [6.225713, 53.410871, 1.25],
          [6.225707, 53.410916, 1.25],
          [6.225614, 53.411066, 1.25],
          [6.227361, 53.411408, 1.25],
          [6.228333, 53.411603, 1.25],
          [6.227361, 53.411408],
          [6.225614, 53.411066],
          [6.225707, 53.410916],
          [6.225713, 53.410871],
          [6.235063, 53.412732],
          [6.235355, 53.412789],
          [6.240477, 53.413813],
          [6.243527, 53.414402],
          [6.245079, 53.414635, 1.0],
          [6.246214, 53.414757, 1.0],
          [6.247538, 53.414862, 0.75],
          [6.248905, 53.414920, 0.75],
          [6.250057, 53.414942, 1.75],
          [6.251375, 53.414911, 1.25],
          [6.252351, 53.414874, 1.0],
          [6.253250, 53.414810, 0.75],
          [6.253962, 53.414738, 0.5],
          [6.253941, 53.414515, 0.25],
          [6.254077, 53.414397, 0.25],
          [6.254266, 53.414336, 0.0],
          [6.254428, 53.414308, 0.0],
          [6.254837, 53.414323, -0.5],
          [6.255415, 53.414278, -0.5],
          [6.256932, 53.414023, 0.0],
          [6.258579, 53.413646, 0.0],
          [6.258790, 53.413580, 0.0],
          [6.259005, 53.413458, 0.0],
          [6.259326, 53.413276, 0.75],
          [6.259678, 53.413023, 0.0],
          [6.259821, 53.412853, 0.0],
          [6.260070, 53.412436, -0.25]
        ]
      }
    }
  ]
}

let day16: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "16- Vierhuizen - Stedum - 50.2km",
        "track-length": "50166",
        "filtered ascend": "45",
        "plain-ascend": "24",
        "total-time": "9815",
        "total-energy": "756751",
        "cost": "73511",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["6264910", "53406269", "-1", "774", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "117", "11727"],
          ["6261503", "53399418", "-2", "935", "1000", "0", "0", "0", "0", "highway=cycleway surface=fine_gravel smoothness=intermediate route_bicycle_rcn=yes", "", "269", "26930"],
          ["6262036", "53399413", "-2", "4", "5050", "0", "111", "0", "0", "highway=track tracktype=grade4 surface=sand smoothness=horrible", "", "272", "26982"],
          ["6261503", "53399418", "-2", "4", "5050", "0", "0", "0", "0", "reversedirection=yes highway=track tracktype=grade4 surface=sand smoothness=horrible", "", "274", "26982"],
          ["6260375", "53398160", "0", "184", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=fine_gravel smoothness=intermediate route_bicycle_rcn=yes", "", "302", "29759"],
          ["6260531", "53398090", "0", "8", "5050", "0", "83", "0", "0", "reversedirection=yes highway=track tracktype=grade4 surface=sand smoothness=horrible", "", "308", "29842"],
          ["6258601", "53399544", "-1", "215", "5050", "0", "112", "0", "0", "highway=track tracktype=grade4 surface=sand smoothness=horrible", "", "451", "29892"],
          ["6260375", "53398160", "0", "207", "5050", "0", "112", "0", "0", "reversedirection=yes highway=track tracktype=grade4 surface=sand smoothness=horrible", "", "596", "30811"],
          ["6253809", "53394249", "-1", "692", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=fine_gravel smoothness=intermediate route_bicycle_rcn=yes", "", "697", "40915"],
          ["6252753", "53393903", "-1", "84", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "709", "42168"],
          ["6252431", "53393972", "-2", "29", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "714", "42605"],
          ["6253498", "53393304", "-1", "22", "5050", "0", "107", "0", "0", "reversedirection=yes highway=track", "", "730", "42921"],
          ["6252431", "53393972", "-2", "22", "5050", "0", "0", "0", "0", "highway=track", "", "743", "42921"],
          ["6259179", "53390576", "1", "620", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "850", "53606"],
          ["6269781", "53384164", "-2", "1545", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "1088", "77376"],
          ["6269579", "53384043", "-2", "20", "1000", "0", "0", "0", "0", "highway=cycleway smoothness=intermediate route_bicycle_rcn=yes", "", "1092", "77742"],
          ["6275158", "53380753", "0", "548", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "1188", "87367"],
          ["6281707", "53376580", "0", "652", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "1285", "97061"],
          ["6282072", "53376359", "0", "35", "40000", "0", "0", "0", "0", "reversedirection=yes highway=steps surface=concrete foot=yes bicycle=dismount route_bicycle_rcn=yes", "", "1310", "97340"],
          ["6282385", "53376217", "0", "27", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "1314", "97781"],
          ["6282654", "53376052", "0", "26", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=wood foot=yes smoothness=intermediate route_bicycle_rcn=yes", "", "1318", "98209"],
          ["6286216", "53373956", "0", "334", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "1371", "103511"],
          ["6282929", "53366036", "0", "1062", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1551", "121477"],
          ["6288525", "53360964", "0", "854", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "", "1699", "136265"],
          ["6288529", "53360962", "0", "1", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "1699", "136285"],
          ["6290484", "53360366", "1", "151", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1729", "139247"],
          ["6290760", "53360332", "1", "19", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1732", "139611"],
          ["6291157", "53360230", "1", "2", "1150", "0", "2", "0", "0", "highway=residential surface=paving_stones", "", "1733", "139649"],
          ["6290760", "53360332", "1", "2", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones", "", "1733", "139667"],
          ["6291835", "53360658", "1", "92", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1743", "140650"],
          ["6293003", "53360439", "1", "83", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1754", "141753"],
          ["6295249", "53359560", "0", "185", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1780", "144352"],
          ["6296559", "53356243", "0", "492", "1350", "0", "208", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "", "1858", "152127"],
          ["6296753", "53355616", "1", "73", "1350", "0", "6", "0", "0", "highway=unclassified surface=asphalt smoothness=good", "", "1869", "153300"],
          ["6297618", "53352932", "-1", "306", "1050", "0", "3", "0", "0", "highway=cycleway surface=concrete smoothness=intermediate", "barrier=cattle_grid", "1906", "156999"],
          ["6297645", "53352862", "-1", "8", "1050", "0", "0", "0", "0", "highway=cycleway surface=paved smoothness=intermediate", "barrier=cattle_grid", "1908", "157128"],
          ["6298878", "53349289", "0", "407", "1050", "0", "0", "0", "0", "highway=cycleway surface=concrete smoothness=intermediate", "barrier=cattle_grid", "1980", "164332"],
          ["6298903", "53349177", "0", "14", "1050", "0", "5", "0", "0", "highway=cycleway surface=concrete smoothness=intermediate", "barrier=cattle_grid", "1982", "164577"],
          ["6298861", "53349135", "0", "6", "1050", "0", "7", "0", "0", "highway=cycleway surface=concrete smoothness=intermediate", "", "1983", "164687"],
          ["6299746", "53348844", "0", "17", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1986", "164975"],
          ["6298045", "53345098", "0", "686", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2089", "175228"],
          ["6297938", "53345035", "0", "2", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2089", "175264"],
          ["6298045", "53345098", "0", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2089", "175283"],
          ["6298613", "53345226", "0", "44", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2094", "175739"],
          ["6299051", "53344957", "0", "50", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "2100", "176390"],
          ["6299148", "53344946", "0", "7", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "2101", "176495"],
          ["6299225", "53344935", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2102", "176586"],
          ["6299466", "53341829", "0", "360", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2149", "181278"],
          ["6299905", "53339837", "0", "226", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2186", "184964"],
          ["6299934", "53339710", "0", "15", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2189", "185254"],
          ["6300050", "53339310", "0", "47", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2199", "186228"],
          ["6300732", "53339325", "0", "48", "1450", "0", "55", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good", "", "2204", "186729"],
          ["6301280", "53338751", "1", "71", "1150", "0", "195", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "2213", "187694"],
          ["6300620", "53338808", "1", "12", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "2214", "187807"],
          ["6300069", "53337968", "2", "111", "1150", "0", "88", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "2228", "189206"],
          ["6300047", "53337908", "2", "7", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "barrier=bollard foot=yes bicycle=yes motorcycle=yes horse=yes", "2229", "189310"],
          ["6299970", "53337644", "1", "30", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes smoothness=intermediate", "", "2234", "189739"],
          ["6299938", "53337534", "1", "13", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "2236", "189930"],
          ["6299210", "53337611", "1", "5", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2236", "190000"],
          ["6299938", "53337534", "1", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2237", "190048"],
          ["6300882", "53337443", "1", "67", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2244", "190789"],
          ["6300939", "53337553", "1", "13", "1150", "0", "134", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "2246", "190949"],
          ["6302329", "53337263", "0", "114", "1150", "0", "79", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "2258", "192186"],
          ["6302776", "53337399", "0", "7", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2259", "192263"],
          ["6301220", "53336957", "0", "91", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2269", "193263"],
          ["6300538", "53336786", "1", "50", "1150", "0", "5", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "barrier=unknown access=yes", "2276", "193989"],
          ["6299854", "53336590", "0", "51", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "2284", "194739"],
          ["6299583", "53336779", "0", "8", "1150", "0", "66", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "2285", "194853"],
          ["6299854", "53336590", "0", "8", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "2286", "194930"],
          ["6300751", "53336011", "1", "90", "1350", "0", "8", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones smoothness=intermediate", "", "2297", "196107"],
          ["6299854", "53336590", "0", "90", "1350", "0", "8", "0", "0", "highway=unclassified surface=paving_stones smoothness=intermediate", "", "2306", "196984"],
          ["6299583", "53336779", "0", "28", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "2309", "197278"],
          ["6299938", "53337534", "1", "170", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_lcn=yes", "", "2336", "199967"],
          ["6298530", "53337697", "0", "97", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=give_way direction=forward", "2351", "201492"],
          ["6298481", "53337717", "0", "4", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "2352", "201555"],
          ["6299869", "53339365", "0", "210", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt cycleway=no smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2378", "204173"],
          ["6300050", "53339310", "0", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2380", "204392"],
          ["6299934", "53339710", "0", "47", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2387", "205067"],
          ["6299905", "53339837", "0", "15", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2389", "205279"],
          ["6299466", "53341829", "0", "226", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2424", "208735"],
          ["6299378", "53345282", "0", "401", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2494", "215810"],
          ["6299302", "53345296", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "2495", "215900"],
          ["6299219", "53345310", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "2496", "215991"],
          ["6298613", "53345226", "0", "45", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt oneway=yes smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2503", "216701"],
          ["6298045", "53345098", "0", "44", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2510", "217413"],
          ["6297938", "53345035", "0", "10", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2512", "217573"],
          ["6298045", "53345098", "0", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2513", "217676"],
          ["6298861", "53349135", "0", "669", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2619", "228269"],
          ["6298903", "53349177", "0", "6", "1050", "0", "90", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=intermediate", "barrier=cattle_grid", "2620", "228370"],
          ["6298878", "53349289", "0", "14", "1050", "0", "12", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=intermediate", "barrier=cattle_grid", "2622", "228591"],
          ["6297645", "53352862", "-1", "407", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=intermediate", "barrier=cattle_grid", "2686", "234956"],
          ["6297618", "53352932", "-1", "8", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved smoothness=intermediate", "barrier=cattle_grid", "2687", "235087"],
          ["6296753", "53355616", "1", "306", "1050", "0", "3", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=intermediate", "", "2749", "241257"],
          ["6296559", "53356243", "0", "73", "1350", "0", "1", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "", "2760", "242403"],
          ["6295249", "53359560", "0", "492", "1350", "0", "88", "0", "0", "highway=unclassified surface=asphalt smoothness=good", "", "2841", "250523"],
          ["6299950", "53359558", "-1", "321", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "2884", "254768"],
          ["6299975", "53359559", "-1", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=forward", "2884", "254804"],
          ["6306190", "53359479", "0", "438", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "", "2961", "262471"],
          ["6319253", "53360868", "-1", "923", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "", "3116", "277953"],
          ["6321463", "53359569", "-2", "214", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "", "3143", "280669"],
          ["6321532", "53359566", "-2", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "3143", "280732"],
          ["6325323", "53359561", "0", "254", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_rcn=yes", "", "3191", "285507"],
          ["6329705", "53359817", "0", "299", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=shared_lane smoothness=good route_bicycle_rcn=yes", "", "3245", "290900"],
          ["6330954", "53359403", "1", "97", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "3264", "292751"],
          ["6333340", "53359182", "2", "164", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "3298", "296187"],
          ["6335519", "53359384", "1", "153", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "3322", "298559"],
          ["6335558", "53357568", "0", "203", "1150", "0", "119", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "3347", "301043"],
          ["6335479", "53357620", "0", "4", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "3347", "301081"],
          ["6334636", "53357015", "0", "89", "1050", "0", "75", "0", "0", "reversedirection=yes highway=path surface=paving_stones smoothness=intermediate", "", "3357", "302116"],
          ["6334206", "53356685", "0", "47", "5050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=fine_gravel smoothness=intermediate", "", "3390", "302226"],
          ["6335964", "53355570", "0", "207", "5050", "0", "254", "0", "0", "highway=path surface=fine_gravel smoothness=intermediate", "", "3530", "302404"],
          ["6335882", "53355007", "0", "85", "5050", "0", "146", "0", "0", "reversedirection=yes highway=path surface=fine_gravel smoothness=intermediate", "", "3587", "302404"],
          ["6335539", "53354618", "-1", "49", "1150", "0", "106", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "3592", "302985"],
          ["6335364", "53354628", "-1", "5", "1150", "0", "55", "0", "0", "highway=residential surface=asphalt smoothness=good", "", "3593", "303049"],
          ["6336980", "53354275", "-1", "109", "1150", "0", "2", "0", "0", "reversedirection=yes highway=residential surface=asphalt smoothness=good", "", "3605", "304266"],
          ["6336691", "53353904", "0", "48", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=excellent route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3612", "304913"],
          ["6342364", "53352282", "-1", "426", "1350", "0", "64", "0", "0", "highway=service surface=asphalt smoothness=excellent", "", "3669", "310625"],
          ["6342422", "53352352", "-1", "9", "5050", "0", "93", "0", "0", "reversedirection=yes highway=path surface=grass smoothness=bad", "barrier=bollard", "3675", "310625"],
          ["6342468", "53352407", "-1", "7", "5050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=grass smoothness=bad", "", "3679", "310625"],
          ["6368804", "53351563", "0", "1831", "5050", "0", "101", "0", "0", "highway=track tracktype=grade4 surface=grass foot=yes bicycle=yes smoothness=bad", "", "4975", "325786"],
          ["6368890", "53351509", "-8192", "10", "5050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=wood smoothness=good", "barrier=bollard foot=yes bicycle=yes motor_vehicle=no", "4982", "325795"],
          ["6368911", "53351494", "0", "3", "5050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=wood smoothness=good", "", "4984", "325795"],
          ["6369090", "53351419", "0", "16", "1050", "0", "7", "0", "0", "reversedirection=yes highway=path surface=asphalt smoothness=intermediate", "", "4985", "325960"],
          ["6370428", "53351080", "0", "98", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=paving_stones", "barrier=bollard", "5051", "325960"],
          ["6370650", "53350969", "0", "21", "1350", "0", "3", "0", "0", "reversedirection=yes highway=service surface=asphalt smoothness=intermediate", "", "5053", "326202"],
          ["6392005", "53350474", "0", "1714", "1350", "0", "64", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "", "5326", "353511"],
          ["6392165", "53350567", "0", "16", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "5328", "353677"],
          ["6392204", "53350591", "0", "4", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "", "5329", "353721"],
          ["6410839", "53346625", "-1", "1410", "1350", "0", "92", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=excellent", "", "5544", "375266"],
          ["6410940", "53346860", "-1", "3", "1350", "0", "82", "0", "0", "highway=unclassified surface=asphalt smoothness=good", "", "5544", "375315"],
          ["6410839", "53346625", "-1", "3", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "", "5545", "375342"],
          ["6410819", "53346438", "-1", "21", "1350", "0", "1", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=intermediate", "", "5547", "375553"],
          ["6422127", "53341812", "0", "1039", "1350", "0", "49", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "direction=backward", "5715", "392403"],
          ["6422210", "53341783", "0", "7", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "highway=crossing", "5717", "392531"],
          ["6425606", "53340683", "0", "261", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "", "5764", "397248"],
          ["6428143", "53340490", "-1", "176", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=forward", "5790", "399860"],
          ["6430677", "53340308", "-2", "172", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "5814", "402317"],
          ["6432421", "53343511", "-1", "415", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "5879", "408759"],
          ["6448867", "53350683", "0", "1728", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "6175", "438383"],
          ["6449843", "53351358", "-1", "114", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes smoothness=intermediate route_bicycle_rcn=yes", "", "6188", "439651"],
          ["6450475", "53351313", "-1", "47", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=yes smoothness=intermediate route_bicycle_rcn=yes", "", "6194", "440260"],
          ["6457983", "53351358", "-1", "504", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "6274", "448293"],
          ["6459772", "53351234", "-2", "160", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "", "6296", "450515"],
          ["6462600", "53351234", "0", "190", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt foot=yes bicycle=yes smoothness=good route_bicycle_rcn=yes", "", "6327", "453552"],
          ["6462617", "53351234", "0", "2", "1000", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes bicycle=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "6327", "453585"],
          ["6464104", "53351281", "0", "100", "1000", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes bicycle=yes smoothness=good route_bicycle_rcn=yes", "", "6345", "455409"],
          ["6467812", "53350096", "0", "316", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones bicycle=yes oneway=no smoothness=intermediate route_bicycle_rcn=yes", "", "6389", "459793"],
          ["6468132", "53350065", "0", "23", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "", "6393", "460138"],
          ["6468181", "53349925", "0", "17", "1000", "0", "0", "0", "0", "highway=unclassified surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "6395", "460393"],
          ["6468242", "53349897", "0", "6", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "6396", "460484"],
          ["6489328", "53341491", "-1", "1733", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt foot=yes bicycle=yes smoothness=good route_bicycle_rcn=yes", "", "6676", "488461"],
          ["6495034", "53332990", "-2", "1088", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes bicycle=yes smoothness=excellent route_bicycle_rcn=yes", "", "6854", "506266"],
          ["6495121", "53332986", "-2", "6", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "", "6854", "506324"],
          ["6502543", "53332600", "-1", "499", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=choker", "6930", "513905"],
          ["6502560", "53332600", "-1", "2", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=forward", "6931", "513938"],
          ["6509367", "53332789", "0", "462", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=chicane", "7016", "522511"],
          ["6510697", "53333649", "0", "196", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "7053", "526175"],
          ["6510777", "53333658", "0", "6", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=backward", "7054", "526272"],
          ["6511104", "53333644", "0", "22", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=forward", "7057", "526630"],
          ["6511063", "53333324", "0", "4", "5050", "0", "90", "0", "0", "reversedirection=yes highway=footway surface=paving_stones smoothness=intermediate", "", "7060", "526663"],
          ["6511104", "53333644", "0", "4", "5050", "0", "0", "0", "0", "highway=footway surface=paving_stones smoothness=intermediate", "highway=give_way direction=forward", "7063", "526663"],
          ["6511231", "53333633", "0", "9", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "7064", "526745"],
          ["6511344", "53333622", "0", "8", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=give_way direction=backward", "7064", "526821"],
          ["6511636", "53333589", "0", "20", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "7067", "527022"],
          ["6511725", "53333694", "0", "14", "1050", "0", "65", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good", "", "7068", "527166"],
          ["6511730", "53333791", "0", "11", "1050", "0", "8", "0", "0", "highway=unclassified surface=paving_stones bicycle=yes smoothness=good", "", "7069", "527284"],
          ["6511881", "53333825", "0", "12", "1650", "0", "78", "0", "0", "highway=secondary surface=asphalt smoothness=good", "highway=crossing bicycle=yes crossing=zebra", "7070", "527418"],
          ["6515110", "53334324", "1", "271", "1650", "0", "14", "0", "0", "highway=secondary surface=asphalt smoothness=good", "highway=crossing crossing=uncontrolled", "7107", "531103"],
          ["6515710", "53334344", "1", "41", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good", "highway=crossing crossing=uncontrolled", "7113", "531711"],
          ["6516946", "53334397", "1", "84", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good", "highway=crossing crossing=uncontrolled", "7126", "532959"],
          ["6517131", "53334406", "1", "13", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good", "highway=crossing crossing=uncontrolled", "7128", "533153"],
          ["6519385", "53334520", "0", "153", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good", "railway=level_crossing", "7149", "535248"],
          ["6522026", "53334723", "1", "183", "1650", "0", "1", "0", "0", "highway=secondary surface=asphalt smoothness=good", "", "7182", "538561"],
          ["6523118", "53334670", "0", "75", "1050", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good", "traffic_calming=table", "7191", "539472"],
          ["6523316", "53334672", "0", "14", "1050", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good", "traffic_calming=table", "7192", "539620"],
          ["6524557", "53334794", "0", "85", "1050", "0", "1", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good", "traffic_calming=table", "7203", "540666"],
          ["6526534", "53334930", "0", "135", "1050", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good", "traffic_calming=table", "7222", "542606"],
          ["6528289", "53335439", "0", "132", "1150", "0", "11", "0", "0", "highway=residential surface=paving_stones bicycle=yes smoothness=intermediate", "", "7242", "544622"],
          ["6528331", "53335437", "0", "3", "5050", "0", "35", "0", "0", "reversedirection=yes highway=footway", "barrier=cycle_barrier foot=yes", "7245", "544642"],
          ["6529583", "53335496", "-1", "85", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "barrier=cycle_barrier foot=yes", "7303", "544894"],
          ["6529632", "53335499", "-1", "4", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "", "7305", "544894"],
          ["6529679", "53335564", "-1", "8", "1150", "0", "46", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "7306", "544982"],
          ["6530337", "53335485", "-1", "58", "1150", "0", "48", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate", "", "7313", "545662"],
          ["6530380", "53335491", "-1", "3", "5050", "0", "84", "0", "0", "highway=footway", "barrier=cycle_barrier foot=yes", "7315", "545667"],
          ["6531603", "53335744", "-2", "88", "5050", "0", "0", "0", "0", "highway=footway", "barrier=cycle_barrier foot=yes", "7375", "545681"],
          ["6531743", "53335775", "-2", "11", "5050", "0", "0", "0", "0", "highway=footway", "traffic_calming=table", "7382", "545681"],
          ["6531210", "53336283", "-2", "68", "1150", "0", "102", "0", "0", "reversedirection=yes highway=residential surface=paving_stones bicycle=yes smoothness=intermediate", "traffic_calming=table", "7390", "546401"],
          ["6531628", "53336536", "-2", "40", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=excellent route_bicycle_rcn=yes", "", "7394", "546890"],
          ["6531144", "53337817", "-1", "196", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "7431", "550504"],
          ["6530967", "53338252", "-1", "50", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "7439", "551368"],
          ["6531066", "53338574", "-1", "37", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "7444", "551836"],
          ["6531069", "53338583", "-1", "2", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt bicycle=yes smoothness=good route_bicycle_rcn=yes", "", "7444", "551856"],
          ["6546341", "53337838", "-1", "1037", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=excellent route_bicycle_rcn=yes", "", "7609", "568383"],
          ["6583795", "53336368", "-1", "2563", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "", "8035", "610909"],
          ["6585178", "53336174", "-1", "96", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "8050", "612475"],
          ["6587630", "53336397", "0", "169", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "8086", "616015"],
          ["6587698", "53336398", "0", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "8087", "616123"],
          ["6587669", "53336484", "0", "2", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "8087", "616165"],
          ["6587698", "53336398", "0", "2", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "8087", "616184"],
          ["6588273", "53335546", "1", "124", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "8103", "617768"],
          ["6590717", "53335423", "1", "175", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones oneway=yes oneway:bicycle=no smoothness=good route_bicycle_rcn=yes", "", "8124", "619801"],
          ["6590726", "53335450", "1", "4", "1000", "0", "0", "0", "0", "highway=unclassified surface=sett smoothness=bad route_bicycle_rcn=yes", "", "8124", "619854"],
          ["6590782", "53335623", "1", "20", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved smoothness=intermediate route_bicycle_rcn=yes", "", "8127", "620126"],
          ["6591146", "53335787", "0", "36", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "", "8132", "620611"],
          ["6593527", "53335495", "-1", "170", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "", "8153", "622774"],
          ["6593565", "53335498", "-1", "3", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "8154", "622813"],
          ["6601180", "53336673", "-1", "532", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "8230", "630422"],
          ["6627166", "53338339", "-2", "1812", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "", "8531", "660576"],
          ["6627785", "53339081", "-3", "103", "1450", "0", "85", "0", "0", "highway=tertiary surface=asphalt cycleway=no smoothness=good", "", "8546", "662086"],
          ["6628473", "53339615", "-2", "79", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "8555", "662989"],
          ["6628723", "53339864", "-2", "33", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=no smoothness=good route_bicycle_rcn=yes", "", "8560", "663471"],
          ["6634984", "53339782", "-3", "436", "5650", "0", "91", "0", "0", "highway=secondary bicycle=no", "", "8856", "664842"],
          ["6635726", "53339820", "-2", "52", "5650", "0", "11", "0", "0", "highway=secondary bicycle=no oneway=yes", "", "8892", "665002"],
          ["6635832", "53339523", "-2", "34", "1450", "0", "89", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no smoothness=good", "", "8896", "665420"],
          ["6637763", "53339710", "-1", "132", "1350", "0", "84", "0", "0", "highway=unclassified surface=concrete smoothness=intermediate", "", "8914", "667265"],
          ["6643869", "53339437", "-1", "431", "1050", "0", "14", "0", "0", "highway=cycleway surface=concrete smoothness=intermediate", "", "8979", "673680"],
          ["6643928", "53339630", "-1", "4", "5050", "0", "91", "0", "0", "reversedirection=yes highway=path surface=grass smoothness=very_bad", "", "8981", "673730"],
          ["6643869", "53339437", "-1", "4", "5050", "0", "0", "0", "0", "highway=path surface=grass smoothness=very_bad", "", "8984", "673730"],
          ["6646929", "53340277", "-1", "267", "1050", "0", "153", "0", "0", "highway=cycleway surface=concrete smoothness=intermediate", "", "9020", "677325"],
          ["6648557", "53340009", "-1", "119", "1150", "0", "10", "0", "0", "highway=residential surface=concrete smoothness=intermediate", "", "9040", "679371"],
          ["6648595", "53339970", "0", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes motorcycle=yes horse=yes", "9042", "679485"],
          ["6648714", "53339872", "0", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes motorcycle=yes horse=yes", "9044", "679748"],
          ["6650549", "53339020", "-1", "158", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "9064", "681770"],
          ["6653753", "53338708", "-1", "237", "1450", "0", "13", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no smoothness=excellent", "", "9100", "685307"],
          ["6669755", "53335667", "-1", "1128", "1050", "0", "83", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent", "", "9279", "703248"],
          ["6672678", "53335200", "0", "203", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "9319", "707274"],
          ["6673671", "53335045", "0", "70", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes oneway=no smoothness=excellent route_bicycle_rcn=yes", "", "9333", "708637"],
          ["6674148", "53334949", "0", "35", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "9340", "709300"],
          ["6678477", "53334302", "-1", "304", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "9385", "713862"],
          ["6693380", "53331973", "-1", "1062", "1000", "0", "0", "0", "0", "highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unknown", "9562", "731561"],
          ["6703321", "53329579", "-2", "752", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "9685", "743874"],
          ["6703639", "53329456", "-2", "30", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "9691", "744392"],
          ["6703669", "53329380", "-2", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "9692", "744547"],
          ["6703428", "53329389", "-1", "14", "1650", "0", "110", "0", "0", "highway=secondary foot=use_sidepath bicycle=use_sidepath", "", "9695", "744792"],
          ["6703669", "53329380", "-2", "14", "1650", "0", "1", "0", "0", "reversedirection=yes highway=secondary foot=use_sidepath bicycle=use_sidepath", "highway=crossing bicycle=yes crossing=unmarked", "9696", "744919"],
          ["6703682", "53329336", "-2", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cycle_barrier foot=yes bicycle=yes", "9696", "744967"],
          ["6698554", "53324460", "-1", "645", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "9797", "754995"],
          ["6697740", "53323686", "-1", "103", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "9813", "756678"],
          ["6697069", "53323049", "-1", "7", "1350", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good", "", "9815", "756787"]
        ],
        "times": [0, 2.039, 7.752, 10.933, 13.749, 15.691, 17.535, 20.737, 38.834, 59.14, 77.726, 87.889, 97.317, 102.743, 112.379, 115.185, 117.262, 118.547, 121.637, 122.493, 124.204, 127.446, 129.999, 131.868, 133.941, 137.962, 141.33, 143.677, 145.919, 148.504, 149.527, 150.856, 152.264, 153.84, 158.031, 159.67, 161.911, 164.064, 166.263, 171.272, 174.245, 176.364, 179.441, 180.373, 181.31, 182.408, 187.487, 189.735, 192.32, 197.206, 203.465, 208.802, 213.763, 215.638, 217.171, 224.733, 225.709, 226.849, 227.665, 230.278, 232.013, 235.122, 240.799, 248.676, 254.3, 269.276, 272.18, 274.759, 275.325, 276.337, 277.655, 278.488, 279.337, 280.381, 281.444, 288.071, 291.589, 295.332, 302.526, 308.269, 313.438, 325.871, 351.956, 375.677, 445.653, 451.302, 456.471, 529.524, 554.602, 582.525, 596.123, 609.14, 609.235, 613.658, 618.253, 627.598, 631.375, 642.094, 650.43, 651.821, 653.52, 655.687, 677.798, 681.093, 682.084, 683.242, 688.381, 690.376, 692.54, 695.048, 697.161, 701.243, 705.441, 707.491, 709.689, 711.332, 712.69, 714.061, 730.106, 743.973, 744.79, 745.638, 746.804, 759.902, 776.464, 780.216, 793.386, 804.871, 806.994, 817.63, 820.796, 827.771, 839.437, 844.981, 850.811, 863.246, 864.824, 874.589, 878.996, 889.44, 913.548, 918.172, 925.017, 937.673, 951.757, 955.935, 969.186, 997.987, 1002.441, 1005.752, 1009.57, 1013.495, 1015.719, 1017.677, 1020.737, 1024.163, 1028.754, 1037.517, 1062.733, 1066.073, 1069.063, 1076.27, 1082.782, 1088.512, 1091.589, 1092.167, 1093.596, 1095.196, 1100.62, 1102.453, 1130.244, 1135.605, 1181.155, 1182.535, 1183.503, 1184.959, 1186.179, 1187.1, 1188.408, 1190.784, 1191.926, 1192.576, 1193.791, 1279.776, 1282.149, 1282.945, 1283.423, 1284.702, 1285.344, 1300.272, 1310.233, 1314.642, 1318.916, 1342.087, 1369.226, 1371.921, 1373.703, 1374.944, 1377.392, 1401.891, 1408.002, 1412.768, 1415.217, 1417.176, 1419.799, 1422.9, 1429.209, 1523.107, 1525.565, 1531.843, 1535.704, 1539.365, 1542.939, 1544.791, 1546.991, 1551.58, 1555.141, 1557.528, 1558.648, 1559.611, 1561.278, 1562.808, 1564.262, 1566.032, 1567.677, 1570.84, 1572.227, 1573.781, 1575.55, 1584.474, 1585.565, 1586.9, 1588.783, 1590.047, 1591.316, 1658.795, 1661.565, 1664.117, 1666.429, 1671.322, 1680.044, 1699.445, 1699.645, 1707.367, 1715.556, 1721.878, 1726.923, 1729.269, 1732.902, 1733.28, 1733.464, 1734.025, 1734.6, 1736.445, 1738, 1738.647, 1739.642, 1741.015, 1743.293, 1750.939, 1754.323, 1755.862, 1757.573, 1760.935, 1765.307, 1767.616, 1771.161, 1774.15, 1780.311, 1780.879, 1792.481, 1802.65, 1821.786, 1828.03, 1858.038, 1861.195, 1868, 1869.772, 1888.12, 1890.12, 1906.756, 1908.05, 1980.082, 1981.799, 1982.533, 1983.629, 1986.518, 1988.188, 1990.295, 1993.614, 1995.843, 1999.092, 2006.214, 2008.587, 2010.085, 2011.856, 2015.129, 2072.958, 2081.399, 2089.035, 2089.4, 2089.584, 2090.817, 2092.061, 2093.14, 2094.143, 2095.88, 2097.4, 2098.047, 2099.157, 2099.753, 2100.052, 2100.652, 2101.708, 2102.618, 2104.302, 2109.357, 2115.723, 2120.397, 2125.372, 2130.826, 2131.01, 2131.477, 2131.953, 2132.341, 2132.736, 2133.576, 2134.44, 2135.105, 2136.66, 2149.522, 2174.729, 2181.864, 2185.459, 2186.373, 2189.273, 2189.845, 2199.016, 2199.414, 2199.876, 2204.027, 2206.501, 2211.93, 2213.67, 2214.796, 2216.08, 2218.042, 2219.851, 2222.249, 2224.049, 2225.746, 2228.789, 2229.823, 2234.109, 2236.024, 2236.725, 2237.205, 2239.624, 2240.288, 2243.895, 2244.613, 2246.21, 2250.131, 2250.632, 2252.09, 2253.121, 2253.703, 2256.081, 2258.582, 2259.353, 2260.004, 2264.91, 2268.427, 2269.344, 2275.711, 2276.608, 2277.36, 2284.093, 2285.232, 2286.004, 2296.501, 2297.067, 2297.778, 2298.241, 2298.618, 2306.545, 2309.489, 2318.943, 2319.639, 2320.384, 2320.983, 2322.106, 2323.393, 2324.685, 2326.067, 2334.817, 2336.374, 2344.362, 2348.657, 2351.627, 2352.258, 2353.047, 2353.792, 2355.142, 2357.753, 2360.2, 2362.607, 2366.438, 2378.435, 2380.618, 2386.923, 2387.367, 2389.487, 2390.165, 2392.931, 2399.561, 2424.042, 2442.537, 2444.603, 2445.562, 2446.844, 2448.053, 2448.661, 2449.272, 2450.038, 2450.808, 2457.07, 2463.701, 2469.855, 2478.436, 2485.836, 2488, 2491.969, 2494.792, 2495.697, 2496.606, 2497.036, 2497.756, 2498.992, 2500.86, 2503.701, 2505.207, 2506.88, 2508.767, 2510.827, 2512.421, 2512.513, 2513.452, 2517.426, 2523.045, 2587.769, 2590.82, 2592.491, 2594.124, 2596.436, 2603.934, 2607.975, 2611.16, 2616.024, 2619.38, 2620.387, 2621.016, 2622.595, 2686.252, 2687.555, 2712.569, 2714.809, 2749.258, 2757.836, 2760.708, 2776.908, 2783.166, 2818.376, 2828.647, 2841.896, 2844.79, 2846.501, 2850.487, 2855.103, 2859.769, 2862.329, 2864.874, 2870.602, 2876.852, 2884.347, 2884.707, 2894.781, 2899.761, 2905.268, 2911.81, 2917.786, 2921.482, 2924.772, 2932.354, 2934.879, 2937.391, 2939.671, 2941.919, 2945.653, 2947.002, 2950.913, 2952.499, 2953.651, 2956.454, 2961.37, 2964.89, 2972.652, 2990.984, 2999.381, 3005.79, 3012.126, 3015.395, 3019.196, 3031.783, 3043.124, 3061.737, 3065.768, 3070.325, 3073.413, 3075.761, 3079.085, 3091.829, 3102.501, 3105.947, 3115.389, 3116.19, 3116.653, 3118.776, 3120.699, 3122.697, 3125.173, 3128.028, 3130.703, 3133.766, 3136.217, 3138.752, 3143.344, 3143.978, 3155.296, 3191.718, 3205.764, 3209.674, 3225.076, 3229.039, 3235.01, 3236.506, 3244.255, 3245.648, 3246.343, 3248.942, 3254.243, 3258.066, 3264.155, 3267.166, 3279.704, 3285.522, 3292.967, 3298.507, 3305.978, 3308.733, 3311.316, 3312.546, 3314.25, 3322.229, 3323.1, 3324.105, 3326.781, 3333.262, 3344.202, 3346.571, 3347.059, 3347.442, 3348.257, 3357.79, 3390.469, 3412.055, 3414.135, 3458.221, 3462.273, 3506.202, 3510.371, 3527.113, 3530.954, 3543.271, 3548.479, 3560.992, 3570.917, 3575.587, 3587.015, 3592.828, 3593.467, 3593.93, 3595.978, 3605.636, 3606.957, 3610.415, 3611.354, 3612.099, 3614.481, 3615.029, 3615.699, 3617.787, 3618.629, 3638.251, 3645.451, 3660.217, 3667.794, 3669.211, 3675.062, 3679.646, 3689.559, 3704.29, 3715.125, 3767.337, 3921.174, 3946.366, 3985.4, 4014.489, 4031.289, 4041.125, 4065.623, 4071.246, 4076.876, 4086.744, 4099.458, 4114.205, 4130.988, 4137.303, 4145.034, 4149.961, 4154.894, 4202.304, 4255.646, 4283.546, 4310.262, 4327.21, 4344.335, 4368.968, 4384.729, 4391.789, 4411.13, 4431.358, 4471.962, 4483.641, 4494.006, 4504.506, 4540.437, 4585.18, 4595.334, 4604.022, 4617.973, 4637.842, 4682.269, 4706.821, 4730.366, 4760.994, 4791.119, 4930.8, 4937.236, 4942.242, 4947.963, 4955.828, 4960.833, 4975.848, 4976.563, 4982.381, 4984.332, 4985.248, 4985.982, 5020.205, 5029.769, 5051.499, 5052.262, 5053.081, 5053.917, 5054.646, 5055.388, 5056.778, 5135.398, 5139.308, 5151.622, 5154.444, 5171.851, 5177.758, 5232.166, 5246.919, 5275.033, 5281.216, 5284.011, 5286.616, 5289.554, 5291.963, 5293.68, 5293.864, 5294.807, 5296.396, 5297.122, 5298.411, 5299.076, 5301.123, 5305.557, 5308.198, 5309.422, 5310.528, 5316.116, 5317.76, 5319.151, 5319.773, 5320.709, 5321.493, 5324.623, 5325.943, 5326.933, 5327.339, 5328.596, 5329.027, 5329.908, 5330.773, 5333.96, 5334.754, 5335.528, 5336.839, 5344.362, 5349.177, 5357.794, 5360.256, 5361.079, 5384.403, 5387.497, 5389.713, 5400.656, 5402.243, 5405.107, 5420.567, 5424.302, 5427.57, 5430.197, 5437.502, 5439.387, 5440.918, 5442.393, 5443.761, 5445.804, 5449.033, 5461.764, 5471.13, 5481.006, 5503.375, 5507.594, 5509.165, 5513.331, 5522.756, 5529.279, 5535.028, 5540.113, 5544.465, 5544.952, 5545.228, 5547.333, 5547.648, 5547.966, 5548.396, 5552.7, 5554.882, 5565.284, 5572.576, 5575.476, 5578.234, 5579.7, 5595.039, 5598.017, 5599.586, 5601.441, 5603.279, 5605.101, 5620.305, 5621.411, 5622.046, 5623.159, 5623.797, 5624.917, 5631.706, 5639.661, 5644.46, 5647.532, 5650.086, 5652.805, 5654.671, 5656.027, 5658.555, 5661.593, 5667.25, 5705.659, 5715.46, 5715.826, 5717.104, 5723.57, 5727.278, 5733.731, 5749.52, 5759.76, 5762.886, 5764.271, 5766.7, 5776.055, 5780.14, 5786.632, 5790.107, 5790.382, 5796.369, 5801.453, 5808.26, 5811.404, 5814.946, 5818.476, 5819.283, 5820.254, 5821.119, 5821.489, 5821.852, 5822.313, 5822.786, 5824.058, 5825.5, 5826.908, 5827.691, 5832.187, 5835.72, 5839.595, 5844.918, 5866.219, 5879.351, 5885.992, 5889.207, 5894.002, 5895.571, 5897.166, 5901.248, 5904.752, 5909.024, 5917.286, 5919.229, 5921.161, 5923.258, 5926.907, 5932.938, 5941.816, 5943.221, 5944.806, 5949.166, 5951.317, 5952.92, 5954.162, 5955.927, 5957.333, 5958.56, 5963.259, 5971.865, 5979.299, 5980.115, 5980.931, 5981.912, 5983.715, 5995.778, 5997.495, 5998.827, 6003.562, 6004.595, 6005.637, 6006.914, 6008.357, 6012.299, 6013.667, 6014.861, 6080.186, 6088.822, 6092.02, 6095.162, 6109.92, 6122.924, 6125.24, 6134.05, 6135.443, 6138.702, 6141.014, 6143.219, 6148.584, 6150.689, 6162.878, 6166.572, 6172.248, 6174.282, 6175.565, 6177.386, 6178.472, 6178.739, 6179.267, 6182.611, 6185.776, 6186.211, 6186.542, 6188.246, 6193.793, 6194.337, 6195.715, 6261.323, 6263.301, 6268.148, 6274.667, 6276.154, 6289.74, 6290.485, 6290.963, 6291.353, 6293.551, 6295.658, 6296.887, 6317.429, 6327.257, 6327.591, 6345.823, 6346.88, 6348.284, 6350.895, 6352.186, 6354.336, 6357.215, 6357.307, 6359.291, 6360.449, 6368.249, 6372.274, 6376.411, 6379.442, 6381.959, 6384.361, 6385.165, 6388.213, 6388.675, 6389.664, 6390.902, 6393.111, 6394.456, 6395.662, 6396.573, 6399.623, 6404.12, 6406.289, 6409.099, 6418.096, 6423.67, 6434.462, 6446.917, 6472.322, 6479.274, 6483.711, 6486.92, 6489.971, 6494.51, 6500.653, 6505.847, 6514.805, 6520.096, 6524.591, 6529.399, 6534.863, 6540.472, 6549.582, 6556.889, 6567.835, 6569.813, 6572.591, 6578.746, 6593.634, 6602.457, 6613.025, 6627.01, 6647.346, 6659.936, 6676.32, 6686.782, 6691.478, 6695.705, 6712.066, 6726.872, 6729.909, 6731.651, 6733.571, 6744.016, 6749.017, 6753.846, 6757.884, 6760.575, 6766.125, 6769.151, 6772.009, 6797.554, 6851.148, 6853.333, 6854.363, 6854.945, 6856.461, 6871.09, 6889.641, 6895.823, 6909.602, 6918.628, 6924.587, 6930.74, 6931.073, 6932.497, 6942.473, 6948.043, 6960.642, 6961.73, 6985.154, 6990.474, 6992.183, 7002.574, 7004.506, 7007.127, 7016.801, 7035.007, 7035.765, 7037.083, 7038.481, 7039.178, 7040.396, 7041.09, 7046.273, 7047.477, 7048.507, 7050.221, 7053.438, 7054.408, 7057.983, 7060.831, 7063.411, 7064.235, 7064.995, 7067.001, 7068.439, 7069.622, 7070.287, 7070.964, 7071.655, 7072.715, 7082.158, 7082.847, 7083.733, 7087.796, 7089.264, 7090.899, 7092.867, 7094.84, 7096.817, 7097.478, 7097.847, 7099.035, 7101.791, 7103.84, 7105.8, 7107.803, 7113.889, 7114.956, 7123.442, 7126.363, 7127.553, 7128.302, 7134.546, 7141.696, 7144.393, 7148.205, 7149.252, 7151.18, 7152.955, 7160.78, 7170.668, 7173.273, 7176.404, 7178.253, 7180.14, 7182.376, 7187.251, 7187.435, 7191.491, 7192.97, 7196.263, 7202.875, 7203.417, 7205.07, 7212.448, 7215.625, 7219.424, 7222.808, 7234.287, 7241.88, 7242.97, 7245.094, 7266.203, 7276.791, 7283.259, 7303.012, 7305.68, 7306.561, 7307.867, 7310.409, 7310.772, 7311.385, 7311.757, 7313.354, 7315.435, 7331.318, 7352.578, 7375.645, 7377.698, 7378.383, 7382.904, 7386.844, 7390.103, 7394.99, 7397.223, 7399.375, 7400.15, 7400.771, 7401.769, 7425.478, 7426.518, 7427.555, 7431.124, 7439.766, 7442.337, 7444.445, 7444.646, 7445.361, 7446.272, 7447.486, 7448.008, 7450.323, 7452.703, 7462.409, 7469.121, 7474.246, 7478.949, 7486.784, 7497.47, 7518.327, 7536.479, 7559.372, 7570.671, 7600.542, 7609.907, 7621.246, 7632.881, 7685.062, 7695.499, 7701.843, 7709.357, 7712.963, 7722.819, 7745.929, 7767.195, 7781.651, 7788.855, 7796.1, 7803.697, 7810.416, 7815.888, 7827.811, 7836.137, 7857.722, 7865.566, 7879.203, 7889.538, 7896.127, 7897.71, 7899.462, 7900.335, 7901.207, 7902.508, 7903.433, 7922.51, 7950.774, 7953.625, 7956.644, 7959.161, 7961.13, 7963.264, 7965.559, 7968.855, 7970.673, 7972.495, 7975.463, 7976.566, 7978.627, 7980.327, 7982.681, 7990.668, 7999.719, 8003.825, 8010.641, 8014.677, 8017.585, 8031.069, 8033.829, 8035.133, 8038.899, 8041.366, 8045.327, 8048.448, 8050.799, 8060.876, 8073.03, 8076.432, 8079.758, 8081.495, 8086.188, 8087.267, 8087.694, 8087.878, 8088.756, 8089.489, 8091.08, 8094.756, 8095.877, 8099.52, 8100.059, 8102.97, 8103.71, 8104.306, 8105.773, 8110.217, 8112.488, 8114.622, 8124.039, 8124.571, 8127.293, 8128.834, 8130.045, 8132.137, 8135.739, 8139.68, 8142.24, 8145.572, 8147.354, 8148.796, 8150.585, 8153.76, 8154.154, 8160.208, 8166.666, 8171.752, 8180.279, 8183.484, 8187.463, 8197.387, 8198.754, 8202.1, 8210.305, 8218.366, 8221.22, 8230.228, 8260.808, 8263.695, 8267.764, 8271.59, 8280.859, 8284.56, 8288.506, 8291.563, 8294.46, 8299.445, 8303.861, 8309.023, 8315.721, 8318.085, 8329.967, 8340.789, 8342.67, 8344.719, 8347.721, 8350.842, 8355.022, 8360.199, 8365.255, 8370.628, 8372.738, 8374.878, 8376.889, 8379.076, 8384.109, 8387.11, 8390.145, 8393.182, 8396.274, 8399.729, 8403.55, 8408.386, 8412.292, 8415.239, 8416.883, 8421.996, 8424.148, 8428.964, 8434.126, 8438.131, 8453.696, 8458.055, 8462.398, 8476.656, 8481.978, 8489.225, 8507.711, 8515.972, 8520.439, 8524.319, 8526.943, 8531.74, 8533.154, 8534.259, 8535.602, 8537.868, 8541.602, 8542.741, 8543.895, 8545.061, 8546.833, 8547.879, 8548.326, 8548.783, 8549.727, 8555.867, 8560.684, 8567.019, 8578.301, 8582.141, 8607.283, 8617.196, 8625.141, 8634.572, 8645.528, 8693.258, 8756.047, 8779.824, 8786.884, 8856.987, 8862.622, 8871.155, 8872.59, 8892.321, 8896.493, 8909.037, 8911.219, 8914.951, 8919.354, 8921.71, 8925.132, 8929.638, 8937.028, 8938.052, 8938.346, 8939.529, 8942.775, 8945.311, 8946.406, 8946.961, 8947.8, 8957.654, 8964.562, 8967.593, 8971.707, 8979.091, 8981.988, 8984.546, 8986.132, 8986.889, 8987.572, 8988.376, 8988.771, 8989.172, 8990.308, 8990.947, 8991.71, 8992.783, 8995.747, 8997.529, 9000.855, 9004.595, 9007.812, 9008.522, 9009.054, 9009.938, 9013.244, 9014.488, 9014.957, 9015.583, 9017.629, 9020.489, 9021.769, 9023.053, 9024.987, 9027.743, 9029.999, 9032.246, 9038.619, 9039.874, 9040.945, 9042.087, 9044.72, 9045.65, 9049.375, 9051.294, 9052.614, 9058.509, 9064.938, 9070.293, 9071.863, 9073.65, 9077.748, 9080.9, 9082.219, 9086.918, 9095.95, 9097.173, 9097.87, 9099.088, 9100.303, 9101.342, 9101.86, 9102.552, 9104.104, 9104.965, 9106.684, 9127.84, 9142.211, 9150.538, 9171.628, 9197.859, 9206.287, 9216.337, 9225.938, 9251.112, 9279.7, 9317.86, 9319.956, 9321.696, 9326.202, 9333.589, 9337.032, 9340.217, 9351.782, 9384.51, 9385.83, 9386.986, 9387.483, 9392.289, 9403.283, 9408.13, 9426.932, 9428.765, 9430.099, 9431.935, 9437.944, 9441.64, 9444.556, 9445.857, 9448.144, 9452.845, 9458.876, 9462.984, 9468.271, 9471.553, 9474.562, 9478.082, 9485.479, 9490.848, 9497.631, 9501.917, 9513.942, 9519.995, 9525.076, 9534.748, 9539.025, 9550.2, 9555.801, 9557.699, 9560.249, 9561.371, 9562.819, 9565.244, 9567.193, 9582.51, 9593.587, 9602.305, 9604.755, 9611.663, 9614.806, 9621.447, 9624.112, 9626.446, 9628.95, 9640.492, 9647.195, 9652.146, 9656.09, 9661.688, 9665.642, 9668.21, 9673.641, 9675.426, 9682.995, 9685.951, 9687.337, 9688.719, 9690.098, 9691.13, 9692.676, 9694.391, 9695.123, 9695.48, 9696.399, 9696.874, 9697.261, 9697.952, 9698.458, 9797.159, 9807.745, 9813.988, 9815.077]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [6.260067, 53.412440, -0.25],
          [6.260178, 53.412256, -0.5],
          [6.260445, 53.411845, 0.0],
          [6.260607, 53.411650, 0.0],
          [6.260784, 53.411500, 0.0],
          [6.260850, 53.411389, 0.0],
          [6.260890, 53.411278, 0.0],
          [6.260937, 53.411088, 0.0],
          [6.261649, 53.409976, -0.75],
          [6.262231, 53.409107, 0.0],
          [6.262873, 53.408101, -0.5],
          [6.263257, 53.407664, 0.0],
          [6.263696, 53.407244, -0.25],
          [6.264015, 53.406988, -0.75],
          [6.264706, 53.406518, -1.5],
          [6.264854, 53.406372, -1.5],
          [6.264910, 53.406269, -1.25],
          [6.264922, 53.406205, -1.25],
          [6.264913, 53.406049, -1.0],
          [6.264934, 53.406010, -1.0],
          [6.265029, 53.405948, -1.0],
          [6.265266, 53.405857, -1.0],
          [6.265436, 53.405769, -1.0],
          [6.265451, 53.405678, -1.0],
          [6.265350, 53.405580, -1.25],
          [6.265111, 53.405418, -1.25],
          [6.264905, 53.405265, -1.5],
          [6.264777, 53.405150, -1.75],
          [6.264681, 53.405030, -1.75],
          [6.264513, 53.404912, -2.0],
          [6.264439, 53.404868, -2.0],
          [6.264369, 53.404808, -2.0],
          [6.264331, 53.404728, -2.25],
          [6.264340, 53.404637, -2.25],
          [6.264519, 53.404398, -2.5],
          [6.264569, 53.404299, -2.75],
          [6.264565, 53.404164, -2.75],
          [6.264499, 53.404040, -2.75],
          [6.264411, 53.403917, -2.75],
          [6.264136, 53.403657, -3.0],
          [6.263917, 53.403540, -3.0],
          [6.263751, 53.403474, -3.0],
          [6.263485, 53.403396, -3.0],
          [6.263454, 53.403349, -3.0],
          [6.263427, 53.403302, -3.0],
          [6.263435, 53.403241, -3.0],
          [6.263563, 53.402968, -3.0],
          [6.263575, 53.402850, -3.0],
          [6.263567, 53.402711, -3.0],
          [6.263478, 53.402448, -3.0],
          [6.263285, 53.402147, -2.75],
          [6.263094, 53.401902, -2.75],
          [6.262863, 53.401685, -2.75],
          [6.262733, 53.401628, -2.75],
          [6.262617, 53.401593, -2.75],
          [6.261914, 53.401546, -3.0],
          [6.261837, 53.401527, -3.0],
          [6.261763, 53.401491, -3.0],
          [6.261720, 53.401459, -3.0],
          [6.261637, 53.401335, -2.75],
          [6.261618, 53.401248, -2.75],
          [6.261640, 53.401094, -2.75],
          [6.261734, 53.400785, -3.0],
          [6.261779, 53.400362, -3.0],
          [6.261781, 53.400059, -3.0],
          [6.261503, 53.399418, -2.0],
          [6.261563, 53.399417, -2.0],
          [6.261503, 53.399418, -2.0],
          [6.261472, 53.399373, -2.0],
          [6.261330, 53.399364, -1.75],
          [6.261150, 53.399365, -1.5],
          [6.261058, 53.399347, -1.25],
          [6.260988, 53.399313, -1.25],
          [6.260915, 53.399256, -1.0],
          [6.260886, 53.399194, -1.0],
          [6.260884, 53.398810, -0.5],
          [6.260850, 53.398626, -0.25],
          [6.260700, 53.398463, 0.0],
          [6.260375, 53.398160, 0.0],
          [6.260468, 53.398118, 0.0],
          [6.260375, 53.398160, 0.0],
          [6.260159, 53.398266, 0.0],
          [6.259780, 53.398524, 0.0],
          [6.259503, 53.398791, -0.25],
          [6.258415, 53.399475, -1.75],
          [6.258512, 53.399511, -1.75],
          [6.258415, 53.399475, -1.75],
          [6.259503, 53.398791, -0.25],
          [6.259780, 53.398524, 0.0],
          [6.260159, 53.398266, 0.0],
          [6.260375, 53.398160, 0.0],
          [6.259528, 53.397692, 0.0],
          [6.259526, 53.397691, 0.25],
          [6.258963, 53.397566, 0.75],
          [6.258467, 53.397423, 0.75],
          [6.257730, 53.396982, 0.5],
          [6.257385, 53.396887, 0.5],
          [6.256645, 53.396453, 0.5],
          [6.255929, 53.396066, -0.75],
          [6.255901, 53.395980, -0.75],
          [6.255917, 53.395877, -0.75],
          [6.255865, 53.395749, -0.75],
          [6.253898, 53.395115, -1.0],
          [6.253703, 53.394988, -1.0],
          [6.253660, 53.394942, -1.0],
          [6.253672, 53.394885, -1.0],
          [6.253975, 53.394681, -1.0],
          [6.254060, 53.394586, -1.0],
          [6.254039, 53.394477, -1.0],
          [6.253956, 53.394343, -1.25],
          [6.253809, 53.394249, -1.75],
          [6.253432, 53.394099, -2.25],
          [6.253108, 53.393959, -1.75],
          [6.252919, 53.393946, -1.75],
          [6.252753, 53.393903, -1.5],
          [6.252648, 53.393969, -2.0],
          [6.252535, 53.394012, -2.0],
          [6.252431, 53.393972, -2.0],
          [6.252658, 53.393829, -1.0],
          [6.252431, 53.393972, -2.0],
          [6.252535, 53.394012, -2.0],
          [6.252648, 53.393969, -2.0],
          [6.252753, 53.393903, -1.5],
          [6.253469, 53.393448, 1.0],
          [6.254187, 53.393009, 2.5],
          [6.254429, 53.392931, 2.25],
          [6.255142, 53.392512, 2.5],
          [6.256025, 53.392130, 1.75],
          [6.256215, 53.392099, 1.5],
          [6.256942, 53.391636, 1.25],
          [6.257312, 53.391620, 0.25],
          [6.257866, 53.391282, 0.0],
          [6.258288, 53.390750, 1.0],
          [6.258720, 53.390645, 1.0],
          [6.259179, 53.390576, 1.25],
          [6.260286, 53.390537, 1.0],
          [6.260413, 53.390579, 0.75],
          [6.261783, 53.391043, 0.25],
          [6.262012, 53.390865, 0.75],
          [6.262908, 53.391149, 0.25],
          [6.264831, 53.392002, -0.25],
          [6.265246, 53.392002, -0.25],
          [6.265748, 53.391827, 0.0],
          [6.266612, 53.391283, -0.75],
          [6.268017, 53.390745, -2.0],
          [6.268304, 53.390587, -2.0],
          [6.268926, 53.389964, -2.0],
          [6.270225, 53.388622, -2.0],
          [6.270451, 53.388452, -1.75],
          [6.270678, 53.388346, -2.0],
          [6.270905, 53.388200, -2.0],
          [6.271120, 53.388025, -2.25],
          [6.271190, 53.387914, -2.25],
          [6.271258, 53.387807, -2.5],
          [6.271329, 53.387633, -2.5],
          [6.271342, 53.387444, -2.5],
          [6.271315, 53.387191, -2.5],
          [6.271211, 53.386691, -2.75],
          [6.270960, 53.385305, -2.75],
          [6.270915, 53.385129, -2.75],
          [6.270827, 53.384968, -3.0],
          [6.270471, 53.384630, -3.0],
          [6.270108, 53.384355, -3.0],
          [6.269781, 53.384164, -2.5],
          [6.269607, 53.384062, -2.5],
          [6.269579, 53.384043, -2.25],
          [6.269626, 53.383983, -2.5],
          [6.269668, 53.383911, -2.5],
          [6.269716, 53.383658, -2.25],
          [6.269771, 53.383575, -2.25],
          [6.271996, 53.382256, -1.0],
          [6.272294, 53.382070, -0.5],
          [6.274530, 53.380754, 1.25],
          [6.274637, 53.380739, 1.25],
          [6.274712, 53.380750, 1.0],
          [6.274836, 53.380742, 1.0],
          [6.274950, 53.380732, 0.75],
          [6.275026, 53.380754, 0.75],
          [6.275158, 53.380753, 0.5],
          [6.275288, 53.380623, 0.25],
          [6.275356, 53.380575, 0.25],
          [6.275420, 53.380531, 0.25],
          [6.275456, 53.380419, 0.0],
          [6.281473, 53.376759, -0.25],
          [6.281682, 53.376728, 0.0],
          [6.281729, 53.376700, 0.0],
          [6.281735, 53.376679, 0.0],
          [6.281710, 53.376613, 0.0],
          [6.281707, 53.376580, 0.0],
          [6.281936, 53.376451, 0.0],
          [6.282072, 53.376359, 0.0],
          [6.282385, 53.376217, 0.0],
          [6.282654, 53.376052, 0.0],
          [6.284342, 53.375021, -1.0],
          [6.286036, 53.374034, -0.75],
          [6.286216, 53.373956, -0.5],
          [6.286204, 53.373872, -0.5],
          [6.286220, 53.373810, -0.5],
          [6.286320, 53.373710, -0.25],
          [6.287790, 53.372870, -0.25],
          [6.288135, 53.372645, 0.0],
          [6.288315, 53.372435, 0.0],
          [6.288376, 53.372318, 0.0],
          [6.288493, 53.372239, -0.25],
          [6.288389, 53.372119, -0.25],
          [6.288315, 53.371953, -0.5],
          [6.288028, 53.371627, -0.75],
          [6.283900, 53.367120, -1.0],
          [6.283740, 53.367030, -1.0],
          [6.283260, 53.366890, -0.75],
          [6.283050, 53.366760, -0.5],
          [6.282900, 53.366620, -0.25],
          [6.282860, 53.366460, -0.25],
          [6.282849, 53.366371, -0.25],
          [6.282860, 53.366270, -0.25],
          [6.282929, 53.366036, -0.5],
          [6.282943, 53.365849, -0.5],
          [6.282973, 53.365716, -0.75],
          [6.282972, 53.365660, -0.75],
          [6.282960, 53.365611, -0.75],
          [6.282919, 53.365517, -1.0],
          [6.282854, 53.365437, -1.0],
          [6.282774, 53.365362, -1.25],
          [6.282661, 53.365288, -1.25],
          [6.282540, 53.365224, -1.25],
          [6.282258, 53.365128, -1.5],
          [6.282143, 53.365082, -1.75],
          [6.282030, 53.365022, -1.75],
          [6.281922, 53.364935, -2.0],
          [6.281495, 53.364474, -1.75],
          [6.281459, 53.364416, -1.75],
          [6.281448, 53.364347, -1.5],
          [6.281474, 53.364249, -1.75],
          [6.281528, 53.364195, -1.75],
          [6.281615, 53.364146, -1.75],
          [6.286626, 53.362341, -1.0],
          [6.286804, 53.362270, -0.75],
          [6.286968, 53.362198, -0.75],
          [6.287099, 53.362131, -0.5],
          [6.287362, 53.361963, -0.5],
          [6.287771, 53.361613, -0.5],
          [6.288525, 53.360964, 0.75],
          [6.288529, 53.360962, 0.75],
          [6.288959, 53.360714, 0.75],
          [6.289507, 53.360538, 1.0],
          [6.289947, 53.360432, 1.25],
          [6.290309, 53.360381, 1.5],
          [6.290484, 53.360366, 1.5],
          [6.290760, 53.360332, 1.5],
          [6.290775, 53.360328, 1.5],
          [6.290760, 53.360332, 1.5],
          [6.290846, 53.360346, 1.5],
          [6.290893, 53.360382, 1.5],
          [6.291043, 53.360517, 1.25],
          [6.291190, 53.360607, 1.25],
          [6.291262, 53.360636, 1.25],
          [6.291387, 53.360665, 1.25],
          [6.291556, 53.360682, 1.25],
          [6.291835, 53.360658, 1.25],
          [6.292660, 53.360510, 1.25],
          [6.293003, 53.360439, 1.0],
          [6.293138, 53.360396, 1.0],
          [6.293280, 53.360334, 1.0],
          [6.293533, 53.360195, 1.0],
          [6.293829, 53.360013, 1.0],
          [6.293988, 53.359930, 1.0],
          [6.294283, 53.359809, 0.75],
          [6.294577, 53.359723, 0.25],
          [6.295249, 53.359560, -0.5],
          [6.295208, 53.359535, -0.25],
          [6.294184, 53.358924, 0.5],
          [6.293512, 53.358509, 1.0],
          [6.295057, 53.357472, -1.0],
          [6.295412, 53.357200, -1.0],
          [6.296559, 53.356243, 0.75],
          [6.296631, 53.356096, 0.75],
          [6.296713, 53.355772, 1.0],
          [6.296753, 53.355616, 1.25],
          [6.297138, 53.354126, 0.0],
          [6.297206, 53.354022, 0.0],
          [6.297618, 53.352932, -1.0],
          [6.297645, 53.352862, -1.0],
          [6.298878, 53.349289, 0.0],
          [6.298909, 53.349204, 0.0],
          [6.298903, 53.349177, 0.25],
          [6.298861, 53.349135, 0.25],
          [6.299075, 53.349064, 0.0],
          [6.298861, 53.349135, 0.25],
          [6.298609, 53.349226, 0.25],
          [6.298230, 53.349350, 0.25],
          [6.297974, 53.349418, 0.0],
          [6.297610, 53.349481, 0.0],
          [6.296863, 53.349520, 0.25],
          [6.296650, 53.349500, 0.5],
          [6.296537, 53.349455, 0.25],
          [6.296504, 53.349365, 0.5],
          [6.296546, 53.349204, 0.75],
          [6.297620, 53.345870, -1.0],
          [6.297810, 53.345430, -0.75],
          [6.298045, 53.345098, -0.25],
          [6.298028, 53.345088, -0.25],
          [6.298045, 53.345098, -0.25],
          [6.298203, 53.345159, -0.25],
          [6.298355, 53.345200, 0.0],
          [6.298487, 53.345221, 0.0],
          [6.298613, 53.345226, 0.0],
          [6.298804, 53.345155, 0.0],
          [6.298952, 53.345111, 0.25],
          [6.298984, 53.345072, 0.25],
          [6.298967, 53.345005, 0.5],
          [6.298984, 53.344978, 0.75],
          [6.299006, 53.344966, 0.75],
          [6.299051, 53.344957, 0.75],
          [6.299148, 53.344946, 0.75],
          [6.299225, 53.344935, 0.75],
          [6.299178, 53.344841, 0.75],
          [6.299083, 53.344525, 0.25],
          [6.299018, 53.344125, 0.0],
          [6.299010, 53.343830, -0.25],
          [6.299041, 53.343505, -0.75],
          [6.299122, 53.343171, -0.75],
          [6.299126, 53.343156, -0.75],
          [6.299173, 53.343123, -0.75],
          [6.299231, 53.343097, -0.75],
          [6.299261, 53.343076, -0.75],
          [6.299281, 53.343049, -0.75],
          [6.299297, 53.342981, -0.5],
          [6.299309, 53.342911, -0.5],
          [6.299297, 53.342861, -0.5],
          [6.299221, 53.342755, -0.25],
          [6.299466, 53.341829, -0.5],
          [6.299816, 53.340459, -0.5],
          [6.299907, 53.340064, -0.75],
          [6.299894, 53.339876, -0.5],
          [6.299905, 53.339837, -0.25],
          [6.299934, 53.339710, 0.0],
          [6.299940, 53.339691, 0.0],
          [6.300050, 53.339310, 0.5],
          [6.300072, 53.339305, 0.5],
          [6.300132, 53.339294, 0.5],
          [6.300732, 53.339325, 0.5],
          [6.300721, 53.339150, 1.0],
          [6.300620, 53.338808, 1.25],
          [6.300785, 53.338793, 1.25],
          [6.300620, 53.338808, 1.25],
          [6.300442, 53.338761, 1.25],
          [6.300406, 53.338603, 1.5],
          [6.300321, 53.338486, 1.75],
          [6.300170, 53.338349, 1.75],
          [6.300100, 53.338247, 2.0],
          [6.300141, 53.338146, 2.0],
          [6.300069, 53.337968, 2.0],
          [6.300047, 53.337908, 2.0],
          [6.299970, 53.337644, 1.75],
          [6.299938, 53.337534, 1.75],
          [6.299870, 53.337541, 1.5],
          [6.299938, 53.337534, 1.75],
          [6.300274, 53.337509, 2.0],
          [6.300354, 53.337518, 2.0],
          [6.300827, 53.337478, 1.75],
          [6.300882, 53.337443, 1.75],
          [6.300939, 53.337553, 1.75],
          [6.301431, 53.337571, 1.25],
          [6.301477, 53.337573, 1.25],
          [6.301642, 53.337583, 1.0],
          [6.301796, 53.337593, 1.0],
          [6.301876, 53.337573, 1.0],
          [6.302154, 53.337446, 0.75],
          [6.302329, 53.337263, 0.5],
          [6.302414, 53.337288, 0.5],
          [6.302329, 53.337263, 0.5],
          [6.301687, 53.337061, 0.25],
          [6.301310, 53.336960, 0.75],
          [6.301220, 53.336957, 0.75],
          [6.300619, 53.336809, 1.0],
          [6.300538, 53.336786, 1.0],
          [6.300473, 53.336767, 1.0],
          [6.299854, 53.336590, 0.75],
          [6.299778, 53.336642, 0.5],
          [6.299854, 53.336590, 0.75],
          [6.300638, 53.336039, 1.75],
          [6.300683, 53.336021, 1.75],
          [6.300750, 53.336011, 1.75],
          [6.300683, 53.336021, 1.75],
          [6.300638, 53.336039, 1.75],
          [6.299854, 53.336590, 0.75],
          [6.299583, 53.336779, 0.0],
          [6.298859, 53.337276, 0.25],
          [6.298838, 53.337314, 0.25],
          [6.298840, 53.337350, 0.5],
          [6.298878, 53.337377, 0.5],
          [6.298957, 53.337414, 0.75],
          [6.299056, 53.337448, 0.75],
          [6.299165, 53.337468, 0.75],
          [6.299281, 53.337478, 1.0],
          [6.299918, 53.337467, 1.75],
          [6.299938, 53.337534, 1.75],
          [6.299210, 53.337611, 1.0],
          [6.298799, 53.337654, 0.75],
          [6.298530, 53.337697, 0.75],
          [6.298481, 53.337717, 0.75],
          [6.298517, 53.337747, 0.75],
          [6.298540, 53.337785, 0.5],
          [6.298579, 53.337859, 0.5],
          [6.298700, 53.338090, 0.5],
          [6.298823, 53.338280, 0.5],
          [6.298950, 53.338450, 0.5],
          [6.299160, 53.338690, 0.5],
          [6.299869, 53.339365, 0.25],
          [6.300050, 53.339310, 0.5],
          [6.299940, 53.339691, 0.0],
          [6.299934, 53.339710, 0.0],
          [6.299905, 53.339837, -0.25],
          [6.299894, 53.339876, -0.5],
          [6.299907, 53.340064, -0.75],
          [6.299816, 53.340459, -0.5],
          [6.299466, 53.341829, -0.5],
          [6.299221, 53.342755, -0.25],
          [6.299297, 53.342861, -0.5],
          [6.299309, 53.342911, -0.5],
          [6.299297, 53.342981, -0.5],
          [6.299281, 53.343049, -0.75],
          [6.299261, 53.343076, -0.75],
          [6.299231, 53.343097, -0.75],
          [6.299173, 53.343123, -0.75],
          [6.299126, 53.343156, -0.75],
          [6.299041, 53.343505, -0.75],
          [6.299010, 53.343830, -0.25],
          [6.299018, 53.344125, 0.0],
          [6.299083, 53.344525, 0.25],
          [6.299178, 53.344841, 0.75],
          [6.299225, 53.344935, 0.75],
          [6.299328, 53.345120, 0.5],
          [6.299378, 53.345282, -0.25],
          [6.299302, 53.345296, -0.25],
          [6.299219, 53.345310, -0.25],
          [6.299177, 53.345318, -0.5],
          [6.299109, 53.345316, -0.5],
          [6.299019, 53.345283, -0.25],
          [6.298850, 53.345265, -0.25],
          [6.298613, 53.345226, 0.0],
          [6.298487, 53.345221, 0.0],
          [6.298355, 53.345200, 0.0],
          [6.298203, 53.345159, -0.25],
          [6.298045, 53.345098, -0.25],
          [6.297938, 53.345035, -0.25],
          [6.297938, 53.345035, -0.25],
          [6.298045, 53.345098, -0.25],
          [6.297810, 53.345430, -0.75],
          [6.297620, 53.345870, -1.0],
          [6.296546, 53.349204, 0.75],
          [6.296504, 53.349365, 0.5],
          [6.296537, 53.349455, 0.25],
          [6.296650, 53.349500, 0.5],
          [6.296863, 53.349520, 0.25],
          [6.297610, 53.349481, 0.0],
          [6.297974, 53.349418, 0.0],
          [6.298230, 53.349350, 0.25],
          [6.298609, 53.349226, 0.25],
          [6.298861, 53.349135, 0.25],
          [6.298903, 53.349177, 0.25],
          [6.298909, 53.349204, 0.0],
          [6.298878, 53.349289, 0.0],
          [6.297645, 53.352862, -1.0],
          [6.297618, 53.352932, -1.0],
          [6.297206, 53.354022, 0.0],
          [6.297138, 53.354126, 0.0],
          [6.296753, 53.355616, 1.25],
          [6.296631, 53.356096, 0.75],
          [6.296559, 53.356243, 0.75],
          [6.295412, 53.357200, -1.0],
          [6.295057, 53.357472, -1.0],
          [6.293512, 53.358509, 1.0],
          [6.294184, 53.358924, 0.5],
          [6.295249, 53.359560, -0.5],
          [6.295515, 53.359510, -0.75],
          [6.295778, 53.359475, -0.75],
          [6.296353, 53.359426, -1.0],
          [6.296962, 53.359392, -1.25],
          [6.297516, 53.359372, -1.25],
          [6.297803, 53.359372, -1.5],
          [6.298091, 53.359389, -1.75],
          [6.298735, 53.359460, -2.0],
          [6.299346, 53.359517, -1.75],
          [6.299950, 53.359558, -1.0],
          [6.299975, 53.359559, -1.0],
          [6.300816, 53.359608, -1.0],
          [6.301208, 53.359623, -0.75],
          [6.301602, 53.359622, -0.25],
          [6.302166, 53.359600, -0.75],
          [6.302704, 53.359568, -1.0],
          [6.303059, 53.359537, -1.25],
          [6.303348, 53.359484, -1.25],
          [6.303959, 53.359318, -1.0],
          [6.304166, 53.359280, -1.0],
          [6.304369, 53.359252, -0.75],
          [6.304540, 53.359249, -0.5],
          [6.304713, 53.359255, -0.5],
          [6.304979, 53.359293, -0.25],
          [6.305071, 53.359319, -0.25],
          [6.305333, 53.359433, -0.5],
          [6.305442, 53.359465, -0.5],
          [6.305538, 53.359484, -0.75],
          [6.305779, 53.359497, -0.75],
          [6.306190, 53.359479, -0.5],
          [6.306469, 53.359449, -0.25],
          [6.307109, 53.359402, -0.25],
          [6.308910, 53.359470, -1.0],
          [6.309620, 53.359520, -0.75],
          [6.310090, 53.359580, -0.25],
          [6.310532, 53.359670, 0.0],
          [6.310750, 53.359700, 0.5],
          [6.310999, 53.359711, 0.75],
          [6.311814, 53.359695, 1.25],
          [6.312904, 53.359661, 0.0],
          [6.315060, 53.359600, -1.5],
          [6.315422, 53.359622, -1.5],
          [6.315831, 53.359662, -1.5],
          [6.316111, 53.359717, -1.75],
          [6.316318, 53.359770, -1.75],
          [6.316584, 53.359854, -1.75],
          [6.317415, 53.360204, -1.0],
          [6.318161, 53.360490, -1.0],
          [6.318440, 53.360568, -1.25],
          [6.319308, 53.360683, -1.5],
          [6.319296, 53.360723, -1.5],
          [6.319308, 53.360683, -1.5],
          [6.319385, 53.360505, -1.25],
          [6.319467, 53.360367, -1.0],
          [6.319569, 53.360244, -0.75],
          [6.319739, 53.360109, -0.75],
          [6.319941, 53.359973, -0.75],
          [6.320167, 53.359859, -1.0],
          [6.320433, 53.359751, -1.0],
          [6.320676, 53.359685, -1.25],
          [6.320938, 53.359631, -1.5],
          [6.321463, 53.359569, -2.0],
          [6.321532, 53.359566, -2.25],
          [6.322554, 53.359549, -1.25],
          [6.325323, 53.359561, 0.0],
          [6.326423, 53.359572, 0.5],
          [6.326701, 53.359590, 1.0],
          [6.327948, 53.359730, 0.75],
          [6.328295, 53.359750, 0.5],
          [6.328826, 53.359783, 0.5],
          [6.328950, 53.359790, 0.5],
          [6.329596, 53.359828, 0.75],
          [6.329705, 53.359817, 0.75],
          [6.329762, 53.359809, 0.75],
          [6.329953, 53.359747, 0.75],
          [6.330340, 53.359628, 1.0],
          [6.330587, 53.359529, 1.25],
          [6.330954, 53.359403, 1.75],
          [6.331166, 53.359373, 1.75],
          [6.331991, 53.359283, 2.5],
          [6.332377, 53.359235, 2.75],
          [6.332916, 53.359177, 2.75],
          [6.333340, 53.359182, 2.75],
          [6.333976, 53.359239, 2.5],
          [6.334210, 53.359247, 2.5],
          [6.334413, 53.359326, 2.0],
          [6.334509, 53.359296, 2.0],
          [6.334661, 53.359304, 2.0],
          [6.335519, 53.359384, 1.25],
          [6.335527, 53.359333, 1.25],
          [6.335541, 53.359248, 1.75],
          [6.335533, 53.359039, 2.0],
          [6.335517, 53.358591, 2.25],
          [6.335484, 53.357790, 1.0],
          [6.335479, 53.357620, 0.5],
          [6.335510, 53.357599, 0.25],
          [6.335479, 53.357620, 0.5],
          [6.335373, 53.357588, 0.75],
          [6.334636, 53.357015, 0.75],
          [6.334206, 53.356685, 0.75],
          [6.333936, 53.356468, 0.5],
          [6.333968, 53.356453, 0.25],
          [6.334768, 53.356092, 0.0],
          [6.334765, 53.356044, 0.0],
          [6.335546, 53.355710, 0.0],
          [6.335623, 53.355729, 0.0],
          [6.335897, 53.355601, 0.0],
          [6.335964, 53.355570, -0.25],
          [6.335783, 53.355445, -0.25],
          [6.335721, 53.355387, -0.5],
          [6.335642, 53.355227, -0.5],
          [6.335594, 53.355097, -0.75],
          [6.335649, 53.355051, -0.75],
          [6.335882, 53.355007, -0.75],
          [6.335539, 53.354618, -1.0],
          [6.335479, 53.354621, -1.0],
          [6.335539, 53.354618, -1.0],
          [6.335839, 53.354561, -1.0],
          [6.336980, 53.354275, -1.0],
          [6.336919, 53.354193, -1.0],
          [6.336764, 53.354008, -0.75],
          [6.336733, 53.353963, -0.5],
          [6.336691, 53.353904, -0.5],
          [6.336947, 53.353765, -0.5],
          [6.337013, 53.353745, -0.25],
          [6.337088, 53.353730, -0.25],
          [6.337339, 53.353696, -0.25],
          [6.337432, 53.353676, -0.25],
          [6.339691, 53.353107, -1.5],
          [6.340368, 53.352915, -2.0],
          [6.341631, 53.352522, -2.0],
          [6.342179, 53.352342, -1.5],
          [6.342364, 53.352282, -1.5],
          [6.342422, 53.352352, -1.75],
          [6.342468, 53.352407, -1.75],
          [6.342671, 53.352354, -1.75],
          [6.342974, 53.352298, -1.75],
          [6.343201, 53.352283, -1.75],
          [6.344378, 53.352206, -2.0],
          [6.347600, 53.351986, -0.75],
          [6.348115, 53.351988, -0.5],
          [6.348919, 53.352004, -0.25],
          [6.349534, 53.351992, -0.75],
          [6.349886, 53.352006, -1.25],
          [6.350080, 53.352025, -1.25],
          [6.350578, 53.352104, -1.5],
          [6.350690, 53.352109, -1.5],
          [6.350797, 53.352102, -1.5],
          [6.350986, 53.352069, -1.5],
          [6.351224, 53.352008, -1.5],
          [6.351514, 53.351944, -1.75],
          [6.351856, 53.351900, -2.0],
          [6.351986, 53.351891, -2.0],
          [6.352148, 53.351888, -2.0],
          [6.352241, 53.351892, -2.0],
          [6.352341, 53.351905, -2.0],
          [6.353283, 53.352112, -2.0],
          [6.354368, 53.352286, -2.0],
          [6.354951, 53.352363, -2.75],
          [6.355498, 53.352423, -2.75],
          [6.355848, 53.352451, -2.75],
          [6.356194, 53.352458, -2.5],
          [6.356698, 53.352459, -2.0],
          [6.357026, 53.352454, -2.25],
          [6.357180, 53.352453, -2.5],
          [6.357613, 53.352411, -3.0],
          [6.358055, 53.352350, -3.5],
          [6.358936, 53.352218, -4.0],
          [6.359172, 53.352174, -3.75],
          [6.359375, 53.352124, -3.75],
          [6.359573, 53.352062, -3.5],
          [6.360222, 53.351838, -2.75],
          [6.361043, 53.351587, -2.5],
          [6.361229, 53.351539, -2.25],
          [6.361403, 53.351530, -2.25],
          [6.361672, 53.351551, -1.75],
          [6.362066, 53.351595, -1.5],
          [6.362930, 53.351669, -0.25],
          [6.363412, 53.351718, 0.0],
          [6.363882, 53.351750, 0.0],
          [6.364502, 53.351773, 0.0],
          [6.365115, 53.351779, 0.5],
          [6.368041, 53.351816, 0.0],
          [6.368172, 53.351810, 0.0],
          [6.368269, 53.351798, 0.0],
          [6.368374, 53.351772, 0.0],
          [6.368517, 53.351723, 0.0],
          [6.368589, 53.351690, 0.0],
          [6.368804, 53.351563, 0.0],
          [6.368805, 53.351562, 0.0],
          [6.368890, 53.351509],
          [6.368911, 53.351494, 0.0],
          [6.369004, 53.351439, 0.25],
          [6.369090, 53.351419, 0.25],
          [6.369791, 53.351243, 0.0],
          [6.369979, 53.351194, 0.0],
          [6.370428, 53.351080, 0.25],
          [6.370508, 53.351053, 0.25],
          [6.370585, 53.351017, 0.5],
          [6.370650, 53.350969, 0.5],
          [6.370736, 53.350971, 0.5],
          [6.370818, 53.350964, 0.5],
          [6.370969, 53.350938, 0.5],
          [6.378460, 53.349030, -2.0],
          [6.378830, 53.348980, -2.0],
          [6.379840, 53.348990, -1.25],
          [6.380040, 53.349030, -1.0],
          [6.381317, 53.349448, -1.0],
          [6.381810, 53.349610, -1.5],
          [6.386307, 53.351162, -2.25],
          [6.387318, 53.351500, -1.5],
          [6.388817, 53.351978, 0.0],
          [6.389286, 53.352108, 0.0],
          [6.389498, 53.352159, 0.0],
          [6.389704, 53.352206, 0.0],
          [6.389939, 53.352238, 0.0],
          [6.390137, 53.352244, 0.0],
          [6.390275, 53.352228, 0.0],
          [6.390292, 53.352227, 0.0],
          [6.390428, 53.352203, 0.0],
          [6.390629, 53.352141, 0.0],
          [6.390703, 53.352107, 0.0],
          [6.390820, 53.352033, 0.0],
          [6.390866, 53.351991, 0.0],
          [6.390968, 53.351854, 0.25],
          [6.391174, 53.351561, 0.0],
          [6.391280, 53.351394, 0.0],
          [6.391299, 53.351316, 0.0],
          [6.391304, 53.351248, 0.0],
          [6.391262, 53.350919, 0.25],
          [6.391274, 53.350832, 0.5],
          [6.391308, 53.350761, 0.25],
          [6.391331, 53.350734, 0.25],
          [6.391388, 53.350694, 0.25],
          [6.391439, 53.350670, 0.25],
          [6.391713, 53.350578, 0.0],
          [6.391886, 53.350520, 0.0],
          [6.392005, 53.350474, 0.0],
          [6.392036, 53.350496, 0.0],
          [6.392165, 53.350567, 0.0],
          [6.392204, 53.350591, 0.0],
          [6.392295, 53.350549, 0.0],
          [6.392376, 53.350501, -0.25],
          [6.392614, 53.350273, -0.75],
          [6.392671, 53.350231, -0.75],
          [6.392740, 53.350192, -1.0],
          [6.392889, 53.350133, -1.25],
          [6.393756, 53.349863, -1.75],
          [6.394242, 53.349752, -1.5],
          [6.394990, 53.349596, -1.0],
          [6.395190, 53.349542, -1.0],
          [6.395247, 53.349524, -1.0],
          [6.397805, 53.348722, -1.0],
          [6.398076, 53.348663, -1.0],
          [6.398287, 53.348639, -1.25],
          [6.399346, 53.348575, -1.25],
          [6.399494, 53.348568, -1.25],
          [6.399777, 53.348579, -1.5],
          [6.401227, 53.348728, -1.5],
          [6.401557, 53.348770, -1.5],
          [6.401840, 53.348822, -1.5],
          [6.402053, 53.348871, -1.5],
          [6.402715, 53.349042, -2.0],
          [6.402896, 53.349072, -2.25],
          [6.403045, 53.349089, -2.5],
          [6.403199, 53.349097, -2.75],
          [6.403339, 53.349093, -2.75],
          [6.403524, 53.349070, -2.25],
          [6.403756, 53.348997, -1.75],
          [6.404485, 53.348665, -1.0],
          [6.405056, 53.348418, -0.75],
          [6.405727, 53.348121, -1.0],
          [6.407483, 53.347328, -1.75],
          [6.407778, 53.347207, -1.5],
          [6.407888, 53.347173, -1.5],
          [6.408209, 53.347087, -1.5],
          [6.408935, 53.346927, -1.25],
          [6.409452, 53.346822, -1.25],
          [6.409986, 53.346731, -1.75],
          [6.410443, 53.346665, -1.75],
          [6.410839, 53.346625, -1.75],
          [6.410847, 53.346643, -1.75],
          [6.410839, 53.346625, -1.75],
          [6.410819, 53.346438, -1.5],
          [6.410835, 53.346417, -1.5],
          [6.410861, 53.346400, -1.5],
          [6.410905, 53.346388, -1.5],
          [6.411428, 53.346340, -1.25],
          [6.411674, 53.346300, -1.25],
          [6.413258, 53.346050, -1.75],
          [6.413969, 53.345933, -2.0],
          [6.414218, 53.345885, -1.75],
          [6.414443, 53.345820, -1.75],
          [6.414545, 53.345782, -1.75],
          [6.415588, 53.345347, -1.25],
          [6.415809, 53.345278, -1.25],
          [6.415925, 53.345252, -1.25],
          [6.416064, 53.345228, -1.0],
          [6.416206, 53.345211, -1.0],
          [6.416351, 53.345203, -1.0],
          [6.417689, 53.345198, -1.25],
          [6.417792, 53.345187, -1.5],
          [6.417838, 53.345175, -1.5],
          [6.417911, 53.345135, -1.5],
          [6.417937, 53.345109, -1.5],
          [6.417958, 53.345054, -1.5],
          [6.417944, 53.344685, -1.5],
          [6.418004, 53.344279, -1.25],
          [6.418004, 53.344031, -1.25],
          [6.417986, 53.343870, -1.25],
          [6.417964, 53.343740, -1.25],
          [6.417971, 53.343599, -1.25],
          [6.418020, 53.343509, -1.25],
          [6.418087, 53.343451, -1.25],
          [6.418236, 53.343365, -1.0],
          [6.418439, 53.343275, -1.0],
          [6.418851, 53.343107, -1.25],
          [6.421461, 53.342068, -0.5],
          [6.422113, 53.341817, 0.0],
          [6.422127, 53.341812, 0.0],
          [6.422210, 53.341783, 0.0],
          [6.422672, 53.341617, 0.0],
          [6.422934, 53.341521, 0.0],
          [6.423399, 53.341352, 0.0],
          [6.424558, 53.340975, 0.25],
          [6.425265, 53.340761, 0.75],
          [6.425501, 53.340702, 0.5],
          [6.425606, 53.340683, 0.5],
          [6.425817, 53.340649, 0.25],
          [6.426670, 53.340480, 0.0],
          [6.427069, 53.340442, -0.25],
          [6.427740, 53.340492, -0.75],
          [6.428125, 53.340490, -1.25],
          [6.428143, 53.340490, -1.25],
          [6.428799, 53.340450, -1.5],
          [6.429318, 53.340428, -1.5],
          [6.429998, 53.340351, -1.75],
          [6.430324, 53.340320, -2.0],
          [6.430677, 53.340308, -2.0],
          [6.430999, 53.340314, -1.75],
          [6.431069, 53.340317, -1.75],
          [6.431142, 53.340330, -1.75],
          [6.431186, 53.340359, -1.5],
          [6.431217, 53.340379, -1.5],
          [6.431231, 53.340410, -1.75],
          [6.431234, 53.340446, -1.75],
          [6.431216, 53.340486, -1.75],
          [6.431139, 53.340588, -1.75],
          [6.431080, 53.340702, -1.75],
          [6.431053, 53.340811, -1.75],
          [6.431055, 53.340871, -1.75],
          [6.431127, 53.341188, -1.5],
          [6.431196, 53.341408, -1.25],
          [6.431276, 53.341620, -1.0],
          [6.431377, 53.341876, -0.5],
          [6.431882, 53.342737, 0.25],
          [6.432421, 53.343511, -1.0],
          [6.432718, 53.343922, -1.75],
          [6.432811, 53.344137, -2.25],
          [6.432878, 53.344448, -2.25],
          [6.432925, 53.344534, -2.25],
          [6.432997, 53.344618, -2.25],
          [6.433196, 53.344809, -2.0],
          [6.433387, 53.344966, -2.0],
          [6.433663, 53.345113, -1.75],
          [6.434241, 53.345339, -1.5],
          [6.434354, 53.345400, -1.5],
          [6.434444, 53.345477, -1.5],
          [6.434504, 53.345570, -1.5],
          [6.434593, 53.345742, -1.5],
          [6.434730, 53.346019, -1.25],
          [6.434895, 53.346382, -0.5],
          [6.434967, 53.346427, -0.5],
          [6.435069, 53.346450, -0.5],
          [6.435418, 53.346475, -0.75],
          [6.435575, 53.346508, -0.75],
          [6.435683, 53.346554, -0.75],
          [6.435743, 53.346600, -0.75],
          [6.435797, 53.346675, -0.75],
          [6.435811, 53.346741, -0.75],
          [6.435800, 53.346799, -0.75],
          [6.435593, 53.347000, -0.75],
          [6.435276, 53.347407, -0.75],
          [6.434959, 53.347774, -1.0],
          [6.434948, 53.347816, -1.0],
          [6.434961, 53.347852, -1.0],
          [6.435013, 53.347895, -1.0],
          [6.435148, 53.347950, -1.0],
          [6.436017, 53.348342, -1.0],
          [6.436150, 53.348387, -1.25],
          [6.436270, 53.348413, -1.5],
          [6.436744, 53.348469, -1.75],
          [6.436835, 53.348491, -1.75],
          [6.436899, 53.348529, -1.75],
          [6.436966, 53.348581, -1.5],
          [6.437024, 53.348653, -1.5],
          [6.437079, 53.348848, -1.25],
          [6.437134, 53.348908, -1.25],
          [6.437192, 53.348951, -1.25],
          [6.441319, 53.350998, 0.0],
          [6.441821, 53.351243, 0.5],
          [6.442025, 53.351320, 0.5],
          [6.442275, 53.351323, 0.5],
          [6.443139, 53.351192, 2.0],
          [6.444052, 53.351070, 2.0],
          [6.444208, 53.351034, 2.0],
          [6.444702, 53.350699, 1.75],
          [6.444796, 53.350660, 1.75],
          [6.445057, 53.350577, 1.5],
          [6.445265, 53.350539, 1.25],
          [6.445473, 53.350519, 1.0],
          [6.446076, 53.350487, 0.25],
          [6.446307, 53.350500, 0.0],
          [6.447839, 53.350705, -1.0],
          [6.448166, 53.350713, -0.75],
          [6.448604, 53.350676, -0.25],
          [6.448764, 53.350673, -0.25],
          [6.448867, 53.350683, -0.25],
          [6.449005, 53.350718, -0.25],
          [6.449066, 53.350747, -0.25],
          [6.449089, 53.350759, -0.5],
          [6.449135, 53.350802, -0.75],
          [6.449365, 53.351092, -1.0],
          [6.449548, 53.351344, -1.25],
          [6.449589, 53.351358, -1.25],
          [6.449623, 53.351361, -1.25],
          [6.449843, 53.351358, -1.25],
          [6.450476, 53.351345, -1.0],
          [6.450475, 53.351313, -1.0],
          [6.450617, 53.351319, -1.0],
          [6.456732, 53.351251, -1.0],
          [6.456905, 53.351255, -1.0],
          [6.457354, 53.351285, -1.25],
          [6.457983, 53.351358, -1.5],
          [6.458050, 53.351426, -1.25],
          [6.459134, 53.351687, -1.0],
          [6.459246, 53.351690, -1.0],
          [6.459308, 53.351671, -1.0],
          [6.459337, 53.351649, -1.0],
          [6.459497, 53.351468, -1.5],
          [6.459661, 53.351316, -1.75],
          [6.459772, 53.351234, -2.0],
          [6.461729, 53.351221, -0.25],
          [6.462600, 53.351234, -0.25],
          [6.462617, 53.351234, -0.25],
          [6.464104, 53.351281, 0.25],
          [6.464184, 53.351292, 0.25],
          [6.464283, 53.351319, 0.25],
          [6.464457, 53.351377, 0.5],
          [6.464551, 53.351392, 0.5],
          [6.464706, 53.351386, 0.75],
          [6.464919, 53.351366, 0.75],
          [6.464929, 53.351366, 0.75],
          [6.465207, 53.351324, 1.0],
          [6.465349, 53.351277, 1.0],
          [6.466228, 53.350942, 0.5],
          [6.466664, 53.350794, 0.0],
          [6.467073, 53.350644, 0.0],
          [6.467312, 53.350531, 0.25],
          [6.467479, 53.350425, 0.25],
          [6.467589, 53.350316, 0.5],
          [6.467632, 53.350285, 0.5],
          [6.467838, 53.350160, 0.25],
          [6.467843, 53.350140, 0.25],
          [6.467812, 53.350096, 0.5],
          [6.467920, 53.350074, 0.25],
          [6.468132, 53.350065, 0.0],
          [6.468142, 53.349985, 0.0],
          [6.468181, 53.349925, 0.0],
          [6.468242, 53.349897, 0.0],
          [6.468504, 53.349792, -0.25],
          [6.468840, 53.349621, -0.25],
          [6.469009, 53.349543, -0.5],
          [6.469240, 53.349449, -0.5],
          [6.470050, 53.349154, -1.0],
          [6.470509, 53.348982, -1.0],
          [6.471881, 53.348473, -1.0],
          [6.472710, 53.348104, -0.25],
          [6.474365, 53.347564, 0.5],
          [6.474985, 53.347425, 0.0],
          [6.475376, 53.347349, 0.0],
          [6.475654, 53.347303, 0.0],
          [6.475931, 53.347239, -0.25],
          [6.476377, 53.347107, -1.0],
          [6.476994, 53.346943, -1.25],
          [6.477440, 53.346851, -0.75],
          [6.478097, 53.346658, -0.25],
          [6.478428, 53.346508, 0.0],
          [6.478780, 53.346408, -0.25],
          [6.479179, 53.346337, -0.25],
          [6.479614, 53.346228, -0.25],
          [6.480059, 53.346099, -0.25],
          [6.480746, 53.345915, 0.0],
          [6.481420, 53.345757, -0.75],
          [6.482491, 53.345547, -1.25],
          [6.482662, 53.345498, -1.25],
          [6.482871, 53.345410, -1.25],
          [6.483279, 53.345186, -1.0],
          [6.484265, 53.344601, -1.25],
          [6.484794, 53.344276, -1.0],
          [6.485486, 53.343867, -1.25],
          [6.486499, 53.343316, -1.75],
          [6.487662, 53.342648, -1.0],
          [6.488409, 53.342162, -1.0],
          [6.489328, 53.341491, -1.0],
          [6.489904, 53.341093, -0.75],
          [6.490158, 53.340906, -0.75],
          [6.490413, 53.340740, -1.0],
          [6.491557, 53.340238, -0.75],
          [6.492706, 53.339743, -1.25],
          [6.492937, 53.339631, -1.5],
          [6.493048, 53.339549, -1.75],
          [6.493146, 53.339449, -1.75],
          [6.493520, 53.338828, -2.25],
          [6.493702, 53.338556, -2.25],
          [6.493904, 53.338307, -2.25],
          [6.494010, 53.338108, -2.0],
          [6.494055, 53.337970, -2.0],
          [6.494132, 53.337683, -2.0],
          [6.494161, 53.337530, -2.0],
          [6.494176, 53.337378, -2.0],
          [6.494175, 53.336013, -2.0],
          [6.495003, 53.333191, -2.0],
          [6.495020, 53.333080, -2.0],
          [6.495034, 53.332990, -2.0],
          [6.495121, 53.332986, -2.0],
          [6.495336, 53.332969, -2.0],
          [6.497089, 53.332847, -1.5],
          [6.498808, 53.332755, -1.5],
          [6.499361, 53.332726, -1.5],
          [6.500641, 53.332659, -1.75],
          [6.501464, 53.332623, -1.75],
          [6.501998, 53.332608, -1.75],
          [6.502543, 53.332600, -1.75],
          [6.502560, 53.332600, -1.75],
          [6.502668, 53.332601, -1.5],
          [6.503424, 53.332615, -1.0],
          [6.503868, 53.332633, -1.0],
          [6.504867, 53.332689, -0.75],
          [6.504946, 53.332693, -0.75],
          [6.506715, 53.332790, -0.25],
          [6.507179, 53.332808, -0.25],
          [6.507326, 53.332807, -0.25],
          [6.508170, 53.332717, 0.0],
          [6.508332, 53.332709, 0.0],
          [6.508546, 53.332717, 0.0],
          [6.509367, 53.332789, 0.0],
          [6.510682, 53.332924, 1.0],
          [6.510730, 53.332929, 1.0],
          [6.510829, 53.332943, 1.0],
          [6.510926, 53.332974, 0.75],
          [6.510964, 53.332999, 0.75],
          [6.511006, 53.333052, 0.75],
          [6.511013, 53.333082, 0.75],
          [6.511004, 53.333344, 0.75],
          [6.510992, 53.333404, 0.75],
          [6.510974, 53.333448, 0.75],
          [6.510903, 53.333525, 0.75],
          [6.510697, 53.333649, 0.5],
          [6.510777, 53.333658, 0.5],
          [6.511104, 53.333644, 0.5],
          [6.511100, 53.333615, 0.5],
          [6.511104, 53.333644, 0.5],
          [6.511231, 53.333633, 0.25],
          [6.511344, 53.333622, 0.25],
          [6.511636, 53.333589, 0.25],
          [6.511725, 53.333694, 0.0],
          [6.511730, 53.333791, 0.0],
          [6.511810, 53.333799, 0.0],
          [6.511881, 53.333825, 0.0],
          [6.511947, 53.333853, 0.0],
          [6.512038, 53.333905, 0.0],
          [6.512692, 53.334444, -0.25],
          [6.512741, 53.334474, -0.25],
          [6.512809, 53.334499, 0.0],
          [6.513167, 53.334609, 0.0],
          [6.513295, 53.334632, 0.25],
          [6.513438, 53.334647, 0.25],
          [6.513604, 53.334652, 0.25],
          [6.513776, 53.334648, 0.25],
          [6.513949, 53.334621, 0.25],
          [6.513993, 53.334609, 0.25],
          [6.514046, 53.334596, 0.25],
          [6.514204, 53.334547, 0.5],
          [6.514503, 53.334435, 1.0],
          [6.514711, 53.334365, 1.25],
          [6.514905, 53.334325, 1.5],
          [6.515110, 53.334324, 1.5],
          [6.515710, 53.334344, 1.5],
          [6.515806, 53.334353, 1.5],
          [6.516660, 53.334383, 1.25],
          [6.516946, 53.334397, 1.0],
          [6.517057, 53.334403, 1.0],
          [6.517131, 53.334406, 1.0],
          [6.517824, 53.334437, 0.25],
          [6.518619, 53.334474, -0.25],
          [6.518901, 53.334488, -0.25],
          [6.519283, 53.334512, -0.25],
          [6.519385, 53.334520, -0.25],
          [6.519556, 53.334528, 0.0],
          [6.519710, 53.334541, 0.0],
          [6.520420, 53.334580, 0.0],
          [6.521170, 53.334641, 0.75],
          [6.521369, 53.334667, 0.75],
          [6.521594, 53.334710, 1.0],
          [6.521713, 53.334724, 1.25],
          [6.521855, 53.334730, 1.0],
          [6.522026, 53.334723, 1.0],
          [6.522457, 53.334685, 0.5],
          [6.522481, 53.334683, 0.5],
          [6.523118, 53.334670, 0.0],
          [6.523316, 53.334672, 0.0],
          [6.523740, 53.334689, 0.0],
          [6.524499, 53.334788, 0.0],
          [6.524557, 53.334794, 0.0],
          [6.524732, 53.334809, 0.0],
          [6.525485, 53.334836, 0.0],
          [6.525794, 53.334848, 0.0],
          [6.526179, 53.334879, -0.25],
          [6.526534, 53.334930, -0.75],
          [6.527537, 53.335228, -0.5],
          [6.528220, 53.335393, -0.75],
          [6.528289, 53.335439, -0.75],
          [6.528331, 53.335437, -0.75],
          [6.528775, 53.335447, -1.0],
          [6.528991, 53.335460, -1.0],
          [6.529136, 53.335470, -1.0],
          [6.529583, 53.335496, -1.0],
          [6.529632, 53.335499, -1.0],
          [6.529679, 53.335564, -1.0],
          [6.529831, 53.335605, -1.25],
          [6.530174, 53.335626, -1.5],
          [6.530206, 53.335623, -1.25],
          [6.530265, 53.335603, -1.25],
          [6.530287, 53.335585, -1.25],
          [6.530337, 53.335485, -1.0],
          [6.530380, 53.335491, -1.0],
          [6.530704, 53.335550, -1.25],
          [6.531126, 53.335646, -1.75],
          [6.531603, 53.335744, -2.5],
          [6.531638, 53.335751, -2.5],
          [6.531647, 53.335753, -2.5],
          [6.531743, 53.335775, -2.5],
          [6.531466, 53.336086, -2.75],
          [6.531210, 53.336283, -2.5],
          [6.531628, 53.336536, -2.75],
          [6.531798, 53.336641, -2.75],
          [6.531951, 53.336731, -2.5],
          [6.531992, 53.336759, -2.25],
          [6.532014, 53.336784, -2.25],
          [6.532026, 53.336837, -2.0],
          [6.531603, 53.337834, -1.0],
          [6.531534, 53.337854, -1.0],
          [6.531456, 53.337858, -1.0],
          [6.531144, 53.337817, -1.25],
          [6.530967, 53.338252, -1.0],
          [6.531006, 53.338380, -1.0],
          [6.531066, 53.338574, -1.0],
          [6.531069, 53.338583, -1.0],
          [6.531162, 53.338586, -1.0],
          [6.531261, 53.338639, -1.25],
          [6.531404, 53.338692, -1.5],
          [6.531471, 53.338700, -1.5],
          [6.531791, 53.338689, -1.75],
          [6.532101, 53.338664, -1.75],
          [6.533022, 53.338524, -0.75],
          [6.533565, 53.338434, -0.25],
          [6.534048, 53.338374, -0.75],
          [6.534524, 53.338333, -1.25],
          [6.535368, 53.338280, -1.75],
          [6.536425, 53.338264, -1.75],
          [6.538193, 53.338169, -1.25],
          [6.540170, 53.338072, -2.5],
          [6.542068, 53.337982, -2.0],
          [6.543107, 53.337943, -2.25],
          [6.545521, 53.337875, -1.5],
          [6.546341, 53.337838, -1.5],
          [6.547338, 53.337794, -1.5],
          [6.548356, 53.337742, -1.5],
          [6.552910, 53.337561, -1.25],
          [6.553880, 53.337517, -1.5],
          [6.554848, 53.337475, -2.0],
          [6.555774, 53.337449, -2.0],
          [6.556179, 53.337433, -2.25],
          [6.557337, 53.337404, -3.0],
          [6.559298, 53.337297, -2.0],
          [6.561173, 53.337218, -2.0],
          [6.562435, 53.337080, -2.0],
          [6.562964, 53.337048, -1.25],
          [6.563495, 53.337023, -1.0],
          [6.564087, 53.337005, -1.0],
          [6.564671, 53.337012, -1.25],
          [6.565145, 53.337034, -1.25],
          [6.566293, 53.336995, -1.75],
          [6.567142, 53.336964, -2.25],
          [6.568824, 53.336880, -1.25],
          [6.569428, 53.336859, -0.75],
          [6.570438, 53.336840, -0.25],
          [6.571263, 53.336807, -0.25],
          [6.571807, 53.336782, -0.25],
          [6.571935, 53.336802, -0.25],
          [6.572074, 53.336808, -0.25],
          [6.572142, 53.336802, -0.25],
          [6.572198, 53.336783, -0.25],
          [6.572279, 53.336758, 0.0],
          [6.572345, 53.336750, 0.0],
          [6.574251, 53.336672, -1.0],
          [6.576796, 53.336587, -1.0],
          [6.577038, 53.336590, -1.0],
          [6.577290, 53.336616, -1.0],
          [6.577489, 53.336674, -1.0],
          [6.577613, 53.336725, -0.75],
          [6.577731, 53.336795, -0.75],
          [6.577882, 53.336864, -0.75],
          [6.578134, 53.336950, -1.0],
          [6.578278, 53.336979, -1.0],
          [6.578426, 53.337001, -1.0],
          [6.578699, 53.337034, -1.25],
          [6.578791, 53.337039, -1.25],
          [6.578976, 53.337028, -1.25],
          [6.579117, 53.336998, -1.0],
          [6.579276, 53.336942, -0.75],
          [6.579776, 53.336745, -0.25],
          [6.580462, 53.336562, -0.5],
          [6.580809, 53.336491, -0.75],
          [6.581524, 53.336441, -1.5],
          [6.581915, 53.336407, -1.5],
          [6.582200, 53.336400, -1.5],
          [6.583465, 53.336358, -1.5],
          [6.583707, 53.336333, -1.5],
          [6.583795, 53.336368, -1.5],
          [6.584124, 53.336312, -1.5],
          [6.584334, 53.336270, -1.5],
          [6.584677, 53.336217, -1.5],
          [6.584970, 53.336184, -1.75],
          [6.585178, 53.336174, -1.5],
          [6.585935, 53.336174, -0.75],
          [6.586768, 53.336230, 0.0],
          [6.587012, 53.336264, 0.0],
          [6.587233, 53.336313, 0.25],
          [6.587333, 53.336343, 0.5],
          [6.587630, 53.336397, 0.75],
          [6.587698, 53.336398, 0.75],
          [6.587694, 53.336407, 0.75],
          [6.587698, 53.336398, 0.75],
          [6.587823, 53.336375, 1.0],
          [6.587906, 53.336346, 1.25],
          [6.588058, 53.336269, 1.5],
          [6.588326, 53.336072, 1.75],
          [6.588366, 53.336009, 2.0],
          [6.588181, 53.335785, 1.5],
          [6.588181, 53.335757, 1.5],
          [6.588256, 53.335587, 1.75],
          [6.588273, 53.335546, 1.75],
          [6.588319, 53.335559, 1.75],
          [6.588511, 53.335612, 2.0],
          [6.589100, 53.335696, 2.0],
          [6.589377, 53.335713, 2.0],
          [6.589623, 53.335691, 2.0],
          [6.590717, 53.335423, 1.0],
          [6.590726, 53.335450, 1.0],
          [6.590782, 53.335623, 1.0],
          [6.590828, 53.335715, 1.0],
          [6.590921, 53.335763, 0.75],
          [6.591146, 53.335787, 0.5],
          [6.591571, 53.335785, 0.0],
          [6.592033, 53.335757, -0.25],
          [6.592322, 53.335712, -0.5],
          [6.592629, 53.335581, -0.75],
          [6.592818, 53.335532, -1.0],
          [6.592965, 53.335507, -1.0],
          [6.593161, 53.335495, -1.25],
          [6.593527, 53.335495, -1.5],
          [6.593565, 53.335498, -1.5],
          [6.594211, 53.335538, -1.5],
          [6.594893, 53.335598, -1.75],
          [6.595419, 53.335671, -2.0],
          [6.596264, 53.335895, -2.5],
          [6.596582, 53.335960, -2.75],
          [6.596967, 53.335998, -2.5],
          [6.597671, 53.336056, -1.25],
          [6.597878, 53.336073, -1.0],
          [6.598280, 53.336136, -0.25],
          [6.599178, 53.336324, -0.5],
          [6.600027, 53.336523, -1.0],
          [6.600303, 53.336576, -1.0],
          [6.601180, 53.336673, -1.0],
          [6.603698, 53.336972, -0.25],
          [6.603951, 53.336986, -0.25],
          [6.604308, 53.336978, -0.25],
          [6.604653, 53.336961, -0.5],
          [6.605505, 53.336813, -0.75],
          [6.605884, 53.336792, -1.25],
          [6.606340, 53.336775, -2.0],
          [6.606726, 53.336775, -2.75],
          [6.607060, 53.336785, -2.75],
          [6.607599, 53.336810, -2.75],
          [6.608091, 53.336850, -3.25],
          [6.608633, 53.336912, -3.25],
          [6.609254, 53.337002, -3.0],
          [6.609440, 53.337038, -2.75],
          [6.610199, 53.337263, -1.75],
          [6.610781, 53.337503, -1.0],
          [6.610895, 53.337536, -1.0],
          [6.611027, 53.337566, -1.0],
          [6.611237, 53.337595, -1.0],
          [6.611464, 53.337610, -1.0],
          [6.611784, 53.337608, -1.0],
          [6.612191, 53.337589, -1.0],
          [6.612609, 53.337562, -1.0],
          [6.613102, 53.337517, -1.5],
          [6.613295, 53.337490, -1.75],
          [6.613494, 53.337454, -1.75],
          [6.613670, 53.337410, -1.75],
          [6.613856, 53.337356, -1.75],
          [6.614239, 53.337228, -1.5],
          [6.614495, 53.337161, -1.75],
          [6.614762, 53.337116, -1.75],
          [6.615056, 53.337081, -2.0],
          [6.615343, 53.337062, -2.0],
          [6.615670, 53.337061, -2.0],
          [6.616030, 53.337063, -2.0],
          [6.616474, 53.337081, -2.0],
          [6.616829, 53.337112, -2.0],
          [6.617087, 53.337150, -2.0],
          [6.617217, 53.337178, -2.0],
          [6.617618, 53.337301, -2.0],
          [6.617800, 53.337336, -2.0],
          [6.618228, 53.337366, -2.0],
          [6.618677, 53.337437, -2.0],
          [6.619025, 53.337485, -2.0],
          [6.620405, 53.337597, -2.0],
          [6.620786, 53.337636, -2.0],
          [6.621204, 53.337700, -2.5],
          [6.622609, 53.337941, -3.0],
          [6.623130, 53.338024, -3.25],
          [6.623811, 53.338115, -3.25],
          [6.625160, 53.338270, -2.0],
          [6.625819, 53.338345, -2.0],
          [6.626174, 53.338392, -2.0],
          [6.626501, 53.338420, -2.0],
          [6.626722, 53.338418, -2.0],
          [6.627166, 53.338339, -2.5],
          [6.627225, 53.338404, -2.5],
          [6.627268, 53.338457, -2.5],
          [6.627331, 53.338527, -2.75],
          [6.627457, 53.338631, -2.75],
          [6.627718, 53.338806, -3.25],
          [6.627790, 53.338862, -3.25],
          [6.627834, 53.338920, -3.25],
          [6.627837, 53.338986, -3.25],
          [6.627785, 53.339081, -3.25],
          [6.627865, 53.339107, -3.25],
          [6.627918, 53.339124, -3.5],
          [6.627976, 53.339152, -3.5],
          [6.628072, 53.339218, -3.5],
          [6.628473, 53.339615, -2.75],
          [6.628723, 53.339864, -2.25],
          [6.628836, 53.339824, -2.25],
          [6.629041, 53.339750, -2.25],
          [6.629107, 53.339727, -2.5],
          [6.629613, 53.339555, -3.0],
          [6.629821, 53.339506, -3.0],
          [6.629982, 53.339477, -3.25],
          [6.630177, 53.339456, -3.0],
          [6.630413, 53.339448, -2.75],
          [6.631410, 53.339500, -1.75],
          [6.632727, 53.339583, -2.25],
          [6.633221, 53.339623, -2.75],
          [6.633383, 53.339637, -3.0],
          [6.634984, 53.339782, -3.5],
          [6.635099, 53.339764, -3.5],
          [6.635266, 53.339763, -3.25],
          [6.635294, 53.339766, -3.0],
          [6.635726, 53.339820, -2.75],
          [6.635832, 53.339523, -2.25],
          [6.636956, 53.339624, -1.25],
          [6.637270, 53.339653, -1.0],
          [6.637763, 53.339710, -1.0],
          [6.638291, 53.339755, -1.0],
          [6.638546, 53.339765, -1.0],
          [6.638921, 53.339773, -1.0],
          [6.639406, 53.339774, -1.25],
          [6.640200, 53.339768, -1.5],
          [6.640304, 53.339760, -1.5],
          [6.640327, 53.339755, -1.5],
          [6.640411, 53.339716, -1.5],
          [6.640676, 53.339571, -2.0],
          [6.640881, 53.339461, -2.25],
          [6.640973, 53.339427, -2.25],
          [6.641019, 53.339419, -2.25],
          [6.641108, 53.339416, -2.25],
          [6.642056, 53.339473, -2.0],
          [6.642665, 53.339524, -1.75],
          [6.642929, 53.339532, -1.75],
          [6.643260, 53.339511, -1.5],
          [6.643869, 53.339437, -1.5],
          [6.643878, 53.339466, -1.25],
          [6.643869, 53.339437, -1.5],
          [6.644107, 53.339415, -1.5],
          [6.644221, 53.339414, -1.75],
          [6.644318, 53.339420, -1.75],
          [6.644421, 53.339443, -1.75],
          [6.644462, 53.339460, -2.0],
          [6.644498, 53.339487, -2.0],
          [6.644577, 53.339571, -2.0],
          [6.644642, 53.339603, -2.0],
          [6.644726, 53.339624, -2.0],
          [6.644865, 53.339636, -2.25],
          [6.645254, 53.339641, -2.25],
          [6.645453, 53.339653, -2.0],
          [6.645812, 53.339696, -2.0],
          [6.646152, 53.339760, -1.5],
          [6.646390, 53.339832, -1.0],
          [6.646436, 53.339855, -1.0],
          [6.646454, 53.339873, -1.0],
          [6.646467, 53.339910, -1.0],
          [6.646428, 53.340080, -1.25],
          [6.646451, 53.340148, -1.5],
          [6.646465, 53.340165, -1.5],
          [6.646499, 53.340185, -1.5],
          [6.646679, 53.340228, -1.5],
          [6.646929, 53.340277, -1.5],
          [6.647040, 53.340292, -1.5],
          [6.647145, 53.340298, -1.5],
          [6.647318, 53.340287, -1.5],
          [6.647561, 53.340244, -1.5],
          [6.647740, 53.340202, -1.25],
          [6.647916, 53.340155, -1.25],
          [6.648384, 53.340012, -1.0],
          [6.648474, 53.340005, -1.0],
          [6.648557, 53.340009, -1.0],
          [6.648595, 53.339970, -0.75],
          [6.648714, 53.339872, -0.75],
          [6.648765, 53.339843, -0.75],
          [6.648967, 53.339729, -0.5],
          [6.649079, 53.339671, -0.5],
          [6.649231, 53.339594, -0.5],
          [6.649881, 53.339298, -0.5],
          [6.650549, 53.339020, -1.0],
          [6.651105, 53.338818, -1.5],
          [6.651260, 53.338768, -1.5],
          [6.651445, 53.338721, -1.75],
          [6.651894, 53.338643, -2.0],
          [6.652209, 53.338606, -1.75],
          [6.652338, 53.338597, -1.75],
          [6.652754, 53.338586, -1.25],
          [6.653509, 53.338594, -1.0],
          [6.653603, 53.338607, -1.0],
          [6.653645, 53.338621, -1.0],
          [6.653711, 53.338659, -1.0],
          [6.653753, 53.338708, -1.0],
          [6.653836, 53.338695, -1.0],
          [6.653881, 53.338695, -1.0],
          [6.653926, 53.338701, -1.0],
          [6.654043, 53.338731, -1.0],
          [6.654103, 53.338737, -1.0],
          [6.654243, 53.338729, -1.0],
          [6.656006, 53.338377, -1.0],
          [6.657328, 53.338109, -1.5],
          [6.658016, 53.337954, -1.25],
          [6.660523, 53.337394, -1.25],
          [6.662565, 53.336943, -0.5],
          [6.663338, 53.336780, -1.0],
          [6.664230, 53.336598, -1.0],
          [6.665278, 53.336407, -2.25],
          [6.667666, 53.336013, -2.25],
          [6.669755, 53.335667, -1.25],
          [6.672511, 53.335216, 0.0],
          [6.672678, 53.335200, 0.0],
          [6.672819, 53.335186, 0.0],
          [6.673146, 53.335131, 0.5],
          [6.673671, 53.335045, 0.75],
          [6.673916, 53.335001, 0.75],
          [6.674148, 53.334949, 0.75],
          [6.675209, 53.334768, 0.0],
          [6.678415, 53.334243, -1.0],
          [6.678477, 53.334302, -1.0],
          [6.678542, 53.334349, -1.0],
          [6.678586, 53.334349, -1.0],
          [6.678994, 53.334281, -1.0],
          [6.679898, 53.334054, -1.0],
          [6.680304, 53.333970, -1.0],
          [6.681986, 53.333642, -1.25],
          [6.682138, 53.333607, -1.25],
          [6.682236, 53.333578, -1.25],
          [6.682391, 53.333551, -1.25],
          [6.682953, 53.333504, -1.5],
          [6.683287, 53.333485, -1.5],
          [6.683549, 53.333487, -1.5],
          [6.683658, 53.333490, -1.5],
          [6.683856, 53.333508, -1.5],
          [6.684247, 53.333554, -1.25],
          [6.684787, 53.333582, -1.5],
          [6.685150, 53.333593, -1.5],
          [6.685627, 53.333589, -1.5],
          [6.685937, 53.333565, -1.75],
          [6.686205, 53.333517, -1.75],
          [6.686502, 53.333449, -1.75],
          [6.687165, 53.333283, -2.0],
          [6.687590, 53.333157, -1.75],
          [6.688084, 53.333041, -1.25],
          [6.688387, 53.332978, -1.0],
          [6.689318, 53.332818, -1.0],
          [6.689808, 53.332746, -1.0],
          [6.690229, 53.332696, -1.0],
          [6.691033, 53.332579, -1.0],
          [6.691364, 53.332483, -1.0],
          [6.692269, 53.332191, -1.25],
          [6.692762, 53.332073, -1.5],
          [6.692933, 53.332040, -1.5],
          [6.693156, 53.332005, -1.5],
          [6.693252, 53.331996, -1.5],
          [6.693380, 53.331973, -1.5],
          [6.693591, 53.331932, -1.5],
          [6.693749, 53.331893, -1.5],
          [6.695147, 53.331671, -1.75],
          [6.696151, 53.331482, -2.0],
          [6.696938, 53.331371, -2.0],
          [6.697139, 53.331334, -2.0],
          [6.697748, 53.331242, -2.0],
          [6.698028, 53.331224, -2.0],
          [6.698615, 53.331215, -2.0],
          [6.698844, 53.331201, -2.0],
          [6.699039, 53.331178, -2.0],
          [6.699248, 53.331147, -2.0],
          [6.700240, 53.330972, -2.0],
          [6.700815, 53.330887, -2.0],
          [6.701276, 53.330789, -2.5],
          [6.701629, 53.330685, -2.75],
          [6.702054, 53.330514, -2.5],
          [6.702322, 53.330392, -2.25],
          [6.702491, 53.330303, -2.25],
          [6.702739, 53.330087, -2.0],
          [6.702821, 53.330014, -2.0],
          [6.703214, 53.329712, -2.0],
          [6.703321, 53.329579, -2.0],
          [6.703379, 53.329526, -2.0],
          [6.703447, 53.329478, -2.0],
          [6.703558, 53.329453, -2.0],
          [6.703639, 53.329456, -2.0],
          [6.703669, 53.329380, -2.0],
          [6.703520, 53.329379, -2.0],
          [6.703464, 53.329385, -1.75],
          [6.703520, 53.329379, -2.0],
          [6.703669, 53.329380, -2.0],
          [6.703682, 53.329336, -2.0],
          [6.703690, 53.329308, -2.0],
          [6.703682, 53.329254, -2.0],
          [6.703654, 53.329213, -2.0],
          [6.698554, 53.324460, -1.5],
          [6.698063, 53.323993, -1.25],
          [6.697740, 53.323686, -1.75],
          [6.697688, 53.323636, -1.75]
        ]
      }
    }
  ]
}

let day17: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "J17 - Stedum - Bedekaspel - 61.3km",
        "track-length": "61284",
        "filtered ascend": "35",
        "plain-ascend": "15",
        "total-time": "20960",
        "total-energy": "833972",
        "cost": "174754",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["6697740", "53323686", "-1", "5", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good", "", "0", "46"],
          ["6698554", "53324460", "-1", "103", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "12", "1245"],
          ["6703682", "53329336", "-2", "645", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cycle_barrier foot=yes bicycle=yes", "114", "11492"],
          ["6703669", "53329380", "-2", "5", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "115", "11573"],
          ["6703639", "53329456", "-2", "9", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "", "117", "11720"],
          ["6731017", "53330090", "-1", "2019", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "452", "45284"],
          ["6731282", "53330135", "-1", "19", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=wood foot=yes smoothness=good route_bicycle_rcn=yes", "", "455", "45595"],
          ["6737293", "53330868", "-2", "418", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "523", "52307"],
          ["6738313", "53331118", "-1", "75", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes smoothness=good route_bicycle_rcn=yes", "", "536", "53620"],
          ["6745449", "53328762", "-1", "561", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated smoothness=good route_bicycle_rcn=yes", "", "623", "62378"],
          ["6750514", "53326938", "-1", "398", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated oneway=no smoothness=good route_bicycle_rcn=yes", "", "694", "69484"],
          ["6761311", "53322570", "-1", "887", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "", "842", "84225"],
          ["6762391", "53321273", "-1", "163", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete smoothness=good route_bicycle_rcn=yes", "", "868", "86817"],
          ["6769046", "53313349", "0", "997", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unknown", "1039", "103931"],
          ["6769995", "53312326", "-1", "135", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=concrete foot=yes smoothness=good route_bicycle_rcn=yes", "", "1063", "106331"],
          ["6770034", "53312205", "-1", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "1065", "106552"],
          ["6770053", "53311797", "-1", "48", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "1073", "107320"],
          ["6770277", "53311724", "-1", "17", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1075", "107596"],
          ["6770067", "53311268", "-1", "55", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1084", "108460"],
          ["6771229", "53311039", "-1", "87", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "1097", "109803"],
          ["6772109", "53311363", "-1", "75", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "1106", "110645"],
          ["6779928", "53312478", "-1", "552", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=forward", "1193", "119351"],
          ["6787523", "53313628", "0", "532", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "1288", "128857"],
          ["6790534", "53314049", "0", "214", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=backward", "1315", "131599"],
          ["6797114", "53315234", "0", "479", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1391", "139204"],
          ["6829276", "53318920", "-1", "2230", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "nodeaccessgranted=yes direction=forward", "1757", "175807"],
          ["6835408", "53319483", "0", "422", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=excellent route_bicycle_rcn=yes", "", "1833", "183378"],
          ["6835415", "53319554", "0", "8", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=unknown", "1835", "183519"],
          ["6835611", "53320075", "1", "63", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1844", "184506"],
          ["6841454", "53320737", "0", "433", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "1901", "190118"],
          ["6842188", "53320883", "0", "52", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1908", "190893"],
          ["6842429", "53320909", "0", "17", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "1911", "191156"],
          ["6843160", "53320945", "0", "50", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1918", "191858"],
          ["6843175", "53320820", "0", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "1920", "192057"],
          ["6843898", "53320784", "-1", "49", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=excellent route_bicycle_rcn=yes", "", "1927", "192751"],
          ["6844059", "53320771", "-1", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=wood foot=yes smoothness=intermediate route_bicycle_rcn=yes", "", "1929", "192928"],
          ["6844589", "53320663", "-1", "38", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=good route_bicycle_rcn=yes", "", "1934", "193465"],
          ["6851800", "53321681", "0", "525", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "2030", "203090"],
          ["6853624", "53321718", "1", "125", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "2052", "205223"],
          ["6853667", "53321710", "1", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway route_bicycle_rcn=yes", "", "2052", "205276"],
          ["6854597", "53321683", "0", "66", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "2063", "206353"],
          ["6856382", "53321337", "2", "132", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones smoothness=intermediate route_bicycle_rcn=yes", "", "2088", "208839"],
          ["6857295", "53321101", "3", "77", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones oneway=yes oneway:bicycle=no smoothness=intermediate route_bicycle_rcn=yes", "", "2106", "210704"],
          ["6859775", "53321621", "1", "182", "1000", "0", "0", "0", "0", "highway=residential cycleway=opposite oneway=yes oneway:bicycle=no route_bicycle_rcn=yes", "", "2137", "213772"],
          ["6862581", "53322448", "0", "211", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes oneway:bicycle=no smoothness=intermediate", "", "2168", "216893"],
          ["6862698", "53322473", "0", "9", "1150", "0", "0", "0", "0", "highway=residential surface=paving_stones smoothness=intermediate", "", "2170", "217034"],
          ["6863922", "53322469", "0", "95", "1050", "0", "183", "0", "0", "reversedirection=yes highway=cycleway surface=paving_stones foot=yes smoothness=intermediate", "", "2185", "218562"],
          ["6868236", "53321863", "-1", "306", "1050", "0", "7", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes smoothness=good", "", "2230", "223045"],
          ["6868396", "53321868", "0", "12", "1050", "0", "1", "0", "0", "highway=cycleway", "", "2232", "223243"],
          ["6871719", "53323141", "0", "273", "1050", "0", "4", "0", "0", "reversedirection=yes highway=cycleway foot=yes", "", "2285", "228599"],
          ["6874820", "53323320", "0", "212", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "2320", "232094"],
          ["6879337", "53322599", "0", "319", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_rcn=yes", "", "2368", "236903"],
          ["6884580", "53324082", "-2", "420", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "2436", "243684"],
          ["6894919", "53324948", "0", "862", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes traffic_calming=table", "2577", "257813"],
          ["6896669", "53325927", "1", "166", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "2612", "261279"],
          ["6898591", "53325894", "0", "131", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=paved route_bicycle_rcn=yes", "", "2633", "263379"],
          ["6898550", "53325983", "0", "6", "1150", "0", "88", "0", "0", "highway=residential", "", "2634", "263469"],
          ["6898591", "53325894", "0", "6", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential", "", "2635", "263525"],
          ["6908986", "53326583", "0", "727", "1050", "0", "249", "0", "0", "reversedirection=yes highway=cycleway surface=paved", "", "2745", "274561"],
          ["6908948", "53326870", "0", "33", "1050", "0", "71", "0", "0", "reversedirection=yes highway=cycleway", "", "2751", "275196"],
          ["6908749", "53326881", "0", "14", "1450", "0", "75", "0", "0", "highway=tertiary oneway=yes", "", "2754", "275453"],
          ["6908612", "53326931", "0", "12", "5650", "0", "0", "0", "0", "highway=secondary bicycle=no junction=roundabout", "", "2762", "275488"],
          ["6908550", "53327007", "0", "10", "5650", "0", "21", "0", "0", "highway=secondary bicycle=no oneway=yes", "", "2768", "275488"],
          ["6908986", "53326583", "0", "76", "1050", "0", "220", "0", "0", "highway=cycleway", "", "2777", "276349"],
          ["6909192", "53324987", "0", "180", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway", "", "2801", "278773"],
          ["6909831", "53325054", "0", "44", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_rcn=yes", "", "2806", "279265"],
          ["6923265", "53328858", "0", "1070", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "2980", "296643"],
          ["6923963", "53329195", "1", "61", "1000", "0", "0", "0", "0", "highway=unclassified oneway=yes route_bicycle_rcn=yes", "", "2994", "298010"],
          ["6923808", "53329242", "1", "12", "1000", "0", "0", "0", "0", "highway=tertiary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2996", "298285"],
          ["6924033", "53329302", "1", "16", "5150", "0", "146", "0", "0", "reversedirection=yes highway=residential oneway=yes", "", "3008", "298569"],
          ["6923808", "53329242", "1", "16", "1150", "0", "0", "0", "0", "highway=residential oneway=yes", "", "3010", "298721"],
          ["6923701", "53329181", "1", "10", "1000", "0", "0", "0", "0", "highway=unclassified oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3011", "298821"],
          ["6923837", "53329135", "0", "11", "1000", "0", "0", "0", "0", "highway=tertiary oneway=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3012", "298930"],
          ["6923963", "53329195", "1", "11", "1000", "0", "0", "0", "0", "highway=unclassified oneway=yes route_bicycle_rcn=yes", "", "3013", "299050"],
          ["6924666", "53329463", "1", "57", "1150", "0", "1", "0", "0", "highway=residential oneway=yes", "", "3020", "299787"],
          ["6925593", "53329684", "2", "70", "1150", "0", "5", "0", "0", "highway=residential", "", "3033", "301070"],
          ["6925646", "53329634", "2", "7", "1150", "0", "39", "0", "0", "reversedirection=yes highway=residential cycleway=opposite oneway=yes", "", "3034", "301190"],
          ["6925679", "53329599", "2", "6", "1150", "0", "3", "0", "0", "highway=residential", "", "3035", "301293"],
          ["6925752", "53329510", "2", "12", "1350", "0", "0", "0", "0", "highway=service", "", "3037", "301475"],
          ["6925978", "53329510", "2", "21", "40000", "0", "180", "0", "0", "reversedirection=yes highway=steps", "", "3052", "301634"],
          ["6925783", "53329445", "2", "11", "5050", "0", "89", "0", "0", "highway=footway", "", "3060", "301706"],
          ["6925978", "53329510", "2", "11", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "", "3067", "301706"],
          ["6925752", "53329510", "2", "21", "40000", "0", "178", "0", "0", "highway=steps", "", "3081", "301706"],
          ["6925763", "53329496", "2", "2", "1350", "0", "87", "0", "0", "highway=service", "", "3081", "301726"],
          ["6925950", "53329459", "2", "16", "1350", "0", "32", "0", "0", "reversedirection=yes highway=service oneway=no", "", "3083", "301897"],
          ["6929391", "53331209", "1", "343", "1050", "0", "12", "0", "0", "reversedirection=yes highway=cycleway oneway=no", "", "3127", "306320"],
          ["6929824", "53331373", "0", "39", "5050", "0", "96", "0", "0", "highway=footway", "", "3153", "306320"],
          ["6929866", "53331363", "0", "4", "1350", "0", "60", "0", "0", "reversedirection=yes highway=service", "railway=level_crossing", "3153", "306361"],
          ["6930328", "53331899", "0", "75", "1350", "0", "93", "0", "0", "reversedirection=yes highway=service", "barrier=lift_gate", "3161", "307155"],
          ["6930395", "53332001", "0", "13", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service", "railway=level_crossing", "3162", "307314"],
          ["6930451", "53332085", "0", "11", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service", "", "3164", "307453"],
          ["6930723", "53332566", "1", "57", "1350", "0", "0", "0", "0", "highway=service", "", "3172", "308265"],
          ["6930982", "53332253", "0", "40", "1350", "0", "157", "0", "0", "highway=unclassified surface=asphalt smoothness=good", "railway=level_crossing", "3177", "308813"],
          ["6931078", "53332188", "0", "10", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt smoothness=good", "", "3179", "308948"],
          ["6932435", "53330987", "-1", "164", "1050", "0", "18", "0", "0", "highway=path foot=yes bicycle=yes", "", "3196", "310639"],
          ["6932561", "53330993", "-1", "9", "5050", "0", "47", "0", "0", "highway=path", "", "3201", "310647"],
          ["6946439", "53324408", "-1", "935", "5670", "0", "29", "0", "10000", "route=ferry", "", "3861", "317114"],
          ["7184863", "53339546", "-8192", "19059", "5670", "0", "215", "0", "0", "reversedirection=yes route=ferry", "", "17454", "484784"],
          ["7185207", "53339867", "-1", "44", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path access=destination foot=designated bicycle=designated", "", "17461", "485456"],
          ["7185273", "53339930", "-1", "9", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "", "17461", "485543"],
          ["7185789", "53339744", "0", "41", "1350", "0", "88", "0", "0", "reversedirection=yes highway=service", "", "17467", "486077"],
          ["7190239", "53343069", "1", "490", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified foot=yes bicycle=yes route_bicycle_rcn=yes", "", "17559", "495299"],
          ["7190987", "53344497", "1", "201", "1000", "0", "0", "0", "0", "highway=unclassified foot=yes bicycle=yes route_bicycle_rcn=yes", "", "17593", "498685"],
          ["7190297", "53344733", "2", "55", "1450", "0", "18", "0", "0", "reversedirection=yes highway=tertiary", "", "17599", "499305"],
          ["7189637", "53344920", "1", "50", "1050", "0", "2", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "barrier=yes access=yes", "17605", "499904"],
          ["7189105", "53345107", "0", "43", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "barrier=yes access=yes", "17610", "500405"],
          ["7188118", "53345429", "0", "77", "1050", "0", "4", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "", "17619", "501317"],
          ["7187457", "53345114", "1", "61", "1450", "0", "9", "0", "0", "reversedirection=yes highway=tertiary", "highway=bus_stop wheelchair=limited", "17629", "502331"],
          ["7186883", "53345118", "2", "47", "1450", "0", "15", "0", "0", "reversedirection=yes highway=tertiary", "barrier=lift_gate access=yes", "17639", "503288"],
          ["7186845", "53345131", "2", "3", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "railway=level_crossing", "17640", "503360"],
          ["7186816", "53345141", "2", "3", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "railway=level_crossing", "17640", "503432"],
          ["7186806", "53345145", "2", "1", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "railway=level_crossing", "17641", "503455"],
          ["7186727", "53345173", "3", "7", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "barrier=lift_gate access=yes", "17642", "503630"],
          ["7186396", "53345288", "3", "27", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "barrier=gate access=yes", "17649", "504265"],
          ["7186304", "53345325", "2", "8", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "", "17650", "504431"],
          ["7186300", "53345720", "3", "49", "1450", "0", "10", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "highway=crossing crossing=unknown", "17661", "505456"],
          ["7187772", "53346949", "2", "221", "1050", "0", "107", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=yes", "", "17687", "508103"],
          ["7187659", "53346954", "2", "8", "1350", "0", "80", "0", "0", "reversedirection=yes highway=unclassified", "", "17688", "508210"],
          ["7187589", "53347807", "1", "96", "1650", "0", "79", "0", "0", "reversedirection=yes highway=secondary surface=asphalt", "highway=bus_stop", "17700", "509418"],
          ["7190268", "53350834", "-1", "388", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt", "highway=bus_stop", "17758", "515166"],
          ["7195235", "53355839", "0", "653", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt", "", "17867", "526054"],
          ["7200280", "53361038", "1", "689", "1650", "0", "24", "0", "0", "reversedirection=yes highway=secondary surface=asphalt cycleway=lane", "railway=level_crossing", "17986", "538001"],
          ["7202138", "53360939", "2", "128", "1650", "0", "3", "0", "0", "reversedirection=yes highway=secondary surface=asphalt cycleway=track", "highway=traffic_signals crossing=traffic_signals", "18004", "539774"],
          ["7202577", "53361575", "2", "80", "1450", "0", "69", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "railway=level_crossing", "18017", "541063"],
          ["7202729", "53361722", "2", "20", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "", "18020", "541403"],
          ["7202876", "53361666", "2", "5", "1350", "0", "91", "0", "0", "highway=service oneway=yes", "", "18021", "541483"],
          ["7202729", "53361722", "2", "5", "5350", "0", "0", "0", "0", "reversedirection=yes highway=service oneway=yes", "", "18024", "541483"],
          ["7204036", "53363067", "5", "175", "1450", "0", "89", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "highway=crossing crossing=uncontrolled", "18053", "544342"],
          ["7204142", "53363184", "5", "15", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "", "18056", "544628"],
          ["7204354", "53363428", "5", "32", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane", "", "18062", "545240"],
          ["7204764", "53363743", "5", "47", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "highway=crossing crossing=uncontrolled", "18070", "546030"],
          ["7204983", "53363882", "5", "22", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "highway=crossing crossing=uncontrolled", "18073", "546380"],
          ["7205844", "53364741", "3", "119", "1450", "0", "1", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "highway=bus_stop", "18090", "548039"],
          ["7205739", "53366016", "7", "149", "1450", "0", "1", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "highway=bus_stop", "18114", "550471"],
          ["7205492", "53366549", "7", "63", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "highway=traffic_signals traffic_signals:direction=forward", "18128", "551844"],
          ["7205460", "53366686", "7", "16", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane", "", "18131", "552163"],
          ["7205493", "53366782", "7", "12", "1450", "0", "6", "0", "0", "highway=tertiary surface=paving_stones cycleway=lane", "highway=traffic_signals crossing=traffic_signals traffic_signals:direction=unknown", "18133", "552390"],
          ["7206110", "53366846", "6", "45", "1450", "0", "18", "0", "0", "highway=tertiary surface=paving_stones foot=use_sidepath cycleway=lane oneway=no", "highway=traffic_signals crossing=unknown traffic_signals:direction=unknown", "18138", "552885"],
          ["7206349", "53366861", "6", "17", "1450", "0", "0", "0", "0", "highway=tertiary surface=paving_stones foot=use_sidepath cycleway=lane oneway=no", "", "18140", "553054"],
          ["7206342", "53367008", "6", "17", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paving_stones foot=use_sidepath cycleway=lane oneway=no route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=unknown traffic_signals:direction=unknown", "18141", "553226"],
          ["7206340", "53367042", "6", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paving_stones foot=use_sidepath cycleway=lane oneway=no route_bicycle_lcn=yes", "", "18142", "553269"],
          ["7206318", "53367570", "6", "59", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane oneway=no route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=both", "18149", "553958"],
          ["7206315", "53367640", "6", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "", "18150", "554061"],
          ["7208370", "53367793", "4", "140", "1150", "0", "84", "0", "0", "highway=residential surface=asphalt oneway=yes", "", "18168", "555865"],
          ["7208654", "53367159", "5", "74", "1150", "0", "79", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "18177", "556786"],
          ["7207653", "53367141", "5", "67", "1150", "0", "108", "0", "0", "reversedirection=yes highway=residential surface=asphalt bicycle=designated vehicle=yes oneway=no bicycle_road=yes", "", "18187", "557746"],
          ["7207122", "53367134", "6", "36", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential bicycle=designated vehicle=no oneway=no bicycle_road=yes", "", "18192", "558326"],
          ["7206342", "53367008", "6", "55", "1150", "0", "4", "0", "0", "reversedirection=yes highway=living_street bicycle=designated vehicle=no bicycle_road=yes", "highway=traffic_signals crossing=unknown traffic_signals:direction=unknown", "18201", "559225"],
          ["7206340", "53367042", "6", "4", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=paving_stones foot=use_sidepath cycleway=lane oneway=no route_bicycle_lcn=yes", "", "18202", "559291"],
          ["7206318", "53367570", "6", "59", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane oneway=no route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=both", "18212", "560268"],
          ["7206258", "53367995", "6", "48", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "", "18220", "561106"],
          ["7205822", "53367981", "6", "31", "1050", "0", "83", "0", "0", "highway=footway foot=designated bicycle=designated", "", "18226", "561662"],
          ["7204374", "53367840", "7", "101", "1150", "0", "1", "0", "0", "highway=living_street surface=paving_stones oneway=no", "", "18246", "563643"],
          ["7202472", "53367745", "5", "124", "1150", "0", "2", "0", "0", "reversedirection=yes highway=living_street surface=paving_stones oneway=no", "", "18266", "565675"],
          ["7204374", "53367840", "7", "124", "1150", "0", "2", "0", "0", "highway=living_street surface=paving_stones oneway=no", "", "18283", "567360"],
          ["7205822", "53367981", "6", "101", "1150", "0", "1", "0", "0", "reversedirection=yes highway=living_street surface=paving_stones oneway=no", "", "18297", "568815"],
          ["7206258", "53367995", "6", "31", "1050", "0", "0", "0", "0", "reversedirection=yes highway=footway foot=designated bicycle=designated", "", "18302", "569249"],
          ["7206212", "53368296", "6", "34", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "18307", "569777"],
          ["7206191", "53368421", "6", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "", "18309", "569973"],
          ["7206152", "53368836", "4", "48", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane oneway=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "18315", "570566"],
          ["7206130", "53368977", "4", "16", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=lane oneway=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "18317", "570742"],
          ["7206131", "53369381", "3", "47", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "18322", "571252"],
          ["7211852", "53370452", "4", "402", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=bus_stop", "18386", "577682"],
          ["7213226", "53370705", "3", "96", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=lane route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "18401", "579168"],
          ["7214263", "53371326", "3", "108", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "18419", "580968"],
          ["7214336", "53371257", "3", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=compacted foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "18420", "581054"],
          ["7214263", "53371326", "3", "5", "1000", "0", "0", "0", "0", "highway=path surface=compacted foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "18420", "581100"],
          ["7214965", "53371604", "2", "57", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_lcn=yes", "", "18425", "581623"],
          ["7215673", "53371629", "2", "52", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=track route_bicycle_lcn=yes", "", "18431", "582158"],
          ["7218769", "53370711", "2", "237", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=lane route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=bus_stop", "18465", "585625"],
          ["7219432", "53370343", "2", "61", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=lane route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "18476", "586722"],
          ["7226743", "53369883", "3", "545", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=lane route_bicycle_lcn=yes", "", "18571", "596157"],
          ["7228323", "53369983", "1", "107", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=track route_bicycle_lcn=yes", "", "18587", "597739"],
          ["7231922", "53370848", "0", "271", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=lane route_bicycle_lcn=yes", "", "18626", "601730"],
          ["7232442", "53371369", "0", "68", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=lane", "highway=traffic_signals crossing=traffic_signals", "18633", "602418"],
          ["7237741", "53373848", "0", "471", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt foot=yes cycleway=lane", "", "18705", "609602"],
          ["7244297", "53375022", "0", "469", "1450", "0", "1", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=track", "highway=bus_stop", "18774", "616445"],
          ["7250744", "53376698", "0", "464", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=track", "", "18851", "624167"],
          ["7250476", "53376558", "0", "2", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track", "", "18851", "624185"],
          ["7250750", "53376250", "0", "40", "1050", "0", "73", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "", "18855", "624578"],
          ["7250513", "53376189", "0", "1", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=fine_gravel foot=designated bicycle=designated oneway=no route_bicycle_lcn=yes", "", "18855", "624589"],
          ["7259710", "53382674", "0", "1243", "1000", "0", "0", "0", "0", "highway=path surface=fine_gravel foot=designated bicycle=designated oneway=no route_bicycle_lcn=yes", "", "19052", "644274"],
          ["7267374", "53389270", "-2", "1003", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated oneway=no route_bicycle_lcn=yes", "", "19208", "659892"],
          ["7267489", "53389309", "-2", "9", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_lcn=yes", "", "19210", "660062"],
          ["7282181", "53396790", "-2", "1533", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_lcn=yes", "", "19470", "686141"],
          ["7288855", "53399447", "-1", "541", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=compacted route_bicycle_lcn=yes", "", "19554", "694491"],
          ["7286215", "53406611", "-2", "819", "1350", "0", "62", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt", "", "19684", "707479"],
          ["7285738", "53406563", "-2", "4", "5050", "0", "85", "0", "0", "highway=track tracktype=grade5", "", "19687", "707518"],
          ["7286215", "53406611", "-2", "4", "5050", "0", "0", "0", "0", "reversedirection=yes highway=track tracktype=grade5", "", "19689", "707518"],
          ["7291924", "53409338", "-2", "486", "1350", "0", "11", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt", "", "19763", "714904"],
          ["7291275", "53409424", "-2", "11", "1350", "0", "146", "0", "0", "highway=service", "", "19765", "715066"],
          ["7291924", "53409338", "-2", "11", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service", "", "19766", "715170"],
          ["7305305", "53410494", "-2", "913", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_lcn=yes", "", "19912", "729747"],
          ["7315910", "53416363", "-2", "1046", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "20090", "747593"],
          ["7315753", "53416396", "-2", "9", "5350", "0", "102", "0", "0", "reversedirection=yes highway=service oneway=yes", "", "20096", "747697"],
          ["7315910", "53416363", "-2", "9", "1350", "0", "2", "0", "0", "highway=service oneway=yes", "", "20097", "747781"],
          ["7315972", "53416459", "-2", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "20098", "747898"],
          ["7319658", "53431329", "-1", "2764", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified tracktype=grade2 surface=paving_stones access=yes route_bicycle_lcn=yes", "", "20549", "792992"],
          ["7320225", "53436437", "-1", "576", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "20637", "801730"],
          ["7323935", "53440219", "-1", "497", "1450", "0", "3", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "", "20721", "810168"],
          ["7317230", "53439440", "-2", "457", "1150", "0", "144", "0", "0", "reversedirection=yes highway=residential", "direction=backward", "20786", "816641"],
          ["7316655", "53439417", "-1", "40", "1150", "0", "4", "0", "0", "reversedirection=yes highway=residential", "", "20792", "817279"],
          ["7310526", "53443778", "-3", "838", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "20921", "830159"],
          ["7308373", "53442427", "-1", "201", "1350", "0", "130", "0", "0", "reversedirection=yes highway=unclassified surface=paved", "", "20959", "833996"]
        ],
        "times": [0, 0.463, 4.916, 12.45, 112.323, 113.133, 114.269, 114.92, 115.734, 117.203, 118.348, 120.157, 121.269, 122.535, 125.228, 130.032, 134.6, 137.436, 140.506, 152.457, 165.727, 178.566, 180.292, 181.998, 183.686, 185.172, 188.112, 190.494, 193.049, 219.72, 225.674, 228.331, 236.3, 244.185, 253.413, 261.137, 270.894, 290.273, 314.87, 326.614, 334.565, 340.004, 345.672, 360.65, 365.016, 372.754, 379.869, 396.515, 401.659, 407.189, 409, 410.686, 413.858, 415.617, 417.385, 431.569, 436.173, 442.663, 447.894, 450.363, 452.817, 455.928, 461.702, 467.063, 468.043, 470.83, 471.487, 486.213, 492.351, 495.426, 500.936, 508.694, 512.351, 523.047, 533.793, 536.173, 543.589, 545.438, 548.544, 549.63, 552.503, 553.751, 564.418, 570.265, 573.241, 582.463, 585.941, 586.938, 587.981, 592.085, 595.666, 598.654, 605.074, 615.258, 623.749, 647.625, 649.493, 651.869, 675.772, 683.471, 686.391, 690.688, 694.809, 696.049, 707.544, 720.532, 737.048, 749.247, 770.464, 778.428, 788.972, 794.786, 807.872, 820.696, 826.714, 829.727, 831.299, 832.882, 836.714, 840.263, 842.211, 844.167, 865.137, 868.132, 870.795, 875.652, 879.305, 911.333, 944.948, 968.935, 973.7, 979.31, 996.15, 1008.798, 1014.813, 1021.761, 1036.241, 1036.878, 1037.3, 1037.93, 1039.265, 1040.361, 1041.872, 1052.588, 1058.93, 1061.709, 1063.27, 1065.473, 1070.414, 1071.702, 1073.155, 1075.913, 1077.705, 1081.102, 1084.554, 1087.553, 1091.23, 1092.473, 1093.88, 1096.877, 1097.989, 1098.64, 1106.401, 1106.528, 1125.08, 1144.873, 1147.383, 1149.918, 1151.673, 1153.116, 1159.431, 1162.512, 1164.128, 1165.765, 1167.423, 1173.706, 1176.265, 1178.917, 1190.205, 1193.462, 1195.075, 1205.807, 1216.485, 1231.457, 1245.001, 1264.344, 1271.013, 1280.493, 1284.176, 1286.613, 1288.521, 1290.076, 1290.26, 1291.689, 1292.792, 1294.372, 1296.379, 1306.316, 1315.933, 1316.236, 1330.874, 1352.623, 1365.251, 1370.612, 1374.192, 1377.146, 1378.801, 1382.163, 1383.402, 1385.902, 1387.245, 1388.756, 1390.37, 1391.974, 1393.302, 1394.619, 1396.018, 1398.572, 1403.778, 1432.417, 1435.784, 1437.722, 1444.684, 1446.942, 1451.126, 1456.842, 1459.641, 1466.283, 1475.76, 1505.293, 1528.932, 1538.775, 1558.682, 1562.748, 1571.806, 1577.441, 1602.949, 1611.69, 1614.146, 1617.457, 1623.827, 1625.306, 1626.128, 1627.942, 1633.9, 1638.06, 1646.052, 1647.479, 1648.24, 1649.27, 1651.232, 1658.87, 1663.328, 1671.449, 1675.655, 1680.116, 1701.572, 1718.371, 1728.453, 1743.219, 1745.339, 1747.316, 1750.744, 1755.241, 1757.232, 1757.958, 1766.987, 1788.184, 1793.689, 1811.59, 1819.504, 1821.558, 1825.055, 1833.663, 1835.074, 1840.994, 1842.146, 1844.089, 1844.949, 1846.778, 1848.745, 1852.234, 1863.22, 1866.679, 1869.26, 1872.065, 1876.255, 1879.096, 1883.019, 1885.948, 1887.698, 1895.327, 1901.053, 1905.772, 1908.809, 1911.434, 1913.941, 1918.451, 1920.445, 1925.342, 1927.377, 1928.261, 1929.151, 1930.951, 1934.517, 1942.248, 1944.022, 1945.803, 1952.028, 1958.362, 1966.062, 1970.593, 1978.266, 1985.603, 1990.26, 2009.187, 2011.041, 2015.242, 2024.691, 2028.229, 2030.755, 2033.618, 2036.983, 2039.339, 2046.907, 2048.881, 2052.081, 2052.611, 2054.549, 2059.325, 2063.385, 2064.872, 2067.295, 2079.049, 2080.711, 2082.862, 2084.103, 2088.24, 2091.518, 2096.318, 2102.757, 2106.885, 2112.701, 2116.155, 2120.83, 2123.752, 2127.86, 2128.885, 2130.645, 2137.569, 2145.062, 2151.396, 2160.539, 2168.778, 2170.188, 2171.606, 2177.832, 2181.554, 2183.508, 2185.469, 2194.622, 2195.974, 2196.882, 2199.176, 2203.658, 2205.691, 2208.927, 2210.226, 2216.763, 2217.797, 2219.289, 2223.703, 2226.499, 2227.911, 2229.331, 2230.282, 2231.236, 2232.258, 2234.977, 2239.048, 2243.722, 2248.141, 2253.086, 2268.854, 2276.991, 2285.811, 2290.094, 2294.699, 2299.834, 2320.761, 2331.746, 2335.431, 2338.915, 2360.995, 2368.824, 2372.128, 2375.829, 2379.408, 2382.886, 2386.844, 2391.445, 2395.688, 2399.075, 2401.939, 2416.591, 2421.983, 2425.436, 2429.332, 2432.317, 2434.324, 2435.197, 2435.635, 2435.993, 2436.632, 2438.019, 2456.823, 2459.843, 2463.889, 2467.549, 2471.781, 2475.217, 2481.827, 2488.672, 2492.177, 2496.523, 2499.523, 2511.445, 2514.874, 2519.734, 2522.167, 2528.721, 2530.949, 2534.651, 2538.949, 2545.885, 2549.463, 2553.032, 2556.255, 2572.454, 2577.915, 2581.41, 2586.836, 2590.063, 2591.746, 2599.194, 2610.283, 2612.569, 2620.818, 2626.461, 2631.638, 2633.57, 2634.472, 2635.028, 2636.48, 2642.64, 2644.611, 2649.47, 2660.331, 2661.397, 2684.806, 2702.293, 2705.793, 2714.48, 2719.502, 2724.025, 2727.881, 2733.604, 2734.49, 2735.473, 2737.364, 2740.311, 2741.745, 2745.375, 2750.126, 2751.721, 2754.29, 2756.456, 2758.39, 2762.274, 2765.529, 2768.826, 2769.555, 2770.412, 2771.921, 2773.653, 2774.566, 2777.433, 2785.085, 2800.635, 2801.666, 2806.588, 2812.853, 2818.763, 2828.128, 2838.196, 2845.576, 2849.394, 2855.599, 2862.538, 2864.47, 2865.345, 2866.393, 2874.659, 2880.582, 2886.885, 2901.896, 2904.194, 2909.611, 2912.933, 2916.227, 2921.568, 2928.006, 2933.189, 2937.658, 2951.082, 2963.528, 2967.29, 2980.348, 2982.426, 2985.264, 2991.399, 2994.016, 2996.765, 3008.594, 3010.108, 3011.105, 3012.203, 3013.396, 3014.635, 3016.155, 3017.814, 3020.768, 3022.366, 3023.329, 3030.25, 3032.119, 3033.6, 3034.803, 3035.319, 3035.833, 3037.65, 3047.616, 3052.559, 3058.92, 3060.335, 3061.623, 3067.453, 3072.06, 3081.275, 3081.484, 3082.332, 3082.643, 3083.191, 3083.976, 3087.041, 3089.685, 3100.388, 3102.481, 3104.414, 3107.656, 3109.612, 3118.682, 3121.08, 3127.225, 3127.415, 3132.638, 3137.853, 3153.042, 3153.365, 3153.457, 3154.089, 3161.392, 3162.985, 3164.375, 3172.485, 3176.277, 3177.397, 3177.963, 3179.315, 3180.225, 3180.502, 3196.23, 3201.946, 3245.619, 3838.729, 3861.544, 3882.451, 4474.797, 4522.565, 4570.393, 5168.574, 5372.274, 5580.98, 6365.057, 7491.498, 8028.272, 8080.449, 8114.024, 8186.678, 8482.776, 9178.164, 9241.774, 9279.656, 9804.518, 11450.744, 11596.553, 13694.334, 13874.45, 14549.886, 14717.516, 16729.641, 16761.09, 16788.25, 16818.27, 16841.141, 16861.869, 16879.736, 16896.891, 16919.762, 17327.168, 17347.896, 17365.764, 17401.502, 17418.656, 17433.666, 17447.961, 17454.393, 17458.762, 17460.273, 17461.113, 17461.984, 17467.322, 17484.053, 17486.711, 17487.877, 17489.121, 17500.221, 17509.889, 17511.008, 17512.914, 17514.373, 17519.957, 17553.107, 17559.529, 17563.34, 17577.469, 17578.383, 17580.199, 17582.564, 17585.26, 17587.125, 17591.965, 17593.389, 17594.979, 17595.348, 17596.396, 17597.188, 17599.584, 17602.521, 17603.631, 17605.572, 17606.449, 17607.91, 17610.588, 17611.055, 17615.449, 17616.762, 17618.713, 17619.701, 17620.699, 17621.771, 17622.92, 17624.07, 17629.84, 17631.055, 17631.982, 17633.752, 17634.92, 17637.119, 17638.959, 17639.412, 17640.135, 17640.848, 17641.084, 17642.832, 17644.533, 17649.176, 17650.838, 17651.66, 17652.879, 17653.885, 17655.797, 17657.051, 17658.492, 17661.086, 17661.51, 17662.479, 17663.486, 17664.215, 17665.18, 17666.826, 17667.688, 17668.35, 17669.139, 17669.945, 17670.889, 17672.633, 17674.953, 17676.902, 17679.062, 17681.58, 17684.195, 17687.551, 17688.623, 17700.695, 17702.104, 17704.84, 17707.199, 17708.633, 17711.355, 17722.783, 17728.744, 17732.191, 17758.162, 17768.402, 17782.721, 17790.172, 17802.949, 17803.805, 17805.221, 17806.623, 17817.678, 17818.783, 17825.986, 17852.805, 17867.041, 17887.969, 17898.537, 17960.588, 17962.684, 17970.045, 17972.314, 17974.268, 17976.064, 17977.986, 17980.768, 17982.727, 17983.309, 17984.08, 17985.039, 17985.23, 17986.508, 17989.725, 17990.086, 17994.318, 17996.371, 17999.225, 18004.238, 18006.254, 18008.762, 18010.025, 18013.529, 18017.119, 18020.527, 18021.324, 18024.578, 18025.566, 18036.186, 18053.164, 18056.02, 18059.408, 18062.139, 18064.121, 18066.469, 18068.146, 18068.934, 18070.039, 18071.943, 18073.539, 18081.383, 18083.334, 18084.758, 18085.766, 18087.371, 18089.756, 18090.125, 18090.979, 18096.184, 18097.088, 18099.607, 18101.529, 18104.262, 18108.43, 18111.498, 18114.441, 18119.943, 18125.504, 18128.166, 18131.354, 18132.723, 18133.627, 18134.35, 18135.248, 18135.34, 18138.578, 18140.262, 18141.988, 18142.41, 18149.303, 18150.33, 18152.441, 18156.385, 18158.588, 18161.141, 18168.369, 18168.631, 18177.574, 18181.893, 18187.17, 18190.543, 18192.971, 18195.572, 18200.648, 18201.965, 18202.623, 18212.391, 18213.721, 18220.77, 18221.643, 18223.383, 18226.338, 18232.109, 18236.865, 18238.986, 18246.143, 18247.488, 18248.631, 18250.33, 18254.598, 18260.037, 18266.461, 18272.625, 18276.746, 18280.049, 18281.371, 18282.262, 18283.307, 18288.52, 18290.162, 18293.613, 18297.85, 18300.062, 18301.477, 18302.191, 18307.463, 18309.426, 18311.053, 18313.312, 18315.359, 18317.111, 18318.484, 18320.295, 18320.516, 18322.217, 18326.9, 18328.531, 18344.115, 18354.348, 18361.539, 18383.844, 18386.518, 18388.021, 18401.373, 18402.566, 18406.752, 18407.723, 18408.859, 18412.844, 18416.115, 18417.832, 18419.373, 18420.229, 18420.691, 18424.074, 18425.924, 18426.969, 18427.459, 18428.572, 18429.199, 18431.273, 18437.74, 18446.68, 18450.357, 18454.803, 18459.068, 18462.965, 18464.893, 18465.941, 18476.906, 18481.869, 18493.941, 18499.842, 18501.85, 18504.629, 18506.342, 18507.646, 18509.41, 18511.5, 18512.709, 18516.082, 18521.881, 18536.525, 18541.514, 18543.393, 18548.793, 18553.152, 18559.189, 18566.939, 18571.252, 18577.746, 18582.127, 18584.227, 18587.066, 18591.279, 18593.166, 18598.324, 18598.799, 18612.521, 18615.303, 18617.18, 18619.998, 18622.891, 18624.771, 18626.602, 18626.971, 18630.973, 18633.848, 18639.863, 18645.949, 18654.654, 18657.361, 18659.77, 18662.348, 18663.891, 18668.789, 18678.691, 18689.064, 18699.527, 18705.674, 18706.65, 18711.514, 18718.285, 18728.934, 18736.598, 18740.061, 18743.766, 18747.107, 18756.75, 18768.584, 18771.23, 18774.098, 18780.066, 18794.949, 18797.113, 18800.377, 18801.889, 18805.666, 18813.168, 18817.385, 18832.709, 18836.771, 18841.191, 18843.33, 18846.664, 18850.924, 18851.314, 18851.492, 18853.518, 18855.424, 18855.527, 18855.619, 18857.811, 18859.824, 18863.342, 18866, 18867.848, 18869.611, 18876.914, 18880.33, 18882.822, 18884.797, 18886.523, 18888.426, 18891.434, 18894.473, 18897.73, 18902.17, 18907.762, 18911.133, 18913.777, 18914.605, 18915.268, 18916.824, 18919.182, 18922.197, 18929.51, 18933.746, 18938.053, 18940.787, 18946.545, 18963.428, 18971.971, 18982.623, 18987.787, 18992.232, 18996.285, 19002.904, 19007.395, 19009.281, 19011.822, 19014.562, 19023.127, 19027.574, 19031.418, 19036.051, 19040.252, 19043.865, 19052.352, 19057.99, 19061.789, 19065.115, 19070.229, 19076.098, 19082.809, 19083.562, 19087.693, 19092.945, 19095.557, 19098.684, 19103.418, 19107.234, 19113.961, 19122.492, 19128.885, 19135.068, 19143.316, 19151.342, 19158.119, 19164.404, 19171.205, 19178.266, 19181.834, 19190.072, 19192.744, 19195.746, 19198.256, 19200.5, 19203.488, 19206.6, 19208.508, 19210.205, 19214.041, 19219.182, 19228.281, 19234.74, 19237.854, 19242.324, 19250.979, 19254.465, 19259.291, 19264.631, 19269.367, 19272.891, 19284.854, 19293.672, 19302.287, 19309.199, 19320.049, 19324.59, 19330.072, 19339.531, 19343.895, 19349.277, 19360.1, 19365.693, 19371.145, 19375.541, 19380.734, 19385.025, 19392.051, 19398.148, 19410.719, 19431.311, 19439.609, 19443.936, 19447.174, 19454.307, 19470.953, 19475.633, 19479.918, 19491.045, 19495.723, 19500.947, 19506.928, 19528.865, 19554.432, 19554.941, 19565.475, 19588.299, 19637.963, 19684.305, 19687.168, 19689.748, 19763.611, 19765.234, 19766.266, 19767.305, 19788.385, 19811.672, 19826.254, 19847.963, 19912.033, 19912.918, 19914.502, 19916.145, 19935.73, 19942.611, 19946.701, 19952.459, 19955.043, 19957.102, 19960.201, 19964.512, 19973.438, 19976.828, 19987.115, 19991.135, 20001.32, 20003.914, 20006.193, 20016.387, 20018.375, 20021.193, 20026.516, 20028.295, 20030.416, 20036.357, 20037.814, 20041.881, 20042.896, 20043.912, 20045.816, 20048.055, 20053.709, 20055.664, 20059.428, 20062.928, 20065.338, 20069.535, 20072.412, 20081.619, 20084.25, 20086.658, 20089.219, 20090.486, 20095.535, 20096.979, 20097.162, 20097.818, 20098.986, 20099.592, 20100.213, 20100.846, 20102.486, 20103.396, 20104.807, 20106.729, 20140.271, 20156.729, 20159.73, 20162.244, 20165.26, 20170.365, 20181.715, 20186.949, 20191.885, 20197.551, 20202.922, 20210.113, 20219.51, 20222.264, 20224.52, 20226.627, 20243.9, 20264.934, 20278.111, 20303.746, 20309.086, 20309.461, 20320.055, 20325.539, 20326.805, 20347.188, 20367.955, 20370.891, 20371.447, 20374.121, 20399.518, 20401.104, 20415.262, 20418.107, 20421.541, 20424.107, 20437.518, 20442.736, 20447.676, 20462.848, 20537.721, 20543.748, 20549.908, 20552.898, 20563.016, 20567.605, 20575.17, 20580.398, 20584.064, 20622, 20631.986, 20637.279, 20638.416, 20642.006, 20644.73, 20653.568, 20685.768, 20692.5, 20695.639, 20711.346, 20721.025, 20721.654, 20724.256, 20729.258, 20731.066, 20786.387, 20789.666, 20791.242, 20792.764, 20794.961, 20797.324, 20799.842, 20802.336, 20810.605, 20818.178, 20828.631, 20840.107, 20842.797, 20846.887, 20854.404, 20877.053, 20879.777, 20882.326, 20884.531, 20885.754, 20886.941, 20888.396, 20909.027, 20912.258, 20915.311, 20918.529, 20921.555, 20925.008, 20929.953, 20935.256, 20936.406, 20937.547, 20944.053, 20949.83, 20955.824, 20959.92]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [6.697707, 53.323654, -1.75],
          [6.697740, 53.323686, -1.75],
          [6.698063, 53.323993, -1.25],
          [6.698554, 53.324460, -1.5],
          [6.703654, 53.329213, -2.0],
          [6.703682, 53.329254, -2.0],
          [6.703690, 53.329308, -2.0],
          [6.703682, 53.329336, -2.0],
          [6.703669, 53.329380, -2.0],
          [6.703639, 53.329456, -2.0],
          [6.703737, 53.329475, -2.0],
          [6.704005, 53.329527, -2.0],
          [6.704165, 53.329538, -2.0],
          [6.704344, 53.329542, -2.0],
          [6.704696, 53.329520, -2.0],
          [6.705250, 53.329425, -2.0],
          [6.705713, 53.329301, -2.0],
          [6.705959, 53.329216, -1.75],
          [6.706161, 53.329105, -1.5],
          [6.707022, 53.328566, -2.25],
          [6.707874, 53.328058, -2.0],
          [6.708595, 53.327701, -1.0],
          [6.708705, 53.327659, -1.0],
          [6.708823, 53.327625, -1.0],
          [6.708946, 53.327598, -1.0],
          [6.709060, 53.327582, -1.0],
          [6.709293, 53.327571, -1.0],
          [6.709502, 53.327567, -1.25],
          [6.709729, 53.327585, -1.5],
          [6.712269, 53.327912, -2.0],
          [6.712802, 53.327954, -2.0],
          [6.713044, 53.327961, -2.25],
          [6.713793, 53.327940, -2.25],
          [6.714546, 53.327893, -2.5],
          [6.715302, 53.327816, -2.0],
          [6.715926, 53.327767, -1.75],
          [6.716700, 53.327727, -1.5],
          [6.718393, 53.327658, -1.75],
          [6.720485, 53.327607, -1.5],
          [6.721808, 53.327604, -3.0],
          [6.722569, 53.327642, -2.75],
          [6.723062, 53.327694, -2.75],
          [6.723543, 53.327759, -2.5],
          [6.724875, 53.327965, -2.75],
          [6.725220, 53.328096, -3.0],
          [6.725755, 53.328351, -2.75],
          [6.726221, 53.328576, -2.5],
          [6.726856, 53.329079, -1.0],
          [6.727090, 53.329247, -1.0],
          [6.727416, 53.329421, -1.25],
          [6.727536, 53.329472, -1.25],
          [6.727663, 53.329516, -1.5],
          [6.727933, 53.329586, -1.75],
          [6.728086, 53.329611, -1.75],
          [6.728243, 53.329629, -1.75],
          [6.729472, 53.329688, -1.5],
          [6.729817, 53.329743, -1.0],
          [6.730283, 53.329872, -1.0],
          [6.730658, 53.329999, -1.0],
          [6.730827, 53.330049, -0.75],
          [6.731017, 53.330090, -1.0],
          [6.731282, 53.330135, -1.25],
          [6.731855, 53.330190, -1.75],
          [6.732342, 53.330228, -1.5],
          [6.732431, 53.330223, -1.5],
          [6.732668, 53.330185, -1.5],
          [6.732723, 53.330186, -1.5],
          [6.733956, 53.330359, -1.25],
          [6.734510, 53.330414, -1.5],
          [6.734793, 53.330463, -1.75],
          [6.735330, 53.330517, -2.0],
          [6.736064, 53.330589, -2.0],
          [6.736390, 53.330644, -2.0],
          [6.737293, 53.330868, -2.0],
          [6.738132, 53.331101, -1.75],
          [6.738313, 53.331118, -1.5],
          [6.738889, 53.331123, -1.25],
          [6.739018, 53.331081, -1.25],
          [6.739254, 53.331028, -1.25],
          [6.739320, 53.330997, -1.25],
          [6.739390, 53.330862, -1.25],
          [6.739459, 53.330824, -1.25],
          [6.740281, 53.330537, -1.5],
          [6.740697, 53.330389, -1.25],
          [6.740900, 53.330301, -1.25],
          [6.741668, 53.330048, -1.75],
          [6.741976, 53.329955, -2.0],
          [6.742095, 53.329907, -2.0],
          [6.742233, 53.329863, -2.0],
          [6.742747, 53.329715, -1.75],
          [6.743140, 53.329568, -2.0],
          [6.743457, 53.329449, -2.25],
          [6.744130, 53.329210, -2.75],
          [6.744887, 53.328960, -1.5],
          [6.745449, 53.328762, -1.0],
          [6.747167, 53.328179, -1.0],
          [6.747312, 53.328135, -1.0],
          [6.747494, 53.328084, -1.0],
          [6.748919, 53.327521, 0.0],
          [6.749555, 53.327257, -0.75],
          [6.749810, 53.327182, -0.75],
          [6.750165, 53.327045, -1.0],
          [6.750514, 53.326938, -1.0],
          [6.750620, 53.326905, -1.0],
          [6.751525, 53.326616, -0.75],
          [6.752509, 53.326318, -0.5],
          [6.753606, 53.325889, 0.0],
          [6.754572, 53.325537, -0.5],
          [6.756233, 53.324947, -0.5],
          [6.756818, 53.324755, -0.25],
          [6.757624, 53.324455, -0.5],
          [6.758072, 53.324263, -0.75],
          [6.759170, 53.323833, -1.25],
          [6.760137, 53.323466, -1.0],
          [6.760564, 53.323279, -1.0],
          [6.760753, 53.323164, -1.0],
          [6.760842, 53.323094, -1.25],
          [6.760921, 53.323019, -1.25],
          [6.761089, 53.322829, -1.25],
          [6.761227, 53.322657, -1.25],
          [6.761311, 53.322570, -1.25],
          [6.761405, 53.322479, -1.25],
          [6.762287, 53.321415, -1.5],
          [6.762391, 53.321273, -1.5],
          [6.762464, 53.321147, -1.25],
          [6.762627, 53.320937, -1.0],
          [6.762787, 53.320787, -1.0],
          [6.764154, 53.319111, -2.0],
          [6.765428, 53.317482, -2.0],
          [6.766290, 53.316439, -1.5],
          [6.766509, 53.316226, -1.5],
          [6.766711, 53.315938, -1.75],
          [6.767438, 53.315064, -2.0],
          [6.767963, 53.314458, -2.0],
          [6.768247, 53.314185, -2.0],
          [6.768547, 53.313915, -1.5],
          [6.769037, 53.313445, -0.25],
          [6.769060, 53.313433, -0.25],
          [6.769073, 53.313417, -0.25],
          [6.769073, 53.313398, -0.25],
          [6.769046, 53.313349, 0.0],
          [6.769025, 53.313306, 0.0],
          [6.769047, 53.313252, 0.0],
          [6.769466, 53.312816, -0.25],
          [6.769756, 53.312517, -0.75],
          [6.769886, 53.312385, -1.0],
          [6.769995, 53.312326, -1.0],
          [6.770034, 53.312205, -1.0],
          [6.770102, 53.311936, -1.0],
          [6.770095, 53.311871, -1.0],
          [6.770053, 53.311797, -1.0],
          [6.770277, 53.311724, -1.0],
          [6.770233, 53.311635, -1.0],
          [6.770158, 53.311450, -1.25],
          [6.770067, 53.311268, -1.25],
          [6.770326, 53.311196, -1.5],
          [6.770657, 53.311131, -1.5],
          [6.770771, 53.311119, -1.5],
          [6.770898, 53.311116, -1.5],
          [6.771175, 53.311139, -1.5],
          [6.771206, 53.311080, -1.5],
          [6.771175, 53.311139, -1.5],
          [6.772109, 53.311363, -1.0],
          [6.772116, 53.311364, -1.0],
          [6.773700, 53.311740, 0.0],
          [6.775397, 53.312180, -0.25],
          [6.775621, 53.312221, -0.5],
          [6.775846, 53.312254, -0.5],
          [6.776001, 53.312262, -0.5],
          [6.776131, 53.312262, -0.5],
          [6.776708, 53.312226, -0.5],
          [6.777005, 53.312224, -0.75],
          [6.777165, 53.312234, -1.0],
          [6.777323, 53.312253, -1.0],
          [6.777477, 53.312279, -1.0],
          [6.778142, 53.312415, -1.75],
          [6.778411, 53.312445, -2.0],
          [6.778684, 53.312454, -2.0],
          [6.779660, 53.312463, -1.25],
          [6.779928, 53.312478, -1.0],
          [6.780050, 53.312488, -1.0],
          [6.780940, 53.312586, -1.0],
          [6.781849, 53.312704, -1.0],
          [6.783156, 53.312951, -1.25],
          [6.784300, 53.313096, -1.0],
          [6.785697, 53.313228, 0.0],
          [6.786219, 53.313288, 0.0],
          [6.786975, 53.313415, 0.0],
          [6.787264, 53.313487, 0.0],
          [6.787429, 53.313555, 0.0],
          [6.787523, 53.313628, 0.0],
          [6.787655, 53.313639, 0.0],
          [6.787680, 53.313641, 0.0],
          [6.787893, 53.313680, 0.0],
          [6.788047, 53.313653, 0.0],
          [6.788176, 53.313755, 0.0],
          [6.788430, 53.313797, 0.0],
          [6.789562, 53.313956, 0.0],
          [6.790534, 53.314049, 0.0],
          [6.790551, 53.314051, 0.0],
          [6.791917, 53.314201, 0.0],
          [6.794046, 53.314381, -0.5],
          [6.795063, 53.314473, 0.0],
          [6.795545, 53.314543, -0.5],
          [6.795886, 53.314615, -1.0],
          [6.796153, 53.314693, -1.0],
          [6.796290, 53.314742, -1.0],
          [6.796543, 53.314858, -1.0],
          [6.796641, 53.314895, -1.0],
          [6.796818, 53.314984, -1.0],
          [6.796898, 53.315035, -0.75],
          [6.796980, 53.315097, -0.75],
          [6.797052, 53.315163, -0.5],
          [6.797114, 53.315234, -0.5],
          [6.797177, 53.315280, -0.25],
          [6.797250, 53.315320, -0.25],
          [6.797332, 53.315354, 0.0],
          [6.797499, 53.315395, 0.0],
          [6.797843, 53.315433, 0.5],
          [6.800149, 53.315624, 0.25],
          [6.800453, 53.315634, 0.0],
          [6.800621, 53.315633, 0.0],
          [6.801413, 53.315547, -1.25],
          [6.801669, 53.315540, -1.75],
          [6.802114, 53.315548, -1.5],
          [6.802625, 53.315584, -1.0],
          [6.802860, 53.315607, -0.75],
          [6.803327, 53.315668, 0.0],
          [6.804001, 53.315832, 0.0],
          [6.806293, 53.316215, 0.25],
          [6.808746, 53.316472, -1.0],
          [6.809611, 53.316597, -1.0],
          [6.811217, 53.316948, -0.75],
          [6.811610, 53.316999, -1.25],
          [6.812465, 53.317065, -1.25],
          [6.813029, 53.317120, -1.75],
          [6.815146, 53.317418, -1.0],
          [6.815852, 53.317524, -0.75],
          [6.816056, 53.317537, -0.75],
          [6.816328, 53.317527, -0.75],
          [6.816891, 53.317455, -1.0],
          [6.817024, 53.317454, -1.0],
          [6.817091, 53.317459, -1.0],
          [6.817245, 53.317490, -1.0],
          [6.817699, 53.317617, -0.75],
          [6.818040, 53.317671, -0.75],
          [6.818689, 53.317733, -0.5],
          [6.818799, 53.317752, -0.5],
          [6.818852, 53.317765, -0.25],
          [6.819002, 53.317804, -0.25],
          [6.819241, 53.317886, 0.0],
          [6.819982, 53.318051, 1.25],
          [6.820424, 53.318129, 1.0],
          [6.821380, 53.318270, -0.25],
          [6.821874, 53.318357, -1.0],
          [6.822362, 53.318424, -1.0],
          [6.824780, 53.318670, -2.0],
          [6.826034, 53.318832, -1.0],
          [6.826730, 53.318900, -0.25],
          [6.827929, 53.318998, -0.5],
          [6.828098, 53.319004, -0.5],
          [6.828266, 53.319004, -0.75],
          [6.828587, 53.318987, -1.0],
          [6.829024, 53.318933, -1.25],
          [6.829208, 53.318921, -1.25],
          [6.829276, 53.318920, -1.5],
          [6.830284, 53.318945, -2.25],
          [6.832134, 53.318954, -1.5],
          [6.832550, 53.319020, -1.0],
          [6.833672, 53.319317, 0.0],
          [6.834261, 53.319424, 0.0],
          [6.834419, 53.319445, 0.0],
          [6.834697, 53.319467, 0.0],
          [6.835408, 53.319483, 0.0],
          [6.835415, 53.319554, 0.0],
          [6.835441, 53.319816, 0.5],
          [6.835471, 53.319858, 0.5],
          [6.835575, 53.320008, 1.0],
          [6.835611, 53.320075, 1.0],
          [6.835842, 53.320011, 0.75],
          [6.836093, 53.319962, 0.5],
          [6.836559, 53.319892, 0.0],
          [6.837901, 53.319759, -0.5],
          [6.838262, 53.319747, -0.5],
          [6.838518, 53.319752, -0.5],
          [6.838774, 53.319768, -0.25],
          [6.839126, 53.319821, 0.0],
          [6.839377, 53.319880, -0.25],
          [6.839710, 53.319986, -0.5],
          [6.839941, 53.320084, -0.5],
          [6.840168, 53.320181, -0.75],
          [6.840930, 53.320550, -0.25],
          [6.841454, 53.320737, 0.0],
          [6.841903, 53.320836, 0.0],
          [6.842188, 53.320883, 0.0],
          [6.842429, 53.320909, 0.0],
          [6.842679, 53.320926, -0.25],
          [6.843160, 53.320945, -0.75],
          [6.843175, 53.320820, -0.75],
          [6.843693, 53.320810, -1.0],
          [6.843898, 53.320784, -1.0],
          [6.843982, 53.320777, -1.0],
          [6.844059, 53.320771, -1.0],
          [6.844230, 53.320747, -1.0],
          [6.844589, 53.320663, -1.5],
          [6.845272, 53.320428, -1.5],
          [6.845428, 53.320398, -1.25],
          [6.845588, 53.320375, -1.25],
          [6.846055, 53.320382, -0.5],
          [6.846492, 53.320426, 0.0],
          [6.847053, 53.320526, 0.0],
          [6.847374, 53.320604, 0.0],
          [6.847923, 53.320780, 0.0],
          [6.848416, 53.320963, 0.25],
          [6.848734, 53.321064, 0.5],
          [6.850024, 53.321413, 1.0],
          [6.850151, 53.321442, 1.0],
          [6.850473, 53.321514, 1.0],
          [6.851274, 53.321645, 0.75],
          [6.851581, 53.321678, 0.75],
          [6.851800, 53.321681, 0.75],
          [6.852038, 53.321629, 0.75],
          [6.852334, 53.321651, 0.75],
          [6.852531, 53.321693, 0.75],
          [6.853202, 53.321719, 0.75],
          [6.853365, 53.321718, 1.0],
          [6.853624, 53.321718, 1.0],
          [6.853667, 53.321710, 1.0],
          [6.853815, 53.321681, 1.0],
          [6.854228, 53.321628, 0.75],
          [6.854597, 53.321683, 0.5],
          [6.854738, 53.321682, 0.25],
          [6.854964, 53.321629, 0.0],
          [6.855772, 53.321387, 1.25],
          [6.855892, 53.321360, 1.25],
          [6.856038, 53.321337, 1.5],
          [6.856118, 53.321331, 1.75],
          [6.856382, 53.321337, 2.25],
          [6.856386, 53.321213, 2.5],
          [6.856658, 53.321168, 3.0],
          [6.857030, 53.321108, 3.25],
          [6.857295, 53.321101, 3.25],
          [6.857694, 53.321131, 3.25],
          [6.857945, 53.321162, 3.0],
          [6.858306, 53.321210, 3.0],
          [6.858541, 53.321253, 2.75],
          [6.858873, 53.321321, 2.75],
          [6.858950, 53.321340, 2.75],
          [6.859083, 53.321385, 2.5],
          [6.859775, 53.321621, 1.25],
          [6.860470, 53.321875, 1.0],
          [6.861031, 53.322057, 1.0],
          [6.861830, 53.322282, 1.0],
          [6.862581, 53.322448, 0.75],
          [6.862698, 53.322473, 0.75],
          [6.862827, 53.322466, 0.75],
          [6.863391, 53.322547, 0.75],
          [6.863727, 53.322570, 0.75],
          [6.863745, 53.322468, 0.75],
          [6.863922, 53.322469, 0.75],
          [6.864883, 53.322470, 0.0],
          [6.865004, 53.322465, 0.0],
          [6.865089, 53.322454, 0.0],
          [6.865301, 53.322414, 0.0],
          [6.865728, 53.322286, -0.5],
          [6.865895, 53.322218, -0.5],
          [6.866203, 53.322138, -0.75],
          [6.866332, 53.322118, -0.75],
          [6.867002, 53.322064, -1.0],
          [6.867097, 53.322047, -1.0],
          [6.867239, 53.322022, -1.0],
          [6.867639, 53.321937, -1.0],
          [6.867896, 53.321894, -1.0],
          [6.868029, 53.321883, -1.0],
          [6.868152, 53.321865, -1.0],
          [6.868236, 53.321863, -1.0],
          [6.868314, 53.321861, -1.0],
          [6.868396, 53.321868, -0.75],
          [6.868629, 53.321872, -0.75],
          [6.868966, 53.321925, -0.75],
          [6.869314, 53.322016, -0.5],
          [6.869583, 53.322123, 0.0],
          [6.869848, 53.322259, 0.25],
          [6.870621, 53.322698, 1.0],
          [6.871082, 53.322902, 1.25],
          [6.871719, 53.323141, 0.75],
          [6.872051, 53.323239, 0.75],
          [6.872430, 53.323310, 0.75],
          [6.872900, 53.323350, 0.5],
          [6.874820, 53.323320, 0.5],
          [6.875890, 53.323330, 0.0],
          [6.876270, 53.323300, -0.5],
          [6.876630, 53.323250, -0.75],
          [6.878715, 53.322738, -1.0],
          [6.879337, 53.322599, -0.75],
          [6.879586, 53.322538, -0.5],
          [6.879838, 53.322500, 0.0],
          [6.880098, 53.322476, 0.0],
          [6.880368, 53.322470, 0.0],
          [6.880674, 53.322480, 0.0],
          [6.881032, 53.322528, 0.0],
          [6.881378, 53.322597, -0.25],
          [6.881646, 53.322677, -0.25],
          [6.881862, 53.322759, -0.5],
          [6.883066, 53.323375, -1.25],
          [6.883452, 53.323560, -1.25],
          [6.883694, 53.323676, -1.25],
          [6.883993, 53.323811, -1.5],
          [6.884235, 53.323905, -1.75],
          [6.884421, 53.323963, -2.0],
          [6.884492, 53.323986, -2.0],
          [6.884519, 53.324003, -2.0],
          [6.884552, 53.324023, -2.25],
          [6.884580, 53.324082, -2.25],
          [6.884800, 53.324081, -2.5],
          [6.886476, 53.324392, 0.0],
          [6.886713, 53.324430, 0.25],
          [6.887041, 53.324472, 0.25],
          [6.887350, 53.324493, 0.25],
          [6.887685, 53.324495, 0.5],
          [6.887966, 53.324479, 0.5],
          [6.888437, 53.324413, 1.0],
          [6.888949, 53.324341, 1.0],
          [6.889220, 53.324289, 1.0],
          [6.889545, 53.324196, 1.0],
          [6.889741, 53.324077, 0.5],
          [6.890751, 53.323583, -0.5],
          [6.891034, 53.323481, -0.5],
          [6.891455, 53.323402, -0.25],
          [6.891646, 53.323366, 0.0],
          [6.892202, 53.323297, 0.0],
          [6.892381, 53.323261, 0.0],
          [6.892721, 53.323253, -0.25],
          [6.893136, 53.323272, -0.5],
          [6.893744, 53.323411, -0.5],
          [6.893992, 53.323514, -0.25],
          [6.894196, 53.323656, -0.25],
          [6.894333, 53.323796, -0.25],
          [6.894716, 53.324658, -0.5],
          [6.894919, 53.324948, -0.75],
          [6.895085, 53.325111, -0.75],
          [6.895364, 53.325322, -0.25],
          [6.895535, 53.325435, 0.0],
          [6.895629, 53.325487, 0.0],
          [6.896040, 53.325661, 0.75],
          [6.896604, 53.325856, 1.75],
          [6.896669, 53.325927, 1.75],
          [6.897352, 53.325881, 1.0],
          [6.897888, 53.325862, 0.5],
          [6.898414, 53.325862, 0.0],
          [6.898591, 53.325894, 0.0],
          [6.898569, 53.325940, 0.0],
          [6.898591, 53.325894, 0.0],
          [6.898803, 53.325935, 0.0],
          [6.899563, 53.326131, 0.0],
          [6.899788, 53.326173, 0.0],
          [6.900335, 53.326212, 0.0],
          [6.901449, 53.326272, 0.0],
          [6.901548, 53.326264, 0.0],
          [6.903658, 53.326391, 0.25],
          [6.905292, 53.326524, 0.0],
          [6.905602, 53.326540, 0.0],
          [6.906376, 53.326573, 0.0],
          [6.906814, 53.326620, 0.0],
          [6.907216, 53.326642, 0.0],
          [6.907559, 53.326637, 0.0],
          [6.908147, 53.326641, -0.75],
          [6.908224, 53.326638, -0.75],
          [6.908299, 53.326597, -1.0],
          [6.908312, 53.326475, -1.25],
          [6.908590, 53.326516, -1.0],
          [6.908711, 53.326535, -0.75],
          [6.908986, 53.326583, -0.25],
          [6.908957, 53.326799, 0.0],
          [6.908948, 53.326870, 0.25],
          [6.908749, 53.326881, 0.0],
          [6.908718, 53.326896, 0.0],
          [6.908687, 53.326912, 0.0],
          [6.908612, 53.326931, 0.0],
          [6.908565, 53.326963, 0.0],
          [6.908550, 53.327007, 0.25],
          [6.908641, 53.327011, 0.25],
          [6.908740, 53.326983, 0.25],
          [6.908931, 53.326998, 0.5],
          [6.908948, 53.326870, 0.25],
          [6.908957, 53.326799, 0.0],
          [6.908986, 53.326583, -0.25],
          [6.909071, 53.325871, -2.75],
          [6.909179, 53.325078, -0.75],
          [6.909192, 53.324987, -0.75],
          [6.909831, 53.325054, -0.25],
          [6.910515, 53.325133, 0.0],
          [6.911148, 53.325206, -0.25],
          [6.912080, 53.325273, -0.25],
          [6.912981, 53.325329, 0.0],
          [6.913600, 53.325370, 0.25],
          [6.913910, 53.325410, 0.25],
          [6.914400, 53.325490, 0.5],
          [6.914917, 53.325643, 0.5],
          [6.915022, 53.325719, 0.5],
          [6.915096, 53.325714, 0.5],
          [6.915171, 53.325728, 0.5],
          [6.915860, 53.325950, 0.0],
          [6.916450, 53.326089, -0.75],
          [6.917150, 53.326130, -1.25],
          [6.918700, 53.326170, -1.25],
          [6.918903, 53.326188, -1.25],
          [6.919360, 53.326220, -1.0],
          [6.919620, 53.326261, -0.75],
          [6.919840, 53.326330, -0.5],
          [6.920156, 53.326437, 0.0],
          [6.920545, 53.326604, 0.0],
          [6.920851, 53.326760, 0.0],
          [6.921097, 53.326908, 0.0],
          [6.921677, 53.327485, 0.0],
          [6.922389, 53.328160, -1.25],
          [6.922653, 53.328364, -2.0],
          [6.923265, 53.328858, -0.5],
          [6.923382, 53.328908, 0.0],
          [6.923526, 53.328998, 0.0],
          [6.923837, 53.329135, 0.75],
          [6.923963, 53.329195, 1.0],
          [6.923808, 53.329242, 1.0],
          [6.924022, 53.329299, 1.0],
          [6.923808, 53.329242, 1.0],
          [6.923701, 53.329181, 1.0],
          [6.923837, 53.329135, 0.75],
          [6.923963, 53.329195, 1.0],
          [6.924094, 53.329255, 1.0],
          [6.924245, 53.329328, 1.0],
          [6.924405, 53.329383, 1.25],
          [6.924666, 53.329463, 1.75],
          [6.924790, 53.329511, 2.0],
          [6.924863, 53.329537, 2.0],
          [6.925346, 53.329671, 2.75],
          [6.925487, 53.329686, 2.75],
          [6.925593, 53.329684, 2.75],
          [6.925646, 53.329634, 2.5],
          [6.925667, 53.329617, 2.5],
          [6.925679, 53.329599, 2.5],
          [6.925752, 53.329510, 2.0],
          [6.925931, 53.329564, 2.25],
          [6.925978, 53.329510, 2.0],
          [6.925872, 53.329476, 2.0],
          [6.925849, 53.329468, 2.0],
          [6.925872, 53.329476, 2.0],
          [6.925978, 53.329510, 2.0],
          [6.925931, 53.329564, 2.25],
          [6.925752, 53.329510, 2.0],
          [6.925763, 53.329496, 2.0],
          [6.925840, 53.329448, 2.0],
          [6.925882, 53.329446, 1.75],
          [6.925950, 53.329459, 2.0],
          [6.926037, 53.329493, 2.0],
          [6.926394, 53.329576, 2.0],
          [6.926703, 53.329628, 1.75],
          [6.928384, 53.329911, 0.75],
          [6.928566, 53.329963, 0.75],
          [6.928703, 53.330023, 1.0],
          [6.928906, 53.330155, 1.0],
          [6.928991, 53.330247, 1.0],
          [6.929283, 53.330734, 0.75],
          [6.929333, 53.330859, 0.75],
          [6.929388, 53.331192, 0.75],
          [6.929391, 53.331209, 1.0],
          [6.929497, 53.331215, 1.0],
          [6.929603, 53.331221, 0.75],
          [6.929824, 53.331373, 0.75],
          [6.929853, 53.331366, 0.75],
          [6.929866, 53.331363, 0.75],
          [6.929958, 53.331339, 0.5],
          [6.930328, 53.331899, 0.75],
          [6.930395, 53.332001, 0.75],
          [6.930451, 53.332085, 0.75],
          [6.930723, 53.332566, 1.0],
          [6.930886, 53.332342, 0.5],
          [6.930944, 53.332280, 0.5],
          [6.930982, 53.332253, 0.5],
          [6.931078, 53.332188, 0.25],
          [6.931159, 53.332163, 0.0],
          [6.931193, 53.332153, 0.0],
          [6.932435, 53.330987, -1.0],
          [6.932561, 53.330993, -1.0],
          [6.933299, 53.330595, -1.0],
          [6.942789, 53.325690, -1.0],
          [6.943193, 53.325547, -1.0],
          [6.942789, 53.325690],
          [6.933299, 53.330595],
          [6.932561, 53.330993],
          [6.933154, 53.330515],
          [6.942728, 53.325643],
          [6.946401, 53.324345],
          [6.950369, 53.323230],
          [6.966324, 53.320811],
          [6.988329, 53.315615],
          [6.999260, 53.313957],
          [7.000349, 53.313893],
          [7.001102, 53.313849],
          [7.002636, 53.314134],
          [7.007707, 53.316298],
          [7.018136, 53.322418],
          [7.019310, 53.322787],
          [7.020088, 53.322849],
          [7.031149, 53.323735],
          [7.065714, 53.324503],
          [7.068747, 53.324732],
          [7.111323, 53.331522],
          [7.115089, 53.331694],
          [7.129254, 53.332074],
          [7.132903, 53.332172],
          [7.175151, 53.333200],
          [7.175798, 53.333229],
          [7.176347, 53.333282],
          [7.176953, 53.333386],
          [7.177389, 53.333486],
          [7.177772, 53.333606],
          [7.178067, 53.333734],
          [7.178309, 53.333885],
          [7.178591, 53.334112],
          [7.182933, 53.338520],
          [7.183193, 53.338727],
          [7.183479, 53.338870],
          [7.184131, 53.339075],
          [7.184424, 53.339199],
          [7.184626, 53.339332],
          [7.184797, 53.339477],
          [7.184863, 53.339546],
          [7.185075, 53.339742, -1.5],
          [7.185141, 53.339805, -1.5],
          [7.185207, 53.339867, -1.5],
          [7.185273, 53.339930, -1.5],
          [7.185789, 53.339744, -0.25],
          [7.186627, 53.340564, 0.25],
          [7.186753, 53.340683, 0.25],
          [7.186814, 53.340725, 0.25],
          [7.186891, 53.340763, 0.5],
          [7.187622, 53.341028, 1.0],
          [7.188257, 53.341258, 1.25],
          [7.188331, 53.341285, 1.25],
          [7.188452, 53.341341, 1.0],
          [7.188533, 53.341401, 0.75],
          [7.188838, 53.341701, 0.0],
          [7.189850, 53.342703, 2.75],
          [7.190239, 53.343069, 1.25],
          [7.190512, 53.343245, 1.25],
          [7.191267, 53.343731, 2.5],
          [7.191312, 53.343760, 2.5],
          [7.191377, 53.343832, 2.5],
          [7.191425, 53.343953, 2.25],
          [7.191397, 53.344105, 1.75],
          [7.191318, 53.344210, 1.5],
          [7.191035, 53.344428, 1.75],
          [7.190987, 53.344497, 1.75],
          [7.190867, 53.344538, 1.75],
          [7.190816, 53.344556, 1.75],
          [7.190676, 53.344603, 1.75],
          [7.190582, 53.344636, 1.75],
          [7.190297, 53.344733, 2.0],
          [7.189948, 53.344811, 2.0],
          [7.189842, 53.344848, 2.0],
          [7.189637, 53.344920, 1.75],
          [7.189554, 53.344949, 1.75],
          [7.189408, 53.345001, 1.5],
          [7.189105, 53.345107, 0.75],
          [7.189056, 53.345124, 0.75],
          [7.188542, 53.345304, 0.0],
          [7.188401, 53.345354, 0.0],
          [7.188210, 53.345418, 0.25],
          [7.188118, 53.345429, 0.5],
          [7.188026, 53.345420, 0.5],
          [7.187932, 53.345400, 0.75],
          [7.187845, 53.345370, 1.0],
          [7.187771, 53.345332, 1.0],
          [7.187457, 53.345114, 1.25],
          [7.187385, 53.345074, 1.25],
          [7.187325, 53.345052, 1.5],
          [7.187206, 53.345036, 1.75],
          [7.187129, 53.345044, 1.75],
          [7.186995, 53.345079, 2.25],
          [7.186902, 53.345111, 2.5],
          [7.186883, 53.345118, 2.5],
          [7.186845, 53.345131, 2.75],
          [7.186816, 53.345141, 2.75],
          [7.186806, 53.345145, 2.75],
          [7.186727, 53.345173, 3.0],
          [7.186647, 53.345200, 3.0],
          [7.186396, 53.345288, 3.0],
          [7.186304, 53.345325, 2.75],
          [7.186265, 53.345350, 2.75],
          [7.186226, 53.345391, 2.75],
          [7.186206, 53.345432, 2.75],
          [7.186205, 53.345512, 3.0],
          [7.186217, 53.345561, 3.0],
          [7.186242, 53.345618, 3.0],
          [7.186300, 53.345720, 3.25],
          [7.186316, 53.345715, 3.25],
          [7.186451, 53.345681, 3.5],
          [7.186588, 53.345656, 3.5],
          [7.186687, 53.345648, 3.5],
          [7.186814, 53.345645, 3.5],
          [7.187044, 53.345660, 3.0],
          [7.187147, 53.345678, 3.0],
          [7.187228, 53.345701, 3.0],
          [7.187305, 53.345734, 3.0],
          [7.187374, 53.345779, 3.0],
          [7.187430, 53.345842, 3.0],
          [7.187517, 53.345961, 2.75],
          [7.187609, 53.346118, 2.75],
          [7.187673, 53.346249, 2.5],
          [7.187728, 53.346397, 2.5],
          [7.187765, 53.346558, 2.5],
          [7.187785, 53.346723, 2.5],
          [7.187772, 53.346949, 2.0],
          [7.187659, 53.346954, 2.0],
          [7.187589, 53.347807, 1.0],
          [7.187593, 53.347891, 1.0],
          [7.187632, 53.348053, 1.0],
          [7.187694, 53.348186, 1.0],
          [7.187738, 53.348259, 1.25],
          [7.187848, 53.348390, 1.25],
          [7.188280, 53.348829, 2.25],
          [7.188495, 53.349045, 2.75],
          [7.188624, 53.349176, 2.75],
          [7.190268, 53.350834, -1.0],
          [7.190751, 53.351320, -1.0],
          [7.191325, 53.351898, -0.25],
          [7.191621, 53.352196, 0.0],
          [7.192130, 53.352709, 0.25],
          [7.192163, 53.352742, 0.0],
          [7.192277, 53.352858, 0.0],
          [7.192378, 53.352960, 0.0],
          [7.193308, 53.353896, -2.0],
          [7.193358, 53.353947, -1.75],
          [7.193647, 53.354239, -1.0],
          [7.194636, 53.355235, -0.25],
          [7.195235, 53.355839, 0.0],
          [7.196103, 53.356713, 0.25],
          [7.196529, 53.357143, 0.75],
          [7.199256, 53.359891, 1.0],
          [7.199354, 53.359989, 0.75],
          [7.199732, 53.360370, 0.25],
          [7.199817, 53.360477, 0.5],
          [7.199873, 53.360574, 0.5],
          [7.199907, 53.360664, 0.5],
          [7.199929, 53.360757, 0.75],
          [7.199944, 53.360889, 1.0],
          [7.199953, 53.360972, 1.25],
          [7.199969, 53.360994, 1.25],
          [7.200004, 53.361015, 1.25],
          [7.200061, 53.361029, 1.25],
          [7.200086, 53.361035, 1.5],
          [7.200280, 53.361038, 1.5],
          [7.200687, 53.360979, 2.0],
          [7.200725, 53.360975, 2.0],
          [7.201187, 53.360925, 2.25],
          [7.201386, 53.360915, 2.5],
          [7.201650, 53.360917, 2.75],
          [7.202138, 53.360939, 2.5],
          [7.202166, 53.361047, 2.5],
          [7.202221, 53.361182, 2.5],
          [7.202263, 53.361247, 2.5],
          [7.202413, 53.361418, 2.5],
          [7.202577, 53.361575, 2.75],
          [7.202729, 53.361722, 2.75],
          [7.202784, 53.361700, 2.5],
          [7.202729, 53.361722, 2.75],
          [7.202806, 53.361796, 2.75],
          [7.203366, 53.362362, 4.25],
          [7.204036, 53.363067, 5.25],
          [7.204142, 53.363184, 5.5],
          [7.204253, 53.363317, 5.75],
          [7.204354, 53.363428, 5.5],
          [7.204436, 53.363513, 5.5],
          [7.204554, 53.363609, 5.25],
          [7.204646, 53.363669, 5.25],
          [7.204694, 53.363699, 5.0],
          [7.204764, 53.363743, 5.0],
          [7.204885, 53.363819, 5.0],
          [7.204983, 53.363882, 5.0],
          [7.205545, 53.364247, 4.25],
          [7.205668, 53.364347, 4.0],
          [7.205726, 53.364421, 4.0],
          [7.205754, 53.364474, 4.0],
          [7.205793, 53.364569, 4.0],
          [7.205836, 53.364714, 3.75],
          [7.205844, 53.364741, 3.75],
          [7.205868, 53.364817, 3.75],
          [7.205977, 53.365217, 4.25],
          [7.205989, 53.365278, 4.5],
          [7.205992, 53.365424, 5.0],
          [7.205970, 53.365530, 5.25],
          [7.205931, 53.365650, 6.0],
          [7.205865, 53.365801, 6.75],
          [7.205805, 53.365912, 7.0],
          [7.205739, 53.366016, 7.0],
          [7.205624, 53.366217, 7.25],
          [7.205527, 53.366441, 7.25],
          [7.205492, 53.366549, 7.25],
          [7.205460, 53.366686, 7.25],
          [7.205466, 53.366741, 7.25],
          [7.205493, 53.366782, 7.0],
          [7.205530, 53.366803, 7.0],
          [7.205590, 53.366815, 7.0],
          [7.205595, 53.366816, 7.0],
          [7.206110, 53.366846, 6.5],
          [7.206349, 53.366861, 6.25],
          [7.206342, 53.367008, 6.0],
          [7.206340, 53.367042, 6.0],
          [7.206318, 53.367570, 6.0],
          [7.206315, 53.367640, 6.0],
          [7.206549, 53.367653, 6.0],
          [7.206985, 53.367682, 5.75],
          [7.207218, 53.367695, 5.75],
          [7.207479, 53.367714, 5.75],
          [7.208370, 53.367793, 4.5],
          [7.208377, 53.367777, 4.5],
          [7.208654, 53.367159, 5.75],
          [7.208193, 53.367143, 5.75],
          [7.207653, 53.367141, 5.75],
          [7.207344, 53.367140, 6.0],
          [7.207122, 53.367134, 6.0],
          [7.206892, 53.367102, 6.0],
          [7.206457, 53.367012, 6.0],
          [7.206342, 53.367008, 6.0],
          [7.206340, 53.367042, 6.0],
          [7.206318, 53.367570, 6.0],
          [7.206315, 53.367640, 6.0],
          [7.206258, 53.367995, 6.25],
          [7.206195, 53.367994, 6.25],
          [7.206053, 53.367990, 6.25],
          [7.205822, 53.367981, 6.5],
          [7.205386, 53.367959, 6.75],
          [7.205030, 53.367954, 7.0],
          [7.204874, 53.367941, 7.0],
          [7.204374, 53.367840, 7.25],
          [7.204290, 53.367820, 7.25],
          [7.204212, 53.367802, 7.25],
          [7.204094, 53.367787, 7.25],
          [7.203763, 53.367779, 7.25],
          [7.203318, 53.367764, 7.25],
          [7.202585, 53.367747, 5.75],
          [7.203318, 53.367764, 7.25],
          [7.203763, 53.367779, 7.25],
          [7.204094, 53.367787, 7.25],
          [7.204212, 53.367802, 7.25],
          [7.204290, 53.367820, 7.25],
          [7.204374, 53.367840, 7.25],
          [7.204874, 53.367941, 7.0],
          [7.205030, 53.367954, 7.0],
          [7.205386, 53.367959, 6.75],
          [7.205822, 53.367981, 6.5],
          [7.206053, 53.367990, 6.25],
          [7.206195, 53.367994, 6.25],
          [7.206258, 53.367995, 6.25],
          [7.206212, 53.368296, 6.5],
          [7.206191, 53.368421, 6.0],
          [7.206181, 53.368523, 5.75],
          [7.206175, 53.368678, 5.25],
          [7.206152, 53.368836, 4.5],
          [7.206130, 53.368977, 4.0],
          [7.206125, 53.369088, 3.5],
          [7.206127, 53.369238, 3.25],
          [7.206127, 53.369249, 3.25],
          [7.206131, 53.369381, 3.25],
          [7.206638, 53.369461, 3.75],
          [7.206789, 53.369488, 4.0],
          [7.208217, 53.369757, 4.0],
          [7.209114, 53.369931, 4.0],
          [7.209661, 53.370035, 4.5],
          [7.211632, 53.370409, 4.0],
          [7.211852, 53.370452, 4.0],
          [7.211978, 53.370475, 4.0],
          [7.213226, 53.370705, 3.5],
          [7.213333, 53.370723, 3.25],
          [7.213688, 53.370801, 3.5],
          [7.213752, 53.370825, 3.5],
          [7.213809, 53.370867, 3.5],
          [7.213969, 53.371048, 3.75],
          [7.214082, 53.371201, 3.75],
          [7.214171, 53.371273, 3.75],
          [7.214263, 53.371326, 3.75],
          [7.214302, 53.371288, 3.75],
          [7.214263, 53.371326, 3.75],
          [7.214707, 53.371513, 3.0],
          [7.214965, 53.371604, 2.25],
          [7.215107, 53.371651, 2.0],
          [7.215177, 53.371666, 2.0],
          [7.215327, 53.371676, 2.0],
          [7.215410, 53.371671, 2.0],
          [7.215673, 53.371629, 2.0],
          [7.216379, 53.371506, 2.5],
          [7.217168, 53.371347, 3.0],
          [7.217492, 53.371263, 2.75],
          [7.217878, 53.371136, 2.5],
          [7.218248, 53.370982, 2.0],
          [7.218558, 53.370828, 2.0],
          [7.218700, 53.370749, 2.0],
          [7.218769, 53.370711, 2.0],
          [7.219432, 53.370343, 2.75],
          [7.219705, 53.370190, 3.25],
          [7.220449, 53.369774, 3.0],
          [7.220887, 53.369534, 2.25],
          [7.221046, 53.369462, 2.0],
          [7.221295, 53.369371, 1.75],
          [7.221452, 53.369335, 1.75],
          [7.221576, 53.369314, 1.75],
          [7.221750, 53.369295, 1.75],
          [7.221958, 53.369288, 1.75],
          [7.222064, 53.369291, 1.75],
          [7.222387, 53.369318, 1.75],
          [7.222889, 53.369380, 2.0],
          [7.224059, 53.369524, 2.5],
          [7.224489, 53.369577, 2.25],
          [7.224659, 53.369600, 2.0],
          [7.225162, 53.369646, 2.0],
          [7.225511, 53.369695, 2.5],
          [7.225941, 53.369762, 3.0],
          [7.226452, 53.369847, 3.5],
          [7.226743, 53.369883, 3.75],
          [7.227278, 53.369921, 3.25],
          [7.227730, 53.369948, 2.25],
          [7.227968, 53.369963, 1.75],
          [7.228323, 53.369983, 1.0],
          [7.228800, 53.370023, 1.0],
          [7.228996, 53.370048, 1.0],
          [7.229464, 53.370127, 1.5],
          [7.229503, 53.370135, 1.5],
          [7.230716, 53.370371, 1.5],
          [7.230960, 53.370417, 1.25],
          [7.231124, 53.370456, 1.25],
          [7.231380, 53.370533, 0.75],
          [7.231629, 53.370638, 0.5],
          [7.231768, 53.370721, 0.25],
          [7.231891, 53.370822, 0.0],
          [7.231922, 53.370848, 0.0],
          [7.232229, 53.371164, -0.25],
          [7.232442, 53.371369, -0.5],
          [7.232837, 53.371742, -0.5],
          [7.233143, 53.372053, 0.0],
          [7.233565, 53.372480, 0.0],
          [7.233714, 53.372596, 0.0],
          [7.233867, 53.372688, 0.0],
          [7.234036, 53.372768, 0.25],
          [7.234141, 53.372810, 0.25],
          [7.234491, 53.372928, 0.5],
          [7.235276, 53.373160, 0.25],
          [7.236241, 53.373430, -0.5],
          [7.237232, 53.373694, -1.0],
          [7.237741, 53.373848, -0.75],
          [7.237814, 53.373870, -0.75],
          [7.238180, 53.373983, -0.5],
          [7.238650, 53.374122, 0.0],
          [7.239423, 53.374360, 0.0],
          [7.240392, 53.374659, 0.0],
          [7.240763, 53.374764, 0.0],
          [7.241162, 53.374838, 0.0],
          [7.241505, 53.374875, 0.0],
          [7.242464, 53.374923, 0.0],
          [7.243770, 53.374989, -1.0],
          [7.244031, 53.375006, -1.0],
          [7.244297, 53.375022, -0.75],
          [7.244789, 53.375046, -0.25],
          [7.245986, 53.375109, 0.0],
          [7.246166, 53.375124, -0.25],
          [7.246479, 53.375170, -0.75],
          [7.246617, 53.375201, -0.75],
          [7.246958, 53.375303, -1.0],
          [7.247573, 53.375502, -0.75],
          [7.247907, 53.375612, -0.75],
          [7.249173, 53.376027, -1.0],
          [7.249503, 53.376133, -1.0],
          [7.249846, 53.376261, -1.0],
          [7.249998, 53.376326, -1.0],
          [7.250220, 53.376429, -0.75],
          [7.250476, 53.376558, -0.5],
          [7.250489, 53.376564, -0.25],
          [7.250476, 53.376558, -0.5],
          [7.250633, 53.376397, -0.25],
          [7.250750, 53.376250, -0.5],
          [7.250742, 53.376247, -0.5],
          [7.250750, 53.376250, -0.5],
          [7.251063, 53.376305, -0.25],
          [7.251319, 53.376339, 0.0],
          [7.251729, 53.376365, 0.25],
          [7.252036, 53.376349, 0.0],
          [7.252227, 53.376322, 0.0],
          [7.252401, 53.376285, 0.0],
          [7.253066, 53.376076, 0.0],
          [7.253406, 53.376013, -0.25],
          [7.253656, 53.375985, -0.25],
          [7.253861, 53.375972, -0.5],
          [7.254038, 53.375970, -0.5],
          [7.254224, 53.375970, -0.5],
          [7.254496, 53.375985, -0.25],
          [7.254767, 53.376028, -0.25],
          [7.255030, 53.376084, 0.0],
          [7.255372, 53.376185, 0.0],
          [7.255744, 53.376349, 0.25],
          [7.255951, 53.376462, 0.25],
          [7.256158, 53.376524, 0.0],
          [7.256215, 53.376543, 0.0],
          [7.256271, 53.376546, 0.0],
          [7.256386, 53.376599, -0.25],
          [7.256483, 53.376719, -0.25],
          [7.256707, 53.376811, -0.25],
          [7.257267, 53.377000, 0.0],
          [7.257605, 53.377075, 0.0],
          [7.257962, 53.377186, -0.25],
          [7.258157, 53.377291, -0.5],
          [7.258387, 53.377607, -0.75],
          [7.258664, 53.378359, 0.5],
          [7.258857, 53.378756, 0.5],
          [7.259226, 53.379344, -0.25],
          [7.259479, 53.379650, -1.0],
          [7.259813, 53.379872, -1.5],
          [7.260146, 53.380067, -2.0],
          [7.260632, 53.380383, -2.0],
          [7.260867, 53.380599, -1.75],
          [7.260937, 53.380695, -1.75],
          [7.260965, 53.380843, -2.0],
          [7.260911, 53.380993, -2.0],
          [7.260423, 53.381436, -2.5],
          [7.260177, 53.381670, -2.75],
          [7.260036, 53.381849, -2.25],
          [7.259912, 53.382036, -1.5],
          [7.259835, 53.382196, -1.0],
          [7.259787, 53.382336, -0.75],
          [7.259710, 53.382674, -0.5],
          [7.259627, 53.382939, -1.0],
          [7.259648, 53.383154, -1.5],
          [7.259638, 53.383347, -1.75],
          [7.259693, 53.383639, -1.75],
          [7.259899, 53.383939, -1.75],
          [7.260261, 53.384288, -2.25],
          [7.260287, 53.384329, -2.25],
          [7.260558, 53.384543, -2.75],
          [7.260989, 53.384756, -3.0],
          [7.261374, 53.384844, -2.75],
          [7.261782, 53.384884, -2.5],
          [7.262375, 53.384926, -2.75],
          [7.262776, 53.384973, -2.5],
          [7.263354, 53.385118, -2.0],
          [7.264033, 53.385387, -2.25],
          [7.264472, 53.385622, -2.25],
          [7.264836, 53.385857, -2.0],
          [7.265272, 53.386225, -2.25],
          [7.265648, 53.386652, -2.75],
          [7.265925, 53.387043, -3.25],
          [7.266102, 53.387420, -3.5],
          [7.266133, 53.387818, -3.5],
          [7.266199, 53.388219, -3.5],
          [7.266284, 53.388392, -3.25],
          [7.266516, 53.388733, -2.5],
          [7.266593, 53.388833, -2.25],
          [7.266721, 53.388937, -2.25],
          [7.266850, 53.389003, -2.0],
          [7.266996, 53.389026, -2.0],
          [7.267179, 53.389100, -2.0],
          [7.267351, 53.389189, -2.0],
          [7.267374, 53.389270, -2.0],
          [7.267489, 53.389309, -2.0],
          [7.267711, 53.389452, -2.25],
          [7.268018, 53.389618, -2.0],
          [7.268508, 53.389968, -2.0],
          [7.268810, 53.390237, -2.0],
          [7.268881, 53.390385, -2.0],
          [7.268884, 53.390613, -2.0],
          [7.268769, 53.391030, -1.75],
          [7.268780, 53.391214, -2.0],
          [7.268847, 53.391466, -2.0],
          [7.269004, 53.391733, -2.0],
          [7.269266, 53.391949, -2.25],
          [7.269495, 53.392088, -2.25],
          [7.270428, 53.392366, -2.0],
          [7.271157, 53.392520, -2.0],
          [7.271901, 53.392617, -2.0],
          [7.272515, 53.392642, -2.0],
          [7.273658, 53.392598, -3.0],
          [7.274101, 53.392608, -3.0],
          [7.274657, 53.392706, -3.5],
          [7.275493, 53.392888, -3.25],
          [7.275835, 53.392940, -2.75],
          [7.276198, 53.392926, -2.0],
          [7.276799, 53.392802, -1.0],
          [7.277136, 53.392721, -1.0],
          [7.277513, 53.392701, -1.0],
          [7.277829, 53.392752, -1.0],
          [7.278147, 53.392892, -1.0],
          [7.278370, 53.393044, -1.0],
          [7.278664, 53.393361, -1.25],
          [7.278850, 53.393714, -2.0],
          [7.279039, 53.394492, -2.5],
          [7.279639, 53.395710, -3.0],
          [7.279997, 53.396126, -3.25],
          [7.280253, 53.396314, -3.25],
          [7.280470, 53.396431, -3.25],
          [7.281009, 53.396568, -2.75],
          [7.282181, 53.396790, -2.0],
          [7.282527, 53.396862, -2.0],
          [7.282806, 53.396955, -1.75],
          [7.283459, 53.397326, -1.75],
          [7.283974, 53.397618, -2.0],
          [7.284515, 53.397881, -2.25],
          [7.285112, 53.398051, -2.0],
          [7.287024, 53.398794, -2.25],
          [7.288855, 53.399447, -1.75],
          [7.288847, 53.399466, -1.75],
          [7.288428, 53.400563, -4.0],
          [7.287993, 53.401771, -3.5],
          [7.287071, 53.404260, -3.0],
          [7.286215, 53.406611, -2.75],
          [7.286159, 53.406605, -2.75],
          [7.286215, 53.406611, -2.75],
          [7.291924, 53.409338, -2.25],
          [7.291775, 53.409357, -2.25],
          [7.291924, 53.409338, -2.25],
          [7.292062, 53.409390, -2.5],
          [7.294773, 53.409906, -3.75],
          [7.296821, 53.410287, -3.5],
          [7.298396, 53.410470, -4.5],
          [7.300171, 53.410648, -4.0],
          [7.305305, 53.410494, -2.5],
          [7.305332, 53.410534, -2.5],
          [7.305404, 53.410601, -2.5],
          [7.305515, 53.410660, -2.75],
          [7.306784, 53.411228, -2.25],
          [7.307308, 53.411478, -2.75],
          [7.307575, 53.411644, -2.75],
          [7.307926, 53.411881, -2.75],
          [7.308077, 53.411975, -2.5],
          [7.308208, 53.412047, -2.5],
          [7.308403, 53.412142, -2.25],
          [7.308690, 53.412258, -2.25],
          [7.309271, 53.412510, -2.0],
          [7.309525, 53.412599, -2.25],
          [7.310479, 53.412862, -3.0],
          [7.310832, 53.412948, -3.0],
          [7.311732, 53.413150, -3.0],
          [7.311942, 53.413208, -3.0],
          [7.312125, 53.413269, -3.0],
          [7.312906, 53.413572, -3.0],
          [7.313053, 53.413622, -3.0],
          [7.313281, 53.413675, -3.0],
          [7.313738, 53.413737, -3.0],
          [7.313870, 53.413765, -2.75],
          [7.314030, 53.413811, -2.75],
          [7.314429, 53.413958, -2.5],
          [7.314520, 53.413991, -2.5],
          [7.314812, 53.414111, -2.75],
          [7.314883, 53.414143, -2.75],
          [7.314940, 53.414174, -2.75],
          [7.315049, 53.414257, -3.0],
          [7.315152, 53.414361, -3.0],
          [7.315342, 53.414653, -3.0],
          [7.315384, 53.414754, -3.0],
          [7.315432, 53.414951, -3.0],
          [7.315491, 53.415119, -2.75],
          [7.315551, 53.415230, -2.5],
          [7.315681, 53.415417, -2.5],
          [7.315745, 53.415542, -2.25],
          [7.315868, 53.415955, -2.0],
          [7.315877, 53.416077, -2.0],
          [7.315869, 53.416188, -2.0],
          [7.315874, 53.416307, -2.0],
          [7.315910, 53.416363, -2.0],
          [7.315812, 53.416378, -2.0],
          [7.315791, 53.416384, -2.0],
          [7.315812, 53.416378, -2.0],
          [7.315910, 53.416363, -2.0],
          [7.315972, 53.416459, -2.0],
          [7.315892, 53.416476, -2.0],
          [7.315820, 53.416491, -2.0],
          [7.315737, 53.416496, -2.0],
          [7.315516, 53.416506, -2.0],
          [7.315404, 53.416526, -2.0],
          [7.315256, 53.416576, -2.0],
          [7.315113, 53.416673, -1.75],
          [7.313233, 53.418627, -3.25],
          [7.312472, 53.419431, -3.25],
          [7.312315, 53.419552, -3.25],
          [7.312110, 53.419627, -3.5],
          [7.311840, 53.419671, -3.5],
          [7.311393, 53.419685, -3.25],
          [7.310391, 53.419698, -3.25],
          [7.309932, 53.419721, -3.25],
          [7.309494, 53.419793, -3.5],
          [7.309056, 53.419997, -3.75],
          [7.308647, 53.420204, -4.0],
          [7.308115, 53.420437, -3.75],
          [7.307361, 53.420597, -3.5],
          [7.307154, 53.420657, -3.5],
          [7.307010, 53.420744, -3.75],
          [7.306953, 53.420847, -3.75],
          [7.306802, 53.421665, -3.0],
          [7.306476, 53.422711, -3.0],
          [7.306442, 53.423406, -3.0],
          [7.306159, 53.424700, -2.75],
          [7.306362, 53.424914, -2.25],
          [7.306383, 53.424923, -2.25],
          [7.307035, 53.425181, -1.75],
          [7.307137, 53.425408, -1.5],
          [7.307126, 53.425459, -1.25],
          [7.306924, 53.426472, -1.75],
          [7.306651, 53.427794, -3.0],
          [7.306745, 53.427944, -3.0],
          [7.306772, 53.427986, -3.0],
          [7.307121, 53.428110, -3.0],
          [7.309592, 53.428272, -1.5],
          [7.309704, 53.428303, -1.25],
          [7.310817, 53.428799, -2.0],
          [7.310995, 53.428922, -2.25],
          [7.311041, 53.429141, -2.75],
          [7.311060, 53.429311, -3.0],
          [7.310979, 53.430187, -3.5],
          [7.311051, 53.430458, -3.0],
          [7.311255, 53.430653, -2.5],
          [7.312354, 53.430821, -2.0],
          [7.318671, 53.431276, -1.5],
          [7.319190, 53.431313, -1.5],
          [7.319658, 53.431329, -1.0],
          [7.319695, 53.431470, -1.0],
          [7.319931, 53.432353, -1.75],
          [7.320024, 53.432686, -2.0],
          [7.320162, 53.433179, -2.0],
          [7.320214, 53.433474, -1.75],
          [7.320232, 53.433669, -1.5],
          [7.320214, 53.435517, -0.75],
          [7.320206, 53.436120, -1.5],
          [7.320225, 53.436437, -1.75],
          [7.320227, 53.436504, -2.0],
          [7.320313, 53.436726, -2.25],
          [7.320423, 53.436876, -2.25],
          [7.320826, 53.437313, -2.0],
          [7.322085, 53.438707, -1.25],
          [7.322411, 53.439041, -1.75],
          [7.322584, 53.439187, -1.75],
          [7.323357, 53.439789, -1.0],
          [7.323870, 53.440170, -1.0],
          [7.323935, 53.440219, -1.25],
          [7.323533, 53.440236, -1.25],
          [7.322852, 53.440150, -1.5],
          [7.322628, 53.440122, -1.75],
          [7.317230, 53.439440, -2.0],
          [7.316922, 53.439399, -2.0],
          [7.316784, 53.439402, -2.0],
          [7.316655, 53.439417, -1.75],
          [7.316482, 53.439464, -1.75],
          [7.316319, 53.439536, -1.75],
          [7.316196, 53.439634, -1.5],
          [7.316120, 53.439749, -1.5],
          [7.316005, 53.440116, -1.0],
          [7.315887, 53.440428, -0.5],
          [7.315684, 53.440836, 0.0],
          [7.315435, 53.441367, -0.25],
          [7.315380, 53.441496, -0.25],
          [7.315320, 53.441719, -0.75],
          [7.315213, 53.442258, -2.25],
          [7.314890, 53.443792, -3.25],
          [7.314812, 53.443921, -3.0],
          [7.314680, 53.444030, -3.0],
          [7.314530, 53.444097, -3.0],
          [7.314346, 53.444142, -3.0],
          [7.314178, 53.444151, -3.0],
          [7.313982, 53.444135, -3.0],
          [7.311629, 53.443770, -3.0],
          [7.311354, 53.443733, -2.75],
          [7.311086, 53.443721, -2.75],
          [7.310802, 53.443741, -2.75],
          [7.310526, 53.443778, -3.0],
          [7.310450, 53.443615, -2.5],
          [7.310145, 53.443469, -2.25],
          [7.309800, 53.443341, -2.0],
          [7.309731, 53.443315, -2.0],
          [7.309657, 53.443288, -2.0],
          [7.309458, 53.442997, -2.0],
          [7.309227, 53.442748, -2.0],
          [7.308920, 53.442557, -1.5],
          [7.308650, 53.442493, -1.25]
        ]
      }
    }
  ]
}

let day18: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "J18 - Bedekaspel - Norden - 30.8km",
        "track-length": "30755",
        "filtered ascend": "33",
        "plain-ascend": "9",
        "total-time": "5232",
        "total-energy": "510759",
        "cost": "35445",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["7308314", "53442579", "-1", "20", "5050", "0", "0", "0", "0", "highway=track", "barrier=lift_gate foot=yes bicycle=yes motorcar=yes motorcycle=yes", "12", "0"],
          ["7310526", "53443778", "-3", "239", "1350", "0", "148", "0", "0", "highway=unclassified surface=paved", "", "41", "2895"],
          ["7306242", "53447068", "-1", "489", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "123", "11051"],
          ["7296148", "53455243", "-2", "1280", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "331", "31873"],
          ["7294362", "53457542", "-3", "283", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "378", "36508"],
          ["7290930", "53461938", "-2", "541", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "470", "45799"],
          ["7290782", "53462217", "-2", "33", "1150", "0", "2", "0", "0", "highway=residential oneway=yes", "", "476", "46395"],
          ["7290700", "53462312", "-2", "12", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt oneway=yes", "highway=crossing bicycle=yes crossing=unmarked", "479", "46624"],
          ["7290578", "53462281", "-2", "5", "1050", "0", "83", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "", "480", "46718"],
          ["7290700", "53462312", "-2", "5", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing bicycle=yes crossing=unmarked", "480", "46764"],
          ["7313551", "53470258", "-1", "1777", "1050", "0", "11", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing bicycle=yes crossing=unmarked", "770", "75787"],
          ["7314273", "53470568", "0", "61", "1050", "0", "5", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing", "780", "76770"],
          ["7314486", "53470672", "0", "19", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing", "784", "77108"],
          ["7317230", "53471998", "0", "239", "1050", "0", "1", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing bicycle=yes crossing=unmarked", "826", "81389"],
          ["7322851", "53474729", "0", "487", "1050", "0", "3", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing bicycle=yes crossing=unmarked", "911", "89843"],
          ["7323988", "53475206", "0", "95", "1050", "0", "1", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "", "926", "91330"],
          ["7324010", "53475241", "0", "5", "1050", "0", "23", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "bicycle=yes railway=crossing", "927", "91405"],
          ["7279652", "53518608", "0", "5706", "1050", "0", "202", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "", "1893", "188072"],
          ["7279739", "53518667", "0", "9", "1150", "0", "78", "0", "0", "highway=residential", "", "1895", "188214"],
          ["7277832", "53519925", "1", "192", "1150", "0", "77", "0", "0", "highway=residential surface=asphalt", "", "1930", "191744"],
          ["7277663", "53520031", "1", "17", "1150", "0", "0", "0", "0", "highway=residential", "highway=crossing crossing=unknown", "1933", "192041"],
          ["7276783", "53520603", "1", "88", "1150", "0", "0", "0", "0", "highway=residential", "", "1948", "193554"],
          ["7273275", "53522330", "4", "311", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2008", "199550"],
          ["7273702", "53523053", "3", "88", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "2019", "200635"],
          ["7269297", "53529251", "-1", "761", "1050", "0", "72", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "", "2127", "211461"],
          ["7261664", "53539135", "1", "1220", "1050", "0", "26", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing", "2334", "232152"],
          ["7254140", "53554402", "1", "1807", "1050", "0", "3", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing", "2635", "262320"],
          ["7239574", "53571649", "3", "2174", "1050", "0", "3", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing crossing=uncontrolled", "3042", "302973"],
          ["7238090", "53573144", "4", "194", "1050", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing crossing=uncontrolled", "3070", "305731"],
          ["7237108", "53574135", "2", "129", "1050", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing crossing=uncontrolled", "3086", "307399"],
          ["7227714", "53583950", "0", "1270", "1050", "0", "10", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing crossing=traffic_signals", "3303", "329076"],
          ["7227854", "53584128", "0", "33", "1050", "0", "49", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated", "highway=crossing crossing=traffic_signals", "3306", "329412"],
          ["7227909", "53583963", "0", "8", "7050", "0", "79", "0", "0", "reversedirection=yes highway=primary surface=asphalt bicycle=no", "", "3312", "329412"],
          ["7227854", "53584128", "0", "8", "7050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=no", "highway=crossing crossing=traffic_signals", "3317", "329412"],
          ["7227650", "53584051", "0", "20", "1050", "0", "111", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "", "3319", "329606"],
          ["7227102", "53583874", "0", "44", "1050", "0", "26", "0", "0", "highway=path foot=designated bicycle=designated", "highway=crossing crossing=uncontrolled", "3324", "330115"],
          ["7226735", "53583272", "1", "76", "1050", "0", "26", "0", "0", "highway=path foot=designated bicycle=designated", "railway=crossing", "3335", "331209"],
          ["7216406", "53589278", "1", "1033", "1050", "0", "43", "0", "0", "highway=path foot=designated bicycle=designated", "", "3499", "347604"],
          ["7216631", "53589730", "1", "69", "1050", "0", "77", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "highway=crossing crossing=traffic_signals", "3510", "348704"],
          ["7217366", "53591425", "0", "205", "1050", "0", "12", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "", "3542", "351948"],
          ["7217365", "53591581", "0", "18", "1050", "0", "18", "0", "0", "reversedirection=yes highway=path surface=asphalt", "", "3545", "352252"],
          ["7217185", "53591610", "0", "15", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals bicycle=yes crossing=traffic_signals", "3548", "352495"],
          ["7216086", "53591441", "0", "81", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_rcn=yes", "", "3560", "353750"],
          ["7216078", "53591356", "0", "10", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_rcn=yes", "", "3562", "353920"],
          ["7214125", "53591667", "2", "152", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "3591", "356865"],
          ["7213855", "53591679", "2", "18", "1000", "0", "0", "0", "0", "highway=residential surface=sett route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "3595", "357231"],
          ["7213747", "53591684", "2", "8", "1000", "0", "0", "0", "0", "highway=residential surface=sett route_bicycle_rcn=yes", "", "3597", "357390"],
          ["7212868", "53591548", "2", "63", "1000", "0", "0", "0", "0", "highway=residential surface=sett foot=designated vehicle=yes oneway=no route_bicycle_rcn=yes", "", "3609", "358617"],
          ["7212748", "53591494", "2", "10", "1000", "0", "0", "0", "0", "highway=pedestrian surface=sett foot=designated vehicle=yes oneway=no route_bicycle_rcn=yes", "", "3611", "358822"],
          ["7208122", "53596191", "6", "614", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian bicycle=dismount route_bicycle_rcn=yes", "", "3729", "370601"],
          ["7208056", "53596174", "6", "3", "3050", "0", "81", "0", "0", "highway=pedestrian surface=paving_stones", "", "3729", "370660"],
          ["7208122", "53596191", "6", "3", "3050", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones", "", "3730", "370687"],
          ["7208082", "53596236", "6", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian bicycle=dismount route_bicycle_rcn=yes", "", "3730", "370744"],
          ["7205786", "53595864", "10", "161", "5000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "3844", "372052"],
          ["7205423", "53595741", "10", "29", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt oneway=no route_bicycle_rcn=yes", "", "3851", "372739"],
          ["7203197", "53595050", "10", "174", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "3884", "376038"],
          ["7202790", "53595057", "10", "28", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt oneway=yes route_bicycle_rcn=yes", "", "3889", "376500"],
          ["7202406", "53594973", "10", "41", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt junction=roundabout route_bicycle_rcn=yes", "", "3895", "377166"],
          ["7202359", "53594945", "10", "5", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "3896", "377250"],
          ["7202175", "53594782", "10", "22", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_rcn=yes", "", "3900", "377619"],
          ["7199980", "53593249", "7", "228", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt route_bicycle_rcn=yes", "", "3932", "380872"],
          ["7195999", "53592077", "5", "304", "1000", "0", "0", "0", "0", "highway=secondary surface=paving_stones oneway=yes route_bicycle_rcn=yes", "", "3973", "384995"],
          ["7193051", "53591350", "5", "213", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt route_bicycle_rcn=yes", "", "4006", "388216"],
          ["7193040", "53591345", "5", "1", "1650", "0", "3", "0", "0", "reversedirection=yes highway=secondary surface=asphalt", "", "4006", "388225"],
          ["7193197", "53591163", "5", "23", "1150", "0", "74", "0", "0", "highway=residential surface=asphalt", "", "4008", "388451"],
          ["7197079", "53591457", "5", "418", "1150", "0", "91", "0", "0", "highway=residential", "highway=crossing crossing=uncontrolled", "4067", "394385"],
          ["7199980", "53593249", "7", "278", "1650", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "4123", "399963"],
          ["7202175", "53594782", "10", "228", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt route_bicycle_rcn=yes", "", "4173", "404961"],
          ["7202436", "53594874", "10", "21", "1650", "0", "8", "0", "0", "highway=secondary surface=asphalt oneway=yes", "highway=crossing crossing=uncontrolled", "4177", "405381"],
          ["7202480", "53594896", "10", "4", "1650", "0", "1", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "4178", "405459"],
          ["7202617", "53595115", "10", "57", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt junction=roundabout route_bicycle_rcn=yes", "", "4189", "406532"],
          ["7201979", "53595676", "8", "79", "1650", "0", "39", "0", "0", "highway=secondary surface=asphalt oneway=yes", "highway=traffic_signals crossing=traffic_signals", "4201", "407773"],
          ["7201727", "53595765", "8", "20", "1650", "0", "4", "0", "0", "highway=secondary surface=asphalt oneway=yes", "", "4204", "408029"],
          ["7201234", "53596049", "7", "45", "1650", "0", "2", "0", "0", "highway=secondary surface=asphalt", "", "4209", "408593"],
          ["7201727", "53595765", "8", "45", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt", "", "4214", "409074"],
          ["7201615", "53595730", "8", "9", "1150", "0", "118", "0", "0", "highway=residential", "highway=crossing crossing=uncontrolled", "4215", "409180"],
          ["7187967", "53602274", "3", "1181", "1050", "0", "241", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated", "", "4394", "427070"],
          ["7185770", "53603253", "2", "182", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "highway=crossing crossing=unmarked", "4421", "429747"],
          ["7184051", "53604021", "0", "143", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "highway=crossing crossing=unmarked", "4439", "431570"],
          ["7181282", "53605266", "1", "231", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "highway=crossing crossing=uncontrolled", "4480", "435669"],
          ["7177410", "53606978", "0", "321", "1050", "0", "2", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "highway=traffic_signals bicycle=yes crossing=traffic_signals traffic_signals:direction=forward", "4528", "440498"],
          ["7174336", "53608402", "-1", "262", "1050", "0", "18", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=designated bicycle=designated", "", "4569", "444563"],
          ["7172019", "53609447", "0", "194", "1050", "0", "0", "0", "0", "reversedirection=yes highway=cycleway foot=designated bicycle=designated", "", "4606", "448260"],
          ["7170842", "53610134", "0", "111", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=yes", "highway=crossing crossing=uncontrolled", "4626", "450210"],
          ["7160051", "53617911", "1", "1127", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=yes", "highway=crossing", "4823", "469965"],
          ["7155914", "53620213", "1", "403", "1050", "0", "58", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=yes", "", "4890", "476626"],
          ["7155815", "53620246", "1", "8", "1000", "0", "0", "0", "0", "highway=service route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4891", "476763"],
          ["7154077", "53618383", "-8192", "238", "1000", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4921", "479777"],
          ["7152918", "53617113", "-8192", "162", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4948", "482425"],
          ["7152231", "53616504", "-8192", "84", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=cobblestone bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4962", "483832"],
          ["7152022", "53616278", "-8192", "29", "1000", "0", "0", "0", "0", "highway=pedestrian bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4967", "484318"],
          ["7152075", "53615875", "-8192", "53", "1000", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "4976", "485208"],
          ["7150849", "53614653", "0", "167", "1000", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5000", "487664"],
          ["7146764", "53610441", "0", "558", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5095", "497198"],
          ["7145665", "53610010", "0", "94", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "5111", "498794"],
          ["7138313", "53604956", "0", "721", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt", "", "5231", "510764"]
        ],
        "times": [0, 12.997, 14.847, 19.062, 22.332, 26.179, 30.762, 31.582, 32.412, 36.056, 39.551, 41.952, 44.869, 47.627, 53.036, 59.803, 66.153, 88.859, 94.036, 102.862, 105.646, 108.027, 110.543, 117.127, 123.501, 125.358, 131.085, 132.312, 138.423, 140.845, 146.657, 151.09, 158.316, 160.658, 163.148, 165.377, 172.962, 175.777, 183.626, 192.998, 199.419, 201.83, 203.376, 205.946, 206.503, 208.155, 209.705, 211.819, 217.387, 221.445, 222.533, 223.715, 227.026, 232.433, 234.206, 236.181, 237.642, 239.199, 241.1, 284.988, 287.87, 290.748, 293.791, 297.169, 331.7, 332.863, 336.19, 337.022, 378.053, 450.363, 470.963, 475.314, 476.926, 479.207, 480.148, 480.61, 480.988, 482.602, 492.018, 493.879, 498.272, 636.664, 647.882, 665.799, 678.234, 689.979, 699.852, 704.415, 714.959, 727.496, 754.898, 757.563, 759.601, 760.863, 767.363, 768.109, 769.464, 770.83, 773.288, 774.374, 775.153, 780.661, 784.041, 790.758, 794.181, 795.865, 806.19, 809.18, 824.911, 826.843, 865.303, 871.545, 873.307, 874.885, 883.145, 885.12, 888.157, 891.324, 892.979, 906.751, 910.097, 911.38, 916.743, 919.402, 921.298, 926.251, 927.007, 929.145, 933.024, 938.148, 945.892, 955.645, 961.793, 965.078, 971.903, 1005.44, 1090.583, 1183.45, 1185.722, 1186.418, 1187.462, 1189.888, 1190.925, 1192.477, 1194.025, 1195.742, 1201.555, 1204.921, 1208.123, 1210.055, 1211.891, 1215.975, 1228.39, 1316.651, 1338.81, 1340.824, 1355.261, 1360.97, 1363.993, 1365.169, 1367.675, 1370.702, 1373.287, 1378.755, 1407.33, 1469.556, 1528.933, 1550.528, 1570.133, 1622.115, 1639.631, 1666.088, 1683.614, 1710.468, 1737.032, 1763.144, 1786.218, 1811.218, 1835.52, 1844.404, 1847.687, 1850.792, 1858.687, 1860.574, 1861.9, 1864.746, 1869.311, 1872.606, 1874.214, 1881.09, 1893.594, 1895.017, 1907.893, 1911.528, 1914.895, 1930.313, 1931.712, 1933.28, 1943.285, 1948.411, 1949.603, 1952.162, 1960.92, 1966.141, 1985.277, 2001.813, 2003.885, 2006.276, 2007.279, 2008.368, 2013.546, 2015.833, 2017.724, 2019.209, 2020.353, 2021.917, 2023.93, 2025.723, 2027.557, 2029.741, 2032.55, 2035.461, 2038.348, 2045.449, 2051.556, 2069.94, 2093.774, 2107.448, 2116.653, 2127.451, 2142.726, 2143.566, 2162.869, 2164.959, 2173.788, 2192.922, 2205.874, 2217.247, 2219.337, 2224.933, 2228.519, 2251.824, 2272.953, 2281.526, 2285.008, 2334.319, 2341.044, 2353.072, 2411.017, 2443.213, 2453.808, 2458.964, 2479.827, 2486.106, 2489.636, 2493.658, 2497.577, 2501.609, 2506.299, 2510.214, 2515.954, 2525.4, 2532.766, 2536.339, 2553.781, 2575.142, 2589.349, 2594.834, 2621.695, 2632.398, 2635.975, 2640.917, 2649.085, 2652.183, 2663.282, 2670.814, 2681.707, 2709.897, 2724.414, 2747.581, 2777.199, 2792.142, 2798.268, 2835.685, 2873.962, 2877.928, 2891.067, 2892.403, 2901.57, 2910.56, 2916.368, 2919.225, 2949.662, 2956.2, 2967.288, 2969.212, 3001.571, 3037.278, 3042.466, 3070.027, 3082.972, 3086.706, 3104.075, 3107.713, 3111.593, 3117.171, 3139.645, 3179.366, 3223.678, 3245.596, 3264.384, 3267.945, 3273.081, 3281.863, 3285.89, 3291.765, 3297.738, 3300.814, 3301.368, 3302.015, 3303.454, 3304.75, 3305.371, 3305.775, 3306.813, 3312.189, 3317.315, 3318.25, 3318.65, 3319.262, 3320.918, 3322.776, 3323.255, 3324.352, 3325.098, 3326.573, 3329.054, 3330.853, 3332.828, 3333.748, 3335.291, 3336.607, 3337.791, 3339.136, 3340.494, 3341.864, 3343.4, 3344.948, 3345.727, 3346.509, 3348.35, 3350.526, 3351.531, 3352.473, 3356.827, 3358.82, 3359.984, 3361.902, 3363.248, 3402.587, 3419.126, 3427.258, 3440.606, 3442.098, 3447.411, 3458.042, 3460.57, 3464.217, 3467.443, 3469.722, 3473.033, 3473.732, 3475.576, 3478.344, 3482.411, 3492.195, 3494.875, 3497.913, 3499.224, 3501.031, 3502.183, 3503.171, 3504.877, 3508.646, 3509.279, 3510.233, 3513.431, 3515.526, 3519.2, 3521.378, 3523.105, 3526.912, 3537.096, 3540.474, 3541.487, 3542.668, 3544.186, 3545.704, 3546.715, 3548.139, 3549.334, 3550.388, 3551.451, 3552.024, 3555.237, 3557.458, 3560.688, 3562.386, 3565.096, 3567.579, 3573.132, 3577.334, 3578.34, 3579.733, 3584.396, 3587.421, 3589.414, 3590.789, 3591.831, 3595.496, 3597.087, 3598.851, 3603.635, 3606.626, 3609.352, 3611.4, 3624.643, 3631.543, 3646.095, 3650.314, 3652.446, 3660.056, 3663.535, 3669.806, 3670.993, 3675.459, 3683.366, 3692.196, 3698.641, 3709.382, 3711.021, 3729.169, 3729.755, 3730.031, 3730.595, 3754.863, 3765.796, 3772.031, 3778.978, 3813.264, 3844.585, 3846.454, 3851.452, 3852.914, 3855.514, 3862.389, 3869.337, 3872.141, 3875.274, 3882.623, 3884.433, 3887.236, 3889.055, 3889.717, 3890.38, 3891.042, 3891.706, 3892.535, 3893.313, 3894.095, 3894.878, 3895.718, 3896.557, 3900.249, 3903.103, 3911.07, 3914.981, 3915.424, 3917.827, 3921.38, 3927.025, 3932.773, 3934.179, 3935.752, 3938.231, 3941.342, 3943.669, 3951.253, 3952.269, 3959.562, 3960.222, 3963.958, 3969.665, 3973.987, 3999.564, 4005.828, 4006.197, 4006.291, 4008.542, 4025.491, 4027.077, 4031.438, 4032.678, 4034.026, 4035.414, 4041.764, 4067.88, 4082.46, 4099.792, 4110.129, 4116.672, 4123.65, 4132.412, 4141.791, 4147.847, 4151.686, 4152.344, 4158.801, 4170.105, 4173.628, 4177.823, 4178.605, 4179.77, 4180.925, 4181.88, 4182.829, 4183.584, 4184.336, 4185.644, 4186.387, 4187.126, 4187.864, 4188.598, 4189.33, 4190.967, 4192.053, 4193.738, 4198.188, 4201.739, 4204.301, 4209.938, 4214.754, 4215.81, 4227.649, 4233.11, 4244.95, 4247.563, 4253.57, 4272.125, 4305.832, 4321.821, 4326.527, 4359.767, 4374.928, 4375.999, 4377.421, 4378.306, 4379.189, 4380.246, 4381.476, 4394.688, 4421.46, 4427.531, 4439.688, 4452.544, 4460.478, 4480.672, 4507.084, 4523.452, 4525.936, 4526.765, 4528.95, 4531.129, 4532.303, 4544.364, 4552.936, 4569.587, 4572.04, 4601.997, 4606.559, 4616.315, 4621.252, 4626.057, 4635.01, 4669.911, 4683.004, 4709.848, 4743.946, 4761.811, 4775.081, 4785.968, 4804.244, 4807.944, 4813.829, 4823.593, 4830.379, 4852.842, 4860.649, 4866.797, 4871.449, 4873.29, 4875.267, 4878.432, 4881.225, 4884.348, 4887.109, 4889.002, 4890.204, 4891.575, 4893.799, 4921.701, 4924.27, 4948.176, 4951.523, 4957.889, 4962.248, 4967.112, 4971.139, 4972.314, 4976.007, 4976.678, 4977.854, 4979.7, 4982.555, 4999.262, 5000.566, 5001.709, 5003.511, 5007.127, 5011.752, 5014.57, 5022.055, 5030.235, 5040.949, 5041.787, 5044.804, 5055.42, 5056.686, 5066.268, 5073.174, 5074.826, 5084.289, 5086.288, 5088.188, 5089.88, 5092.294, 5095.902, 5097.615, 5099.058, 5102.316, 5105.733, 5111.18, 5111.859, 5128.265, 5154.368, 5178.23, 5198.559, 5203.958, 5214.486, 5227.894, 5231.558]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [7.308232, 53.442747, -1.0],
          [7.308314, 53.442579, -1.0],
          [7.308373, 53.442427, -1.0],
          [7.308920, 53.442557, -1.5],
          [7.309227, 53.442748, -2.0],
          [7.309458, 53.442997, -2.0],
          [7.309657, 53.443288, -2.0],
          [7.309731, 53.443315, -2.0],
          [7.309800, 53.443341, -2.0],
          [7.310145, 53.443469, -2.25],
          [7.310450, 53.443615, -2.5],
          [7.310526, 53.443778, -3.0],
          [7.310217, 53.443843, -3.0],
          [7.309930, 53.443922, -3.25],
          [7.309454, 53.444087, -3.0],
          [7.308976, 53.444321, -2.75],
          [7.308592, 53.444601, -3.0],
          [7.307775, 53.445767, -3.0],
          [7.307612, 53.446024, -3.0],
          [7.307319, 53.446435, -2.75],
          [7.307227, 53.446550, -2.5],
          [7.307115, 53.446645, -2.5],
          [7.306984, 53.446730, -2.25],
          [7.306630, 53.446907, -1.75],
          [7.306242, 53.447068, -1.75],
          [7.306137, 53.447112, -1.5],
          [7.305812, 53.447247, -1.25],
          [7.305748, 53.447274, -1.25],
          [7.305401, 53.447420, -1.0],
          [7.305265, 53.447478, -1.0],
          [7.304924, 53.447621, -0.75],
          [7.304677, 53.447727, -0.5],
          [7.304295, 53.447901, 0.0],
          [7.304150, 53.447948, 0.0],
          [7.303991, 53.447990, 0.0],
          [7.303832, 53.448005, 0.0],
          [7.303261, 53.448039, 0.0],
          [7.303041, 53.448049, 0.0],
          [7.302409, 53.448092, 0.0],
          [7.301624, 53.448140, 0.0],
          [7.301070, 53.448168, 0.0],
          [7.300880, 53.448196, 0.0],
          [7.300755, 53.448221, 0.0],
          [7.300577, 53.448289, 0.0],
          [7.300506, 53.448317, 0.0],
          [7.300313, 53.448406, 0.0],
          [7.300160, 53.448499, 0.0],
          [7.299988, 53.448646, -0.25],
          [7.299611, 53.449018, -0.5],
          [7.299331, 53.449291, -1.25],
          [7.299280, 53.449359, -1.25],
          [7.299245, 53.449438, -1.5],
          [7.299297, 53.449696, -2.0],
          [7.299380, 53.450121, -2.75],
          [7.299396, 53.450252, -3.0],
          [7.299393, 53.450393, -3.0],
          [7.299361, 53.450496, -3.25],
          [7.299311, 53.450602, -3.5],
          [7.299230, 53.450730, -3.75],
          [7.297886, 53.452830, -2.0],
          [7.297814, 53.452973, -2.0],
          [7.297761, 53.453121, -2.0],
          [7.297694, 53.453270, -2.0],
          [7.297585, 53.453433, -2.0],
          [7.296148, 53.455243, -2.75],
          [7.296112, 53.455301, -2.75],
          [7.295985, 53.455462, -2.75],
          [7.295955, 53.455502, -2.75],
          [7.294362, 53.457542, -3.0],
          [7.291619, 53.461045, -3.0],
          [7.290930, 53.461938, -2.5],
          [7.290838, 53.462145, -2.25],
          [7.290782, 53.462217, -2.25],
          [7.290700, 53.462312, -2.0],
          [7.290633, 53.462295, -2.0],
          [7.290700, 53.462312, -2.0],
          [7.290747, 53.462328, -2.0],
          [7.290992, 53.462360, -2.25],
          [7.292210, 53.462706, -3.0],
          [7.292409, 53.462760, -3.0],
          [7.292999, 53.462924, -3.0],
          [7.304093, 53.466180, -1.0],
          [7.305025, 53.466470, -1.25],
          [7.306323, 53.466916, -0.75],
          [7.307146, 53.467224, -0.25],
          [7.307915, 53.467529, 0.0],
          [7.308593, 53.467812, 0.0],
          [7.308908, 53.467950, 0.0],
          [7.309628, 53.468276, 0.0],
          [7.310435, 53.468669, 0.25],
          [7.312427, 53.469636, -0.25],
          [7.312601, 53.469726, -0.25],
          [7.312727, 53.469811, -0.5],
          [7.312815, 53.469858, -0.5],
          [7.313336, 53.470110, -1.0],
          [7.313376, 53.470137, -1.0],
          [7.313449, 53.470205, -1.0],
          [7.313551, 53.470258, -1.0],
          [7.313735, 53.470337, -1.0],
          [7.313829, 53.470357, -1.0],
          [7.313892, 53.470379, -1.0],
          [7.314273, 53.470568, -0.75],
          [7.314486, 53.470672, -0.5],
          [7.314888, 53.470856, 0.0],
          [7.315112, 53.470930, 0.0],
          [7.315210, 53.470973, 0.0],
          [7.315923, 53.471336, -0.5],
          [7.316121, 53.471431, -0.25],
          [7.317124, 53.471931, 0.0],
          [7.317230, 53.471998, 0.0],
          [7.319866, 53.473264, 0.0],
          [7.320290, 53.473450, 0.25],
          [7.320404, 53.473504, 0.25],
          [7.320494, 53.473559, 0.25],
          [7.321018, 53.473810, 0.5],
          [7.321147, 53.473861, 0.5],
          [7.321321, 53.473951, 0.75],
          [7.321515, 53.474047, 0.75],
          [7.321603, 53.474106, 0.75],
          [7.322540, 53.474566, 0.5],
          [7.322766, 53.474691, 0.25],
          [7.322851, 53.474729, 0.25],
          [7.323255, 53.474919, 0.0],
          [7.323438, 53.475015, 0.0],
          [7.323577, 53.475077, 0.0],
          [7.323988, 53.475206, 0.0],
          [7.324010, 53.475241, -0.25],
          [7.324079, 53.475354, -0.25],
          [7.323881, 53.475537, -0.25],
          [7.323440, 53.475946, -1.0],
          [7.322873, 53.476505, -1.75],
          [7.322291, 53.477101, -2.0],
          [7.321956, 53.477427, -2.0],
          [7.321790, 53.477588, -2.0],
          [7.321477, 53.477913, -1.75],
          [7.320059, 53.479316, -1.0],
          [7.316077, 53.483300, -1.5],
          [7.312104, 53.487278, 0.0],
          [7.311991, 53.487370, 0.0],
          [7.311946, 53.487386, 0.0],
          [7.311873, 53.487397, 0.0],
          [7.311835, 53.487515, 0.0],
          [7.311817, 53.487565, 0.0],
          [7.311707, 53.487605, 0.0],
          [7.311670, 53.487675, 0.0],
          [7.311611, 53.487750, 0.0],
          [7.311368, 53.488009, 0.0],
          [7.311212, 53.488163, -0.25],
          [7.311012, 53.488305, -0.5],
          [7.310910, 53.488408, -1.0],
          [7.310821, 53.488510, -1.0],
          [7.310628, 53.488758, -1.5],
          [7.309882, 53.489479, -2.25],
          [7.305771, 53.493596, -2.0],
          [7.304733, 53.494610, -2.0],
          [7.304645, 53.494703, -2.0],
          [7.303996, 53.495370, -2.0],
          [7.303737, 53.495624, -2.0],
          [7.303580, 53.495755, -2.0],
          [7.303515, 53.495794, -2.0],
          [7.303401, 53.495891, -1.75],
          [7.303299, 53.496020, -1.5],
          [7.303230, 53.496124, -1.25],
          [7.303043, 53.496318, -0.75],
          [7.302084, 53.497270, 0.0],
          [7.298922, 53.500442, -2.0],
          [7.296244, 53.503107, -1.5],
          [7.295151, 53.504170, -2.0],
          [7.294147, 53.505206, -2.75],
          [7.291869, 53.507466, -2.0],
          [7.290942, 53.508368, -2.75],
          [7.290124, 53.509206, -1.0],
          [7.289227, 53.510096, -1.75],
          [7.288403, 53.510947, 0.0],
          [7.287171, 53.512170, -0.25],
          [7.285857, 53.513444, -0.75],
          [7.284969, 53.514366, 0.0],
          [7.284063, 53.515282, 1.0],
          [7.283393, 53.515923, 3.75],
          [7.282938, 53.516313, 2.5],
          [7.282748, 53.516465, 2.0],
          [7.282484, 53.516616, 1.0],
          [7.282086, 53.517029, 1.5],
          [7.281925, 53.517085, 1.25],
          [7.281795, 53.517102, 1.25],
          [7.281639, 53.517238, 1.25],
          [7.281275, 53.517433, 0.75],
          [7.281074, 53.517611, 0.5],
          [7.280955, 53.517685, 0.25],
          [7.280460, 53.518054, -0.25],
          [7.279652, 53.518608, 0.0],
          [7.279739, 53.518667, 0.0],
          [7.279068, 53.519132, 0.75],
          [7.278888, 53.519255, 1.0],
          [7.278711, 53.519367, 1.0],
          [7.277832, 53.519925, 1.0],
          [7.277751, 53.519976, 1.0],
          [7.277663, 53.520031, 1.0],
          [7.277080, 53.520408, 1.0],
          [7.276783, 53.520603, 1.0],
          [7.276715, 53.520644, 1.0],
          [7.276548, 53.520743, 0.75],
          [7.275927, 53.521046, 0.75],
          [7.275567, 53.521197, 1.0],
          [7.274369, 53.521703, 1.75],
          [7.273576, 53.522078, 3.25],
          [7.273468, 53.522119, 3.5],
          [7.273375, 53.522180, 3.75],
          [7.273318, 53.522252, 4.0],
          [7.273275, 53.522330, 4.25],
          [7.273556, 53.522666, 4.5],
          [7.273662, 53.522817, 4.0],
          [7.273698, 53.522948, 4.0],
          [7.273702, 53.523053, 3.75],
          [7.273597, 53.523094, 3.75],
          [7.273550, 53.523196, 3.75],
          [7.273446, 53.523310, 3.75],
          [7.273320, 53.523394, 3.75],
          [7.273223, 53.523494, 3.75],
          [7.273141, 53.523628, 3.5],
          [7.273076, 53.523808, 3.25],
          [7.273039, 53.523998, 3.0],
          [7.272990, 53.524186, 2.75],
          [7.272771, 53.524659, 2.25],
          [7.272496, 53.525046, 1.75],
          [7.271691, 53.526167, 1.25],
          [7.270899, 53.527194, 2.0],
          [7.270211, 53.528069, 0.5],
          [7.269785, 53.528616, -0.5],
          [7.269297, 53.529251, -1.0],
          [7.268694, 53.530016, -0.75],
          [7.268638, 53.530088, -0.75],
          [7.267699, 53.531300, 0.25],
          [7.267617, 53.531406, 0.25],
          [7.267266, 53.531870, 0.0],
          [7.266658, 53.532639, 1.25],
          [7.266333, 53.533077, 2.5],
          [7.265976, 53.533487, 2.75],
          [7.265846, 53.533546, 2.5],
          [7.265720, 53.533820, 2.25],
          [7.265612, 53.534002, 2.0],
          [7.264574, 53.535363, 0.75],
          [7.263668, 53.536544, 0.0],
          [7.263333, 53.536960, 0.0],
          [7.263213, 53.537132, 0.0],
          [7.261664, 53.539135, 1.75],
          [7.261407, 53.539461, 1.5],
          [7.260961, 53.540084, 1.25],
          [7.258725, 53.542968, 1.0],
          [7.257479, 53.544526, 1.0],
          [7.257126, 53.545019, 1.25],
          [7.256950, 53.545247, 1.5],
          [7.256220, 53.546196, 1.5],
          [7.255995, 53.546476, 1.75],
          [7.255827, 53.546622, 1.75],
          [7.255706, 53.546815, 1.75],
          [7.255601, 53.547020, 1.5],
          [7.255447, 53.547233, 1.25],
          [7.255293, 53.547513, 0.75],
          [7.255183, 53.547727, 1.0],
          [7.255077, 53.548039, 1.0],
          [7.254956, 53.548581, 0.75],
          [7.254902, 53.548987, 0.75],
          [7.254881, 53.549183, 0.75],
          [7.254748, 53.550268, 0.0],
          [7.254611, 53.551185, 1.0],
          [7.254512, 53.551856, 1.5],
          [7.254466, 53.552192, 0.5],
          [7.254259, 53.553717, 0.5],
          [7.254186, 53.554228, 1.0],
          [7.254140, 53.554402, 1.0],
          [7.254076, 53.554648, 1.0],
          [7.253995, 53.555059, 1.0],
          [7.253952, 53.555217, 1.0],
          [7.253799, 53.555786, 1.0],
          [7.253614, 53.556145, 1.25],
          [7.253324, 53.556610, 1.75],
          [7.252451, 53.557631, 2.75],
          [7.251798, 53.558268, 2.75],
          [7.250424, 53.559572, 1.0],
          [7.248717, 53.561285, -1.0],
          [7.248090, 53.561970, -0.75],
          [7.247846, 53.562237, -0.5],
          [7.246725, 53.563648, 1.0],
          [7.245164, 53.565655, 0.0],
          [7.245019, 53.565844, 0.0],
          [7.244501, 53.566482, 0.0],
          [7.244458, 53.566543, 0.0],
          [7.244158, 53.566973, 0.25],
          [7.243756, 53.567368, 0.25],
          [7.243546, 53.567619, 0.5],
          [7.243417, 53.567723, 0.75],
          [7.242623, 53.568521, 2.75],
          [7.242372, 53.568763, 3.25],
          [7.242020, 53.569179, 3.75],
          [7.241952, 53.569248, 4.0],
          [7.241208, 53.569986, 7.25],
          [7.239992, 53.571216, 7.5],
          [7.239574, 53.571649, 3.5],
          [7.238090, 53.573144, 4.25],
          [7.237301, 53.573933, 3.0],
          [7.237108, 53.574135, 2.5],
          [7.236229, 53.575022, 2.5],
          [7.236029, 53.575172, 2.5],
          [7.235862, 53.575341, 2.75],
          [7.235662, 53.575598, 2.75],
          [7.234545, 53.576741, 2.0],
          [7.232798, 53.578470, 2.5],
          [7.230745, 53.580549, 2.25],
          [7.229986, 53.581280, 4.0],
          [7.229197, 53.581987, 4.25],
          [7.229068, 53.582117, 4.75],
          [7.228875, 53.582298, 5.0],
          [7.228522, 53.582632, 5.0],
          [7.228361, 53.582820, 4.5],
          [7.228145, 53.583118, 4.25],
          [7.227941, 53.583522, 3.0],
          [7.227849, 53.583761, 1.75],
          [7.227817, 53.583799, 1.5],
          [7.227771, 53.583836, 1.25],
          [7.227714, 53.583950, 0.75],
          [7.227650, 53.584051, 0.25],
          [7.227674, 53.584102, 0.25],
          [7.227711, 53.584121, 0.0],
          [7.227854, 53.584128, 0.0],
          [7.227876, 53.584061, 0.25],
          [7.227854, 53.584128, 0.0],
          [7.227711, 53.584121, 0.0],
          [7.227674, 53.584102, 0.25],
          [7.227650, 53.584051, 0.25],
          [7.227469, 53.583986, 0.5],
          [7.227268, 53.583924, 0.5],
          [7.227215, 53.583913, 0.5],
          [7.227102, 53.583874, 0.5],
          [7.227041, 53.583847, 0.5],
          [7.226999, 53.583760, 0.75],
          [7.226859, 53.583622, 0.75],
          [7.226807, 53.583520, 1.0],
          [7.226778, 53.583407, 1.0],
          [7.226775, 53.583354, 1.0],
          [7.226735, 53.583272, 1.0],
          [7.226684, 53.583202, 0.75],
          [7.226613, 53.583147, 0.75],
          [7.226507, 53.583100, 0.75],
          [7.226397, 53.583061, 0.75],
          [7.226278, 53.583046, 0.75],
          [7.226131, 53.583045, 0.75],
          [7.225996, 53.583066, 0.75],
          [7.225929, 53.583083, 0.75],
          [7.225872, 53.583105, 0.75],
          [7.225750, 53.583170, 1.0],
          [7.225642, 53.583262, 1.0],
          [7.225614, 53.583309, 1.0],
          [7.225602, 53.583358, 0.75],
          [7.225608, 53.583614, 0.5],
          [7.225580, 53.583721, 0.5],
          [7.225549, 53.583785, 0.25],
          [7.225457, 53.583887, 0.25],
          [7.225383, 53.583947, 0.25],
          [7.222693, 53.585513, 0.0],
          [7.221711, 53.586079, 0.5],
          [7.221275, 53.586374, 0.75],
          [7.220539, 53.586789, 1.25],
          [7.220460, 53.586840, 1.25],
          [7.220164, 53.587029, 1.25],
          [7.219494, 53.587418, 1.0],
          [7.219332, 53.587509, 1.0],
          [7.218934, 53.587735, 1.0],
          [7.218622, 53.587914, 1.0],
          [7.218405, 53.588021, 1.0],
          [7.218141, 53.588186, 1.0],
          [7.218114, 53.588227, 1.25],
          [7.217982, 53.588301, 1.25],
          [7.217795, 53.588411, 1.5],
          [7.217522, 53.588578, 1.5],
          [7.216841, 53.588975, 1.25],
          [7.216673, 53.589095, 1.0],
          [7.216472, 53.589226, 1.0],
          [7.216406, 53.589278, 1.25],
          [7.216281, 53.589337, 1.25],
          [7.216225, 53.589385, 1.25],
          [7.216218, 53.589438, 1.25],
          [7.216315, 53.589516, 1.0],
          [7.216565, 53.589661, 1.0],
          [7.216571, 53.589690, 1.0],
          [7.216631, 53.589730, 1.0],
          [7.216820, 53.589859, 1.0],
          [7.216923, 53.589955, 1.0],
          [7.217068, 53.590152, 0.75],
          [7.217134, 53.590270, 0.75],
          [7.217172, 53.590361, 0.75],
          [7.217216, 53.590571, 0.75],
          [7.217291, 53.591162, 0.5],
          [7.217299, 53.591333, 0.75],
          [7.217310, 53.591378, 0.75],
          [7.217366, 53.591425, 0.75],
          [7.217363, 53.591502, 0.75],
          [7.217365, 53.591581, 0.75],
          [7.217309, 53.591619, 0.75],
          [7.217185, 53.591610, 0.5],
          [7.217078, 53.591605, 0.25],
          [7.217014, 53.591558, 0.25],
          [7.216929, 53.591539, 0.25],
          [7.216873, 53.591527, 0.0],
          [7.216549, 53.591485, 0.0],
          [7.216358, 53.591443, 0.25],
          [7.216086, 53.591441, 0.5],
          [7.216078, 53.591356, 0.5],
          [7.215855, 53.591373, 0.75],
          [7.215662, 53.591357, 1.0],
          [7.215254, 53.591324, 1.25],
          [7.214936, 53.591299, 1.25],
          [7.214868, 53.591307, 1.5],
          [7.214793, 53.591342, 1.5],
          [7.214598, 53.591515, 1.5],
          [7.214421, 53.591608, 1.5],
          [7.214292, 53.591646, 1.75],
          [7.214192, 53.591659, 1.75],
          [7.214125, 53.591667, 2.0],
          [7.213855, 53.591679, 2.0],
          [7.213747, 53.591684, 2.0],
          [7.213620, 53.591678, 2.0],
          [7.213261, 53.591646, 2.0],
          [7.213049, 53.591601, 2.25],
          [7.212868, 53.591548, 2.25],
          [7.212748, 53.591494, 2.5],
          [7.212320, 53.591915, 3.5],
          [7.212122, 53.592126, 4.25],
          [7.211771, 53.592487, 5.75],
          [7.211660, 53.592600, 6.0],
          [7.211606, 53.592655, 6.0],
          [7.211338, 53.592917, 5.5],
          [7.211221, 53.593044, 5.5],
          [7.210969, 53.593308, 5.25],
          [7.210922, 53.593355, 5.0],
          [7.210571, 53.593708, 4.75],
          [7.210057, 53.594218, 4.75],
          [7.209558, 53.594701, 4.75],
          [7.209245, 53.595017, 5.0],
          [7.208811, 53.595458, 5.75],
          [7.208745, 53.595526, 5.75],
          [7.208122, 53.596191, 6.75],
          [7.208093, 53.596183, 6.75],
          [7.208122, 53.596191, 6.75],
          [7.208082, 53.596236, 6.75],
          [7.207557, 53.596168, 7.5],
          [7.207331, 53.596142, 7.5],
          [7.207199, 53.596125, 7.75],
          [7.207057, 53.596106, 7.75],
          [7.206369, 53.595998, 8.5],
          [7.205786, 53.595864, 10.0],
          [7.205693, 53.595833, 10.25],
          [7.205423, 53.595741, 10.5],
          [7.205355, 53.595716, 10.75],
          [7.205224, 53.595671, 10.75],
          [7.204864, 53.595502, 10.75],
          [7.204438, 53.595302, 10.5],
          [7.204248, 53.595223, 10.25],
          [7.204001, 53.595175, 10.25],
          [7.203350, 53.595077, 10.0],
          [7.203197, 53.595050, 10.0],
          [7.202952, 53.595056, 10.0],
          [7.202790, 53.595057, 10.0],
          [7.202757, 53.595081, 10.0],
          [7.202716, 53.595099, 10.0],
          [7.202668, 53.595111, 10.0],
          [7.202617, 53.595115, 10.0],
          [7.202547, 53.595109, 10.0],
          [7.202484, 53.595089, 9.75],
          [7.202435, 53.595057, 9.75],
          [7.202408, 53.595016, 9.75],
          [7.202406, 53.594973, 10.0],
          [7.202359, 53.594945, 10.0],
          [7.202175, 53.594782, 10.0],
          [7.202033, 53.594657, 10.0],
          [7.201566, 53.594307, 9.75],
          [7.201322, 53.594119, 9.25],
          [7.201311, 53.594101, 9.25],
          [7.201150, 53.593991, 9.0],
          [7.200879, 53.593813, 8.5],
          [7.200429, 53.593525, 8.0],
          [7.199980, 53.593249, 7.75],
          [7.199848, 53.593211, 7.75],
          [7.199702, 53.593184, 7.75],
          [7.199462, 53.593157, 7.75],
          [7.199148, 53.593122, 7.5],
          [7.198927, 53.593067, 7.5],
          [7.198208, 53.592838, 7.0],
          [7.198127, 53.592812, 7.0],
          [7.197336, 53.592564, 5.75],
          [7.197278, 53.592543, 5.75],
          [7.196950, 53.592426, 6.0],
          [7.196425, 53.592225, 5.5],
          [7.195999, 53.592077, 5.0],
          [7.193620, 53.591490, 5.0],
          [7.193097, 53.591361, 5.0],
          [7.193051, 53.591350, 5.0],
          [7.193040, 53.591345, 5.0],
          [7.193197, 53.591163, 5.0],
          [7.194343, 53.589893, 3.5],
          [7.194476, 53.589937, 3.25],
          [7.195069, 53.590133, 3.0],
          [7.195202, 53.590186, 3.25],
          [7.195324, 53.590244, 3.5],
          [7.195439, 53.590308, 3.5],
          [7.195879, 53.590591, 4.0],
          [7.197079, 53.591457, 5.5],
          [7.197870, 53.591963, 6.0],
          [7.198790, 53.592492, 6.75],
          [7.199312, 53.592813, 7.25],
          [7.199648, 53.593019, 7.5],
          [7.199980, 53.593249, 7.75],
          [7.200429, 53.593525, 8.0],
          [7.200879, 53.593813, 8.5],
          [7.201150, 53.593991, 9.0],
          [7.201311, 53.594101, 9.25],
          [7.201322, 53.594119, 9.25],
          [7.201566, 53.594307, 9.75],
          [7.202033, 53.594657, 10.0],
          [7.202175, 53.594782, 10.0],
          [7.202436, 53.594874, 10.0],
          [7.202480, 53.594896, 10.0],
          [7.202559, 53.594872, 10.0],
          [7.202647, 53.594869, 10.0],
          [7.202716, 53.594884, 10.0],
          [7.202772, 53.594911, 10.0],
          [7.202803, 53.594940, 10.0],
          [7.202820, 53.594973, 10.0],
          [7.202811, 53.595031, 10.0],
          [7.202790, 53.595057, 10.0],
          [7.202757, 53.595081, 10.0],
          [7.202716, 53.595099, 10.0],
          [7.202668, 53.595111, 10.0],
          [7.202617, 53.595115, 10.0],
          [7.202560, 53.595179, 10.0],
          [7.202521, 53.595222, 10.0],
          [7.202455, 53.595295, 9.75],
          [7.202230, 53.595503, 9.5],
          [7.201979, 53.595676, 8.75],
          [7.201727, 53.595765, 8.25],
          [7.201240, 53.596045, 7.75],
          [7.201727, 53.595765, 8.25],
          [7.201615, 53.595730, 8.25],
          [7.200352, 53.596477, 6.5],
          [7.199931, 53.596738, 5.75],
          [7.198982, 53.597306, 5.0],
          [7.198787, 53.597416, 5.0],
          [7.198284, 53.597632, 4.75],
          [7.196641, 53.598363, 4.0],
          [7.194188, 53.599466, 4.0],
          [7.192858, 53.600064, 3.25],
          [7.192544, 53.600205, 3.5],
          [7.190194, 53.601261, 3.5],
          [7.189223, 53.601708, 4.0],
          [7.189135, 53.601715, 4.0],
          [7.189037, 53.601684, 4.0],
          [7.188983, 53.601713, 4.0],
          [7.188933, 53.601740, 4.0],
          [7.188960, 53.601786, 4.0],
          [7.188921, 53.601836, 4.0],
          [7.187967, 53.602274, 3.75],
          [7.185770, 53.603253, 2.75],
          [7.185355, 53.603444, 3.0],
          [7.184051, 53.604021, 0.75],
          [7.183052, 53.604476, 0.5],
          [7.182553, 53.604704, 1.25],
          [7.181282, 53.605266, 1.5],
          [7.179035, 53.606286, 0.0],
          [7.177835, 53.606829, 0.0],
          [7.177654, 53.606906, 0.0],
          [7.177597, 53.606921, 0.0],
          [7.177410, 53.606978, -0.25],
          [7.177271, 53.607050, 0.0],
          [7.177227, 53.607103, 0.0],
          [7.176454, 53.607455, 0.5],
          [7.175745, 53.607765, -0.5],
          [7.174336, 53.608402, -1.0],
          [7.174162, 53.608480, -1.0],
          [7.172309, 53.609313, 0.0],
          [7.172019, 53.609447, 0.25],
          [7.171436, 53.609754, 0.5],
          [7.171141, 53.609937, 0.25],
          [7.170842, 53.610134, 0.0],
          [7.170313, 53.610509, 0.0],
          [7.168305, 53.611964, 0.0],
          [7.167549, 53.612498, 0.0],
          [7.166220, 53.613467, 0.75],
          [7.164554, 53.614670, 1.75],
          [7.163606, 53.615365, 2.0],
          [7.162863, 53.615894, 2.0],
          [7.162253, 53.616332, 2.0],
          [7.161216, 53.617078, 2.0],
          [7.161004, 53.617229, 2.0],
          [7.160660, 53.617466, 2.0],
          [7.160051, 53.617911, 1.5],
          [7.159629, 53.618220, 1.25],
          [7.158465, 53.619074, 2.0],
          [7.158018, 53.619442, 1.5],
          [7.157613, 53.619743, 1.0],
          [7.157339, 53.619961, 1.0],
          [7.157227, 53.620037, 1.0],
          [7.157090, 53.620095, 1.25],
          [7.156847, 53.620155, 1.5],
          [7.156624, 53.620197, 1.5],
          [7.156362, 53.620218, 1.5],
          [7.156135, 53.620200, 1.5],
          [7.155985, 53.620171, 1.5],
          [7.155914, 53.620213, 1.5],
          [7.155815, 53.620246, 1.5],
          [7.155721, 53.620146, 1.5],
          [7.154077, 53.618383],
          [7.153970, 53.618262],
          [7.152918, 53.617113],
          [7.152748, 53.616975],
          [7.152412, 53.616708],
          [7.152231, 53.616504],
          [7.152022, 53.616278],
          [7.151857, 53.616088],
          [7.151908, 53.616038],
          [7.152075, 53.615875],
          [7.152109, 53.615848],
          [7.152025, 53.615814, 1.0],
          [7.151907, 53.615755, 1.0],
          [7.151706, 53.615663, 1.0],
          [7.150838, 53.614722, 0.0],
          [7.150849, 53.614653, 0.0],
          [7.150767, 53.614629, 0.0],
          [7.150667, 53.614561, 0.0],
          [7.150516, 53.614389, 0.0],
          [7.150310, 53.614171, 0.0],
          [7.150189, 53.614039, 0.0],
          [7.149839, 53.613694, 0.0],
          [7.149463, 53.613318, 0.0],
          [7.148998, 53.612822, 0.0],
          [7.148961, 53.612783, 0.0],
          [7.148825, 53.612645, 0.0],
          [7.148384, 53.612208, 0.5],
          [7.148339, 53.612160, 0.5],
          [7.147944, 53.611737, 0.5],
          [7.147591, 53.611432, 0.25],
          [7.147512, 53.611364, 0.25],
          [7.146977, 53.610972, 0.25],
          [7.146889, 53.610888, 0.25],
          [7.146826, 53.610814, 0.75],
          [7.146782, 53.610743, 0.75],
          [7.146748, 53.610629, 0.75],
          [7.146764, 53.610441, 0.5],
          [7.146630, 53.610426, 0.5],
          [7.146505, 53.610402, 0.25],
          [7.146250, 53.610339, 0.5],
          [7.146015, 53.610237, 0.5],
          [7.145695, 53.610031, 0.5],
          [7.145665, 53.610010, 0.5],
          [7.144735, 53.609339, 0.5],
          [7.143262, 53.608267, 0.5],
          [7.141911, 53.607283, 0.5],
          [7.140756, 53.606443, 0.5],
          [7.140432, 53.606210, 0.25],
          [7.139755, 53.605762, 0.0],
          [7.138886, 53.605235, 0.0],
          [7.138645, 53.605118, 0.25]
        ]
      }
    }
  ]
}

let day19: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "J19 - Norden - Harlesiel - 54.3km",
        "track-length": "54341",
        "filtered ascend": "10",
        "plain-ascend": "4",
        "total-time": "9081",
        "total-energy": "899846",
        "cost": "58555",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["7138937", "53605198", "-8192", "23", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated", "", "2", "220"],
          ["7145730", "53609977", "0", "700", "1050", "0", "0", "0", "0", "highway=cycleway surface=asphalt foot=designated bicycle=designated", "", "113", "11340"],
          ["7145665", "53610010", "0", "6", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 access=destination bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "114", "11449"],
          ["7146764", "53610441", "0", "94", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "130", "13020"],
          ["7150849", "53614653", "0", "558", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "222", "22223"],
          ["7152075", "53615875", "1", "167", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "254", "25483"],
          ["7152022", "53616278", "1", "53", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "263", "26387"],
          ["7152231", "53616504", "1", "29", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "268", "26880"],
          ["7152918", "53617113", "1", "84", "1000", "0", "0", "0", "0", "highway=pedestrian surface=cobblestone bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "282", "28300"],
          ["7154077", "53618383", "1", "162", "1000", "0", "0", "0", "0", "highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "310", "31027"],
          ["7155815", "53620246", "-8192", "238", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "348", "34895"],
          ["7155914", "53620213", "-8192", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "349", "34975"],
          ["7160051", "53617911", "1", "403", "1050", "0", "61", "0", "0", "highway=path foot=designated bicycle=yes", "highway=crossing", "409", "40902"],
          ["7166220", "53613467", "0", "634", "1050", "0", "0", "0", "0", "highway=path foot=designated bicycle=yes", "", "513", "51388"],
          ["7160051", "53617911", "1", "634", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=yes", "highway=crossing", "613", "61310"],
          ["7158465", "53619074", "2", "168", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=yes", "", "642", "64235"],
          ["7158562", "53619123", "2", "9", "1350", "0", "88", "0", "0", "reversedirection=yes highway=service", "", "643", "64388"],
          ["7158178", "53619480", "1", "49", "1450", "0", "81", "0", "0", "highway=tertiary surface=asphalt", "", "651", "65195"],
          ["7157885", "53619827", "1", "44", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt", "", "658", "65853"],
          ["7158335", "53621755", "2", "226", "1350", "0", "5", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt", "", "699", "69982"],
          ["7158409", "53621869", "2", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing", "701", "70128"],
          ["7158534", "53622042", "2", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "703", "70352"],
          ["7159540", "53622370", "3", "82", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "714", "71452"],
          ["7159603", "53622403", "3", "6", "1000", "0", "0", "0", "0", "highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "715", "71551"],
          ["7160267", "53622737", "3", "60", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "725", "72583"],
          ["7164929", "53625059", "2", "409", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_rcn=yes", "", "793", "79389"],
          ["7166471", "53626105", "1", "173", "1350", "0", "84", "0", "0", "highway=service", "", "821", "82115"],
          ["7166279", "53626419", "1", "31", "5050", "0", "10", "0", "0", "highway=footway", "", "842", "82291"],
          ["7166471", "53626105", "1", "31", "5050", "0", "8", "0", "0", "reversedirection=yes highway=footway", "", "863", "82291"],
          ["7166537", "53626039", "1", "10", "1350", "0", "8", "0", "0", "reversedirection=yes highway=service", "", "864", "82400"],
          ["7166723", "53626270", "1", "29", "1350", "0", "126", "0", "0", "highway=service surface=concrete", "barrier=gate", "867", "82710"],
          ["7170767", "53628728", "-1", "385", "1350", "0", "3", "0", "0", "highway=service surface=concrete", "barrier=gate", "920", "87969"],
          ["7173044", "53630144", "-1", "43", "1350", "0", "0", "0", "0", "highway=service surface=concrete", "", "925", "88533"],
          ["7170828", "53628766", "-1", "36", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service surface=concrete", "", "929", "88865"],
          ["7171708", "53628318", "0", "78", "1050", "0", "87", "0", "0", "reversedirection=yes highway=path surface=concrete foot=yes", "", "939", "89938"],
          ["7173329", "53629602", "-1", "185", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "965", "92499"],
          ["7176638", "53631896", "1", "339", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1032", "99222"],
          ["7178189", "53633493", "0", "207", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1065", "102509"],
          ["7180178", "53636090", "0", "322", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=concrete route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1119", "107906"],
          ["7181663", "53638120", "0", "248", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1161", "112072"],
          ["7185149", "53640918", "0", "397", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1227", "118741"],
          ["7189031", "53642543", "0", "316", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1280", "124050"],
          ["7191743", "53643673", "0", "220", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1317", "127747"],
          ["7194207", "53644710", "0", "201", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1351", "131124"],
          ["7198675", "53646579", "0", "363", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1413", "137326"],
          ["7202824", "53648306", "0", "336", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1471", "143081"],
          ["7206325", "53649777", "0", "285", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1519", "147885"],
          ["7206624", "53649961", "0", "29", "1350", "0", "1", "0", "0", "highway=service surface=concrete", "barrier=gate foot=yes bicycle=yes", "1524", "148373"],
          ["7218293", "53654881", "0", "976", "1350", "0", "347", "0", "0", "highway=service surface=concrete", "", "1685", "164497"],
          ["7218475", "53654563", "0", "38", "1050", "0", "86", "0", "0", "reversedirection=yes highway=path surface=concrete foot=yes bicycle=yes", "", "1689", "164906"],
          ["7218554", "53654352", "0", "25", "40000", "0", "0", "0", "0", "reversedirection=yes highway=steps surface=concrete foot=yes bicycle=yes", "barrier=gate foot=yes bicycle=yes", "1706", "164906"],
          ["7218559", "53654339", "0", "2", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete", "", "1706", "164931"],
          ["7217929", "53654232", "0", "14", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1708", "165108"],
          ["7219894", "53654566", "0", "106", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1720", "166318"],
          ["7224221", "53655281", "0", "297", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "1766", "170889"],
          ["7225495", "53655500", "0", "88", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=lift_gate access=yes motor_vehicle=no", "1780", "172313"],
          ["7226220", "53655859", "0", "65", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1792", "173489"],
          ["7226387", "53659540", "0", "431", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "1863", "180624"],
          ["7229023", "53661360", "0", "292", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "1912", "185520"],
          ["7233322", "53662466", "0", "312", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "1964", "190756"],
          ["7237506", "53663554", "0", "303", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "2016", "195908"],
          ["7241406", "53664557", "0", "282", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "2061", "200414"],
          ["7245595", "53665358", "0", "295", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "2110", "205314"],
          ["7354876", "53676318", "0", "7499", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "3365", "330832"],
          ["7354972", "53676336", "0", "7", "1000", "0", "0", "0", "0", "highway=service surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3366", "330956"],
          ["7354903", "53676735", "0", "55", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=kissing_gate", "3376", "331915"],
          ["7410202", "53680002", "0", "3745", "1000", "0", "0", "0", "0", "highway=unclassified route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4006", "394972"],
          ["7475109", "53678333", "0", "4327", "1000", "0", "0", "0", "0", "highway=unclassified bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4736", "467914"],
          ["7481183", "53677686", "0", "415", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4811", "475414"],
          ["7486948", "53678569", "1", "502", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes", "", "4895", "483791"],
          ["7485929", "53677710", "0", "119", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes", "", "4915", "485819"],
          ["7491679", "53676449", "0", "421", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "4985", "492823"],
          ["7494655", "53675381", "0", "231", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "5022", "496571"],
          ["7497485", "53674591", "0", "207", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "5060", "500335"],
          ["7498935", "53674190", "0", "107", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes barrier=lift_gate foot=yes bicycle=yes", "5077", "502002"],
          ["7500257", "53673823", "0", "97", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "5093", "503587"],
          ["7502952", "53673076", "1", "197", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "5130", "507302"],
          ["7505662", "53672324", "0", "198", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "5162", "510574"],
          ["7508686", "53671485", "0", "221", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "5200", "514280"],
          ["7511399", "53670733", "0", "198", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=passing_place", "5232", "517509"],
          ["7514473", "53669879", "0", "226", "1000", "0", "0", "0", "0", "highway=service access=yes foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "", "5268", "521121"],
          ["7533459", "53671764", "0", "1312", "1000", "0", "0", "0", "0", "highway=service access=permissive foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "", "5488", "543129"],
          ["7559374", "53673085", "0", "1785", "1000", "0", "0", "0", "0", "highway=service route_bicycle_icn=yes route_bicycle_ncn=yes", "", "5790", "573347"],
          ["7559433", "53673031", "0", "8", "1000", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes bicycle=yes oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes", "", "5791", "573474"],
          ["7563880", "53673778", "0", "323", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "5842", "578515"],
          ["7569035", "53674648", "-1", "381", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "5903", "584675"],
          ["7570079", "53674725", "0", "70", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes", "", "5917", "586020"],
          ["7572257", "53674765", "0", "147", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "5943", "588680"],
          ["7575114", "53674188", "1", "208", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "5986", "592952"],
          ["7575708", "53674179", "1", "41", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes foot=designated bicycle=designated", "5994", "593763"],
          ["7575695", "53674238", "1", "7", "1050", "0", "96", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated", "foot=designated bicycle=designated", "5996", "593888"],
          ["7575692", "53674260", "1", "3", "1000", "0", "0", "0", "0", "highway=living_street surface=paving_stones route_bicycle_rcn=yes", "", "5996", "593941"],
          ["7575515", "53674347", "1", "16", "5050", "0", "27", "0", "0", "highway=footway", "", "6008", "594083"],
          ["7575692", "53674260", "1", "17", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway", "", "6019", "594083"],
          ["7575265", "53675062", "0", "101", "1000", "0", "0", "0", "0", "highway=living_street surface=paving_stones route_bicycle_rcn=yes", "", "6029", "595078"],
          ["7575211", "53675113", "0", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=lift_gate access=no foot=yes bicycle=yes", "6029", "595157"],
          ["7575355", "53676980", "1", "279", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified route_bicycle_rcn=yes", "", "6077", "599919"],
          ["7575469", "53677003", "1", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_rcn=yes", "", "6079", "600100"],
          ["7578445", "53677577", "0", "213", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt cycleway=no route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "6114", "603629"],
          ["7578479", "53677631", "0", "7", "1000", "0", "0", "0", "0", "highway=service access=designated foot=yes bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "6115", "603746"],
          ["7581881", "53678136", "0", "241", "1000", "0", "0", "0", "0", "highway=service access=designated foot=yes bicycle=yes route_bicycle_rcn=yes", "", "6156", "607819"],
          ["7595671", "53682381", "0", "1048", "1000", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "6329", "625098"],
          ["7607470", "53686359", "-8192", "903", "1000", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "6470", "639194"],
          ["7630817", "53688513", "-8192", "1602", "1000", "0", "0", "0", "0", "highway=service surface=asphalt foot=yes bicycle=yes route_bicycle_rcn=yes", "", "6739", "666102"],
          ["7647049", "53691780", "-8192", "1169", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "6935", "685742"],
          ["7679308", "53698637", "-8192", "2321", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "7315", "723697"],
          ["7695690", "53701026", "0", "1122", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "", "7503", "742548"],
          ["7699902", "53700727", "0", "287", "1000", "0", "0", "0", "0", "highway=service surface=concrete access=designated foot=yes bicycle=yes route_bicycle_rcn=yes", "", "7552", "747369"],
          ["7699924", "53700548", "0", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=asphalt foot=yes bicycle=yes route_bicycle_rcn=yes", "", "7555", "747722"],
          ["7701064", "53700483", "1", "76", "1000", "0", "0", "0", "0", "highway=residential surface=sett cycleway=opposite oneway=yes route_bicycle_rcn=yes", "", "7568", "749061"],
          ["7701575", "53700432", "1", "35", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=sett route_bicycle_rcn=yes", "", "7575", "749688"],
          ["7701452", "53699919", "1", "60", "1000", "0", "0", "0", "0", "reversedirection=yes highway=living_street surface=sett route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=mini_roundabout", "7586", "750829"],
          ["7704101", "53699335", "1", "194", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt foot=yes bicycle=yes cycleway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7619", "754137"],
          ["7704847", "53699385", "1", "52", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt foot=yes bicycle=yes cycleway=track route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop wheelchair=limited", "7628", "755045"],
          ["7705661", "53699498", "2", "56", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt foot=yes bicycle=yes cycleway=track route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7639", "756135"],
          ["7706507", "53699552", "1", "60", "1000", "0", "0", "0", "0", "highway=footway surface=asphalt bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "7649", "757083"],
          ["7711553", "53699114", "0", "346", "1000", "0", "0", "0", "0", "highway=footway surface=asphalt bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "7702", "762394"],
          ["7715502", "53698777", "0", "267", "1000", "0", "0", "0", "0", "highway=footway surface=asphalt bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "7748", "767000"],
          ["7715526", "53698836", "0", "7", "1150", "0", "87", "0", "0", "reversedirection=yes highway=residential", "", "7749", "767120"],
          ["7719453", "53698213", "0", "273", "1450", "0", "87", "0", "0", "highway=tertiary surface=asphalt", "highway=crossing bicycle=yes crossing=unmarked", "7788", "771054"],
          ["7720376", "53697837", "0", "76", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt", "", "7799", "772123"],
          ["7720507", "53697928", "0", "15", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7801", "772344"],
          ["7720681", "53698077", "0", "22", "1000", "0", "0", "0", "0", "highway=service surface=concrete route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7805", "772686"],
          ["7720708", "53698089", "0", "3", "1000", "0", "0", "0", "0", "highway=service surface=concrete route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "7805", "772733"],
          ["7720735", "53698101", "0", "3", "1000", "0", "0", "0", "0", "highway=service surface=concrete route_bicycle_rcn=yes", "", "7806", "772780"],
          ["7727570", "53697874", "0", "464", "1000", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "7888", "780970"],
          ["7732136", "53698177", "1", "304", "1000", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "7942", "786398"],
          ["7736602", "53698479", "0", "298", "1000", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "7987", "790909"],
          ["7737354", "53698530", "0", "51", "1000", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "7995", "791721"],
          ["7737391", "53698532", "0", "3", "1350", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no", "barrier=gate", "7996", "791769"],
          ["7737425", "53698534", "0", "3", "1350", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no", "", "7996", "791817"],
          ["7765416", "53700616", "0", "1866", "1000", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate access=private", "8310", "823258"],
          ["7775147", "53702320", "1", "674", "1000", "0", "0", "0", "0", "highway=service surface=concrete bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8427", "834888"],
          ["7776416", "53702657", "1", "94", "1000", "0", "0", "0", "0", "highway=service surface=paving_stones bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "8443", "836563"],
          ["7779290", "53702673", "0", "194", "1000", "0", "0", "0", "0", "highway=service surface=paving_stones bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8472", "839391"],
          ["7779325", "53702672", "0", "3", "1000", "0", "0", "0", "0", "highway=service surface=paving_stones bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes barrier=gate", "8472", "839440"],
          ["7779361", "53702671", "0", "3", "1000", "0", "0", "0", "0", "highway=service surface=asphalt bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes", "", "8473", "839489"],
          ["7780492", "53702704", "0", "77", "1000", "0", "0", "0", "0", "highway=service surface=asphalt bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "8485", "840762"],
          ["7782965", "53702825", "0", "164", "1000", "0", "0", "0", "0", "highway=service surface=asphalt bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "8513", "843500"],
          ["7786331", "53702989", "0", "223", "1000", "0", "0", "0", "0", "highway=service surface=asphalt bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "8550", "847245"],
          ["7789682", "53703035", "0", "225", "1000", "0", "0", "0", "0", "highway=service surface=asphalt bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=passing_place", "8587", "850928"],
          ["7802061", "53703687", "0", "825", "1000", "0", "0", "0", "0", "highway=service surface=asphalt bicycle=yes vehicle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "8725", "864691"],
          ["7804621", "53705863", "0", "303", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8777", "869913"],
          ["7804928", "53706309", "0", "54", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt", "", "8785", "870768"],
          ["7805091", "53706629", "0", "40", "1150", "0", "5", "0", "0", "highway=residential surface=asphalt oneway=yes", "", "8792", "871400"],
          ["7805174", "53706719", "0", "12", "1150", "0", "0", "0", "0", "highway=residential surface=asphalt junction=roundabout", "", "8794", "871586"],
          ["7805549", "53706932", "0", "37", "1150", "0", "18", "0", "0", "highway=residential surface=asphalt oneway=yes", "", "8800", "872198"],
          ["7806821", "53707873", "0", "136", "1150", "0", "1", "0", "0", "reversedirection=yes highway=residential surface=paving_stones", "", "8824", "874620"],
          ["7807507", "53707975", "0", "51", "1150", "0", "32", "0", "0", "highway=residential surface=asphalt", "", "8830", "875266"],
          ["7807449", "53707802", "0", "20", "1150", "0", "40", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "highway=crossing crossing=unmarked", "8832", "875467"],
          ["7807346", "53707568", "0", "27", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "8835", "875762"],
          ["7808080", "53706753", "-1", "143", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "8855", "877699"],
          ["7810088", "53706183", "0", "153", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8881", "880299"],
          ["7810216", "53706245", "0", "11", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "8883", "880521"],
          ["7809612", "53698162", "0", "913", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_rcn=yes", "", "9032", "895407"],
          ["7809530", "53698174", "0", "6", "5050", "0", "86", "0", "0", "highway=path", "", "9036", "895407"],
          ["7809277", "53698212", "0", "18", "1150", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "9038", "895616"],
          ["7808914", "53698238", "0", "25", "1550", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=wood", "", "9041", "895941"],
          ["7805153", "53698796", "0", "285", "1150", "0", "243", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "9080", "899853"]
        ],
        "times": [0, 0.745, 2.209, 10.629, 19.038, 29.052, 46.125, 68.902, 94.827, 113.399, 114.487, 115.21, 120.599, 123.965, 126.974, 128.505, 130.205, 133.994, 136.314, 137.91, 139.674, 141.78, 150.706, 152.304, 159.091, 168.419, 169.619, 179.339, 182.393, 183.241, 193.061, 200.876, 208.194, 210.983, 215.598, 219.24, 221.065, 222.227, 223.557, 248.101, 251.039, 252.932, 254.135, 254.821, 258.586, 259.781, 263.869, 268.793, 273.196, 279.617, 282.992, 307.58, 310.269, 347.235, 348.946, 349.747, 350.468, 351.639, 353.423, 355.542, 357.518, 359.727, 361.183, 362.688, 366.775, 373.505, 382.613, 401.144, 409.014, 421.204, 427.544, 431.454, 450.347, 461.15, 474.117, 490.247, 513.849, 534.877, 551.821, 564.804, 575.575, 593.738, 597.434, 603.315, 613.075, 619.859, 642.319, 643.85, 647.925, 650.795, 651.918, 655.421, 658.5, 665.939, 673.41, 680.82, 686.967, 697.28, 699.79, 701.251, 703.487, 704.384, 705.349, 708.24, 712.025, 714.021, 714.484, 715.476, 717.462, 721.692, 724.488, 725.792, 727.636, 729.811, 736.089, 743.286, 749.128, 763.832, 793.832, 795.784, 799.593, 807.168, 816.576, 818.365, 819.571, 820.33, 821.092, 833.81, 840.125, 842.935, 845.515, 851.405, 863.316, 863.856, 864.406, 867.51, 870.9, 913.342, 919.813, 920.075, 920.339, 920.968, 925.714, 929.04, 932.233, 935.601, 939.763, 940.075, 947.171, 948.9, 952.721, 965.367, 981.027, 998.813, 1024.119, 1032.58, 1034.222, 1050.682, 1065.448, 1068.283, 1077.979, 1079.485, 1080.49, 1087.025, 1088.198, 1103.298, 1119.418, 1143.942, 1156.71, 1161.078, 1185.606, 1194.51, 1206.439, 1227.775, 1246.088, 1264.736, 1275.32, 1280.864, 1286.912, 1317.825, 1344.202, 1351.594, 1362.682, 1391.411, 1413.619, 1422.239, 1471.164, 1515.678, 1517.528, 1519.21, 1524.086, 1539.55, 1547.616, 1559.377, 1561.898, 1625.908, 1648.421, 1654.637, 1655.309, 1660.181, 1665.557, 1671.941, 1677.513, 1678.282, 1683.115, 1685.323, 1689.411, 1706.4, 1706.648, 1708.418, 1709.738, 1720.516, 1766.23, 1780.467, 1781.78, 1785.693, 1792.231, 1793.402, 1799.097, 1802.785, 1806.475, 1810.576, 1813.227, 1863.579, 1866.419, 1869.931, 1874.283, 1878.303, 1883.165, 1899.778, 1906.662, 1912.54, 1915.703, 1941.931, 1964.894, 2002.723, 2016.417, 2030.44, 2061.471, 2065.373, 2096.431, 2104.87, 2108.662, 2110.471, 2116.547, 2141.702, 2170.785, 2200.975, 2201.815, 2264.254, 2286.074, 2300.863, 2329.729, 2361.509, 2393.127, 2448.566, 2476.479, 2506.589, 2530.513, 2541.073, 2542.555, 2544.039, 2555.918, 2583.206, 2599.46, 2614.397, 2627.784, 2656.446, 2678.024, 2697.353, 2700.359, 2702.654, 2740.822, 2749.811, 2776.6, 2794.854, 2799.753, 2801.797, 2816.538, 2874.449, 2907.176, 2942.677, 2960.477, 2981.403, 3025.015, 3050.184, 3057.67, 3062.327, 3065.25, 3070.281, 3096.699, 3109.734, 3129.049, 3184.584, 3187.993, 3192.581, 3194.955, 3251.043, 3262.75, 3274.735, 3279.347, 3329.885, 3333.161, 3334.423, 3337.641, 3339.303, 3341.299, 3344.112, 3347.137, 3349.753, 3351.009, 3353.993, 3355.25, 3359.654, 3360.58, 3361.2, 3362.36, 3364.187, 3365.606, 3366.843, 3368.603, 3369.655, 3370.705, 3372.274, 3373.665, 3375.052, 3376.436, 3380.286, 3384.784, 3386.486, 3388.714, 3391.034, 3393.061, 3394.819, 3396.755, 3399.11, 3401.276, 3472.833, 3477.033, 3484.543, 3615.006, 3654.637, 3675.675, 3796.103, 3827.772, 3853.057, 3886.647, 3902.18, 3979.379, 3990.801, 4006.978, 4061.337, 4121.906, 4152.015, 4179.51, 4213.972, 4274.491, 4287.435, 4294.762, 4305.047, 4335.244, 4366.369, 4425.153, 4454.449, 4518.078, 4554.377, 4562.841, 4576.094, 4604.752, 4631.877, 4690.181, 4729.999, 4736.383, 4751.655, 4777.271, 4779.854, 4783.111, 4805.175, 4807.958, 4811.368, 4829.931, 4852.096, 4860.506, 4866.341, 4874.378, 4882.108, 4891.238, 4895.135, 4900.068, 4915.411, 4920.001, 4934.222, 4936.621, 4939.505, 4941.457, 4956.419, 4962.128, 4964.837, 4969.293, 4985.45, 5010.293, 5022.93, 5060.567, 5075.472, 5077.236, 5093.087, 5130.232, 5162.952, 5200.01, 5232.297, 5252.549, 5268.417, 5278.796, 5286.657, 5393.711, 5401.952, 5409.065, 5418.812, 5425.125, 5477.463, 5488.499, 5490.844, 5495.872, 5502.916, 5626.88, 5673.08, 5682.32, 5691.056, 5697.608, 5701.304, 5707.352, 5712.168, 5718.131, 5748.329, 5752.845, 5755.858, 5771.977, 5787.556, 5789.409, 5790.674, 5791.308, 5791.943, 5802.104, 5808.486, 5815.982, 5830.722, 5833.058, 5835.418, 5838.721, 5840.094, 5841.105, 5842.348, 5843.127, 5844.463, 5845.132, 5846.301, 5847.907, 5850.18, 5854.268, 5861.861, 5868.739, 5873.609, 5878.326, 5887.401, 5903.943, 5908.63, 5917.393, 5926.638, 5930.077, 5941.003, 5941.502, 5943.985, 5945.22, 5947.502, 5948.551, 5951.336, 5954.99, 5958.444, 5968.735, 5977.895, 5981.659, 5983.585, 5986.708, 5987.524, 5987.93, 5990.135, 5993.658, 5994.812, 5996.059, 5996.592, 6008.01, 6008.66, 6019.217, 6023.497, 6023.805, 6024.645, 6028.073, 6029.167, 6029.955, 6032.162, 6035.427, 6057.912, 6059.902, 6066.042, 6073.22, 6077.571, 6078.58, 6079.381, 6081.358, 6102.787, 6104.959, 6109.142, 6111.318, 6114.668, 6115.841, 6116.343, 6117.852, 6119.584, 6141.535, 6146.327, 6150.606, 6156.571, 6159.23, 6180.031, 6186.962, 6191.275, 6195.767, 6201.438, 6212.143, 6215.326, 6219.851, 6223.876, 6226.56, 6240.828, 6246.873, 6255.271, 6285.171, 6309.531, 6316.755, 6324.82, 6329.356, 6369.845, 6379.085, 6385.134, 6434.584, 6439.586, 6470.319, 6491.599, 6524.186, 6533.425, 6540.817, 6544.514, 6552.914, 6559.13, 6566.522, 6572.234, 6609.027, 6614.907, 6618.099, 6628.347, 6631.035, 6645.147, 6652.708, 6658.588, 6677.908, 6682.948, 6715.205, 6727.637, 6739.397, 6744.102, 6785.599, 6792.991, 6801.223, 6810.127, 6830.12, 6834.656, 6848.768, 6862.544, 6869.264, 6874.304, 6885.729, 6894.801, 6912.105, 6921.177, 6935.794, 6936.634, 6987.203, 7002.827, 7014.587, 7022.315, 7027.524, 7046.844, 7055.412, 7062.132, 7079.941, 7096.405, 7108.837, 7117.214, 7147.461, 7156.736, 7163.73, 7172.084, 7183.138, 7199.412, 7211.668, 7229.975, 7246.103, 7293.647, 7315.319, 7316.496, 7337.496, 7359.168, 7376.473, 7385.545, 7395.289, 7401.169, 7420.322, 7443.002, 7452.411, 7469.883, 7484.163, 7503.82, 7508.524, 7515.58, 7525.156, 7550.188, 7552.037, 7552.708, 7555.565, 7568.955, 7571.377, 7575.227, 7580.013, 7582.816, 7584.478, 7586.628, 7589.902, 7591.304, 7593.081, 7595.777, 7599.002, 7602.853, 7608.778, 7612.56, 7615.17, 7616.879, 7618.288, 7619.705, 7621.288, 7623.832, 7627.257, 7628.785, 7639.688, 7641.367, 7647.389, 7649.167, 7652.643, 7654.332, 7656.192, 7658.227, 7660.437, 7678.082, 7680.593, 7684.29, 7685.53, 7698.998, 7702.279, 7711.227, 7715.371, 7724.576, 7748.335, 7749.537, 7755.677, 7765.615, 7775.483, 7780.222, 7784.263, 7788.871, 7792.466, 7795.128, 7799.553, 7800.841, 7801.764, 7803.312, 7804.248, 7805.187, 7805.657, 7806.129, 7807.643, 7809.83, 7811.175, 7832.99, 7838.144, 7843.76, 7848.674, 7857.813, 7859.868, 7888.025, 7942.305, 7987.413, 7995.527, 7996.011, 7996.495, 8150.911, 8230.74, 8310.401, 8310.896, 8311.389, 8330.139, 8333.036, 8343.218, 8425.191, 8427.193, 8439.158, 8443.466, 8443.948, 8444.431, 8447.749, 8449.521, 8453.141, 8472.205, 8472.696, 8473.188, 8474.174, 8476.312, 8485.913, 8513.3, 8550.747, 8556.795, 8559.818, 8563.347, 8566.539, 8587.571, 8618.374, 8650.644, 8653.856, 8657.403, 8660.581, 8719.412, 8723.545, 8725.202, 8727.027, 8741.661, 8756.494, 8759.883, 8763.436, 8766.297, 8771.941, 8777.417, 8785.969, 8787.256, 8788.709, 8789.843, 8790.91, 8792.292, 8793.219, 8794.151, 8794.931, 8797.603, 8799.105, 8800.276, 8807.807, 8824.49, 8828.019, 8829.483, 8830.253, 8830.549, 8830.947, 8831.934, 8832.958, 8835.912, 8837.669, 8838.151, 8839.008, 8841.133, 8842.575, 8843.891, 8845.223, 8846.118, 8846.868, 8848.229, 8849.757, 8851.354, 8855.017, 8855.271, 8857.281, 8857.524, 8865.677, 8869.419, 8874.023, 8878.591, 8881.272, 8883.488, 8885.858, 8890.771, 8895.092, 8902.586, 8906.72, 9003.749, 9006.314, 9011.289, 9015.353, 9022.1, 9023.476, 9027.033, 9029.534, 9030.307, 9032.344, 9036.34, 9038.436, 9041.682, 9042.488, 9043.44, 9044.406, 9045.807, 9046.373, 9047.229, 9049.704, 9051.256, 9052.747, 9053.991, 9055.187, 9056.132, 9059.608, 9060.321, 9061.185, 9080.792]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [7.138688, 53.605066],
          [7.138772, 53.605106],
          [7.138937, 53.605198],
          [7.139715, 53.605672, 0.0],
          [7.140352, 53.606079, 0.0],
          [7.140967, 53.606520, 0.25],
          [7.141972, 53.607257, 0.25],
          [7.143335, 53.608235, 0.0],
          [7.144800, 53.609312, 0.0],
          [7.145730, 53.609977, 0.75],
          [7.145665, 53.610010, 0.75],
          [7.145695, 53.610031, 0.75],
          [7.146015, 53.610237, 0.5],
          [7.146250, 53.610339, 0.5],
          [7.146505, 53.610402, 0.25],
          [7.146630, 53.610426, 0.5],
          [7.146764, 53.610441, 0.5],
          [7.146748, 53.610629, 0.75],
          [7.146782, 53.610743, 0.75],
          [7.146826, 53.610814, 0.75],
          [7.146889, 53.610888, 0.75],
          [7.146977, 53.610972, 0.75],
          [7.147512, 53.611364, 0.25],
          [7.147591, 53.611432, 0.25],
          [7.147944, 53.611737, 0.25],
          [7.148339, 53.612160, 0.5],
          [7.148384, 53.612208, 0.5],
          [7.148825, 53.612645, 0.5],
          [7.148961, 53.612783, 0.5],
          [7.148998, 53.612822, 0.5],
          [7.149463, 53.613318, 0.0],
          [7.149839, 53.613694, 0.0],
          [7.150189, 53.614039, 0.0],
          [7.150310, 53.614171, 0.0],
          [7.150516, 53.614389, 0.0],
          [7.150667, 53.614561, 0.0],
          [7.150767, 53.614629, 0.0],
          [7.150849, 53.614653, 0.0],
          [7.150838, 53.614722, 0.0],
          [7.151706, 53.615663, 1.0],
          [7.151907, 53.615755, 1.0],
          [7.152025, 53.615814, 1.0],
          [7.152109, 53.615848, 1.0],
          [7.152075, 53.615875, 1.0],
          [7.151908, 53.616038, 1.0],
          [7.151857, 53.616088, 1.0],
          [7.152022, 53.616278, 1.0],
          [7.152231, 53.616504, 1.0],
          [7.152412, 53.616708, 1.0],
          [7.152748, 53.616975, 1.0],
          [7.152918, 53.617113, 1.0],
          [7.153970, 53.618262, 1.0],
          [7.154077, 53.618383, 1.0],
          [7.155688, 53.620109, 1.0],
          [7.155815, 53.620246],
          [7.155914, 53.620213],
          [7.155985, 53.620171],
          [7.156135, 53.620200],
          [7.156362, 53.620218],
          [7.156624, 53.620197],
          [7.156847, 53.620155, 1.5],
          [7.157090, 53.620095, 1.25],
          [7.157227, 53.620037, 1.0],
          [7.157339, 53.619961, 1.0],
          [7.157613, 53.619743, 1.0],
          [7.158018, 53.619442, 1.5],
          [7.158465, 53.619074, 2.0],
          [7.159629, 53.618220, 1.25],
          [7.160051, 53.617911, 1.5],
          [7.160660, 53.617466, 2.0],
          [7.161004, 53.617229, 2.0],
          [7.161216, 53.617078, 2.0],
          [7.162253, 53.616332, 2.0],
          [7.162863, 53.615894, 2.0],
          [7.163606, 53.615365, 2.0],
          [7.164554, 53.614670, 1.75],
          [7.166129, 53.613532, 0.75],
          [7.164554, 53.614670, 1.75],
          [7.163606, 53.615365, 2.0],
          [7.162863, 53.615894, 2.0],
          [7.162253, 53.616332, 2.0],
          [7.161216, 53.617078, 2.0],
          [7.161004, 53.617229, 2.0],
          [7.160660, 53.617466, 2.0],
          [7.160051, 53.617911, 1.5],
          [7.159629, 53.618220, 1.25],
          [7.158465, 53.619074, 2.0],
          [7.158562, 53.619123, 2.0],
          [7.158364, 53.619293, 2.0],
          [7.158225, 53.619427, 1.75],
          [7.158178, 53.619480, 1.75],
          [7.158017, 53.619657, 1.5],
          [7.157885, 53.619827, 1.25],
          [7.157708, 53.620207, 1.75],
          [7.157679, 53.620517, 2.75],
          [7.157721, 53.620792, 3.5],
          [7.157841, 53.621051, 3.25],
          [7.158188, 53.621545, 2.75],
          [7.158335, 53.621755, 2.75],
          [7.158409, 53.621869, 2.75],
          [7.158534, 53.622042, 2.5],
          [7.158640, 53.622025, 2.5],
          [7.158757, 53.622026, 2.75],
          [7.159031, 53.622144, 2.75],
          [7.159353, 53.622291, 3.0],
          [7.159511, 53.622356, 3.25],
          [7.159540, 53.622370, 3.25],
          [7.159603, 53.622403, 3.5],
          [7.159728, 53.622469, 3.5],
          [7.159992, 53.622610, 3.75],
          [7.160168, 53.622708, 3.75],
          [7.160267, 53.622737, 3.5],
          [7.160427, 53.622765, 3.25],
          [7.160603, 53.622820, 3.25],
          [7.161083, 53.623119, 2.5],
          [7.161680, 53.623489, 1.5],
          [7.162216, 53.623744, 1.0],
          [7.163473, 53.624384, 0.75],
          [7.164929, 53.625059, 2.75],
          [7.165090, 53.625049, 2.75],
          [7.165376, 53.625162, 2.5],
          [7.165888, 53.625464, 2.25],
          [7.166476, 53.625881, 2.0],
          [7.166556, 53.625973, 1.75],
          [7.166537, 53.626039, 1.75],
          [7.166491, 53.626071, 1.75],
          [7.166471, 53.626105, 1.75],
          [7.166447, 53.626260, 1.75],
          [7.166406, 53.626328, 1.5],
          [7.166373, 53.626351, 1.5],
          [7.166406, 53.626328, 1.5],
          [7.166447, 53.626260, 1.75],
          [7.166471, 53.626105, 1.75],
          [7.166491, 53.626071, 1.75],
          [7.166537, 53.626039, 1.75],
          [7.166723, 53.626270, 1.25],
          [7.167021, 53.626468, 1.0],
          [7.170211, 53.628383, 0.0],
          [7.170755, 53.628721, -1.25],
          [7.170767, 53.628728, -1.25],
          [7.170778, 53.628735, -1.25],
          [7.170828, 53.628766, -1.5],
          [7.171195, 53.628994, -1.5],
          [7.170828, 53.628766, -1.5],
          [7.171110, 53.628592, -0.75],
          [7.171370, 53.628448, -0.25],
          [7.171708, 53.628318, 0.0],
          [7.171720, 53.628326, 0.0],
          [7.172036, 53.628766, -1.0],
          [7.172137, 53.628856, -1.25],
          [7.172414, 53.629050, -1.5],
          [7.173329, 53.629602, -1.5],
          [7.174401, 53.630248, -1.5],
          [7.175473, 53.630961, -1.5],
          [7.176317, 53.631609, 1.25],
          [7.176638, 53.631896, 1.25],
          [7.176699, 53.631955, 1.25],
          [7.177574, 53.632785, 0.0],
          [7.178189, 53.633493, 0.0],
          [7.178305, 53.633626, 0.0],
          [7.178671, 53.634098, 0.0],
          [7.178718, 53.634172, 0.0],
          [7.178746, 53.634215, 0.0],
          [7.178912, 53.634550, 0.0],
          [7.178939, 53.634603, 0.0],
          [7.179563, 53.635312, 0.0],
          [7.180178, 53.636090, 0.0],
          [7.181077, 53.637279, 0.0],
          [7.181521, 53.637903, 0.0],
          [7.181663, 53.638120, 0.0],
          [7.182565, 53.639312, 0.0],
          [7.182956, 53.639727, 0.0],
          [7.183669, 53.640202, 0.0],
          [7.185149, 53.640918, 0.0],
          [7.186502, 53.641475, 0.0],
          [7.187863, 53.642045, 0.0],
          [7.188632, 53.642367, 0.0],
          [7.189031, 53.642543, 0.0],
          [7.189473, 53.642728, 0.0],
          [7.191743, 53.643673, 0.0],
          [7.193680, 53.644481, 0.0],
          [7.194207, 53.644710, 0.0],
          [7.195011, 53.645052, 0.0],
          [7.197111, 53.645946, 0.0],
          [7.198675, 53.646579, 0.25],
          [7.199306, 53.646835, 0.25],
          [7.202824, 53.648306, 0.5],
          [7.206072, 53.649676, 0.5],
          [7.206205, 53.649726, 0.5],
          [7.206325, 53.649777, 0.5],
          [7.206624, 53.649961, 0.5],
          [7.207614, 53.650537, 0.5],
          [7.208110, 53.650841, 0.5],
          [7.208743, 53.651343, 0.5],
          [7.208835, 53.651463, 0.5],
          [7.213525, 53.653447, 0.5],
          [7.215172, 53.654133, 0.5],
          [7.215644, 53.654297, 0.5],
          [7.215675, 53.654268, 0.5],
          [7.216062, 53.654375, 0.5],
          [7.216496, 53.654485, 0.5],
          [7.217031, 53.654607, 0.5],
          [7.217553, 53.654707, 0.0],
          [7.217536, 53.654748, 0.0],
          [7.217973, 53.654824, 0.0],
          [7.218293, 53.654881, 0.0],
          [7.218475, 53.654563, 0.0],
          [7.218554, 53.654352, 0.0],
          [7.218559, 53.654339, 0.0],
          [7.218359, 53.654305, 0.0],
          [7.218559, 53.654339, 0.0],
          [7.219894, 53.654566, 0.25],
          [7.224221, 53.655281, 0.0],
          [7.225495, 53.655500, 0.0],
          [7.225606, 53.655521, 0.0],
          [7.225842, 53.655635, 0.5],
          [7.226220, 53.655859, 0.5],
          [7.226282, 53.655902, 0.25],
          [7.226607, 53.656128, 0.25],
          [7.226785, 53.656290, 0.25],
          [7.226902, 53.656473, 0.25],
          [7.226974, 53.656671, 0.5],
          [7.226980, 53.656813, 0.25],
          [7.226387, 53.659540, 0.0],
          [7.226356, 53.659686, 0.0],
          [7.226334, 53.659871, 0.0],
          [7.226417, 53.660091, 0.0],
          [7.226593, 53.660271, 0.0],
          [7.226905, 53.660444, 0.0],
          [7.228052, 53.661012, 0.0],
          [7.228555, 53.661217, 0.0],
          [7.229023, 53.661360, 0.0],
          [7.229295, 53.661422, -0.25],
          [7.231513, 53.662002, -0.25],
          [7.233322, 53.662466, 0.0],
          [7.236333, 53.663244, 0.25],
          [7.237506, 53.663554, 0.0],
          [7.238686, 53.663849, 0.0],
          [7.241406, 53.664557, -0.5],
          [7.241749, 53.664634, -0.75],
          [7.244209, 53.665114, 0.0],
          [7.244991, 53.665259, -0.5],
          [7.245332, 53.665315, -0.5],
          [7.245595, 53.665358, -0.5],
          [7.246361, 53.665459, 0.0],
          [7.248945, 53.665779, 0.0],
          [7.251528, 53.666137, 0.0],
          [7.254170, 53.666501, 0.0],
          [7.254235, 53.666510, 0.0],
          [7.259628, 53.667230, 0.25],
          [7.261341, 53.667450, 0.75],
          [7.262631, 53.667556, 0.75],
          [7.265445, 53.667751, 0.0],
          [7.268214, 53.667958, 0.25],
          [7.270833, 53.668140, 0.75],
          [7.276100, 53.668513, -0.25],
          [7.278722, 53.668666, -0.5],
          [7.281333, 53.668808, -0.25],
          [7.283276, 53.668908, 0.25],
          [7.284150, 53.669011, 0.5],
          [7.284281, 53.669002, 0.25],
          [7.284402, 53.669027, 0.25],
          [7.285531, 53.668985, 0.0],
          [7.288028, 53.669029, 0.0],
          [7.289488, 53.669064, 0.0],
          [7.290825, 53.669092, 0.0],
          [7.291778, 53.669222, 1.0],
          [7.294359, 53.669590, 0.25],
          [7.296247, 53.669853, 0.25],
          [7.297843, 53.670086, 0.5],
          [7.298124, 53.670142, 0.0],
          [7.298327, 53.670193, 0.0],
          [7.301512, 53.671230, -0.25],
          [7.302276, 53.671390, -0.25],
          [7.304191, 53.671725, 0.75],
          [7.305802, 53.672011, 0.5],
          [7.306245, 53.672098, 0.25],
          [7.306414, 53.672122, 0.5],
          [7.307684, 53.672323, 0.5],
          [7.312851, 53.672984, 0.25],
          [7.315540, 53.673333, 0.75],
          [7.318903, 53.673767, 0.0],
          [7.320226, 53.673911, 1.0],
          [7.322022, 53.674106, 0.75],
          [7.326124, 53.674530, 0.0],
          [7.328297, 53.674759, 0.25],
          [7.328910, 53.674847, 0.5],
          [7.329265, 53.674913, 0.75],
          [7.329489, 53.674942, 0.75],
          [7.329894, 53.674995, 0.75],
          [7.332278, 53.675388, 0.25],
          [7.333406, 53.675563, 0.25],
          [7.335163, 53.675848, 0.0],
          [7.339709, 53.676569, 0.75],
          [7.339993, 53.676621, 0.75],
          [7.340394, 53.676654, 0.75],
          [7.340605, 53.676662, 0.75],
          [7.345879, 53.676824, 0.0],
          [7.346950, 53.676846, 0.0],
          [7.348032, 53.676893, 0.0],
          [7.348412, 53.676924, 0.25],
          [7.352735, 53.677394, 0.5],
          [7.353003, 53.677416, 0.75],
          [7.353108, 53.677420, 0.75],
          [7.353376, 53.677399, 0.75],
          [7.353505, 53.677359, 0.5],
          [7.353641, 53.677299, 0.5],
          [7.353843, 53.677180, 0.0],
          [7.354026, 53.677044, 0.0],
          [7.354148, 53.676907, -0.25],
          [7.354183, 53.676830, -0.5],
          [7.354267, 53.676648, -0.75],
          [7.354321, 53.676580, -0.75],
          [7.354424, 53.676332, -0.5],
          [7.354473, 53.676289, -0.5],
          [7.354523, 53.676279, -0.5],
          [7.354620, 53.676282, -0.25],
          [7.354776, 53.676297, -0.25],
          [7.354876, 53.676318, 0.0],
          [7.354972, 53.676336, 0.0],
          [7.355077, 53.676388, 0.0],
          [7.355106, 53.676438, 0.0],
          [7.355099, 53.676491, 0.0],
          [7.355036, 53.676556, 0.0],
          [7.354967, 53.676604, 0.0],
          [7.354923, 53.676669, 0.0],
          [7.354903, 53.676735, 0.0],
          [7.354897, 53.676915, 0.25],
          [7.354904, 53.677106, 0.75],
          [7.354927, 53.677171, 1.0],
          [7.354982, 53.677251, 1.25],
          [7.355053, 53.677322, 1.5],
          [7.355135, 53.677380, 1.5],
          [7.355225, 53.677420, 1.5],
          [7.355338, 53.677459, 1.5],
          [7.355507, 53.677490, 1.25],
          [7.355685, 53.677505, 1.0],
          [7.362126, 53.677532, 0.75],
          [7.362492, 53.677539, 0.75],
          [7.363276, 53.677570, 0.0],
          [7.374805, 53.678417, 0.75],
          [7.378673, 53.678690, -0.25],
          [7.380195, 53.678749, 0.75],
          [7.391056, 53.679084, 0.5],
          [7.394069, 53.679207, 0.0],
          [7.396361, 53.679306, 0.0],
          [7.399274, 53.679459, 0.25],
          [7.400656, 53.679521, 0.25],
          [7.407725, 53.679872, -0.25],
          [7.408904, 53.679971, -1.0],
          [7.410202, 53.680002, 0.0],
          [7.414972, 53.680221, 0.0],
          [7.420389, 53.680500, 0.0],
          [7.423167, 53.680610, -0.25],
          [7.425889, 53.680667, -1.0],
          [7.428611, 53.680694, 0.0],
          [7.434019, 53.680797, 0.0],
          [7.435004, 53.680810, 0.75],
          [7.435708, 53.680819, 0.0],
          [7.436806, 53.680835, -0.75],
          [7.439500, 53.680889, -0.25],
          [7.442194, 53.680778, 0.0],
          [7.447528, 53.680446, -0.25],
          [7.450250, 53.680305, -0.5],
          [7.455778, 53.679973, 0.0],
          [7.458987, 53.679803, 0.0],
          [7.459771, 53.679759, -0.25],
          [7.460972, 53.679668, -0.25],
          [7.463441, 53.679449, 0.0],
          [7.465833, 53.679195, 0.0],
          [7.471014, 53.678714, 0.0],
          [7.474544, 53.678386, 0.0],
          [7.475109, 53.678333, 0.0],
          [7.476767, 53.678179, -1.0],
          [7.478715, 53.678132, 0.0],
          [7.478930, 53.678123, 0.0],
          [7.479200, 53.678088, 0.0],
          [7.480695, 53.677863, 1.0],
          [7.480934, 53.677810, 0.75],
          [7.481183, 53.677686, 0.5],
          [7.482243, 53.678448, 0.75],
          [7.483370, 53.679425, 0.75],
          [7.484200, 53.679270, 0.0],
          [7.484817, 53.679143, -0.75],
          [7.485561, 53.678987, -0.5],
          [7.486171, 53.678832, 0.0],
          [7.486724, 53.678655, 1.0],
          [7.486948, 53.678569, 1.25],
          [7.486806, 53.678409, 1.75],
          [7.485929, 53.677710, 0.25],
          [7.486310, 53.677568, 0.0],
          [7.487547, 53.677180, -0.25],
          [7.487750, 53.677117, -0.5],
          [7.488029, 53.677061, -0.75],
          [7.488228, 53.677029, -1.0],
          [7.489490, 53.677045, 0.0],
          [7.489952, 53.677034, 0.25],
          [7.490166, 53.677004, 0.25],
          [7.490504, 53.676905, 0.25],
          [7.491679, 53.676449, 0.25],
          [7.493595, 53.675704, 0.0],
          [7.494655, 53.675381, -0.25],
          [7.497485, 53.674591, 0.5],
          [7.498796, 53.674228, 0.0],
          [7.498935, 53.674190, 0.0],
          [7.500257, 53.673823, 0.0],
          [7.502952, 53.673076, 1.0],
          [7.505662, 53.672324, 0.75],
          [7.508686, 53.671485, 0.75],
          [7.511399, 53.670733, 0.5],
          [7.513128, 53.670253, 0.25],
          [7.514473, 53.669879, 0.0],
          [7.515351, 53.669775, 0.25],
          [7.516037, 53.669762, 0.25],
          [7.525645, 53.669822, 0.25],
          [7.526383, 53.669822, 0.25],
          [7.526982, 53.669868, 0.5],
          [7.527801, 53.669984, 0.5],
          [7.528381, 53.670100, 0.0],
          [7.532591, 53.671477, 0.0],
          [7.533459, 53.671764, 0.0],
          [7.533639, 53.671819, 0.0],
          [7.534031, 53.671946, 0.0],
          [7.534608, 53.672083, 0.0],
          [7.545444, 53.673659, 0.0],
          [7.549485, 53.674242, 0.0],
          [7.550304, 53.674296, 0.0],
          [7.551085, 53.674305, 0.0],
          [7.551671, 53.674272, 0.0],
          [7.551990, 53.674239, 0.0],
          [7.552511, 53.674167, 0.0],
          [7.552903, 53.674105, 0.25],
          [7.553349, 53.674015, 0.5],
          [7.555887, 53.673358, 0.0],
          [7.556267, 53.673276, 0.0],
          [7.556522, 53.673253, 0.0],
          [7.557909, 53.673207, 0.25],
          [7.559148, 53.673166, 0.75],
          [7.559288, 53.673128, 0.5],
          [7.559374, 53.673085, 0.25],
          [7.559407, 53.673062, 0.25],
          [7.559433, 53.673031, 0.25],
          [7.560310, 53.673302, 0.0],
          [7.560858, 53.673454, 0.0],
          [7.561575, 53.673622, -0.5],
          [7.562850, 53.673880, -0.25],
          [7.563061, 53.673898, -0.5],
          [7.563281, 53.673887, -0.5],
          [7.563561, 53.673784, -0.75],
          [7.563676, 53.673752, -0.75],
          [7.563775, 53.673743, -1.0],
          [7.563880, 53.673778, -0.75],
          [7.563930, 53.673803, -0.75],
          [7.563980, 53.673867, -0.5],
          [7.563985, 53.673902, -0.5],
          [7.563991, 53.673958, -0.5],
          [7.564045, 53.674024, -0.25],
          [7.564162, 53.674105, 0.0],
          [7.564430, 53.674215, 0.0],
          [7.565017, 53.674335, 0.0],
          [7.565567, 53.674434, 0.0],
          [7.565978, 53.674487, 0.0],
          [7.566401, 53.674515, -0.25],
          [7.567261, 53.674563, -0.5],
          [7.569035, 53.674648, -1.25],
          [7.569435, 53.674684, -1.0],
          [7.570079, 53.674725, -0.25],
          [7.570759, 53.674762, 0.0],
          [7.571024, 53.674770, 0.0],
          [7.572011, 53.674801, -0.5],
          [7.572056, 53.674803, -0.5],
          [7.572257, 53.674765, -0.25],
          [7.572346, 53.674754, -0.25],
          [7.572533, 53.674758, -0.25],
          [7.572609, 53.674760, -0.25],
          [7.572821, 53.674733, 0.0],
          [7.573100, 53.674672, 0.0],
          [7.573339, 53.674611, 0.25],
          [7.573985, 53.674438, 1.0],
          [7.574542, 53.674286, 1.5],
          [7.574770, 53.674232, 1.75],
          [7.574898, 53.674210, 1.75],
          [7.575114, 53.674188, 1.75],
          [7.575166, 53.674187, 1.75],
          [7.575195, 53.674186, 1.75],
          [7.575358, 53.674176, 1.75],
          [7.575629, 53.674176, 1.75],
          [7.575708, 53.674179, 1.75],
          [7.575695, 53.674238, 1.5],
          [7.575692, 53.674260, 1.5],
          [7.575515, 53.674347, 1.25],
          [7.575515, 53.674347, 1.25],
          [7.575692, 53.674260, 1.5],
          [7.575700, 53.674668, 0.0],
          [7.575676, 53.674685, 0.0],
          [7.575627, 53.674743, 0.0],
          [7.575345, 53.674992, -0.75],
          [7.575265, 53.675062, -0.75],
          [7.575211, 53.675113, -0.75],
          [7.575065, 53.675248, -0.5],
          [7.574957, 53.675451, -0.25],
          [7.574205, 53.676668, 0.0],
          [7.574226, 53.676771, 0.0],
          [7.574633, 53.676842, 1.0],
          [7.575057, 53.676917, 1.75],
          [7.575355, 53.676980, 1.5],
          [7.575425, 53.676994, 1.5],
          [7.575469, 53.677003, 1.5],
          [7.575601, 53.677036, 1.5],
          [7.577425, 53.677496, 0.75],
          [7.577600, 53.677529, 0.75],
          [7.577961, 53.677565, 0.75],
          [7.578151, 53.677574, 0.75],
          [7.578445, 53.677577, 0.75],
          [7.578479, 53.677631, 0.75],
          [7.578490, 53.677649, 0.75],
          [7.578581, 53.677702, 0.75],
          [7.578719, 53.677742, 0.5],
          [7.580567, 53.677875, 1.0],
          [7.581002, 53.677925, 0.75],
          [7.581403, 53.677997, 0.5],
          [7.581881, 53.678136, 0.75],
          [7.582084, 53.678201, 0.75],
          [7.583820, 53.678934, 0.0],
          [7.584326, 53.679155, 0.0],
          [7.584652, 53.679273, 0.0],
          [7.585007, 53.679383, 0.0],
          [7.585468, 53.679503, 0.0],
          [7.586381, 53.679677, 0.0],
          [7.586651, 53.679711, 0.0],
          [7.587047, 53.679740, 0.0],
          [7.587406, 53.679742, 0.0],
          [7.587643, 53.679757, 0.0],
          [7.588847, 53.680003, 0.0],
          [7.589348, 53.680128, 0.0],
          [7.590025, 53.680317, 0.0],
          [7.592293, 53.681167, 0.0],
          [7.594126, 53.681882, 0.0],
          [7.594691, 53.682060, 0.0],
          [7.595331, 53.682248, 0.0],
          [7.595671, 53.682381, 0.0],
          [7.598809, 53.683482, 0.0],
          [7.599520, 53.683738, 0.0],
          [7.600270, 53.684010],
          [7.604433, 53.685648],
          [7.604839, 53.685777],
          [7.607470, 53.686359],
          [7.609279, 53.686732],
          [7.612073, 53.687248],
          [7.612890, 53.687318],
          [7.613547, 53.687337],
          [7.613863, 53.687296],
          [7.614553, 53.687121],
          [7.615097, 53.687046],
          [7.615756, 53.687073],
          [7.616259, 53.687136],
          [7.619317, 53.687874],
          [7.619825, 53.687946],
          [7.620107, 53.687938],
          [7.621010, 53.687835],
          [7.621240, 53.687808],
          [7.622496, 53.687773],
          [7.623175, 53.687785],
          [7.623692, 53.687814],
          [7.625385, 53.688025],
          [7.625828, 53.688079],
          [7.628664, 53.688415],
          [7.629778, 53.688437],
          [7.630817, 53.688513],
          [7.631200, 53.688599],
          [7.634652, 53.689426],
          [7.635234, 53.689599],
          [7.635858, 53.689822],
          [7.636484, 53.690111],
          [7.637804, 53.690829],
          [7.638188, 53.690885],
          [7.639429, 53.691033],
          [7.640615, 53.691216],
          [7.641183, 53.691325],
          [7.641633, 53.691343],
          [7.642655, 53.691329],
          [7.643469, 53.691332],
          [7.644998, 53.691480],
          [7.645788, 53.691567],
          [7.647049, 53.691780],
          [7.647119, 53.691792],
          [7.651503, 53.692503],
          [7.652896, 53.692575],
          [7.653903, 53.692740],
          [7.654487, 53.692956],
          [7.654859, 53.693123],
          [7.656212, 53.693772],
          [7.656911, 53.693944],
          [7.657480, 53.694051],
          [7.659060, 53.694205],
          [7.660510, 53.694382],
          [7.661612, 53.694497],
          [7.662775, 53.694619],
          [7.665901, 53.694987],
          [7.666726, 53.695093],
          [7.667260, 53.695281],
          [7.667774, 53.695608],
          [7.668451, 53.696039],
          [7.669561, 53.696600],
          [7.670476, 53.696965],
          [7.671917, 53.697424],
          [7.673308, 53.697664],
          [7.677421, 53.698348],
          [7.679308, 53.698637],
          [7.679403, 53.698648],
          [7.681216, 53.698949],
          [7.683090, 53.699269],
          [7.684586, 53.699503],
          [7.685371, 53.699603],
          [7.686217, 53.699710],
          [7.686724, 53.699766],
          [7.688413, 53.699953],
          [7.690416, 53.700157],
          [7.691234, 53.700281],
          [7.692740, 53.700552],
          [7.693977, 53.700757, 0.75],
          [7.695690, 53.701026, 0.75],
          [7.696098, 53.701002, 0.75],
          [7.696721, 53.701009, 0.75],
          [7.697570, 53.701030, 0.75],
          [7.699789, 53.700790, 0.75],
          [7.699902, 53.700727, 0.75],
          [7.699920, 53.700697, 0.75],
          [7.699924, 53.700548, 0.75],
          [7.701064, 53.700483, 1.0],
          [7.701265, 53.700474, 1.0],
          [7.701575, 53.700432, 1.25],
          [7.701470, 53.700225, 1.5],
          [7.701443, 53.700093, 1.5],
          [7.701448, 53.700014, 1.5],
          [7.701452, 53.699919, 1.75],
          [7.701688, 53.699913, 2.0],
          [7.701783, 53.699903, 2.0],
          [7.701916, 53.699889, 2.0],
          [7.702096, 53.699858, 2.25],
          [7.702318, 53.699806, 2.25],
          [7.702596, 53.699721, 2.0],
          [7.703096, 53.699551, 1.25],
          [7.703458, 53.699446, 0.75],
          [7.703682, 53.699376, 1.0],
          [7.703836, 53.699352, 1.0],
          [7.703968, 53.699339, 1.0],
          [7.704101, 53.699335, 1.0],
          [7.704244, 53.699333, 1.0],
          [7.704460, 53.699344, 1.25],
          [7.704741, 53.699372, 1.5],
          [7.704847, 53.699385, 1.75],
          [7.705661, 53.699498, 2.0],
          [7.705771, 53.699458, 2.0],
          [7.706336, 53.699539, 1.25],
          [7.706507, 53.699552, 1.0],
          [7.706840, 53.699566, 1.0],
          [7.707006, 53.699566, 1.0],
          [7.707178, 53.699555, 1.0],
          [7.707366, 53.699533, 1.0],
          [7.707558, 53.699498, 1.0],
          [7.709143, 53.699224, 1.0],
          [7.709364, 53.699191, 0.75],
          [7.709743, 53.699153, 0.25],
          [7.709871, 53.699149, 0.0],
          [7.711238, 53.699109, 0.0],
          [7.711553, 53.699114, 0.0],
          [7.712394, 53.699113, 0.0],
          [7.712788, 53.699095, -0.25],
          [7.713689, 53.699000, -0.5],
          [7.715502, 53.698777, 0.5],
          [7.715526, 53.698836, 0.5],
          [7.716080, 53.698767, 0.25],
          [7.717617, 53.698576, 0.0],
          [7.718377, 53.698462, 1.0],
          [7.718742, 53.698395, 1.0],
          [7.719068, 53.698321, 0.75],
          [7.719453, 53.698213, 0.5],
          [7.719768, 53.698104, 0.0],
          [7.719999, 53.698012, -0.25],
          [7.720376, 53.697837, -0.5],
          [7.720458, 53.697892, -0.5],
          [7.720507, 53.697928, -0.25],
          [7.720575, 53.698001, -0.25],
          [7.720626, 53.698044, -0.25],
          [7.720681, 53.698077, -0.25],
          [7.720708, 53.698089, -0.25],
          [7.720735, 53.698101, -0.25],
          [7.720859, 53.698134, 0.0],
          [7.721042, 53.698143, 0.0],
          [7.721152, 53.698139, 0.0],
          [7.722787, 53.697990, 0.75],
          [7.723213, 53.697923, 0.75],
          [7.723657, 53.697840, 1.0],
          [7.724037, 53.697786, 1.25],
          [7.724825, 53.697705, 1.0],
          [7.725000, 53.697702, 1.0],
          [7.727570, 53.697874, 0.75],
          [7.732136, 53.698177, 1.5],
          [7.736602, 53.698479, 0.0],
          [7.737354, 53.698530, 0.0],
          [7.737391, 53.698532, 0.0],
          [7.737425, 53.698534, 0.0],
          [7.751280, 53.699484, 0.0],
          [7.758155, 53.699982, 0.75],
          [7.765381, 53.700614, 0.25],
          [7.765416, 53.700616, 0.25],
          [7.765451, 53.700619, 0.25],
          [7.766949, 53.700758, 0.75],
          [7.767195, 53.700788, 0.75],
          [7.768062, 53.700934, 0.75],
          [7.774997, 53.702283, 1.0],
          [7.775147, 53.702320, 1.25],
          [7.776010, 53.702563, 1.5],
          [7.776382, 53.702649, 1.0],
          [7.776416, 53.702657, 1.0],
          [7.776449, 53.702664, 1.0],
          [7.776776, 53.702732, 0.5],
          [7.776942, 53.702745, 0.5],
          [7.777299, 53.702716, 0.5],
          [7.779290, 53.702673, 0.0],
          [7.779325, 53.702672, 0.0],
          [7.779361, 53.702671, 0.0],
          [7.779440, 53.702670, 0.0],
          [7.779627, 53.702666, 0.0],
          [7.780492, 53.702704, 0.0],
          [7.782965, 53.702825, 0.0],
          [7.786331, 53.702989, 0.0],
          [7.786874, 53.703016, 0.0],
          [7.787140, 53.703011, 0.0],
          [7.787440, 53.702970, 0.0],
          [7.787715, 53.702945, 0.0],
          [7.789682, 53.703035, -0.25],
          [7.792461, 53.703162, -0.25],
          [7.795259, 53.703290, 0.0],
          [7.795534, 53.703336, 0.0],
          [7.795826, 53.703397, 0.0],
          [7.796118, 53.703443, -0.25],
          [7.801551, 53.703675, -0.5],
          [7.801914, 53.703696, -0.5],
          [7.802061, 53.703687, -0.5],
          [7.802176, 53.703747, -0.5],
          [7.802904, 53.704274, 0.25],
          [7.803750, 53.704866, 0.0],
          [7.803930, 53.705006, 0.0],
          [7.804098, 53.705160, 0.0],
          [7.804212, 53.705297, -0.25],
          [7.804419, 53.705598, -0.5],
          [7.804621, 53.705863, -0.25],
          [7.804928, 53.706309, -0.5],
          [7.804988, 53.706371, -0.5],
          [7.805034, 53.706443, -0.5],
          [7.805058, 53.706501, -0.5],
          [7.805060, 53.706556, -0.75],
          [7.805091, 53.706629, -0.75],
          [7.805149, 53.706668, -0.75],
          [7.805174, 53.706719, -0.75],
          [7.805220, 53.706745, -0.75],
          [7.805408, 53.706824, -0.5],
          [7.805499, 53.706877, -0.5],
          [7.805549, 53.706932, -0.5],
          [7.805955, 53.707246, -0.5],
          [7.806821, 53.707873, 0.0],
          [7.807100, 53.707939, 0.0],
          [7.807312, 53.707990, -0.25],
          [7.807418, 53.708005, -0.25],
          [7.807462, 53.707999, -0.25],
          [7.807507, 53.707975, -0.25],
          [7.807486, 53.707888, -0.5],
          [7.807449, 53.707802, -0.5],
          [7.807346, 53.707568, -0.5],
          [7.807289, 53.707442, -0.5],
          [7.807297, 53.707408, -0.5],
          [7.807365, 53.707364, -0.5],
          [7.807238, 53.707247, -0.25],
          [7.807183, 53.707168, 0.0],
          [7.807166, 53.707093, 0.0],
          [7.807190, 53.707019, 0.0],
          [7.807221, 53.706977, 0.0],
          [7.807268, 53.706945, 0.0],
          [7.807361, 53.706891, 0.0],
          [7.807489, 53.706849, 0.0],
          [7.807636, 53.706818, -0.25],
          [7.808064, 53.706755, -1.25],
          [7.808080, 53.706753, -1.25],
          [7.808325, 53.706711, -1.75],
          [7.808351, 53.706707, -1.75],
          [7.809095, 53.706574, -0.75],
          [7.809407, 53.706511, -0.5],
          [7.809719, 53.706405, 0.0],
          [7.809976, 53.706268, 0.25],
          [7.810088, 53.706183, 0.5],
          [7.810216, 53.706245, 0.5],
          [7.810275, 53.706151, 0.5],
          [7.810370, 53.705945, 0.75],
          [7.810428, 53.705753, 0.75],
          [7.810461, 53.705340, 0.0],
          [7.810457, 53.705098, -0.25],
          [7.810131, 53.699488, -2.0],
          [7.810114, 53.699349, -2.0],
          [7.810050, 53.699092, -1.75],
          [7.809975, 53.698914, -1.25],
          [7.809839, 53.698658, -0.5],
          [7.809807, 53.698608, -0.25],
          [7.809762, 53.698484, 0.0],
          [7.809720, 53.698391, 0.0],
          [7.809692, 53.698329, 0.25],
          [7.809612, 53.698162, 0.25],
          [7.809530, 53.698174, 0.25],
          [7.809277, 53.698212, 0.5],
          [7.808914, 53.698238, 0.75],
          [7.808831, 53.698255, 0.75],
          [7.808751, 53.698290, 0.75],
          [7.808688, 53.698340, 0.75],
          [7.808575, 53.698286, 0.75],
          [7.808527, 53.698270, 0.75],
          [7.808441, 53.698260, 0.75],
          [7.808174, 53.698264, 0.5],
          [7.808014, 53.698278, 0.5],
          [7.807870, 53.698308, 0.25],
          [7.807746, 53.698315, 0.25],
          [7.807628, 53.698293, 0.0],
          [7.807591, 53.698350, 0.0],
          [7.807595, 53.698573, 0.0],
          [7.807573, 53.698610, 0.0],
          [7.807513, 53.698645, 0.0],
          [7.805354, 53.698783, -0.75]
        ]
      }
    }
  ]
}

let day20: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "J20 - Harlesiel - Sande - 36.1km",
        "track-length": "36109",
        "filtered ascend": "38",
        "plain-ascend": "12",
        "total-time": "5982",
        "total-energy": "597719",
        "cost": "37942",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["7808914", "53698238", "0", "285", "1150", "0", "241", "0", "0", "highway=residential surface=asphalt", "", "42", "4215"],
          ["7809277", "53698212", "0", "25", "1550", "0", "2", "0", "0", "highway=residential surface=wood", "", "46", "4639"],
          ["7809296", "53698242", "0", "2", "5050", "0", "68", "0", "0", "reversedirection=yes highway=path", "", "47", "4658"],
          ["7809277", "53698212", "0", "2", "5050", "0", "0", "0", "0", "highway=path", "", "49", "4658"],
          ["7809530", "53698174", "0", "18", "1150", "0", "100", "0", "0", "highway=residential surface=asphalt", "", "50", "4825"],
          ["7806648", "53691249", "1", "830", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "", "185", "18331"],
          ["7806536", "53691243", "1", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no route_bicycle_rcn=yes", "", "187", "18466"],
          ["7806509", "53690769", "1", "10", "1350", "0", "79", "0", "0", "highway=service access=customers", "", "188", "18635"],
          ["7806536", "53691243", "1", "10", "1350", "0", "0", "0", "0", "reversedirection=yes highway=service access=customers", "", "189", "18729"],
          ["7803599", "53691319", "2", "199", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt cycleway=no route_bicycle_rcn=yes", "", "217", "21498"],
          ["7802802", "53690464", "1", "128", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "237", "23504"],
          ["7803186", "53690356", "1", "25", "1350", "0", "100", "0", "0", "highway=service", "", "241", "23899"],
          ["7802802", "53690464", "1", "25", "1350", "0", "12", "0", "0", "reversedirection=yes highway=service", "", "243", "24134"],
          ["7803599", "53691319", "2", "128", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "260", "25786"],
          ["7806648", "53691249", "1", "207", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=no route_bicycle_rcn=yes", "", "291", "28872"],
          ["7806927", "53691259", "1", "19", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "294", "29163"],
          ["7808446", "53691271", "0", "103", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing crossing=uncontrolled", "309", "30695"],
          ["7808597", "53691252", "0", "11", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "", "311", "30865"],
          ["7809023", "53691253", "0", "49", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt junction=roundabout route_bicycle_icn=yes route_bicycle_ncn=yes", "", "318", "31606"],
          ["7809166", "53691268", "0", "10", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "320", "31770"],
          ["7809893", "53691279", "0", "49", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "328", "32621"],
          ["7817115", "53690639", "0", "488", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "", "397", "39541"],
          ["7817582", "53690741", "0", "33", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt route_bicycle_rcn=yes", "", "403", "40084"],
          ["7820525", "53691157", "0", "212", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "438", "43649"],
          ["7830518", "53690301", "0", "237", "1050", "0", "4", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated", "", "480", "47835"],
          ["7820525", "53691157", "0", "237", "1050", "0", "4", "0", "0", "reversedirection=yes highway=path surface=concrete foot=designated bicycle=designated", "highway=crossing bicycle=yes crossing=unmarked", "511", "50857"],
          ["7817582", "53690741", "0", "212", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=designated bicycle=designated route_bicycle_rcn=yes", "", "544", "54192"],
          ["7817115", "53690639", "0", "33", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt route_bicycle_rcn=yes", "", "549", "54741"],
          ["7825085", "53681228", "-1", "1346", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "758", "75573"],
          ["7828942", "53675965", "-2", "668", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "869", "86734"],
          ["7828998", "53675876", "-2", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "871", "86915"],
          ["7833229", "53669346", "0", "780", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1008", "100602"],
          ["7830273", "53669150", "0", "204", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1045", "104340"],
          ["7830217", "53659872", "-1", "1042", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes", "", "1204", "120208"],
          ["7831123", "53659935", "-1", "61", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1214", "121226"],
          ["7833403", "53650028", "0", "1149", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "1415", "141278"],
          ["7850443", "53652619", "0", "1267", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "1629", "162729"],
          ["7861975", "53646991", "0", "990", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1785", "178306"],
          ["7862122", "53647265", "0", "33", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt cycleway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1790", "178859"],
          ["7872422", "53646877", "0", "853", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "1932", "193036"],
          ["7875495", "53646722", "0", "567", "1000", "0", "0", "0", "0", "reversedirection=yes highway=unclassified surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2027", "202486"],
          ["7878359", "53645331", "-2", "247", "1000", "0", "0", "0", "0", "highway=track surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2058", "205634"],
          ["7878634", "53645232", "-2", "22", "1000", "0", "0", "0", "0", "highway=unclassified surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2062", "206016"],
          ["7884616", "53643145", "-2", "467", "1000", "0", "0", "0", "0", "highway=track surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2141", "213877"],
          ["7888345", "53641954", "-2", "281", "1000", "0", "0", "0", "0", "highway=track surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "2190", "218783"],
          ["7886728", "53639685", "0", "276", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2242", "224055"],
          ["7885528", "53637940", "1", "211", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cycle_barrier", "2286", "228442"],
          ["7885454", "53637836", "1", "13", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "2289", "228669"],
          ["7885442", "53637817", "1", "3", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cycle_barrier", "2289", "228721"],
          ["7883512", "53634993", "-2", "341", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2337", "233532"],
          ["7883480", "53634951", "-2", "6", "1000", "0", "0", "0", "0", "highway=cycleway route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2338", "233621"],
          ["7873903", "53619371", "0", "1853", "1000", "0", "0", "0", "0", "highway=cycleway surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "2662", "265983"],
          ["7866468", "53615792", "0", "699", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential tracktype=grade1 route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2779", "277714"],
          ["7866393", "53615789", "0", "5", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2780", "277807"],
          ["7878574", "53581520", "0", "4055", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "3458", "345658"],
          ["7878614", "53581459", "0", "8", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=uncontrolled", "3460", "345783"],
          ["7881120", "53577941", "-1", "438", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3528", "352643"],
          ["7882017", "53577741", "0", "66", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3542", "354055"],
          ["7882150", "53577722", "0", "10", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3544", "354260"],
          ["7896334", "53574051", "8", "1048", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "3767", "376525"],
          ["7897298", "53574334", "8", "77", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "3776", "377445"],
          ["7899405", "53575380", "7", "186", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes", "", "3801", "379933"],
          ["7902397", "53574855", "9", "234", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "3848", "384618"],
          ["7904121", "53573274", "11", "219", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3890", "388838"],
          ["7904296", "53573216", "11", "14", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "3893", "389117"],
          ["7904442", "53573175", "11", "11", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "3895", "389332"],
          ["7905841", "53572113", "10", "99", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "", "3911", "390919"],
          ["7904545", "53573157", "10", "91", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "", "3922", "392000"],
          ["7904593", "53573231", "10", "9", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=yes bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "3923", "392116"],
          ["7904644", "53573299", "10", "9", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=yes bicycle=yes route_bicycle_rcn=yes", "", "3924", "392233"],
          ["7905674", "53572612", "10", "108", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=yes bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "3939", "393696"],
          ["7906162", "53574265", "5", "236", "1450", "0", "109", "0", "0", "highway=tertiary surface=asphalt", "", "3963", "396163"],
          ["7906124", "53574427", "4", "19", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "3966", "396392"],
          ["7909284", "53575785", "0", "271", "1150", "0", "102", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "3997", "399532"],
          ["7910411", "53575631", "0", "78", "1150", "0", "106", "0", "0", "highway=residential", "", "4008", "400608"],
          ["7910440", "53575536", "0", "2", "5050", "0", "59", "0", "0", "reversedirection=yes highway=track", "", "4009", "400612"],
          ["7910411", "53575631", "0", "2", "5050", "0", "0", "0", "0", "highway=track", "", "4010", "400612"],
          ["7909284", "53575785", "0", "78", "1150", "0", "63", "0", "0", "reversedirection=yes highway=residential", "", "4019", "401499"],
          ["7906124", "53574427", "4", "271", "1150", "0", "124", "0", "0", "highway=residential surface=asphalt", "", "4074", "406921"],
          ["7906162", "53574265", "5", "19", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "4078", "407407"],
          ["7904817", "53573677", "9", "111", "1000", "0", "0", "0", "0", "highway=residential surface=paved oneway=yes route_bicycle_rcn=yes", "", "4131", "412646"],
          ["7904711", "53573658", "9", "8", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "4132", "412818"],
          ["7904319", "53573537", "10", "30", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path route_bicycle_rcn=yes", "", "4140", "413564"],
          ["7904351", "53573497", "10", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=pedestrian surface=paving_stones bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4141", "413688"],
          ["7904166", "53573332", "11", "24", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "4147", "414321"],
          ["7904121", "53573274", "11", "8", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "4150", "414534"],
          ["7904296", "53573216", "11", "14", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "4153", "414890"],
          ["7904442", "53573175", "11", "11", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes", "4156", "415156"],
          ["7907078", "53570851", "6", "321", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=street_lamp", "4202", "419778"],
          ["7907099", "53570830", "6", "3", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes crossing=traffic_signals", "4202", "419806"],
          ["7907232", "53570697", "6", "18", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "4204", "419979"],
          ["7912966", "53564810", "0", "783", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=unmarked", "4307", "430268"],
          ["7914319", "53562266", "0", "314", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "", "4354", "434996"],
          ["7914544", "53561978", "0", "38", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=designated bicycle=designated route_bicycle_rcn=yes", "", "4362", "435725"],
          ["7915394", "53561027", "1", "123", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "4390", "438562"],
          ["7915479", "53560962", "1", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "4392", "438770"],
          ["7915519", "53560930", "1", "5", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing bicycle=yes crossing=traffic_signals", "4393", "438872"],
          ["7915570", "53560892", "1", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=cycleway surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "", "4394", "438994"],
          ["7917446", "53555721", "-2", "607", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated oneway:bicycle=no route_bicycle_rcn=yes", "nodeaccessgranted=yes bicycle=yes railway=crossing", "4483", "447910"],
          ["7920502", "53548665", "3", "825", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated oneway:bicycle=no route_bicycle_rcn=yes", "", "4654", "464959"],
          ["7920837", "53548258", "3", "52", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=yes route_bicycle_rcn=yes", "", "4660", "465556"],
          ["7920974", "53548279", "3", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "", "4661", "465663"],
          ["7941235", "53543843", "3", "1444", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "", "4899", "489439"],
          ["7944485", "53543023", "3", "241", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=crossing", "4945", "494131"],
          ["7946930", "53542549", "4", "181", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=yes route_bicycle_rcn=yes", "", "4976", "497146"],
          ["7948596", "53541412", "4", "183", "1050", "0", "64", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=yes", "", "4998", "499413"],
          ["7948517", "53541342", "4", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes crossing=traffic_signals railway=crossing", "5000", "499568"],
          ["7948466", "53541288", "4", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes crossing=traffic_signals railway=crossing", "5001", "499677"],
          ["7948671", "53541141", "4", "27", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=yes route_bicycle_rcn=yes", "", "5005", "500125"],
          ["7947739", "53537237", "3", "445", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=unmarked", "5068", "506412"],
          ["7947851", "53534243", "5", "337", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=yes route_bicycle_rcn=yes", "", "5133", "512842"],
          ["7947897", "53534237", "5", "4", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt smoothness=good route_bicycle_rcn=yes", "", "5133", "512913"],
          ["7947469", "53528528", "6", "643", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones cycleway=track smoothness=intermediate route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=stop direction=forward", "5248", "524422"],
          ["7947499", "53528421", "6", "13", "1000", "0", "0", "0", "0", "highway=tertiary surface=paving_stones cycleway=track smoothness=intermediate route_bicycle_rcn=yes", "", "5251", "524671"],
          ["7947439", "53528237", "6", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_rcn=yes", "", "5255", "525065"],
          ["7947481", "53528364", "6", "14", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_rcn=yes", "", "5256", "525197"],
          ["7947413", "53528357", "7", "5", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_rcn=yes", "", "5257", "525248"],
          ["7944822", "53527673", "4", "196", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=yes route_bicycle_rcn=yes", "", "5279", "527532"],
          ["7944890", "53527495", "3", "21", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=track route_bicycle_rcn=yes", "", "5282", "527753"],
          ["7944724", "53527467", "3", "12", "1350", "0", "85", "0", "0", "reversedirection=yes highway=service", "", "5283", "527882"],
          ["7944890", "53527495", "3", "12", "1350", "0", "22", "0", "0", "highway=service", "", "5284", "528008"],
          ["7944920", "53527411", "3", "10", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=track route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "5285", "528110"],
          ["7944987", "53527243", "3", "20", "1000", "0", "0", "0", "0", "highway=tertiary cycleway=track route_bicycle_rcn=yes", "", "5287", "528326"],
          ["7945029", "53527246", "4", "3", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=cobblestone route_bicycle_rcn=yes", "", "5288", "528361"],
          ["7945714", "53525149", "3", "239", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=yes route_bicycle_rcn=yes", "", "5320", "531539"],
          ["7966524", "53503395", "0", "2885", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "", "5794", "578953"],
          ["7966587", "53503060", "0", "39", "1000", "0", "0", "0", "0", "highway=tertiary route_bicycle_rcn=yes", "", "5799", "579471"],
          ["7966624", "53502641", "-1", "50", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path tracktype=grade1 surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "", "5804", "579997"],
          ["7965501", "53494749", "0", "915", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path tracktype=grade1 surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "5958", "595439"],
          ["7961805", "53495016", "-1", "158", "1150", "0", "92", "0", "0", "highway=residential surface=asphalt", "", "5981", "597729"]
        ],
        "times": [0, 17.307, 18.257, 19.051, 23.052, 24.18, 25.732, 27.28, 29.295, 31.292, 34.739, 35.87, 36.621, 38.482, 39.773, 41.057, 42.151, 46.391, 47.822, 49.111, 50.778, 59.111, 66.159, 68.606, 74.106, 98.471, 120.562, 122.711, 124.666, 126.611, 129.421, 131.821, 145.295, 154.307, 176.709, 179.247, 184.654, 185.835, 187.185, 188.872, 189.807, 193.064, 200.342, 203.169, 208.598, 211.284, 217.497, 218.673, 219.681, 220.52, 221.308, 222.255, 223.683, 224.32, 232.604, 234.177, 235.759, 237.558, 239.226, 240.693, 241.51, 241.973, 242.801, 243.855, 245.107, 246.193, 247.316, 254.249, 254.797, 256.044, 256.886, 257.639, 258.395, 259.308, 260.379, 266.141, 268.532, 273.616, 276.458, 285.44, 290.021, 291.23, 294.139, 300.236, 304.761, 306.712, 309.455, 311.153, 312.324, 313.507, 314.701, 315.604, 316.512, 317.425, 318.568, 320.203, 325.082, 328.712, 341.371, 367.009, 384.01, 387.449, 390.74, 394.951, 397.896, 403.326, 404.482, 416.212, 422.879, 425.323, 427.755, 430.52, 433.972, 438.976, 446.172, 449.682, 453.855, 457.85, 480.834, 495.505, 498.609, 502.092, 504.861, 511.051, 515.41, 518.415, 520.671, 522.807, 524.845, 531.014, 543.233, 544.396, 549.888, 554.846, 557.463, 560.413, 563.488, 565.941, 567.685, 572.318, 575.438, 584.987, 611.611, 666.611, 673.518, 675.654, 678.126, 690.516, 704.844, 706.382, 707.576, 709.621, 716.303, 751.93, 757.425, 758.177, 762.717, 780.421, 798.914, 869.78, 871.589, 885.01, 1001.237, 1008.453, 1010.471, 1012.258, 1014.019, 1045.835, 1047.369, 1049.286, 1063.212, 1097.815, 1132.807, 1141.918, 1143.324, 1145.424, 1147.713, 1204.504, 1214.686, 1216.827, 1260.356, 1302.769, 1387.58, 1404.996, 1415.192, 1430.324, 1432.128, 1439.966, 1461.915, 1473.718, 1490.491, 1503.756, 1520.687, 1536.332, 1544.632, 1575.806, 1580.445, 1620.35, 1629.684, 1671.778, 1677.207, 1713.053, 1730.258, 1785.448, 1790.986, 1805.922, 1838.76, 1842.051, 1845.459, 1847.651, 1850.185, 1865.852, 1870.067, 1874.69, 1878.316, 1884.367, 1897.921, 1907.588, 1922.198, 1929.991, 1932.746, 1939.001, 1948.855, 1958.06, 1965.555, 1968.394, 1981.285, 1984.515, 1988.489, 1991.182, 1994.829, 1997.429, 2003.612, 2005.051, 2006.364, 2008.091, 2011.626, 2014.137, 2019.068, 2021.089, 2025.027, 2027.229, 2031.639, 2041.599, 2051.282, 2055.209, 2058.708, 2062.526, 2065.834, 2090.611, 2112.785, 2118.545, 2123.767, 2136.378, 2138.68, 2141.139, 2154.929, 2164.715, 2190.193, 2198.023, 2205.348, 2236.163, 2242.915, 2259.32, 2286.776, 2288.696, 2289.045, 2289.567, 2294.759, 2331.222, 2337.667, 2338.557, 2356.56, 2409.919, 2436.706, 2457.536, 2505.165, 2519.125, 2565.211, 2631.764, 2662.153, 2671.463, 2673.916, 2675.817, 2677.783, 2688.934, 2699.992, 2706.454, 2718.722, 2729.101, 2732.486, 2741.601, 2746.644, 2748.616, 2750.965, 2755.651, 2760.579, 2765.732, 2769.052, 2771.405, 2779.427, 2780.356, 2782.016, 2782.702, 2784.755, 2807.153, 2816.737, 2818.033, 2848.83, 2880.604, 2885.055, 2886.115, 2886.819, 2887.522, 2891.802, 2907.413, 2933.271, 2947.508, 2955.414, 2960.62, 2982.215, 2984.88, 2988.478, 2994.658, 3006.605, 3018.244, 3030.389, 3037.063, 3041.659, 3043.358, 3050.529, 3057.959, 3068.882, 3073.585, 3095.904, 3122.314, 3129.433, 3133.617, 3141.527, 3144.892, 3146.237, 3148.928, 3152.795, 3160.528, 3164.271, 3167.994, 3173.167, 3176.267, 3197.383, 3204.897, 3208.527, 3234.09, 3238.661, 3256.352, 3265.962, 3268.219, 3279.164, 3282.242, 3294.383, 3297.047, 3303.443, 3312.083, 3314.615, 3323.556, 3338.653, 3357.225, 3363.855, 3371.136, 3381.938, 3389.487, 3397.638, 3405.281, 3418.6, 3434.097, 3441.044, 3448.209, 3455.652, 3458.827, 3460.083, 3461.187, 3462.295, 3463.408, 3467.191, 3470.437, 3473.549, 3482.246, 3492.962, 3503.794, 3516.058, 3518.431, 3523.46, 3526.296, 3528.684, 3530.444, 3534.586, 3535.222, 3537.676, 3540.697, 3542.793, 3544.845, 3578.591, 3599.33, 3603.128, 3608.76, 3610.7, 3620.047, 3622.987, 3633.231, 3635.021, 3638.349, 3650.562, 3659.838, 3692.411, 3706.611, 3711.035, 3716.125, 3737.421, 3748.783, 3755.582, 3766.585, 3767.455, 3768.393, 3769.75, 3772.616, 3775.281, 3776.657, 3778.877, 3787.554, 3797.26, 3799.391, 3801.521, 3804.32, 3806.485, 3808.037, 3809.883, 3811.296, 3812.493, 3813.875, 3817.997, 3819.714, 3822.437, 3824.623, 3829.869, 3833.678, 3838.981, 3845.346, 3848.363, 3850.331, 3854.404, 3859.61, 3876.599, 3881.077, 3882.909, 3884.711, 3887.072, 3890.564, 3893.357, 3895.506, 3896.948, 3899.095, 3900.873, 3901.405, 3911.369, 3918.93, 3919.311, 3920.599, 3922.185, 3923.336, 3924.513, 3925.268, 3926.293, 3927.867, 3928.535, 3929.345, 3933.877, 3939.139, 3944.781, 3947.213, 3948.461, 3949.765, 3950.285, 3951.03, 3955.591, 3956.674, 3958.076, 3962.469, 3963.807, 3966.099, 3969.556, 3975.107, 3982.652, 3986.712, 3991.302, 3995.386, 3997.49, 3999.527, 4008.242, 4009.633, 4010.932, 4017.925, 4019.801, 4021.88, 4026.627, 4033.167, 4040.167, 4054.346, 4065.197, 4074.008, 4078.869, 4131.248, 4132.756, 4132.969, 4139.919, 4140.422, 4141.663, 4144.491, 4146.345, 4147.994, 4150.124, 4153.682, 4156.347, 4158.099, 4160.662, 4162.744, 4163.36, 4183.08, 4191.794, 4198.936, 4202.554, 4202.84, 4204.566, 4238.148, 4251.7, 4254.28, 4255.972, 4259.209, 4267.456, 4273.445, 4278.565, 4282.855, 4287.386, 4303.26, 4305.362, 4306.576, 4307.439, 4308.309, 4309.187, 4319.574, 4327.557, 4329.774, 4330.372, 4332.333, 4333.707, 4334.782, 4335.554, 4336.64, 4337.888, 4338.672, 4339.616, 4341.132, 4352.632, 4354.024, 4354.719, 4356.201, 4360.482, 4362.006, 4384.373, 4388.25, 4390.374, 4392.451, 4393.473, 4394.687, 4395.289, 4395.887, 4400.291, 4402.1, 4404.119, 4405.297, 4408.662, 4411.185, 4427.227, 4431.862, 4442.276, 4444.908, 4479.288, 4482.531, 4483.182, 4483.834, 4485.141, 4551.563, 4557.959, 4570.439, 4589.1, 4591.346, 4598.974, 4611.108, 4615.273, 4619.682, 4627.092, 4634.317, 4646.979, 4654.295, 4656.609, 4656.979, 4658.32, 4660.262, 4660.369, 4661.34, 4669.775, 4674.977, 4685.767, 4704.625, 4717.329, 4727.202, 4731.412, 4741.11, 4750.551, 4754.125, 4755.698, 4768.413, 4775.291, 4787.802, 4804.447, 4809.76, 4813.822, 4819.062, 4823.243, 4831.95, 4842.007, 4858.128, 4885.365, 4899.072, 4927.739, 4933.052, 4936.802, 4938.572, 4944.956, 4945.987, 4947.626, 4948.679, 4949.249, 4951.437, 4957.167, 4959.248, 4961.97, 4965.271, 4968.025, 4976.135, 4978.159, 4980.344, 4983.803, 4984.986, 4986.576, 4998.491, 4998.799, 5000.35, 5001.442, 5002.226, 5004.742, 5005.245, 5005.916, 5006.419, 5012.288, 5016.146, 5026.483, 5040.488, 5040.951, 5047.201, 5055.723, 5064.379, 5068.783, 5077.306, 5081.243, 5104.645, 5121.037, 5129.131, 5130.75, 5133.074, 5133.785, 5145.601, 5186.745, 5198.151, 5201.552, 5206.779, 5241.698, 5248.855, 5250.009, 5251.343, 5252.667, 5255.282, 5256.602, 5257.111, 5264.355, 5268.018, 5272.157, 5274.003, 5276.03, 5279.946, 5282.161, 5283.445, 5284.709, 5285.729, 5286.788, 5287.883, 5288.236, 5299.968, 5320.008, 5329.972, 5335.138, 5339.309, 5342.97, 5353.236, 5356.535, 5362.969, 5369.453, 5380.671, 5391.399, 5401.232, 5405.634, 5410.446, 5474.468, 5480.462, 5484.88, 5488.378, 5489.423, 5492.564, 5498.9, 5506.138, 5515.948, 5532.72, 5543.883, 5559.826, 5603.727, 5659.924, 5663.936, 5664.837, 5665.736, 5668.595, 5671.402, 5674.936, 5679.508, 5683.693, 5701.89, 5753.415, 5767.304, 5783.978, 5785.84, 5787.362, 5788.883, 5792.26, 5794.117, 5796.309, 5797.489, 5799.298, 5799.697, 5800.205, 5802.568, 5804.56, 5809.647, 5831.484, 5848.443, 5858.392, 5863.702, 5868.411, 5873.338, 5878.675, 5883.463, 5886.259, 5889.761, 5901.062, 5912.523, 5919.074, 5944.037, 5955.761, 5958.967, 5959.811, 5961.666, 5965.373, 5966.637, 5968.282, 5974.828, 5981.866]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [7.805357, 53.698782, -0.75],
          [7.807513, 53.698645, 0.0],
          [7.807573, 53.698610, 0.0],
          [7.807595, 53.698573, 0.0],
          [7.807591, 53.698350, 0.0],
          [7.807628, 53.698293, 0.0],
          [7.807746, 53.698315, 0.25],
          [7.807870, 53.698308, 0.25],
          [7.808014, 53.698278, 0.5],
          [7.808174, 53.698264, 0.5],
          [7.808441, 53.698260, 0.75],
          [7.808527, 53.698270, 0.75],
          [7.808575, 53.698286, 0.75],
          [7.808688, 53.698340, 0.75],
          [7.808751, 53.698290, 0.75],
          [7.808831, 53.698255, 0.75],
          [7.808914, 53.698238, 0.75],
          [7.809277, 53.698212, 0.5],
          [7.809284, 53.698224, 0.5],
          [7.809277, 53.698212, 0.5],
          [7.809530, 53.698174, 0.25],
          [7.809195, 53.697454, -0.75],
          [7.808878, 53.697029, -0.25],
          [7.808764, 53.696895, -0.25],
          [7.808508, 53.696624, 0.0],
          [7.807449, 53.695434, 0.0],
          [7.806496, 53.694399, 0.0],
          [7.806424, 53.694306, 0.25],
          [7.806371, 53.694215, 0.25],
          [7.806335, 53.694122, 0.25],
          [7.806307, 53.693995, 0.5],
          [7.806313, 53.693885, 0.5],
          [7.806400, 53.693282, 1.0],
          [7.806462, 53.692849, 1.0],
          [7.806634, 53.691718, 1.0],
          [7.806647, 53.691586, 1.0],
          [7.806649, 53.691307, 1.0],
          [7.806648, 53.691249, 1.0],
          [7.806536, 53.691243, 1.0],
          [7.806531, 53.691155, 1.0],
          [7.806536, 53.691243, 1.0],
          [7.806078, 53.691229, 1.25],
          [7.805181, 53.691193, 1.25],
          [7.804883, 53.691188, 1.5],
          [7.804370, 53.691214, 1.75],
          [7.804136, 53.691240, 2.0],
          [7.803599, 53.691319, 2.0],
          [7.803497, 53.691327, 2.0],
          [7.803409, 53.691326, 2.0],
          [7.803346, 53.691318, 2.0],
          [7.803291, 53.691302, 1.75],
          [7.803231, 53.691267, 1.75],
          [7.803168, 53.691201, 1.75],
          [7.803148, 53.691172, 1.75],
          [7.803032, 53.690700, 1.5],
          [7.802993, 53.690614, 1.5],
          [7.802923, 53.690541, 1.5],
          [7.802802, 53.690464, 1.25],
          [7.802911, 53.690401, 1.25],
          [7.803042, 53.690382, 1.5],
          [7.803106, 53.690370, 1.5],
          [7.803042, 53.690382, 1.5],
          [7.802911, 53.690401, 1.25],
          [7.802802, 53.690464, 1.25],
          [7.802923, 53.690541, 1.5],
          [7.802993, 53.690614, 1.5],
          [7.803032, 53.690700, 1.5],
          [7.803148, 53.691172, 1.75],
          [7.803168, 53.691201, 1.75],
          [7.803231, 53.691267, 1.75],
          [7.803291, 53.691302, 1.75],
          [7.803346, 53.691318, 2.0],
          [7.803409, 53.691326, 2.0],
          [7.803497, 53.691327, 2.0],
          [7.803599, 53.691319, 2.0],
          [7.804136, 53.691240, 2.0],
          [7.804370, 53.691214, 1.75],
          [7.804883, 53.691188, 1.5],
          [7.805181, 53.691193, 1.25],
          [7.806078, 53.691229, 1.25],
          [7.806536, 53.691243, 1.0],
          [7.806648, 53.691249, 1.0],
          [7.806927, 53.691259, 1.0],
          [7.807536, 53.691282, 0.75],
          [7.807997, 53.691283, 0.5],
          [7.808187, 53.691282, 0.5],
          [7.808446, 53.691271, 0.5],
          [7.808597, 53.691252, 0.5],
          [7.808617, 53.691184, 0.25],
          [7.808694, 53.691132, 0.25],
          [7.808806, 53.691112, 0.25],
          [7.808895, 53.691122, 0.25],
          [7.808968, 53.691153, 0.25],
          [7.809014, 53.691199, 0.25],
          [7.809023, 53.691253, 0.5],
          [7.809166, 53.691268, 0.5],
          [7.809583, 53.691291, 0.75],
          [7.809893, 53.691279, 0.75],
          [7.810989, 53.691164, 0.75],
          [7.814124, 53.690837, 0.75],
          [7.815896, 53.690642, 0.0],
          [7.816203, 53.690615, 0.0],
          [7.816497, 53.690602, 0.0],
          [7.816858, 53.690613, 0.25],
          [7.817115, 53.690639, 0.0],
          [7.817582, 53.690741, 0.0],
          [7.817584, 53.690801, 0.0],
          [7.818625, 53.691037, -0.25],
          [7.819211, 53.691156, -0.25],
          [7.819412, 53.691185, 0.0],
          [7.819620, 53.691204, 0.0],
          [7.819834, 53.691211, 0.25],
          [7.820109, 53.691198, 0.25],
          [7.820525, 53.691157, 0.25],
          [7.821133, 53.691092, 0.25],
          [7.821409, 53.691101, 0.5],
          [7.821739, 53.691069, 0.5],
          [7.822037, 53.691030, 0.75],
          [7.824021, 53.690859, 0.5],
          [7.822037, 53.691030, 0.75],
          [7.821739, 53.691069, 0.5],
          [7.821409, 53.691101, 0.5],
          [7.821133, 53.691092, 0.25],
          [7.820525, 53.691157, 0.25],
          [7.820109, 53.691198, 0.25],
          [7.819834, 53.691211, 0.25],
          [7.819620, 53.691204, 0.0],
          [7.819412, 53.691185, 0.0],
          [7.819211, 53.691156, -0.25],
          [7.818625, 53.691037, -0.25],
          [7.817584, 53.690801, 0.0],
          [7.817582, 53.690741, 0.0],
          [7.817115, 53.690639, 0.0],
          [7.817315, 53.690424, 0.25],
          [7.817397, 53.690309, 0.5],
          [7.817472, 53.690183, 0.75],
          [7.817556, 53.690057, 0.75],
          [7.817638, 53.689954, 0.75],
          [7.817717, 53.689880, 0.5],
          [7.817990, 53.689671, 0.0],
          [7.818156, 53.689515, -0.25],
          [7.818574, 53.688912, -1.25],
          [7.819556, 53.687469, -1.25],
          [7.821772, 53.684218, -1.75],
          [7.822035, 53.683836, -1.5],
          [7.822122, 53.683734, -1.25],
          [7.822323, 53.683692, -1.25],
          [7.823593, 53.683776, -2.0],
          [7.824822, 53.683889, -1.5],
          [7.824944, 53.683885, -1.5],
          [7.825039, 53.683865, -1.5],
          [7.825151, 53.683790, -1.5],
          [7.825322, 53.683501, -1.0],
          [7.825064, 53.681527, -1.75],
          [7.825084, 53.681255, -1.5],
          [7.825085, 53.681228, -1.25],
          [7.825110, 53.681024, -1.0],
          [7.825349, 53.679997, -2.0],
          [7.826598, 53.679618, -1.0],
          [7.828942, 53.675965, -2.0],
          [7.828998, 53.675876, -2.0],
          [7.829439, 53.675198, -2.0],
          [7.833002, 53.669641, -0.75],
          [7.833229, 53.669346, -0.25],
          [7.833155, 53.669274, 0.0],
          [7.833046, 53.669228, 0.0],
          [7.832921, 53.669212, 0.0],
          [7.830273, 53.669150, 0.0],
          [7.830246, 53.669074, 0.0],
          [7.830235, 53.668967, -0.25],
          [7.830220, 53.667917, -2.0],
          [7.830215, 53.666190, -1.25],
          [7.830210, 53.663905, -0.5],
          [7.830203, 53.663451, 0.0],
          [7.830114, 53.663406, 0.0],
          [7.830202, 53.663316, 0.0],
          [7.830227, 53.663198, -0.25],
          [7.830217, 53.659872, -1.75],
          [7.831123, 53.659935, -1.5],
          [7.831158, 53.659837, -1.25],
          [7.831789, 53.657483, -1.75],
          [7.832464, 53.655303, -1.5],
          [7.833837, 53.650943, -1.0],
          [7.834023, 53.650202, 0.0],
          [7.833403, 53.650028, 0.75],
          [7.834643, 53.649448, -0.75],
          [7.834791, 53.649407, -0.75],
          [7.835461, 53.649390, -0.5],
          [7.837150, 53.649598, 0.0],
          [7.838287, 53.649660, -0.5],
          [7.839702, 53.649923, -0.25],
          [7.840796, 53.650093, 0.0],
          [7.842100, 53.650296, 0.5],
          [7.843484, 53.650395, 0.25],
          [7.844252, 53.650450, 0.0],
          [7.847415, 53.650732, -1.0],
          [7.847799, 53.650832, -1.0],
          [7.849934, 53.652237, 0.0],
          [7.850443, 53.652619, 0.0],
          [7.853447, 53.651019, -0.75],
          [7.854059, 53.650694, -1.0],
          [7.857060, 53.649103, -1.75],
          [7.858385, 53.648521, -1.75],
          [7.861975, 53.646991, -0.25],
          [7.862122, 53.647265, -0.5],
          [7.863210, 53.646945, 0.0],
          [7.866058, 53.646048, -1.0],
          [7.866367, 53.646020, -1.25],
          [7.866719, 53.646030, -1.75],
          [7.866936, 53.645992, -1.75],
          [7.867136, 53.645907, -1.75],
          [7.867983, 53.645211, -1.5],
          [7.868266, 53.645080, -1.25],
          [7.868616, 53.645008, -1.0],
          [7.868908, 53.645028, -1.0],
          [7.869361, 53.645200, -1.25],
          [7.870414, 53.645679, -1.75],
          [7.871062, 53.646044, -1.75],
          [7.871775, 53.646581, -1.0],
          [7.872249, 53.646818, -0.75],
          [7.872422, 53.646877, -0.5],
          [7.872392, 53.647134, 0.0],
          [7.872422, 53.647526, 0.5],
          [7.872575, 53.647897, 0.75],
          [7.872803, 53.648203, 0.75],
          [7.872941, 53.648293, 1.0],
          [7.873944, 53.648725, 0.0],
          [7.874227, 53.648770, 0.0],
          [7.874524, 53.648677, 0.25],
          [7.874864, 53.648572, 0.75],
          [7.875160, 53.648393, 1.5],
          [7.875344, 53.648273, 1.5],
          [7.875866, 53.648022, 1.25],
          [7.875882, 53.647939, 1.25],
          [7.875896, 53.647864, 1.25],
          [7.875842, 53.647776, 1.5],
          [7.875737, 53.647607, 1.75],
          [7.875670, 53.647497, 2.0],
          [7.875684, 53.647208, 1.25],
          [7.875673, 53.647091, 1.0],
          [7.875514, 53.646860, 0.75],
          [7.875495, 53.646722, 0.5],
          [7.875953, 53.646537, -0.5],
          [7.877207, 53.645949, -2.75],
          [7.877898, 53.645602, -2.5],
          [7.878144, 53.645446, -2.5],
          [7.878359, 53.645331, -2.25],
          [7.878634, 53.645232, -2.25],
          [7.878858, 53.645152, -2.0],
          [7.880790, 53.644642, -2.0],
          [7.882459, 53.644122, -1.75],
          [7.882927, 53.643968, -2.0],
          [7.883335, 53.643793, -2.25],
          [7.884286, 53.643278, -2.75],
          [7.884449, 53.643212, -2.5],
          [7.884616, 53.643145, -2.25],
          [7.885670, 53.642876, -2.0],
          [7.886393, 53.642620, -2.0],
          [7.888345, 53.641954, -2.0],
          [7.888069, 53.641597, -1.75],
          [7.887821, 53.641253, -1.75],
          [7.886947, 53.639986, -0.75],
          [7.886728, 53.639685, -0.5],
          [7.886264, 53.638981, 0.0],
          [7.885528, 53.637940, 1.0],
          [7.885465, 53.637852, 1.0],
          [7.885454, 53.637836, 1.0],
          [7.885442, 53.637817, 1.0],
          [7.885273, 53.637573, 1.0],
          [7.883757, 53.635362, -1.5],
          [7.883512, 53.634993, -2.0],
          [7.883480, 53.634951, -2.0],
          [7.882855, 53.634021, -1.75],
          [7.881051, 53.631435, -1.5],
          [7.880166, 53.630109, -1.5],
          [7.879321, 53.628867, -2.75],
          [7.877746, 53.626652, -2.0],
          [7.877371, 53.625957, -2.0],
          [7.876200, 53.623725, -1.5],
          [7.874452, 53.620439, -1.0],
          [7.873903, 53.619371, 0.75],
          [7.873205, 53.619140, 0.75],
          [7.873058, 53.619027, 0.25],
          [7.872959, 53.618929, 0.0],
          [7.872824, 53.618844, -0.25],
          [7.871459, 53.618443, -1.75],
          [7.870661, 53.617958, -2.25],
          [7.870206, 53.617657, -2.75],
          [7.869516, 53.617025, -3.0],
          [7.868949, 53.616575, -2.75],
          [7.868844, 53.616430, -2.25],
          [7.868738, 53.616058, -1.5],
          [7.868626, 53.615879, -1.0],
          [7.868506, 53.615844, -1.0],
          [7.868348, 53.615825, -1.0],
          [7.868060, 53.615827, -0.5],
          [7.867744, 53.615845, -0.25],
          [7.867434, 53.615890, 0.0],
          [7.867219, 53.615911, 0.0],
          [7.867065, 53.615903, 0.0],
          [7.866468, 53.615792, -0.25],
          [7.866393, 53.615789, -0.25],
          [7.866427, 53.615718, -0.25],
          [7.866421, 53.615688, -0.5],
          [7.866403, 53.615587, -0.5],
          [7.867004, 53.614173, -2.0],
          [7.867179, 53.613736, -1.25],
          [7.867177, 53.613681, -1.25],
          [7.867985, 53.611973, -2.25],
          [7.868727, 53.610315, -2.25],
          [7.868806, 53.610104, -2.0],
          [7.868846, 53.610060, -2.0],
          [7.868883, 53.610033, -2.0],
          [7.868928, 53.610013, -2.0],
          [7.868964, 53.609784, -2.25],
          [7.868954, 53.608907, -2.5],
          [7.868944, 53.607404, -3.0],
          [7.868937, 53.606706, -2.5],
          [7.868932, 53.606053, -2.25],
          [7.868929, 53.605723, -1.75],
          [7.868961, 53.604505, -1.5],
          [7.868984, 53.604356, -1.75],
          [7.869016, 53.604148, -2.0],
          [7.869096, 53.603799, -2.0],
          [7.869289, 53.603113, -2.25],
          [7.869514, 53.602418, -2.75],
          [7.869694, 53.601801, -2.25],
          [7.869750, 53.601456, -2.25],
          [7.869758, 53.601216, -2.25],
          [7.869762, 53.601128, -2.25],
          [7.869737, 53.600775, -2.0],
          [7.869664, 53.600421, -1.75],
          [7.869460, 53.599916, -1.5],
          [7.869344, 53.599693, -1.5],
          [7.868761, 53.598496, -2.0],
          [7.868302, 53.597585, -0.25],
          [7.868189, 53.597258, 0.0],
          [7.868140, 53.597059, 0.0],
          [7.868099, 53.596643, -0.25],
          [7.868078, 53.596466, -0.25],
          [7.868080, 53.596401, -0.25],
          [7.868084, 53.596266, -0.25],
          [7.868125, 53.596067, -0.25],
          [7.868254, 53.595661, -0.25],
          [7.868355, 53.595447, -0.75],
          [7.868462, 53.595219, -1.25],
          [7.868712, 53.594891, -2.0],
          [7.868870, 53.594707, -2.25],
          [7.869957, 53.593620, -2.0],
          [7.870302, 53.593296, -1.75],
          [7.870464, 53.593143, -1.75],
          [7.871435, 53.592222, -0.75],
          [7.871653, 53.592015, -1.0],
          [7.872505, 53.591142, -1.25],
          [7.872878, 53.590768, -0.5],
          [7.872977, 53.590680, -0.5],
          [7.873590, 53.590145, -1.5],
          [7.873773, 53.589987, -2.0],
          [7.874424, 53.589375, -2.0],
          [7.874545, 53.589249, -2.0],
          [7.874825, 53.588957, -1.75],
          [7.875109, 53.588586, -1.25],
          [7.875175, 53.588481, -1.0],
          [7.875469, 53.588013, -1.75],
          [7.875987, 53.587093, -2.5],
          [7.876486, 53.586237, -2.0],
          [7.876681, 53.585915, -2.0],
          [7.876864, 53.585546, -2.0],
          [7.877134, 53.585002, -2.0],
          [7.877259, 53.584655, -1.5],
          [7.877361, 53.584305, -1.0],
          [7.877435, 53.583951, -1.0],
          [7.877637, 53.583339, -0.75],
          [7.877956, 53.582663, -0.25],
          [7.878130, 53.582344, -0.25],
          [7.878325, 53.582026, 0.0],
          [7.878515, 53.581684, 0.0],
          [7.878574, 53.581520, -0.25],
          [7.878614, 53.581459, -0.5],
          [7.878660, 53.581412, -0.5],
          [7.878737, 53.581373, -0.5],
          [7.878801, 53.581324, -0.5],
          [7.878975, 53.581127, -0.75],
          [7.879112, 53.580959, -0.75],
          [7.879267, 53.580797, -1.0],
          [7.879789, 53.580285, -2.0],
          [7.880239, 53.579692, -2.0],
          [7.880593, 53.579118, -2.0],
          [7.880948, 53.578514, -1.75],
          [7.880998, 53.578392, -1.75],
          [7.880997, 53.578144, -1.5],
          [7.881010, 53.578016, -1.25],
          [7.881120, 53.577941, -1.0],
          [7.881253, 53.577931, -1.0],
          [7.881512, 53.577880, -0.5],
          [7.881546, 53.577866, -0.5],
          [7.881679, 53.577808, -0.25],
          [7.881872, 53.577757, -0.25],
          [7.882017, 53.577741, -0.25],
          [7.882150, 53.577722, -0.25],
          [7.883959, 53.577463, 1.5],
          [7.885560, 53.577208, 1.75],
          [7.885909, 53.577146, 1.25],
          [7.886468, 53.577012, 0.75],
          [7.886649, 53.576950, 0.5],
          [7.887334, 53.576640, 1.0],
          [7.887540, 53.576543, 1.0],
          [7.888119, 53.576221, 1.75],
          [7.888201, 53.576158, 2.0],
          [7.888419, 53.576110, 2.25],
          [7.889033, 53.575805, 3.0],
          [7.889512, 53.575630, 3.75],
          [7.891023, 53.575228, 5.25],
          [7.891957, 53.574979, 6.0],
          [7.892276, 53.574916, 6.0],
          [7.892678, 53.574817, 5.75],
          [7.894306, 53.574418, 6.0],
          [7.895065, 53.574260, 7.0],
          [7.895511, 53.574179, 7.5],
          [7.896214, 53.574069, 8.0],
          [7.896334, 53.574051, 8.25],
          [7.896455, 53.574068, 8.5],
          [7.896622, 53.574074, 8.75],
          [7.896950, 53.574157, 8.75],
          [7.897190, 53.574268, 8.75],
          [7.897298, 53.574334, 8.5],
          [7.897488, 53.574439, 8.25],
          [7.898305, 53.574886, 7.25],
          [7.899054, 53.575279, 7.5],
          [7.899236, 53.575323, 7.5],
          [7.899405, 53.575380, 7.75],
          [7.899608, 53.575422, 8.25],
          [7.899769, 53.575433, 8.5],
          [7.899878, 53.575432, 8.5],
          [7.900009, 53.575449, 8.75],
          [7.900098, 53.575467, 8.75],
          [7.900172, 53.575498, 8.75],
          [7.900263, 53.575525, 8.75],
          [7.900553, 53.575531, 9.0],
          [7.900673, 53.575524, 9.25],
          [7.900859, 53.575504, 9.25],
          [7.900999, 53.575482, 9.5],
          [7.901298, 53.575409, 10.0],
          [7.901509, 53.575334, 10.0],
          [7.901790, 53.575193, 10.0],
          [7.902216, 53.574969, 9.25],
          [7.902397, 53.574855, 9.25],
          [7.902493, 53.574779, 9.5],
          [7.902687, 53.574614, 9.5],
          [7.902876, 53.574397, 9.75],
          [7.903459, 53.573706, 10.25],
          [7.903616, 53.573525, 10.5],
          [7.903684, 53.573462, 10.75],
          [7.903765, 53.573404, 10.75],
          [7.903909, 53.573345, 10.75],
          [7.904121, 53.573274, 11.0],
          [7.904296, 53.573216, 11.0],
          [7.904442, 53.573175, 11.0],
          [7.904545, 53.573157, 10.75],
          [7.904702, 53.573116, 10.75],
          [7.904826, 53.573072, 10.75],
          [7.904857, 53.573059, 10.75],
          [7.905376, 53.572559, 10.0],
          [7.904857, 53.573059, 10.75],
          [7.904826, 53.573072, 10.75],
          [7.904702, 53.573116, 10.75],
          [7.904545, 53.573157, 10.75],
          [7.904593, 53.573231, 10.5],
          [7.904644, 53.573299, 10.5],
          [7.904727, 53.573278, 10.25],
          [7.904834, 53.573246, 10.25],
          [7.904971, 53.573188, 10.25],
          [7.905018, 53.573162, 10.25],
          [7.905069, 53.573126, 10.25],
          [7.905360, 53.572879, 10.0],
          [7.905674, 53.572612, 10.0],
          [7.906355, 53.572862, 7.75],
          [7.906647, 53.572983, 6.75],
          [7.906763, 53.573055, 6.5],
          [7.906805, 53.573161, 6.0],
          [7.906785, 53.573200, 6.0],
          [7.906752, 53.573267, 6.0],
          [7.906522, 53.573657, 5.5],
          [7.906467, 53.573740, 5.5],
          [7.906399, 53.573848, 5.25],
          [7.906208, 53.574173, 5.0],
          [7.906162, 53.574265, 5.0],
          [7.906124, 53.574427, 4.75],
          [7.906601, 53.574497, 3.5],
          [7.907287, 53.574673, 3.0],
          [7.907997, 53.575067, 2.25],
          [7.908464, 53.575200, 1.5],
          [7.908868, 53.575448, 1.0],
          [7.909205, 53.575656, 0.75],
          [7.909284, 53.575785, 0.75],
          [7.909484, 53.575722, 0.75],
          [7.910411, 53.575631, 0.5],
          [7.910413, 53.575622, 0.25],
          [7.910411, 53.575631, 0.5],
          [7.909484, 53.575722, 0.75],
          [7.909284, 53.575785, 0.75],
          [7.909205, 53.575656, 0.75],
          [7.908868, 53.575448, 1.0],
          [7.908464, 53.575200, 1.5],
          [7.907997, 53.575067, 2.25],
          [7.907287, 53.574673, 3.0],
          [7.906601, 53.574497, 3.5],
          [7.906124, 53.574427, 4.75],
          [7.906162, 53.574265, 5.0],
          [7.904817, 53.573677, 9.0],
          [7.904725, 53.573661, 9.25],
          [7.904711, 53.573658, 9.25],
          [7.904343, 53.573544, 10.0],
          [7.904319, 53.573537, 10.25],
          [7.904351, 53.573497, 10.25],
          [7.904260, 53.573417, 10.5],
          [7.904200, 53.573375, 10.75],
          [7.904166, 53.573332, 11.0],
          [7.904121, 53.573274, 11.0],
          [7.904296, 53.573216, 11.0],
          [7.904442, 53.573175, 11.0],
          [7.904545, 53.573157, 10.75],
          [7.904702, 53.573116, 10.75],
          [7.904826, 53.573072, 10.75],
          [7.904857, 53.573059, 10.75],
          [7.905841, 53.572113, 9.75],
          [7.906304, 53.571627, 8.75],
          [7.906770, 53.571159, 7.25],
          [7.907078, 53.570851, 6.5],
          [7.907099, 53.570830, 6.25],
          [7.907232, 53.570697, 6.0],
          [7.909003, 53.568642, 5.5],
          [7.909711, 53.567805, 4.5],
          [7.909860, 53.567685, 4.25],
          [7.909958, 53.567616, 4.25],
          [7.910235, 53.567522, 4.0],
          [7.910979, 53.567232, 3.5],
          [7.911493, 53.566991, 3.0],
          [7.911849, 53.566739, 2.75],
          [7.912097, 53.566472, 2.0],
          [7.912307, 53.566155, 1.25],
          [7.912904, 53.565045, 0.5],
          [7.912947, 53.564927, 0.25],
          [7.912950, 53.564856, 0.25],
          [7.912966, 53.564810, 0.0],
          [7.912996, 53.564762, 0.0],
          [7.913043, 53.564723, 0.0],
          [7.913450, 53.564049, -1.0],
          [7.913702, 53.563568, -1.25],
          [7.913762, 53.563442, -1.25],
          [7.913774, 53.563415, -1.25],
          [7.913826, 53.563304, -1.25],
          [7.913847, 53.563233, -1.25],
          [7.913801, 53.563180, -1.25],
          [7.913782, 53.563145, -1.25],
          [7.913795, 53.563090, -1.25],
          [7.913834, 53.563031, -1.25],
          [7.913885, 53.563001, -1.25],
          [7.913957, 53.562979, -1.25],
          [7.914012, 53.562912, -1.0],
          [7.914292, 53.562356, -0.75],
          [7.914296, 53.562291, -0.75],
          [7.914319, 53.562266, -0.75],
          [7.914384, 53.562213, -0.5],
          [7.914500, 53.562037, -0.25],
          [7.914544, 53.561978, -0.25],
          [7.915227, 53.561245, 1.25],
          [7.915311, 53.561091, 1.25],
          [7.915394, 53.561027, 1.5],
          [7.915479, 53.560962, 1.5],
          [7.915519, 53.560930, 1.5],
          [7.915570, 53.560892, 1.5],
          [7.915534, 53.560879, 1.5],
          [7.915513, 53.560863, 1.5],
          [7.915393, 53.560666, 1.25],
          [7.915362, 53.560579, 1.25],
          [7.915344, 53.560474, 1.0],
          [7.915339, 53.560416, 1.0],
          [7.915359, 53.560241, 1.0],
          [7.915407, 53.560112, 1.0],
          [7.915933, 53.558977, -1.0],
          [7.916109, 53.558740, -1.0],
          [7.916361, 53.558192, -1.0],
          [7.916368, 53.558052, -1.0],
          [7.917304, 53.555937, -2.75],
          [7.917440, 53.555780, -2.75],
          [7.917452, 53.555752, -2.75],
          [7.917446, 53.555721, -2.75],
          [7.917427, 53.555655, -2.75],
          [7.918739, 53.552883, 0.0],
          [7.918868, 53.552570, 0.0],
          [7.918962, 53.552057, 1.0],
          [7.918996, 53.551336, 2.0],
          [7.919009, 53.551244, 2.0],
          [7.919085, 53.550897, 2.0],
          [7.919287, 53.550320, 2.0],
          [7.919379, 53.550138, 2.25],
          [7.919529, 53.549973, 2.75],
          [7.919686, 53.549698, 3.25],
          [7.919860, 53.549467, 4.0],
          [7.920195, 53.549024, 4.25],
          [7.920502, 53.548665, 3.25],
          [7.920574, 53.548538, 3.0],
          [7.920591, 53.548510, 3.0],
          [7.920694, 53.548403, 3.0],
          [7.920837, 53.548258, 3.0],
          [7.920845, 53.548263, 3.0],
          [7.920974, 53.548279, 3.0],
          [7.921937, 53.548116, 3.25],
          [7.922464, 53.548013, 3.25],
          [7.923336, 53.547814, 4.0],
          [7.924884, 53.547480, 4.0],
          [7.925996, 53.547229, 3.75],
          [7.926913, 53.547010, 3.25],
          [7.927340, 53.546945, 2.75],
          [7.928411, 53.546703, 1.75],
          [7.929270, 53.546485, 2.0],
          [7.929601, 53.546412, 1.75],
          [7.929751, 53.546392, 1.5],
          [7.930915, 53.546113, 1.5],
          [7.931490, 53.545982, 1.75],
          [7.932481, 53.545757, 2.0],
          [7.933602, 53.545502, 3.0],
          [7.933989, 53.545414, 3.0],
          [7.934292, 53.545348, 3.0],
          [7.934701, 53.545258, 3.0],
          [7.935045, 53.545183, 2.75],
          [7.935768, 53.545025, 2.75],
          [7.936736, 53.544815, 2.0],
          [7.938052, 53.544523, 2.5],
          [7.940147, 53.544080, 3.0],
          [7.941235, 53.543843, 3.25],
          [7.943075, 53.543433, 4.5],
          [7.943453, 53.543359, 5.0],
          [7.943727, 53.543272, 4.75],
          [7.943856, 53.543245, 4.75],
          [7.944394, 53.543004, 3.75],
          [7.944485, 53.543023, 3.75],
          [7.944614, 53.543073, 3.75],
          [7.944705, 53.543087, 3.75],
          [7.944762, 53.543078, 3.5],
          [7.944980, 53.543032, 3.25],
          [7.945520, 53.542892, 3.25],
          [7.945686, 53.542822, 3.25],
          [7.945940, 53.542766, 3.25],
          [7.946207, 53.542712, 3.75],
          [7.946396, 53.542667, 4.25],
          [7.946930, 53.542549, 4.75],
          [7.946962, 53.542466, 4.75],
          [7.946974, 53.542373, 4.75],
          [7.946971, 53.542207, 4.5],
          [7.947027, 53.542111, 4.5],
          [7.947205, 53.542003, 4.25],
          [7.948582, 53.541427, 4.25],
          [7.948596, 53.541412, 4.25],
          [7.948517, 53.541342, 4.25],
          [7.948466, 53.541288, 4.25],
          [7.948437, 53.541256, 4.25],
          [7.948616, 53.541189, 4.5],
          [7.948643, 53.541172, 4.5],
          [7.948671, 53.541141, 4.5],
          [7.948676, 53.541116, 4.5],
          [7.948515, 53.540840, 4.75],
          [7.948415, 53.540657, 4.75],
          [7.948322, 53.540041, 4.0],
          [7.948153, 53.539120, 3.25],
          [7.948146, 53.539079, 3.25],
          [7.948043, 53.538567, 3.5],
          [7.947898, 53.537988, 3.5],
          [7.947772, 53.537485, 3.75],
          [7.947739, 53.537237, 3.75],
          [7.947668, 53.536695, 3.0],
          [7.947705, 53.536476, 3.25],
          [7.947828, 53.535555, 4.75],
          [7.947882, 53.534825, 5.5],
          [7.947874, 53.534431, 5.5],
          [7.947865, 53.534355, 5.5],
          [7.947851, 53.534243, 5.5],
          [7.947897, 53.534237, 5.5],
          [7.947732, 53.533516, 4.5],
          [7.947185, 53.531213, 4.25],
          [7.947116, 53.530573, 4.0],
          [7.947106, 53.530392, 4.0],
          [7.947159, 53.530114, 4.0],
          [7.947379, 53.528846, 6.25],
          [7.947469, 53.528528, 6.75],
          [7.947484, 53.528475, 6.75],
          [7.947499, 53.528421, 6.75],
          [7.947481, 53.528364, 6.75],
          [7.947443, 53.528249, 6.75],
          [7.947481, 53.528364, 6.75],
          [7.947413, 53.528357, 7.0],
          [7.946588, 53.528242, 7.75],
          [7.946210, 53.528120, 7.25],
          [7.945849, 53.527894, 6.5],
          [7.945673, 53.527808, 6.0],
          [7.945402, 53.527753, 5.25],
          [7.944822, 53.527673, 4.0],
          [7.944890, 53.527495, 3.75],
          [7.944724, 53.527467, 3.5],
          [7.944890, 53.527495, 3.75],
          [7.944920, 53.527411, 3.75],
          [7.944955, 53.527326, 3.75],
          [7.944987, 53.527243, 3.75],
          [7.945029, 53.527246, 4.0],
          [7.945366, 53.526348, 3.5],
          [7.945714, 53.525149, 3.0],
          [7.945700, 53.524362, 0.5],
          [7.945729, 53.523994, 0.0],
          [7.945825, 53.523701, -0.5],
          [7.945944, 53.523459, -0.75],
          [7.946386, 53.522801, -1.25],
          [7.946522, 53.522616, -1.25],
          [7.946808, 53.522274, -1.25],
          [7.947169, 53.521925, -1.75],
          [7.947871, 53.521376, -2.0],
          [7.948437, 53.520967, -1.25],
          [7.948961, 53.520576, -1.25],
          [7.949185, 53.520382, -1.5],
          [7.949317, 53.520124, -1.75],
          [7.950511, 53.516464, -3.0],
          [7.950640, 53.516146, -3.0],
          [7.950764, 53.515923, -3.0],
          [7.950875, 53.515756, -2.75],
          [7.950850, 53.515712, -2.75],
          [7.950954, 53.515573, -2.5],
          [7.951205, 53.515321, -2.25],
          [7.951503, 53.515050, -2.0],
          [7.952016, 53.514696, -2.0],
          [7.952889, 53.514070, -1.75],
          [7.953378, 53.513722, -0.75],
          [7.954189, 53.513111, -1.0],
          [7.956827, 53.511158, -2.0],
          [7.959683, 53.509026, -0.75],
          [7.959851, 53.508866, -0.5],
          [7.959868, 53.508831, -0.5],
          [7.959884, 53.508796, -0.5],
          [7.960012, 53.508685, -0.25],
          [7.960149, 53.508582, -0.25],
          [7.960352, 53.508480, 0.0],
          [7.960575, 53.508311, 0.0],
          [7.960833, 53.508160, -0.25],
          [7.961985, 53.507310, -1.0],
          [7.964779, 53.505225, -0.5],
          [7.965599, 53.504601, -1.0],
          [7.966505, 53.503909, -0.75],
          [7.966567, 53.503819, -0.75],
          [7.966549, 53.503741, -0.75],
          [7.966531, 53.503666, -0.75],
          [7.966563, 53.503490, -0.75],
          [7.966524, 53.503395, -0.75],
          [7.966547, 53.503287, -0.75],
          [7.966557, 53.503228, -0.75],
          [7.966587, 53.503060, -0.75],
          [7.966619, 53.503036, -0.75],
          [7.966645, 53.502998, -0.75],
          [7.966653, 53.502796, -1.0],
          [7.966624, 53.502641, -1.0],
          [7.966509, 53.502272, -1.0],
          [7.966301, 53.501045, -0.25],
          [7.966158, 53.500218, 0.25],
          [7.966077, 53.499741, 0.5],
          [7.965971, 53.499499, 0.75],
          [7.965773, 53.499326, 1.0],
          [7.965505, 53.499159, 1.0],
          [7.965296, 53.498937, 1.0],
          [7.965189, 53.498729, 1.25],
          [7.965154, 53.498608, 1.5],
          [7.965173, 53.498450, 1.5],
          [7.965464, 53.497810, 0.5],
          [7.965765, 53.497141, 0.0],
          [7.965894, 53.496776, 0.0],
          [7.965543, 53.495466, 0.25],
          [7.965441, 53.494908, 0.75],
          [7.965501, 53.494749, 0.5],
          [7.965436, 53.494738, 0.5],
          [7.965288, 53.494711, 0.5],
          [7.964990, 53.494631, 0.5],
          [7.964894, 53.494605, 0.25],
          [7.964739, 53.494593, 0.0],
          [7.964047, 53.494650, -0.5],
          [7.963277, 53.494775, -1.25]
        ]
      }
    }
  ]
}

let day21: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "creator": "BRouter-1.1",
        "name": "j21 - Sande - Wremen - 79.8km",
        "track-length": "79751",
        "filtered ascend": "81",
        "plain-ascend": "32",
        "total-time": "14937",
        "total-energy": "1248632",
        "cost": "118273",
        "messages": [
          ["Longitude", "Latitude", "Elevation", "Distance", "CostPerKm", "ElevCost", "TurnCost", "NodeCost", "InitialCost", "WayTags", "NodeTags", "Time", "Energy"],
          ["7965501", "53494749", "0", "154", "1150", "0", "7", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "20", "2030"],
          ["7969174", "53489403", "1", "660", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path tracktype=grade1 surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "121", "12149"],
          ["7973111", "53490041", "0", "11", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes", "", "123", "12360"],
          ["7969174", "53489403", "1", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_ncn=yes", "", "124", "12466"],
          ["7974376", "53479504", "0", "1368", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path tracktype=grade1 surface=asphalt foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "345", "34537"],
          ["7974446", "53479437", "0", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path tracktype=grade1 surface=asphalt foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "346", "34692"],
          ["7974130", "53479359", "0", "13", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "349", "34914"],
          ["7974446", "53479437", "0", "13", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "350", "35037"],
          ["7976969", "53479938", "0", "181", "1000", "0", "0", "0", "0", "highway=path tracktype=grade1 surface=asphalt foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "374", "37442"],
          ["7981187", "53479367", "0", "300", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "421", "42193"],
          ["7984757", "53478334", "1", "266", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "471", "47185"],
          ["7984971", "53478264", "2", "17", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "475", "47510"],
          ["7988164", "53476610", "0", "285", "1150", "0", "1", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "highway=bus_stop", "510", "51051"],
          ["7989776", "53475879", "1", "140", "1150", "0", "4", "0", "0", "reversedirection=yes highway=residential surface=asphalt", "", "534", "53428"],
          ["7990572", "53476050", "1", "58", "1000", "0", "0", "0", "0", "highway=residential route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "544", "54429"],
          ["7995241", "53477104", "0", "336", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "588", "58891"],
          ["8006405", "53475915", "0", "792", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "714", "71441"],
          ["8016801", "53474555", "0", "729", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "830", "83105"],
          ["8029026", "53471158", "0", "933", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "982", "98309"],
          ["8029841", "53470995", "0", "58", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "991", "99198"],
          ["8029969", "53470980", "0", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path route_bicycle_rcn=yes", "", "993", "99340"],
          ["8029655", "53469863", "0", "128", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes", "", "1012", "101293"],
          ["8034197", "53470224", "0", "305", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1062", "106250"],
          ["8034261", "53470229", "0", "5", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "1063", "106337"],
          ["8034766", "53470276", "0", "35", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "1070", "107016"],
          ["8046406", "53471109", "0", "786", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_rcn=yes", "", "1191", "119128"],
          ["8057344", "53462947", "-1", "1529", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_icn=yes route_bicycle_ncn=yes", "", "1420", "142052"],
          ["8053268", "53461686", "-1", "9", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_rcn=yes", "", "1421", "142198"],
          ["8057344", "53462947", "-1", "9", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "1422", "142282"],
          ["8062343", "53464480", "0", "374", "1000", "0", "0", "0", "0", "reversedirection=yes highway=track tracktype=grade1 surface=concrete foot=yes bicycle=yes route_bicycle_rcn=yes", "", "1479", "147969"],
          ["8062359", "53464606", "0", "5", "1050", "0", "43", "0", "0", "reversedirection=yes highway=path surface=concrete foot=yes bicycle=yes", "", "1480", "148046"],
          ["8062343", "53464480", "0", "5", "1050", "0", "0", "0", "0", "highway=path surface=concrete foot=yes bicycle=yes", "", "1480", "148092"],
          ["8076903", "53449990", "0", "1890", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=designated bicycle=designated oneway=no smoothness=good route_bicycle_rcn=yes", "", "1791", "179122"],
          ["8080516", "53448323", "1", "308", "1050", "0", "11", "0", "0", "highway=path surface=concrete foot=yes bicycle=yes", "", "1836", "183658"],
          ["8090731", "53442317", "2", "956", "1050", "0", "1", "0", "0", "reversedirection=yes highway=path surface=concrete access=no foot=designated bicycle=designated", "", "1997", "199768"],
          ["8091555", "53441422", "2", "66", "1050", "0", "3", "0", "0", "highway=path surface=concrete foot=yes bicycle=yes", "", "2009", "200948"],
          ["8090731", "53442317", "2", "66", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=yes bicycle=yes", "", "2015", "201612"],
          ["8102800", "53444804", "1", "926", "1050", "0", "201", "0", "0", "reversedirection=yes highway=path surface=concrete access=no foot=designated bicycle=designated", "", "2160", "216079"],
          ["8104773", "53445036", "1", "135", "1050", "0", "3", "0", "0", "highway=path surface=concrete foot=yes", "", "2177", "217792"],
          ["8105199", "53445167", "0", "32", "1050", "0", "3", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated", "", "2181", "218151"],
          ["8107231", "53445453", "-1", "141", "1050", "0", "4", "0", "0", "highway=path surface=concrete foot=yes", "", "2198", "219854"],
          ["8104407", "53444581", "0", "45", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=designated bicycle=designated oneway=no smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2205", "220532"],
          ["8107357", "53445460", "-1", "54", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated oneway=no smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2210", "221064"],
          ["8107766", "53445405", "-1", "28", "1000", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated oneway=no smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate foot=yes bicycle=yes", "2213", "221385"],
          ["8109767", "53444429", "3", "210", "1000", "0", "0", "0", "0", "highway=service surface=paving_stones foot=designated bicycle=designated oneway=no smoothness=good route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "2257", "225794"],
          ["8109991", "53445273", "3", "98", "1000", "0", "0", "0", "0", "highway=unclassified surface=cobblestone route_bicycle_icn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=turning_circle", "2278", "227874"],
          ["8110022", "53445389", "3", "14", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated oneway=no route_bicycle_icn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "2281", "228156"],
          ["8110821", "53446496", "4", "136", "1000", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated oneway=no route_bicycle_icn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "2312", "231247"],
          ["8111750", "53446880", "9", "84", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=dirt foot=designated bicycle=designated oneway=no route_bicycle_rcn=yes", "", "2327", "232810"],
          ["8111789", "53447120", "8", "29", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service surface=dirt foot=designated bicycle=designated route_bicycle_rcn=yes", "", "2332", "233286"],
          ["8112363", "53447436", "9", "60", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_rcn=yes", "", "2343", "234409"],
          ["8118081", "53448691", "6", "411", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt route_bicycle_icn=yes route_bicycle_rcn=yes", "", "2395", "239539"],
          ["8118083", "53448794", "5", "12", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_icn=yes route_bicycle_rcn=yes", "", "2397", "239740"],
          ["8119756", "53448963", "5", "115", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=compacted route_bicycle_icn=yes route_bicycle_rcn=yes", "", "2416", "241711"],
          ["8125629", "53450654", "2", "454", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard", "2480", "248031"],
          ["8125776", "53450664", "2", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_rcn=yes", "", "2481", "248207"],
          ["8126803", "53450508", "3", "71", "1000", "0", "0", "0", "0", "reversedirection=yes highway=service route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=cattle_grid foot=yes bicycle=yes", "2497", "249786"],
          ["8131371", "53448973", "0", "351", "1000", "0", "0", "0", "0", "reversedirection=yes highway=track tracktype=grade1 route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate", "2547", "254755"],
          ["8187415", "53410422", "-1", "5932", "1000", "0", "0", "0", "0", "reversedirection=yes highway=track tracktype=grade1 route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3532", "353263"],
          ["8187662", "53409554", "0", "102", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3551", "355172"],
          ["8187741", "53409442", "0", "14", "1000", "0", "0", "0", "0", "highway=residential surface=concrete oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3554", "355472"],
          ["8187898", "53409221", "1", "28", "1000", "0", "0", "0", "0", "highway=residential surface=paving_stones route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3561", "356163"],
          ["8189751", "53407766", "1", "234", "1000", "0", "0", "0", "0", "highway=residential surface=asphalt oneway=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "3601", "360158"],
          ["8193173", "53401246", "0", "764", "1000", "0", "0", "0", "0", "reversedirection=yes highway=construction tracktype=grade1 foot=designated bicycle=designated vehicle=destination route_bicycle_rcn=yes", "", "3721", "372223"],
          ["8207416", "53390391", "-1", "1558", "1000", "0", "0", "0", "0", "reversedirection=yes highway=construction tracktype=grade1 foot=designated bicycle=designated route_bicycle_rcn=yes", "", "3975", "397621"],
          ["8209291", "53390134", "0", "130", "1000", "0", "0", "0", "0", "reversedirection=yes highway=construction access=permissive route_bicycle_rcn=yes", "", "3998", "399900"],
          ["8211165", "53390421", "0", "138", "1000", "0", "0", "0", "0", "reversedirection=yes highway=construction route_bicycle_rcn=yes", "", "4025", "402571"],
          ["8230014", "53390027", "0", "1296", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=paved route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate access=no foot=yes bicycle=yes", "4230", "423108"],
          ["8230999", "53389988", "-1", "66", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=paved route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate access=no foot=yes bicycle=yes", "4241", "424170"],
          ["8260011", "53395035", "0", "2070", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=paved route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate access=no foot=yes bicycle=unknown", "4596", "459643"],
          ["8260462", "53395194", "0", "42", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=paved route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=gate access=no foot=yes bicycle=unknown", "4603", "460360"],
          ["8261053", "53394897", "0", "53", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=paved route_bicycle_rcn=yes", "", "4612", "461258"],
          ["8261138", "53394843", "0", "9", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=paved route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "4613", "461411"],
          ["8258911", "53392892", "0", "37", "1050", "0", "72", "0", "0", "highway=tertiary foot=no bicycle=yes", "", "4619", "461943"],
          ["8261138", "53394843", "0", "37", "1050", "0", "0", "0", "0", "reversedirection=yes highway=tertiary foot=no bicycle=yes", "", "4623", "462343"],
          ["8261281", "53394772", "0", "13", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "4624", "462499"],
          ["8276292", "53407903", "1", "1779", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "4922", "492270"],
          ["8276902", "53408435", "1", "72", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "4935", "493554"],
          ["8277303", "53408784", "1", "48", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "4942", "494303"],
          ["8279459", "53410658", "1", "254", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing", "4985", "498541"],
          ["8296379", "53426294", "0", "2088", "1000", "0", "0", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "5330", "533106"],
          ["8308632", "53425348", "-1", "824", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary surface=asphalt route_bicycle_lcn=yes", "", "5457", "545829"],
          ["8310509", "53425127", "0", "128", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_lcn=yes", "", "5483", "548355"],
          ["8328301", "53434343", "0", "1600", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_lcn=yes", "", "5745", "574607"],
          ["8330033", "53435078", "-1", "142", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "", "5768", "576891"],
          ["8330168", "53435135", "-1", "11", "1350", "0", "0", "0", "0", "highway=service", "", "5770", "577054"],
          ["8340915", "53440153", "0", "920", "1450", "0", "3", "0", "0", "reversedirection=yes highway=tertiary", "", "5922", "592322"],
          ["8342859", "53442704", "-1", "342", "1000", "0", "0", "0", "0", "reversedirection=yes highway=tertiary route_bicycle_lcn=yes", "", "5975", "597613"],
          ["8342775", "53446362", "0", "411", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary route_bicycle_lcn=yes", "", "6049", "605030"],
          ["8343609", "53446365", "0", "14", "5050", "0", "123", "0", "0", "highway=track", "", "6059", "605152"],
          ["8342775", "53446362", "0", "14", "5050", "0", "10", "0", "0", "reversedirection=yes highway=track", "", "6068", "605152"],
          ["8346131", "53456717", "0", "1207", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary route_bicycle_lcn=yes", "", "6264", "624679"],
          ["8346284", "53456729", "0", "11", "1000", "0", "0", "0", "0", "highway=secondary cycleway=track route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6266", "624897"],
          ["8346624", "53457074", "0", "27", "1350", "0", "29", "0", "0", "reversedirection=yes highway=service", "", "6271", "625451"],
          ["8346284", "53456729", "0", "27", "1350", "0", "0", "0", "0", "highway=service", "", "6274", "625706"],
          ["8357808", "53457074", "2", "793", "1000", "0", "0", "0", "0", "highway=secondary cycleway=track route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals crossing=traffic_signals", "6406", "638929"],
          ["8363067", "53457503", "1", "367", "1000", "0", "0", "0", "0", "highway=secondary cycleway=track route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "6467", "645006"],
          ["8362575", "53460209", "2", "312", "1000", "0", "0", "0", "0", "highway=secondary cycleway=track route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "6525", "650820"],
          ["8420827", "53492940", "-1", "5874", "1050", "0", "303", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated lcn=yes", "nodeaccessgranted=yes highway=crossing", "7490", "747379"],
          ["8420189", "53492812", "-1", "18", "1450", "0", "107", "0", "0", "highway=tertiary", "", "7494", "747708"],
          ["8420827", "53492940", "-1", "18", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary", "highway=crossing", "7495", "747873"],
          ["8427484", "53490726", "-1", "522", "1050", "0", "77", "0", "0", "highway=path surface=asphalt foot=designated bicycle=designated lcn=yes", "", "7577", "756056"],
          ["8427498", "53490748", "-1", "3", "1350", "0", "93", "0", "0", "highway=service lcn=yes", "", "7578", "756104"],
          ["8424804", "53491433", "0", "3", "1650", "0", "86", "0", "0", "highway=secondary", "", "7578", "756156"],
          ["8427498", "53490748", "-1", "3", "1650", "0", "0", "0", "0", "reversedirection=yes highway=secondary", "", "7579", "756183"],
          ["8427635", "53490914", "-1", "21", "1350", "0", "85", "0", "0", "highway=service lcn=yes", "", "7580", "756379"],
          ["8428148", "53491516", "-1", "77", "5050", "0", "0", "0", "0", "reversedirection=yes highway=footway foot=yes lcn=yes", "", "7631", "756379"],
          ["8433958", "53487931", "0", "560", "1000", "0", "0", "0", "0", "highway=footway foot=designated bicycle=yes route_bicycle_rcn=yes", "", "7713", "764564"],
          ["8436264", "53486597", "0", "218", "1000", "0", "0", "0", "0", "highway=residential cycleway=lane route_bicycle_rcn=yes", "", "7753", "768493"],
          ["8436229", "53486554", "0", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential route_bicycle_rcn=yes", "", "7754", "768600"],
          ["8437183", "53486139", "0", "80", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=paved cycleway=lane route_bicycle_rcn=yes", "", "7768", "770038"],
          ["8453067", "53481661", "0", "1201", "1000", "0", "0", "0", "0", "highway=cycleway foot=yes route_bicycle_rcn=yes", "", "7960", "789212"],
          ["8453727", "53482030", "0", "66", "1000", "0", "0", "0", "0", "highway=tertiary surface=paved foot=designated bicycle=designated route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals bicycle=yes", "7972", "790385"],
          ["8453886", "53482068", "0", "12", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt route_bicycle_rcn=yes", "", "7973", "790577"],
          ["8470515", "53477830", "0", "1242", "1000", "0", "0", "0", "0", "highway=path foot=designated bicycle=designated route_bicycle_rcn=yes", "", "8172", "810464"],
          ["8475919", "53486418", "2", "1033", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "8350", "828269"],
          ["8478352", "53489267", "1", "359", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track", "", "8405", "833734"],
          ["8481406", "53492696", "0", "437", "1450", "0", "0", "0", "0", "highway=tertiary surface=paved cycleway=track", "highway=bus_stop", "8479", "841152"],
          ["8483037", "53494569", "0", "238", "1450", "0", "0", "0", "0", "highway=tertiary surface=paved cycleway=track", "highway=traffic_signals", "8518", "845047"],
          ["8484187", "53495761", "0", "156", "1450", "0", "0", "0", "0", "highway=tertiary surface=paved cycleway=track", "highway=bus_stop", "8544", "847681"],
          ["8486666", "53498247", "-1", "327", "1450", "0", "1", "0", "0", "highway=tertiary surface=paved cycleway=track", "", "8591", "852370"],
          ["8487816", "53498346", "0", "82", "1450", "0", "7", "0", "0", "reversedirection=yes highway=tertiary surface=paved cycleway=track", "", "8603", "853507"],
          ["8488785", "53498182", "0", "69", "1450", "0", "1", "0", "0", "highway=tertiary surface=paved cycleway=track oneway=yes", "", "8615", "854702"],
          ["8488892", "53498405", "0", "26", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved cycleway=track route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8619", "855154"],
          ["8493865", "53505745", "0", "914", "1000", "0", "0", "0", "0", "highway=tertiary surface=paved cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "8760", "869285"],
          ["8493930", "53505834", "0", "11", "1000", "0", "0", "0", "0", "highway=tertiary surface=paved cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8762", "869470"],
          ["8494290", "53506220", "0", "50", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "8770", "870267"],
          ["8494502", "53506474", "0", "32", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "8775", "870786"],
          ["8495014", "53507037", "0", "73", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "8789", "872102"],
          ["8499136", "53510103", "1", "442", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "8865", "879777"],
          ["8500802", "53511200", "0", "166", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "8891", "882320"],
          ["8501521", "53510872", "0", "11", "5350", "0", "88", "0", "0", "reversedirection=yes highway=service oneway=yes", "", "8898", "882360"],
          ["8500802", "53511200", "0", "11", "1350", "0", "0", "0", "0", "highway=service oneway=yes", "", "8900", "882463"],
          ["8505697", "53514486", "-1", "492", "1000", "0", "0", "0", "0", "highway=tertiary surface=asphalt cycleway=track route=bicycle route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "8972", "889699"],
          ["8506992", "53514178", "0", "94", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "8993", "891840"],
          ["8508104", "53513930", "1", "81", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "9013", "893824"],
          ["8514200", "53515674", "0", "656", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved cycleway=lane route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9123", "904782"],
          ["8516430", "53514610", "2", "192", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9161", "908660"],
          ["8516893", "53514536", "2", "32", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=bus_stop", "9168", "909355"],
          ["8518282", "53514058", "2", "108", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9188", "911355"],
          ["8522472", "53514402", "3", "309", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9246", "917138"],
          ["8522612", "53514489", "2", "14", "1000", "0", "0", "0", "0", "highway=footway surface=unpaved foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "9248", "917359"],
          ["8523313", "53515352", "1", "129", "1000", "0", "0", "0", "0", "highway=footway surface=unpaved foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "9267", "919240"],
          ["8523443", "53515403", "1", "11", "1000", "0", "0", "0", "0", "highway=footway surface=unpaved foot=yes bicycle=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9269", "919395"],
          ["8525362", "53516623", "1", "187", "1000", "0", "0", "0", "0", "highway=residential route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9298", "922294"],
          ["8539372", "53521118", "2", "1199", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes railway=level_crossing", "9497", "942219"],
          ["8539701", "53521360", "2", "37", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9503", "942818"],
          ["8540173", "53521360", "2", "32", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes barrier=unknown", "9508", "943342"],
          ["8542747", "53521516", "3", "176", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=designated bicycle=designated route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9541", "946636"],
          ["8544029", "53520690", "1", "135", "1000", "0", "0", "0", "0", "highway=cycleway surface=paving_stones foot=designated bicycle=designated route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "9562", "948758"],
          ["8545749", "53520570", "0", "142", "1000", "0", "0", "0", "0", "highway=primary route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes wheelchair=yes", "9578", "950331"],
          ["8580633", "53536557", "-1", "2994", "5670", "0", "0", "0", "10000", "foot=yes bicycle=yes route=ferry route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "nodeaccessgranted=yes wheelchair=yes", "11704", "973853"],
          ["8581287", "53536724", "0", "48", "1000", "0", "0", "0", "0", "highway=primary surface=asphalt foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11714", "974895"],
          ["8581483", "53536784", "0", "15", "1000", "0", "0", "0", "0", "highway=primary surface=cobblestone route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes", "", "11717", "975219"],
          ["8582152", "53537062", "0", "55", "1000", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=cobblestone oneway=yes oneway:bicycle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11730", "976450"],
          ["8584095", "53538075", "1", "173", "1000", "0", "0", "0", "0", "highway=residential surface=cobblestone route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11768", "980270"],
          ["8584123", "53538098", "1", "4", "1000", "0", "0", "0", "0", "highway=residential surface=sett route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes barrier=gate access=yes", "11769", "980339"],
          ["8584181", "53538141", "1", "7", "1000", "0", "0", "0", "0", "highway=residential surface=sett route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11770", "980452"],
          ["8586778", "53540027", "2", "276", "1000", "0", "0", "0", "0", "highway=residential surface=cobblestone route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11809", "984398"],
          ["8587041", "53539941", "3", "21", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "11812", "984719"],
          ["8587093", "53539928", "3", "4", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "11813", "984785"],
          ["8587363", "53539922", "3", "19", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11817", "985151"],
          ["8587151", "53539986", "3", "16", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=unknown cycleway=shared_lane oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "11819", "985410"],
          ["8586631", "53540090", "1", "37", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=no oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11824", "985879"],
          ["8586461", "53540137", "1", "7", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt cycleway=shared route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11825", "985972"],
          ["8586631", "53540090", "1", "7", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt cycleway=shared route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11825", "986037"],
          ["8587041", "53539941", "3", "34", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "11829", "986423"],
          ["8587093", "53539928", "3", "4", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "11830", "986477"],
          ["8587363", "53539922", "3", "19", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt oneway=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11833", "986774"],
          ["8587549", "53539912", "4", "13", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=unknown route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "11835", "987000"],
          ["8587618", "53539910", "4", "5", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=unknown route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals", "11836", "987093"],
          ["8588814", "53539897", "5", "81", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=unknown route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "11855", "988959"],
          ["8590089", "53539890", "4", "87", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=unknown cycleway=track route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=traffic_signals traffic_signals:direction=forward", "11868", "990286"],
          ["8590161", "53539879", "4", "5", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=unknown cycleway=track route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "11869", "990361"],
          ["8590308", "53539848", "4", "11", "1000", "0", "0", "0", "0", "highway=secondary surface=asphalt bicycle=unknown cycleway=track route_bicycle_rcn=yes", "", "11870", "990527"],
          ["8590357", "53540000", "4", "6", "53050", "0", "103", "0", "0", "reversedirection=yes highway=primary surface=asphalt bicycle=unknown oneway=yes", "", "11875", "990563"],
          ["8590308", "53539848", "4", "6", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes", "", "11875", "990619"],
          ["8590161", "53539879", "4", "11", "1000", "0", "0", "0", "0", "reversedirection=yes highway=secondary surface=asphalt bicycle=unknown cycleway=track route_bicycle_rcn=yes", "nodeaccessgranted=yes highway=crossing crossing=traffic_signals", "11876", "990725"],
          ["8591073", "53543466", "1", "414", "1050", "0", "91", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=yes oneway=no", "", "11931", "996245"],
          ["8591171", "53543461", "1", "7", "1050", "0", "102", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated", "", "11932", "996347"],
          ["8591322", "53543939", "1", "55", "1050", "0", "81", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "highway=crossing crossing=traffic_signals", "11940", "997140"],
          ["8593351", "53546701", "0", "344", "1050", "0", "7", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "", "11999", "1003000"],
          ["8593997", "53547543", "0", "142", "1050", "0", "42", "0", "0", "highway=path foot=yes bicycle=yes", "", "12019", "1004961"],
          ["8594290", "53547535", "0", "20", "1150", "0", "1", "0", "0", "highway=residential surface=cobblestone", "", "12022", "1005263"],
          ["8594056", "53549400", "1", "209", "3050", "0", "98", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes", "", "12060", "1009134"],
          ["8594030", "53549816", "0", "47", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown cycleway=track oneway=yes", "", "12067", "1009802"],
          ["8594035", "53550134", "0", "36", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes", "highway=traffic_signals", "12072", "1010315"],
          ["8594035", "53550706", "0", "66", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes", "highway=traffic_signals", "12082", "1011316"],
          ["8594024", "53550840", "0", "15", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes", "", "12084", "1011552"],
          ["8593401", "53554300", "2", "393", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt foot=designated bicycle=unknown oneway=yes", "highway=traffic_signals", "12145", "1017571"],
          ["8593397", "53554341", "2", "5", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt foot=designated bicycle=unknown oneway=yes", "highway=crossing crossing=traffic_signals", "12146", "1017661"],
          ["8593156", "53556541", "2", "250", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt foot=designated bicycle=unknown oneway=yes", "highway=traffic_signals", "12180", "1021139"],
          ["8593150", "53556598", "2", "7", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt foot=designated bicycle=unknown oneway=yes", "highway=crossing crossing=traffic_signals", "12182", "1021258"],
          ["8593123", "53556832", "3", "27", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt foot=designated bicycle=unknown oneway=yes", "", "12186", "1021744"],
          ["8593107", "53557086", "3", "29", "3050", "0", "0", "0", "0", "highway=primary surface=paved bicycle=unknown oneway=yes smoothness=good", "highway=crossing crossing=traffic_signals", "12192", "1022258"],
          ["8593064", "53557511", "3", "48", "3050", "0", "0", "0", "0", "highway=primary surface=paved bicycle=unknown oneway=yes smoothness=good", "wheelchair=yes", "12200", "1023141"],
          ["8593032", "53557660", "3", "17", "3050", "0", "0", "0", "0", "highway=primary surface=paved bicycle=unknown oneway=yes smoothness=good", "", "12203", "1023445"],
          ["8592967", "53558418", "3", "87", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes smoothness=good", "highway=traffic_signals", "12214", "1024540"],
          ["8592964", "53558452", "3", "4", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes smoothness=good", "highway=crossing crossing=traffic_signals", "12215", "1024586"],
          ["8592964", "53558841", "3", "45", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes smoothness=good", "highway=crossing crossing=traffic_signals", "12221", "1025201"],
          ["8593001", "53559029", "4", "22", "3050", "0", "0", "0", "0", "highway=primary surface=asphalt bicycle=unknown oneway=yes smoothness=good", "", "12224", "1025546"],
          ["8593228", "53559328", "4", "37", "3050", "0", "4", "0", "0", "reversedirection=yes highway=primary surface=asphalt bicycle=unknown cycleway=track smoothness=good", "", "12230", "1026136"],
          ["8593767", "53561386", "6", "241", "3050", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=paved bicycle=unknown cycleway=track smoothness=good", "highway=traffic_signals traffic_signals:direction=backward", "12278", "1030931"],
          ["8593751", "53561604", "6", "25", "3050", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=paved bicycle=unknown cycleway=track smoothness=good", "highway=crossing crossing=traffic_signals", "12283", "1031439"],
          ["8593747", "53561691", "6", "10", "3050", "0", "0", "0", "0", "reversedirection=yes highway=primary surface=paved bicycle=unknown cycleway=track smoothness=good", "", "12285", "1031575"],
          ["8588922", "53561858", "5", "322", "1150", "0", "83", "0", "0", "highway=residential surface=paved", "", "12330", "1036090"],
          ["8588879", "53561372", "5", "5", "1150", "0", "91", "0", "0", "reversedirection=yes highway=residential surface=cobblestone", "", "12331", "1036158"],
          ["8586231", "53562676", "7", "288", "1150", "0", "99", "0", "0", "highway=residential surface=cobblestone", "", "12374", "1040516"],
          ["8586279", "53563645", "8", "109", "1450", "0", "97", "0", "0", "highway=tertiary surface=asphalt bicycle=unknown cycleway=lane", "highway=traffic_signals traffic_signals:direction=forward", "12390", "1042103"],
          ["8586280", "53563672", "8", "4", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt bicycle=unknown cycleway=lane", "highway=crossing crossing=traffic_signals", "12390", "1042156"],
          ["8586272", "53563751", "8", "9", "1450", "0", "0", "0", "0", "highway=tertiary surface=asphalt bicycle=unknown cycleway=lane", "", "12392", "1042271"],
          ["8586249", "53563847", "7", "11", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary bicycle=unknown cycleway=track", "highway=crossing crossing=traffic_signals", "12393", "1042401"],
          ["8586238", "53563878", "7", "4", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary bicycle=unknown cycleway=track", "highway=traffic_signals traffic_signals:direction=forward", "12393", "1042450"],
          ["8586089", "53564329", "5", "52", "1450", "0", "0", "0", "0", "reversedirection=yes highway=tertiary bicycle=unknown cycleway=track", "", "12399", "1042991"],
          ["8582136", "53563821", "5", "188", "1350", "0", "90", "0", "0", "reversedirection=yes highway=unclassified surface=paved bicycle=unknown cycleway=track", "", "12421", "1045234"],
          ["8583390", "53564001", "6", "3", "1350", "0", "0", "0", "0", "highway=unclassified surface=paved bicycle=unknown cycleway=track", "", "12422", "1045263"],
          ["8582484", "53566163", "0", "249", "1350", "0", "91", "0", "0", "highway=unclassified", "", "12446", "1047685"],
          ["8582268", "53566116", "0", "16", "1150", "0", "99", "0", "0", "highway=residential surface=paved", "", "12448", "1047904"],
          ["8579941", "53570621", "-1", "549", "1050", "0", "93", "0", "0", "highway=unclassified surface=paved access=yes bicycle=yes", "", "12531", "1056189"],
          ["8579662", "53571349", "0", "84", "1050", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=destination bicycle=yes lcn=yes smoothness=bad", "", "12547", "1057818"],
          ["8578946", "53573888", "1", "291", "1050", "0", "6", "0", "0", "highway=unclassified surface=asphalt access=destination bicycle=yes lcn=yes smoothness=intermediate", "", "12603", "1063426"],
          ["8578835", "53574174", "2", "33", "1050", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=destination bicycle=yes lcn=yes smoothness=bad", "", "12610", "1064157"],
          ["8577752", "53577197", "2", "345", "1350", "0", "0", "0", "0", "highway=unclassified surface=asphalt access=destination smoothness=intermediate", "", "12678", "1070910"],
          ["8578579", "53577200", "5", "55", "1350", "0", "110", "0", "0", "highway=unclassified surface=paved", "", "12686", "1071737"],
          ["8578737", "53577189", "5", "11", "1000", "0", "0", "0", "0", "highway=unclassified surface=paved route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12688", "1071908"],
          ["8578740", "53577369", "5", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes barrier=bollard foot=yes bicycle=yes", "12691", "1072238"],
          ["8578975", "53578673", "4", "151", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=asphalt foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12720", "1075158"],
          ["8578713", "53579778", "1", "140", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12733", "1076444"],
          ["8578455", "53580153", "2", "46", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paved foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12739", "1077002"],
          ["8580917", "53581304", "2", "234", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12773", "1080370"],
          ["8578573", "53581190", "2", "158", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12793", "1082418"],
          ["8578563", "53581124", "2", "8", "1000", "0", "0", "0", "0", "highway=path surface=paved foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12794", "1082534"],
          ["8572857", "53586612", "2", "902", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=compacted foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes barrier=bollard", "12935", "1096633"],
          ["8572773", "53586936", "2", "37", "1000", "0", "0", "0", "0", "reversedirection=yes highway=path surface=compacted foot=designated bicycle=designated route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "12942", "1097290"],
          ["8572323", "53587014", "3", "32", "1450", "0", "52", "0", "0", "highway=tertiary surface=paved bicycle=unknown cycleway=track", "", "12948", "1097920"],
          ["8569149", "53587595", "3", "221", "1450", "0", "0", "0", "0", "highway=tertiary surface=paved", "", "12983", "1101439"],
          ["8568805", "53587676", "3", "25", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path foot=designated bicycle=yes", "", "12986", "1101752"],
          ["8563986", "53588698", "1", "346", "1050", "0", "17", "0", "0", "highway=path foot=designated bicycle=designated oneway=yes oneway:bicycle=yes", "", "13038", "1106865"],
          ["8563562", "53588732", "0", "31", "1050", "0", "96", "0", "0", "highway=path surface=paved foot=designated bicycle=designated oneway=no", "", "13041", "1107221"],
          ["8558664", "53589942", "2", "367", "1050", "0", "29", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated oneway=no", "", "13096", "1112737"],
          ["8558234", "53589955", "1", "35", "1050", "0", "147", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "", "13102", "1113295"],
          ["8553130", "53591077", "3", "364", "1050", "0", "9", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated oneway=yes oneway:bicycle=yes", "", "13169", "1120003"],
          ["8552755", "53591169", "3", "27", "1050", "0", "0", "0", "0", "highway=path surface=concrete foot=designated bicycle=designated oneway=yes", "", "13174", "1120528"],
          ["8547229", "53592817", "0", "434", "1050", "0", "98", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated oneway=yes oneway:bicycle=yes", "", "13235", "1126634"],
          ["8544929", "53595800", "2", "387", "1050", "0", "128", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "highway=crossing", "13292", "1132315"],
          ["8544782", "53595970", "1", "22", "1050", "0", "0", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "highway=crossing", "13295", "1132645"],
          ["8537526", "53598544", "0", "584", "1050", "0", "72", "0", "0", "highway=path surface=paving_stones foot=designated bicycle=designated", "", "13382", "1141285"],
          ["8536994", "53598705", "0", "40", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=concrete foot=designated bicycle=designated", "", "13387", "1141772"],
          ["8535619", "53599234", "1", "114", "1050", "0", "67", "0", "0", "reversedirection=yes highway=path surface=paved foot=designated bicycle=designated", "", "13405", "1143587"],
          ["8535525", "53599217", "1", "7", "1150", "0", "1", "0", "0", "reversedirection=yes highway=residential surface=asphalt cycleway=opposite oneway=yes oneway:bicycle=no", "", "13406", "1143720"],
          ["8535229", "53599218", "1", "21", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=asphalt cycleway=opposite oneway=yes oneway:bicycle=no route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "13410", "1144152"],
          ["8534141", "53599610", "4", "87", "1000", "0", "0", "0", "0", "reversedirection=yes highway=residential surface=cobblestone route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "13424", "1145484"],
          ["8532336", "53598459", "5", "184", "1000", "0", "0", "0", "0", "highway=residential surface=cobblestone route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "13458", "1148913"],
          ["8532912", "53598210", "4", "49", "1000", "0", "0", "0", "0", "highway=residential surface=paved route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "13466", "1149676"],
          ["8532561", "53597886", "3", "43", "1000", "0", "0", "0", "0", "highway=service route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "13471", "1150241"],
          ["8532497", "53597812", "3", "10", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=paving_stones foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "nodeaccessgranted=yes barrier=bollard access=no foot=yes bicycle=yes", "13473", "1150372"],
          ["8532465", "53597771", "3", "6", "1000", "0", "0", "0", "0", "reversedirection=yes highway=footway surface=paving_stones foot=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "13473", "1150440"],
          ["8531611", "53598014", "4", "63", "1000", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=asphalt foot=yes bicycle=yes route_bicycle_icn=yes route_bicycle_ncn=yes route_bicycle_rcn=yes route_bicycle_lcn=yes", "", "13480", "1151134"],
          ["8531393", "53598011", "3", "15", "1050", "0", "9", "0", "0", "highway=footway surface=paving_stones foot=yes bicycle=yes", "", "13482", "1151316"],
          ["8522928", "53605423", "2", "1013", "1050", "0", "20", "0", "0", "reversedirection=yes highway=footway surface=paving_stones bicycle=yes smoothness=bad", "", "13638", "1166961"],
          ["8522731", "53605688", "2", "33", "1050", "0", "2", "0", "0", "reversedirection=yes highway=footway bicycle=yes", "", "13643", "1167458"],
          ["8522540", "53605419", "2", "33", "1050", "0", "151", "0", "0", "highway=path foot=designated bicycle=designated", "", "13647", "1167785"],
          ["8522101", "53606477", "1", "127", "1050", "0", "176", "0", "0", "highway=track tracktype=grade1 surface=asphalt bicycle=yes", "barrier=gate foot=yes bicycle=yes", "13661", "1169258"],
          ["8521933", "53606528", "1", "15", "1050", "0", "9", "0", "0", "highway=track tracktype=grade1 surface=asphalt bicycle=yes", "barrier=cattle_grid foot=yes bicycle=yes", "13663", "1169418"],
          ["8518127", "53610625", "-8192", "599", "1050", "0", "89", "0", "0", "highway=track tracktype=grade1 surface=asphalt bicycle=yes", "barrier=cattle_grid foot=yes bicycle=yes", "13746", "1177722"],
          ["8503285", "53631960", "2", "2616", "1050", "0", "49", "0", "0", "highway=track tracktype=grade1 surface=asphalt bicycle=yes", "", "14175", "1220579"],
          ["8499131", "53640157", "1", "1053", "1050", "0", "143", "0", "0", "highway=track tracktype=grade1 surface=asphalt foot=yes bicycle=yes smoothness=excellent", "", "14347", "1237818"],
          ["8499210", "53640627", "0", "54", "1050", "0", "0", "0", "0", "highway=track tracktype=grade1 surface=asphalt", "", "14356", "1238729"],
          ["8499076", "53641031", "1", "46", "1050", "0", "4", "0", "0", "reversedirection=yes highway=track tracktype=grade1 surface=asphalt bicycle=yes", "", "14364", "1239530"],
          ["8499037", "53641150", "1", "14", "1050", "0", "0", "0", "0", "reversedirection=yes highway=path surface=paving_stones bicycle=yes", "barrier=gate", "14366", "1239772"],
          ["8495541", "53646308", "1", "632", "5050", "0", "3", "0", "0", "highway=footway", "", "14802", "1241661"],
          ["8495494", "53647179", "2", "100", "5050", "0", "5", "0", "0", "highway=footway surface=paving_stones", "", "14873", "1242300"],
          ["8494510", "53645761", "0", "184", "1150", "0", "240", "0", "0", "highway=residential surface=asphalt", "", "14892", "1244261"],
          ["8496604", "53643380", "1", "290", "1350", "0", "31", "0", "0", "reversedirection=yes highway=service", "", "14936", "1248671"]
        ],
        "times": [0, 5.279, 11.692, 13.367, 14.676, 18.287, 19.275, 19.832, 20.306, 21.484, 26.606, 29.163, 48.107, 53.33, 57.441, 62.076, 63.731, 64.663, 114.641, 116.051, 120.025, 121.482, 123.584, 124.652, 126.427, 128.485, 152.006, 163, 167.245, 171.66, 172.83, 176.967, 179.43, 189.267, 198.899, 206.756, 211.066, 212.173, 216.373, 220.156, 223.116, 227.853, 229.38, 230.423, 230.951, 231.71, 232.223, 233.262, 235.16, 253.795, 277.394, 287.021, 291.602, 306.115, 312.631, 340.517, 342.243, 343.276, 343.792, 345.338, 346.881, 349.105, 350.328, 359.217, 364.345, 370.313, 372.689, 374.385, 375.815, 377.318, 380.053, 382.566, 394.007, 409.195, 419.013, 420.702, 421.883, 423.325, 433.589, 440.697, 450.095, 468.29, 471.802, 474.855, 475.046, 477.141, 481.708, 488.064, 492.114, 494.627, 503.326, 510.451, 518.473, 522.38, 524.923, 529.831, 531.859, 534.224, 537.599, 540.465, 544.229, 544.585, 549.194, 550.99, 575.768, 584.204, 588.845, 593.071, 598.988, 604.193, 616.569, 629.839, 646.491, 676.696, 680.96, 684.649, 691.422, 699.319, 701.197, 704.944, 707.657, 713.236, 714.337, 717.796, 722.87, 728.552, 734.03, 742.282, 751.409, 762.362, 775.924, 790.231, 802.588, 815.438, 825.45, 827.836, 828.676, 830.963, 839.883, 845.611, 854.778, 863.613, 866.994, 874.487, 893.514, 913.38, 919.452, 938.574, 949.419, 982.991, 991.882, 993.298, 998.715, 1012.832, 1053.981, 1062.401, 1063.269, 1067.385, 1070.061, 1073.435, 1112.042, 1120.451, 1123.964, 1131.194, 1134.153, 1191.175, 1191.505, 1220.372, 1221.283, 1225.515, 1227.926, 1229.847, 1231.674, 1232.53, 1234.704, 1236.584, 1238.321, 1241.666, 1246.883, 1280.543, 1282.659, 1287.079, 1289.711, 1291.855, 1294.005, 1297.818, 1300.476, 1303.139, 1305.639, 1307.596, 1307.966, 1352.492, 1360.106, 1420.383, 1421.849, 1422.689, 1479.554, 1480.328, 1480.791, 1483.248, 1514.361, 1521.022, 1528.39, 1689.45, 1780.345, 1789.5, 1791.087, 1792.492, 1795.636, 1806.182, 1817.822, 1826.536, 1832.249, 1836.438, 1871.968, 1913.713, 1933.435, 1953.079, 1997.533, 2009.331, 2015.975, 2032.242, 2033.874, 2035.511, 2049.012, 2160.641, 2166.41, 2174.701, 2177.768, 2181.353, 2191.815, 2196.065, 2198.377, 2205.157, 2209.518, 2210.486, 2212.052, 2213.69, 2214.657, 2218.676, 2219.217, 2221.532, 2234.187, 2236.306, 2238.746, 2242.25, 2251.494, 2254.597, 2257.77, 2260.028, 2270.369, 2276.516, 2278.57, 2281.381, 2289.679, 2310.875, 2312.285, 2314.105, 2318.106, 2320.286, 2320.669, 2321.626, 2323.506, 2325.48, 2327.918, 2330, 2331.459, 2332.68, 2334.776, 2336.264, 2337.74, 2343.903, 2355.763, 2359.168, 2366.838, 2371.445, 2384.242, 2387.059, 2388.898, 2395.2, 2397.209, 2403.597, 2410.399, 2416.918, 2419.703, 2422.524, 2425.215, 2427.803, 2429.4, 2431.494, 2433.25, 2449.4, 2458.856, 2460.434, 2461.78, 2463.741, 2465.493, 2470.829, 2480.118, 2481.872, 2493.721, 2497.663, 2507.12, 2511.067, 2515.325, 2547.337, 2569.862, 2589.205, 2600.897, 2619.398, 2642.289, 2660.884, 2668.656, 2680.949, 2708.541, 2712.55, 2716.011, 2856.187, 2860.675, 2862.673, 2909.421, 3179.117, 3205.679, 3246.717, 3280.83, 3355.838, 3362.227, 3392.989, 3409.353, 3455.597, 3457.25, 3465.709, 3470.283, 3475.816, 3512.817, 3515.477, 3517.668, 3524.522, 3527.34, 3529.693, 3532.397, 3536.253, 3541.19, 3543.878, 3546.698, 3549.432, 3551.484, 3554.482, 3556.709, 3561.384, 3564.004, 3565.774, 3568.701, 3571.277, 3573.766, 3575.528, 3578.734, 3580.605, 3585.701, 3586.891, 3588.07, 3589.238, 3590.203, 3590.295, 3593.031, 3599.809, 3601.337, 3683.925, 3721.983, 3725.164, 3757.278, 3883.833, 3916.474, 3954.547, 3963.286, 3971.973, 3974.703, 3975.932, 3981.397, 3986.768, 3998.723, 4001.576, 4004.569, 4019.915, 4021.955, 4023.425, 4025.43, 4041.619, 4043.982, 4046.493, 4049.13, 4067.867, 4077.217, 4086.635, 4230.789, 4236.233, 4241.407, 4369.236, 4475.147, 4524.833, 4596.13, 4599.035, 4601.763, 4603.294, 4605.673, 4612.283, 4613.806, 4618.094, 4619.122, 4619.772, 4623.129, 4624.685, 4625.987, 4627.394, 4642.218, 4679.058, 4697.273, 4711.756, 4728.573, 4758.338, 4804.583, 4859.14, 4873.686, 4887.083, 4888.21, 4903.211, 4922.34, 4935.182, 4942.675, 4965.156, 4971.566, 4985.049, 5005.491, 5017.279, 5026.008, 5030.557, 5036.328, 5047.625, 5053.513, 5062.382, 5069.17, 5078.947, 5111.513, 5119.93, 5176.589, 5186.048, 5205.022, 5225.96, 5243.821, 5260.54, 5269.243, 5327.254, 5330.69, 5345.57, 5348.413, 5365.969, 5434.528, 5457.906, 5479.134, 5483.164, 5486.833, 5488.119, 5492.584, 5494.645, 5506.477, 5535.328, 5557.054, 5564.758, 5576.512, 5600.232, 5615.232, 5675.675, 5679.559, 5689.713, 5704.998, 5714.912, 5719.546, 5741.532, 5743.161, 5745.675, 5751.696, 5762.096, 5768.506, 5770.137, 5775.762, 5782.324, 5800.441, 5807.43, 5808.944, 5815.1, 5823.068, 5865.628, 5874.812, 5896.569, 5914.848, 5922.804, 5924.277, 5926.438, 5929.09, 5931.549, 5932.214, 5933.364, 5934.983, 5940.312, 5949.495, 5960.566, 5965.793, 5969.803, 5975.7, 5978.874, 5982.725, 5989.593, 6008.693, 6025.539, 6039.636, 6041.653, 6049.856, 6055.54, 6059.84, 6063.68, 6068.839, 6071.617, 6084.67, 6099.186, 6119.528, 6120.205, 6128.137, 6137.31, 6142.555, 6164.387, 6170.186, 6171.716, 6185.952, 6198.724, 6240.426, 6247.667, 6253.304, 6259.588, 6264.085, 6266.267, 6269.582, 6271.8, 6272.831, 6274.358, 6274.656, 6279.754, 6283.3, 6287.078, 6291.456, 6292.129, 6295.663, 6300.878, 6305.698, 6306.052, 6307.817, 6315.84, 6316.532, 6322.04, 6327.341, 6333.805, 6337.366, 6342.104, 6343.691, 6345.191, 6349.46, 6352.042, 6353.358, 6354.096, 6356.186, 6359.733, 6364.318, 6364.862, 6366.126, 6369.99, 6370.787, 6371.774, 6376.982, 6379.985, 6384.218, 6385.308, 6390.689, 6392.959, 6394.082, 6394.827, 6400.865, 6405.931, 6406.567, 6412.387, 6417.57, 6421.673, 6423.759, 6425.6, 6429.632, 6430.678, 6435.09, 6436.168, 6444.83, 6446.143, 6447.115, 6450.778, 6452.24, 6453.873, 6456.248, 6463.434, 6463.888, 6466.023, 6467.335, 6468.814, 6470.396, 6478.669, 6482.021, 6486.537, 6487.994, 6488.953, 6494.433, 6499.096, 6504.054, 6504.543, 6513.326, 6521.362, 6522.493, 6525.471, 6526.76, 6527.129, 6527.954, 6542.604, 6543.491, 6545.885, 6555.275, 6567.224, 6590.078, 6599.313, 6601.155, 6603.525, 6644.365, 6662.826, 6663.323, 6665.811, 6707.444, 6710.341, 6716.963, 6723.056, 6727.521, 6731.945, 6736.969, 6755.394, 6770.635, 6820.241, 6855.392, 6857.896, 6860.034, 6863.423, 6870.563, 6875.875, 6895.859, 6904.361, 6908.848, 6912.012, 6917.701, 6922.728, 6928.032, 6972.275, 7037.275, 7043.862, 7048.629, 7053.149, 7056.379, 7059.499, 7066.827, 7068.329, 7085.135, 7088.989, 7090.608, 7091.351, 7092.255, 7093.881, 7105.18, 7139.224, 7141.559, 7143.562, 7150.248, 7170.01, 7177.817, 7184.665, 7191.938, 7198.175, 7209.941, 7226.818, 7240.746, 7258.104, 7274.352, 7284.062, 7305.302, 7324.227, 7329.498, 7332.34, 7334.731, 7338.146, 7363.905, 7377.575, 7384.141, 7386.121, 7388.105, 7389.343, 7390.928, 7394.84, 7428.096, 7430.841, 7435.759, 7439.481, 7441.386, 7447.172, 7463.397, 7476.935, 7487.731, 7489.281, 7491, 7494.284, 7495.938, 7501.44, 7506.279, 7510.112, 7515.75, 7531.656, 7549.985, 7555.53, 7577.752, 7578.236, 7578.754, 7579.021, 7580.988, 7624.215, 7625.573, 7631.987, 7641.102, 7646.038, 7649.959, 7673.115, 7684.493, 7701.68, 7713.81, 7728.313, 7737.692, 7739.262, 7741.174, 7745.84, 7753.097, 7754.167, 7757.381, 7763.639, 7768.544, 7774.096, 7796.776, 7797.943, 7808.533, 7831.77, 7834.85, 7857.26, 7880.164, 7901.197, 7942.022, 7960.266, 7962.33, 7964.185, 7966.571, 7968.026, 7969.38, 7970.734, 7972.002, 7973.916, 7975.519, 7977.291, 7978.746, 7987.646, 7991.566, 8009.068, 8014.479, 8015, 8022.341, 8035.034, 8100.145, 8144.983, 8171.925, 8172.765, 8179.528, 8201.058, 8204.989, 8207.393, 8209.004, 8222.29, 8231.905, 8237.319, 8246.752, 8258.399, 8263.883, 8278.327, 8287.091, 8301.646, 8304.585, 8317.413, 8327.87, 8343.903, 8349.506, 8350.798, 8357.6, 8363.907, 8368.083, 8380.963, 8389.83, 8405.448, 8417.005, 8427.122, 8433.732, 8456.194, 8460.506, 8463.345, 8476.125, 8479.627, 8483.97, 8492.621, 8493.602, 8504.729, 8518.576, 8524.435, 8528.774, 8530.978, 8541.838, 8544.911, 8555.134, 8568.112, 8574.338, 8581.422, 8589.753, 8590.593, 8591.806, 8592.223, 8593.566, 8596.289, 8603.175, 8607.01, 8609.854, 8615.127, 8616.695, 8619.646, 8623.545, 8626.628, 8633.088, 8636.006, 8646.494, 8650.267, 8655.192, 8659.98, 8661.654, 8666.419, 8671.504, 8682.921, 8707.275, 8731.718, 8735.747, 8740.449, 8743.137, 8746.496, 8751.031, 8755.734, 8758.422, 8760.941, 8762.79, 8768.67, 8770.761, 8775.954, 8776.934, 8789.113, 8795.449, 8797.366, 8808.565, 8824.879, 8834.67, 8845.729, 8854.266, 8865.86, 8885.589, 8891.293, 8898.98, 8900.012, 8900.668, 8903.313, 8920.669, 8931.356, 8937.16, 8954.635, 8972.364, 8979.048, 8993.769, 8996.11, 8997.362, 9013.603, 9014.945, 9017.286, 9025.448, 9058.528, 9070.524, 9071.785, 9073.812, 9078.378, 9081.059, 9082.526, 9087.319, 9089.864, 9111.377, 9120.067, 9123.164, 9135.718, 9151.586, 9161.935, 9168.881, 9174.563, 9188.885, 9190.458, 9197.978, 9207.74, 9213.976, 9225.44, 9240.848, 9246.714, 9248.92, 9257.584, 9258.233, 9259.209, 9264.305, 9267.028, 9267.445, 9267.725, 9269.279, 9298.268, 9306.444, 9336.178, 9351.435, 9421.356, 9429.916, 9442.823, 9462.155, 9481.624, 9497.489, 9499.908, 9501.204, 9503.48, 9508.719, 9512.837, 9513.543, 9514.424, 9518.154, 9522.245, 9525.688, 9536.774, 9539.526, 9541.659, 9543.38, 9545.8, 9547.188, 9548.756, 9549.726, 9552.772, 9554.018, 9560.401, 9561.186, 9562.507, 9562.876, 9568.448, 9569.486, 9570.434, 9572.144, 9578.604, 9683.01, 9873.566, 10017.195, 10188.733, 10327.394, 10453.904, 10473.487, 10595.826, 10728.971, 10976.218, 11149.179, 11240.666, 11321.433, 11388.618, 11419.353, 11450.802, 11468.67, 11617.556, 11704.169, 11714.596, 11717.834, 11730.136, 11730.964, 11743.715, 11767.117, 11768.33, 11769.022, 11770.156, 11774.553, 11775.775, 11785.127, 11787.701, 11796.553, 11803.908, 11809.602, 11811.325, 11812.81, 11813.471, 11814.529, 11817.134, 11819.721, 11824.404, 11825.338, 11825.988, 11827.294, 11828.671, 11829.852, 11830.384, 11831.238, 11833.354, 11835.618, 11836.547, 11844.667, 11851.741, 11855.207, 11857.849, 11858.896, 11867.721, 11868.467, 11869.217, 11870.881, 11875.115, 11875.672, 11876.729, 11880.968, 11883.192, 11887.895, 11889.488, 11892.26, 11895.619, 11898.223, 11902.118, 11910.249, 11917.35, 11920.333, 11925.884, 11931.924, 11932.945, 11940.872, 11943.589, 11979.714, 11983.521, 11986.883, 11996.906, 11998.644, 11999.461, 12000.844, 12008.985, 12010.062, 12011.155, 12012.405, 12013.816, 12016.119, 12017.29, 12019.069, 12022.088, 12027.817, 12048.91, 12060.796, 12067.471, 12071.582, 12072.602, 12074.817, 12077.831, 12081.059, 12082.615, 12084.971, 12087.348, 12092.318, 12096.535, 12098.984, 12100.95, 12102.959, 12118.218, 12122.309, 12122.515, 12125.208, 12134.312, 12145.155, 12146.062, 12150.045, 12159.948, 12165.437, 12166.632, 12176.069, 12180.837, 12182.026, 12186.889, 12192.022, 12200.851, 12203.897, 12207.73, 12209.232, 12210.553, 12214.845, 12215.299, 12218.153, 12221.454, 12224.901, 12230.801, 12235.7, 12240.724, 12244.279, 12248.057, 12255.042, 12261.968, 12278.748, 12281.617, 12283.819, 12284.609, 12285.187, 12300.199, 12317.427, 12330.324, 12331.006, 12331.485, 12336.412, 12344.257, 12364.559, 12374.021, 12374.578, 12386.855, 12390.446, 12390.979, 12392.129, 12393.431, 12393.914, 12396.561, 12399.331, 12400.766, 12400.949, 12406.931, 12407.857, 12421.306, 12421.758, 12422.045, 12435.441, 12446.264, 12448.453, 12454.637, 12463.422, 12472.974, 12493.894, 12498.668, 12506.41, 12511.854, 12515.905, 12518.654, 12521.354, 12527.751, 12531.299, 12547.581, 12553.747, 12558.632, 12562.986, 12566.734, 12570.188, 12588.488, 12596.996, 12603.666, 12610.967, 12643.479, 12656.14, 12677.836, 12678.486, 12686.764, 12688.472, 12691.769, 12716.097, 12718.417, 12719.003, 12719.879, 12720.969, 12722.364, 12722.971, 12724.2, 12725.605, 12726.925, 12727.853, 12730.081, 12731.138, 12732.242, 12733.823, 12739.399, 12740.44, 12741.501, 12742.578, 12743.674, 12755.479, 12758.993, 12761.453, 12764.433, 12766.921, 12768.694, 12773.079, 12777.696, 12779.604, 12784.622, 12792.131, 12793.556, 12794.711, 12798.188, 12814.918, 12818.458, 12819.549, 12822.367, 12830.121, 12832.383, 12842.71, 12846.807, 12851.398, 12858.809, 12866.106, 12873.302, 12875.884, 12879.133, 12881.194, 12883.992, 12895.973, 12899.092, 12903.877, 12908.184, 12913.24, 12918.684, 12935.697, 12937.487, 12942.268, 12947.021, 12948.566, 12977.364, 12983.754, 12986.883, 12994.547, 13003.161, 13015.534, 13021.705, 13030.846, 13033.714, 13037.112, 13038.002, 13039.058, 13040.091, 13041.564, 13042.03, 13045.787, 13048.811, 13051.81, 13080.464, 13083.92, 13093.886, 13094.497, 13095.11, 13095.726, 13096.713, 13098.197, 13100.014, 13100.79, 13101.568, 13102.303, 13106.028, 13107.238, 13111.347, 13114.376, 13165.82, 13169.37, 13174.617, 13191.497, 13198.863, 13206.475, 13211.934, 13215.983, 13220.395, 13223.587, 13225.553, 13228.264, 13229.289, 13229.827, 13232.519, 13233.136, 13233.905, 13234.466, 13235.671, 13236.659, 13237.541, 13238.568, 13239.879, 13245.074, 13249.588, 13258.375, 13264.138, 13267.378, 13267.935, 13269.375, 13272.294, 13279.996, 13283.315, 13289.086, 13290.609, 13292.472, 13295.778, 13296.999, 13298.156, 13300.38, 13301.801, 13303.439, 13309.304, 13310.479, 13312.626, 13315.686, 13319.44, 13326.383, 13328.725, 13331.125, 13336.693, 13345.851, 13350.725, 13355.144, 13366.838, 13367.317, 13368.345, 13371.319, 13380.437, 13382.163, 13387.029, 13394.504, 13400.718, 13404.03, 13405.181, 13406.511, 13408.722, 13410.832, 13415.927, 13417.555, 13421.322, 13424.143, 13428.923, 13434.858, 13439.014, 13443.504, 13444.301, 13447.822, 13456.516, 13458.438, 13460.071, 13464.881, 13466.065, 13471.713, 13473.025, 13473.425, 13473.701, 13477.52, 13480.646, 13482.462, 13482.697, 13486.449, 13489.945, 13495.117, 13499.856, 13520.874, 13526.499, 13531.71, 13540.086, 13541.907, 13552.267, 13587.104, 13628.867, 13638.886, 13643.863, 13644.008, 13647.133, 13648.955, 13651.119, 13654.727, 13657.905, 13659.146, 13661.854, 13662.619, 13662.711, 13663.459, 13672.725, 13673.611, 13683.658, 13684.215, 13692.407, 13715.454, 13728.571, 13746.481, 13748.494, 13778.371, 13787.441, 13817.009, 13842.041, 13859.682, 13873.626, 13892.946, 13912.771, 13932.763, 13970.563, 13976.108, 13980.812, 13988.876, 13991.229, 14033.229, 14043.819, 14078.35, 14085.618, 14094.597, 14123.543, 14132.777, 14137.983, 14160.322, 14168.051, 14171.036, 14172.973, 14175.045, 14176.251, 14180.886, 14182.254, 14183.374, 14185.788, 14188.216, 14190.331, 14192.637, 14196.326, 14198.136, 14207.944, 14209.47, 14210.834, 14232.025, 14235.031, 14241.911, 14244.933, 14247.575, 14250.37, 14253.167, 14258.542, 14281.462, 14283.313, 14288.488, 14290.557, 14293.281, 14295.055, 14304.516, 14313.934, 14314.643, 14332.411, 14333.716, 14335.381, 14347.41, 14351.613, 14356.521, 14364.53, 14366.945, 14372.681, 14414.34, 14480.961, 14502.028, 14556.158, 14588.994, 14603.305, 14671.489, 14697.734, 14723.142, 14744.23, 14748.46, 14802.636, 14844.234, 14855.565, 14864.073, 14873.299, 14874.579, 14876.487, 14882.074, 14885.406, 14886.883, 14888.007, 14888.226, 14892.903, 14894.92, 14899.968, 14907.421, 14927.155, 14936.998]
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [7.963349, 53.494763, -1.0],
          [7.964047, 53.494650, -0.5],
          [7.964739, 53.494593, 0.0],
          [7.964894, 53.494605, 0.25],
          [7.964990, 53.494631, 0.5],
          [7.965288, 53.494711, 0.5],
          [7.965363, 53.494724, 0.5],
          [7.965436, 53.494738, 0.5],
          [7.965501, 53.494749, 0.5],
          [7.965537, 53.494651, 0.5],
          [7.965826, 53.494239, 0.0],
          [7.966066, 53.494108, 0.0],
          [7.966836, 53.493020, 0.5],
          [7.967007, 53.492778, 0.75],
          [7.966992, 53.492596, 1.25],
          [7.967136, 53.492388, 1.0],
          [7.967251, 53.492337, 0.75],
          [7.967328, 53.492313, 0.5],
          [7.969163, 53.489701, 0.0],
          [7.969197, 53.489634, 0.25],
          [7.969170, 53.489463, 0.75],
          [7.969174, 53.489403, 1.0],
          [7.969328, 53.489427, 0.75],
          [7.969174, 53.489403, 1.0],
          [7.969185, 53.489263, 1.5],
          [7.969183, 53.489128, 2.0],
          [7.968833, 53.487894, 3.0],
          [7.968625, 53.487240, 2.25],
          [7.968531, 53.486962, 1.5],
          [7.968418, 53.486650, 0.75],
          [7.968364, 53.486576, 0.75],
          [7.968123, 53.486328, 0.5],
          [7.968112, 53.486158, 0.25],
          [7.967617, 53.485767, 1.5],
          [7.967182, 53.485470, 2.5],
          [7.966903, 53.485190, 2.75],
          [7.966780, 53.485006, 2.5],
          [7.966747, 53.484956, 2.5],
          [7.966727, 53.484727, 2.0],
          [7.966734, 53.484497, 1.5],
          [7.966777, 53.484303, 1.0],
          [7.967026, 53.483979, 0.0],
          [7.967057, 53.483874, 0.0],
          [7.967106, 53.483811, 0.0],
          [7.967143, 53.483791, 0.0],
          [7.967200, 53.483760, -0.25],
          [7.967226, 53.483734, -0.25],
          [7.967318, 53.483699, -0.25],
          [7.967526, 53.483649, -0.5],
          [7.969175, 53.482731, -1.5],
          [7.970848, 53.481822, -1.75],
          [7.971424, 53.481506, -1.25],
          [7.971630, 53.481335, -1.0],
          [7.972468, 53.480823, -1.0],
          [7.972811, 53.480613, -0.5],
          [7.974115, 53.479647, 0.0],
          [7.974213, 53.479583, 0.0],
          [7.974295, 53.479565, 0.0],
          [7.974327, 53.479570, 0.0],
          [7.974376, 53.479504, 0.0],
          [7.974446, 53.479437, 0.0],
          [7.974273, 53.479394, 0.0],
          [7.974446, 53.479437, 0.0],
          [7.975541, 53.479716, 0.0],
          [7.976090, 53.479831, 0.0],
          [7.976637, 53.479926, 0.5],
          [7.976832, 53.479948, 0.75],
          [7.976969, 53.479938, 0.75],
          [7.977065, 53.479890, 0.5],
          [7.977144, 53.479818, 0.25],
          [7.977357, 53.479705, 0.0],
          [7.977588, 53.479630, -0.25],
          [7.978768, 53.479538, -0.5],
          [7.980096, 53.479454, 0.0],
          [7.980952, 53.479372, 0.0],
          [7.981091, 53.479363, 0.0],
          [7.981187, 53.479367, 0.0],
          [7.981291, 53.479345, 0.25],
          [7.982013, 53.479175, 0.75],
          [7.982490, 53.479028, 1.0],
          [7.983283, 53.478791, 0.25],
          [7.984521, 53.478404, 1.25],
          [7.984757, 53.478334, 1.5],
          [7.984946, 53.478271, 1.75],
          [7.984971, 53.478264, 2.0],
          [7.985232, 53.478164, 2.0],
          [7.985682, 53.477920, 2.0],
          [7.986281, 53.477594, 1.5],
          [7.986668, 53.477392, 0.75],
          [7.986904, 53.477269, 0.5],
          [7.987663, 53.476872, 0.25],
          [7.988164, 53.476610, 0.75],
          [7.988674, 53.476330, 1.0],
          [7.988930, 53.476195, 1.0],
          [7.989088, 53.476111, 1.0],
          [7.989431, 53.475954, 1.0],
          [7.989582, 53.475906, 1.0],
          [7.989776, 53.475879, 1.0],
          [7.990064, 53.475910, 1.0],
          [7.990302, 53.475963, 1.0],
          [7.990572, 53.476050, 1.25],
          [7.990591, 53.476056, 1.25],
          [7.991203, 53.476245, 1.25],
          [7.991415, 53.476300, 1.25],
          [7.994172, 53.477014, 0.0],
          [7.994856, 53.477077, 0.75],
          [7.995241, 53.477104, 0.75],
          [7.995587, 53.477115, 0.75],
          [7.996086, 53.477080, 0.75],
          [7.996542, 53.476992, 0.5],
          [7.997638, 53.476656, 0.0],
          [7.998908, 53.476380, -0.5],
          [8.000248, 53.476067, 0.0],
          [8.002828, 53.475488, -0.25],
          [8.003186, 53.475463, 0.0],
          [8.003488, 53.475487, 0.0],
          [8.004030, 53.475605, 0.0],
          [8.004668, 53.475745, 0.0],
          [8.004824, 53.475768, 0.0],
          [8.005132, 53.475813, 0.0],
          [8.005535, 53.475872, 0.0],
          [8.006277, 53.475914, 0.0],
          [8.006405, 53.475915, 0.0],
          [8.006798, 53.475905, 0.0],
          [8.007347, 53.475871, 0.0],
          [8.007917, 53.475792, 0.0],
          [8.008430, 53.475697, 0.0],
          [8.009182, 53.475494, -0.25],
          [8.009927, 53.475238, -0.25],
          [8.010914, 53.474886, -1.0],
          [8.011983, 53.474651, -0.25],
          [8.013143, 53.474541, 0.0],
          [8.014210, 53.474552, 0.0],
          [8.015231, 53.474550, 0.5],
          [8.016111, 53.474550, 0.25],
          [8.016323, 53.474549, 0.0],
          [8.016458, 53.474549, 0.0],
          [8.016801, 53.474555, 0.0],
          [8.017938, 53.474529, 0.0],
          [8.018582, 53.474462, -0.25],
          [8.019443, 53.474279, 0.0],
          [8.020174, 53.474033, 0.0],
          [8.020419, 53.473926, 0.0],
          [8.020928, 53.473655, 0.0],
          [8.022395, 53.472813, -1.0],
          [8.023607, 53.472080, -0.75],
          [8.024057, 53.471979, -0.25],
          [8.025437, 53.471872, 0.5],
          [8.026309, 53.471694, 0.25],
          [8.029026, 53.471158, 0.5],
          [8.029841, 53.470995, 0.0],
          [8.029969, 53.470980, 0.0],
          [8.029917, 53.470684, 0.0],
          [8.029655, 53.469863, -0.5],
          [8.033485, 53.470167, -0.75],
          [8.034197, 53.470224, -0.5],
          [8.034261, 53.470229, -0.5],
          [8.034570, 53.470255, 0.0],
          [8.034766, 53.470276, 0.0],
          [8.035029, 53.470297, 0.0],
          [8.039300, 53.470647, 0.0],
          [8.040000, 53.470681, 0.75],
          [8.040289, 53.470670, 0.75],
          [8.040929, 53.470591, 0.5],
          [8.041210, 53.470583, 0.25],
          [8.046406, 53.471109, 0.0],
          [8.046408, 53.471100, 0.0],
          [8.046946, 53.469129, 0.5],
          [8.046958, 53.469084, 0.25],
          [8.047131, 53.468849, 0.0],
          [8.047300, 53.468745, -0.25],
          [8.047451, 53.468667, -0.5],
          [8.047616, 53.468612, -0.5],
          [8.047689, 53.468588, -0.5],
          [8.047904, 53.468562, -0.5],
          [8.048076, 53.468552, -0.25],
          [8.048228, 53.468551, -0.25],
          [8.048532, 53.468598, -0.25],
          [8.049017, 53.468728, -0.75],
          [8.052226, 53.469671, -2.0],
          [8.052403, 53.469708, -2.0],
          [8.052807, 53.469730, -2.0],
          [8.053034, 53.469714, -2.0],
          [8.053219, 53.469685, -2.0],
          [8.053394, 53.469645, -2.0],
          [8.053682, 53.469544, -2.0],
          [8.053852, 53.469448, -2.0],
          [8.054000, 53.469342, -2.0],
          [8.054113, 53.469232, -2.0],
          [8.054184, 53.469143, -1.75],
          [8.054206, 53.469116, -1.75],
          [8.055524, 53.466525, -0.5],
          [8.055715, 53.466150, -0.25],
          [8.057344, 53.462947, -1.0],
          [8.057228, 53.462911, -1.0],
          [8.057344, 53.462947, -1.0],
          [8.062343, 53.464480, 0.0],
          [8.062347, 53.464519, 0.0],
          [8.062343, 53.464480, 0.0],
          [8.062492, 53.464278, 0.0],
          [8.064443, 53.462512, -0.25],
          [8.064742, 53.462213, 0.0],
          [8.065029, 53.461895, 0.25],
          [8.071673, 53.454243, 0.0],
          [8.076364, 53.450409, 0.5],
          [8.076826, 53.450054, 0.75],
          [8.076903, 53.449990, 0.75],
          [8.077000, 53.449959, 0.75],
          [8.077208, 53.449859, 0.75],
          [8.077848, 53.449515, 1.0],
          [8.078964, 53.448916, 1.5],
          [8.079754, 53.448623, 1.5],
          [8.080216, 53.448459, 1.75],
          [8.080516, 53.448323, 1.75],
          [8.082743, 53.446854, 1.5],
          [8.085586, 53.445327, 1.25],
          [8.086863, 53.444602, 1.25],
          [8.088107, 53.443861, 1.25],
          [8.090731, 53.442317, 2.0],
          [8.091208, 53.441798, 2.25],
          [8.090731, 53.442317, 2.0],
          [8.091967, 53.441591, 2.75],
          [8.092090, 53.441557, 2.75],
          [8.092233, 53.441574, 2.75],
          [8.093419, 53.441936, 2.25],
          [8.102800, 53.444804, 1.0],
          [8.103305, 53.444861, 1.0],
          [8.104393, 53.444986, 1.5],
          [8.104773, 53.445036, 1.0],
          [8.105199, 53.445167, 0.25],
          [8.106505, 53.445382, -0.75],
          [8.106985, 53.445449, -1.0],
          [8.107231, 53.445453, -1.0],
          [8.106642, 53.445271, -0.75],
          [8.107231, 53.445453, -1.0],
          [8.107357, 53.445460, -1.0],
          [8.107563, 53.445435, -1.0],
          [8.107766, 53.445405, -1.0],
          [8.107869, 53.445391, -1.0],
          [8.108356, 53.445336, -1.25],
          [8.108414, 53.445329, -1.0],
          [8.108622, 53.445299, -0.5],
          [8.109388, 53.445204, 1.5],
          [8.109499, 53.445165, 1.75],
          [8.109580, 53.445098, 2.0],
          [8.109658, 53.444976, 2.0],
          [8.109688, 53.444644, 2.5],
          [8.109706, 53.444534, 2.75],
          [8.109767, 53.444429, 3.0],
          [8.109862, 53.444484, 3.25],
          [8.109955, 53.444910, 3.0],
          [8.109991, 53.445185, 3.0],
          [8.109991, 53.445273, 3.25],
          [8.110022, 53.445389, 3.25],
          [8.110175, 53.445695, 4.0],
          [8.110800, 53.446440, 4.75],
          [8.110821, 53.446496, 4.75],
          [8.110910, 53.446531, 5.25],
          [8.110993, 53.446662, 5.75],
          [8.111077, 53.446705, 6.25],
          [8.111116, 53.446725, 6.5],
          [8.111238, 53.446756, 7.0],
          [8.111434, 53.446782, 8.0],
          [8.111584, 53.446824, 8.75],
          [8.111750, 53.446880, 9.25],
          [8.111737, 53.446983, 9.0],
          [8.111741, 53.447057, 8.75],
          [8.111789, 53.447120, 8.5],
          [8.111959, 53.447111, 9.0],
          [8.112064, 53.447137, 9.25],
          [8.112153, 53.447179, 9.25],
          [8.112363, 53.447436, 9.5],
          [8.112989, 53.447604, 11.0],
          [8.113374, 53.447707, 12.25],
          [8.114494, 53.447985, 9.5],
          [8.115164, 53.448151, 7.75],
          [8.117164, 53.448600, 5.0],
          [8.117434, 53.448661, 4.75],
          [8.117606, 53.448691, 5.0],
          [8.118081, 53.448691, 6.0],
          [8.118083, 53.448794, 5.5],
          [8.118584, 53.448916, 5.75],
          [8.119161, 53.448955, 5.75],
          [8.119756, 53.448963, 5.5],
          [8.120025, 53.448976, 5.25],
          [8.120280, 53.448997, 5.25],
          [8.120540, 53.449041, 5.0],
          [8.120769, 53.449100, 5.0],
          [8.120902, 53.449145, 4.75],
          [8.121097, 53.449210, 4.5],
          [8.121252, 53.449268, 4.25],
          [8.122714, 53.449984, 3.5],
          [8.123583, 53.450410, 2.0],
          [8.123727, 53.450463, 1.75],
          [8.123860, 53.450502, 1.75],
          [8.124064, 53.450547, 1.5],
          [8.124253, 53.450573, 1.5],
          [8.124779, 53.450605, 1.75],
          [8.125629, 53.450654, 2.0],
          [8.125776, 53.450664, 2.25],
          [8.126535, 53.450554, 3.5],
          [8.126803, 53.450508, 3.5],
          [8.127598, 53.450331, 2.75],
          [8.127973, 53.450227, 2.0],
          [8.128426, 53.450067, 1.0],
          [8.131371, 53.448973, 0.25],
          [8.133056, 53.448362, 0.5],
          [8.134768, 53.447886, 0.0],
          [8.135837, 53.447635, -0.5],
          [8.137478, 53.447297, -0.5],
          [8.139431, 53.446911, -0.5],
          [8.141795, 53.446446, -0.75],
          [8.142497, 53.446251, -1.0],
          [8.143341, 53.445988, 0.0],
          [8.145018, 53.445472, 1.0],
          [8.145290, 53.445348, 1.0],
          [8.145479, 53.445214, 1.0],
          [8.151722, 53.438483, 0.0],
          [8.151906, 53.438273, 0.0],
          [8.152030, 53.438198, 0.0],
          [8.154759, 53.436372, 0.25],
          [8.170780, 53.425749, 0.75],
          [8.172435, 53.424665, 0.5],
          [8.175059, 53.422911, -0.25],
          [8.177058, 53.421587, 0.0],
          [8.181543, 53.418616, 0.0],
          [8.181888, 53.418350, 0.0],
          [8.183114, 53.417332, 1.5],
          [8.184049, 53.416573, 1.0],
          [8.186375, 53.414655, 1.5],
          [8.186477, 53.414584, 1.0],
          [8.187004, 53.414092, 0.0],
          [8.187188, 53.413833, 0.0],
          [8.187348, 53.413519, 0.0],
          [8.188191, 53.411472, -0.25],
          [8.188211, 53.411336, -0.25],
          [8.188166, 53.411219, -0.5],
          [8.187680, 53.410856, -1.5],
          [8.187514, 53.410698, -1.75],
          [8.187437, 53.410570, -1.5],
          [8.187415, 53.410422, -1.25],
          [8.187495, 53.410214, -1.25],
          [8.187499, 53.409978, -0.75],
          [8.187509, 53.409857, -0.5],
          [8.187543, 53.409740, -0.25],
          [8.187597, 53.409635, 0.0],
          [8.187662, 53.409554, 0.0],
          [8.187741, 53.409442, 0.25],
          [8.187795, 53.409365, 0.5],
          [8.187898, 53.409221, 1.25],
          [8.187955, 53.409141, 1.5],
          [8.188006, 53.409090, 1.5],
          [8.188113, 53.409007, 1.5],
          [8.188223, 53.408935, 1.5],
          [8.188346, 53.408870, 1.5],
          [8.188435, 53.408834, 1.5],
          [8.188634, 53.408782, 1.5],
          [8.188757, 53.408765, 1.5],
          [8.189156, 53.408747, 1.25],
          [8.189244, 53.408735, 1.5],
          [8.189308, 53.408710, 1.5],
          [8.189352, 53.408669, 1.5],
          [8.189377, 53.408628, 1.5],
          [8.189378, 53.408627, 1.5],
          [8.189482, 53.408377, 1.25],
          [8.189712, 53.407866, 1.5],
          [8.189751, 53.407766, 1.5],
          [8.191679, 53.403128, 0.75],
          [8.193173, 53.401246, 0.75],
          [8.193297, 53.401096, 0.75],
          [8.194749, 53.399328, -0.5],
          [8.201392, 53.394047, 0.25],
          [8.203282, 53.392671, 0.0],
          [8.205732, 53.390979, -1.0],
          [8.206336, 53.390676, -1.0],
          [8.207052, 53.390433, -1.25],
          [8.207305, 53.390403, -1.5],
          [8.207416, 53.390391, -1.5],
          [8.207906, 53.390281, -1.5],
          [8.208322, 53.390202, -1.0],
          [8.209291, 53.390134, -0.75],
          [8.209504, 53.390156, -0.5],
          [8.209708, 53.390195, -0.25],
          [8.210778, 53.390468, 0.0],
          [8.210927, 53.390485, 0.0],
          [8.211038, 53.390471, 0.0],
          [8.211165, 53.390421, 0.0],
          [8.211869, 53.390944, 1.0],
          [8.212002, 53.391013, 1.0],
          [8.212184, 53.391036, 1.0],
          [8.212365, 53.391046, 1.25],
          [8.214224, 53.390936, 0.0],
          [8.215193, 53.390887, -0.75],
          [8.216096, 53.390834, -0.75],
          [8.230014, 53.390027, -0.75],
          [8.230505, 53.390007, -0.75],
          [8.230999, 53.389988, -1.0],
          [8.242107, 53.390179, 0.0],
          [8.250895, 53.391711, 0.75],
          [8.255212, 53.392784, 0.0],
          [8.260011, 53.395035, 0.75],
          [8.260176, 53.395141, 0.75],
          [8.260356, 53.395236, 0.75],
          [8.260462, 53.395194, 0.75],
          [8.260600, 53.395109, 0.75],
          [8.261053, 53.394897, 0.75],
          [8.261138, 53.394843, 0.75],
          [8.260883, 53.394626, 0.0],
          [8.260828, 53.394577, 0.0],
          [8.260883, 53.394626, 0.0],
          [8.261138, 53.394843, 0.75],
          [8.261281, 53.394772, 0.75],
          [8.261374, 53.394838, 1.0],
          [8.261362, 53.394925, 1.25],
          [8.262240, 53.395666, 1.25],
          [8.264398, 53.397542, -0.25],
          [8.265294, 53.398324, 0.0],
          [8.266005, 53.398968, 0.0],
          [8.266840, 53.399704, 0.0],
          [8.268407, 53.401053, -0.25],
          [8.270392, 53.402780, 1.25],
          [8.273360, 53.405374, 0.0],
          [8.274118, 53.406027, 0.0],
          [8.274735, 53.406612, 0.25],
          [8.274800, 53.406659, 0.0],
          [8.275371, 53.407166, 1.5],
          [8.276292, 53.407903, 1.25],
          [8.276902, 53.408435, 1.5],
          [8.277303, 53.408784, 1.0],
          [8.278431, 53.409768, 1.25],
          [8.278732, 53.410030, 1.5],
          [8.279459, 53.410658, 1.0],
          [8.280478, 53.411537, 1.25],
          [8.281130, 53.412131, 0.5],
          [8.281641, 53.412581, 0.0],
          [8.281881, 53.412808, 0.0],
          [8.282193, 53.413081, 0.0],
          [8.282731, 53.413581, 0.25],
          [8.283018, 53.413820, 0.5],
          [8.283409, 53.414173, 0.75],
          [8.283718, 53.414452, 0.75],
          [8.284176, 53.414872, 0.75],
          [8.285633, 53.416279, 1.0],
          [8.286079, 53.416689, 0.5],
          [8.289005, 53.419290, 0.25],
          [8.289510, 53.419731, 0.0],
          [8.290627, 53.420542, 0.0],
          [8.291714, 53.421386, 0.25],
          [8.292627, 53.422057, 0.75],
          [8.293332, 53.422618, 1.75],
          [8.293746, 53.423035, 1.0],
          [8.296155, 53.426016, 0.0],
          [8.296379, 53.426294, 0.0],
          [8.298249, 53.426165, 0.0],
          [8.298525, 53.426146, -0.25],
          [8.300433, 53.426013, -1.0],
          [8.306661, 53.425576, -1.25],
          [8.308632, 53.425348, -1.0],
          [8.310193, 53.425166, -0.25],
          [8.310509, 53.425127, 0.0],
          [8.310404, 53.425316, -0.5],
          [8.310478, 53.425369, -0.5],
          [8.310922, 53.425686, -0.75],
          [8.311124, 53.425785, -0.5],
          [8.312246, 53.426270, -0.75],
          [8.314585, 53.427514, -1.75],
          [8.315847, 53.428177, -1.0],
          [8.316375, 53.428487, -1.5],
          [8.317115, 53.428922, -1.25],
          [8.318319, 53.429645, -0.25],
          [8.319391, 53.430262, -1.0],
          [8.323822, 53.431806, 0.0],
          [8.324100, 53.431940, -0.25],
          [8.324764, 53.432402, -0.75],
          [8.325747, 53.433110, -1.0],
          [8.326256, 53.433445, -0.25],
          [8.326552, 53.433575, -0.25],
          [8.328032, 53.434230, -0.25],
          [8.328131, 53.434274, 0.0],
          [8.328301, 53.434343, 0.0],
          [8.328718, 53.434516, 0.0],
          [8.329487, 53.434847, -0.25],
          [8.330033, 53.435078, -1.0],
          [8.330168, 53.435135, -1.0],
          [8.330619, 53.435328, -1.0],
          [8.331102, 53.435587, -1.25],
          [8.332236, 53.436379, -1.25],
          [8.332641, 53.436658, -1.25],
          [8.332789, 53.436761, -1.25],
          [8.333402, 53.437171, -2.0],
          [8.334197, 53.437510, -2.0],
          [8.337621, 53.438869, -2.0],
          [8.338297, 53.439155, -2.0],
          [8.339468, 53.439650, -0.25],
          [8.340305, 53.439983, 1.5],
          [8.340915, 53.440153, 0.5],
          [8.341021, 53.440195, 0.25],
          [8.341138, 53.440291, 0.0],
          [8.341252, 53.440441, -0.5],
          [8.341300, 53.440604, -1.0],
          [8.341306, 53.440641, -1.0],
          [8.341328, 53.440712, -1.25],
          [8.341361, 53.440821, -1.5],
          [8.341459, 53.441185, -1.75],
          [8.341640, 53.441753, -1.75],
          [8.341804, 53.442244, -0.5],
          [8.342021, 53.442456, -0.5],
          [8.342294, 53.442564, -0.5],
          [8.342859, 53.442704, -1.5],
          [8.342773, 53.442874, -1.25],
          [8.342692, 53.443083, -1.25],
          [8.342657, 53.443441, -1.0],
          [8.342649, 53.444284, 0.0],
          [8.342643, 53.444893, 1.5],
          [8.342645, 53.445782, -0.5],
          [8.342658, 53.445901, -0.75],
          [8.342775, 53.446362, -0.5],
          [8.342883, 53.446334, -0.5],
          [8.342971, 53.446337, -0.25],
          [8.342883, 53.446334, -0.5],
          [8.342775, 53.446362, -0.5],
          [8.342866, 53.446603, -0.5],
          [8.343186, 53.447538, 0.0],
          [8.343419, 53.448221, 0.75],
          [8.343658, 53.449242, 0.75],
          [8.343664, 53.449269, 0.75],
          [8.343767, 53.449776, -0.25],
          [8.343889, 53.450384, -1.0],
          [8.343952, 53.450697, -1.0],
          [8.344160, 53.451729, 0.0],
          [8.344218, 53.452030, 0.0],
          [8.344241, 53.452105, 0.0],
          [8.344430, 53.453066, -1.25],
          [8.344594, 53.453878, -2.25],
          [8.345021, 53.456028, -1.5],
          [8.345229, 53.456326, -0.75],
          [8.345479, 53.456497, -0.25],
          [8.345833, 53.456649, 0.0],
          [8.346131, 53.456717, 0.0],
          [8.346284, 53.456729, 0.0],
          [8.346417, 53.456843, 0.25],
          [8.346488, 53.456923, 0.25],
          [8.346417, 53.456843, 0.25],
          [8.346284, 53.456729, 0.0],
          [8.346322, 53.456730, 0.0],
          [8.347014, 53.456749, 0.0],
          [8.347439, 53.456753, 0.0],
          [8.347828, 53.456757, 0.5],
          [8.348219, 53.456762, 1.0],
          [8.348270, 53.456762, 1.0],
          [8.348584, 53.456765, 1.0],
          [8.349044, 53.456770, 1.0],
          [8.349440, 53.456782, 1.25],
          [8.349460, 53.456783, 1.25],
          [8.349605, 53.456788, 1.25],
          [8.350291, 53.456815, 1.25],
          [8.350337, 53.456816, 1.25],
          [8.350803, 53.456837, 1.25],
          [8.351256, 53.456868, 1.25],
          [8.351813, 53.456902, 1.25],
          [8.352126, 53.456921, 1.25],
          [8.352543, 53.456951, 1.25],
          [8.352691, 53.456961, 1.0],
          [8.352830, 53.456969, 0.75],
          [8.353281, 53.456999, 0.25],
          [8.353542, 53.457015, 0.25],
          [8.353667, 53.457024, 0.25],
          [8.353736, 53.457028, 0.25],
          [8.353940, 53.457041, 0.25],
          [8.354263, 53.457062, 0.5],
          [8.354625, 53.457085, 1.0],
          [8.354656, 53.457087, 1.0],
          [8.354746, 53.457093, 1.0],
          [8.355016, 53.457110, 1.5],
          [8.355066, 53.457114, 1.5],
          [8.355140, 53.457119, 1.5],
          [8.355540, 53.457144, 1.5],
          [8.355769, 53.457159, 1.5],
          [8.356106, 53.457181, 1.5],
          [8.356193, 53.457186, 1.5],
          [8.356640, 53.457203, 1.5],
          [8.356817, 53.457203, 1.75],
          [8.356896, 53.457195, 1.75],
          [8.356948, 53.457188, 1.75],
          [8.357415, 53.457104, 1.75],
          [8.357776, 53.457072, 2.25],
          [8.357808, 53.457074, 2.5],
          [8.358174, 53.457094, 3.0],
          [8.358474, 53.457114, 3.5],
          [8.358745, 53.457131, 3.25],
          [8.358890, 53.457141, 3.25],
          [8.359013, 53.457149, 3.25],
          [8.359345, 53.457171, 2.75],
          [8.359429, 53.457176, 2.75],
          [8.359819, 53.457202, 2.5],
          [8.359922, 53.457209, 2.25],
          [8.360863, 53.457268, 1.5],
          [8.360991, 53.457277, 1.5],
          [8.361082, 53.457283, 1.25],
          [8.361474, 53.457311, 1.0],
          [8.361627, 53.457321, 0.75],
          [8.361805, 53.457332, 0.75],
          [8.362045, 53.457347, 0.75],
          [8.362762, 53.457402, 0.75],
          [8.362805, 53.457405, 0.75],
          [8.362990, 53.457456, 0.75],
          [8.363067, 53.457503, 1.0],
          [8.363128, 53.457572, 1.0],
          [8.363140, 53.457650, 1.25],
          [8.363063, 53.458005, 2.0],
          [8.363036, 53.458141, 2.25],
          [8.362999, 53.458327, 2.5],
          [8.362987, 53.458388, 2.5],
          [8.362979, 53.458427, 2.25],
          [8.362925, 53.458698, 2.0],
          [8.362872, 53.458962, 1.5],
          [8.362806, 53.459251, 1.25],
          [8.362801, 53.459274, 1.5],
          [8.362718, 53.459694, 2.0],
          [8.362659, 53.460028, 2.75],
          [8.362637, 53.460074, 2.5],
          [8.362575, 53.460209, 2.5],
          [8.362563, 53.460270, 2.5],
          [8.362558, 53.460299, 2.5],
          [8.362671, 53.460343, 2.25],
          [8.364119, 53.461463, 0.0],
          [8.364151, 53.461505, 0.0],
          [8.364237, 53.461631, 0.0],
          [8.364850, 53.462122, -0.75],
          [8.365574, 53.462677, -0.75],
          [8.366953, 53.463771, -1.25],
          [8.367450, 53.464139, -1.0],
          [8.367554, 53.464195, -0.75],
          [8.367713, 53.464261, -0.75],
          [8.369745, 53.465838, -0.25],
          [8.370835, 53.466687, -0.75],
          [8.370854, 53.466710, -0.75],
          [8.370971, 53.466823, -0.75],
          [8.373062, 53.468453, 0.0],
          [8.373238, 53.468542, 0.25],
          [8.373539, 53.468777, 0.75],
          [8.373808, 53.468988, 1.0],
          [8.373998, 53.469158, 1.0],
          [8.374153, 53.469361, 0.75],
          [8.374473, 53.469595, 0.0],
          [8.375719, 53.470582, -1.0],
          [8.376437, 53.471121, 0.0],
          [8.379040, 53.473166, 0.0],
          [8.381080, 53.474721, -0.5],
          [8.381233, 53.474811, -0.5],
          [8.381408, 53.474823, -0.25],
          [8.381650, 53.474888, 0.0],
          [8.382192, 53.475007, 0.0],
          [8.382572, 53.475100, 0.25],
          [8.383785, 53.475398, 1.5],
          [8.384407, 53.475573, 1.25],
          [8.384677, 53.475726, 1.25],
          [8.384818, 53.475870, 1.0],
          [8.385077, 53.476173, 0.5],
          [8.385315, 53.476460, 0.0],
          [8.385607, 53.476723, 0.0],
          [8.388341, 53.478547, 0.0],
          [8.392228, 53.481141, 0.0],
          [8.392592, 53.481361, 0.5],
          [8.392894, 53.481448, 1.0],
          [8.393175, 53.481481, 1.5],
          [8.393394, 53.481480, 1.5],
          [8.393605, 53.481457, 1.5],
          [8.394224, 53.481321, 0.75],
          [8.394343, 53.481286, 0.75],
          [8.396057, 53.480922, -0.25],
          [8.396430, 53.480930, -0.5],
          [8.396586, 53.480957, -0.75],
          [8.396652, 53.480975, -0.75],
          [8.396778, 53.481012, -1.0],
          [8.396978, 53.481106, -1.0],
          [8.398028, 53.481784, -0.75],
          [8.400254, 53.483194, -1.0],
          [8.400354, 53.483298, -1.0],
          [8.400420, 53.483391, -1.0],
          [8.400600, 53.483726, -1.0],
          [8.401164, 53.484730, -1.0],
          [8.401499, 53.485168, -1.75],
          [8.401824, 53.485533, -2.0],
          [8.402176, 53.485873, -1.75],
          [8.402470, 53.486137, -1.5],
          [8.403010, 53.486589, -1.0],
          [8.403866, 53.487268, -1.0],
          [8.404612, 53.487840, -1.0],
          [8.405588, 53.488541, -1.0],
          [8.406383, 53.489125, -0.25],
          [8.406847, 53.489487, 0.0],
          [8.408106, 53.490378, -0.5],
          [8.409380, 53.491309, -1.5],
          [8.409770, 53.491503, -1.75],
          [8.410036, 53.491502, -1.75],
          [8.410244, 53.491469, -1.75],
          [8.410515, 53.491392, -1.5],
          [8.412374, 53.490610, -1.5],
          [8.413429, 53.490182, -1.75],
          [8.413941, 53.489999, -1.75],
          [8.414107, 53.489978, -1.75],
          [8.414285, 53.489978, -1.75],
          [8.414386, 53.489994, -1.5],
          [8.414504, 53.490028, -1.5],
          [8.414720, 53.490162, -1.25],
          [8.416110, 53.491504, -0.75],
          [8.416142, 53.491637, -0.5],
          [8.416198, 53.491889, -0.75],
          [8.416373, 53.492054, -0.75],
          [8.416511, 53.492122, -1.0],
          [8.417039, 53.492250, -1.25],
          [8.418709, 53.492586, -2.0],
          [8.419778, 53.492791, -1.5],
          [8.420653, 53.492973, -1.5],
          [8.420753, 53.493017, -1.5],
          [8.420827, 53.492940, -1.5],
          [8.420584, 53.492891, -1.25],
          [8.420827, 53.492940, -1.5],
          [8.421182, 53.492564, -1.0],
          [8.421562, 53.492314, -1.0],
          [8.421889, 53.492163, -1.0],
          [8.422400, 53.492000, -1.0],
          [8.423580, 53.491685, 0.0],
          [8.424788, 53.491385, 1.0],
          [8.425217, 53.491300, 0.75],
          [8.427484, 53.490726, -1.0],
          [8.427498, 53.490748, -1.0],
          [8.427466, 53.490755, -0.75],
          [8.427498, 53.490748, -1.0],
          [8.427635, 53.490914, -1.0],
          [8.428067, 53.491430, -1.25],
          [8.428078, 53.491442, -1.25],
          [8.428148, 53.491516, -1.5],
          [8.428978, 53.491001, -1.0],
          [8.429484, 53.490688, -1.0],
          [8.429845, 53.490467, -1.25],
          [8.431560, 53.489474, -0.75],
          [8.432308, 53.489050, -0.75],
          [8.433493, 53.488377, -1.0],
          [8.433958, 53.487931, 0.0],
          [8.434785, 53.487444, 0.0],
          [8.435387, 53.487140, 0.0],
          [8.435475, 53.487086, 0.0],
          [8.435551, 53.487001, 0.0],
          [8.435790, 53.486814, 0.0],
          [8.436264, 53.486597, 0.25],
          [8.436229, 53.486554, 0.25],
          [8.436422, 53.486459, 0.5],
          [8.436848, 53.486292, 0.5],
          [8.437183, 53.486139, 0.25],
          [8.437480, 53.486344, 0.5],
          [8.439230, 53.485612, 0.0],
          [8.439315, 53.485578, 0.0],
          [8.440530, 53.485103, 0.0],
          [8.442586, 53.484306, 0.0],
          [8.442827, 53.484213, -0.25],
          [8.444829, 53.483580, -0.75],
          [8.446827, 53.483092, -1.0],
          [8.448564, 53.482642, -1.0],
          [8.451810, 53.481947, -0.5],
          [8.453067, 53.481661, 0.5],
          [8.453136, 53.481747, 0.5],
          [8.453217, 53.481815, 0.5],
          [8.453344, 53.481897, 0.5],
          [8.453424, 53.481944, 0.5],
          [8.453515, 53.481981, 0.25],
          [8.453619, 53.482005, 0.25],
          [8.453727, 53.482030, 0.0],
          [8.453886, 53.482068, 0.0],
          [8.453909, 53.481982, 0.0],
          [8.454059, 53.481958, 0.0],
          [8.454063, 53.481886, 0.0],
          [8.454301, 53.481368, -0.5],
          [8.454741, 53.481282, -1.5],
          [8.456436, 53.480911, -1.25],
          [8.456865, 53.480817, -1.0],
          [8.456893, 53.480810, -1.0],
          [8.457931, 53.480584, -1.5],
          [8.459511, 53.480238, -2.0],
          [8.464980, 53.479022, -1.75],
          [8.468724, 53.478169, -1.75],
          [8.470393, 53.477852, -0.25],
          [8.470515, 53.477830, -0.25],
          [8.470877, 53.478388, -0.75],
          [8.471492, 53.479325, 1.5],
          [8.471614, 53.479510, 1.5],
          [8.471688, 53.479632, 1.25],
          [8.471736, 53.479710, 1.25],
          [8.472256, 53.480557, 0.25],
          [8.472562, 53.481074, 0.0],
          [8.472721, 53.481344, 0.25],
          [8.472961, 53.481796, 0.5],
          [8.473243, 53.482244, 1.5],
          [8.473377, 53.482456, 1.75],
          [8.473766, 53.483043, 2.0],
          [8.474026, 53.483430, 2.0],
          [8.474466, 53.484117, 2.0],
          [8.474557, 53.484263, 1.75],
          [8.474910, 53.484821, 2.5],
          [8.475204, 53.485279, 2.75],
          [8.475696, 53.486063, 2.5],
          [8.475881, 53.486357, 2.25],
          [8.475919, 53.486418, 2.25],
          [8.476202, 53.486773, 2.0],
          [8.476430, 53.487157, 1.25],
          [8.476666, 53.487440, 0.0],
          [8.477375, 53.488239, 0.0],
          [8.477759, 53.488643, 0.25],
          [8.478352, 53.489267, 1.0],
          [8.478791, 53.489777, 1.0],
          [8.479254, 53.490275, 0.5],
          [8.479560, 53.490609, 0.25],
          [8.480448, 53.491621, 0.75],
          [8.480614, 53.491809, 1.0],
          [8.480725, 53.491932, 1.0],
          [8.481271, 53.492535, 0.75],
          [8.481406, 53.492696, 0.75],
          [8.481583, 53.492904, 0.75],
          [8.481914, 53.493294, 1.0],
          [8.481948, 53.493335, 0.75],
          [8.482455, 53.493917, 0.25],
          [8.483037, 53.494569, 0.5],
          [8.483323, 53.494874, 0.0],
          [8.483524, 53.495085, 0.0],
          [8.483626, 53.495188, 0.0],
          [8.484067, 53.495636, 0.75],
          [8.484187, 53.495761, 0.75],
          [8.484675, 53.496279, 0.0],
          [8.485342, 53.496957, -0.5],
          [8.485690, 53.497329, -1.5],
          [8.486102, 53.497717, -1.75],
          [8.486493, 53.498109, -1.25],
          [8.486555, 53.498171, -1.25],
          [8.486666, 53.498247, -1.0],
          [8.486707, 53.498267, -1.0],
          [8.486858, 53.498316, -0.75],
          [8.487151, 53.498361, -0.25],
          [8.487816, 53.498346, 0.25],
          [8.488147, 53.498305, 0.5],
          [8.488365, 53.498264, 0.75],
          [8.488785, 53.498182, 0.75],
          [8.488824, 53.498258, 0.75],
          [8.488892, 53.498405, 0.75],
          [8.488953, 53.498612, 0.5],
          [8.488976, 53.498790, 0.25],
          [8.488977, 53.499152, 0.25],
          [8.488979, 53.499413, 0.25],
          [8.489080, 53.500156, 0.75],
          [8.489190, 53.500393, 0.5],
          [8.489397, 53.500703, 0.0],
          [8.489624, 53.500996, -0.25],
          [8.489699, 53.501088, -0.25],
          [8.489934, 53.501342, -0.25],
          [8.490186, 53.501586, 0.0],
          [8.490696, 53.502102, 0.25],
          [8.491962, 53.503217, 0.0],
          [8.493183, 53.504303, 0.0],
          [8.493371, 53.504482, 0.0],
          [8.493558, 53.504701, 0.0],
          [8.493624, 53.504831, 0.0],
          [8.493651, 53.505007, 0.0],
          [8.493657, 53.505244, 0.0],
          [8.493694, 53.505493, 0.0],
          [8.493761, 53.505629, 0.0],
          [8.493865, 53.505745, 0.0],
          [8.493930, 53.505834, 0.0],
          [8.494189, 53.506120, -0.25],
          [8.494290, 53.506220, -0.25],
          [8.494502, 53.506474, -0.25],
          [8.494540, 53.506515, -0.25],
          [8.495014, 53.507037, 0.25],
          [8.495302, 53.507306, 0.25],
          [8.495388, 53.507387, 0.25],
          [8.495922, 53.507869, 0.25],
          [8.496786, 53.508554, 0.25],
          [8.497318, 53.508929, 0.5],
          [8.497982, 53.509372, 0.25],
          [8.498538, 53.509724, 0.0],
          [8.499136, 53.510103, 1.0],
          [8.500413, 53.510909, 0.25],
          [8.500802, 53.511200, -0.75],
          [8.500927, 53.511142, -0.75],
          [8.500802, 53.511200, -0.75],
          [8.500863, 53.511242, -1.0],
          [8.501132, 53.511444, -1.75],
          [8.502653, 53.512582, -2.75],
          [8.503307, 53.513017, -2.5],
          [8.503655, 53.513248, -2.5],
          [8.504654, 53.513862, -2.0],
          [8.505697, 53.514486, -1.75],
          [8.506102, 53.514340, -1.0],
          [8.506992, 53.514178, 0.0],
          [8.507143, 53.514150, 0.0],
          [8.507215, 53.514131, 0.0],
          [8.508104, 53.513930, 1.25],
          [8.508177, 53.513913, 1.25],
          [8.508309, 53.513885, 1.5],
          [8.508727, 53.513773, 2.25],
          [8.510261, 53.513366, 3.5],
          [8.511454, 53.513049, 2.0],
          [8.511573, 53.513011, 1.75],
          [8.511765, 53.512950, 1.5],
          [8.512209, 53.512810, 1.25],
          [8.512376, 53.512948, 1.25],
          [8.512500, 53.513050, 1.5],
          [8.512740, 53.513413, 1.5],
          [8.512844, 53.513596, 1.25],
          [8.513667, 53.515170, -0.5],
          [8.513984, 53.515576, 0.0],
          [8.514200, 53.515674, 0.0],
          [8.514907, 53.515298, 0.75],
          [8.515833, 53.514806, 1.0],
          [8.516430, 53.514610, 2.0],
          [8.516893, 53.514536, 2.25],
          [8.517282, 53.514446, 2.25],
          [8.518282, 53.514058, 2.0],
          [8.518317, 53.513987, 2.0],
          [8.518894, 53.513871, 2.25],
          [8.519752, 53.513769, 2.0],
          [8.520267, 53.513718, 2.25],
          [8.521036, 53.513920, 3.0],
          [8.522011, 53.514256, 3.5],
          [8.522472, 53.514402, 3.0],
          [8.522612, 53.514489, 2.75],
          [8.523205, 53.514819, 2.75],
          [8.523182, 53.514845, 2.75],
          [8.523163, 53.514894, 2.75],
          [8.523020, 53.515235, 1.5],
          [8.523261, 53.515331, 1.5],
          [8.523293, 53.515343, 1.5],
          [8.523313, 53.515352, 1.5],
          [8.523443, 53.515403, 1.5],
          [8.525362, 53.516623, 1.5],
          [8.525955, 53.516329, 1.25],
          [8.527203, 53.515513, 3.25],
          [8.528522, 53.516240, 1.5],
          [8.533093, 53.518287, 3.25],
          [8.533727, 53.518570, 2.75],
          [8.534712, 53.519011, 2.5],
          [8.536803, 53.519946, 2.0],
          [8.538296, 53.520613, 2.0],
          [8.539372, 53.521118, 2.25],
          [8.539558, 53.521194, 2.0],
          [8.539633, 53.521250, 2.0],
          [8.539701, 53.521360, 2.0],
          [8.540173, 53.521360, 2.0],
          [8.540535, 53.521366, 2.0],
          [8.540587, 53.521358, 2.25],
          [8.540654, 53.521357, 2.25],
          [8.540951, 53.521361, 2.5],
          [8.541265, 53.521375, 2.75],
          [8.541518, 53.521400, 3.0],
          [8.542373, 53.521501, 3.0],
          [8.542593, 53.521519, 3.0],
          [8.542747, 53.521516, 3.25],
          [8.542878, 53.521503, 3.25],
          [8.543041, 53.521469, 3.5],
          [8.543125, 53.521440, 3.5],
          [8.543219, 53.521395, 3.5],
          [8.543266, 53.521361, 3.5],
          [8.543401, 53.521232, 3.25],
          [8.543446, 53.521179, 3.25],
          [8.543788, 53.520795, 1.75],
          [8.543843, 53.520760, 1.5],
          [8.543982, 53.520707, 1.0],
          [8.544029, 53.520690, 1.0],
          [8.544572, 53.520331, 1.0],
          [8.544681, 53.520299, 1.0],
          [8.544795, 53.520300, 1.0],
          [8.544986, 53.520347, 1.0],
          [8.545749, 53.520570, 0.0],
          [8.547803, 53.521123, 0.0],
          [8.551428, 53.522161, 0.0],
          [8.554120, 53.522992, 0.0],
          [8.557118, 53.524186, 0.0],
          [8.559491, 53.525198, 0.0],
          [8.561461, 53.526265, 0.0],
          [8.561791, 53.526444],
          [8.563668, 53.527578],
          [8.565429, 53.528884],
          [8.568529, 53.531376],
          [8.570654, 53.533141],
          [8.571921, 53.534006],
          [8.573231, 53.534646],
          [8.574399, 53.535117],
          [8.574954, 53.535314],
          [8.575546, 53.535474],
          [8.575893, 53.535545],
          [8.578996, 53.536181, -2.5],
          [8.580633, 53.536557, -1.0],
          [8.581287, 53.536724, 0.0],
          [8.581483, 53.536784, 0.25],
          [8.582152, 53.537062, 0.75],
          [8.582197, 53.537085, 0.75],
          [8.582779, 53.537347, 2.0],
          [8.584025, 53.538039, 1.75],
          [8.584095, 53.538075, 1.75],
          [8.584123, 53.538098, 1.75],
          [8.584181, 53.538141, 1.5],
          [8.584424, 53.538326, 1.5],
          [8.584490, 53.538366, 1.75],
          [8.584953, 53.538629, 2.75],
          [8.585210, 53.538775, 3.5],
          [8.585840, 53.539261, 3.75],
          [8.586347, 53.539683, 3.0],
          [8.586778, 53.540027, 2.0],
          [8.586928, 53.539971, 2.5],
          [8.587041, 53.539941, 3.0],
          [8.587093, 53.539928, 3.0],
          [8.587181, 53.539922, 3.25],
          [8.587363, 53.539922, 3.75],
          [8.587151, 53.539986, 3.0],
          [8.586631, 53.540090, 1.75],
          [8.586535, 53.540116, 1.75],
          [8.586631, 53.540090, 1.75],
          [8.586778, 53.540027, 2.0],
          [8.586928, 53.539971, 2.5],
          [8.587041, 53.539941, 3.0],
          [8.587093, 53.539928, 3.0],
          [8.587181, 53.539922, 3.25],
          [8.587363, 53.539922, 3.75],
          [8.587549, 53.539912, 4.0],
          [8.587618, 53.539910, 4.25],
          [8.588113, 53.539905, 5.5],
          [8.588556, 53.539900, 5.75],
          [8.588814, 53.539897, 5.25],
          [8.589012, 53.539896, 5.25],
          [8.589094, 53.539896, 5.0],
          [8.590018, 53.539905, 4.0],
          [8.590089, 53.539890, 4.0],
          [8.590161, 53.539879, 4.0],
          [8.590308, 53.539848, 4.0],
          [8.590324, 53.539897, 4.0],
          [8.590308, 53.539848, 4.0],
          [8.590161, 53.539879, 4.0],
          [8.590296, 53.540261, 3.25],
          [8.590388, 53.540442, 2.75],
          [8.590637, 53.540822, 2.0],
          [8.590702, 53.540940, 2.0],
          [8.590696, 53.541132, 2.25],
          [8.590816, 53.541335, 2.5],
          [8.590835, 53.541485, 2.75],
          [8.590910, 53.541701, 2.75],
          [8.591034, 53.542152, 2.75],
          [8.591094, 53.542560, 2.5],
          [8.591096, 53.542736, 2.25],
          [8.591108, 53.543087, 1.75],
          [8.591073, 53.543466, 1.5],
          [8.591171, 53.543461, 1.5],
          [8.591322, 53.543939, 1.25],
          [8.591444, 53.544082, 1.25],
          [8.592155, 53.545689, 2.75],
          [8.592310, 53.545859, 2.75],
          [8.592495, 53.546020, 2.25],
          [8.593214, 53.546571, 1.0],
          [8.593308, 53.546664, 0.75],
          [8.593351, 53.546701, 0.75],
          [8.593367, 53.546789, 0.75],
          [8.593226, 53.547325, 0.25],
          [8.593222, 53.547388, 0.0],
          [8.593258, 53.547453, 0.0],
          [8.593343, 53.547511, 0.0],
          [8.593483, 53.547541, 0.0],
          [8.593715, 53.547569, 0.0],
          [8.593835, 53.547565, 0.0],
          [8.593997, 53.547543, 0.0],
          [8.594290, 53.547535, 0.0],
          [8.594266, 53.547867, 0.0],
          [8.594127, 53.548813, 1.0],
          [8.594056, 53.549400, 1.25],
          [8.594030, 53.549816, 0.25],
          [8.594036, 53.550073, 0.0],
          [8.594035, 53.550134, 0.0],
          [8.594048, 53.550263, 0.0],
          [8.594045, 53.550437, 0.0],
          [8.594039, 53.550621, 0.0],
          [8.594035, 53.550706, 0.0],
          [8.594024, 53.550840, 0.0],
          [8.594000, 53.550972, 0.0],
          [8.593902, 53.551238, 0.0],
          [8.593804, 53.551461, 0.0],
          [8.593746, 53.551587, 0.0],
          [8.593709, 53.551692, 0.0],
          [8.593683, 53.551806, -0.25],
          [8.593553, 53.552839, -1.25],
          [8.593533, 53.553020, -0.5],
          [8.593532, 53.553028, -0.25],
          [8.593508, 53.553258, 0.25],
          [8.593454, 53.553782, 1.75],
          [8.593401, 53.554300, 2.5],
          [8.593397, 53.554341, 2.5],
          [8.593376, 53.554557, 2.0],
          [8.593314, 53.555151, 1.5],
          [8.593265, 53.555627, 1.5],
          [8.593256, 53.555713, 1.75],
          [8.593183, 53.556296, 2.25],
          [8.593156, 53.556541, 2.75],
          [8.593150, 53.556598, 2.75],
          [8.593123, 53.556832, 3.0],
          [8.593107, 53.557086, 3.0],
          [8.593064, 53.557511, 3.25],
          [8.593032, 53.557660, 3.25],
          [8.593006, 53.557859, 3.0],
          [8.593001, 53.557932, 3.0],
          [8.592993, 53.558051, 3.0],
          [8.592967, 53.558418, 3.0],
          [8.592964, 53.558452, 3.0],
          [8.592962, 53.558643, 3.5],
          [8.592964, 53.558841, 3.75],
          [8.593001, 53.559029, 4.0],
          [8.593228, 53.559328, 4.0],
          [8.593451, 53.559582, 3.75],
          [8.593649, 53.559835, 3.75],
          [8.593741, 53.560010, 4.0],
          [8.593794, 53.560190, 4.25],
          [8.593835, 53.560484, 5.0],
          [8.593832, 53.560737, 5.75],
          [8.593767, 53.561386, 6.25],
          [8.593758, 53.561508, 6.25],
          [8.593751, 53.561604, 6.25],
          [8.593749, 53.561638, 6.25],
          [8.593747, 53.561691, 6.5],
          [8.591801, 53.561743, 6.75],
          [8.590386, 53.561796, 7.5],
          [8.588922, 53.561858, 5.75],
          [8.588918, 53.561817, 5.5],
          [8.588922, 53.561858, 5.75],
          [8.588960, 53.562230, 6.5],
          [8.589033, 53.562710, 7.0],
          [8.587239, 53.562701, 7.5],
          [8.586316, 53.562678, 7.0],
          [8.586231, 53.562676, 7.0],
          [8.586273, 53.563396, 9.25],
          [8.586279, 53.563645, 8.25],
          [8.586280, 53.563672, 8.25],
          [8.586272, 53.563751, 8.0],
          [8.586249, 53.563847, 7.5],
          [8.586238, 53.563878, 7.5],
          [8.586175, 53.564098, 6.5],
          [8.586089, 53.564329, 5.75],
          [8.585900, 53.564304, 5.75],
          [8.585885, 53.564302, 5.75],
          [8.585018, 53.564235, 5.75],
          [8.584904, 53.564223, 5.75],
          [8.583390, 53.564001, 6.0],
          [8.583355, 53.563996, 5.75],
          [8.583390, 53.564001, 6.0],
          [8.582809, 53.565379, 2.25],
          [8.582484, 53.566163, 0.75],
          [8.582268, 53.566116, 0.75],
          [8.581903, 53.566533, -0.5],
          [8.581455, 53.567043, -0.5],
          [8.581057, 53.567566, -0.5],
          [8.580199, 53.568635, -0.5],
          [8.580068, 53.568857, -0.25],
          [8.579982, 53.569222, 0.0],
          [8.580087, 53.569537, -0.75],
          [8.580240, 53.569776, -1.25],
          [8.580284, 53.569945, -1.5],
          [8.580236, 53.570107, -1.5],
          [8.580027, 53.570446, -1.25],
          [8.579941, 53.570621, -1.0],
          [8.579662, 53.571349, -0.25],
          [8.579538, 53.571658, -0.5],
          [8.579471, 53.571892, -0.25],
          [8.579512, 53.572091, 0.0],
          [8.579489, 53.572258, 0.25],
          [8.579419, 53.572411, 0.25],
          [8.579189, 53.573226, 0.75],
          [8.579063, 53.573610, 1.0],
          [8.578946, 53.573888, 1.5],
          [8.578835, 53.574174, 2.0],
          [8.578466, 53.575321, 3.25],
          [8.578266, 53.575892, 3.75],
          [8.577774, 53.577139, 2.75],
          [8.577752, 53.577197, 2.75],
          [8.578579, 53.577200, 5.0],
          [8.578737, 53.577189, 5.0],
          [8.578740, 53.577369, 5.0],
          [8.578851, 53.578344, 6.5],
          [8.578822, 53.578469, 6.0],
          [8.578836, 53.578500, 5.75],
          [8.578871, 53.578580, 5.25],
          [8.578975, 53.578673, 4.5],
          [8.578980, 53.578819, 3.75],
          [8.578935, 53.578874, 3.75],
          [8.578783, 53.578959, 3.5],
          [8.578653, 53.579072, 3.0],
          [8.578592, 53.579199, 2.5],
          [8.578599, 53.579286, 2.5],
          [8.578756, 53.579473, 2.0],
          [8.578800, 53.579564, 1.75],
          [8.578792, 53.579660, 1.75],
          [8.578713, 53.579778, 1.75],
          [8.578455, 53.580153, 2.0],
          [8.578429, 53.580221, 2.0],
          [8.578430, 53.580287, 2.0],
          [8.578487, 53.580346, 2.0],
          [8.578567, 53.580390, 2.0],
          [8.579877, 53.580753, 0.75],
          [8.580223, 53.580830, 0.75],
          [8.580454, 53.580860, 1.0],
          [8.580678, 53.580939, 1.25],
          [8.580821, 53.581034, 1.25],
          [8.580891, 53.581113, 1.5],
          [8.580917, 53.581304, 2.0],
          [8.580560, 53.581283, 2.0],
          [8.580271, 53.581267, 2.0],
          [8.579563, 53.581208, 1.75],
          [8.578721, 53.581178, 2.25],
          [8.578573, 53.581190, 2.25],
          [8.578563, 53.581124, 2.25],
          [8.578342, 53.580997, 2.75],
          [8.576532, 53.580932, 1.75],
          [8.576203, 53.580993, 1.5],
          [8.576111, 53.581010, 1.5],
          [8.575871, 53.581095, 1.25],
          [8.575353, 53.581393, 1.5],
          [8.575263, 53.581495, 1.75],
          [8.574973, 53.582001, 1.75],
          [8.574885, 53.582201, 1.75],
          [8.574852, 53.582438, 1.75],
          [8.574844, 53.582782, 2.25],
          [8.574798, 53.583139, 2.25],
          [8.574721, 53.583753, 2.25],
          [8.574563, 53.583950, 1.25],
          [8.574298, 53.584194, 0.25],
          [8.574121, 53.584328, 0.25],
          [8.573882, 53.584471, 0.5],
          [8.572973, 53.584851, 1.5],
          [8.572776, 53.584970, 1.5],
          [8.572625, 53.585209, 1.5],
          [8.572865, 53.585346, 2.0],
          [8.573054, 53.585550, 2.25],
          [8.573071, 53.585805, 2.25],
          [8.572857, 53.586612, 2.5],
          [8.572835, 53.586698, 2.5],
          [8.572773, 53.586936, 2.5],
          [8.572426, 53.586996, 3.0],
          [8.572323, 53.587014, 3.0],
          [8.570042, 53.587431, 3.0],
          [8.569149, 53.587595, 3.0],
          [8.568805, 53.587676, 3.25],
          [8.567923, 53.587863, 2.5],
          [8.566874, 53.588067, 1.25],
          [8.565875, 53.588276, 2.5],
          [8.565442, 53.588344, 3.25],
          [8.564681, 53.588477, 2.75],
          [8.564425, 53.588558, 2.0],
          [8.564039, 53.588651, 1.0],
          [8.563986, 53.588698, 1.0],
          [8.563861, 53.588667, 0.5],
          [8.563738, 53.588695, 0.25],
          [8.563562, 53.588732, 0.0],
          [8.563509, 53.588737, 0.0],
          [8.563121, 53.588813, 0.5],
          [8.562720, 53.588892, 1.25],
          [8.562420, 53.588925, 2.25],
          [8.559928, 53.589499, 2.5],
          [8.559652, 53.589595, 2.25],
          [8.558713, 53.589818, 1.75],
          [8.558670, 53.589841, 1.75],
          [8.558652, 53.589866, 1.75],
          [8.558643, 53.589893, 1.75],
          [8.558664, 53.589942, 2.0],
          [8.558549, 53.589968, 2.0],
          [8.558400, 53.590002, 2.0],
          [8.558356, 53.589975, 1.75],
          [8.558301, 53.589957, 1.75],
          [8.558234, 53.589955, 1.5],
          [8.557830, 53.590039, 0.75],
          [8.557686, 53.590055, 0.25],
          [8.557199, 53.590153, -0.25],
          [8.556825, 53.590207, -0.75],
          [8.553386, 53.591011, 2.75],
          [8.553130, 53.591077, 3.0],
          [8.552755, 53.591169, 3.25],
          [8.551226, 53.591468, 2.5],
          [8.550525, 53.591588, 2.0],
          [8.549798, 53.591728, 1.75],
          [8.549279, 53.591845, 1.5],
          [8.548905, 53.591944, 1.25],
          [8.548498, 53.592071, 1.0],
          [8.548210, 53.592191, 0.5],
          [8.548073, 53.592287, 0.25],
          [8.547810, 53.592395, -0.25],
          [8.547704, 53.592419, -0.25],
          [8.547632, 53.592437, -0.5],
          [8.547333, 53.592612, -0.5],
          [8.547289, 53.592657, -0.5],
          [8.547292, 53.592712, -0.25],
          [8.547326, 53.592749, -0.25],
          [8.547229, 53.592817, 0.0],
          [8.547161, 53.592871, 0.0],
          [8.547073, 53.592852, 0.0],
          [8.546965, 53.592867, 0.0],
          [8.546854, 53.592918, 0.0],
          [8.546531, 53.593170, 0.25],
          [8.546321, 53.593406, 0.25],
          [8.545968, 53.593888, 0.0],
          [8.545807, 53.594187, 0.25],
          [8.545666, 53.594451, 0.75],
          [8.545640, 53.594493, 0.75],
          [8.545573, 53.594585, 1.0],
          [8.545454, 53.594751, 1.5],
          [8.545216, 53.595174, 1.75],
          [8.545139, 53.595354, 1.75],
          [8.544965, 53.595639, 2.0],
          [8.545000, 53.595711, 2.0],
          [8.544929, 53.595800, 2.0],
          [8.544782, 53.595970, 1.5],
          [8.544733, 53.596031, 1.5],
          [8.544636, 53.596064, 1.25],
          [8.544497, 53.596173, 1.0],
          [8.544401, 53.596233, 1.0],
          [8.544259, 53.596286, 0.75],
          [8.543769, 53.596561, 0.25],
          [8.543727, 53.596635, 0.0],
          [8.543552, 53.596733, 0.0],
          [8.543301, 53.596856, 0.0],
          [8.542988, 53.596990, 0.0],
          [8.542380, 53.597180, 0.0],
          [8.542182, 53.597250, -0.25],
          [8.541947, 53.597310, -0.5],
          [8.541483, 53.597462, -0.25],
          [8.540887, 53.597710, 0.5],
          [8.540574, 53.597865, 0.5],
          [8.540205, 53.597982, 0.0],
          [8.539225, 53.598181, 0.25],
          [8.539168, 53.598193, 0.5],
          [8.539022, 53.598176, 0.75],
          [8.538669, 53.598241, 1.25],
          [8.537688, 53.598494, 1.0],
          [8.537526, 53.598544, 0.75],
          [8.536994, 53.598705, 0.0],
          [8.536264, 53.598939, 0.0],
          [8.535870, 53.599149, 0.75],
          [8.535697, 53.599258, 1.25],
          [8.535619, 53.599234, 1.25],
          [8.535525, 53.599217, 1.25],
          [8.535376, 53.599201, 1.5],
          [8.535229, 53.599218, 1.75],
          [8.534943, 53.599315, 2.25],
          [8.534743, 53.599385, 2.75],
          [8.534387, 53.599539, 3.5],
          [8.534141, 53.599610, 4.0],
          [8.533925, 53.599396, 4.5],
          [8.533707, 53.599158, 5.0],
          [8.533536, 53.599008, 5.25],
          [8.533336, 53.598861, 5.5],
          [8.533298, 53.598834, 5.5],
          [8.533104, 53.598727, 5.5],
          [8.532478, 53.598497, 5.25],
          [8.532336, 53.598459, 5.25],
          [8.532427, 53.598395, 5.0],
          [8.532822, 53.598249, 4.75],
          [8.532912, 53.598210, 4.5],
          [8.532561, 53.597886, 3.75],
          [8.532497, 53.597812, 3.5],
          [8.532481, 53.597791, 3.5],
          [8.532465, 53.597771, 3.5],
          [8.531963, 53.597915, 3.75],
          [8.531611, 53.598014, 4.0],
          [8.531393, 53.598011, 3.75],
          [8.531371, 53.598018, 3.5],
          [8.530887, 53.598192, 3.5],
          [8.530548, 53.598363, 3.75],
          [8.530233, 53.598613, 4.5],
          [8.530048, 53.598817, 5.25],
          [8.529176, 53.600067, 3.75],
          [8.528949, 53.600436, 2.5],
          [8.528663, 53.600758, 2.0],
          [8.528079, 53.601244, 1.25],
          [8.527949, 53.601336, 1.0],
          [8.526867, 53.602107, 0.25],
          [8.525417, 53.603293, 2.25],
          [8.523515, 53.604956, 3.0],
          [8.522928, 53.605423, 2.5],
          [8.522731, 53.605688, 2.25],
          [8.522728, 53.605683, 2.0],
          [8.522540, 53.605419, 2.0],
          [8.522552, 53.605563, 2.0],
          [8.522541, 53.605726, 2.0],
          [8.522447, 53.606000, 1.5],
          [8.522329, 53.606230, 1.25],
          [8.522271, 53.606310, 1.25],
          [8.522101, 53.606477, 1.0],
          [8.522037, 53.606504, 1.0],
          [8.522035, 53.606506, 1.0],
          [8.521933, 53.606528, 1.0],
          [8.520699, 53.606354, 1.0],
          [8.520648, 53.606406, 1.0],
          [8.520447, 53.607049, 1.0],
          [8.520433, 53.607095],
          [8.519970, 53.607714],
          [8.518725, 53.608990],
          [8.518454, 53.609682],
          [8.518127, 53.610625],
          [8.518062, 53.610720],
          [8.516620, 53.612065],
          [8.516276, 53.612505],
          [8.515301, 53.613970],
          [8.514759, 53.615269],
          [8.514298, 53.616165],
          [8.513866, 53.616864],
          [8.513266, 53.617833],
          [8.512567, 53.618803, 1.0],
          [8.511744, 53.619746, 1.0],
          [8.510308, 53.621574, 1.0],
          [8.510094, 53.621836, 1.0],
          [8.509945, 53.622070, 1.0],
          [8.509738, 53.622483, 1.0],
          [8.509666, 53.622595, 1.0],
          [8.507732, 53.624517, 1.0],
          [8.506982, 53.625263],
          [8.505345, 53.627097],
          [8.505069, 53.627452],
          [8.504809, 53.627908],
          [8.504155, 53.629409],
          [8.504090, 53.629893],
          [8.504015, 53.630163],
          [8.503341, 53.631284, 2.25],
          [8.503098, 53.631667, 2.25],
          [8.503040, 53.631839, 1.75],
          [8.503126, 53.631924, 2.0],
          [8.503285, 53.631960, 2.25],
          [8.503257, 53.632012, 2.25],
          [8.503052, 53.632217, 2.25],
          [8.502975, 53.632263, 2.25],
          [8.502886, 53.632297, 2.0],
          [8.502687, 53.632341, 2.0],
          [8.502497, 53.632400, 2.0],
          [8.502359, 53.632473, 2.0],
          [8.502249, 53.632590, 1.75],
          [8.502114, 53.632794, 1.5],
          [8.502007, 53.632880, 1.5],
          [8.501398, 53.633311, 1.5],
          [8.501302, 53.633397, 0.5],
          [8.501235, 53.633478, 0.25],
          [8.500704, 53.634653, 1.0],
          [8.500655, 53.634795, 1.25],
          [8.500572, 53.635100, 1.75],
          [8.500502, 53.635238, 1.5],
          [8.500435, 53.635358, 1.5],
          [8.500336, 53.635498, 1.25],
          [8.500202, 53.635638, 1.0],
          [8.500004, 53.635916, 1.0],
          [8.499244, 53.637247, 0.25],
          [8.499151, 53.637334, 0.0],
          [8.498783, 53.637522, 0.0],
          [8.498673, 53.637613, 0.0],
          [8.498569, 53.637749, 0.0],
          [8.498518, 53.637834, 0.0],
          [8.498282, 53.638333, 0.0],
          [8.498021, 53.638820, 0.0],
          [8.498028, 53.638852, 0.25],
          [8.498915, 53.639448, 1.0],
          [8.498974, 53.639496, 1.0],
          [8.499011, 53.639567, 1.0],
          [8.499131, 53.640157, 1.0],
          [8.499160, 53.640366, 1.0],
          [8.499210, 53.640627, 0.75],
          [8.499076, 53.641031, 1.0],
          [8.499037, 53.641150, 1.0],
          [8.499014, 53.641214, 1.0],
          [8.498822, 53.641768, 1.0],
          [8.498338, 53.642568, 1.75],
          [8.498186, 53.642820, 1.5],
          [8.497708, 53.643445, 1.25],
          [8.497345, 53.643802, 0.75],
          [8.497176, 53.643970, 0.75],
          [8.496357, 53.644727, 1.25],
          [8.496077, 53.645010, 1.25],
          [8.495835, 53.645296, 1.0],
          [8.495729, 53.645552, 0.75],
          [8.495716, 53.645604, 0.75],
          [8.495541, 53.646308, 1.5],
          [8.495445, 53.646827, 2.0],
          [8.495464, 53.646965, 2.0],
          [8.495501, 53.647065, 2.0],
          [8.495494, 53.647179, 2.0],
          [8.495444, 53.647120, 2.0],
          [8.495312, 53.646966, 2.0],
          [8.494987, 53.646534, 1.75],
          [8.494762, 53.646310, 1.25],
          [8.494633, 53.646233, 1.0],
          [8.494498, 53.646205, 0.75],
          [8.494498, 53.646189, 0.5],
          [8.494510, 53.645761, 0.25],
          [8.494420, 53.645599, 0.0],
          [8.494709, 53.645260, 0.0],
          [8.495154, 53.644841, 0.0],
          [8.496092, 53.643904, 0.5],
          [8.496468, 53.643518, 1.25]
        ]
      }
    }
  ]
}

let day22: any = {
  "type": "FeatureCollection",
  "name": "tracks",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
    }
  },
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "J22 - From Wremen to Cuxhaven"
      },
      "geometry": {
        "type": "MultiLineString",
        "coordinates": [
          [
            [
              8.495885,
              53.643721
            ],
            [
              8.496033,
              53.64384
            ],
            [
              8.496071,
              53.643936
            ],
            [
              8.495993,
              53.644025
            ],
            [
              8.495918,
              53.644104
            ],
            [
              8.495828,
              53.644202
            ],
            [
              8.495753,
              53.644293
            ],
            [
              8.49566,
              53.64438
            ],
            [
              8.495576,
              53.644467
            ],
            [
              8.495493,
              53.644549
            ],
            [
              8.495387,
              53.644638
            ],
            [
              8.495292,
              53.644735
            ],
            [
              8.49519,
              53.644818
            ],
            [
              8.495077,
              53.644911
            ],
            [
              8.494996,
              53.645
            ],
            [
              8.494895,
              53.645088
            ],
            [
              8.494794,
              53.64518
            ],
            [
              8.494705,
              53.645284
            ],
            [
              8.494634,
              53.645372
            ],
            [
              8.49456,
              53.645454
            ],
            [
              8.494493,
              53.645556
            ],
            [
              8.494539,
              53.645664
            ],
            [
              8.494542,
              53.645777
            ],
            [
              8.494534,
              53.645892
            ],
            [
              8.494529,
              53.645988
            ],
            [
              8.494531,
              53.646083
            ],
            [
              8.494622,
              53.646172
            ],
            [
              8.49472,
              53.646252
            ],
            [
              8.494816,
              53.646329
            ],
            [
              8.494877,
              53.646428
            ],
            [
              8.494945,
              53.646517
            ],
            [
              8.495046,
              53.646599
            ],
            [
              8.495126,
              53.64669
            ],
            [
              8.495186,
              53.646777
            ],
            [
              8.495261,
              53.646867
            ],
            [
              8.495346,
              53.646955
            ],
            [
              8.495408,
              53.647046
            ],
            [
              8.49547,
              53.64715
            ],
            [
              8.4955,
              53.647251
            ],
            [
              8.495468,
              53.647357
            ],
            [
              8.49551,
              53.647473
            ],
            [
              8.495544,
              53.647564
            ],
            [
              8.495592,
              53.647666
            ],
            [
              8.495647,
              53.647775
            ],
            [
              8.495684,
              53.647886
            ],
            [
              8.495706,
              53.647983
            ],
            [
              8.495732,
              53.64808
            ],
            [
              8.495755,
              53.648196
            ],
            [
              8.49576,
              53.648287
            ],
            [
              8.495738,
              53.648401
            ],
            [
              8.495705,
              53.6485
            ],
            [
              8.495645,
              53.648609
            ],
            [
              8.495567,
              53.648704
            ],
            [
              8.495474,
              53.648791
            ],
            [
              8.495377,
              53.648873
            ],
            [
              8.495269,
              53.648954
            ],
            [
              8.495183,
              53.649031
            ],
            [
              8.49509,
              53.649117
            ],
            [
              8.494993,
              53.649205
            ],
            [
              8.494925,
              53.649298
            ],
            [
              8.494859,
              53.649394
            ],
            [
              8.494801,
              53.649501
            ],
            [
              8.494758,
              53.649607
            ],
            [
              8.494712,
              53.649723
            ],
            [
              8.49467,
              53.649816
            ],
            [
              8.494638,
              53.649909
            ],
            [
              8.494589,
              53.65001
            ],
            [
              8.49455,
              53.650117
            ],
            [
              8.494508,
              53.650223
            ],
            [
              8.494463,
              53.650319
            ],
            [
              8.494442,
              53.650423
            ],
            [
              8.494412,
              53.650524
            ],
            [
              8.494382,
              53.650621
            ],
            [
              8.494345,
              53.650709
            ],
            [
              8.494315,
              53.650825
            ],
            [
              8.49429,
              53.650919
            ],
            [
              8.494252,
              53.651019
            ],
            [
              8.494228,
              53.651117
            ],
            [
              8.494209,
              53.651216
            ],
            [
              8.494164,
              53.651325
            ],
            [
              8.49412,
              53.651432
            ],
            [
              8.494081,
              53.651523
            ],
            [
              8.494047,
              53.651623
            ],
            [
              8.494007,
              53.651723
            ],
            [
              8.493972,
              53.651818
            ],
            [
              8.493935,
              53.651914
            ],
            [
              8.493888,
              53.652022
            ],
            [
              8.493874,
              53.652119
            ],
            [
              8.493832,
              53.65223
            ],
            [
              8.493794,
              53.652324
            ],
            [
              8.493759,
              53.652419
            ],
            [
              8.493721,
              53.652515
            ],
            [
              8.493684,
              53.652605
            ],
            [
              8.493633,
              53.65272
            ],
            [
              8.493598,
              53.652813
            ],
            [
              8.493564,
              53.652903
            ],
            [
              8.493523,
              53.653018
            ],
            [
              8.493487,
              53.653116
            ],
            [
              8.493449,
              53.653234
            ],
            [
              8.493419,
              53.653323
            ],
            [
              8.493384,
              53.653412
            ],
            [
              8.493347,
              53.653522
            ],
            [
              8.493315,
              53.653626
            ],
            [
              8.493268,
              53.653739
            ],
            [
              8.493229,
              53.653833
            ],
            [
              8.493187,
              53.653945
            ],
            [
              8.493143,
              53.654048
            ],
            [
              8.49311,
              53.654146
            ],
            [
              8.493074,
              53.654238
            ],
            [
              8.493039,
              53.654327
            ],
            [
              8.493006,
              53.654427
            ],
            [
              8.492967,
              53.654524
            ],
            [
              8.492939,
              53.654615
            ],
            [
              8.49291,
              53.654703
            ],
            [
              8.492876,
              53.6548
            ],
            [
              8.492841,
              53.654898
            ],
            [
              8.492803,
              53.654999
            ],
            [
              8.492764,
              53.655098
            ],
            [
              8.492721,
              53.655197
            ],
            [
              8.492699,
              53.655289
            ],
            [
              8.492666,
              53.655385
            ],
            [
              8.492628,
              53.655491
            ],
            [
              8.492588,
              53.655581
            ],
            [
              8.492551,
              53.655673
            ],
            [
              8.492513,
              53.65577
            ],
            [
              8.492471,
              53.655868
            ],
            [
              8.492437,
              53.655959
            ],
            [
              8.492397,
              53.656063
            ],
            [
              8.492351,
              53.656172
            ],
            [
              8.49232,
              53.656261
            ],
            [
              8.492286,
              53.656361
            ],
            [
              8.492244,
              53.656451
            ],
            [
              8.492207,
              53.656553
            ],
            [
              8.492161,
              53.656653
            ],
            [
              8.492122,
              53.656744
            ],
            [
              8.492078,
              53.65684
            ],
            [
              8.492026,
              53.656936
            ],
            [
              8.491981,
              53.657028
            ],
            [
              8.491937,
              53.657122
            ],
            [
              8.491892,
              53.657217
            ],
            [
              8.491845,
              53.657315
            ],
            [
              8.491802,
              53.657407
            ],
            [
              8.491747,
              53.657493
            ],
            [
              8.491697,
              53.657579
            ],
            [
              8.491635,
              53.657684
            ],
            [
              8.491575,
              53.657772
            ],
            [
              8.491519,
              53.657861
            ],
            [
              8.491462,
              53.65795
            ],
            [
              8.49139,
              53.65805
            ],
            [
              8.491334,
              53.658135
            ],
            [
              8.491276,
              53.658221
            ],
            [
              8.491208,
              53.658315
            ],
            [
              8.491145,
              53.658405
            ],
            [
              8.491074,
              53.658497
            ],
            [
              8.491009,
              53.658586
            ],
            [
              8.490947,
              53.658681
            ],
            [
              8.490882,
              53.658774
            ],
            [
              8.490814,
              53.658857
            ],
            [
              8.490741,
              53.658951
            ],
            [
              8.490681,
              53.659043
            ],
            [
              8.490622,
              53.659128
            ],
            [
              8.490558,
              53.659212
            ],
            [
              8.490479,
              53.659296
            ],
            [
              8.490405,
              53.659385
            ],
            [
              8.490327,
              53.659477
            ],
            [
              8.490251,
              53.659563
            ],
            [
              8.490178,
              53.659643
            ],
            [
              8.490091,
              53.659741
            ],
            [
              8.490021,
              53.659847
            ],
            [
              8.48996,
              53.659931
            ],
            [
              8.489894,
              53.660025
            ],
            [
              8.489827,
              53.660107
            ],
            [
              8.489769,
              53.660193
            ],
            [
              8.489717,
              53.660278
            ],
            [
              8.489647,
              53.660375
            ],
            [
              8.489565,
              53.660451
            ],
            [
              8.489474,
              53.660551
            ],
            [
              8.489358,
              53.660641
            ],
            [
              8.489241,
              53.660729
            ],
            [
              8.489099,
              53.660808
            ],
            [
              8.489005,
              53.660892
            ],
            [
              8.488895,
              53.660968
            ],
            [
              8.488761,
              53.661043
            ],
            [
              8.488625,
              53.661136
            ],
            [
              8.488497,
              53.661229
            ],
            [
              8.488354,
              53.661335
            ],
            [
              8.488189,
              53.661449
            ],
            [
              8.488028,
              53.66153
            ],
            [
              8.487838,
              53.661569
            ],
            [
              8.487654,
              53.66157
            ],
            [
              8.487486,
              53.661569
            ],
            [
              8.487278,
              53.661561
            ],
            [
              8.487116,
              53.661548
            ],
            [
              8.486953,
              53.661527
            ],
            [
              8.486768,
              53.661519
            ],
            [
              8.486588,
              53.661505
            ],
            [
              8.486436,
              53.661488
            ],
            [
              8.486274,
              53.661477
            ],
            [
              8.486093,
              53.66146
            ],
            [
              8.48591,
              53.661444
            ],
            [
              8.48573,
              53.661425
            ],
            [
              8.485542,
              53.661408
            ],
            [
              8.485363,
              53.661392
            ],
            [
              8.48519,
              53.661378
            ],
            [
              8.485026,
              53.661362
            ],
            [
              8.484865,
              53.66134
            ],
            [
              8.484715,
              53.661325
            ],
            [
              8.484526,
              53.661362
            ],
            [
              8.484464,
              53.661466
            ],
            [
              8.484462,
              53.66158
            ],
            [
              8.484469,
              53.661692
            ],
            [
              8.484472,
              53.661803
            ],
            [
              8.48445,
              53.661895
            ],
            [
              8.484461,
              53.661999
            ],
            [
              8.484498,
              53.66211
            ],
            [
              8.484519,
              53.662222
            ],
            [
              8.484537,
              53.662341
            ],
            [
              8.484536,
              53.662445
            ],
            [
              8.484547,
              53.66256
            ],
            [
              8.484543,
              53.662669
            ],
            [
              8.484562,
              53.662765
            ],
            [
              8.484554,
              53.662881
            ],
            [
              8.484567,
              53.662975
            ],
            [
              8.484582,
              53.663075
            ],
            [
              8.484595,
              53.663183
            ],
            [
              8.484616,
              53.663291
            ],
            [
              8.484625,
              53.663414
            ],
            [
              8.484641,
              53.663541
            ],
            [
              8.484667,
              53.663662
            ],
            [
              8.484676,
              53.663773
            ],
            [
              8.484687,
              53.66388
            ],
            [
              8.484715,
              53.663977
            ],
            [
              8.484725,
              53.664086
            ],
            [
              8.484746,
              53.664203
            ],
            [
              8.484779,
              53.664306
            ],
            [
              8.484798,
              53.664403
            ],
            [
              8.484813,
              53.664514
            ],
            [
              8.484828,
              53.664623
            ],
            [
              8.484858,
              53.664721
            ],
            [
              8.484896,
              53.66484
            ],
            [
              8.484935,
              53.664954
            ],
            [
              8.484976,
              53.665066
            ],
            [
              8.485018,
              53.665178
            ],
            [
              8.48505,
              53.665302
            ],
            [
              8.485066,
              53.665399
            ],
            [
              8.485096,
              53.66551
            ],
            [
              8.48509,
              53.665628
            ],
            [
              8.485068,
              53.665739
            ],
            [
              8.48505,
              53.665861
            ],
            [
              8.485021,
              53.665974
            ],
            [
              8.484986,
              53.666089
            ],
            [
              8.484955,
              53.666209
            ],
            [
              8.484925,
              53.666324
            ],
            [
              8.484896,
              53.666437
            ],
            [
              8.484865,
              53.666561
            ],
            [
              8.484825,
              53.666693
            ],
            [
              8.484781,
              53.666815
            ],
            [
              8.48473,
              53.666941
            ],
            [
              8.48469,
              53.667063
            ],
            [
              8.484653,
              53.667178
            ],
            [
              8.484655,
              53.667293
            ],
            [
              8.48466,
              53.667408
            ],
            [
              8.484647,
              53.667525
            ],
            [
              8.484649,
              53.667648
            ],
            [
              8.484634,
              53.667774
            ],
            [
              8.484641,
              53.667899
            ],
            [
              8.484656,
              53.668033
            ],
            [
              8.48464,
              53.668124
            ],
            [
              8.484609,
              53.668255
            ],
            [
              8.484575,
              53.668378
            ],
            [
              8.484553,
              53.668505
            ],
            [
              8.484508,
              53.668624
            ],
            [
              8.48449,
              53.668753
            ],
            [
              8.484465,
              53.668886
            ],
            [
              8.484435,
              53.669019
            ],
            [
              8.48444,
              53.669147
            ],
            [
              8.484408,
              53.669281
            ],
            [
              8.484381,
              53.669409
            ],
            [
              8.484352,
              53.669498
            ],
            [
              8.484327,
              53.669588
            ],
            [
              8.484318,
              53.669706
            ],
            [
              8.484299,
              53.669824
            ],
            [
              8.484269,
              53.669945
            ],
            [
              8.484238,
              53.67007
            ],
            [
              8.484199,
              53.670196
            ],
            [
              8.484166,
              53.670325
            ],
            [
              8.484096,
              53.670439
            ],
            [
              8.484015,
              53.670546
            ],
            [
              8.483941,
              53.670658
            ],
            [
              8.483872,
              53.670772
            ],
            [
              8.483827,
              53.670896
            ],
            [
              8.483809,
              53.67102
            ],
            [
              8.48379,
              53.671143
            ],
            [
              8.48378,
              53.671266
            ],
            [
              8.483733,
              53.671383
            ],
            [
              8.48372,
              53.671497
            ],
            [
              8.483691,
              53.67161
            ],
            [
              8.483669,
              53.671725
            ],
            [
              8.483645,
              53.67185
            ],
            [
              8.48362,
              53.671972
            ],
            [
              8.483598,
              53.672092
            ],
            [
              8.483594,
              53.672212
            ],
            [
              8.483604,
              53.672335
            ],
            [
              8.483626,
              53.672462
            ],
            [
              8.483624,
              53.672596
            ],
            [
              8.483635,
              53.672721
            ],
            [
              8.483628,
              53.672842
            ],
            [
              8.483628,
              53.672948
            ],
            [
              8.483636,
              53.673069
            ],
            [
              8.48364,
              53.673198
            ],
            [
              8.483639,
              53.673323
            ],
            [
              8.483651,
              53.673446
            ],
            [
              8.483655,
              53.673571
            ],
            [
              8.483654,
              53.673693
            ],
            [
              8.483657,
              53.673819
            ],
            [
              8.483629,
              53.673954
            ],
            [
              8.483618,
              53.674055
            ],
            [
              8.483603,
              53.674146
            ],
            [
              8.483582,
              53.674273
            ],
            [
              8.483554,
              53.674408
            ],
            [
              8.483534,
              53.67453
            ],
            [
              8.483522,
              53.674655
            ],
            [
              8.483515,
              53.674777
            ],
            [
              8.483522,
              53.674892
            ],
            [
              8.483528,
              53.675017
            ],
            [
              8.483539,
              53.675155
            ],
            [
              8.483529,
              53.675294
            ],
            [
              8.483517,
              53.675423
            ],
            [
              8.483476,
              53.675552
            ],
            [
              8.483418,
              53.675669
            ],
            [
              8.483357,
              53.675788
            ],
            [
              8.483305,
              53.675889
            ],
            [
              8.48327,
              53.675998
            ],
            [
              8.483271,
              53.676111
            ],
            [
              8.483268,
              53.676224
            ],
            [
              8.483276,
              53.676332
            ],
            [
              8.483272,
              53.676437
            ],
            [
              8.483274,
              53.676548
            ],
            [
              8.483281,
              53.67666
            ],
            [
              8.483306,
              53.676768
            ],
            [
              8.483314,
              53.676875
            ],
            [
              8.483322,
              53.676989
            ],
            [
              8.483327,
              53.677079
            ],
            [
              8.483321,
              53.677194
            ],
            [
              8.483331,
              53.677296
            ],
            [
              8.48334,
              53.677415
            ],
            [
              8.483343,
              53.67752
            ],
            [
              8.483344,
              53.677612
            ],
            [
              8.483355,
              53.677722
            ],
            [
              8.483356,
              53.677835
            ],
            [
              8.483371,
              53.677934
            ],
            [
              8.483389,
              53.678034
            ],
            [
              8.483396,
              53.678151
            ],
            [
              8.483411,
              53.678266
            ],
            [
              8.483408,
              53.678393
            ],
            [
              8.483401,
              53.678517
            ],
            [
              8.483392,
              53.678633
            ],
            [
              8.483384,
              53.678754
            ],
            [
              8.483386,
              53.678874
            ],
            [
              8.483396,
              53.678987
            ],
            [
              8.483407,
              53.679097
            ],
            [
              8.483435,
              53.679199
            ],
            [
              8.483449,
              53.679307
            ],
            [
              8.483475,
              53.679421
            ],
            [
              8.483515,
              53.679535
            ],
            [
              8.483559,
              53.679651
            ],
            [
              8.483583,
              53.679767
            ],
            [
              8.483613,
              53.679891
            ],
            [
              8.483641,
              53.680015
            ],
            [
              8.48367,
              53.680134
            ],
            [
              8.483713,
              53.680256
            ],
            [
              8.483747,
              53.680374
            ],
            [
              8.483753,
              53.680494
            ],
            [
              8.483755,
              53.680606
            ],
            [
              8.48376,
              53.680714
            ],
            [
              8.483748,
              53.680839
            ],
            [
              8.483739,
              53.680966
            ],
            [
              8.483714,
              53.681091
            ],
            [
              8.483684,
              53.681208
            ],
            [
              8.483666,
              53.681332
            ],
            [
              8.483651,
              53.681452
            ],
            [
              8.483646,
              53.68156
            ],
            [
              8.48363,
              53.681672
            ],
            [
              8.483619,
              53.681785
            ],
            [
              8.483619,
              53.681894
            ],
            [
              8.483602,
              53.682009
            ],
            [
              8.483616,
              53.682122
            ],
            [
              8.483623,
              53.68223
            ],
            [
              8.483625,
              53.682349
            ],
            [
              8.483639,
              53.682474
            ],
            [
              8.483656,
              53.682604
            ],
            [
              8.483658,
              53.682727
            ],
            [
              8.483681,
              53.682838
            ],
            [
              8.483704,
              53.682948
            ],
            [
              8.483739,
              53.683057
            ],
            [
              8.483755,
              53.68316
            ],
            [
              8.483755,
              53.683263
            ],
            [
              8.483765,
              53.683368
            ],
            [
              8.483776,
              53.683481
            ],
            [
              8.483799,
              53.683596
            ],
            [
              8.483813,
              53.683706
            ],
            [
              8.483832,
              53.683801
            ],
            [
              8.483857,
              53.683907
            ],
            [
              8.483873,
              53.684013
            ],
            [
              8.483888,
              53.684119
            ],
            [
              8.483909,
              53.684237
            ],
            [
              8.483921,
              53.684343
            ],
            [
              8.483924,
              53.684447
            ],
            [
              8.483943,
              53.684539
            ],
            [
              8.483961,
              53.68463
            ],
            [
              8.483973,
              53.68473
            ],
            [
              8.48399,
              53.68484
            ],
            [
              8.484002,
              53.684959
            ],
            [
              8.484007,
              53.685076
            ],
            [
              8.484013,
              53.685195
            ],
            [
              8.484002,
              53.685309
            ],
            [
              8.483975,
              53.685427
            ],
            [
              8.483963,
              53.685547
            ],
            [
              8.483949,
              53.685667
            ],
            [
              8.483924,
              53.685786
            ],
            [
              8.483869,
              53.685906
            ],
            [
              8.483848,
              53.686012
            ],
            [
              8.483807,
              53.686101
            ],
            [
              8.483754,
              53.686202
            ],
            [
              8.483688,
              53.686303
            ],
            [
              8.483641,
              53.686407
            ],
            [
              8.483566,
              53.686505
            ],
            [
              8.483495,
              53.686612
            ],
            [
              8.483437,
              53.68672
            ],
            [
              8.483371,
              53.686829
            ],
            [
              8.483318,
              53.686938
            ],
            [
              8.483241,
              53.687042
            ],
            [
              8.483165,
              53.68715
            ],
            [
              8.48311,
              53.687256
            ],
            [
              8.483073,
              53.687361
            ],
            [
              8.483065,
              53.687474
            ],
            [
              8.483072,
              53.687588
            ],
            [
              8.483101,
              53.687702
            ],
            [
              8.483117,
              53.687814
            ],
            [
              8.483136,
              53.687925
            ],
            [
              8.48318,
              53.688043
            ],
            [
              8.483214,
              53.688158
            ],
            [
              8.483269,
              53.688267
            ],
            [
              8.483312,
              53.688376
            ],
            [
              8.483329,
              53.688475
            ],
            [
              8.48335,
              53.68858
            ],
            [
              8.483381,
              53.688689
            ],
            [
              8.483411,
              53.688779
            ],
            [
              8.483436,
              53.688877
            ],
            [
              8.483456,
              53.689008
            ],
            [
              8.483484,
              53.689119
            ],
            [
              8.483538,
              53.689231
            ],
            [
              8.483583,
              53.689333
            ],
            [
              8.48363,
              53.689445
            ],
            [
              8.483664,
              53.689556
            ],
            [
              8.483695,
              53.689667
            ],
            [
              8.483718,
              53.689775
            ],
            [
              8.483736,
              53.689879
            ],
            [
              8.483746,
              53.689979
            ],
            [
              8.483758,
              53.690094
            ],
            [
              8.483771,
              53.690197
            ],
            [
              8.48378,
              53.69031
            ],
            [
              8.483796,
              53.690414
            ],
            [
              8.483814,
              53.690514
            ],
            [
              8.48382,
              53.690623
            ],
            [
              8.483836,
              53.690713
            ],
            [
              8.483857,
              53.690805
            ],
            [
              8.483873,
              53.690896
            ],
            [
              8.483904,
              53.691001
            ],
            [
              8.48391,
              53.691099
            ],
            [
              8.483897,
              53.691226
            ],
            [
              8.483923,
              53.69134
            ],
            [
              8.483935,
              53.691448
            ],
            [
              8.483951,
              53.691564
            ],
            [
              8.483971,
              53.691683
            ],
            [
              8.484001,
              53.691797
            ],
            [
              8.483992,
              53.691907
            ],
            [
              8.483988,
              53.692022
            ],
            [
              8.484014,
              53.692141
            ],
            [
              8.484028,
              53.692261
            ],
            [
              8.484035,
              53.692377
            ],
            [
              8.484044,
              53.692482
            ],
            [
              8.484061,
              53.692592
            ],
            [
              8.484083,
              53.692701
            ],
            [
              8.484113,
              53.692824
            ],
            [
              8.484143,
              53.692945
            ],
            [
              8.484168,
              53.693063
            ],
            [
              8.484192,
              53.69319
            ],
            [
              8.484203,
              53.693305
            ],
            [
              8.484195,
              53.693418
            ],
            [
              8.484195,
              53.693512
            ],
            [
              8.484165,
              53.693618
            ],
            [
              8.484108,
              53.693735
            ],
            [
              8.484036,
              53.693846
            ],
            [
              8.483989,
              53.693951
            ],
            [
              8.483963,
              53.694063
            ],
            [
              8.48395,
              53.694166
            ],
            [
              8.483988,
              53.694277
            ],
            [
              8.484067,
              53.694392
            ],
            [
              8.484161,
              53.694501
            ],
            [
              8.484259,
              53.694594
            ],
            [
              8.484361,
              53.694707
            ],
            [
              8.484446,
              53.694812
            ],
            [
              8.48452,
              53.694926
            ],
            [
              8.484613,
              53.695027
            ],
            [
              8.484706,
              53.69514
            ],
            [
              8.484809,
              53.695254
            ],
            [
              8.48489,
              53.695339
            ],
            [
              8.48496,
              53.69542
            ],
            [
              8.485067,
              53.695538
            ],
            [
              8.485135,
              53.695628
            ],
            [
              8.48526,
              53.695729
            ],
            [
              8.485348,
              53.695813
            ],
            [
              8.485425,
              53.695892
            ],
            [
              8.485527,
              53.696002
            ],
            [
              8.48566,
              53.696106
            ],
            [
              8.485793,
              53.696213
            ],
            [
              8.485914,
              53.696304
            ],
            [
              8.486045,
              53.69641
            ],
            [
              8.48613,
              53.696499
            ],
            [
              8.48621,
              53.696577
            ],
            [
              8.486272,
              53.696662
            ],
            [
              8.486352,
              53.696779
            ],
            [
              8.486409,
              53.696865
            ],
            [
              8.486503,
              53.696992
            ],
            [
              8.486541,
              53.697079
            ],
            [
              8.486592,
              53.697175
            ],
            [
              8.486655,
              53.697272
            ],
            [
              8.486738,
              53.697397
            ],
            [
              8.486821,
              53.697518
            ],
            [
              8.486875,
              53.697603
            ],
            [
              8.486964,
              53.697718
            ],
            [
              8.487057,
              53.697846
            ],
            [
              8.487139,
              53.697968
            ],
            [
              8.487206,
              53.698089
            ],
            [
              8.487287,
              53.698212
            ],
            [
              8.487365,
              53.698333
            ],
            [
              8.487454,
              53.69845
            ],
            [
              8.487513,
              53.69857
            ],
            [
              8.487561,
              53.698662
            ],
            [
              8.487622,
              53.698753
            ],
            [
              8.487706,
              53.698875
            ],
            [
              8.487765,
              53.698984
            ],
            [
              8.487833,
              53.699099
            ],
            [
              8.487917,
              53.699213
            ],
            [
              8.487995,
              53.699326
            ],
            [
              8.488067,
              53.69943
            ],
            [
              8.488146,
              53.69953
            ],
            [
              8.488219,
              53.69963
            ],
            [
              8.488287,
              53.699737
            ],
            [
              8.488371,
              53.699847
            ],
            [
              8.488439,
              53.699959
            ],
            [
              8.488479,
              53.700066
            ],
            [
              8.48852,
              53.700166
            ],
            [
              8.488559,
              53.700278
            ],
            [
              8.488594,
              53.700392
            ],
            [
              8.488636,
              53.700495
            ],
            [
              8.488685,
              53.700586
            ],
            [
              8.488744,
              53.700691
            ],
            [
              8.488789,
              53.700788
            ],
            [
              8.48883,
              53.70091
            ],
            [
              8.488866,
              53.701036
            ],
            [
              8.488907,
              53.701162
            ],
            [
              8.488973,
              53.701281
            ],
            [
              8.489024,
              53.701397
            ],
            [
              8.489082,
              53.701522
            ],
            [
              8.489132,
              53.70164
            ],
            [
              8.489187,
              53.701755
            ],
            [
              8.489257,
              53.701872
            ],
            [
              8.489312,
              53.70198
            ],
            [
              8.489383,
              53.702089
            ],
            [
              8.489437,
              53.70221
            ],
            [
              8.489504,
              53.702327
            ],
            [
              8.489587,
              53.702452
            ],
            [
              8.489643,
              53.70258
            ],
            [
              8.4897,
              53.702697
            ],
            [
              8.489765,
              53.702809
            ],
            [
              8.489834,
              53.702919
            ],
            [
              8.489886,
              53.703006
            ],
            [
              8.489939,
              53.70314
            ],
            [
              8.490001,
              53.703226
            ],
            [
              8.49008,
              53.703324
            ],
            [
              8.490171,
              53.703406
            ],
            [
              8.490285,
              53.703491
            ],
            [
              8.490383,
              53.703571
            ],
            [
              8.490497,
              53.703648
            ],
            [
              8.490603,
              53.703724
            ],
            [
              8.490696,
              53.703818
            ],
            [
              8.490756,
              53.703909
            ],
            [
              8.490821,
              53.703992
            ],
            [
              8.490877,
              53.70408
            ],
            [
              8.490937,
              53.704171
            ],
            [
              8.490996,
              53.704283
            ],
            [
              8.491047,
              53.704391
            ],
            [
              8.491114,
              53.704489
            ],
            [
              8.491166,
              53.704583
            ],
            [
              8.491237,
              53.704677
            ],
            [
              8.491262,
              53.704766
            ],
            [
              8.491313,
              53.704886
            ],
            [
              8.491383,
              53.704974
            ],
            [
              8.491443,
              53.705071
            ],
            [
              8.491484,
              53.705165
            ],
            [
              8.491549,
              53.705261
            ],
            [
              8.49161,
              53.705364
            ],
            [
              8.49168,
              53.705468
            ],
            [
              8.491749,
              53.705557
            ],
            [
              8.491855,
              53.70563
            ],
            [
              8.491963,
              53.705728
            ],
            [
              8.49206,
              53.70582
            ],
            [
              8.492131,
              53.705915
            ],
            [
              8.492226,
              53.706012
            ],
            [
              8.492317,
              53.706116
            ],
            [
              8.492385,
              53.70622
            ],
            [
              8.49243,
              53.706308
            ],
            [
              8.492492,
              53.706406
            ],
            [
              8.492567,
              53.706495
            ],
            [
              8.492659,
              53.706595
            ],
            [
              8.49273,
              53.706694
            ],
            [
              8.492813,
              53.706794
            ],
            [
              8.492896,
              53.706893
            ],
            [
              8.492979,
              53.706971
            ],
            [
              8.493039,
              53.707061
            ],
            [
              8.493108,
              53.707173
            ],
            [
              8.493171,
              53.707285
            ],
            [
              8.493224,
              53.707399
            ],
            [
              8.493261,
              53.707488
            ],
            [
              8.493309,
              53.707575
            ],
            [
              8.493365,
              53.707688
            ],
            [
              8.493402,
              53.707776
            ],
            [
              8.493457,
              53.707867
            ],
            [
              8.493532,
              53.707978
            ],
            [
              8.493577,
              53.708065
            ],
            [
              8.493575,
              53.708182
            ],
            [
              8.493639,
              53.708275
            ],
            [
              8.493679,
              53.708368
            ],
            [
              8.493758,
              53.708456
            ],
            [
              8.493826,
              53.708549
            ],
            [
              8.493857,
              53.708644
            ],
            [
              8.49392,
              53.708752
            ],
            [
              8.493999,
              53.708845
            ],
            [
              8.494028,
              53.708948
            ],
            [
              8.494065,
              53.709049
            ],
            [
              8.494109,
              53.709146
            ],
            [
              8.494168,
              53.709259
            ],
            [
              8.494213,
              53.709348
            ],
            [
              8.49426,
              53.709446
            ],
            [
              8.494333,
              53.709534
            ],
            [
              8.494389,
              53.709635
            ],
            [
              8.494448,
              53.709742
            ],
            [
              8.494506,
              53.709854
            ],
            [
              8.494576,
              53.709957
            ],
            [
              8.494598,
              53.710065
            ],
            [
              8.494646,
              53.710171
            ],
            [
              8.494733,
              53.710266
            ],
            [
              8.494776,
              53.710354
            ],
            [
              8.494823,
              53.710464
            ],
            [
              8.494904,
              53.710568
            ],
            [
              8.494957,
              53.710659
            ],
            [
              8.494994,
              53.710762
            ],
            [
              8.495065,
              53.710867
            ],
            [
              8.495156,
              53.710965
            ],
            [
              8.495194,
              53.711065
            ],
            [
              8.495242,
              53.711175
            ],
            [
              8.495318,
              53.711283
            ],
            [
              8.495325,
              53.71138
            ],
            [
              8.495369,
              53.711478
            ],
            [
              8.49541,
              53.711595
            ],
            [
              8.49547,
              53.711678
            ],
            [
              8.495573,
              53.711756
            ],
            [
              8.495716,
              53.711812
            ],
            [
              8.495799,
              53.711906
            ],
            [
              8.495924,
              53.711985
            ],
            [
              8.496062,
              53.712052
            ],
            [
              8.496214,
              53.712101
            ],
            [
              8.496358,
              53.712163
            ],
            [
              8.496517,
              53.712221
            ],
            [
              8.49666,
              53.712295
            ],
            [
              8.496756,
              53.712374
            ],
            [
              8.49686,
              53.712467
            ],
            [
              8.496947,
              53.712557
            ],
            [
              8.497022,
              53.712647
            ],
            [
              8.497093,
              53.712728
            ],
            [
              8.497155,
              53.712814
            ],
            [
              8.497215,
              53.7129
            ],
            [
              8.497291,
              53.713005
            ],
            [
              8.497358,
              53.713103
            ],
            [
              8.497418,
              53.713198
            ],
            [
              8.497497,
              53.713298
            ],
            [
              8.497578,
              53.713386
            ],
            [
              8.497634,
              53.713483
            ],
            [
              8.497709,
              53.713583
            ],
            [
              8.497779,
              53.713663
            ],
            [
              8.497804,
              53.713761
            ],
            [
              8.497847,
              53.713854
            ],
            [
              8.497892,
              53.713953
            ],
            [
              8.497939,
              53.714053
            ],
            [
              8.497973,
              53.714141
            ],
            [
              8.498019,
              53.714231
            ],
            [
              8.498037,
              53.714333
            ],
            [
              8.498071,
              53.71444
            ],
            [
              8.498102,
              53.714547
            ],
            [
              8.498129,
              53.714647
            ],
            [
              8.498169,
              53.714748
            ],
            [
              8.498228,
              53.714847
            ],
            [
              8.498264,
              53.714942
            ],
            [
              8.49833,
              53.715041
            ],
            [
              8.498369,
              53.71513
            ],
            [
              8.498432,
              53.715235
            ],
            [
              8.498504,
              53.715335
            ],
            [
              8.498566,
              53.715418
            ],
            [
              8.498637,
              53.715513
            ],
            [
              8.498724,
              53.715609
            ],
            [
              8.498801,
              53.715717
            ],
            [
              8.498858,
              53.715821
            ],
            [
              8.498904,
              53.715919
            ],
            [
              8.498961,
              53.716016
            ],
            [
              8.499053,
              53.716118
            ],
            [
              8.499122,
              53.716231
            ],
            [
              8.499201,
              53.716323
            ],
            [
              8.499245,
              53.716418
            ],
            [
              8.499329,
              53.716498
            ],
            [
              8.499386,
              53.716591
            ],
            [
              8.499438,
              53.716693
            ],
            [
              8.499503,
              53.716801
            ],
            [
              8.499562,
              53.716905
            ],
            [
              8.499628,
              53.71699
            ],
            [
              8.499776,
              53.71701
            ],
            [
              8.499947,
              53.717051
            ],
            [
              8.500109,
              53.717087
            ],
            [
              8.500283,
              53.717124
            ],
            [
              8.500437,
              53.717136
            ],
            [
              8.50059,
              53.717124
            ],
            [
              8.5007,
              53.717051
            ],
            [
              8.500878,
              53.71706
            ],
            [
              8.501025,
              53.717038
            ],
            [
              8.501189,
              53.717045
            ],
            [
              8.501271,
              53.71717
            ],
            [
              8.501341,
              53.717267
            ],
            [
              8.501403,
              53.71736
            ],
            [
              8.501463,
              53.717453
            ],
            [
              8.501528,
              53.717548
            ],
            [
              8.501599,
              53.717639
            ],
            [
              8.501684,
              53.717732
            ],
            [
              8.501754,
              53.717837
            ],
            [
              8.501846,
              53.717926
            ],
            [
              8.501949,
              53.718011
            ],
            [
              8.502006,
              53.718096
            ],
            [
              8.502058,
              53.718201
            ],
            [
              8.502109,
              53.718302
            ],
            [
              8.502194,
              53.718383
            ],
            [
              8.502289,
              53.718463
            ],
            [
              8.50238,
              53.718536
            ],
            [
              8.502423,
              53.718634
            ],
            [
              8.502409,
              53.71874
            ],
            [
              8.502509,
              53.718829
            ],
            [
              8.502578,
              53.718915
            ],
            [
              8.502646,
              53.718997
            ],
            [
              8.50275,
              53.719076
            ],
            [
              8.502821,
              53.719168
            ],
            [
              8.502905,
              53.719263
            ],
            [
              8.502979,
              53.719345
            ],
            [
              8.503043,
              53.719426
            ],
            [
              8.50312,
              53.719506
            ],
            [
              8.503209,
              53.719599
            ],
            [
              8.50337,
              53.719621
            ],
            [
              8.503525,
              53.719618
            ],
            [
              8.503694,
              53.719627
            ],
            [
              8.503801,
              53.719696
            ],
            [
              8.503877,
              53.719795
            ],
            [
              8.503946,
              53.719893
            ],
            [
              8.504012,
              53.720002
            ],
            [
              8.504096,
              53.720081
            ],
            [
              8.504176,
              53.720181
            ],
            [
              8.504247,
              53.720288
            ],
            [
              8.504334,
              53.720399
            ],
            [
              8.504408,
              53.720509
            ],
            [
              8.504484,
              53.720612
            ],
            [
              8.504563,
              53.720721
            ],
            [
              8.504642,
              53.720834
            ],
            [
              8.504715,
              53.720945
            ],
            [
              8.504802,
              53.721055
            ],
            [
              8.504886,
              53.721166
            ],
            [
              8.504973,
              53.721286
            ],
            [
              8.505037,
              53.721378
            ],
            [
              8.505098,
              53.721464
            ],
            [
              8.505166,
              53.721591
            ],
            [
              8.505245,
              53.721704
            ],
            [
              8.505317,
              53.721827
            ],
            [
              8.505404,
              53.721946
            ],
            [
              8.505465,
              53.722029
            ],
            [
              8.505523,
              53.722116
            ],
            [
              8.505584,
              53.722205
            ],
            [
              8.505649,
              53.722299
            ],
            [
              8.505723,
              53.722388
            ],
            [
              8.505785,
              53.722485
            ],
            [
              8.505848,
              53.722574
            ],
            [
              8.50591,
              53.722663
            ],
            [
              8.505974,
              53.722758
            ],
            [
              8.506048,
              53.722859
            ],
            [
              8.506111,
              53.722952
            ],
            [
              8.506181,
              53.723035
            ],
            [
              8.506253,
              53.723132
            ],
            [
              8.50632,
              53.723225
            ],
            [
              8.506401,
              53.723314
            ],
            [
              8.506478,
              53.723411
            ],
            [
              8.506589,
              53.723518
            ],
            [
              8.506662,
              53.723615
            ],
            [
              8.506724,
              53.723706
            ],
            [
              8.506799,
              53.723799
            ],
            [
              8.506918,
              53.723928
            ],
            [
              8.506981,
              53.724038
            ],
            [
              8.507054,
              53.724136
            ],
            [
              8.507119,
              53.724242
            ],
            [
              8.507195,
              53.724338
            ],
            [
              8.507275,
              53.724439
            ],
            [
              8.507347,
              53.724539
            ],
            [
              8.507412,
              53.724634
            ],
            [
              8.507481,
              53.724727
            ],
            [
              8.507546,
              53.724808
            ],
            [
              8.50764,
              53.724919
            ],
            [
              8.507703,
              53.725013
            ],
            [
              8.507808,
              53.725142
            ],
            [
              8.50787,
              53.725238
            ],
            [
              8.507934,
              53.72533
            ],
            [
              8.508004,
              53.725415
            ],
            [
              8.508064,
              53.7255
            ],
            [
              8.50813,
              53.725583
            ],
            [
              8.508209,
              53.725693
            ],
            [
              8.508261,
              53.725778
            ],
            [
              8.50836,
              53.725903
            ],
            [
              8.508417,
              53.725988
            ],
            [
              8.508476,
              53.726084
            ],
            [
              8.508569,
              53.726213
            ],
            [
              8.508641,
              53.726297
            ],
            [
              8.508748,
              53.726423
            ],
            [
              8.50881,
              53.726509
            ],
            [
              8.508895,
              53.726631
            ],
            [
              8.50896,
              53.726761
            ],
            [
              8.509032,
              53.72684
            ],
            [
              8.509102,
              53.726922
            ],
            [
              8.509197,
              53.727027
            ],
            [
              8.509283,
              53.727135
            ],
            [
              8.509351,
              53.72723
            ],
            [
              8.509407,
              53.727315
            ],
            [
              8.509479,
              53.7274
            ],
            [
              8.509534,
              53.727494
            ],
            [
              8.50961,
              53.727582
            ],
            [
              8.509678,
              53.727685
            ],
            [
              8.509745,
              53.727784
            ],
            [
              8.509815,
              53.727889
            ],
            [
              8.50989,
              53.727996
            ],
            [
              8.509971,
              53.728095
            ],
            [
              8.510059,
              53.728183
            ],
            [
              8.510127,
              53.728284
            ],
            [
              8.510194,
              53.728378
            ],
            [
              8.51027,
              53.728479
            ],
            [
              8.510333,
              53.728568
            ],
            [
              8.510403,
              53.72865
            ],
            [
              8.510465,
              53.728737
            ],
            [
              8.510528,
              53.728828
            ],
            [
              8.510602,
              53.728913
            ],
            [
              8.510663,
              53.72901
            ],
            [
              8.510761,
              53.729127
            ],
            [
              8.510831,
              53.729219
            ],
            [
              8.510897,
              53.729317
            ],
            [
              8.510994,
              53.729439
            ],
            [
              8.511062,
              53.729526
            ],
            [
              8.511118,
              53.729618
            ],
            [
              8.511179,
              53.729707
            ],
            [
              8.511251,
              53.729796
            ],
            [
              8.511335,
              53.729914
            ],
            [
              8.511399,
              53.730015
            ],
            [
              8.511452,
              53.730125
            ],
            [
              8.511536,
              53.730235
            ],
            [
              8.511611,
              53.730333
            ],
            [
              8.511683,
              53.730428
            ],
            [
              8.511757,
              53.730524
            ],
            [
              8.511827,
              53.73062
            ],
            [
              8.511921,
              53.730733
            ],
            [
              8.511981,
              53.73083
            ],
            [
              8.512065,
              53.730916
            ],
            [
              8.512136,
              53.731012
            ],
            [
              8.512191,
              53.731116
            ],
            [
              8.512258,
              53.731224
            ],
            [
              8.51233,
              53.731339
            ],
            [
              8.512394,
              53.731426
            ],
            [
              8.51251,
              53.731538
            ],
            [
              8.512567,
              53.731632
            ],
            [
              8.512625,
              53.731721
            ],
            [
              8.512713,
              53.731842
            ],
            [
              8.51279,
              53.731948
            ],
            [
              8.512885,
              53.732057
            ],
            [
              8.512956,
              53.732185
            ],
            [
              8.513044,
              53.732307
            ],
            [
              8.513098,
              53.7324
            ],
            [
              8.513177,
              53.732486
            ],
            [
              8.51324,
              53.732574
            ],
            [
              8.513304,
              53.732672
            ],
            [
              8.513362,
              53.732757
            ],
            [
              8.513458,
              53.732876
            ],
            [
              8.513522,
              53.732964
            ],
            [
              8.513583,
              53.733049
            ],
            [
              8.51365,
              53.733135
            ],
            [
              8.513707,
              53.733224
            ],
            [
              8.513786,
              53.733345
            ],
            [
              8.513861,
              53.733448
            ],
            [
              8.513945,
              53.733566
            ],
            [
              8.514016,
              53.733645
            ],
            [
              8.514079,
              53.733727
            ],
            [
              8.514133,
              53.733819
            ],
            [
              8.514197,
              53.733905
            ],
            [
              8.514264,
              53.734019
            ],
            [
              8.514346,
              53.734122
            ],
            [
              8.51454,
              53.734153
            ],
            [
              8.514689,
              53.734122
            ],
            [
              8.51483,
              53.734079
            ],
            [
              8.515,
              53.734187
            ],
            [
              8.515063,
              53.734275
            ],
            [
              8.515133,
              53.734375
            ],
            [
              8.515202,
              53.734481
            ],
            [
              8.51526,
              53.734566
            ],
            [
              8.51534,
              53.734674
            ],
            [
              8.515428,
              53.734778
            ],
            [
              8.515506,
              53.734884
            ],
            [
              8.515583,
              53.734993
            ],
            [
              8.51566,
              53.735102
            ],
            [
              8.515718,
              53.735186
            ],
            [
              8.515792,
              53.735295
            ],
            [
              8.515858,
              53.735389
            ],
            [
              8.515905,
              53.735476
            ],
            [
              8.515965,
              53.735565
            ],
            [
              8.516032,
              53.735647
            ],
            [
              8.516123,
              53.735742
            ],
            [
              8.516246,
              53.735889
            ],
            [
              8.516336,
              53.736034
            ],
            [
              8.516411,
              53.736126
            ],
            [
              8.516481,
              53.736212
            ],
            [
              8.51656,
              53.736312
            ],
            [
              8.516638,
              53.736404
            ],
            [
              8.516707,
              53.736496
            ],
            [
              8.516754,
              53.736597
            ],
            [
              8.516809,
              53.736695
            ],
            [
              8.516889,
              53.736777
            ],
            [
              8.517015,
              53.736858
            ],
            [
              8.517013,
              53.73696
            ],
            [
              8.51689,
              53.737048
            ],
            [
              8.516779,
              53.737145
            ],
            [
              8.516694,
              53.737249
            ],
            [
              8.516544,
              53.737306
            ],
            [
              8.516412,
              53.737381
            ],
            [
              8.516356,
              53.737466
            ],
            [
              8.516259,
              53.737547
            ],
            [
              8.516157,
              53.737646
            ],
            [
              8.516071,
              53.737761
            ],
            [
              8.515963,
              53.737865
            ],
            [
              8.515848,
              53.73796
            ],
            [
              8.515704,
              53.738033
            ],
            [
              8.515538,
              53.738002
            ],
            [
              8.515347,
              53.737967
            ],
            [
              8.515184,
              53.737986
            ],
            [
              8.51501,
              53.73796
            ],
            [
              8.514994,
              53.737864
            ],
            [
              8.515134,
              53.737828
            ],
            [
              8.514964,
              53.737944
            ],
            [
              8.514857,
              53.73801
            ],
            [
              8.514758,
              53.738089
            ],
            [
              8.514366,
              53.738227
            ],
            [
              8.514501,
              53.738178
            ],
            [
              8.514419,
              53.738255
            ],
            [
              8.514624,
              53.738163
            ],
            [
              8.514765,
              53.738095
            ],
            [
              8.514867,
              53.738019
            ],
            [
              8.51498,
              53.737936
            ],
            [
              8.515119,
              53.737988
            ],
            [
              8.515312,
              53.737955
            ],
            [
              8.515435,
              53.737869
            ],
            [
              8.515518,
              53.737748
            ],
            [
              8.515595,
              53.737648
            ],
            [
              8.515639,
              53.737557
            ],
            [
              8.515735,
              53.737432
            ],
            [
              8.515807,
              53.737352
            ],
            [
              8.51591,
              53.737238
            ],
            [
              8.516019,
              53.737141
            ],
            [
              8.516164,
              53.737071
            ],
            [
              8.516353,
              53.737053
            ],
            [
              8.516537,
              53.737059
            ],
            [
              8.516693,
              53.737079
            ],
            [
              8.516858,
              53.737096
            ],
            [
              8.517009,
              53.737108
            ],
            [
              8.517191,
              53.73713
            ],
            [
              8.517344,
              53.737156
            ],
            [
              8.517491,
              53.737183
            ],
            [
              8.517644,
              53.737204
            ],
            [
              8.51777,
              53.737154
            ],
            [
              8.51792,
              53.737229
            ],
            [
              8.518095,
              53.737273
            ],
            [
              8.518289,
              53.737234
            ],
            [
              8.518423,
              53.73715
            ],
            [
              8.518554,
              53.737064
            ],
            [
              8.518723,
              53.736964
            ],
            [
              8.518874,
              53.736879
            ],
            [
              8.518985,
              53.736818
            ],
            [
              8.519105,
              53.736744
            ],
            [
              8.519219,
              53.736666
            ],
            [
              8.519343,
              53.736579
            ],
            [
              8.519464,
              53.736506
            ],
            [
              8.519619,
              53.736415
            ],
            [
              8.519732,
              53.736342
            ],
            [
              8.519734,
              53.736247
            ],
            [
              8.519626,
              53.736312
            ],
            [
              8.519622,
              53.736395
            ],
            [
              8.51966,
              53.736223
            ],
            [
              8.519811,
              53.736283
            ],
            [
              8.519792,
              53.73638
            ],
            [
              8.519682,
              53.736454
            ],
            [
              8.519554,
              53.736535
            ],
            [
              8.519425,
              53.736611
            ],
            [
              8.519316,
              53.736688
            ],
            [
              8.519209,
              53.736757
            ],
            [
              8.519111,
              53.736831
            ],
            [
              8.518994,
              53.736909
            ],
            [
              8.518864,
              53.736955
            ],
            [
              8.518738,
              53.737028
            ],
            [
              8.518614,
              53.737093
            ],
            [
              8.518521,
              53.737168
            ],
            [
              8.518402,
              53.737234
            ],
            [
              8.518271,
              53.737286
            ],
            [
              8.51813,
              53.737348
            ],
            [
              8.518092,
              53.737446
            ],
            [
              8.518109,
              53.737539
            ],
            [
              8.518126,
              53.737638
            ],
            [
              8.518171,
              53.737744
            ],
            [
              8.518168,
              53.737862
            ],
            [
              8.518174,
              53.737956
            ],
            [
              8.518184,
              53.738054
            ],
            [
              8.518184,
              53.738151
            ],
            [
              8.518201,
              53.738245
            ],
            [
              8.518262,
              53.738352
            ],
            [
              8.518317,
              53.738454
            ],
            [
              8.518415,
              53.738551
            ],
            [
              8.518511,
              53.738624
            ],
            [
              8.518605,
              53.738698
            ],
            [
              8.518702,
              53.738773
            ],
            [
              8.518814,
              53.738842
            ],
            [
              8.518923,
              53.73892
            ],
            [
              8.519019,
              53.738997
            ],
            [
              8.519125,
              53.739067
            ],
            [
              8.519231,
              53.739149
            ],
            [
              8.51935,
              53.739237
            ],
            [
              8.51951,
              53.739371
            ],
            [
              8.519619,
              53.739441
            ],
            [
              8.519734,
              53.739518
            ],
            [
              8.519839,
              53.739611
            ],
            [
              8.519954,
              53.739697
            ],
            [
              8.520076,
              53.739781
            ],
            [
              8.52019,
              53.739862
            ],
            [
              8.520309,
              53.739939
            ],
            [
              8.520414,
              53.740017
            ],
            [
              8.520518,
              53.740097
            ],
            [
              8.520624,
              53.740173
            ],
            [
              8.52073,
              53.740245
            ],
            [
              8.520833,
              53.740319
            ],
            [
              8.520939,
              53.740393
            ],
            [
              8.521082,
              53.740451
            ],
            [
              8.521261,
              53.740505
            ],
            [
              8.521432,
              53.740573
            ],
            [
              8.521629,
              53.740616
            ],
            [
              8.521784,
              53.740622
            ],
            [
              8.521935,
              53.740666
            ],
            [
              8.522089,
              53.740743
            ],
            [
              8.522216,
              53.740818
            ],
            [
              8.522348,
              53.740936
            ],
            [
              8.522455,
              53.741002
            ],
            [
              8.52257,
              53.741067
            ],
            [
              8.522666,
              53.741153
            ],
            [
              8.522808,
              53.74126
            ],
            [
              8.522916,
              53.741331
            ],
            [
              8.523021,
              53.7414
            ],
            [
              8.523125,
              53.741465
            ],
            [
              8.523262,
              53.741554
            ],
            [
              8.523394,
              53.741648
            ],
            [
              8.523529,
              53.741747
            ],
            [
              8.523665,
              53.741847
            ],
            [
              8.523798,
              53.741945
            ],
            [
              8.52393,
              53.742039
            ],
            [
              8.524073,
              53.742133
            ],
            [
              8.524197,
              53.742234
            ],
            [
              8.52433,
              53.742325
            ],
            [
              8.524465,
              53.742418
            ],
            [
              8.524599,
              53.742514
            ],
            [
              8.524726,
              53.74261
            ],
            [
              8.524864,
              53.742705
            ],
            [
              8.524994,
              53.742797
            ],
            [
              8.525123,
              53.742889
            ],
            [
              8.525246,
              53.742987
            ],
            [
              8.525373,
              53.743075
            ],
            [
              8.525503,
              53.743161
            ],
            [
              8.525635,
              53.743252
            ],
            [
              8.525764,
              53.74335
            ],
            [
              8.525891,
              53.743445
            ],
            [
              8.526006,
              53.74353
            ],
            [
              8.526123,
              53.743601
            ],
            [
              8.526207,
              53.743699
            ],
            [
              8.52629,
              53.743782
            ],
            [
              8.52639,
              53.743862
            ],
            [
              8.526492,
              53.743969
            ],
            [
              8.526592,
              53.744066
            ],
            [
              8.526674,
              53.744174
            ],
            [
              8.526739,
              53.744288
            ],
            [
              8.526867,
              53.744493
            ],
            [
              8.526931,
              53.744596
            ],
            [
              8.526995,
              53.744689
            ],
            [
              8.527075,
              53.74479
            ],
            [
              8.527151,
              53.7449
            ],
            [
              8.527232,
              53.745006
            ],
            [
              8.527309,
              53.745114
            ],
            [
              8.527394,
              53.745221
            ],
            [
              8.527469,
              53.745331
            ],
            [
              8.527552,
              53.745462
            ],
            [
              8.52761,
              53.74555
            ],
            [
              8.527692,
              53.745676
            ],
            [
              8.52775,
              53.745765
            ],
            [
              8.5278,
              53.745852
            ],
            [
              8.527851,
              53.745944
            ],
            [
              8.527948,
              53.746071
            ],
            [
              8.527998,
              53.746162
            ],
            [
              8.528065,
              53.746261
            ],
            [
              8.528134,
              53.746345
            ],
            [
              8.528201,
              53.746428
            ],
            [
              8.528263,
              53.746527
            ],
            [
              8.528345,
              53.746622
            ],
            [
              8.528403,
              53.746711
            ],
            [
              8.528469,
              53.746793
            ],
            [
              8.528531,
              53.746881
            ],
            [
              8.528606,
              53.746969
            ],
            [
              8.528684,
              53.747089
            ],
            [
              8.528746,
              53.747208
            ],
            [
              8.528811,
              53.747295
            ],
            [
              8.528879,
              53.747422
            ],
            [
              8.528956,
              53.747539
            ],
            [
              8.528998,
              53.747626
            ],
            [
              8.529045,
              53.747737
            ],
            [
              8.529095,
              53.747853
            ],
            [
              8.529127,
              53.747946
            ],
            [
              8.529157,
              53.748034
            ],
            [
              8.529199,
              53.748126
            ],
            [
              8.529259,
              53.74822
            ],
            [
              8.529316,
              53.748352
            ],
            [
              8.529354,
              53.748446
            ],
            [
              8.529413,
              53.748578
            ],
            [
              8.529468,
              53.748697
            ],
            [
              8.529509,
              53.748786
            ],
            [
              8.529549,
              53.748874
            ],
            [
              8.529597,
              53.748961
            ],
            [
              8.529648,
              53.749061
            ],
            [
              8.529685,
              53.749153
            ],
            [
              8.52972,
              53.749244
            ],
            [
              8.529757,
              53.749334
            ],
            [
              8.529795,
              53.749426
            ],
            [
              8.529828,
              53.749521
            ],
            [
              8.529867,
              53.749616
            ],
            [
              8.529912,
              53.749711
            ],
            [
              8.529955,
              53.749815
            ],
            [
              8.530008,
              53.749918
            ],
            [
              8.530052,
              53.750028
            ],
            [
              8.530095,
              53.750127
            ],
            [
              8.530139,
              53.750232
            ],
            [
              8.530188,
              53.750341
            ],
            [
              8.530251,
              53.75044
            ],
            [
              8.530306,
              53.750548
            ],
            [
              8.53036,
              53.750651
            ],
            [
              8.530397,
              53.750762
            ],
            [
              8.53044,
              53.75086
            ],
            [
              8.530498,
              53.750961
            ],
            [
              8.53055,
              53.751057
            ],
            [
              8.530592,
              53.75116
            ],
            [
              8.53063,
              53.751268
            ],
            [
              8.530678,
              53.751375
            ],
            [
              8.530723,
              53.751482
            ],
            [
              8.530768,
              53.751579
            ],
            [
              8.530802,
              53.751674
            ],
            [
              8.530843,
              53.751776
            ],
            [
              8.530891,
              53.751882
            ],
            [
              8.530941,
              53.751991
            ],
            [
              8.530979,
              53.752095
            ],
            [
              8.531035,
              53.752199
            ],
            [
              8.531088,
              53.752304
            ],
            [
              8.531139,
              53.752403
            ],
            [
              8.531183,
              53.752502
            ],
            [
              8.531223,
              53.752615
            ],
            [
              8.531271,
              53.752716
            ],
            [
              8.531324,
              53.752814
            ],
            [
              8.531368,
              53.752921
            ],
            [
              8.531412,
              53.753021
            ],
            [
              8.531474,
              53.753123
            ],
            [
              8.53152,
              53.753213
            ],
            [
              8.53156,
              53.753304
            ],
            [
              8.531602,
              53.753395
            ],
            [
              8.531638,
              53.753492
            ],
            [
              8.531668,
              53.753592
            ],
            [
              8.531708,
              53.753693
            ],
            [
              8.531753,
              53.753783
            ],
            [
              8.531812,
              53.753868
            ],
            [
              8.531861,
              53.753957
            ],
            [
              8.531905,
              53.754053
            ],
            [
              8.531939,
              53.754152
            ],
            [
              8.531985,
              53.75425
            ],
            [
              8.532036,
              53.754356
            ],
            [
              8.53207,
              53.754454
            ],
            [
              8.532109,
              53.754549
            ],
            [
              8.532156,
              53.754639
            ],
            [
              8.5322,
              53.754743
            ],
            [
              8.532279,
              53.754874
            ],
            [
              8.532333,
              53.754967
            ],
            [
              8.532397,
              53.755061
            ],
            [
              8.532465,
              53.755147
            ],
            [
              8.532546,
              53.755261
            ],
            [
              8.532603,
              53.755346
            ],
            [
              8.5327,
              53.755449
            ],
            [
              8.532769,
              53.755554
            ],
            [
              8.532837,
              53.755656
            ],
            [
              8.532909,
              53.755753
            ],
            [
              8.532991,
              53.755848
            ],
            [
              8.533067,
              53.755949
            ],
            [
              8.533141,
              53.756061
            ],
            [
              8.533202,
              53.756168
            ],
            [
              8.533258,
              53.756263
            ],
            [
              8.533327,
              53.756358
            ],
            [
              8.533403,
              53.756467
            ],
            [
              8.533457,
              53.756561
            ],
            [
              8.533536,
              53.756673
            ],
            [
              8.533626,
              53.756783
            ],
            [
              8.533704,
              53.756897
            ],
            [
              8.533787,
              53.757008
            ],
            [
              8.533879,
              53.757127
            ],
            [
              8.53397,
              53.75725
            ],
            [
              8.534059,
              53.757368
            ],
            [
              8.534146,
              53.757478
            ],
            [
              8.534216,
              53.7576
            ],
            [
              8.534272,
              53.757687
            ],
            [
              8.534374,
              53.757796
            ],
            [
              8.534434,
              53.757882
            ],
            [
              8.534516,
              53.758016
            ],
            [
              8.534568,
              53.758101
            ],
            [
              8.534658,
              53.758216
            ],
            [
              8.534732,
              53.758306
            ],
            [
              8.534787,
              53.758392
            ],
            [
              8.534858,
              53.758483
            ],
            [
              8.534911,
              53.758571
            ],
            [
              8.535002,
              53.758687
            ],
            [
              8.535089,
              53.758796
            ],
            [
              8.53516,
              53.758915
            ],
            [
              8.535248,
              53.759025
            ],
            [
              8.535321,
              53.759137
            ],
            [
              8.535395,
              53.759246
            ],
            [
              8.535465,
              53.759358
            ],
            [
              8.535549,
              53.759471
            ],
            [
              8.535625,
              53.759581
            ],
            [
              8.535707,
              53.759696
            ],
            [
              8.535785,
              53.759807
            ],
            [
              8.535864,
              53.759923
            ],
            [
              8.535955,
              53.760039
            ],
            [
              8.536044,
              53.760164
            ],
            [
              8.536132,
              53.760279
            ],
            [
              8.536214,
              53.760401
            ],
            [
              8.53628,
              53.760483
            ],
            [
              8.536365,
              53.760599
            ],
            [
              8.536449,
              53.760714
            ],
            [
              8.536507,
              53.760798
            ],
            [
              8.536558,
              53.760888
            ],
            [
              8.536623,
              53.760972
            ],
            [
              8.536684,
              53.761055
            ],
            [
              8.536744,
              53.76114
            ],
            [
              8.536832,
              53.761259
            ],
            [
              8.536918,
              53.761381
            ],
            [
              8.537016,
              53.761496
            ],
            [
              8.537111,
              53.761613
            ],
            [
              8.537226,
              53.761727
            ],
            [
              8.537317,
              53.761803
            ],
            [
              8.537481,
              53.761898
            ],
            [
              8.537653,
              53.761984
            ],
            [
              8.537767,
              53.762049
            ],
            [
              8.537894,
              53.762109
            ],
            [
              8.538063,
              53.762193
            ],
            [
              8.538223,
              53.762226
            ],
            [
              8.538328,
              53.762159
            ],
            [
              8.538209,
              53.762221
            ],
            [
              8.53828,
              53.76231
            ],
            [
              8.538411,
              53.762364
            ],
            [
              8.538554,
              53.762434
            ],
            [
              8.538683,
              53.762512
            ],
            [
              8.538804,
              53.762585
            ],
            [
              8.538922,
              53.762651
            ],
            [
              8.53907,
              53.76272
            ],
            [
              8.539216,
              53.762793
            ],
            [
              8.539371,
              53.762877
            ],
            [
              8.539512,
              53.762947
            ],
            [
              8.539647,
              53.763021
            ],
            [
              8.539777,
              53.763091
            ],
            [
              8.539898,
              53.763154
            ],
            [
              8.540042,
              53.763226
            ],
            [
              8.540187,
              53.763306
            ],
            [
              8.540337,
              53.763377
            ],
            [
              8.54049,
              53.763464
            ],
            [
              8.540631,
              53.763547
            ],
            [
              8.540747,
              53.763614
            ],
            [
              8.540906,
              53.763686
            ],
            [
              8.541026,
              53.763758
            ],
            [
              8.54116,
              53.763819
            ],
            [
              8.541298,
              53.763894
            ],
            [
              8.541444,
              53.763971
            ],
            [
              8.541595,
              53.764047
            ],
            [
              8.541742,
              53.764114
            ],
            [
              8.541878,
              53.764182
            ],
            [
              8.542013,
              53.764252
            ],
            [
              8.542145,
              53.764322
            ],
            [
              8.542279,
              53.764393
            ],
            [
              8.542412,
              53.764465
            ],
            [
              8.542535,
              53.764539
            ],
            [
              8.542674,
              53.764603
            ],
            [
              8.542815,
              53.76467
            ],
            [
              8.542954,
              53.764746
            ],
            [
              8.543091,
              53.764821
            ],
            [
              8.543223,
              53.764893
            ],
            [
              8.543355,
              53.764967
            ],
            [
              8.543492,
              53.765038
            ],
            [
              8.543614,
              53.765101
            ],
            [
              8.543733,
              53.765166
            ],
            [
              8.543862,
              53.765234
            ],
            [
              8.543985,
              53.765315
            ],
            [
              8.544085,
              53.765409
            ],
            [
              8.544169,
              53.76551
            ],
            [
              8.544243,
              53.765629
            ],
            [
              8.544279,
              53.765724
            ],
            [
              8.544328,
              53.765843
            ],
            [
              8.544371,
              53.765973
            ],
            [
              8.544409,
              53.766063
            ],
            [
              8.544447,
              53.766189
            ],
            [
              8.544485,
              53.766306
            ],
            [
              8.544524,
              53.766414
            ],
            [
              8.544576,
              53.766535
            ],
            [
              8.544611,
              53.76665
            ],
            [
              8.544652,
              53.766769
            ],
            [
              8.544696,
              53.766881
            ],
            [
              8.544734,
              53.766996
            ],
            [
              8.544778,
              53.767112
            ],
            [
              8.544822,
              53.767222
            ],
            [
              8.544873,
              53.767345
            ],
            [
              8.544903,
              53.767464
            ],
            [
              8.544954,
              53.767586
            ],
            [
              8.545001,
              53.767714
            ],
            [
              8.545041,
              53.76782
            ],
            [
              8.545082,
              53.767928
            ],
            [
              8.545122,
              53.768038
            ],
            [
              8.545156,
              53.768154
            ],
            [
              8.545201,
              53.768269
            ],
            [
              8.545234,
              53.768385
            ],
            [
              8.545268,
              53.768507
            ],
            [
              8.545306,
              53.768624
            ],
            [
              8.545353,
              53.768724
            ],
            [
              8.545385,
              53.768834
            ],
            [
              8.545435,
              53.76895
            ],
            [
              8.545487,
              53.769071
            ],
            [
              8.545531,
              53.769193
            ],
            [
              8.545564,
              53.769321
            ],
            [
              8.545613,
              53.769436
            ],
            [
              8.545669,
              53.769557
            ],
            [
              8.54572,
              53.769677
            ],
            [
              8.545763,
              53.769797
            ],
            [
              8.545808,
              53.769911
            ],
            [
              8.545855,
              53.770022
            ],
            [
              8.545897,
              53.770138
            ],
            [
              8.545948,
              53.770259
            ],
            [
              8.54599,
              53.770378
            ],
            [
              8.546031,
              53.770493
            ],
            [
              8.546076,
              53.77061
            ],
            [
              8.54612,
              53.770726
            ],
            [
              8.546159,
              53.770832
            ],
            [
              8.546198,
              53.77095
            ],
            [
              8.546242,
              53.771065
            ],
            [
              8.546286,
              53.771178
            ],
            [
              8.546322,
              53.7713
            ],
            [
              8.546365,
              53.771416
            ],
            [
              8.546401,
              53.771529
            ],
            [
              8.546449,
              53.771643
            ],
            [
              8.546486,
              53.771755
            ],
            [
              8.546519,
              53.771869
            ],
            [
              8.54656,
              53.77198
            ],
            [
              8.546598,
              53.772092
            ],
            [
              8.54665,
              53.772196
            ],
            [
              8.54669,
              53.772306
            ],
            [
              8.546721,
              53.772419
            ],
            [
              8.54676,
              53.772533
            ],
            [
              8.546801,
              53.772645
            ],
            [
              8.546843,
              53.772758
            ],
            [
              8.546887,
              53.77287
            ],
            [
              8.546922,
              53.772987
            ],
            [
              8.546968,
              53.773106
            ],
            [
              8.547001,
              53.773221
            ],
            [
              8.547048,
              53.773338
            ],
            [
              8.547084,
              53.773457
            ],
            [
              8.547127,
              53.773575
            ],
            [
              8.547157,
              53.773685
            ],
            [
              8.547198,
              53.773792
            ],
            [
              8.547239,
              53.77391
            ],
            [
              8.547284,
              53.774026
            ],
            [
              8.547328,
              53.774137
            ],
            [
              8.547367,
              53.774249
            ],
            [
              8.547411,
              53.774357
            ],
            [
              8.547458,
              53.77447
            ],
            [
              8.547511,
              53.774592
            ],
            [
              8.547551,
              53.774713
            ],
            [
              8.5476,
              53.774829
            ],
            [
              8.547658,
              53.774954
            ],
            [
              8.5477,
              53.77507
            ],
            [
              8.547746,
              53.775188
            ],
            [
              8.547786,
              53.775309
            ],
            [
              8.547817,
              53.775428
            ],
            [
              8.54785,
              53.775546
            ],
            [
              8.547884,
              53.775666
            ],
            [
              8.547925,
              53.77578
            ],
            [
              8.547965,
              53.775889
            ],
            [
              8.548,
              53.775996
            ],
            [
              8.548036,
              53.77609
            ],
            [
              8.548083,
              53.776189
            ],
            [
              8.548124,
              53.776295
            ],
            [
              8.548165,
              53.776406
            ],
            [
              8.548208,
              53.776525
            ],
            [
              8.548234,
              53.776643
            ],
            [
              8.548266,
              53.776751
            ],
            [
              8.548302,
              53.776851
            ],
            [
              8.548346,
              53.776959
            ],
            [
              8.548396,
              53.777074
            ],
            [
              8.54843,
              53.777186
            ],
            [
              8.548462,
              53.777291
            ],
            [
              8.548497,
              53.777389
            ],
            [
              8.548544,
              53.777487
            ],
            [
              8.548572,
              53.777583
            ],
            [
              8.548608,
              53.777685
            ],
            [
              8.548654,
              53.777792
            ],
            [
              8.54869,
              53.777906
            ],
            [
              8.548715,
              53.778007
            ],
            [
              8.548753,
              53.778121
            ],
            [
              8.548798,
              53.778234
            ],
            [
              8.54883,
              53.778336
            ],
            [
              8.548852,
              53.778441
            ],
            [
              8.548888,
              53.778541
            ],
            [
              8.548923,
              53.778644
            ],
            [
              8.548971,
              53.778757
            ],
            [
              8.549005,
              53.778861
            ],
            [
              8.549043,
              53.778952
            ],
            [
              8.549071,
              53.77906
            ],
            [
              8.549095,
              53.779163
            ],
            [
              8.549137,
              53.779263
            ],
            [
              8.549177,
              53.779358
            ],
            [
              8.549222,
              53.779458
            ],
            [
              8.549256,
              53.77956
            ],
            [
              8.549306,
              53.779674
            ],
            [
              8.549335,
              53.779765
            ],
            [
              8.549374,
              53.779882
            ],
            [
              8.549404,
              53.779971
            ],
            [
              8.549442,
              53.780058
            ],
            [
              8.549474,
              53.780159
            ],
            [
              8.549507,
              53.780254
            ],
            [
              8.549538,
              53.780343
            ],
            [
              8.549582,
              53.780458
            ],
            [
              8.549611,
              53.780573
            ],
            [
              8.549632,
              53.780667
            ],
            [
              8.549654,
              53.780759
            ],
            [
              8.549683,
              53.780855
            ],
            [
              8.549721,
              53.780949
            ],
            [
              8.549763,
              53.781047
            ],
            [
              8.549798,
              53.781142
            ],
            [
              8.549845,
              53.781241
            ],
            [
              8.549872,
              53.78134
            ],
            [
              8.549906,
              53.78144
            ],
            [
              8.549946,
              53.781528
            ],
            [
              8.549993,
              53.781624
            ],
            [
              8.550039,
              53.781721
            ],
            [
              8.550081,
              53.781817
            ],
            [
              8.550115,
              53.781913
            ],
            [
              8.550142,
              53.782007
            ],
            [
              8.550187,
              53.782103
            ],
            [
              8.550258,
              53.782198
            ],
            [
              8.550296,
              53.782299
            ],
            [
              8.550346,
              53.78241
            ],
            [
              8.550409,
              53.782516
            ],
            [
              8.550451,
              53.782625
            ],
            [
              8.550485,
              53.782725
            ],
            [
              8.550521,
              53.782827
            ],
            [
              8.550571,
              53.782927
            ],
            [
              8.550617,
              53.783033
            ],
            [
              8.550663,
              53.783141
            ],
            [
              8.550718,
              53.783248
            ],
            [
              8.550767,
              53.783353
            ],
            [
              8.550804,
              53.783468
            ],
            [
              8.55085,
              53.78358
            ],
            [
              8.550919,
              53.783686
            ],
            [
              8.550983,
              53.783804
            ],
            [
              8.55104,
              53.783923
            ],
            [
              8.551096,
              53.784032
            ],
            [
              8.551157,
              53.784145
            ],
            [
              8.551217,
              53.784253
            ],
            [
              8.551274,
              53.784361
            ],
            [
              8.551338,
              53.784476
            ],
            [
              8.551412,
              53.784589
            ],
            [
              8.551471,
              53.784699
            ],
            [
              8.551535,
              53.784812
            ],
            [
              8.551598,
              53.784923
            ],
            [
              8.551667,
              53.785038
            ],
            [
              8.551721,
              53.785147
            ],
            [
              8.551794,
              53.785251
            ],
            [
              8.551858,
              53.785352
            ],
            [
              8.551948,
              53.785449
            ],
            [
              8.55203,
              53.785552
            ],
            [
              8.552112,
              53.785667
            ],
            [
              8.552194,
              53.785774
            ],
            [
              8.552273,
              53.785879
            ],
            [
              8.552365,
              53.785978
            ],
            [
              8.552456,
              53.786083
            ],
            [
              8.552545,
              53.786189
            ],
            [
              8.552643,
              53.786293
            ],
            [
              8.552729,
              53.786401
            ],
            [
              8.552833,
              53.786509
            ],
            [
              8.552923,
              53.786595
            ],
            [
              8.553026,
              53.786691
            ],
            [
              8.553123,
              53.786779
            ],
            [
              8.553222,
              53.786876
            ],
            [
              8.553316,
              53.786973
            ],
            [
              8.553404,
              53.787074
            ],
            [
              8.553498,
              53.787182
            ],
            [
              8.553586,
              53.787288
            ],
            [
              8.553669,
              53.787398
            ],
            [
              8.553766,
              53.787505
            ],
            [
              8.553866,
              53.78761
            ],
            [
              8.553953,
              53.787713
            ],
            [
              8.554034,
              53.787804
            ],
            [
              8.55413,
              53.787893
            ],
            [
              8.554211,
              53.787994
            ],
            [
              8.554301,
              53.788097
            ],
            [
              8.554387,
              53.788188
            ],
            [
              8.554491,
              53.788256
            ],
            [
              8.554519,
              53.788359
            ],
            [
              8.554612,
              53.788457
            ],
            [
              8.554686,
              53.788544
            ],
            [
              8.554762,
              53.788625
            ],
            [
              8.554868,
              53.788727
            ],
            [
              8.554953,
              53.78882
            ],
            [
              8.55503,
              53.788908
            ],
            [
              8.555117,
              53.789002
            ],
            [
              8.555195,
              53.789113
            ],
            [
              8.555267,
              53.789203
            ],
            [
              8.555343,
              53.789298
            ],
            [
              8.555416,
              53.789393
            ],
            [
              8.555486,
              53.789488
            ],
            [
              8.555571,
              53.789591
            ],
            [
              8.555655,
              53.789695
            ],
            [
              8.555741,
              53.789792
            ],
            [
              8.555829,
              53.789897
            ],
            [
              8.555913,
              53.79
            ],
            [
              8.556001,
              53.790106
            ],
            [
              8.556092,
              53.79021
            ],
            [
              8.556156,
              53.79032
            ],
            [
              8.556255,
              53.790424
            ],
            [
              8.556351,
              53.790527
            ],
            [
              8.556444,
              53.790633
            ],
            [
              8.556545,
              53.790742
            ],
            [
              8.556632,
              53.790851
            ],
            [
              8.55672,
              53.790949
            ],
            [
              8.556813,
              53.791058
            ],
            [
              8.556898,
              53.79118
            ],
            [
              8.556958,
              53.791267
            ],
            [
              8.557034,
              53.791369
            ],
            [
              8.557122,
              53.791476
            ],
            [
              8.557224,
              53.791584
            ],
            [
              8.557318,
              53.791685
            ],
            [
              8.557397,
              53.791793
            ],
            [
              8.557482,
              53.791907
            ],
            [
              8.557562,
              53.792015
            ],
            [
              8.557665,
              53.79212
            ],
            [
              8.55775,
              53.792236
            ],
            [
              8.557852,
              53.792343
            ],
            [
              8.557946,
              53.792451
            ],
            [
              8.558029,
              53.79256
            ],
            [
              8.558125,
              53.792666
            ],
            [
              8.558212,
              53.792776
            ],
            [
              8.558295,
              53.792881
            ],
            [
              8.558376,
              53.79298
            ],
            [
              8.558462,
              53.793081
            ],
            [
              8.558532,
              53.79319
            ],
            [
              8.558619,
              53.793294
            ],
            [
              8.558709,
              53.793394
            ],
            [
              8.558801,
              53.793497
            ],
            [
              8.558889,
              53.79361
            ],
            [
              8.558979,
              53.793711
            ],
            [
              8.559062,
              53.793819
            ],
            [
              8.55914,
              53.793923
            ],
            [
              8.559225,
              53.794026
            ],
            [
              8.559303,
              53.794119
            ],
            [
              8.559375,
              53.794213
            ],
            [
              8.55946,
              53.794322
            ],
            [
              8.559547,
              53.794441
            ],
            [
              8.559636,
              53.794548
            ],
            [
              8.559725,
              53.794657
            ],
            [
              8.559813,
              53.794759
            ],
            [
              8.559899,
              53.794864
            ],
            [
              8.55998,
              53.794973
            ],
            [
              8.560079,
              53.795077
            ],
            [
              8.560176,
              53.795184
            ],
            [
              8.560268,
              53.795288
            ],
            [
              8.560353,
              53.79538
            ],
            [
              8.560451,
              53.795474
            ],
            [
              8.560543,
              53.795569
            ],
            [
              8.560649,
              53.795657
            ],
            [
              8.560762,
              53.795748
            ],
            [
              8.56089,
              53.795835
            ],
            [
              8.561021,
              53.795914
            ],
            [
              8.561148,
              53.795997
            ],
            [
              8.561267,
              53.796081
            ],
            [
              8.561379,
              53.796157
            ],
            [
              8.561481,
              53.796226
            ],
            [
              8.561622,
              53.796305
            ],
            [
              8.561746,
              53.796395
            ],
            [
              8.561865,
              53.796479
            ],
            [
              8.561979,
              53.79656
            ],
            [
              8.562099,
              53.796659
            ],
            [
              8.562227,
              53.796764
            ],
            [
              8.562367,
              53.796874
            ],
            [
              8.562481,
              53.796964
            ],
            [
              8.562594,
              53.797052
            ],
            [
              8.562714,
              53.797151
            ],
            [
              8.562834,
              53.797255
            ],
            [
              8.562956,
              53.797352
            ],
            [
              8.563073,
              53.797446
            ],
            [
              8.563184,
              53.797538
            ],
            [
              8.563302,
              53.79763
            ],
            [
              8.563419,
              53.797724
            ],
            [
              8.563525,
              53.797794
            ],
            [
              8.563676,
              53.797877
            ],
            [
              8.563777,
              53.797946
            ],
            [
              8.56393,
              53.798038
            ],
            [
              8.564054,
              53.798131
            ],
            [
              8.564182,
              53.798218
            ],
            [
              8.56431,
              53.798313
            ],
            [
              8.564445,
              53.798404
            ],
            [
              8.564589,
              53.798482
            ],
            [
              8.564733,
              53.798558
            ],
            [
              8.564876,
              53.79864
            ],
            [
              8.565007,
              53.798733
            ],
            [
              8.565118,
              53.798819
            ],
            [
              8.565223,
              53.798904
            ],
            [
              8.565351,
              53.798992
            ],
            [
              8.565452,
              53.79907
            ],
            [
              8.565577,
              53.799142
            ],
            [
              8.565679,
              53.799234
            ],
            [
              8.565775,
              53.799305
            ],
            [
              8.565875,
              53.799385
            ],
            [
              8.565992,
              53.799468
            ],
            [
              8.566109,
              53.799544
            ],
            [
              8.566216,
              53.799619
            ],
            [
              8.566331,
              53.799702
            ],
            [
              8.566443,
              53.799785
            ],
            [
              8.566565,
              53.799874
            ],
            [
              8.566697,
              53.799958
            ],
            [
              8.566823,
              53.800048
            ],
            [
              8.566953,
              53.800136
            ],
            [
              8.567085,
              53.800225
            ],
            [
              8.567208,
              53.800311
            ],
            [
              8.567321,
              53.800398
            ],
            [
              8.567441,
              53.800492
            ],
            [
              8.567554,
              53.800582
            ],
            [
              8.567659,
              53.800662
            ],
            [
              8.56775,
              53.800742
            ],
            [
              8.567859,
              53.800812
            ],
            [
              8.567954,
              53.800885
            ],
            [
              8.568075,
              53.800972
            ],
            [
              8.56815,
              53.801083
            ],
            [
              8.568196,
              53.801192
            ],
            [
              8.568245,
              53.801305
            ],
            [
              8.568285,
              53.801405
            ],
            [
              8.568328,
              53.801493
            ],
            [
              8.568373,
              53.8016
            ],
            [
              8.56844,
              53.801702
            ],
            [
              8.568493,
              53.801809
            ],
            [
              8.568547,
              53.801906
            ],
            [
              8.568599,
              53.802011
            ],
            [
              8.568637,
              53.802114
            ],
            [
              8.568681,
              53.802203
            ],
            [
              8.568733,
              53.802291
            ],
            [
              8.568774,
              53.802386
            ],
            [
              8.568828,
              53.802481
            ],
            [
              8.568875,
              53.802573
            ],
            [
              8.568934,
              53.802687
            ],
            [
              8.568991,
              53.802802
            ],
            [
              8.569034,
              53.802896
            ],
            [
              8.569081,
              53.802992
            ],
            [
              8.569116,
              53.803086
            ],
            [
              8.569157,
              53.803182
            ],
            [
              8.569203,
              53.803274
            ],
            [
              8.569239,
              53.803368
            ],
            [
              8.569287,
              53.803459
            ],
            [
              8.56933,
              53.803556
            ],
            [
              8.569397,
              53.80366
            ],
            [
              8.569447,
              53.803754
            ],
            [
              8.569495,
              53.803845
            ],
            [
              8.569534,
              53.803943
            ],
            [
              8.569582,
              53.804036
            ],
            [
              8.569628,
              53.804134
            ],
            [
              8.569665,
              53.804231
            ],
            [
              8.569727,
              53.804346
            ],
            [
              8.569762,
              53.804443
            ],
            [
              8.5698,
              53.804537
            ],
            [
              8.569827,
              53.804637
            ],
            [
              8.569846,
              53.804733
            ],
            [
              8.56988,
              53.804825
            ],
            [
              8.56991,
              53.804924
            ],
            [
              8.569956,
              53.805032
            ],
            [
              8.570002,
              53.805137
            ],
            [
              8.570056,
              53.805241
            ],
            [
              8.570087,
              53.80536
            ],
            [
              8.570114,
              53.805453
            ],
            [
              8.570156,
              53.805542
            ],
            [
              8.570185,
              53.805634
            ],
            [
              8.570209,
              53.80574
            ],
            [
              8.570255,
              53.805843
            ],
            [
              8.570292,
              53.805949
            ],
            [
              8.570322,
              53.806053
            ],
            [
              8.570356,
              53.806163
            ],
            [
              8.570387,
              53.806266
            ],
            [
              8.570428,
              53.806362
            ],
            [
              8.570451,
              53.806453
            ],
            [
              8.570502,
              53.806552
            ],
            [
              8.570543,
              53.806656
            ],
            [
              8.57058,
              53.806767
            ],
            [
              8.570618,
              53.806877
            ],
            [
              8.570663,
              53.80698
            ],
            [
              8.570706,
              53.807088
            ],
            [
              8.570743,
              53.807187
            ],
            [
              8.570785,
              53.807279
            ],
            [
              8.570817,
              53.807375
            ],
            [
              8.570853,
              53.807474
            ],
            [
              8.570892,
              53.807584
            ],
            [
              8.570912,
              53.807685
            ],
            [
              8.570949,
              53.807783
            ],
            [
              8.570975,
              53.807894
            ],
            [
              8.571005,
              53.807995
            ],
            [
              8.571043,
              53.808096
            ],
            [
              8.571068,
              53.8082
            ],
            [
              8.571123,
              53.808311
            ],
            [
              8.571184,
              53.808426
            ],
            [
              8.57125,
              53.808514
            ],
            [
              8.571366,
              53.808592
            ],
            [
              8.571509,
              53.808651
            ],
            [
              8.571666,
              53.808687
            ],
            [
              8.571835,
              53.808709
            ],
            [
              8.572007,
              53.808731
            ],
            [
              8.572199,
              53.808766
            ],
            [
              8.572389,
              53.8088
            ],
            [
              8.572576,
              53.808825
            ],
            [
              8.572768,
              53.808855
            ],
            [
              8.572955,
              53.808888
            ],
            [
              8.573147,
              53.808922
            ],
            [
              8.573323,
              53.808952
            ],
            [
              8.573495,
              53.80898
            ],
            [
              8.573674,
              53.809015
            ],
            [
              8.573847,
              53.809044
            ],
            [
              8.57403,
              53.809082
            ],
            [
              8.574208,
              53.809111
            ],
            [
              8.57437,
              53.809141
            ],
            [
              8.574516,
              53.809173
            ],
            [
              8.57469,
              53.809185
            ],
            [
              8.574858,
              53.809208
            ],
            [
              8.575037,
              53.809232
            ],
            [
              8.575222,
              53.809258
            ],
            [
              8.575402,
              53.809286
            ],
            [
              8.575581,
              53.809311
            ],
            [
              8.575768,
              53.809338
            ],
            [
              8.575948,
              53.809367
            ],
            [
              8.576126,
              53.809396
            ],
            [
              8.576305,
              53.809418
            ],
            [
              8.576472,
              53.809449
            ],
            [
              8.57665,
              53.809476
            ],
            [
              8.576821,
              53.809507
            ],
            [
              8.577021,
              53.809535
            ],
            [
              8.577212,
              53.809573
            ],
            [
              8.577412,
              53.809597
            ],
            [
              8.577613,
              53.809624
            ],
            [
              8.577825,
              53.80966
            ],
            [
              8.578025,
              53.8097
            ],
            [
              8.578212,
              53.809723
            ],
            [
              8.57836,
              53.809747
            ],
            [
              8.578564,
              53.809776
            ],
            [
              8.578757,
              53.809804
            ],
            [
              8.578935,
              53.809828
            ],
            [
              8.579107,
              53.809853
            ],
            [
              8.57927,
              53.809877
            ],
            [
              8.579427,
              53.809902
            ],
            [
              8.579575,
              53.809931
            ],
            [
              8.579755,
              53.809967
            ],
            [
              8.579892,
              53.810008
            ],
            [
              8.580036,
              53.810066
            ],
            [
              8.580194,
              53.810139
            ],
            [
              8.580324,
              53.810205
            ],
            [
              8.580445,
              53.810277
            ],
            [
              8.580528,
              53.81037
            ],
            [
              8.580549,
              53.810483
            ],
            [
              8.580551,
              53.8106
            ],
            [
              8.580566,
              53.810711
            ],
            [
              8.580576,
              53.81081
            ],
            [
              8.58061,
              53.810901
            ],
            [
              8.580628,
              53.810991
            ],
            [
              8.580649,
              53.811081
            ],
            [
              8.580665,
              53.811176
            ],
            [
              8.58068,
              53.811287
            ],
            [
              8.58069,
              53.811386
            ],
            [
              8.580683,
              53.811482
            ],
            [
              8.580689,
              53.811577
            ],
            [
              8.580717,
              53.811666
            ],
            [
              8.580739,
              53.811773
            ],
            [
              8.580752,
              53.811865
            ],
            [
              8.580781,
              53.811959
            ],
            [
              8.580817,
              53.812057
            ],
            [
              8.580864,
              53.812145
            ],
            [
              8.580932,
              53.812241
            ],
            [
              8.581024,
              53.812325
            ],
            [
              8.581153,
              53.812389
            ],
            [
              8.581299,
              53.812457
            ],
            [
              8.58142,
              53.812515
            ],
            [
              8.581572,
              53.81259
            ],
            [
              8.581693,
              53.812644
            ],
            [
              8.581841,
              53.812695
            ],
            [
              8.581978,
              53.81277
            ],
            [
              8.582144,
              53.812819
            ],
            [
              8.582269,
              53.812877
            ],
            [
              8.582387,
              53.81294
            ],
            [
              8.582506,
              53.813003
            ],
            [
              8.582637,
              53.813061
            ],
            [
              8.582771,
              53.813117
            ],
            [
              8.582922,
              53.81318
            ],
            [
              8.583069,
              53.81325
            ],
            [
              8.583232,
              53.813314
            ],
            [
              8.583398,
              53.813372
            ],
            [
              8.583572,
              53.813432
            ],
            [
              8.583743,
              53.813473
            ],
            [
              8.583915,
              53.813505
            ],
            [
              8.584096,
              53.813533
            ],
            [
              8.584248,
              53.81356
            ],
            [
              8.584434,
              53.813587
            ],
            [
              8.584605,
              53.813608
            ],
            [
              8.584744,
              53.813652
            ],
            [
              8.584905,
              53.8137
            ],
            [
              8.585086,
              53.813733
            ],
            [
              8.585237,
              53.813751
            ],
            [
              8.58541,
              53.81376
            ],
            [
              8.585536,
              53.813812
            ],
            [
              8.585694,
              53.813851
            ],
            [
              8.585888,
              53.813853
            ],
            [
              8.586055,
              53.813844
            ],
            [
              8.586219,
              53.813836
            ],
            [
              8.586432,
              53.813843
            ],
            [
              8.586618,
              53.81386
            ],
            [
              8.586795,
              53.81386
            ],
            [
              8.586989,
              53.813853
            ],
            [
              8.587145,
              53.813854
            ],
            [
              8.587321,
              53.813859
            ],
            [
              8.587509,
              53.813884
            ],
            [
              8.587675,
              53.813906
            ],
            [
              8.587848,
              53.813953
            ],
            [
              8.587999,
              53.814021
            ],
            [
              8.588142,
              53.814064
            ],
            [
              8.588244,
              53.814147
            ],
            [
              8.588308,
              53.814257
            ],
            [
              8.588339,
              53.814349
            ],
            [
              8.588364,
              53.81444
            ],
            [
              8.588414,
              53.814546
            ],
            [
              8.588449,
              53.814653
            ],
            [
              8.588483,
              53.814758
            ],
            [
              8.588524,
              53.814867
            ],
            [
              8.588547,
              53.814982
            ],
            [
              8.588599,
              53.815082
            ],
            [
              8.588636,
              53.815193
            ],
            [
              8.588686,
              53.815304
            ],
            [
              8.588736,
              53.815416
            ],
            [
              8.58877,
              53.815546
            ],
            [
              8.588785,
              53.815635
            ],
            [
              8.588813,
              53.815724
            ],
            [
              8.588842,
              53.815822
            ],
            [
              8.588885,
              53.81594
            ],
            [
              8.588911,
              53.816043
            ],
            [
              8.588743,
              53.816046
            ],
            [
              8.588617,
              53.815993
            ],
            [
              8.58865,
              53.815881
            ],
            [
              8.588703,
              53.815792
            ],
            [
              8.588728,
              53.815702
            ],
            [
              8.588694,
              53.815614
            ],
            [
              8.588666,
              53.815523
            ],
            [
              8.588757,
              53.815598
            ],
            [
              8.588774,
              53.815692
            ],
            [
              8.588814,
              53.81579
            ],
            [
              8.588863,
              53.815877
            ],
            [
              8.588888,
              53.815972
            ],
            [
              8.588912,
              53.81608
            ],
            [
              8.588959,
              53.816167
            ],
            [
              8.588978,
              53.816276
            ],
            [
              8.588998,
              53.816401
            ],
            [
              8.589039,
              53.81652
            ],
            [
              8.589067,
              53.816641
            ],
            [
              8.58912,
              53.816767
            ],
            [
              8.589163,
              53.816892
            ],
            [
              8.589194,
              53.817026
            ],
            [
              8.589224,
              53.817118
            ],
            // [
            //   8.589261,
            //   53.817206
            // ],
            // [
            //   8.589319,
            //   53.817292
            // ],
            // [
            //   8.589481,
            //   53.817283
            // ],
            // [
            //   8.589651,
            //   53.817311
            // ],
            // [
            //   8.589822,
            //   53.817342
            // ],
            // [
            //   8.589996,
            //   53.817376
            // ],
            // [
            //   8.590166,
            //   53.81738
            // ],
            // [
            //   8.590318,
            //   53.817419
            // ],
            // [
            //   8.590488,
            //   53.817441
            // ],
            // [
            //   8.590636,
            //   53.817473
            // ],
            // [
            //   8.590788,
            //   53.817504
            // ],
            // [
            //   8.59094,
            //   53.81754
            // ],
            // [
            //   8.591107,
            //   53.817573
            // ],
            // [
            //   8.591267,
            //   53.817591
            // ],
            // [
            //   8.591427,
            //   53.817637
            // ],
            // [
            //   8.591547,
            //   53.817697
            // ],
            // [
            //   8.591708,
            //   53.817746
            // ],
            // [
            //   8.591828,
            //   53.81781
            // ],
            // [
            //   8.59197,
            //   53.817855
            // ],
            // [
            //   8.592128,
            //   53.817918
            // ],
            // [
            //   8.592276,
            //   53.817974
            // ],
            // [
            //   8.592415,
            //   53.817936
            // ],
            // [
            //   8.592538,
            //   53.817848
            // ],
            // [
            //   8.592638,
            //   53.817772
            // ],
            // [
            //   8.592751,
            //   53.817698
            // ],
            // [
            //   8.59288,
            //   53.817619
            // ],
            // [
            //   8.592984,
            //   53.817528
            // ],
            // [
            //   8.593102,
            //   53.817456
            // ],
            // [
            //   8.593225,
            //   53.81736
            // ],
            // [
            //   8.593341,
            //   53.817267
            // ],
            // [
            //   8.59344,
            //   53.817186
            // ],
            // [
            //   8.593548,
            //   53.817094
            // ],
            // [
            //   8.593662,
            //   53.817007
            // ],
            // [
            //   8.593772,
            //   53.816923
            // ],
            // [
            //   8.593877,
            //   53.816845
            // ],
            // [
            //   8.593985,
            //   53.816754
            // ],
            // [
            //   8.594099,
            //   53.816669
            // ],
            // [
            //   8.59418,
            //   53.816585
            // ],
            // [
            //   8.594268,
            //   53.816498
            // ],
            // [
            //   8.594343,
            //   53.816412
            // ],
            // [
            //   8.594406,
            //   53.816315
            // ],
            // [
            //   8.594475,
            //   53.81622
            // ],
            // [
            //   8.594582,
            //   53.816129
            // ],
            // [
            //   8.594663,
            //   53.816053
            // ],
            // [
            //   8.594744,
            //   53.815961
            // ],
            // [
            //   8.594814,
            //   53.815877
            // ],
            // [
            //   8.594895,
            //   53.815773
            // ],
            // [
            //   8.594949,
            //   53.815687
            // ],
            // [
            //   8.595026,
            //   53.815609
            // ],
            // [
            //   8.595101,
            //   53.815516
            // ],
            // [
            //   8.595204,
            //   53.815426
            // ],
            // [
            //   8.595295,
            //   53.81534
            // ],
            // [
            //   8.595346,
            //   53.815252
            // ],
            // [
            //   8.595389,
            //   53.815157
            // ],
            // [
            //   8.59545,
            //   53.815067
            // ],
            // [
            //   8.595531,
            //   53.814972
            // ],
            // [
            //   8.595615,
            //   53.814873
            // ],
            // [
            //   8.595699,
            //   53.814772
            // ],
            // [
            //   8.595778,
            //   53.814669
            // ],
            // [
            //   8.595861,
            //   53.814567
            // ],
            // [
            //   8.595947,
            //   53.814462
            // ],
            // [
            //   8.596032,
            //   53.814358
            // ],
            // [
            //   8.59611,
            //   53.814261
            // ],
            // [
            //   8.596189,
            //   53.814163
            // ],
            // [
            //   8.59627,
            //   53.814058
            // ],
            // [
            //   8.596352,
            //   53.813963
            // ],
            // [
            //   8.596426,
            //   53.813869
            // ],
            // [
            //   8.596497,
            //   53.813782
            // ],
            // [
            //   8.59658,
            //   53.81368
            // ],
            // [
            //   8.596649,
            //   53.813574
            // ],
            // [
            //   8.596734,
            //   53.813483
            // ],
            // [
            //   8.596792,
            //   53.813383
            // ],
            // [
            //   8.59686,
            //   53.813293
            // ],
            // [
            //   8.596911,
            //   53.813203
            // ],
            // [
            //   8.596982,
            //   53.813114
            // ],
            // [
            //   8.597076,
            //   53.813035
            // ],
            // [
            //   8.59695,
            //   53.812965
            // ],
            // [
            //   8.596791,
            //   53.812964
            // ],
            // [
            //   8.596635,
            //   53.812847
            // ],
            // [
            //   8.596784,
            //   53.812894
            // ],
            // [
            //   8.596934,
            //   53.812935
            // ],
            // [
            //   8.597052,
            //   53.812996
            // ],
            // [
            //   8.596907,
            //   53.812956
            // ],
            // [
            //   8.596758,
            //   53.812927
            // ],
            // [
            //   8.596694,
            //   53.812905
            // ]
          ]
        ]
      }
    }
  ]
}

let day23: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            8.596573,
            53.81279,
            49.834989
          ],
          [
            8.59702,
            53.812998,
            49.834989
          ],
          [
            8.596897,
            53.813242,
            49.834989
          ],
          [
            8.596775,
            53.81344,
            49.834989
          ],
          [
            8.596651,
            53.813623,
            49.972141
          ],
          [
            8.59649,
            53.813812,
            50.243238
          ],
          [
            8.596338,
            53.813975,
            50.481696
          ],
          [
            8.596208,
            53.814156,
            50.733516
          ],
          [
            8.596058,
            53.814327,
            50.980024
          ],
          [
            8.595872,
            53.814496,
            51.237955
          ],
          [
            8.595662,
            53.814687,
            51.529767
          ],
          [
            8.595531,
            53.814876,
            51.791202
          ],
          [
            8.59541,
            53.81509,
            52.080048
          ],
          [
            8.595256,
            53.815293,
            51.830414
          ],
          [
            8.595109,
            53.815488,
            51.463147
          ],
          [
            8.594944,
            53.815693,
            51.072611
          ],
          [
            8.594797,
            53.815898,
            50.689571
          ],
          [
            8.594643,
            53.816086,
            50.327983
          ],
          [
            8.594504,
            53.816259,
            49.996619
          ],
          [
            8.594335,
            53.816442,
            49.637908
          ],
          [
            8.594214,
            53.816626,
            49.293001
          ],
          [
            8.594,
            53.816809,
            48.877552
          ],
          [
            8.593754,
            53.816993,
            48.375201
          ],
          [
            8.593475,
            53.817193,
            47.820417
          ],
          [
            8.593287,
            53.817336,
            47.430777
          ],
          [
            8.593063,
            53.817518,
            46.948511
          ],
          [
            8.592858,
            53.817705,
            46.471519
          ],
          [
            8.592584,
            53.817886,
            45.951785
          ],
          [
            8.592256,
            53.818042,
            45.419065
          ],
          [
            8.591936,
            53.818187,
            44.918155
          ],
          [
            8.591613,
            53.818349,
            44.399498
          ],
          [
            8.591357,
            53.818505,
            43.947
          ],
          [
            8.591186,
            53.818732,
            43.431959
          ],
          [
            8.591016,
            53.818967,
            42.90226
          ],
          [
            8.590882,
            53.819171,
            42.44855
          ],
          [
            8.590976,
            53.81937,
            42.018652
          ],
          [
            8.591093,
            53.81956,
            41.599437
          ],
          [
            8.591193,
            53.819782,
            41.596723
          ],
          [
            8.591174,
            53.820024,
            41.795307
          ],
          [
            8.59104,
            53.820244,
            41.986096
          ],
          [
            8.590805,
            53.820457,
            42.193329
          ],
          [
            8.59062,
            53.820641,
            42.36811
          ],
          [
            8.590471,
            53.820882,
            42.577902
          ],
          [
            8.590344,
            53.821125,
            42.786033
          ],
          [
            8.590261,
            53.82131,
            42.953102
          ],
          [
            8.59018,
            53.821561,
            43.30541
          ],
          [
            8.590076,
            53.821805,
            43.652551
          ],
          [
            8.589978,
            53.822015,
            43.952915
          ],
          [
            8.589898,
            53.822246,
            44.278631
          ],
          [
            8.589803,
            53.822457,
            44.579785
          ],
          [
            8.589701,
            53.822659,
            44.870426
          ],
          [
            8.589615,
            53.822861,
            45.157592
          ],
          [
            8.589515,
            53.823068,
            45.483855
          ],
          [
            8.58958,
            53.823256,
            45.924212
          ],
          [
            8.58979,
            53.823416,
            46.386316
          ],
          [
            8.590074,
            53.82353,
            46.848782
          ],
          [
            8.590388,
            53.82365,
            47.350379
          ],
          [
            8.590732,
            53.823783,
            47.901502
          ],
          [
            8.591053,
            53.823913,
            48.424697
          ],
          [
            8.591405,
            53.824043,
            48.981358
          ],
          [
            8.591747,
            53.824188,
            49.514561
          ],
          [
            8.592006,
            53.824359,
            49.730916
          ],
          [
            8.59231,
            53.824469,
            49.929221
          ],
          [
            8.59264,
            53.824577,
            50.139044
          ],
          [
            8.592961,
            53.824701,
            50.352375
          ],
          [
            8.593309,
            53.824817,
            50.574629
          ],
          [
            8.593657,
            53.824931,
            50.796042
          ],
          [
            8.593998,
            53.825059,
            51.020776
          ],
          [
            8.594352,
            53.825172,
            51.107965
          ],
          [
            8.594677,
            53.825289,
            50.819094
          ],
          [
            8.594993,
            53.825407,
            50.535284
          ],
          [
            8.595276,
            53.825518,
            50.277445
          ],
          [
            8.595532,
            53.82562,
            50.042865
          ],
          [
            8.595835,
            53.825732,
            49.771407
          ],
          [
            8.596112,
            53.825836,
            49.522292
          ],
          [
            8.596484,
            53.825958,
            49.198824
          ],
          [
            8.596813,
            53.826082,
            48.902345
          ],
          [
            8.597181,
            53.82622,
            48.534966
          ],
          [
            8.597474,
            53.82632,
            48.249503
          ],
          [
            8.597776,
            53.826428,
            47.951942
          ],
          [
            8.598052,
            53.82654,
            47.668789
          ],
          [
            8.598335,
            53.826686,
            47.351865
          ],
          [
            8.598584,
            53.826812,
            47.075403
          ],
          [
            8.598854,
            53.826968,
            46.757102
          ],
          [
            8.599173,
            53.827125,
            46.407036
          ],
          [
            8.59944,
            53.82728,
            46.423549
          ],
          [
            8.599695,
            53.827412,
            46.576994
          ],
          [
            8.599954,
            53.827539,
            46.729349
          ],
          [
            8.600224,
            53.827676,
            46.890453
          ],
          [
            8.600485,
            53.827831,
            47.058012
          ],
          [
            8.600764,
            53.827979,
            47.227802
          ],
          [
            8.601091,
            53.828152,
            47.426591
          ],
          [
            8.601381,
            53.828301,
            47.60055
          ],
          [
            8.601657,
            53.828437,
            47.539868
          ],
          [
            8.601939,
            53.828582,
            47.221261
          ],
          [
            8.602242,
            53.828725,
            46.890467
          ],
          [
            8.602524,
            53.828869,
            46.572718
          ],
          [
            8.602845,
            53.829031,
            46.212205
          ],
          [
            8.60314,
            53.82917,
            45.890657
          ],
          [
            8.603446,
            53.829321,
            45.550854
          ],
          [
            8.603729,
            53.829466,
            45.231635
          ],
          [
            8.603991,
            53.829597,
            45.162503
          ],
          [
            8.604243,
            53.82973,
            45.300729
          ],
          [
            8.604487,
            53.829856,
            45.433306
          ],
          [
            8.604773,
            53.830003,
            45.588398
          ],
          [
            8.6051,
            53.830148,
            45.75564
          ],
          [
            8.605382,
            53.830282,
            45.903671
          ],
          [
            8.605715,
            53.830424,
            46.072016
          ],
          [
            8.606065,
            53.830562,
            46.244887
          ],
          [
            8.606399,
            53.830723,
            46.516602
          ],
          [
            8.606751,
            53.830852,
            46.876109
          ],
          [
            8.607105,
            53.831,
            47.253018
          ],
          [
            8.607392,
            53.831136,
            47.572245
          ],
          [
            8.607722,
            53.831282,
            47.929994
          ],
          [
            8.608089,
            53.831425,
            48.312432
          ],
          [
            8.608353,
            53.831539,
            48.59636
          ],
          [
            8.608696,
            53.831669,
            48.950009
          ],
          [
            8.609016,
            53.831824,
            48.994648
          ],
          [
            8.609342,
            53.831954,
            49.010477
          ],
          [
            8.609664,
            53.832097,
            49.026699
          ],
          [
            8.609975,
            53.832226,
            49.041989
          ],
          [
            8.610333,
            53.832356,
            49.058893
          ],
          [
            8.6107,
            53.832476,
            49.075765
          ],
          [
            8.611016,
            53.832587,
            49.090577
          ],
          [
            8.61134,
            53.832691,
            49.120424
          ],
          [
            8.611686,
            53.832805,
            49.204416
          ],
          [
            8.611985,
            53.83293,
            49.282071
          ],
          [
            8.612262,
            53.833054,
            49.356029
          ],
          [
            8.612505,
            53.833209,
            49.431965
          ],
          [
            8.612712,
            53.833366,
            49.503403
          ],
          [
            8.612925,
            53.833533,
            49.578458
          ],
          [
            8.613127,
            53.833701,
            49.652444
          ],
          [
            8.613305,
            53.833866,
            49.722734
          ],
          [
            8.61351,
            53.834019,
            49.858589
          ],
          [
            8.613718,
            53.834189,
            50.043829
          ],
          [
            8.613963,
            53.834388,
            50.261087
          ],
          [
            8.614203,
            53.834565,
            50.461493
          ],
          [
            8.614445,
            53.834744,
            50.663729
          ],
          [
            8.614639,
            53.834917,
            50.848543
          ],
          [
            8.614851,
            53.835081,
            51.030993
          ],
          [
            8.615043,
            53.835264,
            51.221284
          ],
          [
            8.615243,
            53.835433,
            51.269913
          ],
          [
            8.615452,
            53.835582,
            51.101211
          ],
          [
            8.615682,
            53.835762,
            50.904668
          ],
          [
            8.615929,
            53.835932,
            50.709362
          ],
          [
            8.616121,
            53.836095,
            50.536248
          ],
          [
            8.616311,
            53.836279,
            50.348411
          ],
          [
            8.61654,
            53.836475,
            50.14088
          ],
          [
            8.616781,
            53.83668,
            49.923368
          ],
          [
            8.617014,
            53.836871,
            49.816081
          ],
          [
            8.61722,
            53.837044,
            49.992097
          ],
          [
            8.617415,
            53.837199,
            50.152932
          ],
          [
            8.617638,
            53.837389,
            50.345365
          ],
          [
            8.617837,
            53.837553,
            50.513277
          ],
          [
            8.618042,
            53.837719,
            50.684276
          ],
          [
            8.61824,
            53.837904,
            50.86679
          ],
          [
            8.618452,
            53.838072,
            51.041412
          ],
          [
            8.618633,
            53.83823,
            51.200184
          ],
          [
            8.618829,
            53.838414,
            51.243457
          ],
          [
            8.619064,
            53.838622,
            51.203641
          ],
          [
            8.619327,
            53.838843,
            51.160585
          ],
          [
            8.619511,
            53.839003,
            51.129748
          ],
          [
            8.619718,
            53.839202,
            51.09256
          ],
          [
            8.619892,
            53.839373,
            51.060792
          ],
          [
            8.620134,
            53.839599,
            51.018154
          ],
          [
            8.620371,
            53.839821,
            50.966906
          ],
          [
            8.620579,
            53.840019,
            50.803223
          ],
          [
            8.620748,
            53.840174,
            50.673785
          ],
          [
            8.620949,
            53.840361,
            50.518274
          ],
          [
            8.621161,
            53.840553,
            50.35736
          ],
          [
            8.621342,
            53.84071,
            50.224021
          ],
          [
            8.621561,
            53.840897,
            50.064357
          ],
          [
            8.621726,
            53.841057,
            49.9328
          ],
          [
            8.621914,
            53.841251,
            49.775875
          ],
          [
            8.622159,
            53.841472,
            49.841409
          ],
          [
            8.622378,
            53.841655,
            49.998269
          ],
          [
            8.622577,
            53.84185,
            50.157551
          ],
          [
            8.622796,
            53.842053,
            50.325976
          ],
          [
            8.622999,
            53.842241,
            50.48195
          ],
          [
            8.6232,
            53.842448,
            50.648984
          ],
          [
            8.623424,
            53.842643,
            50.814218
          ],
          [
            8.62361,
            53.842819,
            50.959352
          ],
          [
            8.623813,
            53.843011,
            51.092238
          ],
          [
            8.624039,
            53.843205,
            51.22766
          ],
          [
            8.624278,
            53.843439,
            51.384866
          ],
          [
            8.624513,
            53.843657,
            51.533636
          ],
          [
            8.624687,
            53.843828,
            51.648369
          ],
          [
            8.624875,
            53.844006,
            51.769039
          ],
          [
            8.625054,
            53.844173,
            51.882726
          ],
          [
            8.625243,
            53.84433,
            51.99371
          ],
          [
            8.62542,
            53.844511,
            51.733549
          ],
          [
            8.625643,
            53.844658,
            51.434722
          ],
          [
            8.625877,
            53.844788,
            51.147807
          ],
          [
            8.626185,
            53.844934,
            50.795063
          ],
          [
            8.626482,
            53.845054,
            50.473231
          ],
          [
            8.626757,
            53.845153,
            50.185419
          ],
          [
            8.62708,
            53.845265,
            49.850643
          ],
          [
            8.627364,
            53.845355,
            49.562691
          ],
          [
            8.627763,
            53.845477,
            49.125669
          ],
          [
            8.628092,
            53.845592,
            48.687673
          ],
          [
            8.628405,
            53.845706,
            48.265998
          ],
          [
            8.628695,
            53.845807,
            47.8802
          ],
          [
            8.628984,
            53.845821,
            47.522817
          ],
          [
            8.629272,
            53.845799,
            47.092203
          ],
          [
            8.629561,
            53.845905,
            46.701932
          ],
          [
            8.629936,
            53.846031,
            46.207857
          ],
          [
            8.630282,
            53.84613,
            45.792329
          ],
          [
            8.630575,
            53.846217,
            45.730756
          ],
          [
            8.630905,
            53.846326,
            45.65969
          ],
          [
            8.631218,
            53.846492,
            45.578912
          ],
          [
            8.63156,
            53.846597,
            45.506471
          ],
          [
            8.631865,
            53.846699,
            45.440661
          ],
          [
            8.632158,
            53.846804,
            45.376283
          ],
          [
            8.632442,
            53.846908,
            45.313536
          ],
          [
            8.632738,
            53.847033,
            45.245158
          ],
          [
            8.633021,
            53.847138,
            45.130025
          ],
          [
            8.633309,
            53.847222,
            44.995646
          ],
          [
            8.633612,
            53.847323,
            44.84966
          ],
          [
            8.633919,
            53.847405,
            44.709105
          ],
          [
            8.634235,
            53.847507,
            44.558871
          ],
          [
            8.634532,
            53.847619,
            44.41161
          ],
          [
            8.63483,
            53.847722,
            44.267276
          ],
          [
            8.635132,
            53.847811,
            44.126319
          ],
          [
            8.635448,
            53.847939,
            43.966388
          ],
          [
            8.63576,
            53.848049,
            44.131499
          ],
          [
            8.636018,
            53.848185,
            44.316914
          ],
          [
            8.636344,
            53.848341,
            44.540301
          ],
          [
            8.636578,
            53.848519,
            44.743183
          ],
          [
            8.636832,
            53.848684,
            44.94397
          ],
          [
            8.637127,
            53.848786,
            45.126078
          ],
          [
            8.637486,
            53.848827,
            45.321153
          ],
          [
            8.637823,
            53.848829,
            45.500443
          ],
          [
            8.638157,
            53.84882,
            45.674857
          ],
          [
            8.638534,
            53.848808,
            45.869598
          ],
          [
            8.63884,
            53.848851,
            46.033113
          ],
          [
            8.639157,
            53.848993,
            46.237743
          ],
          [
            8.639488,
            53.849144,
            46.452831
          ],
          [
            8.639816,
            53.849241,
            46.642384
          ],
          [
            8.640182,
            53.849167,
            46.845442
          ],
          [
            8.640595,
            53.849053,
            47.079837
          ],
          [
            8.640964,
            53.848952,
            46.959209
          ],
          [
            8.641265,
            53.848856,
            46.743253
          ],
          [
            8.641562,
            53.848745,
            46.521852
          ],
          [
            8.641894,
            53.848658,
            46.271003
          ],
          [
            8.642235,
            53.848787,
            46.014899
          ],
          [
            8.642526,
            53.848859,
            45.815943
          ],
          [
            8.642828,
            53.848942,
            45.606155
          ],
          [
            8.643129,
            53.849027,
            45.395089
          ],
          [
            8.643434,
            53.849125,
            45.198385
          ],
          [
            8.643826,
            53.849244,
            45.057433
          ],
          [
            8.644145,
            53.849325,
            44.9457
          ],
          [
            8.644487,
            53.84937,
            44.833535
          ],
          [
            8.644858,
            53.849411,
            44.710421
          ],
          [
            8.645235,
            53.849387,
            44.589151
          ],
          [
            8.645561,
            53.849335,
            44.481224
          ],
          [
            8.645876,
            53.849292,
            44.377716
          ],
          [
            8.646215,
            53.849245,
            44.266277
          ],
          [
            8.646601,
            53.849207,
            44.076624
          ],
          [
            8.646999,
            53.84913,
            43.8608
          ],
          [
            8.647345,
            53.849092,
            43.679081
          ],
          [
            8.647662,
            53.849017,
            43.501287
          ],
          [
            8.648005,
            53.84895,
            43.313643
          ],
          [
            8.648445,
            53.848893,
            43.081454
          ],
          [
            8.648779,
            53.848806,
            42.893275
          ],
          [
            8.649156,
            53.848736,
            42.689667
          ],
          [
            8.649504,
            53.848678,
            42.844034
          ],
          [
            8.649873,
            53.848663,
            43.028708
          ],
          [
            8.650277,
            53.848672,
            43.230417
          ],
          [
            8.650676,
            53.848684,
            43.429899
          ],
          [
            8.651085,
            53.848713,
            43.635497
          ],
          [
            8.651463,
            53.848731,
            43.824791
          ],
          [
            8.65183,
            53.848753,
            44.008839
          ],
          [
            8.652157,
            53.848767,
            44.172693
          ],
          [
            8.652496,
            53.848767,
            44.422356
          ],
          [
            8.65283,
            53.848796,
            44.684077
          ],
          [
            8.653177,
            53.848825,
            44.955773
          ],
          [
            8.653491,
            53.848865,
            45.20481
          ],
          [
            8.653799,
            53.848881,
            45.444524
          ],
          [
            8.654141,
            53.848922,
            45.715128
          ],
          [
            8.65443,
            53.848998,
            45.961472
          ],
          [
            8.654788,
            53.849089,
            46.2641
          ],
          [
            8.655095,
            53.849178,
            46.529729
          ],
          [
            8.655403,
            53.849267,
            46.221058
          ],
          [
            8.655757,
            53.849372,
            45.77602
          ],
          [
            8.656065,
            53.849516,
            45.333902
          ],
          [
            8.656292,
            53.849644,
            44.980128
          ],
          [
            8.656447,
            53.84983,
            44.584022
          ],
          [
            8.656562,
            53.850022,
            44.196334
          ],
          [
            8.656682,
            53.850203,
            43.826348
          ],
          [
            8.656795,
            53.850395,
            43.43925
          ],
          [
            8.656938,
            53.850617,
            43.139533
          ],
          [
            8.657062,
            53.850812,
            43.146525
          ],
          [
            8.657225,
            53.850989,
            43.153304
          ],
          [
            8.657483,
            53.851141,
            43.160665
          ],
          [
            8.657841,
            53.851224,
            43.168361
          ],
          [
            8.658167,
            53.851217,
            43.174837
          ],
          [
            8.658507,
            53.851219,
            43.181569
          ],
          [
            8.658823,
            53.851215,
            43.187826
          ],
          [
            8.659133,
            53.851211,
            43.19398
          ],
          [
            8.659533,
            53.851208,
            43.284233
          ],
          [
            8.659916,
            53.851195,
            43.425215
          ],
          [
            8.660326,
            53.851199,
            43.576145
          ],
          [
            8.660764,
            53.851217,
            43.73761
          ],
          [
            8.661178,
            53.851204,
            43.889964
          ],
          [
            8.661554,
            53.851173,
            44.029478
          ],
          [
            8.661862,
            53.851112,
            44.148906
          ],
          [
            8.662181,
            53.851031,
            44.276531
          ],
          [
            8.662553,
            53.850953,
            44.495004
          ],
          [
            8.662902,
            53.850897,
            44.721567
          ],
          [
            8.663209,
            53.850836,
            44.924403
          ],
          [
            8.663571,
            53.850773,
            45.160907
          ],
          [
            8.663947,
            53.850694,
            45.410977
          ],
          [
            8.664298,
            53.850622,
            45.643643
          ],
          [
            8.664681,
            53.850527,
            45.904351
          ],
          [
            8.665028,
            53.850458,
            46.133682
          ],
          [
            8.665401,
            53.850403,
            46.251787
          ],
          [
            8.665815,
            53.850329,
            46.297896
          ],
          [
            8.666144,
            53.850273,
            46.334404
          ],
          [
            8.666472,
            53.850219,
            46.370685
          ],
          [
            8.666827,
            53.850138,
            46.411239
          ],
          [
            8.667175,
            53.850073,
            46.450146
          ],
          [
            8.667532,
            53.849989,
            46.491108
          ],
          [
            8.667877,
            53.849909,
            46.53061
          ],
          [
            8.668203,
            53.84984,
            46.356445
          ],
          [
            8.668574,
            53.849762,
            45.848024
          ],
          [
            8.668929,
            53.849685,
            45.359753
          ],
          [
            8.669284,
            53.84962,
            44.879924
          ],
          [
            8.669637,
            53.849552,
            44.400081
          ],
          [
            8.670001,
            53.849467,
            43.894675
          ],
          [
            8.670355,
            53.849393,
            43.409818
          ],
          [
            8.670724,
            53.849321,
            42.908065
          ],
          [
            8.67107,
            53.849246,
            42.578071
          ],
          [
            8.671427,
            53.849184,
            42.479731
          ],
          [
            8.671753,
            53.849158,
            42.392799
          ],
          [
            8.672191,
            53.84911,
            42.275151
          ],
          [
            8.672568,
            53.849083,
            42.174884
          ],
          [
            8.672933,
            53.849049,
            42.07726
          ],
          [
            8.673336,
            53.849034,
            41.970615
          ],
          [
            8.673712,
            53.849022,
            41.87119
          ],
          [
            8.673956,
            53.848921,
            41.833739
          ],
          [
            8.674332,
            53.848972,
            41.915387
          ],
          [
            8.67466,
            53.849052,
            41.991283
          ],
          [
            8.674997,
            53.849087,
            42.063822
          ],
          [
            8.675362,
            53.849092,
            42.140959
          ],
          [
            8.675721,
            53.849106,
            42.216915
          ],
          [
            8.676125,
            53.84911,
            42.302208
          ],
          [
            8.676534,
            53.849088,
            42.388906
          ],
          [
            8.676888,
            53.849014,
            42.432774
          ],
          [
            8.677233,
            53.848923,
            42.306561
          ],
          [
            8.677614,
            53.848867,
            42.175173
          ],
          [
            8.678018,
            53.848862,
            42.040126
          ],
          [
            8.678417,
            53.848855,
            41.906806
          ],
          [
            8.678781,
            53.848854,
            41.785137
          ],
          [
            8.67914,
            53.84886,
            41.665147
          ],
          [
            8.679459,
            53.848859,
            41.558611
          ],
          [
            8.679789,
            53.848858,
            41.448401
          ],
          [
            8.680116,
            53.848853,
            41.636677
          ],
          [
            8.680518,
            53.848833,
            41.914716
          ],
          [
            8.680961,
            53.848833,
            42.220017
          ],
          [
            8.68133,
            53.848843,
            42.474631
          ],
          [
            8.681761,
            53.848845,
            42.771671
          ],
          [
            8.682157,
            53.848845,
            43.044583
          ],
          [
            8.682613,
            53.848833,
            43.359181
          ],
          [
            8.68293,
            53.848812,
            43.54557
          ],
          [
            8.683252,
            53.848812,
            43.588897
          ],
          [
            8.683642,
            53.848823,
            43.641533
          ],
          [
            8.684042,
            53.848817,
            43.695351
          ],
          [
            8.684361,
            53.848822,
            43.738283
          ],
          [
            8.684677,
            53.848804,
            43.781003
          ],
          [
            8.685061,
            53.848812,
            43.83268
          ],
          [
            8.685377,
            53.848797,
            43.875331
          ],
          [
            8.685763,
            53.848794,
            43.927252
          ],
          [
            8.686076,
            53.848778,
            44.039829
          ],
          [
            8.686448,
            53.848767,
            44.250432
          ],
          [
            8.686612,
            53.848903,
            44.430762
          ],
          [
            8.686584,
            53.849126,
            44.643963
          ],
          [
            8.686604,
            53.84936,
            44.867315
          ],
          [
            8.686628,
            53.849609,
            45.10522
          ],
          [
            8.686646,
            53.84979,
            45.278055
          ],
          [
            8.686675,
            53.849986,
            45.465669
          ],
          [
            8.686677,
            53.850173,
            45.64393
          ],
          [
            8.6867,
            53.850379,
            45.709206
          ],
          [
            8.686725,
            53.850607,
            45.766431
          ],
          [
            8.686728,
            53.850804,
            45.816012
          ],
          [
            8.686728,
            53.851021,
            45.870388
          ],
          [
            8.686685,
            53.851241,
            45.926347
          ],
          [
            8.686707,
            53.851477,
            45.985546
          ],
          [
            8.686859,
            53.851624,
            46.031977
          ],
          [
            8.687122,
            53.851487,
            46.085488
          ],
          [
            8.687557,
            53.851448,
            46.104986
          ],
          [
            8.687997,
            53.851382,
            46.091691
          ],
          [
            8.68838,
            53.851309,
            46.080005
          ],
          [
            8.688741,
            53.851303,
            46.069071
          ],
          [
            8.689068,
            53.851404,
            46.058147
          ],
          [
            8.689214,
            53.851637,
            46.045932
          ],
          [
            8.68936,
            53.851866,
            46.033902
          ],
          [
            8.68953,
            53.8521,
            45.989786
          ],
          [
            8.689657,
            53.85231,
            45.848551
          ],
          [
            8.68979,
            53.852514,
            45.710677
          ],
          [
            8.689954,
            53.852731,
            45.560802
          ],
          [
            8.690085,
            53.852913,
            45.435925
          ],
          [
            8.690219,
            53.853132,
            45.289054
          ],
          [
            8.690363,
            53.85336,
            45.135566
          ],
          [
            8.690489,
            53.853571,
            44.99441
          ],
          [
            8.690657,
            53.853776,
            44.972308
          ],
          [
            8.690786,
            53.853964,
            45.245813
          ],
          [
            8.691002,
            53.854205,
            45.613564
          ],
          [
            8.691154,
            53.854416,
            45.922627
          ],
          [
            8.691304,
            53.854632,
            46.237729
          ],
          [
            8.691453,
            53.854856,
            46.562793
          ],
          [
            8.691569,
            53.855034,
            46.819968
          ],
          [
            8.691708,
            53.855211,
            47.082982
          ],
          [
            8.691848,
            53.855419,
            47.276191
          ],
          [
            8.692004,
            53.855626,
            47.111841
          ],
          [
            8.692137,
            53.85582,
            46.96045
          ],
          [
            8.692284,
            53.856007,
            46.811295
          ],
          [
            8.692437,
            53.856196,
            46.659627
          ],
          [
            8.692571,
            53.856384,
            46.512086
          ],
          [
            8.692728,
            53.856618,
            46.329881
          ],
          [
            8.692878,
            53.856808,
            46.1782
          ],
          [
            8.693038,
            53.857017,
            46.011828
          ],
          [
            8.693181,
            53.857208,
            45.783961
          ],
          [
            8.693231,
            53.857389,
            45.583684
          ],
          [
            8.693297,
            53.857608,
            45.340932
          ],
          [
            8.693383,
            53.857857,
            45.062935
          ],
          [
            8.693446,
            53.858073,
            44.82371
          ],
          [
            8.693499,
            53.858269,
            44.6071
          ],
          [
            8.693578,
            53.858466,
            44.386005
          ],
          [
            8.693638,
            53.858667,
            44.163175
          ],
          [
            8.693692,
            53.858854,
            44.069026
          ],
          [
            8.693655,
            53.859067,
            44.116048
          ],
          [
            8.693759,
            53.859278,
            44.165223
          ],
          [
            8.693898,
            53.859501,
            44.217796
          ],
          [
            8.69405,
            53.859693,
            44.264328
          ],
          [
            8.694136,
            53.859881,
            44.307166
          ],
          [
            8.694257,
            53.860089,
            44.355461
          ],
          [
            8.694399,
            53.860303,
            44.405978
          ],
          [
            8.694556,
            53.86053,
            44.576982
          ],
          [
            8.694689,
            53.86076,
            45.050207
          ],
          [
            8.69481,
            53.860969,
            45.4792
          ],
          [
            8.694897,
            53.86119,
            45.919726
          ],
          [
            8.695049,
            53.861402,
            46.36891
          ],
          [
            8.695375,
            53.861441,
            46.751073
          ],
          [
            8.695653,
            53.861628,
            47.234659
          ],
          [
            8.695998,
            53.861724,
            47.674125
          ],
          [
            8.696278,
            53.861857,
            47.877184
          ],
          [
            8.696595,
            53.861985,
            47.698675
          ],
          [
            8.696955,
            53.862123,
            47.499193
          ],
          [
            8.697364,
            53.862235,
            47.290012
          ],
          [
            8.697678,
            53.862361,
            47.113802
          ],
          [
            8.698,
            53.862473,
            46.938808
          ],
          [
            8.69835,
            53.86244,
            46.766665
          ],
          [
            8.698674,
            53.862407,
            46.61184
          ],
          [
            8.698886,
            53.862579,
            46.517263
          ],
          [
            8.699018,
            53.862802,
            46.503408
          ],
          [
            8.69916,
            53.863039,
            46.488645
          ],
          [
            8.699285,
            53.863237,
            46.476234
          ],
          [
            8.699384,
            53.863431,
            46.464329
          ],
          [
            8.699581,
            53.863586,
            46.452925
          ],
          [
            8.699763,
            53.86376,
            46.440909
          ],
          [
            8.69994,
            53.863943,
            46.428539
          ],
          [
            8.700176,
            53.864145,
            46.427421
          ],
          [
            8.700568,
            53.864163,
            46.46889
          ],
          [
            8.700906,
            53.864022,
            46.509466
          ],
          [
            8.701209,
            53.863877,
            46.547593
          ],
          [
            8.701505,
            53.863702,
            46.588545
          ],
          [
            8.701757,
            53.863559,
            46.622719
          ],
          [
            8.701978,
            53.863379,
            46.659542
          ],
          [
            8.702268,
            53.86337,
            46.690791
          ],
          [
            8.702549,
            53.863352,
            46.703861
          ],
          [
            8.702877,
            53.863238,
            46.659776
          ],
          [
            8.70318,
            53.863096,
            46.616129
          ],
          [
            8.703433,
            53.862935,
            46.573675
          ],
          [
            8.703739,
            53.862771,
            46.526985
          ],
          [
            8.704024,
            53.862625,
            46.484342
          ],
          [
            8.704299,
            53.862515,
            46.446323
          ],
          [
            8.704611,
            53.86265,
            46.402057
          ],
          [
            8.704826,
            53.862814,
            46.495763
          ],
          [
            8.705083,
            53.862997,
            47.101695
          ],
          [
            8.705292,
            53.86316,
            47.622782
          ],
          [
            8.705475,
            53.863317,
            48.109179
          ],
          [
            8.705762,
            53.863511,
            48.766529
          ],
          [
            8.705953,
            53.863659,
            49.240787
          ],
          [
            8.706219,
            53.863884,
            49.940214
          ],
          [
            8.706475,
            53.86406,
            50.531832
          ],
          [
            8.706757,
            53.864253,
            50.948967
          ],
          [
            8.707021,
            53.864424,
            50.924903
          ],
          [
            8.707204,
            53.864593,
            50.903905
          ],
          [
            8.707454,
            53.864777,
            50.879381
          ],
          [
            8.707642,
            53.864941,
            50.858788
          ],
          [
            8.707877,
            53.865114,
            50.835729
          ],
          [
            8.708111,
            53.865274,
            50.813769
          ],
          [
            8.708357,
            53.865443,
            50.790619
          ],
          [
            8.708579,
            53.865623,
            50.770472
          ],
          [
            8.70881,
            53.865796,
            50.766348
          ],
          [
            8.70904,
            53.865978,
            50.762098
          ],
          [
            8.709237,
            53.866143,
            50.75832
          ],
          [
            8.709419,
            53.866292,
            50.75485
          ],
          [
            8.709626,
            53.866465,
            50.750869
          ],
          [
            8.709884,
            53.866626,
            50.746711
          ],
          [
            8.71008,
            53.866775,
            50.74318
          ],
          [
            8.710221,
            53.866936,
            50.739785
          ],
          [
            8.71047,
            53.86705,
            50.47232
          ],
          [
            8.710823,
            53.867026,
            49.853131
          ],
          [
            8.711149,
            53.866986,
            49.271563
          ],
          [
            8.711376,
            53.867123,
            48.705857
          ],
          [
            8.711545,
            53.867281,
            48.154201
          ],
          [
            8.711759,
            53.867447,
            47.537551
          ],
          [
            8.71202,
            53.867602,
            46.891177
          ],
          [
            8.712316,
            53.867782,
            46.150459
          ],
          [
            8.712615,
            53.867973,
            45.433811
          ],
          [
            8.712868,
            53.868134,
            45.554974
          ],
          [
            8.713161,
            53.868282,
            45.68046
          ],
          [
            8.713412,
            53.868423,
            45.793648
          ],
          [
            8.713679,
            53.868584,
            45.917898
          ],
          [
            8.713904,
            53.868719,
            46.022282
          ],
          [
            8.714188,
            53.868865,
            46.144835
          ],
          [
            8.714233,
            53.869078,
            46.26468
          ],
          [
            8.714143,
            53.869251,
            46.378846
          ],
          [
            8.714364,
            53.869501,
            45.567911
          ],
          [
            8.7144,
            53.869704,
            44.738441
          ],
          [
            8.714185,
            53.869853,
            43.948033
          ],
          [
            8.714107,
            53.870025,
            43.174078
          ],
          [
            8.7143,
            53.870186,
            42.382419
          ],
          [
            8.714552,
            53.870221,
            41.625138
          ],
          [
            8.714744,
            53.870058,
            40.827822
          ],
          [
            8.714953,
            53.869925,
            40.085495
          ],
          [
            8.715084,
            53.869751,
            39.320908
          ],
          [
            8.715181,
            53.86972,
            40.887169
          ],
          [
            8.715081,
            53.86965,
            42.450495
          ],
          [
            8.715111,
            53.869462,
            43.991893
          ],
          [
            8.715249,
            53.869643,
            45.660552
          ],
          [
            8.715477,
            53.86971,
            47.206945
          ],
          [
            8.715507,
            53.869511,
            48.860759
          ],
          [
            8.715751,
            53.869395,
            50.364978
          ],
          [
            8.716001,
            53.869266,
            51.956863
          ],
          [
            8.716278,
            53.869126,
            53.706564
          ],
          [
            8.71653,
            53.868992,
            53.490412
          ],
          [
            8.716805,
            53.868868,
            53.125965
          ],
          [
            8.717118,
            53.868695,
            52.67468
          ],
          [
            8.717425,
            53.868529,
            52.235529
          ],
          [
            8.717718,
            53.868365,
            51.809885
          ],
          [
            8.718039,
            53.868231,
            51.396417
          ],
          [
            8.71834,
            53.868101,
            51.004592
          ],
          [
            8.718614,
            53.867981,
            50.645925
          ],
          [
            8.7189,
            53.867832,
            50.977541
          ],
          [
            8.719245,
            53.867651,
            51.438021
          ],
          [
            8.719575,
            53.86748,
            51.877383
          ],
          [
            8.719933,
            53.867321,
            52.324439
          ],
          [
            8.720276,
            53.867141,
            52.782326
          ],
          [
            8.72064,
            53.866971,
            53.245364
          ],
          [
            8.720996,
            53.866785,
            53.713227
          ],
          [
            8.721361,
            53.86661,
            54.13014
          ],
          [
            8.721762,
            53.866418,
            54.587854
          ],
          [
            8.722163,
            53.866213,
            55.058126
          ],
          [
            8.722593,
            53.866004,
            55.551926
          ],
          [
            8.723006,
            53.865794,
            56.035174
          ],
          [
            8.723428,
            53.865581,
            56.461343
          ],
          [
            8.723869,
            53.865367,
            56.762852
          ],
          [
            8.724318,
            53.865158,
            57.065007
          ],
          [
            8.724757,
            53.864944,
            57.365683
          ],
          [
            8.725005,
            53.864828,
            57.533089
          ],
          [
            8.725334,
            53.864656,
            57.765197
          ],
          [
            8.725768,
            53.864429,
            57.879364
          ],
          [
            8.726212,
            53.864192,
            57.571658
          ],
          [
            8.726553,
            53.864013,
            57.337146
          ],
          [
            8.7269,
            53.863838,
            57.102564
          ],
          [
            8.727135,
            53.863715,
            56.9411
          ],
          [
            8.727467,
            53.863534,
            56.708649
          ],
          [
            8.727694,
            53.863404,
            56.54606
          ],
          [
            8.72795,
            53.863294,
            56.349156
          ],
          [
            8.72829,
            53.863106,
            55.771901
          ],
          [
            8.728528,
            53.862985,
            55.382624
          ],
          [
            8.728766,
            53.862865,
            54.99483
          ],
          [
            8.729016,
            53.862745,
            54.595166
          ],
          [
            8.729269,
            53.862624,
            54.191573
          ],
          [
            8.729613,
            53.86244,
            53.616107
          ],
          [
            8.72986,
            53.862327,
            53.22895
          ],
          [
            8.730125,
            53.8622,
            52.80406
          ],
          [
            8.730493,
            53.862012,
            52.262528
          ],
          [
            8.730736,
            53.861877,
            51.90892
          ],
          [
            8.73099,
            53.861755,
            51.561907
          ],
          [
            8.731234,
            53.861635,
            51.225506
          ],
          [
            8.731485,
            53.861514,
            50.882199
          ],
          [
            8.731745,
            53.861393,
            50.531511
          ],
          [
            8.731988,
            53.861263,
            50.183884
          ],
          [
            8.732241,
            53.861132,
            49.827333
          ],
          [
            8.732492,
            53.861014,
            49.487458
          ],
          [
            8.732738,
            53.860886,
            49.255066
          ],
          [
            8.732998,
            53.860769,
            49.06143
          ],
          [
            8.733257,
            53.860645,
            48.863946
          ],
          [
            8.733528,
            53.860529,
            48.665715
          ],
          [
            8.733775,
            53.860411,
            48.47751
          ],
          [
            8.734026,
            53.860294,
            48.288096
          ],
          [
            8.734281,
            53.860175,
            48.095589
          ],
          [
            8.734623,
            53.859984,
            47.81676
          ],
          [
            8.734869,
            53.859846,
            47.615532
          ],
          [
            8.735122,
            53.85972,
            47.468987
          ],
          [
            8.735372,
            53.859592,
            47.328145
          ],
          [
            8.735631,
            53.859467,
            47.185686
          ],
          [
            8.735886,
            53.859348,
            47.047338
          ],
          [
            8.736145,
            53.859226,
            46.906209
          ],
          [
            8.736404,
            53.859101,
            46.763843
          ],
          [
            8.736662,
            53.858977,
            46.622135
          ],
          [
            8.736924,
            53.858853,
            46.479194
          ],
          [
            8.737188,
            53.858729,
            46.335625
          ],
          [
            8.737438,
            53.858608,
            46.4425
          ],
          [
            8.737681,
            53.858488,
            46.636876
          ],
          [
            8.737923,
            53.858358,
            46.837685
          ],
          [
            8.738181,
            53.858238,
            47.039212
          ],
          [
            8.738427,
            53.85811,
            47.240418
          ],
          [
            8.738685,
            53.85798,
            47.448545
          ],
          [
            8.738927,
            53.857856,
            47.645152
          ],
          [
            8.739186,
            53.857743,
            47.842868
          ],
          [
            8.739429,
            53.857616,
            48.041994
          ],
          [
            8.739673,
            53.857486,
            48.275622
          ],
          [
            8.739925,
            53.857347,
            48.576936
          ],
          [
            8.740164,
            53.857224,
            48.853969
          ],
          [
            8.740427,
            53.857102,
            49.146612
          ],
          [
            8.740671,
            53.85698,
            49.426623
          ],
          [
            8.740928,
            53.856846,
            49.726283
          ],
          [
            8.741195,
            53.856718,
            50.026996
          ],
          [
            8.741451,
            53.856591,
            50.319152
          ],
          [
            8.741715,
            53.856471,
            50.610656
          ],
          [
            8.741952,
            53.856343,
            50.910038
          ],
          [
            8.742191,
            53.856209,
            51.288515
          ],
          [
            8.742447,
            53.856075,
            51.681339
          ],
          [
            8.742699,
            53.855943,
            52.068185
          ],
          [
            8.742936,
            53.855814,
            52.438517
          ],
          [
            8.743187,
            53.855689,
            52.81559
          ],
          [
            8.743429,
            53.855561,
            53.188939
          ],
          [
            8.743675,
            53.855433,
            53.565707
          ],
          [
            8.743932,
            53.855309,
            53.946776
          ],
          [
            8.744187,
            53.855184,
            54.327521
          ],
          [
            8.744443,
            53.855057,
            54.405706
          ],
          [
            8.744692,
            53.854928,
            54.479995
          ],
          [
            8.744941,
            53.854805,
            54.5528
          ],
          [
            8.745204,
            53.85468,
            54.628525
          ],
          [
            8.745441,
            53.854555,
            54.699791
          ],
          [
            8.745697,
            53.854428,
            54.77478
          ],
          [
            8.745949,
            53.854302,
            54.848845
          ],
          [
            8.74619,
            53.854176,
            54.921044
          ],
          [
            8.746444,
            53.854048,
            54.995929
          ],
          [
            8.746708,
            53.853925,
            55.028952
          ],
          [
            8.746968,
            53.853798,
            55.047666
          ],
          [
            8.747219,
            53.853674,
            55.065818
          ],
          [
            8.747483,
            53.853555,
            55.084244
          ],
          [
            8.747756,
            53.853433,
            55.103231
          ],
          [
            8.747997,
            53.853303,
            55.121336
          ],
          [
            8.748258,
            53.853158,
            55.141228
          ],
          [
            8.748508,
            53.853024,
            55.159953
          ],
          [
            8.748767,
            53.852898,
            55.178566
          ],
          [
            8.749028,
            53.85277,
            54.97166
          ],
          [
            8.749286,
            53.852653,
            54.684334
          ],
          [
            8.749538,
            53.852535,
            54.400265
          ],
          [
            8.749796,
            53.852419,
            54.113745
          ],
          [
            8.750071,
            53.852292,
            53.805384
          ],
          [
            8.750323,
            53.852165,
            53.512642
          ],
          [
            8.750584,
            53.852044,
            53.219531
          ],
          [
            8.750845,
            53.851922,
            52.925402
          ],
          [
            8.751078,
            53.851794,
            52.644128
          ],
          [
            8.751338,
            53.851664,
            52.517814
          ],
          [
            8.751595,
            53.851546,
            52.567771
          ],
          [
            8.751847,
            53.851418,
            52.618837
          ],
          [
            8.752109,
            53.851293,
            52.670508
          ],
          [
            8.752377,
            53.851165,
            52.723561
          ],
          [
            8.752634,
            53.851051,
            52.772868
          ],
          [
            8.752884,
            53.850924,
            52.823489
          ],
          [
            8.753132,
            53.850794,
            52.87437
          ],
          [
            8.753379,
            53.850677,
            52.92298
          ],
          [
            8.753651,
            53.850551,
            52.984575
          ],
          [
            8.753896,
            53.85042,
            53.061271
          ],
          [
            8.754145,
            53.850303,
            53.135141
          ],
          [
            8.754398,
            53.850175,
            53.212449
          ],
          [
            8.754645,
            53.850059,
            53.285688
          ],
          [
            8.754895,
            53.849925,
            53.364092
          ],
          [
            8.755148,
            53.849795,
            53.441938
          ],
          [
            8.755398,
            53.849661,
            53.520287
          ],
          [
            8.755662,
            53.849546,
            53.596427
          ],
          [
            8.755904,
            53.849421,
            53.646851
          ],
          [
            8.75615,
            53.8493,
            53.309155
          ],
          [
            8.756418,
            53.849184,
            52.958918
          ],
          [
            8.756692,
            53.849068,
            52.603471
          ],
          [
            8.756961,
            53.848949,
            52.249198
          ],
          [
            8.757219,
            53.848821,
            51.893833
          ],
          [
            8.757464,
            53.848693,
            51.548652
          ],
          [
            8.75773,
            53.84857,
            51.191793
          ],
          [
            8.757987,
            53.848453,
            50.849742
          ],
          [
            8.75825,
            53.84833,
            50.496078
          ],
          [
            8.758519,
            53.848206,
            50.570654
          ],
          [
            8.758791,
            53.848092,
            50.699916
          ],
          [
            8.759054,
            53.847978,
            50.826102
          ],
          [
            8.759324,
            53.847868,
            50.952916
          ],
          [
            8.759582,
            53.847758,
            51.075946
          ],
          [
            8.759844,
            53.847638,
            51.204341
          ],
          [
            8.760089,
            53.847525,
            51.324617
          ],
          [
            8.760336,
            53.847396,
            51.452338
          ],
          [
            8.760606,
            53.847277,
            51.582782
          ],
          [
            8.760866,
            53.847157,
            51.696053
          ],
          [
            8.761122,
            53.847034,
            51.800359
          ],
          [
            8.761385,
            53.84692,
            51.903366
          ],
          [
            8.761637,
            53.846806,
            52.003581
          ],
          [
            8.761905,
            53.846693,
            52.107557
          ],
          [
            8.762189,
            53.846591,
            52.212659
          ],
          [
            8.762574,
            53.846428,
            52.36225
          ],
          [
            8.762821,
            53.846318,
            52.459913
          ],
          [
            8.763085,
            53.846199,
            52.56477
          ],
          [
            8.763338,
            53.846091,
            52.60969
          ],
          [
            8.763611,
            53.845979,
            52.632871
          ],
          [
            8.763882,
            53.845875,
            52.655448
          ],
          [
            8.764143,
            53.845764,
            52.677877
          ],
          [
            8.764421,
            53.845655,
            52.701148
          ],
          [
            8.764702,
            53.845553,
            52.724163
          ],
          [
            8.764974,
            53.845458,
            52.746204
          ],
          [
            8.765248,
            53.845358,
            52.768668
          ],
          [
            8.765522,
            53.845253,
            52.791449
          ],
          [
            8.765801,
            53.845146,
            52.786348
          ],
          [
            8.766073,
            53.845036,
            52.724349
          ],
          [
            8.766346,
            53.844932,
            52.663261
          ],
          [
            8.766625,
            53.844833,
            52.60205
          ],
          [
            8.766902,
            53.84473,
            52.540492
          ],
          [
            8.767188,
            53.844629,
            52.47781
          ],
          [
            8.767472,
            53.844533,
            52.416243
          ],
          [
            8.767753,
            53.844431,
            52.354224
          ],
          [
            8.768022,
            53.844328,
            52.293892
          ],
          [
            8.768298,
            53.84422,
            52.224749
          ],
          [
            8.768565,
            53.844121,
            51.987647
          ],
          [
            8.768848,
            53.844015,
            51.735666
          ],
          [
            8.769133,
            53.843906,
            51.479997
          ],
          [
            8.769425,
            53.843801,
            51.222891
          ],
          [
            8.769702,
            53.843703,
            50.979829
          ],
          [
            8.769982,
            53.843609,
            50.737665
          ],
          [
            8.770262,
            53.84351,
            50.492281
          ],
          [
            8.770552,
            53.843402,
            50.234443
          ],
          [
            8.770845,
            53.843316,
            49.988445
          ],
          [
            8.77127,
            53.843195,
            50.031538
          ],
          [
            8.771548,
            53.843104,
            50.100617
          ],
          [
            8.771834,
            53.84301,
            50.171761
          ],
          [
            8.772136,
            53.842926,
            50.244306
          ],
          [
            8.772444,
            53.842817,
            50.322503
          ],
          [
            8.772745,
            53.842727,
            50.395826
          ],
          [
            8.773172,
            53.842599,
            50.499893
          ],
          [
            8.773463,
            53.842511,
            50.570944
          ],
          [
            8.773747,
            53.842426,
            50.802075
          ],
          [
            8.774154,
            53.842286,
            51.372197
          ],
          [
            8.774453,
            53.842202,
            51.772936
          ],
          [
            8.774741,
            53.842114,
            52.166145
          ],
          [
            8.775024,
            53.842034,
            52.545841
          ],
          [
            8.77532,
            53.841948,
            52.945084
          ],
          [
            8.775608,
            53.841867,
            53.331135
          ],
          [
            8.77604,
            53.841742,
            53.913315
          ],
          [
            8.776344,
            53.841662,
            54.285922
          ],
          [
            8.776639,
            53.84157,
            54.158306
          ],
          [
            8.776925,
            53.84148,
            54.03452
          ],
          [
            8.77722,
            53.841402,
            53.911091
          ],
          [
            8.777512,
            53.841324,
            53.788714
          ],
          [
            8.777817,
            53.841242,
            53.660703
          ],
          [
            8.778129,
            53.84116,
            53.530253
          ],
          [
            8.778435,
            53.841088,
            53.404476
          ],
          [
            8.778718,
            53.84101,
            53.285211
          ],
          [
            8.779017,
            53.840937,
            53.161582
          ],
          [
            8.779309,
            53.840867,
            52.857002
          ],
          [
            8.779612,
            53.840791,
            52.468684
          ],
          [
            8.779923,
            53.840711,
            52.068571
          ],
          [
            8.780233,
            53.840639,
            51.675686
          ],
          [
            8.780538,
            53.840564,
            51.285784
          ],
          [
            8.780845,
            53.840487,
            50.891382
          ],
          [
            8.781182,
            53.840433,
            50.478755
          ],
          [
            8.781478,
            53.840367,
            50.104182
          ],
          [
            8.781781,
            53.840306,
            49.726432
          ],
          [
            8.782081,
            53.84024,
            49.624585
          ],
          [
            8.782401,
            53.840187,
            49.81482
          ],
          [
            8.782715,
            53.840129,
            50.003062
          ],
          [
            8.783031,
            53.840072,
            50.192155
          ],
          [
            8.783342,
            53.840015,
            50.378486
          ],
          [
            8.783649,
            53.839953,
            50.564134
          ],
          [
            8.783961,
            53.839896,
            50.751022
          ],
          [
            8.78427,
            53.839838,
            50.936622
          ],
          [
            8.784567,
            53.83978,
            51.115709
          ],
          [
            8.784877,
            53.839717,
            51.307506
          ],
          [
            8.78519,
            53.83966,
            51.526511
          ],
          [
            8.785505,
            53.839609,
            51.744903
          ],
          [
            8.785816,
            53.83956,
            51.960327
          ],
          [
            8.786131,
            53.839507,
            52.179415
          ],
          [
            8.786443,
            53.839461,
            52.394448
          ],
          [
            8.786898,
            53.839395,
            52.707712
          ],
          [
            8.787205,
            53.839351,
            52.919042
          ],
          [
            8.787522,
            53.839305,
            53.137317
          ],
          [
            8.787839,
            53.839267,
            53.334891
          ],
          [
            8.788155,
            53.839227,
            53.440615
          ],
          [
            8.788455,
            53.839174,
            53.543045
          ],
          [
            8.788775,
            53.839127,
            53.650913
          ],
          [
            8.789077,
            53.839068,
            53.75497
          ],
          [
            8.789418,
            53.839033,
            53.868183
          ],
          [
            8.789764,
            53.838988,
            53.984092
          ],
          [
            8.790096,
            53.838956,
            54.094136
          ],
          [
            8.790565,
            53.838908,
            54.249854
          ],
          [
            8.791031,
            53.838863,
            54.547774
          ],
          [
            8.791358,
            53.838828,
            54.828433
          ],
          [
            8.791684,
            53.838796,
            55.107476
          ],
          [
            8.792009,
            53.838761,
            55.386425
          ],
          [
            8.792341,
            53.838734,
            55.669452
          ],
          [
            8.79279,
            53.838688,
            56.054251
          ],
          [
            8.793103,
            53.838659,
            56.321982
          ],
          [
            8.793432,
            53.83863,
            56.602863
          ],
          [
            8.793752,
            53.838613,
            56.874237
          ],
          [
            8.794093,
            53.838588,
            56.80835
          ],
          [
            8.794417,
            53.838571,
            56.730006
          ],
          [
            8.794742,
            53.838552,
            56.651347
          ],
          [
            8.795057,
            53.838536,
            56.575182
          ],
          [
            8.795393,
            53.838516,
            56.493842
          ],
          [
            8.795715,
            53.838491,
            56.41558
          ],
          [
            8.796033,
            53.83847,
            56.338512
          ],
          [
            8.796368,
            53.838455,
            56.257594
          ],
          [
            8.796695,
            53.838443,
            56.178649
          ],
          [
            8.797024,
            53.83842,
            56.015234
          ],
          [
            8.797357,
            53.838404,
            55.811057
          ],
          [
            8.797682,
            53.83839,
            55.611914
          ],
          [
            8.798004,
            53.838382,
            55.414959
          ],
          [
            8.798323,
            53.838372,
            55.219628
          ],
          [
            8.798793,
            53.838367,
            54.932342
          ],
          [
            8.799118,
            53.838358,
            54.733484
          ],
          [
            8.799452,
            53.838341,
            54.528406
          ],
          [
            8.799779,
            53.838329,
            54.328143
          ],
          [
            8.800098,
            53.838316,
            54.430981
          ],
          [
            8.800436,
            53.838299,
            54.615728
          ],
          [
            8.800768,
            53.838291,
            54.796726
          ],
          [
            8.8011,
            53.838283,
            54.977771
          ],
          [
            8.801435,
            53.838281,
            55.160459
          ],
          [
            8.801772,
            53.838274,
            55.344108
          ],
          [
            8.802091,
            53.83827,
            55.517917
          ],
          [
            8.802421,
            53.838263,
            55.698302
          ],
          [
            8.802745,
            53.838262,
            55.874876
          ],
          [
            8.803065,
            53.83826,
            56.01385
          ],
          [
            8.803383,
            53.83826,
            56.125015
          ],
          [
            8.803706,
            53.838266,
            56.237925
          ],
          [
            8.804199,
            53.838253,
            56.410352
          ],
          [
            8.804535,
            53.838251,
            56.527808
          ],
          [
            8.805007,
            53.83824,
            56.692896
          ],
          [
            8.805364,
            53.838242,
            56.817686
          ],
          [
            8.805702,
            53.838235,
            56.935926
          ],
          [
            8.80604,
            53.838238,
            56.920744
          ],
          [
            8.806367,
            53.838238,
            56.640418
          ],
          [
            8.806714,
            53.838242,
            56.342878
          ],
          [
            8.807044,
            53.83824,
            56.059906
          ],
          [
            8.807355,
            53.83823,
            55.792483
          ],
          [
            8.807675,
            53.838232,
            55.5179
          ],
          [
            8.808,
            53.83824,
            55.239037
          ],
          [
            8.808332,
            53.838233,
            54.95421
          ],
          [
            8.808655,
            53.838229,
            54.676878
          ],
          [
            8.809152,
            53.838229,
            54.413471
          ],
          [
            8.809625,
            53.838227,
            54.443084
          ],
          [
            8.809948,
            53.838227,
            54.463305
          ],
          [
            8.810303,
            53.838231,
            54.485547
          ],
          [
            8.810631,
            53.838227,
            54.506086
          ],
          [
            8.810969,
            53.83823,
            54.527249
          ],
          [
            8.8113,
            53.838229,
            54.54797
          ],
          [
            8.811619,
            53.838222,
            54.567953
          ],
          [
            8.811974,
            53.838229,
            54.5902
          ],
          [
            8.812311,
            53.838228,
            54.639932
          ],
          [
            8.812635,
            53.838224,
            54.692355
          ],
          [
            8.812967,
            53.838218,
            54.74611
          ],
          [
            8.81329,
            53.838222,
            54.798371
          ],
          [
            8.813618,
            53.838223,
            54.851513
          ],
          [
            8.813943,
            53.838221,
            54.904112
          ],
          [
            8.814264,
            53.838218,
            54.956059
          ],
          [
            8.814586,
            53.838214,
            55.008159
          ],
          [
            8.814926,
            53.838216,
            55.063182
          ],
          [
            8.81525,
            53.838217,
            55.056861
          ],
          [
            8.815563,
            53.83821,
            55.006021
          ],
          [
            8.815907,
            53.838209,
            54.950184
          ],
          [
            8.816244,
            53.838216,
            54.895395
          ],
          [
            8.816587,
            53.838214,
            54.839719
          ],
          [
            8.81691,
            53.838204,
            54.787027
          ],
          [
            8.817244,
            53.838205,
            54.732808
          ],
          [
            8.817568,
            53.83821,
            54.6802
          ],
          [
            8.817887,
            53.838213,
            54.628397
          ],
          [
            8.818219,
            53.83822,
            54.495691
          ],
          [
            8.818553,
            53.838222,
            54.190809
          ],
          [
            8.818897,
            53.838221,
            53.876859
          ],
          [
            8.819225,
            53.838216,
            53.577502
          ],
          [
            8.81955,
            53.838216,
            53.280971
          ],
          [
            8.819865,
            53.838212,
            52.993445
          ],
          [
            8.82022,
            53.838208,
            52.669488
          ],
          [
            8.820552,
            53.838216,
            52.366074
          ],
          [
            8.820876,
            53.838229,
            52.069782
          ],
          [
            8.821194,
            53.838231,
            51.83497
          ],
          [
            8.82152,
            53.838238,
            52.071161
          ],
          [
            8.821842,
            53.838249,
            52.304749
          ],
          [
            8.822164,
            53.838265,
            52.538822
          ],
          [
            8.822491,
            53.838277,
            52.776058
          ],
          [
            8.822806,
            53.838277,
            53.004315
          ],
          [
            8.823133,
            53.838287,
            53.241415
          ],
          [
            8.823448,
            53.838286,
            53.469545
          ],
          [
            8.823779,
            53.838301,
            53.709895
          ],
          [
            8.824114,
            53.838304,
            53.952475
          ],
          [
            8.824443,
            53.838312,
            53.921018
          ],
          [
            8.824922,
            53.838322,
            53.728608
          ],
          [
            8.825243,
            53.838331,
            53.59967
          ],
          [
            8.825573,
            53.838343,
            53.466991
          ],
          [
            8.825929,
            53.838359,
            53.323743
          ],
          [
            8.826253,
            53.838368,
            53.193602
          ],
          [
            8.826582,
            53.838373,
            53.061555
          ],
          [
            8.82691,
            53.83838,
            52.929868
          ],
          [
            8.82725,
            53.838385,
            52.793567
          ],
          [
            8.827581,
            53.838389,
            52.687731
          ],
          [
            8.827912,
            53.838391,
            52.581912
          ],
          [
            8.828263,
            53.838398,
            52.469488
          ],
          [
            8.828576,
            53.838405,
            52.369361
          ],
          [
            8.828895,
            53.838413,
            52.267272
          ],
          [
            8.82924,
            53.838421,
            52.156825
          ],
          [
            8.829715,
            53.838419,
            52.004959
          ],
          [
            8.830052,
            53.838423,
            51.897206
          ],
          [
            8.830393,
            53.838435,
            51.768029
          ],
          [
            8.830721,
            53.838435,
            51.597289
          ],
          [
            8.831064,
            53.838439,
            51.418713
          ],
          [
            8.831401,
            53.838452,
            51.242889
          ],
          [
            8.831741,
            53.838457,
            51.065827
          ],
          [
            8.832075,
            53.838465,
            50.891866
          ],
          [
            8.832411,
            53.838471,
            50.716929
          ],
          [
            8.832764,
            53.838488,
            50.532651
          ],
          [
            8.833092,
            53.838498,
            50.361765
          ],
          [
            8.833427,
            53.838511,
            50.186412
          ],
          [
            8.833755,
            53.838523,
            50.013622
          ],
          [
            8.834092,
            53.838521,
            49.836209
          ],
          [
            8.834431,
            53.838537,
            49.657401
          ],
          [
            8.834772,
            53.838547,
            49.477887
          ],
          [
            8.835098,
            53.838554,
            49.30631
          ],
          [
            8.83543,
            53.838565,
            49.131459
          ],
          [
            8.835759,
            53.838571,
            48.958401
          ],
          [
            8.836095,
            53.838582,
            48.781472
          ],
          [
            8.836425,
            53.838592,
            48.631245
          ],
          [
            8.836748,
            53.838615,
            48.631461
          ],
          [
            8.837083,
            53.838627,
            48.631684
          ],
          [
            8.83742,
            53.838639,
            48.631908
          ],
          [
            8.837759,
            53.83865,
            48.632133
          ],
          [
            8.838098,
            53.83865,
            48.632358
          ],
          [
            8.838429,
            53.838659,
            48.632578
          ],
          [
            8.838795,
            53.838678,
            48.632822
          ],
          [
            8.839115,
            53.838688,
            48.633035
          ],
          [
            8.83945,
            53.838698,
            48.629974
          ],
          [
            8.8398,
            53.838709,
            48.590777
          ],
          [
            8.840129,
            53.838717,
            48.553951
          ],
          [
            8.840456,
            53.838724,
            48.517348
          ],
          [
            8.840787,
            53.838733,
            48.480281
          ],
          [
            8.841124,
            53.838738,
            48.442582
          ],
          [
            8.841453,
            53.838742,
            48.40578
          ],
          [
            8.841777,
            53.838758,
            48.369403
          ],
          [
            8.84212,
            53.838768,
            48.330984
          ],
          [
            8.842452,
            53.838779,
            48.293793
          ],
          [
            8.842763,
            53.838787,
            48.40871
          ],
          [
            8.843103,
            53.838796,
            48.541261
          ],
          [
            8.843442,
            53.838804,
            48.673521
          ],
          [
            8.843783,
            53.838808,
            48.806337
          ],
          [
            8.84412,
            53.83882,
            48.937787
          ],
          [
            8.84444,
            53.838829,
            49.062522
          ],
          [
            8.844782,
            53.838837,
            49.195886
          ],
          [
            8.845111,
            53.838843,
            49.324043
          ],
          [
            8.845447,
            53.838851,
            49.454976
          ],
          [
            8.845916,
            53.838862,
            49.563746
          ],
          [
            8.846269,
            53.838888,
            49.637628
          ],
          [
            8.846626,
            53.838904,
            49.712034
          ],
          [
            8.84696,
            53.838914,
            49.781486
          ],
          [
            8.847288,
            53.838925,
            49.849735
          ],
          [
            8.847601,
            53.838938,
            49.914919
          ],
          [
            8.847924,
            53.83895,
            49.982134
          ],
          [
            8.848262,
            53.83897,
            50.052691
          ],
          [
            8.848586,
            53.838977,
            50.133539
          ],
          [
            8.848903,
            53.838982,
            50.313485
          ],
          [
            8.849233,
            53.838989,
            50.500844
          ],
          [
            8.849553,
            53.838998,
            50.682733
          ],
          [
            8.849895,
            53.839019,
            50.878
          ],
          [
            8.850219,
            53.839038,
            51.062852
          ],
          [
            8.850538,
            53.83905,
            51.245031
          ],
          [
            8.850869,
            53.839062,
            51.433205
          ],
          [
            8.851195,
            53.839082,
            51.619174
          ],
          [
            8.851516,
            53.839101,
            51.802292
          ],
          [
            8.851852,
            53.839115,
            52.157394
          ],
          [
            8.852324,
            53.839129,
            52.71537
          ],
          [
            8.852656,
            53.839155,
            53.110761
          ],
          [
            8.852982,
            53.839175,
            53.497847
          ],
          [
            8.853315,
            53.839187,
            53.891786
          ],
          [
            8.853639,
            53.839198,
            54.27491
          ],
          [
            8.854096,
            53.839225,
            54.817284
          ],
          [
            8.854422,
            53.839236,
            55.202764
          ],
          [
            8.854748,
            53.839258,
            55.326119
          ],
          [
            8.855084,
            53.839284,
            55.021447
          ],
          [
            8.855547,
            53.839314,
            54.602314
          ],
          [
            8.855878,
            53.839334,
            54.303297
          ],
          [
            8.856214,
            53.839355,
            53.999566
          ],
          [
            8.856556,
            53.839374,
            53.69089
          ],
          [
            8.856885,
            53.839386,
            53.394279
          ],
          [
            8.857218,
            53.839407,
            53.09326
          ],
          [
            8.85754,
            53.839425,
            52.802643
          ],
          [
            8.857873,
            53.839441,
            52.744154
          ],
          [
            8.858213,
            53.839458,
            52.809812
          ],
          [
            8.858687,
            53.839484,
            52.901407
          ],
          [
            8.859012,
            53.839505,
            52.964354
          ],
          [
            8.859338,
            53.83952,
            53.027281
          ],
          [
            8.859665,
            53.839536,
            53.090417
          ],
          [
            8.859997,
            53.839554,
            53.154577
          ],
          [
            8.860325,
            53.839571,
            53.217931
          ],
          [
            8.860648,
            53.839583,
            53.280235
          ],
          [
            8.860977,
            53.839607,
            53.193014
          ],
          [
            8.861445,
            53.83963,
            53.039544
          ],
          [
            8.861924,
            53.839653,
            52.882594
          ],
          [
            8.862384,
            53.839675,
            52.731857
          ],
          [
            8.862703,
            53.839688,
            52.627402
          ],
          [
            8.863019,
            53.839706,
            52.523676
          ],
          [
            8.863355,
            53.839722,
            52.413592
          ],
          [
            8.863691,
            53.839749,
            52.30284
          ],
          [
            8.864024,
            53.839765,
            52.139529
          ],
          [
            8.86433,
            53.839778,
            51.984495
          ],
          [
            8.864657,
            53.839792,
            51.818779
          ],
          [
            8.864995,
            53.839814,
            51.646835
          ],
          [
            8.865307,
            53.839828,
            51.488629
          ],
          [
            8.86578,
            53.839857,
            51.248319
          ],
          [
            8.866106,
            53.839875,
            51.082827
          ],
          [
            8.866431,
            53.839891,
            50.917894
          ],
          [
            8.866764,
            53.839896,
            50.755126
          ],
          [
            8.867094,
            53.839903,
            50.944817
          ],
          [
            8.867434,
            53.839922,
            51.141068
          ],
          [
            8.867764,
            53.839932,
            51.331052
          ],
          [
            8.868244,
            53.839942,
            51.606971
          ],
          [
            8.868562,
            53.839952,
            51.789913
          ],
          [
            8.868894,
            53.839971,
            51.981578
          ],
          [
            8.869217,
            53.839982,
            52.167498
          ],
          [
            8.869539,
            53.840001,
            52.353418
          ],
          [
            8.86987,
            53.840016,
            52.533841
          ],
          [
            8.870186,
            53.840029,
            52.670025
          ],
          [
            8.870517,
            53.840046,
            52.812745
          ],
          [
            8.870845,
            53.84006,
            52.954036
          ],
          [
            8.871168,
            53.84007,
            53.092935
          ],
          [
            8.871492,
            53.840078,
            53.232194
          ],
          [
            8.871804,
            53.840083,
            53.36632
          ],
          [
            8.872132,
            53.840107,
            53.508395
          ],
          [
            8.872461,
            53.840121,
            53.650134
          ],
          [
            8.872788,
            53.840128,
            53.790646
          ],
          [
            8.873114,
            53.840139,
            53.985768
          ],
          [
            8.8736,
            53.840161,
            54.292067
          ],
          [
            8.873927,
            53.840175,
            54.49808
          ],
          [
            8.874248,
            53.840186,
            54.700103
          ],
          [
            8.874577,
            53.840204,
            54.907669
          ],
          [
            8.874901,
            53.840223,
            55.112222
          ],
          [
            8.875234,
            53.840247,
            55.322958
          ],
          [
            8.875556,
            53.840264,
            55.526007
          ],
          [
            8.875883,
            53.84029,
            55.698495
          ],
          [
            8.876202,
            53.840308,
            54.821412
          ],
          [
            8.876667,
            53.840332,
            53.543525
          ],
          [
            8.876994,
            53.840346,
            52.646217
          ],
          [
            8.877315,
            53.840376,
            51.755014
          ],
          [
            8.877627,
            53.84038,
            50.900448
          ],
          [
            8.877943,
            53.840391,
            50.033792
          ],
          [
            8.878265,
            53.840398,
            49.151349
          ],
          [
            8.878585,
            53.84042,
            48.269605
          ],
          [
            8.87891,
            53.840434,
            47.382575
          ],
          [
            8.879236,
            53.840455,
            47.183418
          ],
          [
            8.879565,
            53.84048,
            46.982012
          ],
          [
            8.879895,
            53.840494,
            46.781111
          ],
          [
            8.880373,
            53.84052,
            46.489643
          ],
          [
            8.880701,
            53.840529,
            46.290242
          ],
          [
            8.881029,
            53.840537,
            46.090949
          ],
          [
            8.881358,
            53.840548,
            45.890839
          ],
          [
            8.881828,
            53.840571,
            45.604539
          ],
          [
            8.882141,
            53.840586,
            45.638464
          ],
          [
            8.882474,
            53.840601,
            45.816775
          ],
          [
            8.882803,
            53.840617,
            45.992927
          ],
          [
            8.883114,
            53.840635,
            46.159663
          ],
          [
            8.883433,
            53.840649,
            46.330349
          ],
          [
            8.88375,
            53.840657,
            46.499643
          ],
          [
            8.884067,
            53.840673,
            46.669402
          ],
          [
            8.88439,
            53.840689,
            46.84235
          ],
          [
            8.884708,
            53.840698,
            47.012221
          ],
          [
            8.885036,
            53.840715,
            47.157623
          ],
          [
            8.885368,
            53.840736,
            47.142986
          ],
          [
            8.885703,
            53.840759,
            47.128202
          ],
          [
            8.886034,
            53.840773,
            47.113655
          ],
          [
            8.886361,
            53.840765,
            47.099303
          ],
          [
            8.886693,
            53.84079,
            47.084633
          ],
          [
            8.88701,
            53.840807,
            47.070672
          ],
          [
            8.887482,
            53.840815,
            47.049967
          ],
          [
            8.887955,
            53.840833,
            47.029189
          ],
          [
            8.888269,
            53.840845,
            47.204596
          ],
          [
            8.888585,
            53.840863,
            47.4319
          ],
          [
            8.888895,
            53.840875,
            47.65433
          ],
          [
            8.889205,
            53.840895,
            47.877651
          ],
          [
            8.889525,
            53.840911,
            48.10758
          ],
          [
            8.889834,
            53.840929,
            48.329879
          ],
          [
            8.890164,
            53.840951,
            48.567653
          ],
          [
            8.890472,
            53.840966,
            48.789067
          ],
          [
            8.890958,
            53.841004,
            49.140138
          ],
          [
            8.891285,
            53.841031,
            49.216423
          ],
          [
            8.891605,
            53.841043,
            49.226905
          ],
          [
            8.892074,
            53.841059,
            49.242262
          ],
          [
            8.892398,
            53.841077,
            49.252926
          ],
          [
            8.892733,
            53.841095,
            49.263939
          ],
          [
            8.893048,
            53.841118,
            49.274314
          ],
          [
            8.893359,
            53.84114,
            49.284551
          ],
          [
            8.893673,
            53.841165,
            49.294907
          ],
          [
            8.893995,
            53.84118,
            49.305471
          ],
          [
            8.894314,
            53.841199,
            49.569974
          ],
          [
            8.894786,
            53.841233,
            50.10812
          ],
          [
            8.895114,
            53.841246,
            50.480444
          ],
          [
            8.895576,
            53.841275,
            51.006105
          ],
          [
            8.8959,
            53.841296,
            51.375286
          ],
          [
            8.896231,
            53.841318,
            51.752191
          ],
          [
            8.89655,
            53.84134,
            52.115586
          ],
          [
            8.896873,
            53.841362,
            52.483476
          ],
          [
            8.897194,
            53.841374,
            52.804534
          ],
          [
            8.897515,
            53.841398,
            52.996226
          ],
          [
            8.897832,
            53.841418,
            53.185195
          ],
          [
            8.898162,
            53.841445,
            53.382569
          ],
          [
            8.898483,
            53.841463,
            53.573762
          ],
          [
            8.898798,
            53.841484,
            53.761568
          ],
          [
            8.899117,
            53.841508,
            53.952088
          ],
          [
            8.899435,
            53.841532,
            54.142065
          ],
          [
            8.899739,
            53.841551,
            54.323174
          ],
          [
            8.900065,
            53.841576,
            54.518026
          ],
          [
            8.900383,
            53.841592,
            54.492947
          ],
          [
            8.900716,
            53.841613,
            54.395659
          ],
          [
            8.901177,
            53.841645,
            54.260819
          ],
          [
            8.9015,
            53.84167,
            54.166178
          ],
          [
            8.901814,
            53.841693,
            54.074255
          ],
          [
            8.90213,
            53.841711,
            53.98187
          ],
          [
            8.902442,
            53.841725,
            53.890958
          ],
          [
            8.902777,
            53.841736,
            53.793043
          ],
          [
            8.90311,
            53.841762,
            53.695462
          ],
          [
            8.903423,
            53.841785,
            53.652579
          ],
          [
            8.903732,
            53.841807,
            53.621683
          ],
          [
            8.904064,
            53.841837,
            53.588345
          ],
          [
            8.904513,
            53.841884,
            53.543061
          ],
          [
            8.904834,
            53.841898,
            53.51111
          ],
          [
            8.905154,
            53.841921,
            53.479113
          ],
          [
            8.905482,
            53.841943,
            53.446334
          ],
          [
            8.905794,
            53.841969,
            53.415057
          ],
          [
            8.90611,
            53.841991,
            53.383472
          ],
          [
            8.906425,
            53.842017,
            53.361862
          ],
          [
            8.906748,
            53.842047,
            53.343218
          ],
          [
            8.907215,
            53.842083,
            53.316364
          ],
          [
            8.907536,
            53.842111,
            53.29786
          ],
          [
            8.907849,
            53.842134,
            53.279873
          ],
          [
            8.908162,
            53.842164,
            53.26179
          ],
          [
            8.908493,
            53.842198,
            53.242632
          ],
          [
            8.908815,
            53.842229,
            53.224027
          ],
          [
            8.909143,
            53.842258,
            53.205114
          ],
          [
            8.909478,
            53.842292,
            53.266317
          ],
          [
            8.909802,
            53.842332,
            53.343931
          ],
          [
            8.910116,
            53.842368,
            53.418931
          ],
          [
            8.910437,
            53.842398,
            53.495141
          ],
          [
            8.910751,
            53.842431,
            53.569931
          ],
          [
            8.911064,
            53.842464,
            53.64448
          ],
          [
            8.911378,
            53.842491,
            53.7189
          ],
          [
            8.911698,
            53.842518,
            53.794715
          ],
          [
            8.912012,
            53.842557,
            53.869954
          ],
          [
            8.912325,
            53.842587,
            53.956333
          ],
          [
            8.912787,
            53.842634,
            54.113387
          ],
          [
            8.913104,
            53.842672,
            54.221757
          ],
          [
            8.913427,
            53.842704,
            54.331482
          ],
          [
            8.91375,
            53.842743,
            54.441974
          ],
          [
            8.914069,
            53.842775,
            54.550366
          ],
          [
            8.914395,
            53.842803,
            54.660807
          ],
          [
            8.91471,
            53.842827,
            54.767287
          ],
          [
            8.915025,
            53.842858,
            54.874264
          ],
          [
            8.915359,
            53.842889,
            54.959722
          ],
          [
            8.915682,
            53.842909,
            55.008232
          ],
          [
            8.915993,
            53.842936,
            55.055108
          ],
          [
            8.916314,
            53.842966,
            55.103576
          ],
          [
            8.916642,
            53.843,
            55.153264
          ],
          [
            8.916968,
            53.843034,
            55.202617
          ],
          [
            8.917295,
            53.843069,
            55.252158
          ],
          [
            8.917619,
            53.843101,
            55.301131
          ],
          [
            8.917947,
            53.843135,
            55.350774
          ],
          [
            8.918272,
            53.843167,
            55.391765
          ],
          [
            8.918748,
            53.843213,
            55.390797
          ],
          [
            8.919065,
            53.843244,
            55.390153
          ],
          [
            8.919379,
            53.843272,
            55.389516
          ],
          [
            8.919696,
            53.843297,
            55.388874
          ],
          [
            8.920023,
            53.843326,
            55.388211
          ],
          [
            8.920341,
            53.843355,
            55.387566
          ],
          [
            8.920675,
            53.843395,
            55.386882
          ],
          [
            8.920986,
            53.843422,
            55.386251
          ],
          [
            8.921316,
            53.843458,
            55.300396
          ],
          [
            8.921665,
            53.843494,
            54.964752
          ],
          [
            8.921991,
            53.843532,
            54.649944
          ],
          [
            8.922315,
            53.843571,
            54.336609
          ],
          [
            8.922646,
            53.843603,
            54.018806
          ],
          [
            8.922965,
            53.843634,
            53.712478
          ],
          [
            8.923299,
            53.843667,
            53.391673
          ],
          [
            8.923618,
            53.843689,
            53.086926
          ],
          [
            8.923951,
            53.843717,
            52.76826
          ],
          [
            8.924282,
            53.843756,
            52.48125
          ],
          [
            8.924762,
            53.843804,
            52.326134
          ],
          [
            8.925092,
            53.843842,
            52.219011
          ],
          [
            8.925421,
            53.843859,
            52.113456
          ],
          [
            8.925763,
            53.84389,
            52.003207
          ],
          [
            8.926095,
            53.843925,
            51.895734
          ],
          [
            8.926418,
            53.84395,
            51.791883
          ],
          [
            8.926754,
            53.843973,
            51.683679
          ],
          [
            8.927078,
            53.844006,
            51.57887
          ],
          [
            8.927387,
            53.844045,
            51.513408
          ],
          [
            8.927725,
            53.84408,
            51.483702
          ],
          [
            8.928047,
            53.844111,
            51.455454
          ],
          [
            8.928373,
            53.844145,
            51.426787
          ],
          [
            8.928705,
            53.844176,
            51.397688
          ],
          [
            8.929037,
            53.844207,
            51.368584
          ],
          [
            8.929371,
            53.844243,
            51.339193
          ],
          [
            8.929694,
            53.844272,
            51.310893
          ],
          [
            8.93002,
            53.844307,
            51.282201
          ],
          [
            8.930353,
            53.844337,
            51.20147
          ],
          [
            8.930682,
            53.844366,
            51.017971
          ],
          [
            8.931,
            53.844392,
            50.840775
          ],
          [
            8.931318,
            53.844424,
            50.662831
          ],
          [
            8.931635,
            53.844461,
            50.48456
          ],
          [
            8.931973,
            53.844495,
            50.295431
          ],
          [
            8.932296,
            53.844516,
            50.116062
          ],
          [
            8.932618,
            53.844538,
            49.937269
          ],
          [
            8.932947,
            53.844572,
            49.753028
          ],
          [
            8.933267,
            53.844596,
            49.569882
          ],
          [
            8.933579,
            53.844631,
            49.246313
          ],
          [
            8.933888,
            53.844659,
            48.927645
          ],
          [
            8.934208,
            53.844676,
            48.60056
          ],
          [
            8.934531,
            53.844706,
            48.267661
          ],
          [
            8.934851,
            53.844731,
            47.938534
          ],
          [
            8.93517,
            53.844745,
            47.612894
          ],
          [
            8.935488,
            53.844779,
            47.283039
          ],
          [
            8.935812,
            53.844819,
            46.946042
          ],
          [
            8.936135,
            53.844864,
            46.607434
          ],
          [
            8.936455,
            53.844898,
            46.783266
          ],
          [
            8.936931,
            53.844932,
            47.525341
          ],
          [
            8.93726,
            53.844936,
            48.03591
          ],
          [
            8.937581,
            53.844971,
            48.54264
          ],
          [
            8.937899,
            53.84502,
            49.052978
          ],
          [
            8.938225,
            53.845067,
            49.57264
          ],
          [
            8.938547,
            53.845104,
            50.080471
          ],
          [
            8.939,
            53.845165,
            50.799584
          ],
          [
            8.939329,
            53.84522,
            51.305457
          ],
          [
            8.939661,
            53.845265,
            51.738636
          ],
          [
            8.939972,
            53.845308,
            52.144834
          ],
          [
            8.940312,
            53.84535,
            52.58669
          ],
          [
            8.940632,
            53.845387,
            53.001451
          ],
          [
            8.940953,
            53.845421,
            53.416169
          ],
          [
            8.941264,
            53.845452,
            53.817303
          ],
          [
            8.94158,
            53.845477,
            54.22274
          ],
          [
            8.941898,
            53.845506,
            54.631939
          ],
          [
            8.942212,
            53.845539,
            55.037515
          ],
          [
            8.942545,
            53.845574,
            54.989785
          ],
          [
            8.942871,
            53.845606,
            54.901858
          ],
          [
            8.943195,
            53.845643,
            54.814074
          ],
          [
            8.943515,
            53.84568,
            54.727333
          ],
          [
            8.943836,
            53.845723,
            54.639773
          ],
          [
            8.944146,
            53.845759,
            54.55573
          ],
          [
            8.944461,
            53.845799,
            54.470002
          ],
          [
            8.944769,
            53.84583,
            54.386877
          ],
          [
            8.945106,
            53.84587,
            54.29544
          ],
          [
            8.945425,
            53.845902,
            54.177486
          ],
          [
            8.945761,
            53.845915,
            54.032176
          ],
          [
            8.946095,
            53.845949,
            53.886868
          ],
          [
            8.946415,
            53.845989,
            53.746637
          ],
          [
            8.946737,
            53.846027,
            53.605839
          ],
          [
            8.947071,
            53.84607,
            53.459288
          ],
          [
            8.947387,
            53.846106,
            53.321315
          ],
          [
            8.947709,
            53.846138,
            53.18133
          ],
          [
            8.94803,
            53.846171,
            53.041581
          ],
          [
            8.948495,
            53.846222,
            52.902903
          ],
          [
            8.94881,
            53.846247,
            52.842072
          ],
          [
            8.949135,
            53.846286,
            52.778594
          ],
          [
            8.949469,
            53.846321,
            52.713631
          ],
          [
            8.949942,
            53.846366,
            52.621929
          ],
          [
            8.950253,
            53.84639,
            52.561908
          ],
          [
            8.950586,
            53.846428,
            52.497007
          ],
          [
            8.950912,
            53.846457,
            52.433867
          ],
          [
            8.951225,
            53.846491,
            52.372967
          ],
          [
            8.951559,
            53.846528,
            52.398951
          ],
          [
            8.951889,
            53.846568,
            52.427189
          ],
          [
            8.952215,
            53.846602,
            52.454952
          ],
          [
            8.952527,
            53.846638,
            52.481598
          ],
          [
            8.952848,
            53.846671,
            52.508909
          ],
          [
            8.953163,
            53.846701,
            52.535655
          ],
          [
            8.953491,
            53.846736,
            52.563594
          ],
          [
            8.953801,
            53.846769,
            52.589999
          ],
          [
            8.954141,
            53.846811,
            52.619182
          ],
          [
            8.954478,
            53.846856,
            52.521081
          ],
          [
            8.954948,
            53.846906,
            52.32362
          ],
          [
            8.955267,
            53.846937,
            52.189947
          ],
          [
            8.955586,
            53.846967,
            52.056388
          ],
          [
            8.955913,
            53.847003,
            51.918757
          ],
          [
            8.956232,
            53.847037,
            51.784718
          ],
          [
            8.956556,
            53.847067,
            51.649105
          ],
          [
            8.956881,
            53.847103,
            51.512383
          ],
          [
            8.957188,
            53.847133,
            51.383719
          ],
          [
            8.957515,
            53.847169,
            51.429089
          ],
          [
            8.957827,
            53.847195,
            51.497423
          ],
          [
            8.958289,
            53.84725,
            51.599607
          ],
          [
            8.958604,
            53.847286,
            51.669171
          ],
          [
            8.958922,
            53.847314,
            51.738863
          ],
          [
            8.959256,
            53.847349,
            51.812399
          ],
          [
            8.959571,
            53.847377,
            51.881448
          ],
          [
            8.959893,
            53.84741,
            51.952346
          ],
          [
            8.960221,
            53.84744,
            52.024291
          ],
          [
            8.960552,
            53.847481,
            51.976287
          ],
          [
            8.960901,
            53.847517,
            51.921064
          ],
          [
            8.961217,
            53.847554,
            51.870857
          ],
          [
            8.96153,
            53.847594,
            51.820948
          ],
          [
            8.961847,
            53.84763,
            51.770633
          ],
          [
            8.962184,
            53.847658,
            51.717536
          ],
          [
            8.962507,
            53.847682,
            51.666804
          ],
          [
            8.962826,
            53.84772,
            51.616067
          ],
          [
            8.963154,
            53.847752,
            51.564254
          ],
          [
            8.963475,
            53.847776,
            51.702757
          ],
          [
            8.96379,
            53.847809,
            51.900274
          ],
          [
            8.964126,
            53.847844,
            52.110973
          ],
          [
            8.964455,
            53.84788,
            52.317565
          ],
          [
            8.96478,
            53.847916,
            52.521722
          ],
          [
            8.965091,
            53.847954,
            52.717828
          ],
          [
            8.965421,
            53.847986,
            52.924322
          ],
          [
            8.965764,
            53.848022,
            53.139405
          ],
          [
            8.966085,
            53.848051,
            53.339893
          ],
          [
            8.96639,
            53.848089,
            53.393761
          ],
          [
            8.966701,
            53.848126,
            53.313152
          ],
          [
            8.967026,
            53.84817,
            53.22842
          ],
          [
            8.967354,
            53.848217,
            53.142588
          ],
          [
            8.967672,
            53.848254,
            53.06021
          ],
          [
            8.967981,
            53.848291,
            52.980103
          ],
          [
            8.9683,
            53.848323,
            52.897881
          ],
          [
            8.968615,
            53.848358,
            52.816414
          ],
          [
            8.968937,
            53.848393,
            52.73323
          ],
          [
            8.969261,
            53.84843,
            52.673652
          ],
          [
            8.969581,
            53.848477,
            52.788885
          ],
          [
            8.969889,
            53.84852,
            52.899483
          ],
          [
            8.970208,
            53.848557,
            53.013094
          ],
          [
            8.970533,
            53.848607,
            53.13052
          ],
          [
            8.97086,
            53.848652,
            53.247929
          ],
          [
            8.971182,
            53.848692,
            53.362915
          ],
          [
            8.97152,
            53.84875,
            53.486046
          ],
          [
            8.97183,
            53.848789,
            53.596818
          ],
          [
            8.972144,
            53.84883,
            53.709203
          ],
          [
            8.972472,
            53.848875,
            53.983023
          ],
          [
            8.972799,
            53.848916,
            54.278744
          ],
          [
            8.973108,
            53.848963,
            54.561062
          ],
          [
            8.973438,
            53.849006,
            54.859975
          ],
          [
            8.973758,
            53.849058,
            55.153675
          ],
          [
            8.974072,
            53.849101,
            55.438797
          ],
          [
            8.974372,
            53.849147,
            55.712959
          ],
          [
            8.974679,
            53.849193,
            55.99321
          ],
          [
            8.97499,
            53.849232,
            56.274695
          ],
          [
            8.975313,
            53.849278,
            56.372089
          ],
          [
            8.975629,
            53.849335,
            56.273742
          ],
          [
            8.976247,
            53.849411,
            56.085858
          ],
          [
            8.976706,
            53.849468,
            55.946261
          ],
          [
            8.977044,
            53.849511,
            55.843332
          ],
          [
            8.977371,
            53.849556,
            55.743347
          ],
          [
            8.977835,
            53.849615,
            55.602033
          ],
          [
            8.97815,
            53.849663,
            55.487175
          ],
          [
            8.978463,
            53.849709,
            55.204015
          ],
          [
            8.978782,
            53.849762,
            54.913226
          ],
          [
            8.979104,
            53.849798,
            54.625448
          ],
          [
            8.979431,
            53.849842,
            54.330917
          ],
          [
            8.979752,
            53.849883,
            54.042738
          ],
          [
            8.980054,
            53.849924,
            53.770802
          ],
          [
            8.98037,
            53.849958,
            53.488824
          ],
          [
            8.980987,
            53.850039,
            52.934224
          ],
          [
            8.981305,
            53.850077,
            52.829073
          ],
          [
            8.981616,
            53.850123,
            52.814202
          ],
          [
            8.981934,
            53.850176,
            52.798877
          ],
          [
            8.982265,
            53.850224,
            52.783074
          ],
          [
            8.982587,
            53.850275,
            52.767615
          ],
          [
            8.982918,
            53.850325,
            52.75176
          ],
          [
            8.983227,
            53.85036,
            52.737163
          ],
          [
            8.983693,
            53.85043,
            52.714867
          ],
          [
            8.984154,
            53.850496,
            52.799315
          ],
          [
            8.984616,
            53.850565,
            53.260654
          ],
          [
            8.984924,
            53.850617,
            53.570766
          ],
          [
            8.985259,
            53.850672,
            53.907529
          ],
          [
            8.985577,
            53.850715,
            54.223335
          ],
          [
            8.9859,
            53.850758,
            54.543897
          ],
          [
            8.986216,
            53.850799,
            54.857142
          ],
          [
            8.986534,
            53.850842,
            55.173166
          ],
          [
            8.986874,
            53.850886,
            55.510332
          ],
          [
            8.987184,
            53.850934,
            55.787461
          ],
          [
            8.9875,
            53.850979,
            56.041249
          ],
          [
            8.987821,
            53.851023,
            56.298561
          ],
          [
            8.988133,
            53.851071,
            56.550268
          ],
          [
            8.988586,
            53.851137,
            56.914525
          ],
          [
            8.989048,
            53.851203,
            57.285615
          ],
          [
            8.989365,
            53.851252,
            57.541485
          ],
          [
            8.989676,
            53.851291,
            57.789715
          ],
          [
            8.990286,
            53.851369,
            57.799778
          ],
          [
            8.990725,
            53.851418,
            57.476032
          ],
          [
            8.991046,
            53.851459,
            57.238046
          ],
          [
            8.991351,
            53.851503,
            57.010529
          ],
          [
            8.991662,
            53.851548,
            56.778474
          ],
          [
            8.991975,
            53.851583,
            56.547636
          ],
          [
            8.992288,
            53.85163,
            56.313602
          ],
          [
            8.992605,
            53.851675,
            56.077344
          ],
          [
            8.992921,
            53.85172,
            55.841787
          ],
          [
            8.993227,
            53.851763,
            55.769563
          ],
          [
            8.993699,
            53.851827,
            55.683605
          ],
          [
            8.994013,
            53.851877,
            55.625885
          ],
          [
            8.99447,
            53.851939,
            55.542656
          ],
          [
            8.99478,
            53.851982,
            55.486143
          ],
          [
            8.995086,
            53.852034,
            55.429576
          ],
          [
            8.995406,
            53.852073,
            55.371577
          ],
          [
            8.995717,
            53.852117,
            55.314808
          ],
          [
            8.996054,
            53.852165,
            55.231502
          ],
          [
            8.996378,
            53.852214,
            55.121832
          ],
          [
            8.996846,
            53.852271,
            54.965158
          ],
          [
            8.997149,
            53.852317,
            54.862566
          ],
          [
            8.997456,
            53.852365,
            54.758403
          ],
          [
            8.997766,
            53.852419,
            54.652371
          ],
          [
            8.998069,
            53.852462,
            54.5502
          ],
          [
            8.998386,
            53.852507,
            54.443229
          ],
          [
            8.998694,
            53.852549,
            54.339594
          ],
          [
            8.999147,
            53.852622,
            54.279239
          ],
          [
            8.999562,
            53.852701,
            54.279102
          ],
          [
            8.999871,
            53.852748,
            54.279001
          ],
          [
            9.000173,
            53.852797,
            54.278903
          ],
          [
            9.000482,
            53.852847,
            54.278802
          ],
          [
            9.000787,
            53.852897,
            54.278702
          ],
          [
            9.001247,
            53.85298,
            54.27855
          ],
          [
            9.001552,
            53.853037,
            54.278449
          ],
          [
            9.00185,
            53.853093,
            54.334809
          ],
          [
            9.002158,
            53.853149,
            54.657989
          ],
          [
            9.002613,
            53.853233,
            55.136034
          ],
          [
            9.002934,
            53.853293,
            55.473661
          ],
          [
            9.003514,
            53.853396,
            56.080969
          ],
          [
            9.003956,
            53.853479,
            56.546007
          ],
          [
            9.004251,
            53.853544,
            56.861967
          ],
          [
            9.004558,
            53.853602,
            57.185379
          ],
          [
            9.005019,
            53.853698,
            57.420253
          ],
          [
            9.005468,
            53.853789,
            57.538991
          ],
          [
            9.005897,
            53.853869,
            57.651495
          ],
          [
            9.006192,
            53.853928,
            57.729393
          ],
          [
            9.006491,
            53.853993,
            57.809114
          ],
          [
            9.006798,
            53.854061,
            57.891096
          ],
          [
            9.007239,
            53.854162,
            58.009358
          ],
          [
            9.007534,
            53.854232,
            58.088848
          ],
          [
            9.007845,
            53.854296,
            58.07193
          ],
          [
            9.008144,
            53.854357,
            58.044126
          ],
          [
            9.008578,
            53.85445,
            58.00363
          ],
          [
            9.009017,
            53.854539,
            57.962926
          ],
          [
            9.009476,
            53.854639,
            57.920011
          ],
          [
            9.009917,
            53.854734,
            57.878848
          ],
          [
            9.010213,
            53.854795,
            57.851357
          ],
          [
            9.010641,
            53.854894,
            57.599832
          ],
          [
            9.01105,
            53.854996,
            57.135227
          ],
          [
            9.011481,
            53.855107,
            56.643162
          ],
          [
            9.011775,
            53.855177,
            56.31139
          ],
          [
            9.012084,
            53.855253,
            55.9611
          ],
          [
            9.012382,
            53.855331,
            55.619956
          ],
          [
            9.012678,
            53.855419,
            55.273144
          ],
          [
            9.013104,
            53.855534,
            54.782928
          ],
          [
            9.0134,
            53.855611,
            54.533335
          ],
          [
            9.013828,
            53.85571,
            54.271351
          ],
          [
            9.014123,
            53.855791,
            54.085953
          ],
          [
            9.014413,
            53.855868,
            53.904727
          ],
          [
            9.014703,
            53.855951,
            53.721049
          ],
          [
            9.01515,
            53.856076,
            53.439198
          ],
          [
            9.015433,
            53.856156,
            53.26029
          ],
          [
            9.015858,
            53.856274,
            52.992662
          ],
          [
            9.016266,
            53.85639,
            52.94785
          ],
          [
            9.016691,
            53.856509,
            53.020381
          ],
          [
            9.016979,
            53.856599,
            53.070655
          ],
          [
            9.017276,
            53.85669,
            53.122266
          ],
          [
            9.017567,
            53.856787,
            53.173797
          ],
          [
            9.01784,
            53.85688,
            53.222399
          ],
          [
            9.018133,
            53.85697,
            53.273363
          ],
          [
            9.018544,
            53.857113,
            53.346937
          ],
          [
            9.018816,
            53.857202,
            53.458463
          ],
          [
            9.019095,
            53.857292,
            53.64713
          ],
          [
            9.019398,
            53.857388,
            53.851008
          ],
          [
            9.019687,
            53.857473,
            54.042542
          ],
          [
            9.020215,
            53.857636,
            54.395677
          ],
          [
            9.02061,
            53.857767,
            54.664239
          ],
          [
            9.020887,
            53.85786,
            54.853101
          ],
          [
            9.021299,
            53.857999,
            55.134344
          ],
          [
            9.021706,
            53.858139,
            55.441469
          ],
          [
            9.022209,
            53.858316,
            55.829987
          ],
          [
            9.022473,
            53.858413,
            56.036289
          ],
          [
            9.02274,
            53.858509,
            56.243691
          ],
          [
            9.023143,
            53.858647,
            56.552766
          ],
          [
            9.023416,
            53.858748,
            56.76651
          ],
          [
            9.023811,
            53.858894,
            57.075718
          ],
          [
            9.024201,
            53.859036,
            57.467988
          ],
          [
            9.024592,
            53.859185,
            57.93037
          ],
          [
            9.024859,
            53.859278,
            58.238333
          ],
          [
            9.025133,
            53.859373,
            58.554093
          ],
          [
            9.025526,
            53.859514,
            59.010985
          ],
          [
            9.025793,
            53.859608,
            59.320162
          ],
          [
            9.026068,
            53.859707,
            59.640139
          ],
          [
            9.02634,
            53.85981,
            59.961187
          ],
          [
            9.026861,
            53.859997,
            60.194949
          ],
          [
            9.027253,
            53.860136,
            60.146241
          ],
          [
            9.02766,
            53.860281,
            60.095602
          ],
          [
            9.027938,
            53.860377,
            60.061297
          ],
          [
            9.028213,
            53.860473,
            60.027266
          ],
          [
            9.028604,
            53.860609,
            59.978927
          ],
          [
            9.028875,
            53.860706,
            59.945167
          ],
          [
            9.029153,
            53.860807,
            59.910384
          ],
          [
            9.029427,
            53.860902,
            59.965193
          ],
          [
            9.029825,
            53.861046,
            60.063989
          ],
          [
            9.030109,
            53.861143,
            60.133446
          ],
          [
            9.030376,
            53.861236,
            60.199059
          ],
          [
            9.030646,
            53.861331,
            60.265587
          ],
          [
            9.030915,
            53.861425,
            60.331745
          ],
          [
            9.031179,
            53.861524,
            60.397939
          ],
          [
            9.031457,
            53.861624,
            60.466888
          ],
          [
            9.031733,
            53.861713,
            60.533453
          ],
          [
            9.032003,
            53.861811,
            60.480024
          ],
          [
            9.032295,
            53.861908,
            60.376621
          ],
          [
            9.032567,
            53.862009,
            60.277418
          ],
          [
            9.032847,
            53.862104,
            60.177766
          ],
          [
            9.033131,
            53.862198,
            60.077297
          ],
          [
            9.033415,
            53.862296,
            59.975798
          ],
          [
            9.033683,
            53.862396,
            59.877959
          ],
          [
            9.033944,
            53.862493,
            59.782791
          ],
          [
            9.034333,
            53.86263,
            59.643032
          ],
          [
            9.034598,
            53.862731,
            59.496855
          ],
          [
            9.034876,
            53.862833,
            59.319997
          ],
          [
            9.035143,
            53.862938,
            59.14664
          ],
          [
            9.03553,
            53.863083,
            58.898969
          ],
          [
            9.035802,
            53.863181,
            58.726793
          ],
          [
            9.03619,
            53.863327,
            58.478123
          ],
          [
            9.03658,
            53.863477,
            58.22662
          ],
          [
            9.036842,
            53.863579,
            58.057005
          ],
          [
            9.037121,
            53.863687,
            57.826482
          ],
          [
            9.0375,
            53.863849,
            57.426821
          ],
          [
            9.037894,
            53.864002,
            57.023974
          ],
          [
            9.038146,
            53.864109,
            56.758594
          ],
          [
            9.038533,
            53.864268,
            56.355873
          ],
          [
            9.038795,
            53.864379,
            56.080279
          ],
          [
            9.039168,
            53.86453,
            55.693986
          ],
          [
            9.039537,
            53.864687,
            55.351609
          ],
          [
            9.039909,
            53.864841,
            55.297017
          ],
          [
            9.040162,
            53.86495,
            55.259376
          ],
          [
            9.040544,
            53.865108,
            55.203323
          ],
          [
            9.040917,
            53.865257,
            55.149193
          ],
          [
            9.041284,
            53.865422,
            55.093719
          ],
          [
            9.041789,
            53.865633,
            55.019375
          ],
          [
            9.042263,
            53.865847,
            54.672899
          ],
          [
            9.04252,
            53.865955,
            54.404606
          ],
          [
            9.042775,
            53.866058,
            54.141903
          ],
          [
            9.043038,
            53.866163,
            53.871959
          ],
          [
            9.043417,
            53.866327,
            53.472386
          ],
          [
            9.043792,
            53.866484,
            53.081501
          ],
          [
            9.044158,
            53.866647,
            52.691569
          ],
          [
            9.044519,
            53.866805,
            52.379103
          ],
          [
            9.044879,
            53.866967,
            52.288793
          ],
          [
            9.045133,
            53.86708,
            52.225333
          ],
          [
            9.045376,
            53.86719,
            52.16424
          ],
          [
            9.045881,
            53.867406,
            52.039802
          ],
          [
            9.046146,
            53.867523,
            51.973773
          ],
          [
            9.046514,
            53.867701,
            51.878844
          ],
          [
            9.046766,
            53.867811,
            51.816252
          ],
          [
            9.047021,
            53.867929,
            51.925113
          ],
          [
            9.047255,
            53.868046,
            52.125542
          ],
          [
            9.047496,
            53.868162,
            52.32877
          ],
          [
            9.047741,
            53.868282,
            52.536833
          ],
          [
            9.047995,
            53.868399,
            52.74739
          ],
          [
            9.04836,
            53.868573,
            53.054029
          ],
          [
            9.048618,
            53.868686,
            53.263978
          ],
          [
            9.048882,
            53.868804,
            53.480385
          ],
          [
            9.049254,
            53.868972,
            53.787245
          ],
          [
            9.049617,
            53.869143,
            54.215007
          ],
          [
            9.049879,
            53.869259,
            54.516656
          ],
          [
            9.050353,
            53.869466,
            55.059656
          ],
          [
            9.050705,
            53.869648,
            55.491051
          ],
          [
            9.051053,
            53.86981,
            55.899236
          ],
          [
            9.051401,
            53.869975,
            56.310459
          ],
          [
            9.051738,
            53.870154,
            56.57085
          ],
          [
            9.051984,
            53.870276,
            56.522172
          ],
          [
            9.052221,
            53.8704,
            56.47422
          ],
          [
            9.052593,
            53.870579,
            56.40158
          ],
          [
            9.052842,
            53.870711,
            56.350917
          ],
          [
            9.053075,
            53.870834,
            56.303605
          ],
          [
            9.053437,
            53.871033,
            56.228586
          ],
          [
            9.053782,
            53.871225,
            56.15663
          ],
          [
            9.054201,
            53.871449,
            56.465191
          ],
          [
            9.054454,
            53.871571,
            56.737738
          ],
          [
            9.054701,
            53.871711,
            57.023498
          ],
          [
            9.05502,
            53.871869,
            57.371172
          ],
          [
            9.055434,
            53.872116,
            57.863974
          ],
          [
            9.055774,
            53.872258,
            58.211788
          ],
          [
            9.056062,
            53.872407,
            58.531296
          ],
          [
            9.056465,
            53.872583,
            58.649765
          ],
          [
            9.056769,
            53.872727,
            58.619472
          ],
          [
            9.057026,
            53.872847,
            58.59401
          ],
          [
            9.057301,
            53.872993,
            58.565222
          ],
          [
            9.057742,
            53.873214,
            58.520302
          ],
          [
            9.058113,
            53.873426,
            58.480238
          ],
          [
            9.058599,
            53.873677,
            58.292485
          ],
          [
            9.058836,
            53.873803,
            57.876989
          ],
          [
            9.059082,
            53.873945,
            57.428928
          ],
          [
            9.059422,
            53.874119,
            56.841513
          ],
          [
            9.059859,
            53.874342,
            56.088347
          ],
          [
            9.060299,
            53.874543,
            55.3643
          ],
          [
            9.060637,
            53.874684,
            54.825824
          ],
          [
            9.060889,
            53.874816,
            54.44928
          ],
          [
            9.061208,
            53.874962,
            54.309566
          ],
          [
            9.061562,
            53.875159,
            54.14346
          ],
          [
            9.06192,
            53.875378,
            53.966666
          ],
          [
            9.062377,
            53.875587,
            53.76919
          ],
          [
            9.06265,
            53.875682,
            53.660589
          ],
          [
            9.063122,
            53.87593,
            53.444757
          ],
          [
            9.063571,
            53.876128,
            52.695254
          ],
          [
            9.063997,
            53.876324,
            51.927914
          ],
          [
            9.064387,
            53.876485,
            51.252565
          ],
          [
            9.064747,
            53.87665,
            50.605749
          ],
          [
            9.0651,
            53.876819,
            49.960674
          ],
          [
            9.065565,
            53.877022,
            49.139795
          ],
          [
            9.066022,
            53.877235,
            49.123345
          ],
          [
            9.06647,
            53.877441,
            49.144022
          ],
          [
            9.066903,
            53.87765,
            49.164388
          ],
          [
            9.067347,
            53.877851,
            49.184771
          ],
          [
            9.067806,
            53.878043,
            49.205263
          ],
          [
            9.068143,
            53.878201,
            49.156887
          ],
          [
            9.068583,
            53.87841,
            48.984869
          ],
          [
            9.069037,
            53.878621,
            48.808891
          ],
          [
            9.069513,
            53.878798,
            48.63742
          ],
          [
            9.069967,
            53.878994,
            48.466077
          ],
          [
            9.070403,
            53.879181,
            48.301673
          ],
          [
            9.070848,
            53.879365,
            48.557618
          ],
          [
            9.071337,
            53.879561,
            48.886123
          ],
          [
            9.071742,
            53.879747,
            49.172628
          ],
          [
            9.072152,
            53.879923,
            49.454408
          ],
          [
            9.072549,
            53.88009,
            49.725347
          ],
          [
            9.072972,
            53.880264,
            50.049708
          ],
          [
            9.073402,
            53.880446,
            50.679745
          ],
          [
            9.073828,
            53.880621,
            51.298081
          ],
          [
            9.074251,
            53.880791,
            51.907473
          ],
          [
            9.074669,
            53.880971,
            52.523574
          ],
          [
            9.075053,
            53.881134,
            53.086767
          ],
          [
            9.075428,
            53.881285,
            53.615103
          ],
          [
            9.075826,
            53.881446,
            53.736712
          ],
          [
            9.076253,
            53.88161,
            53.864989
          ],
          [
            9.076646,
            53.881783,
            53.988444
          ],
          [
            9.077052,
            53.881943,
            54.111366
          ],
          [
            9.077467,
            53.882101,
            54.235711
          ],
          [
            9.077845,
            53.882263,
            54.35334
          ],
          [
            9.078244,
            53.882418,
            54.027798
          ],
          [
            9.078629,
            53.882561,
            53.599104
          ],
          [
            9.079012,
            53.882708,
            53.168611
          ],
          [
            9.079365,
            53.882846,
            52.769477
          ],
          [
            9.079708,
            53.882984,
            52.378327
          ],
          [
            9.080064,
            53.883107,
            51.988234
          ],
          [
            9.080346,
            53.883248,
            51.639961
          ],
          [
            9.080612,
            53.883383,
            51.228233
          ],
          [
            9.08092,
            53.883518,
            50.718042
          ],
          [
            9.081215,
            53.883625,
            50.257429
          ],
          [
            9.081515,
            53.883749,
            49.770367
          ],
          [
            9.081877,
            53.883921,
            49.145029
          ],
          [
            9.082164,
            53.883987,
            48.73317
          ],
          [
            9.082494,
            53.884094,
            48.231404
          ],
          [
            9.082744,
            53.884223,
            47.789097
          ],
          [
            9.08302,
            53.884362,
            47.174126
          ],
          [
            9.083348,
            53.884489,
            46.172098
          ],
          [
            9.083675,
            53.884643,
            45.102994
          ],
          [
            9.083935,
            53.884754,
            44.283029
          ],
          [
            9.084281,
            53.884852,
            43.302343
          ],
          [
            9.084637,
            53.884955,
            42.281669
          ],
          [
            9.084953,
            53.885075,
            41.321846
          ],
          [
            9.085271,
            53.885198,
            40.350698
          ],
          [
            9.085538,
            53.885325,
            39.514111
          ],
          [
            9.085815,
            53.88543,
            38.853709
          ],
          [
            9.086055,
            53.88555,
            38.223168
          ],
          [
            9.086343,
            53.885686,
            37.483832
          ],
          [
            9.08662,
            53.885827,
            36.750646
          ],
          [
            9.086866,
            53.885979,
            36.035405
          ],
          [
            9.087106,
            53.886125,
            35.344432
          ],
          [
            9.087357,
            53.886241,
            34.699227
          ],
          [
            9.087667,
            53.886346,
            33.979915
          ],
          [
            9.087964,
            53.886421,
            33.42455
          ],
          [
            9.088223,
            53.886536,
            33.055623
          ],
          [
            9.088506,
            53.886634,
            32.681761
          ],
          [
            9.088773,
            53.886734,
            32.322144
          ],
          [
            9.08905,
            53.886824,
            31.962612
          ],
          [
            9.089316,
            53.886932,
            31.595175
          ],
          [
            9.089636,
            53.887033,
            31.182063
          ],
          [
            9.089924,
            53.887142,
            30.791805
          ],
          [
            9.090241,
            53.887219,
            30.401711
          ],
          [
            9.090505,
            53.887351,
            30.453904
          ],
          [
            9.090812,
            53.887391,
            32.435426
          ],
          [
            9.091083,
            53.887449,
            34.443341
          ],
          [
            9.091465,
            53.887409,
            37.007772
          ],
          [
            9.091787,
            53.887386,
            39.037156
          ],
          [
            9.092131,
            53.887396,
            41.193858
          ],
          [
            9.092461,
            53.887408,
            43.258243
          ],
          [
            9.092752,
            53.88747,
            45.219483
          ],
          [
            9.092948,
            53.887621,
            47.236161
          ],
          [
            9.093094,
            53.887787,
            49.113878
          ],
          [
            9.093125,
            53.887973,
            48.872352
          ],
          [
            9.093162,
            53.888163,
            48.624959
          ],
          [
            9.093176,
            53.888349,
            48.384644
          ],
          [
            9.09319,
            53.888534,
            48.143712
          ],
          [
            9.093195,
            53.888719,
            47.904859
          ],
          [
            9.093288,
            53.888903,
            47.656234
          ],
          [
            9.093321,
            53.889003,
            47.41457
          ],
          [
            9.093319,
            53.889001,
            47.17596
          ],
          [
            9.093596,
            53.888862,
            46.88624
          ],
          [
            9.09381,
            53.888891,
            46.421551
          ],
          [
            9.094197,
            53.888892,
            45.814987
          ],
          [
            9.094553,
            53.888894,
            45.256762
          ],
          [
            9.094897,
            53.888901,
            44.716994
          ],
          [
            9.095256,
            53.888908,
            44.1535
          ],
          [
            9.095583,
            53.888912,
            43.640637
          ],
          [
            9.09595,
            53.888902,
            43.064618
          ],
          [
            9.096327,
            53.888903,
            42.47157
          ],
          [
            9.096692,
            53.888914,
            42.009544
          ],
          [
            9.097036,
            53.888925,
            41.942273
          ],
          [
            9.097411,
            53.888935,
            41.868969
          ],
          [
            9.097786,
            53.888944,
            41.795683
          ],
          [
            9.098142,
            53.888941,
            41.726064
          ],
          [
            9.098485,
            53.888941,
            41.659085
          ],
          [
            9.098815,
            53.888953,
            41.594509
          ],
          [
            9.099176,
            53.88897,
            41.523706
          ],
          [
            9.099522,
            53.888972,
            41.456111
          ],
          [
            9.099887,
            53.888968,
            41.279343
          ],
          [
            9.100246,
            53.888976,
            41.043268
          ],
          [
            9.100611,
            53.888989,
            40.803177
          ],
          [
            9.100952,
            53.889009,
            40.578174
          ],
          [
            9.101313,
            53.889007,
            40.3411
          ],
          [
            9.101668,
            53.888999,
            40.107644
          ],
          [
            9.102029,
            53.888972,
            39.868624
          ],
          [
            9.102387,
            53.888946,
            39.631811
          ],
          [
            9.102758,
            53.888898,
            39.417951
          ],
          [
            9.103098,
            53.88887,
            39.376169
          ],
          [
            9.103452,
            53.888836,
            39.332517
          ],
          [
            9.103804,
            53.888808,
            39.289077
          ],
          [
            9.104154,
            53.888778,
            39.245981
          ],
          [
            9.104494,
            53.888745,
            39.204034
          ],
          [
            9.104847,
            53.888719,
            39.160734
          ],
          [
            9.105207,
            53.888684,
            39.116327
          ],
          [
            9.105543,
            53.888654,
            39.074966
          ],
          [
            9.10587,
            53.888625,
            39.147611
          ],
          [
            9.106236,
            53.888596,
            39.357494
          ],
          [
            9.106603,
            53.888567,
            39.567957
          ],
          [
            9.106964,
            53.888565,
            39.77315
          ],
          [
            9.107311,
            53.888608,
            39.974827
          ],
          [
            9.107669,
            53.88869,
            40.193246
          ],
          [
            9.107938,
            53.888776,
            40.367193
          ],
          [
            9.108241,
            53.88892,
            40.588853
          ],
          [
            9.108478,
            53.889088,
            40.795787
          ],
          [
            9.108685,
            53.889235,
            40.9137
          ],
          [
            9.108916,
            53.889355,
            41.025451
          ],
          [
            9.109231,
            53.889487,
            41.165864
          ],
          [
            9.109517,
            53.889569,
            41.281329
          ],
          [
            9.109807,
            53.889642,
            41.395756
          ],
          [
            9.110169,
            53.889705,
            41.532717
          ],
          [
            9.110533,
            53.889746,
            41.668156
          ],
          [
            9.110905,
            53.88976,
            41.803413
          ],
          [
            9.111287,
            53.889767,
            42.037033
          ],
          [
            9.111649,
            53.889757,
            42.441443
          ],
          [
            9.112006,
            53.889725,
            42.844306
          ],
          [
            9.112379,
            53.889711,
            43.261085
          ],
          [
            9.112736,
            53.889689,
            43.661432
          ],
          [
            9.113077,
            53.889676,
            44.04298
          ],
          [
            9.113426,
            53.889653,
            44.43496
          ],
          [
            9.113764,
            53.88962,
            44.817166
          ],
          [
            9.114087,
            53.889574,
            45.187754
          ],
          [
            9.114405,
            53.889523,
            45.271886
          ],
          [
            9.114711,
            53.889465,
            45.23358
          ],
          [
            9.115021,
            53.889391,
            45.193728
          ],
          [
            9.115322,
            53.889309,
            45.154218
          ],
          [
            9.11562,
            53.88922,
            45.114411
          ],
          [
            9.11591,
            53.88913,
            45.075196
          ],
          [
            9.116206,
            53.889034,
            45.034934
          ],
          [
            9.116504,
            53.888939,
            44.994566
          ],
          [
            9.116821,
            53.888848,
            44.952552
          ],
          [
            9.117134,
            53.888756,
            44.654328
          ],
          [
            9.117459,
            53.888705,
            44.209794
          ],
          [
            9.117774,
            53.888722,
            43.78138
          ],
          [
            9.1181,
            53.888685,
            43.3399
          ],
          [
            9.11844,
            53.888733,
            42.876092
          ],
          [
            9.118749,
            53.888812,
            42.429949
          ],
          [
            9.11903,
            53.88893,
            41.973522
          ],
          [
            9.119283,
            53.88907,
            41.514661
          ],
          [
            9.11952,
            53.889192,
            41.096497
          ],
          [
            9.119779,
            53.889309,
            40.950785
          ],
          [
            9.120094,
            53.889371,
            41.03663
          ],
          [
            9.120409,
            53.889404,
            41.119203
          ],
          [
            9.120715,
            53.889421,
            41.198555
          ],
          [
            9.121063,
            53.889469,
            41.290836
          ],
          [
            9.121374,
            53.889491,
            41.371661
          ],
          [
            9.121685,
            53.889519,
            41.452884
          ],
          [
            9.122026,
            53.889561,
            41.542807
          ],
          [
            9.122406,
            53.889588,
            41.641753
          ],
          [
            9.122652,
            53.889726,
            41.716271
          ],
          [
            9.122793,
            53.889923,
            41.772728
          ],
          [
            9.122934,
            53.890118,
            41.828725
          ],
          [
            9.123081,
            53.890291,
            41.879837
          ],
          [
            9.123195,
            53.890483,
            41.933543
          ],
          [
            9.123347,
            53.890654,
            41.984512
          ],
          [
            9.12361,
            53.890802,
            42.042234
          ],
          [
            9.123796,
            53.890972,
            42.098746
          ],
          [
            9.123869,
            53.891168,
            42.151777
          ],
          [
            9.123928,
            53.891361,
            42.248813
          ],
          [
            9.123908,
            53.891546,
            42.359114
          ],
          [
            9.123796,
            53.891712,
            42.466627
          ],
          [
            9.123577,
            53.891844,
            42.58123
          ],
          [
            9.123363,
            53.891991,
            42.695023
          ],
          [
            9.123353,
            53.892168,
            42.804527
          ],
          [
            9.123487,
            53.892357,
            42.924415
          ],
          [
            9.123541,
            53.892554,
            43.041497
          ],
          [
            9.12363,
            53.892778,
            43.176215
          ],
          [
            9.123703,
            53.89297,
            43.448893
          ],
          [
            9.123762,
            53.893178,
            43.840607
          ],
          [
            9.123876,
            53.893363,
            44.209399
          ],
          [
            9.124042,
            53.893542,
            44.58891
          ],
          [
            9.12421,
            53.893746,
            45.011999
          ],
          [
            9.124401,
            53.893944,
            45.435991
          ],
          [
            9.12462,
            53.894097,
            45.807624
          ],
          [
            9.124793,
            53.894258,
            46.163127
          ],
          [
            9.124989,
            53.894417,
            46.528577
          ],
          [
            9.125156,
            53.894588,
            46.839302
          ],
          [
            9.125349,
            53.894728,
            47.121519
          ],
          [
            9.125511,
            53.894902,
            47.449029
          ],
          [
            9.125822,
            53.895002,
            47.773358
          ],
          [
            9.126167,
            53.89514,
            48.153979
          ],
          [
            9.126392,
            53.895265,
            48.437817
          ],
          [
            9.126647,
            53.895399,
            48.74977
          ],
          [
            9.126869,
            53.895533,
            49.039949
          ],
          [
            9.127182,
            53.895493,
            49.344209
          ],
          [
            9.127443,
            53.895376,
            49.324848
          ],
          [
            9.127725,
            53.895271,
            49.304839
          ],
          [
            9.128023,
            53.89515,
            49.283129
          ],
          [
            9.128336,
            53.895012,
            49.259664
          ],
          [
            9.128609,
            53.894875,
            49.238159
          ],
          [
            9.128859,
            53.894771,
            49.219791
          ],
          [
            9.129119,
            53.894641,
            49.199304
          ],
          [
            9.12919,
            53.894448,
            49.17689
          ],
          [
            9.129032,
            53.894273,
            49.07266
          ],
          [
            9.129107,
            53.894225,
            48.627902
          ],
          [
            9.129011,
            53.894278,
            48.174704
          ],
          [
            9.129212,
            53.894439,
            47.804056
          ],
          [
            9.129485,
            53.894499,
            47.423419
          ],
          [
            9.129784,
            53.89441,
            47.059241
          ],
          [
            9.130105,
            53.894289,
            46.644622
          ],
          [
            9.130439,
            53.894167,
            46.217617
          ],
          [
            9.130728,
            53.894035,
            45.833395
          ],
          [
            9.130957,
            53.893986,
            45.674398
          ],
          [
            9.131223,
            53.893852,
            45.497577
          ],
          [
            9.131529,
            53.893704,
            45.297855
          ],
          [
            9.131796,
            53.893609,
            45.140496
          ],
          [
            9.132098,
            53.893611,
            44.974139
          ],
          [
            9.132303,
            53.893783,
            44.793799
          ],
          [
            9.132456,
            53.893965,
            44.615221
          ],
          [
            9.13264,
            53.894112,
            44.458803
          ],
          [
            9.132867,
            53.894247,
            44.286102
          ],
          [
            9.133218,
            53.894336,
            43.880872
          ],
          [
            9.133426,
            53.894477,
            43.551202
          ],
          [
            9.133671,
            53.894649,
            43.15465
          ],
          [
            9.133909,
            53.894827,
            42.752235
          ],
          [
            9.134156,
            53.894971,
            42.390984
          ],
          [
            9.1344,
            53.895133,
            42.008818
          ],
          [
            9.134658,
            53.895294,
            41.618154
          ],
          [
            9.13493,
            53.895488,
            41.174128
          ],
          [
            9.135176,
            53.895663,
            41.316961
          ],
          [
            9.135414,
            53.895824,
            41.511396
          ],
          [
            9.135657,
            53.895969,
            41.697074
          ],
          [
            9.135913,
            53.896143,
            41.907014
          ],
          [
            9.136188,
            53.89627,
            42.098623
          ],
          [
            9.136443,
            53.896123,
            42.290065
          ],
          [
            9.136696,
            53.895998,
            42.468476
          ],
          [
            9.137049,
            53.895926,
            42.668947
          ],
          [
            9.137374,
            53.895898,
            42.782994
          ],
          [
            9.13773,
            53.895877,
            42.817454
          ],
          [
            9.138076,
            53.89584,
            42.851332
          ],
          [
            9.138383,
            53.89581,
            42.881305
          ],
          [
            9.138764,
            53.895776,
            42.918429
          ],
          [
            9.139122,
            53.895741,
            42.953386
          ],
          [
            9.139448,
            53.895707,
            42.98535
          ],
          [
            9.139778,
            53.895685,
            43.017339
          ],
          [
            9.140125,
            53.895622,
            43.052394
          ],
          [
            9.140476,
            53.895583,
            42.900852
          ],
          [
            9.140813,
            53.895529,
            42.667595
          ],
          [
            9.141144,
            53.895449,
            42.428361
          ],
          [
            9.141472,
            53.895379,
            42.195277
          ],
          [
            9.14179,
            53.895313,
            41.970087
          ],
          [
            9.142124,
            53.89523,
            41.727981
          ],
          [
            9.142451,
            53.895154,
            41.493029
          ],
          [
            9.142741,
            53.895074,
            41.279162
          ],
          [
            9.142974,
            53.895122,
            41.060688
          ],
          [
            9.143122,
            53.895347,
            41.004765
          ],
          [
            9.14326,
            53.895524,
            40.98627
          ],
          [
            9.143385,
            53.895714,
            40.966937
          ],
          [
            9.14352,
            53.895917,
            40.946259
          ],
          [
            9.143637,
            53.896112,
            40.926455
          ],
          [
            9.144007,
            53.896098,
            40.905433
          ],
          [
            9.144331,
            53.89605,
            40.886746
          ],
          [
            9.144663,
            53.896007,
            40.867743
          ],
          [
            9.144977,
            53.895954,
            40.874696
          ],
          [
            9.145311,
            53.895914,
            40.959175
          ],
          [
            9.145667,
            53.895876,
            41.048883
          ],
          [
            9.146026,
            53.895859,
            41.138202
          ],
          [
            9.146357,
            53.895894,
            41.224232
          ],
          [
            9.1466,
            53.896024,
            41.306359
          ],
          [
            9.146843,
            53.896173,
            41.393568
          ],
          [
            9.147176,
            53.896368,
            41.51378
          ],
          [
            9.147388,
            53.896515,
            41.596656
          ],
          [
            9.147551,
            53.896719,
            41.55399
          ],
          [
            9.147392,
            53.896903,
            41.494912
          ],
          [
            9.147361,
            53.897115,
            41.432591
          ],
          [
            9.147505,
            53.897279,
            41.378916
          ],
          [
            9.147714,
            53.897424,
            41.32378
          ],
          [
            9.148114,
            53.89739,
            41.255019
          ],
          [
            9.148422,
            53.897348,
            41.20158
          ],
          [
            9.148741,
            53.897255,
            41.141621
          ],
          [
            9.149036,
            53.89715,
            41.135908
          ],
          [
            9.149335,
            53.897054,
            41.306466
          ],
          [
            9.149619,
            53.896969,
            41.466324
          ],
          [
            9.14993,
            53.896908,
            41.630499
          ],
          [
            9.15023,
            53.896822,
            41.797627
          ],
          [
            9.150537,
            53.896736,
            41.967882
          ],
          [
            9.150883,
            53.896687,
            42.14606
          ],
          [
            9.151213,
            53.896657,
            42.31343
          ],
          [
            9.151528,
            53.896645,
            42.471514
          ],
          [
            9.151869,
            53.896618,
            42.650712
          ],
          [
            9.152232,
            53.896608,
            42.897222
          ],
          [
            9.152567,
            53.896641,
            43.127473
          ],
          [
            9.152897,
            53.89664,
            43.351312
          ],
          [
            9.153235,
            53.896668,
            43.58269
          ],
          [
            9.153584,
            53.896699,
            43.821934
          ],
          [
            9.153924,
            53.896727,
            44.054808
          ],
          [
            9.154272,
            53.89676,
            44.293751
          ],
          [
            9.15462,
            53.896767,
            44.530254
          ],
          [
            9.15497,
            53.896759,
            44.585919
          ],
          [
            9.155308,
            53.896756,
            44.246659
          ],
          [
            9.155616,
            53.896767,
            43.938358
          ],
          [
            9.156062,
            53.896736,
            43.489253
          ],
          [
            9.156377,
            53.896689,
            43.162964
          ],
          [
            9.156752,
            53.896613,
            42.766773
          ],
          [
            9.157075,
            53.896554,
            42.428602
          ],
          [
            9.157397,
            53.896491,
            42.089082
          ],
          [
            9.157736,
            53.896433,
            41.736423
          ],
          [
            9.158096,
            53.896371,
            41.822719
          ],
          [
            9.157818,
            53.896384,
            42.032172
          ],
          [
            9.157857,
            53.896411,
            42.263194
          ],
          [
            9.158195,
            53.89636,
            42.486539
          ],
          [
            9.15846,
            53.89622,
            42.709221
          ],
          [
            9.158741,
            53.89614,
            42.90823
          ],
          [
            9.159001,
            53.896033,
            43.106749
          ],
          [
            9.159263,
            53.89591,
            43.316349
          ],
          [
            9.159556,
            53.895772,
            43.551056
          ],
          [
            9.15982,
            53.895644,
            42.833504
          ],
          [
            9.160052,
            53.895504,
            42.116457
          ],
          [
            9.160324,
            53.895379,
            41.376933
          ],
          [
            9.160635,
            53.895248,
            40.555615
          ],
          [
            9.160939,
            53.895192,
            39.866748
          ],
          [
            9.161257,
            53.89524,
            39.143262
          ],
          [
            9.161563,
            53.895334,
            38.403459
          ],
          [
            9.161916,
            53.895379,
            37.626766
          ],
          [
            9.162287,
            53.895413,
            36.97557
          ],
          [
            9.162629,
            53.89546,
            36.833215
          ],
          [
            9.163018,
            53.895499,
            36.673305
          ],
          [
            9.163371,
            53.895557,
            36.524806
          ],
          [
            9.163688,
            53.895583,
            36.395121
          ],
          [
            9.164005,
            53.89563,
            36.262513
          ],
          [
            9.164299,
            53.89568,
            36.138396
          ],
          [
            9.164604,
            53.895721,
            36.011564
          ],
          [
            9.16498,
            53.895761,
            35.856751
          ],
          [
            9.165338,
            53.895791,
            35.67224
          ],
          [
            9.165659,
            53.895847,
            35.456673
          ],
          [
            9.165949,
            53.895934,
            35.244262
          ],
          [
            9.166271,
            53.895997,
            35.02627
          ],
          [
            9.1666,
            53.895965,
            34.811956
          ],
          [
            9.166926,
            53.895936,
            34.599952
          ],
          [
            9.167305,
            53.895956,
            34.355394
          ],
          [
            9.167638,
            53.895963,
            34.141109
          ],
          [
            9.167965,
            53.896001,
            33.926283
          ],
          [
            9.168328,
            53.895997,
            33.789886
          ],
          [
            9.168722,
            53.89602,
            33.739307
          ],
          [
            9.169036,
            53.896016,
            33.699168
          ],
          [
            9.169399,
            53.896052,
            33.652147
          ],
          [
            9.169753,
            53.896044,
            33.60687
          ],
          [
            9.170095,
            53.896079,
            33.562467
          ],
          [
            9.170415,
            53.896117,
            33.520763
          ],
          [
            9.170694,
            53.896192,
            33.481508
          ],
          [
            9.171024,
            53.896164,
            33.438773
          ],
          [
            9.171371,
            53.896124,
            33.75461
          ],
          [
            9.171737,
            53.896142,
            34.261537
          ],
          [
            9.172077,
            53.896159,
            34.732619
          ],
          [
            9.172438,
            53.896186,
            35.235155
          ],
          [
            9.172802,
            53.896212,
            35.741237
          ],
          [
            9.173156,
            53.896225,
            36.230708
          ],
          [
            9.173522,
            53.896272,
            36.751664
          ],
          [
            9.173852,
            53.896351,
            37.262144
          ],
          [
            9.174211,
            53.89637,
            37.625839
          ],
          [
            9.174569,
            53.89639,
            37.584119
          ],
          [
            9.17496,
            53.89641,
            37.5386
          ],
          [
            9.175276,
            53.89642,
            37.501893
          ],
          [
            9.175637,
            53.896447,
            37.459527
          ],
          [
            9.175976,
            53.896483,
            37.419551
          ],
          [
            9.176328,
            53.896495,
            37.378615
          ],
          [
            9.176678,
            53.896513,
            37.337811
          ],
          [
            9.176998,
            53.896513,
            37.300682
          ],
          [
            9.177364,
            53.896492,
            37.459369
          ],
          [
            9.177717,
            53.896528,
            37.764257
          ],
          [
            9.178043,
            53.896554,
            38.043258
          ],
          [
            9.178381,
            53.896571,
            38.331419
          ],
          [
            9.178741,
            53.896569,
            38.640132
          ],
          [
            9.178911,
            53.896399,
            38.924559
          ],
          [
            9.179254,
            53.896431,
            39.219026
          ],
          [
            9.17961,
            53.896441,
            39.521173
          ],
          [
            9.179963,
            53.896443,
            39.820461
          ],
          [
            9.180351,
            53.896467,
            39.851818
          ],
          [
            9.180702,
            53.896491,
            39.832407
          ],
          [
            9.181057,
            53.896506,
            39.812897
          ],
          [
            9.181403,
            53.896513,
            39.793898
          ],
          [
            9.181768,
            53.896529,
            39.773834
          ],
          [
            9.18211,
            53.896574,
            39.754622
          ],
          [
            9.182472,
            53.896638,
            39.733865
          ],
          [
            9.182838,
            53.896701,
            39.712913
          ],
          [
            9.183193,
            53.896761,
            39.681167
          ],
          [
            9.183555,
            53.896814,
            39.637217
          ],
          [
            9.183888,
            53.896869,
            39.596462
          ],
          [
            9.184215,
            53.896931,
            39.555879
          ],
          [
            9.184565,
            53.896997,
            39.512413
          ],
          [
            9.184843,
            53.897079,
            39.475786
          ],
          [
            9.185156,
            53.897172,
            39.434472
          ],
          [
            9.18548,
            53.897247,
            39.393463
          ],
          [
            9.185764,
            53.897334,
            39.355627
          ],
          [
            9.186082,
            53.897405,
            39.36785
          ],
          [
            9.186437,
            53.897492,
            39.408645
          ],
          [
            9.1868,
            53.897576,
            39.450047
          ],
          [
            9.187144,
            53.897658,
            39.489482
          ],
          [
            9.187487,
            53.897741,
            39.528838
          ],
          [
            9.187811,
            53.897825,
            39.566419
          ],
          [
            9.188152,
            53.897892,
            39.604559
          ],
          [
            9.188485,
            53.897972,
            39.642731
          ],
          [
            9.188836,
            53.898053,
            39.626927
          ],
          [
            9.18919,
            53.898115,
            39.527765
          ],
          [
            9.189543,
            53.898176,
            39.428877
          ],
          [
            9.189902,
            53.898246,
            39.326957
          ],
          [
            9.190228,
            53.898345,
            39.228165
          ],
          [
            9.190577,
            53.898377,
            39.13332
          ],
          [
            9.190888,
            53.898412,
            39.0483
          ],
          [
            9.191262,
            53.898451,
            38.946167
          ],
          [
            9.191621,
            53.898481,
            38.84878
          ],
          [
            9.191939,
            53.898504,
            39.00351
          ],
          [
            9.192297,
            53.898525,
            39.181848
          ],
          [
            9.192649,
            53.898508,
            39.35728
          ],
          [
            9.19299,
            53.898509,
            39.527186
          ],
          [
            9.193354,
            53.898503,
            39.707645
          ],
          [
            9.193664,
            53.898484,
            39.8622
          ],
          [
            9.194,
            53.898453,
            40.030736
          ],
          [
            9.194355,
            53.898457,
            40.207088
          ],
          [
            9.194711,
            53.898442,
            40.362508
          ],
          [
            9.195058,
            53.898406,
            40.380188
          ],
          [
            9.195367,
            53.898384,
            40.395805
          ],
          [
            9.195715,
            53.898363,
            40.413372
          ],
          [
            9.1961,
            53.898358,
            40.432718
          ],
          [
            9.196466,
            53.898338,
            40.45116
          ],
          [
            9.196782,
            53.898326,
            40.467062
          ],
          [
            9.19717,
            53.8983,
            40.48673
          ],
          [
            9.197527,
            53.898284,
            40.504695
          ],
          [
            9.197862,
            53.898272,
            40.76193
          ],
          [
            9.198214,
            53.898256,
            41.292477
          ],
          [
            9.198569,
            53.898229,
            41.830619
          ],
          [
            9.198923,
            53.898205,
            42.367342
          ],
          [
            9.199255,
            53.898203,
            42.868295
          ],
          [
            9.199636,
            53.89821,
            43.445151
          ],
          [
            9.199963,
            53.89819,
            43.939148
          ],
          [
            9.200319,
            53.898157,
            44.481223
          ],
          [
            9.200625,
            53.89813,
            44.946116
          ],
          [
            9.200964,
            53.898119,
            45.086694
          ],
          [
            9.201327,
            53.898105,
            45.066749
          ],
          [
            9.201675,
            53.898112,
            45.047728
          ],
          [
            9.202018,
            53.898089,
            45.02887
          ],
          [
            9.202397,
            53.898057,
            45.007974
          ],
          [
            9.20277,
            53.898056,
            44.987616
          ],
          [
            9.203108,
            53.898037,
            44.969078
          ],
          [
            9.203496,
            53.898025,
            44.947546
          ],
          [
            9.203849,
            53.89799,
            44.883738
          ],
          [
            9.204198,
            53.89797,
            44.696613
          ],
          [
            9.204541,
            53.897968,
            44.513119
          ],
          [
            9.205055,
            53.897946,
            44.238099
          ],
          [
            9.205405,
            53.897917,
            44.049452
          ],
          [
            9.205758,
            53.897949,
            43.857113
          ],
          [
            9.206144,
            53.897889,
            43.643542
          ],
          [
            9.206463,
            53.897849,
            43.46949
          ],
          [
            9.206842,
            53.897813,
            43.336387
          ],
          [
            9.207228,
            53.89777,
            43.508132
          ],
          [
            9.207553,
            53.897768,
            43.650238
          ],
          [
            9.20792,
            53.897765,
            43.810788
          ],
          [
            9.208299,
            53.897744,
            43.977173
          ],
          [
            9.208726,
            53.897753,
            44.163912
          ],
          [
            9.209166,
            53.897748,
            44.356249
          ],
          [
            9.209473,
            53.897726,
            44.491537
          ],
          [
            9.209838,
            53.897674,
            44.640028
          ],
          [
            9.210212,
            53.89763,
            44.658191
          ],
          [
            9.21067,
            53.897603,
            44.680097
          ],
          [
            9.210972,
            53.897555,
            44.694996
          ],
          [
            9.211314,
            53.89755,
            44.711342
          ],
          [
            9.211681,
            53.897543,
            44.72886
          ],
          [
            9.211996,
            53.897498,
            44.744411
          ],
          [
            9.212324,
            53.897468,
            44.760222
          ],
          [
            9.212704,
            53.897453,
            44.778342
          ],
          [
            9.213032,
            53.897421,
            44.642308
          ],
          [
            9.21334,
            53.897377,
            44.447021
          ],
          [
            9.213692,
            53.897299,
            44.214416
          ],
          [
            9.213961,
            53.897194,
            44.013973
          ],
          [
            9.21433,
            53.897263,
            43.775263
          ],
          [
            9.214681,
            53.897234,
            43.556802
          ],
          [
            9.215033,
            53.897203,
            43.337765
          ],
          [
            9.215382,
            53.897188,
            43.12127
          ],
          [
            9.215714,
            53.897161,
            42.915155
          ],
          [
            9.216058,
            53.897147,
            43.013198
          ],
          [
            9.216388,
            53.897147,
            43.119338
          ],
          [
            9.216751,
            53.897147,
            43.23635
          ],
          [
            9.217102,
            53.897143,
            43.3493
          ],
          [
            9.217448,
            53.897194,
            43.463868
          ],
          [
            9.217793,
            53.897261,
            43.580581
          ],
          [
            9.218134,
            53.89733,
            43.696767
          ],
          [
            9.218359,
            53.897488,
            43.810592
          ],
          [
            9.218632,
            53.897612,
            43.828325
          ],
          [
            9.218917,
            53.897717,
            43.642257
          ],
          [
            9.219233,
            53.897823,
            43.440335
          ],
          [
            9.219532,
            53.897919,
            43.2519
          ],
          [
            9.219838,
            53.898035,
            43.050542
          ],
          [
            9.220143,
            53.898129,
            42.860169
          ],
          [
            9.220435,
            53.898232,
            42.671918
          ],
          [
            9.220729,
            53.898344,
            42.478099
          ],
          [
            9.221014,
            53.898453,
            42.28961
          ],
          [
            9.221326,
            53.898568,
            42.065996
          ],
          [
            9.221649,
            53.89868,
            41.822014
          ],
          [
            9.221973,
            53.898803,
            41.57108
          ],
          [
            9.222257,
            53.898906,
            41.35401
          ],
          [
            9.222566,
            53.899016,
            41.119011
          ],
          [
            9.22285,
            53.899127,
            40.897097
          ],
          [
            9.223174,
            53.899245,
            40.649144
          ],
          [
            9.223521,
            53.899362,
            40.388902
          ],
          [
            9.223858,
            53.899482,
            40.187446
          ],
          [
            9.224172,
            53.8996,
            40.112483
          ],
          [
            9.224454,
            53.899692,
            40.047557
          ],
          [
            9.22476,
            53.899786,
            39.978046
          ],
          [
            9.225073,
            53.899863,
            39.909424
          ],
          [
            9.225349,
            53.899979,
            39.841155
          ],
          [
            9.225647,
            53.900072,
            39.773029
          ],
          [
            9.225972,
            53.900129,
            39.704833
          ],
          [
            9.226331,
            53.900168,
            39.631401
          ],
          [
            9.226699,
            53.900188,
            39.678849
          ],
          [
            9.22704,
            53.900175,
            39.814745
          ],
          [
            9.227378,
            53.900125,
            39.953042
          ],
          [
            9.227759,
            53.900087,
            40.106615
          ],
          [
            9.22808,
            53.900005,
            40.245483
          ],
          [
            9.228382,
            53.899923,
            40.377593
          ],
          [
            9.228404,
            53.899731,
            40.512757
          ],
          [
            9.228371,
            53.899532,
            40.650523
          ],
          [
            9.228658,
            53.899394,
            40.799228
          ],
          [
            9.228668,
            53.899403,
            40.638822
          ],
          [
            9.228391,
            53.899529,
            40.427301
          ],
          [
            9.228428,
            53.899728,
            40.21115
          ],
          [
            9.228705,
            53.89983,
            40.00337
          ],
          [
            9.229063,
            53.899749,
            39.77086
          ],
          [
            9.229442,
            53.899623,
            39.508003
          ],
          [
            9.229773,
            53.899524,
            39.283793
          ],
          [
            9.230113,
            53.899429,
            39.055805
          ],
          [
            9.23047,
            53.899364,
            38.999936
          ],
          [
            9.230822,
            53.899313,
            39.054471
          ],
          [
            9.231135,
            53.899227,
            39.106328
          ],
          [
            9.231446,
            53.899189,
            39.155394
          ],
          [
            9.231816,
            53.899185,
            39.214308
          ],
          [
            9.232008,
            53.899031,
            39.264727
          ],
          [
            9.232257,
            53.89891,
            39.313597
          ],
          [
            9.232556,
            53.898812,
            39.36493
          ],
          [
            9.232867,
            53.898711,
            39.418236
          ],
          [
            9.233158,
            53.898601,
            39.714631
          ],
          [
            9.233425,
            53.898463,
            40.046928
          ],
          [
            9.233301,
            53.898236,
            40.432694
          ],
          [
            9.233256,
            53.898039,
            40.746987
          ],
          [
            9.233236,
            53.897833,
            41.073479
          ],
          [
            9.233236,
            53.897636,
            41.385039
          ],
          [
            9.233182,
            53.897432,
            41.711968
          ],
          [
            9.233273,
            53.89723,
            42.052284
          ],
          [
            9.2335,
            53.897079,
            42.356806
          ],
          [
            9.2337,
            53.896939,
            42.60143
          ],
          [
            9.233915,
            53.896777,
            42.873892
          ],
          [
            9.234118,
            53.896639,
            43.115877
          ],
          [
            9.234328,
            53.896502,
            43.361223
          ],
          [
            9.234572,
            53.896292,
            43.698683
          ],
          [
            9.23476,
            53.896136,
            43.952253
          ],
          [
            9.234905,
            53.895955,
            44.21742
          ],
          [
            9.235046,
            53.895771,
            44.485587
          ],
          [
            9.235032,
            53.895553,
            44.496613
          ],
          [
            9.235088,
            53.895331,
            44.130341
          ],
          [
            9.235334,
            53.895171,
            43.782776
          ],
          [
            9.235541,
            53.895025,
            43.476234
          ],
          [
            9.235779,
            53.894899,
            43.173119
          ],
          [
            9.236026,
            53.894761,
            42.850619
          ],
          [
            9.236277,
            53.894619,
            42.520963
          ],
          [
            9.236539,
            53.894485,
            42.191965
          ],
          [
            9.236827,
            53.894358,
            41.851131
          ],
          [
            9.237059,
            53.894233,
            41.829564
          ],
          [
            9.23737,
            53.894102,
            41.956375
          ],
          [
            9.237646,
            53.893979,
            42.071154
          ],
          [
            9.237946,
            53.893874,
            42.186945
          ],
          [
            9.238243,
            53.893761,
            42.30426
          ],
          [
            9.238543,
            53.893665,
            42.417603
          ],
          [
            9.238866,
            53.893568,
            42.537844
          ],
          [
            9.23921,
            53.893484,
            42.661362
          ],
          [
            9.23957,
            53.893415,
            42.800965
          ],
          [
            9.239942,
            53.893368,
            43.028737
          ],
          [
            9.240305,
            53.893365,
            43.245951
          ],
          [
            9.240665,
            53.893386,
            43.462419
          ],
          [
            9.240997,
            53.893398,
            43.661541
          ],
          [
            9.241338,
            53.893416,
            43.866458
          ],
          [
            9.241713,
            53.893427,
            44.091109
          ],
          [
            9.242097,
            53.893433,
            44.320952
          ],
          [
            9.242473,
            53.893452,
            44.546759
          ],
          [
            9.242854,
            53.893471,
            44.581895
          ],
          [
            9.243216,
            53.893494,
            44.564191
          ],
          [
            9.243576,
            53.893492,
            44.546678
          ],
          [
            9.243969,
            53.89352,
            44.527425
          ],
          [
            9.244287,
            53.893523,
            44.511942
          ],
          [
            9.244614,
            53.893512,
            44.496016
          ],
          [
            9.244936,
            53.893467,
            44.479924
          ],
          [
            9.245261,
            53.893391,
            44.462898
          ],
          [
            9.245539,
            53.893288,
            44.450793
          ],
          [
            9.245801,
            53.893187,
            44.488202
          ],
          [
            9.246115,
            53.893082,
            44.53137
          ],
          [
            9.246386,
            53.892971,
            44.570833
          ],
          [
            9.246701,
            53.892868,
            44.613877
          ],
          [
            9.246977,
            53.892774,
            44.651967
          ],
          [
            9.247252,
            53.89268,
            44.689964
          ],
          [
            9.24752,
            53.892591,
            44.726732
          ],
          [
            9.247813,
            53.892495,
            44.766796
          ],
          [
            9.248141,
            53.892421,
            44.808778
          ],
          [
            9.248452,
            53.892365,
            44.843971
          ],
          [
            9.248747,
            53.892289,
            44.878529
          ],
          [
            9.249053,
            53.892207,
            44.91448
          ],
          [
            9.249359,
            53.892138,
            44.949525
          ],
          [
            9.249677,
            53.8921,
            44.984282
          ],
          [
            9.250003,
            53.892043,
            45.020656
          ],
          [
            9.250293,
            53.891965,
            45.054758
          ],
          [
            9.250648,
            53.891861,
            45.097164
          ],
          [
            9.25091,
            53.891739,
            45.132891
          ],
          [
            9.251132,
            53.891603,
            44.98489
          ],
          [
            9.251359,
            53.891455,
            44.785575
          ],
          [
            9.251587,
            53.891326,
            44.599576
          ],
          [
            9.251807,
            53.891174,
            44.399717
          ],
          [
            9.252031,
            53.891015,
            44.193293
          ],
          [
            9.252215,
            53.890858,
            44.002749
          ],
          [
            9.252436,
            53.890668,
            43.772504
          ],
          [
            9.252611,
            53.89049,
            43.567107
          ],
          [
            9.252797,
            53.890303,
            43.350646
          ],
          [
            9.252947,
            53.890127,
            43.245444
          ],
          [
            9.253062,
            53.889934,
            43.13974
          ],
          [
            9.253165,
            53.889744,
            43.03676
          ],
          [
            9.253245,
            53.889546,
            42.931664
          ],
          [
            9.253316,
            53.889349,
            42.827679
          ],
          [
            9.253359,
            53.889146,
            42.721925
          ],
          [
            9.253383,
            53.888938,
            42.614245
          ],
          [
            9.253424,
            53.888637,
            42.458184
          ],
          [
            9.253443,
            53.888443,
            42.453134
          ],
          [
            9.253473,
            53.888238,
            42.524184
          ],
          [
            9.253514,
            53.888033,
            42.595503
          ],
          [
            9.253544,
            53.887823,
            42.668247
          ],
          [
            9.253582,
            53.887605,
            42.743914
          ],
          [
            9.253646,
            53.887402,
            42.815292
          ],
          [
            9.253723,
            53.887201,
            42.886452
          ],
          [
            9.253806,
            53.886994,
            42.959955
          ],
          [
            9.253869,
            53.886814,
            43.024868
          ],
          [
            9.253976,
            53.886612,
            42.987764
          ],
          [
            9.254083,
            53.886412,
            42.931832
          ],
          [
            9.254166,
            53.886207,
            42.875591
          ],
          [
            9.254257,
            53.886009,
            42.820856
          ],
          [
            9.254357,
            53.885795,
            42.761656
          ],
          [
            9.254438,
            53.885592,
            42.706003
          ],
          [
            9.254521,
            53.885391,
            42.650731
          ],
          [
            9.254632,
            53.885196,
            42.595877
          ],
          [
            9.254746,
            53.884986,
            42.60407
          ],
          [
            9.254843,
            53.884793,
            42.739403
          ],
          [
            9.254976,
            53.884595,
            42.882489
          ],
          [
            9.25509,
            53.884425,
            43.005746
          ],
          [
            9.2552,
            53.884244,
            43.135099
          ],
          [
            9.255357,
            53.884062,
            43.272684
          ],
          [
            9.255468,
            53.883874,
            43.408243
          ],
          [
            9.255571,
            53.883677,
            43.547057
          ],
          [
            9.255706,
            53.883479,
            43.690554
          ],
          [
            9.255849,
            53.883279,
            43.745616
          ],
          [
            9.255936,
            53.883095,
            43.711585
          ],
          [
            9.256042,
            53.882912,
            43.676925
          ],
          [
            9.256167,
            53.882724,
            43.640953
          ],
          [
            9.256295,
            53.882533,
            43.604348
          ],
          [
            9.256435,
            53.882337,
            43.566437
          ],
          [
            9.256605,
            53.882156,
            43.529575
          ],
          [
            9.256789,
            53.881982,
            43.49298
          ],
          [
            9.25698,
            53.881802,
            43.455169
          ],
          [
            9.257169,
            53.881635,
            43.578173
          ],
          [
            9.257391,
            53.881451,
            43.794322
          ],
          [
            9.257614,
            53.881289,
            43.993967
          ],
          [
            9.257833,
            53.881114,
            44.202227
          ],
          [
            9.258054,
            53.880949,
            44.403413
          ],
          [
            9.258324,
            53.880798,
            44.613598
          ],
          [
            9.258597,
            53.880649,
            44.823476
          ],
          [
            9.25889,
            53.880531,
            45.023727
          ],
          [
            9.259157,
            53.880387,
            45.114922
          ],
          [
            9.259402,
            53.880266,
            44.968345
          ],
          [
            9.259643,
            53.880151,
            44.82604
          ],
          [
            9.25995,
            53.880004,
            44.643985
          ],
          [
            9.260215,
            53.879868,
            44.482834
          ],
          [
            9.260433,
            53.879729,
            44.335033
          ],
          [
            9.260689,
            53.879591,
            44.175907
          ],
          [
            9.260945,
            53.879467,
            44.023941
          ],
          [
            9.261175,
            53.879344,
            43.881497
          ],
          [
            9.261436,
            53.8792,
            43.750349
          ],
          [
            9.261689,
            53.879058,
            43.697918
          ],
          [
            9.261927,
            53.878938,
            43.650898
          ],
          [
            9.262177,
            53.8788,
            43.599495
          ],
          [
            9.262404,
            53.878659,
            43.550012
          ],
          [
            9.26265,
            53.87853,
            43.500575
          ],
          [
            9.262877,
            53.878404,
            43.453693
          ],
          [
            9.263162,
            53.878265,
            43.398182
          ],
          [
            9.263413,
            53.878119,
            43.345202
          ],
          [
            9.263696,
            53.877963,
            43.327227
          ],
          [
            9.263961,
            53.877808,
            43.376366
          ],
          [
            9.264213,
            53.877687,
            43.419099
          ],
          [
            9.264457,
            53.877566,
            43.461019
          ],
          [
            9.264709,
            53.877407,
            43.509562
          ],
          [
            9.265007,
            53.877276,
            43.558439
          ],
          [
            9.265279,
            53.877141,
            43.605335
          ],
          [
            9.265556,
            53.877005,
            43.652733
          ],
          [
            9.265872,
            53.876931,
            43.697821
          ],
          [
            9.266181,
            53.876873,
            43.976962
          ],
          [
            9.266555,
            53.876827,
            44.410722
          ],
          [
            9.266899,
            53.876839,
            44.803988
          ],
          [
            9.267262,
            53.876861,
            45.218695
          ],
          [
            9.267574,
            53.87689,
            45.577702
          ],
          [
            9.267929,
            53.876989,
            46.023676
          ],
          [
            9.268285,
            53.877029,
            46.435089
          ],
          [
            9.268625,
            53.877068,
            46.828291
          ],
          [
            9.268965,
            53.877108,
            47.162612
          ],
          [
            9.269316,
            53.877158,
            47.076454
          ],
          [
            9.269634,
            53.877202,
            46.998538
          ],
          [
            9.269985,
            53.877248,
            46.9127
          ],
          [
            9.270329,
            53.877299,
            46.826592
          ],
          [
            9.270691,
            53.877331,
            46.739188
          ],
          [
            9.271061,
            53.877355,
            46.650343
          ],
          [
            9.271424,
            53.877366,
            46.562973
          ],
          [
            9.271769,
            53.877421,
            46.477726
          ],
          [
            9.272137,
            53.877438,
            46.468703
          ],
          [
            9.272518,
            53.877471,
            46.507462
          ],
          [
            9.272899,
            53.877497,
            46.546167
          ],
          [
            9.27326,
            53.877485,
            46.582561
          ],
          [
            9.273622,
            53.877483,
            46.619023
          ],
          [
            9.273952,
            53.877453,
            46.652709
          ],
          [
            9.27433,
            53.877433,
            46.691091
          ],
          [
            9.274664,
            53.877383,
            46.725783
          ],
          [
            9.274994,
            53.87735,
            46.700426
          ],
          [
            9.275346,
            53.877284,
            46.433513
          ],
          [
            9.275677,
            53.877226,
            46.184034
          ],
          [
            9.276002,
            53.877152,
            45.932456
          ],
          [
            9.276321,
            53.877085,
            45.687927
          ],
          [
            9.276642,
            53.877006,
            45.436762
          ],
          [
            9.276934,
            53.876924,
            45.203229
          ],
          [
            9.277224,
            53.876831,
            44.964867
          ],
          [
            9.277519,
            53.876758,
            44.733846
          ],
          [
            9.27782,
            53.876684,
            44.563797
          ],
          [
            9.278216,
            53.876591,
            44.650485
          ],
          [
            9.278539,
            53.876513,
            44.721549
          ],
          [
            9.278856,
            53.876437,
            44.791361
          ],
          [
            9.279178,
            53.876353,
            44.862824
          ],
          [
            9.279505,
            53.876266,
            44.935645
          ],
          [
            9.279826,
            53.876183,
            45.006785
          ],
          [
            9.280159,
            53.876094,
            45.080986
          ],
          [
            9.280492,
            53.876022,
            45.152971
          ],
          [
            9.280783,
            53.875952,
            45.117136
          ],
          [
            9.281103,
            53.875863,
            45.04052
          ],
          [
            9.281433,
            53.875791,
            44.964328
          ],
          [
            9.28174,
            53.875721,
            44.893008
          ],
          [
            9.282038,
            53.875647,
            44.822999
          ],
          [
            9.282341,
            53.875575,
            44.752276
          ],
          [
            9.282669,
            53.875487,
            44.674232
          ],
          [
            9.282969,
            53.875415,
            44.604045
          ],
          [
            9.283276,
            53.875337,
            44.531674
          ],
          [
            9.283592,
            53.875251,
            44.508369
          ],
          [
            9.283895,
            53.875164,
            44.508751
          ],
          [
            9.284192,
            53.875083,
            44.509121
          ],
          [
            9.284524,
            53.875001,
            44.509528
          ],
          [
            9.284825,
            53.874927,
            44.509897
          ],
          [
            9.285169,
            53.874853,
            44.510311
          ],
          [
            9.285458,
            53.874773,
            44.510672
          ],
          [
            9.285743,
            53.874694,
            44.511029
          ],
          [
            9.286071,
            53.874618,
            44.511428
          ],
          [
            9.286411,
            53.874528,
            44.495499
          ],
          [
            9.286701,
            53.874445,
            44.476094
          ],
          [
            9.287029,
            53.874369,
            44.454885
          ],
          [
            9.287316,
            53.874306,
            44.436452
          ],
          [
            9.28764,
            53.874229,
            44.415335
          ],
          [
            9.287964,
            53.874131,
            44.393418
          ],
          [
            9.288265,
            53.874063,
            44.373992
          ],
          [
            9.288565,
            53.87398,
            44.354048
          ],
          [
            9.288854,
            53.873908,
            44.335129
          ],
          [
            9.289191,
            53.873825,
            44.244493
          ],
          [
            9.289538,
            53.873753,
            44.119801
          ],
          [
            9.289888,
            53.873662,
            43.990175
          ],
          [
            9.290175,
            53.873598,
            43.886102
          ],
          [
            9.290476,
            53.87352,
            43.77468
          ],
          [
            9.290795,
            53.873444,
            43.658028
          ],
          [
            9.291081,
            53.873357,
            43.548982
          ],
          [
            9.291388,
            53.873276,
            43.43499
          ],
          [
            9.291685,
            53.873203,
            43.32577
          ],
          [
            9.292035,
            53.873124,
            43.451511
          ],
          [
            9.292384,
            53.87302,
            43.669275
          ],
          [
            9.292674,
            53.872924,
            43.854293
          ],
          [
            9.292954,
            53.872801,
            44.04855
          ],
          [
            9.29325,
            53.872708,
            44.235268
          ],
          [
            9.293534,
            53.872621,
            44.413413
          ],
          [
            9.293808,
            53.872534,
            44.58664
          ],
          [
            9.294086,
            53.87244,
            44.764888
          ],
          [
            9.294376,
            53.872343,
            44.950333
          ],
          [
            9.294688,
            53.87226,
            44.877748
          ],
          [
            9.294975,
            53.872187,
            44.746013
          ],
          [
            9.295303,
            53.872093,
            44.592497
          ],
          [
            9.295608,
            53.871999,
            44.447695
          ],
          [
            9.295927,
            53.871911,
            44.299283
          ],
          [
            9.296265,
            53.871799,
            44.136152
          ],
          [
            9.296588,
            53.871705,
            43.984488
          ],
          [
            9.296902,
            53.871598,
            43.831864
          ],
          [
            9.297189,
            53.871504,
            43.695794
          ],
          [
            9.297506,
            53.871402,
            43.567028
          ],
          [
            9.297813,
            53.871302,
            43.441989
          ],
          [
            9.298096,
            53.871218,
            43.329039
          ],
          [
            9.298382,
            53.871125,
            43.212611
          ],
          [
            9.298695,
            53.871031,
            43.087387
          ],
          [
            9.299018,
            53.870926,
            42.955661
          ],
          [
            9.299332,
            53.870819,
            42.826331
          ],
          [
            9.299646,
            53.870719,
            42.698974
          ],
          [
            9.299956,
            53.870624,
            42.751901
          ],
          [
            9.300297,
            53.870514,
            43.152039
          ],
          [
            9.300581,
            53.870405,
            43.500919
          ],
          [
            9.300878,
            53.8703,
            43.857422
          ],
          [
            9.301183,
            53.8702,
            44.216706
          ],
          [
            9.301513,
            53.870094,
            44.603602
          ],
          [
            9.301837,
            53.869975,
            44.997413
          ],
          [
            9.302181,
            53.869842,
            45.420938
          ],
          [
            9.302518,
            53.869711,
            45.669286
          ],
          [
            9.302829,
            53.869594,
            45.214614
          ],
          [
            9.303146,
            53.869474,
            44.750124
          ],
          [
            9.303412,
            53.86937,
            44.356629
          ],
          [
            9.303708,
            53.869251,
            43.914726
          ],
          [
            9.303967,
            53.869153,
            43.534778
          ],
          [
            9.304251,
            53.869046,
            43.119418
          ],
          [
            9.304543,
            53.86892,
            42.673458
          ],
          [
            9.304816,
            53.868805,
            42.259817
          ],
          [
            9.305078,
            53.868686,
            42.014827
          ],
          [
            9.305376,
            53.868556,
            42.057531
          ],
          [
            9.305661,
            53.868428,
            42.098761
          ],
          [
            9.305932,
            53.868306,
            42.13799
          ],
          [
            9.30621,
            53.868188,
            42.177436
          ],
          [
            9.306491,
            53.868066,
            42.217578
          ],
          [
            9.306797,
            53.867947,
            42.259745
          ],
          [
            9.307094,
            53.867816,
            42.302554
          ],
          [
            9.307357,
            53.867706,
            42.339717
          ],
          [
            9.307663,
            53.867566,
            42.406644
          ],
          [
            9.307924,
            53.867452,
            42.469777
          ],
          [
            9.308235,
            53.86732,
            42.544243
          ],
          [
            9.308484,
            53.867186,
            42.609764
          ],
          [
            9.308783,
            53.867062,
            42.680804
          ],
          [
            9.309068,
            53.866942,
            42.748925
          ],
          [
            9.309362,
            53.866821,
            42.818611
          ],
          [
            9.309647,
            53.866701,
            42.886677
          ],
          [
            9.309917,
            53.866581,
            42.948417
          ],
          [
            9.310177,
            53.866465,
            42.979163
          ],
          [
            9.310448,
            53.866344,
            43.011228
          ],
          [
            9.310706,
            53.86623,
            43.041639
          ],
          [
            9.310997,
            53.866109,
            43.075256
          ],
          [
            9.31126,
            53.866,
            43.105577
          ],
          [
            9.311566,
            53.865866,
            43.141523
          ],
          [
            9.311891,
            53.865754,
            43.177095
          ],
          [
            9.31214,
            53.865602,
            43.211145
          ],
          [
            9.312351,
            53.865443,
            43.150726
          ],
          [
            9.312667,
            53.865344,
            42.908033
          ],
          [
            9.312974,
            53.865223,
            42.658627
          ],
          [
            9.313257,
            53.865094,
            42.417034
          ],
          [
            9.313529,
            53.864968,
            42.18338
          ],
          [
            9.313836,
            53.86486,
            41.94195
          ],
          [
            9.314106,
            53.864743,
            41.715552
          ],
          [
            9.314357,
            53.864618,
            41.493661
          ],
          [
            9.314633,
            53.864517,
            41.274283
          ],
          [
            9.314878,
            53.864393,
            41.21102
          ],
          [
            9.315125,
            53.864266,
            41.284853
          ],
          [
            9.315349,
            53.864138,
            41.355137
          ],
          [
            9.315561,
            53.863999,
            41.426648
          ],
          [
            9.315754,
            53.863854,
            41.497078
          ],
          [
            9.315974,
            53.863722,
            41.567846
          ],
          [
            9.316208,
            53.863583,
            41.642679
          ],
          [
            9.31643,
            53.863437,
            41.718113
          ],
          [
            9.316732,
            53.863317,
            41.80029
          ],
          [
            9.316994,
            53.86318,
            41.86541
          ],
          [
            9.317301,
            53.863056,
            41.890354
          ],
          [
            9.317588,
            53.862938,
            41.913815
          ],
          [
            9.317868,
            53.862818,
            41.937026
          ],
          [
            9.318168,
            53.8627,
            41.961202
          ],
          [
            9.318456,
            53.862571,
            41.985446
          ],
          [
            9.318754,
            53.862456,
            42.00932
          ],
          [
            9.319074,
            53.862322,
            42.035636
          ],
          [
            9.31937,
            53.862205,
            42.059546
          ],
          [
            9.319692,
            53.862064,
            41.839254
          ],
          [
            9.319978,
            53.861957,
            41.611919
          ],
          [
            9.3203,
            53.861858,
            41.368042
          ],
          [
            9.320619,
            53.861763,
            41.128776
          ],
          [
            9.320958,
            53.86168,
            40.882232
          ],
          [
            9.321275,
            53.861606,
            40.653393
          ],
          [
            9.321597,
            53.861563,
            40.432115
          ],
          [
            9.321948,
            53.861504,
            40.187669
          ],
          [
            9.322303,
            53.861428,
            40.030428
          ],
          [
            9.322669,
            53.861355,
            40.055606
          ],
          [
            9.322979,
            53.861287,
            40.077228
          ],
          [
            9.323304,
            53.861245,
            40.098912
          ],
          [
            9.323655,
            53.861184,
            40.122758
          ],
          [
            9.323982,
            53.861126,
            40.14501
          ],
          [
            9.324312,
            53.861075,
            40.167244
          ],
          [
            9.324661,
            53.861022,
            40.190728
          ],
          [
            9.324981,
            53.860967,
            40.212449
          ],
          [
            9.325326,
            53.860909,
            40.340667
          ],
          [
            9.325676,
            53.860842,
            40.530596
          ],
          [
            9.326001,
            53.860784,
            40.706509
          ],
          [
            9.326347,
            53.860734,
            40.890384
          ],
          [
            9.326685,
            53.860674,
            41.072729
          ],
          [
            9.326978,
            53.860621,
            41.230932
          ],
          [
            9.327312,
            53.860554,
            41.413166
          ],
          [
            9.327631,
            53.860498,
            41.584958
          ],
          [
            9.327963,
            53.860443,
            41.763549
          ],
          [
            9.328276,
            53.86038,
            41.66665
          ],
          [
            9.328565,
            53.860294,
            41.512651
          ],
          [
            9.328825,
            53.860191,
            41.363931
          ],
          [
            9.329088,
            53.86005,
            41.195214
          ],
          [
            9.329312,
            53.859881,
            41.022492
          ],
          [
            9.329478,
            53.859719,
            40.870141
          ],
          [
            9.329622,
            53.859551,
            40.718615
          ],
          [
            9.329749,
            53.85937,
            40.560918
          ],
          [
            9.329865,
            53.859184,
            40.401404
          ],
          [
            9.329976,
            53.858991,
            40.447014
          ],
          [
            9.330088,
            53.85881,
            40.588035
          ],
          [
            9.330255,
            53.858632,
            40.737066
          ],
          [
            9.33047,
            53.858487,
            40.878121
          ],
          [
            9.330682,
            53.858352,
            41.01282
          ],
          [
            9.330953,
            53.858191,
            41.178936
          ],
          [
            9.331176,
            53.858058,
            41.315937
          ],
          [
            9.331428,
            53.85789,
            41.480111
          ],
          [
            9.331682,
            53.85774,
            41.635268
          ],
          [
            9.331874,
            53.857597,
            41.616302
          ],
          [
            9.332098,
            53.857438,
            41.548362
          ],
          [
            9.332357,
            53.857273,
            41.474125
          ],
          [
            9.332593,
            53.857097,
            41.400347
          ],
          [
            9.332811,
            53.856949,
            41.335899
          ],
          [
            9.333023,
            53.856792,
            41.269873
          ],
          [
            9.333227,
            53.856643,
            41.206902
          ],
          [
            9.333414,
            53.856494,
            41.145899
          ],
          [
            9.333644,
            53.856338,
            41.077964
          ],
          [
            9.333837,
            53.856158,
            41.137649
          ],
          [
            9.33401,
            53.855975,
            41.207265
          ],
          [
            9.334033,
            53.855966,
            41.271482
          ],
          [
            9.334249,
            53.855809,
            41.338712
          ],
          [
            9.334394,
            53.855627,
            41.405247
          ],
          [
            9.334551,
            53.855458,
            41.469015
          ],
          [
            9.334722,
            53.855279,
            41.537004
          ],
          [
            9.334946,
            53.855112,
            41.607456
          ],
          [
            9.335146,
            53.854965,
            41.669715
          ],
          [
            9.335376,
            53.854822,
            41.725731
          ],
          [
            9.335595,
            53.854657,
            41.785143
          ],
          [
            9.335893,
            53.854527,
            41.847157
          ],
          [
            9.336174,
            53.854381,
            41.909806
          ],
          [
            9.336471,
            53.854267,
            41.96907
          ],
          [
            9.336765,
            53.854161,
            42.026832
          ],
          [
            9.337017,
            53.854059,
            42.078192
          ],
          [
            9.337328,
            53.853946,
            42.139302
          ],
          [
            9.3376,
            53.853822,
            42.048606
          ],
          [
            9.33785,
            53.853708,
            41.696821
          ],
          [
            9.338092,
            53.853569,
            41.319952
          ],
          [
            9.33833,
            53.853427,
            40.943351
          ],
          [
            9.338513,
            53.853268,
            40.580678
          ],
          [
            9.33872,
            53.853085,
            40.165799
          ],
          [
            9.338902,
            53.8529,
            39.761027
          ],
          [
            9.339046,
            53.852717,
            39.38042
          ],
          [
            9.339142,
            53.852526,
            39.004663
          ],
          [
            9.339241,
            53.852329,
            38.864984
          ],
          [
            9.339369,
            53.852121,
            39.061206
          ],
          [
            9.339451,
            53.851933,
            39.233256
          ],
          [
            9.339533,
            53.851749,
            39.401761
          ],
          [
            9.339613,
            53.851555,
            39.578603
          ],
          [
            9.339707,
            53.851378,
            39.742936
          ],
          [
            9.339792,
            53.851187,
            39.917905
          ],
          [
            9.339887,
            53.851007,
            40.084875
          ],
          [
            9.340023,
            53.850823,
            40.262816
          ],
          [
            9.340175,
            53.850606,
            40.537306
          ],
          [
            9.340321,
            53.850397,
            40.881474
          ],
          [
            9.340488,
            53.850215,
            41.196052
          ],
          [
            9.340652,
            53.850051,
            41.48521
          ],
          [
            9.340823,
            53.849895,
            41.767497
          ],
          [
            9.341014,
            53.84974,
            42.058515
          ],
          [
            9.341224,
            53.849539,
            42.417188
          ],
          [
            9.341418,
            53.84937,
            42.72724
          ],
          [
            9.341629,
            53.849196,
            43.052309
          ],
          [
            9.34182,
            53.849023,
            43.01343
          ],
          [
            9.342066,
            53.84885,
            42.884427
          ],
          [
            9.342245,
            53.84867,
            42.765178
          ],
          [
            9.342429,
            53.848507,
            42.653135
          ],
          [
            9.342625,
            53.848339,
            42.535822
          ],
          [
            9.342806,
            53.848167,
            42.420146
          ],
          [
            9.343037,
            53.847973,
            42.284573
          ],
          [
            9.343255,
            53.847792,
            42.157724
          ],
          [
            9.343461,
            53.847623,
            42.070843
          ],
          [
            9.343633,
            53.847458,
            42.04162
          ],
          [
            9.34382,
            53.847271,
            42.008867
          ],
          [
            9.344039,
            53.847079,
            41.97396
          ],
          [
            9.344233,
            53.846915,
            41.943789
          ],
          [
            9.34439,
            53.846754,
            41.915772
          ],
          [
            9.344619,
            53.846569,
            41.881115
          ],
          [
            9.34484,
            53.846439,
            41.853345
          ],
          [
            9.34509,
            53.846307,
            41.823476
          ],
          [
            9.345354,
            53.846178,
            41.823582
          ],
          [
            9.345619,
            53.846051,
            41.84464
          ],
          [
            9.345864,
            53.845894,
            41.866932
          ],
          [
            9.346055,
            53.845735,
            41.887287
          ],
          [
            9.34624,
            53.845561,
            41.908758
          ],
          [
            9.3464,
            53.845383,
            41.929809
          ],
          [
            9.346601,
            53.845201,
            41.952498
          ],
          [
            9.34679,
            53.845032,
            41.973645
          ],
          [
            9.346971,
            53.844868,
            41.994086
          ],
          [
            9.347155,
            53.844699,
            42.029274
          ],
          [
            9.347316,
            53.844531,
            42.067195
          ],
          [
            9.347523,
            53.844345,
            42.11089
          ],
          [
            9.347698,
            53.844182,
            42.14877
          ],
          [
            9.347877,
            53.844019,
            42.186901
          ],
          [
            9.348082,
            53.843846,
            42.228365
          ],
          [
            9.348306,
            53.843655,
            42.273968
          ],
          [
            9.348461,
            53.843476,
            42.313539
          ],
          [
            9.348638,
            53.843289,
            42.360045
          ],
          [
            9.348835,
            53.843108,
            42.455118
          ],
          [
            9.349011,
            53.842922,
            42.549254
          ],
          [
            9.34922,
            53.842745,
            42.644597
          ],
          [
            9.349403,
            53.842572,
            42.734724
          ],
          [
            9.349608,
            53.842421,
            42.820185
          ],
          [
            9.34979,
            53.842257,
            42.906814
          ],
          [
            9.349979,
            53.842083,
            42.998121
          ],
          [
            9.350164,
            53.841906,
            43.090119
          ],
          [
            9.350355,
            53.841738,
            43.185158
          ],
          [
            9.350557,
            53.841564,
            43.294334
          ],
          [
            9.350763,
            53.841399,
            43.400507
          ],
          [
            9.350958,
            53.841223,
            43.509422
          ],
          [
            9.351157,
            53.841048,
            43.618513
          ],
          [
            9.351383,
            53.840874,
            43.731991
          ],
          [
            9.351608,
            53.840744,
            43.828174
          ],
          [
            9.351834,
            53.840619,
            43.9228
          ],
          [
            9.352148,
            53.840485,
            44.041192
          ],
          [
            9.352451,
            53.840378,
            44.093888
          ],
          [
            9.352769,
            53.840285,
            44.118554
          ],
          [
            9.353062,
            53.840215,
            44.140508
          ],
          [
            9.353344,
            53.840145,
            44.161758
          ],
          [
            9.353655,
            53.840054,
            44.185866
          ],
          [
            9.353955,
            53.839995,
            44.207829
          ],
          [
            9.354278,
            53.839924,
            44.231776
          ],
          [
            9.354577,
            53.839832,
            44.255199
          ],
          [
            9.354876,
            53.839733,
            44.279009
          ],
          [
            9.355176,
            53.839652,
            44.033294
          ],
          [
            9.355481,
            53.839571,
            43.56442
          ],
          [
            9.355847,
            53.83948,
            43.007569
          ],
          [
            9.356187,
            53.839365,
            42.457771
          ],
          [
            9.356482,
            53.839286,
            42.003589
          ],
          [
            9.356759,
            53.839207,
            41.572192
          ],
          [
            9.357062,
            53.839121,
            41.100775
          ],
          [
            9.357359,
            53.839035,
            40.636982
          ],
          [
            9.357689,
            53.838943,
            40.124805
          ],
          [
            9.358013,
            53.83887,
            40.155044
          ],
          [
            9.358326,
            53.838796,
            40.329173
          ],
          [
            9.358655,
            53.838699,
            40.51915
          ],
          [
            9.358965,
            53.838609,
            40.697767
          ],
          [
            9.359289,
            53.838507,
            40.887419
          ],
          [
            9.359647,
            53.838409,
            41.091215
          ],
          [
            9.359986,
            53.838298,
            41.291488
          ],
          [
            9.360318,
            53.838206,
            41.480969
          ],
          [
            9.360662,
            53.838095,
            41.594595
          ],
          [
            9.361019,
            53.837991,
            41.6049
          ],
          [
            9.361357,
            53.837895,
            41.614605
          ],
          [
            9.361655,
            53.837803,
            41.623313
          ],
          [
            9.361969,
            53.837706,
            41.632485
          ],
          [
            9.362334,
            53.837606,
            41.642904
          ],
          [
            9.362687,
            53.837522,
            41.652751
          ],
          [
            9.363047,
            53.837424,
            41.663035
          ],
          [
            9.363391,
            53.837328,
            41.762285
          ],
          [
            9.363723,
            53.837234,
            41.978891
          ],
          [
            9.364043,
            53.837176,
            42.17621
          ],
          [
            9.36441,
            53.837112,
            42.401569
          ],
          [
            9.364762,
            53.837043,
            42.619968
          ],
          [
            9.365095,
            53.836977,
            42.826956
          ],
          [
            9.365476,
            53.836903,
            43.062953
          ],
          [
            9.365834,
            53.836833,
            43.284817
          ],
          [
            9.366184,
            53.836754,
            43.470348
          ],
          [
            9.36655,
            53.836668,
            43.516552
          ],
          [
            9.3669,
            53.836578,
            43.561309
          ],
          [
            9.367201,
            53.836502,
            43.599669
          ],
          [
            9.367557,
            53.836415,
            43.644818
          ],
          [
            9.367883,
            53.836327,
            43.686821
          ],
          [
            9.368255,
            53.836228,
            43.734678
          ],
          [
            9.368588,
            53.836139,
            43.77751
          ],
          [
            9.368855,
            53.836041,
            43.814408
          ],
          [
            9.369136,
            53.835919,
            43.842909
          ],
          [
            9.369459,
            53.835791,
            43.87305
          ],
          [
            9.369744,
            53.835692,
            43.898711
          ],
          [
            9.370049,
            53.835594,
            43.925644
          ],
          [
            9.370372,
            53.835464,
            43.956106
          ],
          [
            9.370748,
            53.835328,
            43.990289
          ],
          [
            9.371067,
            53.835205,
            44.019801
          ],
          [
            9.371378,
            53.835088,
            44.048368
          ],
          [
            9.371694,
            53.834971,
            43.837097
          ],
          [
            9.371988,
            53.834833,
            43.554354
          ],
          [
            9.372291,
            53.834738,
            43.29647
          ],
          [
            9.372572,
            53.834626,
            43.041574
          ],
          [
            9.372847,
            53.834492,
            42.77322
          ],
          [
            9.373116,
            53.83437,
            42.518167
          ],
          [
            9.373386,
            53.834221,
            42.240381
          ],
          [
            9.373652,
            53.834096,
            41.984747
          ],
          [
            9.37393,
            53.833966,
            41.790535
          ],
          [
            9.374225,
            53.833828,
            41.949942
          ],
          [
            9.374514,
            53.833716,
            42.096187
          ],
          [
            9.374799,
            53.833596,
            42.244221
          ],
          [
            9.375114,
            53.833463,
            42.407992
          ],
          [
            9.375371,
            53.833329,
            42.553016
          ],
          [
            9.375647,
            53.833197,
            42.703235
          ],
          [
            9.375893,
            53.833065,
            42.84401
          ],
          [
            9.376126,
            53.833236,
            43.00406
          ],
          [
            9.376416,
            53.833322,
            42.966545
          ],
          [
            9.376695,
            53.833489,
            42.773736
          ],
          [
            9.37666,
            53.833692,
            42.626422
          ],
          [
            9.37647,
            53.833845,
            42.487302
          ],
          [
            9.376204,
            53.833962,
            42.35004
          ],
          [
            9.37594,
            53.834082,
            42.21161
          ],
          [
            9.375644,
            53.83422,
            42.055547
          ],
          [
            9.375354,
            53.834349,
            41.905306
          ],
          [
            9.375087,
            53.834472,
            41.813247
          ],
          [
            9.374782,
            53.834607,
            41.935729
          ],
          [
            9.374475,
            53.834754,
            42.062956
          ],
          [
            9.374198,
            53.834871,
            42.172266
          ],
          [
            9.374025,
            53.835025,
            42.280327
          ],
          [
            9.374358,
            53.835062,
            42.401483
          ],
          [
            9.374658,
            53.834983,
            42.506944
          ],
          [
            9.374972,
            53.834891,
            42.619452
          ],
          [
            9.375289,
            53.834827,
            42.727158
          ],
          [
            9.3756,
            53.834771,
            42.902213
          ],
          [
            9.375715,
            53.834845,
            43.132798
          ],
          [
            9.376032,
            53.834715,
            43.401496
          ],
          [
            9.376375,
            53.834671,
            43.644799
          ],
          [
            9.376732,
            53.834592,
            43.908628
          ],
          [
            9.377126,
            53.834531,
            44.19057
          ],
          [
            9.377536,
            53.834441,
            44.492997
          ],
          [
            9.377908,
            53.83437,
            44.763576
          ],
          [
            9.378274,
            53.834314,
            44.835312
          ],
          [
            9.378605,
            53.83423,
            44.764266
          ],
          [
            9.378964,
            53.834136,
            44.686859
          ],
          [
            9.37935,
            53.834052,
            44.604862
          ],
          [
            9.379645,
            53.833975,
            44.541243
          ],
          [
            9.379937,
            53.833882,
            44.475829
          ],
          [
            9.380241,
            53.833797,
            44.409526
          ],
          [
            9.380575,
            53.833769,
            44.341478
          ],
          [
            9.380966,
            53.833828,
            44.289222
          ],
          [
            9.381348,
            53.833886,
            44.354601
          ],
          [
            9.38167,
            53.833758,
            44.420095
          ],
          [
            9.38194,
            53.833624,
            44.478579
          ],
          [
            9.382279,
            53.833502,
            44.545122
          ],
          [
            9.382646,
            53.833478,
            44.606321
          ],
          [
            9.383006,
            53.833499,
            44.666235
          ],
          [
            9.383391,
            53.833524,
            44.730421
          ],
          [
            9.383723,
            53.833534,
            44.750857
          ],
          [
            9.384035,
            53.833507,
            44.367376
          ],
          [
            9.384434,
            53.833456,
            43.870889
          ],
          [
            9.384758,
            53.833358,
            43.427826
          ],
          [
            9.385005,
            53.833247,
            43.051667
          ],
          [
            9.385343,
            53.833099,
            42.541818
          ],
          [
            9.385665,
            53.83298,
            42.081562
          ],
          [
            9.385956,
            53.832863,
            41.655008
          ],
          [
            9.38627,
            53.83274,
            41.198504
          ],
          [
            9.386596,
            53.832629,
            40.982361
          ],
          [
            9.386902,
            53.832497,
            40.840144
          ],
          [
            9.387171,
            53.832342,
            40.6991
          ],
          [
            9.387467,
            53.83215,
            40.533988
          ],
          [
            9.387772,
            53.831998,
            40.384134
          ],
          [
            9.388131,
            53.831867,
            40.225954
          ],
          [
            9.388479,
            53.831769,
            40.081376
          ],
          [
            9.388871,
            53.831669,
            39.965166
          ],
          [
            9.389281,
            53.8316,
            40.06914
          ],
          [
            9.389659,
            53.831593,
            40.161632
          ],
          [
            9.390089,
            53.831605,
            40.266597
          ],
          [
            9.390509,
            53.831612,
            40.369021
          ],
          [
            9.390933,
            53.831636,
            40.472883
          ],
          [
            9.391324,
            53.831722,
            40.574894
          ],
          [
            9.391652,
            53.831805,
            40.662632
          ],
          [
            9.392027,
            53.831801,
            41.036169
          ],
          [
            9.39236,
            53.831772,
            41.484099
          ],
          [
            9.3927,
            53.831743,
            41.941237
          ],
          [
            9.393039,
            53.831673,
            42.41916
          ],
          [
            9.393374,
            53.831602,
            42.893105
          ],
          [
            9.393708,
            53.831593,
            43.338298
          ],
          [
            9.39402,
            53.831558,
            43.7657
          ],
          [
            9.394324,
            53.83141,
            44.290502
          ],
          [
            9.394511,
            53.831254,
            44.72215
          ],
          [
            9.394728,
            53.831037,
            44.888706
          ],
          [
            9.39492,
            53.830866,
            45.009672
          ],
          [
            9.395081,
            53.830699,
            45.122972
          ],
          [
            9.395179,
            53.83049,
            45.251066
          ],
          [
            9.395343,
            53.83032,
            45.367169
          ],
          [
            9.395753,
            53.830368,
            45.519644
          ],
          [
            9.396081,
            53.830494,
            45.656701
          ],
          [
            9.396341,
            53.8306,
            45.766719
          ],
          [
            9.39666,
            53.830737,
            45.648292
          ],
          [
            9.396944,
            53.830668,
            45.427274
          ],
          [
            9.397106,
            53.830489,
            45.230333
          ],
          [
            9.397334,
            53.830341,
            45.03686
          ],
          [
            9.397575,
            53.830182,
            44.830318
          ],
          [
            9.397856,
            53.830042,
            44.620729
          ],
          [
            9.39813,
            53.829898,
            44.411109
          ],
          [
            9.398417,
            53.829745,
            44.190692
          ],
          [
            9.398683,
            53.829591,
            44.061483
          ],
          [
            9.398944,
            53.829444,
            44.041985
          ],
          [
            9.399183,
            53.829278,
            44.022075
          ],
          [
            9.399454,
            53.829131,
            44.002222
          ],
          [
            9.399706,
            53.82898,
            43.982851
          ],
          [
            9.399957,
            53.828825,
            43.963248
          ],
          [
            9.400175,
            53.828678,
            43.945266
          ],
          [
            9.400433,
            53.828513,
            43.924632
          ],
          [
            9.400605,
            53.82831,
            43.972882
          ],
          [
            9.400538,
            53.828124,
            44.584569
          ],
          [
            9.400326,
            53.827959,
            45.191411
          ],
          [
            9.400072,
            53.827841,
            45.752646
          ],
          [
            9.399753,
            53.827913,
            46.363033
          ],
          [
            9.399557,
            53.828074,
            46.9437
          ],
          [
            9.399318,
            53.828212,
            47.521898
          ],
          [
            9.399005,
            53.828235,
            48.073384
          ],
          [
            9.398822,
            53.828085,
            48.645799
          ],
          [
            9.39878,
            53.827922,
            49.178485
          ],
          [
            9.399081,
            53.827798,
            49.376081
          ],
          [
            9.399352,
            53.827612,
            49.595027
          ],
          [
            9.399584,
            53.82744,
            49.791506
          ],
          [
            9.399786,
            53.827288,
            49.96429
          ],
          [
            9.400034,
            53.827116,
            50.166218
          ],
          [
            9.400251,
            53.826955,
            50.349925
          ],
          [
            9.400464,
            53.826814,
            50.518567
          ],
          [
            9.400715,
            53.82664,
            50.722532
          ],
          [
            9.400973,
            53.82648,
            50.964181
          ],
          [
            9.401239,
            53.826287,
            51.256378
          ],
          [
            9.4015,
            53.826089,
            51.551021
          ],
          [
            9.401736,
            53.825921,
            51.80711
          ],
          [
            9.401977,
            53.825748,
            52.07006
          ],
          [
            9.402196,
            53.825575,
            52.323679
          ],
          [
            9.40239,
            53.825433,
            52.53773
          ],
          [
            9.402657,
            53.825235,
            52.834727
          ],
          [
            9.40288,
            53.825063,
            52.08982
          ],
          [
            9.403151,
            53.824865,
            50.898225
          ],
          [
            9.403427,
            53.824659,
            49.668728
          ],
          [
            9.403671,
            53.82448,
            48.593151
          ],
          [
            9.40378,
            53.8243,
            47.698262
          ],
          [
            9.403929,
            53.824123,
            46.773002
          ],
          [
            9.404132,
            53.823912,
            45.636538
          ],
          [
            9.404329,
            53.823726,
            44.608759
          ],
          [
            9.404535,
            53.823549,
            44.24779
          ],
          [
            9.404813,
            53.823357,
            43.946021
          ],
          [
            9.405071,
            53.823174,
            43.661572
          ],
          [
            9.405322,
            53.82301,
            43.397512
          ],
          [
            9.405453,
            53.822825,
            43.13752
          ],
          [
            9.40518,
            53.822709,
            42.899314
          ],
          [
            9.404911,
            53.8226,
            42.669183
          ],
          [
            9.404629,
            53.822486,
            42.427982
          ],
          [
            9.40428,
            53.82235,
            42.335533
          ],
          [
            9.403927,
            53.822229,
            42.36014
          ],
          [
            9.403627,
            53.822113,
            42.381655
          ],
          [
            9.403343,
            53.821986,
            42.403088
          ],
          [
            9.403119,
            53.821858,
            42.421883
          ],
          [
            9.402901,
            53.821725,
            42.440771
          ],
          [
            9.402677,
            53.821526,
            42.465053
          ],
          [
            9.402517,
            53.821362,
            42.48429
          ],
          [
            9.402351,
            53.821191,
            42.485312
          ],
          [
            9.402185,
            53.821027,
            42.30931
          ],
          [
            9.402008,
            53.820872,
            42.137135
          ],
          [
            9.40184,
            53.820708,
            41.960624
          ],
          [
            9.40165,
            53.820531,
            41.767614
          ],
          [
            9.401437,
            53.820343,
            41.559133
          ],
          [
            9.401258,
            53.820184,
            41.382771
          ],
          [
            9.400991,
            53.820054,
            41.194254
          ],
          [
            9.400696,
            53.819941,
            41.002659
          ],
          [
            9.400375,
            53.819799,
            40.824804
          ],
          [
            9.400154,
            53.819665,
            40.765417
          ],
          [
            9.399921,
            53.819493,
            40.695496
          ],
          [
            9.399655,
            53.819287,
            40.613312
          ],
          [
            9.399409,
            53.819102,
            40.538594
          ],
          [
            9.399175,
            53.81896,
            40.475509
          ],
          [
            9.398936,
            53.818798,
            40.407328
          ],
          [
            9.398647,
            53.818619,
            40.328846
          ],
          [
            9.398377,
            53.818428,
            40.40159
          ],
          [
            9.398112,
            53.818233,
            40.795582
          ],
          [
            9.397891,
            53.818066,
            41.129753
          ],
          [
            9.397667,
            53.817906,
            41.456779
          ],
          [
            9.397404,
            53.817762,
            41.790786
          ],
          [
            9.39715,
            53.817579,
            42.163586
          ],
          [
            9.39694,
            53.817419,
            42.482586
          ],
          [
            9.396725,
            53.817252,
            42.813068
          ],
          [
            9.396572,
            53.81704,
            43.147546
          ],
          [
            9.396218,
            53.816937,
            43.372342
          ],
          [
            9.396076,
            53.816787,
            43.565469
          ],
          [
            9.396281,
            53.816568,
            43.789292
          ],
          [
            9.396472,
            53.816412,
            43.961378
          ],
          [
            9.396655,
            53.816218,
            44.159783
          ],
          [
            9.396819,
            53.81605,
            44.333032
          ],
          [
            9.39703,
            53.815851,
            44.542842
          ],
          [
            9.39722,
            53.81568,
            44.706546
          ],
          [
            9.397419,
            53.815487,
            44.529949
          ],
          [
            9.397657,
            53.815255,
            44.318083
          ],
          [
            9.39789,
            53.815026,
            44.109446
          ],
          [
            9.398079,
            53.814849,
            43.946022
          ],
          [
            9.3983,
            53.814653,
            43.762159
          ],
          [
            9.398482,
            53.814469,
            43.595586
          ],
          [
            9.398706,
            53.814266,
            43.406189
          ],
          [
            9.398906,
            53.814075,
            43.2012
          ],
          [
            9.399078,
            53.813903,
            42.988262
          ],
          [
            9.39927,
            53.813715,
            42.754545
          ],
          [
            9.399468,
            53.813531,
            42.522577
          ],
          [
            9.399648,
            53.813342,
            42.291756
          ],
          [
            9.399831,
            53.813161,
            42.067192
          ],
          [
            9.400035,
            53.812951,
            41.809202
          ],
          [
            9.400248,
            53.812767,
            41.572036
          ],
          [
            9.400441,
            53.812574,
            41.439426
          ],
          [
            9.400612,
            53.812377,
            41.59667
          ],
          [
            9.40079,
            53.812209,
            41.737185
          ],
          [
            9.400982,
            53.812013,
            41.897738
          ],
          [
            9.401146,
            53.811811,
            42.056877
          ],
          [
            9.401325,
            53.811607,
            42.220117
          ],
          [
            9.401526,
            53.811407,
            42.385195
          ],
          [
            9.401739,
            53.811232,
            42.538222
          ],
          [
            9.401931,
            53.811042,
            42.647273
          ],
          [
            9.4021,
            53.810864,
            42.486684
          ],
          [
            9.402282,
            53.810678,
            42.317953
          ],
          [
            9.402476,
            53.810501,
            42.152327
          ],
          [
            9.402706,
            53.810312,
            41.969398
          ],
          [
            9.402902,
            53.810134,
            41.80262
          ],
          [
            9.403207,
            53.81,
            41.620487
          ],
          [
            9.403474,
            53.809858,
            41.453819
          ],
          [
            9.403729,
            53.809742,
            41.304463
          ],
          [
            9.404003,
            53.809613,
            41.561834
          ],
          [
            9.404295,
            53.809493,
            41.984105
          ],
          [
            9.404588,
            53.809345,
            42.441662
          ],
          [
            9.40483,
            53.809209,
            42.838424
          ],
          [
            9.405135,
            53.809078,
            43.285988
          ],
          [
            9.405413,
            53.808924,
            43.741128
          ],
          [
            9.405619,
            53.808738,
            44.187744
          ],
          [
            9.405775,
            53.808552,
            44.605766
          ],
          [
            9.405985,
            53.808351,
            44.906538
          ],
          [
            9.406153,
            53.808176,
            44.969961
          ],
          [
            9.406329,
            53.807978,
            45.040409
          ],
          [
            9.406522,
            53.807792,
            45.109002
          ],
          [
            9.406661,
            53.807604,
            45.173506
          ],
          [
            9.406841,
            53.807417,
            45.241143
          ],
          [
            9.407023,
            53.807224,
            45.310837
          ],
          [
            9.407225,
            53.807005,
            45.389258
          ],
          [
            9.407427,
            53.806809,
            45.301058
          ],
          [
            9.407639,
            53.806614,
            44.835867
          ],
          [
            9.407875,
            53.806459,
            44.417572
          ],
          [
            9.408121,
            53.806306,
            43.994163
          ],
          [
            9.40835,
            53.806133,
            43.552484
          ],
          [
            9.408552,
            53.805933,
            43.085142
          ],
          [
            9.40875,
            53.805751,
            42.650867
          ],
          [
            9.408969,
            53.805561,
            42.18952
          ],
          [
            9.40914,
            53.805396,
            41.834314
          ],
          [
            9.409327,
            53.805226,
            41.890344
          ],
          [
            9.409542,
            53.805065,
            41.947146
          ],
          [
            9.409716,
            53.804909,
            41.998852
          ],
          [
            9.40987,
            53.80473,
            42.054523
          ],
          [
            9.409993,
            53.804546,
            42.109252
          ],
          [
            9.410123,
            53.804305,
            42.179216
          ],
          [
            9.410271,
            53.804058,
            42.251824
          ],
          [
            9.410389,
            53.803874,
            42.30625
          ],
          [
            9.410469,
            53.803682,
            42.338432
          ],
          [
            9.410696,
            53.803489,
            42.360185
          ],
          [
            9.410983,
            53.803405,
            42.377483
          ],
          [
            9.411361,
            53.803256,
            42.402055
          ],
          [
            9.411644,
            53.803148,
            42.42049
          ],
          [
            9.41194,
            53.80307,
            42.437999
          ],
          [
            9.412242,
            53.803,
            42.455527
          ],
          [
            9.412555,
            53.802963,
            42.472857
          ],
          [
            9.412885,
            53.802942,
            42.490785
          ],
          [
            9.41326,
            53.802924,
            43.004545
          ],
          [
            9.413606,
            53.802868,
            43.520229
          ],
          [
            9.413904,
            53.802759,
            44.024183
          ],
          [
            9.414084,
            53.802578,
            44.53372
          ],
          [
            9.414385,
            53.802455,
            45.075395
          ],
          [
            9.414673,
            53.802376,
            45.531312
          ],
          [
            9.414935,
            53.802225,
            46.055554
          ],
          [
            9.415228,
            53.802074,
            46.612246
          ],
          [
            9.415309,
            53.801896,
            47.045453
          ],
          [
            9.415319,
            53.80193,
            47.352613
          ],
          [
            9.415559,
            53.801989,
            47.768147
          ],
          [
            9.415814,
            53.801831,
            48.176166
          ],
          [
            9.416078,
            53.801644,
            48.631341
          ],
          [
            9.416309,
            53.801472,
            49.041734
          ],
          [
            9.416595,
            53.801258,
            49.552165
          ],
          [
            9.416772,
            53.801063,
            49.965742
          ],
          [
            9.416918,
            53.800891,
            50.064505
          ],
          [
            9.417098,
            53.800692,
            49.565023
          ],
          [
            9.417298,
            53.8005,
            49.066223
          ],
          [
            9.417497,
            53.800323,
            48.59353
          ],
          [
            9.417803,
            53.800287,
            48.181171
          ],
          [
            9.417774,
            53.800094,
            47.751721
          ],
          [
            9.417893,
            53.79987,
            47.230245
          ],
          [
            9.418019,
            53.799661,
            46.738953
          ],
          [
            9.418006,
            53.799438,
            46.238926
          ],
          [
            9.418005,
            53.799216,
            46.110213
          ],
          [
            9.418036,
            53.799014,
            46.001286
          ],
          [
            9.418052,
            53.798804,
            45.888316
          ],
          [
            9.418115,
            53.798564,
            45.757895
          ],
          [
            9.418146,
            53.798368,
            45.65219
          ],
          [
            9.418217,
            53.798144,
            45.52979
          ],
          [
            9.418219,
            53.797919,
            45.408942
          ],
          [
            9.418229,
            53.79772,
            45.301945
          ],
          [
            9.418277,
            53.797534,
            45.384349
          ],
          [
            9.418307,
            53.797312,
            45.630529
          ],
          [
            9.418352,
            53.797118,
            45.847048
          ],
          [
            9.418391,
            53.796927,
            46.059592
          ],
          [
            9.418409,
            53.796704,
            46.30624
          ],
          [
            9.418426,
            53.796509,
            46.521957
          ],
          [
            9.418472,
            53.796275,
            46.782204
          ],
          [
            9.418509,
            53.796049,
            47.033063
          ],
          [
            9.418533,
            53.795823,
            47.223015
          ],
          [
            9.418556,
            53.795598,
            47.048653
          ],
          [
            9.418589,
            53.795399,
            46.893909
          ],
          [
            9.418646,
            53.79519,
            46.730132
          ],
          [
            9.418695,
            53.794991,
            46.574371
          ],
          [
            9.418738,
            53.794788,
            46.416105
          ],
          [
            9.418789,
            53.794572,
            46.247395
          ],
          [
            9.418815,
            53.794384,
            46.101388
          ],
          [
            9.418874,
            53.794171,
            45.934139
          ],
          [
            9.41891,
            53.793956,
            45.97719
          ],
          [
            9.418949,
            53.793758,
            46.184288
          ],
          [
            9.418978,
            53.793543,
            46.40853
          ],
          [
            9.419004,
            53.793327,
            46.633841
          ],
          [
            9.418996,
            53.793124,
            46.846839
          ],
          [
            9.419014,
            53.7929,
            47.079825
          ],
          [
            9.419075,
            53.792704,
            47.28763
          ],
          [
            9.419142,
            53.792483,
            47.520901
          ],
          [
            9.419191,
            53.792225,
            47.725331
          ],
          [
            9.419224,
            53.791977,
            47.725331
          ],
          [
            9.4193,
            53.791748,
            47.725331
          ],
          [
            9.419232,
            53.791532,
            47.725331
          ],
          [
            9.419278,
            53.7914,
            47.725331
          ]
        ]
      }
    }
  ]
}

let day24: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            9.432384,
            53.793035,
            39.908569
          ],
          [
            9.432368,
            53.793213,
            39.908569
          ],
          [
            9.432627,
            53.793361,
            39.908569
          ],
          [
            9.432871,
            53.793511,
            39.908569
          ],
          [
            9.433106,
            53.793662,
            39.908569
          ],
          [
            9.433317,
            53.7938,
            39.891237
          ],
          [
            9.433427,
            53.793984,
            39.864225
          ],
          [
            9.433405,
            53.794202,
            39.833824
          ],
          [
            9.433189,
            53.794394,
            39.801456
          ],
          [
            9.432889,
            53.794558,
            39.768128
          ],
          [
            9.432641,
            53.794764,
            39.733083
          ],
          [
            9.432611,
            53.795001,
            39.699279
          ],
          [
            9.432785,
            53.795204,
            39.667789
          ],
          [
            9.433107,
            53.795439,
            39.248588
          ],
          [
            9.433345,
            53.795594,
            38.901787
          ],
          [
            9.433552,
            53.795751,
            38.571174
          ],
          [
            9.433764,
            53.795889,
            38.262082
          ],
          [
            9.433983,
            53.796021,
            37.955973
          ],
          [
            9.434217,
            53.796156,
            37.63589
          ],
          [
            9.434469,
            53.796304,
            37.288223
          ],
          [
            9.434715,
            53.796463,
            36.930865
          ],
          [
            9.434885,
            53.796632,
            36.752512
          ],
          [
            9.435137,
            53.796801,
            37.100776
          ],
          [
            9.435453,
            53.796979,
            37.499704
          ],
          [
            9.435729,
            53.797126,
            37.838821
          ],
          [
            9.436003,
            53.797253,
            38.157161
          ],
          [
            9.436271,
            53.797413,
            38.504716
          ],
          [
            9.436564,
            53.797585,
            38.881505
          ],
          [
            9.436872,
            53.797761,
            39.272698
          ],
          [
            9.43716,
            53.797927,
            39.3385
          ],
          [
            9.437428,
            53.798095,
            39.101654
          ],
          [
            9.437664,
            53.79825,
            38.887759
          ],
          [
            9.437918,
            53.798404,
            38.667096
          ],
          [
            9.438213,
            53.798419,
            38.463346
          ],
          [
            9.438529,
            53.798255,
            38.208342
          ],
          [
            9.438795,
            53.798095,
            37.978262
          ],
          [
            9.43906,
            53.797927,
            37.742682
          ],
          [
            9.439313,
            53.797769,
            37.575927
          ],
          [
            9.439573,
            53.797613,
            37.486205
          ],
          [
            9.439852,
            53.797435,
            37.386831
          ],
          [
            9.440118,
            53.797279,
            37.296019
          ],
          [
            9.440383,
            53.797118,
            37.203999
          ],
          [
            9.440636,
            53.796956,
            37.113717
          ],
          [
            9.440891,
            53.796794,
            37.022987
          ],
          [
            9.441155,
            53.796636,
            36.932054
          ],
          [
            9.441421,
            53.796484,
            37.018554
          ],
          [
            9.441649,
            53.796341,
            37.352837
          ],
          [
            9.441914,
            53.796195,
            37.71732
          ],
          [
            9.442136,
            53.796046,
            38.05518
          ],
          [
            9.442396,
            53.795893,
            38.424354
          ],
          [
            9.442629,
            53.795763,
            38.746728
          ],
          [
            9.442879,
            53.795608,
            39.111131
          ],
          [
            9.443145,
            53.795441,
            39.501955
          ],
          [
            9.443467,
            53.795305,
            39.902601
          ],
          [
            9.443833,
            53.795323,
            39.161281
          ],
          [
            9.444213,
            53.795415,
            38.205872
          ],
          [
            9.444577,
            53.795515,
            37.271939
          ],
          [
            9.444914,
            53.795601,
            36.417928
          ],
          [
            9.445243,
            53.795687,
            35.580571
          ],
          [
            9.445575,
            53.795763,
            34.752187
          ],
          [
            9.445934,
            53.795859,
            33.835319
          ],
          [
            9.446304,
            53.795961,
            32.884732
          ],
          [
            9.446655,
            53.796052,
            33.096918
          ],
          [
            9.446956,
            53.796139,
            33.317241
          ],
          [
            9.447283,
            53.796241,
            33.560561
          ],
          [
            9.447606,
            53.796326,
            33.793548
          ],
          [
            9.447899,
            53.796399,
            34.002898
          ],
          [
            9.448235,
            53.796472,
            34.238388
          ],
          [
            9.448539,
            53.796558,
            34.459983
          ],
          [
            9.449106,
            53.796664,
            34.851808
          ],
          [
            9.44945,
            53.796747,
            35.288794
          ],
          [
            9.449814,
            53.796843,
            35.760861
          ],
          [
            9.45008,
            53.796959,
            36.174174
          ],
          [
            9.450357,
            53.797115,
            36.626994
          ],
          [
            9.450546,
            53.797319,
            37.092515
          ],
          [
            9.450722,
            53.797535,
            37.572356
          ],
          [
            9.450901,
            53.79774,
            38.034832
          ],
          [
            9.451066,
            53.797967,
            38.505771
          ],
          [
            9.451253,
            53.79819,
            38.843257
          ],
          [
            9.4514,
            53.798397,
            39.147679
          ],
          [
            9.451564,
            53.798576,
            39.423898
          ],
          [
            9.451745,
            53.798749,
            39.699808
          ],
          [
            9.452052,
            53.798926,
            40.044175
          ],
          [
            9.452269,
            53.798914,
            40.341811
          ],
          [
            9.452216,
            53.798914,
            40.612463
          ],
          [
            9.452327,
            53.79907,
            40.894904
          ],
          [
            9.452616,
            53.799159,
            40.820526
          ],
          [
            9.452937,
            53.79921,
            40.744274
          ],
          [
            9.453273,
            53.799252,
            40.665718
          ],
          [
            9.453576,
            53.799286,
            40.594736
          ],
          [
            9.453907,
            53.799327,
            40.517393
          ],
          [
            9.454241,
            53.799373,
            40.438958
          ],
          [
            9.454567,
            53.799421,
            40.362103
          ],
          [
            9.454899,
            53.799482,
            40.282581
          ],
          [
            9.45526,
            53.799553,
            40.203186
          ],
          [
            9.455628,
            53.799598,
            40.327422
          ],
          [
            9.455966,
            53.79969,
            40.45105
          ],
          [
            9.456273,
            53.799841,
            40.583576
          ],
          [
            9.456483,
            53.800015,
            40.70341
          ],
          [
            9.456601,
            53.800219,
            40.824101
          ],
          [
            9.456674,
            53.800439,
            40.949565
          ],
          [
            9.456728,
            53.800654,
            41.071219
          ],
          [
            9.456799,
            53.800874,
            41.196552
          ],
          [
            9.456873,
            53.80108,
            41.320118
          ],
          [
            9.457013,
            53.801276,
            41.448277
          ],
          [
            9.45738,
            53.801292,
            41.587171
          ],
          [
            9.45769,
            53.801129,
            41.731669
          ],
          [
            9.457981,
            53.80096,
            41.873648
          ],
          [
            9.458283,
            53.800782,
            42.022056
          ],
          [
            9.458547,
            53.800628,
            42.151129
          ],
          [
            9.458809,
            53.800465,
            42.289823
          ],
          [
            9.459054,
            53.800315,
            42.453286
          ],
          [
            9.459271,
            53.800174,
            42.603684
          ],
          [
            9.459514,
            53.80002,
            42.768722
          ],
          [
            9.459783,
            53.799855,
            42.948251
          ],
          [
            9.46008,
            53.799687,
            43.138612
          ],
          [
            9.460384,
            53.799509,
            43.336812
          ],
          [
            9.460659,
            53.799329,
            43.526811
          ],
          [
            9.460961,
            53.799158,
            43.589544
          ],
          [
            9.461323,
            53.799086,
            43.265636
          ],
          [
            9.461658,
            53.799239,
            42.902919
          ],
          [
            9.461947,
            53.799409,
            42.557953
          ],
          [
            9.462258,
            53.799549,
            42.229045
          ],
          [
            9.462598,
            53.799694,
            41.876995
          ],
          [
            9.462932,
            53.799842,
            41.526649
          ],
          [
            9.463268,
            53.800007,
            41.159745
          ],
          [
            9.463549,
            53.800148,
            40.984384
          ],
          [
            9.463841,
            53.800292,
            40.824717
          ],
          [
            9.464098,
            53.800427,
            40.679569
          ],
          [
            9.464406,
            53.800571,
            40.514582
          ],
          [
            9.464667,
            53.800704,
            40.369771
          ],
          [
            9.464932,
            53.800835,
            40.224678
          ],
          [
            9.465258,
            53.800962,
            40.060803
          ],
          [
            9.46552,
            53.801071,
            39.92635
          ],
          [
            9.465811,
            53.801168,
            39.971401
          ],
          [
            9.466058,
            53.801285,
            40.281057
          ],
          [
            9.466321,
            53.801395,
            40.59648
          ],
          [
            9.466612,
            53.801528,
            40.956359
          ],
          [
            9.4669,
            53.801667,
            41.321095
          ],
          [
            9.467159,
            53.801774,
            41.630033
          ],
          [
            9.467474,
            53.801909,
            42.01164
          ],
          [
            9.467807,
            53.802057,
            42.419539
          ],
          [
            9.468115,
            53.802184,
            42.786764
          ],
          [
            9.468438,
            53.802343,
            42.498607
          ],
          [
            9.468751,
            53.802402,
            42.223245
          ],
          [
            9.468744,
            53.802597,
            41.942985
          ],
          [
            9.468602,
            53.802827,
            41.602398
          ],
          [
            9.468425,
            53.803061,
            41.246024
          ],
          [
            9.468259,
            53.803267,
            40.92897
          ],
          [
            9.468113,
            53.803478,
            40.61207
          ],
          [
            9.467967,
            53.803654,
            40.339686
          ],
          [
            9.467809,
            53.803867,
            40.012549
          ],
          [
            9.467655,
            53.804035,
            39.743208
          ],
          [
            9.467513,
            53.804215,
            39.463577
          ],
          [
            9.467361,
            53.804396,
            39.178678
          ],
          [
            9.467213,
            53.804582,
            38.889288
          ],
          [
            9.467056,
            53.804763,
            38.602509
          ],
          [
            9.466939,
            53.804951,
            38.319988
          ],
          [
            9.466789,
            53.805175,
            37.98052
          ],
          [
            9.466701,
            53.805352,
            37.742705
          ],
          [
            9.466633,
            53.805548,
            37.556385
          ],
          [
            9.466587,
            53.805743,
            37.37305
          ],
          [
            9.466555,
            53.805942,
            37.186898
          ],
          [
            9.46652,
            53.806138,
            37.003372
          ],
          [
            9.466495,
            53.806324,
            36.829567
          ],
          [
            9.466452,
            53.806516,
            36.649032
          ],
          [
            9.466473,
            53.806748,
            36.428941
          ],
          [
            9.466748,
            53.806831,
            36.256051
          ],
          [
            9.467076,
            53.80687,
            36.154147
          ],
          [
            9.467406,
            53.806899,
            36.359489
          ],
          [
            9.46774,
            53.806941,
            36.569314
          ],
          [
            9.468049,
            53.806979,
            36.763305
          ],
          [
            9.468439,
            53.807024,
            37.007689
          ],
          [
            9.468799,
            53.807051,
            37.230787
          ],
          [
            9.469183,
            53.807083,
            37.469074
          ],
          [
            9.469561,
            53.807122,
            37.706087
          ],
          [
            9.469877,
            53.807135,
            37.900712
          ],
          [
            9.470325,
            53.807161,
            37.972297
          ],
          [
            9.470667,
            53.80719,
            37.961404
          ],
          [
            9.47101,
            53.807236,
            37.950345
          ],
          [
            9.471383,
            53.807291,
            37.938228
          ],
          [
            9.471686,
            53.807363,
            37.927959
          ],
          [
            9.472017,
            53.807437,
            37.916831
          ],
          [
            9.472325,
            53.807512,
            37.906357
          ],
          [
            9.47262,
            53.807587,
            37.89626
          ],
          [
            9.472943,
            53.807676,
            37.91123
          ],
          [
            9.473241,
            53.807765,
            38.087377
          ],
          [
            9.473573,
            53.807832,
            38.272199
          ],
          [
            9.473896,
            53.807917,
            38.459065
          ],
          [
            9.474219,
            53.808,
            38.644572
          ],
          [
            9.474558,
            53.808088,
            38.839545
          ],
          [
            9.47488,
            53.808161,
            39.021133
          ],
          [
            9.475198,
            53.80824,
            39.202899
          ],
          [
            9.475517,
            53.808318,
            39.38493
          ],
          [
            9.475836,
            53.808394,
            39.573409
          ],
          [
            9.476183,
            53.808477,
            39.789514
          ],
          [
            9.476451,
            53.808586,
            39.97745
          ],
          [
            9.476755,
            53.808673,
            40.172383
          ],
          [
            9.47706,
            53.808745,
            40.362011
          ],
          [
            9.477377,
            53.80881,
            40.555631
          ],
          [
            9.477711,
            53.808884,
            40.76194
          ],
          [
            9.478129,
            53.808953,
            41.012431
          ],
          [
            9.478501,
            53.809037,
            41.242315
          ],
          [
            9.478794,
            53.809108,
            41.342962
          ],
          [
            9.479074,
            53.809193,
            41.440858
          ],
          [
            9.479386,
            53.809279,
            41.547507
          ],
          [
            9.479743,
            53.809382,
            41.670603
          ],
          [
            9.480074,
            53.809452,
            41.779562
          ],
          [
            9.480425,
            53.809527,
            41.895182
          ],
          [
            9.480759,
            53.809612,
            42.007935
          ],
          [
            9.481077,
            53.809693,
            42.115373
          ],
          [
            9.481406,
            53.809744,
            42.17967
          ],
          [
            9.481737,
            53.809819,
            42.137178
          ],
          [
            9.482037,
            53.809907,
            42.096793
          ],
          [
            9.482379,
            53.809989,
            42.052372
          ],
          [
            9.482749,
            53.810059,
            42.005702
          ],
          [
            9.483068,
            53.810136,
            41.964325
          ],
          [
            9.483428,
            53.810209,
            41.918703
          ],
          [
            9.483755,
            53.810276,
            41.877145
          ],
          [
            9.484081,
            53.810353,
            41.835063
          ],
          [
            9.484374,
            53.81026,
            41.630759
          ],
          [
            9.484685,
            53.81032,
            41.415664
          ],
          [
            9.485026,
            53.810413,
            41.172749
          ],
          [
            9.485325,
            53.810491,
            40.961447
          ],
          [
            9.48571,
            53.810581,
            40.693343
          ],
          [
            9.486084,
            53.810667,
            40.43394
          ],
          [
            9.486384,
            53.810729,
            40.227637
          ],
          [
            9.486722,
            53.810815,
            39.989086
          ],
          [
            9.487025,
            53.810905,
            39.839686
          ],
          [
            9.487339,
            53.810979,
            39.795268
          ],
          [
            9.487669,
            53.811058,
            39.748459
          ],
          [
            9.488046,
            53.811121,
            39.697085
          ],
          [
            9.488436,
            53.81119,
            39.643888
          ],
          [
            9.488737,
            53.811239,
            39.603116
          ],
          [
            9.489043,
            53.811291,
            39.561283
          ],
          [
            9.489372,
            53.811373,
            39.514521
          ],
          [
            9.489674,
            53.811419,
            39.473773
          ],
          [
            9.48999,
            53.811481,
            39.659192
          ],
          [
            9.490361,
            53.811572,
            40.016351
          ],
          [
            9.490696,
            53.811636,
            40.327832
          ],
          [
            9.491002,
            53.811719,
            40.628591
          ],
          [
            9.491358,
            53.811775,
            40.955129
          ],
          [
            9.491667,
            53.811833,
            41.241994
          ],
          [
            9.492011,
            53.811889,
            41.557906
          ],
          [
            9.492315,
            53.811969,
            41.852444
          ],
          [
            9.492687,
            53.812045,
            42.142908
          ],
          [
            9.493051,
            53.812117,
            42.057763
          ],
          [
            9.493355,
            53.812182,
            41.98618
          ],
          [
            9.493659,
            53.812261,
            41.912614
          ],
          [
            9.493989,
            53.812374,
            41.828094
          ],
          [
            9.494421,
            53.812487,
            41.723454
          ],
          [
            9.494628,
            53.812651,
            41.64316
          ],
          [
            9.494843,
            53.81282,
            41.560349
          ],
          [
            9.495212,
            53.812877,
            41.474188
          ],
          [
            9.495515,
            53.812949,
            41.377938
          ],
          [
            9.495872,
            53.81301,
            41.2683
          ],
          [
            9.496183,
            53.813068,
            41.171938
          ],
          [
            9.49655,
            53.81318,
            41.047772
          ],
          [
            9.496949,
            53.813242,
            40.925892
          ],
          [
            9.49729,
            53.813338,
            40.814179
          ],
          [
            9.497616,
            53.813391,
            40.714515
          ],
          [
            9.497967,
            53.813454,
            40.606317
          ],
          [
            9.498299,
            53.813536,
            40.629397
          ],
          [
            9.498586,
            53.813613,
            40.681503
          ],
          [
            9.498911,
            53.81368,
            40.738415
          ],
          [
            9.499227,
            53.813758,
            40.795255
          ],
          [
            9.49956,
            53.813829,
            40.853861
          ],
          [
            9.499879,
            53.81394,
            40.916169
          ],
          [
            9.500193,
            53.81402,
            40.972692
          ],
          [
            9.500538,
            53.814093,
            41.033259
          ],
          [
            9.500859,
            53.814195,
            41.080811
          ],
          [
            9.501165,
            53.814267,
            41.044409
          ],
          [
            9.501536,
            53.81437,
            40.999007
          ],
          [
            9.501884,
            53.814445,
            40.957559
          ],
          [
            9.502292,
            53.814522,
            40.910145
          ],
          [
            9.502591,
            53.814605,
            40.873634
          ],
          [
            9.50301,
            53.814714,
            40.822994
          ],
          [
            9.503307,
            53.814778,
            40.78802
          ],
          [
            9.503689,
            53.814846,
            40.751274
          ],
          [
            9.504075,
            53.814939,
            40.767954
          ],
          [
            9.504415,
            53.815038,
            40.783073
          ],
          [
            9.504762,
            53.815115,
            40.797743
          ],
          [
            9.505144,
            53.815188,
            40.813632
          ],
          [
            9.505431,
            53.815263,
            40.826052
          ],
          [
            9.50576,
            53.81532,
            40.83962
          ],
          [
            9.506112,
            53.815396,
            40.854455
          ],
          [
            9.50648,
            53.81546,
            40.869641
          ],
          [
            9.506804,
            53.815557,
            40.820501
          ],
          [
            9.507124,
            53.81567,
            40.768912
          ],
          [
            9.507467,
            53.815771,
            40.716027
          ],
          [
            9.507774,
            53.81585,
            40.669764
          ],
          [
            9.508151,
            53.815948,
            40.613106
          ],
          [
            9.508539,
            53.816046,
            40.554887
          ],
          [
            9.508836,
            53.816114,
            40.511023
          ],
          [
            9.509166,
            53.816201,
            40.461097
          ],
          [
            9.509474,
            53.81626,
            40.636404
          ],
          [
            9.509858,
            53.816332,
            40.931225
          ],
          [
            9.51017,
            53.816402,
            41.175475
          ],
          [
            9.510483,
            53.816467,
            41.418484
          ],
          [
            9.510802,
            53.816534,
            41.666291
          ],
          [
            9.511172,
            53.816618,
            41.956408
          ],
          [
            9.511567,
            53.816675,
            42.254002
          ],
          [
            9.511951,
            53.816716,
            42.539567
          ],
          [
            9.512301,
            53.816742,
            42.8035
          ],
          [
            9.512599,
            53.816826,
            43.052626
          ],
          [
            9.512932,
            53.816883,
            43.313322
          ],
          [
            9.513253,
            53.816925,
            43.561261
          ],
          [
            9.513596,
            53.816966,
            43.824334
          ],
          [
            9.513939,
            53.817025,
            44.093179
          ],
          [
            9.514296,
            53.817041,
            44.364846
          ],
          [
            9.514553,
            53.816911,
            44.632355
          ],
          [
            9.514813,
            53.816787,
            44.884184
          ],
          [
            9.515088,
            53.816647,
            44.88364
          ],
          [
            9.515344,
            53.816488,
            44.753024
          ],
          [
            9.515617,
            53.816339,
            44.62235
          ],
          [
            9.515944,
            53.81621,
            44.483926
          ],
          [
            9.516306,
            53.816095,
            44.339209
          ],
          [
            9.516705,
            53.815994,
            44.186598
          ],
          [
            9.517117,
            53.815927,
            44.036285
          ],
          [
            9.517505,
            53.815843,
            43.901477
          ],
          [
            9.517894,
            53.815745,
            43.922804
          ],
          [
            9.51829,
            53.815639,
            43.94473
          ],
          [
            9.518693,
            53.815552,
            43.966369
          ],
          [
            9.519078,
            53.815467,
            43.987117
          ],
          [
            9.51945,
            53.815368,
            44.007693
          ],
          [
            9.519842,
            53.815248,
            44.029961
          ],
          [
            9.520175,
            53.815126,
            44.049764
          ],
          [
            9.520495,
            53.815044,
            44.072691
          ],
          [
            9.52085,
            53.814973,
            44.098995
          ],
          [
            9.521252,
            53.814911,
            44.12823
          ],
          [
            9.521654,
            53.814876,
            44.15675
          ],
          [
            9.522072,
            53.81484,
            44.186397
          ],
          [
            9.522516,
            53.814812,
            44.217747
          ],
          [
            9.522946,
            53.814781,
            44.248153
          ],
          [
            9.523341,
            53.814755,
            44.143888
          ],
          [
            9.523731,
            53.814755,
            43.744319
          ],
          [
            9.524108,
            53.814726,
            43.351022
          ],
          [
            9.524472,
            53.814687,
            42.974191
          ],
          [
            9.524766,
            53.814625,
            42.654805
          ],
          [
            9.525084,
            53.814508,
            42.273338
          ],
          [
            9.52543,
            53.814379,
            41.856232
          ],
          [
            9.525757,
            53.814223,
            41.426916
          ],
          [
            9.52602,
            53.81407,
            41.176777
          ],
          [
            9.52624,
            53.813885,
            41.213223
          ],
          [
            9.526466,
            53.813706,
            41.249447
          ],
          [
            9.526655,
            53.813549,
            41.280422
          ],
          [
            9.526849,
            53.813357,
            41.316337
          ],
          [
            9.527007,
            53.813202,
            41.345431
          ],
          [
            9.527184,
            53.81301,
            41.380637
          ],
          [
            9.527424,
            53.812832,
            41.417191
          ],
          [
            9.527631,
            53.812633,
            41.454708
          ],
          [
            9.527894,
            53.812436,
            41.914633
          ],
          [
            9.528121,
            53.812227,
            42.372085
          ],
          [
            9.528315,
            53.812042,
            42.77264
          ],
          [
            9.528528,
            53.811859,
            43.181255
          ],
          [
            9.528683,
            53.81168,
            43.551516
          ],
          [
            9.528827,
            53.811505,
            43.910314
          ],
          [
            9.529023,
            53.811341,
            44.279662
          ],
          [
            9.529284,
            53.811166,
            44.709118
          ],
          [
            9.529503,
            53.810998,
            44.842616
          ],
          [
            9.529693,
            53.810828,
            44.930013
          ],
          [
            9.529879,
            53.810656,
            45.017605
          ],
          [
            9.530087,
            53.810473,
            45.112179
          ],
          [
            9.530288,
            53.810274,
            45.211595
          ],
          [
            9.530504,
            53.810087,
            45.308715
          ],
          [
            9.530723,
            53.809888,
            45.410562
          ],
          [
            9.530941,
            53.809705,
            45.507014
          ],
          [
            9.531116,
            53.809535,
            45.435735
          ],
          [
            9.531309,
            53.809342,
            45.26327
          ],
          [
            9.53153,
            53.809145,
            45.081443
          ],
          [
            9.531756,
            53.808948,
            44.898332
          ],
          [
            9.53194,
            53.808779,
            44.743697
          ],
          [
            9.53216,
            53.808582,
            44.562099
          ],
          [
            9.532384,
            53.808388,
            44.381372
          ],
          [
            9.532596,
            53.808194,
            44.203711
          ],
          [
            9.532784,
            53.808023,
            44.154233
          ],
          [
            9.533004,
            53.807825,
            44.157567
          ],
          [
            9.533219,
            53.80761,
            44.161089
          ],
          [
            9.533454,
            53.807406,
            44.164563
          ],
          [
            9.533639,
            53.807222,
            44.167576
          ],
          [
            9.533832,
            53.807056,
            44.170414
          ],
          [
            9.534024,
            53.806874,
            44.173442
          ],
          [
            9.534199,
            53.806697,
            44.176333
          ],
          [
            9.534319,
            53.806513,
            44.259033
          ],
          [
            9.534542,
            53.806334,
            44.429791
          ],
          [
            9.53473,
            53.806147,
            44.596921
          ],
          [
            9.534964,
            53.805982,
            44.763805
          ],
          [
            9.535293,
            53.805967,
            44.929099
          ],
          [
            9.535595,
            53.806083,
            45.093943
          ],
          [
            9.535859,
            53.806194,
            45.252315
          ],
          [
            9.536118,
            53.806299,
            45.394877
          ],
          [
            9.53643,
            53.806429,
            45.560875
          ],
          [
            9.536777,
            53.80653,
            45.587019
          ],
          [
            9.537044,
            53.806616,
            45.607704
          ],
          [
            9.537374,
            53.806726,
            45.633303
          ],
          [
            9.537716,
            53.806852,
            45.660531
          ],
          [
            9.538073,
            53.806986,
            45.689211
          ],
          [
            9.53834,
            53.807085,
            45.710507
          ],
          [
            9.538599,
            53.807195,
            45.732216
          ],
          [
            9.53892,
            53.807324,
            45.75855
          ],
          [
            9.539208,
            53.807425,
            45.800389
          ],
          [
            9.539545,
            53.807548,
            45.85965
          ],
          [
            9.539894,
            53.807676,
            45.921102
          ],
          [
            9.540253,
            53.807807,
            45.984207
          ],
          [
            9.540616,
            53.807952,
            46.049757
          ],
          [
            9.540951,
            53.808081,
            46.109571
          ],
          [
            9.541278,
            53.808205,
            46.167681
          ],
          [
            9.541613,
            53.808305,
            46.187752
          ],
          [
            9.541913,
            53.808434,
            45.667164
          ],
          [
            9.542242,
            53.808546,
            45.134423
          ],
          [
            9.542518,
            53.808638,
            44.689818
          ],
          [
            9.542823,
            53.808741,
            44.196859
          ],
          [
            9.543143,
            53.808851,
            43.677253
          ],
          [
            9.543464,
            53.808972,
            43.142858
          ],
          [
            9.543775,
            53.809064,
            42.654797
          ],
          [
            9.544109,
            53.809195,
            42.092347
          ],
          [
            9.544424,
            53.809328,
            41.864837
          ],
          [
            9.544755,
            53.80947,
            41.745174
          ],
          [
            9.545086,
            53.809597,
            41.629701
          ],
          [
            9.545419,
            53.809725,
            41.513502
          ],
          [
            9.54575,
            53.80984,
            41.40119
          ],
          [
            9.546118,
            53.809972,
            41.275276
          ],
          [
            9.546474,
            53.81009,
            41.155161
          ],
          [
            9.546838,
            53.810217,
            41.115824
          ],
          [
            9.547155,
            53.810321,
            41.356064
          ],
          [
            9.547467,
            53.810431,
            41.596856
          ],
          [
            9.547808,
            53.810545,
            41.857511
          ],
          [
            9.548076,
            53.810651,
            42.07108
          ],
          [
            9.548365,
            53.810751,
            42.292857
          ],
          [
            9.548664,
            53.810871,
            42.533247
          ],
          [
            9.548985,
            53.81099,
            42.784334
          ],
          [
            9.549326,
            53.811134,
            43.061889
          ],
          [
            9.549609,
            53.811231,
            43.36613
          ],
          [
            9.549914,
            53.811372,
            43.729443
          ],
          [
            9.550249,
            53.8115,
            44.102292
          ],
          [
            9.550621,
            53.811647,
            44.520554
          ],
          [
            9.550933,
            53.811741,
            44.847845
          ],
          [
            9.551296,
            53.811875,
            45.248592
          ],
          [
            9.551633,
            53.812012,
            45.63136
          ],
          [
            9.551977,
            53.812142,
            45.843875
          ],
          [
            9.552359,
            53.812232,
            45.524953
          ],
          [
            9.55277,
            53.812269,
            45.205075
          ],
          [
            9.553192,
            53.812296,
            44.878337
          ],
          [
            9.553565,
            53.812328,
            44.588432
          ],
          [
            9.553952,
            53.812369,
            44.286024
          ],
          [
            9.55436,
            53.812421,
            43.964964
          ],
          [
            9.554747,
            53.812452,
            43.664606
          ],
          [
            9.55509,
            53.812484,
            43.473684
          ],
          [
            9.555482,
            53.812519,
            43.297827
          ],
          [
            9.555864,
            53.81254,
            43.127507
          ],
          [
            9.556273,
            53.812581,
            42.943483
          ],
          [
            9.556637,
            53.812608,
            42.780626
          ],
          [
            9.557054,
            53.812659,
            42.591733
          ],
          [
            9.557417,
            53.812696,
            42.428339
          ],
          [
            9.557807,
            53.812742,
            42.251671
          ],
          [
            9.558183,
            53.812753,
            42.182317
          ],
          [
            9.558586,
            53.812805,
            42.125528
          ],
          [
            9.559003,
            53.812874,
            42.066059
          ],
          [
            9.559391,
            53.812917,
            42.011804
          ],
          [
            9.559818,
            53.812957,
            41.952385
          ],
          [
            9.56021,
            53.812985,
            41.898119
          ],
          [
            9.560606,
            53.81302,
            41.843122
          ],
          [
            9.561021,
            53.813065,
            41.787912
          ],
          [
            9.56144,
            53.813115,
            41.736213
          ],
          [
            9.561842,
            53.813132,
            41.687293
          ],
          [
            9.562259,
            53.813172,
            41.636274
          ],
          [
            9.56264,
            53.8132,
            41.589911
          ],
          [
            9.563038,
            53.813239,
            41.541198
          ],
          [
            9.563444,
            53.813284,
            41.490573
          ],
          [
            9.563807,
            53.813325,
            41.445951
          ],
          [
            9.564182,
            53.813365,
            40.950839
          ],
          [
            9.56456,
            53.81341,
            40.3846
          ],
          [
            9.564979,
            53.813486,
            39.739207
          ],
          [
            9.565353,
            53.813567,
            39.154206
          ],
          [
            9.565702,
            53.813618,
            38.625195
          ],
          [
            9.566088,
            53.81371,
            38.013559
          ],
          [
            9.566434,
            53.813803,
            37.455289
          ],
          [
            9.566786,
            53.813894,
            37.067346
          ],
          [
            9.567155,
            53.81397,
            37.770112
          ],
          [
            9.567482,
            53.814046,
            38.402077
          ],
          [
            9.56786,
            53.814129,
            39.127189
          ],
          [
            9.568165,
            53.814208,
            39.732383
          ],
          [
            9.568525,
            53.814293,
            40.429772
          ],
          [
            9.568905,
            53.814384,
            41.166907
          ],
          [
            9.569269,
            53.814489,
            41.895148
          ],
          [
            9.569637,
            53.814607,
            42.446319
          ],
          [
            9.570028,
            53.814744,
            42.459318
          ],
          [
            9.570373,
            53.81487,
            42.4709
          ],
          [
            9.570698,
            53.815003,
            42.482191
          ],
          [
            9.571026,
            53.815132,
            42.493437
          ],
          [
            9.571302,
            53.815257,
            42.503357
          ],
          [
            9.571618,
            53.815396,
            42.514626
          ],
          [
            9.571942,
            53.815582,
            42.527514
          ],
          [
            9.572279,
            53.815749,
            42.027489
          ],
          [
            9.57252,
            53.815877,
            41.568454
          ],
          [
            9.572822,
            53.816035,
            40.995711
          ],
          [
            9.573169,
            53.816203,
            40.360331
          ],
          [
            9.573453,
            53.816354,
            39.818854
          ],
          [
            9.573752,
            53.816493,
            39.27973
          ],
          [
            9.574068,
            53.816638,
            38.71308
          ],
          [
            9.57434,
            53.816765,
            38.2215
          ],
          [
            9.574647,
            53.816921,
            37.744304
          ],
          [
            9.574978,
            53.81706,
            37.267175
          ],
          [
            9.575264,
            53.817221,
            36.802684
          ],
          [
            9.575557,
            53.817369,
            36.349797
          ],
          [
            9.575854,
            53.817523,
            35.88549
          ],
          [
            9.57614,
            53.817667,
            35.443982
          ],
          [
            9.576422,
            53.817801,
            35.018871
          ],
          [
            9.576721,
            53.817941,
            34.719032
          ],
          [
            9.577043,
            53.818114,
            35.32455
          ],
          [
            9.577311,
            53.81827,
            35.848055
          ],
          [
            9.577618,
            53.818404,
            36.379441
          ],
          [
            9.577925,
            53.818531,
            36.900855
          ],
          [
            9.578214,
            53.81867,
            37.420022
          ],
          [
            9.578528,
            53.818843,
            38.018062
          ],
          [
            9.578837,
            53.818987,
            38.567156
          ],
          [
            9.579058,
            53.819127,
            38.971971
          ],
          [
            9.57932,
            53.819278,
            39.315508
          ],
          [
            9.579553,
            53.819446,
            39.660925
          ],
          [
            9.579744,
            53.819616,
            39.985386
          ],
          [
            9.579947,
            53.819793,
            40.325477
          ],
          [
            9.580154,
            53.819942,
            40.632103
          ],
          [
            9.580358,
            53.8201,
            40.94788
          ],
          [
            9.580562,
            53.820269,
            41.277769
          ],
          [
            9.580799,
            53.82042,
            41.606588
          ],
          [
            9.581103,
            53.820543,
            41.759102
          ],
          [
            9.581334,
            53.820691,
            41.795514
          ],
          [
            9.581648,
            53.820802,
            41.834837
          ],
          [
            9.581954,
            53.820926,
            41.874515
          ],
          [
            9.582234,
            53.821043,
            41.911292
          ],
          [
            9.58255,
            53.821145,
            41.949749
          ],
          [
            9.582863,
            53.821243,
            41.987581
          ],
          [
            9.5832,
            53.821353,
            42.0287
          ],
          [
            9.583527,
            53.821469,
            42.089282
          ],
          [
            9.58385,
            53.821605,
            42.214933
          ],
          [
            9.584211,
            53.821722,
            42.345344
          ],
          [
            9.584526,
            53.821808,
            42.455269
          ],
          [
            9.584845,
            53.82191,
            42.570265
          ],
          [
            9.585167,
            53.82202,
            42.688073
          ],
          [
            9.585451,
            53.822115,
            42.791439
          ],
          [
            9.585799,
            53.822206,
            42.912072
          ],
          [
            9.586155,
            53.822274,
            43.022078
          ],
          [
            9.586514,
            53.822326,
            42.982148
          ],
          [
            9.586841,
            53.82241,
            42.943604
          ],
          [
            9.587136,
            53.822485,
            42.908886
          ],
          [
            9.587407,
            53.822579,
            42.874928
          ],
          [
            9.587684,
            53.822685,
            42.839268
          ],
          [
            9.588008,
            53.822825,
            42.795849
          ],
          [
            9.588271,
            53.82294,
            42.760487
          ],
          [
            9.58858,
            53.823055,
            42.72102
          ],
          [
            9.588912,
            53.823183,
            42.562158
          ],
          [
            9.589257,
            53.823308,
            42.218273
          ],
          [
            9.589608,
            53.823426,
            41.874679
          ],
          [
            9.589982,
            53.823546,
            41.513453
          ],
          [
            9.59032,
            53.823658,
            41.183803
          ],
          [
            9.59068,
            53.823792,
            40.822656
          ],
          [
            9.591025,
            53.823906,
            40.486988
          ],
          [
            9.591402,
            53.824027,
            40.122774
          ],
          [
            9.591758,
            53.82415,
            40.360755
          ],
          [
            9.592101,
            53.824257,
            40.606511
          ],
          [
            9.592457,
            53.824382,
            40.8692
          ],
          [
            9.592849,
            53.82449,
            41.143577
          ],
          [
            9.593163,
            53.824604,
            41.377489
          ],
          [
            9.593533,
            53.824702,
            41.634507
          ],
          [
            9.593899,
            53.824799,
            41.888742
          ],
          [
            9.594257,
            53.824866,
            42.252038
          ],
          [
            9.594593,
            53.824926,
            42.794646
          ],
          [
            9.594941,
            53.825004,
            43.370217
          ],
          [
            9.595271,
            53.825075,
            43.91322
          ],
          [
            9.59562,
            53.825154,
            44.493124
          ],
          [
            9.595978,
            53.82524,
            45.090546
          ],
          [
            9.596345,
            53.825268,
            45.662515
          ],
          [
            9.596668,
            53.825345,
            46.200917
          ],
          [
            9.597012,
            53.825426,
            46.746713
          ],
          [
            9.597323,
            53.825528,
            46.690063
          ],
          [
            9.597666,
            53.825611,
            46.631037
          ],
          [
            9.597982,
            53.825668,
            46.5783
          ],
          [
            9.598275,
            53.825628,
            46.523353
          ],
          [
            9.598464,
            53.825439,
            46.46415
          ],
          [
            9.598637,
            53.825275,
            46.411968
          ],
          [
            9.598832,
            53.825108,
            46.357248
          ],
          [
            9.599028,
            53.824942,
            46.302642
          ],
          [
            9.599236,
            53.824768,
            46.164307
          ],
          [
            9.599445,
            53.824591,
            45.858679
          ],
          [
            9.599642,
            53.824434,
            45.580845
          ],
          [
            9.599802,
            53.824263,
            45.304058
          ],
          [
            9.600009,
            53.824097,
            45.012072
          ],
          [
            9.6002,
            53.823918,
            44.712401
          ],
          [
            9.600381,
            53.823744,
            44.423087
          ],
          [
            9.600566,
            53.82357,
            44.132075
          ],
          [
            9.600763,
            53.82342,
            43.863191
          ],
          [
            9.600955,
            53.823246,
            43.764843
          ],
          [
            9.601163,
            53.823066,
            43.866301
          ],
          [
            9.601352,
            53.822905,
            43.957514
          ],
          [
            9.601538,
            53.822745,
            44.047859
          ],
          [
            9.601738,
            53.822565,
            44.148128
          ],
          [
            9.601911,
            53.822414,
            44.233011
          ],
          [
            9.602134,
            53.822263,
            44.326354
          ],
          [
            9.602339,
            53.822091,
            44.424284
          ],
          [
            9.602523,
            53.821907,
            44.523759
          ],
          [
            9.602717,
            53.821724,
            44.945922
          ],
          [
            9.602875,
            53.821552,
            45.451928
          ],
          [
            9.603052,
            53.821369,
            45.996959
          ],
          [
            9.603248,
            53.821207,
            46.514622
          ],
          [
            9.603474,
            53.821031,
            47.086838
          ],
          [
            9.603694,
            53.820869,
            47.624047
          ],
          [
            9.603889,
            53.820696,
            48.161376
          ],
          [
            9.604065,
            53.820548,
            48.630213
          ],
          [
            9.604276,
            53.820394,
            49.143017
          ],
          [
            9.604446,
            53.820243,
            49.513427
          ],
          [
            9.604646,
            53.820069,
            49.925462
          ],
          [
            9.60484,
            53.819918,
            50.297012
          ],
          [
            9.605048,
            53.819761,
            50.687577
          ],
          [
            9.605253,
            53.819589,
            51.100096
          ],
          [
            9.60543,
            53.819432,
            51.470188
          ],
          [
            9.605614,
            53.819262,
            51.865534
          ],
          [
            9.605809,
            53.819084,
            52.281326
          ],
          [
            9.605981,
            53.818927,
            52.647768
          ],
          [
            9.606177,
            53.818762,
            52.690099
          ],
          [
            9.60643,
            53.818595,
            52.635715
          ],
          [
            9.606639,
            53.818429,
            52.585391
          ],
          [
            9.606802,
            53.818241,
            52.534074
          ],
          [
            9.607018,
            53.818056,
            52.479494
          ],
          [
            9.607215,
            53.817891,
            52.430489
          ],
          [
            9.607423,
            53.817733,
            52.381914
          ],
          [
            9.607614,
            53.817574,
            52.3346
          ],
          [
            9.607817,
            53.817401,
            52.379274
          ],
          [
            9.608075,
            53.817235,
            52.914824
          ],
          [
            9.608286,
            53.817082,
            53.383864
          ],
          [
            9.608526,
            53.816947,
            53.849073
          ],
          [
            9.60877,
            53.816799,
            54.341056
          ],
          [
            9.608964,
            53.816647,
            54.793297
          ],
          [
            9.60921,
            53.816495,
            55.293002
          ],
          [
            9.609443,
            53.816326,
            55.810778
          ],
          [
            9.609708,
            53.816164,
            56.346218
          ],
          [
            9.609958,
            53.816002,
            56.452635
          ],
          [
            9.610207,
            53.815835,
            56.255846
          ],
          [
            9.610443,
            53.81567,
            56.06487
          ],
          [
            9.610677,
            53.815499,
            55.870521
          ],
          [
            9.610931,
            53.815309,
            55.656464
          ],
          [
            9.611207,
            53.815129,
            55.441745
          ],
          [
            9.611441,
            53.814956,
            55.245869
          ],
          [
            9.611678,
            53.814794,
            55.056578
          ],
          [
            9.611905,
            53.814618,
            55.226837
          ],
          [
            9.612098,
            53.81445,
            55.621543
          ],
          [
            9.612332,
            53.814278,
            56.050952
          ],
          [
            9.612561,
            53.814107,
            56.474628
          ],
          [
            9.612789,
            53.813956,
            56.868607
          ],
          [
            9.613047,
            53.813795,
            57.299379
          ],
          [
            9.613297,
            53.813655,
            57.694936
          ],
          [
            9.613539,
            53.813525,
            58.070424
          ],
          [
            9.613805,
            53.8134,
            58.460777
          ],
          [
            9.614081,
            53.813276,
            58.367891
          ],
          [
            9.614327,
            53.81313,
            58.261285
          ],
          [
            9.614626,
            53.813002,
            58.148443
          ],
          [
            9.614903,
            53.812872,
            58.040328
          ],
          [
            9.615183,
            53.812753,
            57.93491
          ],
          [
            9.615462,
            53.812606,
            57.820601
          ],
          [
            9.615695,
            53.81246,
            57.716793
          ],
          [
            9.615934,
            53.81232,
            57.61388
          ],
          [
            9.616112,
            53.812164,
            57.445521
          ],
          [
            9.61636,
            53.812008,
            57.012209
          ],
          [
            9.6167,
            53.811818,
            56.451625
          ],
          [
            9.616981,
            53.811669,
            55.99947
          ],
          [
            9.617256,
            53.811534,
            55.571516
          ],
          [
            9.617507,
            53.811399,
            55.165522
          ],
          [
            9.617769,
            53.811269,
            54.756274
          ],
          [
            9.618105,
            53.811212,
            54.314276
          ],
          [
            9.618398,
            53.811317,
            53.904352
          ],
          [
            9.618742,
            53.811396,
            54.19935
          ],
          [
            9.619097,
            53.811528,
            54.551479
          ],
          [
            9.619388,
            53.811701,
            54.893902
          ],
          [
            9.619677,
            53.811869,
            55.230183
          ],
          [
            9.619915,
            53.811888,
            55.493866
          ],
          [
            9.620151,
            53.811723,
            55.797404
          ],
          [
            9.620425,
            53.811585,
            56.099549
          ],
          [
            9.620683,
            53.811444,
            56.391398
          ],
          [
            9.62095,
            53.811289,
            56.285071
          ],
          [
            9.621193,
            53.811126,
            56.133771
          ],
          [
            9.621429,
            53.810976,
            55.99116
          ],
          [
            9.621707,
            53.810884,
            55.854457
          ],
          [
            9.621947,
            53.811016,
            55.719143
          ],
          [
            9.622178,
            53.811176,
            55.57204
          ],
          [
            9.622335,
            53.811376,
            55.418416
          ],
          [
            9.62231,
            53.811392,
            55.28026
          ],
          [
            9.622186,
            53.811202,
            55.182567
          ],
          [
            9.62206,
            53.811023,
            55.230586
          ],
          [
            9.622261,
            53.810877,
            55.275316
          ],
          [
            9.622501,
            53.810734,
            55.322807
          ],
          [
            9.622762,
            53.810566,
            55.376637
          ],
          [
            9.623024,
            53.810391,
            55.431737
          ],
          [
            9.62277,
            53.810544,
            55.482332
          ],
          [
            9.622519,
            53.810704,
            55.533847
          ],
          [
            9.622383,
            53.810802,
            55.566194
          ],
          [
            9.622249,
            53.81128,
            54.883633
          ],
          [
            9.622071,
            53.811089,
            54.602129
          ],
          [
            9.622237,
            53.810893,
            54.312099
          ],
          [
            9.622496,
            53.810725,
            54.014889
          ],
          [
            9.622749,
            53.810558,
            53.726134
          ],
          [
            9.623022,
            53.8104,
            53.435193
          ],
          [
            9.623271,
            53.810292,
            53.214759
          ],
          [
            9.623523,
            53.810184,
            53.026555
          ],
          [
            9.623814,
            53.810031,
            52.791021
          ],
          [
            9.624152,
            53.810024,
            52.544374
          ],
          [
            9.624465,
            53.810173,
            52.301366
          ],
          [
            9.624699,
            53.810302,
            52.107537
          ],
          [
            9.624964,
            53.810408,
            51.913963
          ],
          [
            9.625301,
            53.81053,
            51.674387
          ],
          [
            9.625367,
            53.810713,
            51.470274
          ],
          [
            9.625252,
            53.810909,
            51.833304
          ],
          [
            9.625173,
            53.811131,
            52.351833
          ],
          [
            9.625207,
            53.811384,
            52.935592
          ],
          [
            9.625217,
            53.811575,
            53.372662
          ],
          [
            9.625263,
            53.811761,
            53.802162
          ],
          [
            9.625355,
            53.811962,
            54.277802
          ],
          [
            9.625457,
            53.812158,
            54.746203
          ],
          [
            9.625643,
            53.81234,
            55.234621
          ],
          [
            9.626021,
            53.812286,
            55.505265
          ],
          [
            9.626418,
            53.812197,
            55.404031
          ],
          [
            9.626805,
            53.812097,
            55.303281
          ],
          [
            9.627088,
            53.812009,
            55.226986
          ],
          [
            9.62738,
            53.811949,
            55.153307
          ],
          [
            9.627772,
            53.811845,
            55.050832
          ],
          [
            9.628134,
            53.811755,
            54.95721
          ],
          [
            9.628488,
            53.811632,
            54.859329
          ],
          [
            9.628856,
            53.811499,
            54.690723
          ],
          [
            9.629174,
            53.811383,
            54.505447
          ],
          [
            9.62943,
            53.811277,
            54.350629
          ],
          [
            9.62976,
            53.811146,
            54.153419
          ],
          [
            9.630072,
            53.811033,
            53.972151
          ],
          [
            9.630356,
            53.810914,
            53.799328
          ],
          [
            9.630692,
            53.810807,
            53.6101
          ],
          [
            9.631008,
            53.810699,
            53.429123
          ],
          [
            9.631291,
            53.810592,
            53.273523
          ],
          [
            9.631559,
            53.810486,
            53.150555
          ],
          [
            9.631822,
            53.810392,
            53.033094
          ],
          [
            9.632154,
            53.810285,
            52.888856
          ],
          [
            9.632487,
            53.810164,
            52.739813
          ],
          [
            9.632866,
            53.810026,
            52.570116
          ],
          [
            9.633249,
            53.809925,
            52.410136
          ],
          [
            9.633583,
            53.809828,
            52.268018
          ],
          [
            9.63395,
            53.809727,
            52.056736
          ],
          [
            9.634244,
            53.809642,
            51.728666
          ],
          [
            9.634589,
            53.809558,
            51.354269
          ],
          [
            9.634914,
            53.809463,
            50.990458
          ],
          [
            9.635293,
            53.809343,
            50.559481
          ],
          [
            9.635677,
            53.809225,
            50.125068
          ],
          [
            9.636013,
            53.809122,
            49.745442
          ],
          [
            9.636329,
            53.809004,
            49.370682
          ],
          [
            9.636698,
            53.808868,
            49.245806
          ],
          [
            9.637004,
            53.808736,
            49.598696
          ],
          [
            9.637312,
            53.808612,
            49.945353
          ],
          [
            9.637605,
            53.808479,
            50.289012
          ],
          [
            9.6379,
            53.808349,
            50.631691
          ],
          [
            9.63822,
            53.808241,
            50.97478
          ],
          [
            9.638525,
            53.808102,
            51.333046
          ],
          [
            9.638843,
            53.807968,
            51.696349
          ],
          [
            9.63914,
            53.807831,
            51.894999
          ],
          [
            9.639451,
            53.807694,
            51.793762
          ],
          [
            9.639781,
            53.807536,
            51.682915
          ],
          [
            9.640145,
            53.807398,
            51.57002
          ],
          [
            9.640489,
            53.807252,
            51.459483
          ],
          [
            9.640837,
            53.807108,
            51.348613
          ],
          [
            9.641181,
            53.806977,
            51.241714
          ],
          [
            9.64154,
            53.806835,
            51.142398
          ],
          [
            9.641895,
            53.80668,
            51.362628
          ],
          [
            9.642154,
            53.806566,
            51.523886
          ],
          [
            9.642419,
            53.806464,
            51.681899
          ],
          [
            9.642758,
            53.806297,
            51.902117
          ],
          [
            9.643088,
            53.806167,
            52.100195
          ],
          [
            9.643378,
            53.806034,
            52.283534
          ],
          [
            9.643656,
            53.805902,
            52.461475
          ],
          [
            9.643972,
            53.805739,
            52.625498
          ],
          [
            9.644265,
            53.805564,
            52.310632
          ],
          [
            9.644588,
            53.805518,
            52.052573
          ],
          [
            9.644927,
            53.805505,
            51.795989
          ],
          [
            9.645252,
            53.805464,
            51.545114
          ],
          [
            9.645548,
            53.805379,
            51.295825
          ],
          [
            9.645871,
            53.805272,
            51.016087
          ],
          [
            9.646176,
            53.805176,
            50.755225
          ],
          [
            9.646495,
            53.805083,
            50.486564
          ],
          [
            9.646852,
            53.804978,
            50.310184
          ],
          [
            9.64722,
            53.804868,
            50.228993
          ],
          [
            9.647584,
            53.804776,
            50.151003
          ],
          [
            9.647901,
            53.804693,
            50.082724
          ],
          [
            9.648225,
            53.804689,
            50.018846
          ],
          [
            9.648544,
            53.804607,
            49.950364
          ],
          [
            9.648867,
            53.804514,
            49.879617
          ],
          [
            9.649231,
            53.804424,
            49.801915
          ],
          [
            9.649548,
            53.804347,
            49.774173
          ],
          [
            9.649868,
            53.804273,
            49.839339
          ],
          [
            9.650198,
            53.804196,
            49.906646
          ],
          [
            9.650513,
            53.804111,
            49.972314
          ],
          [
            9.650845,
            53.804027,
            50.040816
          ],
          [
            9.651215,
            53.803935,
            50.116937
          ],
          [
            9.651574,
            53.803826,
            50.193551
          ],
          [
            9.651914,
            53.803695,
            50.270543
          ],
          [
            9.652206,
            53.803574,
            50.331108
          ],
          [
            9.652432,
            53.803417,
            50.319785
          ],
          [
            9.652666,
            53.80323,
            50.307018
          ],
          [
            9.652904,
            53.803057,
            50.294721
          ],
          [
            9.653264,
            53.802928,
            50.281077
          ],
          [
            9.653621,
            53.802854,
            50.268809
          ],
          [
            9.65397,
            53.802778,
            50.256756
          ],
          [
            9.654307,
            53.802715,
            50.2453
          ],
          [
            9.654695,
            53.802661,
            50.253303
          ],
          [
            9.655108,
            53.802601,
            50.504342
          ],
          [
            9.655476,
            53.802525,
            50.7345
          ],
          [
            9.655786,
            53.802493,
            50.920598
          ],
          [
            9.656186,
            53.802377,
            51.183627
          ],
          [
            9.656526,
            53.802285,
            51.404598
          ],
          [
            9.656853,
            53.80219,
            51.619721
          ],
          [
            9.657231,
            53.802095,
            51.86227
          ],
          [
            9.657568,
            53.802012,
            52.047474
          ],
          [
            9.657922,
            53.801906,
            52.129275
          ],
          [
            9.658237,
            53.801808,
            52.202654
          ],
          [
            9.658597,
            53.801669,
            52.291305
          ],
          [
            9.658912,
            53.801558,
            52.367004
          ],
          [
            9.659234,
            53.80143,
            52.447003
          ],
          [
            9.659535,
            53.80131,
            52.521853
          ],
          [
            9.659824,
            53.801204,
            52.591972
          ],
          [
            9.660113,
            53.801101,
            52.672313
          ],
          [
            9.660358,
            53.80098,
            52.998771
          ],
          [
            9.660546,
            53.800835,
            53.335187
          ],
          [
            9.660645,
            53.80064,
            53.696366
          ],
          [
            9.660476,
            53.800449,
            54.066248
          ],
          [
            9.660429,
            53.800271,
            54.39085
          ],
          [
            9.660717,
            53.800185,
            54.7204
          ],
          [
            9.660908,
            53.800029,
            55.057672
          ],
          [
            9.660933,
            53.799837,
            55.386825
          ],
          [
            9.660981,
            53.79963,
            55.727077
          ],
          [
            9.661178,
            53.799447,
            55.552231
          ],
          [
            9.661418,
            53.799309,
            55.390392
          ],
          [
            9.661699,
            53.799147,
            55.202666
          ],
          [
            9.661967,
            53.799018,
            55.038143
          ],
          [
            9.662235,
            53.798876,
            54.866562
          ],
          [
            9.662504,
            53.798772,
            54.71355
          ],
          [
            9.662806,
            53.798678,
            54.55074
          ],
          [
            9.66315,
            53.798617,
            54.379247
          ],
          [
            9.663482,
            53.798534,
            54.202799
          ],
          [
            9.663862,
            53.798399,
            53.979072
          ],
          [
            9.664217,
            53.798305,
            53.782535
          ],
          [
            9.664532,
            53.798337,
            53.60163
          ],
          [
            9.664792,
            53.798347,
            53.441156
          ],
          [
            9.665,
            53.798189,
            53.269169
          ],
          [
            9.665208,
            53.798051,
            53.111312
          ],
          [
            9.665434,
            53.797894,
            52.935174
          ],
          [
            9.665669,
            53.797722,
            52.748874
          ],
          [
            9.665882,
            53.79756,
            52.968182
          ],
          [
            9.66609,
            53.797392,
            53.190713
          ],
          [
            9.66628,
            53.797225,
            53.406169
          ],
          [
            9.666502,
            53.797035,
            53.652934
          ],
          [
            9.66672,
            53.796882,
            53.867245
          ],
          [
            9.667043,
            53.79682,
            54.084267
          ],
          [
            9.667389,
            53.796822,
            54.302727
          ],
          [
            9.667736,
            53.796834,
            54.522174
          ],
          [
            9.668145,
            53.796828,
            54.778543
          ],
          [
            9.66842,
            53.796672,
            55.015647
          ],
          [
            9.668626,
            53.796493,
            55.240818
          ],
          [
            9.668811,
            53.796316,
            55.457237
          ],
          [
            9.668991,
            53.796148,
            55.664142
          ],
          [
            9.669216,
            53.795968,
            55.896941
          ],
          [
            9.669449,
            53.795794,
            56.12774
          ],
          [
            9.669687,
            53.795613,
            56.36617
          ],
          [
            9.669898,
            53.795454,
            56.523532
          ],
          [
            9.670154,
            53.795308,
            56.414315
          ],
          [
            9.670439,
            53.795144,
            56.292007
          ],
          [
            9.670653,
            53.794988,
            56.187675
          ],
          [
            9.670939,
            53.794913,
            56.079744
          ],
          [
            9.671265,
            53.795042,
            55.95922
          ],
          [
            9.67156,
            53.79518,
            55.843728
          ],
          [
            9.671886,
            53.795178,
            55.732241
          ],
          [
            9.672072,
            53.794984,
            55.616381
          ],
          [
            9.672306,
            53.79478,
            55.928385
          ],
          [
            9.672525,
            53.794574,
            56.272338
          ],
          [
            9.672734,
            53.794383,
            56.594074
          ],
          [
            9.672931,
            53.794206,
            56.894229
          ],
          [
            9.673131,
            53.794012,
            57.215462
          ],
          [
            9.673369,
            53.793856,
            57.512529
          ],
          [
            9.673629,
            53.793694,
            57.82818
          ],
          [
            9.673915,
            53.793515,
            58.128385
          ],
          [
            9.674183,
            53.793339,
            57.858939
          ],
          [
            9.674428,
            53.793157,
            57.594301
          ],
          [
            9.674682,
            53.792964,
            57.315514
          ],
          [
            9.674875,
            53.792773,
            57.062296
          ],
          [
            9.675061,
            53.79259,
            56.817883
          ],
          [
            9.675218,
            53.792374,
            56.550375
          ],
          [
            9.675364,
            53.792151,
            56.278155
          ],
          [
            9.675508,
            53.791928,
            55.897492
          ],
          [
            9.675642,
            53.791709,
            55.332978
          ],
          [
            9.675795,
            53.791475,
            54.725077
          ],
          [
            9.675886,
            53.791249,
            54.161731
          ],
          [
            9.675928,
            53.791003,
            53.562554
          ],
          [
            9.675972,
            53.79075,
            52.946169
          ],
          [
            9.676013,
            53.790523,
            52.392686
          ],
          [
            9.676045,
            53.790289,
            51.823516
          ],
          [
            9.676081,
            53.790032,
            52.018434
          ],
          [
            9.676127,
            53.789781,
            52.325605
          ],
          [
            9.676169,
            53.789518,
            52.647001
          ],
          [
            9.676217,
            53.789325,
            52.884485
          ],
          [
            9.676239,
            53.789137,
            53.114087
          ],
          [
            9.676314,
            53.788899,
            53.40868
          ],
          [
            9.676479,
            53.788673,
            53.708137
          ],
          [
            9.676617,
            53.788464,
            53.957238
          ],
          [
            9.676729,
            53.788265,
            54.087119
          ],
          [
            9.67685,
            53.788051,
            54.226802
          ],
          [
            9.676989,
            53.787829,
            54.373298
          ],
          [
            9.677157,
            53.787625,
            54.513882
          ],
          [
            9.677365,
            53.787435,
            54.65393
          ],
          [
            9.677598,
            53.787272,
            54.78614
          ],
          [
            9.677864,
            53.787112,
            54.925983
          ],
          [
            9.677949,
            53.786888,
            54.994526
          ],
          [
            9.678088,
            53.786647,
            54.634962
          ],
          [
            9.678326,
            53.786438,
            54.279247
          ],
          [
            9.678475,
            53.786268,
            54.008917
          ],
          [
            9.678657,
            53.786069,
            53.689523
          ],
          [
            9.678844,
            53.785865,
            53.361773
          ],
          [
            9.679038,
            53.785673,
            53.045269
          ],
          [
            9.679278,
            53.78547,
            52.695475
          ],
          [
            9.679586,
            53.785287,
            52.356153
          ],
          [
            9.679891,
            53.785149,
            52.082291
          ],
          [
            9.680127,
            53.785014,
            51.847988
          ],
          [
            9.680188,
            53.785031,
            51.606911
          ],
          [
            9.680083,
            53.785198,
            51.372698
          ],
          [
            9.680436,
            53.78526,
            51.091
          ],
          [
            9.680802,
            53.78521,
            50.823214
          ],
          [
            9.681203,
            53.785166,
            50.532477
          ],
          [
            9.681647,
            53.785138,
            50.267931
          ],
          [
            9.682019,
            53.7851,
            50.118219
          ],
          [
            9.682338,
            53.785051,
            49.98761
          ],
          [
            9.68269,
            53.784989,
            49.842145
          ],
          [
            9.683036,
            53.784928,
            49.699155
          ],
          [
            9.683346,
            53.784844,
            49.564034
          ],
          [
            9.683641,
            53.784778,
            49.439085
          ],
          [
            9.684041,
            53.784753,
            49.278429
          ],
          [
            9.684414,
            53.784802,
            49.131191
          ],
          [
            9.684763,
            53.784874,
            49.172196
          ],
          [
            9.685091,
            53.784972,
            49.212987
          ],
          [
            9.685399,
            53.78509,
            49.253725
          ],
          [
            9.685659,
            53.785209,
            49.290222
          ],
          [
            9.685984,
            53.785336,
            49.333445
          ],
          [
            9.686328,
            53.785434,
            49.375879
          ],
          [
            9.68667,
            53.785535,
            49.418301
          ],
          [
            9.68703,
            53.785608,
            49.460506
          ],
          [
            9.687331,
            53.785676,
            49.649629
          ],
          [
            9.687617,
            53.785757,
            49.874639
          ],
          [
            9.687929,
            53.785827,
            50.114295
          ],
          [
            9.688236,
            53.785903,
            50.350394
          ],
          [
            9.688567,
            53.785956,
            50.594235
          ],
          [
            9.68892,
            53.785965,
            50.845147
          ],
          [
            9.689236,
            53.785957,
            51.069478
          ],
          [
            9.689636,
            53.785935,
            51.354447
          ],
          [
            9.689783,
            53.785797,
            51.57469
          ],
          [
            9.690035,
            53.7859,
            51.657865
          ],
          [
            9.690398,
            53.78595,
            51.704206
          ],
          [
            9.690787,
            53.785973,
            51.752748
          ],
          [
            9.691218,
            53.785978,
            51.806323
          ],
          [
            9.691607,
            53.785874,
            51.859419
          ],
          [
            9.69182,
            53.785683,
            51.908389
          ],
          [
            9.69196,
            53.785489,
            51.952669
          ],
          [
            9.692076,
            53.785253,
            52.004253
          ],
          [
            9.6922,
            53.785052,
            51.607309
          ],
          [
            9.692323,
            53.784883,
            51.262751
          ],
          [
            9.692466,
            53.784675,
            50.842222
          ],
          [
            9.69258,
            53.784484,
            50.463058
          ],
          [
            9.692712,
            53.784248,
            49.997729
          ],
          [
            9.692884,
            53.784047,
            49.57604
          ],
          [
            9.693092,
            53.783864,
            49.162018
          ],
          [
            9.693324,
            53.783649,
            48.684629
          ],
          [
            9.693539,
            53.783474,
            49.0805
          ],
          [
            9.693763,
            53.783304,
            49.582134
          ],
          [
            9.693971,
            53.783164,
            50.014407
          ],
          [
            9.694223,
            53.783044,
            50.458037
          ],
          [
            9.694511,
            53.782921,
            50.945367
          ],
          [
            9.694791,
            53.782794,
            51.429797
          ],
          [
            9.695114,
            53.782692,
            51.93221
          ],
          [
            9.69547,
            53.782577,
            52.488398
          ],
          [
            9.695819,
            53.782493,
            52.615556
          ],
          [
            9.696058,
            53.782369,
            52.178485
          ],
          [
            9.696318,
            53.782253,
            51.73385
          ],
          [
            9.696565,
            53.782131,
            51.291673
          ],
          [
            9.696779,
            53.781967,
            50.813418
          ],
          [
            9.696971,
            53.781797,
            50.34139
          ],
          [
            9.697152,
            53.781627,
            49.877392
          ],
          [
            9.697309,
            53.781451,
            49.417502
          ],
          [
            9.6975,
            53.781271,
            48.926862
          ],
          [
            9.69769,
            53.781064,
            48.650203
          ],
          [
            9.697858,
            53.78088,
            48.639804
          ],
          [
            9.697983,
            53.780703,
            48.630241
          ],
          [
            9.698117,
            53.780468,
            48.617892
          ],
          [
            9.698234,
            53.780257,
            48.606849
          ],
          [
            9.698342,
            53.780076,
            48.597304
          ],
          [
            9.698467,
            53.779874,
            48.586605
          ],
          [
            9.698591,
            53.779673,
            48.575966
          ],
          [
            9.698721,
            53.779434,
            48.642505
          ],
          [
            9.698819,
            53.779206,
            48.922339
          ],
          [
            9.698898,
            53.778983,
            49.193827
          ],
          [
            9.698948,
            53.778768,
            49.452091
          ],
          [
            9.698999,
            53.778534,
            49.732812
          ],
          [
            9.699042,
            53.778275,
            50.042505
          ],
          [
            9.699106,
            53.778047,
            50.317833
          ],
          [
            9.699303,
            53.777864,
            50.578132
          ],
          [
            9.699598,
            53.777685,
            50.501112
          ],
          [
            9.699864,
            53.7775,
            50.1507
          ],
          [
            9.700142,
            53.77732,
            49.799225
          ],
          [
            9.700351,
            53.77716,
            49.507333
          ],
          [
            9.700616,
            53.777137,
            49.237545
          ],
          [
            9.700923,
            53.777253,
            48.927017
          ],
          [
            9.70124,
            53.777352,
            48.621118
          ],
          [
            9.701585,
            53.777436,
            48.30303
          ],
          [
            9.701894,
            53.777498,
            48.362134
          ],
          [
            9.702199,
            53.777541,
            49.118695
          ],
          [
            9.702534,
            53.777575,
            49.940923
          ],
          [
            9.702859,
            53.777589,
            50.726847
          ],
          [
            9.703205,
            53.777605,
            51.563946
          ],
          [
            9.70354,
            53.777629,
            52.377873
          ],
          [
            9.7039,
            53.777626,
            53.24623
          ],
          [
            9.704243,
            53.777633,
            54.074774
          ],
          [
            9.704594,
            53.777642,
            54.922194
          ],
          [
            9.704963,
            53.777651,
            55.369246
          ],
          [
            9.705316,
            53.777663,
            55.16915
          ],
          [
            9.705703,
            53.777685,
            54.949113
          ],
          [
            9.706074,
            53.77771,
            54.737792
          ],
          [
            9.706446,
            53.777756,
            54.522763
          ],
          [
            9.706801,
            53.777812,
            54.314804
          ],
          [
            9.70716,
            53.77787,
            54.104173
          ],
          [
            9.707524,
            53.777964,
            53.879273
          ],
          [
            9.70785,
            53.77804,
            53.644061
          ],
          [
            9.708204,
            53.778156,
            53.248607
          ],
          [
            9.708554,
            53.778297,
            52.833862
          ],
          [
            9.708861,
            53.778399,
            52.489726
          ],
          [
            9.709118,
            53.778515,
            52.173731
          ],
          [
            9.70938,
            53.778636,
            51.847927
          ],
          [
            9.70966,
            53.778779,
            51.48592
          ],
          [
            9.709918,
            53.778909,
            51.154692
          ],
          [
            9.710148,
            53.779052,
            50.828104
          ],
          [
            9.710442,
            53.779244,
            50.649048
          ],
          [
            9.71072,
            53.779446,
            50.517996
          ],
          [
            9.710969,
            53.779637,
            50.39677
          ],
          [
            9.711188,
            53.779839,
            50.276174
          ],
          [
            9.711428,
            53.780036,
            50.154076
          ],
          [
            9.711668,
            53.780229,
            50.033657
          ],
          [
            9.711875,
            53.780415,
            49.921746
          ],
          [
            9.712064,
            53.780598,
            49.740659
          ],
          [
            9.71226,
            53.780779,
            49.434671
          ],
          [
            9.712445,
            53.780938,
            49.159909
          ],
          [
            9.712632,
            53.781099,
            48.881807
          ],
          [
            9.712809,
            53.781268,
            48.598295
          ],
          [
            9.713013,
            53.781445,
            48.293353
          ],
          [
            9.713226,
            53.781637,
            47.966302
          ],
          [
            9.71342,
            53.781819,
            47.660027
          ],
          [
            9.713609,
            53.782017,
            47.336157
          ],
          [
            9.713827,
            53.782207,
            47.505055
          ],
          [
            9.714044,
            53.782393,
            47.745782
          ],
          [
            9.714258,
            53.782586,
            47.991655
          ],
          [
            9.714481,
            53.782777,
            48.238907
          ],
          [
            9.714719,
            53.782962,
            48.487144
          ],
          [
            9.714957,
            53.783136,
            48.725775
          ],
          [
            9.715231,
            53.783295,
            48.96757
          ],
          [
            9.715499,
            53.783444,
            49.199285
          ],
          [
            9.715787,
            53.783565,
            49.560818
          ],
          [
            9.716101,
            53.783676,
            49.941721
          ],
          [
            9.716416,
            53.783775,
            50.313154
          ],
          [
            9.716763,
            53.783867,
            50.709017
          ],
          [
            9.717122,
            53.783964,
            51.120417
          ],
          [
            9.717482,
            53.784035,
            51.51672
          ],
          [
            9.717846,
            53.784101,
            51.913562
          ],
          [
            9.718194,
            53.784165,
            52.294771
          ],
          [
            9.718616,
            53.784224,
            52.681629
          ],
          [
            9.718959,
            53.784304,
            52.998161
          ],
          [
            9.719324,
            53.784371,
            53.32609
          ],
          [
            9.7197,
            53.784452,
            53.669358
          ],
          [
            9.720091,
            53.784538,
            54.027446
          ],
          [
            9.720438,
            53.784624,
            54.350189
          ],
          [
            9.720839,
            53.784718,
            54.720205
          ],
          [
            9.721223,
            53.784806,
            54.977446
          ],
          [
            9.721594,
            53.784892,
            54.930928
          ],
          [
            9.721952,
            53.785001,
            54.883921
          ],
          [
            9.722294,
            53.785113,
            54.838279
          ],
          [
            9.722626,
            53.785221,
            54.794023
          ],
          [
            9.722958,
            53.785329,
            54.749783
          ],
          [
            9.723297,
            53.785443,
            54.704256
          ],
          [
            9.723637,
            53.785552,
            54.659106
          ],
          [
            9.723945,
            53.785664,
            54.728644
          ],
          [
            9.724234,
            53.785768,
            54.952917
          ],
          [
            9.724555,
            53.785875,
            55.197331
          ],
          [
            9.724867,
            53.785996,
            55.445198
          ],
          [
            9.725144,
            53.786095,
            55.659812
          ],
          [
            9.725437,
            53.78616,
            55.867308
          ],
          [
            9.725727,
            53.786251,
            56.085269
          ],
          [
            9.72603,
            53.786393,
            56.341657
          ],
          [
            9.726345,
            53.786522,
            56.595759
          ],
          [
            9.726707,
            53.786601,
            56.318398
          ],
          [
            9.727069,
            53.786721,
            55.861415
          ],
          [
            9.727418,
            53.786816,
            55.438309
          ],
          [
            9.72778,
            53.786917,
            54.997442
          ],
          [
            9.728123,
            53.786981,
            54.601307
          ],
          [
            9.728484,
            53.787055,
            54.180542
          ],
          [
            9.728891,
            53.787122,
            53.715275
          ],
          [
            9.72927,
            53.787162,
            53.30082
          ],
          [
            9.729674,
            53.787218,
            53.35965
          ],
          [
            9.73006,
            53.78727,
            53.415796
          ],
          [
            9.730449,
            53.787339,
            53.473442
          ],
          [
            9.730856,
            53.787386,
            53.532262
          ],
          [
            9.731244,
            53.787438,
            53.588702
          ],
          [
            9.731602,
            53.787488,
            53.640871
          ],
          [
            9.731958,
            53.78753,
            53.692347
          ],
          [
            9.732334,
            53.787582,
            53.797191
          ],
          [
            9.732757,
            53.787642,
            54.054874
          ],
          [
            9.733156,
            53.787683,
            54.295138
          ],
          [
            9.733573,
            53.787739,
            54.54846
          ],
          [
            9.733942,
            53.787785,
            54.771856
          ],
          [
            9.734359,
            53.787816,
            55.021618
          ],
          [
            9.734689,
            53.787873,
            55.225256
          ],
          [
            9.73502,
            53.787918,
            55.426428
          ],
          [
            9.735338,
            53.787977,
            55.401677
          ],
          [
            9.735703,
            53.788022,
            55.072754
          ],
          [
            9.736051,
            53.788077,
            54.75515
          ],
          [
            9.736398,
            53.7881,
            54.446947
          ],
          [
            9.736791,
            53.788111,
            54.099779
          ],
          [
            9.7372,
            53.788091,
            53.737923
          ],
          [
            9.737278,
            53.78815,
            53.43071
          ],
          [
            9.737304,
            53.788372,
            53.098118
          ],
          [
            9.737381,
            53.788587,
            52.862236
          ],
          [
            9.737593,
            53.788753,
            52.906625
          ],
          [
            9.737802,
            53.788911,
            52.949416
          ],
          [
            9.738009,
            53.789063,
            52.991085
          ],
          [
            9.738255,
            53.78921,
            53.03519
          ],
          [
            9.738529,
            53.789379,
            53.085111
          ],
          [
            9.73875,
            53.789536,
            53.128668
          ],
          [
            9.738999,
            53.789709,
            53.177136
          ],
          [
            9.739288,
            53.789886,
            53.229608
          ],
          [
            9.739498,
            53.790065,
            53.251203
          ],
          [
            9.739769,
            53.79026,
            53.273168
          ],
          [
            9.739965,
            53.790406,
            53.289393
          ],
          [
            9.74019,
            53.790579,
            53.308452
          ],
          [
            9.740432,
            53.790743,
            53.327446
          ],
          [
            9.740726,
            53.790874,
            53.34651
          ],
          [
            9.741085,
            53.790941,
            53.365873
          ],
          [
            9.741383,
            53.791035,
            53.383272
          ],
          [
            9.741831,
            53.79115,
            53.292252
          ],
          [
            9.742192,
            53.79122,
            53.18446
          ],
          [
            9.742511,
            53.791294,
            53.087066
          ],
          [
            9.742859,
            53.791384,
            52.97929
          ],
          [
            9.743237,
            53.791485,
            52.861668
          ],
          [
            9.743627,
            53.791616,
            52.734466
          ],
          [
            9.743801,
            53.791778,
            52.633278
          ],
          [
            9.743642,
            53.791961,
            52.534552
          ],
          [
            9.74379,
            53.791771,
            52.700522
          ],
          [
            9.74413,
            53.791794,
            52.882219
          ],
          [
            9.744359,
            53.791772,
            53.052872
          ],
          [
            9.744409,
            53.791587,
            53.218439
          ],
          [
            9.744502,
            53.791399,
            53.393286
          ],
          [
            9.744654,
            53.791232,
            53.560884
          ],
          [
            9.744787,
            53.791028,
            53.754533
          ],
          [
            9.744869,
            53.790799,
            53.96149
          ],
          [
            9.744919,
            53.790562,
            54.006617
          ],
          [
            9.745009,
            53.790348,
            53.624302
          ],
          [
            9.7451,
            53.790159,
            53.284102
          ],
          [
            9.745203,
            53.789932,
            52.876958
          ],
          [
            9.745287,
            53.789726,
            52.510172
          ],
          [
            9.745393,
            53.789533,
            52.157659
          ],
          [
            9.745488,
            53.78934,
            51.809761
          ],
          [
            9.745548,
            53.789122,
            51.426847
          ],
          [
            9.745567,
            53.788893,
            51.030013
          ],
          [
            9.745652,
            53.788687,
            51.828874
          ],
          [
            9.745713,
            53.788481,
            52.706871
          ],
          [
            9.745826,
            53.788282,
            53.588806
          ],
          [
            9.745949,
            53.78808,
            54.492323
          ],
          [
            9.746014,
            53.787896,
            55.289376
          ],
          [
            9.746094,
            53.7877,
            56.137077
          ],
          [
            9.746196,
            53.787517,
            56.947737
          ],
          [
            9.746455,
            53.787404,
            57.815575
          ],
          [
            9.746823,
            53.787361,
            58.575837
          ],
          [
            9.747228,
            53.787326,
            58.693912
          ],
          [
            9.747647,
            53.787295,
            58.815799
          ],
          [
            9.748016,
            53.787281,
            58.922492
          ],
          [
            9.748395,
            53.787252,
            59.033042
          ],
          [
            9.748795,
            53.78722,
            59.149649
          ],
          [
            9.7492,
            53.7872,
            59.266888
          ],
          [
            9.749525,
            53.787173,
            59.361747
          ],
          [
            9.749875,
            53.787189,
            59.037783
          ],
          [
            9.75032,
            53.787155,
            57.435281
          ],
          [
            9.750783,
            53.787103,
            55.751992
          ],
          [
            9.751106,
            53.787096,
            54.597637
          ],
          [
            9.751501,
            53.787072,
            53.178625
          ],
          [
            9.751845,
            53.787052,
            51.943896
          ],
          [
            9.752172,
            53.787037,
            50.76794
          ],
          [
            9.752609,
            53.787008,
            49.197408
          ],
          [
            9.753013,
            53.786974,
            48.570553
          ],
          [
            9.753351,
            53.786924,
            48.588993
          ],
          [
            9.753675,
            53.786876,
            48.606662
          ],
          [
            9.754048,
            53.78682,
            48.62702
          ],
          [
            9.754355,
            53.786782,
            48.643607
          ],
          [
            9.754658,
            53.786723,
            48.660464
          ],
          [
            9.754983,
            53.786663,
            48.67846
          ],
          [
            9.755351,
            53.786598,
            48.698755
          ],
          [
            9.755683,
            53.786575,
            48.716502
          ],
          [
            9.756032,
            53.786597,
            48.86555
          ],
          [
            9.756367,
            53.786636,
            49.033461
          ],
          [
            9.756685,
            53.78667,
            49.192143
          ],
          [
            9.757026,
            53.786645,
            49.362892
          ],
          [
            9.757299,
            53.786771,
            49.533123
          ],
          [
            9.75766,
            53.786809,
            49.713084
          ],
          [
            9.757986,
            53.786848,
            49.876396
          ],
          [
            9.758357,
            53.786899,
            50.063376
          ],
          [
            9.758705,
            53.786923,
            50.221532
          ],
          [
            9.759046,
            53.786966,
            50.285896
          ],
          [
            9.759393,
            53.786986,
            50.350257
          ],
          [
            9.759741,
            53.78704,
            50.416759
          ],
          [
            9.760052,
            53.787085,
            50.475851
          ],
          [
            9.760417,
            53.78714,
            50.545366
          ],
          [
            9.760794,
            53.787191,
            50.616749
          ],
          [
            9.761146,
            53.787249,
            50.684244
          ],
          [
            9.761484,
            53.787296,
            50.748336
          ],
          [
            9.761822,
            53.787339,
            51.013957
          ],
          [
            9.762154,
            53.787382,
            51.417333
          ],
          [
            9.762479,
            53.787439,
            51.819848
          ],
          [
            9.762188,
            53.787466,
            52.190798
          ],
          [
            9.762148,
            53.787509,
            52.570773
          ],
          [
            9.762108,
            53.787497,
            52.911856
          ],
          [
            9.762557,
            53.787521,
            53.45046
          ],
          [
            9.762912,
            53.787564,
            53.880543
          ],
          [
            9.763247,
            53.78762,
            54.298953
          ],
          [
            9.763616,
            53.787671,
            54.415432
          ],
          [
            9.76391,
            53.787734,
            54.446043
          ],
          [
            9.764333,
            53.787829,
            54.490334
          ],
          [
            9.764717,
            53.787932,
            54.531744
          ],
          [
            9.765125,
            53.788023,
            54.57449
          ],
          [
            9.765492,
            53.78811,
            54.613195
          ],
          [
            9.765853,
            53.788215,
            54.652583
          ],
          [
            9.766162,
            53.788312,
            54.663215
          ],
          [
            9.766445,
            53.788404,
            54.485973
          ],
          [
            9.766755,
            53.788496,
            54.295645
          ],
          [
            9.767083,
            53.788571,
            54.101794
          ],
          [
            9.767451,
            53.788631,
            53.891854
          ],
          [
            9.767817,
            53.788692,
            53.68323
          ],
          [
            9.768186,
            53.788779,
            53.465218
          ],
          [
            9.768499,
            53.78884,
            53.28254
          ],
          [
            9.768801,
            53.788908,
            53.105151
          ],
          [
            9.769217,
            53.788984,
            53.316264
          ],
          [
            9.769617,
            53.789025,
            53.778733
          ],
          [
            9.769972,
            53.789078,
            54.194137
          ],
          [
            9.770294,
            53.789056,
            54.562424
          ],
          [
            9.770686,
            53.789054,
            55.008909
          ],
          [
            9.771077,
            53.78908,
            55.455112
          ],
          [
            9.771439,
            53.789172,
            55.902074
          ],
          [
            9.771782,
            53.789237,
            56.311218
          ],
          [
            9.772113,
            53.789284,
            56.616705
          ],
          [
            9.772415,
            53.789372,
            56.862452
          ],
          [
            9.772692,
            53.789483,
            57.111119
          ],
          [
            9.772972,
            53.789607,
            57.367704
          ],
          [
            9.773285,
            53.789712,
            57.630596
          ],
          [
            9.77362,
            53.789814,
            57.906083
          ],
          [
            9.773942,
            53.789858,
            58.147553
          ],
          [
            9.774307,
            53.789919,
            58.424411
          ],
          [
            9.77468,
            53.789973,
            58.679001
          ],
          [
            9.774985,
            53.789876,
            58.548421
          ],
          [
            9.775062,
            53.789628,
            58.40833
          ],
          [
            9.775153,
            53.789391,
            58.273273
          ],
          [
            9.775222,
            53.789182,
            58.15494
          ],
          [
            9.775393,
            53.788995,
            58.036856
          ],
          [
            9.775623,
            53.78882,
            57.913749
          ],
          [
            9.775942,
            53.788716,
            57.786311
          ],
          [
            9.776352,
            53.788758,
            57.506167
          ],
          [
            9.776652,
            53.788696,
            56.94557
          ],
          [
            9.776812,
            53.788498,
            56.363216
          ],
          [
            9.776939,
            53.7883,
            55.79534
          ],
          [
            9.777042,
            53.78812,
            55.291472
          ],
          [
            9.777167,
            53.787942,
            54.779131
          ],
          [
            9.777361,
            53.787749,
            54.182711
          ],
          [
            9.777511,
            53.787585,
            53.687378
          ],
          [
            9.777747,
            53.787383,
            53.036091
          ],
          [
            9.777858,
            53.787145,
            53.110566
          ],
          [
            9.777958,
            53.786958,
            53.295914
          ],
          [
            9.778119,
            53.786788,
            53.480342
          ],
          [
            9.778401,
            53.786605,
            53.714219
          ],
          [
            9.778643,
            53.786484,
            53.894581
          ],
          [
            9.778995,
            53.786398,
            54.109895
          ],
          [
            9.779348,
            53.786319,
            54.320724
          ],
          [
            9.779703,
            53.786266,
            54.525281
          ],
          [
            9.780076,
            53.786188,
            54.653098
          ],
          [
            9.780451,
            53.78611,
            54.712636
          ],
          [
            9.780832,
            53.786009,
            54.775415
          ],
          [
            9.781243,
            53.785946,
            54.839004
          ],
          [
            9.781659,
            53.785883,
            54.903317
          ],
          [
            9.782064,
            53.785806,
            54.96731
          ],
          [
            9.78249,
            53.785737,
            55.033536
          ],
          [
            9.782875,
            53.785666,
            55.029336
          ],
          [
            9.783261,
            53.785571,
            54.883004
          ],
          [
            9.783618,
            53.785514,
            54.753531
          ],
          [
            9.783944,
            53.785431,
            54.628746
          ],
          [
            9.78423,
            53.78536,
            54.518923
          ],
          [
            9.784561,
            53.785275,
            54.391734
          ],
          [
            9.784943,
            53.785167,
            54.243096
          ],
          [
            9.785341,
            53.785041,
            54.085142
          ],
          [
            9.785654,
            53.784941,
            53.943371
          ],
          [
            9.786008,
            53.784816,
            53.747795
          ],
          [
            9.786334,
            53.784696,
            53.566445
          ],
          [
            9.78667,
            53.784588,
            53.386069
          ],
          [
            9.786991,
            53.784463,
            53.204627
          ],
          [
            9.787334,
            53.784353,
            53.02059
          ],
          [
            9.787655,
            53.784255,
            52.850075
          ],
          [
            9.787686,
            53.784443,
            52.696038
          ],
          [
            9.787628,
            53.78462,
            52.693496
          ],
          [
            9.787788,
            53.784816,
            53.171471
          ],
          [
            9.788093,
            53.784829,
            53.652377
          ],
          [
            9.788447,
            53.78471,
            54.180887
          ],
          [
            9.788766,
            53.784615,
            54.644426
          ],
          [
            9.789077,
            53.78453,
            55.089054
          ],
          [
            9.789319,
            53.784405,
            55.509129
          ],
          [
            9.789079,
            53.784527,
            55.943177
          ],
          [
            9.788748,
            53.784627,
            56.425709
          ],
          [
            9.788576,
            53.784776,
            56.428195
          ],
          [
            9.788456,
            53.78468,
            56.25915
          ],
          [
            9.788132,
            53.784766,
            56.115027
          ],
          [
            9.787798,
            53.784842,
            55.969213
          ],
          [
            9.787541,
            53.784688,
            55.820107
          ],
          [
            9.787356,
            53.784525,
            55.685516
          ],
          [
            9.787459,
            53.784359,
            55.547903
          ],
          [
            9.78774,
            53.784242,
            55.407958
          ],
          [
            9.788052,
            53.784144,
            55.329154
          ],
          [
            9.788381,
            53.784047,
            55.544042
          ],
          [
            9.788656,
            53.783958,
            55.727291
          ],
          [
            9.788931,
            53.783861,
            55.914902
          ],
          [
            9.789221,
            53.783771,
            56.106354
          ],
          [
            9.789518,
            53.783675,
            56.304319
          ],
          [
            9.789839,
            53.783578,
            56.515022
          ],
          [
            9.790104,
            53.783486,
            56.694698
          ],
          [
            9.790476,
            53.783393,
            56.930883
          ],
          [
            9.790752,
            53.783297,
            57.044363
          ],
          [
            9.791032,
            53.783208,
            56.945132
          ],
          [
            9.791372,
            53.783113,
            56.827686
          ],
          [
            9.79171,
            53.783095,
            56.721471
          ],
          [
            9.792061,
            53.783138,
            56.609598
          ],
          [
            9.792425,
            53.783222,
            56.487563
          ],
          [
            9.792753,
            53.783315,
            56.374001
          ],
          [
            9.793043,
            53.783389,
            56.275247
          ],
          [
            9.793344,
            53.78348,
            56.16969
          ],
          [
            9.793652,
            53.783584,
            56.120235
          ],
          [
            9.793974,
            53.783682,
            56.120626
          ],
          [
            9.794266,
            53.783789,
            56.120996
          ],
          [
            9.794576,
            53.783879,
            56.121369
          ],
          [
            9.794918,
            53.783974,
            56.121776
          ],
          [
            9.795216,
            53.784062,
            56.122135
          ],
          [
            9.795484,
            53.784171,
            56.122485
          ],
          [
            9.795768,
            53.784267,
            56.122838
          ],
          [
            9.796059,
            53.78435,
            56.123186
          ],
          [
            9.796381,
            53.784411,
            56.09193
          ],
          [
            9.796697,
            53.784448,
            56.048051
          ],
          [
            9.797005,
            53.784469,
            56.005884
          ],
          [
            9.797333,
            53.784443,
            55.960815
          ],
          [
            9.797651,
            53.784371,
            55.91448
          ],
          [
            9.797948,
            53.784287,
            55.86968
          ],
          [
            9.798287,
            53.784176,
            55.816968
          ],
          [
            9.798597,
            53.784089,
            55.770295
          ],
          [
            9.798902,
            53.783992,
            55.723181
          ],
          [
            9.799207,
            53.783913,
            55.976074
          ],
          [
            9.79953,
            53.78382,
            56.390498
          ],
          [
            9.799641,
            53.783633,
            56.826827
          ],
          [
            9.799893,
            53.78371,
            57.194672
          ],
          [
            9.800209,
            53.783648,
            57.580082
          ],
          [
            9.800566,
            53.783608,
            57.999204
          ],
          [
            9.800944,
            53.783578,
            58.439105
          ],
          [
            9.8013,
            53.783555,
            58.852185
          ],
          [
            9.801678,
            53.783531,
            59.231783
          ],
          [
            9.80205,
            53.78351,
            59.300721
          ],
          [
            9.802401,
            53.783493,
            59.365658
          ],
          [
            9.802777,
            53.783481,
            59.435111
          ],
          [
            9.803156,
            53.783487,
            59.505045
          ],
          [
            9.803465,
            53.783462,
            59.562625
          ],
          [
            9.803838,
            53.783423,
            59.632471
          ],
          [
            9.804156,
            53.783429,
            59.691135
          ],
          [
            9.804481,
            53.783432,
            59.751107
          ],
          [
            9.80482,
            53.783472,
            59.659351
          ],
          [
            9.805147,
            53.783511,
            59.431872
          ],
          [
            9.805483,
            53.783547,
            59.198933
          ],
          [
            9.805824,
            53.783573,
            58.964484
          ],
          [
            9.806182,
            53.783618,
            58.714907
          ],
          [
            9.806528,
            53.783662,
            58.473428
          ],
          [
            9.80687,
            53.783708,
            58.234213
          ],
          [
            9.807193,
            53.783751,
            58.008434
          ],
          [
            9.807515,
            53.783777,
            57.78683
          ],
          [
            9.807836,
            53.783815,
            57.726706
          ],
          [
            9.808191,
            53.783833,
            57.761983
          ],
          [
            9.808552,
            53.783882,
            57.79862
          ],
          [
            9.80891,
            53.783929,
            57.834891
          ],
          [
            9.809294,
            53.78397,
            57.873485
          ],
          [
            9.80967,
            53.784001,
            57.911035
          ],
          [
            9.810012,
            53.784046,
            57.945689
          ],
          [
            9.810342,
            53.784098,
            57.979478
          ],
          [
            9.810665,
            53.784146,
            57.995644
          ],
          [
            9.811008,
            53.784192,
            57.920454
          ],
          [
            9.811348,
            53.784228,
            57.846616
          ],
          [
            9.811682,
            53.784259,
            57.774344
          ],
          [
            9.812091,
            53.784323,
            57.683884
          ],
          [
            9.812468,
            53.784369,
            57.601579
          ],
          [
            9.812771,
            53.784406,
            57.535435
          ],
          [
            9.813125,
            53.78445,
            57.458107
          ],
          [
            9.813448,
            53.784488,
            57.387648
          ],
          [
            9.81379,
            53.784516,
            57.370847
          ],
          [
            9.814114,
            53.784552,
            57.394816
          ],
          [
            9.814449,
            53.784597,
            57.419809
          ],
          [
            9.814793,
            53.78465,
            57.445653
          ],
          [
            9.81515,
            53.784685,
            57.471964
          ],
          [
            9.815513,
            53.784725,
            57.498808
          ],
          [
            9.81586,
            53.78475,
            57.524221
          ],
          [
            9.816246,
            53.784798,
            57.552917
          ],
          [
            9.816612,
            53.784848,
            57.589527
          ],
          [
            9.816977,
            53.784904,
            57.717705
          ],
          [
            9.817302,
            53.784943,
            57.830298
          ],
          [
            9.817637,
            53.784983,
            57.946397
          ],
          [
            9.817964,
            53.785018,
            58.059217
          ],
          [
            9.818293,
            53.785062,
            58.173724
          ],
          [
            9.81864,
            53.785136,
            58.298953
          ],
          [
            9.818945,
            53.785185,
            58.406309
          ],
          [
            9.819255,
            53.785234,
            58.515352
          ],
          [
            9.819599,
            53.785272,
            58.600258
          ],
          [
            9.819942,
            53.785338,
            58.543929
          ],
          [
            9.820271,
            53.785417,
            58.488469
          ],
          [
            9.820579,
            53.785508,
            58.434696
          ],
          [
            9.820908,
            53.785608,
            58.37692
          ],
          [
            9.821223,
            53.7857,
            58.322027
          ],
          [
            9.821515,
            53.785802,
            58.26904
          ],
          [
            9.821823,
            53.785893,
            58.2152
          ],
          [
            9.82213,
            53.785994,
            58.160295
          ],
          [
            9.822432,
            53.786073,
            58.33633
          ],
          [
            9.822773,
            53.786149,
            58.762017
          ],
          [
            9.823077,
            53.786194,
            59.12807
          ],
          [
            9.823395,
            53.786232,
            59.507376
          ],
          [
            9.823711,
            53.786246,
            59.879247
          ],
          [
            9.824036,
            53.786258,
            60.260023
          ],
          [
            9.824345,
            53.786279,
            60.623345
          ],
          [
            9.824665,
            53.786293,
            60.998019
          ],
          [
            9.825024,
            53.786305,
            61.417918
          ],
          [
            9.825344,
            53.786323,
            61.718039
          ],
          [
            9.825709,
            53.786346,
            61.832487
          ],
          [
            9.826083,
            53.786381,
            61.950597
          ],
          [
            9.826445,
            53.786402,
            62.063978
          ],
          [
            9.826781,
            53.786419,
            62.169266
          ],
          [
            9.82716,
            53.786436,
            62.287743
          ],
          [
            9.827464,
            53.786457,
            62.383187
          ],
          [
            9.827818,
            53.786465,
            62.493613
          ],
          [
            9.828168,
            53.786481,
            62.603056
          ],
          [
            9.82851,
            53.786502,
            62.526691
          ],
          [
            9.828888,
            53.786528,
            62.33905
          ],
          [
            9.829235,
            53.786561,
            62.16537
          ],
          [
            9.829599,
            53.78657,
            61.985734
          ],
          [
            9.829913,
            53.786584,
            61.830462
          ],
          [
            9.830247,
            53.786572,
            61.664786
          ],
          [
            9.830589,
            53.786591,
            61.495409
          ],
          [
            9.830924,
            53.786626,
            61.327665
          ],
          [
            9.83132,
            53.786673,
            61.166537
          ],
          [
            9.831711,
            53.786709,
            61.72995
          ],
          [
            9.832093,
            53.786752,
            62.28367
          ],
          [
            9.832402,
            53.786787,
            62.731662
          ],
          [
            9.832787,
            53.786819,
            63.285331
          ],
          [
            9.833009,
            53.786666,
            63.783817
          ],
          [
            9.833215,
            53.786495,
            64.289954
          ],
          [
            9.83342,
            53.786319,
            64.804897
          ],
          [
            9.83361,
            53.786141,
            65.312634
          ],
          [
            9.833782,
            53.785988,
            65.668491
          ],
          [
            9.834014,
            53.785802,
            66.054177
          ],
          [
            9.834212,
            53.785623,
            66.411077
          ],
          [
            9.834432,
            53.785451,
            66.771568
          ],
          [
            9.834616,
            53.785285,
            67.102755
          ],
          [
            9.834835,
            53.785094,
            67.487912
          ],
          [
            9.835051,
            53.784938,
            67.824896
          ],
          [
            9.835307,
            53.784827,
            68.138027
          ],
          [
            9.83557,
            53.78466,
            68.439105
          ],
          [
            9.835805,
            53.784509,
            68.188258
          ],
          [
            9.836039,
            53.784362,
            67.94351
          ],
          [
            9.836308,
            53.784207,
            67.673544
          ],
          [
            9.836576,
            53.784068,
            67.415823
          ],
          [
            9.836884,
            53.783981,
            67.171082
          ],
          [
            9.837203,
            53.783876,
            66.909571
          ],
          [
            9.837501,
            53.783797,
            66.675599
          ],
          [
            9.837842,
            53.783715,
            66.412017
          ],
          [
            9.838177,
            53.783633,
            66.297151
          ],
          [
            9.83852,
            53.783562,
            66.301514
          ],
          [
            9.838821,
            53.783459,
            66.30569
          ],
          [
            9.839187,
            53.783389,
            66.310341
          ],
          [
            9.839549,
            53.783355,
            66.314741
          ],
          [
            9.839875,
            53.78326,
            66.319105
          ],
          [
            9.840142,
            53.783147,
            66.323048
          ],
          [
            9.840453,
            53.783058,
            66.327216
          ],
          [
            9.840782,
            53.78305,
            66.331168
          ],
          [
            9.84114,
            53.782956,
            66.63342
          ],
          [
            9.841499,
            53.782886,
            66.933575
          ],
          [
            9.841812,
            53.782772,
            67.223448
          ],
          [
            9.842135,
            53.782717,
            67.487831
          ],
          [
            9.842424,
            53.782604,
            67.75969
          ],
          [
            9.842705,
            53.782465,
            68.047341
          ],
          [
            9.842991,
            53.782356,
            68.314406
          ],
          [
            9.843276,
            53.782273,
            68.565172
          ],
          [
            9.843557,
            53.782138,
            68.64777
          ],
          [
            9.843643,
            53.781918,
            68.48999
          ],
          [
            9.843562,
            53.781725,
            68.351767
          ],
          [
            9.843454,
            53.781529,
            68.208679
          ],
          [
            9.843374,
            53.781295,
            68.042595
          ],
          [
            9.843254,
            53.781067,
            67.876826
          ],
          [
            9.843158,
            53.780871,
            67.735199
          ],
          [
            9.843045,
            53.780685,
            67.598032
          ],
          [
            9.84292,
            53.780471,
            67.427714
          ],
          [
            9.842778,
            53.780263,
            67.204183
          ],
          [
            9.842661,
            53.780054,
            66.984735
          ],
          [
            9.842549,
            53.779846,
            66.767165
          ],
          [
            9.842433,
            53.779631,
            66.54219
          ],
          [
            9.842333,
            53.779425,
            66.328459
          ],
          [
            9.842234,
            53.779214,
            66.110242
          ],
          [
            9.842114,
            53.779003,
            65.8884
          ],
          [
            9.842007,
            53.778819,
            65.694446
          ],
          [
            9.841914,
            53.778624,
            65.770322
          ],
          [
            9.841807,
            53.778425,
            65.873222
          ],
          [
            9.84167,
            53.778221,
            65.98147
          ],
          [
            9.841561,
            53.778044,
            66.074297
          ],
          [
            9.841451,
            53.777867,
            66.167219
          ],
          [
            9.84135,
            53.777687,
            66.260689
          ],
          [
            9.841244,
            53.777501,
            66.357447
          ],
          [
            9.841126,
            53.77732,
            66.453033
          ],
          [
            9.841011,
            53.777126,
            66.554343
          ],
          [
            9.840904,
            53.776915,
            66.377071
          ],
          [
            9.840781,
            53.776674,
            66.139756
          ],
          [
            9.840708,
            53.776463,
            65.936379
          ],
          [
            9.840741,
            53.776216,
            65.701728
          ],
          [
            9.840856,
            53.776006,
            65.493478
          ],
          [
            9.840942,
            53.775818,
            65.309916
          ],
          [
            9.841023,
            53.775639,
            65.135265
          ],
          [
            9.841096,
            53.775455,
            64.957128
          ],
          [
            9.841182,
            53.77527,
            64.880782
          ],
          [
            9.841266,
            53.775066,
            64.904657
          ],
          [
            9.841362,
            53.774859,
            64.929069
          ],
          [
            9.841473,
            53.774649,
            64.954102
          ],
          [
            9.841581,
            53.774445,
            64.97842
          ],
          [
            9.841685,
            53.774221,
            65.004829
          ],
          [
            9.841758,
            53.77401,
            65.029335
          ],
          [
            9.841801,
            53.773831,
            65.049891
          ],
          [
            9.841902,
            53.773634,
            65.073311
          ],
          [
            9.842005,
            53.773444,
            65.292196
          ],
          [
            9.842105,
            53.773234,
            65.538504
          ],
          [
            9.842203,
            53.773018,
            65.790939
          ],
          [
            9.84231,
            53.772805,
            66.041743
          ],
          [
            9.842401,
            53.772614,
            66.26573
          ],
          [
            9.842499,
            53.772432,
            66.481525
          ],
          [
            9.842598,
            53.772237,
            66.7114
          ],
          [
            9.842688,
            53.772042,
            66.939656
          ],
          [
            9.842765,
            53.77185,
            67.030022
          ],
          [
            9.842844,
            53.771663,
            66.75244
          ],
          [
            9.842929,
            53.771479,
            66.477929
          ],
          [
            9.843015,
            53.771289,
            66.194799
          ],
          [
            9.843104,
            53.771083,
            65.888803
          ],
          [
            9.843188,
            53.770883,
            65.592126
          ],
          [
            9.843273,
            53.770688,
            65.302493
          ],
          [
            9.843357,
            53.770487,
            65.00465
          ],
          [
            9.843446,
            53.770303,
            64.729131
          ],
          [
            9.843492,
            53.770112,
            64.632196
          ],
          [
            9.843595,
            53.769915,
            65.152602
          ],
          [
            9.843704,
            53.769708,
            65.699895
          ],
          [
            9.843843,
            53.769513,
            66.23389
          ],
          [
            9.843987,
            53.769314,
            66.780002
          ],
          [
            9.844152,
            53.769129,
            67.307777
          ],
          [
            9.844273,
            53.768928,
            67.846179
          ],
          [
            9.844396,
            53.768752,
            68.327266
          ],
          [
            9.844537,
            53.768554,
            68.869414
          ],
          [
            9.844662,
            53.768356,
            69.143193
          ],
          [
            9.844778,
            53.768181,
            69.262851
          ],
          [
            9.84489,
            53.767978,
            69.399327
          ],
          [
            9.845001,
            53.76778,
            69.53235
          ],
          [
            9.845148,
            53.767577,
            69.674118
          ],
          [
            9.845292,
            53.767382,
            69.809656
          ],
          [
            9.845432,
            53.767161,
            69.959912
          ],
          [
            9.845545,
            53.766963,
            70.093089
          ],
          [
            9.845658,
            53.766758,
            70.072221
          ],
          [
            9.845777,
            53.766564,
            69.506045
          ],
          [
            9.845921,
            53.766379,
            68.94707
          ],
          [
            9.846099,
            53.766229,
            68.444404
          ],
          [
            9.846455,
            53.766231,
            67.860481
          ],
          [
            9.846766,
            53.766136,
            67.268006
          ],
          [
            9.846938,
            53.765965,
            66.722203
          ],
          [
            9.847199,
            53.765846,
            66.183681
          ],
          [
            9.847447,
            53.765734,
            65.677464
          ],
          [
            9.847722,
            53.765634,
            65.281933
          ],
          [
            9.848009,
            53.76554,
            65.35335
          ],
          [
            9.848303,
            53.765439,
            65.427337
          ],
          [
            9.848593,
            53.765339,
            65.500391
          ],
          [
            9.848875,
            53.765242,
            65.571387
          ],
          [
            9.849196,
            53.765136,
            65.651392
          ],
          [
            9.84949,
            53.765037,
            65.725013
          ],
          [
            9.84978,
            53.764932,
            65.799014
          ],
          [
            9.850075,
            53.764836,
            65.872301
          ],
          [
            9.850378,
            53.764739,
            65.911858
          ],
          [
            9.850679,
            53.764641,
            65.843734
          ],
          [
            9.850979,
            53.764531,
            65.77378
          ],
          [
            9.851266,
            53.764418,
            65.705448
          ],
          [
            9.851571,
            53.764309,
            65.634824
          ],
          [
            9.851836,
            53.764203,
            65.571392
          ],
          [
            9.852106,
            53.764066,
            65.500826
          ],
          [
            9.852372,
            53.763935,
            65.432221
          ],
          [
            9.852624,
            53.763805,
            65.365926
          ],
          [
            9.852869,
            53.763667,
            65.339903
          ],
          [
            9.853133,
            53.763562,
            65.373164
          ],
          [
            9.853397,
            53.763455,
            65.406423
          ],
          [
            9.853652,
            53.763325,
            65.441425
          ],
          [
            9.853925,
            53.763172,
            65.480543
          ],
          [
            9.854209,
            53.763046,
            65.517424
          ],
          [
            9.854443,
            53.762911,
            65.551381
          ],
          [
            9.854709,
            53.762769,
            65.588604
          ],
          [
            9.854988,
            53.762647,
            65.624657
          ],
          [
            9.855253,
            53.762519,
            65.798559
          ],
          [
            9.855501,
            53.762367,
            66.11217
          ],
          [
            9.855748,
            53.762208,
            66.432762
          ],
          [
            9.855984,
            53.762061,
            66.733701
          ],
          [
            9.85621,
            53.761907,
            67.036626
          ],
          [
            9.85643,
            53.761756,
            67.332625
          ],
          [
            9.856681,
            53.761589,
            67.664716
          ],
          [
            9.856877,
            53.761442,
            67.942788
          ],
          [
            9.857073,
            53.761291,
            68.225411
          ],
          [
            9.857325,
            53.761107,
            67.790075
          ],
          [
            9.857527,
            53.760955,
            67.222338
          ],
          [
            9.857758,
            53.760769,
            66.544378
          ],
          [
            9.857903,
            53.760589,
            65.953477
          ],
          [
            9.858068,
            53.76039,
            65.303331
          ],
          [
            9.858255,
            53.760192,
            64.638913
          ],
          [
            9.85844,
            53.759996,
            63.981298
          ],
          [
            9.858618,
            53.759809,
            63.352477
          ],
          [
            9.858802,
            53.759609,
            62.889576
          ],
          [
            9.858966,
            53.759422,
            62.624949
          ],
          [
            9.859189,
            53.759205,
            62.306128
          ],
          [
            9.859445,
            53.759026,
            62.01087
          ],
          [
            9.859712,
            53.758871,
            61.733094
          ],
          [
            9.859994,
            53.758731,
            61.459756
          ],
          [
            9.860299,
            53.758599,
            61.178557
          ],
          [
            9.860621,
            53.758509,
            60.913677
          ],
          [
            9.860993,
            53.758507,
            60.722295
          ],
          [
            9.861393,
            53.758495,
            60.597988
          ],
          [
            9.861764,
            53.758548,
            60.47979
          ],
          [
            9.862072,
            53.758602,
            60.38022
          ],
          [
            9.862402,
            53.758602,
            60.277378
          ],
          [
            9.862729,
            53.758593,
            60.175973
          ],
          [
            9.863037,
            53.758561,
            60.0791
          ],
          [
            9.863469,
            53.758515,
            59.943047
          ],
          [
            9.863883,
            53.758473,
            59.928205
          ],
          [
            9.864237,
            53.758434,
            60.256054
          ],
          [
            9.864578,
            53.758376,
            60.579122
          ],
          [
            9.86495,
            53.758293,
            60.941326
          ],
          [
            9.865319,
            53.758205,
            61.303706
          ],
          [
            9.865682,
            53.758115,
            61.66214
          ],
          [
            9.865986,
            53.757997,
            61.994822
          ],
          [
            9.866297,
            53.757918,
            62.303224
          ],
          [
            9.86666,
            53.757831,
            62.652503
          ],
          [
            9.867014,
            53.757744,
            62.947012
          ],
          [
            9.867343,
            53.757672,
            63.216457
          ],
          [
            9.867658,
            53.757604,
            63.474024
          ],
          [
            9.867984,
            53.757523,
            63.745639
          ],
          [
            9.868333,
            53.757439,
            64.035062
          ],
          [
            9.86866,
            53.757363,
            64.30495
          ],
          [
            9.868954,
            53.75728,
            64.555411
          ],
          [
            9.86928,
            53.757179,
            64.838129
          ],
          [
            9.869525,
            53.757048,
            64.947525
          ],
          [
            9.86977,
            53.756908,
            64.945432
          ],
          [
            9.870017,
            53.756748,
            64.943166
          ],
          [
            9.870286,
            53.756627,
            64.941089
          ],
          [
            9.8705,
            53.75649,
            64.939152
          ],
          [
            9.870664,
            53.756295,
            64.93687
          ],
          [
            9.870752,
            53.756089,
            64.934664
          ],
          [
            9.870833,
            53.755889,
            64.932527
          ],
          [
            9.870918,
            53.75569,
            64.930396
          ],
          [
            9.870996,
            53.755472,
            64.69997
          ],
          [
            9.871068,
            53.755241,
            64.406841
          ],
          [
            9.871144,
            53.755009,
            64.111932
          ],
          [
            9.871218,
            53.754783,
            63.824694
          ],
          [
            9.871299,
            53.754559,
            63.538818
          ],
          [
            9.871407,
            53.754337,
            63.25012
          ],
          [
            9.87158,
            53.754149,
            62.982975
          ],
          [
            9.871781,
            53.75398,
            62.724966
          ],
          [
            9.872007,
            53.753829,
            62.79377
          ],
          [
            9.872227,
            53.753686,
            62.916505
          ],
          [
            9.872425,
            53.753511,
            63.04984
          ],
          [
            9.872638,
            53.753344,
            63.182447
          ],
          [
            9.872903,
            53.753184,
            63.324337
          ],
          [
            9.873216,
            53.75306,
            63.465595
          ],
          [
            9.873513,
            53.752933,
            63.602847
          ],
          [
            9.873808,
            53.752827,
            63.732098
          ],
          [
            9.874125,
            53.752699,
            63.798696
          ],
          [
            9.874379,
            53.752568,
            63.734677
          ],
          [
            9.874596,
            53.752438,
            63.676041
          ],
          [
            9.874799,
            53.752288,
            63.614177
          ],
          [
            9.875002,
            53.752121,
            63.548161
          ],
          [
            9.875211,
            53.75195,
            63.480385
          ],
          [
            9.875427,
            53.751773,
            63.409902
          ],
          [
            9.875652,
            53.751601,
            63.340112
          ],
          [
            9.875851,
            53.751416,
            63.269746
          ],
          [
            9.876017,
            53.751248,
            62.936078
          ],
          [
            9.876196,
            53.75105,
            62.37645
          ],
          [
            9.876383,
            53.750839,
            61.782616
          ],
          [
            9.876586,
            53.750636,
            61.194775
          ],
          [
            9.876752,
            53.750427,
            60.618265
          ],
          [
            9.876932,
            53.750268,
            60.141328
          ],
          [
            9.877215,
            53.750148,
            59.626115
          ],
          [
            9.877456,
            53.750004,
            59.121054
          ],
          [
            9.877709,
            53.749855,
            58.869432
          ],
          [
            9.87806,
            53.749724,
            59.248892
          ],
          [
            9.878363,
            53.749608,
            59.578742
          ],
          [
            9.878674,
            53.749501,
            59.907545
          ],
          [
            9.87896,
            53.749368,
            60.241222
          ],
          [
            9.879149,
            53.749207,
            60.544847
          ],
          [
            9.879373,
            53.749017,
            60.90277
          ],
          [
            9.87962,
            53.748833,
            61.265902
          ],
          [
            9.879861,
            53.748633,
            61.383914
          ],
          [
            9.88012,
            53.748433,
            60.773542
          ],
          [
            9.880406,
            53.748271,
            60.204583
          ],
          [
            9.880746,
            53.748184,
            59.673507
          ],
          [
            9.881112,
            53.748106,
            59.116114
          ],
          [
            9.88152,
            53.748057,
            58.518105
          ],
          [
            9.881913,
            53.748049,
            57.954638
          ],
          [
            9.882237,
            53.748068,
            57.487653
          ],
          [
            9.882567,
            53.74817,
            57.23265
          ],
          [
            9.882903,
            53.748306,
            57.350579
          ],
          [
            9.883189,
            53.748436,
            57.454995
          ],
          [
            9.883486,
            53.748567,
            57.562246
          ],
          [
            9.883746,
            53.748693,
            57.659552
          ],
          [
            9.884023,
            53.748814,
            57.759245
          ],
          [
            9.884296,
            53.748949,
            57.862293
          ],
          [
            9.884522,
            53.749071,
            57.950897
          ],
          [
            9.884803,
            53.749143,
            58.039987
          ],
          [
            9.885155,
            53.749159,
            58.00964
          ],
          [
            9.885403,
            53.749012,
            57.927523
          ],
          [
            9.885502,
            53.748824,
            57.85631
          ],
          [
            9.885611,
            53.748615,
            57.777203
          ],
          [
            9.885729,
            53.748402,
            57.696141
          ],
          [
            9.885843,
            53.748199,
            57.618781
          ],
          [
            9.885924,
            53.747999,
            57.544357
          ],
          [
            9.886017,
            53.747798,
            57.468863
          ],
          [
            9.886115,
            53.747605,
            57.422731
          ],
          [
            9.886211,
            53.747407,
            57.449569
          ],
          [
            9.886314,
            53.747216,
            57.475699
          ],
          [
            9.886423,
            53.747014,
            57.503327
          ],
          [
            9.886522,
            53.746827,
            57.528869
          ],
          [
            9.886629,
            53.746627,
            57.556201
          ],
          [
            9.886748,
            53.746448,
            57.581285
          ],
          [
            9.88703,
            53.746544,
            57.606498
          ],
          [
            9.887348,
            53.74663,
            57.633467
          ],
          [
            9.887671,
            53.746713,
            57.698562
          ],
          [
            9.888,
            53.746791,
            57.823602
          ],
          [
            9.888317,
            53.746855,
            57.94175
          ],
          [
            9.888694,
            53.746887,
            58.077027
          ],
          [
            9.889028,
            53.746947,
            58.201096
          ],
          [
            9.889354,
            53.747018,
            58.323679
          ],
          [
            9.889683,
            53.747087,
            58.446811
          ],
          [
            9.890017,
            53.747151,
            58.570652
          ],
          [
            9.890333,
            53.747208,
            58.687452
          ],
          [
            9.890674,
            53.747262,
            58.664002
          ],
          [
            9.891012,
            53.747329,
            58.581214
          ],
          [
            9.891374,
            53.747375,
            58.495242
          ],
          [
            9.89171,
            53.747443,
            58.412758
          ],
          [
            9.892052,
            53.747501,
            58.330126
          ],
          [
            9.892355,
            53.747544,
            58.257035
          ],
          [
            9.892697,
            53.747616,
            58.172709
          ],
          [
            9.893051,
            53.747691,
            58.085299
          ],
          [
            9.893415,
            53.747699,
            58.057949
          ],
          [
            9.893759,
            53.747665,
            58.270006
          ],
          [
            9.894134,
            53.747633,
            58.500305
          ],
          [
            9.894452,
            53.747584,
            58.700067
          ],
          [
            9.894762,
            53.747528,
            58.897003
          ],
          [
            9.895118,
            53.747469,
            59.121667
          ],
          [
            9.89545,
            53.747426,
            59.328139
          ],
          [
            9.895797,
            53.747383,
            59.543908
          ],
          [
            9.89615,
            53.747336,
            59.76373
          ],
          [
            9.89652,
            53.747309,
            59.949709
          ],
          [
            9.896886,
            53.74731,
            60.10038
          ],
          [
            9.897277,
            53.747307,
            60.261231
          ],
          [
            9.897623,
            53.747278,
            60.404982
          ],
          [
            9.897958,
            53.747215,
            60.549574
          ],
          [
            9.898306,
            53.747138,
            60.702451
          ],
          [
            9.898633,
            53.747093,
            60.841063
          ],
          [
            9.898981,
            53.747043,
            60.988439
          ],
          [
            9.899428,
            53.746964,
            61.450892
          ],
          [
            9.899749,
            53.746915,
            62.156888
          ],
          [
            9.900087,
            53.746845,
            62.91758
          ],
          [
            9.900411,
            53.746817,
            63.626133
          ],
          [
            9.900715,
            53.746732,
            64.340206
          ],
          [
            9.901074,
            53.746724,
            65.107928
          ],
          [
            9.901406,
            53.746668,
            65.845751
          ],
          [
            9.90173,
            53.746609,
            66.570328
          ],
          [
            9.90204,
            53.746555,
            67.258039
          ],
          [
            9.902405,
            53.746495,
            67.627961
          ],
          [
            9.90273,
            53.746417,
            67.710013
          ],
          [
            9.903037,
            53.746345,
            67.787153
          ],
          [
            9.903317,
            53.746229,
            67.866972
          ],
          [
            9.903579,
            53.746122,
            67.9414
          ],
          [
            9.903853,
            53.745998,
            68.021944
          ],
          [
            9.904093,
            53.745857,
            68.10092
          ],
          [
            9.904439,
            53.745775,
            68.18801
          ],
          [
            9.904812,
            53.745707,
            68.279156
          ],
          [
            9.905131,
            53.745649,
            68.264919
          ],
          [
            9.905498,
            53.745594,
            68.241664
          ],
          [
            9.90587,
            53.745531,
            68.217903
          ],
          [
            9.906189,
            53.745476,
            68.197499
          ],
          [
            9.906498,
            53.74546,
            68.178425
          ],
          [
            9.906837,
            53.745413,
            68.157045
          ],
          [
            9.907192,
            53.745378,
            68.134943
          ],
          [
            9.907535,
            53.745323,
            68.113111
          ],
          [
            9.907916,
            53.745284,
            67.871504
          ],
          [
            9.90828,
            53.745251,
            67.23402
          ],
          [
            9.908638,
            53.745253,
            66.613983
          ],
          [
            9.908962,
            53.745216,
            66.041262
          ],
          [
            9.909277,
            53.745154,
            65.466364
          ],
          [
            9.909649,
            53.745138,
            64.817892
          ],
          [
            9.91,
            53.745133,
            64.210016
          ],
          [
            9.910326,
            53.745129,
            63.636781
          ],
          [
            9.91053,
            53.74531,
            62.999532
          ],
          [
            9.910737,
            53.745465,
            62.43702
          ],
          [
            9.91096,
            53.745648,
            61.803308
          ],
          [
            9.911231,
            53.745837,
            61.106854
          ],
          [
            9.911534,
            53.746008,
            60.411034
          ],
          [
            9.911783,
            53.746163,
            59.81011
          ],
          [
            9.912086,
            53.746298,
            59.172631
          ],
          [
            9.912419,
            53.746416,
            58.526798
          ],
          [
            9.912766,
            53.746526,
            57.870178
          ],
          [
            9.913055,
            53.746616,
            57.995397
          ],
          [
            9.913391,
            53.746746,
            58.314065
          ],
          [
            9.913762,
            53.746844,
            58.636396
          ],
          [
            9.914102,
            53.747001,
            58.979115
          ],
          [
            9.914403,
            53.747121,
            59.266668
          ],
          [
            9.914698,
            53.747282,
            59.584888
          ],
          [
            9.914955,
            53.747455,
            59.893354
          ],
          [
            9.91517,
            53.74763,
            60.183087
          ],
          [
            9.915356,
            53.747792,
            60.47965
          ],
          [
            9.915527,
            53.74796,
            60.777385
          ],
          [
            9.915702,
            53.748119,
            61.065322
          ],
          [
            9.915885,
            53.748267,
            61.343598
          ],
          [
            9.916095,
            53.748417,
            61.640425
          ],
          [
            9.916321,
            53.748586,
            61.96812
          ],
          [
            9.916533,
            53.748739,
            62.268459
          ],
          [
            9.916764,
            53.748893,
            62.580953
          ],
          [
            9.916976,
            53.749048,
            62.884564
          ],
          [
            9.917191,
            53.749223,
            63.574128
          ],
          [
            9.917402,
            53.749363,
            64.207839
          ],
          [
            9.917647,
            53.749502,
            64.889026
          ],
          [
            9.917913,
            53.749626,
            65.566158
          ],
          [
            9.918189,
            53.74973,
            66.220178
          ],
          [
            9.918499,
            53.749812,
            66.89888
          ],
          [
            9.918641,
            53.749987,
            67.635349
          ],
          [
            9.918856,
            53.75003,
            68.271101
          ],
          [
            9.919267,
            53.74986,
            69.014015
          ],
          [
            9.919608,
            53.749885,
            69.050223
          ],
          [
            9.919979,
            53.74989,
            69.089319
          ],
          [
            9.92034,
            53.749876,
            69.127725
          ],
          [
            9.920717,
            53.749878,
            69.167436
          ],
          [
            9.921055,
            53.749906,
            69.203364
          ],
          [
            9.921418,
            53.749918,
            69.242015
          ],
          [
            9.921799,
            53.74995,
            69.282573
          ],
          // [
          //   9.922149,
          //   53.749945,
          //   69.3154
          // ],
          // [
          //   9.922486,
          //   53.749955,
          //   69.304613
          // ],
          // [
          //   9.922734,
          //   53.750048,
          //   69.294192
          // ],
          // [
          //   9.922508,
          //   53.750142,
          //   69.282714
          // ],
          // [
          //   9.922732,
          //   53.7503,
          //   69.268895
          // ],
          // [
          //   9.923107,
          //   53.750321,
          //   69.256825
          // ],
          // [
          //   9.923485,
          //   53.75033,
          //   69.244725
          // ],
          // [
          //   9.923493,
          //   53.750362,
          //   69.234725
          // ],
          // [
          //   9.923158,
          //   53.750312,
          //   69.223639
          // ],
          // [
          //   9.922799,
          //   53.750289,
          //   68.980279
          // ],
          // [
          //   9.922442,
          //   53.750304,
          //   68.590373
          // ],
          // [
          //   9.922076,
          //   53.750326,
          //   68.189534
          // ],
          // [
          //   9.92188,
          //   53.75048,
          //   67.792509
          // ],
          // [
          //   9.921926,
          //   53.750715,
          //   67.356703
          // ],
          // [
          //   9.921974,
          //   53.75094,
          //   66.935949
          // ],
          // [
          //   9.922173,
          //   53.751127,
          //   66.52871
          // ],
          // [
          //   9.922281,
          //   53.751326,
          //   66.143715
          // ],
          // [
          //   9.922351,
          //   53.751545,
          //   65.878849
          // ],
          // [
          //   9.922448,
          //   53.751758,
          //   65.813329
          // ],
          // [
          //   9.922511,
          //   53.751968,
          //   65.749387
          // ],
          // [
          //   9.922745,
          //   53.752178,
          //   65.674766
          // ],
          // [
          //   9.923069,
          //   53.752276,
          //   65.611041
          // ],
          // [
          //   9.923484,
          //   53.752338,
          //   65.536219
          // ],
          // [
          //   9.92389,
          //   53.752423,
          //   65.46089
          // ],
          // [
          //   9.924263,
          //   53.752513,
          //   65.390272
          // ],
          // [
          //   9.924496,
          //   53.752663,
          //   65.622137
          // ],
          // [
          //   9.924775,
          //   53.75279,
          //   65.962756
          // ],
          // [
          //   9.925033,
          //   53.752898,
          //   66.267036
          // ],
          // [
          //   9.925131,
          //   53.753084,
          //   66.587261
          // ],
          // [
          //   9.924874,
          //   53.752969,
          //   66.904439
          // ],
          // [
          //   9.924625,
          //   53.752833,
          //   67.229153
          // ],
          // [
          //   9.924356,
          //   53.752697,
          //   67.568375
          // ],
          // [
          //   9.92402,
          //   53.752578,
          //   67.943689
          // ],
          // [
          //   9.923671,
          //   53.752497,
          //   68.298153
          // ],
          // [
          //   9.923353,
          //   53.752451,
          //   68.500223
          // ],
          // [
          //   9.923036,
          //   53.752392,
          //   68.706108
          // ],
          // [
          //   9.922767,
          //   53.7523,
          //   68.899652
          // ],
          // [
          //   9.922471,
          //   53.752136,
          //   69.155256
          // ],
          // [
          //   9.922397,
          //   53.751908,
          //   69.404011
          // ],
          // [
          //   9.92228,
          //   53.751707,
          //   69.625914
          // ],
          // [
          //   9.922182,
          //   53.751519,
          //   69.831197
          // ],
          // [
          //   9.922079,
          //   53.751284,
          //   70.084589
          // ],
          // [
          //   9.922127,
          //   53.751279,
          //   70.165278
          // ],
          // [
          //   9.9222,
          //   53.751457,
          //   70.165278
          // ],
          // [
          //   9.922535,
          //   53.751449,
          //   70.165278
          // ],
          // [
          //   9.922654,
          //   53.751306,
          //   70.165278
          // ],
          // [
          //   9.922631,
          //   53.751233,
          //   70.165278
          // ],
          // [
          //   9.922568,
          //   53.751223,
          //   70.165278
          // ],
          // [
          //   9.922538,
          //   53.7512,
          //   70.165278
          // ]
        ]
      }
    }
  ]
}

let day25: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            9.921799,
            53.74995,
            69.282573
          ],
          // [
          //   9.922666,
          //   53.751225,
          //   65.953899
          // ],
          // [
          //   9.92279,
          //   53.750928,
          //   65.953899
          // ],
          // [
          //   9.923109,
          //   53.750914,
          //   65.953899
          // ],
          // [
          //   9.923064,
          //   53.750835,
          //   65.953899
          // ],
          // [
          //   9.922715,
          //   53.750884,
          //   65.991359
          // ],
          // [
          //   9.922367,
          //   53.750924,
          //   66.400226
          // ],
          // [
          //   9.922002,
          //   53.750956,
          //   66.829695
          // ],
          // [
          //   9.921915,
          //   53.750755,
          //   67.249513
          // ],
          // [
          //   9.921876,
          //   53.750559,
          //   67.634293
          // ],
          // [
          //   9.921919,
          //   53.750353,
          //   68.042461
          // ],
          // [
          //   9.922273,
          //   53.750295,
          //   68.469509
          // ],
          // [
          //   9.922476,
          //   53.750192,
          //   68.83141
          // ],
          [
            9.922647,
            53.750076,
            69.234452
          ],
          [
            9.922984,
            53.750039,
            69.358548
          ],
          [
            9.923308,
            53.750066,
            69.148672
          ],
          [
            9.923629,
            53.750075,
            68.942964
          ],
          [
            9.92395,
            53.750096,
            68.736227
          ],
          [
            9.924299,
            53.750116,
            68.511839
          ],
          [
            9.924659,
            53.750127,
            68.281166
          ],
          [
            9.925016,
            53.750144,
            68.051952
          ],
          [
            9.925388,
            53.75016,
            67.812534
          ],
          [
            9.925742,
            53.750176,
            67.585293
          ],
          [
            9.926152,
            53.750229,
            67.713056
          ],
          [
            9.926507,
            53.750283,
            67.956594
          ],
          [
            9.926846,
            53.750337,
            68.189042
          ],
          [
            9.927177,
            53.75039,
            68.415987
          ],
          [
            9.927523,
            53.750468,
            68.661015
          ],
          [
            9.927872,
            53.75055,
            68.909616
          ],
          [
            9.928216,
            53.750631,
            69.154633
          ],
          [
            9.928558,
            53.750722,
            69.402855
          ],
          [
            9.928885,
            53.750795,
            69.642645
          ],
          [
            9.929208,
            53.750875,
            69.892367
          ],
          [
            9.929541,
            53.750942,
            70.143179
          ],
          [
            9.929853,
            53.751011,
            70.380694
          ],
          [
            9.93018,
            53.751084,
            70.630031
          ],
          [
            9.930509,
            53.751163,
            70.883195
          ],
          [
            9.930818,
            53.751251,
            71.127763
          ],
          [
            9.931181,
            53.751303,
            71.394061
          ],
          [
            9.931517,
            53.751314,
            71.635885
          ],
          [
            9.93182,
            53.75133,
            71.735814
          ],
          [
            9.931929,
            53.751507,
            71.795926
          ],
          [
            9.932294,
            53.751586,
            71.864012
          ],
          [
            9.932641,
            53.751662,
            71.928819
          ],
          [
            9.932953,
            53.751762,
            71.991186
          ],
          [
            9.933264,
            53.751849,
            72.051623
          ],
          [
            9.933579,
            53.751961,
            72.116005
          ],
          [
            9.933936,
            53.752062,
            72.18538
          ],
          [
            9.934296,
            53.752158,
            72.263349
          ],
          [
            9.934597,
            53.75223,
            72.337621
          ],
          [
            9.934913,
            53.752303,
            72.415238
          ],
          [
            9.935217,
            53.752383,
            72.491367
          ],
          [
            9.935519,
            53.752449,
            72.564991
          ],
          [
            9.935816,
            53.752528,
            72.639457
          ],
          [
            9.936095,
            53.752604,
            72.709712
          ],
          [
            9.936427,
            53.752679,
            72.790978
          ],
          [
            9.936727,
            53.752746,
            72.86433
          ],
          [
            9.937069,
            53.752824,
            72.885461
          ],
          [
            9.937406,
            53.752889,
            72.77745
          ],
          [
            9.937726,
            53.752968,
            72.671795
          ],
          [
            9.938036,
            53.753037,
            72.570879
          ],
          [
            9.938333,
            53.75313,
            72.468479
          ],
          [
            9.938662,
            53.753209,
            72.360267
          ],
          [
            9.938998,
            53.753293,
            72.24898
          ],
          [
            9.939255,
            53.753406,
            72.151404
          ],
          [
            9.939512,
            53.753514,
            72.055344
          ],
          [
            9.939801,
            53.753631,
            71.967149
          ],
          [
            9.940046,
            53.753743,
            71.910882
          ],
          [
            9.940301,
            53.753852,
            71.853691
          ],
          [
            9.940574,
            53.753975,
            71.791331
          ],
          [
            9.940885,
            53.75412,
            71.719346
          ],
          [
            9.941169,
            53.754244,
            71.655184
          ],
          [
            9.941412,
            53.754359,
            71.598624
          ],
          [
            9.941723,
            53.754502,
            71.527037
          ],
          [
            9.941986,
            53.754607,
            71.46938
          ],
          [
            9.942267,
            53.754733,
            71.63091
          ],
          [
            9.942569,
            53.754852,
            71.972872
          ],
          [
            9.942893,
            53.754963,
            72.325926
          ],
          [
            9.943147,
            53.755086,
            72.636446
          ],
          [
            9.943419,
            53.755219,
            72.970047
          ],
          [
            9.9437,
            53.755339,
            73.296407
          ],
          [
            9.943958,
            53.75546,
            73.60651
          ],
          [
            9.944212,
            53.755578,
            73.911426
          ],
          [
            9.944601,
            53.755757,
            74.349104
          ],
          [
            9.944888,
            53.755916,
            74.579765
          ],
          [
            9.945172,
            53.756028,
            74.779182
          ],
          [
            9.945453,
            53.756139,
            74.976632
          ],
          [
            9.945713,
            53.756246,
            75.161715
          ],
          [
            9.945977,
            53.756377,
            75.363167
          ],
          [
            9.946253,
            53.75652,
            75.577559
          ],
          [
            9.946531,
            53.756648,
            75.783398
          ],
          [
            9.946821,
            53.756764,
            75.987932
          ],
          [
            9.947131,
            53.756904,
            76.251534
          ],
          [
            9.947412,
            53.757032,
            76.514436
          ],
          [
            9.947722,
            53.757167,
            76.800158
          ],
          [
            9.948007,
            53.757321,
            77.086773
          ],
          [
            9.948282,
            53.75747,
            77.363224
          ],
          [
            9.948558,
            53.757605,
            77.628705
          ],
          [
            9.948847,
            53.757718,
            77.885563
          ],
          [
            9.949135,
            53.757837,
            78.145971
          ],
          [
            9.949431,
            53.757935,
            78.340684
          ],
          [
            9.949725,
            53.758068,
            78.355104
          ],
          [
            9.949945,
            53.758221,
            78.368314
          ],
          [
            9.950228,
            53.758341,
            78.381868
          ],
          [
            9.950535,
            53.758447,
            78.395694
          ],
          [
            9.950804,
            53.758574,
            78.4091
          ],
          [
            9.951113,
            53.758689,
            78.42333
          ],
          [
            9.951387,
            53.758803,
            78.436444
          ],
          [
            9.951676,
            53.758965,
            78.451984
          ],
          [
            9.951941,
            53.759108,
            78.464231
          ],
          [
            9.952179,
            53.759233,
            78.474533
          ],
          [
            9.952438,
            53.759371,
            78.485822
          ],
          [
            9.952685,
            53.7595,
            78.496484
          ],
          [
            9.952967,
            53.759637,
            78.508284
          ],
          [
            9.953207,
            53.759767,
            78.518816
          ],
          [
            9.953463,
            53.759873,
            78.528928
          ],
          [
            9.953721,
            53.759998,
            78.539713
          ],
          [
            9.953978,
            53.760143,
            78.551213
          ],
          [
            9.954318,
            53.760268,
            78.50587
          ],
          [
            9.954578,
            53.760387,
            78.454284
          ],
          [
            9.954856,
            53.76051,
            78.399864
          ],
          [
            9.955116,
            53.76063,
            78.347725
          ],
          [
            9.955369,
            53.76076,
            78.295201
          ],
          [
            9.955626,
            53.760893,
            78.241612
          ],
          [
            9.955904,
            53.761018,
            78.186877
          ],
          [
            9.956196,
            53.761147,
            78.12972
          ],
          [
            9.956452,
            53.761285,
            78.082796
          ],
          [
            9.956773,
            53.761417,
            78.244831
          ],
          [
            9.957025,
            53.76156,
            78.389449
          ],
          [
            9.957272,
            53.7617,
            78.53108
          ],
          [
            9.957542,
            53.761863,
            78.690892
          ],
          [
            9.957793,
            53.762017,
            78.840837
          ],
          [
            9.958068,
            53.762149,
            78.987657
          ],
          [
            9.958314,
            53.762274,
            79.121985
          ],
          [
            9.958569,
            53.762403,
            79.260971
          ],
          [
            9.958844,
            53.76252,
            79.402834
          ],
          [
            9.959115,
            53.762653,
            79.552127
          ],
          [
            9.959391,
            53.762793,
            79.706248
          ],
          [
            9.95965,
            53.762909,
            79.843938
          ],
          [
            9.959919,
            53.763042,
            79.992539
          ],
          [
            9.960166,
            53.763188,
            80.140634
          ],
          [
            9.960439,
            53.763349,
            80.304047
          ],
          [
            9.960678,
            53.763521,
            80.463603
          ],
          [
            9.960898,
            53.763692,
            80.617999
          ],
          [
            9.961098,
            53.763845,
            80.307853
          ],
          [
            9.961313,
            53.763981,
            79.982105
          ],
          [
            9.961569,
            53.764142,
            79.595822
          ],
          [
            9.96181,
            53.764318,
            79.199305
          ],
          [
            9.962076,
            53.764473,
            78.813251
          ],
          [
            9.962291,
            53.764628,
            78.462923
          ],
          [
            9.962489,
            53.76478,
            78.127358
          ],
          [
            9.962677,
            53.764942,
            77.78365
          ],
          [
            9.962894,
            53.765119,
            77.388384
          ],
          [
            9.963105,
            53.765289,
            76.960538
          ],
          [
            9.963298,
            53.765434,
            76.585655
          ],
          [
            9.963512,
            53.765593,
            76.173255
          ],
          [
            9.963699,
            53.765765,
            75.757671
          ],
          [
            9.963953,
            53.765962,
            75.254861
          ],
          [
            9.964165,
            53.766146,
            74.80262
          ],
          [
            9.964384,
            53.766285,
            74.415484
          ],
          [
            9.964636,
            53.766454,
            73.958449
          ],
          [
            9.964924,
            53.766704,
            74.283675
          ],
          [
            9.965187,
            53.766906,
            74.758753
          ],
          [
            9.965427,
            53.767083,
            75.181438
          ],
          [
            9.965676,
            53.767252,
            75.598666
          ],
          [
            9.965898,
            53.767442,
            76.028613
          ],
          [
            9.96612,
            53.767635,
            76.463528
          ],
          [
            9.966343,
            53.767808,
            76.868499
          ],
          [
            9.966569,
            53.767943,
            77.180629
          ],
          [
            9.966854,
            53.768102,
            77.156459
          ],
          [
            9.967126,
            53.768245,
            77.133943
          ],
          [
            9.967411,
            53.768398,
            77.110188
          ],
          [
            9.967654,
            53.768539,
            77.089177
          ],
          [
            9.967924,
            53.768708,
            77.064932
          ],
          [
            9.96822,
            53.768893,
            77.038371
          ],
          [
            9.968523,
            53.769087,
            77.01083
          ],
          [
            9.968838,
            53.769273,
            76.951468
          ],
          [
            9.969088,
            53.769428,
            76.869202
          ],
          [
            9.969332,
            53.769589,
            76.786071
          ],
          [
            9.969579,
            53.769759,
            76.700006
          ],
          [
            9.969871,
            53.769939,
            76.604108
          ],
          [
            9.970142,
            53.770105,
            76.515554
          ],
          [
            9.970415,
            53.770275,
            76.42558
          ],
          [
            9.970686,
            53.770432,
            76.339477
          ],
          [
            9.97094,
            53.770601,
            76.242466
          ],
          [
            9.971168,
            53.770784,
            76.1383
          ],
          [
            9.971352,
            53.770933,
            76.053708
          ],
          [
            9.971656,
            53.770945,
            75.963591
          ],
          [
            9.971908,
            53.771046,
            75.873364
          ],
          [
            9.972018,
            53.771235,
            75.781836
          ],
          [
            9.972181,
            53.771446,
            75.67553
          ],
          [
            9.972283,
            53.771657,
            75.575086
          ],
          [
            9.972393,
            53.771875,
            75.468241
          ],
          [
            9.972532,
            53.772087,
            75.337478
          ],
          [
            9.972671,
            53.772308,
            75.201795
          ],
          [
            9.97277,
            53.772495,
            75.088667
          ],
          [
            9.972888,
            53.772682,
            74.973879
          ],
          [
            9.972972,
            53.77288,
            74.856476
          ],
          [
            9.973108,
            53.773098,
            74.722839
          ],
          [
            9.973234,
            53.773268,
            74.615731
          ],
          [
            9.97332,
            53.773462,
            74.500144
          ],
          [
            9.973422,
            53.773663,
            74.260086
          ],
          [
            9.973539,
            53.77386,
            73.926061
          ],
          [
            9.973619,
            53.774054,
            73.608539
          ],
          [
            9.973697,
            53.774246,
            73.294528
          ],
          [
            9.973784,
            53.774435,
            72.982838
          ],
          [
            9.973861,
            53.774644,
            72.64192
          ],
          [
            9.973982,
            53.774863,
            72.27557
          ],
          [
            9.974035,
            53.775075,
            71.934682
          ],
          [
            9.974068,
            53.77529,
            71.590672
          ],
          [
            9.974091,
            53.775529,
            71.224184
          ],
          [
            9.97422,
            53.775777,
            70.826481
          ],
          [
            9.974339,
            53.775997,
            70.473079
          ],
          [
            9.974457,
            53.776214,
            70.124324
          ],
          [
            9.974546,
            53.776442,
            69.765912
          ],
          [
            9.974684,
            53.77666,
            69.408665
          ],
          [
            9.974819,
            53.776897,
            69.025781
          ],
          [
            9.974979,
            53.777127,
            69.080498
          ],
          [
            9.975084,
            53.777342,
            69.522716
          ],
          [
            9.97518,
            53.777523,
            69.897737
          ],
          [
            9.975272,
            53.777708,
            70.279167
          ],
          [
            9.975412,
            53.777902,
            70.695903
          ],
          [
            9.975535,
            53.778122,
            71.154085
          ],
          [
            9.975675,
            53.778359,
            71.650038
          ],
          [
            9.975808,
            53.778552,
            72.061779
          ],
          [
            9.975945,
            53.778766,
            72.511263
          ],
          [
            9.976068,
            53.778949,
            72.891336
          ],
          [
            9.976165,
            53.779162,
            73.316418
          ],
          [
            9.976276,
            53.779393,
            73.77928
          ],
          [
            9.976426,
            53.779636,
            74.277885
          ],
          [
            9.97654,
            53.779866,
            74.739743
          ],
          [
            9.976634,
            53.780091,
            75.188652
          ],
          [
            9.97675,
            53.780319,
            75.647544
          ],
          [
            9.977058,
            53.780402,
            75.633238
          ],
          [
            9.977006,
            53.780592,
            75.187397
          ],
          [
            9.976912,
            53.780814,
            74.665491
          ],
          [
            9.976828,
            53.780998,
            74.230636
          ],
          [
            9.97667,
            53.781185,
            73.74256
          ],
          [
            9.976598,
            53.781373,
            73.302944
          ],
          [
            9.976529,
            53.781597,
            72.783586
          ],
          [
            9.976498,
            53.781832,
            72.245656
          ],
          [
            9.976238,
            53.781869,
            71.815589
          ],
          [
            9.976476,
            53.781885,
            71.480424
          ],
          [
            9.976491,
            53.782083,
            71.161581
          ],
          [
            9.976394,
            53.782278,
            70.845799
          ],
          [
            9.976266,
            53.782492,
            70.493068
          ],
          [
            9.976147,
            53.782718,
            70.125299
          ],
          [
            9.97601,
            53.782954,
            69.73766
          ],
          [
            9.975896,
            53.783219,
            69.312772
          ],
          [
            9.975796,
            53.783445,
            68.969566
          ],
          [
            9.975807,
            53.783634,
            69.347151
          ],
          [
            9.97599,
            53.783797,
            69.776588
          ],
          [
            9.976093,
            53.784006,
            70.212214
          ],
          [
            9.976243,
            53.784199,
            70.636362
          ],
          [
            9.976498,
            53.784383,
            71.11903
          ],
          [
            9.976518,
            53.784559,
            71.50006
          ],
          [
            9.976554,
            53.784651,
            72.045032
          ],
          [
            9.976721,
            53.784843,
            72.476164
          ],
          [
            9.976889,
            53.785042,
            72.896985
          ],
          [
            9.977025,
            53.785209,
            73.244152
          ],
          [
            9.977179,
            53.785397,
            73.635633
          ],
          [
            9.977351,
            53.785597,
            74.055852
          ],
          [
            9.977514,
            53.785771,
            74.428293
          ],
          [
            9.977697,
            53.785961,
            74.837625
          ],
          [
            9.977864,
            53.786147,
            75.231999
          ],
          [
            9.978024,
            53.786303,
            75.574061
          ],
          [
            9.978237,
            53.786445,
            75.920786
          ],
          [
            9.978472,
            53.786592,
            76.062928
          ],
          [
            9.978642,
            53.78675,
            76.194573
          ],
          [
            9.978813,
            53.786916,
            76.331369
          ],
          [
            9.978961,
            53.787108,
            76.479664
          ],
          [
            9.979122,
            53.787285,
            76.621163
          ],
          [
            9.979272,
            53.787468,
            76.764144
          ],
          [
            9.979359,
            53.78765,
            76.897364
          ],
          [
            9.97944,
            53.787843,
            77.037457
          ],
          [
            9.979471,
            53.788054,
            77.213955
          ],
          [
            9.979454,
            53.788259,
            77.976122
          ],
          [
            9.97946,
            53.788469,
            78.756167
          ],
          [
            9.979438,
            53.78868,
            79.541552
          ],
          [
            9.979493,
            53.788885,
            80.319955
          ],
          [
            9.979515,
            53.789088,
            81.077756
          ],
          [
            9.979469,
            53.789273,
            81.823857
          ],
          [
            9.979626,
            53.789442,
            82.54547
          ],
          [
            9.979727,
            53.789642,
            83.320512
          ],
          [
            9.979824,
            53.789838,
            83.850974
          ],
          [
            9.979941,
            53.790024,
            83.838141
          ],
          [
            9.980001,
            53.790255,
            83.823042
          ],
          [
            9.980139,
            53.790425,
            83.810856
          ],
          [
            9.980319,
            53.790588,
            83.79813
          ],
          [
            9.980471,
            53.790756,
            83.785816
          ],
          [
            9.980622,
            53.790926,
            83.773399
          ],
          [
            9.980793,
            53.791116,
            83.759472
          ],
          [
            9.980892,
            53.791318,
            83.745882
          ],
          [
            9.980977,
            53.791523,
            83.883081
          ],
          [
            9.981027,
            53.791723,
            84.176641
          ],
          [
            9.981097,
            53.791932,
            84.486283
          ],
          [
            9.981155,
            53.792134,
            84.784072
          ],
          [
            9.981243,
            53.792352,
            85.109906
          ],
          [
            9.981325,
            53.792546,
            85.400266
          ],
          [
            9.981383,
            53.792752,
            85.703788
          ],
          [
            9.981668,
            53.792716,
            85.982975
          ],
          [
            9.981905,
            53.792566,
            86.301644
          ],
          [
            9.982189,
            53.792447,
            86.469807
          ],
          [
            9.982151,
            53.792388,
            86.596932
          ],
          [
            9.981907,
            53.792547,
            86.745535
          ],
          [
            9.981673,
            53.792698,
            86.886861
          ],
          [
            9.981684,
            53.792894,
            87.024073
          ],
          [
            9.981737,
            53.793114,
            87.179589
          ],
          [
            9.981844,
            53.793336,
            87.338894
          ],
          [
            9.981966,
            53.793516,
            87.473077
          ],
          [
            9.98206,
            53.793713,
            87.524662
          ],
          [
            9.982317,
            53.793803,
            87.113595
          ],
          [
            9.982217,
            53.793537,
            86.560537
          ],
          [
            9.982243,
            53.793349,
            86.157859
          ],
          [
            9.982332,
            53.793139,
            85.719555
          ],
          [
            9.982468,
            53.792928,
            85.262394
          ],
          [
            9.98266,
            53.792751,
            84.835907
          ],
          [
            9.982896,
            53.792581,
            84.391689
          ],
          [
            9.983109,
            53.792434,
            84.000663
          ],
          [
            9.983351,
            53.792287,
            83.75205
          ],
          [
            9.983608,
            53.792148,
            83.521562
          ],
          [
            9.983944,
            53.792022,
            83.256714
          ],
          [
            9.984247,
            53.791921,
            83.026133
          ],
          [
            9.984572,
            53.791851,
            82.796684
          ],
          [
            9.984998,
            53.791775,
            82.502245
          ],
          [
            9.985355,
            53.791717,
            82.257503
          ],
          [
            9.985719,
            53.791695,
            82.015629
          ],
          [
            9.98605,
            53.791695,
            81.977957
          ],
          [
            9.986366,
            53.791713,
            82.023628
          ],
          [
            9.986717,
            53.791758,
            82.075132
          ],
          [
            9.987112,
            53.791816,
            82.133546
          ],
          [
            9.987456,
            53.791889,
            82.185976
          ],
          [
            9.987791,
            53.791965,
            82.237439
          ],
          [
            9.988169,
            53.792064,
            82.296789
          ],
          [
            9.988488,
            53.792112,
            82.344018
          ],
          [
            9.988881,
            53.792166,
            82.35558
          ],
          [
            9.989254,
            53.79222,
            82.28094
          ],
          [
            9.989602,
            53.792241,
            82.212951
          ],
          [
            9.990036,
            53.792251,
            82.128515
          ],
          [
            9.990392,
            53.792269,
            82.059072
          ],
          [
            9.990735,
            53.792288,
            81.992052
          ],
          [
            9.99109,
            53.792244,
            81.921485
          ],
          [
            9.99142,
            53.792236,
            81.857282
          ],
          [
            9.99178,
            53.792215,
            81.820531
          ],
          [
            9.992144,
            53.792208,
            82.433803
          ],
          [
            9.992535,
            53.792211,
            83.093453
          ],
          [
            9.992947,
            53.79221,
            83.787737
          ],
          [
            9.993321,
            53.792208,
            84.417394
          ],
          [
            9.993688,
            53.792219,
            85.03603
          ],
          [
            9.994013,
            53.792207,
            85.584261
          ],
          [
            9.994378,
            53.792208,
            86.199254
          ],
          [
            9.994742,
            53.792187,
            86.814937
          ],
          [
            9.995111,
            53.792174,
            86.962262
          ],
          [
            9.99547,
            53.792165,
            87.015693
          ],
          [
            9.995836,
            53.792156,
            87.070296
          ],
          [
            9.996223,
            53.79215,
            87.127884
          ],
          [
            9.996628,
            53.792137,
            87.188197
          ],
          [
            9.996995,
            53.792121,
            87.242907
          ],
          [
            9.997317,
            53.792124,
            87.290972
          ],
          [
            9.997684,
            53.792128,
            87.345551
          ],
          [
            9.998049,
            53.792097,
            87.141481
          ],
          [
            9.998402,
            53.792087,
            86.762215
          ],
          [
            9.998738,
            53.792077,
            86.400551
          ],
          [
            9.999062,
            53.792043,
            86.047684
          ],
          [
            9.999433,
            53.79201,
            85.645269
          ],
          [
            9.999796,
            53.791961,
            85.245466
          ],
          [
            10.000196,
            53.791916,
            84.808873
          ],
          [
            10.000609,
            53.79185,
            84.349978
          ],
          [
            10.000985,
            53.791798,
            84.049869
          ],
          [
            10.00135,
            53.791759,
            83.921562
          ],
          [
            10.001703,
            53.7917,
            83.79448
          ],
          [
            10.002077,
            53.79165,
            83.661512
          ],
          [
            10.002384,
            53.7916,
            83.551351
          ],
          [
            10.002731,
            53.791543,
            83.426521
          ],
          [
            10.003093,
            53.791497,
            83.298446
          ],
          [
            10.003481,
            53.791441,
            83.160311
          ],
          [
            10.003806,
            53.791384,
            83.056584
          ],
          [
            10.004182,
            53.79134,
            83.14386
          ],
          [
            10.004541,
            53.791283,
            83.228532
          ],
          [
            10.004959,
            53.79123,
            83.32584
          ],
          [
            10.005426,
            53.791171,
            83.436185
          ],
          [
            10.005741,
            53.791118,
            83.51083
          ],
          [
            10.006107,
            53.791067,
            83.597075
          ],
          [
            10.006463,
            53.791031,
            83.681879
          ],
          [
            10.00676,
            53.790975,
            83.715887
          ],
          [
            10.007061,
            53.790931,
            83.493384
          ],
          [
            10.007377,
            53.790879,
            83.262372
          ],
          [
            10.007743,
            53.790832,
            82.998799
          ],
          [
            10.00809,
            53.790765,
            82.741899
          ],
          [
            10.008449,
            53.790715,
            82.481567
          ],
          [
            10.008775,
            53.790657,
            82.241566
          ],
          [
            10.009105,
            53.790605,
            81.998441
          ],
          [
            10.009462,
            53.79057,
            81.743775
          ],
          [
            10.009816,
            53.790512,
            81.580274
          ],
          [
            10.010219,
            53.790468,
            81.527301
          ],
          [
            10.010625,
            53.79045,
            81.474587
          ],
          [
            10.010975,
            53.790403,
            81.428349
          ],
          [
            10.011366,
            53.790348,
            81.376216
          ],
          [
            10.011747,
            53.790314,
            81.326489
          ],
          [
            10.012105,
            53.790246,
            81.278077
          ],
          [
            10.012456,
            53.79018,
            81.230657
          ],
          [
            10.012812,
            53.790116,
            81.234802
          ],
          [
            10.013162,
            53.79005,
            81.278676
          ],
          [
            10.013512,
            53.790014,
            81.321051
          ],
          [
            10.01388,
            53.789943,
            81.367399
          ],
          [
            10.014261,
            53.789866,
            81.415532
          ],
          [
            10.014609,
            53.789849,
            81.457499
          ],
          [
            10.014973,
            53.789869,
            81.501557
          ],
          [
            10.015429,
            53.78977,
            81.560385
          ],
          [
            10.015722,
            53.789674,
            81.492665
          ],
          [
            10.016042,
            53.789562,
            81.363868
          ],
          [
            10.016304,
            53.789424,
            81.242302
          ],
          [
            10.016564,
            53.78929,
            81.122752
          ],
          [
            10.01689,
            53.789172,
            80.990108
          ],
          [
            10.017171,
            53.789049,
            80.869014
          ],
          [
            10.017477,
            53.788956,
            80.748612
          ],
          [
            10.017828,
            53.788835,
            80.607842
          ],
          [
            10.018101,
            53.788727,
            80.511214
          ],
          [
            10.018514,
            53.788592,
            80.463426
          ],
          [
            10.018888,
            53.788496,
            80.422102
          ],
          [
            10.019205,
            53.788413,
            80.386999
          ],
          [
            10.019585,
            53.788333,
            80.346154
          ],
          [
            10.019976,
            53.788255,
            80.304372
          ],
          [
            10.02034,
            53.788175,
            80.265053
          ],
          [
            10.020726,
            53.788098,
            80.223808
          ],
          [
            10.021082,
            53.788052,
            80.488547
          ],
          [
            10.021455,
            53.787956,
            80.975898
          ],
          [
            10.02184,
            53.787879,
            81.462756
          ],
          [
            10.022208,
            53.787818,
            81.920809
          ],
          [
            10.022554,
            53.787763,
            82.349996
          ],
          [
            10.02292,
            53.787713,
            82.800875
          ],
          [
            10.023267,
            53.787635,
            83.246032
          ],
          [
            10.023587,
            53.787565,
            83.655545
          ],
          [
            10.023998,
            53.787505,
            83.879549
          ],
          [
            10.024318,
            53.78743,
            83.912071
          ],
          [
            10.024711,
            53.787367,
            83.950581
          ],
          [
            10.025079,
            53.787318,
            83.986211
          ],
          [
            10.025468,
            53.787245,
            84.024767
          ],
          [
            10.025802,
            53.787175,
            84.05826
          ],
          [
            10.026216,
            53.787128,
            84.098232
          ],
          [
            10.026614,
            53.787065,
            84.137327
          ],
          [
            10.026981,
            53.786982,
            84.078836
          ],
          [
            10.027305,
            53.78691,
            84.012508
          ],
          [
            10.027629,
            53.786844,
            83.946857
          ],
          [
            10.027967,
            53.786806,
            83.880824
          ],
          [
            10.028346,
            53.786723,
            83.803393
          ],
          [
            10.028649,
            53.78667,
            83.742793
          ],
          [
            10.029003,
            53.786598,
            83.671076
          ],
          [
            10.02933,
            53.786537,
            83.605395
          ],
          [
            10.029643,
            53.786476,
            83.613179
          ],
          [
            10.029952,
            53.78642,
            83.801741
          ],
          [
            10.03029,
            53.78635,
            84.010845
          ],
          [
            10.030623,
            53.7863,
            84.211148
          ],
          [
            10.030971,
            53.786238,
            84.422995
          ],
          [
            10.031316,
            53.786168,
            84.635749
          ],
          [
            10.031616,
            53.786119,
            84.81762
          ],
          [
            10.031977,
            53.786064,
            85.034944
          ],
          [
            10.032335,
            53.785992,
            85.25562
          ],
          [
            10.032695,
            53.785925,
            85.496317
          ],
          [
            10.033043,
            53.785866,
            85.738165
          ],
          [
            10.033362,
            53.785797,
            85.965399
          ],
          [
            10.033685,
            53.785742,
            86.190191
          ],
          [
            10.034023,
            53.78569,
            86.4235
          ],
          [
            10.034396,
            53.785634,
            86.681373
          ],
          [
            10.03471,
            53.785566,
            86.904886
          ],
          [
            10.035036,
            53.78552,
            87.12901
          ],
          [
            10.035381,
            53.785428,
            87.3649
          ],
          [
            10.035707,
            53.785375,
            87.324994
          ],
          [
            10.036027,
            53.785335,
            87.286713
          ],
          [
            10.036439,
            53.785272,
            87.237078
          ],
          [
            10.036836,
            53.785209,
            87.189098
          ],
          [
            10.03718,
            53.785139,
            87.146657
          ],
          [
            10.037535,
            53.785056,
            87.102072
          ],
          [
            10.037913,
            53.784994,
            87.056335
          ],
          [
            10.038274,
            53.784919,
            87.013278
          ],
          [
            10.03862,
            53.784862,
            87.026959
          ],
          [
            10.038997,
            53.784797,
            87.041916
          ],
          [
            10.03939,
            53.784724,
            87.057606
          ],
          [
            10.039777,
            53.784648,
            87.073143
          ],
          [
            10.040156,
            53.784572,
            87.088389
          ],
          [
            10.040562,
            53.784491,
            87.104732
          ],
          [
            10.040953,
            53.784415,
            87.120409
          ],
          [
            10.041339,
            53.784358,
            87.230862
          ],
          [
            10.041742,
            53.784293,
            87.47235
          ],
          [
            10.042051,
            53.784231,
            87.660963
          ],
          [
            10.042395,
            53.784159,
            87.87218
          ],
          [
            10.042785,
            53.784069,
            88.115173
          ],
          [
            10.043164,
            53.784027,
            88.338067
          ],
          [
            10.043524,
            53.78397,
            88.553595
          ],
          [
            10.043902,
            53.783897,
            88.783479
          ],
          [
            10.044258,
            53.783841,
            88.77609
          ],
          [
            10.04458,
            53.783779,
            88.57308
          ],
          [
            10.044934,
            53.78372,
            88.352568
          ],
          [
            10.045287,
            53.783642,
            88.126699
          ],
          [
            10.045659,
            53.783587,
            87.896835
          ],
          [
            10.045994,
            53.783544,
            87.690651
          ],
          [
            10.046364,
            53.783512,
            87.46633
          ],
          [
            10.046667,
            53.783458,
            87.276649
          ],
          [
            10.047038,
            53.783406,
            87.069677
          ],
          [
            10.04736,
            53.78335,
            87.143228
          ],
          [
            10.047731,
            53.783317,
            87.225527
          ],
          [
            10.048105,
            53.78325,
            87.311293
          ],
          [
            10.048442,
            53.783201,
            87.387395
          ],
          [
            10.048801,
            53.783158,
            87.467666
          ],
          [
            10.049188,
            53.783108,
            87.554568
          ],
          [
            10.049605,
            53.783045,
            87.648907
          ],
          [
            10.050009,
            53.783001,
            87.720498
          ],
          [
            10.050397,
            53.782962,
            87.607979
          ],
          [
            10.050758,
            53.782913,
            87.502087
          ],
          [
            10.05114,
            53.782874,
            87.391262
          ],
          [
            10.051536,
            53.782827,
            87.275765
          ],
          [
            10.051904,
            53.782789,
            87.168966
          ],
          [
            10.052287,
            53.782746,
            87.057505
          ],
          [
            10.052672,
            53.782695,
            86.944551
          ],
          [
            10.053088,
            53.782624,
            86.80001
          ],
          [
            10.053473,
            53.782597,
            86.631845
          ],
          [
            10.053839,
            53.782551,
            86.46952
          ],
          [
            10.054161,
            53.782504,
            86.325667
          ],
          [
            10.054527,
            53.782452,
            86.16238
          ],
          [
            10.054904,
            53.782399,
            85.994269
          ],
          [
            10.055291,
            53.782346,
            85.821986
          ],
          [
            10.055703,
            53.782302,
            85.640408
          ],
          [
            10.056116,
            53.782257,
            85.542207
          ],
          [
            10.056512,
            53.782208,
            85.545662
          ],
          [
            10.056852,
            53.782182,
            85.548588
          ],
          [
            10.057262,
            53.782119,
            85.552204
          ],
          [
            10.057653,
            53.782067,
            85.555625
          ],
          [
            10.05801,
            53.782016,
            85.55876
          ],
          [
            10.058423,
            53.781961,
            85.562374
          ],
          [
            10.05882,
            53.781917,
            85.565822
          ],
          [
            10.059229,
            53.781861,
            85.356435
          ],
          [
            10.059666,
            53.781809,
            85.075189
          ],
          [
            10.060103,
            53.781757,
            84.793953
          ],
          [
            10.060509,
            53.78172,
            84.53478
          ],
          [
            10.060926,
            53.781676,
            84.267474
          ],
          [
            10.061343,
            53.781625,
            83.998687
          ],
          [
            10.06175,
            53.781566,
            83.734281
          ],
          [
            10.06216,
            53.781523,
            83.774915
          ],
          [
            10.062587,
            53.781473,
            83.977529
          ],
          [
            10.063012,
            53.781452,
            84.176028
          ],
          [
            10.063407,
            53.781454,
            84.360037
          ],
          [
            10.063808,
            53.781438,
            84.547096
          ],
          [
            10.064226,
            53.781426,
            84.74192
          ],
          [
            10.064592,
            53.781428,
            84.912381
          ],
          [
            10.065017,
            53.781433,
            85.031394
          ],
          [
            10.065428,
            53.781427,
            84.904785
          ],
          [
            10.06582,
            53.781451,
            84.782973
          ],
          [
            10.066193,
            53.781455,
            84.668083
          ],
          [
            10.066552,
            53.781436,
            84.55707
          ],
          [
            10.066902,
            53.781436,
            84.449039
          ],
          [
            10.067256,
            53.78142,
            84.339606
          ],
          [
            10.06761,
            53.781429,
            84.230487
          ],
          [
            10.067934,
            53.781433,
            84.130664
          ],
          [
            10.068258,
            53.78146,
            84.4993
          ],
          [
            10.068601,
            53.781457,
            84.912633
          ],
          [
            10.06904,
            53.78145,
            85.444665
          ],
          [
            10.069393,
            53.781443,
            85.872347
          ],
          [
            10.069778,
            53.781434,
            86.336655
          ],
          [
            10.070167,
            53.781427,
            86.805538
          ],
          [
            10.070531,
            53.781421,
            87.244271
          ],
          [
            10.070882,
            53.781421,
            87.667154
          ],
          [
            10.07124,
            53.781414,
            87.526373
          ],
          [
            10.071591,
            53.781438,
            87.155303
          ],
          [
            10.071989,
            53.781455,
            86.736731
          ],
          [
            10.072371,
            53.781468,
            86.335283
          ],
          [
            10.072719,
            53.781491,
            85.967188
          ],
          [
            10.073084,
            53.781532,
            85.577163
          ],
          [
            10.073429,
            53.781565,
            85.210551
          ],
          [
            10.073811,
            53.781629,
            84.793892
          ],
          [
            10.074169,
            53.781694,
            84.446612
          ],
          [
            10.074504,
            53.781765,
            84.158401
          ],
          [
            10.074814,
            53.781825,
            83.894079
          ],
          [
            10.075187,
            53.781904,
            83.572968
          ],
          [
            10.07549,
            53.782027,
            83.275364
          ],
          [
            10.075879,
            53.782101,
            82.944561
          ],
          [
            10.076213,
            53.782122,
            82.67267
          ],
          [
            10.076563,
            53.78222,
            82.35349
          ],
          [
            10.076787,
            53.782354,
            82.191221
          ],
          [
            10.077107,
            53.782478,
            82.601593
          ],
          [
            10.077456,
            53.782593,
            83.03129
          ],
          [
            10.077759,
            53.782731,
            83.441278
          ],
          [
            10.07811,
            53.782811,
            83.84549
          ],
          [
            10.078433,
            53.782961,
            84.286987
          ],
          [
            10.078434,
            53.782953,
            84.679374
          ],
          [
            10.078466,
            53.782929,
            85.029132
          ],
          [
            10.078711,
            53.783137,
            85.407395
          ],
          [
            10.078888,
            53.783324,
            85.444841
          ],
          [
            10.079061,
            53.783504,
            85.480579
          ],
          [
            10.079045,
            53.783687,
            85.512655
          ],
          [
            10.079194,
            53.783851,
            85.545967
          ],
          [
            10.079452,
            53.784007,
            85.583617
          ],
          [
            10.079697,
            53.784161,
            85.620106
          ],
          [
            10.079941,
            53.784316,
            85.656649
          ],
          [
            10.080173,
            53.784486,
            85.694471
          ],
          [
            10.080395,
            53.784643,
            85.63093
          ],
          [
            10.08062,
            53.784802,
            85.496604
          ],
          [
            10.080866,
            53.784971,
            85.352102
          ],
          [
            10.081127,
            53.785122,
            85.211851
          ],
          [
            10.081398,
            53.785299,
            85.057246
          ],
          [
            10.081682,
            53.785465,
            84.904362
          ],
          [
            10.081934,
            53.78562,
            84.765152
          ],
          [
            10.082178,
            53.785764,
            84.633175
          ],
          [
            10.082423,
            53.785905,
            84.667672
          ],
          [
            10.082703,
            53.786053,
            85.094814
          ],
          [
            10.082934,
            53.786227,
            85.519136
          ],
          [
            10.08317,
            53.786401,
            85.946974
          ],
          [
            10.083412,
            53.78657,
            86.372702
          ],
          [
            10.083669,
            53.786716,
            86.776877
          ],
          [
            10.083939,
            53.786899,
            87.242978
          ],
          [
            10.084201,
            53.78706,
            87.671832
          ],
          [
            10.084429,
            53.787232,
            87.894927
          ],
          [
            10.084646,
            53.787403,
            87.469508
          ],
          [
            10.084911,
            53.787573,
            87.009383
          ],
          [
            10.085174,
            53.787738,
            86.557363
          ],
          [
            10.085452,
            53.787924,
            86.063505
          ],
          [
            10.085709,
            53.788086,
            85.621089
          ],
          [
            10.086007,
            53.788283,
            85.095246
          ],
          [
            10.086268,
            53.78845,
            84.642817
          ],
          [
            10.086546,
            53.788649,
            84.288253
          ],
          [
            10.086818,
            53.788819,
            84.080952
          ],
          [
            10.087112,
            53.789009,
            83.851942
          ],
          [
            10.087383,
            53.789179,
            83.644974
          ],
          [
            10.087611,
            53.789329,
            83.466592
          ],
          [
            10.087833,
            53.789494,
            83.28022
          ],
          [
            10.088088,
            53.789656,
            83.084566
          ],
          [
            10.088335,
            53.789814,
            82.89432
          ],
          [
            10.088565,
            53.789969,
            82.144305
          ],
          [
            10.08886,
            53.790113,
            80.93996
          ],
          [
            10.089157,
            53.790244,
            79.770753
          ],
          [
            10.089444,
            53.790407,
            78.517984
          ],
          [
            10.089798,
            53.790577,
            77.080807
          ],
          [
            10.09006,
            53.790758,
            75.81032
          ],
          [
            10.090354,
            53.790906,
            74.591885
          ],
          [
            10.090709,
            53.791001,
            73.365114
          ],
          [
            10.091038,
            53.791094,
            73.519539
          ],
          [
            10.09131,
            53.791239,
            73.829558
          ],
          [
            10.091609,
            53.791363,
            74.13777
          ],
          [
            10.091934,
            53.791474,
            74.454487
          ],
          [
            10.092239,
            53.791572,
            74.747392
          ],
          [
            10.092558,
            53.791714,
            75.085219
          ],
          [
            10.092937,
            53.791847,
            75.457193
          ],
          [
            10.093266,
            53.791962,
            75.780058
          ],
          [
            10.093587,
            53.792055,
            75.633948
          ],
          [
            10.093891,
            53.792196,
            75.417861
          ],
          [
            10.094281,
            53.79228,
            75.185972
          ],
          [
            10.094567,
            53.792412,
            74.981137
          ],
          [
            10.094869,
            53.792509,
            74.78913
          ],
          [
            10.095209,
            53.79261,
            74.576292
          ],
          [
            10.095502,
            53.792673,
            74.401455
          ],
          [
            10.095832,
            53.792781,
            74.190712
          ],
          [
            10.096103,
            53.792896,
            73.919377
          ],
          [
            10.096416,
            53.793019,
            73.543926
          ],
          [
            10.096741,
            53.793126,
            73.172241
          ],
          [
            10.097068,
            53.793255,
            72.77945
          ],
          [
            10.097364,
            53.793354,
            72.439619
          ],
          [
            10.097692,
            53.793482,
            72.047001
          ],
          [
            10.098035,
            53.793641,
            71.611554
          ],
          [
            10.098347,
            53.793773,
            71.228082
          ],
          [
            10.098675,
            53.793889,
            70.851162
          ],
          [
            10.098961,
            53.794006,
            70.511261
          ],
          [
            10.099291,
            53.794118,
            70.138825
          ],
          [
            10.099615,
            53.794232,
            69.76967
          ],
          [
            10.09992,
            53.794349,
            69.414167
          ],
          [
            10.100263,
            53.794474,
            69.019363
          ],
          [
            10.100595,
            53.794593,
            68.639922
          ],
          [
            10.10095,
            53.794732,
            68.223449
          ],
          [
            10.101233,
            53.794833,
            68.221514
          ],
          [
            10.101688,
            53.794956,
            68.53613
          ],
          [
            10.102026,
            53.795082,
            68.78529
          ],
          [
            10.102395,
            53.795182,
            69.03966
          ],
          [
            10.102812,
            53.795278,
            69.319349
          ],
          [
            10.103173,
            53.795379,
            69.568425
          ],
          [
            10.103477,
            53.795452,
            69.773061
          ],
          [
            10.103836,
            53.795543,
            70.031228
          ],
          [
            10.104158,
            53.795616,
            70.385472
          ],
          [
            10.104525,
            53.795696,
            70.786072
          ],
          [
            10.104899,
            53.795776,
            71.193466
          ],
          [
            10.105225,
            53.795843,
            71.547197
          ],
          [
            10.105533,
            53.795902,
            71.878767
          ],
          [
            10.105911,
            53.795977,
            72.289861
          ],
          [
            10.106276,
            53.796088,
            72.71024
          ],
          [
            10.10673,
            53.796149,
            73.121269
          ],
          [
            10.107033,
            53.79622,
            73.158542
          ],
          [
            10.107352,
            53.796291,
            73.197537
          ],
          [
            10.107688,
            53.796354,
            73.237811
          ],
          [
            10.108053,
            53.796414,
            73.281283
          ],
          [
            10.108472,
            53.796479,
            73.330905
          ],
          [
            10.10882,
            53.796528,
            73.371772
          ],
          [
            10.109153,
            53.79655,
            73.410052
          ],
          [
            10.109466,
            53.796592,
            73.446768
          ],
          [
            10.109784,
            53.796627,
            73.392476
          ],
          [
            10.11013,
            53.79667,
            73.273241
          ],
          [
            10.110524,
            53.796693,
            73.138985
          ],
          [
            10.110901,
            53.796726,
            73.010395
          ],
          [
            10.111239,
            53.796763,
            72.894184
          ],
          [
            10.111602,
            53.796793,
            72.770634
          ],
          [
            10.111933,
            53.796833,
            72.655854
          ],
          [
            10.112313,
            53.796858,
            72.52697
          ],
          [
            10.112697,
            53.796893,
            72.35608
          ],
          [
            10.113058,
            53.796925,
            72.104101
          ],
          [
            10.113419,
            53.796949,
            71.853562
          ],
          [
            10.113745,
            53.796955,
            71.62748
          ],
          [
            10.114164,
            53.796995,
            71.334857
          ],
          [
            10.114496,
            53.797028,
            71.102758
          ],
          [
            10.1149,
            53.797064,
            70.821069
          ],
          [
            10.115342,
            53.797111,
            70.511459
          ],
          [
            10.115781,
            53.797138,
            70.307927
          ],
          [
            10.116157,
            53.797164,
            70.25361
          ],
          [
            10.11658,
            53.797198,
            70.192243
          ],
          [
            10.116998,
            53.797239,
            70.131411
          ],
          [
            10.117417,
            53.797285,
            70.070269
          ],
          [
            10.117797,
            53.797319,
            70.014662
          ],
          [
            10.11822,
            53.797353,
            69.953405
          ],
          [
            10.118631,
            53.797381,
            69.898895
          ],
          [
            10.119017,
            53.797428,
            69.912488
          ],
          [
            10.119417,
            53.797439,
            69.926302
          ],
          [
            10.119813,
            53.797466,
            69.940047
          ],
          [
            10.120205,
            53.79749,
            69.953637
          ],
          [
            10.120608,
            53.797526,
            69.967694
          ],
          [
            10.120978,
            53.797573,
            69.980769
          ],
          [
            10.121341,
            53.797588,
            69.993343
          ],
          [
            10.121712,
            53.797633,
            70.13005
          ],
          [
            10.122072,
            53.797678,
            70.596108
          ],
          [
            10.122405,
            53.797682,
            71.017898
          ],
          [
            10.122709,
            53.797724,
            71.414134
          ],
          [
            10.123056,
            53.797778,
            71.868763
          ],
          [
            10.12344,
            53.797807,
            72.359124
          ],
          [
            10.123802,
            53.797836,
            72.821778
          ],
          [
            10.124165,
            53.797856,
            73.283525
          ],
          [
            10.124501,
            53.79791,
            73.724495
          ],
          [
            10.124878,
            53.797938,
            74.059842
          ],
          [
            10.125223,
            53.797965,
            74.316437
          ],
          [
            10.125552,
            53.798009,
            74.563719
          ],
          [
            10.125866,
            53.798059,
            74.802131
          ],
          [
            10.126223,
            53.798122,
            75.075564
          ],
          [
            10.126585,
            53.798164,
            75.345998
          ],
          [
            10.126937,
            53.798174,
            75.604894
          ],
          [
            10.127274,
            53.798205,
            75.854978
          ],
          [
            10.127648,
            53.798238,
            76.076061
          ],
          [
            10.12804,
            53.798244,
            75.96458
          ],
          [
            10.128414,
            53.798301,
            75.854457
          ],
          [
            10.128801,
            53.798334,
            75.743836
          ],
          [
            10.129164,
            53.798359,
            75.640429
          ],
          [
            10.129512,
            53.798364,
            75.541858
          ],
          [
            10.129809,
            53.798405,
            75.454615
          ],
          [
            10.130133,
            53.798456,
            75.359524
          ],
          [
            10.130446,
            53.798511,
            75.267102
          ],
          [
            10.130819,
            53.798557,
            75.408862
          ],
          [
            10.131133,
            53.798573,
            75.631523
          ],
          [
            10.131478,
            53.798592,
            75.87628
          ],
          [
            10.131823,
            53.798636,
            76.12587
          ],
          [
            10.132163,
            53.798674,
            76.370357
          ],
          [
            10.132504,
            53.798703,
            76.613747
          ],
          [
            10.132893,
            53.798739,
            76.891875
          ],
          [
            10.133224,
            53.798761,
            77.127165
          ],
          [
            10.133594,
            53.7988,
            77.363919
          ],
          [
            10.13395,
            53.798845,
            76.946468
          ],
          [
            10.134272,
            53.798881,
            76.569836
          ],
          [
            10.134581,
            53.798891,
            76.213713
          ],
          [
            10.134926,
            53.798932,
            75.809885
          ],
          [
            10.135306,
            53.798949,
            75.372857
          ],
          [
            10.135671,
            53.798982,
            74.947597
          ],
          [
            10.136023,
            53.798998,
            74.541935
          ],
          [
            10.136371,
            53.798997,
            74.14296
          ],
          [
            10.136741,
            53.798985,
            74.209624
          ],
          [
            10.137099,
            53.799012,
            74.974879
          ],
          [
            10.137445,
            53.799028,
            75.710964
          ],
          [
            10.13778,
            53.799007,
            76.425711
          ],
          [
            10.138109,
            53.798971,
            77.135896
          ],
          [
            10.138266,
            53.79905,
            77.821528
          ],
          [
            10.138299,
            53.798826,
            78.633811
          ],
          [
            10.138289,
            53.79859,
            79.483166
          ],
          [
            10.13852,
            53.798471,
            80.202705
          ],
          [
            10.138802,
            53.798607,
            79.563492
          ],
          [
            10.138961,
            53.798771,
            78.769904
          ],
          [
            10.139027,
            53.798975,
            77.896114
          ],
          [
            10.139355,
            53.799029,
            77.051727
          ],
          [
            10.139756,
            53.799058,
            76.050001
          ],
          [
            10.140097,
            53.799041,
            75.199818
          ],
          [
            10.140422,
            53.799035,
            74.38663
          ],
          [
            10.140735,
            53.799048,
            73.596851
          ],
          [
            10.141085,
            53.799024,
            72.786265
          ],
          [
            10.141517,
            53.799018,
            72.600923
          ],
          [
            10.141926,
            53.799027,
            72.425325
          ],
          [
            10.142311,
            53.799056,
            72.258848
          ],
          [
            10.142692,
            53.799031,
            72.092078
          ],
          [
            10.143006,
            53.79903,
            71.957084
          ],
          [
            10.143334,
            53.799042,
            71.816121
          ],
          [
            10.143654,
            53.79907,
            71.677358
          ],
          [
            10.143962,
            53.799059,
            71.544683
          ],
          [
            10.144284,
            53.799072,
            71.737778
          ],
          [
            10.144609,
            53.799095,
            72.130875
          ],
          [
            10.144965,
            53.799071,
            72.561294
          ],
          [
            10.145299,
            53.799129,
            72.979372
          ],
          [
            10.145613,
            53.799,
            73.445895
          ],
          [
            10.14543,
            53.79888,
            73.843442
          ],
          [
            10.145511,
            53.798778,
            74.258532
          ],
          [
            10.145925,
            53.798791,
            74.756402
          ],
          [
            10.146337,
            53.798778,
            75.032845
          ],
          [
            10.146712,
            53.798796,
            74.50606
          ],
          [
            10.147046,
            53.79885,
            73.996494
          ],
          [
            10.147187,
            53.798976,
            73.539443
          ],
          [
            10.147552,
            53.799016,
            73.023404
          ],
          [
            10.147954,
            53.799044,
            72.461372
          ],
          [
            10.148377,
            53.79905,
            71.872715
          ],
          [
            10.148738,
            53.799042,
            71.371024
          ],
          [
            10.149139,
            53.799057,
            70.907565
          ],
          [
            10.149511,
            53.799137,
            70.832514
          ],
          [
            10.14989,
            53.79917,
            70.759915
          ],
          [
            10.150337,
            53.799204,
            70.67467
          ],
          [
            10.150653,
            53.799227,
            70.614392
          ],
          [
            10.15103,
            53.799262,
            70.542213
          ],
          [
            10.151457,
            53.799304,
            70.460275
          ],
          [
            10.151883,
            53.799351,
            70.378274
          ],
          [
            10.152249,
            53.799376,
            70.371645
          ],
          [
            10.15265,
            53.799406,
            70.421704
          ],
          [
            10.152977,
            53.799434,
            70.462634
          ],
          [
            10.153388,
            53.799482,
            70.514537
          ],
          [
            10.153764,
            53.799506,
            70.561814
          ],
          [
            10.154173,
            53.799546,
            70.613191
          ],
          [
            10.154486,
            53.799574,
            70.652396
          ],
          [
            10.154921,
            53.799614,
            70.706922
          ],
          [
            10.155229,
            53.799658,
            70.648008
          ],
          [
            10.155561,
            53.799717,
            70.502441
          ],
          [
            10.155916,
            53.79975,
            70.352311
          ],
          [
            10.156347,
            53.799774,
            70.171453
          ],
          [
            10.156679,
            53.799843,
            70.024398
          ],
          [
            10.157064,
            53.799869,
            69.8625
          ],
          [
            10.15739,
            53.799887,
            69.725549
          ],
          [
            10.157719,
            53.799903,
            69.586506
          ],
          [
            10.158084,
            53.799945,
            69.436446
          ],
          [
            10.158503,
            53.799994,
            69.305042
          ],
          [
            10.158885,
            53.80004,
            69.183891
          ],
          [
            10.159225,
            53.800086,
            69.076608
          ],
          [
            10.159594,
            53.800119,
            68.961446
          ],
          [
            10.15997,
            53.800133,
            68.84558
          ],
          [
            10.160357,
            53.800188,
            68.723118
          ],
          [
            10.160657,
            53.80023,
            68.628197
          ],
          [
            10.161022,
            53.800257,
            68.515074
          ],
          [
            10.161382,
            53.800283,
            68.870752
          ],
          [
            10.161732,
            53.800334,
            69.224205
          ],
          [
            10.162115,
            53.800399,
            69.614686
          ],
          [
            10.162537,
            53.800443,
            70.034822
          ],
          [
            10.162922,
            53.800488,
            70.419389
          ],
          [
            10.163275,
            53.800522,
            70.771179
          ],
          [
            10.163625,
            53.800576,
            71.125903
          ],
          [
            10.163985,
            53.800645,
            71.497194
          ],
          [
            10.16435,
            53.800683,
            71.231786
          ],
          [
            10.16468,
            53.800718,
            70.988724
          ],
          [
            10.164979,
            53.800765,
            70.764221
          ],
          [
            10.165418,
            53.800791,
            70.443425
          ],
          [
            10.165758,
            53.800847,
            70.187219
          ],
          [
            10.166101,
            53.80089,
            69.932694
          ],
          [
            10.166445,
            53.800934,
            69.677538
          ],
          [
            10.166785,
            53.800973,
            69.426454
          ],
          [
            10.167155,
            53.801022,
            69.274735
          ],
          [
            10.1675,
            53.801063,
            69.244424
          ],
          [
            10.167849,
            53.801116,
            69.213226
          ],
          [
            10.168187,
            53.801151,
            69.183642
          ],
          [
            10.168541,
            53.801203,
            69.152215
          ],
          [
            10.168882,
            53.801218,
            69.122673
          ],
          [
            10.169216,
            53.80125,
            69.09352
          ],
          [
            10.169553,
            53.801307,
            69.063077
          ],
          [
            10.169872,
            53.801362,
            69.034389
          ],
          [
            10.17021,
            53.801386,
            69.400097
          ],
          [
            10.170548,
            53.801442,
            69.867312
          ],
          [
            10.170896,
            53.801487,
            70.341025
          ],
          [
            10.17125,
            53.801522,
            70.817969
          ],
          [
            10.171552,
            53.801564,
            71.230288
          ],
          [
            10.171887,
            53.801592,
            71.679848
          ],
          [
            10.172214,
            53.801623,
            72.11991
          ],
          [
            10.17255,
            53.801667,
            72.579935
          ],
          [
            10.17287,
            53.801702,
            73.012819
          ],
          [
            10.173205,
            53.801755,
            72.848109
          ],
          [
            10.173573,
            53.801781,
            72.564791
          ],
          [
            10.173964,
            53.801832,
            72.260626
          ],
          [
            10.174354,
            53.801856,
            71.963217
          ],
          [
            10.174692,
            53.801862,
            71.706729
          ],
          [
            10.175027,
            53.80186,
            71.451593
          ],
          [
            10.17538,
            53.801883,
            71.182195
          ],
          [
            10.175734,
            53.801911,
            70.911278
          ],
          [
            10.176095,
            53.801911,
            70.758638
          ],
          [
            10.176456,
            53.801926,
            70.743209
          ],
          [
            10.176786,
            53.80193,
            70.729137
          ],
          [
            10.177138,
            53.801933,
            70.714128
          ],
          [
            10.177498,
            53.801938,
            70.698763
          ],
          [
            10.177863,
            53.801926,
            70.683169
          ],
          [
            10.17823,
            53.801937,
            70.667393
          ],
          [
            10.178565,
            53.801923,
            70.653075
          ],
          [
            10.178887,
            53.80191,
            70.639315
          ],
          [
            10.179238,
            53.801901,
            70.45741
          ],
          [
            10.179596,
            53.80192,
            70.223185
          ],
          [
            10.179944,
            53.801915,
            69.996227
          ],
          [
            10.180304,
            53.801898,
            69.760892
          ],
          [
            10.180637,
            53.801865,
            69.540698
          ],
          [
            10.181029,
            53.801886,
            69.284167
          ],
          [
            10.181361,
            53.801908,
            69.066475
          ],
          [
            10.181703,
            53.80191,
            68.843606
          ],
          [
            10.182041,
            53.801917,
            68.725492
          ],
          [
            10.182396,
            53.801936,
            69.332821
          ],
          [
            10.182779,
            53.801917,
            69.987976
          ],
          [
            10.183094,
            53.801932,
            70.527946
          ],
          [
            10.183452,
            53.801955,
            71.141857
          ],
          [
            10.183802,
            53.801978,
            71.741736
          ],
          [
            10.184134,
            53.801952,
            72.312703
          ],
          [
            10.184455,
            53.801953,
            72.861207
          ],
          [
            10.184799,
            53.801923,
            73.453882
          ],
          [
            10.18514,
            53.801963,
            73.713053
          ],
          [
            10.185506,
            53.801987,
            73.330098
          ],
          [
            10.1859,
            53.801968,
            72.919358
          ],
          [
            10.186271,
            53.801934,
            72.52363
          ],
          [
            10.186638,
            53.801975,
            72.13509
          ],
          [
            10.187028,
            53.80202,
            71.722297
          ],
          [
            10.18741,
            53.802048,
            71.32242
          ],
          [
            10.187803,
            53.80209,
            70.907551
          ],
          [
            10.188216,
            53.802147,
            70.761756
          ],
          [
            10.188562,
            53.802163,
            70.909879
          ],
          [
            10.188916,
            53.802229,
            71.068326
          ],
          [
            10.189247,
            53.802305,
            71.220035
          ],
          [
            10.18959,
            53.802394,
            71.380423
          ],
          [
            10.189985,
            53.802441,
            71.552402
          ],
          [
            10.190304,
            53.802495,
            71.694248
          ],
          [
            10.190709,
            53.802553,
            71.872395
          ],
          [
            10.191051,
            53.802614,
            71.796902
          ],
          [
            10.19141,
            53.802648,
            71.240765
          ],
          [
            10.191796,
            53.802686,
            70.625055
          ],
          [
            10.192113,
            53.802755,
            70.102048
          ],
          [
            10.192448,
            53.802804,
            69.571686
          ],
          [
            10.192765,
            53.802836,
            69.078929
          ],
          [
            10.193106,
            53.802882,
            68.54397
          ],
          [
            10.193432,
            53.802922,
            68.034742
          ],
          [
            10.193772,
            53.802984,
            67.487628
          ],
          [
            10.194129,
            53.803034,
            67.676497
          ],
          [
            10.194553,
            53.803116,
            68.300819
          ],
          [
            10.194927,
            53.803185,
            68.849152
          ],
          [
            10.195328,
            53.803262,
            69.439059
          ],
          [
            10.195719,
            53.803327,
            70.00773
          ],
          [
            10.196085,
            53.803397,
            70.546447
          ],
          [
            10.196452,
            53.803456,
            71.07935
          ],
          [
            10.196873,
            53.803507,
            71.581106
          ],
          [
            10.19725,
            53.803539,
            71.595823
          ],
          [
            10.19764,
            53.803592,
            71.611271
          ],
          [
            10.198015,
            53.803616,
            71.625838
          ],
          [
            10.198371,
            53.80364,
            71.639668
          ],
          [
            10.198758,
            53.803642,
            71.654609
          ],
          [
            10.199128,
            53.803649,
            71.668898
          ],
          [
            10.19952,
            53.803664,
            71.684067
          ],
          [
            10.199871,
            53.803657,
            71.686237
          ],
          [
            10.200233,
            53.803645,
            71.611571
          ],
          [
            10.20058,
            53.803676,
            71.539361
          ],
          [
            10.200992,
            53.803644,
            71.453969
          ],
          [
            10.201419,
            53.80361,
            71.36564
          ],
          [
            10.201815,
            53.803587,
            71.284075
          ],
          [
            10.202178,
            53.803558,
            71.209
          ],
          [
            10.202507,
            53.803535,
            71.141065
          ],
          [
            10.202833,
            53.803489,
            71.072051
          ],
          [
            10.203181,
            53.803443,
            71.140523
          ],
          [
            10.203544,
            53.80341,
            71.211814
          ],
          [
            10.203924,
            53.803333,
            71.290116
          ],
          [
            10.204337,
            53.803249,
            71.374896
          ],
          [
            10.204724,
            53.803181,
            71.453279
          ],
          [
            10.20505,
            53.803106,
            71.521164
          ],
          [
            10.205414,
            53.803029,
            71.596346
          ],
          [
            10.205778,
            53.802968,
            71.654123
          ],
          [
            10.206117,
            53.802855,
            71.564823
          ],
          [
            10.206477,
            53.80275,
            71.472503
          ],
          [
            10.206813,
            53.802662,
            71.388182
          ],
          [
            10.207146,
            53.802608,
            71.308746
          ],
          [
            10.207478,
            53.802541,
            71.228243
          ],
          [
            10.207841,
            53.802462,
            71.13952
          ],
          [
            10.208154,
            53.802397,
            71.063355
          ],
          [
            10.208527,
            53.802327,
            70.973265
          ],
          [
            10.208822,
            53.802251,
            70.955652
          ],
          [
            10.209133,
            53.802184,
            70.945687
          ],
          [
            10.209488,
            53.802115,
            70.934438
          ],
          [
            10.209776,
            53.802042,
            70.924999
          ],
          [
            10.210126,
            53.80194,
            70.913245
          ],
          [
            10.210506,
            53.801858,
            70.901067
          ],
          [
            10.210824,
            53.801789,
            70.890848
          ],
          [
            10.211215,
            53.801717,
            70.878516
          ],
          [
            10.211535,
            53.801643,
            70.994763
          ],
          [
            10.211855,
            53.801554,
            71.296777
          ],
          [
            10.212186,
            53.80148,
            71.599078
          ],
          [
            10.212487,
            53.801421,
            71.869523
          ],
          [
            10.212822,
            53.801378,
            72.162195
          ],
          [
            10.213137,
            53.801311,
            72.448004
          ],
          [
            10.213494,
            53.801225,
            72.776956
          ],
          [
            10.213809,
            53.801159,
            73.062143
          ],
          [
            10.214087,
            53.801055,
            73.34346
          ],
          [
            10.214441,
            53.800984,
            73.430848
          ],
          [
            10.214804,
            53.800896,
            73.363743
          ],
          [
            10.215179,
            53.800827,
            73.296455
          ],
          [
            10.21553,
            53.800725,
            73.229582
          ],
          [
            10.215824,
            53.800662,
            73.176126
          ],
          [
            10.216148,
            53.800611,
            73.11858
          ],
          [
            10.216455,
            53.800548,
            73.063029
          ],
          [
            10.216798,
            53.800468,
            72.999991
          ],
          [
            10.217112,
            53.800385,
            72.966052
          ],
          [
            10.21744,
            53.80031,
            73.093532
          ],
          [
            10.217736,
            53.800245,
            73.207903
          ],
          [
            10.218097,
            53.800176,
            73.345385
          ],
          [
            10.218442,
            53.8001,
            73.478722
          ],
          [
            10.218754,
            53.800021,
            73.601642
          ],
          [
            10.21907,
            53.799948,
            73.724788
          ],
          [
            10.219399,
            53.799877,
            73.851796
          ],
          [
            10.219768,
            53.799774,
            73.999652
          ],
          [
            10.220114,
            53.799692,
            74.081728
          ],
          [
            10.220482,
            53.799618,
            74.132696
          ],
          [
            10.220857,
            53.799554,
            74.183909
          ],
          [
            10.221167,
            53.799474,
            74.228301
          ],
          [
            10.221503,
            53.799403,
            74.275244
          ],
          [
            10.221862,
            53.799367,
            74.323139
          ],
          [
            10.2222,
            53.799294,
            74.370343
          ],
          [
            10.22256,
            53.799202,
            74.421828
          ],
          [
            10.222877,
            53.799128,
            74.483904
          ],
          [
            10.223179,
            53.799046,
            74.576139
          ],
          [
            10.223454,
            53.798958,
            74.663503
          ],
          [
            10.22376,
            53.798902,
            74.752966
          ],
          [
            10.224093,
            53.798827,
            74.851882
          ],
          [
            10.224406,
            53.79874,
            74.947904
          ],
          [
            10.224766,
            53.79867,
            75.053224
          ],
          [
            10.225058,
            53.798594,
            75.141857
          ],
          [
            10.225382,
            53.7985,
            75.242032
          ],
          [
            10.225727,
            53.798444,
            75.228982
          ],
          [
            10.226038,
            53.798375,
            75.092564
          ],
          [
            10.226347,
            53.798315,
            74.958991
          ],
          [
            10.226685,
            53.798242,
            74.811194
          ],
          [
            10.226987,
            53.79817,
            74.676703
          ],
          [
            10.227338,
            53.798117,
            74.527922
          ],
          [
            10.227742,
            53.798097,
            74.361252
          ],
          [
            10.228062,
            53.798096,
            74.229188
          ],
          [
            10.228383,
            53.798035,
            74.090677
          ],
          [
            10.22874,
            53.798033,
            74.008822
          ],
          [
            10.229061,
            53.798048,
            73.961034
          ],
          [
            10.229422,
            53.798075,
            73.907052
          ],
          [
            10.229809,
            53.798085,
            73.84965
          ],
          [
            10.230126,
            53.798095,
            73.802633
          ],
          [
            10.230513,
            53.798103,
            73.745273
          ],
          [
            10.230884,
            53.798084,
            73.690165
          ],
          [
            10.231236,
            53.798073,
            73.637981
          ],
          [
            10.231561,
            53.798047,
            73.611895
          ],
          [
            10.231903,
            53.797991,
            73.766864
          ],
          [
            10.232258,
            53.797978,
            73.918483
          ],
          [
            10.232579,
            53.798018,
            74.05971
          ],
          [
            10.232952,
            53.798003,
            74.219341
          ],
          [
            10.233286,
            53.797975,
            74.363484
          ],
          [
            10.233621,
            53.797948,
            74.508098
          ],
          [
            10.23394,
            53.797874,
            74.654255
          ],
          [
            10.234258,
            53.79778,
            74.806004
          ],
          [
            10.234613,
            53.797724,
            74.853145
          ],
          [
            10.234936,
            53.797687,
            74.772994
          ],
          [
            10.235276,
            53.797655,
            74.689161
          ],
          [
            10.235609,
            53.797619,
            74.606603
          ],
          [
            10.235973,
            53.797589,
            74.517097
          ],
          [
            10.236359,
            53.797559,
            74.42222
          ],
          [
            10.23675,
            53.797529,
            74.326211
          ],
          [
            10.237108,
            53.7975,
            74.238018
          ],
          [
            10.237452,
            53.79746,
            74.152563
          ],
          [
            10.237819,
            53.797431,
            74.339056
          ],
          [
            10.238195,
            53.79742,
            74.53213
          ],
          [
            10.238565,
            53.797418,
            74.721963
          ],
          [
            10.23894,
            53.79743,
            74.915638
          ],
          [
            10.239333,
            53.797422,
            75.116979
          ],
          [
            10.239705,
            53.797418,
            75.307554
          ],
          [
            10.240051,
            53.797473,
            75.49201
          ],
          [
            10.240444,
            53.797466,
            75.693331
          ],
          [
            10.240846,
            53.797451,
            75.7601
          ],
          [
            10.241296,
            53.797444,
            75.820417
          ],
          [
            10.241622,
            53.797435,
            75.864523
          ],
          [
            10.241969,
            53.797417,
            75.911383
          ],
          [
            10.242365,
            53.797384,
            75.96492
          ],
          [
            10.242729,
            53.797373,
            76.013795
          ],
          [
            10.243144,
            53.797372,
            76.069351
          ],
          [
            10.243536,
            53.797336,
            76.11952
          ],
          [
            10.243951,
            53.79733,
            76.134059
          ],
          [
            10.24436,
            53.797326,
            76.148382
          ],
          [
            10.244696,
            53.797324,
            76.160162
          ],
          [
            10.245064,
            53.797324,
            76.173059
          ],
          [
            10.245395,
            53.797288,
            76.184851
          ],
          [
            10.245775,
            53.797285,
            76.198157
          ],
          [
            10.246151,
            53.797278,
            76.211322
          ],
          [
            10.246507,
            53.797298,
            76.223852
          ],
          [
            10.246828,
            53.797293,
            76.087363
          ],
          [
            10.247276,
            53.79727,
            75.875191
          ],
          [
            10.247609,
            53.797257,
            75.71683
          ],
          [
            10.247975,
            53.79725,
            75.543613
          ],
          [
            10.248287,
            53.797252,
            75.395698
          ],
          [
            10.248663,
            53.797223,
            75.216789
          ],
          [
            10.248984,
            53.797201,
            75.064256
          ],
          [
            10.249317,
            53.797192,
            74.906948
          ],
          [
            10.24974,
            53.797166,
            74.7293
          ],
          [
            10.250113,
            53.797168,
            74.603045
          ],
          [
            10.250525,
            53.79715,
            74.463059
          ],
          [
            10.250893,
            53.797108,
            74.336083
          ],
          [
            10.251272,
            53.797089,
            74.207232
          ],
          [
            10.251651,
            53.797078,
            74.078732
          ],
          [
            10.252017,
            53.797075,
            73.954773
          ],
          [
            10.252362,
            53.797053,
            73.837246
          ],
          [
            10.252712,
            53.79706,
            73.731931
          ],
          [
            10.2531,
            53.797058,
            73.645629
          ],
          [
            10.253429,
            53.797081,
            73.571945
          ],
          [
            10.25378,
            53.797074,
            73.492953
          ],
          [
            10.254099,
            53.797064,
            73.421216
          ],
          [
            10.254444,
            53.797048,
            73.34424
          ],
          [
            10.254736,
            53.796987,
            73.273629
          ],
          [
            10.255105,
            53.796963,
            73.190708
          ],
          [
            10.255491,
            53.796933,
            73.103454
          ],
          [
            10.255843,
            53.796946,
            73.165453
          ],
          [
            10.25619,
            53.796953,
            73.284726
          ],
          [
            10.256532,
            53.79691,
            73.40566
          ],
          [
            10.25686,
            53.796908,
            73.518338
          ],
          [
            10.257201,
            53.796938,
            73.637538
          ],
          [
            10.25759,
            53.796932,
            73.771781
          ],
          [
            10.257977,
            53.796869,
            73.91021
          ],
          [
            10.258339,
            53.796876,
            74.036425
          ],
          [
            10.258752,
            53.796883,
            74.139359
          ],
          [
            10.259067,
            53.79689,
            74.166948
          ],
          [
            10.259474,
            53.796838,
            74.20338
          ],
          [
            10.25989,
            53.796847,
            74.23989
          ],
          [
            10.260239,
            53.796871,
            74.270647
          ],
          [
            10.260637,
            53.796871,
            74.305593
          ],
          [
            10.261058,
            53.796833,
            74.342871
          ],
          [
            10.261465,
            53.796795,
            74.378931
          ],
          [
            10.261893,
            53.796783,
            73.86333
          ],
          [
            10.262266,
            53.796775,
            73.142641
          ],
          [
            10.262632,
            53.796762,
            72.425801
          ],
          [
            10.262955,
            53.796739,
            71.778586
          ],
          [
            10.263277,
            53.796682,
            71.129504
          ],
          [
            10.263659,
            53.796674,
            70.385654
          ],
          [
            10.264004,
            53.796728,
            69.69619
          ],
          [
            10.264336,
            53.796719,
            69.054175
          ],
          [
            10.264711,
            53.796701,
            68.574141
          ],
          [
            10.265069,
            53.796666,
            68.797969
          ],
          [
            10.265402,
            53.796635,
            69.006232
          ],
          [
            10.265746,
            53.796628,
            69.218619
          ],
          [
            10.266096,
            53.796619,
            69.434605
          ],
          [
            10.266437,
            53.79662,
            69.645048
          ],
          [
            10.26682,
            53.796613,
            69.88128
          ],
          [
            10.267169,
            53.796563,
            70.102927
          ],
          [
            10.267546,
            53.796567,
            70.335423
          ],
          [
            10.267885,
            53.796575,
            70.2849
          ],
          [
            10.268259,
            53.796567,
            70.125187
          ],
          [
            10.268627,
            53.79652,
            69.961927
          ],
          [
            10.269013,
            53.796559,
            69.794434
          ],
          [
            10.269358,
            53.79652,
            69.644576
          ],
          [
            10.269702,
            53.796518,
            69.498114
          ],
          [
            10.270011,
            53.796525,
            69.364614
          ],
          [
            10.270408,
            53.796483,
            69.193258
          ],
          [
            10.27073,
            53.796445,
            69.045253
          ],
          [
            10.27117,
            53.796414,
            68.820388
          ],
          [
            10.271559,
            53.796403,
            68.622763
          ],
          [
            10.271919,
            53.796395,
            68.440149
          ],
          [
            10.272253,
            53.796374,
            68.269236
          ],
          [
            10.272635,
            53.796366,
            68.075089
          ],
          [
            10.272968,
            53.796351,
            67.905814
          ],
          [
            10.273325,
            53.796326,
            67.72329
          ],
          [
            10.273715,
            53.7963,
            67.609672
          ],
          [
            10.274018,
            53.796262,
            67.902662
          ],
          [
            10.274398,
            53.79623,
            68.26608
          ],
          [
            10.274728,
            53.796177,
            68.584003
          ],
          [
            10.275067,
            53.79616,
            68.901486
          ],
          [
            10.27541,
            53.796182,
            69.222303
          ],
          [
            10.275781,
            53.796189,
            69.567326
          ],
          [
            10.276129,
            53.796203,
            69.892133
          ],
          [
            10.276547,
            53.796192,
            70.281256
          ],
          [
            10.276923,
            53.796173,
            70.695408
          ],
          [
            10.277269,
            53.796183,
            71.099191
          ],
          [
            10.277616,
            53.796179,
            71.503733
          ],
          [
            10.277941,
            53.796177,
            71.882574
          ],
          [
            10.278302,
            53.796165,
            72.305342
          ],
          [
            10.278663,
            53.796171,
            72.726292
          ],
          [
            10.279013,
            53.796184,
            73.136064
          ],
          [
            10.279359,
            53.796194,
            73.539983
          ],
          [
            10.279707,
            53.796255,
            73.93306
          ],
          [
            10.280094,
            53.796293,
            73.923386
          ],
          [
            10.280437,
            53.796392,
            73.914063
          ],
          [
            10.280733,
            53.796446,
            73.906494
          ],
          [
            10.28112,
            53.796543,
            73.896241
          ],
          [
            10.281474,
            53.796627,
            73.886938
          ],
          [
            10.281827,
            53.796714,
            73.877615
          ],
          [
            10.282139,
            53.7968,
            73.86921
          ],
          [
            10.282423,
            53.796881,
            73.86152
          ],
          [
            10.28273,
            53.79696,
            74.289355
          ],
          [
            10.283019,
            53.797031,
            74.823296
          ],
          [
            10.283357,
            53.797129,
            75.463745
          ],
          [
            10.283673,
            53.797211,
            76.052722
          ],
          [
            10.284036,
            53.797265,
            76.689579
          ],
          [
            10.284345,
            53.797365,
            77.291322
          ],
          [
            10.284674,
            53.797463,
            77.919527
          ],
          [
            10.285004,
            53.797562,
            78.549152
          ],
          [
            10.285366,
            53.797663,
            79.130003
          ],
          [
            10.285711,
            53.797736,
            79.426534
          ],
          [
            10.286024,
            53.797829,
            79.710004
          ],
          [
            10.286343,
            53.797909,
            79.991239
          ],
          [
            10.286715,
            53.797988,
            80.311344
          ],
          [
            10.287081,
            53.798095,
            80.642471
          ],
          [
            10.287441,
            53.798167,
            80.950127
          ],
          [
            10.287804,
            53.798223,
            81.25366
          ],
          [
            10.288158,
            53.798282,
            81.392644
          ],
          [
            10.288518,
            53.798306,
            80.727605
          ],
          [
            10.288891,
            53.798345,
            80.03217
          ],
          [
            10.289211,
            53.79835,
            79.443214
          ],
          [
            10.289532,
            53.798366,
            78.851857
          ],
          [
            10.289943,
            53.798384,
            78.095313
          ],
          [
            10.290344,
            53.798364,
            77.355139
          ],
          [
            10.290726,
            53.798372,
            76.652643
          ],
          [
            10.291159,
            53.798362,
            75.907119
          ],
          [
            10.291514,
            53.798341,
            75.84239
          ],
          [
            10.291851,
            53.798319,
            75.780913
          ],
          [
            10.292249,
            53.798262,
            75.706706
          ],
          [
            10.292636,
            53.798218,
            75.635347
          ],
          [
            10.293036,
            53.798181,
            75.562053
          ],
          [
            10.293434,
            53.798133,
            75.48851
          ],
          [
            10.293818,
            53.798102,
            75.418355
          ],
          [
            10.294158,
            53.798055,
            75.381881
          ],
          [
            10.294536,
            53.798018,
            75.600712
          ],
          [
            10.294872,
            53.797963,
            75.799844
          ],
          [
            10.295265,
            53.797911,
            76.030194
          ],
          [
            10.295644,
            53.797862,
            76.251916
          ],
          [
            10.296088,
            53.797839,
            76.50754
          ],
          [
            10.296404,
            53.797794,
            76.694175
          ],
          [
            10.296757,
            53.797767,
            76.897473
          ],
          [
            10.297119,
            53.797722,
            77.108518
          ],
          [
            10.297432,
            53.797698,
            77.27956
          ],
          [
            10.297775,
            53.797648,
            77.471116
          ],
          [
            10.298108,
            53.797608,
            77.655268
          ],
          [
            10.298412,
            53.79754,
            77.831993
          ],
          [
            10.298744,
            53.797496,
            78.016769
          ],
          [
            10.299052,
            53.79749,
            78.187386
          ],
          [
            10.299415,
            53.797449,
            78.388026
          ],
          [
            10.299799,
            53.797376,
            78.606648
          ],
          [
            10.300181,
            53.797358,
            78.632514
          ],
          [
            10.300548,
            53.797325,
            78.256002
          ],
          [
            10.300867,
            53.797267,
            77.917656
          ],
          [
            10.30119,
            53.797221,
            77.580826
          ],
          [
            10.301537,
            53.797177,
            77.218274
          ],
          [
            10.301915,
            53.797126,
            76.823206
          ],
          [
            10.302263,
            53.797116,
            76.470085
          ],
          [
            10.302607,
            53.79708,
            76.11603
          ],
          [
            10.302981,
            53.797022,
            75.724149
          ],
          [
            10.303359,
            53.79699,
            75.65604
          ],
          [
            10.303679,
            53.796958,
            75.647161
          ],
          [
            10.304103,
            53.796933,
            75.635504
          ],
          [
            10.304509,
            53.796915,
            75.624366
          ],
          [
            10.304927,
            53.796901,
            75.612885
          ],
          [
            10.305311,
            53.796874,
            75.602268
          ],
          [
            10.305721,
            53.796832,
            75.590884
          ],
          [
            10.306137,
            53.796801,
            75.535704
          ],
          [
            10.306538,
            53.796768,
            75.30188
          ],
          [
            10.306952,
            53.79673,
            75.060001
          ],
          [
            10.307354,
            53.796704,
            74.826535
          ],
          [
            10.307781,
            53.796669,
            74.57766
          ],
          [
            10.308201,
            53.796631,
            74.332355
          ],
          [
            10.308603,
            53.7966,
            74.098301
          ],
          [
            10.308993,
            53.796568,
            73.87098
          ],
          [
            10.309385,
            53.79655,
            73.88695
          ],
          [
            10.309774,
            53.796528,
            73.9666
          ],
          [
            10.310165,
            53.796502,
            74.046776
          ],
          [
            10.310561,
            53.79647,
            74.12823
          ],
          [
            10.310973,
            53.796441,
            74.212777
          ],
          [
            10.311372,
            53.796407,
            74.294924
          ],
          [
            10.311761,
            53.796393,
            74.374334
          ],
          [
            10.312143,
            53.796372,
            74.426321
          ],
          [
            10.312567,
            53.796345,
            74.244194
          ],
          [
            10.312979,
            53.796311,
            74.066459
          ],
          [
            10.313367,
            53.796278,
            73.899087
          ],
          [
            10.313739,
            53.796263,
            73.739869
          ],
          [
            10.314133,
            53.796232,
            73.570156
          ],
          [
            10.314532,
            53.796197,
            73.397717
          ],
          [
            10.314904,
            53.796183,
            73.238128
          ],
          [
            10.315268,
            53.796147,
            73.172159
          ],
          [
            10.315643,
            53.796123,
            73.244186
          ],
          [
            10.316003,
            53.796099,
            73.31442
          ],
          [
            10.316384,
            53.796045,
            73.389145
          ],
          [
            10.316776,
            53.79599,
            73.46599
          ],
          [
            10.317244,
            53.795964,
            73.555692
          ],
          [
            10.317552,
            53.795949,
            73.614636
          ],
          [
            10.317914,
            53.795917,
            73.684448
          ],
          [
            10.318264,
            53.795893,
            73.841684
          ],
          [
            10.318593,
            53.795857,
            74.119154
          ],
          [
            10.318914,
            53.795834,
            74.387372
          ],
          [
            10.31932,
            53.795827,
            74.723008
          ],
          [
            10.319695,
            53.795801,
            75.0341
          ],
          [
            10.320119,
            53.795774,
            75.385824
          ],
          [
            10.320526,
            53.795713,
            75.731791
          ],
          [
            10.320926,
            53.795688,
            76.064354
          ],
          [
            10.321248,
            53.795683,
            76.053328
          ],
          [
            10.321622,
            53.795637,
            75.457454
          ],
          [
            10.321964,
            53.795548,
            74.883139
          ],
          [
            10.322335,
            53.795542,
            74.309525
          ],
          [
            10.322745,
            53.795552,
            73.675403
          ],
          [
            10.323121,
            53.795505,
            73.084904
          ],
          [
            10.323491,
            53.795481,
            72.513008
          ],
          [
            10.323905,
            53.795437,
            71.865215
          ],
          [
            10.324198,
            53.795352,
            71.489576
          ],
          [
            10.324565,
            53.795296,
            71.290857
          ],
          [
            10.324875,
            53.795222,
            71.11465
          ],
          [
            10.325144,
            53.795107,
            70.940366
          ],
          [
            10.325407,
            53.794991,
            70.765206
          ],
          [
            10.325692,
            53.795073,
            70.596567
          ],
          [
            10.325993,
            53.795155,
            70.422691
          ],
          [
            10.326306,
            53.795243,
            70.23962
          ],
          [
            10.326619,
            53.795325,
            70.059683
          ],
          [
            10.326956,
            53.79541,
            70.179723
          ],
          [
            10.327295,
            53.795488,
            70.641667
          ],
          [
            10.327646,
            53.795563,
            71.115617
          ],
          [
            10.328008,
            53.795637,
            71.602266
          ],
          [
            10.32834,
            53.795692,
            72.04009
          ],
          [
            10.328626,
            53.795807,
            72.479416
          ],
          [
            10.328933,
            53.795872,
            72.893932
          ],
          [
            10.32926,
            53.795955,
            73.346801
          ],
          [
            10.329557,
            53.796018,
            73.747605
          ],
          [
            10.329908,
            53.796098,
            73.859219
          ],
          [
            10.33024,
            53.796178,
            73.897926
          ],
          [
            10.330556,
            53.79626,
            73.935176
          ],
          [
            10.330884,
            53.796328,
            73.972687
          ],
          [
            10.331197,
            53.796399,
            74.008881
          ],
          [
            10.33154,
            53.796466,
            74.047889
          ],
          [
            10.331816,
            53.796442,
            74.081308
          ],
          [
            10.331868,
            53.796212,
            74.123742
          ],
          [
            10.332021,
            53.796014,
            74.118695
          ],
          [
            10.332133,
            53.795798,
            73.969026
          ],
          [
            10.332377,
            53.795639,
            73.817794
          ],
          [
            10.332789,
            53.795575,
            73.647329
          ],
          [
            10.333131,
            53.795587,
            73.513409
          ],
          [
            10.333542,
            53.795618,
            73.351694
          ],
          [
            10.333959,
            53.795679,
            73.182126
          ],
          [
            10.334437,
            53.795734,
            72.992716
          ],
          [
            10.334867,
            53.795768,
            72.359591
          ],
          [
            10.335226,
            53.795788,
            71.772178
          ],
          [
            10.335604,
            53.795828,
            71.146598
          ],
          [
            10.336014,
            53.795859,
            70.470354
          ],
          [
            10.336313,
            53.795909,
            69.962249
          ],
          [
            10.33671,
            53.795966,
            69.295423
          ],
          [
            10.336918,
            53.796137,
            68.713358
          ],
          [
            10.337163,
            53.79628,
            68.149063
          ],
          [
            10.337479,
            53.796326,
            67.936632
          ],
          [
            10.337817,
            53.796371,
            67.833222
          ],
          [
            10.338135,
            53.796409,
            67.736125
          ],
          [
            10.338457,
            53.796431,
            67.638668
          ],
          [
            10.338732,
            53.796333,
            67.541072
          ],
          [
            10.339013,
            53.796277,
            67.447194
          ],
          [
            10.339345,
            53.796272,
            67.347977
          ],
          [
            10.339679,
            53.796264,
            67.248148
          ],
          [
            10.340067,
            53.796218,
            67.128877
          ],
          [
            10.340495,
            53.796239,
            66.986643
          ],
          [
            10.340806,
            53.796267,
            66.879534
          ],
          [
            10.341178,
            53.796293,
            66.751458
          ],
          [
            10.341523,
            53.796324,
            66.63281
          ],
          [
            10.341852,
            53.796322,
            66.516044
          ],
          [
            10.342188,
            53.79637,
            66.398411
          ],
          [
            10.342542,
            53.796399,
            66.276953
          ],
          [
            10.34294,
            53.796469,
            66.13584
          ],
          [
            10.343336,
            53.796538,
            66.082669
          ],
          [
            10.343734,
            53.796583,
            66.116699
          ],
          [
            10.344091,
            53.796648,
            66.14809
          ],
          [
            10.344427,
            53.796677,
            66.176639
          ],
          [
            10.344773,
            53.796729,
            66.206631
          ],
          [
            10.345141,
            53.796754,
            66.237777
          ],
          [
            10.345453,
            53.796801,
            66.264825
          ],
          [
            10.345843,
            53.796832,
            66.297916
          ],
          [
            10.346215,
            53.796839,
            66.306128
          ],
          [
            10.346628,
            53.796921,
            66.239034
          ],
          [
            10.347067,
            53.796938,
            66.171265
          ],
          [
            10.347407,
            53.796977,
            66.117672
          ],
          [
            10.347757,
            53.796991,
            66.063382
          ],
          [
            10.348146,
            53.797027,
            66.00205
          ],
          [
            10.3485,
            53.797052,
            65.947133
          ],
          [
            10.348911,
            53.797104,
            65.882408
          ],
          [
            10.349245,
            53.797147,
            66.032234
          ],
          [
            10.349587,
            53.797176,
            66.457476
          ],
          [
            10.349928,
            53.797212,
            66.88731
          ],
          [
            10.350284,
            53.797242,
            67.33057
          ],
          [
            10.350615,
            53.797283,
            67.746746
          ],
          [
            10.350935,
            53.797316,
            68.146537
          ],
          [
            10.351272,
            53.797341,
            68.564551
          ],
          [
            10.351658,
            53.797339,
            69.042366
          ],
          [
            10.352002,
            53.797387,
            69.47757
          ],
          [
            10.352307,
            53.797398,
            69.424137
          ],
          [
            10.35267,
            53.797395,
            69.11551
          ],
          [
            10.35309,
            53.797424,
            68.756693
          ],
          [
            10.35347,
            53.797481,
            68.424
          ],
          [
            10.353832,
            53.797499,
            68.112069
          ],
          [
            10.354178,
            53.79755,
            67.809468
          ],
          [
            10.354507,
            53.797598,
            67.521932
          ],
          [
            10.35488,
            53.797625,
            67.202969
          ],
          [
            10.355227,
            53.797643,
            67.136605
          ],
          [
            10.355577,
            53.797683,
            67.475759
          ],
          [
            10.355906,
            53.797732,
            67.795901
          ],
          [
            10.356218,
            53.797771,
            68.096677
          ],
          [
            10.356568,
            53.79778,
            68.427069
          ],
          [
            10.35694,
            53.797772,
            68.778628
          ],
          [
            10.357317,
            53.797759,
            69.135474
          ],
          [
            10.357727,
            53.797734,
            69.524317
          ],
          [
            10.358094,
            53.797735,
            69.870514
          ],
          [
            10.358509,
            53.797691,
            69.866441
          ],
          [
            10.358928,
            53.797627,
            69.843772
          ],
          [
            10.359403,
            53.797596,
            69.818827
          ],
          [
            10.359934,
            53.797543,
            69.790713
          ],
          [
            10.360426,
            53.797498,
            69.764722
          ],
          [
            10.360876,
            53.797472,
            69.741135
          ],
          [
            10.361292,
            53.797448,
            69.221909
          ],
          [
            10.361679,
            53.797413,
            68.117311
          ],
          [
            10.36205,
            53.797406,
            67.07004
          ],
          [
            10.36244,
            53.797387,
            65.964697
          ],
          [
            10.36282,
            53.797372,
            64.887489
          ],
          [
            10.363163,
            53.797355,
            63.91215
          ],
          [
            10.363435,
            53.797498,
            62.883345
          ],
          [
            10.363729,
            53.797498,
            61.957448
          ],
          [
            10.363524,
            53.79747,
            61.064848
          ],
          [
            10.363946,
            53.797462,
            60.685497
          ],
          [
            10.364271,
            53.797495,
            60.388611
          ],
          [
            10.364653,
            53.797507,
            60.042056
          ],
          [
            10.365063,
            53.797521,
            59.672779
          ],
          [
            10.365467,
            53.797542,
            59.308007
          ],
          [
            10.365778,
            53.797543,
            59.028166
          ],
          [
            10.366106,
            53.797539,
            58.733107
          ],
          [
            10.366435,
            53.797575,
            58.431902
          ],
          [
            10.366778,
            53.797572,
            58.09102
          ],
          [
            10.367118,
            53.797597,
            57.747492
          ],
          [
            10.367429,
            53.797609,
            57.434968
          ],
          [
            10.367812,
            53.79762,
            57.049768
          ],
          [
            10.368227,
            53.797635,
            56.63261
          ],
          [
            10.368601,
            53.797667,
            56.25194
          ],
          [
            10.368939,
            53.797677,
            55.912313
          ],
          [
            10.369246,
            53.797753,
            55.574341
          ],
          [
            10.369559,
            53.797842,
            55.446928
          ],
          [
            10.36982,
            53.79798,
            55.727622
          ],
          [
            10.370078,
            53.798207,
            56.09769
          ],
          [
            10.370229,
            53.798427,
            56.418751
          ],
          [
            10.370568,
            53.798629,
            56.804422
          ],
          [
            10.370888,
            53.798732,
            57.097325
          ],
          [
            10.371261,
            53.798913,
            57.486189
          ],
          [
            10.371519,
            53.79909,
            57.725816
          ],
          [
            10.371791,
            53.799223,
            56.992263
          ],
          [
            10.37202,
            53.799367,
            56.298066
          ],
          [
            10.372232,
            53.799549,
            55.522434
          ],
          [
            10.372434,
            53.799746,
            54.715137
          ],
          [
            10.372634,
            53.799966,
            53.837195
          ],
          [
            10.372907,
            53.800144,
            52.993955
          ],
          [
            10.373183,
            53.800311,
            52.176722
          ],
          [
            10.37345,
            53.800441,
            51.484775
          ],
          [
            10.373745,
            53.800632,
            51.500139
          ],
          [
            10.37395,
            53.80078,
            51.511511
          ],
          [
            10.374158,
            53.800944,
            51.523678
          ],
          [
            10.374404,
            53.8011,
            51.536331
          ],
          [
            10.374665,
            53.80124,
            51.548694
          ],
          [
            10.374958,
            53.801445,
            51.564617
          ],
          [
            10.375168,
            53.801581,
            51.575554
          ],
          [
            10.375334,
            53.801781,
            51.588891
          ],
          [
            10.375331,
            53.801976,
            52.475331
          ],
          [
            10.375058,
            53.802047,
            53.522923
          ],
          [
            10.374717,
            53.802087,
            54.685437
          ],
          [
            10.37442,
            53.802149,
            55.724494
          ],
          [
            10.374078,
            53.80222,
            56.91966
          ],
          [
            10.373747,
            53.802284,
            58.068042
          ],
          [
            10.373445,
            53.802361,
            59.156071
          ],
          [
            10.373271,
            53.802466,
            60.183916
          ],
          [
            10.373125,
            53.802651,
            61.323812
          ],
          [
            10.373159,
            53.802862,
            61.512846
          ],
          [
            10.373234,
            53.803046,
            61.371711
          ],
          [
            10.373317,
            53.803222,
            61.235793
          ],
          [
            10.373075,
            53.803382,
            61.076123
          ],
          [
            10.372862,
            53.803537,
            60.927747
          ],
          [
            10.372796,
            53.803719,
            60.788789
          ],
          [
            10.372863,
            53.803985,
            60.588597
          ],
          [
            10.372857,
            53.803604,
            60.276392
          ],
          [
            10.372764,
            53.803766,
            60.072468
          ],
          [
            10.372929,
            53.803932,
            59.892437
          ],
          [
            10.373145,
            53.804071,
            59.714199
          ],
          [
            10.373387,
            53.804204,
            59.532755
          ],
          [
            10.373643,
            53.804324,
            59.353154
          ],
          [
            10.373945,
            53.804237,
            59.167064
          ],
          [
            10.374259,
            53.804146,
            58.974145
          ],
          [
            10.374588,
            53.804141,
            58.793148
          ],
          [
            10.374905,
            53.804195,
            58.636759
          ],
          [
            10.375044,
            53.804377,
            58.726456
          ],
          [
            10.375242,
            53.804583,
            58.832888
          ],
          [
            10.375409,
            53.804769,
            58.927526
          ],
          [
            10.375501,
            53.804967,
            59.019769
          ],
          [
            10.375605,
            53.805167,
            59.114146
          ],
          [
            10.375637,
            53.80538,
            59.210219
          ],
          [
            10.37569,
            53.805571,
            59.297174
          ],
          [
            10.375766,
            53.805776,
            59.391475
          ],
          [
            10.375774,
            53.805992,
            59.263612
          ],
          [
            10.375719,
            53.806183,
            59.002813
          ],
          [
            10.375639,
            53.806371,
            58.742528
          ],
          [
            10.375678,
            53.806562,
            58.482012
          ],
          [
            10.375714,
            53.806749,
            58.228404
          ],
          [
            10.375846,
            53.806915,
            57.97867
          ],
          [
            10.37619,
            53.806878,
            57.699894
          ],
          [
            10.376517,
            53.806804,
            57.42101
          ],
          [
            10.376894,
            53.806775,
            57.119275
          ],
          [
            10.377261,
            53.80673,
            57.170414
          ],
          [
            10.377603,
            53.806665,
            57.39514
          ],
          [
            10.377811,
            53.8065,
            57.620179
          ],
          [
            10.378039,
            53.806574,
            57.847345
          ],
          [
            10.378167,
            53.80678,
            58.08821
          ],
          [
            10.378456,
            53.806911,
            58.315162
          ],
          [
            10.378766,
            53.806951,
            58.51163
          ],
          [
            10.379083,
            53.806984,
            58.710586
          ],
          [
            10.379388,
            53.807017,
            58.904843
          ],
          [
            10.379764,
            53.807069,
            59.332749
          ],
          [
            10.380095,
            53.807084,
            59.700611
          ],
          [
            10.380427,
            53.807108,
            60.07324
          ],
          [
            10.380768,
            53.807147,
            60.463043
          ],
          [
            10.381083,
            53.807212,
            60.835125
          ],
          [
            10.381414,
            53.807244,
            61.206927
          ],
          [
            10.381756,
            53.807331,
            61.623339
          ],
          [
            10.382051,
            53.807446,
            62.020197
          ],
          [
            10.382374,
            53.807467,
            62.186148
          ],
          [
            10.38271,
            53.807403,
            61.909344
          ],
          [
            10.383048,
            53.807347,
            61.634752
          ],
          [
            10.383383,
            53.807293,
            61.362032
          ],
          [
            10.383788,
            53.807281,
            61.044699
          ],
          [
            10.384201,
            53.807275,
            60.721482
          ],
          [
            10.384562,
            53.807294,
            60.43763
          ],
          [
            10.384951,
            53.807329,
            60.126413
          ],
          [
            10.385307,
            53.807336,
            60.007014
          ],
          [
            10.3857,
            53.807364,
            60.802958
          ],
          [
            10.386025,
            53.807363,
            61.461859
          ],
          [
            10.386351,
            53.807418,
            62.143576
          ],
          [
            10.386702,
            53.807434,
            62.851432
          ],
          [
            10.387046,
            53.807455,
            63.546694
          ],
          [
            10.387354,
            53.807481,
            64.172799
          ],
          [
            10.387691,
            53.807522,
            64.864641
          ],
          [
            10.388045,
            53.80756,
            65.588112
          ],
          [
            10.388392,
            53.807579,
            66.165329
          ],
          [
            10.388747,
            53.80762,
            66.562064
          ],
          [
            10.389084,
            53.807638,
            66.934854
          ],
          [
            10.389401,
            53.807645,
            67.282776
          ],
          [
            10.38977,
            53.807635,
            67.688159
          ],
          [
            10.390141,
            53.807659,
            68.097761
          ],
          [
            10.390484,
            53.807695,
            68.479826
          ],
          [
            10.390847,
            53.807741,
            68.887023
          ],
          [
            10.391203,
            53.807785,
            69.286733
          ],
          [
            10.391515,
            53.807792,
            68.98372
          ],
          [
            10.391842,
            53.807786,
            68.497388
          ],
          [
            10.392205,
            53.807769,
            67.955829
          ],
          [
            10.392517,
            53.807721,
            67.475928
          ],
          [
            10.392851,
            53.807676,
            66.965428
          ],
          [
            10.393158,
            53.807617,
            66.484005
          ],
          [
            10.393507,
            53.807536,
            65.926541
          ],
          [
            10.393631,
            53.80765,
            65.462149
          ],
          [
            10.393585,
            53.807863,
            64.872845
          ],
          [
            10.393733,
            53.808035,
            64.949447
          ],
          [
            10.393909,
            53.808229,
            65.101674
          ],
          [
            10.394083,
            53.808422,
            65.252986
          ],
          [
            10.394261,
            53.808622,
            65.409231
          ],
          [
            10.394419,
            53.808811,
            65.555562
          ],
          [
            10.394591,
            53.809012,
            65.711776
          ],
          [
            10.394736,
            53.809183,
            65.844028
          ],
          [
            10.394875,
            53.809364,
            65.981493
          ],
          [
            10.395095,
            53.809535,
            66.044524
          ],
          [
            10.395418,
            53.809663,
            65.972465
          ],
          [
            10.395804,
            53.809786,
            65.891169
          ],
          [
            10.396141,
            53.809901,
            65.81921
          ],
          [
            10.39649,
            53.810009,
            65.746343
          ],
          [
            10.396872,
            53.810109,
            65.669008
          ],
          [
            10.397178,
            53.810218,
            65.602823
          ],
          [
            10.397511,
            53.810318,
            65.533742
          ],
          [
            10.397858,
            53.810452,
            64.971633
          ],
          [
            10.39819,
            53.810561,
            64.245008
          ],
          [
            10.398517,
            53.810673,
            63.519633
          ],
          [
            10.398824,
            53.810779,
            62.83936
          ],
          [
            10.399164,
            53.81087,
            62.123438
          ],
          [
            10.399521,
            53.810977,
            61.357506
          ],
          [
            10.399851,
            53.811028,
            60.70305
          ],
          [
            10.400307,
            53.811041,
            59.824072
          ],
          [
            10.400671,
            53.811005,
            60.00496
          ],
          [
            10.401027,
            53.810931,
            60.418579
          ],
          [
            10.401294,
            53.810809,
            60.787787
          ],
          [
            10.401571,
            53.810703,
            61.148696
          ],
          [
            10.401863,
            53.810601,
            61.519689
          ],
          [
            10.402208,
            53.810599,
            61.902111
          ],
          [
            10.402554,
            53.81064,
            62.289898
          ],
          [
            10.402918,
            53.810683,
            62.700452
          ],
          [
            10.403303,
            53.810744,
            62.855465
          ],
          [
            10.40365,
            53.810809,
            62.34916
          ],
          [
            10.403988,
            53.810862,
            61.862567
          ],
          [
            10.404351,
            53.810905,
            61.347835
          ],
          [
            10.404769,
            53.810946,
            60.758758
          ],
          [
            10.405114,
            53.810976,
            60.272548
          ],
          [
            10.405525,
            53.810962,
            59.700132
          ],
          [
            10.405887,
            53.810939,
            59.192587
          ],
          [
            10.406238,
            53.810932,
            58.683505
          ],
          [
            10.406615,
            53.810897,
            58.016373
          ],
          [
            10.407012,
            53.810861,
            57.314329
          ],
          [
            10.407454,
            53.810805,
            56.524094
          ],
          [
            10.407881,
            53.810749,
            55.758018
          ],
          [
            10.408308,
            53.810689,
            54.991124
          ],
          [
            10.408691,
            53.810621,
            54.291405
          ],
          [
            10.409038,
            53.81059,
            53.678297
          ],
          [
            10.409426,
            53.810523,
            53.25146
          ],
          [
            10.409854,
            53.810467,
            52.927518
          ],
          [
            10.410263,
            53.810443,
            52.624106
          ],
          [
            10.410672,
            53.810407,
            52.318793
          ],
          [
            10.411074,
            53.810385,
            52.020877
          ],
          [
            10.411488,
            53.810385,
            51.714148
          ],
          [
            10.41183,
            53.810439,
            51.452897
          ],
          [
            10.41223,
            53.81044,
            51.357483
          ],
          [
            10.41258,
            53.810512,
            52.050398
          ],
          [
            10.412896,
            53.81063,
            52.751437
          ],
          [
            10.413259,
            53.810629,
            53.426311
          ],
          [
            10.413614,
            53.810664,
            54.094572
          ],
          [
            10.41395,
            53.81071,
            54.737546
          ],
          [
            10.414229,
            53.810831,
            55.394062
          ],
          [
            10.414374,
            53.811025,
            56.060867
          ],
          [
            10.41456,
            53.811193,
            56.693285
          ],
          [
            10.414802,
            53.81136,
            57.607874
          ],
          [
            10.415123,
            53.811465,
            58.597595
          ],
          [
            10.415465,
            53.811463,
            59.507818
          ],
          [
            10.415779,
            53.811388,
            60.415886
          ],
          [
            10.416016,
            53.811239,
            61.334703
          ],
          [
            10.4162,
            53.811081,
            62.196343
          ],
          [
            10.416492,
            53.81092,
            63.25846
          ],
          [
            10.416751,
            53.810755,
            64.273348
          ],
          [
            10.417036,
            53.810623,
            64.787938
          ],
          [
            10.417311,
            53.810506,
            64.306209
          ],
          [
            10.417607,
            53.810373,
            63.770128
          ],
          [
            10.417861,
            53.810211,
            63.238218
          ],
          [
            10.418108,
            53.810056,
            62.725949
          ],
          [
            10.418486,
            53.809868,
            62.022284
          ],
          [
            10.418764,
            53.809771,
            61.563294
          ],
          [
            10.419039,
            53.80966,
            61.089525
          ],
          [
            10.419366,
            53.809556,
            60.630169
          ],
          [
            10.419667,
            53.809439,
            60.7212
          ],
          [
            10.419909,
            53.809319,
            60.801175
          ],
          [
            10.420218,
            53.80916,
            60.904707
          ],
          [
            10.420446,
            53.808977,
            61.001986
          ],
          [
            10.420656,
            53.808774,
            61.103857
          ],
          [
            10.420831,
            53.80856,
            61.20565
          ],
          [
            10.420974,
            53.80836,
            61.298661
          ],
          [
            10.421068,
            53.80816,
            61.387501
          ],
          [
            10.421165,
            53.807973,
            62.800994
          ],
          [
            10.421292,
            53.807797,
            64.210975
          ],
          [
            10.421485,
            53.807628,
            65.713903
          ],
          [
            10.421681,
            53.807475,
            67.13068
          ],
          [
            10.421922,
            53.807335,
            68.601476
          ],
          [
            10.422204,
            53.807222,
            70.084214
          ],
          [
            10.422512,
            53.80716,
            71.501731
          ],
          [
            10.422818,
            53.807094,
            72.92216
          ],
          [
            10.42315,
            53.807064,
            74.382598
          ],
          [
            10.423472,
            53.807051,
            74.907676
          ],
          [
            10.4238,
            53.807074,
            75.241156
          ],
          [
            10.424154,
            53.807083,
            75.599244
          ],
          [
            10.424482,
            53.807112,
            75.93414
          ],
          [
            10.424825,
            53.80715,
            76.2865
          ],
          [
            10.425148,
            53.807193,
            76.623018
          ],
          [
            10.425456,
            53.807241,
            76.950529
          ],
          [
            10.425936,
            53.807302,
            77.446355
          ],
          [
            10.426272,
            53.807345,
            77.694447
          ],
          [
            10.426609,
            53.807352,
            77.639214
          ],
          [
            10.426977,
            53.807366,
            77.57876
          ],
          [
            10.427339,
            53.807401,
            77.518692
          ],
          [
            10.427683,
            53.807432,
            77.461499
          ],
          [
            10.428041,
            53.807455,
            77.402531
          ],
          [
            10.428378,
            53.807465,
            77.347257
          ],
          [
            10.428711,
            53.807489,
            77.292275
          ],
          [
            10.429102,
            53.80751,
            77.22796
          ],
          [
            10.429476,
            53.807533,
            77.231503
          ],
          [
            10.429848,
            53.807564,
            77.262819
          ],
          [
            10.430227,
            53.807601,
            77.294841
          ],
          [
            10.430556,
            53.80764,
            77.322812
          ],
          [
            10.430899,
            53.807685,
            77.352148
          ],
          [
            10.43129,
            53.807749,
            77.386052
          ],
          [
            10.431595,
            53.807805,
            77.412717
          ],
          [
            10.431888,
            53.807882,
            77.439449
          ],
          [
            10.432176,
            53.807959,
            77.47131
          ],
          [
            10.432479,
            53.808035,
            77.562571
          ],
          [
            10.432851,
            53.80812,
            77.673284
          ],
          [
            10.433162,
            53.808191,
            77.765685
          ],
          [
            10.433493,
            53.808286,
            77.867664
          ],
          [
            10.433822,
            53.808388,
            77.970671
          ],
          [
            10.434138,
            53.808538,
            78.0834
          ],
          [
            10.43449,
            53.808637,
            78.191608
          ],
          [
            10.43484,
            53.808741,
            78.30207
          ],
          [
            10.435159,
            53.808835,
            78.556244
          ],
          [
            10.435512,
            53.808904,
            78.830861
          ],
          [
            10.435868,
            53.808962,
            79.103074
          ],
          [
            10.436219,
            53.809108,
            79.428075
          ],
          [
            10.436532,
            53.809172,
            79.674118
          ],
          [
            10.436883,
            53.809246,
            79.948907
          ],
          [
            10.437286,
            53.809344,
            80.270615
          ],
          [
            10.437628,
            53.809437,
            80.549982
          ],
          [
            10.438022,
            53.809536,
            80.135116
          ],
          [
            10.438395,
            53.809524,
            79.766554
          ],
          [
            10.438721,
            53.809529,
            79.446831
          ],
          [
            10.4391,
            53.809552,
            79.072144
          ],
          [
            10.439477,
            53.80959,
            78.697691
          ],
          [
            10.439832,
            53.80967,
            78.325423
          ],
          [
            10.440134,
            53.809801,
            77.958176
          ],
          [
            10.44039,
            53.80993,
            77.628416
          ],
          [
            10.44059,
            53.810081,
            77.243299
          ],
          [
            10.440723,
            53.810283,
            76.793456
          ],
          [
            10.440836,
            53.810525,
            76.272661
          ],
          [
            10.440857,
            53.81073,
            75.845933
          ],
          [
            10.440881,
            53.810927,
            75.436357
          ],
          [
            10.441192,
            53.810945,
            74.98763
          ],
          [
            10.441541,
            53.810814,
            74.47791
          ],
          [
            10.441857,
            53.810676,
            73.996516
          ],
          [
            10.442099,
            53.810526,
            74.214481
          ],
          [
            10.442355,
            53.810413,
            74.753942
          ],
          [
            10.442627,
            53.810306,
            75.30398
          ],
          [
            10.442884,
            53.810178,
            75.872041
          ],
          [
            10.443121,
            53.810058,
            76.395611
          ],
          [
            10.443396,
            53.809906,
            77.024859
          ],
          [
            10.443598,
            53.809723,
            77.643753
          ],
          [
            10.44384,
            53.809558,
            78.26867
          ],
          [
            10.444094,
            53.809439,
            78.81033
          ],
          [
            10.44431,
            53.809297,
            78.940012
          ],
          [
            10.444537,
            53.809159,
            78.954504
          ],
          [
            10.444789,
            53.809027,
            78.969478
          ],
          [
            10.44502,
            53.808867,
            78.985322
          ],
          [
            10.445218,
            53.808673,
            79.002372
          ],
          [
            10.445324,
            53.808481,
            79.017587
          ],
          [
            10.445397,
            53.808261,
            79.034462
          ],
          [
            10.445538,
            53.808034,
            79.052665
          ],
          [
            10.445659,
            53.807812,
            79.437307
          ],
          [
            10.445787,
            53.807585,
            80.549889
          ],
          [
            10.445892,
            53.807399,
            81.461448
          ],
          [
            10.445991,
            53.807206,
            82.398934
          ],
          [
            10.446067,
            53.807023,
            83.274746
          ],
          [
            10.446173,
            53.806828,
            84.226428
          ],
          [
            10.446295,
            53.806645,
            85.142279
          ],
          [
            10.446507,
            53.806497,
            86.044272
          ],
          [
            10.446739,
            53.80634,
            87.013189
          ],
          [
            10.446943,
            53.806165,
            87.568584
          ],
          [
            10.447162,
            53.80601,
            87.806178
          ],
          [
            10.447382,
            53.805844,
            88.053785
          ],
          [
            10.447609,
            53.80566,
            88.321467
          ],
          [
            10.447902,
            53.805484,
            88.611643
          ],
          [
            10.448137,
            53.805307,
            88.876155
          ],
          [
            10.448395,
            53.805325,
            89.093181
          ],
          [
            10.448618,
            53.80548,
            89.332522
          ],
          [
            10.448841,
            53.805624,
            89.487789
          ],
          [
            10.449064,
            53.805767,
            89.085571
          ],
          [
            10.449293,
            53.80592,
            88.663043
          ],
          [
            10.449511,
            53.806083,
            88.232011
          ],
          [
            10.449823,
            53.806353,
            87.555617
          ],
          [
            10.450085,
            53.806537,
            87.057983
          ],
          [
            10.450371,
            53.806714,
            86.550126
          ],
          [
            10.450655,
            53.806834,
            86.122839
          ],
          [
            10.45096,
            53.806887,
            85.79208
          ],
          [
            10.451342,
            53.806888,
            85.67574
          ],
          [
            10.451705,
            53.806991,
            85.551903
          ],
          [
            10.452025,
            53.807068,
            85.446719
          ],
          [
            10.452461,
            53.807078,
            85.314048
          ],
          [
            10.452879,
            53.807064,
            85.186955
          ],
          [
            10.453253,
            53.807042,
            85.07269
          ],
          [
            10.453633,
            53.806962,
            84.950065
          ],
          [
            10.45393,
            53.806903,
            84.84275
          ],
          [
            10.454257,
            53.806871,
            84.706458
          ],
          [
            10.454598,
            53.806834,
            84.563935
          ],
          [
            10.454998,
            53.806819,
            84.399135
          ],
          [
            10.455416,
            53.806828,
            84.226536
          ],
          [
            10.455749,
            53.806863,
            84.087308
          ],
          [
            10.456098,
            53.806895,
            83.941927
          ],
          [
            10.456496,
            53.806924,
            83.777047
          ],
          [
            10.456924,
            53.806993,
            83.465442
          ],
          [
            10.457224,
            53.807117,
            82.868997
          ],
          [
            10.457444,
            53.807276,
            82.303062
          ],
          [
            10.457722,
            53.807477,
            81.58799
          ],
          [
            10.45799,
            53.807671,
            80.897869
          ],
          [
            10.458267,
            53.807895,
            80.134273
          ],
          [
            10.458587,
            53.808134,
            79.295395
          ],
          [
            10.458907,
            53.808392,
            78.33224
          ],
          [
            10.459197,
            53.808609,
            77.338028
          ],
          [
            10.459571,
            53.808894,
            76.041634
          ],
          [
            10.459913,
            53.809186,
            74.764994
          ],
          [
            10.460195,
            53.809399,
            73.792907
          ],
          [
            10.460478,
            53.809655,
            72.690096
          ],
          [
            10.460671,
            53.8099,
            72.353302
          ],
          [
            10.460883,
            53.810041,
            72.540777
          ],
          [
            10.461171,
            53.809965,
            72.751909
          ],
          [
            10.461464,
            53.809842,
            72.9579
          ],
          [
            10.461782,
            53.809689,
            73.192928
          ],
          [
            10.4621,
            53.809629,
            73.384189
          ],
          [
            10.462386,
            53.809521,
            73.578825
          ],
          [
            10.462679,
            53.809444,
            73.762497
          ],
          [
            10.462997,
            53.809377,
            73.955814
          ],
          [
            10.463331,
            53.809366,
            73.911256
          ],
          [
            10.463669,
            53.80933,
            73.856392
          ],
          [
            10.464027,
            53.809359,
            73.798759
          ],
          [
            10.464334,
            53.809433,
            73.745816
          ],
          [
            10.464649,
            53.809492,
            73.693374
          ],
          [
            10.465011,
            53.809559,
            73.633133
          ],
          [
            10.465428,
            53.80963,
            73.564265
          ],
          [
            10.465849,
            53.809699,
            73.494932
          ],
          [
            10.466269,
            53.809763,
            73.235433
          ],
          [
            10.466649,
            53.809825,
            72.947974
          ],
          [
            10.467076,
            53.809879,
            72.62962
          ],
          [
            10.467392,
            53.80992,
            72.393305
          ],
          [
            10.467796,
            53.81,
            72.082544
          ],
          [
            10.468091,
            53.810063,
            71.852962
          ],
          [
            10.468383,
            53.810137,
            71.620974
          ],
          [
            10.468678,
            53.81023,
            71.376968
          ],
          [
            10.469025,
            53.81033,
            70.908918
          ],
          [
            10.46938,
            53.810441,
            70.280896
          ],
          [
            10.469758,
            53.810539,
            69.635493
          ],
          [
            10.470102,
            53.810626,
            69.050162
          ],
          [
            10.470479,
            53.810734,
            68.39502
          ],
          [
            10.47085,
            53.810836,
            67.754359
          ],
          [
            10.471251,
            53.810928,
            67.081732
          ],
          [
            10.47165,
            53.811037,
            66.459817
          ],
          [
            10.472023,
            53.811132,
            66.23153
          ],
          [
            10.472381,
            53.811204,
            66.018942
          ],
          [
            10.472677,
            53.811314,
            65.823443
          ],
          [
            10.473037,
            53.811396,
            65.607591
          ],
          [
            10.473384,
            53.811498,
            65.390801
          ],
          [
            10.47372,
            53.8116,
            65.179611
          ],
          [
            10.474038,
            53.81169,
            64.982439
          ],
          [
            10.47433,
            53.811773,
            64.801112
          ],
          [
            10.474642,
            53.811855,
            64.662155
          ],
          [
            10.474962,
            53.811929,
            64.524518
          ],
          [
            10.475302,
            53.811976,
            64.384408
          ],
          [
            10.475692,
            53.812004,
            64.227029
          ],
          [
            10.476117,
            53.812002,
            64.055608
          ],
          [
            10.476516,
            53.811972,
            63.894376
          ],
          [
            10.47684,
            53.811898,
            63.754622
          ],
          [
            10.477159,
            53.811785,
            63.605635
          ],
          [
            10.477438,
            53.811681,
            63.758174
          ],
          [
            10.47772,
            53.811567,
            64.009512
          ],
          [
            10.478016,
            53.811447,
            64.273475
          ],
          [
            10.478322,
            53.811338,
            64.536425
          ],
          [
            10.478618,
            53.811231,
            64.791936
          ],
          [
            10.478913,
            53.811104,
            65.060724
          ],
          [
            10.479204,
            53.810966,
            65.335115
          ],
          [
            10.479444,
            53.810809,
            65.599286
          ],
          [
            10.479666,
            53.810663,
            65.788871
          ],
          [
            10.479799,
            53.810427,
            65.539594
          ],
          [
            10.480005,
            53.810209,
            65.289221
          ],
          [
            10.480068,
            53.809992,
            65.068932
          ],
          [
            10.480139,
            53.80978,
            64.853106
          ],
          [
            10.480217,
            53.80958,
            64.645933
          ],
          [
            10.480318,
            53.809389,
            64.445214
          ],
          [
            10.480433,
            53.809206,
            64.250271
          ],
          [
            10.480562,
            53.809017,
            64.046334
          ],
          [
            10.480717,
            53.808837,
            63.974706
          ],
          [
            10.480901,
            53.808667,
            63.925086
          ],
          [
            10.481036,
            53.808483,
            63.875791
          ],
          [
            10.481203,
            53.808281,
            63.820523
          ],
          [
            10.481388,
            53.808068,
            63.761665
          ],
          [
            10.481551,
            53.80788,
            63.709744
          ],
          [
            10.481719,
            53.807698,
            63.658764
          ],
          [
            10.481872,
            53.807519,
            63.609473
          ],
          [
            10.48204,
            53.807326,
            63.656551
          ],
          [
            10.482179,
            53.807163,
            63.849859
          ],
          [
            10.482348,
            53.806987,
            64.064167
          ],
          [
            10.482524,
            53.806809,
            64.282502
          ],
          [
            10.48273,
            53.80663,
            64.511755
          ],
          [
            10.482973,
            53.806458,
            64.749026
          ],
          [
            10.483267,
            53.806291,
            65.004507
          ],
          [
            10.483612,
            53.806159,
            65.261638
          ],
          [
            10.483976,
            53.806055,
            65.281105
          ],
          [
            10.484367,
            53.805981,
            63.797932
          ],
          [
            10.484755,
            53.805944,
            62.38165
          ],
          [
            10.485188,
            53.805951,
            60.820255
          ],
          [
            10.485673,
            53.805988,
            59.057996
          ],
          [
            10.486104,
            53.806024,
            57.486679
          ],
          [
            10.486562,
            53.806075,
            55.807054
          ],
          [
            10.486883,
            53.806131,
            54.600837
          ],
          [
            10.487221,
            53.806178,
            53.865466
          ],
          [
            10.487565,
            53.806234,
            53.15412
          ],
          [
            10.487915,
            53.806281,
            52.43856
          ],
          [
            10.48826,
            53.806321,
            51.737508
          ],
          [
            10.488593,
            53.806337,
            51.067018
          ],
          [
            10.48895,
            53.806335,
            50.355209
          ],
          [
            10.489308,
            53.806333,
            49.641693
          ],
          [
            10.489663,
            53.806309,
            48.929566
          ],
          [
            10.490003,
            53.806263,
            48.508278
          ],
          [
            10.490312,
            53.806207,
            48.745182
          ],
          [
            10.490752,
            53.806127,
            49.082537
          ],
          [
            10.491286,
            53.806,
            49.504322
          ],
          [
            10.49174,
            53.805906,
            49.8569
          ],
          [
            10.492137,
            53.805824,
            50.165025
          ],
          [
            10.492504,
            53.805766,
            50.443341
          ],
          [
            10.492837,
            53.805741,
            50.660024
          ],
          [
            10.493199,
            53.805719,
            50.595093
          ],
          [
            10.493537,
            53.805749,
            50.534071
          ],
          [
            10.493898,
            53.805812,
            50.466913
          ],
          [
            10.494198,
            53.805869,
            50.410698
          ],
          [
            10.494588,
            53.805998,
            50.33095
          ],
          [
            10.494917,
            53.80609,
            50.266016
          ],
          [
            10.495254,
            53.806175,
            50.200531
          ],
          [
            10.495565,
            53.80622,
            50.143416
          ],
          [
            10.495911,
            53.806258,
            50.921688
          ],
          [
            10.496257,
            53.806258,
            52.095002
          ],
          [
            10.4966,
            53.806227,
            53.272645
          ],
          [
            10.496925,
            53.806173,
            54.417484
          ],
          [
            10.497243,
            53.806121,
            55.541075
          ],
          [
            10.497569,
            53.806067,
            56.689604
          ],
          [
            10.497911,
            53.806023,
            57.875875
          ],
          [
            10.49824,
            53.805981,
            59.016445
          ],
          [
            10.498612,
            53.805956,
            60.289788
          ],
          [
            10.498979,
            53.805952,
            60.082453
          ],
          [
            10.499327,
            53.805977,
            59.689371
          ],
          [
            10.499669,
            53.806005,
            59.302285
          ],
          [
            10.500001,
            53.806044,
            58.922768
          ],
          [
            10.500336,
            53.806081,
            58.54067
          ],
          [
            10.500696,
            53.806147,
            58.117775
          ],
          [
            10.50108,
            53.806204,
            57.673862
          ],
          [
            10.501523,
            53.806251,
            57.16926
          ],
          [
            10.501901,
            53.806288,
            56.441026
          ],
          [
            10.502318,
            53.806238,
            55.471283
          ],
          [
            10.502724,
            53.806193,
            54.528578
          ],
          [
            10.503161,
            53.806131,
            53.504484
          ],
          [
            10.503692,
            53.806096,
            52.282868
          ],
          [
            10.504147,
            53.806098,
            51.24631
          ],
          [
            10.50461,
            53.80606,
            50.179973
          ],
          [
            10.505183,
            53.805959,
            51.539794
          ],
          [
            10.505611,
            53.805798,
            52.854097
          ],
          [
            10.505894,
            53.805679,
            53.75367
          ],
          [
            10.506104,
            53.805534,
            54.590207
          ],
          [
            10.506311,
            53.805393,
            55.408493
          ],
          [
            10.506552,
            53.805252,
            56.301363
          ],
          [
            10.506727,
            53.805085,
            57.162408
          ],
          [
            10.506915,
            53.804923,
            58.016025
          ],
          [
            10.507119,
            53.804752,
            58.689662
          ],
          [
            10.507273,
            53.804571,
            59.342119
          ],
          [
            10.507527,
            53.804415,
            60.038401
          ],
          [
            10.507753,
            53.804272,
            60.667737
          ],
          [
            10.507976,
            53.804127,
            61.298142
          ],
          [
            10.508243,
            53.804007,
            61.936951
          ],
          [
            10.508533,
            53.803877,
            62.629476
          ],
          [
            10.508838,
            53.803763,
            63.315478
          ],
          [
            10.509142,
            53.803658,
            63.803685
          ],
          [
            10.509491,
            53.803558,
            63.93957
          ],
          [
            10.509819,
            53.80347,
            64.065958
          ],
          [
            10.510126,
            53.80341,
            64.179546
          ],
          [
            10.510473,
            53.80337,
            64.303464
          ],
          [
            10.510807,
            53.803335,
            64.422319
          ],
          [
            10.511129,
            53.803303,
            64.536765
          ],
          [
            10.511459,
            53.803282,
            64.6539
          ],
          [
            10.511807,
            53.803297,
            64.776114
          ],
          [
            10.512142,
            53.803313,
            64.866102
          ],
          [
            10.512495,
            53.803338,
            64.937019
          ],
          [
            10.512842,
            53.80338,
            65.007677
          ],
          [
            10.5132,
            53.803432,
            65.08118
          ],
          [
            10.513552,
            53.803504,
            65.155436
          ],
          [
            10.514015,
            53.803647,
            65.259656
          ],
          [
            10.514305,
            53.803747,
            65.326619
          ],
          [
            10.514607,
            53.803862,
            65.398249
          ],
          [
            10.514715,
            53.80382,
            65.645387
          ],
          [
            10.514743,
            53.803627,
            66.063496
          ],
          [
            10.514909,
            53.803476,
            66.443963
          ],
          [
            10.515092,
            53.803302,
            66.874731
          ],
          [
            10.515259,
            53.803123,
            67.304313
          ],
          [
            10.515412,
            53.802944,
            67.727229
          ],
          [
            10.515552,
            53.802781,
            68.111579
          ],
          [
            10.515711,
            53.802595,
            68.549643
          ],
          [
            10.515874,
            53.802391,
            69.024203
          ],
          [
            10.516049,
            53.802194,
            69.207961
          ],
          [
            10.516196,
            53.802004,
            69.193173
          ],
          [
            10.516351,
            53.801824,
            69.178877
          ],
          [
            10.51651,
            53.801621,
            69.163036
          ],
          [
            10.516625,
            53.801449,
            69.149929
          ],
          [
            10.516775,
            53.801235,
            69.133515
          ],
          [
            10.516922,
            53.800992,
            69.115241
          ],
          [
            10.51711,
            53.800768,
            69.097524
          ],
          [
            10.517391,
            53.800567,
            69.099116
          ],
          [
            10.517699,
            53.800413,
            69.113449
          ],
          [
            10.518033,
            53.800287,
            69.127538
          ],
          [
            10.518374,
            53.800146,
            69.142351
          ],
          [
            10.518678,
            53.799973,
            69.157355
          ],
          [
            10.51895,
            53.799784,
            69.172273
          ],
          [
            10.519212,
            53.799595,
            69.186966
          ],
          [
            10.519491,
            53.799416,
            69.198812
          ],
          [
            10.519738,
            53.799247,
            69.201689
          ],
          [
            10.519987,
            53.799066,
            69.204697
          ],
          [
            10.520203,
            53.798895,
            69.207446
          ],
          [
            10.520422,
            53.798676,
            69.210726
          ],
          [
            10.520573,
            53.79851,
            69.213154
          ],
          [
            10.520772,
            53.798312,
            69.21612
          ],
          [
            10.520969,
            53.798097,
            69.219271
          ],
          [
            10.521177,
            53.797892,
            69.262072
          ],
          [
            10.521365,
            53.797696,
            69.367271
          ],
          [
            10.521533,
            53.797506,
            69.467355
          ],
          [
            10.521722,
            53.797323,
            69.567461
          ],
          [
            10.521932,
            53.797122,
            69.677756
          ],
          [
            10.522145,
            53.796892,
            69.800163
          ],
          [
            10.52233,
            53.796745,
            69.885686
          ],
          [
            10.522572,
            53.796554,
            69.997085
          ],
          [
            10.522826,
            53.796334,
            70.117565
          ],
          [
            10.522969,
            53.796131,
            70.2134
          ],
          [
            10.523054,
            53.795918,
            70.308713
          ],
          [
            10.52311,
            53.795707,
            70.401672
          ],
          [
            10.52315,
            53.795483,
            70.499708
          ],
          [
            10.523239,
            53.795259,
            70.599865
          ],
          [
            10.523314,
            53.795062,
            70.68775
          ],
          [
            10.523389,
            53.794861,
            70.77753
          ],
          [
            10.523495,
            53.794656,
            70.574687
          ],
          [
            10.523568,
            53.794456,
            69.684687
          ],
          [
            10.523693,
            53.794202,
            68.534105
          ],
          [
            10.523842,
            53.793956,
            67.397349
          ],
          [
            10.524041,
            53.793715,
            66.230581
          ],
          [
            10.52429,
            53.793442,
            64.880592
          ],
          [
            10.524532,
            53.793215,
            63.71029
          ],
          [
            10.524739,
            53.793055,
            62.931109
          ],
          [
            10.524968,
            53.792903,
            62.507102
          ],
          [
            10.525203,
            53.792757,
            62.086004
          ],
          [
            10.52547,
            53.792647,
            61.684376
          ],
          [
            10.52579,
            53.792543,
            61.233524
          ],
          [
            10.526113,
            53.792475,
            60.811387
          ],
          [
            10.526427,
            53.792447,
            60.420495
          ],
          [
            10.526751,
            53.792444,
            60.017024
          ],
          [
            10.527293,
            53.792435,
            59.347932
          ],
          [
            10.527736,
            53.792445,
            59.158114
          ],
          [
            10.528144,
            53.792451,
            59.036496
          ],
          [
            10.528494,
            53.792475,
            58.93149
          ],
          [
            10.528812,
            53.7925,
            58.835787
          ],
          [
            10.529198,
            53.79252,
            58.720422
          ],
          [
            10.529654,
            53.792541,
            58.584239
          ],
          [
            10.530039,
            53.792541,
            58.469614
          ],
          [
            10.530362,
            53.792538,
            58.37333
          ],
          [
            10.530746,
            53.792554,
            58.397158
          ],
          [
            10.531089,
            53.792576,
            58.427411
          ],
          [
            10.531446,
            53.792602,
            58.458935
          ],
          [
            10.531793,
            53.792617,
            58.489453
          ],
          [
            10.532146,
            53.792617,
            58.520399
          ],
          [
            10.532533,
            53.792613,
            58.554355
          ],
          [
            10.532576,
            53.792598,
            58.585492
          ],
          [
            10.532552,
            53.792409,
            58.613746
          ],
          [
            10.532541,
            53.792369,
            58.427102
          ],
          [
            10.532528,
            53.792369,
            58.045431
          ],
          [
            10.532345,
            53.792314,
            57.407369
          ],
          [
            10.532439,
            53.792514,
            56.938039
          ],
          [
            10.532648,
            53.792667,
            56.36845
          ],
          [
            10.533011,
            53.79263,
            55.912835
          ],
          [
            10.533373,
            53.792612,
            55.463156
          ],
          [
            10.533421,
            53.792652,
            55.053751
          ],
          [
            10.533428,
            53.792847,
            54.726589
          ],
          [
            10.533393,
            53.79309,
            54.398797
          ],
          [
            10.533377,
            53.793294,
            54.127605
          ],
          [
            10.533473,
            53.793496,
            53.843782
          ],
          [
            10.533711,
            53.793671,
            53.538871
          ],
          [
            10.53405,
            53.793776,
            53.236699
          ],
          [
            10.534447,
            53.793778,
            52.922436
          ],
          [
            10.534769,
            53.7937,
            52.649116
          ],
          [
            10.535129,
            53.793691,
            52.724616
          ],
          [
            10.535539,
            53.793686,
            53.373483
          ],
          [
            10.53593,
            53.793672,
            53.993563
          ],
          [
            10.5363,
            53.793669,
            54.57902
          ],
          [
            10.536649,
            53.793652,
            55.138589
          ],
          [
            10.536991,
            53.793649,
            55.679807
          ],
          [
            10.537307,
            53.793637,
            56.188411
          ],
          [
            10.537632,
            53.793648,
            56.703788
          ],
          [
            10.537942,
            53.79369,
            57.208418
          ],
          [
            10.538274,
            53.793719,
            57.718831
          ],
          [
            10.538541,
            53.793818,
            58.195576
          ],
          [
            10.538814,
            53.793939,
            58.710729
          ],
          [
            10.539091,
            53.794058,
            59.232368
          ],
          [
            10.539428,
            53.794131,
            59.773707
          ],
          [
            10.539771,
            53.794226,
            60.345431
          ],
          [
            10.540128,
            53.794317,
            60.931872
          ],
          [
            10.540413,
            53.794415,
            61.431151
          ],
          [
            10.540724,
            53.794507,
            61.935871
          ],
          [
            10.541061,
            53.794604,
            62.325481
          ],
          [
            10.541363,
            53.794699,
            62.681089
          ],
          [
            10.541652,
            53.794789,
            63.020739
          ],
          [
            10.541985,
            53.794901,
            63.419841
          ],
          [
            10.542336,
            53.795012,
            63.835059
          ],
          [
            10.542667,
            53.795117,
            64.225671
          ],
          [
            10.542966,
            53.795231,
            64.595698
          ],
          [
            10.54327,
            53.795324,
            64.952397
          ],
          [
            10.543553,
            53.795424,
            64.960188
          ],
          [
            10.543859,
            53.795527,
            64.812848
          ],
          [
            10.544219,
            53.795631,
            64.645228
          ],
          [
            10.544504,
            53.795723,
            64.509357
          ],
          [
            10.544816,
            53.795829,
            64.358463
          ],
          [
            10.545132,
            53.795946,
            64.202452
          ],
          [
            10.545435,
            53.796049,
            64.05623
          ],
          [
            10.54574,
            53.796158,
            63.906969
          ],
          [
            10.546061,
            53.796259,
            63.753019
          ],
          [
            10.546389,
            53.796375,
            63.583096
          ],
          [
            10.546698,
            53.79649,
            63.420778
          ],
          [
            10.547021,
            53.796595,
            63.256924
          ],
          [
            10.547335,
            53.796689,
            63.100413
          ],
          [
            10.547647,
            53.7968,
            62.938475
          ],
          [
            10.54798,
            53.796903,
            62.770556
          ],
          [
            10.548362,
            53.797033,
            62.574622
          ],
          [
            10.548639,
            53.797121,
            62.434749
          ],
          [
            10.548924,
            53.797222,
            62.461845
          ],
          [
            10.549246,
            53.79733,
            62.499364
          ],
          [
            10.549582,
            53.797416,
            62.536503
          ],
          [
            10.549883,
            53.797507,
            62.570753
          ],
          [
            10.550199,
            53.797597,
            62.606308
          ],
          [
            10.550512,
            53.797685,
            62.641455
          ],
          [
            10.550837,
            53.797773,
            62.677698
          ],
          [
            10.551152,
            53.797861,
            62.712999
          ],
          [
            10.551479,
            53.797925,
            62.740128
          ],
          [
            10.551799,
            53.797942,
            62.747807
          ],
          [
            10.552121,
            53.797868,
            62.755761
          ],
          [
            10.552431,
            53.797769,
            62.763891
          ],
          [
            10.552719,
            53.797576,
            62.773921
          ],
          [
            10.552987,
            53.797401,
            62.783118
          ],
          [
            10.553208,
            53.797244,
            62.791098
          ],
          [
            10.553463,
            53.79709,
            62.799514
          ],
          [
            10.553759,
            53.79698,
            62.807567
          ],
          [
            10.554144,
            53.796946,
            62.842551
          ],
          [
            10.554125,
            53.796941,
            62.872997
          ],
          [
            10.554124,
            53.796951,
            62.903253
          ],
          [
            10.554465,
            53.796999,
            62.935264
          ],
          [
            10.554809,
            53.797054,
            62.967848
          ],
          [
            10.555149,
            53.797115,
            63.000297
          ],
          [
            10.55547,
            53.797157,
            63.030347
          ],
          [
            10.55579,
            53.797117,
            63.06053
          ],
          [
            10.556119,
            53.79699,
            62.794326
          ],
          [
            10.55641,
            53.796864,
            61.872723
          ],
          [
            10.556675,
            53.796728,
            60.975969
          ],
          [
            10.556967,
            53.796615,
            60.076893
          ],
          [
            10.557309,
            53.796538,
            59.142029
          ],
          [
            10.557721,
            53.796463,
            58.040831
          ],
          [
            10.558176,
            53.796367,
            56.806562
          ],
          [
            10.558635,
            53.796288,
            55.584187
          ],
          [
            10.559009,
            53.796254,
            55.193808
          ],
          [
            10.559346,
            53.796239,
            55.050438
          ],
          [
            10.559675,
            53.796299,
            54.904949
          ],
          [
            10.560048,
            53.796398,
            54.732568
          ],
          [
            10.560437,
            53.796501,
            54.552819
          ],
          [
            10.560832,
            53.796609,
            54.369343
          ],
          [
            10.561156,
            53.796743,
            54.202517
          ],
          [
            10.561409,
            53.796865,
            54.06467
          ],
          [
            10.561636,
            53.797017,
            53.887759
          ],
          [
            10.561904,
            53.797141,
            53.701539
          ],
          [
            10.562169,
            53.797275,
            53.511479
          ],
          [
            10.562387,
            53.797452,
            53.308881
          ],
          [
            10.562505,
            53.797666,
            53.099965
          ],
          [
            10.562546,
            53.797893,
            52.889396
          ],
          [
            10.562672,
            53.798093,
            52.692249
          ],
          [
            10.562908,
            53.798266,
            52.48715
          ],
          [
            10.563247,
            53.798432,
            52.42856
          ],
          [
            10.56355,
            53.798508,
            52.524694
          ],
          [
            10.56387,
            53.798601,
            52.628994
          ],
          [
            10.564164,
            53.798685,
            52.724294
          ],
          [
            10.564439,
            53.798797,
            52.821757
          ],
          [
            10.564708,
            53.798982,
            52.942397
          ],
          [
            10.564781,
            53.799196,
            53.051405
          ],
          [
            10.564749,
            53.799436,
            53.170537
          ],
          [
            10.564723,
            53.799651,
            53.296318
          ],
          [
            10.564676,
            53.799868,
            53.494043
          ],
          [
            10.56474,
            53.800131,
            53.737078
          ],
          [
            10.565001,
            53.80034,
            53.973618
          ],
          [
            10.56533,
            53.800453,
            54.177056
          ],
          [
            10.565647,
            53.800502,
            54.354168
          ],
          [
            10.566063,
            53.800544,
            54.57993
          ],
          [
            10.566442,
            53.800586,
            54.786102
          ],
          [
            10.566738,
            53.800731,
            55.282448
          ],
          [
            10.566947,
            53.800874,
            55.883874
          ],
          [
            10.567174,
            53.801042,
            56.568547
          ],
          [
            10.567355,
            53.801223,
            57.237875
          ],
          [
            10.567505,
            53.801385,
            57.826121
          ],
          [
            10.567648,
            53.801571,
            58.47695
          ],
          [
            10.567744,
            53.80176,
            59.105264
          ],
          [
            10.567835,
            53.801943,
            59.712481
          ],
          [
            10.567869,
            53.802155,
            60.39333
          ],
          [
            10.567859,
            53.80237,
            60.486766
          ],
          [
            10.567963,
            53.802565,
            60.322652
          ],
          [
            10.568238,
            53.802667,
            60.169355
          ],
          [
            10.568522,
            53.802755,
            60.01773
          ],
          [
            10.568872,
            53.802831,
            59.841458
          ],
          [
            10.569224,
            53.802916,
            59.662027
          ],
          [
            10.569621,
            53.802986,
            59.464705
          ],
          [
            10.569942,
            53.802976,
            59.312673
          ],
          [
            10.570303,
            53.802975,
            59.221195
          ],
          [
            10.570756,
            53.802977,
            59.639737
          ],
          [
            10.571132,
            53.802962,
            59.986063
          ],
          [
            10.571519,
            53.80296,
            60.341681
          ],
          [
            10.571898,
            53.802965,
            60.690021
          ],
          [
            10.572332,
            53.802962,
            61.088866
          ],
          [
            10.572778,
            53.80295,
            61.499291
          ],
          [
            10.573208,
            53.802964,
            61.895485
          ],
          [
            10.573646,
            53.802961,
            61.894309
          ],
          [
            10.574007,
            53.802951,
            61.820846
          ],
          [
            10.574371,
            53.80283,
            61.734104
          ],
          [
            10.574402,
            53.802602,
            61.655535
          ],
          [
            10.574415,
            53.802394,
            61.584152
          ],
          [
            10.57455,
            53.802223,
            61.517289
          ],
          [
            10.57486,
            53.802218,
            61.453081
          ],
          [
            10.575154,
            53.802286,
            61.389056
          ],
          [
            10.5755,
            53.802369,
            61.323378
          ],
          [
            10.575843,
            53.802454,
            61.268402
          ],
          [
            10.576196,
            53.802566,
            61.209098
          ],
          [
            10.576559,
            53.802688,
            61.147329
          ],
          [
            10.576897,
            53.802851,
            61.082828
          ],
          [
            10.577176,
            53.802997,
            61.027768
          ],
          [
            10.577439,
            53.803156,
            60.972149
          ],
          [
            10.57771,
            53.80334,
            60.911148
          ],
          [
            10.577943,
            53.803514,
            60.956127
          ],
          [
            10.578151,
            53.803717,
            61.029078
          ],
          [
            10.578385,
            53.803926,
            61.106234
          ],
          [
            10.578554,
            53.804151,
            61.181891
          ],
          [
            10.578707,
            53.804374,
            61.255871
          ],
          [
            10.578789,
            53.804587,
            61.323054
          ],
          [
            10.578855,
            53.804773,
            61.381469
          ],
          [
            10.578955,
            53.80501,
            61.452494
          ],
          [
            10.579068,
            53.805252,
            61.4285
          ],
          [
            10.579202,
            53.805487,
            61.404797
          ],
          [
            10.579309,
            53.805735,
            61.380335
          ],
          [
            10.579435,
            53.805964,
            61.357311
          ],
          [
            10.579518,
            53.806146,
            61.339292
          ],
          [
            10.579625,
            53.806359,
            61.318056
          ],
          [
            10.579803,
            53.806553,
            61.296859
          ],
          [
            10.580103,
            53.806689,
            61.119501
          ],
          [
            10.580439,
            53.806818,
            60.515506
          ],
          [
            10.580774,
            53.806954,
            59.903666
          ],
          [
            10.58112,
            53.807059,
            59.317805
          ],
          [
            10.581513,
            53.807168,
            58.664617
          ],
          [
            10.581878,
            53.807268,
            58.049887
          ],
          [
            10.582161,
            53.807106,
            57.456283
          ],
          [
            10.582524,
            53.806981,
            56.823509
          ],
          [
            10.582913,
            53.80683,
            56.165312
          ],
          [
            10.583346,
            53.806686,
            55.469865
          ],
          [
            10.583824,
            53.806522,
            54.699039
          ],
          [
            10.584224,
            53.806407,
            54.078651
          ],
          [
            10.584585,
            53.806283,
            53.495589
          ],
          [
            10.585072,
            53.806163,
            52.756269
          ],
          [
            10.585569,
            53.806101,
            52.48535
          ],
          [
            10.586069,
            53.806098,
            52.54185
          ],
          [
            10.586468,
            53.80609,
            52.587548
          ],
          [
            10.586814,
            53.806118,
            52.62703
          ],
          [
            10.587144,
            53.806173,
            52.665822
          ],
          [
            10.587463,
            53.806231,
            52.703563
          ],
          [
            10.587798,
            53.806298,
            52.743805
          ],
          [
            10.588098,
            53.806375,
            52.781383
          ],
          [
            10.588451,
            53.806485,
            53.094168
          ],
          [
            10.588811,
            53.806532,
            53.509769
          ],
          [
            10.589121,
            53.806599,
            53.882366
          ],
          [
            10.589467,
            53.806669,
            54.295687
          ],
          [
            10.589769,
            53.80675,
            54.670581
          ],
          [
            10.590111,
            53.80678,
            55.060688
          ],
          [
            10.590472,
            53.806807,
            55.471066
          ],
          [
            10.590894,
            53.806821,
            55.949508
          ],
          [
            10.591311,
            53.806807,
            56.140912
          ],
          [
            10.591648,
            53.806851,
            55.957386
          ],
          [
            10.592001,
            53.806912,
            55.763464
          ],
          [
            10.592297,
            53.807,
            55.588053
          ],
          [
            10.592638,
            53.807107,
            55.383659
          ],
          [
            10.59297,
            53.807224,
            55.179578
          ],
          [
            10.593288,
            53.807341,
            54.982003
          ],
          [
            10.593569,
            53.807466,
            54.791879
          ],
          [
            10.593931,
            53.807553,
            54.653177
          ],
          [
            10.59423,
            53.807653,
            54.789506
          ],
          [
            10.594518,
            53.807758,
            54.923493
          ],
          [
            10.594856,
            53.807864,
            55.074993
          ],
          [
            10.59521,
            53.80799,
            55.23869
          ],
          [
            10.595555,
            53.807958,
            55.388621
          ],
          [
            10.595938,
            53.807881,
            55.548775
          ],
          [
            10.596273,
            53.807801,
            55.691969
          ],
          [
            10.596606,
            53.807761,
            55.826893
          ],
          [
            10.596922,
            53.80768,
            56.112626
          ],
          [
            10.597235,
            53.807581,
            56.407652
          ],
          [
            10.597547,
            53.807478,
            56.705522
          ],
          [
            10.597881,
            53.807392,
            57.008589
          ],
          [
            10.598215,
            53.807285,
            57.323969
          ],
          [
            10.598545,
            53.807212,
            57.616423
          ],
          [
            10.59895,
            53.807119,
            57.97695
          ],
          [
            10.5994,
            53.807017,
            58.367202
          ],
          [
            10.599709,
            53.806963,
            58.505525
          ],
          [
            10.599934,
            53.806821,
            58.650523
          ],
          [
            10.599962,
            53.806612,
            58.803215
          ],
          [
            10.600016,
            53.806386,
            58.969109
          ],
          [
            10.600072,
            53.806199,
            59.107155
          ],
          [
            10.600128,
            53.805967,
            59.277498
          ],
          [
            10.600146,
            53.805751,
            59.435133
          ],
          [
            10.600144,
            53.805551,
            59.580507
          ],
          [
            10.600139,
            53.805351,
            59.593338
          ],
          [
            10.600111,
            53.805142,
            59.418826
          ],
          [
            10.60026,
            53.804955,
            59.245006
          ],
          [
            10.600481,
            53.804761,
            59.049896
          ],
          [
            10.600656,
            53.804487,
            58.806776
          ],
          [
            10.600717,
            53.80428,
            58.632116
          ],
          [
            10.600775,
            53.80406,
            58.44611
          ],
          [
            10.600792,
            53.803862,
            58.280118
          ],
          [
            10.600848,
            53.803651,
            57.904261
          ],
          [
            10.600942,
            53.80346,
            57.259601
          ],
          [
            10.601075,
            53.803295,
            56.666829
          ],
          [
            10.601184,
            53.803106,
            56.018028
          ],
          [
            10.601358,
            53.802919,
            55.326109
          ],
          [
            10.601515,
            53.80271,
            54.584932
          ],
          [
            10.601695,
            53.802506,
            53.839393
          ],
          [
            10.602016,
            53.802508,
            53.108723
          ],
          [
            10.60232,
            53.802667,
            52.343559
          ],
          [
            10.602655,
            53.802816,
            52.449932
          ],
          [
            10.602965,
            53.802908,
            52.537962
          ],
          [
            10.60334,
            53.802999,
            52.641104
          ],
          [
            10.603673,
            53.803088,
            52.73381
          ],
          [
            10.604046,
            53.803171,
            52.835093
          ],
          [
            10.604414,
            53.803231,
            52.931917
          ],
          [
            10.604737,
            53.803315,
            53.021467
          ],
          [
            10.605076,
            53.80344,
            53.111387
          ],
          [
            10.605387,
            53.803605,
            53.072218
          ],
          [
            10.605699,
            53.803747,
            53.035377
          ],
          [
            10.606018,
            53.803875,
            52.999323
          ],
          [
            10.606337,
            53.804016,
            52.962031
          ],
          [
            10.606677,
            53.804149,
            52.923906
          ],
          [
            10.607014,
            53.804247,
            52.888762
          ],
          [
            10.607384,
            53.804321,
            52.852226
          ],
          [
            10.607759,
            53.804374,
            52.9318
          ],
          [
            10.60814,
            53.804385,
            53.197888
          ],
          [
            10.608494,
            53.804376,
            53.444683
          ],
          [
            10.608836,
            53.80437,
            53.682734
          ],
          [
            10.60927,
            53.80434,
            53.986787
          ],
          [
            10.60969,
            53.804286,
            54.28582
          ],
          [
            10.610053,
            53.804226,
            54.548321
          ],
          [
            10.61042,
            53.804171,
            54.811955
          ],
          [
            10.610793,
            53.804082,
            55.055651
          ],
          [
            10.611173,
            53.803974,
            55.274744
          ],
          [
            10.611551,
            53.803861,
            55.494855
          ],
          [
            10.611951,
            53.803772,
            55.717162
          ],
          [
            10.612344,
            53.803691,
            55.933496
          ],
          [
            10.612747,
            53.80359,
            56.160951
          ],
          [
            10.613148,
            53.803504,
            56.383102
          ],
          [
            10.61356,
            53.803437,
            56.63502
          ],
          [
            10.613984,
            53.80338,
            56.951722
          ],
          [
            10.614387,
            53.803314,
            57.256398
          ],
          [
            10.614751,
            53.803264,
            57.528581
          ],
          [
            10.615118,
            53.80321,
            57.80404
          ],
          [
            10.615488,
            53.80316,
            58.080473
          ],
          [
            10.615872,
            53.80311,
            58.366888
          ],
          [
            10.616272,
            53.803054,
            58.666304
          ],
          [
            10.61658,
            53.803003,
            58.681391
          ],
          [
            10.616953,
            53.802955,
            58.556467
          ],
          [
            10.617266,
            53.802908,
            58.450792
          ],
          [
            10.617604,
            53.80286,
            58.337044
          ],
          [
            10.617921,
            53.802825,
            58.231193
          ],
          [
            10.618255,
            53.802768,
            58.117415
          ],
          [
            10.618616,
            53.802721,
            57.996457
          ],
          [
            10.61896,
            53.802684,
            57.882046
          ],
          [
            10.619318,
            53.802663,
            57.764262
          ],
          [
            10.619667,
            53.802648,
            57.321015
          ],
          [
            10.62005,
            53.802651,
            56.794902
          ],
          [
            10.620395,
            53.802672,
            56.318453
          ],
          [
            10.620767,
            53.802692,
            55.805961
          ],
          [
            10.62113,
            53.802692,
            55.307818
          ],
          [
            10.621497,
            53.802705,
            54.802958
          ],
          [
            10.621849,
            53.802696,
            54.319732
          ],
          [
            10.622176,
            53.802663,
            53.862342
          ],
          [
            10.622507,
            53.802641,
            53.485442
          ],
          [
            10.622727,
            53.802807,
            53.227215
          ],
          [
            10.622844,
            53.802984,
            52.997461
          ],
          [
            10.622953,
            53.803182,
            52.745921
          ],
          [
            10.623107,
            53.803417,
            52.441465
          ],
          [
            10.623264,
            53.803657,
            52.13062
          ],
          [
            10.623474,
            53.803924,
            51.774914
          ],
          [
            10.623681,
            53.804203,
            51.406885
          ],
          [
            10.623938,
            53.804492,
            50.723271
          ],
          [
            10.624282,
            53.804748,
            50.033024
          ],
          [
            10.624639,
            53.804917,
            49.46503
          ],
          [
            10.624546,
            53.805119,
            49.016557
          ],
          [
            10.624507,
            53.805322,
            48.561547
          ],
          [
            10.624581,
            53.805498,
            48.164079
          ],
          [
            10.624508,
            53.805711,
            47.691914
          ],
          [
            10.624277,
            53.805889,
            47.313173
          ],
          [
            10.624077,
            53.806076,
            46.955503
          ],
          [
            10.623884,
            53.806281,
            46.576364
          ],
          [
            10.623683,
            53.806502,
            46.170744
          ],
          [
            10.623454,
            53.806725,
            45.749062
          ],
          [
            10.623286,
            53.806896,
            45.429478
          ],
          [
            10.623134,
            53.807066,
            45.118712
          ],
          [
            10.622929,
            53.807273,
            44.731034
          ],
          [
            10.622772,
            53.807461,
            44.817207
          ],
          [
            10.622587,
            53.807666,
            44.936543
          ],
          [
            10.622449,
            53.807866,
            45.047616
          ],
          [
            10.622308,
            53.808061,
            45.156548
          ],
          [
            10.622155,
            53.808258,
            45.268052
          ],
          [
            10.622006,
            53.808484,
            45.392889
          ],
          [
            10.62187,
            53.808721,
            45.521476
          ],
          [
            10.621775,
            53.808928,
            45.6318
          ],
          [
            10.621681,
            53.809117,
            45.476329
          ],
          [
            10.621578,
            53.809314,
            45.294615
          ],
          [
            10.621513,
            53.80951,
            45.118529
          ],
          [
            10.621446,
            53.809694,
            44.952523
          ],
          [
            10.621383,
            53.809916,
            44.754119
          ],
          [
            10.621321,
            53.810115,
            44.575784
          ],
          [
            10.62127,
            53.810319,
            44.394018
          ],
          [
            10.621224,
            53.810522,
            44.213414
          ],
          [
            10.621177,
            53.81075,
            44.060223
          ],
          [
            10.621154,
            53.810984,
            44.09434
          ],
          [
            10.62112,
            53.811211,
            44.12757
          ],
          [
            10.621117,
            53.811412,
            44.156886
          ],
          [
            10.621114,
            53.811632,
            44.188904
          ],
          [
            10.621082,
            53.811844,
            44.219884
          ],
          [
            10.62108,
            53.81206,
            44.251318
          ],
          [
            10.621071,
            53.812273,
            44.282328
          ],
          [
            10.621069,
            53.812506,
            44.317427
          ],
          [
            10.621114,
            53.812762,
            44.390069
          ],
          [
            10.621144,
            53.813023,
            44.463963
          ],
          [
            10.621168,
            53.813235,
            44.523949
          ],
          [
            10.62119,
            53.813442,
            44.582507
          ],
          [
            10.621202,
            53.813667,
            44.646053
          ],
          [
            10.621238,
            53.813869,
            44.703384
          ],
          [
            10.621285,
            53.814087,
            44.76542
          ],
          [
            10.621348,
            53.814299,
            44.828826
          ],
          [
            10.621431,
            53.814506,
            44.933897
          ],
          [
            10.621527,
            53.814715,
            45.04086
          ],
          [
            10.621632,
            53.81491,
            45.141925
          ],
          [
            10.62175,
            53.815101,
            45.242345
          ],
          [
            10.621886,
            53.815304,
            45.350197
          ],
          [
            10.62201,
            53.8155,
            45.453595
          ],
          [
            10.622158,
            53.815693,
            45.558253
          ],
          [
            10.622306,
            53.815899,
            45.668777
          ],
          [
            10.622437,
            53.816066,
            45.694626
          ],
          [
            10.622566,
            53.816277,
            45.657349
          ],
          [
            10.622602,
            53.816492,
            45.62116
          ],
          [
            10.622657,
            53.816715,
            45.58349
          ],
          [
            10.622725,
            53.816966,
            45.541247
          ],
          [
            10.622823,
            53.81718,
            45.504407
          ],
          [
            10.622992,
            53.817361,
            45.469938
          ],
          [
            10.62321,
            53.817585,
            45.42701
          ],
          [
            10.623431,
            53.81777,
            45.338068
          ],
          [
            10.623641,
            53.817922,
            45.231916
          ],
          [
            10.623868,
            53.818075,
            45.121335
          ],
          [
            10.624151,
            53.818205,
            45.006457
          ],
          [
            10.62447,
            53.818287,
            44.895291
          ],
          [
            10.62478,
            53.818368,
            44.787094
          ],
          [
            10.625064,
            53.81846,
            44.683439
          ],
          [
            10.625346,
            53.818596,
            44.56722
          ],
          [
            10.625638,
            53.818699,
            44.458631
          ],
          [
            10.625944,
            53.818809,
            44.401796
          ],
          [
            10.626261,
            53.818927,
            44.354115
          ],
          [
            10.626556,
            53.819079,
            44.304366
          ],
          [
            10.626814,
            53.81927,
            44.251786
          ],
          [
            10.627072,
            53.819443,
            44.202138
          ],
          [
            10.627252,
            53.819639,
            44.154062
          ],
          [
            10.627185,
            53.819847,
            44.108079
          ],
          [
            10.627224,
            53.820038,
            44.06435
          ],
          [
            10.627526,
            53.820153,
            44.110308
          ],
          [
            10.627903,
            53.820156,
            44.188589
          ],
          [
            10.62832,
            53.820197,
            44.276629
          ],
          [
            10.628622,
            53.820332,
            44.355733
          ],
          [
            10.628876,
            53.820492,
            44.432865
          ],
          [
            10.629139,
            53.820651,
            44.51107
          ],
          [
            10.629435,
            53.820809,
            44.593924
          ],
          [
            10.629727,
            53.820964,
            44.675531
          ],
          [
            10.630008,
            53.821126,
            44.788288
          ],
          [
            10.630293,
            53.821273,
            44.901256
          ],
          [
            10.630567,
            53.821424,
            45.012941
          ],
          [
            10.630852,
            53.821591,
            45.13259
          ],
          [
            10.631111,
            53.821755,
            45.245858
          ],
          [
            10.631373,
            53.821918,
            45.35931
          ],
          [
            10.631568,
            53.82208,
            45.460143
          ],
          [
            10.631774,
            53.822235,
            45.559697
          ],
          [
            10.631977,
            53.822392,
            45.55659
          ],
          [
            10.632198,
            53.822555,
            45.498301
          ],
          [
            10.632398,
            53.822705,
            45.44502
          ],
          [
            10.632615,
            53.822891,
            45.381965
          ],
          [
            10.632813,
            53.823079,
            45.320186
          ],
          [
            10.632995,
            53.823281,
            45.256302
          ],
          [
            10.63317,
            53.823464,
            45.197654
          ],
          [
            10.633349,
            53.823662,
            45.135018
          ],
          [
            10.633547,
            53.823865,
            45.069352
          ],
          [
            10.633732,
            53.824071,
            45.003397
          ],
          [
            10.633927,
            53.824277,
            44.936644
          ],
          [
            10.634118,
            53.82448,
            44.870936
          ],
          [
            10.634281,
            53.824672,
            44.810184
          ],
          [
            10.634471,
            53.824878,
            44.743835
          ],
          [
            10.634669,
            53.825086,
            44.676336
          ],
          [
            10.634863,
            53.825283,
            44.611877
          ],
          [
            10.635043,
            53.825491,
            44.584911
          ],
          [
            10.635228,
            53.8257,
            44.589403
          ],
          [
            10.635407,
            53.825895,
            44.59363
          ],
          [
            10.635569,
            53.826078,
            44.597563
          ],
          [
            10.635752,
            53.82626,
            44.601595
          ],
          [
            10.635949,
            53.826474,
            44.606235
          ],
          [
            10.636142,
            53.826688,
            44.610854
          ],
          [
            10.636316,
            53.826882,
            44.615035
          ],
          [
            10.636526,
            53.827098,
            44.406318
          ],
          [
            10.636734,
            53.827323,
            44.071848
          ],
          [
            10.636946,
            53.827539,
            43.746194
          ],
          [
            10.637105,
            53.827739,
            43.458002
          ],
          [
            10.637297,
            53.827949,
            43.146706
          ],
          [
            10.637493,
            53.828129,
            42.867407
          ],
          [
            10.637667,
            53.828331,
            42.571715
          ],
          [
            10.637834,
            53.828491,
            42.326574
          ],
          [
            10.637994,
            53.828675,
            42.255582
          ],
          [
            10.638137,
            53.828851,
            42.237889
          ],
          [
            10.638312,
            53.829057,
            42.216994
          ],
          [
            10.638518,
            53.829282,
            42.193799
          ],
          [
            10.638699,
            53.829482,
            42.173244
          ],
          [
            10.638889,
            53.829682,
            42.152461
          ],
          [
            10.639076,
            53.829863,
            42.133245
          ],
          [
            10.639294,
            53.830067,
            42.111317
          ],
          [
            10.639492,
            53.830292,
            42.382217
          ],
          [
            10.63964,
            53.830488,
            42.662541
          ],
          [
            10.639828,
            53.830704,
            42.979981
          ],
          [
            10.64001,
            53.830901,
            43.273138
          ],
          [
            10.640236,
            53.831104,
            43.590463
          ],
          [
            10.640428,
            53.831292,
            43.877456
          ],
          [
            10.640638,
            53.831508,
            44.204309
          ],
          [
            10.640779,
            53.831707,
            44.475087
          ],
          [
            10.640928,
            53.831886,
            44.636303
          ],
          [
            10.641117,
            53.832091,
            44.824928
          ],
          [
            10.641266,
            53.832258,
            44.977474
          ],
          [
            10.641475,
            53.832475,
            45.179214
          ],
          [
            10.641612,
            53.832646,
            45.332183
          ],
          [
            10.64179,
            53.832836,
            45.507654
          ],
          [
            10.641971,
            53.833032,
            45.688068
          ],
          [
            10.642188,
            53.833259,
            45.898678
          ],
          [
            10.642348,
            53.833487,
            45.98854
          ],
          [
            10.642561,
            53.833707,
            46.07384
          ],
          [
            10.642727,
            53.833925,
            46.154393
          ],
          [
            10.642859,
            53.834162,
            46.238273
          ],
          [
            10.643003,
            53.834376,
            46.315949
          ],
          [
            10.643143,
            53.834576,
            46.388781
          ],
          [
            10.643269,
            53.834784,
            46.46314
          ],
          [
            10.643361,
            53.834987,
            46.535639
          ],
          [
            10.64344,
            53.835224,
            46.624875
          ],
          [
            10.643501,
            53.83546,
            46.713084
          ],
          [
            10.643553,
            53.835702,
            46.803202
          ],
          [
            10.643582,
            53.835933,
            46.889039
          ],
          [
            10.643585,
            53.836164,
            46.974377
          ],
          [
            10.643613,
            53.836392,
            47.058897
          ],
          [
            10.643617,
            53.836611,
            47.139868
          ],
          [
            10.643612,
            53.83681,
            47.162354
          ],
          [
            10.643591,
            53.837046,
            47.11808
          ],
          [
            10.643524,
            53.83725,
            47.079142
          ],
          [
            10.643461,
            53.837445,
            47.041953
          ],
          [
            10.643402,
            53.837679,
            46.99756
          ],
          [
            10.643347,
            53.837887,
            46.958123
          ],
          [
            10.643547,
            53.838109,
            46.910773
          ],
          [
            10.643468,
            53.838329,
            46.866495
          ],
          [
            10.643189,
            53.838507,
            46.984656
          ],
          [
            10.643125,
            53.838706,
            47.215897
          ],
          [
            10.643096,
            53.838908,
            47.446937
          ],
          [
            10.64305,
            53.839109,
            47.678053
          ],
          [
            10.642992,
            53.83932,
            47.922713
          ],
          [
            10.642913,
            53.83953,
            48.167882
          ],
          [
            10.642867,
            53.839729,
            48.396812
          ],
          [
            10.642863,
            53.839935,
            48.633217
          ],
          [
            10.642875,
            53.840154,
            48.882874
          ],
          [
            10.642862,
            53.840351,
            48.360347
          ],
          [
            10.642901,
            53.840554,
            47.786595
          ],
          [
            10.642917,
            53.840756,
            47.218636
          ],
          [
            10.642937,
            53.840974,
            46.605436
          ],
          [
            10.642981,
            53.841207,
            45.947103
          ],
          [
            10.643086,
            53.841414,
            45.340375
          ],
          [
            10.643201,
            53.841656,
            44.634611
          ],
          [
            10.643309,
            53.841868,
            44.013012
          ],
          [
            10.643438,
            53.84207,
            43.706351
          ],
          [
            10.643587,
            53.842283,
            43.505383
          ],
          [
            10.643733,
            53.842494,
            43.306588
          ],
          [
            10.643888,
            53.842664,
            43.138241
          ],
          [
            10.644025,
            53.842861,
            42.952503
          ],
          [
            10.644236,
            53.843079,
            42.733567
          ],
          [
            10.644474,
            53.843291,
            42.511576
          ],
          [
            10.644724,
            53.843489,
            42.296165
          ],
          [
            10.644973,
            53.843652,
            42.275581
          ],
          [
            10.645338,
            53.843681,
            42.278771
          ],
          [
            10.645379,
            53.843886,
            42.282077
          ],
          [
            10.645437,
            53.844095,
            42.285252
          ],
          [
            10.645717,
            53.844233,
            42.288443
          ],
          [
            10.646027,
            53.844395,
            42.292029
          ],
          [
            10.646343,
            53.844563,
            42.29571
          ],
          [
            10.646678,
            53.844716,
            42.321525
          ],
          [
            10.647033,
            53.844865,
            42.656251
          ],
          [
            10.647296,
            53.844963,
            42.895204
          ],
          [
            10.647667,
            53.84509,
            43.224588
          ],
          [
            10.648027,
            53.845205,
            43.538941
          ],
          [
            10.648376,
            53.845306,
            43.837419
          ],
          [
            10.648735,
            53.845435,
            44.160749
          ],
          [
            10.649034,
            53.845517,
            44.414312
          ],
          [
            10.649436,
            53.845593,
            44.519803
          ],
          [
            10.649836,
            53.845666,
            44.130245
          ],
          [
            10.650203,
            53.845729,
            43.774527
          ],
          [
            10.650554,
            53.845769,
            43.440983
          ],
          [
            10.650932,
            53.845789,
            43.087732
          ],
          [
            10.651277,
            53.845816,
            42.763876
          ],
          [
            10.651553,
            53.845912,
            42.460586
          ],
          [
            10.651887,
            53.846073,
            42.058847
          ],
          [
            10.652208,
            53.846139,
            41.690961
          ],
          [
            10.652531,
            53.84604,
            41.192353
          ],
          [
            10.652871,
            53.84597,
            40.695307
          ],
          [
            10.653223,
            53.845906,
            40.188104
          ],
          [
            10.653592,
            53.845883,
            39.679985
          ],
          [
            10.653975,
            53.845887,
            39.155422
          ],
          [
            10.654292,
            53.845877,
            38.720607
          ],
          [
            10.654687,
            53.845894,
            38.178259
          ],
          [
            10.655132,
            53.845893,
            37.714749
          ],
          [
            10.655547,
            53.84576,
            38.633771
          ],
          [
            10.65587,
            53.84564,
            39.373025
          ],
          [
            10.656214,
            53.845604,
            40.050475
          ],
          [
            10.656612,
            53.845557,
            40.837218
          ],
          [
            10.656867,
            53.845653,
            41.43185
          ],
          [
            10.657189,
            53.845704,
            42.078632
          ],
          [
            10.657589,
            53.845785,
            42.897853
          ],
          [
            10.657931,
            53.845796,
            43.535854
          ],
          [
            10.658262,
            53.845803,
            43.589539
          ],
          [
            10.658575,
            53.845832,
            43.641217
          ],
          [
            10.658881,
            53.845889,
            43.694613
          ],
          [
            10.659289,
            53.845936,
            43.762359
          ],
          [
            10.659638,
            53.845992,
            43.82102
          ],
          [
            10.659988,
            53.846046,
            43.879656
          ],
          [
            10.660363,
            53.846119,
            43.943694
          ],
          [
            10.660745,
            53.846181,
            44.007947
          ],
          [
            10.661081,
            53.846255,
            43.897325
          ],
          [
            10.661462,
            53.846341,
            43.677474
          ],
          [
            10.661816,
            53.846441,
            43.466195
          ],
          [
            10.662161,
            53.846554,
            43.253778
          ],
          [
            10.662488,
            53.846681,
            43.042845
          ],
          [
            10.662859,
            53.846802,
            42.811508
          ],
          [
            10.663161,
            53.84694,
            42.605508
          ],
          [
            10.663472,
            53.847098,
            42.389207
          ],
          [
            10.66378,
            53.847241,
            42.911512
          ],
          [
            10.66406,
            53.847387,
            43.409541
          ],
          [
            10.664325,
            53.847551,
            43.921325
          ],
          [
            10.664581,
            53.847739,
            44.466127
          ],
          [
            10.664843,
            53.847897,
            44.965448
          ],
          [
            10.665134,
            53.848069,
            45.51564
          ],
          [
            10.665388,
            53.848257,
            46.058797
          ],
          [
            10.665513,
            53.848477,
            46.368996
          ],
          [
            10.665768,
            53.84868,
            46.077546
          ],
          [
            10.666045,
            53.848824,
            45.825714
          ],
          [
            10.666267,
            53.84903,
            45.543446
          ],
          [
            10.666451,
            53.849244,
            45.26788
          ],
          [
            10.666664,
            53.849432,
            45.008011
          ],
          [
            10.666978,
            53.849652,
            44.677729
          ],
          [
            10.667221,
            53.849805,
            44.436651
          ],
          [
            10.667437,
            53.849944,
            44.304098
          ],
          [
            10.667723,
            53.850035,
            44.196206
          ],
          [
            10.66801,
            53.850125,
            44.089279
          ],
          [
            10.668329,
            53.850239,
            43.966752
          ],
          [
            10.668633,
            53.850412,
            43.828261
          ],
          [
            10.668929,
            53.850597,
            43.686821
          ],
          [
            10.669255,
            53.850787,
            43.536572
          ],
          [
            10.669542,
            53.850927,
            43.414456
          ],
          [
            10.669759,
            53.851075,
            43.327237
          ],
          [
            10.66997,
            53.851213,
            43.252567
          ],
          [
            10.670237,
            53.851373,
            43.16206
          ],
          [
            10.670529,
            53.851507,
            43.074321
          ],
          [
            10.670715,
            53.851701,
            42.984201
          ],
          [
            10.670715,
            53.851906,
            42.901777
          ],
          [
            10.670946,
            53.852069,
            42.816423
          ],
          [
            10.671249,
            53.852219,
            42.722278
          ],
          [
            10.671544,
            53.852377,
            42.790453
          ],
          [
            10.671811,
            53.852551,
            43.161354
          ],
          [
            10.672054,
            53.852714,
            43.504472
          ],
          [
            10.672309,
            53.852837,
            43.811662
          ],
          [
            10.672649,
            53.852853,
            44.139308
          ],
          [
            10.673007,
            53.852842,
            44.474968
          ],
          [
            10.673275,
            53.85293,
            44.766133
          ],
          [
            10.67328,
            53.852944,
            45.06679
          ],
          [
            10.673588,
            53.853113,
            45.458919
          ],
          [
            10.673825,
            53.853275,
            45.047857
          ],
          [
            10.673839,
            53.853497,
            44.506206
          ],
          [
            10.674045,
            53.853677,
            43.965748
          ],
          [
            10.674275,
            53.853809,
            43.504282
          ],
          [
            10.674511,
            53.853956,
            43.010756
          ],
          [
            10.674737,
            53.854093,
            42.54462
          ],
          [
            10.674975,
            53.854242,
            42.045582
          ],
          [
            10.675249,
            53.854413,
            41.47203
          ],
          [
            10.675534,
            53.854608,
            41.298027
          ],
          [
            10.675802,
            53.854758,
            41.644563
          ],
          [
            10.67609,
            53.854909,
            42.005926
          ],
          [
            10.676388,
            53.855083,
            42.399191
          ],
          [
            10.676652,
            53.855245,
            42.756473
          ],
          [
            10.676949,
            53.855418,
            43.147929
          ],
          [
            10.6772,
            53.855579,
            43.495971
          ],
          [
            10.677491,
            53.855767,
            43.90072
          ],
          [
            10.677744,
            53.855946,
            44.257358
          ],
          [
            10.67798,
            53.856151,
            44.632125
          ],
          [
            10.678142,
            53.856352,
            44.967823
          ],
          [
            10.678278,
            53.856544,
            45.282366
          ],
          [
            10.67845,
            53.856762,
            45.645051
          ],
          [
            10.678382,
            53.856903,
            45.921517
          ],
          [
            10.678083,
            53.856981,
            46.247363
          ],
          [
            10.677777,
            53.857114,
            46.585503
          ],
          [
            10.677438,
            53.857223,
            47.054644
          ],
          [
            10.677145,
            53.857343,
            47.539873
          ],
          [
            10.676938,
            53.857499,
            48.009795
          ],
          [
            10.67703,
            53.857595,
            48.463304
          ],
          [
            10.677279,
            53.857453,
            48.934726
          ],
          [
            10.677553,
            53.857341,
            49.388189
          ],
          [
            10.677862,
            53.85724,
            49.868964
          ],
          [
            10.678221,
            53.857142,
            50.407117
          ],
          [
            10.678535,
            53.857063,
            50.822363
          ],
          [
            10.678866,
            53.856982,
            50.566736
          ],
          [
            10.679158,
            53.856907,
            50.339415
          ],
          [
            10.679491,
            53.856823,
            50.081102
          ],
          [
            10.679815,
            53.85672,
            49.817118
          ],
          [
            10.680104,
            53.856611,
            49.571537
          ],
          [
            10.680325,
            53.856773,
            49.318023
          ],
          [
            10.680615,
            53.856656,
            49.062178
          ],
          [
            10.680816,
            53.856785,
            48.788824
          ],
          [
            10.680721,
            53.856966,
            48.574495
          ],
          [
            10.680622,
            53.857178,
            48.346076
          ],
          [
            10.680549,
            53.857395,
            48.116182
          ],
          [
            10.680469,
            53.857616,
            47.881427
          ],
          [
            10.680398,
            53.857818,
            47.667127
          ],
          [
            10.680311,
            53.858035,
            47.435418
          ],
          [
            10.680247,
            53.858239,
            47.219907
          ],
          [
            10.680175,
            53.858458,
            46.988133
          ],
          [
            10.680116,
            53.858681,
            46.788848
          ],
          [
            10.680046,
            53.858906,
            46.746781
          ],
          [
            10.679957,
            53.85913,
            46.704475
          ],
          [
            10.67989,
            53.859361,
            46.661412
          ],
          [
            10.679834,
            53.859605,
            46.616162
          ],
          [
            10.67977,
            53.859845,
            46.571488
          ],
          [
            10.679679,
            53.860099,
            46.523786
          ],
          [
            10.679639,
            53.860288,
            46.488787
          ],
          [
            10.679584,
            53.860501,
            46.323046
          ],
          [
            10.679536,
            53.860726,
            45.96707
          ],
          [
            10.679453,
            53.860909,
            45.670509
          ],
          [
            10.679381,
            53.861158,
            45.27407
          ],
          [
            10.679698,
            53.861211,
            44.930068
          ],
          [
            10.680022,
            53.861151,
            44.616518
          ],
          [
            10.680324,
            53.861025,
            44.274706
          ],
          [
            10.680589,
            53.86087,
            43.929405
          ],
          [
            10.680841,
            53.860729,
            43.649641
          ],
          [
            10.681067,
            53.86056,
            43.645101
          ],
          [
            10.681421,
            53.860394,
            43.63949
          ],
          [
            10.681668,
            53.860247,
            43.635127
          ],
          [
            10.681884,
            53.86011,
            43.63119
          ],
          [
            10.6821,
            53.85996,
            43.627049
          ],
          [
            10.682333,
            53.859824,
            43.622974
          ],
          [
            10.682552,
            53.859679,
            43.61888
          ],
          [
            10.682792,
            53.859526,
            43.61449
          ],
          [
            10.683037,
            53.859405,
            43.767369
          ],
          [
            10.683306,
            53.859249,
            44.16297
          ],
          [
            10.683586,
            53.859082,
            44.578806
          ],
          [
            10.683891,
            53.858895,
            45.039474
          ],
          [
            10.684135,
            53.85872,
            45.440433
          ],
          [
            10.684439,
            53.85858,
            45.843304
          ],
          [
            10.684687,
            53.858442,
            46.19918
          ],
          [
            10.685028,
            53.858373,
            46.581384
          ],
          [
            10.685421,
            53.858402,
            46.580397
          ],
          [
            10.685738,
            53.858357,
            46.181954
          ],
          [
            10.685852,
            53.858122,
            45.715898
          ],
          [
            10.685933,
            53.857905,
            45.290319
          ],
          [
            10.685997,
            53.85762,
            44.741415
          ],
          [
            10.686167,
            53.857457,
            44.373755
          ],
          [
            10.686542,
            53.857366,
            43.915605
          ],
          [
            10.686893,
            53.857453,
            43.486488
          ],
          [
            10.687283,
            53.857524,
            42.908323
          ],
          [
            10.687706,
            53.857601,
            42.23567
          ],
          [
            10.688078,
            53.857724,
            41.586856
          ],
          [
            10.688365,
            53.857863,
            41.004274
          ],
          [
            10.688767,
            53.858012,
            40.282908
          ],
          [
            10.689001,
            53.858141,
            39.796194
          ],
          [
            10.689314,
            53.858308,
            39.154021
          ],
          [
            10.689564,
            53.858444,
            38.802901
          ],
          [
            10.689832,
            53.858574,
            39.17947
          ],
          [
            10.690021,
            53.858734,
            39.540745
          ],
          [
            10.690292,
            53.858937,
            40.016402
          ],
          [
            10.690509,
            53.859115,
            40.420342
          ],
          [
            10.690742,
            53.859289,
            40.827795
          ],
          [
            10.690983,
            53.859445,
            41.220596
          ],
          [
            10.69127,
            53.859689,
            41.766569
          ],
          [
            10.691443,
            53.859888,
            42.062228
          ],
          [
            10.691618,
            53.860107,
            42.138163
          ],
          [
            10.691752,
            53.860288,
            42.19994
          ],
          [
            10.691877,
            53.860482,
            42.264829
          ],
          [
            10.692049,
            53.86072,
            42.345868
          ],
          [
            10.692166,
            53.860914,
            42.410646
          ],
          [
            10.69231,
            53.861097,
            42.473774
          ],
          [
            10.692441,
            53.861343,
            42.554401
          ],
          [
            10.692599,
            53.861543,
            42.829218
          ],
          [
            10.692779,
            53.861753,
            43.56743
          ],
          [
            10.692945,
            53.861991,
            44.374238
          ],
          [
            10.693071,
            53.862195,
            45.055168
          ],
          [
            10.693214,
            53.862384,
            45.704148
          ],
          [
            10.693362,
            53.862608,
            46.45775
          ],
          [
            10.693522,
            53.86284,
            47.243025
          ],
          [
            10.693656,
            53.863025,
            47.874436
          ],
          [
            10.693746,
            53.86325,
            48.311516
          ],
          [
            10.693836,
            53.863432,
            48.430828
          ],
          [
            10.693601,
            53.863577,
            48.558028
          ],
          [
            10.693656,
            53.863725,
            48.680821
          ],
          [
            10.693995,
            53.863716,
            48.806563
          ],
          [
            10.694325,
            53.863668,
            48.932505
          ],
          [
            10.694713,
            53.86362,
            49.080744
          ],
          [
            10.695065,
            53.863542,
            49.220257
          ],
          [
            10.69546,
            53.86347,
            49.381592
          ],
          [
            10.695836,
            53.863426,
            49.652349
          ],
          [
            10.696191,
            53.863365,
            49.911637
          ],
          [
            10.696528,
            53.863297,
            50.161816
          ],
          [
            10.696844,
            53.863193,
            50.415945
          ],
          [
            10.697232,
            53.863121,
            50.702258
          ],
          [
            10.697559,
            53.863046,
            50.949969
          ],
          [
            10.69795,
            53.863058,
            51.224618
          ],
          [
            10.69835,
            53.863072,
            51.505723
          ],
          [
            10.69869,
            53.863072,
            51.834863
          ],
          [
            10.699048,
            53.863066,
            52.181839
          ],
          [
            10.69941,
            53.862997,
            52.556814
          ],
          [
            10.699802,
            53.86299,
            52.938318
          ],
          [
            10.700169,
            53.862995,
            53.296591
          ],
          [
            10.70052,
            53.862986,
            53.637004
          ],
          [
            10.700902,
            53.862988,
            54.007062
          ],
          [
            10.701309,
            53.862996,
            54.407937
          ],
          [
            10.701614,
            53.863034,
            54.504245
          ],
          [
            10.701951,
            53.863047,
            54.561815
          ],
          [
            10.702392,
            53.863029,
            54.635009
          ],
          [
            10.702766,
            53.862998,
            54.697332
          ],
          [
            10.703134,
            53.86301,
            54.758445
          ],
          [
            10.703455,
            53.863005,
            54.811422
          ],
          [
            10.703831,
            53.86302,
            54.873604
          ],
          [
            10.704256,
            53.863033,
            54.943809
          ],
          [
            10.704635,
            53.863017,
            55.123466
          ],
          [
            10.704981,
            53.863017,
            55.341116
          ],
          [
            10.705327,
            53.86301,
            55.559334
          ],
          [
            10.705665,
            53.862994,
            55.772643
          ],
          [
            10.706016,
            53.863013,
            55.99446
          ],
          [
            10.706391,
            53.863016,
            56.230367
          ],
          [
            10.706789,
            53.863,
            56.481495
          ],
          [
            10.707173,
            53.863037,
            56.727476
          ],
          [
            10.707565,
            53.863073,
            56.884782
          ],
          [
            10.707936,
            53.863109,
            56.88815
          ],
          [
            10.708301,
            53.863139,
            56.891454
          ],
          [
            10.708632,
            53.863171,
            56.894457
          ],
          [
            10.708978,
            53.863229,
            56.897676
          ],
          [
            10.709338,
            53.863264,
            56.900953
          ],
          [
            10.70973,
            53.863302,
            56.904507
          ],
          [
            10.710109,
            53.863343,
            56.907955
          ],
          [
            10.710491,
            53.863383,
            56.998502
          ],
          [
            10.710848,
            53.863421,
            57.395391
          ],
          [
            10.711189,
            53.863443,
            57.771028
          ],
          [
            10.711523,
            53.863429,
            58.137757
          ],
          [
            10.711646,
            53.863752,
            58.752011
          ],
          [
            10.711724,
            53.86396,
            59.147303
          ],
          [
            10.711789,
            53.864206,
            59.610184
          ],
          [
            10.71184,
            53.864465,
            60.094494
          ],
          [
            10.711882,
            53.864649,
            60.316723
          ],
          [
            10.711952,
            53.864893,
            60.482351
          ],
          [
            10.712008,
            53.865093,
            60.618047
          ],
          [
            10.712038,
            53.865295,
            60.753996
          ],
          [
            10.71211,
            53.865523,
            60.909227
          ],
          [
            10.712152,
            53.865753,
            61.064057
          ],
          [
            10.712231,
            53.865992,
            61.22712
          ],
          [
            10.712282,
            53.866211,
            61.375141
          ],
          [
            10.712353,
            53.86645,
            61.307673
          ],
          [
            10.712398,
            53.866669,
            61.061069
          ],
          [
            10.712537,
            53.866827,
            60.850524
          ],
          [
            10.712431,
            53.867,
            60.613953
          ],
          [
            10.712474,
            53.867209,
            60.378953
          ],
          [
            10.7125,
            53.867452,
            60.107141
          ],
          [
            10.712518,
            53.867706,
            59.823335
          ],
          [
            10.712552,
            53.867905,
            59.60001
          ],
          [
            10.712551,
            53.868126,
            59.544241
          ],
          [
            10.712446,
            53.86831,
            59.780122
          ],
          [
            10.712402,
            53.86851,
            60.025074
          ],
          [
            10.712345,
            53.868746,
            60.314556
          ],
          [
            10.712286,
            53.868942,
            60.556221
          ],
          // [
          //   10.712226,
          //   53.869134,
          //   60.793376
          // ],
          // [
          //   10.71216,
          //   53.869373,
          //   61.088148
          // ],
          // [
          //   10.712146,
          //   53.869554,
          //   61.309464
          // ],
          // [
          //   10.712226,
          //   53.869747,
          //   61.577652
          // ],
          // [
          //   10.712596,
          //   53.8698,
          //   61.627453
          // ],
          // [
          //   10.713022,
          //   53.869852,
          //   61.627453
          // ],
          // [
          //   10.713437,
          //   53.86992,
          //   61.627453
          // ],
          // [
          //   10.713847,
          //   53.869973,
          //   61.627453
          // ],
          // [
          //   10.714204,
          //   53.870024,
          //   61.627453
          // ],
          // [
          //   10.71413,
          //   53.870228,
          //   61.627453
          // ],
          // [
          //   10.714054,
          //   53.870407,
          //   61.627453
          // ],
          // [
          //   10.713825,
          //   53.8705,
          //   61.627453
          // ],
          // [
          //   10.713595,
          //   53.870449,
          //   61.627453
          // ]
        ]
      }
    }
  ]
}

let day27: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            10.71402,
            53.870408,
            63.392157
          ],
          [
            10.714119,
            53.870203,
            63.392157
          ],
          [
            10.714242,
            53.870016,
            63.392157
          ],
          [
            10.714573,
            53.870028,
            63.392157
          ],
          [
            10.714985,
            53.870082,
            63.392157
          ],
          [
            10.71535,
            53.870126,
            63.14873
          ],
          [
            10.715731,
            53.870157,
            62.861964
          ],
          [
            10.716094,
            53.870178,
            62.590042
          ],
          [
            10.716426,
            53.870192,
            62.341367
          ],
          [
            10.716741,
            53.870227,
            62.101995
          ],
          [
            10.717075,
            53.87025,
            61.851297
          ],
          [
            10.717427,
            53.870278,
            61.586278
          ],
          [
            10.71776,
            53.870321,
            61.332028
          ],
          [
            10.718117,
            53.87036,
            61.03151
          ],
          [
            10.718482,
            53.870399,
            60.609805
          ],
          [
            10.718851,
            53.870427,
            60.186933
          ],
          [
            10.719178,
            53.870457,
            59.810518
          ],
          [
            10.719534,
            53.870492,
            59.40027
          ],
          [
            10.719891,
            53.870544,
            58.982293
          ],
          [
            10.720207,
            53.870581,
            58.616117
          ],
          [
            10.720441,
            53.87068,
            58.247482
          ],
          [
            10.720459,
            53.870882,
            57.851854
          ],
          [
            10.720378,
            53.871095,
            57.401221
          ],
          [
            10.720263,
            53.871313,
            56.902336
          ],
          [
            10.720164,
            53.871534,
            56.402621
          ],
          [
            10.720041,
            53.871767,
            55.867806
          ],
          [
            10.71987,
            53.871998,
            55.316475
          ],
          [
            10.719693,
            53.872188,
            54.842569
          ],
          [
            10.719519,
            53.872412,
            54.30409
          ],
          [
            10.719416,
            53.872646,
            53.771195
          ],
          [
            10.719774,
            53.872704,
            54.264577
          ],
          [
            10.720102,
            53.872722,
            54.800551
          ],
          [
            10.720462,
            53.872771,
            55.399581
          ],
          [
            10.720865,
            53.872829,
            56.072454
          ],
          [
            10.721284,
            53.87289,
            56.771759
          ],
          [
            10.721703,
            53.872896,
            57.450868
          ],
          [
            10.722087,
            53.872917,
            58.076308
          ],
          [
            10.722505,
            53.8729,
            58.576499
          ],
          [
            10.722875,
            53.872871,
            58.003181
          ],
          [
            10.723286,
            53.872829,
            57.36258
          ],
          [
            10.723686,
            53.872783,
            56.736715
          ],
          [
            10.724062,
            53.872763,
            56.156851
          ],
          [
            10.724444,
            53.872763,
            55.56961
          ],
          [
            10.724767,
            53.872794,
            55.067039
          ],
          [
            10.725099,
            53.872921,
            54.455477
          ],
          [
            10.725194,
            53.873108,
            53.921667
          ],
          [
            10.725023,
            53.873309,
            53.622803
          ],
          [
            10.725132,
            53.873505,
            53.346477
          ],
          [
            10.725482,
            53.873484,
            53.065671
          ],
          [
            10.725825,
            53.873438,
            52.789909
          ],
          [
            10.726158,
            53.873405,
            52.524867
          ],
          [
            10.726539,
            53.873363,
            52.22062
          ],
          [
            10.726903,
            53.87332,
            51.929484
          ],
          [
            10.727256,
            53.87328,
            51.64713
          ],
          [
            10.727597,
            53.873254,
            51.758257
          ],
          [
            10.727932,
            53.873206,
            51.976907
          ],
          [
            10.728233,
            53.873148,
            52.177609
          ],
          [
            10.728574,
            53.873108,
            52.397835
          ],
          [
            10.728979,
            53.873065,
            52.658537
          ],
          [
            10.729338,
            53.873014,
            52.892477
          ],
          [
            10.729669,
            53.872955,
            53.111505
          ],
          [
            10.729983,
            53.872897,
            53.319929
          ],
          [
            10.73028,
            53.872821,
            53.52441
          ],
          [
            10.730662,
            53.872733,
            53.751285
          ],
          [
            10.731036,
            53.872667,
            53.966548
          ],
          [
            10.731416,
            53.872571,
            54.194324
          ],
          [
            10.731772,
            53.87249,
            54.404567
          ],
          [
            10.732156,
            53.872394,
            54.634395
          ],
          [
            10.73247,
            53.872334,
            54.816301
          ],
          [
            10.732747,
            53.872244,
            54.990605
          ],
          [
            10.73305,
            53.872181,
            55.167844
          ],
          [
            10.733369,
            53.872125,
            55.019717
          ],
          [
            10.733699,
            53.87205,
            54.783853
          ],
          [
            10.734027,
            53.871977,
            54.550055
          ],
          [
            10.734348,
            53.871914,
            54.324422
          ],
          [
            10.734658,
            53.87185,
            54.105233
          ],
          [
            10.734988,
            53.871755,
            53.860291
          ],
          [
            10.735269,
            53.871673,
            53.651087
          ],
          [
            10.735576,
            53.871569,
            53.414965
          ],
          [
            10.73584,
            53.871457,
            53.197677
          ],
          [
            10.736155,
            53.871319,
            53.650981
          ],
          [
            10.736462,
            53.871243,
            54.115902
          ],
          [
            10.736728,
            53.871125,
            54.581323
          ],
          [
            10.736994,
            53.870998,
            55.059346
          ],
          [
            10.737266,
            53.870897,
            55.511468
          ],
          [
            10.737548,
            53.870811,
            55.990226
          ],
          [
            10.737824,
            53.870925,
            56.460733
          ],
          [
            10.73807,
            53.871091,
            56.984466
          ],
          [
            10.738315,
            53.871262,
            57.472888
          ],
          [
            10.738648,
            53.871374,
            57.758727
          ],
          [
            10.739006,
            53.871462,
            58.045659
          ],
          [
            10.739355,
            53.871536,
            58.320056
          ],
          [
            10.739677,
            53.871605,
            58.573535
          ],
          [
            10.739994,
            53.871645,
            58.813812
          ],
          [
            10.740306,
            53.871669,
            59.047504
          ],
          [
            10.740663,
            53.871707,
            59.315827
          ],
          [
            10.741002,
            53.871739,
            59.56999
          ],
          [
            10.741361,
            53.871776,
            59.92859
          ],
          [
            10.741715,
            53.871819,
            60.346022
          ],
          [
            10.742097,
            53.871875,
            60.802125
          ],
          [
            10.742461,
            53.871928,
            61.238685
          ],
          [
            10.742796,
            53.871963,
            61.631322
          ],
          [
            10.74318,
            53.871999,
            62.080355
          ],
          [
            10.743484,
            53.87203,
            62.436685
          ],
          [
            10.74385,
            53.872075,
            62.868744
          ],
          [
            10.74422,
            53.872113,
            63.080053
          ],
          [
            10.744529,
            53.872152,
            62.629255
          ],
          [
            10.744922,
            53.872205,
            62.050828
          ],
          [
            10.745295,
            53.872235,
            61.513671
          ],
          [
            10.74562,
            53.872186,
            61.035051
          ],
          [
            10.745981,
            53.872205,
            60.518004
          ],
          [
            10.746146,
            53.872027,
            60.023023
          ],
          [
            10.746346,
            53.871916,
            59.575816
          ],
          [
            10.746618,
            53.871772,
            59.053864
          ],
          [
            10.746973,
            53.871786,
            58.970184
          ],
          [
            10.747099,
            53.871851,
            59.140365
          ],
          [
            10.747012,
            53.871677,
            59.31165
          ],
          [
            10.746939,
            53.871811,
            59.488791
          ],
          [
            10.747376,
            53.871797,
            59.738403
          ],
          [
            10.747516,
            53.871631,
            59.917438
          ],
          [
            10.747531,
            53.871433,
            60.103977
          ],
          [
            10.747661,
            53.871554,
            60.400346
          ],
          [
            10.747311,
            53.87177,
            60.474308
          ],
          [
            10.747341,
            53.871788,
            60.416754
          ],
          [
            10.747546,
            53.871686,
            60.358807
          ],
          [
            10.747652,
            53.871768,
            60.27027
          ],
          [
            10.7474,
            53.871875,
            60.211653
          ],
          [
            10.747524,
            53.871685,
            60.122045
          ],
          [
            10.747953,
            53.871809,
            60.010525
          ],
          [
            10.747503,
            53.871784,
            59.967206
          ],
          [
            10.747192,
            53.871938,
            59.975084
          ],
          [
            10.747109,
            53.872122,
            59.980995
          ],
          [
            10.747047,
            53.872314,
            59.987061
          ],
          [
            10.7473,
            53.872447,
            59.993414
          ],
          [
            10.747644,
            53.872475,
            59.999752
          ],
          [
            10.74798,
            53.872526,
            60.006084
          ],
          [
            10.748388,
            53.872572,
            60.013666
          ],
          [
            10.748718,
            53.872586,
            59.847048
          ],
          [
            10.749047,
            53.872621,
            58.359005
          ],
          [
            10.749367,
            53.872722,
            56.749196
          ],
          [
            10.749704,
            53.872767,
            55.215223
          ],
          [
            10.750025,
            53.872831,
            53.703117
          ],
          [
            10.75033,
            53.872919,
            52.196352
          ],
          [
            10.750715,
            53.872972,
            50.433353
          ],
          [
            10.751084,
            53.873014,
            48.766549
          ],
          [
            10.751429,
            53.873057,
            47.202236
          ],
          [
            10.751799,
            53.873083,
            47.156548
          ],
          [
            10.752174,
            53.873113,
            48.344509
          ],
          [
            10.752521,
            53.873134,
            49.43857
          ],
          [
            10.752916,
            53.873183,
            50.704749
          ],
          [
            10.753287,
            53.873231,
            51.896045
          ],
          [
            10.753663,
            53.873233,
            53.076604
          ],
          [
            10.754089,
            53.873264,
            54.423708
          ],
          [
            10.754434,
            53.873308,
            55.530698
          ],
          [
            10.754824,
            53.873362,
            56.023219
          ],
          [
            10.755238,
            53.873422,
            55.962297
          ],
          [
            10.7556,
            53.873473,
            55.909105
          ],
          [
            10.755949,
            53.8735,
            55.858721
          ],
          [
            10.756264,
            53.873556,
            55.811646
          ],
          [
            10.756601,
            53.873606,
            55.761988
          ],
          [
            10.756959,
            53.873641,
            55.709648
          ],
          [
            10.757306,
            53.873703,
            55.657836
          ],
          [
            10.757647,
            53.873757,
            55.473055
          ],
          [
            10.757965,
            53.873816,
            54.940494
          ],
          [
            10.75833,
            53.873863,
            54.344088
          ],
          [
            10.75871,
            53.873932,
            53.708271
          ],
          [
            10.759081,
            53.874018,
            53.057765
          ],
          [
            10.759462,
            53.874072,
            52.431493
          ],
          [
            10.759822,
            53.874183,
            51.781555
          ],
          [
            10.760133,
            53.874266,
            51.232151
          ],
          [
            10.760456,
            53.874341,
            50.670974
          ],
          [
            10.760836,
            53.874446,
            49.937221
          ],
          [
            10.761179,
            53.874511,
            49.304111
          ],
          [
            10.761491,
            53.874577,
            48.724381
          ],
          [
            10.761811,
            53.874676,
            48.092827
          ],
          [
            10.762119,
            53.874762,
            47.497299
          ],
          [
            10.762486,
            53.874841,
            46.814265
          ],
          [
            10.762847,
            53.874908,
            46.153346
          ],
          [
            10.763167,
            53.874987,
            45.546303
          ],
          [
            10.763536,
            53.875053,
            46.123104
          ],
          [
            10.763918,
            53.875132,
            47.019485
          ],
          [
            10.764291,
            53.875174,
            47.86593
          ],
          [
            10.764641,
            53.875234,
            48.675158
          ],
          [
            10.765031,
            53.875323,
            49.601984
          ],
          [
            10.76539,
            53.875379,
            50.424255
          ],
          [
            10.765682,
            53.875436,
            51.105499
          ],
          [
            10.766081,
            53.875529,
            52.057014
          ],
          [
            10.766425,
            53.875629,
            52.703292
          ],
          [
            10.766733,
            53.875741,
            53.280621
          ],
          [
            10.767052,
            53.875848,
            53.866337
          ],
          [
            10.767375,
            53.875966,
            54.472326
          ],
          [
            10.767701,
            53.876093,
            55.095488
          ],
          [
            10.768011,
            53.876205,
            55.675396
          ],
          [
            10.768301,
            53.87632,
            56.232828
          ],
          [
            10.7686,
            53.876427,
            56.790788
          ],
          [
            10.768921,
            53.876553,
            57.020496
          ],
          [
            10.769204,
            53.87668,
            56.98183
          ],
          [
            10.769529,
            53.876768,
            56.942946
          ],
          [
            10.769831,
            53.876867,
            56.90535
          ],
          [
            10.770135,
            53.876983,
            56.865984
          ],
          [
            10.770409,
            53.877096,
            56.829615
          ],
          [
            10.770695,
            53.877182,
            56.794711
          ],
          [
            10.770983,
            53.877278,
            56.758723
          ],
          [
            10.771284,
            53.877356,
            56.722881
          ],
          [
            10.771615,
            53.877477,
            56.669119
          ],
          [
            10.771887,
            53.877568,
            56.62334
          ],
          [
            10.772196,
            53.877639,
            56.574452
          ],
          [
            10.772495,
            53.877754,
            56.522096
          ],
          [
            10.772827,
            53.877886,
            56.463473
          ],
          [
            10.773145,
            53.878016,
            56.406819
          ],
          [
            10.773389,
            53.878144,
            56.358975
          ],
          [
            10.773695,
            53.878284,
            56.302254
          ],
          [
            10.773994,
            53.878436,
            56.225329
          ],
          [
            10.774279,
            53.878588,
            56.121127
          ],
          [
            10.774531,
            53.878729,
            56.026522
          ],
          [
            10.774838,
            53.878849,
            55.926495
          ],
          [
            10.775115,
            53.878964,
            55.834515
          ],
          [
            10.77541,
            53.879118,
            55.727683
          ],
          [
            10.775674,
            53.879251,
            55.633483
          ],
          [
            10.775943,
            53.879378,
            55.540042
          ],
          [
            10.776215,
            53.879509,
            55.444797
          ],
          [
            10.776476,
            53.879629,
            55.796804
          ],
          [
            10.77675,
            53.879748,
            56.185588
          ],
          [
            10.777033,
            53.879876,
            56.593104
          ],
          [
            10.777341,
            53.880022,
            57.044537
          ],
          [
            10.777608,
            53.880147,
            57.434049
          ],
          [
            10.777881,
            53.880265,
            57.820692
          ],
          [
            10.778163,
            53.880403,
            58.239721
          ],
          [
            10.778466,
            53.880521,
            58.655671
          ],
          [
            10.778746,
            53.88064,
            58.979928
          ],
          [
            10.779027,
            53.880783,
            59.167159
          ],
          [
            10.779332,
            53.880933,
            59.367501
          ],
          [
            10.779629,
            53.881058,
            59.551719
          ],
          [
            10.779925,
            53.881187,
            59.737216
          ],
          [
            10.780224,
            53.881313,
            59.922443
          ],
          [
            10.780533,
            53.881472,
            60.129233
          ],
          [
            10.780829,
            53.881619,
            60.324256
          ],
          [
            10.7811,
            53.881752,
            60.395472
          ],
          [
            10.781383,
            53.881891,
            60.086833
          ],
          [
            10.781721,
            53.882031,
            59.741942
          ],
          [
            10.782066,
            53.882182,
            59.383305
          ],
          [
            10.782385,
            53.882338,
            59.03761
          ],
          [
            10.782673,
            53.882472,
            58.731573
          ],
          [
            10.783013,
            53.882622,
            58.377344
          ],
          [
            10.783302,
            53.882772,
            58.056165
          ],
          [
            10.78364,
            53.882899,
            58.055566
          ],
          [
            10.783939,
            53.883054,
            58.285921
          ],
          [
            10.784251,
            53.883202,
            58.517171
          ],
          [
            10.784557,
            53.883347,
            58.743876
          ],
          [
            10.784847,
            53.883468,
            58.94895
          ],
          [
            10.785111,
            53.883585,
            59.13962
          ],
          [
            10.785407,
            53.883725,
            59.358717
          ],
          [
            10.785691,
            53.883869,
            59.575019
          ],
          [
            10.785974,
            53.884008,
            59.761936
          ],
          [
            10.786279,
            53.884134,
            59.925944
          ],
          [
            10.786572,
            53.884269,
            60.089701
          ],
          [
            10.786884,
            53.8844,
            60.258374
          ],
          [
            10.78726,
            53.884545,
            60.456502
          ],
          [
            10.787609,
            53.884688,
            60.643763
          ],
          [
            10.787958,
            53.884819,
            60.825952
          ],
          [
            10.788264,
            53.884927,
            60.983062
          ],
          [
            10.788561,
            53.885022,
            61.011054
          ],
          [
            10.788894,
            53.885135,
            60.993942
          ],
          [
            10.789206,
            53.885251,
            60.977507
          ],
          [
            10.789539,
            53.885354,
            60.960724
          ],
          [
            10.789882,
            53.885468,
            60.94317
          ],
          [
            10.790183,
            53.885591,
            60.926858
          ],
          [
            10.790493,
            53.88574,
            60.909035
          ],
          [
            10.790773,
            53.885859,
            60.893623
          ],
          [
            10.791105,
            53.885952,
            60.928875
          ],
          [
            10.791383,
            53.886049,
            60.996868
          ],
          [
            10.791703,
            53.886166,
            61.075988
          ],
          [
            10.792005,
            53.886301,
            61.155641
          ],
          [
            10.792333,
            53.886408,
            61.234351
          ],
          [
            10.7927,
            53.886538,
            61.324266
          ],
          [
            10.793047,
            53.886654,
            61.408027
          ],
          [
            10.793394,
            53.886781,
            61.493787
          ],
          [
            10.793745,
            53.8869,
            61.467517
          ],
          [
            10.794073,
            53.887019,
            61.375083
          ],
          [
            10.794371,
            53.887149,
            61.286118
          ],
          [
            10.794728,
            53.887286,
            61.183896
          ],
          [
            10.795093,
            53.887414,
            61.081934
          ],
          [
            10.795409,
            53.887495,
            60.99898
          ],
          [
            10.795682,
            53.887598,
            60.920165
          ],
          [
            10.795957,
            53.887725,
            60.836165
          ],
          [
            10.796279,
            53.887876,
            60.238685
          ],
          [
            10.796708,
            53.887933,
            59.214567
          ],
          [
            10.797032,
            53.887995,
            58.421418
          ],
          [
            10.797393,
            53.888069,
            57.531685
          ],
          [
            10.797796,
            53.888122,
            56.570356
          ],
          [
            10.798254,
            53.888148,
            55.49704
          ],
          [
            10.798724,
            53.888129,
            54.396892
          ],
          [
            10.799096,
            53.888043,
            53.678461
          ],
          [
            10.79937,
            53.887911,
            53.636089
          ],
          [
            10.799583,
            53.887768,
            53.597385
          ],
          [
            10.79982,
            53.887608,
            53.554323
          ],
          [
            10.800089,
            53.887445,
            53.507904
          ],
          [
            10.800339,
            53.887308,
            53.467085
          ],
          [
            10.800554,
            53.887156,
            53.426953
          ],
          [
            10.800758,
            53.886979,
            53.383533
          ],
          [
            10.800982,
            53.886838,
            53.344345
          ],
          [
            10.801201,
            53.886693,
            53.448793
          ],
          [
            10.801407,
            53.886559,
            53.663256
          ],
          [
            10.801661,
            53.886373,
            53.946423
          ],
          [
            10.80191,
            53.886214,
            54.203105
          ],
          [
            10.80217,
            53.886061,
            54.460096
          ],
          [
            10.802407,
            53.885915,
            54.699774
          ],
          [
            10.802669,
            53.885767,
            54.953694
          ],
          [
            10.802902,
            53.885615,
            55.196704
          ],
          [
            10.803132,
            53.885463,
            55.438272
          ],
          [
            10.803405,
            53.885289,
            55.357876
          ],
          [
            10.80364,
            53.885124,
            55.258455
          ],
          [
            10.803844,
            53.884978,
            55.1713
          ],
          [
            10.80408,
            53.884836,
            55.079712
          ],
          [
            10.804303,
            53.884697,
            54.991568
          ],
          [
            10.804576,
            53.884529,
            54.884364
          ],
          [
            10.804831,
            53.88437,
            54.783369
          ],
          [
            10.805056,
            53.884226,
            54.692922
          ],
          [
            10.805079,
            53.884252,
            54.679772
          ],
          [
            10.805041,
            53.884397,
            54.834198
          ],
          [
            10.805126,
            53.884313,
            55.008003
          ],
          [
            10.805232,
            53.88418,
            55.174944
          ],
          [
            10.805501,
            53.884073,
            55.343367
          ],
          [
            10.805827,
            53.884023,
            55.51293
          ],
          [
            10.806171,
            53.883983,
            55.690079
          ],
          [
            10.806505,
            53.883987,
            55.859135
          ],
          [
            10.806822,
            53.883968,
            56.019396
          ],
          [
            10.807188,
            53.883975,
            56.244859
          ],
          [
            10.807559,
            53.883945,
            56.629973
          ],
          [
            10.807871,
            53.883951,
            56.950793
          ],
          [
            10.808191,
            53.883942,
            57.279441
          ],
          [
            10.808498,
            53.88395,
            57.595041
          ],
          [
            10.808848,
            53.883953,
            57.953858
          ],
          [
            10.809292,
            53.883973,
            58.410438
          ],
          [
            10.809659,
            53.883946,
            58.789575
          ],
          [
            10.810005,
            53.883947,
            59.14437
          ],
          [
            10.81038,
            53.883949,
            59.143659
          ],
          [
            10.810687,
            53.883955,
            58.949203
          ],
          [
            10.811028,
            53.883952,
            58.733355
          ],
          [
            10.811377,
            53.883959,
            58.512233
          ],
          [
            10.811699,
            53.883957,
            58.308247
          ],
          [
            10.812034,
            53.883932,
            58.094441
          ],
          [
            10.81237,
            53.883876,
            57.873137
          ],
          [
            10.812677,
            53.883777,
            57.65146
          ],
          [
            10.812857,
            53.883611,
            57.427933
          ],
          [
            10.81312,
            53.883523,
            57.922435
          ],
          [
            10.813469,
            53.883462,
            58.794358
          ],
          [
            10.813705,
            53.883312,
            59.607059
          ],
          [
            10.813903,
            53.883164,
            60.35552
          ],
          [
            10.814124,
            53.883025,
            61.112018
          ],
          [
            10.814344,
            53.882869,
            61.917679
          ],
          [
            10.814539,
            53.882695,
            62.747773
          ],
          [
            10.814753,
            53.882533,
            63.565633
          ],
          [
            10.81497,
            53.882388,
            64.336248
          ],
          [
            10.81519,
            53.882238,
            64.848498
          ],
          [
            10.815394,
            53.882082,
            65.28599
          ],
          [
            10.81559,
            53.881923,
            65.723223
          ],
          [
            10.81575,
            53.881732,
            66.196424
          ],
          [
            10.81608,
            53.881766,
            66.658104
          ],
          [
            10.816336,
            53.881894,
            67.097627
          ],
          [
            10.816631,
            53.882025,
            67.58197
          ],
          [
            10.816939,
            53.88217,
            68.098049
          ],
          [
            10.817283,
            53.882322,
            68.335942
          ],
          [
            10.817607,
            53.882481,
            67.816201
          ],
          [
            10.817949,
            53.882629,
            67.292959
          ],
          [
            10.818308,
            53.88278,
            66.748617
          ],
          [
            10.818565,
            53.88289,
            66.357116
          ],
          [
            10.818854,
            53.883024,
            65.903537
          ],
          [
            10.819166,
            53.883149,
            65.435671
          ],
          [
            10.819496,
            53.883272,
            64.954297
          ],
          [
            10.819875,
            53.883386,
            64.385364
          ],
          [
            10.820238,
            53.883495,
            63.809936
          ],
          [
            10.820577,
            53.883583,
            63.285257
          ],
          [
            10.820955,
            53.883662,
            62.717365
          ],
          [
            10.8213,
            53.883705,
            62.219138
          ],
          [
            10.821635,
            53.883743,
            61.737239
          ],
          [
            10.821988,
            53.88376,
            61.234469
          ],
          [
            10.822368,
            53.883807,
            60.68609
          ],
          [
            10.822724,
            53.883828,
            60.422329
          ],
          [
            10.823077,
            53.883839,
            60.421503
          ],
          [
            10.823435,
            53.883844,
            60.420667
          ],
          [
            10.823752,
            53.883839,
            60.419925
          ],
          [
            10.824107,
            53.883862,
            60.419091
          ],
          [
            10.824458,
            53.883877,
            60.41827
          ],
          [
            10.824817,
            53.883872,
            60.417431
          ],
          [
            10.825167,
            53.883808,
            60.416576
          ],
          [
            10.825543,
            53.883805,
            60.415698
          ],
          [
            10.825957,
            53.883807,
            60.568176
          ],
          [
            10.826297,
            53.883801,
            60.706762
          ],
          [
            10.826613,
            53.883803,
            60.835532
          ],
          [
            10.826937,
            53.883791,
            60.967724
          ],
          [
            10.827319,
            53.883795,
            61.123199
          ],
          [
            10.827742,
            53.883788,
            61.295381
          ],
          [
            10.828107,
            53.883785,
            61.443909
          ],
          [
            10.828482,
            53.883795,
            61.597109
          ],
          [
            10.828838,
            53.883783,
            62.164181
          ],
          [
            10.829157,
            53.883793,
            62.930657
          ],
          [
            10.829508,
            53.883788,
            63.771866
          ],
          [
            10.829903,
            53.883778,
            64.717768
          ],
          [
            10.83027,
            53.883794,
            65.598482
          ],
          [
            10.830587,
            53.883829,
            66.370189
          ],
          [
            10.83094,
            53.883854,
            67.224378
          ],
          [
            10.831317,
            53.883854,
            68.12647
          ],
          [
            10.831646,
            53.883875,
            68.919528
          ],
          [
            10.832007,
            53.883885,
            70.108293
          ],
          [
            10.832396,
            53.883859,
            71.400213
          ],
          [
            10.832736,
            53.883874,
            72.526061
          ],
          [
            10.833088,
            53.883882,
            73.68984
          ],
          [
            10.833446,
            53.883902,
            74.881524
          ],
          [
            10.833809,
            53.883869,
            76.100469
          ],
          [
            10.834182,
            53.883849,
            77.336297
          ],
          [
            10.834501,
            53.883817,
            78.404
          ],
          [
            10.834847,
            53.883824,
            78.810363
          ],
          [
            10.835189,
            53.883834,
            78.343847
          ],
          [
            10.835557,
            53.883845,
            77.841836
          ],
          [
            10.835923,
            53.88383,
            77.341637
          ],
          [
            10.836278,
            53.883833,
            76.853349
          ],
          [
            10.836609,
            53.883823,
            76.401432
          ],
          [
            10.83699,
            53.883845,
            75.876998
          ],
          [
            10.837348,
            53.883856,
            75.382055
          ],
          [
            10.837761,
            53.883808,
            74.743427
          ],
          [
            10.838145,
            53.883794,
            73.656757
          ],
          [
            10.838521,
            53.883773,
            72.532374
          ],
          [
            10.838805,
            53.883669,
            71.508331
          ],
          [
            10.839204,
            53.883686,
            70.378087
          ],
          [
            10.839558,
            53.883661,
            69.365231
          ],
          [
            10.839885,
            53.883631,
            68.424782
          ],
          [
            10.840234,
            53.883642,
            67.436965
          ],
          [
            10.840582,
            53.883662,
            66.447036
          ],
          [
            10.840897,
            53.883702,
            66.245115
          ],
          [
            10.841311,
            53.883766,
            66.236587
          ],
          [
            10.841734,
            53.883782,
            66.228131
          ],
          [
            10.842182,
            53.883772,
            66.219197
          ],
          [
            10.842597,
            53.883786,
            66.210892
          ],
          [
            10.842974,
            53.883801,
            66.203363
          ],
          [
            10.843336,
            53.883809,
            66.196142
          ],
          [
            10.84375,
            53.88382,
            66.147296
          ],
          [
            10.844165,
            53.883855,
            65.907498
          ],
          [
            10.844586,
            53.883856,
            65.666682
          ],
          [
            10.84495,
            53.883873,
            65.458026
          ],
          [
            10.845326,
            53.883871,
            65.243067
          ],
          [
            10.845726,
            53.883861,
            65.013738
          ],
          [
            10.84614,
            53.883843,
            64.776094
          ],
          [
            10.846456,
            53.883854,
            64.595176
          ],
          [
            10.846842,
            53.883858,
            64.386348
          ],
          [
            10.847218,
            53.883847,
            64.205805
          ],
          [
            10.84764,
            53.883815,
            64.002668
          ],
          [
            10.847977,
            53.883812,
            63.841315
          ],
          [
            10.848386,
            53.883848,
            63.644205
          ],
          [
            10.848803,
            53.883855,
            63.444837
          ],
          [
            10.849243,
            53.883814,
            63.232061
          ],
          [
            10.849547,
            53.883759,
            63.080303
          ],
          [
            10.849857,
            53.8837,
            63.046734
          ],
          [
            10.850207,
            53.883621,
            63.194611
          ],
          [
            10.850592,
            53.883553,
            63.353375
          ],
          [
            10.850949,
            53.883478,
            63.502892
          ],
          [
            10.851309,
            53.883418,
            63.650485
          ],
          [
            10.851672,
            53.883334,
            63.80439
          ],
          [
            10.851995,
            53.883294,
            63.934925
          ],
          [
            10.8523,
            53.883226,
            64.064124
          ],
          [
            10.852604,
            53.883145,
            64.19949
          ],
          [
            10.852951,
            53.883078,
            64.827922
          ],
          [
            10.853307,
            53.882999,
            65.483231
          ],
          [
            10.853611,
            53.882929,
            66.045209
          ],
          [
            10.853946,
            53.882836,
            66.683635
          ],
          [
            10.85429,
            53.882777,
            67.300363
          ],
          [
            10.854606,
            53.882694,
            67.895837
          ],
          [
            10.854947,
            53.882627,
            68.515494
          ],
          [
            10.855261,
            53.882557,
            69.095238
          ],
          [
            10.855581,
            53.882491,
            69.642442
          ],
          [
            10.85589,
            53.882408,
            70.136365
          ],
          [
            10.856215,
            53.882347,
            70.632167
          ],
          [
            10.856558,
            53.882264,
            71.173802
          ],
          [
            10.856897,
            53.882185,
            71.703275
          ],
          [
            10.857224,
            53.882123,
            72.203406
          ],
          [
            10.857544,
            53.882078,
            72.681158
          ],
          [
            10.857875,
            53.881999,
            73.200123
          ],
          [
            10.858204,
            53.88196,
            73.687657
          ],
          [
            10.858515,
            53.881987,
            73.955096
          ],
          [
            10.858836,
            53.88206,
            74.098625
          ],
          [
            10.85918,
            53.882147,
            74.25462
          ],
          [
            10.859542,
            53.882203,
            74.41195
          ],
          [
            10.859829,
            53.882306,
            74.553123
          ],
          [
            10.860184,
            53.882391,
            74.712844
          ],
          [
            10.860514,
            53.882476,
            74.862779
          ],
          [
            10.860808,
            53.882574,
            75.003397
          ],
          [
            10.861111,
            53.88264,
            75.13791
          ],
          [
            10.86144,
            53.882717,
            74.913946
          ],
          [
            10.861793,
            53.882801,
            74.642991
          ],
          [
            10.862144,
            53.882887,
            74.372927
          ],
          [
            10.862498,
            53.883003,
            74.084895
          ],
          [
            10.862876,
            53.883084,
            73.798685
          ],
          [
            10.863213,
            53.88318,
            73.530882
          ],
          [
            10.863616,
            53.883255,
            73.230377
          ],
          [
            10.863938,
            53.883335,
            72.981215
          ],
          [
            10.86429,
            53.883439,
            72.813404
          ],
          [
            10.864663,
            53.883556,
            72.633408
          ],
          [
            10.865055,
            53.883655,
            72.452289
          ],
          [
            10.865447,
            53.883748,
            72.272877
          ],
          [
            10.865773,
            53.88383,
            72.122178
          ],
          [
            10.866143,
            53.883949,
            71.943216
          ],
          [
            10.86642,
            53.884091,
            71.784904
          ],
          [
            10.866747,
            53.884218,
            71.602185
          ],
          [
            10.867117,
            53.884306,
            71.397884
          ],
          [
            10.867504,
            53.884403,
            71.182543
          ],
          [
            10.867839,
            53.884496,
            70.992931
          ],
          [
            10.868137,
            53.884623,
            70.802981
          ],
          [
            10.86804,
            53.88482,
            70.624524
          ],
          [
            10.868194,
            53.884861,
            70.466014
          ],
          [
            10.868242,
            53.884675,
            70.301318
          ],
          [
            10.868552,
            53.884546,
            70.149231
          ],
          [
            10.868836,
            53.884625,
            70.332689
          ],
          [
            10.869194,
            53.884716,
            70.560304
          ],
          [
            10.869496,
            53.884792,
            70.752092
          ],
          [
            10.869825,
            53.884902,
            70.973534
          ],
          [
            10.870168,
            53.884981,
            71.189708
          ],
          [
            10.870499,
            53.885042,
            71.392889
          ],
          [
            10.870845,
            53.885161,
            71.627457
          ],
          [
            10.871191,
            53.88527,
            71.858535
          ],
          [
            10.871471,
            53.885374,
            71.840929
          ],
          [
            10.871805,
            53.885455,
            71.752381
          ],
          [
            10.87217,
            53.885534,
            71.65699
          ],
          [
            10.872573,
            53.885637,
            71.549407
          ],
          [
            10.872953,
            53.885716,
            71.450696
          ],
          [
            10.873316,
            53.885815,
            71.352663
          ],
          [
            10.873651,
            53.885895,
            71.264091
          ],
          [
            10.87403,
            53.885984,
            71.164133
          ],
          [
            10.874328,
            53.886067,
            71.108821
          ],
          [
            10.874643,
            53.886147,
            71.054375
          ],
          [
            10.875033,
            53.886222,
            70.989215
          ],
          [
            10.875343,
            53.886315,
            70.934081
          ],
          [
            10.875687,
            53.886412,
            70.873663
          ],
          [
            10.875997,
            53.886489,
            70.820367
          ],
          [
            10.876298,
            53.886574,
            70.767436
          ],
          [
            10.876584,
            53.886654,
            70.717281
          ],
          [
            10.876888,
            53.886738,
            70.753823
          ],
          [
            10.877204,
            53.886808,
            71.260431
          ],
          [
            10.877539,
            53.88689,
            71.80489
          ],
          [
            10.877848,
            53.886992,
            72.33616
          ],
          [
            10.878161,
            53.887063,
            72.839333
          ],
          [
            10.878472,
            53.887132,
            73.339563
          ],
          [
            10.878765,
            53.887234,
            73.858731
          ],
          [
            10.87907,
            53.88731,
            74.358048
          ],
          [
            10.879469,
            53.887388,
            74.988872
          ],
          [
            10.879794,
            53.887483,
            75.014805
          ],
          [
            10.880137,
            53.887585,
            74.535033
          ],
          [
            10.88051,
            53.887698,
            74.012113
          ],
          [
            10.880852,
            53.887802,
            73.531797
          ],
          [
            10.881218,
            53.887891,
            73.038027
          ],
          [
            10.88159,
            53.887971,
            72.543936
          ],
          [
            10.881995,
            53.888078,
            71.990547
          ],
          [
            10.882379,
            53.888161,
            71.480577
          ],
          [
            10.882749,
            53.888247,
            71.279296
          ],
          [
            10.883112,
            53.888339,
            71.102001
          ],
          [
            10.883475,
            53.888447,
            70.91954
          ],
          [
            10.883875,
            53.888546,
            70.72488
          ],
          [
            10.884253,
            53.888648,
            70.538382
          ],
          [
            10.884622,
            53.888759,
            70.352513
          ],
          [
            10.88499,
            53.888848,
            70.173968
          ],
          [
            10.885354,
            53.888929,
            70.043915
          ],
          [
            10.885667,
            53.889015,
            69.978895
          ],
          [
            10.885947,
            53.889102,
            69.919293
          ],
          [
            10.886322,
            53.889178,
            69.844622
          ],
          [
            10.886608,
            53.889254,
            69.785423
          ],
          [
            10.886923,
            53.889361,
            69.716957
          ],
          [
            10.887231,
            53.889517,
            69.640488
          ],
          [
            10.887519,
            53.889634,
            69.574547
          ],
          [
            10.887766,
            53.889756,
            69.513704
          ],
          [
            10.887992,
            53.889904,
            69.084351
          ],
          [
            10.888173,
            53.8901,
            68.499164
          ],
          [
            10.888473,
            53.890246,
            67.906472
          ],
          [
            10.888728,
            53.890361,
            67.417186
          ],
          [
            10.889008,
            53.890482,
            66.888225
          ],
          [
            10.889274,
            53.890592,
            66.393172
          ],
          [
            10.889533,
            53.890697,
            65.914267
          ],
          [
            10.889845,
            53.890823,
            65.337797
          ],
          [
            10.890114,
            53.890944,
            64.835227
          ],
          [
            10.890419,
            53.891053,
            64.556229
          ],
          [
            10.8907,
            53.891169,
            64.287824
          ],
          [
            10.89099,
            53.891259,
            64.031443
          ],
          [
            10.891265,
            53.891361,
            63.777064
          ],
          [
            10.891566,
            53.891421,
            63.528496
          ],
          [
            10.891928,
            53.891509,
            63.222211
          ],
          [
            10.89222,
            53.891602,
            62.962247
          ],
          [
            10.892511,
            53.891696,
            62.700529
          ],
          [
            10.892815,
            53.891781,
            62.480734
          ],
          [
            10.893127,
            53.891838,
            62.618789
          ],
          [
            10.89347,
            53.891935,
            62.779462
          ],
          [
            10.89388,
            53.892017,
            62.9627
          ],
          [
            10.894242,
            53.892097,
            63.126129
          ],
          [
            10.894588,
            53.892172,
            63.28226
          ],
          [
            10.894939,
            53.892227,
            63.435732
          ],
          [
            10.895277,
            53.892292,
            63.586092
          ],
          [
            10.895623,
            53.892359,
            63.739963
          ],
          [
            10.895921,
            53.892417,
            63.693128
          ],
          [
            10.89627,
            53.892474,
            63.613674
          ],
          [
            10.896602,
            53.892583,
            63.529926
          ],
          [
            10.896961,
            53.892652,
            63.444289
          ],
          [
            10.897371,
            53.892654,
            63.354145
          ],
          [
            10.897889,
            53.892644,
            63.240095
          ],
          [
            10.898383,
            53.892676,
            63.131054
          ],
          [
            10.898874,
            53.892712,
            62.868191
          ],
          [
            10.899363,
            53.892747,
            62.492801
          ],
          [
            10.899882,
            53.892797,
            62.09209
          ],
          [
            10.900428,
            53.892827,
            61.674183
          ],
          [
            10.900903,
            53.892862,
            61.309385
          ],
          [
            10.901295,
            53.892902,
            61.005217
          ],
          [
            10.901692,
            53.892928,
            60.636769
          ],
          [
            10.902044,
            53.892948,
            60.071409
          ],
          [
            10.902397,
            53.89298,
            59.500608
          ],
          [
            10.902776,
            53.893004,
            58.889104
          ],
          [
            10.902919,
            53.893201,
            58.267557
          ],
          [
            10.902817,
            53.89343,
            57.624839
          ],
          [
            10.902732,
            53.89365,
            57.012832
          ],
          [
            10.903026,
            53.893693,
            56.488625
          ],
          [
            10.903383,
            53.893627,
            55.890612
          ],
          [
            10.903728,
            53.893566,
            55.358018
          ],
          [
            10.903988,
            53.893425,
            54.795628
          ],
          [
            10.904052,
            53.893238,
            54.319308
          ],
          [
            10.904293,
            53.893088,
            53.764929
          ],
          [
            10.904675,
            53.89311,
            53.199598
          ],
          [
            10.905045,
            53.893141,
            52.649838
          ],
          [
            10.905419,
            53.893188,
            52.085194
          ],
          [
            10.905818,
            53.893216,
            51.492551
          ],
          [
            10.906205,
            53.893259,
            52.192945
          ],
          [
            10.90656,
            53.893272,
            53.066826
          ],
          [
            10.906924,
            53.8933,
            53.970195
          ],
          [
            10.907246,
            53.893324,
            54.776587
          ],
          [
            10.907569,
            53.893359,
            55.583104
          ],
          [
            10.9079,
            53.893405,
            56.418733
          ],
          [
            10.908264,
            53.89345,
            57.332206
          ],
          [
            10.908633,
            53.893501,
            58.263982
          ],
          [
            10.90896,
            53.893538,
            58.748739
          ],
          [
            10.909343,
            53.893566,
            58.087328
          ],
          [
            10.909676,
            53.893597,
            57.507901
          ],
          [
            10.910098,
            53.893635,
            56.773616
          ],
          [
            10.910525,
            53.893654,
            56.038313
          ],
          [
            10.911018,
            53.893706,
            55.180175
          ],
          [
            10.911532,
            53.893749,
            54.290692
          ],
          [
            10.911995,
            53.893767,
            53.758407
          ],
          [
            10.912382,
            53.893797,
            54.182528
          ],
          [
            10.912724,
            53.89385,
            54.566965
          ],
          [
            10.91307,
            53.893882,
            54.947281
          ],
          [
            10.913414,
            53.893891,
            55.325105
          ],
          [
            10.913793,
            53.893908,
            55.737666
          ],
          [
            10.914137,
            53.89394,
            56.116907
          ],
          [
            10.914603,
            53.893926,
            56.625935
          ],
          [
            10.914938,
            53.893972,
            56.946311
          ],
          [
            10.915329,
            53.893993,
            56.620477
          ],
          [
            10.915657,
            53.894024,
            56.345717
          ],
          [
            10.916038,
            53.894078,
            56.021482
          ],
          [
            10.916445,
            53.894133,
            55.675982
          ],
          [
            10.916774,
            53.894174,
            55.397029
          ],
          [
            10.917089,
            53.894239,
            55.120993
          ],
          [
            10.917439,
            53.894304,
            54.817456
          ],
          [
            10.91778,
            53.894344,
            54.528007
          ],
          [
            10.918084,
            53.894376,
            54.138549
          ],
          [
            10.918394,
            53.894435,
            53.66202
          ],
          [
            10.918774,
            53.89449,
            53.089968
          ],
          [
            10.919133,
            53.894535,
            52.553545
          ],
          [
            10.919468,
            53.894574,
            52.054234
          ],
          [
            10.919824,
            53.894673,
            51.473568
          ],
          [
            10.920344,
            53.894677,
            50.704745
          ],
          [
            10.920694,
            53.894736,
            50.172076
          ],
          [
            10.921073,
            53.894771,
            49.868032
          ],
          [
            10.921431,
            53.894813,
            49.701086
          ],
          [
            10.921788,
            53.894858,
            49.534932
          ],
          [
            10.922127,
            53.894889,
            49.378687
          ],
          [
            10.92248,
            53.89494,
            49.213272
          ],
          [
            10.922853,
            53.894983,
            49.040252
          ],
          [
            10.923238,
            53.895035,
            48.860203
          ],
          [
            10.923608,
            53.895085,
            48.687433
          ],
          [
            10.924012,
            53.895126,
            48.37351
          ],
          [
            10.924412,
            53.895174,
            47.936246
          ],
          [
            10.92482,
            53.895219,
            47.491811
          ],
          [
            10.925264,
            53.895263,
            47.00963
          ],
          [
            10.925754,
            53.895312,
            46.476944
          ],
          [
            10.926264,
            53.895354,
            45.925369
          ],
          [
            10.926714,
            53.895404,
            45.435079
          ],
          [
            10.92719,
            53.895458,
            45.357047
          ],
          [
            10.927634,
            53.895503,
            45.392499
          ],
          [
            10.92804,
            53.895558,
            45.42534
          ],
          [
            10.92843,
            53.895629,
            45.457475
          ],
          [
            10.928753,
            53.895719,
            45.485825
          ],
          [
            10.929066,
            53.895845,
            45.515685
          ],
          [
            10.929435,
            53.895992,
            45.550736
          ],
          [
            10.929806,
            53.896138,
            45.669428
          ],
          [
            10.930139,
            53.896283,
            45.846916
          ],
          [
            10.930475,
            53.896415,
            46.020014
          ],
          [
            10.930787,
            53.896546,
            46.184422
          ],
          [
            10.931075,
            53.896665,
            46.335216
          ],
          [
            10.931345,
            53.896777,
            46.476789
          ],
          [
            10.931649,
            53.896911,
            46.639524
          ],
          [
            10.93198,
            53.897052,
            46.814622
          ],
          [
            10.932298,
            53.8972,
            47.273618
          ],
          [
            10.932617,
            53.897356,
            47.900431
          ],
          [
            10.932894,
            53.897487,
            48.438022
          ],
          [
            10.933161,
            53.897603,
            48.939635
          ],
          [
            10.933418,
            53.897741,
            49.465375
          ],
          [
            10.933676,
            53.897862,
            49.964105
          ],
          [
            10.93395,
            53.897985,
            50.484927
          ],
          [
            10.934253,
            53.898114,
            51.050319
          ],
          [
            10.934551,
            53.89824,
            51.387846
          ],
          [
            10.934902,
            53.898399,
            50.782648
          ],
          [
            10.935178,
            53.898499,
            50.339596
          ],
          [
            10.935485,
            53.898643,
            49.803232
          ],
          [
            10.935753,
            53.898742,
            49.370792
          ],
          [
            10.936076,
            53.898852,
            48.860699
          ],
          [
            10.936436,
            53.898976,
            48.290592
          ],
          [
            10.936871,
            53.899075,
            47.647329
          ],
          [
            10.93735,
            53.899184,
            47.09017
          ],
          [
            10.937834,
            53.899285,
            46.66109
          ],
          [
            10.938269,
            53.89939,
            46.266308
          ],
          [
            10.938702,
            53.899463,
            45.889936
          ],
          [
            10.93916,
            53.899482,
            45.505792
          ],
          [
            10.939647,
            53.899513,
            45.095986
          ],
          [
            10.940132,
            53.899499,
            44.703091
          ],
          [
            10.940588,
            53.899509,
            44.387997
          ],
          [
            10.940996,
            53.899562,
            44.099234
          ],
          [
            10.941357,
            53.899643,
            43.832486
          ],
          [
            10.941685,
            53.899766,
            43.563156
          ],
          [
            10.941975,
            53.899895,
            43.312238
          ],
          [
            10.942251,
            53.900049,
            43.049489
          ],
          [
            10.942472,
            53.900204,
            42.812122
          ],
          [
            10.942712,
            53.900357,
            42.779849
          ],
          [
            10.942948,
            53.900545,
            43.141085
          ],
          [
            10.943143,
            53.900717,
            43.459908
          ],
          [
            10.943401,
            53.90086,
            43.781561
          ],
          [
            10.943691,
            53.900967,
            44.095129
          ],
          [
            10.944017,
            53.901072,
            44.432986
          ],
          [
            10.944295,
            53.901208,
            44.761105
          ],
          [
            10.944609,
            53.901338,
            45.109604
          ],
          [
            10.944892,
            53.901464,
            45.431562
          ],
          [
            10.945172,
            53.9016,
            45.411608
          ],
          [
            10.945425,
            53.901707,
            45.394486
          ],
          [
            10.945742,
            53.901834,
            45.373408
          ],
          [
            10.946019,
            53.901943,
            45.355093
          ],
          [
            10.946321,
            53.902074,
            45.33447
          ],
          [
            10.946622,
            53.902205,
            45.313892
          ],
          [
            10.946911,
            53.902323,
            45.294562
          ],
          [
            10.94727,
            53.902464,
            45.270843
          ],
          [
            10.947574,
            53.902603,
            45.150959
          ],
          [
            10.947948,
            53.902727,
            44.961661
          ],
          [
            10.948272,
            53.902849,
            44.791756
          ],
          [
            10.948578,
            53.90296,
            44.633189
          ],
          [
            10.94887,
            53.903089,
            44.471761
          ],
          [
            10.949146,
            53.903212,
            44.319092
          ],
          [
            10.949451,
            53.903347,
            44.150799
          ],
          [
            10.949713,
            53.903479,
            43.998723
          ],
          [
            10.949921,
            53.903626,
            44.036069
          ],
          [
            10.950175,
            53.903795,
            44.361934
          ],
          [
            10.950379,
            53.903941,
            44.634942
          ],
          [
            10.950651,
            53.90413,
            44.992632
          ],
          [
            10.950905,
            53.904319,
            45.341232
          ],
          [
            10.951158,
            53.904496,
            45.675392
          ],
          [
            10.951409,
            53.904627,
            45.960753
          ],
          [
            10.951659,
            53.904777,
            46.264206
          ],
          [
            10.951895,
            53.904916,
            46.544859
          ],
          [
            10.952154,
            53.905059,
            46.815496
          ],
          [
            10.952416,
            53.905196,
            47.08261
          ],
          [
            10.952711,
            53.905319,
            47.35802
          ],
          [
            10.953036,
            53.90543,
            47.644938
          ],
          [
            10.953421,
            53.905551,
            47.977439
          ],
          [
            10.953771,
            53.905654,
            48.275771
          ],
          [
            10.954054,
            53.905744,
            48.520828
          ],
          [
            10.954385,
            53.905849,
            48.807373
          ],
          [
            10.954722,
            53.905951,
            49.136967
          ],
          [
            10.955077,
            53.906026,
            49.470638
          ],
          [
            10.955451,
            53.906043,
            49.801965
          ],
          [
            10.955808,
            53.906047,
            50.117439
          ],
          [
            10.956147,
            53.906041,
            50.417108
          ],
          [
            10.956464,
            53.90603,
            50.698283
          ],
          [
            10.956825,
            53.906009,
            51.018665
          ],
          [
            10.957228,
            53.905982,
            51.376918
          ],
          [
            10.957634,
            53.905947,
            51.130142
          ],
          [
            10.958021,
            53.905919,
            50.4419
          ],
          [
            10.958458,
            53.905899,
            49.668759
          ],
          [
            10.958786,
            53.905897,
            49.09018
          ],
          [
            10.959109,
            53.905865,
            48.512268
          ],
          [
            10.959433,
            53.905839,
            47.933676
          ],
          [
            10.959794,
            53.905824,
            47.295257
          ],
          [
            10.960207,
            53.905804,
            46.564311
          ],
          [
            10.960659,
            53.905782,
            45.967443
          ],
          [
            10.96107,
            53.90574,
            45.617749
          ],
          [
            10.961469,
            53.905716,
            45.281801
          ],
          [
            10.961884,
            53.905707,
            44.93407
          ],
          [
            10.962276,
            53.905706,
            44.605821
          ],
          [
            10.962656,
            53.905713,
            44.286694
          ],
          [
            10.963027,
            53.90575,
            43.971748
          ],
          [
            10.963379,
            53.905772,
            43.675149
          ],
          [
            10.963717,
            53.905811,
            43.742184
          ],
          [
            10.964071,
            53.905872,
            43.959354
          ],
          [
            10.964419,
            53.905936,
            44.173748
          ],
          [
            10.964771,
            53.905998,
            44.389801
          ],
          [
            10.9651,
            53.906073,
            44.597257
          ],
          [
            10.96553,
            53.906146,
            44.860918
          ],
          [
            10.965897,
            53.906209,
            45.085739
          ],
          [
            10.96628,
            53.90629,
            45.32518
          ],
          [
            10.966644,
            53.906357,
            45.062675
          ],
          [
            10.966971,
            53.906439,
            44.630163
          ],
          [
            10.967314,
            53.906547,
            44.159431
          ],
          [
            10.967623,
            53.906651,
            43.727037
          ],
          [
            10.968049,
            53.906776,
            43.15111
          ],
          [
            10.968358,
            53.906898,
            42.700766
          ],
          [
            10.968722,
            53.907016,
            42.197992
          ],
          [
            10.969046,
            53.907115,
            41.75576
          ],
          [
            10.969317,
            53.907065,
            42.020299
          ],
          [
            10.969606,
            53.906967,
            42.345542
          ],
          [
            10.969902,
            53.907029,
            42.628595
          ],
          [
            10.970205,
            53.907103,
            42.922473
          ],
          [
            10.970525,
            53.907164,
            43.224555
          ],
          [
            10.970843,
            53.907196,
            43.513892
          ],
          [
            10.971182,
            53.907249,
            43.828191
          ],
          [
            10.971505,
            53.907252,
            44.117305
          ],
          [
            10.971802,
            53.907333,
            44.412649
          ],
          [
            10.972127,
            53.907363,
            45.261824
          ],
          [
            10.972464,
            53.907394,
            46.195363
          ],
          [
            10.972793,
            53.907459,
            47.124678
          ],
          [
            10.973132,
            53.907489,
            48.076518
          ],
          [
            10.973477,
            53.907507,
            49.00462
          ],
          [
            10.973814,
            53.907555,
            49.942764
          ],
          [
            10.974172,
            53.907577,
            50.906989
          ],
          [
            10.974501,
            53.907612,
            51.802267
          ],
          [
            10.974815,
            53.90767,
            52.63121
          ],
          [
            10.975091,
            53.907885,
            52.997887
          ],
          [
            10.975387,
            53.907961,
            53.253757
          ],
          [
            10.975704,
            53.908009,
            53.513833
          ],
          [
            10.97604,
            53.908049,
            53.785588
          ],
          [
            10.976394,
            53.90827,
            54.195115
          ],
          [
            10.976751,
            53.908351,
            54.499917
          ],
          [
            10.977071,
            53.908466,
            54.796944
          ],
          [
            10.977352,
            53.908557,
            54.948809
          ],
          [
            10.977713,
            53.908534,
            54.134066
          ],
          [
            10.978037,
            53.908483,
            53.384913
          ],
          [
            10.978371,
            53.908439,
            52.616789
          ],
          [
            10.978705,
            53.908377,
            51.83454
          ],
          [
            10.979052,
            53.908317,
            51.02688
          ],
          [
            10.979389,
            53.908328,
            50.273089
          ],
          [
            10.979738,
            53.908327,
            49.493201
          ],
          [
            10.980125,
            53.90833,
            48.621572
          ],
          [
            10.980469,
            53.908382,
            48.561804
          ],
          [
            10.980786,
            53.908415,
            49.243382
          ],
          [
            10.981156,
            53.908454,
            50.037614
          ],
          [
            10.981532,
            53.908456,
            50.831458
          ],
          [
            10.981869,
            53.908466,
            51.547711
          ],
          [
            10.982207,
            53.908509,
            52.27937
          ],
          [
            10.982539,
            53.908529,
            52.986358
          ],
          [
            10.982876,
            53.908553,
            53.702752
          ],
          [
            10.983199,
            53.90859,
            54.397922
          ],
          [
            10.98353,
            53.908607,
            54.872374
          ],
          [
            10.983856,
            53.908604,
            55.212026
          ],
          [
            10.984206,
            53.908634,
            55.584848
          ],
          [
            10.984527,
            53.908617,
            55.920791
          ],
          [
            10.984859,
            53.908665,
            56.280766
          ],
          [
            10.985175,
            53.908679,
            56.610884
          ],
          [
            10.985508,
            53.908681,
            56.958438
          ],
          [
            10.985835,
            53.908678,
            57.299694
          ],
          [
            10.986208,
            53.908682,
            57.689144
          ],
          [
            10.986552,
            53.908689,
            57.911008
          ],
          [
            10.986878,
            53.908695,
            58.037578
          ],
          [
            10.987225,
            53.908663,
            58.174207
          ],
          [
            10.98759,
            53.908726,
            58.329506
          ],
          [
            10.987818,
            53.908875,
            58.461869
          ],
          [
            10.988044,
            53.909002,
            58.583143
          ],
          [
            10.988321,
            53.909118,
            58.715028
          ],
          [
            10.988616,
            53.909252,
            58.859528
          ],
          [
            10.98887,
            53.909378,
            58.988645
          ],
          [
            10.98863,
            53.909235,
            59.222434
          ],
          [
            10.988334,
            53.909102,
            59.50441
          ],
          [
            10.988022,
            53.908991,
            59.780196
          ],
          [
            10.987826,
            53.908794,
            60.084996
          ],
          [
            10.988139,
            53.908704,
            60.375447
          ],
          [
            10.988546,
            53.908724,
            60.68415
          ],
          [
            10.988803,
            53.908846,
            60.963653
          ],
          [
            10.988802,
            53.909104,
            61.294716
          ],
          [
            10.98884,
            53.909299,
            61.480127
          ],
          [
            10.988998,
            53.909457,
            61.64217
          ],
          [
            10.989265,
            53.909572,
            61.814983
          ],
          [
            10.989546,
            53.909675,
            61.986771
          ],
          [
            10.98985,
            53.909812,
            62.185455
          ],
          [
            10.990108,
            53.909933,
            62.360348
          ],
          [
            10.990418,
            53.910067,
            62.55998
          ],
          [
            10.990709,
            53.910185,
            62.744099
          ],
          [
            10.990996,
            53.910303,
            62.915754
          ],
          [
            10.991323,
            53.910437,
            63.014136
          ],
          [
            10.991596,
            53.910557,
            63.098349
          ],
          [
            10.991863,
            53.910678,
            63.181669
          ],
          [
            10.992133,
            53.910798,
            63.265233
          ],
          [
            10.992426,
            53.910906,
            63.350931
          ],
          [
            10.992703,
            53.911031,
            63.437116
          ],
          [
            10.992986,
            53.911154,
            63.523977
          ],
          [
            10.993304,
            53.911298,
            63.623041
          ],
          [
            10.993626,
            53.911464,
            64.006901
          ],
          [
            10.99397,
            53.911621,
            64.553366
          ],
          [
            10.994289,
            53.911744,
            65.032154
          ],
          [
            10.994623,
            53.911874,
            65.534851
          ],
          [
            10.994933,
            53.912019,
            66.032045
          ],
          [
            10.995238,
            53.912157,
            66.515675
          ],
          [
            10.995536,
            53.912291,
            66.986538
          ],
          [
            10.995854,
            53.912427,
            67.480187
          ],
          [
            10.996186,
            53.91255,
            67.815542
          ],
          [
            10.996504,
            53.912679,
            68.140841
          ],
          [
            10.996786,
            53.912799,
            68.433932
          ],
          [
            10.997069,
            53.912906,
            68.717305
          ],
          [
            10.997337,
            53.913038,
            69.011625
          ],
          [
            10.997615,
            53.913156,
            69.300316
          ],
          [
            10.997877,
            53.913277,
            69.580801
          ],
          [
            10.99819,
            53.913416,
            69.911044
          ],
          [
            10.998468,
            53.913551,
            70.240666
          ],
          [
            10.998799,
            53.913713,
            70.66807
          ],
          [
            10.999133,
            53.913851,
            71.072889
          ],
          [
            10.999461,
            53.913989,
            71.47326
          ],
          [
            10.999772,
            53.914127,
            71.859563
          ],
          [
            11.000087,
            53.914263,
            72.247183
          ],
          [
            11.000409,
            53.914416,
            72.657601
          ],
          [
            11.000751,
            53.914555,
            73.06983
          ],
          [
            11.001043,
            53.914688,
            73.182458
          ],
          [
            11.001368,
            53.914836,
            73.285067
          ],
          [
            11.001704,
            53.914961,
            73.384481
          ],
          [
            11.001962,
            53.915077,
            73.465537
          ],
          [
            11.002233,
            53.915196,
            73.550047
          ],
          [
            11.002488,
            53.915303,
            73.628354
          ],
          [
            11.00281,
            53.915439,
            73.727297
          ],
          [
            11.003055,
            53.915559,
            73.807138
          ],
          [
            11.003352,
            53.915676,
            73.702979
          ],
          [
            11.00361,
            53.915793,
            73.35514
          ],
          [
            11.003883,
            53.915913,
            72.99034
          ],
          [
            11.004184,
            53.916049,
            72.58293
          ],
          [
            11.004557,
            53.916192,
            72.107521
          ],
          [
            11.004931,
            53.916339,
            71.627247
          ],
          [
            11.005324,
            53.916499,
            71.116314
          ],
          [
            11.005745,
            53.916694,
            70.625497
          ],
          [
            11.006138,
            53.916864,
            70.895982
          ],
          [
            11.006469,
            53.916997,
            71.118492
          ],
          [
            11.006772,
            53.917126,
            71.326116
          ],
          [
            11.007068,
            53.91728,
            71.545162
          ],
          [
            11.007318,
            53.917393,
            71.720132
          ],
          [
            11.007597,
            53.917517,
            71.914018
          ],
          [
            11.007893,
            53.917659,
            72.125716
          ],
          [
            11.008276,
            53.917807,
            72.21067
          ],
          [
            11.00862,
            53.917966,
            71.990565
          ],
          [
            11.008951,
            53.918092,
            71.792345
          ],
          [
            11.009249,
            53.918226,
            71.603795
          ],
          [
            11.009567,
            53.918328,
            71.421644
          ],
          [
            11.009809,
            53.918464,
            71.253116
          ],
          [
            11.010062,
            53.918582,
            71.090501
          ],
          [
            11.010417,
            53.91873,
            70.871745
          ],
          [
            11.010685,
            53.918923,
            71.067494
          ],
          [
            11.010792,
            53.919162,
            71.748654
          ],
          [
            11.010767,
            53.919404,
            72.414384
          ],
          [
            11.010719,
            53.919635,
            73.052686
          ],
          [
            11.010655,
            53.919873,
            73.713593
          ],
          [
            11.010627,
            53.920103,
            74.346219
          ],
          [
            11.010597,
            53.920333,
            74.979413
          ],
          [
            11.010536,
            53.920566,
            75.626752
          ],
          [
            11.010486,
            53.920803,
            75.216463
          ],
          [
            11.010452,
            53.921035,
            74.70832
          ],
          [
            11.010416,
            53.921235,
            74.268791
          ],
          [
            11.010372,
            53.921449,
            73.797685
          ],
          [
            11.010319,
            53.921655,
            73.341874
          ],
          [
            11.010296,
            53.921869,
            72.873493
          ],
          [
            11.010246,
            53.922107,
            72.350022
          ],
          [
            11.010191,
            53.922369,
            71.773572
          ],
          [
            11.010183,
            53.922644,
            71.411862
          ],
          [
            11.010211,
            53.922918,
            71.055192
          ],
          [
            11.010212,
            53.923187,
            70.707226
          ],
          [
            11.01026,
            53.923438,
            70.379934
          ],
          [
            11.010365,
            53.923686,
            70.049044
          ],
          [
            11.010486,
            53.923916,
            69.737596
          ],
          [
            11.010662,
            53.924148,
            69.356242
          ],
          [
            11.010827,
            53.924366,
            68.490802
          ],
          [
            11.011011,
            53.924576,
            67.632639
          ],
          [
            11.011164,
            53.924763,
            66.880015
          ],
          [
            11.011315,
            53.924987,
            66.006074
          ],
          [
            11.011449,
            53.925234,
            65.064072
          ],
          [
            11.011576,
            53.925436,
            64.280233
          ],
          [
            11.011687,
            53.925688,
            63.33445
          ],
          [
            11.011789,
            53.925897,
            63.173945
          ],
          [
            11.011912,
            53.926121,
            63.769744
          ],
          [
            11.012001,
            53.926332,
            64.320362
          ],
          [
            11.01212,
            53.926557,
            64.917033
          ],
          [
            11.012218,
            53.92679,
            65.526316
          ],
          [
            11.012315,
            53.926976,
            66.018715
          ],
          [
            11.012466,
            53.927172,
            66.565156
          ],
          [
            11.012672,
            53.927318,
            67.046702
          ],
          [
            11.012916,
            53.927445,
            67.542675
          ],
          [
            11.013194,
            53.92756,
            68.125639
          ],
          [
            11.013464,
            53.927662,
            68.677736
          ],
          [
            11.0138,
            53.927753,
            69.313908
          ],
          [
            11.014128,
            53.927829,
            69.919104
          ],
          [
            11.014456,
            53.927928,
            70.551002
          ],
          [
            11.014771,
            53.928019,
            71.152539
          ],
          [
            11.015101,
            53.928114,
            71.782333
          ],
          [
            11.015432,
            53.928224,
            72.434587
          ],
          [
            11.015796,
            53.928316,
            72.942418
          ],
          [
            11.016157,
            53.92841,
            73.335876
          ],
          [
            11.016501,
            53.928506,
            73.715602
          ],
          [
            11.016861,
            53.928609,
            74.114695
          ],
          [
            11.01722,
            53.928713,
            74.513552
          ],
          [
            11.017557,
            53.928824,
            74.898659
          ],
          [
            11.017849,
            53.928897,
            75.215249
          ],
          [
            11.01819,
            53.928995,
            75.594173
          ],
          [
            11.018499,
            53.929089,
            75.567872
          ],
          [
            11.018799,
            53.929187,
            75.243211
          ],
          [
            11.019068,
            53.929282,
            74.947163
          ],
          [
            11.019362,
            53.92942,
            74.591214
          ],
          [
            11.01968,
            53.929601,
            74.173702
          ],
          [
            11.019882,
            53.929766,
            73.847311
          ],
          [
            11.020137,
            53.929955,
            73.459389
          ],
          [
            11.020371,
            53.930138,
            73.090814
          ],
          [
            11.020562,
            53.930304,
            72.769902
          ],
          [
            11.020769,
            53.930484,
            72.422697
          ],
          [
            11.020964,
            53.930671,
            72.072323
          ],
          [
            11.021218,
            53.930839,
            71.711836
          ],
          [
            11.021486,
            53.931051,
            71.289551
          ],
          [
            11.021756,
            53.931299,
            70.818918
          ],
          [
            11.022006,
            53.931542,
            70.365305
          ],
          [
            11.02224,
            53.931773,
            70.072695
          ],
          [
            11.022461,
            53.932006,
            70.607235
          ],
          [
            11.022621,
            53.932218,
            71.071826
          ],
          [
            11.022781,
            53.932409,
            71.498334
          ],
          [
            11.02294,
            53.932598,
            71.92081
          ],
          [
            11.023121,
            53.932817,
            72.408773
          ],
          [
            11.02327,
            53.933015,
            72.842468
          ],
          [
            11.023403,
            53.933201,
            73.246833
          ],
          [
            11.023551,
            53.933395,
            73.542521
          ],
          [
            11.023706,
            53.933596,
            73.207356
          ],
          [
            11.023839,
            53.933805,
            72.868389
          ],
          [
            11.023998,
            53.934002,
            72.537503
          ],
          [
            11.02411,
            53.934225,
            72.184095
          ],
          [
            11.024265,
            53.934416,
            71.862403
          ],
          [
            11.024488,
            53.934584,
            71.538863
          ],
          [
            11.024725,
            53.934747,
            71.213341
          ],
          [
            11.025009,
            53.934876,
            70.892164
          ],
          [
            11.025332,
            53.934971,
            71.183398
          ],
          [
            11.025657,
            53.935007,
            71.492865
          ],
          [
            11.025992,
            53.93506,
            71.816169
          ],
          [
            11.026306,
            53.935102,
            72.11654
          ],
          [
            11.026669,
            53.935164,
            72.468914
          ],
          [
            11.026968,
            53.935208,
            72.756205
          ],
          [
            11.027387,
            53.93527,
            73.158816
          ],
          [
            11.027763,
            53.935324,
            73.51951
          ],
          [
            11.028201,
            53.935381,
            74.066228
          ],
          [
            11.028556,
            53.935437,
            74.608971
          ],
          [
            11.02895,
            53.935496,
            75.20889
          ],
          [
            11.029336,
            53.935551,
            75.794837
          ],
          [
            11.029736,
            53.935602,
            76.398784
          ],
          [
            11.030135,
            53.935647,
            76.99816
          ],
          [
            11.030487,
            53.935705,
            77.538215
          ],
          [
            11.030828,
            53.935743,
            78.050243
          ],
          [
            11.031164,
            53.935787,
            78.230106
          ],
          [
            11.031482,
            53.935832,
            78.237703
          ],
          [
            11.031804,
            53.935876,
            78.245385
          ],
          [
            11.03216,
            53.93592,
            78.25385
          ],
          [
            11.032465,
            53.935946,
            78.261063
          ],
          [
            11.032773,
            53.93597,
            78.268281
          ],
          [
            11.033194,
            53.935996,
            78.278156
          ],
          [
            11.03354,
            53.936035,
            78.286341
          ],
          [
            11.033885,
            53.936062,
            78.294427
          ],
          [
            11.034226,
            53.93611,
            78.379968
          ],
          [
            11.03457,
            53.936148,
            78.480933
          ],
          [
            11.034886,
            53.936177,
            78.573111
          ],
          [
            11.035194,
            53.936212,
            78.663719
          ],
          [
            11.035631,
            53.936246,
            78.790847
          ],
          [
            11.036053,
            53.93629,
            78.914407
          ],
          [
            11.036435,
            53.93633,
            79.026266
          ],
          [
            11.03685,
            53.93635,
            79.146307
          ],
          [
            11.037181,
            53.936379,
            79.425307
          ],
          [
            11.037505,
            53.936423,
            79.785129
          ],
          [
            11.037913,
            53.936451,
            80.229225
          ],
          [
            11.038231,
            53.936495,
            80.583748
          ],
          [
            11.038562,
            53.936547,
            80.954115
          ],
          [
            11.038888,
            53.936566,
            81.308372
          ],
          [
            11.039218,
            53.936587,
            81.668328
          ],
          [
            11.039603,
            53.936614,
            82.088477
          ],
          [
            11.039913,
            53.93665,
            82.430094
          ],
          [
            11.040282,
            53.936698,
            82.641415
          ],
          [
            11.040706,
            53.936709,
            82.848271
          ],
          [
            11.041122,
            53.936758,
            83.054706
          ],
          [
            11.041527,
            53.9368,
            83.254841
          ],
          [
            11.0419,
            53.936836,
            83.438779
          ],
          [
            11.042354,
            53.936879,
            83.663502
          ],
          [
            11.042669,
            53.936913,
            83.819394
          ],
          [
            11.042997,
            53.93695,
            83.938276
          ],
          [
            11.043387,
            53.936978,
            83.597297
          ],
          [
            11.043835,
            53.937042,
            83.19698
          ],
          [
            11.044333,
            53.9371,
            82.755305
          ],
          [
            11.04484,
            53.93716,
            82.306406
          ],
          [
            11.045336,
            53.937209,
            81.869938
          ],
          [
            11.045775,
            53.937253,
            81.483471
          ],
          [
            11.046203,
            53.937282,
            81.426158
          ],
          [
            11.046618,
            53.93732,
            81.623898
          ],
          [
            11.047,
            53.937369,
            81.808047
          ],
          [
            11.047389,
            53.937406,
            81.993388
          ],
          [
            11.047769,
            53.937425,
            82.1728
          ],
          [
            11.048111,
            53.937443,
            82.334369
          ],
          [
            11.04847,
            53.93746,
            82.503773
          ],
          [
            11.048815,
            53.937485,
            82.667757
          ],
          [
            11.04919,
            53.937492,
            82.748398
          ],
          [
            11.049533,
            53.937518,
            82.742373
          ],
          [
            11.049855,
            53.937585,
            82.736426
          ],
          [
            11.050191,
            53.937653,
            82.730208
          ],
          [
            11.050584,
            53.937714,
            82.723132
          ],
          [
            11.050991,
            53.93779,
            82.715686
          ],
          [
            11.051389,
            53.93786,
            82.708448
          ],
          [
            11.051793,
            53.937929,
            82.701121
          ],
          [
            11.052173,
            53.938009,
            82.767038
          ],
          [
            11.052552,
            53.938095,
            82.873844
          ],
          [
            11.052914,
            53.938195,
            82.978809
          ],
          [
            11.05323,
            53.938259,
            83.066517
          ],
          [
            11.05354,
            53.938341,
            83.155782
          ],
          [
            11.053844,
            53.938425,
            83.244127
          ],
          [
            11.054187,
            53.938532,
            83.346173
          ],
          [
            11.054503,
            53.938599,
            83.434325
          ],
          [
            11.054845,
            53.938659,
            83.488467
          ],
          [
            11.055165,
            53.938711,
            83.450042
          ],
          [
            11.055557,
            53.938756,
            83.403812
          ],
          [
            11.055944,
            53.938806,
            83.35796
          ],
          [
            11.056328,
            53.938864,
            83.312096
          ],
          [
            11.056742,
            53.938916,
            83.263119
          ],
          [
            11.057169,
            53.93897,
            83.212565
          ],
          [
            11.057569,
            53.939044,
            83.164039
          ],
          [
            11.057931,
            53.939092,
            83.161168
          ],
          [
            11.058341,
            53.939159,
            83.187839
          ],
          [
            11.05867,
            53.93921,
            83.209109
          ],
          [
            11.059053,
            53.93927,
            83.233886
          ],
          [
            11.059408,
            53.939312,
            83.25653
          ],
          [
            11.059729,
            53.939352,
            83.277069
          ],
          [
            11.060083,
            53.939382,
            83.299438
          ],
          [
            11.060448,
            53.939371,
            83.32229
          ],
          [
            11.060845,
            53.93937,
            83.499744
          ],
          [
            11.061236,
            53.939375,
            83.935392
          ],
          [
            11.061598,
            53.939362,
            84.339376
          ],
          [
            11.061949,
            53.939356,
            84.730494
          ],
          [
            11.06231,
            53.939354,
            85.134063
          ],
          [
            11.062679,
            53.939336,
            85.546476
          ],
          [
            11.063042,
            53.939352,
            85.951952
          ],
          [
            11.063407,
            53.939337,
            86.359833
          ],
          [
            11.063773,
            53.939377,
            86.763845
          ],
          [
            11.064139,
            53.939425,
            87.043452
          ],
          [
            11.064545,
            53.939452,
            87.347514
          ],
          [
            11.064947,
            53.9395,
            87.653348
          ],
          [
            11.065385,
            53.939548,
            87.984947
          ],
          [
            11.065789,
            53.939585,
            88.289055
          ],
          [
            11.066184,
            53.939642,
            88.591757
          ],
          [
            11.066569,
            53.939665,
            88.880177
          ],
          [
            11.066948,
            53.939697,
            89.084704
          ],
          [
            11.067315,
            53.93975,
            89.215848
          ],
          [
            11.067651,
            53.939787,
            89.334418
          ],
          [
            11.06801,
            53.939805,
            89.459341
          ],
          [
            11.068379,
            53.939833,
            89.588339
          ],
          [
            11.068782,
            53.939855,
            89.728727
          ],
          [
            11.069147,
            53.939891,
            89.857037
          ],
          [
            11.069529,
            53.939928,
            89.991252
          ],
          [
            11.069872,
            53.939985,
            90.203631
          ],
          [
            11.070202,
            53.94001,
            90.568416
          ],
          [
            11.070589,
            53.940048,
            91.000384
          ],
          [
            11.070897,
            53.940142,
            91.38003
          ],
          [
            11.071154,
            53.940293,
            91.776554
          ],
          [
            11.07137,
            53.940458,
            92.164999
          ],
          [
            11.071608,
            53.940633,
            92.580808
          ],
          [
            11.071848,
            53.940793,
            92.97666
          ],
          [
            11.072163,
            53.940918,
            93.394719
          ],
          [
            11.072504,
            53.940947,
            93.141523
          ],
          [
            11.072869,
            53.940954,
            92.849167
          ],
          [
            11.073216,
            53.940916,
            92.566451
          ],
          [
            11.073548,
            53.940894,
            92.297986
          ],
          [
            11.073939,
            53.940895,
            91.984976
          ],
          [
            11.074313,
            53.940932,
            91.680169
          ],
          [
            11.0747,
            53.940939,
            91.3699
          ],
          [
            11.0751,
            53.940968,
            91.046632
          ],
          [
            11.075437,
            53.941,
            91.241644
          ],
          [
            11.075798,
            53.941012,
            91.670474
          ],
          [
            11.076158,
            53.941031,
            92.098095
          ],
          [
            11.076483,
            53.941048,
            92.484944
          ],
          [
            11.07682,
            53.941105,
            92.899988
          ],
          [
            11.077194,
            53.941102,
            93.344171
          ],
          [
            11.077531,
            53.941144,
            93.75143
          ],
          [
            11.077869,
            53.941201,
            94.168235
          ],
          [
            11.078187,
            53.941206,
            94.549398
          ],
          [
            11.078522,
            53.941195,
            94.454269
          ],
          [
            11.078884,
            53.941205,
            94.315877
          ],
          [
            11.079218,
            53.941223,
            94.187835
          ],
          [
            11.079574,
            53.941239,
            94.050883
          ],
          [
            11.079904,
            53.941233,
            93.924849
          ],
          [
            11.080226,
            53.941251,
            93.801133
          ],
          [
            11.080556,
            53.941261,
            93.674993
          ],
          [
            11.080901,
            53.941295,
            93.540955
          ],
          [
            11.081241,
            53.941371,
            93.421181
          ],
          [
            11.081558,
            53.941445,
            93.682462
          ],
          [
            11.081865,
            53.941528,
            93.941905
          ],
          [
            11.082157,
            53.941624,
            94.198248
          ],
          [
            11.082493,
            53.94171,
            94.480493
          ],
          [
            11.082791,
            53.941764,
            94.720392
          ],
          [
            11.083093,
            53.941847,
            94.975547
          ],
          [
            11.083374,
            53.94197,
            95.247218
          ],
          [
            11.083605,
            53.942107,
            95.498457
          ],
          [
            11.083839,
            53.94224,
            95.747846
          ],
          [
            11.084005,
            53.9424,
            96.203945
          ],
          [
            11.084274,
            53.94252,
            96.689767
          ],
          [
            11.084597,
            53.942594,
            97.183877
          ],
          [
            11.0849,
            53.942664,
            97.652015
          ],
          [
            11.0852,
            53.942749,
            98.139111
          ],
          [
            11.085521,
            53.942824,
            98.631341
          ],
          [
            11.085844,
            53.942917,
            99.144901
          ],
          [
            11.086136,
            53.943061,
            99.693863
          ],
          [
            11.086448,
            53.943189,
            100.0075
          ],
          [
            11.086766,
            53.943262,
            99.660567
          ],
          [
            11.087064,
            53.943373,
            99.302503
          ],
          [
            11.087403,
            53.943465,
            98.923481
          ],
          [
            11.087699,
            53.94355,
            98.589213
          ],
          [
            11.087983,
            53.943655,
            98.248975
          ],
          [
            11.088385,
            53.943763,
            97.7995
          ],
          [
            11.088745,
            53.94383,
            97.416518
          ],
          [
            11.089043,
            53.943947,
            97.053137
          ],
          [
            11.089317,
            53.944068,
            96.816987
          ],
          [
            11.089596,
            53.944217,
            96.579346
          ],
          [
            11.089845,
            53.944359,
            96.356953
          ],
          [
            11.090128,
            53.944515,
            96.11228
          ],
          [
            11.090392,
            53.944662,
            95.8832
          ],
          [
            11.090708,
            53.944829,
            95.614552
          ],
          [
            11.091024,
            53.944978,
            95.359335
          ],
          [
            11.09134,
            53.945082,
            95.130937
          ],
          [
            11.091652,
            53.945189,
            95.465907
          ],
          [
            11.091884,
            53.945355,
            95.980625
          ],
          [
            11.092082,
            53.945523,
            96.47005
          ],
          [
            11.092321,
            53.945652,
            96.928578
          ],
          [
            11.092574,
            53.945804,
            97.441835
          ],
          [
            11.09281,
            53.945982,
            97.982278
          ],
          [
            11.093027,
            53.94613,
            98.450326
          ],
          [
            11.093196,
            53.946301,
            98.927419
          ],
          [
            11.093429,
            53.946468,
            99.388845
          ],
          [
            11.093631,
            53.946656,
            99.441987
          ],
          [
            11.093847,
            53.946809,
            99.489414
          ],
          [
            11.094137,
            53.946942,
            99.541058
          ],
          [
            11.094433,
            53.947071,
            99.592697
          ],
          [
            11.094681,
            53.947189,
            99.638295
          ],
          [
            11.094903,
            53.94733,
            99.684087
          ],
          [
            11.09519,
            53.947478,
            99.737731
          ],
          [
            11.095534,
            53.947632,
            99.798457
          ],
          [
            11.095804,
            53.947801,
            99.252906
          ],
          [
            11.096104,
            53.947949,
            98.536164
          ],
          [
            11.096456,
            53.948098,
            97.74201
          ],
          [
            11.096907,
            53.948286,
            96.730022
          ],
          [
            11.097383,
            53.948399,
            95.789406
          ],
          [
            11.097812,
            53.948515,
            94.924878
          ],
          [
            11.098214,
            53.948623,
            94.198534
          ],
          [
            11.098584,
            53.948703,
            94.063634
          ],
          [
            11.098966,
            53.948795,
            93.922375
          ],
          [
            11.099316,
            53.948884,
            93.791874
          ],
          [
            11.099645,
            53.948986,
            93.663934
          ],
          [
            11.099953,
            53.949125,
            93.53082
          ],
          [
            11.10024,
            53.949268,
            93.402102
          ],
          [
            11.100585,
            53.949393,
            93.263298
          ],
          [
            11.10091,
            53.949515,
            93.268484
          ],
          [
            11.101159,
            53.949661,
            93.550629
          ],
          [
            11.101411,
            53.949836,
            93.863082
          ],
          [
            11.101659,
            53.949993,
            94.154504
          ],
          [
            11.101918,
            53.95014,
            94.442719
          ],
          [
            11.102095,
            53.95029,
            94.692298
          ],
          [
            11.10225,
            53.950491,
            94.992397
          ],
          [
            11.102409,
            53.950644,
            95.237617
          ],
          [
            11.102756,
            53.950731,
            95.541185
          ],
          [
            11.103123,
            53.950818,
            95.159899
          ],
          [
            11.103474,
            53.95097,
            94.500778
          ],
          [
            11.103724,
            53.951106,
            93.985162
          ],
          [
            11.103987,
            53.951228,
            93.478601
          ],
          [
            11.104244,
            53.95133,
            93.009644
          ],
          [
            11.104499,
            53.951504,
            92.41736
          ],
          [
            11.104874,
            53.951649,
            91.737234
          ],
          [
            11.105261,
            53.951747,
            91.098692
          ],
          [
            11.105711,
            53.951803,
            90.084068
          ],
          [
            11.106104,
            53.951881,
            89.11795
          ],
          [
            11.106493,
            53.951944,
            88.179433
          ],
          [
            11.10687,
            53.951988,
            87.285429
          ],
          [
            11.107331,
            53.952072,
            86.162158
          ],
          [
            11.107876,
            53.952133,
            84.869494
          ],
          [
            11.10829,
            53.952206,
            83.86401
          ],
          [
            11.108744,
            53.952282,
            82.75442
          ],
          [
            11.109052,
            53.952317,
            82.017324
          ],
          [
            11.109378,
            53.95237,
            81.222153
          ],
          [
            11.109689,
            53.95244,
            80.44135
          ],
          [
            11.110082,
            53.952588,
            79.335327
          ],
          [
            11.110463,
            53.95284,
            77.987115
          ],
          [
            11.110677,
            53.953044,
            77.030747
          ],
          [
            11.110898,
            53.953216,
            76.626602
          ],
          [
            11.111247,
            53.953412,
            76.435521
          ],
          [
            11.111658,
            53.953572,
            76.240214
          ],
          [
            11.112165,
            53.953664,
            76.030439
          ],
          [
            11.112604,
            53.95375,
            75.847624
          ],
          [
            11.11292,
            53.953911,
            75.67789
          ],
          [
            11.113075,
            53.954131,
            75.517882
          ],
          [
            11.113292,
            53.954358,
            75.283124
          ],
          [
            11.113467,
            53.954532,
            75.099218
          ],
          [
            11.113722,
            53.954684,
            74.90504
          ],
          [
            11.113994,
            53.954833,
            74.706155
          ],
          [
            11.11424,
            53.954991,
            74.511331
          ],
          [
            11.114497,
            53.955161,
            74.304477
          ],
          [
            11.114759,
            53.955375,
            74.064694
          ],
          [
            11.114997,
            53.955523,
            73.879076
          ],
          [
            11.115246,
            53.955668,
            73.757995
          ],
          [
            11.115494,
            53.955818,
            73.635746
          ],
          [
            11.115743,
            53.955954,
            73.519188
          ],
          [
            11.115968,
            53.956098,
            73.40475
          ],
          [
            11.116157,
            53.956241,
            73.299084
          ],
          [
            11.116409,
            53.956416,
            73.164457
          ],
          [
            11.116701,
            53.956545,
            73.039097
          ],
          [
            11.117019,
            53.956665,
            72.909431
          ],
          [
            11.117376,
            53.956773,
            72.707826
          ],
          [
            11.117757,
            53.956926,
            72.372833
          ],
          [
            11.11819,
            53.957039,
            72.026513
          ],
          [
            11.118647,
            53.95703,
            71.693373
          ],
          [
            11.119012,
            53.957001,
            71.424659
          ],
          [
            11.119482,
            53.956986,
            71.082517
          ],
          [
            11.11985,
            53.957,
            70.814668
          ],
          [
            11.120234,
            53.957003,
            70.591631
          ],
          [
            11.120646,
            53.956986,
            70.520806
          ],
          [
            11.120981,
            53.956954,
            70.462498
          ],
          [
            11.121342,
            53.956916,
            70.399583
          ],
          [
            11.121683,
            53.956881,
            70.340209
          ],
          [
            11.122127,
            53.956891,
            70.263993
          ],
          [
            11.122457,
            53.95692,
            70.206763
          ],
          [
            11.122761,
            53.956996,
            70.150074
          ],
          [
            11.123051,
            53.957082,
            70.094383
          ],
          [
            11.123332,
            53.957173,
            69.889212
          ],
          [
            11.123632,
            53.957279,
            69.631434
          ],
          [
            11.123949,
            53.957379,
            69.366477
          ],
          [
            11.124261,
            53.957485,
            69.100922
          ],
          [
            11.124563,
            53.957594,
            68.839896
          ],
          [
            11.124887,
            53.957665,
            68.584698
          ],
          [
            11.125288,
            53.95773,
            68.277589
          ],
          [
            11.125723,
            53.957804,
            67.943868
          ],
          [
            11.126147,
            53.957888,
            67.85378
          ],
          [
            11.126489,
            53.957938,
            67.878322
          ],
          [
            11.126838,
            53.957979,
            67.903149
          ],
          [
            11.127145,
            53.95803,
            67.925487
          ],
          [
            11.127586,
            53.958021,
            67.956236
          ],
          [
            11.127902,
            53.957996,
            67.978453
          ],
          [
            11.128221,
            53.957964,
            68.00099
          ],
          [
            11.128554,
            53.957954,
            68.02424
          ],
          [
            11.128885,
            53.957951,
            68.047358
          ],
          [
            11.129269,
            53.957951,
            68.075435
          ],
          [
            11.129669,
            53.957984,
            68.104936
          ],
          [
            11.129969,
            53.958021,
            68.127352
          ],
          [
            11.130266,
            53.958082,
            68.150304
          ],
          [
            11.130687,
            53.95814,
            68.181973
          ],
          [
            11.131005,
            53.958175,
            68.205569
          ],
          [
            11.13135,
            53.958225,
            68.231485
          ],
          [
            11.131729,
            53.9583,
            68.260651
          ],
          [
            11.13218,
            53.958365,
            67.817683
          ],
          [
            11.132673,
            53.958431,
            67.169374
          ],
          [
            11.133189,
            53.958504,
            66.488402
          ],
          [
            11.133663,
            53.958586,
            65.854874
          ],
          [
            11.134082,
            53.958642,
            65.303931
          ],
          [
            11.134456,
            53.95869,
            64.811069
          ],
          [
            11.134785,
            53.958741,
            64.372177
          ],
          [
            11.135101,
            53.958772,
            64.2123
          ],
          [
            11.135499,
            53.958819,
            64.028273
          ],
          [
            11.135819,
            53.958861,
            63.876623
          ],
          [
            11.136003,
            53.958753,
            63.729545
          ],
          [
            11.135944,
            53.958558,
            63.576766
          ],
          [
            11.136183,
            53.958526,
            63.395465
          ],
          [
            11.135927,
            53.958416,
            63.190854
          ],
          [
            11.136071,
            53.958547,
            62.991219
          ],
          [
            11.136021,
            53.958421,
            62.784944
          ],
          [
            11.136008,
            53.958599,
            62.564703
          ],
          [
            11.136012,
            53.958801,
            62.323052
          ],
          [
            11.136235,
            53.958922,
            62.0917
          ],
          [
            11.136565,
            53.95897,
            61.852437
          ],
          [
            11.136885,
            53.959072,
            61.595863
          ],
          [
            11.137139,
            53.959271,
            61.295279
          ],
          [
            11.137303,
            53.959491,
            61.007543
          ],
          [
            11.137469,
            53.95966,
            60.752154
          ],
          [
            11.137623,
            53.959868,
            60.335688
          ],
          [
            11.13779,
            53.960069,
            59.924404
          ],
          [
            11.138037,
            53.960273,
            59.46458
          ],
          [
            11.138343,
            53.960387,
            59.07285
          ],
          [
            11.138697,
            53.960495,
            58.641967
          ],
          [
            11.139054,
            53.960599,
            58.211164
          ],
          [
            11.139432,
            53.9607,
            57.762393
          ],
          [
            11.139821,
            53.960814,
            57.469339
          ],
          [
            11.140148,
            53.960869,
            57.397078
          ],
          [
            11.140477,
            53.960969,
            57.318371
          ],
          [
            11.140806,
            53.961076,
            57.238582
          ],
          [
            11.141134,
            53.961125,
            57.166467
          ],
          [
            11.141476,
            53.96119,
            57.089656
          ],
          [
            11.141811,
            53.961233,
            57.016845
          ],
          [
            11.142141,
            53.961278,
            56.944959
          ],
          [
            11.142475,
            53.961305,
            56.87336
          ],
          [
            11.142857,
            53.961336,
            56.654193
          ],
          [
            11.143171,
            53.961349,
            56.460428
          ],
          [
            11.143505,
            53.961339,
            56.254838
          ],
          [
            11.143877,
            53.96132,
            56.02506
          ],
          [
            11.144273,
            53.961324,
            55.778037
          ],
          [
            11.144589,
            53.961354,
            55.580994
          ],
          [
            11.144889,
            53.961424,
            55.379589
          ],
          [
            11.145184,
            53.961531,
            55.16662
          ],
          [
            11.145455,
            53.961661,
            55.012083
          ],
          [
            11.145724,
            53.961857,
            55.219975
          ],
          [
            11.145953,
            53.962016,
            55.392059
          ],
          [
            11.146181,
            53.962176,
            55.56449
          ],
          [
            11.146439,
            53.962306,
            55.729442
          ],
          [
            11.146702,
            53.96244,
            55.898394
          ],
          [
            11.147009,
            53.962571,
            56.082599
          ],
          [
            11.147372,
            53.962674,
            56.278446
          ],
          [
            11.14769,
            53.962759,
            56.44889
          ],
          [
            11.148032,
            53.962817,
            56.043254
          ],
          [
            11.148409,
            53.962858,
            55.521294
          ],
          [
            11.148823,
            53.962913,
            54.943504
          ],
          [
            11.149239,
            53.962999,
            54.342488
          ],
          [
            11.149671,
            53.963104,
            53.705544
          ],
          [
            11.150086,
            53.963248,
            53.049438
          ],
          [
            11.150471,
            53.963427,
            52.38079
          ],
          [
            11.150832,
            53.96361,
            52.40054
          ],
          [
            11.151195,
            53.963822,
            52.51267
          ],
          [
            11.151582,
            53.964034,
            52.628632
          ],
          [
            11.151914,
            53.964214,
            52.7275
          ],
          [
            11.1522,
            53.964392,
            52.818674
          ],
          [
            11.152494,
            53.964564,
            52.909545
          ],
          [
            11.152805,
            53.964699,
            52.904063
          ],
          [
            11.153102,
            53.964848,
            52.532171
          ],
          [
            11.153418,
            53.964982,
            52.161579
          ],
          [
            11.153705,
            53.965102,
            51.826016
          ],
          [
            11.153972,
            53.965215,
            51.513271
          ],
          [
            11.154358,
            53.965331,
            51.101349
          ],
          [
            11.154747,
            53.965432,
            50.696029
          ],
          [
            11.155152,
            53.965523,
            50.284028
          ],
          [
            11.155571,
            53.965589,
            50.033093
          ],
          [
            11.156002,
            53.965645,
            49.952232
          ],
          [
            11.156392,
            53.965696,
            49.878878
          ],
          [
            11.15674,
            53.965731,
            49.813823
          ],
          [
            11.157116,
            53.965774,
            49.743579
          ],
          [
            11.157539,
            53.965821,
            49.664703
          ],
          [
            11.157943,
            53.965897,
            49.586977
          ],
          [
            11.158299,
            53.966001,
            49.513869
          ],
          [
            11.15866,
            53.966087,
            49.917697
          ],
          [
            11.158997,
            53.966178,
            50.31564
          ],
          [
            11.159297,
            53.966292,
            50.698822
          ],
          [
            11.159618,
            53.966386,
            51.08389
          ],
          [
            11.159905,
            53.966491,
            51.446826
          ],
          [
            11.16027,
            53.966604,
            51.890148
          ],
          [
            11.160539,
            53.966702,
            52.22971
          ],
          [
            11.160884,
            53.966836,
            52.673833
          ],
          [
            11.161212,
            53.966959,
            53.004409
          ],
          [
            11.161518,
            53.967042,
            53.261079
          ],
          [
            11.161824,
            53.967129,
            53.521405
          ],
          [
            11.162125,
            53.967251,
            53.799966
          ],
          [
            11.162467,
            53.967356,
            54.093793
          ],
          [
            11.162789,
            53.96748,
            54.387235
          ],
          [
            11.163158,
            53.967601,
            54.709017
          ],
          [
            11.163511,
            53.967677,
            54.996056
          ],
          [
            11.163772,
            53.967786,
            55.005254
          ],
          [
            11.163701,
            53.96758,
            54.747671
          ],
          [
            11.163705,
            53.967635,
            54.436343
          ],
          [
            11.163933,
            53.967753,
            54.200749
          ],
          [
            11.164114,
            53.967939,
            53.938122
          ],
          [
            11.164201,
            53.968125,
            53.699891
          ],
          [
            11.164212,
            53.968322,
            53.455133
          ],
          [
            11.164209,
            53.968525,
            53.206356
          ],
          [
            11.16425,
            53.968719,
            52.966441
          ],
          [
            11.164395,
            53.96892,
            54.169792
          ],
          [
            11.164616,
            53.969071,
            55.571021
          ],
          [
            11.164896,
            53.969198,
            57.022373
          ],
          [
            11.165125,
            53.969361,
            58.504622
          ],
          [
            11.165021,
            53.969532,
            59.812886
          ],
          [
            11.164848,
            53.96969,
            61.126247
          ],
          [
            11.164636,
            53.969844,
            62.539791
          ],
          [
            11.164474,
            53.970014,
            63.903131
          ],
          [
            11.164297,
            53.97019,
            65.32935
          ],
          [
            11.164126,
            53.970347,
            66.184633
          ],
          [
            11.163943,
            53.970515,
            67.04449
          ],
          [
            11.163749,
            53.970663,
            67.849894
          ],
          [
            11.163553,
            53.970816,
            68.680875
          ],
          [
            11.163227,
            53.970848,
            69.546529
          ],
          [
            11.162908,
            53.970755,
            70.449124
          ],
          [
            11.162631,
            53.970651,
            71.287084
          ],
          [
            11.162334,
            53.97054,
            72.181348
          ],
          [
            11.162047,
            53.970432,
            73.044732
          ],
          [
            11.161971,
            53.970553,
            73.300501
          ],
          [
            11.162142,
            53.970722,
            73.421183
          ],
          [
            11.162038,
            53.970949,
            73.568794
          ],
          [
            11.162038,
            53.971002,
            73.678949
          ],
          [
            11.162033,
            53.971001,
            73.791534
          ],
          [
            11.162133,
            53.970822,
            73.914041
          ],
          [
            11.162035,
            53.970633,
            74.042224
          ],
          [
            11.161905,
            53.970456,
            74.16371
          ],
          [
            11.162245,
            53.970483,
            74.290915
          ],
          [
            11.162543,
            53.970608,
            73.276218
          ],
          [
            11.162871,
            53.970734,
            71.948937
          ],
          [
            11.163169,
            53.97085,
            70.737314
          ],
          [
            11.163491,
            53.970871,
            69.563367
          ],
          [
            11.163696,
            53.970702,
            68.367473
          ],
          [
            11.163906,
            53.970505,
            67.028451
          ],
          [
            11.164129,
            53.970295,
            65.60276
          ],
          [
            11.164393,
            53.970075,
            64.051826
          ],
          [
            11.164629,
            53.969859,
            62.250438
          ],
          [
            11.164869,
            53.96965,
            60.45906
          ],
          [
            11.16508,
            53.969473,
            58.92357
          ],
          [
            11.164984,
            53.969281,
            57.435229
          ],
          [
            11.164708,
            53.969137,
            55.8926
          ],
          [
            11.16445,
            53.968999,
            54.434549
          ],
          [
            11.164303,
            53.968782,
            52.767034
          ],
          [
            11.164244,
            53.968568,
            51.22691
          ],
          [
            11.164256,
            53.968341,
            51.231564
          ],
          [
            11.164252,
            53.968132,
            51.279411
          ],
          [
            11.164117,
            53.967921,
            51.331037
          ],
          [
            11.163972,
            53.967751,
            51.374402
          ],
          [
            11.164041,
            53.967579,
            51.421341
          ],
          [
            11.164343,
            53.96748,
            51.467767
          ],
          [
            11.164645,
            53.967384,
            51.513783
          ],
          [
            11.164974,
            53.967279,
            51.564253
          ],
          [
            11.165148,
            53.967137,
            51.987138
          ],
          [
            11.165072,
            53.966956,
            53.089735
          ],
          [
            11.165075,
            53.966766,
            54.217458
          ],
          [
            11.165247,
            53.966597,
            55.410699
          ],
          [
            11.165467,
            53.966436,
            56.632084
          ],
          [
            11.165728,
            53.966309,
            57.808798
          ],
          [
            11.166057,
            53.966181,
            59.180911
          ],
          [
            11.166358,
            53.966084,
            60.374044
          ],
          [
            11.16666,
            53.96598,
            61.589745
          ],
          [
            11.166922,
            53.96588,
            62.053771
          ],
          [
            11.167206,
            53.965781,
            61.656925
          ],
          [
            11.167472,
            53.965614,
            61.196737
          ],
          [
            11.167734,
            53.965466,
            60.768116
          ],
          [
            11.167995,
            53.965343,
            60.373095
          ],
          [
            11.168229,
            53.965207,
            59.984954
          ],
          [
            11.168488,
            53.965059,
            59.55891
          ],
          [
            11.16876,
            53.964957,
            59.177543
          ],
          [
            11.169108,
            53.964883,
            58.740524
          ],
          [
            11.169424,
            53.96485,
            59.162487
          ],
          [
            11.169786,
            53.964807,
            60.167077
          ],
          [
            11.170157,
            53.964743,
            61.218671
          ],
          [
            11.170478,
            53.964708,
            62.107635
          ],
          [
            11.170833,
            53.96465,
            63.109748
          ],
          [
            11.171165,
            53.964598,
            64.044802
          ],
          [
            11.17152,
            53.964547,
            65.03907
          ],
          [
            11.171856,
            53.964507,
            65.97148
          ],
          [
            11.172228,
            53.964451,
            66.957035
          ],
          [
            11.172523,
            53.964353,
            67.314644
          ],
          [
            11.172892,
            53.964291,
            67.719181
          ],
          [
            11.173248,
            53.964243,
            68.103896
          ],
          [
            11.17358,
            53.964203,
            68.460785
          ],
          [
            11.1739,
            53.964159,
            68.807019
          ],
          [
            11.174226,
            53.964133,
            69.153472
          ],
          [
            11.174549,
            53.964127,
            69.49388
          ],
          [
            11.174808,
            53.963986,
            69.874049
          ],
          [
            11.17504,
            53.963879,
            70.185455
          ],
          [
            11.175375,
            53.963979,
            70.426476
          ],
          [
            11.175722,
            53.963928,
            70.654806
          ],
          [
            11.176051,
            53.963837,
            70.886827
          ],
          [
            11.176333,
            53.963737,
            71.097053
          ],
          [
            11.176624,
            53.963614,
            71.326085
          ],
          [
            11.177007,
            53.963555,
            71.579286
          ],
          [
            11.177333,
            53.963445,
            71.820319
          ],
          [
            11.177663,
            53.963348,
            72.056367
          ],
          [
            11.177948,
            53.963269,
            72.47077
          ],
          [
            11.178244,
            53.963172,
            72.964292
          ],
          [
            11.178572,
            53.963099,
            73.474429
          ],
          [
            11.178921,
            53.963017,
            74.020558
          ],
          [
            11.179258,
            53.962917,
            74.569445
          ],
          [
            11.179553,
            53.962835,
            75.043732
          ],
          [
            11.179827,
            53.962737,
            75.511325
          ],
          [
            11.180153,
            53.962634,
            76.051917
          ],
          [
            11.180532,
            53.962587,
            76.55686
          ],
          [
            11.180828,
            53.962535,
            76.681686
          ],
          [
            11.181173,
            53.962444,
            76.833674
          ],
          [
            11.181472,
            53.962371,
            76.963834
          ],
          [
            11.181775,
            53.962283,
            77.099701
          ],
          [
            11.18206,
            53.962182,
            77.233697
          ],
          [
            11.182363,
            53.962049,
            77.385671
          ],
          [
            11.182679,
            53.961986,
            77.520459
          ],
          [
            11.183036,
            53.961943,
            77.667227
          ],
          [
            11.183332,
            53.961887,
            77.813956
          ],
          [
            11.183625,
            53.961796,
            78.045259
          ],
          [
            11.183954,
            53.961706,
            78.29774
          ],
          [
            11.184243,
            53.961647,
            78.510552
          ],
          [
            11.184581,
            53.961597,
            78.753362
          ],
          [
            11.184898,
            53.961537,
            78.985092
          ],
          [
            11.185222,
            53.961466,
            79.225591
          ],
          [
            11.185399,
            53.961339,
            79.460402
          ],
          [
            11.185398,
            53.961311,
            79.719734
          ],
          [
            11.185663,
            53.961411,
            79.828225
          ],
          [
            11.186029,
            53.961397,
            79.681377
          ],
          [
            11.186443,
            53.96137,
            79.515124
          ],
          [
            11.186777,
            53.961367,
            79.381797
          ],
          [
            11.187105,
            53.961352,
            79.250472
          ],
          [
            11.187465,
            53.961337,
            79.10642
          ],
          [
            11.187834,
            53.961308,
            78.957827
          ],
          [
            11.188167,
            53.961268,
            78.822166
          ],
          [
            11.188522,
            53.961255,
            78.679931
          ],
          [
            11.188863,
            53.96123,
            77.830873
          ],
          [
            11.189192,
            53.961188,
            76.946111
          ],
          [
            11.188832,
            53.961234,
            75.976134
          ],
          [
            11.188485,
            53.961236,
            75.054903
          ],
          [
            11.188659,
            53.961352,
            74.092308
          ],
          [
            11.18902,
            53.96134,
            73.140653
          ],
          [
            11.189426,
            53.961279,
            72.039768
          ],
          [
            11.189748,
            53.961276,
            71.192461
          ],
          [
            11.190169,
            53.961268,
            70.409117
          ],
          [
            11.190575,
            53.961238,
            69.962155
          ],
          [
            11.190986,
            53.961204,
            69.508731
          ],
          [
            11.191417,
            53.961174,
            69.034842
          ],
          [
            11.191801,
            53.961146,
            68.611981
          ],
          [
            11.192209,
            53.961122,
            68.163207
          ],
          [
            11.192623,
            53.961095,
            67.706307
          ],
          [
            11.193002,
            53.961061,
            67.295892
          ],
          [
            11.193394,
            53.961049,
            67.135103
          ],
          [
            11.193797,
            53.961015,
            66.968229
          ],
          [
            11.194222,
            53.960997,
            66.793698
          ],
          [
            11.194646,
            53.960944,
            66.616107
          ],
          [
            11.195058,
            53.960905,
            66.445179
          ],
          [
            11.195433,
            53.960866,
            66.289196
          ],
          [
            11.195805,
            53.960818,
            66.133184
          ],
          [
            11.196141,
            53.960786,
            65.977156
          ],
          [
            11.196479,
            53.960737,
            65.792861
          ],
          [
            11.196832,
            53.960643,
            65.586251
          ],
          [
            11.197184,
            53.960571,
            65.389129
          ],
          [
            11.197546,
            53.960494,
            65.185466
          ],
          [
            11.1979,
            53.960406,
            64.982212
          ],
          [
            11.198322,
            53.960308,
            64.742241
          ],
          [
            11.198705,
            53.960198,
            64.516756
          ],
          [
            11.199083,
            53.960091,
            64.651483
          ],
          [
            11.199441,
            53.959989,
            64.986526
          ],
          [
            11.199779,
            53.959893,
            65.30265
          ],
          [
            11.200129,
            53.959814,
            65.618655
          ],
          [
            11.200442,
            53.959715,
            65.917904
          ],
          [
            11.200775,
            53.959653,
            66.212672
          ],
          [
            11.20113,
            53.959557,
            66.542928
          ],
          [
            11.201423,
            53.959483,
            66.811478
          ],
          [
            11.201727,
            53.959425,
            67.044585
          ],
          [
            11.202044,
            53.959387,
            67.185255
          ],
          [
            11.20236,
            53.959297,
            67.348743
          ],
          [
            11.202705,
            53.959238,
            67.505699
          ],
          [
            11.203113,
            53.959216,
            67.684097
          ],
          [
            11.203517,
            53.959173,
            67.862797
          ],
          [
            11.203898,
            53.959103,
            68.039933
          ],
          [
            11.204322,
            53.959047,
            68.229081
          ],
          [
            11.204724,
            53.959018,
            68.341465
          ],
          [
            11.205076,
            53.958988,
            68.35494
          ],
          [
            11.205407,
            53.958953,
            68.367669
          ],
          [
            11.205808,
            53.958909,
            68.383112
          ],
          [
            11.206187,
            53.958884,
            68.397567
          ],
          [
            11.206547,
            53.958854,
            68.411333
          ],
          [
            11.206892,
            53.958821,
            68.424571
          ],
          [
            11.207251,
            53.958787,
            68.438343
          ],
          [
            11.207619,
            53.958753,
            68.430787
          ],
          [
            11.207957,
            53.958719,
            68.243754
          ],
          [
            11.208284,
            53.958682,
            68.062118
          ],
          [
            11.208665,
            53.958637,
            67.850152
          ],
          [
            11.209089,
            53.9586,
            67.616325
          ],
          [
            11.209474,
            53.958558,
            67.402749
          ],
          [
            11.209803,
            53.958521,
            67.21983
          ],
          [
            11.210221,
            53.958464,
            66.985441
          ],
          [
            11.21055,
            53.95843,
            66.803257
          ],
          [
            11.210951,
            53.958393,
            66.080135
          ],
          [
            11.211385,
            53.958342,
            65.239441
          ],
          [
            11.211785,
            53.958301,
            64.46803
          ],
          [
            11.21213,
            53.958261,
            63.79988
          ],
          [
            11.212617,
            53.958232,
            62.86933
          ],
          [
            11.212934,
            53.958199,
            62.257888
          ],
          [
            11.212845,
            53.958222,
            61.57955
          ],
          [
            11.212883,
            53.958217,
            60.975989
          ],
          [
            11.213204,
            53.958167,
            60.818778
          ],
          [
            11.213551,
            53.958112,
            60.651296
          ],
          [
            11.213956,
            53.958073,
            60.460035
          ],
          [
            11.214346,
            53.958029,
            60.274681
          ],
          [
            11.214682,
            53.957958,
            60.108201
          ],
          [
            11.215036,
            53.957931,
            59.941766
          ],
          [
            11.21545,
            53.957922,
            59.748607
          ],
          [
            11.21578,
            53.957879,
            59.591089
          ],
          [
            11.216152,
            53.957846,
            58.979751
          ],
          [
            11.216538,
            53.957811,
            58.219579
          ],
          [
            11.216912,
            53.957758,
            57.468891
          ],
          [
            11.21725,
            53.957705,
            56.788191
          ],
          [
            11.217568,
            53.957592,
            56.059816
          ],
          [
            11.217685,
            53.957407,
            55.401523
          ],
          [
            11.217724,
            53.957186,
            54.666639
          ],
          [
            11.217741,
            53.956975,
            53.968048
          ],
          [
            11.217935,
            53.956748,
            53.758769
          ],
          [
            11.217916,
            53.956554,
            53.949941
          ],
          [
            11.217877,
            53.956373,
            54.129576
          ],
          [
            11.217759,
            53.956149,
            54.362418
          ],
          [
            11.217649,
            53.955945,
            54.572977
          ],
          [
            11.217578,
            53.95576,
            54.759231
          ],
          [
            11.217455,
            53.955568,
            54.960387
          ],
          [
            11.217213,
            53.955315,
            55.245628
          ],
          [
            11.217067,
            53.95514,
            55.27671
          ],
          [
            11.216842,
            53.95497,
            54.998736
          ],
          [
            11.216667,
            53.954775,
            54.715857
          ],
          [
            11.216489,
            53.954571,
            54.421889
          ],
          [
            11.21629,
            53.954374,
            54.126967
          ],
          [
            11.216101,
            53.954175,
            53.834433
          ],
          [
            11.215887,
            53.954,
            53.557262
          ],
          [
            11.215809,
            53.953794,
            53.286568
          ],
          [
            11.215787,
            53.953602,
            53.0951
          ],
          [
            11.215764,
            53.953407,
            53.468722
          ],
          [
            11.215712,
            53.95322,
            53.830135
          ],
          [
            11.215549,
            53.953029,
            54.237931
          ],
          [
            11.215655,
            53.953218,
            54.617597
          ],
          [
            11.21567,
            53.953427,
            55.016482
          ],
          [
            11.215683,
            53.953644,
            55.430811
          ],
          [
            11.215747,
            53.953852,
            55.834035
          ],
          [
            11.215871,
            53.954042,
            56.223095
          ],
          [
            11.21609,
            53.954202,
            56.491737
          ],
          [
            11.216286,
            53.954391,
            56.491737
          ],
          [
            11.21647,
            53.954602,
            56.491737
          ],
          [
            11.216636,
            53.954781,
            56.491737
          ],
          [
            11.216825,
            53.954961,
            56.491737
          ],
          [
            11.216772,
            53.954995,
            56.491737
          ],
          [
            11.216557,
            53.954848,
            56.491737
          ]
        ]
      }
    }
  ]
}

let day28: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            11.216527,
            53.95484,
            54.95268
          ],
          [
            11.216646,
            53.95501,
            54.95268
          ],
          [
            11.216607,
            53.954836,
            54.95268
          ],
          [
            11.21685,
            53.954989,
            54.95268
          ],
          [
            11.217004,
            53.95515,
            54.95268
          ],
          [
            11.217186,
            53.955304,
            54.836329
          ],
          [
            11.21737,
            53.955477,
            54.588088
          ],
          [
            11.217511,
            53.955657,
            54.346754
          ],
          [
            11.217584,
            53.955865,
            54.088107
          ],
          [
            11.217641,
            53.956054,
            53.852218
          ],
          [
            11.2177,
            53.956272,
            53.583348
          ],
          [
            11.217748,
            53.956486,
            53.320644
          ],
          [
            11.217883,
            53.956702,
            53.040258
          ],
          [
            11.218151,
            53.956885,
            52.693006
          ],
          [
            11.218532,
            53.956805,
            52.044197
          ],
          [
            11.218882,
            53.95678,
            51.477904
          ],
          [
            11.219244,
            53.956759,
            50.894532
          ],
          [
            11.219648,
            53.956733,
            50.241152
          ],
          [
            11.219966,
            53.95671,
            49.727305
          ],
          [
            11.220251,
            53.956884,
            49.065806
          ],
          [
            11.220515,
            53.957032,
            48.479433
          ],
          [
            11.220822,
            53.956945,
            47.919913
          ],
          [
            11.221043,
            53.956796,
            48.270957
          ],
          [
            11.22123,
            53.956634,
            48.722991
          ],
          [
            11.221449,
            53.956455,
            49.232049
          ],
          [
            11.221696,
            53.956302,
            49.719536
          ],
          [
            11.221892,
            53.956164,
            50.136273
          ],
          [
            11.222125,
            53.956,
            50.63032
          ],
          [
            11.222394,
            53.955852,
            51.130507
          ],
          [
            11.222643,
            53.955691,
            51.632859
          ],
          [
            11.222865,
            53.955513,
            52.183449
          ],
          [
            11.222991,
            53.95532,
            52.783516
          ],
          [
            11.223303,
            53.955269,
            53.315826
          ],
          [
            11.223577,
            53.955154,
            53.863746
          ],
          [
            11.223813,
            53.955018,
            54.40142
          ],
          [
            11.224066,
            53.954867,
            54.988087
          ],
          [
            11.224292,
            53.95474,
            55.496712
          ],
          [
            11.224535,
            53.954611,
            56.029386
          ],
          [
            11.2248,
            53.954459,
            56.631787
          ],
          [
            11.225043,
            53.954317,
            57.210622
          ],
          [
            11.225277,
            53.954185,
            57.794565
          ],
          [
            11.225523,
            53.954036,
            58.430956
          ],
          [
            11.225732,
            53.953899,
            58.994679
          ],
          [
            11.225983,
            53.953771,
            59.592721
          ],
          [
            11.226245,
            53.953615,
            60.26391
          ],
          [
            11.226484,
            53.953464,
            60.895361
          ],
          [
            11.226751,
            53.953317,
            61.553784
          ],
          [
            11.227001,
            53.95317,
            62.190149
          ],
          [
            11.227225,
            53.95304,
            62.670749
          ],
          [
            11.227497,
            53.952882,
            63.135488
          ],
          [
            11.227752,
            53.952736,
            63.568287
          ],
          [
            11.227961,
            53.952594,
            63.95731
          ],
          [
            11.228185,
            53.952466,
            64.337168
          ],
          [
            11.228439,
            53.952331,
            64.753555
          ],
          [
            11.228683,
            53.952172,
            65.196591
          ],
          [
            11.22894,
            53.952013,
            65.650069
          ],
          [
            11.229196,
            53.951868,
            66.082126
          ],
          [
            11.229467,
            53.951714,
            65.812506
          ],
          [
            11.229703,
            53.951552,
            65.28553
          ],
          [
            11.229919,
            53.95139,
            64.776867
          ],
          [
            11.230149,
            53.95119,
            64.180416
          ],
          [
            11.230356,
            53.951003,
            63.629249
          ],
          [
            11.230514,
            53.950811,
            63.102266
          ],
          [
            11.230703,
            53.950623,
            62.562808
          ],
          [
            11.230902,
            53.950426,
            61.996798
          ],
          [
            11.231085,
            53.950245,
            61.521003
          ],
          [
            11.231249,
            53.950079,
            61.119294
          ],
          [
            11.2314,
            53.949908,
            60.716197
          ],
          [
            11.231564,
            53.949701,
            60.237989
          ],
          [
            11.231776,
            53.949496,
            59.73597
          ],
          [
            11.231988,
            53.94929,
            59.232301
          ],
          [
            11.232241,
            53.949043,
            58.629013
          ],
          [
            11.232476,
            53.948807,
            58.056933
          ],
          [
            11.232706,
            53.948578,
            57.930682
          ],
          [
            11.232913,
            53.948369,
            57.856016
          ],
          [
            11.233076,
            53.948207,
            57.797902
          ],
          [
            11.233287,
            53.947993,
            57.721552
          ],
          [
            11.233478,
            53.947764,
            57.642745
          ],
          [
            11.233666,
            53.94758,
            57.576481
          ],
          [
            11.233827,
            53.947392,
            57.511454
          ],
          [
            11.234011,
            53.947194,
            57.508925
          ],
          [
            11.234224,
            53.946978,
            58.050259
          ],
          [
            11.234421,
            53.946778,
            58.551537
          ],
          [
            11.234578,
            53.946602,
            58.982435
          ],
          [
            11.234764,
            53.946427,
            59.429802
          ],
          [
            11.234942,
            53.946276,
            59.828642
          ],
          [
            11.235113,
            53.9461,
            60.269032
          ],
          [
            11.235279,
            53.945912,
            60.728327
          ],
          [
            11.235435,
            53.945726,
            61.177878
          ],
          [
            11.235583,
            53.945533,
            61.679238
          ],
          [
            11.235734,
            53.945365,
            62.151785
          ],
          [
            11.235928,
            53.945186,
            62.679619
          ],
          [
            11.236097,
            53.945019,
            63.163228
          ],
          [
            11.236279,
            53.944848,
            63.665023
          ],
          [
            11.23644,
            53.944674,
            64.157576
          ],
          [
            11.236598,
            53.944502,
            64.64405
          ],
          [
            11.236755,
            53.944319,
            65.153986
          ],
          [
            11.23703,
            53.944186,
            65.680081
          ],
          [
            11.237242,
            53.944032,
            66.260899
          ],
          [
            11.237376,
            53.943856,
            66.837395
          ],
          [
            11.237526,
            53.943667,
            67.460348
          ],
          [
            11.237699,
            53.943499,
            68.046906
          ],
          [
            11.237864,
            53.943328,
            68.634218
          ],
          [
            11.238008,
            53.943134,
            69.269874
          ],
          [
            11.238181,
            53.942952,
            69.895299
          ],
          [
            11.238361,
            53.942767,
            70.531925
          ],
          [
            11.238557,
            53.942604,
            71.12848
          ],
          [
            11.238686,
            53.942435,
            70.993564
          ],
          [
            11.238868,
            53.942234,
            70.723129
          ],
          [
            11.239055,
            53.942058,
            70.476727
          ],
          [
            11.239218,
            53.941876,
            70.232175
          ],
          [
            11.239411,
            53.941669,
            69.951512
          ],
          [
            11.239645,
            53.941521,
            69.709954
          ],
          [
            11.239864,
            53.941327,
            69.431891
          ],
          [
            11.240082,
            53.941125,
            69.147905
          ],
          [
            11.24032,
            53.940904,
            68.691758
          ],
          [
            11.240518,
            53.940758,
            68.32156
          ],
          [
            11.240822,
            53.940551,
            67.779513
          ],
          [
            11.241104,
            53.940383,
            67.309777
          ],
          [
            11.241428,
            53.940239,
            66.834776
          ],
          [
            11.241783,
            53.940165,
            66.386245
          ],
          [
            11.242159,
            53.940218,
            65.933229
          ],
          [
            11.242527,
            53.94028,
            65.478806
          ],
          [
            11.242947,
            53.940355,
            64.260138
          ],
          [
            11.243406,
            53.940427,
            62.938968
          ],
          [
            11.243866,
            53.940463,
            61.652648
          ],
          [
            11.244306,
            53.940463,
            60.432826
          ],
          [
            11.244758,
            53.940444,
            59.176797
          ],
          [
            11.245235,
            53.940376,
            57.814528
          ],
          [
            11.245709,
            53.940235,
            56.595588
          ],
          [
            11.246161,
            53.940066,
            55.662675
          ],
          [
            11.246626,
            53.939898,
            54.710853
          ],
          [
            11.246995,
            53.939739,
            53.914105
          ],
          [
            11.247422,
            53.939522,
            52.931357
          ],
          [
            11.247805,
            53.939269,
            51.928309
          ],
          [
            11.248131,
            53.939045,
            51.267077
          ],
          [
            11.248258,
            53.938873,
            50.892818
          ],
          [
            11.248463,
            53.938731,
            50.519573
          ],
          [
            11.248695,
            53.938602,
            50.146032
          ],
          [
            11.248958,
            53.938435,
            49.693208
          ],
          [
            11.249199,
            53.938264,
            49.251356
          ],
          [
            11.249493,
            53.93808,
            48.748993
          ],
          [
            11.249679,
            53.93784,
            48.224153
          ],
          [
            11.249947,
            53.937671,
            47.826968
          ],
          [
            11.250232,
            53.937526,
            47.485366
          ],
          [
            11.250484,
            53.937352,
            47.134761
          ],
          [
            11.25077,
            53.937184,
            46.77001
          ],
          [
            11.251062,
            53.937008,
            46.392787
          ],
          [
            11.251334,
            53.936856,
            46.05425
          ],
          [
            11.251571,
            53.936732,
            45.767975
          ],
          [
            11.251839,
            53.93659,
            45.44204
          ],
          [
            11.252159,
            53.936432,
            45.522595
          ],
          [
            11.252494,
            53.936275,
            45.723185
          ],
          [
            11.252771,
            53.936128,
            45.897772
          ],
          [
            11.253075,
            53.93599,
            46.077508
          ],
          [
            11.253389,
            53.935845,
            46.264245
          ],
          [
            11.253716,
            53.935695,
            46.458361
          ],
          [
            11.254018,
            53.935559,
            46.636295
          ],
          [
            11.254286,
            53.935447,
            46.790128
          ],
          [
            11.254582,
            53.935295,
            46.851623
          ],
          [
            11.254854,
            53.935182,
            46.900354
          ],
          [
            11.255176,
            53.935042,
            46.958917
          ],
          [
            11.255464,
            53.934916,
            47.011412
          ],
          [
            11.25576,
            53.934808,
            47.062367
          ],
          [
            11.256036,
            53.934689,
            47.112642
          ],
          [
            11.256299,
            53.934587,
            47.158937
          ],
          [
            11.25661,
            53.934467,
            47.21335
          ],
          [
            11.25691,
            53.934346,
            47.301976
          ],
          [
            11.25718,
            53.934247,
            47.418476
          ],
          [
            11.257514,
            53.934121,
            47.563608
          ],
          [
            11.257808,
            53.934022,
            47.687498
          ],
          [
            11.258124,
            53.933886,
            47.83089
          ],
          [
            11.258458,
            53.93376,
            47.976029
          ],
          [
            11.258747,
            53.933665,
            48.097192
          ],
          [
            11.25906,
            53.933537,
            48.236747
          ],
          [
            11.259331,
            53.933433,
            48.355138
          ],
          [
            11.259636,
            53.933327,
            47.998137
          ],
          [
            11.259996,
            53.933227,
            47.572925
          ],
          [
            11.260294,
            53.933137,
            47.216224
          ],
          [
            11.260644,
            53.933033,
            46.79856
          ],
          [
            11.260929,
            53.933059,
            46.411639
          ],
          [
            11.260952,
            53.933241,
            46.079654
          ],
          [
            11.261043,
            53.933349,
            45.738058
          ],
          [
            11.260786,
            53.933462,
            45.395611
          ],
          [
            11.261109,
            53.933384,
            45.192176
          ],
          [
            11.26129,
            53.933241,
            45.553022
          ],
          [
            11.26108,
            53.933187,
            45.913477
          ],
          [
            11.26097,
            53.933086,
            46.250849
          ],
          [
            11.261045,
            53.932911,
            46.615595
          ],
          [
            11.261353,
            53.93282,
            46.987439
          ],
          [
            11.261664,
            53.93272,
            47.370181
          ],
          [
            11.261941,
            53.932625,
            47.716418
          ],
          [
            11.262241,
            53.932529,
            48.085152
          ],
          [
            11.262565,
            53.932448,
            48.330107
          ],
          [
            11.262844,
            53.932361,
            47.918347
          ],
          [
            11.263133,
            53.932264,
            47.484198
          ],
          [
            11.26343,
            53.932143,
            47.013213
          ],
          [
            11.263782,
            53.932016,
            46.47503
          ],
          [
            11.264104,
            53.931913,
            45.997126
          ],
          [
            11.26444,
            53.931811,
            45.504262
          ],
          [
            11.264809,
            53.931732,
            44.98977
          ],
          [
            11.265164,
            53.931676,
            44.510415
          ],
          [
            11.26548,
            53.931609,
            44.726737
          ],
          [
            11.265786,
            53.931507,
            45.128231
          ],
          [
            11.266109,
            53.931442,
            45.518172
          ],
          [
            11.266457,
            53.931409,
            45.920919
          ],
          [
            11.266792,
            53.931347,
            46.320755
          ],
          [
            11.267155,
            53.931277,
            46.755905
          ],
          [
            11.267493,
            53.931183,
            47.181629
          ],
          [
            11.267817,
            53.931092,
            47.590273
          ],
          [
            11.268131,
            53.931013,
            47.877949
          ],
          [
            11.268446,
            53.930941,
            47.77759
          ],
          [
            11.268768,
            53.930858,
            47.673186
          ],
          [
            11.269089,
            53.930762,
            47.566244
          ],
          [
            11.269361,
            53.930626,
            47.460142
          ],
          [
            11.269718,
            53.930533,
            47.343936
          ],
          [
            11.270104,
            53.930498,
            47.227934
          ],
          [
            11.270432,
            53.930412,
            47.121151
          ],
          [
            11.270745,
            53.930341,
            47.021382
          ],
          [
            11.271062,
            53.930265,
            46.869782
          ],
          [
            11.271433,
            53.930214,
            46.677987
          ],
          [
            11.271749,
            53.930093,
            46.486315
          ],
          [
            11.272112,
            53.930022,
            46.293154
          ],
          [
            11.272554,
            53.929977,
            46.06733
          ],
          [
            11.272921,
            53.929939,
            45.879686
          ],
          [
            11.273308,
            53.929891,
            45.680545
          ],
          [
            11.273647,
            53.929857,
            45.507192
          ],
          [
            11.274006,
            53.929832,
            45.463904
          ],
          [
            11.274367,
            53.9298,
            45.478576
          ],
          [
            11.274795,
            53.929768,
            45.495921
          ],
          [
            11.275155,
            53.929781,
            45.510424
          ],
          [
            11.275536,
            53.929746,
            45.525959
          ],
          [
            11.27593,
            53.929672,
            45.54273
          ],
          [
            11.276273,
            53.929629,
            45.556969
          ],
          [
            11.276656,
            53.929605,
            45.572449
          ],
          [
            11.277035,
            53.929584,
            45.681219
          ],
          [
            11.277381,
            53.929572,
            45.8099
          ],
          [
            11.277686,
            53.929549,
            45.924195
          ],
          [
            11.278059,
            53.929525,
            46.063518
          ],
          [
            11.27842,
            53.929499,
            46.198607
          ],
          [
            11.278777,
            53.929474,
            46.33209
          ],
          [
            11.279135,
            53.929448,
            46.466097
          ],
          [
            11.279451,
            53.929421,
            46.584657
          ],
          [
            11.279766,
            53.929404,
            46.702109
          ],
          [
            11.280083,
            53.929389,
            46.868978
          ],
          [
            11.280409,
            53.929388,
            47.044409
          ],
          [
            11.280755,
            53.929401,
            47.230426
          ],
          [
            11.281167,
            53.929431,
            47.453459
          ],
          [
            11.281543,
            53.929453,
            47.656329
          ],
          [
            11.281908,
            53.929476,
            47.853317
          ],
          [
            11.282277,
            53.929494,
            48.052067
          ],
          [
            11.282625,
            53.929505,
            48.239062
          ],
          [
            11.282959,
            53.929507,
            48.233354
          ],
          [
            11.283277,
            53.929517,
            47.944915
          ],
          [
            11.28366,
            53.929543,
            47.595633
          ],
          [
            11.284009,
            53.929562,
            47.278599
          ],
          [
            11.284428,
            53.929596,
            46.895974
          ],
          [
            11.284803,
            53.929658,
            46.543372
          ],
          [
            11.285147,
            53.929682,
            46.229267
          ],
          [
            11.285493,
            53.92973,
            45.907692
          ],
          [
            11.2858,
            53.929793,
            45.61168
          ],
          [
            11.286179,
            53.929847,
            46.053422
          ],
          [
            11.286516,
            53.929876,
            46.492738
          ],
          [
            11.286826,
            53.929906,
            46.899868
          ],
          [
            11.287151,
            53.929895,
            47.320641
          ],
          [
            11.287482,
            53.929865,
            47.753929
          ],
          [
            11.287796,
            53.929816,
            48.176485
          ],
          [
            11.288144,
            53.929715,
            48.677265
          ],
          [
            11.288461,
            53.929625,
            49.131448
          ],
          [
            11.288795,
            53.929504,
            49.726013
          ],
          [
            11.289025,
            53.929362,
            50.497526
          ],
          [
            11.289278,
            53.929193,
            51.385783
          ],
          [
            11.289541,
            53.929066,
            52.173225
          ],
          [
            11.289795,
            53.928934,
            52.957834
          ],
          [
            11.290061,
            53.928797,
            53.777244
          ],
          [
            11.290263,
            53.928649,
            54.523689
          ],
          [
            11.290487,
            53.928502,
            55.300158
          ],
          [
            11.290746,
            53.928367,
            56.100884
          ],
          [
            11.290994,
            53.928223,
            56.535488
          ],
          [
            11.291259,
            53.928093,
            56.375619
          ],
          [
            11.291516,
            53.928226,
            56.216597
          ],
          [
            11.291498,
            53.928418,
            56.055848
          ],
          [
            11.291704,
            53.928567,
            55.904857
          ],
          [
            11.291987,
            53.928727,
            55.722679
          ],
          [
            11.292222,
            53.928881,
            55.559994
          ],
          [
            11.292487,
            53.929055,
            55.376252
          ],
          [
            11.292777,
            53.929238,
            55.179787
          ],
          [
            11.293051,
            53.929405,
            55.003931
          ],
          [
            11.293349,
            53.929573,
            54.819862
          ],
          [
            11.293667,
            53.929705,
            54.646374
          ],
          [
            11.294051,
            53.929858,
            54.439529
          ],
          [
            11.294434,
            53.930004,
            54.236089
          ],
          [
            11.294836,
            53.930149,
            54.025881
          ],
          [
            11.295254,
            53.93027,
            53.821271
          ],
          [
            11.29562,
            53.930438,
            53.7649
          ],
          [
            11.295906,
            53.930577,
            53.719886
          ],
          [
            11.296035,
            53.930763,
            53.678462
          ],
          [
            11.296145,
            53.930959,
            53.63559
          ],
          [
            11.296111,
            53.931176,
            53.5905
          ],
          [
            11.296047,
            53.931401,
            53.543215
          ],
          [
            11.295956,
            53.93161,
            53.498758
          ],
          [
            11.295881,
            53.931795,
            53.459406
          ],
          [
            11.295923,
            53.931981,
            53.699246
          ],
          [
            11.296251,
            53.932064,
            54.03096
          ],
          [
            11.296566,
            53.932121,
            54.333721
          ],
          [
            11.296906,
            53.932157,
            54.649942
          ],
          [
            11.297284,
            53.932199,
            55.004452
          ],
          [
            11.297667,
            53.932246,
            55.363446
          ],
          [
            11.298079,
            53.932292,
            55.747364
          ],
          [
            11.298494,
            53.932359,
            56.141078
          ],
          [
            11.298874,
            53.932425,
            56.147951
          ],
          [
            11.299245,
            53.932463,
            56.015318
          ],
          [
            11.299626,
            53.932501,
            55.879238
          ],
          [
            11.299979,
            53.932529,
            55.753778
          ],
          [
            11.300349,
            53.932578,
            55.620221
          ],
          [
            11.300709,
            53.932625,
            55.490378
          ],
          [
            11.301046,
            53.932651,
            55.370685
          ],
          [
            11.301383,
            53.932691,
            55.249617
          ],
          [
            11.30173,
            53.932739,
            55.116378
          ],
          [
            11.30209,
            53.932782,
            54.965669
          ],
          [
            11.30244,
            53.932823,
            54.819241
          ],
          [
            11.30278,
            53.93286,
            54.677514
          ],
          [
            11.303121,
            53.932895,
            54.535607
          ],
          [
            11.303484,
            53.932937,
            54.383966
          ],
          [
            11.303849,
            53.932977,
            54.23178
          ],
          [
            11.304209,
            53.933009,
            54.082555
          ],
          [
            11.304529,
            53.933067,
            53.944601
          ],
          [
            11.304834,
            53.933122,
            53.914624
          ],
          [
            11.305169,
            53.933155,
            53.90898
          ],
          [
            11.305469,
            53.933202,
            53.903834
          ],
          [
            11.305855,
            53.933263,
            53.897214
          ],
          [
            11.306242,
            53.933307,
            53.890685
          ],
          [
            11.306675,
            53.933344,
            53.883436
          ],
          [
            11.307032,
            53.933405,
            53.877252
          ],
          [
            11.307343,
            53.933458,
            53.87188
          ],
          [
            11.307676,
            53.933499,
            53.972574
          ],
          [
            11.308162,
            53.933555,
            54.385293
          ],
          [
            11.308544,
            53.933592,
            54.708125
          ],
          [
            11.308921,
            53.933624,
            55.02568
          ],
          [
            11.309281,
            53.93367,
            55.332644
          ],
          [
            11.309644,
            53.933694,
            55.638598
          ],
          [
            11.309979,
            53.93375,
            55.928857
          ],
          [
            11.310314,
            53.933795,
            56.218838
          ],
          [
            11.310623,
            53.933843,
            56.191219
          ],
          [
            11.310954,
            53.933872,
            55.365187
          ],
          [
            11.311321,
            53.933915,
            54.441087
          ],
          [
            11.311681,
            53.933987,
            53.503691
          ],
          [
            11.312072,
            53.934037,
            52.513872
          ],
          [
            11.312435,
            53.934047,
            51.618161
          ],
          [
            11.312824,
            53.934098,
            50.635655
          ],
          [
            11.313261,
            53.934154,
            49.532919
          ],
          [
            11.313675,
            53.934088,
            50.066777
          ],
          [
            11.313936,
            53.933883,
            52.435826
          ],
          [
            11.314227,
            53.933734,
            54.548326
          ],
          [
            11.314505,
            53.933529,
            56.975615
          ],
          [
            11.314765,
            53.9334,
            58.85252
          ],
          [
            11.315069,
            53.933258,
            60.96497
          ],
          [
            11.315362,
            53.933178,
            63.404823
          ],
          [
            11.315579,
            53.933025,
            65.278246
          ],
          [
            11.315865,
            53.932875,
            65.047449
          ],
          [
            11.316156,
            53.932741,
            64.540788
          ],
          [
            11.316433,
            53.932597,
            64.034095
          ],
          [
            11.316728,
            53.932441,
            63.488027
          ],
          [
            11.317028,
            53.932264,
            62.905736
          ],
          [
            11.317301,
            53.932094,
            62.359392
          ],
          [
            11.317596,
            53.931921,
            61.788584
          ],
          [
            11.317931,
            53.931736,
            61.297234
          ],
          [
            11.318241,
            53.931537,
            61.190205
          ],
          [
            11.318565,
            53.931332,
            61.079481
          ],
          [
            11.318922,
            53.931127,
            60.963502
          ],
          [
            11.31927,
            53.93093,
            60.851182
          ],
          [
            11.319568,
            53.930708,
            60.739395
          ],
          [
            11.319803,
            53.930507,
            60.642929
          ],
          [
            11.320063,
            53.9303,
            59.858933
          ],
          [
            11.320316,
            53.930123,
            58.924035
          ],
          [
            11.320575,
            53.929948,
            57.985799
          ],
          [
            11.320804,
            53.929806,
            57.194014
          ],
          [
            11.321035,
            53.929682,
            56.450111
          ],
          [
            11.321392,
            53.9296,
            55.51977
          ],
          [
            11.32175,
            53.929599,
            54.666891
          ],
          [
            11.322123,
            53.929625,
            53.77325
          ],
          [
            11.322512,
            53.929641,
            53.272653
          ],
          [
            11.322871,
            53.929669,
            53.144754
          ],
          [
            11.323251,
            53.929681,
            53.010242
          ],
          [
            11.323571,
            53.929695,
            52.896899
          ],
          [
            11.323888,
            53.929704,
            52.784813
          ],
          [
            11.324215,
            53.929694,
            52.66908
          ],
          [
            11.324533,
            53.929674,
            52.556124
          ],
          [
            11.324876,
            53.929655,
            52.434451
          ],
          [
            11.325198,
            53.929637,
            52.320229
          ],
          [
            11.325527,
            53.929631,
            52.067842
          ],
          [
            11.325917,
            53.929622,
            51.638757
          ],
          [
            11.326308,
            53.929593,
            51.205618
          ],
          [
            11.326627,
            53.929548,
            50.844851
          ],
          [
            11.32693,
            53.929449,
            50.463563
          ],
          [
            11.327224,
            53.929355,
            50.09582
          ],
          [
            11.327523,
            53.929275,
            49.73486
          ],
          [
            11.327905,
            53.929161,
            49.263977
          ],
          [
            11.328225,
            53.929074,
            48.92254
          ],
          [
            11.328568,
            53.929045,
            49.054538
          ],
          [
            11.328788,
            53.929194,
            49.177699
          ],
          [
            11.328996,
            53.929366,
            49.309525
          ],
          [
            11.329243,
            53.929546,
            49.453804
          ],
          [
            11.329465,
            53.929728,
            49.593514
          ],
          [
            11.329705,
            53.929934,
            49.749269
          ],
          [
            11.329909,
            53.930118,
            49.886276
          ],
          [
            11.330128,
            53.930349,
            50.085445
          ],
          [
            11.330304,
            53.930549,
            50.476797
          ],
          [
            11.330427,
            53.930764,
            50.871187
          ],
          [
            11.330657,
            53.930956,
            51.295016
          ],
          [
            11.330838,
            53.930834,
            51.652747
          ],
          [
            11.330993,
            53.930628,
            52.044551
          ],
          [
            11.331199,
            53.93048,
            52.377346
          ],
          [
            11.331474,
            53.93035,
            52.73853
          ],
          [
            11.331756,
            53.930252,
            53.073632
          ],
          [
            11.332033,
            53.930153,
            53.448553
          ],
          [
            11.332322,
            53.930063,
            53.84069
          ],
          [
            11.332611,
            53.929966,
            54.240318
          ],
          [
            11.332905,
            53.929846,
            54.669433
          ],
          [
            11.333209,
            53.929764,
            55.071392
          ],
          [
            11.333514,
            53.929652,
            55.504266
          ],
          [
            11.333515,
            53.929668,
            55.905391
          ],
          [
            11.333495,
            53.929653,
            56.587967
          ],
          [
            11.33379,
            53.929541,
            57.05448
          ],
          [
            11.334098,
            53.929436,
            57.580371
          ],
          [
            11.334376,
            53.929349,
            58.045394
          ],
          [
            11.334692,
            53.92924,
            58.583001
          ],
          [
            11.334944,
            53.929127,
            59.04785
          ],
          [
            11.335231,
            53.928998,
            59.57897
          ],
          [
            11.335479,
            53.928879,
            60.050864
          ],
          [
            11.335656,
            53.928724,
            60.527761
          ],
          [
            11.335887,
            53.928572,
            61.040978
          ],
          [
            11.336164,
            53.928411,
            61.281602
          ],
          [
            11.336412,
            53.928275,
            61.245338
          ],
          [
            11.336666,
            53.928127,
            61.207137
          ],
          [
            11.336886,
            53.927971,
            61.170322
          ],
          [
            11.337148,
            53.927808,
            61.129325
          ],
          [
            11.337393,
            53.92768,
            61.093952
          ],
          [
            11.337632,
            53.927504,
            61.05303
          ],
          [
            11.33788,
            53.927333,
            61.012201
          ],
          [
            11.338111,
            53.927162,
            61.026852
          ],
          [
            11.33836,
            53.927012,
            61.377063
          ],
          [
            11.338607,
            53.926855,
            61.734584
          ],
          [
            11.338848,
            53.926708,
            62.076405
          ],
          [
            11.339062,
            53.926551,
            62.413401
          ],
          [
            11.339305,
            53.926392,
            62.77117
          ],
          [
            11.339558,
            53.926246,
            63.120267
          ],
          [
            11.339816,
            53.926104,
            63.468451
          ],
          [
            11.340068,
            53.925959,
            63.814856
          ],
          [
            11.340292,
            53.925804,
            64.286126
          ],
          [
            11.34052,
            53.925648,
            64.887685
          ],
          [
            11.34071,
            53.92549,
            65.45303
          ],
          [
            11.340946,
            53.925352,
            66.025901
          ],
          [
            11.341201,
            53.925206,
            66.637784
          ],
          [
            11.341395,
            53.925056,
            67.18848
          ],
          [
            11.341618,
            53.924927,
            67.730545
          ],
          [
            11.341892,
            53.924798,
            68.333998
          ],
          [
            11.342089,
            53.924659,
            68.863826
          ],
          [
            11.34233,
            53.924526,
            69.282624
          ],
          [
            11.342602,
            53.924347,
            69.460194
          ],
          [
            11.342823,
            53.924176,
            69.619157
          ],
          [
            11.343112,
            53.924026,
            69.785949
          ],
          [
            11.343315,
            53.923867,
            69.932311
          ],
          [
            11.343568,
            53.92373,
            70.081244
          ],
          [
            11.34382,
            53.923561,
            70.246602
          ],
          [
            11.344085,
            53.923408,
            70.407272
          ],
          [
            11.344319,
            53.923249,
            70.547361
          ],
          [
            11.344539,
            53.923065,
            70.406925
          ],
          [
            11.344729,
            53.92287,
            70.267407
          ],
          [
            11.344938,
            53.922688,
            70.131057
          ],
          [
            11.345205,
            53.922516,
            69.986392
          ],
          [
            11.345404,
            53.922339,
            69.854496
          ],
          [
            11.345639,
            53.922161,
            69.714581
          ],
          [
            11.34589,
            53.92199,
            69.574299
          ],
          [
            11.3461,
            53.92183,
            69.447204
          ],
          [
            11.346278,
            53.921678,
            68.705675
          ],
          [
            11.346527,
            53.921509,
            67.739171
          ],
          [
            11.346717,
            53.921289,
            66.671683
          ],
          [
            11.346881,
            53.921096,
            65.740058
          ],
          [
            11.347107,
            53.920919,
            64.783954
          ],
          [
            11.347363,
            53.920754,
            63.819105
          ],
          [
            11.34779,
            53.920574,
            62.476266
          ],
          [
            11.348281,
            53.920412,
            61.191935
          ],
          [
            11.348702,
            53.920289,
            60.275447
          ],
          [
            11.349008,
            53.920174,
            59.568609
          ],
          [
            11.349308,
            53.92002,
            58.791902
          ],
          [
            11.349628,
            53.919991,
            57.963679
          ],
          [
            11.349816,
            53.92018,
            57.230794
          ],
          [
            11.349852,
            53.920374,
            56.546049
          ],
          [
            11.349949,
            53.920601,
            55.768957
          ],
          [
            11.350007,
            53.92079,
            55.611686
          ],
          [
            11.350128,
            53.921011,
            55.461888
          ],
          [
            11.350264,
            53.921184,
            55.338425
          ],
          [
            11.350294,
            53.921381,
            55.205892
          ],
          [
            11.350436,
            53.92156,
            55.078469
          ],
          [
            11.350647,
            53.921769,
            54.921656
          ],
          [
            11.350829,
            53.921946,
            54.787828
          ],
          [
            11.351086,
            53.922157,
            54.620315
          ],
          [
            11.351363,
            53.922413,
            54.287094
          ],
          [
            11.351643,
            53.922671,
            53.900309
          ],
          [
            11.351878,
            53.922914,
            53.547035
          ],
          [
            11.352061,
            53.92312,
            53.25236
          ],
          [
            11.352258,
            53.923308,
            52.97296
          ],
          [
            11.352489,
            53.923514,
            52.660856
          ],
          [
            11.352854,
            53.923727,
            52.257456
          ],
          [
            11.353245,
            53.923936,
            51.388263
          ],
          [
            11.353634,
            53.924151,
            50.510091
          ],
          [
            11.354042,
            53.924368,
            49.605169
          ],
          [
            11.354419,
            53.9246,
            48.706923
          ],
          [
            11.354796,
            53.924808,
            47.856536
          ],
          [
            11.355171,
            53.925027,
            47.311624
          ],
          [
            11.355526,
            53.925261,
            47.446126
          ],
          [
            11.35588,
            53.925478,
            47.575155
          ],
          [
            11.356243,
            53.925688,
            47.703557
          ],
          [
            11.356556,
            53.925879,
            47.81732
          ],
          [
            11.35688,
            53.926051,
            47.927451
          ],
          [
            11.357196,
            53.926189,
            48.026775
          ],
          [
            11.35751,
            53.926281,
            47.784379
          ],
          [
            11.357864,
            53.926274,
            47.474867
          ],
          [
            11.358213,
            53.926174,
            47.148362
          ],
          [
            11.35859,
            53.92607,
            46.798211
          ],
          [
            11.359024,
            53.925957,
            46.399105
          ],
          [
            11.359463,
            53.92592,
            46.018203
          ],
          [
            11.359669,
            53.926082,
            45.712765
          ],
          [
            11.359697,
            53.926296,
            45.445092
          ],
          [
            11.35975,
            53.926512,
            45.323386
          ],
          [
            11.359912,
            53.926721,
            45.195068
          ],
          [
            11.360129,
            53.926945,
            45.051085
          ],
          [
            11.360334,
            53.927133,
            44.926182
          ],
          [
            11.360499,
            53.927345,
            44.796141
          ],
          [
            11.36073,
            53.927534,
            44.666265
          ],
          [
            11.360876,
            53.927762,
            44.529518
          ],
          [
            11.360914,
            53.927978,
            44.420182
          ],
          [
            11.360969,
            53.928192,
            44.323457
          ],
          [
            11.361104,
            53.928417,
            44.216792
          ],
          [
            11.361303,
            53.928606,
            44.117363
          ],
          [
            11.361635,
            53.928617,
            44.029785
          ],
          [
            11.361941,
            53.928566,
            43.946244
          ],
          [
            11.362281,
            53.928477,
            43.848522
          ],
          [
            11.362679,
            53.928399,
            43.738311
          ],
          [
            11.363074,
            53.928331,
            43.508471
          ],
          [
            11.363458,
            53.928306,
            43.05241
          ],
          [
            11.363819,
            53.928314,
            42.626464
          ],
          [
            11.364189,
            53.928304,
            42.189798
          ],
          [
            11.364563,
            53.928335,
            41.743178
          ],
          [
            11.36487,
            53.928378,
            41.371147
          ],
          [
            11.365232,
            53.928433,
            40.930385
          ],
          [
            11.365603,
            53.928497,
            40.47462
          ],
          [
            11.365991,
            53.92851,
            40.100295
          ],
          [
            11.366346,
            53.928511,
            40.423473
          ],
          [
            11.366731,
            53.928477,
            40.777595
          ],
          [
            11.367103,
            53.928453,
            41.117979
          ],
          [
            11.367477,
            53.928436,
            41.459147
          ],
          [
            11.367833,
            53.928397,
            41.788516
          ],
          [
            11.368177,
            53.928365,
            42.105478
          ],
          [
            11.368513,
            53.928336,
            42.414417
          ],
          [
            11.368861,
            53.92831,
            42.73435
          ],
          [
            11.369246,
            53.928291,
            43.165123
          ],
          [
            11.369649,
            53.92827,
            43.653157
          ],
          [
            11.369959,
            53.928278,
            44.025727
          ],
          [
            11.370255,
            53.928284,
            44.401839
          ],
          [
            11.370578,
            53.928214,
            44.816613
          ],
          [
            11.370892,
            53.928109,
            45.251132
          ],
          [
            11.371208,
            53.928047,
            45.651066
          ],
          [
            11.371535,
            53.927972,
            46.073229
          ],
          [
            11.37195,
            53.927869,
            46.460214
          ],
          [
            11.37236,
            53.927764,
            46.205135
          ],
          [
            11.372758,
            53.927656,
            45.955307
          ],
          [
            11.373032,
            53.927572,
            45.778414
          ],
          [
            11.373323,
            53.927478,
            45.58918
          ],
          [
            11.373682,
            53.927384,
            45.365193
          ],
          [
            11.374017,
            53.927314,
            45.162506
          ],
          [
            11.374346,
            53.927226,
            44.956335
          ],
          [
            11.374697,
            53.92719,
            44.744086
          ],
          [
            11.375026,
            53.927217,
            44.49308
          ],
          [
            11.375339,
            53.927237,
            44.255721
          ],
          [
            11.375697,
            53.927253,
            43.985229
          ],
          [
            11.376092,
            53.927294,
            43.682832
          ],
          [
            11.376493,
            53.927319,
            43.378696
          ],
          [
            11.376862,
            53.92734,
            43.099451
          ],
          [
            11.377178,
            53.927375,
            42.857209
          ],
          [
            11.377496,
            53.927393,
            42.616345
          ],
          [
            11.377821,
            53.927408,
            42.740233
          ],
          [
            11.37823,
            53.92743,
            43.614337
          ],
          [
            11.378627,
            53.927444,
            44.457699
          ],
          [
            11.378975,
            53.927473,
            45.203123
          ],
          [
            11.379309,
            53.927501,
            45.920281
          ],
          [
            11.379654,
            53.927497,
            46.651922
          ],
          [
            11.379995,
            53.927533,
            47.386647
          ],
          [
            11.380307,
            53.927534,
            48.052461
          ],
          [
            11.380628,
            53.927555,
            48.737255
          ],
          [
            11.381021,
            53.927579,
            48.983858
          ],
          [
            11.381338,
            53.927608,
            49.026935
          ],
          [
            11.381744,
            53.927627,
            49.081481
          ],
          [
            11.382141,
            53.927621,
            49.134576
          ],
          [
            11.3825,
            53.927644,
            49.182903
          ],
          [
            11.382932,
            53.927647,
            49.240631
          ],
          [
            11.383356,
            53.927608,
            49.298178
          ],
          [
            11.383718,
            53.927601,
            49.346722
          ],
          [
            11.384085,
            53.927606,
            49.605889
          ],
          [
            11.384504,
            53.927607,
            49.933183
          ],
          [
            11.38491,
            53.927603,
            50.248494
          ],
          [
            11.3853,
            53.927568,
            50.554961
          ],
          [
            11.385643,
            53.927519,
            50.82926
          ],
          [
            11.385972,
            53.927453,
            51.099148
          ],
          [
            11.386332,
            53.9274,
            51.387469
          ],
          [
            11.386651,
            53.92734,
            51.647638
          ],
          [
            11.386976,
            53.927268,
            51.690673
          ],
          [
            11.387293,
            53.927225,
            51.646372
          ],
          [
            11.387695,
            53.927215,
            51.592214
          ],
          [
            11.388077,
            53.92721,
            51.540753
          ],
          [
            11.38842,
            53.927179,
            51.494114
          ],
          [
            11.388815,
            53.927129,
            51.439823
          ],
          [
            11.389161,
            53.927141,
            51.393086
          ],
          [
            11.389554,
            53.927132,
            51.340237
          ],
          [
            11.389933,
            53.92717,
            51.188193
          ],
          [
            11.390294,
            53.927232,
            50.937339
          ],
          [
            11.390669,
            53.927238,
            50.678464
          ],
          [
            11.390953,
            53.927113,
            50.441932
          ],
          [
            11.391237,
            53.927023,
            50.225047
          ],
          [
            11.391624,
            53.926976,
            49.961397
          ],
          [
            11.391986,
            53.926933,
            49.715044
          ],
          [
            11.392369,
            53.926897,
            49.456281
          ],
          [
            11.392776,
            53.926833,
            49.347007
          ],
          [
            11.393143,
            53.92671,
            49.543759
          ],
          [
            11.393438,
            53.926558,
            49.726439
          ],
          [
            11.39366,
            53.926373,
            49.905839
          ],
          [
            11.393828,
            53.926176,
            50.080276
          ],
          [
            11.393977,
            53.925962,
            50.263638
          ],
          [
            11.394147,
            53.925731,
            50.462948
          ],
          [
            11.394328,
            53.925494,
            50.668567
          ],
          [
            11.394448,
            53.925283,
            50.443715
          ],
          [
            11.394545,
            53.925098,
            50.175672
          ],
          [
            11.394631,
            53.92489,
            49.878917
          ],
          [
            11.394773,
            53.924703,
            49.595124
          ],
          [
            11.394896,
            53.924503,
            49.300528
          ],
          [
            11.395012,
            53.924286,
            48.985537
          ],
          [
            11.395048,
            53.92406,
            48.670769
          ],
          [
            11.394998,
            53.923844,
            48.368752
          ],
          [
            11.394975,
            53.923627,
            48.278321
          ],
          [
            11.394897,
            53.923443,
            48.405738
          ],
          [
            11.394808,
            53.923259,
            48.534302
          ],
          [
            11.394741,
            53.923064,
            48.667689
          ],
          [
            11.394824,
            53.922851,
            48.816275
          ],
          [
            11.395009,
            53.922673,
            48.956468
          ],
          [
            11.395203,
            53.922512,
            49.088801
          ],
          [
            11.395409,
            53.922331,
            49.234969
          ],
          [
            11.395588,
            53.92217,
            49.363996
          ],
          [
            11.395816,
            53.921992,
            49.946193
          ],
          [
            11.395995,
            53.921815,
            50.697088
          ],
          [
            11.396203,
            53.921662,
            51.406283
          ],
          [
            11.396399,
            53.921505,
            52.111221
          ],
          [
            11.396607,
            53.921338,
            52.861033
          ],
          [
            11.396831,
            53.921146,
            53.704297
          ],
          [
            11.397041,
            53.920967,
            54.491376
          ],
          [
            11.397222,
            53.920808,
            55.184915
          ],
          [
            11.397425,
            53.920646,
            55.913377
          ],
          [
            11.397628,
            53.920493,
            55.888904
          ],
          [
            11.397833,
            53.920339,
            55.855188
          ],
          [
            11.398025,
            53.920134,
            55.814791
          ],
          [
            11.398135,
            53.919946,
            55.780423
          ],
          [
            11.398233,
            53.919755,
            55.746044
          ],
          [
            11.398314,
            53.919536,
            55.707408
          ],
          [
            11.398387,
            53.919348,
            55.674166
          ],
          [
            11.398469,
            53.919152,
            55.63932
          ],
          [
            11.39856,
            53.918941,
            55.58727
          ],
          [
            11.398649,
            53.918752,
            55.505503
          ],
          [
            11.398724,
            53.918575,
            55.429438
          ],
          [
            11.398794,
            53.918392,
            55.35125
          ],
          [
            11.398854,
            53.918209,
            55.273477
          ],
          [
            11.398927,
            53.91801,
            55.188478
          ],
          [
            11.398975,
            53.917818,
            55.107513
          ],
          [
            11.399061,
            53.917627,
            55.02467
          ],
          [
            11.399146,
            53.917416,
            54.934255
          ],
          [
            11.399214,
            53.91723,
            54.86393
          ],
          [
            11.399498,
            53.917114,
            54.879747
          ],
          [
            11.399931,
            53.917088,
            54.899312
          ],
          [
            11.400332,
            53.9171,
            54.917301
          ],
          [
            11.400716,
            53.91713,
            54.934657
          ],
          [
            11.401062,
            53.917155,
            54.950315
          ],
          [
            11.40143,
            53.91717,
            54.966884
          ],
          [
            11.401849,
            53.917183,
            54.985732
          ],
          [
            11.40226,
            53.9172,
            54.88515
          ],
          [
            11.402646,
            53.917218,
            54.482018
          ],
          [
            11.403053,
            53.917246,
            54.055223
          ],
          [
            11.403454,
            53.917265,
            53.636313
          ],
          [
            11.403801,
            53.917281,
            53.273012
          ],
          [
            11.404163,
            53.917287,
            52.895907
          ],
          [
            11.404573,
            53.917298,
            52.467255
          ],
          [
            11.40494,
            53.917297,
            52.084263
          ],
          [
            11.405313,
            53.917408,
            51.444344
          ],
          [
            11.40558,
            53.917524,
            50.69732
          ],
          [
            11.405881,
            53.917662,
            49.838148
          ],
          [
            11.406095,
            53.917811,
            49.091478
          ],
          [
            11.406323,
            53.918009,
            48.17718
          ],
          [
            11.406505,
            53.918216,
            47.286396
          ],
          [
            11.406646,
            53.91838,
            46.583638
          ],
          [
            11.406866,
            53.91859,
            45.633135
          ],
          [
            11.407117,
            53.918713,
            44.93548
          ],
          [
            11.40749,
            53.918777,
            44.744202
          ],
          [
            11.407872,
            53.918823,
            44.555687
          ],
          [
            11.408267,
            53.918799,
            44.362989
          ],
          [
            11.40857,
            53.918644,
            44.166694
          ],
          [
            11.408803,
            53.918476,
            43.988554
          ],
          [
            11.409103,
            53.918339,
            43.805053
          ],
          [
            11.409417,
            53.918203,
            43.616803
          ],
          [
            11.409617,
            53.918055,
            43.473325
          ],
          [
            11.409813,
            53.917898,
            43.49843
          ],
          [
            11.410126,
            53.917847,
            43.522127
          ],
          [
            11.410372,
            53.917727,
            43.545415
          ],
          [
            11.410333,
            53.917737,
            43.573518
          ],
          [
            11.410085,
            53.91786,
            43.597164
          ],
          [
            11.409844,
            53.917783,
            43.625707
          ],
          [
            11.410072,
            53.917627,
            43.651416
          ],
          [
            11.410345,
            53.917515,
            43.675657
          ],
          [
            11.410621,
            53.91738,
            43.80486
          ],
          [
            11.41089,
            53.91726,
            44.16388
          ],
          [
            11.411265,
            53.917108,
            44.649083
          ],
          [
            11.411513,
            53.916992,
            44.985986
          ],
          [
            11.411803,
            53.916875,
            45.360346
          ],
          [
            11.412083,
            53.916746,
            45.739411
          ],
          [
            11.412365,
            53.916635,
            46.10067
          ],
          [
            11.412678,
            53.916494,
            46.520026
          ],
          [
            11.412969,
            53.91636,
            46.913459
          ],
          [
            11.413271,
            53.916237,
            46.761856
          ],
          [
            11.413576,
            53.916103,
            46.558853
          ],
          [
            11.413948,
            53.91596,
            46.3221
          ],
          [
            11.414235,
            53.915852,
            46.140625
          ],
          [
            11.414525,
            53.915732,
            45.951306
          ],
          [
            11.414837,
            53.915604,
            45.748701
          ],
          [
            11.415205,
            53.915488,
            45.526298
          ],
          [
            11.41551,
            53.915381,
            45.336895
          ],
          [
            11.415841,
            53.915269,
            45.413644
          ],
          [
            11.416159,
            53.91517,
            45.516764
          ],
          [
            11.416447,
            53.915055,
            45.616516
          ],
          [
            11.416764,
            53.914962,
            45.718103
          ],
          [
            11.41709,
            53.914859,
            45.824235
          ],
          [
            11.417428,
            53.914777,
            45.929114
          ],
          [
            11.417751,
            53.914675,
            46.034336
          ],
          [
            11.418063,
            53.914586,
            46.133889
          ],
          [
            11.418374,
            53.914498,
            46.351334
          ],
          [
            11.418697,
            53.914426,
            46.731337
          ],
          [
            11.419006,
            53.914361,
            47.093868
          ],
          [
            11.419355,
            53.914301,
            47.494858
          ],
          [
            11.419719,
            53.914221,
            47.922564
          ],
          [
            11.420041,
            53.91415,
            48.300907
          ],
          [
            11.420409,
            53.914113,
            48.711725
          ],
          [
            11.420788,
            53.914026,
            49.160323
          ],
          [
            11.421104,
            53.913946,
            49.538798
          ],
          [
            11.421392,
            53.913865,
            49.056715
          ],
          [
            11.421708,
            53.91375,
            48.456983
          ],
          [
            11.422012,
            53.913628,
            47.868899
          ],
          [
            11.422358,
            53.913569,
            47.290408
          ],
          [
            11.4227,
            53.913469,
            46.678052
          ],
          [
            11.423061,
            53.913418,
            46.085158
          ],
          [
            11.423432,
            53.913314,
            45.425726
          ],
          [
            11.423863,
            53.913252,
            44.70093
          ],
          [
            11.424224,
            53.913161,
            45.517002
          ],
          [
            11.424527,
            53.913088,
            46.252243
          ],
          [
            11.424892,
            53.912998,
            47.139149
          ],
          [
            11.425238,
            53.912929,
            47.958027
          ],
          [
            11.425544,
            53.912833,
            48.734895
          ],
          [
            11.425888,
            53.912738,
            49.586178
          ],
          [
            11.426299,
            53.912656,
            50.558835
          ],
          [
            11.426635,
            53.912584,
            51.359999
          ],
          [
            11.426984,
            53.912495,
            51.433946
          ],
          [
            11.427285,
            53.912427,
            51.34989
          ],
          [
            11.427592,
            53.912367,
            51.263067
          ],
          [
            11.4279,
            53.912321,
            51.180403
          ],
          [
            11.428217,
            53.912263,
            51.093664
          ],
          [
            11.428513,
            53.912165,
            51.005397
          ],
          [
            11.428767,
            53.912028,
            50.91583
          ],
          [
            11.42885,
            53.911836,
            50.825885
          ],
          [
            11.428844,
            53.911633,
            50.735891
          ],
          [
            11.42878,
            53.911444,
            50.720972
          ],
          [
            11.428785,
            53.911249,
            50.720856
          ],
          [
            11.429125,
            53.911157,
            50.720731
          ],
          [
            11.429396,
            53.911037,
            50.720618
          ],
          [
            11.429667,
            53.910899,
            50.720499
          ],
          [
            11.429848,
            53.910718,
            50.72038
          ],
          [
            11.429966,
            53.910515,
            50.720258
          ],
          [
            11.430083,
            53.910309,
            50.720136
          ],
          [
            11.43018,
            53.910083,
            50.825731
          ],
          [
            11.430301,
            53.90985,
            51.176346
          ],
          [
            11.430394,
            53.909621,
            51.514952
          ],
          [
            11.43036,
            53.909432,
            51.788282
          ],
          [
            11.430421,
            53.909223,
            52.09324
          ],
          [
            11.430459,
            53.908991,
            52.428463
          ],
          [
            11.430502,
            53.90877,
            52.749289
          ],
          [
            11.430536,
            53.908578,
            53.027104
          ],
          [
            11.430516,
            53.908377,
            53.305984
          ],
          [
            11.430544,
            53.908153,
            53.295036
          ],
          [
            11.430561,
            53.907939,
            53.284592
          ],
          [
            11.430565,
            53.907688,
            53.272356
          ],
          [
            11.430519,
            53.907425,
            53.259469
          ],
          [
            11.430431,
            53.907181,
            53.247309
          ],
          [
            11.430376,
            53.90696,
            53.236387
          ],
          [
            11.430293,
            53.906741,
            53.225414
          ],
          [
            11.430253,
            53.906551,
            53.089453
          ],
          [
            11.430217,
            53.906339,
            52.570214
          ],
          [
            11.43018,
            53.90612,
            52.033033
          ],
          [
            11.430115,
            53.905904,
            51.49854
          ],
          [
            11.43009,
            53.905715,
            51.036726
          ],
          [
            11.430052,
            53.905486,
            50.47571
          ],
          [
            11.429997,
            53.905241,
            49.873673
          ],
          [
            11.429981,
            53.905027,
            49.351733
          ],
          [
            11.429936,
            53.904811,
            48.848484
          ],
          [
            11.429893,
            53.904585,
            49.2284
          ],
          [
            11.429841,
            53.904333,
            49.652427
          ],
          [
            11.429785,
            53.904134,
            49.991024
          ],
          [
            11.429769,
            53.903931,
            50.330597
          ],
          [
            11.429735,
            53.90373,
            50.669008
          ],
          [
            11.429738,
            53.903511,
            51.035582
          ],
          [
            11.429695,
            53.903317,
            51.362541
          ],
          [
            11.429659,
            53.903126,
            51.683567
          ],
          [
            11.429598,
            53.902929,
            51.920757
          ],
          [
            11.429508,
            53.902722,
            52.081506
          ],
          [
            11.42935,
            53.902516,
            52.251528
          ],
          [
            11.429172,
            53.902296,
            52.434858
          ],
          [
            11.428988,
            53.902057,
            52.632407
          ],
          [
            11.428834,
            53.901862,
            52.794286
          ],
          [
            11.428666,
            53.901659,
            52.964198
          ],
          [
            11.428535,
            53.901466,
            53.12051
          ],
          [
            11.428381,
            53.901267,
            53.229433
          ],
          [
            11.428234,
            53.901079,
            53.290536
          ],
          [
            11.428123,
            53.900892,
            53.349006
          ],
          [
            11.428038,
            53.900708,
            53.405415
          ],
          [
            11.427922,
            53.900487,
            53.473691
          ],
          [
            11.427848,
            53.900277,
            53.537249
          ],
          [
            11.427885,
            53.900061,
            53.601322
          ],
          [
            11.427946,
            53.899855,
            53.663095
          ],
          [
            11.428019,
            53.899676,
            53.717472
          ],
          [
            11.428089,
            53.899455,
            53.970068
          ],
          [
            11.428174,
            53.899247,
            54.231041
          ],
          [
            11.428226,
            53.89905,
            54.474615
          ],
          [
            11.428334,
            53.898888,
            54.703917
          ],
          [
            11.428343,
            53.89868,
            54.958812
          ],
          [
            11.428309,
            53.898481,
            55.203305
          ],
          [
            11.428215,
            53.898282,
            55.454944
          ],
          [
            11.428161,
            53.898092,
            55.689717
          ],
          [
            11.428049,
            53.897893,
            55.991191
          ],
          [
            11.42796,
            53.897697,
            56.622818
          ],
          [
            11.427834,
            53.897506,
            57.259047
          ],
          [
            11.427667,
            53.897228,
            58.175019
          ],
          [
            11.427449,
            53.897076,
            58.795026
          ],
          [
            11.427537,
            53.896912,
            59.411501
          ],
          [
            11.428012,
            53.896839,
            60.356141
          ],
          [
            11.428345,
            53.89675,
            61.025388
          ],
          [
            11.428634,
            53.896647,
            61.410183
          ],
          [
            11.428948,
            53.896528,
            61.003857
          ],
          [
            11.429232,
            53.896426,
            60.641935
          ],
          [
            11.429591,
            53.896294,
            60.180459
          ],
          [
            11.429906,
            53.896209,
            59.803406
          ],
          [
            11.430244,
            53.896107,
            59.389993
          ],
          [
            11.430591,
            53.895994,
            58.958482
          ],
          [
            11.430943,
            53.895852,
            58.492628
          ],
          [
            11.431324,
            53.895712,
            58.179203
          ],
          [
            11.431619,
            53.895518,
            58.189609
          ],
          [
            11.431895,
            53.895372,
            58.198616
          ],
          [
            11.432035,
            53.895574,
            58.207333
          ],
          [
            11.431857,
            53.895415,
            58.214968
          ],
          [
            11.431716,
            53.895229,
            58.2231
          ],
          [
            11.431622,
            53.895013,
            58.231953
          ],
          [
            11.431531,
            53.894807,
            58.240406
          ],
          [
            11.431624,
            53.894622,
            58.075715
          ],
          [
            11.431971,
            53.894582,
            57.438406
          ],
          [
            11.432349,
            53.894541,
            56.74478
          ],
          [
            11.43266,
            53.894496,
            56.167229
          ],
          [
            11.433042,
            53.894455,
            55.46589
          ],
          [
            11.433456,
            53.89442,
            54.710956
          ],
          [
            11.433868,
            53.894383,
            53.959885
          ],
          [
            11.434237,
            53.894363,
            53.291358
          ],
          [
            11.434625,
            53.894249,
            52.508144
          ],
          [
            11.434971,
            53.894221,
            51.880505
          ],
          [
            11.435388,
            53.894179,
            51.119523
          ],
          [
            11.435826,
            53.894148,
            50.326555
          ],
          [
            11.436213,
            53.894087,
            49.606577
          ],
          [
            11.436639,
            53.894078,
            48.840466
          ],
          [
            11.437081,
            53.894099,
            48.043307
          ],
          [
            11.437492,
            53.894094,
            47.304381
          ],
          [
            11.437875,
            53.8941,
            47.146691
          ],
          [
            11.43828,
            53.894118,
            47.019773
          ],
          [
            11.438564,
            53.894029,
            46.911853
          ],
          [
            11.438966,
            53.894179,
            46.757337
          ],
          [
            11.439324,
            53.894215,
            46.643846
          ],
          [
            11.43968,
            53.894213,
            46.532194
          ],
          [
            11.440044,
            53.894224,
            46.417777
          ],
          [
            11.440351,
            53.894297,
            46.314312
          ],
          [
            11.440624,
            53.894369,
            46.084418
          ],
          [
            11.440994,
            53.894384,
            45.815559
          ],
          [
            11.441413,
            53.894383,
            45.511747
          ],
          [
            11.44182,
            53.89434,
            45.211189
          ],
          [
            11.442211,
            53.894276,
            44.916999
          ],
          [
            11.442553,
            53.894221,
            44.659827
          ],
          [
            11.442885,
            53.894175,
            44.412566
          ],
          [
            11.443235,
            53.894128,
            44.151965
          ],
          [
            11.443585,
            53.894079,
            44.350527
          ],
          [
            11.443918,
            53.894034,
            44.662436
          ],
          [
            11.444337,
            53.893967,
            45.059307
          ],
          [
            11.444712,
            53.89391,
            45.412998
          ],
          [
            11.445039,
            53.893873,
            45.716996
          ],
          [
            11.445412,
            53.893799,
            46.07625
          ],
          [
            11.445801,
            53.893755,
            46.437842
          ],
          [
            11.446176,
            53.893711,
            46.787712
          ],
          [
            11.446529,
            53.893673,
            46.848483
          ],
          [
            11.446837,
            53.893634,
            46.809318
          ],
          [
            11.447184,
            53.893573,
            46.764225
          ],
          [
            11.447509,
            53.89353,
            46.722783
          ],
          [
            11.447996,
            53.893447,
            46.659758
          ],
          [
            11.448396,
            53.893406,
            46.609284
          ],
          [
            11.448801,
            53.893333,
            46.556621
          ],
          [
            11.449111,
            53.893278,
            46.516373
          ],
          [
            11.449425,
            53.893235,
            47.018458
          ],
          [
            11.449746,
            53.893191,
            47.874759
          ],
          [
            11.450093,
            53.893153,
            48.79312
          ],
          [
            11.450429,
            53.893099,
            49.698012
          ],
          [
            11.450746,
            53.893053,
            50.546469
          ],
          [
            11.451089,
            53.893014,
            51.454109
          ],
          [
            11.451459,
            53.892975,
            52.430724
          ],
          [
            11.451806,
            53.892932,
            53.352192
          ],
          [
            11.452163,
            53.892893,
            54.295855
          ],
          [
            11.452519,
            53.892849,
            55.015258
          ],
          [
            11.452859,
            53.892813,
            55.662563
          ],
          [
            11.453176,
            53.892766,
            56.27509
          ],
          [
            11.453511,
            53.892723,
            56.91755
          ],
          [
            11.45389,
            53.892667,
            57.649962
          ],
          [
            11.454271,
            53.892604,
            58.391482
          ],
          [
            11.454643,
            53.892546,
            59.112566
          ],
          [
            11.455027,
            53.892476,
            59.865782
          ],
          [
            11.455379,
            53.89244,
            59.69639
          ],
          [
            11.455692,
            53.892525,
            58.883813
          ],
          [
            11.455988,
            53.892673,
            58.025458
          ],
          [
            11.456298,
            53.892857,
            57.053093
          ],
          [
            11.456614,
            53.893008,
            56.153575
          ],
          [
            11.456925,
            53.893151,
            55.280574
          ],
          [
            11.457236,
            53.893306,
            54.379737
          ],
          [
            11.457503,
            53.893457,
            53.557884
          ],
          [
            11.457788,
            53.893625,
            52.39011
          ],
          [
            11.458074,
            53.893771,
            51.240518
          ],
          [
            11.458366,
            53.893931,
            50.027979
          ],
          [
            11.458664,
            53.894103,
            48.760578
          ],
          [
            11.458939,
            53.894274,
            47.545973
          ],
          [
            11.45918,
            53.894436,
            46.433821
          ],
          [
            11.459376,
            53.894601,
            45.395137
          ],
          [
            11.459595,
            53.894852,
            44.168182
          ],
          [
            11.459779,
            53.895046,
            44.366449
          ],
          [
            11.460013,
            53.895204,
            44.553373
          ],
          [
            11.460212,
            53.895393,
            44.751975
          ],
          [
            11.460383,
            53.895554,
            44.923317
          ],
          [
            11.460534,
            53.895758,
            45.121973
          ],
          [
            11.460599,
            53.895947,
            45.294027
          ],
          [
            11.460835,
            53.896182,
            45.537423
          ],
          [
            11.460965,
            53.89637,
            45.718517
          ],
          [
            11.461132,
            53.89653,
            45.556065
          ],
          [
            11.46142,
            53.896638,
            45.339499
          ],
          [
            11.461688,
            53.896746,
            45.133696
          ],
          [
            11.46197,
            53.896872,
            44.910973
          ],
          [
            11.462283,
            53.896953,
            44.695877
          ],
          [
            11.462611,
            53.896988,
            44.485029
          ],
          [
            11.462955,
            53.89701,
            44.267382
          ],
          [
            11.463291,
            53.897034,
            44.054138
          ],
          [
            11.463602,
            53.89706,
            43.856159
          ],
          [
            11.463933,
            53.897047,
            43.829032
          ],
          [
            11.464272,
            53.89705,
            43.845618
          ],
          [
            11.464599,
            53.897055,
            43.861578
          ],
          [
            11.464953,
            53.897085,
            43.87903
          ],
          [
            11.465314,
            53.897094,
            43.896865
          ],
          [
            11.465672,
            53.897092,
            43.914383
          ],
          [
            11.465981,
            53.897076,
            43.929576
          ],
          [
            11.466291,
            53.897043,
            43.944952
          ],
          [
            11.466644,
            53.897025,
            43.962242
          ],
          [
            11.466801,
            53.8972,
            44.10179
          ],
          [
            11.466932,
            53.897377,
            44.260114
          ],
          [
            11.467181,
            53.897521,
            44.428502
          ],
          [
            11.467562,
            53.897664,
            44.652144
          ],
          [
            11.467905,
            53.897705,
            44.820989
          ],
          [
            11.468176,
            53.897671,
            44.975255
          ],
          [
            11.468356,
            53.897867,
            45.157498
          ],
          [
            11.468606,
            53.898057,
            45.354731
          ],
          [
            11.468959,
            53.898161,
            45.406279
          ],
          [
            11.469249,
            53.898293,
            45.359251
          ],
          [
            11.469382,
            53.898466,
            45.317881
          ],
          [
            11.469486,
            53.898642,
            45.277303
          ],
          [
            11.469508,
            53.898848,
            45.232312
          ],
          [
            11.469323,
            53.899013,
            45.187093
          ],
          [
            11.469423,
            53.899179,
            45.145148
          ],
          [
            11.469637,
            53.899371,
            45.095129
          ],
          [
            11.469763,
            53.89954,
            45.054714
          ],
          [
            11.469903,
            53.89973,
            45.063093
          ],
          [
            11.470078,
            53.89989,
            45.085941
          ],
          [
            11.470255,
            53.900048,
            45.108649
          ],
          [
            11.470456,
            53.900222,
            45.133915
          ],
          [
            11.470654,
            53.900394,
            45.158842
          ],
          [
            11.470858,
            53.900594,
            45.186834
          ],
          [
            11.471082,
            53.900792,
            45.21538
          ],
          [
            11.471276,
            53.900948,
            45.238575
          ],
          [
            11.471537,
            53.901132,
            45.221764
          ],
          [
            11.47185,
            53.901225,
            45.098709
          ],
          [
            11.472142,
            53.901352,
            44.97082
          ],
          [
            11.472293,
            53.901547,
            44.843204
          ],
          [
            11.472259,
            53.901739,
            44.727214
          ],
          [
            11.47216,
            53.901948,
            44.598603
          ],
          [
            11.471988,
            53.902134,
            44.472945
          ],
          [
            11.471877,
            53.902358,
            44.334681
          ],
          [
            11.471775,
            53.902556,
            44.21193
          ],
          [
            11.471717,
            53.902743,
            44.187023
          ],
          [
            11.471611,
            53.90295,
            44.177275
          ],
          [
            11.471484,
            53.903143,
            44.168246
          ],
          [
            11.471334,
            53.90332,
            44.15961
          ],
          [
            11.471157,
            53.903496,
            44.150687
          ],
          [
            11.47101,
            53.903666,
            44.142358
          ],
          [
            11.470831,
            53.903828,
            44.133926
          ],
          [
            11.470633,
            53.904,
            44.12486
          ],
          [
            11.470492,
            53.90419,
            44.115811
          ],
          [
            11.470338,
            53.90436,
            44.355469
          ],
          [
            11.470154,
            53.904539,
            44.622559
          ],
          [
            11.469973,
            53.904753,
            44.927477
          ],
          [
            11.469765,
            53.904957,
            45.230992
          ],
          [
            11.469582,
            53.905171,
            45.536618
          ],
          [
            11.469449,
            53.90538,
            45.821836
          ],
          [
            11.469361,
            53.905603,
            46.113898
          ],
          [
            11.469294,
            53.905816,
            46.390093
          ],
          [
            11.469271,
            53.906036,
            46.326173
          ],
          [
            11.469241,
            53.90627,
            46.231512
          ],
          [
            11.46923,
            53.906503,
            46.137874
          ],
          [
            11.469223,
            53.90671,
            46.054669
          ],
          [
            11.469217,
            53.906909,
            45.974718
          ],
          [
            11.4692,
            53.907096,
            45.899446
          ],
          [
            11.469216,
            53.907279,
            45.825824
          ],
          [
            11.469249,
            53.907475,
            45.746703
          ],
          [
            11.469287,
            53.907688,
            45.633366
          ],
          [
            11.469332,
            53.907918,
            45.441873
          ],
          [
            11.469328,
            53.908125,
            45.270585
          ],
          [
            11.469336,
            53.908331,
            45.10018
          ],
          [
            11.469375,
            53.90853,
            44.934464
          ],
          [
            11.469382,
            53.90876,
            44.744236
          ],
          [
            11.469394,
            53.908977,
            44.564509
          ],
          [
            11.469408,
            53.909218,
            44.364892
          ],
          [
            11.469412,
            53.909445,
            44.199656
          ],
          [
            11.469313,
            53.909663,
            44.205718
          ],
          [
            11.469122,
            53.90986,
            44.211806
          ],
          [
            11.468858,
            53.909997,
            44.217394
          ],
          [
            11.468556,
            53.910098,
            44.222897
          ],
          [
            11.468189,
            53.910152,
            44.2289
          ],
          [
            11.467843,
            53.910152,
            44.234361
          ],
          [
            11.467461,
            53.910156,
            44.24039
          ],
          [
            11.467079,
            53.910169,
            44.246429
          ],
          [
            11.466668,
            53.910175,
            44.061776
          ],
          [
            11.466263,
            53.910174,
            43.857032
          ],
          [
            11.465867,
            53.910184,
            43.656687
          ],
          [
            11.465502,
            53.910195,
            43.471638
          ],
          [
            11.465152,
            53.910247,
            43.287478
          ],
          [
            11.464714,
            53.910411,
            43.02072
          ],
          [
            11.464904,
            53.910587,
            42.841758
          ],
          [
            11.465065,
            53.91079,
            42.833526
          ],
          [
            11.465201,
            53.910965,
            43.227744
          ],
          [
            11.465357,
            53.911161,
            43.671671
          ],
          [
            11.465566,
            53.911358,
            44.147423
          ],
          [
            11.465776,
            53.911549,
            44.613429
          ],
          [
            11.465989,
            53.911709,
            45.029893
          ],
          [
            11.466247,
            53.91189,
            45.51411
          ],
          [
            11.466483,
            53.912041,
            45.934376
          ],
          [
            11.466739,
            53.91217,
            46.340902
          ],
          [
            11.46704,
            53.912301,
            46.37022
          ],
          [
            11.467347,
            53.91242,
            46.352129
          ],
          [
            11.467677,
            53.912531,
            46.33343
          ],
          [
            11.468014,
            53.912627,
            46.31501
          ],
          [
            11.468369,
            53.912703,
            46.296407
          ],
          [
            11.468717,
            53.912765,
            46.278516
          ],
          [
            11.469105,
            53.912819,
            46.258879
          ],
          [
            11.469479,
            53.912847,
            46.240328
          ],
          [
            11.469906,
            53.912868,
            46.430797
          ],
          [
            11.470217,
            53.912886,
            46.603513
          ],
          [
            11.470598,
            53.912909,
            46.815329
          ],
          [
            11.470916,
            53.912908,
            46.991055
          ],
          [
            11.471247,
            53.912916,
            47.174122
          ],
          [
            11.47163,
            53.912906,
            47.385974
          ],
          [
            11.472012,
            53.91291,
            47.59721
          ],
          [
            11.472348,
            53.912907,
            47.782959
          ],
          [
            11.472723,
            53.912909,
            47.750934
          ],
          [
            11.473055,
            53.912905,
            47.27153
          ],
          [
            11.47338,
            53.912894,
            46.801209
          ],
          [
            11.473708,
            53.912902,
            46.327317
          ],
          [
            11.474036,
            53.912899,
            45.854126
          ],
          [
            11.474386,
            53.912902,
            45.349151
          ],
          [
            11.474717,
            53.912908,
            44.870517
          ],
          [
            11.475084,
            53.912901,
            44.340852
          ],
          [
            11.475438,
            53.912895,
            43.829422
          ],
          [
            11.475785,
            53.912911,
            43.615563
          ],
          [
            11.476106,
            53.912928,
            43.848309
          ],
          [
            11.476427,
            53.912924,
            44.080127
          ],
          [
            11.476747,
            53.912917,
            44.311345
          ],
          [
            11.477187,
            53.912951,
            44.632612
          ],
          [
            11.477493,
            53.912943,
            44.853872
          ],
          [
            11.477884,
            53.912918,
            45.137844
          ],
          [
            11.478025,
            53.91311,
            45.401674
          ],
          [
            11.47807,
            53.91336,
            45.70993
          ],
          [
            11.478102,
            53.913574,
            45.787206
          ],
          [
            11.478123,
            53.913804,
            45.858976
          ],
          [
            11.478114,
            53.914006,
            45.922037
          ],
          [
            11.478051,
            53.914219,
            45.989521
          ],
          [
            11.477936,
            53.914406,
            46.05148
          ],
          [
            11.47775,
            53.914597,
            46.120612
          ],
          [
            11.477508,
            53.914732,
            46.181808
          ],
          [
            11.477229,
            53.914869,
            46.248503
          ],
          [
            11.476933,
            53.915006,
            46.641522
          ],
          [
            11.476688,
            53.915149,
            47.314665
          ],
          [
            11.47646,
            53.915292,
            47.964601
          ],
          [
            11.476229,
            53.915443,
            48.638654
          ],
          [
            11.475985,
            53.915591,
            49.322155
          ],
          [
            11.475678,
            53.915726,
            50.070253
          ],
          [
            11.475351,
            53.915887,
            50.903234
          ],
          [
            11.475112,
            53.916015,
            51.533599
          ],
          [
            11.474881,
            53.916147,
            52.16178
          ],
          [
            11.474593,
            53.916292,
            51.969364
          ],
          [
            11.47426,
            53.916455,
            51.617705
          ],
          [
            11.473948,
            53.916625,
            51.272006
          ],
          [
            11.473654,
            53.916781,
            50.949797
          ],
          [
            11.473385,
            53.916929,
            50.650848
          ],
          [
            11.473158,
            53.917127,
            50.31748
          ],
          [
            11.473085,
            53.91731,
            50.057857
          ],
          [
            11.473072,
            53.917511,
            49.780472
          ],
          [
            11.473047,
            53.917725,
            49.51547
          ],
          [
            11.473047,
            53.917935,
            49.258085
          ],
          [
            11.473037,
            53.918127,
            49.022606
          ],
          [
            11.473037,
            53.918337,
            48.765135
          ],
          [
            11.473067,
            53.91855,
            48.502804
          ],
          [
            11.473086,
            53.918801,
            48.194882
          ],
          [
            11.473081,
            53.91899,
            47.962973
          ],
          [
            11.473102,
            53.919188,
            47.719694
          ],
          [
            11.473178,
            53.919398,
            47.523438
          ],
          [
            11.473307,
            53.919607,
            47.429295
          ],
          [
            11.473542,
            53.919768,
            47.339574
          ],
          [
            11.473884,
            53.919894,
            47.238085
          ],
          [
            11.47427,
            53.919934,
            47.140542
          ],
          [
            11.474651,
            53.919943,
            47.045304
          ],
          [
            11.474976,
            53.919953,
            46.964371
          ],
          [
            11.475303,
            53.919971,
            46.882692
          ],
          [
            11.475607,
            53.920012,
            46.80505
          ],
          [
            11.47594,
            53.920049,
            46.914212
          ],
          [
            11.476286,
            53.920097,
            47.043638
          ],
          [
            11.476603,
            53.920114,
            47.160564
          ],
          [
            11.476929,
            53.920088,
            47.280383
          ],
          [
            11.47719,
            53.920212,
            47.413655
          ],
          [
            11.477364,
            53.92044,
            47.568268
          ],
          [
            11.477534,
            53.920635,
            47.703927
          ],
          [
            11.477654,
            53.920861,
            47.850867
          ],
          [
            11.477775,
            53.921054,
            47.759448
          ],
          [
            11.477931,
            53.921267,
            47.433843
          ],
          [
            11.477762,
            53.921405,
            47.168608
          ],
          [
            11.4774,
            53.921439,
            46.862825
          ],
          [
            11.477313,
            53.921625,
            46.567229
          ],
          [
            11.47743,
            53.921845,
            46.243804
          ],
          [
            11.477524,
            53.92209,
            45.891287
          ],
          [
            11.477612,
            53.922331,
            45.54528
          ],
          [
            11.477725,
            53.922553,
            45.479985
          ],
          [
            11.477841,
            53.922787,
            45.66783
          ],
          [
            11.477945,
            53.922983,
            45.826356
          ],
          [
            11.478066,
            53.923174,
            45.983705
          ],
          [
            11.478138,
            53.923369,
            46.138189
          ],
          [
            11.478243,
            53.923565,
            46.297067
          ],
          [
            11.478355,
            53.923777,
            46.468146
          ],
          [
            11.478427,
            53.923988,
            46.633972
          ],
          [
            11.478508,
            53.924207,
            46.713194
          ],
          [
            11.478634,
            53.924416,
            46.400607
          ],
          [
            11.4787,
            53.924641,
            46.079006
          ],
          [
            11.478938,
            53.924868,
            45.70325
          ],
          [
            11.479232,
            53.925116,
            45.277529
          ],
          [
            11.479512,
            53.925377,
            44.842817
          ],
          [
            11.479788,
            53.925621,
            44.42981
          ],
          [
            11.480052,
            53.925826,
            44.121789
          ],
          [
            11.480295,
            53.926005,
            43.898013
          ],
          [
            11.480509,
            53.926172,
            43.693344
          ],
          [
            11.480751,
            53.926355,
            43.465955
          ],
          [
            11.480991,
            53.926513,
            43.258432
          ],
          [
            11.481216,
            53.926664,
            43.062047
          ],
          [
            11.481427,
            53.926843,
            42.849291
          ],
          [
            11.481655,
            53.927021,
            42.631368
          ],
          [
            11.481877,
            53.927211,
            42.756673
          ],
          [
            11.482087,
            53.92739,
            43.444864
          ],
          [
            11.48227,
            53.927556,
            44.070935
          ],
          [
            11.482451,
            53.927742,
            44.750328
          ],
          [
            11.4826,
            53.927933,
            45.416717
          ],
          [
            11.482726,
            53.928124,
            46.064216
          ],
          [
            11.482856,
            53.928347,
            46.80923
          ],
          [
            11.482987,
            53.928529,
            47.434185
          ],
          [
            11.483094,
            53.928718,
            48.063856
          ],
          [
            11.483185,
            53.928909,
            48.196435
          ],
          [
            11.483254,
            53.929098,
            48.224954
          ],
          [
            11.483352,
            53.929273,
            48.252459
          ],
          [
            11.483508,
            53.929456,
            48.282671
          ],
          [
            11.483657,
            53.929623,
            48.310515
          ],
          [
            11.483843,
            53.929798,
            48.341022
          ],
          [
            11.484065,
            53.929951,
            48.370794
          ],
          [
            11.484345,
            53.930089,
            48.40269
          ],
          [
            11.484627,
            53.930208,
            48.43282
          ],
          [
            11.484773,
            53.930408,
            48.199071
          ],
          [
            11.484896,
            53.930641,
            47.894006
          ],
          [
            11.485036,
            53.930854,
            47.608482
          ],
          [
            11.485155,
            53.931037,
            47.363385
          ],
          [
            11.48532,
            53.931237,
            47.085209
          ],
          [
            11.48555,
            53.931417,
            46.803666
          ],
          [
            11.485776,
            53.931583,
            46.537483
          ],
          [
            11.485957,
            53.931732,
            46.307966
          ],
          [
            11.486206,
            53.931892,
            46.349225
          ],
          [
            11.486344,
            53.932066,
            46.59936
          ],
          [
            11.486407,
            53.93225,
            46.844736
          ],
          [
            11.486444,
            53.932473,
            47.136406
          ],
          [
            11.486486,
            53.932676,
            47.402544
          ],
          [
            11.486629,
            53.932851,
            47.677351
          ],
          [
            11.486801,
            53.933029,
            47.956862
          ],
          [
            11.486871,
            53.933241,
            48.237871
          ],
          [
            11.486922,
            53.933435,
            48.493879
          ],
          [
            11.48698,
            53.933639,
            49.204218
          ],
          [
            11.487012,
            53.933837,
            49.953949
          ],
          [
            11.487077,
            53.934022,
            50.663044
          ],
          [
            11.487146,
            53.934229,
            51.454701
          ],
          [
            11.487179,
            53.934419,
            52.171678
          ],
          [
            11.48725,
            53.934609,
            52.902329
          ],
          [
            11.487313,
            53.934807,
            53.659395
          ],
          [
            11.487362,
            53.935004,
            54.407605
          ],
          [
            11.487413,
            53.93519,
            55.114682
          ],
          [
            11.487444,
            53.935377,
            55.228378
          ],
          [
            11.487517,
            53.935577,
            55.155372
          ],
          [
            11.487565,
            53.935772,
            55.084933
          ],
          [
            11.487593,
            53.935965,
            55.015799
          ],
          [
            11.487602,
            53.936162,
            54.945453
          ],
          [
            11.487602,
            53.93637,
            54.871175
          ],
          [
            11.487585,
            53.936628,
            54.778859
          ],
          [
            11.487677,
            53.936866,
            54.691706
          ],
          [
            11.487589,
            53.937075,
            54.568018
          ],
          [
            11.487529,
            53.937308,
            54.325111
          ],
          [
            11.487493,
            53.937557,
            54.068565
          ],
          [
            11.487457,
            53.93781,
            53.807953
          ],
          [
            11.487388,
            53.938038,
            53.57006
          ],
          [
            11.487315,
            53.938248,
            53.350098
          ],
          [
            11.487272,
            53.938469,
            53.121622
          ],
          [
            11.487218,
            53.9387,
            52.882024
          ],
          [
            11.487173,
            53.938896,
            52.602199
          ],
          [
            11.487117,
            53.939116,
            52.218946
          ],
          [
            11.487063,
            53.939349,
            51.813943
          ],
          [
            11.487007,
            53.939589,
            51.396782
          ],
          [
            11.486948,
            53.939813,
            51.006456
          ],
          [
            11.486921,
            53.940039,
            50.616333
          ],
          [
            11.486904,
            53.940287,
            50.188856
          ],
          [
            11.486896,
            53.940515,
            49.795655
          ],
          [
            11.486897,
            53.940774,
            49.498318
          ],
          [
            11.486908,
            53.940995,
            49.281482
          ],
          [
            11.486921,
            53.941226,
            49.054823
          ],
          [
            11.486927,
            53.941422,
            48.862497
          ],
          [
            11.486899,
            53.941635,
            48.652933
          ],
          [
            11.486864,
            53.941859,
            48.432337
          ],
          [
            11.486801,
            53.942096,
            48.197012
          ],
          [
            11.486723,
            53.94232,
            47.972303
          ],
          [
            11.486639,
            53.942536,
            47.910312
          ],
          [
            11.48656,
            53.94278,
            47.881413
          ],
          [
            11.486492,
            53.94304,
            47.850805
          ],
          [
            11.486462,
            53.94323,
            47.828592
          ],
          [
            11.48649,
            53.94346,
            47.801759
          ],
          [
            11.486488,
            53.943709,
            47.772788
          ],
          [
            11.486491,
            53.943959,
            47.743689
          ],
          [
            11.486495,
            53.944219,
            47.815307
          ],
          [
            11.486501,
            53.94445,
            48.10976
          ],
          [
            11.486537,
            53.944694,
            48.421027
          ],
          [
            11.486586,
            53.944924,
            48.717969
          ],
          [
            11.486617,
            53.945158,
            49.020437
          ],
          [
            11.486579,
            53.945425,
            49.361379
          ],
          [
            11.486598,
            53.945606,
            49.591916
          ],
          [
            11.486622,
            53.945832,
            49.880067
          ],
          [
            11.486623,
            53.946037,
            49.736254
          ],
          [
            11.486641,
            53.946254,
            49.170101
          ],
          [
            11.486638,
            53.946451,
            48.658727
          ],
          [
            11.486652,
            53.946671,
            48.088289
          ],
          [
            11.486776,
            53.946903,
            47.455146
          ],
          [
            11.486822,
            53.947117,
            46.866809
          ],
          [
            11.486742,
            53.947333,
            46.293892
          ],
          [
            11.486793,
            53.947532,
            45.771465
          ],
          [
            11.486863,
            53.947746,
            45.38344
          ],
          [
            11.486935,
            53.947969,
            45.530781
          ],
          [
            11.487011,
            53.948196,
            45.680937
          ],
          [
            11.487129,
            53.948411,
            45.827599
          ],
          [
            11.48722,
            53.948596,
            45.952963
          ],
          [
            11.48728,
            53.948794,
            46.083512
          ],
          [
            11.487341,
            53.948998,
            46.21793
          ],
          [
            11.487393,
            53.949181,
            46.338334
          ],
          [
            11.48743,
            53.949378,
            46.466978
          ],
          [
            11.487404,
            53.949619,
            46.557342
          ],
          [
            11.487355,
            53.949849,
            46.615651
          ],
          [
            11.487294,
            53.950117,
            46.683667
          ],
          [
            11.487249,
            53.950344,
            46.74116
          ],
          [
            11.48721,
            53.950559,
            46.795563
          ],
          [
            11.48716,
            53.950791,
            46.85439
          ],
          [
            11.487096,
            53.95106,
            46.922725
          ],
          [
            11.487039,
            53.951287,
            46.975248
          ],
          [
            11.48701,
            53.951526,
            47.010904
          ],
          [
            11.48701,
            53.951751,
            47.044387
          ],
          [
            11.48704,
            53.951939,
            47.072483
          ],
          [
            11.48709,
            53.952185,
            47.109346
          ],
          [
            11.487146,
            53.952445,
            47.148342
          ],
          [
            11.487202,
            53.952659,
            47.180594
          ],
          [
            11.487242,
            53.952845,
            47.208486
          ],
          [
            11.487281,
            53.953096,
            47.256286
          ],
          [
            11.487329,
            53.953328,
            47.324455
          ],
          [
            11.487381,
            53.953579,
            47.398254
          ],
          [
            11.487432,
            53.953793,
            47.461282
          ],
          [
            11.487489,
            53.954046,
            47.535725
          ],
          [
            11.487521,
            53.954279,
            47.603973
          ],
          [
            11.487574,
            53.954523,
            47.67574
          ],
          [
            11.487657,
            53.954755,
            47.744892
          ],
          [
            11.487711,
            53.954981,
            47.940043
          ],
          [
            11.48774,
            53.955213,
            48.177578
          ],
          [
            11.487796,
            53.95545,
            48.421413
          ],
          [
            11.48784,
            53.955667,
            48.644238
          ],
          [
            11.487841,
            53.9559,
            48.881674
          ],
          [
            11.487912,
            53.956177,
            49.167397
          ],
          [
            11.487972,
            53.956402,
            49.399575
          ],
          [
            11.488021,
            53.956631,
            49.583287
          ],
          [
            11.488041,
            53.956834,
            49.536542
          ],
          [
            11.488089,
            53.957034,
            49.489989
          ],
          [
            11.488159,
            53.957247,
            49.440086
          ],
          [
            11.488214,
            53.957483,
            49.385321
          ],
          [
            11.488262,
            53.957686,
            49.338181
          ],
          [
            11.488315,
            53.957877,
            49.293694
          ],
          [
            11.48838,
            53.958094,
            49.243052
          ],
          [
            11.488418,
            53.958299,
            49.195656
          ],
          [
            11.488475,
            53.958539,
            49.206201
          ],
          [
            11.488571,
            53.958729,
            49.237151
          ],
          [
            11.488665,
            53.95891,
            49.266708
          ],
          [
            11.488756,
            53.959102,
            49.297888
          ],
          [
            11.488814,
            53.959293,
            49.328187
          ],
          [
            11.488897,
            53.959524,
            49.36504
          ],
          [
            11.488914,
            53.959753,
            49.400825
          ],
          [
            11.489013,
            53.960005,
            49.441255
          ],
          [
            11.489117,
            53.960253,
            49.297223
          ],
          [
            11.489203,
            53.960488,
            49.006794
          ],
          [
            11.489325,
            53.960713,
            48.721199
          ],
          [
            11.489446,
            53.960968,
            48.401406
          ],
          [
            11.489559,
            53.961173,
            48.141108
          ],
          [
            11.489677,
            53.961363,
            47.896385
          ],
          [
            11.489781,
            53.961599,
            47.60178
          ],
          [
            11.489845,
            53.96183,
            47.31766
          ],
          [
            11.489726,
            53.962051,
            47.333506
          ],
          [
            11.489528,
            53.962193,
            47.374493
          ],
          [
            11.489453,
            53.962386,
            47.418277
          ],
          [
            11.489428,
            53.962585,
            47.462254
          ],
          [
            11.48942,
            53.962788,
            47.507004
          ],
          [
            11.489439,
            53.963,
            47.554305
          ],
          [
            11.489492,
            53.96321,
            47.601154
          ],
          [
            11.489536,
            53.963424,
            47.648665
          ],
          [
            11.489619,
            53.963648,
            47.740519
          ],
          [
            11.489714,
            53.963841,
            47.903378
          ],
          [
            11.489915,
            53.964034,
            48.086833
          ],
          [
            11.490174,
            53.964171,
            48.252713
          ],
          [
            11.490515,
            53.964304,
            48.448051
          ],
          [
            11.490851,
            53.964425,
            48.635729
          ],
          [
            11.491184,
            53.964499,
            48.809125
          ],
          [
            11.491472,
            53.964712,
            49.030476
          ],
          [
            11.491627,
            53.964891,
            49.071407
          ],
          [
            11.491786,
            53.965062,
            48.866967
          ],
          [
            11.491933,
            53.965253,
            48.647651
          ],
          [
            11.492081,
            53.965415,
            48.455562
          ],
          [
            11.49229,
            53.965581,
            48.239054
          ],
          [
            11.492551,
            53.965773,
            47.982359
          ],
          [
            11.492686,
            53.965947,
            47.78075
          ],
          [
            11.492979,
            53.9661,
            47.53981
          ],
          [
            11.493282,
            53.966284,
            47.272277
          ],
          [
            11.493533,
            53.96643,
            47.07261
          ],
          [
            11.49377,
            53.966572,
            46.880716
          ],
          [
            11.49402,
            53.966699,
            46.694911
          ],
          [
            11.494264,
            53.96683,
            46.508783
          ],
          [
            11.494516,
            53.966961,
            46.319611
          ],
          [
            11.494813,
            53.967115,
            46.096913
          ],
          [
            11.495117,
            53.967277,
            45.866157
          ],
          [
            11.495371,
            53.967442,
            45.652802
          ],
          [
            11.49567,
            53.967598,
            45.80545
          ],
          [
            11.495967,
            53.96776,
            46.330138
          ],
          [
            11.496241,
            53.967922,
            46.833399
          ],
          [
            11.496549,
            53.96808,
            47.362785
          ],
          [
            11.496875,
            53.968239,
            47.911709
          ],
          [
            11.497195,
            53.96842,
            48.486879
          ],
          [
            11.497486,
            53.968564,
            48.979464
          ],
          [
            11.497802,
            53.968694,
            49.478997
          ],
          [
            11.498175,
            53.968809,
            49.793888
          ],
          [
            11.498475,
            53.968916,
            50.047886
          ],
          [
            11.498853,
            53.969034,
            50.35707
          ],
          [
            11.499203,
            53.969164,
            50.656519
          ],
          [
            11.499541,
            53.969303,
            50.95467
          ],
          [
            11.499837,
            53.969478,
            51.257982
          ],
          [
            11.500117,
            53.969672,
            51.570707
          ],
          [
            11.500412,
            53.969856,
            51.410853
          ],
          [
            11.500694,
            53.970009,
            50.917685
          ],
          [
            11.501031,
            53.970138,
            50.400072
          ],
          [
            11.501331,
            53.970233,
            49.96209
          ],
          [
            11.501643,
            53.970312,
            49.525451
          ],
          [
            11.502007,
            53.970402,
            49.017726
          ],
          [
            11.502429,
            53.970515,
            48.421694
          ],
          [
            11.502854,
            53.970615,
            47.833259
          ],
          [
            11.503336,
            53.970754,
            47.394711
          ],
          [
            11.503693,
            53.970863,
            47.081378
          ],
          [
            11.504163,
            53.971001,
            46.672641
          ],
          [
            11.504567,
            53.971086,
            46.331999
          ],
          [
            11.504972,
            53.97114,
            46.004052
          ],
          [
            11.505334,
            53.971239,
            45.693521
          ],
          [
            11.505717,
            53.971365,
            45.394404
          ],
          [
            11.506028,
            53.971521,
            45.342055
          ],
          [
            11.506343,
            53.971669,
            45.289985
          ],
          [
            11.506643,
            53.97175,
            45.247787
          ],
          [
            11.506864,
            53.971874,
            45.207727
          ],
          [
            11.506704,
            53.972051,
            45.161722
          ],
          [
            11.506931,
            53.972233,
            45.112658
          ],
          [
            11.50718,
            53.972393,
            45.06552
          ],
          [
            11.507413,
            53.972534,
            45.022793
          ],
          [
            11.507642,
            53.972683,
            45.11401
          ],
          [
            11.507912,
            53.972863,
            45.275797
          ],
          [
            11.508125,
            53.973034,
            45.418518
          ],
          [
            11.50841,
            53.973169,
            45.563362
          ],
          [
            11.508653,
            53.973315,
            45.701185
          ],
          [
            11.508863,
            53.973469,
            45.83405
          ],
          [
            11.509134,
            53.973671,
            46.007099
          ],
          [
            11.509399,
            53.973859,
            46.172237
          ],
          [
            11.509644,
            53.973992,
            46.162559
          ],
          [
            11.509928,
            53.974157,
            46.053764
          ],
          [
            11.510196,
            53.974326,
            45.94737
          ],
          [
            11.510445,
            53.974501,
            45.842283
          ],
          [
            11.510746,
            53.974669,
            45.729602
          ],
          [
            11.511012,
            53.974837,
            45.623434
          ],
          [
            11.511251,
            53.974986,
            45.529093
          ],
          [
            11.511487,
            53.975144,
            45.43206
          ],
          [
            11.51172,
            53.975282,
            45.401806
          ],
          [
            11.511943,
            53.975436,
            45.417828
          ],
          [
            11.512147,
            53.975592,
            45.433414
          ],
          [
            11.512375,
            53.975749,
            45.449783
          ],
          [
            11.512604,
            53.975892,
            45.465339
          ],
          [
            11.51282,
            53.976057,
            45.48183
          ],
          [
            11.513004,
            53.976218,
            45.497188
          ],
          [
            11.513254,
            53.976423,
            45.517253
          ],
          [
            11.513459,
            53.97658,
            45.532927
          ],
          [
            11.513662,
            53.976757,
            45.487112
          ],
          [
            11.513849,
            53.976907,
            45.43749
          ],
          [
            11.514059,
            53.977056,
            45.385802
          ],
          [
            11.514268,
            53.977211,
            45.33303
          ],
          [
            11.514473,
            53.977362,
            45.281487
          ],
          [
            11.514727,
            53.977525,
            45.222424
          ],
          [
            11.515063,
            53.977667,
            45.157517
          ],
          [
            11.515348,
            53.977815,
            45.097766
          ],
          [
            11.515708,
            53.977891,
            45.07898
          ],
          [
            11.515844,
            53.978126,
            45.164996
          ],
          [
            11.516025,
            53.978357,
            45.252901
          ],
          [
            11.516179,
            53.978567,
            45.331922
          ],
          [
            11.516361,
            53.978763,
            45.409062
          ],
          [
            11.51654,
            53.978945,
            45.481684
          ],
          [
            11.516734,
            53.979147,
            45.562147
          ],
          [
            11.516926,
            53.979345,
            45.640922
          ],
          [
            11.517129,
            53.979546,
            45.755399
          ],
          [
            11.517347,
            53.979705,
            45.879218
          ],
          [
            11.517632,
            53.979898,
            46.034304
          ],
          [
            11.517936,
            53.980074,
            46.186314
          ],
          [
            11.518217,
            53.980221,
            46.320314
          ],
          [
            11.518513,
            53.980369,
            46.458848
          ],
          [
            11.518793,
            53.980516,
            46.592584
          ],
          [
            11.519087,
            53.980648,
            46.724425
          ],
          [
            11.519331,
            53.980766,
            46.753576
          ],
          [
            11.519582,
            53.9809,
            46.731189
          ],
          [
            11.519929,
            53.981041,
            46.703335
          ],
          [
            11.520265,
            53.981206,
            46.674419
          ],
          [
            11.520499,
            53.981323,
            46.654121
          ],
          [
            11.520782,
            53.981475,
            46.628769
          ],
          [
            11.521128,
            53.981614,
            46.601013
          ],
          [
            11.521484,
            53.981749,
            46.573026
          ],
          [
            11.521876,
            53.981805,
            46.918097
          ],
          [
            11.522257,
            53.981842,
            47.41102
          ],
          [
            11.522566,
            53.981878,
            47.813119
          ],
          [
            11.522947,
            53.981913,
            48.305988
          ],
          [
            11.523308,
            53.981987,
            48.79401
          ],
          [
            11.523669,
            53.982039,
            49.272744
          ],
          [
            11.524033,
            53.982171,
            49.819412
          ],
          [
            11.524287,
            53.98234,
            50.310222
          ],
          [
            11.524514,
            53.982506,
            50.788225
          ],
          [
            11.524718,
            53.982683,
            51.277231
          ],
          [
            11.524874,
            53.982855,
            51.721403
          ],
          [
            11.525038,
            53.983022,
            52.160775
          ],
          [
            11.525243,
            53.983199,
            52.64959
          ],
          [
            11.525463,
            53.983383,
            53.16204
          ],
          [
            11.525648,
            53.983551,
            53.61827
          ],
          [
            11.525841,
            53.983703,
            54.050526
          ],
          [
            11.52607,
            53.983863,
            54.527185
          ],
          [
            11.526305,
            53.984024,
            54.861711
          ],
          [
            11.526506,
            53.984174,
            55.150997
          ],
          [
            11.526725,
            53.984326,
            55.453074
          ],
          [
            11.526956,
            53.984496,
            55.782712
          ],
          [
            11.527144,
            53.984665,
            56.088501
          ],
          [
            11.527301,
            53.984828,
            56.372161
          ],
          [
            11.527466,
            53.984993,
            56.662102
          ],
          [
            11.527638,
            53.985164,
            56.963369
          ],
          [
            11.527872,
            53.985347,
            57.310013
          ],
          [
            11.528131,
            53.985488,
            57.609987
          ],
          [
            11.528431,
            53.985615,
            57.924418
          ],
          [
            11.528745,
            53.985747,
            58.252944
          ],
          [
            11.529062,
            53.985877,
            58.581824
          ],
          [
            11.529378,
            53.986012,
            58.913791
          ],
          [
            11.529709,
            53.986144,
            59.25357
          ],
          [
            11.530013,
            53.986269,
            59.568822
          ],
          [
            11.530353,
            53.9864,
            59.870632
          ],
          [
            11.530711,
            53.986549,
            59.599009
          ],
          [
            11.531023,
            53.986683,
            59.359598
          ],
          [
            11.531376,
            53.98682,
            59.097616
          ],
          [
            11.531685,
            53.986942,
            58.867181
          ],
          [
            11.531997,
            53.987081,
            58.618297
          ],
          [
            11.532322,
            53.98721,
            58.375533
          ],
          [
            11.532634,
            53.987362,
            58.124622
          ],
          [
            11.532953,
            53.987488,
            58.126591
          ],
          [
            11.533223,
            53.987601,
            58.375637
          ],
          [
            11.533412,
            53.987782,
            58.663609
          ],
          [
            11.533737,
            53.987897,
            58.948483
          ],
          [
            11.534064,
            53.988023,
            59.241913
          ],
          [
            11.534387,
            53.988162,
            59.542367
          ],
          [
            11.534706,
            53.988295,
            59.835872
          ],
          [
            11.534992,
            53.988415,
            60.099752
          ],
          [
            11.535301,
            53.988557,
            60.168744
          ],
          [
            11.535529,
            53.988757,
            59.799812
          ],
          [
            11.535651,
            53.988964,
            59.467176
          ],
          [
            11.5356,
            53.989177,
            59.141388
          ],
          [
            11.535478,
            53.989384,
            58.809778
          ],
          [
            11.535351,
            53.989587,
            58.482282
          ],
          [
            11.53527,
            53.989788,
            58.169134
          ],
          [
            11.53526,
            53.989992,
            57.858928
          ],
          [
            11.535253,
            53.990192,
            57.552845
          ],
          [
            11.535298,
            53.990383,
            57.197639
          ],
          [
            11.535399,
            53.990603,
            56.777781
          ],
          [
            11.535495,
            53.990797,
            56.405504
          ],
          [
            11.535533,
            53.991017,
            55.998152
          ],
          [
            11.535602,
            53.991211,
            55.631454
          ],
          [
            11.5357,
            53.991416,
            55.238145
          ],
          [
            11.535754,
            53.991648,
            54.806178
          ],
          [
            11.535813,
            53.991865,
            54.400974
          ],
          [
            11.535874,
            53.99209,
            54.872125
          ],
          [
            11.53592,
            53.992281,
            55.670987
          ],
          [
            11.535974,
            53.992499,
            56.583317
          ],
          [
            11.536044,
            53.992679,
            57.348299
          ],
          [
            11.53611,
            53.992858,
            58.117243
          ],
          [
            11.536218,
            53.993045,
            58.935066
          ],
          [
            11.536333,
            53.993233,
            59.762696
          ],
          [
            11.536465,
            53.993429,
            60.635702
          ],
          [
            11.536618,
            53.993601,
            61.439956
          ],
          [
            11.536791,
            53.993786,
            62.567239
          ],
          [
            11.536957,
            53.993956,
            63.715699
          ],
          [
            11.537101,
            53.994122,
            64.807323
          ],
          [
            11.537267,
            53.994282,
            65.906226
          ],
          [
            11.537434,
            53.994456,
            67.077241
          ],
          [
            11.537661,
            53.99461,
            68.272744
          ],
          [
            11.53792,
            53.994736,
            69.434803
          ],
          [
            11.538203,
            53.994834,
            70.570683
          ],
          [
            11.538458,
            53.994969,
            71.754806
          ],
          [
            11.53874,
            53.995064,
            71.941082
          ],
          [
            11.53891,
            53.994988,
            71.436076
          ],
          [
            11.53906,
            53.995153,
            70.925773
          ],
          [
            11.539221,
            53.995323,
            70.392773
          ],
          [
            11.539373,
            53.995503,
            69.83859
          ],
          [
            11.539596,
            53.99565,
            69.292195
          ],
          [
            11.539779,
            53.995825,
            68.731165
          ],
          [
            11.540042,
            53.995985,
            68.124492
          ],
          [
            11.540211,
            53.996171,
            67.549665
          ],
          [
            11.540426,
            53.99636,
            66.896168
          ],
          [
            11.540642,
            53.996632,
            66.012729
          ],
          [
            11.540807,
            53.996797,
            65.44994
          ],
          [
            11.540909,
            53.997019,
            64.771214
          ],
          [
            11.541039,
            53.99727,
            63.99384
          ],
          [
            11.541232,
            53.997515,
            63.199636
          ],
          [
            11.541404,
            53.997747,
            62.455821
          ],
          [
            11.541573,
            53.997954,
            62.030144
          ],
          [
            11.541748,
            53.998168,
            61.967946
          ],
          [
            11.541904,
            53.998358,
            61.912764
          ],
          [
            11.542077,
            53.998539,
            61.858348
          ],
          [
            11.542265,
            53.998729,
            61.800482
          ],
          [
            11.542428,
            53.998919,
            61.744383
          ],
          [
            11.542655,
            53.99908,
            61.689497
          ],
          [
            11.542784,
            53.999259,
            61.638608
          ],
          [
            11.542965,
            53.99942,
            61.587821
          ],
          [
            11.543078,
            53.999643,
            61.533356
          ],
          [
            11.543249,
            53.999864,
            61.477036
          ],
          [
            11.543449,
            54.000088,
            61.418354
          ],
          [
            11.543696,
            54.000392,
            61.340186
          ],
          [
            11.543946,
            54.000666,
            61.268024
          ],
          [
            11.544157,
            54.000871,
            61.212437
          ],
          [
            11.544352,
            54.001095,
            61.335065
          ],
          [
            11.544517,
            54.001292,
            62.005398
          ],
          [
            11.544679,
            54.001476,
            62.636417
          ],
          [
            11.54487,
            54.00164,
            63.242005
          ],
          [
            11.545059,
            54.001801,
            63.837786
          ],
          [
            11.545194,
            54.001996,
            64.480365
          ],
          [
            11.54538,
            54.00217,
            65.106358
          ],
          [
            11.545559,
            54.002343,
            65.723138
          ],
          [
            11.545725,
            54.002505,
            66.29914
          ],
          [
            11.545896,
            54.002679,
            66.376693
          ],
          [
            11.546063,
            54.002884,
            65.677692
          ],
          [
            11.546167,
            54.003068,
            65.080933
          ],
          [
            11.546349,
            54.003254,
            64.420331
          ],
          [
            11.546499,
            54.003443,
            63.779018
          ],
          [
            11.546624,
            54.003636,
            63.144227
          ],
          [
            11.546838,
            54.00386,
            62.354525
          ],
          [
            11.547002,
            54.004026,
            61.764632
          ],
          [
            11.54715,
            54.004209,
            61.141732
          ],
          [
            11.547332,
            54.004385,
            60.260538
          ],
          [
            11.547513,
            54.00458,
            59.299506
          ],
          [
            11.547713,
            54.004759,
            58.371318
          ],
          [
            11.547917,
            54.004952,
            57.388261
          ],
          [
            11.548197,
            54.005154,
            56.254781
          ],
          [
            11.548537,
            54.005261,
            55.264778
          ],
          [
            11.548944,
            54.005338,
            54.177735
          ],
          [
            11.549321,
            54.00542,
            53.394772
          ],
          [
            11.549679,
            54.005486,
            53.69971
          ],
          [
            11.550007,
            54.005582,
            53.996669
          ],
          [
            11.55026,
            54.005697,
            54.257525
          ],
          [
            11.550503,
            54.005832,
            54.52853
          ],
          [
            11.550724,
            54.005966,
            54.78601
          ],
          [
            11.550961,
            54.006164,
            55.119793
          ],
          [
            11.551138,
            54.006356,
            55.420956
          ],
          [
            11.551323,
            54.006586,
            55.772003
          ],
          [
            11.551461,
            54.006767,
            55.443023
          ],
          [
            11.551542,
            54.006944,
            55.029278
          ],
          [
            11.551632,
            54.007122,
            54.610047
          ],
          [
            11.55177,
            54.007325,
            54.116569
          ],
          [
            11.551879,
            54.007525,
            53.642696
          ],
          [
            11.552001,
            54.007733,
            53.146354
          ],
          [
            11.552147,
            54.007944,
            52.632484
          ],
          [
            11.552258,
            54.008152,
            52.138924
          ],
          [
            11.552368,
            54.008333,
            51.7803
          ],
          [
            11.552595,
            54.008526,
            51.98504
          ],
          [
            11.552722,
            54.00875,
            52.190069
          ],
          [
            11.552845,
            54.008978,
            52.397809
          ],
          [
            11.55297,
            54.009207,
            52.606643
          ],
          [
            11.553126,
            54.009435,
            52.82003
          ],
          [
            11.553241,
            54.009645,
            53.011815
          ],
          [
            11.553349,
            54.009844,
            53.19331
          ],
          [
            11.553468,
            54.010035,
            53.51237
          ],
          [
            11.55358,
            54.010209,
            54.133664
          ],
          [
            11.553731,
            54.010411,
            54.870996
          ],
          [
            11.553902,
            54.010605,
            55.600769
          ],
          [
            11.554077,
            54.010787,
            56.298963
          ],
          [
            11.554249,
            54.010946,
            56.928284
          ],
          [
            11.554423,
            54.011115,
            57.588694
          ],
          [
            11.554615,
            54.011291,
            58.28705
          ],
          [
            11.554799,
            54.011449,
            58.926438
          ],
          [
            11.554983,
            54.011615,
            59.334557
          ],
          [
            11.555196,
            54.01179,
            59.353195
          ],
          [
            11.555386,
            54.011955,
            59.370594
          ],
          [
            11.555568,
            54.012127,
            59.388138
          ],
          [
            11.555767,
            54.012292,
            59.405718
          ],
          [
            11.555952,
            54.012453,
            59.422587
          ],
          [
            11.55613,
            54.012624,
            59.439952
          ],
          [
            11.556316,
            54.012804,
            59.458194
          ],
          [
            11.556561,
            54.012991,
            59.478637
          ],
          [
            11.556876,
            54.013179,
            59.436218
          ],
          [
            11.557144,
            54.013356,
            59.381833
          ],
          [
            11.557396,
            54.013532,
            59.329038
          ],
          [
            11.55766,
            54.013711,
            59.274595
          ],
          [
            11.557912,
            54.013874,
            59.224041
          ],
          [
            11.558103,
            54.014039,
            59.177151
          ],
          [
            11.558337,
            54.014199,
            59.128727
          ],
          [
            11.558541,
            54.014357,
            59.083099
          ],
          [
            11.558763,
            54.014527,
            59.220072
          ],
          [
            11.559008,
            54.014689,
            59.421832
          ],
          [
            11.559246,
            54.014844,
            59.616672
          ],
          [
            11.559474,
            54.014969,
            59.786995
          ],
          [
            11.559675,
            54.015114,
            59.960839
          ],
          [
            11.55989,
            54.015252,
            60.134808
          ],
          [
            11.560115,
            54.015386,
            60.309853
          ],
          [
            11.560313,
            54.015538,
            60.487937
          ],
          [
            11.560533,
            54.015715,
            60.691677
          ],
          [
            11.560722,
            54.015904,
            60.885125
          ],
          [
            11.560926,
            54.016095,
            61.080459
          ],
          [
            11.561129,
            54.016271,
            61.264614
          ],
          [
            11.56137,
            54.016465,
            61.472668
          ],
          [
            11.561603,
            54.016644,
            61.667871
          ],
          [
            11.561826,
            54.016818,
            61.856548
          ],
          [
            11.562058,
            54.016985,
            62.043483
          ],
          [
            11.562383,
            54.016966,
            62.221326
          ],
          [
            11.562694,
            54.016851,
            62.635568
          ],
          [
            11.56299,
            54.016733,
            63.200791
          ],
          [
            11.563294,
            54.016631,
            63.75407
          ],
          [
            11.5636,
            54.016505,
            64.344523
          ],
          [
            11.563898,
            54.016403,
            64.889486
          ],
          [
            11.564188,
            54.016315,
            65.405527
          ],
          [
            11.564527,
            54.016245,
            65.973568
          ],
          [
            11.564873,
            54.016192,
            66.538862
          ],
          [
            11.565257,
            54.016177,
            67.139001
          ],
          [
            11.565611,
            54.016183,
            67.206417
          ],
          [
            11.565957,
            54.016155,
            67.273417
          ],
          [
            11.566329,
            54.016199,
            67.345579
          ],
          [
            11.56668,
            54.016248,
            67.414234
          ],
          [
            11.56702,
            54.016301,
            67.481132
          ],
          [
            11.567325,
            54.016354,
            67.541616
          ],
          [
            11.567617,
            54.016416,
            67.600688
          ],
          [
            11.567951,
            54.016529,
            67.673983
          ],
          [
            11.568252,
            54.016678,
            68.158593
          ],
          [
            11.56855,
            54.016819,
            69.265055
          ],
          [
            11.568828,
            54.016959,
            70.324284
          ],
          [
            11.569091,
            54.017105,
            71.371196
          ],
          [
            11.569338,
            54.017262,
            72.423881
          ],
          [
            11.569592,
            54.017411,
            73.463199
          ],
          [
            11.569839,
            54.017551,
            74.455788
          ],
          [
            11.570092,
            54.017698,
            75.484966
          ],
          [
            11.570338,
            54.017844,
            76.496202
          ],
          [
            11.570607,
            54.018001,
            76.816914
          ],
          [
            11.570873,
            54.01816,
            77.080506
          ],
          [
            11.571153,
            54.018329,
            77.359172
          ],
          [
            11.571438,
            54.018502,
            77.643706
          ],
          [
            11.571745,
            54.018684,
            77.946469
          ],
          [
            11.571999,
            54.018849,
            78.209335
          ],
          [
            11.572264,
            54.019001,
            78.466424
          ],
          [
            11.572539,
            54.019158,
            78.777086
          ],
          [
            11.572862,
            54.01932,
            79.434399
          ],
          [
            11.573099,
            54.019463,
            79.96164
          ],
          [
            11.573322,
            54.019609,
            80.478728
          ],
          [
            11.573559,
            54.019739,
            80.980962
          ],
          [
            11.573825,
            54.01988,
            81.53561
          ],
          [
            11.574089,
            54.020032,
            82.107865
          ],
          [
            11.574351,
            54.020178,
            82.666915
          ],
          [
            11.574599,
            54.020331,
            83.223547
          ],
          [
            11.574837,
            54.020492,
            83.307608
          ],
          [
            11.575073,
            54.020643,
            83.111166
          ],
          [
            11.575322,
            54.020817,
            82.893584
          ],
          [
            11.57556,
            54.020983,
            82.685885
          ],
          [
            11.575814,
            54.021137,
            82.480638
          ],
          [
            11.576031,
            54.021293,
            82.2877
          ],
          [
            11.576251,
            54.021451,
            82.092298
          ],
          [
            11.576448,
            54.021632,
            81.886706
          ],
          [
            11.576664,
            54.021845,
            81.494453
          ],
          [
            11.576859,
            54.022019,
            80.814407
          ],
          [
            11.577068,
            54.022197,
            80.109053
          ],
          [
            11.577325,
            54.022417,
            79.23924
          ],
          [
            11.5776,
            54.022648,
            78.320249
          ],
          [
            11.577861,
            54.022873,
            77.432676
          ],
          [
            11.57812,
            54.023086,
            76.579379
          ],
          [
            11.578394,
            54.02333,
            75.684697
          ],
          [
            11.578632,
            54.023531,
            75.093815
          ],
          [
            11.578932,
            54.023771,
            74.375366
          ],
          [
            11.579225,
            54.023983,
            73.716327
          ],
          [
            11.579467,
            54.024161,
            73.166642
          ],
          [
            11.579704,
            54.024343,
            72.613644
          ],
          [
            11.580009,
            54.024569,
            71.917744
          ],
          [
            11.580342,
            54.024809,
            71.274494
          ],
          [
            11.580682,
            54.025041,
            70.761222
          ],
          [
            11.581015,
            54.025261,
            70.267653
          ],
          [
            11.581325,
            54.025455,
            69.821507
          ],
          [
            11.581583,
            54.025621,
            69.444584
          ],
          [
            11.58186,
            54.025794,
            69.04637
          ],
          [
            11.582189,
            54.02601,
            68.560388
          ],
          [
            11.582554,
            54.026248,
            67.740598
          ],
          [
            11.582912,
            54.026467,
            66.926651
          ],
          [
            11.583233,
            54.026668,
            66.187724
          ],
          [
            11.583518,
            54.026858,
            65.50843
          ],
          [
            11.583794,
            54.027043,
            64.848034
          ],
          [
            11.584139,
            54.027249,
            64.073203
          ],
          [
            11.58446,
            54.027457,
            63.34467
          ],
          [
            11.584775,
            54.02766,
            62.658826
          ],
          [
            11.585133,
            54.027889,
            61.882414
          ],
          [
            11.585472,
            54.028114,
            61.132193
          ],
          [
            11.585784,
            54.028325,
            60.434189
          ],
          [
            11.586089,
            54.028534,
            59.746833
          ],
          [
            11.586377,
            54.02874,
            59.174648
          ],
          [
            11.586632,
            54.028947,
            59.123926
          ],
          [
            11.586793,
            54.029139,
            59.081381
          ],
          [
            11.586962,
            54.029328,
            59.038983
          ],
          [
            11.587128,
            54.02954,
            58.992681
          ],
          [
            11.587237,
            54.029765,
            58.946258
          ],
          [
            11.587408,
            54.02999,
            58.897169
          ],
          [
            11.587603,
            54.030211,
            58.847779
          ],
          [
            11.587794,
            54.030419,
            59.22148
          ],
          [
            11.587918,
            54.030633,
            59.918839
          ],
          [
            11.58804,
            54.030837,
            60.588069
          ],
          [
            11.588143,
            54.031047,
            61.262773
          ],
          [
            11.588239,
            54.03126,
            61.942568
          ],
          [
            11.588456,
            54.031402,
            62.531094
          ],
          [
            11.588442,
            54.031606,
            63.167154
          ],
          [
            11.588527,
            54.031803,
            63.793999
          ],
          [
            11.588739,
            54.03197,
            64.298783
          ],
          [
            11.588792,
            54.032152,
            63.854235
          ],
          [
            11.588767,
            54.032369,
            63.35249
          ],
          [
            11.588824,
            54.032573,
            62.869907
          ],
          [
            11.588932,
            54.032784,
            62.361785
          ],
          [
            11.589056,
            54.032981,
            61.876937
          ],
          [
            11.58918,
            54.033209,
            61.324932
          ],
          [
            11.58931,
            54.033463,
            60.713267
          ],
          [
            11.589461,
            54.033739,
            60.135187
          ],
          [
            11.589644,
            54.034007,
            59.806011
          ],
          [
            11.589779,
            54.03426,
            59.503794
          ],
          [
            11.589921,
            54.03446,
            59.2567
          ],
          [
            11.590057,
            54.03466,
            59.010722
          ],
          [
            11.590148,
            54.03485,
            58.785732
          ],
          [
            11.590248,
            54.035056,
            58.541381
          ],
          [
            11.590375,
            54.035239,
            58.316125
          ],
          [
            11.590413,
            54.035499,
            57.89236
          ],
          [
            11.590577,
            54.035708,
            57.415469
          ],
          [
            11.590698,
            54.035888,
            57.017082
          ],
          [
            11.590801,
            54.036074,
            56.614805
          ],
          [
            11.590894,
            54.036255,
            56.224516
          ],
          [
            11.591046,
            54.03648,
            55.726821
          ],
          [
            11.591167,
            54.036696,
            55.259214
          ],
          [
            11.591357,
            54.036896,
            54.788194
          ],
          [
            11.591595,
            54.037109,
            54.142149
          ],
          [
            11.591763,
            54.037302,
            53.44172
          ],
          [
            11.591951,
            54.037502,
            52.703523
          ],
          [
            11.59217,
            54.037693,
            51.958118
          ],
          [
            11.592361,
            54.037911,
            51.163961
          ],
          [
            11.592601,
            54.038105,
            50.381975
          ],
          [
            11.592961,
            54.038173,
            49.645189
          ],
          [
            11.593349,
            54.038135,
            48.890574
          ],
          [
            11.593622,
            54.038014,
            48.791492
          ],
          [
            11.593924,
            54.037878,
            49.008725
          ],
          [
            11.594178,
            54.03774,
            49.206231
          ],
          [
            11.594437,
            54.037617,
            49.396309
          ],
          [
            11.594748,
            54.037483,
            49.617545
          ],
          [
            11.595087,
            54.037452,
            49.819038
          ],
          [
            11.595421,
            54.037496,
            50.014372
          ],
          [
            11.595729,
            54.037546,
            50.196738
          ],
          [
            11.596068,
            54.037623,
            50.404164
          ],
          [
            11.596386,
            54.037721,
            50.921422
          ],
          [
            11.596742,
            54.037771,
            51.456678
          ],
          [
            11.59711,
            54.037791,
            51.997992
          ],
          [
            11.597434,
            54.037813,
            52.474951
          ],
          [
            11.597775,
            54.037817,
            52.973323
          ],
          [
            11.59811,
            54.037856,
            53.47271
          ],
          [
            11.598441,
            54.037869,
            53.959914
          ],
          [
            11.598751,
            54.037882,
            54.413945
          ],
          [
            11.599083,
            54.037892,
            54.89087
          ],
          [
            11.599412,
            54.037906,
            55.066232
          ],
          [
            11.599783,
            54.037924,
            55.264523
          ],
          [
            11.600115,
            54.037937,
            55.441415
          ],
          [
            11.600468,
            54.037956,
            55.629894
          ],
          [
            11.600797,
            54.037967,
            55.805093
          ],
          [
            11.601163,
            54.037993,
            56.001483
          ],
          [
            11.60152,
            54.038013,
            56.192164
          ],
          [
            11.601848,
            54.038041,
            56.368381
          ],
          [
            11.602201,
            54.038081,
            56.566701
          ],
          [
            11.602575,
            54.038106,
            56.794729
          ],
          [
            11.602925,
            54.038122,
            57.007873
          ],
          [
            11.603285,
            54.038119,
            57.226823
          ],
          [
            11.6037,
            54.038106,
            57.479317
          ],
          [
            11.604032,
            54.038084,
            57.681467
          ],
          [
            11.604361,
            54.038149,
            57.892347
          ],
          [
            11.604715,
            54.038197,
            58.112237
          ],
          [
            11.60508,
            54.038317,
            58.365569
          ],
          [
            11.605385,
            54.038378,
            58.188162
          ],
          [
            11.605684,
            54.038437,
            58.011928
          ],
          [
            11.606045,
            54.038535,
            57.788899
          ],
          [
            11.6064,
            54.038613,
            57.577171
          ],
          [
            11.60679,
            54.038676,
            57.351333
          ],
          [
            11.60713,
            54.038732,
            57.153779
          ],
          [
            11.607513,
            54.038804,
            56.929247
          ],
          [
            11.607888,
            54.038881,
            56.707316
          ],
          [
            11.608281,
            54.038947,
            56.307166
          ],
          [
            11.608704,
            54.039039,
            55.81239
          ],
          [
            11.609124,
            54.039121,
            55.326934
          ],
          [
            11.609499,
            54.039213,
            54.880753
          ],
          [
            11.609812,
            54.039311,
            54.4917
          ],
          [
            11.610177,
            54.039422,
            54.040786
          ],
          [
            11.610526,
            54.039526,
            53.611528
          ],
          [
            11.610916,
            54.03965,
            53.444118
          ],
          [
            11.611271,
            54.039772,
            53.827407
          ],
          [
            11.611587,
            54.039859,
            54.15248
          ],
          [
            11.611899,
            54.039968,
            54.490612
          ],
          [
            11.612264,
            54.040078,
            54.87272
          ],
          [
            11.612621,
            54.040182,
            55.243986
          ],
          [
            11.612963,
            54.040297,
            55.611391
          ],
          [
            11.613274,
            54.040379,
            55.928902
          ],
          [
            11.613589,
            54.040472,
            56.289576
          ],
          [
            11.613927,
            54.04053,
            56.717191
          ],
          [
            11.614287,
            54.040501,
            57.156634
          ],
          [
            11.614633,
            54.040462,
            57.581757
          ],
          [
            11.614976,
            54.040414,
            58.007415
          ],
          [
            11.615291,
            54.040373,
            58.396778
          ],
          [
            11.61563,
            54.040331,
            58.814936
          ],
          [
            11.615959,
            54.040289,
            59.221363
          ],
          [
            11.616316,
            54.040246,
            59.66121
          ],
          [
            11.616667,
            54.040189,
            59.924764
          ],
          [
            11.617027,
            54.040143,
            60.06185
          ],
          [
            11.61737,
            54.040093,
            60.193332
          ],
          [
            11.617722,
            54.040049,
            60.327545
          ],
          [
            11.618047,
            54.040051,
            60.455075
          ],
          [
            11.618418,
            54.040006,
            60.596216
          ],
          [
            11.618781,
            54.039945,
            60.736789
          ],
          [
            11.619116,
            54.039886,
            60.866931
          ],
          [
            11.619501,
            54.039827,
            61.095559
          ],
          [
            11.619846,
            54.039779,
            61.588744
          ],
          [
            11.620172,
            54.039715,
            62.066446
          ],
          [
            11.620498,
            54.039656,
            62.540542
          ],
          [
            11.620801,
            54.039573,
            63.007789
          ],
          [
            11.621116,
            54.039647,
            63.497157
          ],
          [
            11.621239,
            54.039832,
            63.970057
          ],
          [
            11.621259,
            54.04003,
            64.439973
          ],
          [
            11.621254,
            54.040233,
            64.922947
          ],
          [
            11.62127,
            54.040445,
            65.291875
          ],
          [
            11.621303,
            54.040656,
            65.425905
          ],
          [
            11.621307,
            54.040887,
            65.571679
          ],
          [
            11.621316,
            54.041105,
            65.709202
          ],
          [
            11.621294,
            54.041306,
            65.836235
          ],
          [
            11.621245,
            54.041523,
            65.974281
          ],
          [
            11.621197,
            54.04175,
            66.118837
          ],
          [
            11.62111,
            54.041979,
            66.266953
          ],
          [
            11.621008,
            54.042206,
            66.129704
          ],
          [
            11.620936,
            54.042432,
            65.194434
          ],
          [
            11.62084,
            54.042631,
            64.352903
          ],
          [
            11.620725,
            54.042847,
            63.428191
          ],
          [
            11.620616,
            54.043069,
            62.487262
          ],
          [
            11.620524,
            54.043292,
            61.553602
          ],
          [
            11.620443,
            54.04351,
            60.645548
          ],
          [
            11.620365,
            54.043715,
            59.790985
          ],
          [
            11.620285,
            54.04393,
            59.002318
          ],
          [
            11.620179,
            54.044164,
            58.660712
          ],
          [
            11.620101,
            54.044364,
            58.37146
          ],
          [
            11.62001,
            54.044564,
            58.079494
          ],
          [
            11.619926,
            54.044751,
            57.806853
          ],
          [
            11.619838,
            54.044965,
            57.496407
          ],
          [
            11.619769,
            54.045152,
            57.226437
          ],
          [
            11.619678,
            54.045337,
            56.954964
          ],
          [
            11.619605,
            54.045519,
            56.691301
          ],
          [
            11.619527,
            54.045734,
            56.664073
          ],
          [
            11.619429,
            54.045926,
            56.937603
          ],
          [
            11.619353,
            54.046113,
            57.199897
          ],
          [
            11.619266,
            54.046344,
            57.523063
          ],
          [
            11.619164,
            54.046586,
            57.863188
          ],
          [
            11.619067,
            54.046792,
            58.154806
          ],
          [
            11.618945,
            54.047015,
            58.474387
          ],
          [
            11.618836,
            54.047249,
            58.805521
          ],
          [
            11.618722,
            54.047472,
            59.102781
          ],
          [
            11.618615,
            54.047683,
            59.360629
          ],
          [
            11.61848,
            54.047893,
            59.623696
          ],
          [
            11.618158,
            54.048003,
            59.885293
          ],
          [
            11.618062,
            54.048212,
            60.138946
          ],
          [
            11.617982,
            54.0484,
            60.365889
          ],
          [
            11.617886,
            54.0486,
            60.609309
          ],
          [
            11.617787,
            54.04881,
            60.864541
          ],
          [
            11.617685,
            54.049037,
            60.972063
          ],
          [
            11.617563,
            54.049275,
            60.365821
          ],
          [
            11.617447,
            54.049521,
            59.743215
          ],
          [
            11.617332,
            54.049784,
            59.079756
          ],
          [
            11.617212,
            54.050053,
            58.401489
          ],
          [
            11.617084,
            54.050346,
            57.663686
          ],
          [
            11.616934,
            54.050639,
            56.917205
          ],
          [
            11.616805,
            54.050914,
            56.243203
          ],
          [
            11.616714,
            54.051171,
            55.632384
          ],
          [
            11.616609,
            54.051405,
            55.069185
          ],
          [
            11.616516,
            54.051617,
            54.559691
          ],
          [
            11.616451,
            54.051802,
            54.119534
          ],
          [
            11.616378,
            54.051995,
            53.659483
          ],
          [
            11.616318,
            54.052182,
            53.216697
          ],
          [
            11.616226,
            54.052416,
            52.657565
          ],
          [
            11.616126,
            54.052603,
            52.108279
          ],
          [
            11.616033,
            54.052789,
            51.521811
          ],
          [
            11.615948,
            54.052978,
            50.928103
          ],
          [
            11.615877,
            54.053185,
            50.290144
          ],
          [
            11.615781,
            54.053409,
            49.592016
          ],
          [
            11.615702,
            54.053588,
            49.032113
          ],
          [
            11.615613,
            54.05381,
            48.342933
          ],
          [
            11.615542,
            54.054014,
            47.71381
          ],
          [
            11.61544,
            54.054258,
            46.996206
          ],
          [
            11.615362,
            54.054443,
            46.614053
          ],
          [
            11.615256,
            54.054666,
            46.148455
          ],
          [
            11.615324,
            54.054884,
            45.673586
          ],
          [
            11.615422,
            54.055055,
            45.243473
          ],
          [
            11.615294,
            54.055271,
            44.785028
          ],
          [
            11.615181,
            54.055492,
            44.320951
          ],
          [
            11.615067,
            54.055721,
            43.842296
          ],
          [
            11.614997,
            54.055938,
            43.528868
          ],
          [
            11.614844,
            54.056103,
            43.812029
          ],
          [
            11.615156,
            54.05612,
            44.089606
          ],
          [
            11.615348,
            54.056293,
            44.400485
          ],
          [
            11.615614,
            54.056451,
            44.734907
          ],
          [
            11.615839,
            54.056614,
            45.050745
          ],
          [
            11.616037,
            54.056763,
            45.336033
          ],
          [
            11.616244,
            54.056922,
            45.637348
          ],
          [
            11.616545,
            54.057147,
            46.068159
          ],
          [
            11.616796,
            54.057314,
            45.945925
          ],
          [
            11.616972,
            54.057466,
            45.653332
          ],
          [
            11.617158,
            54.057629,
            45.341487
          ],
          [
            11.61741,
            54.057807,
            44.973578
          ],
          [
            11.617627,
            54.057975,
            44.637881
          ],
          [
            11.617764,
            54.058175,
            44.294733
          ],
          [
            11.617989,
            54.05835,
            43.945833
          ],
          [
            11.618264,
            54.058549,
            43.538528
          ],
          [
            11.618517,
            54.05876,
            43.403543
          ],
          [
            11.618746,
            54.058981,
            43.577126
          ],
          [
            11.618956,
            54.059197,
            43.744034
          ],
          [
            11.619123,
            54.059396,
            43.892947
          ],
          [
            11.619379,
            54.05962,
            44.074081
          ],
          [
            11.619545,
            54.05979,
            44.205667
          ],
          [
            11.619707,
            54.059964,
            44.339407
          ],
          [
            11.619871,
            54.060171,
            44.492594
          ],
          [
            11.620115,
            54.060309,
            44.697829
          ],
          [
            11.620382,
            54.060469,
            44.958175
          ],
          [
            11.620662,
            54.06063,
            45.225668
          ],
          [
            11.620913,
            54.060768,
            45.46047
          ],
          [
            11.621125,
            54.060903,
            45.673947
          ],
          [
            11.62133,
            54.061077,
            45.920938
          ],
          [
            11.621569,
            54.061229,
            46.161469
          ],
          [
            11.621816,
            54.061378,
            46.403147
          ],
          [
            11.622057,
            54.061518,
            46.622477
          ],
          [
            11.622277,
            54.061657,
            46.664673
          ],
          [
            11.622512,
            54.061806,
            46.709807
          ],
          [
            11.622739,
            54.061952,
            46.753735
          ],
          [
            11.622929,
            54.062097,
            46.794391
          ],
          [
            11.623194,
            54.062232,
            46.84021
          ],
          [
            11.623439,
            54.062378,
            46.885876
          ],
          [
            11.623722,
            54.06255,
            46.939018
          ],
          [
            11.623975,
            54.062688,
            46.984074
          ],
          [
            11.624253,
            54.062864,
            47.059551
          ],
          [
            11.624501,
            54.063036,
            47.171258
          ],
          [
            11.624743,
            54.063183,
            47.272364
          ],
          [
            11.624921,
            54.063335,
            47.363609
          ],
          [
            11.625163,
            54.063493,
            47.46873
          ],
          [
            11.625421,
            54.063633,
            47.570737
          ],
          [
            11.625672,
            54.063783,
            47.674709
          ],
          [
            11.625912,
            54.063931,
            47.775756
          ],
          [
            11.626144,
            54.064082,
            47.876358
          ],
          [
            11.626355,
            54.064261,
            47.952592
          ],
          [
            11.626464,
            54.064448,
            48.009313
          ],
          [
            11.626527,
            54.064648,
            48.067672
          ],
          [
            11.626657,
            54.064858,
            48.13192
          ],
          [
            11.626774,
            54.06505,
            48.190462
          ],
          [
            11.626907,
            54.065253,
            48.253058
          ],
          [
            11.627071,
            54.065471,
            48.321444
          ],
          [
            11.627232,
            54.065702,
            48.393067
          ],
          [
            11.627398,
            54.065939,
            48.454359
          ],
          [
            11.627584,
            54.066167,
            48.505618
          ],
          [
            11.627735,
            54.066406,
            48.5573
          ],
          [
            11.627873,
            54.066618,
            48.603318
          ],
          [
            11.628028,
            54.066785,
            48.641922
          ],
          [
            11.628152,
            54.066965,
            48.681345
          ],
          [
            11.628281,
            54.067159,
            48.723654
          ],
          [
            11.628403,
            54.067339,
            48.763032
          ],
          [
            11.628553,
            54.067544,
            48.682109
          ],
          [
            11.628703,
            54.067746,
            48.425162
          ],
          [
            11.628858,
            54.06795,
            48.164416
          ],
          [
            11.629035,
            54.068173,
            47.877347
          ],
          [
            11.629186,
            54.068387,
            47.607276
          ],
          [
            11.629334,
            54.068603,
            47.335823
          ],
          [
            11.629517,
            54.068829,
            47.044061
          ],
          [
            11.629689,
            54.069059,
            46.751186
          ],
          [
            11.629851,
            54.069299,
            46.455849
          ],
          [
            11.630011,
            54.06954,
            46.161147
          ],
          [
            11.630203,
            54.06978,
            45.859239
          ],
          [
            11.630328,
            54.069956,
            45.641801
          ],
          [
            11.630445,
            54.070131,
            45.427677
          ],
          [
            11.630559,
            54.070316,
            45.203178
          ],
          [
            11.630714,
            54.070544,
            44.923654
          ],
          [
            11.630848,
            54.070713,
            44.711261
          ],
          [
            11.630968,
            54.070893,
            44.629265
          ],
          [
            11.631109,
            54.071095,
            44.604621
          ],
          [
            11.631254,
            54.071273,
            44.582343
          ],
          [
            11.631378,
            54.071445,
            44.561258
          ],
          [
            11.63153,
            54.071655,
            44.535489
          ],
          [
            11.631642,
            54.071826,
            44.514802
          ],
          [
            11.63178,
            54.072029,
            44.490043
          ],
          [
            11.631887,
            54.072241,
            44.465064
          ],
          [
            11.631925,
            54.07243,
            44.44356
          ],
          [
            11.631933,
            54.072662,
            44.675653
          ],
          [
            11.631923,
            54.072848,
            44.880682
          ],
          [
            11.631945,
            54.073076,
            45.132464
          ],
          [
            11.631937,
            54.073317,
            45.397612
          ],
          [
            11.631952,
            54.073558,
            45.664815
          ],
          [
            11.631944,
            54.073764,
            45.892056
          ],
          [
            11.632098,
            54.073931,
            46.101472
          ],
          [
            11.632251,
            54.074129,
            46.340522
          ],
          [
            11.632408,
            54.074331,
            46.365297
          ],
          [
            11.632579,
            54.074514,
            46.290975
          ],
          [
            11.632775,
            54.074688,
            46.216676
          ],
          [
            11.632921,
            54.074884,
            46.14045
          ],
          [
            11.633054,
            54.075101,
            46.058196
          ],
          [
            11.633142,
            54.075288,
            45.989002
          ],
          [
            11.633211,
            54.075497,
            45.913187
          ],
          [
            11.633252,
            54.07571,
            45.836779
          ],
          [
            11.63326,
            54.075937,
            45.8176
          ],
          [
            11.633174,
            54.076175,
            45.967592
          ],
          [
            11.633015,
            54.076371,
            46.10184
          ],
          [
            11.632841,
            54.076574,
            46.242006
          ],
          [
            11.632719,
            54.076745,
            46.356331
          ],
          [
            11.632564,
            54.07694,
            46.488837
          ],
          [
            11.632327,
            54.077147,
            46.642344
          ],
          [
            11.63215,
            54.077363,
            46.78993
          ],
          [
            11.631977,
            54.077567,
            46.80669
          ],
          [
            11.631811,
            54.077767,
            46.563766
          ],
          [
            11.63162,
            54.077983,
            46.298204
          ],
          [
            11.631432,
            54.0782,
            46.032554
          ],
          [
            11.631268,
            54.078418,
            45.772413
          ],
          [
            11.631142,
            54.078651,
            45.505073
          ],
          [
            11.631114,
            54.078881,
            45.252632
          ],
          [
            11.63112,
            54.079068,
            45.048517
          ],
          [
            11.631153,
            54.079255,
            44.884532
          ],
          [
            11.631183,
            54.079447,
            44.783219
          ],
          [
            11.631216,
            54.079632,
            44.685389
          ],
          [
            11.631259,
            54.079857,
            44.566473
          ],
          [
            11.631284,
            54.080065,
            44.456897
          ],
          [
            11.631292,
            54.080302,
            44.332216
          ],
          [
            11.631305,
            54.080501,
            44.227564
          ],
          [
            11.631294,
            54.080701,
            44.122445
          ],
          [
            11.631309,
            54.080923,
            44.005705
          ],
          [
            11.63128,
            54.081165,
            44.284739
          ],
          [
            11.631161,
            54.0814,
            44.678597
          ],
          [
            11.631165,
            54.081643,
            45.068306
          ],
          [
            11.631181,
            54.08185,
            45.400349
          ],
          [
            11.631194,
            54.082047,
            45.716211
          ],
          [
            11.631224,
            54.082241,
            46.028308
          ],
          [
            11.63123,
            54.082453,
            46.368327
          ],
          [
            11.631257,
            54.082665,
            46.709026
          ],
          [
            11.631265,
            54.082866,
            46.865816
          ],
          [
            11.631255,
            54.083078,
            46.877598
          ],
          [
            11.63129,
            54.083283,
            46.889045
          ],
          [
            11.631304,
            54.083497,
            46.900957
          ],
          [
            11.631323,
            54.083719,
            46.913306
          ],
          [
            11.631324,
            54.083957,
            46.926539
          ],
          [
            11.631331,
            54.084201,
            46.940096
          ],
          [
            11.631313,
            54.084419,
            46.952221
          ],
          [
            11.631312,
            54.084643,
            46.9637
          ],
          [
            11.631331,
            54.0849,
            46.975085
          ],
          [
            11.631361,
            54.085119,
            46.984809
          ],
          [
            11.631361,
            54.085341,
            46.994634
          ],
          [
            11.631379,
            54.085563,
            47.00447
          ],
          [
            11.631375,
            54.085793,
            47.01465
          ],
          [
            11.631369,
            54.086002,
            47.02393
          ],
          [
            11.631376,
            54.086213,
            47.03327
          ],
          [
            11.631404,
            54.086424,
            47.073052
          ],
          [
            11.631422,
            54.086633,
            47.169374
          ],
          [
            11.63142,
            54.086832,
            47.261122
          ],
          [
            11.631406,
            54.087043,
            47.358273
          ],
          [
            11.631507,
            54.087231,
            47.449615
          ],
          [
            11.631523,
            54.087456,
            47.55317
          ],
          [
            11.631538,
            54.087652,
            47.64335
          ],
          [
            11.631548,
            54.087881,
            47.748646
          ],
          [
            11.631374,
            54.088063,
            47.850944
          ],
          [
            11.63142,
            54.088258,
            48.004449
          ],
          [
            11.63152,
            54.088458,
            48.169808
          ],
          [
            11.631584,
            54.088656,
            48.329486
          ],
          [
            11.631657,
            54.088878,
            48.508633
          ],
          [
            11.63173,
            54.0891,
            48.687788
          ],
          [
            11.631827,
            54.089316,
            48.864792
          ],
          [
            11.63194,
            54.089513,
            49.029725
          ],
          [
            11.632066,
            54.089702,
            49.190527
          ],
          [
            11.632182,
            54.089881,
            49.221119
          ],
          [
            11.632293,
            54.090089,
            48.985832
          ],
          [
            11.632415,
            54.090283,
            48.762406
          ],
          [
            11.63256,
            54.090493,
            48.517864
          ],
          [
            11.632703,
            54.090693,
            48.283733
          ],
          [
            11.632879,
            54.090888,
            48.045062
          ],
          [
            11.633021,
            54.091123,
            47.775766
          ],
          [
            11.633191,
            54.09132,
            47.537332
          ],
          [
            11.633327,
            54.091501,
            47.331075
          ],
          [
            11.633465,
            54.09169,
            47.173733
          ],
          [
            11.633591,
            54.091873,
            47.02215
          ],
          [
            11.633713,
            54.092041,
            46.88228
          ],
          [
            11.633847,
            54.092244,
            46.715432
          ],
          [
            11.633989,
            54.092452,
            46.543956
          ],
          [
            11.634142,
            54.092677,
            46.358608
          ],
          [
            11.634277,
            54.092893,
            46.182519
          ],
          [
            11.634441,
            54.093082,
            46.020062
          ],
          [
            11.634562,
            54.093263,
            46.201787
          ],
          [
            11.634683,
            54.093436,
            46.520597
          ],
          [
            11.634839,
            54.093634,
            46.892287
          ],
          [
            11.634997,
            54.093857,
            47.303837
          ],
          [
            11.635129,
            54.09408,
            47.70646
          ],
          [
            11.635305,
            54.094285,
            48.099199
          ],
          [
            11.635542,
            54.094484,
            48.513225
          ],
          [
            11.635756,
            54.0947,
            48.940047
          ],
          [
            11.635912,
            54.094939,
            48.697531
          ],
          [
            11.636026,
            54.095184,
            48.26022
          ],
          [
            11.636108,
            54.095386,
            47.902662
          ],
          [
            11.636119,
            54.095631,
            47.480636
          ],
          [
            11.63607,
            54.095844,
            47.110472
          ],
          [
            11.635999,
            54.096055,
            46.740124
          ],
          [
            11.635903,
            54.096244,
            46.400217
          ],
          [
            11.63577,
            54.096439,
            46.038573
          ],
          [
            11.635593,
            54.096657,
            45.889813
          ],
          [
            11.63534,
            54.09683,
            45.826292
          ],
          [
            11.63504,
            54.097,
            45.758088
          ],
          [
            11.634805,
            54.097145,
            45.702343
          ],
          [
            11.634536,
            54.097298,
            45.641124
          ],
          [
            11.634237,
            54.097453,
            45.5759
          ],
          [
            11.63392,
            54.097575,
            45.513959
          ],
          [
            11.633622,
            54.097757,
            45.443578
          ],
          [
            11.633419,
            54.097896,
            45.561266
          ],
          [
            11.633105,
            54.098074,
            45.741217
          ],
          [
            11.632798,
            54.098255,
            45.920614
          ],
          [
            11.632498,
            54.098401,
            46.081292
          ],
          [
            11.63226,
            54.098525,
            46.212535
          ],
          [
            11.631974,
            54.098616,
            46.34664
          ],
          [
            11.631648,
            54.098751,
            46.511083
          ],
          [
            11.631384,
            54.098858,
            46.643399
          ],
          [
            11.631051,
            54.098958,
            46.581819
          ],
          [
            11.630668,
            54.099046,
            46.359917
          ],
          [
            11.630308,
            54.099128,
            46.151581
          ],
          [
            11.629961,
            54.099216,
            45.947638
          ],
          [
            11.62965,
            54.0993,
            45.762901
          ],
          [
            11.629294,
            54.099369,
            45.56064
          ],
          [
            11.628886,
            54.099458,
            45.325408
          ],
          [
            11.628573,
            54.09952,
            45.147183
          ],
          [
            11.628205,
            54.099589,
            44.998199
          ],
          [
            11.627904,
            54.099633,
            44.920696
          ],
          [
            11.627548,
            54.099686,
            44.828916
          ],
          [
            11.627149,
            54.099726,
            44.727765
          ],
          [
            11.626712,
            54.099786,
            44.615661
          ],
          [
            11.626301,
            54.099847,
            44.509791
          ],
          [
            11.625912,
            54.099911,
            44.40875
          ],
          [
            11.625523,
            54.099964,
            44.309014
          ],
          [
            11.625093,
            54.100013,
            44.653608
          ],
          [
            11.624732,
            54.10006,
            45.061653
          ],
          [
            11.624402,
            54.100104,
            45.435703
          ],
          [
            11.624041,
            54.100138,
            45.838242
          ],
          [
            11.623689,
            54.100187,
            46.237086
          ],
          [
            11.623401,
            54.10027,
            46.612732
          ],
          [
            11.62308,
            54.100338,
            46.989947
          ],
          [
            11.622744,
            54.100362,
            47.363062
          ],
          [
            11.6224,
            54.100367,
            47.702884
          ],
          [
            11.622059,
            54.100394,
            47.898374
          ],
          [
            11.621741,
            54.100413,
            48.080071
          ],
          [
            11.621395,
            54.100423,
            48.276878
          ],
          [
            11.621013,
            54.10044,
            48.494544
          ],
          [
            11.620677,
            54.100458,
            48.68626
          ],
          [
            11.620328,
            54.100484,
            48.886121
          ],
          [
            11.619952,
            54.100506,
            49.100831
          ],
          [
            11.619619,
            54.100524,
            49.290819
          ],
          [
            11.619268,
            54.100564,
            49.242929
          ],
          [
            11.618961,
            54.100668,
            48.888443
          ],
          [
            11.618646,
            54.100803,
            48.498861
          ],
          [
            11.618369,
            54.100954,
            48.121661
          ],
          [
            11.618071,
            54.101116,
            47.717077
          ],
          [
            11.617761,
            54.10128,
            47.301425
          ],
          [
            11.617503,
            54.10142,
            46.951475
          ],
          [
            11.61728,
            54.101561,
            46.624992
          ],
          [
            11.61702,
            54.101698,
            46.326463
          ],
          [
            11.616754,
            54.101845,
            46.211579
          ],
          [
            11.616485,
            54.101976,
            46.101568
          ],
          [
            11.6162,
            54.102125,
            45.981585
          ],
          [
            11.615937,
            54.102291,
            45.860138
          ],
          [
            11.615689,
            54.102483,
            45.731067
          ],
          [
            11.615448,
            54.102675,
            45.603262
          ],
          [
            11.615212,
            54.102863,
            45.478168
          ],
          [
            11.614963,
            54.103045,
            45.348867
          ],
          [
            11.614724,
            54.103209,
            45.218344
          ],
          [
            11.614437,
            54.103377,
            45.074495
          ],
          [
            11.614187,
            54.103512,
            44.953956
          ],
          [
            11.613901,
            54.103635,
            44.827952
          ],
          [
            11.613603,
            54.103764,
            44.696571
          ],
          [
            11.613245,
            54.103918,
            44.53907
          ],
          [
            11.612922,
            54.104044,
            44.401337
          ],
          [
            11.612575,
            54.10416,
            44.274166
          ],
          [
            11.612185,
            54.104275,
            44.178469
          ],
          [
            11.61179,
            54.104368,
            44.08524
          ],
          [
            11.611465,
            54.104454,
            44.007144
          ],
          [
            11.611156,
            54.104551,
            43.930359
          ],
          [
            11.610809,
            54.104629,
            43.848954
          ],
          [
            11.610498,
            54.104711,
            43.774268
          ],
          [
            11.610174,
            54.10477,
            43.699959
          ],
          [
            11.610051,
            54.104583,
            43.626013
          ],
          [
            11.609968,
            54.104396,
            43.654313
          ],
          [
            11.609641,
            54.104363,
            43.684233
          ],
          [
            11.609313,
            54.104346,
            43.71251
          ],
          [
            11.608956,
            54.104322,
            43.743365
          ],
          [
            11.608589,
            54.104304,
            43.775021
          ],
          [
            11.608228,
            54.104305,
            43.806092
          ],
          [
            11.607884,
            54.104318,
            43.836385
          ],
          [
            11.6076,
            54.104389,
            43.864499
          ],
          [
            11.607384,
            54.104503,
            43.879617
          ],
          [
            11.607321,
            54.104331,
            43.756531
          ],
          [
            11.607097,
            54.104227,
            43.640523
          ],
          [
            11.606791,
            54.104114,
            43.498602
          ],
          [
            11.606808,
            54.104139,
            43.379939
          ],
          [
            11.607102,
            54.104245,
            43.232469
          ],
          [
            11.607404,
            54.104326,
            43.110812
          ],
          [
            11.607395,
            54.104505,
            42.994405
          ],
          [
            11.607213,
            54.104674,
            42.869559
          ],
          [
            11.606998,
            54.104814,
            42.797377
          ],
          [
            11.60696,
            54.104952,
            43.0571
          ],
          [
            11.606585,
            54.105083,
            43.385197
          ],
          [
            11.606858,
            54.104996,
            43.61871
          ],
          [
            11.607244,
            54.104942,
            43.920869
          ],
          [
            11.607624,
            54.104997,
            44.214865
          ],
          [
            11.607927,
            54.105046,
            44.450949
          ],
          [
            11.608252,
            54.105132,
            44.718765
          ],
          [
            11.608563,
            54.105205,
            44.976042
          ],
          [
            11.608846,
            54.105313,
            45.484194
          ],
          [
            11.609167,
            54.105418,
            46.195275
          ],
          [
            11.609485,
            54.105503,
            46.866442
          ],
          [
            11.609805,
            54.105567,
            47.515133
          ],
          [
            11.610117,
            54.105629,
            48.148203
          ],
          [
            11.610466,
            54.105666,
            48.82865
          ],
          [
            11.610803,
            54.1057,
            49.489624
          ],
          [
            11.61112,
            54.105777,
            50.148264
          ],
          [
            11.611454,
            54.105832,
            50.81768
          ],
          [
            11.6118,
            54.105827,
            51.051439
          ],
          [
            11.612148,
            54.10578,
            51.17359
          ],
          [
            11.612475,
            54.105698,
            51.295235
          ],
          [
            11.612834,
            54.10562,
            51.42639
          ],
          [
            11.613165,
            54.105589,
            51.541313
          ],
          [
            11.613495,
            54.105647,
            51.65926
          ],
          [
            11.613818,
            54.105772,
            51.791648
          ],
          [
            11.614155,
            54.105908,
            51.931582
          ],
          [
            11.614468,
            54.106021,
            52.209113
          ],
          [
            11.614781,
            54.106123,
            52.697132
          ],
          [
            11.61511,
            54.10622,
            53.19763
          ],
          [
            11.615491,
            54.10626,
            53.724511
          ],
          [
            11.615826,
            54.106226,
            54.194916
          ],
          [
            11.615801,
            54.106249,
            54.645158
          ],
          [
            11.615484,
            54.106345,
            55.139555
          ],
          [
            11.615695,
            54.106498,
            55.610794
          ],
          [
            11.61599,
            54.106628,
            56.111348
          ],
          [
            11.616248,
            54.106759,
            56.576949
          ],
          [
            11.616492,
            54.106892,
            57.032568
          ],
          [
            11.616768,
            54.107014,
            57.504573
          ],
          [
            11.617068,
            54.107142,
            58.011194
          ],
          [
            11.617334,
            54.107264,
            58.476185
          ],
          [
            11.617584,
            54.107392,
            58.932038
          ],
          [
            11.61786,
            54.107515,
            59.405378
          ],
          [
            11.618113,
            54.107641,
            59.858583
          ],
          [
            11.618358,
            54.107752,
            60.281405
          ],
          [
            11.618668,
            54.107883,
            60.60446
          ],
          [
            11.618919,
            54.108012,
            60.858359
          ],
          [
            11.619174,
            54.108161,
            61.132103
          ],
          [
            11.619501,
            54.108283,
            61.426827
          ],
          [
            11.619781,
            54.108403,
            61.690166
          ],
          [
            11.620061,
            54.108529,
            61.958116
          ],
          [
            11.620385,
            54.108639,
            62.242328
          ],
          [
            11.620702,
            54.108764,
            62.532485
          ],
          [
            11.620966,
            54.108863,
            62.664123
          ],
          [
            11.621253,
            54.108982,
            62.600426
          ],
          [
            11.621554,
            54.109108,
            62.533554
          ],
          [
            11.621838,
            54.109237,
            62.468304
          ],
          [
            11.622094,
            54.109371,
            62.406219
          ],
          [
            11.622383,
            54.109503,
            62.339981
          ],
          [
            11.622688,
            54.109666,
            62.264999
          ],
          [
            11.622946,
            54.109819,
            62.198599
          ],
          [
            11.623227,
            54.109983,
            62.141067
          ],
          [
            11.623469,
            54.110132,
            62.368263
          ],
          [
            11.623723,
            54.110272,
            62.593876
          ],
          [
            11.623991,
            54.110421,
            62.832911
          ],
          [
            11.62427,
            54.110553,
            63.06498
          ],
          [
            11.624522,
            54.110684,
            63.28305
          ],
          [
            11.624736,
            54.110826,
            63.493163
          ],
          [
            11.624978,
            54.110955,
            63.7051
          ],
          [
            11.625234,
            54.11106,
            63.907294
          ],
          [
            11.625507,
            54.111197,
            64.171985
          ],
          [
            11.625758,
            54.111334,
            64.680768
          ],
          [
            11.62603,
            54.111502,
            65.266924
          ],
          [
            11.626231,
            54.111647,
            65.739846
          ],
          [
            11.62644,
            54.111788,
            66.212649
          ],
          [
            11.626665,
            54.111955,
            66.751602
          ],
          [
            11.626883,
            54.112107,
            67.254187
          ],
          [
            11.627093,
            54.112246,
            67.724212
          ],
          [
            11.627373,
            54.112406,
            68.304373
          ],
          [
            11.627642,
            54.112544,
            68.833994
          ],
          [
            11.627909,
            54.11265,
            69.308444
          ],
          [
            11.628223,
            54.112752,
            69.837177
          ],
          [
            11.628524,
            54.112857,
            70.352715
          ],
          [
            11.628883,
            54.112954,
            70.934007
          ],
          [
            11.629233,
            54.113019,
            71.474953
          ],
          [
            11.629487,
            54.113129,
            71.956153
          ],
          [
            11.629768,
            54.113258,
            72.491083
          ],
          [
            11.630072,
            54.113342,
            72.985276
          ],
          [
            11.630398,
            54.113429,
            72.998289
          ],
          [
            11.630741,
            54.113522,
            72.696684
          ],
          [
            11.63109,
            54.113634,
            72.379139
          ],
          [
            11.631396,
            54.113761,
            72.079425
          ],
          [
            11.631697,
            54.113906,
            71.767426
          ],
          [
            11.632015,
            54.114066,
            71.432898
          ],
          [
            11.632325,
            54.114202,
            71.123867
          ],
          [
            11.632608,
            54.114313,
            70.852105
          ],
          [
            11.632928,
            54.114422,
            70.785311
          ],
          [
            11.633217,
            54.114522,
            70.870315
          ],
          [
            11.633525,
            54.114643,
            70.964301
          ],
          [
            11.633851,
            54.11476,
            71.061117
          ],
          [
            11.634163,
            54.114901,
            71.160897
          ],
          [
            11.634456,
            54.115027,
            71.25294
          ],
          [
            11.634731,
            54.115153,
            71.341385
          ],
          [
            11.635004,
            54.115284,
            71.43075
          ],
          [
            11.635345,
            54.115301,
            71.598421
          ],
          [
            11.635606,
            54.115435,
            71.956772
          ],
          [
            11.635886,
            54.11557,
            72.331282
          ],
          [
            11.636149,
            54.115693,
            72.67845
          ],
          [
            11.636401,
            54.115838,
            73.042787
          ],
          [
            11.636655,
            54.115983,
            73.408481
          ],
          [
            11.636888,
            54.116129,
            73.760251
          ],
          [
            11.637147,
            54.11628,
            74.137345
          ],
          [
            11.637397,
            54.116436,
            74.513943
          ],
          [
            11.637632,
            54.116581,
            74.744117
          ],
          [
            11.637879,
            54.116725,
            74.877539
          ],
          [
            11.638121,
            54.116882,
            75.015901
          ],
          [
            11.63836,
            54.117005,
            75.137706
          ],
          [
            11.638629,
            54.117176,
            75.289841
          ],
          [
            11.638911,
            54.117371,
            75.4569
          ],
          [
            11.6392,
            54.11755,
            75.617914
          ],
          [
            11.639445,
            54.117718,
            75.76245
          ],
          [
            11.639656,
            54.117871,
            75.839809
          ],
          [
            11.639887,
            54.118001,
            75.81864
          ],
          [
            11.640175,
            54.11817,
            75.791711
          ],
          [
            11.640394,
            54.118309,
            75.770371
          ],
          [
            11.640625,
            54.118466,
            75.746985
          ],
          [
            11.640877,
            54.11862,
            75.722927
          ],
          [
            11.641153,
            54.118793,
            75.696224
          ],
          [
            11.641426,
            54.118951,
            75.670871
          ],
          [
            11.641675,
            54.119114,
            75.64619
          ],
          [
            11.641896,
            54.119259,
            75.547769
          ],
          [
            11.642152,
            54.11943,
            75.425472
          ],
          [
            11.642423,
            54.119602,
            75.299647
          ],
          [
            11.642651,
            54.119735,
            75.198367
          ],
          [
            11.64292,
            54.119908,
            75.072587
          ],
          [
            11.643184,
            54.120056,
            74.957558
          ],
          [
            11.643415,
            54.120221,
            74.842699
          ],
          [
            11.643632,
            54.120362,
            74.740637
          ],
          [
            11.643806,
            54.120533,
            74.533449
          ],
          [
            11.644014,
            54.120732,
            74.127243
          ],
          [
            11.644227,
            54.120942,
            73.702009
          ],
          [
            11.644404,
            54.121107,
            73.362744
          ],
          [
            11.644608,
            54.121282,
            72.993174
          ],
          [
            11.644846,
            54.121479,
            72.573037
          ],
          [
            11.645108,
            54.121692,
            72.115796
          ],
          [
            11.645354,
            54.121917,
            71.650737
          ],
          [
            11.645581,
            54.122137,
            71.342176
          ],
          [
            11.645819,
            54.122346,
            71.080934
          ],
          [
            11.646055,
            54.122534,
            70.838509
          ],
          [
            11.646278,
            54.122731,
            70.59301
          ],
          [
            11.646498,
            54.122916,
            70.358808
          ],
          [
            11.646696,
            54.123085,
            70.145913
          ],
          [
            11.646952,
            54.123264,
            69.903374
          ],
          [
            11.647156,
            54.123452,
            69.664342
          ],
          [
            11.647357,
            54.123625,
            69.248439
          ],
          [
            11.647599,
            54.123831,
            68.750764
          ],
          [
            11.647809,
            54.124014,
            68.312486
          ],
          [
            11.648006,
            54.124187,
            67.898233
          ],
          [
            11.648233,
            54.124405,
            67.390815
          ],
          [
            11.648985,
            54.125025,
            65.78433
          ],
          [
            11.649178,
            54.125197,
            65.20495
          ],
          [
            11.649388,
            54.125382,
            64.577921
          ],
          [
            11.649647,
            54.125613,
            63.800133
          ],
          [
            11.64994,
            54.125862,
            62.948577
          ],
          [
            11.650224,
            54.12613,
            62.060843
          ],
          [
            11.650544,
            54.126404,
            61.126535
          ],
          [
            11.65089,
            54.126674,
            60.854965
          ],
          [
            11.651237,
            54.126949,
            60.643678
          ],
          [
            11.65155,
            54.127199,
            60.45271
          ],
          [
            11.651784,
            54.12741,
            60.297775
          ],
          [
            11.651996,
            54.127589,
            60.163603
          ],
          [
            11.652227,
            54.127773,
            60.022967
          ],
          [
            11.65242,
            54.127944,
            60.002205
          ],
          [
            11.652632,
            54.128117,
            60.201718
          ],
          [
            11.652875,
            54.128273,
            60.399435
          ],
          [
            11.653127,
            54.128423,
            60.596423
          ],
          [
            11.653398,
            54.128557,
            60.790844
          ],
          [
            11.653656,
            54.128682,
            60.974613
          ],
          [
            11.653967,
            54.128777,
            61.16732
          ],
          [
            11.654252,
            54.128862,
            61.343255
          ],
          [
            11.654559,
            54.128959,
            61.534735
          ],
          [
            11.654851,
            54.129079,
            61.783504
          ],
          [
            11.655152,
            54.129176,
            62.063968
          ],
          [
            11.655419,
            54.129287,
            62.331074
          ],
          [
            11.655696,
            54.129386,
            62.595866
          ],
          [
            11.656055,
            54.129506,
            62.932988
          ],
          [
            11.656379,
            54.129593,
            63.223724
          ],
          [
            11.656728,
            54.129707,
            63.549769
          ],
          [
            11.657023,
            54.129848,
            63.860369
          ],
          [
            11.657355,
            54.129978,
            64.311037
          ],
          [
            11.657634,
            54.130091,
            65.150993
          ],
          [
            11.657864,
            54.13022,
            65.942639
          ],
          [
            11.658066,
            54.13039,
            66.821849
          ],
          [
            11.658204,
            54.130578,
            67.687814
          ],
          [
            11.658333,
            54.130756,
            68.505095
          ],
          [
            11.658539,
            54.130925,
            69.386973
          ],
          [
            11.658852,
            54.130953,
            70.173482
          ],
          [
            11.659167,
            54.130975,
            70.959399
          ],
          [
            11.659544,
            54.131014,
            71.674304
          ],
          [
            11.659945,
            54.131063,
            71.390625
          ],
          [
            11.660352,
            54.131107,
            71.103938
          ],
          [
            11.660725,
            54.131148,
            70.841004
          ],
          [
            11.661068,
            54.131174,
            70.601487
          ],
          [
            11.661418,
            54.131205,
            70.356303
          ],
          [
            11.661743,
            54.131265,
            70.120015
          ],
          [
            11.662154,
            54.131298,
            69.832699
          ],
          [
            11.662522,
            54.131335,
            69.553051
          ],
          [
            11.662897,
            54.131355,
            69.077503
          ],
          [
            11.66322,
            54.131393,
            68.662
          ],
          [
            11.663564,
            54.131445,
            68.213625
          ],
          [
            11.663948,
            54.131468,
            67.724259
          ],
          [
            11.66432,
            54.131471,
            67.254909
          ],
          [
            11.664765,
            54.131475,
            66.693446
          ],
          [
            11.665253,
            54.131484,
            66.077362
          ],
          [
            11.665674,
            54.13147,
            66.169289
          ],
          [
            11.666039,
            54.131434,
            67.302878
          ],
          [
            11.666469,
            54.131359,
            68.672586
          ],
          [
            11.666795,
            54.131285,
            69.741496
          ],
          [
            11.667087,
            54.131193,
            70.76211
          ],
          [
            11.667399,
            54.131115,
            71.799733
          ],
          [
            11.667653,
            54.131003,
            72.770513
          ],
          [
            11.667967,
            54.130945,
            73.775822
          ],
          [
            11.668236,
            54.130836,
            74.774429
          ],
          [
            11.668525,
            54.130713,
            76.336903
          ],
          [
            11.668834,
            54.130632,
            78.002542
          ],
          [
            11.669163,
            54.130579,
            79.683136
          ],
          [
            11.669496,
            54.130524,
            81.385504
          ],
          [
            11.66978,
            54.130433,
            82.978904
          ],
          [
            11.670098,
            54.130346,
            84.705963
          ],
          [
            11.670428,
            54.13029,
            86.398771
          ],
          [
            11.670741,
            54.130252,
            87.972154
          ],
          [
            11.671065,
            54.130222,
            89.586201
          ],
          [
            11.671405,
            54.130187,
            90.215094
          ],
          [
            11.671751,
            54.130132,
            90.23354
          ],
          [
            11.672128,
            54.13008,
            90.253478
          ],
          [
            11.672467,
            54.130027,
            90.271528
          ],
          [
            11.672878,
            54.129951,
            90.293704
          ],
          [
            11.673238,
            54.129896,
            90.312845
          ],
          [
            11.673584,
            54.129844,
            90.331222
          ],
          [
            11.674016,
            54.129786,
            90.354023
          ],
          [
            11.674453,
            54.129708,
            90.92367
          ],
          [
            11.674795,
            54.129646,
            91.575567
          ],
          [
            11.675159,
            54.129598,
            92.255135
          ],
          [
            11.675487,
            54.129556,
            92.867096
          ],
          [
            11.675788,
            54.129503,
            93.440166
          ],
          [
            11.676169,
            54.129455,
            94.150682
          ],
          [
            11.676538,
            54.129413,
            94.836221
          ],
          [
            11.676918,
            54.129378,
            95.536951
          ],
          [
            11.677272,
            54.12936,
            95.973863
          ],
          [
            11.677617,
            54.129346,
            96.043022
          ],
          [
            11.677931,
            54.129304,
            96.107402
          ],
          [
            11.678279,
            54.12923,
            96.181443
          ],
          [
            11.678616,
            54.129136,
            96.256683
          ],
          [
            11.67899,
            54.129076,
            96.3342
          ],
          [
            11.679368,
            54.129034,
            96.41114
          ],
          [
            11.679738,
            54.12897,
            96.4884
          ],
          [
            11.680101,
            54.128893,
            96.559941
          ],
          [
            11.680441,
            54.128853,
            96.536125
          ],
          [
            11.680796,
            54.128837,
            96.511492
          ],
          [
            11.681153,
            54.128791,
            96.486443
          ],
          [
            11.681473,
            54.128745,
            96.463862
          ],
          [
            11.68167,
            54.128874,
            96.440855
          ],
          [
            11.681729,
            54.129088,
            96.41551
          ],
          [
            11.681777,
            54.129311,
            96.3892
          ],
          [
            11.681827,
            54.12955,
            96.361039
          ],
          [
            11.68187,
            54.129813,
            96.026638
          ],
          [
            11.681877,
            54.130045,
            95.607042
          ],
          [
            11.681891,
            54.130277,
            95.187595
          ],
          [
            11.68193,
            54.130471,
            94.8345
          ],
          [
            11.681983,
            54.130671,
            94.465992
          ],
          [
            11.681996,
            54.130906,
            94.041106
          ],
          [
            11.682021,
            54.131102,
            93.685931
          ],
          [
            11.682045,
            54.131314,
            93.301966
          ],
          [
            11.682095,
            54.131571,
            92.328771
          ],
          [
            11.68207,
            54.131886,
            90.680199
          ],
          [
            11.681958,
            54.132215,
            88.929595
          ],
          [
            11.681801,
            54.132535,
            87.190445
          ],
          [
            11.681633,
            54.132852,
            85.45732
          ],
          [
            11.68149,
            54.13317,
            83.741403
          ],
          [
            11.681384,
            54.133442,
            82.144049
          ],
          [
            11.681328,
            54.133641,
            80.988459
          ],
          [
            11.681275,
            54.133825,
            79.918956
          ],
          [
            11.681218,
            54.134016,
            78.805995
          ],
          [
            11.681154,
            54.134203,
            77.713416
          ],
          [
            11.681079,
            54.134475,
            76.134346
          ],
          [
            11.680974,
            54.134806,
            74.205901
          ],
          [
            11.68091,
            54.135138,
            72.403124
          ],
          [
            11.680823,
            54.135456,
            70.73968
          ],
          [
            11.680816,
            54.135806,
            68.933337
          ],
          [
            11.680813,
            54.136159,
            67.111619
          ],
          [
            11.68082,
            54.136349,
            66.130766
          ],
          [
            11.680844,
            54.136557,
            65.054619
          ],
          [
            11.680824,
            54.136747,
            64.064414
          ],
          [
            11.680818,
            54.136948,
            62.919707
          ],
          [
            11.680821,
            54.137154,
            61.747131
          ],
          [
            11.680823,
            54.137347,
            60.648591
          ],
          [
            11.680808,
            54.137544,
            59.526207
          ],
          [
            11.680819,
            54.13773,
            58.4657
          ],
          [
            11.680779,
            54.137917,
            57.392539
          ],
          [
            11.680687,
            54.138187,
            55.825378
          ],
          [
            11.680575,
            54.138444,
            54.315277
          ],
          [
            11.680516,
            54.138773,
            54.311895
          ],
          [
            11.680571,
            54.139067,
            54.792625
          ],
          [
            11.680773,
            54.139317,
            55.242874
          ],
          [
            11.681012,
            54.139525,
            55.65114
          ],
          [
            11.681221,
            54.139742,
            56.055859
          ],
          [
            11.681465,
            54.139971,
            56.494831
          ],
          [
            11.681737,
            54.140183,
            56.628111
          ],
          [
            11.681998,
            54.140409,
            55.872185
          ],
          [
            11.682283,
            54.140671,
            55.011397
          ],
          [
            11.682567,
            54.140955,
            54.099537
          ],
          [
            11.682883,
            54.14122,
            53.204303
          ],
          [
            11.683115,
            54.141433,
            52.50463
          ],
          [
            11.683409,
            54.141708,
            51.864126
          ],
          [
            11.683692,
            54.141973,
            51.970548
          ],
          [
            11.683996,
            54.142222,
            52.074766
          ],
          [
            11.684256,
            54.142458,
            52.17045
          ],
          [
            11.68453,
            54.142688,
            52.265898
          ],
          [
            11.68477,
            54.142913,
            52.356275
          ],
          [
            11.68501,
            54.143123,
            52.442277
          ],
          [
            11.68523,
            54.143322,
            52.277623
          ],
          [
            11.685426,
            54.143511,
            52.106563
          ],
          [
            11.685639,
            54.143683,
            51.942538
          ],
          [
            11.685865,
            54.143865,
            51.768829
          ],
          [
            11.686062,
            54.144048,
            51.601849
          ],
          [
            11.686274,
            54.144238,
            51.425338
          ],
          [
            11.6865,
            54.144402,
            51.262667
          ],
          [
            11.686691,
            54.144586,
            51.096405
          ],
          [
            11.686875,
            54.144761,
            50.916673
          ],
          [
            11.68704,
            54.144928,
            50.742102
          ],
          [
            11.687226,
            54.145108,
            50.551888
          ],
          [
            11.687405,
            54.14527,
            50.37744
          ],
          [
            11.687588,
            54.145434,
            50.200282
          ],
          [
            11.687834,
            54.145639,
            49.972931
          ],
          [
            11.688052,
            54.145829,
            49.765807
          ],
          [
            11.688175,
            54.146025,
            49.575747
          ],
          [
            11.688391,
            54.146208,
            49.360223
          ],
          [
            11.68861,
            54.146372,
            49.126208
          ],
          [
            11.688855,
            54.146557,
            48.861685
          ],
          [
            11.689059,
            54.146734,
            48.621119
          ],
          [
            11.689262,
            54.146906,
            48.386097
          ],
          [
            11.689498,
            54.147098,
            48.120063
          ],
          [
            11.689674,
            54.14728,
            47.884942
          ],
          [
            11.689882,
            54.147463,
            47.637849
          ],
          [
            11.690077,
            54.147665,
            47.362401
          ],
          [
            11.690322,
            54.147864,
            46.972117
          ],
          [
            11.690586,
            54.148109,
            46.511024
          ],
          [
            11.690898,
            54.148367,
            46.00804
          ],
          [
            11.691216,
            54.148623,
            45.504426
          ],
          [
            11.691577,
            54.148717,
            45.119421
          ],
          [
            11.691905,
            54.148601,
            44.760576
          ],
          [
            11.692172,
            54.148438,
            44.455902
          ],
          [
            11.692384,
            54.148261,
            44.237397
          ],
          [
            11.692636,
            54.148134,
            44.040472
          ],
          [
            11.692957,
            54.148009,
            43.812478
          ],
          [
            11.693231,
            54.147907,
            43.620489
          ],
          [
            11.693553,
            54.147788,
            43.394267
          ],
          [
            11.693877,
            54.147671,
            43.169184
          ],
          [
            11.694185,
            54.147539,
            42.94326
          ],
          [
            11.694583,
            54.147436,
            42.68363
          ],
          [
            11.694958,
            54.14744,
            42.453064
          ],
          [
            11.695275,
            54.147494,
            42.249818
          ],
          [
            11.695615,
            54.147556,
            42.030844
          ],
          [
            11.695973,
            54.147627,
            41.798466
          ],
          [
            11.696289,
            54.147723,
            41.574649
          ],
          [
            11.696297,
            54.147913,
            41.368584
          ],
          [
            11.696215,
            54.148106,
            41.159853
          ],
          [
            11.696082,
            54.148308,
            40.931505
          ],
          [
            11.695943,
            54.148507,
            40.758064
          ],
          [
            11.69582,
            54.148693,
            40.625837
          ],
          [
            11.695711,
            54.148874,
            40.498986
          ],
          [
            11.695596,
            54.149047,
            40.376277
          ],
          [
            11.695518,
            54.14923,
            40.251478
          ],
          [
            11.695399,
            54.149405,
            40.126976
          ],
          [
            11.695262,
            54.149655,
            39.953116
          ],
          [
            11.695158,
            54.149835,
            39.827521
          ],
          [
            11.695101,
            54.150035,
            39.693405
          ],
          [
            11.695079,
            54.15023,
            39.854628
          ],
          [
            11.695059,
            54.150492,
            40.215517
          ],
          [
            11.695151,
            54.150665,
            40.46744
          ],
          [
            11.695397,
            54.150873,
            40.81476
          ],
          [
            11.695632,
            54.151057,
            41.130134
          ],
          [
            11.695851,
            54.15123,
            41.425682
          ],
          [
            11.696112,
            54.151429,
            41.770107
          ],
          [
            11.696364,
            54.151654,
            42.125317
          ],
          [
            11.696642,
            54.151859,
            42.080171
          ],
          [
            11.696957,
            54.15198,
            42.042172
          ],
          [
            11.697222,
            54.152071,
            42.011208
          ],
          [
            11.697607,
            54.152122,
            41.970847
          ],
          [
            11.698043,
            54.15208,
            41.926222
          ],
          [
            11.698445,
            54.152052,
            41.885406
          ],
          [
            11.698815,
            54.152025,
            41.847822
          ],
          [
            11.699206,
            54.151985,
            41.819521
          ],
          [
            11.699519,
            54.151942,
            41.827006
          ],
          [
            11.699834,
            54.1519,
            41.83453
          ],
          [
            11.700291,
            54.151864,
            41.845266
          ],
          [
            11.700665,
            54.151854,
            41.853993
          ],
          [
            11.701016,
            54.151825,
            41.862247
          ],
          [
            11.701382,
            54.15178,
            41.870982
          ],
          [
            11.701734,
            54.151747,
            41.879284
          ],
          [
            11.70213,
            54.151727,
            41.888557
          ],
          [
            11.702505,
            54.151678,
            42.538685
          ],
          [
            11.702856,
            54.151637,
            43.162796
          ],
          [
            11.703241,
            54.151603,
            43.842034
          ],
          [
            11.703573,
            54.15158,
            44.425293
          ],
          [
            11.703913,
            54.151566,
            45.019794
          ],
          [
            11.704288,
            54.151531,
            45.682085
          ],
          [
            11.704642,
            54.151492,
            46.310856
          ],
          [
            11.705005,
            54.151465,
            46.949446
          ],
          [
            11.705371,
            54.151445,
            47.256084
          ],
          [
            11.705738,
            54.151413,
            47.278803
          ],
          [
            11.706109,
            54.151387,
            47.301609
          ],
          [
            11.706459,
            54.151387,
            47.322995
          ],
          [
            11.706861,
            54.151369,
            47.347658
          ],
          [
            11.707285,
            54.151381,
            47.373571
          ],
          [
            11.707692,
            54.151374,
            47.398431
          ],
          [
            11.708097,
            54.151367,
            47.42316
          ],
          [
            11.708514,
            54.15136,
            47.562671
          ],
          [
            11.708888,
            54.151351,
            47.736566
          ],
          [
            11.709268,
            54.151346,
            47.913139
          ],
          [
            11.709636,
            54.151348,
            48.084088
          ],
          [
            11.710015,
            54.151337,
            48.260326
          ],
          [
            11.710368,
            54.15132,
            48.424884
          ],
          [
            11.710763,
            54.151308,
            48.608618
          ],
          [
            11.711146,
            54.151307,
            48.787009
          ],
          [
            11.711528,
            54.151295,
            48.821472
          ],
          [
            11.711897,
            54.151293,
            48.763434
          ],
          [
            11.712263,
            54.151288,
            48.705889
          ],
          [
            11.712624,
            54.151286,
            48.649138
          ],
          [
            11.712949,
            54.151295,
            48.597836
          ],
          [
            11.713294,
            54.151284,
            48.54341
          ],
          [
            11.713679,
            54.151299,
            48.482737
          ],
          [
            11.714051,
            54.151291,
            48.424221
          ],
          [
            11.714444,
            54.151285,
            48.334472
          ],
          [
            11.714812,
            54.15129,
            48.148427
          ],
          [
            11.71525,
            54.15128,
            47.926949
          ],
          [
            11.715585,
            54.151268,
            47.757328
          ],
          [
            11.71597,
            54.15128,
            47.562237
          ],
          [
            11.716345,
            54.151268,
            47.371648
          ],
          [
            11.716761,
            54.151252,
            47.161002
          ],
          [
            11.717154,
            54.151225,
            46.960973
          ],
          [
            11.717508,
            54.151202,
            46.875638
          ],
          [
            11.717837,
            54.151195,
            47.08159
          ],
          [
            11.718247,
            54.151179,
            47.338591
          ],
          [
            11.718679,
            54.151167,
            47.609023
          ],
          [
            11.719058,
            54.151165,
            47.846003
          ],
          [
            11.719347,
            54.151249,
            48.062958
          ],
          [
            11.719173,
            54.151165,
            48.257442
          ],
          [
            11.718861,
            54.151228,
            48.464105
          ],
          [
            11.718515,
            54.151246,
            48.681668
          ],
          [
            11.718379,
            54.151399,
            48.898904
          ],
          [
            11.718537,
            54.15157,
            49.106662
          ],
          [
            11.718843,
            54.15158,
            49.291126
          ],
          [
            11.71918,
            54.151525,
            49.499212
          ],
          [
            11.719234,
            54.151303,
            49.732002
          ],
          [
            11.719463,
            54.151173,
            49.94898
          ],
          [
            11.719804,
            54.151153,
            50.152542
          ],
          [
            11.720182,
            54.151124,
            50.378901
          ],
          [
            11.720546,
            54.151133,
            50.618712
          ],
          [
            11.720876,
            54.151111,
            50.978587
          ],
          [
            11.721226,
            54.151116,
            51.357757
          ],
          [
            11.721566,
            54.151093,
            51.728928
          ],
          [
            11.721936,
            54.151076,
            52.131005
          ],
          [
            11.722315,
            54.151086,
            52.542945
          ],
          [
            11.722718,
            54.151095,
            52.979714
          ],
          [
            11.723083,
            54.151101,
            53.375279
          ],
          [
            11.723496,
            54.151139,
            53.828237
          ],
          [
            11.723796,
            54.151297,
            52.885471
          ],
          [
            11.724041,
            54.151519,
            51.579095
          ],
          [
            11.724194,
            54.151675,
            50.689707
          ],
          [
            11.724363,
            54.151885,
            49.542151
          ],
          [
            11.724458,
            54.152069,
            48.590672
          ],
          [
            11.724475,
            54.152251,
            47.685604
          ],
          [
            11.724506,
            54.152444,
            46.725523
          ],
          [
            11.724564,
            54.152661,
            45.640186
          ],
          [
            11.724751,
            54.152842,
            44.97337
          ],
          [
            11.725095,
            54.152936,
            44.899532
          ],
          [
            11.725409,
            54.152984,
            44.836267
          ],
          [
            11.725791,
            54.152988,
            44.761987
          ],
          [
            11.726149,
            54.153031,
            44.690634
          ],
          [
            11.726521,
            54.153077,
            44.616633
          ],
          [
            11.726923,
            54.1531,
            44.538111
          ],
          [
            11.727243,
            54.153079,
            44.475484
          ],
          [
            11.727683,
            54.153061,
            44.526338
          ],
          [
            11.728097,
            54.153009,
            45.059626
          ],
          [
            11.728472,
            54.152968,
            45.539806
          ],
          [
            11.72885,
            54.152967,
            46.015729
          ],
          [
            11.729186,
            54.152954,
            46.440762
          ],
          [
            11.729528,
            54.153014,
            46.894632
          ],
          [
            11.729855,
            54.15302,
            47.310639
          ],
          [
            11.730189,
            54.153,
            47.74079
          ],
          [
            11.730527,
            54.152989,
            48.167475
          ],
          [
            11.730836,
            54.152921,
            48.22657
          ],
          [
            11.731204,
            54.152905,
            48.158361
          ],
          [
            11.731458,
            54.152791,
            48.094781
          ],
          [
            11.731799,
            54.1527,
            48.024545
          ],
          [
            11.732142,
            54.152667,
            47.959999
          ],
          [
            11.732525,
            54.152586,
            47.884643
          ],
          [
            11.73281,
            54.152468,
            47.820259
          ],
          [
            11.732912,
            54.152551,
            47.754189
          ],
          [
            11.732903,
            54.152693,
            47.599976
          ],
          [
            11.733201,
            54.152811,
            47.079899
          ],
          [
            11.733594,
            54.152794,
            46.546467
          ],
          [
            11.734011,
            54.152776,
            45.981404
          ],
          [
            11.734397,
            54.152764,
            45.456992
          ],
          [
            11.734829,
            54.152743,
            44.870824
          ],
          [
            11.735232,
            54.15269,
            44.311534
          ],
          [
            11.735613,
            54.152654,
            43.790007
          ],
          [
            11.735926,
            54.152663,
            43.414139
          ],
          [
            11.736246,
            54.15266,
            43.090222
          ],
          [
            11.736576,
            54.152683,
            42.754879
          ],
          [
            11.736938,
            54.152699,
            42.388812
          ],
          [
            11.73744,
            54.152659,
            41.877155
          ],
          [
            11.737764,
            54.152653,
            41.549553
          ],
          [
            11.738092,
            54.152694,
            41.21092
          ],
          [
            11.738448,
            54.152746,
            40.839228
          ],
          [
            11.738813,
            54.1528,
            40.464005
          ],
          [
            11.739175,
            54.152855,
            40.494039
          ],
          [
            11.739495,
            54.152911,
            40.520817
          ],
          [
            11.739847,
            54.152969,
            40.550142
          ],
          [
            11.740151,
            54.153013,
            40.575338
          ],
          [
            11.74049,
            54.153033,
            40.602677
          ],
          [
            11.740873,
            54.153029,
            40.633422
          ],
          [
            11.741298,
            54.153052,
            40.667646
          ],
          [
            11.741701,
            54.153098,
            40.700572
          ],
          [
            11.742069,
            54.153077,
            40.79084
          ],
          [
            11.742409,
            54.153065,
            40.899509
          ],
          [
            11.742808,
            54.153085,
            41.027246
          ],
          [
            11.743212,
            54.153089,
            41.156464
          ],
          [
            11.743561,
            54.153092,
            41.267783
          ],
          [
            11.743879,
            54.15309,
            41.370177
          ],
          [
            11.744223,
            54.153097,
            41.480016
          ],
          [
            11.744654,
            54.153116,
            41.617925
          ],
          [
            11.74509,
            54.153131,
            41.768787
          ],
          [
            11.745518,
            54.153142,
            41.928676
          ],
          [
            11.745912,
            54.153165,
            42.076446
          ],
          [
            11.7463,
            54.153205,
            42.223525
          ],
          [
            11.746663,
            54.15325,
            42.362253
          ],
          [
            11.747056,
            54.153265,
            42.509219
          ],
          [
            11.74748,
            54.15331,
            42.670105
          ],
          [
            11.747796,
            54.153336,
            42.789247
          ],
          [
            11.748184,
            54.153355,
            42.822388
          ],
          [
            11.74855,
            54.153396,
            42.804198
          ],
          [
            11.748971,
            54.153431,
            42.783512
          ],
          [
            11.749319,
            54.153453,
            42.76651
          ],
          [
            11.749736,
            54.153476,
            42.746161
          ],
          [
            11.750098,
            54.153517,
            42.728133
          ],
          [
            11.750456,
            54.153582,
            42.709926
          ],
          [
            11.750807,
            54.153587,
            42.692811
          ],
          [
            11.751122,
            54.153617,
            42.505998
          ],
          [
            11.751456,
            54.153626,
            42.172852
          ],
          [
            11.751768,
            54.153659,
            41.858936
          ],
          [
            11.752145,
            54.1537,
            41.47853
          ],
          [
            11.752501,
            54.153744,
            41.118389
          ],
          [
            11.752848,
            54.153771,
            40.770394
          ],
          [
            11.753201,
            54.153828,
            40.406975
          ],
          [
            11.753547,
            54.153867,
            40.0534
          ],
          [
            11.753916,
            54.153899,
            39.683265
          ],
          [
            11.754321,
            54.153939,
            39.658921
          ],
          [
            11.754659,
            54.154013,
            39.671434
          ],
          [
            11.755168,
            54.154049,
            39.689164
          ],
          [
            11.75554,
            54.154076,
            39.7021
          ],
          [
            11.75591,
            54.154114,
            39.715063
          ],
          [
            11.756308,
            54.15415,
            39.728963
          ],
          [
            11.756707,
            54.1542,
            39.743046
          ],
          [
            11.757122,
            54.154267,
            39.86498
          ],
          [
            11.757516,
            54.154338,
            40.136235
          ],
          [
            11.757873,
            54.154367,
            40.373637
          ],
          [
            11.758264,
            54.154383,
            40.631781
          ],
          [
            11.758616,
            54.154386,
            40.863405
          ],
          [
            11.758987,
            54.154416,
            41.109853
          ],
          [
            11.759387,
            54.154415,
            41.373321
          ],
          [
            11.759743,
            54.154411,
            41.607638
          ],
          [
            11.76009,
            54.154392,
            41.678565
          ],
          [
            11.760482,
            54.154332,
            41.292446
          ],
          [
            11.760876,
            54.15426,
            40.899241
          ],
          [
            11.761215,
            54.154192,
            40.557929
          ],
          [
            11.76153,
            54.154122,
            40.228825
          ],
          [
            11.761898,
            54.154046,
            39.855974
          ],
          [
            11.762204,
            54.153963,
            39.53472
          ],
          [
            11.762526,
            54.15388,
            39.199538
          ],
          [
            11.76289,
            54.153778,
            38.922402
          ],
          [
            11.763228,
            54.153651,
            39.815411
          ],
          [
            11.76354,
            54.153526,
            40.655888
          ],
          [
            11.763802,
            54.153409,
            41.389161
          ],
          [
            11.763926,
            54.153236,
            42.104717
          ],
          [
            11.764095,
            54.153057,
            42.894261
          ],
          [
            11.764407,
            54.152989,
            43.634399
          ],
          [
            11.764751,
            54.152896,
            44.477369
          ],
          [
            11.765075,
            54.152804,
            45.277931
          ],
          [
            11.765385,
            54.152731,
            45.493344
          ],
          [
            11.765723,
            54.152627,
            45.043917
          ],
          [
            11.766132,
            54.152517,
            44.515446
          ],
          [
            11.766443,
            54.152433,
            44.111649
          ],
          [
            11.766761,
            54.152394,
            43.725997
          ],
          [
            11.767112,
            54.152311,
            43.28149
          ],
          [
            11.767457,
            54.152217,
            42.834526
          ],
          [
            11.767816,
            54.152119,
            42.368602
          ],
          [
            11.768143,
            54.152033,
            41.993738
          ],
          [
            11.768252,
            54.151811,
            41.70087
          ],
          [
            11.768538,
            54.151681,
            41.428606
          ],
          [
            11.768839,
            54.151592,
            41.182696
          ],
          [
            11.769186,
            54.151498,
            40.903014
          ],
          [
            11.769472,
            54.151406,
            40.659758
          ],
          [
            11.769768,
            54.151329,
            40.422938
          ],
          [
            11.770079,
            54.151249,
            40.175231
          ],
          [
            11.770423,
            54.151167,
            39.904358
          ],
          [
            11.770717,
            54.15109,
            39.963949
          ],
          [
            11.771075,
            54.151001,
            40.201536
          ],
          [
            11.771393,
            54.150907,
            40.419177
          ],
          [
            11.771623,
            54.15077,
            40.619652
          ],
          [
            11.771923,
            54.150668,
            40.832389
          ],
          [
            11.772135,
            54.150521,
            41.033349
          ],
          [
            11.7724,
            54.150587,
            41.282982
          ],
          [
            11.772682,
            54.150512,
            41.472189
          ],
          [
            11.772944,
            54.150629,
            41.673467
          ],
          [
            11.773348,
            54.150576,
            41.726276
          ],
          [
            11.773735,
            54.150496,
            41.749299
          ],
          [
            11.774119,
            54.150396,
            41.772892
          ],
          [
            11.774492,
            54.150308,
            41.79544
          ],
          [
            11.774863,
            54.150225,
            41.817786
          ],
          [
            11.775215,
            54.150169,
            41.83824
          ],
          [
            11.775584,
            54.150085,
            41.860461
          ],
          [
            11.775912,
            54.150019,
            41.860563
          ],
          [
            11.776274,
            54.149985,
            41.668745
          ],
          [
            11.77659,
            54.149912,
            41.49105
          ],
          [
            11.776891,
            54.149858,
            41.325506
          ],
          [
            11.777218,
            54.149807,
            41.14849
          ],
          [
            11.777518,
            54.149736,
            40.977893
          ],
          [
            11.77782,
            54.149675,
            40.810713
          ],
          [
            11.778212,
            54.149586,
            40.590786
          ],
          [
            11.778526,
            54.149521,
            40.416495
          ],
          [
            11.778848,
            54.149462,
            40.21116
          ],
          [
            11.779174,
            54.149373,
            39.850952
          ],
          [
            11.779481,
            54.149303,
            39.521016
          ],
          [
            11.779796,
            54.149234,
            39.184204
          ],
          [
            11.780171,
            54.149157,
            38.785733
          ],
          [
            11.7805,
            54.149086,
            38.43448
          ],
          [
            11.78083,
            54.149004,
            38.075593
          ],
          [
            11.78116,
            54.148963,
            37.737388
          ],
          [
            11.781487,
            54.148912,
            37.398349
          ],
          [
            11.781846,
            54.14884,
            36.996768
          ],
          [
            11.782165,
            54.148751,
            36.59908
          ],
          [
            11.782484,
            54.148684,
            36.219959
          ],
          [
            11.782786,
            54.148645,
            35.872828
          ],
          [
            11.783092,
            54.148582,
            35.509963
          ],
          [
            11.783464,
            54.14852,
            35.077247
          ],
          [
            11.783845,
            54.148433,
            34.619751
          ],
          [
            11.784256,
            54.148355,
            34.136324
          ],
          [
            11.784605,
            54.148286,
            33.782075
          ],
          [
            11.784937,
            54.148226,
            33.992617
          ],
          [
            11.785325,
            54.148154,
            34.240205
          ],
          [
            11.785652,
            54.148089,
            34.449491
          ],
          [
            11.78597,
            54.148015,
            34.656852
          ],
          [
            11.786289,
            54.147932,
            34.870238
          ],
          [
            11.786624,
            54.147864,
            35.085082
          ],
          [
            11.786956,
            54.147794,
            35.299397
          ],
          [
            11.787282,
            54.147726,
            35.509159
          ],
          [
            11.787604,
            54.147629,
            35.772222
          ],
          [
            11.78795,
            54.147541,
            36.093253
          ],
          [
            11.788275,
            54.147481,
            36.383125
          ],
          [
            11.788636,
            54.147396,
            36.714108
          ],
          [
            11.788967,
            54.147321,
            37.016234
          ],
          [
            11.789316,
            54.147281,
            37.318807
          ],
          [
            11.789671,
            54.147248,
            37.625322
          ],
          [
            11.790046,
            54.147229,
            37.945528
          ],
          [
            11.790391,
            54.147184,
            38.251704
          ],
          [
            11.790796,
            54.147109,
            38.76119
          ],
          [
            11.791132,
            54.147092,
            39.166197
          ],
          [
            11.791467,
            54.147031,
            39.586693
          ],
          [
            11.791853,
            54.14699,
            40.056848
          ],
          [
            11.792176,
            54.146947,
            40.453905
          ],
          [
            11.792481,
            54.146902,
            40.831972
          ],
          [
            11.792845,
            54.146843,
            41.286312
          ],
          [
            11.79317,
            54.146859,
            41.677103
          ],
          [
            11.793517,
            54.146843,
            41.725235
          ],
          [
            11.793897,
            54.146777,
            41.241868
          ],
          [
            11.794247,
            54.146733,
            40.807853
          ],
          [
            11.794581,
            54.146713,
            40.400339
          ],
          [
            11.794918,
            54.146646,
            39.968326
          ],
          [
            11.795236,
            54.14659,
            39.562419
          ],
          [
            11.795573,
            54.146568,
            39.151433
          ],
          [
            11.795925,
            54.146509,
            38.706635
          ],
          [
            11.796307,
            54.146461,
            38.232767
          ],
          [
            11.796746,
            54.146419,
            38.557824
          ],
          [
            11.797104,
            54.146392,
            38.878219
          ],
          [
            11.797425,
            54.146335,
            39.175901
          ],
          [
            11.797818,
            54.146285,
            39.532678
          ],
          [
            11.798239,
            54.146247,
            39.910853
          ],
          [
            11.798615,
            54.146215,
            40.248224
          ],
          [
            11.799002,
            54.146172,
            40.598672
          ],
          [
            11.799303,
            54.14612,
            40.883052
          ],
          [
            11.799686,
            54.146058,
            41.022517
          ],
          [
            11.800085,
            54.146025,
            41.140646
          ],
          [
            11.800476,
            54.145999,
            41.256006
          ],
          [
            11.800883,
            54.145951,
            41.377834
          ],
          [
            11.801275,
            54.145928,
            41.493332
          ],
          [
            11.801635,
            54.145905,
            41.599494
          ],
          [
            11.801951,
            54.145887,
            41.692755
          ],
          [
            11.802115,
            54.145977,
            41.790272
          ],
          [
            11.802226,
            54.146151,
            41.868724
          ],
          [
            11.802134,
            54.146325,
            41.939045
          ],
          [
            11.802278,
            54.146377,
            42.028182
          ],
          [
            11.80259,
            54.146343,
            42.100152
          ],
          [
            11.802859,
            54.146254,
            42.169773
          ],
          [
            11.80295,
            54.1463,
            42.265484
          ],
          [
            11.802649,
            54.146352,
            42.336013
          ],
          [
            11.802316,
            54.14638,
            42.411739
          ],
          [
            11.802244,
            54.146285,
            42.484741
          ],
          [
            11.802167,
            54.146039,
            42.50685
          ],
          [
            11.802232,
            54.146221,
            42.50685
          ],
          [
            11.802193,
            54.14605,
            42.50685
          ],
          [
            11.802207,
            54.145807,
            42.50685
          ],
          [
            11.802239,
            54.145623,
            42.50685
          ],
          [
            11.802569,
            54.145477,
            42.50685
          ],
          [
            11.802623,
            54.145588,
            42.50685
          ]
        ]
      }
    }
  ]
}

let day29: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            11.802241,
            54.146224,
            47.938821
          ],
          [
            11.80214,
            54.14603,
            47.938821
          ],
          [
            11.802332,
            54.145893,
            47.938821
          ],
          [
            11.802655,
            54.145887,
            47.938821
          ],
          [
            11.802995,
            54.145868,
            47.938821
          ],
          [
            11.803391,
            54.145831,
            47.749107
          ],
          [
            11.803798,
            54.145809,
            47.43455
          ],
          [
            11.804156,
            54.145796,
            47.159822
          ],
          [
            11.804518,
            54.14575,
            46.875868
          ],
          [
            11.804859,
            54.145711,
            46.608823
          ],
          [
            11.805183,
            54.145674,
            46.355979
          ],
          [
            11.805525,
            54.14565,
            46.091715
          ],
          [
            11.805851,
            54.145639,
            45.839483
          ],
          [
            11.80621,
            54.145603,
            45.600864
          ],
          [
            11.806522,
            54.145575,
            45.727528
          ],
          [
            11.806849,
            54.145541,
            45.860302
          ],
          [
            11.807194,
            54.145517,
            45.999734
          ],
          [
            11.807522,
            54.145476,
            46.133629
          ],
          [
            11.807839,
            54.14547,
            46.260682
          ],
          [
            11.808221,
            54.145449,
            46.413828
          ],
          [
            11.808611,
            54.145405,
            46.57262
          ],
          [
            11.808976,
            54.145395,
            46.718731
          ],
          [
            11.809362,
            54.145367,
            46.858336
          ],
          [
            11.809762,
            54.145322,
            46.979518
          ],
          [
            11.810139,
            54.145309,
            47.091921
          ],
          [
            11.81052,
            54.145296,
            47.205542
          ],
          [
            11.81088,
            54.145247,
            47.315501
          ],
          [
            11.811243,
            54.145217,
            47.424555
          ],
          [
            11.811617,
            54.145182,
            47.53739
          ],
          [
            11.811962,
            54.14513,
            47.64353
          ],
          [
            11.812332,
            54.145091,
            47.733799
          ],
          [
            11.812705,
            54.14509,
            47.763298
          ],
          [
            11.813112,
            54.145059,
            47.795714
          ],
          [
            11.813519,
            54.145015,
            47.828391
          ],
          [
            11.813885,
            54.144965,
            47.858075
          ],
          [
            11.814212,
            54.144957,
            47.883951
          ],
          [
            11.814618,
            54.144916,
            47.916538
          ],
          [
            11.814954,
            54.144897,
            47.943188
          ],
          [
            11.815265,
            54.144875,
            47.96792
          ],
          [
            11.815657,
            54.14483,
            48.00759
          ],
          [
            11.816012,
            54.14479,
            48.043618
          ],
          [
            11.816404,
            54.144781,
            48.082708
          ],
          [
            11.816779,
            54.144754,
            48.120341
          ],
          [
            11.817014,
            54.144647,
            48.152561
          ],
          [
            11.817074,
            54.144468,
            48.184039
          ],
          [
            11.817021,
            54.144254,
            48.220833
          ],
          [
            11.817014,
            54.144038,
            48.257567
          ],
          [
            11.817016,
            54.143818,
            48.37963
          ],
          [
            11.816981,
            54.143618,
            48.553229
          ],
          [
            11.816944,
            54.143409,
            48.73469
          ],
          [
            11.817072,
            54.143215,
            48.921862
          ],
          [
            11.817365,
            54.143121,
            49.090929
          ],
          [
            11.817755,
            54.14304,
            49.301425
          ],
          [
            11.818166,
            54.142984,
            49.514836
          ],
          [
            11.818542,
            54.143041,
            49.712672
          ],
          [
            11.818809,
            54.143181,
            49.66304
          ],
          [
            11.819106,
            54.143258,
            49.263602
          ],
          [
            11.819374,
            54.143362,
            48.889988
          ],
          [
            11.819703,
            54.143529,
            48.380121
          ],
          [
            11.820077,
            54.14359,
            47.92985
          ],
          [
            11.820373,
            54.143657,
            47.55567
          ],
          [
            11.820643,
            54.143741,
            47.183095
          ],
          [
            11.820978,
            54.143836,
            46.746551
          ],
          [
            11.821301,
            54.143913,
            46.341081
          ],
          [
            11.82165,
            54.143975,
            46.400234
          ],
          [
            11.821926,
            54.144058,
            46.528038
          ],
          [
            11.822296,
            54.144138,
            46.694836
          ],
          [
            11.822635,
            54.144201,
            46.840795
          ],
          [
            11.822963,
            54.144194,
            46.977717
          ],
          [
            11.82332,
            54.144256,
            47.130546
          ],
          [
            11.823669,
            54.144267,
            47.274729
          ],
          [
            11.824074,
            54.144219,
            47.444683
          ],
          [
            11.82445,
            54.144147,
            48.306725
          ],
          [
            11.824828,
            54.144193,
            49.963083
          ],
          [
            11.825133,
            54.14411,
            51.403309
          ],
          [
            11.825357,
            54.14396,
            52.855742
          ],
          [
            11.8257,
            54.143983,
            55.031434
          ],
          [
            11.825567,
            54.144168,
            56.541171
          ],
          [
            11.825849,
            54.144255,
            57.909549
          ],
          [
            11.826197,
            54.144324,
            59.479678
          ],
          [
            11.826519,
            54.144311,
            60.865659
          ],
          [
            11.826877,
            54.144297,
            62.039831
          ],
          [
            11.827228,
            54.144296,
            63.194799
          ],
          [
            11.827579,
            54.144279,
            64.348135
          ],
          [
            11.827897,
            54.144258,
            65.394923
          ],
          [
            11.828249,
            54.14427,
            66.554077
          ],
          [
            11.828617,
            54.14427,
            67.757922
          ],
          [
            11.828965,
            54.144272,
            68.906695
          ],
          [
            11.829313,
            54.144226,
            70.076499
          ],
          [
            11.829693,
            54.144201,
            70.275709
          ],
          [
            11.830092,
            54.144189,
            69.458019
          ],
          [
            11.830454,
            54.144142,
            68.698888
          ],
          [
            11.830852,
            54.144111,
            67.877381
          ],
          [
            11.831237,
            54.144088,
            67.083392
          ],
          [
            11.831609,
            54.144053,
            66.310385
          ],
          [
            11.831945,
            54.144043,
            65.62198
          ],
          [
            11.832309,
            54.144014,
            64.869242
          ],
          [
            11.832677,
            54.14399,
            63.909189
          ],
          [
            11.833035,
            54.143963,
            62.651085
          ],
          [
            11.833389,
            54.143969,
            61.406873
          ],
          [
            11.833677,
            54.143886,
            60.256561
          ],
          [
            11.834005,
            54.143803,
            59.01025
          ],
          [
            11.834344,
            54.143713,
            57.713009
          ],
          [
            11.834663,
            54.143602,
            56.417925
          ],
          [
            11.834989,
            54.143493,
            55.108741
          ],
          [
            11.835322,
            54.143404,
            53.830212
          ],
          [
            11.835627,
            54.143302,
            52.063292
          ],
          [
            11.835956,
            54.143248,
            50.277249
          ],
          [
            11.836306,
            54.143143,
            48.221853
          ],
          [
            11.836613,
            54.143064,
            46.474437
          ],
          [
            11.836948,
            54.142961,
            44.477791
          ],
          [
            11.837278,
            54.142842,
            42.458319
          ],
          [
            11.837644,
            54.142712,
            40.226894
          ],
          [
            11.83799,
            54.142579,
            38.067348
          ],
          [
            11.83836,
            54.142458,
            39.023716
          ],
          [
            11.838668,
            54.142353,
            40.365476
          ],
          [
            11.839059,
            54.142242,
            42.010168
          ],
          [
            11.839458,
            54.142139,
            43.651869
          ],
          [
            11.839774,
            54.142028,
            45.040362
          ],
          [
            11.840048,
            54.141891,
            46.398701
          ],
          [
            11.840353,
            54.141805,
            47.673239
          ],
          [
            11.840698,
            54.141783,
            48.989389
          ],
          [
            11.84107,
            54.141798,
            49.444164
          ],
          [
            11.841469,
            54.141793,
            49.691827
          ],
          [
            11.841846,
            54.141796,
            49.92592
          ],
          [
            11.842245,
            54.141823,
            50.179417
          ],
          [
            11.842549,
            54.141933,
            50.403393
          ],
          [
            11.842947,
            54.141924,
            50.651151
          ],
          [
            11.843311,
            54.141962,
            50.884113
          ],
          [
            11.843633,
            54.142072,
            51.11526
          ],
          [
            11.84389,
            54.142199,
            51.486175
          ],
          [
            11.844167,
            54.142316,
            51.894667
          ],
          [
            11.844431,
            54.142413,
            52.272585
          ],
          [
            11.844706,
            54.142552,
            52.706942
          ],
          [
            11.844955,
            54.142712,
            53.148964
          ],
          [
            11.845149,
            54.142872,
            53.549641
          ],
          [
            11.845477,
            54.142928,
            53.958955
          ],
          [
            11.84584,
            54.143009,
            54.425322
          ],
          [
            11.846217,
            54.143043,
            54.775229
          ],
          [
            11.846593,
            54.143002,
            54.248712
          ],
          [
            11.846892,
            54.142946,
            53.811164
          ],
          [
            11.847249,
            54.142928,
            53.321117
          ],
          [
            11.847631,
            54.142994,
            52.778131
          ],
          [
            11.847986,
            54.143024,
            52.288983
          ],
          [
            11.848326,
            54.143046,
            51.822584
          ],
          [
            11.848671,
            54.143078,
            51.345954
          ],
          [
            11.848927,
            54.14307,
            50.920409
          ],
          [
            11.849011,
            54.143282,
            50.301078
          ],
          [
            11.849069,
            54.143511,
            49.50053
          ],
          [
            11.849218,
            54.143713,
            48.734956
          ],
          [
            11.849289,
            54.143957,
            47.879025
          ],
          [
            11.849406,
            54.144196,
            47.018257
          ],
          [
            11.849561,
            54.1444,
            46.241972
          ],
          [
            11.849886,
            54.144548,
            45.403255
          ],
          [
            11.850235,
            54.144593,
            44.679294
          ],
          [
            11.850668,
            54.144618,
            44.213815
          ],
          [
            11.851043,
            54.144661,
            43.952348
          ],
          [
            11.85135,
            54.144683,
            43.740244
          ],
          [
            11.851779,
            54.144699,
            43.446106
          ],
          [
            11.852191,
            54.144732,
            43.161527
          ],
          [
            11.852577,
            54.144759,
            42.89549
          ],
          [
            11.852886,
            54.144803,
            42.677817
          ],
          [
            11.853217,
            54.144832,
            42.448725
          ],
          [
            11.853551,
            54.144881,
            42.170168
          ],
          [
            11.853882,
            54.144901,
            41.854767
          ],
          [
            11.854266,
            54.144939,
            41.485949
          ],
          [
            11.854579,
            54.14497,
            41.185159
          ],
          [
            11.855,
            54.145004,
            40.782914
          ],
          [
            11.855409,
            54.145068,
            40.382358
          ],
          [
            11.855851,
            54.145128,
            39.953121
          ],
          [
            11.856272,
            54.145181,
            39.545793
          ],
          [
            11.85667,
            54.145244,
            39.359623
          ],
          [
            11.857046,
            54.145293,
            39.275908
          ],
          [
            11.857474,
            54.14537,
            39.178684
          ],
          [
            11.857912,
            54.145432,
            39.08106
          ],
          [
            11.858341,
            54.145507,
            38.984063
          ],
          [
            11.858694,
            54.145569,
            38.903828
          ],
          [
            11.858999,
            54.145621,
            38.834956
          ],
          [
            11.859436,
            54.145704,
            38.795222
          ],
          [
            11.85986,
            54.145766,
            38.991344
          ],
          [
            11.860288,
            54.145813,
            39.186629
          ],
          [
            11.860664,
            54.145879,
            39.362702
          ],
          [
            11.860975,
            54.145924,
            39.506356
          ],
          [
            11.861335,
            54.146007,
            39.679958
          ],
          [
            11.861702,
            54.146066,
            39.851112
          ],
          [
            11.862139,
            54.146151,
            40.057803
          ],
          [
            11.862564,
            54.146218,
            40.070519
          ],
          [
            11.86299,
            54.146292,
            39.971428
          ],
          [
            11.863415,
            54.146344,
            39.874551
          ],
          [
            11.863727,
            54.146403,
            39.801399
          ],
          [
            11.864161,
            54.146474,
            39.700914
          ],
          [
            11.864593,
            54.14653,
            39.602235
          ],
          [
            11.864986,
            54.146608,
            39.50942
          ],
          [
            11.865368,
            54.146678,
            39.51478
          ],
          [
            11.865783,
            54.146733,
            39.752465
          ],
          [
            11.866201,
            54.14679,
            39.991872
          ],
          [
            11.866609,
            54.14685,
            40.226533
          ],
          [
            11.867027,
            54.146925,
            40.471562
          ],
          [
            11.867457,
            54.146969,
            40.71516
          ],
          [
            11.867819,
            54.147017,
            40.922229
          ],
          [
            11.868242,
            54.14708,
            41.160601
          ],
          [
            11.868601,
            54.147174,
            41.178638
          ],
          [
            11.868951,
            54.147278,
            41.196656
          ],
          [
            11.869302,
            54.147355,
            41.213851
          ],
          [
            11.869688,
            54.147446,
            41.232909
          ],
          [
            11.870096,
            54.147543,
            41.253085
          ],
          [
            11.870491,
            54.147641,
            41.272737
          ],
          [
            11.87088,
            54.147719,
            41.291567
          ],
          [
            11.871303,
            54.147764,
            41.073859
          ],
          [
            11.871724,
            54.147816,
            40.64736
          ],
          [
            11.872141,
            54.147862,
            40.22712
          ],
          [
            11.872536,
            54.147891,
            39.832942
          ],
          [
            11.872933,
            54.147934,
            39.433277
          ],
          [
            11.873338,
            54.147983,
            39.023788
          ],
          [
            11.873747,
            54.148009,
            38.616197
          ],
          [
            11.87415,
            54.148053,
            38.264326
          ],
          [
            11.874585,
            54.148083,
            38.294738
          ],
          [
            11.874955,
            54.148119,
            38.320838
          ],
          [
            11.875384,
            54.148174,
            38.35133
          ],
          [
            11.875749,
            54.148226,
            38.377439
          ],
          [
            11.876141,
            54.148267,
            38.405093
          ],
          [
            11.876542,
            54.148311,
            38.433423
          ],
          [
            11.876913,
            54.148397,
            38.461149
          ],
          [
            11.877334,
            54.148478,
            38.63868
          ],
          [
            11.877771,
            54.148541,
            38.924835
          ],
          [
            11.87819,
            54.148626,
            39.206825
          ],
          [
            11.878566,
            54.148697,
            39.458341
          ],
          [
            11.878929,
            54.148783,
            39.707309
          ],
          [
            11.879278,
            54.14886,
            39.944547
          ],
          [
            11.879581,
            54.148923,
            40.149402
          ],
          [
            11.879892,
            54.14899,
            40.360081
          ],
          [
            11.880197,
            54.149068,
            40.50745
          ],
          [
            11.880489,
            54.149131,
            40.617082
          ],
          [
            11.880903,
            54.14922,
            40.772455
          ],
          [
            11.881253,
            54.149289,
            40.902694
          ],
          [
            11.881673,
            54.149386,
            41.061708
          ],
          [
            11.882057,
            54.14949,
            41.21073
          ],
          [
            11.88246,
            54.149553,
            41.357748
          ],
          [
            11.882866,
            54.149646,
            41.505305
          ],
          [
            11.883273,
            54.149729,
            41.380836
          ],
          [
            11.883665,
            54.149808,
            41.261191
          ],
          [
            11.884058,
            54.149881,
            41.142134
          ],
          [
            11.884458,
            54.14996,
            41.020303
          ],
          [
            11.884875,
            54.150014,
            40.896897
          ],
          [
            11.885287,
            54.150054,
            40.776256
          ],
          [
            11.885613,
            54.150076,
            40.681487
          ],
          [
            11.886029,
            54.150071,
            40.801369
          ],
          [
            11.886428,
            54.150066,
            41.144566
          ],
          [
            11.886838,
            54.150075,
            41.498064
          ],
          [
            11.887221,
            54.150118,
            41.833786
          ],
          [
            11.887595,
            54.150172,
            42.16523
          ],
          [
            11.887937,
            54.150229,
            42.471355
          ],
          [
            11.888241,
            54.150299,
            42.752548
          ],
          [
            11.888596,
            54.150405,
            43.095782
          ],
          [
            11.889013,
            54.150488,
            43.273348
          ],
          [
            11.88936,
            54.150565,
            43.289367
          ],
          [
            11.889715,
            54.150654,
            43.306061
          ],
          [
            11.890018,
            54.150711,
            43.319791
          ],
          [
            11.890368,
            54.1508,
            43.336288
          ],
          [
            11.890761,
            54.150891,
            43.354518
          ],
          [
            11.891189,
            54.150986,
            43.374289
          ],
          [
            11.89149,
            54.151053,
            43.38818
          ],
          [
            11.891891,
            54.151129,
            43.349378
          ],
          [
            11.892305,
            54.151228,
            43.270628
          ],
          [
            11.892707,
            54.151321,
            43.194515
          ],
          [
            11.893071,
            54.151401,
            43.126043
          ],
          [
            11.893414,
            54.151498,
            43.058948
          ],
          [
            11.893826,
            54.151599,
            42.9803
          ],
          [
            11.894181,
            54.151676,
            42.913476
          ],
          [
            11.894584,
            54.151765,
            42.808207
          ],
          [
            11.894944,
            54.151851,
            42.620475
          ],
          [
            11.89524,
            54.151919,
            42.467013
          ],
          [
            11.895548,
            54.151986,
            42.308429
          ],
          [
            11.895887,
            54.152075,
            42.129138
          ],
          [
            11.896191,
            54.152129,
            41.975787
          ],
          [
            11.896553,
            54.15221,
            41.788145
          ],
          [
            11.896885,
            54.152301,
            41.611133
          ],
          [
            11.897177,
            54.152374,
            41.457757
          ],
          [
            11.897486,
            54.152446,
            41.404128
          ],
          [
            11.897865,
            54.152517,
            41.486216
          ],
          [
            11.898246,
            54.152596,
            41.569607
          ],
          [
            11.898558,
            54.152672,
            41.639318
          ],
          [
            11.898927,
            54.152756,
            41.72099
          ],
          [
            11.89931,
            54.152849,
            41.8065
          ],
          [
            11.899681,
            54.152937,
            41.889236
          ],
          [
            11.900016,
            54.153033,
            41.966133
          ],
          [
            11.900368,
            54.153121,
            41.980457
          ],
          [
            11.90075,
            54.153196,
            41.928356
          ],
          [
            11.901063,
            54.153247,
            41.886462
          ],
          [
            11.901419,
            54.153327,
            41.83725
          ],
          [
            11.901774,
            54.153417,
            41.787374
          ],
          [
            11.902181,
            54.153506,
            41.731272
          ],
          [
            11.90253,
            54.153591,
            41.68254
          ],
          [
            11.902889,
            54.153696,
            41.630742
          ],
          [
            11.903257,
            54.15379,
            41.777034
          ],
          [
            11.90362,
            54.153868,
            42.052093
          ],
          [
            11.903948,
            54.153934,
            42.299315
          ],
          [
            11.904268,
            54.154006,
            42.543155
          ],
          [
            11.904606,
            54.154074,
            42.797369
          ],
          [
            11.904942,
            54.154162,
            43.059331
          ],
          [
            11.905306,
            54.15424,
            43.335038
          ],
          [
            11.905657,
            54.154332,
            43.60858
          ],
          [
            11.906011,
            54.154418,
            43.743151
          ],
          [
            11.906359,
            54.154506,
            43.58572
          ],
          [
            11.906669,
            54.154606,
            43.438639
          ],
          [
            11.906953,
            54.154725,
            43.293509
          ],
          [
            11.907295,
            54.154827,
            43.133995
          ],
          [
            11.907574,
            54.15493,
            42.997053
          ],
          [
            11.90788,
            54.155042,
            42.847105
          ],
          [
            11.908151,
            54.155132,
            42.717677
          ],
          [
            11.908426,
            54.155234,
            42.582518
          ],
          [
            11.908706,
            54.155332,
            42.535652
          ],
          [
            11.908987,
            54.155437,
            42.568368
          ],
          [
            11.909287,
            54.155545,
            42.602925
          ],
          [
            11.909604,
            54.155648,
            42.638464
          ],
          [
            11.909946,
            54.15576,
            42.676875
          ],
          [
            11.910299,
            54.15589,
            42.717746
          ],
          [
            11.910633,
            54.156002,
            42.755529
          ],
          [
            11.910953,
            54.156116,
            42.792251
          ],
          [
            11.911353,
            54.156203,
            42.775493
          ],
          [
            11.911725,
            54.156319,
            42.647573
          ],
          [
            11.91207,
            54.156422,
            42.530101
          ],
          [
            11.912329,
            54.156522,
            42.435683
          ],
          [
            11.912633,
            54.156661,
            42.318391
          ],
          [
            11.912973,
            54.156838,
            42.18039
          ],
          [
            11.91328,
            54.157014,
            42.050068
          ],
          [
            11.913613,
            54.157155,
            41.925213
          ],
          [
            11.913986,
            54.157265,
            41.986907
          ],
          [
            11.914352,
            54.157382,
            42.126531
          ],
          [
            11.914668,
            54.157489,
            42.248808
          ],
          [
            11.915004,
            54.157598,
            42.37754
          ],
          [
            11.915359,
            54.157719,
            42.515087
          ],
          [
            11.915723,
            54.157832,
            42.653188
          ],
          [
            11.916117,
            54.157949,
            42.801094
          ],
          [
            11.916443,
            54.158061,
            42.950851
          ],
          [
            11.916756,
            54.158165,
            43.319874
          ],
          [
            11.917111,
            54.158258,
            43.7187
          ],
          [
            11.91745,
            54.158364,
            44.112755
          ],
          [
            11.917807,
            54.158459,
            44.514891
          ],
          [
            11.918138,
            54.158551,
            44.890614
          ],
          [
            11.918472,
            54.158642,
            45.268392
          ],
          [
            11.918818,
            54.158699,
            45.638626
          ],
          [
            11.91917,
            54.158781,
            46.028788
          ],
          [
            11.919488,
            54.158896,
            45.776667
          ],
          [
            11.919859,
            54.158992,
            45.42929
          ],
          [
            11.920232,
            54.159084,
            45.082745
          ],
          [
            11.920565,
            54.159173,
            44.769304
          ],
          [
            11.920892,
            54.15922,
            44.481068
          ],
          [
            11.921227,
            54.159273,
            44.183993
          ],
          [
            11.921614,
            54.159319,
            43.845941
          ],
          [
            11.921973,
            54.159369,
            43.529998
          ],
          [
            11.922336,
            54.159433,
            43.376187
          ],
          [
            11.922715,
            54.15951,
            43.286364
          ],
          [
            11.923095,
            54.159586,
            43.19666
          ],
          [
            11.923483,
            54.159648,
            43.106795
          ],
          [
            11.923854,
            54.159715,
            43.020059
          ],
          [
            11.924289,
            54.159799,
            42.917734
          ],
          [
            11.924669,
            54.159868,
            42.82881
          ],
          [
            11.925025,
            54.159946,
            42.749942
          ],
          [
            11.925363,
            54.160019,
            42.746124
          ],
          [
            11.925673,
            54.160099,
            42.742536
          ],
          [
            11.926014,
            54.160188,
            42.738583
          ],
          [
            11.926353,
            54.160268,
            42.73471
          ],
          [
            11.926685,
            54.160337,
            42.73098
          ],
          [
            11.926995,
            54.160403,
            42.727487
          ],
          [
            11.927301,
            54.160489,
            42.723879
          ],
          [
            11.927181,
            54.160631,
            42.720439
          ],
          [
            11.927439,
            54.160522,
            42.792562
          ],
          [
            11.927773,
            54.160544,
            43.179359
          ],
          [
            11.928092,
            54.160508,
            43.549571
          ],
          [
            11.928432,
            54.160524,
            43.938508
          ],
          [
            11.928772,
            54.160513,
            44.327028
          ],
          [
            11.929101,
            54.160551,
            44.709244
          ],
          [
            11.929436,
            54.160568,
            45.099528
          ],
          [
            11.929742,
            54.160656,
            45.487927
          ],
          [
            11.930053,
            54.160751,
            45.8919
          ],
          [
            11.930423,
            54.160762,
            46.270957
          ],
          [
            11.930762,
            54.160818,
            46.49371
          ],
          [
            11.931123,
            54.160867,
            46.728498
          ],
          [
            11.931463,
            54.160936,
            46.958318
          ],
          [
            11.931819,
            54.161008,
            47.196337
          ],
          [
            11.932179,
            54.161025,
            47.424453
          ],
          [
            11.932527,
            54.161025,
            47.64547
          ],
          [
            11.932438,
            54.160841,
            47.871519
          ],
          [
            11.932237,
            54.160682,
            48.085622
          ],
          [
            11.932447,
            54.16083,
            48.359625
          ],
          [
            11.932681,
            54.160961,
            48.640278
          ],
          [
            11.93294,
            54.16112,
            48.965559
          ],
          [
            11.933176,
            54.161267,
            49.264286
          ],
          [
            11.933459,
            54.161358,
            49.546939
          ],
          [
            11.933782,
            54.16141,
            49.837567
          ],
          [
            11.93377,
            54.161608,
            50.132712
          ],
          [
            11.933968,
            54.161649,
            50.405694
          ],
          [
            11.93426,
            54.161769,
            50.715632
          ],
          [
            11.934594,
            54.161827,
            50.61978
          ],
          [
            11.934908,
            54.161911,
            50.333625
          ],
          [
            11.935184,
            54.16202,
            50.060446
          ],
          [
            11.935476,
            54.162091,
            49.797624
          ],
          [
            11.935805,
            54.162087,
            49.527947
          ],
          [
            11.936108,
            54.16217,
            49.252351
          ],
          [
            11.93633,
            54.16206,
            48.987311
          ],
          [
            11.936328,
            54.16206,
            48.731581
          ],
          [
            11.936591,
            54.16196,
            48.466543
          ],
          [
            11.936932,
            54.162,
            48.275184
          ],
          [
            11.93726,
            54.162065,
            48.216582
          ],
          [
            11.937575,
            54.16215,
            48.156932
          ],
          [
            11.937856,
            54.162253,
            48.100842
          ],
          [
            11.938149,
            54.162366,
            48.041512
          ],
          [
            11.938472,
            54.162445,
            47.982109
          ],
          [
            11.938813,
            54.162521,
            47.9204
          ],
          [
            11.939158,
            54.162581,
            47.859479
          ],
          [
            11.939469,
            54.162654,
            47.802721
          ],
          [
            11.939803,
            54.162697,
            47.839855
          ],
          [
            11.940102,
            54.162797,
            47.938514
          ],
          [
            11.94041,
            54.162894,
            48.039415
          ],
          [
            11.9407,
            54.163008,
            48.139481
          ],
          [
            11.941003,
            54.163066,
            48.234261
          ],
          [
            11.941295,
            54.163175,
            48.334017
          ],
          [
            11.941581,
            54.163296,
            48.437596
          ],
          [
            11.941947,
            54.163321,
            48.54332
          ],
          [
            11.942293,
            54.163345,
            48.64455
          ],
          [
            11.94258,
            54.163431,
            48.460088
          ],
          [
            11.942923,
            54.163528,
            48.178658
          ],
          [
            11.943247,
            54.163613,
            47.916226
          ],
          [
            11.943557,
            54.163723,
            47.648603
          ],
          [
            11.943902,
            54.163867,
            47.335683
          ],
          [
            11.944231,
            54.163984,
            47.050799
          ],
          [
            11.944562,
            54.16405,
            46.79191
          ],
          [
            11.944889,
            54.164096,
            46.543646
          ],
          [
            11.945196,
            54.164192,
            46.58119
          ],
          [
            11.945496,
            54.164252,
            47.003279
          ],
          [
            11.945856,
            54.164301,
            47.494389
          ],
          [
            11.946178,
            54.16435,
            47.969854
          ],
          [
            11.946501,
            54.164431,
            48.438272
          ],
          [
            11.946712,
            54.16433,
            48.888318
          ],
          [
            11.946913,
            54.164192,
            49.319267
          ],
          [
            11.947192,
            54.164282,
            49.742247
          ],
          [
            11.947502,
            54.164379,
            50.209168
          ],
          [
            11.947848,
            54.164418,
            50.217352
          ],
          [
            11.947998,
            54.164237,
            49.665427
          ],
          [
            11.948329,
            54.164338,
            49.073388
          ],
          [
            11.948631,
            54.164428,
            48.538482
          ],
          [
            11.94895,
            54.164528,
            47.967335
          ],
          [
            11.949267,
            54.164606,
            47.421917
          ],
          [
            11.949621,
            54.164616,
            46.860594
          ],
          [
            11.949956,
            54.164624,
            46.330794
          ],
          [
            11.950279,
            54.164635,
            45.819925
          ],
          [
            11.950578,
            54.164561,
            45.55955
          ],
          [
            11.950887,
            54.164567,
            45.459352
          ],
          [
            11.951201,
            54.164598,
            45.359933
          ],
          [
            11.95158,
            54.16458,
            45.240178
          ],
          [
            11.951943,
            54.16461,
            45.126174
          ],
          [
            11.952324,
            54.164632,
            45.007137
          ],
          [
            11.952732,
            54.164684,
            44.877451
          ],
          [
            11.953098,
            54.164688,
            44.763714
          ],
          [
            11.953494,
            54.164723,
            44.669988
          ],
          [
            11.953853,
            54.164734,
            44.6772
          ],
          [
            11.954268,
            54.164751,
            44.685441
          ],
          [
            11.954653,
            54.164782,
            44.693146
          ],
          [
            11.954975,
            54.164827,
            44.699702
          ],
          [
            11.955324,
            54.164838,
            44.70663
          ],
          [
            11.955673,
            54.16489,
            44.71377
          ],
          [
            11.956036,
            54.164954,
            44.721277
          ],
          [
            11.956418,
            54.164998,
            44.731305
          ],
          [
            11.956845,
            54.165027,
            44.987484
          ],
          [
            11.957231,
            54.165044,
            45.218028
          ],
          [
            11.957595,
            54.165051,
            45.435109
          ],
          [
            11.957973,
            54.165095,
            45.665183
          ],
          [
            11.958373,
            54.165149,
            45.91054
          ],
          [
            11.958748,
            54.165217,
            46.144017
          ],
          [
            11.959081,
            54.165275,
            46.352745
          ],
          [
            11.959459,
            54.165313,
            46.519658
          ],
          [
            11.959817,
            54.165361,
            46.197711
          ],
          [
            11.960257,
            54.165396,
            45.808457
          ],
          [
            11.96063,
            54.165393,
            45.47993
          ],
          [
            11.961001,
            54.165411,
            45.152858
          ],
          [
            11.961431,
            54.165481,
            44.754591
          ],
          [
            11.961786,
            54.165556,
            44.422173
          ],
          [
            11.962178,
            54.165599,
            44.072255
          ],
          [
            11.962545,
            54.165663,
            43.887162
          ],
          [
            11.96287,
            54.165747,
            43.946572
          ],
          [
            11.963179,
            54.165801,
            44.000694
          ],
          [
            11.963506,
            54.165843,
            44.056714
          ],
          [
            11.963903,
            54.16589,
            44.124605
          ],
          [
            11.964194,
            54.165964,
            44.177705
          ],
          [
            11.964503,
            54.166042,
            44.234035
          ],
          [
            11.964922,
            54.166144,
            44.310235
          ],
          [
            11.965267,
            54.166174,
            44.36861
          ],
          [
            11.965666,
            54.166249,
            44.432926
          ],
          [
            11.966064,
            54.166324,
            44.496273
          ],
          [
            11.96645,
            54.166398,
            44.557798
          ],
          [
            11.966863,
            54.166465,
            44.622714
          ],
          [
            11.967257,
            54.166539,
            44.685411
          ],
          [
            11.967634,
            54.166633,
            44.747572
          ],
          [
            11.968033,
            54.166733,
            44.813321
          ],
          [
            11.968404,
            54.166835,
            44.672395
          ],
          [
            11.968752,
            54.16693,
            44.377461
          ],
          [
            11.969037,
            54.167017,
            44.13046
          ],
          [
            11.969364,
            54.1671,
            43.856846
          ],
          [
            11.969661,
            54.167165,
            43.613088
          ],
          [
            11.969965,
            54.16724,
            43.359384
          ],
          [
            11.970298,
            54.167353,
            43.06377
          ],
          [
            11.970588,
            54.167428,
            42.820385
          ],
          [
            11.970901,
            54.167507,
            42.55827
          ],
          [
            11.97119,
            54.167584,
            42.552564
          ],
          [
            11.971482,
            54.167652,
            42.65146
          ],
          [
            11.971832,
            54.167766,
            42.777353
          ],
          [
            11.972132,
            54.167839,
            42.879559
          ],
          [
            11.972481,
            54.167923,
            42.998167
          ],
          [
            11.972863,
            54.168046,
            43.135242
          ],
          [
            11.973238,
            54.168162,
            43.268806
          ],
          [
            11.973595,
            54.168258,
            43.392383
          ],
          [
            11.973959,
            54.168363,
            43.654625
          ],
          [
            11.974339,
            54.16847,
            44.039073
          ],
          [
            11.974723,
            54.168576,
            44.42619
          ],
          [
            11.975087,
            54.168677,
            44.793427
          ],
          [
            11.975447,
            54.16876,
            45.146119
          ],
          [
            11.975794,
            54.168838,
            45.485202
          ],
          [
            11.97609,
            54.168922,
            45.785358
          ],
          [
            11.976391,
            54.169006,
            46.089357
          ],
          [
            11.976724,
            54.169094,
            46.339081
          ],
          [
            11.977065,
            54.169179,
            46.513875
          ],
          [
            11.977444,
            54.169298,
            46.716849
          ],
          [
            11.977793,
            54.169406,
            46.903093
          ],
          [
            11.978177,
            54.169515,
            47.104329
          ],
          [
            11.97854,
            54.169617,
            47.294123
          ],
          [
            11.978937,
            54.169718,
            47.498227
          ],
          [
            11.979342,
            54.169818,
            47.703778
          ],
          [
            11.979733,
            54.169923,
            47.862134
          ],
          [
            11.98012,
            54.170029,
            48.019434
          ],
          [
            11.980503,
            54.170129,
            48.1738
          ],
          [
            11.980881,
            54.170224,
            48.325214
          ],
          [
            11.981243,
            54.170312,
            48.469525
          ],
          [
            11.981563,
            54.170377,
            48.594211
          ],
          [
            11.981629,
            54.17057,
            48.71819
          ],
          [
            11.98194,
            54.170633,
            48.861936
          ],
          [
            11.982253,
            54.170716,
            49.177294
          ],
          [
            11.982585,
            54.170793,
            49.503774
          ],
          [
            11.9829,
            54.170861,
            49.810714
          ],
          [
            11.983204,
            54.17095,
            50.120865
          ],
          [
            11.98357,
            54.171027,
            50.476066
          ],
          [
            11.983897,
            54.171119,
            50.80756
          ],
          [
            11.984295,
            54.171174,
            51.181239
          ],
          [
            11.98461,
            54.17125,
            51.492147
          ],
          [
            11.984932,
            54.171339,
            51.540306
          ],
          [
            11.9853,
            54.171447,
            51.352339
          ],
          [
            11.985638,
            54.171544,
            51.180041
          ],
          [
            11.986028,
            54.171624,
            50.990844
          ],
          [
            11.986361,
            54.171702,
            50.827071
          ],
          [
            11.986649,
            54.171797,
            50.676127
          ],
          [
            11.986962,
            54.171878,
            50.519867
          ],
          [
            11.987373,
            54.172011,
            50.305057
          ],
          [
            11.987789,
            54.172134,
            49.798925
          ],
          [
            11.988104,
            54.172211,
            49.306975
          ],
          [
            11.98851,
            54.172285,
            48.697556
          ],
          [
            11.988885,
            54.172376,
            48.116298
          ],
          [
            11.989233,
            54.172458,
            47.57684
          ],
          [
            11.989559,
            54.172507,
            47.094608
          ],
          [
            11.989931,
            54.172591,
            46.523479
          ],
          [
            11.99035,
            54.172701,
            45.865913
          ],
          [
            11.990696,
            54.172777,
            45.570468
          ],
          [
            11.991023,
            54.17282,
            45.318034
          ],
          [
            11.991386,
            54.172915,
            45.01753
          ],
          [
            11.991774,
            54.172983,
            44.71245
          ],
          [
            11.992165,
            54.173071,
            44.396815
          ],
          [
            11.992537,
            54.173143,
            44.101676
          ],
          [
            11.992927,
            54.173222,
            43.789332
          ],
          [
            11.99328,
            54.173305,
            43.518416
          ],
          [
            11.993646,
            54.173388,
            43.556876
          ],
          [
            11.994051,
            54.173446,
            43.598285
          ],
          [
            11.994349,
            54.173533,
            43.630708
          ],
          [
            11.99468,
            54.173623,
            43.666331
          ],
          [
            11.995094,
            54.173669,
            43.70744
          ],
          [
            11.995471,
            54.17374,
            43.746002
          ],
          [
            11.99591,
            54.173814,
            43.790539
          ],
          [
            11.996222,
            54.173949,
            43.741893
          ],
          [
            11.996509,
            54.174032,
            43.561776
          ],
          [
            11.996916,
            54.174107,
            43.32285
          ],
          [
            11.997267,
            54.174145,
            43.121098
          ],
          [
            11.997656,
            54.174193,
            42.898502
          ],
          [
            11.99805,
            54.174232,
            42.674662
          ],
          [
            11.998375,
            54.174306,
            42.477947
          ],
          [
            11.998703,
            54.174384,
            42.278565
          ],
          [
            11.998999,
            54.174512,
            42.073378
          ],
          [
            11.999276,
            54.174627,
            41.891381
          ],
          [
            11.999613,
            54.174761,
            41.672997
          ],
          [
            11.999943,
            54.174876,
            41.46715
          ],
          [
            12.000262,
            54.174981,
            41.27095
          ],
          [
            12.000567,
            54.175067,
            41.089142
          ],
          [
            12.00095,
            54.175162,
            40.866226
          ],
          [
            12.001301,
            54.175251,
            40.661201
          ],
          [
            12.001598,
            54.175329,
            40.486635
          ],
          [
            12.001953,
            54.175429,
            40.567455
          ],
          [
            12.002268,
            54.175505,
            40.692429
          ],
          [
            12.002641,
            54.175612,
            40.845281
          ],
          [
            12.003023,
            54.17572,
            41.000915
          ],
          [
            12.003348,
            54.175825,
            41.137115
          ],
          [
            12.003697,
            54.17593,
            41.28111
          ],
          [
            12.004026,
            54.176003,
            41.410331
          ],
          [
            12.004352,
            54.176087,
            41.541093
          ],
          [
            12.004707,
            54.17618,
            42.077127
          ],
          [
            12.005039,
            54.176282,
            42.717014
          ],
          [
            12.00536,
            54.176355,
            43.30262
          ],
          [
            12.005706,
            54.176435,
            43.93519
          ],
          [
            12.006109,
            54.176539,
            44.684036
          ],
          [
            12.006463,
            54.176628,
            45.339377
          ],
          [
            12.006747,
            54.176716,
            45.885782
          ],
          [
            12.007117,
            54.176795,
            46.555479
          ],
          [
            12.0075,
            54.176898,
            47.112045
          ],
          [
            12.007872,
            54.176981,
            47.558868
          ],
          [
            12.008272,
            54.177055,
            48.029626
          ],
          [
            12.008626,
            54.177115,
            48.443097
          ],
          [
            12.009054,
            54.177168,
            48.933929
          ],
          [
            12.009434,
            54.177242,
            49.383187
          ],
          [
            12.009827,
            54.177284,
            49.831378
          ],
          [
            12.010166,
            54.17734,
            50.226533
          ],
          [
            12.010508,
            54.177292,
            50.7227
          ],
          [
            12.010829,
            54.177232,
            51.205843
          ],
          [
            12.011164,
            54.177149,
            51.726071
          ],
          [
            12.011506,
            54.177107,
            52.226378
          ],
          [
            12.011786,
            54.177007,
            52.695234
          ],
          [
            12.012085,
            54.176906,
            53.189856
          ],
          [
            12.012405,
            54.17684,
            53.674196
          ],
          [
            12.012721,
            54.176757,
            54.168576
          ],
          [
            12.013046,
            54.176695,
            54.603576
          ],
          [
            12.013386,
            54.176605,
            53.8863
          ],
          [
            12.013712,
            54.176536,
            53.222356
          ],
          [
            12.014036,
            54.176474,
            52.571849
          ],
          [
            12.014333,
            54.176406,
            51.963291
          ],
          [
            12.014664,
            54.176314,
            51.26295
          ],
          [
            12.014989,
            54.176252,
            50.609857
          ],
          [
            12.015293,
            54.176157,
            49.952272
          ],
          [
            12.015647,
            54.176112,
            49.260355
          ],
          [
            12.015973,
            54.176059,
            48.789083
          ],
          [
            12.016333,
            54.176025,
            48.874268
          ],
          [
            12.016687,
            54.175988,
            48.958237
          ],
          [
            12.016984,
            54.17593,
            49.03176
          ],
          [
            12.017338,
            54.175903,
            49.115261
          ],
          [
            12.017685,
            54.175888,
            49.196554
          ],
          [
            12.018068,
            54.17584,
            49.287914
          ],
          [
            12.018443,
            54.175808,
            49.376489
          ],
          [
            12.018787,
            54.175736,
            49.461729
          ],
          [
            12.01913,
            54.175718,
            50.01697
          ],
          [
            12.019478,
            54.17567,
            50.81004
          ],
          [
            12.019857,
            54.175627,
            51.666724
          ],
          [
            12.020199,
            54.175588,
            52.443173
          ],
          [
            12.02061,
            54.17551,
            53.418301
          ],
          [
            12.020976,
            54.175507,
            54.230108
          ],
          [
            12.021368,
            54.175456,
            55.127864
          ],
          [
            12.021788,
            54.175433,
            56.063572
          ],
          [
            12.022197,
            54.17538,
            55.825357
          ],
          [
            12.022616,
            54.17533,
            55.172101
          ],
          [
            12.022992,
            54.175284,
            54.583485
          ],
          [
            12.023346,
            54.175212,
            54.010996
          ],
          [
            12.023695,
            54.175184,
            53.470565
          ],
          [
            12.024011,
            54.175152,
            52.980679
          ],
          [
            12.024323,
            54.17511,
            52.491624
          ],
          [
            12.024787,
            54.175083,
            51.779264
          ],
          [
            12.025123,
            54.175022,
            51.428825
          ],
          [
            12.025447,
            54.175005,
            51.185131
          ],
          [
            12.025766,
            54.174954,
            50.93831
          ],
          [
            12.026166,
            54.174916,
            50.635802
          ],
          [
            12.026485,
            54.174859,
            50.386801
          ],
          [
            12.026843,
            54.174811,
            50.112561
          ],
          [
            12.027203,
            54.174808,
            49.843364
          ],
          [
            12.027543,
            54.174775,
            49.586014
          ],
          [
            12.027852,
            54.174725,
            49.346702
          ],
          [
            12.028219,
            54.174685,
            50.06922
          ],
          [
            12.028566,
            54.174618,
            50.911636
          ],
          [
            12.028908,
            54.174557,
            51.731531
          ],
          [
            12.029257,
            54.174525,
            52.541761
          ],
          [
            12.029635,
            54.174482,
            53.424314
          ],
          [
            12.030005,
            54.174485,
            54.271843
          ],
          [
            12.030373,
            54.174504,
            55.117617
          ],
          [
            12.030774,
            54.174519,
            56.037499
          ],
          [
            12.031138,
            54.174505,
            56.403929
          ],
          [
            12.031593,
            54.174509,
            56.513964
          ],
          [
            12.031976,
            54.174527,
            56.606856
          ],
          [
            12.032337,
            54.174537,
            56.694221
          ],
          [
            12.032698,
            54.174524,
            56.781719
          ],
          [
            12.033048,
            54.174522,
            56.866322
          ],
          [
            12.033459,
            54.174533,
            56.965973
          ],
          [
            12.033834,
            54.174523,
            57.056707
          ],
          [
            12.034176,
            54.174499,
            56.444352
          ],
          [
            12.034575,
            54.174494,
            55.160301
          ],
          [
            12.034933,
            54.174493,
            54.008716
          ],
          [
            12.035251,
            54.174505,
            52.979307
          ],
          [
            12.035603,
            54.174534,
            51.835454
          ],
          [
            12.03599,
            54.174588,
            50.556417
          ],
          [
            12.036381,
            54.17462,
            49.28396
          ],
          [
            12.03675,
            54.174645,
            48.089577
          ],
          [
            12.037063,
            54.174705,
            47.229798
          ],
          [
            12.037386,
            54.174773,
            47.333621
          ],
          [
            12.037819,
            54.17481,
            47.465983
          ],
          [
            12.038202,
            54.174867,
            47.58547
          ],
          [
            12.038586,
            54.174873,
            47.701624
          ],
          [
            12.038941,
            54.174924,
            47.812169
          ],
          [
            12.039288,
            54.174964,
            47.919101
          ],
          [
            12.039666,
            54.174992,
            48.03472
          ],
          [
            12.040038,
            54.175007,
            48.153092
          ],
          [
            12.040409,
            54.175023,
            48.355046
          ],
          [
            12.040756,
            54.175047,
            48.54478
          ],
          [
            12.041196,
            54.175121,
            48.793959
          ],
          [
            12.041532,
            54.175184,
            48.986011
          ],
          [
            12.041905,
            54.175215,
            49.190585
          ],
          [
            12.042211,
            54.175258,
            49.361794
          ],
          [
            12.042551,
            54.17525,
            49.547223
          ],
          [
            12.042946,
            54.175308,
            49.768401
          ],
          [
            12.043317,
            54.175349,
            49.275739
          ],
          [
            12.043697,
            54.175385,
            48.593094
          ],
          [
            12.044071,
            54.175436,
            47.914479
          ],
          [
            12.044476,
            54.175492,
            47.179203
          ],
          [
            12.044903,
            54.175527,
            46.416887
          ],
          [
            12.045266,
            54.175567,
            45.759896
          ],
          [
            12.045598,
            54.175608,
            45.159859
          ],
          [
            12.046,
            54.175645,
            44.440778
          ],
          [
            12.046368,
            54.175673,
            44.21752
          ],
          [
            12.046668,
            54.175721,
            44.066558
          ],
          [
            12.047135,
            54.175787,
            43.832537
          ],
          [
            12.04747,
            54.175842,
            43.663633
          ],
          [
            12.04783,
            54.175876,
            43.486597
          ],
          [
            12.048285,
            54.175897,
            43.265077
          ],
          [
            12.048644,
            54.175945,
            43.08635
          ],
          [
            12.048955,
            54.175976,
            42.933106
          ],
          [
            12.049394,
            54.175998,
            42.316985
          ],
          [
            12.049784,
            54.17604,
            41.670808
          ],
          [
            12.050157,
            54.176112,
            41.030849
          ],
          [
            12.050541,
            54.176153,
            40.39414
          ],
          [
            12.050963,
            54.176199,
            39.694556
          ],
          [
            12.051387,
            54.176214,
            39.002442
          ],
          [
            12.051739,
            54.176241,
            38.423756
          ],
          [
            12.052115,
            54.176299,
            37.920914
          ],
          [
            12.052485,
            54.176373,
            38.182958
          ],
          [
            12.052828,
            54.17643,
            38.422473
          ],
          [
            12.053204,
            54.176425,
            38.677143
          ],
          [
            12.053583,
            54.176352,
            38.944943
          ],
          [
            12.053907,
            54.176272,
            39.180515
          ],
          [
            12.054235,
            54.1762,
            39.415143
          ],
          [
            12.054621,
            54.176224,
            39.67722
          ],
          [
            12.054999,
            54.176289,
            39.937799
          ],
          [
            12.055333,
            54.176345,
            39.133646
          ],
          [
            12.055741,
            54.176381,
            38.179698
          ],
          [
            12.056069,
            54.176397,
            37.417795
          ],
          [
            12.056451,
            54.176413,
            36.529592
          ],
          [
            12.056843,
            54.176463,
            35.602402
          ],
          [
            12.05722,
            54.176511,
            34.711097
          ],
          [
            12.057603,
            54.176552,
            33.810979
          ],
          [
            12.05794,
            54.176597,
            33.012407
          ],
          [
            12.058361,
            54.176614,
            33.595311
          ],
          [
            12.058736,
            54.176646,
            34.41697
          ],
          [
            12.059085,
            54.176695,
            35.195063
          ],
          [
            12.059486,
            54.176717,
            36.068098
          ],
          [
            12.059928,
            54.176731,
            37.026358
          ],
          [
            12.060234,
            54.176764,
            37.700047
          ],
          [
            12.060546,
            54.176794,
            38.3849
          ],
          [
            12.060963,
            54.176846,
            39.308117
          ],
          [
            12.061341,
            54.176889,
            39.085141
          ],
          [
            12.061754,
            54.176927,
            38.512131
          ],
          [
            12.062117,
            54.176937,
            38.015425
          ],
          [
            12.062544,
            54.176956,
            37.429636
          ],
          [
            12.062921,
            54.176985,
            36.909614
          ],
          [
            12.063305,
            54.177049,
            36.363529
          ],
          [
            12.063727,
            54.177076,
            35.783261
          ],
          [
            12.064115,
            54.177067,
            35.320641
          ],
          [
            12.064487,
            54.177072,
            35.646226
          ],
          [
            12.064845,
            54.177057,
            35.96158
          ],
          [
            12.065263,
            54.177055,
            36.327026
          ],
          [
            12.065593,
            54.177044,
            36.616113
          ],
          [
            12.065996,
            54.177001,
            36.980234
          ],
          [
            12.066361,
            54.176955,
            37.306681
          ],
          [
            12.066736,
            54.176947,
            37.635215
          ],
          [
            12.067081,
            54.176945,
            37.937549
          ],
          [
            12.067516,
            54.176934,
            37.999954
          ],
          [
            12.067945,
            54.176929,
            38.021503
          ],
          [
            12.068352,
            54.17687,
            38.042615
          ],
          [
            12.068779,
            54.176837,
            38.064271
          ],
          [
            12.069157,
            54.176826,
            38.083277
          ],
          [
            12.069485,
            54.176789,
            38.100055
          ],
          [
            12.069851,
            54.176759,
            38.118633
          ],
          [
            12.070168,
            54.176729,
            38.134762
          ],
          [
            12.070559,
            54.176694,
            37.690476
          ],
          [
            12.07093,
            54.176651,
            37.263367
          ],
          [
            12.071354,
            54.17661,
            36.777847
          ],
          [
            12.071759,
            54.17656,
            36.307433
          ],
          [
            12.072184,
            54.176522,
            35.821404
          ],
          [
            12.072601,
            54.176484,
            35.344481
          ],
          [
            12.072998,
            54.176475,
            34.895338
          ],
          [
            12.073364,
            54.176461,
            34.884615
          ],
          [
            12.073717,
            54.176431,
            35.364972
          ],
          [
            12.074072,
            54.17638,
            35.857018
          ],
          [
            12.07447,
            54.17636,
            36.394727
          ],
          [
            12.074874,
            54.176333,
            36.942858
          ],
          [
            12.075265,
            54.176308,
            37.474014
          ],
          [
            12.075665,
            54.176283,
            38.015434
          ],
          [
            12.075995,
            54.17626,
            38.464541
          ],
          [
            12.076321,
            54.176265,
            38.735782
          ],
          [
            12.076694,
            54.176258,
            38.424932
          ],
          [
            12.077029,
            54.176279,
            38.139204
          ],
          [
            12.077432,
            54.176287,
            37.802616
          ],
          [
            12.077785,
            54.176318,
            37.503045
          ],
          [
            12.078147,
            54.176374,
            37.191111
          ],
          [
            12.078472,
            54.176369,
            36.918388
          ],
          [
            12.078858,
            54.176412,
            36.590683
          ],
          [
            12.079217,
            54.176431,
            36.290484
          ],
          [
            12.079573,
            54.176457,
            36.753859
          ],
          [
            12.079898,
            54.176413,
            37.328011
          ],
          [
            12.080293,
            54.176446,
            38.013489
          ],
          [
            12.080648,
            54.176468,
            38.626558
          ],
          [
            12.081029,
            54.176495,
            39.285416
          ],
          [
            12.081369,
            54.176528,
            39.88173
          ],
          [
            12.081723,
            54.176549,
            40.494792
          ],
          [
            12.082077,
            54.176589,
            41.113647
          ],
          [
            12.082457,
            54.176617,
            41.488761
          ],
          [
            12.082811,
            54.176651,
            41.427121
          ],
          [
            12.08315,
            54.176674,
            41.368338
          ],
          [
            12.083477,
            54.176695,
            41.311621
          ],
          [
            12.083793,
            54.176648,
            41.252678
          ],
          [
            12.084079,
            54.176731,
            41.197466
          ],
          [
            12.084387,
            54.176774,
            41.14228
          ],
          [
            12.084348,
            54.176788,
            41.088556
          ],
          [
            12.084509,
            54.17698,
            41.025719
          ],
          [
            12.084835,
            54.177013,
            41.008814
          ],
          [
            12.085138,
            54.177049,
            41.072872
          ],
          [
            12.085451,
            54.177115,
            41.143686
          ],
          [
            12.085784,
            54.177104,
            41.213345
          ],
          [
            12.085871,
            54.176913,
            41.283067
          ],
          [
            12.086211,
            54.176903,
            41.353317
          ],
          [
            12.086534,
            54.176933,
            41.421114
          ],
          [
            12.086849,
            54.176948,
            41.486731
          ],
          [
            12.087157,
            54.176829,
            41.563235
          ],
          [
            12.086907,
            54.176719,
            41.754357
          ],
          [
            12.087262,
            54.17668,
            42.076536
          ],
          [
            12.087476,
            54.17655,
            42.224123
          ],
          [
            12.087514,
            54.176566,
            42.389094
          ],
          [
            12.087494,
            54.176582,
            42.551109
          ],
          [
            12.087315,
            54.176713,
            42.698227
          ],
          [
            12.08703,
            54.176791,
            42.853253
          ],
          [
            12.086826,
            54.176939,
            43.008787
          ],
          [
            12.086487,
            54.176909,
            43.056465
          ],
          [
            12.086155,
            54.176881,
            42.997155
          ],
          [
            12.085861,
            54.176957,
            42.935158
          ],
          [
            12.085793,
            54.177165,
            42.871324
          ],
          [
            12.085733,
            54.177347,
            42.815273
          ],
          [
            12.085787,
            54.177357,
            42.756383
          ],
          [
            12.085787,
            54.177176,
            42.700271
          ],
          [
            12.085446,
            54.177098,
            42.635664
          ],
          [
            12.08509,
            54.177076,
            42.572627
          ],
          [
            12.084782,
            54.176999,
            42.746499
          ],
          [
            12.084456,
            54.176949,
            43.100426
          ],
          [
            12.084116,
            54.176963,
            43.456992
          ],
          [
            12.083894,
            54.176997,
            43.794285
          ],
          [
            12.084247,
            54.177036,
            44.189568
          ],
          [
            12.084576,
            54.177068,
            44.538519
          ],
          [
            12.084883,
            54.177131,
            44.880197
          ],
          [
            12.085255,
            54.177155,
            45.270951
          ],
          [
            12.085648,
            54.17717,
            45.681332
          ],
          [
            12.085807,
            54.17699,
            45.624174
          ],
          [
            12.086098,
            54.176918,
            45.474459
          ],
          [
            12.08645,
            54.176946,
            45.324179
          ],
          [
            12.086757,
            54.176984,
            45.183364
          ],
          [
            12.086996,
            54.176846,
            45.038311
          ],
          [
            12.087303,
            54.176772,
            44.895477
          ],
          [
            12.08759,
            54.176733,
            44.739631
          ],
          [
            12.087932,
            54.176778,
            44.591102
          ],
          [
            12.088232,
            54.17685,
            44.453941
          ],
          [
            12.08853,
            54.17691,
            44.373647
          ],
          [
            12.088858,
            54.176927,
            44.29094
          ],
          [
            12.089153,
            54.176985,
            44.213975
          ],
          [
            12.089506,
            54.177037,
            44.122302
          ],
          [
            12.089837,
            54.177076,
            44.03862
          ],
          [
            12.090143,
            54.17716,
            43.954713
          ],
          [
            12.090457,
            54.177219,
            43.87313
          ],
          [
            12.090767,
            54.177291,
            43.789203
          ],
          [
            12.090726,
            54.177526,
            43.689237
          ],
          [
            12.090939,
            54.177683,
            43.612415
          ],
          [
            12.091152,
            54.177579,
            43.544366
          ],
          [
            12.091198,
            54.177385,
            43.474588
          ],
          [
            12.091496,
            54.177403,
            43.409432
          ],
          [
            12.09181,
            54.177468,
            43.338057
          ],
          [
            12.092111,
            54.177532,
            43.270699
          ],
          [
            12.092416,
            54.177592,
            43.202812
          ],
          [
            12.092675,
            54.177498,
            43.128343
          ],
          [
            12.092812,
            54.17731,
            43.052298
          ],
          [
            12.092807,
            54.177071,
            42.223727
          ],
          [
            12.092541,
            54.176882,
            41.346844
          ],
          [
            12.092355,
            54.176666,
            40.437538
          ],
          [
            12.092629,
            54.17668,
            39.740901
          ],
          [
            12.093018,
            54.176789,
            38.837419
          ],
          [
            12.093265,
            54.176893,
            38.190557
          ],
          [
            12.093589,
            54.176906,
            37.504697
          ],
          [
            12.093895,
            54.17686,
            36.842891
          ],
          [
            12.094235,
            54.176816,
            36.539066
          ],
          [
            12.094601,
            54.176766,
            36.424232
          ],
          [
            12.094957,
            54.176742,
            36.314735
          ],
          [
            12.095297,
            54.176772,
            36.209551
          ],
          [
            12.095633,
            54.176761,
            36.106719
          ],
          [
            12.09597,
            54.176741,
            36.003218
          ],
          [
            12.096311,
            54.176725,
            35.898565
          ],
          [
            12.09664,
            54.176716,
            35.797872
          ],
          [
            12.096956,
            54.176697,
            35.700776
          ],
          [
            12.097265,
            54.176675,
            35.931134
          ],
          [
            12.097586,
            54.176702,
            36.312505
          ],
          [
            12.0979,
            54.176692,
            36.682472
          ],
          [
            12.098199,
            54.176643,
            37.047738
          ],
          [
            12.098627,
            54.176668,
            37.561765
          ],
          [
            12.098951,
            54.17666,
            37.943417
          ],
          [
            12.099307,
            54.176676,
            38.363678
          ],
          [
            12.099675,
            54.176696,
            38.798999
          ],
          [
            12.100076,
            54.176693,
            39.270891
          ],
          [
            12.100438,
            54.176709,
            38.969561
          ],
          [
            12.100771,
            54.176708,
            38.667871
          ],
          [
            12.101124,
            54.176691,
            38.34743
          ],
          [
            12.10151,
            54.176691,
            37.99761
          ],
          [
            12.101855,
            54.176644,
            37.676659
          ],
          [
            12.102207,
            54.176647,
            37.356885
          ],
          [
            12.102638,
            54.176652,
            36.966876
          ],
          [
            12.10302,
            54.176648,
            36.620617
          ],
          [
            12.103409,
            54.17664,
            36.841779
          ],
          [
            12.103779,
            54.176669,
            37.316587
          ],
          [
            12.104192,
            54.176655,
            37.842779
          ],
          [
            12.104577,
            54.176632,
            38.335327
          ],
          [
            12.104907,
            54.176642,
            38.755998
          ],
          [
            12.105252,
            54.176658,
            39.197231
          ],
          [
            12.105632,
            54.176674,
            39.683169
          ],
          [
            12.105953,
            54.176692,
            40.094132
          ],
          [
            12.106305,
            54.176705,
            40.404386
          ],
          [
            12.106675,
            54.176711,
            40.364681
          ],
          [
            12.107076,
            54.176696,
            40.321573
          ],
          [
            12.107434,
            54.176697,
            40.283179
          ],
          [
            12.107836,
            54.176718,
            40.239901
          ],
          [
            12.108213,
            54.176729,
            40.199414
          ],
          [
            12.108592,
            54.17674,
            40.158714
          ],
          [
            12.108953,
            54.17678,
            40.119251
          ],
          [
            12.10935,
            54.176871,
            40.150184
          ],
          [
            12.10974,
            54.176964,
            40.39122
          ],
          [
            12.110122,
            54.177059,
            40.628971
          ],
          [
            12.110491,
            54.177149,
            40.857912
          ],
          [
            12.110821,
            54.177249,
            41.070609
          ],
          [
            12.111144,
            54.177347,
            41.278907
          ],
          [
            12.1115,
            54.177471,
            41.51624
          ],
          [
            12.111872,
            54.177583,
            41.755692
          ],
          [
            12.112224,
            54.17768,
            41.777659
          ],
          [
            12.112537,
            54.177781,
            41.675672
          ],
          [
            12.112896,
            54.177885,
            41.561504
          ],
          [
            12.113252,
            54.177959,
            41.453829
          ],
          [
            12.113569,
            54.178044,
            41.35403
          ],
          [
            12.11389,
            54.178113,
            41.256548
          ],
          [
            12.114183,
            54.178211,
            41.160208
          ],
          [
            12.114535,
            54.178305,
            41.049898
          ],
          [
            12.114872,
            54.178421,
            41.014611
          ],
          [
            12.115175,
            54.178554,
            41.177869
          ],
          [
            12.115518,
            54.178692,
            41.357607
          ],
          [
            12.115889,
            54.1788,
            41.536146
          ],
          [
            12.116216,
            54.178877,
            41.688638
          ],
          [
            12.116565,
            54.178969,
            41.854634
          ],
          [
            12.116936,
            54.179103,
            42.042477
          ],
          [
            12.117321,
            54.179229,
            42.232556
          ],
          [
            12.11768,
            54.179382,
            42.465673
          ],
          [
            12.117937,
            54.179493,
            42.647225
          ],
          [
            12.118251,
            54.179621,
            42.864473
          ],
          [
            12.118577,
            54.179762,
            43.094643
          ],
          [
            12.118891,
            54.179912,
            43.325166
          ],
          [
            12.119237,
            54.18003,
            43.552587
          ],
          [
            12.119505,
            54.180155,
            43.74773
          ],
          [
            12.119813,
            54.180298,
            43.971166
          ],
          [
            12.120069,
            54.180433,
            43.974093
          ],
          [
            12.120418,
            54.180588,
            43.85256
          ],
          [
            12.12073,
            54.180716,
            43.74673
          ],
          [
            12.121044,
            54.180834,
            43.642873
          ],
          [
            12.121305,
            54.180953,
            43.550653
          ],
          [
            12.121607,
            54.1811,
            43.441706
          ],
          [
            12.121935,
            54.181223,
            43.33367
          ],
          [
            12.122226,
            54.181368,
            43.227673
          ],
          [
            12.122572,
            54.181515,
            43.20651
          ],
          [
            12.122932,
            54.181677,
            43.242169
          ],
          [
            12.123246,
            54.181821,
            43.273523
          ],
          [
            12.123547,
            54.181956,
            43.303299
          ],
          [
            12.123844,
            54.182112,
            43.33464
          ],
          [
            12.124171,
            54.182278,
            43.368617
          ],
          [
            12.124486,
            54.182434,
            43.401012
          ],
          [
            12.124805,
            54.182619,
            43.425739
          ],
          [
            12.125126,
            54.182797,
            43.423992
          ],
          [
            12.125431,
            54.182943,
            43.422435
          ],
          [
            12.125708,
            54.183089,
            43.420962
          ],
          [
            12.126025,
            54.183252,
            43.41929
          ],
          [
            12.126323,
            54.183422,
            43.417647
          ],
          [
            12.126617,
            54.183582,
            43.416061
          ],
          [
            12.126909,
            54.183732,
            43.414526
          ],
          [
            12.127231,
            54.183889,
            43.211487
          ],
          [
            12.12757,
            54.184068,
            42.91574
          ],
          [
            12.127856,
            54.184221,
            42.664683
          ],
          [
            12.128137,
            54.184385,
            42.407622
          ],
          [
            12.128374,
            54.184505,
            42.20461
          ],
          [
            12.128614,
            54.18464,
            41.988868
          ],
          [
            12.128849,
            54.184767,
            41.78158
          ],
          [
            12.129204,
            54.184919,
            41.49655
          ],
          [
            12.12946,
            54.185091,
            41.461154
          ],
          [
            12.129677,
            54.185232,
            41.505515
          ],
          [
            12.129914,
            54.185412,
            41.558608
          ],
          [
            12.130129,
            54.185579,
            41.607462
          ],
          [
            12.130377,
            54.185749,
            41.659694
          ],
          [
            12.130627,
            54.185928,
            41.713724
          ],
          [
            12.130847,
            54.186087,
            41.761529
          ],
          [
            12.131092,
            54.186274,
            41.816585
          ],
          [
            12.131365,
            54.186471,
            41.804373
          ],
          [
            12.131601,
            54.186624,
            41.746514
          ],
          [
            12.131801,
            54.18677,
            41.693978
          ],
          [
            12.132061,
            54.186952,
            41.627369
          ],
          [
            12.132308,
            54.187162,
            41.55572
          ],
          [
            12.132506,
            54.187305,
            41.503987
          ],
          [
            12.132725,
            54.187487,
            41.441501
          ],
          [
            12.132959,
            54.18766,
            41.379567
          ],
          [
            12.133193,
            54.187825,
            41.391316
          ],
          [
            12.133436,
            54.18802,
            41.576461
          ],
          [
            12.133687,
            54.188211,
            41.761324
          ],
          [
            12.133935,
            54.188368,
            41.925822
          ],
          [
            12.134201,
            54.188568,
            42.120236
          ],
          [
            12.134437,
            54.188748,
            42.294275
          ],
          [
            12.134686,
            54.188929,
            42.472532
          ],
          [
            12.134919,
            54.189105,
            42.64332
          ],
          [
            12.135147,
            54.189279,
            42.673783
          ],
          [
            12.135387,
            54.189453,
            42.591679
          ],
          [
            12.135652,
            54.18965,
            42.49962
          ],
          [
            12.135938,
            54.189827,
            42.410103
          ],
          [
            12.136182,
            54.190032,
            42.318327
          ],
          [
            12.136387,
            54.190197,
            42.24339
          ],
          [
            12.136642,
            54.190372,
            42.158941
          ],
          [
            12.136923,
            54.190565,
            42.06579
          ],
          [
            12.137181,
            54.19076,
            42.005034
          ],
          [
            12.137428,
            54.190921,
            41.954315
          ],
          [
            12.137724,
            54.191129,
            41.89087
          ],
          [
            12.137953,
            54.191319,
            41.836354
          ],
          [
            12.138218,
            54.191503,
            41.779962
          ],
          [
            12.138418,
            54.191659,
            41.734215
          ],
          [
            12.138652,
            54.19183,
            41.682803
          ],
          [
            12.138864,
            54.191978,
            41.637417
          ],
          [
            12.139063,
            54.192143,
            41.673392
          ],
          [
            12.139266,
            54.192311,
            41.711955
          ],
          [
            12.1395,
            54.192473,
            41.751695
          ],
          [
            12.139714,
            54.192616,
            41.78736
          ],
          [
            12.139966,
            54.192759,
            41.82585
          ],
          [
            12.14028,
            54.192888,
            41.867909
          ],
          [
            12.140589,
            54.192971,
            41.90519
          ],
          [
            12.140908,
            54.193051,
            41.94324
          ],
          [
            12.141251,
            54.193116,
            41.947679
          ],
          [
            12.141569,
            54.19316,
            41.849861
          ],
          [
            12.14188,
            54.193199,
            41.75491
          ],
          [
            12.142278,
            54.193217,
            41.635629
          ],
          [
            12.1426,
            54.193235,
            41.539038
          ],
          [
            12.142925,
            54.193277,
            41.439637
          ],
          [
            12.14323,
            54.193315,
            41.34655
          ],
          [
            12.143631,
            54.193365,
            41.224164
          ],
          [
            12.14404,
            54.193401,
            41.100695
          ],
          [
            12.144476,
            54.193461,
            41.26919
          ],
          [
            12.14481,
            54.193503,
            41.514777
          ],
          [
            12.14513,
            54.193535,
            41.750222
          ],
          [
            12.14547,
            54.193505,
            42.002591
          ],
          [
            12.145806,
            54.19352,
            42.24478
          ],
          [
            12.146168,
            54.193527,
            42.505085
          ],
          [
            12.146525,
            54.193521,
            42.761794
          ],
          [
            12.146882,
            54.193457,
            43.030753
          ],
          [
            12.147227,
            54.193331,
            43.276515
          ],
          [
            12.147588,
            54.193208,
            43.336057
          ],
          [
            12.147929,
            54.193102,
            43.39108
          ],
          [
            12.148258,
            54.192993,
            43.444971
          ],
          [
            12.148571,
            54.192879,
            43.49753
          ],
          [
            12.148884,
            54.192787,
            43.547514
          ],
          [
            12.149189,
            54.19268,
            43.59824
          ],
          [
            12.149552,
            54.192572,
            43.656501
          ],
          [
            12.149921,
            54.192471,
            43.650263
          ],
          [
            12.150296,
            54.192353,
            43.371047
          ],
          [
            12.150621,
            54.192267,
            43.138177
          ],
          [
            12.150886,
            54.19216,
            42.927634
          ],
          [
            12.151211,
            54.192049,
            42.681834
          ],
          [
            12.151541,
            54.191936,
            42.432221
          ],
          [
            12.151898,
            54.191835,
            42.172604
          ],
          [
            12.152257,
            54.191722,
            41.906387
          ],
          [
            12.152585,
            54.191615,
            41.710894
          ],
          [
            12.152916,
            54.191507,
            41.810419
          ],
          [
            12.153285,
            54.191384,
            41.922158
          ],
          [
            12.153616,
            54.19127,
            42.023216
          ],
          [
            12.153985,
            54.191177,
            42.129894
          ],
          [
            12.154359,
            54.191175,
            42.228207
          ],
          [
            12.154727,
            54.191177,
            42.324849
          ],
          [
            12.15505,
            54.19119,
            42.410453
          ],
          [
            12.155403,
            54.191173,
            42.503509
          ],
          [
            12.155485,
            54.190993,
            42.282538
          ],
          [
            12.155695,
            54.190815,
            42.03631
          ],
          [
            12.156032,
            54.190774,
            41.838251
          ],
          [
            12.156388,
            54.190725,
            41.627855
          ],
          [
            12.156759,
            54.190718,
            41.414118
          ],
          [
            12.157151,
            54.190744,
            41.186185
          ],
          [
            12.157567,
            54.190718,
            40.945582
          ],
          [
            12.157947,
            54.190695,
            40.777332
          ],
          [
            12.158299,
            54.190727,
            41.620864
          ],
          [
            12.158625,
            54.190781,
            42.421451
          ],
          [
            12.158972,
            54.190827,
            43.26127
          ],
          [
            12.159296,
            54.190862,
            44.039777
          ],
          [
            12.159625,
            54.190922,
            44.854064
          ],
          [
            12.15994,
            54.191009,
            45.688426
          ],
          [
            12.160241,
            54.191139,
            46.570965
          ],
          [
            12.160525,
            54.191243,
            47.365321
          ],
          [
            12.160876,
            54.191325,
            47.972646
          ],
          [
            12.161212,
            54.191386,
            47.934149
          ],
          [
            12.161573,
            54.191464,
            47.892138
          ],
          [
            12.161922,
            54.191578,
            47.848551
          ],
          [
            12.162323,
            54.191673,
            47.801353
          ],
          [
            12.162664,
            54.191761,
            47.760706
          ],
          [
            12.163028,
            54.191821,
            47.719419
          ],
          [
            12.163392,
            54.191944,
            47.673413
          ],
          [
            12.163691,
            54.192042,
            47.633388
          ],
          [
            12.164024,
            54.192149,
            47.584157
          ],
          [
            12.164346,
            54.192233,
            47.538545
          ],
          [
            12.164744,
            54.192301,
            47.48488
          ],
          [
            12.165033,
            54.192389,
            47.44269
          ],
          [
            12.165315,
            54.192484,
            47.400568
          ],
          [
            12.165675,
            54.192574,
            47.349768
          ],
          [
            12.16599,
            54.192655,
            47.305209
          ],
          [
            12.166295,
            54.192748,
            47.260686
          ],
          [
            12.166607,
            54.192868,
            46.557702
          ],
          [
            12.16702,
            54.192935,
            45.597243
          ],
          [
            12.167326,
            54.192996,
            44.872642
          ],
          [
            12.167686,
            54.193052,
            44.034794
          ],
          [
            12.168025,
            54.193067,
            43.272806
          ],
          [
            12.168426,
            54.193075,
            42.373479
          ],
          [
            12.168798,
            54.193046,
            41.532739
          ],
          [
            12.169085,
            54.192978,
            40.838669
          ],
          [
            12.16948,
            54.192927,
            40.608232
          ],
          [
            12.169891,
            54.192895,
            41.100031
          ],
          [
            12.170276,
            54.192801,
            41.594408
          ],
          [
            12.170678,
            54.192736,
            42.089173
          ],
          [
            12.171062,
            54.192728,
            42.544455
          ],
          [
            12.171421,
            54.192645,
            43.00438
          ],
          [
            12.171751,
            54.19256,
            43.431461
          ],
          [
            12.172127,
            54.19249,
            43.899299
          ],
          [
            12.172482,
            54.192426,
            44.191382
          ],
          [
            12.172873,
            54.192374,
            44.451699
          ],
          [
            12.173186,
            54.192318,
            44.664119
          ],
          [
            12.173548,
            54.192274,
            44.904096
          ],
          [
            12.173956,
            54.19222,
            45.175829
          ],
          [
            12.17437,
            54.192169,
            45.450373
          ],
          [
            12.174726,
            54.192131,
            45.685526
          ],
          [
            12.175085,
            54.192077,
            45.926078
          ],
          [
            12.175433,
            54.192054,
            45.858435
          ],
          [
            12.175835,
            54.191991,
            45.585679
          ],
          [
            12.176233,
            54.191919,
            45.313137
          ],
          [
            12.176669,
            54.191867,
            45.02219
          ],
          [
            12.17708,
            54.191775,
            44.734244
          ],
          [
            12.17747,
            54.191692,
            44.461848
          ],
          [
            12.177818,
            54.191647,
            44.228628
          ],
          [
            12.178215,
            54.191565,
            44.064924
          ],
          [
            12.178613,
            54.19147,
            44.501786
          ],
          [
            12.178984,
            54.191394,
            44.90133
          ],
          [
            12.17932,
            54.191328,
            45.262411
          ],
          [
            12.179631,
            54.191273,
            45.592935
          ],
          [
            12.180001,
            54.191237,
            45.976127
          ],
          [
            12.180344,
            54.191172,
            46.342741
          ],
          [
            12.180731,
            54.191136,
            46.741021
          ],
          [
            12.181079,
            54.191071,
            47.112465
          ],
          [
            12.181456,
            54.191035,
            47.618058
          ],
          [
            12.181773,
            54.191251,
            48.269907
          ],
          [
            12.182023,
            54.19136,
            48.683457
          ],
          [
            12.182324,
            54.191503,
            49.197642
          ],
          [
            12.182639,
            54.191636,
            49.713006
          ],
          [
            12.182929,
            54.19177,
            50.203588
          ],
          [
            12.183203,
            54.19191,
            50.686598
          ],
          [
            12.183489,
            54.19201,
            51.12843
          ],
          [
            12.183754,
            54.192101,
            51.404069
          ],
          [
            12.184037,
            54.192202,
            51.672237
          ],
          [
            12.184376,
            54.192261,
            51.960354
          ],
          [
            12.184758,
            54.19224,
            52.271473
          ],
          [
            12.18509,
            54.192275,
            52.550593
          ],
          [
            12.185244,
            54.192464,
            52.848018
          ],
          [
            12.185299,
            54.192672,
            53.142131
          ],
          [
            12.185304,
            54.192881,
            53.430995
          ],
          [
            12.1853,
            54.193086,
            53.721913
          ],
          [
            12.185249,
            54.19329,
            54.07579
          ],
          [
            12.185224,
            54.193505,
            54.444993
          ],
          [
            12.185229,
            54.193755,
            54.873406
          ],
          [
            12.185234,
            54.194002,
            55.297107
          ],
          [
            12.185238,
            54.194229,
            55.68603
          ],
          [
            12.185219,
            54.194435,
            56.039795
          ],
          [
            12.185221,
            54.194671,
            56.444512
          ],
          [
            12.185197,
            54.194902,
            56.762329
          ],
          [
            12.185174,
            54.195108,
            56.750887
          ],
          [
            12.18512,
            54.195322,
            56.738891
          ],
          [
            12.185106,
            54.195539,
            56.726857
          ],
          [
            12.185062,
            54.195755,
            56.714801
          ],
          [
            12.185063,
            54.195958,
            56.703551
          ],
          [
            12.185029,
            54.196163,
            56.692136
          ],
          [
            12.185003,
            54.196374,
            56.680329
          ],
          [
            12.184975,
            54.196622,
            56.666544
          ],
          [
            12.184952,
            54.196839,
            56.373748
          ],
          [
            12.184964,
            54.197036,
            56.074682
          ],
          [
            12.184925,
            54.197252,
            55.745274
          ],
          [
            12.184932,
            54.197491,
            55.382839
          ],
          [
            12.184925,
            54.197737,
            55.007892
          ],
          [
            12.184894,
            54.197948,
            54.686518
          ],
          [
            12.184904,
            54.198196,
            54.31043
          ],
          [
            12.184952,
            54.198404,
            53.992035
          ],
          [
            12.185044,
            54.198608,
            53.724622
          ],
          [
            12.185173,
            54.198816,
            53.456052
          ],
          [
            12.185319,
            54.198998,
            53.211985
          ],
          [
            12.185458,
            54.199213,
            52.932812
          ],
          [
            12.185591,
            54.199393,
            52.694795
          ],
          [
            12.185717,
            54.199593,
            52.4355
          ],
          [
            12.18584,
            54.199823,
            52.141584
          ],
          [
            12.185855,
            54.200055,
            51.859526
          ],
          [
            12.185763,
            54.20026,
            51.861917
          ],
          [
            12.18573,
            54.200474,
            52.043579
          ],
          [
            12.185694,
            54.200683,
            52.221625
          ],
          [
            12.185674,
            54.200873,
            52.382624
          ],
          [
            12.185655,
            54.201097,
            52.572271
          ],
          [
            12.185636,
            54.201305,
            52.748586
          ],
          [
            12.185637,
            54.201488,
            52.903531
          ],
          [
            12.185637,
            54.201707,
            53.088778
          ],
          [
            12.185625,
            54.201914,
            53.263896
          ],
          [
            12.185591,
            54.202109,
            53.775351
          ],
          [
            12.185474,
            54.20232,
            54.380761
          ],
          [
            12.185398,
            54.202556,
            55.036188
          ],
          [
            12.185353,
            54.202789,
            55.677198
          ],
          [
            12.185353,
            54.202995,
            56.239502
          ],
          [
            12.185423,
            54.203212,
            56.842233
          ],
          [
            12.185531,
            54.203422,
            57.44249
          ],
          [
            12.185695,
            54.203602,
            57.999312
          ],
          [
            12.185788,
            54.203799,
            58.182261
          ],
          [
            12.185925,
            54.203986,
            58.17868
          ],
          [
            12.186151,
            54.204197,
            58.174286
          ],
          [
            12.186287,
            54.204388,
            58.170639
          ],
          [
            12.186433,
            54.204571,
            58.167081
          ],
          [
            12.186601,
            54.204775,
            58.163095
          ],
          [
            12.186749,
            54.20494,
            58.159814
          ],
          [
            12.186893,
            54.205123,
            58.156267
          ],
          [
            12.187013,
            54.205342,
            58.010746
          ],
          [
            12.187166,
            54.205539,
            57.334187
          ],
          [
            12.187283,
            54.20574,
            56.671185
          ],
          [
            12.187371,
            54.205963,
            55.956785
          ],
          [
            12.187457,
            54.206182,
            55.253935
          ],
          [
            12.187522,
            54.206405,
            54.547677
          ],
          [
            12.187603,
            54.206617,
            53.868863
          ],
          [
            12.187634,
            54.206816,
            53.244717
          ],
          [
            12.187653,
            54.20702,
            52.606637
          ],
          [
            12.187724,
            54.207213,
            52.892269
          ],
          [
            12.187864,
            54.207434,
            53.363876
          ],
          [
            12.187985,
            54.207647,
            53.813303
          ],
          [
            12.188126,
            54.207829,
            54.212689
          ],
          [
            12.188247,
            54.208034,
            54.647564
          ],
          [
            12.18843,
            54.208213,
            55.064941
          ],
          [
            12.188598,
            54.208391,
            55.471262
          ],
          [
            12.188795,
            54.208585,
            55.922767
          ],
          [
            12.188922,
            54.208787,
            55.940139
          ],
          [
            12.189058,
            54.20897,
            55.5863
          ],
          [
            12.189241,
            54.209165,
            55.190683
          ],
          [
            12.189409,
            54.209379,
            54.772843
          ],
          [
            12.189574,
            54.209542,
            54.436558
          ],
          [
            12.189712,
            54.209718,
            54.091923
          ],
          [
            12.18987,
            54.209914,
            53.707608
          ],
          [
            12.18995,
            54.210099,
            53.368288
          ],
          [
            12.189929,
            54.210295,
            53.020034
          ],
          [
            12.189837,
            54.210483,
            53.448686
          ],
          [
            12.189839,
            54.210682,
            54.100444
          ],
          [
            12.189834,
            54.210887,
            54.772025
          ],
          [
            12.189886,
            54.2111,
            55.476501
          ],
          [
            12.18992,
            54.211319,
            56.196549
          ],
          [
            12.189974,
            54.211545,
            56.944945
          ],
          [
            12.190066,
            54.211764,
            57.685137
          ],
          [
            12.190213,
            54.211974,
            58.428123
          ],
          [
            12.190419,
            54.212161,
            58.78811
          ],
          [
            12.190612,
            54.212382,
            58.673406
          ],
          [
            12.190787,
            54.212564,
            58.576745
          ],
          [
            12.191012,
            54.212763,
            58.466548
          ],
          [
            12.191184,
            54.212962,
            58.363447
          ],
          [
            12.191356,
            54.213177,
            58.253687
          ],
          [
            12.191576,
            54.213353,
            58.152993
          ],
          [
            12.191768,
            54.213519,
            58.059743
          ],
          [
            12.191785,
            54.213716,
            57.940214
          ],
          [
            12.191789,
            54.213899,
            57.790196
          ],
          [
            12.191724,
            54.21414,
            57.590221
          ],
          [
            12.191647,
            54.214352,
            57.412507
          ],
          [
            12.191514,
            54.214537,
            57.246012
          ],
          [
            12.191346,
            54.214734,
            57.065485
          ],
          [
            12.191209,
            54.214919,
            56.900165
          ],
          [
            12.191234,
            54.215124,
            56.727139
          ],
          [
            12.19149,
            54.21527,
            56.554613
          ],
          [
            12.191855,
            54.215339,
            56.101478
          ],
          [
            12.19216,
            54.215392,
            55.682376
          ],
          [
            12.192535,
            54.215428,
            55.190014
          ],
          [
            12.192892,
            54.215461,
            54.72173
          ],
          [
            12.193269,
            54.215493,
            54.225633
          ],
          [
            12.193704,
            54.215482,
            53.660556
          ],
          [
            12.194035,
            54.2155,
            53.22913
          ],
          [
            12.194438,
            54.215477,
            52.704456
          ],
          [
            12.194821,
            54.215434,
            52.555949
          ],
          [
            12.195222,
            54.215411,
            52.574419
          ],
          [
            12.195618,
            54.215413,
            52.592588
          ],
          [
            12.195933,
            54.215442,
            52.607208
          ],
          [
            12.196296,
            54.215473,
            52.624024
          ],
          [
            12.196714,
            54.215492,
            52.643302
          ],
          [
            12.197063,
            54.215504,
            52.659381
          ],
          [
            12.197438,
            54.215564,
            52.677268
          ],
          [
            12.19777,
            54.21562,
            53.011464
          ],
          [
            12.198079,
            54.215686,
            53.601361
          ],
          [
            12.198419,
            54.215776,
            54.270522
          ],
          [
            12.198795,
            54.215891,
            55.031088
          ],
          [
            12.199114,
            54.215998,
            55.690414
          ],
          [
            12.199427,
            54.216099,
            56.331168
          ],
          [
            12.199736,
            54.216241,
            57.035633
          ],
          [
            12.200029,
            54.216396,
            57.743806
          ],
          [
            12.200267,
            54.216555,
            58.273935
          ],
          [
            12.200503,
            54.216698,
            58.511692
          ],
          [
            12.200823,
            54.216818,
            58.777583
          ],
          [
            12.201124,
            54.216954,
            59.043922
          ],
          [
            12.201404,
            54.217077,
            59.28941
          ],
          [
            12.201744,
            54.217201,
            59.56985
          ],
          [
            12.202149,
            54.217316,
            59.885352
          ],
          [
            12.202475,
            54.217418,
            60.144123
          ],
          [
            12.202775,
            54.2175,
            60.384274
          ],
          [
            12.203097,
            54.217574,
            60.701589
          ],
          [
            12.20337,
            54.217663,
            60.988234
          ],
          [
            12.203751,
            54.217754,
            61.36596
          ],
          [
            12.204063,
            54.217844,
            61.685271
          ],
          [
            12.20435,
            54.217954,
            62.001324
          ],
          [
            12.204617,
            54.218104,
            62.341307
          ],
          [
            12.204884,
            54.218266,
            62.694516
          ],
          [
            12.205107,
            54.218413,
            63.003009
          ],
          [
            12.205307,
            54.218575,
            62.833138
          ],
          [
            12.205017,
            54.218729,
            61.983558
          ],
          [
            12.204715,
            54.218841,
            61.231284
          ],
          [
            12.204398,
            54.21895,
            60.45722
          ],
          [
            12.204063,
            54.219039,
            59.681668
          ],
          [
            12.203762,
            54.219156,
            58.920378
          ],
          [
            12.203467,
            54.219279,
            58.157276
          ],
          [
            12.203126,
            54.219416,
            57.285088
          ],
          [
            12.202836,
            54.219563,
            56.558558
          ],
          [
            12.202523,
            54.219673,
            56.075153
          ],
          [
            12.20221,
            54.219783,
            55.595482
          ],
          [
            12.20192,
            54.219896,
            55.137506
          ],
          [
            12.20168,
            54.220061,
            54.647587
          ],
          [
            12.201563,
            54.220252,
            54.190838
          ],
          [
            12.201482,
            54.220482,
            53.664272
          ],
          [
            12.201421,
            54.220722,
            53.120134
          ],
          [
            12.201371,
            54.220964,
            52.701233
          ],
          [
            12.201309,
            54.221171,
            52.877433
          ],
          [
            12.201312,
            54.221389,
            53.060553
          ],
          [
            12.201271,
            54.221624,
            53.258843
          ],
          [
            12.201291,
            54.221836,
            53.436917
          ],
          [
            12.20132,
            54.222071,
            53.634637
          ],
          [
            12.201318,
            54.222316,
            53.840442
          ],
          [
            12.201354,
            54.222528,
            54.019072
          ],
          [
            12.201361,
            54.222732,
            54.171193
          ],
          [
            12.201358,
            54.222958,
            54.133284
          ],
          [
            12.201386,
            54.223139,
            54.102909
          ],
          [
            12.201437,
            54.223353,
            54.066796
          ],
          [
            12.201556,
            54.223576,
            54.027709
          ],
          [
            12.201631,
            54.22383,
            53.984627
          ],
          [
            12.201722,
            54.224061,
            53.944977
          ],
          [
            12.201779,
            54.224272,
            53.909241
          ],
          [
            12.201834,
            54.224498,
            53.829282
          ],
          [
            12.201851,
            54.224705,
            53.248402
          ],
          [
            12.201781,
            54.224881,
            52.738116
          ],
          [
            12.20161,
            54.225114,
            52.02725
          ],
          [
            12.201463,
            54.225313,
            51.418164
          ],
          [
            12.201337,
            54.225513,
            50.820373
          ],
          [
            12.201188,
            54.225712,
            50.211991
          ],
          [
            12.200979,
            54.225921,
            49.530271
          ],
          [
            12.200808,
            54.226151,
            48.851644
          ],
          [
            12.200664,
            54.226352,
            49.914313
          ],
          [
            12.200544,
            54.226556,
            50.967183
          ],
          [
            12.200434,
            54.226797,
            52.183979
          ],
          [
            12.200396,
            54.227034,
            53.345156
          ],
          [
            12.200337,
            54.227231,
            54.320486
          ],
          [
            12.200303,
            54.227454,
            55.416686
          ],
          [
            12.200261,
            54.227693,
            56.590614
          ],
          [
            12.20021,
            54.227885,
            57.538608
          ],
          [
            12.200157,
            54.228122,
            57.388799
          ],
          [
            12.200116,
            54.228377,
            57.139468
          ],
          [
            12.200185,
            54.228579,
            56.934814
          ],
          [
            12.200281,
            54.228789,
            56.723461
          ],
          [
            12.20041,
            54.229014,
            56.491592
          ],
          [
            12.200567,
            54.229221,
            56.271339
          ],
          [
            12.20067,
            54.229447,
            56.043833
          ],
          [
            12.200787,
            54.229649,
            55.800632
          ],
          [
            12.200857,
            54.229826,
            55.342346
          ],
          [
            12.200934,
            54.230033,
            54.807954
          ],
          [
            12.201053,
            54.230234,
            54.270196
          ],
          [
            12.201175,
            54.230451,
            53.693169
          ],
          [
            12.201266,
            54.230679,
            53.102417
          ],
          [
            12.201377,
            54.230906,
            52.506093
          ],
          [
            12.201474,
            54.231098,
            52.000027
          ],
          [
            12.201663,
            54.231316,
            51.379708
          ],
          [
            12.201763,
            54.231496,
            51.412415
          ],
          [
            12.201856,
            54.231681,
            51.516872
          ],
          [
            12.201935,
            54.23191,
            51.643435
          ],
          [
            12.202013,
            54.232096,
            51.748223
          ],
          [
            12.202096,
            54.232272,
            51.847129
          ],
          [
            12.202198,
            54.2325,
            51.975031
          ],
          [
            12.202288,
            54.232738,
            52.107084
          ],
          [
            12.202396,
            54.232971,
            52.237974
          ],
          [
            12.202461,
            54.233206,
            51.981735
          ],
          [
            12.202603,
            54.233497,
            51.248055
          ],
          [
            12.202739,
            54.233671,
            50.784932
          ],
          [
            12.202867,
            54.233896,
            50.205683
          ],
          [
            12.202968,
            54.234087,
            49.722737
          ],
          [
            12.203136,
            54.234267,
            49.219773
          ],
          [
            12.203376,
            54.234418,
            48.720893
          ],
          [
            12.20366,
            54.234567,
            48.182557
          ],
          [
            12.203935,
            54.234695,
            47.725692
          ],
          [
            12.20423,
            54.234846,
            47.253218
          ],
          [
            12.204515,
            54.235004,
            46.779984
          ],
          [
            12.204799,
            54.235153,
            46.320192
          ],
          [
            12.205063,
            54.235292,
            45.892128
          ],
          [
            12.20533,
            54.235437,
            45.453049
          ],
          [
            12.205633,
            54.235595,
            44.963796
          ],
          [
            12.205944,
            54.235759,
            44.459085
          ],
          [
            12.206245,
            54.235903,
            44.473797
          ],
          [
            12.206534,
            54.23605,
            44.876906
          ],
          [
            12.206775,
            54.236253,
            45.322674
          ],
          [
            12.206974,
            54.236429,
            45.702475
          ],
          [
            12.207144,
            54.236599,
            46.057614
          ],
          [
            12.207297,
            54.236781,
            46.422715
          ],
          [
            12.207488,
            54.236996,
            46.859919
          ],
          [
            12.20769,
            54.237194,
            47.274909
          ],
          [
            12.207878,
            54.237374,
            47.431249
          ],
          [
            12.208071,
            54.237598,
            47.283639
          ],
          [
            12.20828,
            54.237794,
            47.147686
          ],
          [
            12.208453,
            54.237977,
            47.024641
          ],
          [
            12.208643,
            54.238159,
            46.899116
          ],
          [
            12.208824,
            54.238329,
            46.781278
          ],
          [
            12.209053,
            54.23851,
            46.648799
          ],
          [
            12.209284,
            54.238656,
            46.531217
          ],
          [
            12.209619,
            54.238735,
            46.505586
          ],
          [
            12.209938,
            54.238818,
            46.947106
          ],
          [
            12.210263,
            54.238928,
            47.420805
          ],
          [
            12.210612,
            54.239038,
            47.920918
          ],
          [
            12.210962,
            54.239153,
            48.427666
          ],
          [
            12.21129,
            54.239284,
            48.931375
          ],
          [
            12.211617,
            54.23939,
            49.406352
          ],
          [
            12.212009,
            54.239488,
            49.944075
          ],
          [
            12.212397,
            54.239609,
            50.28202
          ],
          [
            12.212795,
            54.239721,
            50.202913
          ],
          [
            12.213172,
            54.239832,
            50.127313
          ],
          [
            12.21356,
            54.239954,
            50.048414
          ],
          [
            12.213919,
            54.240063,
            49.975976
          ],
          [
            12.214296,
            54.240169,
            49.901074
          ],
          [
            12.214661,
            54.240289,
            49.826083
          ],
          [
            12.215043,
            54.240399,
            49.784896
          ],
          [
            12.215373,
            54.240553,
            50.035505
          ],
          [
            12.215613,
            54.24069,
            50.23161
          ],
          [
            12.215897,
            54.24081,
            50.434846
          ],
          [
            12.216167,
            54.240946,
            50.644091
          ],
          [
            12.216379,
            54.241142,
            50.874104
          ],
          [
            12.216593,
            54.241305,
            51.078126
          ],
          [
            12.216793,
            54.241478,
            51.285116
          ],
          [
            12.216996,
            54.241655,
            51.496327
          ],
          [
            12.217215,
            54.24184,
            51.210677
          ],
          [
            12.21739,
            54.242002,
            50.859865
          ],
          [
            12.217561,
            54.242196,
            50.460264
          ],
          [
            12.217726,
            54.24235,
            50.119251
          ],
          [
            12.217926,
            54.242548,
            49.697895
          ],
          [
            12.218105,
            54.242712,
            49.341312
          ],
          [
            12.217853,
            54.242853,
            48.959291
          ],
          [
            12.217498,
            54.242884,
            48.574125
          ],
          [
            12.217208,
            54.242965,
            48.244499
          ],
          [
            12.217116,
            54.243163,
            48.209121
          ],
          [
            12.217062,
            54.24337,
            48.173042
          ],
          [
            12.217005,
            54.243609,
            48.131452
          ],
          [
            12.21695,
            54.243836,
            48.091958
          ],
          [
            12.216944,
            54.244045,
            48.055913
          ],
          [
            12.216889,
            54.244264,
            48.017723
          ],
          [
            12.216855,
            54.244497,
            47.977374
          ],
          [
            12.216797,
            54.244699,
            47.941899
          ],
          [
            12.216791,
            54.244912,
            48.864388
          ],
          [
            12.21687,
            54.245125,
            49.925078
          ],
          [
            12.217011,
            54.245321,
            50.965233
          ],
          [
            12.217242,
            54.245465,
            51.925149
          ],
          [
            12.21747,
            54.245645,
            53.018092
          ],
          [
            12.217711,
            54.245815,
            54.099776
          ],
          [
            12.217996,
            54.245968,
            55.199207
          ],
          [
            12.218244,
            54.246143,
            56.303814
          ],
          [
            12.218488,
            54.246319,
            56.355958
          ],
          [
            12.218702,
            54.246511,
            55.852736
          ],
          [
            12.218923,
            54.246697,
            55.354315
          ],
          [
            12.219119,
            54.246903,
            54.835528
          ],
          [
            12.219341,
            54.247094,
            54.328235
          ],
          [
            12.219548,
            54.247265,
            53.868431
          ],
          [
            12.219755,
            54.247454,
            53.372927
          ],
          [
            12.220003,
            54.247644,
            52.843712
          ],
          [
            12.220278,
            54.247828,
            52.708953
          ],
          [
            12.220472,
            54.248046,
            52.677439
          ],
          [
            12.220725,
            54.24822,
            52.648026
          ],
          [
            12.220961,
            54.248393,
            52.619699
          ],
          [
            12.221178,
            54.248573,
            52.591501
          ],
          [
            12.221399,
            54.248767,
            52.56166
          ],
          [
            12.221584,
            54.248918,
            52.537879
          ],
          [
            12.221748,
            54.249116,
            52.509709
          ],
          [
            12.221967,
            54.249298,
            51.457251
          ],
          [
            12.222148,
            54.24945,
            50.348538
          ],
          [
            12.222436,
            54.249473,
            49.228353
          ],
          [
            12.222723,
            54.249363,
            48.027376
          ],
          [
            12.223092,
            54.249422,
            46.68409
          ],
          [
            12.2234,
            54.249493,
            45.524589
          ],
          [
            12.223724,
            54.24957,
            44.30248
          ],
          [
            12.224104,
            54.249586,
            42.964891
          ],
          [
            12.224505,
            54.249595,
            41.825784
          ],
          [
            12.224842,
            54.249609,
            42.272535
          ],
          [
            12.225154,
            54.249635,
            42.688755
          ],
          [
            12.225486,
            54.249734,
            43.183993
          ],
          [
            12.225814,
            54.249804,
            43.651696
          ],
          [
            12.22611,
            54.249867,
            44.082748
          ],
          [
            12.226259,
            54.250049,
            44.550122
          ],
          [
            12.226488,
            54.250193,
            44.995176
          ],
          [
            12.226717,
            54.250337,
            45.438933
          ],
          [
            12.22688,
            54.250502,
            45.849902
          ],
          [
            12.226872,
            54.250688,
            46.115724
          ],
          [
            12.22679,
            54.25089,
            46.412344
          ],
          [
            12.226683,
            54.251068,
            46.682024
          ],
          [
            12.226566,
            54.251245,
            46.954468
          ],
          [
            12.226486,
            54.251479,
            47.295381
          ],
          [
            12.226441,
            54.251671,
            47.57355
          ],
          [
            12.226399,
            54.25187,
            47.860038
          ],
          [
            12.226363,
            54.252112,
            48.207315
          ],
          [
            12.226287,
            54.252332,
            48.412686
          ],
          [
            12.226207,
            54.252558,
            48.488172
          ],
          [
            12.226237,
            54.252754,
            48.553391
          ],
          [
            12.226404,
            54.25294,
            48.621956
          ],
          [
            12.226498,
            54.253118,
            48.683414
          ],
          [
            12.226529,
            54.253322,
            48.751063
          ],
          [
            12.226593,
            54.253529,
            48.819867
          ],
          [
            12.226652,
            54.253719,
            48.883068
          ],
          [
            12.226645,
            54.253916,
            48.947787
          ],
          [
            12.226673,
            54.254132,
            48.543671
          ],
          [
            12.226629,
            54.254332,
            48.028555
          ],
          [
            12.226607,
            54.254523,
            47.539278
          ],
          [
            12.226608,
            54.254477,
            47.075528
          ],
          [
            12.226924,
            54.254397,
            46.520982
          ],
          [
            12.227247,
            54.254462,
            46.010653
          ],
          [
            12.227246,
            54.254506,
            45.499688
          ],
          [
            12.227279,
            54.254505,
            44.972984
          ],
          [
            12.227572,
            54.254566,
            44.509028
          ],
          [
            12.227921,
            54.254626,
            44.092338
          ],
          [
            12.228284,
            54.2547,
            43.698196
          ],
          [
            12.228661,
            54.25477,
            43.294358
          ],
          [
            12.228996,
            54.254822,
            42.939142
          ],
          [
            12.22935,
            54.25486,
            42.56971
          ],
          [
            12.229703,
            54.254916,
            42.192855
          ],
          [
            12.229804,
            54.25513,
            41.804943
          ],
          [
            12.230016,
            54.255295,
            41.440572
          ],
          [
            12.230268,
            54.255428,
            41.168335
          ],
          [
            12.230569,
            54.255529,
            41.003422
          ],
          [
            12.230881,
            54.255607,
            40.841509
          ],
          [
            12.231241,
            54.255737,
            40.640383
          ],
          [
            12.231587,
            54.255828,
            40.459808
          ],
          [
            12.231969,
            54.255889,
            40.270792
          ],
          [
            12.232311,
            54.255985,
            40.090616
          ],
          [
            12.23265,
            54.256057,
            39.919293
          ],
          [
            12.233013,
            54.256133,
            39.8274
          ],
          [
            12.233358,
            54.256076,
            40.110175
          ],
          [
            12.233681,
            54.255996,
            40.386739
          ],
          [
            12.23404,
            54.256035,
            40.66556
          ],
          [
            12.233723,
            54.255945,
            40.945557
          ],
          [
            12.233432,
            54.256063,
            41.222288
          ],
          [
            12.233133,
            54.256122,
            41.467384
          ],
          [
            12.232701,
            54.255986,
            41.842537
          ],
          [
            12.232354,
            54.255932,
            42.121512
          ],
          [
            12.231981,
            54.255866,
            42.213859
          ],
          [
            12.231648,
            54.255764,
            42.3024
          ],
          [
            12.231363,
            54.255676,
            42.378243
          ],
          [
            12.231086,
            54.255564,
            42.457491
          ],
          [
            12.230659,
            54.255453,
            42.570074
          ],
          [
            12.230356,
            54.255361,
            42.650413
          ],
          [
            12.230037,
            54.255224,
            42.744677
          ],
          [
            12.229777,
            54.255063,
            42.83381
          ],
          [
            12.22952,
            54.254941,
            42.900666
          ],
          [
            12.229189,
            54.254899,
            42.969801
          ],
          [
            12.228863,
            54.254763,
            43.048541
          ],
          [
            12.228563,
            54.254671,
            43.115256
          ],
          [
            12.228157,
            54.254626,
            43.19713
          ],
          [
            12.227783,
            54.254565,
            43.273675
          ],
          [
            12.227447,
            54.254515,
            43.341894
          ],
          [
            12.227147,
            54.254385,
            43.415591
          ],
          [
            12.226808,
            54.254355,
            43.302046
          ],
          [
            12.226783,
            54.254366,
            43.065786
          ],
          [
            12.227075,
            54.254438,
            42.847042
          ],
          [
            12.2274,
            54.254534,
            42.595337
          ],
          [
            12.227768,
            54.254571,
            42.339039
          ],
          [
            12.228161,
            54.254624,
            42.062269
          ],
          [
            12.228559,
            54.254717,
            41.76886
          ],
          [
            12.228904,
            54.25482,
            41.503517
          ],
          [
            12.229235,
            54.254858,
            41.437425
          ],
          [
            12.229536,
            54.254948,
            41.736973
          ],
          [
            12.229819,
            54.2551,
            42.076169
          ],
          [
            12.230053,
            54.255277,
            42.413788
          ],
          [
            12.230313,
            54.255405,
            42.717667
          ],
          [
            12.230607,
            54.255538,
            43.045642
          ],
          [
            12.230882,
            54.255647,
            43.338828
          ],
          [
            12.231192,
            54.25573,
            43.640042
          ],
          [
            12.231502,
            54.255808,
            43.938209
          ],
          [
            12.231824,
            54.255909,
            44.131081
          ],
          [
            12.232122,
            54.255978,
            44.233174
          ],
          [
            12.232428,
            54.256028,
            44.335296
          ],
          [
            12.232887,
            54.256088,
            44.485089
          ],
          [
            12.233214,
            54.256164,
            44.597434
          ],
          [
            12.233498,
            54.256033,
            44.711727
          ],
          [
            12.233887,
            54.256,
            44.838173
          ],
          [
            12.23424,
            54.256024,
            44.952923
          ],
          [
            12.234565,
            54.256087,
            45.098083
          ],
          [
            12.234889,
            54.256165,
            45.339562
          ],
          [
            12.235229,
            54.2562,
            45.583389
          ],
          [
            12.235583,
            54.256258,
            45.840355
          ],
          [
            12.235836,
            54.256375,
            46.062283
          ],
          [
            12.236052,
            54.256513,
            46.282364
          ],
          [
            12.236205,
            54.256677,
            46.502164
          ],
          [
            12.236327,
            54.25685,
            46.723679
          ],
          [
            12.236474,
            54.257027,
            46.956133
          ],
          [
            12.236769,
            54.257113,
            47.142655
          ],
          [
            12.237069,
            54.257227,
            47.107464
          ],
          [
            12.237406,
            54.25733,
            47.069628
          ],
          [
            12.237775,
            54.25733,
            47.033263
          ],
          [
            12.238043,
            54.257482,
            46.996383
          ],
          [
            12.2384,
            54.257624,
            46.953821
          ],
          [
            12.238741,
            54.257695,
            46.918268
          ],
          [
            12.239129,
            54.257779,
            46.87746
          ],
          [
            12.239538,
            54.257708,
            46.742464
          ],
          [
            12.239975,
            54.257765,
            46.309505
          ],
          [
            12.240291,
            54.257845,
            45.976718
          ],
          [
            12.240682,
            54.257965,
            45.548767
          ],
          [
            12.24106,
            54.257995,
            45.180432
          ],
          [
            12.241434,
            54.258087,
            44.7878
          ],
          [
            12.241773,
            54.258156,
            44.437755
          ],
          [
            12.242142,
            54.25828,
            44.026924
          ],
          [
            12.24247,
            54.258254,
            43.928362
          ],
          [
            12.242502,
            54.25844,
            44.017937
          ],
          [
            12.24226,
            54.258586,
            44.116115
          ],
          [
            12.242109,
            54.258758,
            44.208358
          ],
          [
            12.242064,
            54.258942,
            44.298123
          ],
          [
            12.242277,
            54.259101,
            44.401855
          ],
          [
            12.242595,
            54.259184,
            44.498877
          ],
          [
            12.242919,
            54.259271,
            44.598283
          ],
          [
            12.243193,
            54.259372,
            44.688672
          ],
          [
            12.243472,
            54.259463,
            44.652145
          ],
          [
            12.243762,
            54.259551,
            44.496443
          ],
          [
            12.24404,
            54.259636,
            44.346886
          ],
          [
            12.244311,
            54.259722,
            44.19986
          ],
          [
            12.24462,
            54.259803,
            44.037844
          ],
          [
            12.244965,
            54.259856,
            43.867838
          ],
          [
            12.245295,
            54.259951,
            43.692542
          ],
          [
            12.245631,
            54.26005,
            43.513158
          ],
          [
            12.245922,
            54.260135,
            43.358139
          ],
          [
            12.246248,
            54.260242,
            43.219594
          ],
          [
            12.246541,
            54.260338,
            43.134765
          ],
          [
            12.246839,
            54.260441,
            43.047212
          ],
          [
            12.247139,
            54.260538,
            42.960446
          ],
          [
            12.247471,
            54.260637,
            42.866325
          ],
          [
            12.247806,
            54.260758,
            42.766798
          ],
          [
            12.248106,
            54.260877,
            42.675219
          ],
          [
            12.248387,
            54.26098,
            42.591287
          ],
          [
            12.248682,
            54.261086,
            42.503834
          ],
          [
            12.248986,
            54.261202,
            42.495612
          ],
          [
            12.249295,
            54.261329,
            42.506869
          ],
          [
            12.249581,
            54.261463,
            42.517793
          ],
          [
            12.24989,
            54.261575,
            42.528639
          ],
          [
            12.250192,
            54.26169,
            42.53938
          ],
          [
            12.250492,
            54.261811,
            42.550242
          ],
          [
            12.250815,
            54.261926,
            42.561517
          ],
          [
            12.251126,
            54.262035,
            42.572328
          ],
          [
            12.251416,
            54.262141,
            42.596863
          ],
          [
            12.251734,
            54.26223,
            42.645327
          ],
          [
            12.252074,
            54.26237,
            42.702497
          ],
          [
            12.252414,
            54.262506,
            42.759132
          ],
          [
            12.252746,
            54.262637,
            42.814189
          ],
          [
            12.253103,
            54.262747,
            42.869655
          ],
          [
            12.253433,
            54.262869,
            42.923321
          ],
          [
            12.253793,
            54.262998,
            42.981372
          ],
          [
            12.25414,
            54.263149,
            43.14861
          ],
          [
            12.254476,
            54.263273,
            43.353518
          ],
          [
            12.254807,
            54.263379,
            43.548149
          ],
          [
            12.255164,
            54.263499,
            43.760555
          ],
          [
            12.255571,
            54.263631,
            44.000891
          ],
          [
            12.255841,
            54.263727,
            44.163942
          ],
          [
            12.256181,
            54.263834,
            44.363068
          ],
          [
            12.256451,
            54.263936,
            44.528851
          ],
          [
            12.256732,
            54.264045,
            44.544502
          ],
          [
            12.257081,
            54.264158,
            44.463367
          ],
          [
            12.257409,
            54.264279,
            44.384541
          ],
          [
            12.257733,
            54.264402,
            44.306032
          ],
          [
            12.258091,
            54.264524,
            44.221828
          ],
          [
            12.258424,
            54.264652,
            44.140596
          ],
          [
            12.258771,
            54.264788,
            44.055701
          ],
          [
            12.259122,
            54.264923,
            43.970322
          ],
          [
            12.259399,
            54.265021,
            44.015922
          ],
          [
            12.259715,
            54.26515,
            44.085117
          ],
          [
            12.260002,
            54.265247,
            44.144625
          ],
          [
            12.260327,
            54.26537,
            44.214289
          ],
          [
            12.26062,
            54.265475,
            44.275983
          ],
          [
            12.260922,
            54.26561,
            44.344252
          ],
          [
            12.261184,
            54.265727,
            44.40345
          ],
          [
            12.261494,
            54.265847,
            44.470196
          ],
          [
            12.261795,
            54.265967,
            44.46685
          ],
          [
            12.262107,
            54.266094,
            44.291671
          ],
          [
            12.262474,
            54.266235,
            44.089253
          ],
          [
            12.262819,
            54.266388,
            43.889694
          ],
          [
            12.263153,
            54.266528,
            43.700304
          ],
          [
            12.263478,
            54.266642,
            43.525615
          ],
          [
            12.263771,
            54.266773,
            43.355655
          ],
          [
            12.264084,
            54.266898,
            43.180979
          ],
          [
            12.264378,
            54.266992,
            43.113593
          ],
          [
            12.264675,
            54.267105,
            43.149568
          ],
          [
            12.264999,
            54.267204,
            43.186676
          ],
          [
            12.265331,
            54.267326,
            43.22646
          ],
          [
            12.2656,
            54.267443,
            43.26099
          ],
          [
            12.265845,
            54.26732,
            43.29386
          ],
          [
            12.266094,
            54.267463,
            43.329446
          ],
          [
            12.266408,
            54.267556,
            43.365377
          ],
          [
            12.266748,
            54.267671,
            43.405353
          ],
          [
            12.267062,
            54.267788,
            43.357209
          ],
          [
            12.267408,
            54.267911,
            43.291093
          ],
          [
            12.267787,
            54.268037,
            43.219855
          ],
          [
            12.268121,
            54.268162,
            43.155098
          ],
          [
            12.268456,
            54.268293,
            43.089265
          ],
          [
            12.268764,
            54.268419,
            43.027874
          ],
          [
            12.269131,
            54.268549,
            42.95781
          ],
          [
            12.269442,
            54.268659,
            42.980999
          ],
          [
            12.269775,
            54.268729,
            43.447428
          ],
          [
            12.270176,
            54.268801,
            44.002308
          ],
          [
            12.270532,
            54.268899,
            44.521036
          ],
          [
            12.270944,
            54.268965,
            45.083176
          ],
          [
            12.271254,
            54.269057,
            45.554093
          ],
          [
            12.271607,
            54.269147,
            46.063267
          ],
          [
            12.271952,
            54.26918,
            46.526905
          ],
          [
            12.272322,
            54.269234,
            46.987578
          ],
          [
            12.272601,
            54.269322,
            47.155373
          ],
          [
            12.272931,
            54.269426,
            47.353499
          ],
          [
            12.27327,
            54.269554,
            47.566684
          ],
          [
            12.273547,
            54.269737,
            47.788603
          ],
          [
            12.273772,
            54.269925,
            47.995975
          ],
          [
            12.274004,
            54.270074,
            48.178455
          ],
          [
            12.274246,
            54.270196,
            48.350174
          ],
          [
            12.274597,
            54.270325,
            48.569133
          ],
          [
            12.274898,
            54.270399,
            48.453512
          ],
          [
            12.275188,
            54.270484,
            48.309869
          ],
          [
            12.275496,
            54.270604,
            48.14576
          ],
          [
            12.275792,
            54.27069,
            47.999424
          ],
          [
            12.276162,
            54.270822,
            47.807346
          ],
          [
            12.276501,
            54.270927,
            47.629308
          ],
          [
            12.276892,
            54.271043,
            47.435148
          ],
          [
            12.277267,
            54.271154,
            47.248999
          ],
          [
            12.277621,
            54.271253,
            47.21676
          ],
          [
            12.277974,
            54.271356,
            47.210132
          ],
          [
            12.278362,
            54.271489,
            47.202574
          ],
          [
            12.27869,
            54.271638,
            47.195572
          ],
          [
            12.279023,
            54.27181,
            47.188097
          ],
          [
            12.279334,
            54.271929,
            47.181852
          ],
          [
            12.279622,
            54.272051,
            47.17587
          ],
          [
            12.280006,
            54.272176,
            47.178325
          ],
          [
            12.280336,
            54.272264,
            47.200409
          ],
          [
            12.280646,
            54.272352,
            47.221416
          ],
          [
            12.280954,
            54.272489,
            47.24503
          ],
          [
            12.2813,
            54.272601,
            47.269205
          ],
          [
            12.281578,
            54.272694,
            47.288709
          ],
          [
            12.281905,
            54.272817,
            47.312488
          ],
          [
            12.282211,
            54.272944,
            47.335417
          ],
          [
            12.282548,
            54.27307,
            47.368754
          ],
          [
            12.282788,
            54.273243,
            47.517534
          ],
          [
            12.283104,
            54.273322,
            47.651467
          ],
          [
            12.283436,
            54.273465,
            47.812204
          ],
          [
            12.283784,
            54.273581,
            47.9683
          ],
          [
            12.284132,
            54.273697,
            48.124517
          ],
          [
            12.284475,
            54.273805,
            48.276472
          ],
          [
            12.284789,
            54.273882,
            48.409528
          ],
          [
            12.285174,
            54.274009,
            48.512137
          ],
          [
            12.285509,
            54.274107,
            48.232641
          ],
          [
            12.285866,
            54.274225,
            47.92746
          ],
          [
            12.286202,
            54.274343,
            47.635785
          ],
          [
            12.286568,
            54.27441,
            47.350441
          ],
          [
            12.286939,
            54.274517,
            47.042156
          ],
          [
            12.287247,
            54.274641,
            46.763207
          ],
          [
            12.287633,
            54.274769,
            46.432391
          ],
          [
            12.287971,
            54.274908,
            46.280101
          ],
          [
            12.288261,
            54.27502,
            46.303569
          ],
          [
            12.288592,
            54.27513,
            46.329252
          ],
          [
            12.288899,
            54.275235,
            46.353232
          ],
          [
            12.289207,
            54.275334,
            46.376938
          ],
          [
            12.289566,
            54.275395,
            46.402217
          ],
          [
            12.289833,
            54.275487,
            46.423144
          ],
          [
            12.290169,
            54.275574,
            46.447915
          ],
          [
            12.290501,
            54.275696,
            46.474353
          ],
          [
            12.290785,
            54.275829,
            45.462378
          ],
          [
            12.291109,
            54.275931,
            44.416565
          ],
          [
            12.291405,
            54.276035,
            43.437371
          ],
          [
            12.291725,
            54.276148,
            42.377378
          ],
          [
            12.292126,
            54.276241,
            41.154381
          ],
          [
            12.292517,
            54.276329,
            39.966862
          ],
          [
            12.292896,
            54.276414,
            38.814541
          ],
          [
            12.293212,
            54.276495,
            37.836086
          ],
          [
            12.293516,
            54.276593,
            37.802428
          ],
          [
            12.293791,
            54.276689,
            37.860842
          ],
          [
            12.294058,
            54.276821,
            37.924571
          ],
          [
            12.294375,
            54.276941,
            37.993436
          ],
          [
            12.294688,
            54.277061,
            38.061645
          ],
          [
            12.295028,
            54.277177,
            38.133442
          ],
          [
            12.295351,
            54.277295,
            38.202884
          ],
          [
            12.295626,
            54.27741,
            38.26456
          ],
          [
            12.296009,
            54.27754,
            38.484092
          ],
          [
            12.296365,
            54.277645,
            38.813144
          ],
          [
            12.296665,
            54.277728,
            39.087548
          ],
          [
            12.296978,
            54.277815,
            39.373397
          ],
          [
            12.297323,
            54.277938,
            39.706312
          ],
          [
            12.297679,
            54.278039,
            40.03208
          ],
          [
            12.298006,
            54.278153,
            40.346084
          ],
          [
            12.298354,
            54.278253,
            40.665975
          ],
          [
            12.298638,
            54.278335,
            40.99286
          ],
          [
            12.299,
            54.278421,
            41.560324
          ],
          [
            12.299371,
            54.27853,
            42.164672
          ],
          [
            12.299743,
            54.278619,
            42.74828
          ],
          [
            12.300091,
            54.278717,
            43.309426
          ],
          [
            12.300535,
            54.278779,
            43.975693
          ],
          [
            12.300916,
            54.278891,
            44.597532
          ],
          [
            12.301263,
            54.278986,
            45.15409
          ],
          [
            12.30166,
            54.279042,
            45.362626
          ],
          [
            12.302046,
            54.27913,
            45.430666
          ],
          [
            12.302438,
            54.279231,
            45.501166
          ],
          [
            12.302812,
            54.279321,
            45.567576
          ],
          [
            12.303204,
            54.279402,
            45.635832
          ],
          [
            12.303529,
            54.279455,
            45.691225
          ],
          [
            12.30382,
            54.27958,
            45.750799
          ],
          [
            12.304054,
            54.279717,
            45.805479
          ],
          [
            12.30432,
            54.279841,
            45.476814
          ],
          [
            12.304648,
            54.279961,
            44.962878
          ],
          [
            12.304962,
            54.280081,
            44.464588
          ],
          [
            12.305337,
            54.280167,
            43.927721
          ],
          [
            12.305679,
            54.280297,
            43.385008
          ],
          [
            12.305951,
            54.280403,
            42.950254
          ],
          [
            12.306278,
            54.280496,
            42.467351
          ],
          [
            12.306637,
            54.280596,
            41.938458
          ],
          [
            12.306981,
            54.280727,
            41.771494
          ],
          [
            12.307287,
            54.280862,
            41.835214
          ],
          [
            12.307598,
            54.280958,
            41.893818
          ],
          [
            12.307973,
            54.281047,
            41.961072
          ],
          [
            12.308383,
            54.281104,
            42.031077
          ],
          [
            12.308825,
            54.281158,
            42.106103
          ],
          [
            12.309191,
            54.281252,
            42.173063
          ],
          [
            12.309544,
            54.281341,
            42.237023
          ],
          [
            12.309952,
            54.28143,
            42.803418
          ],
          [
            12.310295,
            54.281515,
            43.311432
          ],
          [
            12.310639,
            54.281608,
            43.829517
          ],
          [
            12.311077,
            54.281726,
            44.487539
          ],
          [
            12.311385,
            54.281812,
            44.956738
          ],
          [
            12.311726,
            54.28189,
            45.456979
          ],
          [
            12.312105,
            54.281915,
            45.976812
          ],
          [
            12.312468,
            54.281938,
            46.451414
          ],
          [
            12.312773,
            54.282009,
            46.600529
          ],
          [
            12.312977,
            54.282158,
            46.745194
          ],
          [
            12.313059,
            54.282341,
            46.887554
          ],
          [
            12.313224,
            54.282489,
            47.033347
          ],
          [
            12.313576,
            54.282446,
            47.194118
          ],
          [
            12.313576,
            54.282484,
            47.34019
          ],
          [
            12.313667,
            54.282628,
            47.491596
          ],
          [
            12.313996,
            54.282684,
            47.642138
          ],
          [
            12.314354,
            54.282748,
            47.755889
          ],
          [
            12.314663,
            54.282853,
            47.34004
          ],
          [
            12.314691,
            54.283023,
            46.958206
          ],
          [
            12.314683,
            54.283195,
            46.535735
          ],
          [
            12.314845,
            54.283376,
            46.12154
          ],
          [
            12.314723,
            54.283572,
            45.706023
          ],
          [
            12.314906,
            54.283745,
            45.294897
          ],
          [
            12.315206,
            54.283899,
            44.830141
          ],
          [
            12.315508,
            54.284059,
            44.355743
          ],
          [
            12.315797,
            54.284244,
            43.997853
          ],
          [
            12.316092,
            54.284386,
            43.73119
          ],
          [
            12.316324,
            54.284507,
            43.514225
          ],
          [
            12.316586,
            54.284671,
            43.246352
          ],
          [
            12.316851,
            54.284846,
            42.965996
          ],
          [
            12.317122,
            54.285033,
            42.673123
          ],
          [
            12.317419,
            54.285148,
            42.424192
          ],
          [
            12.317775,
            54.285271,
            42.135605
          ],
          [
            12.318087,
            54.285348,
            42.591088
          ],
          [
            12.318449,
            54.285399,
            43.445456
          ],
          [
            12.31884,
            54.28543,
            44.355837
          ],
          [
            12.319177,
            54.285445,
            45.129977
          ],
          [
            12.319499,
            54.28543,
            45.876849
          ],
          [
            12.319744,
            54.285311,
            46.604611
          ],
          [
            12.320058,
            54.28523,
            47.398734
          ],
          [
            12.320435,
            54.285144,
            48.32537
          ],
          [
            12.320834,
            54.285122,
            48.993998
          ],
          [
            12.321153,
            54.285044,
            48.436191
          ],
          [
            12.321544,
            54.285074,
            47.789294
          ],
          [
            12.321902,
            54.285164,
            47.159031
          ],
          [
            12.322229,
            54.285211,
            46.615281
          ],
          [
            12.322586,
            54.285187,
            46.034859
          ],
          [
            12.323004,
            54.285208,
            45.349797
          ],
          [
            12.323406,
            54.285223,
            44.700378
          ],
          [
            12.323766,
            54.28532,
            44.092731
          ],
          [
            12.324074,
            54.285465,
            43.848093
          ],
          [
            12.324475,
            54.285665,
            43.52117
          ],
          [
            12.324756,
            54.285775,
            43.301293
          ],
          [
            12.324982,
            54.28592,
            43.095428
          ],
          [
            12.325245,
            54.286067,
            42.871911
          ],
          [
            12.325551,
            54.286209,
            42.632397
          ],
          [
            12.325813,
            54.286323,
            42.431677
          ],
          [
            12.326062,
            54.286444,
            42.244728
          ],
          [
            12.326352,
            54.286552,
            42.342707
          ],
          [
            12.326624,
            54.286661,
            42.436263
          ],
          [
            12.326883,
            54.286852,
            42.554196
          ],
          [
            12.327078,
            54.287018,
            42.653575
          ],
          [
            12.327351,
            54.287158,
            42.756107
          ],
          [
            12.327641,
            54.287298,
            42.863137
          ],
          [
            12.327905,
            54.287441,
            42.96483
          ],
          [
            12.328148,
            54.287576,
            43.05976
          ],
          [
            12.328387,
            54.287763,
            43.170891
          ],
          [
            12.328622,
            54.287918,
            43.268213
          ],
          [
            12.328711,
            54.288125,
            43.369495
          ],
          [
            12.328753,
            54.288341,
            43.471714
          ],
          [
            12.328837,
            54.288572,
            43.584185
          ],
          [
            12.328947,
            54.288748,
            43.67348
          ],
          [
            12.329109,
            54.288941,
            43.774877
          ],
          [
            12.329312,
            54.289126,
            43.878338
          ],
          [
            12.329486,
            54.289295,
            43.939513
          ],
          [
            12.32972,
            54.289488,
            43.820484
          ],
          [
            12.329835,
            54.289702,
            43.707547
          ],
          [
            12.329958,
            54.289902,
            43.600547
          ],
          [
            12.330081,
            54.29009,
            43.499229
          ],
          [
            12.330159,
            54.290297,
            43.392466
          ],
          [
            12.330332,
            54.290483,
            43.281882
          ],
          [
            12.330583,
            54.290648,
            43.1708
          ],
          [
            12.330828,
            54.290818,
            43.058963
          ],
          [
            12.33102,
            54.290971,
            43.45796
          ],
          [
            12.331248,
            54.291167,
            44.017531
          ],
          [
            12.33149,
            54.291345,
            44.552427
          ],
          [
            12.331717,
            54.291525,
            45.078595
          ],
          [
            12.331971,
            54.29168,
            45.584118
          ],
          [
            12.332204,
            54.291828,
            46.058236
          ],
          [
            12.332446,
            54.291985,
            46.555454
          ],
          [
            12.332733,
            54.292136,
            47.086331
          ],
          [
            12.332975,
            54.292296,
            47.030122
          ],
          [
            12.3333,
            54.292337,
            46.647399
          ],
          [
            12.333664,
            54.292336,
            46.230469
          ],
          [
            12.33401,
            54.292319,
            45.831067
          ],
          [
            12.334319,
            54.292329,
            45.477168
          ],
          [
            12.334068,
            54.292455,
            45.073821
          ],
          [
            12.334205,
            54.292632,
            44.674776
          ],
          [
            12.334443,
            54.29278,
            44.277006
          ],
          [
            12.334679,
            54.292933,
            43.87158
          ],
          [
            12.334924,
            54.293091,
            43.484208
          ],
          [
            12.33516,
            54.293244,
            43.120375
          ],
          [
            12.335414,
            54.293419,
            42.71055
          ],
          [
            12.33566,
            54.293574,
            42.337297
          ],
          [
            12.335929,
            54.293731,
            41.944409
          ],
          [
            12.336159,
            54.29387,
            41.602804
          ],
          [
            12.336413,
            54.294048,
            41.193434
          ],
          [
            12.336699,
            54.29422,
            40.769935
          ],
          [
            12.336922,
            54.294384,
            40.865373
          ],
          [
            12.337189,
            54.294552,
            41.488239
          ],
          [
            12.337462,
            54.294727,
            42.131533
          ],
          [
            12.337702,
            54.294873,
            42.682628
          ],
          [
            12.337938,
            54.295038,
            43.267272
          ],
          [
            12.338161,
            54.295186,
            43.803241
          ],
          [
            12.338371,
            54.295343,
            44.345166
          ],
          [
            12.338579,
            54.295525,
            44.941184
          ],
          [
            12.338783,
            54.295694,
            45.46067
          ],
          [
            12.338987,
            54.295887,
            45.233647
          ],
          [
            12.339156,
            54.296041,
            45.050598
          ],
          [
            12.339354,
            54.296214,
            44.842104
          ],
          [
            12.339571,
            54.296385,
            44.629135
          ],
          [
            12.339786,
            54.296566,
            44.408708
          ],
          [
            12.340008,
            54.296758,
            44.176879
          ],
          [
            12.340214,
            54.29696,
            43.941503
          ],
          [
            12.340403,
            54.29713,
            43.738673
          ],
          [
            12.340605,
            54.29729,
            43.52182
          ],
          [
            12.340578,
            54.297503,
            43.3006
          ],
          [
            12.340705,
            54.297702,
            43.082033
          ],
          [
            12.340775,
            54.297908,
            42.866235
          ],
          [
            12.340921,
            54.298118,
            42.633244
          ],
          [
            12.341111,
            54.298296,
            42.417635
          ],
          [
            12.341319,
            54.29848,
            42.191217
          ],
          [
            12.341485,
            54.298659,
            41.980752
          ],
          [
            12.341735,
            54.298772,
            41.864324
          ],
          [
            12.342021,
            54.298913,
            42.132912
          ],
          [
            12.342308,
            54.299019,
            42.376497
          ],
          [
            12.342564,
            54.299136,
            42.609796
          ],
          [
            12.342862,
            54.29929,
            42.895263
          ],
          [
            12.343132,
            54.299427,
            43.152135
          ],
          [
            12.343371,
            54.299561,
            43.389817
          ],
          [
            12.343593,
            54.299726,
            43.647605
          ],
          [
            12.343839,
            54.299891,
            43.916377
          ],
          [
            12.344057,
            54.300067,
            44.301045
          ],
          [
            12.344265,
            54.300243,
            44.770912
          ],
          [
            12.344464,
            54.300427,
            45.249223
          ],
          [
            12.34466,
            54.300592,
            45.690452
          ],
          [
            12.344852,
            54.300756,
            46.127168
          ],
          [
            12.345092,
            54.30094,
            46.635906
          ],
          [
            12.34532,
            54.301135,
            47.154721
          ],
          [
            12.345566,
            54.301325,
            47.678204
          ],
          [
            12.345792,
            54.301526,
            47.824732
          ],
          [
            12.345996,
            54.30173,
            47.43805
          ],
          [
            12.346203,
            54.301924,
            47.063947
          ],
          [
            12.346438,
            54.302107,
            46.689653
          ],
          [
            12.346661,
            54.302292,
            46.319258
          ],
          [
            12.346881,
            54.302478,
            45.948836
          ],
          [
            12.347106,
            54.302683,
            45.550348
          ],
          [
            12.347304,
            54.302854,
            45.212492
          ],
          [
            12.3475,
            54.303019,
            45.101121
          ],
          [
            12.347726,
            54.303203,
            45.23422
          ],
          [
            12.347947,
            54.303386,
            45.365793
          ],
          [
            12.348157,
            54.303575,
            45.498184
          ],
          [
            12.348363,
            54.303763,
            45.629331
          ],
          [
            12.348584,
            54.303956,
            45.765751
          ],
          [
            12.348795,
            54.304143,
            45.897334
          ],
          [
            12.34901,
            54.304338,
            46.033786
          ],
          [
            12.349217,
            54.304524,
            46.054757
          ],
          [
            12.349436,
            54.30471,
            45.958372
          ],
          [
            12.349648,
            54.304891,
            45.86475
          ],
          [
            12.349846,
            54.305056,
            45.778755
          ],
          [
            12.350058,
            54.305219,
            45.691385
          ],
          [
            12.350271,
            54.305392,
            45.600437
          ],
          [
            12.350486,
            54.305553,
            45.513299
          ],
          [
            12.350702,
            54.305715,
            45.425631
          ],
          [
            12.350945,
            54.305894,
            45.339026
          ],
          [
            12.351191,
            54.306075,
            45.466497
          ],
          [
            12.351453,
            54.306196,
            45.574237
          ],
          [
            12.3517,
            54.306341,
            45.686926
          ],
          [
            12.351928,
            54.306488,
            45.796245
          ],
          [
            12.352153,
            54.30666,
            45.915588
          ],
          [
            12.352376,
            54.306819,
            46.028847
          ],
          [
            12.352606,
            54.307001,
            46.153501
          ],
          [
            12.352787,
            54.307173,
            46.264759
          ],
          [
            12.352975,
            54.307362,
            46.260895
          ],
          [
            12.353141,
            54.307531,
            46.14913
          ],
          [
            12.353259,
            54.307705,
            46.041874
          ],
          [
            12.353379,
            54.307898,
            45.924068
          ],
          [
            12.353464,
            54.308098,
            45.806005
          ],
          [
            12.353534,
            54.308287,
            45.695177
          ],
          [
            12.353605,
            54.308513,
            45.563532
          ],
          [
            12.353686,
            54.308753,
            45.423335
          ],
          [
            12.353759,
            54.308996,
            45.285054
          ],
          [
            12.353899,
            54.309243,
            45.174708
          ],
          [
            12.354037,
            54.309484,
            45.066897
          ],
          [
            12.354201,
            54.309718,
            44.959628
          ],
          [
            12.3544,
            54.309935,
            44.855251
          ],
          [
            12.354589,
            54.310162,
            44.748226
          ],
          [
            12.354778,
            54.310369,
            44.648763
          ],
          [
            12.354968,
            54.310582,
            44.546897
          ],
          [
            12.355151,
            54.310786,
            44.528998
          ],
          [
            12.355344,
            54.310991,
            44.526481
          ],
          [
            12.355551,
            54.311217,
            44.523729
          ],
          [
            12.355767,
            54.311452,
            44.520864
          ],
          [
            12.355973,
            54.311653,
            44.518349
          ],
          [
            12.356139,
            54.311854,
            44.515949
          ],
          [
            12.356296,
            54.312015,
            44.513959
          ],
          [
            12.356457,
            54.312178,
            44.511938
          ],
          [
            12.356625,
            54.312358,
            44.671302
          ],
          [
            12.356818,
            54.312572,
            44.876931
          ],
          [
            12.356998,
            54.312774,
            45.070334
          ],
          [
            12.357154,
            54.312934,
            45.22674
          ],
          [
            12.357338,
            54.313134,
            45.419613
          ],
          [
            12.3575,
            54.313333,
            45.606764
          ],
          [
            12.357696,
            54.313554,
            45.818159
          ],
          [
            12.357883,
            54.313744,
            46.004283
          ],
          [
            12.358097,
            54.313977,
            45.767979
          ],
          [
            12.358278,
            54.314166,
            45.503548
          ],
          [
            12.358427,
            54.314326,
            45.281275
          ],
          [
            12.358631,
            54.314537,
            44.985395
          ],
          [
            12.358825,
            54.314743,
            44.698485
          ],
          [
            12.359002,
            54.314942,
            44.42479
          ],
          [
            12.359204,
            54.315129,
            44.154942
          ],
          [
            12.359413,
            54.315348,
            43.848981
          ],
          [
            12.359595,
            54.315549,
            43.413346
          ],
          [
            12.359806,
            54.315785,
            42.899974
          ],
          [
            12.359944,
            54.315955,
            42.536471
          ],
          [
            12.360107,
            54.316177,
            42.070182
          ],
          [
            12.360255,
            54.316388,
            41.630372
          ],
          [
            12.360387,
            54.316614,
            41.16987
          ],
          [
            12.360481,
            54.316827,
            40.745606
          ],
          [
            12.360534,
            54.317054,
            40.421655
          ],
          [
            12.360595,
            54.317275,
            40.703933
          ],
          [
            12.360635,
            54.317497,
            40.985435
          ],
          [
            12.36067,
            54.317726,
            41.275957
          ],
          [
            12.360676,
            54.317961,
            41.572366
          ],
          [
            12.360662,
            54.318199,
            41.87267
          ],
          [
            12.360748,
            54.318426,
            42.169485
          ],
          [
            12.360908,
            54.318608,
            42.427879
          ],
          [
            12.361089,
            54.318814,
            42.5326
          ],
          [
            12.361272,
            54.319009,
            42.128581
          ],
          [
            12.361454,
            54.319204,
            41.724956
          ],
          [
            12.361639,
            54.319428,
            41.272997
          ],
          [
            12.361854,
            54.319627,
            40.845475
          ],
          [
            12.362068,
            54.319826,
            40.418464
          ],
          [
            12.362317,
            54.32004,
            39.94812
          ],
          [
            12.362512,
            54.320227,
            39.549949
          ],
          [
            12.362713,
            54.320437,
            39.671738
          ],
          [
            12.362906,
            54.320622,
            40.119601
          ],
          [
            12.363076,
            54.320789,
            40.5213
          ],
          [
            12.362925,
            54.320832,
            40.901199
          ],
          [
            12.362854,
            54.320924,
            41.303463
          ],
          [
            12.362869,
            54.320952,
            41.682926
          ],
          [
            12.363025,
            54.320788,
            42.080036
          ],
          [
            12.363276,
            54.320991,
            42.597782
          ],
          [
            12.363482,
            54.321177,
            43.055787
          ],
          [
            12.363685,
            54.321352,
            43.036432
          ],
          [
            12.36386,
            54.321524,
            42.976605
          ],
          [
            12.364061,
            54.321703,
            42.912625
          ],
          [
            12.364284,
            54.321908,
            42.840031
          ],
          [
            12.36452,
            54.322106,
            42.767934
          ],
          [
            12.364742,
            54.322313,
            42.694925
          ],
          [
            12.364938,
            54.322517,
            42.625008
          ],
          [
            12.365149,
            54.322719,
            42.555136
          ],
          [
            12.365378,
            54.32293,
            42.512376
          ],
          [
            12.365584,
            54.323155,
            42.468662
          ],
          [
            12.365795,
            54.32337,
            42.426236
          ],
          [
            12.365968,
            54.323572,
            42.387571
          ],
          [
            12.366183,
            54.32381,
            42.341477
          ],
          [
            12.366383,
            54.324,
            42.3033
          ],
          [
            12.366529,
            54.324171,
            42.270579
          ],
          [
            12.366714,
            54.324365,
            42.373304
          ],
          [
            12.366914,
            54.324601,
            42.730315
          ],
          [
            12.367084,
            54.324795,
            43.025717
          ],
          [
            12.36728,
            54.325017,
            43.36429
          ],
          [
            12.367465,
            54.325233,
            43.691702
          ],
          [
            12.367637,
            54.325448,
            44.013394
          ],
          [
            12.36782,
            54.325651,
            44.324396
          ],
          [
            12.368,
            54.325853,
            44.633066
          ],
          [
            12.36818,
            54.326066,
            44.52354
          ],
          [
            12.368366,
            54.326292,
            44.316218
          ],
          [
            12.368552,
            54.326511,
            44.114085
          ],
          [
            12.36875,
            54.326729,
            43.910062
          ],
          [
            12.368934,
            54.326973,
            43.68936
          ],
          [
            12.369067,
            54.327139,
            43.537827
          ],
          [
            12.369234,
            54.327346,
            43.348531
          ],
          [
            12.369413,
            54.327557,
            43.135711
          ],
          [
            12.369597,
            54.32778,
            42.849906
          ],
          [
            12.369738,
            54.327978,
            42.602211
          ],
          [
            12.369913,
            54.328177,
            42.343906
          ],
          [
            12.370118,
            54.328411,
            42.040387
          ],
          [
            12.370298,
            54.32865,
            41.738522
          ],
          [
            12.370447,
            54.328851,
            41.485657
          ],
          [
            12.370654,
            54.329069,
            41.197752
          ],
          [
            12.370852,
            54.329277,
            41.073543
          ],
          [
            12.371029,
            54.329511,
            41.001154
          ],
          [
            12.371227,
            54.329737,
            40.929263
          ],
          [
            12.371368,
            54.329946,
            40.865684
          ],
          [
            12.371519,
            54.330136,
            40.806363
          ],
          [
            12.371664,
            54.330302,
            40.753633
          ],
          [
            12.371843,
            54.330527,
            40.683425
          ],
          [
            12.372011,
            54.330744,
            40.616036
          ],
          [
            12.372178,
            54.330962,
            40.517914
          ],
          [
            12.37235,
            54.331165,
            40.423732
          ],
          [
            12.37252,
            54.331372,
            40.328284
          ],
          [
            12.372696,
            54.331584,
            40.230229
          ],
          [
            12.372882,
            54.331811,
            40.125605
          ],
          [
            12.37305,
            54.332032,
            40.025073
          ],
          [
            12.373244,
            54.33225,
            39.922724
          ],
          [
            12.373449,
            54.332477,
            39.805954
          ],
          [
            12.373608,
            54.332678,
            39.695193
          ],
          [
            12.373755,
            54.332882,
            39.584457
          ],
          [
            12.373943,
            54.333107,
            39.459164
          ],
          [
            12.374112,
            54.333322,
            39.34082
          ],
          [
            12.374275,
            54.333536,
            39.223648
          ],
          [
            12.374451,
            54.333756,
            39.102175
          ],
          [
            12.374634,
            54.333985,
            38.975755
          ],
          [
            12.374807,
            54.334209,
            39.001678
          ],
          [
            12.374986,
            54.334441,
            39.04249
          ],
          [
            12.37515,
            54.334637,
            39.077474
          ],
          [
            12.375312,
            54.334858,
            39.116044
          ],
          [
            12.375488,
            54.335077,
            39.154872
          ],
          [
            12.375625,
            54.335298,
            39.192569
          ],
          [
            12.375795,
            54.335527,
            39.232603
          ],
          [
            12.375971,
            54.335759,
            39.374462
          ],
          [
            12.376116,
            54.335961,
            39.594052
          ],
          [
            12.376256,
            54.336174,
            39.822783
          ],
          [
            12.3764,
            54.336392,
            40.056991
          ],
          [
            12.376542,
            54.336614,
            40.294574
          ],
          [
            12.376694,
            54.336832,
            40.531138
          ],
          [
            12.376869,
            54.337057,
            40.778892
          ],
          [
            12.377027,
            54.33728,
            41.020793
          ],
          [
            12.377197,
            54.337503,
            40.993908
          ],
          [
            12.377358,
            54.337746,
            40.914441
          ],
          [
            12.377556,
            54.337986,
            40.8332
          ],
          [
            12.377722,
            54.338223,
            40.755113
          ],
          [
            12.377878,
            54.338453,
            40.679662
          ],
          [
            12.37799,
            54.338631,
            40.6218
          ],
          [
            12.378139,
            54.338867,
            40.545093
          ],
          [
            12.3783,
            54.339073,
            40.538601
          ],
          [
            12.378448,
            54.339304,
            40.607348
          ],
          [
            12.378609,
            54.339527,
            40.674748
          ],
          [
            12.378777,
            54.339758,
            40.744644
          ],
          [
            12.37891,
            54.339954,
            40.803394
          ],
          [
            12.379035,
            54.340166,
            40.865903
          ],
          [
            12.37919,
            54.340365,
            40.926784
          ],
          [
            12.379345,
            54.3406,
            40.996919
          ],
          [
            12.37949,
            54.3408,
            40.920592
          ],
          [
            12.379649,
            54.341029,
            40.792034
          ],
          [
            12.379802,
            54.34124,
            40.672826
          ],
          [
            12.37995,
            54.341457,
            40.551096
          ],
          [
            12.380099,
            54.341653,
            40.439576
          ],
          [
            12.380238,
            54.341848,
            40.329724
          ],
          [
            12.380376,
            54.342048,
            40.21755
          ],
          [
            12.380523,
            54.342249,
            40.103864
          ],
          [
            12.380663,
            54.34246,
            40.150627
          ],
          [
            12.380818,
            54.342682,
            40.259236
          ],
          [
            12.380976,
            54.342877,
            40.356986
          ],
          [
            12.381133,
            54.343081,
            40.458384
          ],
          [
            12.381322,
            54.343263,
            40.555545
          ],
          [
            12.381627,
            54.343351,
            40.645584
          ],
          [
            12.381953,
            54.343433,
            40.739466
          ],
          [
            12.382326,
            54.343492,
            40.841556
          ],
          [
            12.382709,
            54.343546,
            40.918077
          ],
          [
            12.38304,
            54.343601,
            40.964853
          ],
          [
            12.383316,
            54.343732,
            41.013721
          ],
          [
            12.383454,
            54.343935,
            41.064718
          ],
          [
            12.383611,
            54.344093,
            41.107166
          ],
          [
            12.38377,
            54.344274,
            41.154454
          ],
          [
            12.383942,
            54.34448,
            41.207722
          ],
          [
            12.384087,
            54.344706,
            41.263947
          ],
          [
            12.384222,
            54.344883,
            41.302843
          ],
          [
            12.384379,
            54.345079,
            41.181639
          ],
          [
            12.384547,
            54.345276,
            41.058412
          ],
          [
            12.38469,
            54.345457,
            40.946711
          ],
          [
            12.384847,
            54.345629,
            40.837576
          ],
          [
            12.384993,
            54.34583,
            40.715359
          ],
          [
            12.385152,
            54.346039,
            40.58734
          ],
          [
            12.385293,
            54.346218,
            40.476974
          ],
          [
            12.385435,
            54.346388,
            40.371096
          ],
          [
            12.385582,
            54.346579,
            40.363385
          ],
          [
            12.385722,
            54.346745,
            40.505588
          ],
          [
            12.385867,
            54.346929,
            40.661498
          ],
          [
            12.386028,
            54.347112,
            40.820405
          ],
          [
            12.386183,
            54.347313,
            40.989511
          ],
          [
            12.386331,
            54.347485,
            41.137753
          ],
          [
            12.386467,
            54.347663,
            41.287319
          ],
          [
            12.386497,
            54.347857,
            41.443249
          ],
          [
            12.386687,
            54.348069,
            41.627926
          ],
          [
            12.386811,
            54.348269,
            41.51238
          ],
          [
            12.386953,
            54.348444,
            41.287251
          ],
          [
            12.387113,
            54.348628,
            41.047129
          ],
          [
            12.387279,
            54.348799,
            40.818836
          ],
          [
            12.387409,
            54.348988,
            40.581913
          ],
          [
            12.387587,
            54.349196,
            40.31179
          ],
          [
            12.387737,
            54.349384,
            40.070861
          ],
          [
            12.387876,
            54.349572,
            39.833017
          ],
          [
            12.388066,
            54.3498,
            39.647435
          ],
          [
            12.388222,
            54.349969,
            39.890439
          ],
          [
            12.388386,
            54.350181,
            40.185107
          ],
          [
            12.388556,
            54.350384,
            40.47123
          ],
          [
            12.38869,
            54.350585,
            40.744279
          ],
          [
            12.388831,
            54.350777,
            41.008741
          ],
          [
            12.388963,
            54.35096,
            41.26014
          ],
          [
            12.389101,
            54.351126,
            41.493745
          ],
          [
            12.389257,
            54.351285,
            41.727577
          ],
          [
            12.389584,
            54.351277,
            42.057774
          ],
          [
            12.389922,
            54.351216,
            42.503372
          ],
          [
            12.390255,
            54.351185,
            42.928322
          ],
          [
            12.39058,
            54.351094,
            43.382839
          ],
          [
            12.39092,
            54.350987,
            43.869602
          ],
          [
            12.391252,
            54.350856,
            44.374211
          ],
          [
            12.391527,
            54.350727,
            44.818846
          ],
          [
            12.391849,
            54.350571,
            45.345845
          ],
          [
            12.392166,
            54.350448,
            45.884933
          ],
          [
            12.392467,
            54.350345,
            46.68864
          ],
          [
            12.392746,
            54.350235,
            47.463639
          ],
          [
            12.393067,
            54.35015,
            48.270163
          ],
          [
            12.393401,
            54.350033,
            49.168448
          ],
          [
            12.393693,
            54.349906,
            50.00181
          ],
          [
            12.39402,
            54.349769,
            50.923949
          ],
          [
            12.394319,
            54.349668,
            51.71448
          ],
          [
            12.394614,
            54.349531,
            52.578867
          ],
          [
            12.394915,
            54.349405,
            52.525715
          ],
          [
            12.395239,
            54.349284,
            52.118992
          ],
          [
            12.395546,
            54.349142,
            51.703926
          ],
          [
            12.39586,
            54.349022,
            51.30704
          ],
          [
            12.396147,
            54.348901,
            50.932583
          ],
          [
            12.396456,
            54.348782,
            50.541119
          ],
          [
            12.396776,
            54.348665,
            50.140236
          ],
          [
            12.397097,
            54.34853,
            49.721454
          ],
          [
            12.397392,
            54.348428,
            49.54646
          ],
          [
            12.397712,
            54.3483,
            49.540901
          ],
          [
            12.398025,
            54.348184,
            49.535598
          ],
          [
            12.39833,
            54.34803,
            49.529715
          ],
          [
            12.39868,
            54.347942,
            49.524238
          ],
          [
            12.399084,
            54.348002,
            49.517497
          ],
          [
            12.399245,
            54.348166,
            49.512839
          ],
          [
            12.399438,
            54.348355,
            49.507442
          ],
          [
            12.399646,
            54.348545,
            49.462437
          ],
          [
            12.399897,
            54.348745,
            49.376413
          ],
          [
            12.40012,
            54.348933,
            49.297179
          ],
          [
            12.400369,
            54.349121,
            49.21468
          ],
          [
            12.400618,
            54.349321,
            49.128991
          ],
          [
            12.400854,
            54.349497,
            49.051473
          ],
          [
            12.401045,
            54.349648,
            48.986442
          ],
          [
            12.401238,
            54.349842,
            48.908432
          ],
          [
            12.401401,
            54.350067,
            48.605559
          ],
          [
            12.401626,
            54.350225,
            48.262165
          ],
          [
            12.401878,
            54.350391,
            47.894997
          ],
          [
            12.402177,
            54.350582,
            47.468644
          ],
          [
            12.402388,
            54.350737,
            47.142217
          ],
          [
            12.402585,
            54.350928,
            46.774643
          ],
          [
            12.402804,
            54.35109,
            46.433709
          ],
          [
            12.402649,
            54.35129,
            46.071461
          ],
          [
            12.402812,
            54.351475,
            45.885964
          ],
          [
            12.402969,
            54.351637,
            45.838419
          ],
          [
            12.402824,
            54.351792,
            45.791454
          ],
          [
            12.40301,
            54.351653,
            45.74205
          ],
          [
            12.40269,
            54.351617,
            45.693657
          ],
          [
            12.402457,
            54.3516,
            45.644599
          ],
          [
            12.40264,
            54.351537,
            45.596759
          ],
          [
            12.402867,
            54.351725,
            45.534842
          ],
          [
            12.40316,
            54.351656,
            45.485595
          ],
          [
            12.403349,
            54.351501,
            45.340769
          ],
          [
            12.403674,
            54.351548,
            45.028281
          ],
          [
            12.403889,
            54.351692,
            44.756924
          ],
          [
            12.404099,
            54.351862,
            44.459211
          ],
          [
            12.404332,
            54.352019,
            44.164228
          ],
          [
            12.404557,
            54.352185,
            43.86363
          ],
          [
            12.404797,
            54.352368,
            43.536282
          ],
          [
            12.404986,
            54.35257,
            43.209375
          ],
          [
            12.405234,
            54.352745,
            42.884452
          ],
          [
            12.405544,
            54.352911,
            42.507671
          ],
          [
            12.405798,
            54.353116,
            42.121184
          ],
          [
            12.406085,
            54.353319,
            41.7192
          ],
          [
            12.40632,
            54.353497,
            41.375923
          ],
          [
            12.406597,
            54.353696,
            40.984317
          ],
          [
            12.406829,
            54.353874,
            40.642549
          ],
          [
            12.407021,
            54.354051,
            40.322537
          ],
          [
            12.407232,
            54.354215,
            40.493459
          ],
          [
            12.407414,
            54.354405,
            41.278305
          ],
          [
            12.407528,
            54.35461,
            42.057022
          ],
          [
            12.407715,
            54.354831,
            42.945841
          ],
          [
            12.407905,
            54.355067,
            43.887296
          ],
          [
            12.408089,
            54.35526,
            44.683673
          ],
          [
            12.408235,
            54.355419,
            45.33925
          ],
          [
            12.408443,
            54.355609,
            46.152889
          ],
          [
            12.40866,
            54.355815,
            46.555551
          ],
          [
            12.408866,
            54.35603,
            46.358665
          ],
          [
            12.409038,
            54.356259,
            46.15879
          ],
          [
            12.409174,
            54.356489,
            45.96428
          ],
          [
            12.40927,
            54.356726,
            45.769578
          ],
          [
            12.409347,
            54.356966,
            45.574229
          ],
          [
            12.409343,
            54.357221,
            45.370326
          ],
          [
            12.409331,
            54.357439,
            45.198144
          ],
          [
            12.40938,
            54.357663,
            45.078005
          ],
          [
            12.409396,
            54.357874,
            44.965667
          ],
          [
            12.409418,
            54.358093,
            44.848991
          ],
          [
            12.4094,
            54.358308,
            44.734494
          ],
          [
            12.40947,
            54.358538,
            44.610203
          ],
          [
            12.409532,
            54.358753,
            44.4932
          ],
          [
            12.409505,
            54.35898,
            44.372071
          ],
          [
            12.409541,
            54.359209,
            44.249737
          ],
          [
            12.409557,
            54.359425,
            44.289174
          ],
          [
            12.409571,
            54.359654,
            44.336558
          ],
          [
            12.409591,
            54.359885,
            44.384387
          ],
          [
            12.409621,
            54.360117,
            44.432495
          ],
          [
            12.409629,
            54.360355,
            44.481712
          ],
          [
            12.409661,
            54.360581,
            44.528609
          ],
          [
            12.409693,
            54.360799,
            44.573868
          ],
          [
            12.409671,
            54.361083,
            44.591361
          ],
          [
            12.409643,
            54.361276,
            44.52063
          ],
          [
            12.409602,
            54.361465,
            44.451103
          ],
          [
            12.409722,
            54.361664,
            44.370289
          ],
          [
            12.409892,
            54.361839,
            44.296797
          ],
          [
            12.410122,
            54.362073,
            44.198374
          ],
          [
            12.410376,
            54.362284,
            44.104165
          ],
          [
            12.410555,
            54.362466,
            44.027583
          ],
          [
            12.410717,
            54.362658,
            43.951843
          ],
          [
            12.410896,
            54.362845,
            43.890165
          ],
          [
            12.411094,
            54.363019,
            43.830083
          ],
          [
            12.411299,
            54.363159,
            43.776644
          ],
          [
            12.411537,
            54.363301,
            43.719525
          ],
          [
            12.411775,
            54.363493,
            43.649752
          ],
          [
            12.411956,
            54.363728,
            43.57479
          ],
          [
            12.412146,
            54.363886,
            43.519273
          ],
          [
            12.412357,
            54.36405,
            43.460083
          ],
          [
            12.412551,
            54.364206,
            43.366
          ],
          [
            12.412753,
            54.364413,
            43.22943
          ],
          [
            12.412798,
            54.364595,
            43.124273
          ],
          [
            12.412808,
            54.364817,
            42.997284
          ],
          [
            12.412809,
            54.365009,
            42.887496
          ],
          [
            12.412789,
            54.365207,
            42.77408
          ],
          [
            12.412917,
            54.365399,
            42.65605
          ],
          [
            12.412939,
            54.365628,
            42.5249
          ],
          [
            12.412953,
            54.365881,
            42.357331
          ],
          [
            12.412999,
            54.366132,
            42.119243
          ],
          [
            12.413014,
            54.366312,
            41.949293
          ],
          [
            12.413032,
            54.366496,
            41.77527
          ],
          [
            12.413077,
            54.366676,
            41.603705
          ],
          [
            12.413137,
            54.366866,
            41.421518
          ],
          [
            12.413257,
            54.367046,
            41.239182
          ],
          [
            12.413432,
            54.367209,
            41.057143
          ],
          [
            12.413686,
            54.367374,
            40.847758
          ],
          [
            12.413974,
            54.367515,
            40.696998
          ],
          [
            12.414334,
            54.367594,
            40.63651
          ],
          [
            12.414534,
            54.367751,
            40.58141
          ],
          [
            12.414812,
            54.367921,
            40.518088
          ],
          [
            12.415066,
            54.368122,
            40.4515
          ],
          [
            12.415231,
            54.368312,
            40.39471
          ],
          [
            12.415426,
            54.368511,
            40.333454
          ],
          [
            12.415657,
            54.368647,
            40.282174
          ],
          [
            12.415811,
            54.368878,
            40.334939
          ],
          [
            12.415962,
            54.369098,
            40.59159
          ],
          [
            12.416101,
            54.369305,
            40.832272
          ],
          [
            12.416187,
            54.369499,
            41.049272
          ],
          [
            12.416353,
            54.369707,
            41.297802
          ],
          [
            12.416482,
            54.369895,
            41.517032
          ],
          [
            12.416619,
            54.370091,
            41.746264
          ],
          [
            12.41671,
            54.37027,
            41.948827
          ],
          [
            12.416794,
            54.370459,
            42.160679
          ],
          [
            12.416946,
            54.370688,
            42.249061
          ],
          [
            12.417011,
            54.370885,
            42.30513
          ],
          [
            12.417106,
            54.371104,
            42.368262
          ],
          [
            12.417253,
            54.371355,
            42.442387
          ],
          [
            12.417361,
            54.371579,
            42.507342
          ],
          [
            12.417522,
            54.371792,
            42.572554
          ],
          [
            12.4177,
            54.371982,
            42.632982
          ],
          [
            12.417846,
            54.372193,
            42.66287
          ],
          [
            12.417935,
            54.37241,
            42.433862
          ],
          [
            12.418081,
            54.372592,
            42.228934
          ],
          [
            12.418178,
            54.372781,
            42.027747
          ],
          [
            12.41809,
            54.372585,
            41.820885
          ],
          [
            12.418441,
            54.37251,
            41.595013
          ],
          [
            12.41876,
            54.372427,
            41.387243
          ],
          [
            12.419101,
            54.372417,
            41.177362
          ],
          [
            12.419424,
            54.372483,
            40.974019
          ],
          [
            12.41964,
            54.372367,
            40.950482
          ],
          [
            12.419838,
            54.372208,
            41.221048
          ],
          [
            12.419835,
            54.372023,
            41.487491
          ],
          [
            12.41996,
            54.371859,
            41.739299
          ],
          [
            12.419709,
            54.371757,
            41.993321
          ],
          [
            12.420168,
            54.37186,
            42.558814
          ],
          [
            12.419937,
            54.372021,
            42.860677
          ],
          [
            12.419724,
            54.372269,
            43.248217
          ],
          [
            12.419456,
            54.372437,
            43.332488
          ],
          [
            12.419129,
            54.372409,
            43.332488
          ],
          [
            12.41881,
            54.37232,
            43.332488
          ],
          [
            12.418791,
            54.372152,
            43.332488
          ],
          [
            12.418915,
            54.371965,
            43.332488
          ],
          [
            12.418878,
            54.372157,
            43.332488
          ],
          [
            12.418765,
            54.372329,
            43.332488
          ],
          [
            12.419064,
            54.372419,
            43.332488
          ],
          [
            12.419402,
            54.372481,
            43.332488
          ],
          [
            12.419665,
            54.372357,
            43.332488
          ],
          [
            12.419834,
            54.372184,
            43.332488
          ],
          [
            12.419924,
            54.371969,
            43.332488
          ],
          [
            12.42017,
            54.371854,
            43.332488
          ],
          [
            12.420292,
            54.3718,
            43.332488
          ]
        ]
      }
    }
  ]
}

let day30: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            12.419722,
            54.372039,
            38.289931
          ],
          [
            12.419776,
            54.372231,
            38.289931
          ],
          [
            12.419564,
            54.372378,
            38.289931
          ],
          [
            12.419305,
            54.372484,
            38.289931
          ],
          [
            12.419002,
            54.372414,
            38.289931
          ],
          [
            12.418775,
            54.37227,
            38.293239
          ],
          [
            12.418769,
            54.372098,
            38.300883
          ],
          [
            12.418536,
            54.37216,
            38.308771
          ],
          [
            12.418755,
            54.372162,
            38.316488
          ],
          [
            12.418856,
            54.372204,
            38.324181
          ],
          [
            12.418887,
            54.37237,
            38.332076
          ],
          [
            12.41938,
            54.372509,
            38.344864
          ],
          [
            12.419699,
            54.372555,
            38.352667
          ],
          [
            12.420027,
            54.372596,
            38.360534
          ],
          [
            12.420351,
            54.372683,
            38.315342
          ],
          [
            12.420652,
            54.372827,
            38.254973
          ],
          [
            12.421036,
            54.372868,
            38.194536
          ],
          [
            12.421431,
            54.372893,
            38.133028
          ],
          [
            12.421833,
            54.372933,
            38.069886
          ],
          [
            12.422244,
            54.372973,
            38.005376
          ],
          [
            12.422668,
            54.373017,
            37.938698
          ],
          [
            12.423047,
            54.373056,
            37.872264
          ],
          [
            12.423417,
            54.373091,
            37.732386
          ],
          [
            12.423804,
            54.37314,
            37.584599
          ],
          [
            12.424169,
            54.373184,
            37.445503
          ],
          [
            12.424511,
            54.373218,
            37.315988
          ],
          [
            12.424868,
            54.373278,
            37.177123
          ],
          [
            12.425177,
            54.373405,
            37.035578
          ],
          [
            12.425387,
            54.373555,
            36.911433
          ],
          [
            12.425614,
            54.373724,
            36.773886
          ],
          [
            12.425847,
            54.373886,
            36.73552
          ],
          [
            12.426069,
            54.374053,
            36.741004
          ],
          [
            12.426268,
            54.374211,
            36.74609
          ],
          [
            12.426479,
            54.374364,
            36.751185
          ],
          [
            12.426707,
            54.374495,
            36.756038
          ],
          [
            12.427,
            54.37466,
            36.762211
          ],
          [
            12.42721,
            54.374809,
            36.767227
          ],
          [
            12.427494,
            54.374889,
            36.771999
          ],
          [
            12.427792,
            54.374956,
            36.776831
          ],
          [
            12.428091,
            54.375028,
            36.63376
          ],
          [
            12.42839,
            54.375104,
            36.41831
          ],
          [
            12.428829,
            54.375158,
            36.120326
          ],
          [
            12.429173,
            54.375245,
            35.872608
          ],
          [
            12.429539,
            54.375334,
            35.6103
          ],
          [
            12.429905,
            54.375406,
            35.355096
          ],
          [
            12.430199,
            54.375474,
            35.146017
          ],
          [
            12.43053,
            54.375544,
            34.913458
          ],
          [
            12.430891,
            54.37561,
            34.88317
          ],
          [
            12.431253,
            54.375696,
            35.376438
          ],
          [
            12.431611,
            54.375791,
            35.872272
          ],
          [
            12.431989,
            54.375861,
            36.372176
          ],
          [
            12.432379,
            54.375927,
            36.884109
          ],
          [
            12.432709,
            54.37601,
            37.337421
          ],
          [
            12.433067,
            54.37611,
            37.838019
          ],
          [
            12.433391,
            54.376228,
            38.320052
          ],
          [
            12.43362,
            54.376432,
            38.63462
          ],
          [
            12.43364,
            54.376681,
            38.644165
          ],
          [
            12.433637,
            54.376901,
            38.652587
          ],
          [
            12.43365,
            54.377144,
            38.661893
          ],
          [
            12.433672,
            54.377388,
            38.671246
          ],
          [
            12.433681,
            54.377627,
            38.680415
          ],
          [
            12.433804,
            54.377812,
            38.688308
          ],
          [
            12.433988,
            54.37799,
            38.696272
          ],
          [
            12.434171,
            54.378159,
            38.580704
          ],
          [
            12.434371,
            54.378357,
            38.344979
          ],
          [
            12.434577,
            54.378568,
            38.096004
          ],
          [
            12.434822,
            54.37879,
            37.825136
          ],
          [
            12.435058,
            54.37896,
            37.600809
          ],
          [
            12.435377,
            54.379109,
            37.355737
          ],
          [
            12.435688,
            54.37924,
            37.126083
          ],
          [
            12.435998,
            54.379287,
            36.932695
          ],
          [
            12.436308,
            54.379274,
            36.91068
          ],
          [
            12.436626,
            54.379256,
            37.009927
          ],
          [
            12.436989,
            54.379227,
            37.123589
          ],
          [
            12.437358,
            54.379167,
            37.242949
          ],
          [
            12.437781,
            54.379056,
            37.386872
          ],
          [
            12.438197,
            54.378953,
            37.52714
          ],
          [
            12.438503,
            54.378861,
            37.634002
          ],
          [
            12.438837,
            54.378771,
            37.748196
          ],
          [
            12.439181,
            54.378734,
            37.757902
          ],
          [
            12.439509,
            54.378792,
            37.627898
          ],
          [
            12.43983,
            54.378899,
            37.488149
          ],
          [
            12.440153,
            54.379007,
            37.347424
          ],
          [
            12.440518,
            54.379117,
            37.192108
          ],
          [
            12.44079,
            54.379213,
            37.071912
          ],
          [
            12.441084,
            54.379328,
            36.938022
          ],
          [
            12.441358,
            54.379417,
            36.819442
          ],
          [
            12.441683,
            54.379484,
            36.688329
          ],
          [
            12.442036,
            54.379465,
            36.706759
          ],
          [
            12.442393,
            54.379435,
            36.797363
          ],
          [
            12.442757,
            54.379411,
            36.889345
          ],
          [
            12.4431,
            54.37938,
            36.976516
          ],
          [
            12.443435,
            54.379359,
            37.061117
          ],
          [
            12.443807,
            54.379383,
            37.155372
          ],
          [
            12.444144,
            54.379456,
            37.245943
          ],
          [
            12.444473,
            54.37954,
            37.336216
          ],
          [
            12.444804,
            54.37962,
            37.422515
          ],
          [
            12.445133,
            54.37971,
            37.444629
          ],
          [
            12.445486,
            54.379805,
            37.468256
          ],
          [
            12.445789,
            54.379895,
            37.488894
          ],
          [
            12.446101,
            54.379975,
            37.509589
          ],
          [
            12.44641,
            54.380027,
            37.529149
          ],
          [
            12.446758,
            54.380068,
            37.550715
          ],
          [
            12.447097,
            54.380079,
            37.571316
          ],
          [
            12.447445,
            54.380078,
            37.592429
          ],
          [
            12.447771,
            54.380081,
            37.591813
          ],
          [
            12.4481,
            54.380082,
            37.495879
          ],
          [
            12.448452,
            54.380086,
            37.393229
          ],
          [
            12.448797,
            54.38009,
            37.292619
          ],
          [
            12.449124,
            54.380091,
            37.197173
          ],
          [
            12.449477,
            54.380101,
            37.094059
          ],
          [
            12.449828,
            54.380149,
            36.988039
          ],
          [
            12.450139,
            54.380262,
            36.880744
          ],
          [
            12.450398,
            54.380413,
            36.773839
          ],
          [
            12.450635,
            54.380563,
            36.740919
          ],
          [
            12.4509,
            54.380725,
            36.840308
          ],
          [
            12.451151,
            54.380872,
            36.932391
          ],
          [
            12.451395,
            54.381013,
            37.021372
          ],
          [
            12.451666,
            54.381138,
            37.111229
          ],
          [
            12.452003,
            54.38119,
            37.201534
          ],
          [
            12.45237,
            54.381199,
            37.296521
          ],
          [
            12.452726,
            54.381198,
            37.388558
          ],
          [
            12.453072,
            54.381208,
            37.478093
          ],
          [
            12.453432,
            54.381201,
            37.397429
          ],
          [
            12.453774,
            54.381201,
            37.248486
          ],
          [
            12.454137,
            54.38121,
            37.090112
          ],
          [
            12.454499,
            54.381209,
            36.930972
          ],
          [
            12.454828,
            54.381205,
            36.787591
          ],
          [
            12.455228,
            54.381226,
            36.612336
          ],
          [
            12.455529,
            54.381308,
            36.466267
          ],
          [
            12.455807,
            54.381432,
            36.313764
          ],
          [
            12.456134,
            54.38153,
            36.168128
          ],
          [
            12.456484,
            54.38156,
            36.284843
          ],
          [
            12.456821,
            54.381582,
            36.39672
          ],
          [
            12.457156,
            54.381595,
            36.507729
          ],
          [
            12.457503,
            54.381599,
            36.622229
          ],
          [
            12.457832,
            54.38162,
            36.731449
          ],
          [
            12.458228,
            54.381631,
            36.862241
          ],
          [
            12.458611,
            54.381638,
            36.988782
          ],
          [
            12.458976,
            54.381665,
            37.110468
          ],
          [
            12.459412,
            54.381678,
            37.265756
          ],
          [
            12.459857,
            54.381688,
            37.435002
          ],
          [
            12.460227,
            54.381707,
            37.576149
          ],
          [
            12.460649,
            54.381716,
            37.736786
          ],
          [
            12.461106,
            54.381735,
            37.910851
          ],
          [
            12.461475,
            54.381746,
            38.051246
          ],
          [
            12.461919,
            54.381752,
            38.219954
          ],
          [
            12.462331,
            54.381768,
            38.370588
          ],
          [
            12.462747,
            54.381784,
            38.486581
          ],
          [
            12.463163,
            54.381801,
            38.602611
          ],
          [
            12.463566,
            54.381811,
            38.714839
          ],
          [
            12.464009,
            54.381818,
            38.838142
          ],
          [
            12.46446,
            54.381832,
            38.9638
          ],
          [
            12.464856,
            54.38184,
            39.074052
          ],
          [
            12.465172,
            54.381847,
            39.162044
          ],
          [
            12.465496,
            54.381857,
            39.204309
          ],
          [
            12.465837,
            54.381863,
            39.183895
          ],
          [
            12.466283,
            54.381876,
            39.157153
          ],
          [
            12.466673,
            54.38189,
            39.133747
          ],
          [
            12.467124,
            54.381898,
            39.106756
          ],
          [
            12.467441,
            54.381915,
            39.087715
          ],
          [
            12.467839,
            54.381925,
            39.063885
          ],
          [
            12.468169,
            54.381943,
            39.044054
          ],
          [
            12.468485,
            54.381952,
            39.012537
          ],
          [
            12.468924,
            54.381976,
            38.873478
          ],
          [
            12.469285,
            54.381972,
            38.759658
          ],
          [
            12.469703,
            54.38198,
            38.627849
          ],
          [
            12.470025,
            54.381999,
            38.525873
          ],
          [
            12.470446,
            54.382011,
            38.393063
          ],
          [
            12.470881,
            54.382018,
            38.255699
          ],
          [
            12.471276,
            54.382033,
            38.130967
          ],
          [
            12.471691,
            54.382051,
            38.137413
          ],
          [
            12.472103,
            54.382063,
            38.331799
          ],
          [
            12.47252,
            54.382071,
            38.528374
          ],
          [
            12.47294,
            54.382075,
            38.726262
          ],
          [
            12.473391,
            54.382081,
            38.938827
          ],
          [
            12.473827,
            54.382103,
            39.144989
          ],
          [
            12.47421,
            54.382107,
            39.325444
          ],
          [
            12.474596,
            54.38212,
            39.507672
          ],
          [
            12.474981,
            54.382139,
            39.339465
          ],
          [
            12.475356,
            54.382146,
            39.172039
          ],
          [
            12.475731,
            54.382146,
            39.004661
          ],
          [
            12.476172,
            54.382163,
            38.807349
          ],
          [
            12.476583,
            54.382177,
            38.623569
          ],
          [
            12.477018,
            54.382194,
            38.428934
          ],
          [
            12.47741,
            54.382201,
            38.253789
          ],
          [
            12.477787,
            54.382216,
            38.079495
          ],
          [
            12.47824,
            54.382229,
            37.852777
          ],
          [
            12.478624,
            54.382228,
            37.660647
          ],
          [
            12.479055,
            54.382245,
            37.444775
          ],
          [
            12.479486,
            54.382249,
            37.229381
          ],
          [
            12.479915,
            54.382261,
            37.014767
          ],
          [
            12.480326,
            54.382279,
            36.808793
          ],
          [
            12.480749,
            54.382294,
            36.597017
          ],
          [
            12.48118,
            54.382303,
            36.516618
          ],
          [
            12.481588,
            54.382313,
            36.445666
          ],
          [
            12.48199,
            54.382328,
            36.375661
          ],
          [
            12.482382,
            54.382335,
            36.307521
          ],
          [
            12.482771,
            54.382351,
            36.239768
          ],
          [
            12.48315,
            54.38236,
            36.173858
          ],
          [
            12.483526,
            54.382369,
            36.108459
          ],
          [
            12.483927,
            54.382384,
            36.131672
          ],
          [
            12.48432,
            54.382402,
            36.538518
          ],
          [
            12.484704,
            54.382408,
            36.93484
          ],
          [
            12.485095,
            54.382413,
            37.338374
          ],
          [
            12.485476,
            54.38243,
            37.732619
          ],
          [
            12.485875,
            54.38244,
            38.144792
          ],
          [
            12.486283,
            54.38246,
            38.567233
          ],
          [
            12.486694,
            54.382484,
            38.993495
          ],
          [
            12.487086,
            54.382494,
            39.110293
          ],
          [
            12.487493,
            54.382505,
            38.773423
          ],
          [
            12.48791,
            54.382524,
            38.427593
          ],
          [
            12.488271,
            54.382496,
            38.122011
          ],
          [
            12.48856,
            54.38242,
            37.859408
          ],
          [
            12.488966,
            54.382326,
            37.498199
          ],
          [
            12.489389,
            54.382255,
            37.134084
          ],
          [
            12.489801,
            54.382248,
            36.791233
          ],
          [
            12.490191,
            54.382318,
            36.528252
          ],
          [
            12.490559,
            54.3824,
            36.307807
          ],
          [
            12.490944,
            54.38248,
            36.079187
          ],
          [
            12.491328,
            54.382549,
            35.854402
          ],
          [
            12.491749,
            54.382624,
            35.608173
          ],
          [
            12.49207,
            54.38266,
            35.424773
          ],
          [
            12.492428,
            54.382688,
            35.222762
          ],
          [
            12.492768,
            54.382701,
            35.032031
          ],
          [
            12.493147,
            54.382711,
            35.097695
          ],
          [
            12.493605,
            54.38273,
            35.357203
          ],
          [
            12.493975,
            54.382747,
            35.567448
          ],
          [
            12.494416,
            54.382778,
            35.819505
          ],
          [
            12.494813,
            54.382853,
            36.055488
          ],
          [
            12.495228,
            54.382903,
            36.295274
          ],
          [
            12.495598,
            54.382885,
            36.505776
          ],
          [
            12.496043,
            54.382849,
            36.777526
          ],
          [
            12.496493,
            54.382824,
            37.113887
          ],
          [
            12.496853,
            54.382769,
            37.392299
          ],
          [
            12.497122,
            54.382621,
            37.669322
          ],
          [
            12.49739,
            54.382428,
            37.986474
          ],
          [
            12.497767,
            54.382444,
            38.291274
          ],
          [
            12.498105,
            54.382517,
            38.564096
          ],
          [
            12.498413,
            54.382563,
            38.801248
          ],
          [
            12.498834,
            54.382589,
            39.192471
          ],
          [
            12.499154,
            54.382646,
            39.593491
          ],
          [
            12.49947,
            54.382709,
            39.999536
          ],
          [
            12.499806,
            54.382783,
            40.432188
          ],
          [
            12.500178,
            54.382738,
            40.885358
          ],
          [
            12.500533,
            54.382704,
            41.316959
          ],
          [
            12.50088,
            54.382698,
            41.730902
          ],
          [
            12.50124,
            54.382662,
            42.167767
          ],
          [
            12.501596,
            54.38261,
            42.607426
          ],
          [
            12.501932,
            54.38255,
            42.446064
          ],
          [
            12.502285,
            54.382515,
            42.155415
          ],
          [
            12.50261,
            54.382518,
            41.891227
          ],
          [
            12.503014,
            54.382516,
            41.5634
          ],
          [
            12.503411,
            54.382515,
            41.240765
          ],
          [
            12.503802,
            54.382556,
            40.917947
          ],
          [
            12.504153,
            54.382592,
            40.628738
          ],
          [
            12.504487,
            54.382637,
            40.350573
          ],
          [
            12.504785,
            54.382684,
            40.155438
          ],
          [
            12.505091,
            54.382746,
            40.084208
          ],
          [
            12.505409,
            54.382834,
            40.00636
          ],
          [
            12.505734,
            54.38288,
            39.932666
          ],
          [
            12.506024,
            54.382989,
            39.854991
          ],
          [
            12.506262,
            54.383159,
            39.771998
          ],
          [
            12.506544,
            54.38328,
            39.694826
          ],
          [
            12.506881,
            54.383287,
            39.619075
          ],
          [
            12.507218,
            54.383218,
            39.540533
          ],
          [
            12.50758,
            54.383193,
            39.411542
          ],
          [
            12.507909,
            54.383244,
            39.240569
          ],
          [
            12.508266,
            54.383319,
            39.050879
          ],
          [
            12.508576,
            54.383405,
            38.879239
          ],
          [
            12.508934,
            54.383418,
            38.699657
          ],
          [
            12.509141,
            54.383337,
            38.534683
          ],
          [
            12.50903,
            54.383145,
            38.359665
          ],
          [
            12.508988,
            54.382964,
            38.198941
          ],
          [
            12.509298,
            54.382869,
            38.01992
          ],
          [
            12.509619,
            54.382805,
            37.827515
          ],
          [
            12.509909,
            54.382696,
            37.616727
          ],
          [
            12.510198,
            54.382588,
            37.406487
          ],
          [
            12.510491,
            54.382468,
            37.18775
          ],
          [
            12.510796,
            54.382346,
            36.961675
          ],
          [
            12.511095,
            54.382225,
            36.739294
          ],
          [
            12.511399,
            54.382109,
            36.517352
          ],
          [
            12.511721,
            54.381976,
            36.276388
          ],
          [
            12.512029,
            54.381847,
            36.087499
          ],
          [
            12.512344,
            54.381707,
            36.282559
          ],
          [
            12.512657,
            54.381582,
            36.469314
          ],
          [
            12.512995,
            54.381474,
            36.65945
          ],
          [
            12.513356,
            54.381392,
            36.850613
          ],
          [
            12.513744,
            54.381331,
            37.048373
          ],
          [
            12.514091,
            54.381259,
            37.232189
          ],
          [
            12.514358,
            54.381128,
            37.405312
          ],
          [
            12.514678,
            54.380993,
            37.579874
          ],
          [
            12.514952,
            54.380844,
            37.452177
          ],
          [
            12.515249,
            54.38068,
            37.312869
          ],
          [
            12.515458,
            54.380488,
            37.179355
          ],
          [
            12.515632,
            54.380308,
            37.05629
          ],
          [
            12.515935,
            54.380216,
            36.939818
          ],
          [
            12.516275,
            54.380163,
            36.819667
          ],
          [
            12.51664,
            54.380117,
            36.692573
          ],
          [
            12.517015,
            54.380073,
            36.562355
          ],
          [
            12.517383,
            54.380029,
            36.673184
          ],
          [
            12.517738,
            54.379989,
            36.836726
          ],
          [
            12.518062,
            54.379918,
            36.992743
          ],
          [
            12.51843,
            54.379873,
            37.162173
          ],
          [
            12.518799,
            54.37983,
            37.331754
          ],
          [
            12.519172,
            54.379786,
            37.50325
          ],
          [
            12.51957,
            54.379825,
            37.687537
          ],
          [
            12.519934,
            54.379884,
            37.857799
          ],
          [
            12.520322,
            54.379897,
            37.963052
          ],
          [
            12.520688,
            54.379941,
            38.019147
          ],
          [
            12.521007,
            54.380034,
            38.07223
          ],
          [
            12.521361,
            54.380156,
            38.133383
          ],
          [
            12.521664,
            54.380269,
            38.186941
          ],
          [
            12.521998,
            54.380399,
            38.246644
          ],
          [
            12.522332,
            54.380534,
            38.307098
          ],
          [
            12.522663,
            54.380645,
            38.363972
          ],
          [
            12.523017,
            54.380765,
            38.380378
          ],
          [
            12.523416,
            54.380835,
            38.368455
          ],
          [
            12.523814,
            54.3809,
            38.356629
          ],
          [
            12.524149,
            54.381028,
            38.344907
          ],
          [
            12.524358,
            54.381198,
            38.334621
          ],
          [
            12.52472,
            54.381307,
            38.322954
          ],
          [
            12.525046,
            54.381414,
            38.312211
          ],
          [
            12.525309,
            54.381577,
            38.301209
          ],
          [
            12.525542,
            54.381719,
            38.275319
          ],
          [
            12.525615,
            54.381899,
            38.246964
          ],
          [
            12.525728,
            54.382091,
            38.215853
          ],
          [
            12.525976,
            54.382238,
            38.183819
          ],
          [
            12.526226,
            54.382358,
            38.154895
          ],
          [
            12.526472,
            54.382487,
            38.125334
          ],
          [
            12.52673,
            54.382624,
            38.094071
          ],
          [
            12.526912,
            54.382798,
            38.062714
          ],
          [
            12.527099,
            54.382979,
            38.030312
          ],
          [
            12.527437,
            54.383034,
            37.897746
          ],
          [
            12.52771,
            54.382915,
            37.745021
          ],
          [
            12.528039,
            54.382856,
            37.594328
          ],
          [
            12.528352,
            54.382776,
            37.446227
          ],
          [
            12.528676,
            54.382726,
            37.300301
          ],
          [
            12.529015,
            54.38273,
            37.152905
          ],
          [
            12.529337,
            54.382748,
            37.012728
          ],
          [
            12.529671,
            54.382783,
            36.86569
          ],
          [
            12.530037,
            54.382834,
            36.702629
          ],
          [
            12.530412,
            54.382879,
            36.901462
          ],
          [
            12.530747,
            54.382924,
            37.118102
          ],
          [
            12.531013,
            54.383066,
            37.354627
          ],
          [
            12.531042,
            54.383269,
            37.576532
          ],
          [
            12.530998,
            54.383488,
            37.81511
          ],
          [
            12.530968,
            54.383728,
            38.075514
          ],
          [
            12.53093,
            54.383963,
            38.330888
          ],
          [
            12.530844,
            54.384176,
            38.568266
          ],
          [
            12.530743,
            54.384394,
            38.80363
          ],
          [
            12.530646,
            54.384622,
            39.045291
          ],
          [
            12.530547,
            54.384851,
            39.288391
          ],
          [
            12.530455,
            54.385076,
            39.526342
          ],
          [
            12.530427,
            54.385259,
            39.715419
          ],
          [
            12.530488,
            54.385488,
            39.957248
          ],
          [
            12.530648,
            54.385676,
            40.173091
          ],
          [
            12.53087,
            54.385873,
            40.415691
          ],
          [
            12.531073,
            54.386049,
            40.59845
          ],
          [
            12.531284,
            54.386228,
            40.770226
          ],
          [
            12.531507,
            54.386401,
            40.941144
          ],
          [
            12.531725,
            54.386578,
            41.113324
          ],
          [
            12.531974,
            54.386772,
            41.304687
          ],
          [
            12.532226,
            54.386962,
            41.494418
          ],
          [
            12.532319,
            54.387152,
            41.654596
          ],
          [
            12.532362,
            54.387389,
            41.842916
          ],
          [
            12.532451,
            54.387602,
            41.805087
          ],
          [
            12.532582,
            54.387825,
            41.645687
          ],
          [
            12.532805,
            54.387986,
            41.5057
          ],
          [
            12.533052,
            54.388142,
            41.362488
          ],
          [
            12.533297,
            54.388257,
            41.23879
          ],
          [
            12.533725,
            54.388381,
            41.049189
          ],
          [
            12.534055,
            54.388495,
            40.8984
          ],
          [
            12.534362,
            54.388611,
            40.754269
          ],
          [
            12.534711,
            54.388707,
            40.72244
          ],
          [
            12.535127,
            54.38883,
            40.793973
          ],
          [
            12.535409,
            54.388929,
            40.844462
          ],
          [
            12.535775,
            54.389032,
            40.906794
          ],
          [
            12.536141,
            54.389113,
            40.966825
          ],
          [
            12.536457,
            54.389188,
            41.019144
          ],
          [
            12.536785,
            54.389242,
            41.071446
          ],
          [
            12.537096,
            54.389294,
            41.121055
          ],
          [
            12.537521,
            54.389361,
            41.072613
          ],
          [
            12.537879,
            54.389406,
            40.88014
          ],
          [
            12.53825,
            54.389476,
            40.67535
          ],
          [
            12.538676,
            54.389538,
            40.444898
          ],
          [
            12.539046,
            54.389587,
            40.24563
          ],
          [
            12.539406,
            54.389642,
            40.049848
          ],
          [
            12.539795,
            54.389697,
            39.839733
          ],
          [
            12.540176,
            54.389733,
            39.637145
          ],
          [
            12.540564,
            54.389755,
            39.320884
          ],
          [
            12.541013,
            54.389773,
            38.841887
          ],
          [
            12.541328,
            54.38978,
            38.506525
          ],
          [
            12.541649,
            54.389793,
            38.163439
          ],
          [
            12.541969,
            54.389795,
            37.823007
          ],
          [
            12.542283,
            54.389802,
            37.488148
          ],
          [
            12.542685,
            54.389818,
            37.059016
          ],
          [
            12.543131,
            54.389843,
            36.582399
          ],
          [
            12.543495,
            54.389856,
            36.273892
          ],
          [
            12.543923,
            54.389821,
            36.413948
          ],
          [
            12.544346,
            54.389765,
            36.554469
          ],
          [
            12.544769,
            54.389726,
            36.693512
          ],
          [
            12.545134,
            54.389774,
            36.815678
          ],
          [
            12.545493,
            54.389909,
            36.954124
          ],
          [
            12.545823,
            54.390034,
            37.081651
          ],
          [
            12.546198,
            54.390073,
            37.205515
          ],
          [
            12.546592,
            54.390081,
            37.377246
          ],
          [
            12.546967,
            54.390094,
            37.568378
          ],
          [
            12.547338,
            54.390146,
            37.763135
          ],
          [
            12.547734,
            54.390215,
            37.973331
          ],
          [
            12.548112,
            54.390274,
            38.172333
          ],
          [
            12.548508,
            54.390346,
            38.383304
          ],
          [
            12.548871,
            54.390424,
            38.580116
          ],
          [
            12.54926,
            54.390542,
            38.805237
          ],
          [
            12.549444,
            54.390692,
            38.759553
          ],
          [
            12.549516,
            54.390904,
            38.668532
          ],
          [
            12.54953,
            54.391131,
            38.573332
          ],
          [
            12.54956,
            54.39138,
            38.468668
          ],
          [
            12.549587,
            54.391609,
            38.372464
          ],
          [
            12.549691,
            54.391642,
            38.294482
          ],
          [
            12.55005,
            54.391656,
            38.206163
          ],
          [
            12.550403,
            54.391677,
            38.119573
          ],
          [
            12.550781,
            54.391664,
            38.082067
          ],
          [
            12.551142,
            54.391669,
            38.099623
          ],
          [
            12.551517,
            54.391675,
            38.117932
          ],
          [
            12.551909,
            54.391677,
            38.136996
          ],
          [
            12.552299,
            54.391696,
            38.156019
          ],
          [
            12.552733,
            54.391716,
            38.177213
          ],
          [
            12.553129,
            54.391707,
            38.196622
          ],
          [
            12.553566,
            54.391719,
            38.217884
          ],
          [
            12.55396,
            54.391743,
            38.18058
          ],
          [
            12.554355,
            54.391758,
            38.12266
          ],
          [
            12.55472,
            54.391771,
            38.069171
          ],
          [
            12.555151,
            54.391753,
            38.005949
          ],
          [
            12.555482,
            54.391752,
            37.957445
          ],
          [
            12.555891,
            54.391722,
            37.897127
          ],
          [
            12.556307,
            54.391686,
            37.834001
          ],
          [
            12.556702,
            54.391655,
            37.775717
          ],
          [
            12.55712,
            54.391635,
            37.581937
          ],
          [
            12.557516,
            54.391613,
            37.388619
          ],
          [
            12.557935,
            54.391586,
            37.183986
          ],
          [
            12.558371,
            54.39157,
            36.971534
          ],
          [
            12.558757,
            54.391573,
            36.783774
          ],
          [
            12.559149,
            54.391598,
            36.592266
          ],
          [
            12.559504,
            54.39161,
            36.419666
          ],
          [
            12.559935,
            54.39165,
            36.320076
          ],
          [
            12.560315,
            54.391688,
            36.458676
          ],
          [
            12.560641,
            54.391727,
            36.579972
          ],
          [
            12.561039,
            54.391794,
            36.728483
          ],
          [
            12.561437,
            54.391861,
            36.877073
          ],
          [
            12.561801,
            54.391916,
            37.011937
          ],
          [
            12.562198,
            54.391964,
            37.157098
          ],
          [
            12.562513,
            54.392017,
            37.274506
          ],
          [
            12.562922,
            54.392022,
            37.390078
          ],
          [
            12.563362,
            54.391969,
            37.434894
          ],
          [
            12.5637,
            54.391905,
            37.470734
          ],
          [
            12.564169,
            54.391904,
            37.517333
          ],
          [
            12.564543,
            54.391903,
            37.554538
          ],
          [
            12.564887,
            54.391858,
            37.589839
          ],
          [
            12.565273,
            54.391839,
            37.628485
          ],
          [
            12.565684,
            54.391826,
            37.66946
          ],
          [
            12.566102,
            54.391797,
            37.642348
          ],
          [
            12.566523,
            54.391858,
            37.572719
          ],
          [
            12.566944,
            54.391884,
            37.504808
          ],
          [
            12.567331,
            54.391921,
            37.442521
          ],
          [
            12.567731,
            54.391963,
            37.377534
          ],
          [
            12.568071,
            54.392006,
            37.321854
          ],
          [
            12.568434,
            54.39205,
            37.262887
          ],
          [
            12.568827,
            54.392078,
            37.200013
          ],
          [
            12.569218,
            54.392082,
            37.727261
          ],
          [
            12.569652,
            54.392078,
            38.370972
          ],
          [
            12.570009,
            54.392098,
            38.902591
          ],
          [
            12.570423,
            54.392096,
            39.516589
          ],
          [
            12.570763,
            54.392131,
            40.02885
          ],
          [
            12.571127,
            54.392186,
            40.586298
          ],
          [
            12.571461,
            54.39223,
            41.094432
          ],
          [
            12.571769,
            54.392281,
            41.569252
          ],
          [
            12.572191,
            54.392313,
            41.589269
          ],
          [
            12.5725,
            54.392358,
            41.385572
          ],
          [
            12.57285,
            54.392423,
            41.15052
          ],
          [
            12.573173,
            54.39246,
            40.939721
          ],
          [
            12.573508,
            54.392479,
            40.724365
          ],
          [
            12.57388,
            54.392508,
            40.484025
          ],
          [
            12.574282,
            54.392481,
            40.224712
          ],
          [
            12.574679,
            54.392463,
            39.969894
          ],
          [
            12.574996,
            54.392459,
            39.759547
          ],
          [
            12.575422,
            54.39241,
            39.414218
          ],
          [
            12.575805,
            54.392416,
            39.10892
          ],
          [
            12.576161,
            54.392368,
            38.818368
          ],
          [
            12.576473,
            54.392329,
            38.563542
          ],
          [
            12.576858,
            54.39225,
            38.239017
          ],
          [
            12.577248,
            54.392219,
            37.925393
          ],
          [
            12.577625,
            54.392218,
            37.624015
          ],
          [
            12.577964,
            54.392162,
            37.350386
          ],
          [
            12.578343,
            54.39215,
            38.281778
          ],
          [
            12.57871,
            54.392101,
            39.214957
          ],
          [
            12.579046,
            54.392076,
            40.089911
          ],
          [
            12.579349,
            54.391987,
            40.92292
          ],
          [
            12.579612,
            54.392142,
            41.841113
          ],
          [
            12.579858,
            54.39243,
            43.196488
          ],
          [
            12.579996,
            54.39263,
            44.109457
          ],
          [
            12.580167,
            54.392856,
            44.704315
          ],
          [
            12.580381,
            54.393067,
            43.734035
          ],
          [
            12.580583,
            54.393259,
            42.843323
          ],
          [
            12.580792,
            54.393484,
            41.826515
          ],
          [
            12.580968,
            54.393674,
            40.972524
          ],
          [
            12.581139,
            54.393857,
            40.148288
          ],
          [
            12.581295,
            54.394054,
            39.288038
          ],
          [
            12.581482,
            54.394239,
            38.437495
          ],
          [
            12.581685,
            54.394465,
            37.763371
          ],
          [
            12.581855,
            54.394654,
            37.668376
          ],
          [
            12.581981,
            54.394834,
            37.581338
          ],
          [
            12.581726,
            54.394943,
            37.498596
          ],
          [
            12.581346,
            54.395036,
            37.391687
          ],
          [
            12.581054,
            54.395103,
            37.31022
          ],
          [
            12.580765,
            54.395172,
            37.22921
          ],
          [
            12.580409,
            54.395263,
            37.128376
          ],
          [
            12.580043,
            54.395358,
            37.024501
          ],
          [
            12.57975,
            54.395427,
            37.194676
          ],
          [
            12.579398,
            54.395525,
            37.50067
          ],
          [
            12.579084,
            54.3956,
            37.766803
          ],
          [
            12.578765,
            54.395664,
            38.031419
          ],
          [
            12.578468,
            54.395725,
            38.278376
          ],
          [
            12.578155,
            54.395816,
            38.552873
          ],
          [
            12.577875,
            54.395927,
            38.818511
          ],
          [
            12.577559,
            54.396056,
            39.121525
          ],
          [
            12.577267,
            54.396218,
            39.422189
          ],
          [
            12.577094,
            54.396396,
            39.296177
          ],
          [
            12.577081,
            54.396605,
            39.167106
          ],
          [
            12.577105,
            54.396816,
            39.036924
          ],
          [
            12.577127,
            54.397028,
            38.906167
          ],
          [
            12.577118,
            54.397234,
            38.779303
          ],
          [
            12.577129,
            54.397441,
            38.651769
          ],
          [
            12.577053,
            54.397635,
            38.529268
          ],
          [
            12.576926,
            54.397824,
            38.404108
          ],
          [
            12.576716,
            54.398033,
            38.114714
          ],
          [
            12.576506,
            54.398193,
            37.726034
          ],
          [
            12.576244,
            54.398404,
            37.22433
          ],
          [
            12.576084,
            54.398581,
            36.837093
          ],
          [
            12.575926,
            54.398764,
            36.442408
          ],
          [
            12.57576,
            54.398938,
            36.058839
          ],
          [
            12.575611,
            54.399118,
            35.673864
          ],
          [
            12.575483,
            54.399306,
            35.284126
          ],
          [
            12.5754,
            54.399529,
            34.855563
          ],
          [
            12.575364,
            54.399728,
            34.869676
          ],
          [
            12.575273,
            54.399918,
            34.883587
          ],
          [
            12.575202,
            54.400106,
            34.897172
          ],
          [
            12.57522,
            54.400323,
            34.912536
          ],
          [
            12.575228,
            54.400557,
            34.929044
          ],
          [
            12.575272,
            54.400757,
            34.943266
          ],
          [
            12.575318,
            54.400985,
            34.959465
          ],
          [
            12.575397,
            54.401205,
            34.975317
          ],
          [
            12.575452,
            54.401418,
            35.151564
          ],
          [
            12.575529,
            54.401628,
            35.453198
          ],
          [
            12.575595,
            54.401886,
            35.819799
          ],
          [
            12.575633,
            54.40209,
            36.108063
          ],
          [
            12.57568,
            54.402281,
            36.379423
          ],
          [
            12.575776,
            54.402469,
            36.656001
          ],
          [
            12.575908,
            54.402692,
            36.987325
          ],
          [
            12.576064,
            54.402895,
            37.299984
          ],
          [
            12.576198,
            54.403088,
            37.548845
          ],
          [
            12.576352,
            54.403286,
            37.695172
          ],
          [
            12.57654,
            54.403454,
            37.829842
          ],
          [
            12.576731,
            54.403627,
            37.967982
          ],
          [
            12.576914,
            54.403802,
            38.105554
          ],
          [
            12.577099,
            54.403971,
            38.240116
          ],
          [
            12.577286,
            54.40415,
            38.38079
          ],
          [
            12.577474,
            54.404308,
            38.509843
          ],
          [
            12.57774,
            54.404475,
            38.664659
          ],
          [
            12.578024,
            54.404588,
            38.643751
          ],
          [
            12.578315,
            54.404676,
            38.531443
          ],
          [
            12.578623,
            54.404777,
            38.410303
          ],
          [
            12.578924,
            54.404901,
            38.284016
          ],
          [
            12.579238,
            54.404996,
            38.162755
          ],
          [
            12.57958,
            54.405074,
            38.036963
          ],
          [
            12.579906,
            54.40514,
            37.918757
          ],
          [
            12.580208,
            54.405225,
            37.803761
          ],
          [
            12.580524,
            54.405298,
            37.687304
          ],
          [
            12.580866,
            54.405367,
            37.726646
          ],
          [
            12.58125,
            54.405452,
            37.828611
          ],
          [
            12.581549,
            54.405508,
            37.90648
          ],
          [
            12.581925,
            54.405599,
            38.007517
          ],
          [
            12.582241,
            54.405689,
            38.094756
          ],
          [
            12.582514,
            54.405806,
            38.179187
          ],
          [
            12.582781,
            54.405965,
            38.274004
          ],
          [
            12.582993,
            54.406152,
            38.370888
          ],
          [
            12.583028,
            54.406337,
            38.518336
          ],
          [
            12.58308,
            54.406568,
            38.878701
          ],
          [
            12.583371,
            54.406772,
            39.288991
          ],
          [
            12.583385,
            54.406957,
            39.596204
          ],
          [
            12.583284,
            54.407153,
            39.914383
          ],
          [
            12.583259,
            54.407373,
            40.254307
          ],
          [
            12.583241,
            54.407574,
            40.564709
          ],
          [
            12.583297,
            54.407789,
            40.90111
          ],
          [
            12.583454,
            54.407985,
            41.217432
          ],
          [
            12.583624,
            54.408159,
            41.385134
          ],
          [
            12.583797,
            54.40834,
            41.55869
          ],
          [
            12.584005,
            54.408499,
            41.725709
          ],
          [
            12.584269,
            54.408606,
            41.882377
          ],
          [
            12.584548,
            54.40873,
            42.053055
          ],
          [
            12.584824,
            54.408869,
            42.230821
          ],
          [
            12.584814,
            54.409064,
            42.393853
          ],
          [
            12.584818,
            54.409285,
            42.580141
          ],
          [
            12.584883,
            54.409468,
            42.638579
          ],
          [
            12.585202,
            54.409483,
            42.394025
          ],
          [
            12.58554,
            54.409442,
            42.139261
          ],
          [
            12.585898,
            54.409415,
            41.872331
          ],
          [
            12.586229,
            54.409404,
            41.627659
          ],
          [
            12.586597,
            54.409411,
            41.356012
          ],
          [
            12.586955,
            54.409415,
            41.091842
          ],
          [
            12.587366,
            54.409425,
            40.788344
          ],
          [
            12.587802,
            54.409423,
            40.466032
          ],
          [
            12.588231,
            54.40949,
            40.313971
          ],
          [
            12.588662,
            54.40956,
            40.190413
          ],
          [
            12.589046,
            54.409612,
            40.081531
          ],
          [
            12.589354,
            54.409672,
            39.991597
          ],
          [
            12.589616,
            54.409779,
            39.902983
          ],
          [
            12.589903,
            54.409876,
            39.811249
          ],
          [
            12.59018,
            54.409982,
            39.719654
          ],
          [
            12.590461,
            54.410081,
            39.62897
          ],
          [
            12.590774,
            54.410164,
            39.482905
          ],
          [
            12.591081,
            54.41024,
            39.243638
          ],
          [
            12.591398,
            54.410316,
            38.996623
          ],
          [
            12.591717,
            54.410355,
            38.761891
          ],
          [
            12.592057,
            54.410356,
            38.517931
          ],
          [
            12.592406,
            54.410358,
            38.267611
          ],
          [
            12.592754,
            54.41037,
            38.018011
          ],
          [
            12.593117,
            54.410354,
            37.755935
          ],
          [
            12.593469,
            54.410325,
            37.501235
          ],
          [
            12.593826,
            54.410288,
            37.301797
          ],
          [
            12.594168,
            54.410258,
            37.187723
          ],
          [
            12.594519,
            54.410218,
            37.069674
          ],
          [
            12.59487,
            54.410222,
            36.953831
          ],
          [
            12.59521,
            54.410249,
            36.8405
          ],
          [
            12.595605,
            54.410298,
            36.707018
          ],
          [
            12.59602,
            54.41032,
            36.569521
          ],
          [
            12.596392,
            54.410329,
            36.446721
          ],
          [
            12.596819,
            54.410342,
            36.420935
          ],
          [
            12.597205,
            54.410371,
            36.815932
          ],
          [
            12.597566,
            54.410421,
            37.191442
          ],
          [
            12.597981,
            54.410463,
            37.617792
          ],
          [
            12.598356,
            54.410457,
            38.001843
          ],
          [
            12.598769,
            54.410408,
            38.42847
          ],
          [
            12.599179,
            54.410377,
            38.846888
          ],
          [
            12.599551,
            54.410356,
            39.225086
          ],
          [
            12.599815,
            54.410479,
            39.401495
          ],
          [
            12.600127,
            54.410606,
            39.191968
          ],
          [
            12.600459,
            54.410701,
            38.990239
          ],
          [
            12.600805,
            54.4108,
            38.780359
          ],
          [
            12.60113,
            54.410891,
            38.583756
          ],
          [
            12.601488,
            54.411001,
            38.36338
          ],
          [
            12.601798,
            54.411082,
            38.178229
          ],
          [
            12.602148,
            54.411179,
            37.965357
          ],
          [
            12.602443,
            54.411268,
            37.78401
          ],
          [
            12.602745,
            54.411344,
            37.5106
          ],
          [
            12.603047,
            54.41142,
            37.234302
          ],
          [
            12.603344,
            54.411516,
            36.949167
          ],
          [
            12.603649,
            54.411598,
            36.666969
          ],
          [
            12.603948,
            54.41167,
            36.394861
          ],
          [
            12.604228,
            54.411754,
            36.128578
          ],
          [
            12.604516,
            54.411873,
            35.832057
          ],
          [
            12.604746,
            54.412,
            35.565943
          ],
          [
            12.604983,
            54.412143,
            35.277439
          ],
          [
            12.605198,
            54.412333,
            35.377177
          ],
          [
            12.605252,
            54.4126,
            35.69337
          ],
          [
            12.605233,
            54.412834,
            35.968662
          ],
          [
            12.605197,
            54.413063,
            36.238893
          ],
          [
            12.60517,
            54.413323,
            36.545057
          ],
          [
            12.605307,
            54.413529,
            36.807509
          ],
          [
            12.605616,
            54.41367,
            37.076043
          ],
          [
            12.605951,
            54.413763,
            37.323173
          ],
          [
            12.606337,
            54.413852,
            37.544691
          ],
          [
            12.606716,
            54.413912,
            37.753465
          ],
          [
            12.607064,
            54.413975,
            37.947493
          ],
          [
            12.607344,
            54.414132,
            38.153969
          ],
          [
            12.607661,
            54.414261,
            38.362162
          ],
          [
            12.608069,
            54.414289,
            38.583112
          ],
          [
            12.608447,
            54.41429,
            38.783368
          ],
          [
            12.608835,
            54.414287,
            38.824246
          ],
          [
            12.609142,
            54.414348,
            38.447316
          ],
          [
            12.60933,
            54.414519,
            38.054988
          ],
          [
            12.609593,
            54.414733,
            37.547566
          ],
          [
            12.609808,
            54.414925,
            37.105429
          ],
          [
            12.609985,
            54.415086,
            36.736773
          ],
          [
            12.610198,
            54.415272,
            36.305466
          ],
          [
            12.610435,
            54.415463,
            35.849451
          ],
          [
            12.610627,
            54.415621,
            35.476113
          ],
          [
            12.610821,
            54.415803,
            35.728284
          ],
          [
            12.611,
            54.415981,
            35.983722
          ],
          [
            12.611208,
            54.416173,
            36.264966
          ],
          [
            12.611422,
            54.416373,
            36.556728
          ],
          [
            12.611645,
            54.416556,
            36.834363
          ],
          [
            12.611826,
            54.416708,
            37.063217
          ],
          [
            12.612028,
            54.416885,
            37.326664
          ],
          [
            12.612149,
            54.417066,
            37.574814
          ],
          [
            12.612215,
            54.417276,
            37.723297
          ],
          [
            12.612298,
            54.417474,
            37.774038
          ],
          [
            12.61238,
            54.417712,
            37.834461
          ],
          [
            12.612432,
            54.417911,
            37.88461
          ],
          [
            12.612509,
            54.418134,
            37.941232
          ],
          [
            12.612592,
            54.418357,
            37.99803
          ],
          [
            12.612682,
            54.418584,
            38.056047
          ],
          [
            12.612774,
            54.41879,
            38.10907
          ],
          [
            12.612848,
            54.418993,
            38.134395
          ],
          [
            12.612928,
            54.419213,
            38.114708
          ],
          [
            12.613017,
            54.419437,
            38.094571
          ],
          [
            12.613079,
            54.419678,
            38.07324
          ],
          [
            12.613168,
            54.419911,
            38.052341
          ],
          [
            12.613246,
            54.420128,
            38.032904
          ],
          [
            12.613328,
            54.420327,
            38.014978
          ],
          [
            12.613397,
            54.42051,
            37.998571
          ],
          [
            12.613446,
            54.420691,
            37.986815
          ],
          [
            12.613542,
            54.420957,
            38.041184
          ],
          [
            12.613588,
            54.421141,
            38.078398
          ],
          [
            12.613672,
            54.421367,
            38.124629
          ],
          [
            12.613751,
            54.421564,
            38.165064
          ],
          [
            12.613823,
            54.421761,
            38.20535
          ],
          [
            12.61389,
            54.421962,
            38.246283
          ],
          [
            12.613976,
            54.422168,
            38.288653
          ],
          [
            12.614039,
            54.422364,
            38.328504
          ],
          [
            12.614086,
            54.422563,
            38.409854
          ],
          [
            12.614161,
            54.422797,
            38.534841
          ],
          [
            12.61416,
            54.423017,
            38.650211
          ],
          [
            12.614098,
            54.423262,
            38.78009
          ],
          [
            12.614071,
            54.423473,
            38.891085
          ],
          [
            12.614047,
            54.423694,
            39.007197
          ],
          [
            12.614022,
            54.423919,
            39.125401
          ],
          [
            12.614139,
            54.424139,
            39.252861
          ],
          [
            12.613992,
            54.424143,
            39.332734
          ],
          [
            12.613921,
            54.42436,
            39.414798
          ],
          [
            12.613891,
            54.424586,
            39.499223
          ],
          [
            12.613868,
            54.424818,
            39.58549
          ],
          [
            12.613841,
            54.425038,
            39.667368
          ],
          [
            12.61381,
            54.425238,
            39.741913
          ],
          [
            12.613769,
            54.425444,
            39.818905
          ],
          [
            12.613758,
            54.42563,
            39.888001
          ],
          [
            12.613751,
            54.425842,
            39.930674
          ],
          [
            12.613724,
            54.426049,
            39.793045
          ],
          [
            12.613694,
            54.42627,
            39.646089
          ],
          [
            12.61372,
            54.426502,
            39.491752
          ],
          [
            12.613701,
            54.426743,
            39.331666
          ],
          [
            12.61368,
            54.426985,
            39.170941
          ],
          [
            12.613656,
            54.427224,
            39.012211
          ],
          [
            12.613621,
            54.427457,
            38.857156
          ],
          [
            12.613609,
            54.427705,
            39.067217
          ],
          [
            12.613579,
            54.427925,
            39.714576
          ],
          [
            12.613541,
            54.428135,
            40.333965
          ],
          [
            12.613521,
            54.428335,
            40.923008
          ],
          [
            12.613477,
            54.428553,
            41.568461
          ],
          [
            12.613464,
            54.428794,
            42.276644
          ],
          [
            12.613424,
            54.429018,
            42.93855
          ],
          [
            12.613392,
            54.429242,
            43.597802
          ],
          [
            12.613396,
            54.429467,
            43.961936
          ],
          [
            12.613394,
            54.429717,
            43.713607
          ],
          [
            12.613426,
            54.429944,
            43.486823
          ],
          [
            12.613353,
            54.430157,
            43.27063
          ],
          [
            12.613139,
            54.43033,
            43.054462
          ],
          [
            12.6128,
            54.430427,
            42.836047
          ],
          [
            12.612435,
            54.430535,
            42.599412
          ],
          [
            12.612097,
            54.430626,
            42.384022
          ],
          [
            12.611733,
            54.430709,
            42.15954
          ],
          [
            12.611394,
            54.430807,
            41.944425
          ],
          [
            12.611065,
            54.430896,
            41.738172
          ],
          [
            12.610725,
            54.430981,
            41.527901
          ],
          [
            12.610351,
            54.431071,
            41.297924
          ],
          [
            12.609988,
            54.431141,
            41.080658
          ],
          [
            12.609642,
            54.431213,
            40.871849
          ],
          [
            12.609288,
            54.431306,
            40.651014
          ],
          [
            12.608926,
            54.431394,
            40.559318
          ],
          [
            12.60858,
            54.431483,
            40.774459
          ],
          [
            12.608218,
            54.431574,
            40.998721
          ],
          [
            12.607857,
            54.431683,
            41.230093
          ],
          [
            12.607536,
            54.43177,
            41.43153
          ],
          [
            12.607241,
            54.43186,
            41.620969
          ],
          [
            12.606912,
            54.431931,
            41.820538
          ],
          [
            12.606586,
            54.432028,
            42.029094
          ],
          [
            12.606254,
            54.432112,
            42.235018
          ],
          [
            12.605902,
            54.432209,
            42.250119
          ],
          [
            12.605573,
            54.432303,
            42.248096
          ],
          [
            12.605251,
            54.432391,
            42.246131
          ],
          [
            12.604924,
            54.432491,
            42.244092
          ],
          [
            12.604586,
            54.432578,
            42.242052
          ],
          [
            12.604248,
            54.432665,
            42.240011
          ],
          [
            12.603914,
            54.432758,
            42.237967
          ],
          [
            12.603569,
            54.432861,
            42.235827
          ],
          [
            12.603262,
            54.432947,
            42.203812
          ],
          [
            12.602928,
            54.433035,
            42.145835
          ],
          [
            12.602597,
            54.433117,
            42.088943
          ],
          [
            12.602305,
            54.433203,
            42.037179
          ],
          [
            12.602017,
            54.433292,
            41.985614
          ],
          [
            12.601729,
            54.433448,
            41.923372
          ],
          [
            12.6015,
            54.433578,
            41.872773
          ],
          [
            12.601167,
            54.43373,
            41.805847
          ],
          [
            12.600831,
            54.433884,
            41.742999
          ],
          [
            12.60052,
            54.434032,
            41.718001
          ],
          [
            12.600221,
            54.434168,
            41.694392
          ],
          [
            12.599921,
            54.434303,
            41.670789
          ],
          [
            12.599604,
            54.434444,
            41.645966
          ],
          [
            12.599296,
            54.434584,
            41.621661
          ],
          [
            12.598993,
            54.434725,
            41.597526
          ],
          [
            12.598701,
            54.43486,
            41.574331
          ],
          [
            12.598428,
            54.435004,
            41.549685
          ],
          [
            12.598128,
            54.435138,
            41.50975
          ],
          [
            12.597833,
            54.435267,
            41.470795
          ],
          [
            12.597505,
            54.435411,
            41.427395
          ],
          [
            12.597202,
            54.435561,
            41.385398
          ],
          [
            12.596898,
            54.435713,
            41.343083
          ],
          [
            12.596609,
            54.435861,
            41.302441
          ],
          [
            12.596328,
            54.435998,
            41.263741
          ],
          [
            12.596043,
            54.436136,
            41.225942
          ],
          [
            12.59576,
            54.436264,
            41.205948
          ],
          [
            12.595471,
            54.436378,
            41.186478
          ],
          [
            12.595166,
            54.436489,
            41.166415
          ],
          [
            12.594852,
            54.436601,
            41.14588
          ],
          [
            12.594546,
            54.436723,
            41.125197
          ],
          [
            12.594237,
            54.43685,
            41.104103
          ],
          [
            12.593931,
            54.436965,
            41.083792
          ],
          [
            12.593622,
            54.437091,
            41.062753
          ],
          [
            12.593306,
            54.437203,
            41.121376
          ],
          [
            12.593014,
            54.43733,
            41.225861
          ],
          [
            12.59277,
            54.437489,
            41.330859
          ],
          [
            12.592538,
            54.437657,
            41.436868
          ],
          [
            12.592319,
            54.437833,
            41.543744
          ],
          [
            12.592091,
            54.438011,
            41.652937
          ],
          [
            12.591867,
            54.438169,
            41.753698
          ],
          [
            12.591661,
            54.438344,
            41.858091
          ],
          [
            12.591424,
            54.438501,
            41.891659
          ],
          [
            12.591232,
            54.438683,
            41.653535
          ],
          [
            12.590991,
            54.438861,
            41.400823
          ],
          [
            12.590759,
            54.439053,
            41.139094
          ],
          [
            12.590513,
            54.43924,
            40.876432
          ],
          [
            12.590275,
            54.439423,
            40.620542
          ],
          [
            12.59004,
            54.439587,
            40.38246
          ],
          [
            12.589815,
            54.439772,
            40.129752
          ],
          [
            12.589553,
            54.439946,
            39.988214
          ],
          [
            12.589308,
            54.440119,
            40.20769
          ],
          [
            12.58908,
            54.440287,
            40.417088
          ],
          [
            12.588849,
            54.440461,
            40.632149
          ],
          [
            12.588625,
            54.440619,
            40.8325
          ],
          [
            12.588391,
            54.440776,
            41.035766
          ],
          [
            12.58817,
            54.440933,
            41.234263
          ],
          [
            12.587959,
            54.441078,
            41.420113
          ],
          [
            12.587736,
            54.441237,
            41.620851
          ],
          [
            12.587512,
            54.441399,
            41.630298
          ],
          [
            12.587303,
            54.441557,
            41.536053
          ],
          [
            12.587086,
            54.441714,
            41.440838
          ],
          [
            12.586862,
            54.441883,
            41.339968
          ],
          [
            12.586642,
            54.442068,
            41.233503
          ],
          [
            12.586443,
            54.442266,
            41.124844
          ],
          [
            12.586229,
            54.442459,
            41.016291
          ],
          [
            12.586013,
            54.442667,
            40.901429
          ],
          [
            12.585841,
            54.442846,
            40.840983
          ],
          [
            12.585644,
            54.443023,
            40.835144
          ],
          [
            12.585477,
            54.443211,
            40.829279
          ],
          [
            12.585284,
            54.443388,
            40.823463
          ],
          [
            12.58513,
            54.443575,
            40.817701
          ],
          [
            12.584882,
            54.443735,
            40.811703
          ],
          [
            12.584643,
            54.443912,
            40.80545
          ],
          [
            12.584354,
            54.44407,
            40.799045
          ],
          [
            12.58409,
            54.444216,
            40.797799
          ],
          [
            12.583967,
            54.444411,
            40.893743
          ],
          [
            12.583866,
            54.4446,
            40.985462
          ],
          [
            12.583561,
            54.444662,
            41.07187
          ],
          [
            12.583237,
            54.444736,
            41.1658
          ],
          [
            12.58299,
            54.444866,
            41.254965
          ],
          [
            12.58274,
            54.445097,
            41.384549
          ],
          [
            12.582516,
            54.445214,
            41.476197
          ],
          [
            12.582609,
            54.445404,
            41.568757
          ],
          [
            12.58275,
            54.4456,
            41.747128
          ],
          [
            12.582881,
            54.445779,
            41.99205
          ],
          [
            12.583005,
            54.445977,
            42.257309
          ],
          [
            12.583112,
            54.446177,
            42.521103
          ],
          [
            12.583309,
            54.446359,
            42.79183
          ],
          [
            12.583528,
            54.446544,
            43.074842
          ],
          [
            12.583791,
            54.446695,
            43.346263
          ],
          [
            12.584052,
            54.446882,
            43.649592
          ],
          [
            12.5844,
            54.447027,
            43.883027
          ],
          [
            12.584711,
            54.447152,
            43.879216
          ],
          [
            12.585061,
            54.447311,
            43.874738
          ],
          [
            12.585402,
            54.447412,
            43.870881
          ],
          [
            12.585749,
            54.447514,
            43.86696
          ],
          [
            12.586079,
            54.44762,
            43.863131
          ],
          [
            12.586283,
            54.4478,
            43.859387
          ],
          [
            12.586448,
            54.447974,
            43.85594
          ],
          [
            12.586672,
            54.448122,
            43.886954
          ],
          [
            12.586995,
            54.448271,
            44.188815
          ],
          [
            12.58726,
            54.448431,
            44.468796
          ],
          [
            12.587419,
            54.44863,
            44.767099
          ],
          [
            12.587779,
            54.448652,
            45.036159
          ],
          [
            12.588094,
            54.448746,
            45.296733
          ],
          [
            12.588391,
            54.448814,
            45.533311
          ],
          [
            12.588748,
            54.448886,
            45.810743
          ],
          [
            12.589072,
            54.448975,
            46.076912
          ],
          [
            12.589425,
            54.449083,
            45.386349
          ],
          [
            12.589734,
            54.449194,
            44.603912
          ],
          [
            12.590044,
            54.449341,
            43.752889
          ],
          [
            12.590365,
            54.449442,
            42.979139
          ],
          [
            12.590663,
            54.449571,
            42.191541
          ],
          [
            12.591021,
            54.449635,
            41.39353
          ],
          [
            12.591369,
            54.449691,
            40.628014
          ],
          [
            12.591689,
            54.44978,
            39.875343
          ],
          [
            12.592019,
            54.449858,
            39.649717
          ],
          [
            12.592344,
            54.449967,
            39.815065
          ],
          [
            12.592559,
            54.450096,
            39.949743
          ],
          [
            12.59288,
            54.45019,
            40.106672
          ],
          [
            12.593229,
            54.450228,
            40.261386
          ],
          [
            12.593575,
            54.450285,
            40.419508
          ],
          [
            12.593956,
            54.450334,
            40.590265
          ],
          [
            12.594309,
            54.450374,
            40.74692
          ],
          [
            12.594679,
            54.450417,
            40.917365
          ],
          [
            12.595048,
            54.450463,
            41.250332
          ],
          [
            12.595368,
            54.450472,
            41.534184
          ],
          [
            12.595368,
            54.450642,
            41.804345
          ],
          [
            12.595406,
            54.450832,
            42.092229
          ],
          [
            12.595455,
            54.450809,
            42.374572
          ],
          [
            12.595329,
            54.450629,
            42.663066
          ],
          [
            12.595339,
            54.450459,
            42.983874
          ],
          [
            12.59574,
            54.450371,
            43.355046
          ],
          [
            12.596097,
            54.450316,
            43.575998
          ],
          [
            12.596431,
            54.450243,
            43.600367
          ],
          [
            12.596734,
            54.450183,
            43.622242
          ],
          [
            12.597082,
            54.450115,
            43.647468
          ],
          [
            12.597396,
            54.450046,
            43.670383
          ],
          [
            12.597767,
            54.449979,
            43.696924
          ],
          [
            12.598102,
            54.449907,
            43.721306
          ],
          [
            12.598416,
            54.449853,
            43.743666
          ],
          [
            12.598785,
            54.449774,
            43.770519
          ],
          [
            12.599151,
            54.449701,
            43.668908
          ],
          [
            12.599521,
            54.449629,
            43.507476
          ],
          [
            12.59984,
            54.449586,
            43.372014
          ],
          [
            12.600164,
            54.449552,
            43.235818
          ],
          [
            12.60051,
            54.449512,
            43.089834
          ],
          [
            12.600848,
            54.449483,
            42.948472
          ],
          [
            12.601187,
            54.449445,
            42.805414
          ],
          [
            12.601518,
            54.449399,
            42.664562
          ],
          [
            12.601866,
            54.449324,
            42.510888
          ],
          [
            12.602217,
            54.449241,
            42.44238
          ],
          [
            12.602548,
            54.449168,
            42.385015
          ],
          [
            12.602878,
            54.449079,
            42.326125
          ],
          [
            12.603217,
            54.448985,
            42.265324
          ],
          [
            12.603564,
            54.448907,
            42.20508
          ],
          [
            12.603909,
            54.448813,
            42.143379
          ],
          [
            12.604234,
            54.448723,
            42.085046
          ],
          [
            12.604562,
            54.448655,
            42.028664
          ],
          [
            12.60491,
            54.448578,
            41.924526
          ],
          [
            12.605197,
            54.448494,
            41.796502
          ],
          [
            12.605646,
            54.448402,
            41.606669
          ],
          [
            12.606025,
            54.448363,
            41.453263
          ],
          [
            12.606386,
            54.448332,
            41.306745
          ],
          [
            12.606708,
            54.448299,
            41.176136
          ],
          [
            12.607054,
            54.448271,
            41.036958
          ],
          [
            12.607395,
            54.448246,
            40.899907
          ],
          [
            12.607768,
            54.448202,
            40.79787
          ],
          [
            12.608169,
            54.448182,
            41.090756
          ],
          [
            12.608481,
            54.44817,
            41.320793
          ],
          [
            12.608788,
            54.448141,
            41.545645
          ],
          [
            12.609231,
            54.448119,
            41.86712
          ],
          [
            12.609678,
            54.448078,
            42.194325
          ],
          [
            12.610106,
            54.448035,
            42.510471
          ],
          [
            12.610559,
            54.447987,
            42.843515
          ],
          [
            12.610889,
            54.447972,
            43.064949
          ],
          [
            12.611229,
            54.447949,
            43.257967
          ],
          [
            12.611564,
            54.447935,
            43.446664
          ],
          [
            12.611919,
            54.447897,
            43.64976
          ],
          [
            12.612267,
            54.447874,
            43.846528
          ],
          [
            12.612599,
            54.447858,
            44.033782
          ],
          [
            12.612942,
            54.447839,
            44.227617
          ],
          [
            12.613302,
            54.447805,
            44.432716
          ],
          [
            12.613637,
            54.447787,
            44.622414
          ],
          [
            12.614032,
            54.447769,
            44.661448
          ],
          [
            12.614361,
            54.447738,
            44.521015
          ],
          [
            12.614682,
            54.447702,
            44.38338
          ],
          [
            12.615019,
            54.447665,
            44.238328
          ],
          [
            12.615395,
            54.447625,
            44.076754
          ],
          [
            12.615759,
            54.447594,
            43.921862
          ],
          [
            12.616114,
            54.447588,
            43.772167
          ],
          [
            12.616477,
            54.447555,
            43.617284
          ],
          [
            12.616852,
            54.447509,
            43.455467
          ],
          [
            12.617223,
            54.447498,
            43.738946
          ],
          [
            12.617598,
            54.447473,
            44.084141
          ],
          [
            12.617968,
            54.447441,
            44.426471
          ],
          [
            12.618341,
            54.447442,
            44.768238
          ],
          [
            12.618701,
            54.447395,
            45.106757
          ],
          [
            12.619058,
            54.447382,
            45.433791
          ],
          [
            12.619431,
            54.447351,
            45.778273
          ],
          [
            12.619781,
            54.447317,
            46.103021
          ],
          [
            12.620132,
            54.447278,
            46.531247
          ],
          [
            12.620488,
            54.447257,
            47.060889
          ],
          [
            12.620858,
            54.447258,
            47.60862
          ],
          [
            12.62122,
            54.447234,
            48.147274
          ],
          [
            12.621578,
            54.447217,
            48.678611
          ],
          [
            12.621941,
            54.447187,
            49.2208
          ],
          [
            12.622297,
            54.447151,
            49.756517
          ],
          [
            12.62266,
            54.447139,
            50.294817
          ],
          [
            12.623034,
            54.447108,
            50.832288
          ],
          [
            12.623395,
            54.447081,
            50.611564
          ],
          [
            12.623734,
            54.447002,
            50.389762
          ],
          [
            12.624061,
            54.44694,
            50.180525
          ],
          [
            12.624378,
            54.446881,
            49.978674
          ],
          [
            12.624743,
            54.446776,
            49.730803
          ],
          [
            12.625102,
            54.446705,
            49.500581
          ],
          [
            12.625428,
            54.446627,
            49.286794
          ],
          [
            12.625782,
            54.446543,
            49.054929
          ],
          [
            12.626126,
            54.446465,
            49.049968
          ],
          [
            12.626479,
            54.446379,
            49.203273
          ],
          [
            12.626821,
            54.446309,
            49.34849
          ],
          [
            12.627167,
            54.446221,
            49.499757
          ],
          [
            12.627546,
            54.446124,
            49.665743
          ],
          [
            12.627886,
            54.446048,
            49.811791
          ],
          [
            12.628248,
            54.445969,
            49.966681
          ],
          [
            12.628577,
            54.445905,
            50.105614
          ],
          [
            12.628927,
            54.445806,
            50.23458
          ],
          [
            12.629271,
            54.445738,
            50.314464
          ],
          [
            12.629612,
            54.445662,
            50.395026
          ],
          [
            12.629951,
            54.445596,
            50.473624
          ],
          [
            12.630322,
            54.445508,
            50.56186
          ],
          [
            12.630666,
            54.445424,
            50.643892
          ],
          [
            12.630999,
            54.445351,
            50.722134
          ],
          [
            12.631328,
            54.44529,
            50.798264
          ],
          [
            12.631664,
            54.445219,
            50.876949
          ],
          [
            12.63202,
            54.445164,
            51.142235
          ],
          [
            12.632369,
            54.445058,
            51.43597
          ],
          [
            12.632707,
            54.444998,
            51.699699
          ],
          [
            12.633059,
            54.444944,
            51.971295
          ],
          [
            12.633381,
            54.444864,
            52.233196
          ],
          [
            12.633702,
            54.444788,
            52.491754
          ],
          [
            12.634055,
            54.444738,
            52.762796
          ],
          [
            12.634376,
            54.444679,
            53.013971
          ],
          [
            12.634709,
            54.444632,
            53.108878
          ],
          [
            12.63505,
            54.444581,
            52.846761
          ],
          [
            12.635385,
            54.444528,
            52.588321
          ],
          [
            12.635712,
            54.444467,
            52.330486
          ],
          [
            12.636058,
            54.444417,
            52.064091
          ],
          [
            12.636399,
            54.444359,
            51.799319
          ],
          [
            12.636737,
            54.444306,
            51.538455
          ],
          [
            12.637063,
            54.444251,
            51.285701
          ],
          [
            12.637405,
            54.444177,
            51.013533
          ],
          [
            12.637734,
            54.444145,
            50.946314
          ],
          [
            12.638096,
            54.444103,
            51.081131
          ],
          [
            12.63843,
            54.444037,
            51.209807
          ],
          [
            12.638775,
            54.444001,
            51.337688
          ],
          [
            12.6391,
            54.443973,
            51.458031
          ],
          [
            12.63943,
            54.443911,
            51.584704
          ],
          [
            12.639755,
            54.443852,
            51.708989
          ],
          [
            12.640098,
            54.4438,
            51.838979
          ],
          [
            12.640448,
            54.443731,
            51.975195
          ],
          [
            12.640812,
            54.443675,
            51.926162
          ],
          [
            12.64117,
            54.443622,
            51.803879
          ],
          [
            12.641547,
            54.443566,
            51.674522
          ],
          [
            12.641899,
            54.443524,
            51.553
          ],
          [
            12.642242,
            54.443445,
            51.430825
          ],
          [
            12.642602,
            54.443385,
            51.306446
          ],
          [
            12.642973,
            54.443323,
            51.178519
          ],
          [
            12.643341,
            54.44326,
            51.051131
          ],
          [
            12.64371,
            54.443203,
            51.481175
          ],
          [
            12.644046,
            54.44314,
            52.344167
          ],
          [
            12.644412,
            54.443083,
            53.271089
          ],
          [
            12.644781,
            54.443059,
            54.183484
          ],
          [
            12.645129,
            54.443039,
            55.038669
          ],
          [
            12.64549,
            54.443038,
            55.922283
          ],
          [
            12.645856,
            54.443007,
            56.829115
          ],
          [
            12.646213,
            54.442968,
            57.718233
          ],
          [
            12.646594,
            54.442973,
            58.586744
          ],
          [
            12.646959,
            54.442948,
            58.932193
          ],
          [
            12.647339,
            54.442944,
            59.288871
          ],
          [
            12.647721,
            54.442913,
            59.650955
          ],
          [
            12.64809,
            54.442897,
            59.998191
          ],
          [
            12.648442,
            54.442848,
            60.337842
          ],
          [
            12.648776,
            54.442826,
            60.653344
          ],
          [
            12.649115,
            54.442785,
            60.978244
          ],
          [
            12.649452,
            54.44273,
            61.309589
          ],
          [
            12.649811,
            54.442702,
            61.867246
          ],
          [
            12.650147,
            54.442705,
            62.528741
          ],
          [
            12.650501,
            54.442692,
            63.223608
          ],
          [
            12.650862,
            54.44266,
            63.938339
          ],
          [
            12.651234,
            54.442644,
            64.669182
          ],
          [
            12.65158,
            54.44261,
            65.35767
          ],
          [
            12.651994,
            54.442597,
            66.169196
          ],
          [
            12.652342,
            54.442615,
            66.866346
          ],
          [
            12.652706,
            54.442614,
            67.453444
          ],
          [
            12.653035,
            54.442625,
            67.034258
          ],
          [
            12.653364,
            54.442577,
            66.603395
          ],
          [
            12.653736,
            54.442566,
            66.127446
          ],
          [
            12.654085,
            54.442544,
            65.678998
          ],
          [
            12.654454,
            54.44251,
            65.204315
          ],
          [
            12.654804,
            54.442479,
            64.754955
          ],
          [
            12.655158,
            54.442444,
            64.299194
          ],
          [
            12.655508,
            54.442361,
            63.815076
          ],
          [
            12.655865,
            54.442313,
            62.902476
          ],
          [
            12.656207,
            54.442283,
            61.634409
          ],
          [
            12.656589,
            54.442264,
            60.231593
          ],
          [
            12.656946,
            54.442261,
            58.92538
          ],
          [
            12.657284,
            54.442185,
            57.595105
          ],
          [
            12.657627,
            54.442141,
            56.311774
          ],
          [
            12.658021,
            54.442111,
            54.860052
          ],
          [
            12.658392,
            54.442086,
            53.491446
          ],
          [
            12.658771,
            54.442045,
            52.14117
          ],
          [
            12.659217,
            54.442002,
            51.114293
          ],
          [
            12.659627,
            54.441956,
            50.166439
          ],
          [
            12.659983,
            54.4419,
            49.329289
          ],
          [
            12.66033,
            54.441851,
            48.517392
          ],
          [
            12.660627,
            54.441766,
            47.758039
          ],
          [
            12.660302,
            54.441579,
            46.651365
          ],
          [
            12.660313,
            54.441345,
            45.734506
          ],
          [
            12.660256,
            54.441159,
            45.261753
          ],
          [
            12.660209,
            54.440914,
            45.280458
          ],
          [
            12.660145,
            54.440671,
            45.299128
          ],
          [
            12.660097,
            54.440422,
            45.318153
          ],
          [
            12.66007,
            54.440179,
            45.336628
          ],
          [
            12.659983,
            54.439953,
            45.354204
          ],
          [
            12.659949,
            54.43977,
            45.36823
          ],
          [
            12.659915,
            54.43955,
            45.385025
          ],
          [
            12.659889,
            54.439328,
            45.278811
          ],
          [
            12.659846,
            54.439111,
            45.061722
          ],
          [
            12.659834,
            54.438925,
            44.87665
          ],
          [
            12.659795,
            54.43874,
            44.691417
          ],
          [
            12.659732,
            54.438514,
            44.463997
          ],
          [
            12.659683,
            54.438302,
            44.25136
          ],
          [
            12.659864,
            54.438105,
            44.02194
          ],
          [
            12.660175,
            54.438001,
            43.813842
          ],
          [
            12.660532,
            54.43793,
            43.630835
          ],
          [
            12.660894,
            54.437857,
            44.106756
          ],
          [
            12.661239,
            54.437785,
            44.561915
          ],
          [
            12.661595,
            54.437723,
            45.023473
          ],
          [
            12.661918,
            54.437601,
            45.501671
          ],
          [
            12.662269,
            54.437463,
            46.027998
          ],
          [
            12.662629,
            54.437322,
            46.566898
          ],
          [
            12.66297,
            54.437168,
            47.103659
          ],
          [
            12.66333,
            54.437027,
            47.286501
          ],
          [
            12.66366,
            54.436912,
            46.896067
          ],
          [
            12.663975,
            54.436778,
            46.499534
          ],
          [
            12.664281,
            54.436665,
            46.131515
          ],
          [
            12.664592,
            54.436544,
            45.751047
          ],
          [
            12.664897,
            54.436421,
            45.374084
          ],
          [
            12.665104,
            54.436275,
            45.043078
          ],
          [
            12.665179,
            54.436083,
            44.697367
          ],
          [
            12.665126,
            54.435887,
            44.350039
          ],
          [
            12.665058,
            54.435675,
            44.647957
          ],
          [
            12.664977,
            54.435471,
            45.019069
          ],
          [
            12.664924,
            54.435262,
            45.393532
          ],
          [
            12.664837,
            54.435056,
            45.769395
          ],
          [
            12.664729,
            54.434821,
            46.200395
          ],
          [
            12.664637,
            54.434592,
            46.617124
          ],
          [
            12.664554,
            54.434346,
            47.061299
          ],
          [
            12.664456,
            54.43411,
            47.491474
          ],
          [
            12.6644,
            54.433899,
            47.217429
          ],
          [
            12.664323,
            54.433695,
            46.943473
          ],
          [
            12.664204,
            54.433492,
            46.662204
          ],
          [
            12.664052,
            54.433289,
            46.371521
          ],
          [
            12.66384,
            54.433077,
            46.049864
          ],
          [
            12.663663,
            54.432884,
            45.762763
          ],
          [
            12.663463,
            54.432688,
            45.463849
          ],
          [
            12.663289,
            54.432477,
            45.156952
          ],
          [
            12.663274,
            54.432224,
            44.960196
          ],
          [
            12.663415,
            54.432055,
            44.822609
          ],
          [
            12.663595,
            54.431839,
            44.647534
          ],
          [
            12.663749,
            54.431653,
            44.495763
          ],
          [
            12.663869,
            54.431454,
            44.341809
          ],
          [
            12.66398,
            54.431243,
            44.180423
          ],
          [
            12.664159,
            54.431046,
            44.017507
          ],
          [
            12.664447,
            54.430908,
            43.859097
          ],
          [
            12.664787,
            54.430774,
            43.76958
          ],
          [
            12.665118,
            54.430633,
            43.701241
          ],
          [
            12.665432,
            54.430501,
            43.636729
          ],
          [
            12.665782,
            54.430344,
            43.563142
          ],
          [
            12.666132,
            54.430188,
            43.489731
          ],
          [
            12.66641,
            54.430033,
            43.425617
          ],
          [
            12.666749,
            54.429871,
            43.352573
          ],
          [
            12.667081,
            54.429695,
            43.534292
          ],
          [
            12.667437,
            54.429534,
            44.065115
          ],
          [
            12.667772,
            54.429388,
            44.557883
          ],
          [
            12.668051,
            54.429243,
            44.997996
          ],
          [
            12.668333,
            54.429093,
            45.447635
          ],
          [
            12.668601,
            54.428949,
            45.877043
          ],
          [
            12.668861,
            54.428767,
            46.355538
          ],
          [
            12.669052,
            54.428564,
            46.823577
          ],
          [
            12.669213,
            54.428345,
            46.312692
          ],
          [
            12.669399,
            54.428128,
            45.443627
          ],
          [
            12.669583,
            54.427918,
            44.602623
          ],
          [
            12.66953,
            54.427715,
            43.847931
          ],
          [
            12.66934,
            54.427521,
            43.051234
          ],
          [
            12.669206,
            54.427356,
            42.400323
          ],
          [
            12.668994,
            54.427215,
            41.730427
          ],
          [
            12.668781,
            54.427053,
            41.003265
          ],
          [
            12.668545,
            54.426871,
            40.385257
          ],
          [
            12.668306,
            54.426714,
            40.060075
          ],
          [
            12.668108,
            54.42656,
            39.76319
          ],
          [
            12.667877,
            54.426382,
            39.418504
          ],
          [
            12.667602,
            54.426218,
            39.064887
          ],
          [
            12.667331,
            54.426056,
            38.716383
          ],
          [
            12.667044,
            54.425878,
            38.33965
          ],
          [
            12.666755,
            54.425706,
            37.968637
          ],
          [
            12.666467,
            54.42553,
            37.972331
          ],
          [
            12.666179,
            54.425374,
            38.419636
          ],
          [
            12.665898,
            54.425206,
            38.877791
          ],
          [
            12.665628,
            54.425031,
            39.337195
          ],
          [
            12.665329,
            54.424844,
            39.836163
          ],
          [
            12.665088,
            54.424705,
            40.221929
          ],
          [
            12.664795,
            54.424519,
            40.714843
          ],
          [
            12.664507,
            54.424335,
            41.201273
          ],
          [
            12.664281,
            54.424197,
            41.213929
          ],
          [
            12.664053,
            54.424057,
            41.137567
          ],
          [
            12.663809,
            54.423876,
            41.046526
          ],
          [
            12.663544,
            54.423724,
            40.960799
          ],
          [
            12.663317,
            54.423572,
            40.881089
          ],
          [
            12.663088,
            54.423393,
            40.792772
          ],
          [
            12.6629,
            54.423224,
            40.712827
          ],
          [
            12.662733,
            54.423037,
            40.62942
          ],
          [
            12.662566,
            54.422874,
            40.579947
          ],
          [
            12.662378,
            54.422667,
            40.771458
          ],
          [
            12.662246,
            54.422491,
            40.927303
          ],
          [
            12.662109,
            54.422295,
            41.099014
          ],
          [
            12.661955,
            54.422105,
            41.269737
          ],
          [
            12.661813,
            54.421915,
            41.437892
          ],
          [
            12.661655,
            54.421732,
            41.604129
          ],
          [
            12.661505,
            54.421548,
            41.769398
          ],
          [
            12.661345,
            54.421327,
            41.964091
          ],
          [
            12.661193,
            54.421147,
            41.986135
          ],
          [
            12.661058,
            54.420962,
            41.92969
          ],
          [
            12.660925,
            54.420741,
            41.86396
          ],
          [
            12.660796,
            54.420519,
            41.798166
          ],
          [
            12.660644,
            54.420307,
            41.733682
          ],
          [
            12.660508,
            54.420066,
            41.662409
          ],
          [
            12.660404,
            54.419867,
            41.603966
          ],
          [
            12.660339,
            54.419652,
            41.54247
          ],
          [
            12.660275,
            54.419439,
            41.384039
          ],
          [
            12.660208,
            54.419256,
            41.187469
          ],
          [
            12.66015,
            54.419064,
            40.982476
          ],
          [
            12.660107,
            54.418861,
            40.767552
          ],
          [
            12.660033,
            54.418606,
            40.495753
          ],
          [
            12.659978,
            54.418421,
            40.297851
          ],
          [
            12.659972,
            54.418232,
            40.099258
          ],
          [
            12.659923,
            54.41801,
            39.863929
          ],
          [
            12.659908,
            54.41776,
            39.695312
          ],
          [
            12.659886,
            54.417547,
            40.26082
          ],
          [
            12.659892,
            54.417377,
            40.821129
          ],
          [
            12.66005,
            54.417186,
            41.383589
          ],
          [
            12.660081,
            54.416963,
            41.984152
          ],
          [
            12.660094,
            54.41671,
            42.660714
          ],
          [
            12.660202,
            54.416465,
            43.330991
          ],
          [
            12.660306,
            54.416259,
            43.900906
          ],
          [
            12.660456,
            54.41603,
            44.242708
          ],
          [
            12.660583,
            54.415817,
            43.662459
          ],
          [
            12.660675,
            54.415625,
            43.147881
          ],
          [
            12.660799,
            54.415398,
            42.535209
          ],
          [
            12.660953,
            54.415223,
            42.028744
          ],
          [
            12.661056,
            54.415047,
            41.541243
          ],
          [
            12.661183,
            54.414832,
            40.956495
          ],
          [
            12.661286,
            54.414652,
            40.46781
          ],
          [
            12.66141,
            54.414435,
            39.878265
          ],
          [
            12.661564,
            54.414211,
            39.78326
          ],
          [
            12.661675,
            54.414027,
            39.798162
          ],
          [
            12.661816,
            54.413865,
            39.812158
          ],
          [
            12.661933,
            54.413661,
            39.828598
          ],
          [
            12.662037,
            54.413478,
            39.843332
          ],
          [
            12.662131,
            54.413291,
            39.858221
          ],
          [
            12.662244,
            54.413108,
            39.873076
          ],
          [
            12.662384,
            54.412923,
            39.888519
          ],
          [
            12.662493,
            54.412741,
            39.903263
          ],
          [
            12.662598,
            54.412553,
            39.995301
          ],
          [
            12.662717,
            54.412376,
            40.096276
          ],
          [
            12.662851,
            54.412193,
            40.202168
          ],
          [
            12.662948,
            54.412013,
            40.302683
          ],
          [
            12.663041,
            54.41183,
            40.404269
          ],
          [
            12.663189,
            54.411624,
            40.522891
          ],
          [
            12.663353,
            54.411435,
            40.635392
          ],
          [
            12.663464,
            54.411253,
            40.738742
          ],
          [
            12.663589,
            54.411078,
            40.839611
          ],
          [
            12.663773,
            54.410838,
            40.761732
          ],
          [
            12.663944,
            54.410677,
            40.676964
          ],
          [
            12.664076,
            54.410504,
            40.592417
          ],
          [
            12.664258,
            54.410309,
            40.493353
          ],
          [
            12.664506,
            54.41009,
            40.376263
          ],
          [
            12.664722,
            54.409899,
            40.274188
          ],
          [
            12.664923,
            54.409707,
            40.173821
          ],
          [
            12.665139,
            54.409504,
            40.06694
          ],
          [
            12.665399,
            54.409359,
            40.339878
          ],
          [
            12.665382,
            54.409189,
            40.632598
          ],
          [
            12.66523,
            54.40899,
            40.957299
          ],
          [
            12.6652,
            54.408783,
            41.268378
          ],
          [
            12.665268,
            54.408594,
            41.554261
          ],
          [
            12.665463,
            54.408419,
            41.86222
          ],
          [
            12.665697,
            54.408274,
            42.156665
          ],
          [
            12.665934,
            54.408067,
            42.52613
          ],
          [
            12.666117,
            54.407908,
            42.782178
          ],
          [
            12.666316,
            54.407755,
            42.986389
          ],
          [
            12.666529,
            54.407612,
            43.18801
          ],
          [
            12.666706,
            54.407457,
            43.386112
          ],
          [
            12.666951,
            54.407289,
            43.620617
          ],
          [
            12.667146,
            54.407133,
            43.82617
          ],
          [
            12.66736,
            54.406964,
            44.049671
          ],
          [
            12.667575,
            54.406783,
            44.283777
          ],
          [
            12.667792,
            54.406607,
            44.514425
          ],
          [
            12.667986,
            54.406407,
            44.650044
          ],
          [
            12.668204,
            54.406245,
            44.688285
          ],
          [
            12.668403,
            54.40609,
            44.724249
          ],
          [
            12.6686,
            54.405935,
            44.760076
          ],
          [
            12.668821,
            54.405766,
            44.799644
          ],
          [
            12.669039,
            54.405605,
            44.837739
          ],
          [
            12.669271,
            54.405439,
            44.87752
          ],
          [
            12.669583,
            54.405286,
            44.921676
          ],
          [
            12.669905,
            54.405177,
            44.943399
          ],
          [
            12.67022,
            54.405113,
            44.123603
          ],
          [
            12.670582,
            54.405055,
            43.205631
          ],
          [
            12.670793,
            54.404855,
            42.162312
          ],
          [
            12.671042,
            54.404641,
            41.075259
          ],
          [
            12.671261,
            54.404446,
            40.095062
          ],
          [
            12.671464,
            54.404288,
            39.261718
          ],
          [
            12.671706,
            54.404109,
            38.304716
          ],
          [
            12.671894,
            54.403954,
            37.507766
          ],
          [
            12.672084,
            54.403808,
            37.728269
          ],
          [
            12.672303,
            54.403597,
            38.226188
          ],
          [
            12.67256,
            54.403389,
            38.743275
          ],
          [
            12.672784,
            54.403192,
            39.22137
          ],
          [
            12.672958,
            54.40298,
            39.695695
          ],
          [
            12.673113,
            54.40277,
            40.15717
          ],
          [
            12.673226,
            54.402538,
            40.644174
          ],
          [
            12.673302,
            54.402337,
            41.068347
          ],
          [
            12.673356,
            54.40213,
            41.65107
          ],
          [
            12.673373,
            54.401911,
            42.261901
          ],
          [
            12.673385,
            54.401695,
            42.866541
          ],
          [
            12.673414,
            54.401501,
            43.408601
          ],
          [
            12.673451,
            54.401312,
            43.938316
          ],
          [
            12.673469,
            54.401106,
            44.514251
          ],
          [
            12.673444,
            54.400883,
            45.136207
          ],
          [
            12.673447,
            54.400666,
            45.740794
          ],
          [
            12.673444,
            54.400435,
            46.430097
          ],
          [
            12.673459,
            54.400205,
            47.157661
          ],
          [
            12.673476,
            54.399989,
            47.84126
          ],
          [
            12.673484,
            54.399757,
            48.574765
          ],
          [
            12.673493,
            54.399521,
            49.321756
          ],
          [
            12.673509,
            54.399295,
            50.038605
          ],
          [
            12.673468,
            54.399054,
            50.804742
          ],
          [
            12.67344,
            54.398812,
            51.571451
          ],
          [
            12.673479,
            54.398574,
            51.715
          ],
          [
            12.673446,
            54.398324,
            51.698318
          ],
          [
            12.673424,
            54.398092,
            51.682849
          ],
          [
            12.673462,
            54.39785,
            51.66666
          ],
          [
            12.673455,
            54.397613,
            51.650887
          ],
          [
            12.67345,
            54.397373,
            51.634919
          ],
          [
            12.673446,
            54.397127,
            51.618548
          ],
          [
            12.673444,
            54.396902,
            51.323072
          ],
          [
            12.673457,
            54.396706,
            50.472116
          ],
          [
            12.673483,
            54.396484,
            49.504123
          ],
          [
            12.673498,
            54.396241,
            48.450432
          ],
          [
            12.673437,
            54.396024,
            47.498725
          ],
          [
            12.673453,
            54.395785,
            46.45837
          ],
          [
            12.673508,
            54.395543,
            45.401923
          ],
          [
            12.673561,
            54.395298,
            44.333017
          ],
          [
            12.673604,
            54.3951,
            43.740242
          ],
          [
            12.673625,
            54.394891,
            43.524708
          ],
          [
            12.673657,
            54.394678,
            43.304392
          ],
          [
            12.673647,
            54.394466,
            43.086053
          ],
          [
            12.673662,
            54.394235,
            42.847809
          ],
          [
            12.673667,
            54.394001,
            42.606502
          ],
          [
            12.673647,
            54.393759,
            42.356737
          ],
          [
            12.673651,
            54.393509,
            42.09934
          ],
          [
            12.673637,
            54.3933,
            41.970475
          ],
          [
            12.673638,
            54.393059,
            41.963068
          ],
          [
            12.673645,
            54.392818,
            41.955656
          ],
          [
            12.673657,
            54.392574,
            41.948153
          ],
          [
            12.67363,
            54.392342,
            41.94099
          ],
          [
            12.673508,
            54.392126,
            41.933877
          ],
          [
            12.673503,
            54.39191,
            41.927202
          ],
          [
            12.673524,
            54.391673,
            41.919894
          ],
          [
            12.673432,
            54.39142,
            41.864519
          ],
          [
            12.673479,
            54.391214,
            41.805869
          ],
          [
            12.673642,
            54.390997,
            41.740411
          ],
          [
            12.673648,
            54.390775,
            41.679152
          ],
          [
            12.673647,
            54.390542,
            41.614834
          ],
          [
            12.673654,
            54.3903,
            41.548088
          ],
          [
            12.673615,
            54.390068,
            41.483824
          ],
          [
            12.673593,
            54.389832,
            41.458492
          ],
          [
            12.673481,
            54.38962,
            42.121467
          ],
          [
            12.673408,
            54.389437,
            42.689892
          ],
          [
            12.673378,
            54.389228,
            43.313167
          ],
          [
            12.673399,
            54.389026,
            43.914271
          ],
          [
            12.673418,
            54.388817,
            44.536779
          ],
          [
            12.673437,
            54.388631,
            45.090236
          ],
          [
            12.673464,
            54.388412,
            45.743565
          ],
          [
            12.673477,
            54.388173,
            46.454585
          ],
          [
            12.673509,
            54.387933,
            46.818453
          ],
          [
            12.673503,
            54.387681,
            46.918096
          ],
          [
            12.673532,
            54.387449,
            47.010095
          ],
          [
            12.673542,
            54.387217,
            47.101905
          ],
          [
            12.673522,
            54.386977,
            47.196916
          ],
          [
            12.673501,
            54.386735,
            47.292707
          ],
          [
            12.673513,
            54.386496,
            47.38735
          ],
          [
            12.673489,
            54.386263,
            47.478605
          ],
          [
            12.673508,
            54.38605,
            47.54187
          ],
          [
            12.673504,
            54.385805,
            47.614581
          ],
          [
            12.673505,
            54.385562,
            47.686703
          ],
          [
            12.673467,
            54.385378,
            47.741992
          ],
          [
            12.673463,
            54.385124,
            47.817397
          ],
          [
            12.67348,
            54.38493,
            47.87502
          ],
          [
            12.673462,
            54.384717,
            47.938302
          ],
          [
            12.67351,
            54.384498,
            48.00379
          ],
          [
            12.67354,
            54.384277,
            47.553424
          ],
          [
            12.673519,
            54.384054,
            47.055472
          ],
          [
            12.673513,
            54.38383,
            46.556413
          ],
          [
            12.673419,
            54.383643,
            46.107694
          ],
          [
            12.673391,
            54.383408,
            45.582972
          ],
          [
            12.673365,
            54.38316,
            45.027359
          ],
          [
            12.673312,
            54.382897,
            44.437305
          ],
          [
            12.673273,
            54.382642,
            43.898663
          ],
          [
            12.673236,
            54.382455,
            43.576236
          ],
          [
            12.67318,
            54.382265,
            43.246236
          ],
          [
            12.67313,
            54.382046,
            42.868078
          ],
          [
            12.673062,
            54.38185,
            42.525731
          ],
          [
            12.673,
            54.381656,
            42.187982
          ],
          [
            12.672948,
            54.381467,
            41.860362
          ],
          [
            12.672924,
            54.381261,
            41.506949
          ],
          [
            12.672893,
            54.381045,
            41.135803
          ],
          [
            12.672884,
            54.380845,
            40.973073
          ],
          [
            12.672831,
            54.380637,
            41.105166
          ],
          [
            12.672793,
            54.380443,
            41.227887
          ],
          [
            12.67276,
            54.380217,
            41.370364
          ],
          [
            12.672715,
            54.380014,
            41.498942
          ],
          [
            12.672654,
            54.379812,
            41.627782
          ],
          [
            12.672625,
            54.379616,
            41.751363
          ],
          [
            12.672572,
            54.379426,
            41.872282
          ],
          [
            12.672519,
            54.379238,
            41.992045
          ],
          [
            12.672499,
            54.379029,
            41.975794
          ],
          [
            12.67248,
            54.378808,
            41.816887
          ],
          [
            12.67248,
            54.3786,
            41.666757
          ],
          [
            12.67246,
            54.378403,
            41.525119
          ],
          [
            12.672356,
            54.378213,
            41.37488
          ],
          [
            12.672332,
            54.378009,
            41.22807
          ],
          [
            12.672267,
            54.377825,
            41.093243
          ],
          [
            12.672195,
            54.377619,
            40.942239
          ],
          [
            12.672154,
            54.377415,
            40.794836
          ],
          [
            12.672095,
            54.377187,
            41.075439
          ],
          [
            12.672071,
            54.376984,
            41.413883
          ],
          [
            12.672011,
            54.37678,
            41.758394
          ],
          [
            12.671976,
            54.376581,
            42.091213
          ],
          [
            12.671908,
            54.376356,
            42.471105
          ],
          [
            12.671851,
            54.376144,
            42.828176
          ],
          [
            12.67182,
            54.375932,
            43.183136
          ],
          [
            12.671761,
            54.375721,
            43.538699
          ],
          [
            12.671726,
            54.375514,
            43.654379
          ],
          [
            12.671679,
            54.37532,
            43.403366
          ],
          [
            12.671685,
            54.375136,
            43.167507
          ],
          [
            12.671657,
            54.374938,
            42.912922
          ],
          [
            12.671608,
            54.374723,
            42.634983
          ],
          [
            12.671567,
            54.374521,
            42.374409
          ],
          [
            12.671548,
            54.374321,
            42.117816
          ],
          [
            12.67154,
            54.374108,
            41.844768
          ],
          [
            12.67152,
            54.373903,
            41.581744
          ],
          [
            12.671502,
            54.373689,
            41.289057
          ],
          [
            12.671502,
            54.373484,
            40.993536
          ],
          [
            12.67145,
            54.373273,
            40.686256
          ],
          [
            12.671428,
            54.373031,
            40.336279
          ],
          [
            12.671421,
            54.372811,
            40.019099
          ],
          [
            12.671441,
            54.372601,
            39.715924
          ],
          [
            12.671474,
            54.372376,
            39.390389
          ],
          [
            12.67149,
            54.372135,
            39.042684
          ],
          [
            12.671455,
            54.371919,
            38.843383
          ],
          [
            12.671442,
            54.371707,
            38.808735
          ],
          [
            12.671455,
            54.371499,
            38.774711
          ],
          [
            12.671451,
            54.371305,
            38.742907
          ],
          [
            12.671455,
            54.371097,
            38.708956
          ],
          [
            12.67147,
            54.370912,
            38.678729
          ],
          [
            12.671467,
            54.370725,
            38.64821
          ],
          [
            12.671493,
            54.370502,
            38.611736
          ],
          [
            12.671488,
            54.370297,
            38.578263
          ],
          [
            12.671484,
            54.370098,
            38.830874
          ],
          [
            12.671486,
            54.369881,
            39.339084
          ],
          [
            12.671468,
            54.369645,
            39.892203
          ],
          [
            12.671445,
            54.369418,
            40.424631
          ],
          [
            12.671434,
            54.369168,
            41.010262
          ],
          [
            12.67144,
            54.368933,
            41.560553
          ],
          [
            12.671376,
            54.368718,
            42.071567
          ],
          [
            12.671247,
            54.368543,
            42.540233
          ],
          [
            12.671061,
            54.368386,
            42.783821
          ],
          [
            12.671039,
            54.368158,
            42.801518
          ],
          [
            12.671035,
            54.367942,
            42.818279
          ],
          [
            12.67099,
            54.367731,
            42.834752
          ],
          [
            12.670931,
            54.367535,
            42.850202
          ],
          [
            12.670927,
            54.367342,
            42.865208
          ],
          [
            12.670886,
            54.367134,
            42.881424
          ],
          [
            12.670948,
            54.366935,
            42.897089
          ],
          [
            12.670999,
            54.366751,
            42.9116
          ],
          [
            12.671079,
            54.366544,
            42.377819
          ],
          [
            12.671232,
            54.36632,
            41.610392
          ],
          [
            12.671327,
            54.366101,
            40.889649
          ],
          [
            12.671461,
            54.365907,
            40.22414
          ],
          [
            12.671592,
            54.365687,
            39.483065
          ],
          [
            12.671762,
            54.365502,
            38.785309
          ],
          [
            12.671981,
            54.365357,
            38.161183
          ],
          [
            12.672146,
            54.365159,
            37.460227
          ],
          [
            12.672543,
            54.365133,
            38.291875
          ],
          [
            12.672934,
            54.36511,
            39.985707
          ],
          [
            12.673314,
            54.365126,
            41.624549
          ],
          [
            12.673643,
            54.365147,
            43.048737
          ],
          [
            12.673968,
            54.365147,
            44.446415
          ],
          [
            12.674279,
            54.365198,
            45.838996
          ],
          [
            12.674616,
            54.365219,
            47.298477
          ],
          [
            12.674974,
            54.365246,
            48.862563
          ],
          [
            12.67535,
            54.365325,
            50.452773
          ],
          [
            12.675754,
            54.365408,
            50.270445
          ],
          [
            12.676079,
            54.365426,
            50.130003
          ],
          [
            12.676442,
            54.365423,
            49.975343
          ],
          [
            12.676798,
            54.365442,
            49.82306
          ],
          [
            12.677178,
            54.365464,
            49.659978
          ],
          [
            12.677503,
            54.365439,
            49.51321
          ],
          [
            12.677891,
            54.365471,
            49.346425
          ],
          [
            12.678221,
            54.365526,
            49.200346
          ],
          [
            12.678559,
            54.365475,
            48.378953
          ],
          [
            12.678903,
            54.365531,
            47.215966
          ],
          [
            12.679226,
            54.365593,
            46.104117
          ],
          [
            12.679556,
            54.365582,
            45.027284
          ],
          [
            12.679998,
            54.365621,
            43.570005
          ],
          [
            12.680359,
            54.365712,
            42.28919
          ],
          [
            12.680761,
            54.365751,
            40.959635
          ],
          [
            12.681209,
            54.365761,
            39.499633
          ],
          [
            12.681624,
            54.36579,
            39.696448
          ],
          [
            12.682043,
            54.365811,
            40.546657
          ],
          [
            12.682371,
            54.365861,
            41.234565
          ],
          [
            12.682746,
            54.365892,
            42.009239
          ],
          [
            12.683114,
            54.365904,
            42.754534
          ],
          [
            12.683585,
            54.365893,
            43.709436
          ],
          [
            12.683949,
            54.365953,
            44.474795
          ],
          [
            12.684326,
            54.366,
            45.278037
          ],
          [
            12.684739,
            54.366061,
            45.011929
          ],
          [
            12.685194,
            54.366078,
            44.632182
          ],
          [
            12.685632,
            54.366084,
            44.267315
          ],
          [
            12.685959,
            54.366096,
            43.994519
          ],
          [
            12.686285,
            54.366116,
            43.721462
          ],
          [
            12.686619,
            54.36614,
            43.44104
          ],
          [
            12.686981,
            54.366196,
            43.129073
          ],
          [
            12.68734,
            54.366267,
            42.813112
          ],
          [
            12.687674,
            54.366312,
            42.589426
          ],
          [
            12.688059,
            54.366353,
            42.346663
          ],
          [
            12.688479,
            54.366392,
            42.080727
          ],
          [
            12.688864,
            54.366421,
            41.839915
          ],
          [
            12.689251,
            54.366457,
            41.596842
          ],
          [
            12.689608,
            54.366497,
            41.37147
          ],
          [
            12.690039,
            54.366544,
            41.099685
          ],
          [
            12.690432,
            54.366603,
            40.859154
          ],
          [
            12.690781,
            54.366651,
            40.906968
          ],
          [
            12.691146,
            54.366708,
            40.957333
          ],
          [
            12.691471,
            54.366756,
            41.002044
          ],
          [
            12.691771,
            54.36681,
            41.043893
          ],
          [
            12.6921,
            54.366856,
            41.088985
          ],
          [
            12.692415,
            54.3669,
            41.132155
          ],
          [
            12.692788,
            54.366952,
            41.183275
          ],
          [
            12.693155,
            54.366982,
            41.232848
          ],
          [
            12.693256,
            54.367099,
            41.230081
          ],
          [
            12.69361,
            54.367183,
            40.999011
          ],
          [
            12.693964,
            54.367253,
            40.773787
          ],
          [
            12.694299,
            54.367307,
            40.564366
          ],
          [
            12.694631,
            54.36735,
            40.359384
          ],
          [
            12.694944,
            54.367397,
            40.164265
          ],
          [
            12.695285,
            54.367444,
            39.952839
          ],
          [
            12.695689,
            54.367512,
            39.699443
          ],
          [
            12.696118,
            54.367577,
            39.432292
          ],
          [
            12.696515,
            54.367633,
            39.609503
          ],
          [
            12.696932,
            54.367691,
            39.843546
          ],
          [
            12.697328,
            54.367745,
            40.064913
          ],
          [
            12.697686,
            54.367792,
            40.264695
          ],
          [
            12.698017,
            54.367836,
            40.449478
          ],
          [
            12.698354,
            54.367877,
            40.636853
          ],
          [
            12.698744,
            54.367945,
            40.858735
          ],
          [
            12.699121,
            54.367989,
            41.067995
          ],
          [
            12.699477,
            54.368027,
            40.998898
          ],
          [
            12.699843,
            54.368068,
            40.895246
          ],
          [
            12.70022,
            54.368122,
            40.787275
          ],
          [
            12.700577,
            54.368177,
            40.684589
          ],
          [
            12.70095,
            54.368225,
            40.578364
          ],
          [
            12.701349,
            54.368268,
            40.46553
          ],
          [
            12.701706,
            54.368312,
            40.363943
          ],
          [
            12.702064,
            54.368355,
            40.262278
          ],
          [
            12.702436,
            54.368397,
            40.055849
          ],
          [
            12.702843,
            54.368404,
            39.787376
          ],
          [
            12.703242,
            54.368427,
            39.52253
          ],
          [
            12.703643,
            54.368455,
            39.255922
          ],
          [
            12.704066,
            54.368472,
            38.976018
          ],
          [
            12.704378,
            54.368474,
            38.769856
          ],
          [
            12.70481,
            54.368486,
            38.484686
          ],
          [
            12.705239,
            54.368503,
            38.200936
          ],
          [
            12.705651,
            54.368486,
            37.709577
          ],
          [
            12.705989,
            54.368486,
            37.305396
          ],
          [
            12.706404,
            54.3685,
            36.805513
          ],
          [
            12.706758,
            54.368513,
            36.381374
          ],
          [
            12.707095,
            54.368508,
            35.978018
          ],
          [
            12.707436,
            54.368509,
            35.570137
          ],
          [
            12.70779,
            54.368495,
            35.145801
          ],
          [
            12.708131,
            54.368492,
            34.737957
          ],
          [
            12.708451,
            54.368488,
            34.546052
          ],
          [
            12.708775,
            54.368491,
            34.658518
          ],
          [
            12.70917,
            54.368493,
            34.795743
          ],
          [
            12.709632,
            54.368503,
            34.956421
          ],
          [
            12.710012,
            54.368497,
            35.08834
          ],
          [
            12.710439,
            54.368477,
            35.237007
          ],
          [
            12.710772,
            54.368469,
            35.352966
          ],
          [
            12.71117,
            54.368471,
            35.491166
          ],
          [
            12.711505,
            54.368461,
            35.719219
          ],
          [
            12.711852,
            54.368451,
            36.248005
          ],
          [
            12.712169,
            54.36845,
            36.730574
          ],
          [
            12.71256,
            54.368451,
            37.326012
          ],
          [
            12.712962,
            54.36845,
            37.936512
          ],
          [
            12.71341,
            54.368457,
            38.619664
          ],
          [
            12.713802,
            54.36844,
            39.216606
          ],
          [
            12.714203,
            54.368431,
            39.825998
          ],
          [
            12.71461,
            54.368426,
            40.333511
          ],
          [
            12.714998,
            54.36843,
            40.562988
          ],
          [
            12.715388,
            54.368429,
            40.793606
          ],
          [
            12.715766,
            54.368425,
            41.017196
          ],
          [
            12.7162,
            54.368452,
            41.275927
          ],
          [
            12.716589,
            54.368439,
            41.506336
          ],
          [
            12.716961,
            54.368419,
            41.727925
          ],
          [
            12.717265,
            54.368311,
            41.939039
          ],
          [
            12.717647,
            54.368327,
            42.026245
          ],
          [
            12.718039,
            54.368332,
            41.838992
          ],
          [
            12.718392,
            54.368341,
            41.670215
          ],
          [
            12.71875,
            54.368346,
            41.499195
          ],
          [
            12.719102,
            54.368359,
            41.330407
          ],
          [
            12.719445,
            54.368392,
            41.164168
          ],
          [
            12.719796,
            54.368418,
            40.995187
          ],
          [
            12.720166,
            54.368448,
            40.816753
          ],
          [
            12.720521,
            54.368472,
            40.646033
          ],
          [
            12.720883,
            54.368481,
            40.598511
          ],
          [
            12.721214,
            54.368526,
            40.58062
          ],
          [
            12.721538,
            54.368591,
            40.56226
          ],
          [
            12.721874,
            54.368616,
            40.544437
          ],
          [
            12.722227,
            54.368642,
            40.525586
          ],
          [
            12.722619,
            54.368662,
            40.504833
          ],
          [
            12.722989,
            54.368697,
            40.485088
          ],
          [
            12.723325,
            54.368728,
            40.467193
          ],
          [
            12.723648,
            54.368759,
            40.515629
          ],
          [
            12.72398,
            54.368823,
            41.233101
          ],
          [
            12.724328,
            54.36885,
            41.93941
          ],
          [
            12.724653,
            54.36884,
            42.602559
          ],
          [
            12.724973,
            54.368836,
            43.245635
          ],
          [
            12.725284,
            54.368813,
            43.875357
          ],
          [
            12.725165,
            54.368885,
            44.510068
          ],
          [
            12.725267,
            54.369052,
            45.36728
          ],
          [
            12.725292,
            54.368857,
            46.041539
          ],
          [
            12.725276,
            54.368647,
            46.731679
          ],
          [
            12.7253,
            54.368453,
            47.150084
          ],
          [
            12.725309,
            54.368261,
            47.564252
          ],
          [
            12.725296,
            54.368037,
            48.046444
          ],
          [
            12.725282,
            54.367809,
            48.538514
          ],
          [
            12.725362,
            54.3676,
            48.999533
          ],
          [
            12.725435,
            54.367404,
            49.430999
          ],
          [
            12.725453,
            54.367201,
            49.86933
          ],
          [
            12.725461,
            54.367002,
            50.298998
          ],
          [
            12.725475,
            54.366806,
            50.105552
          ],
          [
            12.725587,
            54.366785,
            49.285301
          ],
          [
            12.72582,
            54.366878,
            48.364632
          ],
          [
            12.725601,
            54.366747,
            47.501122
          ],
          [
            12.725559,
            54.366558,
            46.618385
          ],
          [
            12.725571,
            54.366368,
            45.758872
          ],
          [
            12.72552,
            54.366159,
            44.803896
          ],
          [
            12.725486,
            54.365945,
            43.832289
          ],
          [
            12.725489,
            54.365742,
            42.913623
          ],
          [
            12.725538,
            54.36552,
            42.286913
          ],
          [
            12.725656,
            54.365333,
            42.092914
          ],
          [
            12.725733,
            54.365129,
            41.88941
          ],
          [
            12.725697,
            54.364944,
            41.694854
          ],
          [
            12.725317,
            54.364926,
            41.478576
          ],
          [
            12.724989,
            54.364884,
            41.288065
          ],
          [
            12.724658,
            54.36485,
            41.097396
          ],
          [
            12.724347,
            54.364792,
            40.911787
          ],
          [
            12.724273,
            54.36462,
            40.52385
          ],
          [
            12.724388,
            54.364801,
            40.359604
          ],
          [
            12.724618,
            54.364885,
            40.191824
          ],
          [
            12.724955,
            54.364884,
            40.024808
          ],
          [
            12.725284,
            54.364894,
            39.861456
          ],
          [
            12.725638,
            54.364948,
            39.680017
          ],
          [
            12.725816,
            54.36482,
            39.522803
          ],
          [
            12.725954,
            54.364863,
            39.365255
          ],
          [
            12.725806,
            54.365036,
            39.199237
          ],
          [
            12.725709,
            54.365234,
            38.997214
          ],
          [
            12.725924,
            54.36537,
            38.776924
          ],
          [
            12.72623,
            54.365491,
            38.541051
          ],
          [
            12.726552,
            54.365565,
            38.318238
          ],
          [
            12.726844,
            54.365673,
            38.095311
          ],
          [
            12.727116,
            54.365788,
            37.878068
          ],
          [
            12.727418,
            54.365911,
            37.642901
          ],
          [
            12.727622,
            54.366079,
            37.417436
          ],
          [
            12.727796,
            54.366245,
            37.204481
          ],
          [
            12.72797,
            54.366412,
            37.033578
          ],
          [
            12.72813,
            54.366589,
            36.873863
          ],
          [
            12.728293,
            54.366783,
            36.701305
          ],
          [
            12.728417,
            54.366958,
            36.550207
          ],
          [
            12.728518,
            54.367148,
            36.391468
          ],
          [
            12.728641,
            54.367365,
            36.209005
          ],
          [
            12.728773,
            54.367554,
            36.046009
          ],
          [
            12.728844,
            54.367746,
            35.889164
          ],
          [
            12.728962,
            54.367962,
            35.714778
          ],
          [
            12.729075,
            54.368159,
            35.748163
          ],
          [
            12.729195,
            54.368348,
            35.780545
          ],
          [
            12.729304,
            54.368534,
            35.81228
          ],
          [
            12.729375,
            54.368735,
            35.845384
          ],
          [
            12.729484,
            54.36892,
            35.87689
          ],
          [
            12.729575,
            54.369103,
            35.90772
          ],
          [
            12.729868,
            54.369088,
            35.943188
          ],
          [
            12.729988,
            54.368909,
            35.974074
          ],
          [
            12.730249,
            54.3688,
            36.015159
          ],
          [
            12.730613,
            54.368781,
            36.219758
          ],
          [
            12.730975,
            54.368772,
            36.421882
          ],
          [
            12.731307,
            54.368761,
            36.607401
          ],
          [
            12.731661,
            54.368749,
            36.805237
          ],
          [
            12.732021,
            54.368735,
            37.006464
          ],
          [
            12.732385,
            54.368735,
            37.210193
          ],
          [
            12.732742,
            54.368711,
            37.410884
          ],
          [
            12.733113,
            54.368665,
            37.622494
          ],
          [
            12.733504,
            54.368616,
            37.680363
          ],
          [
            12.733874,
            54.368578,
            37.603922
          ],
          [
            12.734278,
            54.368536,
            37.520417
          ],
          [
            12.734651,
            54.368507,
            37.443835
          ],
          [
            12.735031,
            54.368452,
            37.36406
          ],
          [
            12.73543,
            54.368435,
            37.282648
          ],
          [
            12.735757,
            54.368409,
            37.215468
          ],
          [
            12.736084,
            54.368377,
            37.148002
          ],
          [
            12.736435,
            54.368331,
            37.144282
          ],
          [
            12.736814,
            54.368284,
            37.318873
          ],
          [
            12.737149,
            54.368263,
            37.470631
          ],
          [
            12.737488,
            54.368236,
            37.624577
          ],
          [
            12.737835,
            54.368165,
            37.790163
          ],
          [
            12.738183,
            54.368094,
            37.956052
          ],
          [
            12.73858,
            54.36812,
            38.13894
          ],
          [
            12.738965,
            54.368206,
            38.32449
          ],
          [
            12.739318,
            54.368293,
            38.490115
          ],
          [
            12.739698,
            54.368398,
            38.567854
          ],
          [
            12.740129,
            54.368488,
            38.652416
          ],
          [
            12.740484,
            54.368567,
            38.722621
          ],
          [
            12.740802,
            54.368635,
            38.785189
          ],
          [
            12.741196,
            54.368678,
            38.860323
          ],
          [
            12.741613,
            54.368659,
            38.938285
          ],
          [
            12.742017,
            54.368582,
            39.016804
          ],
          [
            12.742394,
            54.368506,
            38.903865
          ],
          [
            12.742796,
            54.368445,
            38.57356
          ],
          [
            12.74315,
            54.368418,
            38.288945
          ],
          [
            12.743556,
            54.368369,
            37.958853
          ],
          [
            12.743979,
            54.368305,
            37.611402
          ],
          [
            12.7444,
            54.368251,
            37.268388
          ],
          [
            12.744823,
            54.368197,
            36.92412
          ],
          [
            12.745227,
            54.368147,
            36.602667
          ],
          [
            12.745644,
            54.368087,
            36.700115
          ],
          [
            12.746071,
            54.368037,
            36.798895
          ],
          [
            12.746478,
            54.367984,
            36.89362
          ],
          [
            12.746873,
            54.367946,
            36.984804
          ],
          [
            12.747241,
            54.367892,
            37.071025
          ],
          [
            12.747601,
            54.367843,
            37.154869
          ],
          [
            12.747968,
            54.367804,
            37.239476
          ],
          [
            12.748335,
            54.367745,
            37.380099
          ],
          [
            12.74871,
            54.367704,
            37.658355
          ],
          [
            12.749143,
            54.367658,
            37.979526
          ],
          [
            12.749512,
            54.367616,
            38.254233
          ],
          [
            12.749938,
            54.367563,
            38.572928
          ],
          [
            12.750325,
            54.367513,
            38.862081
          ],
          [
            12.750649,
            54.367472,
            39.103918
          ],
          [
            12.750976,
            54.36742,
            39.352005
          ],
          [
            12.751341,
            54.367383,
            39.627917
          ],
          [
            12.751666,
            54.367373,
            39.883542
          ],
          [
            12.751994,
            54.36731,
            40.154125
          ],
          [
            12.752349,
            54.367327,
            40.43408
          ],
          [
            12.752687,
            54.36736,
            40.704806
          ],
          [
            12.753087,
            54.367327,
            41.022034
          ],
          [
            12.753452,
            54.367271,
            41.317778
          ],
          [
            12.753787,
            54.367228,
            41.586809
          ],
          [
            12.75421,
            54.36718,
            41.924416
          ],
          [
            12.754515,
            54.367139,
            41.610791
          ],
          [
            12.754884,
            54.367145,
            41.081742
          ],
          [
            12.755153,
            54.367238,
            40.573794
          ],
          [
            12.755275,
            54.367421,
            40.095917
          ],
          [
            12.755402,
            54.367654,
            39.500679
          ],
          [
            12.755547,
            54.367908,
            38.849599
          ],
          [
            12.755714,
            54.368156,
            38.198996
          ],
          [
            12.755871,
            54.368392,
            37.605808
          ],
          [
            12.755999,
            54.368607,
            37.80321
          ],
          [
            12.756193,
            54.368801,
            37.997607
          ],
          [
            12.756346,
            54.369004,
            38.189862
          ],
          [
            12.756487,
            54.369232,
            38.399646
          ],
          [
            12.756624,
            54.369427,
            38.582899
          ],
          [
            12.756852,
            54.369571,
            38.754462
          ],
          [
            12.757193,
            54.369661,
            38.943941
          ],
          [
            12.757591,
            54.36976,
            39.165269
          ],
          [
            12.757954,
            54.369867,
            39.466562
          ],
          [
            12.758309,
            54.369994,
            39.775461
          ],
          [
            12.758659,
            54.370117,
            40.078056
          ],
          [
            12.759035,
            54.370233,
            40.393284
          ],
          [
            12.759431,
            54.370336,
            40.714516
          ],
          [
            12.759821,
            54.37043,
            41.026929
          ],
          [
            12.760156,
            54.370552,
            41.319432
          ],
          [
            12.76055,
            54.370633,
            41.325653
          ],
          [
            12.760961,
            54.370753,
            41.116558
          ],
          [
            12.761343,
            54.370781,
            40.942095
          ],
          [
            12.761686,
            54.37071,
            40.776649
          ],
          [
            12.762077,
            54.370662,
            40.595748
          ],
          [
            12.762458,
            54.370633,
            40.421733
          ],
          [
            12.762816,
            54.37056,
            40.249964
          ],
          [
            12.763181,
            54.370538,
            40.083838
          ],
          [
            12.763557,
            54.370522,
            39.972059
          ],
          [
            12.76391,
            54.370504,
            39.884289
          ],
          [
            12.764249,
            54.370471,
            39.799153
          ],
          [
            12.764547,
            54.370405,
            39.720219
          ],
          [
            12.7649,
            54.37025,
            39.610491
          ],
          [
            12.765165,
            54.370106,
            39.520725
          ],
          [
            12.765385,
            54.369966,
            39.439573
          ],
          [
            12.765754,
            54.369943,
            39.34728
          ],
          [
            12.766103,
            54.369941,
            39.292263
          ],
          [
            12.76647,
            54.369965,
            39.360474
          ],
          [
            12.766816,
            54.36998,
            39.424303
          ],
          [
            12.767186,
            54.36998,
            39.492294
          ],
          [
            12.767577,
            54.369975,
            39.564218
          ],
          [
            12.767933,
            54.369945,
            39.630783
          ],
          [
            12.768261,
            54.369885,
            39.694081
          ],
          [
            12.768608,
            54.369794,
            39.764079
          ],
          [
            12.768923,
            54.369708,
            39.828062
          ],
          [
            12.76925,
            54.369647,
            39.914844
          ],
          [
            12.769664,
            54.369559,
            40.038556
          ],
          [
            12.770081,
            54.369465,
            40.164086
          ],
          [
            12.770443,
            54.369404,
            40.270249
          ],
          [
            12.770807,
            54.369357,
            40.375065
          ],
          [
            12.77089,
            54.369186,
            40.467563
          ],
          [
            12.770776,
            54.368975,
            40.574097
          ],
          [
            12.770644,
            54.368765,
            40.682236
          ],
          [
            12.770593,
            54.368533,
            41.005549
          ],
          [
            12.7706,
            54.368317,
            41.37396
          ],
          [
            12.770586,
            54.368115,
            41.718666
          ],
          [
            12.770593,
            54.367915,
            42.05985
          ],
          [
            12.770509,
            54.367711,
            42.418609
          ],
          [
            12.770441,
            54.367496,
            42.791362
          ],
          [
            12.770363,
            54.367275,
            43.176432
          ],
          [
            12.770242,
            54.367093,
            43.509426
          ],
          [
            12.77008,
            54.366879,
            43.95345
          ],
          [
            12.769914,
            54.366664,
            44.495549
          ],
          [
            12.769845,
            54.366462,
            44.971994
          ],
          [
            12.76995,
            54.366258,
            45.462733
          ],
          [
            12.770065,
            54.366086,
            45.887377
          ],
          [
            12.77018,
            54.365869,
            46.409373
          ],
          [
            12.770293,
            54.365663,
            46.906469
          ],
          [
            12.770312,
            54.365449,
            47.403687
          ],
          [
            12.770242,
            54.36522,
            47.93013
          ],
          [
            12.77019,
            54.365038,
            48.213157
          ],
          [
            12.770157,
            54.364839,
            48.519896
          ],
          [
            12.770293,
            54.364662,
            48.855321
          ],
          [
            12.770711,
            54.364614,
            49.237604
          ],
          [
            12.771159,
            54.364531,
            49.658164
          ],
          [
            12.771561,
            54.364459,
            50.034562
          ],
          [
            12.771977,
            54.364389,
            50.422496
          ],
          [
            12.772305,
            54.364339,
            50.656137
          ],
          [
            12.772637,
            54.364283,
            50.563199
          ],
          [
            12.772994,
            54.364256,
            50.46639
          ],
          [
            12.773326,
            54.364217,
            50.375273
          ],
          [
            12.773655,
            54.364183,
            50.28541
          ],
          [
            12.774007,
            54.364144,
            50.189065
          ],
          [
            12.774428,
            54.364105,
            50.073968
          ],
          [
            12.774833,
            54.364043,
            49.961376
          ],
          [
            12.775282,
            54.363996,
            49.813497
          ],
          [
            12.775741,
            54.363954,
            48.780501
          ],
          [
            12.776293,
            54.363902,
            47.53972
          ],
          [
            12.776608,
            54.363877,
            46.834339
          ],
          [
            12.776952,
            54.363847,
            46.063186
          ],
          [
            12.777302,
            54.36382,
            45.279565
          ],
          [
            12.777663,
            54.363787,
            44.46912
          ],
          [
            12.778033,
            54.363767,
            43.645276
          ],
          [
            12.778409,
            54.363728,
            42.987025
          ],
          [
            12.778763,
            54.363693,
            42.942929
          ],
          [
            12.779148,
            54.363662,
            42.895314
          ],
          [
            12.779528,
            54.363623,
            42.848062
          ],
          [
            12.7799,
            54.363595,
            42.802119
          ],
          [
            12.780262,
            54.363572,
            42.757515
          ],
          [
            12.780615,
            54.363523,
            42.712968
          ],
          [
            12.780934,
            54.363486,
            42.673125
          ],
          [
            12.781242,
            54.363463,
            42.635097
          ],
          [
            12.78173,
            54.363434,
            43.069015
          ],
          [
            12.782086,
            54.36341,
            43.506519
          ],
          [
            12.782512,
            54.363371,
            44.035619
          ],
          [
            12.782888,
            54.363376,
            44.49476
          ],
          [
            12.783273,
            54.363347,
            44.971502
          ],
          [
            12.783595,
            54.363343,
            45.365048
          ],
          [
            12.78396,
            54.363339,
            45.811225
          ],
          [
            12.784303,
            54.363367,
            46.234408
          ],
          [
            12.784788,
            54.363385,
            46.227224
          ],
          [
            12.78533,
            54.363376,
            45.983165
          ],
          [
            12.785716,
            54.363207,
            45.766256
          ],
          [
            12.786133,
            54.363237,
            45.573773
          ],
          [
            12.786474,
            54.363343,
            45.400196
          ],
          [
            12.786807,
            54.363443,
            45.231989
          ],
          [
            12.787132,
            54.363519,
            45.072867
          ],
          [
            12.787446,
            54.363517,
            45.136594
          ],
          [
            12.787809,
            54.363546,
            45.44411
          ],
          [
            12.788194,
            54.36357,
            45.76915
          ],
          [
            12.788579,
            54.363581,
            46.092009
          ],
          [
            12.788893,
            54.363589,
            46.355646
          ],
          [
            12.789242,
            54.363576,
            46.648624
          ],
          [
            12.789639,
            54.363582,
            46.983029
          ],
          [
            12.790031,
            54.363596,
            47.312105
          ],
          [
            12.790349,
            54.363522,
            47.599835
          ],
          [
            12.790544,
            54.36333,
            47.736826
          ],
          [
            12.790851,
            54.363244,
            47.861718
          ],
          [
            12.791176,
            54.36328,
            47.981083
          ],
          [
            12.791517,
            54.363438,
            48.137404
          ],
          [
            12.791832,
            54.363595,
            48.285817
          ],
          [
            12.792172,
            54.363705,
            48.4265
          ],
          [
            12.792497,
            54.363742,
            48.544944
          ],
          [
            12.792833,
            54.363783,
            48.667731
          ],
          [
            12.793176,
            54.363831,
            48.294662
          ],
          [
            12.793522,
            54.363867,
            47.800353
          ],
          [
            12.793853,
            54.363909,
            47.324293
          ],
          [
            12.794194,
            54.363943,
            46.837155
          ],
          [
            12.794495,
            54.364004,
            46.383345
          ],
          [
            12.794879,
            54.364083,
            45.803731
          ],
          [
            12.795201,
            54.364193,
            45.279311
          ],
          [
            12.795521,
            54.364314,
            44.741984
          ],
          [
            12.795852,
            54.364434,
            44.293738
          ],
          [
            12.796312,
            54.364576,
            44.013287
          ],
          [
            12.796715,
            54.364725,
            43.756385
          ],
          [
            12.797,
            54.36482,
            43.579807
          ],
          [
            12.797305,
            54.364919,
            43.391908
          ],
          [
            12.797638,
            54.365021,
            43.189597
          ],
          [
            12.797949,
            54.365112,
            43.002414
          ],
          [
            12.798295,
            54.365219,
            42.791747
          ],
          [
            12.798638,
            54.365333,
            42.284755
          ],
          [
            12.798996,
            54.365445,
            41.510347
          ],
          [
            12.799346,
            54.365561,
            40.743505
          ],
          [
            12.799694,
            54.36568,
            39.974867
          ],
          [
            12.800036,
            54.365779,
            39.247356
          ],
          [
            12.80038,
            54.365841,
            38.561634
          ],
          [
            12.800705,
            54.36595,
            37.847303
          ],
          [
            12.801161,
            54.366073,
            36.889831
          ],
          [
            12.801448,
            54.366155,
            36.574246
          ],
          [
            12.801885,
            54.366247,
            36.17458
          ],
          [
            12.802437,
            54.366234,
            35.697733
          ],
          [
            12.802884,
            54.366204,
            35.31043
          ],
          [
            12.803252,
            54.366112,
            34.952216
          ],
          [
            12.803429,
            54.365956,
            34.675862
          ],
          [
            12.803534,
            54.365702,
            34.290106
          ],
          [
            12.803559,
            54.365472,
            34.241853
          ],
          [
            12.80366,
            54.365276,
            34.355622
          ],
          [
            12.803777,
            54.365051,
            34.486398
          ],
          [
            12.803853,
            54.364863,
            34.59379
          ],
          [
            12.803846,
            54.36463,
            34.724367
          ],
          [
            12.803763,
            54.364427,
            34.840364
          ],
          [
            12.803671,
            54.364231,
            34.953589
          ],
          [
            12.803676,
            54.364014,
            35.074673
          ],
          [
            12.803804,
            54.363818,
            35.15329
          ],
          [
            12.803939,
            54.363595,
            35.120013
          ],
          [
            12.804047,
            54.363368,
            35.086867
          ],
          [
            12.804164,
            54.36312,
            35.050676
          ],
          [
            12.80426,
            54.362905,
            35.019416
          ],
          [
            12.804365,
            54.362686,
            34.987321
          ],
          [
            12.804522,
            54.362481,
            34.955719
          ],
          [
            12.804777,
            54.362278,
            34.920321
          ],
          [
            12.80503,
            54.362072,
            34.907865
          ],
          [
            12.805233,
            54.361865,
            34.907865
          ],
          [
            12.805466,
            54.36176,
            34.907865
          ],
          [
            12.805748,
            54.361897,
            34.907865
          ],
          [
            12.806022,
            54.362021,
            34.907865
          ],
          [
            12.806333,
            54.362117,
            34.907865
          ],
          [
            12.806611,
            54.362209,
            34.907865
          ]
        ]
      }
    }
  ]
}

let day31: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            12.80539,
            54.361839,
            42.657617
          ],
          [
            12.805451,
            54.361656,
            42.657617
          ],
          [
            12.805658,
            54.361508,
            42.657617
          ],
          [
            12.805931,
            54.361367,
            42.657617
          ],
          [
            12.806183,
            54.36123,
            42.657617
          ],
          [
            12.806345,
            54.361067,
            42.762899
          ],
          [
            12.806508,
            54.360895,
            42.963607
          ],
          [
            12.806648,
            54.360715,
            43.165646
          ],
          [
            12.806799,
            54.360513,
            43.390658
          ],
          [
            12.806941,
            54.360338,
            43.588479
          ],
          [
            12.807058,
            54.360153,
            43.790317
          ],
          [
            12.807132,
            54.359962,
            43.990294
          ],
          [
            12.80719,
            54.359763,
            44.196501
          ],
          [
            12.807233,
            54.359569,
            44.396345
          ],
          [
            12.807349,
            54.359349,
            44.258493
          ],
          [
            12.807446,
            54.359177,
            43.939393
          ],
          [
            12.8076,
            54.358988,
            43.570844
          ],
          [
            12.807826,
            54.358802,
            43.169783
          ],
          [
            12.80801,
            54.358573,
            42.722187
          ],
          [
            12.808065,
            54.358339,
            42.304764
          ],
          [
            12.808099,
            54.358119,
            41.915961
          ],
          [
            12.808149,
            54.357895,
            41.517667
          ],
          [
            12.808194,
            54.357682,
            41.155845
          ],
          [
            12.808236,
            54.357485,
            40.835846
          ],
          [
            12.808277,
            54.357278,
            40.499893
          ],
          [
            12.808292,
            54.357074,
            40.17051
          ],
          [
            12.808307,
            54.356882,
            39.860685
          ],
          [
            12.808303,
            54.356658,
            39.499479
          ],
          [
            12.808255,
            54.356464,
            39.183303
          ],
          [
            12.80816,
            54.356255,
            38.834653
          ],
          [
            12.808057,
            54.35606,
            38.505702
          ],
          [
            12.807982,
            54.355847,
            38.383775
          ],
          [
            12.807904,
            54.35565,
            38.328936
          ],
          [
            12.807829,
            54.355438,
            38.270331
          ],
          [
            12.807724,
            54.355195,
            38.202485
          ],
          [
            12.807642,
            54.354974,
            38.141266
          ],
          [
            12.807586,
            54.354753,
            38.080749
          ],
          [
            12.807514,
            54.354557,
            38.02648
          ],
          [
            12.80727,
            54.354368,
            37.962231
          ],
          [
            12.807171,
            54.354127,
            38.146352
          ],
          [
            12.807069,
            54.353918,
            38.396081
          ],
          [
            12.806943,
            54.353709,
            38.651036
          ],
          [
            12.807087,
            54.353507,
            38.92585
          ],
          [
            12.807485,
            54.353412,
            39.214756
          ],
          [
            12.807619,
            54.353188,
            39.488542
          ],
          [
            12.807704,
            54.352971,
            39.744401
          ],
          [
            12.807714,
            54.352743,
            40.007017
          ],
          [
            12.807708,
            54.352508,
            39.76704
          ],
          [
            12.8077,
            54.352289,
            39.537433
          ],
          [
            12.807692,
            54.352068,
            39.305964
          ],
          [
            12.807648,
            54.351865,
            39.090863
          ],
          [
            12.807445,
            54.35168,
            38.860186
          ],
          [
            12.807162,
            54.351539,
            38.633051
          ],
          [
            12.806908,
            54.35141,
            38.427364
          ],
          [
            12.806651,
            54.351285,
            38.223087
          ],
          [
            12.806393,
            54.351161,
            38.27794
          ],
          [
            12.806103,
            54.351014,
            38.603348
          ],
          [
            12.805835,
            54.350878,
            38.905138
          ],
          [
            12.805629,
            54.350715,
            39.19925
          ],
          [
            12.805424,
            54.350544,
            39.502872
          ],
          [
            12.805411,
            54.350364,
            39.766038
          ],
          [
            12.805558,
            54.350195,
            40.041691
          ],
          [
            12.805712,
            54.350008,
            40.343025
          ],
          [
            12.805838,
            54.349835,
            40.616439
          ],
          [
            12.805878,
            54.349647,
            40.926952
          ],
          [
            12.805904,
            54.349464,
            41.255831
          ],
          [
            12.805948,
            54.349281,
            41.58677
          ],
          [
            12.805998,
            54.349095,
            41.923906
          ],
          [
            12.806092,
            54.348918,
            42.256114
          ],
          [
            12.806256,
            54.34873,
            42.633802
          ],
          [
            12.806434,
            54.348565,
            42.983779
          ],
          [
            12.806579,
            54.348391,
            43.330195
          ],
          [
            12.806713,
            54.348215,
            43.675362
          ],
          [
            12.806912,
            54.348012,
            43.686068
          ],
          [
            12.807072,
            54.347853,
            43.017241
          ],
          [
            12.806896,
            54.347741,
            42.292885
          ],
          [
            12.806506,
            54.347852,
            41.338371
          ],
          [
            12.806183,
            54.347739,
            40.535513
          ],
          [
            12.805865,
            54.347618,
            39.731196
          ],
          [
            12.805609,
            54.347503,
            39.047428
          ],
          [
            12.805382,
            54.347343,
            38.293833
          ],
          [
            12.805168,
            54.347175,
            37.5345
          ],
          [
            12.804985,
            54.346999,
            37.427306
          ],
          [
            12.804818,
            54.346828,
            37.418974
          ],
          [
            12.804641,
            54.346648,
            37.410187
          ],
          [
            12.804387,
            54.346473,
            37.40042
          ],
          [
            12.804021,
            54.346409,
            37.390973
          ],
          [
            12.80362,
            54.346354,
            37.380805
          ],
          [
            12.803223,
            54.346295,
            37.370691
          ],
          [
            12.802806,
            54.346219,
            37.359906
          ],
          [
            12.802376,
            54.346175,
            37.618551
          ],
          [
            12.801957,
            54.346103,
            37.909555
          ],
          [
            12.801566,
            54.346035,
            38.181454
          ],
          [
            12.801166,
            54.345957,
            38.46245
          ],
          [
            12.801007,
            54.345744,
            38.74397
          ],
          [
            12.801081,
            54.345506,
            39.020337
          ],
          [
            12.80114,
            54.34527,
            39.292959
          ],
          [
            12.801214,
            54.345031,
            39.501626
          ],
          [
            12.80131,
            54.344806,
            39.650152
          ],
          [
            12.801383,
            54.344593,
            39.789426
          ],
          [
            12.801455,
            54.344379,
            39.929225
          ],
          [
            12.801517,
            54.344198,
            40.047462
          ],
          [
            12.801758,
            54.344098,
            40.187451
          ],
          [
            12.802108,
            54.344078,
            40.318834
          ],
          [
            12.802459,
            54.34405,
            40.451142
          ],
          [
            12.802795,
            54.344012,
            40.581079
          ],
          [
            12.803145,
            54.343965,
            40.736498
          ],
          [
            12.80352,
            54.343926,
            40.901588
          ],
          [
            12.803954,
            54.343893,
            41.091001
          ],
          [
            12.804342,
            54.343875,
            41.260322
          ],
          [
            12.804736,
            54.343856,
            41.431414
          ],
          [
            12.805072,
            54.343824,
            41.578735
          ],
          [
            12.805413,
            54.343813,
            41.726604
          ],
          [
            12.805758,
            54.343797,
            41.877928
          ],
          [
            12.806089,
            54.343814,
            41.919286
          ],
          [
            12.806398,
            54.343855,
            41.94
          ],
          [
            12.806809,
            54.343889,
            41.966994
          ],
          [
            12.807129,
            54.343923,
            41.988152
          ],
          [
            12.807362,
            54.344033,
            42.009477
          ],
          [
            12.80743,
            54.344218,
            42.030612
          ],
          [
            12.807675,
            54.344359,
            42.054031
          ],
          [
            12.807845,
            54.344172,
            42.077921
          ],
          [
            12.808019,
            54.343968,
            42.085477
          ],
          [
            12.808134,
            54.343754,
            41.85414
          ],
          [
            12.808359,
            54.343561,
            41.61224
          ],
          [
            12.808671,
            54.343406,
            41.364521
          ],
          [
            12.80901,
            54.343254,
            41.107154
          ],
          [
            12.809362,
            54.343122,
            40.855353
          ],
          [
            12.809615,
            54.342952,
            40.622723
          ],
          [
            12.809817,
            54.34277,
            40.392677
          ],
          [
            12.809746,
            54.34254,
            40.052711
          ],
          [
            12.809725,
            54.342324,
            39.596994
          ],
          [
            12.809766,
            54.342105,
            39.133894
          ],
          [
            12.809806,
            54.341898,
            38.695613
          ],
          [
            12.809849,
            54.341678,
            38.230011
          ],
          [
            12.809875,
            54.341461,
            37.772722
          ],
          [
            12.809904,
            54.341265,
            37.359058
          ],
          [
            12.809924,
            54.341064,
            36.935372
          ],
          [
            12.809953,
            54.340858,
            36.500863
          ],
          [
            12.810027,
            54.340669,
            36.39411
          ],
          [
            12.810332,
            54.340551,
            36.306593
          ],
          [
            12.810668,
            54.34046,
            36.219244
          ],
          [
            12.811026,
            54.340351,
            36.124034
          ],
          [
            12.811377,
            54.340224,
            36.026615
          ],
          [
            12.811709,
            54.340083,
            35.929545
          ],
          [
            12.811954,
            54.339898,
            35.834998
          ],
          [
            12.812201,
            54.339737,
            35.747658
          ],
          [
            12.81245,
            54.339544,
            35.891696
          ],
          [
            12.812717,
            54.339343,
            36.069174
          ],
          [
            12.812944,
            54.339168,
            36.222392
          ],
          [
            12.813181,
            54.338942,
            36.407625
          ],
          [
            12.813392,
            54.338721,
            36.585695
          ],
          [
            12.813771,
            54.3386,
            36.761685
          ],
          [
            12.814107,
            54.338502,
            36.914622
          ],
          [
            12.814502,
            54.338396,
            37.100765
          ],
          [
            12.814911,
            54.338329,
            37.290212
          ],
          [
            12.815212,
            54.338263,
            37.433463
          ],
          [
            12.815531,
            54.338299,
            37.580946
          ],
          [
            12.815833,
            54.338424,
            37.745908
          ],
          [
            12.816146,
            54.338556,
            37.919229
          ],
          [
            12.816437,
            54.338669,
            38.074888
          ],
          [
            12.816715,
            54.338795,
            38.231652
          ],
          [
            12.816989,
            54.338907,
            38.382832
          ],
          [
            12.817258,
            54.339031,
            38.557238
          ],
          [
            12.817578,
            54.339156,
            38.753212
          ],
          [
            12.817904,
            54.339268,
            38.945803
          ],
          [
            12.818285,
            54.33943,
            39.185597
          ],
          [
            12.818578,
            54.339542,
            39.363884
          ],
          [
            12.818936,
            54.339692,
            39.588092
          ],
          [
            12.819255,
            54.339828,
            39.789046
          ],
          [
            12.819541,
            54.339962,
            39.963254
          ],
          [
            12.819808,
            54.340079,
            40.079297
          ],
          [
            12.820086,
            54.340209,
            40.203155
          ],
          [
            12.820375,
            54.340325,
            40.325077
          ],
          [
            12.820633,
            54.340449,
            40.441233
          ],
          [
            12.820914,
            54.340561,
            40.55948
          ],
          [
            12.821227,
            54.340681,
            40.68963
          ],
          [
            12.821524,
            54.340807,
            40.817261
          ],
          [
            12.821826,
            54.340911,
            40.939433
          ],
          [
            12.822071,
            54.341035,
            40.937404
          ],
          [
            12.822332,
            54.341203,
            40.719424
          ],
          [
            12.822543,
            54.341353,
            40.533115
          ],
          [
            12.822743,
            54.341495,
            40.356506
          ],
          [
            12.822954,
            54.341638,
            40.174382
          ],
          [
            12.823197,
            54.341819,
            39.953193
          ],
          [
            12.823428,
            54.34201,
            39.728717
          ],
          [
            12.823662,
            54.342174,
            39.523463
          ],
          [
            12.823923,
            54.342372,
            39.283612
          ],
          [
            12.824165,
            54.34251,
            39.521631
          ],
          [
            12.82438,
            54.342665,
            39.768265
          ],
          [
            12.824332,
            54.342876,
            40.067249
          ],
          [
            12.824015,
            54.343059,
            40.388478
          ],
          [
            12.823834,
            54.343276,
            40.687884
          ],
          [
            12.823742,
            54.343513,
            40.988401
          ],
          [
            12.823653,
            54.343752,
            41.290508
          ],
          [
            12.823546,
            54.343989,
            41.518685
          ],
          [
            12.823461,
            54.344243,
            41.575768
          ],
          [
            12.823389,
            54.344421,
            41.616132
          ],
          [
            12.823307,
            54.344639,
            41.665311
          ],
          [
            12.823235,
            54.344847,
            41.712297
          ],
          [
            12.823154,
            54.345063,
            41.761025
          ],
          [
            12.823093,
            54.345285,
            41.810594
          ],
          [
            12.82302,
            54.345511,
            41.861269
          ],
          [
            12.823019,
            54.345765,
            41.779375
          ],
          [
            12.823213,
            54.346002,
            41.408616
          ],
          [
            12.82344,
            54.346219,
            41.04986
          ],
          [
            12.823703,
            54.346464,
            40.641792
          ],
          [
            12.82394,
            54.346657,
            40.306748
          ],
          [
            12.824132,
            54.346809,
            40.039998
          ],
          [
            12.824338,
            54.347016,
            39.701815
          ],
          [
            12.824553,
            54.347216,
            39.368654
          ],
          [
            12.824763,
            54.347399,
            39.413438
          ],
          [
            12.824942,
            54.347582,
            39.465993
          ],
          [
            12.825147,
            54.347774,
            39.522399
          ],
          [
            12.825372,
            54.347979,
            39.583665
          ],
          [
            12.825571,
            54.348164,
            39.638124
          ],
          [
            12.825774,
            54.34838,
            39.699545
          ],
          [
            12.825996,
            54.348557,
            39.754226
          ],
          [
            12.826169,
            54.348739,
            39.806132
          ],
          [
            12.826353,
            54.34889,
            39.645119
          ],
          [
            12.826608,
            54.349099,
            39.406208
          ],
          [
            12.826793,
            54.349285,
            39.20582
          ],
          [
            12.826964,
            54.349438,
            39.035793
          ],
          [
            12.827144,
            54.349599,
            38.856842
          ],
          [
            12.827376,
            54.34978,
            38.646431
          ],
          [
            12.827612,
            54.35,
            38.404742
          ],
          [
            12.827798,
            54.350157,
            38.226838
          ],
          [
            12.828012,
            54.350352,
            38.276671
          ],
          [
            12.828187,
            54.350523,
            38.49317
          ],
          [
            12.828388,
            54.350709,
            38.731987
          ],
          [
            12.828622,
            54.350848,
            38.943787
          ],
          [
            12.828951,
            54.35091,
            39.164295
          ],
          [
            12.829332,
            54.350904,
            39.405653
          ],
          [
            12.829664,
            54.350874,
            39.618999
          ],
          [
            12.830003,
            54.350871,
            39.8338
          ],
          [
            12.830338,
            54.350833,
            40.050326
          ],
          [
            12.830706,
            54.350803,
            40.203516
          ],
          [
            12.831103,
            54.350813,
            40.350573
          ],
          [
            12.831476,
            54.350853,
            40.490848
          ],
          [
            12.831851,
            54.350867,
            40.631336
          ],
          [
            12.83218,
            54.350774,
            40.767102
          ],
          [
            12.832507,
            54.350676,
            40.903138
          ],
          [
            12.832835,
            54.35056,
            41.045144
          ],
          [
            12.833141,
            54.350462,
            41.175119
          ],
          [
            12.833463,
            54.350349,
            40.789391
          ],
          [
            12.833821,
            54.350284,
            40.068169
          ],
          [
            12.834196,
            54.350333,
            39.3288
          ],
          [
            12.834544,
            54.350415,
            38.609219
          ],
          [
            12.83491,
            54.350501,
            37.853032
          ],
          [
            12.835306,
            54.350593,
            37.037648
          ],
          [
            12.835673,
            54.3507,
            36.252611
          ],
          [
            12.836066,
            54.350778,
            35.458092
          ],
          [
            12.836451,
            54.350874,
            35.299187
          ],
          [
            12.836858,
            54.350952,
            35.265651
          ],
          [
            12.837266,
            54.350999,
            35.233108
          ],
          [
            12.837685,
            54.351016,
            35.20026
          ],
          [
            12.838115,
            54.351037,
            35.166519
          ],
          [
            12.838523,
            54.351062,
            35.134359
          ],
          [
            12.838939,
            54.351093,
            35.101529
          ],
          [
            12.839358,
            54.351092,
            35.584278
          ],
          [
            12.839781,
            54.351057,
            36.596394
          ],
          [
            12.840169,
            54.350977,
            37.571333
          ],
          [
            12.84052,
            54.350876,
            38.496612
          ],
          [
            12.840848,
            54.350798,
            39.333989
          ],
          [
            12.841152,
            54.350692,
            40.171468
          ],
          [
            12.841445,
            54.350596,
            40.966894
          ],
          [
            12.841764,
            54.350495,
            41.825356
          ],
          [
            12.842078,
            54.350406,
            42.222275
          ],
          [
            12.842389,
            54.350278,
            41.700539
          ],
          [
            12.842729,
            54.350178,
            41.178541
          ],
          [
            12.843102,
            54.350137,
            40.657711
          ],
          [
            12.843496,
            54.350158,
            40.115907
          ],
          [
            12.843884,
            54.350173,
            39.583399
          ],
          [
            12.84428,
            54.350186,
            39.040112
          ],
          [
            12.844713,
            54.350214,
            38.442712
          ],
          [
            12.845086,
            54.350231,
            37.971135
          ],
          [
            12.845496,
            54.350187,
            37.504351
          ],
          [
            12.845921,
            54.350113,
            37.008022
          ],
          [
            12.846302,
            54.350098,
            36.55977
          ],
          [
            12.846676,
            54.350254,
            36.043921
          ],
          [
            12.846999,
            54.350415,
            35.569204
          ],
          [
            12.847247,
            54.350565,
            35.167648
          ],
          [
            12.847558,
            54.350733,
            34.727966
          ],
          [
            12.847885,
            54.35084,
            35.325332
          ],
          [
            12.848218,
            54.35095,
            35.935373
          ],
          [
            12.848619,
            54.351079,
            36.665913
          ],
          [
            12.848956,
            54.351235,
            37.351504
          ],
          [
            12.849273,
            54.351353,
            37.950424
          ],
          [
            12.849649,
            54.35148,
            38.642354
          ],
          [
            12.849988,
            54.351594,
            39.265563
          ],
          [
            12.850387,
            54.35172,
            39.596313
          ],
          [
            12.85071,
            54.351825,
            39.556318
          ],
          [
            12.851037,
            54.351961,
            39.512892
          ],
          [
            12.851367,
            54.352106,
            39.468187
          ],
          [
            12.851717,
            54.352251,
            39.42177
          ],
          [
            12.852045,
            54.352394,
            39.377464
          ],
          [
            12.852365,
            54.35255,
            39.332368
          ],
          [
            12.852694,
            54.352709,
            39.291324
          ],
          [
            12.85298,
            54.352864,
            39.3945
          ],
          [
            12.853285,
            54.352997,
            39.495155
          ],
          [
            12.85361,
            54.353105,
            39.59402
          ],
          [
            12.853787,
            54.353305,
            39.696044
          ],
          [
            12.854089,
            54.353483,
            39.809911
          ],
          [
            12.854374,
            54.353648,
            39.916059
          ],
          [
            12.854631,
            54.353827,
            40.021943
          ],
          [
            12.854858,
            54.354001,
            40.115633
          ],
          [
            12.855085,
            54.35418,
            40.186413
          ],
          [
            12.855333,
            54.354379,
            40.264567
          ],
          [
            12.855573,
            54.354568,
            40.339285
          ],
          [
            12.855824,
            54.354749,
            40.413241
          ],
          [
            12.856076,
            54.354931,
            40.48755
          ],
          [
            12.856311,
            54.355143,
            40.567749
          ],
          [
            12.856534,
            54.355323,
            40.638353
          ],
          [
            12.856776,
            54.355505,
            40.757856
          ],
          [
            12.857008,
            54.355697,
            40.925319
          ],
          [
            12.857212,
            54.355878,
            41.079812
          ],
          [
            12.857465,
            54.356052,
            41.242399
          ],
          [
            12.857712,
            54.356205,
            41.392553
          ],
          [
            12.858006,
            54.356388,
            41.571305
          ],
          [
            12.858281,
            54.356588,
            41.754104
          ],
          [
            12.858524,
            54.356785,
            41.927156
          ],
          [
            12.858727,
            54.35697,
            41.852427
          ],
          [
            12.858942,
            54.357174,
            41.712314
          ],
          [
            12.859167,
            54.357366,
            41.57622
          ],
          [
            12.859421,
            54.35757,
            41.428671
          ],
          [
            12.859674,
            54.357792,
            41.272701
          ],
          [
            12.859906,
            54.35796,
            41.146484
          ],
          [
            12.86015,
            54.358162,
            41.001906
          ],
          [
            12.860346,
            54.358361,
            40.874255
          ],
          [
            12.86058,
            54.358553,
            40.761358
          ],
          [
            12.860865,
            54.358753,
            40.636872
          ],
          [
            12.861096,
            54.358929,
            40.530839
          ],
          [
            12.861342,
            54.359122,
            40.415733
          ],
          [
            12.861606,
            54.359314,
            40.297673
          ],
          [
            12.861882,
            54.359515,
            40.174484
          ],
          [
            12.862152,
            54.359711,
            40.05421
          ],
          [
            12.862389,
            54.359883,
            39.998474
          ],
          [
            12.862645,
            54.360043,
            39.948907
          ],
          [
            12.862903,
            54.360232,
            39.894182
          ],
          [
            12.863143,
            54.360396,
            39.845345
          ],
          [
            12.863388,
            54.360545,
            39.798557
          ],
          [
            12.863667,
            54.36069,
            39.749135
          ],
          [
            12.863948,
            54.360846,
            39.697483
          ],
          [
            12.864101,
            54.36105,
            39.646992
          ],
          [
            12.864382,
            54.361177,
            39.723698
          ],
          [
            12.864667,
            54.361294,
            39.83728
          ],
          [
            12.865049,
            54.361346,
            39.965164
          ],
          [
            12.865272,
            54.361489,
            40.073177
          ],
          [
            12.865582,
            54.361627,
            40.200139
          ],
          [
            12.865936,
            54.361761,
            40.337509
          ],
          [
            12.86624,
            54.361875,
            40.455131
          ],
          [
            12.866528,
            54.361967,
            40.562596
          ],
          [
            12.86688,
            54.362046,
            40.674146
          ],
          [
            12.867236,
            54.362148,
            40.771315
          ],
          [
            12.86757,
            54.362247,
            40.862978
          ],
          [
            12.86793,
            54.362361,
            40.963194
          ],
          [
            12.868251,
            54.362476,
            41.055369
          ],
          [
            12.868563,
            54.362561,
            41.139994
          ],
          [
            12.868902,
            54.362641,
            41.229452
          ],
          [
            12.869241,
            54.362726,
            41.31973
          ],
          [
            12.869612,
            54.362798,
            41.40211
          ],
          [
            12.869977,
            54.362889,
            41.435661
          ],
          [
            12.870328,
            54.362963,
            41.467218
          ],
          [
            12.870685,
            54.363035,
            41.499142
          ],
          [
            12.871035,
            54.363103,
            41.530321
          ],
          [
            12.871358,
            54.363153,
            41.558564
          ],
          [
            12.871672,
            54.363211,
            41.586406
          ],
          [
            12.872019,
            54.363285,
            41.617636
          ],
          [
            12.872334,
            54.363358,
            41.646308
          ],
          [
            12.872651,
            54.363424,
            41.371084
          ],
          [
            12.873015,
            54.363499,
            40.876989
          ],
          [
            12.873389,
            54.363556,
            40.38162
          ],
          [
            12.873754,
            54.363559,
            39.913005
          ],
          [
            12.874096,
            54.363547,
            39.474545
          ],
          [
            12.87448,
            54.363542,
            38.982774
          ],
          [
            12.874888,
            54.363543,
            38.460433
          ],
          [
            12.875292,
            54.363535,
            37.943127
          ],
          [
            12.875662,
            54.363595,
            37.626025
          ],
          [
            12.876002,
            54.363715,
            37.470387
          ],
          [
            12.876343,
            54.363834,
            37.314407
          ],
          [
            12.87662,
            54.363947,
            37.182023
          ],
          [
            12.876875,
            54.364075,
            37.050102
          ],
          [
            12.877126,
            54.364189,
            36.925389
          ],
          [
            12.877462,
            54.364328,
            36.764039
          ],
          [
            12.877813,
            54.364479,
            36.593135
          ],
          [
            12.878062,
            54.364593,
            36.511839
          ],
          [
            12.878318,
            54.364716,
            36.581402
          ],
          [
            12.878705,
            54.364876,
            36.680756
          ],
          [
            12.878935,
            54.365007,
            36.748102
          ],
          [
            12.87924,
            54.365185,
            36.838481
          ],
          [
            12.879479,
            54.365316,
            36.907377
          ],
          [
            12.879759,
            54.365478,
            36.989989
          ],
          [
            12.880099,
            54.365654,
            37.085364
          ],
          [
            12.880355,
            54.365775,
            37.122839
          ],
          [
            12.88061,
            54.365899,
            36.995962
          ],
          [
            12.880874,
            54.366014,
            36.870196
          ],
          [
            12.881059,
            54.366212,
            36.721861
          ],
          [
            12.881218,
            54.366423,
            36.571032
          ],
          [
            12.881431,
            54.366628,
            36.414235
          ],
          [
            12.881611,
            54.366807,
            36.27844
          ],
          [
            12.881868,
            54.366985,
            36.126232
          ],
          [
            12.882139,
            54.367134,
            35.984202
          ],
          [
            12.882405,
            54.367279,
            36.243882
          ],
          [
            12.882675,
            54.36743,
            36.570751
          ],
          [
            12.882921,
            54.367589,
            36.891273
          ],
          [
            12.883238,
            54.367783,
            37.293521
          ],
          [
            12.883497,
            54.36797,
            37.654211
          ],
          [
            12.883848,
            54.36811,
            38.02758
          ],
          [
            12.884154,
            54.36819,
            38.320102
          ],
          [
            12.884523,
            54.368228,
            38.647418
          ],
          [
            12.88496,
            54.368256,
            38.706064
          ],
          [
            12.885291,
            54.368298,
            38.743332
          ],
          [
            12.885616,
            54.368301,
            38.779072
          ],
          [
            12.885941,
            54.368321,
            38.815266
          ],
          [
            12.886275,
            54.368345,
            38.852259
          ],
          [
            12.886601,
            54.368388,
            38.889086
          ],
          [
            12.887025,
            54.36843,
            38.936408
          ],
          [
            12.88747,
            54.368364,
            38.987347
          ],
          [
            12.887833,
            54.368285,
            38.942468
          ],
          [
            12.888281,
            54.368351,
            38.850506
          ],
          [
            12.888576,
            54.36847,
            38.779892
          ],
          [
            12.888844,
            54.36858,
            38.715427
          ],
          [
            12.889109,
            54.368683,
            38.652792
          ],
          [
            12.889368,
            54.368802,
            38.58796
          ],
          [
            12.88964,
            54.368911,
            38.523062
          ],
          [
            12.889946,
            54.369049,
            38.447005
          ],
          [
            12.890227,
            54.369181,
            38.394243
          ],
          [
            12.890385,
            54.369351,
            38.404489
          ],
          [
            12.89051,
            54.36954,
            38.415219
          ],
          [
            12.890586,
            54.369746,
            38.426417
          ],
          [
            12.890588,
            54.369968,
            38.43818
          ],
          [
            12.890546,
            54.370166,
            38.448772
          ],
          [
            12.890486,
            54.370358,
            38.45911
          ],
          [
            12.890417,
            54.37056,
            38.470051
          ],
          [
            12.890406,
            54.370763,
            38.480811
          ],
          [
            12.890401,
            54.370954,
            38.540415
          ],
          [
            12.890392,
            54.371202,
            38.72148
          ],
          [
            12.890426,
            54.371423,
            38.88324
          ],
          [
            12.890481,
            54.371644,
            39.046049
          ],
          [
            12.890472,
            54.371836,
            39.186068
          ],
          [
            12.89051,
            54.372017,
            39.319992
          ],
          [
            12.890538,
            54.372221,
            39.469221
          ],
          [
            12.890551,
            54.372413,
            39.609322
          ],
          [
            12.890573,
            54.372683,
            39.791139
          ],
          [
            12.890586,
            54.372875,
            39.669033
          ],
          [
            12.890608,
            54.373071,
            39.544286
          ],
          [
            12.890641,
            54.373268,
            39.41855
          ],
          [
            12.89066,
            54.373493,
            39.275431
          ],
          [
            12.890698,
            54.373679,
            39.156172
          ],
          [
            12.890728,
            54.373868,
            39.035608
          ],
          [
            12.890774,
            54.374085,
            38.896723
          ],
          [
            12.890805,
            54.374283,
            38.770424
          ],
          [
            12.890808,
            54.37448,
            38.672362
          ],
          [
            12.890846,
            54.374709,
            38.898423
          ],
          [
            12.890879,
            54.374942,
            39.128071
          ],
          [
            12.89088,
            54.375174,
            39.35622
          ],
          [
            12.890879,
            54.375394,
            39.572883
          ],
          [
            12.890933,
            54.375618,
            39.795277
          ],
          [
            12.890978,
            54.375828,
            40.00317
          ],
          [
            12.89102,
            54.376075,
            40.246998
          ],
          [
            12.891053,
            54.376269,
            40.412676
          ],
          [
            12.891086,
            54.376494,
            40.274713
          ],
          [
            12.89111,
            54.376724,
            40.13381
          ],
          [
            12.891149,
            54.376956,
            39.991364
          ],
          [
            12.891173,
            54.377166,
            39.862692
          ],
          [
            12.891192,
            54.377356,
            39.746425
          ],
          [
            12.891214,
            54.377575,
            39.612395
          ],
          [
            12.891268,
            54.377762,
            39.496525
          ],
          [
            12.891275,
            54.377961,
            39.37489
          ],
          [
            12.891302,
            54.378171,
            39.154003
          ],
          [
            12.89134,
            54.378403,
            38.843147
          ],
          [
            12.891392,
            54.378619,
            38.551826
          ],
          [
            12.891409,
            54.378827,
            38.274163
          ],
          [
            12.891443,
            54.379033,
            37.997838
          ],
          [
            12.891463,
            54.379264,
            37.689276
          ],
          [
            12.891475,
            54.379496,
            37.377046
          ],
          [
            12.891415,
            54.379701,
            37.099749
          ],
          [
            12.891181,
            54.379821,
            37.000164
          ],
          [
            12.890929,
            54.379942,
            37.277566
          ],
          [
            12.890646,
            54.380075,
            37.586185
          ],
          [
            12.89031,
            54.380194,
            37.920215
          ],
          [
            12.889982,
            54.380294,
            38.234474
          ],
          [
            12.889662,
            54.380415,
            38.558507
          ],
          [
            12.88939,
            54.380551,
            38.865064
          ],
          [
            12.889132,
            54.38072,
            39.194777
          ],
          [
            12.888905,
            54.380907,
            39.528534
          ],
          [
            12.888759,
            54.381105,
            39.468971
          ],
          [
            12.888614,
            54.381309,
            39.384936
          ],
          [
            12.888478,
            54.381502,
            39.305539
          ],
          [
            12.88833,
            54.381724,
            39.214906
          ],
          [
            12.888167,
            54.381924,
            39.130468
          ],
          [
            12.888035,
            54.382124,
            39.048921
          ],
          [
            12.887876,
            54.382342,
            38.958757
          ],
          [
            12.887865,
            54.382532,
            38.884364
          ],
          [
            12.888012,
            54.382757,
            39.038658
          ],
          [
            12.888204,
            54.382954,
            39.259115
          ],
          [
            12.888452,
            54.383145,
            39.491628
          ],
          [
            12.88869,
            54.383326,
            39.713097
          ],
          [
            12.888939,
            54.38352,
            39.948993
          ],
          [
            12.889124,
            54.383688,
            40.143323
          ],
          [
            12.889131,
            54.383915,
            40.366251
          ],
          [
            12.889196,
            54.384139,
            40.588759
          ],
          [
            12.889394,
            54.384326,
            40.348663
          ],
          [
            12.889629,
            54.384502,
            40.058963
          ],
          [
            12.889764,
            54.384711,
            39.765809
          ],
          [
            12.889876,
            54.384904,
            39.497658
          ],
          [
            12.890067,
            54.385096,
            39.209371
          ],
          [
            12.89023,
            54.385255,
            38.968751
          ],
          [
            12.890425,
            54.385459,
            38.664829
          ],
          [
            12.890275,
            54.385644,
            38.366459
          ],
          [
            12.88998,
            54.385747,
            38.046314
          ],
          [
            12.889683,
            54.385869,
            37.673228
          ],
          [
            12.889352,
            54.386006,
            37.256374
          ],
          [
            12.88905,
            54.386126,
            36.880563
          ],
          [
            12.888763,
            54.386277,
            36.483735
          ],
          [
            12.888444,
            54.386423,
            36.067136
          ],
          [
            12.888456,
            54.386636,
            35.667007
          ],
          [
            12.888582,
            54.386807,
            35.338282
          ],
          [
            12.888799,
            54.386993,
            35.22492
          ],
          [
            12.889104,
            54.387181,
            35.572204
          ],
          [
            12.889372,
            54.387379,
            35.910863
          ],
          [
            12.889558,
            54.387583,
            36.221332
          ],
          [
            12.88973,
            54.387783,
            36.521846
          ],
          [
            12.889901,
            54.387947,
            36.77979
          ],
          [
            12.890102,
            54.388101,
            37.039524
          ],
          [
            12.890309,
            54.388281,
            37.330496
          ],
          [
            12.890554,
            54.388454,
            37.590038
          ],
          [
            12.890777,
            54.388621,
            37.770316
          ],
          [
            12.890971,
            54.388793,
            37.945874
          ],
          [
            12.891184,
            54.388972,
            38.131478
          ],
          [
            12.891424,
            54.38917,
            38.33821
          ],
          [
            12.891649,
            54.38935,
            38.527983
          ],
          [
            12.891882,
            54.389549,
            38.733249
          ],
          [
            12.892122,
            54.389704,
            38.911623
          ],
          [
            12.892412,
            54.389863,
            39.01809
          ],
          [
            12.89269,
            54.390026,
            38.910173
          ],
          [
            12.892925,
            54.390148,
            38.823844
          ],
          [
            12.893125,
            54.390304,
            38.732467
          ],
          [
            12.893371,
            54.390476,
            38.627398
          ],
          [
            12.893594,
            54.390608,
            38.540468
          ],
          [
            12.893786,
            54.390762,
            38.450397
          ],
          [
            12.894063,
            54.390936,
            38.338859
          ],
          [
            12.894257,
            54.39108,
            38.252953
          ],
          [
            12.894496,
            54.391278,
            38.044242
          ],
          [
            12.894726,
            54.39147,
            37.778233
          ],
          [
            12.895021,
            54.39165,
            37.495618
          ],
          [
            12.895194,
            54.391853,
            37.233092
          ],
          [
            12.8952,
            54.392072,
            36.984261
          ],
          [
            12.89532,
            54.392299,
            36.711326
          ],
          [
            12.895524,
            54.392498,
            36.448041
          ],
          [
            12.895783,
            54.392723,
            36.163899
          ],
          [
            12.895988,
            54.392917,
            36.169082
          ],
          [
            12.896199,
            54.393131,
            36.174703
          ],
          [
            12.896339,
            54.393365,
            36.180343
          ],
          [
            12.896463,
            54.393582,
            36.185547
          ],
          [
            12.8966,
            54.393792,
            36.190658
          ],
          [
            12.896724,
            54.393997,
            36.195603
          ],
          [
            12.896839,
            54.394218,
            36.200859
          ],
          [
            12.896935,
            54.394416,
            36.164211
          ],
          [
            12.897046,
            54.39465,
            35.978556
          ],
          [
            12.897137,
            54.394855,
            35.816367
          ],
          [
            12.897235,
            54.395085,
            35.635156
          ],
          [
            12.897319,
            54.395313,
            35.456695
          ],
          [
            12.897379,
            54.395495,
            35.315019
          ],
          [
            12.897441,
            54.395682,
            35.169395
          ],
          [
            12.897468,
            54.395919,
            34.98778
          ],
          [
            12.897557,
            54.396148,
            34.91464
          ],
          [
            12.897629,
            54.396346,
            35.543043
          ],
          [
            12.897796,
            54.396557,
            36.261778
          ],
          [
            12.897918,
            54.396747,
            36.896326
          ],
          [
            12.898093,
            54.396934,
            37.554684
          ],
          [
            12.898248,
            54.397118,
            38.190184
          ],
          [
            12.898321,
            54.397308,
            38.792218
          ],
          [
            12.898366,
            54.397569,
            39.603881
          ],
          [
            12.898455,
            54.397772,
            40.251728
          ],
          [
            12.898528,
            54.397999,
            40.329147
          ],
          [
            12.898457,
            54.398262,
            40.242074
          ],
          [
            12.898492,
            54.398461,
            40.176803
          ],
          [
            12.898539,
            54.398659,
            40.111417
          ],
          [
            12.898611,
            54.398889,
            40.034774
          ],
          [
            12.898689,
            54.399099,
            39.964685
          ],
          [
            12.898737,
            54.399317,
            39.892969
          ],
          [
            12.898764,
            54.399524,
            39.825238
          ],
          [
            12.898857,
            54.399821,
            40.131802
          ],
          [
            12.898982,
            54.400026,
            40.437334
          ],
          [
            12.899105,
            54.400252,
            40.770122
          ],
          [
            12.89924,
            54.400433,
            41.047644
          ],
          [
            12.899395,
            54.400603,
            41.31835
          ],
          [
            12.899537,
            54.400813,
            41.635886
          ],
          [
            12.899842,
            54.400976,
            41.974078
          ],
          [
            12.900141,
            54.401065,
            42.24923
          ],
          [
            12.900437,
            54.401179,
            42.321033
          ],
          [
            12.900782,
            54.401273,
            42.313061
          ],
          [
            12.901094,
            54.401416,
            42.304754
          ],
          [
            12.901395,
            54.401554,
            42.296744
          ],
          [
            12.901726,
            54.40172,
            42.287613
          ],
          [
            12.90205,
            54.401897,
            42.278332
          ],
          [
            12.902365,
            54.402058,
            42.269575
          ],
          [
            12.902671,
            54.402237,
            42.270047
          ],
          [
            12.902936,
            54.402395,
            42.315165
          ],
          [
            12.903236,
            54.402536,
            42.361135
          ],
          [
            12.903615,
            54.402667,
            42.413534
          ],
          [
            12.903881,
            54.402783,
            42.453049
          ],
          [
            12.904196,
            54.402916,
            42.499307
          ],
          [
            12.904517,
            54.403049,
            42.546174
          ],
          [
            12.904784,
            54.403157,
            42.584833
          ],
          [
            12.90506,
            54.403247,
            42.622541
          ],
          [
            12.905383,
            54.403351,
            42.478986
          ],
          [
            12.905712,
            54.403481,
            42.289585
          ],
          [
            12.906002,
            54.403591,
            42.1248
          ],
          [
            12.906325,
            54.403719,
            41.938762
          ],
          [
            12.906633,
            54.403844,
            41.760408
          ],
          [
            12.906922,
            54.403959,
            41.593876
          ],
          [
            12.907194,
            54.404083,
            41.429567
          ],
          [
            12.90749,
            54.404225,
            41.247295
          ],
          [
            12.90779,
            54.40435,
            40.884703
          ],
          [
            12.908079,
            54.404426,
            40.417068
          ],
          [
            12.908446,
            54.404581,
            39.749065
          ],
          [
            12.908755,
            54.40469,
            39.217385
          ],
          [
            12.909062,
            54.404767,
            38.725612
          ],
          [
            12.909397,
            54.404845,
            38.194831
          ],
          [
            12.909717,
            54.404915,
            37.691966
          ],
          [
            12.91002,
            54.404999,
            37.198107
          ],
          [
            12.910377,
            54.405082,
            36.632786
          ],
          [
            12.910694,
            54.405175,
            36.542385
          ],
          [
            12.911048,
            54.405273,
            36.457194
          ],
          [
            12.911351,
            54.405367,
            36.382563
          ],
          [
            12.91168,
            54.405456,
            36.30356
          ],
          [
            12.912045,
            54.405586,
            36.210632
          ],
          [
            12.912414,
            54.405724,
            36.115384
          ],
          [
            12.912715,
            54.40587,
            36.030251
          ],
          [
            12.913054,
            54.406011,
            35.959871
          ],
          [
            12.913408,
            54.406152,
            36.159085
          ],
          [
            12.913741,
            54.406305,
            36.355975
          ],
          [
            12.914069,
            54.406463,
            36.553562
          ],
          [
            12.91438,
            54.40664,
            36.755409
          ],
          [
            12.914668,
            54.406807,
            36.944275
          ],
          [
            12.915056,
            54.406805,
            37.126553
          ],
          [
            12.915468,
            54.406792,
            37.319745
          ],
          [
            12.915741,
            54.406916,
            37.40486
          ],
          [
            12.916016,
            54.407019,
            37.442606
          ],
          [
            12.916258,
            54.407134,
            37.478816
          ],
          [
            12.916516,
            54.407256,
            37.517152
          ],
          [
            12.916819,
            54.407338,
            37.555759
          ],
          [
            12.917113,
            54.407439,
            37.595116
          ],
          [
            12.9174,
            54.40755,
            37.635111
          ],
          [
            12.917702,
            54.40765,
            37.675175
          ],
          [
            12.918011,
            54.407767,
            37.717818
          ],
          [
            12.918264,
            54.407899,
            37.806326
          ],
          [
            12.918531,
            54.408044,
            37.947981
          ],
          [
            12.918805,
            54.408182,
            38.08855
          ],
          [
            12.919119,
            54.408319,
            38.240894
          ],
          [
            12.919434,
            54.408429,
            38.383329
          ],
          [
            12.919729,
            54.40855,
            38.523258
          ],
          [
            12.920028,
            54.40864,
            38.65384
          ],
          [
            12.920268,
            54.408767,
            38.780625
          ],
          [
            12.920447,
            54.408985,
            38.933847
          ],
          [
            12.920596,
            54.409162,
            38.927265
          ],
          [
            12.920809,
            54.409369,
            38.91919
          ],
          [
            12.921096,
            54.409485,
            38.912384
          ],
          [
            12.921357,
            54.409602,
            38.905949
          ],
          [
            12.921659,
            54.409737,
            38.89856
          ],
          [
            12.921909,
            54.409854,
            38.892331
          ],
          [
            12.922156,
            54.409975,
            38.886058
          ],
          [
            12.922401,
            54.410097,
            38.879798
          ],
          [
            12.922836,
            54.410172,
            38.942326
          ],
          [
            12.923149,
            54.410217,
            39.069647
          ],
          [
            12.92351,
            54.410238,
            39.212882
          ],
          [
            12.923847,
            54.410149,
            39.361783
          ],
          [
            12.924045,
            54.409958,
            39.513097
          ],
          [
            12.924235,
            54.409775,
            39.658134
          ],
          [
            12.924417,
            54.409591,
            39.802301
          ],
          [
            12.924578,
            54.409431,
            39.928072
          ],
          [
            12.924792,
            54.409263,
            40.069932
          ],
          [
            12.924966,
            54.409098,
            39.825593
          ],
          [
            12.92515,
            54.408917,
            39.467755
          ],
          [
            12.925355,
            54.408724,
            39.081707
          ],
          [
            12.925548,
            54.408534,
            38.706106
          ],
          [
            12.925768,
            54.408353,
            38.328856
          ],
          [
            12.926028,
            54.40815,
            37.89782
          ],
          [
            12.926291,
            54.408042,
            37.579008
          ],
          [
            12.926663,
            54.407926,
            37.161106
          ],
          [
            12.926971,
            54.407808,
            37.014621
          ],
          [
            12.927357,
            54.407683,
            36.978885
          ],
          [
            12.927696,
            54.407583,
            36.948159
          ],
          [
            12.928005,
            54.407519,
            36.921632
          ],
          [
            12.928326,
            54.407436,
            36.893233
          ],
          [
            12.928646,
            54.407358,
            36.865192
          ],
          [
            12.928979,
            54.40726,
            36.835023
          ],
          [
            12.929313,
            54.407189,
            36.806275
          ],
          [
            12.929645,
            54.407096,
            36.829661
          ],
          [
            12.929974,
            54.407014,
            36.998123
          ],
          [
            12.930294,
            54.406941,
            37.159888
          ],
          [
            12.930613,
            54.406881,
            37.317699
          ],
          [
            12.93093,
            54.406843,
            37.470123
          ],
          [
            12.931342,
            54.406784,
            37.670004
          ],
          [
            12.931749,
            54.406685,
            37.877529
          ],
          [
            12.932163,
            54.406604,
            38.082996
          ],
          [
            12.932555,
            54.406526,
            38.280655
          ],
          [
            12.932968,
            54.406448,
            38.498475
          ],
          [
            12.933356,
            54.406366,
            38.705738
          ],
          [
            12.93378,
            54.406303,
            38.925231
          ],
          [
            12.934185,
            54.40623,
            39.137888
          ],
          [
            12.934531,
            54.406178,
            39.317127
          ],
          [
            12.934916,
            54.406103,
            39.521435
          ],
          [
            12.935289,
            54.406037,
            39.717025
          ],
          [
            12.935699,
            54.405971,
            39.807555
          ],
          [
            12.936113,
            54.405899,
            39.837245
          ],
          [
            12.936515,
            54.405818,
            39.866469
          ],
          [
            12.936897,
            54.405728,
            39.894818
          ],
          [
            12.937304,
            54.405656,
            39.924023
          ],
          [
            12.937721,
            54.405585,
            39.954037
          ],
          [
            12.938036,
            54.405544,
            39.976246
          ],
          [
            12.938342,
            54.405492,
            39.998173
          ],
          [
            12.938679,
            54.405423,
            40.180905
          ],
          [
            12.939106,
            54.405359,
            40.422492
          ],
          [
            12.939525,
            54.405276,
            40.665018
          ],
          [
            12.93992,
            54.405218,
            40.888331
          ],
          [
            12.940312,
            54.405145,
            41.113876
          ],
          [
            12.940671,
            54.405073,
            41.321904
          ],
          [
            12.941102,
            54.405008,
            41.565833
          ],
          [
            12.941401,
            54.40494,
            41.798892
          ],
          [
            12.941761,
            54.404853,
            42.263735
          ],
          [
            12.94214,
            54.404795,
            42.727441
          ],
          [
            12.94251,
            54.404735,
            43.183355
          ],
          [
            12.942881,
            54.404671,
            43.640806
          ],
          [
            12.943201,
            54.404615,
            44.036316
          ],
          [
            12.943497,
            54.404558,
            44.404713
          ],
          [
            12.943804,
            54.404508,
            44.781419
          ],
          [
            12.944189,
            54.404457,
            45.248276
          ],
          [
            12.944436,
            54.404344,
            45.400256
          ],
          [
            12.944699,
            54.404219,
            45.481806
          ],
          [
            12.944925,
            54.404067,
            45.564892
          ],
          [
            12.945133,
            54.403879,
            45.657337
          ],
          [
            12.945304,
            54.403714,
            45.736862
          ],
          [
            12.945439,
            54.403498,
            45.831698
          ],
          [
            12.945461,
            54.403258,
            45.930925
          ],
          [
            12.945784,
            54.403197,
            46.016678
          ],
          [
            12.946128,
            54.403194,
            46.096493
          ],
          [
            12.946449,
            54.403184,
            46.153779
          ],
          [
            12.946867,
            54.403182,
            46.228255
          ],
          [
            12.947317,
            54.403207,
            46.308808
          ],
          [
            12.947668,
            54.403236,
            46.371974
          ],
          [
            12.94801,
            54.403277,
            46.434185
          ],
          [
            12.948351,
            54.403299,
            46.495311
          ],
          [
            12.948627,
            54.403222,
            46.553117
          ],
          [
            12.948698,
            54.40302,
            46.616464
          ],
          [
            12.948806,
            54.402845,
            46.99855
          ],
          [
            12.948904,
            54.402648,
            47.619003
          ],
          [
            12.948994,
            54.40244,
            48.267328
          ],
          [
            12.949263,
            54.402398,
            48.865538
          ],
          [
            12.949655,
            54.402479,
            49.597494
          ],
          [
            12.950021,
            54.402556,
            50.282233
          ],
          [
            12.950382,
            54.402573,
            50.919474
          ],
          [
            12.950739,
            54.402577,
            51.552534
          ],
          [
            12.951084,
            54.402578,
            52.116501
          ],
          [
            12.951469,
            54.402556,
            52.457469
          ],
          [
            12.951879,
            54.402516,
            52.824154
          ],
          [
            12.95229,
            54.402493,
            53.188054
          ],
          [
            12.952716,
            54.402476,
            53.564514
          ],
          [
            12.953137,
            54.402449,
            53.937829
          ],
          [
            12.953557,
            54.402434,
            54.308713
          ],
          [
            12.95393,
            54.402386,
            54.645396
          ],
          [
            12.954315,
            54.402321,
            54.581349
          ],
          [
            12.954706,
            54.402269,
            54.201885
          ],
          [
            12.955088,
            54.402229,
            53.83847
          ],
          [
            12.95546,
            54.402177,
            53.480379
          ],
          [
            12.955774,
            54.402126,
            53.171322
          ],
          [
            12.956134,
            54.402073,
            52.823419
          ],
          [
            12.956518,
            54.402045,
            52.460789
          ],
          [
            12.956825,
            54.40202,
            52.167918
          ],
          [
            12.957217,
            54.401976,
            51.934277
          ],
          [
            12.957549,
            54.401956,
            52.017749
          ],
          [
            12.957884,
            54.401916,
            52.103191
          ],
          [
            12.958217,
            54.401882,
            52.187507
          ],
          [
            12.958584,
            54.401824,
            52.282363
          ],
          [
            12.958922,
            54.401776,
            52.369135
          ],
          [
            12.959257,
            54.401752,
            52.453301
          ],
          [
            12.959611,
            54.401742,
            52.541681
          ],
          [
            12.959946,
            54.401723,
            52.625788
          ],
          [
            12.960308,
            54.401713,
            52.714203
          ],
          [
            12.960644,
            54.401715,
            52.79406
          ],
          [
            12.960972,
            54.401708,
            52.87227
          ],
          [
            12.961344,
            54.401703,
            52.960796
          ],
          [
            12.961681,
            54.401689,
            53.041322
          ],
          [
            12.962015,
            54.401684,
            53.120672
          ],
          [
            12.962349,
            54.401695,
            53.200074
          ],
          [
            12.962687,
            54.401714,
            53.281082
          ],
          [
            12.963035,
            54.401733,
            53.36404
          ],
          [
            12.963364,
            54.401743,
            53.509823
          ],
          [
            12.963689,
            54.401769,
            53.745722
          ],
          [
            12.964013,
            54.401767,
            53.977464
          ],
          [
            12.964351,
            54.401779,
            54.220471
          ],
          [
            12.964664,
            54.401801,
            54.447119
          ],
          [
            12.964968,
            54.401828,
            54.669621
          ],
          [
            12.965288,
            54.401832,
            54.900777
          ],
          [
            12.965675,
            54.401826,
            55.178311
          ],
          [
            12.966022,
            54.40181,
            55.427399
          ],
          [
            12.966378,
            54.401796,
            55.52118
          ],
          [
            12.966697,
            54.401733,
            55.15916
          ],
          [
            12.967039,
            54.401668,
            54.769403
          ],
          [
            12.967364,
            54.401606,
            54.401626
          ],
          [
            12.967663,
            54.401429,
            53.943311
          ],
          [
            12.967942,
            54.401268,
            53.520433
          ],
          [
            12.96824,
            54.401098,
            53.071541
          ],
          [
            12.968551,
            54.400941,
            52.629001
          ],
          [
            12.968842,
            54.40079,
            52.311261
          ],
          [
            12.96912,
            54.400645,
            52.371292
          ],
          [
            12.969388,
            54.400516,
            52.427186
          ],
          [
            12.969702,
            54.400378,
            52.490361
          ],
          [
            12.970056,
            54.400261,
            52.555759
          ],
          [
            12.970349,
            54.40013,
            52.615201
          ],
          [
            12.970619,
            54.399981,
            52.674962
          ],
          [
            12.970893,
            54.399837,
            52.734229
          ],
          [
            12.971135,
            54.399712,
            52.786178
          ],
          [
            12.971349,
            54.39958,
            52.835551
          ],
          [
            12.971591,
            54.399448,
            52.887358
          ],
          [
            12.97184,
            54.399314,
            52.940277
          ],
          [
            12.972126,
            54.399169,
            52.999466
          ],
          [
            12.972354,
            54.399044,
            53.048407
          ],
          [
            12.972586,
            54.398922,
            53.097193
          ],
          [
            12.97286,
            54.398797,
            53.151517
          ],
          [
            12.973161,
            54.398672,
            53.209231
          ],
          [
            12.973453,
            54.398545,
            53.266136
          ],
          [
            12.973771,
            54.398504,
            53.469643
          ],
          [
            12.973874,
            54.398654,
            53.7021
          ],
          [
            12.973556,
            54.39877,
            53.948812
          ],
          [
            12.973508,
            54.398958,
            54.173064
          ],
          [
            12.97359,
            54.399187,
            54.43712
          ],
          [
            12.973661,
            54.399415,
            54.698692
          ],
          [
            12.973743,
            54.39964,
            54.95832
          ],
          [
            12.97378,
            54.399834,
            55.178833
          ],
          [
            12.973848,
            54.400061,
            55.610209
          ],
          [
            12.973885,
            54.400269,
            56.1504
          ],
          [
            12.973947,
            54.400483,
            56.715674
          ],
          [
            12.973998,
            54.40069,
            57.255413
          ],
          [
            12.974053,
            54.400897,
            57.796936
          ],
          [
            12.974304,
            54.401033,
            58.355504
          ],
          [
            12.974638,
            54.401046,
            58.858487
          ],
          [
            12.975009,
            54.401035,
            59.417109
          ],
          [
            12.9754,
            54.401038,
            59.930313
          ],
          [
            12.975816,
            54.401038,
            59.753495
          ],
          [
            12.976216,
            54.401018,
            59.582904
          ],
          [
            12.976613,
            54.40098,
            59.411947
          ],
          [
            12.976944,
            54.400982,
            59.271172
          ],
          [
            12.977293,
            54.400974,
            59.122755
          ],
          [
            12.977743,
            54.40096,
            58.93113
          ],
          [
            12.978083,
            54.400951,
            58.786437
          ],
          [
            12.978414,
            54.400915,
            58.642826
          ],
          [
            12.978774,
            54.400891,
            58.262311
          ],
          [
            12.979169,
            54.40092,
            57.834536
          ],
          [
            12.979571,
            54.40098,
            57.387667
          ],
          [
            12.979931,
            54.401053,
            56.977721
          ],
          [
            12.98031,
            54.401122,
            56.55134
          ],
          [
            12.980689,
            54.401188,
            56.125364
          ],
          [
            12.981041,
            54.401257,
            55.726525
          ],
          [
            12.981427,
            54.401322,
            55.300646
          ],
          [
            12.981836,
            54.401407,
            54.964928
          ],
          [
            12.982249,
            54.401476,
            54.632984
          ],
          [
            12.98266,
            54.401552,
            54.299258
          ],
          [
            12.983061,
            54.401637,
            53.969568
          ],
          [
            12.983494,
            54.401711,
            53.62049
          ],
          [
            12.983914,
            54.401797,
            53.275394
          ],
          [
            12.984353,
            54.401894,
            52.91176
          ],
          [
            12.984794,
            54.401973,
            52.538088
          ],
          [
            12.985249,
            54.402049,
            52.154673
          ],
          [
            12.985692,
            54.402137,
            51.774709
          ],
          [
            12.986148,
            54.402222,
            51.386572
          ],
          [
            12.986647,
            54.402314,
            50.962679
          ],
          [
            12.987137,
            54.402382,
            50.554336
          ],
          [
            12.987644,
            54.402475,
            50.069323
          ],
          [
            12.988137,
            54.402596,
            49.557915
          ],
          [
            12.98862,
            54.402669,
            49.080869
          ],
          [
            12.989064,
            54.402743,
            48.639204
          ],
          [
            12.989495,
            54.402821,
            48.207715
          ],
          [
            12.989911,
            54.402901,
            47.78873
          ],
          [
            12.990324,
            54.402974,
            47.454405
          ],
          [
            12.990715,
            54.403048,
            47.371483
          ],
          [
            12.991088,
            54.40313,
            47.290939
          ],
          [
            12.99148,
            54.403205,
            47.207612
          ],
          [
            12.991888,
            54.403296,
            47.119517
          ],
          [
            12.992316,
            54.403372,
            47.02928
          ],
          [
            12.992781,
            54.403451,
            46.931542
          ],
          [
            12.993235,
            54.403468,
            46.947165
          ],
          [
            12.993676,
            54.403446,
            47.567057
          ],
          [
            12.994131,
            54.403414,
            48.208849
          ],
          [
            12.99455,
            54.403379,
            48.801604
          ],
          [
            12.994917,
            54.403348,
            49.3221
          ],
          [
            12.995272,
            54.403324,
            49.822591
          ],
          [
            12.995665,
            54.403313,
            50.375499
          ],
          [
            12.995994,
            54.40329,
            50.839637
          ],
          [
            12.996324,
            54.40325,
            51.06653
          ],
          [
            12.996659,
            54.403214,
            50.661294
          ],
          [
            12.996995,
            54.403198,
            50.260288
          ],
          [
            12.997332,
            54.403131,
            49.829973
          ],
          [
            12.997672,
            54.403103,
            49.421434
          ],
          [
            12.99801,
            54.403079,
            49.014996
          ],
          [
            12.99842,
            54.403082,
            48.525176
          ],
          [
            12.998789,
            54.40299,
            48.044069
          ],
          [
            12.999121,
            54.402947,
            47.637198
          ],
          [
            12.999456,
            54.402937,
            47.304022
          ],
          [
            12.999771,
            54.402936,
            47.019632
          ],
          [
            13.000138,
            54.402929,
            46.685228
          ],
          [
            13.000486,
            54.402894,
            46.366112
          ],
          [
            13.000844,
            54.402869,
            46.040491
          ],
          [
            13.001221,
            54.402819,
            45.690992
          ],
          [
            13.001584,
            54.402802,
            45.362265
          ],
          [
            13.001929,
            54.402794,
            45.049218
          ],
          [
            13.002285,
            54.40276,
            44.723571
          ],
          [
            13.002644,
            54.402734,
            44.642394
          ],
          [
            13.003006,
            54.402713,
            44.560796
          ],
          [
            13.003403,
            54.402729,
            44.469723
          ],
          [
            13.003785,
            54.40274,
            44.383936
          ],
          [
            13.004189,
            54.40276,
            44.292924
          ],
          [
            13.004573,
            54.402793,
            44.205861
          ],
          [
            13.004963,
            54.402814,
            44.117941
          ],
          [
            13.005361,
            54.402854,
            44.033386
          ],
          [
            13.005767,
            54.402908,
            44.105427
          ],
          [
            13.006171,
            54.40296,
            44.17705
          ],
          [
            13.00659,
            54.403005,
            44.250959
          ],
          [
            13.006991,
            54.403061,
            44.322321
          ],
          [
            13.007398,
            54.403117,
            44.39467
          ],
          [
            13.007784,
            54.403174,
            44.463599
          ],
          [
            13.008191,
            54.403235,
            44.536385
          ],
          [
            13.008568,
            54.403317,
            44.662199
          ],
          [
            13.008953,
            54.403426,
            44.838496
          ],
          [
            13.009277,
            54.403498,
            44.982923
          ],
          [
            13.009618,
            54.403598,
            45.140078
          ],
          [
            13.009962,
            54.403727,
            45.312476
          ],
          [
            13.010265,
            54.403785,
            45.44383
          ],
          [
            13.010576,
            54.403891,
            45.597395
          ],
          [
            13.011,
            54.40395,
            45.776831
          ],
          [
            13.01141,
            54.403968,
            45.853178
          ],
          [
            13.011797,
            54.403998,
            45.877014
          ],
          [
            13.012201,
            54.404058,
            45.902484
          ],
          [
            13.012522,
            54.404147,
            45.924303
          ],
          [
            13.012846,
            54.404186,
            45.944504
          ],
          [
            13.01323,
            54.404183,
            45.967976
          ],
          [
            13.013559,
            54.40427,
            45.990074
          ],
          [
            13.013946,
            54.404278,
            46.013783
          ],
          [
            13.014345,
            54.404265,
            45.646744
          ],
          [
            13.014644,
            54.404114,
            44.947114
          ],
          [
            13.014875,
            54.403967,
            44.339155
          ],
          [
            13.015158,
            54.403807,
            43.641205
          ],
          [
            13.015466,
            54.403639,
            42.894798
          ],
          [
            13.015798,
            54.403479,
            42.132788
          ],
          [
            13.016064,
            54.403336,
            41.492648
          ],
          [
            13.0163,
            54.403175,
            40.847114
          ],
          [
            13.016597,
            54.40302,
            40.385698
          ],
          [
            13.016863,
            54.402858,
            40.097802
          ],
          [
            13.017138,
            54.402705,
            39.813359
          ],
          [
            13.017396,
            54.402554,
            39.539605
          ],
          [
            13.017635,
            54.402425,
            39.295382
          ],
          [
            13.017919,
            54.402262,
            38.996638
          ],
          [
            13.018217,
            54.402123,
            38.710865
          ],
          [
            13.018465,
            54.401971,
            38.441538
          ],
          [
            13.018172,
            54.401903,
            38.266445
          ],
          [
            13.01796,
            54.401761,
            38.326553
          ],
          [
            13.017726,
            54.401631,
            38.386222
          ],
          [
            13.017653,
            54.401392,
            38.47369
          ],
          [
            13.017993,
            54.401454,
            38.540588
          ],
          [
            13.018309,
            54.401553,
            38.606185
          ],
          [
            13.018657,
            54.401666,
            38.679055
          ],
          [
            13.019005,
            54.401621,
            38.748174
          ],
          [
            13.019229,
            54.401469,
            38.811099
          ],
          [
            13.01945,
            54.401313,
            38.916259
          ],
          [
            13.019695,
            54.401171,
            39.026921
          ],
          [
            13.020035,
            54.401071,
            39.149399
          ],
          [
            13.020258,
            54.400913,
            39.261518
          ],
          [
            13.020469,
            54.400765,
            39.366975
          ],
          [
            13.020619,
            54.400563,
            39.487802
          ],
          [
            13.020739,
            54.40037,
            39.60043
          ],
          [
            13.020857,
            54.400173,
            39.715109
          ],
          [
            13.020987,
            54.399971,
            39.801324
          ],
          [
            13.021123,
            54.39979,
            39.787924
          ],
          [
            13.021243,
            54.399599,
            39.774118
          ],
          [
            13.02137,
            54.399388,
            39.758953
          ],
          [
            13.021464,
            54.399159,
            39.742919
          ],
          [
            13.021565,
            54.398922,
            39.72633
          ],
          [
            13.021635,
            54.398679,
            39.709611
          ],
          [
            13.021669,
            54.398455,
            39.694222
          ],
          [
            13.02168,
            54.39821,
            39.513353
          ],
          [
            13.021699,
            54.398015,
            39.087374
          ],
          [
            13.021717,
            54.397816,
            38.652778
          ],
          [
            13.021725,
            54.397569,
            38.113958
          ],
          [
            13.021691,
            54.397349,
            37.632209
          ],
          [
            13.021663,
            54.397128,
            37.148492
          ],
          [
            13.021654,
            54.396906,
            36.664016
          ],
          [
            13.021735,
            54.396675,
            36.149276
          ],
          [
            13.021945,
            54.396472,
            35.695405
          ],
          [
            13.022158,
            54.396264,
            35.426547
          ],
          [
            13.022373,
            54.396055,
            35.155974
          ],
          [
            13.022595,
            54.395832,
            34.869883
          ],
          [
            13.022801,
            54.395625,
            34.604374
          ],
          [
            13.023007,
            54.39544,
            34.359612
          ],
          [
            13.023203,
            54.395292,
            34.152203
          ],
          [
            13.023447,
            54.395123,
            33.906892
          ],
          [
            13.023761,
            54.394947,
            33.605216
          ],
          [
            13.024038,
            54.394809,
            33.336653
          ],
          [
            13.02432,
            54.394649,
            33.046704
          ],
          [
            13.024631,
            54.394487,
            32.739433
          ],
          [
            13.024967,
            54.394326,
            32.41899
          ],
          [
            13.025303,
            54.394161,
            32.095217
          ],
          [
            13.02565,
            54.393988,
            31.758831
          ],
          [
            13.025906,
            54.393866,
            31.515119
          ],
          [
            13.026193,
            54.393705,
            31.739601
          ],
          [
            13.026474,
            54.393545,
            32.009106
          ],
          [
            13.026763,
            54.393422,
            32.254573
          ],
          [
            13.027034,
            54.393297,
            32.491632
          ],
          [
            13.027334,
            54.393178,
            32.741036
          ],
          [
            13.027588,
            54.393052,
            32.969906
          ],
          [
            13.027868,
            54.39292,
            33.217226
          ],
          [
            13.028134,
            54.392797,
            33.450917
          ],
          [
            13.028398,
            54.392663,
            33.931692
          ],
          [
            13.028618,
            54.392536,
            34.75896
          ],
          [
            13.028931,
            54.392365,
            35.90503
          ],
          [
            13.029253,
            54.392193,
            37.072245
          ],
          [
            13.029576,
            54.392009,
            38.278827
          ],
          [
            13.029843,
            54.391809,
            39.440513
          ],
          [
            13.030031,
            54.391633,
            40.392448
          ],
          [
            13.030413,
            54.391626,
            41.414574
          ],
          [
            13.030783,
            54.391608,
            41.871508
          ],
          [
            13.031182,
            54.391523,
            41.902975
          ],
          [
            13.031472,
            54.391397,
            41.929741
          ],
          [
            13.031802,
            54.391268,
            41.959077
          ],
          [
            13.032091,
            54.391141,
            41.985757
          ],
          [
            13.032389,
            54.391007,
            42.013515
          ],
          [
            13.032651,
            54.390886,
            42.038172
          ],
          [
            13.032953,
            54.390759,
            42.065637
          ],
          [
            13.033305,
            54.39064,
            42.046615
          ],
          [
            13.033709,
            54.390576,
            41.948096
          ],
          [
            13.034051,
            54.390431,
            41.848396
          ],
          [
            13.034357,
            54.390282,
            41.754419
          ],
          [
            13.034671,
            54.390152,
            41.663756
          ],
          [
            13.03498,
            54.390022,
            41.574027
          ],
          [
            13.035288,
            54.389876,
            41.48054
          ],
          [
            13.035606,
            54.389767,
            41.393587
          ],
          [
            13.035978,
            54.389647,
            41.260659
          ],
          [
            13.036308,
            54.389505,
            41.11435
          ],
          [
            13.036526,
            54.389373,
            41.00225
          ],
          [
            13.036794,
            54.389202,
            40.86054
          ],
          [
            13.037036,
            54.389029,
            40.723817
          ],
          [
            13.037227,
            54.388873,
            40.606546
          ],
          [
            13.03748,
            54.388706,
            40.469917
          ],
          [
            13.037818,
            54.388539,
            40.311646
          ],
          [
            13.038151,
            54.38838,
            40.755061
          ],
          [
            13.038438,
            54.388235,
            41.447217
          ],
          [
            13.038556,
            54.387998,
            42.229567
          ],
          [
            13.038457,
            54.387771,
            42.960375
          ],
          [
            13.03837,
            54.387554,
            43.655151
          ],
          [
            13.038391,
            54.387339,
            44.329702
          ],
          [
            13.038397,
            54.387153,
            44.921914
          ],
          [
            13.03843,
            54.386916,
            45.672211
          ],
          [
            13.038508,
            54.386719,
            46.024079
          ],
          [
            13.038692,
            54.386533,
            46.267782
          ],
          [
            13.038891,
            54.386345,
            46.517679
          ],
          [
            13.039043,
            54.386186,
            46.723731
          ],
          [
            13.039202,
            54.386011,
            46.947712
          ],
          [
            13.039387,
            54.385817,
            47.198756
          ],
          [
            13.039588,
            54.385661,
            47.420035
          ],
          [
            13.039846,
            54.385508,
            47.663122
          ],
          [
            13.040149,
            54.385411,
            47.892555
          ],
          [
            13.04051,
            54.385345,
            47.26193
          ],
          [
            13.040901,
            54.385266,
            46.547099
          ],
          [
            13.041205,
            54.38509,
            45.797398
          ],
          [
            13.041396,
            54.384893,
            45.125265
          ],
          [
            13.041515,
            54.384684,
            44.471935
          ],
          [
            13.041625,
            54.384464,
            43.793262
          ],
          [
            13.041677,
            54.384276,
            43.229305
          ],
          [
            13.041741,
            54.384074,
            42.620105
          ],
          [
            13.041869,
            54.383898,
            42.396491
          ],
          [
            13.041952,
            54.383713,
            42.205147
          ],
          [
            13.042076,
            54.383527,
            42.005375
          ],
          [
            13.042212,
            54.38332,
            41.783524
          ],
          [
            13.042353,
            54.383121,
            41.567795
          ],
          [
            13.04257,
            54.382916,
            41.326255
          ],
          [
            13.042775,
            54.382726,
            41.100776
          ],
          [
            13.042938,
            54.382531,
            40.883499
          ],
          [
            13.043136,
            54.38237,
            40.705768
          ],
          [
            13.043335,
            54.382228,
            40.565771
          ],
          [
            13.04353,
            54.382067,
            40.415325
          ],
          [
            13.043768,
            54.381894,
            40.246086
          ],
          [
            13.043966,
            54.381736,
            40.096639
          ],
          [
            13.04419,
            54.381573,
            39.937239
          ],
          [
            13.044439,
            54.381399,
            39.764326
          ],
          [
            13.044663,
            54.381234,
            39.603643
          ],
          [
            13.044885,
            54.381092,
            39.457021
          ],
          [
            13.045109,
            54.380919,
            39.828592
          ],
          [
            13.045326,
            54.380774,
            40.414439
          ],
          [
            13.045526,
            54.380623,
            40.995014
          ],
          [
            13.045754,
            54.380479,
            41.591391
          ],
          [
            13.045969,
            54.380329,
            42.186506
          ],
          [
            13.046147,
            54.380181,
            42.736745
          ],
          [
            13.046379,
            54.380007,
            43.408089
          ],
          [
            13.046594,
            54.379831,
            44.065761
          ],
          [
            13.04681,
            54.379648,
            44.742368
          ],
          [
            13.047002,
            54.379491,
            45.29973
          ],
          [
            13.047104,
            54.379297,
            45.878769
          ],
          [
            13.047191,
            54.379072,
            46.536008
          ],
          [
            13.047252,
            54.378882,
            47.08664
          ],
          [
            13.047291,
            54.378691,
            47.634608
          ],
          [
            13.047277,
            54.378489,
            48.210688
          ],
          [
            13.047265,
            54.378296,
            48.760809
          ],
          [
            13.04735,
            54.378101,
            49.336895
          ],
          [
            13.047466,
            54.377912,
            49.908439
          ],
          [
            13.047572,
            54.37771,
            50.144066
          ],
          [
            13.047734,
            54.377527,
            50.313603
          ],
          [
            13.047896,
            54.377369,
            50.466524
          ],
          [
            13.048076,
            54.37721,
            50.623086
          ],
          [
            13.048284,
            54.377009,
            50.816097
          ],
          [
            13.048502,
            54.376811,
            51.009515
          ],
          [
            13.048709,
            54.376595,
            51.213127
          ],
          [
            13.048801,
            54.376372,
            51.401748
          ],
          [
            13.048822,
            54.376187,
            51.173916
          ],
          [
            13.048794,
            54.375974,
            50.515362
          ],
          [
            13.04872,
            54.375756,
            49.832763
          ],
          [
            13.048641,
            54.375559,
            49.212407
          ],
          [
            13.04854,
            54.375375,
            48.619671
          ],
          [
            13.048427,
            54.37517,
            47.958811
          ],
          [
            13.048346,
            54.374974,
            47.340422
          ],
          [
            13.04828,
            54.374783,
            46.742828
          ],
          [
            13.048247,
            54.374592,
            46.153813
          ],
          [
            13.048275,
            54.374372,
            45.974449
          ],
          [
            13.048339,
            54.37413,
            45.998391
          ],
          [
            13.048358,
            54.373883,
            46.022571
          ],
          [
            13.048413,
            54.373655,
            46.045084
          ],
          [
            13.048459,
            54.373422,
            46.06803
          ],
          [
            13.048493,
            54.373185,
            46.091284
          ],
          [
            13.048532,
            54.37298,
            46.111465
          ],
          [
            13.048557,
            54.372787,
            46.130402
          ],
          [
            13.048578,
            54.372573,
            46.387181
          ],
          [
            13.048618,
            54.372332,
            46.750744
          ],
          [
            13.048648,
            54.37214,
            47.040233
          ],
          [
            13.048683,
            54.371904,
            47.396021
          ],
          [
            13.048743,
            54.37164,
            47.795889
          ],
          [
            13.048812,
            54.37142,
            48.133654
          ],
          [
            13.048852,
            54.371205,
            48.458961
          ],
          [
            13.048897,
            54.370956,
            48.835229
          ],
          [
            13.048925,
            54.370715,
            49.377205
          ],
          [
            13.048992,
            54.370472,
            49.929643
          ],
          [
            13.049043,
            54.370235,
            50.465702
          ],
          [
            13.049111,
            54.369996,
            51.009488
          ],
          [
            13.049181,
            54.369809,
            51.439063
          ],
          [
            13.049214,
            54.369627,
            51.85309
          ],
          [
            13.049248,
            54.369421,
            52.31778
          ],
          [
            13.049281,
            54.369194,
            52.829161
          ],
          [
            13.049314,
            54.368982,
            52.154516
          ],
          [
            13.04933,
            54.368794,
            51.456998
          ],
          [
            13.049363,
            54.368592,
            50.705071
          ],
          [
            13.049365,
            54.368393,
            49.967025
          ],
          [
            13.049382,
            54.368205,
            49.269315
          ],
          [
            13.049421,
            54.368011,
            48.545485
          ],
          [
            13.049431,
            54.367807,
            47.78455
          ],
          [
            13.049468,
            54.367586,
            46.961683
          ],
          [
            13.049505,
            54.367376,
            46.200806
          ],
          [
            13.049545,
            54.367148,
            46.004172
          ],
          [
            13.049578,
            54.366962,
            45.843741
          ],
          [
            13.04962,
            54.36676,
            45.669161
          ],
          [
            13.049657,
            54.366568,
            45.503379
          ],
          [
            13.049691,
            54.366357,
            45.321554
          ],
          [
            13.049743,
            54.366116,
            45.113143
          ],
          [
            13.049779,
            54.365886,
            44.914785
          ],
          [
            13.049792,
            54.365651,
            44.713004
          ],
          [
            13.049852,
            54.365408,
            45.085301
          ],
          [
            13.049905,
            54.36515,
            45.664392
          ],
          [
            13.050068,
            54.364921,
            46.222076
          ],
          [
            13.050396,
            54.364767,
            46.770985
          ],
          [
            13.050746,
            54.364677,
            47.267646
          ],
          [
            13.051084,
            54.364563,
            47.77478
          ],
          [
            13.05145,
            54.364477,
            48.287063
          ],
          [
            13.051779,
            54.364371,
            48.713701
          ],
          [
            13.052135,
            54.364278,
            48.920098
          ],
          [
            13.052466,
            54.364181,
            49.116228
          ],
          [
            13.05276,
            54.36409,
            49.292349
          ],
          [
            13.053048,
            54.363995,
            49.467476
          ],
          [
            13.053348,
            54.363908,
            49.644782
          ],
          [
            13.053662,
            54.363822,
            49.828501
          ],
          [
            13.053959,
            54.363746,
            50.000101
          ],
          [
            13.054266,
            54.363641,
            50.188447
          ],
          [
            13.05463,
            54.363527,
            50.405876
          ],
          [
            13.054968,
            54.363451,
            50.596772
          ],
          [
            13.055287,
            54.36336,
            50.782856
          ],
          [
            13.055653,
            54.363242,
            51.001541
          ],
          [
            13.056031,
            54.363129,
            51.223658
          ],
          [
            13.056416,
            54.363017,
            51.448638
          ],
          [
            13.056761,
            54.362923,
            51.647831
          ],
          [
            13.057071,
            54.362856,
            51.820695
          ],
          [
            13.057465,
            54.362735,
            51.672411
          ],
          [
            13.057758,
            54.362634,
            51.347721
          ],
          [
            13.058085,
            54.362545,
            51.00387
          ],
          [
            13.058463,
            54.362416,
            50.587239
          ],
          [
            13.058859,
            54.362294,
            50.160974
          ],
          [
            13.059279,
            54.362148,
            49.695609
          ],
          [
            13.059726,
            54.362002,
            49.208195
          ],
          [
            13.060079,
            54.361852,
            48.949263
          ],
          [
            13.060448,
            54.36171,
            48.875255
          ],
          [
            13.060818,
            54.361579,
            48.802845
          ],
          [
            13.061191,
            54.361415,
            48.724581
          ],
          [
            13.061573,
            54.361287,
            48.650804
          ],
          [
            13.061933,
            54.36115,
            48.578856
          ],
          [
            13.062305,
            54.361051,
            48.51024
          ],
          [
            13.062692,
            54.360961,
            48.572109
          ],
          [
            13.063037,
            54.360883,
            48.825157
          ],
          [
            13.063325,
            54.360799,
            49.046279
          ],
          [
            13.06363,
            54.360664,
            49.312274
          ],
          [
            13.063942,
            54.360661,
            49.560625
          ],
          [
            13.064291,
            54.360685,
            49.80066
          ],
          [
            13.06463,
            54.360611,
            50.048153
          ],
          [
            13.065002,
            54.360537,
            50.316516
          ],
          [
            13.065365,
            54.360469,
            50.570685
          ],
          [
            13.065703,
            54.360388,
            50.313811
          ],
          [
            13.066088,
            54.360295,
            50.021657
          ],
          [
            13.066481,
            54.360206,
            49.726221
          ],
          [
            13.066878,
            54.360107,
            49.423205
          ],
          [
            13.067245,
            54.360012,
            49.141259
          ],
          [
            13.067595,
            54.359897,
            48.859582
          ],
          [
            13.067935,
            54.359788,
            48.585599
          ],
          [
            13.068249,
            54.359715,
            48.347146
          ],
          [
            13.068538,
            54.35959,
            48.08784
          ],
          [
            13.068843,
            54.359496,
            47.839939
          ],
          [
            13.069168,
            54.359408,
            47.582464
          ],
          [
            13.069528,
            54.359316,
            47.299988
          ],
          [
            13.069919,
            54.359262,
            47.011228
          ],
          [
            13.070311,
            54.359286,
            46.727027
          ],
          [
            13.070662,
            54.359349,
            46.461498
          ],
          [
            13.071017,
            54.359256,
            46.187963
          ],
          [
            13.071189,
            54.359062,
            46.076158
          ],
          [
            13.071341,
            54.358864,
            45.965221
          ],
          [
            13.071448,
            54.358646,
            45.849209
          ],
          [
            13.071479,
            54.358418,
            45.732197
          ],
          [
            13.071504,
            54.358174,
            45.607123
          ],
          [
            13.071525,
            54.357951,
            45.4929
          ],
          [
            13.071542,
            54.357687,
            45.357747
          ],
          [
            13.071561,
            54.35748,
            45.242543
          ],
          [
            13.071579,
            54.357243,
            45.072174
          ],
          [
            13.071599,
            54.357051,
            44.933853
          ],
          [
            13.07166,
            54.356845,
            44.783658
          ],
          [
            13.071734,
            54.356638,
            44.631768
          ],
          [
            13.071761,
            54.356449,
            44.495425
          ],
          [
            13.071835,
            54.356226,
            44.332299
          ],
          [
            13.071872,
            54.355996,
            44.166294
          ],
          [
            13.071919,
            54.355725,
            43.970259
          ],
          [
            13.071971,
            54.355505,
            43.811716
          ],
          [
            13.072017,
            54.355293,
            43.65919
          ],
          [
            13.07205,
            54.355062,
            43.493601
          ],
          [
            13.072102,
            54.354854,
            43.343622
          ],
          [
            13.072154,
            54.354656,
            43.200642
          ],
          [
            13.072214,
            54.354463,
            43.0604
          ],
          [
            13.072159,
            54.35422,
            42.880939
          ],
          [
            13.071924,
            54.354031,
            42.71272
          ],
          [
            13.071704,
            54.353867,
            42.426561
          ],
          [
            13.071485,
            54.35368,
            42.100789
          ],
          [
            13.071324,
            54.35348,
            41.783095
          ],
          [
            13.071238,
            54.35328,
            41.484958
          ],
          [
            13.071167,
            54.353091,
            41.206706
          ],
          [
            13.071122,
            54.352905,
            40.936561
          ],
          [
            13.071276,
            54.352718,
            40.621642
          ],
          [
            13.071536,
            54.352582,
            40.328863
          ],
          [
            13.071838,
            54.35244,
            40.11512
          ],
          [
            13.07202,
            54.352278,
            40.11959
          ],
          [
            13.072265,
            54.352119,
            40.124543
          ],
          [
            13.072611,
            54.351949,
            40.130633
          ],
          [
            13.072929,
            54.351793,
            40.136227
          ],
          [
            13.073263,
            54.351643,
            40.141903
          ],
          [
            13.073604,
            54.351467,
            40.148031
          ],
          [
            13.073942,
            54.351298,
            40.154026
          ],
          [
            13.074201,
            54.351106,
            40.246589
          ],
          [
            13.074334,
            54.350874,
            40.353043
          ],
          [
            13.074583,
            54.350707,
            40.449514
          ],
          [
            13.074868,
            54.350561,
            40.5459
          ],
          [
            13.07515,
            54.350449,
            40.632456
          ],
          [
            13.075454,
            54.350341,
            40.722735
          ],
          [
            13.075726,
            54.350217,
            40.810306
          ],
          [
            13.075979,
            54.350073,
            40.900205
          ],
          [
            13.075883,
            54.349883,
            41.188429
          ],
          [
            13.075911,
            54.349692,
            41.644781
          ],
          [
            13.076135,
            54.349564,
            42.035059
          ],
          [
            13.075861,
            54.349391,
            42.524092
          ],
          [
            13.075614,
            54.349235,
            42.965407
          ],
          [
            13.075418,
            54.34904,
            43.443724
          ],
          [
            13.075396,
            54.348832,
            43.8756
          ],
          [
            13.075299,
            54.348628,
            44.314982
          ],
          [
            13.075176,
            54.348452,
            44.64568
          ],
          [
            13.075062,
            54.348254,
            44.492846
          ],
          [
            13.07498,
            54.348047,
            44.337393
          ],
          [
            13.074876,
            54.347845,
            44.182996
          ],
          [
            13.074758,
            54.347599,
            43.996108
          ],
          [
            13.074691,
            54.34742,
            43.86182
          ],
          [
            13.074668,
            54.347181,
            43.686679
          ],
          [
            13.074681,
            54.346982,
            43.540659
          ],
          [
            13.074681,
            54.346769,
            43.384667
          ],
          [
            13.074626,
            54.346544,
            43.150843
          ],
          [
            13.074515,
            54.346349,
            42.922808
          ],
          [
            13.07453,
            54.346152,
            42.701983
          ],
          [
            13.074635,
            54.345943,
            42.460177
          ],
          [
            13.074695,
            54.345687,
            42.173327
          ],
          [
            13.074759,
            54.34546,
            41.917755
          ],
          [
            13.074823,
            54.345242,
            41.672275
          ],
          [
            13.07492,
            54.345029,
            41.427676
          ],
          [
            13.074942,
            54.344842,
            41.527951
          ],
          [
            13.074973,
            54.344644,
            41.818931
          ],
          [
            13.075007,
            54.344436,
            42.125127
          ],
          [
            13.075051,
            54.34423,
            42.428951
          ],
          [
            13.075168,
            54.344013,
            42.762123
          ],
          [
            13.075275,
            54.343763,
            43.139311
          ],
          [
            13.075326,
            54.343505,
            43.519628
          ],
          [
            13.075313,
            54.343283,
            43.844756
          ],
          [
            13.075379,
            54.343081,
            44.222224
          ],
          [
            13.075506,
            54.342879,
            44.684792
          ],
          [
            13.075572,
            54.342663,
            45.156792
          ],
          [
            13.075636,
            54.342447,
            45.627669
          ],
          [
            13.075722,
            54.342246,
            46.072615
          ],
          [
            13.075821,
            54.342031,
            46.55109
          ],
          [
            13.075895,
            54.341824,
            47.005335
          ],
          [
            13.075977,
            54.341603,
            47.491286
          ],
          [
            13.076058,
            54.341366,
            47.928426
          ],
          [
            13.076123,
            54.341137,
            48.175937
          ],
          [
            13.076201,
            54.340924,
            48.407723
          ],
          [
            13.076338,
            54.340737,
            48.625768
          ],
          [
            13.076441,
            54.340558,
            48.826806
          ],
          [
            13.076542,
            54.34035,
            49.058686
          ],
          [
            13.076613,
            54.340135,
            49.291648
          ],
          [
            13.076736,
            54.339904,
            49.549042
          ],
          [
            13.076906,
            54.339729,
            49.75765
          ],
          [
            13.07704,
            54.339504,
            49.13095
          ],
          [
            13.077147,
            54.3393,
            48.568832
          ],
          [
            13.077213,
            54.339038,
            47.87203
          ],
          [
            13.077206,
            54.338824,
            47.307305
          ],
          [
            13.077366,
            54.338622,
            46.718733
          ],
          [
            13.077672,
            54.338434,
            46.03675
          ],
          [
            13.077937,
            54.338186,
            45.266975
          ],
          [
            13.078121,
            54.337916,
            44.887294
          ],
          [
            13.078204,
            54.337668,
            44.708294
          ],
          [
            13.078287,
            54.337454,
            44.552836
          ],
          [
            13.078364,
            54.337241,
            44.398466
          ],
          [
            13.078418,
            54.337005,
            44.229662
          ],
          [
            13.07825,
            54.336793,
            44.062534
          ],
          [
            13.078137,
            54.336609,
            43.918607
          ],
          [
            13.07818,
            54.336424,
            43.785374
          ],
          [
            13.078318,
            54.336235,
            44.093903
          ],
          [
            13.078486,
            54.336039,
            44.549694
          ],
          [
            13.078561,
            54.335827,
            45.004111
          ],
          [
            13.078621,
            54.335634,
            45.41529
          ],
          [
            13.078761,
            54.335462,
            45.81078
          ],
          [
            13.078865,
            54.335261,
            46.248009
          ],
          [
            13.07897,
            54.335066,
            46.672523
          ],
          [
            13.079056,
            54.334877,
            47.078669
          ],
          [
            13.079205,
            54.334718,
            47.45514
          ],
          [
            13.079417,
            54.334539,
            47.613317
          ],
          [
            13.079227,
            54.334684,
            47.72121
          ],
          [
            13.079067,
            54.334894,
            47.854996
          ],
          [
            13.07897,
            54.335103,
            47.984286
          ],
          [
            13.078888,
            54.33507,
            48.090047
          ],
          [
            13.079046,
            54.334905,
            48.206601
          ],
          [
            13.079192,
            54.334721,
            48.324133
          ],
          [
            13.079391,
            54.334535,
            48.45146
          ],
          [
            13.079583,
            54.334357,
            48.547537
          ],
          [
            13.079719,
            54.334154,
            48.592745
          ],
          [
            13.079819,
            54.333953,
            48.635739
          ],
          [
            13.079938,
            54.333741,
            48.681556
          ],
          [
            13.080039,
            54.333539,
            48.724773
          ],
          [
            13.080144,
            54.333351,
            48.765419
          ],
          [
            13.080256,
            54.333031,
            48.833399
          ],
          [
            13.080215,
            54.332876,
            48.875655
          ],
          [
            13.079866,
            54.332904,
            48.865633
          ],
          [
            13.079541,
            54.332937,
            48.768694
          ],
          [
            13.079205,
            54.332944,
            48.669791
          ],
          [
            13.078836,
            54.332971,
            48.560378
          ],
          [
            13.078511,
            54.332948,
            48.464085
          ],
          [
            13.078144,
            54.332894,
            48.352843
          ],
          [
            13.077783,
            54.332836,
            48.242251
          ],
          [
            13.077392,
            54.332841,
            48.125855
          ],
          [
            13.077115,
            54.332725,
            48.024896
          ],
          [
            13.077072,
            54.332566,
            48.167531
          ],
          [
            13.077296,
            54.332385,
            48.468058
          ],
          [
            13.077363,
            54.332204,
            48.744301
          ],
          [
            13.077103,
            54.332025,
            49.059491
          ],
          [
            13.076864,
            54.331858,
            49.351623
          ],
          [
            13.07663,
            54.3317,
            49.632476
          ],
          [
            13.07629,
            54.331623,
            49.918311
          ],
          [
            13.076021,
            54.331479,
            50.205237
          ],
          [
            13.07573,
            54.331339,
            50.470619
          ],
          [
            13.075438,
            54.331193,
            50.668964
          ],
          [
            13.075118,
            54.331028,
            50.887814
          ],
          [
            13.074894,
            54.330871,
            51.06895
          ],
          [
            13.074619,
            54.33071,
            51.268407
          ],
          [
            13.074332,
            54.330608,
            51.440874
          ],
          [
            13.074096,
            54.330465,
            51.61681
          ],
          [
            13.07382,
            54.330336,
            51.798971
          ],
          [
            13.073557,
            54.330203,
            51.977431
          ],
          [
            13.073262,
            54.330065,
            51.979606
          ],
          [
            13.072999,
            54.32994,
            51.969376
          ],
          [
            13.072742,
            54.329813,
            51.959248
          ],
          [
            13.072449,
            54.329701,
            51.948675
          ],
          [
            13.072189,
            54.329726,
            51.937904
          ],
          [
            13.071948,
            54.329928,
            51.92522
          ],
          [
            13.071759,
            54.330074,
            51.91579
          ],
          [
            13.071525,
            54.330256,
            51.904052
          ],
          [
            13.071296,
            54.3304,
            51.927359
          ],
          [
            13.07106,
            54.33056,
            52.016897
          ],
          [
            13.070824,
            54.330748,
            52.115756
          ],
          [
            13.070588,
            54.330922,
            52.209972
          ],
          [
            13.070326,
            54.330829,
            52.289921
          ],
          [
            13.070034,
            54.330633,
            52.400086
          ],
          [
            13.06975,
            54.330509,
            52.48975
          ],
          [
            13.069466,
            54.330373,
            52.581074
          ],
          [
            13.069203,
            54.330237,
            52.662105
          ],
          [
            13.068933,
            54.330125,
            52.675863
          ],
          [
            13.068648,
            54.330022,
            52.689788
          ],
          [
            13.06838,
            54.329901,
            52.703859
          ],
          [
            13.068098,
            54.329777,
            52.718541
          ],
          [
            13.06779,
            54.329643,
            52.734504
          ],
          [
            13.06751,
            54.329489,
            52.750482
          ],
          [
            13.067203,
            54.329336,
            52.767278
          ],
          [
            13.06691,
            54.329231,
            52.781582
          ],
          [
            13.066618,
            54.329097,
            52.463773
          ],
          [
            13.066319,
            54.329011,
            51.930156
          ],
          [
            13.066029,
            54.328911,
            51.393391
          ],
          [
            13.065712,
            54.328821,
            50.831085
          ],
          [
            13.065414,
            54.328711,
            50.268944
          ],
          [
            13.065117,
            54.328584,
            49.681985
          ],
          [
            13.064786,
            54.328459,
            49.053726
          ],
          [
            13.064438,
            54.328382,
            48.460644
          ],
          [
            13.064074,
            54.328273,
            47.886423
          ],
          [
            13.063708,
            54.328174,
            47.998814
          ],
          [
            13.063327,
            54.328065,
            48.117034
          ],
          [
            13.063032,
            54.327964,
            48.212361
          ],
          [
            13.062728,
            54.327879,
            48.306274
          ],
          [
            13.062428,
            54.32779,
            48.400168
          ],
          [
            13.062111,
            54.327688,
            48.501135
          ],
          [
            13.061806,
            54.327578,
            48.601061
          ],
          [
            13.0615,
            54.327509,
            48.692457
          ],
          [
            13.061174,
            54.327437,
            48.726363
          ],
          [
            13.060831,
            54.327384,
            48.713092
          ],
          [
            13.060519,
            54.327311,
            48.700485
          ],
          [
            13.060147,
            54.327251,
            48.686048
          ],
          [
            13.059774,
            54.327223,
            48.67195
          ],
          [
            13.059406,
            54.327189,
            48.657997
          ],
          [
            13.059012,
            54.327145,
            48.642947
          ],
          [
            13.058591,
            54.327072,
            48.626483
          ],
          [
            13.058243,
            54.326952,
            48.403273
          ],
          [
            13.058008,
            54.326755,
            47.94243
          ],
          [
            13.057943,
            54.326554,
            47.533322
          ],
          [
            13.057593,
            54.326477,
            47.115122
          ],
          [
            13.057285,
            54.326443,
            46.740517
          ],
          [
            13.05717,
            54.326267,
            46.379655
          ],
          [
            13.057043,
            54.326069,
            45.97499
          ],
          [
            13.056922,
            54.325842,
            45.520344
          ],
          [
            13.056837,
            54.325654,
            45.196181
          ],
          [
            13.056774,
            54.325453,
            45.420642
          ],
          [
            13.056744,
            54.325243,
            45.652069
          ],
          [
            13.056719,
            54.32504,
            45.875583
          ],
          [
            13.056689,
            54.324841,
            46.094976
          ],
          [
            13.056667,
            54.324645,
            46.31069
          ],
          [
            13.056617,
            54.324444,
            46.533858
          ],
          [
            13.056559,
            54.32425,
            46.751065
          ],
          [
            13.056538,
            54.324039,
            46.983207
          ],
          [
            13.056489,
            54.323836,
            47.064573
          ],
          [
            13.056411,
            54.32363,
            46.681459
          ],
          [
            13.056401,
            54.323428,
            46.3136
          ],
          [
            13.056323,
            54.32322,
            45.929577
          ],
          [
            13.056321,
            54.323029,
            45.584633
          ],
          [
            13.05629,
            54.322821,
            45.208039
          ],
          [
            13.056248,
            54.322598,
            44.803507
          ],
          [
            13.056241,
            54.322378,
            44.406668
          ],
          [
            13.056248,
            54.32216,
            44.011356
          ],
          [
            13.05622,
            54.321917,
            43.58899
          ],
          [
            13.05607,
            54.321706,
            43.190873
          ],
          [
            13.055714,
            54.321605,
            42.795306
          ],
          [
            13.055407,
            54.321491,
            42.430697
          ],
          [
            13.0551,
            54.321387,
            42.075727
          ],
          [
            13.054746,
            54.321388,
            41.715352
          ],
          [
            13.054362,
            54.321381,
            41.331648
          ],
          [
            13.054258,
            54.321182,
            40.964171
          ],
          [
            13.054114,
            54.320983,
            41.040499
          ],
          [
            13.053741,
            54.320964,
            41.347355
          ],
          [
            13.0534,
            54.32096,
            41.630373
          ],
          [
            13.053036,
            54.320961,
            41.930135
          ],
          [
            13.052651,
            54.320928,
            42.249092
          ],
          [
            13.052296,
            54.321008,
            42.5665
          ],
          [
            13.051921,
            54.321049,
            42.87954
          ],
          [
            13.051596,
            54.321075,
            43.148548
          ],
          [
            13.051223,
            54.321077,
            43.391021
          ],
          [
            13.050836,
            54.321063,
            43.49949
          ],
          [
            13.05059,
            54.320937,
            43.594072
          ],
          [
            13.050406,
            54.320714,
            43.712702
          ],
          [
            13.050067,
            54.320683,
            43.812924
          ],
          [
            13.049731,
            54.320806,
            43.924487
          ],
          [
            13.049352,
            54.320918,
            44.043242
          ],
          [
            13.048966,
            54.32104,
            44.166204
          ],
          [
            13.048622,
            54.321109,
            44.29708
          ],
          [
            13.048306,
            54.321207,
            44.458249
          ],
          [
            13.048047,
            54.321118,
            44.607189
          ],
          [
            13.048019,
            54.32093,
            44.753608
          ],
          [
            13.047877,
            54.320783,
            44.905761
          ],
          [
            13.047282,
            54.320827,
            45.180152
          ],
          [
            13.046996,
            54.320853,
            45.446007
          ],
          [
            13.047528,
            54.320773,
            45.790753
          ],
          [
            13.047737,
            54.320638,
            46.085621
          ],
          [
            13.047939,
            54.320798,
            46.406499
          ],
          [
            13.048096,
            54.320772,
            46.712127
          ],
          [
            13.047891,
            54.32063,
            47.013048
          ],
          [
            13.047668,
            54.32051,
            47.310809
          ],
          [
            13.047591,
            54.32032,
            47.627382
          ],
          [
            13.047519,
            54.320142,
            47.928811
          ],
          [
            13.047713,
            54.319903,
            48.373053
          ],
          [
            13.047896,
            54.320218,
            48.446557
          ],
          [
            13.04781,
            54.320397,
            48.398486
          ],
          [
            13.047814,
            54.320576,
            48.346894
          ],
          [
            13.047613,
            54.32073,
            48.292542
          ],
          [
            13.047311,
            54.320796,
            48.242842
          ],
          [
            13.046964,
            54.320877,
            48.186714
          ],
          [
            13.047914,
            54.320674,
            46.930321
          ],
          [
            13.047681,
            54.320526,
            46.689631
          ],
          [
            13.047774,
            54.320348,
            46.464723
          ],
          [
            13.047697,
            54.320151,
            46.230783
          ],
          [
            13.048106,
            54.32004,
            46.22806
          ],
          [
            13.047782,
            54.319918,
            46.537007
          ],
          [
            13.047897,
            54.319877,
            46.845812
          ],
          [
            13.047636,
            54.320076,
            47.152971
          ],
          [
            13.047667,
            54.320266,
            47.376371
          ],
          [
            13.047652,
            54.320483,
            47.625141
          ],
          [
            13.047775,
            54.32066,
            47.857944
          ],
          [
            13.048094,
            54.320773,
            47.934811
          ],
          [
            13.0481,
            54.32072,
            47.699384
          ],
          [
            13.048146,
            54.320714,
            47.474601
          ],
          [
            13.048382,
            54.320614,
            47.256539
          ],
          [
            13.048698,
            54.320553,
            47.035028
          ],
          [
            13.049075,
            54.320491,
            46.774016
          ],
          [
            13.049418,
            54.320427,
            46.534354
          ],
          [
            13.049749,
            54.320367,
            46.302583
          ],
          [
            13.050062,
            54.320295,
            46.078431
          ],
          [
            13.050072,
            54.320098,
            46.114477
          ],
          [
            13.050109,
            54.319935,
            46.39594
          ],
          [
            13.050253,
            54.319732,
            46.715926
          ],
          [
            13.0506,
            54.319748,
            47.014884
          ],
          [
            13.050941,
            54.319793,
            47.306654
          ],
          [
            13.051278,
            54.319835,
            47.593925
          ],
          [
            13.051617,
            54.319838,
            47.876958
          ],
          [
            13.051962,
            54.319849,
            48.164985
          ],
          [
            13.052348,
            54.319841,
            48.487051
          ],
          [
            13.052742,
            54.319846,
            48.189191
          ],
          [
            13.053152,
            54.31983,
            47.756546
          ],
          [
            13.053568,
            54.319798,
            47.31501
          ],
          [
            13.05401,
            54.31978,
            46.840404
          ],
          [
            13.054412,
            54.319791,
            46.416844
          ],
          [
            13.054765,
            54.31977,
            46.043449
          ],
          [
            13.055109,
            54.319757,
            45.680602
          ],
          [
            13.055469,
            54.319736,
            45.299901
          ],
          [
            13.05582,
            54.319698,
            45.43305
          ],
          [
            13.056164,
            54.319619,
            45.578881
          ],
          [
            13.056494,
            54.319565,
            45.714165
          ],
          [
            13.056841,
            54.319594,
            45.852477
          ],
          [
            13.057212,
            54.319597,
            45.998854
          ],
          [
            13.057589,
            54.319637,
            46.150051
          ],
          [
            13.057948,
            54.319643,
            46.291967
          ],
          [
            13.058321,
            54.319649,
            46.439161
          ],
          [
            13.058691,
            54.319664,
            46.466068
          ],
          [
            13.059045,
            54.319655,
            46.384178
          ],
          [
            13.059411,
            54.319633,
            46.299111
          ],
          [
            13.059719,
            54.319608,
            46.227213
          ],
          [
            13.060098,
            54.319585,
            46.139168
          ],
          [
            13.060472,
            54.319583,
            46.052703
          ],
          [
            13.060903,
            54.319595,
            45.952822
          ],
          [
            13.061314,
            54.319581,
            45.857701
          ],
          [
            13.06165,
            54.319529,
            45.80373
          ],
          [
            13.062023,
            54.319481,
            45.829527
          ],
          [
            13.062404,
            54.319439,
            45.855736
          ],
          [
            13.06281,
            54.319407,
            45.883423
          ],
          [
            13.063155,
            54.319347,
            45.907751
          ],
          [
            13.063468,
            54.319309,
            45.929443
          ],
          [
            13.063891,
            54.319268,
            45.958396
          ],
          [
            13.064289,
            54.319218,
            45.985885
          ],
          [
            13.064613,
            54.319187,
            46.04075
          ],
          [
            13.064984,
            54.319136,
            46.413064
          ],
          [
            13.065422,
            54.31909,
            46.844936
          ],
          [
            13.065812,
            54.319045,
            47.229501
          ],
          [
            13.066278,
            54.318993,
            47.689247
          ],
          [
            13.066647,
            54.318957,
            48.054142
          ],
          [
            13.066989,
            54.31889,
            48.403045
          ],
          [
            13.067373,
            54.31888,
            48.774798
          ],
          [
            13.067753,
            54.318855,
            48.886255
          ],
          [
            13.068132,
            54.318827,
            48.646063
          ],
          [
            13.068576,
            54.318799,
            48.365031
          ],
          [
            13.068986,
            54.318775,
            48.105978
          ],
          [
            13.069286,
            54.318663,
            47.871957
          ],
          [
            13.069455,
            54.318491,
            47.658176
          ],
          [
            13.069703,
            54.318336,
            47.424923
          ],
          [
            13.07005,
            54.318283,
            47.198344
          ],
          [
            13.070412,
            54.318176,
            46.82248
          ],
          [
            13.0707,
            54.318088,
            46.386437
          ],
          [
            13.070942,
            54.31792,
            45.886397
          ],
          [
            13.071234,
            54.317758,
            45.350889
          ],
          [
            13.07148,
            54.317582,
            44.833054
          ],
          [
            13.071748,
            54.31742,
            44.319884
          ],
          [
            13.072069,
            54.317311,
            43.824174
          ],
          [
            13.072428,
            54.317214,
            43.297884
          ],
          [
            13.072782,
            54.317162,
            42.782808
          ],
          [
            13.073166,
            54.317183,
            42.166739
          ],
          [
            13.073511,
            54.317173,
            41.608517
          ],
          [
            13.073805,
            54.317111,
            41.10796
          ],
          [
            13.074186,
            54.317111,
            40.494792
          ],
          [
            13.074571,
            54.317072,
            39.870924
          ],
          [
            13.074982,
            54.317076,
            39.20795
          ],
          [
            13.075408,
            54.317083,
            38.52736
          ],
          [
            13.075769,
            54.317085,
            38.098415
          ],
          [
            13.076104,
            54.317077,
            38.504391
          ],
          [
            13.07641,
            54.317049,
            38.879446
          ],
          [
            13.076815,
            54.31697,
            39.397778
          ],
          [
            13.077148,
            54.316836,
            39.887545
          ],
          [
            13.077461,
            54.316771,
            40.292365
          ],
          [
            13.077789,
            54.316723,
            40.704985
          ],
          [
            13.078125,
            54.316679,
            41.123043
          ],
          [
            13.078511,
            54.316631,
            41.600883
          ],
          [
            13.07896,
            54.316477,
            41.993714
          ],
          [
            13.079234,
            54.316365,
            42.190884
          ],
          [
            13.079571,
            54.316293,
            42.4034
          ],
          [
            13.079912,
            54.316186,
            42.631188
          ],
          [
            13.080245,
            54.31615,
            42.832936
          ],
          [
            13.080565,
            54.316092,
            43.032187
          ],
          [
            13.080801,
            54.316176,
            43.220257
          ],
          [
            13.080865,
            54.316365,
            43.414596
          ],
          [
            13.08097,
            54.316549,
            43.634611
          ],
          [
            13.081174,
            54.316736,
            44.046215
          ],
          [
            13.081244,
            54.316968,
            44.483095
          ],
          [
            13.081327,
            54.317162,
            44.853096
          ],
          [
            13.081393,
            54.317377,
            45.258983
          ],
          [
            13.081466,
            54.317595,
            45.670125
          ],
          [
            13.081484,
            54.317816,
            46.080134
          ],
          [
            13.081545,
            54.318008,
            46.441525
          ],
          [
            13.081603,
            54.318225,
            46.849377
          ],
          [
            13.08172,
            54.318428,
            46.827804
          ],
          [
            13.081852,
            54.318602,
            46.742522
          ],
          [
            13.082017,
            54.3188,
            46.643697
          ],
          [
            13.08235,
            54.318766,
            46.550121
          ],
          [
            13.082666,
            54.31867,
            46.456973
          ],
          [
            13.082972,
            54.318583,
            46.367793
          ],
          [
            13.083258,
            54.318486,
            46.281311
          ],
          [
            13.08355,
            54.318366,
            46.187921
          ],
          [
            13.083877,
            54.318182,
            46.207073
          ],
          [
            13.08415,
            54.318014,
            46.520116
          ],
          [
            13.084462,
            54.317874,
            46.830835
          ],
          [
            13.084859,
            54.317892,
            47.159656
          ],
          [
            13.085156,
            54.318077,
            47.502201
          ],
          [
            13.085457,
            54.318259,
            47.844036
          ],
          [
            13.085742,
            54.318437,
            48.173297
          ],
          [
            13.086076,
            54.318578,
            48.50095
          ],
          [
            13.086483,
            54.31865,
            47.625985
          ],
          [
            13.086878,
            54.318716,
            46.649973
          ],
          [
            13.087295,
            54.318703,
            45.657053
          ],
          [
            13.087671,
            54.318584,
            44.639675
          ],
          [
            13.087961,
            54.318437,
            43.723755
          ],
          [
            13.088175,
            54.318252,
            42.809117
          ],
          [
            13.088194,
            54.318033,
            41.889563
          ],
          [
            13.088518,
            54.318024,
            41.286907
          ],
          [
            13.088782,
            54.317915,
            41.667626
          ],
          [
            13.089063,
            54.317769,
            42.091489
          ],
          [
            13.089212,
            54.317602,
            42.455373
          ],
          [
            13.089492,
            54.3175,
            42.840035
          ],
          [
            13.08981,
            54.317589,
            43.242613
          ],
          [
            13.090034,
            54.317751,
            43.644286
          ],
          [
            13.090304,
            54.317901,
            44.065967
          ],
          [
            13.090684,
            54.317947,
            44.511069
          ],
          [
            13.09109,
            54.317948,
            44.557206
          ],
          [
            13.091445,
            54.317923,
            44.362279
          ],
          [
            13.091755,
            54.317877,
            44.187585
          ],
          [
            13.092051,
            54.31776,
            43.993457
          ],
          [
            13.092342,
            54.317613,
            43.784622
          ],
          [
            13.092619,
            54.317452,
            43.572152
          ],
          [
            13.092898,
            54.31728,
            43.351928
          ],
          [
            13.093103,
            54.317144,
            43.18322
          ],
          [
            13.093339,
            54.316987,
            43.084412
          ],
          [
            13.093595,
            54.31684,
            43.526837
          ],
          [
            13.093855,
            54.316706,
            43.954259
          ],
          [
            13.094042,
            54.316525,
            44.404492
          ],
          [
            13.094321,
            54.316491,
            44.825473
          ],
          [
            13.094621,
            54.316575,
            45.235399
          ],
          [
            13.094832,
            54.316502,
            45.618635
          ],
          [
            13.094994,
            54.316298,
            46.093886
          ],
          [
            13.095158,
            54.316115,
            46.529759
          ],
          [
            13.095288,
            54.315941,
            46.651844
          ],
          [
            13.095421,
            54.315755,
            46.056491
          ],
          [
            13.095624,
            54.315583,
            45.431907
          ],
          [
            13.095807,
            54.315409,
            44.82981
          ],
          [
            13.095945,
            54.315224,
            44.232977
          ],
          [
            13.096082,
            54.315019,
            43.584053
          ],
          [
            13.096148,
            54.314806,
            42.940854
          ],
          [
            13.096184,
            54.314621,
            42.391889
          ],
          [
            13.096331,
            54.314431,
            41.776271
          ],
          [
            13.096388,
            54.314234,
            41.546158
          ],
          [
            13.096493,
            54.314043,
            41.610047
          ],
          [
            13.09657,
            54.313859,
            41.670398
          ],
          [
            13.096678,
            54.313674,
            41.73276
          ],
          [
            13.096926,
            54.313544,
            41.79957
          ],
          [
            13.09724,
            54.313623,
            41.863175
          ],
          [
            13.097549,
            54.313705,
            41.926447
          ],
          [
            13.097845,
            54.313678,
            41.986367
          ],
          [
            13.098112,
            54.313576,
            42.045668
          ],
          [
            13.098464,
            54.313489,
            41.92796
          ],
          [
            13.098765,
            54.313398,
            41.624423
          ],
          [
            13.098961,
            54.313216,
            41.296895
          ],
          [
            13.09915,
            54.313032,
            40.969934
          ],
          [
            13.099273,
            54.312841,
            40.65959
          ],
          [
            13.099424,
            54.312672,
            40.370001
          ],
          [
            13.099651,
            54.31252,
            40.063589
          ],
          [
            13.099891,
            54.312358,
            39.73827
          ],
          [
            13.100098,
            54.312185,
            39.417738
          ],
          [
            13.100326,
            54.31202,
            39.799699
          ],
          [
            13.100595,
            54.311854,
            40.407642
          ],
          [
            13.100861,
            54.311714,
            40.964239
          ],
          [
            13.101072,
            54.311568,
            41.478701
          ],
          [
            13.101185,
            54.311381,
            42.006497
          ],
          [
            13.101331,
            54.311171,
            42.609908
          ],
          [
            13.101477,
            54.310972,
            43.186019
          ],
          [
            13.101588,
            54.310751,
            43.799038
          ],
          [
            13.101739,
            54.310531,
            43.909699
          ],
          [
            13.101866,
            54.310303,
            43.409397
          ],
          [
            13.10201,
            54.310105,
            42.960189
          ],
          [
            13.102251,
            54.309971,
            42.55291
          ],
          [
            13.102505,
            54.309834,
            42.125443
          ],
          [
            13.102613,
            54.309655,
            41.729312
          ],
          [
            13.102733,
            54.309442,
            41.260874
          ],
          [
            13.102847,
            54.309261,
            40.858452
          ],
          [
            13.102962,
            54.309057,
            40.410295
          ],
          [
            13.103098,
            54.308849,
            40.644864
          ],
          [
            13.103425,
            54.308711,
            40.93553
          ],
          [
            13.103652,
            54.308529,
            41.214527
          ],
          [
            13.10381,
            54.308334,
            41.48065
          ],
          [
            13.103983,
            54.308145,
            41.744938
          ],
          [
            13.104143,
            54.307955,
            42.006048
          ],
          [
            13.104283,
            54.307788,
            42.235353
          ],
          [
            13.104453,
            54.307576,
            42.524041
          ],
          [
            13.104593,
            54.307406,
            42.477088
          ],
          [
            13.104736,
            54.307213,
            42.262816
          ],
          [
            13.104716,
            54.307012,
            42.058521
          ],
          [
            13.104851,
            54.30681,
            41.838143
          ],
          [
            13.105037,
            54.306637,
            41.630841
          ],
          [
            13.105214,
            54.306446,
            41.41054
          ],
          [
            13.105454,
            54.306294,
            41.200653
          ],
          [
            13.105682,
            54.306136,
            40.990495
          ],
          [
            13.105825,
            54.305955,
            40.787894
          ],
          [
            13.105962,
            54.30576,
            40.560637
          ],
          [
            13.106264,
            54.305756,
            40.340651
          ],
          [
            13.1063,
            54.30557,
            40.12663
          ],
          [
            13.106221,
            54.305407,
            39.929726
          ],
          [
            13.106236,
            54.305224,
            39.731809
          ],
          [
            13.106138,
            54.305031,
            39.513809
          ],
          [
            13.106,
            54.304835,
            39.284837
          ],
          [
            13.10595,
            54.304588,
            39.015404
          ],
          [
            13.106007,
            54.304383,
            38.943855
          ],
          [
            13.105976,
            54.30416,
            39.496786
          ],
          [
            13.106095,
            54.30398,
            39.980332
          ],
          [
            13.106166,
            54.303795,
            40.449879
          ],
          [
            13.106062,
            54.303588,
            40.981342
          ],
          [
            13.105924,
            54.303408,
            41.466399
          ],
          [
            13.105735,
            54.303231,
            41.978998
          ],
          [
            13.105597,
            54.303061,
            42.442001
          ],
          [
            13.105366,
            54.302895,
            42.967536
          ],
          [
            13.105161,
            54.302746,
            43.352676
          ],
          [
            13.104975,
            54.302578,
            43.613499
          ],
          [
            13.104807,
            54.302372,
            43.91017
          ],
          [
            13.104608,
            54.302161,
            44.22299
          ],
          [
            13.104419,
            54.301955,
            44.526478
          ],
          [
            13.104222,
            54.301729,
            44.856189
          ],
          [
            13.104078,
            54.301507,
            45.16456
          ],
          [
            13.10393,
            54.301297,
            45.459545
          ],
          [
            13.10378,
            54.3011,
            45.462757
          ],
          [
            13.103936,
            54.300936,
            45.242753
          ],
          [
            13.103609,
            54.300821,
            44.976993
          ],
          [
            13.103478,
            54.30064,
            44.747296
          ],
          [
            13.10337,
            54.300454,
            44.517742
          ],
          [
            13.103243,
            54.300267,
            44.282668
          ],
          [
            13.103108,
            54.300092,
            44.058465
          ],
          [
            13.102963,
            54.299922,
            43.836597
          ],
          [
            13.102831,
            54.299737,
            43.60251
          ],
          [
            13.102687,
            54.299526,
            43.375972
          ],
          [
            13.102573,
            54.29933,
            43.194478
          ],
          [
            13.102438,
            54.29911,
            42.989773
          ],
          [
            13.102321,
            54.298892,
            42.789655
          ],
          [
            13.102203,
            54.298678,
            42.59273
          ],
          [
            13.102072,
            54.29846,
            42.390349
          ],
          [
            13.101954,
            54.298226,
            42.176431
          ],
          [
            13.101851,
            54.298014,
            41.983388
          ],
          [
            13.10175,
            54.297808,
            41.944376
          ],
          [
            13.101649,
            54.297611,
            41.984655
          ],
          [
            13.101554,
            54.297417,
            42.024198
          ],
          [
            13.101468,
            54.297219,
            42.064258
          ],
          [
            13.101383,
            54.297013,
            42.105782
          ],
          [
            13.101355,
            54.296817,
            42.144414
          ],
          [
            13.101329,
            54.296591,
            42.18878
          ],
          [
            13.101266,
            54.296404,
            42.226164
          ],
          [
            13.101129,
            54.296192,
            42.283209
          ],
          [
            13.101002,
            54.296013,
            42.771799
          ],
          [
            13.10083,
            54.295839,
            43.278986
          ],
          [
            13.100659,
            54.295649,
            43.820723
          ],
          [
            13.100517,
            54.29548,
            44.295369
          ],
          [
            13.100321,
            54.295325,
            44.781347
          ],
          [
            13.100137,
            54.295158,
            45.282663
          ],
          [
            13.099904,
            54.294973,
            45.862271
          ],
          [
            13.09973,
            54.294824,
            46.31701
          ],
          [
            13.099518,
            54.294628,
            46.793503
          ],
          [
            13.0993,
            54.29445,
            46.728827
          ],
          [
            13.099084,
            54.294304,
            46.671874
          ],
          [
            13.098894,
            54.294136,
            46.612164
          ],
          [
            13.098634,
            54.294014,
            46.554236
          ],
          [
            13.098383,
            54.293882,
            46.496073
          ],
          [
            13.098105,
            54.29374,
            46.432476
          ],
          [
            13.097814,
            54.293612,
            46.369679
          ],
          [
            13.097517,
            54.293488,
            46.306781
          ],
          [
            13.097236,
            54.29339,
            46.308655
          ],
          [
            13.096923,
            54.293284,
            46.396343
          ],
          [
            13.096605,
            54.293196,
            46.48151
          ],
          [
            13.096622,
            54.29302,
            46.568414
          ],
          [
            13.096898,
            54.292923,
            46.646377
          ],
          [
            13.097266,
            54.292791,
            46.751053
          ],
          [
            13.097464,
            54.292619,
            46.842736
          ],
          [
            13.097577,
            54.292394,
            46.940833
          ],
          [
            13.097711,
            54.292226,
            47.017824
          ],
          [
            13.097797,
            54.292014,
            46.951601
          ],
          [
            13.097887,
            54.291796,
            46.878851
          ],
          [
            13.097925,
            54.291596,
            46.813498
          ],
          [
            13.097966,
            54.291382,
            46.743554
          ],
          [
            13.098037,
            54.291159,
            46.669948
          ],
          [
            13.098027,
            54.290912,
            46.589787
          ],
          [
            13.098063,
            54.290632,
            46.498679
          ],
          [
            13.098253,
            54.290469,
            46.454598
          ],
          [
            13.098687,
            54.290503,
            46.747472
          ],
          [
            13.099127,
            54.290503,
            47.041059
          ],
          [
            13.099499,
            54.290486,
            47.289553
          ],
          [
            13.099889,
            54.290488,
            47.550719
          ],
          [
            13.100214,
            54.290492,
            47.767247
          ],
          [
            13.100561,
            54.290505,
            47.998864
          ],
          [
            13.100897,
            54.290544,
            48.227171
          ],
          [
            13.101284,
            54.290543,
            48.485107
          ],
          [
            13.101604,
            54.290571,
            47.986426
          ],
          [
            13.10201,
            54.290599,
            47.338933
          ],
          [
            13.102381,
            54.290576,
            46.737404
          ],
          [
            13.102776,
            54.290558,
            46.109248
          ],
          [
            13.103035,
            54.290434,
            45.538094
          ],
          [
            13.10308,
            54.290187,
            44.865191
          ],
          [
            13.103106,
            54.289935,
            44.178572
          ],
          [
            13.103066,
            54.28974,
            43.646474
          ],
          [
            13.103086,
            54.289548,
            43.673396
          ],
          [
            13.103132,
            54.289352,
            43.735157
          ],
          [
            13.103138,
            54.289149,
            43.798471
          ],
          [
            13.103167,
            54.28894,
            43.863906
          ],
          [
            13.103195,
            54.288739,
            43.926883
          ],
          [
            13.103247,
            54.288546,
            43.987808
          ],
          [
            13.103273,
            54.28834,
            44.052304
          ],
          [
            13.10326,
            54.288093,
            44.129365
          ],
          [
            13.103313,
            54.287888,
            44.187984
          ],
          [
            13.103333,
            54.28767,
            44.231451
          ],
          [
            13.103315,
            54.287477,
            44.269769
          ],
          [
            13.103303,
            54.287253,
            44.314172
          ],
          [
            13.103326,
            54.287023,
            44.359803
          ],
          [
            13.103287,
            54.286799,
            44.404364
          ],
          [
            13.10327,
            54.286558,
            44.452238
          ],
          [
            13.103246,
            54.286333,
            44.496877
          ],
          [
            13.103178,
            54.286108,
            44.408566
          ],
          [
            13.103071,
            54.285919,
            43.844508
          ],
          [
            13.1031,
            54.285703,
            43.229187
          ],
          [
            13.103177,
            54.2855,
            42.636379
          ],
          [
            13.103072,
            54.285277,
            41.982373
          ],
          [
            13.103201,
            54.285046,
            41.290561
          ],
          [
            13.103344,
            54.284764,
            40.452879
          ],
          [
            13.103313,
            54.284477,
            39.638549
          ],
          [
            13.103233,
            54.284231,
            39.660559
          ],
          [
            13.103138,
            54.284036,
            39.895845
          ],
          [
            13.103128,
            54.283823,
            40.143025
          ],
          [
            13.103107,
            54.283631,
            40.36639
          ],
          [
            13.103096,
            54.283437,
            40.591528
          ],
          [
            13.103102,
            54.28324,
            40.819994
          ],
          [
            13.103301,
            54.283002,
            41.127069
          ],
          [
            13.103511,
            54.282801,
            41.400651
          ],
          [
            13.103722,
            54.282646,
            41.796525
          ],
          [
            13.103849,
            54.282455,
            42.455317
          ],
          [
            13.103904,
            54.282256,
            43.09025
          ],
          [
            13.104126,
            54.282114,
            43.688721
          ],
          [
            13.10443,
            54.281991,
            44.360962
          ],
          [
            13.104702,
            54.28186,
            45.005836
          ],
          [
            13.104927,
            54.281716,
            45.612529
          ],
          [
            13.10514,
            54.281567,
            46.216605
          ],
          [
            13.105402,
            54.281427,
            46.862425
          ],
          [
            13.105657,
            54.281267,
            47.330725
          ],
          [
            13.105877,
            54.281113,
            47.63279
          ],
          [
            13.10611,
            54.280947,
            47.956054
          ],
          [
            13.106332,
            54.280807,
            48.243774
          ],
          [
            13.106554,
            54.280665,
            48.533708
          ],
          [
            13.106774,
            54.280453,
            48.9078
          ],
          [
            13.106757,
            54.280452,
            49.188142
          ],
          [
            13.106908,
            54.28029,
            49.465943
          ],
          [
            13.106771,
            54.280448,
            49.736963
          ],
          [
            13.106768,
            54.280442,
            49.860659
          ],
          [
            13.106955,
            54.280294,
            49.884589
          ],
          [
            13.107179,
            54.280133,
            49.911562
          ],
          [
            13.107425,
            54.279967,
            49.940192
          ],
          [
            13.107662,
            54.279782,
            49.970237
          ],
          [
            13.107814,
            54.279617,
            49.994944
          ],
          [
            13.107963,
            54.279398,
            50.026009
          ],
          [
            13.1082,
            54.279238,
            50.053688
          ],
          [
            13.10851,
            54.279059,
            50.03784
          ],
          [
            13.108791,
            54.278877,
            49.938706
          ],
          [
            13.109153,
            54.278742,
            49.837298
          ],
          [
            13.109338,
            54.27858,
            49.758523
          ],
          [
            13.109558,
            54.278408,
            49.671686
          ],
          [
            13.109842,
            54.278228,
            49.572128
          ],
          [
            13.110123,
            54.278072,
            49.480467
          ],
          [
            13.110351,
            54.277933,
            49.402708
          ],
          [
            13.110599,
            54.277751,
            49.463244
          ],
          [
            13.110791,
            54.277518,
            49.76773
          ],
          [
            13.111053,
            54.277324,
            50.058679
          ],
          [
            13.111366,
            54.277142,
            50.362822
          ],
          [
            13.111696,
            54.276969,
            50.66757
          ],
          [
            13.111948,
            54.27685,
            50.890276
          ],
          [
            13.112211,
            54.276721,
            51.126639
          ],
          [
            13.112483,
            54.276586,
            51.371938
          ],
          [
            13.112788,
            54.276438,
            51.669241
          ],
          [
            13.113074,
            54.276299,
            51.962503
          ],
          [
            13.113376,
            54.276131,
            52.288445
          ],
          [
            13.113641,
            54.275988,
            52.570247
          ],
          [
            13.113907,
            54.275854,
            52.844653
          ],
          [
            13.114149,
            54.275731,
            53.095223
          ],
          [
            13.114385,
            54.275605,
            53.346157
          ],
          [
            13.114669,
            54.275433,
            53.665712
          ],
          [
            13.114933,
            54.275304,
            53.855681
          ],
          [
            13.115191,
            54.275163,
            53.793966
          ],
          [
            13.115347,
            54.274985,
            53.734045
          ],
          [
            13.115545,
            54.274787,
            53.665283
          ],
          [
            13.115834,
            54.274641,
            53.598617
          ],
          [
            13.116174,
            54.274473,
            53.520921
          ],
          [
            13.116507,
            54.274461,
            53.462708
          ],
          [
            13.116872,
            54.274356,
            53.391433
          ],
          [
            13.117253,
            54.27418,
            53.347782
          ],
          [
            13.117636,
            54.273986,
            53.398413
          ],
          [
            13.117961,
            54.273795,
            53.444485
          ],
          [
            13.118231,
            54.273634,
            53.483031
          ],
          [
            13.118526,
            54.273516,
            53.518797
          ],
          [
            13.118821,
            54.273367,
            53.557744
          ],
          [
            13.119065,
            54.273217,
            53.593166
          ],
          [
            13.119342,
            54.273069,
            53.630658
          ],
          [
            13.119592,
            54.272924,
            53.252772
          ],
          [
            13.119885,
            54.272766,
            52.648047
          ],
          [
            13.120184,
            54.272655,
            52.097284
          ],
          [
            13.120515,
            54.272815,
            51.434992
          ],
          [
            13.12088,
            54.272919,
            50.81353
          ],
          [
            13.121233,
            54.272855,
            50.246637
          ],
          [
            13.121599,
            54.272733,
            49.605972
          ],
          [
            13.121938,
            54.272629,
            49.025376
          ],
          [
            13.122246,
            54.272526,
            49.332476
          ],
          [
            13.122525,
            54.272427,
            49.704069
          ],
          [
            13.122845,
            54.272316,
            50.126801
          ],
          [
            13.123057,
            54.272171,
            50.500037
          ],
          [
            13.123223,
            54.272001,
            50.880648
          ],
          [
            13.123399,
            54.271841,
            51.250427
          ],
          [
            13.123573,
            54.271671,
            51.635664
          ],
          [
            13.123862,
            54.271567,
            52.021562
          ],
          [
            13.124133,
            54.27146,
            52.393023
          ],
          [
            13.124429,
            54.271351,
            52.554615
          ],
          [
            13.124728,
            54.271251,
            52.660031
          ],
          [
            13.125027,
            54.271139,
            52.768948
          ],
          [
            13.125356,
            54.271057,
            52.879913
          ],
          [
            13.125699,
            54.271009,
            52.987727
          ],
          [
            13.125974,
            54.270905,
            53.088824
          ],
          [
            13.126141,
            54.270728,
            53.194622
          ],
          [
            13.126438,
            54.270634,
            53.302985
          ],
          [
            13.126709,
            54.270524,
            53.404168
          ],
          [
            13.127012,
            54.270387,
            52.916641
          ],
          [
            13.127268,
            54.270245,
            52.442033
          ],
          [
            13.127618,
            54.270064,
            51.812349
          ],
          [
            13.127989,
            54.269944,
            51.241969
          ],
          [
            13.128297,
            54.269852,
            50.777078
          ],
          [
            13.128665,
            54.269741,
            50.219236
          ],
          [
            13.129051,
            54.269636,
            49.646023
          ],
          [
            13.129368,
            54.269566,
            49.249417
          ],
          [
            13.129667,
            54.269478,
            49.129802
          ],
          [
            13.130078,
            54.26939,
            48.973458
          ],
          [
            13.130408,
            54.269323,
            48.848711
          ],
          [
            13.130757,
            54.269256,
            48.717537
          ],
          [
            13.131115,
            54.26917,
            48.579316
          ],
          [
            13.131467,
            54.269106,
            48.447659
          ],
          [
            13.131823,
            54.269028,
            48.311895
          ],
          [
            13.132158,
            54.268968,
            48.186745
          ],
          [
            13.132466,
            54.268911,
            48.357746
          ],
          [
            13.132849,
            54.268855,
            48.620652
          ],
          [
            13.1332,
            54.268809,
            48.861942
          ],
          [
            13.133543,
            54.268774,
            49.09472
          ],
          [
            13.133873,
            54.268699,
            49.331189
          ],
          [
            13.134185,
            54.268628,
            49.555857
          ],
          [
            13.134517,
            54.268586,
            49.782475
          ],
          [
            13.134855,
            54.268556,
            50.010153
          ],
          [
            13.134989,
            54.268381,
            50.216195
          ],
          [
            13.135283,
            54.268262,
            50.012173
          ],
          [
            13.135218,
            54.268069,
            49.820198
          ],
          [
            13.135094,
            54.267863,
            49.609593
          ],
          [
            13.134974,
            54.267672,
            49.413404
          ],
          [
            13.134849,
            54.267471,
            49.207195
          ],
          [
            13.134687,
            54.267296,
            49.01525
          ],
          [
            13.134546,
            54.267119,
            48.826983
          ],
          [
            13.134439,
            54.266924,
            48.629496
          ],
          [
            13.134339,
            54.266715,
            48.466078
          ],
          [
            13.134642,
            54.266612,
            48.402788
          ],
          [
            13.134957,
            54.266548,
            48.344643
          ],
          [
            13.135229,
            54.266397,
            48.279322
          ],
          [
            13.135545,
            54.266315,
            48.218966
          ],
          [
            13.135942,
            54.266196,
            48.141047
          ],
          [
            13.136367,
            54.266102,
            48.061918
          ],
          [
            13.136652,
            54.266006,
            48.003769
          ],
          [
            13.13695,
            54.265871,
            48.117662
          ],
          [
            13.136711,
            54.265718,
            48.769432
          ],
          [
            13.136487,
            54.265587,
            49.336895
          ],
          [
            13.136251,
            54.265437,
            49.957455
          ],
          [
            13.136011,
            54.265237,
            50.701654
          ],
          [
            13.135827,
            54.265046,
            51.369469
          ],
          [
            13.135658,
            54.264879,
            51.961666
          ],
          [
            13.135431,
            54.264681,
            52.687524
          ],
          [
            13.135152,
            54.264486,
            53.441662
          ],
          [
            13.134963,
            54.264331,
            53.655091
          ],
          [
            13.134746,
            54.264187,
            53.869376
          ],
          [
            13.134411,
            54.263989,
            54.180774
          ],
          [
            13.134151,
            54.263882,
            54.388444
          ],
          [
            13.133858,
            54.26374,
            54.636766
          ],
          [
            13.133533,
            54.263618,
            54.888761
          ],
          [
            13.133308,
            54.263493,
            55.091527
          ],
          [
            13.132963,
            54.26334,
            55.374195
          ],
          [
            13.132698,
            54.263234,
            55.465766
          ],
          [
            13.132448,
            54.263104,
            55.506454
          ],
          [
            13.132193,
            54.262989,
            55.545582
          ],
          [
            13.131921,
            54.262862,
            55.587876
          ],
          [
            13.131624,
            54.262757,
            55.630183
          ],
          [
            13.131349,
            54.262631,
            55.67264
          ],
          [
            13.131105,
            54.262518,
            55.710474
          ],
          [
            13.130787,
            54.262399,
            55.756378
          ],
          [
            13.130507,
            54.262253,
            55.802061
          ],
          [
            13.130235,
            54.262101,
            55.730232
          ],
          [
            13.129933,
            54.261931,
            55.610372
          ],
          [
            13.129678,
            54.261779,
            55.506391
          ],
          [
            13.129439,
            54.261631,
            55.407001
          ],
          [
            13.129171,
            54.261468,
            55.296636
          ],
          [
            13.128869,
            54.26129,
            55.174185
          ],
          [
            13.128629,
            54.261129,
            55.069937
          ],
          [
            13.128321,
            54.260938,
            54.94146
          ],
          [
            13.128031,
            54.260764,
            54.870807
          ],
          [
            13.12771,
            54.260609,
            54.802877
          ],
          [
            13.127366,
            54.260472,
            54.735194
          ],
          [
            13.127058,
            54.260347,
            54.674223
          ],
          [
            13.126767,
            54.260247,
            54.619328
          ],
          [
            13.126426,
            54.260149,
            54.557546
          ],
          [
            13.126052,
            54.260062,
            54.492069
          ],
          [
            13.125713,
            54.259983,
            54.442444
          ],
          [
            13.125366,
            54.259893,
            54.912157
          ],
          [
            13.125043,
            54.259804,
            55.353656
          ],
          [
            13.124729,
            54.259722,
            55.778756
          ],
          [
            13.124446,
            54.259621,
            56.190076
          ],
          [
            13.124237,
            54.259443,
            56.650169
          ],
          [
            13.124137,
            54.259228,
            57.121667
          ],
          [
            13.12399,
            54.259009,
            57.619381
          ],
          [
            13.12384,
            54.258772,
            58.154177
          ],
          [
            13.123702,
            54.258566,
            58.343063
          ],
          [
            13.123549,
            54.258361,
            58.471236
          ],
          [
            13.123384,
            54.25816,
            58.598993
          ],
          [
            13.123234,
            54.257977,
            58.715267
          ],
          [
            13.123067,
            54.25781,
            58.826251
          ],
          [
            13.122832,
            54.257645,
            58.949159
          ],
          [
            13.122618,
            54.257448,
            59.082869
          ],
          [
            13.122348,
            54.257266,
            59.22078
          ],
          [
            13.122141,
            54.257117,
            59.171129
          ],
          [
            13.121859,
            54.256941,
            58.95183
          ],
          [
            13.121638,
            54.256788,
            58.76978
          ],
          [
            13.121424,
            54.256636,
            58.589967
          ],
          [
            13.121236,
            54.256443,
            58.388111
          ],
          [
            13.121044,
            54.256252,
            58.186617
          ],
          [
            13.1212,
            54.256084,
            58.011168
          ],
          [
            13.12144,
            54.255915,
            57.81137
          ],
          [
            13.121656,
            54.255734,
            57.66996
          ],
          [
            13.121841,
            54.255564,
            57.948825
          ],
          [
            13.122094,
            54.255403,
            58.251096
          ],
          [
            13.122327,
            54.255265,
            58.519238
          ],
          [
            13.122565,
            54.255097,
            58.821194
          ],
          [
            13.122824,
            54.254993,
            59.076651
          ],
          [
            13.123063,
            54.254841,
            59.362166
          ],
          [
            13.123296,
            54.254699,
            59.634432
          ],
          [
            13.123511,
            54.254535,
            59.921746
          ],
          [
            13.123712,
            54.25439,
            60.192797
          ],
          [
            13.123946,
            54.25424,
            60.529129
          ],
          [
            13.124186,
            54.254078,
            60.886185
          ],
          [
            13.124436,
            54.253928,
            61.233171
          ],
          [
            13.124684,
            54.253759,
            61.602118
          ],
          [
            13.124921,
            54.253585,
            61.971237
          ],
          [
            13.125174,
            54.253458,
            62.294215
          ],
          [
            13.125432,
            54.253298,
            62.658481
          ],
          [
            13.125681,
            54.253147,
            63.006248
          ],
          [
            13.125949,
            54.252964,
            62.321514
          ],
          [
            13.126217,
            54.252785,
            61.306074
          ],
          [
            13.126433,
            54.25261,
            60.38336
          ],
          [
            13.126664,
            54.252471,
            59.556971
          ],
          [
            13.126901,
            54.252314,
            58.663643
          ],
          [
            13.127115,
            54.25218,
            57.88168
          ],
          [
            13.127338,
            54.252021,
            57.004007
          ],
          [
            13.12758,
            54.251835,
            56.00568
          ],
          [
            13.127844,
            54.251663,
            55.418533
          ],
          [
            13.128151,
            54.251476,
            55.387961
          ],
          [
            13.128399,
            54.25132,
            55.362775
          ],
          [
            13.128647,
            54.251153,
            55.336632
          ],
          [
            13.1289,
            54.250988,
            55.310493
          ],
          [
            13.129157,
            54.250821,
            55.283996
          ],
          [
            13.129418,
            54.250712,
            55.261849
          ],
          [
            13.129695,
            54.250538,
            55.233812
          ],
          [
            13.12998,
            54.250359,
            55.246245
          ],
          [
            13.130222,
            54.25019,
            55.304695
          ],
          [
            13.13047,
            54.250024,
            55.363125
          ],
          [
            13.130668,
            54.249879,
            55.412314
          ],
          [
            13.130887,
            54.249727,
            55.465055
          ],
          [
            13.13112,
            54.249564,
            55.521374
          ],
          [
            13.131367,
            54.24941,
            55.577344
          ],
          [
            13.131634,
            54.249266,
            55.633792
          ],
          [
            13.131857,
            54.249088,
            55.692287
          ],
          [
            13.132111,
            54.24894,
            55.95142
          ],
          [
            13.132341,
            54.248781,
            56.217517
          ],
          [
            13.132588,
            54.248612,
            56.501429
          ],
          [
            13.132732,
            54.248441,
            56.745985
          ],
          [
            13.132994,
            54.248295,
            57.016297
          ],
          [
            13.133266,
            54.248172,
            57.272969
          ],
          [
            13.133557,
            54.248044,
            57.544782
          ],
          [
            13.133891,
            54.247944,
            57.824978
          ],
          [
            13.134192,
            54.247845,
            58.088783
          ],
          [
            13.13451,
            54.247765,
            58.364528
          ],
          [
            13.134848,
            54.247705,
            58.646408
          ],
          [
            13.135183,
            54.247627,
            58.932825
          ],
          [
            13.135517,
            54.247544,
            59.221001
          ],
          [
            13.13589,
            54.247472,
            59.533144
          ],
          [
            13.136253,
            54.247394,
            59.840928
          ],
          [
            13.136613,
            54.247306,
            60.150818
          ],
          [
            13.136978,
            54.247238,
            60.418639
          ],
          [
            13.137345,
            54.247171,
            60.160119
          ],
          [
            13.137694,
            54.2471,
            59.9117
          ],
          [
            13.138072,
            54.247026,
            59.643673
          ],
          [
            13.138421,
            54.246934,
            59.386202
          ],
          [
            13.13879,
            54.246855,
            59.122011
          ],
          [
            13.139148,
            54.246784,
            58.867406
          ],
          [
            13.139464,
            54.246708,
            58.637127
          ],
          [
            13.139795,
            54.24665,
            58.404735
          ],
          [
            13.140147,
            54.246555,
            58.304474
          ],
          [
            13.140467,
            54.24649,
            58.241089
          ],
          [
            13.140809,
            54.246415,
            58.172987
          ],
          [
            13.141181,
            54.246327,
            58.098157
          ],
          [
            13.141688,
            54.246228,
            57.998587
          ],
          [
            13.142001,
            54.246142,
            57.93417
          ],
          [
            13.142375,
            54.246046,
            57.85802
          ],
          [
            13.142784,
            54.245952,
            57.690365
          ],
          [
            13.143146,
            54.245869,
            57.243922
          ],
          [
            13.143497,
            54.245789,
            56.811429
          ],
          [
            13.143857,
            54.245711,
            56.369685
          ],
          [
            13.144161,
            54.245646,
            55.997947
          ],
          [
            13.144523,
            54.245585,
            55.565253
          ],
          [
            13.144859,
            54.245497,
            55.142414
          ],
          [
            13.14518,
            54.245412,
            54.736749
          ],
          [
            13.14554,
            54.245353,
            54.30754
          ],
          [
            13.145826,
            54.24526,
            54.104386
          ],
          [
            13.146176,
            54.24518,
            53.90313
          ],
          [
            13.146507,
            54.245091,
            53.7078
          ],
          [
            13.146869,
            54.245039,
            53.506122
          ],
          [
            13.14723,
            54.244965,
            53.301259
          ],
          [
            13.147574,
            54.244913,
            53.110952
          ],
          [
            13.147923,
            54.244825,
            52.907376
          ],
          [
            13.148287,
            54.244726,
            52.692065
          ],
          [
            13.148683,
            54.244643,
            53.128273
          ],
          [
            13.149064,
            54.244543,
            53.928609
          ],
          [
            13.149458,
            54.244454,
            54.737752
          ],
          [
            13.149845,
            54.244377,
            55.520734
          ],
          [
            13.150222,
            54.244288,
            56.299523
          ],
          [
            13.150607,
            54.244212,
            57.077883
          ],
          [
            13.150979,
            54.244126,
            57.844052
          ],
          [
            13.151373,
            54.244042,
            58.463703
          ],
          [
            13.15171,
            54.243944,
            58.248347
          ],
          [
            13.152069,
            54.243872,
            58.031254
          ],
          [
            13.152467,
            54.243773,
            57.784344
          ],
          [
            13.15283,
            54.2437,
            57.565278
          ],
          [
            13.153127,
            54.243625,
            57.380632
          ],
          [
            13.153447,
            54.243554,
            57.185325
          ],
          [
            13.153785,
            54.243487,
            56.981458
          ],
          [
            13.154106,
            54.243418,
            56.786196
          ],
          [
            13.154401,
            54.24334,
            56.677702
          ],
          [
            13.15477,
            54.243267,
            56.569851
          ],
          [
            13.15508,
            54.243212,
            56.479827
          ],
          [
            13.155428,
            54.243136,
            56.376186
          ],
          [
            13.155737,
            54.243054,
            56.28121
          ],
          [
            13.156052,
            54.242971,
            56.185541
          ],
          [
            13.156404,
            54.242885,
            56.079903
          ],
          [
            13.156718,
            54.242844,
            55.990512
          ],
          [
            13.157083,
            54.242764,
            55.96789
          ],
          [
            13.157414,
            54.242695,
            56.424942
          ],
          [
            13.157705,
            54.242609,
            56.849123
          ],
          [
            13.158012,
            54.24254,
            57.27703
          ],
          [
            13.158302,
            54.242477,
            57.683359
          ],
          [
            13.158646,
            54.242392,
            58.169075
          ],
          [
            13.158988,
            54.242316,
            58.645408
          ],
          [
            13.159344,
            54.242238,
            59.140307
          ],
          [
            13.159659,
            54.242154,
            59.591963
          ],
          [
            13.159976,
            54.242097,
            59.888146
          ],
          [
            13.160285,
            54.242006,
            59.843432
          ],
          [
            13.160689,
            54.241953,
            59.789927
          ],
          [
            13.161099,
            54.241867,
            59.733645
          ],
          [
            13.161407,
            54.241797,
            59.690952
          ],
          [
            13.161722,
            54.241718,
            59.646507
          ],
          [
            13.162137,
            54.241631,
            59.589525
          ],
          [
            13.162461,
            54.241541,
            59.543172
          ],
          [
            13.16283,
            54.241465,
            59.49202
          ],
          [
            13.163204,
            54.241376,
            59.43672
          ],
          [
            13.163582,
            54.241297,
            59.38176
          ],
          [
            13.163951,
            54.24121,
            59.327268
          ],
          [
            13.164322,
            54.241119,
            59.272164
          ],
          [
            13.164703,
            54.241055,
            59.217785
          ],
          [
            13.165036,
            54.241009,
            59.170743
          ],
          [
            13.165385,
            54.24094,
            59.120264
          ],
          [
            13.165732,
            54.240854,
            59.120961
          ],
          [
            13.16607,
            54.240768,
            59.276371
          ],
          [
            13.166431,
            54.240686,
            59.439464
          ],
          [
            13.166837,
            54.240588,
            59.62414
          ],
          [
            13.167186,
            54.240509,
            59.782063
          ],
          [
            13.167508,
            54.240468,
            59.920646
          ],
          [
            13.167906,
            54.240414,
            60.093315
          ],
          [
            13.16827,
            54.240347,
            60.255117
          ],
          [
            13.168658,
            54.24025,
            60.209186
          ],
          [
            13.169022,
            54.24016,
            59.726712
          ],
          [
            13.169375,
            54.240088,
            59.270671
          ],
          [
            13.169755,
            54.239999,
            58.7711
          ],
          [
            13.170112,
            54.239921,
            58.306213
          ],
          [
            13.170494,
            54.239843,
            57.812637
          ],
          [
            13.170827,
            54.239769,
            57.378043
          ],
          [
            13.171172,
            54.239689,
            56.925193
          ],
          [
            13.171509,
            54.239601,
            56.473967
          ],
          [
            13.171865,
            54.23952,
            56.005099
          ],
          [
            13.172195,
            54.239435,
            55.562595
          ],
          [
            13.172537,
            54.239369,
            55.120633
          ],
          [
            13.172849,
            54.239307,
            54.715747
          ],
          [
            13.173169,
            54.239251,
            54.304822
          ],
          [
            13.173445,
            54.239315,
            53.890274
          ],
          [
            13.173463,
            54.239308,
            53.468617
          ],
          [
            13.173504,
            54.239098,
            53.024819
          ],
          [
            13.173525,
            54.238892,
            52.996488
          ],
          [
            13.173542,
            54.238705,
            53.232581
          ],
          [
            13.173539,
            54.23849,
            53.502526
          ],
          [
            13.173592,
            54.238279,
            53.773478
          ],
          [
            13.173654,
            54.238064,
            54.047248
          ],
          [
            13.17364,
            54.237859,
            54.305895
          ],
          [
            13.17355,
            54.237662,
            54.561982
          ],
          [
            13.173523,
            54.23743,
            54.853925
          ],
          [
            13.173563,
            54.237245,
            55.090529
          ],
          [
            13.173484,
            54.23709,
            55.392658
          ],
          [
            13.173095,
            54.237108,
            55.750382
          ],
          [
            13.172781,
            54.237115,
            56.04215
          ],
          [
            13.172412,
            54.237119,
            56.380669
          ],
          [
            13.17204,
            54.237104,
            56.722217
          ],
          [
            13.171649,
            54.237137,
            57.083888
          ],
          [
            13.171302,
            54.237137,
            57.40156
          ],
          [
            13.170907,
            54.237136,
            57.763243
          ],
          [
            13.170552,
            54.237128,
            57.92904
          ],
          [
            13.170193,
            54.237146,
            57.946411
          ],
          [
            13.169858,
            54.237099,
            57.963021
          ],
          [
            13.169497,
            54.237024,
            57.981476
          ],
          [
            13.169175,
            54.236935,
            57.998642
          ],
          [
            13.168826,
            54.236857,
            58.016641
          ],
          [
            13.16854,
            54.236773,
            58.03207
          ],
          [
            13.168294,
            54.236568,
            58.053962
          ],
          [
            13.168492,
            54.236366,
            57.953099
          ],
          [
            13.168749,
            54.23623,
            57.605012
          ],
          [
            13.168555,
            54.236379,
            57.295785
          ],
          [
            13.168336,
            54.236549,
            56.937944
          ],
          [
            13.168425,
            54.236705,
            56.610414
          ],
          [
            13.168739,
            54.236769,
            56.289367
          ],
          [
            13.169096,
            54.236844,
            55.923266
          ],
          [
            13.169438,
            54.236925,
            55.566938
          ],
          [
            13.169769,
            54.237011,
            55.217118
          ],
          [
            13.170046,
            54.237105,
            55.248632
          ],
          [
            13.170365,
            54.23712,
            55.497813
          ],
          [
            13.170721,
            54.237107,
            55.768742
          ],
          [
            13.171104,
            54.237104,
            56.059731
          ],
          [
            13.171489,
            54.237081,
            56.354118
          ],
          [
            13.171934,
            54.237089,
            56.692346
          ],
          [
            13.172328,
            54.237098,
            56.991821
          ],
          [
            13.172756,
            54.237077,
            57.318037
          ],
          [
            13.173138,
            54.237086,
            57.390587
          ],
          [
            13.173565,
            54.237087,
            57.304955
          ],
          [
            13.17392,
            54.237027,
            57.230938
          ],
          [
            13.174189,
            54.236908,
            57.163305
          ],
          [
            13.174192,
            54.236928,
            57.085547
          ],
          [
            13.173899,
            54.237024,
            57.017652
          ],
          [
            13.173658,
            54.237171,
            56.947945
          ],
          [
            13.173554,
            54.23736,
            56.878917
          ],
          [
            13.1736,
            54.237571,
            56.719839
          ],
          [
            13.173629,
            54.237774,
            56.22557
          ],
          [
            13.17371,
            54.238016,
            55.623179
          ],
          [
            13.173687,
            54.238246,
            55.062609
          ],
          [
            13.173634,
            54.238439,
            54.58844
          ],
          [
            13.173548,
            54.238653,
            54.053373
          ],
          [
            13.17354,
            54.238845,
            53.587159
          ],
          [
            13.173525,
            54.23903,
            53.137398
          ],
          [
            13.173765,
            54.239137,
            52.6484
          ],
          [
            13.174123,
            54.239131,
            52.010193
          ],
          [
            13.174521,
            54.239133,
            51.212803
          ],
          [
            13.174855,
            54.239088,
            50.527338
          ],
          [
            13.175314,
            54.23903,
            49.587431
          ],
          [
            13.175799,
            54.238991,
            48.608771
          ],
          [
            13.176211,
            54.238962,
            47.779052
          ],
          [
            13.176724,
            54.238932,
            46.748468
          ],
          [
            13.177107,
            54.238929,
            46.214221
          ],
          [
            13.17749,
            54.239009,
            45.982595
          ],
          [
            13.177839,
            54.239109,
            45.761877
          ],
          [
            13.178239,
            54.239226,
            45.50867
          ],
          [
            13.178516,
            54.239343,
            45.315452
          ],
          [
            13.178827,
            54.239517,
            45.072044
          ],
          [
            13.17917,
            54.239626,
            44.849753
          ],
          [
            13.179592,
            54.239675,
            44.606636
          ],
          [
            13.179974,
            54.239656,
            45.366455
          ],
          [
            13.180252,
            54.239542,
            46.211887
          ],
          [
            13.180501,
            54.239402,
            47.073924
          ],
          [
            13.18077,
            54.239255,
            47.990101
          ],
          [
            13.181006,
            54.239118,
            48.817423
          ],
          [
            13.181249,
            54.238992,
            49.625374
          ],
          [
            13.181491,
            54.238863,
            50.440044
          ],
          [
            13.181733,
            54.238737,
            51.246454
          ],
          [
            13.182014,
            54.238604,
            52.14757
          ],
          [
            13.18225,
            54.238475,
            52.614976
          ],
          [
            13.182486,
            54.23834,
            53.058586
          ],
          [
            13.182721,
            54.238195,
            53.517089
          ],
          [
            13.18297,
            54.238056,
            53.979072
          ],
          [
            13.183237,
            54.237915,
            54.461879
          ],
          [
            13.183489,
            54.237768,
            54.940386
          ],
          [
            13.18372,
            54.237635,
            55.375431
          ],
          [
            13.184018,
            54.237527,
            55.849511
          ],
          [
            13.184043,
            54.237329,
            56.315861
          ],
          [
            13.184349,
            54.237201,
            56.567844
          ],
          [
            13.18463,
            54.237052,
            56.80378
          ],
          [
            13.184862,
            54.236926,
            57.000501
          ],
          [
            13.185124,
            54.236787,
            57.220108
          ],
          [
            13.185374,
            54.236656,
            57.428444
          ],
          [
            13.185646,
            54.236519,
            57.651357
          ],
          [
            13.185918,
            54.236391,
            57.868065
          ],
          [
            13.186245,
            54.236253,
            58.118377
          ],
          [
            13.186554,
            54.236115,
            58.163555
          ],
          [
            13.186869,
            54.235986,
            57.935141
          ],
          [
            13.187211,
            54.235852,
            57.690684
          ],
          [
            13.187606,
            54.235701,
            57.410048
          ],
          [
            13.187949,
            54.235591,
            57.177784
          ],
          [
            13.188228,
            54.235502,
            56.987762
          ],
          [
            13.188526,
            54.235412,
            56.788091
          ],
          [
            13.188837,
            54.235318,
            56.580159
          ],
          [
            13.18914,
            54.235209,
            56.265177
          ],
          [
            13.189512,
            54.23509,
            55.622637
          ],
          [
            13.189865,
            54.23495,
            54.975976
          ],
          [
            13.190259,
            54.234822,
            54.292922
          ],
          [
            13.190667,
            54.234689,
            53.585034
          ],
          [
            13.191128,
            54.234534,
            52.778593
          ],
          [
            13.191572,
            54.23436,
            51.968169
          ],
          [
            13.192003,
            54.234212,
            51.490968
          ],
          [
            13.192426,
            54.234052,
            51.10962
          ],
          [
            13.1928,
            54.233932,
            50.787018
          ],
          [
            13.193119,
            54.233822,
            50.507087
          ],
          [
            13.193445,
            54.233716,
            50.225201
          ],
          [
            13.193744,
            54.233587,
            49.944057
          ],
          [
            13.194097,
            54.233484,
            49.64588
          ],
          [
            13.19446,
            54.233335,
            48.993369
          ],
          [
            13.194802,
            54.233249,
            48.04993
          ],
          [
            13.195191,
            54.233116,
            46.908183
          ],
          [
            13.195474,
            54.23302,
            46.071811
          ],
          [
            13.195763,
            54.232898,
            45.16868
          ],
          [
            13.1961,
            54.232751,
            44.103393
          ],
          [
            13.196472,
            54.23262,
            43.000081
          ],
          [
            13.196855,
            54.232483,
            41.860726
          ],
          [
            13.197242,
            54.232365,
            41.481988
          ],
          [
            13.197595,
            54.232262,
            41.295313
          ],
          [
            13.19792,
            54.232139,
            41.11214
          ],
          [
            13.198229,
            54.232035,
            40.943402
          ],
          [
            13.198617,
            54.231895,
            40.72669
          ],
          [
            13.198952,
            54.231801,
            40.550845
          ],
          [
            13.199276,
            54.23168,
            40.368792
          ],
          [
            13.199559,
            54.231557,
            40.201945
          ],
          [
            13.199885,
            54.231461,
            40.425535
          ],
          [
            13.200175,
            54.231358,
            40.65227
          ],
          [
            13.200482,
            54.231275,
            40.87851
          ],
          [
            13.200779,
            54.231172,
            41.109862
          ],
          [
            13.201083,
            54.231058,
            41.351386
          ],
          [
            13.201407,
            54.230947,
            41.60224
          ],
          [
            13.201733,
            54.230818,
            41.865186
          ],
          [
            13.202056,
            54.230712,
            42.112791
          ],
          [
            13.202377,
            54.230588,
            42.749201
          ],
          [
            13.202673,
            54.23049,
            43.67698
          ],
          [
            13.202969,
            54.230388,
            44.615702
          ],
          [
            13.203265,
            54.230281,
            45.565311
          ],
          [
            13.203562,
            54.230186,
            46.490196
          ],
          [
            13.203852,
            54.230097,
            47.389042
          ],
          [
            13.204172,
            54.229986,
            48.404551
          ],
          [
            13.204458,
            54.229885,
            49.316071
          ],
          [
            13.204758,
            54.229784,
            50.263567
          ],
          [
            13.205082,
            54.229676,
            51.129014
          ],
          [
            13.205378,
            54.229568,
            51.853549
          ],
          [
            13.205645,
            54.229459,
            52.528864
          ],
          [
            13.205954,
            54.229365,
            53.253222
          ],
          [
            13.206232,
            54.229259,
            53.942492
          ],
          [
            13.206543,
            54.229161,
            54.675793
          ],
          [
            13.20685,
            54.229059,
            55.408018
          ],
          [
            13.207142,
            54.228959,
            56.109815
          ],
          [
            13.207475,
            54.228839,
            56.921644
          ],
          [
            13.207788,
            54.228731,
            56.961567
          ],
          [
            13.208062,
            54.228617,
            56.899592
          ],
          [
            13.208383,
            54.228509,
            56.831395
          ],
          [
            13.208727,
            54.2284,
            56.759345
          ],
          [
            13.209042,
            54.228264,
            56.687201
          ],
          [
            13.209343,
            54.228145,
            56.620244
          ],
          [
            13.209656,
            54.228036,
            56.553151
          ],
          [
            13.209976,
            54.227929,
            56.485158
          ],
          [
            13.210283,
            54.227826,
            56.37196
          ],
          [
            13.210586,
            54.227726,
            56.215908
          ],
          [
            13.210921,
            54.227621,
            56.045399
          ],
          [
            13.211251,
            54.227508,
            55.873707
          ],
          [
            13.211559,
            54.227394,
            55.710217
          ],
          [
            13.211867,
            54.227274,
            55.54425
          ],
          [
            13.212169,
            54.22717,
            55.386954
          ],
          [
            13.212496,
            54.227049,
            55.213383
          ],
          [
            13.21284,
            54.226932,
            55.057555
          ],
          [
            13.213201,
            54.226817,
            54.980707
          ],
          [
            13.213531,
            54.226704,
            54.909234
          ],
          [
            13.213882,
            54.226567,
            54.830341
          ],
          [
            13.214234,
            54.226433,
            54.75179
          ],
          [
            13.214607,
            54.226332,
            54.674923
          ],
          [
            13.214979,
            54.226203,
            54.594085
          ],
          [
            13.215318,
            54.226092,
            54.521465
          ],
          [
            13.215632,
            54.225958,
            54.478559
          ],
          [
            13.215963,
            54.225835,
            54.449011
          ],
          [
            13.216305,
            54.225725,
            54.419566
          ],
          [
            13.216657,
            54.225611,
            54.389264
          ],
          [
            13.217005,
            54.225492,
            54.358902
          ],
          [
            13.217342,
            54.225386,
            54.330098
          ],
          [
            13.217662,
            54.22526,
            54.301062
          ],
          [
            13.217997,
            54.22514,
            54.271434
          ],
          [
            13.218345,
            54.225038,
            54.558333
          ],
          [
            13.218653,
            54.224921,
            54.880369
          ],
          [
            13.218998,
            54.224798,
            55.233771
          ],
          [
            13.219321,
            54.224678,
            55.568476
          ],
          [
            13.219618,
            54.224555,
            55.887257
          ],
          [
            13.219937,
            54.224458,
            56.201821
          ],
          [
            13.220263,
            54.224362,
            56.521086
          ],
          [
            13.220604,
            54.224242,
            56.869276
          ],
          [
            13.220907,
            54.224141,
            56.993584
          ],
          [
            13.221202,
            54.224047,
            57.04212
          ],
          [
            13.221482,
            54.223953,
            57.088677
          ],
          [
            13.221828,
            54.223836,
            57.146315
          ],
          [
            13.222131,
            54.223738,
            57.196273
          ],
          [
            13.222416,
            54.223645,
            57.243344
          ],
          [
            13.222686,
            54.223532,
            57.291225
          ],
          [
            13.223,
            54.223425,
            57.343632
          ],
          [
            13.223303,
            54.223322,
            57.394244
          ],
          [
            13.223629,
            54.223207,
            56.994235
          ],
          [
            13.223924,
            54.223105,
            56.569443
          ],
          [
            13.224228,
            54.222987,
            56.119312
          ],
          [
            13.224556,
            54.222875,
            55.650779
          ],
          [
            13.224898,
            54.222759,
            55.163234
          ],
          [
            13.225221,
            54.222657,
            54.710075
          ],
          [
            13.22557,
            54.222536,
            54.209458
          ],
          [
            13.225875,
            54.222418,
            53.758542
          ],
          [
            13.226233,
            54.222274,
            53.683023
          ],
          [
            13.226564,
            54.222173,
            53.772374
          ],
          [
            13.226884,
            54.222057,
            53.862062
          ],
          [
            13.227196,
            54.221942,
            53.95065
          ],
          [
            13.227587,
            54.221814,
            54.057502
          ],
          [
            13.22792,
            54.221681,
            54.153747
          ],
          [
            13.228213,
            54.221582,
            54.234344
          ],
          [
            13.228563,
            54.221471,
            54.329194
          ],
          [
            13.228888,
            54.221344,
            54.194387
          ],
          [
            13.229235,
            54.221215,
            54.017204
          ],
          [
            13.229625,
            54.221096,
            53.827535
          ],
          [
            13.229984,
            54.220994,
            53.655495
          ],
          [
            13.230292,
            54.220866,
            53.492549
          ],
          [
            13.230644,
            54.220741,
            53.315112
          ],
          [
            13.231011,
            54.220608,
            53.128856
          ],
          [
            13.23136,
            54.220498,
            53.03464
          ],
          [
            13.231722,
            54.220386,
            53.091828
          ],
          [
            13.232058,
            54.220243,
            53.149926
          ],
          [
            13.232378,
            54.220141,
            53.200819
          ],
          [
            13.232688,
            54.220033,
            53.251221
          ],
          [
            13.233009,
            54.219925,
            53.302959
          ],
          [
            13.233304,
            54.219813,
            53.352076
          ],
          [
            13.233616,
            54.21972,
            53.400981
          ],
          [
            13.233956,
            54.219602,
            53.407388
          ],
          [
            13.234299,
            54.219469,
            53.205898
          ],
          [
            13.234634,
            54.21937,
            53.022894
          ],
          [
            13.234953,
            54.21925,
            52.837728
          ],
          [
            13.23526,
            54.219129,
            52.656489
          ],
          [
            13.235575,
            54.219026,
            52.480465
          ],
          [
            13.235927,
            54.218938,
            52.292216
          ],
          [
            13.236277,
            54.218841,
            52.103429
          ],
          [
            13.236557,
            54.218672,
            51.966962
          ],
          [
            13.236875,
            54.218562,
            52.055649
          ],
          [
            13.237188,
            54.218463,
            52.140558
          ],
          [
            13.237523,
            54.218361,
            52.230665
          ],
          [
            13.237837,
            54.218257,
            52.316715
          ],
          [
            13.238126,
            54.218126,
            52.40404
          ],
          [
            13.238489,
            54.218004,
            52.504137
          ],
          [
            13.238819,
            54.217895,
            52.594516
          ],
          [
            13.239148,
            54.21778,
            52.663371
          ],
          [
            13.239453,
            54.217683,
            52.426244
          ],
          [
            13.239765,
            54.21758,
            52.181476
          ],
          [
            13.240072,
            54.217461,
            51.929881
          ],
          [
            13.240386,
            54.217345,
            51.675703
          ],
          [
            13.240703,
            54.217229,
            51.419981
          ],
          [
            13.240995,
            54.217127,
            51.18757
          ],
          [
            13.241335,
            54.217006,
            50.915483
          ],
          [
            13.241656,
            54.216897,
            50.661876
          ],
          [
            13.242029,
            54.216794,
            50.640344
          ],
          [
            13.242364,
            54.216677,
            50.722151
          ],
          [
            13.242674,
            54.216545,
            50.802549
          ],
          [
            13.242985,
            54.216464,
            50.873983
          ],
          [
            13.243225,
            54.216342,
            50.942372
          ],
          [
            13.243517,
            54.216239,
            51.014432
          ],
          [
            13.243888,
            54.216138,
            51.100323
          ],
          [
            13.244203,
            54.216138,
            51.173236
          ],
          [
            13.244502,
            54.216044,
            51.261165
          ],
          [
            13.244831,
            54.21595,
            51.401049
          ],
          [
            13.245127,
            54.215857,
            51.529376
          ],
          [
            13.245417,
            54.215757,
            51.657942
          ],
          [
            13.245694,
            54.215647,
            51.785808
          ],
          [
            13.245967,
            54.215515,
            51.921204
          ],
          [
            13.246275,
            54.215396,
            52.062291
          ],
          [
            13.246625,
            54.215264,
            52.22134
          ],
          [
            13.246968,
            54.215134,
            52.377454
          ],
          [
            13.247341,
            54.215024,
            52.51764
          ],
          [
            13.247658,
            54.214895,
            52.643913
          ],
          [
            13.24802,
            54.214772,
            52.780773
          ],
          [
            13.248321,
            54.214659,
            52.897735
          ],
          [
            13.248621,
            54.214561,
            53.010065
          ],
          [
            13.248909,
            54.214455,
            53.121324
          ],
          [
            13.249221,
            54.214361,
            53.236119
          ],
          [
            13.249545,
            54.214258,
            53.356688
          ],
          [
            13.249875,
            54.214155,
            53.165494
          ],
          [
            13.25019,
            54.214041,
            52.779671
          ],
          [
            13.250465,
            54.213934,
            52.435318
          ],
          [
            13.250813,
            54.213819,
            52.014468
          ],
          [
            13.251065,
            54.21392,
            51.687654
          ],
          [
            13.250979,
            54.213714,
            51.308803
          ],
          [
            13.251143,
            54.213535,
            50.942538
          ],
          [
            13.25136,
            54.213371,
            50.572939
          ],
          [
            13.25136,
            54.21317,
            50.21065
          ],
          [
            13.251492,
            54.212979,
            49.714232
          ],
          [
            13.251563,
            54.212759,
            49.17105
          ],
          [
            13.251596,
            54.212563,
            48.691251
          ],
          [
            13.251538,
            54.212339,
            48.13648
          ],
          [
            13.251445,
            54.212144,
            47.645337
          ],
          [
            13.251341,
            54.211949,
            47.149759
          ],
          [
            13.251265,
            54.211753,
            46.662174
          ],
          [
            13.251253,
            54.211538,
            46.139038
          ],
          [
            13.251337,
            54.211346,
            45.750326
          ],
          [
            13.251331,
            54.211126,
            45.485213
          ],
          [
            13.25143,
            54.210928,
            45.239491
          ],
          [
            13.251528,
            54.210695,
            44.954593
          ],
          [
            13.251605,
            54.210512,
            44.731045
          ],
          [
            13.251729,
            54.210253,
            44.411821
          ],
          [
            13.251827,
            54.210012,
            44.117755
          ],
          [
            13.251922,
            54.209836,
            43.89881
          ],
          [
            13.252019,
            54.209606,
            43.903439
          ],
          [
            13.252117,
            54.209372,
            44.54143
          ],
          [
            13.252235,
            54.20913,
            45.20811
          ],
          [
            13.252327,
            54.208898,
            45.842463
          ],
          [
            13.252442,
            54.208685,
            46.434289
          ],
          [
            13.252531,
            54.208486,
            46.979006
          ],
          [
            13.252668,
            54.208307,
            47.498479
          ],
          [
            13.252739,
            54.208112,
            48.0277
          ],
          [
            13.25287,
            54.207941,
            48.50675
          ],
          [
            13.253039,
            54.207744,
            48.905353
          ],
          [
            13.253217,
            54.20754,
            49.319723
          ],
          [
            13.253432,
            54.20737,
            49.702151
          ],
          [
            13.253643,
            54.207215,
            50.060463
          ],
          [
            13.253832,
            54.207064,
            50.398933
          ],
          [
            13.254024,
            54.206913,
            50.739387
          ],
          [
            13.254248,
            54.206743,
            51.127543
          ],
          [
            13.25445,
            54.206591,
            51.476159
          ],
          [
            13.254664,
            54.206417,
            51.59545
          ],
          [
            13.254857,
            54.20626,
            51.285374
          ],
          [
            13.255044,
            54.20611,
            50.987689
          ],
          [
            13.255266,
            54.205939,
            50.642771
          ],
          [
            13.255485,
            54.205772,
            50.305271
          ],
          [
            13.255433,
            54.205593,
            49.997581
          ],
          [
            13.255441,
            54.205579,
            49.656115
          ],
          [
            13.255684,
            54.205647,
            49.34648
          ],
          [
            13.255871,
            54.205497,
            49.048733
          ],
          [
            13.256049,
            54.205319,
            48.969588
          ],
          [
            13.256259,
            54.205142,
            49.351041
          ],
          [
            13.256469,
            54.204979,
            49.712229
          ],
          [
            13.256706,
            54.204809,
            50.100623
          ],
          [
            13.256904,
            54.204639,
            50.464937
          ],
          [
            13.257094,
            54.204454,
            50.846838
          ],
          [
            13.257279,
            54.204299,
            51.181899
          ],
          [
            13.257497,
            54.204138,
            51.545353
          ],
          [
            13.257726,
            54.203965,
            51.932792
          ],
          [
            13.257959,
            54.203777,
            52.008494
          ],
          [
            13.258209,
            54.203598,
            51.993702
          ],
          [
            13.258426,
            54.203424,
            51.979901
          ],
          [
            13.258631,
            54.203247,
            51.966218
          ],
          [
            13.258866,
            54.203059,
            51.951313
          ],
          [
            13.259071,
            54.202887,
            51.937893
          ],
          [
            13.259301,
            54.202716,
            51.923969
          ],
          [
            13.259521,
            54.202552,
            51.910628
          ],
          [
            13.259718,
            54.202396,
            52.111089
          ],
          [
            13.259941,
            54.202234,
            52.508446
          ],
          [
            13.260159,
            54.202069,
            52.908122
          ],
          [
            13.260392,
            54.2019,
            53.323123
          ],
          [
            13.260605,
            54.201733,
            53.721267
          ],
          [
            13.260787,
            54.201545,
            54.13408
          ],
          [
            13.261021,
            54.20137,
            54.55852
          ],
          [
            13.261256,
            54.201201,
            54.974795
          ],
          [
            13.261451,
            54.201049,
            55.337858
          ],
          [
            13.261663,
            54.200879,
            55.169128
          ],
          [
            13.261884,
            54.200707,
            54.991919
          ],
          [
            13.262104,
            54.200557,
            54.829235
          ],
          [
            13.26234,
            54.200385,
            54.647651
          ],
          [
            13.262519,
            54.200227,
            54.49156
          ],
          [
            13.262729,
            54.200055,
            54.317503
          ],
          [
            13.262949,
            54.199898,
            54.150387
          ],
          [
            13.263162,
            54.199726,
            53.975397
          ],
          [
            13.26337,
            54.19956,
            53.889173
          ],
          [
            13.263598,
            54.199387,
            53.983127
          ],
          [
            13.263772,
            54.19923,
            54.06378
          ],
          [
            13.264027,
            54.199042,
            54.167026
          ],
          [
            13.264234,
            54.198836,
            54.269798
          ],
          [
            13.264484,
            54.19865,
            54.371602
          ],
          [
            13.26473,
            54.198465,
            54.472452
          ],
          [
            13.264978,
            54.198283,
            54.572559
          ],
          [
            13.265212,
            54.198107,
            54.864807
          ],
          [
            13.265422,
            54.197947,
            55.449008
          ],
          [
            13.265607,
            54.197777,
            56.033012
          ],
          [
            13.26583,
            54.197621,
            56.623177
          ],
          [
            13.266049,
            54.197451,
            57.239185
          ],
          [
            13.266273,
            54.197277,
            57.8695
          ],
          [
            13.266506,
            54.197101,
            58.513987
          ],
          [
            13.266732,
            54.196918,
            59.167229
          ],
          [
            13.266951,
            54.196734,
            59.815969
          ],
          [
            13.267174,
            54.196561,
            59.97358
          ],
          [
            13.26742,
            54.196381,
            60.122954
          ],
          [
            13.267638,
            54.196194,
            60.26965
          ],
          [
            13.26788,
            54.196005,
            60.423133
          ],
          [
            13.268129,
            54.195821,
            60.575337
          ],
          [
            13.268347,
            54.195643,
            60.717265
          ],
          [
            13.268582,
            54.195452,
            60.869789
          ],
          [
            13.268842,
            54.195257,
            60.920261
          ],
          [
            13.26908,
            54.195061,
            60.426306
          ],
          [
            13.269292,
            54.194873,
            59.963723
          ],
          [
            13.26952,
            54.194699,
            59.513328
          ],
          [
            13.269754,
            54.194526,
            59.060077
          ],
          [
            13.269977,
            54.194348,
            58.606785
          ],
          [
            13.270204,
            54.194172,
            58.153792
          ],
          [
            13.270437,
            54.193985,
            57.678438
          ],
          [
            13.270711,
            54.193768,
            57.247109
          ],
          [
            13.270948,
            54.193595,
            57.093195
          ],
          [
            13.27119,
            54.193408,
            56.93056
          ],
          [
            13.271417,
            54.193224,
            56.773315
          ],
          [
            13.271631,
            54.193044,
            56.621477
          ],
          [
            13.271859,
            54.192833,
            56.44852
          ],
          [
            13.272117,
            54.192643,
            56.280413
          ],
          [
            13.272353,
            54.192462,
            56.122744
          ],
          [
            13.272624,
            54.192277,
            55.938067
          ],
          [
            13.272868,
            54.192066,
            55.73602
          ],
          [
            13.273098,
            54.191902,
            55.567369
          ],
          [
            13.27336,
            54.191706,
            55.370038
          ],
          [
            13.273627,
            54.191523,
            55.179215
          ],
          [
            13.273834,
            54.191333,
            55.000559
          ],
          [
            13.274061,
            54.191152,
            54.822542
          ],
          [
            13.274324,
            54.190937,
            54.601539
          ],
          [
            13.274571,
            54.190747,
            54.32661
          ],
          [
            13.274792,
            54.19057,
            54.074161
          ],
          [
            13.274999,
            54.190394,
            53.828097
          ],
          [
            13.275268,
            54.1902,
            53.540415
          ],
          [
            13.275502,
            54.190019,
            53.279064
          ],
          [
            13.275729,
            54.189837,
            53.019313
          ],
          [
            13.275951,
            54.189679,
            52.78377
          ],
          [
            13.276157,
            54.189525,
            52.564649
          ],
          [
            13.276368,
            54.189353,
            52.506482
          ],
          [
            13.276578,
            54.189149,
            52.441056
          ],
          [
            13.276819,
            54.188961,
            52.376474
          ],
          [
            13.277067,
            54.188778,
            52.312293
          ],
          [
            13.277287,
            54.188592,
            52.250145
          ],
          [
            13.277537,
            54.188403,
            52.184456
          ],
          [
            13.277774,
            54.188213,
            52.119806
          ],
          [
            13.277998,
            54.188026,
            52.12869
          ],
          [
            13.278241,
            54.18785,
            52.353379
          ],
          [
            13.278487,
            54.187677,
            52.57703
          ],
          [
            13.278738,
            54.187489,
            52.813935
          ],
          [
            13.278996,
            54.1873,
            53.05426
          ],
          [
            13.279227,
            54.18713,
            53.269914
          ],
          [
            13.279486,
            54.186919,
            53.528064
          ],
          [
            13.279726,
            54.186733,
            53.760994
          ],
          [
            13.279978,
            54.186528,
            53.698495
          ],
          [
            13.280192,
            54.18636,
            53.481205
          ],
          [
            13.28044,
            54.186155,
            53.220619
          ],
          [
            13.28067,
            54.185972,
            52.984982
          ],
          [
            13.280944,
            54.185777,
            52.722996
          ],
          [
            13.281187,
            54.185564,
            52.457357
          ],
          [
            13.281411,
            54.185367,
            52.211958
          ],
          [
            13.281661,
            54.185169,
            52.007551
          ],
          [
            13.281883,
            54.185005,
            52.091734
          ],
          [
            13.282158,
            54.184813,
            52.192487
          ],
          [
            13.282412,
            54.184609,
            52.294073
          ],
          [
            13.282651,
            54.184406,
            52.393215
          ],
          [
            13.282908,
            54.184212,
            52.491936
          ],
          [
            13.283169,
            54.184015,
            52.592187
          ],
          [
            13.28341,
            54.183825,
            52.687413
          ],
          [
            13.283641,
            54.183644,
            52.660523
          ],
          [
            13.283909,
            54.183456,
            52.570839
          ],
          [
            13.284147,
            54.18326,
            52.482708
          ],
          [
            13.284372,
            54.18308,
            52.401071
          ],
          [
            13.284583,
            54.182908,
            52.323559
          ],
          [
            13.284807,
            54.182735,
            52.244038
          ],
          [
            13.285016,
            54.182563,
            52.166775
          ],
          [
            13.285224,
            54.182387,
            52.088396
          ],
          [
            13.285471,
            54.182198,
            52.041966
          ],
          [
            13.285721,
            54.182009,
            52.016858
          ],
          [
            13.285982,
            54.18182,
            51.99129
          ],
          [
            13.286205,
            54.181645,
            51.968307
          ],
          [
            13.286448,
            54.181444,
            51.942346
          ],
          [
            13.286707,
            54.18127,
            51.918137
          ],
          [
            13.286952,
            54.18107,
            51.892309
          ],
          [
            13.287157,
            54.180878,
            51.883626
          ],
          [
            13.287375,
            54.180724,
            52.164146
          ],
          [
            13.28758,
            54.180585,
            52.421713
          ],
          [
            13.28782,
            54.180395,
            52.753294
          ],
          [
            13.288032,
            54.180256,
            53.014813
          ],
          [
            13.288201,
            54.180094,
            53.28105
          ],
          [
            13.288433,
            54.17991,
            53.60185
          ],
          [
            13.288654,
            54.179714,
            53.932879
          ],
          [
            13.288918,
            54.179504,
            54.298677
          ],
          [
            13.289155,
            54.179339,
            54.276363
          ],
          [
            13.289381,
            54.17915,
            54.096346
          ],
          [
            13.289615,
            54.178975,
            53.922938
          ],
          [
            13.289839,
            54.17881,
            53.758485
          ],
          [
            13.290051,
            54.178634,
            53.590355
          ],
          [
            13.290321,
            54.178432,
            53.390189
          ],
          [
            13.290594,
            54.178248,
            53.199923
          ],
          [
            13.29084,
            54.178058,
            53.013889
          ],
          [
            13.291097,
            54.17787,
            53.24539
          ],
          [
            13.291361,
            54.177675,
            53.550982
          ],
          [
            13.291592,
            54.177492,
            53.830648
          ],
          [
            13.291784,
            54.177318,
            54.08513
          ],
          [
            13.291998,
            54.177145,
            54.347487
          ],
          [
            13.292218,
            54.176987,
            54.598424
          ],
          [
            13.29249,
            54.176781,
            54.918288
          ],
          [
            13.292698,
            54.176576,
            55.206612
          ],
          [
            13.29292,
            54.176397,
            55.382318
          ],
          [
            13.293182,
            54.176217,
            55.570918
          ],
          [
            13.29342,
            54.175996,
            55.778425
          ],
          [
            13.293662,
            54.175805,
            55.967305
          ],
          [
            13.293925,
            54.175609,
            56.165468
          ],
          [
            13.29415,
            54.175426,
            56.344667
          ],
          [
            13.294385,
            54.175237,
            56.530401
          ],
          [
            13.294641,
            54.175034,
            56.542754
          ],
          [
            13.294864,
            54.174863,
            56.404772
          ],
          [
            13.295063,
            54.174704,
            56.278336
          ],
          [
            13.295274,
            54.174518,
            56.134875
          ],
          [
            13.295491,
            54.174347,
            55.998164
          ],
          [
            13.295734,
            54.174164,
            55.849351
          ],
          [
            13.295957,
            54.174003,
            55.716402
          ],
          [
            13.296194,
            54.173792,
            55.55443
          ],
          [
            13.296393,
            54.173623,
            55.4557
          ],
          [
            13.296614,
            54.173438,
            55.405554
          ],
          [
            13.296851,
            54.173251,
            55.353791
          ],
          [
            13.297077,
            54.173088,
            55.306918
          ],
          [
            13.297312,
            54.172916,
            55.257989
          ],
          [
            13.297573,
            54.172754,
            55.20851
          ],
          [
            13.297758,
            54.172591,
            55.164948
          ],
          [
            13.29797,
            54.172439,
            55.121353
          ],
          [
            13.298196,
            54.172261,
            55.077101
          ],
          [
            13.298405,
            54.172077,
            55.189735
          ],
          [
            13.298615,
            54.171892,
            55.302747
          ],
          [
            13.298863,
            54.171696,
            55.426866
          ],
          [
            13.29912,
            54.17151,
            55.548591
          ],
          [
            13.299345,
            54.171312,
            55.669584
          ],
          [
            13.299588,
            54.171136,
            55.784728
          ],
          [
            13.2998,
            54.170945,
            55.900991
          ],
          [
            13.300024,
            54.170765,
            55.88442
          ],
          [
            13.300231,
            54.170617,
            55.494584
          ],
          [
            13.300429,
            54.170458,
            55.093515
          ],
          [
            13.300643,
            54.170309,
            54.694863
          ],
          [
            13.300834,
            54.170157,
            54.308914
          ],
          [
            13.30108,
            54.169994,
            53.865462
          ],
          [
            13.301349,
            54.169774,
            53.313594
          ],
          [
            13.301584,
            54.169582,
            52.831017
          ],
          [
            13.301769,
            54.169426,
            52.44362
          ],
          [
            13.301994,
            54.169257,
            51.854101
          ],
          [
            13.302264,
            54.169033,
            51.026492
          ],
          [
            13.30254,
            54.168841,
            50.263864
          ],
          [
            13.302785,
            54.168665,
            49.576818
          ],
          [
            13.302962,
            54.168505,
            49.000823
          ],
          [
            13.303146,
            54.168353,
            48.438382
          ],
          [
            13.303428,
            54.168155,
            47.660134
          ],
          [
            13.303669,
            54.16796,
            46.933567
          ],
          [
            13.303869,
            54.167795,
            46.710397
          ],
          [
            13.304128,
            54.167607,
            46.476124
          ],
          [
            13.304334,
            54.167424,
            46.263206
          ],
          [
            13.304559,
            54.167252,
            46.0533
          ],
          [
            13.304763,
            54.16709,
            45.85815
          ],
          [
            13.304966,
            54.166917,
            45.654809
          ],
          [
            13.30514,
            54.166757,
            45.470927
          ],
          [
            13.305375,
            54.166582,
            45.255253
          ],
          [
            13.305579,
            54.166415,
            45.277564
          ],
          [
            13.305795,
            54.166281,
            45.516993
          ],
          [
            13.305982,
            54.166094,
            45.795306
          ],
          [
            13.306246,
            54.165892,
            46.122129
          ],
          [
            13.306476,
            54.165695,
            46.428599
          ],
          [
            13.306695,
            54.165538,
            46.689003
          ],
          [
            13.306895,
            54.165374,
            46.947822
          ],
          [
            13.307077,
            54.16522,
            47.188345
          ],
          [
            13.307315,
            54.164999,
            47.408054
          ],
          [
            13.307497,
            54.1648,
            47.159759
          ],
          [
            13.307633,
            54.164592,
            46.91294
          ],
          [
            13.307755,
            54.164384,
            46.671046
          ],
          [
            13.307884,
            54.164178,
            46.429709
          ],
          [
            13.307968,
            54.163966,
            46.190306
          ],
          [
            13.308052,
            54.163758,
            45.954641
          ],
          [
            13.308142,
            54.163543,
            45.711042
          ],
          [
            13.308219,
            54.163345,
            45.487711
          ],
          [
            13.3083,
            54.163168,
            45.223562
          ],
          [
            13.30839,
            54.162963,
            44.915909
          ],
          [
            13.308478,
            54.162735,
            44.577183
          ],
          [
            13.308543,
            54.162548,
            44.300617
          ],
          [
            13.308633,
            54.162363,
            44.021812
          ],
          [
            13.30871,
            54.162175,
            43.74119
          ],
          [
            13.308788,
            54.161959,
            43.421295
          ],
          [
            13.308864,
            54.161736,
            43.091549
          ],
          [
            13.308978,
            54.1615,
            42.868426
          ],
          [
            13.30908,
            54.161271,
            42.847214
          ],
          [
            13.309191,
            54.161028,
            42.824723
          ],
          [
            13.309272,
            54.160807,
            42.804511
          ],
          [
            13.30936,
            54.160582,
            42.783776
          ],
          [
            13.309456,
            54.160386,
            42.765533
          ],
          [
            13.309544,
            54.160178,
            42.746371
          ],
          [
            13.309599,
            54.159944,
            42.725253
          ],
          [
            13.309703,
            54.159736,
            42.533175
          ],
          [
            13.309803,
            54.159517,
            42.182074
          ],
          [
            13.309875,
            54.159294,
            41.830736
          ],
          [
            13.309941,
            54.159087,
            41.503451
          ],
          [
            13.310191,
            54.158906,
            41.13777
          ],
          [
            13.310329,
            54.158737,
            40.845037
          ],
          [
            13.310418,
            54.158551,
            40.546032
          ],
          [
            13.310517,
            54.158358,
            40.233869
          ],
          [
            13.3106,
            54.158155,
            39.940093
          ],
          [
            13.310714,
            54.157958,
            40.001335
          ],
          [
            13.310745,
            54.157773,
            40.056366
          ],
          [
            13.310837,
            54.157569,
            40.118158
          ],
          [
            13.310883,
            54.157361,
            40.179571
          ],
          [
            13.310939,
            54.157154,
            40.241118
          ],
          [
            13.311123,
            54.156986,
            40.299516
          ],
          [
            13.311174,
            54.156776,
            40.361577
          ],
          [
            13.311242,
            54.156581,
            40.419786
          ],
          [
            13.311352,
            54.156396,
            40.528968
          ],
          [
            13.311356,
            54.156223,
            40.755451
          ],
          [
            13.311174,
            54.156078,
            40.996773
          ],
          [
            13.31124,
            54.155874,
            41.25639
          ],
          [
            13.311327,
            54.155668,
            41.516759
          ],
          [
            13.311427,
            54.155438,
            41.807895
          ],
          [
            13.311523,
            54.155214,
            42.091173
          ],
          [
            13.311583,
            54.155001,
            42.355991
          ],
          [
            13.311583,
            54.154803,
            42.601934
          ],
          [
            13.311834,
            54.154706,
            42.660174
          ],
          [
            13.311914,
            54.154513,
            42.650929
          ],
          [
            13.312051,
            54.154323,
            42.641301
          ],
          [
            13.312197,
            54.154104,
            42.630411
          ],
          [
            13.312329,
            54.153881,
            42.619479
          ],
          [
            13.312454,
            54.153671,
            42.609176
          ],
          [
            13.312582,
            54.153464,
            42.598969
          ],
          [
            13.312702,
            54.153263,
            42.589107
          ],
          [
            13.312787,
            54.15307,
            42.590836
          ],
          [
            13.312912,
            54.152872,
            42.608323
          ],
          [
            13.313055,
            54.152653,
            42.627752
          ],
          [
            13.313177,
            54.152432,
            42.646995
          ],
          [
            13.313298,
            54.152214,
            42.665982
          ],
          [
            13.313458,
            54.151974,
            42.687323
          ],
          [
            13.313599,
            54.151773,
            42.705327
          ],
          [
            13.313787,
            54.151575,
            42.724102
          ],
          [
            13.313983,
            54.151395,
            42.924229
          ],
          [
            13.314236,
            54.151198,
            43.358444
          ],
          [
            13.314525,
            54.151006,
            43.809105
          ],
          [
            13.314821,
            54.15083,
            44.244068
          ],
          [
            13.315119,
            54.150671,
            44.659745
          ],
          [
            13.315405,
            54.150496,
            45.08629
          ],
          [
            13.315702,
            54.150317,
            45.525771
          ],
          [
            13.315937,
            54.150174,
            45.875426
          ],
          [
            13.316201,
            54.15001,
            45.618182
          ],
          [
            13.31648,
            54.149843,
            45.30753
          ],
          [
            13.316765,
            54.14967,
            44.988077
          ],
          [
            13.317027,
            54.149515,
            44.697978
          ],
          [
            13.317283,
            54.149368,
            44.418272
          ],
          [
            13.317557,
            54.149208,
            44.117058
          ],
          [
            13.317846,
            54.149041,
            43.801101
          ],
          [
            13.318139,
            54.148868,
            43.510196
          ],
          [
            13.318396,
            54.148707,
            43.515022
          ],
          [
            13.318646,
            54.148557,
            43.519614
          ],
          [
            13.31893,
            54.148387,
            43.524837
          ],
          [
            13.31909,
            54.148294,
            43.529242
          ],
          [
            13.319342,
            54.14814,
            43.53396
          ],
          [
            13.319611,
            54.147993,
            43.538703
          ],
          [
            13.319914,
            54.147819,
            43.544145
          ],
          [
            13.32022,
            54.147647,
            43.556059
          ],
          [
            13.320482,
            54.147469,
            43.622153
          ],
          [
            13.32074,
            54.147306,
            43.684911
          ],
          [
            13.320991,
            54.147158,
            43.743585
          ],
          [
            13.321279,
            54.146992,
            43.810158
          ],
          [
            13.321547,
            54.146847,
            43.870274
          ],
          [
            13.321819,
            54.146686,
            43.933974
          ],
          [
            13.322077,
            54.146558,
            43.989738
          ],
          [
            13.322166,
            54.146389,
            44.043826
          ],
          [
            13.322431,
            54.146231,
            44.128259
          ],
          [
            13.322699,
            54.146071,
            44.218529
          ],
          [
            13.322959,
            54.145899,
            44.311043
          ],
          [
            13.323273,
            54.145726,
            44.412734
          ],
          [
            13.323592,
            54.145547,
            44.516973
          ],
          [
            13.323807,
            54.145409,
            44.592207
          ],
          [
            13.32412,
            54.145246,
            44.690993
          ],
          [
            13.324365,
            54.145072,
            44.781262
          ],
          [
            13.324618,
            54.144918,
            44.848176
          ],
          [
            13.324949,
            54.144738,
            44.931116
          ],
          [
            13.325204,
            54.144585,
            44.998249
          ],
          [
            13.325477,
            54.144426,
            45.06889
          ],
          [
            13.325752,
            54.144271,
            45.139024
          ],
          [
            13.326066,
            54.14409,
            45.219829
          ],
          [
            13.326306,
            54.143943,
            45.283523
          ],
          [
            13.326532,
            54.143799,
            45.325469
          ],
          [
            13.326806,
            54.143652,
            44.874691
          ],
          [
            13.327046,
            54.143521,
            44.478285
          ],
          [
            13.327279,
            54.143371,
            44.060035
          ],
          [
            13.32755,
            54.143214,
            43.599431
          ],
          [
            13.327856,
            54.143049,
            43.096692
          ],
          [
            13.328114,
            54.142878,
            42.625982
          ],
          [
            13.328423,
            54.142692,
            42.090716
          ],
          [
            13.328723,
            54.142529,
            41.634451
          ],
          [
            13.328941,
            54.142361,
            41.643601
          ],
          [
            13.329185,
            54.142171,
            41.653914
          ],
          [
            13.32913,
            54.141986,
            41.662494
          ],
          [
            13.328982,
            54.141801,
            41.671377
          ],
          [
            13.32887,
            54.141607,
            41.680325
          ],
          [
            13.32857,
            54.141535,
            41.688571
          ],
          [
            13.328254,
            54.1415,
            41.696802
          ],
          [
            13.328248,
            54.141483,
            41.704912
          ],
          [
            13.328573,
            54.141513,
            41.689829
          ],
          [
            13.32888,
            54.141595,
            41.574358
          ],
          [
            13.329058,
            54.141913,
            41.378846
          ],
          [
            13.329225,
            54.142094,
            41.258571
          ],
          [
            13.329617,
            54.141927,
            41.065333
          ],
          [
            13.32987,
            54.141785,
            40.945532
          ],
          [
            13.330139,
            54.141631,
            40.816798
          ],
          [
            13.330378,
            54.141484,
            40.698319
          ],
          [
            13.33067,
            54.14136,
            40.946904
          ],
          [
            13.330927,
            54.141252,
            41.308345
          ],
          [
            13.331164,
            54.1411,
            41.69754
          ],
          [
            13.331409,
            54.140965,
            42.069892
          ],
          [
            13.331664,
            54.140815,
            42.469846
          ],
          [
            13.331943,
            54.140676,
            42.875119
          ],
          [
            13.332178,
            54.140504,
            43.291256
          ],
          [
            13.332398,
            54.140348,
            43.673473
          ],
          [
            13.332648,
            54.140195,
            44.055216
          ],
          [
            13.332914,
            54.14005,
            43.937505
          ],
          [
            13.333179,
            54.139894,
            43.815805
          ],
          [
            13.33342,
            54.13974,
            43.700261
          ],
          [
            13.333685,
            54.139578,
            43.576187
          ],
          [
            13.333994,
            54.139394,
            43.433455
          ],
          [
            13.334275,
            54.139238,
            43.307621
          ],
          [
            13.334548,
            54.139066,
            43.177693
          ],
          [
            13.334817,
            54.138921,
            43.072104
          ],
          [
            13.335081,
            54.138773,
            43.229069
          ],
          [
            13.335313,
            54.138623,
            43.377644
          ],
          [
            13.33556,
            54.138475,
            43.529417
          ],
          [
            13.335806,
            54.138314,
            43.687961
          ],
          [
            13.336082,
            54.138156,
            43.853746
          ],
          [
            13.336395,
            54.137986,
            44.03714
          ],
          [
            13.336663,
            54.137847,
            44.190976
          ],
          [
            13.336931,
            54.13767,
            44.364935
          ],
          [
            13.337179,
            54.137505,
            44.468888
          ],
          [
            13.337439,
            54.137344,
            44.566352
          ],
          [
            13.337728,
            54.137175,
            44.671268
          ],
          [
            13.338007,
            54.137014,
            44.771891
          ],
          [
            13.3383,
            54.136861,
            44.872738
          ],
          [
            13.338605,
            54.136692,
            44.980616
          ],
          [
            13.338859,
            54.136537,
            45.074995
          ],
          [
            13.33915,
            54.136375,
            45.171947
          ],
          [
            13.339417,
            54.136208,
            45.162618
          ],
          [
            13.339663,
            54.13605,
            45.153901
          ],
          [
            13.339935,
            54.135873,
            45.144105
          ],
          [
            13.340189,
            54.135695,
            45.134647
          ],
          [
            13.340491,
            54.135518,
            45.124436
          ],
          [
            13.340735,
            54.13537,
            45.116048
          ],
          [
            13.341012,
            54.135217,
            45.106962
          ],
          [
            13.341294,
            54.135058,
            45.129794
          ],
          [
            13.341561,
            54.134886,
            45.312728
          ],
          [
            13.341894,
            54.134697,
            45.529206
          ],
          [
            13.342181,
            54.134504,
            45.730486
          ],
          [
            13.342478,
            54.134344,
            45.916535
          ],
          [
            13.342758,
            54.134203,
            46.086877
          ],
          [
            13.34308,
            54.134033,
            46.286454
          ],
          [
            13.343331,
            54.133853,
            46.47079
          ],
          [
            13.343567,
            54.133714,
            46.384027
          ],
          [
            13.343878,
            54.133536,
            46.154681
          ],
          [
            13.344142,
            54.133384,
            45.959426
          ],
          [
            13.344402,
            54.133259,
            45.781899
          ],
          [
            13.34468,
            54.133093,
            45.572487
          ],
          [
            13.344926,
            54.132924,
            45.372408
          ],
          [
            13.345161,
            54.132786,
            45.196886
          ],
          [
            13.345468,
            54.132604,
            44.966354
          ],
          [
            13.345691,
            54.132465,
            44.891611
          ],
          [
            13.346041,
            54.132283,
            44.88739
          ],
          [
            13.346311,
            54.132108,
            44.883767
          ],
          [
            13.346547,
            54.131975,
            44.88082
          ],
          [
            13.346836,
            54.131828,
            44.877375
          ],
          [
            13.347079,
            54.131655,
            44.873926
          ],
          [
            13.347302,
            54.131532,
            44.871167
          ],
          [
            13.347606,
            54.131343,
            44.867177
          ],
          [
            13.347862,
            54.131177,
            45.055695
          ],
          [
            13.34808,
            54.131011,
            45.37086
          ],
          [
            13.348348,
            54.130839,
            45.721809
          ],
          [
            13.348601,
            54.130685,
            46.043897
          ],
          [
            13.348864,
            54.130543,
            46.359369
          ],
          [
            13.349119,
            54.130394,
            46.677058
          ],
          [
            13.349408,
            54.13026,
            47.001985
          ],
          [
            13.349669,
            54.130088,
            47.348351
          ],
          [
            13.34991,
            54.129898,
            47.649713
          ],
          [
            13.350169,
            54.129742,
            47.842274
          ],
          [
            13.350446,
            54.12959,
            48.039295
          ],
          [
            13.350657,
            54.129445,
            48.20744
          ],
          [
            13.350854,
            54.12927,
            48.392306
          ],
          [
            13.351014,
            54.129064,
            48.591895
          ],
          [
            13.351212,
            54.128895,
            48.772847
          ],
          [
            13.351346,
            54.128706,
            48.9534
          ],
          [
            13.351527,
            54.128494,
            49.146857
          ],
          [
            13.351651,
            54.128303,
            48.668596
          ],
          [
            13.351799,
            54.128132,
            48.223915
          ],
          [
            13.351911,
            54.127941,
            47.753717
          ],
          [
            13.352071,
            54.127744,
            47.24665
          ],
          [
            13.352243,
            54.127565,
            46.769789
          ],
          [
            13.352361,
            54.127386,
            46.324716
          ],
          [
            13.352527,
            54.127195,
            45.827536
          ],
          [
            13.352687,
            54.127009,
            45.34414
          ],
          [
            13.35285,
            54.126821,
            44.888896
          ],
          [
            13.353,
            54.126617,
            44.50673
          ],
          [
            13.353141,
            54.126422,
            44.143475
          ],
          [
            13.353287,
            54.126242,
            43.801619
          ],
          [
            13.353415,
            54.126056,
            43.454169
          ],
          [
            13.353574,
            54.125858,
            43.078678
          ],
          [
            13.353737,
            54.125652,
            42.689205
          ],
          [
            13.353876,
            54.125445,
            42.307609
          ],
          [
            13.354003,
            54.12525,
            41.949099
          ],
          [
            13.354204,
            54.125059,
            41.401343
          ],
          [
            13.354387,
            54.124862,
            40.831142
          ],
          [
            13.354546,
            54.124653,
            40.249146
          ],
          [
            13.35469,
            54.124466,
            39.726268
          ],
          [
            13.354832,
            54.124268,
            39.180265
          ],
          [
            13.354945,
            54.124093,
            38.704617
          ],
          [
            13.35504,
            54.123896,
            38.184215
          ],
          [
            13.355309,
            54.123611,
            37.356279
          ],
          [
            13.355436,
            54.123393,
            37.94403
          ],
          [
            13.35554,
            54.123199,
            38.513033
          ],
          [
            13.355699,
            54.123021,
            39.075131
          ],
          [
            13.355836,
            54.122822,
            39.675863
          ],
          [
            13.356027,
            54.122626,
            40.3073
          ],
          [
            13.356183,
            54.122424,
            40.928556
          ],
          [
            13.356304,
            54.122214,
            41.549016
          ],
          [
            13.356488,
            54.122008,
            42.201675
          ],
          [
            13.356681,
            54.121826,
            42.604944
          ],
          [
            13.356877,
            54.121602,
            42.990318
          ],
          [
            13.357082,
            54.121414,
            43.334312
          ],
          [
            13.357386,
            54.121264,
            43.692684
          ],
          [
            13.357691,
            54.121128,
            44.036787
          ],
          [
            13.358045,
            54.121156,
            44.363773
          ],
          [
            13.358361,
            54.121107,
            44.657048
          ],
          [
            13.358735,
            54.121044,
            45.011204
          ],
          [
            13.359134,
            54.120975,
            45.290996
          ],
          [
            13.359529,
            54.120885,
            45.539612
          ],
          [
            13.359894,
            54.120822,
            45.762806
          ],
          [
            13.360242,
            54.120766,
            45.974522
          ],
          [
            13.360591,
            54.120702,
            46.189488
          ],
          [
            13.360922,
            54.120637,
            46.394314
          ],
          [
            13.36125,
            54.120572,
            46.597829
          ],
          [
            13.361577,
            54.120527,
            46.795483
          ],
          [
            13.361935,
            54.120488,
            46.781422
          ],
          [
            13.362297,
            54.120458,
            46.481885
          ],
          [
            13.362655,
            54.120421,
            46.180042
          ],
          [
            13.363054,
            54.120386,
            45.8495
          ],
          [
            13.363414,
            54.120361,
            45.552098
          ],
          [
            13.36379,
            54.120317,
            45.237959
          ],
          [
            13.36412,
            54.120283,
            44.962563
          ],
          [
            13.364497,
            54.120216,
            44.639729
          ],
          [
            13.364856,
            54.120207,
            44.379044
          ],
          [
            13.365185,
            54.120202,
            44.276197
          ],
          [
            13.36553,
            54.120208,
            44.168324
          ],
          [
            13.365902,
            54.12017,
            44.050356
          ],
          [
            13.366279,
            54.12018,
            43.930027
          ],
          [
            13.366631,
            54.120163,
            43.818885
          ],
          [
            13.366966,
            54.120129,
            43.712643
          ],
          [
            13.367347,
            54.120112,
            43.593245
          ],
          [
            13.367724,
            54.12007,
            43.473258
          ],
          [
            13.368089,
            54.120034,
            43.594668
          ],
          [
            13.368458,
            54.120001,
            43.808167
          ],
          [
            13.368823,
            54.119995,
            44.016604
          ],
          [
            13.369203,
            54.120013,
            44.234196
          ],
          [
            13.369574,
            54.120023,
            44.446171
          ],
          [
            13.369948,
            54.120043,
            44.660546
          ],
          [
            13.37034,
            54.120073,
            44.886449
          ],
          [
            13.370733,
            54.120085,
            45.111459
          ],
          [
            13.371152,
            54.120102,
            45.128298
          ],
          [
            13.371582,
            54.120124,
            45.027503
          ],
          [
            13.372006,
            54.120149,
            44.928077
          ],
          [
            13.372379,
            54.120175,
            44.84035
          ],
          [
            13.372757,
            54.120189,
            44.751835
          ],
          [
            13.373195,
            54.120227,
            44.64849
          ],
          [
            13.373511,
            54.120227,
            44.574415
          ],
          [
            13.373843,
            54.120231,
            44.496939
          ],
          [
            13.374231,
            54.120237,
            44.182147
          ],
          [
            13.374545,
            54.120209,
            43.871783
          ],
          [
            13.374892,
            54.120112,
            43.49375
          ],
          [
            13.375159,
            54.119996,
            43.168324
          ],
          [
            13.375368,
            54.119842,
            42.840344
          ],
          [
            13.375596,
            54.119688,
            42.499101
          ],
          [
            13.375807,
            54.119505,
            42.131969
          ],
          [
            13.375961,
            54.119304,
            41.764281
          ],
          [
            13.37608,
            54.119123,
            41.474637
          ],
          [
            13.376127,
            54.118916,
            41.371862
          ],
          [
            13.376189,
            54.118695,
            41.261628
          ],
          [
            13.376129,
            54.118471,
            41.149392
          ],
          [
            13.37593,
            54.118239,
            41.021621
          ],
          [
            13.375843,
            54.118026,
            40.911013
          ],
          [
            13.375925,
            54.117764,
            40.779733
          ],
          [
            13.376042,
            54.117524,
            40.656892
          ],
          [
            13.376115,
            54.117323,
            40.486236
          ],
          [
            13.376237,
            54.117069,
            40.167302
          ],
          [
            13.376341,
            54.116845,
            39.886732
          ],
          [
            13.376373,
            54.116657,
            39.657763
          ],
          [
            13.37642,
            54.116422,
            39.371792
          ],
          [
            13.376518,
            54.116223,
            39.121211
          ],
          [
            13.37662,
            54.116029,
            38.875856
          ],
          [
            13.376691,
            54.115832,
            38.629697
          ],
          [
            13.376752,
            54.115639,
            38.477499
          ],
          [
            13.376825,
            54.115408,
            38.843717
          ],
          [
            13.376925,
            54.115143,
            39.266763
          ],
          [
            13.377018,
            54.114941,
            39.593016
          ],
          [
            13.377046,
            54.11474,
            39.907503
          ],
          [
            13.377078,
            54.114513,
            40.263398
          ],
          [
            13.377093,
            54.114293,
            40.606613
          ],
          [
            13.377062,
            54.114089,
            40.926238
          ],
          [
            13.376999,
            54.11387,
            41.249028
          ],
          [
            13.376904,
            54.113635,
            41.400815
          ],
          [
            13.376725,
            54.113438,
            41.541137
          ],
          [
            13.376495,
            54.113269,
            41.676792
          ],
          [
            13.376225,
            54.1131,
            41.822343
          ],
          [
            13.376078,
            54.112882,
            41.970118
          ],
          [
            13.375977,
            54.112673,
            42.106487
          ],
          [
            13.37589,
            54.112428,
            42.264049
          ],
          [
            13.375825,
            54.112201,
            42.256521
          ],
          [
            13.375778,
            54.111972,
            41.931099
          ],
          [
            13.375702,
            54.111747,
            41.607499
          ],
          [
            13.37567,
            54.111523,
            41.290337
          ],
          [
            13.375591,
            54.111316,
            40.991036
          ],
          [
            13.375481,
            54.11113,
            40.713295
          ],
          [
            13.375392,
            54.110886,
            40.360855
          ],
          [
            13.375337,
            54.110648,
            40.022012
          ],
          [
            13.375288,
            54.110417,
            39.872098
          ],
          [
            13.375202,
            54.110184,
            39.99549
          ],
          [
            13.375093,
            54.109956,
            40.118009
          ],
          [
            13.375008,
            54.109716,
            40.244873
          ],
          [
            13.374942,
            54.109493,
            40.362049
          ],
          [
            13.374846,
            54.109273,
            40.479542
          ],
          [
            13.374758,
            54.109071,
            40.587398
          ],
          [
            13.374671,
            54.108858,
            40.700722
          ],
          [
            13.374546,
            54.108684,
            40.740117
          ],
          [
            13.374649,
            54.108475,
            40.702963
          ],
          [
            13.374754,
            54.108271,
            40.666843
          ],
          [
            13.374889,
            54.108032,
            40.624242
          ],
          [
            13.375015,
            54.107784,
            40.580392
          ],
          [
            13.375118,
            54.107569,
            40.542409
          ],
          [
            13.375248,
            54.10738,
            40.507934
          ],
          [
            13.375352,
            54.107169,
            40.470779
          ],
          [
            13.375445,
            54.106984,
            40.480715
          ],
          [
            13.37554,
            54.106775,
            40.570956
          ],
          [
            13.375647,
            54.106582,
            40.655616
          ],
          [
            13.375765,
            54.106371,
            40.748461
          ],
          [
            13.375925,
            54.106146,
            40.850142
          ],
          [
            13.376056,
            54.105911,
            40.953256
          ],
          [
            13.376184,
            54.105723,
            41.037674
          ],
          [
            13.376305,
            54.105489,
            41.139637
          ],
          [
            13.376387,
            54.1053,
            41.194541
          ],
          [
            13.376506,
            54.105101,
            41.169624
          ],
          [
            13.376589,
            54.104886,
            41.14356
          ],
          [
            13.376729,
            54.104648,
            41.11391
          ],
          [
            13.376872,
            54.104432,
            41.086607
          ],
          [
            13.376977,
            54.104212,
            41.05963
          ],
          [
            13.377076,
            54.104033,
            41.037444
          ],
          [
            13.377175,
            54.103858,
            41.015729
          ],
          [
            13.377302,
            54.103647,
            40.989375
          ],
          [
            13.37744,
            54.103429,
            40.977564
          ],
          [
            13.377587,
            54.103225,
            40.966775
          ],
          [
            13.377737,
            54.102997,
            40.954859
          ],
          [
            13.377889,
            54.102791,
            40.943872
          ],
          [
            13.377982,
            54.10257,
            40.93278
          ],
          [
            13.378057,
            54.10234,
            40.921355
          ],
          [
            13.378184,
            54.102108,
            40.909419
          ],
          [
            13.37827,
            54.101907,
            40.949598
          ],
          [
            13.378395,
            54.101683,
            41.295494
          ],
          [
            13.378496,
            54.101449,
            41.650367
          ],
          [
            13.378598,
            54.101225,
            41.990624
          ],
          [
            13.378696,
            54.100989,
            42.347072
          ],
          [
            13.378782,
            54.10077,
            42.676876
          ],
          [
            13.378822,
            54.100556,
            42.992814
          ],
          [
            13.37886,
            54.100373,
            43.264192
          ],
          [
            13.378958,
            54.100201,
            43.53033
          ],
          [
            13.37891,
            54.10031,
            44.031663
          ],
          [
            13.37945,
            54.098815,
            46.688267
          ],
          [
            13.379765,
            54.09877,
            46.313124
          ],
          [
            13.379431,
            54.09879,
            45.925114
          ],
          [
            13.379764,
            54.098773,
            45.531276
          ],
          [
            13.380107,
            54.098761,
            45.134167
          ],
          [
            13.380452,
            54.098779,
            44.73372
          ],
          [
            13.380773,
            54.098804,
            44.359427
          ],
          [
            13.381144,
            54.098812,
            43.930276
          ],
          [
            13.381527,
            54.098829,
            43.484933
          ],
          [
            13.381856,
            54.098859,
            43.177591
          ],
          [
            13.382199,
            54.098877,
            43.13434
          ],
          [
            13.382519,
            54.098894,
            43.093986
          ],
          [
            13.382824,
            54.098951,
            43.053782
          ],
          [
            13.383143,
            54.098987,
            43.012958
          ],
          [
            13.383474,
            54.099033,
            42.97022
          ],
          [
            13.383821,
            54.099074,
            42.925626
          ],
          [
            13.384175,
            54.099133,
            42.879384
          ],
          [
            13.38449,
            54.099166,
            42.838974
          ],
          [
            13.384885,
            54.099131,
            42.799666
          ],
          [
            13.385247,
            54.099121,
            42.792284
          ],
          [
            13.385624,
            54.099116,
            42.784598
          ],
          [
            13.385967,
            54.099053,
            42.777275
          ],
          [
            13.386299,
            54.098951,
            42.769609
          ],
          [
            13.386602,
            54.098846,
            42.762439
          ],
          [
            13.38688,
            54.09891,
            42.755066
          ],
          [
            13.386911,
            54.099109,
            42.748082
          ],
          [
            13.387164,
            54.09923,
            42.740616
          ],
          [
            13.387533,
            54.0992,
            42.77001
          ],
          [
            13.387892,
            54.099189,
            42.805502
          ],
          [
            13.388253,
            54.099195,
            42.841206
          ],
          [
            13.388626,
            54.09922,
            42.878272
          ],
          [
            13.389007,
            54.099223,
            42.915894
          ],
          [
            13.389365,
            54.099227,
            42.951241
          ],
          [
            13.389762,
            54.099224,
            42.990436
          ],
          [
            13.390079,
            54.099222,
            43.021737
          ],
          [
            13.390452,
            54.099225,
            43.06257
          ],
          [
            13.390807,
            54.099229,
            43.106169
          ],
          [
            13.391198,
            54.099205,
            43.154481
          ],
          [
            13.391562,
            54.099181,
            43.199475
          ],
          [
            13.391919,
            54.099198,
            43.243453
          ],
          [
            13.392276,
            54.099185,
            43.287382
          ],
          [
            13.392603,
            54.099205,
            43.327834
          ],
          [
            13.392934,
            54.09921,
            43.368641
          ],
          [
            13.393281,
            54.099207,
            43.411257
          ],
          [
            13.393633,
            54.099209,
            43.662627
          ],
          [
            13.393965,
            54.09922,
            43.94037
          ],
          [
            13.394325,
            54.099231,
            44.242369
          ],
          [
            13.394667,
            54.099228,
            44.528143
          ],
          [
            13.395016,
            54.099237,
            44.81993
          ],
          [
            13.395345,
            54.099257,
            45.096393
          ],
          [
            13.395685,
            54.099253,
            45.380432
          ],
          [
            13.396051,
            54.099267,
            45.688268
          ],
          [
            13.396384,
            54.099266,
            45.966585
          ],
          [
            13.39673,
            54.099266,
            45.936147
          ],
          [
            13.397107,
            54.099253,
            45.884971
          ],
          [
            13.397424,
            54.099261,
            45.841974
          ],
          [
            13.397728,
            54.099298,
            45.799847
          ],
          [
            13.398039,
            54.099296,
            45.757703
          ],
          [
            13.398425,
            54.099301,
            45.705326
          ],
          [
            13.398795,
            54.099309,
            45.655148
          ],
          [
            13.399103,
            54.099356,
            45.611902
          ],
          [
            13.399427,
            54.099348,
            45.567897
          ],
          [
            13.399761,
            54.099338,
            45.340393
          ],
          [
            13.40011,
            54.099342,
            45.090509
          ],
          [
            13.400435,
            54.099327,
            44.857059
          ],
          [
            13.400825,
            54.099294,
            44.574801
          ],
          [
            13.40118,
            54.099265,
            44.317564
          ],
          [
            13.401492,
            54.099228,
            44.089598
          ],
          [
            13.401828,
            54.099158,
            43.83416
          ],
          [
            13.402151,
            54.099085,
            43.586211
          ],
          [
            13.40247,
            54.099039,
            43.373628
          ],
          [
            13.402822,
            54.098977,
            43.436315
          ],
          [
            13.40318,
            54.098941,
            43.498041
          ],
          [
            13.403497,
            54.098908,
            43.552717
          ],
          [
            13.403823,
            54.09886,
            43.609903
          ],
          [
            13.404135,
            54.098812,
            43.664762
          ],
          [
            13.404474,
            54.098762,
            43.724289
          ],
          [
            13.404799,
            54.098712,
            43.781352
          ],
          [
            13.405158,
            54.098698,
            43.842958
          ],
          [
            13.405472,
            54.098639,
            43.860549
          ],
          [
            13.405806,
            54.098589,
            43.662534
          ],
          [
            13.406164,
            54.09855,
            43.453078
          ],
          [
            13.406495,
            54.098508,
            43.25854
          ],
          [
            13.40685,
            54.098449,
            43.046607
          ],
          [
            13.407155,
            54.098402,
            42.865344
          ],
          [
            13.407465,
            54.098339,
            42.676922
          ],
          [
            13.407794,
            54.098297,
            42.483435
          ],
          [
            13.408124,
            54.098251,
            42.28864
          ],
          [
            13.408455,
            54.098218,
            42.074365
          ],
          [
            13.408808,
            54.098163,
            41.728277
          ],
          [
            13.409159,
            54.098097,
            41.378972
          ],
          [
            13.409467,
            54.098042,
            41.073643
          ],
          [
            13.409837,
            54.098004,
            40.717466
          ],
          [
            13.410183,
            54.097965,
            40.383355
          ],
          [
            13.410554,
            54.097933,
            40.028032
          ],
          [
            13.410889,
            54.097924,
            39.709952
          ],
          [
            13.411248,
            54.097886,
            39.362871
          ],
          [
            13.411635,
            54.097864,
            39.29739
          ],
          [
            13.411984,
            54.097864,
            39.406025
          ],
          [
            13.412339,
            54.097909,
            39.518762
          ],
          [
            13.412654,
            54.097957,
            39.61971
          ],
          [
            13.412964,
            54.097998,
            39.718546
          ],
          [
            13.413316,
            54.098044,
            39.830419
          ],
          [
            13.413679,
            54.098122,
            39.95046
          ],
          [
            13.414031,
            54.098194,
            40.066213
          ],
          [
            13.414369,
            54.098248,
            40.174005
          ],
          [
            13.414712,
            54.098277,
            40.207491
          ],
          [
            13.415037,
            54.098298,
            40.23909
          ],
          [
            13.415378,
            54.098318,
            40.272217
          ],
          [
            13.415697,
            54.098326,
            40.303084
          ],
          [
            13.416023,
            54.098285,
            40.335361
          ],
          [
            13.416347,
            54.098257,
            40.367089
          ],
          [
            13.416664,
            54.098222,
            40.398363
          ],
          [
            13.417014,
            54.098169,
            40.433315
          ],
          [
            13.417334,
            54.098139,
            40.464709
          ],
          [
            13.417633,
            54.098082,
            40.77271
          ],
          [
            13.417928,
            54.098004,
            41.15063
          ],
          [
            13.418202,
            54.097902,
            41.528578
          ],
          [
            13.418469,
            54.097798,
            41.901934
          ],
          [
            13.418744,
            54.097696,
            42.280882
          ],
          [
            13.41901,
            54.097597,
            42.648322
          ],
          [
            13.419285,
            54.097491,
            43.031596
          ],
          [
            13.419599,
            54.097364,
            43.476857
          ],
          [
            13.419873,
            54.097254,
            43.863906
          ],
          [
            13.420173,
            54.097141,
            44.030048
          ],
          [
            13.420493,
            54.096999,
            44.006714
          ],
          [
            13.420807,
            54.096853,
            43.983392
          ],
          [
            13.421106,
            54.096729,
            43.962105
          ],
          [
            13.421402,
            54.096631,
            43.942346
          ],
          [
            13.421721,
            54.09653,
            43.921256
          ],
          [
            13.422028,
            54.096453,
            43.901843
          ],
          [
            13.42234,
            54.096361,
            43.881534
          ],
          [
            13.422675,
            54.096303,
            43.842912
          ],
          [
            13.422999,
            54.096237,
            43.671463
          ],
          [
            13.423339,
            54.096156,
            43.488508
          ],
          [
            13.423676,
            54.096086,
            43.310169
          ],
          [
            13.424007,
            54.095999,
            43.12933
          ],
          [
            13.424324,
            54.0959,
            42.950287
          ],
          [
            13.424664,
            54.095823,
            42.768463
          ],
          [
            13.424993,
            54.095746,
            42.591853
          ],
          [
            13.425328,
            54.095672,
            42.413371
          ],
          [
            13.425681,
            54.095582,
            42.342118
          ],
          [
            13.426011,
            54.095486,
            42.354319
          ],
          [
            13.426345,
            54.095402,
            42.366337
          ],
          [
            13.426675,
            54.095316,
            42.378291
          ],
          [
            13.427014,
            54.095235,
            42.39039
          ],
          [
            13.427333,
            54.095149,
            42.402003
          ],
          [
            13.427682,
            54.095081,
            42.414179
          ],
          [
            13.428049,
            54.095044,
            42.426494
          ],
          [
            13.428414,
            54.095057,
            42.427661
          ],
          [
            13.428749,
            54.095114,
            42.390825
          ],
          [
            13.429105,
            54.095161,
            42.352205
          ],
          [
            13.429425,
            54.095189,
            42.31801
          ],
          [
            13.429759,
            54.095233,
            42.281851
          ],
          [
            13.430142,
            54.095264,
            42.240921
          ],
          [
            13.430449,
            54.095262,
            42.208499
          ],
          [
            13.430751,
            54.095222,
            42.175795
          ],
          [
            13.43107,
            54.095177,
            42.141103
          ],
          [
            13.431424,
            54.095131,
            42.093059
          ],
          [
            13.431801,
            54.095085,
            42.009686
          ],
          [
            13.432196,
            54.095059,
            41.923615
          ],
          [
            13.432542,
            54.095014,
            41.846871
          ],
          [
            13.432896,
            54.094998,
            41.769982
          ],
          [
            13.433286,
            54.094978,
            41.685203
          ],
          [
            13.433667,
            54.094966,
            41.6025
          ],
          [
            13.434029,
            54.094946,
            41.523089
          ],
          [
            13.434422,
            54.094929,
            41.446241
          ],
          [
            13.434786,
            54.094933,
            41.432478
          ],
          [
            13.435108,
            54.094921,
            41.420164
          ],
          [
            13.435456,
            54.094929,
            41.406983
          ],
          [
            13.435802,
            54.094943,
            41.393873
          ],
          [
            13.436152,
            54.094951,
            41.380632
          ],
          [
            13.436501,
            54.094958,
            41.367429
          ],
          [
            13.43686,
            54.094947,
            41.353833
          ],
          [
            13.437204,
            54.094946,
            41.340802
          ],
          [
            13.437561,
            54.094926,
            41.468535
          ],
          [
            13.437964,
            54.094915,
            41.896484
          ],
          [
            13.438334,
            54.094874,
            42.296206
          ],
          [
            13.438685,
            54.094837,
            42.67477
          ],
          [
            13.439022,
            54.094783,
            43.045427
          ],
          [
            13.439307,
            54.094671,
            43.415306
          ],
          [
            13.439532,
            54.094506,
            43.797934
          ],
          [
            13.439737,
            54.094333,
            44.179055
          ],
          [
            13.439971,
            54.094171,
            44.563056
          ],
          [
            13.440203,
            54.094005,
            44.47434
          ],
          [
            13.44041,
            54.093846,
            44.364828
          ],
          [
            13.440644,
            54.093677,
            44.245656
          ],
          [
            13.440886,
            54.09352,
            44.129812
          ],
          [
            13.441141,
            54.093361,
            44.01032
          ],
          [
            13.441394,
            54.093207,
            43.893211
          ],
          [
            13.441641,
            54.093058,
            43.779463
          ],
          [
            13.441927,
            54.092933,
            43.664961
          ],
          [
            13.442245,
            54.092839,
            43.429265
          ],
          [
            13.442576,
            54.092783,
            43.051911
          ],
          [
            13.442893,
            54.092735,
            42.693544
          ],
          [
            13.443208,
            54.092674,
            42.330295
          ],
          [
            13.44353,
            54.092625,
            41.965629
          ],
          [
            13.443896,
            54.092629,
            41.564978
          ],
          [
            13.444233,
            54.092603,
            41.192958
          ],
          [
            13.444576,
            54.092571,
            40.81271
          ],
          [
            13.444895,
            54.092567,
            40.46317
          ],
          [
            13.44525,
            54.092527,
            40.112289
          ],
          [
            13.445587,
            54.092537,
            39.83732
          ],
          [
            13.445943,
            54.09254,
            39.547199
          ],
          [
            13.446301,
            54.092555,
            39.254735
          ],
          [
            13.446656,
            54.092562,
            38.965041
          ],
          [
            13.446988,
            54.092593,
            38.689792
          ],
          [
            13.447299,
            54.092649,
            38.424539
          ],
          [
            13.447601,
            54.09274,
            38.147668
          ],
          [
            13.447905,
            54.092824,
            37.87311
          ],
          [
            13.448203,
            54.092886,
            37.977123
          ],
          [
            13.448525,
            54.092937,
            38.46624
          ],
          [
            13.44884,
            54.093004,
            38.956052
          ],
          [
            13.448977,
            54.093184,
            39.461561
          ],
          [
            13.449016,
            54.093131,
            40.053357
          ],
          [
            13.449287,
            54.093008,
            40.55614
          ],
          [
            13.449504,
            54.092862,
            41.039352
          ],
          [
            13.449764,
            54.092742,
            41.537615
          ],
          [
            13.450058,
            54.09285,
            42.052602
          ],
          [
            13.450428,
            54.092908,
            42.108861
          ],
          [
            13.450826,
            54.092993,
            41.925255
          ],
          [
            13.451178,
            54.093075,
            41.76102
          ],
          [
            13.451149,
            54.093046,
            41.599436
          ],
          [
            13.450781,
            54.092976,
            41.431708
          ],
          [
            13.450435,
            54.092893,
            41.269669
          ],
          [
            13.450086,
            54.092809,
            41.105878
          ],
          [
            13.449845,
            54.092668,
            40.957519
          ],
          [
            13.449773,
            54.092478,
            41.151768
          ],
          [
            13.450021,
            54.09237,
            41.587272
          ],
          [
            13.450225,
            54.092214,
            42.043876
          ],
          [
            13.45046,
            54.092047,
            42.546698
          ],
          [
            13.450807,
            54.091977,
            43.055001
          ],
          [
            13.451163,
            54.091856,
            43.616017
          ],
          [
            13.451516,
            54.091786,
            44.124227
          ],
          [
            13.451838,
            54.091648,
            44.671948
          ],
          [
            13.452144,
            54.09157,
            45.048678
          ],
          [
            13.452479,
            54.091489,
            44.8362
          ],
          [
            13.452804,
            54.091401,
            44.627292
          ],
          [
            13.453144,
            54.091282,
            44.395729
          ],
          [
            13.453483,
            54.091194,
            44.179142
          ],
          [
            13.453826,
            54.091113,
            43.963296
          ],
          [
            13.454191,
            54.091013,
            43.728112
          ],
          [
            13.454557,
            54.090912,
            43.49204
          ],
          [
            13.454881,
            54.090812,
            43.276068
          ],
          [
            13.455214,
            54.090708,
            42.922408
          ],
          [
            13.455549,
            54.090616,
            42.576804
          ],
          [
            13.455869,
            54.090526,
            42.244318
          ],
          [
            13.456184,
            54.090458,
            41.931192
          ],
          [
            13.456506,
            54.090413,
            41.622462
          ],
          [
            13.456855,
            54.09033,
            41.269863
          ],
          [
            13.457115,
            54.090189,
            40.936526
          ],
          [
            13.457352,
            54.090043,
            40.615843
          ],
          [
            13.457591,
            54.089877,
            40.659523
          ],
          [
            13.4578,
            54.089707,
            41.182078
          ],
          [
            13.45799,
            54.089508,
            41.75069
          ],
          [
            13.458138,
            54.08931,
            42.288236
          ],
          [
            13.458262,
            54.089125,
            42.783665
          ],
          [
            13.458331,
            54.088926,
            43.288873
          ],
          [
            13.45834,
            54.088722,
            43.796256
          ],
          [
            13.45835,
            54.088512,
            44.319083
          ],
          [
            13.458301,
            54.088303,
            44.843823
          ],
          [
            13.458211,
            54.088091,
            44.910751
          ],
          [
            13.458082,
            54.087884,
            44.929888
          ],
          [
            13.457952,
            54.087683,
            44.948537
          ],
          [
            13.457772,
            54.087477,
            44.968638
          ],
          [
            13.457627,
            54.087306,
            44.985219
          ],
          [
            13.457842,
            54.087176,
            45.002034
          ],
          [
            13.458206,
            54.087083,
            45.022639
          ],
          [
            13.458475,
            54.087164,
            45.039539
          ],
          [
            13.45802,
            54.087134,
            44.861496
          ],
          [
            13.45768,
            54.087216,
            44.631348
          ],
          [
            13.457776,
            54.087397,
            44.410504
          ],
          [
            13.457924,
            54.08757,
            44.203782
          ],
          [
            13.457774,
            54.087398,
            43.997581
          ],
          [
            13.457718,
            54.087208,
            43.775201
          ],
          [
            13.458062,
            54.087083,
            43.517709
          ],
          [
            13.458414,
            54.087001,
            43.280547
          ],
          [
            13.458735,
            54.086906,
            43.237255
          ],
          [
            13.459114,
            54.086808,
            43.608527
          ],
          [
            13.459465,
            54.086723,
            43.948622
          ],
          [
            13.459823,
            54.086622,
            44.305312
          ],
          [
            13.460214,
            54.086557,
            44.669202
          ],
          [
            13.460585,
            54.086477,
            45.023089
          ],
          [
            13.460991,
            54.086397,
            45.406948
          ],
          [
            13.461325,
            54.086273,
            45.760875
          ],
          [
            13.46166,
            54.086224,
            46.186633
          ],
          [
            13.462002,
            54.086164,
            46.697711
          ],
          [
            13.462338,
            54.086092,
            47.209509
          ],
          [
            13.462673,
            54.086019,
            47.720687
          ],
          [
            13.463006,
            54.085944,
            48.2309
          ],
          [
            13.463355,
            54.085872,
            48.760079
          ],
          [
            13.463685,
            54.085788,
            49.274901
          ],
          [
            13.464021,
            54.085747,
            49.765885
          ],
          [
            13.464344,
            54.085685,
            50.252337
          ],
          [
            13.464671,
            54.085609,
            50.112035
          ],
          [
            13.465005,
            54.08555,
            49.96185
          ],
          [
            13.465315,
            54.085525,
            49.827172
          ],
          [
            13.465652,
            54.085437,
            49.668362
          ],
          [
            13.465981,
            54.085358,
            49.515297
          ],
          [
            13.46632,
            54.085281,
            49.35847
          ],
          [
            13.466641,
            54.085203,
            49.208811
          ],
          [
            13.46697,
            54.085123,
            49.0555
          ],
          [
            13.46733,
            54.085045,
            48.882452
          ],
          [
            13.467692,
            54.084969,
            48.691381
          ],
          [
            13.468051,
            54.084891,
            48.501175
          ],
          [
            13.468431,
            54.084803,
            48.298266
          ],
          [
            13.468813,
            54.084713,
            48.093858
          ],
          [
            13.469211,
            54.084638,
            47.88624
          ],
          [
            13.469602,
            54.084564,
            47.682151
          ],
          [
            13.469991,
            54.084484,
            47.477462
          ],
          [
            13.470413,
            54.084403,
            47.241629
          ],
          [
            13.470816,
            54.084309,
            47.005982
          ],
          [
            13.471173,
            54.084213,
            46.792424
          ],
          [
            13.471546,
            54.084123,
            46.57307
          ],
          [
            13.471833,
            54.084,
            46.377359
          ],
          [
            13.472169,
            54.083945,
            46.172902
          ],
          [
            13.472476,
            54.083837,
            45.963515
          ],
          [
            13.472793,
            54.083794,
            45.772247
          ],
          [
            13.473146,
            54.083769,
            46.115666
          ],
          [
            13.473505,
            54.083713,
            46.514114
          ],
          [
            13.473857,
            54.083648,
            46.909952
          ],
          [
            13.474208,
            54.083576,
            47.309583
          ],
          [
            13.474521,
            54.083506,
            47.669164
          ],
          [
            13.474871,
            54.083431,
            48.068887
          ],
          [
            13.475198,
            54.083367,
            48.438704
          ],
          [
            13.475372,
            54.083225,
            48.800447
          ],
          [
            13.475249,
            54.083021,
            48.88318
          ],
          [
            13.475138,
            54.082819,
            48.485447
          ],
          [
            13.475014,
            54.082626,
            48.098949
          ],
          [
            13.47487,
            54.082441,
            47.71763
          ],
          [
            13.474792,
            54.082253,
            47.354952
          ],
          [
            13.474683,
            54.08207,
            46.991565
          ],
          [
            13.474601,
            54.081888,
            46.636093
          ],
          [
            13.474443,
            54.081833,
            46.280337
          ],
          [
            13.474038,
            54.081771,
            45.805008
          ],
          [
            13.473839,
            54.081518,
            45.671324
          ],
          [
            13.473877,
            54.081259,
            45.671324
          ],
          [
            13.473651,
            54.081314,
            45.671324
          ],
          [
            13.473932,
            54.081387,
            45.671324
          ]
        ]
      }
    }
  ]
}


let day32: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            13.473717,
            54.081949,
            50.995588
          ],
          [
            13.474061,
            54.081886,
            50.995588
          ],
          [
            13.474381,
            54.081833,
            50.995588
          ],
          [
            13.474701,
            54.081632,
            50.995588
          ],
          [
            13.474875,
            54.081459,
            51.004781
          ],
          [
            13.475047,
            54.081272,
            51.150821
          ],
          [
            13.475239,
            54.081117,
            51.282981
          ],
          [
            13.475396,
            54.080954,
            51.41144
          ],
          [
            13.475451,
            54.08076,
            51.547091
          ],
          [
            13.475399,
            54.080555,
            51.689335
          ],
          [
            13.475319,
            54.080236,
            51.912225
          ],
          [
            13.475186,
            54.080038,
            52.058174
          ],
          [
            13.475075,
            54.079839,
            52.202084
          ],
          [
            13.474977,
            54.079642,
            51.142924
          ],
          [
            13.474869,
            54.079452,
            49.829369
          ],
          [
            13.474773,
            54.079237,
            48.377517
          ],
          [
            13.474632,
            54.079061,
            47.106667
          ],
          [
            13.474618,
            54.078865,
            45.824784
          ],
          [
            13.474524,
            54.078681,
            44.569392
          ],
          [
            13.474441,
            54.078495,
            43.313223
          ],
          [
            13.474317,
            54.078224,
            41.480081
          ],
          [
            13.474188,
            54.078042,
            40.283763
          ],
          [
            13.474133,
            54.077815,
            39.239038
          ],
          [
            13.474059,
            54.077629,
            38.388272
          ],
          [
            13.473939,
            54.077439,
            37.479576
          ],
          [
            13.47383,
            54.077234,
            36.523202
          ],
          [
            13.473778,
            54.077043,
            35.657668
          ],
          [
            13.473691,
            54.076866,
            34.836837
          ],
          [
            13.473581,
            54.076678,
            33.947084
          ],
          [
            13.473506,
            54.07647,
            33.000331
          ],
          [
            13.4734,
            54.076291,
            32.724229
          ],
          [
            13.473264,
            54.076092,
            33.483624
          ],
          [
            13.473169,
            54.075907,
            34.165966
          ],
          [
            13.473069,
            54.07569,
            34.959481
          ],
          [
            13.472959,
            54.07549,
            35.701368
          ],
          [
            13.472863,
            54.075288,
            36.443212
          ],
          [
            13.472766,
            54.075095,
            37.153773
          ],
          [
            13.472693,
            54.074918,
            37.796874
          ],
          [
            13.472653,
            54.074709,
            38.539711
          ],
          [
            13.472517,
            54.074542,
            39.202595
          ],
          [
            13.472462,
            54.074337,
            39.949588
          ],
          [
            13.472402,
            54.074142,
            40.659833
          ],
          [
            13.472322,
            54.07396,
            41.343177
          ],
          [
            13.472248,
            54.073772,
            42.041415
          ],
          [
            13.472142,
            54.073592,
            42.730687
          ],
          [
            13.472079,
            54.073406,
            43.411664
          ],
          [
            13.471996,
            54.073213,
            44.124809
          ],
          [
            13.471907,
            54.073014,
            44.863511
          ],
          [
            13.471834,
            54.07282,
            45.417683
          ],
          [
            13.471714,
            54.07261,
            45.811323
          ],
          [
            13.471672,
            54.072402,
            46.183561
          ],
          [
            13.471618,
            54.072203,
            46.547171
          ],
          [
            13.471941,
            54.072147,
            46.90937
          ],
          [
            13.472301,
            54.072166,
            47.286287
          ],
          [
            13.47264,
            54.072188,
            47.642048
          ],
          [
            13.472976,
            54.072201,
            47.994302
          ],
          [
            13.473302,
            54.072199,
            48.335182
          ],
          [
            13.473649,
            54.072174,
            48.850077
          ],
          [
            13.473983,
            54.072182,
            49.417018
          ],
          [
            13.474355,
            54.072159,
            50.050138
          ],
          [
            13.474671,
            54.072167,
            50.590618
          ],
          [
            13.475002,
            54.072192,
            51.156153
          ],
          [
            13.475355,
            54.072208,
            51.757902
          ],
          [
            13.475714,
            54.072275,
            52.399537
          ],
          [
            13.476031,
            54.072352,
            52.987293
          ],
          [
            13.476398,
            54.072426,
            53.640439
          ],
          [
            13.476718,
            54.072518,
            52.073676
          ],
          [
            13.477035,
            54.072578,
            50.612918
          ],
          [
            13.477374,
            54.07263,
            49.073037
          ],
          [
            13.477713,
            54.072657,
            47.561139
          ],
          [
            13.477834,
            54.072832,
            46.016769
          ],
          [
            13.477876,
            54.073016,
            44.62863
          ],
          [
            13.477981,
            54.073227,
            42.988455
          ],
          [
            13.478033,
            54.073428,
            41.471291
          ],
          [
            13.478097,
            54.073657,
            40.345302
          ],
          [
            13.478178,
            54.073895,
            40.790314
          ],
          [
            13.47841,
            54.074106,
            41.252846
          ],
          [
            13.478695,
            54.074241,
            41.64586
          ],
          [
            13.479007,
            54.074333,
            42.020839
          ],
          [
            13.479341,
            54.074472,
            42.46016
          ],
          [
            13.47969,
            54.074583,
            42.88593
          ],
          [
            13.480019,
            54.07467,
            43.272855
          ],
          [
            13.480179,
            54.074839,
            43.539669
          ],
          [
            13.480144,
            54.075043,
            43.612071
          ],
          [
            13.479817,
            54.075205,
            43.712137
          ],
          [
            13.479629,
            54.075339,
            43.785474
          ],
          [
            13.479718,
            54.075524,
            43.853395
          ],
          [
            13.479399,
            54.075572,
            43.921766
          ],
          [
            13.479365,
            54.075544,
            43.989454
          ],
          [
            13.479519,
            54.075375,
            44.057165
          ],
          [
            13.479751,
            54.07524,
            44.125254
          ],
          [
            13.480049,
            54.075176,
            44.074938
          ],
          [
            13.480096,
            54.075379,
            43.953268
          ],
          [
            13.480052,
            54.075563,
            43.842881
          ],
          [
            13.480008,
            54.075774,
            43.716705
          ],
          [
            13.480122,
            54.07596,
            43.595244
          ],
          [
            13.480422,
            54.07603,
            43.482379
          ],
          [
            13.480757,
            54.076084,
            43.359224
          ],
          [
            13.481102,
            54.076051,
            43.23754
          ],
          [
            13.481481,
            54.076019,
            43.104152
          ],
          [
            13.481792,
            54.075997,
            42.82096
          ],
          [
            13.482128,
            54.07597,
            42.462218
          ],
          [
            13.482474,
            54.075944,
            42.093075
          ],
          [
            13.482813,
            54.075904,
            41.727284
          ],
          [
            13.483182,
            54.075865,
            41.330396
          ],
          [
            13.483561,
            54.075865,
            40.929492
          ],
          [
            13.483911,
            54.075835,
            40.555318
          ],
          [
            13.484279,
            54.075806,
            40.162125
          ],
          [
            13.484617,
            54.075779,
            39.813982
          ],
          [
            13.484934,
            54.07573,
            39.590327
          ],
          [
            13.485291,
            54.075707,
            39.34544
          ],
          [
            13.48566,
            54.075686,
            39.092711
          ],
          [
            13.486006,
            54.075699,
            38.856154
          ],
          [
            13.486213,
            54.075867,
            38.600208
          ],
          [
            13.486225,
            54.076076,
            38.357151
          ],
          [
            13.486239,
            54.076284,
            38.115231
          ],
          [
            13.486253,
            54.076487,
            37.879043
          ],
          [
            13.486335,
            54.076708,
            37.94015
          ],
          [
            13.486481,
            54.076908,
            38.308935
          ],
          [
            13.486538,
            54.077125,
            38.681539
          ],
          [
            13.486564,
            54.077335,
            39.038549
          ],
          [
            13.486565,
            54.077558,
            39.416633
          ],
          [
            13.486566,
            54.077773,
            39.781063
          ],
          [
            13.486591,
            54.078002,
            40.170355
          ],
          [
            13.486581,
            54.078206,
            40.516334
          ],
          [
            13.486601,
            54.078396,
            40.781279
          ],
          [
            13.48661,
            54.078589,
            40.663098
          ],
          [
            13.486614,
            54.078797,
            40.536411
          ],
          [
            13.486627,
            54.079013,
            40.404702
          ],
          [
            13.486657,
            54.079223,
            40.276286
          ],
          [
            13.486661,
            54.079418,
            40.157515
          ],
          [
            13.486638,
            54.079628,
            40.028741
          ],
          [
            13.486646,
            54.079843,
            39.897001
          ],
          [
            13.486616,
            54.080061,
            39.763779
          ],
          [
            13.486835,
            54.080133,
            39.455944
          ],
          [
            13.487175,
            54.080058,
            38.921844
          ],
          [
            13.487528,
            54.080031,
            38.403777
          ],
          [
            13.487859,
            54.079956,
            37.887733
          ],
          [
            13.488164,
            54.079916,
            37.43476
          ],
          [
            13.488541,
            54.079847,
            36.862414
          ],
          [
            13.488876,
            54.07978,
            36.348707
          ],
          [
            13.489178,
            54.079721,
            35.884538
          ],
          [
            13.48951,
            54.079688,
            35.396583
          ],
          [
            13.489824,
            54.079646,
            35.347427
          ],
          [
            13.490156,
            54.079589,
            35.483367
          ],
          [
            13.490461,
            54.07953,
            35.610066
          ],
          [
            13.490773,
            54.079483,
            35.736664
          ],
          [
            13.491148,
            54.079409,
            35.89268
          ],
          [
            13.491462,
            54.079365,
            36.019521
          ],
          [
            13.491783,
            54.079308,
            36.151673
          ],
          [
            13.492143,
            54.079241,
            36.300081
          ],
          [
            13.492525,
            54.079177,
            36.456168
          ],
          [
            13.492876,
            54.079105,
            36.920911
          ],
          [
            13.493189,
            54.079042,
            37.348635
          ],
          [
            13.493525,
            54.078976,
            37.806309
          ],
          [
            13.493846,
            54.078922,
            38.237895
          ],
          [
            13.494153,
            54.078851,
            38.664553
          ],
          [
            13.494504,
            54.078777,
            39.146322
          ],
          [
            13.494886,
            54.078734,
            39.65343
          ],
          [
            13.495201,
            54.078704,
            40.067377
          ],
          [
            13.495516,
            54.078649,
            40.403767
          ],
          [
            13.495845,
            54.0786,
            40.292554
          ],
          [
            13.496194,
            54.078549,
            40.174759
          ],
          [
            13.496542,
            54.078518,
            40.059457
          ],
          [
            13.496888,
            54.078525,
            39.943974
          ],
          [
            13.497271,
            54.078569,
            39.813384
          ],
          [
            13.497672,
            54.078523,
            39.679291
          ],
          [
            13.498042,
            54.078467,
            39.553047
          ],
          [
            13.498409,
            54.078485,
            39.432431
          ],
          [
            13.49874,
            54.078467,
            39.992901
          ],
          [
            13.499085,
            54.078406,
            40.730453
          ],
          [
            13.499477,
            54.078369,
            41.532592
          ],
          [
            13.499878,
            54.078328,
            42.346654
          ],
          [
            13.500235,
            54.078328,
            43.058751
          ],
          [
            13.500612,
            54.078347,
            43.813019
          ],
          [
            13.500981,
            54.078363,
            44.553932
          ],
          [
            13.501352,
            54.078391,
            45.299235
          ],
          [
            13.501735,
            54.078408,
            45.696707
          ],
          [
            13.502089,
            54.078409,
            45.920697
          ],
          [
            13.502471,
            54.078427,
            46.16349
          ],
          [
            13.502825,
            54.078429,
            46.386783
          ],
          [
            13.503167,
            54.078364,
            46.61415
          ],
          [
            13.503535,
            54.078306,
            46.855491
          ],
          [
            13.503909,
            54.078294,
            47.091936
          ],
          [
            13.504299,
            54.078263,
            47.340193
          ],
          [
            13.504682,
            54.078233,
            47.172144
          ],
          [
            13.505056,
            54.078194,
            46.617045
          ],
          [
            13.505431,
            54.078128,
            46.045104
          ],
          [
            13.505809,
            54.078061,
            45.468246
          ],
          [
            13.506175,
            54.077986,
            44.902515
          ],
          [
            13.506519,
            54.07793,
            44.381513
          ],
          [
            13.506839,
            54.077847,
            43.870915
          ],
          [
            13.507155,
            54.077765,
            43.366675
          ],
          [
            13.507481,
            54.077696,
            42.873635
          ],
          [
            13.507811,
            54.077615,
            42.404621
          ],
          [
            13.508121,
            54.077533,
            41.958704
          ],
          [
            13.508446,
            54.077435,
            41.479376
          ],
          [
            13.508781,
            54.07733,
            40.981392
          ],
          [
            13.509091,
            54.077239,
            40.526895
          ],
          [
            13.509401,
            54.077153,
            40.077263
          ],
          [
            13.509705,
            54.077074,
            39.641215
          ],
          [
            13.510006,
            54.076986,
            39.200245
          ],
          [
            13.510313,
            54.076899,
            39.160698
          ],
          [
            13.510615,
            54.076815,
            39.558648
          ],
          [
            13.510908,
            54.076723,
            39.954907
          ],
          [
            13.511202,
            54.076643,
            40.342128
          ],
          [
            13.511513,
            54.076547,
            40.760463
          ],
          [
            13.511797,
            54.076453,
            41.148755
          ],
          [
            13.51211,
            54.076352,
            41.574743
          ],
          [
            13.512446,
            54.076244,
            42.032212
          ],
          [
            13.512743,
            54.076164,
            42.421833
          ],
          [
            13.513092,
            54.076117,
            42.951639
          ],
          [
            13.513409,
            54.076053,
            43.528563
          ],
          [
            13.513741,
            54.075994,
            44.125259
          ],
          [
            13.51407,
            54.075957,
            44.701252
          ],
          [
            13.514412,
            54.075936,
            45.292533
          ],
          [
            13.514775,
            54.075903,
            45.925684
          ],
          [
            13.515152,
            54.075888,
            46.576203
          ],
          [
            13.515564,
            54.075896,
            47.286136
          ],
          [
            13.515976,
            54.075876,
            47.848414
          ],
          [
            13.516358,
            54.075836,
            47.617222
          ],
          [
            13.516711,
            54.075822,
            47.406475
          ],
          [
            13.517078,
            54.075808,
            47.187191
          ],
          [
            13.517443,
            54.075789,
            46.968726
          ],
          [
            13.517431,
            54.075781,
            46.756283
          ],
          [
            13.517389,
            54.075919,
            46.571317
          ],
          [
            13.517401,
            54.076174,
            46.311103
          ],
          [
            13.517083,
            54.076283,
            46.084369
          ],
          [
            13.516787,
            54.076353,
            46.122752
          ],
          [
            13.51647,
            54.076326,
            46.194274
          ],
          [
            13.516169,
            54.076404,
            46.267157
          ],
          [
            13.515939,
            54.07625,
            46.344505
          ],
          [
            13.515612,
            54.076145,
            46.427886
          ],
          [
            13.515245,
            54.076222,
            46.52
          ],
          [
            13.515013,
            54.076339,
            46.594848
          ],
          [
            13.515278,
            54.076466,
            46.671365
          ],
          [
            13.515338,
            54.076467,
            46.739037
          ],
          [
            13.515657,
            54.07641,
            46.741443
          ],
          [
            13.515959,
            54.07637,
            46.743663
          ],
          [
            13.515596,
            54.07641,
            46.746303
          ],
          [
            13.515328,
            54.076539,
            46.749106
          ],
          [
            13.515124,
            54.076666,
            46.751839
          ],
          [
            13.514778,
            54.076675,
            46.754312
          ],
          [
            13.514839,
            54.076779,
            46.756947
          ],
          [
            13.515202,
            54.076754,
            46.759561
          ],
          [
            13.515195,
            54.076759,
            46.72312
          ],
          [
            13.514781,
            54.076842,
            46.601059
          ],
          [
            13.514439,
            54.076861,
            46.507607
          ],
          [
            13.514412,
            54.076829,
            46.416502
          ],
          [
            13.514372,
            54.076751,
            46.330866
          ],
          [
            13.514039,
            54.076839,
            46.225205
          ],
          [
            13.514031,
            54.07685,
            46.139616
          ],
          [
            13.513758,
            54.076915,
            46.054761
          ],
          [
            13.513435,
            54.076952,
            45.965145
          ],
          [
            13.513084,
            54.077076,
            45.720928
          ],
          [
            13.513242,
            54.077246,
            45.468319
          ],
          [
            13.513121,
            54.077385,
            45.234225
          ],
          [
            13.513147,
            54.077495,
            45.004085
          ],
          [
            13.513201,
            54.077662,
            44.77562
          ],
          [
            13.513464,
            54.077683,
            44.49654
          ],
          [
            13.513494,
            54.077647,
            44.273634
          ],
          [
            13.513589,
            54.077828,
            44.032251
          ],
          [
            13.513317,
            54.077912,
            43.799652
          ],
          [
            13.513224,
            54.077926,
            43.910556
          ],
          [
            13.513564,
            54.077948,
            44.155523
          ],
          [
            13.513905,
            54.077849,
            44.43804
          ],
          [
            13.513742,
            54.077717,
            44.683811
          ],
          [
            13.514035,
            54.0778,
            44.916139
          ],
          [
            13.513976,
            54.077906,
            45.143845
          ],
          [
            13.513665,
            54.077981,
            45.384191
          ],
          [
            13.513353,
            54.078004,
            45.609085
          ],
          [
            13.5137,
            54.07798,
            45.858572
          ],
          [
            13.514008,
            54.077983,
            45.84353
          ],
          [
            13.514349,
            54.077936,
            45.704319
          ],
          [
            13.514691,
            54.077923,
            45.568501
          ],
          [
            13.515005,
            54.077911,
            45.44149
          ],
          [
            13.515248,
            54.0778,
            45.317034
          ],
          [
            13.515284,
            54.077839,
            45.188096
          ],
          [
            13.515283,
            54.077768,
            45.035173
          ],
          [
            13.515562,
            54.077813,
            44.904471
          ],
          [
            13.515587,
            54.077757,
            44.776881
          ],
          [
            13.515631,
            54.07759,
            44.738214
          ],
          [
            13.515516,
            54.077428,
            44.792136
          ],
          [
            13.515557,
            54.07727,
            44.843979
          ],
          [
            13.515697,
            54.07715,
            44.895888
          ],
          [
            13.515486,
            54.077002,
            44.950608
          ],
          [
            13.515455,
            54.076806,
            45.006636
          ],
          [
            13.515462,
            54.076996,
            45.060494
          ],
          [
            13.515666,
            54.07709,
            45.113505
          ],
          [
            13.515574,
            54.07712,
            45.167658
          ],
          [
            13.515446,
            54.076947,
            45.221057
          ],
          [
            13.515155,
            54.077026,
            45.073402
          ],
          [
            13.514985,
            54.077133,
            44.918226
          ],
          [
            13.51496,
            54.077323,
            44.763268
          ],
          [
            13.515013,
            54.077366,
            44.612767
          ],
          [
            13.514844,
            54.077417,
            44.460383
          ],
          [
            13.514517,
            54.07743,
            44.30227
          ],
          [
            13.514322,
            54.07756,
            44.15118
          ],
          [
            13.514061,
            54.077664,
            43.987225
          ],
          [
            13.513884,
            54.077787,
            43.824493
          ],
          [
            13.51361,
            54.07789,
            43.693554
          ],
          [
            13.513348,
            54.077985,
            43.587354
          ],
          [
            13.513684,
            54.077997,
            43.471656
          ],
          [
            13.514023,
            54.078003,
            43.354139
          ],
          [
            13.514426,
            54.077963,
            43.21408
          ],
          [
            13.514801,
            54.077937,
            43.084871
          ],
          [
            13.515027,
            54.077825,
            42.960602
          ],
          [
            13.514921,
            54.07764,
            42.84188
          ],
          [
            13.515062,
            54.07751,
            42.731935
          ],
          [
            13.514755,
            54.077468,
            43.069013
          ],
          [
            13.515031,
            54.077346,
            43.529569
          ],
          [
            13.515051,
            54.077143,
            43.989645
          ],
          [
            13.515295,
            54.077024,
            44.413724
          ],
          [
            13.515424,
            54.076829,
            44.891663
          ],
          [
            13.51506,
            54.076781,
            45.42042
          ],
          [
            13.515363,
            54.076717,
            45.8714
          ],
          [
            13.51535,
            54.076507,
            46.346621
          ],
          [
            13.515696,
            54.076455,
            46.82249
          ],
          [
            13.516005,
            54.07644,
            47.258659
          ],
          [
            13.516076,
            54.07644,
            47.823926
          ],
          [
            13.516372,
            54.076361,
            48.296517
          ],
          [
            13.516701,
            54.076345,
            48.758611
          ],
          [
            13.516994,
            54.076419,
            49.20468
          ],
          [
            13.517293,
            54.076334,
            49.67007
          ],
          [
            13.517392,
            54.076143,
            50.146651
          ],
          [
            13.517327,
            54.075942,
            50.640741
          ],
          [
            13.517529,
            54.075804,
            50.989826
          ],
          [
            13.517934,
            54.075791,
            50.383723
          ],
          [
            13.518266,
            54.075772,
            49.885351
          ],
          [
            13.518609,
            54.075743,
            49.367606
          ],
          [
            13.518959,
            54.075727,
            48.842759
          ],
          [
            13.519307,
            54.075696,
            48.316675
          ],
          [
            13.519686,
            54.075674,
            47.747596
          ],
          [
            13.520068,
            54.075652,
            47.173954
          ],
          [
            13.520463,
            54.075642,
            46.582911
          ],
          [
            13.520882,
            54.075616,
            46.586875
          ],
          [
            13.521256,
            54.075583,
            46.703434
          ],
          [
            13.521609,
            54.075585,
            46.812083
          ],
          [
            13.521928,
            54.075571,
            46.910528
          ],
          [
            13.522309,
            54.075549,
            47.028402
          ],
          [
            13.522705,
            54.075522,
            47.151128
          ],
          [
            13.523143,
            54.075489,
            47.287193
          ],
          [
            13.523517,
            54.075458,
            47.403477
          ],
          [
            13.523882,
            54.07544,
            47.33758
          ],
          [
            13.524256,
            54.075445,
            47.234349
          ],
          [
            13.524569,
            54.075536,
            47.137392
          ],
          [
            13.524874,
            54.075487,
            47.050081
          ],
          [
            13.525256,
            54.075462,
            46.94364
          ],
          [
            13.525632,
            54.075445,
            46.839386
          ],
          [
            13.526023,
            54.075424,
            46.730801
          ],
          [
            13.526387,
            54.07541,
            46.630138
          ],
          [
            13.526717,
            54.075395,
            46.524887
          ],
          [
            13.52704,
            54.075343,
            46.39838
          ],
          [
            13.527228,
            54.075197,
            46.280378
          ],
          [
            13.527449,
            54.075044,
            46.151562
          ],
          [
            13.527673,
            54.074877,
            46.013597
          ],
          [
            13.528002,
            54.074816,
            45.882906
          ],
          [
            13.528335,
            54.074734,
            45.746732
          ],
          [
            13.528652,
            54.074673,
            45.621035
          ],
          [
            13.528976,
            54.074602,
            45.489242
          ],
          [
            13.529289,
            54.074541,
            45.713842
          ],
          [
            13.529598,
            54.074474,
            46.353434
          ],
          [
            13.529919,
            54.074521,
            47.018278
          ],
          [
            13.530188,
            54.07465,
            47.69623
          ],
          [
            13.530473,
            54.074771,
            48.379009
          ],
          [
            13.530754,
            54.074903,
            49.083691
          ],
          [
            13.531062,
            54.074983,
            49.738266
          ],
          [
            13.531371,
            54.07509,
            50.434615
          ],
          [
            13.531666,
            54.075202,
            51.11659
          ],
          [
            13.531954,
            54.075311,
            51.020804
          ],
          [
            13.532303,
            54.075427,
            50.361058
          ],
          [
            13.532134,
            54.07559,
            49.806894
          ],
          [
            13.532014,
            54.075805,
            49.168483
          ],
          [
            13.532023,
            54.076015,
            48.578813
          ],
          [
            13.532085,
            54.076217,
            48.004086
          ],
          [
            13.532208,
            54.076409,
            47.430386
          ],
          [
            13.532376,
            54.076582,
            46.872265
          ],
          [
            13.532526,
            54.076792,
            46.264498
          ],
          [
            13.532642,
            54.076991,
            45.836161
          ],
          [
            13.532807,
            54.077187,
            45.393209
          ],
          [
            13.53297,
            54.077391,
            44.936378
          ],
          [
            13.533135,
            54.077587,
            44.493231
          ],
          [
            13.533316,
            54.077805,
            44.002226
          ],
          [
            13.533452,
            54.078012,
            43.553005
          ],
          [
            13.533615,
            54.078209,
            43.109539
          ],
          [
            13.533764,
            54.078411,
            42.684129
          ],
          [
            13.533898,
            54.078615,
            42.498836
          ],
          [
            13.533986,
            54.07881,
            42.327791
          ],
          [
            13.534094,
            54.079032,
            42.131552
          ],
          [
            13.534122,
            54.07924,
            41.954708
          ],
          [
            13.534174,
            54.079427,
            41.793303
          ],
          [
            13.534236,
            54.079654,
            41.598416
          ],
          [
            13.534213,
            54.079868,
            41.416455
          ],
          [
            13.534267,
            54.080082,
            41.231646
          ],
          [
            13.534389,
            54.080304,
            41.169162
          ],
          [
            13.534491,
            54.080542,
            41.161552
          ],
          [
            13.534588,
            54.080764,
            41.154447
          ],
          [
            13.534646,
            54.080989,
            41.147397
          ],
          [
            13.534706,
            54.081209,
            41.140495
          ],
          [
            13.534767,
            54.081427,
            41.133649
          ],
          [
            13.534841,
            54.08169,
            41.125375
          ],
          [
            13.5349,
            54.081904,
            41.118658
          ],
          [
            13.534949,
            54.082098,
            41.084858
          ],
          [
            13.534984,
            54.082292,
            41.051039
          ],
          [
            13.535085,
            54.082476,
            41.017317
          ],
          [
            13.535194,
            54.08269,
            40.978498
          ],
          [
            13.535353,
            54.082866,
            40.943827
          ],
          [
            13.535552,
            54.083035,
            40.908202
          ],
          [
            13.535663,
            54.083229,
            40.871812
          ],
          [
            13.535689,
            54.083423,
            40.837955
          ],
          [
            13.535841,
            54.083586,
            40.815891
          ],
          [
            13.536044,
            54.083796,
            41.137871
          ],
          [
            13.536234,
            54.083982,
            41.427069
          ],
          [
            13.535969,
            54.084042,
            41.715723
          ],
          [
            13.535607,
            54.084023,
            42.009848
          ],
          [
            13.535377,
            54.084158,
            42.27574
          ],
          [
            13.535223,
            54.084327,
            42.531359
          ],
          [
            13.535075,
            54.084529,
            42.82538
          ],
          [
            13.534895,
            54.084701,
            43.094555
          ],
          [
            13.534576,
            54.084828,
            43.427875
          ],
          [
            13.53425,
            54.084908,
            43.746941
          ],
          [
            13.53395,
            54.084973,
            44.035136
          ],
          [
            13.533606,
            54.085055,
            44.36948
          ],
          [
            13.533356,
            54.085205,
            44.694049
          ],
          [
            13.533173,
            54.085381,
            45.012909
          ],
          [
            13.533074,
            54.085567,
            45.312172
          ],
          [
            13.53301,
            54.085773,
            45.63383
          ],
          [
            13.532967,
            54.085975,
            45.946938
          ],
          [
            13.532911,
            54.086181,
            46.725553
          ],
          [
            13.532845,
            54.086364,
            47.449128
          ],
          [
            13.5328,
            54.08657,
            48.252011
          ],
          [
            13.532818,
            54.086755,
            48.968472
          ],
          [
            13.532824,
            54.086952,
            49.730181
          ],
          [
            13.532823,
            54.08715,
            50.496039
          ],
          [
            13.532844,
            54.087334,
            51.210927
          ],
          [
            13.532856,
            54.087567,
            52.112103
          ],
          [
            13.53285,
            54.087791,
            52.934044
          ],
          [
            13.532846,
            54.088014,
            53.143044
          ],
          [
            13.532771,
            54.08821,
            53.331981
          ],
          [
            13.532655,
            54.08843,
            53.547829
          ],
          [
            13.532511,
            54.088623,
            53.745311
          ],
          [
            13.53242,
            54.088811,
            53.928611
          ],
          [
            13.532338,
            54.089017,
            54.126863
          ],
          [
            13.532302,
            54.089241,
            54.337761
          ],
          [
            13.53229,
            54.089425,
            54.510327
          ],
          [
            13.532334,
            54.089626,
            54.643541
          ],
          [
            13.532382,
            54.089849,
            54.728118
          ],
          [
            13.532406,
            54.090075,
            54.813257
          ],
          [
            13.532431,
            54.090293,
            54.895423
          ],
          [
            13.532487,
            54.090538,
            54.988365
          ],
          [
            13.532551,
            54.090771,
            55.077113
          ],
          [
            13.532589,
            54.090964,
            55.150234
          ],
          [
            13.532636,
            54.091197,
            55.238559
          ],
          [
            13.532679,
            54.091395,
            55.166319
          ],
          [
            13.532736,
            54.091586,
            54.904741
          ],
          [
            13.53277,
            54.091772,
            54.652324
          ],
          [
            13.532796,
            54.091996,
            54.348909
          ],
          [
            13.532858,
            54.09218,
            54.095978
          ],
          [
            13.532863,
            54.092456,
            53.723776
          ],
          [
            13.532949,
            54.092709,
            53.375625
          ],
          [
            13.532976,
            54.092912,
            53.101001
          ],
          [
            13.533004,
            54.093118,
            52.848423
          ],
          [
            13.533051,
            54.093353,
            52.773143
          ],
          [
            13.533108,
            54.093566,
            52.704183
          ],
          [
            13.533129,
            54.093802,
            52.628981
          ],
          [
            13.533173,
            54.094025,
            52.557567
          ],
          [
            13.533203,
            54.094224,
            52.494006
          ],
          [
            13.533245,
            54.094458,
            52.418748
          ],
          [
            13.533268,
            54.094655,
            52.355938
          ],
          [
            13.53332,
            54.094876,
            52.284867
          ],
          [
            13.533373,
            54.095133,
            52.307905
          ],
          [
            13.533442,
            54.095371,
            52.329998
          ],
          [
            13.533479,
            54.095618,
            52.352697
          ],
          [
            13.533505,
            54.095878,
            52.376522
          ],
          [
            13.533564,
            54.096129,
            52.399698
          ],
          [
            13.533646,
            54.096394,
            52.424352
          ],
          [
            13.533693,
            54.096632,
            52.446289
          ],
          [
            13.533739,
            54.096886,
            52.392417
          ],
          [
            13.533783,
            54.097125,
            52.332271
          ],
          [
            13.533829,
            54.097373,
            52.270263
          ],
          [
            13.533873,
            54.0976,
            52.2135
          ],
          [
            13.533894,
            54.097787,
            52.166952
          ],
          [
            13.533976,
            54.097975,
            52.118757
          ],
          [
            13.534009,
            54.098179,
            52.067858
          ],
          [
            13.534037,
            54.098366,
            52.021181
          ],
          [
            13.53408,
            54.098551,
            52.136584
          ],
          [
            13.534107,
            54.098778,
            52.412225
          ],
          [
            13.534073,
            54.099009,
            52.694116
          ],
          [
            13.534081,
            54.099216,
            52.944745
          ],
          [
            13.534069,
            54.099438,
            53.213785
          ],
          [
            13.534056,
            54.099633,
            53.450027
          ],
          [
            13.534015,
            54.099823,
            53.681854
          ],
          [
            13.534,
            54.10001,
            53.908468
          ],
          [
            13.533957,
            54.100265,
            54.154893
          ],
          [
            13.533952,
            54.100474,
            53.997294
          ],
          [
            13.533908,
            54.100709,
            53.819468
          ],
          [
            13.533858,
            54.100954,
            53.633898
          ],
          [
            13.533824,
            54.101194,
            53.452697
          ],
          [
            13.533802,
            54.101444,
            53.264399
          ],
          [
            13.533824,
            54.10172,
            53.054876
          ],
          [
            13.53379,
            54.101936,
            52.891719
          ],
          [
            13.533753,
            54.102128,
            52.697401
          ],
          [
            13.533729,
            54.102356,
            52.421823
          ],
          [
            13.533699,
            54.102614,
            52.109128
          ],
          [
            13.53364,
            54.102867,
            51.801124
          ],
          [
            13.533588,
            54.10309,
            51.529639
          ],
          [
            13.533567,
            54.103312,
            51.260978
          ],
          [
            13.533524,
            54.103561,
            50.959061
          ],
          [
            13.533497,
            54.103803,
            50.666478
          ],
          [
            13.533484,
            54.104053,
            50.737486
          ],
          [
            13.53347,
            54.104296,
            50.818022
          ],
          [
            13.533424,
            54.104542,
            50.899996
          ],
          [
            13.53337,
            54.104792,
            50.983364
          ],
          [
            13.533313,
            54.10505,
            51.069637
          ],
          [
            13.533294,
            54.105231,
            51.129633
          ],
          [
            13.533263,
            54.105484,
            51.213548
          ],
          [
            13.53326,
            54.105708,
            51.251467
          ],
          [
            13.533196,
            54.105937,
            51.249716
          ],
          [
            13.533176,
            54.106119,
            51.24833
          ],
          [
            13.533119,
            54.106313,
            51.246843
          ],
          [
            13.533099,
            54.106521,
            51.245271
          ],
          [
            13.533049,
            54.106713,
            51.243799
          ],
          [
            13.533025,
            54.106909,
            51.242316
          ],
          [
            13.532985,
            54.107123,
            51.24069
          ],
          [
            13.532968,
            54.107367,
            51.238847
          ],
          [
            13.532917,
            54.107609,
            51.049319
          ],
          [
            13.532857,
            54.107853,
            50.843217
          ],
          [
            13.532829,
            54.108101,
            50.635442
          ],
          [
            13.532814,
            54.108331,
            50.442919
          ],
          [
            13.532747,
            54.108568,
            50.242092
          ],
          [
            13.532696,
            54.108793,
            50.052276
          ],
          [
            13.532635,
            54.109032,
            49.850245
          ],
          [
            13.532587,
            54.10925,
            49.60744
          ],
          [
            13.532527,
            54.109487,
            49.234536
          ],
          [
            13.532533,
            54.109693,
            48.914009
          ],
          [
            13.532485,
            54.109915,
            48.56594
          ],
          [
            13.532448,
            54.110125,
            48.237488
          ],
          [
            13.53242,
            54.110321,
            47.931537
          ],
          [
            13.532337,
            54.110504,
            47.635661
          ],
          [
            13.532234,
            54.110708,
            47.298281
          ],
          [
            13.53221,
            54.110929,
            46.95298
          ],
          [
            13.53219,
            54.111139,
            46.805087
          ],
          [
            13.532145,
            54.111371,
            46.650903
          ],
          [
            13.532085,
            54.111614,
            46.488688
          ],
          [
            13.53204,
            54.111841,
            46.337769
          ],
          [
            13.53201,
            54.112044,
            46.20324
          ],
          [
            13.531982,
            54.112253,
            46.064804
          ],
          [
            13.531945,
            54.112459,
            45.928028
          ],
          [
            13.531901,
            54.112662,
            45.792891
          ],
          [
            13.531859,
            54.112853,
            45.745452
          ],
          [
            13.531815,
            54.113062,
            45.737558
          ],
          [
            13.531795,
            54.113305,
            45.728443
          ],
          [
            13.531775,
            54.113524,
            45.720187
          ],
          [
            13.532079,
            54.113704,
            45.710625
          ],
          [
            13.53241,
            54.113829,
            45.701952
          ],
          [
            13.532731,
            54.113941,
            45.693746
          ],
          [
            13.533062,
            54.114081,
            45.684781
          ],
          [
            13.533458,
            54.114238,
            45.900225
          ],
          [
            13.533769,
            54.114387,
            46.123891
          ],
          [
            13.534101,
            54.114496,
            46.335758
          ],
          [
            13.534407,
            54.114635,
            46.550863
          ],
          [
            13.534696,
            54.114766,
            46.753853
          ],
          [
            13.534989,
            54.114884,
            46.951416
          ],
          [
            13.535268,
            54.115007,
            47.145563
          ],
          [
            13.53554,
            54.115126,
            47.334224
          ],
          [
            13.535819,
            54.115279,
            47.494499
          ],
          [
            13.536132,
            54.115411,
            47.638647
          ],
          [
            13.536438,
            54.115517,
            47.771597
          ],
          [
            13.536738,
            54.115642,
            47.909302
          ],
          [
            13.537076,
            54.115789,
            48.066492
          ],
          [
            13.537398,
            54.115934,
            48.218171
          ],
          [
            13.537646,
            54.116044,
            48.334446
          ],
          [
            13.537926,
            54.116173,
            48.467525
          ],
          [
            13.538191,
            54.116302,
            48.418416
          ],
          [
            13.538485,
            54.116453,
            48.148909
          ],
          [
            13.538687,
            54.116598,
            47.927523
          ],
          [
            13.539033,
            54.116727,
            47.644345
          ],
          [
            13.539358,
            54.116858,
            47.372455
          ],
          [
            13.5397,
            54.117012,
            47.074985
          ],
          [
            13.540011,
            54.117153,
            46.803795
          ],
          [
            13.540277,
            54.117281,
            46.566435
          ],
          [
            13.540589,
            54.117412,
            46.457222
          ],
          [
            13.540926,
            54.117552,
            46.550497
          ],
          [
            13.541227,
            54.117683,
            46.635087
          ],
          [
            13.541521,
            54.117829,
            46.722275
          ],
          [
            13.541864,
            54.117987,
            46.820833
          ],
          [
            13.542156,
            54.118133,
            46.907616
          ],
          [
            13.542447,
            54.118227,
            46.983138
          ],
          [
            13.542713,
            54.118346,
            47.058639
          ],
          [
            13.542964,
            54.11847,
            47.160432
          ],
          [
            13.543223,
            54.118585,
            47.326751
          ],
          [
            13.543505,
            54.118686,
            47.49589
          ],
          [
            13.543804,
            54.11881,
            47.683761
          ],
          [
            13.544115,
            54.118982,
            47.902584
          ],
          [
            13.544435,
            54.119108,
            48.100045
          ],
          [
            13.544684,
            54.119221,
            48.262301
          ],
          [
            13.54496,
            54.119349,
            48.442522
          ],
          [
            13.545229,
            54.119474,
            48.618235
          ],
          [
            13.545499,
            54.119607,
            48.630425
          ],
          [
            13.545769,
            54.119721,
            48.557429
          ],
          [
            13.546039,
            54.119854,
            48.480062
          ],
          [
            13.546312,
            54.119971,
            48.405876
          ],
          [
            13.54658,
            54.120096,
            48.3305
          ],
          [
            13.546902,
            54.120227,
            48.244504
          ],
          [
            13.547168,
            54.120336,
            48.173303
          ],
          [
            13.547421,
            54.120451,
            48.103062
          ],
          [
            13.547734,
            54.120582,
            48.018605
          ],
          [
            13.548091,
            54.120703,
            47.669647
          ],
          [
            13.548457,
            54.120734,
            47.325434
          ],
          [
            13.548775,
            54.120687,
            47.020844
          ],
          [
            13.549132,
            54.120648,
            46.683635
          ],
          [
            13.549495,
            54.120606,
            46.339772
          ],
          [
            13.549848,
            54.12058,
            46.009301
          ],
          [
            13.550208,
            54.120545,
            45.670394
          ],
          [
            13.550487,
            54.120677,
            45.336703
          ],
          [
            13.550755,
            54.120813,
            45.407024
          ],
          [
            13.551018,
            54.120946,
            45.938448
          ],
          [
            13.551287,
            54.121046,
            46.428439
          ],
          [
            13.5516,
            54.121086,
            46.91868
          ],
          [
            13.551963,
            54.121086,
            47.474854
          ],
          [
            13.552334,
            54.121081,
            48.042578
          ],
          [
            13.552684,
            54.121064,
            48.579982
          ],
          [
            13.552995,
            54.121036,
            49.061316
          ],
          [
            13.553349,
            54.121008,
            49.607881
          ],
          [
            13.553655,
            54.120972,
            49.976927
          ],
          [
            13.554043,
            54.120951,
            50.294723
          ],
          [
            13.554414,
            54.120938,
            50.598481
          ],
          [
            13.55476,
            54.120908,
            50.883766
          ],
          [
            13.555084,
            54.120874,
            51.152262
          ],
          [
            13.555423,
            54.120836,
            51.433745
          ],
          [
            13.555732,
            54.120806,
            51.689181
          ],
          [
            13.556098,
            54.120774,
            51.991037
          ],
          [
            13.556435,
            54.12074,
            52.270258
          ],
          [
            13.556819,
            54.120717,
            52.35981
          ],
          [
            13.557211,
            54.120662,
            52.36553
          ],
          [
            13.557637,
            54.120618,
            52.371669
          ],
          [
            13.558025,
            54.120591,
            52.377219
          ],
          [
            13.558411,
            54.12052,
            52.382965
          ],
          [
            13.558785,
            54.120429,
            52.388712
          ],
          [
            13.559161,
            54.120334,
            52.394522
          ],
          [
            13.559565,
            54.120264,
            52.354995
          ],
          [
            13.559945,
            54.120182,
            52.130947
          ],
          [
            13.560331,
            54.120105,
            51.905316
          ],
          [
            13.560719,
            54.120026,
            51.677902
          ],
          [
            13.561097,
            54.119959,
            51.459432
          ],
          [
            13.561459,
            54.119891,
            51.249125
          ],
          [
            13.56182,
            54.11981,
            51.035276
          ],
          [
            13.562183,
            54.119745,
            50.825208
          ],
          [
            13.562546,
            54.119677,
            50.806319
          ],
          [
            13.562914,
            54.119608,
            51.062624
          ],
          [
            13.563226,
            54.119543,
            51.282251
          ],
          [
            13.563568,
            54.119463,
            51.526501
          ],
          [
            13.563974,
            54.119374,
            51.814029
          ],
          [
            13.5643,
            54.119321,
            52.038743
          ],
          [
            13.56466,
            54.11926,
            52.28736
          ],
          [
            13.564997,
            54.119197,
            52.522478
          ],
          [
            13.565354,
            54.119125,
            52.726463
          ],
          [
            13.565735,
            54.11904,
            52.647077
          ],
          [
            13.56612,
            54.118963,
            52.567864
          ],
          [
            13.566418,
            54.118898,
            52.505782
          ],
          [
            13.566729,
            54.118839,
            52.442113
          ],
          [
            13.567044,
            54.118786,
            52.378305
          ],
          [
            13.567428,
            54.118771,
            52.303375
          ],
          [
            13.567775,
            54.118829,
            52.233111
          ],
          [
            13.568102,
            54.118829,
            52.169031
          ],
          [
            13.568427,
            54.118742,
            52.106928
          ],
          [
            13.568748,
            54.118685,
            52.054359
          ],
          [
            13.569068,
            54.118657,
            52.003128
          ],
          [
            13.569411,
            54.118709,
            51.947522
          ],
          [
            13.569761,
            54.118723,
            51.891082
          ],
          [
            13.570036,
            54.118601,
            51.83703
          ],
          [
            13.570336,
            54.118511,
            51.784215
          ],
          [
            13.570765,
            54.118412,
            51.711966
          ],
          [
            13.571081,
            54.118384,
            51.661886
          ],
          [
            13.571397,
            54.118358,
            51.996683
          ],
          [
            13.571743,
            54.118353,
            52.388295
          ],
          [
            13.572105,
            54.118351,
            52.797516
          ],
          [
            13.572428,
            54.118343,
            53.164634
          ],
          [
            13.572819,
            54.118338,
            53.606705
          ],
          [
            13.573133,
            54.118271,
            53.992265
          ],
          [
            13.573469,
            54.11815,
            54.438406
          ],
          [
            13.573743,
            54.118051,
            54.802813
          ],
          [
            13.574098,
            54.117935,
            55.220506
          ],
          [
            13.574367,
            54.117832,
            55.4713
          ],
          [
            13.574658,
            54.117737,
            55.731319
          ],
          [
            13.57493,
            54.117645,
            55.976459
          ],
          [
            13.575225,
            54.117541,
            56.245137
          ],
          [
            13.575562,
            54.117428,
            56.549288
          ],
          [
            13.575898,
            54.117333,
            56.840801
          ],
          [
            13.576233,
            54.117229,
            57.13681
          ],
          [
            13.576527,
            54.117156,
            57.386683
          ],
          [
            13.57682,
            54.117087,
            57.361051
          ],
          [
            13.57715,
            54.11702,
            56.962614
          ],
          [
            13.577519,
            54.116966,
            56.526234
          ],
          [
            13.577741,
            54.117111,
            56.145708
          ],
          [
            13.578023,
            54.11728,
            55.686417
          ],
          [
            13.578289,
            54.117446,
            55.244476
          ],
          [
            13.578523,
            54.117567,
            54.889543
          ],
          [
            13.578816,
            54.117729,
            54.431366
          ],
          [
            13.579097,
            54.117894,
            54.003941
          ],
          [
            13.579339,
            54.118032,
            53.80036
          ],
          [
            13.579585,
            54.118169,
            53.596217
          ],
          [
            13.57984,
            54.118323,
            53.375906
          ],
          [
            13.580113,
            54.118475,
            53.149137
          ],
          [
            13.580348,
            54.118641,
            52.927639
          ],
          [
            13.580595,
            54.118803,
            52.704634
          ],
          [
            13.580863,
            54.11896,
            52.476647
          ],
          [
            13.581138,
            54.119124,
            52.240532
          ],
          [
            13.581422,
            54.119302,
            52.496008
          ],
          [
            13.581738,
            54.11949,
            52.925097
          ],
          [
            13.582015,
            54.119669,
            53.318072
          ],
          [
            13.582288,
            54.119814,
            53.669176
          ],
          [
            13.582531,
            54.119977,
            54.021109
          ],
          [
            13.582764,
            54.120125,
            54.348769
          ],
          [
            13.583015,
            54.120261,
            54.6745
          ],
          [
            13.58324,
            54.1204,
            54.986427
          ],
          [
            13.583484,
            54.12053,
            55.235551
          ],
          [
            13.583794,
            54.120679,
            55.486573
          ],
          [
            13.584044,
            54.12081,
            55.6969
          ],
          [
            13.584338,
            54.120934,
            55.923915
          ],
          [
            13.584605,
            54.121045,
            56.128874
          ],
          [
            13.584953,
            54.121156,
            56.377333
          ],
          [
            13.585259,
            54.121261,
            56.599574
          ],
          [
            13.585547,
            54.121355,
            56.806003
          ],
          [
            13.585832,
            54.121435,
            57.004514
          ],
          [
            13.586215,
            54.121472,
            57.213325
          ],
          [
            13.586599,
            54.121537,
            57.423447
          ],
          [
            13.586912,
            54.121592,
            57.595309
          ],
          [
            13.587255,
            54.121664,
            57.786845
          ],
          [
            13.587625,
            54.121726,
            57.989156
          ],
          [
            13.587976,
            54.121784,
            58.181047
          ],
          [
            13.588303,
            54.121848,
            58.362473
          ],
          [
            13.588656,
            54.12192,
            58.559008
          ],
          [
            13.589009,
            54.12199,
            58.49587
          ],
          [
            13.589328,
            54.122057,
            58.253814
          ],
          [
            13.589666,
            54.122174,
            57.973554
          ],
          [
            13.590024,
            54.122267,
            57.693998
          ],
          [
            13.590361,
            54.122322,
            57.444222
          ],
          [
            13.59066,
            54.122392,
            57.214128
          ],
          [
            13.59105,
            54.12249,
            56.911187
          ],
          [
            13.591408,
            54.122605,
            56.619681
          ],
          [
            13.591744,
            54.122688,
            56.300736
          ],
          [
            13.592098,
            54.122791,
            55.844406
          ],
          [
            13.592439,
            54.122914,
            55.381925
          ],
          [
            13.592788,
            54.123056,
            54.890771
          ],
          [
            13.593148,
            54.123217,
            54.368027
          ],
          [
            13.593484,
            54.123415,
            53.817074
          ],
          [
            13.593819,
            54.123595,
            53.292478
          ],
          [
            13.594141,
            54.12379,
            52.906876
          ],
          [
            13.594452,
            54.123981,
            52.890289
          ],
          [
            13.594765,
            54.124162,
            52.874123
          ],
          [
            13.595077,
            54.124354,
            52.857492
          ],
          [
            13.595373,
            54.124518,
            52.842517
          ],
          [
            13.595649,
            54.124684,
            52.827973
          ],
          [
            13.595884,
            54.124845,
            52.81461
          ],
          [
            13.596165,
            54.124986,
            52.80101
          ],
          [
            13.596444,
            54.125146,
            52.977214
          ],
          [
            13.596706,
            54.1253,
            53.175103
          ],
          [
            13.596952,
            54.12545,
            53.364485
          ],
          [
            13.597221,
            54.125601,
            53.563127
          ],
          [
            13.597489,
            54.125751,
            53.761372
          ],
          [
            13.597756,
            54.12591,
            53.964508
          ],
          [
            13.597998,
            54.126064,
            54.155016
          ],
          [
            13.598252,
            54.126206,
            54.342156
          ],
          [
            13.598501,
            54.126349,
            54.403825
          ],
          [
            13.598748,
            54.126496,
            54.340443
          ],
          [
            13.599022,
            54.126657,
            54.270597
          ],
          [
            13.599279,
            54.126814,
            54.203776
          ],
          [
            13.59954,
            54.126968,
            54.137115
          ],
          [
            13.599772,
            54.127109,
            54.076895
          ],
          [
            13.600024,
            54.12723,
            54.01826
          ],
          [
            13.600299,
            54.127403,
            53.945646
          ],
          [
            13.600563,
            54.127556,
            53.878879
          ],
          [
            13.600885,
            54.127715,
            53.804166
          ],
          [
            13.601122,
            54.12785,
            53.745717
          ],
          [
            13.601395,
            54.128008,
            53.677919
          ],
          [
            13.601675,
            54.128159,
            53.610669
          ],
          [
            13.601996,
            54.128292,
            53.541073
          ],
          [
            13.602311,
            54.128438,
            53.470136
          ],
          [
            13.602639,
            54.128596,
            53.395146
          ],
          [
            13.602965,
            54.128741,
            53.285256
          ],
          [
            13.603284,
            54.128831,
            53.090593
          ],
          [
            13.603648,
            54.128916,
            52.875093
          ],
          [
            13.603988,
            54.128998,
            52.672939
          ],
          [
            13.604329,
            54.129087,
            52.467652
          ],
          [
            13.604704,
            54.129141,
            52.254693
          ],
          [
            13.605017,
            54.12929,
            52.025307
          ],
          [
            13.605118,
            54.129528,
            51.794055
          ],
          [
            13.604955,
            54.129711,
            51.558589
          ],
          [
            13.604719,
            54.129895,
            51.168846
          ],
          [
            13.604508,
            54.130036,
            50.853072
          ],
          [
            13.604307,
            54.130203,
            50.508852
          ],
          [
            13.604184,
            54.130412,
            50.136343
          ],
          [
            13.604125,
            54.13066,
            49.714789
          ],
          [
            13.604083,
            54.130893,
            49.320399
          ],
          [
            13.604157,
            54.131135,
            48.904779
          ],
          [
            13.604314,
            54.131338,
            48.562726
          ],
          [
            13.604444,
            54.131564,
            48.300177
          ],
          [
            13.604577,
            54.131766,
            48.061808
          ],
          [
            13.60466,
            54.131967,
            47.833989
          ],
          [
            13.604812,
            54.132158,
            47.601229
          ],
          [
            13.604961,
            54.132354,
            47.361237
          ],
          [
            13.604907,
            54.132564,
            47.12591
          ],
          [
            13.604698,
            54.13277,
            46.86212
          ],
          [
            13.604428,
            54.132958,
            46.524828
          ],
          [
            13.604129,
            54.133127,
            45.931366
          ],
          [
            13.603821,
            54.13325,
            45.399076
          ],
          [
            13.603448,
            54.133338,
            44.825054
          ],
          [
            13.603133,
            54.133467,
            44.27424
          ],
          [
            13.602811,
            54.133607,
            43.701641
          ],
          [
            13.602603,
            54.133796,
            43.14821
          ],
          [
            13.602424,
            54.134009,
            42.569106
          ],
          [
            13.602196,
            54.134168,
            42.272002
          ],
          [
            13.601957,
            54.134321,
            42.293582
          ],
          [
            13.601868,
            54.13456,
            42.318551
          ],
          [
            13.601832,
            54.134855,
            42.348729
          ],
          [
            13.601588,
            54.135118,
            42.37932
          ],
          [
            13.601373,
            54.135347,
            42.406027
          ],
          [
            13.601467,
            54.135587,
            42.43325
          ],
          [
            13.601417,
            54.13554,
            42.562169
          ],
          [
            13.601673,
            54.135659,
            43.051765
          ],
          [
            13.602005,
            54.135702,
            43.527811
          ],
          [
            13.602325,
            54.135746,
            43.987798
          ],
          [
            13.602653,
            54.135786,
            44.456667
          ],
          [
            13.603018,
            54.135806,
            44.969652
          ],
          [
            13.603392,
            54.135836,
            45.497818
          ],
          [
            13.603762,
            54.13588,
            46.026096
          ],
          [
            13.604134,
            54.135908,
            46.550967
          ],
          [
            13.604511,
            54.135952,
            46.388737
          ],
          [
            13.604879,
            54.135996,
            45.851916
          ],
          [
            13.605257,
            54.136037,
            45.302509
          ],
          [
            13.605618,
            54.136055,
            44.784639
          ],
          [
            13.605974,
            54.136121,
            44.24829
          ],
          [
            13.606349,
            54.136167,
            43.700519
          ],
          [
            13.606716,
            54.13626,
            43.128955
          ],
          [
            13.607096,
            54.136342,
            42.550164
          ],
          [
            13.607433,
            54.136404,
            42.321864
          ],
          [
            13.607685,
            54.136345,
            42.27042
          ],
          [
            13.608023,
            54.136332,
            42.217913
          ],
          [
            13.608374,
            54.136275,
            42.162163
          ],
          [
            13.608671,
            54.136148,
            42.10616
          ],
          [
            13.608965,
            54.136035,
            42.052513
          ],
          [
            13.609264,
            54.135973,
            42.003135
          ],
          [
            13.609528,
            54.135877,
            41.950386
          ],
          [
            13.609893,
            54.135926,
            41.893384
          ],
          [
            13.610257,
            54.135951,
            42.42799
          ],
          [
            13.610609,
            54.13597,
            43.011057
          ],
          [
            13.611002,
            54.136009,
            43.667406
          ],
          [
            13.611327,
            54.136028,
            44.205174
          ],
          [
            13.611728,
            54.136045,
            44.867116
          ],
          [
            13.6121,
            54.136091,
            45.493052
          ],
          [
            13.612531,
            54.136105,
            46.206337
          ],
          [
            13.612953,
            54.13616,
            46.919603
          ],
          [
            13.613368,
            54.136238,
            46.952544
          ],
          [
            13.613773,
            54.136299,
            46.96304
          ],
          [
            13.614166,
            54.136357,
            46.973203
          ],
          [
            13.614544,
            54.136405,
            46.982902
          ],
          [
            13.614889,
            54.136461,
            46.991886
          ],
          [
            13.61523,
            54.136513,
            47.00072
          ],
          [
            13.615547,
            54.136571,
            47.009055
          ],
          [
            13.615883,
            54.136624,
            47.017789
          ],
          [
            13.616238,
            54.136686,
            47.441129
          ],
          [
            13.616549,
            54.136758,
            47.874149
          ],
          [
            13.616908,
            54.136824,
            48.361228
          ],
          [
            13.617229,
            54.13687,
            48.78967
          ],
          [
            13.617545,
            54.136909,
            49.208276
          ],
          [
            13.617868,
            54.136949,
            49.635655
          ],
          [
            13.618197,
            54.136998,
            50.075195
          ],
          [
            13.618546,
            54.13705,
            50.541414
          ],
          [
            13.618902,
            54.1371,
            50.961397
          ],
          [
            13.619262,
            54.137167,
            50.295739
          ],
          [
            13.619635,
            54.137259,
            49.579761
          ],
          [
            13.619996,
            54.137338,
            48.895787
          ],
          [
            13.620409,
            54.137413,
            48.133309
          ],
          [
            13.620814,
            54.137434,
            47.416093
          ],
          [
            13.620952,
            54.137251,
            46.804434
          ],
          [
            13.621035,
            54.137039,
            46.149605
          ],
          [
            13.62113,
            54.136838,
            45.58124
          ],
          [
            13.621223,
            54.136627,
            45.563423
          ],
          [
            13.621308,
            54.136426,
            45.546398
          ],
          [
            13.621413,
            54.136227,
            45.529359
          ],
          [
            13.621511,
            54.136026,
            45.512249
          ],
          [
            13.621611,
            54.135823,
            45.494969
          ],
          [
            13.621943,
            54.135781,
            45.476309
          ],
          [
            13.622351,
            54.135831,
            45.456285
          ],
          [
            13.622783,
            54.135852,
            45.436887
          ],
          [
            13.623164,
            54.135875,
            45.496649
          ],
          [
            13.623541,
            54.135879,
            45.555372
          ],
          [
            13.623923,
            54.135876,
            45.614814
          ],
          [
            13.624353,
            54.135876,
            45.681772
          ],
          [
            13.624788,
            54.13591,
            45.750145
          ],
          [
            13.625225,
            54.135922,
            45.818214
          ],
          [
            13.625547,
            54.1359,
            45.86868
          ],
          [
            13.625877,
            54.135917,
            46.006789
          ],
          [
            13.626271,
            54.135954,
            46.865584
          ],
          [
            13.62663,
            54.135972,
            47.642004
          ],
          [
            13.626666,
            54.135935,
            48.337694
          ],
          [
            13.626761,
            54.135716,
            49.168516
          ],
          [
            13.626864,
            54.135523,
            49.911202
          ],
          [
            13.626938,
            54.135302,
            50.738381
          ],
          [
            13.62703,
            54.135099,
            51.512967
          ],
          [
            13.627125,
            54.134912,
            52.229682
          ],
          [
            13.627228,
            54.134698,
            52.390587
          ],
          [
            13.627309,
            54.134481,
            52.191218
          ],
          [
            13.627426,
            54.134265,
            51.988054
          ],
          [
            13.627573,
            54.134025,
            51.759509
          ],
          [
            13.627594,
            54.133817,
            51.572387
          ],
          [
            13.627516,
            54.133599,
            51.372212
          ],
          [
            13.627428,
            54.133422,
            51.206857
          ],
          [
            13.627277,
            54.133237,
            51.023096
          ],
          [
            13.627281,
            54.133024,
            50.946904
          ],
          [
            13.627358,
            54.132793,
            51.055654
          ],
          [
            13.627396,
            54.132594,
            51.148106
          ],
          [
            13.627394,
            54.132377,
            51.248308
          ],
          [
            13.627383,
            54.132158,
            51.349463
          ],
          [
            13.627385,
            54.131939,
            51.450578
          ],
          [
            13.627386,
            54.131738,
            51.543522
          ],
          [
            13.6276,
            54.131632,
            51.639309
          ],
          [
            13.62791,
            54.131711,
            51.730812
          ],
          [
            13.628236,
            54.131814,
            51.754488
          ],
          [
            13.628563,
            54.13189,
            51.771413
          ],
          [
            13.628901,
            54.132003,
            51.790225
          ],
          [
            13.629177,
            54.132122,
            51.806735
          ],
          [
            13.629503,
            54.132255,
            51.825846
          ],
          [
            13.629909,
            54.132352,
            51.847161
          ],
          [
            13.630193,
            54.132443,
            51.862737
          ],
          [
            13.630478,
            54.13254,
            51.878771
          ],
          [
            13.630822,
            54.132648,
            51.589342
          ],
          [
            13.631094,
            54.132745,
            51.208345
          ],
          [
            13.631368,
            54.132851,
            50.814598
          ],
          [
            13.631728,
            54.133009,
            50.277186
          ],
          [
            13.631991,
            54.133105,
            49.873868
          ],
          [
            13.632323,
            54.133195,
            49.433531
          ],
          [
            13.632601,
            54.13331,
            49.026627
          ],
          [
            13.632977,
            54.133418,
            48.526285
          ],
          [
            13.633304,
            54.133508,
            48.250016
          ],
          [
            13.633694,
            54.133659,
            48.390021
          ],
          [
            13.634026,
            54.133788,
            48.509302
          ],
          [
            13.63434,
            54.133908,
            48.621843
          ],
          [
            13.634665,
            54.134032,
            48.738144
          ],
          [
            13.634951,
            54.134151,
            48.844285
          ],
          [
            13.635254,
            54.134229,
            48.943404
          ],
          [
            13.635578,
            54.134334,
            49.054309
          ],
          [
            13.63586,
            54.134405,
            49.151151
          ],
          [
            13.636194,
            54.134532,
            49.33418
          ],
          [
            13.636528,
            54.134639,
            49.508281
          ],
          [
            13.636862,
            54.134782,
            49.697024
          ],
          [
            13.63719,
            54.134864,
            49.859778
          ],
          [
            13.637501,
            54.134954,
            50.018056
          ],
          [
            13.637824,
            54.13505,
            50.183523
          ],
          [
            13.638116,
            54.135156,
            50.340248
          ],
          [
            13.638404,
            54.135293,
            50.509515
          ],
          [
            13.638691,
            54.135423,
            51.137936
          ],
          [
            13.638968,
            54.135527,
            51.790432
          ],
          [
            13.639278,
            54.135626,
            52.490399
          ],
          [
            13.639595,
            54.135746,
            53.239996
          ],
          [
            13.639931,
            54.135855,
            54.001856
          ],
          [
            13.640285,
            54.135979,
            54.820674
          ],
          [
            13.640599,
            54.136092,
            55.552076
          ],
          [
            13.640917,
            54.136223,
            56.322901
          ],
          [
            13.641305,
            54.136324,
            56.047319
          ],
          [
            13.641602,
            54.136464,
            55.23107
          ],
          [
            13.641945,
            54.136516,
            54.418651
          ],
          [
            13.64221,
            54.136645,
            53.689905
          ],
          [
            13.642522,
            54.13677,
            52.890136
          ],
          [
            13.642844,
            54.136874,
            52.112388
          ],
          [
            13.643145,
            54.136968,
            51.390785
          ],
          [
            13.64345,
            54.137075,
            50.638204
          ],
          [
            13.643751,
            54.137187,
            50.044905
          ],
          [
            13.644042,
            54.137306,
            49.78117
          ],
          [
            13.644348,
            54.137396,
            49.526596
          ],
          [
            13.644651,
            54.1375,
            49.265673
          ],
          [
            13.644979,
            54.137613,
            48.982439
          ],
          [
            13.645257,
            54.137707,
            48.743144
          ],
          [
            13.645554,
            54.137799,
            48.493529
          ],
          [
            13.645839,
            54.137882,
            48.250486
          ],
          [
            13.646181,
            54.137975,
            47.97015
          ],
          [
            13.646457,
            54.138058,
            47.867677
          ],
          [
            13.646818,
            54.138135,
            47.910234
          ],
          [
            13.647178,
            54.138226,
            47.953697
          ],
          [
            13.647554,
            54.138306,
            47.998025
          ],
          [
            13.647875,
            54.138358,
            48.034918
          ],
          [
            13.648251,
            54.138407,
            48.077592
          ],
          [
            13.648579,
            54.138476,
            48.116235
          ],
          [
            13.6489,
            54.138527,
            48.153258
          ],
          [
            13.649264,
            54.138575,
            48.129481
          ],
          [
            13.649698,
            54.13858,
            47.277873
          ],
          [
            13.650032,
            54.13856,
            46.622657
          ],
          [
            13.650381,
            54.138592,
            45.93186
          ],
          [
            13.65074,
            54.13861,
            45.228851
          ],
          [
            13.651116,
            54.138631,
            44.491709
          ],
          [
            13.651481,
            54.138619,
            43.777672
          ],
          [
            13.651829,
            54.138613,
            43.097854
          ],
          [
            13.652142,
            54.138606,
            42.486318
          ],
          [
            13.652467,
            54.13859,
            42.589488
          ],
          [
            13.652804,
            54.138552,
            43.329809
          ],
          [
            13.653123,
            54.138527,
            44.024585
          ],
          [
            13.653477,
            54.138518,
            44.789097
          ],
          [
            13.653802,
            54.138503,
            45.492381
          ],
          [
            13.654178,
            54.138491,
            46.305787
          ],
          [
            13.654543,
            54.138439,
            47.121167
          ],
          [
            13.654866,
            54.138395,
            47.836539
          ],
          [
            13.655201,
            54.138377,
            48.562233
          ],
          [
            13.65557,
            54.138352,
            49.473967
          ],
          [
            13.655945,
            54.138313,
            50.463647
          ],
          [
            13.65632,
            54.138286,
            51.445451
          ],
          [
            13.656715,
            54.138257,
            52.479891
          ],
          [
            13.657097,
            54.138218,
            53.487591
          ],
          [
            13.657439,
            54.138197,
            54.381248
          ],
          [
            13.657773,
            54.138169,
            55.258091
          ],
          [
            13.658146,
            54.138147,
            56.232248
          ],
          [
            13.6585,
            54.138148,
            56.483702
          ],
          [
            13.658881,
            54.138107,
            55.567651
          ],
          [
            13.65919,
            54.138064,
            54.816346
          ],
          [
            13.659505,
            54.138034,
            54.061814
          ],
          [
            13.659849,
            54.137978,
            53.217665
          ],
          [
            13.660235,
            54.137926,
            52.281191
          ],
          [
            13.660588,
            54.137882,
            51.427617
          ],
          [
            13.66097,
            54.137844,
            50.5111
          ],
          [
            13.661298,
            54.13781,
            49.723173
          ],
          [
            13.661634,
            54.137779,
            49.64449
          ],
          [
            13.66197,
            54.137756,
            49.773714
          ],
          [
            13.662304,
            54.137726,
            49.902801
          ],
          [
            13.662659,
            54.137694,
            50.04007
          ],
          [
            13.663034,
            54.137658,
            50.185242
          ],
          [
            13.663359,
            54.137622,
            50.31159
          ],
          [
            13.663692,
            54.137603,
            50.439382
          ],
          [
            13.664011,
            54.137571,
            50.56302
          ],
          [
            13.664361,
            54.137544,
            50.697857
          ],
          [
            13.664744,
            54.137511,
            50.861523
          ],
          [
            13.66512,
            54.137471,
            51.025201
          ],
          [
            13.665507,
            54.137434,
            51.193283
          ],
          [
            13.665901,
            54.137402,
            51.363742
          ],
          [
            13.666249,
            54.137371,
            51.514758
          ],
          [
            13.666603,
            54.137344,
            51.667755
          ],
          [
            13.666938,
            54.13733,
            51.811606
          ],
          [
            13.667308,
            54.137283,
            51.97376
          ],
          [
            13.667718,
            54.137247,
            51.85457
          ],
          [
            13.668163,
            54.137198,
            51.573157
          ],
          [
            13.668609,
            54.13715,
            51.290539
          ],
          [
            13.669045,
            54.137127,
            51.01852
          ],
          [
            13.669349,
            54.137091,
            50.825742
          ],
          [
            13.669667,
            54.137066,
            50.626418
          ],
          [
            13.670001,
            54.137037,
            50.416674
          ],
          [
            13.670399,
            54.137007,
            50.167382
          ],
          [
            13.670769,
            54.136964,
            50.252669
          ],
          [
            13.671161,
            54.13693,
            50.419016
          ],
          [
            13.671553,
            54.136907,
            50.585272
          ],
          [
            13.671944,
            54.136866,
            50.752005
          ],
          [
            13.672356,
            54.136838,
            50.926106
          ],
          [
            13.67276,
            54.136793,
            51.098835
          ],
          [
            13.673159,
            54.136774,
            51.266877
          ],
          [
            13.673572,
            54.136769,
            51.473976
          ],
          [
            13.673949,
            54.136749,
            51.819455
          ],
          [
            13.674331,
            54.136712,
            52.172663
          ],
          [
            13.674655,
            54.1367,
            52.46846
          ],
          [
            13.67503,
            54.136689,
            52.811351
          ],
          [
            13.675429,
            54.136672,
            53.175855
          ],
          [
            13.675837,
            54.136633,
            53.55272
          ],
          [
            13.676164,
            54.136613,
            53.852456
          ],
          [
            13.676503,
            54.136582,
            54.166501
          ],
          [
            13.676852,
            54.136573,
            54.387483
          ],
          [
            13.677208,
            54.136559,
            54.598752
          ],
          [
            13.677595,
            54.13653,
            54.828402
          ],
          [
            13.67801,
            54.136518,
            55.073092
          ],
          [
            13.678349,
            54.136478,
            55.27743
          ],
          [
            13.678784,
            54.136436,
            55.539834
          ],
          [
            13.679143,
            54.136412,
            55.75259
          ],
          [
            13.679467,
            54.136412,
            55.94329
          ],
          [
            13.679835,
            54.136382,
            56.165829
          ],
          [
            13.680182,
            54.136352,
            56.378259
          ],
          [
            13.680518,
            54.13635,
            56.582111
          ],
          [
            13.680858,
            54.136307,
            56.792322
          ],
          [
            13.681249,
            54.136306,
            57.028754
          ],
          [
            13.681611,
            54.136276,
            57.249992
          ],
          [
            13.681968,
            54.136274,
            57.466323
          ],
          [
            13.682336,
            54.136251,
            57.690468
          ],
          [
            13.682703,
            54.136233,
            57.699386
          ],
          [
            13.683067,
            54.136206,
            56.77797
          ],
          [
            13.683465,
            54.136174,
            55.768069
          ],
          [
            13.683928,
            54.136147,
            54.599981
          ],
          [
            13.684459,
            54.136125,
            53.263389
          ],
          [
            13.684996,
            54.136105,
            51.912328
          ],
          [
            13.685484,
            54.136084,
            50.683559
          ],
          [
            13.685937,
            54.136069,
            50.237053
          ],
          [
            13.686389,
            54.136049,
            50.370789
          ],
          [
            13.686833,
            54.136067,
            50.502422
          ],
          [
            13.687243,
            54.136087,
            50.62488
          ],
          [
            13.6876,
            54.136159,
            50.736612
          ],
          [
            13.68794,
            54.136211,
            50.840296
          ],
          [
            13.688227,
            54.136318,
            50.94084
          ],
          [
            13.68849,
            54.136425,
            51.035367
          ],
          [
            13.688729,
            54.13655,
            50.878039
          ],
          [
            13.689009,
            54.136719,
            50.501219
          ],
          [
            13.689164,
            54.136907,
            50.16728
          ],
          [
            13.689304,
            54.137109,
            49.817794
          ],
          [
            13.689439,
            54.137318,
            49.460574
          ],
          [
            13.68951,
            54.137523,
            49.124779
          ],
          [
            13.6896,
            54.137705,
            48.822068
          ],
          [
            13.689639,
            54.137926,
            48.46592
          ],
          [
            13.68968,
            54.138153,
            48.104208
          ],
          [
            13.689746,
            54.138385,
            47.743199
          ],
          [
            13.689817,
            54.138584,
            47.430643
          ],
          [
            13.689944,
            54.138805,
            47.072781
          ],
          [
            13.690087,
            54.139065,
            46.653019
          ],
          [
            13.690311,
            54.139303,
            46.235717
          ],
          [
            13.690579,
            54.139543,
            45.795561
          ],
          [
            13.690867,
            54.139775,
            45.452174
          ],
          [
            13.691148,
            54.14004,
            45.546564
          ],
          [
            13.691403,
            54.140304,
            45.638369
          ],
          [
            13.691705,
            54.140558,
            45.732083
          ],
          [
            13.692,
            54.140802,
            45.822467
          ],
          [
            13.692287,
            54.141044,
            45.911531
          ],
          [
            13.692549,
            54.141268,
            45.905593
          ],
          [
            13.692776,
            54.141488,
            45.486902
          ],
          [
            13.693036,
            54.141686,
            45.079855
          ],
          [
            13.693271,
            54.141907,
            44.655881
          ],
          [
            13.69349,
            54.142108,
            44.26659
          ],
          [
            13.693702,
            54.14231,
            43.88038
          ],
          [
            13.693909,
            54.142533,
            43.467006
          ],
          [
            13.694073,
            54.14271,
            43.138563
          ],
          [
            13.694238,
            54.142929,
            42.84714
          ],
          [
            13.694442,
            54.143105,
            42.613477
          ],
          [
            13.694608,
            54.143285,
            42.388756
          ],
          [
            13.694823,
            54.143478,
            42.135802
          ],
          [
            13.695031,
            54.143668,
            41.888031
          ],
          [
            13.695286,
            54.143832,
            41.644628
          ],
          [
            13.695664,
            54.143945,
            41.364397
          ],
          [
            13.696061,
            54.143985,
            41.104644
          ],
          [
            13.696396,
            54.143948,
            41.024605
          ],
          [
            13.696679,
            54.143848,
            40.96629
          ],
          [
            13.696907,
            54.143656,
            40.896038
          ],
          [
            13.697168,
            54.143452,
            40.819441
          ],
          [
            13.697419,
            54.143286,
            40.752747
          ],
          [
            13.697706,
            54.14314,
            40.685894
          ],
          [
            13.69801,
            54.143022,
            40.62169
          ],
          [
            13.698354,
            54.143022,
            40.560226
          ],
          [
            13.698709,
            54.14301,
            40.507231
          ],
          [
            13.699052,
            54.142955,
            40.45928
          ],
          [
            13.699282,
            54.14279,
            40.410431
          ],
          [
            13.699498,
            54.142594,
            40.356989
          ],
          [
            13.699796,
            54.142418,
            40.300277
          ],
          [
            13.700028,
            54.142244,
            40.24985
          ],
          [
            13.700209,
            54.142058,
            40.200938
          ],
          [
            13.700411,
            54.141887,
            40.153442
          ],
          [
            13.70058,
            54.141727,
            40.200022
          ],
          [
            13.700786,
            54.141562,
            40.408622
          ],
          [
            13.700987,
            54.141391,
            40.620685
          ],
          [
            13.701176,
            54.141218,
            40.830209
          ],
          [
            13.701416,
            54.141044,
            41.058371
          ],
          [
            13.70168,
            54.140944,
            41.246208
          ],
          [
            13.701778,
            54.140764,
            41.440808
          ],
          [
            13.701898,
            54.140597,
            41.627982
          ],
          [
            13.702143,
            54.140473,
            41.821638
          ],
          [
            13.702413,
            54.140353,
            42.226456
          ],
          [
            13.702754,
            54.140242,
            43.157938
          ],
          [
            13.703054,
            54.140115,
            44.05361
          ],
          [
            13.703443,
            54.140074,
            44.997439
          ],
          [
            13.7038,
            54.140043,
            45.866527
          ],
          [
            13.704104,
            54.139949,
            46.687525
          ],
          [
            13.704484,
            54.139839,
            47.699283
          ],
          [
            13.704894,
            54.139741,
            48.757677
          ],
          [
            13.705268,
            54.139636,
            49.582927
          ],
          [
            13.705574,
            54.139533,
            50.121715
          ],
          [
            13.705961,
            54.139447,
            50.754695
          ],
          [
            13.706364,
            54.139376,
            51.397174
          ],
          [
            13.706715,
            54.139309,
            51.961046
          ],
          [
            13.707069,
            54.139239,
            52.531434
          ],
          [
            13.707448,
            54.139157,
            53.149536
          ],
          [
            13.7078,
            54.139083,
            53.722283
          ],
          [
            13.708166,
            54.13899,
            53.628065
          ],
          [
            13.708519,
            54.138899,
            53.049269
          ],
          [
            13.708848,
            54.138813,
            52.507953
          ],
          [
            13.709228,
            54.138722,
            51.891852
          ],
          [
            13.709585,
            54.138636,
            51.312616
          ],
          [
            13.709992,
            54.138529,
            50.64295
          ],
          [
            13.710403,
            54.138426,
            49.97144
          ],
          [
            13.710734,
            54.138333,
            49.420571
          ],
          [
            13.711118,
            54.138269,
            48.682448
          ],
          [
            13.711469,
            54.138191,
            47.9808
          ],
          [
            13.71189,
            54.138093,
            47.133958
          ],
          [
            13.712309,
            54.138001,
            46.296422
          ],
          [
            13.712628,
            54.13791,
            45.624786
          ],
          [
            13.712997,
            54.137853,
            44.909348
          ],
          [
            13.713373,
            54.13783,
            44.20283
          ],
          [
            13.713788,
            54.137794,
            43.638005
          ],
          [
            13.714166,
            54.137745,
            43.656471
          ],
          [
            13.714542,
            54.137698,
            43.675009
          ],
          [
            13.714854,
            54.137657,
            43.690263
          ],
          [
            13.715233,
            54.137642,
            43.708377
          ],
          [
            13.715614,
            54.137585,
            43.727164
          ],
          [
            13.71597,
            54.137551,
            43.744373
          ],
          [
            13.716379,
            54.137522,
            43.763998
          ],
          [
            13.716752,
            54.137524,
            43.891972
          ],
          [
            13.717062,
            54.13752,
            44.438178
          ],
          [
            13.717437,
            54.137513,
            45.099189
          ],
          [
            13.717818,
            54.137466,
            45.786629
          ],
          [
            13.718189,
            54.137426,
            46.450496
          ],
          [
            13.718573,
            54.137389,
            47.136031
          ],
          [
            13.718935,
            54.137355,
            47.78149
          ],
          [
            13.719334,
            54.137315,
            48.494075
          ],
          [
            13.719754,
            54.137272,
            49.171458
          ],
          [
            13.720153,
            54.137269,
            49.061867
          ],
          [
            13.720483,
            54.137235,
            48.969761
          ],
          [
            13.720839,
            54.137136,
            48.86153
          ],
          [
            13.721251,
            54.137116,
            48.747868
          ],
          [
            13.721566,
            54.1371,
            48.66087
          ],
          [
            13.722,
            54.137059,
            48.540164
          ],
          [
            13.722316,
            54.137034,
            48.452548
          ],
          [
            13.722751,
            54.136999,
            48.292219
          ],
          [
            13.723077,
            54.136978,
            47.679084
          ],
          [
            13.723401,
            54.136944,
            47.064044
          ],
          [
            13.723731,
            54.1369,
            46.42984
          ],
          [
            13.724088,
            54.136854,
            45.746834
          ],
          [
            13.724464,
            54.136793,
            45.017777
          ],
          [
            13.724868,
            54.13673,
            44.233486
          ],
          [
            13.72526,
            54.136711,
            43.497399
          ],
          [
            13.725671,
            54.136773,
            42.703628
          ],
          [
            13.726105,
            54.136841,
            42.394847
          ],
          [
            13.726533,
            54.136819,
            42.168774
          ],
          [
            13.726948,
            54.136722,
            41.934262
          ],
          [
            13.727365,
            54.136622,
            41.69777
          ],
          [
            13.727738,
            54.13648,
            41.464266
          ],
          [
            13.728061,
            54.136354,
            41.260593
          ],
          [
            13.728319,
            54.136437,
            41.082947
          ],
          [
            13.728441,
            54.136664,
            40.855701
          ],
          [
            13.72859,
            54.136878,
            40.624271
          ],
          [
            13.728581,
            54.137086,
            40.400163
          ],
          [
            13.728405,
            54.137308,
            40.15537
          ],
          [
            13.728227,
            54.137502,
            39.935185
          ],
          [
            13.728013,
            54.137675,
            39.72156
          ],
          [
            13.727851,
            54.137858,
            39.515468
          ],
          [
            13.727579,
            54.137984,
            39.309098
          ],
          [
            13.727278,
            54.138006,
            39.287055
          ],
          [
            13.727287,
            54.138005,
            39.551235
          ],
          [
            13.72738,
            54.138184,
            39.812499
          ],
          [
            13.72768,
            54.138255,
            40.077942
          ],
          [
            13.727959,
            54.138343,
            40.337212
          ],
          [
            13.728288,
            54.138376,
            40.610608
          ],
          [
            13.728578,
            54.138293,
            40.878209
          ],
          [
            13.728708,
            54.138111,
            41.153769
          ],
          [
            13.728967,
            54.138004,
            41.413047
          ],
          [
            13.729182,
            54.137866,
            41.675522
          ],
          [
            13.729506,
            54.137891,
            41.549922
          ],
          [
            13.729828,
            54.137894,
            41.375947
          ],
          [
            13.730155,
            54.137842,
            41.201215
          ],
          [
            13.729828,
            54.137894,
            41.021417
          ],
          [
            13.729512,
            54.137846,
            40.853054
          ],
          [
            13.729188,
            54.137785,
            40.676895
          ],
          [
            13.728953,
            54.13787,
            40.504419
          ],
          [
            13.728793,
            54.138041,
            40.332704
          ],
          [
            13.728628,
            54.138209,
            40.161842
          ],
          [
            13.728432,
            54.138355,
            40.301903
          ],
          [
            13.728115,
            54.138312,
            40.557949
          ],
          [
            13.727805,
            54.138199,
            40.827968
          ],
          [
            13.727493,
            54.13812,
            41.078417
          ],
          [
            13.727186,
            54.138044,
            41.324473
          ],
          [
            13.727123,
            54.138039,
            41.551157
          ],
          [
            13.727398,
            54.138224,
            41.863428
          ],
          [
            13.727724,
            54.138276,
            42.122959
          ],
          [
            13.728042,
            54.138355,
            42.378748
          ],
          [
            13.728419,
            54.138408,
            42.081459
          ],
          [
            13.728686,
            54.138327,
            41.830823
          ],
          [
            13.728846,
            54.138162,
            41.575894
          ],
          [
            13.72902,
            54.137991,
            41.309009
          ],
          [
            13.729289,
            54.137869,
            41.032612
          ],
          [
            13.729613,
            54.13792,
            40.768782
          ],
          [
            13.729944,
            54.137891,
            40.504763
          ],
          [
            13.730144,
            54.13758,
            39.997505
          ],
          [
            13.730087,
            54.137391,
            39.244253
          ],
          [
            13.730333,
            54.137294,
            38.49008
          ],
          [
            13.730668,
            54.137234,
            37.66677
          ],
          [
            13.731069,
            54.137202,
            36.71474
          ],
          [
            13.731383,
            54.137194,
            35.975885
          ],
          [
            13.731766,
            54.137168,
            35.068592
          ],
          [
            13.732115,
            54.137212,
            34.225928
          ],
          [
            13.732465,
            54.137262,
            33.379214
          ],
          [
            13.732838,
            54.137301,
            32.788508
          ],
          [
            13.733151,
            54.137355,
            32.879106
          ],
          [
            13.733472,
            54.137412,
            32.97237
          ],
          [
            13.733808,
            54.137463,
            33.069359
          ],
          [
            13.734125,
            54.137496,
            33.15877
          ],
          [
            13.73448,
            54.137582,
            33.265678
          ],
          [
            13.734784,
            54.137672,
            33.361904
          ],
          [
            13.735184,
            54.137785,
            33.486666
          ],
          [
            13.735519,
            54.13787,
            33.589237
          ],
          [
            13.735858,
            54.137981,
            33.592756
          ],
          [
            13.736278,
            54.138096,
            33.568573
          ],
          [
            13.736574,
            54.138168,
            33.551692
          ],
          [
            13.736948,
            54.138282,
            33.529586
          ],
          [
            13.737235,
            54.138403,
            33.511104
          ],
          [
            13.737553,
            54.138456,
            33.493855
          ],
          [
            13.737851,
            54.13855,
            33.4762
          ],
          [
            13.738163,
            54.138673,
            33.456575
          ],
          [
            13.73848,
            54.138782,
            33.345766
          ],
          [
            13.738824,
            54.138885,
            33.172296
          ],
          [
            13.739196,
            54.139006,
            32.981369
          ],
          [
            13.739492,
            54.139122,
            32.821474
          ],
          [
            13.739842,
            54.139223,
            32.646315
          ],
          [
            13.740201,
            54.139325,
            32.467246
          ],
          [
            13.740531,
            54.139407,
            32.306401
          ],
          [
            13.740794,
            54.139549,
            32.137421
          ],
          [
            13.74112,
            54.139658,
            31.867329
          ],
          [
            13.741527,
            54.139738,
            31.495762
          ],
          [
            13.741745,
            54.139824,
            31.124198
          ],
          [
            13.742143,
            54.139926,
            30.748767
          ],
          [
            13.742525,
            54.140007,
            30.397061
          ],
          [
            13.742876,
            54.140079,
            30.075696
          ],
          [
            13.743207,
            54.140174,
            29.757854
          ],
          [
            13.743558,
            54.140287,
            29.427858
          ],
          [
            13.743902,
            54.140351,
            29.508633
          ],
          [
            13.744262,
            54.140406,
            29.591827
          ],
          [
            13.744638,
            54.140475,
            29.679881
          ],
          [
            13.744965,
            54.140578,
            29.763432
          ],
          [
            13.745371,
            54.140625,
            29.85599
          ],
          [
            13.745714,
            54.140693,
            29.936977
          ],
          [
            13.746186,
            54.140667,
            30.042991
          ],
          [
            13.746483,
            54.140735,
            30.112714
          ],
          [
            13.746891,
            54.140767,
            30.16828
          ],
          [
            13.747329,
            54.140793,
            30.227683
          ],
          [
            13.747655,
            54.140818,
            30.272395
          ],
          [
            13.748012,
            54.140855,
            30.32204
          ],
          [
            13.74841,
            54.140819,
            30.376555
          ],
          [
            13.748729,
            54.140774,
            30.420944
          ],
          [
            13.749066,
            54.14073,
            30.467566
          ],
          [
            13.749401,
            54.140641,
            30.517244
          ],
          [
            13.749681,
            54.140509,
            30.564855
          ],
          [
            13.749959,
            54.140386,
            30.614
          ],
          [
            13.750187,
            54.14022,
            30.661993
          ],
          [
            13.750356,
            54.140024,
            30.711406
          ],
          [
            13.7506,
            54.139861,
            30.760293
          ],
          [
            13.750852,
            54.139677,
            30.813377
          ],
          [
            13.751102,
            54.139521,
            30.861621
          ],
          [
            13.751269,
            54.139348,
            30.906355
          ],
          [
            13.75147,
            54.139159,
            31.048795
          ],
          [
            13.751651,
            54.138962,
            31.26856
          ],
          [
            13.751844,
            54.138777,
            31.481561
          ],
          [
            13.751997,
            54.13858,
            31.694167
          ],
          [
            13.752196,
            54.138393,
            31.911351
          ],
          [
            13.752367,
            54.138197,
            32.127637
          ],
          [
            13.75257,
            54.138016,
            32.340545
          ],
          [
            13.752781,
            54.13783,
            32.559995
          ],
          [
            13.752983,
            54.13764,
            32.925706
          ],
          [
            13.753187,
            54.137444,
            33.542089
          ],
          [
            13.753378,
            54.137271,
            34.095706
          ],
          [
            13.75358,
            54.13709,
            34.676687
          ],
          [
            13.753801,
            54.136926,
            35.237616
          ],
          [
            13.754034,
            54.136761,
            35.812384
          ],
          [
            13.754236,
            54.136584,
            36.386287
          ],
          [
            13.754411,
            54.1364,
            36.952044
          ],
          [
            13.754606,
            54.136211,
            37.536422
          ],
          [
            13.754791,
            54.136016,
            37.907838
          ],
          [
            13.754975,
            54.135826,
            38.271516
          ],
          [
            13.755146,
            54.135628,
            38.641093
          ],
          [
            13.755297,
            54.13543,
            39.002178
          ],
          [
            13.755485,
            54.135243,
            39.363565
          ],
          [
            13.755682,
            54.135057,
            39.728349
          ],
          [
            13.755878,
            54.134869,
            40.095159
          ],
          [
            13.756059,
            54.134677,
            40.46054
          ],
          [
            13.756206,
            54.134478,
            39.628605
          ],
          [
            13.75637,
            54.134288,
            38.593034
          ],
          [
            13.756534,
            54.134087,
            37.50972
          ],
          [
            13.756735,
            54.133905,
            36.45528
          ],
          [
            13.75694,
            54.133738,
            35.45443
          ],
          [
            13.757154,
            54.133585,
            34.491779
          ],
          [
            13.757391,
            54.13343,
            33.477947
          ],
          [
            13.757684,
            54.133298,
            32.420325
          ],
          [
            13.75799,
            54.133114,
            31.774293
          ],
          [
            13.758306,
            54.13299,
            31.776988
          ],
          [
            13.758689,
            54.132901,
            31.779897
          ],
          [
            13.758964,
            54.132803,
            31.782171
          ],
          [
            13.759224,
            54.132689,
            31.784464
          ],
          [
            13.759526,
            54.132575,
            31.787119
          ],
          [
            13.759802,
            54.132438,
            31.789676
          ],
          [
            13.76014,
            54.132319,
            31.792458
          ],
          [
            13.760418,
            54.13221,
            31.737211
          ],
          [
            13.760663,
            54.132075,
            31.360289
          ],
          [
            13.760681,
            54.13186,
            30.965234
          ],
          [
            13.760997,
            54.131818,
            30.564257
          ],
          [
            13.761369,
            54.131761,
            30.156103
          ],
          [
            13.761649,
            54.131585,
            29.704037
          ],
          [
            13.761963,
            54.131477,
            29.319425
          ],
          [
            13.762189,
            54.131343,
            28.979797
          ],
          [
            13.762454,
            54.131191,
            28.587247
          ],
          [
            13.762784,
            54.131114,
            28.651267
          ],
          [
            13.763142,
            54.13099,
            28.774559
          ],
          [
            13.76347,
            54.130853,
            28.893808
          ],
          [
            13.763773,
            54.130718,
            29.006461
          ],
          [
            13.764077,
            54.130572,
            29.12279
          ],
          [
            13.764346,
            54.13046,
            29.22049
          ],
          [
            13.764643,
            54.130341,
            29.326977
          ],
          [
            13.764944,
            54.130214,
            29.436772
          ],
          [
            13.765214,
            54.130077,
            29.833737
          ],
          [
            13.765409,
            54.129927,
            30.281154
          ],
          [
            13.765598,
            54.129735,
            30.80671
          ],
          [
            13.765711,
            54.129516,
            31.34895
          ],
          [
            13.765693,
            54.129298,
            31.868838
          ],
          [
            13.765576,
            54.129098,
            32.375306
          ],
          [
            13.765363,
            54.128929,
            32.872695
          ],
          [
            13.765071,
            54.128776,
            33.416714
          ],
          [
            13.764822,
            54.128639,
            33.906481
          ],
          [
            13.764585,
            54.128474,
            34.470471
          ],
          [
            13.764385,
            54.128324,
            34.963378
          ],
          [
            13.764176,
            54.128169,
            35.474664
          ],
          [
            13.76389,
            54.128021,
            36.054939
          ],
          [
            13.763648,
            54.127891,
            36.552827
          ],
          [
            13.763372,
            54.127728,
            37.150088
          ],
          [
            13.76308,
            54.127577,
            37.740983
          ],
          [
            13.762901,
            54.127425,
            38.222606
          ],
          [
            13.762712,
            54.127264,
            39.084959
          ],
          [
            13.762449,
            54.127116,
            40.197332
          ],
          [
            13.76218,
            54.126983,
            41.267912
          ],
          [
            13.761947,
            54.126856,
            42.237745
          ],
          [
            13.761711,
            54.126709,
            43.285695
          ],
          [
            13.761418,
            54.126578,
            44.412555
          ],
          [
            13.761141,
            54.126456,
            45.466118
          ],
          [
            13.760928,
            54.126295,
            46.524639
          ],
          [
            13.760723,
            54.12614,
            47.542198
          ],
          [
            13.760477,
            54.125992,
            46.982423
          ],
          [
            13.760175,
            54.125842,
            46.017707
          ],
          [
            13.759914,
            54.125727,
            45.221763
          ],
          [
            13.759614,
            54.125623,
            44.372746
          ],
          [
            13.759315,
            54.125497,
            43.475138
          ],
          [
            13.759024,
            54.125366,
            42.58101
          ],
          [
            13.758791,
            54.12523,
            41.779818
          ],
          [
            13.758542,
            54.125104,
            40.976376
          ],
          [
            13.758243,
            54.124981,
            40.143624
          ],
          [
            13.757973,
            54.124837,
            39.636632
          ],
          [
            13.757629,
            54.124727,
            39.087932
          ],
          [
            13.757344,
            54.124612,
            38.599675
          ],
          [
            13.757154,
            54.124456,
            38.145472
          ],
          [
            13.756988,
            54.124285,
            37.679081
          ],
          [
            13.756959,
            54.124086,
            37.19704
          ],
          [
            13.757046,
            54.123891,
            36.718384
          ],
          [
            13.757187,
            54.123706,
            36.23764
          ],
          [
            13.757344,
            54.123542,
            35.865538
          ],
          [
            13.757668,
            54.12363,
            35.321174
          ],
          [
            13.757993,
            54.123724,
            35.02534
          ],
          [
            13.758267,
            54.123852,
            34.73929
          ],
          [
            13.758486,
            54.124022,
            34.442591
          ],
          [
            13.758661,
            54.124174,
            34.187039
          ],
          [
            13.758835,
            54.12434,
            33.915689
          ],
          [
            13.759017,
            54.124516,
            33.628965
          ],
          [
            13.759201,
            54.124686,
            33.601048
          ],
          [
            13.759411,
            54.124859,
            33.946162
          ],
          [
            13.759644,
            54.125026,
            34.296525
          ],
          [
            13.759864,
            54.125165,
            34.604372
          ],
          [
            13.76011,
            54.125326,
            34.955272
          ],
          [
            13.760339,
            54.125486,
            35.294369
          ],
          [
            13.760558,
            54.125647,
            35.628695
          ],
          [
            13.760778,
            54.125784,
            35.934188
          ],
          [
            13.76102,
            54.125934,
            36.269363
          ],
          [
            13.761218,
            54.126079,
            36.263261
          ],
          [
            13.761459,
            54.126218,
            36.050705
          ],
          [
            13.761713,
            54.12639,
            35.806763
          ],
          [
            13.76193,
            54.126523,
            35.60947
          ],
          [
            13.762166,
            54.12668,
            35.38513
          ],
          [
            13.762389,
            54.126836,
            35.166825
          ],
          [
            13.762611,
            54.126975,
            34.962609
          ],
          [
            13.762841,
            54.127101,
            34.764788
          ],
          [
            13.763108,
            54.127229,
            34.547912
          ],
          [
            13.763374,
            54.12736,
            34.357378
          ],
          [
            13.76363,
            54.127484,
            34.194107
          ],
          [
            13.763873,
            54.12762,
            34.028768
          ],
          [
            13.764107,
            54.127765,
            33.86139
          ],
          [
            13.764321,
            54.127923,
            33.692233
          ],
          [
            13.764559,
            54.128113,
            33.49456
          ],
          [
            13.764767,
            54.128272,
            33.326526
          ],
          [
            13.764971,
            54.128438,
            33.154974
          ],
          [
            13.76515,
            54.128617,
            32.980989
          ],
          [
            13.765366,
            54.128814,
            32.866894
          ],
          [
            13.765511,
            54.128993,
            32.783815
          ],
          [
            13.765654,
            54.12918,
            32.698032
          ],
          [
            13.765787,
            54.129373,
            32.610896
          ],
          [
            13.765908,
            54.129547,
            32.532252
          ],
          [
            13.766051,
            54.129738,
            32.444808
          ],
          [
            13.766192,
            54.129932,
            32.356539
          ],
          [
            13.766342,
            54.13012,
            32.269636
          ],
          [
            13.766475,
            54.130289,
            32.205208
          ],
          [
            13.766624,
            54.1305,
            32.402781
          ],
          [
            13.766742,
            54.130683,
            32.571939
          ],
          [
            13.766839,
            54.130864,
            32.735975
          ],
          [
            13.766911,
            54.131048,
            32.899207
          ],
          [
            13.767017,
            54.131253,
            33.084417
          ],
          [
            13.767108,
            54.131464,
            33.272622
          ],
          [
            13.767191,
            54.13169,
            33.472555
          ],
          [
            13.767265,
            54.131885,
            33.645282
          ],
          [
            13.767343,
            54.132076,
            33.636478
          ],
          [
            13.767426,
            54.132279,
            33.311529
          ],
          [
            13.767502,
            54.132481,
            32.989566
          ],
          [
            13.767572,
            54.132668,
            32.69152
          ],
          [
            13.767622,
            54.132894,
            32.336816
          ],
          [
            13.76767,
            54.133085,
            32.036267
          ],
          [
            13.767744,
            54.133296,
            31.700977
          ],
          [
            13.767754,
            54.133508,
            31.370381
          ],
          [
            13.767706,
            54.1337,
            31.068306
          ],
          [
            13.767687,
            54.133922,
            31.652416
          ],
          [
            13.767601,
            54.134118,
            32.615469
          ],
          [
            13.767535,
            54.134315,
            33.574533
          ],
          [
            13.767399,
            54.13449,
            34.489453
          ],
          [
            13.767397,
            54.134657,
            35.530362
          ],
          [
            13.76768,
            54.134578,
            36.414971
          ],
          [
            13.767959,
            54.13453,
            37.29731
          ],
          [
            13.767995,
            54.134674,
            38.284395
          ],
          [
            13.767766,
            54.134817,
            39.233794
          ],
          [
            13.767576,
            54.134996,
            39.321949
          ],
          [
            13.767272,
            54.135057,
            39.105485
          ],
          [
            13.766944,
            54.135111,
            38.856759
          ],
          [
            13.766946,
            54.135086,
            38.647396
          ],
          [
            13.766515,
            54.134431,
            37.826974
          ],
          [
            13.766726,
            54.13452,
            37.538077
          ],
          [
            13.766886,
            54.134688,
            37.483025
          ],
          [
            13.767061,
            54.134849,
            37.525977
          ],
          [
            13.767169,
            54.135036,
            37.570374
          ],
          [
            13.767067,
            54.135004,
            37.613733
          ],
          [
            13.767417,
            54.135123,
            37.676765
          ],
          [
            13.767737,
            54.135187,
            37.721299
          ],
          [
            13.768065,
            54.135278,
            37.769169
          ],
          [
            13.768412,
            54.13537,
            37.819389
          ],
          [
            13.768711,
            54.135464,
            37.850291
          ],
          [
            13.768989,
            54.135562,
            37.735479
          ],
          [
            13.769294,
            54.135631,
            37.620315
          ],
          [
            13.769649,
            54.135688,
            37.490661
          ],
          [
            13.769957,
            54.135718,
            37.380695
          ],
          [
            13.770304,
            54.135713,
            37.258414
          ],
          [
            13.770656,
            54.135685,
            37.133285
          ],
          [
            13.771009,
            54.135642,
            37.006186
          ],
          [
            13.771347,
            54.135614,
            36.885885
          ],
          [
            13.771729,
            54.135562,
            36.842104
          ],
          [
            13.772079,
            54.135562,
            37.092172
          ],
          [
            13.772429,
            54.135606,
            37.345277
          ],
          [
            13.772783,
            54.135667,
            37.606453
          ],
          [
            13.773102,
            54.135771,
            37.864561
          ],
          [
            13.77341,
            54.135891,
            38.126062
          ],
          [
            13.773715,
            54.136023,
            38.395768
          ],
          [
            13.773985,
            54.136164,
            38.651605
          ],
          [
            13.773998,
            54.136165,
            38.886838
          ],
          [
            13.773724,
            54.136038,
            38.899398
          ],
          [
            13.77348,
            54.135872,
            38.827723
          ],
          [
            13.773524,
            54.135649,
            38.754833
          ],
          [
            13.773576,
            54.135445,
            38.687928
          ],
          [
            13.773618,
            54.135223,
            38.615369
          ],
          [
            13.773751,
            54.135022,
            38.54508
          ],
          [
            13.773777,
            54.134801,
            38.471419
          ],
          [
            13.773777,
            54.134609,
            38.409133
          ],
          [
            13.773778,
            54.134415,
            38.397688
          ],
          [
            13.773764,
            54.134209,
            38.502392
          ],
          [
            13.773758,
            54.133997,
            38.610069
          ],
          [
            13.773771,
            54.133787,
            38.716861
          ],
          [
            13.773795,
            54.133603,
            38.8106
          ],
          [
            13.773852,
            54.133416,
            38.907101
          ],
          [
            13.773958,
            54.133202,
            39.020249
          ],
          [
            13.774086,
            54.132977,
            39.140665
          ],
          [
            13.77421,
            54.13276,
            39.256856
          ],
          [
            13.774331,
            54.132527,
            39.169397
          ],
          [
            13.774482,
            54.132303,
            39.035913
          ],
          [
            13.774625,
            54.132075,
            38.901511
          ],
          [
            13.77474,
            54.131849,
            38.771045
          ],
          [
            13.774889,
            54.131609,
            38.629681
          ],
          [
            13.77499,
            54.131406,
            38.512629
          ],
          [
            13.775123,
            54.131199,
            38.390266
          ],
          [
            13.775261,
            54.131001,
            38.27415
          ],
          [
            13.775391,
            54.130792,
            38.172791
          ],
          [
            13.775517,
            54.130582,
            38.071367
          ],
          [
            13.775635,
            54.130347,
            37.959779
          ],
          [
            13.775746,
            54.130118,
            37.851318
          ],
          [
            13.775883,
            54.129914,
            37.751382
          ],
          [
            13.776021,
            54.129696,
            37.64546
          ],
          [
            13.776151,
            54.12947,
            37.536818
          ],
          [
            13.776264,
            54.12925,
            37.428515
          ],
          [
            13.776394,
            54.129031,
            37.311035
          ],
          [
            13.776522,
            54.128824,
            37.199694
          ],
          [
            13.776625,
            54.128624,
            37.094065
          ],
          [
            13.776768,
            54.128384,
            36.965515
          ],
          [
            13.776914,
            54.128167,
            36.84759
          ],
          [
            13.777039,
            54.127975,
            36.743632
          ],
          [
            13.777138,
            54.127776,
            36.638838
          ],
          [
            13.777249,
            54.127576,
            36.526404
          ],
          [
            13.777405,
            54.127367,
            36.380509
          ],
          [
            13.777531,
            54.127133,
            36.223819
          ],
          [
            13.777709,
            54.12691,
            36.066581
          ],
          [
            13.777844,
            54.126687,
            35.915516
          ],
          [
            13.777925,
            54.126447,
            35.759044
          ],
          [
            13.777945,
            54.126196,
            35.59864
          ],
          [
            13.777965,
            54.125948,
            35.440119
          ],
          [
            13.77796,
            54.125724,
            35.547587
          ],
          [
            13.777934,
            54.125496,
            35.731546
          ],
          [
            13.777882,
            54.125246,
            35.933992
          ],
          [
            13.777808,
            54.125011,
            36.12608
          ],
          [
            13.777746,
            54.124798,
            36.299858
          ],
          [
            13.777669,
            54.124537,
            36.512968
          ],
          [
            13.77761,
            54.124283,
            36.719429
          ],
          [
            13.777541,
            54.124045,
            36.947874
          ],
          [
            13.77749,
            54.123795,
            37.266265
          ],
          [
            13.777474,
            54.123549,
            37.579217
          ],
          [
            13.777457,
            54.123312,
            37.87907
          ],
          [
            13.777333,
            54.123076,
            38.192738
          ],
          [
            13.777234,
            54.122833,
            38.508544
          ],
          [
            13.777191,
            54.122607,
            38.796193
          ],
          [
            13.777185,
            54.122391,
            39.069603
          ],
          [
            13.777222,
            54.122172,
            39.059629
          ],
          [
            13.777264,
            54.121942,
            38.969924
          ],
          [
            13.777423,
            54.121723,
            38.878536
          ],
          [
            13.777728,
            54.121536,
            38.778626
          ],
          [
            13.778007,
            54.121442,
            38.706085
          ],
          [
            13.778323,
            54.121363,
            38.628682
          ],
          [
            13.778687,
            54.121287,
            38.541752
          ],
          [
            13.77905,
            54.121223,
            38.456313
          ],
          [
            13.779476,
            54.121137,
            38.328345
          ],
          [
            13.77985,
            54.121073,
            38.212245
          ],
          [
            13.78019,
            54.121026,
            38.107998
          ],
          [
            13.780538,
            54.121003,
            38.002849
          ],
          [
            13.780864,
            54.120965,
            37.90386
          ],
          [
            13.781224,
            54.120883,
            37.788784
          ],
          [
            13.781513,
            54.120806,
            37.694203
          ],
          [
            13.781837,
            54.120763,
            37.595269
          ],
          [
            13.782224,
            54.120702,
            37.449889
          ],
          [
            13.782585,
            54.120591,
            37.260468
          ],
          [
            13.782925,
            54.120491,
            37.083762
          ],
          [
            13.783292,
            54.120428,
            36.905861
          ],
          [
            13.783669,
            54.120366,
            36.723979
          ],
          [
            13.783998,
            54.120285,
            36.558107
          ],
          [
            13.784326,
            54.120163,
            36.37704
          ],
          [
            13.784639,
            54.120055,
            36.208145
          ],
          [
            13.785033,
            54.120065,
            36.048788
          ],
          [
            13.785355,
            54.12009,
            35.948816
          ],
          [
            13.785756,
            54.120083,
            35.825224
          ],
          [
            13.786171,
            54.120039,
            35.694964
          ],
          [
            13.786603,
            54.12002,
            35.561567
          ],
          [
            13.78695,
            54.120056,
            35.452178
          ],
          [
            13.787225,
            54.120186,
            35.343422
          ],
          [
            13.78753,
            54.120125,
            35.231321
          ],
          [
            13.787756,
            54.119933,
            35.107618
          ],
          [
            13.788018,
            54.119756,
            34.982091
          ],
          [
            13.788284,
            54.119585,
            34.858096
          ],
          [
            13.78855,
            54.119415,
            34.734514
          ],
          [
            13.788826,
            54.119224,
            34.600428
          ],
          [
            13.789136,
            54.119042,
            34.462606
          ],
          [
            13.789433,
            54.11886,
            34.327688
          ],
          [
            13.789658,
            54.118723,
            34.225809
          ],
          [
            13.789865,
            54.11858,
            34.297682
          ],
          [
            13.79012,
            54.118411,
            34.504778
          ],
          [
            13.790406,
            54.118257,
            34.713895
          ],
          [
            13.79066,
            54.118101,
            34.913125
          ],
          [
            13.790882,
            54.117921,
            35.11731
          ],
          [
            13.79111,
            54.117774,
            35.299664
          ],
          [
            13.791394,
            54.117611,
            35.513505
          ],
          [
            13.791621,
            54.117464,
            35.695864
          ],
          [
            13.791893,
            54.11727,
            35.750539
          ],
          [
            13.792142,
            54.117098,
            35.537935
          ],
          [
            13.792373,
            54.116942,
            35.342955
          ],
          [
            13.792671,
            54.116755,
            35.101952
          ],
          [
            13.7929,
            54.116613,
            34.91723
          ],
          [
            13.793166,
            54.116444,
            34.700368
          ],
          [
            13.793407,
            54.116316,
            34.520762
          ],
          [
            13.793693,
            54.116168,
            34.310044
          ],
          [
            13.793942,
            54.115977,
            34.098923
          ],
          [
            13.7942,
            54.115792,
            33.929589
          ],
          [
            13.794479,
            54.115612,
            33.757247
          ],
          [
            13.794774,
            54.115415,
            33.571308
          ],
          [
            13.795037,
            54.115268,
            33.420259
          ],
          [
            13.795253,
            54.11513,
            33.287543
          ],
          [
            13.79548,
            54.114985,
            33.147807
          ],
          [
            13.795696,
            54.114852,
            33.017521
          ],
          [
            13.796002,
            54.114676,
            32.914209
          ],
          [
            13.796228,
            54.114504,
            33.122241
          ],
          [
            13.796529,
            54.114338,
            33.354373
          ],
          [
            13.796821,
            54.114231,
            33.549722
          ],
          [
            13.797147,
            54.114146,
            33.7511
          ],
          [
            13.79747,
            54.114079,
            33.943576
          ],
          [
            13.797785,
            54.11402,
            34.129323
          ],
          [
            13.798131,
            54.113954,
            34.333728
          ],
          [
            13.798486,
            54.113901,
            34.539493
          ],
          [
            13.798812,
            54.113842,
            34.64785
          ],
          [
            13.799143,
            54.113784,
            34.723528
          ],
          [
            13.799463,
            54.113726,
            34.796856
          ],
          [
            13.799773,
            54.113659,
            34.869245
          ],
          [
            13.800213,
            54.113574,
            34.970657
          ],
          [
            13.800591,
            54.113509,
            35.056887
          ],
          [
            13.800971,
            54.113452,
            35.142754
          ],
          [
            13.801261,
            54.113385,
            35.211251
          ],
          [
            13.801574,
            54.11333,
            35.343511
          ],
          [
            13.801888,
            54.113285,
            35.66836
          ],
          [
            13.802185,
            54.113225,
            35.984171
          ],
          [
            13.802498,
            54.113167,
            36.313797
          ],
          [
            13.802825,
            54.113102,
            36.660544
          ],
          [
            13.803149,
            54.11304,
            37.002783
          ],
          [
            13.803464,
            54.112987,
            37.331868
          ],
          [
            13.803838,
            54.112918,
            37.725614
          ],
          [
            13.804133,
            54.112859,
            38.038684
          ],
          [
            13.803812,
            54.112927,
            38.355117
          ],
          [
            13.804307,
            54.112817,
            38.473842
          ],
          [
            13.804639,
            54.112759,
            38.551522
          ],
          [
            13.804977,
            54.112698,
            38.630792
          ],
          [
            13.80532,
            54.112628,
            38.712198
          ],
          [
            13.805738,
            54.112557,
            38.809958
          ],
          [
            13.80606,
            54.112499,
            38.88547
          ],
          [
            13.806498,
            54.112426,
            38.987538
          ],
          [
            13.806806,
            54.112372,
            39.042827
          ],
          [
            13.807158,
            54.112294,
            39.069329
          ],
          [
            13.807564,
            54.1122,
            39.100072
          ],
          [
            13.807944,
            54.112144,
            39.127666
          ],
          [
            13.808268,
            54.1121,
            39.151101
          ],
          [
            13.808632,
            54.112033,
            39.177974
          ],
          [
            13.808997,
            54.111962,
            39.205059
          ],
          [
            13.809379,
            54.111913,
            39.232641
          ],
          [
            13.809771,
            54.111833,
            39.254814
          ],
          [
            13.810155,
            54.111777,
            39.264197
          ],
          [
            13.810515,
            54.111713,
            39.273117
          ],
          [
            13.810875,
            54.111637,
            39.28219
          ],
          [
            13.811255,
            54.111575,
            39.291559
          ],
          [
            13.811616,
            54.11152,
            39.300402
          ],
          [
            13.811939,
            54.111485,
            39.3082
          ],
          [
            13.812263,
            54.111444,
            39.316058
          ],
          [
            13.812587,
            54.111401,
            39.323952
          ],
          [
            13.81302,
            54.111382,
            39.35784
          ],
          [
            13.813396,
            54.111454,
            39.388739
          ],
          [
            13.81375,
            54.111496,
            39.416986
          ],
          [
            13.81411,
            54.111456,
            39.446412
          ],
          [
            13.814304,
            54.111266,
            39.47591
          ],
          [
            13.814509,
            54.111104,
            39.502812
          ],
          [
            13.814822,
            54.111046,
            39.532595
          ],
          [
            13.815098,
            54.111182,
            39.560751
          ],
          [
            13.815391,
            54.111328,
            39.682525
          ],
          [
            13.815706,
            54.111499,
            39.828938
          ],
          [
            13.816049,
            54.111672,
            39.983239
          ],
          [
            13.816281,
            54.111809,
            40.095571
          ],
          [
            13.816527,
            54.111949,
            40.21249
          ],
          [
            13.816845,
            54.112127,
            40.362477
          ],
          [
            13.817093,
            54.112299,
            40.493503
          ],
          [
            13.817312,
            54.112432,
            40.601099
          ],
          [
            13.817522,
            54.112579,
            40.682218
          ],
          [
            13.817744,
            54.112752,
            40.770889
          ],
          [
            13.817925,
            54.112921,
            40.852627
          ],
          [
            13.818142,
            54.113098,
            40.941899
          ],
          [
            13.818379,
            54.113258,
            41.028938
          ],
          [
            13.818614,
            54.113424,
            41.117306
          ],
          [
            13.818833,
            54.113579,
            41.199776
          ],
          [
            13.819082,
            54.11372,
            41.282927
          ],
          [
            13.819336,
            54.113853,
            41.33686
          ],
          [
            13.819594,
            54.11399,
            41.292529
          ],
          [
            13.819853,
            54.114117,
            41.24955
          ],
          [
            13.820124,
            54.114251,
            41.204336
          ],
          [
            13.820416,
            54.114382,
            41.157472
          ],
          [
            13.820674,
            54.114528,
            41.111802
          ],
          [
            13.820977,
            54.114664,
            41.063232
          ],
          [
            13.821296,
            54.114774,
            41.016099
          ],
          [
            13.82159,
            54.114872,
            40.973061
          ],
          [
            13.821883,
            54.114948,
            40.957535
          ],
          [
            13.822214,
            54.115006,
            40.960273
          ],
          [
            13.822529,
            54.115068,
            40.962863
          ],
          [
            13.822833,
            54.115128,
            40.965361
          ],
          [
            13.823182,
            54.115213,
            40.968313
          ],
          [
            13.823565,
            54.115294,
            40.97148
          ],
          [
            13.823924,
            54.11538,
            40.974521
          ],
          [
            13.824202,
            54.115461,
            40.976939
          ],
          [
            13.824484,
            54.115564,
            40.979528
          ],
          [
            13.824763,
            54.115691,
            40.938179
          ],
          [
            13.825035,
            54.115848,
            40.884958
          ],
          [
            13.825252,
            54.115989,
            40.839782
          ],
          [
            13.825479,
            54.116128,
            40.793955
          ],
          [
            13.825715,
            54.116326,
            40.736488
          ],
          [
            13.82593,
            54.116479,
            40.689391
          ],
          [
            13.826161,
            54.116616,
            40.643616
          ],
          [
            13.826403,
            54.116762,
            40.59525
          ],
          [
            13.826678,
            54.116881,
            40.56297
          ],
          [
            13.827011,
            54.116991,
            40.674434
          ],
          [
            13.827339,
            54.117086,
            40.78107
          ],
          [
            13.827696,
            54.117159,
            40.891273
          ],
          [
            13.827995,
            54.117204,
            40.98131
          ],
          [
            13.828426,
            54.117248,
            41.108901
          ],
          [
            13.828845,
            54.117262,
            41.232051
          ],
          [
            13.829192,
            54.117248,
            41.334805
          ],
          [
            13.82946,
            54.117016,
            41.514686
          ],
          [
            13.829637,
            54.117193,
            41.762982
          ],
          [
            13.82987,
            54.117339,
            42.009583
          ],
          [
            13.830175,
            54.117393,
            42.232975
          ],
          [
            13.830473,
            54.11746,
            42.45686
          ],
          [
            13.830812,
            54.117513,
            42.702655
          ],
          [
            13.831151,
            54.117555,
            42.946364
          ],
          [
            13.831423,
            54.117693,
            43.198215
          ],
          [
            13.831573,
            54.117889,
            43.455611
          ],
          [
            13.831573,
            54.118072,
            43.479388
          ],
          [
            13.831725,
            54.118207,
            43.202016
          ],
          [
            13.83145,
            54.118353,
            42.891457
          ],
          [
            13.831565,
            54.118103,
            42.455368
          ],
          [
            13.831642,
            54.117961,
            42.179265
          ],
          [
            13.831806,
            54.117786,
            41.892425
          ],
          [
            13.83213,
            54.117791,
            41.620617
          ],
          [
            13.83245,
            54.117786,
            41.330574
          ],
          [
            13.832729,
            54.117883,
            41.057862
          ],
          [
            13.833062,
            54.117991,
            41.383796
          ],
          [
            13.833389,
            54.118077,
            41.744547
          ],
          [
            13.833677,
            54.118182,
            42.084752
          ],
          [
            13.833962,
            54.118332,
            42.467773
          ],
          [
            13.834188,
            54.118511,
            42.847973
          ],
          [
            13.83443,
            54.118713,
            43.269359
          ],
          [
            13.834718,
            54.118861,
            43.653503
          ],
          [
            13.83504,
            54.118906,
            43.989311
          ],
          [
            13.835285,
            54.11903,
            44.202879
          ],
          [
            13.835529,
            54.119157,
            44.360099
          ],
          [
            13.835829,
            54.119247,
            44.537787
          ],
          [
            13.836116,
            54.119404,
            44.726814
          ],
          [
            13.836398,
            54.119496,
            44.885482
          ],
          [
            13.83667,
            54.119624,
            45.055176
          ],
          [
            13.836888,
            54.119753,
            45.204134
          ],
          [
            13.837162,
            54.119905,
            45.38553
          ],
          [
            13.837428,
            54.120042,
            45.555715
          ],
          [
            13.837699,
            54.120194,
            45.444103
          ],
          [
            13.837994,
            54.120316,
            45.302278
          ],
          [
            13.838317,
            54.120437,
            45.151654
          ],
          [
            13.838627,
            54.120548,
            45.008544
          ],
          [
            13.838947,
            54.120625,
            44.872662
          ],
          [
            13.839261,
            54.12072,
            44.73381
          ],
          [
            13.839601,
            54.12085,
            44.574348
          ],
          [
            13.839884,
            54.121012,
            44.417703
          ],
          [
            13.84018,
            54.121129,
            43.789406
          ],
          [
            13.840491,
            54.121033,
            42.897459
          ],
          [
            13.840708,
            54.120892,
            42.114169
          ],
          [
            13.840919,
            54.120716,
            41.227591
          ],
          [
            13.841173,
            54.120573,
            40.376162
          ],
          [
            13.841321,
            54.12039,
            39.540151
          ],
          [
            13.841499,
            54.120205,
            38.663219
          ],
          [
            13.841738,
            54.120046,
            37.789631
          ],
          [
            13.841972,
            54.11991,
            36.992676
          ],
          [
            13.842182,
            54.119742,
            36.81765
          ],
          [
            13.842402,
            54.119572,
            36.670284
          ],
          [
            13.842591,
            54.119404,
            36.530994
          ],
          [
            13.842843,
            54.119167,
            36.33809
          ],
          [
            13.843094,
            54.118958,
            36.161392
          ],
          [
            13.843364,
            54.118814,
            36.013274
          ],
          [
            13.843597,
            54.118674,
            35.877875
          ],
          [
            13.843832,
            54.11849,
            35.718641
          ],
          [
            13.844104,
            54.118336,
            36.746493
          ],
          [
            13.844351,
            54.118152,
            37.867584
          ],
          [
            13.844522,
            54.117977,
            38.832804
          ],
          [
            13.844756,
            54.117798,
            39.909746
          ],
          [
            13.844933,
            54.117615,
            40.914386
          ],
          [
            13.844965,
            54.117818,
            42.409896
          ],
          [
            13.845271,
            54.117622,
            43.911501
          ],
          [
            13.845588,
            54.11763,
            44.07861
          ],
          [
            13.845825,
            54.117561,
            43.714447
          ],
          [
            13.845862,
            54.117589,
            43.360069
          ],
          [
            13.845886,
            54.117412,
            42.996877
          ],
          [
            13.845991,
            54.117228,
            42.626964
          ],
          [
            13.846087,
            54.117229,
            42.275479
          ],
          [
            13.845965,
            54.117403,
            41.911466
          ],
          [
            13.845852,
            54.117559,
            41.539196
          ],
          [
            13.845502,
            54.117669,
            41.090063
          ],
          [
            13.845488,
            54.11765,
            40.876514
          ],
          [
            13.845671,
            54.117498,
            40.876514
          ],
          [
            13.845994,
            54.117526,
            40.876514
          ],
          [
            13.84572,
            54.117639,
            40.876514
          ],
          [
            13.845463,
            54.117725,
            40.876514
          ],
          [
            13.84516,
            54.117749,
            40.876514
          ],
          [
            13.845406,
            54.117661,
            40.876514
          ],
          [
            13.84568,
            54.117552,
            40.876514
          ],
          [
            13.845991,
            54.117538,
            40.876514
          ],
          [
            13.845911,
            54.11735,
            40.876514
          ],
          [
            13.846045,
            54.117183,
            40.876514
          ],
          [
            13.846067,
            54.117181,
            40.876514
          ]
        ]
      }
    }
  ]
}

let day33: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            13.846052,
            54.11685,
            43.115109
          ],
          [
            13.846275,
            54.116688,
            43.115109
          ],
          [
            13.846506,
            54.116514,
            43.115109
          ],
          [
            13.846735,
            54.116371,
            43.115109
          ],
          [
            13.846921,
            54.116212,
            43.115109
          ],
          [
            13.847108,
            54.116029,
            43.210541
          ],
          [
            13.847299,
            54.115845,
            43.367142
          ],
          [
            13.84752,
            54.115715,
            43.499168
          ],
          [
            13.847796,
            54.115494,
            43.695702
          ],
          [
            13.848069,
            54.115309,
            43.871408
          ],
          [
            13.848245,
            54.115125,
            44.022788
          ],
          [
            13.848479,
            54.114935,
            44.191153
          ],
          [
            13.848798,
            54.114756,
            44.377097
          ],
          [
            13.849066,
            54.114573,
            44.615063
          ],
          [
            13.849315,
            54.114451,
            44.81289
          ],
          [
            13.849564,
            54.114253,
            45.068649
          ],
          [
            13.849815,
            54.114052,
            45.327706
          ],
          [
            13.850077,
            54.113859,
            45.584157
          ],
          [
            13.850295,
            54.113667,
            45.824213
          ],
          [
            13.850499,
            54.113497,
            46.040778
          ],
          [
            13.850786,
            54.11331,
            46.21757
          ],
          [
            13.851055,
            54.113148,
            45.736614
          ],
          [
            13.851186,
            54.112939,
            45.266024
          ],
          [
            13.851395,
            54.11276,
            44.809671
          ],
          [
            13.85165,
            54.112577,
            44.310702
          ],
          [
            13.851853,
            54.112419,
            43.894562
          ],
          [
            13.852078,
            54.112252,
            43.446424
          ],
          [
            13.852327,
            54.11206,
            42.938882
          ],
          [
            13.852553,
            54.111878,
            42.47564
          ],
          [
            13.852666,
            54.111681,
            42.215741
          ],
          [
            13.852859,
            54.111494,
            41.942316
          ],
          [
            13.853087,
            54.11131,
            41.658288
          ],
          [
            13.853336,
            54.111117,
            41.356344
          ],
          [
            13.853604,
            54.110952,
            41.072248
          ],
          [
            13.853755,
            54.110741,
            40.780954
          ],
          [
            13.853674,
            54.110516,
            40.493083
          ],
          [
            13.853441,
            54.110371,
            40.260418
          ],
          [
            13.853173,
            54.110232,
            41.053152
          ],
          [
            13.852855,
            54.110127,
            41.846525
          ],
          [
            13.852603,
            54.110004,
            42.557947
          ],
          [
            13.852363,
            54.109868,
            43.290988
          ],
          [
            13.852148,
            54.109678,
            44.136033
          ],
          [
            13.851961,
            54.109487,
            44.952113
          ],
          [
            13.85191,
            54.109296,
            45.667148
          ],
          [
            13.8519,
            54.10909,
            46.428835
          ],
          [
            13.852059,
            54.108882,
            46.944477
          ],
          [
            13.85231,
            54.108668,
            47.068292
          ],
          [
            13.852243,
            54.108443,
            47.176009
          ],
          [
            13.852136,
            54.108226,
            47.282347
          ],
          [
            13.852014,
            54.108025,
            47.382785
          ],
          [
            13.851856,
            54.107842,
            47.479345
          ],
          [
            13.851739,
            54.107658,
            47.571852
          ],
          [
            13.85161,
            54.107463,
            47.670416
          ],
          [
            13.851464,
            54.107249,
            47.790642
          ],
          [
            13.851567,
            54.10705,
            47.926426
          ],
          [
            13.851767,
            54.10688,
            48.055675
          ],
          [
            13.851969,
            54.106721,
            48.179567
          ],
          [
            13.852234,
            54.106543,
            48.32716
          ],
          [
            13.85245,
            54.106346,
            48.473243
          ],
          [
            13.852685,
            54.106188,
            48.604087
          ],
          [
            13.852886,
            54.106011,
            48.737021
          ],
          [
            13.8531,
            54.105823,
            48.830291
          ],
          [
            13.853328,
            54.105646,
            48.4857
          ],
          [
            13.85358,
            54.105476,
            48.135524
          ],
          [
            13.853817,
            54.105314,
            47.803981
          ],
          [
            13.854029,
            54.105148,
            47.481956
          ],
          [
            13.85427,
            54.104957,
            47.112855
          ],
          [
            13.85455,
            54.104768,
            46.724047
          ],
          [
            13.854806,
            54.104577,
            46.346797
          ],
          [
            13.855023,
            54.104393,
            46.06724
          ],
          [
            13.85528,
            54.104195,
            46.04428
          ],
          [
            13.855526,
            54.103999,
            46.021815
          ],
          [
            13.855804,
            54.103816,
            45.999199
          ],
          [
            13.856035,
            54.103643,
            45.978905
          ],
          [
            13.856261,
            54.103466,
            45.958498
          ],
          [
            13.856483,
            54.103273,
            45.937005
          ],
          [
            13.856644,
            54.103062,
            45.915671
          ],
          [
            13.8568,
            54.102837,
            46.101372
          ],
          [
            13.857004,
            54.102691,
            46.380894
          ],
          [
            13.857292,
            54.102558,
            46.697175
          ],
          [
            13.857568,
            54.10239,
            47.040183
          ],
          [
            13.85784,
            54.102232,
            47.370593
          ],
          [
            13.858075,
            54.10204,
            47.718044
          ],
          [
            13.858299,
            54.101858,
            48.048781
          ],
          [
            13.858588,
            54.101724,
            48.366441
          ],
          [
            13.858825,
            54.101575,
            48.577207
          ],
          [
            13.859032,
            54.101407,
            48.648006
          ],
          [
            13.859273,
            54.101233,
            48.724217
          ],
          [
            13.859489,
            54.101076,
            48.79282
          ],
          [
            13.859857,
            54.10083,
            48.904065
          ],
          [
            13.860101,
            54.100662,
            48.979084
          ],
          [
            13.860329,
            54.100495,
            49.052208
          ],
          [
            13.860575,
            54.100314,
            49.131015
          ],
          [
            13.860793,
            54.100154,
            49.149913
          ],
          [
            13.86101,
            54.099972,
            49.128401
          ],
          [
            13.861238,
            54.099781,
            49.105818
          ],
          [
            13.86151,
            54.099559,
            49.079337
          ],
          [
            13.861805,
            54.09939,
            49.05589
          ],
          [
            13.862101,
            54.099226,
            49.03276
          ],
          [
            13.862358,
            54.099066,
            49.011455
          ],
          [
            13.862613,
            54.098931,
            48.991941
          ],
          [
            13.862898,
            54.098765,
            48.33884
          ],
          [
            13.863172,
            54.098613,
            47.560743
          ],
          [
            13.863447,
            54.098478,
            46.820621
          ],
          [
            13.863751,
            54.098299,
            45.931352
          ],
          [
            13.864011,
            54.098197,
            45.263446
          ],
          [
            13.864341,
            54.098039,
            44.384623
          ],
          [
            13.864586,
            54.097862,
            43.582179
          ],
          [
            13.864894,
            54.097711,
            42.753039
          ],
          [
            13.865201,
            54.097538,
            42.38212
          ],
          [
            13.865496,
            54.097391,
            42.099531
          ],
          [
            13.865783,
            54.097231,
            41.810559
          ],
          [
            13.866056,
            54.097064,
            41.522192
          ],
          [
            13.866349,
            54.096911,
            41.23599
          ],
          [
            13.866653,
            54.096762,
            40.946981
          ],
          [
            13.86696,
            54.096588,
            40.635236
          ],
          [
            13.86726,
            54.096442,
            40.506998
          ],
          [
            13.867528,
            54.096269,
            40.849023
          ],
          [
            13.867812,
            54.096108,
            41.187941
          ],
          [
            13.8681,
            54.095962,
            41.514724
          ],
          [
            13.86842,
            54.095797,
            41.880562
          ],
          [
            13.868749,
            54.095654,
            42.232373
          ],
          [
            13.869051,
            54.095487,
            42.588524
          ],
          [
            13.869345,
            54.095322,
            42.938525
          ],
          [
            13.869653,
            54.095204,
            43.313649
          ],
          [
            13.869902,
            54.095062,
            43.700542
          ],
          [
            13.870194,
            54.094893,
            44.157205
          ],
          [
            13.870479,
            54.094746,
            44.580093
          ],
          [
            13.870754,
            54.094628,
            44.9595
          ],
          [
            13.870999,
            54.094498,
            45.327272
          ],
          [
            13.871296,
            54.094356,
            45.754533
          ],
          [
            13.87159,
            54.09421,
            46.183373
          ],
          [
            13.871877,
            54.094039,
            46.522474
          ],
          [
            13.872209,
            54.093892,
            46.671528
          ],
          [
            13.872446,
            54.09375,
            46.793033
          ],
          [
            13.872743,
            54.093593,
            46.936187
          ],
          [
            13.873052,
            54.093423,
            47.088005
          ],
          [
            13.873379,
            54.093274,
            47.236906
          ],
          [
            13.873651,
            54.093132,
            47.367374
          ],
          [
            13.873885,
            54.092989,
            47.488496
          ],
          [
            13.874158,
            54.092844,
            47.43633
          ],
          [
            13.874426,
            54.092747,
            47.176263
          ],
          [
            13.874627,
            54.092745,
            46.893863
          ],
          [
            13.874788,
            54.092915,
            46.615115
          ],
          [
            13.874999,
            54.093079,
            46.325384
          ],
          [
            13.875225,
            54.093232,
            46.040379
          ],
          [
            13.875436,
            54.093382,
            45.766575
          ],
          [
            13.875685,
            54.093554,
            45.447929
          ],
          [
            13.875934,
            54.093705,
            45.151876
          ],
          [
            13.87619,
            54.093856,
            44.915638
          ],
          [
            13.876396,
            54.093961,
            44.746156
          ],
          [
            13.876534,
            54.094127,
            44.567364
          ],
          [
            13.876731,
            54.094271,
            44.400902
          ],
          [
            13.87697,
            54.094427,
            44.211049
          ],
          [
            13.877269,
            54.094529,
            44.028012
          ],
          [
            13.877528,
            54.094665,
            43.844272
          ],
          [
            13.877776,
            54.094788,
            43.672662
          ],
          [
            13.878052,
            54.094911,
            43.488753
          ],
          [
            13.878282,
            54.095048,
            43.517397
          ],
          [
            13.878658,
            54.095155,
            43.755533
          ],
          [
            13.878998,
            54.095286,
            43.987156
          ],
          [
            13.879369,
            54.09534,
            44.206594
          ],
          [
            13.879736,
            54.095367,
            44.417297
          ],
          [
            13.880116,
            54.095387,
            44.634574
          ],
          [
            13.880465,
            54.095424,
            44.845095
          ],
          [
            13.880779,
            54.095441,
            45.042941
          ],
          [
            13.881129,
            54.095331,
            45.219162
          ],
          [
            13.88143,
            54.0952,
            45.336596
          ],
          [
            13.881716,
            54.095057,
            45.453709
          ],
          [
            13.881972,
            54.094919,
            45.563346
          ],
          [
            13.882239,
            54.094759,
            45.682277
          ],
          [
            13.882537,
            54.094612,
            45.80377
          ],
          [
            13.882815,
            54.09448,
            45.915215
          ],
          [
            13.883062,
            54.094333,
            46.025039
          ],
          [
            13.883359,
            54.094227,
            46.140466
          ],
          [
            13.883654,
            54.094106,
            46.28761
          ],
          [
            13.883916,
            54.093963,
            46.43373
          ],
          [
            13.884141,
            54.093821,
            46.5687
          ],
          [
            13.884393,
            54.093679,
            46.711453
          ],
          [
            13.884659,
            54.093531,
            46.86146
          ],
          [
            13.884951,
            54.09342,
            47.004931
          ],
          [
            13.885245,
            54.093279,
            47.160095
          ],
          [
            13.885496,
            54.093172,
            47.287018
          ],
          [
            13.885782,
            54.09306,
            47.304018
          ],
          [
            13.886096,
            54.092922,
            47.144894
          ],
          [
            13.88642,
            54.092775,
            46.978793
          ],
          [
            13.886693,
            54.092659,
            46.842511
          ],
          [
            13.886939,
            54.092543,
            46.7149
          ],
          [
            13.887191,
            54.092408,
            46.575301
          ],
          [
            13.887461,
            54.092286,
            46.436511
          ],
          [
            13.887776,
            54.092177,
            46.288317
          ],
          [
            13.888033,
            54.092017,
            46.136802
          ],
          [
            13.888364,
            54.091852,
            45.950459
          ],
          [
            13.888637,
            54.091699,
            45.787784
          ],
          [
            13.888901,
            54.091575,
            45.642104
          ],
          [
            13.889199,
            54.091451,
            45.484533
          ],
          [
            13.889519,
            54.091332,
            45.32105
          ],
          [
            13.889837,
            54.091163,
            45.136252
          ],
          [
            13.890154,
            54.09102,
            44.963761
          ],
          [
            13.890471,
            54.090888,
            44.819467
          ],
          [
            13.890777,
            54.090746,
            45.093956
          ],
          [
            13.891108,
            54.090591,
            45.39072
          ],
          [
            13.891387,
            54.090424,
            45.6705
          ],
          [
            13.891664,
            54.090304,
            45.915728
          ],
          [
            13.891961,
            54.090197,
            46.160137
          ],
          [
            13.892286,
            54.090094,
            46.419402
          ],
          [
            13.892592,
            54.089997,
            46.663835
          ],
          [
            13.892879,
            54.089865,
            46.919461
          ],
          [
            13.8932,
            54.089706,
            47.016507
          ],
          [
            13.893489,
            54.08957,
            47.079277
          ],
          [
            13.893808,
            54.08939,
            47.154084
          ],
          [
            13.894089,
            54.089244,
            47.217516
          ],
          [
            13.894399,
            54.089137,
            47.278291
          ],
          [
            13.894723,
            54.089022,
            47.342319
          ],
          [
            13.895029,
            54.088912,
            47.40301
          ],
          [
            13.895319,
            54.088794,
            47.462668
          ],
          [
            13.895595,
            54.088672,
            47.831929
          ],
          [
            13.895855,
            54.088557,
            48.233133
          ],
          [
            13.896129,
            54.08845,
            48.639145
          ],
          [
            13.896391,
            54.088324,
            49.056745
          ],
          [
            13.896698,
            54.0882,
            49.516417
          ],
          [
            13.897004,
            54.088089,
            49.959979
          ],
          [
            13.89728,
            54.087979,
            50.371183
          ],
          [
            13.897547,
            54.087859,
            50.787095
          ],
          [
            13.897832,
            54.087717,
            51.24782
          ],
          [
            13.898144,
            54.087615,
            50.791132
          ],
          [
            13.898428,
            54.087488,
            50.330465
          ],
          [
            13.898718,
            54.087357,
            49.858006
          ],
          [
            13.899014,
            54.087238,
            49.394401
          ],
          [
            13.899338,
            54.087138,
            48.921733
          ],
          [
            13.899625,
            54.087043,
            48.49665
          ],
          [
            13.899949,
            54.086954,
            48.034753
          ],
          [
            13.900282,
            54.086841,
            47.537652
          ],
          [
            13.90056,
            54.086725,
            47.15334
          ],
          [
            13.900907,
            54.086585,
            46.763228
          ],
          [
            13.901207,
            54.086404,
            46.365858
          ],
          [
            13.901514,
            54.086256,
            45.996499
          ],
          [
            13.901797,
            54.086154,
            45.688895
          ],
          [
            13.902071,
            54.086038,
            45.371964
          ],
          [
            13.902367,
            54.08591,
            45.032432
          ],
          [
            13.902706,
            54.085783,
            44.660525
          ],
          [
            13.903038,
            54.08568,
            44.424824
          ],
          [
            13.903319,
            54.085563,
            44.340374
          ],
          [
            13.903612,
            54.085467,
            44.259463
          ],
          [
            13.903924,
            54.085431,
            44.180978
          ],
          [
            13.904229,
            54.085316,
            44.093431
          ],
          [
            13.904537,
            54.085224,
            44.009882
          ],
          [
            13.904837,
            54.085088,
            43.918484
          ],
          [
            13.905167,
            54.084941,
            43.818593
          ],
          [
            13.90536,
            54.084741,
            43.74639
          ],
          [
            13.905579,
            54.084614,
            44.399394
          ],
          [
            13.905877,
            54.084496,
            45.155123
          ],
          [
            13.90619,
            54.084399,
            45.897302
          ],
          [
            13.906466,
            54.084263,
            46.653342
          ],
          [
            13.906833,
            54.084141,
            47.539455
          ],
          [
            13.907134,
            54.084006,
            48.334009
          ],
          [
            13.907462,
            54.083879,
            49.158006
          ],
          [
            13.907775,
            54.083752,
            49.955979
          ],
          [
            13.908167,
            54.08363,
            50.765304
          ],
          [
            13.90854,
            54.083506,
            51.515909
          ],
          [
            13.908823,
            54.083373,
            52.150616
          ],
          [
            13.909159,
            54.083219,
            52.904393
          ],
          [
            13.909514,
            54.083079,
            53.65457
          ],
          [
            13.909822,
            54.082934,
            54.345839
          ],
          [
            13.910101,
            54.08281,
            54.958491
          ],
          [
            13.910426,
            54.082697,
            55.461129
          ],
          [
            13.910747,
            54.082593,
            55.092453
          ],
          [
            13.911071,
            54.082483,
            54.71632
          ],
          [
            13.911384,
            54.082404,
            54.372389
          ],
          [
            13.911655,
            54.082307,
            54.053165
          ],
          [
            13.911942,
            54.082211,
            53.72117
          ],
          [
            13.912269,
            54.082084,
            53.323777
          ],
          [
            13.912603,
            54.081986,
            52.948261
          ],
          [
            13.91289,
            54.081875,
            52.602731
          ],
          [
            13.913165,
            54.081768,
            52.141924
          ],
          [
            13.913504,
            54.081645,
            51.433983
          ],
          [
            13.913815,
            54.081537,
            50.790396
          ],
          [
            13.914122,
            54.081406,
            50.113643
          ],
          [
            13.914444,
            54.08131,
            49.47173
          ],
          [
            13.914648,
            54.081164,
            48.899544
          ],
          [
            13.914899,
            54.081035,
            48.303978
          ],
          [
            13.915197,
            54.080968,
            47.736871
          ],
          [
            13.915491,
            54.080862,
            47.121961
          ],
          [
            13.91582,
            54.080779,
            47.062967
          ],
          [
            13.916161,
            54.080692,
            47.152266
          ],
          [
            13.916501,
            54.080582,
            47.245534
          ],
          [
            13.916873,
            54.080474,
            47.345265
          ],
          [
            13.917234,
            54.080361,
            47.4436
          ],
          [
            13.917579,
            54.080274,
            47.533849
          ],
          [
            13.917911,
            54.080187,
            47.621061
          ],
          [
            13.9183,
            54.080062,
            47.727424
          ],
          [
            13.918594,
            54.079974,
            47.779119
          ],
          [
            13.91889,
            54.079883,
            47.830846
          ],
          [
            13.919189,
            54.07979,
            47.883163
          ],
          [
            13.919517,
            54.079666,
            47.943467
          ],
          [
            13.919822,
            54.079578,
            47.996463
          ],
          [
            13.920117,
            54.079476,
            48.049383
          ],
          [
            13.920401,
            54.079386,
            48.099267
          ],
          [
            13.920685,
            54.079284,
            48.150738
          ],
          [
            13.920951,
            54.079177,
            48.200624
          ],
          [
            13.921246,
            54.079081,
            48.331686
          ],
          [
            13.921533,
            54.078983,
            48.46484
          ],
          [
            13.921867,
            54.078863,
            48.621736
          ],
          [
            13.922199,
            54.078768,
            48.769953
          ],
          [
            13.922565,
            54.078641,
            48.940253
          ],
          [
            13.92287,
            54.078508,
            49.093433
          ],
          [
            13.923206,
            54.078418,
            49.241674
          ],
          [
            13.923549,
            54.078304,
            49.399877
          ],
          [
            13.923837,
            54.078203,
            49.195131
          ],
          [
            13.924118,
            54.078095,
            48.888754
          ],
          [
            13.924438,
            54.077989,
            48.5537
          ],
          [
            13.924744,
            54.077881,
            48.227967
          ],
          [
            13.925042,
            54.077778,
            47.912616
          ],
          [
            13.925315,
            54.077677,
            47.618289
          ],
          [
            13.925624,
            54.077543,
            47.26791
          ],
          [
            13.925915,
            54.077452,
            46.965216
          ],
          [
            13.926196,
            54.077339,
            46.651866
          ],
          [
            13.926484,
            54.077235,
            46.611587
          ],
          [
            13.926768,
            54.07712,
            46.585589
          ],
          [
            13.927082,
            54.077009,
            46.557933
          ],
          [
            13.926975,
            54.076819,
            46.531241
          ],
          [
            13.926802,
            54.076628,
            46.503275
          ],
          [
            13.92671,
            54.076418,
            46.475231
          ],
          [
            13.926623,
            54.07623,
            46.450119
          ],
          [
            13.926599,
            54.07603,
            46.424374
          ],
          [
            13.926463,
            54.075823,
            46.413364
          ],
          [
            13.926327,
            54.07566,
            46.434922
          ],
          [
            13.926157,
            54.075477,
            46.459901
          ],
          [
            13.925984,
            54.07528,
            46.486253
          ],
          [
            13.92577,
            54.075058,
            46.516555
          ],
          [
            13.925617,
            54.074847,
            46.543818
          ],
          [
            13.925576,
            54.074619,
            46.571237
          ],
          [
            13.925751,
            54.074406,
            46.599337
          ],
          [
            13.925996,
            54.074198,
            46.614472
          ],
          [
            13.926324,
            54.074099,
            46.605564
          ],
          [
            13.926667,
            54.074046,
            46.596978
          ],
          [
            13.927099,
            54.073949,
            46.585825
          ],
          [
            13.92745,
            54.073844,
            46.576327
          ],
          [
            13.927795,
            54.073779,
            46.567176
          ],
          [
            13.928162,
            54.073682,
            46.557456
          ],
          [
            13.928556,
            54.073617,
            46.547577
          ],
          [
            13.928875,
            54.073543,
            46.708035
          ],
          [
            13.92922,
            54.07347,
            46.980255
          ],
          [
            13.929602,
            54.073371,
            47.29045
          ],
          [
            13.929959,
            54.073295,
            47.572241
          ],
          [
            13.930373,
            54.073232,
            47.889407
          ],
          [
            13.930708,
            54.073165,
            48.152148
          ],
          [
            13.931061,
            54.073093,
            48.429237
          ],
          [
            13.931419,
            54.073076,
            48.695889
          ],
          [
            13.931771,
            54.072963,
            48.559669
          ],
          [
            13.932059,
            54.072887,
            48.218654
          ],
          [
            13.932433,
            54.072809,
            47.790027
          ],
          [
            13.932779,
            54.072751,
            47.400256
          ],
          [
            13.933159,
            54.072659,
            46.956289
          ],
          [
            13.933499,
            54.072553,
            46.540532
          ],
          [
            13.933829,
            54.072458,
            46.140611
          ],
          [
            13.93422,
            54.072394,
            45.702221
          ],
          [
            13.934638,
            54.072322,
            45.061749
          ],
          [
            13.935024,
            54.072254,
            44.357667
          ],
          [
            13.935376,
            54.072212,
            43.719361
          ],
          [
            13.935658,
            54.072114,
            43.142775
          ],
          [
            13.935987,
            54.072014,
            42.495347
          ],
          [
            13.936346,
            54.071948,
            41.83827
          ],
          [
            13.93676,
            54.071882,
            41.083079
          ],
          [
            13.93709,
            54.0718,
            40.457083
          ],
          [
            13.937458,
            54.071732,
            40.228186
          ],
          [
            13.937832,
            54.071635,
            40.371574
          ],
          [
            13.938192,
            54.07159,
            40.500242
          ],
          [
            13.938531,
            54.07147,
            40.638982
          ],
          [
            13.938913,
            54.071425,
            40.775113
          ],
          [
            13.939238,
            54.071373,
            40.893217
          ],
          [
            13.939568,
            54.071309,
            41.014651
          ],
          [
            13.939874,
            54.071203,
            41.139637
          ],
          [
            13.940243,
            54.071198,
            40.913729
          ],
          [
            13.940566,
            54.07125,
            40.122824
          ],
          [
            13.940931,
            54.071273,
            39.217209
          ],
          [
            13.941244,
            54.07132,
            38.45672
          ],
          [
            13.941577,
            54.071261,
            37.649219
          ],
          [
            13.941912,
            54.071208,
            36.842951
          ],
          [
            13.942286,
            54.07117,
            35.961426
          ],
          [
            13.942646,
            54.071127,
            35.105786
          ],
          [
            13.94298,
            54.071038,
            34.252928
          ],
          [
            13.943348,
            54.07105,
            34.384071
          ],
          [
            13.943697,
            54.070916,
            34.758138
          ],
          [
            13.944002,
            54.070838,
            35.056356
          ],
          [
            13.944341,
            54.070775,
            35.375031
          ],
          [
            13.944709,
            54.070719,
            35.716648
          ],
          [
            13.945052,
            54.070679,
            36.030332
          ],
          [
            13.945371,
            54.070596,
            36.353774
          ],
          [
            13.945599,
            54.070425,
            36.685393
          ],
          [
            13.945824,
            54.070233,
            36.843544
          ],
          [
            13.946019,
            54.070051,
            36.821414
          ],
          [
            13.946329,
            54.06993,
            36.798729
          ],
          [
            13.946744,
            54.069876,
            36.772941
          ],
          [
            13.947053,
            54.069821,
            36.753057
          ],
          [
            13.947408,
            54.069748,
            36.730226
          ],
          [
            13.947713,
            54.069714,
            36.710193
          ],
          [
            13.948078,
            54.069656,
            36.687332
          ],
          [
            13.948422,
            54.069641,
            36.719983
          ],
          [
            13.948736,
            54.069725,
            36.947758
          ],
          [
            13.949084,
            54.069784,
            37.191453
          ],
          [
            13.949472,
            54.069771,
            37.44831
          ],
          [
            13.949839,
            54.069759,
            37.692705
          ],
          [
            13.950167,
            54.069719,
            37.915607
          ],
          [
            13.950507,
            54.069677,
            38.14656
          ],
          [
            13.950811,
            54.069594,
            38.368992
          ],
          [
            13.951116,
            54.069448,
            38.629618
          ],
          [
            13.951496,
            54.069382,
            39.000201
          ],
          [
            13.951911,
            54.069392,
            39.419223
          ],
          [
            13.95232,
            54.069435,
            39.838423
          ],
          [
            13.952643,
            54.069497,
            40.185819
          ],
          [
            13.952966,
            54.069475,
            40.512757
          ],
          [
            13.953295,
            54.069519,
            40.851966
          ],
          [
            13.953629,
            54.069487,
            41.192987
          ],
          [
            13.954017,
            54.06946,
            41.586139
          ],
          [
            13.954366,
            54.069458,
            41.967132
          ],
          [
            13.954765,
            54.06943,
            42.447273
          ],
          [
            13.955123,
            54.069389,
            42.882813
          ],
          [
            13.955457,
            54.069382,
            43.29142
          ],
          [
            13.955793,
            54.069397,
            43.695916
          ],
          [
            13.956139,
            54.069383,
            44.110283
          ],
          [
            13.956531,
            54.069366,
            44.580204
          ],
          [
            13.956853,
            54.069311,
            44.981482
          ],
          [
            13.957247,
            54.069219,
            45.442436
          ],
          [
            13.95764,
            54.069158,
            45.565627
          ],
          [
            13.958119,
            54.069061,
            45.719139
          ],
          [
            13.958478,
            54.068994,
            45.833239
          ],
          [
            13.958781,
            54.068936,
            45.92976
          ],
          [
            13.959108,
            54.068929,
            46.028888
          ],
          [
            13.959469,
            54.068866,
            46.143141
          ],
          [
            13.959864,
            54.068823,
            46.264801
          ],
          [
            13.960297,
            54.06886,
            46.303977
          ],
          [
            13.960667,
            54.068889,
            46.166279
          ],
          [
            13.961064,
            54.068922,
            46.018196
          ],
          [
            13.961266,
            54.069058,
            45.885762
          ],
          [
            13.961247,
            54.069258,
            45.759429
          ],
          [
            13.961531,
            54.069347,
            45.632331
          ],
          [
            13.961937,
            54.069418,
            45.476037
          ],
          [
            13.962322,
            54.069453,
            45.332325
          ],
          [
            13.962691,
            54.069505,
            45.189739
          ],
          [
            13.963005,
            54.069554,
            45.065602
          ],
          [
            13.963441,
            54.069621,
            44.893487
          ],
          [
            13.963837,
            54.069659,
            44.739875
          ],
          [
            13.964176,
            54.069662,
            44.610246
          ],
          [
            13.964554,
            54.069663,
            44.465938
          ],
          [
            13.964926,
            54.069614,
            44.320099
          ],
          [
            13.965265,
            54.069554,
            44.184922
          ],
          [
            13.965665,
            54.06948,
            43.960636
          ],
          [
            13.96601,
            54.069425,
            43.528113
          ],
          [
            13.966384,
            54.06937,
            43.063521
          ],
          [
            13.966734,
            54.069294,
            42.610893
          ],
          [
            13.966839,
            54.069112,
            42.216298
          ],
          [
            13.966937,
            54.068908,
            41.781078
          ],
          [
            13.967027,
            54.068707,
            41.353713
          ],
          [
            13.967162,
            54.068498,
            40.89472
          ],
          [
            13.96737,
            54.068325,
            40.459035
          ],
          [
            13.967579,
            54.068117,
            40.236326
          ],
          [
            13.967762,
            54.067938,
            40.101912
          ],
          [
            13.967985,
            54.067779,
            39.968694
          ],
          [
            13.968201,
            54.067614,
            39.834901
          ],
          [
            13.968378,
            54.067429,
            39.698469
          ],
          [
            13.968582,
            54.067249,
            39.559145
          ],
          [
            13.968963,
            54.067119,
            39.391259
          ],
          [
            13.969349,
            54.067009,
            39.229328
          ],
          [
            13.96969,
            54.066926,
            39.439615
          ],
          [
            13.9701,
            54.066811,
            39.789353
          ],
          [
            13.970394,
            54.06674,
            40.033988
          ],
          [
            13.970744,
            54.066648,
            40.329103
          ],
          [
            13.971049,
            54.066571,
            40.584625
          ],
          [
            13.971343,
            54.066492,
            40.833737
          ],
          [
            13.971644,
            54.066413,
            41.08748
          ],
          [
            13.97196,
            54.066334,
            41.352041
          ],
          [
            13.972329,
            54.066225,
            41.640716
          ],
          [
            13.97268,
            54.066158,
            41.847757
          ],
          [
            13.973028,
            54.066079,
            42.056527
          ],
          [
            13.97338,
            54.065981,
            42.274402
          ],
          [
            13.973739,
            54.065888,
            42.493863
          ],
          [
            13.974091,
            54.065801,
            42.70741
          ],
          [
            13.974436,
            54.065719,
            42.915514
          ],
          [
            13.97477,
            54.065625,
            43.122842
          ],
          [
            13.9751,
            54.065531,
            43.254722
          ],
          [
            13.975454,
            54.065432,
            43.162567
          ],
          [
            13.975804,
            54.065335,
            43.071534
          ],
          [
            13.976173,
            54.065243,
            42.977327
          ],
          [
            13.976561,
            54.065146,
            42.878184
          ],
          [
            13.976909,
            54.065055,
            42.788652
          ],
          [
            13.977276,
            54.064971,
            42.695962
          ],
          [
            13.977638,
            54.064865,
            42.600822
          ],
          [
            13.978009,
            54.064777,
            42.426121
          ],
          [
            13.978381,
            54.064678,
            42.173988
          ],
          [
            13.978739,
            54.064597,
            41.936974
          ],
          [
            13.979061,
            54.064518,
            41.72153
          ],
          [
            13.979394,
            54.064417,
            41.490111
          ],
          [
            13.979723,
            54.064341,
            41.271881
          ],
          [
            13.980038,
            54.064266,
            41.062066
          ],
          [
            13.980423,
            54.064174,
            40.805283
          ],
          [
            13.980729,
            54.064088,
            40.674939
          ],
          [
            13.981043,
            54.06402,
            40.70591
          ],
          [
            13.981354,
            54.063943,
            40.737212
          ],
          [
            13.981683,
            54.063857,
            40.770448
          ],
          [
            13.982031,
            54.063782,
            40.804693
          ],
          [
            13.982367,
            54.063683,
            40.839398
          ],
          [
            13.982672,
            54.06359,
            40.871271
          ],
          [
            13.983027,
            54.063492,
            40.907474
          ],
          [
            13.983342,
            54.063418,
            40.938817
          ],
          [
            13.983687,
            54.063333,
            41.01385
          ],
          [
            13.984014,
            54.06326,
            41.096714
          ],
          [
            13.984354,
            54.063156,
            41.187452
          ],
          [
            13.984659,
            54.063089,
            41.264719
          ],
          [
            13.985025,
            54.062981,
            41.361709
          ],
          [
            13.985418,
            54.062913,
            41.458682
          ],
          [
            13.985725,
            54.06287,
            41.534508
          ],
          [
            13.985999,
            54.062783,
            41.608335
          ],
          [
            13.986322,
            54.062681,
            41.62369
          ],
          [
            13.986674,
            54.062589,
            41.425398
          ],
          [
            13.987039,
            54.0625,
            41.221087
          ],
          [
            13.987391,
            54.062422,
            41.027458
          ],
          [
            13.987696,
            54.062318,
            40.844686
          ],
          [
            13.988014,
            54.062224,
            40.660923
          ],
          [
            13.988366,
            54.062144,
            40.46666
          ],
          [
            13.988675,
            54.062042,
            40.283853
          ],
          [
            13.988965,
            54.061932,
            40.105442
          ],
          [
            13.989249,
            54.061824,
            40.147213
          ],
          [
            13.989539,
            54.061701,
            40.204792
          ],
          [
            13.989867,
            54.061581,
            40.266998
          ],
          [
            13.990195,
            54.061437,
            40.332906
          ],
          [
            13.990505,
            54.06133,
            40.390965
          ],
          [
            13.990847,
            54.061201,
            40.456376
          ],
          [
            13.991148,
            54.061072,
            40.516426
          ],
          [
            13.991397,
            54.060961,
            40.567013
          ],
          [
            13.991732,
            54.060827,
            40.58668
          ],
          [
            13.992024,
            54.060687,
            40.583821
          ],
          [
            13.992372,
            54.060563,
            40.580735
          ],
          [
            13.992694,
            54.060439,
            40.577816
          ],
          [
            13.992969,
            54.060311,
            40.575156
          ],
          [
            13.993284,
            54.060181,
            40.572237
          ],
          [
            13.993634,
            54.060044,
            40.569049
          ],
          [
            13.993949,
            54.059896,
            40.56599
          ],
          [
            13.994326,
            54.059768,
            40.559184
          ],
          [
            13.994625,
            54.059638,
            40.552856
          ],
          [
            13.994949,
            54.059517,
            40.546329
          ],
          [
            13.995218,
            54.059413,
            40.540847
          ],
          [
            13.995545,
            54.059287,
            40.534184
          ],
          [
            13.995846,
            54.059151,
            40.527731
          ],
          [
            13.996197,
            54.059003,
            40.520387
          ],
          [
            13.996503,
            54.058894,
            40.514278
          ],
          [
            13.996878,
            54.05875,
            41.384464
          ],
          [
            13.997167,
            54.058621,
            42.176621
          ],
          [
            13.997448,
            54.058501,
            42.934711
          ],
          [
            13.997712,
            54.058401,
            43.62638
          ],
          [
            13.998013,
            54.0583,
            44.382463
          ],
          [
            13.998337,
            54.058205,
            45.17392
          ],
          [
            13.99864,
            54.058094,
            45.955123
          ],
          [
            13.998954,
            54.058033,
            46.676687
          ],
          [
            13.999258,
            54.05794,
            47.218797
          ],
          [
            13.999611,
            54.057891,
            47.305206
          ],
          [
            13.999902,
            54.057808,
            47.382421
          ],
          [
            14.000195,
            54.057759,
            47.456023
          ],
          [
            14.00046,
            54.057652,
            47.532706
          ],
          [
            14.00077,
            54.057566,
            47.614985
          ],
          [
            14.001038,
            54.05747,
            47.692021
          ],
          [
            14.001328,
            54.057347,
            47.777314
          ],
          [
            14.001604,
            54.057188,
            47.869525
          ],
          [
            14.001868,
            54.057046,
            48.237735
          ],
          [
            14.002179,
            54.056919,
            49.148737
          ],
          [
            14.00258,
            54.056813,
            50.20065
          ],
          [
            14.002899,
            54.056718,
            51.057967
          ],
          [
            14.003209,
            54.056661,
            51.837307
          ],
          [
            14.003553,
            54.056603,
            52.69392
          ],
          [
            14.003899,
            54.056534,
            53.567315
          ],
          [
            14.004147,
            54.05642,
            54.32833
          ],
          [
            14.004462,
            54.056336,
            55.158197
          ],
          [
            14.004781,
            54.056273,
            55.476508
          ],
          [
            14.005088,
            54.056196,
            55.731734
          ],
          [
            14.005391,
            54.056109,
            55.989473
          ],
          [
            14.00569,
            54.056012,
            56.250346
          ],
          [
            14.005992,
            54.055924,
            56.509527
          ],
          [
            14.00629,
            54.055872,
            56.751407
          ],
          [
            14.006604,
            54.055877,
            56.991633
          ],
          [
            14.006714,
            54.055751,
            57.276404
          ],
          [
            14.006894,
            54.055628,
            57.523541
          ],
          [
            14.007192,
            54.055481,
            57.158652
          ],
          [
            14.007515,
            54.055322,
            56.578752
          ],
          [
            14.007922,
            54.05522,
            55.970952
          ],
          [
            14.008211,
            54.055082,
            55.447345
          ],
          [
            14.008284,
            54.054857,
            54.910356
          ],
          [
            14.008348,
            54.054609,
            54.323405
          ],
          [
            14.008426,
            54.054392,
            53.804356
          ],
          [
            14.008484,
            54.054196,
            53.355369
          ],
          [
            14.008637,
            54.053981,
            53.031035
          ],
          [
            14.008818,
            54.053824,
            52.769012
          ],
          [
            14.009021,
            54.05369,
            52.517136
          ],
          [
            14.009161,
            54.053481,
            52.20306
          ],
          [
            14.009479,
            54.053389,
            51.914596
          ],
          [
            14.009804,
            54.053236,
            51.57575
          ],
          [
            14.010105,
            54.053103,
            51.270012
          ],
          [
            14.010413,
            54.052943,
            50.936012
          ],
          [
            14.010732,
            54.052792,
            52.273083
          ],
          [
            14.011021,
            54.052662,
            53.666561
          ],
          [
            14.011284,
            54.052523,
            55.023521
          ],
          [
            14.011502,
            54.052389,
            56.231584
          ],
          [
            14.011743,
            54.05226,
            57.486812
          ],
          [
            14.012002,
            54.052126,
            58.807869
          ],
          [
            14.012244,
            54.051995,
            60.067825
          ],
          [
            14.012522,
            54.051884,
            61.355624
          ],
          [
            14.012792,
            54.051739,
            62.537497
          ],
          [
            14.013078,
            54.051589,
            61.665686
          ],
          [
            14.013347,
            54.051453,
            60.858635
          ],
          [
            14.013559,
            54.051289,
            60.060119
          ],
          [
            14.013837,
            54.051142,
            59.204364
          ],
          [
            14.013927,
            54.050952,
            58.441363
          ],
          [
            14.014228,
            54.050838,
            57.627983
          ],
          [
            14.01449,
            54.05071,
            56.853586
          ],
          [
            14.014767,
            54.050572,
            56.025995
          ],
          [
            14.015101,
            54.050435,
            56.326598
          ],
          [
            14.015398,
            54.050311,
            57.307711
          ],
          [
            14.015643,
            54.050189,
            58.170922
          ],
          [
            14.015916,
            54.050053,
            59.135865
          ],
          [
            14.016205,
            54.049914,
            60.14016
          ],
          [
            14.016542,
            54.049778,
            61.236838
          ],
          [
            14.016858,
            54.049618,
            62.363164
          ],
          [
            14.017197,
            54.049468,
            63.501594
          ],
          [
            14.017486,
            54.049322,
            63.448832
          ],
          [
            14.017792,
            54.049185,
            62.763825
          ],
          [
            14.018159,
            54.049065,
            62.015929
          ],
          [
            14.018609,
            54.049072,
            61.17
          ],
          [
            14.01895,
            54.049102,
            60.556119
          ],
          [
            14.019227,
            54.049019,
            59.94833
          ],
          [
            14.019423,
            54.048824,
            59.261627
          ],
          [
            14.019582,
            54.048641,
            58.638646
          ],
          [
            14.019732,
            54.048476,
            58.336761
          ],
          [
            14.019967,
            54.048325,
            58.182454
          ],
          [
            14.020192,
            54.048185,
            58.037349
          ],
          [
            14.020389,
            54.047961,
            57.843538
          ],
          [
            14.02059,
            54.047737,
            57.652163
          ],
          [
            14.020705,
            54.047553,
            57.503959
          ],
          [
            14.020879,
            54.04736,
            57.339489
          ],
          [
            14.021141,
            54.047209,
            57.177091
          ],
          [
            14.021406,
            54.047008,
            57.101792
          ],
          [
            14.021655,
            54.046793,
            57.1754
          ],
          [
            14.021871,
            54.04663,
            57.233801
          ],
          [
            14.022166,
            54.046429,
            57.308929
          ],
          [
            14.022438,
            54.046221,
            57.383206
          ],
          [
            14.022694,
            54.046014,
            57.455978
          ],
          [
            14.022906,
            54.045835,
            57.517811
          ],
          [
            14.023139,
            54.045628,
            57.459833
          ],
          [
            14.023462,
            54.045404,
            56.415414
          ],
          [
            14.023798,
            54.04517,
            55.322912
          ],
          [
            14.0243,
            54.044724,
            53.420991
          ],
          [
            14.024491,
            54.044528,
            52.614657
          ],
          [
            14.02464,
            54.044338,
            51.864271
          ],
          [
            14.024927,
            54.044169,
            51.144259
          ],
          [
            14.025192,
            54.043978,
            50.956459
          ],
          [
            14.025445,
            54.043787,
            50.773
          ],
          [
            14.025638,
            54.043593,
            50.601699
          ],
          [
            14.025865,
            54.043416,
            50.433954
          ],
          [
            14.026204,
            54.043166,
            50.191933
          ],
          [
            14.026475,
            54.042935,
            49.979651
          ],
          [
            14.026681,
            54.042773,
            49.823587
          ],
          [
            14.026845,
            54.04262,
            49.507333
          ],
          [
            14.027022,
            54.042445,
            49.145494
          ],
          [
            14.027243,
            54.042298,
            48.796292
          ],
          [
            14.027458,
            54.042124,
            48.414186
          ],
          [
            14.027714,
            54.041963,
            48.021148
          ],
          [
            14.02793,
            54.041763,
            47.597215
          ],
          [
            14.028131,
            54.041605,
            47.246734
          ],
          [
            14.028315,
            54.041413,
            46.849573
          ],
          [
            14.028427,
            54.04122,
            46.257044
          ],
          [
            14.028571,
            54.041114,
            45.376798
          ],
          [
            14.028304,
            54.040962,
            44.335427
          ],
          [
            14.02806,
            54.040809,
            43.337249
          ],
          [
            14.027826,
            54.040644,
            42.31519
          ],
          [
            14.027593,
            54.040447,
            41.173544
          ],
          [
            14.027524,
            54.040251,
            40.176415
          ],
          [
            14.027779,
            54.040346,
            39.307805
          ],
          [
            14.027991,
            54.040486,
            38.415681
          ],
          [
            14.028247,
            54.040628,
            37.66394
          ],
          [
            14.028516,
            54.040762,
            37.039371
          ],
          [
            14.028822,
            54.040884,
            36.384685
          ],
          [
            14.029096,
            54.041009,
            35.771405
          ],
          [
            14.029422,
            54.040958,
            35.128068
          ],
          [
            14.029681,
            54.040812,
            34.493429
          ],
          [
            14.029898,
            54.04067,
            33.918849
          ],
          [
            14.030086,
            54.04052,
            33.356852
          ],
          [
            14.030319,
            54.040373,
            32.753245
          ],
          [
            14.030524,
            54.040209,
            32.640877
          ],
          [
            14.03076,
            54.040032,
            32.619176
          ],
          [
            14.031036,
            54.039848,
            32.595525
          ],
          [
            14.031286,
            54.039696,
            32.575068
          ],
          [
            14.031559,
            54.039495,
            32.550281
          ],
          [
            14.031817,
            54.039279,
            32.524851
          ],
          [
            14.032054,
            54.039085,
            32.501799
          ],
          [
            14.032323,
            54.038932,
            32.536949
          ],
          [
            14.032543,
            54.038772,
            32.835463
          ],
          [
            14.032802,
            54.038615,
            33.153798
          ],
          [
            14.033018,
            54.038464,
            33.441654
          ],
          [
            14.033226,
            54.038292,
            33.747485
          ],
          [
            14.033474,
            54.038141,
            34.051601
          ],
          [
            14.033742,
            54.037986,
            34.372492
          ],
          [
            14.034012,
            54.037851,
            34.674396
          ],
          [
            14.034267,
            54.037701,
            34.982459
          ],
          [
            14.034545,
            54.037527,
            34.768453
          ],
          [
            14.034767,
            54.037367,
            34.362353
          ],
          [
            14.034987,
            54.037199,
            33.940023
          ],
          [
            14.035274,
            54.037074,
            33.515202
          ],
          [
            14.035515,
            54.036931,
            33.119492
          ],
          [
            14.03575,
            54.03678,
            32.717108
          ],
          [
            14.035977,
            54.036641,
            32.338071
          ],
          [
            14.036258,
            54.036459,
            31.854619
          ],
          [
            14.036483,
            54.036264,
            31.640292
          ],
          [
            14.036697,
            54.036092,
            31.857991
          ],
          [
            14.03692,
            54.035941,
            32.062246
          ],
          [
            14.037088,
            54.03574,
            32.292227
          ],
          [
            14.037184,
            54.035509,
            32.535281
          ],
          [
            14.037391,
            54.035344,
            32.748123
          ],
          [
            14.037598,
            54.035186,
            32.952419
          ],
          [
            14.037832,
            54.035026,
            33.168102
          ],
          [
            14.03807,
            54.034839,
            33.426828
          ],
          [
            14.038284,
            54.034696,
            33.860675
          ],
          [
            14.038557,
            54.034545,
            34.363734
          ],
          [
            14.038759,
            54.034378,
            34.830277
          ],
          [
            14.03897,
            54.034232,
            35.266265
          ],
          [
            14.039153,
            54.034044,
            35.759777
          ],
          [
            14.039402,
            54.033879,
            36.266712
          ],
          [
            14.03969,
            54.033734,
            36.773709
          ],
          [
            14.039964,
            54.033595,
            37.258671
          ],
          [
            14.040199,
            54.03345,
            37.979478
          ],
          [
            14.040421,
            54.033317,
            38.893474
          ],
          [
            14.040619,
            54.033162,
            39.84411
          ],
          [
            14.040811,
            54.03299,
            40.854661
          ],
          [
            14.040948,
            54.032784,
            41.938245
          ],
          [
            14.040975,
            54.032588,
            42.914063
          ],
          [
            14.040918,
            54.032364,
            44.030176
          ],
          [
            14.041,
            54.032184,
            44.964904
          ],
          [
            14.041216,
            54.032014,
            46.00384
          ],
          [
            14.041471,
            54.031868,
            45.734403
          ],
          [
            14.041676,
            54.031684,
            44.922401
          ],
          [
            14.041887,
            54.031486,
            44.054681
          ],
          [
            14.042312,
            54.031341,
            42.987807
          ],
          [
            14.04286,
            54.031301,
            41.791163
          ],
          [
            14.043178,
            54.031198,
            40.951524
          ],
          [
            14.043381,
            54.031029,
            40.190867
          ],
          [
            14.043586,
            54.030861,
            39.746899
          ],
          [
            14.043664,
            54.030619,
            39.945299
          ],
          [
            14.043762,
            54.030366,
            40.155584
          ],
          [
            14.04398,
            54.030169,
            40.346643
          ],
          [
            14.044251,
            54.030042,
            40.513723
          ],
          [
            14.044435,
            54.029881,
            40.670518
          ],
          [
            14.044657,
            54.029744,
            40.823072
          ],
          [
            14.044879,
            54.029611,
            40.972683
          ],
          [
            14.045052,
            54.029436,
            41.108428
          ],
          [
            14.045347,
            54.02939,
            40.707318
          ],
          [
            14.045475,
            54.029206,
            40.311543
          ],
          [
            14.045654,
            54.029024,
            39.892966
          ],
          [
            14.045993,
            54.0288,
            39.29675
          ],
          [
            14.04624,
            54.02865,
            38.881424
          ],
          [
            14.04643,
            54.028482,
            38.465744
          ],
          [
            14.04668,
            54.028302,
            38.002937
          ],
          [
            14.047017,
            54.028109,
            37.881352
          ],
          [
            14.047404,
            54.027914,
            39.737921
          ],
          [
            14.047777,
            54.02766,
            41.817276
          ],
          [
            14.04812,
            54.027478,
            43.501473
          ],
          [
            14.048367,
            54.027318,
            44.844574
          ],
          [
            14.048602,
            54.027123,
            46.325697
          ],
          [
            14.048872,
            54.026972,
            47.685022
          ],
          [
            14.049102,
            54.026814,
            49.002859
          ],
          [
            14.049347,
            54.026646,
            50.519546
          ],
          [
            14.04962,
            54.026471,
            52.148643
          ],
          [
            14.049882,
            54.026328,
            53.597317
          ],
          [
            14.050243,
            54.026093,
            55.770036
          ],
          [
            14.050515,
            54.025914,
            57.419818
          ],
          [
            14.050794,
            54.025788,
            58.852802
          ],
          [
            14.051056,
            54.02563,
            60.366687
          ],
          [
            14.051249,
            54.025458,
            61.531866
          ],
          [
            14.05148,
            54.025302,
            62.472087
          ],
          [
            14.05168,
            54.025147,
            63.356388
          ],
          [
            14.051935,
            54.025002,
            64.310417
          ],
          [
            14.052158,
            54.02486,
            65.189359
          ],
          [
            14.052405,
            54.024692,
            66.198607
          ],
          [
            14.052665,
            54.024551,
            67.144686
          ],
          [
            14.052875,
            54.024403,
            68.021526
          ],
          [
            14.053115,
            54.024232,
            69.029174
          ],
          [
            14.053404,
            54.024075,
            68.352479
          ],
          [
            14.053645,
            54.023926,
            67.439551
          ],
          [
            14.053858,
            54.02377,
            66.549032
          ],
          [
            14.054185,
            54.023545,
            65.215392
          ],
          [
            14.054564,
            54.023305,
            63.760549
          ],
          [
            14.054919,
            54.023048,
            62.27796
          ],
          [
            14.055227,
            54.022864,
            61.173732
          ],
          [
            14.055562,
            54.022638,
            60.481785
          ],
          [
            14.05581,
            54.022459,
            59.948869
          ],
          [
            14.056064,
            54.022299,
            59.443252
          ],
          [
            14.056321,
            54.022145,
            58.94463
          ],
          [
            14.056597,
            54.02197,
            58.389092
          ],
          [
            14.0569,
            54.021758,
            57.74607
          ],
          [
            14.057249,
            54.021567,
            57.096339
          ],
          [
            14.057523,
            54.021385,
            56.47658
          ],
          [
            14.057783,
            54.021195,
            55.850863
          ],
          [
            14.058036,
            54.021022,
            55.255316
          ],
          [
            14.058253,
            54.020837,
            54.676005
          ],
          [
            14.058562,
            54.020693,
            54.078443
          ],
          [
            14.058857,
            54.0205,
            53.41132
          ],
          [
            14.059138,
            54.020296,
            52.73873
          ],
          [
            14.059397,
            54.020114,
            52.2966
          ],
          [
            14.059673,
            54.019983,
            52.021501
          ],
          [
            14.059922,
            54.019835,
            51.758255
          ],
          [
            14.060109,
            54.019658,
            51.495243
          ],
          [
            14.060319,
            54.019502,
            51.242311
          ],
          [
            14.060615,
            54.019346,
            50.947371
          ],
          [
            14.060939,
            54.019131,
            50.584949
          ],
          [
            14.061285,
            54.018892,
            50.188064
          ],
          [
            14.061628,
            54.018669,
            49.183563
          ],
          [
            14.062031,
            54.018449,
            48.103989
          ],
          [
            14.062318,
            54.018259,
            47.254174
          ],
          [
            14.062587,
            54.018062,
            46.410341
          ],
          [
            14.062773,
            54.017909,
            45.734176
          ],
          [
            14.063029,
            54.017747,
            44.995814
          ],
          [
            14.063385,
            54.017527,
            44.061626
          ],
          [
            14.063728,
            54.017306,
            43.450308
          ],
          [
            14.064062,
            54.01717,
            42.971276
          ],
          [
            14.064392,
            54.016997,
            42.450059
          ],
          [
            14.06461,
            54.016826,
            42.020892
          ],
          [
            14.06488,
            54.01665,
            41.545628
          ],
          [
            14.065275,
            54.016586,
            41.058697
          ],
          [
            14.065681,
            54.016571,
            40.575664
          ],
          [
            14.066007,
            54.016604,
            39.926413
          ],
          [
            14.066329,
            54.016658,
            39.262333
          ],
          [
            14.066623,
            54.016747,
            38.626405
          ],
          [
            14.066939,
            54.016811,
            37.982171
          ],
          [
            14.067249,
            54.016881,
            37.344025
          ],
          [
            14.067607,
            54.016904,
            36.654013
          ],
          [
            14.067922,
            54.016931,
            36.044073
          ],
          [
            14.06828,
            54.016971,
            35.345565
          ],
          [
            14.068648,
            54.017042,
            34.769426
          ],
          [
            14.068997,
            54.017109,
            35.175286
          ],
          [
            14.068977,
            54.017125,
            35.549584
          ],
          [
            14.068644,
            54.01709,
            35.924281
          ],
          [
            14.068295,
            54.017038,
            36.32468
          ],
          [
            14.067954,
            54.016963,
            36.727071
          ],
          [
            14.067658,
            54.016878,
            37.09808
          ],
          [
            14.067902,
            54.016753,
            37.456681
          ],
          [
            14.068202,
            54.016641,
            37.851478
          ],
          [
            14.068545,
            54.016521,
            37.68252
          ],
          [
            14.068793,
            54.01636,
            36.850983
          ],
          [
            14.06903,
            54.016184,
            35.99098
          ],
          [
            14.069168,
            54.015986,
            35.172924
          ],
          [
            14.069334,
            54.015789,
            34.329203
          ],
          [
            14.069565,
            54.015609,
            33.452679
          ],
          [
            14.069804,
            54.015476,
            32.710218
          ],
          [
            14.070133,
            54.015373,
            31.869281
          ],
          [
            14.070457,
            54.015304,
            31.244128
          ],
          [
            14.070657,
            54.015145,
            31.409901
          ],
          [
            14.070793,
            54.014979,
            31.565095
          ],
          [
            14.070865,
            54.014787,
            31.732327
          ],
          [
            14.070961,
            54.014563,
            31.925337
          ],
          [
            14.071063,
            54.01437,
            32.094282
          ],
          [
            14.071197,
            54.014153,
            32.287167
          ],
          [
            14.071314,
            54.013962,
            32.45681
          ],
          [
            14.071518,
            54.013788,
            32.634016
          ],
          [
            14.071863,
            54.013688,
            32.525587
          ],
          [
            14.072233,
            54.013599,
            32.153787
          ],
          [
            14.072566,
            54.01357,
            31.844449
          ],
          [
            14.072955,
            54.013545,
            31.484806
          ],
          [
            14.073356,
            54.013483,
            31.10359
          ],
          [
            14.073775,
            54.013417,
            30.704565
          ],
          [
            14.074205,
            54.013313,
            30.277265
          ],
          [
            14.074573,
            54.013206,
            29.921358
          ],
          [
            14.074904,
            54.013068,
            30.713128
          ],
          [
            14.075204,
            54.012933,
            31.446163
          ],
          [
            14.075477,
            54.012819,
            32.096169
          ],
          [
            14.075888,
            54.012672,
            33.030397
          ],
          [
            14.076195,
            54.012533,
            33.789122
          ],
          [
            14.076516,
            54.012414,
            34.525379
          ],
          [
            14.076784,
            54.012285,
            35.198877
          ],
          [
            14.077033,
            54.012123,
            35.878242
          ],
          [
            14.077339,
            54.011953,
            36.260448
          ],
          [
            14.077553,
            54.011811,
            36.552359
          ],
          [
            14.077816,
            54.011648,
            36.8987
          ],
          [
            14.078062,
            54.011527,
            37.188877
          ],
          [
            14.078301,
            54.011367,
            37.516332
          ],
          [
            14.078605,
            54.011197,
            37.896558
          ],
          [
            14.078874,
            54.01106,
            38.218256
          ],
          [
            14.079132,
            54.010927,
            38.529556
          ],
          [
            14.079427,
            54.010781,
            38.458596
          ],
          [
            14.079704,
            54.0106,
            38.253037
          ],
          [
            14.079964,
            54.010475,
            38.086348
          ],
          [
            14.080299,
            54.010304,
            37.866255
          ],
          [
            14.08065,
            54.01013,
            37.63854
          ],
          [
            14.080979,
            54.009944,
            37.412056
          ],
          [
            14.081305,
            54.00977,
            37.193649
          ],
          [
            14.081658,
            54.009614,
            37.171909
          ],
          [
            14.081991,
            54.009464,
            37.321182
          ],
          [
            14.082295,
            54.009328,
            37.457528
          ],
          [
            14.082591,
            54.009203,
            37.587332
          ],
          [
            14.082859,
            54.009073,
            37.711403
          ],
          [
            14.083165,
            54.008943,
            37.845797
          ],
          [
            14.083392,
            54.008794,
            37.966814
          ],
          [
            14.083646,
            54.008619,
            38.106224
          ],
          [
            14.083823,
            54.008449,
            38.154862
          ],
          [
            14.084074,
            54.008304,
            38.096023
          ],
          [
            14.084324,
            54.008138,
            38.032293
          ],
          [
            14.08465,
            54.007984,
            37.961859
          ],
          [
            14.084925,
            54.007829,
            37.898081
          ],
          [
            14.08519,
            54.007654,
            37.831276
          ],
          [
            14.085459,
            54.007495,
            37.767357
          ],
          [
            14.085732,
            54.007296,
            37.694694
          ],
          [
            14.085915,
            54.0071,
            37.834652
          ],
          [
            14.086107,
            54.006936,
            38.102821
          ],
          [
            14.086335,
            54.006772,
            38.388077
          ],
          [
            14.08662,
            54.006624,
            38.690652
          ],
          [
            14.086956,
            54.006542,
            38.980053
          ],
          [
            14.08727,
            54.006438,
            39.267945
          ],
          [
            14.087608,
            54.00631,
            39.586331
          ],
          [
            14.087911,
            54.006207,
            39.863443
          ],
          [
            14.088239,
            54.006096,
            40.026677
          ],
          [
            14.088566,
            54.005976,
            39.770977
          ],
          [
            14.088879,
            54.005834,
            39.507469
          ],
          [
            14.089165,
            54.005698,
            39.263733
          ],
          [
            14.089431,
            54.005561,
            39.029346
          ],
          [
            14.089729,
            54.00536,
            38.728826
          ],
          [
            14.089941,
            54.005222,
            38.517211
          ],
          [
            14.090162,
            54.005063,
            38.283153
          ],
          [
            14.090471,
            54.004938,
            38.073353
          ],
          [
            14.090784,
            54.004847,
            38.165496
          ],
          [
            14.091121,
            54.004695,
            38.277597
          ],
          [
            14.091394,
            54.004544,
            38.376746
          ],
          [
            14.0916,
            54.004353,
            38.478306
          ],
          [
            14.091795,
            54.004152,
            38.582993
          ],
          [
            14.091957,
            54.003985,
            38.670129
          ],
          [
            14.092239,
            54.003869,
            38.761341
          ],
          [
            14.092613,
            54.003786,
            38.866916
          ],
          [
            14.092969,
            54.003706,
            39.096613
          ],
          [
            14.093344,
            54.003551,
            39.376517
          ],
          [
            14.093532,
            54.003336,
            39.627158
          ],
          [
            14.093714,
            54.003163,
            39.837955
          ],
          [
            14.094007,
            54.003044,
            40.057784
          ],
          [
            14.0943,
            54.002959,
            40.258881
          ],
          [
            14.094598,
            54.002839,
            40.478972
          ],
          [
            14.094915,
            54.002657,
            40.701399
          ],
          [
            14.095241,
            54.002457,
            40.136694
          ],
          [
            14.095493,
            54.002265,
            39.643229
          ],
          [
            14.095743,
            54.002093,
            39.182814
          ],
          [
            14.095997,
            54.001975,
            38.794757
          ],
          [
            14.096405,
            54.001852,
            38.245877
          ],
          [
            14.096757,
            54.00172,
            37.745706
          ],
          [
            14.097033,
            54.001533,
            37.241587
          ],
          [
            14.097273,
            54.001344,
            37.185188
          ],
          [
            14.097457,
            54.001184,
            37.327033
          ],
          [
            14.097676,
            54.001027,
            37.476969
          ],
          [
            14.097921,
            54.000865,
            37.636119
          ],
          [
            14.098164,
            54.000669,
            37.814343
          ],
          [
            14.098428,
            54.000525,
            37.969793
          ],
          [
            14.098713,
            54.000368,
            38.138598
          ],
          [
            14.099069,
            54.000246,
            38.318641
          ],
          [
            14.099412,
            54.000115,
            38.363771
          ],
          [
            14.099773,
            54.000009,
            38.312534
          ],
          [
            14.100152,
            53.999893,
            38.258746
          ],
          [
            14.100508,
            53.999737,
            38.20288
          ],
          [
            14.100816,
            53.999575,
            38.150369
          ],
          [
            14.101131,
            53.999393,
            38.094471
          ],
          [
            14.101331,
            53.99922,
            38.049251
          ],
          [
            14.101537,
            53.999052,
            38.004413
          ],
          [
            14.101725,
            53.998899,
            37.959298
          ],
          [
            14.101925,
            53.998733,
            37.910689
          ],
          [
            14.102201,
            53.998538,
            37.850179
          ],
          [
            14.102435,
            53.998354,
            37.795377
          ],
          [
            14.102663,
            53.998206,
            37.747748
          ],
          [
            14.102902,
            53.998023,
            37.692636
          ],
          [
            14.103102,
            53.997808,
            37.63419
          ],
          [
            14.103311,
            53.997644,
            37.585112
          ],
          [
            14.103468,
            53.997465,
            37.451417
          ],
          [
            14.10365,
            53.99728,
            37.296995
          ],
          [
            14.103787,
            53.997078,
            37.140656
          ],
          [
            14.103942,
            53.996885,
            36.987057
          ],
          [
            14.104098,
            53.9967,
            36.838614
          ],
          [
            14.104273,
            53.996477,
            36.661198
          ],
          [
            14.104465,
            53.996308,
            36.515082
          ],
          [
            14.104695,
            53.996106,
            36.340068
          ],
          [
            14.105025,
            53.995962,
            36.280457
          ],
          [
            14.105384,
            53.995835,
            36.271469
          ],
          [
            14.105772,
            53.995783,
            36.262954
          ],
          [
            14.106166,
            53.995777,
            36.254503
          ],
          [
            14.106588,
            53.995715,
            36.2452
          ],
          [
            14.106942,
            53.995698,
            36.237603
          ],
          [
            14.107316,
            53.995648,
            36.229398
          ],
          [
            14.10757,
            53.995543,
            36.222692
          ],
          [
            14.107884,
            53.995385,
            36.414014
          ],
          [
            14.108192,
            53.995243,
            36.636478
          ],
          [
            14.108426,
            53.995096,
            36.831728
          ],
          [
            14.108659,
            53.994959,
            37.020684
          ],
          [
            14.108867,
            53.994794,
            37.219278
          ],
          [
            14.109064,
            53.994647,
            37.400497
          ],
          [
            14.109303,
            53.994468,
            37.620678
          ],
          [
            14.109543,
            53.994308,
            37.827241
          ],
          [
            14.109744,
            53.994147,
            37.869418
          ],
          [
            14.109943,
            53.993989,
            37.587983
          ],
          [
            14.110142,
            53.993823,
            37.297433
          ],
          [
            14.110316,
            53.993639,
            36.996188
          ],
          [
            14.11057,
            53.993433,
            36.63211
          ],
          [
            14.110739,
            53.99325,
            36.33369
          ],
          [
            14.110906,
            53.993084,
            36.057747
          ],
          [
            14.111108,
            53.992902,
            35.746787
          ],
          [
            14.111253,
            53.992728,
            35.469464
          ],
          [
            14.111442,
            53.992569,
            35.090646
          ],
          [
            14.111634,
            53.992333,
            34.521452
          ],
          [
            14.111893,
            53.992187,
            34.063809
          ],
          [
            14.112211,
            53.99206,
            33.573556
          ],
          [
            14.112499,
            53.991946,
            33.116404
          ],
          [
            14.112781,
            53.991833,
            32.681278
          ],
          [
            14.113109,
            53.991754,
            32.229333
          ],
          [
            14.113345,
            53.991626,
            31.795294
          ],
          [
            14.113518,
            53.991456,
            31.521201
          ],
          [
            14.113549,
            53.991233,
            31.66185
          ],
          [
            14.113599,
            53.991038,
            31.785809
          ],
          [
            14.113596,
            53.990833,
            31.915109
          ],
          [
            14.113462,
            53.990647,
            32.043126
          ],
          [
            14.113335,
            53.990398,
            32.206669
          ],
          [
            14.113327,
            53.990155,
            32.359623
          ],
          [
            14.113256,
            53.989932,
            32.502446
          ],
          [
            14.113267,
            53.989698,
            32.608965
          ],
          [
            14.113517,
            53.989553,
            32.576616
          ],
          [
            14.11384,
            53.989487,
            32.546308
          ],
          [
            14.11422,
            53.989383,
            32.509383
          ],
          [
            14.114575,
            53.989289,
            32.474817
          ],
          [
            14.115021,
            53.989168,
            32.431607
          ],
          [
            14.115314,
            53.989009,
            32.396503
          ],
          [
            14.115549,
            53.988829,
            32.362486
          ],
          [
            14.115706,
            53.988629,
            32.94293
          ],
          [
            14.115879,
            53.988459,
            33.914673
          ],
          [
            14.116049,
            53.988304,
            34.824227
          ],
          [
            14.116201,
            53.988115,
            35.85053
          ],
          [
            14.116377,
            53.987937,
            36.860179
          ],
          [
            14.116506,
            53.987737,
            37.909985
          ],
          [
            14.116648,
            53.987505,
            39.119996
          ],
          [
            14.116778,
            53.987264,
            40.365064
          ],
          [
            14.116964,
            53.987039,
            41.535722
          ],
          [
            14.117178,
            53.986867,
            42.442193
          ],
          [
            14.117342,
            53.986684,
            43.327536
          ],
          [
            14.117356,
            53.986495,
            44.180765
          ],
          [
            14.117239,
            53.986314,
            45.004671
          ],
          [
            14.117045,
            53.986144,
            45.875612
          ],
          [
            14.116854,
            53.98599,
            46.686699
          ],
          [
            14.11666,
            53.985825,
            47.540871
          ],
          [
            14.116507,
            53.985636,
            48.431023
          ],
          [
            14.116362,
            53.985462,
            48.957456
          ],
          [
            14.116257,
            53.985274,
            49.230604
          ],
          [
            14.116237,
            53.985078,
            49.501654
          ],
          [
            14.116274,
            53.984874,
            49.784859
          ],
          [
            14.116508,
            53.984753,
            50.048837
          ],
          [
            14.116763,
            53.984629,
            50.320759
          ],
          [
            14.117036,
            53.984489,
            50.614933
          ],
          [
            14.117382,
            53.984428,
            50.910843
          ],
          [
            14.117727,
            53.984399,
            51.194156
          ],
          [
            14.118043,
            53.984354,
            51.661895
          ],
          [
            14.118375,
            53.984254,
            52.321973
          ],
          [
            14.118737,
            53.984173,
            53.009075
          ],
          [
            14.119068,
            53.984094,
            53.642277
          ],
          [
            14.119268,
            53.983954,
            54.196143
          ],
          [
            14.119445,
            53.983631,
            55.229811
          ],
          [
            14.119553,
            53.983391,
            55.979516
          ],
          [
            14.119676,
            53.983187,
            56.631501
          ],
          [
            14.119784,
            53.982943,
            57.07468
          ],
          [
            14.119904,
            53.982746,
            57.412094
          ],
          [
            14.120048,
            53.982536,
            57.777359
          ],
          [
            14.120194,
            53.982281,
            58.211583
          ],
          [
            14.120243,
            53.982037,
            58.607959
          ],
          [
            14.120334,
            53.981832,
            58.9496
          ],
          [
            14.120474,
            53.981551,
            59.421713
          ],
          [
            14.120712,
            53.981408,
            59.954079
          ],
          [
            14.121007,
            53.981484,
            60.648383
          ],
          [
            14.121357,
            53.981563,
            61.447892
          ],
          [
            14.121653,
            53.981657,
            62.165545
          ],
          [
            14.122045,
            53.981706,
            63.021998
          ],
          [
            14.122375,
            53.981759,
            63.751409
          ],
          [
            14.122699,
            53.981793,
            64.453479
          ],
          [
            14.123059,
            53.981742,
            65.24735
          ],
          [
            14.123318,
            53.981624,
            65.94664
          ],
          [
            14.123825,
            53.981363,
            65.938325
          ],
          [
            14.124003,
            53.981196,
            65.857883
          ],
          [
            14.124233,
            53.98101,
            65.765407
          ],
          [
            14.124442,
            53.980827,
            65.67726
          ],
          [
            14.124853,
            53.980696,
            65.56682
          ],
          [
            14.125246,
            53.980699,
            65.474273
          ],
          [
            14.125475,
            53.980823,
            65.094372
          ],
          [
            14.1257,
            53.980983,
            63.19707
          ],
          [
            14.125953,
            53.981138,
            61.230165
          ],
          [
            14.126269,
            53.981184,
            59.476575
          ],
          [
            14.126639,
            53.981151,
            57.435259
          ],
          [
            14.127034,
            53.981109,
            55.277397
          ],
          [
            14.127431,
            53.981115,
            53.135195
          ],
          [
            14.127832,
            53.981088,
            50.966887
          ],
          [
            14.128325,
            53.981043,
            49.086959
          ],
          [
            14.128817,
            53.980949,
            49.500849
          ],
          [
            14.129208,
            53.980858,
            49.837151
          ],
          [
            14.12968,
            53.980746,
            50.244256
          ],
          [
            14.130043,
            53.980617,
            50.583477
          ],
          [
            14.130264,
            53.980466,
            50.856026
          ],
          [
            14.130576,
            53.980384,
            51.130013
          ],
          [
            14.130987,
            53.980379,
            51.392906
          ],
          [
            14.131325,
            53.980287,
            51.028311
          ],
          [
            14.131683,
            53.980185,
            50.639054
          ],
          [
            14.132005,
            53.980115,
            50.303491
          ],
          [
            14.132474,
            53.979999,
            49.80475
          ],
          [
            14.132905,
            53.979942,
            49.370957
          ],
          [
            14.133347,
            53.979883,
            48.927867
          ],
          [
            14.133755,
            53.979823,
            48.516096
          ],
          [
            14.134217,
            53.979774,
            49.349031
          ],
          [
            14.13459,
            53.979697,
            50.26683
          ],
          [
            14.134922,
            53.979594,
            51.138497
          ],
          [
            14.134934,
            53.979597,
            51.913448
          ],
          [
            14.134889,
            53.979717,
            52.683863
          ],
          [
            14.135126,
            53.979832,
            53.403093
          ],
          [
            14.13502,
            53.979827,
            54.357781
          ],
          [
            14.134826,
            53.97986,
            55.186731
          ],
          [
            14.134762,
            53.980027,
            55.481401
          ],
          [
            14.134641,
            53.9802,
            55.378419
          ],
          [
            14.134526,
            53.980175,
            55.266145
          ],
          [
            14.134779,
            53.980068,
            55.163307
          ],
          [
            14.134829,
            53.979869,
            55.052492
          ],
          [
            14.134781,
            53.979691,
            54.951451
          ],
          [
            14.135174,
            53.979511,
            54.791978
          ],
          [
            14.135457,
            53.97939,
            54.67991
          ],
          [
            14.135706,
            53.97927,
            54.575965
          ],
          [
            14.136,
            53.979124,
            54.213617
          ],
          [
            14.136215,
            53.978989,
            53.892058
          ],
          [
            14.136359,
            53.978805,
            53.54001
          ],
          [
            14.136506,
            53.978626,
            53.194325
          ],
          [
            14.136854,
            53.978396,
            52.651554
          ],
          [
            14.137187,
            53.978168,
            52.128756
          ],
          [
            14.13748,
            53.977973,
            51.676669
          ],
          [
            14.13766,
            53.977774,
            51.138774
          ],
          [
            14.137842,
            53.977604,
            50.477321
          ],
          [
            14.138129,
            53.977451,
            49.728154
          ],
          [
            14.138346,
            53.97727,
            48.991731
          ],
          [
            14.138484,
            53.97701,
            48.092424
          ],
          [
            14.138617,
            53.976789,
            47.320263
          ],
          [
            14.138952,
            53.976633,
            46.467437
          ],
          [
            14.139271,
            53.976558,
            45.783459
          ],
          [
            14.139412,
            53.976367,
            45.906468
          ],
          [
            14.139667,
            53.976189,
            46.591149
          ],
          [
            14.139891,
            53.976056,
            47.137143
          ],
          [
            14.140103,
            53.975894,
            47.73331
          ],
          [
            14.140156,
            53.975928,
            48.276044
          ],
          [
            14.140331,
            53.975755,
            48.866044
          ],
          [
            14.140485,
            53.975559,
            49.498184
          ],
          [
            14.140679,
            53.975365,
            50.157768
          ],
          [
            14.140997,
            53.975148,
            50.706679
          ],
          [
            14.141214,
            53.974981,
            50.541282
          ],
          [
            14.14138,
            53.974806,
            50.383516
          ],
          [
            14.141581,
            53.974615,
            50.206009
          ],
          [
            14.141768,
            53.974417,
            50.026918
          ],
          [
            14.141981,
            53.974277,
            49.877985
          ],
          [
            14.14222,
            53.974094,
            49.696313
          ],
          [
            14.142403,
            53.973937,
            49.54649
          ],
          [
            14.142603,
            53.973757,
            49.377206
          ],
          [
            14.142842,
            53.973566,
            48.393359
          ],
          [
            14.143031,
            53.973406,
            47.484613
          ],
          [
            14.143182,
            53.973249,
            46.635013
          ],
          [
            14.143403,
            53.973076,
            45.622945
          ],
          [
            14.143605,
            53.972904,
            44.647147
          ],
          [
            14.143839,
            53.972715,
            43.555399
          ],
          [
            14.144057,
            53.972529,
            42.501644
          ],
          [
            14.144294,
            53.972344,
            41.420885
          ],
          [
            14.144546,
            53.972248,
            40.92767
          ],
          [
            14.144455,
            53.972168,
            40.845974
          ],
          [
            14.144249,
            53.972014,
            40.763283
          ],
          [
            14.144059,
            53.971892,
            40.692912
          ],
          [
            14.14377,
            53.971773,
            40.604842
          ],
          [
            14.143531,
            53.971649,
            40.525676
          ],
          [
            14.143602,
            53.971542,
            40.44831
          ],
          [
            14.143617,
            53.971546,
            40.364751
          ],
          [
            14.1434,
            53.971419,
            40.287674
          ],
          [
            14.143596,
            53.971559,
            40.206811
          ],
          [
            14.143849,
            53.971497,
            40.096852
          ],
          [
            14.143634,
            53.971489,
            39.999861
          ],
          [
            14.14382,
            53.971663,
            39.9125
          ],
          [
            14.143562,
            53.971744,
            39.824703
          ],
          [
            14.143558,
            53.97156,
            39.738681
          ],
          [
            14.143386,
            53.971418,
            39.661919
          ],
          [
            14.143537,
            53.971424,
            39.547601
          ],
          [
            14.143813,
            53.971392,
            39.469581
          ],
          [
            14.144097,
            53.971291,
            39.380421
          ],
          [
            14.144347,
            53.97117,
            39.290226
          ],
          [
            14.144663,
            53.971043,
            39.183568
          ],
          [
            14.144951,
            53.97093,
            39.087077
          ],
          [
            14.1452,
            53.970783,
            38.988722
          ],
          [
            14.145459,
            53.970651,
            38.893127
          ],
          [
            14.145718,
            53.970533,
            38.80178
          ],
          [
            14.146052,
            53.970423,
            38.695075
          ],
          [
            14.146325,
            53.970323,
            38.605392
          ],
          [
            14.146619,
            53.970226,
            38.412068
          ],
          [
            14.146921,
            53.970097,
            38.172499
          ],
          [
            14.147202,
            53.96995,
            37.931728
          ],
          [
            14.147473,
            53.969801,
            37.694516
          ],
          [
            14.147737,
            53.96961,
            37.426847
          ],
          [
            14.147978,
            53.969422,
            37.170855
          ],
          [
            14.148179,
            53.969264,
            36.95632
          ],
          [
            14.148392,
            53.969102,
            36.732883
          ],
          [
            14.148591,
            53.968947,
            36.607079
          ],
          [
            14.148816,
            53.96877,
            36.551278
          ],
          [
            14.148996,
            53.968597,
            36.500089
          ],
          [
            14.149164,
            53.968423,
            36.449579
          ],
          [
            14.149349,
            53.968251,
            36.39819
          ],
          [
            14.149527,
            53.968086,
            36.348876
          ],
          [
            14.149743,
            53.967916,
            36.294745
          ],
          [
            14.149884,
            53.96774,
            36.245569
          ],
          [
            14.150031,
            53.967567,
            36.196766
          ],
          [
            14.150222,
            53.967403,
            36.524975
          ],
          [
            14.150419,
            53.967263,
            37.01024
          ],
          [
            14.150664,
            53.96715,
            37.499588
          ],
          [
            14.150924,
            53.967208,
            38.029109
          ],
          [
            14.15108,
            53.967392,
            38.585139
          ],
          [
            14.15128,
            53.967556,
            39.124063
          ],
          [
            14.151612,
            53.967565,
            39.746009
          ],
          [
            14.151843,
            53.967388,
            40.341063
          ],
          [
            14.152125,
            53.967236,
            40.94103
          ],
          [
            14.152435,
            53.967065,
            41.061849
          ],
          [
            14.152718,
            53.966906,
            41.14589
          ],
          [
            14.152978,
            53.96676,
            41.223188
          ],
          [
            14.153269,
            53.966603,
            41.307986
          ],
          [
            14.153549,
            53.966453,
            41.389571
          ],
          [
            14.153803,
            53.966323,
            41.461923
          ],
          [
            14.154056,
            53.966171,
            41.539786
          ],
          [
            14.154219,
            53.966002,
            41.610725
          ],
          [
            14.154478,
            53.965826,
            42.011803
          ],
          [
            14.15474,
            53.965658,
            42.50718
          ],
          [
            14.155005,
            53.965486,
            43.011747
          ],
          [
            14.155277,
            53.965314,
            43.522127
          ],
          [
            14.155554,
            53.965132,
            44.052827
          ],
          [
            14.155783,
            53.964958,
            44.530901
          ],
          [
            14.156048,
            53.964773,
            45.056461
          ],
          [
            14.156295,
            53.964629,
            45.501115
          ],
          [
            14.156553,
            53.964461,
            45.186113
          ],
          [
            14.156816,
            53.964302,
            44.811216
          ],
          [
            14.157051,
            53.964127,
            44.434355
          ],
          [
            14.157337,
            53.963958,
            44.029287
          ],
          [
            14.157587,
            53.963788,
            43.649481
          ],
          [
            14.157798,
            53.963653,
            43.339529
          ],
          [
            14.158038,
            53.963506,
            42.995073
          ],
          [
            14.158288,
            53.963346,
            42.62739
          ],
          [
            14.158558,
            53.96316,
            42.546169
          ],
          [
            14.158823,
            53.963005,
            42.605802
          ],
          [
            14.159045,
            53.962829,
            42.665483
          ],
          [
            14.159288,
            53.962627,
            42.732613
          ],
          [
            14.159504,
            53.962463,
            42.788909
          ],
          [
            14.159748,
            53.962333,
            42.841773
          ],
          [
            14.159985,
            53.962165,
            42.900997
          ],
          [
            14.160236,
            53.962011,
            42.958872
          ],
          [
            14.160546,
            53.961933,
            42.823836
          ],
          [
            14.1609,
            53.961866,
            42.432759
          ],
          [
            14.161237,
            53.96177,
            42.038845
          ],
          [
            14.161502,
            53.961602,
            41.629849
          ],
          [
            14.161751,
            53.961445,
            41.246674
          ],
          [
            14.161957,
            53.961285,
            40.887646
          ],
          [
            14.16218,
            53.961123,
            40.514826
          ],
          [
            14.162449,
            53.960981,
            40.135273
          ],
          [
            14.162687,
            53.960822,
            39.7701
          ],
          [
            14.162949,
            53.960673,
            39.628642
          ],
          [
            14.163225,
            53.96049,
            39.467297
          ],
          [
            14.163491,
            53.960324,
            39.316839
          ],
          [
            14.163757,
            53.960182,
            39.177421
          ],
          [
            14.164016,
            53.959993,
            39.017289
          ],
          [
            14.164263,
            53.959829,
            38.872785
          ],
          [
            14.164546,
            53.959646,
            38.70961
          ],
          [
            14.164815,
            53.959475,
            38.706501
          ],
          [
            14.165118,
            53.959314,
            39.203933
          ],
          [
            14.16545,
            53.959212,
            39.659406
          ],
          [
            14.165788,
            53.959083,
            40.146872
          ],
          [
            14.166005,
            53.958901,
            40.6216
          ],
          [
            14.166203,
            53.958726,
            41.058497
          ],
          [
            14.166526,
            53.958659,
            41.472773
          ],
          [
            14.1668,
            53.958574,
            41.847911
          ],
          [
            14.167041,
            53.958391,
            42.289775
          ],
          [
            14.167331,
            53.958192,
            42.352818
          ],
          [
            14.167595,
            53.958008,
            42.410707
          ],
          [
            14.167825,
            53.957821,
            42.466247
          ],
          [
            14.168065,
            53.957631,
            42.523201
          ],
          [
            14.168299,
            53.957437,
            42.580457
          ],
          [
            14.168526,
            53.957244,
            42.636893
          ],
          [
            14.168824,
            53.957135,
            42.687361
          ],
          [
            14.169172,
            53.957083,
            42.69781
          ],
          [
            14.169361,
            53.956921,
            42.651914
          ],
          [
            14.171907,
            53.954881,
            41.553216
          ],
          [
            14.171838,
            53.954667,
            41.391159
          ],
          [
            14.171623,
            53.954509,
            41.243047
          ],
          [
            14.171359,
            53.954393,
            41.10133
          ],
          [
            14.171202,
            53.954231,
            41.016344
          ],
          [
            14.171389,
            53.954016,
            41.209328
          ],
          [
            14.171588,
            53.953844,
            41.37438
          ],
          [
            14.171794,
            53.953665,
            41.545868
          ],
          [
            14.171965,
            53.953452,
            41.73357
          ],
          [
            14.172144,
            53.953269,
            41.902188
          ],
          [
            14.172369,
            53.953085,
            42.082013
          ],
          [
            14.172632,
            53.952902,
            42.272126
          ],
          [
            14.172878,
            53.952717,
            42.397411
          ],
          [
            14.173115,
            53.952547,
            42.336893
          ],
          [
            14.173365,
            53.952348,
            42.26897
          ],
          [
            14.173608,
            53.952191,
            42.210598
          ],
          [
            14.173887,
            53.952015,
            42.144507
          ],
          [
            14.174178,
            53.951849,
            42.079048
          ],
          [
            14.174405,
            53.95167,
            42.017605
          ],
          [
            14.174635,
            53.951476,
            41.952665
          ],
          [
            14.174897,
            53.951275,
            42.061388
          ],
          [
            14.175154,
            53.951105,
            42.305479
          ],
          [
            14.175464,
            53.950923,
            42.581732
          ],
          [
            14.175691,
            53.950756,
            42.811005
          ],
          [
            14.17596,
            53.950559,
            43.081926
          ],
          [
            14.176247,
            53.950369,
            43.354508
          ],
          [
            14.176529,
            53.950179,
            43.625172
          ],
          [
            14.176782,
            53.949984,
            43.779169
          ],
          [
            14.17706,
            53.949796,
            43.329681
          ],
          [
            14.177332,
            53.949624,
            42.905506
          ],
          [
            14.177612,
            53.949452,
            42.475772
          ],
          [
            14.177899,
            53.949278,
            42.03841
          ],
          [
            14.178188,
            53.949109,
            41.605964
          ],
          [
            14.178465,
            53.948933,
            41.173278
          ],
          [
            14.178747,
            53.948759,
            40.73951
          ],
          [
            14.179024,
            53.9486,
            40.931332
          ],
          [
            14.179309,
            53.948449,
            41.416958
          ],
          [
            14.179577,
            53.94829,
            41.898544
          ],
          [
            14.179814,
            53.948131,
            42.35329
          ],
          [
            14.180091,
            53.947956,
            42.86747
          ],
          [
            14.180376,
            53.94778,
            43.390313
          ],
          [
            14.180671,
            53.9476,
            43.927967
          ],
          [
            14.180917,
            53.947428,
            44.411307
          ],
          [
            14.181182,
            53.947251,
            44.503449
          ],
          [
            14.181459,
            53.9471,
            44.538645
          ],
          [
            14.181761,
            53.946929,
            44.577759
          ],
          [
            14.182034,
            53.946773,
            44.613231
          ],
          [
            14.182304,
            53.946608,
            44.649525
          ],
          [
            14.182546,
            53.946438,
            44.68478
          ],
          [
            14.182762,
            53.946263,
            44.719179
          ],
          [
            14.183025,
            53.946122,
            44.752345
          ],
          [
            14.18329,
            53.945966,
            44.475217
          ],
          [
            14.183524,
            53.945837,
            44.213754
          ],
          [
            14.183837,
            53.945667,
            43.866284
          ],
          [
            14.184105,
            53.945508,
            43.555959
          ],
          [
            14.184377,
            53.945345,
            43.239398
          ],
          [
            14.184705,
            53.945175,
            42.882943
          ],
          [
            14.185015,
            53.944996,
            42.528703
          ],
          [
            14.185317,
            53.944826,
            42.367444
          ],
          [
            14.185599,
            53.944661,
            42.817664
          ],
          [
            14.185897,
            53.944491,
            43.287291
          ],
          [
            14.186205,
            53.944324,
            43.761183
          ],
          [
            14.186464,
            53.944182,
            44.161808
          ],
          [
            14.186703,
            53.944043,
            44.542069
          ],
          [
            14.186978,
            53.943878,
            44.986591
          ],
          [
            14.187214,
            53.943738,
            45.367285
          ],
          [
            14.187449,
            53.943603,
            45.714016
          ],
          [
            14.187681,
            53.943477,
            45.567988
          ],
          [
            14.187932,
            53.94332,
            45.39824
          ],
          [
            14.188096,
            53.943139,
            45.232379
          ],
          [
            14.18832,
            53.942974,
            45.060625
          ],
          [
            14.188585,
            53.942825,
            44.891152
          ],
          [
            14.188902,
            53.942655,
            44.692647
          ],
          [
            14.189156,
            53.942541,
            44.544947
          ],
          [
            14.18943,
            53.942391,
            44.371932
          ],
          [
            14.189766,
            53.942224,
            44.248624
          ],
          [
            14.19008,
            53.942064,
            44.166534
          ],
          [
            14.190343,
            53.941937,
            44.099219
          ],
          [
            14.190646,
            53.941772,
            44.017607
          ],
          [
            14.190929,
            53.941621,
            43.942092
          ],
          [
            14.191268,
            53.941446,
            43.852941
          ],
          [
            14.19154,
            53.941304,
            43.780921
          ],
          [
            14.191833,
            53.941156,
            43.704514
          ],
          [
            14.192096,
            53.941012,
            43.676815
          ],
          [
            14.192375,
            53.940856,
            43.647172
          ],
          [
            14.192661,
            53.940735,
            43.619984
          ],
          [
            14.193006,
            53.940568,
            43.585575
          ],
          [
            14.193295,
            53.940411,
            43.555155
          ],
          [
            14.193605,
            53.940241,
            43.522513
          ],
          [
            14.193913,
            53.940088,
            43.491465
          ],
          [
            14.194207,
            53.939945,
            43.464391
          ],
          [
            14.194517,
            53.939791,
            43.44356
          ],
          [
            14.194825,
            53.939621,
            43.421869
          ],
          [
            14.19511,
            53.939467,
            43.402
          ],
          [
            14.195399,
            53.939332,
            43.383043
          ],
          [
            14.195707,
            53.939176,
            43.362177
          ],
          [
            14.196024,
            53.939026,
            43.341289
          ],
          [
            14.196295,
            53.938907,
            43.323927
          ],
          [
            14.196592,
            53.938759,
            43.312205
          ],
          [
            14.196868,
            53.938628,
            43.31222
          ],
          [
            14.197199,
            53.938502,
            43.312238
          ],
          [
            14.19752,
            53.938355,
            43.312255
          ],
          [
            14.197886,
            53.938197,
            43.312275
          ],
          [
            14.198235,
            53.938057,
            43.312294
          ],
          [
            14.198542,
            53.937931,
            43.31231
          ],
          [
            14.198848,
            53.937801,
            43.312327
          ],
          [
            14.19918,
            53.937661,
            43.547875
          ],
          [
            14.199482,
            53.937537,
            43.838821
          ],
          [
            14.199824,
            53.937387,
            44.175618
          ],
          [
            14.200188,
            53.937227,
            44.534317
          ],
          [
            14.200531,
            53.937073,
            44.875605
          ],
          [
            14.200853,
            53.936941,
            45.185796
          ],
          [
            14.201128,
            53.936834,
            45.446024
          ],
          [
            14.201384,
            53.936722,
            45.698046
          ],
          [
            14.201632,
            53.93661,
            45.648634
          ],
          [
            14.201929,
            53.936479,
            45.547247
          ],
          [
            14.20226,
            53.936341,
            45.437144
          ],
          [
            14.202621,
            53.936182,
            45.314935
          ],
          [
            14.20289,
            53.93607,
            45.225535
          ],
          [
            14.203171,
            53.935929,
            45.125451
          ],
          [
            14.203463,
            53.935799,
            45.025791
          ],
          [
            14.203765,
            53.935665,
            44.923175
          ],
          [
            14.204123,
            53.93549,
            44.924577
          ],
          [
            14.204415,
            53.935334,
            44.955259
          ],
          [
            14.204696,
            53.935203,
            44.983094
          ],
          [
            14.205044,
            53.935054,
            45.016501
          ],
          [
            14.205303,
            53.934932,
            45.042287
          ],
          [
            14.205619,
            53.934796,
            45.072684
          ],
          [
            14.205876,
            53.934645,
            45.10088
          ],
          [
            14.206212,
            53.934496,
            45.131884
          ],
          [
            14.206485,
            53.934383,
            44.98338
          ],
          [
            14.206815,
            53.934228,
            44.795271
          ],
          [
            14.207085,
            53.934136,
            44.656762
          ],
          [
            14.20734,
            53.934012,
            44.509939
          ],
          [
            14.207638,
            53.933879,
            44.343783
          ],
          [
            14.207907,
            53.933756,
            44.192608
          ],
          [
            14.208193,
            53.933652,
            44.041414
          ],
          [
            14.208449,
            53.933528,
            43.893657
          ],
          [
            14.208745,
            53.9334,
            43.661898
          ],
          [
            14.209083,
            53.933259,
            43.204019
          ],
          [
            14.209374,
            53.933137,
            42.813117
          ],
          [
            14.209718,
            53.933046,
            42.400432
          ],
          [
            14.21001,
            53.93291,
            41.992695
          ],
          [
            14.210306,
            53.932757,
            41.552798
          ],
          [
            14.210602,
            53.93262,
            41.138975
          ],
          [
            14.210968,
            53.932489,
            40.667915
          ],
          [
            14.21126,
            53.932358,
            40.370356
          ],
          [
            14.211533,
            53.93221,
            40.214309
          ],
          [
            14.211794,
            53.932097,
            40.078158
          ],
          [
            14.212139,
            53.931959,
            39.90245
          ],
          [
            14.212448,
            53.931848,
            39.746928
          ],
          [
            14.21284,
            53.931673,
            39.537008
          ],
          [
            14.213115,
            53.931541,
            39.387695
          ],
          [
            14.213432,
            53.931391,
            39.215874
          ],
          [
            14.213872,
            53.931222,
            39.329197
          ],
          [
            14.214255,
            53.931083,
            39.542017
          ],
          [
            14.214554,
            53.930958,
            39.715494
          ],
          [
            14.214855,
            53.930831,
            39.890465
          ],
          [
            14.215131,
            53.930708,
            40.054033
          ],
          [
            14.215488,
            53.930571,
            40.25557
          ],
          [
            14.215937,
            53.930384,
            40.515389
          ],
          [
            14.216335,
            53.930216,
            40.840008
          ],
          [
            14.216751,
            53.930064,
            41.214467
          ],
          [
            14.217133,
            53.929899,
            41.575999
          ],
          [
            14.217593,
            53.929717,
            41.999032
          ],
          [
            14.217927,
            53.929592,
            42.30204
          ],
          [
            14.21839,
            53.929414,
            42.723922
          ],
          [
            14.218773,
            53.929234,
            42.990258
          ],
          [
            14.219255,
            53.929106,
            43.141423
          ],
          [
            14.21957,
            53.928948,
            43.259935
          ],
          [
            14.219871,
            53.928816,
            43.367112
          ],
          [
            14.22016,
            53.928716,
            43.462845
          ],
          [
            14.220505,
            53.928619,
            43.572039
          ],
          [
            14.220774,
            53.928497,
            43.669015
          ],
          [
            14.221036,
            53.928388,
            43.76062
          ],
          [
            14.221356,
            53.928257,
            43.56204
          ],
          [
            14.221636,
            53.928159,
            43.270658
          ],
          [
            14.221945,
            53.928041,
            42.940502
          ],
          [
            14.222253,
            53.927922,
            42.611603
          ],
          [
            14.222625,
            53.927798,
            42.22946
          ],
          [
            14.223032,
            53.927655,
            41.80607
          ],
          [
            14.223435,
            53.927515,
            41.388368
          ],
          [
            14.223784,
            53.927362,
            41.108191
          ],
          [
            14.224074,
            53.927255,
            41.268553
          ],
          [
            14.22435,
            53.927158,
            41.419105
          ],
          [
            14.224679,
            53.927035,
            41.601504
          ],
          [
            14.22507,
            53.927045,
            41.819044
          ],
          [
            14.22535,
            53.927188,
            41.994028
          ],
          [
            14.225717,
            53.927322,
            42.196557
          ],
          [
            14.225876,
            53.927502,
            42.357827
          ],
          [
            14.226052,
            53.92768,
            42.479703
          ],
          [
            14.226147,
            53.927913,
            42.294981
          ],
          [
            14.226197,
            53.928114,
            42.138478
          ],
          [
            14.226283,
            53.928302,
            41.988288
          ],
          [
            14.226206,
            53.928131,
            41.845677
          ],
          [
            14.226199,
            53.928109,
            41.684642
          ],
          [
            14.226169,
            53.927906,
            41.527625
          ],
          [
            14.226081,
            53.927679,
            41.346459
          ],
          [
            14.22584,
            53.927494,
            41.165917
          ],
          [
            14.225621,
            53.927283,
            41.193486
          ],
          [
            14.225264,
            53.927184,
            41.294143
          ],
          [
            14.225006,
            53.927038,
            41.38598
          ],
          [
            14.225037,
            53.926891,
            41.478451
          ],
          [
            14.225319,
            53.926788,
            41.563452
          ],
          [
            14.225567,
            53.926651,
            41.650259
          ],
          [
            14.22587,
            53.926583,
            41.738604
          ],
          [
            14.226173,
            53.926522,
            41.821471
          ],
          [
            14.226482,
            53.926405,
            41.885697
          ],
          [
            14.22682,
            53.926298,
            41.848247
          ],
          [
            14.227171,
            53.926177,
            41.808653
          ],
          [
            14.22748,
            53.926049,
            41.771868
          ],
          [
            14.227832,
            53.925937,
            41.732753
          ],
          [
            14.228148,
            53.925835,
            41.69767
          ],
          [
            14.228455,
            53.925753,
            41.664791
          ],
          [
            14.228757,
            53.925638,
            41.629762
          ],
          [
            14.229064,
            53.925506,
            41.549151
          ],
          [
            14.229407,
            53.925393,
            41.066946
          ],
          [
            14.229738,
            53.925336,
            40.643077
          ],
          [
            14.229978,
            53.925176,
            40.185497
          ],
          [
            14.230313,
            53.92508,
            39.728336
          ],
          [
            14.230611,
            53.924986,
            39.313573
          ],
          [
            14.230911,
            53.924886,
            38.890641
          ],
          [
            14.231218,
            53.924768,
            38.430194
          ],
          [
            14.231561,
            53.924683,
            37.963789
          ],
          [
            14.231882,
            53.924601,
            38.084183
          ],
          [
            14.232175,
            53.924497,
            38.391362
          ],
          [
            14.232454,
            53.9244,
            38.682061
          ],
          [
            14.232874,
            53.92426,
            39.115092
          ],
          [
            14.233188,
            53.924162,
            39.434528
          ],
          [
            14.233523,
            53.924055,
            39.776377
          ],
          [
            14.233844,
            53.923961,
            40.100185
          ],
          [
            14.234216,
            53.92383,
            40.4922
          ],
          [
            14.234549,
            53.923729,
            40.546359
          ],
          [
            14.234899,
            53.923637,
            40.485054
          ],
          [
            14.235252,
            53.923573,
            40.425985
          ],
          [
            14.23555,
            53.923441,
            40.366354
          ],
          [
            14.235915,
            53.923331,
            40.300739
          ],
          [
            14.236238,
            53.923211,
            40.239657
          ],
          [
            14.236615,
            53.923095,
            40.170368
          ],
          [
            14.236972,
            53.922961,
            40.102612
          ],
          [
            14.237302,
            53.922841,
            40.32678
          ],
          [
            14.237657,
            53.922759,
            40.557822
          ],
          [
            14.237986,
            53.922661,
            40.78127
          ],
          [
            14.238382,
            53.922567,
            41.038785
          ],
          [
            14.238765,
            53.922465,
            41.292111
          ],
          [
            14.239089,
            53.922351,
            41.519758
          ],
          [
            14.2394,
            53.922433,
            41.728142
          ],
          [
            14.23975,
            53.922316,
            41.945144
          ],
          [
            14.240047,
            53.922221,
            41.973168
          ],
          [
            14.240385,
            53.922155,
            42.002715
          ],
          [
            14.240768,
            53.922059,
            42.037226
          ],
          [
            14.241105,
            53.921942,
            42.069663
          ],
          [
            14.241476,
            53.921872,
            42.102001
          ],
          [
            14.241835,
            53.921774,
            42.13498
          ],
          [
            14.242155,
            53.921637,
            42.167778
          ],
          [
            14.242456,
            53.921542,
            42.223973
          ],
          [
            14.242786,
            53.921452,
            42.61841
          ],
          [
            14.243176,
            53.921362,
            43.072473
          ],
          [
            14.243549,
            53.921283,
            43.50244
          ],
          [
            14.243571,
            53.921103,
            43.873462
          ],
          [
            14.243831,
            53.921,
            44.254193
          ],
          [
            14.244142,
            53.920938,
            44.610334
          ],
          [
            14.244476,
            53.92089,
            44.984085
          ],
          [
            14.244823,
            53.920832,
            45.375158
          ],
          [
            14.245201,
            53.920753,
            45.404263
          ],
          [
            14.245545,
            53.920707,
            45.279222
          ],
          [
            14.245894,
            53.920645,
            45.150236
          ],
          [
            14.246244,
            53.920591,
            45.021926
          ],
          [
            14.246574,
            53.920514,
            44.896338
          ],
          [
            14.246933,
            53.920454,
            44.764331
          ],
          [
            14.247316,
            53.9204,
            44.624725
          ],
          [
            14.24769,
            53.920326,
            44.48516
          ],
          [
            14.248017,
            53.920262,
            44.429526
          ],
          [
            14.248351,
            53.920194,
            44.441512
          ],
          [
            14.248688,
            53.920144,
            44.453301
          ],
          [
            14.249027,
            53.920081,
            44.465347
          ],
          [
            14.249365,
            53.920036,
            44.477093
          ],
          [
            14.249679,
            53.919995,
            44.488015
          ],
          [
            14.250009,
            53.919932,
            44.499784
          ],
          [
            14.250368,
            53.919866,
            44.512532
          ],
          [
            14.250709,
            53.91981,
            44.524529
          ],
          [
            14.251098,
            53.919742,
            44.081016
          ],
          [
            14.251475,
            53.919672,
            43.538987
          ],
          [
            14.251846,
            53.919601,
            43.005641
          ],
          [
            14.25218,
            53.91955,
            42.534305
          ],
          [
            14.252513,
            53.919472,
            42.044567
          ],
          [
            14.252824,
            53.919408,
            41.591427
          ],
          [
            14.252771,
            53.919126,
            40.926529
          ],
          [
            14.253069,
            53.919081,
            40.505717
          ],
          [
            14.2534,
            53.919056,
            40.367305
          ],
          [
            14.253795,
            53.918971,
            40.389297
          ],
          [
            14.254033,
            53.918827,
            40.408268
          ],
          [
            14.253852,
            53.918633,
            40.427965
          ],
          [
            14.253753,
            53.918462,
            40.444008
          ],
          [
            14.253595,
            53.918237,
            40.46567
          ],
          [
            14.253445,
            53.918004,
            40.487905
          ],
          [
            14.253328,
            53.917825,
            40.504995
          ],
          [
            14.253642,
            53.917749,
            40.479425
          ],
          [
            14.253672,
            53.917551,
            40.393965
          ],
          [
            14.253482,
            53.917353,
            40.299972
          ],
          [
            14.253341,
            53.917156,
            40.211579
          ],
          [
            14.253153,
            53.916953,
            40.115956
          ],
          [
            14.253003,
            53.91678,
            40.035672
          ],
          [
            14.253005,
            53.916578,
            39.949781
          ],
          [
            14.253109,
            53.916411,
            39.872491
          ],
          [
            14.253164,
            53.916191,
            39.774931
          ],
          [
            14.253441,
            53.915978,
            39.291336
          ],
          [
            14.253653,
            53.915803,
            38.897167
          ],
          [
            14.253869,
            53.915561,
            38.396056
          ],
          [
            14.254113,
            53.915342,
            37.915845
          ],
          [
            14.254383,
            53.915143,
            37.448976
          ],
          [
            14.254579,
            53.914992,
            37.100243
          ],
          [
            14.254782,
            53.914813,
            36.704924
          ],
          [
            14.25498,
            53.914634,
            36.321983
          ],
          [
            14.255159,
            53.914466,
            35.978669
          ],
          [
            14.255331,
            53.914245,
            35.559299
          ],
          [
            14.25518,
            53.914042,
            35.162047
          ],
          [
            14.25492,
            53.9139,
            34.796212
          ],
          [
            14.254592,
            53.913736,
            34.359061
          ],
          [
            14.254327,
            53.913599,
            34.000512
          ],
          [
            14.25403,
            53.913469,
            33.624536
          ],
          [
            14.254011,
            53.913289,
            33.585131
          ],
          [
            14.254145,
            53.913107,
            34.32175
          ],
          [
            14.254288,
            53.912892,
            35.175781
          ],
          [
            14.254291,
            53.912663,
            36.030674
          ],
          [
            14.254197,
            53.912414,
            36.975685
          ],
          [
            14.254261,
            53.91222,
            37.773664
          ],
          [
            14.254249,
            53.912088,
            38.509299
          ],
          [
            14.254141,
            53.911906,
            39.306982
          ],
          [
            14.25436,
            53.911699,
            40.203777
          ],
          [
            14.254596,
            53.911514,
            41.034217
          ],
          [
            14.254291,
            53.911526,
            41.85839
          ],
          [
            14.253878,
            53.911575,
            42.751812
          ],
          [
            14.253533,
            53.9116,
            43.486751
          ],
          [
            14.25311,
            53.911633,
            44.390972
          ],
          [
            14.252706,
            53.911621,
            45.246108
          ],
          [
            14.252335,
            53.91163,
            46.032538
          ],
          [
            14.251894,
            53.911657,
            46.128061
          ],
          [
            14.251559,
            53.911668,
            45.622618
          ],
          [
            14.251232,
            53.911674,
            45.129781
          ],
          [
            14.250906,
            53.91169,
            44.636996
          ],
          [
            14.250592,
            53.911718,
            44.158366
          ],
          [
            14.250252,
            53.911701,
            43.643729
          ],
          [
            14.249832,
            53.91171,
            43.003531
          ],
          [
            14.249664,
            53.911511,
            42.427427
          ],
          [
            14.249605,
            53.911252,
            41.940856
          ],
          [
            14.249571,
            53.91107,
            42.180642
          ],
          [
            14.249518,
            53.910825,
            42.504079
          ],
          [
            14.249442,
            53.910622,
            42.777758
          ],
          [
            14.249327,
            53.910445,
            43.030467
          ],
          [
            14.249317,
            53.910233,
            43.308232
          ],
          [
            14.249322,
            53.910029,
            43.576514
          ],
          [
            14.249302,
            53.909999,
            43.871094
          ],
          [
            14.24929,
            53.910251,
            44.204422
          ],
          [
            14.249379,
            53.910451,
            43.363893
          ],
          [
            14.249422,
            53.910697,
            42.22632
          ],
          [
            14.249492,
            53.91095,
            41.053129
          ],
          [
            14.249531,
            53.911166,
            40.060654
          ],
          [
            14.249592,
            53.91138,
            39.06923
          ],
          [
            14.249641,
            53.911595,
            38.077483
          ],
          [
            14.249728,
            53.911804,
            37.094606
          ],
          [
            14.249782,
            53.912016,
            36.114954
          ],
          [
            14.249809,
            53.912228,
            36.112614
          ],
          [
            14.249819,
            53.912474,
            36.231541
          ],
          [
            14.249838,
            53.912686,
            36.334163
          ],
          [
            14.249889,
            53.912892,
            36.434863
          ],
          [
            14.249942,
            53.913098,
            36.535558
          ],
          [
            14.249956,
            53.913327,
            36.646663
          ],
          [
            14.249968,
            53.91355,
            36.754574
          ],
          [
            14.249922,
            53.913763,
            36.858393
          ],
          [
            14.249878,
            53.914006,
            37.007499
          ],
          [
            14.249846,
            53.914235,
            37.157848
          ],
          [
            14.249815,
            53.914445,
            37.295865
          ],
          [
            14.249757,
            53.914689,
            37.457128
          ],
          [
            14.249719,
            53.914881,
            37.583723
          ],
          [
            14.249675,
            53.915085,
            37.718288
          ],
          [
            14.249644,
            53.915317,
            37.870569
          ],
          [
            14.249621,
            53.915554,
            38.02606
          ],
          [
            14.249564,
            53.91576,
            37.635148
          ],
          [
            14.249507,
            53.916007,
            36.908225
          ],
          [
            14.249455,
            53.916224,
            36.269321
          ],
          [
            14.24937,
            53.916429,
            35.654107
          ],
          [
            14.249358,
            53.916636,
            35.050043
          ],
          [
            14.249363,
            53.916858,
            34.401082
          ],
          [
            14.249298,
            53.917098,
            33.692338
          ],
          [
            14.249273,
            53.91728,
            33.159666
          ],
          [
            14.249336,
            53.917475,
            33.073981
          ],
          [
            14.249454,
            53.917668,
            33.688999
          ],
          [
            14.249609,
            53.917876,
            34.371616
          ],
          [
            14.249715,
            53.918068,
            34.977053
          ],
          [
            14.249878,
            53.918263,
            35.643506
          ],
          [
            14.250202,
            53.918337,
            36.261215
          ],
          [
            14.250558,
            53.918282,
            36.919292
          ],
          [
            14.250913,
            53.918196,
            37.59691
          ],
          [
            14.25122,
            53.918147,
            38.16149
          ],
          [
            14.251551,
            53.918104,
            38.454877
          ],
          [
            14.251904,
            53.918002,
            38.76144
          ],
          [
            14.252238,
            53.917942,
            39.033518
          ],
          [
            14.252575,
            53.91788,
            39.308826
          ],
          [
            14.252916,
            53.917836,
            39.580708
          ],
          [
            14.253245,
            53.917783,
            39.846359
          ],
          [
            14.253554,
            53.917722,
            40.100189
          ],
          [
            14.253939,
            53.917649,
            40.415195
          ],
          [
            14.254273,
            53.917566,
            40.48477
          ],
          [
            14.25461,
            53.917497,
            40.205855
          ],
          [
            14.255001,
            53.917433,
            39.889065
          ],
          [
            14.255349,
            53.917383,
            39.608488
          ],
          [
            14.255747,
            53.917323,
            39.287252
          ],
          [
            14.256009,
            53.917206,
            39.014333
          ],
          [
            14.255908,
            53.916999,
            38.721145
          ],
          [
            14.255603,
            53.917047,
            38.472022
          ],
          [
            14.255274,
            53.917081,
            38.210958
          ],
          [
            14.255115,
            53.916996,
            38.208032
          ],
          [
            14.255196,
            53.916832,
            38.208032
          ],
          [
            14.255633,
            53.916826,
            38.208032
          ],
          [
            14.255997,
            53.916885,
            38.208032
          ],
          [
            14.255768,
            53.916834,
            38.208032
          ],
          [
            14.255778,
            53.916895,
            38.208032
          ]
        ]
      }
    }
  ]
}

let day34: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.258339,
            53.916766,
            45.409544
          ],
          [
            14.258428,
            53.916484,
            45.409544
          ],
          [
            14.25837,
            53.916294,
            45.409544
          ],
          [
            14.258275,
            53.916108,
            45.409544
          ],
          [
            14.258112,
            53.915904,
            45.400494
          ],
          [
            14.257998,
            53.915636,
            45.270642
          ],
          [
            14.257929,
            53.915453,
            45.182127
          ],
          [
            14.257847,
            53.915221,
            45.069969
          ],
          [
            14.257776,
            53.915023,
            44.974674
          ],
          [
            14.257704,
            53.914808,
            44.871648
          ],
          [
            14.257588,
            53.914624,
            44.77817
          ],
          [
            14.257483,
            53.914377,
            44.658502
          ],
          [
            14.257397,
            53.91415,
            44.564986
          ],
          [
            14.257305,
            53.913892,
            44.571269
          ],
          [
            14.257209,
            53.913653,
            44.577124
          ],
          [
            14.257138,
            53.913431,
            44.582531
          ],
          [
            14.257012,
            53.913211,
            44.588059
          ],
          [
            14.256917,
            53.91302,
            44.592802
          ],
          [
            14.256823,
            53.912831,
            44.597491
          ],
          [
            14.256747,
            53.912624,
            44.602551
          ],
          [
            14.256668,
            53.912395,
            44.636625
          ],
          [
            14.256577,
            53.912169,
            44.789185
          ],
          [
            14.256504,
            53.911948,
            44.937103
          ],
          [
            14.25642,
            53.911709,
            45.097415
          ],
          [
            14.256369,
            53.911447,
            45.270798
          ],
          [
            14.256282,
            53.911239,
            45.411725
          ],
          [
            14.256189,
            53.911028,
            45.554926
          ],
          [
            14.256091,
            53.910812,
            45.70182
          ],
          [
            14.255986,
            53.910614,
            45.93838
          ],
          [
            14.255815,
            53.910442,
            46.357233
          ],
          [
            14.25561,
            53.910308,
            46.741911
          ],
          [
            14.255783,
            53.910149,
            47.125117
          ],
          [
            14.255837,
            53.909986,
            47.527274
          ],
          [
            14.255737,
            53.909782,
            47.948989
          ],
          [
            14.255665,
            53.909575,
            48.367538
          ],
          [
            14.255555,
            53.909374,
            48.786001
          ],
          [
            14.255468,
            53.909179,
            49.185863
          ],
          [
            14.2554,
            53.908966,
            48.931878
          ],
          [
            14.255413,
            53.908763,
            48.293511
          ],
          [
            14.255296,
            53.908583,
            47.68771
          ],
          [
            14.255212,
            53.908404,
            47.102245
          ],
          [
            14.255138,
            53.908221,
            46.507772
          ],
          [
            14.255071,
            53.908035,
            45.910257
          ],
          [
            14.255004,
            53.907831,
            45.256827
          ],
          [
            14.25503,
            53.907636,
            44.605858
          ],
          [
            14.255431,
            53.907645,
            43.858662
          ],
          [
            14.255714,
            53.907558,
            43.127838
          ],
          [
            14.255929,
            53.907433,
            42.329533
          ],
          [
            14.255895,
            53.907413,
            41.533811
          ],
          [
            14.255607,
            53.907371,
            40.789556
          ],
          [
            14.255942,
            53.907383,
            39.986201
          ],
          [
            14.25626,
            53.907306,
            39.208177
          ],
          [
            14.256582,
            53.907262,
            38.460101
          ],
          [
            14.256885,
            53.907267,
            37.752688
          ],
          [
            14.257203,
            53.907264,
            37.020614
          ],
          [
            14.257485,
            53.907199,
            36.476413
          ],
          [
            14.257773,
            53.907127,
            36.007749
          ],
          [
            14.258076,
            53.907061,
            35.526794
          ],
          [
            14.258329,
            53.906953,
            35.062954
          ],
          [
            14.258588,
            53.906824,
            34.559676
          ],
          [
            14.258832,
            53.906713,
            34.101845
          ],
          [
            14.259108,
            53.906598,
            33.599324
          ],
          [
            14.259399,
            53.906497,
            33.097062
          ],
          [
            14.25973,
            53.906408,
            32.557266
          ],
          [
            14.260013,
            53.906308,
            32.097235
          ],
          [
            14.260328,
            53.906238,
            31.673505
          ],
          [
            14.260633,
            53.906159,
            31.254913
          ],
          [
            14.260962,
            53.906093,
            30.817742
          ],
          [
            14.261295,
            53.90605,
            30.389519
          ],
          [
            14.261628,
            53.906026,
            29.967986
          ],
          [
            14.261963,
            53.905996,
            29.54211
          ],
          [
            14.262314,
            53.905983,
            29.10029
          ],
          [
            14.262632,
            53.905992,
            28.699648
          ],
          [
            14.263003,
            53.905994,
            28.501218
          ],
          [
            14.26337,
            53.905988,
            28.683482
          ],
          [
            14.263708,
            53.905963,
            28.852705
          ],
          [
            14.264032,
            53.905924,
            29.017042
          ],
          [
            14.264356,
            53.905897,
            29.17956
          ],
          [
            14.264669,
            53.905872,
            29.336409
          ],
          [
            14.264993,
            53.90584,
            29.49955
          ],
          [
            14.265313,
            53.905788,
            29.664367
          ],
          [
            14.265621,
            53.905749,
            29.821909
          ],
          [
            14.265934,
            53.905714,
            30.276277
          ],
          [
            14.26626,
            53.905686,
            31.642672
          ],
          [
            14.266561,
            53.905632,
            32.952756
          ],
          [
            14.267006,
            53.905622,
            34.803715
          ],
          [
            14.267298,
            53.90555,
            36.121863
          ],
          [
            14.267616,
            53.905576,
            37.502894
          ],
          [
            14.267935,
            53.905557,
            38.841605
          ],
          [
            14.2682,
            53.905694,
            40.306258
          ],
          [
            14.268426,
            53.905836,
            41.679345
          ],
          [
            14.268664,
            53.905997,
            42.555253
          ],
          [
            14.268984,
            53.906038,
            42.445194
          ],
          [
            14.26922,
            53.905919,
            42.336065
          ],
          [
            14.269351,
            53.905739,
            42.225139
          ],
          [
            14.269488,
            53.905572,
            42.12031
          ],
          [
            14.269634,
            53.905388,
            42.005545
          ],
          [
            14.269784,
            53.9052,
            41.888172
          ],
          [
            14.269955,
            53.905046,
            41.784177
          ],
          [
            14.270176,
            53.904891,
            41.66846
          ],
          [
            14.270472,
            53.904784,
            41.597879
          ],
          [
            14.270656,
            53.904636,
            41.626522
          ],
          [
            14.270951,
            53.904525,
            41.658799
          ],
          [
            14.27126,
            53.904418,
            41.691845
          ],
          [
            14.271556,
            53.904337,
            41.721842
          ],
          [
            14.271857,
            53.904282,
            41.750803
          ],
          [
            14.272211,
            53.904201,
            41.785713
          ],
          [
            14.27253,
            53.904165,
            41.815675
          ],
          [
            14.272855,
            53.90417,
            41.845554
          ],
          [
            14.27319,
            53.904215,
            41.705937
          ],
          [
            14.273503,
            53.904276,
            41.278648
          ],
          [
            14.273848,
            53.904294,
            40.832358
          ],
          [
            14.274183,
            53.904324,
            40.396033
          ],
          [
            14.274504,
            53.904373,
            39.9688
          ],
          [
            14.274895,
            53.904401,
            39.461421
          ],
          [
            14.275219,
            53.904448,
            39.031027
          ],
          [
            14.275589,
            53.90449,
            38.542469
          ],
          [
            14.275881,
            53.904419,
            38.080123
          ],
          [
            14.276169,
            53.904404,
            37.947267
          ],
          [
            14.276486,
            53.904446,
            37.963322
          ],
          [
            14.276848,
            53.904518,
            37.982202
          ],
          [
            14.277186,
            53.904545,
            37.999
          ],
          [
            14.277533,
            53.904596,
            38.016617
          ],
          [
            14.277893,
            53.904623,
            38.034483
          ],
          [
            14.278242,
            53.904658,
            38.051949
          ],
          [
            14.278591,
            53.904689,
            38.069852
          ],
          [
            14.278935,
            53.904747,
            38.087245
          ],
          [
            14.279319,
            53.904804,
            38.091722
          ],
          [
            14.279723,
            53.904861,
            38.096419
          ],
          [
            14.280153,
            53.904915,
            38.101389
          ],
          [
            14.280574,
            53.904974,
            38.106281
          ],
          [
            14.280984,
            53.905023,
            38.11101
          ],
          [
            14.281355,
            53.90508,
            38.115355
          ],
          [
            14.281712,
            53.905123,
            38.119475
          ],
          [
            14.28209,
            53.905171,
            38.314943
          ],
          [
            14.282477,
            53.905211,
            38.712097
          ],
          [
            14.282854,
            53.905249,
            39.098798
          ],
          [
            14.283213,
            53.905311,
            39.476969
          ],
          [
            14.283596,
            53.905353,
            39.870975
          ],
          [
            14.28394,
            53.905397,
            40.226964
          ],
          [
            14.284271,
            53.905456,
            40.578261
          ],
          [
            14.284624,
            53.905505,
            40.944839
          ],
          [
            14.28494,
            53.905559,
            41.154051
          ],
          [
            14.285269,
            53.905593,
            40.903649
          ],
          [
            14.285654,
            53.905632,
            40.610802
          ],
          [
            14.286033,
            53.905688,
            40.317793
          ],
          [
            14.286414,
            53.905725,
            40.027637
          ],
          [
            14.286835,
            53.905746,
            39.710331
          ],
          [
            14.287242,
            53.905764,
            39.404057
          ],
          [
            14.28767,
            53.905756,
            39.083042
          ],
          [
            14.288103,
            53.905737,
            38.868335
          ],
          [
            14.288532,
            53.905679,
            38.764948
          ],
          [
            14.28893,
            53.905632,
            38.66958
          ],
          [
            14.289331,
            53.905562,
            38.571228
          ],
          [
            14.289702,
            53.905443,
            38.471922
          ],
          [
            14.29011,
            53.905361,
            38.370668
          ],
          [
            14.29045,
            53.905246,
            38.278598
          ],
          [
            14.290841,
            53.905131,
            38.324462
          ],
          [
            14.291208,
            53.904991,
            38.807724
          ],
          [
            14.291547,
            53.904841,
            39.275347
          ],
          [
            14.29189,
            53.904687,
            39.751205
          ],
          [
            14.292164,
            53.904533,
            40.16954
          ],
          [
            14.292464,
            53.904359,
            40.634722
          ],
          [
            14.29277,
            53.904189,
            41.098647
          ],
          [
            14.293059,
            53.904043,
            41.51868
          ],
          [
            14.293316,
            53.903889,
            41.767215
          ],
          [
            14.293569,
            53.903755,
            41.977253
          ],
          [
            14.293819,
            53.903605,
            42.197825
          ],
          [
            14.294097,
            53.903468,
            42.421567
          ],
          [
            14.294414,
            53.903305,
            42.681563
          ],
          [
            14.294705,
            53.903136,
            42.933774
          ],
          [
            14.29499,
            53.90298,
            43.173856
          ],
          [
            14.295267,
            53.902827,
            43.408193
          ],
          [
            14.295557,
            53.902704,
            43.4685
          ],
          [
            14.295807,
            53.902549,
            43.487749
          ],
          [
            14.296101,
            53.902394,
            43.508664
          ],
          [
            14.296357,
            53.902241,
            43.528032
          ],
          [
            14.296667,
            53.902073,
            43.550365
          ],
          [
            14.296931,
            53.901923,
            43.569941
          ],
          [
            14.297212,
            53.901796,
            43.588719
          ],
          [
            14.297469,
            53.901642,
            43.608185
          ],
          [
            14.297747,
            53.901499,
            44.068427
          ],
          [
            14.297861,
            53.901314,
            44.746968
          ],
          [
            14.297623,
            53.901152,
            45.449124
          ],
          [
            14.297303,
            53.901061,
            46.133311
          ],
          [
            14.296952,
            53.90105,
            46.814733
          ],
          [
            14.296637,
            53.901098,
            47.44517
          ],
          [
            14.296518,
            53.901284,
            48.143796
          ],
          [
            14.296608,
            53.901503,
            48.880255
          ],
          [
            14.296656,
            53.901682,
            49.472611
          ],
          [
            14.296706,
            53.901891,
            49.140958
          ],
          [
            14.296777,
            53.902094,
            48.784245
          ],
          [
            14.296828,
            53.90228,
            48.459985
          ],
          [
            14.296884,
            53.902463,
            48.139924
          ],
          [
            14.296941,
            53.902668,
            47.782387
          ],
          [
            14.297016,
            53.902892,
            47.389452
          ],
          [
            14.297107,
            53.903151,
            46.934259
          ],
          [
            14.297197,
            53.903403,
            46.490888
          ],
          [
            14.297283,
            53.903614,
            46.125705
          ],
          [
            14.297364,
            53.90382,
            45.772659
          ],
          [
            14.297446,
            53.904043,
            45.391713
          ],
          [
            14.297502,
            53.904304,
            44.952481
          ],
          [
            14.297547,
            53.904488,
            44.642014
          ],
          [
            14.297641,
            53.904678,
            44.311408
          ],
          [
            14.297723,
            53.904877,
            43.969501
          ],
          [
            14.297769,
            53.905081,
            43.625879
          ],
          [
            14.297819,
            53.905271,
            43.206814
          ],
          [
            14.297878,
            53.905466,
            42.508534
          ],
          [
            14.297952,
            53.905663,
            41.804189
          ],
          [
            14.298054,
            53.905929,
            40.852901
          ],
          [
            14.298129,
            53.906122,
            40.162391
          ],
          [
            14.298236,
            53.906347,
            39.345952
          ],
          [
            14.298321,
            53.906527,
            38.693319
          ],
          [
            14.298376,
            53.906755,
            37.890137
          ],
          [
            14.298424,
            53.906945,
            37.220056
          ],
          [
            14.298483,
            53.907131,
            37.399634
          ],
          [
            14.298554,
            53.907362,
            37.803177
          ],
          [
            14.298627,
            53.907589,
            38.200403
          ],
          [
            14.298713,
            53.90782,
            38.606603
          ],
          [
            14.298775,
            53.908013,
            38.944013
          ],
          [
            14.29883,
            53.9082,
            39.270794
          ],
          [
            14.298918,
            53.908415,
            39.65114
          ],
          [
            14.298998,
            53.908662,
            40.084084
          ],
          [
            14.299081,
            53.908917,
            40.317205
          ],
          [
            14.299125,
            53.909098,
            40.421344
          ],
          [
            14.299165,
            53.909302,
            40.538404
          ],
          [
            14.299238,
            53.909537,
            40.674569
          ],
          [
            14.2993,
            53.909746,
            40.795505
          ],
          [
            14.29935,
            53.909973,
            40.92601
          ],
          [
            14.299419,
            53.910234,
            41.076757
          ],
          [
            14.299515,
            53.910413,
            41.184618
          ],
          [
            14.299592,
            53.910644,
            41.095164
          ],
          [
            14.299656,
            53.910865,
            40.877328
          ],
          [
            14.299732,
            53.911044,
            40.69756
          ],
          [
            14.299823,
            53.91126,
            40.481739
          ],
          [
            14.299912,
            53.911498,
            40.245357
          ],
          [
            14.299971,
            53.911735,
            40.01305
          ],
          [
            14.300048,
            53.911984,
            39.76761
          ],
          [
            14.300098,
            53.912164,
            39.590716
          ],
          [
            14.300254,
            53.912348,
            39.635308
          ],
          [
            14.300658,
            53.912278,
            39.960677
          ],
          [
            14.300975,
            53.912174,
            40.241497
          ],
          [
            14.301236,
            53.912046,
            40.50267
          ],
          [
            14.301535,
            53.911959,
            40.759237
          ],
          [
            14.301859,
            53.911911,
            41.016015
          ],
          [
            14.302179,
            53.911853,
            41.273891
          ],
          [
            14.302513,
            53.911813,
            41.535851
          ],
          [
            14.302811,
            53.911752,
            41.77837
          ],
          [
            14.303177,
            53.911708,
            41.373198
          ],
          [
            14.303518,
            53.911653,
            40.818011
          ],
          [
            14.30386,
            53.911594,
            40.256394
          ],
          [
            14.304197,
            53.911531,
            39.701209
          ],
          [
            14.304561,
            53.911518,
            39.12797
          ],
          [
            14.304842,
            53.911388,
            38.566309
          ],
          [
            14.305198,
            53.911289,
            37.94412
          ],
          [
            14.305556,
            53.911254,
            37.374217
          ],
          [
            14.305885,
            53.911213,
            36.966058
          ],
          [
            14.306189,
            53.911066,
            36.723544
          ],
          [
            14.306497,
            53.910972,
            36.509527
          ],
          [
            14.306805,
            53.910874,
            36.292645
          ],
          [
            14.307132,
            53.910799,
            36.076128
          ],
          [
            14.307467,
            53.910722,
            35.853849
          ],
          [
            14.307771,
            53.910636,
            35.64592
          ],
          [
            14.308128,
            53.910577,
            35.416258
          ],
          [
            14.308448,
            53.910536,
            35.214116
          ],
          [
            14.308938,
            53.910469,
            35.333497
          ],
          [
            14.309235,
            53.910407,
            35.461476
          ],
          [
            14.309567,
            53.910318,
            35.611104
          ],
          [
            14.309908,
            53.910222,
            35.76426
          ],
          [
            14.310246,
            53.910159,
            35.90811
          ],
          [
            14.310607,
            53.910135,
            36.056297
          ],
          [
            14.310954,
            53.910099,
            36.198846
          ],
          [
            14.311298,
            53.910079,
            36.340097
          ],
          [
            14.311656,
            53.910032,
            36.12036
          ],
          [
            14.311988,
            53.909965,
            35.6991
          ],
          [
            14.312321,
            53.909888,
            35.270063
          ],
          [
            14.312633,
            53.909799,
            34.850801
          ],
          [
            14.312972,
            53.90967,
            34.367324
          ],
          [
            14.313257,
            53.909575,
            33.974549
          ],
          [
            14.313579,
            53.909497,
            33.556299
          ],
          [
            14.313898,
            53.909431,
            33.149793
          ],
          [
            14.314279,
            53.909377,
            32.852661
          ],
          [
            14.31459,
            53.909321,
            33.603505
          ],
          [
            14.314888,
            53.909239,
            34.361673
          ],
          [
            14.31519,
            53.909136,
            35.166352
          ],
          [
            14.31555,
            53.909045,
            36.0693
          ],
          [
            14.315841,
            53.908972,
            36.798449
          ],
          [
            14.316144,
            53.90892,
            37.525914
          ],
          [
            14.316477,
            53.90885,
            38.341962
          ],
          [
            14.316738,
            53.908744,
            39.072811
          ],
          [
            14.316986,
            53.90859,
            39.805008
          ],
          [
            14.317187,
            53.908432,
            39.975083
          ],
          [
            14.317469,
            53.908324,
            40.149791
          ],
          [
            14.317768,
            53.908237,
            40.319042
          ],
          [
            14.318047,
            53.908097,
            40.505583
          ],
          [
            14.318322,
            53.907983,
            40.676065
          ],
          [
            14.318601,
            53.907867,
            40.849794
          ],
          [
            14.318897,
            53.90775,
            41.030807
          ],
          [
            14.319173,
            53.907668,
            41.187508
          ],
          [
            14.319484,
            53.907573,
            41.018436
          ],
          [
            14.319806,
            53.907486,
            39.674833
          ],
          [
            14.320118,
            53.907408,
            38.391042
          ],
          [
            14.320487,
            53.907378,
            36.978772
          ],
          [
            14.32078,
            53.907325,
            35.817621
          ],
          [
            14.321051,
            53.907205,
            34.5312
          ],
          [
            14.321363,
            53.907127,
            33.233029
          ],
          [
            14.321709,
            53.907134,
            31.913629
          ],
          [
            14.32203,
            53.907096,
            30.663369
          ],
          [
            14.32234,
            53.90707,
            29.593782
          ],
          [
            14.322669,
            53.907068,
            28.860946
          ],
          [
            14.323013,
            53.907061,
            28.088792
          ],
          [
            14.323376,
            53.90705,
            27.279165
          ],
          [
            14.323681,
            53.906931,
            26.46263
          ],
          [
            14.323978,
            53.906852,
            25.734935
          ],
          [
            14.3243,
            53.906834,
            25.011393
          ],
          [
            14.324635,
            53.906942,
            24.160421
          ],
          [
            14.324955,
            53.906989,
            23.422363
          ],
          [
            14.325283,
            53.907026,
            23.165581
          ],
          [
            14.325619,
            53.907045,
            23.711327
          ],
          [
            14.325983,
            53.907057,
            24.298825
          ],
          [
            14.326316,
            53.906998,
            24.858245
          ],
          [
            14.32666,
            53.906915,
            25.457226
          ],
          [
            14.326999,
            53.906825,
            26.055156
          ],
          [
            14.327211,
            53.906691,
            26.555237
          ],
          [
            14.32748,
            53.90653,
            27.174275
          ],
          [
            14.327759,
            53.906419,
            27.717726
          ],
          [
            14.328037,
            53.9063,
            28.492936
          ],
          [
            14.3283,
            53.90616,
            29.38093
          ],
          [
            14.3286,
            53.906023,
            30.331041
          ],
          [
            14.328842,
            53.905899,
            31.134316
          ],
          [
            14.32911,
            53.905777,
            31.982512
          ],
          [
            14.32941,
            53.905661,
            32.893334
          ],
          [
            14.329766,
            53.905563,
            33.877451
          ],
          [
            14.330102,
            53.905453,
            34.839563
          ],
          [
            14.330368,
            53.905349,
            35.638553
          ],
          [
            14.330612,
            53.905206,
            36.467477
          ],
          [
            14.330815,
            53.90502,
            37.375433
          ],
          [
            14.330902,
            53.904822,
            38.213426
          ],
          [
            14.33094,
            53.904633,
            38.99463
          ],
          [
            14.331043,
            53.904425,
            39.883661
          ],
          [
            14.33122,
            53.904261,
            40.678173
          ],
          [
            14.331418,
            53.90412,
            41.426545
          ],
          [
            14.33169,
            53.903998,
            42.263186
          ],
          [
            14.33193,
            53.903863,
            42.839856
          ],
          [
            14.332123,
            53.903699,
            42.742176
          ],
          [
            14.332287,
            53.903515,
            42.64075
          ],
          [
            14.332482,
            53.903312,
            42.526813
          ],
          [
            14.332619,
            53.903108,
            42.419553
          ],
          [
            14.332781,
            53.902911,
            42.312588
          ],
          [
            14.332858,
            53.902721,
            42.217281
          ],
          [
            14.332968,
            53.902544,
            42.125183
          ],
          [
            14.333162,
            53.902382,
            42.026803
          ],
          [
            14.333299,
            53.902216,
            41.901671
          ],
          [
            14.333404,
            53.901962,
            41.684679
          ],
          [
            14.333285,
            53.901779,
            41.522043
          ],
          [
            14.333138,
            53.901591,
            41.351508
          ],
          [
            14.333005,
            53.901398,
            41.17929
          ],
          [
            14.332894,
            53.901208,
            41.013533
          ],
          [
            14.332682,
            53.901078,
            40.856169
          ],
          [
            14.332551,
            53.900892,
            40.690083
          ],
          [
            14.332451,
            53.900692,
            40.518028
          ],
          [
            14.332333,
            53.900486,
            40.505121
          ],
          [
            14.332289,
            53.900293,
            40.504704
          ],
          [
            14.332262,
            53.900081,
            40.504248
          ],
          [
            14.332447,
            53.899981,
            40.50381
          ],
          [
            14.332764,
            53.900057,
            40.503377
          ],
          [
            14.333063,
            53.900114,
            40.502977
          ],
          [
            14.333388,
            53.900195,
            40.502531
          ],
          [
            14.333748,
            53.900295,
            40.502027
          ],
          [
            14.334126,
            53.900335,
            40.591416
          ],
          [
            14.334445,
            53.900378,
            40.825508
          ],
          [
            14.334728,
            53.900474,
            41.059079
          ],
          [
            14.335038,
            53.900519,
            41.287887
          ],
          [
            14.335365,
            53.90055,
            41.526283
          ],
          [
            14.335713,
            53.90055,
            41.775907
          ],
          [
            14.336032,
            53.900593,
            42.011358
          ],
          [
            14.336369,
            53.900643,
            42.260265
          ],
          [
            14.336698,
            53.900705,
            42.50728
          ],
          [
            14.337027,
            53.900695,
            42.755696
          ],
          [
            14.337363,
            53.900727,
            43.037927
          ],
          [
            14.337702,
            53.900798,
            43.336228
          ],
          [
            14.338024,
            53.90089,
            43.632961
          ],
          [
            14.338345,
            53.900985,
            43.930894
          ],
          [
            14.338674,
            53.901061,
            44.22383
          ],
          [
            14.339018,
            53.901146,
            44.533312
          ],
          [
            14.339378,
            53.901232,
            44.855425
          ],
          [
            14.33969,
            53.901376,
            45.184881
          ],
          [
            14.340044,
            53.901422,
            44.003241
          ],
          [
            14.340366,
            53.901498,
            42.717178
          ],
          [
            14.34073,
            53.901594,
            41.263946
          ],
          [
            14.341069,
            53.901666,
            39.948692
          ],
          [
            14.341467,
            53.901718,
            38.45844
          ],
          [
            14.341798,
            53.901732,
            37.241919
          ],
          [
            14.342171,
            53.901694,
            35.86196
          ],
          [
            14.342569,
            53.901723,
            34.399474
          ],
          [
            14.343037,
            53.901709,
            33.944949
          ],
          [
            14.343462,
            53.901747,
            33.780606
          ],
          [
            14.34388,
            53.901843,
            33.609573
          ],
          [
            14.344248,
            53.901912,
            33.462467
          ],
          [
            14.344614,
            53.901935,
            33.321291
          ],
          [
            14.344969,
            53.902021,
            33.175301
          ],
          [
            14.345324,
            53.902093,
            33.032512
          ],
          [
            14.345681,
            53.902155,
            32.984078
          ],
          [
            14.346045,
            53.902229,
            33.182966
          ],
          [
            14.346376,
            53.902268,
            33.356852
          ],
          [
            14.346738,
            53.902358,
            33.559081
          ],
          [
            14.347055,
            53.902438,
            33.73656
          ],
          [
            14.347324,
            53.902543,
            33.902687
          ],
          [
            14.347618,
            53.902634,
            34.074179
          ],
          [
            14.347945,
            53.902727,
            34.261606
          ],
          [
            14.34831,
            53.902786,
            34.45644
          ],
          [
            14.348632,
            53.902809,
            34.363445
          ],
          [
            14.349109,
            53.902915,
            34.06843
          ],
          [
            14.349442,
            53.902974,
            33.866689
          ],
          [
            14.349826,
            53.903035,
            33.635335
          ],
          [
            14.350122,
            53.903095,
            33.45432
          ],
          [
            14.350439,
            53.903083,
            33.27065
          ],
          [
            14.350736,
            53.903151,
            33.086127
          ],
          [
            14.351148,
            53.903156,
            32.847429
          ],
          [
            14.351558,
            53.903231,
            32.922999
          ],
          [
            14.351868,
            53.903337,
            33.206377
          ],
          [
            14.352215,
            53.903419,
            33.502634
          ],
          [
            14.35254,
            53.903506,
            33.784515
          ],
          [
            14.352885,
            53.903617,
            34.095025
          ],
          [
            14.353223,
            53.903728,
            34.400611
          ],
          [
            14.353563,
            53.903812,
            34.692079
          ],
          [
            14.353723,
            53.903874,
            34.941115
          ],
          [
            14.353852,
            53.903636,
            35.130866
          ],
          [
            14.354124,
            53.903511,
            35.101349
          ],
          [
            14.354449,
            53.903487,
            35.073099
          ],
          [
            14.354866,
            53.903439,
            35.036562
          ],
          [
            14.355138,
            53.903318,
            35.007254
          ],
          [
            14.355351,
            53.903166,
            34.978353
          ],
          [
            14.35565,
            53.903118,
            34.950554
          ],
          [
            14.356018,
            53.90309,
            34.918822
          ],
          [
            14.356322,
            53.902981,
            34.888215
          ],
          [
            14.356642,
            53.90287,
            35.433123
          ],
          [
            14.356926,
            53.902743,
            36.004895
          ],
          [
            14.357261,
            53.902773,
            36.570274
          ],
          [
            14.357607,
            53.902878,
            37.195819
          ],
          [
            14.357934,
            53.902962,
            37.767792
          ],
          [
            14.358239,
            53.903006,
            38.272306
          ],
          [
            14.358591,
            53.903097,
            38.89223
          ],
          [
            14.358927,
            53.903183,
            39.481832
          ],
          [
            14.359253,
            53.903272,
            40.104008
          ],
          [
            14.359601,
            53.903363,
            40.81295
          ],
          [
            14.359934,
            53.903381,
            41.458696
          ],
          [
            14.360286,
            53.903498,
            42.21132
          ],
          [
            14.360709,
            53.903587,
            43.048391
          ],
          [
            14.36102,
            53.903668,
            43.681627
          ],
          [
            14.361441,
            53.903742,
            44.502581
          ],
          [
            14.361751,
            53.903817,
            45.129691
          ],
          [
            14.362075,
            53.903922,
            44.856131
          ],
          [
            14.362375,
            53.903986,
            43.842288
          ],
          [
            14.362749,
            53.904047,
            42.613278
          ],
          [
            14.363049,
            53.904111,
            41.600185
          ],
          [
            14.363388,
            53.904204,
            40.387938
          ],
          [
            14.363731,
            53.90428,
            39.22811
          ],
          [
            14.364086,
            53.904343,
            38.053567
          ],
          [
            14.364545,
            53.904439,
            36.510869
          ],
          [
            14.364872,
            53.904504,
            35.819716
          ],
          [
            14.36519,
            53.904579,
            35.867621
          ],
          [
            14.365475,
            53.904694,
            35.91609
          ],
          [
            14.365829,
            53.904751,
            35.967816
          ],
          [
            14.366196,
            53.904795,
            36.020174
          ],
          [
            14.366557,
            53.904911,
            36.077912
          ],
          [
            14.36683,
            53.90506,
            36.12996
          ],
          [
            14.367125,
            53.905223,
            36.18649
          ],
          [
            14.367444,
            53.905321,
            36.196036
          ],
          [
            14.367788,
            53.905424,
            35.951578
          ],
          [
            14.368182,
            53.905553,
            35.665089
          ],
          [
            14.368495,
            53.90567,
            35.429155
          ],
          [
            14.368808,
            53.905794,
            35.190295
          ],
          [
            14.369105,
            53.905883,
            34.978641
          ],
          [
            14.369459,
            53.905974,
            34.733647
          ],
          [
            14.369831,
            53.906039,
            34.487637
          ],
          [
            14.370143,
            53.906133,
            34.220445
          ],
          [
            14.370532,
            53.90623,
            33.556688
          ],
          [
            14.370894,
            53.906305,
            32.946893
          ],
          [
            14.371299,
            53.906426,
            32.232819
          ],
          [
            14.371671,
            53.906477,
            31.626217
          ],
          [
            14.372025,
            53.906479,
            31.034669
          ],
          [
            14.372372,
            53.906558,
            30.449817
          ],
          [
            14.372738,
            53.906663,
            29.796658
          ],
          [
            14.373037,
            53.906774,
            30.088132
          ],
          [
            14.373347,
            53.906845,
            31.277829
          ],
          [
            14.373717,
            53.906927,
            32.691027
          ],
          [
            14.374012,
            53.907046,
            33.969983
          ],
          [
            14.374296,
            53.907181,
            35.274472
          ],
          [
            14.374515,
            53.907363,
            36.629625
          ],
          [
            14.374665,
            53.907583,
            38.071464
          ],
          [
            14.374894,
            53.907761,
            39.426738
          ],
          [
            14.375086,
            53.907969,
            40.325122
          ],
          [
            14.375291,
            53.908145,
            40.07111
          ],
          [
            14.375553,
            53.908287,
            39.819432
          ],
          [
            14.375826,
            53.908437,
            39.557788
          ],
          [
            14.376181,
            53.908554,
            39.27028
          ],
          [
            14.376504,
            53.908657,
            39.012857
          ],
          [
            14.376847,
            53.908742,
            38.752052
          ],
          [
            14.377158,
            53.908845,
            38.501469
          ],
          [
            14.377447,
            53.908922,
            38.279175
          ],
          [
            14.377722,
            53.909004,
            38.417801
          ],
          [
            14.378078,
            53.909088,
            38.60133
          ],
          [
            14.378412,
            53.909136,
            38.76658
          ],
          [
            14.37877,
            53.909181,
            38.941734
          ],
          [
            14.379076,
            53.909217,
            39.091332
          ],
          [
            14.379399,
            53.909267,
            39.251074
          ],
          [
            14.379767,
            53.90936,
            39.442594
          ],
          [
            14.380129,
            53.909484,
            39.643338
          ],
          [
            14.380458,
            53.909577,
            39.873796
          ],
          [
            14.380793,
            53.909675,
            40.172499
          ],
          [
            14.381166,
            53.909802,
            40.520767
          ],
          [
            14.381476,
            53.909894,
            40.79744
          ],
          [
            14.381764,
            53.909954,
            41.042038
          ],
          [
            14.382084,
            53.910011,
            41.308718
          ],
          [
            14.382374,
            53.910091,
            41.563719
          ],
          [
            14.382666,
            53.910199,
            41.841995
          ],
          [
            14.382908,
            53.91034,
            42.113247
          ],
          [
            14.383154,
            53.91051,
            42.30221
          ],
          [
            14.383415,
            53.910678,
            42.470931
          ],
          [
            14.383651,
            53.910844,
            42.631221
          ],
          [
            14.38388,
            53.910988,
            42.777961
          ],
          [
            14.384091,
            53.911152,
            42.931097
          ],
          [
            14.384237,
            53.911334,
            43.080286
          ],
          [
            14.384452,
            53.911499,
            43.23531
          ],
          [
            14.384781,
            53.911642,
            43.413603
          ],
          [
            14.385116,
            53.911753,
            43.313274
          ],
          [
            14.385394,
            53.911847,
            43.00903
          ],
          [
            14.385663,
            53.91198,
            42.674969
          ],
          [
            14.385953,
            53.912084,
            42.352295
          ],
          [
            14.386266,
            53.912181,
            42.016131
          ],
          [
            14.386539,
            53.912318,
            41.675112
          ],
          [
            14.386784,
            53.912507,
            41.29192
          ],
          [
            14.387164,
            53.912606,
            40.895128
          ],
          [
            14.387562,
            53.912713,
            40.319496
          ],
          [
            14.387936,
            53.912828,
            39.386845
          ],
          [
            14.388311,
            53.912888,
            38.527579
          ],
          [
            14.388686,
            53.913011,
            37.577776
          ],
          [
            14.389096,
            53.913069,
            36.642966
          ],
          [
            14.389494,
            53.913074,
            35.763029
          ],
          [
            14.389812,
            53.913102,
            35.049727
          ],
          [
            14.390203,
            53.913132,
            34.170331
          ],
          [
            14.390604,
            53.913153,
            33.8893
          ],
          [
            14.390936,
            53.913208,
            33.938769
          ],
          [
            14.391318,
            53.913251,
            33.994488
          ],
          [
            14.391682,
            53.913351,
            34.052013
          ],
          [
            14.392034,
            53.913452,
            34.108032
          ],
          [
            14.392439,
            53.91353,
            34.168988
          ],
          [
            14.392818,
            53.913628,
            34.228292
          ],
          [
            14.393157,
            53.91374,
            34.283974
          ],
          [
            14.393446,
            53.913859,
            34.772843
          ],
          [
            14.393343,
            53.914064,
            35.329933
          ],
          [
            14.393242,
            53.91425,
            35.834533
          ],
          [
            14.393091,
            53.91441,
            36.317304
          ],
          [
            14.393005,
            53.914603,
            36.83823
          ],
          [
            14.392898,
            53.914783,
            37.333719
          ],
          [
            14.392722,
            53.915016,
            37.992705
          ],
          [
            14.392578,
            53.915186,
            38.489227
          ],
          [
            14.392568,
            53.91538,
            38.854515
          ],
          [
            14.392386,
            53.915525,
            38.265747
          ],
          [
            14.392465,
            53.915706,
            37.678072
          ],
          [
            14.3924,
            53.915508,
            37.07205
          ],
          [
            14.39267,
            53.915406,
            36.464866
          ],
          [
            14.392984,
            53.915498,
            35.846685
          ],
          [
            14.393249,
            53.915617,
            35.258803
          ],
          [
            14.393545,
            53.915688,
            34.680103
          ],
          [
            14.393864,
            53.915747,
            34.089047
          ],
          [
            14.394168,
            53.915823,
            33.548284
          ],
          [
            14.394484,
            53.915866,
            33.466946
          ],
          [
            14.394826,
            53.91594,
            33.375514
          ],
          [
            14.395119,
            53.916023,
            33.29349
          ],
          [
            14.395451,
            53.916093,
            33.205057
          ],
          [
            14.395791,
            53.916175,
            33.112815
          ],
          [
            14.3961,
            53.916257,
            33.027716
          ],
          [
            14.39642,
            53.916315,
            32.943628
          ],
          [
            14.396767,
            53.916377,
            32.852537
          ],
          [
            14.397129,
            53.916453,
            33.096897
          ],
          [
            14.397504,
            53.916504,
            33.98598
          ],
          [
            14.39781,
            53.916562,
            34.728773
          ],
          [
            14.398162,
            53.916665,
            35.636738
          ],
          [
            14.398497,
            53.916746,
            36.473462
          ],
          [
            14.398857,
            53.916859,
            37.415933
          ],
          [
            14.399236,
            53.916935,
            38.341186
          ],
          [
            14.399547,
            53.91703,
            39.161666
          ],
          [
            14.399912,
            53.917094,
            39.787085
          ],
          [
            14.400325,
            53.917189,
            39.501137
          ],
          [
            14.400679,
            53.91728,
            39.251398
          ],
          [
            14.401045,
            53.917373,
            38.99298
          ],
          [
            14.40143,
            53.917481,
            38.717823
          ],
          [
            14.401853,
            53.917555,
            38.432651
          ],
          [
            14.402134,
            53.917667,
            38.21384
          ],
          [
            14.402466,
            53.917778,
            37.967555
          ],
          [
            14.402814,
            53.917861,
            37.924979
          ],
          [
            14.403123,
            53.917914,
            37.996425
          ],
          [
            14.403412,
            53.918008,
            38.070163
          ],
          [
            14.403783,
            53.918081,
            38.157065
          ],
          [
            14.404163,
            53.918184,
            38.252543
          ],
          [
            14.404484,
            53.918264,
            38.330123
          ],
          [
            14.404792,
            53.918358,
            38.40718
          ],
          [
            14.405083,
            53.918434,
            38.477914
          ],
          [
            14.405429,
            53.918519,
            38.546363
          ],
          [
            14.405832,
            53.918596,
            38.497383
          ],
          [
            14.406207,
            53.918694,
            38.44978
          ],
          [
            14.406622,
            53.918783,
            38.398978
          ],
          [
            14.406992,
            53.918862,
            38.353773
          ],
          [
            14.407342,
            53.918943,
            38.309866
          ],
          [
            14.407654,
            53.919042,
            38.26909
          ],
          [
            14.407948,
            53.919114,
            38.232151
          ],
          [
            14.40834,
            53.919217,
            38.219009
          ],
          [
            14.408676,
            53.919322,
            38.262252
          ],
          [
            14.409023,
            53.919327,
            38.30217
          ],
          [
            14.409375,
            53.919426,
            38.34671
          ],
          [
            14.409714,
            53.919549,
            38.391994
          ],
          [
            14.410068,
            53.919622,
            38.434996
          ],
          [
            14.410462,
            53.919742,
            38.486692
          ],
          [
            14.41086,
            53.919841,
            38.535964
          ],
          [
            14.411226,
            53.919975,
            38.170047
          ],
          [
            14.411612,
            53.920062,
            37.67878
          ],
          [
            14.412025,
            53.920154,
            37.162048
          ],
          [
            14.412343,
            53.920226,
            36.76337
          ],
          [
            14.412676,
            53.9203,
            36.346022
          ],
          [
            14.413075,
            53.920437,
            35.804369
          ],
          [
            14.413435,
            53.920525,
            35.348182
          ],
          [
            14.413749,
            53.9206,
            34.953617
          ],
          [
            14.414115,
            53.920712,
            34.514727
          ],
          [
            14.414521,
            53.920781,
            34.062876
          ],
          [
            14.414906,
            53.920914,
            33.587216
          ],
          [
            14.415277,
            53.920981,
            33.162469
          ],
          [
            14.415629,
            53.921171,
            32.650455
          ],
          [
            14.416023,
            53.921286,
            32.181663
          ],
          [
            14.41643,
            53.921355,
            31.729352
          ],
          [
            14.416843,
            53.92147,
            32.313089
          ],
          [
            14.417198,
            53.921582,
            32.837377
          ],
          [
            14.417532,
            53.921671,
            33.313135
          ],
          [
            14.417894,
            53.921798,
            33.85989
          ],
          [
            14.41826,
            53.92189,
            34.376822
          ],
          [
            14.41865,
            53.921971,
            34.913398
          ],
          [
            14.419019,
            53.922108,
            35.479786
          ],
          [
            14.41941,
            53.922202,
            36.049697
          ],
          [
            14.419783,
            53.922286,
            36.597571
          ],
          [
            14.420102,
            53.922389,
            37.097825
          ],
          [
            14.420473,
            53.922487,
            37.657272
          ],
          [
            14.42079,
            53.922604,
            38.171272
          ],
          [
            14.421098,
            53.922709,
            38.659798
          ],
          [
            14.42145,
            53.922792,
            39.180119
          ],
          [
            14.421795,
            53.922863,
            39.687527
          ],
          [
            14.422143,
            53.922965,
            39.805919
          ],
          [
            14.422471,
            53.923062,
            39.701586
          ],
          [
            14.422837,
            53.92317,
            39.585562
          ],
          [
            14.423209,
            53.923278,
            39.466664
          ],
          [
            14.423634,
            53.923383,
            39.335912
          ],
          [
            14.423927,
            53.923449,
            39.246914
          ],
          [
            14.424246,
            53.923538,
            39.146464
          ],
          [
            14.424632,
            53.923646,
            39.023881
          ],
          [
            14.424959,
            53.92378,
            39.098369
          ],
          [
            14.425267,
            53.923874,
            39.180528
          ],
          [
            14.425617,
            53.923986,
            39.274734
          ],
          [
            14.425982,
            53.924076,
            39.3692
          ],
          [
            14.426279,
            53.924189,
            39.452904
          ],
          [
            14.426519,
            53.924113,
            39.527218
          ],
          [
            14.426672,
            53.92394,
            39.605641
          ],
          [
            14.426849,
            53.923757,
            39.690427
          ],
          [
            14.427194,
            53.923774,
            39.709826
          ],
          [
            14.427547,
            53.923821,
            39.659627
          ],
          [
            14.427877,
            53.923922,
            39.608984
          ],
          [
            14.428223,
            53.924083,
            39.548827
          ],
          [
            14.42857,
            53.924189,
            39.495596
          ],
          [
            14.428867,
            53.92428,
            39.449947
          ],
          [
            14.429238,
            53.924385,
            39.393865
          ],
          [
            14.429565,
            53.924461,
            39.34502
          ],
          [
            14.42996,
            53.924525,
            39.197061
          ],
          [
            14.4303,
            53.924594,
            38.994524
          ],
          [
            14.430626,
            53.924663,
            38.79938
          ],
          [
            14.430975,
            53.924729,
            38.592638
          ],
          [
            14.431309,
            53.924835,
            38.378972
          ],
          [
            14.431624,
            53.924955,
            38.167649
          ],
          [
            14.431968,
            53.925074,
            37.943161
          ],
          [
            14.432279,
            53.925181,
            37.740409
          ],
          [
            14.432641,
            53.92526,
            37.77002
          ],
          [
            14.432986,
            53.925326,
            38.219059
          ],
          [
            14.433365,
            53.92536,
            38.69395
          ],
          [
            14.43375,
            53.925385,
            39.174466
          ],
          [
            14.434075,
            53.92541,
            39.580222
          ],
          [
            14.434423,
            53.925535,
            40.085319
          ],
          [
            14.43472,
            53.925612,
            40.487202
          ],
          [
            14.435089,
            53.925713,
            40.990913
          ],
          [
            14.435383,
            53.925778,
            41.380377
          ],
          [
            14.435825,
            53.925827,
            40.800547
          ],
          [
            14.436197,
            53.925818,
            40.31923
          ],
          [
            14.436538,
            53.925752,
            39.855721
          ],
          [
            14.436774,
            53.925638,
            39.423572
          ],
          [
            14.43691,
            53.925461,
            38.957021
          ],
          [
            14.437186,
            53.925539,
            38.515349
          ],
          [
            14.437079,
            53.92563,
            38.08077
          ],
          [
            14.43676,
            53.925579,
            37.614857
          ],
          [
            14.436786,
            53.925365,
            37.424221
          ],
          [
            14.43674,
            53.925347,
            37.405773
          ],
          [
            14.436755,
            53.925141,
            37.385689
          ],
          [
            14.43663,
            53.924981,
            37.360855
          ],
          [
            14.436583,
            53.924781,
            37.341253
          ],
          [
            14.436675,
            53.924607,
            37.323481
          ],
          [
            14.436688,
            53.924409,
            37.303904
          ],
          [
            14.436645,
            53.924195,
            37.28293
          ],
          [
            14.436615,
            53.923976,
            37.269753
          ],
          [
            14.436555,
            53.923746,
            37.424291
          ],
          [
            14.436514,
            53.923549,
            37.556053
          ],
          [
            14.436492,
            53.923336,
            37.697756
          ],
          [
            14.436463,
            53.923111,
            37.847537
          ],
          [
            14.436425,
            53.922904,
            37.985712
          ],
          [
            14.436394,
            53.922665,
            38.144772
          ],
          [
            14.436366,
            53.922455,
            38.284555
          ],
          [
            14.436344,
            53.922248,
            38.422204
          ],
          [
            14.436323,
            53.922025,
            38.711061
          ],
          [
            14.436284,
            53.921777,
            39.079579
          ],
          [
            14.436242,
            53.921557,
            39.407131
          ],
          [
            14.436202,
            53.921342,
            39.727181
          ],
          [
            14.436121,
            53.921118,
            40.066033
          ],
          [
            14.436104,
            53.920892,
            40.40088
          ],
          [
            14.436068,
            53.920687,
            40.705821
          ],
          [
            14.436091,
            53.920481,
            41.011269
          ],
          [
            14.436066,
            53.920272,
            40.742097
          ],
          [
            14.436056,
            53.920057,
            40.156561
          ],
          [
            14.436056,
            53.91983,
            39.538635
          ],
          [
            14.436052,
            53.919598,
            38.907024
          ],
          [
            14.43603,
            53.919383,
            38.32056
          ],
          [
            14.435961,
            53.919192,
            37.786806
          ],
          [
            14.435928,
            53.918988,
            37.228993
          ],
          [
            14.435832,
            53.918796,
            36.684105
          ],
          [
            14.435746,
            53.918594,
            36.268714
          ],
          [
            14.435608,
            53.918386,
            36.542889
          ],
          [
            14.435519,
            53.918177,
            36.808577
          ],
          [
            14.435717,
            53.91801,
            37.065559
          ],
          [
            14.436057,
            53.917952,
            37.32164
          ],
          [
            14.436424,
            53.917907,
            37.59273
          ],
          [
            14.436746,
            53.917874,
            37.829471
          ],
          [
            14.437038,
            53.917916,
            38.058728
          ],
          [
            14.436967,
            53.917733,
            38.293634
          ],
          [
            14.43688,
            53.917553,
            38.46313
          ],
          [
            14.436783,
            53.917349,
            38.555754
          ],
          [
            14.436665,
            53.917135,
            38.654129
          ],
          [
            14.436527,
            53.916921,
            38.754251
          ],
          [
            14.436414,
            53.916741,
            38.838171
          ],
          [
            14.436301,
            53.916545,
            38.92867
          ],
          [
            14.436226,
            53.916359,
            39.012263
          ],
          [
            14.436141,
            53.916164,
            39.100772
          ],
          [
            14.436055,
            53.915965,
            39.190706
          ],
          [
            14.435954,
            53.915752,
            39.18436
          ],
          [
            14.435841,
            53.915555,
            39.14389
          ],
          [
            14.435715,
            53.915345,
            39.10056
          ],
          [
            14.435626,
            53.915124,
            39.056413
          ],
          [
            14.435511,
            53.914899,
            39.010746
          ],
          [
            14.43537,
            53.9147,
            38.968835
          ],
          [
            14.43524,
            53.914502,
            38.927484
          ],
          [
            14.435144,
            53.914306,
            38.88777
          ],
          [
            14.43503,
            53.914088,
            39.002812
          ],
          [
            14.434971,
            53.913867,
            39.257852
          ],
          [
            14.434844,
            53.91364,
            39.530641
          ],
          [
            14.43476,
            53.913429,
            39.777527
          ],
          [
            14.434677,
            53.913204,
            40.040204
          ],
          [
            14.434557,
            53.912982,
            40.30559
          ],
          [
            14.434419,
            53.912754,
            40.581864
          ],
          [
            14.434345,
            53.912526,
            40.847713
          ],
          [
            14.434255,
            53.912324,
            40.897104
          ],
          [
            14.434258,
            53.912124,
            40.871924
          ],
          [
            14.434308,
            53.911913,
            40.845866
          ],
          [
            14.434525,
            53.91177,
            40.822279
          ],
          [
            14.434755,
            53.911646,
            40.799941
          ],
          [
            14.434996,
            53.911525,
            40.777138
          ],
          [
            14.435273,
            53.911357,
            40.748653
          ],
          [
            14.435542,
            53.911228,
            40.723843
          ],
          [
            14.435809,
            53.911114,
            40.700197
          ],
          [
            14.436123,
            53.91096,
            40.606003
          ],
          [
            14.436426,
            53.910821,
            40.509962
          ],
          [
            14.436701,
            53.910678,
            40.418223
          ],
          [
            14.436979,
            53.910541,
            40.327562
          ],
          [
            14.437289,
            53.910383,
            40.224846
          ],
          [
            14.437539,
            53.910231,
            40.134097
          ],
          [
            14.43783,
            53.910072,
            40.034772
          ],
          [
            14.438028,
            53.909862,
            39.931079
          ],
          [
            14.438054,
            53.909636,
            39.794502
          ],
          [
            14.437935,
            53.909441,
            39.673054
          ],
          [
            14.437848,
            53.909219,
            39.539093
          ],
          [
            14.437756,
            53.909005,
            39.409648
          ],
          [
            14.4377,
            53.908801,
            39.288421
          ],
          [
            14.437665,
            53.908614,
            39.178144
          ],
          [
            14.437634,
            53.908382,
            39.041674
          ],
          [
            14.437601,
            53.908158,
            38.909878
          ],
          [
            14.437588,
            53.907957,
            39.08266
          ],
          [
            14.437566,
            53.907736,
            39.384926
          ],
          [
            14.437555,
            53.907517,
            39.685573
          ],
          [
            14.437653,
            53.907265,
            40.038526
          ],
          [
            14.437772,
            53.907031,
            40.372485
          ],
          [
            14.437863,
            53.906788,
            40.71259
          ],
          [
            14.43789,
            53.90657,
            41.011044
          ],
          [
            14.437861,
            53.906368,
            41.287828
          ],
          [
            14.437793,
            53.906136,
            41.336116
          ],
          [
            14.437738,
            53.905884,
            41.337805
          ],
          [
            14.437676,
            53.905695,
            41.339086
          ],
          [
            14.437594,
            53.905484,
            41.340525
          ],
          [
            14.437503,
            53.905278,
            41.341939
          ],
          [
            14.437431,
            53.905061,
            41.343408
          ],
          [
            14.43735,
            53.904872,
            41.344704
          ],
          [
            14.437303,
            53.90464,
            41.346261
          ],
          [
            14.437238,
            53.904454,
            41.45982
          ],
          [
            14.437147,
            53.904253,
            41.646019
          ],
          [
            14.437048,
            53.90405,
            41.835035
          ],
          [
            14.436974,
            53.90384,
            42.02676
          ],
          [
            14.436909,
            53.903631,
            42.216656
          ],
          [
            14.436875,
            53.903439,
            42.389271
          ],
          [
            14.436863,
            53.903243,
            42.564668
          ],
          [
            14.43681,
            53.903049,
            42.74028
          ],
          [
            14.436789,
            53.902775,
            42.875152
          ],
          [
            14.436721,
            53.902535,
            42.326741
          ],
          [
            14.436646,
            53.902322,
            41.836553
          ],
          [
            14.436582,
            53.902057,
            41.233255
          ],
          [
            14.436482,
            53.901838,
            40.722227
          ],
          [
            14.436429,
            53.901598,
            40.176879
          ],
          [
            14.436377,
            53.90137,
            39.657633
          ],
          [
            14.436467,
            53.901133,
            39.107476
          ],
          [
            14.436715,
            53.900955,
            38.837887
          ],
          [
            14.436926,
            53.900814,
            38.752011
          ],
          [
            14.437222,
            53.900624,
            38.63406
          ],
          [
            14.43742,
            53.90046,
            38.542114
          ],
          [
            14.437617,
            53.900297,
            38.449804
          ],
          [
            14.437747,
            53.900056,
            38.333913
          ],
          [
            14.437731,
            53.899844,
            38.236965
          ],
          [
            14.437716,
            53.899631,
            38.139574
          ],
          [
            14.437695,
            53.89944,
            38.241884
          ],
          [
            14.43768,
            53.899249,
            38.759964
          ],
          [
            14.437644,
            53.899036,
            39.338777
          ],
          [
            14.437658,
            53.89883,
            39.898009
          ],
          [
            14.43764,
            53.898614,
            40.482927
          ],
          [
            14.437659,
            53.898419,
            41.010916
          ],
          [
            14.437729,
            53.8982,
            41.61859
          ],
          [
            14.437745,
            53.897972,
            42.235637
          ],
          [
            14.437766,
            53.897743,
            42.856971
          ],
          [
            14.437749,
            53.897518,
            42.560172
          ],
          [
            14.437766,
            53.897328,
            42.197886
          ],
          [
            14.437758,
            53.89708,
            41.72415
          ],
          [
            14.437707,
            53.896829,
            41.242834
          ],
          [
            14.437719,
            53.896582,
            40.772361
          ],
          [
            14.437729,
            53.896362,
            40.353553
          ],
          [
            14.437687,
            53.896146,
            39.939811
          ],
          [
            14.437629,
            53.895922,
            39.509394
          ],
          [
            14.437549,
            53.895683,
            39.161035
          ],
          [
            14.437475,
            53.895471,
            38.85185
          ],
          [
            14.437397,
            53.895267,
            38.553133
          ],
          [
            14.437304,
            53.89508,
            38.274727
          ],
          [
            14.437245,
            53.894847,
            37.938056
          ],
          [
            14.437156,
            53.894647,
            37.64255
          ],
          [
            14.437064,
            53.894442,
            37.339636
          ],
          [
            14.436958,
            53.89422,
            37.010199
          ],
          [
            14.436901,
            53.894029,
            37.043
          ],
          [
            14.436883,
            53.893824,
            37.184915
          ],
          [
            14.43697,
            53.893635,
            37.319049
          ],
          [
            14.437021,
            53.89343,
            37.460903
          ],
          [
            14.437042,
            53.893217,
            37.608606
          ],
          [
            14.437051,
            53.893003,
            37.755186
          ],
          [
            14.436989,
            53.892791,
            37.902471
          ],
          [
            14.436914,
            53.892579,
            38.050769
          ],
          [
            14.436823,
            53.89236,
            38.466908
          ],
          [
            14.43674,
            53.892169,
            39.741074
          ],
          [
            14.436684,
            53.891983,
            40.958136
          ],
          [
            14.436665,
            53.891776,
            42.292772
          ],
          [
            14.436724,
            53.891586,
            43.564309
          ],
          [
            14.436851,
            53.891395,
            44.884578
          ],
          [
            14.436941,
            53.89122,
            46.073063
          ],
          [
            14.437051,
            53.891019,
            47.435053
          ],
          [
            14.437207,
            53.890835,
            48.763506
          ],
          [
            14.437399,
            53.890677,
            49.8934
          ],
          [
            14.43763,
            53.890538,
            50.547484
          ],
          [
            14.437849,
            53.89039,
            51.207247
          ],
          [
            14.438055,
            53.890234,
            51.875946
          ],
          [
            14.438217,
            53.890071,
            52.531839
          ],
          [
            14.438282,
            53.889858,
            53.258819
          ],
          [
            14.438338,
            53.889642,
            53.992813
          ],
          [
            14.438487,
            53.889452,
            54.70685
          ],
          [
            14.438589,
            53.889244,
            55.434407
          ],
          [
            14.438755,
            53.889032,
            55.639709
          ],
          [
            14.43896,
            53.888832,
            55.360381
          ],
          [
            14.439237,
            53.888628,
            55.048408
          ],
          [
            14.439508,
            53.888412,
            54.727577
          ],
          [
            14.439805,
            53.888199,
            54.398093
          ],
          [
            14.440124,
            53.88798,
            54.052927
          ],
          [
            14.440386,
            53.887785,
            53.755449
          ],
          [
            14.440644,
            53.887636,
            53.662208
          ],
          [
            14.440911,
            53.887521,
            53.691641
          ],
          [
            14.441162,
            53.887411,
            53.719474
          ],
          [
            14.441533,
            53.887302,
            53.756413
          ],
          [
            14.441893,
            53.887223,
            53.790782
          ],
          [
            14.442225,
            53.88716,
            53.82185
          ],
          [
            14.442577,
            53.887094,
            53.854717
          ],
          [
            14.442941,
            53.887029,
            53.888622
          ],
          [
            14.443304,
            53.886964,
            53.894494
          ],
          [
            14.44368,
            53.886899,
            53.784371
          ],
          [
            14.444055,
            53.886834,
            53.67447
          ],
          [
            14.44439,
            53.886781,
            53.576948
          ],
          [
            14.44471,
            53.886725,
            53.48311
          ],
          [
            14.445065,
            53.886693,
            53.38214
          ],
          [
            14.445366,
            53.886647,
            53.294744
          ],
          [
            14.445726,
            53.886611,
            53.192121
          ],
          [
            14.446087,
            53.886554,
            53.087083
          ],
          [
            14.446433,
            53.886514,
            52.707488
          ],
          [
            14.446684,
            53.886389,
            52.222606
          ],
          [
            14.446651,
            53.886154,
            51.640497
          ],
          [
            14.446488,
            53.885966,
            51.136665
          ],
          [
            14.446346,
            53.885771,
            50.630234
          ],
          [
            14.446186,
            53.885554,
            50.062275
          ],
          [
            14.446019,
            53.885356,
            49.534575
          ],
          [
            14.446015,
            53.885153,
            49.046114
          ],
          [
            14.446154,
            53.884928,
            48.474913
          ],
          [
            14.44629,
            53.884715,
            47.93348
          ],
          [
            14.446403,
            53.884502,
            47.402214
          ],
          [
            14.446517,
            53.884318,
            46.93557
          ],
          [
            14.446621,
            53.884143,
            46.494395
          ],
          [
            14.446751,
            53.883912,
            45.91506
          ],
          [
            14.44686,
            53.883669,
            45.317213
          ],
          [
            14.446966,
            53.883495,
            44.877473
          ],
          [
            14.447074,
            53.883314,
            44.434859
          ],
          [
            14.447176,
            53.883122,
            44.055314
          ],
          [
            14.447291,
            53.882924,
            43.660296
          ],
          [
            14.447412,
            53.882725,
            43.261549
          ],
          [
            14.447497,
            53.882534,
            42.888979
          ],
          [
            14.44759,
            53.882301,
            42.436942
          ],
          [
            14.44772,
            53.882045,
            41.932542
          ],
          [
            14.447831,
            53.881832,
            41.512273
          ],
          [
            14.447934,
            53.881593,
            41.1223
          ],
          [
            14.447952,
            53.881403,
            41.324222
          ],
          [
            14.448002,
            53.881214,
            41.527062
          ],
          [
            14.448053,
            53.880988,
            41.76883
          ],
          [
            14.448105,
            53.880746,
            42.027503
          ],
          [
            14.448082,
            53.880502,
            42.287039
          ],
          [
            14.447991,
            53.880289,
            42.520009
          ],
          [
            14.447889,
            53.880091,
            42.742969
          ],
          [
            14.447678,
            53.879899,
            42.985566
          ],
          [
            14.447465,
            53.879719,
            43.039291
          ],
          [
            14.447271,
            53.879557,
            43.075186
          ],
          [
            14.447084,
            53.87938,
            43.112867
          ],
          [
            14.44698,
            53.879184,
            43.150117
          ],
          [
            14.446849,
            53.878981,
            43.189341
          ],
          [
            14.446982,
            53.878818,
            43.226545
          ],
          [
            14.447351,
            53.8788,
            43.266334
          ],
          [
            14.447681,
            53.878761,
            43.302157
          ],
          [
            14.448006,
            53.878749,
            43.394052
          ],
          [
            14.448355,
            53.878715,
            43.655786
          ],
          [
            14.448655,
            53.878679,
            43.882983
          ],
          [
            14.448971,
            53.878661,
            44.117608
          ],
          [
            14.449349,
            53.878628,
            44.400012
          ],
          [
            14.44967,
            53.878601,
            44.639902
          ],
          [
            14.450017,
            53.878587,
            44.89725
          ],
          [
            14.450361,
            53.87855,
            45.155742
          ],
          [
            14.45071,
            53.878502,
            45.420604
          ],
          [
            14.451049,
            53.87843,
            45.592199
          ],
          [
            14.451385,
            53.878382,
            45.616601
          ],
          [
            14.451705,
            53.878342,
            45.639688
          ],
          [
            14.452013,
            53.878309,
            45.661772
          ],
          [
            14.452408,
            53.878265,
            45.690137
          ],
          [
            14.452727,
            53.878256,
            45.712705
          ],
          [
            14.453042,
            53.878251,
            45.734951
          ],
          [
            14.453473,
            53.878237,
            45.765409
          ],
          [
            14.453842,
            53.878222,
            45.791536
          ],
          [
            14.454286,
            53.878189,
            45.839012
          ],
          [
            14.454666,
            53.878182,
            45.882184
          ],
          [
            14.455004,
            53.878174,
            45.920502
          ],
          [
            14.455372,
            53.878161,
            45.962256
          ],
          [
            14.455784,
            53.878136,
            46.009171
          ],
          [
            14.456179,
            53.878134,
            46.053924
          ],
          [
            14.456542,
            53.878129,
            46.095071
          ],
          [
            14.456923,
            53.878101,
            46.138561
          ],
          [
            14.457285,
            53.87806,
            46.644202
          ],
          [
            14.457632,
            53.878021,
            47.17934
          ],
          [
            14.457972,
            53.877967,
            47.712817
          ],
          [
            14.458304,
            53.877927,
            48.226562
          ],
          [
            14.458689,
            53.877888,
            48.819662
          ],
          [
            14.459044,
            53.877838,
            49.373606
          ],
          [
            14.459388,
            53.87776,
            49.932111
          ],
          [
            14.459728,
            53.87773,
            50.457463
          ],
          [
            14.460106,
            53.877725,
            50.9957
          ],
          [
            14.46049,
            53.877704,
            51.501819
          ],
          [
            14.460831,
            53.877657,
            51.961074
          ],
          [
            14.461111,
            53.877553,
            52.39625
          ],
          [
            14.461351,
            53.877426,
            52.819279
          ],
          [
            14.46162,
            53.877283,
            53.296302
          ],
          [
            14.461927,
            53.877166,
            53.780587
          ],
          [
            14.462232,
            53.877168,
            54.182149
          ],
          [
            14.462563,
            53.877182,
            54.617318
          ],
          [
            14.46292,
            53.877223,
            54.939696
          ],
          [
            14.463259,
            53.877316,
            55.199576
          ],
          [
            14.46353,
            53.87741,
            55.417962
          ],
          [
            14.463884,
            53.877507,
            55.6891
          ],
          [
            14.464212,
            53.877617,
            55.951154
          ],
          [
            14.464532,
            53.877727,
            56.208483
          ],
          [
            14.464819,
            53.877822,
            56.437892
          ],
          [
            14.465179,
            53.877823,
            56.687883
          ],
          [
            14.465517,
            53.877801,
            57.095883
          ],
          [
            14.465836,
            53.877833,
            58.238742
          ],
          [
            14.466121,
            53.877943,
            59.453125
          ],
          [
            14.466383,
            53.878072,
            60.659226
          ],
          [
            14.466662,
            53.878192,
            61.882804
          ],
          [
            14.466969,
            53.878309,
            63.176623
          ],
          [
            14.467234,
            53.878454,
            64.452207
          ],
          [
            14.467557,
            53.878509,
            65.639518
          ],
          [
            14.467886,
            53.878563,
            66.846071
          ],
          [
            14.468222,
            53.878541,
            68.034786
          ],
          [
            14.468575,
            53.878548,
            69.250916
          ],
          [
            14.468916,
            53.878564,
            70.446146
          ],
          [
            14.469231,
            53.878607,
            71.571605
          ],
          [
            14.46956,
            53.878669,
            72.763184
          ],
          [
            14.469887,
            53.878716,
            73.973428
          ],
          [
            14.470413,
            53.87875,
            75.797192
          ],
          [
            14.470745,
            53.878769,
            76.949807
          ],
          [
            14.471073,
            53.878812,
            78.109234
          ],
          [
            14.471378,
            53.878932,
            78.573821
          ],
          [
            14.471671,
            53.879013,
            78.958461
          ],
          [
            14.472006,
            53.879048,
            79.362687
          ],
          [
            14.472342,
            53.879096,
            79.773448
          ],
          [
            14.472642,
            53.87914,
            80.144775
          ],
          [
            14.472973,
            53.879185,
            80.547708
          ],
          [
            14.473319,
            53.879233,
            80.969336
          ],
          [
            14.473685,
            53.879276,
            81.414839
          ],
          [
            14.473986,
            53.879344,
            81.760794
          ],
          [
            14.47431,
            53.87939,
            81.67328
          ],
          [
            14.474609,
            53.879474,
            81.586072
          ],
          [
            14.474911,
            53.879548,
            81.499798
          ],
          [
            14.475244,
            53.879629,
            81.404566
          ],
          [
            14.475588,
            53.879734,
            81.302858
          ],
          [
            14.475875,
            53.879794,
            81.222577
          ],
          [
            14.476146,
            53.879922,
            81.131293
          ],
          [
            14.476444,
            53.879972,
            81.04973
          ],
          [
            14.476749,
            53.880105,
            80.770318
          ],
          [
            14.477064,
            53.880257,
            79.595124
          ],
          [
            14.477388,
            53.8804,
            78.426849
          ],
          [
            14.477759,
            53.880538,
            77.142054
          ],
          [
            14.477998,
            53.880658,
            76.237403
          ],
          [
            14.478438,
            53.880837,
            74.696552
          ],
          [
            14.478899,
            53.881029,
            73.06959
          ],
          [
            14.479311,
            53.881182,
            72.588867
          ],
          [
            14.479688,
            53.881359,
            73.696101
          ],
          [
            14.480119,
            53.881493,
            74.819064
          ],
          [
            14.480482,
            53.881589,
            75.740505
          ],
          [
            14.480835,
            53.881755,
            76.776752
          ],
          [
            14.481163,
            53.881901,
            77.720438
          ],
          [
            14.481488,
            53.882069,
            78.714474
          ],
          [
            14.481889,
            53.882167,
            78.781247
          ],
          [
            14.482234,
            53.882329,
            78.045361
          ],
          [
            14.482556,
            53.882465,
            77.366788
          ],
          [
            14.482874,
            53.882602,
            76.710559
          ],
          [
            14.483205,
            53.882716,
            76.072261
          ],
          [
            14.483465,
            53.882838,
            75.512903
          ],
          [
            14.483849,
            53.882975,
            74.76504
          ],
          [
            14.484203,
            53.883106,
            74.052037
          ],
          [
            14.484519,
            53.883219,
            73.285113
          ],
          [
            14.484891,
            53.883063,
            72.311834
          ],
          [
            14.485244,
            53.882942,
            71.464274
          ],
          [
            14.485574,
            53.882811,
            70.638541
          ],
          [
            14.485859,
            53.882712,
            69.951876
          ],
          [
            14.486161,
            53.882594,
            69.19361
          ],
          [
            14.486525,
            53.882472,
            68.324931
          ],
          [
            14.486868,
            53.882325,
            67.690763
          ],
          [
            14.487151,
            53.882195,
            67.522263
          ],
          [
            14.487451,
            53.882085,
            67.354736
          ],
          [
            14.48773,
            53.881944,
            67.181589
          ],
          [
            14.487866,
            53.881739,
            67.003733
          ],
          [
            14.487892,
            53.881507,
            66.818434
          ],
          [
            14.48798,
            53.881322,
            66.664022
          ],
          [
            14.488216,
            53.88115,
            66.487778
          ],
          [
            14.488525,
            53.880999,
            66.23921
          ],
          [
            14.488822,
            53.88083,
            65.664513
          ],
          [
            14.489118,
            53.880666,
            65.098049
          ],
          [
            14.489398,
            53.880483,
            64.513378
          ],
          [
            14.489678,
            53.880351,
            64.01153
          ],
          [
            14.489969,
            53.880197,
            63.456818
          ],
          [
            14.49022,
            53.880063,
            62.985168
          ],
          [
            14.490457,
            53.879895,
            62.467827
          ],
          [
            14.490681,
            53.87975,
            62.085599
          ],
          [
            14.49093,
            53.879578,
            62.093651
          ],
          [
            14.491159,
            53.879413,
            62.101262
          ],
          [
            14.491476,
            53.879261,
            62.109861
          ],
          [
            14.491767,
            53.879099,
            62.118264
          ],
          [
            14.49204,
            53.878944,
            62.126246
          ],
          [
            14.492289,
            53.878808,
            62.133373
          ],
          [
            14.492539,
            53.878654,
            62.140964
          ],
          [
            14.492754,
            53.878504,
            62.147978
          ],
          [
            14.493001,
            53.878383,
            62.894472
          ],
          [
            14.493214,
            53.878226,
            63.745977
          ],
          [
            14.493437,
            53.878072,
            64.603968
          ],
          [
            14.493669,
            53.877923,
            65.460756
          ],
          [
            14.493917,
            53.877779,
            66.330732
          ],
          [
            14.494173,
            53.87762,
            67.259384
          ],
          [
            14.49442,
            53.877493,
            68.077523
          ],
          [
            14.494703,
            53.877372,
            68.95122
          ],
          [
            14.494968,
            53.877237,
            69.716437
          ],
          [
            14.495225,
            53.877078,
            69.027686
          ],
          [
            14.495438,
            53.876935,
            68.431054
          ],
          [
            14.495745,
            53.876753,
            67.625646
          ],
          [
            14.496026,
            53.876593,
            66.903226
          ],
          [
            14.496383,
            53.876368,
            65.936391
          ],
          [
            14.496668,
            53.876208,
            65.205656
          ],
          [
            14.496928,
            53.876014,
            64.430343
          ],
          [
            14.497153,
            53.875862,
            63.897059
          ],
          [
            14.497375,
            53.875709,
            63.457177
          ],
          [
            14.497609,
            53.875557,
            63.008819
          ],
          [
            14.497875,
            53.875407,
            62.534824
          ],
          [
            14.498137,
            53.875256,
            62.063006
          ],
          [
            14.498601,
            53.875002,
            61.246814
          ],
          [
            14.498917,
            53.874805,
            60.654191
          ],
          [
            14.499307,
            53.874642,
            60.222884
          ],
          [
            14.499608,
            53.874424,
            60.325343
          ],
          [
            14.499903,
            53.874285,
            60.408588
          ],
          [
            14.500264,
            53.874212,
            60.491698
          ],
          [
            14.500539,
            53.874068,
            60.571439
          ],
          [
            14.500878,
            53.873922,
            60.66163
          ],
          [
            14.501226,
            53.873778,
            60.752991
          ],
          [
            14.501574,
            53.873619,
            60.847604
          ],
          [
            14.5019,
            53.87348,
            62.792049
          ],
          [
            14.502152,
            53.873351,
            64.492335
          ],
          [
            14.502447,
            53.873209,
            66.427277
          ],
          [
            14.502696,
            53.873063,
            68.224437
          ],
          [
            14.502939,
            53.8729,
            70.107107
          ],
          [
            14.503223,
            53.872781,
            71.88033
          ],
          [
            14.503506,
            53.872649,
            73.712212
          ],
          [
            14.503811,
            53.872546,
            75.495105
          ],
          [
            14.504122,
            53.872472,
            76.230318
          ],
          [
            14.504379,
            53.872359,
            76.059743
          ],
          [
            14.504686,
            53.872308,
            75.888554
          ],
          [
            14.505106,
            53.872234,
            75.610547
          ],
          [
            14.505419,
            53.872207,
            75.442297
          ],
          [
            14.505776,
            53.872205,
            75.247639
          ],
          [
            14.506107,
            53.872151,
            75.064929
          ],
          [
            14.506432,
            53.872101,
            74.885727
          ],
          [
            14.506788,
            53.872047,
            74.708089
          ],
          [
            14.507142,
            53.871983,
            74.824476
          ],
          [
            14.507416,
            53.871884,
            74.923667
          ],
          [
            14.507804,
            53.871797,
            75.051795
          ],
          [
            14.508141,
            53.871672,
            75.17541
          ],
          [
            14.508424,
            53.871496,
            75.302427
          ],
          [
            14.508637,
            53.871346,
            75.404855
          ],
          [
            14.508818,
            53.871185,
            75.506297
          ],
          [
            14.508962,
            53.871009,
            75.608714
          ],
          [
            14.509097,
            53.870811,
            75.208431
          ],
          [
            14.509198,
            53.870602,
            74.569546
          ],
          [
            14.509343,
            53.870403,
            73.933976
          ],
          [
            14.509472,
            53.87023,
            73.379048
          ],
          [
            14.509627,
            53.870046,
            72.77585
          ],
          [
            14.509807,
            53.869861,
            72.149923
          ],
          [
            14.510023,
            53.86972,
            71.59239
          ],
          [
            14.510199,
            53.869563,
            71.038621
          ],
          [
            14.510412,
            53.869415,
            70.467909
          ],
          [
            14.510626,
            53.869265,
            69.933986
          ],
          [
            14.510848,
            53.869089,
            69.340755
          ],
          [
            14.511057,
            53.868946,
            68.832641
          ],
          [
            14.511216,
            53.868746,
            68.238516
          ],
          [
            14.511422,
            53.868574,
            67.657884
          ],
          [
            14.511794,
            53.868437,
            66.96574
          ],
          [
            14.512101,
            53.868308,
            66.366623
          ],
          [
            14.512429,
            53.868179,
            65.744304
          ],
          [
            14.51275,
            53.868063,
            65.562653
          ],
          [
            14.513019,
            53.867962,
            65.576922
          ],
          [
            14.513187,
            53.867802,
            65.591153
          ],
          [
            14.51333,
            53.867626,
            65.605911
          ],
          [
            14.513498,
            53.867439,
            65.621942
          ],
          [
            14.513663,
            53.867259,
            65.637402
          ],
          [
            14.513885,
            53.867087,
            65.65374
          ],
          [
            14.51407,
            53.866892,
            65.670624
          ],
          [
            14.514247,
            53.866697,
            65.692698
          ],
          [
            14.514407,
            53.866524,
            66.392625
          ],
          [
            14.514594,
            53.866347,
            67.133341
          ],
          [
            14.514751,
            53.86618,
            67.811718
          ],
          [
            14.514922,
            53.866021,
            68.480599
          ],
          [
            14.514983,
            53.865831,
            69.176469
          ],
          [
            14.51492,
            53.86562,
            69.937716
          ],
          [
            14.514944,
            53.865432,
            70.609355
          ],
          [
            14.514927,
            53.865235,
            71.312115
          ],
          [
            14.514899,
            53.865042,
            72.000166
          ],
          [
            14.514815,
            53.864865,
            72.033623
          ],
          [
            14.514966,
            53.864693,
            71.979308
          ],
          [
            14.515291,
            53.864633,
            71.927213
          ],
          [
            14.515612,
            53.86455,
            71.873592
          ],
          [
            14.515945,
            53.864452,
            71.816366
          ],
          [
            14.516287,
            53.864373,
            71.760182
          ],
          [
            14.516637,
            53.864285,
            71.701871
          ],
          [
            14.516981,
            53.86421,
            71.645754
          ],
          [
            14.517357,
            53.864129,
            71.522525
          ],
          [
            14.51774,
            53.864053,
            71.305681
          ],
          [
            14.518123,
            53.86399,
            71.092296
          ],
          [
            14.518481,
            53.863953,
            70.897252
          ],
          [
            14.518794,
            53.863888,
            70.719181
          ],
          [
            14.519186,
            53.863812,
            70.497329
          ],
          [
            14.519566,
            53.863728,
            70.279041
          ],
          [
            14.519909,
            53.863702,
            70.092716
          ],
          [
            14.520225,
            53.863629,
            69.87149
          ],
          [
            14.520599,
            53.863552,
            69.52598
          ],
          [
            14.52102,
            53.863481,
            69.143819
          ],
          [
            14.521323,
            53.863424,
            68.864121
          ],
          [
            14.521643,
            53.863356,
            68.567381
          ],
          [
            14.522023,
            53.863271,
            68.208727
          ],
          [
            14.522424,
            53.863211,
            67.847361
          ],
          [
            14.522792,
            53.863167,
            67.519704
          ],
          [
            14.52314,
            53.863116,
            67.357241
          ],
          [
            14.523534,
            53.86308,
            67.50534
          ],
          [
            14.523888,
            53.862998,
            67.64698
          ],
          [
            14.524208,
            53.862915,
            67.777287
          ],
          [
            14.524573,
            53.862824,
            67.924475
          ],
          [
            14.524936,
            53.86274,
            68.069546
          ],
          [
            14.525292,
            53.862716,
            68.202897
          ],
          [
            14.525685,
            53.862629,
            68.360073
          ],
          [
            14.526082,
            53.862583,
            68.591341
          ],
          [
            14.526387,
            53.86253,
            68.856091
          ],
          [
            14.52676,
            53.862459,
            69.182614
          ],
          [
            14.527118,
            53.862431,
            69.484224
          ],
          [
            14.527473,
            53.862414,
            69.78329
          ],
          [
            14.527811,
            53.862364,
            70.075838
          ],
          [
            14.528176,
            53.862354,
            70.380383
          ],
          [
            14.528521,
            53.862376,
            70.672856
          ],
          [
            14.528867,
            53.862364,
            70.961815
          ],
          [
            14.529206,
            53.862306,
            71.028963
          ],
          [
            14.529623,
            53.862258,
            71.087227
          ],
          [
            14.529984,
            53.862252,
            71.136723
          ],
          [
            14.530366,
            53.862246,
            71.189365
          ],
          [
            14.530765,
            53.862197,
            71.245229
          ],
          [
            14.531099,
            53.862113,
            71.295051
          ],
          [
            14.531464,
            53.862113,
            71.34543
          ],
          [
            14.531802,
            53.862158,
            71.392953
          ],
          [
            14.532178,
            53.862148,
            71.092396
          ],
          [
            14.532539,
            53.862131,
            70.73037
          ],
          [
            14.53293,
            53.862095,
            70.333597
          ],
          [
            14.533252,
            53.862094,
            70.006325
          ],
          [
            14.533628,
            53.862101,
            69.629156
          ],
          [
            14.533961,
            53.862088,
            69.295232
          ],
          [
            14.534305,
            53.862044,
            68.942071
          ],
          [
            14.534611,
            53.861964,
            68.607023
          ],
          [
            14.53494,
            53.861932,
            68.368726
          ],
          [
            14.535249,
            53.861932,
            68.422524
          ],
          [
            14.53567,
            53.861932,
            68.495303
          ],
          [
            14.535995,
            53.861913,
            68.551788
          ],
          [
            14.53633,
            53.861899,
            68.609944
          ],
          [
            14.536737,
            53.861933,
            68.681073
          ],
          [
            14.537238,
            53.861894,
            68.768466
          ],
          [
            14.53771,
            53.861855,
            68.851343
          ],
          [
            14.538106,
            53.861847,
            68.948043
          ],
          [
            14.538589,
            53.861783,
            69.094581
          ],
          [
            14.538944,
            53.861762,
            69.201162
          ],
          [
            14.539287,
            53.861779,
            69.303067
          ],
          [
            14.539649,
            53.861761,
            69.410668
          ],
          [
            14.539962,
            53.861732,
            69.505267
          ],
          [
            14.540305,
            53.861731,
            69.606825
          ],
          [
            14.540666,
            53.861672,
            69.717701
          ],
          [
            14.540986,
            53.86167,
            69.717172
          ],
          [
            14.541339,
            53.861642,
            69.477921
          ],
          [
            14.541705,
            53.861611,
            69.229465
          ],
          [
            14.542062,
            53.861595,
            68.988445
          ],
          [
            14.542425,
            53.861554,
            68.738647
          ],
          [
            14.542808,
            53.861512,
            68.476643
          ],
          [
            14.543169,
            53.861512,
            68.232852
          ],
          [
            14.543547,
            53.861513,
            67.978901
          ],
          [
            14.543877,
            53.86148,
            67.753687
          ],
          [
            14.544236,
            53.861449,
            67.144917
          ],
          [
            14.544624,
            53.861391,
            66.445599
          ],
          [
            14.545034,
            53.861373,
            65.726644
          ],
          [
            14.545445,
            53.861359,
            65.005853
          ],
          [
            14.545876,
            53.861331,
            64.249647
          ],
          [
            14.546264,
            53.861391,
            63.539695
          ],
          [
            14.546601,
            53.861406,
            62.948425
          ],
          [
            14.546969,
            53.861378,
            62.266558
          ],
          [
            14.547402,
            53.86133,
            61.266371
          ],
          [
            14.547647,
            53.861209,
            60.515479
          ],
          [
            14.547857,
            53.861031,
            59.68208
          ],
          [
            14.548091,
            53.860852,
            58.813504
          ],
          [
            14.548381,
            53.860671,
            57.856125
          ],
          [
            14.548654,
            53.860493,
            56.933825
          ],
          [
            14.54896,
            53.860336,
            56.01458
          ],
          [
            14.5492,
            53.86019,
            55.494634
          ],
          [
            14.549462,
            53.860062,
            55.466845
          ],
          [
            14.549742,
            53.85994,
            55.438345
          ],
          [
            14.55007,
            53.859808,
            55.405938
          ],
          [
            14.550337,
            53.859706,
            55.379964
          ],
          [
            14.550641,
            53.859603,
            55.351282
          ],
          [
            14.550909,
            53.859497,
            55.324933
          ],
          [
            14.551155,
            53.859388,
            55.299818
          ],
          [
            14.551616,
            53.85931,
            55.259847
          ],
          [
            14.551988,
            53.859299,
            54.474887
          ],
          [
            14.552411,
            53.859263,
            53.432327
          ],
          [
            14.552876,
            53.859204,
            52.271756
          ],
          [
            14.553393,
            53.859159,
            50.997223
          ],
          [
            14.553882,
            53.859115,
            49.790228
          ],
          [
            14.554329,
            53.85907,
            48.683344
          ],
          [
            14.554743,
            53.859041,
            47.925122
          ],
          [
            14.55511,
            53.859002,
            48.570017
          ],
          [
            14.555522,
            53.85896,
            49.293176
          ],
          [
            14.555878,
            53.85891,
            49.92622
          ],
          [
            14.556244,
            53.858863,
            50.573945
          ],
          [
            14.556593,
            53.858812,
            51.195802
          ],
          [
            14.556906,
            53.858763,
            51.756017
          ],
          [
            14.557231,
            53.858706,
            52.342407
          ],
          [
            14.557525,
            53.858603,
            52.935807
          ],
          [
            14.557795,
            53.858494,
            53.480582
          ],
          [
            14.558109,
            53.858415,
            54.037448
          ],
          [
            14.558418,
            53.858299,
            54.634795
          ],
          [
            14.558759,
            53.858197,
            55.258519
          ],
          [
            14.559037,
            53.858101,
            55.783885
          ],
          [
            14.559334,
            53.858,
            56.343074
          ],
          [
            14.559625,
            53.857901,
            56.891126
          ],
          [
            14.559941,
            53.857788,
            57.493813
          ],
          [
            14.560273,
            53.857683,
            58.068852
          ],
          [
            14.560618,
            53.857597,
            58.127268
          ],
          [
            14.560995,
            53.857505,
            58.190886
          ],
          [
            14.561274,
            53.857387,
            58.24472
          ],
          [
            14.561549,
            53.857263,
            58.298793
          ],
          [
            14.561873,
            53.857123,
            58.36142
          ],
          [
            14.562183,
            53.856995,
            58.420422
          ],
          [
            14.56249,
            53.85688,
            58.477128
          ],
          [
            14.562828,
            53.856742,
            58.529515
          ],
          [
            14.563163,
            53.856602,
            57.91266
          ],
          [
            14.563505,
            53.856463,
            57.288485
          ],
          [
            14.563831,
            53.856322,
            56.680485
          ],
          [
            14.564105,
            53.856218,
            56.190929
          ],
          [
            14.564423,
            53.856073,
            55.58683
          ],
          [
            14.564784,
            53.855908,
            54.899689
          ],
          [
            14.565192,
            53.85574,
            54.152064
          ],
          [
            14.56558,
            53.855597,
            53.608754
          ],
          [
            14.565904,
            53.855468,
            53.194217
          ],
          [
            14.566192,
            53.85535,
            52.822284
          ],
          [
            14.566469,
            53.855241,
            52.468684
          ],
          [
            14.566776,
            53.855113,
            52.070057
          ],
          [
            14.567039,
            53.855012,
            51.737209
          ],
          [
            14.567354,
            53.854872,
            51.319123
          ],
          [
            14.567639,
            53.85476,
            50.956109
          ],
          [
            14.567958,
            53.854604,
            50.465639
          ],
          [
            14.568258,
            53.854454,
            49.947153
          ],
          [
            14.568551,
            53.854301,
            49.430708
          ],
          [
            14.568847,
            53.854156,
            48.922347
          ],
          [
            14.569143,
            53.854009,
            48.412213
          ],
          [
            14.569387,
            53.853891,
            47.99616
          ],
          [
            14.569665,
            53.85378,
            47.553376
          ],
          [
            14.569945,
            53.853655,
            47.089665
          ],
          [
            14.570224,
            53.853524,
            46.782293
          ],
          [
            14.570528,
            53.853386,
            47.223666
          ],
          [
            14.570842,
            53.853258,
            47.662813
          ],
          [
            14.571157,
            53.853139,
            48.093735
          ],
          [
            14.571432,
            53.853008,
            48.502036
          ],
          [
            14.571707,
            53.852906,
            48.876557
          ],
          [
            14.571973,
            53.852786,
            49.263761
          ],
          [
            14.572241,
            53.852668,
            49.649569
          ],
          [
            14.572533,
            53.852553,
            50.053591
          ],
          [
            14.572788,
            53.852423,
            49.873022
          ],
          [
            14.573047,
            53.852292,
            49.286182
          ],
          [
            14.573334,
            53.85218,
            48.694396
          ],
          [
            14.573683,
            53.852069,
            48.012486
          ],
          [
            14.573965,
            53.851964,
            47.438958
          ],
          [
            14.574304,
            53.851848,
            46.764987
          ],
          [
            14.574672,
            53.851728,
            46.041863
          ],
          [
            14.574981,
            53.851613,
            45.413522
          ],
          [
            14.575296,
            53.851497,
            44.819162
          ],
          [
            14.575593,
            53.851389,
            44.354931
          ],
          [
            14.57588,
            53.851292,
            43.915292
          ],
          [
            14.576177,
            53.851184,
            43.451823
          ],
          [
            14.576555,
            53.851056,
            42.872881
          ],
          [
            14.576901,
            53.850934,
            42.336681
          ],
          [
            14.577198,
            53.850888,
            41.922487
          ],
          [
            14.577559,
            53.850845,
            41.43288
          ],
          [
            14.577895,
            53.850799,
            40.974085
          ],
          [
            14.578256,
            53.850786,
            40.50928
          ],
          [
            14.578643,
            53.850731,
            39.99968
          ],
          [
            14.579012,
            53.850728,
            39.527262
          ],
          [
            14.579429,
            53.850734,
            38.992881
          ],
          [
            14.579871,
            53.850728,
            38.42742
          ],
          [
            14.580188,
            53.850726,
            38.021141
          ],
          [
            14.580521,
            53.850714,
            37.593937
          ],
          [
            14.580845,
            53.850723,
            37.178965
          ],
          [
            14.581205,
            53.850731,
            36.987379
          ],
          [
            14.581216,
            53.850536,
            36.940985
          ],
          [
            14.581124,
            53.850325,
            36.88977
          ],
          [
            14.580915,
            53.850168,
            36.842653
          ],
          [
            14.580605,
            53.850052,
            36.79153
          ],
          [
            14.580293,
            53.850017,
            36.747391
          ],
          [
            14.580046,
            53.849897,
            36.70273
          ],
          [
            14.579823,
            53.849736,
            36.653867
          ],
          [
            14.579596,
            53.84954,
            36.598068
          ],
          [
            14.579391,
            53.849333,
            36.602867
          ],
          [
            14.57911,
            53.849176,
            36.608004
          ],
          [
            14.578712,
            53.849128,
            36.613356
          ],
          [
            14.578372,
            53.849096,
            36.61789
          ],
          [
            14.578011,
            53.849057,
            36.622729
          ],
          [
            14.577605,
            53.849002,
            36.628215
          ],
          [
            14.577197,
            53.848953,
            36.6337
          ],
          [
            14.576867,
            53.848904,
            36.653404
          ],
          [
            14.576461,
            53.848858,
            36.835083
          ],
          [
            14.576067,
            53.848809,
            37.013192
          ],
          [
            14.57573,
            53.848736,
            37.170954
          ],
          [
            14.575448,
            53.84864,
            37.317191
          ],
          [
            14.575556,
            53.848432,
            37.482595
          ],
          [
            14.575722,
            53.848232,
            37.648371
          ],
          [
            14.575891,
            53.848031,
            37.815407
          ],
          [
            14.57607,
            53.847836,
            37.97532
          ],
          [
            14.576245,
            53.847631,
            37.914568
          ],
          [
            14.576408,
            53.847454,
            37.861215
          ],
          [
            14.576561,
            53.847257,
            37.803861
          ],
          [
            14.576745,
            53.847063,
            37.744978
          ],
          [
            14.576919,
            53.84686,
            37.684742
          ],
          [
            14.577073,
            53.846673,
            37.629711
          ],
          [
            14.577252,
            53.846492,
            37.574237
          ],
          [
            14.577409,
            53.846322,
            37.522996
          ],
          [
            14.577567,
            53.846152,
            37.430153
          ],
          [
            14.577736,
            53.845953,
            37.286685
          ],
          [
            14.577909,
            53.845744,
            37.136848
          ],
          [
            14.578088,
            53.845547,
            36.992741
          ],
          [
            14.578259,
            53.845356,
            36.853416
          ],
          [
            14.578396,
            53.845189,
            36.733883
          ],
          [
            14.578579,
            53.845013,
            36.600866
          ],
          [
            14.578749,
            53.844818,
            36.459614
          ],
          [
            14.578893,
            53.844646,
            36.356111
          ],
          [
            14.579048,
            53.844466,
            36.663119
          ],
          [
            14.579203,
            53.844247,
            37.023975
          ],
          [
            14.579336,
            53.844035,
            37.367846
          ],
          [
            14.579463,
            53.843841,
            37.684013
          ],
          [
            14.579623,
            53.843632,
            38.032715
          ],
          [
            14.57974,
            53.843443,
            38.338907
          ],
          [
            14.579857,
            53.843267,
            38.627483
          ],
          [
            14.579962,
            53.843064,
            38.950129
          ],
          [
            14.58009,
            53.842862,
            39.118892
          ],
          [
            14.580204,
            53.842678,
            39.182253
          ],
          [
            14.580451,
            53.842634,
            39.251972
          ],
          [
            14.580702,
            53.842806,
            39.325287
          ],
          [
            14.58095,
            53.842952,
            39.392037
          ],
          [
            14.581188,
            53.843078,
            39.452953
          ],
          [
            14.581449,
            53.843223,
            39.521245
          ],
          [
            14.581748,
            53.843396,
            39.601022
          ],
          [
            14.581983,
            53.843592,
            39.70599
          ],
          [
            14.582284,
            53.843571,
            39.836769
          ],
          [
            14.582654,
            53.843517,
            39.999049
          ],
          [
            14.583044,
            53.843457,
            40.170653
          ],
          [
            14.583433,
            53.843394,
            40.342449
          ],
          [
            14.583818,
            53.84335,
            40.509776
          ],
          [
            14.584153,
            53.843297,
            40.657468
          ],
          [
            14.584487,
            53.843242,
            40.805134
          ],
          [
            14.584797,
            53.843188,
            40.942751
          ],
          [
            14.585097,
            53.843143,
            40.988231
          ],
          [
            14.585417,
            53.843082,
            41.028311
          ],
          [
            14.585731,
            53.843022,
            41.067661
          ],
          [
            14.58611,
            53.842969,
            41.114127
          ],
          [
            14.586499,
            53.842903,
            41.16239
          ],
          [
            14.586938,
            53.842845,
            41.21605
          ],
          [
            14.587353,
            53.84277,
            41.267926
          ],
          [
            14.587751,
            53.84272,
            41.316426
          ],
          [
            14.588102,
            53.842675,
            41.30244
          ],
          [
            14.588423,
            53.84263,
            41.287612
          ],
          [
            14.588723,
            53.84255,
            41.272834
          ],
          [
            14.589054,
            53.84249,
            41.257286
          ],
          [
            14.589404,
            53.842418,
            41.240648
          ],
          [
            14.589803,
            53.842355,
            41.222099
          ],
          [
            14.590186,
            53.842316,
            41.204559
          ],
          [
            14.590502,
            53.842265,
            41.18986
          ],
          [
            14.590832,
            53.842212,
            41.296601
          ],
          [
            14.591166,
            53.842157,
            41.565502
          ],
          [
            14.59148,
            53.842106,
            41.818311
          ],
          [
            14.591823,
            53.842061,
            42.090886
          ],
          [
            14.592138,
            53.841977,
            42.359203
          ],
          [
            14.592449,
            53.842013,
            42.617108
          ],
          [
            14.592771,
            53.841963,
            42.875322
          ],
          [
            14.593066,
            53.841918,
            43.111792
          ],
          [
            14.593358,
            53.841835,
            43.36836
          ],
          [
            14.593812,
            53.841777,
            43.49956
          ],
          [
            14.594158,
            53.841727,
            43.430948
          ],
          [
            14.594484,
            53.841674,
            43.365826
          ],
          [
            14.594843,
            53.841629,
            43.295032
          ],
          [
            14.595177,
            53.841591,
            43.229525
          ],
          [
            14.595515,
            53.841513,
            43.159578
          ],
          [
            14.595819,
            53.841454,
            43.097607
          ],
          [
            14.596145,
            53.841415,
            43.033545
          ],
          [
            14.59645,
            53.841375,
            42.973205
          ],
          [
            14.596755,
            53.841322,
            43.296007
          ],
          [
            14.59705,
            53.84125,
            43.756447
          ],
          [
            14.597374,
            53.841217,
            44.227124
          ],
          [
            14.597735,
            53.841169,
            44.749824
          ],
          [
            14.598062,
            53.841128,
            45.222022
          ],
          [
            14.598373,
            53.841086,
            45.672776
          ],
          [
            14.598706,
            53.84103,
            46.162469
          ],
          [
            14.599054,
            53.840972,
            46.673378
          ],
          [
            14.599446,
            53.840914,
            47.244444
          ],
          [
            14.599842,
            53.840836,
            46.909247
          ],
          [
            14.60021,
            53.840771,
            46.57285
          ],
          [
            14.600522,
            53.84072,
            46.289103
          ],
          [
            14.600907,
            53.840673,
            45.944799
          ],
          [
            14.601255,
            53.840612,
            45.625863
          ],
          [
            14.601585,
            53.840563,
            45.327904
          ],
          [
            14.601938,
            53.840503,
            45.006125
          ],
          [
            14.602275,
            53.840435,
            44.694263
          ],
          [
            14.602637,
            53.840365,
            44.831866
          ],
          [
            14.602951,
            53.840302,
            45.128013
          ],
          [
            14.603265,
            53.840271,
            45.412074
          ],
          [
            14.603598,
            53.840238,
            45.713362
          ],
          [
            14.603957,
            53.840183,
            46.04434
          ],
          [
            14.604313,
            53.840112,
            46.379706
          ],
          [
            14.604621,
            53.840057,
            46.667375
          ],
          [
            14.604937,
            53.840001,
            46.968442
          ],
          [
            14.605307,
            53.839969,
            47.302312
          ],
          [
            14.605625,
            53.839915,
            46.821759
          ],
          [
            14.605954,
            53.839871,
            46.299376
          ],
          [
            14.606283,
            53.839818,
            45.769751
          ],
          [
            14.606636,
            53.83975,
            45.194901
          ],
          [
            14.606984,
            53.839685,
            44.62987
          ],
          [
            14.60734,
            53.83962,
            44.053024
          ],
          [
            14.607767,
            53.839566,
            43.375854
          ],
          [
            14.608087,
            53.839513,
            42.859787
          ],
          [
            14.608469,
            53.839483,
            42.379814
          ],
          [
            14.608829,
            53.839438,
            42.011939
          ],
          [
            14.609186,
            53.83942,
            41.653725
          ],
          [
            14.609555,
            53.839396,
            41.2825
          ],
          [
            14.609939,
            53.839363,
            40.893798
          ],
          [
            14.610317,
            53.839364,
            40.515628
          ],
          [
            14.610688,
            53.83935,
            40.14335
          ],
          [
            14.610874,
            53.839523,
            39.77636
          ],
          [
            14.610886,
            53.839723,
            39.665525
          ],
          [
            14.610849,
            53.839944,
            40.063795
          ],
          [
            14.610824,
            53.840169,
            40.468262
          ],
          [
            14.610801,
            53.840386,
            40.858529
          ],
          [
            14.61087,
            53.840576,
            41.207001
          ],
          [
            14.610928,
            53.840768,
            41.556756
          ],
          [
            14.61104,
            53.840978,
            41.951901
          ],
          [
            14.611138,
            53.841185,
            42.338983
          ],
          [
            14.611261,
            53.841432,
            42.826144
          ],
          [
            14.611387,
            53.841667,
            43.685807
          ],
          [
            14.6115,
            53.841894,
            44.510214
          ],
          [
            14.611587,
            53.842106,
            45.27066
          ],
          [
            14.611673,
            53.842334,
            46.084759
          ],
          [
            14.611775,
            53.842562,
            46.906701
          ],
          [
            14.611867,
            53.842752,
            47.595239
          ],
          [
            14.611948,
            53.842927,
            48.227303
          ],
          [
            14.612037,
            53.843125,
            48.942148
          ],
          [
            14.612159,
            53.843367,
            48.438747
          ],
          [
            14.612243,
            53.843568,
            47.885669
          ],
          [
            14.612289,
            53.843802,
            47.256174
          ],
          [
            14.61229,
            53.844051,
            46.590404
          ],
          [
            14.612247,
            53.844268,
            46.00593
          ],
          [
            14.612204,
            53.844477,
            45.443309
          ],
          [
            14.612179,
            53.844688,
            44.870167
          ],
          [
            14.612301,
            53.844853,
            44.384335
          ],
          [
            14.61258,
            53.844959,
            44.199502
          ],
          [
            14.612879,
            53.845086,
            44.142967
          ],
          [
            14.613159,
            53.845213,
            44.088795
          ],
          [
            14.613473,
            53.845271,
            44.036303
          ],
          [
            14.613809,
            53.845294,
            43.981928
          ],
          [
            14.614158,
            53.845252,
            43.927177
          ],
          [
            14.614402,
            53.845139,
            43.879223
          ],
          [
            14.614638,
            53.844963,
            43.820878
          ],
          [
            14.614856,
            53.844807,
            43.768227
          ],
          [
            14.614728,
            53.844612,
            43.62061
          ],
          [
            14.6145,
            53.844466,
            43.484673
          ],
          [
            14.614662,
            53.844376,
            43.360824
          ],
          [
            14.614288,
            53.844404,
            43.198603
          ],
          [
            14.613987,
            53.844316,
            43.055038
          ],
          [
            14.61371,
            53.844175,
            42.905896
          ],
          [
            14.613367,
            53.844084,
            42.753964
          ],
          [
            14.613007,
            53.84401,
            42.599521
          ],
          [
            14.612621,
            53.843957,
            42.633508
          ],
          [
            14.612443,
            53.84411,
            42.780091
          ],
          [
            14.612336,
            53.844311,
            42.92386
          ],
          [
            14.612399,
            53.844557,
            43.09323
          ],
          [
            14.612317,
            53.84472,
            43.226778
          ],
          [
            14.612009,
            53.844776,
            43.365288
          ],
          [
            14.611706,
            53.844822,
            43.491113
          ],
          [
            14.611379,
            53.844807,
            43.627893
          ],
          [
            14.611294,
            53.844621,
            43.75896
          ],
          [
            14.611007,
            53.84462,
            43.716871
          ],
          [
            14.611102,
            53.844598,
            43.685352
          ],
          [
            14.611241,
            53.84475,
            43.642034
          ],
          [
            14.611288,
            53.844947,
            43.596664
          ],
          [
            14.611407,
            53.845144,
            43.548268
          ],
          [
            14.611446,
            53.845346,
            43.50196
          ],
          [
            14.61154,
            53.845551,
            43.453587
          ],
          [
            14.611281,
            53.845682,
            43.407605
          ],
          [
            14.611097,
            53.845766,
            43.364579
          ],
          [
            14.611397,
            53.845742,
            43.536616
          ],
          [
            14.611697,
            53.845682,
            43.771331
          ],
          [
            14.611985,
            53.84561,
            43.988796
          ],
          [
            14.61234,
            53.845524,
            44.255566
          ],
          [
            14.61269,
            53.845475,
            44.507722
          ],
          [
            14.612991,
            53.845406,
            44.733506
          ],
          [
            14.613369,
            53.845345,
            45.007464
          ],
          [
            14.613743,
            53.845333,
            45.26793
          ],
          [
            14.614102,
            53.845319,
            45.499745
          ],
          [
            14.614417,
            53.845221,
            45.657792
          ],
          [
            14.614626,
            53.845046,
            45.815997
          ],
          [
            14.614825,
            53.84489,
            45.960434
          ],
          [
            14.615018,
            53.844738,
            46.100794
          ],
          [
            14.6153,
            53.844618,
            46.252942
          ],
          [
            14.615626,
            53.844552,
            46.403514
          ],
          [
            14.615946,
            53.844464,
            46.55755
          ],
          [
            14.616265,
            53.844398,
            46.705073
          ],
          [
            14.616583,
            53.844328,
            46.716489
          ],
          [
            14.616925,
            53.844259,
            46.486975
          ],
          [
            14.617273,
            53.844166,
            46.244373
          ],
          [
            14.617566,
            53.844104,
            46.046192
          ],
          [
            14.617908,
            53.84402,
            45.810966
          ],
          [
            14.618283,
            53.843939,
            45.557371
          ],
          [
            14.618676,
            53.843834,
            45.283422
          ],
          [
            14.619023,
            53.843742,
            45.041722
          ],
          [
            14.619389,
            53.843652,
            44.781257
          ],
          [
            14.619769,
            53.843564,
            44.490679
          ],
          [
            14.620122,
            53.843462,
            44.210943
          ],
          [
            14.620488,
            53.843353,
            43.919188
          ],
          [
            14.620835,
            53.843274,
            43.654346
          ],
          [
            14.621233,
            53.843189,
            43.352966
          ],
          [
            14.621594,
            53.843097,
            43.070293
          ],
          [
            14.621955,
            53.843039,
            42.804024
          ],
          [
            14.622306,
            53.843046,
            42.675241
          ],
          [
            14.622656,
            53.843055,
            42.644937
          ],
          [
            14.623047,
            53.843065,
            42.611168
          ],
          [
            14.623422,
            53.843078,
            42.578756
          ],
          [
            14.623727,
            53.843129,
            42.551403
          ],
          [
            14.624023,
            53.843188,
            42.524446
          ],
          [
            14.62442,
            53.843274,
            42.487782
          ],
          [
            14.624818,
            53.843364,
            42.450987
          ],
          [
            14.625225,
            53.843454,
            42.347911
          ],
          [
            14.625574,
            53.84354,
            42.179581
          ],
          [
            14.625884,
            53.84362,
            42.028894
          ],
          [
            14.626194,
            53.843703,
            41.877477
          ],
          [
            14.626513,
            53.843777,
            41.724804
          ],
          [
            14.626815,
            53.843847,
            41.580518
          ],
          [
            14.627163,
            53.843918,
            41.416783
          ],
          [
            14.627491,
            53.844006,
            41.256497
          ],
          [
            14.627836,
            53.844136,
            41.074377
          ],
          [
            14.628209,
            53.844173,
            41.123362
          ],
          [
            14.628373,
            53.843984,
            41.17336
          ],
          [
            14.628222,
            53.84376,
            41.225699
          ],
          [
            14.628101,
            53.843537,
            41.276843
          ],
          [
            14.627997,
            53.843342,
            41.321212
          ],
          [
            14.627883,
            53.843118,
            41.371966
          ],
          [
            14.627777,
            53.842918,
            41.417458
          ],
          [
            14.6277,
            53.842729,
            41.459635
          ],
          [
            14.627577,
            53.842521,
            41.447257
          ],
          [
            14.627425,
            53.842335,
            41.430116
          ],
          [
            14.627259,
            53.842137,
            41.41178
          ],
          [
            14.62708,
            53.841947,
            41.393734
          ],
          [
            14.626902,
            53.841762,
            41.376044
          ],
          [
            14.626697,
            53.841578,
            41.357765
          ],
          [
            14.6265,
            53.84138,
            41.338706
          ],
          [
            14.626309,
            53.841187,
            41.320148
          ],
          [
            14.626096,
            53.841006,
            41.196371
          ],
          [
            14.625936,
            53.8408,
            41.021095
          ],
          [
            14.625779,
            53.840594,
            40.847305
          ],
          [
            14.625705,
            53.840383,
            40.681471
          ],
          [
            14.625621,
            53.840198,
            40.533991
          ],
          [
            14.62548,
            53.840021,
            40.38341
          ],
          [
            14.625288,
            53.839837,
            40.217055
          ],
          [
            14.625353,
            53.839626,
            40.051031
          ],
          [
            14.625425,
            53.839402,
            40.051355
          ],
          [
            14.625401,
            53.839161,
            40.450623
          ],
          [
            14.62544,
            53.838912,
            40.864184
          ],
          [
            14.625491,
            53.838687,
            41.240149
          ],
          [
            14.625523,
            53.838457,
            41.621829
          ],
          [
            14.625544,
            53.838219,
            42.015996
          ],
          [
            14.625549,
            53.837981,
            42.409983
          ],
          [
            14.625522,
            53.837754,
            42.786439
          ],
          [
            14.625452,
            53.837546,
            43.000034
          ],
          [
            14.625428,
            53.837341,
            43.136038
          ],
          [
            14.625437,
            53.837128,
            43.277134
          ],
          [
            14.625499,
            53.836911,
            43.422793
          ],
          [
            14.625586,
            53.836698,
            43.567764
          ],
          [
            14.625646,
            53.836481,
            43.713365
          ],
          [
            14.625644,
            53.836289,
            43.840562
          ],
          [
            14.625608,
            53.836098,
            43.967791
          ],
          [
            14.625571,
            53.835909,
            44.093862
          ],
          [
            14.625561,
            53.8357,
            44.092749
          ],
          [
            14.625496,
            53.835475,
            44.089404
          ],
          [
            14.625291,
            53.835283,
            44.086074
          ],
          [
            14.625108,
            53.835093,
            44.08287
          ],
          [
            14.624904,
            53.834908,
            44.079632
          ],
          [
            14.624759,
            53.83471,
            44.076467
          ],
          [
            14.624618,
            53.834534,
            44.073612
          ],
          [
            14.624449,
            53.834347,
            44.070502
          ],
          [
            14.624267,
            53.834146,
            44.041385
          ],
          [
            14.624049,
            53.833955,
            43.999323
          ],
          [
            14.623845,
            53.833774,
            43.95962
          ],
          [
            14.623661,
            53.833584,
            43.919625
          ],
          [
            14.623457,
            53.833386,
            43.877254
          ],
          [
            14.623312,
            53.833178,
            43.835532
          ],
          [
            14.623155,
            53.833,
            43.798827
          ],
          [
            14.622982,
            53.832818,
            43.760683
          ],
          [
            14.622822,
            53.832629,
            43.588275
          ],
          [
            14.622651,
            53.832433,
            43.261539
          ],
          [
            14.622454,
            53.832239,
            42.926166
          ],
          [
            14.622265,
            53.832046,
            42.595583
          ],
          [
            14.622079,
            53.831877,
            42.296645
          ],
          [
            14.621884,
            53.831688,
            41.968422
          ],
          [
            14.621699,
            53.831495,
            41.639766
          ],
          [
            14.621549,
            53.831277,
            41.290827
          ],
          [
            14.621473,
            53.831051,
            41.079396
          ],
          [
            14.621433,
            53.830836,
            41.089766
          ],
          [
            14.621436,
            53.830644,
            41.098968
          ],
          [
            14.621403,
            53.830442,
            41.108695
          ],
          [
            14.621361,
            53.83025,
            41.117973
          ],
          [
            14.621313,
            53.830039,
            41.128176
          ],
          [
            14.621255,
            53.829816,
            41.138995
          ],
          [
            14.621216,
            53.829579,
            41.150421
          ],
          [
            14.621187,
            53.829334,
            41.153691
          ],
          [
            14.621126,
            53.829102,
            41.029684
          ],
          [
            14.62109,
            53.828888,
            40.915666
          ],
          [
            14.621049,
            53.828644,
            40.786133
          ],
          [
            14.620979,
            53.82843,
            40.670953
          ],
          [
            14.620998,
            53.828239,
            40.569842
          ],
          [
            14.620983,
            53.827987,
            40.43653
          ],
          [
            14.620945,
            53.827751,
            40.311339
          ],
          [
            14.620878,
            53.82753,
            40.337215
          ],
          [
            14.620841,
            53.827334,
            41.022089
          ],
          [
            14.62078,
            53.827129,
            41.745734
          ],
          [
            14.620706,
            53.82692,
            42.489172
          ],
          [
            14.620597,
            53.826742,
            43.145326
          ],
          [
            14.620426,
            53.82659,
            43.777888
          ],
          [
            14.620164,
            53.826434,
            44.546716
          ],
          [
            14.619891,
            53.826308,
            45.256847
          ],
          [
            14.619621,
            53.826157,
            46.019483
          ],
          [
            14.619387,
            53.82599,
            46.437701
          ],
          [
            14.619199,
            53.825809,
            46.416677
          ],
          [
            14.619032,
            53.825619,
            46.395484
          ],
          [
            14.618873,
            53.825456,
            46.376826
          ],
          [
            14.618692,
            53.825275,
            46.356
          ],
          [
            14.618521,
            53.825067,
            46.333105
          ],
          [
            14.618395,
            53.824883,
            46.313458
          ],
          [
            14.618265,
            53.82469,
            46.292898
          ],
          [
            14.618107,
            53.824521,
            46.273786
          ],
          [
            14.617953,
            53.824337,
            46.291998
          ],
          [
            14.617784,
            53.824156,
            46.322632
          ],
          [
            14.617656,
            53.823956,
            46.35444
          ],
          [
            14.617481,
            53.823757,
            46.387673
          ],
          [
            14.617341,
            53.823556,
            46.419881
          ],
          [
            14.617199,
            53.823378,
            46.449044
          ],
          [
            14.617072,
            53.823182,
            46.480146
          ],
          [
            14.616965,
            53.822999,
            46.508838
          ],
          [
            14.616836,
            53.822804,
            46.648535
          ],
          [
            14.616671,
            53.822622,
            47.435294
          ],
          [
            14.616543,
            53.822424,
            48.24371
          ],
          [
            14.616386,
            53.822243,
            49.018179
          ],
          [
            14.616254,
            53.822071,
            49.737557
          ],
          [
            14.616149,
            53.821879,
            50.505721
          ],
          [
            14.616011,
            53.821694,
            51.27557
          ],
          [
            14.61587,
            53.821518,
            52.017604
          ],
          [
            14.615766,
            53.821342,
            52.72742
          ],
          [
            14.615666,
            53.821149,
            53.368729
          ],
          [
            14.615529,
            53.820986,
            53.288562
          ],
          [
            14.615386,
            53.820795,
            53.196513
          ],
          [
            14.615238,
            53.820599,
            53.101965
          ],
          [
            14.615128,
            53.820409,
            53.013461
          ],
          [
            14.615031,
            53.820183,
            52.910724
          ],
          [
            14.614984,
            53.819956,
            52.809933
          ],
          [
            14.614954,
            53.819695,
            52.694673
          ],
          [
            14.614917,
            53.81944,
            52.557856
          ],
          [
            14.6149,
            53.819197,
            52.110389
          ],
          [
            14.614859,
            53.818974,
            51.697839
          ],
          [
            14.614854,
            53.818737,
            51.261968
          ],
          [
            14.614859,
            53.818506,
            50.837075
          ],
          [
            14.614864,
            53.818271,
            50.404439
          ],
          [
            14.614861,
            53.818043,
            49.983801
          ],
          [
            14.614836,
            53.817856,
            49.638824
          ],
          [
            14.614805,
            53.817659,
            49.281569
          ],
          [
            14.614827,
            53.817424,
            49.267275
          ],
          [
            14.614793,
            53.817165,
            49.2514
          ],
          [
            14.614776,
            53.81693,
            49.237097
          ],
          [
            14.614759,
            53.816745,
            49.225845
          ],
          [
            14.614717,
            53.816494,
            49.210506
          ],
          [
            14.614696,
            53.816237,
            49.194882
          ],
          [
            14.61466,
            53.815982,
            49.17934
          ],
          [
            14.61468,
            53.81574,
            49.179465
          ],
          [
            14.614664,
            53.815494,
            49.192421
          ],
          [
            14.614651,
            53.815258,
            49.204849
          ],
          [
            14.614646,
            53.815043,
            49.216168
          ],
          [
            14.614664,
            53.814822,
            49.227811
          ],
          [
            14.614675,
            53.81461,
            49.238973
          ],
          [
            14.614688,
            53.814411,
            49.249479
          ],
          [
            14.614715,
            53.814212,
            49.260062
          ],
          [
            14.614729,
            53.814004,
            49.132329
          ],
          [
            14.614732,
            53.813807,
            48.76374
          ],
          [
            14.614749,
            53.813596,
            48.367458
          ],
          [
            14.614763,
            53.813388,
            47.978007
          ],
          [
            14.61481,
            53.813177,
            47.57919
          ],
          [
            14.614843,
            53.812981,
            47.210422
          ],
          [
            14.614864,
            53.812763,
            46.801955
          ],
          [
            14.614871,
            53.812546,
            46.39594
          ],
          [
            14.61486,
            53.812329,
            45.989838
          ],
          [
            14.614823,
            53.81213,
            45.655887
          ],
          [
            14.614763,
            53.811934,
            45.337313
          ],
          [
            14.614717,
            53.811724,
            44.999711
          ],
          [
            14.614639,
            53.811532,
            44.684491
          ],
          [
            14.614571,
            53.811323,
            44.342553
          ],
          [
            14.614567,
            53.811123,
            44.021731
          ],
          [
            14.614536,
            53.810876,
            43.626517
          ],
          [
            14.6145,
            53.810632,
            43.235919
          ],
          [
            14.614498,
            53.810393,
            43.148707
          ],
          [
            14.614516,
            53.810153,
            43.389487
          ],
          [
            14.614577,
            53.809902,
            43.642437
          ],
          [
            14.614621,
            53.809683,
            43.86236
          ],
          [
            14.614653,
            53.809437,
            44.108349
          ],
          [
            14.614658,
            53.80923,
            44.315871
          ],
          [
            14.614656,
            53.808997,
            44.548411
          ],
          [
            14.614653,
            53.808811,
            44.733859
          ],
          [
            14.614699,
            53.808614,
            44.861463
          ],
          [
            14.614739,
            53.808401,
            44.928839
          ],
          [
            14.614835,
            53.808196,
            44.996228
          ],
          [
            14.614885,
            53.807947,
            45.075087
          ],
          [
            14.614961,
            53.807691,
            45.156795
          ],
          [
            14.615042,
            53.807451,
            45.233793
          ],
          [
            14.615131,
            53.807242,
            45.301759
          ],
          [
            14.615229,
            53.807045,
            45.366368
          ],
          [
            14.615279,
            53.806843,
            45.344521
          ],
          [
            14.615354,
            53.806629,
            45.250227
          ],
          [
            14.615454,
            53.806415,
            45.154114
          ],
          [
            14.615548,
            53.806226,
            45.069123
          ],
          [
            14.615608,
            53.806017,
            44.97752
          ],
          [
            14.615693,
            53.805813,
            44.88687
          ],
          [
            14.615777,
            53.805597,
            44.791247
          ],
          [
            14.615785,
            53.805396,
            44.704316
          ],
          [
            14.615791,
            53.80519,
            44.609318
          ],
          [
            14.615763,
            53.804998,
            44.348284
          ],
          [
            14.615789,
            53.804768,
            44.036649
          ],
          [
            14.615808,
            53.804538,
            43.72547
          ],
          [
            14.615832,
            53.804334,
            43.449122
          ],
          [
            14.615864,
            53.804142,
            43.188405
          ],
          [
            14.615821,
            53.803931,
            42.90018
          ],
          [
            14.615708,
            53.803728,
            42.609256
          ],
          [
            14.61555,
            53.803547,
            42.333988
          ],
          [
            14.615408,
            53.803366,
            42.340522
          ],
          [
            14.615251,
            53.803191,
            42.672325
          ],
          [
            14.615099,
            53.80299,
            43.041008
          ],
          [
            14.614949,
            53.802818,
            43.36505
          ],
          [
            14.614835,
            53.802618,
            43.720834
          ],
          [
            14.614775,
            53.802431,
            44.03956
          ],
          [
            14.614735,
            53.802231,
            44.376793
          ],
          [
            14.614702,
            53.801997,
            44.769999
          ],
          [
            14.614687,
            53.801798,
            45.103597
          ],
          [
            14.614698,
            53.801605,
            45.032155
          ],
          [
            14.614701,
            53.801418,
            44.802225
          ],
          [
            14.61472,
            53.801202,
            44.536247
          ],
          [
            14.614713,
            53.801006,
            44.295103
          ],
          [
            14.61472,
            53.800803,
            44.045489
          ],
          [
            14.614712,
            53.800596,
            43.790844
          ],
          [
            14.614698,
            53.80038,
            43.525092
          ],
          [
            14.614695,
            53.800177,
            43.27539
          ],
          [
            14.614711,
            53.799969,
            43.019411
          ],
          [
            14.614739,
            53.799761,
            42.997074
          ],
          [
            14.614756,
            53.799551,
            43.007115
          ],
          [
            14.614728,
            53.799357,
            43.016401
          ],
          [
            14.614754,
            53.799162,
            43.02576
          ],
          [
            14.614714,
            53.798974,
            43.034809
          ],
          [
            14.614749,
            53.798768,
            43.044683
          ],
          [
            14.614775,
            53.798558,
            43.05474
          ],
          [
            14.614779,
            53.798349,
            43.064727
          ],
          [
            14.614756,
            53.798144,
            43.082363
          ],
          [
            14.614736,
            53.797955,
            43.248592
          ],
          [
            14.614739,
            53.797772,
            43.409279
          ],
          [
            14.61477,
            53.797568,
            43.58919
          ],
          [
            14.614791,
            53.797373,
            43.760833
          ],
          [
            14.614808,
            53.797184,
            43.927001
          ],
          [
            14.61481,
            53.796995,
            44.092912
          ],
          [
            14.614786,
            53.796796,
            44.268017
          ],
          [
            14.614781,
            53.796593,
            44.446295
          ],
          [
            14.614782,
            53.796382,
            44.631571
          ],
          [
            14.614776,
            53.796168,
            44.626293
          ],
          [
            14.61477,
            53.795963,
            44.597797
          ],
          [
            14.614734,
            53.795732,
            44.565561
          ],
          [
            14.614757,
            53.795499,
            44.533135
          ],
          [
            14.614791,
            53.795279,
            44.50244
          ],
          [
            14.614803,
            53.795066,
            44.47281
          ],
          [
            14.614809,
            53.794854,
            44.443353
          ],
          [
            14.614829,
            53.794601,
            44.408162
          ],
          [
            14.614802,
            53.794369,
            44.143755
          ],
          [
            14.614813,
            53.794123,
            43.815113
          ],
          [
            14.614819,
            53.793889,
            43.502516
          ],
          [
            14.614822,
            53.793651,
            43.184618
          ],
          [
            14.614798,
            53.793408,
            42.858857
          ],
          [
            14.614808,
            53.793161,
            42.528516
          ],
          [
            14.614797,
            53.792911,
            42.194512
          ],
          [
            14.614796,
            53.792666,
            42.036316
          ],
          [
            14.614846,
            53.792441,
            42.117016
          ],
          [
            14.614988,
            53.792234,
            42.196211
          ],
          [
            14.615129,
            53.792026,
            42.275738
          ],
          [
            14.61524,
            53.791819,
            42.352701
          ],
          [
            14.615387,
            53.791628,
            42.427256
          ],
          [
            14.615518,
            53.791438,
            42.500086
          ],
          [
            14.61567,
            53.79123,
            42.580411
          ],
          [
            14.615841,
            53.791041,
            42.788315
          ],
          [
            14.615985,
            53.790873,
            43.340257
          ],
          [
            14.616138,
            53.790703,
            43.904964
          ],
          [
            14.616284,
            53.790524,
            44.487484
          ],
          [
            14.616471,
            53.790322,
            45.162843
          ],
          [
            14.61664,
            53.790138,
            45.777411
          ],
          [
            14.616837,
            53.789965,
            46.389075
          ],
          [
            14.617068,
            53.789821,
            46.970586
          ],
          [
            14.617056,
            53.789672,
            47.584761
          ],
          [
            14.616702,
            53.78961,
            47.875389
          ],
          [
            14.616363,
            53.789541,
            47.806564
          ],
          [
            14.616018,
            53.789492,
            47.738445
          ],
          [
            14.615679,
            53.789438,
            47.670784
          ],
          [
            14.615345,
            53.789386,
            47.604509
          ],
          [
            14.615002,
            53.789335,
            47.536688
          ],
          [
            14.614662,
            53.789311,
            47.470817
          ],
          [
            14.614289,
            53.789284,
            47.398644
          ],
          [
            14.613972,
            53.789342,
            47.334348
          ],
          [
            14.613707,
            53.789455,
            46.666537
          ],
          [
            14.613373,
            53.789455,
            45.88511
          ],
          [
            14.613052,
            53.789363,
            45.054661
          ],
          [
            14.612777,
            53.789258,
            44.296578
          ],
          [
            14.612544,
            53.789116,
            43.499773
          ],
          [
            14.612433,
            53.788929,
            42.722277
          ],
          [
            14.612402,
            53.788707,
            41.846718
          ],
          [
            14.612366,
            53.788491,
            40.995959
          ],
          [
            14.612355,
            53.788298,
            40.289909
          ],
          [
            14.612324,
            53.788098,
            40.376812
          ],
          [
            14.612271,
            53.787796,
            40.5084
          ],
          [
            14.612251,
            53.787579,
            40.602457
          ],
          [
            14.612218,
            53.787389,
            40.68511
          ],
          [
            14.612195,
            53.787156,
            40.786103
          ],
          [
            14.612167,
            53.786952,
            40.874666
          ],
          [
            14.612128,
            53.786738,
            40.96782
          ],
          [
            14.612167,
            53.786545,
            41.052499
          ],
          [
            14.612356,
            53.786339,
            41.123616
          ],
          [
            14.612572,
            53.786196,
            41.177821
          ],
          [
            14.612805,
            53.786056,
            41.233337
          ],
          [
            14.613045,
            53.785919,
            41.289095
          ],
          [
            14.613354,
            53.785879,
            41.342775
          ],
          [
            14.613742,
            53.78587,
            41.40769
          ],
          [
            14.614007,
            53.785766,
            41.462009
          ],
          [
            14.614178,
            53.78558,
            41.521867
          ],
          [
            14.614372,
            53.785402,
            41.567239
          ],
          [
            14.614572,
            53.785215,
            41.539539
          ],
          [
            14.614785,
            53.785022,
            41.510626
          ],
          [
            14.614986,
            53.784852,
            41.484647
          ],
          [
            14.615157,
            53.784686,
            41.460303
          ],
          [
            14.615392,
            53.784499,
            41.431131
          ],
          [
            14.615611,
            53.784319,
            41.403364
          ],
          [
            14.615771,
            53.784126,
            41.376248
          ],
          [
            14.615841,
            53.783919,
            41.349793
          ],
          [
            14.615898,
            53.783719,
            41.491605
          ],
          [
            14.616001,
            53.783523,
            41.660493
          ],
          [
            14.616091,
            53.783306,
            41.845218
          ],
          [
            14.616205,
            53.783108,
            42.017436
          ],
          [
            14.616303,
            53.78291,
            42.187125
          ],
          [
            14.616351,
            53.782682,
            42.376707
          ],
          [
            14.616372,
            53.782473,
            42.548931
          ],
          [
            14.616369,
            53.782257,
            42.72688
          ],
          [
            14.616381,
            53.782055,
            42.762811
          ],
          [
            14.616386,
            53.781863,
            42.61576
          ],
          [
            14.616313,
            53.781683,
            42.473825
          ],
          [
            14.616287,
            53.781487,
            42.323246
          ],
          [
            14.616267,
            53.781279,
            42.163789
          ],
          [
            14.616188,
            53.781105,
            42.025163
          ],
          [
            14.615895,
            53.780961,
            41.850003
          ],
          [
            14.61557,
            53.780857,
            41.682856
          ],
          [
            14.615242,
            53.780745,
            41.511389
          ],
          [
            14.614992,
            53.780613,
            41.411072
          ],
          [
            14.614879,
            53.780409,
            41.339912
          ],
          [
            14.614849,
            53.780199,
            41.27163
          ],
          [
            14.614879,
            53.779995,
            41.205268
          ],
          [
            14.614878,
            53.77976,
            41.129134
          ],
          [
            14.614891,
            53.779533,
            41.055396
          ],
          [
            14.614858,
            53.779302,
            40.98025
          ],
          [
            14.614859,
            53.779085,
            40.909948
          ],
          [
            14.614897,
            53.778862,
            41.00411
          ],
          [
            14.614969,
            53.778632,
            41.361855
          ],
          [
            14.615047,
            53.778408,
            41.711611
          ],
          [
            14.615124,
            53.778193,
            42.047697
          ],
          [
            14.615221,
            53.777972,
            42.396853
          ],
          [
            14.615339,
            53.777771,
            42.722375
          ],
          [
            14.615451,
            53.777596,
            43.008618
          ],
          [
            14.615582,
            53.777427,
            43.292906
          ],
          [
            14.615688,
            53.777246,
            43.585814
          ],
          [
            14.615781,
            53.77706,
            43.400153
          ],
          [
            14.615825,
            53.776865,
            43.154078
          ],
          [
            14.615839,
            53.776671,
            42.911241
          ],
          [
            14.615827,
            53.776467,
            42.656029
          ],
          [
            14.615838,
            53.776266,
            42.404352
          ],
          [
            14.615809,
            53.776073,
            42.162024
          ],
          [
            14.615791,
            53.775857,
            41.891552
          ],
          [
            14.615808,
            53.775633,
            41.611031
          ],
          [
            14.615821,
            53.775448,
            41.379534
          ],
          [
            14.61583,
            53.775257,
            41.362992
          ],
          [
            14.615839,
            53.775063,
            41.357306
          ],
          [
            14.615827,
            53.774845,
            41.350916
          ],
          [
            14.615785,
            53.774639,
            41.344831
          ],
          [
            14.615742,
            53.774405,
            41.33793
          ],
          [
            14.615813,
            53.77421,
            41.332078
          ],
          [
            14.615964,
            53.774004,
            41.3255
          ],
          [
            14.616086,
            53.773821,
            41.31974
          ],
          [
            14.616235,
            53.773613,
            41.329222
          ],
          [
            14.61635,
            53.773414,
            41.362238
          ],
          [
            14.616539,
            53.77324,
            41.394711
          ],
          [
            14.616756,
            53.773086,
            41.426175
          ],
          [
            14.617015,
            53.772932,
            41.460281
          ],
          [
            14.617261,
            53.772781,
            41.493199
          ],
          [
            14.617411,
            53.772598,
            41.525131
          ],
          [
            14.617533,
            53.772414,
            41.556184
          ],
          [
            14.617504,
            53.772204,
            41.589599
          ],
          [
            14.617446,
            53.771986,
            41.61853
          ],
          [
            14.617392,
            53.771798,
            41.641953
          ],
          [
            14.617328,
            53.771587,
            41.668284
          ],
          [
            14.617275,
            53.771397,
            41.691945
          ],
          [
            14.617214,
            53.771198,
            41.716786
          ],
          [
            14.617158,
            53.771009,
            41.740363
          ],
          [
            14.617091,
            53.770828,
            41.763121
          ],
          [
            14.617044,
            53.770644,
            41.785984
          ],
          [
            14.616995,
            53.770442,
            41.811064
          ],
          [
            14.616927,
            53.77022,
            42.054049
          ],
          [
            14.6168,
            53.770009,
            42.379414
          ],
          [
            14.616698,
            53.769816,
            42.673631
          ],
          [
            14.616605,
            53.769628,
            42.958293
          ],
          [
            14.616529,
            53.769429,
            43.254781
          ],
          [
            14.616455,
            53.76923,
            43.550786
          ],
          [
            14.61638,
            53.769045,
            43.827383
          ],
          [
            14.616303,
            53.768847,
            44.122709
          ],
          [
            14.616209,
            53.768624,
            44.433598
          ],
          [
            14.616123,
            53.768419,
            44.455992
          ],
          [
            14.616063,
            53.76821,
            44.478468
          ],
          [
            14.615961,
            53.76799,
            44.502668
          ],
          [
            14.615856,
            53.767769,
            44.527014
          ],
          [
            14.615786,
            53.767568,
            44.548825
          ],
          [
            14.615677,
            53.767345,
            44.57344
          ],
          [
            14.615601,
            53.767141,
            44.595584
          ],
          [
            14.615526,
            53.76693,
            44.618448
          ],
          [
            14.615452,
            53.766702,
            44.611084
          ],
          [
            14.615361,
            53.766522,
            44.600084
          ],
          [
            14.615276,
            53.766308,
            44.587219
          ],
          [
            14.615209,
            53.766114,
            44.575632
          ],
          [
            14.615108,
            53.765909,
            44.563137
          ],
          [
            14.614998,
            53.765689,
            44.54971
          ],
          [
            14.614914,
            53.765486,
            44.537478
          ],
          [
            14.614827,
            53.765254,
            44.52357
          ],
          [
            14.614713,
            53.765052,
            44.30544
          ],
          [
            14.614592,
            53.764864,
            43.896709
          ],
          [
            14.614476,
            53.764671,
            43.481026
          ],
          [
            14.614319,
            53.764461,
            43.014622
          ],
          [
            14.614094,
            53.764265,
            42.533229
          ],
          [
            14.613811,
            53.764149,
            42.119974
          ],
          [
            14.61354,
            53.764034,
            41.719275
          ],
          [
            14.613264,
            53.763934,
            41.330878
          ],
          [
            14.61294,
            53.763821,
            40.878955
          ],
          [
            14.612663,
            53.763701,
            40.503753
          ],
          [
            14.612362,
            53.763563,
            40.090106
          ],
          [
            14.612011,
            53.763439,
            39.645746
          ],
          [
            14.611693,
            53.763317,
            39.233631
          ],
          [
            14.61144,
            53.763204,
            38.889296
          ],
          [
            14.611139,
            53.763066,
            38.475833
          ],
          [
            14.610869,
            53.762938,
            38.100083
          ],
          [
            14.610577,
            53.7628,
            37.694335
          ],
          [
            14.61032,
            53.762654,
            37.446933
          ],
          [
            14.610065,
            53.762542,
            37.28896
          ],
          [
            14.609787,
            53.762426,
            37.119743
          ],
          [
            14.609503,
            53.762308,
            36.947083
          ],
          [
            14.60924,
            53.762189,
            36.7821
          ],
          [
            14.608967,
            53.762042,
            36.598473
          ],
          [
            14.608713,
            53.761919,
            36.435194
          ],
          [
            14.60842,
            53.761817,
            36.265986
          ],
          [
            14.608135,
            53.761727,
            36.105303
          ],
          [
            14.607805,
            53.761658,
            36.623806
          ],
          [
            14.607486,
            53.761625,
            37.384231
          ],
          [
            14.607148,
            53.7616,
            38.183471
          ],
          [
            14.60682,
            53.761593,
            38.953484
          ],
          [
            14.606504,
            53.761592,
            39.694938
          ],
          [
            14.606126,
            53.761612,
            40.586279
          ],
          [
            14.605798,
            53.76163,
            41.35909
          ],
          [
            14.605474,
            53.761651,
            42.123846
          ],
          [
            14.605142,
            53.761696,
            42.922942
          ],
          [
            14.604778,
            53.761757,
            42.953055
          ],
          [
            14.604448,
            53.761802,
            42.649433
          ],
          [
            14.604132,
            53.761826,
            42.363708
          ],
          [
            14.603773,
            53.761859,
            42.03789
          ],
          [
            14.603425,
            53.761879,
            41.724304
          ],
          [
            14.603083,
            53.76187,
            41.417468
          ],
          [
            14.60271,
            53.761875,
            41.082713
          ],
          [
            14.602342,
            53.761902,
            40.750402
          ],
          [
            14.602009,
            53.761938,
            40.462688
          ],
          [
            14.601712,
            53.761995,
            40.449932
          ],
          [
            14.601365,
            53.762071,
            40.434816
          ],
          [
            14.601052,
            53.762164,
            40.4205
          ],
          [
            14.600767,
            53.762263,
            40.406993
          ],
          [
            14.600414,
            53.762354,
            40.391264
          ],
          [
            14.600059,
            53.762394,
            40.376471
          ],
          [
            14.599753,
            53.762393,
            40.363942
          ],
          [
            14.599433,
            53.762368,
            40.350756
          ],
          [
            14.599104,
            53.762345,
            40.348492
          ],
          [
            14.598771,
            53.762291,
            40.41328
          ],
          [
            14.598447,
            53.762225,
            40.477387
          ],
          [
            14.598094,
            53.76215,
            40.547581
          ],
          [
            14.597767,
            53.762056,
            40.615604
          ],
          [
            14.597449,
            53.761986,
            40.679087
          ],
          [
            14.597084,
            53.761927,
            40.749885
          ],
          [
            14.596724,
            53.761864,
            40.820157
          ],
          [
            14.596392,
            53.761818,
            40.884018
          ],
          [
            14.596063,
            53.76177,
            41.18332
          ],
          [
            14.595707,
            53.761757,
            41.653779
          ],
          [
            14.595386,
            53.761764,
            42.077374
          ],
          [
            14.595034,
            53.761787,
            42.544433
          ],
          [
            14.59467,
            53.761815,
            43.028558
          ],
          [
            14.594314,
            53.76184,
            43.501338
          ],
          [
            14.593936,
            53.761868,
            44.003876
          ],
          [
            14.593611,
            53.761893,
            44.436067
          ],
          [
            14.593272,
            53.761923,
            44.888276
          ],
          [
            14.592931,
            53.761963,
            44.294945
          ],
          [
            14.592606,
            53.761977,
            43.662786
          ],
          [
            14.592238,
            53.76198,
            42.948666
          ],
          [
            14.591876,
            53.761935,
            42.229823
          ],
          [
            14.591571,
            53.761859,
            41.586469
          ],
          [
            14.591315,
            53.761731,
            40.935785
          ],
          [
            14.591118,
            53.76155,
            40.229746
          ],
          [
            14.59099,
            53.761345,
            39.513209
          ],
          [
            14.590862,
            53.76113,
            39.095544
          ],
          [
            14.590812,
            53.760919,
            39.278362
          ],
          [
            14.590714,
            53.760736,
            39.442982
          ],
          [
            14.590642,
            53.760531,
            39.6225
          ],
          [
            14.590577,
            53.760305,
            39.8191
          ],
          [
            14.590482,
            53.760116,
            39.988277
          ],
          [
            14.590365,
            53.759908,
            40.176567
          ],
          [
            14.590175,
            53.759708,
            40.373246
          ],
          [
            14.589972,
            53.75955,
            40.543539
          ],
          [
            14.589752,
            53.759391,
            40.563292
          ],
          [
            14.589509,
            53.759256,
            40.556474
          ],
          [
            14.589251,
            53.759113,
            40.549255
          ],
          [
            14.589031,
            53.758962,
            40.542379
          ],
          [
            14.588874,
            53.758772,
            40.535074
          ],
          [
            14.588753,
            53.758551,
            40.52706
          ],
          [
            14.588612,
            53.758334,
            40.519039
          ],
          [
            14.588492,
            53.758114,
            40.511064
          ],
          [
            14.588316,
            53.757926,
            40.477335
          ],
          [
            14.588147,
            53.757733,
            40.415763
          ],
          [
            14.587994,
            53.757535,
            40.353913
          ],
          [
            14.587822,
            53.757346,
            40.293106
          ],
          [
            14.587653,
            53.757171,
            40.236012
          ],
          [
            14.587475,
            53.756982,
            40.174723
          ],
          [
            14.587296,
            53.756796,
            40.114098
          ],
          [
            14.587141,
            53.756605,
            40.054037
          ],
          [
            14.586902,
            53.756476,
            39.96649
          ],
          [
            14.586641,
            53.756366,
            39.581672
          ],
          [
            14.586343,
            53.756267,
            39.171451
          ],
          [
            14.586013,
            53.756205,
            38.755482
          ],
          [
            14.585717,
            53.756128,
            38.367325
          ],
          [
            14.585441,
            53.756035,
            37.98609
          ],
          [
            14.585173,
            53.755909,
            37.573948
          ],
          [
            14.584908,
            53.755784,
            37.166819
          ],
          [
            14.584625,
            53.755658,
            36.741687
          ],
          [
            14.584415,
            53.755509,
            36.347915
          ],
          [
            14.584203,
            53.755369,
            36.505264
          ],
          [
            14.583955,
            53.755225,
            36.678457
          ],
          [
            14.583728,
            53.755071,
            36.85041
          ],
          [
            14.583472,
            53.754907,
            37.038292
          ],
          [
            14.583245,
            53.754758,
            37.207224
          ],
          [
            14.583008,
            53.754614,
            37.376434
          ],
          [
            14.582771,
            53.754472,
            37.544458
          ],
          [
            14.582536,
            53.754327,
            37.71376
          ],
          [
            14.582245,
            53.754176,
            37.942868
          ],
          [
            14.581996,
            53.754062,
            38.222534
          ],
          [
            14.581657,
            53.753975,
            38.550686
          ],
          [
            14.581317,
            53.753885,
            38.881651
          ],
          [
            14.580994,
            53.753845,
            39.175157
          ],
          [
            14.58064,
            53.753845,
            39.490008
          ],
          [
            14.580296,
            53.753883,
            39.801968
          ],
          [
            14.579956,
            53.753941,
            40.116238
          ],
          [
            14.579628,
            53.754013,
            40.426966
          ],
          [
            14.579293,
            53.754064,
            40.573078
          ],
          [
            14.57895,
            53.754119,
            40.592602
          ],
          [
            14.578622,
            53.754177,
            40.611407
          ],
          [
            14.578283,
            53.754234,
            40.630827
          ],
          [
            14.577941,
            53.754284,
            40.650177
          ],
          [
            14.577608,
            53.75434,
            40.669192
          ],
          [
            14.577306,
            53.754388,
            40.686368
          ],
          [
            14.576936,
            53.75445,
            40.707502
          ],
          [
            14.576565,
            53.754499,
            40.728409
          ],
          [
            14.576217,
            53.754566,
            40.515105
          ],
          [
            14.575903,
            53.754666,
            40.294179
          ],
          [
            14.575589,
            53.754795,
            40.057322
          ],
          [
            14.575294,
            53.754904,
            39.841821
          ],
          [
            14.574986,
            53.755011,
            39.620672
          ],
          [
            14.574668,
            53.755129,
            39.388237
          ],
          [
            14.574333,
            53.755239,
            39.151025
          ],
          [
            14.574037,
            53.755346,
            38.936255
          ],
          [
            14.573774,
            53.755446,
            38.883787
          ],
          [
            14.573477,
            53.755552,
            38.961202
          ],
          [
            14.5732,
            53.755675,
            39.038488
          ],
          [
            14.57288,
            53.755759,
            39.117327
          ],
          [
            14.572532,
            53.755804,
            39.196839
          ],
          [
            14.572205,
            53.755835,
            39.270761
          ],
          [
            14.571876,
            53.755879,
            39.346054
          ],
          [
            14.571531,
            53.755919,
            39.424541
          ],
          [
            14.57119,
            53.755974,
            39.503417
          ],
          [
            14.570854,
            53.756013,
            39.491232
          ],
          [
            14.570473,
            53.756048,
            39.438132
          ],
          [
            14.570132,
            53.756105,
            39.389276
          ],
          [
            14.569798,
            53.756145,
            39.342002
          ],
          [
            14.569432,
            53.756178,
            39.290949
          ],
          [
            14.569086,
            53.75622,
            39.242283
          ],
          [
            14.568759,
            53.756267,
            39.195934
          ],
          [
            14.568391,
            53.756325,
            39.143468
          ],
          [
            14.568007,
            53.756373,
            39.137297
          ],
          [
            14.567622,
            53.75641,
            39.237961
          ],
          [
            14.567419,
            53.756281,
            39.328901
          ],
          [
            14.567381,
            53.756082,
            39.416659
          ],
          [
            14.56728,
            53.755866,
            39.514523
          ],
          [
            14.567178,
            53.755653,
            39.61113
          ],
          [
            14.567045,
            53.755447,
            39.70736
          ],
          [
            14.566921,
            53.755229,
            39.807744
          ],
          [
            14.566819,
            53.755031,
            39.90573
          ],
          [
            14.567041,
            53.754878,
            40.083942
          ],
          [
            14.567359,
            53.754744,
            40.284102
          ],
          [
            14.567638,
            53.754626,
            40.459913
          ],
          [
            14.567879,
            53.754477,
            40.639312
          ],
          [
            14.568088,
            53.754316,
            40.815278
          ],
          [
            14.568346,
            53.754153,
            41.00895
          ],
          [
            14.568585,
            53.754021,
            41.176575
          ],
          [
            14.568682,
            53.753839,
            41.353347
          ],
          [
            14.568446,
            53.753733,
            41.478547
          ],
          [
            14.56818,
            53.753842,
            41.54039
          ],
          [
            14.56789,
            53.753969,
            41.609334
          ],
          [
            14.567577,
            53.754063,
            41.676386
          ],
          [
            14.567258,
            53.754127,
            41.74071
          ],
          [
            14.566933,
            53.754165,
            41.803954
          ],
          [
            14.566596,
            53.754206,
            41.869659
          ],
          [
            14.566235,
            53.754232,
            41.939085
          ],
          [
            14.565892,
            53.754263,
            42.005556
          ],
          [
            14.565547,
            53.754302,
            41.851024
          ],
          [
            14.565184,
            53.754364,
            41.54094
          ],
          [
            14.564843,
            53.754403,
            41.25594
          ],
          [
            14.564506,
            53.754451,
            40.971533
          ],
          [
            14.56414,
            53.754479,
            40.668765
          ],
          [
            14.563795,
            53.75451,
            40.382467
          ],
          [
            14.563433,
            53.754557,
            40.078382
          ],
          [
            14.563085,
            53.754609,
            39.783913
          ],
          [
            14.562735,
            53.754626,
            39.506036
          ],
          [
            14.562365,
            53.754659,
            39.280001
          ],
          [
            14.56204,
            53.754705,
            39.078104
          ],
          [
            14.561685,
            53.754739,
            38.860601
          ],
          [
            14.561357,
            53.754773,
            38.659432
          ],
          [
            14.561014,
            53.754815,
            38.447551
          ],
          [
            14.560671,
            53.754856,
            38.23617
          ],
          [
            14.560352,
            53.754902,
            38.037812
          ],
          [
            14.560022,
            53.754942,
            37.833779
          ],
          [
            14.559663,
            53.754957,
            37.629625
          ],
          [
            14.559313,
            53.754997,
            37.449629
          ],
          [
            14.558971,
            53.754966,
            37.274026
          ],
          [
            14.558769,
            53.754819,
            37.106827
          ],
          [
            14.558803,
            53.75461,
            36.925981
          ],
          [
            14.558914,
            53.754407,
            36.743743
          ],
          [
            14.559022,
            53.754188,
            36.548642
          ],
          [
            14.559158,
            53.753996,
            36.370468
          ],
          [
            14.559276,
            53.753808,
            36.199155
          ],
          [
            14.559423,
            53.753607,
            36.450764
          ],
          [
            14.559531,
            53.75342,
            36.776246
          ],
          [
            14.559637,
            53.753196,
            37.159884
          ],
          [
            14.559654,
            53.753012,
            37.463008
          ],
          [
            14.55963,
            53.752803,
            37.807923
          ],
          [
            14.559616,
            53.752592,
            38.155327
          ],
          [
            14.559593,
            53.752366,
            38.528008
          ],
          [
            14.559554,
            53.752157,
            38.87442
          ],
          [
            14.559523,
            53.751948,
            39.079114
          ],
          [
            14.559511,
            53.75172,
            38.922182
          ],
          [
            14.559469,
            53.751491,
            38.763731
          ],
          [
            14.559412,
            53.751283,
            38.618834
          ],
          [
            14.559369,
            53.751088,
            38.483524
          ],
          [
            14.559355,
            53.750893,
            38.349316
          ],
          [
            14.559324,
            53.750687,
            38.207102
          ],
          [
            14.559315,
            53.75047,
            38.057805
          ],
          [
            14.559273,
            53.750248,
            37.904082
          ],
          [
            14.559211,
            53.750018,
            37.818358
          ],
          [
            14.559103,
            53.749833,
            37.755312
          ],
          [
            14.559028,
            53.749641,
            37.691839
          ],
          [
            14.558929,
            53.749439,
            37.624154
          ],
          [
            14.558821,
            53.749228,
            37.553214
          ],
          [
            14.558684,
            53.749026,
            37.483125
          ],
          [
            14.558588,
            53.748814,
            37.412501
          ],
          [
            14.558509,
            53.748631,
            37.351698
          ],
          [
            14.558435,
            53.748436,
            37.242639
          ],
          [
            14.558323,
            53.748227,
            36.993854
          ],
          [
            14.55823,
            53.748021,
            36.751889
          ],
          [
            14.558116,
            53.747805,
            36.495077
          ],
          [
            14.558061,
            53.747625,
            36.287398
          ],
          [
            14.55799,
            53.747406,
            36.033855
          ],
          [
            14.55788,
            53.7472,
            35.788717
          ],
          [
            14.557791,
            53.747012,
            35.566663
          ],
          [
            14.557683,
            53.746795,
            35.309967
          ],
          [
            14.557594,
            53.746588,
            35.2183
          ],
          [
            14.557474,
            53.746383,
            35.160884
          ],
          [
            14.55736,
            53.746182,
            35.104806
          ],
          [
            14.557243,
            53.745992,
            35.051322
          ],
          [
            14.5571,
            53.745781,
            34.991168
          ],
          [
            14.556969,
            53.745558,
            34.928722
          ],
          [
            14.556827,
            53.745339,
            34.866633
          ],
          [
            14.556686,
            53.74514,
            34.809462
          ],
          [
            14.556564,
            53.744961,
            34.967676
          ],
          [
            14.556429,
            53.744758,
            35.312306
          ],
          [
            14.556316,
            53.744534,
            35.681715
          ],
          [
            14.556199,
            53.744341,
            36.006104
          ],
          [
            14.556093,
            53.744127,
            36.358355
          ],
          [
            14.556011,
            53.743939,
            36.665316
          ],
          [
            14.555923,
            53.74374,
            36.990648
          ],
          [
            14.555881,
            53.743526,
            37.331736
          ],
          [
            14.555883,
            53.743317,
            37.638178
          ],
          [
            14.555944,
            53.743119,
            37.720944
          ],
          [
            14.55604,
            53.742913,
            37.808895
          ],
          [
            14.556167,
            53.742727,
            37.891399
          ],
          [
            14.55632,
            53.742538,
            37.977728
          ],
          [
            14.556472,
            53.742365,
            38.058034
          ],
          [
            14.556591,
            53.742174,
            38.141742
          ],
          [
            14.556641,
            53.741982,
            38.221927
          ],
          [
            14.556623,
            53.741775,
            38.307299
          ],
          [
            14.556568,
            53.741575,
            38.403872
          ],
          [
            14.55647,
            53.741358,
            38.553079
          ],
          [
            14.556391,
            53.741167,
            38.683736
          ],
          [
            14.556337,
            53.740948,
            38.830773
          ],
          [
            14.556266,
            53.740725,
            38.981517
          ],
          [
            14.5562,
            53.740512,
            39.125396
          ],
          [
            14.556116,
            53.740285,
            39.279778
          ],
          [
            14.556058,
            53.740071,
            39.423881
          ],
          [
            14.556014,
            53.739875,
            39.555499
          ],
          [
            14.555958,
            53.739674,
            39.627168
          ],
          [
            14.555915,
            53.739447,
            39.702749
          ],
          [
            14.555877,
            53.739225,
            39.776582
          ],
          [
            14.555848,
            53.73903,
            39.841498
          ],
          [
            14.555805,
            53.738827,
            39.909234
          ],
          [
            14.555759,
            53.738616,
            39.979632
          ],
          [
            14.555706,
            53.738411,
            40.048303
          ],
          [
            14.555632,
            53.738204,
            40.11869
          ],
          [
            14.555555,
            53.737987,
            39.993477
          ],
          [
            14.555442,
            53.737781,
            39.633171
          ],
          [
            14.555355,
            53.737593,
            39.308829
          ],
          [
            14.555256,
            53.737394,
            38.963694
          ],
          [
            14.555142,
            53.737214,
            38.643872
          ],
          [
            14.555044,
            53.737014,
            38.297442
          ],
          [
            14.55494,
            53.736833,
            37.979375
          ],
          [
            14.554785,
            53.736619,
            37.5919
          ],
          [
            14.55461,
            53.736446,
            37.25634
          ],
          [
            14.554401,
            53.736253,
            37.211801
          ],
          [
            14.554201,
            53.736054,
            37.271345
          ],
          [
            14.55409,
            53.73585,
            37.326508
          ],
          [
            14.554058,
            53.735643,
            37.37992
          ],
          [
            14.554032,
            53.735429,
            37.435065
          ],
          [
            14.554025,
            53.735203,
            37.493145
          ],
          [
            14.55398,
            53.734998,
            37.546272
          ],
          [
            14.553967,
            53.734787,
            37.600532
          ],
          [
            14.553975,
            53.734584,
            37.56633
          ],
          [
            14.553971,
            53.734375,
            37.425397
          ],
          [
            14.553916,
            53.734161,
            37.279438
          ],
          [
            14.553852,
            53.733954,
            37.137424
          ],
          [
            14.55378,
            53.73377,
            37.010045
          ],
          [
            14.553701,
            53.733591,
            36.885215
          ],
          [
            14.553611,
            53.733362,
            36.726667
          ],
          [
            14.553521,
            53.733179,
            36.598173
          ],
          [
            14.553431,
            53.732997,
            36.470316
          ],
          [
            14.553483,
            53.732786,
            36.681738
          ],
          [
            14.553792,
            53.732737,
            37.035243
          ],
          [
            14.55413,
            53.732714,
            37.408046
          ],
          [
            14.55442,
            53.732638,
            37.758879
          ],
          [
            14.554466,
            53.732457,
            38.106715
          ],
          [
            14.554353,
            53.732286,
            38.44739
          ],
          [
            14.554216,
            53.732108,
            38.809681
          ],
          [
            14.554217,
            53.731893,
            39.209838
          ],
          [
            14.554297,
            53.73169,
            39.596295
          ],
          [
            14.554428,
            53.731511,
            39.847323
          ],
          [
            14.554609,
            53.731365,
            40.007701
          ],
          [
            14.554857,
            53.731223,
            40.188186
          ],
          [
            14.555091,
            53.731053,
            40.382191
          ],
          [
            14.555336,
            53.73089,
            40.575073
          ],
          [
            14.555621,
            53.730692,
            40.804985
          ],
          [
            14.555888,
            53.730505,
            41.02138
          ],
          [
            14.556184,
            53.730317,
            41.249266
          ],
          [
            14.556499,
            53.730187,
            41.281252
          ],
          [
            14.556859,
            53.730059,
            41.174278
          ],
          [
            14.557205,
            53.729936,
            41.071554
          ],
          [
            14.55751,
            53.729825,
            40.980363
          ],
          [
            14.557844,
            53.729721,
            40.884311
          ],
          [
            14.558133,
            53.729624,
            40.799742
          ],
          [
            14.558302,
            53.72943,
            40.693517
          ],
          [
            14.558266,
            53.729219,
            40.60229
          ],
          [
            14.558201,
            53.72902,
            40.49183
          ],
          [
            14.558071,
            53.728799,
            40.342156
          ],
          [
            14.557933,
            53.728603,
            40.20618
          ],
          [
            14.55782,
            53.728429,
            40.086742
          ],
          [
            14.557667,
            53.728254,
            39.960692
          ],
          [
            14.557523,
            53.728094,
            39.844569
          ],
          [
            14.55742,
            53.727917,
            39.724813
          ],
          [
            14.557318,
            53.727732,
            39.600333
          ],
          [
            14.557172,
            53.72754,
            39.465654
          ],
          [
            14.557025,
            53.727356,
            39.359613
          ],
          [
            14.556899,
            53.727183,
            39.276884
          ],
          [
            14.556773,
            53.727005,
            39.192125
          ],
          [
            14.556635,
            53.726834,
            39.108848
          ],
          [
            14.556495,
            53.726671,
            39.028542
          ],
          [
            14.556378,
            53.726494,
            38.945047
          ],
          [
            14.556259,
            53.726324,
            38.864245
          ],
          [
            14.556109,
            53.726134,
            38.772099
          ],
          [
            14.556013,
            53.725954,
            38.68909
          ],
          [
            14.555875,
            53.725766,
            38.649938
          ],
          [
            14.555751,
            53.725587,
            38.747538
          ],
          [
            14.555645,
            53.725403,
            38.84558
          ],
          [
            14.555499,
            53.72519,
            38.961489
          ],
          [
            14.555353,
            53.724997,
            39.068167
          ],
          [
            14.555201,
            53.724792,
            39.181073
          ],
          [
            14.555076,
            53.724616,
            39.277392
          ],
          [
            14.55494,
            53.724415,
            39.386594
          ],
          [
            14.554827,
            53.724224,
            39.488748
          ],
          [
            14.55476,
            53.724027,
            39.51352
          ],
          [
            14.554638,
            53.723818,
            39.483646
          ],
          [
            14.554575,
            53.723628,
            39.457475
          ],
          [
            14.554476,
            53.723429,
            39.429469
          ],
          [
            14.554443,
            53.723237,
            39.403322
          ],
          [
            14.554377,
            53.723023,
            39.373954
          ],
          [
            14.554338,
            53.722822,
            39.346618
          ],
          [
            14.554346,
            53.722609,
            39.317838
          ],
          [
            14.55434,
            53.722375,
            39.291545
          ],
          [
            14.554361,
            53.72218,
            39.459264
          ],
          [
            14.554393,
            53.721969,
            39.64121
          ],
          [
            14.554392,
            53.721763,
            39.818037
          ],
          [
            14.554414,
            53.721539,
            40.010648
          ],
          [
            14.554457,
            53.721356,
            40.169595
          ],
          [
            14.554577,
            53.721155,
            40.352785
          ],
          [
            14.554625,
            53.720967,
            40.516
          ],
          [
            14.554688,
            53.720783,
            40.677147
          ],
          [
            14.554811,
            53.720606,
            40.812152
          ],
          [
            14.554909,
            53.720405,
            40.536315
          ],
          [
            14.555001,
            53.72019,
            40.244621
          ],
          [
            14.555063,
            53.719971,
            39.952838
          ],
          [
            14.555049,
            53.71976,
            39.675075
          ],
          [
            14.55504,
            53.719528,
            39.370057
          ],
          [
            14.555016,
            53.71934,
            39.121832
          ],
          [
            14.554998,
            53.719146,
            38.866
          ],
          [
            14.55496,
            53.718938,
            38.5903
          ],
          [
            14.554942,
            53.718725,
            38.314158
          ],
          [
            14.554942,
            53.718534,
            38.069286
          ],
          [
            14.554912,
            53.718326,
            37.802241
          ],
          [
            14.554882,
            53.718122,
            37.540089
          ],
          [
            14.554876,
            53.717934,
            37.29957
          ],
          [
            14.554832,
            53.717727,
            37.032735
          ],
          [
            14.554812,
            53.717534,
            36.785547
          ],
          [
            14.554782,
            53.717325,
            36.5175
          ],
          [
            14.554748,
            53.717134,
            36.272067
          ],
          [
            14.554725,
            53.716946,
            36.158951
          ],
          [
            14.5547,
            53.716744,
            36.140334
          ],
          [
            14.554689,
            53.71654,
            36.121593
          ],
          [
            14.55464,
            53.716346,
            36.103597
          ],
          [
            14.554588,
            53.716142,
            36.08467
          ],
          [
            14.554578,
            53.715934,
            36.065575
          ],
          [
            14.554554,
            53.715729,
            36.046692
          ],
          [
            14.55452,
            53.715504,
            36.025969
          ],
          [
            14.554446,
            53.715307,
            36.007454
          ],
          [
            14.554368,
            53.715119,
            36.153783
          ],
          [
            14.554263,
            53.714937,
            36.341013
          ],
          [
            14.55416,
            53.714741,
            36.540512
          ],
          [
            14.554004,
            53.714551,
            36.746244
          ],
          [
            14.553856,
            53.714384,
            36.929524
          ],
          [
            14.553684,
            53.714212,
            37.123838
          ],
          [
            14.55349,
            53.714022,
            37.339608
          ],
          [
            14.553324,
            53.713852,
            37.530479
          ],
          [
            14.553162,
            53.713682,
            37.72018
          ],
          [
            14.552983,
            53.713507,
            37.997007
          ],
          [
            14.552812,
            53.713318,
            38.302528
          ],
          [
            14.552689,
            53.713127,
            38.593842
          ],
          [
            14.552581,
            53.712943,
            38.871374
          ],
          [
            14.552512,
            53.712727,
            39.184601
          ],
          [
            14.552473,
            53.712514,
            39.490008
          ],
          [
            14.552455,
            53.712313,
            39.781268
          ],
          [
            14.552384,
            53.712102,
            40.087822
          ],
          [
            14.552325,
            53.711907,
            40.314677
          ],
          [
            14.552134,
            53.711802,
            40.314677
          ],
          [
            14.551825,
            53.711754,
            40.314677
          ],
          [
            14.551507,
            53.711756,
            40.314677
          ],
          [
            14.551266,
            53.711695,
            40.314677
          ],
          [
            14.551327,
            53.711759,
            40.314677
          ]
        ]
      }
    }
  ]
}

let day35: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.551327,
            53.711759,
            40.314677
          ],
          [14.552237, 53.711590, 5.0],
          [14.551475, 53.708664, 6.5],
          [14.551003, 53.703583, 6.5],
          [14.551281, 53.702309, 6.25],
          [14.551266, 53.701980, 6.0],
          [14.550667, 53.700879, 5.25],
          [14.550518, 53.700699, 5.25],
          [14.550498, 53.700675, 5.25],
          [14.550148, 53.700388, 5.25],
          [14.549774, 53.700135, 4.75],
          [14.549533, 53.700005, 4.25],
          [14.548920, 53.699716, 3.25],
          [14.548591, 53.699562, 2.75],
          [14.548379, 53.699459, 2.5],
          [14.548702, 53.699273, 2.25],
          [
            14.548521,
            53.699461,
            40.759877
          ],
          [
            14.54759,
            53.698653,
            40.753612
          ],
          [
            14.547522,
            53.698437,
            40.736703
          ],
          [
            14.54741,
            53.6982,
            40.717719
          ],
          [
            14.547318,
            53.697992,
            40.701127
          ],
          [
            14.547155,
            53.697774,
            40.682735
          ],
          [
            14.546949,
            53.697571,
            40.664425
          ],
          [
            14.546751,
            53.69739,
            40.64783
          ],
          [
            14.546599,
            53.697191,
            40.630987
          ],
          [
            14.546544,
            53.696978,
            40.5156
          ],
          [
            14.546444,
            53.696777,
            40.273631
          ],
          [
            14.546112,
            53.69672,
            39.977321
          ],
          [
            14.545789,
            53.696819,
            39.72845
          ],
          [
            14.545478,
            53.696942,
            39.470462
          ],
          [
            14.545088,
            53.69703,
            39.18501
          ],
          [
            14.544748,
            53.697095,
            38.94074
          ],
          [
            14.544399,
            53.697157,
            38.691526
          ],
          [
            14.54399,
            53.697203,
            38.452648
          ],
          [
            14.543624,
            53.697261,
            38.279893
          ],
          [
            14.543313,
            53.697284,
            38.134346
          ],
          [
            14.543172,
            53.697445,
            37.990041
          ],
          [
            14.543188,
            53.697404,
            37.817019
          ],
          [
            14.543411,
            53.697291,
            37.672762
          ],
          [
            14.543712,
            53.69724,
            37.529251
          ],
          [
            14.544034,
            53.697201,
            37.379311
          ],
          [
            14.544347,
            53.697172,
            37.234544
          ],
          [
            14.544555,
            53.697057,
            37.420338
          ],
          [
            14.544394,
            53.696879,
            37.996305
          ],
          [
            14.544626,
            53.697082,
            38.697024
          ],
          [
            14.544932,
            53.697041,
            39.226902
          ],
          [
            14.545267,
            53.696978,
            39.819909
          ],
          [
            14.545585,
            53.696887,
            40.417232
          ],
          [
            14.545865,
            53.696804,
            40.946506
          ],
          [
            14.546233,
            53.696709,
            41.625299
          ],
          [
            14.546485,
            53.69659,
            42.181487
          ],
          [
            14.546649,
            53.696377,
            41.914954
          ],
          [
            14.546824,
            53.696198,
            41.529425
          ],
          [
            14.546954,
            53.696015,
            41.159293
          ],
          [
            14.547132,
            53.695848,
            40.791329
          ],
          [
            14.547261,
            53.695654,
            40.402012
          ],
          [
            14.547422,
            53.695442,
            39.968712
          ],
          [
            14.547479,
            53.695259,
            39.620025
          ],
          [
            14.547447,
            53.695065,
            39.256838
          ],
          [
            14.547415,
            53.694853,
            38.939804
          ],
          [
            14.547382,
            53.694657,
            38.975061
          ],
          [
            14.547354,
            53.694474,
            39.007927
          ],
          [
            14.547324,
            53.69424,
            39.049992
          ],
          [
            14.547262,
            53.694056,
            39.083709
          ],
          [
            14.54722,
            53.693798,
            39.130116
          ],
          [
            14.547201,
            53.693552,
            39.174163
          ],
          [
            14.547181,
            53.69334,
            39.212153
          ],
          [
            14.547208,
            53.69311,
            39.253453
          ],
          [
            14.547322,
            53.692866,
            39.864914
          ],
          [
            14.547425,
            53.692655,
            40.408249
          ],
          [
            14.547529,
            53.692409,
            41.034269
          ],
          [
            14.547616,
            53.69218,
            41.61383
          ],
          [
            14.547709,
            53.691931,
            42.243906
          ],
          [
            14.547849,
            53.691687,
            42.882936
          ],
          [
            14.547897,
            53.691461,
            43.445247
          ],
          [
            14.547963,
            53.691224,
            43.571039
          ],
          [
            14.548057,
            53.691021,
            43.383886
          ],
          [
            14.54813,
            53.690775,
            43.162321
          ],
          [
            14.548204,
            53.690564,
            42.971368
          ],
          [
            14.548299,
            53.690321,
            42.75052
          ],
          [
            14.548363,
            53.690071,
            42.525774
          ],
          [
            14.548485,
            53.689829,
            42.302144
          ],
          [
            14.54857,
            53.689655,
            42.141748
          ],
          [
            14.548648,
            53.689416,
            41.904658
          ],
          [
            14.548784,
            53.689206,
            41.681553
          ],
          [
            14.548861,
            53.68898,
            41.452829
          ],
          [
            14.548958,
            53.688742,
            41.20986
          ],
          [
            14.549017,
            53.68853,
            40.996449
          ],
          [
            14.549074,
            53.688315,
            40.78033
          ],
          [
            14.549186,
            53.688111,
            40.567235
          ],
          [
            14.549237,
            53.687919,
            40.373099
          ],
          [
            14.54935,
            53.687723,
            40.271641
          ],
          [
            14.549458,
            53.687512,
            40.210609
          ],
          [
            14.549522,
            53.687315,
            40.155383
          ],
          [
            14.549591,
            53.687097,
            40.094335
          ],
          [
            14.549633,
            53.686882,
            40.034755
          ],
          [
            14.549624,
            53.686655,
            39.972197
          ],
          [
            14.549603,
            53.686419,
            39.907149
          ],
          [
            14.549571,
            53.68618,
            39.84116
          ],
          [
            14.549545,
            53.685941,
            39.411191
          ],
          [
            14.549555,
            53.685706,
            38.856967
          ],
          [
            14.549543,
            53.68546,
            38.276429
          ],
          [
            14.549511,
            53.68522,
            37.709172
          ],
          [
            14.549504,
            53.684977,
            37.136536
          ],
          [
            14.549469,
            53.684735,
            36.564267
          ],
          [
            14.549455,
            53.684492,
            35.991396
          ],
          [
            14.549425,
            53.68424,
            35.712273
          ],
          [
            14.549462,
            53.683975,
            36.132624
          ],
          [
            14.549529,
            53.68372,
            36.539445
          ],
          [
            14.549557,
            53.683472,
            36.93112
          ],
          [
            14.54951,
            53.683236,
            37.306447
          ],
          [
            14.549385,
            53.682996,
            37.702227
          ],
          [
            14.549278,
            53.682751,
            38.101415
          ],
          [
            14.549174,
            53.682515,
            38.36424
          ],
          [
            14.549081,
            53.682276,
            38.042143
          ],
          [
            14.549023,
            53.682035,
            37.722423
          ],
          [
            14.548968,
            53.68179,
            37.397852
          ],
          [
            14.548902,
            53.681554,
            37.083695
          ],
          [
            14.548838,
            53.681314,
            36.764615
          ],
          [
            14.548774,
            53.681078,
            36.450721
          ],
          [
            14.548716,
            53.680843,
            36.138808
          ],
          [
            14.548659,
            53.680603,
            36.21184
          ],
          [
            14.548582,
            53.680374,
            36.411352
          ],
          [
            14.548502,
            53.680139,
            36.616227
          ],
          [
            14.548415,
            53.679906,
            36.820108
          ],
          [
            14.548332,
            53.679688,
            37.011399
          ],
          [
            14.548244,
            53.679464,
            37.207948
          ],
          [
            14.548174,
            53.67923,
            37.41099
          ],
          [
            14.548102,
            53.678993,
            37.647338
          ],
          [
            14.548029,
            53.678758,
            38.12927
          ],
          [
            14.547973,
            53.678525,
            38.604031
          ],
          [
            14.547926,
            53.678292,
            39.077659
          ],
          [
            14.547843,
            53.678087,
            39.502868
          ],
          [
            14.547791,
            53.677871,
            39.943013
          ],
          [
            14.547802,
            53.677635,
            40.419494
          ],
          [
            14.547906,
            53.67738,
            40.948925
          ],
          [
            14.548111,
            53.677144,
            41.495198
          ],
          [
            14.548263,
            53.676985,
            41.873421
          ],
          [
            14.548534,
            53.676831,
            42.333602
          ],
          [
            14.548865,
            53.676678,
            42.852628
          ],
          [
            14.549245,
            53.676575,
            43.364723
          ],
          [
            14.549676,
            53.676523,
            43.903878
          ],
          [
            14.550068,
            53.676489,
            44.389573
          ],
          [
            14.55038,
            53.676453,
            44.779469
          ],
          [
            14.550737,
            53.676393,
            44.577269
          ],
          [
            14.551101,
            53.676355,
            44.009807
          ],
          [
            14.551471,
            53.67631,
            43.430086
          ],
          [
            14.551855,
            53.676255,
            42.824572
          ],
          [
            14.552246,
            53.676201,
            42.20881
          ],
          [
            14.552623,
            53.676132,
            41.604023
          ],
          [
            14.553001,
            53.676097,
            41.01517
          ],
          [
            14.553304,
            53.676044,
            40.529332
          ],
          [
            14.553677,
            53.675985,
            40.507597
          ],
          [
            14.553972,
            53.675927,
            40.80455
          ],
          [
            14.554278,
            53.675881,
            41.106187
          ],
          [
            14.5546,
            53.675813,
            41.432923
          ],
          [
            14.554957,
            53.675778,
            41.778828
          ],
          [
            14.555316,
            53.675748,
            42.125222
          ],
          [
            14.5557,
            53.675764,
            42.493466
          ],
          [
            14.556014,
            53.675768,
            42.793934
          ],
          [
            14.556333,
            53.675741,
            43.101799
          ],
          [
            14.556667,
            53.675737,
            42.827464
          ],
          [
            14.557036,
            53.67575,
            42.275374
          ],
          [
            14.557461,
            53.675749,
            41.640378
          ],
          [
            14.557779,
            53.675733,
            41.162355
          ],
          [
            14.558093,
            53.675731,
            40.689477
          ],
          [
            14.558405,
            53.675715,
            40.221651
          ],
          [
            14.558771,
            53.675649,
            39.649937
          ],
          [
            14.559079,
            53.675597,
            39.16846
          ],
          [
            14.559402,
            53.675569,
            38.680837
          ],
          [
            14.559716,
            53.675516,
            38.399775
          ],
          [
            14.560026,
            53.675446,
            38.12712
          ],
          [
            14.560353,
            53.675408,
            37.852493
          ],
          [
            14.560721,
            53.675348,
            37.538748
          ],
          [
            14.561045,
            53.675296,
            37.262889
          ],
          [
            14.561368,
            53.675217,
            36.97557
          ],
          [
            14.561689,
            53.67517,
            36.703772
          ],
          [
            14.562004,
            53.675129,
            36.438653
          ],
          [
            14.562384,
            53.67506,
            36.171255
          ],
          [
            14.562667,
            53.674998,
            36.234008
          ],
          [
            14.563043,
            53.674935,
            36.314817
          ],
          [
            14.563422,
            53.674885,
            36.395216
          ],
          [
            14.563724,
            53.674826,
            36.461061
          ],
          [
            14.564046,
            53.674779,
            36.529683
          ],
          [
            14.564467,
            53.674721,
            36.619046
          ],
          [
            14.564775,
            53.674663,
            36.685871
          ],
          [
            14.5651,
            53.674614,
            36.755301
          ],
          [
            14.565448,
            53.674558,
            36.98979
          ],
          [
            14.565836,
            53.674534,
            37.371214
          ],
          [
            14.566138,
            53.674499,
            37.67216
          ],
          [
            14.566531,
            53.674451,
            38.066844
          ],
          [
            14.566907,
            53.6744,
            38.443696
          ],
          [
            14.567281,
            53.674361,
            38.81493
          ],
          [
            14.567694,
            53.674299,
            39.231088
          ],
          [
            14.568075,
            53.6742,
            39.637473
          ],
          [
            14.568411,
            53.67408,
            39.791024
          ],
          [
            14.568663,
            53.673952,
            39.837283
          ],
          [
            14.568997,
            53.673804,
            39.895339
          ],
          [
            14.569318,
            53.673678,
            39.949046
          ],
          [
            14.569639,
            53.673554,
            40.002385
          ],
          [
            14.569924,
            53.673377,
            40.060224
          ],
          [
            14.570199,
            53.673173,
            40.121546
          ],
          [
            14.57043,
            53.672988,
            40.17549
          ],
          [
            14.570652,
            53.672788,
            40.202997
          ],
          [
            14.570878,
            53.672593,
            40.230175
          ],
          [
            14.571107,
            53.672393,
            40.257948
          ],
          [
            14.571342,
            53.672208,
            40.284581
          ],
          [
            14.57155,
            53.672022,
            40.310217
          ],
          [
            14.571796,
            53.671863,
            40.33501
          ],
          [
            14.572005,
            53.671722,
            40.356604
          ],
          [
            14.572214,
            53.671517,
            40.361687
          ],
          [
            14.572379,
            53.671326,
            40.1251
          ],
          [
            14.572526,
            53.671115,
            39.873824
          ],
          [
            14.572769,
            53.670938,
            39.620242
          ],
          [
            14.573047,
            53.67082,
            39.396833
          ],
          [
            14.573311,
            53.670696,
            39.177001
          ],
          [
            14.573591,
            53.670547,
            38.93157
          ],
          [
            14.573889,
            53.67041,
            38.685578
          ],
          [
            14.57422,
            53.670267,
            38.418477
          ],
          [
            14.574528,
            53.670124,
            38.560437
          ],
          [
            14.574793,
            53.670004,
            38.704562
          ],
          [
            14.575096,
            53.669913,
            38.850679
          ],
          [
            14.575459,
            53.66985,
            39.01335
          ],
          [
            14.575824,
            53.66979,
            39.176367
          ],
          [
            14.576185,
            53.669699,
            39.345212
          ],
          [
            14.576515,
            53.669574,
            39.513839
          ],
          [
            14.576862,
            53.669451,
            39.687767
          ],
          [
            14.577198,
            53.669315,
            39.405131
          ],
          [
            14.57757,
            53.66919,
            39.044569
          ],
          [
            14.57786,
            53.66906,
            38.737978
          ],
          [
            14.578178,
            53.66894,
            38.420051
          ],
          [
            14.578531,
            53.6688,
            38.061726
          ],
          [
            14.578897,
            53.668693,
            37.717212
          ],
          [
            14.579314,
            53.668631,
            37.354748
          ],
          [
            14.579695,
            53.668579,
            36.983591
          ],
          [
            14.580054,
            53.668539,
            36.572418
          ],
          [
            14.580438,
            53.668493,
            36.128959
          ],
          [
            14.580885,
            53.668447,
            35.618172
          ],
          [
            14.581346,
            53.668413,
            35.094964
          ],
          [
            14.581724,
            53.66837,
            34.661693
          ],
          [
            14.582147,
            53.668316,
            34.173925
          ],
          [
            14.582586,
            53.668273,
            33.806892
          ],
          [
            14.582951,
            53.668252,
            34.340186
          ],
          [
            14.583327,
            53.668259,
            34.885908
          ],
          [
            14.58371,
            53.668301,
            35.451984
          ],
          [
            14.584022,
            53.668317,
            35.906251
          ],
          [
            14.584342,
            53.668337,
            36.37402
          ],
          [
            14.584648,
            53.668373,
            36.828538
          ],
          [
            14.584964,
            53.668413,
            37.297054
          ],
          [
            14.58534,
            53.668453,
            37.853454
          ],
          [
            14.585654,
            53.668482,
            38.168094
          ],
          [
            14.585988,
            53.668523,
            38.262978
          ],
          [
            14.586306,
            53.668552,
            38.352818
          ],
          [
            14.586662,
            53.668559,
            38.453571
          ],
          [
            14.587044,
            53.668579,
            38.560383
          ],
          [
            14.587366,
            53.668607,
            38.65119
          ],
          [
            14.587764,
            53.668603,
            38.762015
          ],
          [
            14.588078,
            53.668582,
            38.850147
          ],
          [
            14.588376,
            53.66854,
            38.935714
          ],
          [
            14.588732,
            53.668437,
            39.044331
          ],
          [
            14.589065,
            53.668361,
            39.141205
          ],
          [
            14.589397,
            53.668259,
            39.242702
          ],
          [
            14.589739,
            53.668112,
            39.357448
          ],
          [
            14.590014,
            53.668013,
            39.444808
          ],
          [
            14.590343,
            53.667841,
            39.563901
          ],
          [
            14.59067,
            53.667673,
            39.681318
          ],
          [
            14.590924,
            53.667518,
            39.78025
          ],
          [
            14.591203,
            53.667349,
            39.96599
          ],
          [
            14.591436,
            53.667179,
            40.154534
          ],
          [
            14.591691,
            53.666994,
            40.36018
          ],
          [
            14.591927,
            53.666795,
            40.569652
          ],
          [
            14.592168,
            53.666608,
            40.772211
          ],
          [
            14.592401,
            53.66642,
            40.973067
          ],
          [
            14.592678,
            53.66624,
            41.18274
          ],
          [
            14.592981,
            53.666076,
            41.390469
          ],
          [
            14.5933,
            53.665926,
            41.590594
          ],
          [
            14.593624,
            53.665771,
            41.795322
          ],
          [
            14.593909,
            53.665597,
            41.996584
          ],
          [
            14.594121,
            53.665406,
            42.18629
          ],
          [
            14.59424,
            53.665201,
            42.366133
          ],
          [
            14.594357,
            53.664984,
            42.555028
          ],
          [
            14.594493,
            53.664759,
            42.753221
          ],
          [
            14.594614,
            53.664534,
            42.884327
          ],
          [
            14.594772,
            53.664322,
            42.962008
          ],
          [
            14.594929,
            53.664142,
            43.029792
          ],
          [
            14.595159,
            53.663956,
            43.106953
          ],
          [
            14.595391,
            53.66376,
            43.187426
          ],
          [
            14.595697,
            53.663628,
            43.262461
          ],
          [
            14.595986,
            53.663513,
            43.331523
          ],
          [
            14.596287,
            53.663408,
            43.400795
          ],
          [
            14.596618,
            53.663313,
            43.395291
          ],
          [
            14.596969,
            53.663282,
            43.290331
          ],
          [
            14.597315,
            53.663254,
            43.187247
          ],
          [
            14.597661,
            53.663257,
            43.085095
          ],
          [
            14.598065,
            53.663262,
            42.965536
          ],
          [
            14.598463,
            53.663262,
            42.847871
          ],
          [
            14.598864,
            53.663229,
            42.72838
          ],
          [
            14.59924,
            53.663152,
            42.610972
          ],
          [
            14.599575,
            53.663017,
            42.456641
          ],
          [
            14.599846,
            53.662873,
            42.280781
          ],
          [
            14.600099,
            53.662687,
            42.086564
          ],
          [
            14.600366,
            53.662482,
            41.875999
          ],
          [
            14.600608,
            53.662289,
            41.680253
          ],
          [
            14.60091,
            53.662136,
            41.488857
          ],
          [
            14.601223,
            53.662006,
            41.303433
          ],
          [
            14.601591,
            53.661901,
            41.106619
          ],
          [
            14.601988,
            53.661797,
            41.080554
          ],
          [
            14.602351,
            53.661708,
            41.076834
          ],
          [
            14.602698,
            53.661601,
            41.07313
          ],
          [
            14.603079,
            53.661523,
            41.069311
          ],
          [
            14.603448,
            53.661479,
            41.065748
          ],
          [
            14.603812,
            53.661446,
            41.062261
          ],
          [
            14.60422,
            53.66144,
            41.058396
          ],
          [
            14.604641,
            53.661433,
            41.127183
          ],
          [
            14.605038,
            53.661411,
            41.376347
          ],
          [
            14.605437,
            53.661405,
            41.625836
          ],
          [
            14.605858,
            53.66138,
            41.890167
          ],
          [
            14.60624,
            53.661358,
            42.129935
          ],
          [
            14.606612,
            53.661345,
            42.36282
          ],
          [
            14.606927,
            53.661328,
            42.560561
          ],
          [
            14.607298,
            53.661365,
            42.795882
          ],
          [
            14.60769,
            53.661427,
            43.067889
          ],
          [
            14.60805,
            53.661488,
            43.346243
          ],
          [
            14.608409,
            53.661558,
            43.628226
          ],
          [
            14.608718,
            53.661576,
            43.859183
          ],
          [
            14.609034,
            53.66155,
            44.097237
          ],
          [
            14.609294,
            53.661433,
            44.341447
          ],
          [
            14.609552,
            53.66126,
            44.631166
          ],
          [
            14.609811,
            53.661084,
            44.924341
          ],
          [
            14.610083,
            53.660911,
            45.194676
          ],
          [
            14.61035,
            53.660731,
            44.879227
          ],
          [
            14.610596,
            53.660572,
            44.595349
          ],
          [
            14.610871,
            53.660416,
            44.298307
          ],
          [
            14.611141,
            53.660288,
            44.028497
          ],
          [
            14.61144,
            53.660175,
            43.7514
          ],
          [
            14.611725,
            53.660047,
            43.472158
          ],
          [
            14.611998,
            53.659909,
            43.192376
          ],
          [
            14.612308,
            53.659769,
            42.888477
          ],
          [
            14.612595,
            53.65963,
            42.803304
          ],
          [
            14.612902,
            53.659496,
            42.756085
          ],
          [
            14.613162,
            53.659373,
            42.714917
          ],
          [
            14.613423,
            53.65925,
            42.67365
          ],
          [
            14.613715,
            53.659177,
            42.634054
          ],
          [
            14.614038,
            53.659121,
            42.592384
          ],
          [
            14.614351,
            53.659072,
            42.552247
          ],
          [
            14.614689,
            53.659033,
            42.509435
          ],
          [
            14.615031,
            53.659002,
            42.466436
          ],
          [
            14.615386,
            53.658988,
            42.58911
          ],
          [
            14.615746,
            53.658974,
            42.715256
          ],
          [
            14.616119,
            53.659016,
            42.847143
          ],
          [
            14.616436,
            53.65905,
            42.960021
          ],
          [
            14.616767,
            53.659048,
            43.075007
          ],
          [
            14.617139,
            53.659033,
            43.204467
          ],
          [
            14.617502,
            53.65902,
            43.330904
          ],
          [
            14.617821,
            53.658991,
            43.442985
          ],
          [
            14.618128,
            53.658951,
            43.529287
          ],
          [
            14.618333,
            53.658801,
            43.56256
          ],
          [
            14.618417,
            53.658597,
            43.598336
          ],
          [
            14.618411,
            53.658384,
            43.634382
          ],
          [
            14.618359,
            53.658185,
            43.668374
          ],
          [
            14.618285,
            53.657962,
            43.706761
          ],
          [
            14.618217,
            53.65778,
            43.738222
          ],
          [
            14.618152,
            53.657574,
            43.773595
          ],
          [
            14.618143,
            53.657379,
            43.806689
          ],
          [
            14.618294,
            53.657203,
            43.766234
          ],
          [
            14.618533,
            53.657049,
            43.646728
          ],
          [
            14.618772,
            53.656897,
            43.52815
          ],
          [
            14.619033,
            53.656734,
            43.399897
          ],
          [
            14.619274,
            53.656573,
            43.277039
          ],
          [
            14.619496,
            53.656435,
            43.16808
          ],
          [
            14.619761,
            53.656277,
            43.038058
          ],
          [
            14.620022,
            53.65612,
            42.912233
          ],
          [
            14.620235,
            53.655957,
            42.792368
          ],
          [
            14.620444,
            53.655818,
            42.60095
          ],
          [
            14.620655,
            53.655682,
            42.411019
          ],
          [
            14.620855,
            53.65554,
            42.22085
          ],
          [
            14.621059,
            53.655383,
            42.016955
          ],
          [
            14.621145,
            53.65519,
            41.811192
          ],
          [
            14.621149,
            53.654986,
            41.601335
          ],
          [
            14.62115,
            53.654781,
            41.390392
          ],
          [
            14.621271,
            53.654593,
            41.183541
          ],
          [
            14.621401,
            53.654394,
            40.964078
          ],
          [
            14.621577,
            53.65423,
            40.838968
          ],
          [
            14.621719,
            53.654041,
            40.712377
          ],
          [
            14.621852,
            53.65384,
            40.581188
          ],
          [
            14.621982,
            53.653651,
            40.457239
          ],
          [
            14.622051,
            53.65342,
            40.314708
          ],
          [
            14.622085,
            53.653235,
            40.201661
          ],
          [
            14.622241,
            53.653034,
            40.062497
          ],
          [
            14.622116,
            53.653221,
            39.939933
          ],
          [
            14.622033,
            53.653232,
            39.86279
          ],
          [
            14.622201,
            53.653038,
            39.892243
          ],
          [
            14.622518,
            53.652953,
            39.919459
          ],
          [
            14.622833,
            53.652856,
            39.947156
          ],
          [
            14.623088,
            53.652722,
            39.973754
          ],
          [
            14.623355,
            53.652595,
            40.000465
          ],
          [
            14.623616,
            53.652454,
            40.028019
          ],
          [
            14.623861,
            53.652319,
            40.054119
          ],
          [
            14.624124,
            53.652174,
            40.082146
          ],
          [
            14.62436,
            53.65204,
            40.690981
          ],
          [
            14.624651,
            53.651885,
            41.901519
          ],
          [
            14.624954,
            53.651793,
            42.967738
          ],
          [
            14.625295,
            53.651786,
            44.024294
          ],
          [
            14.625638,
            53.651765,
            45.090631
          ],
          [
            14.625968,
            53.651814,
            46.147985
          ],
          [
            14.626278,
            53.651882,
            47.173055
          ],
          [
            14.626604,
            53.651979,
            48.301928
          ],
          [
            14.626901,
            53.652098,
            49.414499
          ],
          [
            14.627218,
            53.652194,
            49.054614
          ],
          [
            14.627557,
            53.652295,
            48.580207
          ],
          [
            14.627905,
            53.652351,
            48.132464
          ],
          [
            14.628263,
            53.652423,
            47.663171
          ],
          [
            14.628654,
            53.65248,
            47.163197
          ],
          [
            14.628989,
            53.652558,
            46.716322
          ],
          [
            14.629316,
            53.652665,
            46.252644
          ],
          [
            14.629647,
            53.652765,
            45.791389
          ],
          [
            14.629965,
            53.652864,
            45.869883
          ],
          [
            14.630272,
            53.652935,
            46.051316
          ],
          [
            14.63063,
            53.652903,
            46.251748
          ],
          [
            14.630939,
            53.652873,
            46.424274
          ],
          [
            14.631274,
            53.652847,
            46.6107
          ],
          [
            14.631603,
            53.652863,
            46.792356
          ],
          [
            14.631941,
            53.652888,
            46.979873
          ],
          [
            14.632281,
            53.652911,
            47.168257
          ],
          [
            14.632617,
            53.652912,
            47.353129
          ],
          [
            14.632934,
            53.65292,
            47.06425
          ],
          [
            14.633247,
            53.652921,
            46.702009
          ],
          [
            14.633589,
            53.652915,
            46.30468
          ],
          [
            14.633958,
            53.652911,
            45.877442
          ],
          [
            14.634316,
            53.652897,
            45.462905
          ],
          [
            14.634711,
            53.652883,
            45.005737
          ],
          [
            14.635086,
            53.652855,
            44.568738
          ],
          [
            14.635472,
            53.652817,
            44.116657
          ],
          [
            14.635897,
            53.652775,
            43.992228
          ],
          [
            14.636195,
            53.652746,
            44.157978
          ],
          [
            14.6366,
            53.652697,
            44.384238
          ],
          [
            14.636945,
            53.65266,
            44.576167
          ],
          [
            14.637279,
            53.652627,
            44.761543
          ],
          [
            14.637631,
            53.652579,
            44.959306
          ],
          [
            14.637926,
            53.652532,
            45.126536
          ],
          [
            14.638235,
            53.652497,
            45.298738
          ],
          [
            14.638547,
            53.652452,
            45.475355
          ],
          [
            14.638889,
            53.652416,
            45.364681
          ],
          [
            14.639198,
            53.652382,
            45.145852
          ],
          [
            14.639517,
            53.652341,
            44.918203
          ],
          [
            14.639843,
            53.65229,
            44.683533
          ],
          [
            14.640222,
            53.652245,
            44.414318
          ],
          [
            14.640641,
            53.652236,
            44.12231
          ],
          [
            14.641066,
            53.652266,
            43.823352
          ],
          [
            14.641514,
            53.652292,
            43.509921
          ],
          [
            14.641843,
            53.652315,
            43.434543
          ],
          [
            14.642165,
            53.652321,
            43.455734
          ],
          [
            14.642494,
            53.652346,
            43.477585
          ],
          [
            14.64288,
            53.652365,
            43.503062
          ],
          [
            14.643263,
            53.652341,
            43.528406
          ],
          [
            14.643672,
            53.652241,
            43.557636
          ],
          [
            14.644002,
            53.652122,
            43.583231
          ],
          [
            14.64426,
            53.652003,
            43.60475
          ],
          [
            14.644563,
            53.651871,
            43.438047
          ],
          [
            14.644876,
            53.651732,
            42.904951
          ],
          [
            14.645215,
            53.651573,
            42.315644
          ],
          [
            14.645489,
            53.65148,
            41.88518
          ],
          [
            14.645776,
            53.651406,
            41.458579
          ],
          [
            14.646073,
            53.651344,
            41.029384
          ],
          [
            14.646387,
            53.651285,
            40.580279
          ],
          [
            14.646742,
            53.651222,
            40.075167
          ],
          [
            14.647054,
            53.651171,
            39.634026
          ],
          [
            14.647458,
            53.651131,
            39.624717
          ],
          [
            14.64779,
            53.651102,
            39.782208
          ],
          [
            14.648104,
            53.651061,
            39.932419
          ],
          [
            14.648535,
            53.651039,
            40.134503
          ],
          [
            14.648905,
            53.650997,
            40.310408
          ],
          [
            14.649227,
            53.650936,
            40.468307
          ],
          [
            14.649554,
            53.650873,
            40.628842
          ],
          [
            14.649884,
            53.650786,
            40.79779
          ],
          [
            14.650189,
            53.650679,
            40.962409
          ],
          [
            14.650474,
            53.650571,
            41.117542
          ],
          [
            14.650727,
            53.650452,
            41.26563
          ],
          [
            14.65097,
            53.650334,
            41.409663
          ],
          [
            14.651197,
            53.650186,
            41.564394
          ],
          [
            14.651395,
            53.650039,
            41.70995
          ],
          [
            14.651585,
            53.649887,
            41.856284
          ],
          [
            14.6518,
            53.649702,
            42.030121
          ],
          [
            14.651986,
            53.649525,
            42.192573
          ],
          [
            14.652186,
            53.649312,
            41.974493
          ],
          [
            14.652406,
            53.649115,
            41.315944
          ],
          [
            14.652613,
            53.648922,
            40.678456
          ],
          [
            14.652873,
            53.648712,
            39.950109
          ],
          [
            14.653155,
            53.648555,
            39.303981
          ],
          [
            14.653646,
            53.648431,
            38.419414
          ],
          [
            14.653978,
            53.648397,
            37.860665
          ],
          [
            14.654301,
            53.648415,
            37.322507
          ],
          [
            14.654662,
            53.648367,
            37.416364
          ],
          [
            14.655049,
            53.64834,
            37.569772
          ],
          [
            14.655407,
            53.648304,
            37.713151
          ],
          [
            14.655768,
            53.64829,
            37.855614
          ],
          [
            14.656204,
            53.648274,
            38.027623
          ],
          [
            14.656606,
            53.648241,
            38.187403
          ],
          [
            14.657036,
            53.648217,
            38.357457
          ],
          [
            14.657412,
            53.648215,
            38.437945
          ],
          [
            14.657849,
            53.648177,
            38.239302
          ],
          [
            14.65822,
            53.648156,
            38.072121
          ],
          [
            14.658598,
            53.648123,
            37.901382
          ],
          [
            14.658908,
            53.648088,
            37.760087
          ],
          [
            14.659228,
            53.648069,
            37.61635
          ],
          [
            14.659537,
            53.64803,
            37.475099
          ],
          [
            14.659858,
            53.648015,
            37.330543
          ],
          [
            14.660288,
            53.647997,
            37.137852
          ],
          [
            14.660599,
            53.647974,
            37.108217
          ],
          [
            14.660922,
            53.647957,
            37.096487
          ],
          [
            14.66131,
            53.64794,
            37.082416
          ],
          [
            14.661765,
            53.647944,
            37.065931
          ],
          [
            14.662077,
            53.647961,
            37.054587
          ],
          [
            14.662526,
            53.64799,
            37.038252
          ],
          [
            14.662887,
            53.648019,
            37.025051
          ],
          [
            14.663287,
            53.648092,
            37.009913
          ],
          [
            14.663681,
            53.648173,
            37.198273
          ],
          [
            14.664059,
            53.648288,
            37.416498
          ],
          [
            14.664402,
            53.648424,
            37.628014
          ],
          [
            14.664754,
            53.648568,
            37.84735
          ],
          [
            14.66508,
            53.648725,
            38.062623
          ],
          [
            14.665427,
            53.64885,
            38.2708
          ],
          [
            14.665749,
            53.648974,
            38.467625
          ],
          [
            14.666052,
            53.649108,
            38.360201
          ],
          [
            14.666396,
            53.649197,
            37.96173
          ],
          [
            14.666703,
            53.649326,
            37.561098
          ],
          [
            14.666977,
            53.649469,
            37.170596
          ],
          [
            14.667278,
            53.649564,
            36.807925
          ],
          [
            14.66765,
            53.649665,
            36.372725
          ],
          [
            14.668014,
            53.649768,
            35.943632
          ],
          [
            14.668292,
            53.649875,
            35.591427
          ],
          [
            14.668609,
            53.649993,
            35.311924
          ],
          [
            14.668847,
            53.650125,
            35.240384
          ],
          [
            14.669183,
            53.650228,
            35.158641
          ],
          [
            14.669483,
            53.65035,
            35.080097
          ],
          [
            14.669851,
            53.650471,
            34.989565
          ],
          [
            14.670151,
            53.650598,
            34.910174
          ],
          [
            14.670407,
            53.650695,
            34.844637
          ],
          [
            14.670787,
            53.650821,
            34.750928
          ],
          [
            14.671165,
            53.650967,
            34.91374
          ],
          [
            14.671479,
            53.651095,
            35.438304
          ],
          [
            14.671814,
            53.651178,
            35.935299
          ],
          [
            14.672146,
            53.651299,
            36.470102
          ],
          [
            14.672405,
            53.651403,
            36.897978
          ],
          [
            14.672696,
            53.65152,
            37.382405
          ],
          [
            14.673047,
            53.651642,
            37.93918
          ],
          [
            14.67332,
            53.651772,
            38.418133
          ],
          [
            14.673643,
            53.65188,
            38.866935
          ],
          [
            14.674011,
            53.652012,
            39.054528
          ],
          [
            14.67436,
            53.652142,
            39.234276
          ],
          [
            14.674691,
            53.652257,
            39.401634
          ],
          [
            14.674994,
            53.652379,
            39.561513
          ],
          [
            14.675314,
            53.652501,
            39.72743
          ],
          [
            14.675653,
            53.652648,
            39.910618
          ],
          [
            14.675979,
            53.652772,
            40.079548
          ],
          [
            14.676323,
            53.652888,
            40.025779
          ],
          [
            14.67664,
            53.653009,
            39.773915
          ],
          [
            14.676958,
            53.653117,
            39.528604
          ],
          [
            14.6773,
            53.653184,
            39.28762
          ],
          [
            14.677604,
            53.653309,
            39.040388
          ],
          [
            14.677854,
            53.653428,
            38.826068
          ],
          [
            14.678183,
            53.653583,
            38.545
          ],
          [
            14.678529,
            53.653696,
            38.280987
          ],
          [
            14.678869,
            53.653827,
            38.242844
          ],
          [
            14.679231,
            53.653967,
            38.489471
          ],
          [
            14.679552,
            53.654106,
            38.715984
          ],
          [
            14.679828,
            53.654231,
            38.915803
          ],
          [
            14.680191,
            53.654218,
            39.125213
          ],
          [
            14.680537,
            53.654183,
            39.325285
          ],
          [
            14.680898,
            53.654176,
            39.531101
          ],
          [
            14.681268,
            53.654161,
            39.742404
          ],
          [
            14.681609,
            53.654146,
            39.708534
          ],
          [
            14.682001,
            53.654141,
            39.227711
          ],
          [
            14.682404,
            53.654088,
            38.719984
          ],
          [
            14.682778,
            53.654045,
            38.252451
          ],
          [
            14.683096,
            53.654023,
            37.859565
          ],
          [
            14.683499,
            53.65398,
            37.356803
          ],
          [
            14.683817,
            53.653913,
            36.942742
          ],
          [
            14.684173,
            53.653858,
            36.491338
          ],
          [
            14.684469,
            53.653784,
            36.154308
          ],
          [
            14.684805,
            53.653727,
            36.254779
          ],
          [
            14.685198,
            53.653714,
            36.367081
          ],
          [
            14.685591,
            53.653672,
            36.480998
          ],
          [
            14.685942,
            53.65359,
            36.588761
          ],
          [
            14.686335,
            53.653494,
            36.71024
          ],
          [
            14.686688,
            53.653419,
            36.817263
          ],
          [
            14.687053,
            53.653364,
            36.924752
          ],
          [
            14.68738,
            53.653307,
            37.09916
          ],
          [
            14.687729,
            53.653205,
            37.883638
          ],
          [
            14.68807,
            53.653073,
            38.706726
          ],
          [
            14.688323,
            53.652946,
            39.372788
          ],
          [
            14.688627,
            53.652835,
            40.089499
          ],
          [
            14.688906,
            53.65271,
            40.791883
          ],
          [
            14.689183,
            53.652562,
            41.540946
          ],
          [
            14.689508,
            53.652424,
            42.345195
          ],
          [
            14.68989,
            53.652362,
            43.082286
          ],
          [
            14.690255,
            53.652314,
            42.748561
          ],
          [
            14.690632,
            53.652281,
            42.408632
          ],
          [
            14.691003,
            53.652235,
            42.07038
          ],
          [
            14.69136,
            53.65222,
            41.750565
          ],
          [
            14.691757,
            53.652214,
            41.396163
          ],
          [
            14.69208,
            53.65219,
            41.105812
          ],
          [
            14.692428,
            53.652137,
            40.784581
          ],
          [
            14.692778,
            53.652047,
            40.444228
          ],
          [
            14.693101,
            53.651968,
            39.849173
          ],
          [
            14.693442,
            53.651867,
            39.141161
          ],
          [
            14.693753,
            53.651805,
            38.531349
          ],
          [
            14.694097,
            53.651739,
            37.859653
          ],
          [
            14.694362,
            53.651615,
            37.227567
          ],
          [
            14.694611,
            53.651449,
            36.531985
          ],
          [
            14.694832,
            53.651248,
            35.780742
          ],
          [
            14.695031,
            53.651055,
            35.072505
          ],
          [
            14.695209,
            53.650874,
            34.8155
          ],
          [
            14.695421,
            53.650734,
            34.906629
          ],
          [
            14.695756,
            53.650496,
            35.060141
          ],
          [
            14.69589,
            53.650308,
            35.158797
          ],
          [
            14.696126,
            53.650131,
            35.268382
          ],
          [
            14.69634,
            53.649925,
            35.385248
          ],
          [
            14.696537,
            53.649756,
            35.484831
          ],
          [
            14.696694,
            53.649573,
            35.585243
          ],
          [
            14.696875,
            53.649394,
            35.779188
          ],
          [
            14.697106,
            53.649203,
            36.080556
          ],
          [
            14.697319,
            53.649014,
            36.371968
          ],
          [
            14.697565,
            53.648818,
            36.686074
          ],
          [
            14.697755,
            53.64864,
            36.956148
          ],
          [
            14.69796,
            53.648452,
            37.243771
          ],
          [
            14.698161,
            53.64831,
            37.481597
          ],
          [
            14.698384,
            53.648138,
            37.759828
          ],
          [
            14.698631,
            53.647943,
            38.146502
          ],
          [
            14.698868,
            53.647696,
            38.709065
          ],
          [
            14.699028,
            53.647495,
            39.15007
          ],
          [
            14.699269,
            53.64731,
            39.614101
          ],
          [
            14.69947,
            53.647128,
            40.045061
          ],
          [
            14.699712,
            53.646943,
            40.509103
          ],
          [
            14.699889,
            53.646793,
            40.871308
          ],
          [
            14.700087,
            53.646566,
            41.377895
          ],
          [
            14.700336,
            53.646363,
            41.880745
          ],
          [
            14.700552,
            53.646197,
            42.30218
          ],
          [
            14.700795,
            53.646005,
            42.78254
          ],
          [
            14.701076,
            53.645802,
            43.310395
          ],
          [
            14.701289,
            53.645629,
            43.739035
          ],
          [
            14.701477,
            53.645439,
            44.180912
          ],
          [
            14.701663,
            53.645241,
            44.634684
          ],
          [
            14.701903,
            53.645058,
            45.099086
          ],
          [
            14.702129,
            53.644884,
            45.460721
          ],
          [
            14.702331,
            53.644691,
            45.835028
          ],
          [
            14.702572,
            53.644519,
            46.203429
          ],
          [
            14.702728,
            53.644308,
            46.582172
          ],
          [
            14.702973,
            53.644109,
            46.987547
          ],
          [
            14.703145,
            53.643932,
            47.326225
          ],
          [
            14.703385,
            53.643723,
            47.741973
          ],
          [
            14.703593,
            53.643539,
            48.048101
          ],
          [
            14.703784,
            53.64337,
            48.029738
          ],
          [
            14.704003,
            53.643149,
            48.006594
          ],
          [
            14.704252,
            53.642944,
            47.983686
          ],
          [
            14.704456,
            53.642772,
            47.964705
          ],
          [
            14.704645,
            53.642599,
            47.946055
          ],
          [
            14.704869,
            53.642425,
            47.926303
          ],
          [
            14.705097,
            53.642237,
            47.905392
          ],
          [
            14.705305,
            53.642098,
            47.876894
          ],
          [
            14.705492,
            53.641939,
            46.85526
          ],
          [
            14.705696,
            53.641756,
            45.699462
          ],
          [
            14.705897,
            53.641534,
            44.372361
          ],
          [
            14.706093,
            53.641341,
            43.184917
          ],
          [
            14.706325,
            53.641138,
            41.89315
          ],
          [
            14.706535,
            53.640941,
            40.662957
          ],
          [
            14.706757,
            53.640748,
            39.432533
          ],
          [
            14.707021,
            53.64056,
            38.60033
          ],
          [
            14.707236,
            53.640349,
            39.478226
          ],
          [
            14.707461,
            53.640167,
            40.281809
          ],
          [
            14.707672,
            53.639971,
            41.110506
          ],
          [
            14.707867,
            53.639802,
            41.839666
          ],
          [
            14.70803,
            53.639585,
            42.690891
          ],
          [
            14.708265,
            53.639427,
            43.444396
          ],
          [
            14.708497,
            53.639252,
            44.237808
          ],
          [
            14.708725,
            53.639069,
            44.708858
          ],
          [
            14.708914,
            53.638874,
            44.315781
          ],
          [
            14.709079,
            53.638694,
            43.958287
          ],
          [
            14.70928,
            53.63852,
            43.590823
          ],
          [
            14.709436,
            53.638341,
            43.239816
          ],
          [
            14.709652,
            53.638146,
            42.831624
          ],
          [
            14.709892,
            53.637976,
            42.444362
          ],
          [
            14.710087,
            53.637798,
            42.073708
          ],
          [
            14.710274,
            53.637626,
            41.716537
          ],
          [
            14.710421,
            53.637442,
            41.809061
          ],
          [
            14.710636,
            53.637262,
            41.949324
          ],
          [
            14.710899,
            53.637077,
            42.103149
          ],
          [
            14.711126,
            53.63689,
            42.24998
          ],
          [
            14.711345,
            53.636644,
            42.427062
          ],
          [
            14.711578,
            53.636457,
            42.57488
          ],
          [
            14.711789,
            53.636268,
            42.719022
          ],
          [
            14.712006,
            53.636093,
            42.870893
          ],
          [
            14.712229,
            53.635912,
            43.08438
          ],
          [
            14.71244,
            53.635732,
            43.293245
          ],
          [
            14.712594,
            53.635564,
            43.476817
          ],
          [
            14.712809,
            53.63539,
            43.682596
          ],
          [
            14.71304,
            53.635228,
            43.885514
          ],
          [
            14.713206,
            53.635059,
            44.076525
          ],
          [
            14.713289,
            53.634855,
            44.277592
          ],
          [
            14.713538,
            53.634664,
            44.507622
          ],
          [
            14.713781,
            53.634461,
            44.033313
          ],
          [
            14.714027,
            53.634248,
            43.399606
          ],
          [
            14.71426,
            53.634084,
            42.87305
          ],
          [
            14.714496,
            53.633915,
            42.334539
          ],
          [
            14.714689,
            53.633741,
            41.821915
          ],
          [
            14.714887,
            53.633557,
            41.279375
          ],
          [
            14.715104,
            53.633349,
            40.67818
          ],
          [
            14.715276,
            53.633154,
            40.138117
          ],
          [
            14.715477,
            53.632957,
            40.864972
          ],
          [
            14.715677,
            53.632763,
            41.603317
          ],
          [
            14.715907,
            53.632576,
            42.3524
          ],
          [
            14.716112,
            53.6324,
            43.043351
          ],
          [
            14.716354,
            53.63224,
            43.738842
          ],
          [
            14.716565,
            53.632039,
            44.502071
          ],
          [
            14.716761,
            53.631881,
            45.134166
          ],
          [
            14.716949,
            53.631735,
            45.725676
          ],
          [
            14.717232,
            53.631537,
            46.078004
          ],
          [
            14.717443,
            53.631361,
            46.247446
          ],
          [
            14.717398,
            53.63115,
            46.418022
          ],
          [
            14.717151,
            53.630975,
            46.595972
          ],
          [
            14.716943,
            53.630813,
            46.754687
          ],
          [
            14.716713,
            53.630658,
            46.915652
          ],
          [
            14.716453,
            53.630497,
            47.089402
          ],
          [
            14.71623,
            53.630357,
            47.240171
          ],
          [
            14.716005,
            53.630185,
            47.179166
          ],
          [
            14.715749,
            53.630016,
            46.872295
          ],
          [
            14.715542,
            53.629859,
            46.603007
          ],
          [
            14.715291,
            53.629683,
            46.291594
          ],
          [
            14.71509,
            53.629498,
            45.994215
          ],
          [
            14.714853,
            53.629325,
            45.692736
          ],
          [
            14.714673,
            53.629156,
            45.421094
          ],
          [
            14.714967,
            53.62906,
            45.139665
          ],
          [
            14.715356,
            53.629024,
            44.868524
          ],
          [
            14.715757,
            53.628996,
            44.744713
          ],
          [
            14.716109,
            53.628933,
            44.632488
          ],
          [
            14.716476,
            53.62886,
            44.513916
          ],
          [
            14.716793,
            53.628775,
            44.407881
          ],
          [
            14.717078,
            53.628688,
            44.310188
          ],
          [
            14.717412,
            53.628563,
            44.189092
          ],
          [
            14.717691,
            53.628442,
            44.083597
          ],
          [
            14.717982,
            53.628324,
            43.975494
          ],
          [
            14.718281,
            53.628198,
            43.514106
          ],
          [
            14.718527,
            53.628038,
            43.042852
          ],
          [
            14.718797,
            53.6279,
            42.581445
          ],
          [
            14.719091,
            53.627729,
            42.05102
          ],
          [
            14.719321,
            53.627569,
            41.594026
          ],
          [
            14.719592,
            53.627443,
            41.148469
          ],
          [
            14.719959,
            53.627267,
            40.541004
          ],
          [
            14.720213,
            53.627092,
            40.086086
          ],
          [
            14.720483,
            53.626928,
            40.388946
          ],
          [
            14.720725,
            53.626749,
            40.692033
          ],
          [
            14.720974,
            53.626549,
            41.020901
          ],
          [
            14.721244,
            53.626363,
            41.345283
          ],
          [
            14.72147,
            53.626181,
            41.644013
          ],
          [
            14.721671,
            53.626028,
            41.900189
          ],
          [
            14.721843,
            53.625865,
            42.154163
          ],
          [
            14.722038,
            53.625712,
            42.408127
          ],
          [
            14.722303,
            53.625513,
            43.06053
          ],
          [
            14.72247,
            53.625307,
            43.682106
          ],
          [
            14.722666,
            53.625123,
            44.291355
          ],
          [
            14.722888,
            53.62494,
            44.904274
          ],
          [
            14.723058,
            53.624787,
            45.405331
          ],
          [
            14.723246,
            53.624597,
            46.005138
          ],
          [
            14.723427,
            53.624375,
            46.675857
          ],
          [
            14.723583,
            53.624183,
            47.255563
          ],
          [
            14.723773,
            53.624021,
            47.826761
          ],
          [
            14.724008,
            53.623867,
            48.424413
          ],
          [
            14.724228,
            53.623714,
            49.002374
          ],
          [
            14.724458,
            53.62353,
            49.66132
          ],
          [
            14.724732,
            53.623354,
            50.350135
          ],
          [
            14.725035,
            53.623167,
            51.09573
          ],
          [
            14.725336,
            53.623012,
            51.775124
          ],
          [
            14.725636,
            53.622879,
            52.413654
          ],
          [
            14.725962,
            53.622786,
            51.580824
          ],
          [
            14.726276,
            53.622706,
            50.567101
          ],
          [
            14.726622,
            53.622627,
            49.466666
          ],
          [
            14.726979,
            53.622555,
            48.348269
          ],
          [
            14.727398,
            53.622536,
            47.101886
          ],
          [
            14.727801,
            53.622499,
            45.891395
          ],
          [
            14.72818,
            53.622483,
            44.761498
          ],
          [
            14.728513,
            53.622525,
            43.751301
          ],
          [
            14.728522,
            53.622532,
            43.444158
          ],
          [
            14.728146,
            53.622512,
            43.352787
          ],
          [
            14.727841,
            53.622471,
            43.275522
          ],
          [
            14.728891,
            53.62248,
            43.021482
          ],
          [
            14.729306,
            53.622501,
            42.92072
          ],
          [
            14.729682,
            53.622511,
            42.829637
          ],
          [
            14.730149,
            53.622509,
            42.911927
          ],
          [
            14.730544,
            53.622532,
            43.142355
          ],
          [
            14.730914,
            53.62254,
            43.357693
          ],
          [
            14.731292,
            53.62255,
            43.578085
          ],
          [
            14.731733,
            53.622558,
            43.834151
          ],
          [
            14.732153,
            53.62259,
            44.079857
          ],
          [
            14.732548,
            53.622606,
            44.309582
          ],
          [
            14.732955,
            53.622624,
            44.537534
          ],
          [
            14.733364,
            53.622634,
            44.611209
          ],
          [
            14.733774,
            53.622647,
            44.685132
          ],
          [
            14.734165,
            53.622644,
            44.755598
          ],
          [
            14.734569,
            53.622591,
            44.830066
          ],
          [
            14.734971,
            53.622473,
            44.910775
          ],
          [
            14.735349,
            53.622385,
            44.984188
          ],
          [
            14.735678,
            53.622304,
            45.048307
          ],
          [
            14.736114,
            53.622224,
            45.159734
          ],
          [
            14.736523,
            53.622177,
            45.277571
          ],
          [
            14.736921,
            53.622139,
            45.39156
          ],
          [
            14.737268,
            53.622092,
            45.492305
          ],
          [
            14.73762,
            53.62198,
            45.606248
          ],
          [
            14.737971,
            53.621834,
            45.727687
          ],
          [
            14.738199,
            53.621659,
            45.833152
          ],
          [
            14.738369,
            53.621473,
            45.934271
          ],
          [
            14.73843,
            53.621245,
            45.156873
          ],
          [
            14.738498,
            53.620996,
            44.28679
          ],
          [
            14.738587,
            53.620765,
            43.469464
          ],
          [
            14.738622,
            53.62055,
            42.724385
          ],
          [
            14.738666,
            53.620321,
            41.928586
          ],
          [
            14.738722,
            53.620068,
            41.04833
          ],
          [
            14.738758,
            53.619839,
            40.254982
          ],
          [
            14.738804,
            53.619615,
            39.782135
          ],
          [
            14.738881,
            53.61938,
            39.941302
          ],
          [
            14.738969,
            53.619137,
            40.106554
          ],
          [
            14.739092,
            53.618906,
            40.267929
          ],
          [
            14.739197,
            53.618664,
            40.434185
          ],
          [
            14.73931,
            53.618415,
            40.605994
          ],
          [
            14.739358,
            53.618198,
            40.754437
          ],
          [
            14.73941,
            53.618005,
            40.888101
          ],
          [
            14.739543,
            53.617777,
            41.491218
          ],
          [
            14.739686,
            53.617561,
            42.214014
          ],
          [
            14.739829,
            53.617362,
            42.88809
          ],
          [
            14.73996,
            53.617166,
            43.544995
          ],
          [
            14.740141,
            53.616955,
            44.28855
          ],
          [
            14.740236,
            53.616738,
            44.986928
          ],
          [
            14.740368,
            53.61653,
            45.678849
          ],
          [
            14.74052,
            53.616316,
            46.401958
          ],
          [
            14.740649,
            53.6161,
            46.248993
          ],
          [
            14.74077,
            53.615892,
            45.923606
          ],
          [
            14.740914,
            53.615681,
            45.587008
          ],
          [
            14.741035,
            53.61547,
            45.25724
          ],
          [
            14.741151,
            53.615261,
            44.931875
          ],
          [
            14.741257,
            53.615073,
            44.638544
          ],
          [
            14.741354,
            53.61488,
            44.340732
          ],
          [
            14.74145,
            53.614681,
            44.033703
          ],
          [
            14.74152,
            53.61449,
            43.805455
          ],
          [
            14.741584,
            53.614307,
            43.664203
          ],
          [
            14.741659,
            53.614123,
            43.521532
          ],
          [
            14.741722,
            53.613916,
            43.362348
          ],
          [
            14.741773,
            53.613723,
            43.215162
          ],
          [
            14.741816,
            53.613543,
            43.077773
          ],
          [
            14.741806,
            53.613309,
            42.901442
          ],
          [
            14.741758,
            53.613106,
            42.746979
          ],
          [
            14.741754,
            53.612883,
            42.578981
          ],
          [
            14.741701,
            53.612677,
            42.511131
          ],
          [
            14.74162,
            53.612455,
            42.506333
          ],
          [
            14.741561,
            53.612257,
            42.502084
          ],
          [
            14.741457,
            53.612068,
            42.497858
          ],
          [
            14.741383,
            53.611866,
            42.493491
          ],
          [
            14.741333,
            53.611652,
            42.488921
          ],
          [
            14.741257,
            53.611457,
            42.484695
          ],
          [
            14.741137,
            53.611256,
            42.480193
          ],
          [
            14.741049,
            53.611064,
            42.475989
          ],
          [
            14.740983,
            53.610847,
            42.446484
          ],
          [
            14.740904,
            53.61061,
            42.412501
          ],
          [
            14.74083,
            53.610405,
            42.382957
          ],
          [
            14.740741,
            53.610219,
            42.355728
          ],
          [
            14.740654,
            53.610017,
            42.326425
          ],
          [
            14.740591,
            53.609801,
            42.295556
          ],
          [
            14.740525,
            53.609594,
            42.26584
          ],
          [
            14.740428,
            53.60937,
            42.23333
          ],
          [
            14.740359,
            53.609142,
            42.428733
          ],
          [
            14.74027,
            53.608943,
            42.697697
          ],
          [
            14.740183,
            53.60872,
            42.996366
          ],
          [
            14.740101,
            53.608485,
            43.309487
          ],
          [
            14.740036,
            53.608242,
            43.630938
          ],
          [
            14.73992,
            53.608036,
            43.914328
          ],
          [
            14.739839,
            53.607799,
            44.229789
          ],
          [
            14.739729,
            53.607594,
            44.51089
          ],
          [
            14.739652,
            53.607393,
            44.517374
          ],
          [
            14.739616,
            53.607195,
            44.453576
          ],
          [
            14.739581,
            53.60698,
            44.384351
          ],
          [
            14.739503,
            53.606776,
            44.31733
          ],
          [
            14.73944,
            53.606556,
            44.245867
          ],
          [
            14.7394,
            53.606321,
            44.170221
          ],
          [
            14.739379,
            53.6061,
            44.099235
          ],
          [
            14.739365,
            53.605876,
            44.027382
          ],
          [
            14.739347,
            53.605655,
            43.995143
          ],
          [
            14.739337,
            53.605409,
            43.999551
          ],
          [
            14.739349,
            53.60516,
            44.004013
          ],
          [
            14.739366,
            53.604932,
            44.0081
          ],
          [
            14.739351,
            53.6047,
            44.012258
          ],
          [
            14.739321,
            53.604458,
            44.016603
          ],
          [
            14.739344,
            53.604246,
            44.020409
          ],
          [
            14.739384,
            53.604016,
            44.024558
          ],
          [
            14.739446,
            53.603799,
            44.068154
          ],
          [
            14.739458,
            53.603559,
            44.125849
          ],
          [
            14.739496,
            53.603321,
            44.183295
          ],
          [
            14.739508,
            53.603097,
            44.237166
          ],
          [
            14.739511,
            53.60286,
            44.29413
          ],
          [
            14.739531,
            53.602613,
            44.353675
          ],
          [
            14.739536,
            53.602375,
            44.410996
          ],
          [
            14.739579,
            53.602116,
            44.55257
          ],
          [
            14.739584,
            53.601863,
            44.913003
          ],
          [
            14.739616,
            53.601647,
            45.221697
          ],
          [
            14.739664,
            53.60143,
            45.533481
          ],
          [
            14.739683,
            53.601173,
            45.899753
          ],
          [
            14.739722,
            53.600917,
            46.265771
          ],
          [
            14.739739,
            53.600686,
            46.595055
          ],
          [
            14.739785,
            53.600473,
            46.900835
          ],
          [
            14.739814,
            53.600225,
            46.785334
          ],
          [
            14.739858,
            53.600002,
            46.471309
          ],
          [
            14.739906,
            53.59981,
            46.199884
          ],
          [
            14.739951,
            53.599628,
            45.942353
          ],
          [
            14.739916,
            53.599406,
            45.630563
          ],
          [
            14.739919,
            53.599181,
            45.314877
          ],
          [
            14.739951,
            53.598961,
            45.005908
          ],
          [
            14.739963,
            53.59871,
            44.654876
          ],
          [
            14.73999,
            53.59847,
            44.318982
          ],
          [
            14.740032,
            53.598254,
            44.014981
          ],
          [
            14.740065,
            53.598063,
            43.746828
          ],
          [
            14.740071,
            53.597803,
            43.384388
          ],
          [
            14.740087,
            53.597583,
            43.076329
          ],
          [
            14.74004,
            53.597345,
            42.74189
          ],
          [
            14.74006,
            53.597115,
            42.415811
          ],
          [
            14.740037,
            53.596887,
            42.097361
          ],
          [
            14.740022,
            53.596682,
            42.0942
          ],
          [
            14.740091,
            53.596449,
            42.268061
          ],
          [
            14.740113,
            53.596238,
            42.424339
          ],
          [
            14.740335,
            53.59614,
            42.570341
          ],
          [
            14.740667,
            53.596201,
            42.721668
          ],
          [
            14.740958,
            53.596256,
            42.854648
          ],
          [
            14.741306,
            53.596328,
            43.015205
          ],
          [
            14.741654,
            53.596387,
            43.172795
          ],
          [
            14.741962,
            53.596442,
            43.312879
          ],
          [
            14.742271,
            53.596478,
            43.191291
          ],
          [
            14.742612,
            53.596549,
            43.044363
          ],
          [
            14.742971,
            53.596614,
            42.89181
          ],
          [
            14.743176,
            53.596374,
            42.70629
          ],
          [
            14.743123,
            53.596364,
            42.579256
          ],
          [
            14.743077,
            53.596544,
            42.453899
          ],
          [
            14.742765,
            53.596551,
            42.32074
          ],
          [
            14.742425,
            53.596509,
            42.179504
          ],
          [
            14.742061,
            53.596469,
            42.029625
          ],
          [
            14.741695,
            53.596418,
            41.878171
          ],
          [
            14.741345,
            53.596378,
            41.734477
          ],
          [
            14.741023,
            53.596318,
            41.59852
          ],
          [
            14.74066,
            53.596245,
            41.444364
          ],
          [
            14.740333,
            53.596141,
            41.295143
          ],
          [
            14.740197,
            53.595986,
            41.170875
          ],
          [
            14.740242,
            53.595774,
            41.026063
          ],
          [
            14.740338,
            53.595601,
            40.901444
          ],
          [
            14.740412,
            53.595423,
            41.023452
          ],
          [
            14.740351,
            53.595452,
            41.232462
          ],
          [
            14.740159,
            53.595204,
            41.553036
          ],
          [
            14.740191,
            53.595,
            41.78341
          ],
          [
            14.740212,
            53.594794,
            42.015474
          ],
          [
            14.740187,
            53.594595,
            42.24063
          ],
          [
            14.74019,
            53.594397,
            42.463014
          ],
          [
            14.740277,
            53.594182,
            42.713315
          ],
          [
            14.740276,
            53.593974,
            42.883558
          ],
          [
            14.740301,
            53.593788,
            42.876711
          ],
          [
            14.740321,
            53.593577,
            42.868907
          ],
          [
            14.740317,
            53.593367,
            42.861197
          ],
          [
            14.740324,
            53.593175,
            42.854151
          ],
          [
            14.740329,
            53.592968,
            42.846556
          ],
          [
            14.740365,
            53.592759,
            42.838846
          ],
          [
            14.740378,
            53.592562,
            42.831604
          ],
          [
            14.740408,
            53.59236,
            42.824162
          ],
          [
            14.740435,
            53.592149,
            42.690459
          ],
          [
            14.740431,
            53.591933,
            42.368176
          ],
          [
            14.740447,
            53.591744,
            42.085799
          ],
          [
            14.74045,
            53.591549,
            41.794822
          ],
          [
            14.740456,
            53.591327,
            41.463537
          ],
          [
            14.740507,
            53.59112,
            41.150169
          ],
          [
            14.740591,
            53.591298,
            40.865125
          ],
          [
            14.740793,
            53.591405,
            40.577519
          ],
          [
            14.74113,
            53.591349,
            40.267613
          ],
          [
            14.741435,
            53.591309,
            40.235141
          ],
          [
            14.741777,
            53.591279,
            40.441824
          ],
          [
            14.742136,
            53.591222,
            40.66399
          ],
          [
            14.74253,
            53.591192,
            40.901378
          ],
          [
            14.742892,
            53.591136,
            41.125059
          ],
          [
            14.743249,
            53.591082,
            41.34521
          ],
          [
            14.743643,
            53.591026,
            41.587308
          ],
          [
            14.744021,
            53.590984,
            41.817143
          ],
          [
            14.744423,
            53.590923,
            41.902048
          ],
          [
            14.744782,
            53.590858,
            41.816518
          ],
          [
            14.745201,
            53.590808,
            41.719622
          ],
          [
            14.745507,
            53.590772,
            41.648902
          ],
          [
            14.745941,
            53.590717,
            41.548277
          ],
          [
            14.746367,
            53.590661,
            41.449363
          ],
          [
            14.74668,
            53.590619,
            41.376573
          ],
          [
            14.747029,
            53.590568,
            41.295084
          ],
          [
            14.747466,
            53.590541,
            41.341643
          ],
          [
            14.747784,
            53.590496,
            41.436292
          ],
          [
            14.748088,
            53.590429,
            41.529482
          ],
          [
            14.748407,
            53.590361,
            41.626893
          ],
          [
            14.748708,
            53.5903,
            41.718376
          ],
          [
            14.749114,
            53.590199,
            41.84489
          ],
          [
            14.749459,
            53.59011,
            41.953043
          ],
          [
            14.749763,
            53.590053,
            42.04466
          ],
          [
            14.750076,
            53.589991,
            42.138983
          ],
          [
            14.750435,
            53.589911,
            42.242432
          ],
          [
            14.750809,
            53.589838,
            42.348634
          ],
          [
            14.751102,
            53.589763,
            42.434672
          ],
          [
            14.751453,
            53.589687,
            42.535211
          ],
          [
            14.751749,
            53.589629,
            42.619068
          ],
          [
            14.752043,
            53.589566,
            42.703139
          ],
          [
            14.752337,
            53.589477,
            42.792651
          ],
          [
            14.752756,
            53.589394,
            42.911458
          ],
          [
            14.753108,
            53.589306,
            42.743287
          ],
          [
            14.753516,
            53.58919,
            42.3817
          ],
          [
            14.753876,
            53.589122,
            42.081307
          ],
          [
            14.75424,
            53.58906,
            41.780592
          ],
          [
            14.754541,
            53.589002,
            41.52882
          ],
          [
            14.754914,
            53.588923,
            41.213327
          ],
          [
            14.755221,
            53.58886,
            40.954746
          ],
          [
            14.755567,
            53.588769,
            40.654477
          ],
          [
            14.755886,
            53.588707,
            40.644782
          ],
          [
            14.756231,
            53.588643,
            40.837235
          ],
          [
            14.756566,
            53.58857,
            41.027069
          ],
          [
            14.756869,
            53.588506,
            41.198064
          ],
          [
            14.757171,
            53.588446,
            41.367497
          ],
          [
            14.757522,
            53.588368,
            41.56712
          ],
          [
            14.757837,
            53.588319,
            41.740323
          ],
          [
            14.758133,
            53.588256,
            41.907567
          ],
          [
            14.758431,
            53.588194,
            42.075613
          ],
          [
            14.758752,
            53.588125,
            42.163454
          ],
          [
            14.759084,
            53.588062,
            42.182263
          ],
          [
            14.759383,
            53.587996,
            42.199477
          ],
          [
            14.75971,
            53.587927,
            42.218196
          ],
          [
            14.760059,
            53.587833,
            42.239415
          ],
          [
            14.760361,
            53.587767,
            42.256775
          ],
          [
            14.760672,
            53.587699,
            42.274654
          ],
          [
            14.760961,
            53.587594,
            42.293028
          ],
          [
            14.761333,
            53.587519,
            42.314218
          ],
          [
            14.761764,
            53.587458,
            42.528617
          ],
          [
            14.7621,
            53.587368,
            42.721735
          ],
          [
            14.762451,
            53.587296,
            42.916694
          ],
          [
            14.762782,
            53.587223,
            43.101712
          ],
          [
            14.762863,
            53.587054,
            43.275123
          ],
          [
            14.762685,
            53.586862,
            43.469272
          ],
          [
            14.762547,
            53.586648,
            43.67151
          ],
          [
            14.762414,
            53.586446,
            43.863024
          ],
          [
            14.762306,
            53.586245,
            43.587341
          ],
          [
            14.762208,
            53.586045,
            43.187694
          ],
          [
            14.762111,
            53.585822,
            42.745795
          ],
          [
            14.762014,
            53.585613,
            42.329987
          ],
          [
            14.76193,
            53.585417,
            41.942183
          ],
          [
            14.761857,
            53.585202,
            41.521415
          ],
          [
            14.761763,
            53.585002,
            41.123195
          ],
          [
            14.761656,
            53.584788,
            40.695143
          ],
          [
            14.761581,
            53.584595,
            40.566144
          ],
          [
            14.761611,
            53.584399,
            40.866637
          ],
          [
            14.761732,
            53.584184,
            41.211756
          ],
          [
            14.761885,
            53.583986,
            41.543126
          ],
          [
            14.762027,
            53.583794,
            41.862036
          ],
          [
            14.762328,
            53.583661,
            42.208049
          ],
          [
            14.762716,
            53.583585,
            42.57694
          ],
          [
            14.763099,
            53.583508,
            42.942034
          ],
          [
            14.763395,
            53.583424,
            43.193418
          ],
          [
            14.763723,
            53.583364,
            43.214263
          ],
          [
            14.76408,
            53.583277,
            43.237688
          ],
          [
            14.764447,
            53.583193,
            43.261567
          ],
          [
            14.764777,
            53.58312,
            43.282943
          ],
          [
            14.765087,
            53.583049,
            43.303112
          ],
          [
            14.765194,
            53.58285,
            43.325605
          ],
          [
            14.765188,
            53.582634,
            43.347705
          ],
          [
            14.765183,
            53.582406,
            43.371023
          ],
          [
            14.765213,
            53.582198,
            43.276332
          ],
          [
            14.765219,
            53.581973,
            43.153264
          ],
          [
            14.765223,
            53.58174,
            43.025581
          ],
          [
            14.765197,
            53.581534,
            42.912677
          ],
          [
            14.765186,
            53.581322,
            42.796729
          ],
          [
            14.765197,
            53.58109,
            42.669864
          ],
          [
            14.765194,
            53.580875,
            42.552296
          ],
          [
            14.765211,
            53.580672,
            42.440926
          ],
          [
            14.765243,
            53.580477,
            42.2199
          ],
          [
            14.765212,
            53.580279,
            41.896826
          ],
          [
            14.76522,
            53.580086,
            41.583329
          ],
          [
            14.765236,
            53.579859,
            41.214422
          ],
          [
            14.76523,
            53.579673,
            40.912314
          ],
          [
            14.765226,
            53.579451,
            40.551842
          ],
          [
            14.765167,
            53.579246,
            40.213499
          ],
          [
            14.765115,
            53.579056,
            39.900589
          ],
          [
            14.764957,
            53.578831,
            39.504737
          ],
          [
            14.764858,
            53.578638,
            39.614772
          ],
          [
            14.764781,
            53.578457,
            39.762132
          ],
          [
            14.764657,
            53.578271,
            39.920186
          ],
          [
            14.764535,
            53.578097,
            40.069013
          ],
          [
            14.764447,
            53.577919,
            40.215944
          ],
          [
            14.764304,
            53.577683,
            40.413917
          ],
          [
            14.76415,
            53.577485,
            40.586485
          ],
          [
            14.764024,
            53.577294,
            40.748635
          ],
          [
            14.763933,
            53.577062,
            40.878744
          ],
          [
            14.763818,
            53.576842,
            40.828113
          ],
          [
            14.763686,
            53.576611,
            40.774512
          ],
          [
            14.763587,
            53.576402,
            40.726791
          ],
          [
            14.763446,
            53.576226,
            40.683961
          ],
          [
            14.763318,
            53.575997,
            40.630933
          ],
          [
            14.763226,
            53.575756,
            40.576549
          ],
          [
            14.763054,
            53.57558,
            40.531054
          ],
          [
            14.762935,
            53.575381,
            40.473727
          ],
          [
            14.762815,
            53.575159,
            40.374474
          ],
          [
            14.762747,
            53.574922,
            40.272096
          ],
          [
            14.762681,
            53.574695,
            40.174025
          ],
          [
            14.762631,
            53.574478,
            40.080786
          ],
          [
            14.762576,
            53.574269,
            39.990732
          ],
          [
            14.762523,
            53.574071,
            39.905349
          ],
          [
            14.762459,
            53.573877,
            39.821194
          ],
          [
            14.762423,
            53.573678,
            39.735963
          ],
          [
            14.762453,
            53.573477,
            39.983242
          ],
          [
            14.762531,
            53.57329,
            40.239773
          ],
          [
            14.762623,
            53.573102,
            40.500995
          ],
          [
            14.762703,
            53.572877,
            40.807217
          ],
          [
            14.762762,
            53.572669,
            41.088162
          ],
          [
            14.762811,
            53.572463,
            41.366173
          ],
          [
            14.762729,
            53.572263,
            41.64098
          ],
          [
            14.76249,
            53.572106,
            41.923849
          ],
          [
            14.762285,
            53.57193,
            42.088083
          ],
          [
            14.762088,
            53.571752,
            41.960634
          ],
          [
            14.761964,
            53.571584,
            41.849607
          ],
          [
            14.761818,
            53.571396,
            41.725625
          ],
          [
            14.761683,
            53.571197,
            41.597424
          ],
          [
            14.761579,
            53.570979,
            41.461701
          ],
          [
            14.761499,
            53.570759,
            41.327154
          ],
          [
            14.761437,
            53.570565,
            41.208333
          ],
          [
            14.7614,
            53.570341,
            41.073595
          ],
          [
            14.761339,
            53.570143,
            40.85558
          ],
          [
            14.761342,
            53.569929,
            40.599496
          ],
          [
            14.761297,
            53.569721,
            40.348332
          ],
          [
            14.761233,
            53.569499,
            40.078254
          ],
          [
            14.761088,
            53.569292,
            39.806911
          ],
          [
            14.760923,
            53.569087,
            39.534262
          ],
          [
            14.760732,
            53.568915,
            39.287064
          ],
          [
            14.760597,
            53.568708,
            39.020248
          ],
          [
            14.760436,
            53.568517,
            38.945469
          ],
          [
            14.760265,
            53.568343,
            39.028199
          ],
          [
            14.760128,
            53.568167,
            39.107939
          ],
          [
            14.759989,
            53.56799,
            39.188096
          ],
          [
            14.759818,
            53.567797,
            39.277617
          ],
          [
            14.759643,
            53.567606,
            39.366869
          ],
          [
            14.759487,
            53.567407,
            39.456963
          ],
          [
            14.759343,
            53.567204,
            39.547369
          ],
          [
            14.759208,
            53.567015,
            39.631639
          ],
          [
            14.759108,
            53.566813,
            39.966721
          ],
          [
            14.758995,
            53.566635,
            40.283419
          ],
          [
            14.758874,
            53.566451,
            40.618652
          ],
          [
            14.758728,
            53.566274,
            40.947381
          ],
          [
            14.758649,
            53.566086,
            41.270395
          ],
          [
            14.758603,
            53.565902,
            41.580028
          ],
          [
            14.758501,
            53.565703,
            41.928048
          ],
          [
            14.75829,
            53.565555,
            42.252444
          ],
          [
            14.758048,
            53.565421,
            42.579619
          ],
          [
            14.757749,
            53.565306,
            42.82393
          ],
          [
            14.757443,
            53.565199,
            43.049413
          ],
          [
            14.757109,
            53.565108,
            43.283424
          ],
          [
            14.75681,
            53.565029,
            43.491382
          ],
          [
            14.756476,
            53.564928,
            43.730274
          ],
          [
            14.75613,
            53.564854,
            43.963758
          ],
          [
            14.755787,
            53.564752,
            44.207216
          ],
          [
            14.755446,
            53.564688,
            44.434885
          ],
          [
            14.755138,
            53.564617,
            44.526651
          ],
          [
            14.754849,
            53.564527,
            44.468763
          ],
          [
            14.754503,
            53.564444,
            44.402508
          ],
          [
            14.754171,
            53.564372,
            44.339814
          ],
          [
            14.753848,
            53.564282,
            44.276337
          ],
          [
            14.753522,
            53.564197,
            44.213057
          ],
          [
            14.753229,
            53.564126,
            44.156936
          ],
          [
            14.752912,
            53.564046,
            44.095852
          ],
          [
            14.752576,
            53.56396,
            44.030962
          ],
          [
            14.752254,
            53.56387,
            43.893806
          ],
          [
            14.751943,
            53.563793,
            43.741176
          ],
          [
            14.751612,
            53.563706,
            43.577293
          ],
          [
            14.751272,
            53.563624,
            43.411154
          ],
          [
            14.750933,
            53.563544,
            43.24573
          ],
          [
            14.75063,
            53.563465,
            43.095859
          ],
          [
            14.750295,
            53.563369,
            42.927286
          ],
          [
            14.749989,
            53.563281,
            42.773333
          ],
          [
            14.74968,
            53.563222,
            42.592313
          ],
          [
            14.749359,
            53.563104,
            42.1018
          ],
          [
            14.749046,
            53.562968,
            41.595582
          ],
          [
            14.748765,
            53.562808,
            41.088631
          ],
          [
            14.748544,
            53.562679,
            40.685811
          ],
          [
            14.748299,
            53.562532,
            40.233687
          ],
          [
            14.748058,
            53.5624,
            39.808051
          ],
          [
            14.747821,
            53.56227,
            39.389008
          ],
          [
            14.74756,
            53.562098,
            38.882861
          ],
          [
            14.747295,
            53.561915,
            38.807877
          ],
          [
            14.747055,
            53.561744,
            38.937079
          ],
          [
            14.74683,
            53.561589,
            39.056634
          ],
          [
            14.746567,
            53.561439,
            39.182577
          ],
          [
            14.746296,
            53.561277,
            39.3153
          ],
          [
            14.746028,
            53.561132,
            39.440592
          ],
          [
            14.745793,
            53.560986,
            39.55795
          ],
          [
            14.745561,
            53.560844,
            39.673045
          ],
          [
            14.745343,
            53.560662,
            39.742362
          ],
          [
            14.745113,
            53.5605,
            39.704289
          ],
          [
            14.744876,
            53.560359,
            39.6685
          ],
          [
            14.744653,
            53.56021,
            39.632679
          ],
          [
            14.744414,
            53.560045,
            39.593572
          ],
          [
            14.744198,
            53.559909,
            39.559974
          ],
          [
            14.743988,
            53.559777,
            39.527301
          ],
          [
            14.743771,
            53.559619,
            39.490678
          ],
          [
            14.743549,
            53.559475,
            39.455606
          ],
          [
            14.743311,
            53.559319,
            39.423522
          ],
          [
            14.74312,
            53.559154,
            39.400554
          ],
          [
            14.742891,
            53.558984,
            39.375594
          ],
          [
            14.742658,
            53.558786,
            39.347905
          ],
          [
            14.742423,
            53.558602,
            39.321422
          ],
          [
            14.742183,
            53.558436,
            39.296327
          ],
          [
            14.741929,
            53.558285,
            39.271824
          ],
          [
            14.741675,
            53.558165,
            39.249741
          ],
          [
            14.741393,
            53.558058,
            39.2351
          ],
          [
            14.741056,
            53.557977,
            39.470148
          ],
          [
            14.740721,
            53.557906,
            39.700369
          ],
          [
            14.740375,
            53.557879,
            39.927793
          ],
          [
            14.740013,
            53.55788,
            40.161433
          ],
          [
            14.739682,
            53.557878,
            40.374954
          ],
          [
            14.739319,
            53.557899,
            40.610665
          ],
          [
            14.738975,
            53.557906,
            40.833403
          ],
          [
            14.738658,
            53.557907,
            41.037957
          ],
          [
            14.738328,
            53.5579,
            41.257699
          ],
          [
            14.738018,
            53.557924,
            41.479006
          ],
          [
            14.737683,
            53.557971,
            41.722747
          ],
          [
            14.737307,
            53.558033,
            41.99873
          ],
          [
            14.736981,
            53.558067,
            42.232829
          ],
          [
            14.736607,
            53.558097,
            42.499601
          ],
          [
            14.736239,
            53.558097,
            42.759738
          ],
          [
            14.73592,
            53.55805,
            42.992583
          ],
          [
            14.735586,
            53.557993,
            43.238274
          ],
          [
            14.735103,
            53.557928,
            42.965479
          ],
          [
            14.734769,
            53.55788,
            42.642208
          ],
          [
            14.734437,
            53.557834,
            42.321614
          ],
          [
            14.734083,
            53.557791,
            41.981857
          ],
          [
            14.733735,
            53.557737,
            41.6433
          ],
          [
            14.733339,
            53.557692,
            41.264031
          ],
          [
            14.732922,
            53.557632,
            40.85846
          ],
          [
            14.732589,
            53.557541,
            40.513458
          ],
          [
            14.73223,
            53.557476,
            40.557714
          ],
          [
            14.731907,
            53.557374,
            40.648507
          ],
          [
            14.731589,
            53.557278,
            40.737053
          ],
          [
            14.731228,
            53.557166,
            40.838131
          ],
          [
            14.730893,
            53.557073,
            40.92988
          ],
          [
            14.730531,
            53.556986,
            41.027017
          ],
          [
            14.730167,
            53.556876,
            41.12838
          ],
          [
            14.729808,
            53.556781,
            41.22407
          ],
          [
            14.729486,
            53.55669,
            41.121275
          ],
          [
            14.729097,
            53.556588,
            40.998693
          ],
          [
            14.728687,
            53.556492,
            40.871607
          ],
          [
            14.728363,
            53.5564,
            40.768062
          ],
          [
            14.728021,
            53.55627,
            40.650758
          ],
          [
            14.727678,
            53.556164,
            40.539301
          ],
          [
            14.72738,
            53.556089,
            40.446001
          ],
          [
            14.727063,
            53.555992,
            40.365524
          ],
          [
            14.726731,
            53.555896,
            40.521895
          ],
          [
            14.726392,
            53.555811,
            40.677729
          ],
          [
            14.726055,
            53.555713,
            40.836682
          ],
          [
            14.725739,
            53.555642,
            40.979746
          ],
          [
            14.725403,
            53.555551,
            41.136123
          ],
          [
            14.72506,
            53.555464,
            41.294138
          ],
          [
            14.724724,
            53.555368,
            41.45207
          ],
          [
            14.724414,
            53.555292,
            41.594083
          ],
          [
            14.724097,
            53.555204,
            41.836578
          ],
          [
            14.72375,
            53.555117,
            42.135554
          ],
          [
            14.723412,
            53.555045,
            42.420562
          ],
          [
            14.723084,
            53.554956,
            42.706938
          ],
          [
            14.72277,
            53.554892,
            42.970418
          ],
          [
            14.722437,
            53.554813,
            43.254988
          ],
          [
            14.722091,
            53.554722,
            43.555365
          ],
          [
            14.721804,
            53.554599,
            43.836494
          ],
          [
            14.721523,
            53.554472,
            43.974244
          ],
          [
            14.721269,
            53.55435,
            43.768726
          ],
          [
            14.720982,
            53.554217,
            43.539821
          ],
          [
            14.720694,
            53.554077,
            43.30571
          ],
          [
            14.720386,
            53.553927,
            43.055228
          ],
          [
            14.720102,
            53.553789,
            42.824513
          ],
          [
            14.719834,
            53.553668,
            42.612813
          ],
          [
            14.719539,
            53.553552,
            42.390353
          ],
          [
            14.719257,
            53.553436,
            42.174608
          ],
          [
            14.718969,
            53.55335,
            42.327657
          ],
          [
            14.718648,
            53.553268,
            42.591775
          ],
          [
            14.718315,
            53.553181,
            42.866722
          ],
          [
            14.718022,
            53.553111,
            43.105381
          ],
          [
            14.717718,
            53.553033,
            43.355714
          ],
          [
            14.717406,
            53.552982,
            43.600729
          ],
          [
            14.717058,
            53.552931,
            43.871658
          ],
          [
            14.716699,
            53.552887,
            44.148827
          ],
          [
            14.716338,
            53.552867,
            44.420267
          ],
          [
            14.715972,
            53.55286,
            44.231317
          ],
          [
            14.715614,
            53.552885,
            44.045219
          ],
          [
            14.715248,
            53.552937,
            43.850905
          ],
          [
            14.714933,
            53.553018,
            43.673787
          ],
          [
            14.71464,
            53.553129,
            43.494326
          ],
          [
            14.714328,
            53.553239,
            43.307123
          ],
          [
            14.714046,
            53.553361,
            43.127083
          ],
          [
            14.713769,
            53.553487,
            42.947084
          ],
          [
            14.7135,
            53.553614,
            42.785556
          ],
          [
            14.713223,
            53.55373,
            42.641456
          ],
          [
            14.712963,
            53.553843,
            42.504459
          ],
          [
            14.712666,
            53.553953,
            42.355594
          ],
          [
            14.712367,
            53.554065,
            42.205276
          ],
          [
            14.712084,
            53.554165,
            42.065132
          ],
          [
            14.711786,
            53.554275,
            41.915859
          ],
          [
            14.71151,
            53.554392,
            41.771546
          ],
          [
            14.711269,
            53.554509,
            41.639091
          ],
          [
            14.711,
            53.554614,
            41.74042
          ],
          [
            14.710729,
            53.554715,
            42.06873
          ],
          [
            14.710452,
            53.554818,
            42.403607
          ],
          [
            14.710163,
            53.554931,
            42.75825
          ],
          [
            14.70986,
            53.555029,
            43.112435
          ],
          [
            14.709532,
            53.55508,
            43.460092
          ],
          [
            14.709216,
            53.555107,
            43.787513
          ],
          [
            14.70886,
            53.555122,
            44.153542
          ],
          [
            14.708512,
            53.555117,
            44.510648
          ],
          [
            14.70812,
            53.555112,
            44.752152
          ],
          [
            14.707819,
            53.555088,
            44.853542
          ],
          [
            14.707439,
            53.555064,
            44.981704
          ],
          [
            14.707085,
            53.555038,
            45.100915
          ],
          [
            14.706741,
            53.554991,
            45.219229
          ],
          [
            14.706409,
            53.554934,
            45.33469
          ],
          [
            14.706086,
            53.554867,
            45.448998
          ],
          [
            14.705779,
            53.554775,
            45.563859
          ],
          [
            14.705474,
            53.554673,
            45.680831
          ],
          [
            14.705135,
            53.554588,
            45.502184
          ],
          [
            14.70483,
            53.554522,
            45.33369
          ],
          [
            14.704511,
            53.554486,
            45.165575
          ],
          [
            14.704138,
            53.55444,
            44.968343
          ],
          [
            14.703819,
            53.554411,
            44.801289
          ],
          [
            14.70348,
            53.554392,
            44.624852
          ],
          [
            14.703138,
            53.554376,
            44.447267
          ],
          [
            14.702785,
            53.554376,
            44.264404
          ],
          [
            14.702443,
            53.554324,
            44.067372
          ],
          [
            14.702578,
            53.554126,
            43.837301
          ],
          [
            14.702707,
            53.553943,
            43.624188
          ],
          [
            14.702867,
            53.55375,
            43.393231
          ],
          [
            14.702979,
            53.553555,
            43.171835
          ],
          [
            14.703098,
            53.553356,
            42.944589
          ],
          [
            14.703216,
            53.553168,
            42.729297
          ],
          [
            14.703294,
            53.552962,
            42.502576
          ],
          [
            14.70297,
            53.552905,
            42.28675
          ],
          [
            14.702634,
            53.552855,
            42.176761
          ],
          [
            14.702334,
            53.552819,
            42.158223
          ],
          [
            14.701962,
            53.552782,
            42.135464
          ],
          [
            14.701649,
            53.552735,
            42.115986
          ],
          [
            14.701294,
            53.552696,
            42.094186
          ],
          [
            14.7009,
            53.552679,
            42.070356
          ],
          [
            14.700581,
            53.552669,
            42.051085
          ],
          [
            14.700238,
            53.552661,
            42.030377
          ],
          [
            14.699903,
            53.552655,
            42.01016
          ],
          [
            14.699581,
            53.55265,
            42.440028
          ],
          [
            14.699252,
            53.552645,
            43.015444
          ],
          [
            14.698941,
            53.552634,
            43.561002
          ],
          [
            14.698621,
            53.552622,
            44.121558
          ],
          [
            14.698289,
            53.552609,
            44.703263
          ],
          [
            14.697969,
            53.552599,
            45.263463
          ],
          [
            14.697639,
            53.552588,
            45.84148
          ],
          [
            14.697292,
            53.552581,
            46.449316
          ],
          [
            14.696945,
            53.552574,
            47.05636
          ],
          [
            14.696602,
            53.552575,
            47.092539
          ],
          [
            14.696259,
            53.552572,
            46.746973
          ],
          [
            14.695898,
            53.552575,
            46.383184
          ],
          [
            14.695551,
            53.55258,
            46.033525
          ],
          [
            14.695203,
            53.552571,
            45.682724
          ],
          [
            14.694858,
            53.552575,
            45.334809
          ],
          [
            14.694519,
            53.552576,
            44.9934
          ],
          [
            14.694184,
            53.552572,
            44.655945
          ],
          [
            14.69384,
            53.552566,
            44.308937
          ],
          [
            14.693465,
            53.552561,
            43.90018
          ],
          [
            14.693111,
            53.552551,
            43.508088
          ],
          [
            14.692788,
            53.552554,
            43.15104
          ],
          [
            14.692455,
            53.552546,
            42.782722
          ],
          [
            14.692133,
            53.552545,
            42.426737
          ],
          [
            14.691798,
            53.552542,
            42.056464
          ],
          [
            14.691468,
            53.552538,
            41.691668
          ],
          [
            14.691124,
            53.552532,
            41.311331
          ],
          [
            14.690773,
            53.552522,
            40.922962
          ],
          [
            14.69045,
            53.552525,
            41.137504
          ],
          [
            14.690111,
            53.552517,
            41.397318
          ],
          [
            14.689789,
            53.552518,
            41.644273
          ],
          [
            14.689452,
            53.552527,
            41.902561
          ],
          [
            14.68912,
            53.552504,
            42.158494
          ],
          [
            14.6888,
            53.5525,
            42.403771
          ],
          [
            14.688456,
            53.552482,
            42.668271
          ],
          [
            14.688142,
            53.552509,
            42.91124
          ],
          [
            14.687833,
            53.552522,
            43.148725
          ],
          [
            14.687491,
            53.552528,
            42.8731
          ],
          [
            14.687136,
            53.55252,
            42.371566
          ],
          [
            14.686774,
            53.552521,
            41.860077
          ],
          [
            14.686416,
            53.552511,
            41.354123
          ],
          [
            14.686103,
            53.552476,
            40.903234
          ],
          [
            14.685757,
            53.552448,
            40.410192
          ],
          [
            14.68544,
            53.55239,
            39.941811
          ],
          [
            14.685085,
            53.552302,
            39.398652
          ],
          [
            14.684774,
            53.5522,
            38.975899
          ],
          [
            14.68448,
            53.552075,
            39.25298
          ],
          [
            14.684204,
            53.55195,
            39.519038
          ],
          [
            14.683951,
            53.551821,
            39.774658
          ],
          [
            14.683684,
            53.551682,
            40.046739
          ],
          [
            14.683406,
            53.551543,
            40.325413
          ],
          [
            14.68314,
            53.551404,
            40.596906
          ],
          [
            14.682851,
            53.551284,
            40.867784
          ],
          [
            14.682539,
            53.551222,
            41.120342
          ],
          [
            14.682169,
            53.551169,
            41.301973
          ],
          [
            14.681822,
            53.551146,
            41.365178
          ],
          [
            14.681482,
            53.551096,
            41.428568
          ],
          [
            14.681132,
            53.551041,
            41.494107
          ],
          [
            14.68079,
            53.550994,
            41.557636
          ],
          [
            14.680447,
            53.550942,
            41.6217
          ],
          [
            14.680097,
            53.550893,
            41.686792
          ],
          [
            14.679773,
            53.550854,
            41.746658
          ],
          [
            14.679347,
            53.550817,
            41.807724
          ],
          [
            14.678987,
            53.55076,
            41.748468
          ],
          [
            14.678671,
            53.550679,
            41.693786
          ],
          [
            14.678383,
            53.550564,
            41.638587
          ],
          [
            14.678124,
            53.55044,
            41.585743
          ],
          [
            14.677874,
            53.550311,
            41.533133
          ],
          [
            14.677659,
            53.550154,
            41.479006
          ],
          [
            14.677433,
            53.549966,
            41.417205
          ],
          [
            14.677196,
            53.54979,
            41.356932
          ],
          [
            14.676926,
            53.549608,
            41.201621
          ],
          [
            14.676659,
            53.549435,
            41.00698
          ],
          [
            14.676378,
            53.549306,
            40.831928
          ],
          [
            14.676077,
            53.54922,
            40.667123
          ],
          [
            14.675763,
            53.549143,
            40.49976
          ],
          [
            14.675443,
            53.549048,
            40.323273
          ],
          [
            14.675103,
            53.548954,
            40.138485
          ],
          [
            14.674886,
            53.548811,
            39.972555
          ],
          [
            14.674818,
            53.548586,
            39.924883
          ],
          [
            14.674727,
            53.548381,
            40.162937
          ],
          [
            14.674655,
            53.548166,
            40.409119
          ],
          [
            14.674576,
            53.54795,
            40.657289
          ],
          [
            14.674521,
            53.547737,
            40.899242
          ],
          [
            14.674444,
            53.547547,
            41.11903
          ],
          [
            14.674395,
            53.54734,
            41.353865
          ],
          [
            14.674353,
            53.547121,
            41.601327
          ],
          [
            14.674324,
            53.546905,
            41.844741
          ],
          [
            14.674476,
            53.546708,
            42.025572
          ],
          [
            14.674712,
            53.546581,
            42.175564
          ],
          [
            14.674902,
            53.546433,
            42.323188
          ],
          [
            14.675119,
            53.546274,
            42.485936
          ],
          [
            14.67537,
            53.546102,
            42.666452
          ],
          [
            14.675621,
            53.545947,
            42.837025
          ],
          [
            14.675853,
            53.545785,
            43.005702
          ],
          [
            14.676081,
            53.545601,
            43.18688
          ],
          [
            14.676301,
            53.545431,
            43.453734
          ],
          [
            14.676522,
            53.545268,
            43.854987
          ],
          [
            14.676739,
            53.54509,
            44.277115
          ],
          [
            14.676969,
            53.544924,
            44.689467
          ],
          [
            14.677171,
            53.544749,
            45.096142
          ],
          [
            14.677392,
            53.54458,
            45.506334
          ],
          [
            14.677612,
            53.544416,
            45.908486
          ],
          [
            14.67785,
            53.544236,
            46.347203
          ],
          [
            14.678069,
            53.544067,
            46.707374
          ],
          [
            14.678307,
            53.543902,
            46.13451
          ],
          [
            14.678551,
            53.543737,
            45.554292
          ],
          [
            14.678735,
            53.543558,
            44.999856
          ],
          [
            14.678882,
            53.543355,
            44.41648
          ],
          [
            14.67899,
            53.543143,
            43.832746
          ],
          [
            14.679078,
            53.542926,
            43.243411
          ],
          [
            14.678992,
            53.54271,
            42.657545
          ],
          [
            14.678893,
            53.542492,
            42.062414
          ],
          [
            14.678772,
            53.542271,
            41.716604
          ],
          [
            14.67865,
            53.54205,
            41.402672
          ],
          [
            14.678543,
            53.541831,
            41.094942
          ],
          [
            14.678436,
            53.541618,
            40.794999
          ],
          [
            14.678354,
            53.541402,
            40.496203
          ],
          [
            14.678255,
            53.54118,
            40.186111
          ],
          [
            14.678147,
            53.540971,
            39.890937
          ],
          [
            14.678057,
            53.54075,
            39.583588
          ],
          [
            14.677983,
            53.540524,
            39.574289
          ],
          [
            14.677923,
            53.540306,
            39.579022
          ],
          [
            14.677846,
            53.5401,
            39.583542
          ],
          [
            14.677788,
            53.539907,
            39.587744
          ],
          [
            14.677744,
            53.539695,
            39.592327
          ],
          [
            14.677679,
            53.539501,
            39.596565
          ],
          [
            14.677608,
            53.539299,
            39.600992
          ],
          [
            14.677534,
            53.539105,
            39.605254
          ],
          [
            14.677485,
            53.538918,
            39.574634
          ],
          [
            14.677436,
            53.538706,
            39.446938
          ],
          [
            14.677371,
            53.538483,
            39.311884
          ],
          [
            14.677327,
            53.538258,
            39.176509
          ],
          [
            14.67725,
            53.538044,
            39.045829
          ],
          [
            14.67718,
            53.537833,
            38.917482
          ],
          [
            14.677108,
            53.537623,
            38.789443
          ],
          [
            14.677003,
            53.537421,
            38.663284
          ],
          [
            14.676932,
            53.537223,
            38.542471
          ],
          [
            14.67688,
            53.537021,
            38.568128
          ],
          [
            14.676992,
            53.536847,
            38.602047
          ],
          [
            14.677336,
            53.536755,
            38.641065
          ],
          [
            14.677661,
            53.536668,
            38.6779
          ],
          [
            14.677971,
            53.53657,
            38.714214
          ],
          [
            14.678281,
            53.536412,
            38.756655
          ],
          [
            14.67851,
            53.536213,
            38.798607
          ],
          [
            14.678703,
            53.536014,
            38.838575
          ],
          [
            14.67889,
            53.535838,
            38.866925
          ],
          [
            14.679082,
            53.535671,
            38.891977
          ],
          [
            14.679281,
            53.535501,
            38.917616
          ],
          [
            14.679468,
            53.535318,
            38.944125
          ],
          [
            14.679638,
            53.535119,
            38.971774
          ],
          [
            14.67976,
            53.534924,
            38.997533
          ],
          [
            14.679843,
            53.534736,
            39.021625
          ],
          [
            14.679951,
            53.534508,
            39.050961
          ],
          [
            14.680023,
            53.534283,
            39.03658
          ],
          [
            14.680125,
            53.534059,
            38.930783
          ],
          [
            14.680259,
            53.53386,
            38.832796
          ],
          [
            14.680505,
            53.533682,
            38.727678
          ],
          [
            14.680782,
            53.533519,
            38.622011
          ],
          [
            14.681045,
            53.533352,
            38.517795
          ],
          [
            14.681304,
            53.533178,
            38.411943
          ],
          [
            14.681555,
            53.532993,
            38.303496
          ],
          [
            14.681769,
            53.532779,
            38.178344
          ],
          [
            14.681943,
            53.532551,
            38.04317
          ],
          [
            14.682121,
            53.532345,
            37.917993
          ],
          [
            14.682357,
            53.532146,
            37.786008
          ],
          [
            14.682642,
            53.53199,
            37.661742
          ],
          [
            14.682912,
            53.531854,
            37.548228
          ],
          [
            14.683221,
            53.53171,
            37.422244
          ],
          [
            14.683493,
            53.531543,
            37.296813
          ],
          [
            14.683722,
            53.531354,
            37.146365
          ],
          [
            14.683655,
            53.531151,
            37.008841
          ],
          [
            14.683548,
            53.530945,
            36.867396
          ],
          [
            14.683447,
            53.530716,
            36.712005
          ],
          [
            14.683385,
            53.53052,
            36.581134
          ],
          [
            14.683321,
            53.530339,
            36.459796
          ],
          [
            14.683268,
            53.530131,
            36.321789
          ],
          [
            14.683192,
            53.52991,
            36.173784
          ],
          [
            14.683092,
            53.529712,
            36.195531
          ],
          [
            14.682867,
            53.529573,
            36.390266
          ],
          [
            14.68259,
            53.529477,
            36.581001
          ],
          [
            14.682392,
            53.529322,
            36.77736
          ],
          [
            14.682261,
            53.529115,
            36.998795
          ],
          [
            14.682106,
            53.528891,
            37.241077
          ],
          [
            14.68201,
            53.528677,
            37.462796
          ],
          [
            14.682096,
            53.528482,
            37.665359
          ],
          [
            14.681994,
            53.528286,
            37.878483
          ],
          [
            14.681761,
            53.528132,
            37.660555
          ],
          [
            14.681832,
            53.527926,
            37.389491
          ],
          [
            14.682126,
            53.527841,
            37.115668
          ],
          [
            14.682548,
            53.527795,
            36.788625
          ],
          [
            14.682917,
            53.527695,
            36.479621
          ],
          [
            14.683312,
            53.527608,
            36.158902
          ],
          [
            14.683626,
            53.52746,
            35.845914
          ],
          [
            14.683812,
            53.527262,
            35.628464
          ],
          [
            14.683996,
            53.527057,
            35.865141
          ],
          [
            14.684219,
            53.526828,
            36.133873
          ],
          [
            14.68436,
            53.526589,
            36.394728
          ],
          [
            14.684341,
            53.52637,
            36.617612
          ],
          [
            14.684317,
            53.526141,
            36.850596
          ],
          [
            14.684265,
            53.525917,
            37.080219
          ],
          [
            14.684218,
            53.525693,
            37.309824
          ],
          [
            14.684176,
            53.525472,
            37.390375
          ],
          [
            14.684307,
            53.525309,
            37.334493
          ],
          [
            14.684619,
            53.525279,
            37.279715
          ],
          [
            14.684976,
            53.525252,
            37.217828
          ],
          [
            14.685345,
            53.525226,
            37.153946
          ],
          [
            14.68574,
            53.525192,
            37.085315
          ],
          [
            14.686107,
            53.525112,
            37.018098
          ],
          [
            14.686451,
            53.525024,
            36.953708
          ],
          [
            14.686802,
            53.524944,
            36.859295
          ],
          [
            14.687252,
            53.524925,
            36.609662
          ],
          [
            14.687614,
            53.525001,
            36.397335
          ],
          [
            14.687956,
            53.525078,
            36.195545
          ],
          [
            14.688311,
            53.525156,
            35.986435
          ],
          [
            14.688647,
            53.525231,
            35.78839
          ],
          [
            14.689032,
            53.525267,
            35.572045
          ],
          [
            14.68945,
            53.525279,
            35.341268
          ],
          [
            14.689813,
            53.525249,
            35.340294
          ],
          [
            14.690175,
            53.525239,
            35.561912
          ],
          [
            14.690538,
            53.525233,
            35.783633
          ],
          [
            14.690945,
            53.525289,
            36.038513
          ],
          [
            14.691354,
            53.525355,
            36.296845
          ],
          [
            14.691749,
            53.525371,
            36.538176
          ],
          [
            14.692123,
            53.525339,
            36.769866
          ],
          [
            14.692545,
            53.525324,
            37.027802
          ],
          [
            14.692939,
            53.525282,
            37.116798
          ],
          [
            14.6933,
            53.525237,
            37.161379
          ],
          [
            14.693686,
            53.52516,
            37.210559
          ],
          [
            14.694075,
            53.525101,
            37.259063
          ],
          [
            14.694439,
            53.525024,
            37.305798
          ],
          [
            14.694757,
            53.524907,
            37.351032
          ],
          [
            14.695061,
            53.524786,
            37.39538
          ],
          [
            14.695356,
            53.524643,
            37.441431
          ],
          [
            14.69567,
            53.524485,
            37.410494
          ],
          [
            14.69595,
            53.524341,
            37.379223
          ],
          [
            14.69624,
            53.524193,
            37.346939
          ],
          [
            14.696539,
            53.524047,
            37.314255
          ],
          [
            14.69684,
            53.523897,
            37.28107
          ],
          [
            14.697098,
            53.523732,
            37.248715
          ],
          [
            14.697271,
            53.523537,
            37.217322
          ],
          [
            14.69739,
            53.523339,
            37.190727
          ],
          [
            14.697486,
            53.523141,
            37.3025
          ],
          [
            14.697566,
            53.522965,
            37.40144
          ],
          [
            14.69765,
            53.522786,
            37.502341
          ],
          [
            14.697644,
            53.522547,
            37.632575
          ],
          [
            14.697666,
            53.522331,
            37.75023
          ],
          [
            14.697804,
            53.522139,
            37.86497
          ],
          [
            14.697963,
            53.521971,
            37.969597
          ],
          [
            14.697952,
            53.521977,
            38.073924
          ],
          [
            14.698142,
            53.521782,
            38.118807
          ],
          [
            14.698356,
            53.521639,
            37.967325
          ],
          [
            14.698526,
            53.521443,
            37.801757
          ],
          [
            14.698697,
            53.521236,
            37.628938
          ],
          [
            14.69891,
            53.521065,
            37.469424
          ],
          [
            14.699124,
            53.520928,
            37.329286
          ],
          [
            14.699416,
            53.520778,
            37.15689
          ],
          [
            14.699706,
            53.520683,
            37.009373
          ],
          [
            14.700029,
            53.520613,
            36.856167
          ],
          [
            14.700362,
            53.520583,
            36.688041
          ],
          [
            14.700676,
            53.520507,
            36.512004
          ],
          [
            14.701013,
            53.520414,
            36.319212
          ],
          [
            14.701337,
            53.520323,
            36.132607
          ],
          [
            14.701617,
            53.520308,
            35.972628
          ],
          [
            14.701975,
            53.520301,
            35.784567
          ],
          [
            14.702351,
            53.520287,
            35.588649
          ],
          [
            14.702676,
            53.520307,
            35.419026
          ],
          [
            14.702995,
            53.520333,
            35.25197
          ],
          [
            14.703334,
            53.520363,
            35.716412
          ],
          [
            14.703653,
            53.520387,
            36.171963
          ],
          [
            14.703994,
            53.520382,
            36.66351
          ],
          [
            14.704298,
            53.520323,
            37.116148
          ],
          [
            14.704588,
            53.520221,
            37.593265
          ],
          [
            14.704904,
            53.520165,
            38.063988
          ],
          [
            14.705179,
            53.52005,
            38.541364
          ],
          [
            14.705492,
            53.519951,
            39.045094
          ],
          [
            14.705769,
            53.519848,
            39.50767
          ],
          [
            14.706054,
            53.519765,
            39.666855
          ],
          [
            14.706359,
            53.519679,
            39.821919
          ],
          [
            14.706702,
            53.519623,
            39.984742
          ],
          [
            14.707005,
            53.519576,
            40.128384
          ],
          [
            14.707264,
            53.519477,
            40.270355
          ],
          [
            14.707525,
            53.51935,
            40.42483
          ],
          [
            14.707798,
            53.519236,
            40.577549
          ],
          [
            14.708053,
            53.51909,
            40.741012
          ],
          [
            14.70822,
            53.518945,
            40.883484
          ],
          [
            14.708489,
            53.518803,
            40.613919
          ],
          [
            14.708747,
            53.518669,
            40.269315
          ],
          [
            14.70906,
            53.518543,
            39.888776
          ],
          [
            14.709345,
            53.51853,
            39.561585
          ],
          [
            14.709632,
            53.518413,
            39.211434
          ],
          [
            14.709905,
            53.518322,
            38.895776
          ],
          [
            14.710173,
            53.518217,
            38.572665
          ],
          [
            14.710424,
            53.518097,
            38.247958
          ],
          [
            14.710668,
            53.517973,
            37.921961
          ],
          [
            14.71094,
            53.51787,
            37.888791
          ],
          [
            14.711238,
            53.5178,
            37.911494
          ],
          [
            14.71154,
            53.517708,
            37.935184
          ],
          [
            14.711827,
            53.517614,
            37.958069
          ],
          [
            14.712123,
            53.5175,
            37.982962
          ],
          [
            14.712465,
            53.517394,
            38.009877
          ],
          [
            14.712771,
            53.51728,
            38.035086
          ],
          [
            14.713012,
            53.517162,
            38.056922
          ],
          [
            14.713257,
            53.517054,
            38.078225
          ],
          [
            14.713529,
            53.516954,
            38.237025
          ],
          [
            14.713833,
            53.516884,
            38.418035
          ],
          [
            14.71413,
            53.516823,
            38.592258
          ],
          [
            14.71444,
            53.516765,
            38.773644
          ],
          [
            14.714774,
            53.516742,
            38.960169
          ],
          [
            14.715169,
            53.516742,
            39.180961
          ],
          [
            14.715487,
            53.51675,
            39.357449
          ],
          [
            14.715823,
            53.516742,
            39.543979
          ],
          [
            14.716156,
            53.516725,
            39.729355
          ],
          [
            14.716513,
            53.516732,
            39.725567
          ],
          [
            14.716821,
            53.516723,
            39.692526
          ],
          [
            14.717143,
            53.516736,
            39.658059
          ],
          [
            14.717362,
            53.516619,
            39.621928
          ],
          [
            14.717312,
            53.516431,
            39.587698
          ],
          [
            14.717295,
            53.516211,
            39.548102
          ],
          [
            14.717288,
            53.515955,
            39.502117
          ],
          [
            14.717278,
            53.51572,
            39.459894
          ],
          [
            14.717249,
            53.515495,
            39.501592
          ],
          [
            14.717234,
            53.515245,
            39.69086
          ],
          [
            14.717201,
            53.514996,
            39.87992
          ],
          [
            14.717099,
            53.514753,
            40.069928
          ],
          [
            14.716938,
            53.514521,
            40.259829
          ],
          [
            14.716763,
            53.514323,
            40.429303
          ],
          [
            14.716596,
            53.514159,
            40.574988
          ],
          [
            14.716373,
            53.513933,
            40.773281
          ],
          [
            14.716195,
            53.513783,
            40.728026
          ],
          [
            14.71603,
            53.513627,
            40.646604
          ],
          [
            14.715861,
            53.513467,
            40.563101
          ],
          [
            14.71566,
            53.513325,
            40.481121
          ],
          [
            14.715379,
            53.513191,
            40.385867
          ],
          [
            14.715016,
            53.513086,
            40.279838
          ],
          [
            14.714646,
            53.512986,
            40.172918
          ],
          [
            14.714325,
            53.512857,
            40.071143
          ],
          [
            14.714043,
            53.512697,
            40.005017
          ],
          [
            14.713883,
            53.512503,
            40.015096
          ],
          [
            14.713782,
            53.512297,
            40.025092
          ],
          [
            14.713709,
            53.512085,
            40.035172
          ],
          [
            14.713615,
            53.511889,
            40.044666
          ],
          [
            14.71352,
            53.511692,
            40.054211
          ],
          [
            14.713405,
            53.511514,
            40.063092
          ],
          [
            14.713277,
            53.511331,
            40.072324
          ],
          [
            14.713151,
            53.511146,
            40.081621
          ],
          [
            14.713011,
            53.51095,
            40.068148
          ],
          [
            14.712866,
            53.51076,
            40.041335
          ],
          [
            14.712725,
            53.510578,
            40.015585
          ],
          [
            14.712575,
            53.510367,
            39.986147
          ],
          [
            14.712376,
            53.510138,
            39.953008
          ],
          [
            14.712205,
            53.50991,
            39.920894
          ],
          [
            14.712016,
            53.50968,
            39.887993
          ],
          [
            14.71184,
            53.509443,
            39.854686
          ],
          [
            14.711648,
            53.509198,
            39.328515
          ],
          [
            14.711498,
            53.50896,
            38.82633
          ],
          [
            14.711376,
            53.508757,
            38.400797
          ],
          [
            14.711239,
            53.508541,
            37.945013
          ],
          [
            14.711092,
            53.508299,
            37.435694
          ],
          [
            14.710975,
            53.508128,
            37.071215
          ],
          [
            14.710881,
            53.507945,
            36.693656
          ],
          [
            14.710795,
            53.507768,
            36.329822
          ],
          [
            14.710739,
            53.507531,
            36.562382
          ],
          [
            14.710689,
            53.507327,
            36.795316
          ],
          [
            14.71064,
            53.507134,
            37.015881
          ],
          [
            14.710581,
            53.506946,
            37.232086
          ],
          [
            14.710461,
            53.506699,
            37.522514
          ],
          [
            14.710371,
            53.506495,
            37.761016
          ],
          [
            14.710251,
            53.506249,
            38.05061
          ],
          [
            14.710102,
            53.506023,
            38.324894
          ],
          [
            14.710023,
            53.505806,
            38.477296
          ],
          [
            14.709932,
            53.505548,
            38.652531
          ],
          [
            14.709876,
            53.505316,
            38.808314
          ],
          [
            14.709799,
            53.505094,
            38.959564
          ],
          [
            14.709758,
            53.504874,
            39.106771
          ],
          [
            14.709696,
            53.504639,
            39.264827
          ],
          [
            14.709609,
            53.504413,
            39.419017
          ],
          [
            14.709521,
            53.504163,
            39.57774
          ],
          [
            14.70944,
            53.503938,
            39.701293
          ],
          [
            14.709369,
            53.503709,
            39.826083
          ],
          [
            14.709303,
            53.503498,
            39.941102
          ],
          [
            14.70914,
            53.503343,
            40.040535
          ],
          [
            14.709021,
            53.503168,
            40.142578
          ],
          [
            14.708919,
            53.502964,
            40.256793
          ],
          [
            14.70891,
            53.502719,
            40.388232
          ],
          [
            14.708936,
            53.502488,
            40.46045
          ],
          [
            14.709101,
            53.502373,
            40.249116
          ],
          [
            14.709104,
            53.502382,
            40.032137
          ],
          [
            14.709023,
            53.502164,
            39.739356
          ],
          [
            14.709053,
            53.501929,
            39.472526
          ],
          [
            14.709116,
            53.501717,
            39.228759
          ],
          [
            14.709234,
            53.501535,
            39.007919
          ],
          [
            14.70935,
            53.501341,
            38.77423
          ],
          [
            14.709485,
            53.501142,
            38.531113
          ],
          [
            14.709582,
            53.500922,
            38.418047
          ],
          [
            14.70965,
            53.50069,
            38.358769
          ],
          [
            14.709681,
            53.500456,
            38.299736
          ],
          [
            14.709727,
            53.50022,
            38.239959
          ],
          [
            14.7098,
            53.500006,
            38.184966
          ],
          [
            14.709864,
            53.499753,
            38.120495
          ],
          [
            14.709934,
            53.499507,
            38.057751
          ],
          [
            14.709993,
            53.499264,
            38.012442
          ],
          [
            14.710077,
            53.499028,
            38.04165
          ],
          [
            14.710208,
            53.498785,
            38.072548
          ],
          [
            14.710328,
            53.49857,
            38.099928
          ],
          [
            14.710404,
            53.498356,
            38.126363
          ],
          [
            14.710498,
            53.49812,
            38.155675
          ],
          [
            14.710588,
            53.497877,
            38.185749
          ],
          [
            14.710678,
            53.497623,
            38.217128
          ],
          [
            14.710754,
            53.497362,
            38.161574
          ],
          [
            14.710822,
            53.497145,
            38.093569
          ],
          [
            14.710924,
            53.496927,
            38.023856
          ],
          [
            14.710983,
            53.496744,
            37.966458
          ],
          [
            14.71103,
            53.496523,
            37.897416
          ],
          [
            14.71109,
            53.4963,
            37.827644
          ],
          [
            14.711107,
            53.496081,
            37.759815
          ],
          [
            14.711071,
            53.495834,
            37.683444
          ],
          [
            14.711026,
            53.49558,
            37.810896
          ],
          [
            14.71099,
            53.495336,
            37.971903
          ],
          [
            14.710991,
            53.495074,
            38.144303
          ],
          [
            14.710983,
            53.494843,
            38.296344
          ],
          [
            14.710996,
            53.49463,
            38.43644
          ],
          [
            14.710995,
            53.494437,
            38.563342
          ],
          [
            14.710973,
            53.494246,
            38.689214
          ],
          [
            14.710947,
            53.49402,
            38.838105
          ],
          [
            14.710929,
            53.493791,
            38.906559
          ],
          [
            14.710949,
            53.493562,
            38.966134
          ],
          [
            14.71102,
            53.49335,
            39.022319
          ],
          [
            14.711164,
            53.493121,
            39.086133
          ],
          [
            14.711334,
            53.492907,
            39.147843
          ],
          [
            14.711552,
            53.492669,
            39.218265
          ],
          [
            14.711745,
            53.492435,
            39.285984
          ],
          [
            14.711954,
            53.492209,
            39.209272
          ],
          [
            14.712125,
            53.492014,
            39.017661
          ],
          [
            14.712251,
            53.491833,
            38.846792
          ],
          [
            14.712318,
            53.491641,
            38.675967
          ],
          [
            14.712365,
            53.491392,
            38.457572
          ],
          [
            14.712402,
            53.491141,
            38.23813
          ],
          [
            14.712426,
            53.490892,
            38.020834
          ],
          [
            14.712476,
            53.490634,
            37.794503
          ],
          [
            14.712471,
            53.490392,
            38.10572
          ],
          [
            14.712488,
            53.490141,
            38.559859
          ],
          [
            14.712502,
            53.489913,
            38.972647
          ],
          [
            14.712449,
            53.489699,
            39.363695
          ],
          [
            14.712347,
            53.489499,
            39.741497
          ],
          [
            14.712225,
            53.489306,
            40.113998
          ],
          [
            14.712112,
            53.489104,
            40.49864
          ],
          [
            14.711992,
            53.488908,
            40.875451
          ],
          [
            14.711858,
            53.488717,
            41.001807
          ],
          [
            14.711751,
            53.48853,
            41.000938
          ],
          [
            14.711642,
            53.488343,
            41.00007
          ],
          [
            14.711549,
            53.488159,
            40.999226
          ],
          [
            14.711487,
            53.487963,
            40.99835
          ],
          [
            14.71146,
            53.487746,
            40.997395
          ],
          [
            14.711443,
            53.487524,
            40.996419
          ],
          [
            14.711454,
            53.487296,
            40.995416
          ],
          [
            14.711481,
            53.487051,
            40.932007
          ],
          [
            14.711496,
            53.486827,
            40.576695
          ],
          [
            14.711531,
            53.486603,
            40.220168
          ],
          [
            14.711573,
            53.486353,
            39.82142
          ],
          [
            14.711607,
            53.48613,
            39.466522
          ],
          [
            14.711617,
            53.485892,
            39.089233
          ],
          [
            14.71166,
            53.48566,
            38.719338
          ],
          [
            14.711679,
            53.485439,
            38.368403
          ],
          [
            14.711647,
            53.485215,
            38.182762
          ],
          [
            14.711639,
            53.484984,
            38.289983
          ],
          [
            14.711616,
            53.484737,
            38.40482
          ],
          [
            14.711581,
            53.484538,
            38.497672
          ],
          [
            14.711556,
            53.484338,
            38.590816
          ],
          [
            14.711515,
            53.484129,
            38.688479
          ],
          [
            14.711439,
            53.483908,
            38.793162
          ],
          [
            14.711378,
            53.483703,
            38.889774
          ],
          [
            14.711313,
            53.483486,
            38.998617
          ],
          [
            14.711298,
            53.48326,
            39.153733
          ],
          [
            14.711238,
            53.483053,
            39.298073
          ],
          [
            14.711192,
            53.482863,
            39.429766
          ],
          [
            14.711124,
            53.482686,
            39.554344
          ],
          [
            14.711068,
            53.482483,
            39.695457
          ],
          [
            14.710981,
            53.482242,
            39.864762
          ],
          [
            14.710927,
            53.48199,
            40.038977
          ],
          [
            14.710883,
            53.481754,
            40.202098
          ],
          [
            14.710829,
            53.481537,
            39.962096
          ],
          [
            14.710786,
            53.481324,
            39.700259
          ],
          [
            14.710738,
            53.481107,
            39.432935
          ],
          [
            14.710673,
            53.480886,
            39.15898
          ],
          [
            14.710607,
            53.480681,
            38.904263
          ],
          [
            14.710522,
            53.480438,
            38.601241
          ],
          [
            14.71046,
            53.480219,
            38.330149
          ],
          [
            14.710384,
            53.480004,
            38.061822
          ],
          [
            14.710329,
            53.479797,
            38.051503
          ],
          [
            14.710309,
            53.479585,
            38.093995
          ],
          [
            14.710259,
            53.479347,
            38.1411
          ],
          [
            14.710255,
            53.479165,
            38.176874
          ],
          [
            14.710314,
            53.478916,
            38.226313
          ],
          [
            14.710439,
            53.478686,
            38.273782
          ],
          [
            14.71064,
            53.47846,
            38.324043
          ],
          [
            14.710846,
            53.478245,
            38.364578
          ],
          [
            14.711053,
            53.47806,
            38.2412
          ],
          [
            14.711279,
            53.477856,
            38.105587
          ],
          [
            14.711496,
            53.477682,
            37.985333
          ],
          [
            14.711691,
            53.477542,
            37.884257
          ],
          [
            14.711932,
            53.477375,
            37.762108
          ],
          [
            14.712238,
            53.477198,
            37.621191
          ],
          [
            14.712544,
            53.477065,
            37.495996
          ],
          [
            14.712775,
            53.476944,
            37.394214
          ],
          [
            14.713032,
            53.476737,
            37.422843
          ],
          [
            14.713198,
            53.476524,
            37.476521
          ],
          [
            14.713352,
            53.476295,
            37.532895
          ],
          [
            14.713471,
            53.476055,
            37.590074
          ],
          [
            14.713581,
            53.475844,
            37.640662
          ],
          [
            14.713715,
            53.47561,
            37.697151
          ],
          [
            14.713861,
            53.47536,
            37.757628
          ],
          [
            14.714011,
            53.475116,
            37.909156
          ],
          [
            14.714136,
            53.474874,
            38.125942
          ],
          [
            14.714179,
            53.474642,
            38.325989
          ],
          [
            14.71422,
            53.474397,
            38.536958
          ],
          [
            14.714275,
            53.474168,
            38.735037
          ],
          [
            14.714328,
            53.473947,
            38.926375
          ],
          [
            14.714454,
            53.473735,
            39.119753
          ],
          [
            14.714784,
            53.473585,
            39.323047
          ],
          [
            14.715166,
            53.473491,
            39.310038
          ],
          [
            14.715517,
            53.47337,
            39.297237
          ],
          [
            14.715858,
            53.47322,
            39.28387
          ],
          [
            14.716166,
            53.473075,
            39.271514
          ],
          [
            14.716398,
            53.47296,
            39.262003
          ],
          [
            14.71659,
            53.472722,
            39.247989
          ],
          [
            14.716651,
            53.472545,
            39.238438
          ],
          [
            14.716694,
            53.472324,
            39.261387
          ],
          [
            14.716687,
            53.47211,
            39.456824
          ],
          [
            14.716688,
            53.471846,
            39.697493
          ],
          [
            14.71661,
            53.471598,
            39.928013
          ],
          [
            14.716462,
            53.471369,
            40.151688
          ],
          [
            14.716268,
            53.471146,
            40.380642
          ],
          [
            14.716116,
            53.470983,
            40.550932
          ],
          [
            14.715944,
            53.470797,
            40.744667
          ],
          [
            14.715759,
            53.470572,
            40.769312
          ],
          [
            14.715653,
            53.4704,
            40.611463
          ],
          [
            14.715551,
            53.470201,
            40.430553
          ],
          [
            14.715476,
            53.469988,
            40.243075
          ],
          [
            14.715385,
            53.469778,
            40.056371
          ],
          [
            14.715288,
            53.469542,
            39.847042
          ],
          [
            14.715209,
            53.469318,
            39.649933
          ],
          [
            14.715148,
            53.469102,
            39.461382
          ],
          [
            14.715135,
            53.46887,
            39.314818
          ],
          [
            14.715103,
            53.468651,
            39.298302
          ],
          [
            14.715108,
            53.468423,
            39.281154
          ],
          [
            14.715109,
            53.46819,
            39.263646
          ],
          [
            14.715095,
            53.467943,
            39.245076
          ],
          [
            14.715076,
            53.467684,
            39.225587
          ],
          [
            14.715034,
            53.467431,
            39.206479
          ],
          [
            14.714931,
            53.467186,
            39.187473
          ],
          [
            14.714875,
            53.466953,
            39.02943
          ],
          [
            14.714777,
            53.466737,
            38.855348
          ],
          [
            14.714712,
            53.466463,
            38.640354
          ],
          [
            14.714645,
            53.466259,
            38.478861
          ],
          [
            14.714611,
            53.466056,
            38.320386
          ],
          [
            14.714663,
            53.465798,
            38.118478
          ],
          [
            14.714699,
            53.465565,
            37.936726
          ],
          [
            14.71472,
            53.465337,
            37.818144
          ],
          [
            14.714748,
            53.465082,
            38.030997
          ],
          [
            14.71473,
            53.46484,
            38.232761
          ],
          [
            14.714737,
            53.464646,
            38.394385
          ],
          [
            14.714745,
            53.464401,
            38.599181
          ],
          [
            14.714648,
            53.464152,
            38.812086
          ],
          [
            14.714539,
            53.463945,
            38.992882
          ],
          [
            14.714409,
            53.463777,
            39.146954
          ],
          [
            14.71429,
            53.46361,
            39.301082
          ],
          [
            14.714177,
            53.463428,
            39.495358
          ],
          [
            14.714051,
            53.463256,
            39.683192
          ],
          [
            14.713932,
            53.463044,
            39.907359
          ],
          [
            14.71385,
            53.462857,
            40.100788
          ],
          [
            14.713781,
            53.462667,
            40.29538
          ],
          [
            14.713712,
            53.462479,
            40.48798
          ],
          [
            14.713638,
            53.462239,
            40.732196
          ],
          [
            14.713564,
            53.462036,
            40.940283
          ],
          [
            14.713457,
            53.46179,
            41.035025
          ],
          [
            14.713367,
            53.461545,
            40.917947
          ],
          [
            14.713295,
            53.461354,
            40.826472
          ],
          [
            14.713354,
            53.461103,
            40.706338
          ],
          [
            14.713629,
            53.46095,
            40.599529
          ],
          [
            14.713986,
            53.460818,
            40.482717
          ],
          [
            14.714342,
            53.460674,
            40.363092
          ],
          [
            14.714647,
            53.460546,
            40.259324
          ],
          [
            14.714936,
            53.460414,
            39.986504
          ],
          [
            14.715288,
            53.460283,
            39.647036
          ],
          [
            14.715646,
            53.460153,
            39.304086
          ],
          [
            14.715992,
            53.460021,
            38.968059
          ],
          [
            14.716285,
            53.459878,
            38.65798
          ],
          [
            14.716583,
            53.45973,
            38.340543
          ],
          [
            14.716931,
            53.459567,
            37.977918
          ],
          [
            14.717327,
            53.459443,
            37.87735
          ],
          [
            14.717674,
            53.459336,
            38.074505
          ],
          [
            14.717955,
            53.459237,
            38.23915
          ],
          [
            14.71836,
            53.459125,
            38.464415
          ],
          [
            14.718694,
            53.459018,
            38.655617
          ],
          [
            14.719071,
            53.458904,
            38.868888
          ],
          [
            14.719457,
            53.458803,
            39.081427
          ],
          [
            14.719827,
            53.458719,
            39.281044
          ],
          [
            14.720231,
            53.458653,
            39.308172
          ],
          [
            14.720582,
            53.458576,
            39.31717
          ],
          [
            14.720869,
            53.458502,
            39.324692
          ],
          [
            14.721175,
            53.45844,
            39.332469
          ],
          [
            14.721575,
            53.458347,
            39.342801
          ],
          [
            14.721949,
            53.458257,
            39.352504
          ],
          [
            14.72233,
            53.458169,
            39.36235
          ],
          [
            14.722695,
            53.458101,
            39.371551
          ],
          [
            14.722993,
            53.458034,
            39.470207
          ],
          [
            14.72332,
            53.457966,
            39.57803
          ],
          [
            14.723642,
            53.457902,
            39.683798
          ],
          [
            14.723952,
            53.457828,
            39.787734
          ],
          [
            14.724252,
            53.457745,
            39.890894
          ],
          [
            14.724605,
            53.457676,
            40.006764
          ],
          [
            14.725022,
            53.457589,
            40.144286
          ],
          [
            14.72541,
            53.457488,
            40.276157
          ],
          [
            14.725807,
            53.457401,
            40.271069
          ],
          [
            14.726179,
            53.457306,
            40.217855
          ],
          [
            14.726549,
            53.457219,
            40.16552
          ],
          [
            14.726901,
            53.457136,
            40.115728
          ],
          [
            14.727201,
            53.457059,
            40.072766
          ],
          [
            14.727567,
            53.456977,
            40.021168
          ],
          [
            14.727974,
            53.456986,
            39.967631
          ],
          [
            14.728371,
            53.457008,
            39.915155
          ],
          [
            14.728739,
            53.456991,
            39.977448
          ],
          [
            14.729057,
            53.45699,
            40.032193
          ],
          [
            14.72941,
            53.456934,
            40.095169
          ],
          [
            14.729725,
            53.456879,
            40.151673
          ],
          [
            14.730028,
            53.456808,
            40.207852
          ],
          [
            14.730352,
            53.456731,
            40.267889
          ],
          [
            14.730678,
            53.456633,
            40.330847
          ],
          [
            14.73096,
            53.456516,
            40.390114
          ],
          [
            14.731229,
            53.45637,
            40.404532
          ],
          [
            14.731509,
            53.456228,
            40.300992
          ],
          [
            14.731792,
            53.456069,
            40.191094
          ],
          [
            14.732121,
            53.455953,
            40.083423
          ],
          [
            14.732455,
            53.455856,
            39.978751
          ],
          [
            14.732775,
            53.455769,
            39.879627
          ],
          [
            14.733096,
            53.455671,
            39.778054
          ],
          [
            14.733428,
            53.455592,
            39.67738
          ],
          [
            14.733767,
            53.455513,
            39.586567
          ],
          [
            14.734117,
            53.455438,
            39.614741
          ],
          [
            14.734456,
            53.455357,
            39.642388
          ],
          [
            14.734767,
            53.45529,
            39.667429
          ],
          [
            14.735079,
            53.455218,
            39.692755
          ],
          [
            14.735397,
            53.455177,
            39.717383
          ],
          [
            14.735704,
            53.455136,
            39.741206
          ],
          [
            14.73603,
            53.455108,
            39.766293
          ],
          [
            14.736329,
            53.455057,
            39.789921
          ],
          [
            14.736614,
            53.454977,
            39.82016
          ],
          [
            14.736934,
            53.454893,
            40.002857
          ],
          [
            14.73726,
            53.454795,
            40.193366
          ],
          [
            14.737568,
            53.454693,
            40.377197
          ],
          [
            14.737887,
            53.454583,
            40.570155
          ],
          [
            14.738165,
            53.454507,
            40.729914
          ],
          [
            14.738483,
            53.454406,
            40.91789
          ],
          [
            14.73881,
            53.454294,
            41.114675
          ],
          [
            14.739114,
            53.454206,
            41.291062
          ],
          [
            14.739462,
            53.454109,
            41.492674
          ],
          [
            14.739799,
            53.454025,
            41.685397
          ],
          [
            14.740153,
            53.453942,
            41.886355
          ],
          [
            14.740542,
            53.453906,
            42.093666
          ],
          [
            14.74088,
            53.453853,
            42.27774
          ],
          [
            14.741308,
            53.453826,
            42.504433
          ],
          [
            14.741631,
            53.453792,
            42.677168
          ],
          [
            14.741951,
            53.453752,
            42.85106
          ],
          [
            14.742312,
            53.453709,
            43.012728
          ],
          [
            14.742647,
            53.453676,
            43.104582
          ],
          [
            14.742995,
            53.453638,
            43.200314
          ],
          [
            14.743319,
            53.453622,
            43.288235
          ],
          [
            14.743705,
            53.453592,
            43.393504
          ],
          [
            14.744025,
            53.453552,
            43.482067
          ],
          [
            14.744376,
            53.453536,
            43.577265
          ],
          [
            14.744736,
            53.453505,
            43.675631
          ],
          [
            14.745094,
            53.453465,
            43.77422
          ],
          [
            14.745408,
            53.453436,
            43.676729
          ],
          [
            14.745769,
            53.453409,
            43.495385
          ],
          [
            14.745949,
            53.453254,
            43.327337
          ],
          [
            14.745864,
            53.453085,
            43.158638
          ],
          [
            14.745584,
            53.452992,
            42.998845
          ],
          [
            14.745306,
            53.452894,
            42.838226
          ],
          [
            14.74497,
            53.452874,
            42.663028
          ],
          [
            14.744635,
            53.452911,
            42.492689
          ],
          [
            14.744333,
            53.452944,
            42.340046
          ],
          [
            14.743971,
            53.452976,
            42.70042
          ],
          [
            14.74369,
            53.452923,
            43.213497
          ],
          [
            14.743565,
            53.452744,
            43.705609
          ],
          [
            14.743414,
            53.452582,
            44.177734
          ],
          [
            14.743362,
            53.452362,
            44.73286
          ],
          [
            14.743304,
            53.452131,
            45.316368
          ],
          [
            14.743232,
            53.451884,
            45.942788
          ],
          [
            14.743174,
            53.451643,
            46.550968
          ],
          [
            14.743113,
            53.451419,
            46.688546
          ],
          [
            14.743037,
            53.451181,
            46.5084
          ],
          [
            14.742994,
            53.450958,
            46.341318
          ],
          [
            14.742918,
            53.450731,
            46.169257
          ],
          [
            14.742839,
            53.450481,
            45.980157
          ],
          [
            14.742763,
            53.450222,
            45.784418
          ],
          [
            14.742714,
            53.450036,
            45.644397
          ],
          [
            14.74266,
            53.449852,
            45.505504
          ],
          [
            14.742589,
            53.449595,
            45.238094
          ],
          [
            14.742526,
            53.449379,
            44.988042
          ],
          [
            14.742459,
            53.449153,
            44.726226
          ],
          [
            14.742396,
            53.448953,
            44.493685
          ],
          [
            14.742319,
            53.4487,
            44.200378
          ],
          [
            14.742226,
            53.44849,
            43.952207
          ],
          [
            14.742179,
            53.448236,
            43.660751
          ],
          [
            14.742101,
            53.447973,
            43.428445
          ],
          [
            14.742041,
            53.447711,
            43.638221
          ],
          [
            14.741967,
            53.447482,
            43.82365
          ],
          [
            14.741897,
            53.447245,
            44.014539
          ],
          [
            14.741844,
            53.447021,
            44.193981
          ],
          [
            14.741794,
            53.446813,
            44.360664
          ],
          [
            14.74174,
            53.446611,
            44.52294
          ],
          [
            14.741683,
            53.446394,
            44.697169
          ],
          [
            14.741618,
            53.446209,
            44.792958
          ],
          [
            14.741552,
            53.445971,
            44.511248
          ],
          [
            14.74149,
            53.445727,
            44.223065
          ],
          [
            14.741421,
            53.445483,
            43.934013
          ],
          [
            14.741383,
            53.445224,
            43.630401
          ],
          [
            14.741366,
            53.445031,
            43.404652
          ],
          [
            14.741362,
            53.444782,
            43.111448
          ],
          [
            14.741295,
            53.444579,
            42.86985
          ],
          [
            14.741228,
            53.444381,
            42.734016
          ],
          [
            14.741121,
            53.444184,
            42.758206
          ],
          [
            14.741,
            53.44399,
            42.782387
          ],
          [
            14.740849,
            53.443776,
            42.809512
          ],
          [
            14.740698,
            53.443575,
            42.835241
          ],
          [
            14.740544,
            53.443373,
            42.861163
          ],
          [
            14.740399,
            53.443166,
            42.887368
          ],
          [
            14.740246,
            53.442943,
            42.915548
          ],
          [
            14.740093,
            53.44274,
            42.967391
          ],
          [
            14.739947,
            53.442544,
            43.092274
          ],
          [
            14.739797,
            53.442326,
            43.229463
          ],
          [
            14.739655,
            53.442115,
            43.361839
          ],
          [
            14.73956,
            53.441894,
            43.49465
          ],
          [
            14.739478,
            53.441677,
            43.624134
          ],
          [
            14.739391,
            53.441461,
            43.753471
          ],
          [
            14.739299,
            53.44126,
            43.874803
          ],
          [
            14.739187,
            53.441071,
            43.987487
          ],
          [
            14.739082,
            53.440883,
            44.053498
          ],
          [
            14.738993,
            53.440691,
            44.119883
          ],
          [
            14.73891,
            53.440499,
            44.185953
          ],
          [
            14.738833,
            53.440293,
            44.256281
          ],
          [
            14.738743,
            53.440111,
            44.319512
          ],
          [
            14.738613,
            53.439907,
            44.392413
          ],
          [
            14.738381,
            53.439694,
            44.47704
          ],
          [
            14.738151,
            53.439517,
            44.551651
          ],
          [
            14.737921,
            53.439395,
            44.544218
          ],
          [
            14.73764,
            53.439212,
            44.447562
          ],
          [
            14.737378,
            53.439053,
            44.360657
          ],
          [
            14.737087,
            53.438979,
            44.287321
          ],
          [
            14.736795,
            53.438841,
            44.199611
          ],
          [
            14.736499,
            53.438654,
            44.099514
          ],
          [
            14.736215,
            53.438474,
            44.003412
          ],
          [
            14.735957,
            53.438314,
            43.916945
          ],
          [
            14.735667,
            53.438138,
            43.740305
          ],
          [
            14.735413,
            53.437973,
            43.537305
          ],
          [
            14.735148,
            53.437819,
            43.337085
          ],
          [
            14.734879,
            53.437679,
            43.141964
          ],
          [
            14.734661,
            53.437543,
            42.971383
          ],
          [
            14.734403,
            53.437388,
            42.772755
          ],
          [
            14.73416,
            53.43723,
            42.578452
          ],
          [
            14.733947,
            53.437098,
            42.412311
          ],
          [
            14.733653,
            53.436908,
            42.245603
          ],
          [
            14.73337,
            53.436751,
            42.230827
          ],
          [
            14.733105,
            53.436596,
            42.216697
          ],
          [
            14.732878,
            53.436449,
            42.203933
          ],
          [
            14.73264,
            53.436304,
            42.190966
          ],
          [
            14.732384,
            53.436123,
            42.175823
          ],
          [
            14.732107,
            53.435957,
            42.160872
          ],
          [
            14.731864,
            53.435802,
            42.147325
          ],
          [
            14.731602,
            53.435655,
            42.164178
          ],
          [
            14.731303,
            53.435458,
            42.378833
          ],
          [
            14.731059,
            53.435317,
            42.5422
          ],
          [
            14.730797,
            53.435215,
            42.692657
          ],
          [
            14.730728,
            53.435027,
            42.848107
          ],
          [
            14.730992,
            53.435121,
            43.000596
          ],
          [
            14.731168,
            53.435299,
            43.167523
          ],
          [
            14.730894,
            53.435231,
            43.32856
          ],
          [
            14.730721,
            53.435097,
            43.477668
          ],
          [
            14.73049,
            53.434957,
            43.587264
          ],
          [
            14.730256,
            53.434814,
            43.589118
          ],
          [
            14.729971,
            53.434665,
            43.591215
          ],
          [
            14.729795,
            53.434505,
            43.592991
          ],
          [
            14.729594,
            53.434366,
            43.594706
          ],
          [
            14.729338,
            53.434224,
            43.59664
          ],
          [
            14.729089,
            53.434045,
            43.598803
          ],
          [
            14.728886,
            53.433871,
            43.60077
          ],
          [
            14.728745,
            53.433679,
            43.602717
          ],
          [
            14.728616,
            53.433466,
            43.557498
          ],
          [
            14.728488,
            53.433243,
            43.488359
          ],
          [
            14.72838,
            53.433045,
            43.427285
          ],
          [
            14.728266,
            53.432854,
            43.367761
          ],
          [
            14.728181,
            53.432662,
            43.309499
          ],
          [
            14.728049,
            53.432455,
            43.244549
          ],
          [
            14.727905,
            53.432222,
            43.171631
          ],
          [
            14.727754,
            53.432006,
            43.10282
          ],
          [
            14.727617,
            53.431798,
            43.141805
          ],
          [
            14.727456,
            53.431563,
            43.269177
          ],
          [
            14.727299,
            53.431353,
            43.384517
          ],
          [
            14.727139,
            53.43116,
            43.492547
          ],
          [
            14.726992,
            53.430993,
            43.587148
          ],
          [
            14.726767,
            53.430809,
            43.701449
          ],
          [
            14.726478,
            53.430657,
            43.816687
          ],
          [
            14.726166,
            53.430502,
            43.938212
          ],
          [
            14.725896,
            53.430388,
            43.850164
          ],
          [
            14.725639,
            53.430256,
            43.631009
          ],
          [
            14.725387,
            53.430139,
            43.424521
          ],
          [
            14.725106,
            53.430015,
            43.197978
          ],
          [
            14.72486,
            53.429876,
            42.979017
          ],
          [
            14.724575,
            53.429739,
            42.74237
          ],
          [
            14.724295,
            53.429593,
            42.502032
          ],
          [
            14.724001,
            53.429453,
            42.258977
          ],
          [
            14.723694,
            53.429322,
            42.024113
          ],
          [
            14.723394,
            53.429186,
            41.93987
          ],
          [
            14.723098,
            53.429034,
            41.852493
          ],
          [
            14.72278,
            53.428883,
            41.761647
          ],
          [
            14.722459,
            53.428741,
            41.67233
          ],
          [
            14.722124,
            53.428587,
            41.577527
          ],
          [
            14.721789,
            53.428429,
            41.482053
          ],
          [
            14.721467,
            53.428266,
            41.387639
          ],
          [
            14.721158,
            53.428149,
            41.262191
          ],
          [
            14.720888,
            53.428016,
            41.113712
          ],
          [
            14.720586,
            53.427892,
            40.957482
          ],
          [
            14.720297,
            53.427768,
            40.806456
          ],
          [
            14.719966,
            53.427662,
            40.646931
          ],
          [
            14.719628,
            53.427562,
            40.486923
          ],
          [
            14.719259,
            53.427482,
            40.320211
          ],
          [
            14.718907,
            53.427417,
            40.1639
          ],
          [
            14.718575,
            53.427367,
            40.237733
          ],
          [
            14.718264,
            53.427308,
            40.636929
          ],
          [
            14.717947,
            53.427241,
            41.04827
          ],
          [
            14.717627,
            53.427137,
            41.494045
          ],
          [
            14.717295,
            53.427013,
            41.973708
          ],
          [
            14.71702,
            53.426868,
            42.422803
          ],
          [
            14.71675,
            53.426726,
            42.863237
          ],
          [
            14.71648,
            53.426572,
            43.320374
          ],
          [
            14.716198,
            53.426418,
            43.77021
          ],
          [
            14.715915,
            53.426284,
            43.838404
          ],
          [
            14.715675,
            53.426152,
            43.900044
          ],
          [
            14.715431,
            53.426006,
            43.965305
          ],
          [
            14.715174,
            53.425886,
            44.026879
          ],
          [
            14.714876,
            53.425721,
            44.103595
          ],
          [
            14.71462,
            53.42559,
            44.167209
          ],
          [
            14.714381,
            53.425452,
            44.229927
          ],
          [
            14.714141,
            53.425295,
            44.297271
          ],
          [
            14.713969,
            53.425099,
            44.168223
          ],
          [
            14.713845,
            53.424878,
            43.780373
          ],
          [
            14.713767,
            53.424645,
            43.383911
          ],
          [
            14.71367,
            53.424422,
            43.001135
          ],
          [
            14.713574,
            53.424201,
            42.621742
          ],
          [
            14.713474,
            53.423985,
            42.249407
          ],
          [
            14.713386,
            53.423796,
            41.923386
          ],
          [
            14.713318,
            53.423584,
            41.564641
          ],
          [
            14.713246,
            53.423381,
            41.388211
          ],
          [
            14.713159,
            53.423159,
            41.511568
          ],
          [
            14.713091,
            53.422934,
            41.63527
          ],
          [
            14.713011,
            53.422727,
            41.750246
          ],
          [
            14.712931,
            53.422511,
            41.870293
          ],
          [
            14.7128,
            53.422317,
            41.983595
          ],
          [
            14.712629,
            53.422138,
            42.095032
          ],
          [
            14.712404,
            53.421972,
            42.210619
          ],
          [
            14.712181,
            53.421822,
            42.319053
          ],
          [
            14.711946,
            53.421642,
            41.941909
          ],
          [
            14.711731,
            53.421484,
            41.601994
          ],
          [
            14.711556,
            53.421328,
            41.288687
          ],
          [
            14.711248,
            53.421137,
            40.843166
          ],
          [
            14.711068,
            53.420985,
            40.532565
          ],
          [
            14.710809,
            53.420779,
            40.102561
          ],
          [
            14.71057,
            53.42061,
            39.73353
          ],
          [
            14.710343,
            53.420435,
            39.363804
          ],
          [
            14.710096,
            53.420257,
            39.910748
          ],
          [
            14.70983,
            53.42008,
            40.606719
          ],
          [
            14.709605,
            53.419945,
            41.16343
          ],
          [
            14.709336,
            53.419788,
            41.820695
          ],
          [
            14.709082,
            53.419638,
            42.445543
          ],
          [
            14.708843,
            53.419515,
            42.995992
          ],
          [
            14.708521,
            53.419343,
            43.75019
          ],
          [
            14.708284,
            53.419222,
            44.294166
          ],
          [
            14.707938,
            53.419056,
            44.824711
          ],
          [
            14.70761,
            53.418884,
            45.208152
          ],
          [
            14.707324,
            53.418742,
            45.534787
          ],
          [
            14.707024,
            53.418587,
            45.883802
          ],
          [
            14.706729,
            53.418435,
            46.22598
          ],
          [
            14.706427,
            53.41829,
            46.56629
          ],
          [
            14.706145,
            53.418151,
            46.887571
          ],
          [
            14.705854,
            53.418002,
            47.224224
          ],
          [
            14.705573,
            53.417855,
            46.89722
          ],
          [
            14.705286,
            53.417708,
            46.563218
          ],
          [
            14.704968,
            53.417569,
            46.215163
          ],
          [
            14.704643,
            53.417407,
            45.841188
          ],
          [
            14.704402,
            53.417294,
            45.569558
          ],
          [
            14.704102,
            53.417151,
            45.230511
          ],
          [
            14.703915,
            53.416993,
            44.94225
          ],
          [
            14.703734,
            53.416821,
            44.641543
          ],
          [
            14.703578,
            53.416634,
            44.433628
          ],
          [
            14.703439,
            53.416446,
            44.263114
          ],
          [
            14.703337,
            53.41624,
            44.085097
          ],
          [
            14.70328,
            53.416023,
            43.903551
          ],
          [
            14.703176,
            53.415841,
            43.744717
          ],
          [
            14.703012,
            53.41565,
            43.567462
          ],
          [
            14.70287,
            53.415448,
            43.386542
          ],
          [
            14.702735,
            53.41526,
            43.217472
          ],
          [
            14.702599,
            53.415068,
            43.078614
          ],
          [
            14.702462,
            53.414875,
            43.091012
          ],
          [
            14.70231,
            53.41466,
            43.104866
          ],
          [
            14.70216,
            53.414449,
            43.118425
          ],
          [
            14.702031,
            53.414238,
            43.131709
          ],
          [
            14.70189,
            53.414035,
            43.144717
          ],
          [
            14.701758,
            53.413834,
            43.157486
          ],
          [
            14.701631,
            53.413628,
            43.170469
          ],
          [
            14.701515,
            53.41342,
            43.177533
          ],
          [
            14.7014,
            53.413218,
            43.076455
          ],
          [
            14.701272,
            53.41302,
            42.975973
          ],
          [
            14.701137,
            53.41283,
            42.878264
          ],
          [
            14.701024,
            53.412646,
            42.785462
          ],
          [
            14.700897,
            53.412449,
            42.685441
          ],
          [
            14.70078,
            53.412256,
            42.588263
          ],
          [
            14.700626,
            53.412088,
            42.497289
          ],
          [
            14.700511,
            53.411904,
            42.404295
          ],
          [
            14.700383,
            53.411726,
            42.357254
          ],
          [
            14.700249,
            53.411518,
            42.506974
          ],
          [
            14.700135,
            53.411307,
            42.655914
          ],
          [
            14.699975,
            53.411103,
            42.80738
          ],
          [
            14.699816,
            53.410896,
            42.960398
          ],
          [
            14.699626,
            53.410714,
            43.104429
          ],
          [
            14.699421,
            53.410552,
            43.240759
          ],
          [
            14.699208,
            53.410396,
            43.375897
          ],
          [
            14.698994,
            53.410251,
            43.50564
          ],
          [
            14.698723,
            53.410045,
            43.323052
          ],
          [
            14.698464,
            53.409855,
            43.072738
          ],
          [
            14.698154,
            53.409763,
            42.854493
          ],
          [
            14.697761,
            53.409757,
            42.612768
          ],
          [
            14.697516,
            53.409637,
            42.418876
          ],
          [
            14.697386,
            53.409467,
            42.225987
          ],
          [
            14.697371,
            53.409278,
            42.031419
          ],
          [
            14.69755,
            53.409083,
            41.80209
          ],
          [
            14.69786,
            53.408946,
            41.625052
          ],
          [
            14.697973,
            53.40869,
            41.470169
          ],
          [
            14.698018,
            53.4085,
            41.359249
          ],
          [
            14.698049,
            53.408307,
            41.247251
          ],
          [
            14.698073,
            53.408077,
            41.113873
          ],
          [
            14.69801,
            53.407824,
            40.966021
          ],
          [
            14.697872,
            53.407594,
            40.824724
          ],
          [
            14.697685,
            53.407373,
            40.681747
          ],
          [
            14.697457,
            53.407166,
            40.308659
          ],
          [
            14.697229,
            53.407168,
            39.968086
          ],
          [
            14.697049,
            53.407355,
            39.610031
          ],
          [
            14.696675,
            53.407411,
            39.173147
          ],
          [
            14.696362,
            53.407318,
            38.826776
          ],
          [
            14.696038,
            53.407236,
            38.47892
          ],
          [
            14.695766,
            53.407151,
            38.175414
          ],
          [
            14.695458,
            53.407071,
            37.84296
          ],
          [
            14.695177,
            53.406955,
            37.931692
          ],
          [
            14.694872,
            53.406928,
            38.369768
          ],
          [
            14.694561,
            53.406883,
            38.824634
          ],
          [
            14.69422,
            53.406809,
            39.341115
          ],
          [
            14.6939,
            53.406722,
            39.840799
          ],
          [
            14.693544,
            53.406636,
            40.386531
          ],
          [
            14.693197,
            53.406554,
            40.916898
          ],
          [
            14.692826,
            53.406469,
            41.482167
          ],
          [
            14.692462,
            53.406406,
            41.963506
          ],
          [
            14.692098,
            53.406344,
            41.932761
          ],
          [
            14.691723,
            53.406254,
            41.899923
          ],
          [
            14.691412,
            53.406144,
            41.870527
          ],
          [
            14.691144,
            53.406021,
            41.842964
          ],
          [
            14.690912,
            53.406175,
            41.812948
          ],
          [
            14.690756,
            53.406365,
            41.784121
          ],
          [
            14.690425,
            53.406441,
            41.753462
          ],
          [
            14.690035,
            53.406364,
            41.713781
          ],
          [
            14.689664,
            53.406287,
            41.553705
          ],
          [
            14.689326,
            53.40623,
            41.410514
          ],
          [
            14.688971,
            53.406156,
            41.256991
          ],
          [
            14.688685,
            53.406093,
            41.131886
          ],
          [
            14.688339,
            53.406026,
            40.983662
          ],
          [
            14.687981,
            53.40593,
            40.823676
          ],
          [
            14.687605,
            53.405837,
            40.657793
          ],
          [
            14.687218,
            53.405733,
            40.503268
          ],
          [
            14.686834,
            53.405635,
            40.74859
          ],
          [
            14.686456,
            53.405509,
            41.003131
          ],
          [
            14.686115,
            53.405373,
            41.243932
          ],
          [
            14.685788,
            53.40526,
            41.465623
          ],
          [
            14.685424,
            53.405149,
            41.70547
          ],
          [
            14.685095,
            53.405041,
            41.925829
          ],
          [
            14.684762,
            53.404938,
            42.145862
          ],
          [
            14.684486,
            53.404849,
            42.240123
          ],
          [
            14.684227,
            53.404744,
            42.181236
          ],
          [
            14.683914,
            53.40462,
            42.110586
          ],
          [
            14.683584,
            53.404513,
            42.039871
          ],
          [
            14.683276,
            53.404417,
            41.974541
          ],
          [
            14.682973,
            53.404319,
            41.90966
          ],
          [
            14.682599,
            53.40431,
            41.838582
          ],
          [
            14.682221,
            53.404197,
            41.759027
          ],
          [
            14.681893,
            53.404077,
            41.736531
          ],
          [
            14.681544,
            53.403944,
            42.137135
          ],
          [
            14.681261,
            53.403875,
            42.429579
          ],
          [
            14.680974,
            53.403798,
            42.730756
          ],
          [
            14.680616,
            53.403716,
            43.098076
          ],
          [
            14.68025,
            53.403623,
            43.478734
          ],
          [
            14.679965,
            53.403545,
            43.778788
          ],
          [
            14.679673,
            53.403476,
            44.08262
          ],
          [
            14.679357,
            53.40339,
            44.414792
          ],
          [
            14.679022,
            53.403312,
            44.551856
          ],
          [
            14.678715,
            53.403239,
            44.502599
          ],
          [
            14.678331,
            53.403147,
            44.441092
          ],
          [
            14.677974,
            53.403068,
            44.384409
          ],
          [
            14.677636,
            53.402987,
            44.330281
          ],
          [
            14.677254,
            53.40289,
            44.268563
          ],
          [
            14.676857,
            53.402819,
            44.206911
          ],
          [
            14.676495,
            53.402706,
            44.146198
          ],
          [
            14.676129,
            53.402591,
            44.096758
          ],
          [
            14.675758,
            53.402483,
            44.051224
          ],
          [
            14.675439,
            53.402354,
            44.008652
          ],
          [
            14.675092,
            53.40222,
            43.963055
          ],
          [
            14.674721,
            53.402092,
            43.915778
          ],
          [
            14.674401,
            53.401964,
            43.873046
          ],
          [
            14.674118,
            53.401837,
            43.833967
          ],
          [
            14.673866,
            53.401707,
            43.790938
          ],
          [
            14.673601,
            53.401575,
            43.61438
          ],
          [
            14.673358,
            53.401437,
            43.443051
          ],
          [
            14.67306,
            53.401236,
            43.213692
          ],
          [
            14.672773,
            53.401053,
            42.999692
          ],
          [
            14.672501,
            53.40087,
            42.790929
          ],
          [
            14.672262,
            53.400707,
            42.605809
          ],
          [
            14.672032,
            53.400532,
            42.415998
          ],
          [
            14.671816,
            53.400356,
            42.23505
          ],
          [
            14.671584,
            53.400178,
            42.072782
          ],
          [
            14.671372,
            53.399985,
            41.906638
          ],
          [
            14.671177,
            53.399768,
            41.729476
          ],
          [
            14.670958,
            53.399605,
            41.577243
          ],
          [
            14.670621,
            53.399624,
            41.431953
          ],
          [
            14.670386,
            53.399755,
            41.248828
          ],
          [
            14.67023,
            53.399953,
            41.091243
          ],
          [
            14.670052,
            53.400138,
            40.94699
          ],
          [
            14.669858,
            53.400328,
            40.834436
          ],
          [
            14.669669,
            53.400522,
            40.720899
          ],
          [
            14.669466,
            53.400696,
            40.613643
          ],
          [
            14.669273,
            53.400881,
            40.502919
          ],
          [
            14.668941,
            53.400931,
            40.395763
          ],
          [
            14.668628,
            53.400849,
            40.292173
          ],
          [
            14.668304,
            53.40075,
            40.182219
          ],
          [
            14.667961,
            53.400719,
            40.07432
          ],
          [
            14.667583,
            53.400793,
            40.049407
          ],
          [
            14.667299,
            53.400891,
            40.040457
          ],
          [
            14.667028,
            53.401,
            40.031534
          ],
          [
            14.666715,
            53.401107,
            40.021693
          ],
          [
            14.666425,
            53.401183,
            40.012468
          ],
          [
            14.666136,
            53.401301,
            40.002914
          ],
          [
            14.665865,
            53.401411,
            39.99397
          ],
          [
            14.665597,
            53.401533,
            39.984756
          ],
          [
            14.665293,
            53.40167,
            39.884142
          ],
          [
            14.664974,
            53.401792,
            39.453419
          ],
          [
            14.664697,
            53.401916,
            39.059539
          ],
          [
            14.6644,
            53.402048,
            38.636643
          ],
          [
            14.664446,
            53.402202,
            38.247913
          ],
          [
            14.664739,
            53.402294,
            37.870713
          ],
          [
            14.664876,
            53.402478,
            37.485291
          ],
          [
            14.664685,
            53.402636,
            37.078381
          ],
          [
            14.66439,
            53.402736,
            36.69291
          ],
          [
            14.664089,
            53.402877,
            36.641666
          ],
          [
            14.663855,
            53.403011,
            36.760637
          ],
          [
            14.663785,
            53.403211,
            36.883172
          ],
          [
            14.663725,
            53.403407,
            37.002613
          ],
          [
            14.663574,
            53.403358,
            37.113043
          ],
          [
            14.663564,
            53.403363,
            37.227459
          ],
          [
            14.663753,
            53.403215,
            37.3615
          ],
          [
            14.663836,
            53.403024,
            37.479803
          ],
          [
            14.664021,
            53.402862,
            37.602413
          ],
          [
            14.664292,
            53.402756,
            37.658231
          ],
          [
            14.664607,
            53.402629,
            37.703745
          ],
          [
            14.664852,
            53.402509,
            37.741767
          ],
          [
            14.664754,
            53.402316,
            37.783287
          ],
          [
            14.664559,
            53.402144,
            37.825121
          ],
          [
            14.664705,
            53.401969,
            37.865654
          ],
          [
            14.664952,
            53.40185,
            37.903661
          ],
          [
            14.665219,
            53.40174,
            37.942511
          ],
          [
            14.665529,
            53.401606,
            37.98834
          ],
          [
            14.665835,
            53.401481,
            38.009311
          ],
          [
            14.666202,
            53.401336,
            38.033805
          ],
          [
            14.666474,
            53.401196,
            38.053888
          ],
          [
            14.666806,
            53.401081,
            38.075289
          ],
          [
            14.667127,
            53.40094,
            38.09747
          ],
          [
            14.667452,
            53.400817,
            38.118885
          ],
          [
            14.667771,
            53.400699,
            38.139786
          ],
          [
            14.66784,
            53.400484,
            38.117323
          ],
          [
            14.667756,
            53.400241,
            37.924779
          ],
          [
            14.667624,
            53.400034,
            37.752869
          ],
          [
            14.66749,
            53.399802,
            37.562421
          ],
          [
            14.667371,
            53.399576,
            37.378586
          ],
          [
            14.667263,
            53.399348,
            37.194711
          ],
          [
            14.667205,
            53.399103,
            37.002625
          ],
          [
            14.667145,
            53.398867,
            36.817369
          ],
          [
            14.667074,
            53.398646,
            37.104511
          ],
          [
            14.667005,
            53.398437,
            37.585382
          ],
          [
            14.667101,
            53.39825,
            38.051505
          ],
          [
            14.66746,
            53.398221,
            38.541733
          ],
          [
            14.667823,
            53.398198,
            39.033352
          ],
          [
            14.668144,
            53.398215,
            39.501041
          ],
          [
            14.6681,
            53.398398,
            39.96384
          ],
          [
            14.667652,
            53.398475,
            40.59083
          ],
          [
            14.667783,
            53.398395,
            40.500238
          ],
          [
            14.667548,
            53.398319,
            39.666395
          ],
          [
            14.667754,
            53.398359,
            39.035001
          ],
          [
            14.667758,
            53.398325,
            37.929472
          ],
          [
            14.667788,
            53.398441,
            36.9726
          ],
          [
            14.66761,
            53.398427,
            35.312084
          ],
          [
            14.667801,
            53.398552,
            35.090113
          ],
          [
            14.667715,
            53.398505,
            35.090113
          ],
          [
            14.667455,
            53.398162,
            35.090113
          ],
          [
            14.667703,
            53.398305,
            35.090113
          ],
          [
            14.667647,
            53.398484,
            35.090113
          ]
        ]
      }
    }
  ]
}

let day36: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.663694,
            53.403303,
            36.541729
          ],
          [
            14.663804,
            53.40312,
            36.541729
          ],
          [
            14.663902,
            53.402915,
            36.541729
          ],
          [
            14.664163,
            53.402812,
            36.541729
          ],
          [
            14.664447,
            53.402698,
            36.541729
          ],
          [
            14.664749,
            53.402566,
            36.792656
          ],
          [
            14.664715,
            53.402371,
            37.205063
          ],
          [
            14.664563,
            53.40219,
            37.617286
          ],
          [
            14.664581,
            53.402016,
            38.025309
          ],
          [
            14.664854,
            53.401872,
            38.465764
          ],
          [
            14.665168,
            53.40176,
            38.907907
          ],
          [
            14.665482,
            53.40165,
            39.347916
          ],
          [
            14.665801,
            53.401506,
            39.831791
          ],
          [
            14.666073,
            53.401396,
            40.193137
          ],
          [
            14.666391,
            53.401259,
            40.269937
          ],
          [
            14.666452,
            53.401044,
            40.344331
          ],
          [
            14.666188,
            53.400852,
            40.42591
          ],
          [
            14.665907,
            53.40071,
            40.497822
          ],
          [
            14.665592,
            53.400522,
            40.585331
          ],
          [
            14.665344,
            53.400361,
            40.657048
          ],
          [
            14.665121,
            53.400223,
            40.7198
          ],
          [
            14.664881,
            53.40005,
            40.754779
          ],
          [
            14.6648,
            53.39985,
            40.681155
          ],
          [
            14.664655,
            53.399654,
            40.604714
          ],
          [
            14.664458,
            53.39943,
            40.514515
          ],
          [
            14.664267,
            53.399215,
            40.42775
          ],
          [
            14.664082,
            53.399013,
            40.345622
          ],
          [
            14.66395,
            53.398851,
            40.281122
          ],
          [
            14.663758,
            53.398632,
            40.192957
          ],
          [
            14.663525,
            53.398432,
            40.012857
          ],
          [
            14.66316,
            53.398359,
            39.658021
          ],
          [
            14.662839,
            53.398272,
            39.331793
          ],
          [
            14.662562,
            53.398413,
            38.994962
          ],
          [
            14.662235,
            53.39842,
            38.678232
          ],
          [
            14.661909,
            53.398312,
            38.334421
          ],
          [
            14.66165,
            53.398202,
            38.041336
          ],
          [
            14.661364,
            53.398076,
            37.713276
          ],
          [
            14.661062,
            53.39794,
            37.364459
          ],
          [
            14.660736,
            53.397808,
            37.41032
          ],
          [
            14.660409,
            53.397646,
            37.473748
          ],
          [
            14.660087,
            53.397531,
            37.529737
          ],
          [
            14.659816,
            53.397428,
            37.577778
          ],
          [
            14.659564,
            53.397309,
            37.626016
          ],
          [
            14.659264,
            53.39714,
            37.687887
          ],
          [
            14.658952,
            53.396989,
            37.74784
          ],
          [
            14.658636,
            53.39683,
            37.796601
          ],
          [
            14.658294,
            53.39668,
            37.732697
          ],
          [
            14.657977,
            53.396514,
            37.669169
          ],
          [
            14.657665,
            53.396338,
            37.604542
          ],
          [
            14.657378,
            53.3962,
            37.549064
          ],
          [
            14.657062,
            53.396028,
            37.484667
          ],
          [
            14.656758,
            53.395872,
            37.424094
          ],
          [
            14.65646,
            53.395723,
            37.365535
          ],
          [
            14.656159,
            53.395577,
            37.564414
          ],
          [
            14.655836,
            53.395428,
            37.87894
          ],
          [
            14.655485,
            53.395312,
            38.188186
          ],
          [
            14.655146,
            53.395212,
            38.479496
          ],
          [
            14.654781,
            53.395109,
            38.790572
          ],
          [
            14.654429,
            53.395046,
            39.073812
          ],
          [
            14.654081,
            53.394976,
            39.356789
          ],
          [
            14.653681,
            53.394926,
            39.671806
          ],
          [
            14.653249,
            53.394875,
            40.182328
          ],
          [
            14.652846,
            53.394846,
            40.653618
          ],
          [
            14.65242,
            53.394807,
            41.153609
          ],
          [
            14.652002,
            53.394782,
            41.640916
          ],
          [
            14.651639,
            53.394738,
            42.070585
          ],
          [
            14.651277,
            53.394723,
            42.492096
          ],
          [
            14.65085,
            53.394691,
            42.991314
          ],
          [
            14.650437,
            53.394673,
            43.037768
          ],
          [
            14.650102,
            53.394682,
            42.865219
          ],
          [
            14.649745,
            53.394672,
            42.681168
          ],
          [
            14.64938,
            53.394664,
            42.493145
          ],
          [
            14.648969,
            53.394666,
            42.281222
          ],
          [
            14.648602,
            53.394665,
            42.092235
          ],
          [
            14.648164,
            53.394661,
            41.866686
          ],
          [
            14.647763,
            53.394671,
            41.660112
          ],
          [
            14.647395,
            53.394654,
            41.686567
          ],
          [
            14.647032,
            53.394669,
            41.771389
          ],
          [
            14.646713,
            53.394657,
            41.845951
          ],
          [
            14.646396,
            53.394645,
            41.920104
          ],
          [
            14.646087,
            53.394643,
            41.992277
          ],
          [
            14.645683,
            53.39466,
            42.086584
          ],
          [
            14.64533,
            53.394676,
            42.169948
          ],
          [
            14.644936,
            53.394729,
            42.264304
          ],
          [
            14.644512,
            53.394735,
            42.122263
          ],
          [
            14.644149,
            53.394709,
            41.720428
          ],
          [
            14.643721,
            53.394713,
            41.253809
          ],
          [
            14.643318,
            53.394723,
            40.814233
          ],
          [
            14.64294,
            53.394723,
            40.40228
          ],
          [
            14.642567,
            53.394748,
            39.993219
          ],
          [
            14.642167,
            53.394768,
            39.555772
          ],
          [
            14.641739,
            53.394809,
            39.083267
          ],
          [
            14.641351,
            53.394801,
            39.21914
          ],
          [
            14.641008,
            53.394845,
            39.408846
          ],
          [
            14.640592,
            53.394827,
            39.635439
          ],
          [
            14.640184,
            53.394837,
            39.85606
          ],
          [
            14.639832,
            53.394871,
            40.049431
          ],
          [
            14.639423,
            53.394903,
            40.272368
          ],
          [
            14.638998,
            53.394914,
            40.502216
          ],
          [
            14.638639,
            53.394915,
            40.647268
          ],
          [
            14.638264,
            53.39493,
            40.546782
          ],
          [
            14.637913,
            53.39497,
            40.451227
          ],
          [
            14.637563,
            53.395007,
            40.356118
          ],
          [
            14.637146,
            53.395011,
            40.244527
          ],
          [
            14.636714,
            53.39501,
            40.128395
          ],
          [
            14.636359,
            53.39504,
            40.032516
          ],
          [
            14.635952,
            53.395072,
            39.922753
          ],
          [
            14.635525,
            53.395066,
            39.782195
          ],
          [
            14.635225,
            53.395093,
            39.656933
          ],
          [
            14.634872,
            53.395118,
            39.509694
          ],
          [
            14.634429,
            53.395123,
            39.326726
          ],
          [
            14.634025,
            53.395145,
            39.157741
          ],
          [
            14.633615,
            53.395178,
            38.987226
          ],
          [
            14.633203,
            53.395192,
            38.817102
          ],
          [
            14.632859,
            53.395256,
            38.668257
          ],
          [
            14.632537,
            53.395318,
            38.54183
          ],
          [
            14.632176,
            53.395298,
            38.415762
          ],
          [
            14.631802,
            53.395313,
            38.285669
          ],
          [
            14.631421,
            53.395365,
            38.150963
          ],
          [
            14.631047,
            53.395423,
            38.017354
          ],
          [
            14.630668,
            53.395488,
            37.88107
          ],
          [
            14.63031,
            53.395545,
            37.753265
          ],
          [
            14.629953,
            53.395601,
            37.626039
          ],
          [
            14.629573,
            53.395663,
            37.702424
          ],
          [
            14.629198,
            53.395719,
            37.905202
          ],
          [
            14.628793,
            53.395769,
            38.122121
          ],
          [
            14.628418,
            53.395838,
            38.328022
          ],
          [
            14.628018,
            53.395903,
            38.545501
          ],
          [
            14.627632,
            53.395978,
            38.758412
          ],
          [
            14.62725,
            53.396048,
            38.968347
          ],
          [
            14.626886,
            53.396124,
            39.153208
          ],
          [
            14.626501,
            53.396196,
            39.108666
          ],
          [
            14.626096,
            53.39626,
            39.062417
          ],
          [
            14.625703,
            53.396322,
            39.017558
          ],
          [
            14.625323,
            53.396403,
            38.973024
          ],
          [
            14.624952,
            53.396468,
            38.930245
          ],
          [
            14.624559,
            53.396522,
            38.885705
          ],
          [
            14.624142,
            53.396595,
            38.837749
          ],
          [
            14.623739,
            53.396656,
            39.192154
          ],
          [
            14.623368,
            53.396716,
            39.688311
          ],
          [
            14.622996,
            53.396767,
            40.180843
          ],
          [
            14.622642,
            53.396821,
            40.65268
          ],
          [
            14.622221,
            53.396885,
            41.213466
          ],
          [
            14.621834,
            53.396937,
            41.725663
          ],
          [
            14.621449,
            53.396985,
            42.233994
          ],
          [
            14.621072,
            53.397038,
            42.71115
          ],
          [
            14.620715,
            53.397097,
            42.601216
          ],
          [
            14.620357,
            53.397161,
            42.490251
          ],
          [
            14.619947,
            53.397214,
            42.365737
          ],
          [
            14.61956,
            53.397272,
            42.247247
          ],
          [
            14.61918,
            53.397329,
            42.130957
          ],
          [
            14.618801,
            53.397396,
            42.013532
          ],
          [
            14.618472,
            53.397457,
            41.911151
          ],
          [
            14.618158,
            53.397506,
            41.834372
          ],
          [
            14.617831,
            53.397525,
            42.06214
          ],
          [
            14.617475,
            53.397601,
            42.324928
          ],
          [
            14.617124,
            53.397646,
            42.574866
          ],
          [
            14.616776,
            53.397704,
            42.825351
          ],
          [
            14.616467,
            53.397791,
            43.06263
          ],
          [
            14.616184,
            53.397908,
            43.302212
          ],
          [
            14.615877,
            53.397998,
            43.539685
          ],
          [
            14.615547,
            53.398061,
            43.780823
          ],
          [
            14.615208,
            53.398079,
            44.153747
          ],
          [
            14.614894,
            53.39809,
            44.649624
          ],
          [
            14.61457,
            53.398112,
            45.162234
          ],
          [
            14.614265,
            53.398133,
            45.646363
          ],
          [
            14.613922,
            53.39815,
            46.187723
          ],
          [
            14.613582,
            53.398186,
            46.730948
          ],
          [
            14.613242,
            53.398203,
            47.267599
          ],
          [
            14.612882,
            53.398201,
            47.833692
          ],
          [
            14.612562,
            53.398213,
            48.337937
          ],
          [
            14.612212,
            53.398223,
            48.445982
          ],
          [
            14.611814,
            53.398273,
            47.887134
          ],
          [
            14.611392,
            53.39831,
            47.301099
          ],
          [
            14.611026,
            53.398325,
            46.796485
          ],
          [
            14.610655,
            53.398289,
            46.28007
          ],
          [
            14.610239,
            53.398201,
            45.673586
          ],
          [
            14.609882,
            53.398133,
            45.148939
          ],
          [
            14.609614,
            53.398021,
            44.697773
          ],
          [
            14.609347,
            53.397912,
            44.333383
          ],
          [
            14.609099,
            53.397782,
            44.022547
          ],
          [
            14.608843,
            53.397653,
            43.703692
          ],
          [
            14.608552,
            53.397499,
            43.337359
          ],
          [
            14.608232,
            53.397408,
            42.993248
          ],
          [
            14.607942,
            53.397297,
            42.66072
          ],
          [
            14.60774,
            53.397134,
            42.333667
          ],
          [
            14.607538,
            53.397,
            42.045011
          ],
          [
            14.607288,
            53.396876,
            41.737637
          ],
          [
            14.607004,
            53.396765,
            42.284246
          ],
          [
            14.606737,
            53.396671,
            43.009248
          ],
          [
            14.60641,
            53.396612,
            43.799081
          ],
          [
            14.606077,
            53.396549,
            44.607248
          ],
          [
            14.605732,
            53.39647,
            45.46669
          ],
          [
            14.60541,
            53.396471,
            46.212668
          ],
          [
            14.605065,
            53.396475,
            47.011117
          ],
          [
            14.604703,
            53.396525,
            47.870987
          ],
          [
            14.604362,
            53.396606,
            48.570401
          ],
          [
            14.604082,
            53.396685,
            47.931252
          ],
          [
            14.603756,
            53.39678,
            47.183248
          ],
          [
            14.6034,
            53.396865,
            46.392668
          ],
          [
            14.603038,
            53.396968,
            45.565472
          ],
          [
            14.602714,
            53.397088,
            44.779218
          ],
          [
            14.602451,
            53.397199,
            44.114817
          ],
          [
            14.602162,
            53.397322,
            43.382432
          ],
          [
            14.601898,
            53.397466,
            42.64437
          ],
          [
            14.601642,
            53.397636,
            42.136583
          ],
          [
            14.601397,
            53.3978,
            41.754078
          ],
          [
            14.601109,
            53.39798,
            41.320554
          ],
          [
            14.600887,
            53.39822,
            40.843426
          ],
          [
            14.600683,
            53.398492,
            40.324481
          ],
          [
            14.600448,
            53.398774,
            39.774743
          ],
          [
            14.60033,
            53.399063,
            39.302043
          ],
          [
            14.600222,
            53.399322,
            39.401344
          ],
          [
            14.600139,
            53.399559,
            39.491361
          ],
          [
            14.600026,
            53.399775,
            39.57576
          ],
          [
            14.599912,
            53.399987,
            39.658532
          ],
          [
            14.599854,
            53.400219,
            39.745744
          ],
          [
            14.599801,
            53.400444,
            39.830225
          ],
          [
            14.599706,
            53.400664,
            39.914743
          ],
          [
            14.599638,
            53.400871,
            39.916299
          ],
          [
            14.599589,
            53.401073,
            39.800709
          ],
          [
            14.599534,
            53.401272,
            39.686589
          ],
          [
            14.599481,
            53.401465,
            39.575913
          ],
          [
            14.599385,
            53.401639,
            39.472004
          ],
          [
            14.599304,
            53.401824,
            39.363331
          ],
          [
            14.599226,
            53.402051,
            39.232035
          ],
          [
            14.599128,
            53.402281,
            39.097724
          ],
          [
            14.599009,
            53.402452,
            38.992821
          ],
          [
            14.598862,
            53.402616,
            38.941518
          ],
          [
            14.598644,
            53.402815,
            38.933403
          ],
          [
            14.598494,
            53.402992,
            38.926699
          ],
          [
            14.598285,
            53.403215,
            38.918051
          ],
          [
            14.598119,
            53.403385,
            38.911399
          ],
          [
            14.597996,
            53.403555,
            38.90514
          ],
          [
            14.597788,
            53.403744,
            38.897482
          ],
          [
            14.597526,
            53.403893,
            38.890128
          ],
          [
            14.597266,
            53.404011,
            38.876315
          ],
          [
            14.597006,
            53.404172,
            38.791454
          ],
          [
            14.596704,
            53.404318,
            38.703553
          ],
          [
            14.596404,
            53.40446,
            38.616971
          ],
          [
            14.596078,
            53.404609,
            38.524153
          ],
          [
            14.595722,
            53.40475,
            38.427454
          ],
          [
            14.595418,
            53.404877,
            38.343303
          ],
          [
            14.595228,
            53.40505,
            38.260044
          ],
          [
            14.594913,
            53.405159,
            38.207392
          ],
          [
            14.594646,
            53.405269,
            38.221944
          ],
          [
            14.594329,
            53.405408,
            38.239616
          ],
          [
            14.593998,
            53.405558,
            38.258252
          ],
          [
            14.593693,
            53.405689,
            38.275116
          ],
          [
            14.593384,
            53.405818,
            38.292028
          ],
          [
            14.593072,
            53.405966,
            38.309897
          ],
          [
            14.592794,
            53.406091,
            38.325503
          ],
          [
            14.592486,
            53.406219,
            38.525072
          ],
          [
            14.592218,
            53.406333,
            39.121531
          ],
          [
            14.591901,
            53.40641,
            39.74183
          ],
          [
            14.591641,
            53.406512,
            40.305853
          ],
          [
            14.591372,
            53.406643,
            40.935131
          ],
          [
            14.591146,
            53.406783,
            41.527392
          ],
          [
            14.590911,
            53.406914,
            42.110625
          ],
          [
            14.590648,
            53.407018,
            42.682406
          ],
          [
            14.590357,
            53.407104,
            43.271855
          ],
          [
            14.590077,
            53.407209,
            43.829257
          ],
          [
            14.589853,
            53.407331,
            44.037646
          ],
          [
            14.589592,
            53.407445,
            44.25787
          ],
          [
            14.589344,
            53.407574,
            44.481873
          ],
          [
            14.589094,
            53.407684,
            44.693449
          ],
          [
            14.58882,
            53.407797,
            44.920388
          ],
          [
            14.588562,
            53.407914,
            45.141212
          ],
          [
            14.588281,
            53.408028,
            45.372556
          ],
          [
            14.587931,
            53.408175,
            45.664474
          ],
          [
            14.587673,
            53.408297,
            45.857063
          ],
          [
            14.587415,
            53.408423,
            45.856437
          ],
          [
            14.587129,
            53.408557,
            45.855754
          ],
          [
            14.586881,
            53.408665,
            45.855177
          ],
          [
            14.586593,
            53.408807,
            45.854475
          ],
          [
            14.58629,
            53.40892,
            45.853805
          ],
          [
            14.585998,
            53.409034,
            45.853149
          ],
          [
            14.585734,
            53.40917,
            45.852495
          ],
          [
            14.585463,
            53.409279,
            45.851881
          ],
          [
            14.585157,
            53.409388,
            45.746982
          ],
          [
            14.584915,
            53.409513,
            45.519018
          ],
          [
            14.584668,
            53.40963,
            45.294177
          ],
          [
            14.584427,
            53.409768,
            45.057026
          ],
          [
            14.584184,
            53.409884,
            44.83617
          ],
          [
            14.583919,
            53.410002,
            44.601508
          ],
          [
            14.583669,
            53.410121,
            44.374468
          ],
          [
            14.583397,
            53.410234,
            44.139075
          ],
          [
            14.583283,
            53.410383,
            43.910217
          ],
          [
            14.582947,
            53.410453,
            43.605755
          ],
          [
            14.58268,
            53.410561,
            43.154371
          ],
          [
            14.582407,
            53.410677,
            42.687182
          ],
          [
            14.58209,
            53.410794,
            42.166106
          ],
          [
            14.581831,
            53.410905,
            41.721481
          ],
          [
            14.581556,
            53.411034,
            41.233925
          ],
          [
            14.581274,
            53.411144,
            40.763946
          ],
          [
            14.581042,
            53.411337,
            40.200842
          ],
          [
            14.580829,
            53.411488,
            39.73332
          ],
          [
            14.580536,
            53.411602,
            39.514839
          ],
          [
            14.580252,
            53.411718,
            39.528634
          ],
          [
            14.57991,
            53.41184,
            39.54457
          ],
          [
            14.579552,
            53.41195,
            39.56068
          ],
          [
            14.579263,
            53.412082,
            39.575232
          ],
          [
            14.578908,
            53.412231,
            39.592593
          ],
          [
            14.578626,
            53.412322,
            39.605409
          ],
          [
            14.57836,
            53.412434,
            39.618604
          ],
          [
            14.578053,
            53.412557,
            39.54195
          ],
          [
            14.577714,
            53.412672,
            39.29604
          ],
          [
            14.577397,
            53.41279,
            39.059503
          ],
          [
            14.577087,
            53.412916,
            38.822672
          ],
          [
            14.576786,
            53.413033,
            38.596203
          ],
          [
            14.576523,
            53.413142,
            38.393892
          ],
          [
            14.576242,
            53.413269,
            38.171652
          ],
          [
            14.575945,
            53.413394,
            37.941973
          ],
          [
            14.575642,
            53.413494,
            37.731711
          ],
          [
            14.575355,
            53.413609,
            38.034541
          ],
          [
            14.575098,
            53.413737,
            38.328033
          ],
          [
            14.574812,
            53.413863,
            38.640167
          ],
          [
            14.574517,
            53.413976,
            38.949
          ],
          [
            14.574195,
            53.414089,
            39.276178
          ],
          [
            14.573867,
            53.414193,
            39.601463
          ],
          [
            14.573566,
            53.414298,
            39.906862
          ],
          [
            14.573244,
            53.414407,
            40.231516
          ],
          [
            14.572955,
            53.414504,
            40.543136
          ],
          [
            14.572662,
            53.414633,
            40.907106
          ],
          [
            14.572359,
            53.414744,
            41.262313
          ],
          [
            14.572059,
            53.414845,
            41.605848
          ],
          [
            14.57172,
            53.414942,
            41.980652
          ],
          [
            14.57138,
            53.415038,
            42.356848
          ],
          [
            14.571109,
            53.415131,
            42.668982
          ],
          [
            14.570789,
            53.415218,
            43.019942
          ],
          [
            14.570491,
            53.415314,
            43.357578
          ],
          [
            14.570203,
            53.415426,
            44.269247
          ],
          [
            14.569898,
            53.415528,
            45.228364
          ],
          [
            14.569607,
            53.415623,
            46.146997
          ],
          [
            14.569308,
            53.415693,
            47.029382
          ],
          [
            14.568998,
            53.415785,
            47.979776
          ],
          [
            14.568737,
            53.41589,
            48.842998
          ],
          [
            14.568442,
            53.416006,
            49.811421
          ],
          [
            14.568157,
            53.416129,
            50.775794
          ],
          [
            14.567915,
            53.416269,
            51.640674
          ],
          [
            14.567673,
            53.416419,
            51.577341
          ],
          [
            14.56747,
            53.416581,
            51.51578
          ],
          [
            14.567301,
            53.416743,
            51.457728
          ],
          [
            14.567118,
            53.416923,
            51.393649
          ],
          [
            14.566973,
            53.417102,
            51.33315
          ],
          [
            14.566826,
            53.417311,
            51.264168
          ],
          [
            14.56672,
            53.417512,
            51.200048
          ],
          [
            14.56664,
            53.417697,
            51.141787
          ],
          [
            14.566586,
            53.417909,
            50.821981
          ],
          [
            14.566573,
            53.418114,
            49.982935
          ],
          [
            14.566573,
            53.418359,
            48.984519
          ],
          [
            14.566592,
            53.418554,
            48.187025
          ],
          [
            14.566612,
            53.418761,
            47.341755
          ],
          [
            14.566697,
            53.418967,
            46.477226
          ],
          [
            14.566758,
            53.419187,
            45.565838
          ],
          [
            14.566849,
            53.419392,
            44.700977
          ],
          [
            14.566915,
            53.419609,
            43.802317
          ],
          [
            14.566967,
            53.419819,
            43.978888
          ],
          [
            14.567065,
            53.420014,
            44.189622
          ],
          [
            14.567144,
            53.420221,
            44.40928
          ],
          [
            14.567225,
            53.420418,
            44.619075
          ],
          [
            14.567341,
            53.420609,
            44.829138
          ],
          [
            14.56742,
            53.420804,
            45.03658
          ],
          [
            14.567516,
            53.421036,
            45.28366
          ],
          [
            14.567584,
            53.421217,
            45.475535
          ],
          [
            14.567668,
            53.421428,
            45.77108
          ],
          [
            14.567755,
            53.421669,
            46.278949
          ],
          [
            14.567881,
            53.421894,
            46.767532
          ],
          [
            14.568002,
            53.422119,
            47.254038
          ],
          [
            14.568094,
            53.422356,
            47.754556
          ],
          [
            14.568171,
            53.422547,
            48.159792
          ],
          [
            14.568236,
            53.422757,
            48.599188
          ],
          [
            14.568255,
            53.42296,
            49.018239
          ],
          [
            14.568265,
            53.423171,
            49.383729
          ],
          [
            14.568266,
            53.423392,
            49.585611
          ],
          [
            14.568231,
            53.423615,
            49.790611
          ],
          [
            14.568179,
            53.423838,
            49.996665
          ],
          [
            14.568091,
            53.424045,
            50.19172
          ],
          [
            14.568021,
            53.424221,
            50.357492
          ],
          [
            14.567909,
            53.424415,
            50.544789
          ],
          [
            14.567766,
            53.424576,
            50.71111
          ],
          [
            14.567603,
            53.424762,
            50.905538
          ],
          [
            14.56746,
            53.424936,
            51.126389
          ],
          [
            14.567279,
            53.425108,
            51.385443
          ],
          [
            14.567024,
            53.425243,
            51.644061
          ],
          [
            14.566758,
            53.425371,
            51.903285
          ],
          [
            14.56653,
            53.42552,
            52.160135
          ],
          [
            14.566272,
            53.425662,
            52.427463
          ],
          [
            14.565998,
            53.425799,
            52.698643
          ],
          [
            14.565738,
            53.425926,
            52.953624
          ],
          [
            14.565528,
            53.426085,
            53.21185
          ],
          [
            14.565398,
            53.426267,
            52.420747
          ],
          [
            14.565356,
            53.426496,
            51.220487
          ],
          [
            14.565424,
            53.426709,
            50.092003
          ],
          [
            14.565556,
            53.426974,
            48.651225
          ],
          [
            14.565679,
            53.427303,
            46.896876
          ],
          [
            14.565775,
            53.42756,
            45.5265
          ],
          [
            14.565915,
            53.427874,
            43.867151
          ],
          [
            14.566013,
            53.428122,
            43.183877
          ],
          [
            14.566093,
            53.428313,
            42.654394
          ],
          [
            14.566267,
            53.428523,
            42.020043
          ],
          [
            14.566337,
            53.428719,
            41.481744
          ],
          [
            14.566424,
            53.428901,
            40.970882
          ],
          [
            14.566466,
            53.429139,
            40.32902
          ],
          [
            14.566262,
            53.429292,
            39.791671
          ],
          [
            14.565957,
            53.429397,
            39.228744
          ],
          [
            14.565906,
            53.429336,
            39.883008
          ],
          [
            14.565562,
            53.429352,
            40.940629
          ],
          [
            14.565285,
            53.429256,
            41.921829
          ],
          [
            14.565135,
            53.429079,
            42.925815
          ],
          [
            14.565002,
            53.428898,
            43.917097
          ],
          [
            14.564907,
            53.428725,
            44.838402
          ],
          [
            14.564752,
            53.428526,
            45.943771
          ],
          [
            14.564672,
            53.42834,
            46.907972
          ],
          [
            14.564781,
            53.428143,
            47.965886
          ],
          [
            14.564764,
            53.427947,
            48.77983
          ],
          [
            14.56451,
            53.427824,
            49.537061
          ],
          [
            14.564181,
            53.427787,
            50.311285
          ],
          [
            14.563901,
            53.427899,
            51.091207
          ],
          [
            14.563566,
            53.427934,
            51.875572
          ],
          [
            14.563242,
            53.428009,
            52.67589
          ],
          [
            14.562913,
            53.428031,
            53.439394
          ],
          [
            14.56262,
            53.428098,
            54.161869
          ],
          [
            14.562342,
            53.428209,
            54.937333
          ],
          [
            14.562063,
            53.428298,
            55.639398
          ],
          [
            14.561728,
            53.428355,
            56.408636
          ],
          [
            14.561414,
            53.428408,
            57.132638
          ],
          [
            14.561103,
            53.42844,
            57.831922
          ],
          [
            14.560785,
            53.4285,
            58.571491
          ],
          [
            14.560375,
            53.428595,
            59.543063
          ],
          [
            14.560065,
            53.428639,
            60.246577
          ],
          [
            14.559686,
            53.4287,
            61.113794
          ],
          [
            14.559378,
            53.428771,
            61.816892
          ],
          [
            14.559072,
            53.428897,
            62.488314
          ],
          [
            14.55875,
            53.428933,
            63.071518
          ],
          [
            14.558442,
            53.428983,
            63.639858
          ],
          [
            14.558091,
            53.42907,
            64.317141
          ],
          [
            14.557739,
            53.42913,
            64.969441
          ],
          [
            14.557393,
            53.42913,
            65.58702
          ],
          [
            14.557061,
            53.429163,
            66.186326
          ],
          [
            14.556782,
            53.429249,
            66.745327
          ],
          [
            14.556462,
            53.429331,
            66.884485
          ],
          [
            14.556117,
            53.42936,
            66.534967
          ],
          [
            14.55578,
            53.429418,
            66.183913
          ],
          [
            14.555469,
            53.429422,
            65.871405
          ],
          [
            14.555086,
            53.429432,
            65.485464
          ],
          [
            14.554755,
            53.429493,
            65.138208
          ],
          [
            14.554425,
            53.429552,
            64.794958
          ],
          [
            14.554075,
            53.429531,
            64.438042
          ],
          [
            14.55393,
            53.429331,
            64.073272
          ],
          [
            14.553818,
            53.42914,
            64.527548
          ],
          [
            14.553706,
            53.428937,
            65.053278
          ],
          [
            14.553579,
            53.4291,
            65.539626
          ],
          [
            14.553404,
            53.429235,
            66.04466
          ],
          [
            14.553125,
            53.429102,
            66.57244
          ],
          [
            14.55282,
            53.429035,
            67.048755
          ],
          [
            14.552475,
            53.428856,
            67.719605
          ],
          [
            14.552182,
            53.428776,
            68.1926
          ],
          [
            14.551832,
            53.428787,
            69.309566
          ],
          [
            14.551516,
            53.428782,
            71.002792
          ],
          [
            14.55114,
            53.428808,
            72.996312
          ],
          [
            14.550825,
            53.42877,
            74.701565
          ],
          [
            14.550494,
            53.428816,
            76.489272
          ],
          [
            14.550132,
            53.42886,
            78.443315
          ],
          [
            14.549774,
            53.428888,
            80.357147
          ],
          [
            14.549459,
            53.428939,
            82.075624
          ],
          [
            14.549295,
            53.429021,
            83.298685
          ],
          [
            14.549527,
            53.428997,
            82.43608
          ],
          [
            14.549505,
            53.428955,
            81.672288
          ],
          [
            14.549176,
            53.429044,
            80.81131
          ],
          [
            14.549284,
            53.428928,
            79.999514
          ],
          [
            14.549654,
            53.428943,
            79.109291
          ],
          [
            14.550012,
            53.428942,
            78.257983
          ],
          [
            14.550315,
            53.428901,
            77.417799
          ],
          [
            14.550717,
            53.428842,
            76.45307
          ],
          [
            14.551108,
            53.428804,
            75.560227
          ],
          [
            14.551466,
            53.428783,
            74.74956
          ],
          [
            14.551672,
            53.428559,
            73.776862
          ],
          [
            14.551622,
            53.428337,
            72.921116
          ],
          [
            14.551555,
            53.428121,
            72.089884
          ],
          [
            14.551491,
            53.427906,
            71.264032
          ],
          [
            14.551418,
            53.427671,
            70.352253
          ],
          [
            14.551333,
            53.427422,
            68.737148
          ],
          [
            14.551284,
            53.427201,
            67.32369
          ],
          [
            14.551189,
            53.426946,
            65.664943
          ],
          [
            14.551091,
            53.426683,
            63.955965
          ],
          [
            14.551029,
            53.426471,
            62.586979
          ],
          [
            14.550995,
            53.426252,
            61.188675
          ],
          [
            14.550911,
            53.426017,
            59.662733
          ],
          [
            14.550784,
            53.425836,
            58.914834
          ],
          [
            14.550664,
            53.425641,
            58.79699
          ],
          [
            14.550505,
            53.425462,
            58.683305
          ],
          [
            14.550662,
            53.425304,
            58.578239
          ],
          [
            14.55076,
            53.425039,
            58.425771
          ],
          [
            14.550729,
            53.424836,
            58.310841
          ],
          [
            14.550654,
            53.424628,
            58.191409
          ],
          [
            14.550547,
            53.424429,
            58.073805
          ],
          [
            14.550342,
            53.424238,
            57.925303
          ],
          [
            14.550198,
            53.424031,
            57.417695
          ],
          [
            14.550351,
            53.423806,
            56.872369
          ],
          [
            14.550185,
            53.42361,
            56.378262
          ],
          [
            14.550069,
            53.423403,
            55.872386
          ],
          [
            14.55006,
            53.423218,
            55.454393
          ],
          [
            14.549921,
            53.422983,
            54.894769
          ],
          [
            14.549818,
            53.422763,
            54.381164
          ],
          [
            14.549799,
            53.422565,
            53.934402
          ],
          [
            14.549637,
            53.422341,
            55.284688
          ],
          [
            14.549551,
            53.422127,
            56.574421
          ],
          [
            14.549454,
            53.421872,
            58.095683
          ],
          [
            14.549336,
            53.421646,
            59.470948
          ],
          [
            14.549238,
            53.421425,
            60.800083
          ],
          [
            14.549034,
            53.421294,
            62.100027
          ],
          [
            14.548634,
            53.421406,
            63.630256
          ],
          [
            14.548282,
            53.42147,
            64.533701
          ],
          [
            14.547948,
            53.421567,
            64.927448
          ],
          [
            14.547619,
            53.421621,
            65.288994
          ],
          [
            14.547275,
            53.42166,
            65.66029
          ],
          [
            14.547107,
            53.421765,
            66.031071
          ],
          [
            14.547232,
            53.421943,
            66.374686
          ],
          [
            14.547282,
            53.422122,
            66.703051
          ],
          [
            14.546982,
            53.422205,
            67.053585
          ],
          [
            14.546699,
            53.422302,
            67.415429
          ],
          [
            14.54651,
            53.422444,
            67.019103
          ],
          [
            14.546181,
            53.422387,
            66.075552
          ],
          [
            14.545956,
            53.422256,
            65.192546
          ],
          [
            14.54582,
            53.422065,
            64.274499
          ],
          [
            14.545674,
            53.421878,
            63.371051
          ],
          [
            14.545507,
            53.421676,
            62.382821
          ],
          [
            14.545427,
            53.42148,
            61.499273
          ],
          [
            14.545307,
            53.421277,
            60.557812
          ],
          [
            14.545204,
            53.421091,
            59.700335
          ],
          [
            14.544829,
            53.421142,
            59.760643
          ],
          [
            14.544509,
            53.4212,
            59.815073
          ],
          [
            14.544139,
            53.421275,
            59.878424
          ],
          [
            14.543781,
            53.421324,
            59.938855
          ],
          [
            14.543424,
            53.421362,
            59.997627
          ],
          [
            14.543058,
            53.42143,
            60.059746
          ],
          [
            14.542762,
            53.421514,
            60.114685
          ],
          [
            14.542418,
            53.421565,
            60.172126
          ],
          [
            14.54209,
            53.421575,
            60.203514
          ],
          [
            14.541767,
            53.421504,
            60.228203
          ],
          [
            14.541559,
            53.421346,
            60.251544
          ],
          [
            14.541213,
            53.421423,
            60.276945
          ],
          [
            14.54097,
            53.421351,
            60.299316
          ],
          [
            14.540805,
            53.421159,
            60.324208
          ],
          [
            14.540715,
            53.420936,
            60.350677
          ],
          [
            14.540569,
            53.420705,
            60.379222
          ],
          [
            14.540421,
            53.420503,
            60.527182
          ],
          [
            14.540338,
            53.420279,
            60.887606
          ],
          [
            14.540284,
            53.419977,
            61.379445
          ],
          [
            14.540092,
            53.419809,
            61.700583
          ],
          [
            14.539971,
            53.41963,
            62.003371
          ],
          [
            14.539683,
            53.419626,
            62.300698
          ],
          [
            14.539363,
            53.419655,
            62.606764
          ],
          [
            14.538992,
            53.41974,
            62.978328
          ],
          [
            14.538823,
            53.41987,
            63.216131
          ],
          [
            14.538904,
            53.420088,
            63.216131
          ],
          [
            14.538963,
            53.420289,
            63.216131
          ],
          [
            14.53892,
            53.420484,
            63.216131
          ],
          [
            14.538917,
            53.420668,
            63.216131
          ],
          [
            14.538668,
            53.420789,
            63.216131
          ],
          [
            14.538336,
            53.420843,
            63.216131
          ],
          [
            14.538541,
            53.420973,
            63.216131
          ],
          [
            14.537747,
            53.421071,
            63.216131
          ],
          [
            14.538257,
            53.421114,
            63.216131
          ],
          [
            14.538534,
            53.421123,
            63.216131
          ]
        ]
      }
    }
  ]
}

let day37: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.538534,
            53.421123,
            63.216131
          ],
          [14.537255, 53.420742, 28.75],
          [14.537269, 53.420774, 29.0],
          [14.537776, 53.420712, 28.25],
          [14.537853, 53.420703, 28.25],
          [14.537950, 53.420692, 28.0],
          [14.538662, 53.420610, 27.0],
          [14.538820, 53.420592, 27.0],
          [14.539359, 53.420536, 26.25],
          [14.539701, 53.420492, 26.0],
          [14.539823, 53.420472, 26.0],
          [14.540403, 53.420369, 25.0],
          [14.540527, 53.420347, 24.75],
          [14.540625, 53.420572, 25.0],
          [14.540782, 53.420929, 25.0],
          [14.540840, 53.421064, 24.75],
          [14.540968, 53.421357, 24.75],
          [14.541040, 53.421393, 24.5],
          [14.541108, 53.421412, 24.5],
          [14.541164, 53.421420, 24.25],
          [14.541368, 53.421391, 24.0],
          [14.541477, 53.421359, 23.75],
          [14.541526, 53.421352, 23.75],
          [14.541541, 53.421366, 23.75],
          [14.541556, 53.421401, 23.75],
          [14.541742, 53.421510, 23.75],
          [14.541754, 53.421538, 23.75],
          [14.541604, 53.421561, 23.75],
          [14.541531, 53.421572, 24.0],
          [14.541274, 53.421612, 24.25],
          [14.541223, 53.421619, 24.25],
          [14.540592, 53.421716, 25.25],
          [14.540366, 53.421751, 25.5],
          [14.538456, 53.422047, 28.25],
          [14.538106, 53.422101, 28.5],
          [14.538037, 53.422112, 28.5],
          [14.537862, 53.422139, 28.5],
          [14.537905, 53.422227, 28.0],
          [14.538075, 53.422609, 26.75],
          [14.538275, 53.423063, 26.25],
          [14.538329, 53.423154, 26.0],
          [14.538372, 53.423225, 26.0],
          [14.538484, 53.423478, 26.0],
          [14.538930, 53.424480, 26.0],
          [14.538966, 53.424562, 26.0],
          [14.539010, 53.424657, 26.0],
          [14.539416, 53.425575, 24.25],
          [14.539449, 53.425646, 24.0],
          [14.539592, 53.425623, 24.5],
          [14.542035, 53.425242, 23.75],
          [14.542186, 53.425220, 23.75],
          [14.542330, 53.425199, 23.75],
          [14.544576, 53.424865, 23.5],
          [14.544685, 53.424847, 23.5],
          [14.544758, 53.424828, 23.75],
          [14.544906, 53.424794, 23.75],
          [14.545047, 53.424795, 24.0],
          [14.545142, 53.424823, 24.0],
          [14.545563, 53.425122, 23.5],
          [14.545618, 53.425149, 23.5],
          [14.545681, 53.425164, 23.5],
          [14.545744, 53.425171, 23.5],
          [14.545934, 53.425174, 23.5],
          [14.546245, 53.425141, 24.0],
          [14.546580, 53.425093, 24.5],
          [14.547023, 53.425028, 24.0],
          [14.547259, 53.424994, 23.5],
          [14.547431, 53.424969, 23.0],
          [14.547678, 53.424937, 22.5],
          [14.548075, 53.424920, 21.75],
          [14.548857, 53.424921, 21.0],
          [14.549112, 53.424920, 21.0],
          [14.549364, 53.424917, 21.0],
          [14.549630, 53.424900, 21.0],
          [14.549750, 53.424885, 21.25],
          [14.549860, 53.424871, 21.25],
          [14.549972, 53.424854, 21.25],
          [14.550241, 53.424815, 21.25],
          [14.550590, 53.424790, 21.5],
          [14.550738, 53.424788, 21.5],
          [14.550761, 53.424788, 21.5],
          [14.550788, 53.424789, 21.5],
          [14.550872, 53.424797, 21.25],
          [14.550894, 53.424801, 21.25],
          [14.550942, 53.424810, 21.25],
          [14.551016, 53.424833, 21.25],
          [14.551040, 53.424843, 21.25],
          [14.551028, 53.424869, 21.25],
          [14.551023, 53.424879, 21.25],
          [14.550978, 53.424940, 21.0],
          [14.550942, 53.424974, 21.0],
          [14.550915, 53.424998, 21.0],
          [14.550829, 53.425053, 21.0],
          [14.550796, 53.425070, 21.25],
          [14.550795, 53.425059, 21.0],
          [14.550792, 53.425029, 21.0],
          [14.550792, 53.425026, 21.0],
          [14.550787, 53.424983, 21.0],
          [14.550784, 53.424948, 21.0],
          [14.550766, 53.424809, 21.25],
          [14.550761, 53.424788, 21.5],
          [14.550753, 53.424760, 21.5],
          [14.550869, 53.424763, 21.5],
          [14.550878, 53.424763, 21.5],
          [14.550932, 53.424764, 21.5],
          [14.551006, 53.424765, 21.5],
          [14.551069, 53.424766, 21.25],
          [14.551106, 53.424766, 21.25],
          [14.551145, 53.424766, 21.25],
          [14.551177, 53.424764, 21.25],
          [14.551279, 53.424758, 21.25],
          [14.551306, 53.424756, 21.25],
          [14.551377, 53.424747, 21.25],
          [14.551498, 53.424731, 21.25],
          [14.551591, 53.424718, 21.25],
          [14.551750, 53.424695, 21.25],
          [14.552249, 53.424626, 21.75],
          [14.552690, 53.424577, 22.0],
          [14.553328, 53.424480, 22.75],
          [14.556049, 53.424072, 16.25],
          [14.556211, 53.424045, 15.75],
          [14.556515, 53.423982, 14.75],
          [14.556789, 53.423913, 13.75],
          [14.557082, 53.423831, 12.75],
          [14.557515, 53.423689, 11.0],
          [14.557945, 53.423513, 9.25],
          [14.558184, 53.423399, 8.5],
          [14.558384, 53.423294, 7.75],
          [14.558765, 53.423063, 6.75],
          [14.558757, 53.422889, 6.25],
          [14.558807, 53.422848, 6.0],
          [14.558883, 53.422806, 5.75],
          [14.559056, 53.422695, 5.0],
          [14.559132, 53.422646, 4.5],
          [14.559221, 53.422590, 4.0],
          [14.559272, 53.422553, 3.75],
          [14.559336, 53.422507, 3.25],
          [14.559402, 53.422459, 3.0],
          [14.559445, 53.422428, 2.75],
          [14.559533, 53.422466, 2.5],
          [14.559619, 53.422494, 2.25],
          [14.559668, 53.422498, 2.0],
          [14.559721, 53.422487, 1.75],
          [14.559761, 53.422469, 1.75],
          [14.559721, 53.422487, 1.75],
          [14.559668, 53.422498, 2.0],
          [14.559619, 53.422494, 2.25],
          [14.559533, 53.422466, 2.5],
          [14.559445, 53.422428, 2.75],
          [14.559402, 53.422459, 3.0],
          [14.559336, 53.422507, 3.25],
          [14.559290, 53.422485, 3.5],
          [14.559238, 53.422460, 3.5],
          [14.559146, 53.422417, 3.75],
          [14.558695, 53.422204, 4.0],
          [14.556762, 53.421286, 1.0],
          [14.556070, 53.420951, 3.0],
          [14.555740, 53.420783, 4.0],
          [14.555678, 53.420745, 4.0],
          [14.555183, 53.420447, 2.75],
          [14.554983, 53.420335, 2.0],
          [14.554843, 53.420295, 1.5],
          [14.554700, 53.420271, 1.25],
          [14.554698, 53.420271, 1.5],
          [14.554648, 53.420281, 1.5],
          [14.554568, 53.420286, 1.75],
          [14.554462, 53.420274, 1.5],
          [14.554413, 53.420260, 1.5],
          [14.554348, 53.420231, 1.25],
          [14.554288, 53.420177, 1.0],
          [14.554275, 53.420114, 0.5],
          [14.554279, 53.420031, 0.0],
          [14.554274, 53.420001, -0.25],
          [14.554241, 53.419953, 0.0],
          [14.554199, 53.419919, 0.0],
          [14.554133, 53.419877, 0.0],
          [14.554061, 53.419843, 0.25],
          [14.553982, 53.419814, 0.25],
          [14.553206, 53.419583, 3.0],
          [14.552961, 53.419491, 4.0],
          [14.552814, 53.419426, 4.75],
          [14.552617, 53.419328, 5.5],
          [14.552524, 53.419279, 5.75],
          [14.552299, 53.419158, 6.25],
          [14.552017, 53.418998, 5.5],
          [14.551945, 53.418957, 5.25],
          [14.551737, 53.418839, 4.5],
          [14.551219, 53.418533, 3.0],
          [14.551107, 53.418464, 2.5],
          [14.550689, 53.418225, 1.75],
          [14.550482, 53.418117, 1.75],
          [14.550447, 53.418076, 1.75],
          [14.550457, 53.418036, 1.5],
          [14.550508, 53.417991, 1.25],
          [14.550576, 53.417969, 1.0],
          [14.550667, 53.417964, 0.75],
          [14.550680, 53.417945, 0.75],
          [14.550680, 53.417923, 0.75],
          [14.550235, 53.417920, 1.25],
          [
            14.548424,
            53.417153,
            43.080919
          ],
          [
            14.548539,
            53.41701,
            43.080919
          ],
          [
            14.548633,
            53.416868,
            43.080919
          ],
          [
            14.548459,
            53.416659,
            43.080919
          ],
          [
            14.548289,
            53.416444,
            43.080919
          ],
          [
            14.548097,
            53.41621,
            43.067444
          ],
          [
            14.547909,
            53.416047,
            43.054925
          ],
          [
            14.547721,
            53.415843,
            43.040191
          ],
          [
            14.547498,
            53.415659,
            43.025824
          ],
          [
            14.54733,
            53.41548,
            43.012831
          ],
          [
            14.5472,
            53.415269,
            42.998596
          ],
          [
            14.547011,
            53.415079,
            42.984606
          ],
          [
            14.546785,
            53.414876,
            42.969188
          ],
          [
            14.546519,
            53.414701,
            43.199792
          ],
          [
            14.546287,
            53.414523,
            43.45792
          ],
          [
            14.546053,
            53.414344,
            43.718119
          ],
          [
            14.545824,
            53.414161,
            43.979598
          ],
          [
            14.545571,
            53.413959,
            44.269149
          ],
          [
            14.54533,
            53.41377,
            44.541028
          ],
          [
            14.545087,
            53.413585,
            44.810044
          ],
          [
            14.544922,
            53.413394,
            45.063031
          ],
          [
            14.544733,
            53.413198,
            45.379245
          ],
          [
            14.544551,
            53.412984,
            45.71472
          ],
          [
            14.544374,
            53.412787,
            46.027182
          ],
          [
            14.544203,
            53.412598,
            46.327597
          ],
          [
            14.544014,
            53.412401,
            46.644768
          ],
          [
            14.543815,
            53.412222,
            46.945102
          ],
          [
            14.543597,
            53.412072,
            47.222454
          ],
          [
            14.543379,
            53.411915,
            47.507288
          ],
          [
            14.543129,
            53.411758,
            47.230039
          ],
          [
            14.542888,
            53.411624,
            46.915655
          ],
          [
            14.542614,
            53.411478,
            46.564534
          ],
          [
            14.542351,
            53.411324,
            46.212696
          ],
          [
            14.542112,
            53.411161,
            45.866251
          ],
          [
            14.541862,
            53.411002,
            45.517501
          ],
          [
            14.541626,
            53.410859,
            45.196235
          ],
          [
            14.541371,
            53.410696,
            44.839565
          ],
          [
            14.541117,
            53.410601,
            44.481486
          ],
          [
            14.540896,
            53.41078,
            43.966634
          ],
          [
            14.540656,
            53.41093,
            43.483422
          ],
          [
            14.540322,
            53.410838,
            42.970537
          ],
          [
            14.540041,
            53.410667,
            42.416313
          ],
          [
            14.539733,
            53.410499,
            41.840092
          ],
          [
            14.539429,
            53.41033,
            41.264945
          ],
          [
            14.539169,
            53.410172,
            40.752517
          ],
          [
            14.538885,
            53.410015,
            40.663394
          ],
          [
            14.538617,
            53.409869,
            40.962077
          ],
          [
            14.538318,
            53.409726,
            41.277772
          ],
          [
            14.538067,
            53.409579,
            41.567486
          ],
          [
            14.537816,
            53.409409,
            41.88015
          ],
          [
            14.537544,
            53.409265,
            42.179415
          ],
          [
            14.537243,
            53.409165,
            42.46409
          ],
          [
            14.536894,
            53.409124,
            42.756865
          ],
          [
            14.536561,
            53.409074,
            43.177231
          ],
          [
            14.536228,
            53.409022,
            44.098766
          ],
          [
            14.535889,
            53.40899,
            45.018096
          ],
          [
            14.535542,
            53.409012,
            45.95765
          ],
          [
            14.535208,
            53.409058,
            46.87576
          ],
          [
            14.534888,
            53.409122,
            47.780327
          ],
          [
            14.534655,
            53.409247,
            48.660142
          ],
          [
            14.534564,
            53.409334,
            49.524632
          ],
          [
            14.534253,
            53.409302,
            50.410884
          ],
          [
            14.533933,
            53.409292,
            51.207977
          ],
          [
            14.533617,
            53.40934,
            51.827813
          ],
          [
            14.533305,
            53.409386,
            52.435953
          ],
          [
            14.533057,
            53.409504,
            53.043409
          ],
          [
            14.532782,
            53.409476,
            53.643754
          ],
          [
            14.532463,
            53.409552,
            54.29675
          ],
          [
            14.532147,
            53.409624,
            54.943764
          ],
          [
            14.531814,
            53.409677,
            55.595959
          ],
          [
            14.531513,
            53.409742,
            56.202552
          ],
          [
            14.531181,
            53.409806,
            56.78602
          ],
          [
            14.530861,
            53.409841,
            56.917774
          ],
          [
            14.53053,
            53.409857,
            57.058646
          ],
          [
            14.530204,
            53.40987,
            57.195974
          ],
          [
            14.530045,
            53.409685,
            57.33719
          ],
          [
            14.529914,
            53.409484,
            57.483644
          ],
          [
            14.52982,
            53.409299,
            57.614977
          ],
          [
            14.529708,
            53.409103,
            57.755863
          ],
          [
            14.529611,
            53.408888,
            57.907132
          ],
          [
            14.529505,
            53.408684,
            58.24321
          ],
          [
            14.529403,
            53.408479,
            58.811736
          ],
          [
            14.529325,
            53.408258,
            59.412271
          ],
          [
            14.529241,
            53.408047,
            59.988856
          ],
          [
            14.529161,
            53.407826,
            60.591158
          ],
          [
            14.528965,
            53.407694,
            61.141553
          ],
          [
            14.528614,
            53.407774,
            61.737178
          ],
          [
            14.528245,
            53.407817,
            62.335526
          ],
          [
            14.527909,
            53.407883,
            62.939322
          ],
          [
            14.527579,
            53.407936,
            63.664238
          ],
          [
            14.527243,
            53.407984,
            64.397209
          ],
          [
            14.526904,
            53.408053,
            65.158924
          ],
          [
            14.526553,
            53.408111,
            65.931519
          ],
          [
            14.526196,
            53.408174,
            66.721647
          ],
          [
            14.525901,
            53.408228,
            67.376669
          ],
          [
            14.525608,
            53.408289,
            68.035534
          ],
          [
            14.525305,
            53.40836,
            68.726415
          ],
          [
            14.524998,
            53.40846,
            69.04312
          ],
          [
            14.524716,
            53.40855,
            68.759183
          ],
          [
            14.524414,
            53.408629,
            68.466322
          ],
          [
            14.524123,
            53.408698,
            68.18827
          ],
          [
            14.523794,
            53.408792,
            67.864157
          ],
          [
            14.523498,
            53.40887,
            67.575572
          ],
          [
            14.523175,
            53.408963,
            67.256811
          ],
          [
            14.522859,
            53.409057,
            66.943232
          ],
          [
            14.522525,
            53.409184,
            66.591133
          ],
          [
            14.522207,
            53.409293,
            66.485662
          ],
          [
            14.521855,
            53.409412,
            66.478273
          ],
          [
            14.52147,
            53.409515,
            66.470588
          ],
          [
            14.521142,
            53.409609,
            66.46396
          ],
          [
            14.520832,
            53.4097,
            66.457647
          ],
          [
            14.520542,
            53.409802,
            66.451512
          ],
          [
            14.520228,
            53.409899,
            66.445065
          ],
          [
            14.519937,
            53.410007,
            66.438819
          ],
          [
            14.519669,
            53.410119,
            66.51292
          ],
          [
            14.519226,
            53.410318,
            66.830997
          ],
          [
            14.518909,
            53.410445,
            67.049828
          ],
          [
            14.51874,
            53.410621,
            67.244515
          ],
          [
            14.518367,
            53.410592,
            67.460127
          ],
          [
            14.518034,
            53.410471,
            67.683539
          ],
          [
            14.51772,
            53.410337,
            67.904625
          ],
          [
            14.517374,
            53.410183,
            68.1515
          ],
          [
            14.517115,
            53.410074,
            67.814722
          ],
          [
            14.516842,
            53.409964,
            67.437341
          ],
          [
            14.516572,
            53.409857,
            67.066031
          ],
          [
            14.516263,
            53.409714,
            66.618358
          ],
          [
            14.515961,
            53.40958,
            66.187472
          ],
          [
            14.515651,
            53.409457,
            65.761046
          ],
          [
            14.515371,
            53.409332,
            65.360702
          ],
          [
            14.515051,
            53.409201,
            64.915667
          ],
          [
            14.514771,
            53.409074,
            64.185799
          ],
          [
            14.514471,
            53.408956,
            63.086169
          ],
          [
            14.514123,
            53.408877,
            61.94227
          ],
          [
            14.513777,
            53.408765,
            60.737284
          ],
          [
            14.513467,
            53.40867,
            59.670956
          ],
          [
            14.513119,
            53.408565,
            58.477683
          ],
          [
            14.512761,
            53.408444,
            57.217376
          ],
          [
            14.512363,
            53.408342,
            55.890986
          ],
          [
            14.51196,
            53.408209,
            55.281921
          ],
          [
            14.511528,
            53.408074,
            54.990173
          ],
          [
            14.511114,
            53.407956,
            54.715001
          ],
          [
            14.510745,
            53.407849,
            54.469283
          ],
          [
            14.510371,
            53.407718,
            54.209747
          ],
          [
            14.510074,
            53.407622,
            54.007654
          ],
          [
            14.509777,
            53.40752,
            53.802609
          ],
          [
            14.509487,
            53.407439,
            53.864455
          ],
          [
            14.509132,
            53.407357,
            54.583085
          ],
          [
            14.508859,
            53.407266,
            55.173333
          ],
          [
            14.508501,
            53.407154,
            55.940112
          ],
          [
            14.508236,
            53.407047,
            56.544113
          ],
          [
            14.507963,
            53.406949,
            57.14711
          ],
          [
            14.507645,
            53.406849,
            57.825435
          ],
          [
            14.507359,
            53.406772,
            58.420481
          ],
          [
            14.507016,
            53.406695,
            59.113081
          ],
          [
            14.506778,
            53.40656,
            59.36848
          ],
          [
            14.506465,
            53.406475,
            59.375487
          ],
          [
            14.506193,
            53.406364,
            59.382181
          ],
          [
            14.505915,
            53.406275,
            59.38861
          ],
          [
            14.505602,
            53.406149,
            59.396281
          ],
          [
            14.505339,
            53.40603,
            59.40299
          ],
          [
            14.505089,
            53.405886,
            59.410071
          ],
          [
            14.504833,
            53.40574,
            59.417268
          ],
          [
            14.504596,
            53.405574,
            59.424694
          ],
          [
            14.504338,
            53.405423,
            59.007597
          ],
          [
            14.504113,
            53.405264,
            58.533838
          ],
          [
            14.503862,
            53.405071,
            57.977773
          ],
          [
            14.503599,
            53.404884,
            57.422141
          ],
          [
            14.503383,
            53.40471,
            56.925939
          ],
          [
            14.503177,
            53.404529,
            56.427914
          ],
          [
            14.503,
            53.404375,
            56.001775
          ],
          [
            14.502837,
            53.40418,
            55.505671
          ],
          [
            14.502665,
            53.403986,
            55.208456
          ],
          [
            14.502516,
            53.403779,
            55.015129
          ],
          [
            14.502515,
            53.403563,
            54.83022
          ],
          [
            14.502519,
            53.403369,
            54.664101
          ],
          [
            14.50242,
            53.403145,
            54.460889
          ],
          [
            14.502213,
            53.402957,
            54.268421
          ],
          [
            14.501965,
            53.402801,
            54.083728
          ],
          [
            14.501676,
            53.402719,
            53.912864
          ],
          [
            14.501356,
            53.402733,
            53.890115
          ],
          [
            14.501009,
            53.402764,
            54.313506
          ],
          [
            14.500746,
            53.402881,
            54.70666
          ],
          [
            14.500504,
            53.403019,
            55.107873
          ],
          [
            14.500282,
            53.403158,
            55.534846
          ],
          [
            14.499979,
            53.403089,
            55.933023
          ],
          [
            14.499738,
            53.402949,
            56.336477
          ],
          [
            14.499534,
            53.402785,
            56.748585
          ],
          [
            14.499357,
            53.402595,
            57.185648
          ],
          [
            14.499156,
            53.40242,
            57.602287
          ],
          [
            14.498962,
            53.402239,
            58.012771
          ],
          [
            14.498811,
            53.402066,
            58.385862
          ],
          [
            14.498624,
            53.401884,
            58.794349
          ],
          [
            14.498417,
            53.401703,
            59.213243
          ],
          [
            14.49823,
            53.401522,
            59.61951
          ],
          [
            14.498196,
            53.401346,
            59.967948
          ],
          [
            14.498114,
            53.401143,
            60.384437
          ],
          [
            14.49792,
            53.400991,
            60.749505
          ],
          [
            14.497705,
            53.400809,
            60.826774
          ],
          [
            14.497555,
            53.400631,
            60.808185
          ],
          [
            14.497371,
            53.400453,
            60.788655
          ],
          [
            14.497186,
            53.400284,
            60.769804
          ],
          [
            14.496953,
            53.400134,
            60.750713
          ],
          [
            14.496726,
            53.399964,
            60.730438
          ],
          [
            14.496507,
            53.399787,
            60.709916
          ],
          [
            14.496308,
            53.399622,
            60.690951
          ],
          [
            14.496097,
            53.399476,
            60.653157
          ],
          [
            14.49589,
            53.399304,
            60.456071
          ],
          [
            14.495717,
            53.399133,
            60.270601
          ],
          [
            14.495517,
            53.398977,
            60.088
          ],
          [
            14.49531,
            53.398797,
            59.88554
          ],
          [
            14.495102,
            53.398625,
            59.688629
          ],
          [
            14.494866,
            53.398427,
            59.462928
          ],
          [
            14.494678,
            53.39827,
            59.283937
          ],
          [
            14.494497,
            53.398108,
            59.103078
          ],
          [
            14.494289,
            53.397922,
            59.378725
          ],
          [
            14.494053,
            53.397769,
            60.025947
          ],
          [
            14.493865,
            53.39759,
            60.674112
          ],
          [
            14.493701,
            53.397409,
            61.30523
          ],
          [
            14.493525,
            53.397248,
            61.895458
          ],
          [
            14.493318,
            53.397063,
            62.578295
          ],
          [
            14.493118,
            53.396874,
            63.263925
          ],
          [
            14.492908,
            53.39669,
            63.947277
          ],
          [
            14.492711,
            53.396521,
            64.513167
          ],
          [
            14.492524,
            53.396352,
            64.376279
          ],
          [
            14.492315,
            53.396158,
            64.220382
          ],
          [
            14.492126,
            53.395989,
            64.082976
          ],
          [
            14.491914,
            53.395817,
            63.938063
          ],
          [
            14.491726,
            53.395665,
            63.810371
          ],
          [
            14.491542,
            53.395509,
            63.681417
          ],
          [
            14.491356,
            53.39534,
            63.54474
          ],
          [
            14.491116,
            53.395185,
            63.402083
          ],
          [
            14.490915,
            53.395006,
            63.38503
          ],
          [
            14.490727,
            53.394821,
            63.59742
          ],
          [
            14.490514,
            53.394681,
            63.781462
          ],
          [
            14.490263,
            53.394629,
            63.962976
          ],
          [
            14.489979,
            53.394518,
            64.162598
          ],
          [
            14.489781,
            53.394322,
            64.383973
          ],
          [
            14.489562,
            53.394148,
            64.59444
          ],
          [
            14.489341,
            53.393961,
            64.815595
          ],
          [
            14.489153,
            53.393812,
            64.996489
          ],
          [
            14.488958,
            53.39361,
            64.881634
          ],
          [
            14.488791,
            53.393436,
            64.697369
          ],
          [
            14.488581,
            53.393282,
            64.514936
          ],
          [
            14.488343,
            53.393122,
            64.316666
          ],
          [
            14.48813,
            53.392935,
            64.108893
          ],
          [
            14.487915,
            53.392729,
            63.885844
          ],
          [
            14.487695,
            53.392535,
            63.670563
          ],
          [
            14.487481,
            53.392319,
            63.439969
          ],
          [
            14.487269,
            53.392103,
            63.146498
          ],
          [
            14.487032,
            53.39194,
            62.879882
          ],
          [
            14.48683,
            53.391766,
            62.618651
          ],
          [
            14.486628,
            53.391593,
            62.358511
          ],
          [
            14.486435,
            53.391414,
            62.095224
          ],
          [
            14.486252,
            53.39124,
            61.841658
          ],
          [
            14.486033,
            53.391095,
            61.59572
          ],
          [
            14.48584,
            53.390917,
            61.3342
          ],
          [
            14.48565,
            53.390749,
            61.210651
          ],
          [
            14.485439,
            53.390569,
            61.31386
          ],
          [
            14.48524,
            53.390367,
            61.423958
          ],
          [
            14.485064,
            53.390194,
            61.519058
          ],
          [
            14.484892,
            53.39003,
            61.609953
          ],
          [
            14.484664,
            53.389869,
            61.709008
          ],
          [
            14.484393,
            53.389706,
            61.817547
          ],
          [
            14.484219,
            53.389544,
            61.909443
          ],
          [
            14.484069,
            53.389363,
            62.004511
          ],
          [
            14.483913,
            53.389164,
            62.168563
          ],
          [
            14.483754,
            53.388967,
            62.343025
          ],
          [
            14.483652,
            53.388757,
            62.519514
          ],
          [
            14.483634,
            53.388568,
            62.672115
          ],
          [
            14.483483,
            53.388385,
            62.834896
          ],
          [
            14.483317,
            53.388175,
            63.020154
          ],
          [
            14.483166,
            53.387979,
            63.192356
          ],
          [
            14.483011,
            53.387796,
            63.355866
          ],
          [
            14.482784,
            53.38764,
            63.451947
          ],
          [
            14.482616,
            53.387459,
            63.443904
          ],
          [
            14.482446,
            53.387275,
            63.435746
          ],
          [
            14.482291,
            53.387064,
            63.4268
          ],
          [
            14.482129,
            53.386883,
            63.418829
          ],
          [
            14.481964,
            53.386702,
            63.410828
          ],
          [
            14.481833,
            53.386532,
            63.403563
          ],
          [
            14.481711,
            53.386348,
            63.395879
          ],
          [
            14.481539,
            53.386155,
            63.387391
          ],
          [
            14.481378,
            53.385957,
            63.284298
          ],
          [
            14.481238,
            53.385767,
            63.158416
          ],
          [
            14.481123,
            53.38558,
            63.0376
          ],
          [
            14.480985,
            53.385402,
            62.91864
          ],
          [
            14.480827,
            53.385209,
            62.788253
          ],
          [
            14.480666,
            53.384983,
            62.638921
          ],
          [
            14.480492,
            53.384787,
            62.504001
          ],
          [
            14.480294,
            53.384581,
            62.359964
          ],
          [
            14.480135,
            53.384348,
            62.07816
          ],
          [
            14.47998,
            53.38414,
            61.734989
          ],
          [
            14.479818,
            53.383938,
            61.397375
          ],
          [
            14.479673,
            53.383719,
            61.041492
          ],
          [
            14.479482,
            53.383512,
            60.685089
          ],
          [
            14.479323,
            53.383297,
            60.330775
          ],
          [
            14.479159,
            53.383101,
            60.000415
          ],
          [
            14.478996,
            53.382907,
            59.673241
          ],
          [
            14.478844,
            53.382725,
            59.826876
          ],
          [
            14.478718,
            53.38253,
            60.182714
          ],
          [
            14.478581,
            53.382361,
            60.501951
          ],
          [
            14.478428,
            53.382174,
            60.855833
          ],
          [
            14.478304,
            53.381992,
            61.18993
          ],
          [
            14.478152,
            53.381807,
            61.540349
          ],
          [
            14.478034,
            53.381626,
            61.870728
          ],
          [
            14.477877,
            53.381457,
            62.199324
          ],
          [
            14.477794,
            53.381284,
            62.508514
          ],
          [
            14.478134,
            53.381265,
            62.739449
          ],
          [
            14.47801,
            53.381091,
            62.882152
          ],
          [
            14.477849,
            53.380884,
            63.051139
          ],
          [
            14.477701,
            53.380716,
            63.191613
          ],
          [
            14.477548,
            53.380538,
            63.339738
          ],
          [
            14.477405,
            53.380346,
            63.495257
          ],
          [
            14.477294,
            53.38016,
            63.641381
          ],
          [
            14.477146,
            53.379957,
            63.805236
          ],
          [
            14.477014,
            53.37977,
            63.955381
          ],
          [
            14.476878,
            53.379584,
            64.322682
          ],
          [
            14.476736,
            53.37938,
            64.752787
          ],
          [
            14.476601,
            53.37921,
            65.119254
          ],
          [
            14.47647,
            53.379036,
            65.490724
          ],
          [
            14.476333,
            53.378863,
            65.863493
          ],
          [
            14.476195,
            53.378701,
            66.217328
          ],
          [
            14.476066,
            53.378522,
            66.596705
          ],
          [
            14.47592,
            53.37834,
            66.989843
          ],
          [
            14.475789,
            53.378156,
            67.379145
          ],
          [
            14.475636,
            53.377962,
            67.542717
          ],
          [
            14.475497,
            53.377778,
            67.626177
          ],
          [
            14.475323,
            53.377589,
            67.715129
          ],
          [
            14.475134,
            53.377416,
            67.800304
          ],
          [
            14.474942,
            53.377258,
            67.880716
          ],
          [
            14.474763,
            53.377091,
            67.962392
          ],
          [
            14.474561,
            53.376904,
            68.054065
          ],
          [
            14.474391,
            53.376714,
            68.143223
          ],
          [
            14.474205,
            53.376523,
            68.188199
          ],
          [
            14.474014,
            53.376351,
            68.063015
          ],
          [
            14.473836,
            53.376193,
            67.947512
          ],
          [
            14.473662,
            53.376006,
            67.817718
          ],
          [
            14.473504,
            53.375816,
            67.688974
          ],
          [
            14.473373,
            53.375625,
            67.563753
          ],
          [
            14.473271,
            53.375444,
            67.447907
          ],
          [
            14.473149,
            53.375245,
            67.31922
          ],
          [
            14.473058,
            53.375057,
            67.200337
          ],
          [
            14.472999,
            53.374873,
            67.211724
          ],
          [
            14.472967,
            53.37465,
            67.523229
          ],
          [
            14.472891,
            53.374443,
            67.818222
          ],
          [
            14.472897,
            53.374233,
            68.110846
          ],
          [
            14.472919,
            53.374032,
            68.391715
          ],
          [
            14.472893,
            53.373841,
            68.65856
          ],
          [
            14.472744,
            53.373668,
            68.947626
          ],
          [
            14.472748,
            53.373456,
            69.242483
          ],
          [
            14.47277,
            53.373233,
            69.553134
          ],
          [
            14.472762,
            53.373013,
            69.914983
          ],
          [
            14.472776,
            53.372809,
            70.267193
          ],
          [
            14.472792,
            53.372581,
            70.660751
          ],
          [
            14.472669,
            53.37242,
            70.995435
          ],
          [
            14.472593,
            53.372233,
            71.327221
          ],
          [
            14.472562,
            53.372031,
            71.679372
          ],
          [
            14.472586,
            53.37184,
            72.009702
          ],
          [
            14.472589,
            53.371644,
            72.347564
          ],
          [
            14.472588,
            53.371452,
            72.678495
          ],
          [
            14.472596,
            53.371247,
            72.585469
          ],
          [
            14.472566,
            53.371048,
            72.427192
          ],
          [
            14.472575,
            53.370846,
            72.267418
          ],
          [
            14.472582,
            53.370626,
            72.093439
          ],
          [
            14.472604,
            53.370401,
            71.915236
          ],
          [
            14.472605,
            53.370196,
            71.753117
          ],
          [
            14.472598,
            53.370006,
            71.602819
          ],
          [
            14.472613,
            53.369813,
            71.450057
          ],
          [
            14.472625,
            53.36961,
            71.291315
          ],
          [
            14.472648,
            53.369418,
            71.158988
          ],
          [
            14.472677,
            53.369223,
            71.0244
          ],
          [
            14.472673,
            53.369028,
            70.890256
          ],
          [
            14.472688,
            53.368833,
            70.756068
          ],
          [
            14.472687,
            53.368643,
            70.625314
          ],
          [
            14.472714,
            53.368446,
            70.489302
          ],
          [
            14.472725,
            53.368228,
            70.339374
          ],
          [
            14.47273,
            53.367989,
            70.175071
          ],
          [
            14.472758,
            53.367768,
            69.967614
          ],
          [
            14.472791,
            53.367533,
            69.606226
          ],
          [
            14.472795,
            53.367328,
            69.291918
          ],
          [
            14.472814,
            53.367121,
            68.974051
          ],
          [
            14.472836,
            53.366876,
            68.59815
          ],
          [
            14.472862,
            53.36669,
            68.311716
          ],
          [
            14.472839,
            53.366432,
            67.914784
          ],
          [
            14.472797,
            53.366215,
            67.578621
          ],
          [
            14.472798,
            53.365974,
            67.399957
          ],
          [
            14.472814,
            53.365728,
            67.717727
          ],
          [
            14.472839,
            53.365486,
            68.030787
          ],
          [
            14.472828,
            53.365277,
            68.300968
          ],
          [
            14.47279,
            53.365011,
            68.646172
          ],
          [
            14.472669,
            53.364767,
            68.97458
          ],
          [
            14.472505,
            53.364566,
            69.263159
          ],
          [
            14.472373,
            53.364393,
            69.509179
          ],
          [
            14.472259,
            53.364215,
            70.16378
          ],
          [
            14.472176,
            53.364036,
            71.21401
          ],
          [
            14.472096,
            53.363832,
            72.399222
          ],
          [
            14.471953,
            53.363666,
            73.456954
          ],
          [
            14.471785,
            53.363487,
            74.616283
          ],
          [
            14.471603,
            53.36331,
            75.790472
          ],
          [
            14.471384,
            53.363143,
            76.98978
          ],
          [
            14.471171,
            53.363,
            78.071058
          ],
          [
            14.470961,
            53.362839,
            79.224824
          ],
          [
            14.470745,
            53.362683,
            79.902748
          ],
          [
            14.470561,
            53.36252,
            80.107006
          ],
          [
            14.470343,
            53.362377,
            80.307952
          ],
          [
            14.470131,
            53.362218,
            80.519119
          ],
          [
            14.469894,
            53.362069,
            80.732798
          ],
          [
            14.469678,
            53.361926,
            80.932931
          ],
          [
            14.469451,
            53.361767,
            81.151064
          ],
          [
            14.469232,
            53.361594,
            81.376528
          ],
          [
            14.469039,
            53.361448,
            81.570297
          ],
          [
            14.46883,
            53.361304,
            81.767301
          ],
          [
            14.468624,
            53.361155,
            81.966203
          ],
          [
            14.468426,
            53.360993,
            82.172581
          ],
          [
            14.468181,
            53.36083,
            82.398019
          ],
          [
            14.467982,
            53.360692,
            82.585447
          ],
          [
            14.467721,
            53.36052,
            82.824664
          ],
          [
            14.467517,
            53.36038,
            83.015622
          ],
          [
            14.467311,
            53.360232,
            83.213656
          ],
          [
            14.467053,
            53.36006,
            83.451255
          ],
          [
            14.466851,
            53.359922,
            83.713237
          ],
          [
            14.466614,
            53.359762,
            84.065732
          ],
          [
            14.466388,
            53.3596,
            84.4136
          ],
          [
            14.466144,
            53.35943,
            84.782878
          ],
          [
            14.465932,
            53.359281,
            85.105366
          ],
          [
            14.465715,
            53.359132,
            85.431053
          ],
          [
            14.465474,
            53.35896,
            85.801175
          ],
          [
            14.465251,
            53.358801,
            86.143259
          ],
          [
            14.465017,
            53.358614,
            86.49755
          ],
          [
            14.464804,
            53.358427,
            86.601929
          ],
          [
            14.464632,
            53.358235,
            86.702644
          ],
          [
            14.464492,
            53.358045,
            86.798562
          ],
          [
            14.464326,
            53.35784,
            86.903692
          ],
          [
            14.464194,
            53.357666,
            86.991856
          ],
          [
            14.464064,
            53.357498,
            87.077279
          ],
          [
            14.463933,
            53.357324,
            87.165337
          ],
          [
            14.463785,
            53.357123,
            87.266711
          ],
          [
            14.463631,
            53.356936,
            87.505524
          ],
          [
            14.463486,
            53.356748,
            87.889283
          ],
          [
            14.463346,
            53.356566,
            88.260793
          ],
          [
            14.463196,
            53.356386,
            88.633945
          ],
          [
            14.463088,
            53.356206,
            88.988496
          ],
          [
            14.462955,
            53.356016,
            89.37036
          ],
          [
            14.462792,
            53.355805,
            89.801192
          ],
          [
            14.462658,
            53.355617,
            90.180592
          ],
          [
            14.462506,
            53.355433,
            90.561529
          ],
          [
            14.462362,
            53.355243,
            90.803923
          ],
          [
            14.462237,
            53.355069,
            90.984471
          ],
          [
            14.462083,
            53.354911,
            91.158788
          ],
          [
            14.461903,
            53.354733,
            91.357114
          ],
          [
            14.461759,
            53.354552,
            91.548368
          ],
          [
            14.461669,
            53.354361,
            91.737577
          ],
          [
            14.461548,
            53.354179,
            91.924302
          ],
          [
            14.461387,
            53.353976,
            92.138494
          ],
          [
            14.461247,
            53.353784,
            92.338235
          ],
          [
            14.461048,
            53.353614,
            92.747536
          ],
          [
            14.460876,
            53.353418,
            93.219414
          ],
          [
            14.460728,
            53.353231,
            93.660518
          ],
          [
            14.460547,
            53.353048,
            94.113782
          ],
          [
            14.460421,
            53.352843,
            94.579502
          ],
          [
            14.460284,
            53.352642,
            95.042623
          ],
          [
            14.460153,
            53.352462,
            95.461238
          ],
          [
            14.460016,
            53.352279,
            95.88873
          ],
          [
            14.459929,
            53.352071,
            96.402753
          ],
          [
            14.459749,
            53.351884,
            97.046411
          ],
          [
            14.459585,
            53.351713,
            97.632776
          ],
          [
            14.459466,
            53.351529,
            98.219165
          ],
          [
            14.459322,
            53.351336,
            98.847275
          ],
          [
            14.45919,
            53.351168,
            99.399039
          ],
          [
            14.459061,
            53.350988,
            99.981093
          ],
          [
            14.458898,
            53.35083,
            100.535007
          ],
          [
            14.458702,
            53.350661,
            101.146164
          ],
          [
            14.458449,
            53.350452,
            101.296504
          ],
          [
            14.458224,
            53.350274,
            100.83865
          ],
          [
            14.457935,
            53.350081,
            100.306551
          ],
          [
            14.457689,
            53.34993,
            99.874029
          ],
          [
            14.457416,
            53.349746,
            99.369485
          ],
          [
            14.457181,
            53.349562,
            98.894572
          ],
          [
            14.45697,
            53.349417,
            98.49937
          ],
          [
            14.456737,
            53.34928,
            98.098548
          ],
          [
            14.456491,
            53.349152,
            97.575312
          ],
          [
            14.456281,
            53.349002,
            96.877806
          ],
          [
            14.456048,
            53.348847,
            96.134713
          ],
          [
            14.4558,
            53.348699,
            95.387859
          ],
          [
            14.455584,
            53.348542,
            94.662725
          ],
          [
            14.455306,
            53.348386,
            93.849345
          ],
          [
            14.455053,
            53.348228,
            93.069541
          ],
          [
            14.454832,
            53.34805,
            92.279076
          ],
          [
            14.454591,
            53.347894,
            91.521883
          ],
          [
            14.45434,
            53.34774,
            91.331598
          ],
          [
            14.454079,
            53.347586,
            91.207719
          ],
          [
            14.453877,
            53.347449,
            91.104534
          ],
          [
            14.453596,
            53.34726,
            90.961768
          ],
          [
            14.453391,
            53.347126,
            90.859267
          ],
          [
            14.453133,
            53.346936,
            90.720865
          ],
          [
            14.452918,
            53.346788,
            90.610154
          ],
          [
            14.45267,
            53.346642,
            90.492204
          ],
          [
            14.452422,
            53.346486,
            90.20487
          ],
          [
            14.452159,
            53.346315,
            89.668345
          ],
          [
            14.451892,
            53.346121,
            89.088215
          ],
          [
            14.451637,
            53.345929,
            88.52213
          ],
          [
            14.451365,
            53.345744,
            87.953338
          ],
          [
            14.451098,
            53.345582,
            87.428209
          ],
          [
            14.450856,
            53.34541,
            86.909237
          ],
          [
            14.450594,
            53.345252,
            86.395266
          ],
          [
            14.450349,
            53.345096,
            86.234225
          ],
          [
            14.450116,
            53.344944,
            86.18886
          ],
          [
            14.449883,
            53.344801,
            86.144939
          ],
          [
            14.449657,
            53.344651,
            86.100509
          ],
          [
            14.449432,
            53.344516,
            86.05848
          ],
          [
            14.449189,
            53.344357,
            86.010924
          ],
          [
            14.448936,
            53.344175,
            85.958852
          ],
          [
            14.448659,
            53.343984,
            85.903203
          ],
          [
            14.448378,
            53.34379,
            85.599811
          ],
          [
            14.44813,
            53.343607,
            85.067955
          ],
          [
            14.447842,
            53.343456,
            84.550848
          ],
          [
            14.447594,
            53.343306,
            84.074025
          ],
          [
            14.447325,
            53.343192,
            83.628921
          ],
          [
            14.447019,
            53.343139,
            83.198253
          ],
          [
            14.446692,
            53.343147,
            82.754453
          ],
          [
            14.446455,
            53.343014,
            82.305937
          ],
          [
            14.446221,
            53.34285,
            81.812201
          ],
          [
            14.445984,
            53.34271,
            81.361356
          ],
          [
            14.445714,
            53.342549,
            80.84356
          ],
          [
            14.445639,
            53.342321,
            80.316149
          ],
          [
            14.445599,
            53.342137,
            79.895941
          ],
          [
            14.445469,
            53.34195,
            79.429351
          ],
          [
            14.445215,
            53.341781,
            78.91422
          ],
          [
            14.444968,
            53.341586,
            78.360114
          ],
          [
            14.444711,
            53.341409,
            77.829551
          ],
          [
            14.444498,
            53.341231,
            77.96267
          ],
          [
            14.444266,
            53.341033,
            78.271749
          ],
          [
            14.444013,
            53.340852,
            78.570658
          ],
          [
            14.443767,
            53.340686,
            78.851697
          ],
          [
            14.443532,
            53.340534,
            79.113979
          ],
          [
            14.443295,
            53.340368,
            79.390593
          ],
          [
            14.443031,
            53.340192,
            79.690154
          ],
          [
            14.442817,
            53.340053,
            79.929542
          ],
          [
            14.442592,
            53.339919,
            79.918798
          ],
          [
            14.442369,
            53.339761,
            79.751492
          ],
          [
            14.442155,
            53.339629,
            79.602944
          ],
          [
            14.441921,
            53.339483,
            79.439505
          ],
          [
            14.441691,
            53.33933,
            79.273277
          ],
          [
            14.441463,
            53.339176,
            79.107052
          ],
          [
            14.44124,
            53.339034,
            78.949367
          ],
          [
            14.440999,
            53.338863,
            78.768673
          ],
          [
            14.440751,
            53.338702,
            78.591769
          ],
          [
            14.440518,
            53.338543,
            78.149897
          ],
          [
            14.440271,
            53.338377,
            77.626579
          ],
          [
            14.440025,
            53.338219,
            77.117788
          ],
          [
            14.439842,
            53.338061,
            76.664105
          ],
          [
            14.439602,
            53.33791,
            76.173488
          ],
          [
            14.439355,
            53.337754,
            75.667214
          ],
          [
            14.439085,
            53.337596,
            75.134763
          ],
          [
            14.438873,
            53.337466,
            74.705279
          ],
          [
            14.438709,
            53.337313,
            74.351198
          ],
          [
            14.4386,
            53.337128,
            74.618894
          ],
          [
            14.438451,
            53.336935,
            74.908771
          ],
          [
            14.438335,
            53.336755,
            75.17194
          ],
          [
            14.438208,
            53.336581,
            75.430969
          ],
          [
            14.438081,
            53.336386,
            75.717731
          ],
          [
            14.437845,
            53.336203,
            76.032801
          ],
          [
            14.437536,
            53.336068,
            76.344979
          ],
          [
            14.437244,
            53.335947,
            76.634616
          ],
          [
            14.436974,
            53.335822,
            76.370654
          ],
          [
            14.4367,
            53.335694,
            75.521301
          ],
          [
            14.436444,
            53.335552,
            74.672078
          ],
          [
            14.436183,
            53.335455,
            73.917917
          ],
          [
            14.435921,
            53.335357,
            73.165057
          ],
          [
            14.435964,
            53.335261,
            72.394185
          ],
          [
            14.436241,
            53.33537,
            71.58019
          ],
          [
            14.436493,
            53.335508,
            70.749205
          ],
          [
            14.436721,
            53.33564,
            69.9771
          ],
          [
            14.437005,
            53.3358,
            69.514747
          ],
          [
            14.437253,
            53.33591,
            69.612072
          ],
          [
            14.437551,
            53.336022,
            69.72294
          ],
          [
            14.437874,
            53.335952,
            69.833434
          ],
          [
            14.438201,
            53.335838,
            69.952658
          ],
          [
            14.438498,
            53.335733,
            70.06136
          ],
          [
            14.438791,
            53.335603,
            70.1766
          ],
          [
            14.439068,
            53.335472,
            70.287861
          ],
          [
            14.439353,
            53.335332,
            70.404153
          ],
          [
            14.439643,
            53.335211,
            70.303384
          ],
          [
            14.439909,
            53.335098,
            70.204543
          ],
          [
            14.440184,
            53.334997,
            70.106786
          ],
          [
            14.440479,
            53.334867,
            69.995761
          ],
          [
            14.440795,
            53.334721,
            69.874788
          ],
          [
            14.441104,
            53.334599,
            69.762612
          ],
          [
            14.441408,
            53.334429,
            69.636099
          ],
          [
            14.441694,
            53.334232,
            69.503676
          ],
          [
            14.441891,
            53.334093,
            69.600907
          ],
          [
            14.442157,
            53.333914,
            69.753046
          ],
          [
            14.442401,
            53.333777,
            69.880182
          ],
          [
            14.442706,
            53.33364,
            70.025076
          ],
          [
            14.442967,
            53.33349,
            70.162606
          ],
          [
            14.443247,
            53.333313,
            70.319397
          ],
          [
            14.443439,
            53.333102,
            70.472179
          ],
          [
            14.443615,
            53.332892,
            70.621576
          ],
          [
            14.443733,
            53.332706,
            69.922118
          ],
          [
            14.443912,
            53.332498,
            68.942284
          ],
          [
            14.444079,
            53.332327,
            68.116285
          ],
          [
            14.444221,
            53.332133,
            67.232984
          ],
          [
            14.444365,
            53.331957,
            66.415771
          ],
          [
            14.444521,
            53.331775,
            65.561914
          ],
          [
            14.44466,
            53.331601,
            64.756787
          ],
          [
            14.444803,
            53.331438,
            63.988289
          ],
          [
            14.444998,
            53.331199,
            63.208388
          ],
          [
            14.445193,
            53.331049,
            63.434696
          ],
          [
            14.445357,
            53.330887,
            63.660303
          ],
          [
            14.445556,
            53.330721,
            63.903564
          ],
          [
            14.445768,
            53.330527,
            64.181094
          ],
          [
            14.445972,
            53.330338,
            64.448902
          ],
          [
            14.446159,
            53.330178,
            64.681336
          ],
          [
            14.446292,
            53.330004,
            64.911545
          ],
          [
            14.446307,
            53.329844,
            65.13058
          ],
          [
            14.446516,
            53.329677,
            65.190426
          ],
          [
            14.446627,
            53.329492,
            64.989276
          ],
          [
            14.446698,
            53.329268,
            64.757349
          ],
          [
            14.446777,
            53.329017,
            64.49743
          ],
          [
            14.446865,
            53.328806,
            64.276084
          ],
          [
            14.446938,
            53.328579,
            64.040891
          ],
          [
            14.447015,
            53.328403,
            63.855828
          ],
          [
            14.447074,
            53.328163,
            63.60883
          ],
          [
            14.447201,
            53.327921,
            63.779666
          ],
          [
            14.447258,
            53.327685,
            64.614435
          ],
          [
            14.447356,
            53.327452,
            65.453128
          ],
          [
            14.447477,
            53.327229,
            66.271736
          ],
          [
            14.447567,
            53.327015,
            67.041949
          ],
          [
            14.447651,
            53.326818,
            67.751528
          ],
          [
            14.44771,
            53.326625,
            68.438682
          ],
          [
            14.447787,
            53.326423,
            69.16186
          ],
          [
            14.447899,
            53.326202,
            69.923003
          ],
          [
            14.447957,
            53.326019,
            70.451126
          ],
          [
            14.448008,
            53.325826,
            71.005436
          ],
          [
            14.448053,
            53.32563,
            71.566608
          ],
          [
            14.448105,
            53.325418,
            72.177605
          ],
          [
            14.448265,
            53.325232,
            72.770469
          ],
          [
            14.448379,
            53.324953,
            73.584909
          ],
          [
            14.448444,
            53.32475,
            74.170937
          ],
          [
            14.448479,
            53.324529,
            74.800239
          ],
          [
            14.448509,
            53.324328,
            74.853284
          ],
          [
            14.448527,
            53.324107,
            74.886568
          ],
          [
            14.448448,
            53.323861,
            74.924579
          ],
          [
            14.448304,
            53.323629,
            74.961799
          ],
          [
            14.448173,
            53.32339,
            74.999626
          ],
          [
            14.448021,
            53.323142,
            75.039432
          ],
          [
            14.447898,
            53.322915,
            75.075393
          ],
          [
            14.447779,
            53.322719,
            75.236841
          ],
          [
            14.447664,
            53.322537,
            75.583157
          ],
          [
            14.447597,
            53.322348,
            75.92719
          ],
          [
            14.447534,
            53.322159,
            76.27015
          ],
          [
            14.447478,
            53.321978,
            76.597583
          ],
          [
            14.447367,
            53.321772,
            76.982606
          ],
          [
            14.447264,
            53.321582,
            77.337897
          ],
          [
            14.447144,
            53.321369,
            77.737811
          ],
          [
            14.447026,
            53.321167,
            78.118561
          ],
          [
            14.446928,
            53.32097,
            78.315257
          ],
          [
            14.446806,
            53.320769,
            78.357337
          ],
          [
            14.446685,
            53.320554,
            78.40199
          ],
          [
            14.446589,
            53.32034,
            78.44558
          ],
          [
            14.4465,
            53.320138,
            78.486676
          ],
          [
            14.446414,
            53.319925,
            78.529789
          ],
          [
            14.446325,
            53.319679,
            78.579313
          ],
          [
            14.446218,
            53.319446,
            78.626847
          ],
          [
            14.446125,
            53.319219,
            78.539193
          ],
          [
            14.446027,
            53.319006,
            78.347975
          ],
          [
            14.445957,
            53.318782,
            78.150744
          ],
          [
            14.445879,
            53.31856,
            77.954395
          ],
          [
            14.445788,
            53.318345,
            77.76203
          ],
          [
            14.445695,
            53.318106,
            77.549671
          ],
          [
            14.445604,
            53.317849,
            77.322312
          ],
          [
            14.44551,
            53.317625,
            77.122439
          ],
          [
            14.445433,
            53.317409,
            77.267683
          ],
          [
            14.445365,
            53.317213,
            77.458678
          ],
          [
            14.445281,
            53.317026,
            77.643048
          ],
          [
            14.445185,
            53.316787,
            77.876967
          ],
          [
            14.44508,
            53.316552,
            78.108467
          ],
          [
            14.444979,
            53.316304,
            78.351606
          ],
          [
            14.444882,
            53.316071,
            78.580343
          ],
          [
            14.444769,
            53.315816,
            78.780939
          ],
          [
            14.444664,
            53.315575,
            78.595899
          ],
          [
            14.444536,
            53.315372,
            78.434609
          ],
          [
            14.444434,
            53.315173,
            78.27998
          ],
          [
            14.444369,
            53.314992,
            78.142415
          ],
          [
            14.444292,
            53.314786,
            77.985479
          ],
          [
            14.444177,
            53.31458,
            77.824135
          ],
          [
            14.444101,
            53.314387,
            77.676821
          ],
          [
            14.444016,
            53.314174,
            77.514086
          ],
          [
            14.443919,
            53.313963,
            77.539702
          ],
          [
            14.443853,
            53.313758,
            77.637381
          ],
          [
            14.443765,
            53.313543,
            77.740986
          ],
          [
            14.443681,
            53.313345,
            77.836823
          ],
          [
            14.443583,
            53.313125,
            77.943346
          ],
          [
            14.443462,
            53.312901,
            78.053532
          ],
          [
            14.443339,
            53.31271,
            78.149403
          ],
          [
            14.44315,
            53.312506,
            78.258586
          ],
          [
            14.443032,
            53.31234,
            78.233759
          ],
          [
            14.442866,
            53.312148,
            78.01488
          ],
          [
            14.442633,
            53.31194,
            77.761069
          ],
          [
            14.442316,
            53.311836,
            77.54181
          ],
          [
            14.441945,
            53.311761,
            77.304636
          ],
          [
            14.441595,
            53.311658,
            77.068559
          ],
          [
            14.441265,
            53.311544,
            76.838007
          ],
          [
            14.440996,
            53.311433,
            76.640107
          ],
          [
            14.440701,
            53.31129,
            76.376276
          ],
          [
            14.440457,
            53.311173,
            76.102513
          ],
          [
            14.440121,
            53.311064,
            75.770643
          ],
          [
            14.439808,
            53.310951,
            75.453226
          ],
          [
            14.439538,
            53.310844,
            75.171006
          ],
          [
            14.439228,
            53.310737,
            74.860271
          ],
          [
            14.438907,
            53.310624,
            74.536881
          ],
          [
            14.438617,
            53.310522,
            74.244538
          ],
          [
            14.438349,
            53.310404,
            73.955548
          ],
          [
            14.438044,
            53.310286,
            73.644004
          ],
          [
            14.437843,
            53.310142,
            73.369457
          ],
          [
            14.437685,
            53.309956,
            73.071347
          ],
          [
            14.437508,
            53.309756,
            72.747933
          ],
          [
            14.437234,
            53.309544,
            72.364889
          ],
          [
            14.436993,
            53.309383,
            72.056093
          ],
          [
            14.436813,
            53.309221,
            71.776639
          ],
          [
            14.436833,
            53.308953,
            71.392807
          ],
          [
            14.43685,
            53.308759,
            71.29262
          ],
          [
            14.436781,
            53.30856,
            71.274092
          ],
          [
            14.436652,
            53.308342,
            71.253102
          ],
          [
            14.436531,
            53.30812,
            71.231905
          ],
          [
            14.43633,
            53.307925,
            71.211121
          ],
          [
            14.436166,
            53.307734,
            71.191626
          ],
          [
            14.435966,
            53.307541,
            71.171028
          ],
          [
            14.435752,
            53.30739,
            71.15307
          ],
          [
            14.435582,
            53.307205,
            71.328419
          ],
          [
            14.435398,
            53.307027,
            71.776108
          ],
          [
            14.435221,
            53.306862,
            72.196485
          ],
          [
            14.435049,
            53.306673,
            72.657787
          ],
          [
            14.434863,
            53.306495,
            73.107726
          ],
          [
            14.434687,
            53.306323,
            73.53917
          ],
          [
            14.434554,
            53.306129,
            73.987779
          ],
          [
            14.434427,
            53.305947,
            74.409766
          ],
          [
            14.434318,
            53.305746,
            74.862103
          ],
          [
            14.434226,
            53.305522,
            75.097841
          ],
          [
            14.43418,
            53.305313,
            75.230467
          ],
          [
            14.43416,
            53.305109,
            75.358873
          ],
          [
            14.434156,
            53.30491,
            75.48415
          ],
          [
            14.434179,
            53.304694,
            75.620177
          ],
          [
            14.43418,
            53.304469,
            75.761697
          ],
          [
            14.434161,
            53.304261,
            75.892626
          ],
          [
            14.434186,
            53.304059,
            76.019949
          ],
          [
            14.434156,
            53.303841,
            76.112098
          ],
          [
            14.434119,
            53.303638,
            76.081927
          ],
          [
            14.434129,
            53.303415,
            76.04897
          ],
          [
            14.434132,
            53.303187,
            76.015281
          ],
          [
            14.434147,
            53.302967,
            75.982789
          ],
          [
            14.434139,
            53.302756,
            75.951552
          ],
          [
            14.434116,
            53.302569,
            75.92387
          ],
          [
            14.434108,
            53.302351,
            75.891693
          ],
          [
            14.434108,
            53.302149,
            75.861882
          ],
          [
            14.434099,
            53.301923,
            75.462414
          ],
          [
            14.434091,
            53.301681,
            74.939014
          ],
          [
            14.434071,
            53.301431,
            74.397637
          ],
          [
            14.434047,
            53.301241,
            73.9856
          ],
          [
            14.434084,
            53.301034,
            73.535442
          ],
          [
            14.434096,
            53.300828,
            73.089683
          ],
          [
            14.434079,
            53.300631,
            72.663033
          ],
          [
            14.434064,
            53.300364,
            72.085287
          ],
          [
            14.434062,
            53.300112,
            72.022944
          ],
          [
            14.434061,
            53.299867,
            72.093869
          ],
          [
            14.434047,
            53.299639,
            72.159894
          ],
          [
            14.434051,
            53.299423,
            72.222442
          ],
          [
            14.434001,
            53.299195,
            72.28898
          ],
          [
            14.434013,
            53.298966,
            72.355523
          ],
          [
            14.434008,
            53.298747,
            72.418901
          ],
          [
            14.434008,
            53.298513,
            72.485073
          ],
          [
            14.434,
            53.298303,
            72.145551
          ],
          [
            14.433988,
            53.298092,
            71.804181
          ],
          [
            14.433957,
            53.297894,
            71.482863
          ],
          [
            14.433958,
            53.297673,
            71.124974
          ],
          [
            14.433958,
            53.297444,
            70.75493
          ],
          [
            14.433959,
            53.297216,
            70.386089
          ],
          [
            14.433954,
            53.296985,
            70.012796
          ],
          [
            14.43395,
            53.296748,
            69.629733
          ],
          [
            14.43394,
            53.296486,
            69.310539
          ],
          [
            14.433956,
            53.296261,
            69.047792
          ],
          [
            14.434016,
            53.296036,
            68.781832
          ],
          [
            14.434133,
            53.295836,
            68.534543
          ],
          [
            14.434272,
            53.29561,
            68.253768
          ],
          [
            14.434363,
            53.295376,
            67.971918
          ],
          [
            14.43446,
            53.295136,
            67.684132
          ],
          [
            14.434536,
            53.294915,
            67.514843
          ],
          [
            14.434605,
            53.294695,
            67.641534
          ],
          [
            14.434661,
            53.294505,
            67.750739
          ],
          [
            14.434718,
            53.294278,
            67.880664
          ],
          [
            14.434775,
            53.294079,
            67.995101
          ],
          [
            14.434817,
            53.293869,
            68.114822
          ],
          [
            14.434887,
            53.293654,
            68.238823
          ],
          [
            14.434939,
            53.29344,
            68.361211
          ],
          [
            14.435005,
            53.293226,
            68.484372
          ],
          [
            14.435071,
            53.293022,
            68.826544
          ],
          [
            14.435158,
            53.292797,
            69.250915
          ],
          [
            14.435217,
            53.29258,
            69.654958
          ],
          [
            14.435276,
            53.292377,
            70.033889
          ],
          [
            14.435345,
            53.292159,
            70.441665
          ],
          [
            14.435401,
            53.291955,
            70.821582
          ],
          [
            14.435437,
            53.291727,
            71.242504
          ],
          [
            14.435524,
            53.291512,
            71.649
          ],
          [
            14.435577,
            53.291299,
            72.229931
          ],
          [
            14.435627,
            53.291072,
            72.977647
          ],
          [
            14.43572,
            53.290875,
            73.645875
          ],
          [
            14.435777,
            53.290688,
            74.265155
          ],
          [
            14.435828,
            53.290494,
            74.90518
          ],
          [
            14.435897,
            53.2903,
            75.552571
          ],
          [
            14.435957,
            53.290093,
            76.237441
          ],
          [
            14.436026,
            53.289887,
            76.922229
          ],
          [
            14.436084,
            53.289679,
            77.609083
          ],
          [
            14.43615,
            53.289476,
            77.717116
          ],
          [
            14.436201,
            53.289293,
            77.767327
          ],
          [
            14.436243,
            53.289081,
            77.825173
          ],
          [
            14.436231,
            53.288861,
            77.884746
          ],
          [
            14.436222,
            53.288635,
            77.94593
          ],
          [
            14.436242,
            53.288431,
            78.001234
          ],
          [
            14.436242,
            53.28822,
            78.058372
          ],
          [
            14.436267,
            53.288026,
            78.111082
          ],
          [
            14.436284,
            53.287811,
            78.20223
          ],
          [
            14.436297,
            53.28759,
            78.379696
          ],
          [
            14.436282,
            53.287381,
            78.547218
          ],
          [
            14.436282,
            53.287165,
            78.720353
          ],
          [
            14.436293,
            53.286934,
            78.905563
          ],
          [
            14.436279,
            53.286724,
            79.073805
          ],
          [
            14.436273,
            53.286511,
            79.244297
          ],
          [
            14.4363,
            53.286309,
            79.406502
          ],
          [
            14.436297,
            53.286107,
            79.568177
          ],
          [
            14.436301,
            53.285895,
            79.716894
          ],
          [
            14.436304,
            53.285695,
            79.853754
          ],
          [
            14.436319,
            53.285467,
            80.009902
          ],
          [
            14.436324,
            53.285255,
            80.154986
          ],
          [
            14.436303,
            53.285056,
            80.291502
          ],
          [
            14.436297,
            53.284848,
            80.43396
          ],
          [
            14.436279,
            53.284652,
            80.568411
          ],
          [
            14.436148,
            53.284466,
            80.708776
          ],
          [
            14.435903,
            53.284298,
            80.755182
          ],
          [
            14.435649,
            53.284179,
            80.523656
          ],
          [
            14.435398,
            53.284027,
            80.268477
          ],
          [
            14.435121,
            53.283867,
            79.99275
          ],
          [
            14.434862,
            53.283722,
            79.739326
          ],
          [
            14.434541,
            53.283551,
            79.430894
          ],
          [
            14.434352,
            53.283358,
            79.162007
          ],
          [
            14.434271,
            53.28315,
            78.906855
          ],
          [
            14.434014,
            53.282996,
            78.673134
          ],
          [
            14.433648,
            53.282948,
            78.665581
          ],
          [
            14.433298,
            53.28291,
            78.658419
          ],
          [
            14.432952,
            53.282843,
            78.651065
          ],
          [
            14.432556,
            53.282766,
            78.642673
          ],
          [
            14.432201,
            53.282705,
            78.635238
          ],
          [
            14.431788,
            53.282643,
            78.626652
          ],
          [
            14.431375,
            53.282567,
            78.617955
          ],
          [
            14.430995,
            53.282483,
            78.427257
          ],
          [
            14.430678,
            53.282332,
            78.013383
          ],
          [
            14.430594,
            53.282123,
            77.645736
          ],
          [
            14.430798,
            53.281883,
            77.191116
          ],
          [
            14.430979,
            53.281687,
            76.812905
          ],
          [
            14.431195,
            53.281483,
            76.405112
          ],
          [
            14.431409,
            53.281318,
            76.051298
          ],
          [
            14.431527,
            53.28113,
            75.7121
          ],
          [
            14.431661,
            53.280904,
            75.679183
          ],
          [
            14.431812,
            53.280695,
            75.825042
          ],
          [
            14.43196,
            53.280499,
            75.963285
          ],
          [
            14.432094,
            53.280332,
            76.082267
          ],
          [
            14.432258,
            53.280107,
            76.239499
          ],
          [
            14.432389,
            53.279868,
            76.401041
          ],
          [
            14.43245,
            53.27965,
            76.542636
          ],
          [
            14.432446,
            53.279403,
            76.702305
          ],
          [
            14.432412,
            53.279168,
            77.277795
          ],
          [
            14.432366,
            53.278938,
            77.932136
          ],
          [
            14.432317,
            53.278707,
            78.589845
          ],
          [
            14.432296,
            53.27848,
            79.232312
          ],
          [
            14.432269,
            53.278275,
            79.813345
          ],
          [
            14.432271,
            53.278071,
            80.389877
          ],
          [
            14.432273,
            53.277877,
            80.937812
          ],
          [
            14.432263,
            53.277675,
            81.508897
          ],
          [
            14.43231,
            53.277466,
            81.938608
          ],
          [
            14.432304,
            53.277244,
            82.213707
          ],
          [
            14.432306,
            53.277041,
            82.465248
          ],
          [
            14.432315,
            53.276834,
            82.72181
          ],
          [
            14.432305,
            53.276646,
            82.954932
          ],
          [
            14.432308,
            53.276459,
            83.187259
          ],
          [
            14.432281,
            53.276259,
            83.436173
          ],
          [
            14.432194,
            53.276076,
            83.675922
          ],
          [
            14.43182,
            53.276075,
            83.954228
          ],
          [
            14.43145,
            53.276091,
            83.831413
          ],
          [
            14.431076,
            53.276094,
            83.533755
          ],
          [
            14.430668,
            53.276093,
            83.208847
          ],
          [
            14.43024,
            53.276106,
            82.867664
          ],
          [
            14.42979,
            53.276125,
            82.508276
          ],
          [
            14.429443,
            53.276141,
            82.231246
          ],
          [
            14.429081,
            53.276147,
            81.942876
          ],
          [
            14.428767,
            53.276149,
            81.692983
          ],
          [
            14.428393,
            53.276158,
            81.169875
          ],
          [
            14.42797,
            53.276162,
            80.527116
          ],
          [
            14.427603,
            53.276168,
            79.970407
          ],
          [
            14.427246,
            53.276187,
            79.426901
          ],
          [
            14.426867,
            53.2762,
            78.851138
          ],
          [
            14.426532,
            53.276203,
            78.342602
          ],
          [
            14.426149,
            53.276213,
            77.761226
          ],
          [
            14.425758,
            53.276223,
            77.167624
          ],
          [
            14.425325,
            53.276238,
            76.754307
          ],
          [
            14.424887,
            53.276248,
            76.373104
          ],
          [
            14.424458,
            53.276267,
            75.998938
          ],
          [
            14.424059,
            53.276265,
            75.652022
          ],
          [
            14.423722,
            53.276273,
            75.358181
          ],
          [
            14.423397,
            53.276275,
            75.075257
          ],
          [
            14.423017,
            53.276288,
            74.744305
          ],
          [
            14.422705,
            53.276305,
            74.471591
          ],
          [
            14.42238,
            53.276312,
            74.781055
          ],
          [
            14.422039,
            53.276292,
            75.115828
          ],
          [
            14.421629,
            53.276209,
            75.537943
          ],
          [
            14.421369,
            53.276091,
            75.858791
          ],
          [
            14.421435,
            53.276066,
            76.258612
          ],
          [
            14.421744,
            53.275974,
            76.59528
          ],
          [
            14.422078,
            53.275854,
            76.975266
          ],
          [
            14.422372,
            53.275752,
            77.307526
          ],
          [
            14.422705,
            53.275629,
            77.871572
          ],
          [
            14.422977,
            53.275502,
            78.421421
          ],
          [
            14.423273,
            53.275388,
            78.981859
          ],
          [
            14.423511,
            53.275263,
            79.487008
          ],
          [
            14.423747,
            53.27512,
            80.02245
          ],
          [
            14.423988,
            53.274948,
            80.620366
          ],
          [
            14.424261,
            53.274783,
            81.238321
          ],
          [
            14.424528,
            53.274617,
            81.851617
          ],
          [
            14.42479,
            53.274457,
            82.2796
          ],
          [
            14.425065,
            53.274301,
            82.490712
          ],
          [
            14.425339,
            53.274141,
            82.704008
          ],
          [
            14.425619,
            53.273991,
            82.913383
          ],
          [
            14.42593,
            53.273851,
            83.1302
          ],
          [
            14.426221,
            53.273721,
            83.332568
          ],
          [
            14.426496,
            53.273598,
            83.523845
          ],
          [
            14.426821,
            53.273474,
            83.738572
          ],
          [
            14.427105,
            53.273409,
            83.847152
          ],
          [
            14.427442,
            53.273361,
            83.771836
          ],
          [
            14.427814,
            53.273329,
            83.690079
          ],
          [
            14.428199,
            53.273293,
            83.605374
          ],
          [
            14.428517,
            53.273243,
            83.533687
          ],
          [
            14.42887,
            53.273162,
            83.451328
          ],
          [
            14.429192,
            53.27303,
            83.366262
          ],
          [
            14.429474,
            53.272885,
            83.285418
          ],
          [
            14.429755,
            53.272745,
            83.229821
          ],
          [
            14.430087,
            53.272616,
            83.59891
          ],
          [
            14.430316,
            53.27246,
            83.922665
          ],
          [
            14.430389,
            53.272283,
            84.209973
          ],
          [
            14.430303,
            53.272081,
            84.536163
          ],
          [
            14.430289,
            53.271894,
            84.828919
          ],
          [
            14.430249,
            53.271689,
            85.150929
          ],
          [
            14.430212,
            53.271488,
            85.46629
          ],
          [
            14.430195,
            53.271278,
            85.794034
          ],
          [
            14.430254,
            53.271087,
            85.916294
          ],
          [
            14.430643,
            53.270984,
            85.458207
          ],
          [
            14.430888,
            53.270823,
            85.049492
          ],
          [
            14.431015,
            53.270616,
            84.654696
          ],
          [
            14.431174,
            53.270426,
            84.274233
          ],
          [
            14.431358,
            53.270249,
            83.899931
          ],
          [
            14.431696,
            53.270233,
            83.529177
          ],
          [
            14.43207,
            53.27025,
            83.127286
          ],
          [
            14.432322,
            53.27015,
            82.794196
          ],
          [
            14.43236,
            53.269951,
            82.763727
          ],
          [
            14.432383,
            53.269768,
            82.735828
          ],
          [
            14.432429,
            53.269557,
            82.703437
          ],
          [
            14.432435,
            53.269346,
            82.671194
          ],
          [
            14.432155,
            53.26921,
            82.638295
          ],
          [
            14.431872,
            53.269112,
            82.608563
          ],
          [
            14.431599,
            53.269006,
            82.578957
          ],
          [
            14.431337,
            53.268884,
            82.548764
          ],
          [
            14.431283,
            53.268666,
            82.470822
          ],
          [
            14.431357,
            53.268432,
            82.223087
          ],
          [
            14.431369,
            53.26825,
            82.033401
          ],
          [
            14.431305,
            53.268003,
            81.773778
          ],
          [
            14.431236,
            53.267803,
            81.561364
          ],
          [
            14.431146,
            53.26759,
            81.333136
          ],
          [
            14.431111,
            53.267396,
            81.130422
          ],
          [
            14.431389,
            53.2673,
            80.930519
          ],
          [
            14.431484,
            53.267093,
            80.706953
          ],
          [
            14.43155,
            53.266878,
            80.146224
          ],
          [
            14.431606,
            53.266651,
            79.45146
          ],
          [
            14.431694,
            53.266453,
            78.83075
          ],
          [
            14.431827,
            53.266258,
            78.191501
          ],
          [
            14.431926,
            53.266083,
            77.632741
          ],
          [
            14.431957,
            53.265897,
            77.064438
          ],
          [
            14.431925,
            53.265703,
            76.474856
          ],
          [
            14.431812,
            53.265444,
            75.661902
          ],
          [
            14.431789,
            53.265236,
            75.294039
          ],
          [
            14.431716,
            53.265011,
            75.591676
          ],
          [
            14.431635,
            53.264786,
            75.892244
          ],
          [
            14.431453,
            53.264557,
            76.225229
          ],
          [
            14.431291,
            53.264372,
            76.498549
          ],
          [
            14.431294,
            53.264167,
            76.764831
          ],
          [
            14.431323,
            53.263954,
            77.04466
          ],
          [
            14.431404,
            53.263761,
            77.305374
          ],
          [
            14.431487,
            53.263559,
            77.515361
          ],
          [
            14.431572,
            53.263328,
            77.122668
          ],
          [
            14.431612,
            53.263109,
            76.756629
          ],
          [
            14.431664,
            53.262874,
            76.363034
          ],
          [
            14.431725,
            53.262669,
            76.017275
          ],
          [
            14.431773,
            53.262446,
            75.644003
          ],
          [
            14.431848,
            53.262208,
            75.241898
          ],
          [
            14.431932,
            53.261991,
            74.872082
          ],
          [
            14.432045,
            53.261765,
            74.154539
          ],
          [
            14.432245,
            53.261566,
            72.306643
          ],
          [
            14.432491,
            53.261404,
            70.564654
          ],
          [
            14.432733,
            53.261272,
            68.986642
          ],
          [
            14.433026,
            53.261166,
            67.352517
          ],
          [
            14.433365,
            53.261011,
            65.31713
          ],
          [
            14.433594,
            53.260861,
            63.699409
          ],
          [
            14.43385,
            53.260685,
            61.842788
          ],
          [
            14.434076,
            53.260547,
            60.30079
          ],
          [
            14.434308,
            53.260414,
            59.900513
          ],
          [
            14.434548,
            53.260291,
            59.544958
          ],
          [
            14.434768,
            53.260153,
            59.18659
          ],
          [
            14.435005,
            53.260025,
            58.827517
          ],
          [
            14.435221,
            53.259898,
            58.487024
          ],
          [
            14.435433,
            53.259756,
            58.129187
          ],
          [
            14.43565,
            53.259618,
            57.77299
          ],
          [
            14.435871,
            53.259472,
            57.402838
          ],
          [
            14.436092,
            53.259309,
            57.008337
          ],
          [
            14.436317,
            53.259156,
            56.325632
          ],
          [
            14.436546,
            53.258996,
            55.444349
          ],
          [
            14.436786,
            53.258826,
            54.513152
          ],
          [
            14.437035,
            53.258636,
            53.501861
          ],
          [
            14.437313,
            53.258421,
            52.364286
          ],
          [
            14.437599,
            53.258191,
            51.163169
          ],
          [
            14.437923,
            53.257941,
            49.838628
          ],
          [
            14.438205,
            53.257713,
            49.17609
          ],
          [
            14.438108,
            53.257518,
            48.952483
          ],
          [
            14.437805,
            53.257404,
            48.733424
          ],
          [
            14.4378,
            53.25723,
            48.542376
          ],
          [
            14.437996,
            53.257044,
            48.318962
          ],
          [
            14.438225,
            53.256872,
            48.095526
          ],
          [
            14.438474,
            53.256744,
            47.895906
          ],
          [
            14.438736,
            53.256565,
            47.651903
          ],
          [
            14.438942,
            53.256386,
            47.536319
          ],
          [
            14.439143,
            53.256219,
            47.584013
          ],
          [
            14.439308,
            53.256044,
            47.630618
          ],
          [
            14.439503,
            53.255887,
            47.675951
          ],
          [
            14.43973,
            53.25572,
            47.72588
          ],
          [
            14.439925,
            53.255557,
            47.772342
          ],
          [
            14.440215,
            53.255408,
            47.825575
          ],
          [
            14.440563,
            53.255295,
            47.880479
          ],
          [
            14.440855,
            53.255206,
            47.926012
          ],
          [
            14.441153,
            53.25511,
            47.657564
          ],
          [
            14.441454,
            53.255045,
            47.34024
          ],
          [
            14.441732,
            53.254941,
            47.021827
          ],
          [
            14.442027,
            53.254808,
            46.663545
          ],
          [
            14.442306,
            53.254722,
            46.356934
          ],
          [
            14.442599,
            53.254645,
            46.045083
          ],
          [
            14.442845,
            53.254527,
            45.737416
          ],
          [
            14.443131,
            53.254437,
            45.423977
          ],
          [
            14.443422,
            53.254341,
            45.101225
          ],
          [
            14.443758,
            53.254307,
            44.477374
          ],
          [
            14.443828,
            53.254171,
            43.770025
          ],
          [
            14.443594,
            53.25404,
            43.093452
          ],
          [
            14.443341,
            53.253919,
            42.409869
          ],
          [
            14.443112,
            53.253771,
            41.695932
          ],
          [
            14.442834,
            53.253657,
            40.974317
          ],
          [
            14.442575,
            53.253506,
            40.211172
          ],
          [
            14.442333,
            53.253366,
            39.500792
          ],
          [
            14.442117,
            53.253207,
            38.777956
          ],
          [
            14.441903,
            53.253061,
            38.822385
          ],
          [
            14.441721,
            53.25289,
            39.005981
          ],
          [
            14.441525,
            53.252719,
            39.194951
          ],
          [
            14.441329,
            53.252581,
            39.358987
          ],
          [
            14.441145,
            53.252405,
            39.548144
          ],
          [
            14.440958,
            53.252233,
            39.73382
          ],
          [
            14.440776,
            53.252085,
            39.901853
          ],
          [
            14.440583,
            53.251935,
            40.073301
          ],
          [
            14.440372,
            53.251782,
            40.252971
          ],
          [
            14.440151,
            53.251627,
            40.301002
          ],
          [
            14.439887,
            53.251599,
            40.301002
          ],
          [
            14.439885,
            53.251605,
            40.301002
          ],
          [
            14.439932,
            53.251483,
            40.301002
          ],
          [
            14.439755,
            53.25132,
            40.301002
          ],
          [
            14.439641,
            53.251135,
            40.301002
          ],
          [
            14.439478,
            53.250949,
            40.301002
          ],
          [
            14.439167,
            53.25097,
            40.301002
          ],
          [
            14.439087,
            53.251102,
            40.301002
          ],
          [
            14.439154,
            53.250994,
            40.301002
          ],
          [
            14.439141,
            53.250942,
            40.301002
          ],
          [
            14.439105,
            53.251068,
            40.301002
          ]
        ]
      }
    }
  ]
}

let day38: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.449071,
            53.254277,
            36.543093
          ],
          [
            14.449432,
            53.254265,
            36.543093
          ],
          [
            14.449787,
            53.254263,
            36.543093
          ],
          [
            14.450148,
            53.25427,
            36.543093
          ],
          [
            14.450473,
            53.254278,
            36.543093
          ],
          [
            14.450857,
            53.254271,
            36.519604
          ],
          [
            14.4512,
            53.254272,
            36.491445
          ],
          [
            14.451559,
            53.254259,
            36.461928
          ],
          [
            14.451896,
            53.254271,
            36.434221
          ],
          [
            14.452211,
            53.254275,
            36.408328
          ],
          [
            14.452551,
            53.254261,
            36.380282
          ],
          [
            14.452903,
            53.254263,
            36.351388
          ],
          [
            14.453252,
            53.25427,
            36.322729
          ],
          [
            14.453583,
            53.25426,
            36.299683
          ],
          [
            14.453953,
            53.254245,
            36.420101
          ],
          [
            14.454339,
            53.25424,
            36.545461
          ],
          [
            14.45472,
            53.254249,
            36.669257
          ],
          [
            14.455089,
            53.254245,
            36.789083
          ],
          [
            14.455458,
            53.254241,
            36.908904
          ],
          [
            14.455858,
            53.254234,
            37.038827
          ],
          [
            14.456231,
            53.254226,
            37.16001
          ],
          [
            14.456625,
            53.254221,
            37.267147
          ],
          [
            14.457003,
            53.254211,
            37.225241
          ],
          [
            14.457382,
            53.254215,
            37.1832
          ],
          [
            14.45777,
            53.254211,
            37.140197
          ],
          [
            14.458155,
            53.254197,
            37.097473
          ],
          [
            14.458545,
            53.254184,
            37.054205
          ],
          [
            14.458934,
            53.25418,
            37.011115
          ],
          [
            14.459305,
            53.254168,
            36.969959
          ],
          [
            14.459675,
            53.254153,
            36.956944
          ],
          [
            14.460059,
            53.254149,
            37.027049
          ],
          [
            14.460465,
            53.254149,
            37.10122
          ],
          [
            14.460805,
            53.254136,
            37.163441
          ],
          [
            14.461169,
            53.254122,
            37.230023
          ],
          [
            14.461513,
            53.254124,
            37.292865
          ],
          [
            14.461861,
            53.254116,
            37.356445
          ],
          [
            14.462182,
            53.254118,
            37.415054
          ],
          [
            14.462582,
            53.254119,
            37.488073
          ],
          [
            14.462924,
            53.254109,
            37.428417
          ],
          [
            14.463281,
            53.254092,
            37.365625
          ],
          [
            14.463632,
            53.254094,
            37.304135
          ],
          [
            14.464012,
            53.254085,
            37.23751
          ],
          [
            14.464409,
            53.254069,
            37.167796
          ],
          [
            14.464763,
            53.254063,
            37.105698
          ],
          [
            14.46513,
            53.254051,
            37.041293
          ],
          [
            14.465493,
            53.254019,
            36.976919
          ],
          [
            14.465796,
            53.253994,
            36.969242
          ],
          [
            14.466124,
            53.25398,
            36.980768
          ],
          [
            14.466464,
            53.253976,
            36.992675
          ],
          [
            14.466795,
            53.253971,
            37.004267
          ],
          [
            14.467168,
            53.253974,
            37.017334
          ],
          [
            14.467552,
            53.253966,
            37.0308
          ],
          [
            14.467935,
            53.253947,
            37.044259
          ],
          [
            14.4683,
            53.253936,
            37.057055
          ],
          [
            14.468675,
            53.253922,
            37.013253
          ],
          [
            14.469031,
            53.25391,
            36.813914
          ],
          [
            14.469382,
            53.253895,
            36.617317
          ],
          [
            14.469709,
            53.253895,
            36.43454
          ],
          [
            14.470069,
            53.253888,
            36.232994
          ],
          [
            14.470453,
            53.253882,
            36.018262
          ],
          [
            14.470802,
            53.253865,
            35.82247
          ],
          [
            14.471141,
            53.253847,
            35.632354
          ],
          [
            14.471495,
            53.253829,
            35.433937
          ],
          [
            14.471857,
            53.253806,
            35.870594
          ],
          [
            14.472198,
            53.253785,
            36.458348
          ],
          [
            14.472577,
            53.253767,
            37.111379
          ],
          [
            14.472962,
            53.253752,
            37.773747
          ],
          [
            14.473336,
            53.253741,
            38.415975
          ],
          [
            14.473681,
            53.25372,
            39.010602
          ],
          [
            14.473996,
            53.253688,
            39.558481
          ],
          [
            14.474347,
            53.253662,
            40.164865
          ],
          [
            14.47472,
            53.253643,
            40.429333
          ],
          [
            14.475092,
            53.253608,
            40.1548
          ],
          [
            14.475413,
            53.253584,
            39.919004
          ],
          [
            14.475772,
            53.253559,
            39.655483
          ],
          [
            14.476144,
            53.253546,
            39.383799
          ],
          [
            14.476531,
            53.253524,
            39.100406
          ],
          [
            14.476918,
            53.253508,
            38.817526
          ],
          [
            14.477313,
            53.253491,
            38.528862
          ],
          [
            14.477697,
            53.25346,
            38.495975
          ],
          [
            14.478012,
            53.253406,
            38.826992
          ],
          [
            14.478351,
            53.25335,
            39.183271
          ],
          [
            14.478673,
            53.25327,
            39.535555
          ],
          [
            14.479007,
            53.253209,
            39.889689
          ],
          [
            14.479333,
            53.253146,
            40.236767
          ],
          [
            14.479633,
            53.253087,
            40.558523
          ],
          [
            14.479926,
            53.253018,
            40.881248
          ],
          [
            14.480252,
            53.252988,
            41.214446
          ],
          [
            14.480553,
            53.252947,
            41.442284
          ],
          [
            14.480916,
            53.252924,
            41.58602
          ],
          [
            14.481282,
            53.252899,
            41.731054
          ],
          [
            14.481643,
            53.252867,
            41.874448
          ],
          [
            14.482025,
            53.252833,
            42.026234
          ],
          [
            14.482421,
            53.252806,
            42.183056
          ],
          [
            14.482743,
            53.252784,
            42.310583
          ],
          [
            14.483053,
            53.252772,
            42.432822
          ],
          [
            14.483449,
            53.252727,
            42.52865
          ],
          [
            14.483865,
            53.252682,
            42.226082
          ],
          [
            14.484242,
            53.252648,
            41.952077
          ],
          [
            14.484593,
            53.252614,
            41.696341
          ],
          [
            14.484968,
            53.252588,
            41.425637
          ],
          [
            14.485268,
            53.252548,
            41.19764
          ],
          [
            14.484971,
            53.252658,
            40.946343
          ],
          [
            14.484802,
            53.252805,
            40.716356
          ],
          [
            14.484653,
            53.252917,
            40.497461
          ],
          [
            14.484879,
            53.252808,
            40.489771
          ],
          [
            14.48509,
            53.252673,
            40.588327
          ],
          [
            14.485408,
            53.252627,
            40.692866
          ],
          [
            14.485729,
            53.252654,
            40.796456
          ],
          [
            14.486035,
            53.252549,
            40.909559
          ],
          [
            14.486357,
            53.252517,
            41.013605
          ],
          [
            14.486731,
            53.252493,
            41.133541
          ],
          [
            14.487057,
            53.252466,
            41.238395
          ],
          [
            14.487381,
            53.252409,
            41.346036
          ],
          [
            14.487691,
            53.252338,
            41.079323
          ],
          [
            14.488071,
            53.252261,
            40.581947
          ],
          [
            14.488046,
            53.252054,
            40.14788
          ],
          [
            14.488033,
            53.251843,
            39.713602
          ],
          [
            14.487978,
            53.251626,
            39.262395
          ],
          [
            14.487942,
            53.251428,
            38.851341
          ],
          [
            14.487971,
            53.251222,
            38.424907
          ],
          [
            14.488039,
            53.251032,
            38.024802
          ],
          [
            14.488126,
            53.250849,
            37.693624
          ],
          [
            14.488285,
            53.250681,
            37.821357
          ],
          [
            14.488506,
            53.250507,
            37.966361
          ],
          [
            14.488715,
            53.250363,
            38.092878
          ],
          [
            14.48889,
            53.250191,
            38.226354
          ],
          [
            14.489039,
            53.249997,
            38.367685
          ],
          [
            14.489101,
            53.249784,
            38.510825
          ],
          [
            14.489231,
            53.249602,
            38.644511
          ],
          [
            14.489175,
            53.24939,
            38.786846
          ],
          [
            14.489177,
            53.249198,
            39.01164
          ],
          [
            14.489124,
            53.248982,
            39.469687
          ],
          [
            14.489134,
            53.248767,
            39.920798
          ],
          [
            14.48939,
            53.248675,
            40.331558
          ],
          [
            14.489433,
            53.248587,
            40.729895
          ],
          [
            14.489213,
            53.248556,
            41.149637
          ],
          [
            14.48914,
            53.248729,
            41.542053
          ],
          [
            14.489095,
            53.248503,
            42.020603
          ],
          [
            14.489114,
            53.248292,
            42.469981
          ],
          [
            14.489092,
            53.248073,
            42.67839
          ],
          [
            14.489093,
            53.247861,
            42.735525
          ],
          [
            14.489092,
            53.247631,
            42.797389
          ],
          [
            14.489072,
            53.247397,
            42.860426
          ],
          [
            14.48904,
            53.247215,
            42.909646
          ],
          [
            14.488991,
            53.247026,
            42.961084
          ],
          [
            14.488971,
            53.246819,
            43.016901
          ],
          [
            14.488955,
            53.246627,
            43.068701
          ],
          [
            14.488939,
            53.246422,
            43.124013
          ],
          [
            14.488941,
            53.246195,
            42.866698
          ],
          [
            14.488938,
            53.245988,
            42.627794
          ],
          [
            14.488919,
            53.245758,
            42.361723
          ],
          [
            14.488909,
            53.245571,
            42.145879
          ],
          [
            14.488878,
            53.245358,
            41.898421
          ],
          [
            14.488901,
            53.24517,
            41.680892
          ],
          [
            14.488887,
            53.244989,
            41.471853
          ],
          [
            14.488875,
            53.2448,
            41.253503
          ],
          [
            14.488869,
            53.244601,
            41.044338
          ],
          [
            14.488864,
            53.244385,
            40.992011
          ],
          [
            14.488856,
            53.244189,
            40.944462
          ],
          [
            14.48884,
            53.243993,
            40.896919
          ],
          [
            14.488803,
            53.243787,
            40.846633
          ],
          [
            14.488774,
            53.243558,
            40.790748
          ],
          [
            14.488758,
            53.243369,
            40.744879
          ],
          [
            14.48874,
            53.243145,
            40.69055
          ],
          [
            14.488748,
            53.242928,
            40.637911
          ],
          [
            14.488721,
            53.242696,
            40.798902
          ],
          [
            14.488695,
            53.242463,
            41.119308
          ],
          [
            14.488673,
            53.24227,
            41.385222
          ],
          [
            14.48874,
            53.242067,
            41.673048
          ],
          [
            14.488728,
            53.241845,
            41.977708
          ],
          [
            14.488702,
            53.241634,
            42.268559
          ],
          [
            14.488687,
            53.241432,
            42.545846
          ],
          [
            14.488672,
            53.241221,
            42.835558
          ],
          [
            14.48865,
            53.241033,
            43.070838
          ],
          [
            14.48864,
            53.24082,
            42.862289
          ],
          [
            14.488613,
            53.240615,
            42.661233
          ],
          [
            14.488606,
            53.240404,
            42.455013
          ],
          [
            14.488605,
            53.240202,
            42.257625
          ],
          [
            14.488607,
            53.240001,
            42.061232
          ],
          [
            14.488586,
            53.239781,
            41.845283
          ],
          [
            14.488577,
            53.239563,
            41.631348
          ],
          [
            14.488576,
            53.239368,
            41.438847
          ],
          [
            14.488556,
            53.23917,
            41.383633
          ],
          [
            14.488525,
            53.238965,
            41.53825
          ],
          [
            14.488513,
            53.23874,
            41.707442
          ],
          [
            14.488521,
            53.238508,
            41.882003
          ],
          [
            14.48851,
            53.238304,
            42.035324
          ],
          [
            14.488489,
            53.238103,
            42.186625
          ],
          [
            14.488463,
            53.237918,
            42.326085
          ],
          [
            14.48843,
            53.237703,
            42.490197
          ],
          [
            14.488455,
            53.237491,
            42.649847
          ],
          [
            14.488451,
            53.237277,
            42.442445
          ],
          [
            14.488456,
            53.23706,
            42.165998
          ],
          [
            14.488462,
            53.236853,
            41.902246
          ],
          [
            14.488466,
            53.236645,
            41.637153
          ],
          [
            14.488465,
            53.236418,
            41.347767
          ],
          [
            14.488522,
            53.236215,
            41.085321
          ],
          [
            14.488583,
            53.236004,
            40.811596
          ],
          [
            14.488589,
            53.235769,
            40.512208
          ],
          [
            14.488574,
            53.235563,
            40.415148
          ],
          [
            14.488588,
            53.23537,
            40.474579
          ],
          [
            14.488597,
            53.235158,
            40.540024
          ],
          [
            14.488623,
            53.234962,
            40.60079
          ],
          [
            14.488638,
            53.234759,
            40.663298
          ],
          [
            14.488635,
            53.234556,
            40.72578
          ],
          [
            14.488648,
            53.234364,
            40.785015
          ],
          [
            14.488694,
            53.234164,
            40.847202
          ],
          [
            14.488728,
            53.233933,
            40.918537
          ],
          [
            14.488753,
            53.233717,
            40.990196
          ],
          [
            14.488754,
            53.233498,
            41.064563
          ],
          [
            14.488781,
            53.233287,
            41.136348
          ],
          [
            14.488788,
            53.233076,
            41.207936
          ],
          [
            14.488737,
            53.232873,
            41.279742
          ],
          [
            14.488754,
            53.232668,
            41.349578
          ],
          [
            14.488776,
            53.232466,
            41.418269
          ],
          [
            14.488798,
            53.23226,
            41.488314
          ],
          [
            14.488813,
            53.232045,
            41.679377
          ],
          [
            14.488812,
            53.231853,
            42.256505
          ],
          [
            14.488854,
            53.231644,
            42.890594
          ],
          [
            14.488878,
            53.231445,
            43.490379
          ],
          [
            14.488911,
            53.23125,
            44.080418
          ],
          [
            14.48897,
            53.231046,
            44.702755
          ],
          [
            14.489011,
            53.23082,
            45.387066
          ],
          [
            14.489037,
            53.23062,
            45.990591
          ],
          [
            14.489107,
            53.230411,
            46.633449
          ],
          [
            14.489158,
            53.230198,
            46.913972
          ],
          [
            14.489209,
            53.229988,
            46.838478
          ],
          [
            14.489236,
            53.229788,
            46.767126
          ],
          [
            14.489332,
            53.229475,
            46.653331
          ],
          [
            14.489377,
            53.229254,
            46.574157
          ],
          [
            14.489431,
            53.229046,
            46.499299
          ],
          [
            14.489502,
            53.228841,
            46.424857
          ],
          [
            14.489578,
            53.228626,
            46.346578
          ],
          [
            14.489624,
            53.228404,
            46.132585
          ],
          [
            14.489676,
            53.228168,
            45.80167
          ],
          [
            14.489721,
            53.227913,
            45.444858
          ],
          [
            14.489714,
            53.22769,
            45.134798
          ],
          [
            14.489664,
            53.22751,
            44.881018
          ],
          [
            14.489534,
            53.227304,
            44.574789
          ],
          [
            14.489399,
            53.227127,
            44.304036
          ],
          [
            14.489235,
            53.226957,
            44.030594
          ],
          [
            14.489068,
            53.226791,
            43.755695
          ],
          [
            14.488842,
            53.22661,
            43.407968
          ],
          [
            14.488681,
            53.226426,
            43.088485
          ],
          [
            14.488514,
            53.226252,
            42.779725
          ],
          [
            14.488355,
            53.226057,
            42.445875
          ],
          [
            14.488187,
            53.225874,
            42.124606
          ],
          [
            14.488009,
            53.225686,
            41.792116
          ],
          [
            14.487811,
            53.225528,
            41.481716
          ],
          [
            14.487622,
            53.225328,
            41.128281
          ],
          [
            14.487459,
            53.22514,
            40.877237
          ],
          [
            14.487317,
            53.224975,
            40.679228
          ],
          [
            14.487152,
            53.22478,
            40.446012
          ],
          [
            14.487,
            53.224612,
            40.242181
          ],
          [
            14.48683,
            53.224439,
            40.027981
          ],
          [
            14.48668,
            53.224245,
            39.799874
          ],
          [
            14.486495,
            53.22407,
            39.578624
          ],
          [
            14.486388,
            53.223897,
            39.381335
          ],
          [
            14.48632,
            53.223716,
            39.183372
          ],
          [
            14.486215,
            53.223493,
            38.788778
          ],
          [
            14.486085,
            53.223293,
            38.384376
          ],
          [
            14.486022,
            53.223111,
            38.032482
          ],
          [
            14.486035,
            53.222924,
            37.679813
          ],
          [
            14.485973,
            53.222735,
            37.316712
          ],
          [
            14.485901,
            53.222545,
            36.949578
          ],
          [
            14.485822,
            53.222355,
            36.580615
          ],
          [
            14.48573,
            53.222156,
            36.191539
          ],
          [
            14.485648,
            53.221959,
            35.808865
          ],
          [
            14.485562,
            53.221743,
            36.25785
          ],
          [
            14.485479,
            53.221527,
            36.880236
          ],
          [
            14.485386,
            53.221315,
            37.49688
          ],
          [
            14.485278,
            53.22111,
            38.100501
          ],
          [
            14.485197,
            53.220893,
            38.724818
          ],
          [
            14.485104,
            53.220671,
            39.367451
          ],
          [
            14.484993,
            53.220462,
            39.983228
          ],
          [
            14.484841,
            53.220273,
            40.572232
          ],
          [
            14.484682,
            53.220102,
            40.931432
          ],
          [
            14.484499,
            53.219921,
            41.184849
          ],
          [
            14.484292,
            53.219742,
            41.445418
          ],
          [
            14.484091,
            53.219547,
            41.719632
          ],
          [
            14.483866,
            53.219347,
            42.00818
          ],
          [
            14.483651,
            53.219149,
            42.290934
          ],
          [
            14.483469,
            53.218972,
            42.539668
          ],
          [
            14.483296,
            53.218785,
            42.795533
          ],
          [
            14.483104,
            53.218612,
            42.983328
          ],
          [
            14.482934,
            53.21844,
            43.081059
          ],
          [
            14.482761,
            53.218272,
            43.177541
          ],
          [
            14.482559,
            53.218097,
            43.281581
          ],
          [
            14.482396,
            53.217923,
            43.379219
          ],
          [
            14.482221,
            53.217755,
            43.476172
          ],
          [
            14.482041,
            53.217598,
            43.569265
          ],
          [
            14.481833,
            53.217407,
            43.680753
          ],
          [
            14.481662,
            53.217253,
            43.771156
          ],
          [
            14.481493,
            53.217082,
            43.925595
          ],
          [
            14.48131,
            53.216919,
            44.135415
          ],
          [
            14.48116,
            53.216741,
            44.348393
          ],
          [
            14.480971,
            53.21657,
            44.567773
          ],
          [
            14.480777,
            53.216394,
            44.793303
          ],
          [
            14.480598,
            53.216208,
            45.02314
          ],
          [
            14.480388,
            53.21603,
            45.255942
          ],
          [
            14.480226,
            53.215849,
            45.475343
          ],
          [
            14.480067,
            53.21569,
            45.673556
          ],
          [
            14.479873,
            53.215522,
            45.621804
          ],
          [
            14.479654,
            53.21533,
            45.423928
          ],
          [
            14.47945,
            53.215132,
            45.225935
          ],
          [
            14.479251,
            53.214945,
            45.037196
          ],
          [
            14.47905,
            53.214742,
            44.836371
          ],
          [
            14.47885,
            53.214523,
            44.623956
          ],
          [
            14.47867,
            53.214322,
            44.429737
          ],
          [
            14.478379,
            53.214278,
            44.259366
          ],
          [
            14.478151,
            53.214423,
            44.404783
          ],
          [
            14.477955,
            53.214572,
            44.653931
          ],
          [
            14.477784,
            53.214745,
            44.917818
          ],
          [
            14.477664,
            53.21493,
            45.17891
          ],
          [
            14.477443,
            53.215046,
            45.436565
          ],
          [
            14.477172,
            53.21496,
            45.679774
          ],
          [
            14.47692,
            53.214849,
            45.92568
          ],
          [
            14.476646,
            53.214736,
            46.187946
          ],
          [
            14.476406,
            53.214623,
            46.427952
          ],
          [
            14.476108,
            53.214526,
            46.388792
          ],
          [
            14.475854,
            53.214404,
            46.009284
          ],
          [
            14.475921,
            53.214224,
            45.645636
          ],
          [
            14.475709,
            53.214204,
            45.083997
          ],
          [
            14.475893,
            53.21405,
            44.716278
          ],
          [
            14.475839,
            53.213812,
            44.239181
          ],
          [
            14.47592,
            53.213795,
            43.848728
          ],
          [
            14.475859,
            53.213997,
            43.430338
          ],
          [
            14.475588,
            53.214109,
            43.040264
          ],
          [
            14.475516,
            53.214128,
            42.624242
          ],
          [
            14.475783,
            53.214112,
            42.218588
          ],
          [
            14.475843,
            53.214405,
            41.498105
          ],
          [
            14.476101,
            53.214532,
            41.051633
          ],
          [
            14.476363,
            53.214663,
            40.594614
          ],
          [
            14.476603,
            53.214777,
            40.185119
          ],
          [
            14.476893,
            53.214861,
            39.755513
          ],
          [
            14.477146,
            53.214988,
            39.315319
          ],
          [
            14.477468,
            53.215047,
            39.180589
          ],
          [
            14.477666,
            53.2149,
            39.380937
          ],
          [
            14.477821,
            53.214723,
            39.582322
          ],
          [
            14.477999,
            53.214561,
            39.778912
          ],
          [
            14.478127,
            53.21438,
            39.977718
          ],
          [
            14.47838,
            53.214276,
            40.175179
          ],
          [
            14.478612,
            53.214272,
            40.364161
          ],
          [
            14.478804,
            53.214468,
            40.593459
          ],
          [
            14.478954,
            53.21463,
            40.78114
          ],
          [
            14.479129,
            53.214794,
            40.898318
          ],
          [
            14.479298,
            53.214969,
            40.914094
          ],
          [
            14.479469,
            53.215134,
            40.929244
          ],
          [
            14.479666,
            53.215296,
            40.94488
          ],
          [
            14.479829,
            53.215494,
            40.962139
          ],
          [
            14.480006,
            53.215659,
            40.977472
          ],
          [
            14.480175,
            53.215828,
            40.992843
          ],
          [
            14.480341,
            53.216011,
            41.009096
          ],
          [
            14.480531,
            53.216185,
            41.025338
          ],
          [
            14.480726,
            53.216343,
            41.142346
          ],
          [
            14.48089,
            53.216514,
            41.335493
          ],
          [
            14.4811,
            53.216707,
            41.56114
          ],
          [
            14.481295,
            53.216897,
            41.779787
          ],
          [
            14.481511,
            53.217086,
            42.004205
          ],
          [
            14.481731,
            53.217279,
            42.233084
          ],
          [
            14.48193,
            53.217483,
            42.464644
          ],
          [
            14.482136,
            53.217682,
            42.694169
          ],
          [
            14.482346,
            53.217878,
            42.775783
          ],
          [
            14.482585,
            53.218089,
            42.741074
          ],
          [
            14.482774,
            53.218285,
            42.710241
          ],
          [
            14.482992,
            53.21848,
            42.678294
          ],
          [
            14.483211,
            53.218699,
            42.643545
          ],
          [
            14.483428,
            53.218905,
            42.610361
          ],
          [
            14.483633,
            53.219097,
            42.579321
          ],
          [
            14.483851,
            53.2193,
            42.548587
          ],
          [
            14.484062,
            53.219499,
            42.545653
          ],
          [
            14.484282,
            53.219676,
            42.542907
          ],
          [
            14.484463,
            53.219871,
            42.540129
          ],
          [
            14.484681,
            53.220063,
            42.537239
          ],
          [
            14.484855,
            53.220237,
            42.534709
          ],
          [
            14.48502,
            53.220414,
            42.532185
          ],
          [
            14.485147,
            53.220605,
            42.529624
          ],
          [
            14.485233,
            53.220817,
            42.526908
          ],
          [
            14.4853,
            53.221021,
            42.556775
          ],
          [
            14.485387,
            53.221221,
            42.594023
          ],
          [
            14.48546,
            53.221423,
            42.631252
          ],
          [
            14.485538,
            53.221625,
            42.668602
          ],
          [
            14.485626,
            53.221814,
            42.703948
          ],
          [
            14.485713,
            53.222013,
            42.741016
          ],
          [
            14.485802,
            53.222236,
            42.78235
          ],
          [
            14.4859,
            53.222445,
            42.821469
          ],
          [
            14.485986,
            53.222638,
            42.813013
          ],
          [
            14.486058,
            53.222832,
            42.622761
          ],
          [
            14.486129,
            53.223019,
            42.439189
          ],
          [
            14.486207,
            53.223213,
            42.248119
          ],
          [
            14.48628,
            53.223397,
            42.067092
          ],
          [
            14.486325,
            53.223597,
            41.873198
          ],
          [
            14.48634,
            53.223798,
            41.675775
          ],
          [
            14.48642,
            53.223998,
            41.47879
          ],
          [
            14.486536,
            53.224173,
            41.298488
          ],
          [
            14.486708,
            53.224358,
            41.146266
          ],
          [
            14.48687,
            53.224542,
            41.25142
          ],
          [
            14.48704,
            53.224732,
            41.360386
          ],
          [
            14.487222,
            53.224916,
            41.468503
          ],
          [
            14.487388,
            53.225092,
            41.570694
          ],
          [
            14.487569,
            53.225277,
            41.679181
          ],
          [
            14.487771,
            53.225482,
            41.799504
          ],
          [
            14.487919,
            53.225682,
            41.910468
          ],
          [
            14.488144,
            53.225865,
            42.025804
          ],
          [
            14.488329,
            53.226076,
            41.950707
          ],
          [
            14.488519,
            53.226283,
            41.854192
          ],
          [
            14.488712,
            53.226491,
            41.757024
          ],
          [
            14.488886,
            53.226684,
            41.667458
          ],
          [
            14.489074,
            53.226895,
            41.56981
          ],
          [
            14.489243,
            53.227084,
            41.48226
          ],
          [
            14.489421,
            53.227321,
            41.375968
          ],
          [
            14.489546,
            53.22754,
            41.309898
          ],
          [
            14.489638,
            53.227745,
            41.334136
          ],
          [
            14.489665,
            53.22793,
            41.35545
          ],
          [
            14.48964,
            53.228144,
            41.379954
          ],
          [
            14.489576,
            53.228341,
            41.402905
          ],
          [
            14.489542,
            53.228543,
            41.426144
          ],
          [
            14.4895,
            53.228729,
            41.447583
          ],
          [
            14.489455,
            53.228954,
            41.473467
          ],
          [
            14.489405,
            53.22915,
            41.496102
          ],
          [
            14.489339,
            53.229357,
            41.469397
          ],
          [
            14.489259,
            53.22954,
            41.392921
          ],
          [
            14.489194,
            53.229767,
            41.299911
          ],
          [
            14.489155,
            53.229977,
            41.214596
          ],
          [
            14.489103,
            53.230181,
            41.131293
          ],
          [
            14.489069,
            53.230391,
            41.046022
          ],
          [
            14.489016,
            53.230613,
            40.955466
          ],
          [
            14.488986,
            53.230823,
            40.870384
          ],
          [
            14.488972,
            53.231014,
            40.792991
          ],
          [
            14.488934,
            53.23122,
            40.469441
          ],
          [
            14.488851,
            53.231447,
            40.070231
          ],
          [
            14.488837,
            53.231654,
            39.712897
          ],
          [
            14.488788,
            53.231923,
            39.24816
          ],
          [
            14.488764,
            53.232161,
            38.838748
          ],
          [
            14.488759,
            53.232425,
            38.383466
          ],
          [
            14.488725,
            53.232664,
            37.971652
          ],
          [
            14.488711,
            53.232866,
            37.680261
          ],
          [
            14.488864,
            53.233035,
            37.610564
          ],
          [
            14.489075,
            53.233156,
            37.537309
          ],
          [
            14.489038,
            53.233356,
            37.465701
          ],
          [
            14.489041,
            53.233564,
            37.391703
          ],
          [
            14.488995,
            53.233765,
            37.319257
          ],
          [
            14.48896,
            53.233982,
            37.241659
          ],
          [
            14.488927,
            53.23418,
            37.170873
          ],
          [
            14.488925,
            53.234385,
            37.097933
          ],
          [
            14.488983,
            53.234584,
            37.082034
          ],
          [
            14.488983,
            53.234781,
            37.146475
          ],
          [
            14.488975,
            53.234983,
            37.212679
          ],
          [
            14.488992,
            53.235187,
            37.279493
          ],
          [
            14.488967,
            53.235392,
            37.346729
          ],
          [
            14.488954,
            53.235598,
            37.414164
          ],
          [
            14.488775,
            53.235761,
            37.479027
          ],
          [
            14.4887,
            53.235978,
            37.551982
          ],
          [
            14.488678,
            53.236195,
            37.62317
          ],
          [
            14.488725,
            53.236397,
            37.82067
          ],
          [
            14.48871,
            53.236585,
            38.034776
          ],
          [
            14.488694,
            53.236801,
            38.28073
          ],
          [
            14.488652,
            53.237028,
            38.54055
          ],
          [
            14.488639,
            53.237218,
            38.756875
          ],
          [
            14.488654,
            53.237422,
            38.989391
          ],
          [
            14.488684,
            53.237636,
            39.233807
          ],
          [
            14.488689,
            53.237855,
            39.483034
          ],
          [
            14.488706,
            53.238076,
            39.738828
          ],
          [
            14.488725,
            53.238282,
            39.994972
          ],
          [
            14.488721,
            53.238488,
            40.250767
          ],
          [
            14.488729,
            53.238702,
            40.516676
          ],
          [
            14.488754,
            53.238923,
            40.79167
          ],
          [
            14.488771,
            53.239154,
            41.078796
          ],
          [
            14.488784,
            53.239373,
            41.350844
          ],
          [
            14.488801,
            53.239606,
            41.640455
          ],
          [
            14.488802,
            53.239837,
            41.927477
          ],
          [
            14.488831,
            53.240025,
            42.173054
          ],
          [
            14.488849,
            53.240224,
            42.432295
          ],
          [
            14.488853,
            53.24043,
            42.700047
          ],
          [
            14.488859,
            53.240626,
            42.954728
          ],
          [
            14.488878,
            53.240855,
            43.252708
          ],
          [
            14.488865,
            53.241079,
            43.544801
          ],
          [
            14.488865,
            53.24128,
            43.806228
          ],
          [
            14.488895,
            53.241486,
            44.074871
          ],
          [
            14.488917,
            53.241684,
            44.242004
          ],
          [
            14.488921,
            53.241888,
            44.180292
          ],
          [
            14.488928,
            53.242071,
            44.124953
          ],
          [
            14.488953,
            53.24228,
            44.061622
          ],
          [
            14.48896,
            53.24249,
            43.997677
          ],
          [
            14.488987,
            53.242687,
            43.937899
          ],
          [
            14.488994,
            53.242883,
            43.878639
          ],
          [
            14.489003,
            53.243077,
            43.819979
          ],
          [
            14.488995,
            53.243274,
            43.760382
          ],
          [
            14.489014,
            53.243484,
            43.547438
          ],
          [
            14.489025,
            53.243668,
            43.046808
          ],
          [
            14.489046,
            53.243849,
            42.55377
          ],
          [
            14.489047,
            53.244063,
            41.972238
          ],
          [
            14.489072,
            53.244272,
            41.402172
          ],
          [
            14.489083,
            53.244474,
            40.852907
          ],
          [
            14.489097,
            53.244697,
            40.246372
          ],
          [
            14.489118,
            53.244892,
            39.715376
          ],
          [
            14.489123,
            53.245118,
            39.101126
          ],
          [
            14.489124,
            53.24532,
            39.019786
          ],
          [
            14.489156,
            53.245529,
            39.416984
          ],
          [
            14.489195,
            53.245743,
            39.825009
          ],
          [
            14.489206,
            53.245955,
            40.22655
          ],
          [
            14.489188,
            53.246162,
            40.618784
          ],
          [
            14.489194,
            53.246358,
            40.989871
          ],
          [
            14.489201,
            53.246569,
            41.389853
          ],
          [
            14.48922,
            53.246768,
            41.767166
          ],
          [
            14.489215,
            53.246985,
            42.177969
          ],
          [
            14.489247,
            53.247209,
            42.663486
          ],
          [
            14.489434,
            53.247331,
            43.09254
          ],
          [
            14.489735,
            53.247279,
            43.505464
          ],
          [
            14.489392,
            53.247324,
            43.967633
          ],
          [
            14.489232,
            53.247479,
            44.414372
          ],
          [
            14.489287,
            53.247707,
            44.920736
          ],
          [
            14.489312,
            53.247921,
            45.392651
          ],
          [
            14.489302,
            53.24812,
            45.830383
          ],
          [
            14.489309,
            53.248348,
            46.212647
          ],
          [
            14.489321,
            53.248558,
            46.301448
          ],
          [
            14.489366,
            53.248752,
            46.384135
          ],
          [
            14.489365,
            53.248946,
            46.466049
          ],
          [
            14.489389,
            53.249145,
            46.550289
          ],
          [
            14.48941,
            53.249335,
            46.63067
          ],
          [
            14.489427,
            53.249531,
            46.713587
          ],
          [
            14.489404,
            53.249759,
            46.810019
          ],
          [
            14.489494,
            53.249967,
            46.901558
          ],
          [
            14.489357,
            53.250186,
            46.411026
          ],
          [
            14.489219,
            53.250364,
            45.637985
          ],
          [
            14.488888,
            53.250426,
            44.792595
          ],
          [
            14.488704,
            53.250591,
            44.025358
          ],
          [
            14.488493,
            53.25074,
            43.267682
          ],
          [
            14.488353,
            53.250941,
            42.424571
          ],
          [
            14.488251,
            53.251147,
            41.593306
          ],
          [
            14.488206,
            53.251364,
            40.747186
          ],
          [
            14.488218,
            53.251559,
            39.986963
          ],
          [
            14.48818,
            53.251757,
            40.627773
          ],
          [
            14.48818,
            53.251972,
            41.318698
          ],
          [
            14.48818,
            53.252189,
            42.015876
          ],
          [
            14.488328,
            53.252375,
            42.681345
          ],
          [
            14.488066,
            53.252439,
            43.285943
          ],
          [
            14.487692,
            53.252415,
            44.009226
          ],
          [
            14.487382,
            53.252443,
            44.612871
          ],
          [
            14.487055,
            53.252441,
            45.245402
          ],
          [
            14.486667,
            53.252466,
            45.750067
          ],
          [
            14.48626,
            53.252493,
            45.702639
          ],
          [
            14.485959,
            53.252517,
            45.667496
          ],
          [
            14.485598,
            53.252547,
            45.625299
          ],
          [
            14.485238,
            53.252585,
            45.583001
          ],
          [
            14.484861,
            53.252628,
            45.538513
          ],
          [
            14.484526,
            53.252659,
            45.499224
          ],
          [
            14.484203,
            53.252693,
            45.461265
          ],
          [
            14.483862,
            53.252714,
            45.421602
          ],
          [
            14.483542,
            53.25276,
            45.147097
          ],
          [
            14.483235,
            53.25278,
            44.852985
          ],
          [
            14.482919,
            53.2528,
            44.549976
          ],
          [
            14.48254,
            53.252824,
            44.187166
          ],
          [
            14.482186,
            53.252867,
            43.842841
          ],
          [
            14.48183,
            53.252884,
            43.502775
          ],
          [
            14.481474,
            53.252909,
            43.160152
          ],
          [
            14.48109,
            53.252941,
            42.791003
          ],
          [
            14.480707,
            53.252981,
            42.358112
          ],
          [
            14.480355,
            53.253012,
            41.860028
          ],
          [
            14.479965,
            53.25305,
            41.306009
          ],
          [
            14.479526,
            53.253087,
            40.685346
          ],
          [
            14.479227,
            53.253143,
            40.246087
          ],
          [
            14.478893,
            53.253222,
            39.743351
          ],
          [
            14.47854,
            53.253304,
            39.213118
          ],
          [
            14.478126,
            53.253374,
            38.609911
          ],
          [
            14.477794,
            53.253432,
            38.276162
          ],
          [
            14.477383,
            53.253484,
            38.088783
          ],
          [
            14.477024,
            53.253498,
            37.928723
          ],
          [
            14.476684,
            53.253519,
            37.776806
          ],
          [
            14.476348,
            53.253533,
            37.627118
          ],
          [
            14.476013,
            53.253561,
            37.476752
          ],
          [
            14.475658,
            53.253587,
            37.317763
          ],
          [
            14.475316,
            53.253607,
            37.165054
          ],
          [
            14.474974,
            53.25363,
            37.012112
          ],
          [
            14.474641,
            53.253656,
            37.116991
          ],
          [
            14.474287,
            53.253686,
            37.232392
          ],
          [
            14.473898,
            53.253706,
            37.358423
          ],
          [
            14.473488,
            53.25373,
            37.491395
          ],
          [
            14.473072,
            53.253752,
            37.626173
          ],
          [
            14.472659,
            53.253773,
            37.76013
          ],
          [
            14.472268,
            53.25379,
            37.886649
          ],
          [
            14.471868,
            53.253811,
            37.939878
          ],
          [
            14.471486,
            53.253822,
            37.800981
          ],
          [
            14.471124,
            53.253839,
            37.66911
          ],
          [
            14.470788,
            53.253866,
            37.54591
          ],
          [
            14.470439,
            53.253885,
            37.418526
          ],
          [
            14.470094,
            53.253903,
            37.292751
          ],
          [
            14.469759,
            53.253914,
            37.170895
          ],
          [
            14.469424,
            53.25393,
            37.048824
          ],
          [
            14.469077,
            53.253936,
            36.9227
          ],
          [
            14.468718,
            53.253941,
            36.778781
          ],
          [
            14.468376,
            53.253946,
            36.637117
          ],
          [
            14.468021,
            53.253935,
            36.489838
          ],
          [
            14.467694,
            53.253946,
            36.354214
          ],
          [
            14.467344,
            53.253958,
            36.209044
          ],
          [
            14.466993,
            53.253968,
            36.062997
          ],
          [
            14.466683,
            53.253987,
            35.933954
          ],
          [
            14.466347,
            53.25401,
            35.793898
          ],
          [
            14.465953,
            53.254023,
            35.639126
          ],
          [
            14.465592,
            53.25404,
            35.58804
          ],
          [
            14.465212,
            53.254032,
            35.534356
          ],
          [
            14.464849,
            53.254043,
            35.48308
          ],
          [
            14.464492,
            53.254054,
            35.432673
          ],
          [
            14.464118,
            53.254068,
            35.379825
          ],
          [
            14.46375,
            53.25408,
            35.32786
          ],
          [
            14.463406,
            53.254081,
            35.279286
          ],
          [
            14.463027,
            53.254087,
            35.225779
          ],
          [
            14.462663,
            53.254096,
            35.402638
          ],
          [
            14.462304,
            53.254106,
            35.607557
          ],
          [
            14.461942,
            53.25411,
            35.813878
          ],
          [
            14.461597,
            53.25412,
            36.010706
          ],
          [
            14.461233,
            53.254139,
            36.219226
          ],
          [
            14.460874,
            53.254154,
            36.424385
          ],
          [
            14.460514,
            53.254154,
            36.629637
          ],
          [
            14.460171,
            53.254157,
            36.825139
          ],
          [
            14.45982,
            53.254161,
            37.020388
          ],
          [
            14.459474,
            53.254172,
            37.207568
          ],
          [
            14.459106,
            53.254175,
            37.406419
          ],
          [
            14.45872,
            53.254183,
            37.615058
          ],
          [
            14.458326,
            53.254188,
            37.828167
          ],
          [
            14.457981,
            53.254198,
            38.014771
          ],
          [
            14.457641,
            53.254211,
            38.198826
          ],
          [
            14.457287,
            53.254212,
            38.390221
          ],
          [
            14.45696,
            53.254214,
            38.549847
          ],
          [
            14.456654,
            53.254223,
            38.441999
          ],
          [
            14.456304,
            53.254225,
            38.318743
          ],
          [
            14.455992,
            53.254228,
            38.20898
          ],
          [
            14.455666,
            53.254236,
            38.094204
          ],
          [
            14.455331,
            53.254243,
            37.976206
          ],
          [
            14.454998,
            53.254246,
            37.859023
          ],
          [
            14.454649,
            53.254239,
            37.736125
          ],
          [
            14.454309,
            53.25425,
            37.616351
          ],
          [
            14.45397,
            53.25425,
            37.502811
          ],
          [
            14.453624,
            53.254255,
            37.738664
          ],
          [
            14.453275,
            53.254257,
            37.976501
          ],
          [
            14.452926,
            53.254255,
            38.214349
          ],
          [
            14.452585,
            53.254258,
            38.446774
          ],
          [
            14.452245,
            53.254258,
            38.678512
          ],
          [
            14.451877,
            53.254267,
            38.929554
          ],
          [
            14.451456,
            53.254269,
            39.216537
          ],
          [
            14.451089,
            53.254268,
            39.466694
          ],
          [
            14.450782,
            53.254254,
            39.517085
          ],
          [
            14.450379,
            53.254253,
            39.451593
          ],
          [
            14.449962,
            53.25425,
            39.383827
          ],
          [
            14.449538,
            53.254252,
            39.314926
          ],
          [
            14.449115,
            53.254262,
            39.246104
          ],
          [
            14.448727,
            53.254265,
            39.18295
          ],
          [
            14.448323,
            53.254264,
            39.117301
          ],
          [
            14.447947,
            53.254278,
            39.058893
          ],
          [
            14.447571,
            53.254274,
            39.05203
          ],
          [
            14.447173,
            53.254281,
            39.044776
          ],
          [
            14.446742,
            53.254279,
            39.036923
          ],
          [
            14.446367,
            53.254285,
            39.03009
          ],
          [
            14.445939,
            53.25429,
            39.022286
          ],
          [
            14.445513,
            53.254303,
            39.014509
          ],
          [
            14.44513,
            53.254324,
            39.007504
          ],
          [
            14.444756,
            53.254348,
            39.441368
          ],
          [
            14.444437,
            53.254354,
            40.103411
          ],
          [
            14.444088,
            53.254339,
            40.830962
          ],
          [
            14.443771,
            53.254289,
            41.539395
          ],
          [
            14.44345,
            53.254312,
            42.219139
          ],
          [
            14.443156,
            53.25439,
            42.886273
          ],
          [
            14.442892,
            53.254487,
            43.533444
          ],
          [
            14.442593,
            53.254589,
            44.247494
          ],
          [
            14.442302,
            53.25467,
            44.913523
          ],
          [
            14.442035,
            53.254758,
            45.10638
          ],
          [
            14.441721,
            53.254862,
            44.778057
          ],
          [
            14.441454,
            53.254957,
            44.494033
          ],
          [
            14.441204,
            53.255074,
            44.203943
          ],
          [
            14.440909,
            53.255148,
            43.911366
          ],
          [
            14.440585,
            53.255257,
            43.571647
          ],
          [
            14.440225,
            53.255383,
            43.190199
          ],
          [
            14.439942,
            53.255519,
            42.85833
          ],
          [
            14.439723,
            53.255681,
            42.539914
          ],
          [
            14.439513,
            53.255832,
            42.470766
          ],
          [
            14.439317,
            53.255987,
            42.444435
          ],
          [
            14.439122,
            53.25619,
            42.412757
          ],
          [
            14.438931,
            53.256356,
            42.385516
          ],
          [
            14.438686,
            53.256397,
            42.359632
          ],
          [
            14.438601,
            53.256206,
            42.332845
          ],
          [
            14.438413,
            53.255995,
            42.300449
          ],
          [
            14.43829,
            53.255818,
            42.274493
          ],
          [
            14.438155,
            53.255635,
            42.229524
          ],
          [
            14.438012,
            53.255469,
            42.033824
          ],
          [
            14.437869,
            53.255277,
            41.813411
          ],
          [
            14.437734,
            53.255073,
            41.583375
          ],
          [
            14.43759,
            53.254905,
            41.385408
          ],
          [
            14.437412,
            53.254735,
            41.174747
          ],
          [
            14.437211,
            53.254534,
            40.929292
          ],
          [
            14.436882,
            53.254361,
            40.653909
          ],
          [
            14.436821,
            53.254145,
            40.398594
          ],
          [
            14.436851,
            53.253935,
            40.347058
          ],
          [
            14.43689,
            53.253741,
            40.326775
          ],
          [
            14.436936,
            53.253533,
            40.304987
          ],
          [
            14.436976,
            53.253316,
            40.282319
          ],
          [
            14.437019,
            53.253078,
            40.25747
          ],
          [
            14.437024,
            53.252838,
            40.232427
          ],
          [
            14.43721,
            53.252686,
            40.212867
          ],
          [
            14.437411,
            53.25253,
            40.192419
          ],
          [
            14.43758,
            53.252374,
            40.136778
          ],
          [
            14.437587,
            53.252145,
            39.961679
          ],
          [
            14.437378,
            53.25195,
            39.788396
          ],
          [
            14.437216,
            53.251777,
            39.639794
          ],
          [
            14.437004,
            53.251618,
            39.486858
          ],
          [
            14.436776,
            53.251459,
            39.329947
          ],
          [
            14.436567,
            53.251244,
            39.143882
          ],
          [
            14.436371,
            53.251036,
            38.965292
          ],
          [
            14.436183,
            53.250842,
            38.747745
          ],
          [
            14.435981,
            53.250649,
            38.346186
          ],
          [
            14.435798,
            53.250473,
            37.980591
          ],
          [
            14.435615,
            53.250292,
            37.605953
          ],
          [
            14.435434,
            53.250112,
            37.235828
          ],
          [
            14.435237,
            53.249947,
            36.878122
          ],
          [
            14.435053,
            53.249781,
            36.524167
          ],
          [
            14.434825,
            53.249623,
            36.156089
          ],
          [
            14.434619,
            53.24946,
            35.795998
          ],
          [
            14.434439,
            53.249299,
            35.658332
          ],
          [
            14.434261,
            53.249119,
            35.646706
          ],
          [
            14.43406,
            53.248925,
            35.634017
          ],
          [
            14.433879,
            53.248746,
            35.622387
          ],
          [
            14.433747,
            53.24858,
            35.61208
          ],
          [
            14.433568,
            53.248431,
            35.601699
          ],
          [
            14.433193,
            53.248435,
            35.588367
          ],
          [
            14.433142,
            53.248652,
            35.576122
          ],
          [
            14.432864,
            53.24873,
            35.565769
          ],
          [
            14.432757,
            53.248748,
            35.877452
          ],
          [
            14.432748,
            53.248454,
            36.436493
          ],
          [
            14.432879,
            53.248298,
            36.809382
          ],
          [
            14.433038,
            53.248134,
            37.16607
          ],
          [
            14.433273,
            53.248227,
            37.522106
          ],
          [
            14.433043,
            53.248077,
            37.905475
          ],
          [
            14.433172,
            53.248321,
            38.424014
          ],
          [
            14.433166,
            53.248244,
            38.771874
          ],
          [
            14.433096,
            53.248151,
            39.355671
          ],
          [
            14.433231,
            53.248335,
            40.071552
          ],
          [
            14.433144,
            53.248165,
            40.723901
          ],
          [
            14.432836,
            53.248211,
            41.420021
          ],
          [
            14.433137,
            53.248182,
            42.103143
          ],
          [
            14.433421,
            53.248121,
            42.764181
          ],
          [
            14.433725,
            53.248152,
            43.436569
          ],
          [
            14.433406,
            53.248166,
            44.179061
          ],
          [
            14.4332,
            53.248093,
            44.870005
          ],
          [
            14.433146,
            53.248105,
            43.761461
          ],
          [
            14.433127,
            53.248123,
            42.961442
          ],
          [
            14.43241,
            53.24677,
            38.745619
          ],
          [
            14.432275,
            53.246594,
            39.45296
          ],
          [
            14.432109,
            53.246418,
            40.189415
          ],
          [
            14.431947,
            53.246239,
            40.935882
          ],
          [
            14.431632,
            53.246194,
            41.772998
          ],
          [
            14.431335,
            53.246252,
            42.458018
          ],
          [
            14.431083,
            53.246128,
            43.169504
          ],
          [
            14.430789,
            53.246034,
            43.902209
          ],
          [
            14.430473,
            53.246055,
            44.334348
          ],
          [
            14.430284,
            53.246203,
            44.641046
          ],
          [
            14.430196,
            53.24639,
            44.952316
          ],
          [
            14.430167,
            53.246585,
            45.264293
          ],
          [
            14.430183,
            53.24678,
            45.575486
          ],
          [
            14.429987,
            53.246922,
            45.870508
          ],
          [
            14.429682,
            53.247018,
            46.200416
          ],
          [
            14.429384,
            53.247104,
            46.515985
          ],
          [
            14.429056,
            53.247087,
            46.830413
          ],
          [
            14.42877,
            53.24696,
            47.177716
          ],
          [
            14.42858,
            53.246809,
            47.483375
          ],
          [
            14.428373,
            53.246627,
            47.839687
          ],
          [
            14.428194,
            53.246465,
            48.153096
          ],
          [
            14.428031,
            53.246312,
            48.44606
          ],
          [
            14.427861,
            53.246157,
            48.745246
          ],
          [
            14.427718,
            53.245978,
            49.065492
          ],
          [
            14.427533,
            53.245805,
            49.397792
          ],
          [
            14.427359,
            53.245644,
            49.707191
          ],
          [
            14.427232,
            53.245476,
            49.566067
          ],
          [
            14.427065,
            53.245323,
            48.795305
          ],
          [
            14.426903,
            53.245105,
            47.788494
          ],
          [
            14.426824,
            53.244906,
            46.923693
          ],
          [
            14.426754,
            53.244668,
            45.902606
          ],
          [
            14.426685,
            53.244408,
            44.792233
          ],
          [
            14.42662,
            53.244099,
            43.478443
          ],
          [
            14.42654,
            53.243762,
            42.144365
          ],
          [
            14.426515,
            53.243568,
            41.65171
          ],
          [
            14.426493,
            53.243371,
            41.151783
          ],
          [
            14.426453,
            53.243022,
            40.266044
          ],
          [
            14.426391,
            53.242704,
            39.455379
          ],
          [
            14.426328,
            53.242425,
            38.74107
          ],
          [
            14.426196,
            53.242207,
            38.152035
          ],
          [
            14.426022,
            53.242029,
            37.757191
          ],
          [
            14.425803,
            53.241831,
            37.827273
          ],
          [
            14.425621,
            53.241669,
            37.884947
          ],
          [
            14.425482,
            53.241498,
            37.941129
          ],
          [
            14.425292,
            53.24131,
            38.006351
          ],
          [
            14.425113,
            53.241107,
            38.074152
          ],
          [
            14.424928,
            53.240909,
            38.141109
          ],
          [
            14.424763,
            53.240742,
            38.198409
          ],
          [
            14.424502,
            53.240517,
            38.241276
          ],
          [
            14.424443,
            53.240329,
            37.835717
          ],
          [
            14.424576,
            53.240118,
            37.378212
          ],
          [
            14.424658,
            53.239943,
            37.008658
          ],
          [
            14.424706,
            53.23972,
            36.55141
          ],
          [
            14.424709,
            53.239501,
            36.104504
          ],
          [
            14.424605,
            53.239254,
            35.58552
          ],
          [
            14.424401,
            53.239102,
            35.190866
          ],
          [
            14.424167,
            53.238957,
            34.782021
          ],
          [
            14.423964,
            53.238798,
            34.740573
          ],
          [
            14.423879,
            53.238621,
            34.896593
          ],
          [
            14.423639,
            53.238496,
            35.06533
          ],
          [
            14.423349,
            53.238412,
            35.225855
          ],
          [
            14.423035,
            53.238317,
            35.401046
          ],
          [
            14.422735,
            53.238206,
            35.576966
          ],
          [
            14.422506,
            53.238066,
            35.739984
          ],
          [
            14.422196,
            53.237949,
            35.923871
          ],
          [
            14.421912,
            53.237847,
            36.088841
          ],
          [
            14.421587,
            53.237775,
            36.11116
          ],
          [
            14.421219,
            53.237693,
            36.083317
          ],
          [
            14.420886,
            53.237617,
            36.058059
          ],
          [
            14.420583,
            53.237564,
            36.035513
          ],
          [
            14.420252,
            53.237578,
            36.011998
          ],
          [
            14.419933,
            53.237526,
            35.98846
          ],
          [
            14.41961,
            53.237494,
            35.965237
          ],
          [
            14.419281,
            53.237495,
            35.941838
          ],
          [
            14.418921,
            53.237499,
            35.943482
          ],
          [
            14.418548,
            53.237481,
            36.820407
          ],
          [
            14.418207,
            53.237519,
            37.637586
          ],
          [
            14.417895,
            53.237501,
            38.398725
          ],
          [
            14.417539,
            53.23745,
            39.266385
          ],
          [
            14.417259,
            53.237267,
            40.237241
          ],
          [
            14.417026,
            53.237056,
            41.227533
          ],
          [
            14.416758,
            53.236879,
            42.186316
          ],
          [
            14.416397,
            53.236797,
            42.860134
          ],
          [
            14.415984,
            53.236667,
            42.108127
          ],
          [
            14.415692,
            53.236481,
            41.40972
          ],
          [
            14.415597,
            53.236269,
            40.825438
          ],
          [
            14.415427,
            53.236077,
            40.249087
          ],
          [
            14.415007,
            53.236005,
            39.535116
          ],
          [
            14.414601,
            53.236007,
            38.890762
          ],
          [
            14.414243,
            53.235991,
            38.319669
          ],
          [
            14.400385,
            53.211023,
            38.155839
          ],
          [
            14.400201,
            53.210819,
            37.084932
          ],
          [
            14.399996,
            53.210632,
            36.045082
          ],
          [
            14.399707,
            53.210481,
            34.986035
          ],
          [
            14.399567,
            53.210272,
            35.110677
          ],
          [
            14.399472,
            53.210051,
            35.428741
          ],
          [
            14.399403,
            53.209826,
            35.747547
          ],
          [
            14.399382,
            53.209639,
            36.008571
          ],
          [
            14.399315,
            53.209449,
            36.280723
          ],
          [
            14.399135,
            53.209226,
            36.625688
          ],
          [
            14.398937,
            53.209021,
            36.956609
          ],
          [
            14.398747,
            53.208806,
            37.295421
          ],
          [
            14.398545,
            53.208589,
            37.72552
          ],
          [
            14.398358,
            53.2084,
            38.117754
          ],
          [
            14.39815,
            53.208222,
            38.505785
          ],
          [
            14.397948,
            53.208043,
            38.891739
          ],
          [
            14.397678,
            53.207888,
            39.291538
          ],
          [
            14.397391,
            53.207729,
            39.709677
          ],
          [
            14.397063,
            53.207569,
            40.161892
          ],
          [
            14.396748,
            53.207404,
            40.537409
          ],
          [
            14.396456,
            53.207245,
            40.410237
          ],
          [
            14.39615,
            53.207097,
            40.283439
          ],
          [
            14.395859,
            53.206944,
            40.158475
          ],
          [
            14.395559,
            53.206784,
            40.02903
          ],
          [
            14.395235,
            53.206652,
            39.902456
          ],
          [
            14.39486,
            53.206559,
            39.771536
          ],
          [
            14.394476,
            53.20646,
            39.636817
          ],
          [
            14.394137,
            53.206395,
            39.301645
          ],
          [
            14.393855,
            53.206322,
            38.86001
          ],
          [
            14.393485,
            53.20627,
            38.31985
          ],
          [
            14.393141,
            53.206266,
            37.828825
          ],
          [
            14.392792,
            53.206269,
            37.332963
          ],
          [
            14.392475,
            53.206318,
            36.867877
          ],
          [
            14.392151,
            53.20636,
            36.3882
          ],
          [
            14.391827,
            53.206408,
            35.913994
          ],
          [
            14.391455,
            53.20642,
            35.384795
          ],
          [
            14.391149,
            53.206446,
            35.247081
          ],
          [
            14.390813,
            53.20646,
            35.153448
          ],
          [
            14.390471,
            53.20648,
            35.057808
          ],
          [
            14.39016,
            53.206508,
            34.970332
          ],
          [
            14.38978,
            53.206557,
            34.86211
          ],
          [
            14.389448,
            53.206588,
            34.767697
          ],
          [
            14.389087,
            53.206622,
            34.666076
          ],
          [
            14.388771,
            53.206654,
            34.576812
          ],
          [
            14.388443,
            53.206676,
            34.483724
          ],
          [
            14.388055,
            53.206672,
            34.111133
          ],
          [
            14.387669,
            53.206705,
            33.735175
          ],
          [
            14.387317,
            53.206821,
            33.349095
          ],
          [
            14.38697,
            53.206944,
            32.96201
          ],
          [
            14.386594,
            53.207071,
            32.547622
          ],
          [
            14.386212,
            53.207202,
            32.124033
          ],
          [
            14.385882,
            53.207328,
            31.747331
          ],
          [
            14.38564,
            53.207447,
            32.0515
          ],
          [
            14.385404,
            53.207601,
            33.012567
          ],
          [
            14.385249,
            53.2078,
            34.021977
          ],
          [
            14.385141,
            53.207993,
            34.958912
          ],
          [
            14.385124,
            53.208196,
            35.894161
          ],
          [
            14.385132,
            53.208402,
            36.841401
          ],
          [
            14.385108,
            53.208607,
            37.78587
          ],
          [
            14.384786,
            53.208625,
            38.753853
          ],
          [
            14.384477,
            53.208533,
            39.706218
          ],
          [
            14.384255,
            53.208338,
            39.907819
          ],
          [
            14.384071,
            53.208125,
            39.953267
          ],
          [
            14.383898,
            53.207927,
            39.995609
          ],
          [
            14.3837,
            53.207758,
            40.034862
          ],
          [
            14.383434,
            53.207646,
            40.071768
          ],
          [
            14.383143,
            53.207565,
            40.108345
          ],
          [
            14.382817,
            53.207532,
            40.145973
          ],
          [
            14.382517,
            53.207467,
            40.184691
          ],
          [
            14.382359,
            53.20727,
            40.282787
          ],
          [
            14.382414,
            53.207072,
            40.439361
          ],
          [
            14.382493,
            53.206868,
            40.603318
          ],
          [
            14.382667,
            53.206687,
            40.76689
          ],
          [
            14.382966,
            53.206522,
            40.957242
          ],
          [
            14.383191,
            53.206402,
            41.097979
          ],
          [
            14.383517,
            53.206294,
            41.272018
          ],
          [
            14.383862,
            53.206215,
            41.444653
          ],
          [
            14.384383,
            53.20619,
            41.346996
          ],
          [
            14.384707,
            53.206104,
            40.777703
          ],
          [
            14.38501,
            53.206009,
            40.233233
          ],
          [
            14.385325,
            53.205898,
            39.649792
          ],
          [
            14.385546,
            53.205752,
            39.120474
          ],
          [
            14.385325,
            53.2056,
            38.511445
          ],
          [
            14.38493,
            53.205524,
            37.850099
          ],
          [
            14.384525,
            53.205428,
            37.154304
          ],
          [
            14.384162,
            53.205383,
            37.219713
          ],
          [
            14.383807,
            53.205367,
            38.033871
          ],
          [
            14.383424,
            53.20534,
            38.922097
          ],
          [
            14.383103,
            53.205191,
            39.86024
          ],
          [
            14.382798,
            53.20503,
            40.789306
          ],
          [
            14.382474,
            53.204904,
            41.671571
          ],
          [
            14.382116,
            53.204764,
            42.647834
          ],
          [
            14.381758,
            53.204633,
            43.605745
          ],
          [
            14.381397,
            53.204513,
            43.902843
          ],
          [
            14.38102,
            53.204403,
            44.140057
          ],
          [
            14.380637,
            53.204278,
            44.386735
          ],
          [
            14.380266,
            53.204157,
            44.625649
          ],
          [
            14.379916,
            53.204034,
            44.85516
          ],
          [
            14.379574,
            53.203906,
            45.083676
          ],
          [
            14.379265,
            53.20377,
            45.300623
          ],
          [
            14.378926,
            53.203632,
            45.09676
          ],
          [
            14.378612,
            53.203497,
            44.653944
          ],
          [
            14.378342,
            53.203359,
            44.245729
          ],
          [
            14.378049,
            53.203194,
            43.784915
          ],
          [
            14.377745,
            53.203043,
            43.332344
          ],
          [
            14.377504,
            53.202893,
            42.934107
          ],
          [
            14.377248,
            53.202755,
            42.53832
          ],
          [
            14.377023,
            53.202619,
            42.172147
          ],
          [
            14.3768,
            53.202469,
            41.958634
          ],
          [
            14.376541,
            53.202308,
            41.984842
          ],
          [
            14.376312,
            53.202154,
            42.009022
          ],
          [
            14.376071,
            53.201948,
            42.038521
          ],
          [
            14.375874,
            53.2018,
            42.060709
          ],
          [
            14.375692,
            53.201638,
            42.083599
          ],
          [
            14.375526,
            53.201484,
            42.105087
          ],
          [
            14.375342,
            53.201306,
            42.129626
          ],
          [
            14.375169,
            53.201129,
            42.153675
          ],
          [
            14.375017,
            53.200942,
            42.001313
          ],
          [
            14.374874,
            53.200765,
            41.804229
          ],
          [
            14.374734,
            53.200595,
            41.614153
          ],
          [
            14.374566,
            53.200408,
            41.39939
          ],
          [
            14.374416,
            53.200204,
            41.176013
          ],
          [
            14.374282,
            53.200011,
            40.966249
          ],
          [
            14.37415,
            53.199815,
            40.754377
          ],
          [
            14.374062,
            53.199596,
            40.528459
          ],
          [
            14.373969,
            53.199385,
            40.294174
          ],
          [
            14.373908,
            53.199173,
            40.010506
          ],
          [
            14.373873,
            53.198938,
            39.699726
          ],
          [
            14.37385,
            53.198705,
            39.392408
          ],
          [
            14.373868,
            53.198487,
            39.104378
          ],
          [
            14.373878,
            53.198274,
            38.823164
          ],
          [
            14.373875,
            53.198068,
            38.551727
          ],
          [
            14.373902,
            53.19787,
            38.290161
          ],
          [
            14.373902,
            53.197667,
            38.022651
          ],
          [
            14.373935,
            53.197446,
            37.937227
          ],
          [
            14.373952,
            53.197227,
            37.879459
          ],
          [
            14.373957,
            53.197027,
            37.826609
          ],
          [
            14.373986,
            53.196809,
            37.768955
          ],
          [
            14.373944,
            53.19658,
            37.708225
          ],
          [
            14.373936,
            53.196386,
            37.656927
          ],
          [
            14.373933,
            53.196183,
            37.603207
          ],
          [
            14.373911,
            53.195956,
            37.543238
          ],
          [
            14.373878,
            53.19576,
            37.655101
          ],
          [
            14.373872,
            53.195545,
            37.990053
          ],
          [
            14.37383,
            53.195343,
            38.307294
          ],
          [
            14.373799,
            53.195131,
            38.638825
          ],
          [
            14.373765,
            53.194916,
            38.975237
          ],
          [
            14.373743,
            53.194707,
            39.301702
          ],
          [
            14.373733,
            53.19451,
            39.610928
          ],
          [
            14.373714,
            53.194313,
            39.918476
          ],
          [
            14.373655,
            53.194078,
            40.290567
          ],
          [
            14.373615,
            53.193853,
            40.52075
          ],
          [
            14.373576,
            53.193671,
            40.699415
          ],
          [
            14.373527,
            53.193402,
            40.963779
          ],
          [
            14.373502,
            53.193175,
            41.185224
          ],
          [
            14.373418,
            53.192939,
            41.420143
          ],
          [
            14.373354,
            53.192711,
            41.64561
          ],
          [
            14.373285,
            53.192502,
            41.853223
          ],
          [
            14.373192,
            53.192248,
            42.097624
          ],
          [
            14.373141,
            53.19204,
            42.255875
          ],
          [
            14.373077,
            53.191818,
            42.425562
          ],
          [
            14.372985,
            53.191551,
            42.631841
          ],
          [
            14.37293,
            53.191352,
            42.78369
          ],
          [
            14.372898,
            53.191142,
            42.942383
          ],
          [
            14.372855,
            53.190939,
            43.096387
          ],
          [
            14.372791,
            53.190736,
            43.251851
          ],
          [
            14.372715,
            53.190532,
            43.409198
          ],
          [
            14.37266,
            53.190333,
            43.31011
          ],
          [
            14.3726,
            53.190125,
            43.184683
          ],
          [
            14.372531,
            53.189881,
            43.0376
          ],
          [
            14.37245,
            53.189651,
            42.89762
          ],
          [
            14.372384,
            53.189438,
            42.768889
          ],
          [
            14.372336,
            53.189244,
            42.651943
          ],
          [
            14.372282,
            53.189039,
            42.528589
          ],
          [
            14.372222,
            53.188809,
            42.390269
          ],
          [
            14.372145,
            53.188623,
            42.280623
          ],
          [
            14.372107,
            53.188431,
            42.172455
          ],
          [
            14.372089,
            53.188243,
            42.066988
          ],
          [
            14.372059,
            53.188001,
            41.931284
          ],
          [
            14.372033,
            53.187767,
            41.799974
          ],
          [
            14.372024,
            53.187569,
            41.689114
          ],
          [
            14.371996,
            53.187373,
            41.579125
          ],
          [
            14.37199,
            53.187179,
            41.470466
          ],
          [
            14.371972,
            53.186981,
            41.359454
          ],
          [
            14.371975,
            53.186784,
            41.433566
          ],
          [
            14.371945,
            53.186594,
            41.529285
          ],
          [
            14.371901,
            53.186358,
            41.648468
          ],
          [
            14.371857,
            53.186168,
            41.744693
          ],
          [
            14.371809,
            53.18597,
            41.845359
          ],
          [
            14.371731,
            53.185743,
            41.961748
          ],
          [
            14.371666,
            53.185546,
            42.06246
          ],
          [
            14.371568,
            53.18535,
            42.165122
          ],
          [
            14.371503,
            53.185164,
            42.287037
          ],
          [
            14.371402,
            53.184972,
            42.612564
          ],
          [
            14.3713,
            53.18478,
            42.938507
          ],
          [
            14.371163,
            53.184593,
            43.268724
          ],
          [
            14.37101,
            53.184401,
            43.612786
          ],
          [
            14.370849,
            53.184199,
            43.974711
          ],
          [
            14.370641,
            53.184032,
            44.31272
          ],
          [
            14.370457,
            53.183843,
            44.666638
          ],
          [
            14.370296,
            53.183674,
            44.982668
          ],
          [
            14.370064,
            53.183498,
            45.102517
          ],
          [
            14.36988,
            53.183307,
            45.001139
          ],
          [
            14.369701,
            53.183141,
            44.910323
          ],
          [
            14.369505,
            53.182963,
            44.812129
          ],
          [
            14.369284,
            53.182776,
            44.706823
          ],
          [
            14.36909,
            53.182591,
            44.606323
          ],
          [
            14.368913,
            53.18241,
            44.509866
          ],
          [
            14.368769,
            53.182223,
            44.415169
          ],
          [
            14.368636,
            53.182034,
            44.325836
          ],
          [
            14.368502,
            53.18182,
            44.279334
          ],
          [
            14.368377,
            53.181595,
            44.231071
          ],
          [
            14.368241,
            53.181386,
            44.185435
          ],
          [
            14.368129,
            53.181161,
            44.137668
          ],
          [
            14.36802,
            53.180938,
            44.090344
          ],
          [
            14.3679,
            53.180711,
            44.041899
          ],
          [
            14.367791,
            53.180464,
            43.989918
          ],
          [
            14.367733,
            53.180252,
            43.834607
          ],
          [
            14.367663,
            53.180033,
            43.506355
          ],
          [
            14.367616,
            53.179798,
            43.158087
          ],
          [
            14.367575,
            53.179567,
            42.816323
          ],
          [
            14.367524,
            53.179351,
            42.494328
          ],
          [
            14.367504,
            53.179121,
            42.154212
          ],
          [
            14.367481,
            53.178893,
            41.81785
          ],
          [
            14.367477,
            53.178663,
            41.479454
          ],
          [
            14.367459,
            53.178411,
            41.439973
          ],
          [
            14.367443,
            53.178155,
            41.659323
          ],
          [
            14.367445,
            53.177935,
            41.847696
          ],
          [
            14.367455,
            53.177721,
            42.030976
          ],
          [
            14.367444,
            53.177462,
            42.252807
          ],
          [
            14.36742,
            53.177222,
            42.458648
          ],
          [
            14.367396,
            53.177006,
            42.64397
          ],
          [
            14.367351,
            53.176795,
            42.82607
          ],
          [
            14.367315,
            53.17657,
            42.709047
          ],
          [
            14.367272,
            53.176353,
            42.53732
          ],
          [
            14.367224,
            53.176122,
            42.354426
          ],
          [
            14.367148,
            53.175884,
            42.163953
          ],
          [
            14.367056,
            53.175637,
            41.965099
          ],
          [
            14.366971,
            53.17539,
            41.766941
          ],
          [
            14.366878,
            53.175151,
            41.574123
          ],
          [
            14.366787,
            53.174925,
            41.491905
          ],
          [
            14.366726,
            53.174716,
            41.640818
          ],
          [
            14.366642,
            53.174483,
            41.808157
          ],
          [
            14.366536,
            53.174249,
            41.978285
          ],
          [
            14.366411,
            53.174019,
            42.14813
          ],
          [
            14.366279,
            53.173791,
            42.317469
          ],
          [
            14.366173,
            53.173577,
            42.47413
          ],
          [
            14.366045,
            53.173363,
            42.633642
          ],
          [
            14.365911,
            53.173132,
            42.869638
          ],
          [
            14.365786,
            53.172928,
            43.12159
          ],
          [
            14.365669,
            53.172691,
            43.408047
          ],
          [
            14.365568,
            53.172479,
            43.663849
          ],
          [
            14.36546,
            53.172277,
            43.909672
          ],
          [
            14.365364,
            53.172046,
            44.186185
          ],
          [
            14.365237,
            53.171815,
            44.468206
          ],
          [
            14.365151,
            53.171559,
            44.770889
          ],
          [
            14.365067,
            53.171306,
            44.648667
          ],
          [
            14.364993,
            53.171088,
            44.517229
          ],
          [
            14.364964,
            53.170871,
            44.388598
          ],
          [
            14.364953,
            53.170625,
            44.243176
          ],
          [
            14.364953,
            53.170377,
            44.096643
          ],
          [
            14.364954,
            53.170115,
            43.941784
          ],
          [
            14.364982,
            53.169865,
            43.793745
          ],
          [
            14.36502,
            53.169644,
            43.700793
          ],
          [
            14.365083,
            53.169396,
            43.638887
          ],
          [
            14.365166,
            53.169144,
            43.575441
          ],
          [
            14.365243,
            53.168886,
            43.510764
          ],
          [
            14.365328,
            53.168684,
            43.459356
          ],
          [
            14.365446,
            53.168431,
            43.39449
          ],
          [
            14.365527,
            53.168197,
            43.335501
          ],
          [
            14.365642,
            53.167943,
            43.17077
          ],
          [
            14.36573,
            53.167718,
            42.704599
          ],
          [
            14.365819,
            53.1675,
            42.25133
          ],
          [
            14.365873,
            53.167254,
            41.749651
          ],
          [
            14.365909,
            53.167013,
            41.261099
          ],
          [
            14.365954,
            53.16678,
            40.787646
          ],
          [
            14.366029,
            53.166535,
            40.285109
          ],
          [
            14.366059,
            53.16628,
            39.769444
          ],
          [
            14.366078,
            53.166017,
            40.061545
          ],
          [
            14.366068,
            53.16576,
            40.565384
          ],
          [
            14.366032,
            53.165502,
            41.072015
          ],
          [
            14.365994,
            53.165284,
            41.502289
          ],
          [
            14.365992,
            53.165082,
            41.897503
          ],
          [
            14.365955,
            53.164862,
            42.330103
          ],
          [
            14.365921,
            53.164628,
            42.789632
          ],
          [
            14.365893,
            53.164384,
            43.211558
          ],
          [
            14.365819,
            53.164157,
            43.388785
          ],
          [
            14.365723,
            53.163926,
            43.571138
          ],
          [
            14.365623,
            53.163691,
            43.757166
          ],
          [
            14.365526,
            53.163476,
            43.927816
          ],
          [
            14.365396,
            53.163247,
            44.113169
          ],
          [
            14.365259,
            53.163044,
            44.280949
          ],
          [
            14.365141,
            53.162864,
            44.429157
          ],
          [
            14.364982,
            53.162657,
            44.408247
          ],
          [
            14.364804,
            53.162427,
            43.859918
          ],
          [
            14.364633,
            53.162244,
            43.406216
          ],
          [
            14.36449,
            53.162036,
            42.918309
          ],
          [
            14.364331,
            53.161847,
            42.460246
          ],
          [
            14.364113,
            53.161629,
            41.910456
          ],
          [
            14.363884,
            53.161414,
            41.358633
          ],
          [
            14.363654,
            53.161201,
            40.808805
          ],
          [
            14.363426,
            53.160999,
            40.709622
          ],
          [
            14.363171,
            53.160791,
            40.777894
          ],
          [
            14.362895,
            53.16059,
            40.846758
          ],
          [
            14.362613,
            53.160402,
            40.913631
          ],
          [
            14.362279,
            53.160227,
            40.983986
          ],
          [
            14.361965,
            53.160051,
            41.052144
          ],
          [
            14.361721,
            53.159938,
            41.101091
          ],
          [
            14.361394,
            53.159767,
            41.291061
          ],
          [
            14.361072,
            53.159603,
            41.616654
          ],
          [
            14.360738,
            53.159433,
            41.954301
          ],
          [
            14.360419,
            53.159273,
            42.274816
          ],
          [
            14.36012,
            53.159115,
            42.581963
          ],
          [
            14.35981,
            53.158955,
            42.897211
          ],
          [
            14.359546,
            53.158802,
            43.180231
          ],
          [
            14.359269,
            53.15861,
            43.450123
          ],
          [
            14.359016,
            53.158426,
            43.44862
          ],
          [
            14.35877,
            53.158228,
            43.447062
          ],
          [
            14.358536,
            53.158027,
            43.445518
          ],
          [
            14.358291,
            53.15783,
            43.443969
          ],
          [
            14.358074,
            53.157621,
            43.442418
          ],
          [
            14.357871,
            53.157423,
            43.440954
          ],
          [
            14.357682,
            53.157221,
            43.439495
          ],
          [
            14.357521,
            53.15699,
            43.288384
          ],
          [
            14.357335,
            53.156782,
            43.09406
          ],
          [
            14.357177,
            53.156574,
            42.905585
          ],
          [
            14.357013,
            53.156351,
            42.704992
          ],
          [
            14.356847,
            53.156119,
            42.49714
          ],
          [
            14.356692,
            53.155888,
            42.292164
          ],
          [
            14.356553,
            53.155658,
            42.090816
          ],
          [
            14.356439,
            53.15547,
            41.977636
          ],
          [
            14.356314,
            53.155251,
            42.086696
          ],
          [
            14.356217,
            53.155016,
            42.200717
          ],
          [
            14.356121,
            53.154759,
            42.324759
          ],
          [
            14.356064,
            53.154526,
            42.435679
          ],
          [
            14.356025,
            53.154332,
            42.527779
          ],
          [
            14.355984,
            53.154116,
            42.63018
          ],
          [
            14.35595,
            53.153895,
            42.734724
          ],
          [
            14.355967,
            53.153672,
            42.855075
          ],
          [
            14.355993,
            53.153432,
            43.019194
          ],
          [
            14.355993,
            53.153185,
            43.187715
          ],
          [
            14.355887,
            53.152954,
            43.35232
          ],
          [
            14.355581,
            53.152795,
            43.520366
          ],
          [
            14.355186,
            53.152738,
            43.686923
          ],
          [
            14.354804,
            53.152734,
            43.843382
          ],
          [
            14.354407,
            53.152743,
            44.005992
          ],
          [
            14.354027,
            53.152752,
            43.904303
          ],
          [
            14.353644,
            53.152756,
            43.747149
          ],
          [
            14.35324,
            53.152777,
            43.580742
          ],
          [
            14.35281,
            53.15278,
            43.404185
          ],
          [
            14.352433,
            53.152792,
            43.24922
          ],
          [
            14.352062,
            53.152815,
            43.096039
          ],
          [
            14.351699,
            53.152809,
            42.94704
          ],
          [
            14.351314,
            53.152812,
            42.8037
          ],
          [
            14.351013,
            53.152819,
            42.811914
          ],
          [
            14.350637,
            53.152821,
            42.822163
          ],
          [
            14.350185,
            53.152817,
            42.834485
          ],
          [
            14.349754,
            53.152796,
            42.846288
          ],
          [
            14.349358,
            53.152764,
            42.857175
          ],
          [
            14.348975,
            53.152735,
            42.867715
          ],
          [
            14.348629,
            53.152763,
            42.87733
          ],
          [
            14.348308,
            53.152812,
            42.884218
          ],
          [
            14.347944,
            53.152832,
            42.882651
          ],
          [
            14.347602,
            53.152886,
            42.881138
          ],
          [
            14.347306,
            53.152986,
            42.879683
          ],
          [
            14.347048,
            53.15313,
            42.878165
          ],
          [
            14.346847,
            53.153283,
            42.876773
          ],
          [
            14.346663,
            53.153445,
            42.875373
          ],
          [
            14.346521,
            53.153636,
            42.873877
          ],
          [
            14.346303,
            53.15348,
            42.872335
          ],
          [
            14.346194,
            53.153262,
            43.191856
          ],
          [
            14.346186,
            53.153055,
            43.683238
          ],
          [
            14.346149,
            53.152863,
            44.1456
          ],
          [
            14.346072,
            53.15267,
            44.616653
          ],
          [
            14.346002,
            53.152468,
            45.106787
          ],
          [
            14.345916,
            53.152253,
            45.632928
          ],
          [
            14.345793,
            53.15208,
            46.079567
          ],
          [
            14.345674,
            53.151875,
            46.594751
          ],
          [
            14.345622,
            53.151666,
            47.096373
          ],
          [
            14.345509,
            53.151452,
            47.194416
          ],
          [
            14.345437,
            53.151172,
            47.268337
          ],
          [
            14.345351,
            53.150902,
            47.340097
          ],
          [
            14.345214,
            53.150696,
            47.399502
          ],
          [
            14.345155,
            53.150472,
            47.45865
          ],
          [
            14.345054,
            53.150287,
            47.510121
          ],
          [
            14.344972,
            53.150069,
            47.568405
          ],
          [
            14.344894,
            53.14984,
            48.016301
          ],
          [
            14.344796,
            53.149611,
            49.252838
          ],
          [
            14.344703,
            53.149407,
            50.35896
          ],
          [
            14.344666,
            53.149205,
            51.422014
          ],
          [
            14.344603,
            53.149006,
            52.481417
          ],
          [
            14.344498,
            53.148809,
            53.563909
          ],
          [
            14.344395,
            53.148591,
            54.751143
          ],
          [
            14.344296,
            53.14836,
            55.998918
          ],
          [
            14.344173,
            53.148109,
            57.026268
          ],
          [
            14.34408,
            53.147915,
            57.056947
          ],
          [
            14.344027,
            53.14772,
            57.086912
          ],
          [
            14.343923,
            53.147533,
            57.116852
          ],
          [
            14.343865,
            53.147339,
            57.146744
          ],
          [
            14.343769,
            53.147104,
            57.183442
          ],
          [
            14.343657,
            53.146847,
            57.22374
          ],
          [
            14.343569,
            53.146641,
            57.255991
          ],
          [
            14.34347,
            53.146379,
            57.101088
          ],
          [
            14.343393,
            53.146087,
            56.021076
          ],
          [
            14.343305,
            53.145882,
            55.258232
          ],
          [
            14.343257,
            53.145693,
            54.562829
          ],
          [
            14.343164,
            53.145488,
            53.799066
          ],
          [
            14.343055,
            53.145262,
            52.953244
          ],
          [
            14.342933,
            53.145032,
            52.084305
          ],
          [
            14.342785,
            53.144814,
            51.2378
          ],
          [
            14.342711,
            53.144581,
            50.912229
          ],
          [
            14.342598,
            53.144355,
            51.085087
          ],
          [
            14.342513,
            53.144078,
            51.291479
          ],
          [
            14.342416,
            53.143854,
            51.461472
          ],
          [
            14.342347,
            53.143644,
            51.61817
          ],
          [
            14.342264,
            53.143427,
            51.78117
          ],
          [
            14.34218,
            53.143186,
            51.961463
          ],
          [
            14.342074,
            53.142947,
            52.132128
          ],
          [
            14.341982,
            53.142722,
            51.698976
          ],
          [
            14.341845,
            53.142529,
            51.301184
          ],
          [
            14.341785,
            53.142338,
            50.937857
          ],
          [
            14.341683,
            53.142131,
            50.533628
          ],
          [
            14.341594,
            53.141919,
            50.125093
          ],
          [
            14.341564,
            53.141718,
            49.748249
          ],
          [
            14.341449,
            53.141487,
            49.297414
          ],
          [
            14.341348,
            53.141265,
            48.866487
          ],
          [
            14.341262,
            53.141044,
            49.240329
          ],
          [
            14.341151,
            53.14082,
            49.832146
          ],
          [
            14.341054,
            53.14063,
            50.33535
          ],
          [
            14.340967,
            53.140429,
            50.861247
          ],
          [
            14.340888,
            53.140198,
            51.462293
          ],
          [
            14.340799,
            53.139988,
            52.011089
          ],
          [
            14.340721,
            53.139793,
            52.520189
          ],
          [
            14.340648,
            53.139594,
            53.036415
          ],
          [
            14.340543,
            53.139384,
            52.965823
          ],
          [
            14.340409,
            53.13912,
            51.955955
          ],
          [
            14.340308,
            53.138872,
            51.01454
          ],
          [
            14.340226,
            53.138638,
            50.136742
          ],
          [
            14.340123,
            53.13841,
            49.269092
          ],
          [
            14.340046,
            53.138176,
            48.394218
          ],
          [
            14.339959,
            53.137928,
            47.46383
          ],
          [
            14.33989,
            53.137742,
            46.763727
          ],
          [
            14.339786,
            53.137457,
            46.752636
          ],
          [
            14.339704,
            53.137214,
            46.751546
          ],
          [
            14.33959,
            53.13698,
            46.750479
          ],
          [
            14.339472,
            53.136732,
            46.74935
          ],
          [
            14.339403,
            53.136526,
            46.74843
          ],
          [
            14.33932,
            53.136313,
            46.747471
          ],
          [
            14.339209,
            53.13613,
            46.746619
          ],
          [
            14.339123,
            53.1359,
            46.161698
          ],
          [
            14.339054,
            53.135647,
            44.68695
          ],
          [
            14.338956,
            53.135437,
            43.433422
          ],
          [
            14.338877,
            53.135215,
            42.128882
          ],
          [
            14.338744,
            53.134991,
            40.757075
          ],
          [
            14.338642,
            53.13477,
            39.435893
          ],
          [
            14.33861,
            53.134566,
            38.25882
          ],
          [
            14.338512,
            53.134381,
            37.143573
          ],
          [
            14.338583,
            53.134216,
            35.738397
          ],
          [
            14.338934,
            53.134213,
            34.274304
          ],
          [
            14.339309,
            53.134084,
            32.420698
          ],
          [
            14.339725,
            53.134004,
            30.560017
          ],
          [
            14.340116,
            53.133968,
            28.888013
          ],
          [
            14.340553,
            53.133871,
            26.939896
          ],
          [
            14.341009,
            53.133758,
            24.880479
          ],
          [
            14.341409,
            53.133672,
            23.859236
          ],
          [
            14.341813,
            53.133612,
            23.750218
          ],
          [
            14.342232,
            53.133536,
            23.635659
          ],
          [
            14.342619,
            53.133494,
            23.532736
          ],
          [
            14.342999,
            53.133436,
            23.430114
          ],
          [
            14.343331,
            53.133365,
            23.337292
          ],
          [
            14.343755,
            53.133323,
            23.22476
          ],
          [
            14.344075,
            53.133269,
            23.136792
          ],
          [
            14.344432,
            53.13322,
            23.799558
          ],
          [
            14.344824,
            53.133132,
            24.668111
          ],
          [
            14.345271,
            53.133075,
            25.627257
          ],
          [
            14.345627,
            53.133023,
            26.395389
          ],
          [
            14.346012,
            53.132947,
            27.236837
          ],
          [
            14.346405,
            53.132855,
            28.112689
          ],
          [
            14.346747,
            53.132807,
            28.842536
          ],
          [
            14.347087,
            53.132772,
            29.765049
          ],
          [
            14.347433,
            53.132726,
            31.151318
          ],
          [
            14.347738,
            53.132697,
            32.359188
          ],
          [
            14.348077,
            53.132616,
            33.781443
          ],
          [
            14.348381,
            53.132518,
            35.126955
          ],
          [
            14.348695,
            53.132419,
            36.513691
          ],
          [
            14.349018,
            53.132363,
            37.824108
          ],
          [
            14.349252,
            53.132195,
            39.278139
          ],
          [
            14.34913,
            53.13201,
            40.585345
          ],
          [
            14.348987,
            53.131814,
            41.279596
          ],
          [
            14.348825,
            53.131569,
            41.730623
          ],
          [
            14.348661,
            53.131363,
            42.121025
          ],
          [
            14.348506,
            53.13116,
            42.502897
          ],
          [
            14.348297,
            53.130957,
            42.911698
          ],
          [
            14.348174,
            53.130763,
            43.266542
          ],
          [
            14.348028,
            53.130577,
            43.618734
          ],
          [
            14.347872,
            53.130373,
            44.003192
          ],
          [
            14.34774,
            53.130186,
            44.167865
          ],
          [
            14.347562,
            53.130002,
            44.261681
          ],
          [
            14.347426,
            53.129827,
            44.346556
          ],
          [
            14.347283,
            53.129639,
            44.437508
          ],
          [
            14.347125,
            53.12946,
            44.526506
          ],
          [
            14.346973,
            53.12928,
            44.615192
          ],
          [
            14.346782,
            53.129077,
            44.71764
          ],
          [
            14.346566,
            53.128945,
            44.79905
          ],
          [
            14.346339,
            53.128616,
            44.830241
          ],
          [
            14.34615,
            53.12841,
            44.719889
          ],
          [
            14.34597,
            53.128211,
            44.613829
          ],
          [
            14.345802,
            53.128021,
            44.512606
          ],
          [
            14.345686,
            53.127841,
            44.422143
          ],
          [
            14.345537,
            53.127625,
            44.31212
          ],
          [
            14.345377,
            53.127399,
            44.196968
          ],
          [
            14.345264,
            53.127189,
            44.093509
          ],
          [
            14.345152,
            53.127011,
            44.162523
          ],
          [
            14.345056,
            53.126786,
            44.413089
          ],
          [
            14.344947,
            53.126589,
            44.636242
          ],
          [
            14.344824,
            53.126365,
            44.88984
          ],
          [
            14.344689,
            53.126171,
            45.115817
          ],
          [
            14.344616,
            53.125973,
            45.334785
          ],
          [
            14.34452,
            53.125763,
            45.569018
          ],
          [
            14.344459,
            53.125552,
            45.799369
          ],
          [
            14.344364,
            53.125362,
            45.99921
          ],
          [
            14.344283,
            53.125159,
            46.11291
          ],
          [
            14.344181,
            53.12494,
            46.23682
          ],
          [
            14.344092,
            53.124723,
            46.358563
          ],
          [
            14.344036,
            53.124533,
            46.463829
          ],
          [
            14.34396,
            53.124276,
            46.606183
          ],
          [
            14.343902,
            53.124068,
            46.721069
          ],
          [
            14.343836,
            53.123853,
            46.84016
          ],
          [
            14.343795,
            53.12363,
            46.962365
          ],
          [
            14.343751,
            53.123391,
            46.463814
          ],
          [
            14.343694,
            53.123156,
            45.958288
          ],
          [
            14.343647,
            53.122917,
            45.446078
          ],
          [
            14.343571,
            53.122672,
            44.915023
          ],
          [
            14.34352,
            53.122428,
            44.391634
          ],
          [
            14.343462,
            53.12217,
            43.837521
          ],
          [
            14.343408,
            53.121924,
            43.309314
          ],
          [
            14.343355,
            53.121661,
            43.307306
          ],
          [
            14.343312,
            53.12139,
            43.558851
          ],
          [
            14.343239,
            53.121116,
            43.81525
          ],
          [
            14.343162,
            53.120855,
            44.060195
          ],
          [
            14.343113,
            53.1206,
            44.297378
          ],
          [
            14.343063,
            53.120348,
            44.5319
          ],
          [
            14.34301,
            53.120083,
            44.778525
          ],
          [
            14.342972,
            53.119818,
            44.759625
          ],
          [
            14.342931,
            53.119573,
            44.719988
          ],
          [
            14.342835,
            53.11935,
            44.682944
          ],
          [
            14.342772,
            53.119108,
            44.643563
          ],
          [
            14.342713,
            53.118839,
            44.599939
          ],
          [
            14.342641,
            53.118578,
            44.557404
          ],
          [
            14.342562,
            53.118338,
            44.517943
          ],
          [
            14.342491,
            53.118098,
            44.322755
          ],
          [
            14.342404,
            53.117845,
            44.071872
          ],
          [
            14.342305,
            53.11758,
            43.808045
          ],
          [
            14.342231,
            53.11735,
            43.580556
          ],
          [
            14.342182,
            53.117096,
            43.331919
          ],
          [
            14.342122,
            53.116854,
            43.094008
          ],
          [
            14.342047,
            53.116631,
            42.872628
          ],
          [
            14.341964,
            53.116401,
            42.961874
          ],
          [
            14.341904,
            53.116142,
            43.386758
          ],
          [
            14.341852,
            53.115884,
            43.809183
          ],
          [
            14.341791,
            53.115613,
            44.254062
          ],
          [
            14.341726,
            53.11536,
            44.67004
          ],
          [
            14.34167,
            53.115097,
            45.100764
          ],
          [
            14.341614,
            53.114865,
            45.481901
          ],
          [
            14.341587,
            53.114611,
            45.650057
          ],
          [
            14.341499,
            53.114363,
            45.581973
          ],
          [
            14.34143,
            53.114116,
            45.514721
          ],
          [
            14.341359,
            53.113885,
            45.451646
          ],
          [
            14.341307,
            53.113668,
            45.392722
          ],
          [
            14.341261,
            53.113452,
            45.334234
          ],
          [
            14.341214,
            53.113265,
            45.283363
          ],
          [
            14.34114,
            53.113012,
            45.214378
          ],
          [
            14.34106,
            53.112746,
            44.835655
          ],
          [
            14.341015,
            53.112552,
            44.515332
          ],
          [
            14.340978,
            53.112356,
            44.192792
          ],
          [
            14.340937,
            53.112175,
            43.891837
          ],
          [
            14.340915,
            53.111974,
            43.562442
          ],
          [
            14.340883,
            53.111736,
            43.172019
          ],
          [
            14.340861,
            53.111555,
            42.875233
          ],
          [
            14.340875,
            53.111356,
            42.548837
          ],
          [
            14.340841,
            53.111127,
            42.294071
          ],
          [
            14.340801,
            53.110884,
            42.443198
          ],
          [
            14.340776,
            53.110642,
            42.591134
          ],
          [
            14.340736,
            53.110393,
            42.743741
          ],
          [
            14.340685,
            53.110166,
            42.883632
          ],
          [
            14.340666,
            53.109946,
            43.018059
          ],
          [
            14.340669,
            53.109737,
            43.14557
          ],
          [
            14.340648,
            53.109531,
            43.271477
          ],
          [
            14.340615,
            53.10934,
            43.284757
          ],
          [
            14.34047,
            53.109154,
            42.975154
          ],
          [
            14.340276,
            53.108983,
            42.666986
          ],
          [
            14.34018,
            53.108795,
            42.375439
          ],
          [
            14.340086,
            53.108545,
            41.995373
          ],
          [
            14.339918,
            53.108287,
            41.58469
          ],
          [
            14.339769,
            53.108049,
            41.207724
          ],
          [
            14.339659,
            53.1078,
            40.8257
          ],
          [
            14.339526,
            53.107605,
            40.675716
          ],
          [
            14.339462,
            53.107389,
            40.64617
          ],
          [
            14.339395,
            53.107172,
            40.616502
          ],
          [
            14.339323,
            53.106936,
            40.584199
          ],
          [
            14.339227,
            53.10668,
            40.548925
          ],
          [
            14.339111,
            53.10643,
            40.514043
          ],
          [
            14.339019,
            53.106206,
            40.483034
          ],
          [
            14.338968,
            53.105986,
            40.453176
          ],
          [
            14.338937,
            53.105762,
            40.241994
          ],
          [
            14.338909,
            53.105547,
            40.020646
          ],
          [
            14.338871,
            53.105274,
            39.739488
          ],
          [
            14.338767,
            53.105004,
            39.455116
          ],
          [
            14.33861,
            53.104751,
            39.178065
          ],
          [
            14.338476,
            53.104489,
            38.896611
          ],
          [
            14.338311,
            53.104224,
            38.606297
          ],
          [
            14.338162,
            53.103942,
            38.797752
          ],
          [
            14.338032,
            53.10369,
            38.970777
          ],
          [
            14.337877,
            53.103436,
            39.148425
          ],
          [
            14.337718,
            53.103173,
            39.331992
          ],
          [
            14.337578,
            53.102935,
            39.497539
          ],
          [
            14.337437,
            53.102697,
            39.663261
          ],
          [
            14.337318,
            53.102453,
            39.798821
          ],
          [
            14.337179,
            53.102216,
            39.850605
          ],
          [
            14.337014,
            53.101984,
            39.902627
          ],
          [
            14.33685,
            53.101784,
            39.948613
          ],
          [
            14.336731,
            53.101541,
            40.000874
          ],
          [
            14.336589,
            53.101319,
            40.049885
          ],
          [
            14.336458,
            53.101095,
            40.098834
          ],
          [
            14.336323,
            53.100877,
            40.146767
          ],
          [
            14.336215,
            53.100649,
            39.91889
          ],
          [
            14.336099,
            53.100438,
            39.654718
          ],
          [
            14.335983,
            53.100205,
            39.36532
          ],
          [
            14.335866,
            53.099971,
            39.074459
          ],
          [
            14.335779,
            53.099745,
            38.798332
          ],
          [
            14.335639,
            53.099529,
            38.522796
          ],
          [
            14.335491,
            53.099297,
            38.225918
          ],
          [
            14.335356,
            53.099086,
            37.920614
          ],
          [
            14.335211,
            53.098862,
            37.459548
          ],
          [
            14.335071,
            53.098625,
            36.97717
          ],
          [
            14.334945,
            53.098399,
            36.520316
          ],
          [
            14.334814,
            53.098157,
            36.032439
          ],
          [
            14.334644,
            53.097948,
            35.580054
          ],
          [
            14.334519,
            53.097729,
            35.136222
          ],
          [
            14.334402,
            53.097492,
            34.660286
          ],
          [
            14.334245,
            53.097293,
            35.296692
          ],
          [
            14.334125,
            53.09708,
            36.248132
          ],
          [
            14.33402,
            53.096863,
            37.202252
          ],
          [
            14.33389,
            53.09666,
            38.119607
          ],
          [
            14.333763,
            53.096428,
            39.153139
          ],
          [
            14.333651,
            53.096173,
            40.266518
          ],
          [
            14.333515,
            53.095961,
            41.224326
          ],
          [
            14.333391,
            53.09575,
            42.154811
          ],
          [
            14.333271,
            53.095509,
            42.583192
          ],
          [
            14.333125,
            53.095299,
            42.981641
          ],
          [
            14.333031,
            53.095066,
            43.389914
          ],
          [
            14.332869,
            53.094873,
            43.758939
          ],
          [
            14.332717,
            53.094673,
            44.133567
          ],
          [
            14.332576,
            53.094443,
            44.551041
          ],
          [
            14.332475,
            53.094211,
            44.964486
          ],
          [
            14.332357,
            53.094002,
            45.133783
          ],
          [
            14.33224,
            53.093817,
            44.946642
          ],
          [
            14.332134,
            53.093615,
            44.745354
          ],
          [
            14.332,
            53.09341,
            44.537507
          ],
          [
            14.331851,
            53.09322,
            44.339333
          ],
          [
            14.331719,
            53.092997,
            44.116006
          ],
          [
            14.331577,
            53.092801,
            43.91408
          ],
          [
            14.331439,
            53.09259,
            43.700044
          ],
          [
            14.331267,
            53.092395,
            43.450217
          ],
          [
            14.331136,
            53.092197,
            42.82624
          ],
          [
            14.331008,
            53.091993,
            42.187504
          ],
          [
            14.330874,
            53.091796,
            41.564334
          ],
          [
            14.330761,
            53.091584,
            40.91248
          ],
          [
            14.330589,
            53.091398,
            40.289436
          ],
          [
            14.330435,
            53.091204,
            39.658508
          ],
          [
            14.330304,
            53.091029,
            39.089305
          ],
          [
            14.330169,
            53.090849,
            38.510475
          ],
          [
            14.329985,
            53.090649,
            38.136244
          ],
          [
            14.329841,
            53.090438,
            37.957909
          ],
          [
            14.329683,
            53.09022,
            37.772288
          ],
          [
            14.329558,
            53.090001,
            37.591558
          ],
          [
            14.329363,
            53.089763,
            37.384477
          ],
          [
            14.329191,
            53.089566,
            37.209804
          ],
          [
            14.329069,
            53.0893,
            36.994419
          ],
          [
            14.328962,
            53.089057,
            36.879284
          ],
          [
            14.328847,
            53.088837,
            37.051321
          ],
          [
            14.328731,
            53.088593,
            37.240264
          ],
          [
            14.32863,
            53.088374,
            37.409498
          ],
          [
            14.328525,
            53.088188,
            37.556081
          ],
          [
            14.328395,
            53.087984,
            37.719025
          ],
          [
            14.328259,
            53.087777,
            37.884796
          ],
          [
            14.328157,
            53.087561,
            38.051982
          ],
          [
            14.328052,
            53.087362,
            38.204884
          ],
          [
            14.327987,
            53.087133,
            38.362682
          ],
          [
            14.327907,
            53.086895,
            38.527295
          ],
          [
            14.327793,
            53.086662,
            38.692024
          ],
          [
            14.327698,
            53.086461,
            38.83373
          ],
          [
            14.327574,
            53.086273,
            38.971156
          ],
          [
            14.327446,
            53.086053,
            39.129553
          ],
          [
            14.327312,
            53.085841,
            39.283396
          ],
          [
            14.327206,
            53.08564,
            39.42689
          ],
          [
            14.32708,
            53.085434,
            39.577182
          ],
          [
            14.326967,
            53.085238,
            39.719253
          ],
          [
            14.326859,
            53.085029,
            39.869117
          ],
          [
            14.326733,
            53.084825,
            40.018534
          ],
          [
            14.326611,
            53.084619,
            40.168482
          ],
          [
            14.326502,
            53.084417,
            40.313933
          ],
          [
            14.326366,
            53.084217,
            40.461882
          ],
          [
            14.32626,
            53.083979,
            40.629744
          ],
          [
            14.326123,
            53.083749,
            40.573133
          ],
          [
            14.32597,
            53.08354,
            40.52021
          ],
          [
            14.325823,
            53.083312,
            40.463532
          ],
          [
            14.325698,
            53.083068,
            40.404325
          ],
          [
            14.325539,
            53.082846,
            40.34831
          ],
          [
            14.325402,
            53.082603,
            40.288859
          ],
          [
            14.325245,
            53.082374,
            40.231395
          ],
          [
            14.325132,
            53.082157,
            40.254268
          ],
          [
            14.324986,
            53.081937,
            40.319592
          ],
          [
            14.324847,
            53.081712,
            40.385785
          ],
          [
            14.32471,
            53.081493,
            40.450304
          ],
          [
            14.324576,
            53.08129,
            40.510528
          ],
          [
            14.324431,
            53.081103,
            40.567437
          ],
          [
            14.324323,
            53.08092,
            40.6211
          ],
          [
            14.324169,
            53.080724,
            40.681353
          ],
          [
            14.324059,
            53.080544,
            40.646083
          ],
          [
            14.323939,
            53.080322,
            40.484145
          ],
          [
            14.3238,
            53.080154,
            40.353987
          ],
          [
            14.32365,
            53.079937,
            40.190931
          ],
          [
            14.323508,
            53.079716,
            40.026252
          ],
          [
            14.323374,
            53.079504,
            39.868919
          ],
          [
            14.32326,
            53.079308,
            39.72485
          ],
          [
            14.32311,
            53.079108,
            39.572402
          ],
          [
            14.323006,
            53.078888,
            39.531933
          ],
          [
            14.322924,
            53.07869,
            39.741853
          ],
          [
            14.322853,
            53.078492,
            39.949965
          ],
          [
            14.322753,
            53.078273,
            40.18333
          ],
          [
            14.322673,
            53.078053,
            40.414813
          ],
          [
            14.322583,
            53.077831,
            40.650476
          ],
          [
            14.322465,
            53.077613,
            40.88609
          ],
          [
            14.322351,
            53.07739,
            41.126718
          ],
          [
            14.322263,
            53.077168,
            41.263419
          ],
          [
            14.322187,
            53.076932,
            41.046589
          ],
          [
            14.322116,
            53.076741,
            40.870115
          ],
          [
            14.322019,
            53.07651,
            40.655175
          ],
          [
            14.321976,
            53.076304,
            40.467699
          ],
          [
            14.321927,
            53.076097,
            40.279027
          ],
          [
            14.321851,
            53.075901,
            40.097574
          ],
          [
            14.321761,
            53.07569,
            39.900623
          ],
          [
            14.321699,
            53.075477,
            39.705541
          ],
          [
            14.32166,
            53.075262,
            39.531523
          ],
          [
            14.321574,
            53.075061,
            39.366666
          ],
          [
            14.321519,
            53.07484,
            39.189005
          ],
          [
            14.321495,
            53.074612,
            39.007501
          ],
          [
            14.321453,
            53.074379,
            38.821256
          ],
          [
            14.321407,
            53.074156,
            38.642677
          ],
          [
            14.321362,
            53.073927,
            38.459417
          ],
          [
            14.321337,
            53.073702,
            38.279758
          ],
          [
            14.321298,
            53.07348,
            38.530909
          ],
          [
            14.321261,
            53.073268,
            38.825435
          ],
          [
            14.321205,
            53.073064,
            39.110955
          ],
          [
            14.32114,
            53.072865,
            39.390978
          ],
          [
            14.321123,
            53.072647,
            39.692594
          ],
          [
            14.321103,
            53.072435,
            39.985797
          ],
          [
            14.32106,
            53.072251,
            40.243697
          ],
          [
            14.321006,
            53.07202,
            40.565804
          ],
          [
            14.320994,
            53.071817,
            40.905765
          ],
          [
            14.320955,
            53.071554,
            41.479893
          ],
          [
            14.321021,
            53.071365,
            41.899367
          ],
          [
            14.321098,
            53.071171,
            42.332728
          ],
          [
            14.321081,
            53.07097,
            42.770628
          ],
          [
            14.321024,
            53.070756,
            43.241034
          ],
          [
            14.320957,
            53.070537,
            43.725074
          ],
          [
            14.320663,
            53.070458,
            44.164829
          ],
          [
            14.320317,
            53.070502,
            44.62618
          ],
          [
            14.319899,
            53.070497,
            43.720521
          ],
          [
            14.319574,
            53.070526,
            42.976227
          ],
          [
            14.319206,
            53.070506,
            42.130989
          ],
          [
            14.318867,
            53.070418,
            41.294066
          ],
          [
            14.318525,
            53.070307,
            40.413059
          ],
          [
            14.318177,
            53.070207,
            39.538611
          ],
          [
            14.317968,
            53.070086,
            38.851808
          ],
          [
            14.318258,
            53.069984,
            38.058475
          ],
          [
            14.318596,
            53.069952,
            37.848073
          ],
          [
            14.318946,
            53.069919,
            37.827252
          ],
          [
            14.319266,
            53.069831,
            37.806214
          ],
          [
            14.319296,
            53.069635,
            37.786602
          ],
          [
            14.31929,
            53.069389,
            37.762567
          ],
          [
            14.31925,
            53.069139,
            37.738049
          ],
          [
            14.319207,
            53.068906,
            37.715164
          ],
          [
            14.319173,
            53.068692,
            37.694173
          ],
          [
            14.319115,
            53.068471,
            37.619106
          ],
          [
            14.319066,
            53.068234,
            37.514018
          ],
          [
            14.319044,
            53.068021,
            37.420034
          ],
          [
            14.319002,
            53.067814,
            37.328214
          ],
          [
            14.318949,
            53.067611,
            37.237816
          ],
          [
            14.318898,
            53.067402,
            37.144886
          ],
          [
            14.318837,
            53.067175,
            37.043675
          ],
          [
            14.318776,
            53.066947,
            36.942092
          ],
          [
            14.318689,
            53.066711,
            36.856093
          ],
          [
            14.31862,
            53.066482,
            36.788216
          ],
          [
            14.318544,
            53.066267,
            36.724113
          ],
          [
            14.318404,
            53.066022,
            36.647552
          ],
          [
            14.318331,
            53.065838,
            36.592391
          ],
          [
            14.318249,
            53.065625,
            36.528601
          ],
          [
            14.318148,
            53.065411,
            36.463733
          ],
          [
            14.318019,
            53.065175,
            36.391188
          ],
          [
            14.317885,
            53.064932,
            36.471018
          ],
          [
            14.317763,
            53.064729,
            36.584301
          ],
          [
            14.3176,
            53.064511,
            36.70969
          ],
          [
            14.317412,
            53.064299,
            36.835449
          ],
          [
            14.317248,
            53.064082,
            36.96023
          ],
          [
            14.317087,
            53.063877,
            37.078899
          ],
          [
            14.316905,
            53.063672,
            37.20057
          ],
          [
            14.316723,
            53.063458,
            37.26908
          ],
          [
            14.316529,
            53.063237,
            36.822869
          ],
          [
            14.316307,
            53.063035,
            36.390555
          ],
          [
            14.316085,
            53.062834,
            35.959716
          ],
          [
            14.315842,
            53.062631,
            35.513091
          ],
          [
            14.315605,
            53.062432,
            35.076085
          ],
          [
            14.315352,
            53.062245,
            34.645659
          ],
          [
            14.315115,
            53.062064,
            34.234364
          ],
          [
            14.314869,
            53.06189,
            34.100313
          ],
          [
            14.314601,
            53.06169,
            34.098455
          ],
          [
            14.314343,
            53.061495,
            34.096653
          ],
          [
            14.314057,
            53.061311,
            34.094832
          ],
          [
            14.313784,
            53.061146,
            34.093148
          ],
          [
            14.313525,
            53.061003,
            34.091619
          ],
          [
            14.313272,
            53.060861,
            34.090114
          ],
          [
            14.312988,
            53.060716,
            34.088494
          ],
          [
            14.312676,
            53.060569,
            34.68994
          ],
          [
            14.312352,
            53.060412,
            35.351818
          ],
          [
            14.312044,
            53.060258,
            35.988838
          ],
          [
            14.311743,
            53.060121,
            36.589089
          ],
          [
            14.311434,
            53.059997,
            37.180589
          ],
          [
            14.311112,
            53.059877,
            37.782882
          ],
          [
            14.310755,
            53.059754,
            38.43725
          ],
          [
            14.31048,
            53.059662,
            38.924033
          ],
          [
            14.310147,
            53.059613,
            39.399658
          ],
          [
            14.309844,
            53.059505,
            39.876525
          ],
          [
            14.30956,
            53.05939,
            40.339732
          ],
          [
            14.309266,
            53.059259,
            40.834792
          ],
          [
            14.308948,
            53.05914,
            41.341521
          ],
          [
            14.308651,
            53.059028,
            41.816083
          ],
          [
            14.308384,
            53.058911,
            42.263082
          ],
          [
            14.308075,
            53.058769,
            42.789403
          ],
          [
            14.307729,
            53.058674,
            42.677424
          ],
          [
            14.307413,
            53.058557,
            42.412876
          ],
          [
            14.307076,
            53.058471,
            42.151918
          ],
          [
            14.306771,
            53.058391,
            41.914709
          ],
          [
            14.306432,
            53.058305,
            41.652351
          ],
          [
            14.306062,
            53.058215,
            41.367827
          ],
          [
            14.305736,
            53.058142,
            41.119213
          ],
          [
            14.305387,
            53.058066,
            40.842939
          ],
          [
            14.305044,
            53.057998,
            40.743202
          ],
          [
            14.304631,
            53.057954,
            40.713212
          ],
          [
            14.304308,
            53.057939,
            40.690008
          ],
          [
            14.303976,
            53.057904,
            40.666027
          ],
          [
            14.303573,
            53.057821,
            40.635721
          ],
          [
            14.303201,
            53.057721,
            40.606726
          ],
          [
            14.302859,
            53.05765,
            40.580967
          ],
          [
            14.302636,
            53.057489,
            40.555932
          ],
          [
            14.30239,
            53.05734,
            40.790904
          ],
          [
            14.302211,
            53.057365,
            41.111546
          ],
          [
            14.302071,
            53.057533,
            41.431809
          ],
          [
            14.301774,
            53.057644,
            41.799362
          ],
          [
            14.301439,
            53.057671,
            42.145304
          ],
          [
            14.301136,
            53.057739,
            42.476043
          ],
          [
            14.300822,
            53.057811,
            42.819433
          ],
          [
            14.300509,
            53.057858,
            43.149135
          ],
          [
            14.300159,
            53.057932,
            43.528821
          ],
          [
            14.299835,
            53.057981,
            43.510376
          ],
          [
            14.299534,
            53.058063,
            43.387951
          ],
          [
            14.299318,
            53.05821,
            43.252972
          ],
          [
            14.298998,
            53.058237,
            43.121814
          ],
          [
            14.298652,
            53.05828,
            42.990655
          ],
          [
            14.298313,
            53.05834,
            42.8607
          ],
          [
            14.298057,
            53.058443,
            42.746506
          ],
          [
            14.297799,
            53.058375,
            42.626273
          ],
          [
            14.2978,
            53.058184,
            42.508727
          ],
          [
            14.297692,
            53.058005,
            42.505385
          ],
          [
            14.297587,
            53.057813,
            42.505385
          ],
          [
            14.297488,
            53.057623,
            42.505385
          ],
          [
            14.297685,
            53.057501,
            42.505385
          ],
          [
            14.297993,
            53.057529,
            42.505385
          ],
          [
            14.298153,
            53.057352,
            42.505385
          ],
          [
            14.298194,
            53.057127,
            42.505385
          ],
          [
            14.298507,
            53.057086,
            42.505385
          ],
          [
            14.298664,
            53.056926,
            42.505385
          ],
          [
            14.298869,
            53.056789,
            42.505385
          ],
          [
            14.299153,
            53.05679,
            42.505385
          ]
        ]
      }
    }
  ]
}

let day39: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.298383,
            53.05741,
            44.341333
          ],
          [
            14.29842,
            53.057183,
            44.341333
          ],
          [
            14.298211,
            53.057193,
            44.341333
          ],
          [
            14.298136,
            53.057378,
            44.341333
          ],
          [
            14.297947,
            53.057525,
            44.341333
          ],
          [
            14.297627,
            53.057492,
            44.376815
          ],
          [
            14.297343,
            53.057403,
            44.42895
          ],
          [
            14.297249,
            53.057193,
            44.486825
          ],
          [
            14.297139,
            53.056997,
            44.542024
          ],
          [
            14.297039,
            53.056785,
            44.600678
          ],
          [
            14.296922,
            53.056604,
            44.652503
          ],
          [
            14.296689,
            53.056485,
            44.706214
          ],
          [
            14.296351,
            53.056494,
            44.760482
          ],
          [
            14.296004,
            53.056442,
            44.81784
          ],
          [
            14.295668,
            53.056361,
            44.937752
          ],
          [
            14.295363,
            53.056255,
            45.056668
          ],
          [
            14.295094,
            53.056141,
            45.168005
          ],
          [
            14.294872,
            53.056007,
            45.275125
          ],
          [
            14.29459,
            53.0559,
            45.38742
          ],
          [
            14.294342,
            53.055763,
            45.501466
          ],
          [
            14.294075,
            53.055652,
            45.610781
          ],
          [
            14.293799,
            53.055523,
            45.729278
          ],
          [
            14.293527,
            53.055603,
            45.812652
          ],
          [
            14.293277,
            53.05567,
            45.680109
          ],
          [
            14.293012,
            53.055642,
            45.563988
          ],
          [
            14.292886,
            53.05565,
            45.446169
          ],
          [
            14.292628,
            53.055617,
            45.325964
          ],
          [
            14.292346,
            53.055558,
            45.199363
          ],
          [
            14.292083,
            53.055433,
            45.071247
          ],
          [
            14.291798,
            53.055285,
            44.927262
          ],
          [
            14.291566,
            53.055143,
            44.798536
          ],
          [
            14.291398,
            53.054957,
            44.5585
          ],
          [
            14.291156,
            53.054788,
            43.911908
          ],
          [
            14.290976,
            53.054558,
            43.185517
          ],
          [
            14.29078,
            53.054394,
            42.606618
          ],
          [
            14.29053,
            53.054266,
            42.040268
          ],
          [
            14.290189,
            53.054186,
            41.413056
          ],
          [
            14.289908,
            53.054041,
            40.778598
          ],
          [
            14.289623,
            53.05392,
            40.180817
          ],
          [
            14.289318,
            53.053815,
            39.576626
          ],
          [
            14.289,
            53.053713,
            39.435504
          ],
          [
            14.288722,
            53.053606,
            39.319615
          ],
          [
            14.288411,
            53.053477,
            39.186651
          ],
          [
            14.288068,
            53.053368,
            39.050604
          ],
          [
            14.2877,
            53.053232,
            38.899073
          ],
          [
            14.287399,
            53.0531,
            38.768387
          ],
          [
            14.287142,
            53.053005,
            38.662512
          ],
          [
            14.286788,
            53.05295,
            38.532101
          ],
          [
            14.286393,
            53.052812,
            38.571575
          ],
          [
            14.28613,
            53.052696,
            38.623978
          ],
          [
            14.285811,
            53.052566,
            38.685747
          ],
          [
            14.285481,
            53.052455,
            38.74642
          ],
          [
            14.285148,
            53.05233,
            38.809434
          ],
          [
            14.284831,
            53.052194,
            38.871902
          ],
          [
            14.284552,
            53.0521,
            38.923164
          ],
          [
            14.28426,
            53.05198,
            38.980061
          ],
          [
            14.283959,
            53.051843,
            38.900597
          ],
          [
            14.283659,
            53.051747,
            38.808043
          ],
          [
            14.283346,
            53.051599,
            38.700493
          ],
          [
            14.282998,
            53.05144,
            38.582442
          ],
          [
            14.282705,
            53.051317,
            38.4859
          ],
          [
            14.282405,
            53.051175,
            38.382778
          ],
          [
            14.28215,
            53.050962,
            38.264451
          ],
          [
            14.281927,
            53.050751,
            38.161579
          ],
          [
            14.281618,
            53.050658,
            38.105013
          ],
          [
            14.281313,
            53.050513,
            38.041349
          ],
          [
            14.280997,
            53.050371,
            37.976784
          ],
          [
            14.280754,
            53.050227,
            37.920928
          ],
          [
            14.280439,
            53.050053,
            37.850498
          ],
          [
            14.28009,
            53.04997,
            37.788925
          ],
          [
            14.279744,
            53.049944,
            37.731861
          ],
          [
            14.27941,
            53.049919,
            37.679671
          ],
          [
            14.279056,
            53.049975,
            37.632148
          ],
          [
            14.278661,
            53.050078,
            37.576327
          ],
          [
            14.278319,
            53.050201,
            37.524414
          ],
          [
            14.278039,
            53.050377,
            37.471881
          ],
          [
            14.277679,
            53.050422,
            37.421911
          ],
          [
            14.27734,
            53.050296,
            37.369674
          ],
          [
            14.277089,
            53.050106,
            37.31735
          ],
          [
            14.276902,
            53.049927,
            37.320093
          ],
          [
            14.27666,
            53.049816,
            37.342198
          ],
          [
            14.276489,
            53.049676,
            37.365644
          ],
          [
            14.276648,
            53.049518,
            37.387809
          ],
          [
            14.2764,
            53.049373,
            37.413572
          ],
          [
            14.276094,
            53.049257,
            37.439711
          ],
          [
            14.27579,
            53.049115,
            37.467535
          ],
          [
            14.27547,
            53.048991,
            37.495013
          ],
          [
            14.275448,
            53.048801,
            37.557001
          ],
          [
            14.27567,
            53.048621,
            37.998243
          ],
          [
            14.275857,
            53.048422,
            38.450164
          ],
          [
            14.275581,
            53.048258,
            38.924069
          ],
          [
            14.275178,
            53.048195,
            39.441261
          ],
          [
            14.274966,
            53.048374,
            39.878436
          ],
          [
            14.274686,
            53.048565,
            40.380201
          ],
          [
            14.274403,
            53.048758,
            40.88719
          ],
          [
            14.274158,
            53.048961,
            41.170505
          ],
          [
            14.273884,
            53.049156,
            41.344662
          ],
          [
            14.273593,
            53.049337,
            41.516013
          ],
          [
            14.273227,
            53.049314,
            41.686642
          ],
          [
            14.273009,
            53.049188,
            41.810431
          ],
          [
            14.272786,
            53.04901,
            41.962202
          ],
          [
            14.272563,
            53.048869,
            42.095031
          ],
          [
            14.272348,
            53.048715,
            42.23214
          ],
          [
            14.272103,
            53.048589,
            42.378771
          ],
          [
            14.271818,
            53.048428,
            42.567999
          ],
          [
            14.271749,
            53.048247,
            42.730968
          ],
          [
            14.272093,
            53.048108,
            42.931612
          ],
          [
            14.272434,
            53.047971,
            43.130165
          ],
          [
            14.272732,
            53.047829,
            43.314109
          ],
          [
            14.273042,
            53.047704,
            43.494732
          ],
          [
            14.273373,
            53.047567,
            43.689269
          ],
          [
            14.273648,
            53.047465,
            43.634012
          ],
          [
            14.273898,
            53.047345,
            43.503233
          ],
          [
            14.274193,
            53.047198,
            43.346367
          ],
          [
            14.274362,
            53.04703,
            43.212951
          ],
          [
            14.2745,
            53.046856,
            43.081894
          ],
          [
            14.274526,
            53.046652,
            42.937042
          ],
          [
            14.27414,
            53.046552,
            42.765208
          ],
          [
            14.273818,
            53.046461,
            42.619848
          ],
          [
            14.273563,
            53.046347,
            42.448013
          ],
          [
            14.273273,
            53.046253,
            42.06945
          ],
          [
            14.272968,
            53.046143,
            41.661348
          ],
          [
            14.272667,
            53.046031,
            41.254464
          ],
          [
            14.272419,
            53.045921,
            40.901018
          ],
          [
            14.272091,
            53.045793,
            40.452624
          ],
          [
            14.271832,
            53.045701,
            40.107817
          ],
          [
            14.271569,
            53.045558,
            39.701319
          ],
          [
            14.271302,
            53.045401,
            39.273266
          ],
          [
            14.271061,
            53.045269,
            39.093669
          ],
          [
            14.2708,
            53.045132,
            39.124145
          ],
          [
            14.270533,
            53.044983,
            39.156196
          ],
          [
            14.270272,
            53.04482,
            39.189292
          ],
          [
            14.270052,
            53.044658,
            39.21989
          ],
          [
            14.269845,
            53.044499,
            39.249424
          ],
          [
            14.269642,
            53.04434,
            39.278786
          ],
          [
            14.269427,
            53.044183,
            39.30859
          ],
          [
            14.269219,
            53.044025,
            39.338063
          ],
          [
            14.269,
            53.043876,
            39.012543
          ],
          [
            14.26881,
            53.043716,
            38.620571
          ],
          [
            14.268613,
            53.043564,
            38.236432
          ],
          [
            14.268419,
            53.043418,
            37.864107
          ],
          [
            14.268207,
            53.043261,
            37.461168
          ],
          [
            14.267996,
            53.043098,
            37.049549
          ],
          [
            14.267765,
            53.042931,
            36.615966
          ],
          [
            14.267568,
            53.042765,
            36.209469
          ],
          [
            14.267358,
            53.042614,
            35.817261
          ],
          [
            14.267148,
            53.04245,
            35.806225
          ],
          [
            14.266934,
            53.042288,
            35.860851
          ],
          [
            14.26669,
            53.042105,
            35.922796
          ],
          [
            14.266458,
            53.04194,
            35.979842
          ],
          [
            14.266231,
            53.041746,
            36.042478
          ],
          [
            14.265992,
            53.041572,
            36.102059
          ],
          [
            14.265746,
            53.041383,
            36.165429
          ],
          [
            14.265523,
            53.041212,
            36.222802
          ],
          [
            14.2653,
            53.041039,
            36.636936
          ],
          [
            14.265063,
            53.040862,
            37.156775
          ],
          [
            14.264829,
            53.040688,
            37.66858
          ],
          [
            14.264573,
            53.040481,
            38.259535
          ],
          [
            14.264389,
            53.040333,
            38.682648
          ],
          [
            14.264203,
            53.040174,
            39.127346
          ],
          [
            14.264011,
            53.040028,
            39.553872
          ],
          [
            14.263781,
            53.039853,
            40.064204
          ],
          [
            14.263503,
            53.039656,
            40.274714
          ],
          [
            14.263282,
            53.039479,
            40.154289
          ],
          [
            14.263038,
            53.039299,
            40.027711
          ],
          [
            14.262802,
            53.039116,
            39.901729
          ],
          [
            14.262573,
            53.038943,
            39.78144
          ],
          [
            14.262324,
            53.038768,
            39.656134
          ],
          [
            14.262067,
            53.03858,
            39.523726
          ],
          [
            14.26182,
            53.038392,
            39.393381
          ],
          [
            14.261574,
            53.038207,
            39.52268
          ],
          [
            14.261341,
            53.038019,
            39.708894
          ],
          [
            14.261118,
            53.037828,
            39.894282
          ],
          [
            14.260892,
            53.03764,
            40.078668
          ],
          [
            14.260636,
            53.037461,
            40.266202
          ],
          [
            14.260393,
            53.03728,
            40.450953
          ],
          [
            14.260137,
            53.037094,
            40.642838
          ],
          [
            14.259887,
            53.036891,
            40.888907
          ],
          [
            14.259644,
            53.03671,
            41.259402
          ],
          [
            14.259402,
            53.036544,
            41.608472
          ],
          [
            14.25921,
            53.03639,
            41.912997
          ],
          [
            14.259004,
            53.036244,
            42.217466
          ],
          [
            14.258701,
            53.035997,
            42.702958
          ],
          [
            14.258495,
            53.035843,
            43.016097
          ],
          [
            14.25829,
            53.035678,
            43.342669
          ],
          [
            14.25808,
            53.035514,
            43.619641
          ],
          [
            14.257835,
            53.035339,
            43.334978
          ],
          [
            14.257639,
            53.0352,
            43.108399
          ],
          [
            14.257403,
            53.035028,
            42.831155
          ],
          [
            14.257181,
            53.034854,
            42.558501
          ],
          [
            14.256996,
            53.034699,
            42.321258
          ],
          [
            14.256754,
            53.034529,
            42.042881
          ],
          [
            14.256528,
            53.034361,
            41.774124
          ],
          [
            14.256298,
            53.034191,
            41.501584
          ],
          [
            14.256078,
            53.034016,
            41.205111
          ],
          [
            14.255869,
            53.033841,
            40.901997
          ],
          [
            14.255675,
            53.033678,
            40.620153
          ],
          [
            14.255461,
            53.033504,
            40.314227
          ],
          [
            14.255255,
            53.03334,
            40.025195
          ],
          [
            14.255002,
            53.033156,
            39.689529
          ],
          [
            14.254765,
            53.032946,
            39.331977
          ],
          [
            14.25455,
            53.032731,
            38.978912
          ],
          [
            14.254356,
            53.032537,
            39.104265
          ],
          [
            14.25418,
            53.032353,
            39.416945
          ],
          [
            14.253984,
            53.032188,
            39.716419
          ],
          [
            14.253754,
            53.032016,
            40.04136
          ],
          [
            14.253555,
            53.031829,
            40.368444
          ],
          [
            14.253399,
            53.031657,
            40.656934
          ],
          [
            14.253229,
            53.031494,
            40.941052
          ],
          [
            14.253051,
            53.031334,
            41.224485
          ],
          [
            14.252879,
            53.031172,
            41.507552
          ],
          [
            14.252706,
            53.03101,
            41.340826
          ],
          [
            14.252519,
            53.030852,
            41.142457
          ],
          [
            14.252332,
            53.030703,
            40.951531
          ],
          [
            14.252135,
            53.030523,
            40.731323
          ],
          [
            14.251914,
            53.030314,
            40.478207
          ],
          [
            14.251694,
            53.030119,
            40.237319
          ],
          [
            14.251482,
            53.029931,
            40.005192
          ],
          [
            14.251265,
            53.029729,
            39.759398
          ],
          [
            14.251051,
            53.029538,
            39.631818
          ],
          [
            14.250868,
            53.029342,
            39.553856
          ],
          [
            14.250655,
            53.029152,
            39.47438
          ],
          [
            14.250424,
            53.028963,
            39.392981
          ],
          [
            14.250209,
            53.028761,
            39.309775
          ],
          [
            14.249968,
            53.028583,
            39.230158
          ],
          [
            14.249751,
            53.028383,
            39.14733
          ],
          [
            14.249533,
            53.028168,
            39.062045
          ],
          [
            14.249339,
            53.02797,
            39.029235
          ],
          [
            14.249088,
            53.027771,
            38.993572
          ],
          [
            14.248848,
            53.027576,
            38.958879
          ],
          [
            14.248619,
            53.027365,
            38.922901
          ],
          [
            14.248422,
            53.027153,
            38.888223
          ],
          [
            14.2482,
            53.026951,
            38.853656
          ],
          [
            14.247972,
            53.026737,
            38.817374
          ],
          [
            14.247771,
            53.026561,
            39.093521
          ],
          [
            14.247551,
            53.026347,
            39.61066
          ],
          [
            14.247348,
            53.026158,
            40.073637
          ],
          [
            14.247133,
            53.025972,
            40.539062
          ],
          [
            14.246957,
            53.025809,
            40.938378
          ],
          [
            14.246764,
            53.025631,
            41.375481
          ],
          [
            14.246581,
            53.025442,
            41.824858
          ],
          [
            14.2464,
            53.025276,
            42.234829
          ],
          [
            14.246203,
            53.025105,
            42.484358
          ],
          [
            14.246008,
            53.024933,
            42.436924
          ],
          [
            14.245812,
            53.024789,
            42.394499
          ],
          [
            14.245617,
            53.024628,
            42.349117
          ],
          [
            14.245431,
            53.02442,
            42.295228
          ],
          [
            14.245207,
            53.024215,
            42.23932
          ],
          [
            14.244965,
            53.023999,
            42.179918
          ],
          [
            14.244756,
            53.023803,
            42.12681
          ],
          [
            14.244514,
            53.023606,
            42.086051
          ],
          [
            14.244289,
            53.02341,
            42.070038
          ],
          [
            14.24407,
            53.023204,
            42.053605
          ],
          [
            14.24386,
            53.023015,
            42.038322
          ],
          [
            14.24367,
            53.022824,
            42.023362
          ],
          [
            14.243415,
            53.022629,
            42.006642
          ],
          [
            14.243244,
            53.022477,
            41.994308
          ],
          [
            14.243056,
            53.022288,
            41.979484
          ],
          [
            14.242846,
            53.022102,
            42.043065
          ],
          [
            14.242682,
            53.021936,
            42.173734
          ],
          [
            14.242499,
            53.02177,
            42.308496
          ],
          [
            14.242332,
            53.021611,
            42.435797
          ],
          [
            14.242121,
            53.021415,
            42.594179
          ],
          [
            14.24196,
            53.021256,
            42.720081
          ],
          [
            14.241772,
            53.021089,
            42.856497
          ],
          [
            14.241593,
            53.020909,
            42.998333
          ],
          [
            14.241379,
            53.020765,
            43.12956
          ],
          [
            14.241201,
            53.020602,
            43.080608
          ],
          [
            14.241134,
            53.020385,
            42.864645
          ],
          [
            14.241005,
            53.020178,
            42.647707
          ],
          [
            14.24084,
            53.020019,
            42.463678
          ],
          [
            14.240665,
            53.019844,
            42.263836
          ],
          [
            14.240417,
            53.019647,
            42.021942
          ],
          [
            14.240227,
            53.019467,
            41.813204
          ],
          [
            14.240038,
            53.01931,
            41.623478
          ],
          [
            14.239798,
            53.019185,
            41.435619
          ],
          [
            14.239543,
            53.01906,
            41.356738
          ],
          [
            14.239344,
            53.018893,
            41.279984
          ],
          [
            14.239163,
            53.018716,
            41.202337
          ],
          [
            14.238987,
            53.018562,
            41.132541
          ],
          [
            14.238804,
            53.018397,
            41.058473
          ],
          [
            14.238593,
            53.01823,
            40.980123
          ],
          [
            14.238383,
            53.018021,
            40.888914
          ],
          [
            14.238198,
            53.017845,
            40.81115
          ],
          [
            14.238012,
            53.017683,
            40.7675
          ],
          [
            14.237832,
            53.017506,
            40.814285
          ],
          [
            14.237643,
            53.017325,
            40.862486
          ],
          [
            14.237465,
            53.017163,
            40.906269
          ],
          [
            14.237275,
            53.016992,
            40.952646
          ],
          [
            14.237097,
            53.016825,
            40.997439
          ],
          [
            14.236915,
            53.016675,
            41.039319
          ],
          [
            14.236747,
            53.016491,
            41.086654
          ],
          [
            14.236573,
            53.016335,
            41.129043
          ],
          [
            14.236409,
            53.016178,
            41.184107
          ],
          [
            14.236255,
            53.016021,
            41.285271
          ],
          [
            14.236065,
            53.015853,
            41.398323
          ],
          [
            14.235901,
            53.015691,
            41.5036
          ],
          [
            14.235668,
            53.015478,
            41.645346
          ],
          [
            14.235473,
            53.01529,
            41.76831
          ],
          [
            14.235305,
            53.015137,
            41.870544
          ],
          [
            14.235133,
            53.014979,
            41.975385
          ],
          [
            14.234923,
            53.01479,
            42.101532
          ],
          [
            14.234687,
            53.014582,
            42.221268
          ],
          [
            14.234428,
            53.014375,
            42.329856
          ],
          [
            14.234256,
            53.0142,
            42.415038
          ],
          [
            14.234014,
            53.014019,
            42.512412
          ],
          [
            14.233868,
            53.013852,
            42.59165
          ],
          [
            14.233627,
            53.013645,
            42.697568
          ],
          [
            14.23343,
            53.013471,
            42.785721
          ],
          [
            14.233216,
            53.01329,
            42.878764
          ],
          [
            14.233034,
            53.013146,
            42.793708
          ],
          [
            14.232832,
            53.013003,
            42.569929
          ],
          [
            14.232572,
            53.012841,
            42.301494
          ],
          [
            14.232315,
            53.01268,
            42.035394
          ],
          [
            14.232107,
            53.01254,
            41.811563
          ],
          [
            14.231829,
            53.012384,
            41.538933
          ],
          [
            14.231632,
            53.012246,
            41.322092
          ],
          [
            14.23139,
            53.012076,
            41.054979
          ],
          [
            14.231113,
            53.011891,
            40.77363
          ],
          [
            14.230844,
            53.011708,
            40.895539
          ],
          [
            14.230563,
            53.011533,
            41.016999
          ],
          [
            14.230367,
            53.011378,
            41.114143
          ],
          [
            14.230163,
            53.011227,
            41.211688
          ],
          [
            14.22996,
            53.011078,
            41.307728
          ],
          [
            14.229749,
            53.010937,
            41.402316
          ],
          [
            14.229548,
            53.010786,
            41.49881
          ],
          [
            14.229358,
            53.010626,
            41.596833
          ],
          [
            14.229152,
            53.01048,
            41.708225
          ],
          [
            14.228953,
            53.010315,
            41.869845
          ],
          [
            14.228728,
            53.010152,
            42.037778
          ],
          [
            14.228513,
            53.009997,
            42.197848
          ],
          [
            14.228295,
            53.00984,
            42.360122
          ],
          [
            14.22808,
            53.009703,
            42.509487
          ],
          [
            14.227855,
            53.009564,
            42.663319
          ],
          [
            14.227611,
            53.009443,
            42.814544
          ],
          [
            14.227322,
            53.009313,
            42.986725
          ],
          [
            14.227053,
            53.009211,
            43.091802
          ],
          [
            14.226711,
            53.009134,
            43.095339
          ],
          [
            14.226367,
            53.009068,
            43.098825
          ],
          [
            14.225961,
            53.008991,
            43.102942
          ],
          [
            14.225621,
            53.008923,
            43.106402
          ],
          [
            14.225307,
            53.008866,
            43.109569
          ],
          [
            14.225004,
            53.00881,
            43.112629
          ],
          [
            14.224689,
            53.00875,
            43.115819
          ],
          [
            14.224388,
            53.008666,
            43.119025
          ],
          [
            14.224113,
            53.008591,
            43.144802
          ],
          [
            14.223811,
            53.008518,
            43.179911
          ],
          [
            14.223518,
            53.008435,
            43.215014
          ],
          [
            14.223231,
            53.008341,
            43.250257
          ],
          [
            14.222936,
            53.00827,
            43.284543
          ],
          [
            14.222625,
            53.008176,
            43.322105
          ],
          [
            14.222309,
            53.00807,
            43.361214
          ],
          [
            14.221999,
            53.007985,
            43.397957
          ],
          [
            14.22171,
            53.007897,
            43.432905
          ],
          [
            14.22143,
            53.00781,
            43.37065
          ],
          [
            14.221152,
            53.007727,
            43.27416
          ],
          [
            14.220762,
            53.007626,
            43.142266
          ],
          [
            14.220444,
            53.007506,
            43.025661
          ],
          [
            14.2202,
            53.007388,
            42.928335
          ],
          [
            14.219904,
            53.007261,
            42.815349
          ],
          [
            14.219623,
            53.007124,
            42.702897
          ],
          [
            14.219296,
            53.006983,
            42.577759
          ],
          [
            14.21898,
            53.006847,
            42.653326
          ],
          [
            14.218656,
            53.006719,
            42.951034
          ],
          [
            14.218349,
            53.006593,
            43.236312
          ],
          [
            14.218033,
            53.006475,
            43.521869
          ],
          [
            14.217719,
            53.006323,
            43.831129
          ],
          [
            14.21737,
            53.006179,
            44.155825
          ],
          [
            14.217058,
            53.006063,
            44.437586
          ],
          [
            14.216804,
            53.005959,
            44.673435
          ],
          [
            14.216499,
            53.005832,
            44.640034
          ],
          [
            14.216141,
            53.005663,
            44.254049
          ],
          [
            14.215873,
            53.00556,
            43.984357
          ],
          [
            14.21558,
            53.005445,
            43.687668
          ],
          [
            14.215309,
            53.005331,
            43.407184
          ],
          [
            14.215041,
            53.005198,
            43.112546
          ],
          [
            14.214774,
            53.005078,
            42.829919
          ],
          [
            14.214511,
            53.004945,
            42.538529
          ],
          [
            14.214261,
            53.004801,
            42.275949
          ],
          [
            14.214017,
            53.004676,
            42.313991
          ],
          [
            14.213765,
            53.004547,
            42.353157
          ],
          [
            14.213542,
            53.004407,
            42.391321
          ],
          [
            14.213325,
            53.004256,
            42.430618
          ],
          [
            14.213129,
            53.004109,
            42.467774
          ],
          [
            14.212924,
            53.003963,
            42.505405
          ],
          [
            14.212742,
            53.003812,
            42.542101
          ],
          [
            14.212545,
            53.003668,
            42.578838
          ],
          [
            14.212358,
            53.0035,
            42.61862
          ],
          [
            14.212157,
            53.003345,
            42.783708
          ],
          [
            14.211984,
            53.003178,
            42.978716
          ],
          [
            14.211826,
            53.002993,
            43.18556
          ],
          [
            14.211669,
            53.002816,
            43.384175
          ],
          [
            14.211497,
            53.002633,
            43.592282
          ],
          [
            14.211362,
            53.002446,
            43.794098
          ],
          [
            14.211188,
            53.002249,
            44.014933
          ],
          [
            14.211051,
            53.002062,
            44.217233
          ],
          [
            14.21093,
            53.001873,
            44.396841
          ],
          [
            14.210814,
            53.001675,
            44.227834
          ],
          [
            14.210712,
            53.001475,
            44.059481
          ],
          [
            14.210599,
            53.001303,
            43.909992
          ],
          [
            14.210491,
            53.001051,
            43.69958
          ],
          [
            14.210428,
            53.000849,
            43.534217
          ],
          [
            14.210346,
            53.000613,
            43.340201
          ],
          [
            14.210292,
            53.00037,
            43.142934
          ],
          [
            14.210203,
            53.000165,
            42.972434
          ],
          [
            14.210115,
            52.999925,
            42.782811
          ],
          [
            14.209941,
            52.999702,
            42.593344
          ],
          [
            14.209754,
            52.999498,
            42.414214
          ],
          [
            14.209522,
            52.999305,
            42.230823
          ],
          [
            14.209274,
            52.999138,
            42.058616
          ],
          [
            14.208978,
            52.998972,
            41.870715
          ],
          [
            14.208643,
            52.998832,
            41.681816
          ],
          [
            14.208356,
            52.99866,
            41.538958
          ],
          [
            14.208076,
            52.998505,
            41.45846
          ],
          [
            14.207805,
            52.998341,
            41.377207
          ],
          [
            14.207559,
            52.998212,
            41.308227
          ],
          [
            14.207288,
            52.998081,
            41.234761
          ],
          [
            14.207024,
            52.997984,
            41.169249
          ],
          [
            14.20673,
            52.9979,
            41.100467
          ],
          [
            14.206414,
            52.997849,
            41.031323
          ],
          [
            14.206084,
            52.997792,
            40.958429
          ],
          [
            14.205764,
            52.99773,
            40.836396
          ],
          [
            14.205437,
            52.997663,
            40.698681
          ],
          [
            14.205121,
            52.997605,
            40.566936
          ],
          [
            14.204812,
            52.997559,
            40.438269
          ],
          [
            14.204512,
            52.997456,
            40.30054
          ],
          [
            14.204223,
            52.997332,
            40.158767
          ],
          [
            14.203978,
            52.997198,
            40.025676
          ],
          [
            14.203775,
            52.997007,
            39.875376
          ],
          [
            14.203952,
            52.997187,
            39.763384
          ],
          [
            14.203683,
            52.997075,
            39.844052
          ],
          [
            14.203467,
            52.996912,
            39.925037
          ],
          [
            14.20329,
            52.996746,
            40.001576
          ],
          [
            14.203067,
            52.996561,
            40.091288
          ],
          [
            14.202881,
            52.996395,
            40.168962
          ],
          [
            14.202651,
            52.996256,
            40.245065
          ],
          [
            14.202406,
            52.996126,
            40.321447
          ],
          [
            14.202151,
            52.996003,
            40.398154
          ],
          [
            14.201855,
            52.995913,
            40.500132
          ],
          [
            14.201569,
            52.995825,
            40.650222
          ],
          [
            14.201222,
            52.995726,
            40.830092
          ],
          [
            14.200924,
            52.995651,
            40.981515
          ],
          [
            14.20062,
            52.995589,
            41.131507
          ],
          [
            14.200258,
            52.995511,
            41.311192
          ],
          [
            14.199958,
            52.995449,
            41.459432
          ],
          [
            14.199653,
            52.995387,
            41.610034
          ],
          [
            14.199364,
            52.995303,
            41.760006
          ],
          [
            14.199094,
            52.995193,
            41.79923
          ],
          [
            14.198836,
            52.995076,
            41.686012
          ],
          [
            14.19853,
            52.994946,
            41.554731
          ],
          [
            14.198212,
            52.994829,
            41.424142
          ],
          [
            14.19783,
            52.994686,
            41.266499
          ],
          [
            14.197472,
            52.994626,
            41.136281
          ],
          [
            14.197165,
            52.994601,
            41.027584
          ],
          [
            14.196848,
            52.994566,
            40.914274
          ],
          [
            14.19647,
            52.994533,
            40.783218
          ],
          [
            14.196037,
            52.994505,
            40.651579
          ],
          [
            14.195689,
            52.99449,
            40.546105
          ],
          [
            14.195293,
            52.994478,
            40.425761
          ],
          [
            14.194897,
            52.994426,
            40.30323
          ],
          [
            14.194535,
            52.994361,
            40.188687
          ],
          [
            14.194171,
            52.994335,
            40.077772
          ],
          [
            14.193809,
            52.994315,
            39.967328
          ],
          [
            14.193391,
            52.994243,
            40.097952
          ],
          [
            14.193045,
            52.994158,
            40.46244
          ],
          [
            14.192628,
            52.994047,
            40.90739
          ],
          [
            14.192351,
            52.993979,
            41.199318
          ],
          [
            14.192065,
            52.993885,
            41.517131
          ],
          [
            14.191758,
            52.99378,
            41.861501
          ],
          [
            14.191496,
            52.993659,
            42.183657
          ],
          [
            14.19121,
            52.993537,
            42.525536
          ],
          [
            14.190882,
            52.993415,
            42.785716
          ],
          [
            14.190537,
            52.993289,
            42.669266
          ],
          [
            14.190155,
            52.993208,
            42.552329
          ],
          [
            14.189748,
            52.993181,
            42.43388
          ],
          [
            14.189344,
            52.993185,
            42.317281
          ],
          [
            14.188957,
            52.993233,
            42.203258
          ],
          [
            14.188644,
            52.993276,
            42.110541
          ],
          [
            14.188236,
            52.993307,
            41.991698
          ],
          [
            14.18787,
            52.993353,
            41.811418
          ],
          [
            14.187524,
            52.993378,
            41.600918
          ],
          [
            14.187186,
            52.993403,
            41.394933
          ],
          [
            14.186836,
            52.993419,
            41.182629
          ],
          [
            14.186467,
            52.993443,
            40.95814
          ],
          [
            14.186128,
            52.993484,
            40.74922
          ],
          [
            14.185818,
            52.993517,
            40.559079
          ],
          [
            14.185484,
            52.993547,
            40.355119
          ],
          [
            14.185101,
            52.9936,
            40.173425
          ],
          [
            14.184704,
            52.993618,
            40.416777
          ],
          [
            14.184332,
            52.993609,
            40.644417
          ],
          [
            14.183959,
            52.993577,
            40.87471
          ],
          [
            14.183593,
            52.993542,
            41.10126
          ],
          [
            14.183246,
            52.993469,
            41.325949
          ],
          [
            14.182907,
            52.993387,
            41.549499
          ],
          [
            14.182564,
            52.993293,
            41.779844
          ],
          [
            14.182218,
            52.993209,
            42.00376
          ],
          [
            14.181832,
            52.993128,
            42.225561
          ],
          [
            14.181458,
            52.993041,
            42.44322
          ],
          [
            14.181051,
            52.992972,
            42.672431
          ],
          [
            14.180664,
            52.992895,
            42.893448
          ],
          [
            14.180299,
            52.992817,
            43.103376
          ],
          [
            14.179913,
            52.992745,
            43.322838
          ],
          [
            14.179532,
            52.992693,
            43.534875
          ],
          [
            14.179198,
            52.99263,
            43.609226
          ],
          [
            14.17879,
            52.992566,
            43.64021
          ],
          [
            14.178417,
            52.992497,
            43.668871
          ],
          [
            14.17804,
            52.992443,
            43.697334
          ],
          [
            14.177641,
            52.992369,
            43.728019
          ],
          [
            14.177233,
            52.992271,
            43.760311
          ],
          [
            14.176889,
            52.992211,
            43.786642
          ],
          [
            14.176522,
            52.992148,
            43.823356
          ],
          [
            14.17618,
            52.992098,
            43.9033
          ],
          [
            14.175901,
            52.991974,
            43.984195
          ],
          [
            14.175706,
            52.991767,
            44.074008
          ],
          [
            14.175517,
            52.991602,
            44.14974
          ],
          [
            14.175349,
            52.991444,
            44.220593
          ],
          [
            14.175152,
            52.991232,
            44.312314
          ],
          [
            14.175013,
            52.991068,
            44.381815
          ],
          [
            14.174828,
            52.990869,
            44.468521
          ],
          [
            14.174677,
            52.990684,
            44.517038
          ],
          [
            14.174605,
            52.990502,
            44.551335
          ],
          [
            14.174564,
            52.990306,
            44.587748
          ],
          [
            14.174575,
            52.990111,
            44.623572
          ],
          [
            14.17463,
            52.989883,
            44.665806
          ],
          [
            14.174708,
            52.989669,
            44.705974
          ],
          [
            14.174792,
            52.989419,
            44.752728
          ],
          [
            14.174848,
            52.989174,
            44.798086
          ],
          [
            14.174893,
            52.988928,
            44.802713
          ],
          [
            14.174958,
            52.988681,
            44.772517
          ],
          [
            14.175022,
            52.988474,
            44.747009
          ],
          [
            14.175096,
            52.988261,
            44.720636
          ],
          [
            14.175239,
            52.988048,
            44.692857
          ],
          [
            14.175482,
            52.987856,
            44.663661
          ],
          [
            14.175746,
            52.9877,
            44.636733
          ],
          [
            14.17598,
            52.987576,
            44.614045
          ],
          [
            14.176198,
            52.987449,
            44.349633
          ],
          [
            14.176467,
            52.987309,
            43.690813
          ],
          [
            14.176732,
            52.98716,
            43.019081
          ],
          [
            14.176928,
            52.986997,
            42.399424
          ],
          [
            14.176672,
            52.986845,
            41.690797
          ],
          [
            14.176362,
            52.986838,
            41.113096
          ],
          [
            14.176039,
            52.986859,
            40.510481
          ],
          [
            14.175672,
            52.986951,
            39.773864
          ],
          [
            14.175275,
            52.987017,
            39.087098
          ],
          [
            14.174867,
            52.987034,
            39.342208
          ],
          [
            14.174476,
            52.987047,
            39.586037
          ],
          [
            14.174098,
            52.987061,
            39.821863
          ],
          [
            14.173718,
            52.987067,
            40.058572
          ],
          [
            14.173279,
            52.987065,
            40.331994
          ],
          [
            14.172942,
            52.987056,
            40.542054
          ],
          [
            14.172607,
            52.987052,
            40.750695
          ],
          [
            14.172243,
            52.987032,
            41.043224
          ],
          [
            14.171913,
            52.987036,
            41.513062
          ],
          [
            14.171584,
            52.987006,
            41.987102
          ],
          [
            14.171186,
            52.987025,
            42.554517
          ],
          [
            14.170849,
            52.987013,
            43.034625
          ],
          [
            14.170446,
            52.986984,
            43.6113
          ],
          [
            14.170093,
            52.98697,
            44.114006
          ],
          [
            14.169748,
            52.986977,
            44.604695
          ],
          [
            14.169403,
            52.98696,
            45.096539
          ],
          [
            14.169082,
            52.986956,
            44.932402
          ],
          [
            14.168695,
            52.986916,
            44.578781
          ],
          [
            14.168343,
            52.986906,
            44.262177
          ],
          [
            14.167985,
            52.986896,
            43.939489
          ],
          [
            14.167626,
            52.986905,
            43.616213
          ],
          [
            14.167303,
            52.986918,
            43.325177
          ],
          [
            14.16693,
            52.986921,
            42.989915
          ],
          [
            14.166616,
            52.986922,
            42.707155
          ],
          [
            14.16631,
            52.986915,
            42.43521
          ],
          [
            14.165955,
            52.986928,
            42.134097
          ],
          [
            14.165569,
            52.986932,
            41.807211
          ],
          [
            14.165176,
            52.986924,
            41.474746
          ],
          [
            14.164813,
            52.986929,
            41.167802
          ],
          [
            14.164379,
            52.986919,
            40.799907
          ],
          [
            14.163935,
            52.986927,
            40.423404
          ],
          [
            14.163532,
            52.986939,
            40.08218
          ],
          [
            14.163097,
            52.986927,
            39.976036
          ],
          [
            14.162687,
            52.986918,
            39.993648
          ],
          [
            14.162278,
            52.986922,
            40.011211
          ],
          [
            14.161855,
            52.986937,
            40.029507
          ],
          [
            14.161493,
            52.986937,
            40.04507
          ],
          [
            14.161154,
            52.986918,
            40.059679
          ],
          [
            14.160771,
            52.986929,
            40.076154
          ],
          [
            14.160462,
            52.986914,
            40.089479
          ],
          [
            14.160157,
            52.9869,
            40.06995
          ],
          [
            14.159754,
            52.986885,
            40.036351
          ],
          [
            14.159384,
            52.986864,
            40.005419
          ],
          [
            14.159038,
            52.986849,
            39.976513
          ],
          [
            14.158665,
            52.986834,
            39.94543
          ],
          [
            14.158293,
            52.986829,
            39.914475
          ],
          [
            14.157899,
            52.986824,
            39.881707
          ],
          [
            14.15752,
            52.986799,
            39.849972
          ],
          [
            14.157184,
            52.986768,
            40.029066
          ],
          [
            14.156827,
            52.986734,
            40.290892
          ],
          [
            14.156438,
            52.986713,
            40.573945
          ],
          [
            14.156056,
            52.986706,
            40.850791
          ],
          [
            14.155671,
            52.986711,
            41.129946
          ],
          [
            14.155274,
            52.986698,
            41.418021
          ],
          [
            14.154909,
            52.986689,
            41.682668
          ],
          [
            14.154558,
            52.986658,
            41.939649
          ],
          [
            14.15414,
            52.986667,
            41.779844
          ],
          [
            14.153756,
            52.986665,
            41.510739
          ],
          [
            14.153384,
            52.986671,
            41.250109
          ],
          [
            14.153026,
            52.986671,
            40.999465
          ],
          [
            14.152645,
            52.986672,
            40.732713
          ],
          [
            14.15229,
            52.98666,
            40.483767
          ],
          [
            14.151926,
            52.986666,
            40.228634
          ],
          [
            14.151546,
            52.986666,
            39.962577
          ],
          [
            14.151178,
            52.986652,
            40.128035
          ],
          [
            14.150771,
            52.986656,
            40.415078
          ],
          [
            14.150446,
            52.986649,
            40.645097
          ],
          [
            14.150085,
            52.986641,
            40.8997
          ],
          [
            14.149747,
            52.986643,
            41.139003
          ],
          [
            14.149356,
            52.986632,
            41.414975
          ],
          [
            14.148978,
            52.986622,
            41.681574
          ],
          [
            14.148604,
            52.986595,
            41.946972
          ],
          [
            14.148206,
            52.986583,
            41.826697
          ],
          [
            14.147789,
            52.986574,
            41.551834
          ],
          [
            14.147483,
            52.98657,
            41.349929
          ],
          [
            14.147125,
            52.986549,
            41.110469
          ],
          [
            14.146779,
            52.986525,
            40.879705
          ],
          [
            14.146407,
            52.986485,
            40.630311
          ],
          [
            14.14603,
            52.986461,
            40.380594
          ],
          [
            14.145652,
            52.986435,
            40.129462
          ],
          [
            14.14525,
            52.986379,
            40.156221
          ],
          [
            14.144911,
            52.986378,
            40.275006
          ],
          [
            14.144611,
            52.986336,
            40.385883
          ],
          [
            14.144289,
            52.986288,
            40.503814
          ],
          [
            14.143954,
            52.986231,
            40.625622
          ],
          [
            14.143622,
            52.986178,
            40.746384
          ],
          [
            14.143288,
            52.986085,
            40.875216
          ],
          [
            14.142908,
            52.985996,
            41.017898
          ],
          [
            14.142532,
            52.985882,
            41.122661
          ],
          [
            14.142171,
            52.985755,
            41.176329
          ],
          [
            14.141851,
            52.985649,
            41.223516
          ],
          [
            14.141557,
            52.98556,
            41.265785
          ],
          [
            14.141186,
            52.985447,
            41.319206
          ],
          [
            14.140882,
            52.985364,
            41.362068
          ],
          [
            14.140514,
            52.985263,
            41.414098
          ],
          [
            14.140221,
            52.985164,
            41.457275
          ],
          [
            14.139886,
            52.985064,
            41.467124
          ],
          [
            14.139486,
            52.984963,
            41.433454
          ],
          [
            14.139145,
            52.984859,
            41.403924
          ],
          [
            14.138754,
            52.984745,
            41.370362
          ],
          [
            14.138476,
            52.984674,
            41.347047
          ],
          [
            14.138192,
            52.984595,
            41.322841
          ],
          [
            14.137909,
            52.984507,
            41.298228
          ],
          [
            14.137616,
            52.984428,
            41.273441
          ],
          [
            14.137289,
            52.984337,
            41.239263
          ],
          [
            14.136931,
            52.984228,
            41.170338
          ],
          [
            14.136569,
            52.98415,
            41.104296
          ],
          [
            14.136181,
            52.984038,
            41.030382
          ],
          [
            14.135827,
            52.983934,
            40.962724
          ],
          [
            14.135491,
            52.98382,
            40.896449
          ],
          [
            14.135163,
            52.983729,
            40.834407
          ],
          [
            14.13484,
            52.983647,
            40.774082
          ],
          [
            14.134468,
            52.983542,
            40.732486
          ],
          [
            14.134151,
            52.983435,
            40.722982
          ],
          [
            14.133812,
            52.983341,
            40.713263
          ],
          [
            14.133442,
            52.983232,
            40.702527
          ],
          [
            14.133085,
            52.983127,
            40.692135
          ],
          [
            14.132692,
            52.983002,
            40.680546
          ],
          [
            14.132334,
            52.982886,
            40.669959
          ],
          [
            14.131979,
            52.982785,
            40.655909
          ],
          [
            14.131691,
            52.982718,
            40.444737
          ],
          [
            14.131343,
            52.982609,
            40.176673
          ],
          [
            14.131061,
            52.982512,
            39.954923
          ],
          [
            14.130792,
            52.982411,
            39.738515
          ],
          [
            14.130508,
            52.982323,
            39.518983
          ],
          [
            14.130146,
            52.982221,
            39.246126
          ],
          [
            14.129837,
            52.982157,
            39.023059
          ],
          [
            14.129564,
            52.982061,
            38.806891
          ],
          [
            14.129228,
            52.981956,
            38.653928
          ],
          [
            14.12889,
            52.981871,
            38.769436
          ],
          [
            14.128594,
            52.981779,
            38.874486
          ],
          [
            14.128325,
            52.981688,
            38.972168
          ],
          [
            14.128039,
            52.98161,
            39.071191
          ],
          [
            14.127759,
            52.98153,
            39.169033
          ],
          [
            14.127459,
            52.981445,
            39.273559
          ],
          [
            14.127156,
            52.981357,
            39.379735
          ],
          [
            14.126865,
            52.981268,
            39.482814
          ],
          [
            14.126572,
            52.98116,
            39.579062
          ],
          [
            14.12622,
            52.981063,
            39.650411
          ],
          [
            14.125927,
            52.980962,
            39.712454
          ],
          [
            14.125643,
            52.980865,
            39.772511
          ],
          [
            14.125336,
            52.980769,
            39.836073
          ],
          [
            14.125056,
            52.980694,
            39.892653
          ],
          [
            14.124726,
            52.980589,
            39.961257
          ],
          [
            14.124397,
            52.98048,
            40.030341
          ],
          [
            14.124016,
            52.98037,
            40.108008
          ],
          [
            14.123693,
            52.980246,
            40.056551
          ],
          [
            14.12344,
            52.98015,
            40.011857
          ],
          [
            14.12313,
            52.980026,
            39.956552
          ],
          [
            14.122804,
            52.97992,
            39.901394
          ],
          [
            14.12244,
            52.979806,
            39.840413
          ],
          [
            14.12213,
            52.979686,
            39.785648
          ],
          [
            14.121781,
            52.979561,
            39.725328
          ],
          [
            14.121406,
            52.979429,
            39.70884
          ],
          [
            14.121102,
            52.979319,
            40.046442
          ],
          [
            14.120779,
            52.979194,
            40.410601
          ],
          [
            14.120504,
            52.979086,
            40.721761
          ],
          [
            14.120214,
            52.978961,
            41.060131
          ],
          [
            14.119937,
            52.978837,
            41.387436
          ],
          [
            14.119665,
            52.978719,
            41.705452
          ],
          [
            14.119323,
            52.978613,
            42.07006
          ],
          [
            14.118998,
            52.978482,
            42.440889
          ],
          [
            14.118736,
            52.97839,
            42.63058
          ],
          [
            14.118383,
            52.978232,
            42.870657
          ],
          [
            14.118034,
            52.978101,
            43.095118
          ],
          [
            14.117711,
            52.977943,
            43.322249
          ],
          [
            14.117388,
            52.977812,
            43.534842
          ],
          [
            14.117091,
            52.977687,
            43.733043
          ],
          [
            14.116775,
            52.977558,
            43.941485
          ],
          [
            14.116524,
            52.977438,
            44.116392
          ],
          [
            14.11626,
            52.977313,
            44.483674
          ],
          [
            14.115967,
            52.977181,
            44.897281
          ],
          [
            14.115667,
            52.977045,
            45.320987
          ],
          [
            14.115374,
            52.976931,
            45.714659
          ],
          [
            14.115079,
            52.976822,
            46.111194
          ],
          [
            14.11489,
            52.976652,
            46.495814
          ],
          [
            14.114642,
            52.976452,
            46.963779
          ],
          [
            14.114383,
            52.976255,
            47.434571
          ],
          [
            14.114147,
            52.97604,
            47.366727
          ],
          [
            14.113977,
            52.975875,
            47.253514
          ],
          [
            14.113772,
            52.975646,
            47.100066
          ],
          [
            14.113579,
            52.975414,
            46.948646
          ],
          [
            14.113444,
            52.97523,
            46.83139
          ],
          [
            14.113311,
            52.975032,
            46.706884
          ],
          [
            14.11319,
            52.974851,
            46.593213
          ],
          [
            14.113065,
            52.974657,
            46.47197
          ],
          [
            14.11296,
            52.974472,
            46.344463
          ],
          [
            14.112842,
            52.974238,
            46.180555
          ],
          [
            14.112749,
            52.974019,
            46.029332
          ],
          [
            14.112678,
            52.973819,
            45.89248
          ],
          [
            14.1126,
            52.973597,
            45.740688
          ],
          [
            14.112564,
            52.973387,
            45.598945
          ],
          [
            14.112446,
            52.97313,
            45.415011
          ],
          [
            14.112395,
            52.972921,
            45.273703
          ],
          [
            14.112359,
            52.972728,
            45.286721
          ],
          [
            14.112328,
            52.972523,
            45.340234
          ],
          [
            14.112292,
            52.972321,
            45.393038
          ],
          [
            14.112275,
            52.972123,
            45.44459
          ],
          [
            14.11224,
            52.97192,
            45.497636
          ],
          [
            14.112244,
            52.971733,
            45.546241
          ],
          [
            14.11226,
            52.971518,
            45.602218
          ],
          [
            14.11227,
            52.971298,
            45.659439
          ],
          [
            14.112287,
            52.971073,
            45.714297
          ],
          [
            14.112332,
            52.970849,
            45.715994
          ],
          [
            14.112378,
            52.970606,
            45.717833
          ],
          [
            14.112439,
            52.970349,
            45.719785
          ],
          [
            14.112461,
            52.970128,
            45.721449
          ],
          [
            14.112498,
            52.969865,
            45.723434
          ],
          [
            14.112526,
            52.969671,
            45.724899
          ],
          [
            14.11253,
            52.969478,
            45.72635
          ],
          [
            14.112554,
            52.969236,
            45.705491
          ],
          [
            14.112532,
            52.969043,
            45.635893
          ],
          [
            14.112555,
            52.968839,
            45.562388
          ],
          [
            14.112514,
            52.968648,
            45.493152
          ],
          [
            14.112464,
            52.968455,
            45.422952
          ],
          [
            14.112411,
            52.968232,
            45.341926
          ],
          [
            14.112374,
            52.968036,
            45.271048
          ],
          [
            14.112314,
            52.967831,
            45.196234
          ],
          [
            14.11224,
            52.967632,
            45.122969
          ],
          [
            14.11215,
            52.967423,
            45.114355
          ],
          [
            14.112028,
            52.967225,
            45.183364
          ],
          [
            14.111919,
            52.967027,
            45.25149
          ],
          [
            14.111773,
            52.966821,
            45.324645
          ],
          [
            14.111654,
            52.966649,
            45.385502
          ],
          [
            14.111543,
            52.966479,
            45.445109
          ],
          [
            14.11144,
            52.966281,
            45.512972
          ],
          [
            14.111327,
            52.966097,
            45.576991
          ],
          [
            14.111216,
            52.965917,
            45.63962
          ],
          [
            14.111081,
            52.965702,
            45.635907
          ],
          [
            14.110936,
            52.965489,
            45.583847
          ],
          [
            14.110828,
            52.96532,
            45.542893
          ],
          [
            14.110725,
            52.965142,
            45.500254
          ],
          [
            14.110571,
            52.964882,
            45.437819
          ],
          [
            14.110449,
            52.964702,
            45.393834
          ],
          [
            14.110306,
            52.964491,
            45.342254
          ],
          [
            14.110201,
            52.964317,
            45.300383
          ],
          [
            14.110039,
            52.964107,
            45.175107
          ],
          [
            14.109906,
            52.963897,
            44.847637
          ],
          [
            14.109766,
            52.963685,
            44.514182
          ],
          [
            14.109614,
            52.963471,
            44.175057
          ],
          [
            14.109511,
            52.96329,
            43.896336
          ],
          [
            14.109371,
            52.963115,
            43.613213
          ],
          [
            14.109226,
            52.962889,
            43.260249
          ],
          [
            14.109103,
            52.962675,
            42.930199
          ],
          [
            14.108961,
            52.962464,
            42.683483
          ],
          [
            14.108831,
            52.962248,
            43.013373
          ],
          [
            14.108686,
            52.962021,
            43.362601
          ],
          [
            14.108543,
            52.961803,
            43.699299
          ],
          [
            14.108413,
            52.961581,
            44.037205
          ],
          [
            14.108292,
            52.961365,
            44.364439
          ],
          [
            14.108155,
            52.961147,
            44.699028
          ],
          [
            14.108013,
            52.960919,
            45.048674
          ],
          [
            14.107874,
            52.960692,
            45.157038
          ],
          [
            14.107732,
            52.960463,
            45.0233
          ],
          [
            14.107576,
            52.960236,
            44.888742
          ],
          [
            14.107446,
            52.96001,
            44.757985
          ],
          [
            14.107321,
            52.959762,
            44.616324
          ],
          [
            14.107227,
            52.959514,
            44.477286
          ],
          [
            14.107155,
            52.959266,
            44.33964
          ],
          [
            14.10711,
            52.95902,
            44.312061
          ],
          [
            14.107106,
            52.958783,
            44.574309
          ],
          [
            14.107143,
            52.958569,
            44.812401
          ],
          [
            14.107188,
            52.958379,
            45.024738
          ],
          [
            14.10723,
            52.958159,
            45.269736
          ],
          [
            14.107291,
            52.957945,
            45.51062
          ],
          [
            14.107365,
            52.957699,
            45.787316
          ],
          [
            14.107428,
            52.957483,
            46.03018
          ],
          [
            14.107517,
            52.957302,
            46.223894
          ],
          [
            14.107573,
            52.957084,
            46.071678
          ],
          [
            14.107618,
            52.956839,
            45.900813
          ],
          [
            14.107669,
            52.956591,
            45.728259
          ],
          [
            14.107747,
            52.956369,
            45.571637
          ],
          [
            14.107814,
            52.956145,
            45.41462
          ],
          [
            14.10787,
            52.955919,
            45.257019
          ],
          [
            14.107931,
            52.955734,
            45.126917
          ],
          [
            14.107985,
            52.955513,
            44.977412
          ],
          [
            14.108024,
            52.955323,
            44.883877
          ],
          [
            14.108108,
            52.955102,
            44.77311
          ],
          [
            14.108094,
            52.954876,
            44.660869
          ],
          [
            14.108195,
            52.954645,
            44.544115
          ],
          [
            14.108268,
            52.954403,
            44.423945
          ],
          [
            14.108354,
            52.954152,
            44.2984
          ],
          [
            14.108477,
            52.953927,
            44.182457
          ],
          [
            14.108634,
            52.953709,
            44.156168
          ],
          [
            14.108798,
            52.953496,
            44.2752
          ],
          [
            14.108973,
            52.953276,
            44.398846
          ],
          [
            14.10914,
            52.953045,
            44.526519
          ],
          [
            14.109281,
            52.952812,
            44.652198
          ],
          [
            14.109414,
            52.95257,
            44.781371
          ],
          [
            14.109505,
            52.952332,
            44.905137
          ],
          [
            14.109586,
            52.952086,
            45.038653
          ],
          [
            14.109676,
            52.951868,
            45.221888
          ],
          [
            14.109754,
            52.951615,
            45.431807
          ],
          [
            14.109818,
            52.951363,
            45.639903
          ],
          [
            14.109899,
            52.951133,
            45.831689
          ],
          [
            14.109955,
            52.950934,
            45.996333
          ],
          [
            14.110013,
            52.95073,
            46.165236
          ],
          [
            14.110077,
            52.950513,
            46.34522
          ],
          [
            14.110143,
            52.950288,
            46.418549
          ],
          [
            14.110197,
            52.950092,
            46.151247
          ],
          [
            14.110185,
            52.949897,
            45.888073
          ],
          [
            14.110294,
            52.949678,
            45.578615
          ],
          [
            14.11038,
            52.949477,
            45.299522
          ],
          [
            14.110467,
            52.949293,
            45.042261
          ],
          [
            14.110516,
            52.949109,
            44.791691
          ],
          [
            14.110572,
            52.948868,
            44.46437
          ],
          [
            14.11066,
            52.94862,
            44.12346
          ],
          [
            14.110729,
            52.948372,
            44.065484
          ],
          [
            14.110836,
            52.948123,
            44.058688
          ],
          [
            14.110919,
            52.947909,
            44.052882
          ],
          [
            14.111014,
            52.947689,
            44.046872
          ],
          [
            14.111103,
            52.94747,
            44.040915
          ],
          [
            14.111196,
            52.94725,
            44.034916
          ],
          [
            14.111296,
            52.947038,
            44.029093
          ],
          [
            14.11141,
            52.946797,
            44.052599
          ],
          [
            14.111522,
            52.946583,
            44.206374
          ],
          [
            14.111618,
            52.946395,
            44.34194
          ],
          [
            14.111727,
            52.946214,
            44.474147
          ],
          [
            14.111884,
            52.946008,
            44.629479
          ],
          [
            14.112012,
            52.945829,
            44.763097
          ],
          [
            14.112152,
            52.945651,
            44.898138
          ],
          [
            14.112317,
            52.945463,
            45.04409
          ],
          [
            14.112483,
            52.945269,
            45.193846
          ],
          [
            14.112666,
            52.945097,
            45.48025
          ],
          [
            14.112845,
            52.944924,
            45.882731
          ],
          [
            14.113003,
            52.944756,
            46.267279
          ],
          [
            14.113217,
            52.944555,
            46.738815
          ],
          [
            14.113383,
            52.944386,
            47.126455
          ],
          [
            14.113561,
            52.944231,
            47.501612
          ],
          [
            14.113755,
            52.944065,
            47.902393
          ],
          [
            14.113961,
            52.943907,
            48.299144
          ],
          [
            14.114179,
            52.943737,
            48.723878
          ],
          [
            14.114412,
            52.943555,
            48.682722
          ],
          [
            14.114634,
            52.943385,
            48.54071
          ],
          [
            14.11484,
            52.943223,
            48.406353
          ],
          [
            14.115091,
            52.94305,
            48.255569
          ],
          [
            14.115324,
            52.942897,
            48.119302
          ],
          [
            14.115562,
            52.942756,
            47.987335
          ],
          [
            14.115793,
            52.942611,
            47.855446
          ],
          [
            14.116024,
            52.942479,
            47.729382
          ],
          [
            14.116272,
            52.942362,
            47.602524
          ],
          [
            14.116508,
            52.942223,
            47.458186
          ],
          [
            14.116755,
            52.94208,
            47.307858
          ],
          [
            14.117007,
            52.94196,
            47.16743
          ],
          [
            14.117255,
            52.941832,
            47.02453
          ],
          [
            14.117492,
            52.9417,
            46.883431
          ],
          [
            14.117747,
            52.941581,
            46.742419
          ],
          [
            14.118097,
            52.941406,
            46.543598
          ],
          [
            14.11839,
            52.941243,
            46.368438
          ],
          [
            14.11864,
            52.941125,
            46.17011
          ],
          [
            14.118935,
            52.940979,
            45.895604
          ],
          [
            14.119221,
            52.940836,
            45.628354
          ],
          [
            14.11945,
            52.940714,
            45.408534
          ],
          [
            14.119691,
            52.940585,
            45.176736
          ],
          [
            14.119947,
            52.940458,
            44.938078
          ],
          [
            14.120212,
            52.940333,
            44.695852
          ],
          [
            14.120511,
            52.940183,
            44.415491
          ],
          [
            14.120754,
            52.94005,
            44.179408
          ],
          [
            14.120991,
            52.939919,
            44.540357
          ],
          [
            14.121213,
            52.939789,
            44.899497
          ],
          [
            14.121459,
            52.939648,
            45.292874
          ],
          [
            14.121703,
            52.939529,
            45.656602
          ],
          [
            14.121964,
            52.939415,
            46.030719
          ],
          [
            14.122216,
            52.939291,
            46.407622
          ],
          [
            14.122478,
            52.93916,
            46.802285
          ],
          [
            14.122709,
            52.939015,
            47.188631
          ],
          [
            14.12297,
            52.938878,
            47.589583
          ],
          [
            14.123245,
            52.938738,
            47.709721
          ],
          [
            14.123525,
            52.938603,
            47.795937
          ],
          [
            14.123815,
            52.938475,
            47.882367
          ],
          [
            14.124102,
            52.93833,
            47.972579
          ],
          [
            14.124361,
            52.938197,
            48.05485
          ],
          [
            14.124589,
            52.938065,
            48.130877
          ],
          [
            14.124869,
            52.937912,
            48.221753
          ],
          [
            14.125114,
            52.937788,
            48.298676
          ],
          [
            14.12537,
            52.937655,
            48.272933
          ],
          [
            14.125639,
            52.937481,
            48.034666
          ],
          [
            14.125857,
            52.937325,
            47.83034
          ],
          [
            14.126058,
            52.937153,
            47.619599
          ],
          [
            14.126273,
            52.936977,
            47.399802
          ],
          [
            14.126479,
            52.936747,
            47.135934
          ],
          [
            14.126701,
            52.936525,
            46.876221
          ],
          [
            14.126871,
            52.936311,
            46.638555
          ],
          [
            14.127007,
            52.936131,
            46.46996
          ],
          [
            14.12709,
            52.935945,
            46.331758
          ],
          [
            14.127147,
            52.935761,
            46.197609
          ],
          [
            14.127191,
            52.935559,
            46.051679
          ],
          [
            14.127189,
            52.935346,
            45.898476
          ],
          [
            14.127233,
            52.935131,
            45.742853
          ],
          [
            14.12727,
            52.934925,
            45.594503
          ],
          [
            14.127321,
            52.934727,
            45.450929
          ],
          [
            14.127363,
            52.934526,
            45.305337
          ],
          [
            14.127417,
            52.934315,
            45.242174
          ],
          [
            14.127436,
            52.93411,
            45.217821
          ],
          [
            14.127487,
            52.933894,
            45.191884
          ],
          [
            14.12753,
            52.933682,
            45.166535
          ],
          [
            14.127547,
            52.933479,
            45.142256
          ],
          [
            14.127607,
            52.933264,
            45.116313
          ],
          [
            14.127612,
            52.933057,
            45.091633
          ],
          [
            14.127624,
            52.932843,
            45.066235
          ],
          [
            14.127653,
            52.932657,
            45.041635
          ],
          [
            14.127674,
            52.932446,
            44.994294
          ],
          [
            14.127715,
            52.93222,
            44.943362
          ],
          [
            14.127744,
            52.931993,
            44.892293
          ],
          [
            14.127783,
            52.931787,
            44.845843
          ],
          [
            14.127861,
            52.931581,
            44.798518
          ],
          [
            14.127887,
            52.931352,
            44.747054
          ],
          [
            14.127905,
            52.93115,
            44.701722
          ],
          [
            14.127913,
            52.930921,
            44.650412
          ],
          [
            14.127971,
            52.930713,
            44.980497
          ],
          [
            14.128011,
            52.930508,
            45.361753
          ],
          [
            14.128019,
            52.930321,
            45.707696
          ],
          [
            14.128042,
            52.930137,
            46.049297
          ],
          [
            14.128082,
            52.92994,
            46.415976
          ],
          [
            14.128125,
            52.92971,
            46.843603
          ],
          [
            14.128156,
            52.929487,
            47.256939
          ],
          [
            14.128176,
            52.929264,
            47.669495
          ],
          [
            14.128201,
            52.929049,
            47.920493
          ],
          [
            14.128219,
            52.928792,
            47.707122
          ],
          [
            14.128217,
            52.928574,
            47.526541
          ],
          [
            14.128189,
            52.928335,
            47.32825
          ],
          [
            14.128141,
            52.928085,
            47.119983
          ],
          [
            14.128117,
            52.927864,
            46.936662
          ],
          [
            14.12807,
            52.9276,
            46.716935
          ],
          [
            14.128015,
            52.927393,
            46.542816
          ],
          [
            14.127966,
            52.927136,
            46.418858
          ],
          [
            14.127938,
            52.926882,
            46.335808
          ],
          [
            14.127922,
            52.926643,
            46.257801
          ],
          [
            14.127888,
            52.926396,
            46.176891
          ],
          [
            14.127872,
            52.926152,
            46.097254
          ],
          [
            14.127865,
            52.925905,
            46.016636
          ],
          [
            14.127845,
            52.925665,
            45.938239
          ],
          [
            14.127817,
            52.925425,
            45.941028
          ],
          [
            14.127827,
            52.925202,
            46.057976
          ],
          [
            14.127839,
            52.92495,
            46.189858
          ],
          [
            14.127875,
            52.924711,
            46.315575
          ],
          [
            14.12792,
            52.924456,
            46.449693
          ],
          [
            14.127941,
            52.924223,
            46.571766
          ],
          [
            14.127998,
            52.923996,
            46.691838
          ],
          [
            14.128069,
            52.923775,
            46.809571
          ],
          [
            14.128104,
            52.923559,
            46.544611
          ],
          [
            14.128007,
            52.92338,
            46.227499
          ],
          [
            14.128136,
            52.923231,
            45.911258
          ],
          [
            14.128433,
            52.923126,
            45.570852
          ],
          [
            14.128635,
            52.922928,
            45.181635
          ],
          [
            14.12868,
            52.922701,
            44.803601
          ],
          [
            14.128799,
            52.92253,
            44.499397
          ],
          [
            14.129032,
            52.922334,
            44.085073
          ],
          [
            14.129434,
            52.922348,
            43.731099
          ],
          [
            14.129858,
            52.922377,
            43.40492
          ],
          [
            14.130222,
            52.922401,
            43.125198
          ],
          [
            14.130566,
            52.922447,
            42.856021
          ],
          [
            14.130888,
            52.922497,
            42.602018
          ],
          [
            14.131187,
            52.922542,
            42.366024
          ],
          [
            14.131545,
            52.922611,
            42.07869
          ],
          [
            14.131961,
            52.922685,
            41.747301
          ],
          [
            14.13238,
            52.922689,
            41.637095
          ],
          [
            14.132784,
            52.922681,
            41.696853
          ],
          [
            14.133191,
            52.922669,
            41.757016
          ],
          [
            14.133559,
            52.922647,
            41.811607
          ],
          [
            14.133932,
            52.922627,
            41.867013
          ],
          [
            14.134322,
            52.922631,
            41.924658
          ],
          [
            14.13469,
            52.922616,
            41.979447
          ],
          [
            14.135054,
            52.922543,
            42.036156
          ],
          [
            14.135415,
            52.922437,
            42.043612
          ],
          [
            14.1358,
            52.922415,
            42.043861
          ],
          [
            14.136166,
            52.922405,
            42.044104
          ],
          [
            14.136481,
            52.922301,
            42.044331
          ],
          [
            14.136823,
            52.922174,
            42.044584
          ],
          [
            14.137189,
            52.922045,
            42.044852
          ],
          [
            14.1375,
            52.921936,
            42.045079
          ],
          [
            14.137885,
            52.921832,
            42.06898
          ],
          [
            14.13824,
            52.921717,
            42.14946
          ],
          [
            14.138595,
            52.921591,
            42.231677
          ],
          [
            14.138944,
            52.921464,
            42.313037
          ],
          [
            14.139271,
            52.921347,
            42.38894
          ],
          [
            14.139583,
            52.921242,
            42.460269
          ],
          [
            14.139905,
            52.921128,
            42.534796
          ],
          [
            14.140211,
            52.921026,
            42.604616
          ],
          [
            14.140482,
            52.92093,
            42.945307
          ],
          [
            14.14078,
            52.920871,
            43.668393
          ],
          [
            14.141188,
            52.920734,
            44.737285
          ],
          [
            14.141473,
            52.920624,
            45.507904
          ],
          [
            14.14177,
            52.920568,
            46.220092
          ],
          [
            14.142055,
            52.92063,
            46.922184
          ],
          [
            14.142219,
            52.920491,
            47.615756
          ],
          [
            14.14228,
            52.920303,
            48.339657
          ],
          [
            14.142375,
            52.920112,
            49.093882
          ],
          [
            14.142448,
            52.919928,
            49.258715
          ],
          [
            14.142512,
            52.919718,
            48.880899
          ],
          [
            14.142596,
            52.919499,
            48.483341
          ],
          [
            14.142638,
            52.919298,
            48.124969
          ],
          [
            14.142703,
            52.919066,
            47.708612
          ],
          [
            14.142782,
            52.918877,
            47.363799
          ],
          [
            14.142838,
            52.918692,
            47.029801
          ],
          [
            14.142911,
            52.918479,
            46.644938
          ],
          [
            14.142985,
            52.91825,
            46.255199
          ],
          [
            14.143072,
            52.918015,
            46.300223
          ],
          [
            14.143178,
            52.917768,
            46.347935
          ],
          [
            14.143289,
            52.917532,
            46.393804
          ],
          [
            14.143381,
            52.917307,
            46.437137
          ],
          [
            14.143461,
            52.917076,
            46.481261
          ],
          [
            14.143546,
            52.916837,
            46.526964
          ],
          [
            14.143623,
            52.91661,
            46.570308
          ],
          [
            14.143694,
            52.916392,
            46.785474
          ],
          [
            14.143769,
            52.916164,
            47.163626
          ],
          [
            14.143849,
            52.915931,
            47.550763
          ],
          [
            14.143948,
            52.915679,
            47.972061
          ],
          [
            14.144045,
            52.915438,
            48.375568
          ],
          [
            14.144122,
            52.915206,
            48.761166
          ],
          [
            14.144203,
            52.91498,
            49.137366
          ],
          [
            14.144284,
            52.914754,
            49.513499
          ],
          [
            14.144358,
            52.914516,
            49.327534
          ],
          [
            14.144434,
            52.914285,
            49.14422
          ],
          [
            14.144488,
            52.914063,
            48.969418
          ],
          [
            14.144596,
            52.913815,
            48.769823
          ],
          [
            14.144694,
            52.913565,
            48.56985
          ],
          [
            14.144793,
            52.9133,
            48.358367
          ],
          [
            14.144863,
            52.913085,
            48.187807
          ],
          [
            14.144944,
            52.912836,
            48.10774
          ],
          [
            14.145009,
            52.912623,
            48.097718
          ],
          [
            14.145095,
            52.912402,
            48.087215
          ],
          [
            14.14516,
            52.912156,
            48.075685
          ],
          [
            14.145239,
            52.911971,
            48.066848
          ],
          [
            14.145318,
            52.911716,
            48.054848
          ],
          [
            14.145384,
            52.911496,
            48.04449
          ],
          [
            14.145447,
            52.911311,
            48.035737
          ],
          [
            14.145536,
            52.911128,
            47.9976
          ],
          [
            14.145605,
            52.910938,
            47.936562
          ],
          [
            14.145671,
            52.910739,
            47.87284
          ],
          [
            14.145744,
            52.910519,
            47.802435
          ],
          [
            14.145822,
            52.910335,
            47.742821
          ],
          [
            14.14592,
            52.910043,
            47.649361
          ],
          [
            14.145995,
            52.909783,
            47.566571
          ],
          [
            14.14608,
            52.909527,
            47.484639
          ],
          [
            14.146152,
            52.909305,
            47.324688
          ],
          [
            14.146236,
            52.909054,
            47.112155
          ],
          [
            14.146302,
            52.908842,
            46.933064
          ],
          [
            14.146374,
            52.908627,
            46.750266
          ],
          [
            14.146436,
            52.908446,
            46.596763
          ],
          [
            14.146514,
            52.908202,
            46.390479
          ],
          [
            14.146576,
            52.907991,
            46.21227
          ],
          [
            14.146654,
            52.907754,
            46.011674
          ],
          [
            14.146743,
            52.907525,
            46.323024
          ],
          [
            14.146785,
            52.907333,
            46.675615
          ],
          [
            14.146848,
            52.907155,
            47.00732
          ],
          [
            14.146904,
            52.906927,
            47.427254
          ],
          [
            14.146981,
            52.906746,
            47.767756
          ],
          [
            14.147057,
            52.906523,
            48.182247
          ],
          [
            14.147124,
            52.9063,
            48.594845
          ],
          [
            14.147187,
            52.906085,
            48.992352
          ],
          [
            14.147281,
            52.90587,
            49.273077
          ],
          [
            14.147368,
            52.90561,
            49.350358
          ],
          [
            14.147461,
            52.90535,
            49.427788
          ],
          [
            14.147551,
            52.905136,
            49.492095
          ],
          [
            14.147612,
            52.904934,
            49.551869
          ],
          [
            14.147696,
            52.904716,
            49.617331
          ],
          [
            14.147766,
            52.904539,
            49.670309
          ],
          [
            14.147864,
            52.904322,
            49.735858
          ],
          [
            14.14793,
            52.904091,
            49.725737
          ],
          [
            14.148005,
            52.903877,
            49.628779
          ],
          [
            14.148093,
            52.903627,
            49.515524
          ],
          [
            14.148187,
            52.903412,
            49.417043
          ],
          [
            14.148259,
            52.903175,
            49.310382
          ],
          [
            14.148315,
            52.902945,
            49.207477
          ],
          [
            14.148374,
            52.902731,
            49.111461
          ],
          [
            14.148448,
            52.902543,
            49.025787
          ],
          [
            14.148503,
            52.902363,
            48.940699
          ],
          [
            14.148596,
            52.902115,
            48.814604
          ],
          [
            14.148661,
            52.901939,
            48.725053
          ],
          [
            14.148747,
            52.901766,
            48.635446
          ],
          [
            14.14885,
            52.901549,
            48.523482
          ],
          [
            14.148952,
            52.901306,
            48.399171
          ],
          [
            14.149059,
            52.901094,
            48.289295
          ],
          [
            14.149114,
            52.900887,
            48.184659
          ],
          [
            14.149246,
            52.900681,
            48.096107
          ],
          [
            14.149377,
            52.900466,
            48.218826
          ],
          [
            14.149512,
            52.900207,
            48.364566
          ],
          [
            14.149607,
            52.900033,
            48.462808
          ],
          [
            14.149734,
            52.89978,
            48.605341
          ],
          [
            14.149829,
            52.899608,
            48.702507
          ],
          [
            14.14998,
            52.899393,
            48.827647
          ],
          [
            14.150108,
            52.899196,
            48.940997
          ],
          [
            14.150232,
            52.898945,
            49.11042
          ],
          [
            14.150393,
            52.89871,
            49.369057
          ],
          [
            14.150677,
            52.898532,
            49.619496
          ],
          [
            14.150975,
            52.89839,
            49.851849
          ],
          [
            14.151235,
            52.898224,
            50.083185
          ],
          [
            14.151456,
            52.898006,
            50.342334
          ],
          [
            14.151648,
            52.897859,
            50.532157
          ],
          [
            14.15193,
            52.89764,
            50.812929
          ],
          [
            14.152128,
            52.897484,
            50.814464
          ],
          [
            14.152282,
            52.897268,
            50.724429
          ],
          [
            14.152409,
            52.897066,
            50.641901
          ],
          [
            14.152529,
            52.896836,
            50.549547
          ],
          [
            14.152711,
            52.89662,
            50.45694
          ],
          [
            14.152854,
            52.896399,
            50.366062
          ],
          [
            14.153048,
            52.896162,
            50.265094
          ],
          [
            14.153219,
            52.89595,
            50.1786
          ],
          [
            14.153373,
            52.895721,
            50.137566
          ],
          [
            14.153537,
            52.895494,
            50.096402
          ],
          [
            14.153702,
            52.895286,
            50.058113
          ],
          [
            14.153851,
            52.895081,
            50.020937
          ],
          [
            14.154012,
            52.894883,
            49.984318
          ],
          [
            14.154164,
            52.894662,
            49.944586
          ],
          [
            14.154315,
            52.894439,
            49.904564
          ],
          [
            14.154456,
            52.894224,
            49.805451
          ],
          [
            14.154589,
            52.894015,
            49.63431
          ],
          [
            14.154749,
            52.893815,
            49.464495
          ],
          [
            14.154922,
            52.893594,
            49.275517
          ],
          [
            14.155089,
            52.893362,
            49.082902
          ],
          [
            14.155229,
            52.893163,
            48.918272
          ],
          [
            14.155381,
            52.89295,
            48.741772
          ],
          [
            14.155561,
            52.892723,
            48.548951
          ],
          [
            14.155698,
            52.892526,
            48.765333
          ],
          [
            14.155886,
            52.892306,
            49.134139
          ],
          [
            14.156052,
            52.892083,
            49.497765
          ],
          [
            14.156217,
            52.891848,
            49.878919
          ],
          [
            14.156387,
            52.89161,
            50.26523
          ],
          [
            14.156555,
            52.891369,
            50.65519
          ],
          [
            14.156708,
            52.891173,
            50.977914
          ],
          [
            14.156871,
            52.890936,
            51.315463
          ],
          [
            14.156988,
            52.890721,
            51.564869
          ],
          [
            14.15712,
            52.890504,
            51.819703
          ],
          [
            14.157267,
            52.89028,
            52.08488
          ],
          [
            14.157395,
            52.890032,
            52.370959
          ],
          [
            14.157478,
            52.889851,
            52.57897
          ],
          [
            14.157571,
            52.889636,
            52.825421
          ],
          [
            14.157673,
            52.889422,
            53.072304
          ],
          [
            14.157765,
            52.889245,
            53.059419
          ],
          [
            14.157827,
            52.889023,
            52.803364
          ],
          [
            14.15792,
            52.88884,
            52.585971
          ],
          [
            14.157989,
            52.888623,
            52.335065
          ],
          [
            14.157987,
            52.888398,
            52.076631
          ],
          [
            14.158044,
            52.888205,
            51.854519
          ],
          [
            14.158124,
            52.888017,
            51.634613
          ],
          [
            14.158101,
            52.887767,
            51.348973
          ],
          [
            14.158194,
            52.887529,
            51.01451
          ],
          [
            14.158197,
            52.887289,
            50.482103
          ],
          [
            14.158188,
            52.887039,
            49.927142
          ],
          [
            14.158104,
            52.886805,
            49.396113
          ],
          [
            14.158005,
            52.886607,
            48.936647
          ],
          [
            14.157895,
            52.886395,
            48.443979
          ],
          [
            14.157805,
            52.88621,
            48.01564
          ],
          [
            14.157711,
            52.885995,
            47.521346
          ],
          [
            14.157614,
            52.885774,
            47.119003
          ],
          [
            14.157522,
            52.88557,
            47.030559
          ],
          [
            14.157414,
            52.885332,
            46.927415
          ],
          [
            14.15733,
            52.885128,
            46.839423
          ],
          [
            14.157449,
            52.885028,
            46.760576
          ],
          [
            14.157363,
            52.884996,
            46.660171
          ],
          [
            14.157171,
            52.884756,
            46.546182
          ],
          [
            14.157112,
            52.884569,
            46.466604
          ],
          [
            14.157041,
            52.884371,
            46.3887
          ],
          [
            14.156957,
            52.884189,
            46.364685
          ],
          [
            14.156868,
            52.883982,
            46.337374
          ],
          [
            14.156763,
            52.883754,
            46.307297
          ],
          [
            14.156693,
            52.88357,
            46.283287
          ],
          [
            14.156608,
            52.883386,
            46.258816
          ],
          [
            14.156472,
            52.883185,
            46.231222
          ],
          [
            14.156356,
            52.882955,
            46.200664
          ],
          [
            14.156227,
            52.882728,
            46.170161
          ],
          [
            14.156175,
            52.882545,
            46.418823
          ],
          [
            14.156117,
            52.882327,
            46.851963
          ],
          [
            14.156127,
            52.88208,
            47.339906
          ],
          [
            14.156106,
            52.881879,
            47.735211
          ],
          [
            14.156077,
            52.881654,
            48.177641
          ],
          [
            14.15602,
            52.881416,
            48.649076
          ],
          [
            14.155971,
            52.881169,
            49.1372
          ],
          [
            14.155904,
            52.880934,
            49.604612
          ],
          [
            14.155818,
            52.880708,
            49.587039
          ],
          [
            14.155708,
            52.880476,
            49.457501
          ],
          [
            14.155568,
            52.880248,
            49.32705
          ],
          [
            14.155405,
            52.880024,
            49.195797
          ],
          [
            14.155235,
            52.879802,
            49.064549
          ],
          [
            14.155069,
            52.879579,
            48.933369
          ],
          [
            14.154876,
            52.87936,
            48.800287
          ],
          [
            14.154665,
            52.87913,
            48.830835
          ],
          [
            14.154482,
            52.878941,
            49.028395
          ],
          [
            14.154301,
            52.878726,
            49.24468
          ],
          [
            14.154125,
            52.878511,
            49.458866
          ],
          [
            14.153935,
            52.878287,
            49.683616
          ],
          [
            14.153748,
            52.878063,
            49.907626
          ],
          [
            14.15355,
            52.877857,
            50.120362
          ],
          [
            14.153358,
            52.87765,
            50.328311
          ],
          [
            14.153163,
            52.877433,
            50.177956
          ],
          [
            14.15295,
            52.877247,
            50.040298
          ],
          [
            14.15273,
            52.877067,
            49.904084
          ],
          [
            14.152529,
            52.876906,
            49.781245
          ],
          [
            14.152323,
            52.876747,
            49.65818
          ],
          [
            14.152128,
            52.876559,
            49.523191
          ],
          [
            14.151891,
            52.876379,
            49.383263
          ],
          [
            14.151659,
            52.876196,
            49.242995
          ],
          [
            14.151424,
            52.876015,
            49.364691
          ],
          [
            14.151218,
            52.875829,
            49.498004
          ],
          [
            14.151053,
            52.875673,
            49.608423
          ],
          [
            14.150815,
            52.875462,
            49.760596
          ],
          [
            14.150613,
            52.87528,
            49.891155
          ],
          [
            14.150392,
            52.87507,
            50.039445
          ],
          [
            14.150203,
            52.874879,
            50.172453
          ],
          [
            14.15003,
            52.874675,
            50.30234
          ],
          [
            14.149888,
            52.874434,
            49.990389
          ],
          [
            14.14974,
            52.874278,
            49.771045
          ],
          [
            14.149561,
            52.874086,
            49.502637
          ],
          [
            14.149426,
            52.873908,
            49.264088
          ],
          [
            14.149238,
            52.87375,
            49.027081
          ],
          [
            14.149066,
            52.873592,
            48.79678
          ],
          [
            14.148815,
            52.873412,
            48.510173
          ],
          [
            14.148596,
            52.873207,
            48.21251
          ],
          [
            14.148502,
            52.87301,
            48.160951
          ],
          [
            14.14843,
            52.872785,
            48.243078
          ],
          [
            14.148511,
            52.872577,
            48.325329
          ],
          [
            14.148778,
            52.872478,
            48.392984
          ],
          [
            14.14906,
            52.87235,
            48.469311
          ],
          [
            14.149323,
            52.872208,
            48.545452
          ],
          [
            14.149566,
            52.872083,
            48.614432
          ],
          [
            14.149822,
            52.871962,
            48.68475
          ],
          [
            14.149929,
            52.871796,
            48.752302
          ],
          [
            14.149834,
            52.871617,
            48.352974
          ],
          [
            14.149621,
            52.871437,
            47.831972
          ],
          [
            14.149394,
            52.871241,
            47.268711
          ],
          [
            14.149143,
            52.871038,
            46.672071
          ],
          [
            14.148903,
            52.870845,
            46.103684
          ],
          [
            14.148709,
            52.870673,
            45.61352
          ],
          [
            14.148547,
            52.870493,
            45.130259
          ],
          [
            14.148308,
            52.870313,
            44.586933
          ],
          [
            14.148076,
            52.870142,
            44.184357
          ],
          [
            14.147841,
            52.869945,
            43.760637
          ],
          [
            14.147588,
            52.86974,
            43.314441
          ],
          [
            14.147409,
            52.869592,
            42.994473
          ],
          [
            14.147197,
            52.869407,
            42.601897
          ],
          [
            14.146959,
            52.869237,
            42.213145
          ],
          [
            14.146736,
            52.869057,
            41.820907
          ],
          [
            14.146484,
            52.868844,
            41.38024
          ],
          [
            14.146284,
            52.868693,
            41.321514
          ],
          [
            14.146082,
            52.868554,
            41.265408
          ],
          [
            14.145893,
            52.868398,
            41.206608
          ],
          [
            14.1457,
            52.868247,
            41.148727
          ],
          [
            14.145508,
            52.868099,
            41.091483
          ],
          [
            14.145318,
            52.867951,
            41.034642
          ],
          [
            14.145112,
            52.867804,
            40.97614
          ],
          [
            14.144893,
            52.867651,
            40.914761
          ],
          [
            14.144682,
            52.8675,
            40.854792
          ],
          [
            14.144486,
            52.867353,
            40.776108
          ],
          [
            14.144291,
            52.867201,
            40.686809
          ],
          [
            14.144059,
            52.867033,
            40.585217
          ],
          [
            14.143852,
            52.866886,
            40.495512
          ],
          [
            14.143604,
            52.866716,
            40.39002
          ],
          [
            14.143397,
            52.866573,
            40.301749
          ],
          [
            14.143116,
            52.866371,
            40.179157
          ],
          [
            14.142821,
            52.866182,
            40.058539
          ],
          [
            14.14258,
            52.866007,
            40.161222
          ],
          [
            14.142372,
            52.865849,
            40.461376
          ],
          [
            14.142165,
            52.865693,
            40.758308
          ],
          [
            14.141914,
            52.865521,
            41.098606
          ],
          [
            14.141653,
            52.865338,
            41.459404
          ],
          [
            14.14131,
            52.865217,
            41.819364
          ],
          [
            14.140931,
            52.865255,
            42.163806
          ],
          [
            14.140889,
            52.865063,
            42.451344
          ],
          [
            14.140699,
            52.864895,
            42.677558
          ],
          [
            14.140435,
            52.864751,
            42.697002
          ],
          [
            14.14018,
            52.864604,
            42.716271
          ],
          [
            14.139972,
            52.864437,
            42.735226
          ],
          [
            14.139881,
            52.864221,
            42.755459
          ],
          [
            14.139823,
            52.864018,
            42.774125
          ],
          [
            14.139709,
            52.863838,
            42.791571
          ],
          [
            14.139549,
            52.86365,
            42.8107
          ],
          [
            14.139343,
            52.863479,
            42.829848
          ],
          [
            14.13914,
            52.863328,
            42.878655
          ],
          [
            14.138914,
            52.863163,
            42.948307
          ],
          [
            14.138678,
            52.863,
            43.018728
          ],
          [
            14.138412,
            52.862812,
            43.099154
          ],
          [
            14.13815,
            52.862608,
            43.183116
          ],
          [
            14.137933,
            52.86244,
            43.252462
          ],
          [
            14.137728,
            52.862298,
            43.313759
          ],
          [
            14.137489,
            52.862126,
            43.38679
          ],
          [
            14.137278,
            52.861964,
            43.256613
          ],
          [
            14.137063,
            52.861818,
            42.944737
          ],
          [
            14.136859,
            52.861666,
            42.63243
          ],
          [
            14.13665,
            52.861518,
            42.321973
          ],
          [
            14.136411,
            52.861317,
            41.926668
          ],
          [
            14.136194,
            52.861158,
            41.597818
          ],
          [
            14.135967,
            52.861003,
            41.267358
          ],
          [
            14.135753,
            52.860847,
            40.943903
          ],
          [
            14.135536,
            52.860688,
            40.614932
          ],
          [
            14.135315,
            52.860522,
            40.639383
          ],
          [
            14.135112,
            52.860376,
            40.738966
          ],
          [
            14.134884,
            52.860227,
            40.84497
          ],
          [
            14.134665,
            52.860076,
            40.949854
          ],
          [
            14.134468,
            52.859915,
            41.05452
          ],
          [
            14.134267,
            52.85976,
            41.157403
          ],
          [
            14.134114,
            52.859593,
            41.257577
          ],
          [
            14.133899,
            52.859461,
            41.354903
          ],
          [
            14.133669,
            52.859315,
            41.460483
          ],
          [
            14.133446,
            52.859164,
            41.428837
          ],
          [
            14.133203,
            52.859,
            41.339186
          ],
          [
            14.132982,
            52.858833,
            41.252045
          ],
          [
            14.132778,
            52.858682,
            41.172668
          ],
          [
            14.132569,
            52.858516,
            41.087713
          ],
          [
            14.132339,
            52.858345,
            40.997907
          ],
          [
            14.132105,
            52.858181,
            40.909378
          ],
          [
            14.131899,
            52.858015,
            40.824874
          ],
          [
            14.131678,
            52.857851,
            40.735303
          ],
          [
            14.131452,
            52.857684,
            40.630376
          ],
          [
            14.131223,
            52.857515,
            40.524183
          ],
          [
            14.130998,
            52.857349,
            40.419875
          ],
          [
            14.130769,
            52.857179,
            40.313178
          ],
          [
            14.130521,
            52.856997,
            40.19853
          ],
          [
            14.130294,
            52.856818,
            40.088894
          ],
          [
            14.130072,
            52.85666,
            39.988161
          ],
          [
            14.129875,
            52.856456,
            39.912008
          ],
          [
            14.129672,
            52.856263,
            40.281623
          ],
          [
            14.129456,
            52.856078,
            40.648336
          ],
          [
            14.129269,
            52.855895,
            40.996155
          ],
          [
            14.12909,
            52.855701,
            41.354993
          ],
          [
            14.128888,
            52.855505,
            41.727977
          ],
          [
            14.1287,
            52.855304,
            42.10111
          ],
          [
            14.128516,
            52.855124,
            42.443
          ],
          [
            14.12834,
            52.854928,
            42.793294
          ],
          [
            14.12808,
            52.854737,
            42.905328
          ],
          [
            14.127883,
            52.854518,
            43.01801
          ],
          [
            14.127682,
            52.854295,
            43.13267
          ],
          [
            14.127497,
            52.854076,
            43.243833
          ],
          [
            14.127279,
            52.853867,
            43.355409
          ],
          [
            14.127081,
            52.853645,
            43.469394
          ],
          [
            14.126895,
            52.85343,
            43.578996
          ],
          [
            14.126731,
            52.853206,
            43.830602
          ],
          [
            14.126551,
            52.852983,
            44.119242
          ],
          [
            14.12638,
            52.852749,
            44.416765
          ],
          [
            14.126198,
            52.852509,
            44.723978
          ],
          [
            14.126009,
            52.852263,
            45.039453
          ],
          [
            14.125825,
            52.852047,
            45.322692
          ],
          [
            14.125658,
            52.851846,
            45.584433
          ],
          [
            14.125535,
            52.851661,
            45.62711
          ],
          [
            14.125397,
            52.851479,
            45.504785
          ],
          [
            14.125292,
            52.851289,
            45.382525
          ],
          [
            14.125173,
            52.851103,
            45.260814
          ],
          [
            14.125121,
            52.850907,
            45.139609
          ],
          [
            14.125078,
            52.850706,
            45.015872
          ],
          [
            14.12503,
            52.850484,
            44.878786
          ],
          [
            14.1249,
            52.850273,
            44.741276
          ],
          [
            14.124724,
            52.85007,
            44.601308
          ],
          [
            14.124554,
            52.849899,
            44.412043
          ],
          [
            14.124376,
            52.849722,
            44.209794
          ],
          [
            14.124139,
            52.849502,
            43.955045
          ],
          [
            14.123938,
            52.849293,
            43.720246
          ],
          [
            14.123732,
            52.849111,
            43.506712
          ],
          [
            14.123557,
            52.848937,
            43.309596
          ],
          [
            14.123448,
            52.848734,
            43.102972
          ],
          [
            14.123338,
            52.848522,
            42.887781
          ],
          [
            14.123244,
            52.848325,
            43.120554
          ],
          [
            14.123165,
            52.848114,
            43.462833
          ],
          [
            14.123097,
            52.847889,
            43.82473
          ],
          [
            14.123003,
            52.847662,
            44.194816
          ],
          [
            14.122954,
            52.847448,
            44.536428
          ],
          [
            14.122927,
            52.847231,
            44.881216
          ],
          [
            14.122945,
            52.846999,
            45.248458
          ],
          [
            14.122957,
            52.846763,
            45.621931
          ],
          [
            14.122939,
            52.84657,
            45.857811
          ],
          [
            14.122921,
            52.846375,
            46.073906
          ],
          [
            14.123006,
            52.846189,
            46.287122
          ],
          [
            14.123079,
            52.846,
            46.501935
          ],
          [
            14.123004,
            52.845819,
            46.708326
          ],
          [
            14.122874,
            52.845627,
            46.937664
          ],
          [
            14.122689,
            52.845446,
            47.172799
          ],
          [
            14.122525,
            52.845277,
            47.388814
          ],
          [
            14.122368,
            52.845107,
            47.604137
          ],
          [
            14.122186,
            52.844942,
            47.913136
          ],
          [
            14.122034,
            52.844727,
            48.334273
          ],
          [
            14.121892,
            52.844523,
            48.732492
          ],
          [
            14.121737,
            52.844309,
            49.153242
          ],
          [
            14.121617,
            52.844091,
            49.566559
          ],
          [
            14.121478,
            52.843877,
            49.980128
          ],
          [
            14.121358,
            52.843675,
            50.36657
          ],
          [
            14.121227,
            52.843436,
            50.819803
          ],
          [
            14.121488,
            52.843338,
            50.998163
          ],
          [
            14.121856,
            52.843313,
            51.133439
          ],
          [
            14.122164,
            52.843271,
            51.248616
          ],
          [
            14.122494,
            52.843232,
            51.37114
          ],
          [
            14.122814,
            52.843208,
            51.488599
          ],
          [
            14.123208,
            52.843153,
            51.635957
          ],
          [
            14.123556,
            52.8431,
            51.766684
          ],
          [
            14.123894,
            52.84305,
            51.893421
          ],
          [
            14.124262,
            52.843011,
            52.076426
          ],
          [
            14.124634,
            52.842973,
            52.432221
          ],
          [
            14.125007,
            52.842944,
            52.786891
          ],
          [
            14.1254,
            52.842857,
            53.185201
          ],
          [
            14.125712,
            52.842768,
            53.510906
          ],
          [
            14.126025,
            52.842673,
            53.842159
          ],
          [
            14.126333,
            52.842658,
            54.133859
          ],
          [
            14.126654,
            52.842624,
            54.445483
          ],
          [
            14.126955,
            52.842565,
            54.744318
          ],
          [
            14.127268,
            52.842511,
            54.590434
          ],
          [
            14.127576,
            52.842542,
            54.324744
          ],
          [
            14.127884,
            52.842514,
            54.063403
          ],
          [
            14.127916,
            52.84255,
            53.789592
          ],
          [
            14.128035,
            52.842739,
            53.507369
          ],
          [
            14.128023,
            52.842956,
            53.206732
          ],
          [
            14.128002,
            52.843147,
            52.941108
          ],
          [
            14.128232,
            52.843283,
            52.671223
          ],
          [
            14.128403,
            52.843446,
            52.404036
          ],
          [
            14.128656,
            52.843544,
            52.096307
          ],
          [
            14.128912,
            52.843665,
            51.740624
          ],
          [
            14.129198,
            52.843738,
            51.371949
          ],
          [
            14.129413,
            52.843879,
            51.030181
          ],
          [
            14.129743,
            52.843953,
            50.647849
          ],
          [
            14.12991,
            52.844102,
            50.273022
          ],
          [
            14.130289,
            52.844199,
            49.827638
          ],
          [
            14.130569,
            52.8443,
            49.474583
          ],
          [
            14.130867,
            52.844392,
            49.120407
          ],
          [
            14.131123,
            52.844508,
            49.506335
          ],
          [
            14.131077,
            52.844678,
            49.859474
          ],
          [
            14.130907,
            52.844846,
            50.236804
          ],
          [
            14.130729,
            52.845016,
            50.623639
          ],
          [
            14.130601,
            52.845194,
            50.996243
          ],
          [
            14.130362,
            52.84533,
            51.387082
          ],
          [
            14.130065,
            52.84538,
            51.783607
          ],
          [
            14.129733,
            52.84536,
            52.169258
          ],
          [
            14.129411,
            52.845335,
            52.547102
          ],
          [
            14.129084,
            52.845286,
            52.185663
          ],
          [
            14.128774,
            52.845273,
            51.834326
          ],
          [
            14.128465,
            52.84523,
            51.475798
          ],
          [
            14.128205,
            52.845152,
            51.128382
          ],
          [
            14.128084,
            52.844962,
            50.747326
          ],
          [
            14.12796,
            52.844769,
            50.359587
          ],
          [
            14.127744,
            52.844777,
            50.014408
          ],
          [
            14.127508,
            52.844923,
            49.632852
          ],
          [
            14.12724,
            52.845042,
            49.257084
          ],
          [
            14.127052,
            52.845198,
            49.541531
          ],
          [
            14.126964,
            52.845421,
            50.036712
          ],
          [
            14.127088,
            52.845456,
            50.607824
          ],
          [
            14.127406,
            52.845597,
            51.138828
          ],
          [
            14.127727,
            52.84554,
            51.573745
          ],
          [
            14.128037,
            52.845497,
            51.987265
          ],
          [
            14.128353,
            52.845432,
            52.420838
          ],
          [
            14.12854,
            52.845618,
            52.890005
          ],
          [
            14.128697,
            52.845774,
            53.213406
          ],
          [
            14.128925,
            52.845961,
            53.556901
          ],
          [
            14.129197,
            52.84607,
            53.848844
          ],
          [
            14.12946,
            52.846186,
            54.140342
          ],
          [
            14.129769,
            52.846275,
            54.44659
          ],
          [
            14.130094,
            52.846348,
            54.75949
          ],
          [
            14.130408,
            52.846476,
            55.098011
          ],
          [
            14.13071,
            52.846571,
            55.402249
          ],
          [
            14.131038,
            52.846688,
            55.662149
          ],
          [
            14.131364,
            52.84682,
            54.681588
          ],
          [
            14.131679,
            52.846918,
            53.796775
          ],
          [
            14.131961,
            52.846997,
            53.020493
          ],
          [
            14.132308,
            52.847101,
            52.051266
          ],
          [
            14.132624,
            52.847202,
            51.157815
          ],
          [
            14.132946,
            52.847288,
            50.278652
          ],
          [
            14.133291,
            52.847393,
            49.312962
          ],
          [
            14.133624,
            52.847509,
            48.352477
          ],
          [
            14.134013,
            52.847619,
            48.052543
          ],
          [
            14.134386,
            52.847732,
            47.811902
          ],
          [
            14.134729,
            52.847843,
            47.587401
          ],
          [
            14.135113,
            52.847946,
            47.345106
          ],
          [
            14.135464,
            52.848044,
            47.122094
          ],
          [
            14.135817,
            52.84816,
            46.890075
          ],
          [
            14.136121,
            52.848294,
            46.672124
          ],
          [
            14.136483,
            52.84843,
            46.536363
          ],
          [
            14.136822,
            52.848544,
            46.487005
          ],
          [
            14.137125,
            52.84864,
            46.443579
          ],
          [
            14.13679,
            52.848554,
            46.396651
          ],
          [
            14.136614,
            52.848731,
            46.353163
          ],
          [
            14.136479,
            52.848921,
            46.309707
          ],
          [
            14.136381,
            52.849099,
            46.27006
          ],
          [
            14.13624,
            52.849278,
            46.228404
          ],
          [
            14.136288,
            52.84928,
            46.202656
          ],
          [
            14.136441,
            52.849099,
            46.353426
          ],
          [
            14.136584,
            52.848901,
            46.513686
          ],
          [
            14.136709,
            52.848699,
            46.673597
          ],
          [
            14.137035,
            52.848639,
            46.875481
          ],
          [
            14.137361,
            52.848725,
            47.035067
          ],
          [
            14.137664,
            52.848803,
            47.182787
          ],
          [
            14.137975,
            52.848892,
            47.336899
          ],
          [
            14.138245,
            52.84899,
            47.477974
          ],
          [
            14.13849,
            52.849102,
            47.56386
          ],
          [
            14.138806,
            52.849176,
            47.630536
          ],
          [
            14.139115,
            52.849258,
            47.697022
          ],
          [
            14.139398,
            52.849354,
            47.76165
          ],
          [
            14.139686,
            52.849437,
            47.824435
          ],
          [
            14.139949,
            52.849532,
            47.884821
          ],
          [
            14.140231,
            52.849619,
            47.947229
          ],
          [
            14.140502,
            52.849733,
            48.012198
          ],
          [
            14.140825,
            52.84985,
            48.086368
          ],
          [
            14.14107,
            52.849972,
            47.952656
          ],
          [
            14.140865,
            52.850168,
            47.683893
          ],
          [
            14.140836,
            52.850337,
            47.46871
          ],
          [
            14.140917,
            52.850194,
            47.232505
          ],
          [
            14.141013,
            52.850013,
            47.011812
          ],
          [
            14.141007,
            52.84984,
            46.787963
          ],
          [
            14.140684,
            52.849757,
            46.542156
          ],
          [
            14.140362,
            52.849662,
            46.291211
          ],
          [
            14.140075,
            52.84958,
            46.068674
          ],
          [
            14.139793,
            52.849479,
            46.187585
          ],
          [
            14.139509,
            52.849382,
            46.389029
          ],
          [
            14.139226,
            52.849276,
            46.595254
          ],
          [
            14.138932,
            52.849178,
            46.807623
          ],
          [
            14.138613,
            52.849108,
            47.017424
          ],
          [
            14.138313,
            52.849014,
            47.227147
          ],
          [
            14.138006,
            52.8489,
            47.449675
          ],
          [
            14.137702,
            52.848805,
            47.66101
          ],
          [
            14.13738,
            52.848713,
            47.865895
          ],
          [
            14.137081,
            52.848596,
            47.901562
          ],
          [
            14.136768,
            52.848499,
            47.936751
          ],
          [
            14.13644,
            52.848397,
            47.973647
          ],
          [
            14.136136,
            52.848295,
            48.008439
          ],
          [
            14.135856,
            52.848178,
            48.042522
          ],
          [
            14.135571,
            52.84809,
            48.074572
          ],
          [
            14.135294,
            52.848002,
            48.10588
          ],
          [
            14.134983,
            52.847897,
            48.141528
          ],
          [
            14.134664,
            52.847813,
            48.149261
          ],
          [
            14.134396,
            52.847724,
            48.126473
          ],
          [
            14.134092,
            52.847624,
            48.100693
          ],
          [
            14.133816,
            52.847545,
            48.077959
          ],
          [
            14.133476,
            52.847435,
            48.049059
          ],
          [
            14.133211,
            52.84734,
            48.026112
          ],
          [
            14.132906,
            52.847236,
            48.000028
          ],
          [
            14.132573,
            52.84714,
            47.972531
          ],
          [
            14.132266,
            52.847064,
            47.947831
          ],
          [
            14.132521,
            52.846921,
            47.544526
          ],
          [
            14.132622,
            52.84673,
            47.013156
          ],
          [
            14.132773,
            52.84657,
            46.527294
          ],
          [
            14.132938,
            52.846396,
            45.997777
          ],
          [
            14.133096,
            52.846227,
            45.482947
          ],
          [
            14.13329,
            52.846068,
            44.959413
          ],
          [
            14.133424,
            52.845898,
            44.461839
          ],
          [
            14.133582,
            52.845709,
            43.903404
          ],
          [
            14.133759,
            52.845538,
            43.371535
          ],
          [
            14.133948,
            52.845377,
            43.953412
          ],
          [
            14.134115,
            52.845201,
            45.131693
          ],
          [
            14.134293,
            52.845031,
            46.300109
          ],
          [
            14.134483,
            52.844872,
            47.441625
          ],
          [
            14.134637,
            52.844676,
            48.700686
          ],
          [
            14.134809,
            52.844523,
            49.773951
          ],
          [
            14.134712,
            52.844374,
            50.964636
          ],
          [
            14.134422,
            52.844278,
            52.124206
          ],
          [
            14.134099,
            52.844225,
            53.328616
          ],
          [
            14.133881,
            52.844092,
            53.922944
          ],
          [
            14.133585,
            52.844017,
            54.329154
          ],
          [
            14.13326,
            52.843921,
            54.787755
          ],
          [
            14.132936,
            52.843821,
            55.248182
          ],
          [
            14.132618,
            52.843718,
            55.70476
          ],
          [
            14.132294,
            52.843608,
            56.175314
          ],
          [
            14.131963,
            52.843499,
            56.653067
          ],
          [
            14.131575,
            52.843388,
            57.196353
          ],
          [
            14.131237,
            52.843284,
            57.293771
          ],
          [
            14.130922,
            52.843193,
            57.121271
          ],
          [
            14.13062,
            52.843101,
            56.953944
          ],
          [
            14.130329,
            52.843012,
            56.792979
          ],
          [
            14.129977,
            52.842925,
            56.605278
          ],
          [
            14.129606,
            52.842918,
            56.413227
          ],
          [
            14.129345,
            52.843051,
            56.244745
          ],
          [
            14.129416,
            52.843223,
            56.095197
          ],
          [
            14.129232,
            52.843424,
            55.854156
          ],
          [
            14.129014,
            52.843609,
            55.383298
          ],
          [
            14.128986,
            52.843838,
            54.909634
          ],
          [
            14.128808,
            52.844035,
            54.446977
          ],
          [
            14.12858,
            52.844193,
            54.014956
          ],
          [
            14.128814,
            52.844065,
            53.621851
          ],
          [
            14.128844,
            52.844142,
            53.203156
          ],
          [
            14.128555,
            52.844207,
            52.808662
          ],
          [
            14.12842,
            52.844395,
            52.383457
          ],
          [
            14.128196,
            52.844575,
            51.934332
          ],
          [
            14.127869,
            52.844539,
            51.515332
          ],
          [
            14.127657,
            52.844449,
            51.13855
          ],
          [
            14.127359,
            52.844528,
            50.748958
          ],
          [
            14.127083,
            52.844653,
            50.338455
          ],
          [
            14.12691,
            52.844827,
            49.942537
          ],
          [
            14.126796,
            52.844994,
            49.582999
          ],
          [
            14.126757,
            52.845194,
            49.18952
          ],
          [
            14.126535,
            52.845332,
            48.809022
          ],
          [
            14.126688,
            52.845419,
            48.759703
          ],
          [
            14.126818,
            52.845217,
            48.820243
          ],
          [
            14.127108,
            52.845135,
            48.873766
          ],
          [
            14.127359,
            52.845024,
            48.92572
          ],
          [
            14.12765,
            52.844912,
            48.983288
          ],
          [
            14.127911,
            52.844784,
            49.039383
          ],
          [
            14.128218,
            52.844636,
            49.105533
          ],
          [
            14.128377,
            52.844431,
            49.1681
          ],
          [
            14.128561,
            52.844233,
            49.248626
          ],
          [
            14.128745,
            52.844039,
            49.379417
          ],
          [
            14.128896,
            52.843862,
            49.495955
          ],
          [
            14.129003,
            52.843674,
            49.612916
          ],
          [
            14.128686,
            52.843571,
            49.741431
          ],
          [
            14.128657,
            52.843596,
            49.849274
          ],
          [
            14.128957,
            52.843705,
            49.973274
          ],
          [
            14.128884,
            52.843892,
            50.085596
          ],
          [
            14.128739,
            52.844087,
            50.215405
          ],
          [
            14.128582,
            52.844265,
            50.265878
          ],
          [
            14.128433,
            52.844432,
            50.265878
          ],
          [
            14.128242,
            52.844605,
            50.265878
          ],
          [
            14.127972,
            52.844738,
            50.265878
          ],
          [
            14.127683,
            52.844861,
            50.265878
          ],
          [
            14.127407,
            52.84496,
            50.265878
          ],
          [
            14.127114,
            52.845086,
            50.265878
          ],
          [
            14.12683,
            52.845181,
            50.265878
          ],
          [
            14.126778,
            52.845322,
            50.265878
          ],
          [
            14.126804,
            52.845334,
            50.265878
          ],
          [
            14.126805,
            52.845325,
            50.265878
          ],
          [
            14.126611,
            52.845403,
            50.265878
          ]
        ]
      }
    }
  ]
}

let day40: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.120276,
            52.84372,
            50.131187
          ],
          [
            14.120627,
            52.843601,
            50.131187
          ],
          [
            14.120947,
            52.843518,
            50.131187
          ],
          [
            14.121213,
            52.843402,
            50.131187
          ],
          [
            14.121157,
            52.843209,
            50.131187
          ],
          [
            14.121062,
            52.843033,
            50.409917
          ],
          [
            14.121023,
            52.842796,
            50.880689
          ],
          [
            14.120969,
            52.842562,
            51.347641
          ],
          [
            14.120927,
            52.84238,
            51.710883
          ],
          [
            14.120859,
            52.842145,
            52.182409
          ],
          [
            14.120761,
            52.841913,
            52.655663
          ],
          [
            14.120692,
            52.841731,
            53.024761
          ],
          [
            14.120605,
            52.841543,
            53.410559
          ],
          [
            14.120495,
            52.84136,
            53.647989
          ],
          [
            14.120399,
            52.841174,
            53.515021
          ],
          [
            14.120277,
            52.840994,
            53.382179
          ],
          [
            14.120113,
            52.840785,
            53.22385
          ],
          [
            14.119963,
            52.84057,
            53.06462
          ],
          [
            14.119833,
            52.840379,
            52.923572
          ],
          [
            14.119749,
            52.840169,
            52.776068
          ],
          [
            14.119646,
            52.839958,
            52.625958
          ],
          [
            14.119555,
            52.839756,
            52.483065
          ],
          [
            14.119435,
            52.839556,
            52.267231
          ],
          [
            14.119306,
            52.83936,
            52.038898
          ],
          [
            14.119164,
            52.839176,
            51.819191
          ],
          [
            14.119003,
            52.838971,
            51.573301
          ],
          [
            14.118857,
            52.838777,
            51.34256
          ],
          [
            14.118733,
            52.838582,
            51.115918
          ],
          [
            14.118594,
            52.83838,
            50.878247
          ],
          [
            14.118487,
            52.838192,
            50.663106
          ],
          [
            14.118376,
            52.837976,
            50.276031
          ],
          [
            14.118339,
            52.837741,
            49.63435
          ],
          [
            14.118336,
            52.837513,
            49.014622
          ],
          [
            14.118332,
            52.837265,
            48.340323
          ],
          [
            14.118336,
            52.837008,
            47.641756
          ],
          [
            14.118345,
            52.836788,
            47.043552
          ],
          [
            14.118329,
            52.836563,
            46.4301
          ],
          [
            14.118283,
            52.836346,
            45.832126
          ],
          [
            14.118511,
            52.836227,
            45.442253
          ],
          [
            14.118836,
            52.836187,
            45.131093
          ],
          [
            14.119211,
            52.836128,
            44.766688
          ],
          [
            14.119523,
            52.836081,
            44.458792
          ],
          [
            14.119867,
            52.836035,
            44.119964
          ],
          [
            14.120195,
            52.835966,
            43.794775
          ],
          [
            14.120563,
            52.835922,
            43.443164
          ],
          [
            14.120881,
            52.835881,
            43.13721
          ],
          [
            14.121246,
            52.835842,
            42.952994
          ],
          [
            14.121629,
            52.835822,
            43.854613
          ],
          [
            14.121967,
            52.835773,
            44.669939
          ],
          [
            14.122289,
            52.835713,
            45.467223
          ],
          [
            14.122333,
            52.835498,
            46.316485
          ],
          [
            14.122264,
            52.83527,
            47.21665
          ],
          [
            14.122253,
            52.835042,
            48.102188
          ],
          [
            14.122219,
            52.834797,
            49.057
          ],
          [
            14.122201,
            52.834611,
            49.780418
          ],
          [
            14.122191,
            52.834354,
            50.29185
          ],
          [
            14.122152,
            52.834166,
            50.654304
          ],
          [
            14.122117,
            52.833947,
            51.075434
          ],
          [
            14.122084,
            52.833684,
            51.579947
          ],
          [
            14.122058,
            52.833437,
            52.053452
          ],
          [
            14.12203,
            52.833223,
            52.46418
          ],
          [
            14.122007,
            52.833007,
            52.878215
          ],
          [
            14.122001,
            52.832775,
            53.275874
          ],
          [
            14.12198,
            52.832525,
            53.400826
          ],
          [
            14.121935,
            52.832305,
            53.51143
          ],
          [
            14.12194,
            52.832047,
            53.640315
          ],
          [
            14.121923,
            52.831852,
            53.737888
          ],
          [
            14.121897,
            52.831652,
            53.838139
          ],
          [
            14.1219,
            52.831441,
            53.94345
          ],
          [
            14.121926,
            52.831214,
            54.057014
          ],
          [
            14.121966,
            52.830981,
            54.059034
          ],
          [
            14.12199,
            52.830721,
            53.309145
          ],
          [
            14.122012,
            52.830537,
            52.777923
          ],
          [
            14.122087,
            52.830313,
            52.11961
          ],
          [
            14.122186,
            52.830083,
            51.434869
          ],
          [
            14.12227,
            52.82988,
            50.830186
          ],
          [
            14.122383,
            52.829693,
            50.256974
          ],
          [
            14.122487,
            52.8295,
            49.672388
          ],
          [
            14.122602,
            52.829311,
            49.092103
          ],
          [
            14.122734,
            52.82913,
            48.479208
          ],
          [
            14.122881,
            52.828963,
            47.882691
          ],
          [
            14.123059,
            52.828806,
            47.28192
          ],
          [
            14.123295,
            52.828584,
            46.449473
          ],
          [
            14.123548,
            52.828384,
            45.654481
          ],
          [
            14.123741,
            52.828201,
            44.970215
          ],
          [
            14.123952,
            52.828037,
            44.31507
          ],
          [
            14.124153,
            52.827879,
            43.686669
          ],
          [
            14.124371,
            52.827748,
            43.386328
          ],
          [
            14.124636,
            52.82761,
            43.642807
          ],
          [
            14.124885,
            52.827476,
            43.887313
          ],
          [
            14.125186,
            52.827331,
            44.170267
          ],
          [
            14.12546,
            52.827212,
            44.417981
          ],
          [
            14.125735,
            52.827089,
            44.668936
          ],
          [
            14.126029,
            52.82699,
            44.915582
          ],
          [
            14.126298,
            52.826887,
            45.148983
          ],
          [
            14.126617,
            52.826781,
            45.416633
          ],
          [
            14.126891,
            52.826686,
            45.432008
          ],
          [
            14.127202,
            52.826555,
            45.335147
          ],
          [
            14.127524,
            52.826446,
            45.240846
          ],
          [
            14.127789,
            52.826354,
            45.162544
          ],
          [
            14.128064,
            52.826262,
            45.082041
          ],
          [
            14.128424,
            52.826118,
            44.971464
          ],
          [
            14.128786,
            52.825991,
            44.864506
          ],
          [
            14.129102,
            52.825871,
            44.769144
          ],
          [
            14.129363,
            52.825768,
            44.88621
          ],
          [
            14.12962,
            52.825665,
            45.214585
          ],
          [
            14.129882,
            52.825553,
            45.556411
          ],
          [
            14.130163,
            52.825457,
            45.900021
          ],
          [
            14.130431,
            52.825362,
            46.230821
          ],
          [
            14.130695,
            52.82526,
            46.564522
          ],
          [
            14.131004,
            52.825136,
            46.960113
          ],
          [
            14.13127,
            52.825042,
            47.288184
          ],
          [
            14.131554,
            52.824949,
            47.632231
          ],
          [
            14.131801,
            52.824841,
            47.889496
          ],
          [
            14.132061,
            52.824739,
            47.85377
          ],
          [
            14.132367,
            52.824611,
            47.810907
          ],
          [
            14.132683,
            52.824493,
            47.768116
          ],
          [
            14.132994,
            52.82437,
            47.725309
          ],
          [
            14.13327,
            52.824272,
            47.688392
          ],
          [
            14.133542,
            52.824174,
            47.651921
          ],
          [
            14.133812,
            52.824075,
            47.615548
          ],
          [
            14.134095,
            52.823981,
            47.578272
          ],
          [
            14.134369,
            52.823883,
            47.427481
          ],
          [
            14.134675,
            52.823801,
            47.01385
          ],
          [
            14.134968,
            52.82372,
            46.615609
          ],
          [
            14.135262,
            52.823633,
            46.211327
          ],
          [
            14.13562,
            52.823555,
            45.741112
          ],
          [
            14.135933,
            52.823489,
            45.331784
          ],
          [
            14.136244,
            52.823442,
            44.935931
          ],
          [
            14.136675,
            52.823381,
            44.389156
          ],
          [
            14.137032,
            52.823345,
            43.941556
          ],
          [
            14.13733,
            52.823304,
            43.939061
          ],
          [
            14.137756,
            52.823267,
            44.042473
          ],
          [
            14.138051,
            52.823237,
            44.114343
          ],
          [
            14.138476,
            52.823199,
            44.217271
          ],
          [
            14.138842,
            52.82316,
            44.306289
          ],
          [
            14.139264,
            52.823119,
            44.40867
          ],
          [
            14.139639,
            52.82309,
            44.499269
          ],
          [
            14.139988,
            52.82305,
            44.584538
          ],
          [
            14.140418,
            52.823016,
            44.940569
          ],
          [
            14.140782,
            52.822991,
            45.255387
          ],
          [
            14.141207,
            52.822952,
            45.624769
          ],
          [
            14.141514,
            52.822933,
            45.889953
          ],
          [
            14.141934,
            52.822903,
            46.253365
          ],
          [
            14.142229,
            52.822875,
            46.51021
          ],
          [
            14.142632,
            52.822839,
            46.860265
          ],
          [
            14.143032,
            52.822813,
            47.134903
          ],
          [
            14.143422,
            52.822774,
            47.053923
          ],
          [
            14.143807,
            52.822729,
            46.973529
          ],
          [
            14.144187,
            52.822688,
            46.894419
          ],
          [
            14.144557,
            52.822654,
            46.817734
          ],
          [
            14.144889,
            52.822622,
            46.748847
          ],
          [
            14.145251,
            52.822578,
            46.673173
          ],
          [
            14.145659,
            52.822546,
            46.58883
          ],
          [
            14.146042,
            52.822509,
            46.508419
          ],
          [
            14.146402,
            52.822476,
            46.431535
          ],
          [
            14.146773,
            52.822445,
            46.352501
          ],
          [
            14.147158,
            52.822406,
            46.270127
          ],
          [
            14.147527,
            52.822362,
            46.190755
          ],
          [
            14.147883,
            52.822321,
            46.114265
          ],
          [
            14.148247,
            52.822285,
            46.036359
          ],
          [
            14.148612,
            52.822248,
            45.958263
          ],
          [
            14.148986,
            52.822216,
            45.949613
          ],
          [
            14.149379,
            52.822171,
            46.051267
          ],
          [
            14.149755,
            52.822132,
            46.148206
          ],
          [
            14.150141,
            52.822102,
            46.247167
          ],
          [
            14.150512,
            52.822074,
            46.342231
          ],
          [
            14.150879,
            52.822054,
            46.4359
          ],
          [
            14.151209,
            52.822014,
            46.521693
          ],
          [
            14.151559,
            52.821982,
            46.611667
          ],
          [
            14.151896,
            52.821941,
            46.739316
          ],
          [
            14.152267,
            52.821903,
            46.955444
          ],
          [
            14.152659,
            52.821867,
            47.182552
          ],
          [
            14.153077,
            52.821838,
            47.423518
          ],
          [
            14.153456,
            52.821806,
            47.642748
          ],
          [
            14.153871,
            52.821763,
            47.883933
          ],
          [
            14.15428,
            52.821723,
            48.121179
          ],
          [
            14.154685,
            52.821685,
            48.355909
          ],
          [
            14.155068,
            52.821639,
            48.700213
          ],
          [
            14.155444,
            52.821617,
            49.041426
          ],
          [
            14.155811,
            52.821587,
            49.37594
          ],
          [
            14.156158,
            52.821559,
            49.692153
          ],
          [
            14.156495,
            52.821532,
            49.999277
          ],
          [
            14.156848,
            52.821497,
            50.322495
          ],
          [
            14.157188,
            52.821451,
            50.637206
          ],
          [
            14.157519,
            52.821425,
            50.938845
          ],
          [
            14.157907,
            52.821393,
            50.566647
          ],
          [
            14.158269,
            52.821351,
            49.863197
          ],
          [
            14.158663,
            52.821315,
            49.102822
          ],
          [
            14.159087,
            52.821271,
            48.281965
          ],
          [
            14.159489,
            52.821239,
            47.508298
          ],
          [
            14.159834,
            52.821191,
            46.832806
          ],
          [
            14.160229,
            52.821154,
            46.070126
          ],
          [
            14.160627,
            52.821119,
            45.378124
          ],
          [
            14.161001,
            52.821099,
            45.3527
          ],
          [
            14.16136,
            52.821064,
            45.328036
          ],
          [
            14.161677,
            52.821038,
            45.306369
          ],
          [
            14.162047,
            52.821004,
            45.28103
          ],
          [
            14.162377,
            52.820979,
            45.258514
          ],
          [
            14.162759,
            52.820944,
            45.232277
          ],
          [
            14.163104,
            52.820898,
            45.208325
          ],
          [
            14.163481,
            52.820847,
            45.182171
          ],
          [
            14.163873,
            52.82082,
            45.374048
          ],
          [
            14.164241,
            52.820794,
            45.578012
          ],
          [
            14.164663,
            52.820762,
            45.812122
          ],
          [
            14.165024,
            52.820718,
            46.014732
          ],
          [
            14.165336,
            52.820668,
            46.192311
          ],
          [
            14.165613,
            52.820577,
            46.365847
          ],
          [
            14.165875,
            52.820474,
            46.537792
          ],
          [
            14.166185,
            52.820401,
            46.720754
          ],
          [
            14.166492,
            52.820341,
            46.9743
          ],
          [
            14.166828,
            52.820322,
            47.332015
          ],
          [
            14.167154,
            52.820337,
            47.678649
          ],
          [
            14.167519,
            52.820377,
            48.072288
          ],
          [
            14.167896,
            52.820403,
            48.475582
          ],
          [
            14.168299,
            52.820406,
            48.902781
          ],
          [
            14.168662,
            52.820391,
            49.288407
          ],
          [
            14.16907,
            52.820338,
            49.73089
          ],
          [
            14.169439,
            52.820305,
            49.889155
          ],
          [
            14.169873,
            52.820265,
            49.648559
          ],
          [
            14.170291,
            52.820225,
            49.416468
          ],
          [
            14.170643,
            52.820179,
            49.218956
          ],
          [
            14.171,
            52.820145,
            49.020861
          ],
          [
            14.171307,
            52.820121,
            48.851153
          ],
          [
            14.171675,
            52.820091,
            48.647489
          ],
          [
            14.172035,
            52.820042,
            48.444926
          ],
          [
            14.172411,
            52.820014,
            48.224901
          ],
          [
            14.172719,
            52.819988,
            48.032072
          ],
          [
            14.173034,
            52.819961,
            47.836146
          ],
          [
            14.173336,
            52.819922,
            47.646378
          ],
          [
            14.173656,
            52.819905,
            47.449017
          ],
          [
            14.174008,
            52.819866,
            47.229138
          ],
          [
            14.174356,
            52.819823,
            47.010734
          ],
          [
            14.174686,
            52.819798,
            46.8062
          ],
          [
            14.175016,
            52.819766,
            46.600653
          ],
          [
            14.175334,
            52.819742,
            46.460568
          ],
          [
            14.175648,
            52.819716,
            46.369299
          ],
          [
            14.176076,
            52.819676,
            46.244717
          ],
          [
            14.176384,
            52.819649,
            46.155181
          ],
          [
            14.176694,
            52.819615,
            46.064544
          ],
          [
            14.177064,
            52.819589,
            45.957383
          ],
          [
            14.17744,
            52.81956,
            45.848195
          ],
          [
            14.177811,
            52.819533,
            45.740679
          ],
          [
            14.17811,
            52.819501,
            45.652771
          ],
          [
            14.178476,
            52.819465,
            45.495258
          ],
          [
            14.178826,
            52.819423,
            45.34338
          ],
          [
            14.179238,
            52.819377,
            45.16592
          ],
          [
            14.179664,
            52.819339,
            44.983555
          ],
          [
            14.180011,
            52.819299,
            44.833794
          ],
          [
            14.180417,
            52.819268,
            44.660377
          ],
          [
            14.18085,
            52.819228,
            44.474859
          ],
          [
            14.18115,
            52.819206,
            44.420934
          ],
          [
            14.181578,
            52.81917,
            44.525209
          ],
          [
            14.181986,
            52.81912,
            44.625504
          ],
          [
            14.182336,
            52.819087,
            44.710845
          ],
          [
            14.182694,
            52.819047,
            44.798556
          ],
          [
            14.183059,
            52.818999,
            44.888557
          ],
          [
            14.183359,
            52.818976,
            44.961414
          ],
          [
            14.183736,
            52.818953,
            45.052881
          ],
          [
            14.184058,
            52.818926,
            45.150438
          ],
          [
            14.184417,
            52.818912,
            45.318886
          ],
          [
            14.184716,
            52.818891,
            45.459933
          ],
          [
            14.185091,
            52.818849,
            45.639001
          ],
          [
            14.185445,
            52.818793,
            45.8103
          ],
          [
            14.185796,
            52.818743,
            45.979426
          ],
          [
            14.186158,
            52.81871,
            46.150832
          ],
          [
            14.186586,
            52.81867,
            46.353474
          ],
          [
            14.186941,
            52.818635,
            46.4698
          ],
          [
            14.187242,
            52.81861,
            46.240016
          ],
          [
            14.187542,
            52.818581,
            46.010409
          ],
          [
            14.187951,
            52.818547,
            45.698374
          ],
          [
            14.188337,
            52.818509,
            45.402465
          ],
          [
            14.188724,
            52.818471,
            45.106146
          ],
          [
            14.189102,
            52.818435,
            44.816948
          ],
          [
            14.18949,
            52.818397,
            44.519879
          ],
          [
            14.189897,
            52.818361,
            44.234678
          ],
          [
            14.19029,
            52.818322,
            44.11067
          ],
          [
            14.190586,
            52.818292,
            44.017168
          ],
          [
            14.19095,
            52.818269,
            43.903056
          ],
          [
            14.191317,
            52.818222,
            43.786294
          ],
          [
            14.191677,
            52.818189,
            43.67284
          ],
          [
            14.192047,
            52.818149,
            43.55578
          ],
          [
            14.192441,
            52.818114,
            43.431818
          ],
          [
            14.19284,
            52.818069,
            43.330705
          ],
          [
            14.193243,
            52.818026,
            43.35727
          ],
          [
            14.19365,
            52.817973,
            43.384314
          ],
          [
            14.194051,
            52.81794,
            43.410558
          ],
          [
            14.194472,
            52.817912,
            43.43803
          ],
          [
            14.194869,
            52.81787,
            43.464159
          ],
          [
            14.195261,
            52.81785,
            43.489666
          ],
          [
            14.195661,
            52.817816,
            43.515855
          ],
          [
            14.196081,
            52.817776,
            44.300008
          ],
          [
            14.196433,
            52.81775,
            45.044163
          ],
          [
            14.196814,
            52.817722,
            45.850364
          ],
          [
            14.197215,
            52.817678,
            46.705658
          ],
          [
            14.197622,
            52.817645,
            47.567222
          ],
          [
            14.198043,
            52.81761,
            48.458665
          ],
          [
            14.198404,
            52.817572,
            49.228204
          ],
          [
            14.198774,
            52.817527,
            49.602842
          ],
          [
            14.199143,
            52.817493,
            49.123149
          ],
          [
            14.199523,
            52.817489,
            48.636537
          ],
          [
            14.199822,
            52.817465,
            48.250262
          ],
          [
            14.200189,
            52.817425,
            47.772585
          ],
          [
            14.200606,
            52.817358,
            47.219827
          ],
          [
            14.201015,
            52.817323,
            46.690966
          ],
          [
            14.201397,
            52.81727,
            46.188855
          ],
          [
            14.201766,
            52.817241,
            46.20116
          ],
          [
            14.202125,
            52.817206,
            46.686847
          ],
          [
            14.202507,
            52.817171,
            47.202746
          ],
          [
            14.202899,
            52.81713,
            47.733945
          ],
          [
            14.203295,
            52.817095,
            48.268364
          ],
          [
            14.203679,
            52.817057,
            48.789127
          ],
          [
            14.204062,
            52.817024,
            49.305708
          ],
          [
            14.204454,
            52.816989,
            49.834938
          ],
          [
            14.204847,
            52.816952,
            49.986565
          ],
          [
            14.20523,
            52.816912,
            50.058469
          ],
          [
            14.205626,
            52.816885,
            50.132221
          ],
          [
            14.206008,
            52.816857,
            50.203424
          ],
          [
            14.206329,
            52.816841,
            50.262992
          ],
          [
            14.206671,
            52.816815,
            50.326951
          ],
          [
            14.207003,
            52.816781,
            50.389229
          ],
          [
            14.207359,
            52.816743,
            50.456093
          ],
          [
            14.207732,
            52.816694,
            50.09405
          ],
          [
            14.208082,
            52.816656,
            49.598723
          ],
          [
            14.208407,
            52.816628,
            49.14189
          ],
          [
            14.20876,
            52.816568,
            48.631993
          ],
          [
            14.209132,
            52.816535,
            48.109146
          ],
          [
            14.209509,
            52.816499,
            47.578497
          ],
          [
            14.209905,
            52.816455,
            47.018581
          ],
          [
            14.210286,
            52.816399,
            46.473437
          ],
          [
            14.210644,
            52.816331,
            46.137936
          ],
          [
            14.211017,
            52.816281,
            45.862733
          ],
          [
            14.211394,
            52.816224,
            45.582713
          ],
          [
            14.211765,
            52.816173,
            45.30859
          ],
          [
            14.212138,
            52.816095,
            45.024278
          ],
          [
            14.212535,
            52.816,
            44.71645
          ],
          [
            14.212913,
            52.815904,
            44.420813
          ],
          [
            14.213277,
            52.81581,
            44.332927
          ],
          [
            14.213627,
            52.815716,
            44.97938
          ],
          [
            14.213974,
            52.815633,
            45.608964
          ],
          [
            14.214291,
            52.815529,
            46.217862
          ],
          [
            14.214604,
            52.815435,
            46.808106
          ],
          [
            14.214925,
            52.815335,
            47.417507
          ],
          [
            14.215276,
            52.815222,
            48.08859
          ],
          [
            14.215609,
            52.8151,
            48.745535
          ],
          [
            14.215926,
            52.81497,
            49.371792
          ],
          [
            14.216241,
            52.814821,
            49.964692
          ],
          [
            14.216564,
            52.814732,
            50.490706
          ],
          [
            14.216896,
            52.814606,
            51.071221
          ],
          [
            14.217242,
            52.814478,
            51.671897
          ],
          [
            14.217576,
            52.814344,
            52.265495
          ],
          [
            14.217916,
            52.814214,
            52.861261
          ],
          [
            14.218208,
            52.814041,
            53.469905
          ],
          [
            14.218513,
            52.813872,
            52.95816
          ],
          [
            14.218798,
            52.813673,
            52.029477
          ],
          [
            14.219077,
            52.813487,
            51.141846
          ],
          [
            14.219355,
            52.813289,
            50.226034
          ],
          [
            14.219564,
            52.813127,
            49.501015
          ],
          [
            14.219761,
            52.812952,
            48.751624
          ],
          [
            14.219927,
            52.812764,
            47.999654
          ],
          [
            14.220161,
            52.812627,
            47.304859
          ],
          [
            14.220412,
            52.812504,
            47.136384
          ],
          [
            14.220659,
            52.812391,
            46.994651
          ],
          [
            14.220923,
            52.812274,
            46.845638
          ],
          [
            14.221172,
            52.812161,
            46.703904
          ],
          [
            14.22137,
            52.812022,
            46.565644
          ],
          [
            14.221583,
            52.811859,
            46.408193
          ],
          [
            14.22174,
            52.811664,
            46.244393
          ],
          [
            14.221902,
            52.811474,
            46.083383
          ],
          [
            14.222029,
            52.811283,
            45.928181
          ],
          [
            14.222207,
            52.811124,
            45.86648
          ],
          [
            14.222401,
            52.810961,
            45.804439
          ],
          [
            14.222567,
            52.810785,
            45.741552
          ],
          [
            14.222732,
            52.81062,
            45.681975
          ],
          [
            14.222894,
            52.810458,
            45.623385
          ],
          [
            14.223089,
            52.81028,
            45.55726
          ],
          [
            14.223268,
            52.810122,
            45.498112
          ],
          [
            14.223445,
            52.809941,
            45.433166
          ],
          [
            14.223598,
            52.809768,
            45.372402
          ],
          [
            14.223755,
            52.809601,
            45.268371
          ],
          [
            14.223918,
            52.809436,
            45.161624
          ],
          [
            14.224102,
            52.80925,
            45.041269
          ],
          [
            14.224291,
            52.809059,
            44.91768
          ],
          [
            14.224492,
            52.80884,
            44.778595
          ],
          [
            14.22468,
            52.808648,
            44.654616
          ],
          [
            14.224893,
            52.808449,
            44.523
          ],
          [
            14.225108,
            52.80825,
            44.391005
          ],
          [
            14.225307,
            52.808038,
            44.520508
          ],
          [
            14.225485,
            52.807846,
            44.681698
          ],
          [
            14.225658,
            52.80765,
            44.844283
          ],
          [
            14.225838,
            52.807453,
            45.008983
          ],
          [
            14.226037,
            52.807268,
            45.170476
          ],
          [
            14.226229,
            52.807078,
            45.334437
          ],
          [
            14.226402,
            52.806891,
            45.49124
          ],
          [
            14.226563,
            52.80673,
            45.628917
          ],
          [
            14.22674,
            52.806532,
            45.615804
          ],
          [
            14.226928,
            52.806334,
            45.506522
          ],
          [
            14.227119,
            52.80613,
            45.393935
          ],
          [
            14.227289,
            52.805884,
            45.265911
          ],
          [
            14.22746,
            52.805644,
            45.140821
          ],
          [
            14.227613,
            52.80548,
            45.050569
          ],
          [
            14.22785,
            52.805255,
            44.922744
          ],
          [
            14.228061,
            52.805074,
            44.815604
          ],
          [
            14.228271,
            52.804856,
            44.679
          ],
          [
            14.228486,
            52.804639,
            44.542013
          ],
          [
            14.228674,
            52.804451,
            44.423035
          ],
          [
            14.228853,
            52.804261,
            44.304634
          ],
          [
            14.229033,
            52.804072,
            44.186532
          ],
          [
            14.229204,
            52.803887,
            44.071471
          ],
          [
            14.229422,
            52.803667,
            43.932574
          ],
          [
            14.229608,
            52.80352,
            43.847022
          ],
          [
            14.22986,
            52.803317,
            43.816332
          ],
          [
            14.230066,
            52.803144,
            43.790548
          ],
          [
            14.230265,
            52.802933,
            43.761177
          ],
          [
            14.230462,
            52.802722,
            43.731873
          ],
          [
            14.230639,
            52.802527,
            43.704977
          ],
          [
            14.230789,
            52.802364,
            43.682419
          ],
          [
            14.230957,
            52.802202,
            43.659148
          ],
          [
            14.231116,
            52.802022,
            43.634471
          ],
          [
            14.231307,
            52.801846,
            43.530683
          ],
          [
            14.231497,
            52.801659,
            43.420103
          ],
          [
            14.231668,
            52.801466,
            43.309804
          ],
          [
            14.231826,
            52.801261,
            43.195873
          ],
          [
            14.232004,
            52.80104,
            43.072024
          ],
          [
            14.232199,
            52.800829,
            42.950253
          ],
          [
            14.232365,
            52.800663,
            42.852466
          ],
          [
            14.232582,
            52.800474,
            42.736515
          ],
          [
            14.232758,
            52.800298,
            42.699811
          ],
          [
            14.232951,
            52.800089,
            42.66433
          ],
          [
            14.233111,
            52.799925,
            42.636102
          ],
          [
            14.23327,
            52.799756,
            42.607302
          ],
          [
            14.233436,
            52.799594,
            42.579027
          ],
          [
            14.233613,
            52.799431,
            42.550035
          ],
          [
            14.233803,
            52.79922,
            42.514432
          ],
          [
            14.234005,
            52.798994,
            42.476281
          ],
          [
            14.234242,
            52.798806,
            42.771121
          ],
          [
            14.234431,
            52.798614,
            43.283433
          ],
          [
            14.234593,
            52.798429,
            43.763349
          ],
          [
            14.234795,
            52.798245,
            44.269791
          ],
          [
            14.234993,
            52.798044,
            44.806308
          ],
          [
            14.235216,
            52.797851,
            45.346416
          ],
          [
            14.23542,
            52.797678,
            45.833587
          ],
          [
            14.235639,
            52.797517,
            46.313627
          ],
          [
            14.23585,
            52.79737,
            46.527489
          ],
          [
            14.236061,
            52.797209,
            46.373413
          ],
          [
            14.236271,
            52.79706,
            46.222368
          ],
          [
            14.236491,
            52.796891,
            46.061079
          ],
          [
            14.236736,
            52.796723,
            45.893056
          ],
          [
            14.236973,
            52.796578,
            45.740172
          ],
          [
            14.237198,
            52.796448,
            45.599049
          ],
          [
            14.23745,
            52.796285,
            45.431676
          ],
          [
            14.237702,
            52.796126,
            45.266491
          ],
          [
            14.237924,
            52.79599,
            44.922699
          ],
          [
            14.238176,
            52.795859,
            44.504212
          ],
          [
            14.238406,
            52.795726,
            44.103604
          ],
          [
            14.23863,
            52.795599,
            43.716275
          ],
          [
            14.238868,
            52.795461,
            43.301088
          ],
          [
            14.239098,
            52.79534,
            42.91715
          ],
          [
            14.239392,
            52.795188,
            42.429902
          ],
          [
            14.239642,
            52.795051,
            42.005183
          ],
          [
            14.2399,
            52.794904,
            41.558941
          ],
          [
            14.240149,
            52.794763,
            41.47572
          ],
          [
            14.240426,
            52.794612,
            41.455098
          ],
          [
            14.240706,
            52.794453,
            41.43387
          ],
          [
            14.241015,
            52.794283,
            41.410727
          ],
          [
            14.241294,
            52.794128,
            41.38978
          ],
          [
            14.241589,
            52.79397,
            41.368002
          ],
          [
            14.241862,
            52.793811,
            41.347057
          ],
          [
            14.242138,
            52.793657,
            41.32927
          ],
          [
            14.242416,
            52.793492,
            41.374669
          ],
          [
            14.24267,
            52.793352,
            41.414709
          ],
          [
            14.242936,
            52.793203,
            41.456927
          ],
          [
            14.243209,
            52.793043,
            41.501198
          ],
          [
            14.24348,
            52.792883,
            41.545304
          ],
          [
            14.243754,
            52.792716,
            41.590601
          ],
          [
            14.244026,
            52.792562,
            41.633988
          ],
          [
            14.244298,
            52.792414,
            41.668337
          ],
          [
            14.244597,
            52.79225,
            41.586319
          ],
          [
            14.244911,
            52.792068,
            41.497985
          ],
          [
            14.245185,
            52.791911,
            41.421327
          ],
          [
            14.245443,
            52.79176,
            41.34841
          ],
          [
            14.245729,
            52.791601,
            41.269265
          ],
          [
            14.246034,
            52.791435,
            41.185922
          ],
          [
            14.246352,
            52.791274,
            41.101632
          ],
          [
            14.246689,
            52.791113,
            41.173604
          ],
          [
            14.247017,
            52.790946,
            41.337746
          ],
          [
            14.247302,
            52.790803,
            41.479183
          ],
          [
            14.247591,
            52.790678,
            41.614865
          ],
          [
            14.247903,
            52.790533,
            41.765124
          ],
          [
            14.248196,
            52.790377,
            41.914202
          ],
          [
            14.248493,
            52.79023,
            42.060815
          ],
          [
            14.248772,
            52.790083,
            42.20212
          ],
          [
            14.249036,
            52.789922,
            42.622368
          ],
          [
            14.249294,
            52.789762,
            43.04322
          ],
          [
            14.249564,
            52.789603,
            43.471821
          ],
          [
            14.249863,
            52.78946,
            43.90573
          ],
          [
            14.250127,
            52.789329,
            44.29451
          ],
          [
            14.250374,
            52.789194,
            44.673024
          ],
          [
            14.250605,
            52.789046,
            45.057126
          ],
          [
            14.250894,
            52.788967,
            45.43349
          ],
          [
            14.25108,
            52.788804,
            45.681591
          ],
          [
            14.251279,
            52.788653,
            45.83571
          ],
          [
            14.251507,
            52.788526,
            45.985411
          ],
          [
            14.251749,
            52.78837,
            46.15618
          ],
          [
            14.252049,
            52.788277,
            46.320834
          ],
          [
            14.252327,
            52.78817,
            46.480263
          ],
          [
            14.252575,
            52.78801,
            46.655428
          ],
          [
            14.252835,
            52.787853,
            46.833191
          ],
          [
            14.253124,
            52.787703,
            47.017006
          ],
          [
            14.253401,
            52.787558,
            46.975465
          ],
          [
            14.253657,
            52.787405,
            46.928547
          ],
          [
            14.25393,
            52.787255,
            46.880472
          ],
          [
            14.2542,
            52.787112,
            46.833668
          ],
          [
            14.254456,
            52.786956,
            46.786273
          ],
          [
            14.254731,
            52.786816,
            46.739423
          ],
          [
            14.255014,
            52.786671,
            46.691058
          ],
          [
            14.255261,
            52.786519,
            46.645119
          ],
          [
            14.25552,
            52.786382,
            46.81212
          ],
          [
            14.255763,
            52.786243,
            47.038809
          ],
          [
            14.256007,
            52.786098,
            47.270722
          ],
          [
            14.256256,
            52.78597,
            47.492256
          ],
          [
            14.256501,
            52.785837,
            47.715608
          ],
          [
            14.256759,
            52.785698,
            47.949878
          ],
          [
            14.256996,
            52.785553,
            48.178944
          ],
          [
            14.257245,
            52.785411,
            48.410909
          ],
          [
            14.257502,
            52.785265,
            48.649907
          ],
          [
            14.257738,
            52.785121,
            48.850532
          ],
          [
            14.257996,
            52.784978,
            49.05994
          ],
          [
            14.258259,
            52.784849,
            49.26257
          ],
          [
            14.258515,
            52.784699,
            49.476002
          ],
          [
            14.258784,
            52.784563,
            49.685915
          ],
          [
            14.259035,
            52.784413,
            49.897027
          ],
          [
            14.259288,
            52.784263,
            50.108992
          ],
          [
            14.25955,
            52.784108,
            50.328388
          ],
          [
            14.259818,
            52.783944,
            50.363475
          ],
          [
            14.260075,
            52.783799,
            50.254841
          ],
          [
            14.260361,
            52.783641,
            50.13512
          ],
          [
            14.260651,
            52.783481,
            50.013755
          ],
          [
            14.260898,
            52.783327,
            49.904106
          ],
          [
            14.261171,
            52.783181,
            49.791472
          ],
          [
            14.261353,
            52.783008,
            49.686681
          ],
          [
            14.261597,
            52.782875,
            49.585152
          ],
          [
            14.261867,
            52.782757,
            49.433554
          ],
          [
            14.262094,
            52.782619,
            49.160257
          ],
          [
            14.262336,
            52.782479,
            48.876348
          ],
          [
            14.262587,
            52.782327,
            48.575377
          ],
          [
            14.262828,
            52.782186,
            48.291245
          ],
          [
            14.263109,
            52.782025,
            47.963377
          ],
          [
            14.263346,
            52.781899,
            47.696073
          ],
          [
            14.263568,
            52.781774,
            47.439071
          ],
          [
            14.263787,
            52.781636,
            47.17098
          ],
          [
            14.264042,
            52.78149,
            46.935108
          ],
          [
            14.264322,
            52.781329,
            46.778929
          ],
          [
            14.264626,
            52.781162,
            46.612993
          ],
          [
            14.264916,
            52.780989,
            46.448421
          ],
          [
            14.265221,
            52.780819,
            46.280767
          ],
          [
            14.2655,
            52.780657,
            46.124511
          ],
          [
            14.265774,
            52.780508,
            45.975476
          ],
          [
            14.266058,
            52.780351,
            45.819844
          ],
          [
            14.266316,
            52.780201,
            45.60322
          ],
          [
            14.266559,
            52.78006,
            45.381826
          ],
          [
            14.266816,
            52.779918,
            45.152753
          ],
          [
            14.267085,
            52.779769,
            44.912948
          ],
          [
            14.267359,
            52.77961,
            44.66333
          ],
          [
            14.267597,
            52.779456,
            44.43419
          ],
          [
            14.267848,
            52.779315,
            44.209024
          ],
          [
            14.268111,
            52.77916,
            43.967649
          ],
          [
            14.268384,
            52.779013,
            44.007368
          ],
          [
            14.268665,
            52.778854,
            44.411222
          ],
          [
            14.268959,
            52.778691,
            44.829724
          ],
          [
            14.269259,
            52.778516,
            45.267092
          ],
          [
            14.26956,
            52.778357,
            45.686425
          ],
          [
            14.269853,
            52.778198,
            46.099449
          ],
          [
            14.270144,
            52.778046,
            46.502887
          ],
          [
            14.270425,
            52.777887,
            46.906625
          ],
          [
            14.270723,
            52.777731,
            47.198333
          ],
          [
            14.271004,
            52.777581,
            47.460303
          ],
          [
            14.271251,
            52.777433,
            47.703278
          ],
          [
            14.271521,
            52.777287,
            47.956567
          ],
          [
            14.27182,
            52.777119,
            48.241871
          ],
          [
            14.272118,
            52.776952,
            48.525817
          ],
          [
            14.272399,
            52.776793,
            48.794941
          ],
          [
            14.272688,
            52.776628,
            49.056119
          ],
          [
            14.27299,
            52.776466,
            49.219774
          ],
          [
            14.273252,
            52.776291,
            49.378162
          ],
          [
            14.273544,
            52.776127,
            49.539648
          ],
          [
            14.273841,
            52.775955,
            49.706348
          ],
          [
            14.274153,
            52.775782,
            49.877891
          ],
          [
            14.274452,
            52.775629,
            50.036757
          ],
          [
            14.274738,
            52.775461,
            50.198318
          ],
          [
            14.275018,
            52.775299,
            50.064503
          ],
          [
            14.275294,
            52.775148,
            49.84089
          ],
          [
            14.275592,
            52.774984,
            49.598894
          ],
          [
            14.275913,
            52.774821,
            49.34709
          ],
          [
            14.276215,
            52.774653,
            49.100594
          ],
          [
            14.27647,
            52.774495,
            48.881234
          ],
          [
            14.276776,
            52.774322,
            48.629607
          ],
          [
            14.277053,
            52.774178,
            48.461913
          ],
          [
            14.277367,
            52.77401,
            48.519842
          ],
          [
            14.277692,
            52.773818,
            48.582624
          ],
          [
            14.277964,
            52.773667,
            48.63364
          ],
          [
            14.278249,
            52.773504,
            48.687862
          ],
          [
            14.278524,
            52.773357,
            48.738587
          ],
          [
            14.278819,
            52.773209,
            48.791565
          ],
          [
            14.279107,
            52.773036,
            48.847654
          ],
          [
            14.279403,
            52.772876,
            48.902688
          ],
          [
            14.279715,
            52.772704,
            48.961236
          ],
          [
            14.279999,
            52.772555,
            49.013387
          ],
          [
            14.280247,
            52.772409,
            49.061385
          ],
          [
            14.280476,
            52.772265,
            49.107208
          ],
          [
            14.280713,
            52.77213,
            49.152361
          ],
          [
            14.280974,
            52.771982,
            49.20198
          ],
          [
            14.281235,
            52.771824,
            49.253201
          ],
          [
            14.281502,
            52.77172,
            49.289236
          ],
          [
            14.281741,
            52.771567,
            49.3198
          ],
          [
            14.281945,
            52.771414,
            49.348384
          ],
          [
            14.282199,
            52.771267,
            49.379184
          ],
          [
            14.282477,
            52.771122,
            49.411347
          ],
          [
            14.282777,
            52.770961,
            49.446492
          ],
          [
            14.283067,
            52.770786,
            49.4824
          ],
          [
            14.283368,
            52.770619,
            49.518224
          ],
          [
            14.283684,
            52.770453,
            49.57035
          ],
          [
            14.283977,
            52.77029,
            49.633719
          ],
          [
            14.284269,
            52.770134,
            49.695737
          ],
          [
            14.284558,
            52.769977,
            49.757583
          ],
          [
            14.284826,
            52.769821,
            49.816885
          ],
          [
            14.285093,
            52.769672,
            49.874723
          ],
          [
            14.285373,
            52.769521,
            49.934459
          ],
          [
            14.285651,
            52.76936,
            49.995728
          ],
          [
            14.285954,
            52.769198,
            49.834733
          ],
          [
            14.286252,
            52.769029,
            49.611482
          ],
          [
            14.28656,
            52.768854,
            49.380529
          ],
          [
            14.286854,
            52.76867,
            49.149307
          ],
          [
            14.287151,
            52.768505,
            48.928769
          ],
          [
            14.287451,
            52.768333,
            48.702801
          ],
          [
            14.287763,
            52.76817,
            48.477474
          ],
          [
            14.288057,
            52.768014,
            48.290614
          ],
          [
            14.288342,
            52.767849,
            48.123111
          ],
          [
            14.288631,
            52.767695,
            47.959575
          ],
          [
            14.28893,
            52.767526,
            47.785763
          ],
          [
            14.289185,
            52.767355,
            47.624054
          ],
          [
            14.289434,
            52.767221,
            47.482462
          ],
          [
            14.289754,
            52.767097,
            47.321077
          ],
          [
            14.290063,
            52.766926,
            47.14325
          ],
          [
            14.290332,
            52.766788,
            47.231483
          ],
          [
            14.290568,
            52.766653,
            47.348829
          ],
          [
            14.290793,
            52.766518,
            47.46332
          ],
          [
            14.29103,
            52.76637,
            47.586384
          ],
          [
            14.291246,
            52.766214,
            47.707917
          ],
          [
            14.291488,
            52.766055,
            47.836994
          ],
          [
            14.29172,
            52.765885,
            47.968717
          ],
          [
            14.291985,
            52.765736,
            48.0997
          ],
          [
            14.292287,
            52.765584,
            48.173014
          ],
          [
            14.29258,
            52.765451,
            48.105948
          ],
          [
            14.292808,
            52.765325,
            48.049497
          ],
          [
            14.293078,
            52.765186,
            47.984647
          ],
          [
            14.29334,
            52.765033,
            47.918092
          ],
          [
            14.293634,
            52.764862,
            47.843553
          ],
          [
            14.29391,
            52.764699,
            47.773056
          ],
          [
            14.294219,
            52.764527,
            47.696312
          ],
          [
            14.294481,
            52.764377,
            47.646409
          ],
          [
            14.29479,
            52.764202,
            47.624504
          ],
          [
            14.295029,
            52.764082,
            47.60843
          ],
          [
            14.295264,
            52.763939,
            47.591167
          ],
          [
            14.295534,
            52.763773,
            47.571234
          ],
          [
            14.295841,
            52.763614,
            47.55032
          ],
          [
            14.296113,
            52.763458,
            47.530911
          ],
          [
            14.296372,
            52.763312,
            47.512589
          ],
          [
            14.296606,
            52.763174,
            47.511056
          ],
          [
            14.296835,
            52.763044,
            47.571593
          ],
          [
            14.297052,
            52.762912,
            47.630915
          ],
          [
            14.297277,
            52.762777,
            47.692015
          ],
          [
            14.297515,
            52.762652,
            47.752773
          ],
          [
            14.297754,
            52.762531,
            47.812906
          ],
          [
            14.298028,
            52.762382,
            47.883932
          ],
          [
            14.298318,
            52.762221,
            47.959834
          ],
          [
            14.298587,
            52.762062,
            48.032332
          ],
          [
            14.298874,
            52.761915,
            48.100006
          ],
          [
            14.299134,
            52.761762,
            48.15965
          ],
          [
            14.299393,
            52.761603,
            48.220308
          ],
          [
            14.299697,
            52.761448,
            48.285669
          ],
          [
            14.299972,
            52.761272,
            48.35147
          ],
          [
            14.300247,
            52.761115,
            48.413623
          ],
          [
            14.300526,
            52.760954,
            48.477046
          ],
          [
            14.30085,
            52.760781,
            48.548085
          ],
          [
            14.301151,
            52.760627,
            48.566438
          ],
          [
            14.301407,
            52.760493,
            48.572649
          ],
          [
            14.301632,
            52.760362,
            48.578383
          ],
          [
            14.30189,
            52.760216,
            48.584869
          ],
          [
            14.30217,
            52.760064,
            48.591775
          ],
          [
            14.302426,
            52.759923,
            48.59813
          ],
          [
            14.302663,
            52.759792,
            48.60402
          ],
          [
            14.302913,
            52.759675,
            48.609821
          ],
          [
            14.303152,
            52.75955,
            48.62416
          ],
          [
            14.303386,
            52.759416,
            48.735772
          ],
          [
            14.303619,
            52.7593,
            48.840339
          ],
          [
            14.303843,
            52.759167,
            48.949059
          ],
          [
            14.304101,
            52.759024,
            49.07036
          ],
          [
            14.30433,
            52.758902,
            49.176251
          ],
          [
            14.304584,
            52.758788,
            49.286071
          ],
          [
            14.304843,
            52.758668,
            49.399112
          ],
          [
            14.305125,
            52.758561,
            49.514446
          ],
          [
            14.305388,
            52.758446,
            49.626921
          ],
          [
            14.305684,
            52.758328,
            49.508006
          ],
          [
            14.306,
            52.758211,
            49.340609
          ],
          [
            14.30632,
            52.758077,
            49.164692
          ],
          [
            14.306634,
            52.757938,
            48.98871
          ],
          [
            14.306944,
            52.757801,
            48.815237
          ],
          [
            14.307267,
            52.757668,
            48.638619
          ],
          [
            14.307588,
            52.757525,
            48.458501
          ],
          [
            14.307914,
            52.757391,
            48.342367
          ],
          [
            14.308235,
            52.75727,
            48.665465
          ],
          [
            14.308514,
            52.757135,
            48.970739
          ],
          [
            14.308794,
            52.75702,
            49.26037
          ],
          [
            14.309115,
            52.756877,
            49.60085
          ],
          [
            14.309395,
            52.75676,
            49.8916
          ],
          [
            14.309706,
            52.756632,
            50.212918
          ],
          [
            14.309975,
            52.756519,
            50.492645
          ],
          [
            14.310285,
            52.756407,
            50.804229
          ],
          [
            14.310674,
            52.756325,
            50.709107
          ],
          [
            14.31106,
            52.756232,
            50.561496
          ],
          [
            14.311428,
            52.756146,
            50.421318
          ],
          [
            14.311727,
            52.75607,
            50.306055
          ],
          [
            14.312006,
            52.755997,
            50.198062
          ],
          [
            14.312303,
            52.755931,
            50.085652
          ],
          [
            14.312623,
            52.755851,
            49.96264
          ],
          [
            14.312934,
            52.755773,
            49.843009
          ],
          [
            14.313257,
            52.755684,
            49.773881
          ],
          [
            14.31362,
            52.755595,
            49.7519
          ],
          [
            14.313988,
            52.7555,
            49.729449
          ],
          [
            14.314324,
            52.75542,
            49.709181
          ],
          [
            14.314737,
            52.755326,
            49.684417
          ],
          [
            14.315097,
            52.75525,
            49.663007
          ],
          [
            14.315457,
            52.755158,
            49.641068
          ],
          [
            14.315827,
            52.755065,
            49.618586
          ],
          [
            14.316208,
            52.75498,
            49.566921
          ],
          [
            14.316495,
            52.75492,
            49.52751
          ],
          [
            14.316833,
            52.754843,
            49.48067
          ],
          [
            14.317214,
            52.754741,
            49.426565
          ],
          [
            14.317607,
            52.754648,
            49.371851
          ],
          [
            14.317942,
            52.754561,
            49.324577
          ],
          [
            14.318307,
            52.754471,
            49.273465
          ],
          [
            14.318637,
            52.754386,
            49.23395
          ],
          [
            14.318968,
            52.754316,
            49.24606
          ],
          [
            14.319371,
            52.754223,
            49.260953
          ],
          [
            14.319748,
            52.75413,
            49.275018
          ],
          [
            14.320069,
            52.754041,
            49.287213
          ],
          [
            14.320451,
            52.753947,
            49.301463
          ],
          [
            14.320825,
            52.75387,
            49.315109
          ],
          [
            14.321206,
            52.753778,
            49.32929
          ],
          [
            14.32153,
            52.753686,
            49.338227
          ],
          [
            14.321931,
            52.753599,
            49.345242
          ],
          [
            14.322267,
            52.753512,
            49.351259
          ],
          [
            14.322604,
            52.753449,
            49.357073
          ],
          [
            14.322908,
            52.75338,
            49.362422
          ],
          [
            14.323284,
            52.753289,
            49.369095
          ],
          [
            14.323647,
            52.753203,
            49.375515
          ],
          [
            14.324021,
            52.753112,
            49.382154
          ],
          [
            14.324396,
            52.75302,
            49.367147
          ],
          [
            14.324768,
            52.752928,
            49.343875
          ],
          [
            14.325144,
            52.752842,
            49.320597
          ],
          [
            14.32551,
            52.752747,
            49.297536
          ],
          [
            14.325874,
            52.752663,
            49.274978
          ],
          [
            14.326243,
            52.752567,
            49.25172
          ],
          [
            14.326633,
            52.752463,
            49.227036
          ],
          [
            14.326998,
            52.752379,
            49.207979
          ],
          [
            14.327341,
            52.752301,
            49.196791
          ],
          [
            14.327729,
            52.752214,
            49.184153
          ],
          [
            14.328014,
            52.75214,
            49.174683
          ],
          [
            14.328357,
            52.752061,
            49.163478
          ],
          [
            14.32871,
            52.751989,
            49.152104
          ],
          [
            14.329081,
            52.751889,
            49.139705
          ],
          [
            14.329444,
            52.751789,
            49.127491
          ],
          [
            14.329821,
            52.751707,
            49.162584
          ],
          [
            14.330155,
            52.751632,
            49.238003
          ],
          [
            14.330481,
            52.751564,
            49.311008
          ],
          [
            14.330789,
            52.751486,
            49.381701
          ],
          [
            14.331115,
            52.751406,
            49.456172
          ],
          [
            14.331418,
            52.751327,
            49.526041
          ],
          [
            14.331708,
            52.75126,
            49.591759
          ],
          [
            14.331995,
            52.751197,
            49.656403
          ],
          [
            14.332313,
            52.751125,
            49.728287
          ],
          [
            14.33262,
            52.751048,
            49.929526
          ],
          [
            14.332969,
            52.750964,
            50.224429
          ],
          [
            14.333268,
            52.750896,
            50.475318
          ],
          [
            14.333601,
            52.75081,
            50.759558
          ],
          [
            14.333952,
            52.750738,
            51.050535
          ],
          [
            14.334239,
            52.75067,
            51.292509
          ],
          [
            14.334522,
            52.750599,
            51.533167
          ],
          [
            14.334843,
            52.750527,
            51.801925
          ],
          [
            14.335155,
            52.750443,
            52.07025
          ],
          [
            14.335437,
            52.750372,
            52.060099
          ],
          [
            14.335761,
            52.7503,
            52.032567
          ],
          [
            14.336046,
            52.750214,
            52.007151
          ],
          [
            14.336356,
            52.750136,
            51.980371
          ],
          [
            14.336708,
            52.750047,
            51.949941
          ],
          [
            14.33704,
            52.749955,
            51.920814
          ],
          [
            14.337371,
            52.749858,
            51.891411
          ],
          [
            14.337683,
            52.749756,
            51.863124
          ],
          [
            14.338009,
            52.749653,
            51.614121
          ],
          [
            14.338347,
            52.749543,
            51.038778
          ],
          [
            14.338696,
            52.74942,
            50.43332
          ],
          [
            14.339034,
            52.749308,
            49.855661
          ],
          [
            14.339265,
            52.749115,
            49.26436
          ],
          [
            14.339599,
            52.748982,
            48.663194
          ],
          [
            14.339882,
            52.748857,
            48.137892
          ],
          [
            14.340151,
            52.748752,
            47.657658
          ],
          [
            14.340452,
            52.748616,
            47.386352
          ],
          [
            14.34071,
            52.748499,
            47.377906
          ],
          [
            14.341005,
            52.748382,
            47.368698
          ],
          [
            14.341301,
            52.748247,
            47.359026
          ],
          [
            14.34164,
            52.748075,
            47.347483
          ],
          [
            14.341975,
            52.747927,
            47.336663
          ],
          [
            14.342304,
            52.747759,
            47.325427
          ],
          [
            14.342568,
            52.747604,
            47.315832
          ],
          [
            14.342859,
            52.747434,
            47.486295
          ],
          [
            14.343173,
            52.74726,
            47.705488
          ],
          [
            14.343467,
            52.747081,
            47.92022
          ],
          [
            14.343729,
            52.74691,
            48.11891
          ],
          [
            14.344022,
            52.746731,
            48.33345
          ],
          [
            14.344291,
            52.746554,
            48.538031
          ],
          [
            14.34455,
            52.746358,
            48.751702
          ],
          [
            14.344816,
            52.746203,
            48.865041
          ],
          [
            14.345025,
            52.746062,
            48.899783
          ],
          [
            14.345231,
            52.745917,
            48.934896
          ],
          [
            14.345421,
            52.745775,
            48.968405
          ],
          [
            14.345651,
            52.745594,
            49.01029
          ],
          [
            14.345856,
            52.745427,
            49.048445
          ],
          [
            14.346081,
            52.745284,
            49.085369
          ],
          [
            14.346192,
            52.745104,
            49.122461
          ],
          [
            14.346448,
            52.744947,
            49.162987
          ],
          [
            14.346697,
            52.744765,
            49.224463
          ],
          [
            14.346926,
            52.744554,
            49.296669
          ],
          [
            14.347086,
            52.744357,
            49.359958
          ],
          [
            14.347268,
            52.744128,
            49.432649
          ],
          [
            14.347454,
            52.743939,
            49.495507
          ],
          [
            14.347621,
            52.743725,
            49.563073
          ],
          [
            14.347805,
            52.743514,
            49.63128
          ],
          [
            14.347983,
            52.743319,
            49.642272
          ],
          [
            14.348179,
            52.743102,
            49.235028
          ],
          [
            14.348357,
            52.742889,
            48.841184
          ],
          [
            14.348513,
            52.742686,
            48.472471
          ],
          [
            14.348672,
            52.742482,
            48.101073
          ],
          [
            14.348814,
            52.742275,
            47.732417
          ],
          [
            14.348971,
            52.742071,
            47.362242
          ],
          [
            14.34914,
            52.741864,
            46.982357
          ],
          [
            14.349306,
            52.741665,
            46.752878
          ],
          [
            14.349463,
            52.741467,
            46.828944
          ],
          [
            14.349647,
            52.741267,
            46.908236
          ],
          [
            14.349792,
            52.741088,
            46.977365
          ],
          [
            14.349937,
            52.74089,
            47.052382
          ],
          [
            14.350076,
            52.740704,
            47.123273
          ],
          [
            14.350195,
            52.740515,
            47.19374
          ],
          [
            14.350342,
            52.740318,
            47.268692
          ],
          [
            14.35057,
            52.740113,
            47.350602
          ],
          [
            14.350762,
            52.739913,
            47.311321
          ],
          [
            14.350948,
            52.739717,
            47.272865
          ],
          [
            14.351102,
            52.739514,
            47.234883
          ],
          [
            14.351255,
            52.739308,
            47.196469
          ],
          [
            14.351435,
            52.73909,
            47.154948
          ],
          [
            14.351599,
            52.738896,
            47.117942
          ],
          [
            14.35178,
            52.73869,
            47.078275
          ],
          [
            14.351939,
            52.738494,
            47.01683
          ],
          [
            14.352126,
            52.738282,
            46.787489
          ],
          [
            14.352272,
            52.738083,
            46.57971
          ],
          [
            14.352421,
            52.737918,
            46.400224
          ],
          [
            14.352574,
            52.737731,
            46.200477
          ],
          [
            14.352773,
            52.7375,
            45.951768
          ],
          [
            14.352939,
            52.737305,
            45.742437
          ],
          [
            14.353109,
            52.737108,
            45.530337
          ],
          [
            14.353301,
            52.736886,
            45.347612
          ],
          [
            14.353446,
            52.736682,
            45.442609
          ],
          [
            14.353626,
            52.736457,
            45.549545
          ],
          [
            14.353826,
            52.736218,
            45.664763
          ],
          [
            14.353975,
            52.736012,
            45.761154
          ],
          [
            14.354166,
            52.735806,
            45.86308
          ],
          [
            14.354345,
            52.735588,
            45.967225
          ],
          [
            14.35451,
            52.73538,
            46.066105
          ],
          [
            14.35469,
            52.735156,
            46.297577
          ],
          [
            14.354833,
            52.734989,
            46.514213
          ],
          [
            14.354965,
            52.734812,
            46.737562
          ],
          [
            14.355111,
            52.734639,
            46.961289
          ],
          [
            14.355251,
            52.734424,
            47.228033
          ],
          [
            14.355413,
            52.734249,
            47.459043
          ],
          [
            14.355581,
            52.734087,
            47.678934
          ],
          [
            14.355737,
            52.733927,
            47.892547
          ],
          [
            14.355889,
            52.733765,
            48.107128
          ],
          [
            14.356057,
            52.733573,
            48.0154
          ],
          [
            14.356222,
            52.733412,
            47.842167
          ],
          [
            14.356381,
            52.733244,
            47.665038
          ],
          [
            14.356541,
            52.733013,
            47.43605
          ],
          [
            14.356854,
            52.732891,
            47.22923
          ],
          [
            14.35724,
            52.732808,
            47.002477
          ],
          [
            14.357642,
            52.732754,
            46.774559
          ],
          [
            14.35805,
            52.732665,
            46.534508
          ],
          [
            14.358341,
            52.732605,
            46.488474
          ],
          [
            14.358649,
            52.732531,
            46.448547
          ],
          [
            14.358941,
            52.732481,
            46.412004
          ],
          [
            14.359294,
            52.732421,
            46.36785
          ],
          [
            14.359721,
            52.732349,
            46.314382
          ],
          [
            14.360063,
            52.732301,
            46.272101
          ],
          [
            14.360388,
            52.73223,
            46.230487
          ],
          [
            14.360687,
            52.732176,
            46.192844
          ],
          [
            14.360995,
            52.732115,
            46.08017
          ],
          [
            14.361306,
            52.732052,
            45.787279
          ],
          [
            14.361627,
            52.732008,
            45.493701
          ],
          [
            14.361942,
            52.731929,
            45.189572
          ],
          [
            14.362268,
            52.731867,
            44.884258
          ],
          [
            14.362563,
            52.731799,
            44.601737
          ],
          [
            14.362912,
            52.731737,
            44.277341
          ],
          [
            14.363242,
            52.731681,
            43.971682
          ],
          [
            14.363536,
            52.731613,
            43.690674
          ],
          [
            14.363866,
            52.731552,
            43.586076
          ],
          [
            14.36424,
            52.731483,
            43.768622
          ],
          [
            14.364576,
            52.731416,
            43.934492
          ],
          [
            14.364929,
            52.731355,
            44.105822
          ],
          [
            14.365267,
            52.731276,
            44.274858
          ],
          [
            14.365611,
            52.73122,
            44.441055
          ],
          [
            14.365959,
            52.731152,
            44.611693
          ],
          [
            14.366287,
            52.731078,
            44.775004
          ],
          [
            14.366594,
            52.730999,
            44.906197
          ],
          [
            14.366889,
            52.73093,
            44.927677
          ],
          [
            14.367205,
            52.730874,
            44.950074
          ],
          [
            14.367557,
            52.730831,
            44.974553
          ],
          [
            14.367893,
            52.730761,
            44.99873
          ],
          [
            14.368197,
            52.730699,
            45.020695
          ],
          [
            14.368523,
            52.730634,
            45.044003
          ],
          [
            14.368847,
            52.730536,
            45.068981
          ],
          [
            14.369151,
            52.730238,
            45.106496
          ],
          [
            14.369329,
            52.730061,
            45.120632
          ],
          [
            14.369517,
            52.72988,
            45.135209
          ],
          [
            14.369754,
            52.729692,
            45.15134
          ],
          [
            14.370042,
            52.729494,
            45.16933
          ],
          [
            14.37027,
            52.729331,
            45.183917
          ],
          [
            14.37055,
            52.729155,
            45.200579
          ],
          [
            14.370799,
            52.728996,
            45.215559
          ],
          [
            14.371031,
            52.728841,
            45.231818
          ],
          [
            14.371288,
            52.728667,
            45.256907
          ],
          [
            14.371503,
            52.728492,
            45.28034
          ],
          [
            14.371729,
            52.7283,
            45.305692
          ],
          [
            14.371948,
            52.7281,
            45.331467
          ],
          [
            14.372161,
            52.727902,
            45.356848
          ],
          [
            14.372399,
            52.727682,
            45.385119
          ],
          [
            14.372641,
            52.727488,
            45.411231
          ],
          [
            14.372899,
            52.727341,
            45.464276
          ],
          [
            14.373181,
            52.727239,
            45.528455
          ],
          [
            14.373464,
            52.72714,
            45.59215
          ],
          [
            14.373737,
            52.727012,
            45.659711
          ],
          [
            14.373957,
            52.726852,
            45.726722
          ],
          [
            14.374175,
            52.726679,
            45.796709
          ],
          [
            14.374359,
            52.726503,
            45.863741
          ],
          [
            14.374532,
            52.726326,
            45.929902
          ],
          [
            14.374696,
            52.726155,
            45.993527
          ],
          [
            14.374835,
            52.725985,
            45.756231
          ],
          [
            14.375033,
            52.725749,
            45.392592
          ],
          [
            14.375218,
            52.725508,
            45.027696
          ],
          [
            14.375352,
            52.725302,
            44.723476
          ],
          [
            14.375493,
            52.725048,
            44.35559
          ],
          [
            14.375646,
            52.724833,
            44.032859
          ],
          [
            14.37576,
            52.72466,
            43.776973
          ],
          [
            14.375881,
            52.724451,
            43.400113
          ],
          [
            14.375965,
            52.724276,
            42.827487
          ],
          [
            14.376066,
            52.724103,
            42.250804
          ],
          [
            14.376137,
            52.723921,
            41.658713
          ],
          [
            14.376204,
            52.723725,
            41.027356
          ],
          [
            14.376266,
            52.723528,
            40.396192
          ],
          [
            14.376353,
            52.723339,
            39.779221
          ],
          [
            14.37643,
            52.723101,
            39.016832
          ],
          [
            14.376493,
            52.72289,
            38.341469
          ],
          [
            14.376597,
            52.72268,
            38.085145
          ],
          [
            14.376691,
            52.722449,
            38.754775
          ],
          [
            14.376806,
            52.722231,
            39.398132
          ],
          [
            14.376955,
            52.722016,
            40.053588
          ],
          [
            14.377104,
            52.721806,
            40.696282
          ],
          [
            14.37725,
            52.721597,
            41.334532
          ],
          [
            14.377407,
            52.721389,
            41.977463
          ],
          [
            14.377507,
            52.721189,
            42.565159
          ],
          [
            14.377626,
            52.720973,
            43.004053
          ],
          [
            14.377694,
            52.720765,
            43.152949
          ],
          [
            14.377755,
            52.720555,
            43.302873
          ],
          [
            14.377839,
            52.720343,
            43.455795
          ],
          [
            14.377919,
            52.720144,
            43.599597
          ],
          [
            14.378069,
            52.719943,
            43.754293
          ],
          [
            14.378187,
            52.719738,
            43.906583
          ],
          [
            14.378337,
            52.71954,
            44.059791
          ],
          [
            14.378512,
            52.719354,
            44.202453
          ],
          [
            14.378693,
            52.719165,
            44.256652
          ],
          [
            14.378935,
            52.719006,
            44.310393
          ],
          [
            14.379217,
            52.718873,
            44.363983
          ],
          [
            14.379474,
            52.718732,
            44.415975
          ],
          [
            14.37974,
            52.718588,
            44.469457
          ],
          [
            14.380008,
            52.718427,
            44.526212
          ],
          [
            14.380206,
            52.718228,
            44.583758
          ],
          [
            14.380397,
            52.718031,
            44.640327
          ],
          [
            14.380612,
            52.717865,
            44.641857
          ],
          [
            14.380883,
            52.717696,
            44.639876
          ],
          [
            14.38121,
            52.717557,
            44.637834
          ],
          [
            14.381542,
            52.717445,
            44.635897
          ],
          [
            14.38186,
            52.717295,
            44.633829
          ],
          [
            14.382081,
            52.7171,
            44.63184
          ],
          [
            14.38237,
            52.71694,
            44.629831
          ],
          [
            14.382751,
            52.71688,
            44.607043
          ],
          [
            14.383123,
            52.716877,
            44.537718
          ],
          [
            14.383512,
            52.716874,
            44.465378
          ],
          [
            14.383863,
            52.716787,
            44.394875
          ],
          [
            14.384192,
            52.716691,
            44.326885
          ],
          [
            14.3845,
            52.716588,
            44.261453
          ],
          [
            14.384786,
            52.716431,
            44.188567
          ],
          [
            14.385035,
            52.716248,
            44.11581
          ],
          [
            14.385291,
            52.716079,
            44.118196
          ],
          [
            14.385519,
            52.715894,
            44.212201
          ],
          [
            14.385712,
            52.71569,
            44.308023
          ],
          [
            14.385911,
            52.715504,
            44.398378
          ],
          [
            14.386089,
            52.715318,
            44.486255
          ],
          [
            14.38624,
            52.715135,
            44.569598
          ],
          [
            14.386328,
            52.714938,
            44.652942
          ],
          [
            14.386397,
            52.714742,
            44.734547
          ],
          [
            14.386475,
            52.714545,
            44.835604
          ],
          [
            14.386533,
            52.714339,
            45.115176
          ],
          [
            14.386583,
            52.71414,
            45.384496
          ],
          [
            14.386596,
            52.713943,
            45.649426
          ],
          [
            14.386585,
            52.713739,
            45.922787
          ],
          [
            14.386601,
            52.713517,
            46.220939
          ],
          [
            14.38663,
            52.713312,
            46.496353
          ],
          [
            14.386795,
            52.713119,
            46.788499
          ],
          [
            14.387037,
            52.712962,
            47.075874
          ],
          [
            14.387328,
            52.712854,
            47.212395
          ],
          [
            14.38769,
            52.712765,
            47.20579
          ],
          [
            14.388032,
            52.712715,
            47.199844
          ],
          [
            14.388392,
            52.71268,
            47.193659
          ],
          [
            14.388753,
            52.712723,
            47.187439
          ],
          [
            14.389099,
            52.712795,
            47.18126
          ],
          [
            14.38944,
            52.712873,
            47.175101
          ],
          [
            14.389826,
            52.71292,
            47.168438
          ],
          [
            14.390209,
            52.712918,
            47.229952
          ],
          [
            14.390596,
            52.712892,
            47.364501
          ],
          [
            14.390835,
            52.712713,
            47.49651
          ],
          [
            14.391145,
            52.712563,
            47.633806
          ],
          [
            14.391493,
            52.712513,
            47.757665
          ],
          [
            14.391855,
            52.71252,
            47.883214
          ],
          [
            14.392201,
            52.712616,
            48.014305
          ],
          [
            14.392586,
            52.712584,
            48.149798
          ],
          [
            14.392922,
            52.712458,
            48.065659
          ],
          [
            14.393133,
            52.71225,
            47.894793
          ],
          [
            14.393168,
            52.712002,
            47.721051
          ],
          [
            14.393187,
            52.711747,
            47.543005
          ],
          [
            14.393207,
            52.711484,
            47.35944
          ],
          [
            14.39322,
            52.71123,
            47.182256
          ],
          [
            14.393162,
            52.710983,
            47.008303
          ],
          [
            14.393084,
            52.710742,
            47.041128
          ],
          [
            14.393173,
            52.71051,
            47.226822
          ],
          [
            14.393385,
            52.710335,
            47.394948
          ],
          [
            14.393646,
            52.710178,
            47.567473
          ],
          [
            14.393859,
            52.709986,
            47.74658
          ],
          [
            14.394114,
            52.709798,
            47.934986
          ],
          [
            14.394389,
            52.709609,
            48.130207
          ],
          [
            14.394682,
            52.70943,
            48.325916
          ],
          [
            14.394982,
            52.70927,
            48.214105
          ],
          [
            14.395265,
            52.709124,
            48.109174
          ],
          [
            14.395563,
            52.708997,
            48.006696
          ],
          [
            14.395879,
            52.708906,
            47.908011
          ],
          [
            14.396198,
            52.708817,
            47.80916
          ],
          [
            14.396532,
            52.708735,
            47.70776
          ],
          [
            14.396862,
            52.708656,
            47.607897
          ],
          [
            14.397181,
            52.708568,
            47.509282
          ],
          [
            14.397496,
            52.708493,
            47.303917
          ],
          [
            14.397807,
            52.708396,
            47.064987
          ],
          [
            14.398107,
            52.708336,
            46.849061
          ],
          [
            14.398445,
            52.708265,
            46.604977
          ],
          [
            14.398759,
            52.708213,
            46.382618
          ],
          [
            14.399113,
            52.708152,
            46.13152
          ],
          [
            14.399459,
            52.708088,
            45.884623
          ],
          [
            14.399793,
            52.708023,
            45.645335
          ],
          [
            14.400151,
            52.707955,
            45.544418
          ],
          [
            14.400484,
            52.707879,
            45.790263
          ],
          [
            14.400814,
            52.707801,
            46.035287
          ],
          [
            14.40117,
            52.707727,
            46.295375
          ],
          [
            14.401515,
            52.707698,
            46.536435
          ],
          [
            14.401838,
            52.707615,
            46.783168
          ],
          [
            14.402164,
            52.707547,
            47.021443
          ],
          [
            14.402498,
            52.707498,
            47.25919
          ],
          [
            14.402816,
            52.707425,
            47.494394
          ],
          [
            14.403172,
            52.707365,
            47.873055
          ],
          [
            14.403506,
            52.70732,
            48.235119
          ],
          [
            14.403873,
            52.707308,
            48.63089
          ],
          [
            14.404227,
            52.707332,
            49.007482
          ],
          [
            14.404494,
            52.707214,
            49.373047
          ],
          [
            14.404665,
            52.707065,
            49.689086
          ],
          [
            14.404895,
            52.706906,
            50.057277
          ],
          [
            14.405116,
            52.706758,
            50.404844
          ],
          [
            14.405361,
            52.706608,
            50.581902
          ],
          [
            14.405606,
            52.706457,
            50.37896
          ],
          [
            14.405862,
            52.706302,
            50.168637
          ],
          [
            14.406152,
            52.706194,
            49.970803
          ],
          [
            14.406425,
            52.706066,
            49.770356
          ],
          [
            14.406728,
            52.705934,
            49.553505
          ],
          [
            14.407006,
            52.705786,
            49.33862
          ],
          [
            14.407235,
            52.705618,
            49.129807
          ],
          [
            14.407388,
            52.705421,
            48.932163
          ],
          [
            14.407546,
            52.70522,
            49.207868
          ],
          [
            14.40773,
            52.705001,
            49.5123
          ],
          [
            14.407896,
            52.70481,
            49.779982
          ],
          [
            14.408078,
            52.704583,
            50.093778
          ],
          [
            14.408223,
            52.704379,
            50.369271
          ],
          [
            14.408347,
            52.704169,
            50.645493
          ],
          [
            14.408456,
            52.703952,
            50.92653
          ],
          [
            14.408583,
            52.703783,
            51.147824
          ],
          [
            14.40874,
            52.703558,
            50.765464
          ],
          [
            14.408906,
            52.703406,
            50.480357
          ],
          [
            14.409117,
            52.70318,
            50.07423
          ],
          [
            14.409268,
            52.703015,
            49.779131
          ],
          [
            14.409453,
            52.702784,
            49.377491
          ],
          [
            14.409593,
            52.702539,
            48.971827
          ],
          [
            14.409743,
            52.702334,
            48.620329
          ],
          [
            14.409917,
            52.702128,
            48.328189
          ],
          [
            14.410037,
            52.701962,
            48.289236
          ],
          [
            14.410228,
            52.701731,
            48.233708
          ],
          [
            14.410455,
            52.701521,
            48.179753
          ],
          [
            14.410626,
            52.701351,
            48.13695
          ],
          [
            14.410802,
            52.701156,
            48.088652
          ],
          [
            14.410922,
            52.700978,
            48.047329
          ],
          [
            14.410828,
            52.700786,
            48.003717
          ],
          [
            14.410798,
            52.700598,
            47.961669
          ],
          [
            14.411152,
            52.700671,
            48.210977
          ],
          [
            14.411098,
            52.700681,
            48.466472
          ],
          [
            14.411215,
            52.700747,
            48.725289
          ],
          [
            14.410966,
            52.700759,
            48.979998
          ],
          [
            14.410891,
            52.700737,
            49.252751
          ],
          [
            14.411209,
            52.700714,
            49.52117
          ],
          [
            14.410853,
            52.700716,
            49.821082
          ],
          [
            14.411149,
            52.700692,
            50.080666
          ],
          [
            14.411099,
            52.700665,
            50.339328
          ],
          [
            14.41108,
            52.700682,
            50.196598
          ],
          [
            14.411179,
            52.700865,
            49.855339
          ],
          [
            14.411228,
            52.701007,
            49.507803
          ],
          [
            14.411045,
            52.700971,
            49.221039
          ],
          [
            14.411208,
            52.701147,
            48.863884
          ],
          [
            14.411129,
            52.700885,
            48.395825
          ],
          [
            14.411166,
            52.700696,
            48.055296
          ],
          [
            14.41091,
            52.700593,
            47.725005
          ],
          [
            14.411029,
            52.700444,
            47.37935
          ],
          [
            14.411322,
            52.700335,
            47.413755
          ],
          [
            14.411609,
            52.700265,
            47.578522
          ],
          [
            14.411923,
            52.700134,
            47.782161
          ],
          [
            14.41214,
            52.699973,
            47.964902
          ],
          [
            14.412317,
            52.699795,
            48.147557
          ],
          [
            14.412388,
            52.699583,
            48.341218
          ],
          [
            14.412369,
            52.699375,
            48.525584
          ],
          [
            14.412439,
            52.699143,
            48.732983
          ],
          [
            14.412461,
            52.698922,
            49.032048
          ],
          [
            14.412585,
            52.698726,
            49.504156
          ],
          [
            14.412654,
            52.698538,
            49.948263
          ],
          [
            14.41272,
            52.698346,
            50.391604
          ],
          [
            14.412898,
            52.698192,
            50.816433
          ],
          [
            14.413166,
            52.698045,
            51.309169
          ],
          [
            14.413429,
            52.697885,
            51.817258
          ],
          [
            14.413728,
            52.697735,
            52.348947
          ],
          [
            14.413986,
            52.697584,
            52.838021
          ],
          [
            14.414215,
            52.697408,
            52.732864
          ],
          [
            14.414506,
            52.697249,
            52.521314
          ],
          [
            14.414842,
            52.697118,
            52.305649
          ],
          [
            14.415127,
            52.696987,
            52.112562
          ],
          [
            14.415435,
            52.696868,
            51.915016
          ],
          [
            14.415726,
            52.696735,
            51.718275
          ],
          [
            14.416041,
            52.696605,
            51.512537
          ],
          [
            14.41633,
            52.696466,
            51.313317
          ],
          [
            14.416588,
            52.69631,
            51.380842
          ],
          [
            14.416843,
            52.696171,
            51.45714
          ],
          [
            14.417114,
            52.696026,
            51.537551
          ],
          [
            14.417401,
            52.69588,
            51.62094
          ],
          [
            14.417714,
            52.695759,
            51.703598
          ],
          [
            14.418035,
            52.695681,
            51.780531
          ],
          [
            14.418389,
            52.695607,
            51.863847
          ],
          [
            14.418767,
            52.695533,
            51.95229
          ],
          [
            14.419092,
            52.695423,
            52.016343
          ],
          [
            14.419393,
            52.695283,
            52.078288
          ],
          [
            14.419692,
            52.695152,
            52.138515
          ],
          [
            14.419994,
            52.695005,
            52.201495
          ],
          [
            14.420273,
            52.694843,
            52.264331
          ],
          [
            14.420549,
            52.694688,
            52.325509
          ],
          [
            14.420843,
            52.694505,
            52.394046
          ],
          [
            14.421156,
            52.694321,
            52.45066
          ],
          [
            14.421413,
            52.69416,
            52.464441
          ],
          [
            14.421595,
            52.694004,
            52.47621
          ],
          [
            14.42179,
            52.69384,
            52.488659
          ],
          [
            14.421974,
            52.693666,
            52.501382
          ],
          [
            14.422075,
            52.693445,
            52.51566
          ],
          [
            14.422192,
            52.693253,
            52.52826
          ],
          [
            14.422313,
            52.693052,
            52.541428
          ],
          [
            14.422459,
            52.692835,
            52.555927
          ],
          [
            14.422619,
            52.692627,
            52.581356
          ],
          [
            14.422786,
            52.692424,
            52.607406
          ],
          [
            14.422953,
            52.692262,
            52.629298
          ],
          [
            14.423095,
            52.692066,
            52.653871
          ],
          [
            14.423232,
            52.691896,
            52.675566
          ],
          [
            14.423373,
            52.691731,
            52.696862
          ],
          [
            14.423521,
            52.691564,
            52.718588
          ],
          [
            14.423663,
            52.691393,
            52.740563
          ],
          [
            14.423823,
            52.691226,
            52.762713
          ],
          [
            14.424009,
            52.691078,
            52.934629
          ],
          [
            14.424203,
            52.690917,
            53.122255
          ],
          [
            14.424398,
            52.690746,
            53.318139
          ],
          [
            14.424575,
            52.690564,
            53.516909
          ],
          [
            14.424761,
            52.690377,
            53.72239
          ],
          [
            14.424986,
            52.690202,
            53.93115
          ],
          [
            14.425141,
            52.690045,
            54.103288
          ],
          [
            14.425355,
            52.689888,
            54.294935
          ],
          [
            14.425541,
            52.689713,
            54.444453
          ],
          [
            14.425755,
            52.689514,
            54.377976
          ],
          [
            14.425908,
            52.689352,
            54.325735
          ],
          [
            14.426081,
            52.689185,
            54.270457
          ],
          [
            14.426254,
            52.689011,
            54.213618
          ],
          [
            14.42639,
            52.688829,
            54.157711
          ],
          [
            14.42654,
            52.688626,
            54.095465
          ],
          [
            14.426684,
            52.688422,
            54.033384
          ],
          [
            14.42681,
            52.688214,
            53.971352
          ],
          [
            14.426899,
            52.687996,
            53.521407
          ],
          [
            14.426983,
            52.687767,
            52.874412
          ],
          [
            14.427051,
            52.687541,
            52.240851
          ],
          [
            14.427094,
            52.687291,
            51.547663
          ],
          [
            14.427113,
            52.687053,
            50.890292
          ],
          [
            14.427088,
            52.686813,
            50.227077
          ],
          [
            14.427059,
            52.686572,
            49.560207
          ],
          [
            14.427021,
            52.686338,
            48.9886
          ],
          [
            14.427006,
            52.686098,
            48.961546
          ],
          [
            14.427026,
            52.685861,
            48.93481
          ],
          [
            14.427106,
            52.685632,
            48.908419
          ],
          [
            14.427273,
            52.68541,
            48.880939
          ],
          [
            14.427467,
            52.685187,
            48.852554
          ],
          [
            14.427639,
            52.68495,
            48.823307
          ],
          [
            14.427732,
            52.6847,
            48.794387
          ],
          [
            14.427806,
            52.684459,
            48.793687
          ],
          [
            14.427813,
            52.684209,
            48.79907
          ],
          [
            14.427848,
            52.683966,
            48.804319
          ],
          [
            14.427908,
            52.68371,
            48.809887
          ],
          [
            14.428007,
            52.68347,
            48.815219
          ],
          [
            14.428101,
            52.68324,
            48.820319
          ],
          [
            14.428184,
            52.683003,
            48.825533
          ],
          [
            14.428269,
            52.682776,
            48.821484
          ],
          [
            14.428327,
            52.682548,
            48.808226
          ],
          [
            14.428423,
            52.682312,
            48.794226
          ],
          [
            14.428634,
            52.682101,
            48.779991
          ],
          [
            14.428882,
            52.681909,
            48.765976
          ],
          [
            14.429119,
            52.681716,
            48.752148
          ],
          [
            14.429343,
            52.681511,
            48.737989
          ],
          [
            14.429695,
            52.68137,
            48.755978
          ],
          [
            14.430004,
            52.681237,
            49.048037
          ],
          [
            14.430309,
            52.681091,
            49.34644
          ],
          [
            14.430586,
            52.680946,
            49.627487
          ],
          [
            14.430849,
            52.680792,
            49.908302
          ],
          [
            14.431088,
            52.68065,
            50.165364
          ],
          [
            14.431315,
            52.680522,
            50.403537
          ],
          [
            14.431572,
            52.680388,
            50.66385
          ],
          [
            14.43186,
            52.680281,
            50.923689
          ],
          [
            14.432112,
            52.680144,
            51.211587
          ],
          [
            14.432409,
            52.680029,
            51.523453
          ],
          [
            14.432692,
            52.679908,
            51.829893
          ],
          [
            14.432966,
            52.679772,
            52.143324
          ],
          [
            14.433261,
            52.679624,
            52.482812
          ],
          [
            14.433536,
            52.679489,
            52.796099
          ],
          [
            14.433783,
            52.679324,
            53.12143
          ],
          [
            14.434035,
            52.679156,
            53.452859
          ],
          [
            14.434282,
            52.678998,
            53.537076
          ],
          [
            14.434518,
            52.678834,
            53.335866
          ],
          [
            14.434772,
            52.678674,
            53.130517
          ],
          [
            14.435016,
            52.678518,
            52.931766
          ],
          [
            14.435286,
            52.678369,
            52.726476
          ],
          [
            14.435585,
            52.67824,
            52.520753
          ],
          [
            14.435919,
            52.678107,
            52.296482
          ],
          [
            14.436213,
            52.677965,
            52.085691
          ],
          [
            14.43649,
            52.677835,
            51.829857
          ],
          [
            14.436709,
            52.677674,
            51.483775
          ],
          [
            14.436665,
            52.677441,
            51.093033
          ],
          [
            14.436567,
            52.677208,
            50.696179
          ],
          [
            14.436511,
            52.676997,
            50.343059
          ],
          [
            14.436807,
            52.676974,
            50.029278
          ],
          [
            14.437124,
            52.676944,
            49.706867
          ],
          [
            14.437433,
            52.676937,
            49.395138
          ],
          [
            14.437682,
            52.676802,
            49.050512
          ],
          [
            14.43782,
            52.676602,
            49.163375
          ],
          [
            14.437979,
            52.676405,
            49.361881
          ],
          [
            14.438188,
            52.676216,
            49.568612
          ],
          [
            14.438533,
            52.676141,
            49.774692
          ],
          [
            14.438868,
            52.676186,
            49.963166
          ],
          [
            14.439232,
            52.67626,
            50.173983
          ],
          [
            14.439628,
            52.676231,
            50.394705
          ],
          [
            14.439991,
            52.676126,
            50.617063
          ],
          [
            14.440253,
            52.675962,
            50.643761
          ],
          [
            14.440495,
            52.675759,
            50.665587
          ],
          [
            14.440798,
            52.675585,
            50.68763
          ],
          [
            14.441132,
            52.675432,
            50.70973
          ],
          [
            14.441429,
            52.675254,
            50.731833
          ],
          [
            14.441748,
            52.675085,
            50.754235
          ],
          [
            14.44207,
            52.67492,
            50.776513
          ],
          [
            14.442377,
            52.674759,
            50.842854
          ],
          [
            14.442673,
            52.674585,
            50.922997
          ],
          [
            14.442945,
            52.674394,
            51.004097
          ],
          [
            14.443199,
            52.674202,
            51.08318
          ],
          [
            14.443402,
            52.674005,
            51.157658
          ],
          [
            14.443616,
            52.673804,
            51.234388
          ],
          [
            14.443852,
            52.673596,
            51.31535
          ],
          [
            14.444121,
            52.673417,
            51.393515
          ],
          [
            14.444404,
            52.67324,
            51.473583
          ],
          [
            14.444573,
            52.673032,
            51.548763
          ],
          [
            14.444673,
            52.672804,
            51.625257
          ],
          [
            14.444769,
            52.672586,
            51.698541
          ],
          [
            14.444898,
            52.67237,
            51.773017
          ],
          [
            14.445022,
            52.672168,
            51.843193
          ],
          [
            14.445187,
            52.671968,
            51.915805
          ],
          [
            14.445351,
            52.671766,
            51.826763
          ],
          [
            14.445477,
            52.671531,
            51.635915
          ],
          [
            14.445504,
            52.671298,
            51.455071
          ],
          [
            14.445507,
            52.671097,
            51.299581
          ],
          [
            14.445442,
            52.670878,
            51.127799
          ],
          [
            14.445525,
            52.670627,
            50.92875
          ],
          [
            14.445684,
            52.670446,
            50.769964
          ],
          [
            14.445852,
            52.670241,
            50.593204
          ],
          [
            14.445969,
            52.670064,
            50.23397
          ],
          [
            14.446073,
            52.669806,
            49.616422
          ],
          [
            14.445999,
            52.669593,
            49.104174
          ],
          [
            14.445869,
            52.669349,
            48.512111
          ],
          [
            14.445882,
            52.669087,
            47.905707
          ],
          [
            14.445925,
            52.668865,
            47.389606
          ],
          [
            14.445949,
            52.668624,
            46.831219
          ],
          [
            14.446012,
            52.668371,
            46.382205
          ],
          [
            14.44605,
            52.668117,
            46.317686
          ],
          [
            14.446041,
            52.667892,
            46.26078
          ],
          [
            14.445993,
            52.667631,
            46.194409
          ],
          [
            14.446002,
            52.667403,
            46.136756
          ],
          [
            14.446008,
            52.667154,
            46.073792
          ],
          [
            14.445987,
            52.666963,
            46.025413
          ],
          [
            14.445897,
            52.666759,
            45.971956
          ],
          [
            14.445762,
            52.666565,
            45.967028
          ],
          [
            14.445622,
            52.66638,
            46.009965
          ],
          [
            14.445492,
            52.666183,
            46.054723
          ],
          [
            14.445404,
            52.665965,
            46.102125
          ],
          [
            14.44534,
            52.66578,
            46.142169
          ],
          [
            14.445295,
            52.665599,
            46.180789
          ],
          [
            14.445258,
            52.665382,
            46.226873
          ],
          [
            14.445212,
            52.665181,
            46.269679
          ],
          [
            14.445161,
            52.66499,
            46.310519
          ],
          [
            14.445049,
            52.664738,
            46.119044
          ],
          [
            14.444896,
            52.664496,
            45.846217
          ],
          [
            14.444749,
            52.664286,
            45.605285
          ],
          [
            14.444584,
            52.664079,
            45.363206
          ],
          [
            14.444385,
            52.663879,
            45.117222
          ],
          [
            14.444212,
            52.663729,
            44.92419
          ],
          [
            14.444049,
            52.66357,
            44.727038
          ],
          [
            14.443827,
            52.663392,
            44.492023
          ],
          [
            14.443674,
            52.6632,
            44.643084
          ],
          [
            14.443598,
            52.662934,
            45.010954
          ],
          [
            14.443511,
            52.66276,
            45.261586
          ],
          [
            14.443389,
            52.66259,
            45.514802
          ],
          [
            14.443229,
            52.662436,
            45.762841
          ],
          [
            14.443,
            52.662229,
            46.102325
          ],
          [
            14.442862,
            52.66203,
            46.396395
          ],
          [
            14.442828,
            52.661778,
            46.742084
          ],
          [
            14.443008,
            52.66157,
            46.959963
          ],
          [
            14.443312,
            52.661456,
            47.084145
          ],
          [
            14.443651,
            52.661368,
            47.21206
          ],
          [
            14.443987,
            52.661282,
            47.338445
          ],
          [
            14.4443,
            52.661118,
            47.482647
          ],
          [
            14.444471,
            52.66096,
            47.590758
          ],
          [
            14.444599,
            52.660748,
            47.719791
          ],
          [
            14.444562,
            52.660487,
            47.870394
          ],
          [
            14.444456,
            52.660273,
            47.588028
          ],
          [
            14.444349,
            52.660062,
            47.137354
          ],
          [
            14.444221,
            52.659893,
            46.757639
          ],
          [
            14.444018,
            52.659707,
            46.301685
          ],
          [
            14.443687,
            52.659532,
            45.755786
          ],
          [
            14.443352,
            52.659447,
            45.299304
          ],
          [
            14.44294,
            52.659397,
            44.778039
          ],
          [
            14.442677,
            52.659245,
            44.32356
          ],
          [
            14.442635,
            52.658997,
            44.438034
          ],
          [
            14.442714,
            52.658812,
            44.619824
          ],
          [
            14.442846,
            52.658599,
            44.836284
          ],
          [
            14.443005,
            52.658392,
            45.053487
          ],
          [
            14.44316,
            52.658194,
            45.262576
          ],
          [
            14.443346,
            52.657998,
            45.477677
          ],
          [
            14.443511,
            52.657806,
            45.683615
          ],
          [
            14.443717,
            52.657627,
            45.891249
          ],
          [
            14.443888,
            52.657474,
            46.014567
          ],
          [
            14.44415,
            52.657262,
            46.155486
          ],
          [
            14.444393,
            52.657086,
            46.277539
          ],
          [
            14.444686,
            52.656878,
            46.42348
          ],
          [
            14.444946,
            52.656689,
            46.554346
          ],
          [
            14.445165,
            52.656562,
            46.652052
          ],
          [
            14.44543,
            52.656402,
            46.773847
          ],
          [
            14.445698,
            52.656248,
            46.893372
          ],
          [
            14.446036,
            52.656087,
            46.955222
          ],
          [
            14.446389,
            52.656096,
            47.001998
          ],
          [
            14.446685,
            52.656155,
            47.042314
          ],
          [
            14.44706,
            52.656189,
            47.091375
          ],
          [
            14.447381,
            52.656216,
            47.13325
          ],
          [
            14.447743,
            52.656265,
            47.181162
          ],
          [
            14.448033,
            52.656317,
            47.220271
          ],
          [
            14.448422,
            52.656377,
            47.272188
          ],
          [
            14.448805,
            52.656424,
            46.908107
          ],
          [
            14.449172,
            52.656545,
            46.332436
          ],
          [
            14.449411,
            52.656763,
            45.741244
          ],
          [
            14.449646,
            52.656941,
            45.226546
          ],
          [
            14.449905,
            52.657124,
            44.681794
          ],
          [
            14.450111,
            52.657261,
            44.262774
          ],
          [
            14.450395,
            52.657449,
            43.688445
          ],
          [
            14.450661,
            52.657587,
            43.263296
          ],
          [
            14.45093,
            52.657751,
            43.77326
          ],
          [
            14.451208,
            52.657903,
            44.273955
          ],
          [
            14.451458,
            52.658028,
            44.706747
          ],
          [
            14.451758,
            52.658132,
            45.167822
          ],
          [
            14.452023,
            52.658245,
            45.600093
          ],
          [
            14.452348,
            52.658358,
            46.100059
          ],
          [
            14.452703,
            52.658432,
            46.604383
          ],
          [
            14.453015,
            52.658467,
            47.028479
          ],
          [
            14.453327,
            52.658518,
            47.340084
          ],
          [
            14.453622,
            52.658557,
            47.562982
          ],
          [
            14.453928,
            52.658601,
            47.794185
          ],
          [
            14.454282,
            52.658663,
            48.065084
          ],
          [
            14.454662,
            52.65866,
            48.345051
          ],
          [
            14.454955,
            52.658612,
            48.568353
          ],
          [
            14.455331,
            52.658545,
            48.857571
          ],
          [
            14.455646,
            52.658516,
            49.091815
          ],
          [
            14.456049,
            52.658412,
            49.335395
          ],
          [
            14.456393,
            52.658323,
            49.08716
          ],
          [
            14.456664,
            52.658236,
            48.883337
          ],
          [
            14.456944,
            52.658095,
            48.641246
          ],
          [
            14.457196,
            52.657916,
            48.383587
          ],
          [
            14.457426,
            52.657742,
            48.13922
          ],
          [
            14.457639,
            52.657571,
            47.904634
          ],
          [
            14.457785,
            52.657335,
            47.628016
          ],
          [
            14.457832,
            52.657147,
            47.419644
          ],
          [
            14.457813,
            52.656962,
            47.143505
          ],
          [
            14.457742,
            52.656776,
            46.857228
          ],
          [
            14.457571,
            52.65657,
            46.511261
          ],
          [
            14.457476,
            52.656355,
            46.177514
          ],
          [
            14.457397,
            52.656128,
            45.829629
          ],
          [
            14.457279,
            52.655906,
            45.479818
          ],
          [
            14.457175,
            52.655736,
            45.205949
          ],
          [
            14.45706,
            52.655517,
            44.861359
          ],
          [
            14.456958,
            52.655303,
            44.846645
          ],
          [
            14.456817,
            52.655061,
            45.12184
          ],
          [
            14.456724,
            52.654843,
            45.363422
          ],
          [
            14.456618,
            52.654659,
            45.572435
          ],
          [
            14.456545,
            52.654473,
            45.777407
          ],
          [
            14.456459,
            52.654296,
            45.9754
          ],
          [
            14.45632,
            52.654083,
            46.221365
          ],
          [
            14.456263,
            52.653874,
            46.449067
          ],
          [
            14.456284,
            52.653651,
            46.651394
          ],
          [
            14.456441,
            52.65345,
            46.699869
          ],
          [
            14.456579,
            52.653288,
            46.739577
          ],
          [
            14.456787,
            52.653107,
            46.787615
          ],
          [
            14.457015,
            52.652872,
            46.846989
          ],
          [
            14.45716,
            52.652701,
            46.888859
          ],
          [
            14.457335,
            52.652507,
            46.937003
          ],
          [
            14.45751,
            52.652309,
            46.985911
          ],
          [
            14.457702,
            52.652117,
            47.033681
          ],
          [
            14.457937,
            52.651938,
            47.046486
          ],
          [
            14.45815,
            52.651796,
            47.057183
          ],
          [
            14.458351,
            52.651655,
            47.067589
          ],
          [
            14.458565,
            52.651471,
            47.080135
          ],
          [
            14.458846,
            52.65139,
            47.090879
          ],
          [
            14.459146,
            52.651321,
            47.101724
          ],
          [
            14.459423,
            52.651246,
            47.111981
          ],
          [
            14.459661,
            52.651116,
            47.122964
          ],
          [
            14.459905,
            52.650935,
            47.099002
          ],
          [
            14.460067,
            52.650779,
            46.962448
          ],
          [
            14.460285,
            52.650622,
            46.809098
          ],
          [
            14.460655,
            52.650542,
            46.632078
          ],
          [
            14.461007,
            52.650591,
            46.468783
          ],
          [
            14.461276,
            52.650697,
            46.32465
          ],
          [
            14.461536,
            52.650823,
            46.175226
          ],
          [
            14.461812,
            52.650954,
            46.017906
          ],
          [
            14.462114,
            52.651032,
            45.870528
          ],
          [
            14.462428,
            52.651087,
            45.971803
          ],
          [
            14.462764,
            52.651133,
            46.30437
          ],
          [
            14.463066,
            52.651187,
            46.608937
          ],
          [
            14.463368,
            52.651262,
            46.925444
          ],
          [
            14.463669,
            52.651319,
            47.229923
          ],
          [
            14.463981,
            52.651377,
            47.544165
          ],
          [
            14.46428,
            52.651437,
            47.847474
          ],
          [
            14.464595,
            52.651446,
            48.151316
          ],
          [
            14.464903,
            52.651442,
            48.449034
          ],
          [
            14.465214,
            52.65141,
            48.839726
          ],
          [
            14.465608,
            52.651384,
            49.569191
          ],
          [
            14.466001,
            52.6514,
            50.29408
          ],
          [
            14.466381,
            52.65142,
            50.996129
          ],
          [
            14.466714,
            52.651456,
            51.620968
          ],
          [
            14.467041,
            52.651478,
            52.226081
          ],
          [
            14.46736,
            52.651503,
            52.82042
          ],
          [
            14.46767,
            52.651544,
            53.40398
          ],
          [
            14.46797,
            52.651571,
            53.961937
          ],
          [
            14.468346,
            52.651617,
            54.008619
          ],
          [
            14.468669,
            52.651669,
            53.896415
          ],
          [
            14.468982,
            52.651718,
            53.788328
          ],
          [
            14.469269,
            52.651794,
            53.683358
          ],
          [
            14.469587,
            52.651845,
            53.572727
          ],
          [
            14.469891,
            52.651874,
            53.46843
          ],
          [
            14.470258,
            52.651895,
            53.345063
          ],
          [
            14.470573,
            52.651881,
            53.239187
          ],
          [
            14.470873,
            52.651859,
            53.137922
          ],
          [
            14.471248,
            52.651848,
            52.535162
          ],
          [
            14.471545,
            52.651807,
            51.978068
          ],
          [
            14.471835,
            52.651764,
            51.431875
          ],
          [
            14.472126,
            52.651722,
            50.884945
          ],
          [
            14.472437,
            52.651652,
            50.276768
          ],
          [
            14.472765,
            52.651584,
            49.642283
          ],
          [
            14.473073,
            52.651525,
            49.051721
          ],
          [
            14.473451,
            52.651693,
            48.19116
          ],
          [
            14.473704,
            52.651857,
            47.784259
          ],
          [
            14.473895,
            52.652011,
            48.051854
          ],
          [
            14.474102,
            52.65217,
            48.333283
          ],
          [
            14.474326,
            52.652321,
            48.615329
          ],
          [
            14.474574,
            52.652472,
            48.911609
          ],
          [
            14.4749,
            52.652445,
            49.199304
          ],
          [
            14.475204,
            52.652306,
            49.52012
          ],
          [
            14.475494,
            52.652143,
            49.853132
          ],
          [
            14.475801,
            52.65199,
            50.187831
          ],
          [
            14.476088,
            52.651855,
            50.232002
          ],
          [
            14.476367,
            52.651713,
            50.268987
          ],
          [
            14.476678,
            52.651559,
            50.309756
          ],
          [
            14.476994,
            52.651407,
            50.350714
          ],
          [
            14.477293,
            52.651253,
            50.390571
          ],
          [
            14.477612,
            52.651112,
            50.43066
          ],
          [
            14.477947,
            52.650957,
            50.473444
          ],
          [
            14.478266,
            52.650807,
            50.456722
          ],
          [
            14.478529,
            52.650659,
            50.370766
          ],
          [
            14.478846,
            52.650525,
            50.27876
          ],
          [
            14.479147,
            52.650387,
            50.188844
          ],
          [
            14.479437,
            52.650259,
            50.10344
          ],
          [
            14.479727,
            52.65012,
            50.015339
          ],
          [
            14.480058,
            52.649934,
            49.90792
          ],
          [
            14.480385,
            52.649801,
            49.813989
          ],
          [
            14.480701,
            52.64967,
            49.826008
          ],
          [
            14.481021,
            52.649529,
            49.87375
          ],
          [
            14.481345,
            52.649401,
            49.920417
          ],
          [
            14.481671,
            52.649255,
            49.969323
          ],
          [
            14.482005,
            52.649125,
            50.017222
          ],
          [
            14.482328,
            52.648986,
            50.065104
          ],
          [
            14.482636,
            52.648835,
            50.1129
          ],
          [
            14.482967,
            52.648679,
            50.082394
          ],
          [
            14.483216,
            52.648565,
            49.90782
          ],
          [
            14.483572,
            52.648412,
            49.663448
          ],
          [
            14.483918,
            52.648268,
            49.42863
          ],
          [
            14.484121,
            52.648132,
            49.258592
          ],
          [
            14.484455,
            52.647991,
            49.03076
          ],
          [
            14.484717,
            52.647898,
            48.860769
          ],
          [
            14.484958,
            52.647776,
            48.684465
          ],
          [
            14.485266,
            52.647654,
            48.48827
          ],
          [
            14.485612,
            52.647509,
            48.45005
          ],
          [
            14.485947,
            52.647364,
            48.412623
          ],
          [
            14.486248,
            52.647218,
            48.377551
          ],
          [
            14.486545,
            52.647086,
            48.344089
          ],
          [
            14.486848,
            52.646956,
            48.31036
          ],
          [
            14.48716,
            52.646812,
            48.274728
          ],
          [
            14.487476,
            52.646669,
            48.238892
          ],
          [
            14.487789,
            52.646526,
            48.01905
          ],
          [
            14.488108,
            52.646384,
            47.602834
          ],
          [
            14.488438,
            52.64623,
            47.164961
          ],
          [
            14.488778,
            52.646077,
            46.719802
          ],
          [
            14.489128,
            52.645925,
            46.267164
          ],
          [
            14.489409,
            52.645789,
            45.888973
          ],
          [
            14.489723,
            52.645628,
            45.451884
          ],
          [
            14.490068,
            52.645496,
            45.158944
          ],
          [
            14.49038,
            52.64534,
            45.452953
          ],
          [
            14.490717,
            52.64519,
            45.756802
          ],
          [
            14.491056,
            52.645045,
            46.058288
          ],
          [
            14.491404,
            52.644901,
            46.364495
          ],
          [
            14.491763,
            52.644759,
            46.676365
          ],
          [
            14.492076,
            52.644621,
            46.957599
          ],
          [
            14.492352,
            52.64448,
            47.220121
          ],
          [
            14.492691,
            52.644331,
            47.082291
          ],
          [
            14.49301,
            52.644188,
            46.892374
          ],
          [
            14.493306,
            52.644024,
            46.700427
          ],
          [
            14.493651,
            52.643886,
            46.502607
          ],
          [
            14.493998,
            52.643734,
            46.297724
          ],
          [
            14.494346,
            52.64359,
            46.096018
          ],
          [
            14.494682,
            52.643453,
            45.902228
          ],
          [
            14.494995,
            52.643333,
            45.894936
          ],
          [
            14.495318,
            52.643176,
            45.992042
          ],
          [
            14.495642,
            52.643038,
            46.084942
          ],
          [
            14.495951,
            52.642892,
            46.176882
          ],
          [
            14.496279,
            52.642755,
            46.270329
          ],
          [
            14.496613,
            52.64262,
            46.364497
          ],
          [
            14.496941,
            52.642482,
            46.458147
          ],
          [
            14.497259,
            52.642353,
            46.599304
          ],
          [
            14.497571,
            52.64223,
            47.019734
          ],
          [
            14.497871,
            52.642102,
            47.434209
          ],
          [
            14.498213,
            52.641967,
            47.895098
          ],
          [
            14.498556,
            52.641825,
            48.364128
          ],
          [
            14.49881,
            52.641724,
            48.709066
          ],
          [
            14.499111,
            52.641597,
            49.123242
          ],
          [
            14.499462,
            52.641453,
            49.601899
          ],
          [
            14.499829,
            52.641322,
            49.911086
          ],
          [
            14.50011,
            52.641186,
            49.968997
          ],
          [
            14.500418,
            52.641061,
            50.028622
          ],
          [
            14.500703,
            52.640926,
            50.086895
          ],
          [
            14.501046,
            52.640788,
            50.153122
          ],
          [
            14.501403,
            52.640665,
            50.219183
          ],
          [
            14.501703,
            52.640545,
            50.277003
          ],
          [
            14.502061,
            52.640403,
            50.345831
          ],
          [
            14.502418,
            52.640262,
            50.244503
          ],
          [
            14.502732,
            52.640152,
            50.122603
          ],
          [
            14.503039,
            52.64002,
            49.995995
          ],
          [
            14.503298,
            52.639924,
            49.893578
          ],
          [
            14.503611,
            52.639791,
            49.764352
          ],
          [
            14.503869,
            52.639676,
            49.656671
          ],
          [
            14.504256,
            52.639543,
            49.507122
          ],
          [
            14.504555,
            52.639417,
            49.384221
          ],
          [
            14.504867,
            52.639282,
            49.207033
          ],
          [
            14.505196,
            52.639159,
            49.018693
          ],
          [
            14.505426,
            52.639028,
            48.864968
          ],
          [
            14.505748,
            52.638906,
            48.680086
          ],
          [
            14.506007,
            52.638776,
            48.516379
          ],
          [
            14.506322,
            52.63866,
            48.336708
          ],
          [
            14.506598,
            52.638544,
            48.173196
          ],
          [
            14.506876,
            52.638439,
            48.013722
          ],
          [
            14.507186,
            52.638316,
            48.033735
          ],
          [
            14.507472,
            52.63822,
            48.244896
          ],
          [
            14.507765,
            52.638144,
            48.450677
          ],
          [
            14.508033,
            52.638041,
            48.657184
          ],
          [
            14.5083,
            52.637936,
            48.862736
          ],
          [
            14.508611,
            52.637805,
            49.107154
          ],
          [
            14.508918,
            52.637681,
            49.345245
          ],
          [
            14.509228,
            52.637561,
            49.582645
          ],
          [
            14.509505,
            52.637474,
            49.784575
          ],
          [
            14.50982,
            52.637362,
            49.817516
          ],
          [
            14.510092,
            52.637264,
            49.800673
          ],
          [
            14.510358,
            52.637167,
            49.784109
          ],
          [
            14.510717,
            52.637033,
            49.76166
          ],
          [
            14.511045,
            52.636919,
            49.74152
          ],
          [
            14.51137,
            52.636795,
            49.721055
          ],
          [
            14.511653,
            52.636682,
            49.702976
          ],
          [
            14.511924,
            52.636565,
            49.685268
          ],
          [
            14.512234,
            52.636449,
            49.689159
          ],
          [
            14.512529,
            52.636357,
            49.715686
          ],
          [
            14.512853,
            52.63623,
            49.746522
          ],
          [
            14.513142,
            52.636132,
            49.773008
          ],
          [
            14.513461,
            52.636021,
            49.802435
          ],
          [
            14.513721,
            52.635919,
            49.827316
          ],
          [
            14.514063,
            52.635794,
            49.859235
          ],
          [
            14.514373,
            52.635686,
            49.887811
          ],
          [
            14.514639,
            52.635588,
            49.91074
          ],
          [
            14.514917,
            52.635501,
            49.853866
          ],
          [
            14.515194,
            52.635404,
            49.795736
          ],
          [
            14.515499,
            52.635273,
            49.727791
          ],
          [
            14.515765,
            52.635179,
            49.671667
          ],
          [
            14.516041,
            52.63509,
            49.614848
          ],
          [
            14.516369,
            52.634967,
            49.544626
          ],
          [
            14.51674,
            52.634829,
            49.465513
          ],
          [
            14.517058,
            52.63472,
            49.399139
          ],
          [
            14.517322,
            52.634632,
            49.441704
          ],
          [
            14.517644,
            52.634514,
            49.600216
          ],
          [
            14.517922,
            52.634405,
            49.739917
          ],
          [
            14.518202,
            52.634326,
            49.870057
          ],
          [
            14.518529,
            52.634221,
            50.025961
          ],
          [
            14.518862,
            52.634116,
            50.184099
          ],
          [
            14.519168,
            52.634,
            50.336475
          ],
          [
            14.519447,
            52.633894,
            50.475234
          ],
          [
            14.519757,
            52.633789,
            50.622908
          ],
          [
            14.520084,
            52.633663,
            50.646303
          ],
          [
            14.520441,
            52.633535,
            50.67124
          ],
          [
            14.520732,
            52.633438,
            50.691223
          ],
          [
            14.521003,
            52.633354,
            50.709529
          ],
          [
            14.521339,
            52.633244,
            50.73265
          ],
          [
            14.521603,
            52.633159,
            50.750694
          ],
          [
            14.521865,
            52.633069,
            50.768817
          ],
          [
            14.522196,
            52.632947,
            50.792134
          ],
          [
            14.52246,
            52.632843,
            50.648955
          ],
          [
            14.522766,
            52.632751,
            50.34965
          ],
          [
            14.523085,
            52.632642,
            50.029632
          ],
          [
            14.523385,
            52.632529,
            49.721633
          ],
          [
            14.523715,
            52.632402,
            49.380773
          ],
          [
            14.524073,
            52.632277,
            49.020406
          ],
          [
            14.524382,
            52.632166,
            48.705794
          ],
          [
            14.52473,
            52.632035,
            48.348137
          ],
          [
            14.525041,
            52.631936,
            48.26474
          ],
          [
            14.52535,
            52.631822,
            48.353731
          ],
          [
            14.525696,
            52.631683,
            48.455997
          ],
          [
            14.526026,
            52.631583,
            48.546955
          ],
          [
            14.526406,
            52.631454,
            48.654129
          ],
          [
            14.526731,
            52.631307,
            48.754021
          ],
          [
            14.526882,
            52.631111,
            48.842326
          ],
          [
            14.526993,
            52.630938,
            48.917625
          ],
          [
            14.527084,
            52.630748,
            49.134725
          ],
          [
            14.527206,
            52.630541,
            49.45373
          ],
          [
            14.527335,
            52.630294,
            49.82998
          ],
          [
            14.527365,
            52.630088,
            50.131384
          ],
          [
            14.527281,
            52.629851,
            50.484008
          ],
          [
            14.527171,
            52.629637,
            50.809585
          ],
          [
            14.527049,
            52.629394,
            51.178381
          ],
          [
            14.52698,
            52.629142,
            51.550125
          ],
          [
            14.526994,
            52.628897,
            51.262917
          ],
          [
            14.52698,
            52.628641,
            50.953825
          ],
          [
            14.526828,
            52.62841,
            50.653107
          ],
          [
            14.526655,
            52.628182,
            50.350863
          ],
          [
            14.526526,
            52.627969,
            50.076922
          ],
          [
            14.526609,
            52.627756,
            49.811544
          ],
          [
            14.526664,
            52.627572,
            49.586031
          ],
          [
            14.526706,
            52.627391,
            49.364443
          ],
          [
            14.526776,
            52.627159,
            49.061937
          ],
          [
            14.52687,
            52.626949,
            48.783082
          ],
          [
            14.526981,
            52.626727,
            48.486021
          ],
          [
            14.527073,
            52.626517,
            48.207942
          ],
          [
            14.52718,
            52.626304,
            47.922984
          ],
          [
            14.527268,
            52.626111,
            47.666678
          ],
          [
            14.527342,
            52.625907,
            47.399387
          ],
          [
            14.527406,
            52.625714,
            47.147361
          ],
          [
            14.527478,
            52.625526,
            47.034643
          ],
          [
            14.527532,
            52.62533,
            46.962209
          ],
          [
            14.527591,
            52.625104,
            46.878644
          ],
          [
            14.527639,
            52.624909,
            46.806824
          ],
          [
            14.527702,
            52.624724,
            46.737963
          ],
          [
            14.52778,
            52.62454,
            46.668756
          ],
          [
            14.527867,
            52.624346,
            46.595516
          ],
          [
            14.52796,
            52.624133,
            46.515217
          ],
          [
            14.52805,
            52.623939,
            46.441773
          ],
          [
            14.528158,
            52.62375,
            46.472047
          ],
          [
            14.528257,
            52.623567,
            46.514958
          ],
          [
            14.528373,
            52.62338,
            46.559449
          ],
          [
            14.528465,
            52.623197,
            46.602051
          ],
          [
            14.528575,
            52.623011,
            46.646052
          ],
          [
            14.52868,
            52.622832,
            46.688363
          ],
          [
            14.528756,
            52.622648,
            46.730625
          ],
          [
            14.528907,
            52.622433,
            46.782692
          ],
          [
            14.52906,
            52.622205,
            46.838991
          ],
          [
            14.529182,
            52.622016,
            46.900199
          ],
          [
            14.529332,
            52.621847,
            46.958096
          ],
          [
            14.52949,
            52.621667,
            47.019828
          ],
          [
            14.529672,
            52.621498,
            47.080708
          ],
          [
            14.529861,
            52.621332,
            47.14166
          ],
          [
            14.530104,
            52.621151,
            47.212085
          ],
          [
            14.53031,
            52.621007,
            47.270126
          ],
          [
            14.530534,
            52.620862,
            47.330106
          ],
          [
            14.530786,
            52.620729,
            47.442621
          ],
          [
            14.531053,
            52.620616,
            47.699054
          ],
          [
            14.531306,
            52.620509,
            47.941974
          ],
          [
            14.53157,
            52.620397,
            48.196363
          ],
          [
            14.531876,
            52.620302,
            48.467766
          ],
          [
            14.532164,
            52.620206,
            48.726343
          ],
          [
            14.532448,
            52.620089,
            48.998527
          ],
          [
            14.532728,
            52.619996,
            49.249876
          ],
          [
            14.53301,
            52.619915,
            49.495394
          ],
          [
            14.533305,
            52.619829,
            49.725659
          ],
          [
            14.533594,
            52.61975,
            49.82629
          ],
          [
            14.533879,
            52.619664,
            49.927165
          ],
          [
            14.534169,
            52.619587,
            50.027758
          ],
          [
            14.534469,
            52.619506,
            50.132088
          ],
          [
            14.534732,
            52.619413,
            50.228645
          ],
          [
            14.535023,
            52.619345,
            50.327472
          ],
          [
            14.535318,
            52.619264,
            50.430118
          ],
          [
            14.535624,
            52.619202,
            50.532366
          ],
          [
            14.535929,
            52.619152,
            50.632745
          ],
          [
            14.536219,
            52.619085,
            50.591063
          ],
          [
            14.536527,
            52.619038,
            50.526623
          ],
          [
            14.536819,
            52.619,
            50.466025
          ],
          [
            14.537119,
            52.618974,
            50.404409
          ],
          [
            14.537486,
            52.618952,
            50.329578
          ],
          [
            14.537791,
            52.61895,
            50.267251
          ],
          [
            14.53817,
            52.618949,
            50.190343
          ],
          [
            14.538482,
            52.618953,
            50.127008
          ],
          [
            14.538789,
            52.618984,
            50.063837
          ],
          [
            14.539094,
            52.619005,
            49.747788
          ],
          [
            14.539423,
            52.619029,
            49.287642
          ],
          [
            14.539789,
            52.619034,
            48.77798
          ],
          [
            14.540099,
            52.619042,
            48.34488
          ],
          [
            14.540412,
            52.619066,
            47.907023
          ],
          [
            14.540729,
            52.619098,
            47.461216
          ],
          [
            14.541048,
            52.619124,
            47.014886
          ],
          [
            14.541376,
            52.619148,
            46.555986
          ],
          [
            14.541687,
            52.619146,
            46.124473
          ],
          [
            14.54207,
            52.619153,
            46.052772
          ],
          [
            14.542448,
            52.61916,
            46.229987
          ],
          [
            14.542749,
            52.619163,
            46.371119
          ],
          [
            14.543077,
            52.619154,
            46.524925
          ],
          [
            14.543408,
            52.619166,
            46.681173
          ],
          [
            14.543716,
            52.619175,
            46.825652
          ],
          [
            14.544038,
            52.619202,
            46.977828
          ],
          [
            14.544353,
            52.619216,
            47.125838
          ],
          [
            14.544671,
            52.61924,
            47.275923
          ],
          [
            14.544975,
            52.619269,
            47.47751
          ],
          [
            14.545285,
            52.619308,
            47.713604
          ],
          [
            14.54558,
            52.619376,
            47.949006
          ],
          [
            14.545906,
            52.619457,
            48.211426
          ],
          [
            14.546187,
            52.619529,
            48.438859
          ],
          [
            14.546493,
            52.619607,
            48.686173
          ],
          [
            14.546774,
            52.619704,
            48.927094
          ],
          [
            14.547062,
            52.619785,
            49.163745
          ],
          [
            14.547346,
            52.619874,
            49.401843
          ],
          [
            14.547614,
            52.619961,
            49.55847
          ],
          [
            14.547922,
            52.620033,
            49.629314
          ],
          [
            14.548186,
            52.620118,
            49.693547
          ],
          [
            14.548552,
            52.620249,
            49.784715
          ],
          [
            14.548828,
            52.620339,
            49.85237
          ],
          [
            14.549125,
            52.62043,
            49.923753
          ],
          [
            14.549419,
            52.620522,
            49.9948
          ],
          [
            14.549689,
            52.620599,
            50.05914
          ],
          [
            14.550031,
            52.620683,
            50.138373
          ],
          [
            14.550409,
            52.620804,
            50.119889
          ],
          [
            14.550751,
            52.6209,
            50.061818
          ],
          [
            14.551034,
            52.62099,
            50.012591
          ],
          [
            14.551302,
            52.621079,
            49.965504
          ],
          [
            14.551582,
            52.621173,
            49.916195
          ],
          [
            14.551859,
            52.621242,
            49.870003
          ],
          [
            14.552158,
            52.621313,
            49.820533
          ],
          [
            14.552501,
            52.621407,
            49.762546
          ],
          [
            14.552803,
            52.621428,
            49.715703
          ],
          [
            14.553097,
            52.621466,
            49.839835
          ],
          [
            14.553401,
            52.621483,
            49.993031
          ],
          [
            14.553721,
            52.62149,
            50.153728
          ],
          [
            14.554047,
            52.621476,
            50.317754
          ],
          [
            14.55436,
            52.621447,
            50.47674
          ],
          [
            14.554661,
            52.621412,
            50.630528
          ],
          [
            14.55496,
            52.621358,
            50.787105
          ],
          [
            14.555369,
            52.621299,
            50.998122
          ],
          [
            14.55574,
            52.621246,
            51.189426
          ],
          [
            14.556042,
            52.621192,
            51.070674
          ],
          [
            14.556344,
            52.621138,
            50.939789
          ],
          [
            14.556638,
            52.621063,
            50.806917
          ],
          [
            14.556944,
            52.620993,
            50.670987
          ],
          [
            14.557246,
            52.620931,
            50.538409
          ],
          [
            14.557543,
            52.620873,
            50.408572
          ],
          [
            14.557832,
            52.620796,
            50.276948
          ],
          [
            14.55809,
            52.620695,
            50.148951
          ],
          [
            14.558349,
            52.6206,
            50.023237
          ],
          [
            14.558607,
            52.620491,
            49.803142
          ],
          [
            14.558864,
            52.620389,
            49.51859
          ],
          [
            14.559119,
            52.620281,
            49.230447
          ],
          [
            14.559418,
            52.620154,
            48.892268
          ],
          [
            14.559667,
            52.620031,
            48.594137
          ],
          [
            14.559977,
            52.61991,
            48.252552
          ],
          [
            14.560215,
            52.619791,
            47.965843
          ],
          [
            14.560451,
            52.619671,
            47.680206
          ],
          [
            14.560727,
            52.619497,
            47.310427
          ],
          [
            14.560962,
            52.619378,
            47.339391
          ],
          [
            14.56119,
            52.619234,
            47.529184
          ],
          [
            14.561405,
            52.619082,
            47.719042
          ],
          [
            14.561603,
            52.618941,
            47.894492
          ],
          [
            14.561858,
            52.618803,
            48.090769
          ],
          [
            14.562134,
            52.618648,
            48.306767
          ],
          [
            14.5624,
            52.618477,
            48.529403
          ],
          [
            14.562701,
            52.618338,
            48.747196
          ],
          [
            14.562951,
            52.618229,
            48.920218
          ],
          [
            14.563238,
            52.618122,
            48.821777
          ],
          [
            14.563519,
            52.618023,
            48.726957
          ],
          [
            14.563798,
            52.617928,
            48.633603
          ],
          [
            14.564078,
            52.617835,
            48.540441
          ],
          [
            14.564373,
            52.617744,
            48.443861
          ],
          [
            14.564649,
            52.617643,
            48.349727
          ],
          [
            14.564912,
            52.61754,
            48.258319
          ],
          [
            14.565219,
            52.617414,
            48.150135
          ],
          [
            14.5655,
            52.617306,
            48.050356
          ],
          [
            14.565758,
            52.617203,
            47.89755
          ],
          [
            14.566062,
            52.617065,
            47.709757
          ],
          [
            14.5664,
            52.616922,
            47.505654
          ],
          [
            14.566659,
            52.61681,
            47.348335
          ],
          [
            14.566923,
            52.616707,
            47.193119
          ],
          [
            14.567181,
            52.616604,
            47.040393
          ],
          [
            14.567454,
            52.616493,
            46.87723
          ],
          [
            14.567708,
            52.616385,
            46.723582
          ],
          [
            14.56801,
            52.616254,
            46.629804
          ],
          [
            14.568266,
            52.61613,
            46.749364
          ],
          [
            14.568514,
            52.616019,
            46.861953
          ],
          [
            14.568793,
            52.615912,
            46.982307
          ],
          [
            14.569067,
            52.61581,
            47.099658
          ],
          [
            14.569377,
            52.615718,
            47.225414
          ],
          [
            14.569664,
            52.615637,
            47.34077
          ],
          [
            14.569944,
            52.615549,
            47.455743
          ],
          [
            14.570221,
            52.615459,
            47.570265
          ],
          [
            14.570537,
            52.61534,
            47.736004
          ],
          [
            14.570822,
            52.615232,
            47.965209
          ],
          [
            14.571109,
            52.615137,
            48.188711
          ],
          [
            14.571392,
            52.615036,
            48.412995
          ],
          [
            14.571679,
            52.614946,
            48.633322
          ],
          [
            14.571935,
            52.614837,
            48.847027
          ],
          [
            14.572202,
            52.614707,
            49.080668
          ],
          [
            14.572451,
            52.614603,
            49.286803
          ],
          [
            14.572706,
            52.614492,
            49.500809
          ],
          [
            14.57301,
            52.614349,
            49.671253
          ],
          [
            14.573291,
            52.614199,
            49.598116
          ],
          [
            14.57363,
            52.614056,
            49.517424
          ],
          [
            14.573901,
            52.61389,
            49.442121
          ],
          [
            14.574153,
            52.613741,
            49.373337
          ],
          [
            14.574369,
            52.613607,
            49.312971
          ],
          [
            14.574578,
            52.613472,
            49.253322
          ],
          [
            14.574787,
            52.613326,
            49.191041
          ],
          [
            14.575019,
            52.61314,
            49.115911
          ],
          [
            14.57528,
            52.612975,
            49.147318
          ],
          [
            14.575481,
            52.612817,
            49.178759
          ],
          [
            14.575691,
            52.612677,
            49.20863
          ],
          [
            14.575963,
            52.6125,
            49.246746
          ],
          [
            14.576174,
            52.612347,
            49.278184
          ],
          [
            14.576424,
            52.612168,
            49.315181
          ],
          [
            14.576666,
            52.612023,
            49.347685
          ],
          [
            14.576851,
            52.611865,
            49.378215
          ],
          [
            14.577052,
            52.611707,
            49.439291
          ],
          [
            14.577246,
            52.611566,
            49.530806
          ],
          [
            14.577442,
            52.611367,
            49.646301
          ],
          [
            14.577625,
            52.611182,
            49.753582
          ],
          [
            14.577789,
            52.611027,
            49.845288
          ],
          [
            14.577969,
            52.610871,
            49.939951
          ],
          [
            14.578155,
            52.610716,
            50.035306
          ],
          [
            14.578333,
            52.610553,
            50.132572
          ],
          [
            14.578561,
            52.610333,
            50.261739
          ],
          [
            14.578756,
            52.610141,
            50.065303
          ],
          [
            14.578981,
            52.609906,
            49.705125
          ],
          [
            14.579145,
            52.609735,
            49.442644
          ],
          [
            14.57933,
            52.609587,
            49.196476
          ],
          [
            14.579531,
            52.609367,
            48.862203
          ],
          [
            14.579713,
            52.609206,
            48.603476
          ],
          [
            14.579871,
            52.608996,
            48.297376
          ],
          [
            14.580029,
            52.608838,
            48.052378
          ],
          [
            14.580161,
            52.60867,
            47.864568
          ],
          [
            14.580338,
            52.60847,
            47.739724
          ],
          [
            14.580534,
            52.608256,
            47.605079
          ],
          [
            14.580682,
            52.608067,
            47.489992
          ],
          [
            14.580845,
            52.607889,
            47.377969
          ],
          [
            14.581035,
            52.607693,
            47.252913
          ],
          [
            14.581209,
            52.607487,
            47.125611
          ],
          [
            14.581377,
            52.607281,
            46.999204
          ],
          [
            14.581537,
            52.607082,
            47.033596
          ],
          [
            14.581727,
            52.606894,
            47.381731
          ],
          [
            14.581903,
            52.606665,
            47.780828
          ],
          [
            14.582066,
            52.606499,
            48.085696
          ],
          [
            14.582243,
            52.606307,
            48.432795
          ],
          [
            14.582406,
            52.606152,
            48.72296
          ],
          [
            14.58262,
            52.605922,
            49.140186
          ],
          [
            14.582787,
            52.605759,
            49.443155
          ],
          [
            14.582986,
            52.605558,
            49.775412
          ],
          [
            14.583154,
            52.605384,
            49.887569
          ],
          [
            14.583318,
            52.605219,
            49.994815
          ],
          [
            14.583485,
            52.605056,
            50.101632
          ],
          [
            14.583671,
            52.604904,
            50.206931
          ],
          [
            14.583833,
            52.604739,
            50.313856
          ],
          [
            14.584064,
            52.604519,
            50.459109
          ],
          [
            14.584241,
            52.604319,
            50.585374
          ],
          [
            14.584415,
            52.604149,
            50.696766
          ],
          [
            14.584564,
            52.603988,
            50.735218
          ],
          [
            14.584728,
            52.603794,
            50.681704
          ],
          [
            14.58494,
            52.603607,
            50.625979
          ],
          [
            14.585089,
            52.603436,
            50.578506
          ],
          [
            14.585274,
            52.603237,
            50.52243
          ],
          [
            14.585475,
            52.603005,
            50.458089
          ],
          [
            14.585611,
            52.602835,
            50.411706
          ],
          [
            14.585779,
            52.602676,
            50.36531
          ],
          [
            14.585931,
            52.602514,
            50.319558
          ],
          [
            14.586129,
            52.602286,
            50.468635
          ],
          [
            14.586363,
            52.602067,
            50.641975
          ],
          [
            14.586532,
            52.601875,
            50.786895
          ],
          [
            14.586737,
            52.601692,
            50.933858
          ],
          [
            14.586931,
            52.601546,
            51.058439
          ],
          [
            14.587127,
            52.601399,
            51.184277
          ],
          [
            14.587419,
            52.60121,
            51.356496
          ],
          [
            14.58762,
            52.601053,
            51.488713
          ],
          [
            14.587893,
            52.600835,
            51.376483
          ],
          [
            14.588132,
            52.600665,
            51.257054
          ],
          [
            14.588356,
            52.600481,
            51.134659
          ],
          [
            14.58854,
            52.600325,
            51.032012
          ],
          [
            14.588791,
            52.600106,
            50.889348
          ],
          [
            14.589026,
            52.599921,
            50.764371
          ],
          [
            14.589193,
            52.599762,
            50.663483
          ],
          [
            14.589448,
            52.599547,
            50.615708
          ],
          [
            14.589675,
            52.599332,
            50.993879
          ],
          [
            14.589889,
            52.599154,
            51.320734
          ],
          [
            14.590075,
            52.598992,
            51.613334
          ],
          [
            14.590312,
            52.598785,
            51.98663
          ],
          [
            14.59053,
            52.598638,
            52.280982
          ],
          [
            14.59078,
            52.598486,
            52.599114
          ],
          [
            14.591016,
            52.59831,
            52.935206
          ],
          [
            14.591232,
            52.598135,
            53.201968
          ],
          [
            14.591402,
            52.597957,
            53.153851
          ],
          [
            14.59174,
            52.597891,
            53.103801
          ],
          [
            14.592095,
            52.597766,
            53.045922
          ],
          [
            14.59243,
            52.597692,
            52.995712
          ],
          [
            14.592781,
            52.597635,
            52.944447
          ],
          [
            14.593119,
            52.597585,
            52.895453
          ],
          [
            14.593452,
            52.597525,
            52.846301
          ],
          [
            14.593773,
            52.597489,
            52.799995
          ],
          [
            14.594129,
            52.59747,
            52.771127
          ],
          [
            14.594417,
            52.59741,
            52.749913
          ],
          [
            14.594782,
            52.597346,
            52.723408
          ],
          [
            14.59514,
            52.597295,
            52.697775
          ],
          [
            14.595466,
            52.597255,
            52.674547
          ],
          [
            14.595714,
            52.597139,
            52.652481
          ],
          [
            14.596061,
            52.597085,
            52.627514
          ],
          [
            14.596395,
            52.597002,
            52.602346
          ],
          [
            14.596659,
            52.596909,
            52.556405
          ],
          [
            14.596989,
            52.596751,
            52.391034
          ],
          [
            14.597261,
            52.596613,
            52.252274
          ],
          [
            14.597517,
            52.59645,
            52.107886
          ],
          [
            14.597767,
            52.596295,
            51.968863
          ],
          [
            14.597978,
            52.596147,
            51.843421
          ],
          [
            14.598201,
            52.595971,
            51.701102
          ],
          [
            14.598468,
            52.595799,
            51.549437
          ],
          [
            14.598744,
            52.595629,
            51.434249
          ],
          [
            14.598981,
            52.595492,
            51.434745
          ],
          [
            14.599289,
            52.595297,
            51.435419
          ],
          [
            14.599565,
            52.595105,
            51.436054
          ],
          [
            14.599861,
            52.594919,
            51.436699
          ],
          [
            14.600105,
            52.594743,
            51.437272
          ],
          [
            14.600359,
            52.594589,
            51.437815
          ],
          [
            14.600595,
            52.59444,
            51.438331
          ],
          [
            14.600814,
            52.594309,
            51.431662
          ],
          [
            14.601029,
            52.594172,
            51.416404
          ],
          [
            14.601253,
            52.59403,
            51.400539
          ],
          [
            14.601546,
            52.593896,
            51.38258
          ],
          [
            14.601748,
            52.593753,
            51.367351
          ],
          [
            14.602007,
            52.593595,
            51.34938
          ],
          [
            14.602298,
            52.593394,
            51.327806
          ],
          [
            14.602541,
            52.593242,
            51.310699
          ],
          [
            14.60279,
            52.59308,
            51.28916
          ],
          [
            14.603027,
            52.592928,
            51.193871
          ],
          [
            14.603269,
            52.592795,
            51.103638
          ],
          [
            14.603504,
            52.5926,
            50.993735
          ],
          [
            14.60375,
            52.59239,
            50.876444
          ],
          [
            14.604047,
            52.592216,
            50.760801
          ],
          [
            14.604393,
            52.592087,
            50.648029
          ],
          [
            14.604673,
            52.592011,
            50.563271
          ],
          [
            14.604986,
            52.591921,
            50.481174
          ],
          [
            14.60532,
            52.591793,
            50.556091
          ],
          [
            14.605544,
            52.591596,
            50.63063
          ],
          [
            14.605714,
            52.591376,
            50.706146
          ],
          [
            14.605864,
            52.591169,
            50.776384
          ],
          [
            14.606036,
            52.590948,
            50.85234
          ],
          [
            14.606198,
            52.590753,
            50.920458
          ],
          [
            14.606345,
            52.590542,
            50.991621
          ],
          [
            14.606514,
            52.590307,
            51.03373
          ],
          [
            14.606689,
            52.590084,
            51.032676
          ],
          [
            14.606865,
            52.589855,
            51.031598
          ],
          [
            14.607034,
            52.589664,
            51.030674
          ],
          [
            14.607204,
            52.589445,
            51.029641
          ],
          [
            14.607371,
            52.589226,
            51.028612
          ],
          [
            14.607536,
            52.588994,
            51.027533
          ],
          [
            14.60772,
            52.588753,
            51.008119
          ],
          [
            14.607881,
            52.588533,
            50.896451
          ],
          [
            14.608049,
            52.588319,
            50.786471
          ],
          [
            14.608184,
            52.588114,
            50.68409
          ],
          [
            14.608354,
            52.587901,
            50.574292
          ],
          [
            14.608527,
            52.58766,
            50.452345
          ],
          [
            14.608517,
            52.587454,
            50.356563
          ],
          [
            14.608446,
            52.587211,
            50.242112
          ],
          [
            14.60843,
            52.586958,
            50.23706
          ],
          [
            14.608434,
            52.586737,
            50.304188
          ],
          [
            14.608455,
            52.58649,
            50.379331
          ],
          [
            14.608508,
            52.586272,
            50.446345
          ],
          [
            14.60849,
            52.586023,
            50.52203
          ],
          [
            14.60854,
            52.585782,
            50.595951
          ],
          [
            14.608598,
            52.585552,
            50.666658
          ],
          [
            14.608663,
            52.585338,
            50.732746
          ],
          [
            14.60869,
            52.58511,
            50.731916
          ],
          [
            14.608661,
            52.584876,
            50.724198
          ],
          [
            14.608608,
            52.584657,
            50.716932
          ],
          [
            14.608669,
            52.58443,
            50.709309
          ],
          [
            14.608747,
            52.584186,
            50.701148
          ],
          [
            14.608727,
            52.583972,
            50.694104
          ],
          [
            14.608742,
            52.583791,
            50.688154
          ],
          [
            14.608714,
            52.583603,
            50.681924
          ],
          [
            14.608687,
            52.583337,
            50.7099
          ],
          [
            14.608702,
            52.583153,
            50.737638
          ],
          [
            14.60879,
            52.582923,
            50.773212
          ],
          [
            14.608927,
            52.582713,
            50.807225
          ],
          [
            14.60915,
            52.582485,
            50.847198
          ],
          [
            14.609326,
            52.582327,
            50.875941
          ],
          [
            14.609513,
            52.582177,
            50.904275
          ],
          [
            14.609733,
            52.581985,
            50.939544
          ],
          [
            14.609936,
            52.581813,
            50.888436
          ],
          [
            14.610171,
            52.581587,
            50.769229
          ],
          [
            14.610431,
            52.581385,
            50.65495
          ],
          [
            14.610642,
            52.581206,
            50.556885
          ],
          [
            14.610828,
            52.581034,
            50.465219
          ],
          [
            14.611024,
            52.580883,
            50.378629
          ],
          [
            14.611224,
            52.580684,
            50.274747
          ],
          [
            14.611478,
            52.580476,
            50.159281
          ],
          [
            14.611686,
            52.580283,
            50.211813
          ],
          [
            14.611949,
            52.580061,
            50.293424
          ],
          [
            14.612152,
            52.579883,
            50.358077
          ],
          [
            14.612348,
            52.579728,
            50.416534
          ],
          [
            14.612638,
            52.579525,
            50.496906
          ],
          [
            14.612921,
            52.579313,
            50.578351
          ],
          [
            14.61315,
            52.579177,
            50.636402
          ],
          [
            14.613385,
            52.579039,
            50.703498
          ],
          [
            14.61366,
            52.578895,
            50.823014
          ],
          [
            14.613903,
            52.578753,
            50.934521
          ],
          [
            14.614172,
            52.578628,
            51.045936
          ],
          [
            14.614475,
            52.578489,
            51.170872
          ],
          [
            14.614742,
            52.578368,
            51.280402
          ],
          [
            14.615032,
            52.57819,
            51.416376
          ],
          [
            14.615274,
            52.578035,
            51.532007
          ],
          [
            14.615512,
            52.577881,
            51.646454
          ],
          [
            14.615752,
            52.577705,
            51.727912
          ],
          [
            14.616029,
            52.577507,
            51.815139
          ],
          [
            14.616247,
            52.57737,
            51.878984
          ],
          [
            14.616432,
            52.577223,
            51.940977
          ],
          [
            14.616691,
            52.577069,
            52.014887
          ],
          [
            14.616858,
            52.57691,
            52.07834
          ],
          [
            14.617093,
            52.576756,
            52.148654
          ],
          [
            14.617337,
            52.57655,
            52.233618
          ],
          [
            14.617552,
            52.576389,
            52.254175
          ],
          [
            14.617808,
            52.576232,
            52.241274
          ],
          [
            14.618009,
            52.576086,
            52.230185
          ],
          [
            14.618204,
            52.575933,
            52.2189
          ],
          [
            14.61844,
            52.575731,
            52.204441
          ],
          [
            14.618725,
            52.575526,
            52.188809
          ],
          [
            14.618946,
            52.575385,
            52.17746
          ],
          [
            14.619191,
            52.575225,
            52.164718
          ],
          [
            14.619466,
            52.575041,
            52.142454
          ],
          [
            14.619703,
            52.574865,
            52.113083
          ],
          [
            14.61985,
            52.574679,
            52.086329
          ],
          [
            14.619607,
            52.574512,
            52.057526
          ],
          [
            14.619315,
            52.57433,
            52.024679
          ],
          [
            14.619083,
            52.574165,
            51.996667
          ],
          [
            14.618841,
            52.573999,
            51.968045
          ],
          [
            14.618607,
            52.573846,
            51.940986
          ],
          [
            14.618407,
            52.573676,
            51.826757
          ],
          [
            14.618198,
            52.573504,
            51.568897
          ],
          [
            14.617978,
            52.573351,
            51.32482
          ],
          [
            14.617724,
            52.573215,
            51.075588
          ],
          [
            14.61748,
            52.57306,
            50.8176
          ],
          [
            14.61724,
            52.572911,
            50.565476
          ],
          [
            14.616982,
            52.572767,
            50.309114
          ],
          [
            14.61672,
            52.57265,
            50.071376
          ],
          [
            14.616421,
            52.572516,
            49.799317
          ],
          [
            14.616165,
            52.572391,
            49.662245
          ],
          [
            14.615876,
            52.572238,
            49.522536
          ],
          [
            14.61564,
            52.572098,
            49.401436
          ],
          [
            14.615349,
            52.571979,
            49.273074
          ],
          [
            14.615047,
            52.57184,
            49.134705
          ],
          [
            14.614783,
            52.571686,
            49.001605
          ],
          [
            14.614769,
            52.571525,
            48.886212
          ],
          [
            14.614932,
            52.571345,
            48.76301
          ],
          [
            14.615678,
            52.57078,
            49.398261
          ],
          [
            14.615869,
            52.570639,
            49.625261
          ],
          [
            14.616148,
            52.570746,
            49.862743
          ],
          [
            14.616424,
            52.570862,
            50.104735
          ],
          [
            14.616708,
            52.571008,
            50.37279
          ],
          [
            14.617033,
            52.571119,
            50.641161
          ],
          [
            14.61738,
            52.571201,
            50.793942
          ],
          [
            14.61773,
            52.571241,
            50.726175
          ],
          [
            14.618074,
            52.571276,
            50.659711
          ],
          [
            14.618388,
            52.571284,
            50.600094
          ],
          [
            14.618751,
            52.571294,
            50.531031
          ],
          [
            14.619116,
            52.571295,
            50.461806
          ],
          [
            14.619466,
            52.571303,
            50.395021
          ],
          [
            14.619808,
            52.571375,
            50.326341
          ],
          [
            14.620089,
            52.571475,
            50.264519
          ],
          [
            14.620386,
            52.571624,
            50.308636
          ],
          [
            14.620569,
            52.571828,
            50.366262
          ],
          [
            14.62066,
            52.572028,
            50.417476
          ],
          [
            14.620649,
            52.57227,
            50.477345
          ],
          [
            14.620639,
            52.572493,
            50.532407
          ],
          [
            14.620632,
            52.572711,
            50.586228
          ],
          [
            14.620598,
            52.572927,
            50.639797
          ],
          [
            14.620572,
            52.573142,
            50.693012
          ],
          [
            14.620558,
            52.57338,
            50.734065
          ],
          [
            14.620571,
            52.573644,
            50.776942
          ],
          [
            14.620625,
            52.573902,
            50.818892
          ],
          [
            14.620834,
            52.574108,
            50.858592
          ],
          [
            14.62118,
            52.574207,
            50.896581
          ],
          [
            14.621531,
            52.574284,
            50.93314
          ],
          [
            14.621866,
            52.57435,
            50.967692
          ],
          [
            14.622205,
            52.574431,
            51.026353
          ],
          [
            14.622542,
            52.574505,
            51.124271
          ],
          [
            14.622855,
            52.574565,
            51.21394
          ],
          [
            14.623138,
            52.574637,
            51.297799
          ],
          [
            14.623356,
            52.574794,
            51.39062
          ],
          [
            14.623539,
            52.574955,
            51.478593
          ],
          [
            14.623753,
            52.575112,
            51.570292
          ],
          [
            14.623937,
            52.57527,
            51.65762
          ],
          [
            14.624161,
            52.575488,
            51.773275
          ],
          [
            14.624454,
            52.57564,
            51.892748
          ],
          [
            14.624697,
            52.575803,
            52.009353
          ],
          [
            14.62491,
            52.575981,
            52.126055
          ],
          [
            14.625173,
            52.57617,
            52.257499
          ],
          [
            14.625411,
            52.576355,
            52.382386
          ],
          [
            14.625634,
            52.576516,
            52.493966
          ],
          [
            14.625838,
            52.576678,
            52.602102
          ],
          [
            14.626073,
            52.57683,
            52.712753
          ],
          [
            14.626275,
            52.577013,
            52.880636
          ],
          [
            14.626484,
            52.577173,
            53.062029
          ],
          [
            14.626728,
            52.57732,
            53.246148
          ],
          [
            14.626995,
            52.577522,
            53.474381
          ],
          [
            14.627278,
            52.577706,
            53.696284
          ],
          [
            14.627522,
            52.577847,
            53.88411
          ],
          [
            14.627778,
            52.577942,
            54.059901
          ],
          [
            14.628005,
            52.57812,
            54.258568
          ],
          [
            14.628191,
            52.578273,
            54.677998
          ],
          [
            14.628348,
            52.578464,
            55.396483
          ],
          [
            14.6285,
            52.578642,
            56.07279
          ],
          [
            14.62869,
            52.578816,
            56.775049
          ],
          [
            14.628855,
            52.578996,
            57.467882
          ],
          [
            14.629006,
            52.579185,
            58.175019
          ],
          [
            14.629174,
            52.579361,
            58.859385
          ],
          [
            14.629199,
            52.57938,
            59.530572
          ],
          [
            14.629245,
            52.579475,
            60.427791
          ],
          [
            14.629438,
            52.579644,
            60.901627
          ],
          [
            14.629662,
            52.579889,
            61.546171
          ],
          [
            14.629827,
            52.580074,
            62.029967
          ],
          [
            14.629936,
            52.58025,
            62.467981
          ],
          [
            14.630152,
            52.580403,
            62.931515
          ],
          [
            14.630371,
            52.580563,
            63.409924
          ],
          [
            14.630578,
            52.580704,
            63.844292
          ],
          [
            14.630819,
            52.580859,
            64.334488
          ],
          [
            14.631109,
            52.580952,
            64.084831
          ],
          [
            14.631389,
            52.581013,
            63.43272
          ],
          [
            14.631708,
            52.58106,
            62.715605
          ],
          [
            14.632033,
            52.581088,
            61.9985
          ],
          [
            14.632356,
            52.581124,
            61.28115
          ],
          [
            14.632784,
            52.5811,
            60.336909
          ],
          [
            14.633146,
            52.581148,
            59.525087
          ],
          [
            14.633481,
            52.581209,
            58.754229
          ],
          [
            14.633851,
            52.581262,
            58.04941
          ],
          [
            14.634161,
            52.581273,
            58.029756
          ],
          [
            14.634501,
            52.581224,
            58.007455
          ],
          [
            14.634796,
            52.581149,
            57.987264
          ],
          [
            14.635079,
            52.581065,
            57.967384
          ],
          [
            14.635395,
            52.580989,
            57.94597
          ],
          [
            14.635719,
            52.580981,
            57.924283
          ],
          [
            14.635978,
            52.581077,
            57.903881
          ],
          [
            14.636311,
            52.581004,
            57.881579
          ],
          [
            14.636688,
            52.580914,
            57.872826
          ],
          [
            14.637056,
            52.580834,
            57.886917
          ],
          [
            14.63737,
            52.580745,
            57.899401
          ],
          [
            14.637699,
            52.580637,
            57.91287
          ],
          [
            14.638028,
            52.58053,
            57.92631
          ],
          [
            14.638331,
            52.580401,
            57.939637
          ],
          [
            14.638636,
            52.580258,
            57.953513
          ],
          [
            14.638908,
            52.580113,
            57.966561
          ],
          [
            14.639156,
            52.579962,
            58.025481
          ],
          [
            14.639374,
            52.579798,
            58.136518
          ],
          [
            14.639261,
            52.579637,
            58.234478
          ],
          [
            14.639147,
            52.579502,
            58.347724
          ],
          [
            14.639028,
            52.579335,
            58.447037
          ],
          [
            14.639244,
            52.579492,
            58.55649
          ],
          [
            14.639266,
            52.579649,
            58.656307
          ],
          [
            14.63965,
            52.579579,
            58.787947
          ],
          [
            14.639895,
            52.579453,
            58.893864
          ],
          [
            14.639773,
            52.579641,
            58.850918
          ],
          [
            14.639838,
            52.579807,
            58.766458
          ],
          [
            14.640099,
            52.579945,
            58.670377
          ],
          [
            14.640377,
            52.580084,
            58.570387
          ],
          [
            14.640665,
            52.580189,
            58.476362
          ],
          [
            14.640742,
            52.579996,
            58.369616
          ],
          [
            14.640631,
            52.579808,
            58.278074
          ],
          [
            14.640545,
            52.57957,
            58.166377
          ],
          [
            14.640553,
            52.57934,
            58.131498
          ],
          [
            14.640618,
            52.579114,
            58.223569
          ],
          [
            14.640733,
            52.57891,
            58.310116
          ],
          [
            14.641007,
            52.578821,
            58.391319
          ],
          [
            14.641166,
            52.578647,
            58.475345
          ],
          [
            14.641253,
            52.578442,
            58.560416
          ],
          [
            14.641331,
            52.578242,
            58.642958
          ],
          [
            14.64133,
            52.578231,
            58.735973
          ],
          [
            14.641289,
            52.578432,
            58.818315
          ],
          [
            14.641166,
            52.578656,
            58.812148
          ],
          [
            14.64107,
            52.57884,
            58.805309
          ],
          [
            14.64075,
            52.57889,
            58.798104
          ],
          [
            14.640611,
            52.579103,
            58.789968
          ],
          [
            14.640539,
            52.579291,
            58.783126
          ],
          [
            14.640517,
            52.579491,
            58.775982
          ],
          [
            14.640548,
            52.579682,
            58.769172
          ],
          [
            14.640611,
            52.579877,
            58.762126
          ],
          [
            14.640672,
            52.580092,
            58.826123
          ],
          [
            14.640686,
            52.580295,
            59.052368
          ],
          [
            14.640359,
            52.580275,
            59.290291
          ],
          [
            14.640094,
            52.580126,
            59.533994
          ],
          [
            14.639852,
            52.580009,
            59.742736
          ],
          [
            14.639607,
            52.579893,
            59.952771
          ],
          [
            14.639329,
            52.579966,
            60.173806
          ],
          [
            14.639067,
            52.580133,
            60.430271
          ],
          [
            14.638786,
            52.580279,
            60.679791
          ],
          [
            14.638492,
            52.580423,
            60.565662
          ],
          [
            14.638194,
            52.580549,
            60.309181
          ],
          [
            14.637856,
            52.58067,
            60.031575
          ],
          [
            14.637545,
            52.580801,
            59.764428
          ],
          [
            14.637212,
            52.580918,
            59.492884
          ],
          [
            14.636905,
            52.581039,
            59.23458
          ],
          [
            14.636554,
            52.581164,
            58.94738
          ],
          [
            14.636207,
            52.581281,
            58.667209
          ],
          [
            14.635828,
            52.581385,
            58.889884
          ],
          [
            14.635507,
            52.581508,
            59.097165
          ],
          [
            14.635179,
            52.581632,
            59.307674
          ],
          [
            14.634849,
            52.58175,
            59.518255
          ],
          [
            14.634514,
            52.581851,
            59.722164
          ],
          [
            14.634171,
            52.581855,
            59.91215
          ],
          [
            14.633817,
            52.581841,
            60.107219
          ],
          [
            14.633439,
            52.581812,
            60.32031
          ],
          [
            14.633132,
            52.581731,
            60.529003
          ],
          [
            14.632823,
            52.581623,
            60.75013
          ],
          [
            14.632553,
            52.581511,
            60.954153
          ],
          [
            14.632474,
            52.581322,
            61.156093
          ],
          [
            14.632145,
            52.58121,
            61.39032
          ],
          [
            14.631889,
            52.581096,
            61.593471
          ],
          [
            14.631564,
            52.581074,
            61.796975
          ],
          [
            14.631254,
            52.580995,
            62.005474
          ],
          [
            14.630956,
            52.580889,
            62.216394
          ],
          [
            14.63069,
            52.580765,
            62.418856
          ],
          [
            14.630459,
            52.580615,
            62.622376
          ],
          [
            14.630232,
            52.580454,
            62.832659
          ],
          [
            14.630043,
            52.580298,
            63.024457
          ],
          [
            14.629882,
            52.580128,
            63.218655
          ],
          [
            14.629707,
            52.579919,
            63.450729
          ],
          [
            14.629534,
            52.579734,
            63.66131
          ],
          [
            14.629336,
            52.579532,
            63.891866
          ],
          [
            14.629175,
            52.579355,
            63.577279
          ],
          [
            14.628996,
            52.579154,
            63.220952
          ],
          [
            14.628813,
            52.578965,
            62.879424
          ],
          [
            14.628614,
            52.578769,
            62.521049
          ],
          [
            14.62845,
            52.578567,
            62.169683
          ],
          [
            14.628282,
            52.578398,
            61.862102
          ],
          [
            14.628121,
            52.578228,
            61.556367
          ],
          [
            14.627828,
            52.578047,
            61.161308
          ],
          [
            14.627521,
            52.577876,
            60.941794
          ],
          [
            14.627245,
            52.577696,
            60.764152
          ],
          [
            14.626944,
            52.577531,
            60.586977
          ],
          [
            14.626744,
            52.577339,
            60.422537
          ],
          [
            14.62648,
            52.577187,
            60.263331
          ],
          [
            14.626258,
            52.577011,
            60.103767
          ],
          [
            14.626018,
            52.576845,
            59.944723
          ],
          [
            14.625801,
            52.57667,
            59.81005
          ],
          [
            14.625554,
            52.57648,
            59.897733
          ],
          [
            14.625328,
            52.576324,
            59.973009
          ],
          [
            14.62513,
            52.576162,
            60.046095
          ],
          [
            14.624879,
            52.576013,
            60.123389
          ],
          [
            14.624665,
            52.575843,
            60.201015
          ],
          [
            14.624443,
            52.575694,
            60.273915
          ],
          [
            14.624206,
            52.575514,
            60.357368
          ],
          [
            14.62395,
            52.575326,
            60.445703
          ],
          [
            14.623704,
            52.575143,
            60.422597
          ],
          [
            14.623457,
            52.574945,
            60.386861
          ],
          [
            14.62323,
            52.574783,
            60.356054
          ],
          [
            14.62294,
            52.574678,
            60.326462
          ],
          [
            14.622588,
            52.57459,
            60.293199
          ],
          [
            14.622223,
            52.574496,
            60.258538
          ],
          [
            14.621877,
            52.574417,
            60.225997
          ],
          [
            14.621569,
            52.574314,
            60.195225
          ],
          [
            14.621219,
            52.574229,
            59.772449
          ],
          [
            14.620897,
            52.574158,
            59.385203
          ],
          [
            14.620643,
            52.574013,
            58.989298
          ],
          [
            14.620611,
            52.573826,
            58.639251
          ],
          [
            14.620592,
            52.573605,
            58.227473
          ],
          [
            14.620578,
            52.573387,
            57.821632
          ],
          [
            14.620596,
            52.573157,
            57.393385
          ],
          [
            14.620607,
            52.57293,
            56.970882
          ],
          [
            14.620586,
            52.572689,
            56.910026
          ],
          [
            14.620587,
            52.572451,
            56.991321
          ],
          [
            14.62058,
            52.572234,
            57.065456
          ],
          [
            14.620566,
            52.572005,
            57.143753
          ],
          [
            14.620479,
            52.571798,
            57.217343
          ],
          [
            14.620305,
            52.57163,
            57.285732
          ],
          [
            14.619998,
            52.57149,
            57.365419
          ],
          [
            14.619716,
            52.57139,
            57.433444
          ],
          [
            14.619352,
            52.571303,
            57.479265
          ],
          [
            14.618954,
            52.571294,
            57.503855
          ],
          [
            14.618579,
            52.571273,
            57.527092
          ],
          [
            14.618204,
            52.571246,
            57.550413
          ],
          [
            14.617831,
            52.571251,
            57.573546
          ],
          [
            14.617475,
            52.571226,
            57.595708
          ],
          [
            14.617109,
            52.571133,
            57.620185
          ],
          [
            14.616785,
            52.571035,
            57.642492
          ],
          [
            14.616468,
            52.570894,
            57.654207
          ],
          [
            14.616186,
            52.570786,
            57.662015
          ],
          [
            14.615909,
            52.570675,
            57.669792
          ],
          [
            14.615703,
            52.570779,
            57.677468
          ],
          [
            14.615501,
            52.570959,
            57.685902
          ],
          [
            14.614826,
            52.571435,
            57.710116
          ],
          [
            14.614619,
            52.571597,
            57.723908
          ],
          [
            14.614791,
            52.57178,
            57.755569
          ],
          [
            14.615121,
            52.57192,
            57.790208
          ],
          [
            14.615429,
            52.572074,
            57.824519
          ],
          [
            14.6157,
            52.572215,
            57.855425
          ],
          [
            14.616006,
            52.572336,
            57.887039
          ],
          [
            14.616317,
            52.572479,
            57.92069
          ],
          [
            14.616605,
            52.572589,
            57.950157
          ],
          [
            14.616837,
            52.572716,
            57.840517
          ],
          [
            14.617115,
            52.572874,
            57.255887
          ],
          [
            14.617364,
            52.573019,
            56.727973
          ],
          [
            14.617614,
            52.573183,
            56.16513
          ],
          [
            14.617831,
            52.573323,
            55.680689
          ],
          [
            14.618077,
            52.57351,
            55.077907
          ],
          [
            14.618264,
            52.573664,
            54.593978
          ],
          [
            14.618538,
            52.573823,
            54.014098
          ],
          [
            14.618804,
            52.573996,
            53.455694
          ],
          [
            14.619042,
            52.574163,
            53.759507
          ],
          [
            14.61924,
            52.5743,
            54.010235
          ],
          [
            14.619512,
            52.574504,
            54.371397
          ],
          [
            14.619767,
            52.574686,
            54.700521
          ],
          [
            14.619675,
            52.574896,
            55.021666
          ],
          [
            14.619449,
            52.575045,
            55.30031
          ],
          [
            14.619228,
            52.575206,
            55.589082
          ],
          [
            14.618983,
            52.575366,
            55.88964
          ],
          [
            14.618749,
            52.575537,
            56.13709
          ],
          [
            14.618533,
            52.57569,
            56.356185
          ],
          [
            14.618332,
            52.575843,
            56.568958
          ],
          [
            14.61813,
            52.575994,
            56.780659
          ],
          [
            14.61795,
            52.57616,
            56.996818
          ],
          [
            14.617719,
            52.576332,
            57.238198
          ],
          [
            14.617499,
            52.576507,
            57.477685
          ],
          [
            14.617226,
            52.576677,
            57.735865
          ],
          [
            14.616985,
            52.57687,
            57.914435
          ],
          [
            14.616726,
            52.577046,
            58.002751
          ],
          [
            14.616504,
            52.577231,
            58.088416
          ],
          [
            14.616274,
            52.577392,
            58.168114
          ],
          [
            14.616048,
            52.577539,
            58.243297
          ],
          [
            14.615818,
            52.577708,
            58.325399
          ],
          [
            14.615595,
            52.577865,
            58.402894
          ],
          [
            14.615367,
            52.578037,
            58.485424
          ],
          [
            14.615117,
            52.578196,
            58.525809
          ],
          [
            14.61489,
            52.578329,
            58.480535
          ],
          [
            14.61466,
            52.578465,
            58.434473
          ],
          [
            14.614388,
            52.578594,
            58.384951
          ],
          [
            14.614102,
            52.578712,
            58.33529
          ],
          [
            14.613809,
            52.578843,
            58.282882
          ],
          [
            14.613549,
            52.578998,
            58.230544
          ],
          [
            14.613311,
            52.579128,
            58.18454
          ],
          [
            14.613065,
            52.579262,
            58.137123
          ],
          [
            14.612862,
            52.579399,
            58.266627
          ],
          [
            14.612664,
            52.579533,
            58.536568
          ],
          [
            14.612441,
            52.579719,
            58.880978
          ],
          [
            14.612235,
            52.579878,
            59.183737
          ],
          [
            14.612343,
            52.580017,
            59.495949
          ],
          [
            14.612523,
            52.580133,
            59.78083
          ],
          [
            14.612541,
            52.580333,
            60.080516
          ],
          [
            14.612555,
            52.580528,
            60.3725
          ],
          [
            14.612555,
            52.580755,
            60.712363
          ],
          [
            14.612585,
            52.580968,
            60.410333
          ],
          [
            14.61257,
            52.581187,
            59.827942
          ],
          [
            14.612608,
            52.581384,
            59.302477
          ],
          [
            14.612658,
            52.581608,
            58.704147
          ],
          [
            14.612698,
            52.581845,
            58.073731
          ],
          [
            14.612751,
            52.58205,
            57.524251
          ],
          [
            14.612813,
            52.582271,
            56.930842
          ],
          [
            14.612873,
            52.582469,
            56.398155
          ],
          [
            14.612945,
            52.582657,
            56.029737
          ],
          [
            14.613018,
            52.582862,
            55.96506
          ],
          [
            14.613093,
            52.583087,
            55.894265
          ],
          [
            14.613131,
            52.583318,
            55.821749
          ],
          [
            14.612888,
            52.583452,
            55.759357
          ],
          [
            14.612919,
            52.583633,
            55.702829
          ],
          [
            14.612835,
            52.583804,
            55.643781
          ],
          [
            14.612568,
            52.583895,
            55.586084
          ],
          [
            14.612509,
            52.584048,
            55.529558
          ],
          [
            14.612508,
            52.584241,
            55.494056
          ],
          [
            14.612316,
            52.584381,
            55.494056
          ],
          [
            14.611991,
            52.584436,
            55.494056
          ],
          [
            14.612296,
            52.58428,
            55.494056
          ],
          [
            14.612501,
            52.584143,
            55.494056
          ],
          [
            14.61273,
            52.58399,
            55.494056
          ],
          [
            14.612523,
            52.584097,
            55.494056
          ],
          [
            14.612379,
            52.584268,
            55.494056
          ],
          [
            14.612109,
            52.58435,
            55.494056
          ],
          [
            14.612062,
            52.584388,
            55.494056
          ],
          [
            14.612022,
            52.584346,
            55.494056
          ]
        ]
      }
    }
  ]
}

let day41: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            14.612525,
            52.584024,
            51.888488
          ],
          [
            14.612697,
            52.583859,
            51.888488
          ],
          [
            14.612926,
            52.583721,
            51.888488
          ],
          [
            14.612752,
            52.58357,
            51.888488
          ],
          [
            14.612775,
            52.583662,
            51.888488
          ],
          [
            14.61279,
            52.583852,
            51.868805
          ],
          [
            14.6129,
            52.583665,
            51.819457
          ],
          [
            14.612882,
            52.583471,
            51.772302
          ],
          [
            14.613084,
            52.583344,
            51.725269
          ],
          [
            14.613117,
            52.583157,
            51.678505
          ],
          [
            14.613016,
            52.582949,
            51.626548
          ],
          [
            14.612942,
            52.582748,
            51.577206
          ],
          [
            14.612881,
            52.582542,
            51.526959
          ],
          [
            14.612808,
            52.582359,
            51.481789
          ],
          [
            14.612758,
            52.582167,
            51.586774
          ],
          [
            14.612697,
            52.581968,
            51.86668
          ],
          [
            14.612635,
            52.581773,
            52.141508
          ],
          [
            14.612573,
            52.58158,
            52.413351
          ],
          [
            14.612524,
            52.581389,
            52.680743
          ],
          [
            14.612517,
            52.581196,
            52.94767
          ],
          [
            14.612534,
            52.580982,
            53.24387
          ],
          [
            14.61255,
            52.580778,
            53.526337
          ],
          [
            14.612524,
            52.580562,
            53.82591
          ],
          [
            14.612498,
            52.580343,
            53.975212
          ],
          [
            14.612505,
            52.580149,
            54.020304
          ],
          [
            14.612382,
            52.579976,
            54.068479
          ],
          [
            14.612175,
            52.579888,
            54.113244
          ],
          [
            14.612362,
            52.57974,
            54.156585
          ],
          [
            14.612584,
            52.5796,
            54.201745
          ],
          [
            14.612798,
            52.579432,
            54.251085
          ],
          [
            14.61303,
            52.579268,
            54.301327
          ],
          [
            14.613286,
            52.579087,
            54.357048
          ],
          [
            14.613553,
            52.578933,
            54.278129
          ],
          [
            14.613831,
            52.578796,
            54.188723
          ],
          [
            14.614102,
            52.578671,
            54.10374
          ],
          [
            14.614364,
            52.578553,
            54.02228
          ],
          [
            14.614614,
            52.578439,
            53.944114
          ],
          [
            14.614852,
            52.578306,
            53.863311
          ],
          [
            14.615082,
            52.578158,
            53.779636
          ],
          [
            14.615296,
            52.578012,
            53.699256
          ],
          [
            14.615511,
            52.577879,
            53.622621
          ],
          [
            14.615715,
            52.577736,
            53.745568
          ],
          [
            14.61593,
            52.577582,
            53.877452
          ],
          [
            14.616158,
            52.577424,
            54.014538
          ],
          [
            14.616387,
            52.577259,
            54.155317
          ],
          [
            14.616621,
            52.577091,
            54.298881
          ],
          [
            14.616859,
            52.576931,
            54.439532
          ],
          [
            14.616833,
            52.576932,
            54.576785
          ],
          [
            14.616634,
            52.577081,
            54.702152
          ],
          [
            14.61683,
            52.576897,
            54.780149
          ],
          [
            14.617084,
            52.576752,
            54.739028
          ],
          [
            14.617282,
            52.576612,
            54.703185
          ],
          [
            14.617512,
            52.576454,
            54.662072
          ],
          [
            14.617722,
            52.576284,
            54.620781
          ],
          [
            14.617946,
            52.576147,
            54.583268
          ],
          [
            14.618167,
            52.576,
            54.544608
          ],
          [
            14.618368,
            52.575835,
            54.504697
          ],
          [
            14.618565,
            52.57566,
            54.463488
          ],
          [
            14.618781,
            52.575516,
            54.199783
          ],
          [
            14.619015,
            52.575354,
            53.697305
          ],
          [
            14.619254,
            52.575192,
            53.190029
          ],
          [
            14.619492,
            52.575035,
            52.69221
          ],
          [
            14.619729,
            52.574891,
            52.217458
          ],
          [
            14.619773,
            52.574684,
            51.699009
          ],
          [
            14.619524,
            52.574539,
            51.210379
          ],
          [
            14.619275,
            52.57439,
            50.715353
          ],
          [
            14.619056,
            52.574226,
            50.211576
          ],
          [
            14.618833,
            52.574071,
            49.552259
          ],
          [
            14.618622,
            52.573923,
            48.924566
          ],
          [
            14.618413,
            52.573736,
            48.200606
          ],
          [
            14.618187,
            52.573588,
            47.553967
          ],
          [
            14.617931,
            52.573408,
            46.79139
          ],
          [
            14.617715,
            52.573276,
            46.195238
          ],
          [
            14.617491,
            52.573133,
            45.56254
          ],
          [
            14.61726,
            52.572961,
            44.85136
          ],
          [
            14.617003,
            52.572814,
            44.633326
          ],
          [
            14.616699,
            52.572662,
            44.956561
          ],
          [
            14.616444,
            52.572552,
            45.213228
          ],
          [
            14.616158,
            52.572418,
            45.50981
          ],
          [
            14.615883,
            52.572274,
            45.807714
          ],
          [
            14.615604,
            52.572158,
            46.085112
          ],
          [
            14.615328,
            52.572006,
            46.391655
          ],
          [
            14.615038,
            52.571854,
            46.705927
          ],
          [
            14.614779,
            52.571727,
            47.052597
          ],
          [
            14.61472,
            52.571562,
            47.776793
          ],
          [
            14.614888,
            52.571384,
            48.407508
          ],
          [
            14.615525,
            52.57087,
            50.385094
          ],
          [
            14.615731,
            52.570718,
            50.997556
          ],
          [
            14.616041,
            52.570752,
            51.644718
          ],
          [
            14.616321,
            52.570865,
            52.272426
          ],
          [
            14.616576,
            52.570986,
            52.505243
          ],
          [
            14.61685,
            52.571095,
            52.585223
          ],
          [
            14.617142,
            52.571184,
            52.664917
          ],
          [
            14.617452,
            52.571245,
            52.744445
          ],
          [
            14.617779,
            52.571272,
            52.825134
          ],
          [
            14.618077,
            52.571259,
            52.898067
          ],
          [
            14.61839,
            52.571247,
            52.974714
          ],
          [
            14.618754,
            52.571245,
            53.063868
          ],
          [
            14.619081,
            52.571232,
            53.14385
          ],
          [
            14.619389,
            52.571258,
            53.506224
          ],
          [
            14.619693,
            52.571331,
            54.057533
          ],
          [
            14.619984,
            52.571448,
            54.647217
          ],
          [
            14.620259,
            52.571584,
            55.24714
          ],
          [
            14.620477,
            52.571745,
            55.82783
          ],
          [
            14.620586,
            52.571954,
            56.44031
          ],
          [
            14.620586,
            52.572194,
            57.107372
          ],
          [
            14.620567,
            52.572425,
            57.749227
          ],
          [
            14.62057,
            52.572653,
            58.02571
          ],
          [
            14.620567,
            52.572903,
            57.593076
          ],
          [
            14.620577,
            52.573146,
            57.172627
          ],
          [
            14.620572,
            52.573382,
            56.763928
          ],
          [
            14.620562,
            52.573613,
            56.363963
          ],
          [
            14.620585,
            52.573858,
            55.939149
          ],
          [
            14.620672,
            52.574086,
            55.533505
          ],
          [
            14.620983,
            52.5742,
            55.141183
          ],
          [
            14.621325,
            52.574264,
            55.082006
          ],
          [
            14.621663,
            52.574339,
            55.121917
          ],
          [
            14.621997,
            52.574367,
            55.159358
          ],
          [
            14.622331,
            52.574457,
            55.199909
          ],
          [
            14.622671,
            52.574546,
            55.241009
          ],
          [
            14.622995,
            52.574633,
            55.280306
          ],
          [
            14.623301,
            52.574751,
            55.320729
          ],
          [
            14.6235,
            52.57493,
            55.360258
          ],
          [
            14.623675,
            52.575111,
            55.464243
          ],
          [
            14.623958,
            52.575206,
            55.626477
          ],
          [
            14.62415,
            52.575353,
            55.781635
          ],
          [
            14.624364,
            52.575546,
            55.973661
          ],
          [
            14.624593,
            52.575713,
            56.152986
          ],
          [
            14.624849,
            52.575901,
            56.354253
          ],
          [
            14.625116,
            52.576094,
            56.562241
          ],
          [
            14.625345,
            52.576265,
            56.744164
          ],
          [
            14.625602,
            52.576444,
            56.932169
          ],
          [
            14.625844,
            52.576639,
            57.112745
          ],
          [
            14.626107,
            52.576831,
            57.297422
          ],
          [
            14.626299,
            52.576984,
            57.440569
          ],
          [
            14.626559,
            52.577144,
            57.606794
          ],
          [
            14.626767,
            52.577317,
            57.766251
          ],
          [
            14.627015,
            52.577483,
            57.932163
          ],
          [
            14.627227,
            52.577631,
            58.077415
          ],
          [
            14.627474,
            52.577781,
            58.092911
          ],
          [
            14.627674,
            52.577959,
            57.711258
          ],
          [
            14.627916,
            52.578098,
            57.353319
          ],
          [
            14.628134,
            52.578239,
            57.011173
          ],
          [
            14.628297,
            52.578415,
            56.65337
          ],
          [
            14.628456,
            52.578615,
            56.260446
          ],
          [
            14.628609,
            52.578785,
            55.917757
          ],
          [
            14.628767,
            52.57897,
            55.54916
          ],
          [
            14.62893,
            52.579147,
            55.19032
          ],
          [
            14.629089,
            52.579316,
            54.935574
          ],
          [
            14.629254,
            52.579475,
            54.781972
          ],
          [
            14.629417,
            52.579643,
            54.623001
          ],
          [
            14.629601,
            52.579851,
            54.430482
          ],
          [
            14.629757,
            52.580013,
            54.27731
          ],
          [
            14.629914,
            52.580184,
            54.117615
          ],
          [
            14.630083,
            52.580354,
            53.955723
          ],
          [
            14.630317,
            52.580521,
            53.776953
          ],
          [
            14.630564,
            52.580696,
            53.589041
          ],
          [
            14.630849,
            52.580834,
            53.852203
          ],
          [
            14.631169,
            52.580954,
            54.262191
          ],
          [
            14.631477,
            52.581019,
            54.617112
          ],
          [
            14.631819,
            52.581074,
            55.002497
          ],
          [
            14.632171,
            52.581108,
            55.390771
          ],
          [
            14.632502,
            52.581112,
            55.751383
          ],
          [
            14.632821,
            52.581111,
            56.098605
          ],
          [
            14.633179,
            52.581176,
            56.505458
          ],
          [
            14.633495,
            52.581221,
            56.737255
          ],
          [
            14.633845,
            52.581259,
            56.592114
          ],
          [
            14.634237,
            52.581266,
            56.449444
          ],
          [
            14.634642,
            52.581185,
            56.294612
          ],
          [
            14.635031,
            52.58109,
            56.142405
          ],
          [
            14.635381,
            52.581,
            56.004284
          ],
          [
            14.635718,
            52.581072,
            55.868621
          ],
          [
            14.63599,
            52.581112,
            55.760411
          ],
          [
            14.636321,
            52.581018,
            55.602309
          ],
          [
            14.636677,
            52.580929,
            55.408148
          ],
          [
            14.637032,
            52.580839,
            55.214151
          ],
          [
            14.63737,
            52.580745,
            55.026682
          ],
          [
            14.63769,
            52.580642,
            54.844039
          ],
          [
            14.638014,
            52.580526,
            54.654291
          ],
          [
            14.638304,
            52.580403,
            54.475738
          ],
          [
            14.63858,
            52.580272,
            54.299107
          ],
          [
            14.638843,
            52.580129,
            54.388337
          ],
          [
            14.63909,
            52.579978,
            54.809096
          ],
          [
            14.639312,
            52.579817,
            55.224217
          ],
          [
            14.639306,
            52.579652,
            55.582668
          ],
          [
            14.639042,
            52.579531,
            55.980322
          ],
          [
            14.63878,
            52.579409,
            56.379047
          ],
          [
            14.638903,
            52.579499,
            56.80367
          ],
          [
            14.639024,
            52.579311,
            57.20333
          ],
          [
            14.639249,
            52.579176,
            57.603861
          ],
          [
            14.63951,
            52.579322,
            57.68519
          ],
          [
            14.639308,
            52.579482,
            57.58683
          ],
          [
            14.639472,
            52.579636,
            57.490187
          ],
          [
            14.639703,
            52.579517,
            57.396582
          ],
          [
            14.639859,
            52.579339,
            57.299157
          ],
          [
            14.640023,
            52.579173,
            57.205556
          ],
          [
            14.640202,
            52.578981,
            57.098914
          ],
          [
            14.640375,
            52.578771,
            56.985419
          ],
          [
            14.640537,
            52.578533,
            56.880576
          ],
          [
            14.640665,
            52.578295,
            56.858933
          ],
          [
            14.640779,
            52.578037,
            56.83584
          ],
          [
            14.640879,
            52.577787,
            56.813601
          ],
          [
            14.640979,
            52.577529,
            56.790691
          ],
          [
            14.640996,
            52.577249,
            56.766442
          ],
          [
            14.640959,
            52.577053,
            56.749238
          ],
          [
            14.640935,
            52.576849,
            56.731554
          ],
          [
            14.640879,
            52.576592,
            56.585886
          ],
          [
            14.640753,
            52.576394,
            56.453834
          ],
          [
            14.640608,
            52.576225,
            56.332812
          ],
          [
            14.640677,
            52.57602,
            56.204589
          ],
          [
            14.640609,
            52.575801,
            56.067844
          ],
          [
            14.640693,
            52.575585,
            55.931396
          ],
          [
            14.640833,
            52.575393,
            55.802692
          ],
          [
            14.640986,
            52.575196,
            55.669237
          ],
          [
            14.641164,
            52.574991,
            55.571147
          ],
          [
            14.641324,
            52.574814,
            55.501606
          ],
          [
            14.641621,
            52.574875,
            55.430005
          ],
          [
            14.641922,
            52.574802,
            55.361827
          ],
          [
            14.642228,
            52.574805,
            55.297628
          ],
          [
            14.64254,
            52.574746,
            55.228223
          ],
          [
            14.64282,
            52.5746,
            55.151005
          ],
          [
            14.643122,
            52.574452,
            55.06979
          ],
          [
            14.643417,
            52.574277,
            55.113911
          ],
          [
            14.643704,
            52.574109,
            55.470747
          ],
          [
            14.643999,
            52.573946,
            55.827747
          ],
          [
            14.644282,
            52.573793,
            56.166922
          ],
          [
            14.644548,
            52.573635,
            56.500017
          ],
          [
            14.644816,
            52.573473,
            56.838741
          ],
          [
            14.645086,
            52.573304,
            57.185954
          ],
          [
            14.645347,
            52.573156,
            57.505602
          ],
          [
            14.645601,
            52.573015,
            57.765333
          ],
          [
            14.645861,
            52.572855,
            57.993748
          ],
          [
            14.646122,
            52.5727,
            58.219158
          ],
          [
            14.646373,
            52.572544,
            58.440855
          ],
          [
            14.646657,
            52.572381,
            58.682127
          ],
          [
            14.646933,
            52.572238,
            58.906069
          ],
          [
            14.647216,
            52.57208,
            59.143254
          ],
          [
            14.647506,
            52.571913,
            59.389835
          ],
          [
            14.647759,
            52.571752,
            59.305663
          ],
          [
            14.648033,
            52.57158,
            58.973508
          ],
          [
            14.648294,
            52.571438,
            58.677807
          ],
          [
            14.648546,
            52.571288,
            58.379638
          ],
          [
            14.648795,
            52.571135,
            58.081048
          ],
          [
            14.649074,
            52.570972,
            57.75476
          ],
          [
            14.649347,
            52.570811,
            57.434025
          ],
          [
            14.649609,
            52.570654,
            57.123733
          ],
          [
            14.649874,
            52.570494,
            56.836114
          ],
          [
            14.650141,
            52.570336,
            56.569366
          ],
          [
            14.650414,
            52.570183,
            56.303562
          ],
          [
            14.650678,
            52.570034,
            56.045685
          ],
          [
            14.650948,
            52.569879,
            55.779823
          ],
          [
            14.651218,
            52.569735,
            55.522696
          ],
          [
            14.651442,
            52.569601,
            55.297627
          ],
          [
            14.651674,
            52.569452,
            55.056031
          ],
          [
            14.651928,
            52.569307,
            54.968471
          ],
          [
            14.652174,
            52.569152,
            55.346465
          ],
          [
            14.652416,
            52.569002,
            55.715168
          ],
          [
            14.652681,
            52.568848,
            56.106266
          ],
          [
            14.652948,
            52.568696,
            56.496446
          ],
          [
            14.653209,
            52.568548,
            56.877323
          ],
          [
            14.653464,
            52.568402,
            57.251124
          ],
          [
            14.653701,
            52.568259,
            57.607732
          ],
          [
            14.653945,
            52.568126,
            57.957299
          ],
          [
            14.654192,
            52.568,
            57.930862
          ],
          [
            14.654458,
            52.56786,
            57.797895
          ],
          [
            14.654716,
            52.567708,
            57.662053
          ],
          [
            14.654977,
            52.567566,
            57.529695
          ],
          [
            14.655241,
            52.567431,
            57.39925
          ],
          [
            14.655526,
            52.567276,
            57.254719
          ],
          [
            14.655832,
            52.56713,
            57.107729
          ],
          [
            14.656152,
            52.566984,
            56.956487
          ],
          [
            14.656482,
            52.566836,
            57.089047
          ],
          [
            14.656808,
            52.5667,
            57.336908
          ],
          [
            14.657126,
            52.566577,
            57.573116
          ],
          [
            14.657465,
            52.566443,
            57.826529
          ],
          [
            14.657803,
            52.566316,
            58.075547
          ],
          [
            14.658118,
            52.566217,
            58.298443
          ],
          [
            14.658427,
            52.566097,
            58.528538
          ],
          [
            14.658773,
            52.565956,
            58.792303
          ],
          [
            14.659094,
            52.565836,
            59.053491
          ],
          [
            14.659415,
            52.56571,
            59.318321
          ],
          [
            14.659751,
            52.565601,
            59.582308
          ],
          [
            14.660044,
            52.565486,
            59.824147
          ],
          [
            14.660389,
            52.565366,
            60.099696
          ],
          [
            14.660664,
            52.565269,
            60.320605
          ],
          [
            14.660993,
            52.565144,
            60.589501
          ],
          [
            14.661321,
            52.565019,
            60.718637
          ],
          [
            14.661644,
            52.564893,
            60.124208
          ],
          [
            14.66196,
            52.56478,
            59.556477
          ],
          [
            14.662282,
            52.564669,
            58.983243
          ],
          [
            14.662593,
            52.564562,
            58.429737
          ],
          [
            14.662941,
            52.564439,
            57.806211
          ],
          [
            14.663273,
            52.564322,
            57.210634
          ],
          [
            14.663591,
            52.5642,
            56.628062
          ],
          [
            14.663923,
            52.56408,
            56.285933
          ],
          [
            14.66425,
            52.563964,
            56.439391
          ],
          [
            14.664576,
            52.563855,
            56.590194
          ],
          [
            14.664865,
            52.563757,
            56.724365
          ],
          [
            14.665185,
            52.56363,
            56.879272
          ],
          [
            14.665499,
            52.563503,
            57.032158
          ],
          [
            14.665797,
            52.563389,
            57.174907
          ],
          [
            14.666107,
            52.563284,
            57.318745
          ],
          [
            14.666405,
            52.563199,
            57.471413
          ],
          [
            14.666746,
            52.56306,
            57.795807
          ],
          [
            14.667067,
            52.562948,
            58.088544
          ],
          [
            14.667366,
            52.562831,
            58.369497
          ],
          [
            14.667706,
            52.562716,
            58.677169
          ],
          [
            14.668071,
            52.562587,
            59.010825
          ],
          [
            14.668407,
            52.562468,
            59.318071
          ],
          [
            14.668734,
            52.562348,
            59.619869
          ],
          [
            14.669059,
            52.562219,
            59.750289
          ],
          [
            14.669372,
            52.562103,
            59.714156
          ],
          [
            14.669694,
            52.561984,
            59.677
          ],
          [
            14.670073,
            52.561849,
            59.633696
          ],
          [
            14.670412,
            52.561722,
            59.594443
          ],
          [
            14.670751,
            52.561596,
            59.555179
          ],
          [
            14.671058,
            52.561489,
            59.520297
          ],
          [
            14.671357,
            52.561378,
            59.485741
          ],
          [
            14.671732,
            52.561246,
            59.682605
          ],
          [
            14.67206,
            52.56112,
            59.904546
          ],
          [
            14.672418,
            52.560999,
            60.138982
          ],
          [
            14.672712,
            52.560882,
            60.339998
          ],
          [
            14.67307,
            52.560764,
            60.572954
          ],
          [
            14.673408,
            52.56064,
            60.798861
          ],
          [
            14.673746,
            52.560515,
            61.025169
          ],
          [
            14.674047,
            52.560405,
            61.240449
          ],
          [
            14.674306,
            52.560306,
            61.460888
          ],
          [
            14.674634,
            52.560216,
            61.721019
          ],
          [
            14.674904,
            52.560116,
            61.949051
          ],
          [
            14.675212,
            52.560019,
            62.198966
          ],
          [
            14.675511,
            52.559906,
            62.453944
          ],
          [
            14.675842,
            52.559794,
            62.726926
          ],
          [
            14.676207,
            52.559637,
            63.051116
          ],
          [
            14.676515,
            52.559506,
            63.27391
          ],
          [
            14.676795,
            52.559399,
            62.930246
          ],
          [
            14.677098,
            52.559279,
            62.557654
          ],
          [
            14.677384,
            52.559182,
            62.219871
          ],
          [
            14.677669,
            52.559073,
            61.872942
          ],
          [
            14.677965,
            52.558978,
            61.528074
          ],
          [
            14.678235,
            52.558879,
            61.203188
          ],
          [
            14.678517,
            52.558765,
            60.854031
          ],
          [
            14.678804,
            52.558675,
            60.521304
          ],
          [
            14.67914,
            52.558565,
            60.267419
          ],
          [
            14.679434,
            52.55847,
            60.304172
          ],
          [
            14.67972,
            52.558361,
            60.341422
          ],
          [
            14.680063,
            52.558225,
            60.386684
          ],
          [
            14.680373,
            52.558109,
            60.426857
          ],
          [
            14.680683,
            52.558,
            60.466381
          ],
          [
            14.680972,
            52.557898,
            60.503291
          ],
          [
            14.681269,
            52.55777,
            60.54347
          ],
          [
            14.681571,
            52.557665,
            60.589467
          ],
          [
            14.681869,
            52.55755,
            60.830587
          ],
          [
            14.682221,
            52.557421,
            61.111669
          ],
          [
            14.682554,
            52.557304,
            61.374339
          ],
          [
            14.682851,
            52.557211,
            61.602602
          ],
          [
            14.683164,
            52.557094,
            61.854021
          ],
          [
            14.68344,
            52.556989,
            62.076579
          ],
          [
            14.683799,
            52.556859,
            62.362445
          ],
          [
            14.684107,
            52.556743,
            62.590031
          ],
          [
            14.684454,
            52.556636,
            62.274205
          ],
          [
            14.684767,
            52.556522,
            61.978318
          ],
          [
            14.685091,
            52.556386,
            61.658408
          ],
          [
            14.685362,
            52.556294,
            61.40668
          ],
          [
            14.685679,
            52.55619,
            61.113456
          ],
          [
            14.685957,
            52.556073,
            60.839224
          ],
          [
            14.686268,
            52.55596,
            60.545387
          ],
          [
            14.686548,
            52.555853,
            60.276905
          ],
          [
            14.68692,
            52.555744,
            60.373911
          ],
          [
            14.687221,
            52.555609,
            60.574685
          ],
          [
            14.687521,
            52.555502,
            60.761854
          ],
          [
            14.687791,
            52.555389,
            60.937761
          ],
          [
            14.688133,
            52.555258,
            61.154661
          ],
          [
            14.688438,
            52.555155,
            61.341883
          ],
          [
            14.688711,
            52.555049,
            61.515709
          ],
          [
            14.689031,
            52.554924,
            61.719988
          ],
          [
            14.689327,
            52.554818,
            61.619312
          ],
          [
            14.689628,
            52.554732,
            61.357039
          ],
          [
            14.689898,
            52.554611,
            61.092352
          ],
          [
            14.690215,
            52.5545,
            60.803872
          ],
          [
            14.690572,
            52.554395,
            60.490494
          ],
          [
            14.690915,
            52.554297,
            60.191295
          ],
          [
            14.691242,
            52.554199,
            59.903781
          ],
          [
            14.69156,
            52.554044,
            59.582226
          ],
          [
            14.69191,
            52.553921,
            59.407502
          ],
          [
            14.692265,
            52.553779,
            59.322833
          ],
          [
            14.692562,
            52.553669,
            59.253549
          ],
          [
            14.692831,
            52.55355,
            59.187246
          ],
          [
            14.693139,
            52.553427,
            59.113821
          ],
          [
            14.693422,
            52.553322,
            59.047771
          ],
          [
            14.693762,
            52.553208,
            58.970412
          ],
          [
            14.69405,
            52.5531,
            58.902931
          ],
          [
            14.694377,
            52.552994,
            58.834919
          ],
          [
            14.694671,
            52.552901,
            58.778942
          ],
          [
            14.694969,
            52.55278,
            58.718476
          ],
          [
            14.695241,
            52.552677,
            58.664079
          ],
          [
            14.695527,
            52.552564,
            58.606512
          ],
          [
            14.695799,
            52.552455,
            58.551572
          ],
          [
            14.696075,
            52.552359,
            58.497945
          ],
          [
            14.696373,
            52.552244,
            58.43842
          ],
          [
            14.696764,
            52.552115,
            58.344326
          ],
          [
            14.697049,
            52.55201,
            58.063218
          ],
          [
            14.697422,
            52.551882,
            57.701719
          ],
          [
            14.697739,
            52.551781,
            57.399409
          ],
          [
            14.698049,
            52.551676,
            57.100029
          ],
          [
            14.698358,
            52.551552,
            56.787699
          ],
          [
            14.6987,
            52.551439,
            56.458998
          ],
          [
            14.699031,
            52.551333,
            56.142664
          ],
          [
            14.699349,
            52.551171,
            55.809324
          ],
          [
            14.699655,
            52.551084,
            55.583532
          ],
          [
            14.699994,
            52.550942,
            55.307287
          ],
          [
            14.700311,
            52.550831,
            55.062872
          ],
          [
            14.700592,
            52.550718,
            54.836411
          ],
          [
            14.700876,
            52.550662,
            54.634755
          ],
          [
            14.701193,
            52.550537,
            54.382471
          ],
          [
            14.70147,
            52.550425,
            54.16033
          ],
          [
            14.701739,
            52.550324,
            53.949241
          ],
          [
            14.702018,
            52.550203,
            53.881358
          ],
          [
            14.702328,
            52.550121,
            53.860542
          ],
          [
            14.702651,
            52.549986,
            53.836411
          ],
          [
            14.702929,
            52.549868,
            53.815503
          ],
          [
            14.70322,
            52.549764,
            53.794726
          ],
          [
            14.703537,
            52.549654,
            53.772213
          ],
          [
            14.703814,
            52.549548,
            53.75205
          ],
          [
            14.704106,
            52.549437,
            53.730811
          ],
          [
            14.70441,
            52.549322,
            53.728965
          ],
          [
            14.704711,
            52.549211,
            53.770747
          ],
          [
            14.705009,
            52.549112,
            53.811134
          ],
          [
            14.705295,
            52.549014,
            53.850099
          ],
          [
            14.705577,
            52.548911,
            53.889149
          ],
          [
            14.705873,
            52.548793,
            53.931181
          ],
          [
            14.706159,
            52.548686,
            53.971037
          ],
          [
            14.706451,
            52.548579,
            54.011512
          ],
          [
            14.706748,
            52.548464,
            54.053329
          ],
          [
            14.707064,
            52.54835,
            54.096151
          ],
          [
            14.707384,
            52.548237,
            54.138934
          ],
          [
            14.707716,
            52.548113,
            54.183926
          ],
          [
            14.708018,
            52.548008,
            54.224097
          ],
          [
            14.708302,
            52.547898,
            54.262979
          ],
          [
            14.708597,
            52.547797,
            54.302071
          ],
          [
            14.70888,
            52.547692,
            54.340425
          ],
          [
            14.709172,
            52.547603,
            54.378142
          ],
          [
            14.709465,
            52.547487,
            54.441083
          ],
          [
            14.709767,
            52.547374,
            54.572293
          ],
          [
            14.710041,
            52.547269,
            54.692174
          ],
          [
            14.710316,
            52.547168,
            54.811054
          ],
          [
            14.710599,
            52.547067,
            54.93274
          ],
          [
            14.71089,
            52.546951,
            55.061459
          ],
          [
            14.7112,
            52.54685,
            55.191563
          ],
          [
            14.711531,
            52.546728,
            55.334741
          ],
          [
            14.711877,
            52.546591,
            55.487467
          ],
          [
            14.712194,
            52.546468,
            55.792823
          ],
          [
            14.712511,
            52.546347,
            56.11654
          ],
          [
            14.712839,
            52.546235,
            56.441866
          ],
          [
            14.713192,
            52.546101,
            56.801702
          ],
          [
            14.713518,
            52.545985,
            57.128305
          ],
          [
            14.713866,
            52.545895,
            57.4553
          ],
          [
            14.714198,
            52.545799,
            57.773376
          ],
          [
            14.714541,
            52.545734,
            58.076722
          ],
          [
            14.714879,
            52.545676,
            58.283933
          ],
          [
            14.715223,
            52.545638,
            58.49039
          ],
          [
            14.715571,
            52.545589,
            58.701044
          ],
          [
            14.715926,
            52.545558,
            58.912604
          ],
          [
            14.716274,
            52.545511,
            59.122821
          ],
          [
            14.716599,
            52.545488,
            59.31591
          ],
          [
            14.716916,
            52.545463,
            59.504965
          ],
          [
            14.717232,
            52.545435,
            59.693587
          ],
          [
            14.717539,
            52.545403,
            59.899645
          ],
          [
            14.717903,
            52.545378,
            60.182477
          ],
          [
            14.718239,
            52.545335,
            60.446652
          ],
          [
            14.718547,
            52.545305,
            60.686716
          ],
          [
            14.718926,
            52.545247,
            60.987395
          ],
          [
            14.719245,
            52.545202,
            61.239499
          ],
          [
            14.719557,
            52.545192,
            61.482787
          ],
          [
            14.719934,
            52.545168,
            61.775299
          ],
          [
            14.720316,
            52.545133,
            62.073294
          ],
          [
            14.720668,
            52.545102,
            62.024541
          ],
          [
            14.721024,
            52.545054,
            61.967391
          ],
          [
            14.721357,
            52.544991,
            61.912563
          ],
          [
            14.721724,
            52.544977,
            61.854925
          ],
          [
            14.722138,
            52.544941,
            61.789102
          ],
          [
            14.722546,
            52.544923,
            61.724978
          ],
          [
            14.722927,
            52.544913,
            61.665189
          ],
          [
            14.723324,
            52.544914,
            61.597455
          ],
          [
            14.72368,
            52.544921,
            61.517541
          ],
          [
            14.724063,
            52.544941,
            61.431295
          ],
          [
            14.724376,
            52.544914,
            61.360289
          ],
          [
            14.724689,
            52.544926,
            61.2898
          ],
          [
            14.725002,
            52.5449,
            61.218244
          ],
          [
            14.725355,
            52.544913,
            61.138919
          ],
          [
            14.725705,
            52.544914,
            61.060342
          ],
          [
            14.726053,
            52.54492,
            60.982254
          ],
          [
            14.726419,
            52.544896,
            61.195646
          ],
          [
            14.726774,
            52.544908,
            61.564981
          ],
          [
            14.727128,
            52.544903,
            61.93283
          ],
          [
            14.727495,
            52.544916,
            62.316172
          ],
          [
            14.727856,
            52.544901,
            62.692908
          ],
          [
            14.728221,
            52.54491,
            63.073276
          ],
          [
            14.728568,
            52.544925,
            63.434867
          ],
          [
            14.728938,
            52.544937,
            63.820012
          ],
          [
            14.729297,
            52.544929,
            63.828446
          ],
          [
            14.729689,
            52.544931,
            63.354649
          ],
          [
            14.730036,
            52.544918,
            62.934321
          ],
          [
            14.730363,
            52.544923,
            62.539533
          ],
          [
            14.730689,
            52.544927,
            62.14595
          ],
          [
            14.731039,
            52.54492,
            61.723207
          ],
          [
            14.731427,
            52.544912,
            61.254177
          ],
          [
            14.731817,
            52.544901,
            60.783118
          ],
          [
            14.732191,
            52.544891,
            60.302486
          ],
          [
            14.732549,
            52.544899,
            59.770903
          ],
          [
            14.732906,
            52.544908,
            59.239418
          ],
          [
            14.733282,
            52.54491,
            58.681114
          ],
          [
            14.733656,
            52.544913,
            58.125835
          ],
          [
            14.734022,
            52.544895,
            57.564694
          ],
          [
            14.734372,
            52.544897,
            57.045294
          ],
          [
            14.734734,
            52.544895,
            56.507307
          ],
          [
            14.735075,
            52.544919,
            56.0544
          ],
          [
            14.735412,
            52.544898,
            55.962153
          ],
          [
            14.735736,
            52.544905,
            55.873538
          ],
          [
            14.736086,
            52.544879,
            55.777326
          ],
          [
            14.736416,
            52.544883,
            55.687452
          ],
          [
            14.736777,
            52.544881,
            55.589146
          ],
          [
            14.737142,
            52.544873,
            55.488811
          ],
          [
            14.737514,
            52.544881,
            55.387417
          ],
          [
            14.737865,
            52.544894,
            55.291092
          ],
          [
            14.738238,
            52.544896,
            55.322236
          ],
          [
            14.738602,
            52.544894,
            55.404714
          ],
          [
            14.738966,
            52.544886,
            55.487242
          ],
          [
            14.739329,
            52.544839,
            55.57134
          ],
          [
            14.7397,
            52.544784,
            55.657918
          ],
          [
            14.740039,
            52.544721,
            55.738284
          ],
          [
            14.740375,
            52.54464,
            55.820188
          ],
          [
            14.740744,
            52.544571,
            55.907659
          ],
          [
            14.741098,
            52.544481,
            56.383479
          ],
          [
            14.741463,
            52.544379,
            57.040468
          ],
          [
            14.741821,
            52.544293,
            57.669995
          ],
          [
            14.7422,
            52.544211,
            58.327752
          ],
          [
            14.74255,
            52.544132,
            58.93819
          ],
          [
            14.74291,
            52.54406,
            59.558009
          ],
          [
            14.743256,
            52.543953,
            60.192796
          ],
          [
            14.743613,
            52.54386,
            60.751843
          ],
          [
            14.743952,
            52.54378,
            60.593461
          ],
          [
            14.744288,
            52.543694,
            60.434675
          ],
          [
            14.744648,
            52.543603,
            60.264777
          ],
          [
            14.744981,
            52.54356,
            60.116479
          ],
          [
            14.74534,
            52.543496,
            59.953435
          ],
          [
            14.745684,
            52.543451,
            59.800177
          ],
          [
            14.746031,
            52.543413,
            59.646334
          ],
          [
            14.746377,
            52.543382,
            59.494004
          ],
          [
            14.746739,
            52.543365,
            59.215409
          ],
          [
            14.747115,
            52.543335,
            58.912038
          ],
          [
            14.747477,
            52.543315,
            58.620347
          ],
          [
            14.747842,
            52.543304,
            58.328031
          ],
          [
            14.748191,
            52.543294,
            58.048769
          ],
          [
            14.748554,
            52.543284,
            57.758155
          ],
          [
            14.748901,
            52.543262,
            57.4779
          ],
          [
            14.749261,
            52.543235,
            57.187949
          ],
          [
            14.749614,
            52.543226,
            56.833355
          ],
          [
            14.749963,
            52.543214,
            56.458144
          ],
          [
            14.750328,
            52.543194,
            56.064684
          ],
          [
            14.7507,
            52.54317,
            55.662781
          ],
          [
            14.751085,
            52.543147,
            55.247454
          ],
          [
            14.75146,
            52.543122,
            54.842148
          ],
          [
            14.751823,
            52.543103,
            54.448982
          ],
          [
            14.752203,
            52.54309,
            54.04041
          ],
          [
            14.752575,
            52.543071,
            53.92929
          ],
          [
            14.752951,
            52.543074,
            53.912333
          ],
          [
            14.753333,
            52.543064,
            53.89509
          ],
          [
            14.753716,
            52.54304,
            53.87773
          ],
          [
            14.754083,
            52.543029,
            53.861145
          ],
          [
            14.754391,
            52.543006,
            53.847158
          ],
          [
            14.754728,
            52.542982,
            53.831865
          ],
          [
            14.755059,
            52.542968,
            53.816903
          ],
          [
            14.755386,
            52.542964,
            53.819884
          ],
          [
            14.755782,
            52.542965,
            53.850287
          ],
          [
            14.756085,
            52.542937,
            53.873873
          ],
          [
            14.75642,
            52.542909,
            53.899787
          ],
          [
            14.756791,
            52.542896,
            53.928397
          ],
          [
            14.757129,
            52.542883,
            53.954342
          ],
          [
            14.757471,
            52.542884,
            53.980668
          ],
          [
            14.757803,
            52.542862,
            54.006244
          ],
          [
            14.758125,
            52.542856,
            54.030928
          ],
          [
            14.758432,
            52.542846,
            54.069882
          ],
          [
            14.758803,
            52.54283,
            54.121178
          ],
          [
            14.759221,
            52.54281,
            54.178979
          ],
          [
            14.759648,
            52.542793,
            54.237979
          ],
          [
            14.759955,
            52.542787,
            54.280412
          ],
          [
            14.760264,
            52.542788,
            54.323023
          ],
          [
            14.760588,
            52.542717,
            54.373988
          ],
          [
            14.760551,
            52.54248,
            54.427993
          ],
          [
            14.760474,
            52.542298,
            54.552376
          ],
          [
            14.760382,
            52.542107,
            54.730756
          ],
          [
            14.76026,
            52.541919,
            54.911954
          ],
          [
            14.76011,
            52.541677,
            55.144019
          ],
          [
            14.759991,
            52.541483,
            55.329645
          ],
          [
            14.75983,
            52.541282,
            55.529877
          ],
          [
            14.759695,
            52.541088,
            55.718963
          ],
          [
            14.759573,
            52.540864,
            55.930473
          ],
          [
            14.759521,
            52.540661,
            55.930627
          ],
          [
            14.759558,
            52.540437,
            55.525918
          ],
          [
            14.759636,
            52.540239,
            55.160147
          ],
          [
            14.759739,
            52.540015,
            54.740913
          ],
          [
            14.759887,
            52.539765,
            54.263182
          ],
          [
            14.759923,
            52.539566,
            53.903367
          ],
          [
            14.759938,
            52.539305,
            53.434113
          ],
          [
            14.75992,
            52.539095,
            53.055134
          ],
          [
            14.759926,
            52.53889,
            52.866996
          ],
          [
            14.759876,
            52.538689,
            52.985145
          ],
          [
            14.759808,
            52.538495,
            53.100428
          ],
          [
            14.759753,
            52.53826,
            53.23835
          ],
          [
            14.759706,
            52.538029,
            53.373588
          ],
          [
            14.759642,
            52.537813,
            53.501128
          ],
          [
            14.759594,
            52.537607,
            53.622021
          ],
          [
            14.759523,
            52.537391,
            53.75021
          ],
          [
            14.759467,
            52.53717,
            53.898123
          ],
          [
            14.759416,
            52.536948,
            54.212223
          ],
          [
            14.759421,
            52.536722,
            54.52896
          ],
          [
            14.759358,
            52.536435,
            54.934592
          ],
          [
            14.759384,
            52.536194,
            55.273012
          ],
          [
            14.759345,
            52.535973,
            55.595351
          ],
          [
            14.759308,
            52.535729,
            55.93869
          ],
          [
            14.75929,
            52.535513,
            56.241746
          ],
          [
            14.759268,
            52.535317,
            56.420954
          ],
          [
            14.759316,
            52.535068,
            56.512395
          ],
          [
            14.759476,
            52.53485,
            56.59951
          ],
          [
            14.759741,
            52.534654,
            56.691879
          ],
          [
            14.760007,
            52.534449,
            56.786919
          ],
          [
            14.760256,
            52.534266,
            56.873387
          ],
          [
            14.760495,
            52.534089,
            56.956741
          ],
          [
            14.760703,
            52.533898,
            57.040138
          ],
          [
            14.760923,
            52.533713,
            57.190471
          ],
          [
            14.761153,
            52.533491,
            57.364671
          ],
          [
            14.761359,
            52.533305,
            57.513556
          ],
          [
            14.761556,
            52.533128,
            57.655455
          ],
          [
            14.761749,
            52.532935,
            57.805436
          ],
          [
            14.761929,
            52.532718,
            57.96681
          ],
          [
            14.76206,
            52.532489,
            58.128125
          ],
          [
            14.762114,
            52.53224,
            58.271851
          ],
          [
            14.762056,
            52.53202,
            58.361245
          ],
          [
            14.762058,
            52.531828,
            58.439632
          ],
          [
            14.762317,
            52.531646,
            58.536911
          ],
          [
            14.762599,
            52.531468,
            58.6361
          ],
          [
            14.762679,
            52.531289,
            58.716462
          ],
          [
            14.762363,
            52.531153,
            58.810958
          ],
          [
            14.762033,
            52.531017,
            58.908239
          ],
          [
            14.761708,
            52.530881,
            59.094923
          ],
          [
            14.761422,
            52.53073,
            59.363428
          ],
          [
            14.761128,
            52.530615,
            59.611197
          ],
          [
            14.76081,
            52.530498,
            59.874736
          ],
          [
            14.760487,
            52.530346,
            60.16447
          ],
          [
            14.760204,
            52.53022,
            60.413302
          ],
          [
            14.759927,
            52.530089,
            60.662054
          ],
          [
            14.759611,
            52.529978,
            60.920692
          ],
          [
            14.759275,
            52.529869,
            60.945092
          ],
          [
            14.758871,
            52.529788,
            60.709609
          ],
          [
            14.758481,
            52.529749,
            60.490877
          ],
          [
            14.758105,
            52.529705,
            60.279159
          ],
          [
            14.757769,
            52.529654,
            60.087198
          ],
          [
            14.757471,
            52.529634,
            59.920457
          ],
          [
            14.757784,
            52.52955,
            59.727507
          ],
          [
            14.757907,
            52.529352,
            59.535107
          ],
          [
            14.758022,
            52.529175,
            59.546164
          ],
          [
            14.758178,
            52.528966,
            60.019791
          ],
          [
            14.758334,
            52.528789,
            60.43394
          ],
          [
            14.758492,
            52.528619,
            60.836635
          ],
          [
            14.758672,
            52.528457,
            61.239853
          ],
          [
            14.758886,
            52.528287,
            61.681496
          ],
          [
            14.759078,
            52.528111,
            62.118002
          ],
          [
            14.759259,
            52.527966,
            62.496958
          ],
          [
            14.759378,
            52.527781,
            62.9111
          ],
          [
            14.759561,
            52.527624,
            63.428567
          ],
          [
            14.759761,
            52.527456,
            64.141924
          ],
          [
            14.75994,
            52.527299,
            64.79865
          ],
          [
            14.760194,
            52.527193,
            65.473702
          ],
          [
            14.76038,
            52.527029,
            66.160749
          ],
          [
            14.760559,
            52.526871,
            66.820264
          ],
          [
            14.760745,
            52.526712,
            67.492028
          ],
          [
            14.760922,
            52.52654,
            68.18949
          ],
          [
            14.761117,
            52.526367,
            68.912253
          ],
          [
            14.761277,
            52.526206,
            69.604564
          ],
          [
            14.761475,
            52.526041,
            70.435304
          ],
          [
            14.761663,
            52.525883,
            71.228891
          ],
          [
            14.761873,
            52.525718,
            72.07703
          ],
          [
            14.762076,
            52.525538,
            72.964226
          ],
          [
            14.762297,
            52.52536,
            73.870868
          ],
          [
            14.762554,
            52.52523,
            74.71806
          ],
          [
            14.76278,
            52.525076,
            75.566115
          ],
          [
            14.762969,
            52.524914,
            76.376413
          ],
          [
            14.763151,
            52.524748,
            76.781054
          ],
          [
            14.763338,
            52.524577,
            77.019955
          ],
          [
            14.763493,
            52.524391,
            77.262539
          ],
          [
            14.763668,
            52.524207,
            77.510068
          ],
          [
            14.763831,
            52.524025,
            77.75114
          ],
          [
            14.763962,
            52.523856,
            77.96851
          ],
          [
            14.76413,
            52.523689,
            78.196309
          ],
          [
            14.764297,
            52.523525,
            78.420934
          ],
          [
            14.764456,
            52.523356,
            78.647428
          ],
          [
            14.764645,
            52.523189,
            78.828275
          ],
          [
            14.764803,
            52.523013,
            78.987458
          ],
          [
            14.764984,
            52.522859,
            79.136702
          ],
          [
            14.765217,
            52.522698,
            79.305744
          ],
          [
            14.765449,
            52.52255,
            79.467374
          ],
          [
            14.765634,
            52.522397,
            79.617228
          ],
          [
            14.765865,
            52.522244,
            79.780891
          ],
          [
            14.766137,
            52.522095,
            79.956332
          ],
          [
            14.766408,
            52.521944,
            80.143504
          ],
          [
            14.766678,
            52.521796,
            80.658617
          ],
          [
            14.766919,
            52.521653,
            81.136107
          ],
          [
            14.767176,
            52.521521,
            81.61275
          ],
          [
            14.767435,
            52.521381,
            82.104334
          ],
          [
            14.767684,
            52.521249,
            82.573021
          ],
          [
            14.767918,
            52.521108,
            83.039771
          ],
          [
            14.768174,
            52.520964,
            83.533863
          ],
          [
            14.768421,
            52.520806,
            84.04177
          ],
          [
            14.768638,
            52.520667,
            84.324758
          ],
          [
            14.768898,
            52.52053,
            84.349441
          ],
          [
            14.769172,
            52.520391,
            84.375046
          ],
          [
            14.769425,
            52.520249,
            84.399759
          ],
          [
            14.769666,
            52.520119,
            84.422878
          ],
          [
            14.769928,
            52.519965,
            84.449013
          ],
          [
            14.770183,
            52.519822,
            84.473893
          ],
          [
            14.770451,
            52.519666,
            84.500503
          ],
          [
            14.770674,
            52.519508,
            84.525101
          ],
          [
            14.770908,
            52.519342,
            84.340051
          ],
          [
            14.771147,
            52.519197,
            84.140119
          ],
          [
            14.771385,
            52.519083,
            83.960647
          ],
          [
            14.771617,
            52.518887,
            83.724714
          ],
          [
            14.771695,
            52.518883,
            83.497396
          ],
          [
            14.771429,
            52.519034,
            83.280926
          ],
          [
            14.771798,
            52.518846,
            82.993477
          ],
          [
            14.772042,
            52.518711,
            82.798058
          ],
          [
            14.7723,
            52.518592,
            83.186933
          ],
          [
            14.772567,
            52.518478,
            83.65063
          ],
          [
            14.77284,
            52.518352,
            84.137193
          ],
          [
            14.773103,
            52.518217,
            84.62604
          ],
          [
            14.773343,
            52.518083,
            85.088587
          ],
          [
            14.773617,
            52.517949,
            85.587841
          ],
          [
            14.773873,
            52.517835,
            86.038324
          ],
          [
            14.774123,
            52.517715,
            86.490488
          ],
          [
            14.774369,
            52.517591,
            86.94428
          ],
          [
            14.774629,
            52.517475,
            87.18055
          ],
          [
            14.774907,
            52.517345,
            87.420523
          ],
          [
            14.775164,
            52.517215,
            87.649407
          ],
          [
            14.775423,
            52.517083,
            87.880636
          ],
          [
            14.775704,
            52.516959,
            88.118212
          ],
          [
            14.775978,
            52.516823,
            88.360224
          ],
          [
            14.776237,
            52.516691,
            88.591504
          ],
          [
            14.776521,
            52.516562,
            88.834068
          ],
          [
            14.776826,
            52.516429,
            89.028453
          ],
          [
            14.777074,
            52.516298,
            89.103071
          ],
          [
            14.777306,
            52.516181,
            89.171525
          ],
          [
            14.777575,
            52.516055,
            89.248649
          ],
          [
            14.777818,
            52.515931,
            89.320672
          ],
          [
            14.778084,
            52.515795,
            89.399589
          ],
          [
            14.778355,
            52.515662,
            89.478658
          ],
          [
            14.778628,
            52.515531,
            89.557621
          ],
          [
            14.778913,
            52.515394,
            89.640153
          ],
          [
            14.779185,
            52.515249,
            89.582474
          ],
          [
            14.779445,
            52.515118,
            89.459037
          ],
          [
            14.779753,
            52.514967,
            89.314411
          ],
          [
            14.780056,
            52.514813,
            89.170054
          ],
          [
            14.780353,
            52.514673,
            89.032656
          ],
          [
            14.780665,
            52.514543,
            88.894375
          ],
          [
            14.780942,
            52.514434,
            88.773724
          ],
          [
            14.781201,
            52.514302,
            88.650179
          ],
          [
            14.781513,
            52.514135,
            88.757342
          ],
          [
            14.781808,
            52.513971,
            89.033645
          ],
          [
            14.782103,
            52.513851,
            89.278811
          ],
          [
            14.782403,
            52.513704,
            89.544615
          ],
          [
            14.782665,
            52.513565,
            89.784467
          ],
          [
            14.782961,
            52.513424,
            90.043995
          ],
          [
            14.783256,
            52.513283,
            90.302841
          ],
          [
            14.783563,
            52.513131,
            90.576024
          ],
          [
            14.7839,
            52.51298,
            90.056571
          ],
          [
            14.784158,
            52.512842,
            89.485621
          ],
          [
            14.784482,
            52.5127,
            88.822834
          ],
          [
            14.784802,
            52.512544,
            88.142669
          ],
          [
            14.785047,
            52.512436,
            87.640759
          ],
          [
            14.785288,
            52.512328,
            87.144268
          ],
          [
            14.785553,
            52.512215,
            86.605352
          ],
          [
            14.785712,
            52.512022,
            86.015769
          ],
          [
            14.785796,
            52.511805,
            85.871873
          ],
          [
            14.785884,
            52.5116,
            86.134483
          ],
          [
            14.786006,
            52.511384,
            86.417595
          ],
          [
            14.786089,
            52.511153,
            86.710994
          ],
          [
            14.786183,
            52.51092,
            87.008389
          ],
          [
            14.786263,
            52.510706,
            87.280464
          ],
          [
            14.786363,
            52.5105,
            87.547163
          ],
          [
            14.786453,
            52.510322,
            87.77803
          ],
          [
            14.78658,
            52.510123,
            88.07144
          ],
          [
            14.786703,
            52.509953,
            88.37662
          ],
          [
            14.786837,
            52.50974,
            88.751113
          ],
          [
            14.786981,
            52.509528,
            89.127696
          ],
          [
            14.787171,
            52.509328,
            89.507486
          ],
          [
            14.787391,
            52.509162,
            89.857758
          ],
          [
            14.787656,
            52.509035,
            90.194802
          ],
          [
            14.787934,
            52.508882,
            90.569287
          ],
          [
            14.788206,
            52.508741,
            90.918693
          ],
          [
            14.788464,
            52.508596,
            91.133144
          ],
          [
            14.788726,
            52.508469,
            91.337989
          ],
          [
            14.788888,
            52.508288,
            91.544906
          ],
          [
            14.789067,
            52.508119,
            91.746633
          ],
          [
            14.789252,
            52.507951,
            91.949544
          ],
          [
            14.789449,
            52.507772,
            92.165867
          ],
          [
            14.789652,
            52.507603,
            92.375925
          ],
          [
            14.789861,
            52.507412,
            92.606216
          ],
          [
            14.790032,
            52.507252,
            92.881103
          ],
          [
            14.790234,
            52.507089,
            93.283556
          ],
          [
            14.790466,
            52.50697,
            93.647407
          ],
          [
            14.790749,
            52.506881,
            94.02944
          ],
          [
            14.791054,
            52.506803,
            94.426054
          ],
          [
            14.791353,
            52.506716,
            94.823258
          ],
          [
            14.791654,
            52.506609,
            95.241479
          ],
          [
            14.791887,
            52.506461,
            95.645065
          ],
          [
            14.792135,
            52.506307,
            96.069608
          ],
          [
            14.792405,
            52.506164,
            96.444022
          ],
          [
            14.792671,
            52.506016,
            96.7809
          ],
          [
            14.79295,
            52.505867,
            97.127796
          ],
          [
            14.793223,
            52.505718,
            97.470501
          ],
          [
            14.793462,
            52.50558,
            97.778397
          ],
          [
            14.793732,
            52.505437,
            98.112901
          ],
          [
            14.793977,
            52.505299,
            98.424967
          ],
          [
            14.794215,
            52.505152,
            98.741883
          ],
          [
            14.794472,
            52.505002,
            99.013883
          ],
          [
            14.794732,
            52.504844,
            99.019269
          ],
          [
            14.794989,
            52.504689,
            99.024575
          ],
          [
            14.795244,
            52.504538,
            99.029799
          ],
          [
            14.79547,
            52.504381,
            99.034848
          ],
          [
            14.795727,
            52.504218,
            99.040298
          ],
          [
            14.795999,
            52.504052,
            99.04595
          ],
          [
            14.796295,
            52.503907,
            99.05152
          ],
          [
            14.796563,
            52.503741,
            99.026852
          ],
          [
            14.796845,
            52.503575,
            98.837674
          ],
          [
            14.797101,
            52.503402,
            98.653118
          ],
          [
            14.797369,
            52.503235,
            98.468283
          ],
          [
            14.797619,
            52.503056,
            98.282278
          ],
          [
            14.797831,
            52.502896,
            98.119422
          ],
          [
            14.798056,
            52.502723,
            97.944432
          ],
          [
            14.798314,
            52.502563,
            97.766568
          ],
          [
            14.798546,
            52.50239,
            97.58061
          ],
          [
            14.798773,
            52.502229,
            97.377077
          ],
          [
            14.798976,
            52.502061,
            97.176909
          ],
          [
            14.799171,
            52.501895,
            96.980518
          ],
          [
            14.799398,
            52.501752,
            96.789624
          ],
          [
            14.799596,
            52.501581,
            96.588918
          ],
          [
            14.799801,
            52.501424,
            96.396519
          ],
          [
            14.799981,
            52.501248,
            96.197629
          ],
          [
            14.800184,
            52.501089,
            96.004447
          ],
          [
            14.800418,
            52.500924,
            95.891776
          ],
          [
            14.800702,
            52.500738,
            95.85903
          ],
          [
            14.800963,
            52.500555,
            95.827755
          ],
          [
            14.801177,
            52.500374,
            95.798993
          ],
          [
            14.8014,
            52.500164,
            95.766673
          ],
          [
            14.801607,
            52.499977,
            95.737585
          ],
          [
            14.801763,
            52.499816,
            95.713355
          ],
          [
            14.801965,
            52.499659,
            95.68762
          ],
          [
            14.802162,
            52.499457,
            95.532114
          ],
          [
            14.802314,
            52.499292,
            95.334472
          ],
          [
            14.802481,
            52.499099,
            95.106344
          ],
          [
            14.80266,
            52.49891,
            94.878366
          ],
          [
            14.802872,
            52.498669,
            94.592763
          ],
          [
            14.803052,
            52.498468,
            94.353588
          ],
          [
            14.803224,
            52.498264,
            94.113978
          ],
          [
            14.803417,
            52.498071,
            93.876281
          ],
          [
            14.803612,
            52.497882,
            93.930943
          ],
          [
            14.803778,
            52.497709,
            94.112226
          ],
          [
            14.803963,
            52.497559,
            94.281459
          ],
          [
            14.804132,
            52.497363,
            94.481667
          ],
          [
            14.804332,
            52.497165,
            94.692055
          ],
          [
            14.804487,
            52.496994,
            94.868359
          ],
          [
            14.804626,
            52.496817,
            95.045358
          ],
          [
            14.804828,
            52.496649,
            95.23327
          ],
          [
            14.805043,
            52.496425,
            95.43096
          ],
          [
            14.805262,
            52.496199,
            95.484491
          ],
          [
            14.805446,
            52.496021,
            95.527364
          ],
          [
            14.805669,
            52.495795,
            95.581034
          ],
          [
            14.805846,
            52.495644,
            95.618778
          ],
          [
            14.806029,
            52.495475,
            95.659962
          ],
          [
            14.806214,
            52.495311,
            95.70045
          ],
          [
            14.806414,
            52.495144,
            95.742537
          ],
          [
            14.806615,
            52.49499,
            95.782563
          ],
          [
            14.806852,
            52.494802,
            96.099371
          ],
          [
            14.807158,
            52.49464,
            96.453274
          ],
          [
            14.807461,
            52.494467,
            96.817156
          ],
          [
            14.807735,
            52.494287,
            97.168007
          ],
          [
            14.808052,
            52.494131,
            97.522932
          ],
          [
            14.808339,
            52.493969,
            97.863535
          ],
          [
            14.808632,
            52.493812,
            98.20322
          ],
          [
            14.80894,
            52.493658,
            98.410864
          ],
          [
            14.809183,
            52.493498,
            98.497718
          ],
          [
            14.809459,
            52.493342,
            98.589156
          ],
          [
            14.809746,
            52.493176,
            98.685245
          ],
          [
            14.810042,
            52.493007,
            98.783704
          ],
          [
            14.810327,
            52.492836,
            98.880821
          ],
          [
            14.810648,
            52.492679,
            98.98073
          ],
          [
            14.810975,
            52.492548,
            99.076228
          ],
          [
            14.811309,
            52.492439,
            99.175392
          ],
          [
            14.811606,
            52.492377,
            99.258007
          ],
          [
            14.811915,
            52.492322,
            99.342336
          ],
          [
            14.812318,
            52.49227,
            99.450442
          ],
          [
            14.81271,
            52.492251,
            99.553332
          ],
          [
            14.813108,
            52.492261,
            99.657866
          ],
          [
            14.813464,
            52.492244,
            99.751309
          ],
          [
            14.81382,
            52.492242,
            99.844366
          ],
          [
            14.814173,
            52.492239,
            99.635868
          ],
          [
            14.814526,
            52.492259,
            99.42143
          ],
          [
            14.814871,
            52.492223,
            99.205169
          ],
          [
            14.815189,
            52.492139,
            98.995038
          ],
          [
            14.815545,
            52.492125,
            98.778659
          ],
          [
            14.815832,
            52.492037,
            98.584337
          ],
          [
            14.816125,
            52.491994,
            98.400717
          ],
          [
            14.816444,
            52.491916,
            98.190491
          ],
          [
            14.816726,
            52.491819,
            98.334553
          ],
          [
            14.81704,
            52.491701,
            99.268755
          ],
          [
            14.81734,
            52.491584,
            100.168648
          ],
          [
            14.81762,
            52.491481,
            100.995289
          ],
          [
            14.817899,
            52.491389,
            101.796522
          ],
          [
            14.818195,
            52.491289,
            102.651466
          ],
          [
            14.818477,
            52.491202,
            103.449823
          ],
          [
            14.818779,
            52.491121,
            104.283561
          ],
          [
            14.819085,
            52.49105,
            105.110986
          ],
          [
            14.819448,
            52.490963,
            105.808306
          ],
          [
            14.819845,
            52.490873,
            106.343602
          ],
          [
            14.820202,
            52.490803,
            106.817399
          ],
          [
            14.820558,
            52.490749,
            107.281121
          ],
          [
            14.820877,
            52.490718,
            107.689407
          ],
          [
            14.821218,
            52.490672,
            108.13072
          ],
          [
            14.821544,
            52.490642,
            108.547548
          ],
          [
            14.821869,
            52.490587,
            108.975602
          ],
          [
            14.82221,
            52.490543,
            109.248583
          ],
          [
            14.822551,
            52.490514,
            109.242448
          ],
          [
            14.822873,
            52.490479,
            109.236618
          ],
          [
            14.823192,
            52.49044,
            109.230819
          ],
          [
            14.82351,
            52.490391,
            109.224963
          ],
          [
            14.82383,
            52.490349,
            109.21913
          ],
          [
            14.824183,
            52.490311,
            109.212741
          ],
          [
            14.824536,
            52.490302,
            109.206443
          ],
          [
            14.824889,
            52.490291,
            109.20012
          ],
          [
            14.825255,
            52.490319,
            109.671917
          ],
          [
            14.825601,
            52.490378,
            110.315518
          ],
          [
            14.825921,
            52.490418,
            110.900359
          ],
          [
            14.826269,
            52.490456,
            111.532275
          ],
          [
            14.826586,
            52.490479,
            112.101625
          ],
          [
            14.826887,
            52.490505,
            112.643866
          ],
          [
            14.827191,
            52.490532,
            113.191412
          ],
          [
            14.827495,
            52.490564,
            113.742214
          ],
          [
            14.827826,
            52.490596,
            114.33947
          ],
          [
            14.828163,
            52.490636,
            114.705425
          ],
          [
            14.828498,
            52.490647,
            115.002282
          ],
          [
            14.82882,
            52.490637,
            115.289144
          ],
          [
            14.829156,
            52.490594,
            115.592906
          ],
          [
            14.829463,
            52.490513,
            115.889414
          ],
          [
            14.829766,
            52.490409,
            116.197136
          ],
          [
            14.83007,
            52.490297,
            116.511978
          ],
          [
            14.830361,
            52.490163,
            116.838254
          ],
          [
            14.830479,
            52.489969,
            117.166166
          ],
          [
            14.830522,
            52.489764,
            117.571464
          ],
          [
            14.830563,
            52.489542,
            118.008823
          ],
          [
            14.830592,
            52.489341,
            118.403771
          ],
          [
            14.830635,
            52.489141,
            118.798629
          ],
          [
            14.83066,
            52.488945,
            119.186124
          ],
          [
            14.83074,
            52.488732,
            119.614912
          ],
          [
            14.830847,
            52.488538,
            120.016818
          ],
          [
            14.830951,
            52.488331,
            120.440955
          ],
          [
            14.830995,
            52.488113,
            120.286603
          ],
          [
            14.831063,
            52.487923,
            119.859394
          ],
          [
            14.831178,
            52.487718,
            119.382836
          ],
          [
            14.83127,
            52.487511,
            118.909559
          ],
          [
            14.831309,
            52.487326,
            118.500238
          ],
          [
            14.831378,
            52.487137,
            118.074534
          ],
          [
            14.831489,
            52.486937,
            117.611262
          ],
          [
            14.831588,
            52.486741,
            117.160124
          ],
          [
            14.831721,
            52.486513,
            116.68163
          ],
          [
            14.831773,
            52.486317,
            117.272232
          ],
          [
            14.831903,
            52.486151,
            117.819361
          ],
          [
            14.832,
            52.485959,
            118.4123
          ],
          [
            14.832081,
            52.485755,
            119.031298
          ],
          [
            14.83215,
            52.485532,
            119.701711
          ],
          [
            14.832208,
            52.485314,
            120.35304
          ],
          [
            14.832298,
            52.485092,
            121.028694
          ],
          [
            14.832389,
            52.484854,
            121.750597
          ],
          [
            14.832453,
            52.484626,
            122.122122
          ],
          [
            14.832513,
            52.484416,
            122.341209
          ],
          [
            14.83255,
            52.484218,
            122.545445
          ],
          [
            14.832593,
            52.484033,
            122.738215
          ],
          [
            14.832642,
            52.483832,
            122.946714
          ],
          [
            14.832705,
            52.483601,
            123.187206
          ],
          [
            14.832765,
            52.483381,
            123.416532
          ],
          [
            14.832879,
            52.483178,
            123.637448
          ],
          [
            14.833025,
            52.482945,
            123.534949
          ],
          [
            14.833207,
            52.482714,
            122.796262
          ],
          [
            14.833436,
            52.482471,
            121.987838
          ],
          [
            14.833659,
            52.482262,
            121.269243
          ],
          [
            14.83387,
            52.48205,
            120.553209
          ],
          [
            14.834083,
            52.481852,
            119.870771
          ],
          [
            14.834284,
            52.481699,
            119.305089
          ],
          [
            14.834514,
            52.481456,
            118.530876
          ],
          [
            14.834723,
            52.481241,
            118.073085
          ],
          [
            14.834928,
            52.481082,
            117.702617
          ],
          [
            14.835152,
            52.480886,
            117.264577
          ],
          [
            14.835341,
            52.480727,
            116.904917
          ],
          [
            14.835541,
            52.480531,
            116.481597
          ],
          [
            14.835723,
            52.480375,
            116.130955
          ],
          [
            14.835946,
            52.480197,
            115.720723
          ],
          [
            14.836154,
            52.480032,
            115.339274
          ],
          [
            14.83641,
            52.479861,
            115.08693
          ],
          [
            14.836655,
            52.479674,
            114.835453
          ],
          [
            14.836918,
            52.479504,
            114.589751
          ],
          [
            14.837145,
            52.479337,
            114.361842
          ],
          [
            14.837407,
            52.479152,
            114.105132
          ],
          [
            14.837671,
            52.478969,
            113.849119
          ],
          [
            14.837883,
            52.478789,
            113.616032
          ],
          [
            14.838169,
            52.478594,
            113.266382
          ],
          [
            14.838405,
            52.478432,
            112.842858
          ],
          [
            14.838685,
            52.478249,
            112.353013
          ],
          [
            14.838938,
            52.478137,
            111.979511
          ],
          [
            14.839228,
            52.478054,
            111.59705
          ],
          [
            14.839575,
            52.477981,
            111.159737
          ],
          [
            14.839925,
            52.477905,
            110.716617
          ],
          [
            14.840336,
            52.47784,
            110.210637
          ],
          [
            14.84078,
            52.477739,
            109.43131
          ],
          [
            14.84121,
            52.477553,
            108.290042
          ],
          [
            14.841533,
            52.477284,
            107.10495
          ],
          [
            14.841811,
            52.476985,
            105.888172
          ],
          [
            14.842056,
            52.476685,
            104.701983
          ],
          [
            14.84229,
            52.476387,
            103.533866
          ],
          [
            14.84255,
            52.476091,
            102.536158
          ],
          [
            14.842823,
            52.475784,
            101.498444
          ],
          [
            14.843036,
            52.475552,
            100.708444
          ],
          [
            14.843317,
            52.475249,
            99.673757
          ],
          [
            14.843512,
            52.475028,
            98.928109
          ],
          [
            14.843764,
            52.474753,
            98.119325
          ],
          [
            14.843977,
            52.474508,
            97.804218
          ],
          [
            14.844218,
            52.474281,
            97.496947
          ],
          [
            14.844417,
            52.474063,
            97.212809
          ],
          [
            14.844589,
            52.473857,
            96.949968
          ],
          [
            14.844788,
            52.47365,
            96.677262
          ],
          [
            14.844938,
            52.473473,
            96.450355
          ],
          [
            14.845092,
            52.473307,
            96.233635
          ],
          [
            14.845269,
            52.47313,
            96.24852
          ],
          [
            14.845454,
            52.472926,
            96.409768
          ],
          [
            14.845628,
            52.472732,
            96.562511
          ],
          [
            14.845847,
            52.472535,
            96.72854
          ],
          [
            14.846016,
            52.472345,
            96.87796
          ],
          [
            14.846193,
            52.472125,
            97.047337
          ],
          [
            14.846392,
            52.471904,
            97.221563
          ],
          [
            14.8466,
            52.471692,
            97.392229
          ],
          [
            14.8468,
            52.471502,
            97.588121
          ],
          [
            14.846971,
            52.471298,
            97.788248
          ],
          [
            14.847132,
            52.471092,
            97.987491
          ],
          [
            14.84731,
            52.470895,
            98.183769
          ],
          [
            14.847464,
            52.470722,
            98.355551
          ],
          [
            14.847659,
            52.470539,
            98.546652
          ],
          [
            14.847814,
            52.470349,
            98.731844
          ],
          [
            14.848012,
            52.470151,
            98.934229
          ],
          [
            14.848185,
            52.469968,
            98.964935
          ],
          [
            14.848362,
            52.469776,
            98.963032
          ],
          [
            14.848569,
            52.469573,
            98.960967
          ],
          [
            14.848759,
            52.469373,
            98.958971
          ],
          [
            14.848943,
            52.46918,
            98.957043
          ],
          [
            14.849118,
            52.468988,
            98.955145
          ],
          [
            14.849273,
            52.468805,
            98.953365
          ],
          [
            14.849425,
            52.468613,
            98.951523
          ],
          [
            14.849593,
            52.468423,
            99.171295
          ],
          [
            14.849763,
            52.468216,
            99.525346
          ],
          [
            14.849939,
            52.468033,
            99.849731
          ],
          [
            14.850114,
            52.467861,
            100.159225
          ],
          [
            14.850265,
            52.467694,
            100.451159
          ],
          [
            14.85045,
            52.467494,
            100.802301
          ],
          [
            14.850616,
            52.467308,
            101.12714
          ],
          [
            14.850797,
            52.467123,
            101.456677
          ],
          [
            14.850961,
            52.466948,
            101.794787
          ],
          [
            14.851118,
            52.46676,
            102.270318
          ],
          [
            14.851272,
            52.466596,
            102.696779
          ],
          [
            14.851438,
            52.466422,
            103.150594
          ],
          [
            14.851607,
            52.466245,
            103.612488
          ],
          [
            14.851791,
            52.466044,
            104.131431
          ],
          [
            14.851977,
            52.465856,
            104.626577
          ],
          [
            14.852165,
            52.465651,
            105.156037
          ],
          [
            14.852361,
            52.465466,
            105.652454
          ],
          [
            14.852544,
            52.465253,
            105.95136
          ],
          [
            14.852737,
            52.465045,
            106.190627
          ],
          [
            14.852933,
            52.464827,
            106.439535
          ],
          [
            14.853128,
            52.464612,
            106.685584
          ],
          [
            14.853348,
            52.464396,
            106.940347
          ],
          [
            14.853491,
            52.464225,
            107.132837
          ],
          [
            14.853675,
            52.46404,
            107.349627
          ],
          [
            14.853907,
            52.463823,
            107.437377
          ],
          [
            14.854101,
            52.463614,
            106.870105
          ],
          [
            14.854329,
            52.463404,
            106.277286
          ],
          [
            14.854593,
            52.463256,
            105.762372
          ],
          [
            14.854863,
            52.463106,
            105.238413
          ],
          [
            14.855172,
            52.46294,
            104.647619
          ],
          [
            14.855477,
            52.462756,
            104.032144
          ],
          [
            14.855791,
            52.462563,
            103.3918
          ],
          [
            14.856134,
            52.462392,
            102.417851
          ],
          [
            14.856515,
            52.462241,
            101.377074
          ],
          [
            14.856983,
            52.462154,
            100.257978
          ],
          [
            14.857511,
            52.462083,
            99.021106
          ],
          [
            14.857999,
            52.461992,
            97.853873
          ],
          [
            14.858489,
            52.4619,
            96.681176
          ],
          [
            14.858976,
            52.461804,
            96.059071
          ],
          [
            14.859342,
            52.46169,
            95.600643
          ],
          [
            14.859666,
            52.461526,
            95.134464
          ],
          [
            14.859952,
            52.461304,
            94.61982
          ],
          [
            14.860133,
            52.461076,
            94.159618
          ],
          [
            14.860335,
            52.460849,
            93.690625
          ],
          [
            14.860504,
            52.460623,
            93.244603
          ],
          [
            14.860668,
            52.460408,
            92.846645
          ],
          [
            14.860832,
            52.460211,
            92.476606
          ],
          [
            14.86098,
            52.460033,
            92.142119
          ],
          [
            14.861143,
            52.459859,
            91.806242
          ],
          [
            14.861286,
            52.45967,
            91.457581
          ],
          [
            14.861429,
            52.459494,
            91.12814
          ],
          [
            14.8616,
            52.459291,
            90.745859
          ],
          [
            14.861744,
            52.459102,
            90.39671
          ],
          [
            14.861923,
            52.458916,
            90.145535
          ],
          [
            14.862094,
            52.458733,
            89.943429
          ],
          [
            14.862264,
            52.458505,
            89.703285
          ],
          [
            14.86245,
            52.4583,
            89.478573
          ],
          [
            14.862635,
            52.458115,
            89.270744
          ],
          [
            14.862788,
            52.457925,
            89.067473
          ],
          [
            14.86291,
            52.457741,
            88.877156
          ],
          [
            14.863002,
            52.457535,
            88.672205
          ],
          [
            14.863102,
            52.457327,
            88.274206
          ],
          [
            14.863193,
            52.457136,
            87.73806
          ],
          [
            14.863295,
            52.456942,
            87.1886
          ],
          [
            14.863416,
            52.45675,
            86.633511
          ],
          [
            14.863502,
            52.456557,
            86.09386
          ],
          [
            14.863598,
            52.456364,
            85.550095
          ],
          [
            14.863722,
            52.456118,
            84.856029
          ],
          [
            14.863814,
            52.455941,
            84.354779
          ],
          [
            14.864118,
            52.455875,
            83.819151
          ],
          [
            14.864484,
            52.455808,
            83.679729
          ],
          [
            14.864838,
            52.455733,
            83.632534
          ],
          [
            14.865189,
            52.455643,
            83.584619
          ],
          [
            14.865489,
            52.455564,
            83.543494
          ],
          [
            14.86589,
            52.455469,
            83.489272
          ],
          [
            14.866196,
            52.455391,
            83.447466
          ],
          [
            14.866514,
            52.455308,
            83.403931
          ],
          [
            14.866824,
            52.455248,
            83.362999
          ],
          [
            14.867116,
            52.455166,
            83.402881
          ],
          [
            14.867417,
            52.455089,
            83.486968
          ],
          [
            14.867714,
            52.454986,
            83.57524
          ],
          [
            14.868002,
            52.454914,
            83.655498
          ],
          [
            14.868306,
            52.454822,
            83.742976
          ],
          [
            14.86871,
            52.454677,
            83.863949
          ],
          [
            14.869025,
            52.454605,
            83.950608
          ],
          [
            14.869328,
            52.454552,
            84.032711
          ],
          [
            14.869649,
            52.454539,
            84.169532
          ],
          [
            14.869965,
            52.454489,
            84.862452
          ],
          [
            14.870323,
            52.454473,
            85.62611
          ],
          [
            14.870656,
            52.454469,
            86.380181
          ],
          [
            14.870952,
            52.454345,
            87.143522
          ],
          [
            14.871178,
            52.454202,
            87.836496
          ],
          [
            14.871424,
            52.454117,
            88.470054
          ],
          [
            14.87167,
            52.453938,
            89.2846
          ],
          [
            14.871888,
            52.453764,
            90.047483
          ],
          [
            14.872052,
            52.453594,
            90.207457
          ],
          [
            14.872273,
            52.453445,
            89.905703
          ],
          [
            14.872444,
            52.453254,
            89.578718
          ],
          [
            14.872686,
            52.45311,
            89.259414
          ],
          [
            14.87304,
            52.45312,
            88.93495
          ],
          [
            14.873348,
            52.453113,
            88.652093
          ],
          [
            14.873692,
            52.453115,
            88.336924
          ],
          [
            14.874003,
            52.453131,
            88.05119
          ],
          [
            14.874343,
            52.453131,
            87.739908
          ],
          [
            14.874687,
            52.453141,
            87.515891
          ],
          [
            14.875027,
            52.453125,
            87.321841
          ],
          [
            14.875356,
            52.453106,
            87.133724
          ],
          [
            14.875704,
            52.453065,
            86.932229
          ],
          [
            14.876022,
            52.452996,
            86.740435
          ],
          [
            14.876361,
            52.452893,
            86.525211
          ],
          [
            14.876672,
            52.452792,
            86.324777
          ],
          [
            14.876925,
            52.452679,
            86.146554
          ],
          [
            14.877175,
            52.452531,
            86.035662
          ],
          [
            14.877349,
            52.452383,
            86.237171
          ],
          [
            14.877493,
            52.45222,
            86.442035
          ],
          [
            14.877643,
            52.452035,
            86.670164
          ],
          [
            14.87779,
            52.451868,
            86.879645
          ],
          [
            14.877947,
            52.451675,
            87.117756
          ],
          [
            14.878131,
            52.451487,
            87.359789
          ],
          [
            14.878302,
            52.451293,
            87.603405
          ],
          [
            14.878444,
            52.451125,
            87.812434
          ],
          [
            14.878588,
            52.450955,
            88.015956
          ],
          [
            14.878773,
            52.450776,
            88.210355
          ],
          [
            14.878958,
            52.450589,
            88.410927
          ],
          [
            14.879122,
            52.450428,
            88.585003
          ],
          [
            14.87928,
            52.450272,
            88.753377
          ],
          [
            14.879445,
            52.450081,
            88.951775
          ],
          [
            14.879622,
            52.449928,
            89.123948
          ],
          [
            14.87983,
            52.44975,
            89.324721
          ],
          [
            14.879926,
            52.449569,
            89.501917
          ],
          [
            14.880013,
            52.449386,
            89.685268
          ],
          [
            14.880121,
            52.449206,
            89.890925
          ],
          [
            14.880247,
            52.448987,
            90.139958
          ],
          [
            14.880377,
            52.448773,
            90.384804
          ],
          [
            14.880469,
            52.448587,
            90.593252
          ],
          [
            14.880572,
            52.448408,
            90.796791
          ],
          [
            14.88069,
            52.448212,
            91.020818
          ],
          [
            14.880832,
            52.448027,
            91.239975
          ],
          [
            14.880995,
            52.447817,
            91.48937
          ],
          [
            14.881142,
            52.447632,
            91.508057
          ],
          [
            14.881273,
            52.447459,
            91.440823
          ],
          [
            14.881405,
            52.447273,
            91.369299
          ],
          [
            14.881543,
            52.447067,
            91.290784
          ],
          [
            14.881694,
            52.446877,
            91.216281
          ],
          [
            14.881837,
            52.446683,
            91.141229
          ],
          [
            14.881981,
            52.446502,
            91.070247
          ],
          [
            14.882104,
            52.446306,
            90.996191
          ],
          [
            14.882239,
            52.446111,
            90.916399
          ],
          [
            14.882359,
            52.445913,
            90.672672
          ],
          [
            14.88253,
            52.44572,
            90.419767
          ],
          [
            14.882706,
            52.445534,
            90.171956
          ],
          [
            14.882874,
            52.445366,
            89.944704
          ],
          [
            14.883048,
            52.445196,
            89.713292
          ],
          [
            14.883246,
            52.445016,
            89.463476
          ],
          [
            14.883433,
            52.444832,
            89.213944
          ],
          [
            14.883643,
            52.444645,
            88.952603
          ],
          [
            14.883848,
            52.44444,
            88.898133
          ],
          [
            14.884048,
            52.444243,
            88.970045
          ],
          [
            14.884247,
            52.444045,
            89.042122
          ],
          [
            14.884434,
            52.443847,
            89.113039
          ],
          [
            14.884633,
            52.443652,
            89.184509
          ],
          [
            14.884843,
            52.443454,
            89.257694
          ],
          [
            14.885053,
            52.443254,
            89.331426
          ],
          [
            14.885242,
            52.44305,
            89.404156
          ],
          [
            14.885395,
            52.44285,
            89.665367
          ],
          [
            14.885532,
            52.442662,
            89.923227
          ],
          [
            14.885667,
            52.442492,
            90.159719
          ],
          [
            14.885803,
            52.442301,
            90.420518
          ],
          [
            14.885949,
            52.442115,
            90.678696
          ],
          [
            14.886105,
            52.441907,
            90.965083
          ],
          [
            14.886261,
            52.441697,
            91.253752
          ],
          [
            14.886418,
            52.441498,
            91.53024
          ],
          [
            14.886577,
            52.441294,
            91.891679
          ],
          [
            14.886728,
            52.441076,
            92.341601
          ],
          [
            14.886879,
            52.440878,
            92.756775
          ],
          [
            14.887014,
            52.440689,
            93.148711
          ],
          [
            14.887163,
            52.440501,
            93.545821
          ],
          [
            14.887306,
            52.440313,
            93.93998
          ],
          [
            14.887442,
            52.440136,
            94.312097
          ],
          [
            14.88757,
            52.439955,
            94.687062
          ],
          [
            14.88773,
            52.439742,
            95.07965
          ],
          [
            14.887851,
            52.439572,
            95.069246
          ],
          [
            14.887964,
            52.4394,
            95.058847
          ],
          [
            14.888079,
            52.439222,
            95.048109
          ],
          [
            14.888221,
            52.439046,
            95.037099
          ],
          [
            14.88834,
            52.438869,
            95.026362
          ],
          [
            14.888483,
            52.438658,
            95.013549
          ],
          [
            14.888615,
            52.438455,
            95.00129
          ],
          [
            14.888776,
            52.438248,
            94.988433
          ],
          [
            14.888911,
            52.438046,
            95.020123
          ],
          [
            14.888858,
            52.437827,
            95.140911
          ],
          [
            14.889083,
            52.437656,
            95.259636
          ],
          [
            14.889301,
            52.437472,
            95.38249
          ],
          [
            14.889485,
            52.437277,
            95.504236
          ],
          [
            14.889656,
            52.437094,
            95.618217
          ],
          [
            14.889809,
            52.436901,
            95.734221
          ],
          [
            14.889973,
            52.436716,
            95.848095
          ],
          [
            14.890114,
            52.436524,
            95.983278
          ],
          [
            14.890257,
            52.436337,
            96.380301
          ],
          [
            14.890393,
            52.436156,
            96.763213
          ],
          [
            14.890542,
            52.435991,
            97.12553
          ],
          [
            14.890692,
            52.435832,
            97.478347
          ],
          [
            14.890839,
            52.435673,
            97.829439
          ],
          [
            14.891019,
            52.435477,
            98.262126
          ],
          [
            14.891197,
            52.435304,
            98.654914
          ],
          [
            14.891357,
            52.435129,
            99.040255
          ],
          [
            14.891505,
            52.434947,
            99.42701
          ],
          [
            14.891642,
            52.434772,
            99.717766
          ],
          [
            14.89181,
            52.434591,
            100.029693
          ],
          [
            14.891966,
            52.434436,
            100.302301
          ],
          [
            14.892114,
            52.434268,
            100.588371
          ],
          [
            14.892262,
            52.434091,
            100.886296
          ],
          [
            14.892437,
            52.433914,
            101.19611
          ],
          [
            14.892579,
            52.433748,
            101.476794
          ],
          [
            14.892716,
            52.433571,
            101.770176
          ],
          [
            14.89288,
            52.433397,
            102.071004
          ],
          [
            14.893033,
            52.433221,
            102.191482
          ],
          [
            14.893195,
            52.433041,
            102.288744
          ],
          [
            14.893365,
            52.432849,
            102.392104
          ],
          [
            14.893533,
            52.432693,
            102.480574
          ],
          [
            14.893738,
            52.432548,
            102.571552
          ],
          [
            14.894043,
            52.432485,
            102.666254
          ],
          [
            14.894328,
            52.432389,
            102.760318
          ],
          [
            14.894657,
            52.432293,
            102.865823
          ],
          [
            14.894939,
            52.432218,
            102.954813
          ],
          [
            14.89529,
            52.432136,
            102.707661
          ],
          [
            14.895585,
            52.43203,
            102.461987
          ],
          [
            14.895938,
            52.43192,
            102.177952
          ],
          [
            14.896287,
            52.431816,
            101.899707
          ],
          [
            14.896631,
            52.431735,
            101.635564
          ],
          [
            14.896989,
            52.431657,
            101.36327
          ],
          [
            14.897305,
            52.431582,
            101.120378
          ],
          [
            14.89762,
            52.431504,
            100.876861
          ],
          [
            14.897928,
            52.431436,
            100.681651
          ],
          [
            14.898258,
            52.431359,
            100.477059
          ],
          [
            14.898588,
            52.431289,
            100.274851
          ],
          [
            14.898914,
            52.431227,
            100.077261
          ],
          [
            14.899291,
            52.431141,
            99.844361
          ],
          [
            14.899681,
            52.431074,
            99.609864
          ],
          [
            14.900001,
            52.430994,
            99.408301
          ],
          [
            14.900273,
            52.430901,
            99.227805
          ],
          [
            14.900594,
            52.430827,
            99.78704
          ],
          [
            14.900893,
            52.430782,
            100.81389
          ],
          [
            14.901244,
            52.430754,
            101.999329
          ],
          [
            14.901567,
            52.430759,
            103.085069
          ],
          [
            14.901905,
            52.430756,
            104.220171
          ],
          [
            14.902234,
            52.43077,
            105.33446
          ],
          [
            14.902545,
            52.430701,
            106.442387
          ],
          [
            14.902818,
            52.430592,
            107.529751
          ],
          [
            14.903071,
            52.430465,
            108.623333
          ],
          [
            14.903322,
            52.430308,
            109.122759
          ],
          [
            14.90357,
            52.430164,
            109.350592
          ],
          [
            14.903823,
            52.430028,
            109.575447
          ],
          [
            14.904084,
            52.429903,
            109.796236
          ],
          [
            14.904384,
            52.429826,
            110.013027
          ],
          [
            14.904686,
            52.429757,
            110.228166
          ],
          [
            14.905044,
            52.429701,
            110.475019
          ],
          [
            14.905359,
            52.429653,
            110.691479
          ],
          [
            14.905668,
            52.429596,
            110.906473
          ],
          [
            14.905969,
            52.429497,
            111.468215
          ],
          [
            14.906277,
            52.429459,
            111.989259
          ],
          [
            14.906596,
            52.42941,
            112.534302
          ],
          [
            14.906913,
            52.429394,
            113.063543
          ],
          [
            14.907251,
            52.429378,
            113.625664
          ],
          [
            14.907631,
            52.429379,
            114.255538
          ],
          [
            14.907946,
            52.429394,
            114.779129
          ],
          [
            14.908268,
            52.429392,
            115.320607
          ],
          [
            14.908628,
            52.429417,
            115.796197
          ],
          [
            14.909002,
            52.429451,
            115.786931
          ],
          [
            14.909428,
            52.42948,
            115.776427
          ],
          [
            14.909788,
            52.42949,
            115.76759
          ],
          [
            14.910213,
            52.429522,
            115.757058
          ],
          [
            14.910603,
            52.429521,
            115.747501
          ],
          [
            14.911017,
            52.429525,
            115.737335
          ],
          [
            14.911419,
            52.429528,
            115.727482
          ],
          [
            14.911815,
            52.429567,
            115.074668
          ],
          [
            14.912174,
            52.429612,
            114.354418
          ],
          [
            14.912489,
            52.42964,
            113.728866
          ],
          [
            14.912824,
            52.42966,
            113.066988
          ],
          [
            14.91317,
            52.429709,
            112.368441
          ],
          [
            14.913482,
            52.429726,
            111.752869
          ],
          [
            14.913903,
            52.429777,
            110.909379
          ],
          [
            14.914199,
            52.429791,
            110.325904
          ],
          [
            14.914557,
            52.429803,
            109.987112
          ],
          [
            14.914957,
            52.429819,
            110.133929
          ],
          [
            14.915322,
            52.429868,
            110.270735
          ],
          [
            14.915729,
            52.429914,
            110.422257
          ],
          [
            14.916135,
            52.429939,
            110.571895
          ],
          [
            14.91655,
            52.429949,
            110.724005
          ],
          [
            14.91695,
            52.429997,
            110.873217
          ],
          [
            14.917341,
            52.43003,
            111.036514
          ],
          [
            14.917737,
            52.430078,
            111.508123
          ],
          [
            14.918127,
            52.430101,
            111.963779
          ],
          [
            14.918496,
            52.430132,
            112.396159
          ],
          [
            14.918807,
            52.430153,
            112.759516
          ],
          [
            14.919171,
            52.430149,
            113.184209
          ],
          [
            14.919515,
            52.430157,
            113.585346
          ],
          [
            14.919966,
            52.430167,
            114.128783
          ],
          [
            14.920343,
            52.430182,
            114.391542
          ],
          [
            14.920741,
            52.4302,
            114.247775
          ],
          [
            14.921068,
            52.430153,
            114.125886
          ],
          [
            14.921407,
            52.430181,
            114.002992
          ],
          [
            14.921742,
            52.430203,
            113.878996
          ],
          [
            14.92206,
            52.430171,
            113.762353
          ],
          [
            14.922397,
            52.430115,
            113.636875
          ],
          [
            14.922699,
            52.43018,
            113.519892
          ],
          [
            14.923041,
            52.430173,
            113.396674
          ],
          [
            14.923383,
            52.430195,
            114.029198
          ],
          [
            14.923716,
            52.430192,
            114.80281
          ],
          [
            14.92406,
            52.43024,
            115.623616
          ],
          [
            14.924457,
            52.430242,
            116.539126
          ],
          [
            14.924812,
            52.430209,
            117.36767
          ],
          [
            14.925193,
            52.430168,
            118.261848
          ],
          [
            14.92553,
            52.430151,
            119.041264
          ],
          [
            14.925907,
            52.430153,
            119.910472
          ],
          [
            14.926265,
            52.430147,
            120.275316
          ],
          [
            14.926637,
            52.430143,
            120.431687
          ],
          [
            14.926992,
            52.43014,
            120.58108
          ],
          [
            14.927369,
            52.430145,
            120.739481
          ],
          [
            14.927744,
            52.430133,
            120.897258
          ],
          [
            14.928112,
            52.430134,
            121.052086
          ],
          [
            14.928443,
            52.43011,
            121.192102
          ],
          [
            14.928785,
            52.430108,
            121.335861
          ],
          [
            14.929135,
            52.430112,
            121.399817
          ],
          [
            14.929489,
            52.430104,
            121.375024
          ],
          [
            14.929832,
            52.430071,
            121.350705
          ],
          [
            14.930181,
            52.430029,
            121.325787
          ],
          [
            14.930538,
            52.429972,
            121.299813
          ],
          [
            14.930885,
            52.429946,
            121.274963
          ],
          [
            14.931208,
            52.429892,
            121.251498
          ],
          [
            14.931544,
            52.429857,
            121.227611
          ],
          [
            14.931853,
            52.429792,
            121.221273
          ],
          [
            14.932104,
            52.429671,
            121.851214
          ],
          [
            14.932234,
            52.42949,
            122.495319
          ],
          [
            14.932301,
            52.429279,
            123.189461
          ],
          [
            14.932463,
            52.429078,
            123.921638
          ],
          [
            14.932699,
            52.428951,
            124.541281
          ],
          [
            14.933006,
            52.428824,
            125.273053
          ],
          [
            14.933268,
            52.428699,
            125.92956
          ],
          [
            14.933606,
            52.428589,
            126.686951
          ],
          [
            14.933878,
            52.428498,
            127.140094
          ],
          [
            14.934189,
            52.428411,
            127.440511
          ],
          [
            14.934472,
            52.42831,
            127.728317
          ],
          [
            14.934779,
            52.428221,
            128.02653
          ],
          [
            14.935079,
            52.428132,
            128.319219
          ],
          [
            14.935379,
            52.428045,
            128.610675
          ],
          [
            14.935683,
            52.427952,
            128.909072
          ],
          [
            14.935997,
            52.42786,
            129.217867
          ],
          [
            14.936289,
            52.427793,
            129.491898
          ],
          [
            14.936595,
            52.427733,
            130.188873
          ],
          [
            14.936904,
            52.427702,
            131.121614
          ],
          [
            14.937198,
            52.427633,
            132.057119
          ],
          [
            14.937499,
            52.427591,
            132.974655
          ],
          [
            14.937826,
            52.427538,
            133.982846
          ],
          [
            14.938124,
            52.427492,
            134.895025
          ],
          [
            14.938424,
            52.427436,
            135.827101
          ],
          [
            14.938752,
            52.427385,
            136.833949
          ],
          [
            14.939073,
            52.427321,
            137.836011
          ],
          [
            14.939394,
            52.427273,
            138.701217
          ],
          [
            14.939705,
            52.427189,
            139.462372
          ],
          [
            14.940002,
            52.427138,
            140.153138
          ],
          [
            14.940286,
            52.427082,
            140.817738
          ],
          [
            14.940578,
            52.427,
            141.535098
          ],
          [
            14.94091,
            52.426969,
            142.283005
          ],
          [
            14.941216,
            52.426908,
            143.000777
          ],
          [
            14.941487,
            52.426806,
            143.70989
          ],
          [
            14.941806,
            52.426729,
            144.485691
          ],
          [
            14.942096,
            52.426665,
            145.089012
          ],
          [
            14.94239,
            52.426583,
            145.568131
          ],
          [
            14.9427,
            52.426495,
            146.07601
          ],
          [
            14.942985,
            52.426426,
            146.534518
          ],
          [
            14.943332,
            52.426363,
            147.071007
          ],
          [
            14.943666,
            52.426293,
            147.594059
          ],
          [
            14.94394,
            52.426225,
            148.032621
          ],
          [
            14.944278,
            52.426176,
            148.54715
          ],
          [
            14.944579,
            52.426103,
            149.02939
          ],
          [
            14.944872,
            52.426025,
            149.166696
          ],
          [
            14.945195,
            52.425938,
            148.88575
          ],
          [
            14.945495,
            52.425889,
            148.64018
          ],
          [
            14.945819,
            52.425888,
            148.384228
          ],
          [
            14.946154,
            52.425882,
            148.119306
          ],
          [
            14.946503,
            52.425851,
            147.840714
          ],
          [
            14.946801,
            52.425819,
            147.598853
          ],
          [
            14.947197,
            52.42581,
            147.285407
          ],
          [
            14.947573,
            52.425785,
            146.98683
          ],
          [
            14.947916,
            52.425781,
            146.858289
          ],
          [
            14.948213,
            52.425715,
            146.754587
          ],
          [
            14.948586,
            52.425677,
            146.632299
          ],
          [
            14.948971,
            52.425649,
            146.506947
          ],
          [
            14.949331,
            52.425628,
            146.389395
          ],
          [
            14.949729,
            52.425595,
            146.25904
          ],
          [
            14.950106,
            52.425578,
            146.1368
          ],
          [
            14.950467,
            52.425553,
            146.019352
          ],
          [
            14.950879,
            52.425518,
            145.650572
          ],
          [
            14.951255,
            52.425497,
            145.290528
          ],
          [
            14.951623,
            52.425457,
            144.93373
          ],
          [
            14.951982,
            52.425435,
            144.589804
          ],
          [
            14.952323,
            52.425402,
            144.257797
          ],
          [
            14.952728,
            52.425381,
            143.869996
          ],
          [
            14.953079,
            52.425364,
            143.534299
          ],
          [
            14.953384,
            52.425273,
            143.206518
          ],
          [
            14.953709,
            52.425286,
            144.465998
          ],
          [
            14.954044,
            52.425345,
            145.861918
          ],
          [
            14.954364,
            52.425329,
            147.146809
          ],
          [
            14.954676,
            52.425283,
            148.43144
          ],
          [
            14.954974,
            52.425278,
            149.651406
          ],
          [
            14.955278,
            52.425262,
            150.903439
          ],
          [
            14.955612,
            52.425263,
            152.241374
          ],
          [
            14.955997,
            52.425304,
            153.806033
          ],
          [
            14.956313,
            52.425328,
            155.034525
          ],
          [
            14.95666,
            52.425328,
            155.630023
          ],
          [
            14.957003,
            52.425328,
            156.219426
          ],
          [
            14.95732,
            52.425342,
            156.767872
          ],
          [
            14.957643,
            52.42534,
            157.324142
          ],
          [
            14.957973,
            52.425361,
            157.892705
          ],
          [
            14.95833,
            52.425365,
            158.505707
          ],
          [
            14.9587,
            52.42538,
            159.141106
          ],
          [
            14.959039,
            52.425388,
            159.725546
          ],
          [
            14.959385,
            52.425403,
            159.702161
          ],
          [
            14.95977,
            52.425404,
            158.844304
          ],
          [
            14.960179,
            52.42539,
            157.931857
          ],
          [
            14.960463,
            52.425326,
            157.251876
          ],
          [
            14.960788,
            52.425275,
            156.504918
          ],
          [
            14.96117,
            52.425204,
            155.615974
          ],
          [
            14.961582,
            52.425108,
            154.634171
          ],
          [
            14.962004,
            52.425015,
            153.635208
          ],
          [
            14.962428,
            52.424918,
            153.185068
          ],
          [
            14.962772,
            52.42474,
            152.831168
          ],
          [
            14.963105,
            52.424582,
            152.49624
          ],
          [
            14.96345,
            52.42439,
            152.131603
          ],
          [
            14.963791,
            52.42418,
            151.753328
          ],
          [
            14.964127,
            52.424035,
            151.431419
          ],
          [
            14.964511,
            52.423937,
            151.286614
          ],
          [
            14.964751,
            52.423721,
            151.703525
          ],
          [
            14.965027,
            52.423613,
            152.018745
          ],
          [
            14.965211,
            52.423409,
            152.385558
          ],
          [
            14.965427,
            52.423221,
            152.747237
          ],
          [
            14.965662,
            52.423073,
            153.071806
          ],
          [
            14.96588,
            52.42293,
            153.379782
          ],
          [
            14.966084,
            52.422771,
            153.69784
          ],
          [
            14.966364,
            52.422678,
            154.004311
          ],
          [
            14.966717,
            52.422654,
            153.923375
          ],
          [
            14.967044,
            52.422604,
            153.828704
          ],
          [
            14.967356,
            52.42253,
            153.734742
          ],
          [
            14.967665,
            52.42242,
            153.634262
          ],
          [
            14.968006,
            52.422393,
            153.53788
          ],
          [
            14.968318,
            52.422348,
            153.447229
          ],
          [
            14.968602,
            52.422264,
            153.358707
          ],
          [
            14.968813,
            52.42213,
            153.273084
          ],
          [
            14.969121,
            52.422062,
            153.345259
          ],
          [
            14.969429,
            52.421963,
            154.672019
          ],
          [
            14.969685,
            52.421845,
            155.908958
          ],
          [
            14.969966,
            52.421769,
            157.09476
          ],
          [
            14.970256,
            52.421671,
            158.360377
          ],
          [
            14.970553,
            52.42156,
            159.686894
          ],
          [
            14.970813,
            52.421463,
            160.849516
          ],
          [
            14.971096,
            52.421373,
            162.064849
          ],
          [
            14.971397,
            52.421285,
            163.337395
          ],
          [
            14.971636,
            52.421131,
            164.514743
          ],
          [
            14.971861,
            52.420946,
            165.063578
          ],
          [
            14.972155,
            52.420794,
            165.625789
          ],
          [
            14.972458,
            52.420696,
            166.124837
          ],
          [
            14.972746,
            52.42057,
            166.640401
          ],
          [
            14.973028,
            52.420442,
            167.151377
          ],
          [
            14.973309,
            52.420325,
            167.645755
          ],
          [
            14.97361,
            52.420223,
            168.146158
          ],
          [
            14.973908,
            52.420124,
            168.645268
          ],
          [
            14.9742,
            52.419993,
            168.978445
          ],
          [
            14.974517,
            52.419875,
            169.293061
          ],
          [
            14.97484,
            52.419745,
            169.620914
          ],
          [
            14.975089,
            52.419612,
            169.901292
          ],
          [
            14.975262,
            52.419452,
            170.167703
          ],
          [
            14.975403,
            52.41928,
            170.434805
          ],
          [
            14.9755,
            52.419108,
            170.687654
          ],
          [
            14.975608,
            52.418898,
            170.993648
          ],
          [
            14.975728,
            52.418718,
            171.110609
          ],
          [
            14.975837,
            52.418537,
            170.677527
          ],
          [
            14.976002,
            52.41836,
            170.220542
          ],
          [
            14.976233,
            52.418195,
            169.732513
          ],
          [
            14.976527,
            52.418038,
            169.197932
          ],
          [
            14.97683,
            52.41791,
            168.693547
          ],
          [
            14.977208,
            52.417796,
            168.116484
          ],
          [
            14.97753,
            52.417707,
            167.632843
          ],
          [
            14.977912,
            52.417609,
            167.143464
          ],
          [
            14.978184,
            52.417534,
            167.033869
          ],
          [
            14.978487,
            52.417466,
            166.91533
          ],
          [
            14.978852,
            52.417376,
            166.77078
          ],
          [
            14.979156,
            52.417305,
            166.651229
          ],
          [
            14.979552,
            52.417211,
            166.495187
          ],
          [
            14.979887,
            52.417127,
            166.362164
          ],
          [
            14.980284,
            52.417038,
            166.206854
          ],
          [
            14.980717,
            52.41699,
            166.110947
          ],
          [
            14.981043,
            52.416972,
            166.170417
          ],
          [
            14.981419,
            52.416946,
            166.239287
          ],
          [
            14.981728,
            52.416924,
            166.295762
          ],
          [
            14.982075,
            52.416929,
            166.358903
          ],
          [
            14.982457,
            52.416901,
            166.428816
          ],
          [
            14.982822,
            52.416876,
            166.495567
          ],
          [
            14.983146,
            52.41686,
            166.554631
          ],
          [
            14.983482,
            52.416817,
            166.61709
          ],
          [
            14.983852,
            52.416776,
            166.123768
          ],
          [
            14.98421,
            52.416767,
            165.58985
          ],
          [
            14.984564,
            52.416731,
            165.055041
          ],
          [
            14.984942,
            52.416683,
            164.4796
          ],
          [
            14.985362,
            52.416608,
            163.826122
          ],
          [
            14.985611,
            52.416517,
            163.380159
          ],
          [
            14.985959,
            52.416469,
            162.848384
          ],
          [
            14.986249,
            52.416411,
            162.391516
          ],
          [
            14.986543,
            52.416386,
            162.267786
          ],
          [
            14.986897,
            52.416336,
            162.339607
          ],
          [
            14.987276,
            52.416294,
            162.415665
          ],
          [
            14.98759,
            52.416268,
            162.478808
          ],
          [
            14.987889,
            52.41625,
            162.538154
          ],
          [
            14.988237,
            52.416212,
            162.608025
          ],
          [
            14.988596,
            52.416171,
            162.68012
          ],
          [
            14.988939,
            52.416123,
            162.749474
          ],
          [
            14.989337,
            52.416053,
            162.762769
          ],
          [
            14.989717,
            52.415957,
            162.565706
          ],
          [
            14.989983,
            52.415864,
            162.418154
          ],
          [
            14.990298,
            52.415736,
            162.236686
          ],
          [
            14.99056,
            52.415624,
            162.083394
          ],
          [
            14.990807,
            52.415467,
            161.912415
          ],
          [
            14.990978,
            52.41529,
            161.751026
          ],
          [
            14.991198,
            52.415108,
            161.573265
          ],
          [
            14.991496,
            52.414963,
            161.395097
          ],
          [
            14.991793,
            52.414865,
            161.333989
          ],
          [
            14.9921,
            52.414779,
            161.272861
          ],
          [
            14.992364,
            52.414686,
            161.217691
          ],
          [
            14.992637,
            52.414578,
            161.158782
          ],
          [
            14.992937,
            52.414477,
            161.096773
          ],
          [
            14.993285,
            52.414367,
            161.025852
          ],
          [
            14.993561,
            52.414266,
            160.967585
          ],
          [
            14.993874,
            52.41416,
            160.902491
          ],
          [
            14.994135,
            52.414065,
            160.729572
          ],
          [
            14.994464,
            52.41395,
            160.198336
          ],
          [
            14.99472,
            52.413847,
            159.768807
          ],
          [
            14.994971,
            52.413746,
            159.347883
          ],
          [
            14.995232,
            52.413607,
            158.85894
          ],
          [
            14.995487,
            52.413494,
            158.417216
          ],
          [
            14.995754,
            52.41339,
            157.972038
          ],
          [
            14.996037,
            52.413297,
            157.521757
          ],
          [
            14.996345,
            52.413152,
            156.976874
          ],
          [
            14.996601,
            52.413063,
            156.852667
          ],
          [
            14.996845,
            52.412943,
            157.140164
          ],
          [
            14.997094,
            52.412815,
            157.438806
          ],
          [
            14.9974,
            52.412688,
            157.7783
          ],
          [
            14.997752,
            52.412576,
            158.144795
          ],
          [
            14.998106,
            52.412556,
            158.476565
          ],
          [
            14.998442,
            52.412614,
            158.797836
          ],
          [
            14.998754,
            52.412678,
            159.0997
          ],
          [
            14.999026,
            52.412762,
            159.385068
          ],
          [
            14.999336,
            52.412848,
            159.790763
          ],
          [
            14.999646,
            52.412912,
            160.1982
          ],
          [
            14.999953,
            52.412976,
            160.601866
          ],
          [
            15.000289,
            52.413032,
            161.035313
          ],
          [
            15.000591,
            52.413086,
            161.426871
          ],
          [
            15.000882,
            52.413148,
            161.810588
          ],
          [
            15.001166,
            52.413216,
            162.192311
          ],
          [
            15.001473,
            52.413281,
            162.596765
          ],
          [
            15.001809,
            52.413351,
            163.038818
          ],
          [
            15.00214,
            52.41343,
            163.057524
          ],
          [
            15.002479,
            52.413532,
            162.992119
          ],
          [
            15.00279,
            52.413607,
            162.934414
          ],
          [
            15.003118,
            52.413678,
            162.874353
          ],
          [
            15.003427,
            52.413728,
            162.819199
          ],
          [
            15.003739,
            52.4138,
            162.761642
          ],
          [
            15.004042,
            52.41387,
            162.705722
          ],
          [
            15.004357,
            52.413939,
            162.647933
          ],
          [
            15.004672,
            52.414001,
            162.502898
          ],
          [
            15.004992,
            52.414064,
            161.918679
          ],
          [
            15.005315,
            52.414144,
            161.313179
          ],
          [
            15.00563,
            52.414231,
            160.712646
          ],
          [
            15.005969,
            52.414308,
            160.084408
          ],
          [
            15.006327,
            52.414371,
            159.435419
          ],
          [
            15.00668,
            52.414466,
            158.764982
          ],
          [
            15.007018,
            52.414539,
            158.142268
          ],
          [
            15.007301,
            52.414605,
            157.61466
          ],
          [
            15.007616,
            52.414686,
            157.511107
          ],
          [
            15.007929,
            52.414755,
            157.551172
          ],
          [
            15.008218,
            52.414825,
            157.588743
          ],
          [
            15.008567,
            52.414897,
            157.633094
          ],
          [
            15.008911,
            52.414989,
            157.67831
          ],
          [
            15.009314,
            52.415066,
            157.729153
          ],
          [
            15.009699,
            52.415146,
            157.778116
          ],
          [
            15.010105,
            52.415258,
            157.831792
          ],
          [
            15.010378,
            52.415332,
            157.626313
          ],
          [
            15.010662,
            52.41541,
            157.393668
          ],
          [
            15.010964,
            52.415476,
            157.154053
          ],
          [
            15.011259,
            52.415535,
            156.92162
          ],
          [
            15.011564,
            52.415608,
            156.676913
          ],
          [
            15.011863,
            52.41569,
            156.431188
          ],
          [
            15.012215,
            52.41577,
            156.150618
          ],
          [
            15.012526,
            52.415843,
            155.901417
          ],
          [
            15.012825,
            52.415908,
            155.664127
          ],
          [
            15.013166,
            52.415975,
            155.677146
          ],
          [
            15.013507,
            52.416051,
            155.729332
          ],
          [
            15.013834,
            52.416138,
            155.780578
          ],
          [
            15.014176,
            52.416198,
            155.831942
          ],
          [
            15.014537,
            52.416277,
            155.886946
          ],
          [
            15.014881,
            52.416364,
            155.940354
          ],
          [
            15.015234,
            52.416446,
            155.994552
          ],
          [
            15.015599,
            52.416539,
            156.0513
          ],
          [
            15.015999,
            52.41663,
            155.018972
          ],
          [
            15.016345,
            52.416723,
            154.047677
          ],
          [
            15.016746,
            52.416809,
            152.953756
          ],
          [
            15.01704,
            52.416894,
            152.117276
          ],
          [
            15.017347,
            52.416966,
            151.272097
          ],
          [
            15.0177,
            52.41704,
            150.313194
          ],
          [
            15.0181,
            52.417137,
            149.207158
          ],
          [
            15.018505,
            52.417203,
            148.24067
          ],
          [
            15.018969,
            52.417315,
            147.366837
          ],
          [
            15.019444,
            52.417417,
            146.485757
          ],
          [
            15.019928,
            52.417533,
            145.575626
          ],
          [
            15.020411,
            52.417643,
            144.673682
          ],
          [
            15.020913,
            52.417754,
            143.736638
          ],
          [
            15.02136,
            52.417849,
            143.471819
          ],
          [
            15.021767,
            52.417941,
            143.749824
          ],
          [
            15.022174,
            52.41803,
            144.026621
          ],
          [
            15.022559,
            52.418117,
            144.289414
          ],
          [
            15.022913,
            52.418185,
            144.527111
          ],
          [
            15.023281,
            52.418241,
            144.770013
          ],
          [
            15.023621,
            52.418302,
            144.996927
          ],
          [
            15.023978,
            52.418358,
            145.258622
          ],
          [
            15.024304,
            52.418405,
            145.695632
          ],
          [
            15.024666,
            52.418434,
            146.168213
          ],
          [
            15.024975,
            52.418466,
            146.575668
          ],
          [
            15.025336,
            52.41853,
            147.06353
          ],
          [
            15.025691,
            52.418635,
            147.588034
          ],
          [
            15.026058,
            52.418688,
            148.100757
          ],
          [
            15.026406,
            52.418756,
            148.576241
          ],
          [
            15.02673,
            52.418832,
            149.013205
          ],
          [
            15.027091,
            52.418842,
            147.70183
          ],
          [
            15.027479,
            52.418847,
            146.28751
          ],
          [
            15.027809,
            52.418872,
            145.087455
          ],
          [
            15.028132,
            52.418856,
            143.906555
          ],
          [
            15.028479,
            52.418904,
            142.62151
          ],
          [
            15.028865,
            52.418986,
            141.146214
          ],
          [
            15.029248,
            52.419034,
            139.732336
          ],
          [
            15.029642,
            52.419147,
            138.205074
          ],
          [
            15.029913,
            52.419268,
            137.266247
          ],
          [
            15.030167,
            52.419387,
            136.368607
          ],
          [
            15.030487,
            52.419558,
            135.179796
          ],
          [
            15.030746,
            52.419758,
            134.018515
          ],
          [
            15.030929,
            52.419921,
            133.118759
          ],
          [
            15.031181,
            52.420125,
            131.955716
          ],
          [
            15.031328,
            52.420303,
            131.040376
          ],
          [
            15.03146,
            52.420499,
            130.380483
          ],
          [
            15.031616,
            52.420663,
            131.772236
          ],
          [
            15.031716,
            52.420839,
            133.195114
          ],
          [
            15.031829,
            52.42103,
            134.669516
          ],
          [
            15.031958,
            52.421219,
            136.157726
          ],
          [
            15.032103,
            52.421398,
            137.607416
          ],
          [
            15.032268,
            52.421559,
            138.986325
          ],
          [
            15.032481,
            52.421743,
            140.626917
          ],
          [
            15.032717,
            52.421891,
            142.126897
          ],
          [
            15.032977,
            52.422018,
            143.244489
          ],
          [
            15.033275,
            52.422114,
            143.21635
          ],
          [
            15.033605,
            52.42219,
            143.186765
          ],
          [
            15.033914,
            52.422305,
            143.156518
          ],
          [
            15.034161,
            52.422432,
            143.128583
          ],
          [
            15.034468,
            52.422535,
            143.099076
          ],
          [
            15.034796,
            52.422506,
            143.071257
          ],
          [
            15.035173,
            52.422471,
            143.03655
          ],
          [
            15.035497,
            52.422509,
            143.008121
          ],
          [
            15.035787,
            52.422426,
            143.864817
          ],
          [
            15.036067,
            52.422356,
            144.760055
          ],
          [
            15.03642,
            52.422341,
            145.798904
          ],
          [
            15.036782,
            52.422317,
            146.859826
          ],
          [
            15.037139,
            52.422327,
            147.900885
          ],
          [
            15.037462,
            52.422346,
            148.849525
          ],
          [
            15.037825,
            52.422368,
            149.91445
          ],
          [
            15.038165,
            52.422404,
            150.919615
          ],
          [
            15.038538,
            52.422443,
            151.756355
          ],
          [
            15.038885,
            52.422485,
            152.144816
          ],
          [
            15.03925,
            52.422512,
            152.548049
          ],
          [
            15.039573,
            52.42255,
            152.909478
          ],
          [
            15.039936,
            52.42259,
            153.316437
          ],
          [
            15.040232,
            52.422614,
            153.644079
          ],
          [
            15.04058,
            52.422637,
            154.028182
          ],
          [
            15.040878,
            52.422665,
            154.359012
          ],
          [
            15.041209,
            52.422688,
            154.724389
          ],
          [
            15.041528,
            52.422711,
            154.802349
          ],
          [
            15.041836,
            52.422718,
            154.763619
          ],
          [
            15.042222,
            52.422754,
            154.715048
          ],
          [
            15.042588,
            52.422796,
            154.668705
          ],
          [
            15.043004,
            52.422831,
            154.616419
          ],
          [
            15.043363,
            52.422865,
            154.571208
          ],
          [
            15.043736,
            52.422901,
            154.524241
          ],
          [
            15.044124,
            52.422935,
            154.47549
          ],
          [
            15.044531,
            52.422972,
            154.988211
          ],
          [
            15.044907,
            52.422999,
            155.61418
          ],
          [
            15.045261,
            52.423036,
            156.207926
          ],
          [
            15.045589,
            52.423062,
            156.754717
          ],
          [
            15.045917,
            52.423096,
            157.307358
          ],
          [
            15.046238,
            52.423123,
            157.84303
          ],
          [
            15.046558,
            52.423154,
            158.37866
          ],
          [
            15.046893,
            52.423186,
            158.941663
          ],
          [
            15.047229,
            52.423222,
            159.598276
          ],
          [
            15.047563,
            52.423246,
            160.465064
          ],
          [
            15.047903,
            52.423274,
            161.349155
          ],
          [
            15.048255,
            52.423311,
            162.269696
          ],
          [
            15.048592,
            52.423313,
            163.137533
          ],
          [
            15.048898,
            52.423361,
            163.954627
          ],
          [
            15.049204,
            52.423369,
            164.745538
          ],
          [
            15.049527,
            52.423416,
            165.600847
          ],
          [
            15.049862,
            52.423447,
            166.477242
          ],
          [
            15.05021,
            52.42346,
            167.262622
          ],
          [
            15.05053,
            52.423513,
            167.899262
          ],
          [
            15.050856,
            52.42353,
            168.52811
          ],
          [
            15.051176,
            52.423547,
            169.144477
          ],
          [
            15.051501,
            52.423584,
            169.780789
          ],
          [
            15.051845,
            52.423589,
            170.442641
          ],
          [
            15.052173,
            52.423607,
            171.076272
          ],
          [
            15.052473,
            52.423638,
            171.66062
          ],
          [
            15.05283,
            52.423668,
            172.352349
          ],
          [
            15.053171,
            52.423695,
            172.94815
          ],
          [
            15.05348,
            52.423725,
            173.457272
          ],
          [
            15.053816,
            52.423767,
            174.015641
          ],
          [
            15.054133,
            52.423801,
            174.539403
          ],
          [
            15.054477,
            52.423821,
            175.101024
          ],
          [
            15.054794,
            52.42386,
            175.628128
          ],
          [
            15.055126,
            52.423892,
            176.175463
          ],
          [
            15.055467,
            52.423937,
            176.742958
          ],
          [
            15.055796,
            52.423953,
            177.28045
          ],
          [
            15.056103,
            52.423973,
            177.64184
          ],
          [
            15.056415,
            52.423996,
            177.972967
          ],
          [
            15.056769,
            52.424024,
            178.34739
          ],
          [
            15.057134,
            52.424062,
            178.735593
          ],
          [
            15.057488,
            52.424089,
            179.109621
          ],
          [
            15.057864,
            52.424114,
            179.506128
          ],
          [
            15.05824,
            52.424145,
            179.904313
          ],
          [
            15.058581,
            52.424173,
            180.265089
          ],
          [
            15.058915,
            52.424207,
            180.546166
          ],
          [
            15.059207,
            52.424235,
            180.69449
          ],
          [
            15.05955,
            52.424272,
            180.869269
          ],
          [
            15.059851,
            52.424291,
            181.021078
          ],
          [
            15.060198,
            52.424316,
            181.196373
          ],
          [
            15.060499,
            52.424337,
            181.348383
          ],
          [
            15.060863,
            52.42436,
            181.531971
          ],
          [
            15.061261,
            52.424403,
            181.734854
          ],
          [
            15.061672,
            52.424454,
            181.945324
          ],
          [
            15.062032,
            52.424484,
            181.856371
          ],
          [
            15.0624,
            52.424512,
            181.7453
          ],
          [
            15.062759,
            52.42454,
            181.63688
          ],
          [
            15.063131,
            52.424582,
            181.523709
          ],
          [
            15.063494,
            52.424612,
            181.414068
          ],
          [
            15.063894,
            52.42466,
            181.292113
          ],
          [
            15.064274,
            52.424682,
            181.177789
          ],
          [
            15.064683,
            52.424722,
            181.099052
          ],
          [
            15.065099,
            52.424757,
            181.23258
          ],
          [
            15.065468,
            52.424796,
            181.351715
          ],
          [
            15.065862,
            52.424828,
            181.478069
          ],
          [
            15.066216,
            52.42485,
            181.591217
          ],
          [
            15.066556,
            52.424875,
            181.700185
          ],
          [
            15.066939,
            52.424904,
            181.822883
          ],
          [
            15.06731,
            52.424945,
            181.942783
          ],
          [
            15.067653,
            52.42496,
            182.406193
          ],
          [
            15.067982,
            52.424982,
            183.470796
          ],
          [
            15.068302,
            52.424981,
            184.501762
          ],
          [
            15.068628,
            52.424993,
            185.552727
          ],
          [
            15.068938,
            52.425014,
            186.556431
          ],
          [
            15.069244,
            52.42504,
            187.552013
          ],
          [
            15.069547,
            52.425099,
            188.579258
          ],
          [
            15.069651,
            52.425275,
            189.632356
          ],
          [
            15.069917,
            52.425429,
            190.855402
          ],
          [
            15.069759,
            52.425342,
            191.416171
          ],
          [
            15.069866,
            52.42543,
            191.257206
          ],
          [
            15.069612,
            52.425239,
            191.063083
          ],
          [
            15.069626,
            52.42503,
            190.897278
          ],
          [
            15.069858,
            52.424889,
            190.737743
          ],
          [
            15.070109,
            52.424765,
            190.582244
          ],
          [
            15.070315,
            52.424631,
            190.436449
          ],
          [
            15.070588,
            52.424524,
            190.278021
          ],
          [
            15.070575,
            52.424548,
            190.12374
          ],
          [
            15.070333,
            52.424668,
            189.897523
          ],
          [
            15.070364,
            52.424867,
            189.647327
          ],
          [
            15.070384,
            52.425063,
            189.401031
          ],
          [
            15.070395,
            52.425247,
            189.170423
          ],
          [
            15.070397,
            52.425458,
            188.905878
          ],
          [
            15.070372,
            52.425679,
            188.627805
          ],
          [
            15.070329,
            52.425867,
            188.390191
          ],
          [
            15.070296,
            52.426094,
            188.104936
          ],
          [
            15.070241,
            52.426343,
            187.802177
          ],
          [
            15.070173,
            52.426551,
            187.616131
          ],
          [
            15.070114,
            52.426776,
            187.416173
          ],
          [
            15.070079,
            52.427026,
            187.19603
          ],
          [
            15.07005,
            52.427245,
            187.002913
          ],
          [
            15.07001,
            52.427487,
            186.789522
          ],
          [
            15.069953,
            52.427712,
            186.589794
          ],
          [
            15.069904,
            52.42792,
            186.405388
          ],
          [
            15.069855,
            52.428135,
            186.281713
          ],
          [
            15.069805,
            52.428333,
            186.42335
          ],
          [
            15.069711,
            52.428557,
            186.58685
          ],
          [
            15.069624,
            52.428753,
            186.730945
          ],
          [
            15.069542,
            52.428953,
            186.876709
          ],
          [
            15.069522,
            52.429161,
            187.024027
          ],
          [
            15.0696,
            52.42938,
            187.184035
          ],
          [
            15.069828,
            52.429542,
            187.336254
          ],
          [
            15.070215,
            52.429655,
            187.521247
          ],
          [
            15.070519,
            52.429673,
            186.723266
          ],
          [
            15.070909,
            52.429707,
            185.670018
          ],
          [
            15.071461,
            52.429744,
            184.187306
          ],
          [
            15.07187,
            52.429739,
            183.096364
          ],
          [
            15.072193,
            52.429763,
            182.226767
          ],
          [
            15.072565,
            52.429784,
            181.229273
          ],
          [
            15.073001,
            52.429793,
            180.065507
          ],
          [
            15.073434,
            52.429805,
            179.107933
          ],
          [
            15.073901,
            52.429824,
            178.190679
          ],
          [
            15.074374,
            52.429849,
            177.260273
          ],
          [
            15.074816,
            52.429855,
            176.393723
          ],
          [
            15.075228,
            52.429851,
            175.584629
          ],
          [
            15.075658,
            52.429906,
            174.723136
          ],
          [
            15.076039,
            52.429913,
            173.97354
          ],
          [
            15.076364,
            52.429929,
            173.406358
          ],
          [
            15.076704,
            52.42996,
            172.823035
          ],
          [
            15.077062,
            52.42996,
            172.21527
          ],
          [
            15.077448,
            52.429964,
            171.560295
          ],
          [
            15.077843,
            52.42997,
            170.889144
          ],
          [
            15.07826,
            52.42998,
            170.180581
          ],
          [
            15.078668,
            52.429995,
            169.486999
          ],
          [
            15.079076,
            52.43,
            168.781771
          ],
          [
            15.079493,
            52.430022,
            167.959765
          ],
          [
            15.079896,
            52.43005,
            167.162594
          ],
          [
            15.080301,
            52.430071,
            166.364746
          ],
          [
            15.080717,
            52.430105,
            165.54021
          ],
          [
            15.081127,
            52.430137,
            164.728617
          ],
          [
            15.081575,
            52.430159,
            163.84637
          ],
          [
            15.082005,
            52.430196,
            163.045802
          ],
          [
            15.082415,
            52.430217,
            162.707872
          ],
          [
            15.082824,
            52.430236,
            162.371209
          ],
          [
            15.083212,
            52.43026,
            162.050475
          ],
          [
            15.083627,
            52.430288,
            161.70763
          ],
          [
            15.084046,
            52.430326,
            161.359968
          ],
          [
            15.084452,
            52.430355,
            161.024448
          ],
          [
            15.084857,
            52.430379,
            160.690399
          ],
          [
            15.085243,
            52.430412,
            160.715819
          ],
          [
            15.085599,
            52.430433,
            160.769861
          ],
          [
            15.085947,
            52.430461,
            160.822903
          ],
          [
            15.086288,
            52.430492,
            160.875131
          ],
          [
            15.086645,
            52.43051,
            160.929261
          ],
          [
            15.086981,
            52.430544,
            160.980712
          ],
          [
            15.087321,
            52.430572,
            161.032538
          ],
          [
            15.087653,
            52.430588,
            161.082887
          ],
          [
            15.087968,
            52.430614,
            161.003093
          ],
          [
            15.088334,
            52.430615,
            160.753313
          ],
          [
            15.088645,
            52.43062,
            160.541461
          ],
          [
            15.088944,
            52.43064,
            160.336649
          ],
          [
            15.089329,
            52.430677,
            160.069546
          ],
          [
            15.089642,
            52.430706,
            159.853677
          ],
          [
            15.089944,
            52.430714,
            159.647558
          ],
          [
            15.090293,
            52.430748,
            159.406898
          ],
          [
            15.090605,
            52.430776,
            159.192169
          ],
          [
            15.090976,
            52.430804,
            159.133324
          ],
          [
            15.091342,
            52.430816,
            159.186197
          ],
          [
            15.091644,
            52.430849,
            159.230236
          ],
          [
            15.092011,
            52.430873,
            159.283458
          ],
          [
            15.092316,
            52.430896,
            159.327828
          ],
          [
            15.092737,
            52.430923,
            159.388617
          ],
          [
            15.093043,
            52.430955,
            159.433259
          ],
          [
            15.093351,
            52.430972,
            159.477761
          ],
          [
            15.093671,
            52.430993,
            159.505327
          ],
          [
            15.094058,
            52.431025,
            158.857735
          ],
          [
            15.094451,
            52.431053,
            158.203617
          ],
          [
            15.094751,
            52.43108,
            157.702665
          ],
          [
            15.095127,
            52.43112,
            157.072231
          ],
          [
            15.09548,
            52.431208,
            156.43962
          ],
          [
            15.095752,
            52.431314,
            155.904642
          ],
          [
            15.096033,
            52.431437,
            155.333315
          ],
          [
            15.096295,
            52.431573,
            154.764278
          ],
          [
            15.096583,
            52.431771,
            154.122484
          ],
          [
            15.096837,
            52.43196,
            153.54345
          ],
          [
            15.097101,
            52.432129,
            152.990378
          ],
          [
            15.097397,
            52.432324,
            152.360696
          ],
          [
            15.09772,
            52.432522,
            151.698642
          ],
          [
            15.098043,
            52.432759,
            150.968038
          ],
          [
            15.09844,
            52.432965,
            150.064758
          ],
          [
            15.098705,
            52.433163,
            148.937876
          ],
          [
            15.09898,
            52.433346,
            147.842774
          ],
          [
            15.099278,
            52.433515,
            146.743564
          ],
          [
            15.099608,
            52.433733,
            145.435332
          ],
          [
            15.099975,
            52.433987,
            143.941437
          ],
          [
            15.100264,
            52.434193,
            142.743719
          ],
          [
            15.100558,
            52.434401,
            141.34159
          ],
          [
            15.100874,
            52.434578,
            139.947253
          ],
          [
            15.101189,
            52.434778,
            138.471709
          ],
          [
            15.101565,
            52.43505,
            136.577823
          ],
          [
            15.101765,
            52.435213,
            135.494745
          ],
          [
            15.102057,
            52.435434,
            133.982964
          ],
          [
            15.102233,
            52.435594,
            132.957927
          ],
          [
            15.102431,
            52.435756,
            132.234654
          ],
          [
            15.102605,
            52.435933,
            131.521171
          ],
          [
            15.102756,
            52.436116,
            130.810686
          ],
          [
            15.102894,
            52.436313,
            130.068923
          ],
          [
            15.103034,
            52.436579,
            129.102377
          ],
          [
            15.103085,
            52.436844,
            128.177482
          ],
          [
            15.103125,
            52.437112,
            127.246844
          ],
          [
            15.103178,
            52.437456,
            126.413219
          ],
          [
            15.103203,
            52.437763,
            125.972475
          ],
          [
            15.103222,
            52.438052,
            125.557769
          ],
          [
            15.103278,
            52.438309,
            125.18488
          ],
          [
            15.1033,
            52.438566,
            124.815833
          ],
          [
            15.103343,
            52.438789,
            124.493891
          ],
          [
            15.103401,
            52.439002,
            124.184059
          ],
          [
            15.103454,
            52.439201,
            123.870403
          ],
          [
            15.103582,
            52.439396,
            123.533384
          ],
          [
            15.10375,
            52.439559,
            123.224117
          ],
          [
            15.103919,
            52.439723,
            122.910176
          ],
          [
            15.104123,
            52.439915,
            122.543936
          ],
          [
            15.104305,
            52.440094,
            122.207
          ],
          [
            15.104511,
            52.440304,
            121.814957
          ],
          [
            15.104724,
            52.440483,
            121.461213
          ],
          [
            15.104959,
            52.440673,
            120.853535
          ],
          [
            15.105214,
            52.440795,
            120.008853
          ],
          [
            15.105536,
            52.440865,
            119.118908
          ],
          [
            15.105874,
            52.440925,
            118.205572
          ],
          [
            15.106217,
            52.441014,
            117.23808
          ],
          [
            15.106568,
            52.441153,
            116.150982
          ],
          [
            15.106872,
            52.441346,
            115.009467
          ],
          [
            15.107166,
            52.441524,
            113.934462
          ],
          [
            15.107502,
            52.44171,
            113.286578
          ],
          [
            15.107873,
            52.4419,
            112.859932
          ],
          [
            15.108295,
            52.442096,
            112.392732
          ],
          [
            15.108699,
            52.442307,
            111.924308
          ],
          [
            15.109059,
            52.442523,
            111.479538
          ],
          [
            15.109395,
            52.442698,
            111.090456
          ],
          [
            15.109695,
            52.442853,
            111.21206
          ],
          [
            15.109971,
            52.442971,
            111.554876
          ],
          [
            15.110274,
            52.443094,
            111.925777
          ],
          [
            15.110578,
            52.44321,
            112.290486
          ],
          [
            15.110819,
            52.443324,
            112.60093
          ],
          [
            15.11107,
            52.4433,
            112.912508
          ],
          [
            15.111178,
            52.443103,
            113.259277
          ],
          [
            15.1113,
            52.442902,
            113.617789
          ],
          [
            15.111445,
            52.442725,
            113.948431
          ],
          [
            15.111592,
            52.442559,
            114.522833
          ],
          [
            15.111729,
            52.442393,
            115.099886
          ],
          [
            15.1119,
            52.442216,
            115.737902
          ],
          [
            15.112086,
            52.442042,
            116.383307
          ],
          [
            15.112256,
            52.44187,
            117.009294
          ],
          [
            15.112443,
            52.441673,
            117.716539
          ],
          [
            15.11263,
            52.441503,
            118.353616
          ],
          [
            15.112919,
            52.441445,
            118.954685
          ],
          [
            15.113178,
            52.441532,
            119.524287
          ],
          [
            15.113483,
            52.44167,
            119.439265
          ],
          [
            15.113713,
            52.441792,
            119.350208
          ],
          [
            15.113939,
            52.441921,
            119.259766
          ],
          [
            15.114223,
            52.442045,
            119.157772
          ],
          [
            15.114534,
            52.442134,
            119.057461
          ],
          [
            15.114813,
            52.44224,
            118.961434
          ],
          [
            15.115125,
            52.442297,
            118.866306
          ],
          [
            15.115474,
            52.442364,
            118.759446
          ],
          [
            15.11579,
            52.442418,
            118.879422
          ],
          [
            15.116072,
            52.442478,
            119.648893
          ],
          [
            15.116391,
            52.442536,
            120.508166
          ],
          [
            15.116703,
            52.442596,
            121.35098
          ],
          [
            15.117019,
            52.442644,
            122.189818
          ],
          [
            15.117346,
            52.442696,
            123.059725
          ],
          [
            15.117449,
            52.442844,
            123.910915
          ],
          [
            15.117545,
            52.442994,
            124.70653
          ],
          [
            15.117396,
            52.443198,
            125.650094
          ],
          [
            15.117275,
            52.443376,
            126.200787
          ],
          [
            15.117122,
            52.443587,
            125.778049
          ],
          [
            15.117001,
            52.443803,
            125.359821
          ],
          [
            15.116796,
            52.444006,
            124.922034
          ],
          [
            15.1166,
            52.444186,
            124.526181
          ],
          [
            15.116415,
            52.444402,
            124.079712
          ],
          [
            15.116225,
            52.444625,
            123.619335
          ],
          [
            15.116079,
            52.444862,
            123.155523
          ],
          [
            15.115891,
            52.445075,
            122.575545
          ],
          [
            15.11573,
            52.445286,
            121.9379
          ],
          [
            15.115594,
            52.445477,
            121.367444
          ],
          [
            15.115438,
            52.445669,
            120.780393
          ],
          [
            15.115293,
            52.445851,
            120.225676
          ],
          [
            15.115162,
            52.446027,
            119.696147
          ],
          [
            15.115007,
            52.44624,
            119.057195
          ],
          [
            15.114821,
            52.446455,
            118.390854
          ],
          [
            15.114598,
            52.446663,
            117.478218
          ],
          [
            15.114298,
            52.446794,
            116.454383
          ],
          [
            15.114113,
            52.446977,
            115.464397
          ],
          [
            15.114197,
            52.447192,
            114.454874
          ],
          [
            15.114387,
            52.447398,
            113.379293
          ],
          [
            15.114544,
            52.447608,
            112.328951
          ],
          [
            15.11467,
            52.447807,
            111.357055
          ],
          [
            15.114787,
            52.447995,
            110.441897
          ],
          [
            15.114915,
            52.448192,
            110.160664
          ],
          [
            15.115025,
            52.448389,
            110.855765
          ],
          [
            15.115141,
            52.448586,
            111.555508
          ],
          [
            15.115246,
            52.448782,
            112.243936
          ],
          [
            15.115366,
            52.448984,
            112.961189
          ],
          [
            15.115468,
            52.449182,
            113.654354
          ],
          [
            15.11556,
            52.449364,
            114.290394
          ],
          [
            15.115644,
            52.449553,
            114.944121
          ],
          [
            15.115708,
            52.449743,
            115.591839
          ],
          [
            15.115818,
            52.449939,
            116.055932
          ],
          [
            15.1159,
            52.450161,
            116.390945
          ],
          [
            15.115956,
            52.450356,
            116.682612
          ],
          [
            15.116038,
            52.45054,
            116.963221
          ],
          [
            15.116112,
            52.450721,
            117.237856
          ],
          [
            15.116212,
            52.450924,
            117.549803
          ],
          [
            15.116261,
            52.451103,
            117.816893
          ],
          [
            15.116358,
            52.451309,
            118.132453
          ],
          [
            15.116441,
            52.451514,
            118.443374
          ],
          [
            15.116491,
            52.451736,
            118.480505
          ],
          [
            15.116555,
            52.451937,
            118.429374
          ],
          [
            15.116627,
            52.45213,
            118.379897
          ],
          [
            15.116708,
            52.452332,
            118.327953
          ],
          [
            15.116781,
            52.452537,
            118.275516
          ],
          [
            15.116852,
            52.452755,
            118.220021
          ],
          [
            15.116929,
            52.452955,
            118.168726
          ],
          [
            15.11702,
            52.45315,
            118.118105
          ],
          [
            15.117093,
            52.453357,
            118.060238
          ],
          [
            15.117156,
            52.453553,
            117.982131
          ],
          [
            15.117207,
            52.453769,
            117.896796
          ],
          [
            15.117256,
            52.453968,
            117.818105
          ],
          [
            15.117292,
            52.454155,
            117.743744
          ],
          [
            15.117358,
            52.454331,
            117.673088
          ],
          [
            15.117444,
            52.454558,
            117.581964
          ],
          [
            15.117514,
            52.454782,
            117.492773
          ],
          [
            15.11759,
            52.454962,
            117.420073
          ],
          [
            15.117663,
            52.455147,
            117.542834
          ],
          [
            15.117736,
            52.455351,
            118.098494
          ],
          [
            15.117809,
            52.455556,
            118.656764
          ],
          [
            15.117879,
            52.455765,
            119.224365
          ],
          [
            15.11793,
            52.455965,
            119.763108
          ],
          [
            15.118007,
            52.456163,
            120.304742
          ],
          [
            15.118103,
            52.456336,
            120.791648
          ],
          [
            15.118218,
            52.456512,
            121.296001
          ],
          [
            15.118358,
            52.456685,
            121.809751
          ],
          [
            15.118501,
            52.456862,
            122.258337
          ],
          [
            15.118644,
            52.45703,
            122.545149
          ],
          [
            15.118796,
            52.4572,
            122.838638
          ],
          [
            15.118945,
            52.457367,
            123.126702
          ],
          [
            15.119087,
            52.45754,
            123.420455
          ],
          [
            15.119256,
            52.457725,
            123.74161
          ],
          [
            15.119424,
            52.4579,
            124.048981
          ],
          [
            15.119595,
            52.458072,
            124.353737
          ],
          [
            15.119747,
            52.458249,
            124.656474
          ],
          [
            15.119911,
            52.458413,
            124.97075
          ],
          [
            15.120078,
            52.458593,
            125.391017
          ],
          [
            15.120256,
            52.458762,
            125.799445
          ],
          [
            15.120416,
            52.458936,
            126.204741
          ],
          [
            15.120578,
            52.459112,
            126.614714
          ],
          [
            15.120757,
            52.459294,
            127.045743
          ],
          [
            15.120929,
            52.459473,
            127.467136
          ],
          [
            15.121073,
            52.459636,
            127.843849
          ],
          [
            15.121227,
            52.459824,
            128.27068
          ],
          [
            15.121379,
            52.460007,
            128.427327
          ],
          [
            15.121552,
            52.460186,
            128.122728
          ],
          [
            15.121713,
            52.460378,
            127.806739
          ],
          [
            15.121858,
            52.460567,
            127.501032
          ],
          [
            15.122033,
            52.460752,
            127.188072
          ],
          [
            15.122204,
            52.460931,
            126.884485
          ],
          [
            15.122369,
            52.461108,
            126.586225
          ],
          [
            15.12253,
            52.461271,
            126.307479
          ],
          [
            15.122712,
            52.461456,
            125.991292
          ],
          [
            15.122868,
            52.461633,
            125.79871
          ],
          [
            15.123045,
            52.461829,
            125.634539
          ],
          [
            15.123236,
            52.462036,
            125.460259
          ],
          [
            15.123427,
            52.462255,
            125.278241
          ],
          [
            15.123634,
            52.462486,
            125.085104
          ],
          [
            15.123796,
            52.46267,
            124.931425
          ],
          [
            15.124021,
            52.462897,
            124.736786
          ],
          [
            15.124181,
            52.46306,
            124.596528
          ],
          [
            15.12437,
            52.463247,
            125.310091
          ],
          [
            15.124574,
            52.463432,
            126.129332
          ],
          [
            15.12479,
            52.463619,
            126.970032
          ],
          [
            15.125032,
            52.463757,
            127.720646
          ],
          [
            15.125251,
            52.463894,
            128.430265
          ],
          [
            15.125448,
            52.464038,
            129.121803
          ],
          [
            15.125638,
            52.464181,
            129.798926
          ],
          [
            15.125854,
            52.464325,
            130.517164
          ],
          [
            15.126058,
            52.464479,
            131.177728
          ],
          [
            15.12618,
            52.464648,
            130.99998
          ],
          [
            15.126309,
            52.464811,
            130.832602
          ],
          [
            15.126466,
            52.464989,
            130.647286
          ],
          [
            15.12664,
            52.465187,
            130.441349
          ],
          [
            15.126824,
            52.465377,
            130.239069
          ],
          [
            15.127029,
            52.465559,
            130.036241
          ],
          [
            15.127152,
            52.465736,
            129.859841
          ],
          [
            15.12728,
            52.465913,
            129.682313
          ],
          [
            15.127424,
            52.466111,
            129.615181
          ],
          [
            15.12757,
            52.466319,
            129.874634
          ],
          [
            15.127679,
            52.466514,
            130.110835
          ],
          [
            15.127798,
            52.466716,
            130.356925
          ],
          [
            15.127912,
            52.466912,
            130.59563
          ],
          [
            15.128026,
            52.467107,
            130.83307
          ],
          [
            15.128132,
            52.467293,
            131.058862
          ],
          [
            15.128267,
            52.467479,
            131.292106
          ],
          [
            15.128405,
            52.46766,
            131.521051
          ],
          [
            15.128515,
            52.467876,
            131.872913
          ],
          [
            15.128618,
            52.468047,
            132.191398
          ],
          [
            15.128725,
            52.46824,
            132.547738
          ],
          [
            15.128851,
            52.468444,
            132.929633
          ],
          [
            15.128949,
            52.468624,
            133.261238
          ],
          [
            15.129054,
            52.468805,
            133.597112
          ],
          [
            15.129179,
            52.469007,
            133.974878
          ],
          [
            15.129302,
            52.469252,
            134.422924
          ],
          [
            15.129448,
            52.46948,
            134.765218
          ],
          [
            15.1296,
            52.469708,
            134.832505
          ],
          [
            15.129715,
            52.469933,
            134.896942
          ],
          [
            15.129824,
            52.470155,
            134.9603
          ],
          [
            15.129933,
            52.470391,
            135.027589
          ],
          [
            15.130067,
            52.470625,
            135.095352
          ],
          [
            15.130197,
            52.470824,
            135.15392
          ],
          [
            15.130313,
            52.471014,
            135.209423
          ],
          [
            15.130442,
            52.471193,
            135.364443
          ],
          [
            15.130569,
            52.471389,
            135.69105
          ],
          [
            15.130698,
            52.471584,
            136.01694
          ],
          [
            15.13083,
            52.471758,
            136.314166
          ],
          [
            15.130947,
            52.471952,
            136.634597
          ],
          [
            15.131055,
            52.472145,
            136.950702
          ],
          [
            15.131176,
            52.472359,
            137.301525
          ],
          [
            15.131284,
            52.472553,
            137.619107
          ],
          [
            15.131406,
            52.472764,
            137.965847
          ],
          [
            15.131516,
            52.472954,
            138.520778
          ],
          [
            15.131632,
            52.473175,
            139.230905
          ],
          [
            15.131755,
            52.473349,
            139.810904
          ],
          [
            15.131877,
            52.473526,
            140.398304
          ],
          [
            15.131981,
            52.47372,
            141.022968
          ],
          [
            15.132084,
            52.473911,
            141.638651
          ],
          [
            15.132191,
            52.4741,
            142.250947
          ],
          [
            15.132308,
            52.474291,
            142.874777
          ],
          [
            15.132434,
            52.474475,
            143.485975
          ],
          [
            15.132525,
            52.474658,
            143.693254
          ],
          [
            15.132642,
            52.474855,
            143.884433
          ],
          [
            15.132754,
            52.475045,
            144.068648
          ],
          [
            15.132867,
            52.475234,
            144.252264
          ],
          [
            15.132967,
            52.47544,
            144.448336
          ],
          [
            15.133081,
            52.475637,
            144.638984
          ],
          [
            15.133175,
            52.475835,
            144.827157
          ],
          [
            15.133288,
            52.476014,
            145.002222
          ],
          [
            15.133258,
            52.476225,
            145.156994
          ],
          [
            15.133362,
            52.476405,
            145.0207
          ],
          [
            15.133501,
            52.476614,
            144.859728
          ],
          [
            15.133628,
            52.476841,
            144.688712
          ],
          [
            15.133773,
            52.477048,
            144.528009
          ],
          [
            15.133984,
            52.477257,
            144.35229
          ],
          [
            15.134189,
            52.477443,
            144.191876
          ],
          [
            15.134305,
            52.477617,
            144.057957
          ],
          [
            15.134427,
            52.477791,
            143.923019
          ],
          [
            15.134587,
            52.478022,
            143.745705
          ],
          [
            15.134721,
            52.47822,
            143.594212
          ],
          [
            15.134903,
            52.478443,
            143.418335
          ],
          [
            15.135062,
            52.47867,
            143.244121
          ],
          [
            15.135207,
            52.478847,
            143.104449
          ],
          [
            15.135344,
            52.479058,
            142.943904
          ],
          [
            15.13545,
            52.479251,
            142.800212
          ],
          [
            15.135573,
            52.479436,
            142.659321
          ],
          [
            15.135711,
            52.479642,
            142.532563
          ],
          [
            15.13587,
            52.479854,
            142.409664
          ],
          [
            15.135898,
            52.48006,
            142.29689
          ],
          [
            15.13599,
            52.480253,
            142.188427
          ],
          [
            15.136141,
            52.480444,
            142.076727
          ],
          [
            15.136295,
            52.480671,
            141.947176
          ],
          [
            15.136439,
            52.480888,
            141.8239
          ],
          [
            15.136609,
            52.481099,
            141.700056
          ],
          [
            15.136783,
            52.48133,
            141.475981
          ],
          [
            15.136955,
            52.481553,
            141.238095
          ],
          [
            15.137123,
            52.481786,
            140.992362
          ],
          [
            15.137277,
            52.481999,
            140.767648
          ],
          [
            15.137439,
            52.482242,
            140.514295
          ],
          [
            15.137574,
            52.482443,
            140.304546
          ],
          [
            15.137743,
            52.482655,
            140.077049
          ],
          [
            15.137862,
            52.482832,
            140.125582
          ],
          [
            15.138026,
            52.483037,
            141.0199
          ],
          [
            15.138173,
            52.483271,
            142.002721
          ],
          [
            15.138269,
            52.483478,
            142.84636
          ],
          [
            15.138481,
            52.483677,
            143.778965
          ],
          [
            15.138616,
            52.483872,
            144.610063
          ],
          [
            15.138787,
            52.484079,
            145.534515
          ],
          [
            15.138908,
            52.484314,
            146.500414
          ],
          [
            15.139074,
            52.484548,
            147.261024
          ],
          [
            15.139264,
            52.484762,
            147.746011
          ],
          [
            15.139423,
            52.484991,
            148.241904
          ],
          [
            15.139592,
            52.485204,
            148.713285
          ],
          [
            15.139774,
            52.485427,
            149.209461
          ],
          [
            15.139885,
            52.485597,
            149.573991
          ],
          [
            15.140002,
            52.485804,
            150.010205
          ],
          [
            15.140152,
            52.486016,
            150.47027
          ],
          [
            15.140314,
            52.486248,
            150.078734
          ],
          [
            15.140487,
            52.486473,
            149.462404
          ],
          [
            15.140654,
            52.486695,
            148.856241
          ],
          [
            15.140813,
            52.486915,
            148.259738
          ],
          [
            15.140985,
            52.487132,
            147.662005
          ],
          [
            15.141152,
            52.487344,
            147.0786
          ],
          [
            15.141322,
            52.487552,
            146.502148
          ],
          [
            15.141451,
            52.487743,
            146.076206
          ],
          [
            15.141599,
            52.487935,
            145.92118
          ],
          [
            15.141764,
            52.488167,
            145.73643
          ],
          [
            15.141928,
            52.488391,
            145.557197
          ],
          [
            15.142089,
            52.488567,
            145.408822
          ],
          [
            15.14226,
            52.488804,
            145.218828
          ],
          [
            15.142411,
            52.489018,
            145.048609
          ],
          [
            15.142571,
            52.489235,
            144.874716
          ],
          [
            15.142736,
            52.489443,
            144.432302
          ],
          [
            15.142878,
            52.489628,
            143.838761
          ],
          [
            15.142991,
            52.489825,
            143.234421
          ],
          [
            15.143118,
            52.490022,
            142.621348
          ],
          [
            15.143243,
            52.49022,
            142.007039
          ],
          [
            15.143366,
            52.490426,
            141.372235
          ],
          [
            15.143508,
            52.490631,
            140.727748
          ],
          [
            15.143649,
            52.490839,
            140.075737
          ],
          [
            15.143801,
            52.491068,
            139.553186
          ],
          [
            15.14393,
            52.491297,
            139.442632
          ],
          [
            15.144047,
            52.491533,
            139.330063
          ],
          [
            15.144202,
            52.491821,
            139.19165
          ],
          [
            15.144321,
            52.492069,
            139.073473
          ],
          [
            15.144443,
            52.492305,
            138.960469
          ],
          [
            15.144558,
            52.492519,
            138.857662
          ],
          [
            15.144663,
            52.49274,
            138.74815
          ],
          [
            15.144798,
            52.492943,
            138.620201
          ],
          [
            15.144912,
            52.493151,
            138.492096
          ],
          [
            15.145025,
            52.493367,
            138.359575
          ],
          [
            15.145128,
            52.493571,
            138.234834
          ],
          [
            15.14523,
            52.493757,
            138.120216
          ],
          [
            15.145358,
            52.493965,
            137.990448
          ],
          [
            15.145465,
            52.49415,
            137.875844
          ],
          [
            15.145573,
            52.49436,
            137.747277
          ],
          [
            15.145686,
            52.494569,
            138.121085
          ],
          [
            15.145788,
            52.494785,
            138.65663
          ],
          [
            15.145898,
            52.494995,
            139.182067
          ],
          [
            15.145994,
            52.495229,
            139.75668
          ],
          [
            15.146105,
            52.495459,
            140.327856
          ],
          [
            15.146216,
            52.495664,
            140.842102
          ],
          [
            15.146318,
            52.495849,
            141.307083
          ],
          [
            15.146406,
            52.496034,
            141.765968
          ],
          [
            15.146513,
            52.496235,
            142.045245
          ],
          [
            15.146621,
            52.496427,
            142.122866
          ],
          [
            15.146738,
            52.496624,
            142.202921
          ],
          [
            15.146847,
            52.496826,
            142.284187
          ],
          [
            15.146967,
            52.49702,
            142.363393
          ],
          [
            15.14708,
            52.497213,
            142.441715
          ],
          [
            15.147155,
            52.497402,
            142.516007
          ],
          [
            15.147249,
            52.497609,
            142.598126
          ],
          [
            15.147296,
            52.497828,
            142.682503
          ],
          [
            15.147336,
            52.498034,
            143.140706
          ],
          [
            15.147359,
            52.498243,
            143.640771
          ],
          [
            15.147324,
            52.498449,
            144.13536
          ],
          [
            15.147243,
            52.498664,
            144.662785
          ],
          [
            15.147165,
            52.498865,
            145.155786
          ],
          [
            15.147046,
            52.499062,
            145.65991
          ],
          [
            15.146893,
            52.499272,
            146.210745
          ],
          [
            15.146742,
            52.499467,
            146.7254
          ],
          [
            15.146568,
            52.49967,
            146.812391
          ],
          [
            15.146393,
            52.499865,
            146.499304
          ],
          [
            15.146219,
            52.500087,
            146.152524
          ],
          [
            15.146034,
            52.50032,
            145.787822
          ],
          [
            15.145897,
            52.500504,
            145.502512
          ],
          [
            15.145746,
            52.500708,
            145.187217
          ],
          [
            15.145575,
            52.500934,
            144.8367
          ],
          [
            15.145431,
            52.501133,
            144.530344
          ],
          [
            15.145318,
            52.501321,
            144.707621
          ],
          [
            15.145256,
            52.50152,
            145.074193
          ],
          [
            15.14523,
            52.501734,
            145.462844
          ],
          [
            15.145248,
            52.50196,
            145.872442
          ],
          [
            15.145334,
            52.502184,
            146.289549
          ],
          [
            15.145433,
            52.502377,
            146.655497
          ],
          [
            15.145438,
            52.502586,
            147.033976
          ],
          [
            15.145389,
            52.502767,
            147.366001
          ],
          [
            15.145324,
            52.50295,
            147.704366
          ],
          [
            15.145271,
            52.503158,
            147.720387
          ],
          [
            15.145221,
            52.503385,
            147.737808
          ],
          [
            15.145194,
            52.503609,
            147.754895
          ],
          [
            15.145169,
            52.503836,
            147.772204
          ],
          [
            15.145141,
            52.504055,
            147.788914
          ],
          [
            15.145118,
            52.50426,
            147.804548
          ],
          [
            15.145091,
            52.504455,
            147.819447
          ],
          [
            15.145054,
            52.504671,
            147.835967
          ],
          [
            15.145046,
            52.504868,
            147.884613
          ],
          [
            15.145039,
            52.505094,
            147.960822
          ],
          [
            15.145022,
            52.505317,
            148.03604
          ],
          [
            15.145001,
            52.505538,
            148.110628
          ],
          [
            15.14519,
            52.505695,
            148.181473
          ],
          [
            15.145518,
            52.505718,
            148.24923
          ],
          [
            15.145858,
            52.505744,
            148.319508
          ],
          [
            15.146158,
            52.505774,
            148.381908
          ],
          [
            15.146468,
            52.505786,
            148.445669
          ],
          [
            15.146787,
            52.505807,
            148.882653
          ],
          [
            15.147116,
            52.505842,
            149.346607
          ],
          [
            15.147421,
            52.505855,
            149.77131
          ],
          [
            15.147755,
            52.505883,
            150.240277
          ],
          [
            15.148054,
            52.505913,
            150.661473
          ],
          [
            15.148421,
            52.505977,
            151.191948
          ],
          [
            15.148765,
            52.506072,
            151.717162
          ],
          [
            15.149068,
            52.506182,
            152.208834
          ],
          [
            15.149369,
            52.506304,
            152.631516
          ],
          [
            15.149614,
            52.506416,
            152.845137
          ],
          [
            15.149885,
            52.506557,
            153.094421
          ],
          [
            15.150149,
            52.506707,
            153.346201
          ],
          [
            15.150459,
            52.506819,
            153.597483
          ],
          [
            15.150688,
            52.506943,
            153.811158
          ],
          [
            15.150903,
            52.507072,
            154.021681
          ],
          [
            15.151165,
            52.507211,
            154.263949
          ],
          [
            15.151388,
            52.50734,
            154.478379
          ],
          [
            15.151669,
            52.507488,
            154.720653
          ],
          [
            15.151947,
            52.507628,
            154.938875
          ],
          [
            15.15222,
            52.507765,
            155.153015
          ],
          [
            15.152468,
            52.507909,
            155.360679
          ],
          [
            15.152727,
            52.508054,
            155.573534
          ],
          [
            15.153,
            52.508209,
            155.799648
          ],
          [
            15.15328,
            52.508344,
            156.015676
          ],
          [
            15.153526,
            52.508481,
            156.21764
          ],
          [
            15.153781,
            52.508611,
            156.430302
          ],
          [
            15.154091,
            52.508759,
            156.791216
          ],
          [
            15.154343,
            52.508881,
            157.086128
          ],
          [
            15.154612,
            52.509011,
            157.400736
          ],
          [
            15.154881,
            52.509147,
            157.721342
          ],
          [
            15.155142,
            52.509277,
            158.030269
          ],
          [
            15.155417,
            52.509423,
            158.364716
          ],
          [
            15.155677,
            52.509564,
            158.68376
          ],
          [
            15.155934,
            52.509708,
            159.00369
          ],
          [
            15.156182,
            52.509828,
            158.774208
          ],
          [
            15.156438,
            52.509963,
            158.234788
          ],
          [
            15.156707,
            52.510108,
            157.662951
          ],
          [
            15.156986,
            52.510267,
            157.054259
          ],
          [
            15.157224,
            52.510395,
            156.548825
          ],
          [
            15.157457,
            52.510534,
            156.029405
          ],
          [
            15.157715,
            52.510659,
            155.504536
          ],
          [
            15.157949,
            52.510796,
            154.986215
          ],
          [
            15.158355,
            52.510948,
            154.31699
          ],
          [
            15.158621,
            52.511069,
            154.068884
          ],
          [
            15.15888,
            52.511212,
            153.807616
          ],
          [
            15.159194,
            52.511368,
            153.504728
          ],
          [
            15.159455,
            52.511522,
            153.23299
          ],
          [
            15.159742,
            52.51164,
            152.973812
          ],
          [
            15.160072,
            52.511768,
            152.681376
          ],
          [
            15.16045,
            52.511872,
            152.371422
          ],
          [
            15.160785,
            52.511958,
            152.193645
          ],
          [
            15.161172,
            52.512058,
            152.193645
          ],
          [
            15.161344,
            52.512272,
            152.193645
          ],
          [
            15.161219,
            52.51246,
            152.193645
          ],
          [
            15.161042,
            52.512625,
            152.193645
          ],
          [
            15.160777,
            52.512702,
            152.193645
          ],
          [
            15.161018,
            52.512585,
            152.193645
          ],
          [
            15.161182,
            52.512428,
            152.193645
          ],
          [
            15.16132,
            52.51226,
            152.193645
          ],
          [
            15.161196,
            52.512431,
            152.193645
          ],
          [
            15.16103,
            52.512598,
            152.193645
          ],
          [
            15.160745,
            52.512641,
            152.193645
          ],
          [
            15.160705,
            52.51249,
            152.193645
          ]
        ]
      }
    }
  ]
}

let day42: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            15.160768,
            52.512497,
            149.902908
          ],
          [
            15.161052,
            52.512437,
            149.902908
          ],
          [
            15.161302,
            52.512303,
            149.902908
          ],
          [
            15.161431,
            52.512134,
            149.902908
          ],
          [
            15.16188,
            52.51222,
            149.902908
          ],
          [
            15.162187,
            52.512287,
            149.73922
          ],
          [
            15.162487,
            52.512356,
            149.56076
          ],
          [
            15.162819,
            52.512435,
            149.362389
          ],
          [
            15.163173,
            52.51251,
            149.153741
          ],
          [
            15.16354,
            52.512574,
            148.94126
          ],
          [
            15.163906,
            52.512647,
            148.726755
          ],
          [
            15.164281,
            52.512732,
            148.50406
          ],
          [
            15.164673,
            52.512811,
            148.274288
          ],
          [
            15.165014,
            52.512889,
            147.953108
          ],
          [
            15.165338,
            52.512965,
            147.637635
          ],
          [
            15.165677,
            52.513039,
            147.310423
          ],
          [
            15.166049,
            52.513099,
            146.960699
          ],
          [
            15.166406,
            52.513178,
            146.615011
          ],
          [
            15.166747,
            52.513309,
            146.248139
          ],
          [
            15.166977,
            52.513537,
            145.839987
          ],
          [
            15.167136,
            52.513771,
            145.38283
          ],
          [
            15.16727,
            52.513989,
            144.786075
          ],
          [
            15.167419,
            52.514194,
            144.215953
          ],
          [
            15.167499,
            52.514425,
            143.615414
          ],
          [
            15.167578,
            52.514652,
            143.025315
          ],
          [
            15.167629,
            52.514865,
            142.47749
          ],
          [
            15.167684,
            52.515072,
            141.943897
          ],
          [
            15.167751,
            52.515287,
            141.385698
          ],
          [
            15.167809,
            52.51549,
            140.988541
          ],
          [
            15.167906,
            52.515683,
            140.945637
          ],
          [
            15.168039,
            52.515894,
            140.897564
          ],
          [
            15.168174,
            52.516148,
            140.840826
          ],
          [
            15.168249,
            52.516329,
            140.801145
          ],
          [
            15.168334,
            52.516524,
            140.758259
          ],
          [
            15.16842,
            52.516743,
            140.71039
          ],
          [
            15.168492,
            52.516948,
            140.665837
          ],
          [
            15.168726,
            52.517087,
            140.62031
          ],
          [
            15.169054,
            52.517083,
            140.642754
          ],
          [
            15.169377,
            52.517044,
            140.669319
          ],
          [
            15.169716,
            52.517027,
            140.69688
          ],
          [
            15.170066,
            52.516981,
            140.725747
          ],
          [
            15.170363,
            52.516947,
            140.750121
          ],
          [
            15.17072,
            52.516905,
            140.779449
          ],
          [
            15.171138,
            52.516892,
            140.81322
          ],
          [
            15.171457,
            52.516884,
            140.838955
          ],
          [
            15.171844,
            52.516891,
            140.882489
          ],
          [
            15.172169,
            52.516905,
            140.931694
          ],
          [
            15.172495,
            52.516905,
            140.980979
          ],
          [
            15.172799,
            52.516922,
            141.027077
          ],
          [
            15.173109,
            52.516935,
            141.073996
          ],
          [
            15.173457,
            52.516958,
            141.126904
          ],
          [
            15.173903,
            52.516962,
            141.194259
          ],
          [
            15.174341,
            52.516964,
            141.260578
          ],
          [
            15.174679,
            52.516973,
            141.176487
          ],
          [
            15.175041,
            52.516989,
            140.435983
          ],
          [
            15.175446,
            52.516994,
            139.609668
          ],
          [
            15.175827,
            52.516967,
            138.827395
          ],
          [
            15.176244,
            52.516973,
            137.976727
          ],
          [
            15.176643,
            52.516981,
            137.161241
          ],
          [
            15.177021,
            52.516955,
            136.385423
          ],
          [
            15.177439,
            52.516924,
            135.526387
          ],
          [
            15.177875,
            52.516902,
            135.169987
          ],
          [
            15.178287,
            52.516864,
            135.031427
          ],
          [
            15.178704,
            52.516854,
            134.892868
          ],
          [
            15.17911,
            52.516824,
            134.75702
          ],
          [
            15.179526,
            52.516804,
            134.618474
          ],
          [
            15.179891,
            52.516784,
            134.496729
          ],
          [
            15.180221,
            52.51674,
            134.38455
          ],
          [
            15.180555,
            52.516708,
            134.326626
          ],
          [
            15.180885,
            52.516707,
            134.502676
          ],
          [
            15.181231,
            52.516695,
            134.687659
          ],
          [
            15.181638,
            52.516672,
            134.905418
          ],
          [
            15.181985,
            52.516642,
            135.092201
          ],
          [
            15.182345,
            52.516649,
            135.283952
          ],
          [
            15.182711,
            52.516692,
            135.482432
          ],
          [
            15.183053,
            52.516749,
            135.671689
          ],
          [
            15.183414,
            52.516814,
            135.869132
          ],
          [
            15.1838,
            52.516892,
            135.966953
          ],
          [
            15.184165,
            52.516953,
            136.058001
          ],
          [
            15.184529,
            52.517023,
            136.149879
          ],
          [
            15.184885,
            52.517077,
            136.238169
          ],
          [
            15.185254,
            52.51712,
            136.328529
          ],
          [
            15.185616,
            52.517174,
            136.418277
          ],
          [
            15.185971,
            52.517254,
            136.509324
          ],
          [
            15.186282,
            52.517305,
            136.522617
          ],
          [
            15.18662,
            52.517365,
            136.020328
          ],
          [
            15.186983,
            52.517443,
            135.472519
          ],
          [
            15.187344,
            52.517499,
            134.942031
          ],
          [
            15.187689,
            52.517562,
            134.429109
          ],
          [
            15.188061,
            52.517617,
            133.884441
          ],
          [
            15.188483,
            52.517688,
            133.26129
          ],
          [
            15.188968,
            52.517772,
            132.543276
          ],
          [
            15.189391,
            52.51784,
            131.096005
          ],
          [
            15.189697,
            52.517887,
            129.827108
          ],
          [
            15.190003,
            52.517945,
            128.538596
          ],
          [
            15.190327,
            52.518006,
            127.173821
          ],
          [
            15.190662,
            52.518052,
            125.792648
          ],
          [
            15.19102,
            52.518103,
            124.314373
          ],
          [
            15.191395,
            52.518166,
            122.750026
          ],
          [
            15.191782,
            52.518235,
            121.128677
          ],
          [
            15.19216,
            52.518305,
            119.964165
          ],
          [
            15.192555,
            52.518373,
            119.050802
          ],
          [
            15.192934,
            52.518438,
            118.174825
          ],
          [
            15.193303,
            52.518501,
            117.322149
          ],
          [
            15.193653,
            52.518563,
            116.511055
          ],
          [
            15.194004,
            52.518605,
            115.715065
          ],
          [
            15.194309,
            52.518659,
            115.008311
          ],
          [
            15.194838,
            52.518734,
            113.811601
          ],
          [
            15.195365,
            52.518748,
            112.781278
          ],
          [
            15.195866,
            52.518666,
            111.765035
          ],
          [
            15.19626,
            52.518576,
            110.942121
          ],
          [
            15.196603,
            52.518435,
            110.116905
          ],
          [
            15.196907,
            52.518255,
            109.286299
          ],
          [
            15.197154,
            52.518059,
            108.493217
          ],
          [
            15.19745,
            52.517907,
            108.333572
          ],
          [
            15.197754,
            52.517744,
            108.712126
          ],
          [
            15.198008,
            52.517565,
            109.07532
          ],
          [
            15.198279,
            52.517398,
            109.435697
          ],
          [
            15.198494,
            52.517228,
            109.764875
          ],
          [
            15.198725,
            52.517032,
            110.135687
          ],
          [
            15.199028,
            52.516866,
            110.516429
          ],
          [
            15.199289,
            52.516738,
            110.831923
          ],
          [
            15.199622,
            52.516598,
            111.097516
          ],
          [
            15.199899,
            52.516486,
            111.295539
          ],
          [
            15.200203,
            52.516326,
            111.534837
          ],
          [
            15.200477,
            52.516211,
            111.73339
          ],
          [
            15.200756,
            52.51606,
            111.95569
          ],
          [
            15.20102,
            52.515934,
            112.155497
          ],
          [
            15.201276,
            52.515814,
            112.348257
          ],
          [
            15.201535,
            52.51569,
            112.544789
          ],
          [
            15.201835,
            52.515544,
            112.366558
          ],
          [
            15.202141,
            52.515426,
            111.811793
          ],
          [
            15.202462,
            52.515276,
            111.191711
          ],
          [
            15.202774,
            52.515144,
            110.609079
          ],
          [
            15.203081,
            52.515006,
            110.024752
          ],
          [
            15.203398,
            52.514856,
            109.409931
          ],
          [
            15.203715,
            52.514708,
            108.797897
          ],
          [
            15.204065,
            52.514557,
            108.141003
          ],
          [
            15.204409,
            52.5144,
            106.805326
          ],
          [
            15.20473,
            52.514235,
            105.492993
          ],
          [
            15.205085,
            52.514082,
            104.131765
          ],
          [
            15.205509,
            52.513899,
            102.5094
          ],
          [
            15.205931,
            52.513775,
            101.037478
          ],
          [
            15.20641,
            52.513671,
            99.443768
          ],
          [
            15.206835,
            52.513594,
            98.479075
          ],
          [
            15.207337,
            52.513498,
            97.642025
          ],
          [
            15.207731,
            52.513404,
            96.971504
          ],
          [
            15.208262,
            52.513284,
            96.075024
          ],
          [
            15.20874,
            52.513182,
            95.272905
          ],
          [
            15.209171,
            52.513082,
            94.542551
          ],
          [
            15.209606,
            52.513011,
            93.858147
          ],
          [
            15.210063,
            52.512918,
            93.14885
          ],
          [
            15.210493,
            52.512833,
            92.483427
          ],
          [
            15.210908,
            52.512744,
            91.83579
          ],
          [
            15.211232,
            52.512646,
            91.302891
          ],
          [
            15.211535,
            52.512528,
            90.772408
          ],
          [
            15.211758,
            52.512362,
            90.24965
          ],
          [
            15.211606,
            52.512292,
            89.926855
          ],
          [
            15.211547,
            52.51223,
            90.112703
          ],
          [
            15.211685,
            52.512057,
            90.306436
          ],
          [
            15.211798,
            52.511873,
            90.505616
          ],
          [
            15.21171,
            52.512052,
            90.694014
          ],
          [
            15.211604,
            52.512235,
            90.889709
          ],
          [
            15.211356,
            52.512278,
            91.08174
          ],
          [
            15.2115,
            52.512253,
            91.343083
          ],
          [
            15.211749,
            52.512358,
            91.53016
          ],
          [
            15.212164,
            52.512182,
            92.16029
          ],
          [
            15.212375,
            52.51201,
            92.860012
          ],
          [
            15.212619,
            52.511894,
            93.471315
          ],
          [
            15.212906,
            52.511751,
            94.202412
          ],
          [
            15.213146,
            52.51159,
            94.906295
          ],
          [
            15.213413,
            52.51145,
            95.600869
          ],
          [
            15.213659,
            52.511312,
            96.261017
          ],
          [
            15.213905,
            52.511197,
            96.872928
          ],
          [
            15.21421,
            52.511075,
            97.533162
          ],
          [
            15.214473,
            52.510912,
            97.678142
          ],
          [
            15.214715,
            52.510772,
            97.807087
          ],
          [
            15.215014,
            52.51064,
            97.949756
          ],
          [
            15.215302,
            52.510476,
            98.102075
          ],
          [
            15.215599,
            52.510335,
            98.24756
          ],
          [
            15.215888,
            52.510199,
            98.388962
          ],
          [
            15.216204,
            52.510099,
            98.526516
          ],
          [
            15.216516,
            52.510041,
            98.652519
          ],
          [
            15.216851,
            52.509947,
            97.387525
          ],
          [
            15.21718,
            52.509841,
            96.028434
          ],
          [
            15.217478,
            52.509746,
            94.80141
          ],
          [
            15.217812,
            52.509687,
            93.529236
          ],
          [
            15.218156,
            52.509607,
            92.191048
          ],
          [
            15.218499,
            52.509551,
            90.897652
          ],
          [
            15.218932,
            52.509498,
            89.291404
          ],
          [
            15.219243,
            52.509479,
            88.152665
          ],
          [
            15.219566,
            52.509435,
            88.148384
          ],
          [
            15.219891,
            52.509396,
            88.429999
          ],
          [
            15.220199,
            52.509383,
            88.691816
          ],
          [
            15.220507,
            52.509384,
            88.953195
          ],
          [
            15.220931,
            52.50938,
            89.312481
          ],
          [
            15.221335,
            52.509387,
            89.655725
          ],
          [
            15.221718,
            52.509372,
            89.981466
          ],
          [
            15.222132,
            52.509343,
            90.334583
          ],
          [
            15.222535,
            52.509338,
            90.324812
          ],
          [
            15.222858,
            52.509312,
            90.215049
          ],
          [
            15.223172,
            52.50929,
            90.108724
          ],
          [
            15.223579,
            52.509256,
            89.970378
          ],
          [
            15.223967,
            52.509236,
            89.839183
          ],
          [
            15.224364,
            52.509247,
            89.705455
          ],
          [
            15.224744,
            52.50925,
            89.576744
          ],
          [
            15.225105,
            52.509248,
            89.455284
          ],
          [
            15.225434,
            52.509277,
            89.428529
          ],
          [
            15.225781,
            52.509304,
            89.425832
          ],
          [
            15.226167,
            52.509367,
            89.422642
          ],
          [
            15.226515,
            52.509413,
            89.419898
          ],
          [
            15.226849,
            52.509516,
            89.417014
          ],
          [
            15.227218,
            52.509596,
            89.413996
          ],
          [
            15.227567,
            52.509691,
            89.411045
          ],
          [
            15.227934,
            52.509781,
            89.407992
          ],
          [
            15.228284,
            52.509864,
            89.8628
          ],
          [
            15.228599,
            52.509946,
            90.303786
          ],
          [
            15.228928,
            52.510046,
            90.776575
          ],
          [
            15.229257,
            52.510134,
            91.238576
          ],
          [
            15.22958,
            52.510223,
            91.694691
          ],
          [
            15.229882,
            52.510311,
            92.125178
          ],
          [
            15.230242,
            52.510387,
            92.616669
          ],
          [
            15.230566,
            52.510433,
            93.044583
          ],
          [
            15.230939,
            52.510482,
            93.430513
          ],
          [
            15.231281,
            52.510505,
            93.732097
          ],
          [
            15.231613,
            52.510514,
            94.02444
          ],
          [
            15.231993,
            52.510517,
            94.356247
          ],
          [
            15.232371,
            52.510518,
            94.686962
          ],
          [
            15.232729,
            52.510505,
            95.00036
          ],
          [
            15.233097,
            52.510488,
            95.32276
          ],
          [
            15.233436,
            52.510423,
            95.633318
          ],
          [
            15.23379,
            52.510355,
            95.827728
          ],
          [
            15.234172,
            52.510284,
            95.908818
          ],
          [
            15.234523,
            52.510218,
            95.983389
          ],
          [
            15.234837,
            52.510157,
            96.050372
          ],
          [
            15.235153,
            52.510086,
            96.11875
          ],
          [
            15.235467,
            52.510023,
            96.185868
          ],
          [
            15.235785,
            52.509975,
            96.252368
          ],
          [
            15.236093,
            52.50991,
            96.318534
          ],
          [
            15.236416,
            52.509858,
            96.386358
          ],
          [
            15.23679,
            52.509776,
            96.516266
          ],
          [
            15.237138,
            52.509694,
            96.638567
          ],
          [
            15.237416,
            52.509616,
            96.738948
          ],
          [
            15.237154,
            52.509706,
            96.837588
          ],
          [
            15.236829,
            52.509769,
            96.949407
          ],
          [
            15.236497,
            52.509825,
            97.062342
          ],
          [
            15.236162,
            52.509885,
            97.176898
          ],
          [
            15.236031,
            52.509736,
            97.282655
          ],
          [
            15.236152,
            52.509548,
            97.239377
          ],
          [
            15.236262,
            52.509369,
            96.908687
          ],
          [
            15.236338,
            52.509169,
            96.553654
          ],
          [
            15.23642,
            52.508912,
            96.100296
          ],
          [
            15.23651,
            52.508714,
            95.745123
          ],
          [
            15.236563,
            52.508514,
            95.394828
          ],
          [
            15.236625,
            52.508281,
            94.984362
          ],
          [
            15.236723,
            52.508078,
            94.618552
          ],
          [
            15.237066,
            52.508098,
            94.238307
          ],
          [
            15.237359,
            52.508209,
            94.049357
          ],
          [
            15.237057,
            52.50846,
            93.726827
          ],
          [
            15.237403,
            52.508416,
            93.472412
          ],
          [
            15.237374,
            52.508166,
            93.251029
          ],
          [
            15.237687,
            52.508206,
            93.078579
          ],
          [
            15.237974,
            52.508264,
            92.915618
          ],
          [
            15.238267,
            52.508333,
            92.746177
          ],
          [
            15.238554,
            52.5084,
            92.504747
          ],
          [
            15.238827,
            52.508501,
            92.162632
          ],
          [
            15.239096,
            52.508615,
            91.812355
          ],
          [
            15.23938,
            52.508724,
            91.453568
          ],
          [
            15.239652,
            52.508818,
            91.113898
          ],
          [
            15.239907,
            52.508808,
            90.7828
          ],
          [
            15.240148,
            52.508925,
            90.45289
          ],
          [
            15.240412,
            52.509036,
            90.110091
          ],
          [
            15.240649,
            52.509207,
            89.715656
          ],
          [
            15.240837,
            52.509375,
            89.679578
          ],
          [
            15.241027,
            52.509549,
            90.142573
          ],
          [
            15.241197,
            52.509707,
            90.561649
          ],
          [
            15.241375,
            52.509882,
            91.017777
          ],
          [
            15.241548,
            52.510043,
            91.444519
          ],
          [
            15.241723,
            52.510217,
            91.897405
          ],
          [
            15.241907,
            52.510383,
            92.343297
          ],
          [
            15.242114,
            52.510536,
            92.7828
          ],
          [
            15.242308,
            52.51072,
            93.267385
          ],
          [
            15.242546,
            52.510876,
            93.625625
          ],
          [
            15.242786,
            52.511052,
            93.904674
          ],
          [
            15.243028,
            52.511226,
            94.182783
          ],
          [
            15.243263,
            52.511405,
            94.46245
          ],
          [
            15.243474,
            52.511573,
            94.720533
          ],
          [
            15.243672,
            52.511738,
            94.970204
          ],
          [
            15.243912,
            52.511876,
            95.215869
          ],
          [
            15.244106,
            52.512033,
            95.45593
          ],
          [
            15.244316,
            52.512182,
            95.665847
          ],
          [
            15.244475,
            52.512352,
            95.426999
          ],
          [
            15.244695,
            52.512515,
            95.1696
          ],
          [
            15.244946,
            52.51267,
            94.904195
          ],
          [
            15.245169,
            52.512819,
            94.657619
          ],
          [
            15.245389,
            52.51295,
            94.429246
          ],
          [
            15.245612,
            52.513093,
            94.188784
          ],
          [
            15.24584,
            52.513262,
            93.922189
          ],
          [
            15.246074,
            52.513417,
            93.665532
          ],
          [
            15.246431,
            52.513587,
            93.655212
          ],
          [
            15.246641,
            52.513717,
            93.884679
          ],
          [
            15.24688,
            52.513864,
            94.145787
          ],
          [
            15.247135,
            52.513999,
            94.406097
          ],
          [
            15.247216,
            52.51415,
            94.645819
          ],
          [
            15.247034,
            52.514312,
            94.892837
          ],
          [
            15.246877,
            52.514473,
            95.128516
          ],
          [
            15.246625,
            52.514493,
            95.357942
          ],
          [
            15.246686,
            52.514406,
            95.620333
          ],
          [
            15.246794,
            52.514502,
            95.718228
          ],
          [
            15.247056,
            52.514608,
            95.648267
          ],
          [
            15.247307,
            52.514727,
            95.577519
          ],
          [
            15.247564,
            52.514838,
            95.507445
          ],
          [
            15.247796,
            52.514972,
            95.436335
          ],
          [
            15.248073,
            52.515104,
            95.358061
          ],
          [
            15.248368,
            52.515241,
            95.275473
          ],
          [
            15.248558,
            52.515395,
            95.205107
          ],
          [
            15.248865,
            52.515507,
            95.124895
          ],
          [
            15.249222,
            52.515592,
            95.373606
          ],
          [
            15.249595,
            52.515669,
            95.81759
          ],
          [
            15.249922,
            52.515753,
            96.217809
          ],
          [
            15.25024,
            52.515796,
            96.586727
          ],
          [
            15.250536,
            52.51586,
            96.94046
          ],
          [
            15.250848,
            52.515905,
            97.301264
          ],
          [
            15.251178,
            52.515961,
            97.687551
          ],
          [
            15.251503,
            52.516037,
            98.079665
          ],
          [
            15.251793,
            52.516117,
            98.378985
          ],
          [
            15.252122,
            52.516171,
            97.473412
          ],
          [
            15.252429,
            52.516268,
            96.553309
          ],
          [
            15.25283,
            52.516353,
            95.42291
          ],
          [
            15.253131,
            52.516412,
            94.581419
          ],
          [
            15.253447,
            52.516482,
            93.687657
          ],
          [
            15.253769,
            52.516539,
            92.796437
          ],
          [
            15.25412,
            52.516607,
            91.816615
          ],
          [
            15.25447,
            52.516645,
            90.868561
          ],
          [
            15.254818,
            52.51664,
            90.119815
          ],
          [
            15.255127,
            52.516624,
            89.53004
          ],
          [
            15.255435,
            52.516573,
            88.922962
          ],
          [
            15.255744,
            52.516537,
            88.32312
          ],
          [
            15.256113,
            52.516491,
            87.606577
          ],
          [
            15.256508,
            52.516436,
            86.835574
          ],
          [
            15.256853,
            52.51638,
            86.156485
          ],
          [
            15.25719,
            52.516325,
            85.492772
          ],
          [
            15.25753,
            52.516272,
            85.012101
          ],
          [
            15.257877,
            52.516238,
            85.389796
          ],
          [
            15.258202,
            52.516194,
            85.747922
          ],
          [
            15.258562,
            52.516162,
            86.138723
          ],
          [
            15.258927,
            52.51612,
            86.537926
          ],
          [
            15.25931,
            52.516077,
            86.956294
          ],
          [
            15.25969,
            52.516029,
            87.373212
          ],
          [
            15.260037,
            52.515983,
            87.754685
          ],
          [
            15.260353,
            52.515953,
            88.098266
          ],
          [
            15.260722,
            52.515883,
            87.737194
          ],
          [
            15.261063,
            52.515833,
            87.37139
          ],
          [
            15.261398,
            52.51578,
            87.010487
          ],
          [
            15.261725,
            52.515751,
            86.665753
          ],
          [
            15.262094,
            52.515698,
            86.270415
          ],
          [
            15.262412,
            52.515646,
            85.927181
          ],
          [
            15.262764,
            52.515597,
            85.550818
          ],
          [
            15.26313,
            52.515548,
            85.160211
          ],
          [
            15.263489,
            52.515518,
            85.269262
          ],
          [
            15.263862,
            52.515514,
            85.616875
          ],
          [
            15.264229,
            52.51557,
            85.969597
          ],
          [
            15.264629,
            52.515604,
            86.346363
          ],
          [
            15.265004,
            52.51563,
            86.698043
          ],
          [
            15.26537,
            52.515645,
            87.039763
          ],
          [
            15.265701,
            52.515658,
            87.349147
          ],
          [
            15.266024,
            52.515663,
            87.650802
          ],
          [
            15.266355,
            52.515674,
            88.39243
          ],
          [
            15.266668,
            52.515705,
            89.447633
          ],
          [
            15.267009,
            52.515753,
            90.608894
          ],
          [
            15.267354,
            52.515765,
            91.755233
          ],
          [
            15.267694,
            52.51581,
            92.909522
          ],
          [
            15.26802,
            52.515855,
            94.018539
          ],
          [
            15.268337,
            52.515881,
            95.079745
          ],
          [
            15.268655,
            52.515898,
            96.139264
          ],
          [
            15.26897,
            52.515903,
            97.187869
          ],
          [
            15.269293,
            52.515947,
            98.379314
          ],
          [
            15.269598,
            52.515983,
            99.549777
          ],
          [
            15.269939,
            52.515986,
            100.832073
          ],
          [
            15.270269,
            52.515997,
            102.071553
          ],
          [
            15.270594,
            52.516,
            103.290918
          ],
          [
            15.270954,
            52.515996,
            104.645783
          ],
          [
            15.271281,
            52.515977,
            105.877744
          ],
          [
            15.271637,
            52.515943,
            107.229277
          ],
          [
            15.271964,
            52.515925,
            108.461202
          ],
          [
            15.272312,
            52.515911,
            108.662623
          ],
          [
            15.272616,
            52.515888,
            108.642664
          ],
          [
            15.272932,
            52.515841,
            108.621445
          ],
          [
            15.273257,
            52.515836,
            108.600239
          ],
          [
            15.273572,
            52.515801,
            108.579394
          ],
          [
            15.27389,
            52.515768,
            108.558393
          ],
          [
            15.27423,
            52.515733,
            108.535934
          ],
          [
            15.274556,
            52.515725,
            108.514686
          ],
          [
            15.274922,
            52.515692,
            108.490579
          ],
          [
            15.275217,
            52.515629,
            108.192956
          ],
          [
            15.275544,
            52.515567,
            107.843571
          ],
          [
            15.275901,
            52.515509,
            107.466639
          ],
          [
            15.276255,
            52.515468,
            107.098977
          ],
          [
            15.276611,
            52.515425,
            106.728732
          ],
          [
            15.276954,
            52.515378,
            106.369981
          ],
          [
            15.277302,
            52.515335,
            106.00744
          ],
          [
            15.277661,
            52.515286,
            105.631865
          ],
          [
            15.278016,
            52.515232,
            105.589501
          ],
          [
            15.278362,
            52.515195,
            105.780911
          ],
          [
            15.278707,
            52.515149,
            105.97347
          ],
          [
            15.279035,
            52.515108,
            106.156068
          ],
          [
            15.279366,
            52.515072,
            106.339278
          ],
          [
            15.279692,
            52.515029,
            106.521175
          ],
          [
            15.280063,
            52.514983,
            106.727483
          ],
          [
            15.280434,
            52.514927,
            106.935757
          ],
          [
            15.280783,
            52.514864,
            107.252055
          ],
          [
            15.281112,
            52.514815,
            107.87544
          ],
          [
            15.281424,
            52.514772,
            108.464168
          ],
          [
            15.281737,
            52.514727,
            109.056415
          ],
          [
            15.282053,
            52.514676,
            109.658107
          ],
          [
            15.282379,
            52.514637,
            110.269996
          ],
          [
            15.282697,
            52.514602,
            110.864879
          ],
          [
            15.283011,
            52.514565,
            111.453543
          ],
          [
            15.283352,
            52.514526,
            112.092079
          ],
          [
            15.283706,
            52.514487,
            112.690676
          ],
          [
            15.284017,
            52.514451,
            113.112791
          ],
          [
            15.284347,
            52.514408,
            113.563021
          ],
          [
            15.284701,
            52.514359,
            114.047172
          ],
          [
            15.285089,
            52.514336,
            114.567128
          ],
          [
            15.285431,
            52.514315,
            115.025471
          ],
          [
            15.28574,
            52.514312,
            115.458578
          ],
          [
            15.286121,
            52.514293,
            115.968871
          ],
          [
            15.286441,
            52.514306,
            116.396463
          ],
          [
            15.286757,
            52.514341,
            117.121214
          ],
          [
            15.287089,
            52.5144,
            117.961753
          ],
          [
            15.287413,
            52.51447,
            118.797253
          ],
          [
            15.287717,
            52.514533,
            119.577501
          ],
          [
            15.288032,
            52.514598,
            120.387435
          ],
          [
            15.28836,
            52.514662,
            121.22425
          ],
          [
            15.288697,
            52.514712,
            122.06729
          ],
          [
            15.289014,
            52.514778,
            122.88154
          ],
          [
            15.28935,
            52.514845,
            123.607127
          ],
          [
            15.289713,
            52.514912,
            123.247586
          ],
          [
            15.290099,
            52.514987,
            122.863526
          ],
          [
            15.290496,
            52.515064,
            122.468425
          ],
          [
            15.290902,
            52.515147,
            122.061898
          ],
          [
            15.291307,
            52.515232,
            121.655344
          ],
          [
            15.291662,
            52.515299,
            121.30251
          ],
          [
            15.29205,
            52.515379,
            120.914183
          ],
          [
            15.292444,
            52.515437,
            120.846127
          ],
          [
            15.29285,
            52.515518,
            120.849958
          ],
          [
            15.293253,
            52.515601,
            120.853779
          ],
          [
            15.293617,
            52.515648,
            120.857117
          ],
          [
            15.293943,
            52.515731,
            120.860285
          ],
          [
            15.294271,
            52.515797,
            120.863387
          ],
          [
            15.294625,
            52.515877,
            120.866778
          ],
          [
            15.294976,
            52.515975,
            120.790024
          ],
          [
            15.295344,
            52.516084,
            120.301327
          ],
          [
            15.295665,
            52.51623,
            119.822351
          ],
          [
            15.296007,
            52.516358,
            119.340234
          ],
          [
            15.296339,
            52.516483,
            118.873284
          ],
          [
            15.296642,
            52.516613,
            118.430586
          ],
          [
            15.296938,
            52.516743,
            117.993829
          ],
          [
            15.297179,
            52.516892,
            117.580724
          ],
          [
            15.297282,
            52.517091,
            117.270873
          ],
          [
            15.297399,
            52.517269,
            117.11596
          ],
          [
            15.297647,
            52.517389,
            116.960775
          ],
          [
            15.29797,
            52.517503,
            116.777283
          ],
          [
            15.298303,
            52.517608,
            116.594055
          ],
          [
            15.29859,
            52.517678,
            116.442403
          ],
          [
            15.298928,
            52.51779,
            116.25431
          ],
          [
            15.299252,
            52.51788,
            116.079983
          ],
          [
            15.299589,
            52.517919,
            115.91038
          ],
          [
            15.299905,
            52.517895,
            115.381878
          ],
          [
            15.300231,
            52.517802,
            114.73295
          ],
          [
            15.300557,
            52.517694,
            114.07241
          ],
          [
            15.300859,
            52.517592,
            113.459706
          ],
          [
            15.301136,
            52.517474,
            112.859284
          ],
          [
            15.301458,
            52.51738,
            112.225764
          ],
          [
            15.301791,
            52.517295,
            111.585206
          ],
          [
            15.302079,
            52.517191,
            110.990756
          ],
          [
            15.302376,
            52.517093,
            110.910774
          ],
          [
            15.302635,
            52.516992,
            111.447264
          ],
          [
            15.302904,
            52.516903,
            111.980857
          ],
          [
            15.303169,
            52.516803,
            112.524569
          ],
          [
            15.303486,
            52.516702,
            113.148231
          ],
          [
            15.303786,
            52.516625,
            113.715895
          ],
          [
            15.304075,
            52.51656,
            114.253091
          ],
          [
            15.304397,
            52.516484,
            114.854874
          ],
          [
            15.304735,
            52.516427,
            115.466003
          ],
          [
            15.305051,
            52.516345,
            115.670635
          ],
          [
            15.305358,
            52.516274,
            115.379986
          ],
          [
            15.305636,
            52.5162,
            115.111416
          ],
          [
            15.305915,
            52.516126,
            114.842103
          ],
          [
            15.306211,
            52.516054,
            114.559767
          ],
          [
            15.306516,
            52.51598,
            114.269217
          ],
          [
            15.306802,
            52.515919,
            114.001044
          ],
          [
            15.307111,
            52.515833,
            113.700372
          ],
          [
            15.30744,
            52.515752,
            113.386291
          ],
          [
            15.307722,
            52.515681,
            113.190969
          ],
          [
            15.308033,
            52.515628,
            113.202705
          ],
          [
            15.308314,
            52.515564,
            113.213652
          ],
          [
            15.308601,
            52.515489,
            113.225002
          ],
          [
            15.308938,
            52.515424,
            113.23785
          ],
          [
            15.309236,
            52.515359,
            113.249353
          ],
          [
            15.309536,
            52.515292,
            113.260966
          ],
          [
            15.309844,
            52.515212,
            113.273135
          ],
          [
            15.310135,
            52.51514,
            113.28455
          ],
          [
            15.310453,
            52.515068,
            113.31055
          ],
          [
            15.310747,
            52.514993,
            113.430679
          ],
          [
            15.311031,
            52.514924,
            113.545954
          ],
          [
            15.311332,
            52.514862,
            113.6657
          ],
          [
            15.311652,
            52.514782,
            113.796071
          ],
          [
            15.311954,
            52.514715,
            113.917318
          ],
          [
            15.31229,
            52.51464,
            114.052214
          ],
          [
            15.312566,
            52.51457,
            114.165336
          ],
          [
            15.312883,
            52.51449,
            114.294655
          ],
          [
            15.313168,
            52.514418,
            114.410347
          ],
          [
            15.313464,
            52.514347,
            114.490253
          ],
          [
            15.313784,
            52.51427,
            114.576708
          ],
          [
            15.314087,
            52.514196,
            114.658759
          ],
          [
            15.314394,
            52.514112,
            114.743255
          ],
          [
            15.314687,
            52.514057,
            114.820229
          ],
          [
            15.314966,
            52.513981,
            114.896968
          ],
          [
            15.315282,
            52.513911,
            114.981384
          ],
          [
            15.315584,
            52.513833,
            115.063848
          ],
          [
            15.315883,
            52.513762,
            115.144416
          ],
          [
            15.316177,
            52.513701,
            115.431399
          ],
          [
            15.31647,
            52.51364,
            115.737029
          ],
          [
            15.316763,
            52.513587,
            116.038777
          ],
          [
            15.317092,
            52.513505,
            116.391065
          ],
          [
            15.317389,
            52.513429,
            116.709026
          ],
          [
            15.317698,
            52.513362,
            117.033462
          ],
          [
            15.318025,
            52.513297,
            117.372934
          ],
          [
            15.318339,
            52.513208,
            117.714761
          ],
          [
            15.318633,
            52.513151,
            118.019493
          ],
          [
            15.318928,
            52.513074,
            118.275859
          ],
          [
            15.3192,
            52.51299,
            118.509037
          ],
          [
            15.319507,
            52.512909,
            118.764939
          ],
          [
            15.319827,
            52.512837,
            119.025741
          ],
          [
            15.320187,
            52.512766,
            119.316069
          ],
          [
            15.320511,
            52.512671,
            119.592203
          ],
          [
            15.320847,
            52.512581,
            119.873261
          ],
          [
            15.321159,
            52.512494,
            120.13595
          ],
          [
            15.321466,
            52.512408,
            120.34631
          ],
          [
            15.321777,
            52.512337,
            120.419715
          ],
          [
            15.3221,
            52.512271,
            120.494854
          ],
          [
            15.32241,
            52.512184,
            120.570154
          ],
          [
            15.322684,
            52.512083,
            120.64081
          ],
          [
            15.322975,
            52.511989,
            120.713473
          ],
          [
            15.323268,
            52.511891,
            120.787217
          ],
          [
            15.323565,
            52.51179,
            120.862379
          ],
          [
            15.323898,
            52.511691,
            120.944111
          ],
          [
            15.324208,
            52.511596,
            121.018362
          ],
          [
            15.324516,
            52.511498,
            121.090752
          ],
          [
            15.324813,
            52.511384,
            121.163898
          ],
          [
            15.325108,
            52.511291,
            121.233097
          ],
          [
            15.325407,
            52.511199,
            121.302935
          ],
          [
            15.32573,
            52.511093,
            121.379369
          ],
          [
            15.326067,
            52.510976,
            121.460249
          ],
          [
            15.326368,
            52.510884,
            121.530408
          ],
          [
            15.326715,
            52.510768,
            121.591264
          ],
          [
            15.327123,
            52.510656,
            121.576945
          ],
          [
            15.327456,
            52.510553,
            121.565005
          ],
          [
            15.327721,
            52.510451,
            121.554986
          ],
          [
            15.328056,
            52.510364,
            121.543325
          ],
          [
            15.328326,
            52.51025,
            121.532825
          ],
          [
            15.328643,
            52.510149,
            121.521355
          ],
          [
            15.328967,
            52.510035,
            121.509394
          ],
          [
            15.329349,
            52.509908,
            121.439996
          ],
          [
            15.329646,
            52.509801,
            121.284447
          ],
          [
            15.329989,
            52.509703,
            121.11362
          ],
          [
            15.330333,
            52.509582,
            120.934625
          ],
          [
            15.330689,
            52.509441,
            120.743135
          ],
          [
            15.331026,
            52.509286,
            120.552833
          ],
          [
            15.331378,
            52.509134,
            120.358059
          ],
          [
            15.33165,
            52.508985,
            120.193065
          ],
          [
            15.331926,
            52.508835,
            120.605959
          ],
          [
            15.332212,
            52.508672,
            121.149612
          ],
          [
            15.332518,
            52.508501,
            121.726612
          ],
          [
            15.332842,
            52.508336,
            122.313222
          ],
          [
            15.333138,
            52.508167,
            122.877738
          ],
          [
            15.333471,
            52.508005,
            123.470229
          ],
          [
            15.333788,
            52.507844,
            124.043173
          ],
          [
            15.334109,
            52.507672,
            124.672387
          ],
          [
            15.334466,
            52.507534,
            125.316309
          ],
          [
            15.334778,
            52.507427,
            125.861472
          ],
          [
            15.335124,
            52.507333,
            126.438286
          ],
          [
            15.335522,
            52.507252,
            127.077591
          ],
          [
            15.335852,
            52.507177,
            127.614115
          ],
          [
            15.336207,
            52.5071,
            128.18966
          ],
          [
            15.336491,
            52.507034,
            128.652358
          ],
          [
            15.336888,
            52.506951,
            128.817551
          ],
          [
            15.337244,
            52.506872,
            128.87376
          ],
          [
            15.33762,
            52.50676,
            128.935859
          ],
          [
            15.338022,
            52.506669,
            128.999485
          ],
          [
            15.338378,
            52.506598,
            129.055056
          ],
          [
            15.338774,
            52.506506,
            129.117945
          ],
          [
            15.339057,
            52.506439,
            129.162992
          ],
          [
            15.33939,
            52.506358,
            129.148575
          ],
          [
            15.339753,
            52.506271,
            128.865508
          ],
          [
            15.340049,
            52.506206,
            128.637188
          ],
          [
            15.340418,
            52.506124,
            128.351441
          ],
          [
            15.340739,
            52.506081,
            128.111535
          ],
          [
            15.341131,
            52.506029,
            127.820037
          ],
          [
            15.341462,
            52.506007,
            127.578384
          ],
          [
            15.3418,
            52.505973,
            127.329652
          ],
          [
            15.342113,
            52.5059,
            127.086471
          ],
          [
            15.342444,
            52.505825,
            126.765236
          ],
          [
            15.342795,
            52.50571,
            126.391417
          ],
          [
            15.343021,
            52.505532,
            126.04433
          ],
          [
            15.343181,
            52.50537,
            125.754913
          ],
          [
            15.343381,
            52.505141,
            125.3586
          ],
          [
            15.343505,
            52.504938,
            125.027684
          ],
          [
            15.343656,
            52.504729,
            124.678841
          ],
          [
            15.343865,
            52.504542,
            124.332247
          ],
          [
            15.344111,
            52.50437,
            124.080719
          ],
          [
            15.34434,
            52.504232,
            123.869143
          ],
          [
            15.344598,
            52.504084,
            123.63589
          ],
          [
            15.344893,
            52.503961,
            123.401448
          ],
          [
            15.345151,
            52.503857,
            123.198608
          ],
          [
            15.345412,
            52.503739,
            122.985369
          ],
          [
            15.345668,
            52.50362,
            122.774024
          ],
          [
            15.34593,
            52.503503,
            122.560875
          ],
          [
            15.346197,
            52.503399,
            122.335445
          ],
          [
            15.346555,
            52.50325,
            121.836178
          ],
          [
            15.346836,
            52.503136,
            121.446414
          ],
          [
            15.347203,
            52.502986,
            120.938443
          ],
          [
            15.347469,
            52.502877,
            120.569373
          ],
          [
            15.347766,
            52.502774,
            120.176242
          ],
          [
            15.34805,
            52.502663,
            119.787809
          ],
          [
            15.348336,
            52.502564,
            119.409836
          ],
          [
            15.348634,
            52.502434,
            118.988383
          ],
          [
            15.348908,
            52.502288,
            119.193243
          ],
          [
            15.349178,
            52.502157,
            119.397758
          ],
          [
            15.34948,
            52.501996,
            119.635095
          ],
          [
            15.34972,
            52.501867,
            119.824338
          ],
          [
            15.350024,
            52.501708,
            120.061915
          ],
          [
            15.350268,
            52.501562,
            120.264113
          ],
          [
            15.350461,
            52.501342,
            120.508792
          ],
          [
            15.350559,
            52.50115,
            120.703836
          ],
          [
            15.35065,
            52.500952,
            120.471284
          ],
          [
            15.350689,
            52.500768,
            120.211636
          ],
          [
            15.350785,
            52.500548,
            119.892846
          ],
          [
            15.350865,
            52.500329,
            119.578918
          ],
          [
            15.35092,
            52.500102,
            119.256865
          ],
          [
            15.351017,
            52.499906,
            118.969912
          ],
          [
            15.351101,
            52.499728,
            118.710546
          ],
          [
            15.351173,
            52.499511,
            118.399666
          ],
          [
            15.35127,
            52.499294,
            118.293932
          ],
          [
            15.351341,
            52.499072,
            118.507249
          ],
          [
            15.351445,
            52.498851,
            118.72442
          ],
          [
            15.35151,
            52.498613,
            118.951996
          ],
          [
            15.351608,
            52.498369,
            119.188906
          ],
          [
            15.351687,
            52.498132,
            119.416999
          ],
          [
            15.351763,
            52.497888,
            119.652232
          ],
          [
            15.351848,
            52.497706,
            119.830857
          ],
          [
            15.351948,
            52.497489,
            119.739617
          ],
          [
            15.352023,
            52.497277,
            119.491886
          ],
          [
            15.352102,
            52.49704,
            119.215905
          ],
          [
            15.352175,
            52.496825,
            118.964492
          ],
          [
            15.352225,
            52.496589,
            118.692826
          ],
          [
            15.352304,
            52.496366,
            118.432159
          ],
          [
            15.352357,
            52.496131,
            118.161458
          ],
          [
            15.352446,
            52.495901,
            117.891732
          ],
          [
            15.352543,
            52.495695,
            117.903635
          ],
          [
            15.352639,
            52.495498,
            117.960686
          ],
          [
            15.352719,
            52.495297,
            118.018071
          ],
          [
            15.352787,
            52.495111,
            118.071114
          ],
          [
            15.352862,
            52.494923,
            118.125036
          ],
          [
            15.352955,
            52.494703,
            118.188104
          ],
          [
            15.35303,
            52.494485,
            118.249895
          ],
          [
            15.353129,
            52.494265,
            118.313173
          ],
          [
            15.35316,
            52.494048,
            118.454942
          ],
          [
            15.353186,
            52.493821,
            118.759944
          ],
          [
            15.353285,
            52.493594,
            119.074689
          ],
          [
            15.353395,
            52.493357,
            119.404709
          ],
          [
            15.353465,
            52.493103,
            119.749925
          ],
          [
            15.353572,
            52.492866,
            120.07961
          ],
          [
            15.353648,
            52.492659,
            120.36443
          ],
          [
            15.353742,
            52.492447,
            120.659509
          ],
          [
            15.353851,
            52.492207,
            120.593743
          ],
          [
            15.353888,
            52.491977,
            120.366655
          ],
          [
            15.353959,
            52.491754,
            120.14263
          ],
          [
            15.354048,
            52.491501,
            119.88877
          ],
          [
            15.354178,
            52.491253,
            119.633388
          ],
          [
            15.354241,
            52.49104,
            119.421005
          ],
          [
            15.354345,
            52.49081,
            119.18694
          ],
          [
            15.35445,
            52.490549,
            118.833087
          ],
          [
            15.354557,
            52.49033,
            118.338761
          ],
          [
            15.354619,
            52.490142,
            117.923871
          ],
          [
            15.354679,
            52.48991,
            117.411811
          ],
          [
            15.354731,
            52.489707,
            116.966925
          ],
          [
            15.354817,
            52.489508,
            116.521639
          ],
          [
            15.354904,
            52.489313,
            116.084453
          ],
          [
            15.354974,
            52.4891,
            115.61282
          ],
          [
            15.355025,
            52.488869,
            115.10702
          ],
          [
            15.355085,
            52.488682,
            115.322467
          ],
          [
            15.355155,
            52.488495,
            115.539274
          ],
          [
            15.355253,
            52.488271,
            115.801266
          ],
          [
            15.35533,
            52.488072,
            116.032285
          ],
          [
            15.355422,
            52.48785,
            116.291006
          ],
          [
            15.355549,
            52.48761,
            116.576509
          ],
          [
            15.355626,
            52.487393,
            116.827566
          ],
          [
            15.355695,
            52.487193,
            117.059098
          ],
          [
            15.355744,
            52.487011,
            116.978497
          ],
          [
            15.355862,
            52.486803,
            116.666764
          ],
          [
            15.355963,
            52.486593,
            116.356102
          ],
          [
            15.356076,
            52.48636,
            116.011811
          ],
          [
            15.356121,
            52.486161,
            115.72653
          ],
          [
            15.356217,
            52.485926,
            115.383258
          ],
          [
            15.356273,
            52.485674,
            115.022841
          ],
          [
            15.356357,
            52.485441,
            114.684931
          ],
          [
            15.356445,
            52.485196,
            114.894485
          ],
          [
            15.356496,
            52.484967,
            115.273942
          ],
          [
            15.356588,
            52.484745,
            115.648404
          ],
          [
            15.356697,
            52.484523,
            116.027387
          ],
          [
            15.356809,
            52.484311,
            116.391843
          ],
          [
            15.356868,
            52.484073,
            116.786022
          ],
          [
            15.356924,
            52.483828,
            117.191536
          ],
          [
            15.357059,
            52.483581,
            117.642513
          ],
          [
            15.357105,
            52.483347,
            118.146636
          ],
          [
            15.357182,
            52.483123,
            118.634144
          ],
          [
            15.357274,
            52.482907,
            119.110672
          ],
          [
            15.357357,
            52.482669,
            119.628595
          ],
          [
            15.357457,
            52.482425,
            120.163483
          ],
          [
            15.357565,
            52.482209,
            120.645538
          ],
          [
            15.357648,
            52.481985,
            121.134295
          ],
          [
            15.357721,
            52.48175,
            121.449786
          ],
          [
            15.35779,
            52.481518,
            121.610704
          ],
          [
            15.357871,
            52.481277,
            121.778543
          ],
          [
            15.35795,
            52.481054,
            121.934199
          ],
          [
            15.358075,
            52.480846,
            122.085304
          ],
          [
            15.358142,
            52.480615,
            122.245442
          ],
          [
            15.358229,
            52.480385,
            122.406467
          ],
          [
            15.358297,
            52.480185,
            122.545787
          ],
          [
            15.35838,
            52.479961,
            122.347992
          ],
          [
            15.358446,
            52.479765,
            122.070745
          ],
          [
            15.358506,
            52.479556,
            121.776918
          ],
          [
            15.358577,
            52.479341,
            121.47267
          ],
          [
            15.358665,
            52.47913,
            121.170824
          ],
          [
            15.358722,
            52.478927,
            120.885496
          ],
          [
            15.358829,
            52.478713,
            120.57565
          ],
          [
            15.358925,
            52.47849,
            120.256347
          ],
          [
            15.358991,
            52.478286,
            119.772944
          ],
          [
            15.359074,
            52.478082,
            119.032629
          ],
          [
            15.359172,
            52.477878,
            118.284525
          ],
          [
            15.359224,
            52.477683,
            117.586325
          ],
          [
            15.35929,
            52.477458,
            116.781399
          ],
          [
            15.35935,
            52.477246,
            116.023382
          ],
          [
            15.359437,
            52.477017,
            115.195985
          ],
          [
            15.359535,
            52.476797,
            114.393332
          ],
          [
            15.359596,
            52.476559,
            113.948106
          ],
          [
            15.359696,
            52.476317,
            114.67605
          ],
          [
            15.359787,
            52.476111,
            115.298979
          ],
          [
            15.359824,
            52.475901,
            115.915268
          ],
          [
            15.359895,
            52.475684,
            116.561435
          ],
          [
            15.359983,
            52.475457,
            117.241965
          ],
          [
            15.360019,
            52.47521,
            117.968213
          ],
          [
            15.359928,
            52.47497,
            118.686767
          ],
          [
            15.359832,
            52.474765,
            119.116001
          ],
          [
            15.359753,
            52.474552,
            119.339924
          ],
          [
            15.359573,
            52.474422,
            119.529449
          ],
          [
            15.359492,
            52.474224,
            119.738901
          ],
          [
            15.359379,
            52.47403,
            119.949703
          ],
          [
            15.359282,
            52.473837,
            120.156308
          ],
          [
            15.359176,
            52.473643,
            120.365603
          ],
          [
            15.359064,
            52.473453,
            120.572722
          ],
          [
            15.358911,
            52.47325,
            120.80143
          ],
          [
            15.358785,
            52.473034,
            120.673159
          ],
          [
            15.358703,
            52.472835,
            120.467047
          ],
          [
            15.358666,
            52.472632,
            120.259439
          ],
          [
            15.358848,
            52.472459,
            120.050585
          ],
          [
            15.359014,
            52.472319,
            119.867124
          ],
          [
            15.358905,
            52.472136,
            119.67077
          ],
          [
            15.358743,
            52.471959,
            119.466975
          ],
          [
            15.35858,
            52.471773,
            119.254873
          ],
          [
            15.358462,
            52.471589,
            119.056385
          ],
          [
            15.358346,
            52.471394,
            119.711691
          ],
          [
            15.358224,
            52.471186,
            120.455958
          ],
          [
            15.358136,
            52.470999,
            121.111346
          ],
          [
            15.358094,
            52.470796,
            121.800584
          ],
          [
            15.358013,
            52.470573,
            122.571133
          ],
          [
            15.357892,
            52.470345,
            123.379222
          ],
          [
            15.357715,
            52.470144,
            124.14758
          ],
          [
            15.357566,
            52.469944,
            124.887409
          ],
          [
            15.357424,
            52.469761,
            125.39831
          ],
          [
            15.357275,
            52.46957,
            125.847565
          ],
          [
            15.3571,
            52.469382,
            126.306538
          ],
          [
            15.35695,
            52.469205,
            126.731315
          ],
          [
            15.35681,
            52.469026,
            127.153144
          ],
          [
            15.356648,
            52.468825,
            127.628785
          ],
          [
            15.356516,
            52.468662,
            128.015214
          ],
          [
            15.356369,
            52.468472,
            128.461299
          ],
          [
            15.35617,
            52.468271,
            128.916994
          ],
          [
            15.355945,
            52.468062,
            128.804362
          ],
          [
            15.35575,
            52.467874,
            128.704239
          ],
          [
            15.355526,
            52.467671,
            128.59391
          ],
          [
            15.355354,
            52.467498,
            128.50207
          ],
          [
            15.355191,
            52.46734,
            128.417607
          ],
          [
            15.355049,
            52.46716,
            128.327695
          ],
          [
            15.354885,
            52.466948,
            128.222175
          ],
          [
            15.35496,
            52.466759,
            128.134396
          ],
          [
            15.355046,
            52.46653,
            128.455493
          ],
          [
            15.355084,
            52.466336,
            128.79742
          ],
          [
            15.355243,
            52.466146,
            129.17042
          ],
          [
            15.355462,
            52.466002,
            129.513585
          ],
          [
            15.355703,
            52.465864,
            129.865731
          ],
          [
            15.355961,
            52.465732,
            130.224809
          ],
          [
            15.356239,
            52.465612,
            130.587596
          ],
          [
            15.356524,
            52.465517,
            130.933512
          ],
          [
            15.356851,
            52.465433,
            131.233027
          ],
          [
            15.357202,
            52.465391,
            131.0543
          ],
          [
            15.357545,
            52.465336,
            130.877055
          ],
          [
            15.357882,
            52.465276,
            130.70165
          ],
          [
            15.358167,
            52.465218,
            130.551546
          ],
          [
            15.358472,
            52.465167,
            130.393547
          ],
          [
            15.358817,
            52.465125,
            130.217798
          ],
          [
            15.35912,
            52.465032,
            130.048146
          ],
          [
            15.359395,
            52.464944,
            129.892768
          ],
          [
            15.359706,
            52.464842,
            129.78112
          ],
          [
            15.360036,
            52.464722,
            129.774975
          ],
          [
            15.360315,
            52.464616,
            129.769722
          ],
          [
            15.360587,
            52.464527,
            129.764789
          ],
          [
            15.360871,
            52.464428,
            129.759564
          ],
          [
            15.361157,
            52.464329,
            129.754314
          ],
          [
            15.36145,
            52.464233,
            129.749005
          ],
          [
            15.361758,
            52.464142,
            129.743543
          ],
          [
            15.362082,
            52.464065,
            129.737992
          ],
          [
            15.362386,
            52.463966,
            130.053768
          ],
          [
            15.362704,
            52.46387,
            130.543677
          ],
          [
            15.363013,
            52.463769,
            131.027718
          ],
          [
            15.363342,
            52.463672,
            131.532337
          ],
          [
            15.363669,
            52.463582,
            132.02817
          ],
          [
            15.36397,
            52.463481,
            132.502828
          ],
          [
            15.364274,
            52.463388,
            132.972354
          ],
          [
            15.364586,
            52.463334,
            133.421649
          ],
          [
            15.364884,
            52.4633,
            133.805918
          ],
          [
            15.365212,
            52.463271,
            133.730826
          ],
          [
            15.365518,
            52.46324,
            133.660543
          ],
          [
            15.365828,
            52.4632,
            133.588752
          ],
          [
            15.366154,
            52.463148,
            133.512234
          ],
          [
            15.366465,
            52.463072,
            133.436301
          ],
          [
            15.366751,
            52.46298,
            133.363023
          ],
          [
            15.367034,
            52.462896,
            133.291692
          ],
          [
            15.367339,
            52.462789,
            133.211897
          ],
          [
            15.367636,
            52.462684,
            133.230434
          ],
          [
            15.367877,
            52.462554,
            134.048904
          ],
          [
            15.368062,
            52.462409,
            134.809634
          ],
          [
            15.36824,
            52.46224,
            135.644742
          ],
          [
            15.368379,
            52.46207,
            136.430148
          ],
          [
            15.368532,
            52.461869,
            137.34782
          ],
          [
            15.368696,
            52.461662,
            138.298363
          ],
          [
            15.368864,
            52.461477,
            139.173031
          ],
          [
            15.369051,
            52.461279,
            140.117906
          ],
          [
            15.369258,
            52.461056,
            140.640791
          ],
          [
            15.369447,
            52.460831,
            140.747207
          ],
          [
            15.369647,
            52.460618,
            140.850485
          ],
          [
            15.369866,
            52.460391,
            140.961268
          ],
          [
            15.370067,
            52.460193,
            141.059257
          ],
          [
            15.370214,
            52.460011,
            141.144674
          ],
          [
            15.370409,
            52.459815,
            141.241132
          ],
          [
            15.370561,
            52.459632,
            141.327482
          ],
          [
            15.370735,
            52.459438,
            141.517427
          ],
          [
            15.370913,
            52.459248,
            141.715876
          ],
          [
            15.371046,
            52.459059,
            141.902576
          ],
          [
            15.371233,
            52.45886,
            142.110658
          ],
          [
            15.37144,
            52.458642,
            142.339115
          ],
          [
            15.371647,
            52.458426,
            142.56654
          ],
          [
            15.371832,
            52.458208,
            142.789153
          ],
          [
            15.372045,
            52.45798,
            142.999443
          ],
          [
            15.37224,
            52.457765,
            143.117931
          ],
          [
            15.372403,
            52.457581,
            143.218675
          ],
          [
            15.372601,
            52.457374,
            143.334
          ],
          [
            15.372777,
            52.457181,
            143.440306
          ],
          [
            15.372956,
            52.456989,
            143.546899
          ],
          [
            15.373125,
            52.456825,
            143.640083
          ],
          [
            15.373288,
            52.456659,
            143.733176
          ],
          [
            15.37346,
            52.456458,
            143.815396
          ],
          [
            15.373622,
            52.456285,
            143.612829
          ],
          [
            15.373785,
            52.456094,
            143.39352
          ],
          [
            15.373968,
            52.455907,
            143.171849
          ],
          [
            15.374138,
            52.455716,
            142.950887
          ],
          [
            15.374342,
            52.455514,
            142.709538
          ],
          [
            15.374463,
            52.455341,
            142.518002
          ],
          [
            15.374627,
            52.45514,
            142.289524
          ],
          [
            15.374835,
            52.454957,
            142.060132
          ],
          [
            15.375045,
            52.45473,
            142.174924
          ],
          [
            15.37522,
            52.454537,
            142.356799
          ],
          [
            15.3754,
            52.454308,
            142.567028
          ],
          [
            15.37552,
            52.45413,
            142.725616
          ],
          [
            15.375698,
            52.453946,
            142.901574
          ],
          [
            15.375839,
            52.453758,
            143.071849
          ],
          [
            15.376021,
            52.453577,
            143.24678
          ],
          [
            15.376217,
            52.453356,
            143.453752
          ],
          [
            15.376458,
            52.453147,
            143.773105
          ],
          [
            15.376662,
            52.452933,
            144.101299
          ],
          [
            15.376848,
            52.452715,
            144.426453
          ],
          [
            15.377045,
            52.452507,
            144.744235
          ],
          [
            15.377246,
            52.45228,
            145.086028
          ],
          [
            15.377455,
            52.452063,
            145.419181
          ],
          [
            15.37765,
            52.451848,
            145.744338
          ],
          [
            15.377842,
            52.451651,
            145.545841
          ],
          [
            15.378029,
            52.451452,
            145.011797
          ],
          [
            15.378203,
            52.451271,
            144.523337
          ],
          [
            15.378325,
            52.451086,
            144.059398
          ],
          [
            15.378527,
            52.450912,
            143.560983
          ],
          [
            15.378824,
            52.45078,
            143.039665
          ],
          [
            15.37912,
            52.450665,
            142.541387
          ],
          [
            15.379423,
            52.450537,
            142.018574
          ],
          [
            15.37973,
            52.450419,
            141.521517
          ],
          [
            15.379999,
            52.450307,
            141.105586
          ],
          [
            15.380275,
            52.450187,
            140.672472
          ],
          [
            15.380594,
            52.450071,
            140.198089
          ],
          [
            15.380953,
            52.449938,
            139.661508
          ],
          [
            15.381367,
            52.449786,
            139.044131
          ],
          [
            15.381774,
            52.449633,
            138.433769
          ],
          [
            15.382171,
            52.449478,
            137.845027
          ],
          [
            15.382558,
            52.449326,
            137.351995
          ],
          [
            15.382935,
            52.449172,
            136.865926
          ],
          [
            15.383297,
            52.449,
            136.374336
          ],
          [
            15.383655,
            52.448863,
            135.921232
          ],
          [
            15.383963,
            52.448744,
            135.530622
          ],
          [
            15.384276,
            52.448631,
            135.141011
          ],
          [
            15.384607,
            52.448591,
            134.776104
          ],
          [
            15.384909,
            52.448646,
            134.741877
          ],
          [
            15.38523,
            52.448613,
            134.726911
          ],
          [
            15.385411,
            52.448407,
            134.710677
          ],
          [
            15.385544,
            52.448246,
            134.698114
          ],
          [
            15.385694,
            52.448001,
            134.680003
          ],
          [
            15.385803,
            52.447824,
            134.666921
          ],
          [
            15.385946,
            52.447644,
            134.653079
          ],
          [
            15.3861,
            52.44746,
            134.638751
          ],
          [
            15.386248,
            52.447291,
            134.614264
          ],
          [
            15.386395,
            52.447106,
            134.563806
          ],
          [
            15.386537,
            52.446913,
            134.511879
          ],
          [
            15.386678,
            52.44673,
            134.462166
          ],
          [
            15.386802,
            52.446541,
            134.412196
          ],
          [
            15.386911,
            52.446334,
            134.358807
          ],
          [
            15.387014,
            52.446156,
            134.312462
          ],
          [
            15.387112,
            52.445964,
            134.263092
          ],
          [
            15.387222,
            52.445754,
            134.208977
          ],
          [
            15.387333,
            52.445504,
            134.10684
          ],
          [
            15.387433,
            52.445274,
            133.996734
          ],
          [
            15.387533,
            52.445057,
            133.892241
          ],
          [
            15.387654,
            52.444823,
            133.778651
          ],
          [
            15.387815,
            52.444585,
            133.65948
          ],
          [
            15.387945,
            52.444378,
            133.556911
          ],
          [
            15.388137,
            52.444179,
            133.449869
          ],
          [
            15.388296,
            52.443999,
            133.353048
          ],
          [
            15.388498,
            52.443809,
            133.000624
          ],
          [
            15.388694,
            52.443617,
            132.649117
          ],
          [
            15.388861,
            52.443399,
            132.275092
          ],
          [
            15.389069,
            52.443199,
            131.907011
          ],
          [
            15.389235,
            52.443024,
            131.592024
          ],
          [
            15.389355,
            52.442853,
            131.302923
          ],
          [
            15.389512,
            52.442677,
            130.990448
          ],
          [
            15.38961,
            52.442482,
            130.669728
          ],
          [
            15.389786,
            52.44226,
            130.755705
          ],
          [
            15.389914,
            52.442055,
            130.99623
          ],
          [
            15.390067,
            52.441865,
            131.228232
          ],
          [
            15.39022,
            52.441694,
            131.442308
          ],
          [
            15.390335,
            52.441479,
            131.69116
          ],
          [
            15.390453,
            52.441274,
            131.929297
          ],
          [
            15.390532,
            52.441022,
            132.210461
          ],
          [
            15.390596,
            52.440813,
            132.443465
          ],
          [
            15.390658,
            52.440607,
            132.491347
          ],
          [
            15.390722,
            52.440395,
            132.424131
          ],
          [
            15.390752,
            52.44018,
            132.356915
          ],
          [
            15.390777,
            52.439998,
            132.300189
          ],
          [
            15.390795,
            52.439768,
            132.228643
          ],
          [
            15.390828,
            52.439536,
            132.156207
          ],
          [
            15.390876,
            52.439295,
            132.080803
          ],
          [
            15.390897,
            52.439068,
            132.010167
          ],
          [
            15.390925,
            52.438845,
            131.787681
          ],
          [
            15.390942,
            52.438613,
            131.372217
          ],
          [
            15.390895,
            52.438372,
            130.936701
          ],
          [
            15.390881,
            52.438147,
            130.533556
          ],
          [
            15.39087,
            52.437932,
            130.148172
          ],
          [
            15.390869,
            52.437694,
            129.721562
          ],
          [
            15.390887,
            52.437478,
            129.332721
          ],
          [
            15.390893,
            52.437275,
            128.968441
          ],
          [
            15.390863,
            52.437074,
            128.743968
          ],
          [
            15.391143,
            52.436951,
            128.714843
          ],
          [
            15.391445,
            52.436836,
            128.684913
          ],
          [
            15.391751,
            52.436707,
            128.65365
          ],
          [
            15.392056,
            52.436587,
            128.623151
          ],
          [
            15.39238,
            52.436445,
            128.589631
          ],
          [
            15.392701,
            52.436326,
            128.558073
          ],
          [
            15.393004,
            52.436198,
            128.527103
          ],
          [
            15.393319,
            52.436077,
            128.506771
          ],
          [
            15.393619,
            52.435953,
            128.504696
          ],
          [
            15.393911,
            52.435817,
            128.502594
          ],
          [
            15.394222,
            52.435706,
            128.500531
          ],
          [
            15.394513,
            52.435594,
            128.498563
          ],
          [
            15.39481,
            52.435488,
            128.496593
          ],
          [
            15.395072,
            52.43537,
            128.494729
          ],
          [
            15.395371,
            52.435259,
            128.492726
          ],
          [
            15.395692,
            52.435134,
            128.489766
          ],
          [
            15.396023,
            52.435015,
            128.475937
          ],
          [
            15.396334,
            52.434897,
            128.462754
          ],
          [
            15.39667,
            52.434762,
            128.448263
          ],
          [
            15.396999,
            52.434633,
            128.434185
          ],
          [
            15.397333,
            52.434503,
            128.419907
          ],
          [
            15.397654,
            52.434373,
            128.406038
          ],
          [
            15.397954,
            52.434253,
            128.393124
          ],
          [
            15.398273,
            52.434127,
            128.345846
          ],
          [
            15.398606,
            52.433992,
            128.236313
          ],
          [
            15.398902,
            52.43387,
            128.138446
          ],
          [
            15.399208,
            52.433741,
            128.036567
          ],
          [
            15.399539,
            52.433614,
            127.929409
          ],
          [
            15.399882,
            52.433489,
            127.819974
          ],
          [
            15.40022,
            52.433363,
            127.711434
          ],
          [
            15.400562,
            52.433232,
            127.600821
          ],
          [
            15.400901,
            52.433096,
            127.494802
          ],
          [
            15.401228,
            52.432985,
            127.398344
          ],
          [
            15.401529,
            52.432865,
            127.30543
          ],
          [
            15.401823,
            52.432751,
            127.21564
          ],
          [
            15.402124,
            52.432626,
            127.121685
          ],
          [
            15.402468,
            52.432493,
            127.016709
          ],
          [
            15.402788,
            52.432375,
            126.920281
          ],
          [
            15.403064,
            52.432268,
            126.835328
          ],
          [
            15.403354,
            52.432145,
            127.128178
          ],
          [
            15.403613,
            52.432032,
            127.483833
          ],
          [
            15.40392,
            52.431902,
            127.900265
          ],
          [
            15.404192,
            52.431796,
            128.260139
          ],
          [
            15.404507,
            52.431668,
            128.68243
          ],
          [
            15.404819,
            52.43153,
            129.112001
          ],
          [
            15.405125,
            52.4314,
            129.52746
          ],
          [
            15.405407,
            52.43128,
            129.910541
          ],
          [
            15.40578,
            52.431138,
            130.346836
          ],
          [
            15.406048,
            52.431049,
            130.625633
          ],
          [
            15.406373,
            52.430927,
            130.97455
          ],
          [
            15.406727,
            52.430815,
            131.338992
          ],
          [
            15.40703,
            52.430695,
            131.670929
          ],
          [
            15.407336,
            52.430569,
            132.008762
          ],
          [
            15.407651,
            52.430443,
            132.355706
          ],
          [
            15.407902,
            52.430338,
            132.634138
          ],
          [
            15.408245,
            52.430223,
            132.95501
          ],
          [
            15.408539,
            52.430075,
            133.236307
          ],
          [
            15.408814,
            52.429951,
            133.488066
          ],
          [
            15.409117,
            52.429837,
            133.750177
          ],
          [
            15.409463,
            52.429704,
            134.05151
          ],
          [
            15.409734,
            52.429602,
            134.286047
          ],
          [
            15.410039,
            52.429491,
            134.547852
          ],
          [
            15.410379,
            52.429385,
            134.828923
          ],
          [
            15.410758,
            52.429261,
            134.681057
          ],
          [
            15.411086,
            52.429169,
            134.248936
          ],
          [
            15.41144,
            52.429067,
            133.780391
          ],
          [
            15.41177,
            52.429005,
            133.367353
          ],
          [
            15.412135,
            52.42894,
            132.912449
          ],
          [
            15.412451,
            52.428891,
            132.522292
          ],
          [
            15.41278,
            52.428829,
            132.110326
          ],
          [
            15.41311,
            52.428796,
            131.710084
          ],
          [
            15.413463,
            52.428754,
            131.303745
          ],
          [
            15.41384,
            52.428707,
            130.911637
          ],
          [
            15.414212,
            52.428655,
            130.522842
          ],
          [
            15.41459,
            52.428596,
            130.125351
          ],
          [
            15.414956,
            52.428543,
            129.741987
          ],
          [
            15.415358,
            52.428501,
            129.326491
          ],
          [
            15.415781,
            52.428455,
            128.888749
          ],
          [
            15.41624,
            52.428371,
            128.4165
          ],
          [
            15.416672,
            52.428253,
            128.154279
          ],
          [
            15.417065,
            52.428092,
            127.891788
          ],
          [
            15.41743,
            52.427907,
            127.628988
          ],
          [
            15.417736,
            52.427703,
            127.377833
          ],
          [
            15.41803,
            52.427519,
            127.144567
          ],
          [
            15.418288,
            52.427324,
            126.916729
          ],
          [
            15.418535,
            52.427142,
            126.888811
          ],
          [
            15.418775,
            52.426962,
            127.070644
          ],
          [
            15.419008,
            52.426814,
            127.232004
          ],
          [
            15.419239,
            52.426658,
            127.396792
          ],
          [
            15.419465,
            52.426482,
            127.572011
          ],
          [
            15.419682,
            52.426324,
            127.733593
          ],
          [
            15.419935,
            52.426166,
            127.906697
          ],
          [
            15.420126,
            52.426022,
            128.051865
          ],
          [
            15.420317,
            52.425869,
            128.202587
          ],
          [
            15.42053,
            52.425723,
            128.622433
          ],
          [
            15.420741,
            52.42558,
            129.053205
          ],
          [
            15.420951,
            52.425422,
            129.508215
          ],
          [
            15.421222,
            52.425225,
            130.084066
          ],
          [
            15.421509,
            52.425035,
            130.662235
          ],
          [
            15.421748,
            52.424858,
            131.175673
          ],
          [
            15.421994,
            52.424667,
            131.719021
          ],
          [
            15.4222,
            52.424509,
            132.171021
          ],
          [
            15.422412,
            52.424355,
            132.321056
          ],
          [
            15.422647,
            52.424183,
            132.432883
          ],
          [
            15.422833,
            52.424032,
            132.527206
          ],
          [
            15.423098,
            52.423834,
            132.654815
          ],
          [
            15.423332,
            52.423676,
            132.761124
          ],
          [
            15.423584,
            52.423511,
            132.873932
          ],
          [
            15.423798,
            52.423366,
            132.971334
          ],
          [
            15.423997,
            52.423213,
            133.068929
          ],
          [
            15.424198,
            52.423043,
            133.119895
          ],
          [
            15.424468,
            52.422868,
            133.081535
          ],
          [
            15.424673,
            52.422725,
            133.051231
          ],
          [
            15.424921,
            52.42258,
            133.017818
          ],
          [
            15.425145,
            52.422393,
            132.980837
          ],
          [
            15.425401,
            52.422202,
            132.941497
          ],
          [
            15.425632,
            52.422038,
            132.907
          ],
          [
            15.425876,
            52.421865,
            132.870566
          ],
          [
            15.426134,
            52.421691,
            132.653546
          ],
          [
            15.42638,
            52.421535,
            132.14117
          ],
          [
            15.426599,
            52.421374,
            131.646266
          ],
          [
            15.426821,
            52.421199,
            131.122005
          ],
          [
            15.427055,
            52.421017,
            130.574841
          ],
          [
            15.427293,
            52.420841,
            130.03507
          ],
          [
            15.42756,
            52.420669,
            129.474493
          ],
          [
            15.427823,
            52.420503,
            128.928312
          ],
          [
            15.428104,
            52.42035,
            128.471317
          ],
          [
            15.428377,
            52.420199,
            128.16369
          ],
          [
            15.428649,
            52.420066,
            127.872691
          ],
          [
            15.428945,
            52.419933,
            127.565409
          ],
          [
            15.429248,
            52.419817,
            127.2667
          ],
          [
            15.429587,
            52.419725,
            126.956974
          ],
          [
            15.429912,
            52.419646,
            126.664926
          ],
          [
            15.430254,
            52.419578,
            126.364671
          ],
          [
            15.43057,
            52.419502,
            126.122311
          ],
          [
            15.430902,
            52.419411,
            126.079456
          ],
          [
            15.431232,
            52.41932,
            126.036884
          ],
          [
            15.431527,
            52.419241,
            125.999012
          ],
          [
            15.431813,
            52.419179,
            125.963327
          ],
          [
            15.432214,
            52.419117,
            125.914694
          ],
          [
            15.432547,
            52.419025,
            125.871687
          ],
          [
            15.432845,
            52.418954,
            125.834082
          ],
          [
            15.433189,
            52.41887,
            125.790435
          ],
          [
            15.433493,
            52.4188,
            125.439102
          ],
          [
            15.433787,
            52.418766,
            125.036975
          ],
          [
            15.434088,
            52.418794,
            124.623287
          ],
          [
            15.434376,
            52.418896,
            124.180143
          ],
          [
            15.434649,
            52.41902,
            123.727418
          ],
          [
            15.434951,
            52.419152,
            123.233637
          ],
          [
            15.435264,
            52.419274,
            122.738352
          ],
          [
            15.435579,
            52.419355,
            122.27668
          ],
          [
            15.435861,
            52.419422,
            121.873346
          ],
          [
            15.436172,
            52.419453,
            122.246105
          ],
          [
            15.436489,
            52.419496,
            122.652065
          ],
          [
            15.43683,
            52.419527,
            123.080477
          ],
          [
            15.437232,
            52.419569,
            123.588271
          ],
          [
            15.437596,
            52.419613,
            124.049366
          ],
          [
            15.437954,
            52.419636,
            124.497717
          ],
          [
            15.438305,
            52.419684,
            124.944775
          ],
          [
            15.438654,
            52.419734,
            125.390334
          ],
          [
            15.439017,
            52.41979,
            125.722004
          ],
          [
            15.439381,
            52.419838,
            125.995972
          ],
          [
            15.439752,
            52.419885,
            126.274837
          ],
          [
            15.440171,
            52.419918,
            126.585804
          ],
          [
            15.440588,
            52.419948,
            126.894617
          ],
          [
            15.441001,
            52.419983,
            127.201484
          ],
          [
            15.441297,
            52.420022,
            127.424367
          ],
          [
            15.441668,
            52.420064,
            127.699126
          ],
          [
            15.441981,
            52.420091,
            127.819777
          ],
          [
            15.44234,
            52.420148,
            127.961251
          ],
          [
            15.442654,
            52.420186,
            128.083453
          ],
          [
            15.442983,
            52.420232,
            128.21233
          ],
          [
            15.443314,
            52.420255,
            128.339589
          ],
          [
            15.44366,
            52.420302,
            128.474751
          ],
          [
            15.44402,
            52.420344,
            128.61449
          ],
          [
            15.444346,
            52.420392,
            128.742625
          ],
          [
            15.444652,
            52.420427,
            128.815204
          ],
          [
            15.444956,
            52.420451,
            128.799778
          ],
          [
            15.445264,
            52.420463,
            128.783943
          ],
          [
            15.445624,
            52.420521,
            128.765222
          ],
          [
            15.445934,
            52.42055,
            128.749452
          ],
          [
            15.446244,
            52.42058,
            128.733667
          ],
          [
            15.446553,
            52.420604,
            128.718006
          ],
          [
            15.446878,
            52.420647,
            128.701279
          ],
          [
            15.447226,
            52.420681,
            128.683558
          ],
          [
            15.447574,
            52.420707,
            128.636733
          ],
          [
            15.447944,
            52.42076,
            128.530312
          ],
          [
            15.448309,
            52.420794,
            128.426915
          ],
          [
            15.448705,
            52.420856,
            128.312452
          ],
          [
            15.449069,
            52.420891,
            128.20894
          ],
          [
            15.449438,
            52.420923,
            128.104586
          ],
          [
            15.449817,
            52.42096,
            127.997108
          ],
          [
            15.450187,
            52.42102,
            127.889847
          ],
          [
            15.450557,
            52.42106,
            127.748543
          ],
          [
            15.450947,
            52.421106,
            127.572816
          ],
          [
            15.451345,
            52.421143,
            127.394637
          ],
          [
            15.451755,
            52.42119,
            127.210024
          ],
          [
            15.452145,
            52.421221,
            127.035908
          ],
          [
            15.452559,
            52.421266,
            126.849881
          ],
          [
            15.452989,
            52.421301,
            126.657805
          ],
          [
            15.45345,
            52.421342,
            126.427266
          ],
          [
            15.453928,
            52.421403,
            126.15281
          ],
          [
            15.454408,
            52.421458,
            125.878345
          ],
          [
            15.454877,
            52.421505,
            125.611299
          ],
          [
            15.455341,
            52.421566,
            125.344145
          ],
          [
            15.455793,
            52.421611,
            125.086801
          ],
          [
            15.456261,
            52.421649,
            124.867231
          ],
          [
            15.456691,
            52.421716,
            124.798002
          ],
          [
            15.457118,
            52.42177,
            124.729957
          ],
          [
            15.457551,
            52.421837,
            124.660276
          ],
          [
            15.45797,
            52.421896,
            124.59316
          ],
          [
            15.458362,
            52.421953,
            124.530293
          ],
          [
            15.458776,
            52.422,
            124.464397
          ],
          [
            15.459191,
            52.42208,
            124.164768
          ],
          [
            15.459587,
            52.422128,
            123.582719
          ],
          [
            15.460013,
            52.422161,
            122.966908
          ],
          [
            15.460428,
            52.422213,
            122.359633
          ],
          [
            15.460804,
            52.422273,
            121.802441
          ],
          [
            15.461221,
            52.422369,
            121.163318
          ],
          [
            15.461629,
            52.422438,
            120.556428
          ],
          [
            15.462023,
            52.422481,
            120.424449
          ],
          [
            15.462482,
            52.422568,
            121.154421
          ],
          [
            15.462927,
            52.422617,
            121.841333
          ],
          [
            15.463369,
            52.422671,
            122.526495
          ],
          [
            15.463807,
            52.42275,
            123.219447
          ],
          [
            15.464254,
            52.422837,
            123.931236
          ],
          [
            15.464676,
            52.422891,
            124.585487
          ],
          [
            15.465088,
            52.422956,
            124.507765
          ],
          [
            15.46551,
            52.423021,
            124.314038
          ],
          [
            15.465918,
            52.423085,
            124.127163
          ],
          [
            15.466338,
            52.42314,
            123.936597
          ],
          [
            15.466759,
            52.423215,
            123.742061
          ],
          [
            15.467205,
            52.423282,
            123.53819
          ],
          [
            15.467567,
            52.423336,
            123.372467
          ],
          [
            15.46801,
            52.423388,
            122.769221
          ],
          [
            15.468383,
            52.423444,
            122.240196
          ],
          [
            15.468792,
            52.423505,
            121.660496
          ],
          [
            15.469134,
            52.423561,
            121.172977
          ],
          [
            15.46949,
            52.423609,
            120.670183
          ],
          [
            15.469798,
            52.423644,
            120.238872
          ],
          [
            15.470119,
            52.423687,
            119.784902
          ],
          [
            15.470418,
            52.423755,
            119.345361
          ],
          [
            15.47076,
            52.423828,
            118.956633
          ],
          [
            15.471085,
            52.423859,
            118.609977
          ],
          [
            15.471409,
            52.423882,
            118.269451
          ],
          [
            15.471761,
            52.423933,
            117.891765
          ],
          [
            15.472092,
            52.423967,
            117.541363
          ],
          [
            15.472461,
            52.424018,
            117.146007
          ],
          [
            15.472822,
            52.424095,
            116.745941
          ],
          [
            15.473186,
            52.424141,
            116.354252
          ],
          [
            15.473552,
            52.424207,
            116.967476
          ],
          [
            15.47393,
            52.424267,
            118.0974
          ],
          [
            15.474303,
            52.424314,
            119.199097
          ],
          [
            15.474631,
            52.42436,
            120.174319
          ],
          [
            15.474947,
            52.42442,
            121.131783
          ],
          [
            15.475316,
            52.424478,
            122.234002
          ],
          [
            15.475725,
            52.424547,
            123.461685
          ],
          [
            15.476086,
            52.424608,
            124.550353
          ],
          [
            15.476439,
            52.424666,
            124.808144
          ],
          [
            15.476793,
            52.424737,
            124.875207
          ],
          [
            15.477121,
            52.424813,
            124.938227
          ],
          [
            15.477443,
            52.42492,
            125.004084
          ],
          [
            15.477785,
            52.425023,
            125.072615
          ],
          [
            15.47815,
            52.425126,
            125.144931
          ],
          [
            15.478491,
            52.425234,
            125.213937
          ],
          [
            15.478863,
            52.425347,
            125.241971
          ],
          [
            15.479179,
            52.42545,
            124.488989
          ],
          [
            15.479451,
            52.425538,
            123.842969
          ],
          [
            15.479768,
            52.425614,
            123.128283
          ],
          [
            15.48012,
            52.425725,
            122.297109
          ],
          [
            15.480446,
            52.425828,
            121.526595
          ],
          [
            15.480815,
            52.425931,
            120.674731
          ],
          [
            15.481228,
            52.42604,
            119.730542
          ],
          [
            15.481695,
            52.426189,
            118.442319
          ],
          [
            15.482181,
            52.426337,
            116.864647
          ],
          [
            15.482704,
            52.426471,
            115.2168
          ],
          [
            15.482971,
            52.426559,
            114.335512
          ],
          [
            15.483248,
            52.426637,
            113.449263
          ],
          [
            15.483542,
            52.426715,
            112.518299
          ],
          [
            15.483822,
            52.426805,
            111.599404
          ],
          [
            15.4841,
            52.426893,
            110.688954
          ],
          [
            15.484389,
            52.426976,
            110.088349
          ],
          [
            15.484686,
            52.427044,
            109.555219
          ],
          [
            15.484962,
            52.427136,
            109.027132
          ],
          [
            15.485254,
            52.427219,
            108.485993
          ],
          [
            15.485529,
            52.42731,
            107.959727
          ],
          [
            15.485816,
            52.42739,
            107.427979
          ],
          [
            15.486108,
            52.427479,
            106.880002
          ],
          [
            15.486393,
            52.427564,
            106.347341
          ],
          [
            15.486908,
            52.427712,
            105.23619
          ],
          [
            15.487283,
            52.427815,
            103.993233
          ],
          [
            15.487754,
            52.427942,
            102.437194
          ],
          [
            15.48826,
            52.428087,
            100.748179
          ],
          [
            15.488734,
            52.428216,
            99.180078
          ],
          [
            15.489189,
            52.428352,
            97.648931
          ],
          [
            15.489677,
            52.428474,
            96.52787
          ],
          [
            15.490178,
            52.428637,
            96.122165
          ],
          [
            15.490681,
            52.428779,
            95.726408
          ],
          [
            15.49103,
            52.428903,
            95.437974
          ],
          [
            15.491488,
            52.429082,
            95.049386
          ],
          [
            15.491924,
            52.42923,
            94.692827
          ],
          [
            15.492328,
            52.429373,
            94.977098
          ],
          [
            15.492679,
            52.429533,
            95.589639
          ],
          [
            15.492999,
            52.429652,
            96.113454
          ],
          [
            15.493288,
            52.429753,
            96.581804
          ],
          [
            15.493345,
            52.429556,
            97.046775
          ],
          [
            15.493414,
            52.429362,
            97.502213
          ],
          [
            15.493487,
            52.429105,
            98.10075
          ],
          [
            15.493566,
            52.428959,
            98.52888
          ],
          [
            15.49398,
            52.428851,
            98.818058
          ],
          [
            15.493657,
            52.428926,
            98.949028
          ],
          [
            15.493645,
            52.429228,
            99.13666
          ],
          [
            15.493465,
            52.42924,
            99.24941
          ],
          [
            15.493422,
            52.42942,
            99.36506
          ],
          [
            15.49344,
            52.429635,
            99.498525
          ],
          [
            15.493491,
            52.429822,
            99.619597
          ],
          [
            15.493775,
            52.429965,
            99.759939
          ],
          [
            15.494035,
            52.430077,
            100.098097
          ],
          [
            15.494308,
            52.430198,
            100.592929
          ],
          [
            15.494577,
            52.430339,
            101.112601
          ],
          [
            15.494858,
            52.430465,
            101.625603
          ],
          [
            15.495131,
            52.430569,
            102.097293
          ],
          [
            15.495448,
            52.430685,
            102.641837
          ],
          [
            15.49575,
            52.430767,
            103.13017
          ],
          [
            15.496058,
            52.430874,
            103.650774
          ],
          [
            15.496322,
            52.430964,
            104.096727
          ],
          [
            15.496596,
            52.43109,
            105.025072
          ],
          [
            15.496892,
            52.431212,
            106.019683
          ],
          [
            15.497173,
            52.431311,
            106.922945
          ],
          [
            15.497407,
            52.431447,
            107.860135
          ],
          [
            15.497695,
            52.431542,
            108.771296
          ],
          [
            15.49801,
            52.431643,
            109.762685
          ],
          [
            15.498301,
            52.431746,
            110.698779
          ],
          [
            15.49858,
            52.431868,
            111.654017
          ],
          [
            15.498848,
            52.431969,
            112.457382
          ],
          [
            15.499102,
            52.432085,
            113.014881
          ],
          [
            15.499375,
            52.432231,
            113.652836
          ],
          [
            15.499652,
            52.432363,
            114.270644
          ],
          [
            15.499921,
            52.43248,
            114.852327
          ],
          [
            15.500195,
            52.432588,
            115.432643
          ],
          [
            15.500448,
            52.432703,
            115.987846
          ],
          [
            15.500779,
            52.432808,
            116.643455
          ],
          [
            15.501103,
            52.432897,
            117.268194
          ],
          [
            15.501414,
            52.432962,
            117.428671
          ],
          [
            15.501766,
            52.433008,
            117.265892
          ],
          [
            15.502126,
            52.433083,
            117.09413
          ],
          [
            15.502512,
            52.433164,
            116.909576
          ],
          [
            15.502924,
            52.433219,
            116.71936
          ],
          [
            15.503316,
            52.433261,
            116.53982
          ],
          [
            15.503625,
            52.433328,
            116.39184
          ],
          [
            15.503971,
            52.433392,
            116.227151
          ],
          [
            15.504325,
            52.433433,
            116.239273
          ],
          [
            15.504613,
            52.433489,
            116.303348
          ],
          [
            15.504961,
            52.433551,
            116.380181
          ],
          [
            15.505302,
            52.433622,
            116.456559
          ],
          [
            15.505653,
            52.433697,
            116.53548
          ],
          [
            15.506005,
            52.433765,
            116.613755
          ],
          [
            15.506376,
            52.433853,
            116.698288
          ],
          [
            15.506746,
            52.433926,
            116.780857
          ],
          [
            15.507149,
            52.434013,
            116.618461
          ],
          [
            15.507594,
            52.434115,
            116.314446
          ],
          [
            15.508053,
            52.434207,
            116.005509
          ],
          [
            15.508544,
            52.434321,
            115.669569
          ],
          [
            15.509066,
            52.434435,
            115.314459
          ],
          [
            15.509485,
            52.434526,
            115.030031
          ],
          [
            15.5099,
            52.434581,
            113.619215
          ],
          [
            15.510207,
            52.434645,
            111.977574
          ],
          [
            15.510604,
            52.434641,
            109.955729
          ],
          [
            15.510893,
            52.434693,
            108.430246
          ],
          [
            15.511196,
            52.434733,
            106.857937
          ],
          [
            15.511637,
            52.43482,
            104.512324
          ],
          [
            15.511952,
            52.43488,
            102.847798
          ],
          [
            15.512259,
            52.434953,
            101.185881
          ],
          [
            15.512589,
            52.434998,
            99.810302
          ],
          [
            15.5129,
            52.435065,
            99.120941
          ],
          [
            15.513177,
            52.43517,
            98.439239
          ],
          [
            15.513566,
            52.435294,
            97.521628
          ],
          [
            15.514084,
            52.435434,
            96.337112
          ],
          [
            15.514523,
            52.435551,
            95.334571
          ],
          [
            15.514945,
            52.43568,
            94.347377
          ],
          [
            15.515346,
            52.435742,
            93.728489
          ],
          [
            15.51573,
            52.43589,
            93.363898
          ],
          [
            15.516095,
            52.436025,
            93.021753
          ],
          [
            15.516454,
            52.436165,
            92.680349
          ],
          [
            15.516789,
            52.43632,
            92.3438
          ],
          [
            15.517111,
            52.436484,
            92.007327
          ],
          [
            15.517423,
            52.436655,
            91.671186
          ],
          [
            15.517742,
            52.436824,
            91.733186
          ],
          [
            15.518037,
            52.437021,
            92.131421
          ],
          [
            15.518342,
            52.437211,
            92.528623
          ],
          [
            15.518656,
            52.437387,
            92.917064
          ],
          [
            15.518955,
            52.437594,
            93.32921
          ],
          [
            15.519259,
            52.437794,
            93.736486
          ],
          [
            15.519556,
            52.43797,
            94.113496
          ],
          [
            15.51982,
            52.438138,
            94.373726
          ],
          [
            15.520099,
            52.438331,
            94.626841
          ],
          [
            15.520356,
            52.438494,
            94.849578
          ],
          [
            15.520582,
            52.43865,
            95.054356
          ],
          [
            15.520826,
            52.438806,
            95.266597
          ],
          [
            15.521056,
            52.438933,
            95.452873
          ],
          [
            15.521364,
            52.439052,
            95.671788
          ],
          [
            15.521772,
            52.439144,
            95.933606
          ],
          [
            15.522097,
            52.439247,
            96.04085
          ],
          [
            15.522431,
            52.439307,
            96.118014
          ],
          [
            15.522724,
            52.439353,
            96.18521
          ],
          [
            15.523132,
            52.439401,
            96.278021
          ],
          [
            15.523487,
            52.439428,
            96.357513
          ],
          [
            15.523805,
            52.439456,
            96.428814
          ],
          [
            15.524166,
            52.439462,
            96.509138
          ],
          [
            15.524514,
            52.439454,
            96.586611
          ],
          [
            15.524916,
            52.439441,
            96.15226
          ],
          [
            15.525315,
            52.439436,
            95.26145
          ],
          [
            15.525738,
            52.439435,
            94.316399
          ],
          [
            15.526176,
            52.439444,
            93.337821
          ],
          [
            15.526636,
            52.439459,
            92.309094
          ],
          [
            15.527092,
            52.439497,
            91.281762
          ],
          [
            15.52755,
            52.439534,
            90.249923
          ],
          [
            15.528068,
            52.439583,
            89.903168
          ],
          [
            15.528567,
            52.439657,
            89.737016
          ],
          [
            15.529088,
            52.439686,
            89.567469
          ],
          [
            15.52956,
            52.439744,
            89.411779
          ],
          [
            15.530038,
            52.43978,
            89.256064
          ],
          [
            15.530529,
            52.439817,
            89.096157
          ],
          [
            15.531013,
            52.439867,
            90.495225
          ],
          [
            15.531478,
            52.439908,
            91.905496
          ],
          [
            15.531883,
            52.439953,
            93.140624
          ],
          [
            15.532268,
            52.439998,
            94.31686
          ],
          [
            15.532659,
            52.440022,
            95.495963
          ],
          [
            15.533007,
            52.440043,
            96.546514
          ],
          [
            15.533317,
            52.44007,
            97.486159
          ],
          [
            15.533696,
            52.440124,
            98.53037
          ],
          [
            15.534044,
            52.44016,
            99.41013
          ],
          [
            15.534389,
            52.440178,
            100.270762
          ],
          [
            15.534754,
            52.44022,
            101.193269
          ],
          [
            15.535117,
            52.440257,
            102.106354
          ],
          [
            15.535477,
            52.440276,
            103.002575
          ],
          [
            15.535857,
            52.440303,
            103.951374
          ],
          [
            15.536239,
            52.440344,
            104.913494
          ],
          [
            15.536625,
            52.440376,
            105.145127
          ],
          [
            15.537041,
            52.440399,
            104.955717
          ],
          [
            15.53735,
            52.440434,
            104.812859
          ],
          [
            15.537689,
            52.440364,
            104.643597
          ],
          [
            15.537987,
            52.440353,
            104.494776
          ],
          [
            15.538315,
            52.440373,
            104.345338
          ],
          [
            15.538666,
            52.440394,
            104.185182
          ],
          [
            15.538971,
            52.440436,
            104.042588
          ],
          [
            15.539301,
            52.440452,
            103.699535
          ],
          [
            15.539769,
            52.440497,
            102.035931
          ],
          [
            15.540303,
            52.440533,
            100.149009
          ],
          [
            15.540754,
            52.440576,
            98.546069
          ],
          [
            15.541074,
            52.440584,
            97.421307
          ],
          [
            15.541419,
            52.440614,
            96.197613
          ],
          [
            15.541764,
            52.440636,
            94.979481
          ],
          [
            15.542097,
            52.440659,
            93.802331
          ],
          [
            15.542414,
            52.440683,
            93.234843
          ],
          [
            15.542738,
            52.440695,
            92.8115
          ],
          [
            15.543072,
            52.440717,
            92.373585
          ],
          [
            15.543377,
            52.440742,
            91.970515
          ],
          [
            15.543702,
            52.44077,
            91.543605
          ],
          [
            15.544009,
            52.440802,
            91.13851
          ],
          [
            15.544313,
            52.440831,
            90.738265
          ],
          [
            15.544885,
            52.440875,
            89.988268
          ],
          [
            15.545438,
            52.440914,
            89.86164
          ],
          [
            15.545992,
            52.440953,
            90.079765
          ],
          [
            15.546537,
            52.441008,
            90.296743
          ],
          [
            15.547013,
            52.441035,
            90.483692
          ],
          [
            15.547441,
            52.441043,
            90.651164
          ],
          [
            15.547858,
            52.441081,
            90.816093
          ],
          [
            15.548263,
            52.441114,
            90.994237
          ],
          [
            15.548667,
            52.44115,
            91.184843
          ],
          [
            15.549087,
            52.441202,
            91.383736
          ],
          [
            15.549507,
            52.441224,
            91.579637
          ],
          [
            15.549914,
            52.441233,
            91.768324
          ],
          [
            15.550342,
            52.441223,
            91.966844
          ],
          [
            15.550772,
            52.441183,
            92.168402
          ],
          [
            15.551172,
            52.441168,
            92.110575
          ],
          [
            15.551598,
            52.441155,
            91.871791
          ],
          [
            15.552019,
            52.441146,
            91.634534
          ],
          [
            15.552469,
            52.44112,
            91.381516
          ],
          [
            15.552889,
            52.441104,
            91.146007
          ],
          [
            15.553264,
            52.441042,
            90.927503
          ],
          [
            15.553664,
            52.441028,
            90.703065
          ],
          [
            15.554054,
            52.440984,
            90.436344
          ],
          [
            15.554467,
            52.440974,
            90.11944
          ],
          [
            15.554831,
            52.44096,
            89.839803
          ],
          [
            15.55522,
            52.440984,
            89.539423
          ],
          [
            15.555616,
            52.440993,
            89.235585
          ],
          [
            15.555975,
            52.441033,
            88.954972
          ],
          [
            15.556328,
            52.441049,
            88.683143
          ],
          [
            15.55663,
            52.440983,
            88.436991
          ],
          [
            15.556921,
            52.441139,
            88.061215
          ],
          [
            15.557245,
            52.441201,
            87.704452
          ],
          [
            15.557634,
            52.441274,
            87.278355
          ],
          [
            15.558036,
            52.441345,
            86.838182
          ],
          [
            15.558447,
            52.44142,
            86.381509
          ],
          [
            15.558853,
            52.4415,
            85.934109
          ],
          [
            15.559239,
            52.441555,
            85.518893
          ],
          [
            15.55961,
            52.441596,
            85.432593
          ],
          [
            15.559959,
            52.441642,
            86.043037
          ],
          [
            15.560297,
            52.441709,
            86.643012
          ],
          [
            15.560635,
            52.441757,
            87.23061
          ],
          [
            15.560959,
            52.441714,
            87.824955
          ],
          [
            15.561264,
            52.441893,
            88.5397
          ],
          [
            15.561634,
            52.441926,
            89.171183
          ],
          [
            15.562015,
            52.441938,
            89.815912
          ],
          [
            15.562404,
            52.441971,
            90.260656
          ],
          [
            15.562813,
            52.441991,
            90.365721
          ],
          [
            15.563132,
            52.441994,
            90.448432
          ],
          [
            15.563446,
            52.442062,
            90.533882
          ],
          [
            15.563788,
            52.442111,
            90.623848
          ],
          [
            15.564088,
            52.442152,
            90.702583
          ],
          [
            15.56439,
            52.44221,
            90.783867
          ],
          [
            15.564716,
            52.442209,
            90.867464
          ],
          [
            15.565018,
            52.442249,
            90.94675
          ],
          [
            15.565342,
            52.442285,
            90.969496
          ],
          [
            15.565674,
            52.442301,
            90.95761
          ],
          [
            15.566004,
            52.442348,
            90.945515
          ],
          [
            15.566278,
            52.442503,
            90.930794
          ],
          [
            15.566596,
            52.442484,
            90.919098
          ],
          [
            15.566915,
            52.442484,
            90.907714
          ],
          [
            15.56721,
            52.442534,
            90.896791
          ],
          [
            15.567535,
            52.442581,
            90.884876
          ],
          [
            15.567828,
            52.442632,
            90.874008
          ],
          [
            15.568209,
            52.442664,
            90.437455
          ],
          [
            15.568532,
            52.442717,
            89.986698
          ],
          [
            15.568853,
            52.442766,
            89.539913
          ],
          [
            15.569157,
            52.442798,
            89.124125
          ],
          [
            15.569485,
            52.44283,
            88.676424
          ],
          [
            15.56979,
            52.442896,
            88.233337
          ],
          [
            15.570165,
            52.442935,
            87.719596
          ],
          [
            15.570498,
            52.442945,
            87.270142
          ],
          [
            15.570825,
            52.442999,
            86.974708
          ],
          [
            15.571154,
            52.442974,
            87.433088
          ],
          [
            15.571452,
            52.443073,
            87.886031
          ],
          [
            15.571751,
            52.443126,
            88.29205
          ],
          [
            15.572101,
            52.443172,
            88.758358
          ],
          [
            15.572379,
            52.443301,
            89.220942
          ],
          [
            15.572715,
            52.443347,
            89.670797
          ],
          [
            15.57294,
            52.443467,
            90.076744
          ],
          [
            15.573225,
            52.443563,
            90.504547
          ],
          [
            15.573529,
            52.443628,
            90.451237
          ],
          [
            15.573843,
            52.443732,
            89.736665
          ],
          [
            15.574182,
            52.443833,
            88.980821
          ],
          [
            15.574336,
            52.444024,
            88.25638
          ],
          [
            15.574405,
            52.444231,
            87.563271
          ],
          [
            15.574502,
            52.444382,
            86.898515
          ],
          [
            15.574522,
            52.444587,
            86.214156
          ],
          [
            15.5746,
            52.444785,
            85.544744
          ],
          [
            15.574771,
            52.444962,
            84.868145
          ],
          [
            15.574719,
            52.445013,
            85.074924
          ],
          [
            15.574395,
            52.444965,
            85.374881
          ],
          [
            15.574074,
            52.445047,
            85.660531
          ],
          [
            15.57377,
            52.445102,
            85.92134
          ],
          [
            15.573439,
            52.445102,
            86.198282
          ],
          [
            15.573194,
            52.445075,
            86.469199
          ],
          [
            15.572864,
            52.445076,
            86.742132
          ],
          [
            15.572574,
            52.445093,
            87.004146
          ],
          [
            15.572673,
            52.445069,
            87.191975
          ],
          [
            15.572975,
            52.445096,
            87.025262
          ],
          [
            15.573294,
            52.445155,
            86.676374
          ],
          [
            15.573573,
            52.445075,
            86.350496
          ],
          [
            15.573855,
            52.445145,
            86.027306
          ],
          [
            15.573974,
            52.445355,
            85.630146
          ],
          [
            15.573919,
            52.445548,
            85.290616
          ],
          [
            15.573849,
            52.445744,
            84.946435
          ],
          [
            15.573881,
            52.445964,
            84.560806
          ],
          [
            15.574149,
            52.446154,
            84.238462
          ],
          [
            15.574471,
            52.446282,
            84.79195
          ],
          [
            15.574761,
            52.446421,
            85.323261
          ],
          [
            15.575062,
            52.446553,
            85.85691
          ],
          [
            15.575375,
            52.446648,
            86.365461
          ],
          [
            15.575863,
            52.44663,
            87.080115
          ],
          [
            15.576199,
            52.44656,
            87.59271
          ],
          [
            15.576508,
            52.446486,
            88.076312
          ],
          [
            15.576868,
            52.446389,
            88.292059
          ],
          [
            15.57721,
            52.446315,
            87.992513
          ],
          [
            15.577548,
            52.446251,
            87.698614
          ],
          [
            15.57792,
            52.446195,
            87.382332
          ],
          [
            15.578247,
            52.446156,
            87.106761
          ],
          [
            15.578621,
            52.446129,
            86.787139
          ],
          [
            15.579006,
            52.446127,
            86.461658
          ],
          [
            15.579338,
            52.446152,
            86.180099
          ],
          [
            15.579712,
            52.446244,
            86.219039
          ],
          [
            15.580027,
            52.446308,
            86.683652
          ],
          [
            15.580381,
            52.44634,
            87.189786
          ],
          [
            15.580776,
            52.446344,
            87.742571
          ],
          [
            15.581165,
            52.446323,
            88.29073
          ],
          [
            15.58155,
            52.446314,
            88.829847
          ],
          [
            15.581949,
            52.446321,
            89.389056
          ],
          [
            15.582335,
            52.446315,
            89.929377
          ],
          [
            15.582693,
            52.446331,
            90.060997
          ],
          [
            15.583023,
            52.446349,
            89.984479
          ],
          [
            15.583399,
            52.446381,
            89.896731
          ],
          [
            15.583702,
            52.446399,
            89.826474
          ],
          [
            15.584026,
            52.446494,
            89.743355
          ],
          [
            15.584326,
            52.446623,
            89.658587
          ],
          [
            15.584629,
            52.446702,
            89.581745
          ],
          [
            15.584956,
            52.446628,
            89.500905
          ],
          [
            15.585254,
            52.446527,
            89.424575
          ],
          [
            15.585202,
            52.446307,
            89.368139
          ],
          [
            15.585163,
            52.446094,
            89.31411
          ],
          [
            15.585137,
            52.44589,
            89.262191
          ],
          [
            15.585082,
            52.445663,
            89.204365
          ],
          [
            15.58499,
            52.445402,
            89.136982
          ],
          [
            15.58489,
            52.445178,
            89.078473
          ],
          [
            15.585244,
            52.44508,
            89.018578
          ],
          [
            15.585601,
            52.444954,
            89.067552
          ],
          [
            15.585874,
            52.44483,
            89.262904
          ],
          [
            15.5861,
            52.444669,
            89.46039
          ],
          [
            15.586215,
            52.444605,
            89.63465
          ],
          [
            15.586511,
            52.4445,
            89.827022
          ],
          [
            15.586824,
            52.444385,
            90.032375
          ],
          [
            15.587159,
            52.444291,
            90.239552
          ],
          [
            15.587447,
            52.4442,
            90.421802
          ],
          [
            15.587737,
            52.444081,
            90.620222
          ],
          [
            15.587717,
            52.443931,
            90.538729
          ],
          [
            15.587416,
            52.443917,
            90.440322
          ],
          [
            15.587118,
            52.443826,
            90.337902
          ],
          [
            15.586808,
            52.443743,
            90.233632
          ],
          [
            15.586464,
            52.443748,
            90.127742
          ],
          [
            15.586117,
            52.443797,
            90.017892
          ],
          [
            15.585781,
            52.443885,
            89.905266
          ],
          [
            15.585424,
            52.443939,
            89.792099
          ],
          [
            15.58504,
            52.443937,
            89.747328
          ],
          [
            15.584897,
            52.443971,
            89.767447
          ],
          [
            15.585214,
            52.44388,
            89.806837
          ],
          [
            15.585529,
            52.443836,
            89.837546
          ],
          [
            15.58582,
            52.443785,
            89.866396
          ],
          [
            15.586114,
            52.4437,
            89.897491
          ],
          [
            15.586454,
            52.443704,
            89.929803
          ],
          [
            15.586773,
            52.443738,
            89.960903
          ],
          [
            15.587069,
            52.443827,
            89.992241
          ],
          [
            15.587383,
            52.443883,
            90.114713
          ],
          [
            15.587713,
            52.443906,
            90.364377
          ],
          [
            15.588022,
            52.443998,
            90.62508
          ],
          [
            15.588352,
            52.444028,
            90.87565
          ],
          [
            15.588653,
            52.444092,
            91.117376
          ],
          [
            15.588982,
            52.444147,
            91.374169
          ],
          [
            15.589329,
            52.444196,
            91.641529
          ],
          [
            15.589628,
            52.444221,
            91.868058
          ],
          [
            15.589928,
            52.444258,
            92.098821
          ],
          [
            15.590244,
            52.444278,
            92.213042
          ],
          [
            15.590606,
            52.444308,
            92.183654
          ],
          [
            15.590928,
            52.444341,
            92.157408
          ],
          [
            15.591236,
            52.444367,
            92.132301
          ],
          [
            15.591561,
            52.444359,
            92.105784
          ],
          [
            15.591903,
            52.444371,
            92.078225
          ],
          [
            15.592167,
            52.444281,
            92.052318
          ],
          [
            15.592467,
            52.444252,
            92.02681
          ],
          [
            15.592764,
            52.444144,
            91.998959
          ],
          [
            15.593046,
            52.44403,
            92.001048
          ],
          [
            15.593317,
            52.443951,
            92.020742
          ],
          [
            15.593631,
            52.443854,
            92.043882
          ],
          [
            15.593902,
            52.443768,
            92.06395
          ],
          [
            15.594235,
            52.443719,
            92.086408
          ],
          [
            15.594572,
            52.443689,
            92.108788
          ],
          [
            15.594907,
            52.443634,
            92.131578
          ],
          [
            15.595272,
            52.44362,
            92.155555
          ],
          [
            15.595596,
            52.443598,
            92.176954
          ],
          [
            15.595944,
            52.443565,
            92.204665
          ],
          [
            15.59622,
            52.443565,
            92.230416
          ],
          [
            15.596483,
            52.443708,
            92.259541
          ],
          [
            15.596734,
            52.443875,
            92.289943
          ],
          [
            15.596964,
            52.444066,
            92.321606
          ],
          [
            15.597292,
            52.444335,
            92.366435
          ],
          [
            15.597506,
            52.444467,
            92.391223
          ],
          [
            15.597779,
            52.444588,
            92.418945
          ],
          [
            15.598159,
            52.444605,
            92.283826
          ],
          [
            15.59858,
            52.444644,
            92.115625
          ],
          [
            15.598988,
            52.444661,
            91.953942
          ],
          [
            15.599409,
            52.444668,
            91.787486
          ],
          [
            15.599825,
            52.444677,
            91.623
          ],
          [
            15.600228,
            52.444689,
            91.463629
          ],
          [
            15.600635,
            52.444705,
            91.302529
          ],
          [
            15.601033,
            52.444717,
            91.608979
          ],
          [
            15.601424,
            52.444733,
            92.101436
          ],
          [
            15.601797,
            52.444756,
            92.572552
          ],
          [
            15.60215,
            52.444774,
            93.01787
          ],
          [
            15.602494,
            52.444786,
            93.450872
          ],
          [
            15.602844,
            52.444794,
            93.891062
          ],
          [
            15.603208,
            52.444803,
            94.34908
          ],
          [
            15.603556,
            52.444818,
            94.787526
          ],
          [
            15.603917,
            52.444837,
            94.759084
          ],
          [
            15.60428,
            52.444851,
            94.422789
          ],
          [
            15.604649,
            52.444862,
            94.081397
          ],
          [
            15.605037,
            52.44488,
            93.72159
          ],
          [
            15.605406,
            52.444898,
            93.37943
          ],
          [
            15.605753,
            52.444897,
            93.058163
          ],
          [
            15.606114,
            52.444888,
            92.724207
          ],
          [
            15.606466,
            52.444916,
            92.395695
          ],
          [
            15.606832,
            52.444939,
            92.267471
          ],
          [
            15.607193,
            52.444965,
            92.323297
          ],
          [
            15.607544,
            52.444972,
            92.377214
          ],
          [
            15.607902,
            52.444982,
            92.432223
          ],
          [
            15.608248,
            52.444989,
            92.485387
          ],
          [
            15.608603,
            52.445002,
            92.539974
          ],
          [
            15.608929,
            52.445015,
            92.590119
          ],
          [
            15.609259,
            52.445026,
            92.640863
          ],
          [
            15.609582,
            52.44503,
            92.690953
          ],
          [
            15.609924,
            52.445041,
            92.842795
          ],
          [
            15.610235,
            52.44507,
            92.982332
          ],
          [
            15.610569,
            52.44508,
            93.130624
          ],
          [
            15.610915,
            52.445088,
            93.284166
          ],
          [
            15.61127,
            52.445106,
            93.442117
          ],
          [
            15.611593,
            52.445135,
            93.58694
          ],
          [
            15.611925,
            52.445137,
            93.734171
          ],
          [
            15.61226,
            52.445145,
            93.882928
          ],
          [
            15.612601,
            52.445151,
            94.01037
          ],
          [
            15.612903,
            52.445162,
            94.054902
          ],
          [
            15.613218,
            52.445168,
            94.101294
          ],
          [
            15.61353,
            52.445183,
            94.147366
          ],
          [
            15.613854,
            52.445189,
            94.195101
          ],
          [
            15.61418,
            52.445201,
            94.243195
          ],
          [
            15.614516,
            52.445226,
            94.293021
          ],
          [
            15.614852,
            52.445248,
            94.342794
          ],
          [
            15.615179,
            52.445259,
            94.391033
          ],
          [
            15.61551,
            52.445271,
            94.430638
          ],
          [
            15.615827,
            52.445298,
            94.415339
          ],
          [
            15.616166,
            52.445312,
            94.399083
          ],
          [
            15.61649,
            52.445321,
            94.38356
          ],
          [
            15.616826,
            52.445321,
            94.367501
          ],
          [
            15.617149,
            52.44532,
            94.35206
          ],
          [
            15.617515,
            52.445346,
            94.334439
          ],
          [
            15.617858,
            52.445375,
            94.317883
          ],
          [
            15.618238,
            52.445397,
            94.299628
          ],
          [
            15.618572,
            52.445408,
            94.548705
          ],
          [
            15.61893,
            52.445416,
            95.079232
          ],
          [
            15.619269,
            52.445426,
            95.582061
          ],
          [
            15.619619,
            52.44544,
            96.10152
          ],
          [
            15.619923,
            52.445453,
            96.553613
          ],
          [
            15.620267,
            52.445453,
            97.06305
          ],
          [
            15.620595,
            52.445461,
            97.549588
          ],
          [
            15.620924,
            52.445474,
            98.037908
          ],
          [
            15.621236,
            52.445493,
            98.502384
          ],
          [
            15.621595,
            52.445502,
            98.574218
          ],
          [
            15.621911,
            52.44551,
            98.463869
          ],
          [
            15.622216,
            52.445513,
            98.357459
          ],
          [
            15.62254,
            52.445528,
            98.244095
          ],
          [
            15.622893,
            52.445537,
            98.120844
          ],
          [
            15.623203,
            52.445554,
            98.012255
          ],
          [
            15.623587,
            52.445573,
            97.877853
          ],
          [
            15.62394,
            52.44562,
            97.751317
          ],
          [
            15.624264,
            52.445685,
            97.631478
          ],
          [
            15.624626,
            52.445694,
            97.586914
          ],
          [
            15.624966,
            52.445753,
            97.543376
          ],
          [
            15.625288,
            52.445757,
            97.503759
          ],
          [
            15.625625,
            52.445776,
            97.462039
          ],
          [
            15.62596,
            52.445781,
            97.420782
          ],
          [
            15.62629,
            52.445787,
            97.380108
          ],
          [
            15.626659,
            52.445791,
            97.334713
          ],
          [
            15.626993,
            52.445782,
            97.29359
          ],
          [
            15.627318,
            52.445784,
            97.217412
          ],
          [
            15.627648,
            52.445797,
            97.086708
          ],
          [
            15.627942,
            52.445816,
            96.969227
          ],
          [
            15.628296,
            52.44588,
            96.822755
          ],
          [
            15.628607,
            52.445925,
            96.696345
          ],
          [
            15.628976,
            52.445941,
            96.550179
          ],
          [
            15.629331,
            52.445964,
            96.409111
          ],
          [
            15.629691,
            52.445971,
            96.266319
          ],
          [
            15.63001,
            52.445984,
            96.139996
          ],
          [
            15.630351,
            52.445975,
            96.070058
          ],
          [
            15.630732,
            52.445995,
            96.019029
          ],
          [
            15.631123,
            52.445993,
            95.966763
          ],
          [
            15.631516,
            52.446002,
            95.914273
          ],
          [
            15.631882,
            52.446005,
            95.865406
          ],
          [
            15.632198,
            52.44599,
            95.823112
          ],
          [
            15.632519,
            52.445981,
            95.780228
          ],
          [
            15.632876,
            52.445962,
            95.732397
          ],
          [
            15.63321,
            52.445878,
            95.589249
          ],
          [
            15.633541,
            52.445804,
            95.36852
          ],
          [
            15.633868,
            52.445723,
            95.147541
          ],
          [
            15.634253,
            52.445701,
            94.903412
          ],
          [
            15.63459,
            52.445683,
            94.691469
          ],
          [
            15.634946,
            52.445681,
            94.468506
          ],
          [
            15.635244,
            52.445626,
            94.26947
          ],
          [
            15.635579,
            52.445596,
            94.057108
          ],
          [
            15.635916,
            52.445561,
            93.878556
          ],
          [
            15.63622,
            52.445521,
            94.039811
          ],
          [
            15.636537,
            52.445478,
            94.208199
          ],
          [
            15.636834,
            52.445433,
            94.366885
          ],
          [
            15.637168,
            52.445378,
            94.546445
          ],
          [
            15.637485,
            52.445296,
            94.732968
          ],
          [
            15.637781,
            52.445227,
            94.898399
          ],
          [
            15.638131,
            52.445211,
            95.080587
          ],
          [
            15.638432,
            52.44517,
            95.240573
          ],
          [
            15.638763,
            52.445107,
            95.442251
          ],
          [
            15.639059,
            52.44503,
            95.73661
          ],
          [
            15.639355,
            52.444988,
            96.014234
          ],
          [
            15.639653,
            52.444936,
            96.297424
          ],
          [
            15.639988,
            52.444867,
            96.620421
          ],
          [
            15.640281,
            52.444824,
            96.896178
          ],
          [
            15.640594,
            52.444788,
            97.187206
          ],
          [
            15.6409,
            52.444762,
            97.469471
          ],
          [
            15.641194,
            52.444672,
            97.770859
          ],
          [
            15.641521,
            52.444599,
            98.087246
          ],
          [
            15.641836,
            52.444537,
            97.895735
          ],
          [
            15.642128,
            52.444479,
            97.718045
          ],
          [
            15.642446,
            52.444429,
            97.528056
          ],
          [
            15.642787,
            52.444356,
            97.319052
          ],
          [
            15.643121,
            52.444287,
            97.115105
          ],
          [
            15.643427,
            52.44421,
            96.923647
          ],
          [
            15.643744,
            52.444155,
            96.733014
          ],
          [
            15.644066,
            52.444109,
            96.541731
          ],
          [
            15.64439,
            52.444055,
            96.426196
          ],
          [
            15.644678,
            52.443991,
            96.662872
          ],
          [
            15.645017,
            52.443952,
            96.924682
          ],
          [
            15.645372,
            52.443948,
            97.194147
          ],
          [
            15.645674,
            52.443995,
            97.433358
          ],
          [
            15.645937,
            52.443975,
            97.665961
          ],
          [
            15.646286,
            52.443973,
            97.935965
          ],
          [
            15.646584,
            52.44403,
            98.173058
          ],
          [
            15.646952,
            52.444103,
            98.466747
          ],
          [
            15.647249,
            52.444168,
            98.663563
          ],
          [
            15.647608,
            52.444207,
            98.80427
          ],
          [
            15.647958,
            52.44425,
            98.939363
          ],
          [
            15.648307,
            52.444328,
            99.080095
          ],
          [
            15.648595,
            52.444382,
            99.194503
          ],
          [
            15.648903,
            52.444439,
            99.316288
          ],
          [
            15.649223,
            52.444521,
            99.447837
          ],
          [
            15.649529,
            52.444625,
            99.58039
          ],
          [
            15.649857,
            52.444691,
            99.711233
          ],
          [
            15.650211,
            52.444751,
            99.549219
          ],
          [
            15.650556,
            52.444778,
            99.33268
          ],
          [
            15.650869,
            52.444844,
            99.126584
          ],
          [
            15.651198,
            52.444883,
            98.918013
          ],
          [
            15.651551,
            52.444947,
            98.688329
          ],
          [
            15.651905,
            52.444997,
            98.46178
          ],
          [
            15.652245,
            52.445073,
            98.235518
          ],
          [
            15.652608,
            52.445153,
            97.992606
          ],
          [
            15.652978,
            52.44522,
            98.090698
          ],
          [
            15.653361,
            52.445303,
            98.414604
          ],
          [
            15.653726,
            52.445398,
            98.730924
          ],
          [
            15.654077,
            52.445473,
            99.027299
          ],
          [
            15.654445,
            52.445545,
            99.335275
          ],
          [
            15.654797,
            52.445604,
            99.626172
          ],
          [
            15.655165,
            52.445663,
            99.929475
          ],
          [
            15.655522,
            52.445734,
            100.228698
          ],
          [
            15.655898,
            52.445791,
            99.497092
          ],
          [
            15.65628,
            52.445834,
            98.679573
          ],
          [
            15.656662,
            52.4459,
            97.843902
          ],
          [
            15.657049,
            52.445965,
            96.998259
          ],
          [
            15.657425,
            52.446037,
            96.168558
          ],
          [
            15.657819,
            52.446106,
            95.305826
          ],
          [
            15.658178,
            52.446159,
            94.527833
          ],
          [
            15.658535,
            52.446226,
            94.11499
          ],
          [
            15.658919,
            52.446286,
            94.318357
          ],
          [
            15.659322,
            52.446366,
            94.535792
          ],
          [
            15.659725,
            52.446435,
            94.750547
          ],
          [
            15.660117,
            52.446515,
            94.962626
          ],
          [
            15.6605,
            52.446587,
            95.168288
          ],
          [
            15.660856,
            52.446647,
            95.3578
          ],
          [
            15.661196,
            52.446704,
            95.538708
          ],
          [
            15.661552,
            52.44677,
            96.01353
          ],
          [
            15.6619,
            52.446831,
            96.503488
          ],
          [
            15.662289,
            52.446904,
            97.054263
          ],
          [
            15.662634,
            52.446973,
            97.544765
          ],
          [
            15.662986,
            52.447049,
            98.04933
          ],
          [
            15.663332,
            52.447105,
            98.533112
          ],
          [
            15.663655,
            52.447184,
            99.003997
          ],
          [
            15.663986,
            52.447282,
            99.501115
          ],
          [
            15.664323,
            52.447342,
            99.566615
          ],
          [
            15.664636,
            52.447402,
            99.592174
          ],
          [
            15.664953,
            52.447516,
            99.620846
          ],
          [
            15.665297,
            52.447624,
            99.651002
          ],
          [
            15.665597,
            52.447727,
            99.677839
          ],
          [
            15.665885,
            52.447848,
            99.705186
          ],
          [
            15.666172,
            52.447934,
            99.730104
          ],
          [
            15.666463,
            52.448062,
            99.758049
          ],
          [
            15.666755,
            52.448188,
            99.573031
          ],
          [
            15.667052,
            52.448316,
            99.186242
          ],
          [
            15.667394,
            52.448451,
            98.752824
          ],
          [
            15.667699,
            52.448568,
            98.369594
          ],
          [
            15.668011,
            52.44872,
            97.944314
          ],
          [
            15.668356,
            52.448837,
            97.523604
          ],
          [
            15.6687,
            52.448952,
            97.106071
          ],
          [
            15.668973,
            52.449032,
            96.783861
          ],
          [
            15.669333,
            52.449176,
            96.428935
          ],
          [
            15.66969,
            52.449324,
            96.123959
          ],
          [
            15.670008,
            52.449454,
            95.851833
          ],
          [
            15.670332,
            52.449564,
            95.589839
          ],
          [
            15.670695,
            52.449672,
            95.304509
          ],
          [
            15.671022,
            52.449761,
            95.051433
          ],
          [
            15.671317,
            52.449822,
            94.831223
          ],
          [
            15.671622,
            52.449874,
            94.607232
          ],
          [
            15.671993,
            52.449902,
            94.917061
          ],
          [
            15.672405,
            52.449915,
            95.438543
          ],
          [
            15.672806,
            52.449911,
            95.945487
          ],
          [
            15.673196,
            52.449916,
            96.438652
          ],
          [
            15.673566,
            52.449939,
            96.909099
          ],
          [
            15.673972,
            52.449975,
            97.427681
          ],
          [
            15.674362,
            52.449999,
            97.923151
          ],
          [
            15.674766,
            52.450027,
            98.134497
          ],
          [
            15.675119,
            52.450053,
            97.723145
          ],
          [
            15.675501,
            52.450098,
            97.272854
          ],
          [
            15.675856,
            52.450137,
            96.855326
          ],
          [
            15.676257,
            52.450157,
            96.389481
          ],
          [
            15.676654,
            52.450201,
            95.921345
          ],
          [
            15.677071,
            52.450242,
            95.432538
          ],
          [
            15.677496,
            52.450273,
            94.937198
          ],
          [
            15.677908,
            52.450324,
            94.618766
          ],
          [
            15.678214,
            52.450322,
            94.406781
          ],
          [
            15.678533,
            52.450316,
            94.185536
          ],
          [
            15.678905,
            52.450327,
            93.928406
          ],
          [
            15.679212,
            52.450348,
            93.715368
          ],
          [
            15.679529,
            52.450378,
            93.494654
          ],
          [
            15.679935,
            52.4504,
            93.214149
          ],
          [
            15.680327,
            52.450417,
            92.943199
          ],
          [
            15.680628,
            52.450427,
            93.01881
          ],
          [
            15.681035,
            52.450469,
            93.544088
          ],
          [
            15.681425,
            52.450513,
            94.048882
          ],
          [
            15.681821,
            52.450551,
            94.559204
          ],
          [
            15.682186,
            52.450593,
            95.031869
          ],
          [
            15.682571,
            52.450634,
            95.530069
          ],
          [
            15.68294,
            52.450673,
            96.006618
          ],
          [
            15.683287,
            52.450715,
            96.456787
          ],
          [
            15.683636,
            52.450733,
            96.602809
          ],
          [
            15.684025,
            52.450777,
            96.622893
          ],
          [
            15.684388,
            52.450827,
            96.641787
          ],
          [
            15.684759,
            52.45084,
            96.660775
          ],
          [
            15.685165,
            52.450859,
            96.68144
          ],
          [
            15.685552,
            52.450886,
            96.701272
          ],
          [
            15.685964,
            52.450942,
            96.722679
          ],
          [
            15.68637,
            52.450998,
            96.706226
          ],
          [
            15.686766,
            52.451076,
            96.517932
          ],
          [
            15.687151,
            52.451151,
            96.33505
          ],
          [
            15.687525,
            52.451244,
            96.152206
          ],
          [
            15.687886,
            52.451355,
            95.969284
          ],
          [
            15.688244,
            52.451486,
            95.780383
          ],
          [
            15.688568,
            52.45163,
            95.598345
          ],
          [
            15.688902,
            52.451789,
            95.406574
          ],
          [
            15.68921,
            52.451939,
            95.36542
          ],
          [
            15.689503,
            52.452091,
            95.326507
          ],
          [
            15.689794,
            52.452226,
            95.289528
          ],
          [
            15.690082,
            52.452371,
            95.251757
          ],
          [
            15.690402,
            52.452535,
            95.209478
          ],
          [
            15.690694,
            52.452697,
            95.16954
          ],
          [
            15.690985,
            52.452845,
            95.13121
          ],
          [
            15.691279,
            52.452999,
            95.075901
          ],
          [
            15.691555,
            52.453163,
            94.99359
          ],
          [
            15.691837,
            52.453325,
            94.910849
          ],
          [
            15.692125,
            52.45348,
            94.828811
          ],
          [
            15.692408,
            52.453633,
            94.748051
          ],
          [
            15.692652,
            52.453761,
            94.679304
          ],
          [
            15.692925,
            52.453865,
            94.610021
          ],
          [
            15.693188,
            52.453992,
            94.538384
          ],
          [
            15.693462,
            52.45413,
            94.467779
          ],
          [
            15.69376,
            52.454287,
            94.415904
          ],
          [
            15.693983,
            52.45441,
            94.376246
          ],
          [
            15.69421,
            52.454533,
            94.336252
          ],
          [
            15.694497,
            52.454681,
            94.286759
          ],
          [
            15.694791,
            52.454851,
            94.233397
          ],
          [
            15.695021,
            52.454989,
            94.190901
          ],
          [
            15.695269,
            52.455126,
            94.146836
          ],
          [
            15.695511,
            52.455246,
            94.105753
          ],
          [
            15.695747,
            52.455371,
            94.154749
          ],
          [
            15.695977,
            52.455494,
            94.270189
          ],
          [
            15.696257,
            52.455649,
            94.412867
          ],
          [
            15.696498,
            52.455778,
            94.533908
          ],
          [
            15.696716,
            52.455934,
            94.66099
          ],
          [
            15.696836,
            52.456113,
            94.780653
          ],
          [
            15.697038,
            52.456293,
            94.915687
          ],
          [
            15.697202,
            52.456447,
            95.029322
          ],
          [
            15.697387,
            52.456628,
            95.161497
          ],
          [
            15.697589,
            52.456818,
            95.189394
          ],
          [
            15.697757,
            52.457,
            95.174533
          ],
          [
            15.697945,
            52.457188,
            95.158868
          ],
          [
            15.698126,
            52.457366,
            95.143979
          ],
          [
            15.698284,
            52.457558,
            95.128698
          ],
          [
            15.698451,
            52.45772,
            95.115087
          ],
          [
            15.698724,
            52.45787,
            95.099132
          ],
          [
            15.699076,
            52.458008,
            95.08099
          ],
          [
            15.699444,
            52.45812,
            94.824405
          ],
          [
            15.699816,
            52.458234,
            94.371351
          ],
          [
            15.700169,
            52.458345,
            93.93905
          ],
          [
            15.700504,
            52.45846,
            93.520699
          ],
          [
            15.70081,
            52.458584,
            93.120736
          ],
          [
            15.701084,
            52.458713,
            92.74402
          ],
          [
            15.701367,
            52.458822,
            92.379481
          ],
          [
            15.701731,
            52.45885,
            91.978962
          ],
          [
            15.702058,
            52.458796,
            91.977569
          ],
          [
            15.70237,
            52.458735,
            92.142315
          ],
          [
            15.702746,
            52.458657,
            92.341775
          ],
          [
            15.703115,
            52.45861,
            92.531187
          ],
          [
            15.703445,
            52.458564,
            92.70118
          ],
          [
            15.70377,
            52.458523,
            92.86823
          ],
          [
            15.704098,
            52.458497,
            93.034531
          ],
          [
            15.704443,
            52.458524,
            93.2095
          ],
          [
            15.704775,
            52.458548,
            93.587944
          ],
          [
            15.705083,
            52.458604,
            94.764326
          ],
          [
            15.70541,
            52.458704,
            96.101942
          ],
          [
            15.705673,
            52.458806,
            97.241743
          ],
          [
            15.70593,
            52.458926,
            98.429353
          ],
          [
            15.706184,
            52.459063,
            99.670089
          ],
          [
            15.706442,
            52.459211,
            100.966579
          ],
          [
            15.706697,
            52.459339,
            102.175536
          ],
          [
            15.706952,
            52.459488,
            103.467254
          ],
          [
            15.707203,
            52.459646,
            104.187886
          ],
          [
            15.70744,
            52.459791,
            104.287675
          ],
          [
            15.70771,
            52.459931,
            104.393396
          ],
          [
            15.707974,
            52.460086,
            104.502286
          ],
          [
            15.708233,
            52.460233,
            104.607356
          ],
          [
            15.708515,
            52.460387,
            104.719783
          ],
          [
            15.708787,
            52.460537,
            104.828705
          ],
          [
            15.709097,
            52.460692,
            104.947758
          ],
          [
            15.709384,
            52.46083,
            104.768521
          ],
          [
            15.709671,
            52.460977,
            104.169486
          ],
          [
            15.709962,
            52.461081,
            103.629139
          ],
          [
            15.71029,
            52.461162,
            103.063213
          ],
          [
            15.710617,
            52.461233,
            102.508511
          ],
          [
            15.710974,
            52.461269,
            101.930326
          ],
          [
            15.711326,
            52.461316,
            101.35453
          ],
          [
            15.711649,
            52.46139,
            100.800402
          ],
          [
            15.711966,
            52.46147,
            100.299661
          ],
          [
            15.712274,
            52.461534,
            100.358808
          ],
          [
            15.712619,
            52.461592,
            100.423848
          ],
          [
            15.712986,
            52.461657,
            100.493304
          ],
          [
            15.713314,
            52.461752,
            100.559302
          ],
          [
            15.713637,
            52.461874,
            100.628364
          ],
          [
            15.713897,
            52.461974,
            100.684274
          ],
          [
            15.714111,
            52.462101,
            100.738656
          ],
          [
            15.714302,
            52.462247,
            100.794362
          ],
          [
            15.714505,
            52.462412,
            100.803689
          ],
          [
            15.714687,
            52.462599,
            100.731004
          ],
          [
            15.714836,
            52.462775,
            100.664768
          ],
          [
            15.714981,
            52.462943,
            100.601304
          ],
          [
            15.715149,
            52.463141,
            100.526778
          ],
          [
            15.715307,
            52.463331,
            100.455541
          ],
          [
            15.71546,
            52.463523,
            100.384171
          ],
          [
            15.715616,
            52.463686,
            100.321091
          ],
          [
            15.71579,
            52.463852,
            100.255244
          ],
          [
            15.715969,
            52.464015,
            100.17051
          ],
          [
            15.716213,
            52.464159,
            100.06759
          ],
          [
            15.71647,
            52.464263,
            99.974592
          ],
          [
            15.716769,
            52.464333,
            99.878182
          ],
          [
            15.717121,
            52.464381,
            99.76967
          ],
          [
            15.717445,
            52.464392,
            99.671772
          ],
          [
            15.717798,
            52.464404,
            99.565545
          ],
          [
            15.718137,
            52.464394,
            99.463098
          ],
          [
            15.718462,
            52.46437,
            99.364735
          ],
          [
            15.718826,
            52.464363,
            99.60488
          ],
          [
            15.719194,
            52.464345,
            99.931525
          ],
          [
            15.71954,
            52.464336,
            100.238015
          ],
          [
            15.719865,
            52.464318,
            100.527338
          ],
          [
            15.720226,
            52.464289,
            100.849534
          ],
          [
            15.72056,
            52.464274,
            101.146108
          ],
          [
            15.720875,
            52.464277,
            101.429428
          ],
          [
            15.721174,
            52.464269,
            101.694359
          ],
          [
            15.721496,
            52.46424,
            102.002584
          ],
          [
            15.721854,
            52.464226,
            102.561641
          ],
          [
            15.722181,
            52.464211,
            103.072089
          ],
          [
            15.722502,
            52.464205,
            103.572789
          ],
          [
            15.722838,
            52.464212,
            104.094661
          ],
          [
            15.72319,
            52.464232,
            104.644118
          ],
          [
            15.723543,
            52.464254,
            105.195712
          ],
          [
            15.723879,
            52.4643,
            105.730333
          ],
          [
            15.724218,
            52.464372,
            106.287963
          ],
          [
            15.724534,
            52.464418,
            106.448631
          ],
          [
            15.724847,
            52.464492,
            106.263236
          ],
          [
            15.725165,
            52.464575,
            106.074105
          ],
          [
            15.725447,
            52.464653,
            105.904723
          ],
          [
            15.725715,
            52.464768,
            105.723763
          ],
          [
            15.725951,
            52.464948,
            105.516967
          ],
          [
            15.726106,
            52.465151,
            105.315996
          ],
          [
            15.726273,
            52.465358,
            105.108994
          ],
          [
            15.726439,
            52.465518,
            104.938779
          ],
          [
            15.726639,
            52.465703,
            104.711423
          ],
          [
            15.726879,
            52.46586,
            104.488696
          ],
          [
            15.727147,
            52.465955,
            104.29211
          ],
          [
            15.727457,
            52.466006,
            104.089399
          ],
          [
            15.727805,
            52.466007,
            103.869691
          ],
          [
            15.728126,
            52.466021,
            103.665341
          ],
          [
            15.72848,
            52.465984,
            103.437885
          ],
          [
            15.728831,
            52.465957,
            103.214471
          ],
          [
            15.729162,
            52.465924,
            103.04428
          ],
          [
            15.729479,
            52.465878,
            102.981881
          ],
          [
            15.729795,
            52.465846,
            102.920522
          ],
          [
            15.730137,
            52.465831,
            102.854903
          ],
          [
            15.730455,
            52.465813,
            102.793643
          ],
          [
            15.730752,
            52.465775,
            102.735485
          ],
          [
            15.731116,
            52.465753,
            102.66548
          ],
          [
            15.731483,
            52.465719,
            102.594339
          ],
          [
            15.731773,
            52.465682,
            102.537529
          ],
          [
            15.73208,
            52.465602,
            102.643244
          ],
          [
            15.732354,
            52.465523,
            103.000468
          ],
          [
            15.732625,
            52.465429,
            103.368229
          ],
          [
            15.732951,
            52.465308,
            103.818175
          ],
          [
            15.733237,
            52.465238,
            104.186513
          ],
          [
            15.733603,
            52.46515,
            104.649893
          ],
          [
            15.733958,
            52.465101,
            105.082214
          ],
          [
            15.734322,
            52.465085,
            105.511678
          ],
          [
            15.734673,
            52.46512,
            105.931537
          ],
          [
            15.735079,
            52.465194,
            106.806998
          ],
          [
            15.735426,
            52.465241,
            107.569982
          ],
          [
            15.735737,
            52.465339,
            108.31995
          ],
          [
            15.736067,
            52.465409,
            109.068194
          ],
          [
            15.736382,
            52.465435,
            109.748823
          ],
          [
            15.736673,
            52.465493,
            110.409207
          ],
          [
            15.736941,
            52.465578,
            111.097726
          ],
          [
            15.737248,
            52.465651,
            111.803414
          ],
          [
            15.737521,
            52.46573,
            112.391336
          ],
          [
            15.737819,
            52.465796,
            112.799822
          ],
          [
            15.73813,
            52.465846,
            113.207268
          ],
          [
            15.738396,
            52.465962,
            113.621526
          ],
          [
            15.738647,
            52.466073,
            114.015111
          ],
          [
            15.738944,
            52.466179,
            114.450861
          ],
          [
            15.739187,
            52.466305,
            114.854882
          ],
          [
            15.739451,
            52.466443,
            115.295401
          ],
          [
            15.739723,
            52.466551,
            115.706589
          ],
          [
            15.740009,
            52.46667,
            115.929634
          ],
          [
            15.740231,
            52.466814,
            115.579298
          ],
          [
            15.740503,
            52.466952,
            115.196697
          ],
          [
            15.74074,
            52.467101,
            114.828776
          ],
          [
            15.741019,
            52.467247,
            114.431381
          ],
          [
            15.741227,
            52.467387,
            114.096226
          ],
          [
            15.741476,
            52.467557,
            113.692135
          ],
          [
            15.741734,
            52.467719,
            113.291858
          ],
          [
            15.74199,
            52.46793,
            112.808584
          ],
          [
            15.742273,
            52.468118,
            111.806036
          ],
          [
            15.742578,
            52.468319,
            110.723884
          ],
          [
            15.742919,
            52.468476,
            109.699968
          ],
          [
            15.743327,
            52.468578,
            108.642002
          ],
          [
            15.74374,
            52.468655,
            107.607968
          ],
          [
            15.744128,
            52.468728,
            106.631596
          ],
          [
            15.744503,
            52.468816,
            105.681043
          ],
          [
            15.744889,
            52.468895,
            104.810627
          ],
          [
            15.745265,
            52.468968,
            103.965291
          ],
          [
            15.74561,
            52.469044,
            103.181427
          ],
          [
            15.745954,
            52.46913,
            102.389406
          ],
          [
            15.746273,
            52.4692,
            101.668137
          ],
          [
            15.74657,
            52.469272,
            100.988165
          ],
          [
            15.746875,
            52.469319,
            100.305911
          ],
          [
            15.747154,
            52.469398,
            99.650867
          ],
          [
            15.747481,
            52.469474,
            99.197379
          ],
          [
            15.747815,
            52.469553,
            98.814382
          ],
          [
            15.748149,
            52.469634,
            98.430479
          ],
          [
            15.748488,
            52.469719,
            98.039191
          ],
          [
            15.748781,
            52.46977,
            97.712892
          ],
          [
            15.749084,
            52.469819,
            97.378256
          ],
          [
            15.749459,
            52.469858,
            96.972098
          ],
          [
            15.749781,
            52.469885,
            96.624394
          ],
          [
            15.750129,
            52.469923,
            96.340169
          ],
          [
            15.750564,
            52.469987,
            96.337797
          ],
          [
            15.750926,
            52.470021,
            96.335841
          ],
          [
            15.751347,
            52.470063,
            96.333582
          ],
          [
            15.751745,
            52.470113,
            96.331429
          ],
          [
            15.752082,
            52.470144,
            96.329623
          ],
          [
            15.752473,
            52.470167,
            96.327542
          ],
          [
            15.752802,
            52.4702,
            96.325775
          ],
          [
            15.75315,
            52.470236,
            96.532576
          ],
          [
            15.753504,
            52.470269,
            96.894013
          ],
          [
            15.753836,
            52.470319,
            97.239174
          ],
          [
            15.754167,
            52.470349,
            97.577089
          ],
          [
            15.754494,
            52.470383,
            97.912073
          ],
          [
            15.754802,
            52.47042,
            98.228918
          ],
          [
            15.755115,
            52.470455,
            98.550343
          ],
          [
            15.75542,
            52.47049,
            98.863551
          ],
          [
            15.755711,
            52.470533,
            99.165846
          ],
          [
            15.756029,
            52.470562,
            99.48971
          ],
          [
            15.756362,
            52.470598,
            99.829274
          ],
          [
            15.756675,
            52.470639,
            100.150851
          ],
          [
            15.756988,
            52.470657,
            100.46652
          ],
          [
            15.757305,
            52.470703,
            100.79365
          ],
          [
            15.757671,
            52.47072,
            101.162022
          ],
          [
            15.758009,
            52.470762,
            101.509566
          ],
          [
            15.758341,
            52.470799,
            101.848384
          ],
          [
            15.758673,
            52.470845,
            102.190318
          ],
          [
            15.758989,
            52.470879,
            101.99891
          ],
          [
            15.759355,
            52.470927,
            101.586824
          ],
          [
            15.759679,
            52.470952,
            101.227326
          ],
          [
            15.760025,
            52.470987,
            100.841222
          ],
          [
            15.76035,
            52.471016,
            100.479285
          ],
          [
            15.760714,
            52.47105,
            100.073349
          ],
          [
            15.761052,
            52.471155,
            99.655438
          ],
          [
            15.761392,
            52.471267,
            99.229768
          ],
          [
            15.761724,
            52.47137,
            99.218626
          ],
          [
            15.762075,
            52.471509,
            99.68116
          ],
          [
            15.76237,
            52.471621,
            100.064978
          ],
          [
            15.762605,
            52.471737,
            100.40018
          ],
          [
            15.762875,
            52.471861,
            100.773552
          ],
          [
            15.76311,
            52.47199,
            101.122878
          ],
          [
            15.763398,
            52.472093,
            101.493913
          ],
          [
            15.763685,
            52.472192,
            101.858339
          ],
          [
            15.763953,
            52.47232,
            102.234373
          ],
          [
            15.764219,
            52.472441,
            102.662458
          ],
          [
            15.764481,
            52.472573,
            103.110636
          ],
          [
            15.764728,
            52.472678,
            103.510079
          ],
          [
            15.765011,
            52.472775,
            103.936919
          ],
          [
            15.765284,
            52.472896,
            104.381648
          ],
          [
            15.765575,
            52.473017,
            104.845135
          ],
          [
            15.765855,
            52.473135,
            105.293249
          ],
          [
            15.766145,
            52.473255,
            105.755094
          ],
          [
            15.7664,
            52.473362,
            106.158031
          ],
          [
            15.766655,
            52.473473,
            105.979407
          ],
          [
            15.766912,
            52.47359,
            105.796541
          ],
          [
            15.767206,
            52.473683,
            105.607768
          ],
          [
            15.767489,
            52.473796,
            105.414147
          ],
          [
            15.767764,
            52.473916,
            105.218908
          ],
          [
            15.768061,
            52.47405,
            105.007685
          ],
          [
            15.768354,
            52.474158,
            104.812543
          ],
          [
            15.768602,
            52.474257,
            104.643555
          ],
          [
            15.768865,
            52.474353,
            104.483286
          ],
          [
            15.769114,
            52.474478,
            104.631751
          ],
          [
            15.769393,
            52.474589,
            104.78511
          ],
          [
            15.769649,
            52.474692,
            104.926574
          ],
          [
            15.769956,
            52.474797,
            105.088625
          ],
          [
            15.770228,
            52.474922,
            105.24546
          ],
          [
            15.770549,
            52.47506,
            105.426264
          ],
          [
            15.770864,
            52.475193,
            105.602614
          ],
          [
            15.771153,
            52.475328,
            105.770195
          ],
          [
            15.771468,
            52.475457,
            105.679536
          ],
          [
            15.771802,
            52.475597,
            105.414098
          ],
          [
            15.772118,
            52.475722,
            105.167224
          ],
          [
            15.772437,
            52.475877,
            104.900065
          ],
          [
            15.772699,
            52.475991,
            104.689076
          ],
          [
            15.772962,
            52.476085,
            104.489438
          ],
          [
            15.77325,
            52.476221,
            104.250853
          ],
          [
            15.773562,
            52.476352,
            104.002715
          ],
          [
            15.773847,
            52.476494,
            103.390108
          ],
          [
            15.774094,
            52.476596,
            102.678719
          ],
          [
            15.774407,
            52.476712,
            101.805151
          ],
          [
            15.774755,
            52.476874,
            100.756818
          ],
          [
            15.775027,
            52.477011,
            99.914176
          ],
          [
            15.77497,
            52.477207,
            99.130526
          ],
          [
            15.774862,
            52.4774,
            98.332223
          ],
          [
            15.774748,
            52.477611,
            97.460661
          ],
          [
            15.774661,
            52.477829,
            96.833408
          ],
          [
            15.774616,
            52.47806,
            96.737745
          ],
          [
            15.774612,
            52.478288,
            96.643972
          ],
          [
            15.774631,
            52.478497,
            96.557977
          ],
          [
            15.77465,
            52.478717,
            96.467407
          ],
          [
            15.77468,
            52.478927,
            96.380655
          ],
          [
            15.774702,
            52.479166,
            96.282326
          ],
          [
            15.774649,
            52.479395,
            96.187245
          ],
          [
            15.774565,
            52.479605,
            96.126179
          ],
          [
            15.774473,
            52.479806,
            96.133489
          ],
          [
            15.774711,
            52.479987,
            96.141686
          ],
          [
            15.774938,
            52.480117,
            96.148305
          ],
          [
            15.775164,
            52.480247,
            96.15491
          ],
          [
            15.775427,
            52.480406,
            96.162803
          ],
          [
            15.77568,
            52.480574,
            96.170754
          ],
          [
            15.775922,
            52.480743,
            96.178598
          ],
          [
            15.776225,
            52.480844,
            96.185937
          ],
          [
            15.776512,
            52.48093,
            96.383535
          ],
          [
            15.776817,
            52.481021,
            96.621549
          ],
          [
            15.777059,
            52.481142,
            96.843151
          ],
          [
            15.777072,
            52.481376,
            97.124429
          ],
          [
            15.776918,
            52.48155,
            97.350488
          ],
          [
            15.776808,
            52.481738,
            97.580523
          ],
          [
            15.776691,
            52.481909,
            97.792002
          ],
          [
            15.776546,
            52.482095,
            98.030867
          ],
          [
            15.776371,
            52.482282,
            98.313513
          ],
          [
            15.776178,
            52.482461,
            98.800433
          ],
          [
            15.776017,
            52.482631,
            99.246557
          ],
          [
            15.776231,
            52.48276,
            99.673323
          ],
          [
            15.776474,
            52.482887,
            100.117689
          ],
          [
            15.776725,
            52.482997,
            100.54825
          ],
          [
            15.777018,
            52.483097,
            101.02295
          ],
          [
            15.776763,
            52.482991,
            101.450274
          ],
          [
            15.776499,
            52.482875,
            101.917546
          ],
          [
            15.7762,
            52.482764,
            102.243151
          ],
          [
            15.775923,
            52.482828,
            101.714799
          ],
          [
            15.77573,
            52.48302,
            101.145492
          ],
          [
            15.775592,
            52.483218,
            100.601739
          ],
          [
            15.775513,
            52.483407,
            100.1092
          ],
          [
            15.775426,
            52.483618,
            99.558953
          ],
          [
            15.775321,
            52.483825,
            99.011793
          ],
          [
            15.775266,
            52.484049,
            98.439823
          ],
          [
            15.775217,
            52.484244,
            97.94138
          ],
          [
            15.77511,
            52.484454,
            97.690589
          ],
          [
            15.775047,
            52.484665,
            97.562928
          ],
          [
            15.774963,
            52.484859,
            97.443271
          ],
          [
            15.774908,
            52.485067,
            97.317788
          ],
          [
            15.774737,
            52.485278,
            97.177697
          ],
          [
            15.774566,
            52.485486,
            97.039218
          ],
          [
            15.774381,
            52.485687,
            96.901987
          ],
          [
            15.774214,
            52.485871,
            96.776821
          ],
          [
            15.77407,
            52.486065,
            96.613741
          ],
          [
            15.773893,
            52.486266,
            96.40079
          ],
          [
            15.77368,
            52.486485,
            96.162426
          ],
          [
            15.773445,
            52.486701,
            95.920429
          ],
          [
            15.77319,
            52.486916,
            95.672719
          ],
          [
            15.772996,
            52.487099,
            95.469253
          ],
          [
            15.772815,
            52.487275,
            95.274635
          ],
          [
            15.772596,
            52.487486,
            95.041449
          ],
          [
            15.772361,
            52.487703,
            94.71901
          ],
          [
            15.772114,
            52.487915,
            94.39448
          ],
          [
            15.771926,
            52.488058,
            94.165775
          ],
          [
            15.771658,
            52.488263,
            93.838397
          ],
          [
            15.771424,
            52.488427,
            93.566991
          ],
          [
            15.771197,
            52.488623,
            93.267149
          ],
          [
            15.770982,
            52.488825,
            92.96653
          ],
          [
            15.770761,
            52.48903,
            92.922551
          ],
          [
            15.770511,
            52.489235,
            93.253369
          ],
          [
            15.770293,
            52.489419,
            93.547702
          ],
          [
            15.770104,
            52.489602,
            93.827933
          ],
          [
            15.769881,
            52.489779,
            94.116957
          ],
          [
            15.769661,
            52.489944,
            94.392943
          ],
          [
            15.769384,
            52.489876,
            94.633791
          ],
          [
            15.769352,
            52.489682,
            94.886439
          ],
          [
            15.769112,
            52.489537,
            95.178195
          ],
          [
            15.768882,
            52.489376,
            95.659287
          ],
          [
            15.768664,
            52.489242,
            96.084839
          ],
          [
            15.768405,
            52.489074,
            96.60353
          ],
          [
            15.768159,
            52.488904,
            97.113541
          ],
          [
            15.7679,
            52.488733,
            97.637321
          ],
          [
            15.767665,
            52.488565,
            98.134351
          ],
          [
            15.767438,
            52.488409,
            98.604841
          ],
          [
            15.767194,
            52.488271,
            99.061522
          ],
          [
            15.766949,
            52.488098,
            99.287196
          ],
          [
            15.76671,
            52.487961,
            99.419239
          ],
          [
            15.766389,
            52.487835,
            99.572836
          ],
          [
            15.766105,
            52.487738,
            99.703705
          ],
          [
            15.765801,
            52.48765,
            99.839573
          ],
          [
            15.765535,
            52.487558,
            99.963324
          ],
          [
            15.765229,
            52.487477,
            100.097561
          ],
          [
            15.764952,
            52.487388,
            100.223425
          ],
          [
            15.764681,
            52.487286,
            100.35214
          ],
          [
            15.764353,
            52.487143,
            100.004016
          ],
          [
            15.764106,
            52.487034,
            99.737563
          ],
          [
            15.763822,
            52.486943,
            99.456777
          ],
          [
            15.76355,
            52.48684,
            99.161156
          ],
          [
            15.763249,
            52.486747,
            98.865337
          ],
          [
            15.762957,
            52.486672,
            98.58784
          ],
          [
            15.762667,
            52.48663,
            98.325789
          ],
          [
            15.762326,
            52.486554,
            98.008511
          ],
          [
            15.76198,
            52.486513,
            97.743424
          ],
          [
            15.761649,
            52.486498,
            97.621824
          ],
          [
            15.761306,
            52.486467,
            97.494903
          ],
          [
            15.761002,
            52.486421,
            97.380408
          ],
          [
            15.760627,
            52.486396,
            97.242327
          ],
          [
            15.760291,
            52.486366,
            97.118116
          ],
          [
            15.759921,
            52.486335,
            96.981586
          ],
          [
            15.759562,
            52.486294,
            96.848029
          ],
          [
            15.759279,
            52.486337,
            96.735277
          ],
          [
            15.759336,
            52.486535,
            96.654624
          ],
          [
            15.75947,
            52.48672,
            96.593554
          ],
          [
            15.759661,
            52.486889,
            96.531525
          ],
          [
            15.759895,
            52.487027,
            96.471698
          ],
          [
            15.760132,
            52.487148,
            96.414748
          ],
          [
            15.760195,
            52.487322,
            96.356163
          ],
          [
            15.760234,
            52.487518,
            96.295726
          ],
          [
            15.759966,
            52.487682,
            96.218327
          ],
          [
            15.759623,
            52.48772,
            96.154311
          ],
          [
            15.759312,
            52.487802,
            96.4597
          ],
          [
            15.759108,
            52.487938,
            96.747496
          ],
          [
            15.759242,
            52.488097,
            97.012803
          ],
          [
            15.75909,
            52.487922,
            97.322699
          ],
          [
            15.759344,
            52.4878,
            97.616429
          ],
          [
            15.759535,
            52.487597,
            97.965985
          ],
          [
            15.759604,
            52.487386,
            98.280443
          ],
          [
            15.759672,
            52.487185,
            98.585007
          ],
          [
            15.759731,
            52.486989,
            98.823767
          ],
          [
            15.760016,
            52.486865,
            98.960106
          ],
          [
            15.760138,
            52.486687,
            99.093398
          ],
          [
            15.760342,
            52.486613,
            99.212969
          ],
          [
            15.76067,
            52.48664,
            99.34185
          ],
          [
            15.760995,
            52.486651,
            99.469306
          ],
          [
            15.760568,
            52.486609,
            99.637335
          ],
          [
            15.760229,
            52.486582,
            99.770238
          ],
          [
            15.759873,
            52.486552,
            99.909843
          ],
          [
            15.759569,
            52.486517,
            100.186338
          ],
          [
            15.759303,
            52.486416,
            100.520593
          ],
          [
            15.759207,
            52.486237,
            100.829755
          ],
          [
            15.758859,
            52.48618,
            101.187944
          ],
          [
            15.758517,
            52.48613,
            101.538658
          ],
          [
            15.758208,
            52.486069,
            101.861376
          ],
          [
            15.757914,
            52.485988,
            102.184547
          ],
          [
            15.757649,
            52.485881,
            102.500649
          ],
          [
            15.757434,
            52.485732,
            102.825332
          ],
          [
            15.757198,
            52.485567,
            102.62359
          ],
          [
            15.756925,
            52.48543,
            102.359043
          ],
          [
            15.756629,
            52.485333,
            102.108028
          ],
          [
            15.756271,
            52.485262,
            101.827192
          ],
          [
            15.755919,
            52.485188,
            101.549399
          ],
          [
            15.755572,
            52.485101,
            101.269598
          ],
          [
            15.755233,
            52.485049,
            101.008812
          ],
          [
            15.754905,
            52.484991,
            100.753922
          ],
          [
            15.754573,
            52.484936,
            100.856796
          ],
          [
            15.754204,
            52.484867,
            101.200794
          ],
          [
            15.753898,
            52.484809,
            101.486372
          ],
          [
            15.753547,
            52.484755,
            101.812077
          ],
          [
            15.753214,
            52.484722,
            102.116135
          ],
          [
            15.752868,
            52.484668,
            102.434624
          ],
          [
            15.752568,
            52.484603,
            102.718377
          ],
          [
            15.752265,
            52.484527,
            103.010705
          ],
          [
            15.751967,
            52.484461,
            103.292461
          ],
          [
            15.751656,
            52.484376,
            103.197437
          ],
          [
            15.751342,
            52.4843,
            103.103214
          ],
          [
            15.751019,
            52.484229,
            103.007449
          ],
          [
            15.750728,
            52.484171,
            102.922096
          ],
          [
            15.750382,
            52.484102,
            102.82059
          ],
          [
            15.750078,
            52.48406,
            102.733688
          ],
          [
            15.749738,
            52.484014,
            102.636089
          ],
          [
            15.749433,
            52.483977,
            102.549392
          ],
          [
            15.749169,
            52.48406,
            102.477103
          ],
          [
            15.748986,
            52.484205,
            102.597933
          ],
          [
            15.748819,
            52.48436,
            102.720401
          ],
          [
            15.748651,
            52.484516,
            102.843621
          ],
          [
            15.748464,
            52.484686,
            102.978932
          ],
          [
            15.748252,
            52.484857,
            103.120444
          ],
          [
            15.748074,
            52.485038,
            103.260067
          ],
          [
            15.747886,
            52.485211,
            103.397367
          ],
          [
            15.747697,
            52.485393,
            103.539574
          ],
          [
            15.747469,
            52.485583,
            103.607542
          ],
          [
            15.747243,
            52.485775,
            103.404012
          ],
          [
            15.747017,
            52.485986,
            103.186971
          ],
          [
            15.746785,
            52.486197,
            102.96817
          ],
          [
            15.746588,
            52.4864,
            102.764932
          ],
          [
            15.746422,
            52.486553,
            102.606894
          ],
          [
            15.746179,
            52.486766,
            102.383374
          ],
          [
            15.745942,
            52.48698,
            102.160977
          ],
          [
            15.745736,
            52.487196,
            101.736175
          ],
          [
            15.745494,
            52.48741,
            101.222644
          ],
          [
            15.74526,
            52.487617,
            100.725755
          ],
          [
            15.745072,
            52.487807,
            100.287262
          ],
          [
            15.744862,
            52.487984,
            99.85545
          ],
          [
            15.744653,
            52.488204,
            99.353232
          ],
          [
            15.744435,
            52.488406,
            98.875517
          ],
          [
            15.744336,
            52.488677,
            98.461565
          ],
          [
            15.744391,
            52.488911,
            98.277356
          ],
          [
            15.744436,
            52.489157,
            98.084491
          ],
          [
            15.744474,
            52.489398,
            97.895849
          ],
          [
            15.7445,
            52.489658,
            97.692897
          ],
          [
            15.744538,
            52.489888,
            97.512399
          ],
          [
            15.744568,
            52.490116,
            97.334182
          ],
          [
            15.744605,
            52.49038,
            97.151307
          ],
          [
            15.74464,
            52.49056,
            97.147699
          ],
          [
            15.744675,
            52.490783,
            97.143244
          ],
          [
            15.744708,
            52.491006,
            97.13879
          ],
          [
            15.744756,
            52.491257,
            97.133764
          ],
          [
            15.744796,
            52.491472,
            97.129455
          ],
          [
            15.744828,
            52.491717,
            97.124564
          ],
          [
            15.744859,
            52.491966,
            97.119597
          ],
          [
            15.744902,
            52.492215,
            97.189503
          ],
          [
            15.744925,
            52.492438,
            97.402106
          ],
          [
            15.744955,
            52.492678,
            97.63124
          ],
          [
            15.745002,
            52.492881,
            97.826292
          ],
          [
            15.745056,
            52.493159,
            98.092671
          ],
          [
            15.745081,
            52.493357,
            98.281931
          ],
          [
            15.74512,
            52.49355,
            98.466953
          ],
          [
            15.745196,
            52.493745,
            98.657645
          ],
          [
            15.745316,
            52.493945,
            98.827374
          ],
          [
            15.745475,
            52.494118,
            98.827374
          ],
          [
            15.745552,
            52.494269,
            98.827374
          ],
          [
            15.745583,
            52.494473,
            98.827374
          ],
          [
            15.745525,
            52.494661,
            98.827374
          ],
          [
            15.745582,
            52.494859,
            98.827374
          ],
          [
            15.745486,
            52.495044,
            98.827374
          ],
          [
            15.745623,
            52.494887,
            98.827374
          ],
          [
            15.745562,
            52.494703,
            98.827374
          ],
          [
            15.745403,
            52.494869,
            98.827374
          ],
          [
            15.745407,
            52.494836,
            98.827374
          ],
          [
            15.745509,
            52.494683,
            98.827374
          ]
        ]
      }
    }
  ]
}

let day43: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            15.744925,
            52.492395,
            100.087129
          ],
          [
            15.744906,
            52.492181,
            100.087129
          ],
          [
            15.744873,
            52.491951,
            100.087129
          ],
          [
            15.744845,
            52.491751,
            100.087129
          ],
          [
            15.744809,
            52.491536,
            100.087129
          ],
          [
            15.744746,
            52.491341,
            100.646697
          ],
          [
            15.744711,
            52.491118,
            101.418914
          ],
          [
            15.744706,
            52.4909,
            102.170727
          ],
          [
            15.744665,
            52.490689,
            102.902685
          ],
          [
            15.744667,
            52.490481,
            103.621245
          ],
          [
            15.74462,
            52.490285,
            104.311374
          ],
          [
            15.744584,
            52.490084,
            105.009674
          ],
          [
            15.744529,
            52.489877,
            105.732941
          ],
          [
            15.744497,
            52.489667,
            106.322682
          ],
          [
            15.744493,
            52.489466,
            106.478466
          ],
          [
            15.744468,
            52.48925,
            106.646283
          ],
          [
            15.744425,
            52.489065,
            106.791172
          ],
          [
            15.744397,
            52.488845,
            106.962312
          ],
          [
            15.744379,
            52.48863,
            107.129157
          ],
          [
            15.744505,
            52.488409,
            107.311386
          ],
          [
            15.744682,
            52.488229,
            107.47404
          ],
          [
            15.744843,
            52.488057,
            107.627914
          ],
          [
            15.74501,
            52.487887,
            107.858583
          ],
          [
            15.74521,
            52.487707,
            108.151081
          ],
          [
            15.74541,
            52.487533,
            108.436929
          ],
          [
            15.745608,
            52.487361,
            108.7197
          ],
          [
            15.745796,
            52.487191,
            108.996198
          ],
          [
            15.746001,
            52.487013,
            109.288888
          ],
          [
            15.746168,
            52.486846,
            109.552075
          ],
          [
            15.746365,
            52.486663,
            109.846618
          ],
          [
            15.746557,
            52.486475,
            110.042775
          ],
          [
            15.746754,
            52.486285,
            109.691684
          ],
          [
            15.746922,
            52.486099,
            109.360793
          ],
          [
            15.747098,
            52.485919,
            109.034356
          ],
          [
            15.747318,
            52.485732,
            108.675951
          ],
          [
            15.747505,
            52.485551,
            108.342796
          ],
          [
            15.747681,
            52.485378,
            108.025619
          ],
          [
            15.747879,
            52.485206,
            107.69809
          ],
          [
            15.748099,
            52.485011,
            107.329325
          ],
          [
            15.748341,
            52.484797,
            106.924522
          ],
          [
            15.748543,
            52.484605,
            106.569027
          ],
          [
            15.748731,
            52.484445,
            106.262433
          ],
          [
            15.748921,
            52.484275,
            105.942095
          ],
          [
            15.749104,
            52.484108,
            105.628907
          ],
          [
            15.749295,
            52.483959,
            105.332879
          ],
          [
            15.749628,
            52.483976,
            105.008357
          ],
          [
            15.749945,
            52.484021,
            104.699636
          ],
          [
            15.750277,
            52.484039,
            104.523584
          ],
          [
            15.750593,
            52.484083,
            104.605553
          ],
          [
            15.750931,
            52.48415,
            104.694999
          ],
          [
            15.751299,
            52.484253,
            104.797078
          ],
          [
            15.751638,
            52.484336,
            104.889116
          ],
          [
            15.751982,
            52.484405,
            104.98026
          ],
          [
            15.752338,
            52.484497,
            105.077574
          ],
          [
            15.7527,
            52.484581,
            105.175094
          ],
          [
            15.753051,
            52.484656,
            105.135702
          ],
          [
            15.753415,
            52.484703,
            104.832654
          ],
          [
            15.753769,
            52.484747,
            104.538385
          ],
          [
            15.754133,
            52.484796,
            104.234459
          ],
          [
            15.754496,
            52.484863,
            103.924693
          ],
          [
            15.754825,
            52.484956,
            103.626678
          ],
          [
            15.755133,
            52.485007,
            103.366521
          ],
          [
            15.755431,
            52.485068,
            103.10914
          ],
          [
            15.755796,
            52.485121,
            102.801105
          ],
          [
            15.756115,
            52.485201,
            102.495917
          ],
          [
            15.756411,
            52.485253,
            102.223062
          ],
          [
            15.756725,
            52.485339,
            101.918283
          ],
          [
            15.75704,
            52.485448,
            101.597186
          ],
          [
            15.757231,
            52.48559,
            101.330056
          ],
          [
            15.757447,
            52.485747,
            101.032374
          ],
          [
            15.757723,
            52.485927,
            100.674607
          ],
          [
            15.758013,
            52.486021,
            100.383887
          ],
          [
            15.758329,
            52.486083,
            99.992296
          ],
          [
            15.758648,
            52.486144,
            99.472238
          ],
          [
            15.758995,
            52.486168,
            98.925082
          ],
          [
            15.759347,
            52.486234,
            98.352982
          ],
          [
            15.759705,
            52.486286,
            97.781214
          ],
          [
            15.759998,
            52.486329,
            97.308833
          ],
          [
            15.760413,
            52.486369,
            96.656078
          ],
          [
            15.760817,
            52.486426,
            96.012063
          ],
          [
            15.761227,
            52.486437,
            95.926598
          ],
          [
            15.761566,
            52.486471,
            96.535285
          ],
          [
            15.761892,
            52.486484,
            97.114171
          ],
          [
            15.762234,
            52.486514,
            97.72614
          ],
          [
            15.762591,
            52.486575,
            98.382882
          ],
          [
            15.76291,
            52.486639,
            98.978199
          ],
          [
            15.763246,
            52.486726,
            99.625466
          ],
          [
            15.763514,
            52.486819,
            100.171727
          ],
          [
            15.763806,
            52.486911,
            100.758667
          ],
          [
            15.764095,
            52.487019,
            100.688078
          ],
          [
            15.764398,
            52.48711,
            100.47518
          ],
          [
            15.764714,
            52.487275,
            100.215239
          ],
          [
            15.765008,
            52.487406,
            99.986812
          ],
          [
            15.765366,
            52.487516,
            99.736106
          ],
          [
            15.765738,
            52.487633,
            99.474772
          ],
          [
            15.766138,
            52.487734,
            99.204372
          ],
          [
            15.766462,
            52.487844,
            98.998653
          ],
          [
            15.766774,
            52.488013,
            98.881381
          ],
          [
            15.767016,
            52.488188,
            98.775761
          ],
          [
            15.767269,
            52.488364,
            98.667395
          ],
          [
            15.767468,
            52.488506,
            98.581394
          ],
          [
            15.767684,
            52.488656,
            98.489493
          ],
          [
            15.767941,
            52.488813,
            98.387306
          ],
          [
            15.768154,
            52.488946,
            98.301507
          ],
          [
            15.768386,
            52.489078,
            98.212302
          ],
          [
            15.768638,
            52.489221,
            98.08872
          ],
          [
            15.76889,
            52.489376,
            97.951765
          ],
          [
            15.769129,
            52.489523,
            97.821801
          ],
          [
            15.769341,
            52.489676,
            97.696665
          ],
          [
            15.769294,
            52.489844,
            97.573598
          ],
          [
            15.769306,
            52.489984,
            97.458481
          ],
          [
            15.769278,
            52.489961,
            97.339155
          ],
          [
            15.769573,
            52.489874,
            97.213881
          ],
          [
            15.769729,
            52.48991,
            97.095906
          ],
          [
            15.769911,
            52.489744,
            97.123357
          ],
          [
            15.77011,
            52.48956,
            97.203657
          ],
          [
            15.770306,
            52.489384,
            97.281176
          ],
          [
            15.770454,
            52.489222,
            97.348762
          ],
          [
            15.770684,
            52.489033,
            97.434512
          ],
          [
            15.770925,
            52.488845,
            97.521468
          ],
          [
            15.771148,
            52.488661,
            97.604814
          ],
          [
            15.771369,
            52.488469,
            97.690268
          ],
          [
            15.771576,
            52.488295,
            98.222194
          ],
          [
            15.77178,
            52.488129,
            99.043979
          ],
          [
            15.771987,
            52.487947,
            99.922671
          ],
          [
            15.772172,
            52.487772,
            100.748371
          ],
          [
            15.772366,
            52.487603,
            101.565591
          ],
          [
            15.772557,
            52.487446,
            102.340011
          ],
          [
            15.772743,
            52.48728,
            103.136872
          ],
          [
            15.772919,
            52.48713,
            103.867568
          ],
          [
            15.77314,
            52.486947,
            104.76953
          ],
          [
            15.773354,
            52.486748,
            104.513283
          ],
          [
            15.773534,
            52.486587,
            104.210732
          ],
          [
            15.773707,
            52.486411,
            103.892123
          ],
          [
            15.773857,
            52.486249,
            103.603276
          ],
          [
            15.774038,
            52.486055,
            103.256705
          ],
          [
            15.774188,
            52.485886,
            102.958341
          ],
          [
            15.77435,
            52.485689,
            102.616039
          ],
          [
            15.774504,
            52.485503,
            102.292409
          ],
          [
            15.774661,
            52.485316,
            101.952874
          ],
          [
            15.774792,
            52.485127,
            101.587683
          ],
          [
            15.774857,
            52.48493,
            101.226771
          ],
          [
            15.77491,
            52.484747,
            100.896068
          ],
          [
            15.774958,
            52.484515,
            100.47991
          ],
          [
            15.775041,
            52.484302,
            100.090086
          ],
          [
            15.775146,
            52.484081,
            99.68057
          ],
          [
            15.775212,
            52.483886,
            99.326126
          ],
          [
            15.775143,
            52.483704,
            98.963085
          ],
          [
            15.774922,
            52.483613,
            98.619674
          ],
          [
            15.774603,
            52.483782,
            97.907479
          ],
          [
            15.77431,
            52.483376,
            97.069295
          ],
          [
            15.77457,
            52.483464,
            96.72552
          ],
          [
            15.774463,
            52.483674,
            95.983814
          ],
          [
            15.774545,
            52.48353,
            95.775348
          ],
          [
            15.774615,
            52.483535,
            96.248205
          ],
          [
            15.774529,
            52.483523,
            96.689739
          ],
          [
            15.774723,
            52.483655,
            97.11308
          ],
          [
            15.775016,
            52.483434,
            97.969458
          ],
          [
            15.775317,
            52.483498,
            98.409306
          ],
          [
            15.775425,
            52.483313,
            98.859228
          ],
          [
            15.775548,
            52.483108,
            99.353374
          ],
          [
            15.775693,
            52.482918,
            99.789456
          ],
          [
            15.775853,
            52.482726,
            100.017753
          ],
          [
            15.776066,
            52.482567,
            100.237427
          ],
          [
            15.776199,
            52.482358,
            100.473053
          ],
          [
            15.776362,
            52.482161,
            100.704953
          ],
          [
            15.776538,
            52.481964,
            100.940798
          ],
          [
            15.77672,
            52.481799,
            101.15009
          ],
          [
            15.7769,
            52.481621,
            101.369851
          ],
          [
            15.777082,
            52.481452,
            101.584232
          ],
          [
            15.777288,
            52.481305,
            101.555434
          ],
          [
            15.777545,
            52.481169,
            101.411899
          ],
          [
            15.777762,
            52.481003,
            101.265133
          ],
          [
            15.778016,
            52.480867,
            101.122398
          ],
          [
            15.778197,
            52.480681,
            100.972797
          ],
          [
            15.778377,
            52.480506,
            100.829961
          ],
          [
            15.778503,
            52.480318,
            100.689442
          ],
          [
            15.778473,
            52.480167,
            100.549621
          ],
          [
            15.778473,
            52.479972,
            100.410362
          ],
          [
            15.778659,
            52.479802,
            100.219389
          ],
          [
            15.778837,
            52.479642,
            100.036293
          ],
          [
            15.779091,
            52.479581,
            99.859334
          ],
          [
            15.779355,
            52.479712,
            99.659172
          ],
          [
            15.779653,
            52.47974,
            99.469022
          ],
          [
            15.77986,
            52.479893,
            99.281035
          ],
          [
            15.780109,
            52.480096,
            99.040999
          ],
          [
            15.780322,
            52.480258,
            98.843149
          ],
          [
            15.780612,
            52.480185,
            98.616028
          ],
          [
            15.780869,
            52.480061,
            98.200508
          ],
          [
            15.781118,
            52.479907,
            97.750453
          ],
          [
            15.781326,
            52.479772,
            97.363733
          ],
          [
            15.781399,
            52.479763,
            96.888021
          ],
          [
            15.781645,
            52.479632,
            96.473969
          ],
          [
            15.781933,
            52.479488,
            96.001878
          ],
          [
            15.782177,
            52.479333,
            95.55524
          ],
          [
            15.782235,
            52.47914,
            95.133462
          ],
          [
            15.782195,
            52.47895,
            94.939856
          ],
          [
            15.782157,
            52.478749,
            94.904648
          ],
          [
            15.782259,
            52.478538,
            94.866258
          ],
          [
            15.782411,
            52.47834,
            94.827788
          ],
          [
            15.782676,
            52.478214,
            94.792265
          ],
          [
            15.78294,
            52.478103,
            94.758288
          ],
          [
            15.783015,
            52.477912,
            94.724165
          ],
          [
            15.782992,
            52.477703,
            94.687582
          ],
          [
            15.782932,
            52.47749,
            94.649972
          ],
          [
            15.782883,
            52.477275,
            94.466321
          ],
          [
            15.782967,
            52.477058,
            94.261716
          ],
          [
            15.783209,
            52.476874,
            94.046513
          ],
          [
            15.783393,
            52.476709,
            93.864246
          ],
          [
            15.78318,
            52.476885,
            93.663663
          ],
          [
            15.782993,
            52.477035,
            93.490716
          ],
          [
            15.782921,
            52.477238,
            93.300453
          ],
          [
            15.782939,
            52.477465,
            93.092997
          ],
          [
            15.782956,
            52.477477,
            92.982382
          ],
          [
            15.782939,
            52.477269,
            92.93673
          ],
          [
            15.782944,
            52.477268,
            92.894
          ],
          [
            15.783109,
            52.4773,
            92.848065
          ],
          [
            15.783117,
            52.477345,
            92.799181
          ],
          [
            15.782939,
            52.477503,
            92.749806
          ],
          [
            15.782982,
            52.477707,
            92.704744
          ],
          [
            15.783009,
            52.477907,
            92.660753
          ],
          [
            15.782932,
            52.478103,
            92.615936
          ],
          [
            15.782673,
            52.478224,
            92.879378
          ],
          [
            15.78239,
            52.478346,
            93.198175
          ],
          [
            15.782287,
            52.478535,
            93.502042
          ],
          [
            15.782208,
            52.478734,
            93.809839
          ],
          [
            15.781895,
            52.47876,
            94.104435
          ],
          [
            15.781585,
            52.478751,
            94.390191
          ],
          [
            15.781249,
            52.478855,
            94.781311
          ],
          [
            15.781121,
            52.479038,
            95.082139
          ],
          [
            15.780921,
            52.479202,
            95.5475
          ],
          [
            15.780702,
            52.479354,
            96.426796
          ],
          [
            15.780486,
            52.479521,
            97.347471
          ],
          [
            15.780202,
            52.479631,
            98.234928
          ],
          [
            15.77992,
            52.479724,
            99.080392
          ],
          [
            15.779615,
            52.479764,
            99.90588
          ],
          [
            15.779295,
            52.479833,
            100.807884
          ],
          [
            15.779051,
            52.479972,
            101.689354
          ],
          [
            15.778875,
            52.480141,
            102.56314
          ],
          [
            15.778706,
            52.4803,
            102.952164
          ],
          [
            15.778505,
            52.480446,
            102.597868
          ],
          [
            15.778285,
            52.480608,
            102.20652
          ],
          [
            15.778028,
            52.480785,
            101.766797
          ],
          [
            15.777783,
            52.480973,
            101.319063
          ],
          [
            15.777553,
            52.481154,
            100.893219
          ],
          [
            15.777286,
            52.481278,
            100.511278
          ],
          [
            15.777167,
            52.481143,
            100.149311
          ],
          [
            15.777166,
            52.481353,
            99.758816
          ],
          [
            15.776983,
            52.481556,
            99.882531
          ],
          [
            15.77679,
            52.481731,
            100.001169
          ],
          [
            15.776632,
            52.481916,
            100.118508
          ],
          [
            15.776491,
            52.48213,
            100.2483
          ],
          [
            15.776351,
            52.482329,
            100.370573
          ],
          [
            15.77629,
            52.482527,
            100.484376
          ],
          [
            15.776166,
            52.482705,
            100.593282
          ],
          [
            15.776412,
            52.482837,
            100.710514
          ],
          [
            15.776695,
            52.482903,
            100.601967
          ],
          [
            15.776901,
            52.483045,
            100.239222
          ],
          [
            15.776941,
            52.48301,
            99.880351
          ],
          [
            15.77669,
            52.482897,
            99.517434
          ],
          [
            15.776277,
            52.482779,
            98.986133
          ],
          [
            15.775969,
            52.482793,
            98.572783
          ],
          [
            15.775809,
            52.482988,
            98.158709
          ],
          [
            15.775618,
            52.483181,
            97.732165
          ],
          [
            15.775514,
            52.483392,
            97.395318
          ],
          [
            15.775255,
            52.483506,
            97.68236
          ],
          [
            15.774913,
            52.483547,
            97.996174
          ],
          [
            15.775422,
            52.483745,
            98.524681
          ],
          [
            15.775128,
            52.483724,
            99.020939
          ],
          [
            15.774786,
            52.483541,
            99.41022
          ],
          [
            15.774819,
            52.483513,
            99.664159
          ],
          [
            15.775081,
            52.483468,
            99.771041
          ],
          [
            15.775287,
            52.483596,
            99.137726
          ],
          [
            15.775346,
            52.483568,
            98.338737
          ],
          [
            15.775411,
            52.483364,
            97.667513
          ],
          [
            15.775564,
            52.483153,
            96.922365
          ],
          [
            15.775702,
            52.482938,
            96.17669
          ],
          [
            15.775684,
            52.482742,
            95.539819
          ],
          [
            15.775604,
            52.482538,
            94.862716
          ],
          [
            15.775516,
            52.48232,
            94.138798
          ],
          [
            15.775483,
            52.482105,
            93.783546
          ],
          [
            15.775496,
            52.481883,
            93.450685
          ],
          [
            15.775557,
            52.481651,
            93.098687
          ],
          [
            15.775645,
            52.481442,
            92.7718
          ],
          [
            15.775767,
            52.481221,
            92.422527
          ],
          [
            15.775854,
            52.481006,
            92.087847
          ],
          [
            15.775832,
            52.480821,
            91.8099
          ],
          [
            15.775723,
            52.480618,
            91.4899
          ],
          [
            15.775469,
            52.480416,
            91.812989
          ],
          [
            15.775185,
            52.480248,
            92.364285
          ],
          [
            15.774938,
            52.48011,
            92.830542
          ],
          [
            15.774662,
            52.47996,
            93.34509
          ],
          [
            15.774436,
            52.479782,
            93.865206
          ],
          [
            15.774491,
            52.479579,
            94.337395
          ],
          [
            15.77458,
            52.47938,
            94.80917
          ],
          [
            15.774601,
            52.479165,
            95.301287
          ],
          [
            15.774609,
            52.47895,
            95.519845
          ],
          [
            15.774594,
            52.478726,
            95.562501
          ],
          [
            15.774555,
            52.478495,
            95.606497
          ],
          [
            15.774554,
            52.478245,
            95.653878
          ],
          [
            15.774584,
            52.478008,
            95.698921
          ],
          [
            15.774635,
            52.477808,
            95.739145
          ],
          [
            15.774695,
            52.477614,
            95.776554
          ],
          [
            15.774811,
            52.477411,
            95.8173
          ],
          [
            15.774925,
            52.477224,
            95.937147
          ],
          [
            15.775008,
            52.477015,
            96.152914
          ],
          [
            15.774802,
            52.476841,
            96.379617
          ],
          [
            15.774495,
            52.476745,
            96.58984
          ],
          [
            15.774228,
            52.476629,
            96.789845
          ],
          [
            15.773928,
            52.476715,
            96.993001
          ],
          [
            15.773626,
            52.476754,
            97.181034
          ],
          [
            15.773274,
            52.476837,
            97.411068
          ],
          [
            15.772961,
            52.476909,
            97.614853
          ],
          [
            15.772626,
            52.47694,
            98.004724
          ],
          [
            15.772287,
            52.477005,
            98.4341
          ],
          [
            15.771922,
            52.477064,
            98.890151
          ],
          [
            15.771554,
            52.477134,
            99.356555
          ],
          [
            15.7712,
            52.477194,
            99.802365
          ],
          [
            15.770839,
            52.477259,
            100.256994
          ],
          [
            15.770502,
            52.477315,
            100.679419
          ],
          [
            15.770168,
            52.477366,
            101.095656
          ],
          [
            15.769827,
            52.477449,
            101.232528
          ],
          [
            15.769523,
            52.477537,
            101.270545
          ],
          [
            15.769194,
            52.477591,
            101.308762
          ],
          [
            15.76886,
            52.477636,
            101.347128
          ],
          [
            15.76852,
            52.477694,
            101.386732
          ],
          [
            15.768194,
            52.477767,
            101.425742
          ],
          [
            15.767854,
            52.477831,
            101.465664
          ],
          [
            15.767563,
            52.477878,
            101.499441
          ],
          [
            15.767267,
            52.477901,
            101.522206
          ],
          [
            15.766947,
            52.477896,
            101.162433
          ],
          [
            15.766586,
            52.477885,
            100.755735
          ],
          [
            15.766178,
            52.477882,
            100.29726
          ],
          [
            15.765764,
            52.477883,
            99.832072
          ],
          [
            15.765383,
            52.477904,
            99.401964
          ],
          [
            15.765007,
            52.477939,
            98.974334
          ],
          [
            15.764627,
            52.47798,
            98.540181
          ],
          [
            15.764234,
            52.478029,
            98.160894
          ],
          [
            15.763857,
            52.478111,
            97.969053
          ],
          [
            15.76352,
            52.47822,
            97.786292
          ],
          [
            15.763199,
            52.478328,
            97.61075
          ],
          [
            15.762882,
            52.478445,
            97.433295
          ],
          [
            15.762571,
            52.478569,
            97.255247
          ],
          [
            15.762266,
            52.478675,
            97.087121
          ],
          [
            15.761943,
            52.478792,
            96.907183
          ],
          [
            15.761609,
            52.478894,
            96.859404
          ],
          [
            15.761263,
            52.478999,
            97.01067
          ],
          [
            15.760921,
            52.479125,
            97.16682
          ],
          [
            15.760594,
            52.47923,
            97.3115
          ],
          [
            15.760273,
            52.479333,
            97.453205
          ],
          [
            15.759968,
            52.479458,
            97.596801
          ],
          [
            15.759656,
            52.479584,
            97.743017
          ],
          [
            15.759328,
            52.479697,
            97.890196
          ],
          [
            15.758991,
            52.479795,
            98.065375
          ],
          [
            15.758672,
            52.4799,
            98.25741
          ],
          [
            15.758353,
            52.480013,
            98.452823
          ],
          [
            15.758048,
            52.48012,
            98.639222
          ],
          [
            15.757731,
            52.480231,
            98.832879
          ],
          [
            15.757431,
            52.480331,
            99.01399
          ],
          [
            15.757092,
            52.480454,
            99.222935
          ],
          [
            15.756778,
            52.480569,
            99.416947
          ],
          [
            15.756443,
            52.480681,
            99.439395
          ],
          [
            15.756148,
            52.48078,
            99.30258
          ],
          [
            15.755864,
            52.480871,
            99.172218
          ],
          [
            15.7556,
            52.480973,
            99.045161
          ],
          [
            15.755306,
            52.481089,
            98.90275
          ],
          [
            15.754983,
            52.481202,
            98.751444
          ],
          [
            15.75465,
            52.481316,
            98.596233
          ],
          [
            15.754336,
            52.481428,
            98.448345
          ],
          [
            15.754034,
            52.481543,
            98.325387
          ],
          [
            15.753713,
            52.481651,
            98.402755
          ],
          [
            15.753389,
            52.481744,
            98.478414
          ],
          [
            15.753075,
            52.481843,
            98.553016
          ],
          [
            15.752789,
            52.481939,
            98.621911
          ],
          [
            15.752507,
            52.482051,
            98.692943
          ],
          [
            15.752207,
            52.482154,
            98.765611
          ],
          [
            15.751902,
            52.482259,
            98.839524
          ],
          [
            15.75159,
            52.482364,
            98.914799
          ],
          [
            15.751301,
            52.48246,
            99.033485
          ],
          [
            15.750994,
            52.482561,
            99.189827
          ],
          [
            15.75074,
            52.482697,
            99.342372
          ],
          [
            15.750524,
            52.482871,
            99.502614
          ],
          [
            15.750327,
            52.483045,
            99.657879
          ],
          [
            15.75009,
            52.483231,
            99.830869
          ],
          [
            15.749868,
            52.483423,
            100.003689
          ],
          [
            15.749656,
            52.483606,
            100.168212
          ],
          [
            15.749464,
            52.48377,
            100.200044
          ],
          [
            15.749309,
            52.483929,
            100.042937
          ],
          [
            15.749113,
            52.484098,
            99.867034
          ],
          [
            15.748895,
            52.484291,
            99.667827
          ],
          [
            15.748684,
            52.484477,
            99.47573
          ],
          [
            15.748491,
            52.484645,
            99.301559
          ],
          [
            15.748285,
            52.484813,
            99.123202
          ],
          [
            15.748122,
            52.484989,
            98.951541
          ],
          [
            15.747941,
            52.485172,
            98.76997
          ],
          [
            15.747755,
            52.485343,
            98.842831
          ],
          [
            15.747566,
            52.485501,
            98.972489
          ],
          [
            15.747347,
            52.485678,
            99.119539
          ],
          [
            15.747132,
            52.485869,
            99.273114
          ],
          [
            15.74694,
            52.486057,
            99.419939
          ],
          [
            15.746764,
            52.48624,
            99.560676
          ],
          [
            15.746559,
            52.486441,
            99.717599
          ],
          [
            15.746382,
            52.486611,
            99.85122
          ],
          [
            15.746198,
            52.486777,
            99.930972
          ],
          [
            15.746028,
            52.486955,
            99.939789
          ],
          [
            15.745848,
            52.487108,
            99.947865
          ],
          [
            15.745652,
            52.487267,
            99.956383
          ],
          [
            15.745464,
            52.487442,
            99.965331
          ],
          [
            15.745309,
            52.487615,
            99.973767
          ],
          [
            15.74513,
            52.487782,
            99.982304
          ],
          [
            15.744949,
            52.487955,
            99.991083
          ],
          [
            15.744776,
            52.488124,
            99.999605
          ],
          [
            15.74458,
            52.48831,
            100.046448
          ],
          [
            15.744412,
            52.488474,
            100.119064
          ],
          [
            15.744389,
            52.488671,
            100.193627
          ],
          [
            15.744415,
            52.488893,
            100.277204
          ],
          [
            15.744424,
            52.489117,
            100.361343
          ],
          [
            15.744469,
            52.489311,
            100.434909
          ],
          [
            15.744485,
            52.489513,
            100.510857
          ],
          [
            15.744522,
            52.489728,
            100.592031
          ],
          [
            15.744549,
            52.489939,
            100.671528
          ],
          [
            15.744589,
            52.490137,
            100.144669
          ],
          [
            15.744633,
            52.490349,
            99.502914
          ],
          [
            15.744662,
            52.490551,
            98.893588
          ],
          [
            15.744687,
            52.49076,
            98.264467
          ],
          [
            15.744732,
            52.490958,
            97.664081
          ],
          [
            15.744758,
            52.491183,
            96.986985
          ],
          [
            15.744782,
            52.491378,
            96.400083
          ],
          [
            15.744806,
            52.491572,
            95.81569
          ],
          [
            15.744834,
            52.491786,
            95.378664
          ],
          [
            15.744875,
            52.491973,
            95.875402
          ],
          [
            15.744901,
            52.492176,
            96.41387
          ],
          [
            15.744924,
            52.492381,
            96.954841
          ],
          [
            15.744961,
            52.492581,
            97.485296
          ],
          [
            15.744974,
            52.492775,
            97.998112
          ],
          [
            15.74501,
            52.492964,
            98.499815
          ],
          [
            15.745086,
            52.493157,
            99.031447
          ],
          [
            15.745075,
            52.493346,
            99.534511
          ],
          [
            15.745141,
            52.493529,
            100.016559
          ],
          [
            15.745186,
            52.493711,
            100.016559
          ],
          [
            15.7453,
            52.493901,
            100.016559
          ],
          [
            15.745409,
            52.494076,
            100.016559
          ],
          [
            15.745623,
            52.494212,
            100.016559
          ],
          [
            15.745628,
            52.4944,
            100.016559
          ],
          [
            15.745631,
            52.494584,
            100.016559
          ],
          [
            15.745459,
            52.494745,
            100.016559
          ],
          [
            15.745361,
            52.494919,
            100.016559
          ]
        ]
      }
    }
  ]
}

let day44: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            15.7451,
            52.493035,
            93.820802
          ],
          [
            15.74501,
            52.492842,
            93.820802
          ],
          [
            15.744973,
            52.492608,
            93.820802
          ],
          [
            15.744939,
            52.492389,
            93.820802
          ],
          [
            15.744908,
            52.492169,
            93.820802
          ],
          [
            15.744849,
            52.491941,
            94.272334
          ],
          [
            15.744782,
            52.491706,
            94.770954
          ],
          [
            15.744739,
            52.491477,
            95.253042
          ],
          [
            15.744729,
            52.491241,
            95.746612
          ],
          [
            15.744724,
            52.491006,
            96.238106
          ],
          [
            15.744705,
            52.490784,
            96.702823
          ],
          [
            15.744697,
            52.490579,
            97.131795
          ],
          [
            15.744658,
            52.490365,
            97.580001
          ],
          [
            15.744599,
            52.490174,
            97.4477
          ],
          [
            15.744541,
            52.489961,
            97.300925
          ],
          [
            15.744521,
            52.489772,
            97.172168
          ],
          [
            15.744521,
            52.489572,
            97.03612
          ],
          [
            15.744494,
            52.489382,
            96.906465
          ],
          [
            15.744435,
            52.489181,
            96.767593
          ],
          [
            15.744398,
            52.488977,
            96.628007
          ],
          [
            15.74435,
            52.488748,
            96.471073
          ],
          [
            15.744348,
            52.488527,
            96.292157
          ],
          [
            15.744505,
            52.488316,
            96.019056
          ],
          [
            15.744696,
            52.48813,
            95.760819
          ],
          [
            15.744885,
            52.487928,
            95.487095
          ],
          [
            15.745069,
            52.487746,
            95.235539
          ],
          [
            15.745266,
            52.48756,
            94.974936
          ],
          [
            15.745477,
            52.487381,
            94.715553
          ],
          [
            15.745699,
            52.487181,
            94.43078
          ],
          [
            15.745891,
            52.48698,
            94.247928
          ],
          [
            15.746097,
            52.486785,
            94.269354
          ],
          [
            15.746329,
            52.486596,
            94.29114
          ],
          [
            15.74654,
            52.48639,
            94.313557
          ],
          [
            15.746772,
            52.486188,
            94.336319
          ],
          [
            15.746973,
            52.485985,
            94.358204
          ],
          [
            15.747187,
            52.485795,
            94.379476
          ],
          [
            15.747399,
            52.485583,
            94.402427
          ],
          [
            15.747639,
            52.485385,
            94.453966
          ],
          [
            15.747891,
            52.485175,
            94.516863
          ],
          [
            15.74812,
            52.48496,
            94.578833
          ],
          [
            15.748333,
            52.484775,
            94.633476
          ],
          [
            15.748532,
            52.484587,
            94.687751
          ],
          [
            15.748709,
            52.484436,
            94.732624
          ],
          [
            15.74894,
            52.484234,
            94.79215
          ],
          [
            15.749164,
            52.484053,
            94.905738
          ],
          [
            15.74936,
            52.483869,
            95.634676
          ],
          [
            15.749537,
            52.483697,
            96.306991
          ],
          [
            15.749687,
            52.483532,
            96.949141
          ],
          [
            15.749546,
            52.483706,
            97.607738
          ],
          [
            15.749438,
            52.483878,
            98.232733
          ],
          [
            15.749743,
            52.483986,
            98.962449
          ],
          [
            15.750042,
            52.484055,
            99.607211
          ],
          [
            15.75034,
            52.484082,
            100.216998
          ],
          [
            15.750675,
            52.484127,
            100.77854
          ],
          [
            15.750969,
            52.484186,
            100.688843
          ],
          [
            15.751264,
            52.484263,
            100.596505
          ],
          [
            15.751558,
            52.484347,
            100.503064
          ],
          [
            15.751879,
            52.484425,
            100.403657
          ],
          [
            15.752187,
            52.484482,
            100.311023
          ],
          [
            15.752474,
            52.4846,
            100.2112
          ],
          [
            15.752842,
            52.484653,
            100.102419
          ],
          [
            15.753215,
            52.484719,
            99.990498
          ],
          [
            15.753612,
            52.484779,
            99.662599
          ],
          [
            15.754006,
            52.484822,
            99.215565
          ],
          [
            15.754341,
            52.484875,
            98.829031
          ],
          [
            15.754704,
            52.484945,
            98.403619
          ],
          [
            15.755086,
            52.485024,
            97.951128
          ],
          [
            15.755415,
            52.485086,
            97.566473
          ],
          [
            15.755755,
            52.485158,
            97.164475
          ],
          [
            15.75608,
            52.485225,
            96.78107
          ],
          [
            15.756382,
            52.485281,
            96.634142
          ],
          [
            15.756692,
            52.485333,
            96.612649
          ],
          [
            15.756985,
            52.485441,
            96.589649
          ],
          [
            15.757206,
            52.485583,
            96.568186
          ],
          [
            15.757407,
            52.485744,
            96.545951
          ],
          [
            15.757615,
            52.485872,
            96.526088
          ],
          [
            15.757905,
            52.485983,
            96.503208
          ],
          [
            15.758264,
            52.486079,
            96.477036
          ],
          [
            15.758674,
            52.486147,
            96.449414
          ],
          [
            15.75906,
            52.4862,
            96.436033
          ],
          [
            15.759385,
            52.48625,
            96.424696
          ],
          [
            15.759734,
            52.486304,
            96.412494
          ],
          [
            15.760082,
            52.486339,
            96.40056
          ],
          [
            15.760393,
            52.48637,
            96.389901
          ],
          [
            15.760701,
            52.4864,
            96.379353
          ],
          [
            15.760995,
            52.486431,
            96.36926
          ],
          [
            15.761395,
            52.486463,
            96.355616
          ],
          [
            15.761769,
            52.486482,
            96.765558
          ],
          [
            15.762128,
            52.486505,
            97.445548
          ],
          [
            15.762491,
            52.486565,
            98.154142
          ],
          [
            15.762828,
            52.486635,
            98.82478
          ],
          [
            15.763111,
            52.486718,
            99.416359
          ],
          [
            15.763393,
            52.486822,
            100.037276
          ],
          [
            15.763676,
            52.486882,
            100.603773
          ],
          [
            15.763964,
            52.487007,
            101.269658
          ],
          [
            15.764241,
            52.487111,
            101.882765
          ],
          [
            15.764532,
            52.487214,
            101.050404
          ],
          [
            15.764812,
            52.487346,
            100.101487
          ],
          [
            15.765099,
            52.487448,
            99.199545
          ],
          [
            15.765479,
            52.487549,
            98.090682
          ],
          [
            15.76587,
            52.487665,
            96.92623
          ],
          [
            15.76623,
            52.487775,
            95.849023
          ],
          [
            15.766581,
            52.487909,
            94.740736
          ],
          [
            15.766856,
            52.488048,
            94.012162
          ],
          [
            15.767145,
            52.488221,
            94.007496
          ],
          [
            15.767437,
            52.4884,
            94.002726
          ],
          [
            15.767656,
            52.488571,
            93.998626
          ],
          [
            15.767916,
            52.488749,
            93.994108
          ],
          [
            15.768143,
            52.488921,
            93.989933
          ],
          [
            15.768364,
            52.489063,
            93.986216
          ],
          [
            15.768612,
            52.489217,
            93.982138
          ],
          [
            15.768851,
            52.489386,
            94.030575
          ],
          [
            15.769091,
            52.489549,
            94.204896
          ],
          [
            15.769327,
            52.489698,
            94.369719
          ],
          [
            15.769394,
            52.48988,
            94.518246
          ],
          [
            15.769704,
            52.489846,
            94.672215
          ],
          [
            15.769913,
            52.489695,
            94.829547
          ],
          [
            15.770114,
            52.489527,
            94.996407
          ],
          [
            15.770388,
            52.489368,
            95.181075
          ],
          [
            15.770391,
            52.48954,
            95.343239
          ],
          [
            15.770323,
            52.489739,
            95.512132
          ],
          [
            15.770435,
            52.489928,
            95.680054
          ],
          [
            15.770611,
            52.490097,
            95.846953
          ],
          [
            15.770756,
            52.490274,
            96.011862
          ],
          [
            15.770934,
            52.490447,
            96.182125
          ],
          [
            15.771103,
            52.49061,
            96.34294
          ],
          [
            15.771246,
            52.49079,
            96.509721
          ],
          [
            15.771409,
            52.490997,
            96.701608
          ],
          [
            15.771577,
            52.49116,
            96.862048
          ],
          [
            15.771736,
            52.491345,
            97.123288
          ],
          [
            15.771909,
            52.491528,
            97.421803
          ],
          [
            15.772074,
            52.491708,
            97.71339
          ],
          [
            15.772239,
            52.491896,
            98.014589
          ],
          [
            15.772395,
            52.492083,
            98.311193
          ],
          [
            15.772594,
            52.492275,
            98.631974
          ],
          [
            15.772763,
            52.49246,
            98.932039
          ],
          [
            15.772938,
            52.492617,
            99.203868
          ],
          [
            15.773083,
            52.492809,
            99.469474
          ],
          [
            15.773331,
            52.492796,
            99.562919
          ],
          [
            15.773471,
            52.492612,
            99.660379
          ],
          [
            15.77359,
            52.49237,
            99.781659
          ],
          [
            15.773689,
            52.49213,
            99.900427
          ],
          [
            15.773977,
            52.49201,
            100.013046
          ],
          [
            15.774329,
            52.49208,
            100.121425
          ],
          [
            15.774685,
            52.492128,
            100.228027
          ],
          [
            15.775065,
            52.492173,
            100.253565
          ],
          [
            15.775464,
            52.492248,
            99.963002
          ],
          [
            15.775839,
            52.492292,
            99.697424
          ],
          [
            15.776191,
            52.492334,
            99.447854
          ],
          [
            15.776537,
            52.492351,
            99.206159
          ],
          [
            15.776932,
            52.492387,
            98.928416
          ],
          [
            15.777311,
            52.492433,
            98.659626
          ],
          [
            15.777672,
            52.492499,
            98.39749
          ],
          [
            15.778017,
            52.492557,
            98.210835
          ],
          [
            15.778358,
            52.492594,
            98.103359
          ],
          [
            15.778708,
            52.492637,
            97.992591
          ],
          [
            15.779064,
            52.492696,
            97.878088
          ],
          [
            15.77942,
            52.492751,
            97.764131
          ],
          [
            15.779734,
            52.492757,
            97.666231
          ],
          [
            15.780051,
            52.492838,
            97.55448
          ],
          [
            15.780269,
            52.492982,
            97.454477
          ],
          [
            15.780524,
            52.493121,
            97.348249
          ],
          [
            15.780771,
            52.493266,
            98.302596
          ],
          [
            15.781029,
            52.493408,
            99.306549
          ],
          [
            15.781245,
            52.493559,
            100.25839
          ],
          [
            15.781324,
            52.493763,
            101.253439
          ],
          [
            15.781509,
            52.49395,
            102.287902
          ],
          [
            15.781694,
            52.494153,
            103.387902
          ],
          [
            15.781845,
            52.494349,
            104.413861
          ],
          [
            15.781992,
            52.494539,
            105.410176
          ],
          [
            15.782109,
            52.494712,
            105.801963
          ],
          [
            15.782262,
            52.494913,
            105.645089
          ],
          [
            15.782421,
            52.49511,
            105.489692
          ],
          [
            15.782555,
            52.495289,
            105.350305
          ],
          [
            15.78268,
            52.49546,
            105.217831
          ],
          [
            15.782851,
            52.495646,
            105.066924
          ],
          [
            15.783037,
            52.495853,
            104.899673
          ],
          [
            15.783198,
            52.496015,
            104.765605
          ],
          [
            15.783457,
            52.496157,
            104.613029
          ],
          [
            15.783567,
            52.496339,
            104.551749
          ],
          [
            15.783683,
            52.49652,
            104.502926
          ],
          [
            15.78377,
            52.496715,
            104.452352
          ],
          [
            15.783861,
            52.496903,
            104.403271
          ],
          [
            15.783961,
            52.497088,
            104.354423
          ],
          [
            15.784041,
            52.497281,
            104.304595
          ],
          [
            15.784122,
            52.497483,
            104.252558
          ],
          [
            15.784216,
            52.49767,
            104.203631
          ],
          [
            15.784321,
            52.497878,
            104.149192
          ],
          [
            15.784413,
            52.498062,
            103.946393
          ],
          [
            15.784476,
            52.498243,
            103.730656
          ],
          [
            15.784511,
            52.498433,
            103.507693
          ],
          [
            15.784535,
            52.498629,
            103.278402
          ],
          [
            15.784566,
            52.498826,
            103.047642
          ],
          [
            15.784593,
            52.499011,
            102.83106
          ],
          [
            15.78463,
            52.499211,
            102.59631
          ],
          [
            15.784669,
            52.499426,
            102.344086
          ],
          [
            15.784717,
            52.499652,
            102.078314
          ],
          [
            15.784746,
            52.499858,
            101.95165
          ],
          [
            15.78477,
            52.500052,
            101.849054
          ],
          [
            15.784794,
            52.500241,
            101.749089
          ],
          [
            15.784844,
            52.500469,
            101.627798
          ],
          [
            15.784872,
            52.500655,
            101.529344
          ],
          [
            15.7849,
            52.500868,
            101.416706
          ],
          [
            15.784933,
            52.501068,
            101.310663
          ],
          [
            15.78497,
            52.501276,
            101.200373
          ],
          [
            15.78501,
            52.501485,
            101.078262
          ],
          [
            15.785054,
            52.501692,
            100.825738
          ],
          [
            15.785247,
            52.501851,
            100.57106
          ],
          [
            15.785546,
            52.501885,
            100.347043
          ],
          [
            15.785887,
            52.501882,
            100.095808
          ],
          [
            15.786251,
            52.50189,
            99.827558
          ],
          [
            15.786616,
            52.501901,
            99.558358
          ],
          [
            15.786971,
            52.501916,
            99.296261
          ],
          [
            15.787338,
            52.501938,
            99.024662
          ],
          [
            15.787705,
            52.501953,
            98.70178
          ],
          [
            15.788042,
            52.50198,
            98.374196
          ],
          [
            15.788392,
            52.502045,
            98.021436
          ],
          [
            15.788701,
            52.502133,
            97.692447
          ],
          [
            15.789025,
            52.50222,
            97.350667
          ],
          [
            15.789341,
            52.502305,
            97.017623
          ],
          [
            15.789661,
            52.502407,
            96.669234
          ],
          [
            15.790013,
            52.502504,
            96.296736
          ],
          [
            15.790359,
            52.502584,
            95.93212
          ],
          [
            15.79069,
            52.502667,
            95.567609
          ],
          [
            15.791031,
            52.50276,
            95.187266
          ],
          [
            15.791379,
            52.502844,
            94.80615
          ],
          [
            15.791735,
            52.502938,
            94.411164
          ],
          [
            15.792088,
            52.503029,
            94.020955
          ],
          [
            15.792399,
            52.503096,
            93.68504
          ],
          [
            15.792705,
            52.503179,
            93.34405
          ],
          [
            15.792996,
            52.503241,
            93.12538
          ],
          [
            15.793317,
            52.503324,
            93.695712
          ],
          [
            15.793619,
            52.503401,
            94.231529
          ],
          [
            15.793953,
            52.503481,
            94.817999
          ],
          [
            15.794288,
            52.503561,
            95.406089
          ],
          [
            15.794607,
            52.503638,
            95.966902
          ],
          [
            15.79496,
            52.503714,
            96.578741
          ],
          [
            15.795297,
            52.503766,
            97.147227
          ],
          [
            15.795628,
            52.503829,
            97.714211
          ],
          [
            15.795956,
            52.503865,
            98.047179
          ],
          [
            15.796269,
            52.50389,
            98.263099
          ],
          [
            15.796618,
            52.50387,
            98.502799
          ],
          [
            15.796968,
            52.503847,
            98.743253
          ],
          [
            15.797278,
            52.503838,
            98.955356
          ],
          [
            15.797598,
            52.503821,
            99.174773
          ],
          [
            15.797934,
            52.50379,
            99.406879
          ],
          [
            15.798254,
            52.503774,
            99.626172
          ],
          [
            15.798566,
            52.50375,
            99.840965
          ],
          [
            15.7989,
            52.503729,
            99.507838
          ],
          [
            15.79923,
            52.503714,
            98.926066
          ],
          [
            15.799555,
            52.503691,
            98.350111
          ],
          [
            15.799863,
            52.503672,
            97.805913
          ],
          [
            15.800198,
            52.503634,
            97.206897
          ],
          [
            15.800556,
            52.503605,
            96.572042
          ],
          [
            15.800916,
            52.503581,
            95.935407
          ],
          [
            15.801282,
            52.503554,
            95.287121
          ],
          [
            15.801639,
            52.503531,
            94.728243
          ],
          [
            15.802001,
            52.503503,
            94.82397
          ],
          [
            15.802375,
            52.50348,
            94.922589
          ],
          [
            15.80272,
            52.503453,
            95.013841
          ],
          [
            15.803084,
            52.503432,
            95.109756
          ],
          [
            15.803429,
            52.503415,
            95.20058
          ],
          [
            15.803776,
            52.503435,
            95.292019
          ],
          [
            15.804142,
            52.503485,
            95.390422
          ],
          [
            15.804489,
            52.503551,
            95.485803
          ],
          [
            15.804861,
            52.503612,
            95.686871
          ],
          [
            15.805222,
            52.503678,
            95.892226
          ],
          [
            15.805579,
            52.503723,
            96.090845
          ],
          [
            15.805933,
            52.503751,
            96.285228
          ],
          [
            15.806266,
            52.503771,
            96.467461
          ],
          [
            15.806599,
            52.503795,
            96.650055
          ],
          [
            15.806923,
            52.503831,
            96.829384
          ],
          [
            15.807267,
            52.503888,
            97.023616
          ],
          [
            15.807573,
            52.503979,
            97.131029
          ],
          [
            15.807865,
            52.504068,
            97.178207
          ],
          [
            15.808163,
            52.504176,
            97.228315
          ],
          [
            15.808467,
            52.504272,
            97.27779
          ],
          [
            15.808769,
            52.50438,
            97.328393
          ],
          [
            15.80909,
            52.504482,
            97.380709
          ],
          [
            15.809408,
            52.504587,
            97.433004
          ],
          [
            15.809663,
            52.504721,
            97.481817
          ],
          [
            15.809865,
            52.504886,
            97.545993
          ],
          [
            15.810065,
            52.505061,
            98.303068
          ],
          [
            15.810237,
            52.505234,
            99.02087
          ],
          [
            15.810406,
            52.505402,
            99.720258
          ],
          [
            15.810547,
            52.505582,
            100.428161
          ],
          [
            15.810723,
            52.505761,
            101.168845
          ],
          [
            15.810889,
            52.505937,
            101.889263
          ],
          [
            15.811048,
            52.506108,
            102.587126
          ],
          [
            15.811177,
            52.506277,
            103.248921
          ],
          [
            15.811336,
            52.50644,
            103.917604
          ],
          [
            15.811493,
            52.506598,
            104.192514
          ],
          [
            15.811663,
            52.506765,
            104.485173
          ],
          [
            15.811857,
            52.506946,
            104.807318
          ],
          [
            15.812069,
            52.507124,
            105.134729
          ],
          [
            15.81229,
            52.507286,
            105.448236
          ],
          [
            15.812502,
            52.507448,
            105.756668
          ],
          [
            15.812737,
            52.507587,
            106.054007
          ],
          [
            15.812985,
            52.507731,
            106.364769
          ],
          [
            15.813227,
            52.507874,
            106.529208
          ],
          [
            15.813497,
            52.507995,
            106.284915
          ],
          [
            15.813765,
            52.508125,
            106.035473
          ],
          [
            15.814008,
            52.508252,
            105.80231
          ],
          [
            15.814243,
            52.508383,
            105.570343
          ],
          [
            15.814532,
            52.508502,
            105.316074
          ],
          [
            15.814796,
            52.50863,
            105.069641
          ],
          [
            15.815064,
            52.508759,
            104.820952
          ],
          [
            15.815331,
            52.508901,
            104.563042
          ],
          [
            15.815578,
            52.50903,
            104.740377
          ],
          [
            15.815809,
            52.509171,
            105.348971
          ],
          [
            15.816018,
            52.509341,
            105.997748
          ],
          [
            15.816234,
            52.509507,
            106.645588
          ],
          [
            15.816466,
            52.509678,
            107.324169
          ],
          [
            15.816656,
            52.509867,
            108.000823
          ],
          [
            15.816798,
            52.510049,
            108.616107
          ],
          [
            15.816962,
            52.510216,
            109.210698
          ],
          [
            15.817136,
            52.510378,
            109.801719
          ],
          [
            15.817375,
            52.510536,
            109.861634
          ],
          [
            15.817625,
            52.510676,
            109.772579
          ],
          [
            15.817929,
            52.510797,
            109.677433
          ],
          [
            15.81819,
            52.510918,
            109.591543
          ],
          [
            15.818499,
            52.511028,
            109.497841
          ],
          [
            15.818768,
            52.511147,
            109.410802
          ],
          [
            15.819078,
            52.51128,
            109.311415
          ],
          [
            15.819396,
            52.511421,
            109.2084
          ],
          [
            15.819721,
            52.511551,
            109.336668
          ],
          [
            15.820015,
            52.511673,
            109.631471
          ],
          [
            15.820315,
            52.511804,
            109.937779
          ],
          [
            15.820624,
            52.511941,
            110.254535
          ],
          [
            15.820927,
            52.51207,
            110.56116
          ],
          [
            15.821247,
            52.512171,
            110.859845
          ],
          [
            15.821555,
            52.512274,
            111.151189
          ],
          [
            15.82185,
            52.512388,
            111.440825
          ],
          [
            15.822121,
            52.512536,
            111.872732
          ],
          [
            15.822422,
            52.512662,
            112.472734
          ],
          [
            15.822706,
            52.512798,
            113.065019
          ],
          [
            15.822998,
            52.512901,
            113.618249
          ],
          [
            15.823285,
            52.513004,
            114.164446
          ],
          [
            15.823564,
            52.513099,
            114.689647
          ],
          [
            15.823805,
            52.513212,
            115.189415
          ],
          [
            15.824097,
            52.513348,
            115.792049
          ],
          [
            15.824349,
            52.513477,
            116.336873
          ],
          [
            15.824606,
            52.513604,
            116.242426
          ],
          [
            15.824849,
            52.513719,
            115.992687
          ],
          [
            15.825123,
            52.513831,
            115.725299
          ],
          [
            15.825435,
            52.513927,
            115.442216
          ],
          [
            15.825701,
            52.514006,
            115.202034
          ],
          [
            15.82599,
            52.514126,
            114.918301
          ],
          [
            15.826266,
            52.514218,
            114.663079
          ],
          [
            15.826563,
            52.514326,
            114.382602
          ],
          [
            15.826852,
            52.514436,
            114.10628
          ],
          [
            15.82713,
            52.514544,
            114.072563
          ],
          [
            15.827394,
            52.514672,
            114.08677
          ],
          [
            15.827704,
            52.514791,
            114.102162
          ],
          [
            15.827973,
            52.514922,
            114.116671
          ],
          [
            15.828293,
            52.515067,
            114.133432
          ],
          [
            15.828624,
            52.515203,
            114.150213
          ],
          [
            15.828926,
            52.515321,
            114.165293
          ],
          [
            15.829201,
            52.515422,
            114.178812
          ],
          [
            15.829487,
            52.515524,
            114.282033
          ],
          [
            15.829726,
            52.51564,
            114.444769
          ],
          [
            15.830006,
            52.515735,
            114.617343
          ],
          [
            15.830287,
            52.515841,
            114.793792
          ],
          [
            15.830555,
            52.515954,
            114.9675
          ],
          [
            15.830871,
            52.516073,
            115.165886
          ],
          [
            15.831157,
            52.51619,
            115.349402
          ],
          [
            15.831431,
            52.516306,
            115.527102
          ],
          [
            15.831719,
            52.516414,
            115.707358
          ],
          [
            15.832038,
            52.516551,
            116.065777
          ],
          [
            15.832302,
            52.516667,
            116.405529
          ],
          [
            15.832597,
            52.516785,
            116.773943
          ],
          [
            15.8329,
            52.516912,
            117.157835
          ],
          [
            15.833219,
            52.517034,
            117.551183
          ],
          [
            15.833512,
            52.517147,
            117.913141
          ],
          [
            15.83381,
            52.51726,
            118.279466
          ],
          [
            15.834104,
            52.517383,
            118.652112
          ],
          [
            15.834373,
            52.517496,
            119.035463
          ],
          [
            15.834643,
            52.517596,
            119.457504
          ],
          [
            15.834952,
            52.517726,
            119.958808
          ],
          [
            15.835232,
            52.517822,
            120.388699
          ],
          [
            15.835537,
            52.517913,
            120.84312
          ],
          [
            15.835804,
            52.518032,
            121.285197
          ],
          [
            15.836086,
            52.518154,
            121.747529
          ],
          [
            15.836371,
            52.518277,
            122.213837
          ],
          [
            15.836652,
            52.518395,
            122.66939
          ],
          [
            15.836942,
            52.518514,
            122.477602
          ],
          [
            15.837269,
            52.518637,
            122.025595
          ],
          [
            15.837579,
            52.518764,
            121.586972
          ],
          [
            15.837884,
            52.518901,
            121.141649
          ],
          [
            15.838175,
            52.519018,
            120.732178
          ],
          [
            15.838475,
            52.519124,
            120.324562
          ],
          [
            15.838803,
            52.519268,
            119.848131
          ],
          [
            15.839114,
            52.519395,
            119.407346
          ],
          [
            15.83945,
            52.519535,
            120.015193
          ],
          [
            15.839792,
            52.519673,
            120.882661
          ],
          [
            15.840127,
            52.519818,
            121.7515
          ],
          [
            15.840456,
            52.519954,
            122.592079
          ],
          [
            15.840755,
            52.520073,
            123.347426
          ],
          [
            15.841024,
            52.520169,
            124.006555
          ],
          [
            15.841322,
            52.520279,
            124.74345
          ],
          [
            15.841596,
            52.520406,
            125.471382
          ],
          [
            15.841916,
            52.520546,
            124.964447
          ],
          [
            15.842216,
            52.520652,
            124.37153
          ],
          [
            15.842485,
            52.520782,
            123.784274
          ],
          [
            15.842768,
            52.520887,
            123.21693
          ],
          [
            15.843053,
            52.520978,
            122.666231
          ],
          [
            15.843327,
            52.521095,
            122.092704
          ],
          [
            15.843573,
            52.521225,
            121.534816
          ],
          [
            15.843877,
            52.521317,
            120.954493
          ],
          [
            15.844169,
            52.521401,
            120.590037
          ],
          [
            15.844514,
            52.521503,
            121.028943
          ],
          [
            15.844818,
            52.521615,
            121.435478
          ],
          [
            15.845136,
            52.521752,
            121.882071
          ],
          [
            15.845447,
            52.521884,
            122.316296
          ],
          [
            15.845757,
            52.522018,
            122.751299
          ],
          [
            15.84598,
            52.522138,
            123.092185
          ],
          [
            15.846139,
            52.522331,
            123.498324
          ],
          [
            15.846399,
            52.522453,
            123.87443
          ],
          [
            15.846683,
            52.522529,
            124.775891
          ],
          [
            15.847013,
            52.522592,
            125.796216
          ],
          [
            15.847312,
            52.522653,
            126.725137
          ],
          [
            15.847616,
            52.522694,
            127.642301
          ],
          [
            15.847921,
            52.522757,
            128.590973
          ],
          [
            15.84822,
            52.522792,
            129.515935
          ],
          [
            15.848629,
            52.522894,
            130.821178
          ],
          [
            15.848967,
            52.522988,
            131.921271
          ],
          [
            15.849367,
            52.523032,
            132.738079
          ],
          [
            15.849748,
            52.523129,
            133.065966
          ],
          [
            15.850066,
            52.523215,
            133.340297
          ],
          [
            15.850328,
            52.523303,
            133.57618
          ],
          [
            15.850592,
            52.523411,
            133.828113
          ],
          [
            15.850904,
            52.523511,
            134.106066
          ],
          [
            15.851261,
            52.523641,
            134.433991
          ],
          [
            15.851608,
            52.523678,
            134.712523
          ],
          [
            15.85193,
            52.523725,
            134.855457
          ],
          [
            15.8523,
            52.523725,
            134.400231
          ],
          [
            15.852661,
            52.523742,
            133.954401
          ],
          [
            15.853022,
            52.523761,
            133.50849
          ],
          [
            15.853392,
            52.523768,
            133.053082
          ],
          [
            15.85372,
            52.523752,
            132.648297
          ],
          [
            15.854049,
            52.523791,
            132.235053
          ],
          [
            15.854399,
            52.523831,
            131.795916
          ],
          [
            15.854707,
            52.523858,
            131.412315
          ],
          [
            15.855088,
            52.523882,
            131.59442
          ],
          [
            15.855446,
            52.523915,
            131.97768
          ],
          [
            15.855861,
            52.523966,
            132.425207
          ],
          [
            15.856243,
            52.524026,
            132.842153
          ],
          [
            15.856577,
            52.524062,
            133.201096
          ],
          [
            15.85695,
            52.524117,
            133.60668
          ],
          [
            15.857323,
            52.524167,
            134.010428
          ],
          [
            15.857697,
            52.524193,
            134.408339
          ],
          [
            15.858077,
            52.524248,
            133.813608
          ],
          [
            15.85852,
            52.524326,
            133.086836
          ],
          [
            15.858834,
            52.524392,
            132.552289
          ],
          [
            15.859188,
            52.524468,
            131.931103
          ],
          [
            15.859576,
            52.524603,
            131.227172
          ],
          [
            15.85994,
            52.524682,
            130.618189
          ],
          [
            15.860259,
            52.524731,
            130.099962
          ],
          [
            15.86068,
            52.524772,
            129.367066
          ],
          [
            15.860983,
            52.524816,
            128.785142
          ],
          [
            15.861298,
            52.524896,
            128.137437
          ],
          [
            15.861595,
            52.524973,
            127.534518
          ],
          [
            15.861931,
            52.525089,
            126.801242
          ],
          [
            15.862226,
            52.525183,
            126.179476
          ],
          [
            15.862581,
            52.525281,
            125.44846
          ],
          [
            15.862865,
            52.525368,
            124.854922
          ],
          [
            15.863195,
            52.525464,
            124.183829
          ],
          [
            15.86354,
            52.525549,
            123.614822
          ],
          [
            15.863565,
            52.525528,
            123.140741
          ],
          [
            15.863693,
            52.525523,
            122.681749
          ],
          [
            15.863419,
            52.525639,
            122.171928
          ],
          [
            15.863255,
            52.525791,
            121.707158
          ],
          [
            15.8631,
            52.52595,
            121.227078
          ],
          [
            15.862876,
            52.526103,
            120.712172
          ],
          [
            15.862657,
            52.526264,
            120.188074
          ],
          [
            15.862485,
            52.526431,
            119.751964
          ],
          [
            15.862293,
            52.526602,
            119.927392
          ],
          [
            15.862133,
            52.526769,
            120.088998
          ],
          [
            15.862129,
            52.526891,
            120.200599
          ],
          [
            15.86216,
            52.526712,
            120.356517
          ],
          [
            15.862311,
            52.526545,
            120.514664
          ],
          [
            15.862483,
            52.526379,
            120.677992
          ],
          [
            15.86268,
            52.526227,
            120.840589
          ],
          [
            15.862837,
            52.526067,
            121.007289
          ],
          [
            15.863045,
            52.52593,
            121.16168
          ],
          [
            15.863244,
            52.525785,
            121.244115
          ],
          [
            15.863442,
            52.525647,
            121.274677
          ],
          [
            15.863729,
            52.525609,
            121.305885
          ],
          [
            15.864018,
            52.525653,
            121.336619
          ],
          [
            15.864233,
            52.525779,
            121.366747
          ],
          [
            15.864545,
            52.525842,
            121.40027
          ],
          [
            15.864857,
            52.525895,
            121.432382
          ],
          [
            15.865295,
            52.525954,
            121.476847
          ],
          [
            15.865607,
            52.52602,
            121.509686
          ],
          [
            15.866025,
            52.526114,
            120.459995
          ],
          [
            15.866412,
            52.526184,
            119.240472
          ],
          [
            15.866772,
            52.526197,
            118.144437
          ],
          [
            15.867152,
            52.526194,
            117.001019
          ],
          [
            15.867474,
            52.526195,
            116.032263
          ],
          [
            15.867817,
            52.52624,
            114.973607
          ],
          [
            15.868165,
            52.526317,
            113.859517
          ],
          [
            15.868458,
            52.526463,
            112.715261
          ],
          [
            15.868748,
            52.5266,
            112.402877
          ],
          [
            15.868985,
            52.526778,
            112.155763
          ],
          [
            15.869199,
            52.52697,
            111.905524
          ],
          [
            15.869377,
            52.527162,
            111.66682
          ],
          [
            15.869598,
            52.527331,
            111.43388
          ],
          [
            15.869769,
            52.527495,
            111.223926
          ],
          [
            15.869996,
            52.527616,
            111.023192
          ],
          [
            15.870337,
            52.527738,
            110.763537
          ],
          [
            15.870702,
            52.527847,
            110.820193
          ],
          [
            15.871067,
            52.527966,
            111.015924
          ],
          [
            15.871401,
            52.528095,
            111.202824
          ],
          [
            15.871675,
            52.528224,
            111.366488
          ],
          [
            15.871952,
            52.528335,
            111.523759
          ],
          [
            15.872232,
            52.528439,
            111.67907
          ],
          [
            15.87253,
            52.52854,
            111.84056
          ],
          [
            15.87285,
            52.52864,
            112.010504
          ],
          [
            15.8732,
            52.528768,
            112.257591
          ],
          [
            15.873479,
            52.528865,
            112.477783
          ],
          [
            15.87376,
            52.528939,
            112.686283
          ],
          [
            15.87402,
            52.529061,
            112.910081
          ],
          [
            15.874171,
            52.529242,
            113.137326
          ],
          [
            15.874328,
            52.529419,
            113.362024
          ],
          [
            15.874505,
            52.529588,
            113.586288
          ],
          [
            15.874804,
            52.529556,
            113.801069
          ],
          [
            15.874983,
            52.529391,
            114.022145
          ],
          [
            15.875339,
            52.529287,
            114.042755
          ],
          [
            15.875731,
            52.529245,
            113.983339
          ],
          [
            15.876157,
            52.529247,
            113.919699
          ],
          [
            15.876517,
            52.529233,
            113.865855
          ],
          [
            15.876853,
            52.529242,
            113.815684
          ],
          [
            15.877178,
            52.529271,
            113.766676
          ],
          [
            15.877486,
            52.529317,
            113.719155
          ],
          [
            15.877803,
            52.529334,
            113.671377
          ],
          [
            15.878119,
            52.529327,
            113.939209
          ],
          [
            15.878401,
            52.529245,
            114.548321
          ],
          [
            15.878628,
            52.529105,
            115.165929
          ],
          [
            15.878964,
            52.529025,
            115.855415
          ],
          [
            15.8793,
            52.528955,
            116.534583
          ],
          [
            15.87963,
            52.528933,
            117.169139
          ],
          [
            15.879943,
            52.528867,
            117.802227
          ],
          [
            15.880263,
            52.528809,
            118.439983
          ],
          [
            15.880564,
            52.52876,
            119.035477
          ],
          [
            15.880983,
            52.528721,
            120.673672
          ],
          [
            15.881325,
            52.528725,
            122.306765
          ],
          [
            15.881622,
            52.528746,
            123.738852
          ],
          [
            15.881955,
            52.528782,
            125.355154
          ],
          [
            15.882247,
            52.52882,
            126.791885
          ],
          [
            15.882573,
            52.528833,
            128.354882
          ],
          [
            15.882864,
            52.528752,
            129.901743
          ],
          [
            15.883141,
            52.528651,
            131.44441
          ],
          [
            15.883392,
            52.528548,
            132.890146
          ],
          [
            15.883665,
            52.528472,
            133.099848
          ],
          [
            15.883976,
            52.528418,
            132.584501
          ],
          [
            15.884307,
            52.528395,
            132.054247
          ],
          [
            15.884627,
            52.528416,
            131.541863
          ],
          [
            15.884933,
            52.528453,
            131.046167
          ],
          [
            15.885249,
            52.528507,
            130.519368
          ],
          [
            15.885553,
            52.528591,
            129.987633
          ],
          [
            15.885876,
            52.528665,
            129.439176
          ],
          [
            15.88622,
            52.528713,
            128.876086
          ],
          [
            15.886548,
            52.528736,
            128.956639
          ],
          [
            15.886928,
            52.528768,
            129.373162
          ],
          [
            15.887234,
            52.528857,
            129.740872
          ],
          [
            15.887559,
            52.528965,
            130.140875
          ],
          [
            15.887865,
            52.529063,
            130.514466
          ],
          [
            15.888196,
            52.529168,
            130.917657
          ],
          [
            15.888609,
            52.529261,
            131.393032
          ],
          [
            15.88896,
            52.529357,
            131.809937
          ],
          [
            15.889312,
            52.529418,
            132.24505
          ],
          [
            15.889634,
            52.529461,
            132.647107
          ],
          [
            15.889959,
            52.529506,
            133.053377
          ],
          [
            15.890326,
            52.529556,
            133.5132
          ],
          [
            15.890609,
            52.529626,
            133.885817
          ],
          [
            15.89096,
            52.529708,
            134.347163
          ],
          [
            15.891259,
            52.529752,
            134.731433
          ],
          [
            15.891592,
            52.529804,
            135.150405
          ],
          [
            15.891961,
            52.529859,
            135.639149
          ],
          [
            15.892365,
            52.529906,
            136.258143
          ],
          [
            15.892718,
            52.52994,
            136.79649
          ],
          [
            15.89309,
            52.529989,
            137.36929
          ],
          [
            15.893482,
            52.530041,
            137.973068
          ],
          [
            15.893814,
            52.530078,
            138.481094
          ],
          [
            15.894127,
            52.530125,
            138.966444
          ],
          [
            15.894451,
            52.53019,
            139.480066
          ],
          [
            15.894802,
            52.530245,
            139.875953
          ],
          [
            15.895181,
            52.530287,
            139.225723
          ],
          [
            15.895496,
            52.530317,
            138.687271
          ],
          [
            15.895813,
            52.530388,
            138.110961
          ],
          [
            15.896116,
            52.530424,
            137.590023
          ],
          [
            15.896451,
            52.530489,
            136.996627
          ],
          [
            15.896766,
            52.530545,
            136.442982
          ],
          [
            15.897089,
            52.530552,
            135.897719
          ],
          [
            15.897435,
            52.530617,
            135.286795
          ],
          [
            15.897768,
            52.530672,
            135.017436
          ],
          [
            15.898169,
            52.530715,
            135.147293
          ],
          [
            15.898483,
            52.530761,
            135.250268
          ],
          [
            15.898796,
            52.530804,
            135.352573
          ],
          [
            15.899185,
            52.530853,
            135.479567
          ],
          [
            15.899573,
            52.530911,
            135.606995
          ],
          [
            15.89988,
            52.530953,
            135.707492
          ],
          [
            15.900276,
            52.531007,
            135.836889
          ],
          [
            15.90066,
            52.531055,
            135.907087
          ],
          [
            15.901035,
            52.531127,
            135.900283
          ],
          [
            15.901349,
            52.531158,
            135.894724
          ],
          [
            15.901661,
            52.531191,
            135.889253
          ],
          [
            15.901988,
            52.531249,
            135.883364
          ],
          [
            15.902304,
            52.531308,
            135.877629
          ],
          [
            15.902679,
            52.531358,
            135.870997
          ],
          [
            15.903103,
            52.531431,
            135.863384
          ],
          [
            15.903496,
            52.531492,
            135.887164
          ],
          [
            15.903869,
            52.531561,
            135.964326
          ],
          [
            15.904217,
            52.5316,
            136.034513
          ],
          [
            15.904598,
            52.531647,
            136.111454
          ],
          [
            15.904949,
            52.531697,
            136.182764
          ],
          [
            15.905307,
            52.531754,
            136.256017
          ],
          [
            15.905701,
            52.531809,
            136.335989
          ],
          [
            15.906072,
            52.53186,
            136.411248
          ],
          [
            15.906379,
            52.531902,
            136.460909
          ],
          [
            15.906676,
            52.531945,
            136.496035
          ],
          [
            15.907032,
            52.531965,
            136.536811
          ],
          [
            15.907429,
            52.532014,
            136.58297
          ],
          [
            15.907801,
            52.532075,
            136.626913
          ],
          [
            15.908185,
            52.532143,
            136.672707
          ],
          [
            15.90854,
            52.532201,
            136.714621
          ],
          [
            15.908948,
            52.53226,
            136.762433
          ],
          [
            15.909371,
            52.532305,
            136.950797
          ],
          [
            15.909788,
            52.532356,
            137.218519
          ],
          [
            15.910149,
            52.532408,
            137.451939
          ],
          [
            15.910445,
            52.532482,
            137.653915
          ],
          [
            15.910806,
            52.532539,
            137.888588
          ],
          [
            15.911166,
            52.532579,
            138.1189
          ],
          [
            15.911516,
            52.532635,
            138.346648
          ],
          [
            15.911883,
            52.5327,
            138.587203
          ],
          [
            15.912264,
            52.532721,
            138.504868
          ],
          [
            15.912618,
            52.532792,
            138.336448
          ],
          [
            15.912914,
            52.532827,
            138.200189
          ],
          [
            15.913321,
            52.5329,
            138.008259
          ],
          [
            15.913625,
            52.532972,
            137.86075
          ],
          [
            15.913944,
            52.533049,
            137.705545
          ],
          [
            15.914317,
            52.533047,
            137.536584
          ],
          [
            15.9147,
            52.533027,
            137.362858
          ],
          [
            15.915085,
            52.533002,
            137.562147
          ],
          [
            15.915473,
            52.532996,
            137.947374
          ],
          [
            15.915816,
            52.532984,
            138.288434
          ],
          [
            15.916147,
            52.532988,
            138.617162
          ],
          [
            15.916464,
            52.533,
            138.932683
          ],
          [
            15.916798,
            52.53297,
            139.267936
          ],
          [
            15.917123,
            52.533034,
            139.612878
          ],
          [
            15.917426,
            52.533023,
            139.916041
          ],
          [
            15.917751,
            52.533045,
            140.239595
          ],
          [
            15.91811,
            52.533027,
            140.240576
          ],
          [
            15.918413,
            52.533022,
            140.241402
          ],
          [
            15.918756,
            52.533005,
            140.242344
          ],
          [
            15.919027,
            52.532894,
            140.243236
          ],
          [
            15.919292,
            52.532763,
            140.244166
          ],
          [
            15.919569,
            52.53268,
            140.24501
          ],
          [
            15.919878,
            52.532618,
            140.245896
          ],
          [
            15.920219,
            52.532588,
            140.246834
          ],
          [
            15.920585,
            52.532583,
            140.340896
          ],
          [
            15.92094,
            52.532594,
            140.803422
          ],
          [
            15.921278,
            52.532626,
            141.248491
          ],
          [
            15.92159,
            52.532688,
            141.675599
          ],
          [
            15.921922,
            52.532746,
            142.125679
          ],
          [
            15.922235,
            52.532812,
            142.557755
          ],
          [
            15.922534,
            52.532837,
            142.951415
          ],
          [
            15.922856,
            52.532852,
            143.371546
          ],
          [
            15.923207,
            52.532788,
            143.854261
          ],
          [
            15.923494,
            52.532676,
            144.115829
          ],
          [
            15.923847,
            52.532582,
            144.169145
          ],
          [
            15.924251,
            52.532612,
            144.227245
          ],
          [
            15.924546,
            52.532782,
            144.284054
          ],
          [
            15.924763,
            52.532971,
            144.336453
          ],
          [
            15.925009,
            52.533144,
            144.38854
          ],
          [
            15.925279,
            52.533296,
            144.439381
          ],
          [
            15.925587,
            52.533408,
            144.488962
          ],
          [
            15.925985,
            52.533465,
            144.215467
          ],
          [
            15.926369,
            52.533478,
            143.857832
          ],
          [
            15.926698,
            52.53347,
            143.551584
          ],
          [
            15.927057,
            52.533462,
            143.21771
          ],
          [
            15.927438,
            52.53346,
            142.863906
          ],
          [
            15.92782,
            52.533455,
            142.509154
          ],
          [
            15.928214,
            52.533427,
            142.14074
          ],
          [
            15.928589,
            52.533406,
            141.789944
          ],
          [
            15.928989,
            52.53339,
            141.287439
          ],
          [
            15.929358,
            52.53338,
            140.814086
          ],
          [
            15.929727,
            52.533371,
            140.340834
          ],
          [
            15.930102,
            52.533355,
            139.859314
          ],
          [
            15.930512,
            52.533332,
            139.331775
          ],
          [
            15.930942,
            52.533311,
            138.77924
          ],
          [
            15.931365,
            52.533296,
            138.236518
          ],
          [
            15.931736,
            52.533275,
            138.079048
          ],
          [
            15.932063,
            52.533264,
            138.295371
          ],
          [
            15.932365,
            52.53326,
            138.494912
          ],
          [
            15.932674,
            52.533253,
            138.699199
          ],
          [
            15.933,
            52.533253,
            138.914742
          ],
          [
            15.93331,
            52.533231,
            139.120718
          ],
          [
            15.933663,
            52.533228,
            139.353854
          ],
          [
            15.934068,
            52.533219,
            139.621422
          ],
          [
            15.934434,
            52.533219,
            139.863008
          ],
          [
            15.934796,
            52.533193,
            139.968067
          ],
          [
            15.935129,
            52.533178,
            140.024222
          ],
          [
            15.935457,
            52.533168,
            140.079475
          ],
          [
            15.935769,
            52.533159,
            140.132005
          ],
          [
            15.936108,
            52.533141,
            140.18927
          ],
          [
            15.936461,
            52.533112,
            140.249248
          ],
          [
            15.93681,
            52.533089,
            140.308311
          ],
          [
            15.937169,
            52.533073,
            140.36885
          ],
          [
            15.937538,
            52.533061,
            140.425634
          ],
          [
            15.937898,
            52.533044,
            140.459434
          ],
          [
            15.938253,
            52.533021,
            140.492825
          ],
          [
            15.938635,
            52.533001,
            140.528695
          ],
          [
            15.939012,
            52.532993,
            140.56397
          ],
          [
            15.939377,
            52.532978,
            140.598177
          ],
          [
            15.939755,
            52.53297,
            140.633542
          ],
          [
            15.94013,
            52.532967,
            140.668614
          ],
          [
            15.940506,
            52.53295,
            140.711073
          ],
          [
            15.940881,
            52.532922,
            140.776169
          ],
          [
            15.941258,
            52.532903,
            140.841345
          ],
          [
            15.941632,
            52.532885,
            140.906001
          ],
          [
            15.942013,
            52.532878,
            140.971672
          ],
          [
            15.942378,
            52.532883,
            141.034584
          ],
          [
            15.942741,
            52.532944,
            141.099499
          ],
          [
            15.943126,
            52.532997,
            141.167502
          ],
          [
            15.9435,
            52.533075,
            141.104642
          ],
          [
            15.943849,
            52.533147,
            140.898771
          ],
          [
            15.944213,
            52.53322,
            140.684835
          ],
          [
            15.944555,
            52.533299,
            140.480243
          ],
          [
            15.944905,
            52.533375,
            140.272794
          ],
          [
            15.945255,
            52.533454,
            140.064329
          ],
          [
            15.945597,
            52.533532,
            139.860323
          ],
          [
            15.945953,
            52.533607,
            139.649945
          ],
          [
            15.946313,
            52.533681,
            139.504417
          ],
          [
            15.9467,
            52.533754,
            139.407522
          ],
          [
            15.947082,
            52.533836,
            139.310644
          ],
          [
            15.947445,
            52.533925,
            139.217019
          ],
          [
            15.947791,
            52.533993,
            139.130041
          ],
          [
            15.948136,
            52.534067,
            139.042555
          ],
          [
            15.948495,
            52.534148,
            138.950962
          ],
          [
            15.94884,
            52.534207,
            138.865124
          ],
          [
            15.949187,
            52.534281,
            138.595608
          ],
          [
            15.949512,
            52.534356,
            138.297231
          ],
          [
            15.949836,
            52.534434,
            137.99822
          ],
          [
            15.95014,
            52.534487,
            137.725103
          ],
          [
            15.950474,
            52.534554,
            137.423166
          ],
          [
            15.95081,
            52.534639,
            137.110894
          ],
          [
            15.951165,
            52.534727,
            136.78172
          ],
          [
            15.951528,
            52.5348,
            136.453643
          ],
          [
            15.951891,
            52.534862,
            136.266182
          ],
          [
            15.952281,
            52.534921,
            136.182275
          ],
          [
            15.95268,
            52.534956,
            136.098139
          ],
          [
            15.953059,
            52.534968,
            136.018961
          ],
          [
            15.953415,
            52.534984,
            135.944485
          ],
          [
            15.953716,
            52.534982,
            135.88168
          ],
          [
            15.953951,
            52.535102,
            135.804202
          ],
          [
            15.953858,
            52.535304,
            135.732206
          ],
          [
            15.953808,
            52.535503,
            135.780561
          ],
          [
            15.953721,
            52.535703,
            135.988782
          ],
          [
            15.953666,
            52.53589,
            136.181164
          ],
          [
            15.953592,
            52.536101,
            136.398566
          ],
          [
            15.953488,
            52.536316,
            136.624148
          ],
          [
            15.953387,
            52.536532,
            136.850169
          ],
          [
            15.95327,
            52.536746,
            137.077092
          ],
          [
            15.953149,
            52.536967,
            137.311469
          ],
          [
            15.953061,
            52.537165,
            137.469553
          ],
          [
            15.95295,
            52.537364,
            137.008368
          ],
          [
            15.952865,
            52.537565,
            136.552995
          ],
          [
            15.952799,
            52.537798,
            136.034362
          ],
          [
            15.952686,
            52.538044,
            135.474141
          ],
          [
            15.952567,
            52.538234,
            135.02769
          ],
          [
            15.952441,
            52.538402,
            134.622422
          ],
          [
            15.952321,
            52.538602,
            134.154705
          ],
          [
            15.952329,
            52.538934,
            133.647931
          ],
          [
            15.952347,
            52.539147,
            133.968546
          ],
          [
            15.952415,
            52.539345,
            134.27177
          ],
          [
            15.952515,
            52.539551,
            134.593578
          ],
          [
            15.952624,
            52.539737,
            134.889497
          ],
          [
            15.952684,
            52.53994,
            135.199694
          ],
          [
            15.952667,
            52.540121,
            135.471353
          ],
          [
            15.95265,
            52.540317,
            135.765399
          ],
          [
            15.952639,
            52.540509,
            136.053213
          ],
          [
            15.952639,
            52.540708,
            136.30859
          ],
          [
            15.952693,
            52.540912,
            136.48444
          ],
          [
            15.952711,
            52.541115,
            136.657323
          ],
          [
            15.952639,
            52.541312,
            136.829107
          ],
          [
            15.952624,
            52.541518,
            137.005381
          ],
          [
            15.952618,
            52.541718,
            137.175388
          ],
          [
            15.952614,
            52.541928,
            137.354714
          ],
          [
            15.952625,
            52.542142,
            137.536663
          ],
          [
            15.952649,
            52.54235,
            137.713882
          ],
          [
            15.952686,
            52.542563,
            138.070909
          ],
          [
            15.952642,
            52.542771,
            138.519061
          ],
          [
            15.95267,
            52.542989,
            138.986555
          ],
          [
            15.952619,
            52.543174,
            139.3897
          ],
          [
            15.952468,
            52.543371,
            139.854292
          ],
          [
            15.952294,
            52.54353,
            140.263452
          ],
          [
            15.952164,
            52.543709,
            140.689192
          ],
          [
            15.951992,
            52.543892,
            141.139769
          ],
          [
            15.951851,
            52.544079,
            141.580405
          ],
          [
            15.95173,
            52.544265,
            141.658375
          ],
          [
            15.951626,
            52.544464,
            141.699488
          ],
          [
            15.951526,
            52.544654,
            141.738733
          ],
          [
            15.951377,
            52.544848,
            141.780766
          ],
          [
            15.951301,
            52.545044,
            141.820323
          ],
          [
            15.951151,
            52.545242,
            141.863079
          ],
          [
            15.951019,
            52.545413,
            141.900196
          ],
          [
            15.950877,
            52.545615,
            141.943411
          ],
          [
            15.950738,
            52.545837,
            141.54717
          ],
          [
            15.950659,
            52.546058,
            140.265418
          ],
          [
            15.950597,
            52.546277,
            139.006094
          ],
          [
            15.950606,
            52.54648,
            137.852792
          ],
          [
            15.950588,
            52.546684,
            136.682841
          ],
          [
            15.950628,
            52.546917,
            135.351607
          ],
          [
            15.950699,
            52.547126,
            134.137542
          ],
          [
            15.950899,
            52.547299,
            132.938878
          ],
          [
            15.950948,
            52.547542,
            131.510866
          ],
          [
            15.950835,
            52.547783,
            129.895586
          ],
          [
            15.950776,
            52.547966,
            128.686119
          ],
          [
            15.950723,
            52.548193,
            127.18933
          ],
          [
            15.950639,
            52.548382,
            125.925808
          ],
          [
            15.950654,
            52.548619,
            124.38981
          ],
          [
            15.95073,
            52.548896,
            122.549176
          ],
          [
            15.95062,
            52.549128,
            120.994897
          ],
          [
            15.950583,
            52.549346,
            119.974028
          ],
          [
            15.950626,
            52.549534,
            119.518144
          ],
          [
            15.95062,
            52.549726,
            119.058317
          ],
          [
            15.95072,
            52.549923,
            118.564509
          ],
          [
            15.950881,
            52.550097,
            118.085428
          ],
          [
            15.951028,
            52.550286,
            117.583784
          ],
          [
            15.951169,
            52.550471,
            117.094867
          ],
          [
            15.951288,
            52.550676,
            116.574385
          ],
          [
            15.9514,
            52.550873,
            116.075353
          ],
          [
            15.951499,
            52.551074,
            115.188467
          ],
          [
            15.951607,
            52.551283,
            114.047467
          ],
          [
            15.951677,
            52.551484,
            112.978143
          ],
          [
            15.95172,
            52.551679,
            111.954489
          ],
          [
            15.951784,
            52.551876,
            110.907993
          ],
          [
            15.951882,
            52.552075,
            109.823073
          ],
          [
            15.952011,
            52.552264,
            108.757612
          ],
          [
            15.952067,
            52.552473,
            107.651532
          ],
          [
            15.952119,
            52.552654,
            106.694485
          ],
          [
            15.952225,
            52.552866,
            106.429992
          ],
          [
            15.952331,
            52.553057,
            106.312518
          ],
          [
            15.952407,
            52.553258,
            106.192216
          ],
          [
            15.952473,
            52.553459,
            106.072314
          ],
          [
            15.952543,
            52.553643,
            105.962097
          ],
          [
            15.952499,
            52.55385,
            105.840489
          ],
          [
            15.952413,
            52.554065,
            105.711559
          ],
          [
            15.952404,
            52.554247,
            105.604975
          ],
          [
            15.952379,
            52.554444,
            105.502354
          ],
          [
            15.952319,
            52.554643,
            105.730371
          ],
          [
            15.952257,
            52.554844,
            105.960989
          ],
          [
            15.95222,
            52.555038,
            106.181086
          ],
          [
            15.952218,
            52.555234,
            106.401959
          ],
          [
            15.952196,
            52.555448,
            106.643689
          ],
          [
            15.952203,
            52.555655,
            106.877027
          ],
          [
            15.952231,
            52.555868,
            107.118314
          ],
          [
            15.952223,
            52.556051,
            107.324664
          ],
          [
            15.95216,
            52.556247,
            107.442684
          ],
          [
            15.952078,
            52.556465,
            106.768875
          ],
          [
            15.951954,
            52.556668,
            106.115058
          ],
          [
            15.951842,
            52.556887,
            105.420498
          ],
          [
            15.951726,
            52.557111,
            104.713109
          ],
          [
            15.951657,
            52.557324,
            104.058232
          ],
          [
            15.95154,
            52.557527,
            103.410281
          ],
          [
            15.951461,
            52.557712,
            102.833863
          ],
          [
            15.951438,
            52.557936,
            102.156476
          ],
          [
            15.951437,
            52.558135,
            102.167544
          ],
          [
            15.951426,
            52.558336,
            102.23825
          ],
          [
            15.951399,
            52.558528,
            102.305995
          ],
          [
            15.951358,
            52.558718,
            102.373361
          ],
          [
            15.95129,
            52.558905,
            102.440902
          ],
          [
            15.951155,
            52.559158,
            102.534572
          ],
          [
            15.951109,
            52.559369,
            102.6095
          ],
          [
            15.951105,
            52.559567,
            102.68013
          ],
          [
            15.951094,
            52.559782,
            102.478708
          ],
          [
            15.951195,
            52.560104,
            100.975501
          ],
          [
            15.951298,
            52.560319,
            99.951287
          ],
          [
            15.951213,
            52.560574,
            98.758255
          ],
          [
            15.951062,
            52.56083,
            97.513689
          ],
          [
            15.9509,
            52.561065,
            96.348715
          ],
          [
            15.950988,
            52.561356,
            94.956773
          ],
          [
            15.9512,
            52.561667,
            93.34442
          ],
          [
            15.951567,
            52.561916,
            91.745156
          ],
          [
            15.95188,
            52.562154,
            90.286954
          ],
          [
            15.952164,
            52.562336,
            89.087464
          ],
          [
            15.952443,
            52.562517,
            87.901427
          ],
          [
            15.952706,
            52.562664,
            86.856182
          ],
          [
            15.952924,
            52.562804,
            85.932953
          ],
          [
            15.953207,
            52.56293,
            85.612266
          ],
          [
            15.95349,
            52.563038,
            85.316617
          ],
          [
            15.953766,
            52.563153,
            85.022931
          ],
          [
            15.9541,
            52.563285,
            84.673987
          ],
          [
            15.954428,
            52.563408,
            84.335017
          ],
          [
            15.954698,
            52.563551,
            84.021447
          ],
          [
            15.954902,
            52.563703,
            83.737633
          ],
          [
            15.955139,
            52.56386,
            83.430349
          ],
          [
            15.955371,
            52.56398,
            83.569203
          ],
          [
            15.955671,
            52.564048,
            84.002144
          ],
          [
            15.95599,
            52.564016,
            84.438844
          ],
          [
            15.956303,
            52.563941,
            84.887875
          ],
          [
            15.95653,
            52.563806,
            85.312357
          ],
          [
            15.956767,
            52.563675,
            85.740112
          ],
          [
            15.957036,
            52.563572,
            86.164609
          ],
          [
            15.957239,
            52.563433,
            86.57583
          ],
          [
            15.957491,
            52.563299,
            87.025289
          ],
          [
            15.957797,
            52.563214,
            87.730006
          ],
          [
            15.958165,
            52.563196,
            88.841703
          ],
          [
            15.958464,
            52.563183,
            89.744361
          ],
          [
            15.958783,
            52.563206,
            90.71175
          ],
          [
            15.959109,
            52.56323,
            91.700956
          ],
          [
            15.959368,
            52.56331,
            92.628421
          ],
          [
            15.959673,
            52.563375,
            93.6025
          ],
          [
            15.959774,
            52.563553,
            94.5457
          ],
          [
            15.959641,
            52.563741,
            95.584209
          ],
          [
            15.95937,
            52.563863,
            96.634265
          ],
          [
            15.959144,
            52.564011,
            97.714261
          ],
          [
            15.958933,
            52.564168,
            98.801222
          ],
          [
            15.958721,
            52.564319,
            99.859683
          ],
          [
            15.958806,
            52.564388,
            100.937739
          ],
          [
            15.959109,
            52.564321,
            101.98329
          ],
          [
            15.959097,
            52.564315,
            102.998388
          ],
          [
            15.958791,
            52.564396,
            104.080529
          ],
          [
            15.958546,
            52.564503,
            105.130541
          ],
          [
            15.95871,
            52.564681,
            106.155434
          ],
          [
            15.958943,
            52.564804,
            106.990333
          ],
          [
            15.959242,
            52.564888,
            107.890979
          ],
          [
            15.959551,
            52.564937,
            108.747702
          ],
          [
            15.959847,
            52.564987,
            109.571644
          ],
          [
            15.960156,
            52.565036,
            110.432313
          ],
          [
            15.960482,
            52.565098,
            111.353166
          ],
          [
            15.960788,
            52.56517,
            112.233137
          ],
          [
            15.961109,
            52.565245,
            113.155485
          ],
          [
            15.961436,
            52.565314,
            113.740867
          ],
          [
            15.961683,
            52.565441,
            113.824975
          ],
          [
            15.961935,
            52.565562,
            113.906529
          ],
          [
            15.962207,
            52.565699,
            113.995985
          ],
          [
            15.962485,
            52.565836,
            114.086603
          ],
          [
            15.962791,
            52.565951,
            114.177757
          ],
          [
            15.963112,
            52.566046,
            114.268165
          ],
          [
            15.963463,
            52.566152,
            114.36744
          ],
          [
            15.963791,
            52.566252,
            114.460037
          ],
          [
            15.96409,
            52.566365,
            114.544735
          ],
          [
            15.964424,
            52.566473,
            114.63566
          ],
          [
            15.964705,
            52.566564,
            114.712186
          ],
          [
            15.96499,
            52.56667,
            114.792487
          ],
          [
            15.965267,
            52.566765,
            114.86895
          ],
          [
            15.965571,
            52.566872,
            114.953515
          ],
          [
            15.965892,
            52.56697,
            115.039844
          ],
          [
            15.96618,
            52.567059,
            115.117511
          ],
          [
            15.966486,
            52.567139,
            115.315559
          ],
          [
            15.966775,
            52.567233,
            115.682527
          ],
          [
            15.967072,
            52.5673,
            116.036638
          ],
          [
            15.967378,
            52.567375,
            116.405529
          ],
          [
            15.967696,
            52.567478,
            116.808666
          ],
          [
            15.968009,
            52.567585,
            117.210066
          ],
          [
            15.968293,
            52.567685,
            117.576988
          ],
          [
            15.968638,
            52.567751,
            117.981485
          ],
          [
            15.968959,
            52.567838,
            118.374471
          ],
          [
            15.969293,
            52.567912,
            118.450065
          ],
          [
            15.969628,
            52.567998,
            118.419816
          ],
          [
            15.969948,
            52.568095,
            118.390006
          ],
          [
            15.970259,
            52.568174,
            118.361942
          ],
          [
            15.970539,
            52.568257,
            118.335971
          ],
          [
            15.970858,
            52.568339,
            118.307169
          ],
          [
            15.971179,
            52.568414,
            118.278502
          ],
          [
            15.971472,
            52.568513,
            118.250598
          ],
          [
            15.971804,
            52.56861,
            118.227285
          ],
          [
            15.972114,
            52.568657,
            118.231516
          ],
          [
            15.972428,
            52.568745,
            118.236095
          ],
          [
            15.972748,
            52.568837,
            118.240797
          ],
          [
            15.973069,
            52.568928,
            118.245487
          ],
          [
            15.973355,
            52.569013,
            118.249703
          ],
          [
            15.973665,
            52.569101,
            118.254232
          ],
          [
            15.974007,
            52.569191,
            118.259166
          ],
          [
            15.97436,
            52.569281,
            118.264233
          ],
          [
            15.974689,
            52.569371,
            117.945653
          ],
          [
            15.974983,
            52.569449,
            117.564084
          ],
          [
            15.97526,
            52.569529,
            117.199232
          ],
          [
            15.975583,
            52.569594,
            116.794387
          ],
          [
            15.975896,
            52.56968,
            116.38495
          ],
          [
            15.976195,
            52.569743,
            116.007857
          ],
          [
            15.97652,
            52.569831,
            115.583846
          ],
          [
            15.976841,
            52.569917,
            115.166585
          ],
          [
            15.977142,
            52.570007,
            114.767331
          ],
          [
            15.977435,
            52.570077,
            114.534728
          ],
          [
            15.977739,
            52.570153,
            114.300869
          ],
          [
            15.978058,
            52.570234,
            114.054899
          ],
          [
            15.978364,
            52.570317,
            113.816332
          ],
          [
            15.978696,
            52.570411,
            113.555869
          ],
          [
            15.97903,
            52.570505,
            113.294067
          ],
          [
            15.979331,
            52.570576,
            113.064305
          ],
          [
            15.979644,
            52.570649,
            112.825638
          ],
          [
            15.97993,
            52.570717,
            112.651512
          ],
          [
            15.980203,
            52.570836,
            112.723807
          ],
          [
            15.980525,
            52.570996,
            112.813173
          ],
          [
            15.980813,
            52.571144,
            112.89421
          ],
          [
            15.981086,
            52.571274,
            112.968659
          ],
          [
            15.981331,
            52.571403,
            113.038413
          ],
          [
            15.981594,
            52.571515,
            113.107515
          ],
          [
            15.981859,
            52.571642,
            113.179951
          ],
          [
            15.982134,
            52.571786,
            113.257945
          ],
          [
            15.982417,
            52.571911,
            112.809945
          ],
          [
            15.9827,
            52.572065,
            112.137739
          ],
          [
            15.983026,
            52.572241,
            111.366408
          ],
          [
            15.983341,
            52.572408,
            110.627195
          ],
          [
            15.983626,
            52.572553,
            109.969724
          ],
          [
            15.983957,
            52.572701,
            109.243108
          ],
          [
            15.984245,
            52.572868,
            108.537577
          ],
          [
            15.98453,
            52.572992,
            108.06461
          ],
          [
            15.98478,
            52.573132,
            108.164406
          ],
          [
            15.985111,
            52.573283,
            108.285837
          ],
          [
            15.985375,
            52.573402,
            108.382245
          ],
          [
            15.985632,
            52.573506,
            108.472925
          ],
          [
            15.985893,
            52.573607,
            108.563845
          ],
          [
            15.986212,
            52.573707,
            108.669114
          ],
          [
            15.986537,
            52.573774,
            108.769899
          ],
          [
            15.986829,
            52.573887,
            108.871447
          ],
          [
            15.987149,
            52.573985,
            108.87683
          ],
          [
            15.987484,
            52.574093,
            108.817649
          ],
          [
            15.987823,
            52.57417,
            108.761209
          ],
          [
            15.988081,
            52.574282,
            108.711747
          ],
          [
            15.988344,
            52.57444,
            108.653976
          ],
          [
            15.988562,
            52.574621,
            108.596435
          ],
          [
            15.988778,
            52.574796,
            108.540246
          ],
          [
            15.988958,
            52.574961,
            108.489149
          ],
          [
            15.989143,
            52.575136,
            108.124808
          ],
          [
            15.989374,
            52.575319,
            106.795391
          ],
          [
            15.989547,
            52.575503,
            105.570195
          ],
          [
            15.989764,
            52.575664,
            104.370571
          ],
          [
            15.989998,
            52.575874,
            102.908778
          ],
          [
            15.990214,
            52.576056,
            101.608233
          ],
          [
            15.990401,
            52.57623,
            100.409935
          ],
          [
            15.990609,
            52.576422,
            99.084111
          ],
          [
            15.990821,
            52.576616,
            98.00109
          ],
          [
            15.99108,
            52.576818,
            97.645543
          ],
          [
            15.991344,
            52.576992,
            97.317394
          ],
          [
            15.991636,
            52.57708,
            97.041843
          ],
          [
            15.991951,
            52.577172,
            96.747137
          ],
          [
            15.992195,
            52.577291,
            96.483543
          ],
          [
            15.992492,
            52.577351,
            96.219847
          ],
          [
            15.992773,
            52.577474,
            95.927965
          ],
          [
            15.993096,
            52.577598,
            95.605438
          ],
          [
            15.993392,
            52.577698,
            94.688501
          ],
          [
            15.993738,
            52.577795,
            93.615781
          ],
          [
            15.99404,
            52.577917,
            92.595369
          ],
          [
            15.994381,
            52.578059,
            91.432657
          ],
          [
            15.994665,
            52.578205,
            90.386344
          ],
          [
            15.994948,
            52.578323,
            89.420978
          ],
          [
            15.995219,
            52.578477,
            88.377378
          ],
          [
            15.995513,
            52.578587,
            87.405137
          ],
          [
            15.995803,
            52.578745,
            87.937629
          ],
          [
            15.996085,
            52.578882,
            88.652278
          ],
          [
            15.996324,
            52.578991,
            89.243836
          ],
          [
            15.996655,
            52.579139,
            90.059176
          ],
          [
            15.99699,
            52.57923,
            90.787627
          ],
          [
            15.997332,
            52.579289,
            91.492689
          ],
          [
            15.997688,
            52.579351,
            92.227287
          ],
          [
            15.998046,
            52.57943,
            92.981128
          ],
          [
            15.998392,
            52.579492,
            93.151778
          ],
          [
            15.998719,
            52.579544,
            93.184907
          ],
          [
            15.999032,
            52.57959,
            93.216478
          ],
          [
            15.999346,
            52.579636,
            93.248134
          ],
          [
            15.999659,
            52.579678,
            93.279826
          ],
          [
            15.999981,
            52.579714,
            93.311914
          ],
          [
            16.000337,
            52.579762,
            93.34765
          ],
          [
            16.000762,
            52.57981,
            93.390013
          ],
          [
            16.001113,
            52.579857,
            93.386104
          ],
          [
            16.001417,
            52.579891,
            93.315325
          ],
          [
            16.001717,
            52.57993,
            93.244675
          ],
          [
            16.002015,
            52.579958,
            93.175601
          ],
          [
            16.002436,
            52.580001,
            93.077795
          ],
          [
            16.00284,
            52.580043,
            92.983959
          ],
          [
            16.003195,
            52.580071,
            92.901983
          ],
          [
            16.003564,
            52.580101,
            92.816754
          ],
          [
            16.003983,
            52.580145,
            92.583806
          ],
          [
            16.004407,
            52.580167,
            91.683636
          ],
          [
            16.004767,
            52.580134,
            90.915573
          ],
          [
            16.005091,
            52.580086,
            90.211992
          ],
          [
            16.005273,
            52.580155,
            89.561914
          ],
          [
            16.005306,
            52.580334,
            88.9268
          ],
          [
            16.005193,
            52.580548,
            88.142354
          ],
          [
            16.005215,
            52.58075,
            87.439555
          ],
          [
            16.005214,
            52.580945,
            86.761195
          ],
          [
            16.005246,
            52.581174,
            86.792828
          ],
          [
            16.005254,
            52.581398,
            87.234265
          ],
          [
            16.005307,
            52.581657,
            87.747292
          ],
          [
            16.005307,
            52.58186,
            88.147011
          ],
          [
            16.005337,
            52.582068,
            88.558303
          ],
          [
            16.005324,
            52.582258,
            88.933684
          ],
          [
            16.005322,
            52.582449,
            89.324861
          ],
          [
            16.005428,
            52.582623,
            89.704109
          ],
          [
            16.005536,
            52.582803,
            90.175652
          ],
          [
            16.005714,
            52.582969,
            91.214073
          ],
          [
            16.005928,
            52.58311,
            92.224517
          ],
          [
            16.00616,
            52.583251,
            93.271163
          ],
          [
            16.006362,
            52.58338,
            94.238298
          ],
          [
            16.006559,
            52.583568,
            95.413967
          ],
          [
            16.006804,
            52.583676,
            96.425983
          ],
          [
            16.007057,
            52.583751,
            97.44396
          ],
          [
            16.007237,
            52.583916,
            98.489524
          ],
          [
            16.007553,
            52.584024,
            99.617972
          ],
          [
            16.007849,
            52.584141,
            100.576767
          ],
          [
            16.008093,
            52.584276,
            101.473047
          ],
          [
            16.00838,
            52.584367,
            102.356675
          ],
          [
            16.008654,
            52.58448,
            103.256041
          ],
          [
            16.00898,
            52.584598,
            104.287335
          ],
          [
            16.009283,
            52.584725,
            105.28777
          ],
          [
            16.009573,
            52.584847,
            106.246223
          ],
          [
            16.009847,
            52.585,
            107.262828
          ],
          [
            16.010132,
            52.585095,
            107.648959
          ],
          [
            16.010444,
            52.585228,
            107.899991
          ],
          [
            16.010748,
            52.58533,
            108.128654
          ],
          [
            16.011068,
            52.585457,
            108.380801
          ],
          [
            16.011352,
            52.585565,
            108.601512
          ],
          [
            16.011611,
            52.58567,
            108.806985
          ],
          [
            16.01188,
            52.58576,
            109.00918
          ],
          [
            16.012148,
            52.585873,
            109.223964
          ],
          [
            16.01249,
            52.585985,
            109.473691
          ],
          [
            16.012737,
            52.5861,
            109.64874
          ],
          [
            16.013026,
            52.586226,
            109.849282
          ],
          [
            16.0133,
            52.586312,
            110.023954
          ],
          [
            16.013623,
            52.586437,
            110.239622
          ],
          [
            16.013925,
            52.586551,
            110.439602
          ],
          [
            16.014211,
            52.586652,
            110.62576
          ],
          [
            16.014523,
            52.586779,
            110.837027
          ],
          [
            16.014837,
            52.586894,
            111.04326
          ],
          [
            16.015189,
            52.587048,
            110.584749
          ],
          [
            16.015548,
            52.587175,
            109.93586
          ],
          [
            16.015853,
            52.587279,
            109.38785
          ],
          [
            16.016154,
            52.587392,
            108.834804
          ],
          [
            16.016494,
            52.587478,
            108.258619
          ],
          [
            16.016875,
            52.587535,
            107.642119
          ],
          [
            16.017274,
            52.587591,
            107.001534
          ],
          [
            16.017633,
            52.587613,
            106.506313
          ],
          [
            16.017965,
            52.587606,
            106.855238
          ],
          [
            16.018307,
            52.587608,
            107.214731
          ],
          [
            16.01864,
            52.587617,
            107.564837
          ],
          [
            16.018995,
            52.587641,
            107.940333
          ],
          [
            16.019306,
            52.587682,
            108.27488
          ],
          [
            16.019671,
            52.587744,
            108.674053
          ],
          [
            16.020025,
            52.587737,
            109.047713
          ],
          [
            16.020333,
            52.587768,
            109.375632
          ],
          [
            16.020649,
            52.587806,
            109.637107
          ],
          [
            16.020988,
            52.587841,
            109.777796
          ],
          [
            16.021293,
            52.587867,
            109.904277
          ],
          [
            16.021633,
            52.587878,
            110.044115
          ],
          [
            16.022027,
            52.58791,
            110.207297
          ],
          [
            16.022357,
            52.587958,
            110.346119
          ],
          [
            16.022695,
            52.588002,
            110.487533
          ],
          [
            16.023052,
            52.588013,
            110.633863
          ],
          [
            16.023376,
            52.588023,
            110.76658
          ],
          [
            16.023697,
            52.58805,
            110.115584
          ],
          [
            16.02404,
            52.588067,
            109.14756
          ],
          [
            16.024377,
            52.588079,
            108.206364
          ],
          [
            16.024684,
            52.588114,
            107.337738
          ],
          [
            16.025065,
            52.588179,
            106.236821
          ],
          [
            16.025358,
            52.588255,
            105.351818
          ],
          [
            16.025782,
            52.588305,
            104.149158
          ],
          [
            16.026193,
            52.588328,
            103.001822
          ],
          [
            16.026538,
            52.588287,
            102.875115
          ],
          [
            16.026864,
            52.588287,
            103.365752
          ],
          [
            16.027219,
            52.588307,
            103.902223
          ],
          [
            16.027553,
            52.588399,
            104.454209
          ],
          [
            16.027817,
            52.588505,
            104.93779
          ],
          [
            16.028099,
            52.588609,
            105.435176
          ],
          [
            16.02837,
            52.588709,
            105.913056
          ],
          [
            16.028596,
            52.588853,
            106.405885
          ],
          [
            16.028843,
            52.589017,
            106.957742
          ],
          [
            16.029096,
            52.589152,
            106.961701
          ],
          [
            16.029326,
            52.589316,
            106.878411
          ],
          [
            16.02958,
            52.589467,
            106.794807
          ],
          [
            16.029873,
            52.589613,
            106.70582
          ],
          [
            16.030098,
            52.589764,
            106.627085
          ],
          [
            16.030346,
            52.589924,
            106.542073
          ],
          [
            16.030593,
            52.59008,
            106.458367
          ],
          [
            16.030886,
            52.590243,
            106.364719
          ],
          [
            16.031227,
            52.590382,
            106.094085
          ],
          [
            16.031549,
            52.590493,
            105.77684
          ],
          [
            16.031913,
            52.590545,
            105.457478
          ],
          [
            16.032138,
            52.590684,
            105.174477
          ],
          [
            16.032214,
            52.590876,
            104.896486
          ],
          [
            16.032339,
            52.591089,
            104.579056
          ],
          [
            16.032577,
            52.591295,
            104.224525
          ],
          [
            16.032805,
            52.591454,
            103.927146
          ],
          [
            16.033046,
            52.591667,
            103.298491
          ],
          [
            16.033215,
            52.591852,
            102.677066
          ],
          [
            16.033402,
            52.592048,
            102.014876
          ],
          [
            16.033612,
            52.592258,
            101.296564
          ],
          [
            16.033809,
            52.592447,
            100.642662
          ],
          [
            16.033986,
            52.592618,
            100.052113
          ],
          [
            16.034161,
            52.592802,
            99.429903
          ],
          [
            16.034376,
            52.592994,
            98.750826
          ],
          [
            16.034613,
            52.593181,
            98.896928
          ],
          [
            16.034918,
            52.593319,
            99.373174
          ],
          [
            16.035219,
            52.593452,
            99.836429
          ],
          [
            16.035516,
            52.593554,
            100.264267
          ],
          [
            16.035853,
            52.593649,
            100.726654
          ],
          [
            16.036135,
            52.593761,
            101.146408
          ],
          [
            16.036355,
            52.593913,
            101.563745
          ],
          [
            16.036586,
            52.594088,
            102.023406
          ],
          [
            16.036816,
            52.594282,
            101.933263
          ],
          [
            16.037007,
            52.594465,
            101.444939
          ],
          [
            16.037221,
            52.594654,
            100.927748
          ],
          [
            16.037447,
            52.594857,
            100.375481
          ],
          [
            16.037673,
            52.595056,
            99.83061
          ],
          [
            16.037895,
            52.595223,
            99.342717
          ],
          [
            16.038102,
            52.595411,
            98.83288
          ],
          [
            16.038313,
            52.595595,
            98.327529
          ],
          [
            16.038511,
            52.595785,
            98.156909
          ],
          [
            16.038728,
            52.59596,
            98.120079
          ],
          [
            16.038935,
            52.596134,
            98.083959
          ],
          [
            16.039143,
            52.596316,
            98.046721
          ],
          [
            16.039338,
            52.596494,
            98.010771
          ],
          [
            16.039526,
            52.59667,
            97.975501
          ],
          [
            16.039716,
            52.596863,
            97.937701
          ],
          [
            16.039956,
            52.597085,
            97.893054
          ],
          [
            16.040176,
            52.597263,
            97.491106
          ],
          [
            16.040247,
            52.597484,
            96.923901
          ],
          [
            16.040256,
            52.597698,
            96.385333
          ],
          [
            16.040193,
            52.597899,
            95.870532
          ],
          [
            16.040135,
            52.598096,
            95.366362
          ],
          [
            16.040213,
            52.598325,
            94.77606
          ],
          [
            16.040264,
            52.598543,
            94.221972
          ],
          [
            16.040281,
            52.598767,
            93.657837
          ],
          [
            16.040328,
            52.598992,
            93.146724
          ],
          [
            16.040353,
            52.599228,
            92.682072
          ],
          [
            16.040397,
            52.599449,
            92.245561
          ],
          [
            16.040503,
            52.599686,
            91.761721
          ],
          [
            16.040552,
            52.599868,
            91.399803
          ],
          [
            16.040649,
            52.600099,
            90.930104
          ],
          [
            16.040759,
            52.600316,
            90.484867
          ],
          [
            16.04082,
            52.60053,
            90.058906
          ],
          [
            16.040851,
            52.600769,
            89.764287
          ],
          [
            16.040789,
            52.600981,
            89.648208
          ],
          [
            16.040705,
            52.601254,
            89.499293
          ],
          [
            16.040624,
            52.601433,
            89.399722
          ],
          [
            16.040592,
            52.601632,
            89.291845
          ],
          [
            16.040863,
            52.601751,
            89.182153
          ],
          [
            16.041169,
            52.601803,
            89.077683
          ],
          [
            16.04153,
            52.601825,
            88.959548
          ],
          [
            16.041908,
            52.601835,
            88.458582
          ],
          [
            16.042305,
            52.601844,
            86.68312
          ],
          [
            16.042794,
            52.601875,
            84.51673
          ],
          [
            16.043351,
            52.601918,
            82.045097
          ],
          [
            16.043899,
            52.60199,
            79.573433
          ],
          [
            16.044328,
            52.602011,
            77.676287
          ],
          [
            16.044787,
            52.602008,
            75.782927
          ],
          [
            16.04509,
            52.602022,
            75.414586
          ],
          [
            16.045408,
            52.60201,
            75.028739
          ],
          [
            16.045861,
            52.602055,
            74.471235
          ],
          [
            16.046181,
            52.60209,
            74.077193
          ],
          [
            16.046502,
            52.602094,
            73.685939
          ],
          [
            16.046943,
            52.602072,
            73.146059
          ],
          [
            16.047299,
            52.60198,
            72.67753
          ],
          [
            16.047683,
            52.60197,
            72.262957
          ],
          [
            16.048115,
            52.602031,
            72.535974
          ],
          [
            16.048527,
            52.602028,
            72.789571
          ],
          [
            16.048867,
            52.601969,
            73.007451
          ],
          [
            16.049244,
            52.601926,
            73.243353
          ],
          [
            16.049588,
            52.60186,
            73.465185
          ],
          [
            16.049967,
            52.6018,
            73.706022
          ],
          [
            16.05034,
            52.601725,
            73.947679
          ],
          [
            16.050737,
            52.601642,
            73.613896
          ],
          [
            16.051063,
            52.601598,
            72.951097
          ],
          [
            16.051457,
            52.601544,
            72.148193
          ],
          [
            16.051848,
            52.601518,
            71.368232
          ],
          [
            16.052215,
            52.601497,
            70.637374
          ],
          [
            16.052643,
            52.601469,
            69.783036
          ],
          [
            16.053053,
            52.601454,
            68.968495
          ],
          [
            16.053451,
            52.601479,
            68.208506
          ],
          [
            16.053842,
            52.601534,
            68.687756
          ],
          [
            16.054185,
            52.601615,
            69.126987
          ],
          [
            16.054476,
            52.601696,
            69.509094
          ],
          [
            16.054804,
            52.601821,
            69.970576
          ],
          [
            16.055074,
            52.601918,
            70.344802
          ],
          [
            16.055356,
            52.602089,
            70.819558
          ],
          [
            16.055603,
            52.602224,
            71.215436
          ],
          [
            16.055815,
            52.602355,
            71.576226
          ],
          [
            16.05605,
            52.602484,
            72.768825
          ],
          [
            16.056259,
            52.602633,
            74.479049
          ],
          [
            16.056486,
            52.602758,
            76.120894
          ],
          [
            16.056666,
            52.602927,
            77.874624
          ],
          [
            16.056886,
            52.603064,
            79.546642
          ],
          [
            16.057101,
            52.603204,
            81.218102
          ],
          [
            16.057343,
            52.603332,
            82.917016
          ],
          [
            16.057547,
            52.603483,
            84.62103
          ],
          [
            16.057779,
            52.603643,
            86.48687
          ],
          [
            16.058038,
            52.603788,
            88.059101
          ],
          [
            16.058248,
            52.603929,
            89.196906
          ],
          [
            16.058477,
            52.604055,
            90.319888
          ],
          [
            16.058718,
            52.604177,
            91.460179
          ],
          [
            16.059027,
            52.60421,
            92.603441
          ],
          [
            16.059361,
            52.604233,
            93.825929
          ],
          [
            16.059682,
            52.604256,
            95.000709
          ],
          [
            16.060036,
            52.604277,
            96.293376
          ],
          [
            16.060333,
            52.604318,
            97.407818
          ],
          [
            16.060654,
            52.604344,
            98.331071
          ],
          [
            16.06096,
            52.604386,
            98.798735
          ],
          [
            16.061008,
            52.604582,
            99.303803
          ],
          [
            16.060962,
            52.604794,
            99.825165
          ],
          [
            16.060904,
            52.604978,
            100.285059
          ],
          [
            16.060839,
            52.605178,
            100.782053
          ],
          [
            16.060815,
            52.60537,
            101.251318
          ],
          [
            16.060844,
            52.605555,
            101.704218
          ],
          [
            16.060894,
            52.605764,
            102.219303
          ],
          [
            16.060972,
            52.605968,
            102.681539
          ],
          [
            16.061086,
            52.606145,
            103.024582
          ],
          [
            16.061231,
            52.606327,
            103.389506
          ],
          [
            16.061394,
            52.606496,
            103.743025
          ],
          [
            16.061565,
            52.606683,
            104.129894
          ],
          [
            16.061712,
            52.606867,
            104.499166
          ],
          [
            16.061837,
            52.60706,
            104.873515
          ],
          [
            16.061971,
            52.607247,
            105.242384
          ],
          [
            16.062117,
            52.607459,
            105.657578
          ],
          [
            16.062275,
            52.607662,
            105.940212
          ],
          [
            16.062435,
            52.607833,
            106.137326
          ],
          [
            16.062602,
            52.608044,
            106.371995
          ],
          [
            16.062745,
            52.608216,
            106.56541
          ],
          [
            16.062868,
            52.608392,
            106.75741
          ],
          [
            16.063024,
            52.608572,
            106.961274
          ],
          [
            16.063157,
            52.608794,
            107.199899
          ],
          [
            16.063333,
            52.608993,
            107.427224
          ],
          [
            16.063476,
            52.609187,
            107.577552
          ],
          [
            16.063626,
            52.609385,
            107.528083
          ],
          [
            16.063792,
            52.609578,
            107.478644
          ],
          [
            16.063954,
            52.609772,
            107.42928
          ],
          [
            16.064101,
            52.609966,
            107.380817
          ],
          [
            16.064238,
            52.610178,
            107.329126
          ],
          [
            16.064404,
            52.610387,
            107.276441
          ],
          [
            16.064545,
            52.610565,
            107.231562
          ],
          [
            16.064654,
            52.61074,
            107.189101
          ],
          [
            16.06482,
            52.610908,
            107.339911
          ],
          [
            16.064984,
            52.611086,
            107.540901
          ],
          [
            16.065129,
            52.611271,
            107.742823
          ],
          [
            16.065274,
            52.611459,
            107.947391
          ],
          [
            16.065423,
            52.611651,
            108.156554
          ],
          [
            16.065563,
            52.611856,
            108.375247
          ],
          [
            16.065699,
            52.61205,
            108.583128
          ],
          [
            16.06585,
            52.61224,
            108.791046
          ],
          [
            16.065982,
            52.612434,
            108.971762
          ],
          [
            16.066144,
            52.612623,
            109.058625
          ],
          [
            16.066322,
            52.612831,
            109.154073
          ],
          [
            16.066461,
            52.61302,
            109.238355
          ],
          [
            16.066625,
            52.613221,
            109.329705
          ],
          [
            16.066765,
            52.613408,
            109.413346
          ],
          [
            16.066896,
            52.613581,
            109.490877
          ],
          [
            16.067037,
            52.613762,
            109.572417
          ],
          [
            16.067188,
            52.613948,
            109.65686
          ],
          [
            16.06732,
            52.614126,
            109.448559
          ],
          [
            16.06746,
            52.614326,
            109.034122
          ],
          [
            16.0676,
            52.614512,
            108.64407
          ],
          [
            16.06776,
            52.614699,
            108.242261
          ],
          [
            16.067922,
            52.614903,
            107.810232
          ],
          [
            16.068069,
            52.6151,
            107.397974
          ],
          [
            16.068037,
            52.61525,
            107.020824
          ],
          [
            16.068273,
            52.615334,
            106.646767
          ],
          [
            16.068437,
            52.615546,
            106.141391
          ],
          [
            16.068604,
            52.615748,
            105.266321
          ],
          [
            16.068747,
            52.615938,
            104.457579
          ],
          [
            16.068895,
            52.616133,
            103.623399
          ],
          [
            16.069056,
            52.616369,
            102.634346
          ],
          [
            16.06925,
            52.616632,
            101.518734
          ],
          [
            16.069463,
            52.616928,
            100.268171
          ],
          [
            16.069662,
            52.617158,
            99.246682
          ],
          [
            16.069869,
            52.617415,
            97.596575
          ],
          [
            16.070015,
            52.617599,
            96.418328
          ],
          [
            16.070156,
            52.617777,
            95.279076
          ],
          [
            16.070358,
            52.618022,
            93.698547
          ],
          [
            16.070599,
            52.618299,
            91.891363
          ],
          [
            16.070865,
            52.618584,
            90.001871
          ],
          [
            16.07112,
            52.618831,
            88.485067
          ],
          [
            16.071368,
            52.619106,
            87.173436
          ],
          [
            16.071619,
            52.61938,
            85.861548
          ],
          [
            16.071908,
            52.619659,
            84.482738
          ],
          [
            16.072155,
            52.619888,
            83.337389
          ],
          [
            16.072317,
            52.620049,
            82.548133
          ],
          [
            16.072475,
            52.620208,
            81.77106
          ],
          [
            16.072799,
            52.620501,
            80.700605
          ],
          [
            16.07298,
            52.620733,
            80.02225
          ],
          [
            16.073078,
            52.621054,
            79.159839
          ],
          [
            16.073161,
            52.621369,
            78.317688
          ],
          [
            16.073236,
            52.621646,
            77.576651
          ],
          [
            16.073415,
            52.621899,
            76.847305
          ],
          [
            16.073624,
            52.622103,
            76.720216
          ],
          [
            16.073822,
            52.62228,
            76.81498
          ],
          [
            16.073982,
            52.622439,
            76.897477
          ],
          [
            16.074181,
            52.622628,
            76.996895
          ],
          [
            16.074325,
            52.62284,
            77.098432
          ],
          [
            16.074462,
            52.623017,
            77.185019
          ],
          [
            16.074591,
            52.623225,
            77.283437
          ],
          [
            16.074686,
            52.623423,
            77.375006
          ],
          [
            16.074651,
            52.623608,
            77.425437
          ],
          [
            16.074547,
            52.623808,
            77.31119
          ],
          [
            16.074406,
            52.624042,
            77.175405
          ],
          [
            16.074267,
            52.624259,
            77.048615
          ],
          [
            16.074153,
            52.624503,
            76.909802
          ],
          [
            16.074043,
            52.624739,
            76.776242
          ],
          [
            16.073931,
            52.624953,
            76.653909
          ],
          [
            16.07382,
            52.62515,
            76.540531
          ],
          [
            16.07369,
            52.625339,
            76.723982
          ],
          [
            16.073574,
            52.625525,
            77.524163
          ],
          [
            16.073442,
            52.625784,
            78.613891
          ],
          [
            16.073294,
            52.626014,
            79.606711
          ],
          [
            16.073169,
            52.626191,
            80.379023
          ],
          [
            16.073035,
            52.626378,
            81.197887
          ],
          [
            16.072912,
            52.626557,
            81.978796
          ],
          [
            16.072799,
            52.626733,
            82.737486
          ],
          [
            16.072716,
            52.626921,
            83.518484
          ],
          [
            16.072707,
            52.627115,
            83.905847
          ],
          [
            16.072765,
            52.627316,
            84.208063
          ],
          [
            16.072774,
            52.627534,
            84.530904
          ],
          [
            16.072811,
            52.627738,
            84.834015
          ],
          [
            16.072824,
            52.627941,
            85.134021
          ],
          [
            16.072842,
            52.628123,
            85.40332
          ],
          [
            16.072804,
            52.628329,
            85.70953
          ],
          [
            16.072798,
            52.628518,
            85.989261
          ],
          [
            16.072789,
            52.628723,
            86.292324
          ],
          [
            16.072847,
            52.628921,
            86.828343
          ],
          [
            16.072871,
            52.62914,
            87.456032
          ],
          [
            16.072871,
            52.629359,
            88.083488
          ],
          [
            16.072897,
            52.629587,
            88.73641
          ],
          [
            16.072915,
            52.629784,
            89.300296
          ],
          [
            16.072893,
            52.629983,
            89.874687
          ],
          [
            16.07288,
            52.630168,
            90.403687
          ],
          [
            16.072933,
            52.630377,
            91.008529
          ],
          [
            16.072957,
            52.630591,
            91.595304
          ],
          [
            16.072924,
            52.630797,
            92.083622
          ],
          [
            16.072949,
            52.631009,
            92.585195
          ],
          [
            16.072972,
            52.631235,
            93.119428
          ],
          [
            16.072969,
            52.631438,
            93.599818
          ],
          [
            16.072993,
            52.631621,
            94.033123
          ],
          [
            16.07299,
            52.631831,
            94.528603
          ],
          [
            16.073003,
            52.63203,
            94.998319
          ],
          [
            16.072999,
            52.632246,
            95.508928
          ],
          [
            16.073016,
            52.632521,
            95.418032
          ],
          [
            16.073085,
            52.632786,
            94.998231
          ],
          [
            16.073155,
            52.633039,
            94.596455
          ],
          [
            16.073195,
            52.633305,
            94.177332
          ],
          [
            16.073204,
            52.633657,
            93.626085
          ],
          [
            16.073265,
            52.63396,
            93.148262
          ],
          [
            16.073498,
            52.634221,
            92.237738
          ],
          [
            16.07367,
            52.634469,
            90.955794
          ],
          [
            16.073907,
            52.634711,
            89.614708
          ],
          [
            16.074099,
            52.634986,
            88.19419
          ],
          [
            16.074288,
            52.635272,
            86.72812
          ],
          [
            16.074569,
            52.635537,
            85.224865
          ],
          [
            16.074779,
            52.635794,
            84.192366
          ],
          [
            16.074993,
            52.636031,
            83.78804
          ],
          [
            16.075138,
            52.636253,
            83.430667
          ],
          [
            16.075367,
            52.636483,
            83.027989
          ],
          [
            16.075596,
            52.636754,
            82.571413
          ],
          [
            16.07577,
            52.636987,
            82.187808
          ],
          [
            16.076029,
            52.637254,
            81.724015
          ],
          [
            16.076262,
            52.637541,
            81.200956
          ],
          [
            16.07648,
            52.6378,
            80.717697
          ],
          [
            16.076655,
            52.63805,
            80.267161
          ],
          [
            16.07682,
            52.63825,
            79.896125
          ],
          [
            16.076933,
            52.638444,
            79.553244
          ],
          [
            16.077015,
            52.638674,
            79.162703
          ],
          [
            16.077142,
            52.638876,
            78.803709
          ],
          [
            16.077247,
            52.639124,
            78.809713
          ],
          [
            16.07736,
            52.639355,
            79.000828
          ],
          [
            16.077475,
            52.639593,
            79.197686
          ],
          [
            16.077555,
            52.639789,
            79.358357
          ],
          [
            16.077594,
            52.639976,
            79.507881
          ],
          [
            16.077587,
            52.640232,
            79.711272
          ],
          [
            16.077617,
            52.640474,
            79.904177
          ],
          [
            16.077656,
            52.640693,
            80.07889
          ],
          [
            16.077689,
            52.640921,
            79.686715
          ],
          [
            16.077765,
            52.641118,
            79.284314
          ],
          [
            16.07781,
            52.641339,
            78.841339
          ],
          [
            16.077878,
            52.641584,
            78.347255
          ],
          [
            16.077957,
            52.641824,
            77.860253
          ],
          [
            16.078044,
            52.642066,
            77.367614
          ],
          [
            16.078122,
            52.6423,
            76.892293
          ],
          [
            16.078195,
            52.64253,
            76.565513
          ],
          [
            16.078289,
            52.642742,
            76.77764
          ],
          [
            16.078356,
            52.642974,
            77.005286
          ],
          [
            16.078429,
            52.64319,
            77.218853
          ],
          [
            16.078488,
            52.643407,
            77.431333
          ],
          [
            16.078536,
            52.643627,
            77.645925
          ],
          [
            16.078603,
            52.643833,
            77.849126
          ],
          [
            16.078675,
            52.64404,
            78.053699
          ],
          [
            16.078725,
            52.644247,
            78.255829
          ],
          [
            16.078798,
            52.644453,
            77.948194
          ],
          [
            16.078869,
            52.644663,
            77.631088
          ],
          [
            16.07894,
            52.644859,
            77.334457
          ],
          [
            16.078998,
            52.645086,
            76.993919
          ],
          [
            16.07904,
            52.645332,
            76.628216
          ],
          [
            16.079075,
            52.645534,
            76.327908
          ],
          [
            16.079037,
            52.645721,
            76.046944
          ],
          [
            16.078951,
            52.645938,
            75.716941
          ],
          [
            16.078886,
            52.646159,
            75.519373
          ],
          [
            16.078828,
            52.64635,
            75.412931
          ],
          [
            16.078751,
            52.646569,
            75.290167
          ],
          [
            16.078671,
            52.646774,
            75.17478
          ],
          [
            16.078588,
            52.646976,
            75.060203
          ],
          [
            16.078502,
            52.647214,
            74.926694
          ],
          [
            16.078509,
            52.647473,
            74.783555
          ],
          [
            16.078609,
            52.647653,
            74.678246
          ],
          [
            16.078793,
            52.647822,
            74.631686
          ],
          [
            16.078943,
            52.648006,
            74.670834
          ],
          [
            16.079021,
            52.648199,
            74.70862
          ],
          [
            16.079057,
            52.648418,
            74.750628
          ],
          [
            16.079148,
            52.648626,
            74.791608
          ],
          [
            16.079292,
            52.648808,
            74.830027
          ],
          [
            16.079477,
            52.648976,
            74.86851
          ],
          [
            16.079637,
            52.649163,
            74.908685
          ],
          [
            16.079809,
            52.64933,
            74.946148
          ],
          [
            16.079894,
            52.649532,
            74.970041
          ],
          [
            16.079864,
            52.649724,
            74.98724
          ],
          [
            16.079847,
            52.649914,
            75.004116
          ],
          [
            16.079843,
            52.650119,
            75.022297
          ],
          [
            16.079828,
            52.650305,
            75.038813
          ],
          [
            16.0798,
            52.650489,
            75.055261
          ],
          [
            16.079844,
            52.650281,
            75.073885
          ],
          [
            16.080144,
            52.650254,
            75.090676
          ],
          [
            16.080409,
            52.650209,
            75.107242
          ],
          [
            16.080472,
            52.65001,
            75.087338
          ],
          [
            16.080515,
            52.649809,
            75.035028
          ],
          [
            16.080692,
            52.649694,
            74.984467
          ],
          [
            16.080974,
            52.649813,
            74.930684
          ],
          [
            16.081185,
            52.64976,
            74.87683
          ],
          [
            16.08135,
            52.649605,
            74.826241
          ],
          [
            16.081618,
            52.649699,
            74.777771
          ],
          [
            16.081794,
            52.649742,
            74.738241
          ],
          [
            16.081999,
            52.649878,
            74.690678
          ],
          [
            16.08222,
            52.650003,
            74.647048
          ],
          [
            16.082485,
            52.649893,
            74.6214
          ],
          [
            16.082729,
            52.64976,
            74.595257
          ],
          [
            16.082947,
            52.649591,
            74.566921
          ],
          [
            16.083011,
            52.649397,
            74.540238
          ],
          [
            16.083072,
            52.649203,
            74.514139
          ],
          [
            16.083209,
            52.649017,
            74.487396
          ],
          [
            16.083335,
            52.64882,
            74.459634
          ],
          [
            16.083537,
            52.648656,
            74.432344
          ],
          [
            16.083733,
            52.648477,
            74.679124
          ],
          [
            16.083883,
            52.648278,
            75.330043
          ],
          [
            16.084036,
            52.648071,
            76.006443
          ],
          [
            16.08416,
            52.647879,
            76.620603
          ],
          [
            16.084307,
            52.647686,
            77.255213
          ],
          [
            16.084477,
            52.647476,
            77.955393
          ],
          [
            16.084632,
            52.647287,
            78.587618
          ],
          [
            16.084794,
            52.647082,
            79.26393
          ],
          [
            16.085001,
            52.646919,
            79.711282
          ],
          [
            16.085342,
            52.646968,
            79.424487
          ],
          [
            16.085656,
            52.647041,
            79.151403
          ],
          [
            16.085968,
            52.647008,
            78.865236
          ],
          [
            16.086147,
            52.646797,
            78.547639
          ],
          [
            16.086001,
            52.646627,
            78.261352
          ],
          [
            16.085879,
            52.646457,
            77.987145
          ],
          [
            16.086192,
            52.646358,
            77.688605
          ],
          [
            16.086224,
            52.646346,
            77.423928
          ],
          [
            16.086067,
            52.646414,
            77.594032
          ],
          [
            16.086029,
            52.646585,
            77.927828
          ],
          [
            16.08619,
            52.646749,
            78.259673
          ],
          [
            16.086096,
            52.646944,
            78.606305
          ],
          [
            16.086055,
            52.647132,
            78.946949
          ],
          [
            16.08639,
            52.647187,
            79.307118
          ],
          [
            16.086716,
            52.647271,
            79.673476
          ],
          [
            16.086991,
            52.647355,
            79.992983
          ],
          [
            16.087283,
            52.647459,
            80.343452
          ],
          [
            16.087606,
            52.647544,
            80.384927
          ],
          [
            16.087897,
            52.647644,
            80.339514
          ],
          [
            16.088175,
            52.647748,
            80.295197
          ],
          [
            16.08851,
            52.647806,
            80.247831
          ],
          [
            16.088815,
            52.647869,
            80.204089
          ],
          [
            16.089115,
            52.647964,
            80.158186
          ],
          [
            16.089443,
            52.648071,
            80.10766
          ],
          [
            16.089717,
            52.64815,
            80.066508
          ],
          [
            16.089994,
            52.648255,
            80.02178
          ],
          [
            16.090332,
            52.648345,
            79.8367
          ],
          [
            16.090644,
            52.648451,
            79.653683
          ],
          [
            16.090953,
            52.64854,
            79.478606
          ],
          [
            16.091284,
            52.648681,
            79.271346
          ],
          [
            16.091579,
            52.648768,
            79.103505
          ],
          [
            16.0919,
            52.648856,
            78.923266
          ],
          [
            16.092192,
            52.648976,
            78.742786
          ],
          [
            16.092487,
            52.649069,
            78.572578
          ],
          [
            16.092766,
            52.649161,
            78.578655
          ],
          [
            16.092979,
            52.649324,
            78.720392
          ],
          [
            16.093255,
            52.64944,
            78.859427
          ],
          [
            16.093623,
            52.649549,
            79.028687
          ],
          [
            16.093959,
            52.649681,
            79.19469
          ],
          [
            16.094281,
            52.649794,
            79.348956
          ],
          [
            16.094647,
            52.649925,
            79.524586
          ],
          [
            16.094948,
            52.650063,
            79.680788
          ],
          [
            16.095191,
            52.650208,
            79.946862
          ],
          [
            16.095514,
            52.650325,
            80.302519
          ],
          [
            16.095858,
            52.650453,
            80.684031
          ],
          [
            16.096202,
            52.650559,
            81.048948
          ],
          [
            16.096529,
            52.650672,
            81.405236
          ],
          [
            16.096791,
            52.650789,
            81.712974
          ],
          [
            16.097131,
            52.650825,
            82.039306
          ],
          [
            16.097485,
            52.650942,
            82.420714
          ],
          [
            16.097743,
            52.651046,
            82.537523
          ],
          [
            16.097989,
            52.651161,
            82.547438
          ],
          [
            16.098285,
            52.65125,
            82.557985
          ],
          [
            16.098609,
            52.651367,
            82.570029
          ],
          [
            16.098887,
            52.651461,
            82.58019
          ],
          [
            16.099178,
            52.651546,
            82.59063
          ],
          [
            16.09945,
            52.651655,
            82.601056
          ],
          [
            16.099737,
            52.651737,
            82.611184
          ],
          [
            16.100007,
            52.651846,
            82.62154
          ],
          [
            16.100269,
            52.651956,
            82.483487
          ],
          [
            16.100556,
            52.652055,
            82.219156
          ],
          [
            16.100838,
            52.652153,
            81.959799
          ],
          [
            16.10114,
            52.65226,
            81.681217
          ],
          [
            16.101435,
            52.652359,
            81.412576
          ],
          [
            16.101736,
            52.652449,
            81.141416
          ],
          [
            16.102059,
            52.652575,
            80.835206
          ],
          [
            16.102404,
            52.652716,
            80.503603
          ],
          [
            16.102767,
            52.652849,
            79.969781
          ],
          [
            16.103188,
            52.652992,
            78.819988
          ],
          [
            16.103551,
            52.653125,
            77.806877
          ],
          [
            16.10393,
            52.653244,
            76.789269
          ],
          [
            16.10435,
            52.653365,
            75.68059
          ],
          [
            16.104795,
            52.653522,
            74.455873
          ],
          [
            16.105141,
            52.653662,
            73.46363
          ],
          [
            16.105535,
            52.653812,
            73.420018
          ],
          [
            16.105876,
            52.653939,
            73.647389
          ],
          [
            16.106195,
            52.654055,
            73.858684
          ],
          [
            16.106503,
            52.654169,
            74.06366
          ],
          [
            16.106848,
            52.654269,
            74.28113
          ],
          [
            16.107179,
            52.654386,
            74.498884
          ],
          [
            16.107501,
            52.65451,
            74.715656
          ],
          [
            16.10783,
            52.654636,
            74.946951
          ],
          [
            16.108151,
            52.654746,
            75.213426
          ],
          [
            16.108468,
            52.654876,
            75.489861
          ],
          [
            16.10878,
            52.65499,
            75.753106
          ],
          [
            16.109095,
            52.655094,
            76.01224
          ],
          [
            16.109425,
            52.655173,
            76.268789
          ],
          [
            16.109743,
            52.655243,
            76.513181
          ],
          [
            16.110054,
            52.655277,
            76.741484
          ],
          [
            16.110364,
            52.655283,
            76.965663
          ],
          [
            16.110694,
            52.6553,
            77.326983
          ],
          [
            16.111017,
            52.655325,
            77.73797
          ],
          [
            16.111335,
            52.655336,
            78.140026
          ],
          [
            16.111693,
            52.655305,
            78.613339
          ],
          [
            16.111837,
            52.65511,
            79.068078
          ],
          [
            16.111941,
            52.65489,
            79.544252
          ],
          [
            16.112137,
            52.654704,
            80.00516
          ],
          [
            16.112317,
            52.654507,
            80.473804
          ],
          [
            16.112492,
            52.654348,
            80.659031
          ],
          [
            16.112677,
            52.654191,
            80.090416
          ],
          [
            16.112844,
            52.654009,
            79.476769
          ],
          [
            16.113124,
            52.653888,
            78.848324
          ],
          [
            16.113422,
            52.653959,
            78.275888
          ],
          [
            16.11378,
            52.654017,
            77.61373
          ],
          [
            16.114114,
            52.654049,
            77.008933
          ],
          [
            16.114412,
            52.654057,
            76.475918
          ],
          [
            16.114816,
            52.654065,
            75.752709
          ],
          [
            16.115192,
            52.654052,
            75.688972
          ],
          [
            16.115584,
            52.654004,
            76.045024
          ],
          [
            16.115884,
            52.653969,
            76.317626
          ],
          [
            16.116246,
            52.653954,
            76.64135
          ],
          [
            16.116601,
            52.653942,
            76.958394
          ],
          [
            16.116968,
            52.653919,
            77.286903
          ],
          [
            16.117322,
            52.653872,
            77.609617
          ],
          [
            16.117682,
            52.653829,
            77.937334
          ],
          [
            16.118003,
            52.653841,
            78.128245
          ],
          [
            16.118308,
            52.653868,
            78.135981
          ],
          [
            16.118614,
            52.653888,
            78.1437
          ],
          [
            16.119034,
            52.653887,
            78.154236
          ],
          [
            16.119371,
            52.653829,
            78.163009
          ],
          [
            16.119648,
            52.653744,
            78.170785
          ],
          [
            16.119955,
            52.653643,
            78.179552
          ],
          [
            16.120251,
            52.653505,
            78.188903
          ],
          [
            16.120561,
            52.653382,
            78.198182
          ],
          [
            16.120895,
            52.653285,
            78.463211
          ],
          [
            16.121147,
            52.653179,
            78.723803
          ],
          [
            16.121395,
            52.653065,
            78.988503
          ],
          [
            16.121693,
            52.652962,
            79.280135
          ],
          [
            16.12198,
            52.652841,
            79.577062
          ],
          [
            16.122298,
            52.652704,
            79.908442
          ],
          [
            16.122548,
            52.652595,
            80.1718
          ],
          [
            16.122854,
            52.652502,
            80.462561
          ],
          [
            16.123177,
            52.652414,
            80.751266
          ],
          [
            16.123474,
            52.652307,
            80.962011
          ],
          [
            16.123756,
            52.652183,
            81.174483
          ],
          [
            16.124033,
            52.652074,
            81.376056
          ],
          [
            16.12432,
            52.651938,
            81.598786
          ],
          [
            16.124612,
            52.651812,
            81.817486
          ],
          [
            16.124886,
            52.651691,
            82.025414
          ],
          [
            16.125194,
            52.65158,
            82.244762
          ],
          [
            16.125474,
            52.651469,
            82.448933
          ],
          [
            16.125771,
            52.651378,
            82.792162
          ],
          [
            16.126083,
            52.65129,
            83.237297
          ],
          [
            16.126375,
            52.651163,
            83.704014
          ],
          [
            16.126631,
            52.651051,
            84.121833
          ],
          [
            16.126917,
            52.650931,
            84.570886
          ],
          [
            16.12722,
            52.650836,
            85.011197
          ],
          [
            16.127493,
            52.650727,
            85.435865
          ],
          [
            16.12781,
            52.650637,
            85.887732
          ],
          [
            16.128163,
            52.650584,
            86.368313
          ],
          [
            16.128484,
            52.650516,
            87.405832
          ],
          [
            16.128813,
            52.650489,
            88.416566
          ],
          [
            16.129152,
            52.650438,
            89.47881
          ],
          [
            16.129476,
            52.650397,
            90.485831
          ],
          [
            16.129825,
            52.650363,
            91.563062
          ],
          [
            16.13015,
            52.650328,
            92.566852
          ],
          [
            16.130455,
            52.650292,
            93.511997
          ],
          [
            16.13077,
            52.650258,
            94.484935
          ],
          [
            16.131096,
            52.650221,
            95.397031
          ],
          [
            16.131403,
            52.650147,
            95.615949
          ],
          [
            16.13169,
            52.65006,
            95.829137
          ],
          [
            16.131986,
            52.64997,
            96.04855
          ],
          [
            16.132276,
            52.649869,
            96.270022
          ],
          [
            16.132548,
            52.649766,
            96.483975
          ],
          [
            16.132947,
            52.649673,
            96.767116
          ],
          [
            16.133259,
            52.649588,
            96.994359
          ],
          [
            16.133593,
            52.649516,
            97.229913
          ],
          [
            16.133963,
            52.649445,
            97.42408
          ],
          [
            16.134267,
            52.649379,
            97.550507
          ],
          [
            16.134586,
            52.649347,
            97.677085
          ],
          [
            16.134933,
            52.64929,
            97.817936
          ],
          [
            16.135283,
            52.649218,
            97.962979
          ],
          [
            16.135606,
            52.649146,
            98.097737
          ],
          [
            16.135939,
            52.649071,
            98.236988
          ],
          [
            16.136282,
            52.649001,
            98.379239
          ],
          [
            16.136645,
            52.648934,
            98.424666
          ],
          [
            16.13695,
            52.648855,
            98.160434
          ],
          [
            16.1373,
            52.648783,
            97.865442
          ],
          [
            16.137617,
            52.648674,
            97.575223
          ],
          [
            16.137954,
            52.648591,
            97.28554
          ],
          [
            16.138321,
            52.648501,
            96.969025
          ],
          [
            16.13871,
            52.648428,
            96.643385
          ],
          [
            16.139081,
            52.648311,
            96.310118
          ],
          [
            16.139416,
            52.648235,
            96.177758
          ],
          [
            16.139753,
            52.64815,
            96.299374
          ],
          [
            16.140082,
            52.648067,
            96.418259
          ],
          [
            16.140428,
            52.648,
            96.5392
          ],
          [
            16.140818,
            52.647923,
            96.675931
          ],
          [
            16.141124,
            52.647858,
            96.788206
          ],
          [
            16.141455,
            52.64777,
            96.909055
          ],
          [
            16.141812,
            52.647676,
            97.038827
          ],
          [
            16.142149,
            52.647597,
            97.239906
          ],
          [
            16.142517,
            52.64752,
            97.637447
          ],
          [
            16.142849,
            52.647447,
            97.996873
          ],
          [
            16.143147,
            52.64736,
            98.33886
          ],
          [
            16.143443,
            52.647289,
            98.66233
          ],
          [
            16.143734,
            52.647215,
            98.98274
          ],
          [
            16.144044,
            52.647141,
            99.320982
          ],
          [
            16.144366,
            52.647073,
            99.667127
          ],
          [
            16.144652,
            52.646994,
            99.98655
          ],
          [
            16.144927,
            52.646917,
            100.092675
          ],
          [
            16.145221,
            52.646861,
            100.023279
          ],
          [
            16.145519,
            52.646791,
            99.951426
          ],
          [
            16.145822,
            52.646728,
            99.879482
          ],
          [
            16.146128,
            52.646645,
            99.804187
          ],
          [
            16.146421,
            52.646561,
            99.731306
          ],
          [
            16.146724,
            52.64649,
            99.658255
          ],
          [
            16.147057,
            52.646426,
            99.579719
          ],
          [
            16.147389,
            52.646338,
            99.498368
          ],
          [
            16.147772,
            52.646251,
            99.607372
          ],
          [
            16.148155,
            52.646161,
            99.839438
          ],
          [
            16.148517,
            52.646085,
            100.055802
          ],
          [
            16.148828,
            52.646016,
            100.24281
          ],
          [
            16.14914,
            52.645943,
            100.432356
          ],
          [
            16.14947,
            52.645855,
            100.635894
          ],
          [
            16.149773,
            52.645786,
            100.818637
          ],
          [
            16.150041,
            52.645701,
            100.989718
          ],
          [
            16.15034,
            52.645624,
            101.098585
          ],
          [
            16.150664,
            52.645562,
            100.88856
          ],
          [
            16.151006,
            52.645476,
            100.659714
          ],
          [
            16.151312,
            52.645389,
            100.450522
          ],
          [
            16.151632,
            52.645301,
            100.233245
          ],
          [
            16.151932,
            52.645234,
            100.035506
          ],
          [
            16.152251,
            52.645188,
            99.832744
          ],
          [
            16.152559,
            52.645095,
            99.619767
          ],
          [
            16.152883,
            52.645036,
            99.410639
          ],
          [
            16.15318,
            52.644954,
            99.209846
          ],
          [
            16.15353,
            52.644881,
            98.982895
          ],
          [
            16.153821,
            52.64481,
            98.790749
          ],
          [
            16.154104,
            52.644728,
            98.59896
          ],
          [
            16.154393,
            52.644646,
            98.403419
          ],
          [
            16.154696,
            52.644588,
            98.207051
          ],
          [
            16.155054,
            52.644508,
            97.973706
          ],
          [
            16.15536,
            52.644431,
            97.770667
          ],
          [
            16.155677,
            52.64435,
            97.560177
          ],
          [
            16.156028,
            52.644265,
            97.568703
          ],
          [
            16.156352,
            52.644195,
            97.667652
          ],
          [
            16.1567,
            52.644129,
            97.772176
          ],
          [
            16.157027,
            52.644043,
            97.874311
          ],
          [
            16.157339,
            52.643958,
            97.972326
          ],
          [
            16.157683,
            52.643894,
            98.075441
          ],
          [
            16.158032,
            52.643833,
            98.179534
          ],
          [
            16.158387,
            52.643753,
            98.288098
          ],
          [
            16.158735,
            52.64364,
            98.158243
          ],
          [
            16.159098,
            52.643536,
            97.803969
          ],
          [
            16.159531,
            52.643428,
            97.391051
          ],
          [
            16.159825,
            52.643359,
            97.113043
          ],
          [
            16.160152,
            52.643262,
            96.791719
          ],
          [
            16.160501,
            52.643196,
            96.469215
          ],
          [
            16.160839,
            52.643123,
            96.152792
          ],
          [
            16.161133,
            52.643057,
            95.876088
          ],
          [
            16.161474,
            52.642973,
            95.292867
          ],
          [
            16.161833,
            52.642892,
            94.459824
          ],
          [
            16.162232,
            52.642799,
            93.530187
          ],
          [
            16.162647,
            52.642706,
            92.568011
          ],
          [
            16.163075,
            52.642603,
            91.566628
          ],
          [
            16.163513,
            52.642496,
            90.53968
          ],
          [
            16.163923,
            52.642388,
            89.567555
          ],
          [
            16.164321,
            52.642281,
            88.777798
          ],
          [
            16.164735,
            52.642191,
            88.049356
          ],
          [
            16.165154,
            52.642105,
            87.317156
          ],
          [
            16.16554,
            52.642015,
            86.632745
          ],
          [
            16.165898,
            52.641926,
            85.99231
          ],
          [
            16.166241,
            52.64185,
            85.387668
          ],
          [
            16.166535,
            52.641784,
            84.868784
          ],
          [
            16.166876,
            52.641673,
            84.344074
          ],
          [
            16.167182,
            52.641568,
            84.221637
          ],
          [
            16.167554,
            52.641485,
            84.083767
          ],
          [
            16.167915,
            52.641406,
            83.950246
          ],
          [
            16.168298,
            52.641318,
            83.807482
          ],
          [
            16.168672,
            52.641233,
            83.668544
          ],
          [
            16.168997,
            52.641165,
            83.548624
          ],
          [
            16.169325,
            52.64108,
            83.424527
          ],
          [
            16.169671,
            52.641001,
            83.348033
          ],
          [
            16.170062,
            52.640924,
            83.360346
          ],
          [
            16.170424,
            52.640843,
            83.371904
          ],
          [
            16.170763,
            52.640756,
            83.38293
          ],
          [
            16.17107,
            52.640669,
            83.393076
          ],
          [
            16.171385,
            52.640592,
            83.403245
          ],
          [
            16.171713,
            52.640527,
            83.41358
          ],
          [
            16.172005,
            52.640469,
            83.422817
          ],
          [
            16.172329,
            52.640385,
            83.424851
          ],
          [
            16.172652,
            52.640266,
            83.301402
          ],
          [
            16.172881,
            52.64014,
            83.201129
          ],
          [
            16.173078,
            52.63997,
            83.089413
          ],
          [
            16.17324,
            52.639752,
            82.961537
          ],
          [
            16.173469,
            52.639569,
            82.838362
          ],
          [
            16.173747,
            52.639456,
            82.729835
          ],
          [
            16.174073,
            52.639359,
            82.612028
          ],
          [
            16.174376,
            52.639286,
            82.505455
          ],
          [
            16.174694,
            52.639235,
            82.87015
          ],
          [
            16.174992,
            52.639277,
            83.415885
          ],
          [
            16.175297,
            52.639335,
            83.986231
          ],
          [
            16.175619,
            52.639382,
            84.576953
          ],
          [
            16.175931,
            52.639452,
            85.171443
          ],
          [
            16.17624,
            52.639517,
            85.754776
          ],
          [
            16.176546,
            52.639563,
            86.317065
          ],
          [
            16.176847,
            52.63962,
            86.880711
          ],
          [
            16.177161,
            52.639656,
            87.4564
          ],
          [
            16.177476,
            52.639687,
            88.080749
          ],
          [
            16.177802,
            52.63973,
            88.79986
          ],
          [
            16.17812,
            52.63978,
            89.514847
          ],
          [
            16.178444,
            52.639764,
            90.222523
          ],
          [
            16.178739,
            52.639684,
            90.919257
          ],
          [
            16.179024,
            52.639628,
            91.564371
          ],
          [
            16.179342,
            52.639556,
            92.294348
          ],
          [
            16.179636,
            52.639489,
            92.970743
          ],
          [
            16.179961,
            52.639427,
            93.704624
          ],
          [
            16.180255,
            52.639388,
            94.103163
          ],
          [
            16.180596,
            52.639334,
            94.015664
          ],
          [
            16.181009,
            52.639233,
            93.905142
          ],
          [
            16.181367,
            52.639163,
            93.811792
          ],
          [
            16.181735,
            52.639075,
            93.713627
          ],
          [
            16.182063,
            52.638994,
            93.625763
          ],
          [
            16.182425,
            52.638908,
            93.529272
          ],
          [
            16.182768,
            52.638834,
            93.438902
          ],
          [
            16.183091,
            52.638757,
            93.304333
          ],
          [
            16.183457,
            52.638685,
            93.094959
          ],
          [
            16.183816,
            52.638616,
            92.889699
          ],
          [
            16.184093,
            52.638554,
            92.728098
          ],
          [
            16.184424,
            52.638476,
            92.535105
          ],
          [
            16.184784,
            52.638413,
            92.331406
          ],
          [
            16.185157,
            52.638338,
            92.117866
          ],
          [
            16.18554,
            52.638243,
            91.892893
          ],
          [
            16.185916,
            52.638136,
            92.085494
          ],
          [
            16.186273,
            52.638061,
            92.621631
          ],
          [
            16.186563,
            52.638002,
            93.054901
          ],
          [
            16.186912,
            52.637918,
            93.586689
          ],
          [
            16.187241,
            52.637867,
            94.067711
          ],
          [
            16.187556,
            52.637791,
            94.548037
          ],
          [
            16.187852,
            52.637698,
            95.023299
          ],
          [
            16.188177,
            52.637633,
            95.508064
          ],
          [
            16.188486,
            52.637555,
            95.981877
          ],
          [
            16.18879,
            52.637502,
            96.251284
          ],
          [
            16.189106,
            52.637416,
            96.546238
          ],
          [
            16.189414,
            52.637339,
            96.829954
          ],
          [
            16.189737,
            52.637268,
            97.122527
          ],
          [
            16.190071,
            52.637213,
            97.417956
          ],
          [
            16.190378,
            52.637115,
            97.713844
          ],
          [
            16.190669,
            52.637049,
            97.979225
          ],
          [
            16.190966,
            52.636998,
            98.242145
          ],
          [
            16.19127,
            52.636939,
            98.524332
          ],
          [
            16.191579,
            52.636871,
            99.092309
          ],
          [
            16.191939,
            52.636806,
            99.741076
          ],
          [
            16.192242,
            52.636763,
            100.27831
          ],
          [
            16.192519,
            52.636682,
            100.80949
          ],
          [
            16.192844,
            52.636617,
            101.400676
          ],
          [
            16.193203,
            52.636532,
            102.089124
          ],
          [
            16.193521,
            52.636477,
            102.66006
          ],
          [
            16.193843,
            52.63641,
            103.248398
          ],
          [
            16.194147,
            52.636327,
            103.569041
          ],
          [
            16.194483,
            52.636251,
            103.410924
          ],
          [
            16.194801,
            52.636168,
            103.258283
          ],
          [
            16.19513,
            52.636089,
            103.101938
          ],
          [
            16.195454,
            52.636031,
            102.952897
          ],
          [
            16.195757,
            52.635954,
            102.808043
          ],
          [
            16.196089,
            52.635907,
            102.657327
          ],
          [
            16.196422,
            52.635841,
            102.501927
          ],
          [
            16.196721,
            52.635777,
            102.361148
          ],
          [
            16.197021,
            52.635677,
            102.427307
          ],
          [
            16.197345,
            52.6356,
            102.594293
          ],
          [
            16.197653,
            52.635554,
            102.746503
          ],
          [
            16.198004,
            52.635487,
            102.923183
          ],
          [
            16.198341,
            52.635406,
            103.097144
          ],
          [
            16.198648,
            52.635346,
            103.252946
          ],
          [
            16.198973,
            52.635259,
            103.423708
          ],
          [
            16.199305,
            52.635185,
            103.593479
          ],
          [
            16.199677,
            52.635109,
            103.634956
          ],
          [
            16.199997,
            52.635045,
            103.275465
          ],
          [
            16.200334,
            52.634981,
            102.897981
          ],
          [
            16.200684,
            52.634894,
            102.494587
          ],
          [
            16.201058,
            52.634812,
            102.070462
          ],
          [
            16.201446,
            52.63473,
            101.632211
          ],
          [
            16.201795,
            52.634654,
            101.236181
          ],
          [
            16.202148,
            52.634583,
            100.839546
          ],
          [
            16.202492,
            52.634502,
            100.328356
          ],
          [
            16.202798,
            52.634434,
            99.674641
          ],
          [
            16.203126,
            52.634376,
            98.994772
          ],
          [
            16.20345,
            52.634284,
            98.282501
          ],
          [
            16.203792,
            52.634201,
            97.549461
          ],
          [
            16.204121,
            52.634116,
            96.838011
          ],
          [
            16.204478,
            52.634046,
            96.091488
          ],
          [
            16.204847,
            52.633958,
            95.301453
          ],
          [
            16.205227,
            52.633883,
            94.615118
          ],
          [
            16.205584,
            52.633805,
            94.336725
          ],
          [
            16.205927,
            52.633714,
            94.062128
          ],
          [
            16.206286,
            52.633646,
            93.786143
          ],
          [
            16.206627,
            52.633574,
            93.51937
          ],
          [
            16.206978,
            52.633513,
            93.251547
          ],
          [
            16.207297,
            52.63343,
            92.996633
          ],
          [
            16.207618,
            52.633346,
            92.740041
          ],
          [
            16.207952,
            52.633276,
            92.467132
          ],
          [
            16.208249,
            52.633202,
            92.097196
          ],
          [
            16.208572,
            52.63313,
            91.701025
          ],
          [
            16.208955,
            52.633059,
            91.239938
          ],
          [
            16.209311,
            52.632986,
            90.807243
          ],
          [
            16.209669,
            52.632904,
            90.366058
          ],
          [
            16.210041,
            52.632819,
            89.908478
          ],
          [
            16.21043,
            52.632742,
            89.437443
          ],
          [
            16.210815,
            52.632649,
            89.187838
          ],
          [
            16.21116,
            52.632583,
            89.484072
          ],
          [
            16.211536,
            52.632512,
            89.806565
          ],
          [
            16.211902,
            52.63245,
            90.117752
          ],
          [
            16.212242,
            52.632361,
            90.421377
          ],
          [
            16.212615,
            52.632289,
            90.742454
          ],
          [
            16.212969,
            52.632207,
            91.053002
          ],
          [
            16.213294,
            52.63212,
            91.343899
          ],
          [
            16.213622,
            52.632042,
            91.446399
          ],
          [
            16.213913,
            52.63194,
            91.264592
          ],
          [
            16.213856,
            52.631725,
            91.064098
          ],
          [
            16.213697,
            52.6315,
            90.845774
          ],
          [
            16.213518,
            52.631309,
            90.650312
          ],
          [
            16.213278,
            52.631135,
            90.448757
          ],
          [
            16.213016,
            52.630962,
            90.240033
          ],
          [
            16.21274,
            52.630792,
            90.028071
          ],
          [
            16.212497,
            52.630617,
            89.826096
          ],
          [
            16.212284,
            52.630427,
            89.62355
          ],
          [
            16.212133,
            52.630249,
            89.447852
          ],
          [
            16.212012,
            52.63007,
            89.278038
          ],
          [
            16.211901,
            52.629867,
            89.090434
          ],
          [
            16.21183,
            52.629666,
            88.910065
          ],
          [
            16.211812,
            52.629475,
            88.742369
          ],
          [
            16.211811,
            52.629265,
            88.558128
          ],
          [
            16.211781,
            52.629053,
            88.371623
          ],
          [
            16.211748,
            52.628858,
            87.810637
          ],
          [
            16.211428,
            52.628811,
            87.166401
          ],
          [
            16.2111,
            52.628811,
            86.528779
          ],
          [
            16.210869,
            52.628693,
            85.891109
          ],
          [
            16.210891,
            52.628478,
            85.200442
          ],
          [
            16.211025,
            52.628305,
            84.530993
          ],
          [
            16.211294,
            52.628245,
            83.918675
          ],
          [
            16.211566,
            52.628191,
            83.330718
          ],
          [
            16.211289,
            52.628049,
            82.62761
          ],
          [
            16.211037,
            52.627868,
            82.25298
          ],
          [
            16.210827,
            52.627663,
            81.884468
          ],
          [
            16.210797,
            52.62743,
            81.528337
          ],
          [
            16.210912,
            52.627201,
            81.164619
          ],
          [
            16.21106,
            52.627003,
            80.83464
          ],
          [
            16.211164,
            52.626796,
            80.504383
          ],
          [
            16.211251,
            52.626603,
            80.200678
          ],
          [
            16.211302,
            52.626397,
            79.883922
          ],
          [
            16.211359,
            52.626178,
            80.263166
          ],
          [
            16.21136,
            52.625954,
            80.676367
          ],
          [
            16.21133,
            52.625744,
            81.065403
          ],
          [
            16.211283,
            52.62553,
            81.463557
          ],
          [
            16.211218,
            52.625327,
            81.845287
          ],
          [
            16.211119,
            52.625129,
            82.227066
          ],
          [
            16.210981,
            52.624927,
            82.630472
          ],
          [
            16.210872,
            52.624747,
            82.988541
          ],
          [
            16.210658,
            52.624566,
            83.189468
          ],
          [
            16.210431,
            52.624396,
            83.194376
          ],
          [
            16.210215,
            52.624246,
            83.19885
          ],
          [
            16.209988,
            52.624096,
            83.203421
          ],
          [
            16.20975,
            52.623935,
            83.208275
          ],
          [
            16.209431,
            52.623804,
            83.213533
          ],
          [
            16.209133,
            52.623708,
            83.218127
          ],
          [
            16.208834,
            52.623606,
            83.222799
          ],
          [
            16.208605,
            52.623488,
            83.226943
          ],
          [
            16.20842,
            52.623303,
            83.18204
          ],
          [
            16.208304,
            52.62313,
            83.141304
          ],
          [
            16.208211,
            52.622931,
            83.096208
          ],
          [
            16.20811,
            52.622729,
            83.050131
          ],
          [
            16.20797,
            52.622531,
            83.003141
          ],
          [
            16.207783,
            52.622316,
            82.9501
          ],
          [
            16.207596,
            52.62211,
            82.898803
          ],
          [
            16.207451,
            52.621927,
            82.854479
          ],
          [
            16.207333,
            52.621756,
            83.170104
          ],
          [
            16.207202,
            52.621592,
            83.802868
          ],
          [
            16.207063,
            52.621427,
            84.446363
          ],
          [
            16.206906,
            52.621255,
            85.129069
          ],
          [
            16.206746,
            52.621074,
            85.844734
          ],
          [
            16.206715,
            52.62089,
            86.498245
          ],
          [
            16.206729,
            52.620683,
            87.21761
          ],
          [
            16.206731,
            52.620474,
            87.943465
          ],
          [
            16.206717,
            52.62026,
            88.687071
          ],
          [
            16.206725,
            52.620079,
            89.301634
          ],
          [
            16.20676,
            52.619789,
            90.239561
          ],
          [
            16.206706,
            52.619592,
            90.886378
          ],
          [
            16.206639,
            52.619403,
            91.508036
          ],
          [
            16.206606,
            52.619204,
            92.151178
          ],
          [
            16.206586,
            52.618988,
            92.84693
          ],
          [
            16.206541,
            52.61877,
            93.553685
          ],
          [
            16.206529,
            52.618551,
            94.258903
          ],
          [
            16.206478,
            52.618355,
            94.874894
          ],
          [
            16.20644,
            52.618171,
            95.109955
          ],
          [
            16.206426,
            52.617971,
            95.363994
          ],
          [
            16.206397,
            52.617756,
            95.637632
          ],
          [
            16.206366,
            52.617563,
            95.883413
          ],
          [
            16.206343,
            52.61736,
            96.141304
          ],
          [
            16.206302,
            52.617166,
            96.389309
          ],
          [
            16.206267,
            52.616944,
            96.672042
          ],
          [
            16.206235,
            52.616731,
            96.945194
          ],
          [
            16.206163,
            52.616522,
            96.973716
          ],
          [
            16.206115,
            52.616317,
            96.404134
          ],
          [
            16.206135,
            52.616125,
            95.872621
          ],
          [
            16.20609,
            52.615924,
            95.314602
          ],
          [
            16.206095,
            52.615669,
            94.61275
          ],
          [
            16.206076,
            52.615433,
            93.962811
          ],
          [
            16.20601,
            52.615222,
            93.372033
          ],
          [
            16.206286,
            52.615304,
            92.82137
          ],
          [
            16.206607,
            52.61538,
            92.238903
          ],
          [
            16.206937,
            52.615428,
            90.787251
          ],
          [
            16.207277,
            52.615434,
            89.245281
          ],
          [
            16.207607,
            52.615376,
            87.666737
          ],
          [
            16.207892,
            52.615264,
            86.128313
          ],
          [
            16.208147,
            52.615163,
            84.753854
          ],
          [
            16.208402,
            52.61504,
            83.279008
          ],
          [
            16.208327,
            52.614775,
            81.231787
          ],
          [
            16.208139,
            52.614532,
            79.235512
          ],
          [
            16.208046,
            52.614341,
            78.821761
          ],
          [
            16.208042,
            52.614537,
            78.798473
          ],
          [
            16.207977,
            52.614727,
            78.775539
          ],
          [
            16.20825,
            52.614796,
            78.75336
          ],
          [
            16.208434,
            52.614657,
            78.731716
          ],
          [
            16.208375,
            52.614831,
            78.710181
          ],
          [
            16.208469,
            52.615041,
            78.68408
          ],
          [
            16.208436,
            52.615034,
            78.662235
          ],
          [
            16.208666,
            52.615158,
            78.63989
          ],
          [
            16.208827,
            52.615397,
            79.965984
          ],
          [
            16.20895,
            52.61557,
            81.610406
          ],
          [
            16.20906,
            52.615735,
            83.180328
          ],
          [
            16.208862,
            52.615598,
            84.787088
          ],
          [
            16.208477,
            52.615649,
            86.873977
          ],
          [
            16.20819,
            52.615706,
            88.457548
          ],
          [
            16.207947,
            52.615819,
            90.061625
          ],
          [
            16.207662,
            52.615889,
            91.672857
          ],
          [
            16.207375,
            52.615835,
            93.271531
          ],
          [
            16.207129,
            52.615722,
            93.981755
          ],
          [
            16.206846,
            52.61565,
            93.621202
          ],
          [
            16.206517,
            52.615688,
            93.243692
          ],
          [
            16.206233,
            52.615762,
            92.898202
          ],
          [
            16.206058,
            52.615601,
            92.536168
          ],
          [
            16.206037,
            52.615417,
            92.195571
          ],
          [
            16.206095,
            52.615235,
            91.841099
          ],
          [
            16.206379,
            52.615395,
            91.40765
          ],
          [
            16.206682,
            52.615425,
            91.061041
          ],
          [
            16.206984,
            52.615442,
            90.678538
          ],
          [
            16.207001,
            52.615445,
            90.169784
          ],
          [
            16.207072,
            52.615239,
            89.633982
          ],
          [
            16.207268,
            52.615093,
            89.159312
          ],
          [
            16.207341,
            52.615144,
            88.661971
          ],
          [
            16.20723,
            52.61532,
            88.177304
          ],
          [
            16.207318,
            52.615458,
            87.689573
          ],
          [
            16.207598,
            52.615386,
            87.224636
          ],
          [
            16.207911,
            52.61521,
            86.57276
          ],
          [
            16.208192,
            52.615139,
            86.320451
          ],
          [
            16.208388,
            52.615111,
            86.320451
          ],
          [
            16.208492,
            52.615104,
            86.320451
          ],
          [
            16.208344,
            52.615069,
            86.320451
          ],
          [
            16.208091,
            52.615161,
            86.320451
          ],
          [
            16.207842,
            52.615272,
            86.320451
          ],
          [
            16.207569,
            52.615364,
            86.320451
          ],
          [
            16.207273,
            52.615422,
            86.320451
          ],
          [
            16.207237,
            52.615239,
            86.320451
          ],
          [
            16.207262,
            52.615055,
            86.320451
          ],
          [
            16.207414,
            52.615055,
            86.320451
          ]
        ]
      }
    }
  ]
}

let day45: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            16.208358,
            52.615023,
            86.982323
          ],
          [
            16.208127,
            52.61513,
            86.982323
          ],
          [
            16.207867,
            52.615228,
            86.982323
          ],
          [
            16.207629,
            52.615352,
            86.982323
          ],
          [
            16.20734,
            52.615404,
            86.982323
          ],
          [
            16.207027,
            52.6154,
            87.133882
          ],
          [
            16.206692,
            52.615392,
            87.905661
          ],
          [
            16.206385,
            52.615339,
            88.645245
          ],
          [
            16.206182,
            52.615194,
            89.377491
          ],
          [
            16.206018,
            52.615022,
            90.131058
          ],
          [
            16.205969,
            52.614822,
            90.901477
          ],
          [
            16.205886,
            52.614626,
            91.669404
          ],
          [
            16.205848,
            52.614437,
            92.39859
          ],
          [
            16.205854,
            52.614236,
            93.16373
          ],
          [
            16.205862,
            52.614038,
            93.696418
          ],
          [
            16.20579,
            52.613856,
            93.055457
          ],
          [
            16.205647,
            52.613675,
            92.368739
          ],
          [
            16.205516,
            52.613499,
            91.706437
          ],
          [
            16.205352,
            52.613304,
            90.958605
          ],
          [
            16.205212,
            52.613132,
            90.30333
          ],
          [
            16.20507,
            52.61295,
            89.612855
          ],
          [
            16.2049,
            52.61277,
            88.902904
          ],
          [
            16.204725,
            52.612614,
            88.257764
          ],
          [
            16.204589,
            52.612429,
            87.502282
          ],
          [
            16.20446,
            52.612225,
            86.262023
          ],
          [
            16.20435,
            52.612057,
            85.239013
          ],
          [
            16.204223,
            52.611829,
            83.87683
          ],
          [
            16.204061,
            52.611659,
            82.7469
          ],
          [
            16.204226,
            52.611502,
            81.606149
          ],
          [
            16.204556,
            52.611402,
            80.337781
          ],
          [
            16.204973,
            52.611323,
            78.836795
          ],
          [
            16.205282,
            52.611284,
            77.752203
          ],
          [
            16.205612,
            52.611178,
            77.98897
          ],
          [
            16.205919,
            52.611031,
            78.658311
          ],
          [
            16.206174,
            52.610877,
            79.272135
          ],
          [
            16.206408,
            52.61075,
            79.808017
          ],
          [
            16.206681,
            52.610612,
            80.414318
          ],
          [
            16.206944,
            52.610499,
            80.965532
          ],
          [
            16.207243,
            52.6104,
            81.54694
          ],
          [
            16.207543,
            52.610335,
            82.093593
          ],
          [
            16.207871,
            52.610308,
            82.828116
          ],
          [
            16.20817,
            52.610227,
            84.160069
          ],
          [
            16.208444,
            52.610146,
            85.396106
          ],
          [
            16.208701,
            52.610045,
            86.637806
          ],
          [
            16.208992,
            52.609957,
            87.95579
          ],
          [
            16.209259,
            52.609864,
            89.215859
          ],
          [
            16.209572,
            52.609783,
            90.596087
          ],
          [
            16.209867,
            52.609678,
            91.985301
          ],
          [
            16.210151,
            52.609576,
            93.325139
          ],
          [
            16.210475,
            52.609508,
            94.693125
          ],
          [
            16.210781,
            52.609424,
            95.840702
          ],
          [
            16.211058,
            52.609333,
            96.917704
          ],
          [
            16.211368,
            52.609237,
            98.105974
          ],
          [
            16.211658,
            52.609115,
            99.322266
          ],
          [
            16.211799,
            52.608927,
            100.485307
          ],
          [
            16.21195,
            52.608736,
            101.677833
          ],
          [
            16.212064,
            52.608554,
            102.773107
          ],
          [
            16.212151,
            52.608351,
            103.952939
          ],
          [
            16.212309,
            52.608175,
            104.960735
          ],
          [
            16.212387,
            52.607976,
            105.788024
          ],
          [
            16.212401,
            52.607783,
            106.563652
          ],
          [
            16.212371,
            52.607564,
            107.448449
          ],
          [
            16.212367,
            52.607358,
            108.276203
          ],
          [
            16.212387,
            52.607148,
            109.122237
          ],
          [
            16.212385,
            52.606932,
            109.990534
          ],
          [
            16.212397,
            52.606724,
            110.826115
          ],
          [
            16.212415,
            52.606514,
            111.673023
          ],
          [
            16.212411,
            52.606323,
            112.141047
          ],
          [
            16.212431,
            52.60613,
            112.503454
          ],
          [
            16.212445,
            52.60593,
            112.878401
          ],
          [
            16.21246,
            52.605735,
            113.243935
          ],
          [
            16.212437,
            52.605547,
            113.597966
          ],
          [
            16.212408,
            52.605344,
            113.980684
          ],
          [
            16.212422,
            52.605149,
            114.346181
          ],
          [
            16.212455,
            52.604954,
            114.713399
          ],
          [
            16.21243,
            52.604742,
            115.111403
          ],
          [
            16.212446,
            52.604535,
            115.894142
          ],
          [
            16.212464,
            52.604323,
            116.916092
          ],
          [
            16.212467,
            52.604134,
            117.822065
          ],
          [
            16.212431,
            52.603929,
            118.811096
          ],
          [
            16.212436,
            52.603712,
            119.852253
          ],
          [
            16.212518,
            52.60353,
            120.757688
          ],
          [
            16.212625,
            52.603338,
            121.729414
          ],
          [
            16.212766,
            52.603167,
            122.646532
          ],
          [
            16.212898,
            52.602981,
            123.621271
          ],
          [
            16.213028,
            52.602795,
            124.098163
          ],
          [
            16.213187,
            52.602593,
            124.440375
          ],
          [
            16.213337,
            52.602407,
            124.757107
          ],
          [
            16.213455,
            52.602223,
            125.059614
          ],
          [
            16.213597,
            52.602052,
            125.352298
          ],
          [
            16.213762,
            52.601895,
            125.636949
          ],
          [
            16.213911,
            52.601698,
            125.968707
          ],
          [
            16.214054,
            52.601521,
            126.2705
          ],
          [
            16.214335,
            52.601473,
            126.558473
          ],
          [
            16.214622,
            52.601488,
            126.707348
          ],
          [
            16.214322,
            52.601477,
            126.819359
          ],
          [
            16.214196,
            52.601317,
            126.942469
          ],
          [
            16.214347,
            52.601125,
            127.069676
          ],
          [
            16.214507,
            52.600939,
            127.194986
          ],
          [
            16.214656,
            52.600766,
            127.31157
          ],
          [
            16.214806,
            52.600595,
            127.427347
          ],
          [
            16.214971,
            52.600408,
            127.554086
          ],
          [
            16.215122,
            52.600223,
            127.677465
          ],
          [
            16.215287,
            52.60005,
            127.489485
          ],
          [
            16.215443,
            52.599876,
            127.265618
          ],
          [
            16.215587,
            52.599689,
            127.03187
          ],
          [
            16.215736,
            52.599494,
            126.788709
          ],
          [
            16.215923,
            52.599298,
            126.532714
          ],
          [
            16.216079,
            52.599111,
            126.295477
          ],
          [
            16.216243,
            52.598926,
            126.058008
          ],
          [
            16.216402,
            52.598738,
            125.81919
          ],
          [
            16.216568,
            52.598555,
            125.642814
          ],
          [
            16.216769,
            52.598343,
            125.586219
          ],
          [
            16.216938,
            52.59817,
            125.539677
          ],
          [
            16.217116,
            52.597949,
            125.482658
          ],
          [
            16.217272,
            52.597778,
            125.437412
          ],
          [
            16.217428,
            52.597614,
            125.39358
          ],
          [
            16.217596,
            52.597401,
            125.338909
          ],
          [
            16.217762,
            52.597216,
            125.290178
          ],
          [
            16.217951,
            52.597025,
            125.304031
          ],
          [
            16.218111,
            52.59683,
            126.150676
          ],
          [
            16.218311,
            52.596618,
            127.099246
          ],
          [
            16.218465,
            52.596436,
            127.893642
          ],
          [
            16.218625,
            52.596273,
            128.630368
          ],
          [
            16.218793,
            52.596086,
            129.459744
          ],
          [
            16.21895,
            52.595904,
            130.257256
          ],
          [
            16.21912,
            52.595731,
            131.039742
          ],
          [
            16.21926,
            52.595538,
            131.85863
          ],
          [
            16.219425,
            52.59535,
            132.366852
          ],
          [
            16.219589,
            52.595166,
            132.619866
          ],
          [
            16.21977,
            52.59496,
            132.90227
          ],
          [
            16.219962,
            52.594748,
            133.194812
          ],
          [
            16.220158,
            52.594538,
            133.486659
          ],
          [
            16.220351,
            52.594315,
            133.79128
          ],
          [
            16.220566,
            52.594092,
            134.10387
          ],
          [
            16.220762,
            52.593878,
            134.397584
          ],
          [
            16.220932,
            52.593646,
            134.442297
          ],
          [
            16.2211,
            52.593409,
            134.487774
          ],
          [
            16.221246,
            52.593199,
            134.527908
          ],
          [
            16.221379,
            52.593008,
            134.564546
          ],
          [
            16.221519,
            52.592818,
            134.601332
          ],
          [
            16.221652,
            52.592621,
            134.638817
          ],
          [
            16.221798,
            52.592435,
            134.675124
          ],
          [
            16.221935,
            52.592251,
            134.710681
          ],
          [
            16.222084,
            52.592069,
            134.645938
          ],
          [
            16.222241,
            52.591879,
            134.568215
          ],
          [
            16.222461,
            52.591685,
            134.482213
          ],
          [
            16.222684,
            52.591507,
            134.400551
          ],
          [
            16.222887,
            52.591329,
            134.321284
          ],
          [
            16.223109,
            52.591156,
            134.241191
          ],
          [
            16.223331,
            52.590981,
            134.160553
          ],
          [
            16.223526,
            52.590816,
            134.086407
          ],
          [
            16.223745,
            52.590644,
            134.292801
          ],
          [
            16.223946,
            52.590469,
            134.659034
          ],
          [
            16.224157,
            52.590279,
            135.050738
          ],
          [
            16.224386,
            52.590115,
            135.417887
          ],
          [
            16.224617,
            52.589912,
            135.839268
          ],
          [
            16.224851,
            52.589733,
            136.229648
          ],
          [
            16.225044,
            52.589561,
            136.585485
          ],
          [
            16.225259,
            52.589363,
            136.991235
          ],
          [
            16.225523,
            52.589193,
            137.549813
          ],
          [
            16.225758,
            52.589025,
            138.154803
          ],
          [
            16.225935,
            52.588868,
            138.680203
          ],
          [
            16.226157,
            52.588685,
            139.304182
          ],
          [
            16.226414,
            52.588488,
            139.994068
          ],
          [
            16.226619,
            52.588316,
            140.576992
          ],
          [
            16.226815,
            52.588145,
            141.148794
          ],
          [
            16.227044,
            52.587965,
            141.773153
          ],
          [
            16.227272,
            52.587786,
            141.833814
          ],
          [
            16.227483,
            52.58761,
            141.418673
          ],
          [
            16.227727,
            52.587411,
            140.945698
          ],
          [
            16.227952,
            52.58724,
            140.528424
          ],
          [
            16.228203,
            52.587056,
            140.072653
          ],
          [
            16.22837,
            52.586892,
            139.703647
          ],
          [
            16.228644,
            52.586693,
            139.209032
          ],
          [
            16.228835,
            52.586485,
            138.754701
          ],
          [
            16.22905,
            52.586306,
            138.67388
          ],
          [
            16.229291,
            52.586147,
            138.726284
          ],
          [
            16.229517,
            52.585975,
            138.779572
          ],
          [
            16.229746,
            52.585787,
            138.836198
          ],
          [
            16.229995,
            52.585599,
            138.894737
          ],
          [
            16.230233,
            52.585388,
            138.956719
          ],
          [
            16.23041,
            52.585176,
            139.014302
          ],
          [
            16.23057,
            52.58493,
            139.017257
          ],
          [
            16.230648,
            52.584684,
            138.593794
          ],
          [
            16.23066,
            52.584437,
            138.174992
          ],
          [
            16.230636,
            52.584196,
            137.766891
          ],
          [
            16.23062,
            52.583925,
            137.308174
          ],
          [
            16.23062,
            52.58365,
            136.843252
          ],
          [
            16.230623,
            52.583373,
            136.373972
          ],
          [
            16.230586,
            52.58313,
            135.993038
          ],
          [
            16.230582,
            52.582875,
            135.758825
          ],
          [
            16.230553,
            52.582648,
            135.549775
          ],
          [
            16.230551,
            52.582403,
            135.324849
          ],
          [
            16.230557,
            52.582199,
            135.137515
          ],
          [
            16.23064,
            52.58199,
            134.94016
          ],
          [
            16.230661,
            52.581798,
            134.763551
          ],
          [
            16.230735,
            52.581586,
            134.564651
          ],
          [
            16.230812,
            52.58137,
            134.400423
          ],
          [
            16.230891,
            52.581142,
            134.638418
          ],
          [
            16.230975,
            52.580912,
            134.879102
          ],
          [
            16.231076,
            52.580675,
            135.129422
          ],
          [
            16.23117,
            52.580439,
            135.377506
          ],
          [
            16.231254,
            52.580194,
            135.633227
          ],
          [
            16.231347,
            52.579964,
            135.875513
          ],
          [
            16.231411,
            52.579741,
            136.106746
          ],
          [
            16.231503,
            52.579534,
            136.244164
          ],
          [
            16.231569,
            52.579332,
            136.296465
          ],
          [
            16.231672,
            52.579129,
            136.350411
          ],
          [
            16.231745,
            52.578929,
            136.402441
          ],
          [
            16.231838,
            52.578726,
            136.455958
          ],
          [
            16.23197,
            52.578532,
            136.509447
          ],
          [
            16.232146,
            52.578313,
            136.571353
          ],
          [
            16.232342,
            52.578086,
            136.636461
          ],
          [
            16.232519,
            52.577861,
            136.444762
          ],
          [
            16.23274,
            52.577633,
            135.849679
          ],
          [
            16.232923,
            52.577429,
            135.32697
          ],
          [
            16.233091,
            52.57722,
            134.803653
          ],
          [
            16.233228,
            52.577031,
            134.339133
          ],
          [
            16.233411,
            52.576832,
            133.825447
          ],
          [
            16.233575,
            52.576628,
            133.313695
          ],
          [
            16.233773,
            52.576439,
            132.8096
          ],
          [
            16.233972,
            52.576276,
            132.533693
          ],
          [
            16.234262,
            52.576135,
            132.358657
          ],
          [
            16.234555,
            52.576009,
            132.189476
          ],
          [
            16.234845,
            52.575883,
            132.021257
          ],
          [
            16.235118,
            52.575757,
            131.859592
          ],
          [
            16.235398,
            52.575657,
            131.706381
          ],
          [
            16.235686,
            52.575546,
            131.545657
          ],
          [
            16.235973,
            52.57543,
            131.383177
          ],
          [
            16.236244,
            52.575321,
            131.230518
          ],
          [
            16.236518,
            52.575215,
            131.100159
          ],
          [
            16.236797,
            52.575096,
            130.9648
          ],
          [
            16.237105,
            52.575198,
            130.815932
          ],
          [
            16.237338,
            52.575417,
            130.64572
          ],
          [
            16.237592,
            52.575617,
            130.480847
          ],
          [
            16.237854,
            52.575742,
            130.34781
          ],
          [
            16.238148,
            52.575862,
            130.207289
          ],
          [
            16.238446,
            52.576008,
            130.067097
          ],
          [
            16.238753,
            52.576144,
            130.269464
          ],
          [
            16.239029,
            52.576275,
            130.455979
          ],
          [
            16.239348,
            52.576411,
            130.663629
          ],
          [
            16.239637,
            52.576548,
            130.859109
          ],
          [
            16.239937,
            52.576664,
            131.048687
          ],
          [
            16.240287,
            52.576778,
            131.260546
          ],
          [
            16.24061,
            52.576932,
            131.479175
          ],
          [
            16.240953,
            52.577065,
            131.639283
          ],
          [
            16.241253,
            52.577198,
            131.648366
          ],
          [
            16.241573,
            52.577323,
            131.657946
          ],
          [
            16.241895,
            52.577471,
            131.667814
          ],
          [
            16.242217,
            52.577604,
            131.677329
          ],
          [
            16.24248,
            52.577723,
            131.685343
          ],
          [
            16.242775,
            52.577834,
            131.693825
          ],
          [
            16.243082,
            52.577929,
            131.702246
          ],
          [
            16.243378,
            52.578071,
            131.564359
          ],
          [
            16.243693,
            52.578193,
            131.052102
          ],
          [
            16.243992,
            52.578303,
            130.572583
          ],
          [
            16.24425,
            52.578434,
            130.111276
          ],
          [
            16.244547,
            52.578571,
            129.599018
          ],
          [
            16.244856,
            52.57869,
            129.097321
          ],
          [
            16.245186,
            52.578838,
            128.533134
          ],
          [
            16.245459,
            52.57899,
            128.025101
          ],
          [
            16.245794,
            52.579099,
            127.578668
          ],
          [
            16.246122,
            52.57921,
            127.3271
          ],
          [
            16.24642,
            52.579339,
            127.081688
          ],
          [
            16.246665,
            52.579526,
            126.817233
          ],
          [
            16.246855,
            52.579695,
            126.590987
          ],
          [
            16.246999,
            52.579875,
            126.370155
          ],
          [
            16.247174,
            52.580075,
            126.120382
          ],
          [
            16.247366,
            52.580287,
            125.853382
          ],
          [
            16.247563,
            52.580453,
            125.81047
          ],
          [
            16.247733,
            52.580612,
            126.554828
          ],
          [
            16.247949,
            52.580775,
            127.376408
          ],
          [
            16.248128,
            52.58093,
            128.118743
          ],
          [
            16.248364,
            52.581145,
            129.131996
          ],
          [
            16.248601,
            52.581336,
            130.069807
          ],
          [
            16.248826,
            52.581527,
            130.990947
          ],
          [
            16.249044,
            52.581716,
            131.895872
          ],
          [
            16.249272,
            52.581923,
            132.702767
          ],
          [
            16.249496,
            52.582117,
            132.604971
          ],
          [
            16.249732,
            52.582338,
            132.496185
          ],
          [
            16.249936,
            52.582522,
            132.404646
          ],
          [
            16.250164,
            52.582731,
            132.301166
          ],
          [
            16.250409,
            52.582939,
            132.195629
          ],
          [
            16.250646,
            52.583153,
            132.0892
          ],
          [
            16.250841,
            52.583345,
            131.996075
          ],
          [
            16.251094,
            52.583557,
            131.862695
          ],
          [
            16.251328,
            52.583743,
            131.738561
          ],
          [
            16.251547,
            52.583975,
            131.596753
          ],
          [
            16.251743,
            52.584159,
            131.480154
          ],
          [
            16.251983,
            52.584349,
            131.353134
          ],
          [
            16.25222,
            52.584542,
            131.225259
          ],
          [
            16.252437,
            52.584745,
            131.096902
          ],
          [
            16.252677,
            52.584936,
            130.944233
          ],
          [
            16.252885,
            52.585114,
            130.773989
          ],
          [
            16.253087,
            52.585306,
            130.59624
          ],
          [
            16.253289,
            52.585479,
            130.430856
          ],
          [
            16.25349,
            52.585668,
            130.255427
          ],
          [
            16.253689,
            52.585844,
            130.088691
          ],
          [
            16.253898,
            52.586035,
            129.909769
          ],
          [
            16.254091,
            52.586183,
            129.762424
          ],
          [
            16.254323,
            52.586337,
            129.620472
          ],
          [
            16.254588,
            52.586465,
            129.61642
          ],
          [
            16.254848,
            52.586568,
            129.61267
          ],
          [
            16.25513,
            52.58667,
            129.608736
          ],
          [
            16.255455,
            52.586784,
            129.604225
          ],
          [
            16.255839,
            52.586915,
            129.598954
          ],
          [
            16.25612,
            52.587007,
            129.595122
          ],
          [
            16.256468,
            52.587113,
            129.590457
          ],
          [
            16.256819,
            52.587249,
            129.577762
          ],
          [
            16.257154,
            52.587366,
            129.245168
          ],
          [
            16.257522,
            52.587498,
            128.877331
          ],
          [
            16.257832,
            52.587629,
            128.552266
          ],
          [
            16.258195,
            52.587709,
            128.219616
          ],
          [
            16.258583,
            52.587749,
            127.880846
          ],
          [
            16.258946,
            52.587775,
            127.564828
          ],
          [
            16.25928,
            52.587801,
            127.275031
          ],
          [
            16.259706,
            52.587828,
            127.030365
          ],
          [
            16.260121,
            52.58785,
            127.010338
          ],
          [
            16.260533,
            52.587845,
            126.990519
          ],
          [
            16.260911,
            52.587803,
            126.971976
          ],
          [
            16.261256,
            52.587751,
            126.95489
          ],
          [
            16.261591,
            52.587716,
            126.938499
          ],
          [
            16.26161,
            52.587744,
            126.923428
          ],
          [
            16.261577,
            52.587916,
            126.908203
          ],
          [
            16.261699,
            52.588111,
            126.903307
          ],
          [
            16.261819,
            52.588311,
            126.9387
          ],
          [
            16.261941,
            52.588502,
            126.972773
          ],
          [
            16.262075,
            52.588697,
            127.007891
          ],
          [
            16.262153,
            52.588895,
            127.041756
          ],
          [
            16.262153,
            52.589115,
            127.078362
          ],
          [
            16.262113,
            52.589332,
            127.114711
          ],
          [
            16.262074,
            52.58957,
            127.154514
          ],
          [
            16.261963,
            52.589748,
            127.187073
          ],
          [
            16.26188,
            52.589954,
            127.284861
          ],
          [
            16.261814,
            52.590151,
            127.392687
          ],
          [
            16.261935,
            52.590308,
            127.498134
          ],
          [
            16.262281,
            52.590264,
            127.613551
          ],
          [
            16.262588,
            52.590236,
            127.7147
          ],
          [
            16.262927,
            52.590189,
            127.828056
          ],
          [
            16.263225,
            52.590147,
            127.927797
          ],
          [
            16.263543,
            52.590111,
            128.033404
          ],
          [
            16.263886,
            52.590066,
            128.14777
          ],
          [
            16.264232,
            52.590024,
            128.238121
          ],
          [
            16.264598,
            52.589967,
            128.332037
          ],
          [
            16.264968,
            52.589897,
            128.428363
          ],
          [
            16.265279,
            52.589848,
            128.508207
          ],
          [
            16.2656,
            52.589784,
            128.592203
          ],
          [
            16.265922,
            52.589742,
            128.674046
          ],
          [
            16.266232,
            52.589698,
            128.753158
          ],
          [
            16.266536,
            52.589681,
            128.829035
          ],
          [
            16.266895,
            52.589687,
            128.902543
          ],
          [
            16.2672,
            52.589693,
            128.927721
          ],
          [
            16.267579,
            52.589692,
            128.958992
          ],
          [
            16.267886,
            52.589684,
            128.98435
          ],
          [
            16.268228,
            52.589693,
            129.012658
          ],
          [
            16.268559,
            52.589727,
            129.041288
          ],
          [
            16.268904,
            52.589729,
            129.069759
          ],
          [
            16.269245,
            52.589756,
            129.09823
          ],
          [
            16.269569,
            52.589781,
            129.12522
          ],
          [
            16.269888,
            52.589793,
            129.13235
          ],
          [
            16.27024,
            52.589791,
            129.11711
          ],
          [
            16.270619,
            52.589783,
            129.100581
          ],
          [
            16.270956,
            52.589802,
            129.085929
          ],
          [
            16.271294,
            52.589801,
            129.071284
          ],
          [
            16.271637,
            52.589806,
            129.056427
          ],
          [
            16.272005,
            52.589824,
            129.040401
          ],
          [
            16.272367,
            52.589816,
            129.02467
          ],
          [
            16.27271,
            52.589815,
            129.013605
          ],
          [
            16.273089,
            52.589828,
            129.05566
          ],
          [
            16.273504,
            52.589849,
            129.101795
          ],
          [
            16.273916,
            52.589872,
            129.147629
          ],
          [
            16.274348,
            52.589892,
            129.195625
          ],
          [
            16.274785,
            52.5899,
            129.244057
          ],
          [
            16.27523,
            52.589919,
            129.293477
          ],
          [
            16.275648,
            52.589942,
            129.324439
          ],
          [
            16.276003,
            52.589956,
            128.811897
          ],
          [
            16.276326,
            52.589951,
            128.346427
          ],
          [
            16.276642,
            52.589937,
            127.888635
          ],
          [
            16.276988,
            52.58996,
            127.387259
          ],
          [
            16.27736,
            52.589968,
            126.85096
          ],
          [
            16.277726,
            52.589963,
            126.323599
          ],
          [
            16.278152,
            52.589978,
            125.707133
          ],
          [
            16.278527,
            52.589992,
            125.165546
          ],
          [
            16.278842,
            52.590003,
            124.803882
          ],
          [
            16.279205,
            52.590017,
            124.413968
          ],
          [
            16.279613,
            52.590031,
            123.975647
          ],
          [
            16.280069,
            52.590046,
            123.486087
          ],
          [
            16.28055,
            52.59005,
            122.969227
          ],
          [
            16.281037,
            52.590036,
            122.446547
          ],
          [
            16.281477,
            52.590042,
            121.974761
          ],
          [
            16.281909,
            52.590055,
            121.640883
          ],
          [
            16.282336,
            52.590062,
            121.336216
          ],
          [
            16.282745,
            52.590063,
            121.044514
          ],
          [
            16.283149,
            52.590075,
            120.756037
          ],
          [
            16.283523,
            52.590091,
            120.488447
          ],
          [
            16.283898,
            52.590093,
            120.219963
          ],
          [
            16.284256,
            52.590123,
            119.962137
          ],
          [
            16.28458,
            52.590131,
            119.972199
          ],
          [
            16.284944,
            52.590147,
            120.793609
          ],
          [
            16.285312,
            52.590159,
            121.624285
          ],
          [
            16.285725,
            52.590166,
            122.556375
          ],
          [
            16.286076,
            52.590191,
            123.352304
          ],
          [
            16.286397,
            52.590212,
            124.078967
          ],
          [
            16.286722,
            52.590222,
            124.811395
          ],
          [
            16.287053,
            52.590223,
            125.557117
          ],
          [
            16.287405,
            52.590232,
            126.350486
          ],
          [
            16.287723,
            52.590232,
            126.807118
          ],
          [
            16.288062,
            52.59024,
            127.24786
          ],
          [
            16.288416,
            52.590232,
            127.708621
          ],
          [
            16.28876,
            52.590223,
            128.155685
          ],
          [
            16.289139,
            52.590235,
            128.648534
          ],
          [
            16.289529,
            52.590252,
            129.156564
          ],
          [
            16.289871,
            52.590267,
            129.601654
          ],
          [
            16.290206,
            52.590291,
            130.039455
          ],
          [
            16.290563,
            52.590301,
            130.443463
          ],
          [
            16.290904,
            52.590315,
            130.759097
          ],
          [
            16.291273,
            52.590321,
            131.100181
          ],
          [
            16.291572,
            52.590322,
            131.376819
          ],
          [
            16.291899,
            52.59032,
            131.678962
          ],
          [
            16.292248,
            52.590335,
            132.002147
          ],
          [
            16.292592,
            52.590354,
            132.321145
          ],
          [
            16.292896,
            52.590356,
            132.602495
          ],
          [
            16.293241,
            52.590365,
            132.921772
          ],
          [
            16.293583,
            52.590362,
            132.908199
          ],
          [
            16.2939,
            52.590391,
            132.736705
          ],
          [
            16.294258,
            52.590407,
            132.544442
          ],
          [
            16.294573,
            52.590399,
            132.375825
          ],
          [
            16.29489,
            52.590403,
            132.205821
          ],
          [
            16.295209,
            52.590406,
            132.035167
          ],
          [
            16.295545,
            52.590406,
            131.85555
          ],
          [
            16.2959,
            52.59043,
            131.664596
          ],
          [
            16.296235,
            52.590405,
            131.48363
          ],
          [
            16.296579,
            52.590387,
            131.154897
          ],
          [
            16.296936,
            52.590411,
            130.775891
          ],
          [
            16.297272,
            52.590426,
            130.418933
          ],
          [
            16.29764,
            52.590438,
            130.030161
          ],
          [
            16.29799,
            52.590464,
            129.658176
          ],
          [
            16.298323,
            52.590478,
            129.30506
          ],
          [
            16.29866,
            52.590481,
            128.946464
          ],
          [
            16.29902,
            52.590522,
            128.558869
          ],
          [
            16.299371,
            52.59053,
            128.611765
          ],
          [
            16.299719,
            52.590529,
            129.3927
          ],
          [
            16.300047,
            52.59056,
            130.138049
          ],
          [
            16.300369,
            52.590557,
            130.862486
          ],
          [
            16.300675,
            52.590565,
            131.551352
          ],
          [
            16.300916,
            52.590473,
            132.310349
          ],
          [
            16.30092,
            52.59026,
            133.100413
          ],
          [
            16.300977,
            52.590058,
            133.857148
          ],
          [
            16.300989,
            52.589855,
            134.607083
          ],
          [
            16.301025,
            52.589671,
            134.825718
          ],
          [
            16.301064,
            52.589484,
            134.53158
          ],
          [
            16.301118,
            52.589277,
            134.204591
          ],
          [
            16.301119,
            52.589073,
            133.886155
          ],
          [
            16.301151,
            52.588845,
            133.528911
          ],
          [
            16.301166,
            52.588612,
            133.164066
          ],
          [
            16.301188,
            52.588405,
            132.840156
          ],
          [
            16.301213,
            52.588204,
            132.525364
          ],
          [
            16.301245,
            52.588004,
            132.211456
          ],
          [
            16.301287,
            52.587788,
            132.275089
          ],
          [
            16.301313,
            52.587572,
            132.413315
          ],
          [
            16.301319,
            52.587361,
            132.547944
          ],
          [
            16.301303,
            52.587149,
            132.683365
          ],
          [
            16.301261,
            52.586919,
            132.830997
          ],
          [
            16.301216,
            52.586682,
            132.98363
          ],
          [
            16.301157,
            52.586448,
            133.13466
          ],
          [
            16.301111,
            52.586226,
            133.277501
          ],
          [
            16.301027,
            52.586022,
            133.086467
          ],
          [
            16.300935,
            52.585811,
            132.799276
          ],
          [
            16.300858,
            52.585623,
            132.544383
          ],
          [
            16.300789,
            52.585419,
            132.270298
          ],
          [
            16.300699,
            52.585201,
            131.974587
          ],
          [
            16.30062,
            52.584969,
            131.662623
          ],
          [
            16.300527,
            52.584743,
            131.355758
          ],
          [
            16.300444,
            52.584519,
            131.053536
          ],
          [
            16.300344,
            52.584307,
            130.744336
          ],
          [
            16.300248,
            52.584088,
            130.413257
          ],
          [
            16.300144,
            52.583874,
            130.087598
          ],
          [
            16.300072,
            52.583663,
            129.773408
          ],
          [
            16.300366,
            52.58356,
            129.46109
          ],
          [
            16.300695,
            52.583491,
            129.152633
          ],
          [
            16.301038,
            52.583422,
            128.832543
          ],
          [
            16.301388,
            52.583358,
            128.50862
          ],
          [
            16.301739,
            52.583295,
            128.193184
          ],
          [
            16.302069,
            52.583225,
            127.906533
          ],
          [
            16.302434,
            52.583162,
            127.594792
          ],
          [
            16.302799,
            52.583109,
            127.287041
          ],
          [
            16.30317,
            52.583035,
            126.96681
          ],
          [
            16.303528,
            52.582958,
            126.654053
          ],
          [
            16.303879,
            52.582893,
            126.353138
          ],
          [
            16.304237,
            52.582832,
            126.048201
          ],
          [
            16.304562,
            52.582777,
            125.953811
          ],
          [
            16.304887,
            52.582713,
            126.107726
          ],
          [
            16.305239,
            52.582649,
            126.273417
          ],
          [
            16.305574,
            52.58259,
            126.430574
          ],
          [
            16.305922,
            52.582533,
            126.592943
          ],
          [
            16.306286,
            52.582459,
            126.765858
          ],
          [
            16.306628,
            52.582391,
            126.927996
          ],
          [
            16.306958,
            52.582318,
            127.086229
          ],
          [
            16.307301,
            52.582243,
            127.232827
          ],
          [
            16.307673,
            52.58218,
            127.296907
          ],
          [
            16.308068,
            52.582116,
            127.36491
          ],
          [
            16.30848,
            52.582047,
            127.435842
          ],
          [
            16.30877,
            52.581985,
            127.486932
          ],
          [
            16.309066,
            52.58194,
            127.537569
          ],
          [
            16.309352,
            52.581871,
            127.588693
          ],
          [
            16.309644,
            52.581806,
            127.640411
          ],
          [
            16.310002,
            52.581754,
            127.701491
          ],
          [
            16.310365,
            52.58169,
            127.457976
          ],
          [
            16.310654,
            52.581636,
            127.20338
          ],
          [
            16.311001,
            52.581578,
            126.900606
          ],
          [
            16.311399,
            52.581505,
            126.550998
          ],
          [
            16.311753,
            52.581452,
            126.244423
          ],
          [
            16.312114,
            52.581397,
            125.931448
          ],
          [
            16.312506,
            52.581312,
            125.581452
          ],
          [
            16.312893,
            52.581248,
            125.242901
          ],
          [
            16.313201,
            52.581187,
            125.100113
          ],
          [
            16.313628,
            52.58111,
            124.917184
          ],
          [
            16.313955,
            52.581006,
            124.765016
          ],
          [
            16.314171,
            52.580859,
            124.631741
          ],
          [
            16.314255,
            52.580654,
            124.488602
          ],
          [
            16.314284,
            52.580446,
            124.347539
          ],
          [
            16.314309,
            52.580247,
            124.212712
          ],
          [
            16.314431,
            52.58004,
            124.06314
          ],
          [
            16.314589,
            52.579864,
            123.971014
          ],
          [
            16.314835,
            52.579725,
            123.90588
          ],
          [
            16.315185,
            52.579637,
            123.832389
          ],
          [
            16.315502,
            52.579567,
            123.767102
          ],
          [
            16.315796,
            52.57951,
            123.707383
          ],
          [
            16.316128,
            52.57945,
            123.640313
          ],
          [
            16.316472,
            52.579387,
            123.570771
          ],
          [
            16.316814,
            52.579323,
            123.501541
          ],
          [
            16.317139,
            52.579257,
            123.433316
          ],
          [
            16.317491,
            52.579237,
            123.289227
          ],
          [
            16.317859,
            52.579275,
            123.137328
          ],
          [
            16.318247,
            52.579312,
            122.977501
          ],
          [
            16.318615,
            52.579346,
            122.82604
          ],
          [
            16.31894,
            52.579366,
            122.69169
          ],
          [
            16.319313,
            52.579405,
            122.537632
          ],
          [
            16.319646,
            52.579445,
            122.39951
          ],
          [
            16.319987,
            52.579484,
            122.258174
          ],
          [
            16.320357,
            52.579511,
            121.960096
          ],
          [
            16.320737,
            52.579559,
            121.618748
          ],
          [
            16.321101,
            52.579493,
            121.282024
          ],
          [
            16.321437,
            52.579358,
            120.927454
          ],
          [
            16.321764,
            52.579239,
            120.592032
          ],
          [
            16.322108,
            52.579131,
            120.25149
          ],
          [
            16.322515,
            52.579008,
            119.851714
          ],
          [
            16.322809,
            52.578926,
            119.544431
          ],
          [
            16.323159,
            52.578832,
            119.086707
          ],
          [
            16.32349,
            52.578755,
            118.662079
          ],
          [
            16.323872,
            52.57868,
            118.181761
          ],
          [
            16.324254,
            52.578597,
            117.696769
          ],
          [
            16.324586,
            52.578529,
            117.276913
          ],
          [
            16.324858,
            52.578425,
            116.891066
          ],
          [
            16.325118,
            52.57826,
            116.441632
          ],
          [
            16.325368,
            52.57808,
            116.206177
          ],
          [
            16.325583,
            52.577923,
            116.613866
          ],
          [
            16.325805,
            52.577775,
            117.013169
          ],
          [
            16.326009,
            52.577616,
            117.415204
          ],
          [
            16.326213,
            52.577446,
            117.836124
          ],
          [
            16.326448,
            52.577308,
            118.231705
          ],
          [
            16.326664,
            52.577177,
            118.601099
          ],
          [
            16.326875,
            52.577032,
            118.986828
          ],
          [
            16.327119,
            52.576879,
            119.413622
          ],
          [
            16.327322,
            52.576726,
            119.772075
          ],
          [
            16.327552,
            52.576574,
            120.076899
          ],
          [
            16.327765,
            52.576425,
            120.36889
          ],
          [
            16.327504,
            52.576297,
            120.677485
          ],
          [
            16.327502,
            52.576313,
            120.970754
          ],
          [
            16.327787,
            52.576397,
            121.259272
          ],
          [
            16.328023,
            52.576255,
            121.560129
          ],
          [
            16.328239,
            52.576099,
            121.860611
          ],
          [
            16.328452,
            52.575947,
            122.154778
          ],
          [
            16.328691,
            52.5758,
            122.429668
          ],
          [
            16.328926,
            52.575652,
            122.666453
          ],
          [
            16.329125,
            52.575502,
            122.887896
          ],
          [
            16.329331,
            52.575352,
            123.112658
          ],
          [
            16.329553,
            52.575213,
            123.335588
          ],
          [
            16.329794,
            52.575074,
            123.567655
          ],
          [
            16.330032,
            52.574938,
            123.796373
          ],
          [
            16.330242,
            52.57478,
            124.030001
          ],
          [
            16.330475,
            52.574622,
            124.273843
          ],
          [
            16.330707,
            52.57447,
            124.266938
          ],
          [
            16.330925,
            52.574345,
            124.052904
          ],
          [
            16.331156,
            52.574184,
            123.801839
          ],
          [
            16.331369,
            52.574042,
            123.575747
          ],
          [
            16.331585,
            52.573899,
            123.347664
          ],
          [
            16.331795,
            52.573749,
            123.116241
          ],
          [
            16.332027,
            52.573582,
            122.859082
          ],
          [
            16.332234,
            52.573441,
            122.636998
          ],
          [
            16.332468,
            52.573287,
            122.390597
          ],
          [
            16.332684,
            52.573145,
            122.338649
          ],
          [
            16.332895,
            52.572992,
            122.46406
          ],
          [
            16.333126,
            52.572826,
            122.600654
          ],
          [
            16.333346,
            52.57267,
            122.729792
          ],
          [
            16.333621,
            52.572501,
            122.8791
          ],
          [
            16.333897,
            52.572322,
            123.033364
          ],
          [
            16.334154,
            52.57214,
            123.184048
          ],
          [
            16.334432,
            52.571957,
            123.340521
          ],
          [
            16.33471,
            52.571766,
            123.491721
          ],
          [
            16.334946,
            52.571614,
            123.610395
          ],
          [
            16.335205,
            52.571454,
            123.737789
          ],
          [
            16.335477,
            52.571278,
            123.874854
          ],
          [
            16.335712,
            52.57112,
            123.995733
          ],
          [
            16.335939,
            52.570949,
            124.120581
          ],
          [
            16.336204,
            52.570781,
            124.252675
          ],
          [
            16.336431,
            52.570618,
            124.373872
          ],
          [
            16.336686,
            52.570453,
            124.456334
          ],
          [
            16.336965,
            52.570309,
            124.504318
          ],
          [
            16.337308,
            52.570223,
            124.553133
          ],
          [
            16.337636,
            52.570187,
            124.596919
          ],
          [
            16.337991,
            52.570192,
            124.643531
          ],
          [
            16.338358,
            52.570175,
            124.691751
          ],
          [
            16.338729,
            52.570177,
            124.74035
          ],
          [
            16.339083,
            52.570129,
            124.787978
          ],
          [
            16.339405,
            52.570099,
            124.426852
          ],
          [
            16.339807,
            52.57013,
            123.06057
          ],
          [
            16.340146,
            52.570141,
            121.913378
          ],
          [
            16.340527,
            52.570122,
            120.620764
          ],
          [
            16.340924,
            52.570107,
            119.27768
          ],
          [
            16.341381,
            52.570109,
            117.733248
          ],
          [
            16.341822,
            52.57009,
            116.226084
          ],
          [
            16.342246,
            52.570085,
            114.875351
          ],
          [
            16.342609,
            52.570079,
            115.833037
          ],
          [
            16.342951,
            52.570092,
            116.735809
          ],
          [
            16.343338,
            52.570119,
            117.762112
          ],
          [
            16.343662,
            52.570211,
            118.704864
          ],
          [
            16.343956,
            52.570302,
            119.574289
          ],
          [
            16.344264,
            52.570373,
            120.442086
          ],
          [
            16.344588,
            52.570466,
            121.387824
          ],
          [
            16.34494,
            52.570559,
            122.401316
          ],
          [
            16.345283,
            52.57065,
            122.710428
          ],
          [
            16.345566,
            52.570729,
            122.791481
          ],
          [
            16.34585,
            52.570812,
            122.8734
          ],
          [
            16.34617,
            52.570905,
            122.965618
          ],
          [
            16.346497,
            52.570951,
            123.053404
          ],
          [
            16.346837,
            52.571032,
            123.148319
          ],
          [
            16.347124,
            52.571126,
            123.233468
          ],
          [
            16.347417,
            52.571235,
            123.323116
          ],
          [
            16.347551,
            52.57145,
            123.244621
          ],
          [
            16.347623,
            52.571646,
            122.482166
          ],
          [
            16.347699,
            52.571854,
            121.673089
          ],
          [
            16.347771,
            52.57208,
            120.799886
          ],
          [
            16.347841,
            52.572314,
            119.897708
          ],
          [
            16.347915,
            52.572539,
            119.027298
          ],
          [
            16.347935,
            52.572734,
            118.285964
          ],
          [
            16.347873,
            52.572967,
            117.388273
          ],
          [
            16.347792,
            52.573145,
            116.687711
          ],
          [
            16.347695,
            52.573342,
            117.075554
          ],
          [
            16.347589,
            52.573528,
            117.621311
          ],
          [
            16.347503,
            52.573767,
            118.298579
          ],
          [
            16.347444,
            52.573957,
            118.833912
          ],
          [
            16.347376,
            52.574144,
            119.364127
          ],
          [
            16.347262,
            52.574368,
            120.013853
          ],
          [
            16.347212,
            52.57459,
            120.634145
          ],
          [
            16.34716,
            52.574781,
            121.171919
          ],
          [
            16.347058,
            52.574988,
            121.601466
          ],
          [
            16.346977,
            52.575179,
            121.705156
          ],
          [
            16.346906,
            52.575379,
            121.812775
          ],
          [
            16.346806,
            52.575574,
            121.920191
          ],
          [
            16.346693,
            52.575778,
            122.033555
          ],
          [
            16.3466,
            52.575991,
            122.149398
          ],
          [
            16.346529,
            52.57618,
            122.251341
          ],
          [
            16.346443,
            52.576395,
            122.367665
          ],
          [
            16.346382,
            52.57659,
            122.47199
          ],
          [
            16.34628,
            52.576787,
            122.167722
          ],
          [
            16.346178,
            52.576999,
            121.629978
          ],
          [
            16.346094,
            52.577224,
            121.067102
          ],
          [
            16.345999,
            52.577452,
            120.494493
          ],
          [
            16.345908,
            52.577685,
            119.910438
          ],
          [
            16.345808,
            52.577867,
            119.44332
          ],
          [
            16.345719,
            52.578042,
            118.997138
          ],
          [
            16.345676,
            52.578239,
            118.512706
          ],
          [
            16.345577,
            52.578453,
            117.958313
          ],
          [
            16.345481,
            52.578648,
            117.420144
          ],
          [
            16.345392,
            52.57884,
            116.893773
          ],
          [
            16.345288,
            52.579044,
            116.330341
          ],
          [
            16.345219,
            52.57925,
            115.774938
          ],
          [
            16.345136,
            52.57948,
            115.153699
          ],
          [
            16.345056,
            52.579697,
            114.56515
          ],
          [
            16.344967,
            52.579899,
            114.011922
          ],
          [
            16.344879,
            52.580114,
            113.427334
          ],
          [
            16.344793,
            52.580323,
            113.769112
          ],
          [
            16.344693,
            52.580504,
            114.13906
          ],
          [
            16.344604,
            52.58071,
            114.55172
          ],
          [
            16.344782,
            52.58088,
            114.977827
          ],
          [
            16.345074,
            52.580945,
            115.343904
          ],
          [
            16.345361,
            52.581008,
            115.703658
          ],
          [
            16.345665,
            52.581039,
            116.066841
          ],
          [
            16.345996,
            52.581087,
            116.46743
          ],
          [
            16.346313,
            52.581134,
            116.852549
          ],
          [
            16.346639,
            52.581179,
            117.682348
          ],
          [
            16.346949,
            52.581224,
            118.491045
          ],
          [
            16.347242,
            52.581276,
            119.266283
          ],
          [
            16.347508,
            52.581389,
            120.093591
          ],
          [
            16.347744,
            52.58153,
            120.93293
          ],
          [
            16.348007,
            52.581675,
            121.833621
          ],
          [
            16.348259,
            52.581829,
            122.739989
          ],
          [
            16.348512,
            52.581977,
            123.630616
          ],
          [
            16.348759,
            52.582099,
            124.379628
          ],
          [
            16.348978,
            52.582234,
            124.439266
          ],
          [
            16.3492,
            52.582381,
            124.502046
          ],
          [
            16.349442,
            52.582512,
            124.564011
          ],
          [
            16.34969,
            52.582645,
            124.627245
          ],
          [
            16.349968,
            52.582771,
            124.693549
          ],
          [
            16.350233,
            52.582899,
            124.758276
          ],
          [
            16.350474,
            52.583041,
            124.822513
          ],
          [
            16.350719,
            52.583191,
            124.889001
          ],
          [
            16.350949,
            52.583318,
            124.823225
          ],
          [
            16.351211,
            52.583457,
            123.803278
          ],
          [
            16.351441,
            52.58359,
            122.871474
          ],
          [
            16.351705,
            52.583739,
            121.795584
          ],
          [
            16.351961,
            52.583886,
            120.762487
          ],
          [
            16.352206,
            52.584025,
            119.775901
          ],
          [
            16.352466,
            52.584181,
            118.699047
          ],
          [
            16.352687,
            52.584344,
            117.679891
          ],
          [
            16.352967,
            52.584513,
            116.522357
          ],
          [
            16.353213,
            52.58464,
            116.736398
          ],
          [
            16.353476,
            52.584777,
            117.432331
          ],
          [
            16.353728,
            52.584911,
            118.103446
          ],
          [
            16.354041,
            52.585076,
            118.934037
          ],
          [
            16.354329,
            52.585219,
            119.678137
          ],
          [
            16.354608,
            52.585401,
            120.496993
          ],
          [
            16.354863,
            52.585527,
            121.154952
          ],
          [
            16.355089,
            52.585662,
            121.790778
          ],
          [
            16.355338,
            52.585814,
            121.968459
          ],
          [
            16.355606,
            52.585959,
            121.461992
          ],
          [
            16.355886,
            52.586102,
            120.943001
          ],
          [
            16.356138,
            52.586229,
            120.476636
          ],
          [
            16.356403,
            52.586396,
            119.937521
          ],
          [
            16.356644,
            52.586516,
            119.497381
          ],
          [
            16.356936,
            52.586682,
            118.932595
          ],
          [
            16.357218,
            52.586804,
            118.443967
          ],
          [
            16.357527,
            52.586973,
            117.861283
          ],
          [
            16.357783,
            52.587123,
            117.372447
          ],
          [
            16.358059,
            52.587263,
            116.878447
          ],
          [
            16.358348,
            52.58741,
            116.361209
          ],
          [
            16.35861,
            52.587557,
            115.871808
          ],
          [
            16.358882,
            52.587762,
            115.276796
          ],
          [
            16.359176,
            52.587893,
            114.775413
          ],
          [
            16.359481,
            52.588062,
            114.20785
          ],
          [
            16.359774,
            52.588249,
            114.275112
          ],
          [
            16.360043,
            52.588391,
            114.773963
          ],
          [
            16.360331,
            52.588551,
            115.320287
          ],
          [
            16.360628,
            52.588722,
            115.892737
          ],
          [
            16.360895,
            52.588891,
            116.432242
          ],
          [
            16.36118,
            52.589048,
            116.970894
          ],
          [
            16.361484,
            52.589202,
            117.52466
          ],
          [
            16.361753,
            52.589363,
            118.053355
          ],
          [
            16.362009,
            52.589518,
            118.593946
          ],
          [
            16.362285,
            52.589681,
            119.172362
          ],
          [
            16.362515,
            52.589831,
            119.682218
          ],
          [
            16.362806,
            52.589981,
            120.256033
          ],
          [
            16.363086,
            52.590141,
            120.834263
          ],
          [
            16.363373,
            52.590296,
            121.411224
          ],
          [
            16.363657,
            52.590444,
            121.973431
          ],
          [
            16.363936,
            52.590582,
            122.514002
          ],
          [
            16.364233,
            52.590717,
            122.773586
          ],
          [
            16.364531,
            52.590872,
            123.035326
          ],
          [
            16.364819,
            52.591002,
            123.275011
          ],
          [
            16.365115,
            52.591172,
            123.546965
          ],
          [
            16.365395,
            52.591341,
            123.810303
          ],
          [
            16.36567,
            52.591496,
            124.060588
          ],
          [
            16.365913,
            52.591649,
            124.294312
          ],
          [
            16.366181,
            52.591773,
            124.513369
          ],
          [
            16.366448,
            52.591928,
            124.585238
          ],
          [
            16.366733,
            52.592099,
            124.663155
          ],
          [
            16.36705,
            52.592266,
            124.744778
          ],
          [
            16.367341,
            52.592427,
            124.821381
          ],
          [
            16.367634,
            52.592581,
            124.896743
          ],
          [
            16.367903,
            52.592734,
            124.968566
          ],
          [
            16.368162,
            52.592884,
            125.038256
          ],
          [
            16.368421,
            52.593051,
            124.991586
          ],
          [
            16.368703,
            52.593188,
            124.725394
          ],
          [
            16.368969,
            52.593341,
            124.456556
          ],
          [
            16.369219,
            52.593495,
            124.195285
          ],
          [
            16.369485,
            52.593647,
            123.927301
          ],
          [
            16.369765,
            52.593796,
            123.654125
          ],
          [
            16.370019,
            52.593953,
            123.386957
          ],
          [
            16.370267,
            52.594096,
            123.136045
          ],
          [
            16.370531,
            52.594258,
            122.963972
          ],
          [
            16.370797,
            52.594427,
            123.228557
          ],
          [
            16.371062,
            52.594574,
            123.475218
          ],
          [
            16.371327,
            52.594718,
            123.719566
          ],
          [
            16.3716,
            52.594841,
            123.953107
          ],
          [
            16.371891,
            52.594998,
            124.220514
          ],
          [
            16.372146,
            52.595154,
            124.469175
          ],
          [
            16.372443,
            52.595293,
            124.726773
          ],
          [
            16.372748,
            52.59545,
            124.839819
          ],
          [
            16.373048,
            52.595588,
            124.326838
          ],
          [
            16.373268,
            52.595731,
            123.886058
          ],
          [
            16.373533,
            52.595881,
            123.39208
          ],
          [
            16.373789,
            52.596025,
            122.917443
          ],
          [
            16.374022,
            52.596169,
            122.464766
          ],
          [
            16.374268,
            52.596296,
            122.024941
          ],
          [
            16.374514,
            52.596465,
            121.519713
          ],
          [
            16.374781,
            52.596604,
            121.041133
          ],
          [
            16.375069,
            52.596766,
            121.2404
          ],
          [
            16.375357,
            52.596856,
            121.583058
          ],
          [
            16.375624,
            52.597011,
            121.972836
          ],
          [
            16.375865,
            52.597159,
            122.33612
          ],
          [
            16.376116,
            52.597276,
            122.670309
          ],
          [
            16.376393,
            52.59743,
            123.067111
          ],
          [
            16.376651,
            52.597545,
            123.406663
          ],
          [
            16.376928,
            52.597725,
            123.835655
          ],
          [
            16.377128,
            52.597919,
            123.904841
          ],
          [
            16.377335,
            52.5981,
            123.630529
          ],
          [
            16.377574,
            52.598225,
            123.391951
          ],
          [
            16.377815,
            52.598363,
            123.142088
          ],
          [
            16.378124,
            52.598475,
            122.870842
          ],
          [
            16.3784,
            52.598633,
            122.585012
          ],
          [
            16.378667,
            52.598781,
            122.312425
          ],
          [
            16.378938,
            52.598938,
            122.029917
          ],
          [
            16.379202,
            52.599077,
            121.679443
          ],
          [
            16.379501,
            52.599203,
            120.90422
          ],
          [
            16.379794,
            52.599342,
            120.114923
          ],
          [
            16.380061,
            52.599497,
            119.328702
          ],
          [
            16.380336,
            52.599668,
            118.495444
          ],
          [
            16.380606,
            52.599777,
            117.788639
          ],
          [
            16.380879,
            52.59994,
            116.967831
          ],
          [
            16.381172,
            52.600084,
            116.16983
          ],
          [
            16.38147,
            52.60014,
            115.521335
          ],
          [
            16.381733,
            52.600314,
            115.033507
          ],
          [
            16.381919,
            52.60047,
            114.63954
          ],
          [
            16.382116,
            52.600668,
            114.165082
          ],
          [
            16.38238,
            52.60081,
            113.727042
          ],
          [
            16.382612,
            52.600944,
            113.328841
          ],
          [
            16.382864,
            52.601094,
            112.890176
          ],
          [
            16.383143,
            52.601255,
            112.412067
          ],
          [
            16.383465,
            52.601377,
            111.939691
          ],
          [
            16.383729,
            52.601527,
            112.569744
          ],
          [
            16.383996,
            52.601677,
            113.430235
          ],
          [
            16.384294,
            52.601782,
            114.251774
          ],
          [
            16.384538,
            52.601985,
            115.228625
          ],
          [
            16.384804,
            52.602141,
            116.100762
          ],
          [
            16.385052,
            52.602314,
            116.991927
          ],
          [
            16.385322,
            52.602467,
            117.86307
          ],
          [
            16.385595,
            52.60264,
            118.795844
          ],
          [
            16.385898,
            52.602805,
            118.757849
          ],
          [
            16.386189,
            52.603001,
            118.657197
          ],
          [
            16.386439,
            52.603152,
            118.575261
          ],
          [
            16.386709,
            52.603307,
            118.489233
          ],
          [
            16.386967,
            52.603452,
            118.407833
          ],
          [
            16.387236,
            52.603598,
            118.324296
          ],
          [
            16.387464,
            52.603751,
            118.245528
          ],
          [
            16.3877,
            52.603874,
            118.173472
          ],
          [
            16.387975,
            52.604006,
            118.404112
          ],
          [
            16.388182,
            52.604143,
            118.652873
          ],
          [
            16.388481,
            52.60426,
            118.941419
          ],
          [
            16.388765,
            52.604407,
            119.244172
          ],
          [
            16.389026,
            52.604552,
            119.53112
          ],
          [
            16.389322,
            52.604726,
            119.865402
          ],
          [
            16.389594,
            52.604907,
            120.192817
          ],
          [
            16.389866,
            52.605067,
            120.500326
          ],
          [
            16.390155,
            52.605248,
            120.752657
          ],
          [
            16.390416,
            52.605413,
            120.963858
          ],
          [
            16.390672,
            52.605575,
            121.170991
          ],
          [
            16.390979,
            52.60574,
            121.401103
          ],
          [
            16.391262,
            52.605877,
            121.603998
          ],
          [
            16.391518,
            52.606058,
            121.824134
          ],
          [
            16.391786,
            52.606219,
            122.035333
          ],
          [
            16.392075,
            52.606359,
            122.204275
          ],
          [
            16.392363,
            52.606486,
            122.016584
          ],
          [
            16.392611,
            52.606601,
            121.851139
          ],
          [
            16.39287,
            52.60677,
            121.649792
          ],
          [
            16.393095,
            52.606928,
            121.468487
          ],
          [
            16.393367,
            52.607088,
            121.268782
          ],
          [
            16.393639,
            52.607228,
            121.080896
          ],
          [
            16.393944,
            52.607415,
            120.851961
          ],
          [
            16.394212,
            52.607575,
            120.65464
          ],
          [
            16.39448,
            52.607745,
            120.46972
          ],
          [
            16.394771,
            52.60789,
            120.290455
          ],
          [
            16.395044,
            52.608019,
            120.125686
          ],
          [
            16.395322,
            52.608148,
            119.958322
          ],
          [
            16.395646,
            52.608303,
            119.761919
          ],
          [
            16.395917,
            52.608435,
            119.596122
          ],
          [
            16.39617,
            52.608578,
            119.431655
          ],
          [
            16.396463,
            52.608744,
            119.237783
          ],
          [
            16.39672,
            52.608892,
            119.027168
          ],
          [
            16.396991,
            52.609078,
            118.783956
          ],
          [
            16.397234,
            52.609228,
            118.57705
          ],
          [
            16.3975,
            52.609377,
            118.361642
          ],
          [
            16.397768,
            52.609514,
            118.153301
          ],
          [
            16.398068,
            52.609659,
            117.925002
          ],
          [
            16.398313,
            52.609809,
            117.718123
          ],
          [
            16.398611,
            52.609986,
            117.468766
          ],
          [
            16.398841,
            52.610135,
            117.262541
          ],
          [
            16.399143,
            52.610267,
            117.035931
          ],
          [
            16.399423,
            52.61041,
            116.813157
          ],
          [
            16.399719,
            52.61057,
            116.57182
          ],
          [
            16.399967,
            52.610735,
            116.347787
          ],
          [
            16.400222,
            52.610908,
            116.114367
          ],
          [
            16.400538,
            52.61107,
            115.86246
          ],
          [
            16.400834,
            52.611233,
            115.898178
          ],
          [
            16.401145,
            52.611383,
            116.626307
          ],
          [
            16.401397,
            52.611547,
            117.305234
          ],
          [
            16.401664,
            52.611702,
            117.981118
          ],
          [
            16.401957,
            52.611859,
            118.696082
          ],
          [
            16.402221,
            52.612013,
            119.368239
          ],
          [
            16.402523,
            52.612155,
            120.067283
          ],
          [
            16.402816,
            52.612344,
            120.849063
          ],
          [
            16.403052,
            52.612478,
            120.930012
          ],
          [
            16.403317,
            52.612614,
            120.595983
          ],
          [
            16.403635,
            52.612749,
            120.22281
          ],
          [
            16.403946,
            52.612872,
            119.86582
          ],
          [
            16.404265,
            52.612966,
            119.52389
          ],
          [
            16.404615,
            52.613029,
            119.172327
          ],
          [
            16.404977,
            52.613096,
            118.808366
          ],
          [
            16.405371,
            52.613175,
            118.408796
          ],
          [
            16.405669,
            52.613237,
            118.144854
          ],
          [
            16.405706,
            52.613273,
            117.896184
          ],
          [
            16.405394,
            52.613206,
            117.661108
          ],
          [
            16.405094,
            52.613136,
            117.433402
          ],
          [
            16.404729,
            52.613065,
            117.161825
          ],
          [
            16.404448,
            52.613003,
            116.949936
          ],
          [
            16.404094,
            52.612924,
            116.682758
          ],
          [
            16.404135,
            52.613082,
            116.45993
          ],
          [
            16.404409,
            52.613217,
            116.209382
          ],
          [
            16.404654,
            52.613354,
            116.280773
          ],
          [
            16.404894,
            52.613494,
            116.434915
          ],
          [
            16.405149,
            52.613633,
            116.593778
          ],
          [
            16.405379,
            52.613775,
            116.745932
          ],
          [
            16.405624,
            52.613899,
            116.89368
          ],
          [
            16.40588,
            52.614036,
            117.051725
          ],
          [
            16.406114,
            52.614188,
            117.210479
          ],
          [
            16.406352,
            52.614328,
            117.363963
          ],
          [
            16.406626,
            52.614457,
            117.524982
          ],
          [
            16.406897,
            52.61459,
            117.745293
          ],
          [
            16.407149,
            52.61471,
            117.949742
          ],
          [
            16.407409,
            52.614867,
            118.183781
          ],
          [
            16.407631,
            52.615025,
            118.402176
          ],
          [
            16.407892,
            52.615172,
            118.629595
          ],
          [
            16.408147,
            52.615318,
            118.853326
          ],
          [
            16.408385,
            52.615459,
            119.065628
          ],
          [
            16.408652,
            52.615583,
            119.280166
          ],
          [
            16.408941,
            52.615729,
            119.331491
          ],
          [
            16.409179,
            52.615864,
            119.141923
          ],
          [
            16.409391,
            52.616009,
            118.955127
          ],
          [
            16.40964,
            52.616143,
            118.761462
          ],
          [
            16.409883,
            52.61627,
            118.574817
          ],
          [
            16.410112,
            52.616394,
            118.396241
          ],
          [
            16.410377,
            52.616538,
            118.189272
          ],
          [
            16.4106,
            52.616666,
            118.010656
          ],
          [
            16.410816,
            52.616798,
            117.832089
          ],
          [
            16.411084,
            52.61694,
            117.688541
          ],
          [
            16.411335,
            52.617081,
            117.664229
          ],
          [
            16.411585,
            52.61722,
            117.640099
          ],
          [
            16.411878,
            52.617365,
            117.613226
          ],
          [
            16.412127,
            52.617513,
            117.588412
          ],
          [
            16.412397,
            52.617679,
            117.561095
          ],
          [
            16.412656,
            52.617826,
            117.53589
          ],
          [
            16.412887,
            52.617959,
            117.513259
          ],
          [
            16.41313,
            52.618097,
            117.489601
          ],
          [
            16.413379,
            52.618232,
            117.191382
          ],
          [
            16.413639,
            52.618363,
            116.852443
          ],
          [
            16.413904,
            52.618501,
            116.502923
          ],
          [
            16.414166,
            52.618659,
            116.133014
          ],
          [
            16.414429,
            52.618799,
            115.782758
          ],
          [
            16.414711,
            52.618947,
            115.409521
          ],
          [
            16.414996,
            52.619103,
            115.025355
          ],
          [
            16.41526,
            52.619251,
            114.665594
          ],
          [
            16.415528,
            52.619393,
            114.428949
          ],
          [
            16.415793,
            52.619532,
            114.276209
          ],
          [
            16.416022,
            52.61968,
            114.130437
          ],
          [
            16.416313,
            52.619839,
            113.959893
          ],
          [
            16.416555,
            52.619979,
            113.814278
          ],
          [
            16.416779,
            52.620131,
            113.667933
          ],
          [
            16.417026,
            52.620267,
            113.522618
          ],
          [
            16.417265,
            52.620409,
            113.376771
          ],
          [
            16.417511,
            52.620568,
            113.223574
          ],
          [
            16.417811,
            52.6207,
            113.118886
          ],
          [
            16.418068,
            52.620829,
            113.024582
          ],
          [
            16.418311,
            52.620953,
            112.93485
          ],
          [
            16.418536,
            52.621111,
            112.837494
          ],
          [
            16.418824,
            52.621243,
            112.735577
          ],
          [
            16.419082,
            52.621383,
            112.637807
          ],
          [
            16.419368,
            52.621541,
            112.528597
          ],
          [
            16.419596,
            52.621699,
            112.430814
          ],
          [
            16.419864,
            52.621833,
            112.596609
          ],
          [
            16.420089,
            52.621975,
            112.902125
          ],
          [
            16.420325,
            52.6221,
            113.196427
          ],
          [
            16.420569,
            52.62224,
            113.511887
          ],
          [
            16.420802,
            52.622384,
            113.825204
          ],
          [
            16.42106,
            52.622525,
            114.151607
          ],
          [
            16.42129,
            52.62266,
            114.452233
          ],
          [
            16.421519,
            52.6228,
            114.75777
          ],
          [
            16.42176,
            52.622927,
            115.060381
          ],
          [
            16.42196,
            52.623083,
            115.040073
          ],
          [
            16.422097,
            52.623259,
            114.82242
          ],
          [
            16.422302,
            52.623422,
            114.593537
          ],
          [
            16.422508,
            52.623594,
            114.356158
          ],
          [
            16.422778,
            52.623751,
            114.10282
          ],
          [
            16.423026,
            52.623864,
            113.892305
          ],
          [
            16.423297,
            52.623963,
            113.6779
          ],
          [
            16.423595,
            52.624049,
            113.454328
          ],
          [
            16.423888,
            52.624108,
            113.245182
          ],
          [
            16.424201,
            52.624185,
            112.744077
          ],
          [
            16.424527,
            52.624264,
            112.084617
          ],
          [
            16.424912,
            52.624351,
            111.312618
          ],
          [
            16.425295,
            52.624445,
            110.537048
          ],
          [
            16.425639,
            52.624534,
            109.831664
          ],
          [
            16.425995,
            52.624595,
            109.137135
          ],
          [
            16.426366,
            52.624696,
            108.373913
          ],
          [
            16.426759,
            52.624791,
            107.561793
          ],
          [
            16.427156,
            52.624892,
            106.240311
          ],
          [
            16.427562,
            52.625001,
            104.878375
          ],
          [
            16.427978,
            52.625103,
            103.501653
          ],
          [
            16.428375,
            52.625199,
            102.190808
          ],
          [
            16.4288,
            52.62528,
            100.809712
          ],
          [
            16.429215,
            52.625342,
            99.498788
          ],
          [
            16.429633,
            52.625455,
            98.495081
          ],
          [
            16.430029,
            52.62559,
            98.413467
          ],
          [
            16.43038,
            52.625644,
            98.348308
          ],
          [
            16.430793,
            52.625761,
            98.266961
          ],
          [
            16.431155,
            52.625933,
            98.184451
          ],
          [
            16.431432,
            52.626148,
            98.104147
          ],
          [
            16.431655,
            52.626354,
            98.031706
          ],
          [
            16.431844,
            52.626518,
            98.025171
          ],
          [
            16.432107,
            52.626701,
            98.1482
          ],
          [
            16.432362,
            52.626827,
            98.249331
          ],
          [
            16.432701,
            52.626922,
            98.364078
          ],
          [
            16.433027,
            52.626998,
            98.471402
          ],
          [
            16.433364,
            52.627028,
            98.576077
          ],
          [
            16.433714,
            52.627031,
            98.683658
          ],
          [
            16.43407,
            52.627051,
            98.793554
          ],
          [
            16.434441,
            52.627073,
            98.907518
          ],
          [
            16.434837,
            52.62709,
            99.016424
          ],
          [
            16.435233,
            52.627111,
            99.125479
          ],
          [
            16.435614,
            52.627128,
            99.23029
          ],
          [
            16.436027,
            52.627137,
            99.343711
          ],
          [
            16.436331,
            52.627143,
            99.427169
          ],
          [
            16.436753,
            52.627146,
            99.543261
          ],
          [
            16.437147,
            52.627117,
            99.652153
          ],
          [
            16.437529,
            52.627093,
            99.691981
          ],
          [
            16.437932,
            52.627051,
            99.629294
          ],
          [
            16.438324,
            52.626997,
            99.567647
          ],
          [
            16.438639,
            52.626912,
            99.514811
          ],
          [
            16.438976,
            52.626802,
            99.456056
          ],
          [
            16.439317,
            52.626637,
            99.389195
          ],
          [
            16.439677,
            52.626522,
            99.326843
          ],
          [
            16.439957,
            52.62639,
            99.272506
          ],
          [
            16.440258,
            52.626251,
            99.489181
          ],
          [
            16.440583,
            52.626119,
            99.780445
          ],
          [
            16.440897,
            52.62599,
            100.062874
          ],
          [
            16.441234,
            52.625862,
            100.358975
          ],
          [
            16.441585,
            52.62577,
            100.643951
          ],
          [
            16.441943,
            52.625729,
            100.915407
          ],
          [
            16.442297,
            52.625697,
            101.182112
          ],
          [
            16.442653,
            52.62569,
            101.447415
          ],
          [
            16.443006,
            52.625714,
            101.582328
          ],
          [
            16.44332,
            52.625736,
            101.692538
          ],
          [
            16.443677,
            52.625753,
            101.817308
          ],
          [
            16.444045,
            52.625799,
            101.948238
          ],
          [
            16.444424,
            52.625845,
            102.08295
          ],
          [
            16.444772,
            52.625925,
            102.212731
          ],
          [
            16.445145,
            52.625993,
            102.348405
          ],
          [
            16.44553,
            52.626066,
            102.488909
          ],
          [
            16.445937,
            52.626113,
            102.666036
          ],
          [
            16.446293,
            52.626156,
            102.823718
          ],
          [
            16.44667,
            52.626219,
            102.993852
          ],
          [
            16.446979,
            52.626258,
            103.131315
          ],
          [
            16.447308,
            52.626328,
            103.282802
          ],
          [
            16.447667,
            52.626376,
            103.442579
          ],
          [
            16.447991,
            52.626433,
            103.589154
          ],
          [
            16.448298,
            52.626478,
            103.72662
          ],
          [
            16.448613,
            52.626501,
            104.259901
          ],
          [
            16.448941,
            52.626517,
            105.139071
          ],
          [
            16.44909,
            52.626642,
            105.976043
          ],
          [
            16.449054,
            52.626804,
            106.763145
          ],
          [
            16.44898,
            52.626626,
            107.625712
          ],
          [
            16.449117,
            52.626476,
            108.449118
          ],
          [
            16.449192,
            52.626433,
            109.414262
          ],
          [
            16.449408,
            52.626555,
            110.218833
          ],
          [
            16.449673,
            52.626652,
            111.091508
          ],
          [
            16.449918,
            52.626724,
            111.6034
          ],
          [
            16.450254,
            52.626737,
            111.278739
          ],
          [
            16.450551,
            52.626748,
            110.992432
          ],
          [
            16.450882,
            52.626733,
            110.67322
          ],
          [
            16.451208,
            52.626731,
            110.359351
          ],
          [
            16.451569,
            52.626741,
            110.011164
          ],
          [
            16.451946,
            52.626769,
            109.645945
          ],
          [
            16.452335,
            52.626764,
            109.27128
          ],
          [
            16.452642,
            52.626747,
            108.973703
          ],
          [
            16.452969,
            52.62666,
            108.933591
          ],
          [
            16.45318,
            52.626499,
            109.052974
          ],
          [
            16.453371,
            52.626356,
            109.159549
          ],
          [
            16.453614,
            52.626192,
            109.287234
          ],
          [
            16.453814,
            52.626038,
            109.400753
          ],
          [
            16.454012,
            52.625879,
            109.516151
          ],
          [
            16.454214,
            52.625725,
            109.630109
          ],
          [
            16.454426,
            52.62558,
            109.742326
          ],
          [
            16.454643,
            52.625423,
            109.860951
          ],
          [
            16.454828,
            52.625258,
            109.971629
          ],
          [
            16.455003,
            52.625099,
            110.07599
          ],
          [
            16.455181,
            52.624901,
            110.199069
          ],
          [
            16.455366,
            52.62471,
            110.320068
          ],
          [
            16.455536,
            52.62454,
            110.428672
          ],
          [
            16.455716,
            52.624358,
            110.544586
          ],
          [
            16.455886,
            52.624191,
            110.651701
          ],
          [
            16.456086,
            52.623992,
            110.77893
          ],
          [
            16.456244,
            52.623834,
            110.871065
          ],
          [
            16.456421,
            52.62367,
            110.855152
          ],
          [
            16.456598,
            52.623488,
            110.838042
          ],
          [
            16.456781,
            52.623286,
            110.819372
          ],
          [
            16.456947,
            52.623099,
            110.802167
          ],
          [
            16.457105,
            52.622925,
            110.786081
          ],
          [
            16.457284,
            52.622746,
            110.76913
          ],
          [
            16.457452,
            52.622559,
            110.751878
          ],
          [
            16.457603,
            52.622392,
            110.736444
          ],
          [
            16.457802,
            52.622203,
            110.749044
          ],
          [
            16.457989,
            52.622019,
            110.796277
          ],
          [
            16.458159,
            52.621849,
            110.839728
          ],
          [
            16.45832,
            52.621687,
            110.881097
          ],
          [
            16.458498,
            52.621507,
            110.926956
          ],
          [
            16.458673,
            52.621329,
            110.972232
          ],
          [
            16.458841,
            52.621151,
            111.017054
          ],
          [
            16.459002,
            52.620967,
            111.062575
          ],
          [
            16.459164,
            52.620806,
            111.103789
          ],
          [
            16.459362,
            52.620662,
            111.056271
          ],
          [
            16.459544,
            52.620501,
            110.949463
          ],
          [
            16.459729,
            52.620348,
            110.845899
          ],
          [
            16.459999,
            52.620226,
            110.732426
          ],
          [
            16.460218,
            52.620073,
            110.62185
          ],
          [
            16.460401,
            52.619903,
            110.511079
          ],
          [
            16.460593,
            52.619739,
            110.401375
          ],
          [
            16.460781,
            52.619572,
            110.291005
          ],
          [
            16.460988,
            52.619406,
            110.177496
          ],
          [
            16.461177,
            52.619244,
            110.28162
          ],
          [
            16.461372,
            52.619082,
            110.505891
          ],
          [
            16.461574,
            52.618923,
            110.73075
          ],
          [
            16.461752,
            52.618763,
            110.94661
          ],
          [
            16.461945,
            52.618602,
            111.169244
          ],
          [
            16.462158,
            52.618432,
            111.40797
          ],
          [
            16.462376,
            52.618282,
            111.631561
          ],
          [
            16.462585,
            52.618128,
            111.85458
          ],
          [
            16.46281,
            52.617945,
            112.109845
          ],
          [
            16.463009,
            52.617764,
            112.263201
          ],
          [
            16.46323,
            52.617601,
            112.395189
          ],
          [
            16.463459,
            52.617439,
            112.528651
          ],
          [
            16.463579,
            52.617255,
            112.653428
          ],
          [
            16.463724,
            52.617085,
            112.773576
          ],
          [
            16.463943,
            52.616908,
            112.912109
          ],
          [
            16.464167,
            52.616725,
            113.05462
          ],
          [
            16.464411,
            52.616522,
            113.211702
          ],
          [
            16.464666,
            52.616311,
            113.117806
          ],
          [
            16.464905,
            52.616122,
            112.890488
          ],
          [
            16.465154,
            52.615913,
            112.64451
          ],
          [
            16.465409,
            52.615702,
            112.394953
          ],
          [
            16.465647,
            52.615506,
            112.162683
          ],
          [
            16.465886,
            52.615304,
            111.925548
          ],
          [
            16.466129,
            52.6151,
            111.68552
          ],
          [
            16.466367,
            52.614915,
            111.659082
          ],
          [
            16.466597,
            52.614723,
            111.893907
          ],
          [
            16.466827,
            52.614536,
            112.124785
          ],
          [
            16.467039,
            52.614352,
            112.347059
          ],
          [
            16.467255,
            52.614151,
            112.584452
          ],
          [
            16.467493,
            52.613963,
            112.818989
          ],
          [
            16.467736,
            52.613771,
            113.058488
          ],
          [
            16.467962,
            52.613589,
            113.283937
          ],
          [
            16.468198,
            52.613396,
            113.410548
          ],
          [
            16.468433,
            52.613208,
            113.50308
          ],
          [
            16.468688,
            52.613024,
            113.597387
          ],
          [
            16.468923,
            52.612831,
            113.691625
          ],
          [
            16.469158,
            52.61263,
            113.788237
          ],
          [
            16.469402,
            52.612438,
            113.88329
          ],
          [
            16.469614,
            52.612244,
            113.974577
          ],
          [
            16.469843,
            52.612066,
            114.081678
          ],
          [
            16.470071,
            52.611879,
            114.25505
          ],
          [
            16.470291,
            52.611706,
            114.417966
          ],
          [
            16.470513,
            52.611534,
            114.580811
          ],
          [
            16.470708,
            52.611378,
            114.726743
          ],
          [
            16.470886,
            52.611219,
            114.870071
          ],
          [
            16.471092,
            52.611055,
            115.023763
          ],
          [
            16.471324,
            52.610879,
            115.191966
          ],
          [
            16.471516,
            52.610713,
            115.343172
          ],
          [
            16.471731,
            52.610537,
            115.691282
          ],
          [
            16.471948,
            52.61036,
            116.101438
          ],
          [
            16.472171,
            52.610175,
            116.527498
          ],
          [
            16.472371,
            52.610014,
            116.902226
          ],
          [
            16.472581,
            52.609844,
            117.297107
          ],
          [
            16.47282,
            52.609669,
            117.719758
          ],
          [
            16.473017,
            52.609503,
            118.099952
          ],
          [
            16.473224,
            52.609343,
            118.478317
          ],
          [
            16.473463,
            52.609163,
            118.822548
          ],
          [
            16.47366,
            52.60899,
            119.030726
          ],
          [
            16.47387,
            52.608809,
            119.249887
          ],
          [
            16.474039,
            52.608649,
            119.438019
          ],
          [
            16.474254,
            52.608474,
            119.654141
          ],
          [
            16.474454,
            52.608328,
            119.842342
          ],
          [
            16.474662,
            52.608163,
            120.048238
          ],
          [
            16.474849,
            52.607998,
            120.246518
          ],
          [
            16.475034,
            52.607834,
            120.44326
          ],
          [
            16.475256,
            52.607668,
            120.711679
          ],
          [
            16.475567,
            52.607603,
            120.993778
          ],
          [
            16.475931,
            52.607589,
            121.296084
          ],
          [
            16.476235,
            52.607557,
            121.551684
          ],
          [
            16.476527,
            52.607489,
            121.810809
          ],
          [
            16.476867,
            52.607441,
            122.10003
          ],
          [
            16.477221,
            52.607396,
            122.39965
          ],
          [
            16.477562,
            52.607344,
            122.69099
          ],
          [
            16.477876,
            52.60727,
            122.946384
          ],
          [
            16.478204,
            52.607221,
            122.649907
          ],
          [
            16.478562,
            52.607176,
            122.328636
          ],
          [
            16.4789,
            52.607138,
            122.02726
          ],
          [
            16.479227,
            52.607088,
            121.731018
          ],
          [
            16.479631,
            52.607013,
            121.360557
          ],
          [
            16.480006,
            52.606967,
            121.02429
          ],
          [
            16.480389,
            52.606901,
            120.673524
          ],
          [
            16.480752,
            52.606854,
            120.362123
          ],
          [
            16.481112,
            52.606789,
            120.36463
          ],
          [
            16.481495,
            52.606734,
            120.367256
          ],
          [
            16.481869,
            52.606678,
            120.369827
          ],
          [
            16.482237,
            52.606626,
            120.372346
          ],
          [
            16.482577,
            52.606559,
            120.37473
          ],
          [
            16.4829,
            52.606468,
            120.377106
          ],
          [
            16.48323,
            52.606358,
            120.379617
          ],
          [
            16.483553,
            52.606246,
            120.432362
          ],
          [
            16.483877,
            52.606125,
            120.817301
          ],
          [
            16.484217,
            52.605987,
            121.232398
          ],
          [
            16.484539,
            52.605828,
            121.652971
          ],
          [
            16.48488,
            52.605707,
            122.053197
          ],
          [
            16.485155,
            52.605601,
            122.382793
          ],
          [
            16.485455,
            52.605523,
            122.72133
          ],
          [
            16.48579,
            52.605486,
            123.066951
          ],
          [
            16.486073,
            52.605396,
            123.354265
          ],
          [
            16.486352,
            52.605275,
            122.673242
          ],
          [
            16.486618,
            52.605152,
            122.011063
          ],
          [
            16.486898,
            52.60504,
            121.346661
          ],
          [
            16.487171,
            52.604933,
            120.703036
          ],
          [
            16.487464,
            52.604829,
            120.031086
          ],
          [
            16.487759,
            52.604735,
            119.37149
          ],
          [
            16.48805,
            52.604668,
            118.755175
          ],
          [
            16.488326,
            52.604567,
            118.117197
          ],
          [
            16.488643,
            52.604447,
            117.413099
          ],
          [
            16.488934,
            52.604357,
            116.93504
          ],
          [
            16.489231,
            52.604247,
            116.425392
          ],
          [
            16.489556,
            52.604144,
            115.888649
          ],
          [
            16.489894,
            52.604027,
            115.319913
          ],
          [
            16.490207,
            52.603915,
            114.788992
          ],
          [
            16.490514,
            52.603803,
            114.265644
          ],
          [
            16.490843,
            52.603679,
            113.699788
          ],
          [
            16.491132,
            52.603576,
            113.208648
          ],
          [
            16.491434,
            52.603481,
            112.863743
          ],
          [
            16.491741,
            52.603364,
            112.503791
          ],
          [
            16.492013,
            52.603267,
            112.19029
          ],
          [
            16.492279,
            52.603172,
            111.883831
          ],
          [
            16.492559,
            52.603084,
            111.570731
          ],
          [
            16.492856,
            52.602966,
            111.218268
          ],
          [
            16.493154,
            52.602851,
            110.867605
          ],
          [
            16.49348,
            52.602749,
            110.503404
          ],
          [
            16.493796,
            52.602636,
            110.38783
          ],
          [
            16.494093,
            52.602517,
            110.856566
          ],
          [
            16.494431,
            52.602393,
            111.376772
          ],
          [
            16.494757,
            52.60229,
            111.861338
          ],
          [
            16.495073,
            52.602199,
            112.322261
          ],
          [
            16.495383,
            52.602132,
            112.755789
          ],
          [
            16.495698,
            52.602066,
            113.195989
          ],
          [
            16.496006,
            52.601996,
            113.62945
          ],
          [
            16.496292,
            52.601924,
            114.03865
          ],
          [
            16.496627,
            52.601852,
            114.212505
          ],
          [
            16.49692,
            52.60177,
            114.289441
          ],
          [
            16.497226,
            52.6017,
            114.36738
          ],
          [
            16.497547,
            52.601618,
            114.450419
          ],
          [
            16.49786,
            52.601539,
            114.531216
          ],
          [
            16.498201,
            52.601466,
            114.617396
          ],
          [
            16.498526,
            52.60139,
            114.700408
          ],
          [
            16.498875,
            52.601304,
            114.790213
          ],
          [
            16.499148,
            52.601235,
            114.905099
          ],
          [
            16.499441,
            52.601167,
            115.419698
          ],
          [
            16.499743,
            52.601102,
            115.945429
          ],
          [
            16.500079,
            52.601031,
            116.529071
          ],
          [
            16.500394,
            52.600961,
            117.079492
          ],
          [
            16.500717,
            52.600895,
            117.641177
          ],
          [
            16.500994,
            52.600802,
            118.165254
          ],
          [
            16.501283,
            52.600718,
            118.691388
          ],
          [
            16.501626,
            52.600645,
            119.288529
          ],
          [
            16.501995,
            52.600575,
            119.777807
          ],
          [
            16.5023,
            52.600495,
            119.949203
          ],
          [
            16.502612,
            52.600424,
            120.120655
          ],
          [
            16.502904,
            52.600326,
            120.292457
          ],
          [
            16.503221,
            52.600249,
            120.468123
          ],
          [
            16.50354,
            52.60015,
            120.65256
          ],
          [
            16.503819,
            52.600071,
            120.811007
          ],
          [
            16.50415,
            52.600012,
            120.988487
          ],
          [
            16.504473,
            52.59995,
            121.162882
          ],
          [
            16.504792,
            52.599859,
            121.116245
          ],
          [
            16.50508,
            52.599785,
            120.940759
          ],
          [
            16.505417,
            52.599708,
            120.739085
          ],
          [
            16.505814,
            52.59962,
            120.502028
          ],
          [
            16.50622,
            52.599539,
            120.262541
          ],
          [
            16.50658,
            52.599453,
            120.045768
          ],
          [
            16.506891,
            52.599373,
            119.856586
          ],
          [
            16.507218,
            52.599285,
            119.656202
          ],
          [
            16.507528,
            52.599221,
            119.642644
          ],
          [
            16.507868,
            52.599146,
            119.772034
          ],
          [
            16.508192,
            52.599059,
            119.898117
          ],
          [
            16.508547,
            52.598987,
            120.031407
          ],
          [
            16.508863,
            52.598905,
            120.153723
          ],
          [
            16.509275,
            52.598812,
            120.310063
          ],
          [
            16.509678,
            52.598733,
            120.460732
          ],
          [
            16.510058,
            52.598653,
            120.603855
          ],
          [
            16.510439,
            52.598563,
            120.981618
          ],
          [
            16.510787,
            52.598485,
            121.37057
          ],
          [
            16.511168,
            52.598402,
            121.79512
          ],
          [
            16.511507,
            52.598313,
            122.183519
          ],
          [
            16.511835,
            52.598252,
            122.54321
          ],
          [
            16.512155,
            52.59818,
            122.90144
          ],
          [
            16.512533,
            52.598087,
            123.329097
          ],
          [
            16.512846,
            52.598006,
            123.686322
          ],
          [
            16.51315,
            52.597922,
            123.614787
          ],
          [
            16.513492,
            52.597827,
            123.457761
          ],
          [
            16.513856,
            52.597751,
            123.296919
          ],
          [
            16.514191,
            52.597676,
            123.147838
          ],
          [
            16.514555,
            52.597588,
            122.984234
          ],
          [
            16.514902,
            52.597499,
            122.826776
          ],
          [
            16.515247,
            52.597399,
            122.666857
          ],
          [
            16.515535,
            52.597312,
            122.530706
          ],
          [
            16.515907,
            52.597226,
            122.657094
          ],
          [
            16.516267,
            52.597154,
            122.844207
          ],
          [
            16.516586,
            52.59708,
            123.012786
          ],
          [
            16.516878,
            52.597033,
            123.173714
          ],
          [
            16.517213,
            52.59699,
            123.344914
          ],
          [
            16.517523,
            52.596922,
            123.507634
          ],
          [
            16.517859,
            52.59684,
            123.68691
          ],
          [
            16.518153,
            52.596757,
            123.848337
          ],
          [
            16.518417,
            52.596669,
            123.902422
          ],
          [
            16.518688,
            52.596564,
            123.651242
          ],
          [
            16.519005,
            52.596506,
            123.385027
          ],
          [
            16.519326,
            52.59644,
            123.121058
          ],
          [
            16.519637,
            52.596366,
            122.861355
          ],
          [
            16.519952,
            52.596266,
            122.585413
          ],
          [
            16.520274,
            52.596161,
            122.30168
          ],
          [
            16.520652,
            52.596115,
            122.000601
          ],
          [
            16.521027,
            52.596095,
            121.708195
          ],
          [
            16.521357,
            52.596068,
            121.286128
          ],
          [
            16.521711,
            52.59606,
            120.799425
          ],
          [
            16.522084,
            52.596052,
            120.286038
          ],
          [
            16.522406,
            52.596062,
            119.843029
          ],
          [
            16.522775,
            52.596077,
            119.333685
          ],
          [
            16.523178,
            52.596063,
            118.779562
          ],
          [
            16.523481,
            52.596024,
            118.353711
          ],
          [
            16.523826,
            52.596004,
            117.877624
          ],
          [
            16.524203,
            52.595999,
            117.396741
          ],
          [
            16.524621,
            52.596025,
            116.908541
          ],
          [
            16.524961,
            52.596007,
            116.51321
          ],
          [
            16.525316,
            52.596018,
            116.101755
          ],
          [
            16.525642,
            52.596041,
            115.721365
          ],
          [
            16.526009,
            52.596062,
            115.294504
          ],
          [
            16.526413,
            52.596057,
            114.826761
          ],
          [
            16.526817,
            52.596051,
            114.358982
          ],
          [
            16.527179,
            52.596053,
            114.12479
          ],
          [
            16.527548,
            52.596077,
            114.038749
          ],
          [
            16.527871,
            52.596116,
            113.962599
          ],
          [
            16.528224,
            52.596127,
            113.879681
          ],
          [
            16.528581,
            52.596127,
            113.797045
          ],
          [
            16.528987,
            52.596128,
            113.703191
          ],
          [
            16.529407,
            52.596128,
            113.606119
          ],
          [
            16.529812,
            52.596147,
            113.512215
          ],
          [
            16.530165,
            52.596161,
            113.424266
          ],
          [
            16.530563,
            52.596161,
            113.322145
          ],
          [
            16.530923,
            52.596168,
            113.229607
          ],
          [
            16.531273,
            52.596187,
            113.139317
          ],
          [
            16.531586,
            52.596222,
            113.057566
          ],
          [
            16.531956,
            52.596224,
            112.96265
          ],
          [
            16.532324,
            52.596208,
            112.867964
          ],
          [
            16.532755,
            52.596187,
            112.757021
          ],
          [
            16.533175,
            52.596195,
            112.471749
          ],
          [
            16.533534,
            52.596195,
            112.171282
          ],
          [
            16.533898,
            52.596211,
            111.865781
          ],
          [
            16.534262,
            52.596206,
            111.560983
          ],
          [
            16.534692,
            52.596191,
            111.199573
          ],
          [
            16.535069,
            52.596195,
            110.883498
          ],
          [
            16.535439,
            52.596187,
            110.573446
          ],
          [
            16.535802,
            52.596201,
            110.269072
          ],
          [
            16.536113,
            52.596202,
            110.21304
          ],
          [
            16.536409,
            52.596195,
            110.175767
          ],
          [
            16.536709,
            52.596207,
            110.137928
          ],
          [
            16.537073,
            52.596214,
            110.092139
          ],
          [
            16.537376,
            52.596213,
            110.053946
          ],
          [
            16.537684,
            52.596219,
            110.015199
          ],
          [
            16.53805,
            52.596221,
            109.969114
          ],
          [
            16.538474,
            52.596213,
            109.915739
          ],
          [
            16.538874,
            52.596211,
            109.996789
          ],
          [
            16.539255,
            52.596222,
            110.500579
          ],
          [
            16.539625,
            52.596228,
            110.989734
          ],
          [
            16.540005,
            52.596226,
            111.491634
          ],
          [
            16.540418,
            52.596233,
            112.037647
          ],
          [
            16.540843,
            52.596236,
            112.599017
          ],
          [
            16.541265,
            52.596243,
            113.156892
          ],
          [
            16.541702,
            52.596266,
            113.736199
          ],
          [
            16.542113,
            52.596277,
            114.162887
          ],
          [
            16.542526,
            52.596295,
            114.57994
          ],
          [
            16.542927,
            52.596288,
            114.983802
          ],
          [
            16.543333,
            52.596298,
            115.392894
          ],
          [
            16.543748,
            52.596316,
            115.811677
          ],
          [
            16.544149,
            52.596324,
            116.21556
          ],
          [
            16.544522,
            52.596312,
            116.592217
          ],
          [
            16.544888,
            52.596327,
            116.655384
          ],
          [
            16.545302,
            52.596323,
            116.414675
          ],
          [
            16.545706,
            52.596327,
            116.179777
          ],
          [
            16.546081,
            52.596328,
            115.961813
          ],
          [
            16.546453,
            52.596321,
            115.745493
          ],
          [
            16.54682,
            52.596324,
            115.532168
          ],
          [
            16.547122,
            52.596338,
            115.355983
          ],
          [
            16.547464,
            52.596332,
            115.156791
          ],
          [
            16.547825,
            52.596343,
            114.923439
          ],
          [
            16.54817,
            52.596349,
            114.676245
          ],
          [
            16.548519,
            52.596357,
            114.425282
          ],
          [
            16.548838,
            52.596354,
            114.194942
          ],
          [
            16.549223,
            52.596355,
            113.918311
          ],
          [
            16.549572,
            52.59637,
            113.667704
          ],
          [
            16.549918,
            52.596381,
            113.419385
          ],
          [
            16.550282,
            52.596378,
            113.158512
          ],
          [
            16.550697,
            52.596367,
            112.817333
          ],
          [
            16.550999,
            52.596372,
            112.45665
          ],
          [
            16.551348,
            52.596362,
            112.040068
          ],
          [
            16.551748,
            52.59638,
            111.561492
          ],
          [
            16.552129,
            52.596379,
            111.107231
          ],
          [
            16.552482,
            52.596367,
            110.682847
          ],
          [
            16.552842,
            52.596374,
            110.2536
          ],
          [
            16.553223,
            52.596373,
            109.798015
          ],
          [
            16.553605,
            52.596383,
            109.403034
          ],
          [
            16.553977,
            52.596392,
            109.445363
          ],
          [
            16.554324,
            52.596389,
            109.484794
          ],
          [
            16.554647,
            52.596405,
            109.521702
          ],
          [
            16.555005,
            52.596417,
            109.562481
          ],
          [
            16.555364,
            52.596417,
            109.603328
          ],
          [
            16.555711,
            52.596422,
            109.642766
          ],
          [
            16.556063,
            52.596435,
            109.683021
          ],
          [
            16.556402,
            52.596444,
            109.721647
          ],
          [
            16.556754,
            52.596464,
            109.643039
          ],
          [
            16.557105,
            52.596467,
            109.510359
          ],
          [
            16.55738,
            52.596553,
            109.38632
          ],
          [
            16.557739,
            52.596577,
            109.250805
          ],
          [
            16.558114,
            52.596606,
            109.109342
          ],
          [
            16.558467,
            52.59667,
            108.971536
          ],
          [
            16.558872,
            52.596744,
            108.813312
          ],
          [
            16.559267,
            52.596814,
            108.659375
          ],
          [
            16.559673,
            52.596813,
            108.375191
          ],
          [
            16.560017,
            52.596741,
            108.086657
          ],
          [
            16.560334,
            52.596634,
            107.799241
          ],
          [
            16.560738,
            52.596664,
            107.465163
          ],
          [
            16.561105,
            52.596798,
            107.128336
          ],
          [
            16.561425,
            52.596929,
            106.825126
          ],
          [
            16.561766,
            52.597066,
            106.503897
          ],
          [
            16.56208,
            52.597182,
            106.237647
          ],
          [
            16.562389,
            52.597253,
            106.046815
          ],
          [
            16.56274,
            52.597373,
            105.814273
          ],
          [
            16.563098,
            52.597506,
            105.571795
          ],
          [
            16.563427,
            52.597678,
            105.321018
          ],
          [
            16.563761,
            52.597808,
            105.091919
          ],
          [
            16.564069,
            52.597917,
            104.886025
          ],
          [
            16.564344,
            52.59804,
            104.688797
          ],
          [
            16.564519,
            52.598202,
            104.39822
          ],
          [
            16.564807,
            52.598251,
            104.002485
          ],
          [
            16.565113,
            52.598389,
            103.532271
          ],
          [
            16.565432,
            52.598536,
            103.038279
          ],
          [
            16.565745,
            52.598693,
            102.537161
          ],
          [
            16.566073,
            52.598857,
            102.012517
          ],
          [
            16.566403,
            52.599023,
            101.483912
          ],
          [
            16.566683,
            52.599179,
            101.013521
          ],
          [
            16.566933,
            52.599321,
            100.984261
          ],
          [
            16.567188,
            52.599478,
            101.044062
          ],
          [
            16.567474,
            52.599628,
            101.106309
          ],
          [
            16.567748,
            52.599786,
            101.168499
          ],
          [
            16.568046,
            52.599952,
            101.235172
          ],
          [
            16.568343,
            52.600114,
            101.300875
          ],
          [
            16.568637,
            52.600252,
            101.362039
          ],
          [
            16.568903,
            52.600397,
            101.420884
          ],
          [
            16.569187,
            52.600553,
            101.361518
          ],
          [
            16.56945,
            52.600706,
            101.296622
          ],
          [
            16.569674,
            52.600836,
            101.241415
          ],
          [
            16.569913,
            52.600965,
            101.184442
          ],
          [
            16.570218,
            52.601122,
            101.113203
          ],
          [
            16.570513,
            52.601293,
            101.040537
          ],
          [
            16.570786,
            52.601446,
            100.974345
          ],
          [
            16.571075,
            52.601589,
            100.907917
          ],
          [
            16.57137,
            52.601736,
            101.281367
          ],
          [
            16.571647,
            52.601889,
            101.726323
          ],
          [
            16.571904,
            52.602027,
            102.133992
          ],
          [
            16.572155,
            52.602159,
            102.528807
          ],
          [
            16.572384,
            52.602295,
            102.909452
          ],
          [
            16.572608,
            52.60244,
            103.298517
          ],
          [
            16.572866,
            52.60256,
            103.684781
          ],
          [
            16.573101,
            52.602689,
            104.061273
          ],
          [
            16.573341,
            52.602847,
            104.443132
          ],
          [
            16.573577,
            52.602999,
            104.608441
          ],
          [
            16.57387,
            52.603152,
            104.794182
          ],
          [
            16.574087,
            52.603285,
            104.942784
          ],
          [
            16.574345,
            52.603434,
            105.113935
          ],
          [
            16.574572,
            52.603555,
            105.259132
          ],
          [
            16.574799,
            52.603684,
            105.408528
          ],
          [
            16.575044,
            52.603819,
            105.567409
          ],
          [
            16.575319,
            52.603961,
            105.740768
          ],
          [
            16.575578,
            52.604095,
            105.865326
          ],
          [
            16.57587,
            52.60425,
            105.940156
          ],
          [
            16.576148,
            52.604389,
            106.009703
          ],
          [
            16.576504,
            52.604514,
            106.088981
          ],
          [
            16.576847,
            52.604654,
            106.168681
          ],
          [
            16.577208,
            52.604788,
            106.25025
          ],
          [
            16.577511,
            52.604898,
            106.318314
          ],
          [
            16.577889,
            52.605018,
            106.400562
          ],
          [
            16.578203,
            52.605137,
            105.994859
          ],
          [
            16.578547,
            52.605252,
            105.485992
          ],
          [
            16.578846,
            52.605371,
            105.022734
          ],
          [
            16.579177,
            52.605501,
            104.512118
          ],
          [
            16.579453,
            52.605606,
            104.090062
          ],
          [
            16.579746,
            52.605707,
            103.653608
          ],
          [
            16.580017,
            52.605825,
            103.221575
          ],
          [
            16.580338,
            52.605887,
            102.776515
          ],
          [
            16.580632,
            52.605957,
            102.291811
          ],
          [
            16.580913,
            52.606045,
            101.730462
          ],
          [
            16.581225,
            52.60616,
            101.08421
          ],
          [
            16.581562,
            52.606278,
            100.39596
          ],
          [
            16.581863,
            52.606379,
            99.786986
          ],
          [
            16.581858,
            52.606409,
            99.252258
          ],
          [
            16.581557,
            52.606409,
            98.689935
          ],
          [
            16.581255,
            52.606298,
            98.065449
          ],
          [
            16.580944,
            52.606333,
            97.382768
          ],
          [
            16.580659,
            52.606446,
            98.276352
          ],
          [
            16.580334,
            52.606737,
            99.987767
          ],
          [
            16.580268,
            52.606758,
            100.840416
          ],
          [
            16.579967,
            52.606729,
            101.687563
          ],
          [
            16.580541,
            52.606445,
            103.734168
          ],
          [
            16.580557,
            52.606401,
            104.637527
          ],
          [
            16.580616,
            52.606431,
            105.482748
          ],
          [
            16.580631,
            52.606437,
            105.289502
          ],
          [
            16.580776,
            52.606465,
            105.104315
          ],
          [
            16.580998,
            52.606331,
            104.920948
          ],
          [
            16.581239,
            52.606195,
            104.727826
          ],
          [
            16.581566,
            52.606284,
            104.514713
          ],
          [
            16.581851,
            52.606376,
            104.325726
          ],
          [
            16.582143,
            52.606487,
            104.123933
          ],
          [
            16.582438,
            52.606563,
            103.933353
          ],
          [
            16.582762,
            52.606513,
            103.782096
          ],
          [
            16.582887,
            52.606332,
            103.763282
          ],
          [
            16.582982,
            52.60611,
            103.74129
          ],
          [
            16.583092,
            52.605897,
            103.719875
          ],
          [
            16.583218,
            52.605708,
            103.700323
          ],
          [
            16.583306,
            52.605494,
            103.678907
          ],
          [
            16.583381,
            52.605298,
            103.659196
          ],
          [
            16.583469,
            52.605148,
            103.640043
          ],
          [
            16.583713,
            52.605007,
            103.619869
          ],
          [
            16.583929,
            52.604825,
            103.492805
          ],
          [
            16.584199,
            52.604713,
            103.35479
          ],
          [
            16.584462,
            52.604572,
            103.206693
          ],
          [
            16.584735,
            52.604438,
            103.058619
          ],
          [
            16.584976,
            52.604302,
            102.91984
          ],
          [
            16.585226,
            52.604168,
            102.77905
          ],
          [
            16.585503,
            52.604021,
            102.623856
          ],
          [
            16.585775,
            52.60393,
            102.490716
          ],
          [
            16.586077,
            52.603954,
            102.359977
          ],
          [
            16.586291,
            52.6041,
            102.251745
          ],
          [
            16.586506,
            52.604251,
            102.141266
          ],
          [
            16.586783,
            52.604412,
            102.012005
          ],
          [
            16.587021,
            52.604588,
            101.885953
          ],
          [
            16.587271,
            52.60476,
            101.758952
          ],
          [
            16.587552,
            52.604818,
            101.641546
          ],
          [
            16.587856,
            52.604717,
            101.525102
          ],
          [
            16.588199,
            52.604614,
            101.39653
          ],
          [
            16.588549,
            52.604491,
            101.17098
          ],
          [
            16.588817,
            52.604391,
            100.980293
          ],
          [
            16.589171,
            52.604261,
            100.72936
          ],
          [
            16.589481,
            52.604155,
            100.513207
          ],
          [
            16.589788,
            52.604062,
            100.305155
          ],
          [
            16.590071,
            52.603953,
            100.101956
          ],
          [
            16.590337,
            52.603838,
            99.903898
          ],
          [
            16.59065,
            52.603728,
            99.684558
          ],
          [
            16.590951,
            52.60363,
            99.798304
          ],
          [
            16.59131,
            52.603545,
            100.329284
          ],
          [
            16.591604,
            52.603451,
            100.785351
          ],
          [
            16.59189,
            52.603375,
            101.21495
          ],
          [
            16.59221,
            52.603277,
            101.705817
          ],
          [
            16.59252,
            52.603157,
            102.211428
          ],
          [
            16.592794,
            52.60306,
            102.64725
          ],
          [
            16.593064,
            52.602927,
            103.123533
          ],
          [
            16.593345,
            52.602836,
            103.559844
          ],
          [
            16.59366,
            52.60273,
            103.607729
          ],
          [
            16.593949,
            52.602606,
            103.580166
          ],
          [
            16.594224,
            52.602527,
            103.556452
          ],
          [
            16.594541,
            52.602419,
            103.528067
          ],
          [
            16.59484,
            52.602315,
            103.501249
          ],
          [
            16.595126,
            52.602236,
            103.47674
          ],
          [
            16.595401,
            52.602158,
            103.453072
          ],
          [
            16.595732,
            52.60206,
            103.424409
          ],
          [
            16.59604,
            52.601958,
            103.389483
          ],
          [
            16.596329,
            52.601877,
            103.318667
          ],
          [
            16.596624,
            52.60177,
            103.241935
          ],
          [
            16.596894,
            52.601682,
            103.173598
          ],
          [
            16.597168,
            52.601579,
            103.101855
          ],
          [
            16.59747,
            52.601484,
            103.026183
          ],
          [
            16.59775,
            52.601411,
            102.958383
          ],
          [
            16.598045,
            52.601318,
            102.884422
          ],
          [
            16.598352,
            52.601196,
            102.802795
          ],
          [
            16.598634,
            52.601098,
            102.747004
          ],
          [
            16.59893,
            52.601002,
            102.776677
          ],
          [
            16.599233,
            52.600881,
            102.808707
          ],
          [
            16.59954,
            52.60078,
            102.839545
          ],
          [
            16.599868,
            52.60068,
            102.871961
          ],
          [
            16.600166,
            52.60058,
            102.902032
          ],
          [
            16.600448,
            52.600476,
            102.931194
          ],
          [
            16.600796,
            52.600363,
            102.966052
          ],
          [
            16.601125,
            52.600266,
            102.99836
          ],
          [
            16.601415,
            52.600191,
            102.795654
          ],
          [
            16.601731,
            52.600139,
            102.527344
          ],
          [
            16.602061,
            52.600075,
            102.242306
          ],
          [
            16.602422,
            52.599988,
            101.923352
          ],
          [
            16.602772,
            52.599926,
            101.624249
          ],
          [
            16.603161,
            52.599852,
            101.289478
          ],
          [
            16.603476,
            52.599813,
            101.026131
          ],
          [
            16.603826,
            52.59972,
            100.71296
          ],
          [
            16.604196,
            52.599632,
            100.517338
          ],
          [
            16.604567,
            52.599549,
            100.414066
          ],
          [
            16.604862,
            52.599482,
            100.331877
          ],
          [
            16.605186,
            52.59939,
            100.238398
          ],
          [
            16.605489,
            52.599334,
            100.155596
          ],
          [
            16.605806,
            52.599277,
            100.069045
          ],
          [
            16.606152,
            52.599215,
            99.974502
          ],
          [
            16.606547,
            52.599128,
            99.864861
          ],
          [
            16.606875,
            52.599112,
            99.864782
          ],
          [
            16.607236,
            52.599051,
            100.069584
          ],
          [
            16.607539,
            52.598998,
            100.241963
          ],
          [
            16.607928,
            52.598915,
            100.467842
          ],
          [
            16.60834,
            52.598857,
            100.699333
          ],
          [
            16.608705,
            52.598933,
            100.915359
          ],
          [
            16.60901,
            52.598891,
            101.091011
          ],
          [
            16.609262,
            52.598732,
            101.289789
          ],
          [
            16.609568,
            52.598621,
            101.405883
          ],
          [
            16.609781,
            52.598491,
            101.360219
          ],
          [
            16.609995,
            52.598359,
            101.314093
          ],
          [
            16.610199,
            52.598215,
            101.266708
          ],
          [
            16.610442,
            52.598055,
            101.212499
          ],
          [
            16.610634,
            52.597914,
            101.166877
          ],
          [
            16.610867,
            52.597766,
            101.115849
          ],
          [
            16.611115,
            52.597599,
            101.059823
          ],
          [
            16.611345,
            52.597464,
            101.011453
          ],
          [
            16.611578,
            52.597305,
            101.011658
          ],
          [
            16.611787,
            52.597156,
            101.1083
          ],
          [
            16.61203,
            52.596992,
            101.217215
          ],
          [
            16.612279,
            52.596837,
            101.324108
          ],
          [
            16.612544,
            52.596664,
            101.440962
          ],
          [
            16.612814,
            52.596481,
            101.562291
          ],
          [
            16.613002,
            52.596295,
            101.670021
          ],
          [
            16.613293,
            52.59612,
            101.792794
          ],
          [
            16.613522,
            52.595965,
            101.838264
          ],
          [
            16.613758,
            52.595805,
            101.751716
          ],
          [
            16.614001,
            52.595637,
            101.661619
          ],
          [
            16.614239,
            52.595476,
            101.574425
          ],
          [
            16.614478,
            52.595293,
            101.480266
          ],
          [
            16.614742,
            52.595128,
            101.387552
          ],
          [
            16.615002,
            52.594969,
            101.297259
          ],
          [
            16.615267,
            52.594782,
            101.197852
          ],
          [
            16.615538,
            52.59459,
            101.340584
          ],
          [
            16.615776,
            52.594425,
            101.749846
          ],
          [
            16.615977,
            52.594243,
            102.158516
          ],
          [
            16.616171,
            52.594069,
            102.550365
          ],
          [
            16.616368,
            52.593887,
            102.956881
          ],
          [
            16.616569,
            52.593709,
            103.359323
          ],
          [
            16.616797,
            52.593512,
            103.808277
          ],
          [
            16.617,
            52.593332,
            104.215136
          ],
          [
            16.617249,
            52.593144,
            104.341116
          ],
          [
            16.617424,
            52.592934,
            103.962418
          ],
          [
            16.617622,
            52.59276,
            103.621467
          ],
          [
            16.617813,
            52.592583,
            103.280434
          ],
          [
            16.617981,
            52.592404,
            102.94886
          ],
          [
            16.618164,
            52.592259,
            102.654731
          ],
          [
            16.618399,
            52.592114,
            102.32727
          ],
          [
            16.618691,
            52.591977,
            101.966666
          ],
          [
            16.618942,
            52.591847,
            101.644165
          ],
          [
            16.619118,
            52.591686,
            101.41916
          ],
          [
            16.619394,
            52.591538,
            101.186892
          ],
          [
            16.619651,
            52.591415,
            100.980697
          ],
          [
            16.619935,
            52.591291,
            100.760237
          ],
          [
            16.620176,
            52.591175,
            100.566381
          ],
          [
            16.620422,
            52.591051,
            100.364937
          ],
          [
            16.620679,
            52.590931,
            100.16059
          ],
          [
            16.620967,
            52.590814,
            99.942258
          ],
          [
            16.621256,
            52.590674,
            99.747441
          ],
          [
            16.62156,
            52.590536,
            99.894275
          ],
          [
            16.621866,
            52.590396,
            100.042638
          ],
          [
            16.622161,
            52.590256,
            100.187467
          ],
          [
            16.622447,
            52.590109,
            100.332413
          ],
          [
            16.622754,
            52.589967,
            100.481696
          ],
          [
            16.623049,
            52.589825,
            100.627322
          ],
          [
            16.623339,
            52.58968,
            100.772647
          ],
          [
            16.623649,
            52.589533,
            100.949646
          ],
          [
            16.623947,
            52.589385,
            101.178305
          ],
          [
            16.624248,
            52.589233,
            101.410749
          ],
          [
            16.624543,
            52.589088,
            101.636188
          ],
          [
            16.62484,
            52.588946,
            101.860613
          ],
          [
            16.625145,
            52.58881,
            102.085287
          ],
          [
            16.625457,
            52.588673,
            102.3139
          ],
          [
            16.625739,
            52.588543,
            102.524221
          ],
          [
            16.62606,
            52.588402,
            102.739416
          ],
          [
            16.62634,
            52.588263,
            102.919232
          ],
          [
            16.626656,
            52.588126,
            103.112271
          ],
          [
            16.626923,
            52.587996,
            103.282365
          ],
          [
            16.627227,
            52.587852,
            103.474172
          ],
          [
            16.627515,
            52.587718,
            103.654507
          ],
          [
            16.627776,
            52.587567,
            103.8337
          ],
          [
            16.628072,
            52.587425,
            104.021209
          ],
          [
            16.628367,
            52.587295,
            103.816426
          ],
          [
            16.628654,
            52.587155,
            103.250121
          ],
          [
            16.628934,
            52.587019,
            102.698785
          ],
          [
            16.629233,
            52.586891,
            102.135381
          ],
          [
            16.629511,
            52.586763,
            101.597445
          ],
          [
            16.629784,
            52.586618,
            101.03952
          ],
          [
            16.63009,
            52.586469,
            100.436564
          ],
          [
            16.630382,
            52.58633,
            99.866222
          ],
          [
            16.630662,
            52.58621,
            99.662395
          ],
          [
            16.630957,
            52.5861,
            99.921838
          ],
          [
            16.631264,
            52.585984,
            100.193175
          ],
          [
            16.631595,
            52.58587,
            100.478095
          ],
          [
            16.63188,
            52.585763,
            100.728903
          ],
          [
            16.632156,
            52.585687,
            100.955855
          ],
          [
            16.63244,
            52.585594,
            101.197574
          ],
          [
            16.632719,
            52.585484,
            101.446568
          ],
          [
            16.632998,
            52.585391,
            101.68486
          ],
          [
            16.633293,
            52.585306,
            101.821372
          ],
          [
            16.633587,
            52.585194,
            101.901964
          ],
          [
            16.633886,
            52.585071,
            101.985833
          ],
          [
            16.63415,
            52.584949,
            102.062874
          ],
          [
            16.634444,
            52.584802,
            102.151311
          ],
          [
            16.634739,
            52.584651,
            102.241121
          ],
          [
            16.634971,
            52.584537,
            102.31045
          ],
          [
            16.635267,
            52.584366,
            102.405356
          ],
          [
            16.635559,
            52.584229,
            102.610283
          ],
          [
            16.635871,
            52.58408,
            103.059083
          ],
          [
            16.636146,
            52.58394,
            103.464906
          ],
          [
            16.636383,
            52.583808,
            103.828806
          ],
          [
            16.636692,
            52.583714,
            104.22699
          ],
          [
            16.636956,
            52.583597,
            104.596514
          ],
          [
            16.637166,
            52.583468,
            104.934215
          ],
          [
            16.637442,
            52.583328,
            105.340858
          ],
          [
            16.637715,
            52.583196,
            105.735577
          ],
          [
            16.637972,
            52.583064,
            106.056075
          ],
          [
            16.638226,
            52.582942,
            106.350896
          ],
          [
            16.638462,
            52.582799,
            106.65436
          ],
          [
            16.638735,
            52.58266,
            106.979368
          ],
          [
            16.639035,
            52.582515,
            107.328714
          ],
          [
            16.639327,
            52.582372,
            107.670201
          ],
          [
            16.639613,
            52.582213,
            108.023209
          ],
          [
            16.639918,
            52.582044,
            108.399254
          ],
          [
            16.640175,
            52.581934,
            108.452982
          ],
          [
            16.640521,
            52.581762,
            108.341713
          ],
          [
            16.640852,
            52.581603,
            108.236696
          ],
          [
            16.641162,
            52.581445,
            108.135995
          ],
          [
            16.641443,
            52.581297,
            108.043445
          ],
          [
            16.641754,
            52.581134,
            107.941224
          ],
          [
            16.642039,
            52.580986,
            107.847907
          ],
          [
            16.642304,
            52.58086,
            107.771622
          ],
          [
            16.642554,
            52.580724,
            107.954316
          ],
          [
            16.642819,
            52.580603,
            108.134876
          ],
          [
            16.643088,
            52.580481,
            108.317622
          ],
          [
            16.64341,
            52.580309,
            108.551087
          ],
          [
            16.643695,
            52.580167,
            108.75176
          ],
          [
            16.643951,
            52.580045,
            108.928962
          ],
          [
            16.644177,
            52.579915,
            109.098409
          ],
          [
            16.644432,
            52.579773,
            109.286813
          ],
          [
            16.644674,
            52.579652,
            109.337769
          ],
          [
            16.644929,
            52.579502,
            109.2401
          ],
          [
            16.645192,
            52.579352,
            109.140987
          ],
          [
            16.645422,
            52.579185,
            109.042475
          ],
          [
            16.645665,
            52.579004,
            108.936544
          ],
          [
            16.645895,
            52.57884,
            108.838985
          ],
          [
            16.646118,
            52.578688,
            108.746895
          ],
          [
            16.646314,
            52.578547,
            108.663404
          ],
          [
            16.646543,
            52.578383,
            108.566147
          ],
          [
            16.646771,
            52.578223,
            108.332468
          ],
          [
            16.647017,
            52.578051,
            108.077351
          ],
          [
            16.647262,
            52.57789,
            107.833093
          ],
          [
            16.647522,
            52.577711,
            107.56706
          ],
          [
            16.647741,
            52.577556,
            107.339466
          ],
          [
            16.64794,
            52.577394,
            107.114149
          ],
          [
            16.648165,
            52.577226,
            106.872788
          ],
          [
            16.648389,
            52.577092,
            106.659866
          ],
          [
            16.64861,
            52.576922,
            106.426476
          ],
          [
            16.648827,
            52.576736,
            106.186344
          ],
          [
            16.649068,
            52.576576,
            105.958131
          ],
          [
            16.649295,
            52.576404,
            105.726084
          ],
          [
            16.649555,
            52.576229,
            105.478048
          ],
          [
            16.649811,
            52.576056,
            105.232759
          ],
          [
            16.650033,
            52.575894,
            105.010982
          ],
          [
            16.650252,
            52.575717,
            104.778051
          ],
          [
            16.650494,
            52.575569,
            104.365516
          ],
          [
            16.650713,
            52.575423,
            103.798221
          ],
          [
            16.650955,
            52.575243,
            103.129229
          ],
          [
            16.651194,
            52.575076,
            102.493154
          ],
          [
            16.651416,
            52.574937,
            101.936203
          ],
          [
            16.65168,
            52.574766,
            101.262119
          ],
          [
            16.651914,
            52.57462,
            100.6759
          ],
          [
            16.652132,
            52.574472,
            100.104765
          ],
          [
            16.652306,
            52.574311,
            99.549123
          ],
          [
            16.652511,
            52.574156,
            99.363686
          ],
          [
            16.652707,
            52.573983,
            99.202236
          ],
          [
            16.652941,
            52.573801,
            99.023419
          ],
          [
            16.653251,
            52.573603,
            98.81257
          ],
          [
            16.653481,
            52.573461,
            98.659297
          ],
          [
            16.65373,
            52.573277,
            98.476134
          ],
          [
            16.654011,
            52.573097,
            98.285079
          ],
          [
            16.654279,
            52.572898,
            98.26085
          ],
          [
            16.654511,
            52.572717,
            98.960228
          ],
          [
            16.654797,
            52.5725,
            99.814382
          ],
          [
            16.655026,
            52.572305,
            100.547107
          ],
          [
            16.655267,
            52.572146,
            101.205913
          ],
          [
            16.655513,
            52.571991,
            101.863527
          ],
          [
            16.655758,
            52.571834,
            102.525228
          ],
          [
            16.655951,
            52.571686,
            103.10078
          ],
          [
            16.656164,
            52.571535,
            103.69566
          ],
          [
            16.656383,
            52.571386,
            104.236903
          ],
          [
            16.656644,
            52.571204,
            104.891364
          ],
          [
            16.6569,
            52.571029,
            105.526274
          ],
          [
            16.657121,
            52.570881,
            106.068562
          ],
          [
            16.657393,
            52.570668,
            106.798987
          ],
          [
            16.657629,
            52.570528,
            107.342397
          ],
          [
            16.657854,
            52.570373,
            107.902444
          ],
          [
            16.658053,
            52.57022,
            108.431867
          ],
          [
            16.658232,
            52.570069,
            108.238324
          ],
          [
            16.658447,
            52.569923,
            107.963838
          ],
          [
            16.658707,
            52.569731,
            107.616041
          ],
          [
            16.658973,
            52.569541,
            107.266936
          ],
          [
            16.659204,
            52.569375,
            106.962828
          ],
          [
            16.659444,
            52.569187,
            106.630012
          ],
          [
            16.659666,
            52.569015,
            106.323946
          ],
          [
            16.659875,
            52.568883,
            106.067677
          ],
          [
            16.660089,
            52.568742,
            106.135873
          ],
          [
            16.660375,
            52.568543,
            106.539175
          ],
          [
            16.660597,
            52.568353,
            106.894962
          ],
          [
            16.660849,
            52.568189,
            107.237362
          ],
          [
            16.661041,
            52.568046,
            107.518933
          ],
          [
            16.661269,
            52.567893,
            107.833975
          ],
          [
            16.66149,
            52.56775,
            108.133108
          ],
          [
            16.661736,
            52.567584,
            108.473899
          ],
          [
            16.66195,
            52.567437,
            108.698299
          ],
          [
            16.662169,
            52.567298,
            108.680388
          ],
          [
            16.662348,
            52.567137,
            108.6623
          ],
          [
            16.662576,
            52.566969,
            108.642026
          ],
          [
            16.662823,
            52.566801,
            108.621028
          ],
          [
            16.663021,
            52.566636,
            108.602023
          ],
          [
            16.663231,
            52.566496,
            108.584392
          ],
          [
            16.663442,
            52.566335,
            108.565236
          ],
          [
            16.663647,
            52.566169,
            108.545884
          ],
          [
            16.663838,
            52.566027,
            108.577253
          ],
          [
            16.664076,
            52.565854,
            108.714146
          ],
          [
            16.664282,
            52.565705,
            108.832551
          ],
          [
            16.664511,
            52.565564,
            108.952774
          ],
          [
            16.664706,
            52.565417,
            109.067491
          ],
          [
            16.664956,
            52.565237,
            109.210429
          ],
          [
            16.66518,
            52.5651,
            109.327629
          ],
          [
            16.665431,
            52.564928,
            109.467318
          ],
          [
            16.665684,
            52.564746,
            109.61197
          ],
          [
            16.665897,
            52.564584,
            109.656073
          ],
          [
            16.666138,
            52.564419,
            109.691573
          ],
          [
            16.666393,
            52.564256,
            109.727751
          ],
          [
            16.666598,
            52.564094,
            109.760633
          ],
          [
            16.666811,
            52.56392,
            109.795496
          ],
          [
            16.667029,
            52.56376,
            109.82889
          ],
          [
            16.667238,
            52.563607,
            109.861021
          ],
          [
            16.66748,
            52.563422,
            109.89914
          ],
          [
            16.667769,
            52.563234,
            109.897167
          ],
          [
            16.667991,
            52.563094,
            109.873788
          ],
          [
            16.668208,
            52.562936,
            109.848961
          ],
          [
            16.668415,
            52.562782,
            109.825047
          ],
          [
            16.668637,
            52.562627,
            109.800331
          ],
          [
            16.668848,
            52.562485,
            109.777334
          ],
          [
            16.669051,
            52.562335,
            109.75398
          ],
          [
            16.66926,
            52.562167,
            109.728501
          ],
          [
            16.669527,
            52.562006,
            109.701026
          ],
          [
            16.669785,
            52.561802,
            109.915264
          ],
          [
            16.670048,
            52.561598,
            110.143454
          ],
          [
            16.670307,
            52.561386,
            110.375998
          ],
          [
            16.670592,
            52.561221,
            110.586652
          ],
          [
            16.670905,
            52.561097,
            110.786516
          ],
          [
            16.671221,
            52.560993,
            110.979395
          ],
          [
            16.67157,
            52.560912,
            111.179257
          ],
          [
            16.671908,
            52.56082,
            111.21998
          ],
          [
            16.672239,
            52.560737,
            111.094416
          ],
          [
            16.672582,
            52.560652,
            110.96497
          ],
          [
            16.672881,
            52.560541,
            110.841682
          ],
          [
            16.673075,
            52.560352,
            110.711803
          ],
          [
            16.673091,
            52.560101,
            110.566713
          ],
          [
            16.672981,
            52.559855,
            110.420234
          ],
          [
            16.672927,
            52.55961,
            110.277561
          ],
          [
            16.67311,
            52.559397,
            110.392543
          ],
          [
            16.673424,
            52.55921,
            110.590808
          ],
          [
            16.673685,
            52.559026,
            110.770927
          ],
          [
            16.67396,
            52.558826,
            110.964304
          ],
          [
            16.674178,
            52.558685,
            111.107915
          ],
          [
            16.67439,
            52.558533,
            111.255643
          ],
          [
            16.674582,
            52.558396,
            111.3898
          ],
          [
            16.674819,
            52.55822,
            111.558483
          ],
          [
            16.675034,
            52.558075,
            111.539537
          ],
          [
            16.675287,
            52.557906,
            111.479998
          ],
          [
            16.675492,
            52.55776,
            111.429946
          ],
          [
            16.675736,
            52.557585,
            111.3701
          ],
          [
            16.675935,
            52.55744,
            111.320901
          ],
          [
            16.676146,
            52.55726,
            111.2633
          ],
          [
            16.67641,
            52.557068,
            111.198069
          ],
          [
            16.676682,
            52.556879,
            111.132625
          ],
          [
            16.67695,
            52.556691,
            111.23047
          ],
          [
            16.677201,
            52.556518,
            111.384245
          ],
          [
            16.677408,
            52.556378,
            111.509698
          ],
          [
            16.677641,
            52.556218,
            111.652105
          ],
          [
            16.677917,
            52.556014,
            111.828579
          ],
          [
            16.67817,
            52.555846,
            111.980371
          ],
          [
            16.67836,
            52.555702,
            112.103373
          ],
          [
            16.67857,
            52.555562,
            112.229643
          ],
          [
            16.678843,
            52.555365,
            112.243105
          ],
          [
            16.679062,
            52.555198,
            112.134276
          ],
          [
            16.679294,
            52.555023,
            112.019907
          ],
          [
            16.679478,
            52.554867,
            111.922242
          ],
          [
            16.679713,
            52.554667,
            111.797185
          ],
          [
            16.679933,
            52.55446,
            111.671778
          ],
          [
            16.680147,
            52.554255,
            111.548186
          ],
          [
            16.680348,
            52.554045,
            111.424573
          ],
          [
            16.680538,
            52.553853,
            111.752568
          ],
          [
            16.68072,
            52.553682,
            112.181872
          ],
          [
            16.680915,
            52.553496,
            112.646837
          ],
          [
            16.681193,
            52.553414,
            113.070384
          ],
          [
            16.681519,
            52.553491,
            113.521232
          ],
          [
            16.681792,
            52.553621,
            113.966853
          ],
          [
            16.682076,
            52.553738,
            114.408176
          ],
          [
            16.682374,
            52.553838,
            114.847879
          ],
          [
            16.682667,
            52.553953,
            115.244758
          ],
          [
            16.682975,
            52.554051,
            115.481507
          ],
          [
            16.683278,
            52.554153,
            115.717251
          ],
          [
            16.683555,
            52.554283,
            115.95544
          ],
          [
            16.683849,
            52.554386,
            116.186613
          ],
          [
            16.684138,
            52.554497,
            116.419913
          ],
          [
            16.684471,
            52.554605,
            116.677052
          ],
          [
            16.684841,
            52.55468,
            116.942758
          ],
          [
            16.685201,
            52.554737,
            117.196203
          ],
          [
            16.6856,
            52.554764,
            117.173937
          ],
          [
            16.686012,
            52.554769,
            117.14556
          ],
          [
            16.686403,
            52.554767,
            117.118634
          ],
          [
            16.686811,
            52.554764,
            117.090545
          ],
          [
            16.687184,
            52.554758,
            117.064857
          ],
          [
            16.687564,
            52.554759,
            117.038699
          ],
          [
            16.687873,
            52.554765,
            117.017412
          ],
          [
            16.688235,
            52.554751,
            117.013766
          ],
          [
            16.688544,
            52.554754,
            117.083237
          ],
          [
            16.688848,
            52.554754,
            117.151628
          ],
          [
            16.68916,
            52.554764,
            117.222123
          ],
          [
            16.689479,
            52.554749,
            117.294035
          ],
          [
            16.689899,
            52.554714,
            117.389266
          ],
          [
            16.690267,
            52.554707,
            117.472101
          ],
          [
            16.690575,
            52.554703,
            117.54145
          ],
          [
            16.690884,
            52.554714,
            117.611208
          ],
          [
            16.691285,
            52.554704,
            117.649306
          ],
          [
            16.691664,
            52.554689,
            117.621814
          ],
          [
            16.692023,
            52.554702,
            117.595682
          ],
          [
            16.692377,
            52.554722,
            117.56991
          ],
          [
            16.692733,
            52.554729,
            117.54413
          ],
          [
            16.69308,
            52.554713,
            117.518943
          ],
          [
            16.693431,
            52.554683,
            117.493279
          ],
          [
            16.693769,
            52.554644,
            117.468382
          ],
          [
            16.694137,
            52.554581,
            117.575871
          ],
          [
            16.694508,
            52.554513,
            118.07513
          ],
          [
            16.694872,
            52.554434,
            118.572856
          ],
          [
            16.695251,
            52.554374,
            119.077447
          ],
          [
            16.695618,
            52.55431,
            119.569211
          ],
          [
            16.695957,
            52.554254,
            120.021627
          ],
          [
            16.696313,
            52.554191,
            120.49962
          ],
          [
            16.696684,
            52.554114,
            121.004595
          ],
          [
            16.697066,
            52.554039,
            121.405102
          ],
          [
            16.697455,
            52.553969,
            121.696909
          ],
          [
            16.697817,
            52.5539,
            121.970325
          ],
          [
            16.698203,
            52.553839,
            122.257967
          ],
          [
            16.698579,
            52.553761,
            122.543485
          ],
          [
            16.698913,
            52.553681,
            122.801415
          ],
          [
            16.699288,
            52.553596,
            123.089094
          ],
          [
            16.699662,
            52.553521,
            123.37216
          ],
          [
            16.700037,
            52.55344,
            123.162709
          ],
          [
            16.700385,
            52.553366,
            122.951533
          ],
          [
            16.700776,
            52.553313,
            122.722058
          ],
          [
            16.701141,
            52.553246,
            122.503365
          ],
          [
            16.701506,
            52.553168,
            122.281675
          ],
          [
            16.701872,
            52.553103,
            122.063267
          ],
          [
            16.702211,
            52.553037,
            121.859212
          ],
          [
            16.702579,
            52.552972,
            121.7174
          ],
          [
            16.702924,
            52.552903,
            121.843972
          ],
          [
            16.7033,
            52.552836,
            121.980473
          ],
          [
            16.703686,
            52.552777,
            122.11918
          ],
          [
            16.704067,
            52.552693,
            122.260404
          ],
          [
            16.70442,
            52.552617,
            122.390862
          ],
          [
            16.704752,
            52.552541,
            122.514435
          ],
          [
            16.705097,
            52.552471,
            122.641153
          ],
          [
            16.705469,
            52.552415,
            122.792742
          ],
          [
            16.70584,
            52.552361,
            122.968497
          ],
          [
            16.706203,
            52.552285,
            123.145283
          ],
          [
            16.70656,
            52.552203,
            123.321015
          ],
          [
            16.706909,
            52.552138,
            123.489087
          ],
          [
            16.707252,
            52.552071,
            123.655087
          ],
          [
            16.70762,
            52.552004,
            123.831979
          ],
          [
            16.707997,
            52.551935,
            124.01327
          ],
          [
            16.708347,
            52.551872,
            124.035551
          ],
          [
            16.708699,
            52.551808,
            123.959994
          ],
          [
            16.709024,
            52.551732,
            123.888384
          ],
          [
            16.709345,
            52.551684,
            123.820378
          ],
          [
            16.709657,
            52.551617,
            123.752331
          ],
          [
            16.709984,
            52.551549,
            123.681243
          ],
          [
            16.710356,
            52.551484,
            123.601644
          ],
          [
            16.710736,
            52.551429,
            123.521272
          ],
          [
            16.71112,
            52.551348,
            123.434519
          ],
          [
            16.711522,
            52.551285,
            123.341327
          ],
          [
            16.711905,
            52.551215,
            123.251537
          ],
          [
            16.712224,
            52.55114,
            123.174752
          ],
          [
            16.71255,
            52.551076,
            123.097914
          ],
          [
            16.712913,
            52.551004,
            123.012183
          ],
          [
            16.71324,
            52.550934,
            122.934313
          ],
          [
            16.713464,
            52.550773,
            122.855016
          ],
          [
            16.71356,
            52.550558,
            122.756883
          ],
          [
            16.713662,
            52.550326,
            122.629105
          ],
          [
            16.71382,
            52.550068,
            122.480683
          ],
          [
            16.713907,
            52.549885,
            122.379271
          ],
          [
            16.71399,
            52.549686,
            122.269947
          ],
          [
            16.714082,
            52.549493,
            122.16298
          ],
          [
            16.71419,
            52.549295,
            122.051986
          ],
          [
            16.714262,
            52.549117,
            121.954421
          ],
          [
            16.714375,
            52.548918,
            121.868992
          ],
          [
            16.714604,
            52.549063,
            122.056097
          ],
          [
            16.714927,
            52.549131,
            122.251881
          ],
          [
            16.714954,
            52.548955,
            122.423072
          ],
          [
            16.71505,
            52.54897,
            122.644758
          ],
          [
            16.714735,
            52.549096,
            122.879066
          ],
          [
            16.714472,
            52.549004,
            123.049728
          ],
          [
            16.714435,
            52.54873,
            123.310234
          ],
          [
            16.714546,
            52.548534,
            123.502024
          ],
          [
            16.71463,
            52.548332,
            123.583896
          ],
          [
            16.714737,
            52.548143,
            123.653943
          ],
          [
            16.714831,
            52.547957,
            123.722138
          ],
          [
            16.714925,
            52.547773,
            123.789725
          ],
          [
            16.714994,
            52.54758,
            123.858964
          ],
          [
            16.715092,
            52.547385,
            123.930417
          ],
          [
            16.715187,
            52.547202,
            123.997747
          ],
          [
            16.715263,
            52.547006,
            124.068343
          ],
          [
            16.715392,
            52.54678,
            124.171704
          ],
          [
            16.715489,
            52.54657,
            124.493446
          ],
          [
            16.715767,
            52.546426,
            124.828006
          ],
          [
            16.716139,
            52.546437,
            125.162791
          ],
          [
            16.716517,
            52.546468,
            125.504882
          ],
          [
            16.716914,
            52.546489,
            125.862516
          ],
          [
            16.717278,
            52.546501,
            126.189473
          ],
          [
            16.717689,
            52.546509,
            126.558288
          ],
          [
            16.718044,
            52.546544,
            126.840762
          ],
          [
            16.718457,
            52.546566,
            127.031304
          ],
          [
            16.718876,
            52.546585,
            127.224401
          ],
          [
            16.719182,
            52.546596,
            127.365528
          ],
          [
            16.719498,
            52.546623,
            127.511844
          ],
          [
            16.719854,
            52.546636,
            127.675416
          ],
          [
            16.720164,
            52.546665,
            127.819469
          ],
          [
            16.720499,
            52.546672,
            127.973311
          ],
          [
            16.720884,
            52.546682,
            128.1504
          ],
          [
            16.721207,
            52.546703,
            128.103882
          ],
          [
            16.72154,
            52.546712,
            128.049738
          ],
          [
            16.721877,
            52.546732,
            127.994734
          ],
          [
            16.722242,
            52.546747,
            127.935276
          ],
          [
            16.72259,
            52.546758,
            127.878649
          ],
          [
            16.722941,
            52.546788,
            127.821071
          ],
          [
            16.723271,
            52.546795,
            127.767243
          ],
          [
            16.723583,
            52.546803,
            127.716471
          ],
          [
            16.723961,
            52.546821,
            127.649971
          ],
          [
            16.724317,
            52.546844,
            127.57746
          ],
          [
            16.724725,
            52.546877,
            127.493551
          ],
          [
            16.725091,
            52.546917,
            127.418219
          ],
          [
            16.725436,
            52.546926,
            127.348289
          ],
          [
            16.725848,
            52.546936,
            127.264783
          ],
          [
            16.726146,
            52.546924,
            127.203855
          ],
          [
            16.726466,
            52.546925,
            127.138984
          ],
          [
            16.726776,
            52.546945,
            127.07585
          ],
          [
            16.727106,
            52.546962,
            127.058141
          ],
          [
            16.727494,
            52.546978,
            127.037548
          ],
          [
            16.727877,
            52.547001,
            127.017169
          ],
          [
            16.7282,
            52.547027,
            126.999892
          ],
          [
            16.728504,
            52.547034,
            126.983778
          ],
          [
            16.728804,
            52.547063,
            126.967689
          ],
          [
            16.729181,
            52.547082,
            126.947559
          ],
          [
            16.729545,
            52.547077,
            126.92828
          ],
          [
            16.72991,
            52.54709,
            126.826706
          ],
          [
            16.730254,
            52.547099,
            126.660113
          ],
          [
            16.730596,
            52.547111,
            126.494193
          ],
          [
            16.730952,
            52.547115,
            126.322002
          ],
          [
            16.73129,
            52.547139,
            126.157443
          ],
          [
            16.731649,
            52.547154,
            125.98336
          ],
          [
            16.732002,
            52.547174,
            125.811803
          ],
          [
            16.732328,
            52.547181,
            125.654057
          ],
          [
            16.732664,
            52.547193,
            125.491239
          ],
          [
            16.733039,
            52.547205,
            124.884253
          ],
          [
            16.733437,
            52.547214,
            124.234639
          ],
          [
            16.733862,
            52.547225,
            123.54061
          ],
          [
            16.734273,
            52.547235,
            122.866627
          ],
          [
            16.734677,
            52.547228,
            122.207443
          ],
          [
            16.735047,
            52.547248,
            121.600944
          ],
          [
            16.735457,
            52.54724,
            120.931817
          ],
          [
            16.735804,
            52.547244,
            120.646256
          ],
          [
            16.736157,
            52.547248,
            120.610798
          ],
          [
            16.736481,
            52.547244,
            120.578225
          ],
          [
            16.736873,
            52.547232,
            120.538821
          ],
          [
            16.737307,
            52.54723,
            120.495188
          ],
          [
            16.737743,
            52.547234,
            120.451394
          ],
          [
            16.738092,
            52.54724,
            120.416207
          ],
          [
            16.738492,
            52.547224,
            120.375928
          ],
          [
            16.738924,
            52.547246,
            120.922753
          ],
          [
            16.739306,
            52.547238,
            121.524821
          ],
          [
            16.739706,
            52.547248,
            122.155058
          ],
          [
            16.740037,
            52.547253,
            122.676489
          ],
          [
            16.740351,
            52.547269,
            123.172507
          ],
          [
            16.740777,
            52.547286,
            123.844553
          ],
          [
            16.741141,
            52.547274,
            124.420225
          ],
          [
            16.741557,
            52.54727,
            125.042095
          ],
          [
            16.741864,
            52.547277,
            125.218921
          ],
          [
            16.742162,
            52.54728,
            125.390655
          ],
          [
            16.742532,
            52.547272,
            125.603751
          ],
          [
            16.742838,
            52.54727,
            125.779864
          ],
          [
            16.743163,
            52.547265,
            125.967356
          ],
          [
            16.743489,
            52.547259,
            126.15514
          ],
          [
            16.743796,
            52.547266,
            126.33206
          ],
          [
            16.744102,
            52.547264,
            126.508214
          ],
          [
            16.744466,
            52.547267,
            126.717909
          ],
          [
            16.744819,
            52.547275,
            126.858126
          ],
          [
            16.745206,
            52.547261,
            127.009459
          ],
          [
            16.745614,
            52.547261,
            127.168718
          ],
          [
            16.745995,
            52.547275,
            127.318154
          ],
          [
            16.746365,
            52.547273,
            127.462575
          ],
          [
            16.746799,
            52.547266,
            127.632084
          ],
          [
            16.747174,
            52.547275,
            127.778597
          ],
          [
            16.747562,
            52.547282,
            127.863995
          ],
          [
            16.747928,
            52.54728,
            127.82012
          ],
          [
            16.748358,
            52.547278,
            127.768561
          ],
          [
            16.748775,
            52.547267,
            127.718513
          ],
          [
            16.749146,
            52.54726,
            127.673948
          ],
          [
            16.749533,
            52.547271,
            127.6275
          ],
          [
            16.749894,
            52.547269,
            127.584218
          ],
          [
            16.750248,
            52.54727,
            127.541772
          ],
          [
            16.750629,
            52.547256,
            127.662324
          ],
          [
            16.751038,
            52.547264,
            127.894549
          ],
          [
            16.751457,
            52.547269,
            128.13235
          ],
          [
            16.751855,
            52.547276,
            128.358294
          ],
          [
            16.752232,
            52.547292,
            128.574108
          ],
          [
            16.752587,
            52.547316,
            128.777046
          ],
          [
            16.752943,
            52.547341,
            128.980364
          ],
          [
            16.7533,
            52.547333,
            129.183051
          ],
          [
            16.753648,
            52.547352,
            129.062563
          ],
          [
            16.75397,
            52.547318,
            128.915115
          ],
          [
            16.754121,
            52.54711,
            128.747395
          ],
          [
            16.754258,
            52.546893,
            128.576568
          ],
          [
            16.754377,
            52.546673,
            128.406373
          ],
          [
            16.754507,
            52.546428,
            128.216963
          ],
          [
            16.754644,
            52.546195,
            128.035103
          ],
          [
            16.754766,
            52.54598,
            127.879345
          ],
          [
            16.754899,
            52.545762,
            127.854289
          ],
          [
            16.755041,
            52.545544,
            127.829011
          ],
          [
            16.75516,
            52.545369,
            127.8086
          ],
          [
            16.755293,
            52.545136,
            127.782018
          ],
          [
            16.755412,
            52.54492,
            127.757467
          ],
          [
            16.755568,
            52.54469,
            127.730654
          ],
          [
            16.755698,
            52.544452,
            127.703621
          ],
          [
            16.755845,
            52.544216,
            127.867282
          ],
          [
            16.756004,
            52.543985,
            128.306404
          ],
          [
            16.75615,
            52.54376,
            128.730739
          ],
          [
            16.75632,
            52.543523,
            129.184248
          ],
          [
            16.756503,
            52.543287,
            129.641647
          ],
          [
            16.756632,
            52.543115,
            129.973056
          ],
          [
            16.756781,
            52.542885,
            130.406699
          ],
          [
            16.75693,
            52.542653,
            130.840314
          ],
          [
            16.757085,
            52.542441,
            130.832746
          ],
          [
            16.757246,
            52.542206,
            130.824445
          ],
          [
            16.757435,
            52.541983,
            130.816236
          ],
          [
            16.757619,
            52.541737,
            130.807425
          ],
          [
            16.757739,
            52.541553,
            130.800972
          ],
          [
            16.757887,
            52.541338,
            130.793365
          ],
          [
            16.758014,
            52.541159,
            130.787007
          ],
          [
            16.758174,
            52.54099,
            130.650338
          ],
          [
            16.758297,
            52.540817,
            129.914402
          ],
          [
            16.758456,
            52.540615,
            129.040826
          ],
          [
            16.758572,
            52.540424,
            128.245104
          ],
          [
            16.758667,
            52.540219,
            127.414256
          ],
          [
            16.758808,
            52.540003,
            126.506475
          ],
          [
            16.758957,
            52.53978,
            125.5671
          ],
          [
            16.759064,
            52.539592,
            124.786701
          ],
          [
            16.759206,
            52.539403,
            123.976181
          ],
          [
            16.759331,
            52.5392,
            124.073136
          ],
          [
            16.759421,
            52.539008,
            124.449224
          ],
          [
            16.759435,
            52.538794,
            124.852624
          ],
          [
            16.759452,
            52.538563,
            125.288134
          ],
          [
            16.759439,
            52.538332,
            125.724193
          ],
          [
            16.75965,
            52.538202,
            126.127481
          ],
          [
            16.760083,
            52.538267,
            126.638409
          ],
          [
            16.760447,
            52.538341,
            127.078039
          ],
          [
            16.760761,
            52.53838,
            127.100614
          ],
          [
            16.76115,
            52.538393,
            127.019546
          ],
          [
            16.761486,
            52.538339,
            126.94731
          ],
          [
            16.761789,
            52.538296,
            126.882365
          ],
          [
            16.762146,
            52.538236,
            126.805244
          ],
          [
            16.762562,
            52.538179,
            126.716563
          ],
          [
            16.76287,
            52.538113,
            126.645219
          ],
          [
            16.763245,
            52.538032,
            126.562513
          ],
          [
            16.763616,
            52.537943,
            126.646927
          ],
          [
            16.764026,
            52.537887,
            126.805491
          ],
          [
            16.764385,
            52.537812,
            126.948718
          ],
          [
            16.764785,
            52.53774,
            127.105808
          ],
          [
            16.765074,
            52.537683,
            127.220227
          ],
          [
            16.765431,
            52.537638,
            127.357524
          ],
          [
            16.765729,
            52.53758,
            127.475672
          ],
          [
            16.766084,
            52.537534,
            127.612586
          ],
          [
            16.766379,
            52.537483,
            127.604776
          ],
          [
            16.766677,
            52.537438,
            127.530691
          ],
          [
            16.766975,
            52.537377,
            127.455735
          ],
          [
            16.767328,
            52.537317,
            127.368368
          ],
          [
            16.767736,
            52.537235,
            127.26584
          ],
          [
            16.768129,
            52.537163,
            127.167993
          ],
          [
            16.768527,
            52.537099,
            127.069797
          ],
          [
            16.76892,
            52.537034,
            126.972717
          ],
          [
            16.769275,
            52.53697,
            126.914336
          ],
          [
            16.769634,
            52.536905,
            126.867197
          ],
          [
            16.769948,
            52.536869,
            126.827009
          ],
          [
            16.770311,
            52.536831,
            126.780601
          ],
          [
            16.770634,
            52.53677,
            126.737611
          ],
          [
            16.770938,
            52.536721,
            126.698054
          ],
          [
            16.771237,
            52.536705,
            126.659987
          ],
          [
            16.771563,
            52.536698,
            126.618918
          ],
          [
            16.771865,
            52.536689,
            126.580901
          ],
          [
            16.772228,
            52.53669,
            126.727217
          ],
          [
            16.772548,
            52.536672,
            126.877597
          ],
          [
            16.77285,
            52.536665,
            127.018848
          ],
          [
            16.773153,
            52.536632,
            127.162959
          ],
          [
            16.773464,
            52.536619,
            127.308673
          ],
          [
            16.773817,
            52.536626,
            127.473944
          ],
          [
            16.774156,
            52.536611,
            127.632844
          ],
          [
            16.774486,
            52.536593,
            127.787725
          ],
          [
            16.774814,
            52.536575,
            127.941676
          ],
          [
            16.775167,
            52.536549,
            127.628218
          ],
          [
            16.775577,
            52.536553,
            127.20754
          ],
          [
            16.775889,
            52.536577,
            126.884808
          ],
          [
            16.776205,
            52.536573,
            126.560532
          ],
          [
            16.776546,
            52.536577,
            126.210218
          ],
          [
            16.776872,
            52.536574,
            125.874786
          ],
          [
            16.777197,
            52.536581,
            125.53718
          ],
          [
            16.777516,
            52.536563,
            125.208509
          ],
          [
            16.777865,
            52.53656,
            124.813426
          ],
          [
            16.778174,
            52.536541,
            124.339618
          ],
          [
            16.778552,
            52.536546,
            123.762839
          ],
          [
            16.778888,
            52.536551,
            123.247467
          ],
          [
            16.779286,
            52.53657,
            122.638417
          ],
          [
            16.779634,
            52.536576,
            122.106186
          ],
          [
            16.779948,
            52.536553,
            121.623698
          ],
          [
            16.780315,
            52.53651,
            121.053103
          ],
          [
            16.780647,
            52.536508,
            120.546378
          ],
          [
            16.780968,
            52.536541,
            119.43531
          ],
          [
            16.781328,
            52.536543,
            117.953088
          ],
          [
            16.781661,
            52.536524,
            116.584078
          ],
          [
            16.782175,
            52.536442,
            114.408972
          ],
          [
            16.782555,
            52.536492,
            112.832258
          ],
          [
            16.782893,
            52.53653,
            111.423681
          ],
          [
            16.783193,
            52.536531,
            110.205589
          ],
          [
            16.783516,
            52.536497,
            108.876161
          ],
          [
            16.78386,
            52.536501,
            108.237275
          ],
          [
            16.784314,
            52.536536,
            107.871176
          ],
          [
            16.784587,
            52.536506,
            107.633286
          ],
          [
            16.784259,
            52.536444,
            107.356944
          ],
          [
            16.78391,
            52.536456,
            107.077827
          ],
          [
            16.783587,
            52.536505,
            106.813768
          ],
          [
            16.78326,
            52.53652,
            106.553611
          ],
          [
            16.782949,
            52.53647,
            106.294922
          ],
          [
            16.782634,
            52.536465,
            106.184428
          ],
          [
            16.782305,
            52.5365,
            107.094775
          ],
          [
            16.781959,
            52.536487,
            108.039847
          ],
          [
            16.781643,
            52.536519,
            108.910009
          ],
          [
            16.781343,
            52.536518,
            109.728307
          ],
          [
            16.781022,
            52.53652,
            110.600177
          ],
          [
            16.780678,
            52.536497,
            111.540902
          ],
          [
            16.780363,
            52.536522,
            112.403787
          ],
          [
            16.780033,
            52.536528,
            113.300834
          ],
          [
            16.779702,
            52.536527,
            114.17388
          ],
          [
            16.779357,
            52.536523,
            114.847813
          ],
          [
            16.779053,
            52.536527,
            115.443697
          ],
          [
            16.778693,
            52.536519,
            116.147381
          ],
          [
            16.77837,
            52.536564,
            116.795328
          ],
          [
            16.778008,
            52.536553,
            117.508653
          ],
          [
            16.777657,
            52.536539,
            118.195503
          ],
          [
            16.777287,
            52.536557,
            118.921397
          ],
          [
            16.776943,
            52.536572,
            119.595481
          ],
          [
            16.776599,
            52.536566,
            120.126652
          ],
          [
            16.776221,
            52.536563,
            120.597274
          ],
          [
            16.775827,
            52.536557,
            121.08695
          ],
          [
            16.77552,
            52.536569,
            121.470436
          ],
          [
            16.775156,
            52.536567,
            121.922733
          ],
          [
            16.774773,
            52.536565,
            122.398824
          ],
          [
            16.774441,
            52.536577,
            122.811992
          ],
          [
            16.774377,
            52.536405,
            123.22135
          ],
          [
            16.774478,
            52.536213,
            123.553949
          ],
          [
            16.774605,
            52.536017,
            123.553949
          ],
          [
            16.774693,
            52.535821,
            123.553949
          ],
          [
            16.774783,
            52.535624,
            123.553949
          ],
          [
            16.774893,
            52.535428,
            123.553949
          ],
          [
            16.774975,
            52.535212,
            123.553949
          ],
          [
            16.775072,
            52.535008,
            123.553949
          ],
          [
            16.775392,
            52.534946,
            123.553949
          ],
          [
            16.775511,
            52.534776,
            123.553949
          ],
          [
            16.775508,
            52.534629,
            123.553949
          ]
        ]
      }
    }
  ]
}

let day46:any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            16.775291,
            52.534454,
            125.157216
          ],
          [
            16.77523,
            52.53467,
            125.157216
          ],
          [
            16.775179,
            52.534879,
            125.157216
          ],
          [
            16.775107,
            52.535076,
            125.157216
          ],
          [
            16.774998,
            52.535262,
            125.157216
          ],
          [
            16.774909,
            52.535454,
            125.114177
          ],
          [
            16.774797,
            52.535645,
            125.047655
          ],
          [
            16.7747,
            52.53583,
            124.983993
          ],
          [
            16.774604,
            52.536029,
            124.915967
          ],
          [
            16.774537,
            52.536208,
            124.855519
          ],
          [
            16.774437,
            52.536392,
            124.791792
          ],
          [
            16.774401,
            52.536587,
            124.726922
          ],
          [
            16.774722,
            52.536603,
            124.661509
          ],
          [
            16.775065,
            52.536586,
            124.59243
          ],
          [
            16.775382,
            52.536588,
            124.658198
          ],
          [
            16.775726,
            52.536585,
            124.820786
          ],
          [
            16.776114,
            52.536571,
            125.004322
          ],
          [
            16.776411,
            52.536586,
            125.144951
          ],
          [
            16.776861,
            52.536578,
            125.358134
          ],
          [
            16.777194,
            52.536585,
            125.515319
          ],
          [
            16.777551,
            52.536584,
            125.683764
          ],
          [
            16.778,
            52.536555,
            125.896758
          ],
          [
            16.778325,
            52.536558,
            125.358219
          ],
          [
            16.778716,
            52.536555,
            124.093457
          ],
          [
            16.779073,
            52.536547,
            122.939585
          ],
          [
            16.779438,
            52.536565,
            121.730706
          ],
          [
            16.779762,
            52.536523,
            120.660829
          ],
          [
            16.780171,
            52.536496,
            119.332421
          ],
          [
            16.78054,
            52.536501,
            118.128854
          ],
          [
            16.780854,
            52.536511,
            117.112546
          ],
          [
            16.78136,
            52.536525,
            115.869455
          ],
          [
            16.781731,
            52.536545,
            115.17308
          ],
          [
            16.782081,
            52.53653,
            114.517029
          ],
          [
            16.782434,
            52.536539,
            113.842112
          ],
          [
            16.782833,
            52.536549,
            113.095383
          ],
          [
            16.783187,
            52.536547,
            112.432494
          ],
          [
            16.783522,
            52.536554,
            111.793563
          ],
          [
            16.783828,
            52.536525,
            111.213902
          ],
          [
            16.784125,
            52.536499,
            111.048089
          ],
          [
            16.784443,
            52.536484,
            111.462903
          ],
          [
            16.784762,
            52.536417,
            111.906228
          ],
          [
            16.785009,
            52.536304,
            112.309532
          ],
          [
            16.785264,
            52.536144,
            112.786539
          ],
          [
            16.785523,
            52.535958,
            113.310644
          ],
          [
            16.785748,
            52.53581,
            113.743471
          ],
          [
            16.785957,
            52.535655,
            114.172116
          ],
          [
            16.786133,
            52.535489,
            114.594258
          ],
          [
            16.786311,
            52.535326,
            115.098526
          ],
          [
            16.786567,
            52.535135,
            115.783988
          ],
          [
            16.78677,
            52.534978,
            116.33951
          ],
          [
            16.787008,
            52.534785,
            117.010609
          ],
          [
            16.787203,
            52.534618,
            117.580557
          ],
          [
            16.787351,
            52.534426,
            118.170597
          ],
          [
            16.787522,
            52.534277,
            118.678387
          ],
          [
            16.787691,
            52.534103,
            119.243054
          ],
          [
            16.787823,
            52.533932,
            119.652426
          ],
          [
            16.788033,
            52.533756,
            118.371499
          ],
          [
            16.788246,
            52.533578,
            117.074615
          ],
          [
            16.788425,
            52.533367,
            115.671401
          ],
          [
            16.788621,
            52.533184,
            114.380729
          ],
          [
            16.788779,
            52.533024,
            113.280673
          ],
          [
            16.788969,
            52.532842,
            112.011189
          ],
          [
            16.789182,
            52.532672,
            110.752639
          ],
          [
            16.789323,
            52.532487,
            109.551802
          ],
          [
            16.789476,
            52.532309,
            108.956193
          ],
          [
            16.789589,
            52.532128,
            108.682857
          ],
          [
            16.789686,
            52.531926,
            108.38554
          ],
          [
            16.789768,
            52.531721,
            108.087639
          ],
          [
            16.789849,
            52.531527,
            107.804947
          ],
          [
            16.789941,
            52.531344,
            107.534751
          ],
          [
            16.790028,
            52.53116,
            107.264415
          ],
          [
            16.790108,
            52.530957,
            106.9697
          ],
          [
            16.79016,
            52.530765,
            106.69494
          ],
          [
            16.790226,
            52.530571,
            106.760334
          ],
          [
            16.790296,
            52.530374,
            107.000559
          ],
          [
            16.790405,
            52.530172,
            107.254752
          ],
          [
            16.790438,
            52.529974,
            107.491855
          ],
          [
            16.790513,
            52.529785,
            107.723542
          ],
          [
            16.790589,
            52.52957,
            107.985477
          ],
          [
            16.790654,
            52.529363,
            108.236637
          ],
          [
            16.790679,
            52.529158,
            108.481647
          ],
          [
            16.79075,
            52.528951,
            108.733498
          ],
          [
            16.790856,
            52.528746,
            109.033586
          ],
          [
            16.790929,
            52.528556,
            109.307535
          ],
          [
            16.790996,
            52.528358,
            109.59146
          ],
          [
            16.791087,
            52.528159,
            109.881476
          ],
          [
            16.791164,
            52.527969,
            110.156267
          ],
          [
            16.791242,
            52.527784,
            110.424477
          ],
          [
            16.791337,
            52.527596,
            110.700917
          ],
          [
            16.791401,
            52.527401,
            110.980112
          ],
          [
            16.791475,
            52.527181,
            111.274355
          ],
          [
            16.791552,
            52.526973,
            111.327062
          ],
          [
            16.791635,
            52.526773,
            111.378082
          ],
          [
            16.791689,
            52.52657,
            111.428853
          ],
          [
            16.791764,
            52.526367,
            111.4802
          ],
          [
            16.791858,
            52.526171,
            111.530642
          ],
          [
            16.791947,
            52.525953,
            111.586177
          ],
          [
            16.792001,
            52.525756,
            111.635466
          ],
          [
            16.792075,
            52.525547,
            111.688231
          ],
          [
            16.792168,
            52.525337,
            111.665019
          ],
          [
            16.792266,
            52.525136,
            111.575967
          ],
          [
            16.79233,
            52.524938,
            111.490337
          ],
          [
            16.792398,
            52.524731,
            111.400889
          ],
          [
            16.792469,
            52.524527,
            111.312493
          ],
          [
            16.792554,
            52.524341,
            111.230664
          ],
          [
            16.792625,
            52.524148,
            111.146694
          ],
          [
            16.79276,
            52.523937,
            111.050332
          ],
          [
            16.792733,
            52.523742,
            110.966395
          ],
          [
            16.792571,
            52.523557,
            111.152191
          ],
          [
            16.792381,
            52.523377,
            111.396872
          ],
          [
            16.792349,
            52.523189,
            111.620074
          ],
          [
            16.792413,
            52.522989,
            111.854063
          ],
          [
            16.792471,
            52.522791,
            112.084606
          ],
          [
            16.79251,
            52.522563,
            112.346871
          ],
          [
            16.792575,
            52.522345,
            112.600317
          ],
          [
            16.792665,
            52.522114,
            112.871708
          ],
          [
            16.792722,
            52.521884,
            113.088801
          ],
          [
            16.792802,
            52.521653,
            113.257288
          ],
          [
            16.79289,
            52.521419,
            113.428607
          ],
          [
            16.792952,
            52.521182,
            113.59992
          ],
          [
            16.793018,
            52.520946,
            113.770803
          ],
          [
            16.793087,
            52.520699,
            113.949628
          ],
          [
            16.793158,
            52.520455,
            114.126476
          ],
          [
            16.793228,
            52.520208,
            114.303867
          ],
          [
            16.793312,
            52.519978,
            114.454134
          ],
          [
            16.793395,
            52.51975,
            114.603317
          ],
          [
            16.79348,
            52.519527,
            114.749662
          ],
          [
            16.79357,
            52.519303,
            114.896718
          ],
          [
            16.793652,
            52.51908,
            115.042454
          ],
          [
            16.793746,
            52.518836,
            115.202294
          ],
          [
            16.793817,
            52.518619,
            115.343436
          ],
          [
            16.793882,
            52.518371,
            115.783832
          ],
          [
            16.79392,
            52.518166,
            116.480774
          ],
          [
            16.793967,
            52.517953,
            117.207023
          ],
          [
            16.794026,
            52.517738,
            117.943923
          ],
          [
            16.794103,
            52.517523,
            118.687264
          ],
          [
            16.794171,
            52.517302,
            119.446822
          ],
          [
            16.794271,
            52.517102,
            120.153036
          ],
          [
            16.794318,
            52.516901,
            120.838952
          ],
          [
            16.794388,
            52.516706,
            121.513237
          ],
          [
            16.794452,
            52.516492,
            120.728236
          ],
          [
            16.79451,
            52.51626,
            119.879677
          ],
          [
            16.794555,
            52.516064,
            119.164088
          ],
          [
            16.794604,
            52.515831,
            118.31476
          ],
          [
            16.794692,
            52.515552,
            117.285618
          ],
          [
            16.794793,
            52.515251,
            116.174392
          ],
          [
            16.794889,
            52.514933,
            115.007301
          ],
          [
            16.794999,
            52.514603,
            114.22775
          ],
          [
            16.795091,
            52.514347,
            113.618933
          ],
          [
            16.795195,
            52.514068,
            112.956597
          ],
          [
            16.795291,
            52.513806,
            112.335148
          ],
          [
            16.79537,
            52.513575,
            111.788805
          ],
          [
            16.795448,
            52.513358,
            111.274407
          ],
          [
            16.795501,
            52.513152,
            110.859895
          ],
          [
            16.795583,
            52.512924,
            110.980027
          ],
          [
            16.795666,
            52.512709,
            111.093809
          ],
          [
            16.795763,
            52.512494,
            111.208531
          ],
          [
            16.795846,
            52.51228,
            111.321663
          ],
          [
            16.795911,
            52.512065,
            111.434149
          ],
          [
            16.79599,
            52.511851,
            111.547037
          ],
          [
            16.796065,
            52.51162,
            111.668199
          ],
          [
            16.796131,
            52.511419,
            111.772704
          ],
          [
            16.796181,
            52.511228,
            111.742759
          ],
          [
            16.796225,
            52.51104,
            111.713359
          ],
          [
            16.796297,
            52.510789,
            111.673913
          ],
          [
            16.796356,
            52.51056,
            111.638026
          ],
          [
            16.796426,
            52.510302,
            111.597544
          ],
          [
            16.796509,
            52.51008,
            111.562293
          ],
          [
            16.796587,
            52.509828,
            111.522566
          ],
          [
            16.796653,
            52.509645,
            111.493273
          ],
          [
            16.796756,
            52.509457,
            111.453252
          ],
          [
            16.796834,
            52.50926,
            111.41236
          ],
          [
            16.796932,
            52.509054,
            111.369012
          ],
          [
            16.797013,
            52.508829,
            111.322494
          ],
          [
            16.797065,
            52.508642,
            111.284229
          ],
          [
            16.797132,
            52.508457,
            111.246008
          ],
          [
            16.797192,
            52.508277,
            111.208957
          ],
          [
            16.797249,
            52.508095,
            111.171589
          ],
          [
            16.79732,
            52.507877,
            111.145817
          ],
          [
            16.797401,
            52.507619,
            111.29641
          ],
          [
            16.79747,
            52.507362,
            111.445737
          ],
          [
            16.797525,
            52.507142,
            111.573399
          ],
          [
            16.797567,
            52.506956,
            111.681095
          ],
          [
            16.797625,
            52.506761,
            111.794784
          ],
          [
            16.797638,
            52.506574,
            111.902115
          ],
          [
            16.797688,
            52.506346,
            112.034399
          ],
          [
            16.797729,
            52.506149,
            112.148306
          ],
          [
            16.797766,
            52.505968,
            111.872222
          ],
          [
            16.797749,
            52.505748,
            111.468967
          ],
          [
            16.797775,
            52.50553,
            111.068357
          ],
          [
            16.797791,
            52.505315,
            110.674262
          ],
          [
            16.797763,
            52.505079,
            110.240902
          ],
          [
            16.797742,
            52.504851,
            109.822744
          ],
          [
            16.797723,
            52.504625,
            109.408346
          ],
          [
            16.797739,
            52.504435,
            109.059959
          ],
          [
            16.797756,
            52.50425,
            108.933229
          ],
          [
            16.797757,
            52.504052,
            109.088051
          ],
          [
            16.797753,
            52.50383,
            109.261359
          ],
          [
            16.797753,
            52.503562,
            109.470664
          ],
          [
            16.79777,
            52.503329,
            109.652724
          ],
          [
            16.797779,
            52.503101,
            109.831084
          ],
          [
            16.797792,
            52.502899,
            109.988964
          ],
          [
            16.797792,
            52.502698,
            110.14591
          ],
          [
            16.797758,
            52.502503,
            110.274539
          ],
          [
            16.797707,
            52.502314,
            110.279432
          ],
          [
            16.797679,
            52.502116,
            110.284509
          ],
          [
            16.797647,
            52.501918,
            110.289592
          ],
          [
            16.797599,
            52.50172,
            110.294706
          ],
          [
            16.797545,
            52.501539,
            110.299405
          ],
          [
            16.797508,
            52.501335,
            110.304655
          ],
          [
            16.797443,
            52.501127,
            110.310063
          ],
          [
            16.797313,
            52.500915,
            110.315844
          ],
          [
            16.79713,
            52.500741,
            110.27529
          ],
          [
            16.797019,
            52.500557,
            110.124697
          ],
          [
            16.796861,
            52.500355,
            109.958047
          ],
          [
            16.796741,
            52.500184,
            109.819704
          ],
          [
            16.796603,
            52.500015,
            109.678198
          ],
          [
            16.796422,
            52.499833,
            109.519906
          ],
          [
            16.796256,
            52.499639,
            109.357166
          ],
          [
            16.796086,
            52.499442,
            109.191602
          ],
          [
            16.79593,
            52.499237,
            109.023492
          ],
          [
            16.795714,
            52.499012,
            109.117321
          ],
          [
            16.795515,
            52.498828,
            109.263343
          ],
          [
            16.795368,
            52.498667,
            109.385435
          ],
          [
            16.795216,
            52.498494,
            109.51587
          ],
          [
            16.795115,
            52.498308,
            109.64598
          ],
          [
            16.795079,
            52.498095,
            109.78791
          ],
          [
            16.795091,
            52.497886,
            109.926901
          ],
          [
            16.795149,
            52.49768,
            110.065609
          ],
          [
            16.795199,
            52.497486,
            110.224977
          ],
          [
            16.795283,
            52.497261,
            110.581303
          ],
          [
            16.795315,
            52.497056,
            110.897852
          ],
          [
            16.795321,
            52.497043,
            111.219855
          ],
          [
            16.795357,
            52.496833,
            111.544764
          ],
          [
            16.79541,
            52.496621,
            111.874886
          ],
          [
            16.795489,
            52.496421,
            112.191166
          ],
          [
            16.79556,
            52.496235,
            112.484962
          ],
          [
            16.795648,
            52.496024,
            112.820007
          ],
          [
            16.795665,
            52.495826,
            112.972208
          ],
          [
            16.795664,
            52.495619,
            113.029469
          ],
          [
            16.795656,
            52.495394,
            113.09173
          ],
          [
            16.795658,
            52.49518,
            113.150922
          ],
          [
            16.795658,
            52.494991,
            113.203328
          ],
          [
            16.795699,
            52.494788,
            113.260009
          ],
          [
            16.795785,
            52.494572,
            113.32151
          ],
          [
            16.795879,
            52.494346,
            113.386067
          ],
          [
            16.795995,
            52.494114,
            113.517477
          ],
          [
            16.796104,
            52.493879,
            113.841649
          ],
          [
            16.796203,
            52.493638,
            114.171221
          ],
          [
            16.796289,
            52.493393,
            114.503338
          ],
          [
            16.796405,
            52.493157,
            114.829902
          ],
          [
            16.796524,
            52.492908,
            115.173691
          ],
          [
            16.796642,
            52.492679,
            115.492101
          ],
          [
            16.796743,
            52.492462,
            115.79109
          ],
          [
            16.796859,
            52.492244,
            115.546469
          ],
          [
            16.796958,
            52.492021,
            115.240889
          ],
          [
            16.797051,
            52.49179,
            114.926365
          ],
          [
            16.797135,
            52.491558,
            114.612181
          ],
          [
            16.797218,
            52.491334,
            114.308413
          ],
          [
            16.797305,
            52.491079,
            113.963993
          ],
          [
            16.797419,
            52.490861,
            113.661398
          ],
          [
            16.797518,
            52.490687,
            113.452653
          ],
          [
            16.797623,
            52.490466,
            113.5864
          ],
          [
            16.797716,
            52.490254,
            113.713686
          ],
          [
            16.797812,
            52.490075,
            113.822894
          ],
          [
            16.797911,
            52.489822,
            113.973763
          ],
          [
            16.798016,
            52.489612,
            114.101062
          ],
          [
            16.798084,
            52.489421,
            114.214431
          ],
          [
            16.798191,
            52.489239,
            114.32665
          ],
          [
            16.798289,
            52.489058,
            114.437293
          ],
          [
            16.798388,
            52.488881,
            114.389016
          ],
          [
            16.798471,
            52.488672,
            114.192116
          ],
          [
            16.798558,
            52.488461,
            113.992099
          ],
          [
            16.79865,
            52.488202,
            113.749425
          ],
          [
            16.79875,
            52.488014,
            113.568292
          ],
          [
            16.798827,
            52.487824,
            113.389048
          ],
          [
            16.798923,
            52.487631,
            113.204295
          ],
          [
            16.799068,
            52.487418,
            112.992857
          ],
          [
            16.799168,
            52.487173,
            112.562242
          ],
          [
            16.79915,
            52.486955,
            111.848709
          ],
          [
            16.799012,
            52.486763,
            111.162839
          ],
          [
            16.798796,
            52.486573,
            110.40687
          ],
          [
            16.79855,
            52.486394,
            109.64112
          ],
          [
            16.798317,
            52.486221,
            108.910791
          ],
          [
            16.798092,
            52.486051,
            108.198125
          ],
          [
            16.797845,
            52.485876,
            107.444206
          ],
          [
            16.79759,
            52.485713,
            106.896337
          ],
          [
            16.797342,
            52.485553,
            106.69842
          ],
          [
            16.797066,
            52.485421,
            106.506108
          ],
          [
            16.796816,
            52.485269,
            106.312592
          ],
          [
            16.796557,
            52.485148,
            106.13367
          ],
          [
            16.796287,
            52.485024,
            105.948386
          ],
          [
            16.796058,
            52.484909,
            105.785749
          ],
          [
            16.795786,
            52.484756,
            105.582928
          ],
          [
            16.795473,
            52.484625,
            105.374906
          ],
          [
            16.795258,
            52.484498,
            105.546412
          ],
          [
            16.794926,
            52.484339,
            105.872825
          ],
          [
            16.794688,
            52.484218,
            106.112032
          ],
          [
            16.794477,
            52.484071,
            106.359479
          ],
          [
            16.794209,
            52.483919,
            106.641987
          ],
          [
            16.793949,
            52.483765,
            106.921676
          ],
          [
            16.793722,
            52.483634,
            107.162999
          ],
          [
            16.793498,
            52.483502,
            107.403423
          ],
          [
            16.79323,
            52.483344,
            107.662405
          ],
          [
            16.792949,
            52.483178,
            107.828757
          ],
          [
            16.792715,
            52.483032,
            107.970998
          ],
          [
            16.792444,
            52.48288,
            108.127374
          ],
          [
            16.792442,
            52.482891,
            108.281502
          ],
          [
            16.792723,
            52.483066,
            108.452221
          ],
          [
            16.793036,
            52.483259,
            108.64131
          ],
          [
            16.793258,
            52.483382,
            108.768706
          ],
          [
            16.793512,
            52.483542,
            108.879147
          ],
          [
            16.79383,
            52.483711,
            108.871925
          ],
          [
            16.794063,
            52.483829,
            108.866744
          ],
          [
            16.794311,
            52.483952,
            108.861269
          ],
          [
            16.79455,
            52.484074,
            108.855935
          ],
          [
            16.794807,
            52.484234,
            108.84965
          ],
          [
            16.795065,
            52.484365,
            108.843906
          ],
          [
            16.795312,
            52.484506,
            108.838115
          ],
          [
            16.795596,
            52.484662,
            108.831564
          ],
          [
            16.795834,
            52.484797,
            109.011051
          ],
          [
            16.79612,
            52.484923,
            109.259624
          ],
          [
            16.79638,
            52.48505,
            109.494347
          ],
          [
            16.796645,
            52.485161,
            109.720849
          ],
          [
            16.796931,
            52.485311,
            109.986748
          ],
          [
            16.7972,
            52.485441,
            110.228851
          ],
          [
            16.797458,
            52.485595,
            110.483192
          ],
          [
            16.797684,
            52.485721,
            110.698947
          ],
          [
            16.797908,
            52.485868,
            110.908988
          ],
          [
            16.798193,
            52.486084,
            110.898652
          ],
          [
            16.798396,
            52.486273,
            110.890234
          ],
          [
            16.798633,
            52.48646,
            110.881412
          ],
          [
            16.798878,
            52.486628,
            110.873037
          ],
          [
            16.799096,
            52.486525,
            110.865959
          ],
          [
            16.799143,
            52.48632,
            110.858176
          ],
          [
            16.799232,
            52.486093,
            110.849466
          ],
          [
            16.799304,
            52.485854,
            110.789856
          ],
          [
            16.799462,
            52.485663,
            110.599144
          ],
          [
            16.799667,
            52.485482,
            110.40471
          ],
          [
            16.799884,
            52.485288,
            110.198115
          ],
          [
            16.800004,
            52.485083,
            110.005011
          ],
          [
            16.800138,
            52.484884,
            109.815679
          ],
          [
            16.800181,
            52.484696,
            109.648158
          ],
          [
            16.800212,
            52.484459,
            109.438357
          ],
          [
            16.800198,
            52.484249,
            109.251006
          ],
          [
            16.800097,
            52.484023,
            108.966175
          ],
          [
            16.800057,
            52.483812,
            108.707878
          ],
          [
            16.80006,
            52.483609,
            108.459502
          ],
          [
            16.800159,
            52.483404,
            108.19944
          ],
          [
            16.800158,
            52.483169,
            107.913588
          ],
          [
            16.800158,
            52.48294,
            107.634341
          ],
          [
            16.800212,
            52.482703,
            107.342361
          ],
          [
            16.800312,
            52.482494,
            107.077608
          ],
          [
            16.800512,
            52.482288,
            107.009482
          ],
          [
            16.800718,
            52.482083,
            106.945115
          ],
          [
            16.800846,
            52.48187,
            106.884563
          ],
          [
            16.800942,
            52.481651,
            106.824051
          ],
          [
            16.801022,
            52.481445,
            106.767203
          ],
          [
            16.801044,
            52.48122,
            106.707023
          ],
          [
            16.801078,
            52.480962,
            106.637917
          ],
          [
            16.801149,
            52.480719,
            106.710734
          ],
          [
            16.801268,
            52.480517,
            107.046444
          ],
          [
            16.801485,
            52.480349,
            107.383072
          ],
          [
            16.801801,
            52.480207,
            107.756479
          ],
          [
            16.801994,
            52.480055,
            108.05615
          ],
          [
            16.802151,
            52.479834,
            108.435238
          ],
          [
            16.802138,
            52.479634,
            108.748558
          ],
          [
            16.802171,
            52.479431,
            109.066719
          ],
          [
            16.802107,
            52.479245,
            109.362758
          ],
          [
            16.802053,
            52.479035,
            109.654535
          ],
          [
            16.801999,
            52.478823,
            109.945131
          ],
          [
            16.801947,
            52.478601,
            110.248906
          ],
          [
            16.801895,
            52.478404,
            110.519496
          ],
          [
            16.801879,
            52.478178,
            110.827969
          ],
          [
            16.80183,
            52.477952,
            111.136882
          ],
          [
            16.801783,
            52.477758,
            111.402696
          ],
          [
            16.80171,
            52.477539,
            111.705512
          ],
          [
            16.801659,
            52.477311,
            111.653403
          ],
          [
            16.801562,
            52.477043,
            111.307012
          ],
          [
            16.801526,
            52.476832,
            111.039524
          ],
          [
            16.801495,
            52.476613,
            110.76259
          ],
          [
            16.801626,
            52.47642,
            110.491743
          ],
          [
            16.801956,
            52.476418,
            110.23702
          ],
          [
            16.802309,
            52.476424,
            109.964388
          ],
          [
            16.802689,
            52.476423,
            109.672755
          ],
          [
            16.803079,
            52.476438,
            109.63297
          ],
          [
            16.803395,
            52.476449,
            109.722448
          ],
          [
            16.803709,
            52.476439,
            109.811441
          ],
          [
            16.804024,
            52.4764,
            109.902352
          ],
          [
            16.804311,
            52.476346,
            109.987413
          ],
          [
            16.80462,
            52.476276,
            110.080633
          ],
          [
            16.804859,
            52.476132,
            110.176738
          ],
          [
            16.804861,
            52.47593,
            110.271488
          ],
          [
            16.804762,
            52.475716,
            110.374772
          ],
          [
            16.804658,
            52.475519,
            110.577869
          ],
          [
            16.804551,
            52.475336,
            110.798486
          ],
          [
            16.804449,
            52.475143,
            111.028789
          ],
          [
            16.804185,
            52.475022,
            111.260388
          ],
          [
            16.804032,
            52.474818,
            111.515178
          ],
          [
            16.803883,
            52.474631,
            111.751384
          ],
          [
            16.803759,
            52.474439,
            111.985702
          ],
          [
            16.803661,
            52.474234,
            112.228293
          ],
          [
            16.803569,
            52.474058,
            112.438094
          ],
          [
            16.803463,
            52.473852,
            112.718331
          ],
          [
            16.803335,
            52.473669,
            112.97671
          ],
          [
            16.803199,
            52.473489,
            113.234499
          ],
          [
            16.803012,
            52.473306,
            113.514674
          ],
          [
            16.802835,
            52.473111,
            113.804124
          ],
          [
            16.802636,
            52.472919,
            114.099065
          ],
          [
            16.802454,
            52.472733,
            114.380831
          ],
          [
            16.80228,
            52.472581,
            114.621849
          ],
          [
            16.802114,
            52.472382,
            114.754909
          ],
          [
            16.802103,
            52.472145,
            114.708324
          ],
          [
            16.802202,
            52.471917,
            114.661775
          ],
          [
            16.802469,
            52.471762,
            114.617647
          ],
          [
            16.802822,
            52.471658,
            114.570756
          ],
          [
            16.803169,
            52.471569,
            114.525842
          ],
          [
            16.803457,
            52.471466,
            114.48601
          ],
          [
            16.80373,
            52.471366,
            114.447981
          ],
          [
            16.804032,
            52.471262,
            114.328336
          ],
          [
            16.804351,
            52.471166,
            114.087406
          ],
          [
            16.804678,
            52.471065,
            113.838286
          ],
          [
            16.805017,
            52.47097,
            113.585537
          ],
          [
            16.80532,
            52.470856,
            113.343449
          ],
          [
            16.805619,
            52.470765,
            113.116946
          ],
          [
            16.805896,
            52.470659,
            112.893727
          ],
          [
            16.806206,
            52.470533,
            112.640794
          ],
          [
            16.806507,
            52.470387,
            112.444441
          ],
          [
            16.806808,
            52.470249,
            112.562921
          ],
          [
            16.807089,
            52.470099,
            112.680174
          ],
          [
            16.807423,
            52.469903,
            112.826524
          ],
          [
            16.807626,
            52.469755,
            112.926237
          ],
          [
            16.807853,
            52.469597,
            113.03441
          ],
          [
            16.808068,
            52.469411,
            113.151633
          ],
          [
            16.808356,
            52.46925,
            113.274306
          ],
          [
            16.808592,
            52.469127,
            113.379708
          ],
          [
            16.808826,
            52.468955,
            113.538051
          ],
          [
            16.80907,
            52.468776,
            113.702894
          ],
          [
            16.809262,
            52.468617,
            113.842735
          ],
          [
            16.809511,
            52.468438,
            114.008991
          ],
          [
            16.809745,
            52.468255,
            114.173429
          ],
          [
            16.809981,
            52.46808,
            114.334687
          ],
          [
            16.810209,
            52.467935,
            114.477854
          ],
          [
            16.810604,
            52.467871,
            114.53839
          ],
          [
            16.810934,
            52.467895,
            114.143765
          ],
          [
            16.811205,
            52.468005,
            113.760368
          ],
          [
            16.81151,
            52.468088,
            113.35985
          ],
          [
            16.811834,
            52.468078,
            112.980658
          ],
          [
            16.812142,
            52.468037,
            112.61112
          ],
          [
            16.812436,
            52.467966,
            112.238595
          ],
          [
            16.812718,
            52.467836,
            111.825485
          ],
          [
            16.813024,
            52.467683,
            111.363139
          ],
          [
            16.813295,
            52.467564,
            111.220166
          ],
          [
            16.8136,
            52.467444,
            111.309928
          ],
          [
            16.813887,
            52.467348,
            111.390771
          ],
          [
            16.814216,
            52.467241,
            111.483015
          ],
          [
            16.814509,
            52.467151,
            111.564168
          ],
          [
            16.814822,
            52.467084,
            111.646098
          ],
          [
            16.815145,
            52.467046,
            111.727418
          ],
          [
            16.81551,
            52.467002,
            111.81929
          ],
          [
            16.815815,
            52.46693,
            111.90216
          ],
          [
            16.816141,
            52.46686,
            111.252794
          ],
          [
            16.816498,
            52.466855,
            110.541354
          ],
          [
            16.81681,
            52.466839,
            109.923043
          ],
          [
            16.817136,
            52.466844,
            109.278665
          ],
          [
            16.81751,
            52.466836,
            108.539124
          ],
          [
            16.817854,
            52.466843,
            107.857421
          ],
          [
            16.81838,
            52.466831,
            106.802229
          ],
          [
            16.818725,
            52.466813,
            106.117033
          ],
          [
            16.819043,
            52.466692,
            106.931928
          ],
          [
            16.819399,
            52.46661,
            107.851365
          ],
          [
            16.819745,
            52.466525,
            108.767655
          ],
          [
            16.820009,
            52.466407,
            109.556418
          ],
          [
            16.820269,
            52.466287,
            110.342376
          ],
          [
            16.820519,
            52.466142,
            111.173733
          ],
          [
            16.820741,
            52.465994,
            111.966772
          ],
          [
            16.820968,
            52.465774,
            112.994637
          ],
          [
            16.821157,
            52.465602,
            113.369752
          ],
          [
            16.821376,
            52.465445,
            113.608152
          ],
          [
            16.82162,
            52.465312,
            113.839725
          ],
          [
            16.821962,
            52.465162,
            114.137428
          ],
          [
            16.822222,
            52.465033,
            114.375217
          ],
          [
            16.82253,
            52.464889,
            114.652721
          ],
          [
            16.822774,
            52.464756,
            114.883619
          ],
          [
            16.823109,
            52.464611,
            115.173311
          ],
          [
            16.823351,
            52.464437,
            114.873507
          ],
          [
            16.823588,
            52.464211,
            114.156672
          ],
          [
            16.823788,
            52.464053,
            113.623328
          ],
          [
            16.824026,
            52.463906,
            113.07144
          ],
          [
            16.824256,
            52.463769,
            112.547419
          ],
          [
            16.824542,
            52.463646,
            111.976746
          ],
          [
            16.82489,
            52.463547,
            111.349574
          ],
          [
            16.825181,
            52.463459,
            110.820309
          ],
          [
            16.825492,
            52.463335,
            110.491014
          ],
          [
            16.825819,
            52.463175,
            110.576156
          ],
          [
            16.826079,
            52.462991,
            110.657326
          ],
          [
            16.826196,
            52.462809,
            110.724019
          ],
          [
            16.826089,
            52.46262,
            110.790635
          ],
          [
            16.826083,
            52.462667,
            110.854307
          ],
          [
            16.826085,
            52.462641,
            110.919119
          ],
          [
            16.826378,
            52.462598,
            110.982409
          ],
          [
            16.826689,
            52.46248,
            111.062833
          ],
          [
            16.826916,
            52.462322,
            111.086444
          ],
          [
            16.827076,
            52.462159,
            111.107802
          ],
          [
            16.827237,
            52.461979,
            111.131006
          ],
          [
            16.82716,
            52.461796,
            111.152291
          ],
          [
            16.826991,
            52.461601,
            111.177126
          ],
          [
            16.826931,
            52.461417,
            111.198323
          ],
          [
            16.827023,
            52.461156,
            111.228388
          ],
          [
            16.827242,
            52.460938,
            111.257292
          ],
          [
            16.827454,
            52.460775,
            111.180187
          ],
          [
            16.827717,
            52.46063,
            111.076351
          ],
          [
            16.828007,
            52.460475,
            110.963725
          ],
          [
            16.828309,
            52.460347,
            110.856318
          ],
          [
            16.828641,
            52.46025,
            110.74871
          ],
          [
            16.828927,
            52.460174,
            110.657404
          ],
          [
            16.829232,
            52.460107,
            110.562747
          ],
          [
            16.829562,
            52.460053,
            110.462983
          ],
          [
            16.829866,
            52.46,
            110.524323
          ],
          [
            16.830156,
            52.459953,
            110.897599
          ],
          [
            16.830493,
            52.459895,
            111.333965
          ],
          [
            16.830804,
            52.459794,
            111.778227
          ],
          [
            16.830981,
            52.459605,
            112.222338
          ],
          [
            16.831203,
            52.459368,
            112.779933
          ],
          [
            16.831307,
            52.459185,
            113.175176
          ],
          [
            16.831419,
            52.458925,
            113.724042
          ],
          [
            16.83156,
            52.4587,
            113.915029
          ],
          [
            16.831665,
            52.458494,
            113.44404
          ],
          [
            16.831765,
            52.458242,
            112.878493
          ],
          [
            16.831751,
            52.458014,
            112.380885
          ],
          [
            16.83175,
            52.45775,
            111.805174
          ],
          [
            16.831804,
            52.457484,
            111.218715
          ],
          [
            16.831819,
            52.457262,
            110.733899
          ],
          [
            16.831836,
            52.457049,
            110.267259
          ],
          [
            16.831846,
            52.456861,
            110.317988
          ],
          [
            16.83186,
            52.456678,
            110.551542
          ],
          [
            16.831854,
            52.456422,
            110.878101
          ],
          [
            16.831844,
            52.456236,
            111.115037
          ],
          [
            16.831817,
            52.456045,
            111.359794
          ],
          [
            16.831752,
            52.455803,
            111.672075
          ],
          [
            16.831715,
            52.455579,
            111.959296
          ],
          [
            16.83174,
            52.455329,
            112.278191
          ],
          [
            16.831776,
            52.455089,
            112.175958
          ],
          [
            16.83182,
            52.454807,
            111.536706
          ],
          [
            16.831856,
            52.4546,
            111.067789
          ],
          [
            16.831859,
            52.454376,
            110.562598
          ],
          [
            16.831789,
            52.454148,
            110.031679
          ],
          [
            16.83173,
            52.453955,
            109.587716
          ],
          [
            16.83175,
            52.45372,
            109.057488
          ],
          [
            16.831823,
            52.45354,
            108.639566
          ],
          [
            16.831954,
            52.453343,
            107.830452
          ],
          [
            16.832135,
            52.453154,
            106.620465
          ],
          [
            16.832364,
            52.452977,
            105.378037
          ],
          [
            16.832532,
            52.452787,
            104.188124
          ],
          [
            16.832754,
            52.452645,
            103.107032
          ],
          [
            16.832987,
            52.452481,
            101.911185
          ],
          [
            16.833224,
            52.452306,
            100.660479
          ],
          [
            16.833464,
            52.452131,
            99.403226
          ],
          [
            16.833708,
            52.45196,
            98.535454
          ],
          [
            16.833992,
            52.451827,
            98.775529
          ],
          [
            16.834276,
            52.451691,
            99.017559
          ],
          [
            16.834513,
            52.451558,
            99.233832
          ],
          [
            16.834795,
            52.45138,
            99.50596
          ],
          [
            16.835095,
            52.451233,
            99.76456
          ],
          [
            16.83541,
            52.45112,
            100.009569
          ],
          [
            16.835696,
            52.451033,
            100.223777
          ],
          [
            16.836062,
            52.450918,
            100.72349
          ],
          [
            16.836244,
            52.450762,
            101.856455
          ],
          [
            16.836462,
            52.450579,
            103.200014
          ],
          [
            16.836752,
            52.450467,
            104.441662
          ],
          [
            16.837139,
            52.450445,
            105.843166
          ],
          [
            16.837398,
            52.450335,
            106.995571
          ],
          [
            16.837601,
            52.450187,
            108.1336
          ],
          [
            16.837871,
            52.450058,
            109.368671
          ],
          [
            16.838195,
            52.449937,
            110.738423
          ],
          [
            16.838522,
            52.449832,
            110.774344
          ],
          [
            16.838772,
            52.449728,
            110.464674
          ],
          [
            16.839055,
            52.449527,
            110.020779
          ],
          [
            16.839277,
            52.449348,
            109.643027
          ],
          [
            16.839444,
            52.449151,
            109.272384
          ],
          [
            16.839657,
            52.448941,
            108.859547
          ],
          [
            16.839754,
            52.448747,
            108.520496
          ],
          [
            16.839851,
            52.448558,
            108.189325
          ],
          [
            16.839909,
            52.44837,
            108.057013
          ],
          [
            16.839976,
            52.448186,
            108.063324
          ],
          [
            16.840021,
            52.44796,
            108.070962
          ],
          [
            16.840072,
            52.447762,
            108.077674
          ],
          [
            16.840139,
            52.447539,
            108.085346
          ],
          [
            16.840304,
            52.447382,
            108.091589
          ],
          [
            16.840395,
            52.447193,
            108.098183
          ],
          [
            16.840575,
            52.447043,
            108.104457
          ],
          [
            16.840786,
            52.446889,
            108.111175
          ],
          [
            16.841029,
            52.446697,
            107.986022
          ],
          [
            16.8412,
            52.446486,
            107.811337
          ],
          [
            16.841378,
            52.446283,
            107.642079
          ],
          [
            16.841461,
            52.446089,
            107.49489
          ],
          [
            16.841526,
            52.445876,
            107.336057
          ],
          [
            16.841629,
            52.445676,
            107.180874
          ],
          [
            16.841776,
            52.445463,
            107.011451
          ],
          [
            16.842004,
            52.445278,
            106.841849
          ],
          [
            16.842232,
            52.445089,
            106.726612
          ],
          [
            16.842474,
            52.444898,
            106.62928
          ],
          [
            16.8427,
            52.44472,
            106.53888
          ],
          [
            16.842965,
            52.444523,
            106.436642
          ],
          [
            16.843155,
            52.444314,
            106.340668
          ],
          [
            16.84331,
            52.44412,
            106.254067
          ],
          [
            16.843517,
            52.443926,
            106.160841
          ],
          [
            16.843698,
            52.443729,
            106.093973
          ],
          [
            16.843892,
            52.443547,
            106.656101
          ],
          [
            16.844137,
            52.443399,
            107.200982
          ],
          [
            16.844349,
            52.443267,
            107.679776
          ],
          [
            16.844668,
            52.443158,
            108.25583
          ],
          [
            16.844979,
            52.443069,
            108.797424
          ],
          [
            16.845313,
            52.442978,
            109.375081
          ],
          [
            16.845697,
            52.442899,
            110.014275
          ],
          [
            16.846069,
            52.442825,
            110.63039
          ],
          [
            16.846383,
            52.44268,
            110.235234
          ],
          [
            16.846683,
            52.442543,
            109.697586
          ],
          [
            16.846952,
            52.442409,
            109.19763
          ],
          [
            16.847277,
            52.442269,
            108.626567
          ],
          [
            16.847534,
            52.44214,
            108.147126
          ],
          [
            16.847828,
            52.442027,
            107.64837
          ],
          [
            16.848248,
            52.441932,
            106.996951
          ],
          [
            16.848504,
            52.441815,
            106.537164
          ],
          [
            16.848875,
            52.441724,
            107.100408
          ],
          [
            16.849144,
            52.441614,
            107.640864
          ],
          [
            16.849479,
            52.441446,
            108.360705
          ],
          [
            16.849732,
            52.441313,
            108.915085
          ],
          [
            16.850006,
            52.441173,
            109.508435
          ],
          [
            16.850209,
            52.441,
            110.087602
          ],
          [
            16.850525,
            52.440795,
            110.857194
          ],
          [
            16.850729,
            52.440628,
            111.345352
          ],
          [
            16.85091,
            52.440429,
            110.761952
          ],
          [
            16.851089,
            52.440261,
            110.250684
          ],
          [
            16.851277,
            52.440081,
            109.706334
          ],
          [
            16.851436,
            52.439914,
            109.213756
          ],
          [
            16.851641,
            52.439712,
            108.607653
          ],
          [
            16.851892,
            52.439519,
            107.979095
          ],
          [
            16.852076,
            52.439338,
            107.435891
          ],
          [
            16.85231,
            52.439133,
            106.795978
          ],
          [
            16.852543,
            52.438967,
            106.417645
          ],
          [
            16.852814,
            52.438792,
            105.994747
          ],
          [
            16.853086,
            52.438666,
            105.6321
          ],
          [
            16.853453,
            52.438527,
            105.176271
          ],
          [
            16.853817,
            52.438461,
            104.774638
          ],
          [
            16.854307,
            52.43844,
            104.256409
          ],
          [
            16.854665,
            52.438384,
            103.866254
          ],
          [
            16.854987,
            52.438336,
            103.662194
          ],
          [
            16.855313,
            52.438271,
            103.617528
          ],
          [
            16.855719,
            52.438217,
            103.563771
          ],
          [
            16.856009,
            52.438092,
            103.517809
          ],
          [
            16.856262,
            52.437927,
            103.46929
          ],
          [
            16.856521,
            52.437748,
            103.418554
          ],
          [
            16.856763,
            52.437604,
            103.374813
          ],
          [
            16.857016,
            52.437427,
            103.324919
          ],
          [
            16.857331,
            52.437287,
            103.70945
          ],
          [
            16.857643,
            52.43717,
            104.437235
          ],
          [
            16.857922,
            52.437075,
            105.072253
          ],
          [
            16.858263,
            52.436985,
            105.810162
          ],
          [
            16.858604,
            52.436873,
            106.579491
          ],
          [
            16.858975,
            52.436765,
            107.401682
          ],
          [
            16.859295,
            52.436659,
            108.125062
          ],
          [
            16.859569,
            52.43651,
            108.856112
          ],
          [
            16.859753,
            52.436341,
            108.962222
          ],
          [
            16.859857,
            52.436141,
            108.585047
          ],
          [
            16.86009,
            52.435922,
            108.115363
          ],
          [
            16.860273,
            52.435735,
            107.723716
          ],
          [
            16.860477,
            52.435563,
            107.342508
          ],
          [
            16.860647,
            52.435384,
            106.968756
          ],
          [
            16.860796,
            52.435208,
            106.612886
          ],
          [
            16.860931,
            52.435015,
            106.236305
          ],
          [
            16.861103,
            52.43481,
            105.677083
          ],
          [
            16.861306,
            52.434592,
            104.629592
          ],
          [
            16.861557,
            52.434412,
            103.637253
          ],
          [
            16.861767,
            52.434203,
            102.617254
          ],
          [
            16.861963,
            52.434,
            101.637021
          ],
          [
            16.862197,
            52.433813,
            100.658541
          ],
          [
            16.862371,
            52.433601,
            99.656702
          ],
          [
            16.862459,
            52.43341,
            98.830954
          ],
          [
            16.862494,
            52.433156,
            98.369641
          ],
          [
            16.862445,
            52.432932,
            98.25938
          ],
          [
            16.862405,
            52.43273,
            98.1594
          ],
          [
            16.862427,
            52.432465,
            98.029727
          ],
          [
            16.862536,
            52.432241,
            97.915714
          ],
          [
            16.8629,
            52.432128,
            97.787373
          ],
          [
            16.863177,
            52.43201,
            97.686579
          ],
          [
            16.863493,
            52.431933,
            97.584708
          ],
          [
            16.863829,
            52.431924,
            96.867428
          ],
          [
            16.86425,
            52.431955,
            95.857762
          ],
          [
            16.864598,
            52.432022,
            94.947708
          ],
          [
            16.864977,
            52.432042,
            94.038003
          ],
          [
            16.865435,
            52.43195,
            92.889238
          ],
          [
            16.865829,
            52.431818,
            91.818413
          ],
          [
            16.866228,
            52.431688,
            90.740967
          ],
          [
            16.866503,
            52.431535,
            91.51545
          ],
          [
            16.866766,
            52.431424,
            92.60653
          ],
          [
            16.866999,
            52.431162,
            94.223471
          ],
          [
            16.867192,
            52.430949,
            95.543687
          ],
          [
            16.867391,
            52.430787,
            96.641832
          ],
          [
            16.867602,
            52.430632,
            97.740621
          ],
          [
            16.867951,
            52.430562,
            98.964272
          ],
          [
            16.868335,
            52.430597,
            100.248506
          ],
          [
            16.868721,
            52.430615,
            100.490413
          ],
          [
            16.869056,
            52.430606,
            100.656443
          ],
          [
            16.869452,
            52.430574,
            100.854734
          ],
          [
            16.869922,
            52.430508,
            101.093565
          ],
          [
            16.870314,
            52.430496,
            101.287876
          ],
          [
            16.870714,
            52.43049,
            101.485899
          ],
          [
            16.871081,
            52.430434,
            101.673134
          ],
          [
            16.871444,
            52.430378,
            101.70208
          ],
          [
            16.871736,
            52.430308,
            101.593281
          ],
          [
            16.87209,
            52.430307,
            101.472535
          ],
          [
            16.872428,
            52.43029,
            101.356797
          ],
          [
            16.872825,
            52.430308,
            101.220713
          ],
          [
            16.873208,
            52.430354,
            101.085777
          ],
          [
            16.873602,
            52.430298,
            100.94779
          ],
          [
            16.873987,
            52.430312,
            100.815431
          ],
          [
            16.874354,
            52.430276,
            100.589189
          ],
          [
            16.874718,
            52.430241,
            100.297467
          ],
          [
            16.875086,
            52.430222,
            100.004869
          ],
          [
            16.875422,
            52.430211,
            99.737875
          ],
          [
            16.875785,
            52.430209,
            99.449633
          ],
          [
            16.876157,
            52.430146,
            99.143354
          ],
          [
            16.87653,
            52.430103,
            98.842203
          ],
          [
            16.876859,
            52.430082,
            98.580328
          ],
          [
            16.87717,
            52.430173,
            98.568163
          ],
          [
            16.877488,
            52.430207,
            98.921887
          ],
          [
            16.877824,
            52.430136,
            99.258269
          ],
          [
            16.878129,
            52.430076,
            99.561324
          ],
          [
            16.87859,
            52.430015,
            100.007047
          ],
          [
            16.878949,
            52.429948,
            100.361745
          ],
          [
            16.879291,
            52.429991,
            100.695833
          ],
          [
            16.879609,
            52.430038,
            101.006081
          ],
          [
            16.879948,
            52.430015,
            101.41715
          ],
          [
            16.880274,
            52.429998,
            101.957407
          ],
          [
            16.880583,
            52.429912,
            102.535311
          ],
          [
            16.880926,
            52.429886,
            103.109339
          ],
          [
            16.881184,
            52.429746,
            103.679894
          ],
          [
            16.881452,
            52.429597,
            104.278503
          ],
          [
            16.881629,
            52.429631,
            104.818126
          ],
          [
            16.881903,
            52.42975,
            105.375727
          ],
          [
            16.882172,
            52.429834,
            105.89603
          ],
          [
            16.882526,
            52.429878,
            106.683132
          ],
          [
            16.88284,
            52.429855,
            107.450673
          ],
          [
            16.883199,
            52.429841,
            108.319301
          ],
          [
            16.883553,
            52.429794,
            109.19489
          ],
          [
            16.883902,
            52.429809,
            110.039872
          ],
          [
            16.884287,
            52.429815,
            110.971048
          ],
          [
            16.884617,
            52.429827,
            111.779642
          ],
          [
            16.884946,
            52.42976,
            112.617231
          ],
          [
            16.885254,
            52.429724,
            113.073768
          ],
          [
            16.885514,
            52.429632,
            112.601507
          ],
          [
            16.885833,
            52.429581,
            112.078397
          ],
          [
            16.886237,
            52.429582,
            111.443588
          ],
          [
            16.886701,
            52.429587,
            110.714283
          ],
          [
            16.887059,
            52.429551,
            110.133186
          ],
          [
            16.88724,
            52.429392,
            109.632572
          ],
          [
            16.887502,
            52.429207,
            109.002145
          ],
          [
            16.887783,
            52.429032,
            108.410986
          ],
          [
            16.888109,
            52.428907,
            107.930368
          ],
          [
            16.888322,
            52.42878,
            107.554287
          ],
          [
            16.888503,
            52.428553,
            107.043778
          ],
          [
            16.888771,
            52.428369,
            106.543355
          ],
          [
            16.889032,
            52.428235,
            106.121803
          ],
          [
            16.88936,
            52.428187,
            105.705323
          ],
          [
            16.889669,
            52.428105,
            105.288976
          ],
          [
            16.889975,
            52.427923,
            105.072733
          ],
          [
            16.890224,
            52.427735,
            105.481924
          ],
          [
            16.890458,
            52.427541,
            105.889669
          ],
          [
            16.890656,
            52.42736,
            106.25878
          ],
          [
            16.890887,
            52.427192,
            106.629974
          ],
          [
            16.891014,
            52.427006,
            106.972656
          ],
          [
            16.891086,
            52.42679,
            107.345844
          ],
          [
            16.891281,
            52.426632,
            107.686031
          ],
          [
            16.891608,
            52.426523,
            107.823306
          ],
          [
            16.891959,
            52.426411,
            107.172364
          ],
          [
            16.892317,
            52.426305,
            106.518317
          ],
          [
            16.89266,
            52.426162,
            105.832554
          ],
          [
            16.89302,
            52.425985,
            105.07159
          ],
          [
            16.893247,
            52.425787,
            104.420118
          ],
          [
            16.89345,
            52.425531,
            103.653425
          ],
          [
            16.893695,
            52.425288,
            102.887783
          ],
          [
            16.89389,
            52.425055,
            102.188644
          ],
          [
            16.894171,
            52.424864,
            101.503987
          ],
          [
            16.894506,
            52.424673,
            100.757479
          ],
          [
            16.894926,
            52.424581,
            100.032058
          ],
          [
            16.895344,
            52.42451,
            99.327803
          ],
          [
            16.895833,
            52.424441,
            98.51319
          ],
          [
            16.896292,
            52.424389,
            98.852503
          ],
          [
            16.89664,
            52.424344,
            99.35372
          ],
          [
            16.896994,
            52.424347,
            99.852061
          ],
          [
            16.897348,
            52.424339,
            100.35078
          ],
          [
            16.897706,
            52.424294,
            100.864846
          ],
          [
            16.898105,
            52.424249,
            101.435506
          ],
          [
            16.898468,
            52.424169,
            101.978349
          ],
          [
            16.898789,
            52.424143,
            102.437032
          ],
          [
            16.899174,
            52.42409,
            102.368358
          ],
          [
            16.899524,
            52.424045,
            102.24547
          ],
          [
            16.899916,
            52.424007,
            102.108979
          ],
          [
            16.900271,
            52.423942,
            101.981642
          ],
          [
            16.900644,
            52.423907,
            101.851227
          ],
          [
            16.901023,
            52.42384,
            101.715384
          ],
          [
            16.901434,
            52.423769,
            101.568646
          ],
          [
            16.901767,
            52.423677,
            101.372335
          ],
          [
            16.90213,
            52.423589,
            100.966134
          ],
          [
            16.902448,
            52.42348,
            100.586298
          ],
          [
            16.902758,
            52.423344,
            100.190001
          ],
          [
            16.903053,
            52.42323,
            99.827424
          ],
          [
            16.903379,
            52.42312,
            99.440666
          ],
          [
            16.9037,
            52.423014,
            99.060447
          ],
          [
            16.903948,
            52.422895,
            98.732915
          ],
          [
            16.904214,
            52.422781,
            98.399269
          ],
          [
            16.904515,
            52.422633,
            98.081311
          ],
          [
            16.904787,
            52.422511,
            97.803627
          ],
          [
            16.905127,
            52.42237,
            97.465581
          ],
          [
            16.905405,
            52.422271,
            97.200762
          ],
          [
            16.905703,
            52.422178,
            96.925519
          ],
          [
            16.906034,
            52.422049,
            96.602096
          ],
          [
            16.90628,
            52.421927,
            96.340749
          ],
          [
            16.906572,
            52.421795,
            96.039771
          ],
          [
            16.906927,
            52.421676,
            95.377725
          ],
          [
            16.907119,
            52.421523,
            94.765892
          ],
          [
            16.907324,
            52.421326,
            94.088777
          ],
          [
            16.907704,
            52.421253,
            93.382445
          ],
          [
            16.908074,
            52.421205,
            92.71332
          ],
          [
            16.908381,
            52.42114,
            92.130699
          ],
          [
            16.908341,
            52.420939,
            91.54296
          ],
          [
            16.908317,
            52.420726,
            90.923346
          ],
          [
            16.908278,
            52.420471,
            90.50675
          ],
          [
            16.908193,
            52.420273,
            90.237101
          ],
          [
            16.908091,
            52.420088,
            89.979881
          ],
          [
            16.907974,
            52.419901,
            89.71441
          ],
          [
            16.907862,
            52.419684,
            89.414686
          ],
          [
            16.907781,
            52.419505,
            89.170019
          ],
          [
            16.907693,
            52.419318,
            88.913676
          ],
          [
            16.907587,
            52.419092,
            88.604014
          ],
          [
            16.907464,
            52.418875,
            88.929083
          ],
          [
            16.907357,
            52.418671,
            90.302739
          ],
          [
            16.907362,
            52.418472,
            91.608097
          ],
          [
            16.907568,
            52.41832,
            92.86466
          ],
          [
            16.907444,
            52.418114,
            94.272088
          ],
          [
            16.907428,
            52.417886,
            95.729142
          ],
          [
            16.907393,
            52.417684,
            97.025145
          ],
          [
            16.907319,
            52.417467,
            98.43774
          ],
          [
            16.907201,
            52.417284,
            99.691377
          ],
          [
            16.907057,
            52.417107,
            99.675693
          ],
          [
            16.907085,
            52.416896,
            99.431846
          ],
          [
            16.907445,
            52.416821,
            99.170869
          ],
          [
            16.907824,
            52.416768,
            98.904105
          ],
          [
            16.90823,
            52.416722,
            98.620541
          ],
          [
            16.9086,
            52.416672,
            98.360559
          ],
          [
            16.908948,
            52.416582,
            98.101242
          ],
          [
            16.909264,
            52.416388,
            97.756942
          ],
          [
            16.909458,
            52.416196,
            97.326085
          ],
          [
            16.909648,
            52.416027,
            96.936129
          ],
          [
            16.909806,
            52.415855,
            96.561048
          ],
          [
            16.909976,
            52.415675,
            96.165881
          ],
          [
            16.91018,
            52.41548,
            95.724197
          ],
          [
            16.910369,
            52.415274,
            95.275144
          ],
          [
            16.910552,
            52.415071,
            94.834457
          ],
          [
            16.910779,
            52.414888,
            94.468534
          ],
          [
            16.911062,
            52.414711,
            95.228584
          ],
          [
            16.911355,
            52.414544,
            95.978604
          ],
          [
            16.911644,
            52.414409,
            96.659738
          ],
          [
            16.911939,
            52.414277,
            97.34447
          ],
          [
            16.912188,
            52.414144,
            97.964778
          ],
          [
            16.91241,
            52.413993,
            98.586757
          ],
          [
            16.9125,
            52.413815,
            99.168606
          ],
          [
            16.912685,
            52.413642,
            99.803078
          ],
          [
            16.912629,
            52.413453,
            100.499888
          ],
          [
            16.912526,
            52.413258,
            101.26986
          ],
          [
            16.912432,
            52.413077,
            101.985557
          ],
          [
            16.912303,
            52.412895,
            102.732202
          ],
          [
            16.912161,
            52.412713,
            103.490002
          ],
          [
            16.912044,
            52.412494,
            104.355595
          ],
          [
            16.911927,
            52.412294,
            105.153649
          ],
          [
            16.911805,
            52.412099,
            105.939077
          ],
          [
            16.911697,
            52.411899,
            106.713872
          ],
          [
            16.911601,
            52.411722,
            107.03812
          ],
          [
            16.911478,
            52.411527,
            107.40137
          ],
          [
            16.911378,
            52.411357,
            107.715438
          ],
          [
            16.911307,
            52.411154,
            108.079955
          ],
          [
            16.911341,
            52.410968,
            108.422858
          ],
          [
            16.911706,
            52.410887,
            108.834824
          ],
          [
            16.912031,
            52.41082,
            109.198512
          ],
          [
            16.912341,
            52.410726,
            109.566255
          ],
          [
            16.912651,
            52.410625,
            109.581441
          ],
          [
            16.912898,
            52.410489,
            108.822058
          ],
          [
            16.912946,
            52.41029,
            108.064938
          ],
          [
            16.912907,
            52.410077,
            107.266912
          ],
          [
            16.91284,
            52.409847,
            106.399504
          ],
          [
            16.912745,
            52.409635,
            105.583239
          ],
          [
            16.912662,
            52.409461,
            104.910352
          ],
          [
            16.912549,
            52.409219,
            103.976017
          ],
          [
            16.912438,
            52.409035,
            103.247186
          ],
          [
            16.912366,
            52.408818,
            103.520631
          ],
          [
            16.912226,
            52.408606,
            103.954687
          ],
          [
            16.912055,
            52.408394,
            104.402646
          ],
          [
            16.911839,
            52.408252,
            104.775295
          ],
          [
            16.911833,
            52.408031,
            105.19738
          ],
          [
            16.911852,
            52.407825,
            105.588859
          ],
          [
            16.911743,
            52.407623,
            105.999852
          ],
          [
            16.91194,
            52.407475,
            106.36698
          ],
          [
            16.911948,
            52.407275,
            106.64916
          ],
          [
            16.911927,
            52.407028,
            106.861098
          ],
          [
            16.911791,
            52.406801,
            107.067247
          ],
          [
            16.911585,
            52.406647,
            107.240472
          ],
          [
            16.911599,
            52.40646,
            107.402136
          ],
          [
            16.911925,
            52.40633,
            107.621791
          ],
          [
            16.91228,
            52.406357,
            107.811971
          ],
          [
            16.912224,
            52.406152,
            107.990418
          ],
          [
            16.912085,
            52.405944,
            107.975439
          ],
          [
            16.911995,
            52.405734,
            107.741552
          ],
          [
            16.911919,
            52.405509,
            107.494299
          ],
          [
            16.91185,
            52.405273,
            107.236162
          ],
          [
            16.911777,
            52.405076,
            107.018609
          ],
          [
            16.911687,
            52.404881,
            106.800575
          ],
          [
            16.911596,
            52.40467,
            106.565096
          ],
          [
            16.911532,
            52.404462,
            106.336986
          ],
          [
            16.911491,
            52.404267,
            106.245814
          ],
          [
            16.911441,
            52.404079,
            106.877802
          ],
          [
            16.911386,
            52.40388,
            107.547449
          ],
          [
            16.911514,
            52.403739,
            108.17826
          ],
          [
            16.911715,
            52.403593,
            108.862876
          ],
          [
            16.912044,
            52.403566,
            109.535347
          ],
          [
            16.912332,
            52.403525,
            110.146015
          ],
          [
            16.912656,
            52.403505,
            110.805249
          ],
          [
            16.912954,
            52.403459,
            111.430386
          ],
          [
            16.913251,
            52.403407,
            112.056001
          ],
          [
            16.913554,
            52.403354,
            111.76821
          ],
          [
            16.91396,
            52.403338,
            111.256873
          ],
          [
            16.914288,
            52.403331,
            110.843541
          ],
          [
            16.91461,
            52.403292,
            110.429796
          ],
          [
            16.91498,
            52.403271,
            109.962699
          ],
          [
            16.915001,
            52.40309,
            109.519603
          ],
          [
            16.914842,
            52.402904,
            109.082994
          ],
          [
            16.91455,
            52.402912,
            108.70351
          ],
          [
            16.914251,
            52.402967,
            108.839848
          ],
          [
            16.913948,
            52.403009,
            110.388436
          ],
          [
            16.913645,
            52.403054,
            111.940893
          ],
          [
            16.913485,
            52.402968,
            113.441218
          ],
          [
            16.913365,
            52.402805,
            114.932227
          ],
          [
            16.912811,
            52.400928,
            119.858833
          ],
          [
            16.91315,
            52.400652,
            118.776368
          ],
          [
            16.913215,
            52.40047,
            119.171654
          ],
          [
            16.913192,
            52.400284,
            120.316245
          ],
          [
            16.913194,
            52.400098,
            121.44516
          ],
          [
            16.913257,
            52.399908,
            122.633405
          ],
          [
            16.913399,
            52.399719,
            123.891776
          ],
          [
            16.912993,
            52.399843,
            125.699842
          ],
          [
            16.913296,
            52.400146,
            128.31179
          ],
          [
            16.913301,
            52.400342,
            129.432362
          ],
          [
            16.913284,
            52.400662,
            129.293222
          ],
          [
            16.913289,
            52.40086,
            129.206333
          ],
          [
            16.913305,
            52.401092,
            129.10549
          ],
          [
            16.913547,
            52.401088,
            128.979854
          ],
          [
            16.913398,
            52.40129,
            128.790811
          ],
          [
            16.912728,
            52.400905,
            126.519307
          ],
          [
            16.912857,
            52.399837,
            115.328066
          ],
          [
            16.913525,
            52.400845,
            120.238625
          ],
          [
            16.913059,
            52.399895,
            125.731023
          ],
          [
            16.913512,
            52.403002,
            121.651924
          ],
          [
            16.913248,
            52.403123,
            121.613432
          ],
          [
            16.912952,
            52.40315,
            121.580226
          ],
          [
            16.912662,
            52.403197,
            121.546847
          ],
          [
            16.912361,
            52.403236,
            121.512766
          ],
          [
            16.912051,
            52.403275,
            121.477712
          ],
          [
            16.911744,
            52.403328,
            121.442367
          ],
          [
            16.911445,
            52.40338,
            121.407934
          ],
          [
            16.91116,
            52.403342,
            121.059144
          ],
          [
            16.910846,
            52.403374,
            120.57596
          ],
          [
            16.910619,
            52.40352,
            120.085278
          ],
          [
            16.91064,
            52.403711,
            119.617779
          ],
          [
            16.910912,
            52.403778,
            119.182484
          ],
          [
            16.911164,
            52.403746,
            118.707971
          ],
          [
            16.911354,
            52.403896,
            118.224325
          ],
          [
            16.911456,
            52.404096,
            117.717179
          ],
          [
            16.911532,
            52.404306,
            117.196994
          ],
          [
            16.911581,
            52.404514,
            116.664278
          ],
          [
            16.911651,
            52.404732,
            116.090436
          ],
          [
            16.911748,
            52.404937,
            115.538964
          ],
          [
            16.91182,
            52.405153,
            114.968647
          ],
          [
            16.91187,
            52.405363,
            114.419734
          ],
          [
            16.911943,
            52.405583,
            113.839891
          ],
          [
            16.912006,
            52.405782,
            113.315696
          ],
          [
            16.912098,
            52.405998,
            112.739126
          ],
          [
            16.912264,
            52.406203,
            112.628588
          ],
          [
            16.912359,
            52.406399,
            113.093102
          ],
          [
            16.912457,
            52.406592,
            113.55231
          ],
          [
            16.912584,
            52.406788,
            114.032036
          ],
          [
            16.91269,
            52.406972,
            114.475328
          ],
          [
            16.912799,
            52.407149,
            114.906048
          ],
          [
            16.913018,
            52.407262,
            115.333764
          ],
          [
            16.913302,
            52.40732,
            115.753564
          ],
          [
            16.913628,
            52.407343,
            116.210954
          ],
          [
            16.913922,
            52.407384,
            116.312311
          ],
          [
            16.914254,
            52.407397,
            115.718765
          ],
          [
            16.914615,
            52.40737,
            115.067726
          ],
          [
            16.914992,
            52.40738,
            114.38945
          ],
          [
            16.915347,
            52.40741,
            113.748574
          ],
          [
            16.915703,
            52.407399,
            113.106164
          ],
          [
            16.916018,
            52.407337,
            112.515929
          ],
          [
            16.916358,
            52.407303,
            111.901731
          ],
          [
            16.916699,
            52.407235,
            111.260605
          ],
          [
            16.917031,
            52.407152,
            110.788919
          ],
          [
            16.917388,
            52.407141,
            110.321374
          ],
          [
            16.917714,
            52.407176,
            109.892902
          ],
          [
            16.918018,
            52.407134,
            109.47698
          ],
          [
            16.918401,
            52.407108,
            108.977252
          ],
          [
            16.918758,
            52.407078,
            108.510555
          ],
          [
            16.919094,
            52.407044,
            108.057708
          ],
          [
            16.919406,
            52.40702,
            107.649087
          ],
          [
            16.919746,
            52.407024,
            107.727478
          ],
          [
            16.920075,
            52.407011,
            108.351919
          ],
          [
            16.920401,
            52.406954,
            108.997517
          ],
          [
            16.920714,
            52.406935,
            109.597143
          ],
          [
            16.921066,
            52.406937,
            110.265809
          ],
          [
            16.921377,
            52.406921,
            110.89031
          ],
          [
            16.921677,
            52.406876,
            111.475245
          ],
          [
            16.922044,
            52.406814,
            112.195501
          ],
          [
            16.922387,
            52.406741,
            112.886988
          ],
          [
            16.922733,
            52.406725,
            113.108797
          ],
          [
            16.923085,
            52.40669,
            113.249404
          ],
          [
            16.923441,
            52.406682,
            113.389632
          ],
          [
            16.923697,
            52.406586,
            113.512095
          ],
          [
            16.924007,
            52.40654,
            113.641677
          ],
          [
            16.924292,
            52.406474,
            113.77025
          ],
          [
            16.924594,
            52.406419,
            113.894522
          ],
          [
            16.924933,
            52.406362,
            114.033426
          ],
          [
            16.925223,
            52.406256,
            114.131402
          ],
          [
            16.925547,
            52.406278,
            113.878088
          ],
          [
            16.925881,
            52.406219,
            113.611145
          ],
          [
            16.9262,
            52.406203,
            113.366596
          ],
          [
            16.926529,
            52.406201,
            113.115762
          ],
          [
            16.926845,
            52.406191,
            112.873469
          ],
          [
            16.927177,
            52.406142,
            112.612577
          ],
          [
            16.927488,
            52.406082,
            112.359486
          ],
          [
            16.927784,
            52.406025,
            112.117535
          ],
          [
            16.928101,
            52.405985,
            111.696387
          ],
          [
            16.928424,
            52.405995,
            110.338756
          ],
          [
            16.928758,
            52.405965,
            108.922665
          ],
          [
            16.929126,
            52.405959,
            107.376891
          ],
          [
            16.929485,
            52.405972,
            105.844062
          ],
          [
            16.929814,
            52.405956,
            104.458003
          ],
          [
            16.930161,
            52.4059,
            102.951531
          ],
          [
            16.930478,
            52.405846,
            101.570836
          ],
          [
            16.930828,
            52.405807,
            100.077842
          ],
          [
            16.931153,
            52.405768,
            99.395258
          ],
          [
            16.931484,
            52.40577,
            99.148156
          ],
          [
            16.931705,
            52.405929,
            98.901724
          ],
          [
            16.931815,
            52.406106,
            98.680026
          ],
          [
            16.931918,
            52.406304,
            98.432128
          ],
          [
            16.931945,
            52.406496,
            98.199972
          ],
          [
            16.932032,
            52.406695,
            97.958172
          ],
          [
            16.932054,
            52.406885,
            97.735356
          ],
          [
            16.932136,
            52.407066,
            97.515509
          ],
          [
            16.932202,
            52.407253,
            97.277155
          ],
          [
            16.932269,
            52.40745,
            97.018448
          ],
          [
            16.932339,
            52.407652,
            96.748378
          ],
          [
            16.932558,
            52.407773,
            96.514689
          ],
          [
            16.932661,
            52.407939,
            96.282374
          ],
          [
            16.932755,
            52.408122,
            96.033184
          ],
          [
            16.932884,
            52.408311,
            95.761121
          ],
          [
            16.932951,
            52.408515,
            95.491647
          ],
          [
            16.933037,
            52.408698,
            95.247048
          ],
          [
            16.933462,
            52.408749,
            95.125743
          ],
          [
            16.933769,
            52.408843,
            95.123515
          ],
          [
            16.933813,
            52.409044,
            95.121403
          ],
          [
            16.933882,
            52.409241,
            95.119306
          ],
          [
            16.933946,
            52.40943,
            95.117297
          ],
          [
            16.934006,
            52.409634,
            95.115139
          ],
          [
            16.934102,
            52.409815,
            95.113159
          ],
          [
            16.934167,
            52.410025,
            95.110933
          ],
          [
            16.934226,
            52.410209,
            95.108982
          ],
          [
            16.934278,
            52.410402,
            94.781935
          ],
          [
            16.934335,
            52.410609,
            94.398533
          ],
          [
            16.934398,
            52.410804,
            94.035836
          ],
          [
            16.934411,
            52.411004,
            93.671263
          ],
          [
            16.934329,
            52.411229,
            93.243611
          ],
          [
            16.934239,
            52.411412,
            92.894802
          ],
          [
            16.933955,
            52.411319,
            92.536434
          ],
          [
            16.933622,
            52.411294,
            92.162347
          ],
          [
            16.933323,
            52.411383,
            91.907325
          ],
          [
            16.933081,
            52.411511,
            92.569339
          ],
          [
            16.932887,
            52.411657,
            93.220246
          ],
          [
            16.932838,
            52.411655,
            93.931966
          ],
          [
            16.932926,
            52.41184,
            94.587095
          ],
          [
            16.933036,
            52.411659,
            95.24122
          ],
          [
            16.933335,
            52.411691,
            95.868962
          ],
          [
            16.933428,
            52.411811,
            96.591858
          ],
          [
            16.93323,
            52.411676,
            97.239543
          ],
          [
            16.933396,
            52.411808,
            97.702883
          ],
          [
            16.933257,
            52.411668,
            97.166683
          ],
          [
            16.933138,
            52.4115,
            96.836467
          ],
          [
            16.93333,
            52.411363,
            96.517198
          ],
          [
            16.933629,
            52.411323,
            96.188346
          ],
          [
            16.93392,
            52.41135,
            95.87611
          ],
          [
            16.934221,
            52.411407,
            95.543286
          ],
          [
            16.934353,
            52.411235,
            95.208536
          ],
          [
            16.934269,
            52.411076,
            94.886799
          ],
          [
            16.934011,
            52.410981,
            94.719128
          ],
          [
            16.933762,
            52.410866,
            94.594072
          ],
          [
            16.933496,
            52.410752,
            94.463854
          ],
          [
            16.933216,
            52.410681,
            94.342444
          ],
          [
            16.932982,
            52.41056,
            94.218959
          ],
          [
            16.932751,
            52.410447,
            94.099188
          ],
          [
            16.932543,
            52.410304,
            93.973527
          ],
          [
            16.932326,
            52.410168,
            93.848956
          ],
          [
            16.932232,
            52.410025,
            93.718212
          ],
          [
            16.932465,
            52.409814,
            93.747554
          ],
          [
            16.932587,
            52.409633,
            93.920686
          ],
          [
            16.932745,
            52.409469,
            94.092388
          ],
          [
            16.932776,
            52.409288,
            94.256598
          ],
          [
            16.932836,
            52.409101,
            94.425376
          ],
          [
            16.93269,
            52.408964,
            94.594079
          ],
          [
            16.932909,
            52.408851,
            94.753463
          ],
          [
            16.933069,
            52.408713,
            94.914447
          ],
          [
            16.933379,
            52.408724,
            95.083039
          ],
          [
            16.933674,
            52.408803,
            95.189317
          ],
          [
            16.933994,
            52.408763,
            95.02045
          ],
          [
            16.934284,
            52.408721,
            94.865757
          ],
          [
            16.934397,
            52.408471,
            94.631337
          ],
          [
            16.93437,
            52.408283,
            94.473417
          ],
          [
            16.934368,
            52.408095,
            94.312532
          ],
          [
            16.934426,
            52.407945,
            94.108214
          ],
          [
            16.934119,
            52.407783,
            93.900982
          ],
          [
            16.933736,
            52.407776,
            93.726231
          ],
          [
            16.933414,
            52.407835,
            93.796899
          ],
          [
            16.932963,
            52.40784,
            93.892841
          ],
          [
            16.932657,
            52.407777,
            93.96989
          ],
          [
            16.932832,
            52.407894,
            94.035152
          ],
          [
            16.932941,
            52.407969,
            94.101335
          ],
          [
            16.933232,
            52.407934,
            94.163299
          ],
          [
            16.933493,
            52.40785,
            94.224964
          ],
          [
            16.933814,
            52.407775,
            94.297872
          ],
          [
            16.934073,
            52.407862,
            94.456782
          ],
          [
            16.934317,
            52.407661,
            94.832646
          ],
          [
            16.93433,
            52.407478,
            95.111701
          ],
          [
            16.934351,
            52.407296,
            95.3862
          ],
          [
            16.934268,
            52.407113,
            95.667185
          ],
          [
            16.934148,
            52.40694,
            95.9454
          ],
          [
            16.934155,
            52.406749,
            96.229184
          ],
          [
            16.934145,
            52.406527,
            96.559989
          ],
          [
            16.934118,
            52.406527,
            96.832101
          ],
          [
            16.933666,
            52.406605,
            95.750482
          ],
          [
            16.933301,
            52.406662,
            94.250083
          ],
          [
            16.933179,
            52.40677,
            92.998593
          ],
          [
            16.9333,
            52.406953,
            91.675113
          ],
          [
            16.933303,
            52.407163,
            90.291718
          ],
          [
            16.933428,
            52.40733,
            89.080668
          ],
          [
            16.933452,
            52.407519,
            87.844207
          ],
          [
            16.933244,
            52.40765,
            86.581195
          ],
          [
            16.932977,
            52.40769,
            85.372339
          ],
          [
            16.932677,
            52.407724,
            86.823364
          ],
          [
            16.932379,
            52.407766,
            88.582024
          ],
          [
            16.932077,
            52.407816,
            90.409588
          ],
          [
            16.931785,
            52.407863,
            92.140058
          ],
          [
            16.931785,
            52.408205,
            95.877651
          ],
          [
            16.932071,
            52.408261,
            97.607554
          ],
          [
            16.932326,
            52.408471,
            100.460663
          ],
          [
            16.932658,
            52.408413,
            102.136282
          ],
          [
            16.932911,
            52.408548,
            102.230654
          ],
          [
            16.933064,
            52.408717,
            102.321661
          ],
          [
            16.932937,
            52.408885,
            102.406145
          ],
          [
            16.932963,
            52.408842,
            102.507318
          ],
          [
            16.933243,
            52.408821,
            102.587438
          ],
          [
            16.933547,
            52.408795,
            102.671062
          ],
          [
            16.93385,
            52.408773,
            102.755061
          ],
          [
            16.934147,
            52.408737,
            102.837996
          ],
          [
            16.934446,
            52.408689,
            102.906153
          ],
          [
            16.934718,
            52.408766,
            102.62708
          ],
          [
            16.935032,
            52.408759,
            102.336654
          ],
          [
            16.935329,
            52.408737,
            102.060711
          ],
          [
            16.935643,
            52.408715,
            101.76898
          ],
          [
            16.935942,
            52.40868,
            101.477338
          ],
          [
            16.935661,
            52.40877,
            101.182356
          ],
          [
            16.935583,
            52.408951,
            100.899295
          ],
          [
            16.935614,
            52.409145,
            100.605677
          ],
          [
            16.935347,
            52.409215,
            100.318711
          ],
          [
            16.935035,
            52.409213,
            99.989338
          ],
          [
            16.934947,
            52.409394,
            99.631579
          ],
          [
            16.935005,
            52.409581,
            99.276106
          ],
          [
            16.935077,
            52.409762,
            98.923855
          ],
          [
            16.935095,
            52.409931,
            98.574552
          ],
          [
            16.935212,
            52.410137,
            98.163317
          ],
          [
            16.935288,
            52.410317,
            97.814659
          ],
          [
            16.935338,
            52.410499,
            97.469539
          ],
          [
            16.935407,
            52.410687,
            97.098893
          ],
          [
            16.935183,
            52.41079,
            96.922736
          ],
          [
            16.934899,
            52.410813,
            97.129052
          ],
          [
            16.934574,
            52.410794,
            97.354728
          ],
          [
            16.934421,
            52.410929,
            97.563198
          ],
          [
            16.934428,
            52.411119,
            97.778702
          ],
          [
            16.934207,
            52.411357,
            98.09044
          ],
          [
            16.933904,
            52.411341,
            98.308122
          ],
          [
            16.933594,
            52.41131,
            98.529156
          ],
          [
            16.933304,
            52.411376,
            98.743471
          ],
          [
            16.933106,
            52.411523,
            98.807382
          ],
          [
            16.93331,
            52.411702,
            98.521213
          ],
          [
            16.933139,
            52.411692,
            98.153745
          ],
          [
            16.933246,
            52.411527,
            97.925192
          ],
          [
            16.933398,
            52.411365,
            97.689642
          ],
          [
            16.93369,
            52.41134,
            97.463344
          ],
          [
            16.933997,
            52.411378,
            97.22526
          ],
          [
            16.934285,
            52.411356,
            96.989175
          ],
          [
            16.934365,
            52.411176,
            96.75681
          ],
          [
            16.934429,
            52.410993,
            96.737562
          ],
          [
            16.934388,
            52.4108,
            96.918813
          ],
          [
            16.934268,
            52.410614,
            97.105374
          ],
          [
            16.934171,
            52.410433,
            97.283217
          ],
          [
            16.934107,
            52.410251,
            97.458674
          ],
          [
            16.93406,
            52.410068,
            97.632066
          ],
          [
            16.93438,
            52.410039,
            97.818031
          ],
          [
            16.934675,
            52.409997,
            97.991854
          ],
          [
            16.934977,
            52.40995,
            98.169358
          ],
          [
            16.934993,
            52.409753,
            98.286089
          ],
          [
            16.934947,
            52.409568,
            98.137365
          ],
          [
            16.93486,
            52.40938,
            97.982982
          ],
          [
            16.934834,
            52.409189,
            97.83125
          ],
          [
            16.934753,
            52.409006,
            97.680352
          ],
          [
            16.934845,
            52.40885,
            97.528713
          ],
          [
            16.93514,
            52.408773,
            97.37402
          ],
          [
            16.93544,
            52.408711,
            97.221314
          ],
          [
            16.935826,
            52.408694,
            97.034665
          ],
          [
            16.935984,
            52.408804,
            96.896306
          ],
          [
            16.936326,
            52.40868,
            96.856386
          ],
          [
            16.936631,
            52.408655,
            96.825407
          ],
          [
            16.936676,
            52.408702,
            96.794173
          ],
          [
            16.936374,
            52.408681,
            96.763074
          ],
          [
            16.936086,
            52.408742,
            96.731972
          ],
          [
            16.935773,
            52.408733,
            96.700598
          ],
          [
            16.935455,
            52.408707,
            96.668258
          ],
          [
            16.935406,
            52.408521,
            96.637348
          ],
          [
            16.935412,
            52.408101,
            96.279293
          ],
          [
            16.935217,
            52.408009,
            95.975616
          ],
          [
            16.934911,
            52.408044,
            95.69449
          ],
          [
            16.934636,
            52.408043,
            95.422528
          ],
          [
            16.934495,
            52.408254,
            95.06018
          ],
          [
            16.934465,
            52.408435,
            94.786444
          ],
          [
            16.934223,
            52.40836,
            94.496172
          ],
          [
            16.934117,
            52.408559,
            94.174572
          ],
          [
            16.933875,
            52.408497,
            93.959957
          ],
          [
            16.933544,
            52.408456,
            94.064496
          ],
          [
            16.933265,
            52.408501,
            94.155877
          ],
          [
            16.932975,
            52.408459,
            94.250982
          ],
          [
            16.932752,
            52.408588,
            94.346542
          ],
          [
            16.932802,
            52.408756,
            94.445657
          ],
          [
            16.932707,
            52.408935,
            94.543813
          ],
          [
            16.932798,
            52.408743,
            94.646126
          ],
          [
            16.932904,
            52.408553,
            94.748888
          ],
          [
            16.932849,
            52.408379,
            94.848438
          ],
          [
            16.932788,
            52.408202,
            94.512977
          ],
          [
            16.932868,
            52.40804,
            94.135273
          ],
          [
            16.933136,
            52.407946,
            93.746899
          ],
          [
            16.933442,
            52.407902,
            93.348832
          ],
          [
            16.933751,
            52.407838,
            92.938174
          ],
          [
            16.934052,
            52.407838,
            92.563079
          ],
          [
            16.93423,
            52.407758,
            92.175231
          ],
          [
            16.934307,
            52.407582,
            91.800587
          ],
          [
            16.934417,
            52.407603,
            91.414059
          ],
          [
            16.934512,
            52.407787,
            91.446163
          ],
          [
            16.934569,
            52.407972,
            92.071818
          ],
          [
            16.93458,
            52.408165,
            92.732612
          ],
          [
            16.934591,
            52.40835,
            93.349639
          ],
          [
            16.934541,
            52.408532,
            93.966889
          ],
          [
            16.934798,
            52.408624,
            94.577436
          ],
          [
            16.935094,
            52.408669,
            95.207054
          ],
          [
            16.935379,
            52.408752,
            95.847424
          ],
          [
            16.935676,
            52.408746,
            96.450208
          ],
          [
            16.935978,
            52.408777,
            97.072846
          ],
          [
            16.936141,
            52.40863,
            96.879941
          ],
          [
            16.936433,
            52.40869,
            96.551819
          ],
          [
            16.936592,
            52.408504,
            96.052553
          ],
          [
            16.936575,
            52.408299,
            95.692496
          ],
          [
            16.936538,
            52.408114,
            95.366545
          ],
          [
            16.936624,
            52.40794,
            95.025045
          ],
          [
            16.936902,
            52.407873,
            94.705159
          ],
          [
            16.937201,
            52.407849,
            94.383111
          ],
          [
            16.937503,
            52.407811,
            94.054485
          ],
          [
            16.937809,
            52.407797,
            93.997539
          ],
          [
            16.9379,
            52.407769,
            93.976348
          ],
          [
            16.937978,
            52.407568,
            93.952284
          ],
          [
            16.93802,
            52.407387,
            93.930996
          ],
          [
            16.937827,
            52.407211,
            93.904183
          ],
          [
            16.937516,
            52.407248,
            93.881529
          ],
          [
            16.937132,
            52.407241,
            93.853776
          ],
          [
            16.936861,
            52.407147,
            93.831128
          ],
          [
            16.936729,
            52.406982,
            93.809637
          ],
          [
            16.936862,
            52.407211,
            94.592728
          ],
          [
            16.936625,
            52.40733,
            95.240815
          ],
          [
            16.936325,
            52.407366,
            95.865947
          ],
          [
            16.936041,
            52.407437,
            96.504655
          ],
          [
            16.93596,
            52.407616,
            97.129447
          ],
          [
            16.935954,
            52.407816,
            97.799902
          ],
          [
            16.936037,
            52.407995,
            98.43182
          ],
          [
            16.936085,
            52.408192,
            99.10604
          ],
          [
            16.936114,
            52.408382,
            99.746977
          ],
          [
            16.936091,
            52.408574,
            99.799846
          ],
          [
            16.935899,
            52.408751,
            99.747562
          ],
          [
            16.935908,
            52.408841,
            99.690462
          ],
          [
            16.935974,
            52.408648,
            99.648611
          ],
          [
            16.935759,
            52.408762,
            99.609256
          ],
          [
            16.935459,
            52.408783,
            99.569853
          ],
          [
            16.935022,
            52.408816,
            99.512795
          ],
          [
            16.934728,
            52.408739,
            99.469615
          ],
          [
            16.934478,
            52.408725,
            99.120667
          ],
          [
            16.934177,
            52.408744,
            98.58571
          ],
          [
            16.93388,
            52.40877,
            98.033994
          ],
          [
            16.933584,
            52.408803,
            97.492392
          ],
          [
            16.933278,
            52.408858,
            96.928977
          ],
          [
            16.932966,
            52.408913,
            96.355178
          ],
          [
            16.932674,
            52.408963,
            95.815757
          ],
          [
            16.932417,
            52.409075,
            95.247448
          ],
          [
            16.931973,
            52.409087,
            94.398115
          ],
          [
            16.93234,
            52.408974,
            93.876152
          ],
          [
            16.932622,
            52.408881,
            93.504793
          ],
          [
            16.93293,
            52.408799,
            93.120493
          ],
          [
            16.933231,
            52.408787,
            92.778227
          ],
          [
            16.933515,
            52.408749,
            92.443524
          ],
          [
            16.933828,
            52.408716,
            92.082686
          ],
          [
            16.934105,
            52.408636,
            91.735059
          ],
          [
            16.934396,
            52.408586,
            91.369413
          ],
          [
            16.934625,
            52.408713,
            91.016409
          ],
          [
            16.934912,
            52.40876,
            91.876455
          ],
          [
            16.935219,
            52.408734,
            93.204927
          ],
          [
            16.935439,
            52.408606,
            94.508039
          ],
          [
            16.935421,
            52.408404,
            95.938585
          ],
          [
            16.935034,
            52.408583,
            98.558828
          ],
          [
            16.935142,
            52.40848,
            102.025905
          ],
          [
            16.935312,
            52.408213,
            103.000536
          ],
          [
            16.935157,
            52.408112,
            101.76633
          ],
          [
            16.934847,
            52.408092,
            100.505559
          ],
          [
            16.934555,
            52.408142,
            99.28295
          ],
          [
            16.934218,
            52.407961,
            97.474921
          ],
          [
            16.933881,
            52.40791,
            96.053493
          ],
          [
            16.933587,
            52.407933,
            94.862051
          ],
          [
            16.933281,
            52.407943,
            93.619085
          ],
          [
            16.93298,
            52.407973,
            92.390344
          ],
          [
            16.932802,
            52.408152,
            92.170656
          ],
          [
            16.93281,
            52.408339,
            92.957308
          ],
          [
            16.932644,
            52.408449,
            93.769512
          ],
          [
            16.932346,
            52.408441,
            94.536633
          ],
          [
            16.932037,
            52.408467,
            95.343479
          ],
          [
            16.931732,
            52.408493,
            96.133909
          ],
          [
            16.93144,
            52.408537,
            96.905328
          ],
          [
            16.931264,
            52.408694,
            97.706484
          ],
          [
            16.931338,
            52.408874,
            98.486673
          ],
          [
            16.931141,
            52.408985,
            99.252413
          ],
          [
            16.93092,
            52.40886,
            99.481546
          ],
          [
            16.930814,
            52.408681,
            99.716104
          ],
          [
            16.930603,
            52.408616,
            99.947027
          ],
          [
            16.930517,
            52.408436,
            100.175765
          ],
          [
            16.930428,
            52.40826,
            100.402424
          ],
          [
            16.930412,
            52.408074,
            100.636343
          ],
          [
            16.930274,
            52.407969,
            100.863711
          ],
          [
            16.929967,
            52.407949,
            101.092859
          ],
          [
            16.92968,
            52.407938,
            101.317265
          ],
          [
            16.929384,
            52.407929,
            101.809142
          ],
          [
            16.929115,
            52.408014,
            102.650703
          ],
          [
            16.92882,
            52.408075,
            103.515261
          ],
          [
            16.928526,
            52.408118,
            104.35975
          ],
          [
            16.928232,
            52.408156,
            105.193361
          ],
          [
            16.927977,
            52.4082,
            106.190101
          ],
          [
            16.927685,
            52.408154,
            107.028655
          ],
          [
            16.927382,
            52.40818,
            107.877422
          ],
          [
            16.927075,
            52.408185,
            108.72947
          ],
          [
            16.926772,
            52.408228,
            109.592569
          ],
          [
            16.926492,
            52.408281,
            109.972734
          ],
          [
            16.926183,
            52.408462,
            110.487109
          ],
          [
            16.925902,
            52.408528,
            110.848854
          ],
          [
            16.925596,
            52.408569,
            111.22434
          ],
          [
            16.925321,
            52.408523,
            111.5993
          ],
          [
            16.92517,
            52.408379,
            111.967514
          ],
          [
            16.924865,
            52.408391,
            112.3346
          ],
          [
            16.924585,
            52.408448,
            112.694333
          ],
          [
            16.924275,
            52.408468,
            113.070675
          ],
          [
            16.923954,
            52.408449,
            114.44035
          ],
          [
            16.923674,
            52.40838,
            116.008208
          ],
          [
            16.923444,
            52.408275,
            117.588447
          ],
          [
            16.923145,
            52.408257,
            119.13213
          ],
          [
            16.922858,
            52.408279,
            120.640482
          ],
          [
            16.922554,
            52.408259,
            122.184533
          ],
          [
            16.922239,
            52.408247,
            123.777883
          ],
          [
            16.922048,
            52.408388,
            125.365048
          ],
          [
            16.922116,
            52.408266,
            126.878286
          ],
          [
            16.921876,
            52.408462,
            127.114207
          ],
          [
            16.921581,
            52.408309,
            125.437692
          ],
          [
            16.921541,
            52.408105,
            123.997101
          ],
          [
            16.921678,
            52.40827,
            122.677883
          ],
          [
            16.921591,
            52.408461,
            121.278979
          ],
          [
            16.921421,
            52.408624,
            119.895101
          ],
          [
            16.921262,
            52.408774,
            118.634
          ],
          [
            16.92102,
            52.408889,
            117.31954
          ],
          [
            16.920855,
            52.408848,
            116.004299
          ],
          [
            16.920678,
            52.408682,
            114.993245
          ],
          [
            16.920564,
            52.408398,
            113.907256
          ],
          [
            16.920931,
            52.408622,
            112.640286
          ],
          [
            16.921129,
            52.408768,
            111.889368
          ],
          [
            16.920947,
            52.408914,
            111.169021
          ],
          [
            16.920623,
            52.408855,
            110.400075
          ],
          [
            16.920362,
            52.408949,
            109.699536
          ],
          [
            16.920179,
            52.409065,
            109.002204
          ],
          [
            16.919883,
            52.409116,
            108.744499
          ],
          [
            16.919596,
            52.40919,
            108.703941
          ],
          [
            16.919366,
            52.409314,
            108.663897
          ],
          [
            16.919123,
            52.409426,
            108.623654
          ],
          [
            16.918836,
            52.409486,
            108.584071
          ],
          [
            16.918529,
            52.409533,
            108.542871
          ],
          [
            16.918163,
            52.409555,
            108.494967
          ],
          [
            16.917863,
            52.409625,
            108.453143
          ],
          [
            16.917555,
            52.409695,
            108.410274
          ],
          [
            16.917271,
            52.409762,
            108.327709
          ],
          [
            16.916994,
            52.409841,
            108.18822
          ],
          [
            16.916802,
            52.40975,
            108.053281
          ],
          [
            16.91667,
            52.409587,
            107.910149
          ],
          [
            16.916586,
            52.40941,
            107.77228
          ],
          [
            16.916461,
            52.409238,
            107.631927
          ],
          [
            16.91635,
            52.40906,
            107.489145
          ],
          [
            16.91628,
            52.408874,
            107.346003
          ],
          [
            16.916303,
            52.408686,
            107.20537
          ],
          [
            16.9164,
            52.408512,
            107.067472
          ],
          [
            16.916503,
            52.408339,
            107.547923
          ],
          [
            16.916801,
            52.408296,
            108.151976
          ],
          [
            16.917109,
            52.408305,
            108.755153
          ],
          [
            16.917269,
            52.408099,
            109.556472
          ],
          [
            16.917231,
            52.407892,
            110.223169
          ],
          [
            16.917222,
            52.407692,
            110.863583
          ],
          [
            16.917635,
            52.407661,
            111.678055
          ],
          [
            16.917924,
            52.407599,
            112.277183
          ],
          [
            16.918233,
            52.407552,
            113.069584
          ],
          [
            16.918515,
            52.40751,
            114.644625
          ],
          [
            16.918798,
            52.407434,
            116.301988
          ],
          [
            16.919075,
            52.407452,
            117.915924
          ],
          [
            16.919054,
            52.4074,
            119.939521
          ],
          [
            16.918965,
            52.407391,
            123.638806
          ],
          [
            16.919199,
            52.407539,
            125.444444
          ],
          [
            16.919044,
            52.407377,
            127.099138
          ],
          [
            16.919303,
            52.407387,
            128.068999
          ],
          [
            16.919132,
            52.407397,
            127.368803
          ],
          [
            16.918956,
            52.407251,
            126.665429
          ],
          [
            16.918917,
            52.407337,
            125.869683
          ],
          [
            16.918999,
            52.407283,
            125.101985
          ],
          [
            16.918925,
            52.40725,
            123.768195
          ],
          [
            16.919331,
            52.407434,
            122.315055
          ],
          [
            16.919263,
            52.407239,
            121.516676
          ],
          [
            16.919383,
            52.407063,
            120.551676
          ],
          [
            16.91944,
            52.406871,
            119.616825
          ],
          [
            16.919526,
            52.406693,
            118.726663
          ],
          [
            16.919633,
            52.406502,
            117.759097
          ],
          [
            16.919737,
            52.406333,
            116.880464
          ],
          [
            16.919809,
            52.40615,
            115.97515
          ],
          [
            16.919943,
            52.405982,
            115.075387
          ],
          [
            16.920104,
            52.405823,
            114.180448
          ],
          [
            16.920348,
            52.405619,
            113.201158
          ],
          [
            16.92048,
            52.40544,
            114.057005
          ],
          [
            16.920558,
            52.405255,
            114.915732
          ],
          [
            16.920629,
            52.40507,
            115.764623
          ],
          [
            16.920881,
            52.404959,
            116.598363
          ],
          [
            16.920971,
            52.404777,
            117.433807
          ],
          [
            16.921086,
            52.404607,
            118.256517
          ],
          [
            16.921253,
            52.40445,
            119.100579
          ],
          [
            16.921523,
            52.404417,
            119.940798
          ],
          [
            16.921661,
            52.40435,
            120.779852
          ],
          [
            16.921877,
            52.404224,
            119.930994
          ],
          [
            16.922155,
            52.404295,
            119.063626
          ],
          [
            16.922445,
            52.40439,
            118.023948
          ],
          [
            16.922449,
            52.404536,
            117.130049
          ],
          [
            16.922415,
            52.404305,
            116.036766
          ],
          [
            16.921971,
            52.404318,
            114.691609
          ],
          [
            16.921653,
            52.404338,
            113.783375
          ],
          [
            16.921368,
            52.404396,
            112.930148
          ],
          [
            16.92105,
            52.404423,
            112.097464
          ],
          [
            16.920731,
            52.404411,
            111.32014
          ],
          [
            16.920432,
            52.404381,
            110.592594
          ],
          [
            16.920126,
            52.404356,
            109.850846
          ],
          [
            16.919819,
            52.404341,
            109.110511
          ],
          [
            16.919523,
            52.404264,
            108.338145
          ],
          [
            16.919214,
            52.404217,
            107.573523
          ],
          [
            16.918949,
            52.404122,
            106.836002
          ],
          [
            16.918658,
            52.404038,
            106.062619
          ],
          [
            16.918347,
            52.403975,
            105.467308
          ],
          [
            16.918088,
            52.403886,
            105.511632
          ],
          [
            16.917817,
            52.403792,
            105.556942
          ],
          [
            16.917586,
            52.403675,
            105.600757
          ],
          [
            16.917332,
            52.403575,
            105.645223
          ],
          [
            16.917272,
            52.403395,
            105.689685
          ],
          [
            16.917373,
            52.40321,
            105.736148
          ],
          [
            16.91759,
            52.403067,
            105.783955
          ],
          [
            16.917824,
            52.402939,
            105.830223
          ],
          [
            16.918049,
            52.402811,
            105.874937
          ],
          [
            16.918317,
            52.402712,
            105.731602
          ],
          [
            16.918615,
            52.402666,
            105.540463
          ],
          [
            16.918915,
            52.402618,
            105.347247
          ],
          [
            16.919197,
            52.402556,
            105.161004
          ],
          [
            16.919464,
            52.402455,
            104.96564
          ],
          [
            16.919745,
            52.402376,
            104.773107
          ],
          [
            16.920032,
            52.402299,
            104.577944
          ],
          [
            16.920302,
            52.402203,
            104.383776
          ],
          [
            16.920607,
            52.402132,
            104.180933
          ],
          [
            16.920897,
            52.40209,
            104.053048
          ],
          [
            16.92117,
            52.402012,
            104.053048
          ],
          [
            16.921441,
            52.402064,
            104.053048
          ],
          [
            16.921678,
            52.402187,
            104.053048
          ],
          [
            16.921961,
            52.402275,
            104.053048
          ],
          [
            16.922271,
            52.402309,
            104.053048
          ],
          [
            16.922517,
            52.402433,
            104.053048
          ],
          [
            16.922829,
            52.402445,
            104.053048
          ],
          [
            16.923146,
            52.402513,
            104.053048
          ],
          [
            16.923429,
            52.402617,
            104.053048
          ],
          [
            16.923776,
            52.40272,
            104.053048
          ],
          [
            16.924001,
            52.402857,
            104.053048
          ],
          [
            16.924033,
            52.403047,
            104.053048
          ],
          [
            16.92427,
            52.403162,
            104.053048
          ]
        ]
      }
    }
  ]
}

let day48: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            16.93343,
            52.411744,
            99.431291
          ],
          [
            16.932955,
            52.411554,
            99.431291
          ],
          [
            16.933139,
            52.411413,
            99.431291
          ],
          [
            16.933427,
            52.411342,
            99.431291
          ],
          [
            16.93374,
            52.411331,
            99.402986
          ],
          [
            16.934045,
            52.411368,
            99.292964
          ],
          [
            16.934342,
            52.411382,
            99.187368
          ],
          [
            16.934649,
            52.411456,
            99.070586
          ],
          [
            16.934918,
            52.411568,
            98.954143
          ],
          [
            16.935257,
            52.411601,
            98.832324
          ],
          [
            16.935575,
            52.41155,
            98.715415
          ],
          [
            16.935883,
            52.411527,
            98.605134
          ],
          [
            16.93621,
            52.411475,
            98.485572
          ],
          [
            16.936554,
            52.411412,
            98.194258
          ],
          [
            16.936887,
            52.411373,
            97.412935
          ],
          [
            16.937225,
            52.411324,
            96.612526
          ],
          [
            16.937535,
            52.411265,
            95.865383
          ],
          [
            16.937843,
            52.411239,
            95.147665
          ],
          [
            16.938144,
            52.411188,
            94.387331
          ],
          [
            16.938509,
            52.411146,
            93.531711
          ],
          [
            16.93882,
            52.411066,
            92.753277
          ],
          [
            16.939142,
            52.411027,
            91.994756
          ],
          [
            16.939437,
            52.41099,
            91.631581
          ],
          [
            16.939773,
            52.410965,
            91.702537
          ],
          [
            16.940083,
            52.41093,
            91.767897
          ],
          [
            16.940401,
            52.410931,
            91.834055
          ],
          [
            16.940687,
            52.41084,
            91.900915
          ],
          [
            16.940977,
            52.410727,
            91.972415
          ],
          [
            16.941257,
            52.410618,
            92.041294
          ],
          [
            16.941533,
            52.410509,
            92.109498
          ],
          [
            16.941822,
            52.410412,
            92.177862
          ],
          [
            16.942124,
            52.410313,
            92.52878
          ],
          [
            16.942417,
            52.410209,
            93.183034
          ],
          [
            16.942709,
            52.41011,
            93.827831
          ],
          [
            16.943056,
            52.410088,
            94.503674
          ],
          [
            16.943398,
            52.41006,
            95.169642
          ],
          [
            16.943715,
            52.410019,
            95.795016
          ],
          [
            16.944018,
            52.409982,
            96.391331
          ],
          [
            16.94437,
            52.410002,
            97.073871
          ],
          [
            16.944717,
            52.410015,
            97.744889
          ],
          [
            16.945042,
            52.410027,
            97.764776
          ],
          [
            16.945372,
            52.410059,
            97.572508
          ],
          [
            16.945711,
            52.410094,
            97.374048
          ],
          [
            16.946077,
            52.410131,
            97.160607
          ],
          [
            16.946377,
            52.410304,
            96.923094
          ],
          [
            16.946726,
            52.410432,
            96.688185
          ],
          [
            16.947014,
            52.410513,
            96.50389
          ],
          [
            16.947295,
            52.410661,
            96.289629
          ],
          [
            16.94749,
            52.410832,
            96.191629
          ],
          [
            16.947632,
            52.411012,
            96.164126
          ],
          [
            16.947901,
            52.411154,
            96.134234
          ],
          [
            16.948136,
            52.411264,
            96.109295
          ],
          [
            16.948461,
            52.411323,
            96.080034
          ],
          [
            16.948775,
            52.411391,
            96.052041
          ],
          [
            16.949061,
            52.411464,
            96.026002
          ],
          [
            16.949339,
            52.411556,
            95.999125
          ],
          [
            16.949683,
            52.411624,
            95.968757
          ],
          [
            16.94999,
            52.411666,
            95.985589
          ],
          [
            16.950347,
            52.411705,
            96.02485
          ],
          [
            16.950659,
            52.411608,
            96.06275
          ],
          [
            16.950994,
            52.411534,
            96.101743
          ],
          [
            16.951377,
            52.411519,
            96.143558
          ],
          [
            16.951763,
            52.411502,
            96.185778
          ],
          [
            16.952106,
            52.411455,
            96.22382
          ],
          [
            16.952455,
            52.411393,
            96.263091
          ],
          [
            16.952776,
            52.411374,
            96.360396
          ],
          [
            16.953041,
            52.411298,
            96.499675
          ],
          [
            16.953343,
            52.41123,
            96.652485
          ],
          [
            16.953655,
            52.411131,
            96.818558
          ],
          [
            16.953626,
            52.411168,
            96.962946
          ],
          [
            16.953529,
            52.411196,
            97.107496
          ],
          [
            16.953743,
            52.411288,
            97.24719
          ],
          [
            16.9536,
            52.411315,
            97.401786
          ],
          [
            16.95379,
            52.411106,
            97.587068
          ],
          [
            16.95414,
            52.411067,
            97.398397
          ],
          [
            16.954426,
            52.410959,
            96.857888
          ],
          [
            16.954381,
            52.410749,
            96.340661
          ],
          [
            16.95441,
            52.410575,
            95.890569
          ],
          [
            16.95474,
            52.410515,
            95.377894
          ],
          [
            16.955049,
            52.410456,
            94.894925
          ],
          [
            16.955403,
            52.410413,
            94.357409
          ],
          [
            16.955737,
            52.410399,
            93.858145
          ],
          [
            16.956054,
            52.410397,
            93.385937
          ],
          [
            16.956309,
            52.410431,
            93.265754
          ],
          [
            16.956283,
            52.41044,
            93.244534
          ],
          [
            16.956105,
            52.410212,
            93.217463
          ],
          [
            16.955973,
            52.410033,
            93.197787
          ],
          [
            16.955913,
            52.409831,
            93.177325
          ],
          [
            16.95637,
            52.409714,
            93.146763
          ],
          [
            16.956686,
            52.409663,
            93.126986
          ],
          [
            16.957032,
            52.409579,
            93.104455
          ],
          [
            16.957351,
            52.4095,
            92.997947
          ],
          [
            16.957577,
            52.40933,
            92.869895
          ],
          [
            16.957859,
            52.40921,
            92.735922
          ],
          [
            16.958022,
            52.408983,
            92.589766
          ],
          [
            16.958238,
            52.408824,
            92.469958
          ],
          [
            16.958458,
            52.408681,
            92.356047
          ],
          [
            16.95869,
            52.408506,
            92.224817
          ],
          [
            16.958913,
            52.408298,
            92.080436
          ],
          [
            16.959124,
            52.408096,
            92.14627
          ],
          [
            16.959337,
            52.407911,
            92.246292
          ],
          [
            16.959552,
            52.407716,
            92.350481
          ],
          [
            16.959782,
            52.407534,
            92.452355
          ],
          [
            16.960073,
            52.407391,
            92.553252
          ],
          [
            16.960311,
            52.407241,
            92.645642
          ],
          [
            16.960547,
            52.407071,
            92.7442
          ],
          [
            16.960795,
            52.406908,
            92.842607
          ],
          [
            16.961023,
            52.406732,
            92.773073
          ],
          [
            16.961257,
            52.40657,
            92.685993
          ],
          [
            16.961473,
            52.406407,
            92.601783
          ],
          [
            16.961701,
            52.40622,
            92.508216
          ],
          [
            16.961935,
            52.406028,
            92.412101
          ],
          [
            16.962169,
            52.405831,
            92.314421
          ],
          [
            16.962396,
            52.405632,
            92.217024
          ],
          [
            16.962629,
            52.405441,
            92.14303
          ],
          [
            16.96288,
            52.405231,
            92.268087
          ],
          [
            16.963111,
            52.405106,
            92.359226
          ],
          [
            16.963461,
            52.40495,
            92.486583
          ],
          [
            16.963792,
            52.404836,
            92.598203
          ],
          [
            16.964082,
            52.404758,
            92.69183
          ],
          [
            16.964411,
            52.404658,
            92.799727
          ],
          [
            16.964722,
            52.404558,
            92.90295
          ],
          [
            16.965078,
            52.404468,
            93.021562
          ],
          [
            16.965389,
            52.404388,
            93.149074
          ],
          [
            16.965725,
            52.404321,
            93.282402
          ],
          [
            16.966033,
            52.404254,
            93.405468
          ],
          [
            16.966337,
            52.404198,
            93.525024
          ],
          [
            16.966632,
            52.40413,
            93.643762
          ],
          [
            16.966949,
            52.404071,
            93.768495
          ],
          [
            16.967266,
            52.404017,
            93.892401
          ],
          [
            16.967555,
            52.403944,
            94.010314
          ],
          [
            16.967899,
            52.403889,
            94.062021
          ],
          [
            16.968217,
            52.403838,
            93.91749
          ],
          [
            16.968531,
            52.403805,
            93.77788
          ],
          [
            16.968858,
            52.403773,
            93.632619
          ],
          [
            16.969205,
            52.403747,
            93.479433
          ],
          [
            16.969518,
            52.403749,
            93.342215
          ],
          [
            16.969841,
            52.403741,
            93.199966
          ],
          [
            16.970179,
            52.403744,
            93.051642
          ],
          [
            16.970504,
            52.403766,
            92.908333
          ],
          [
            16.970839,
            52.403782,
            92.979435
          ],
          [
            16.971157,
            52.403803,
            93.413242
          ],
          [
            16.971524,
            52.403837,
            93.916011
          ],
          [
            16.971829,
            52.403853,
            94.330933
          ],
          [
            16.972235,
            52.403904,
            94.89304
          ],
          [
            16.972645,
            52.403949,
            95.457205
          ],
          [
            16.973034,
            52.403993,
            95.992995
          ],
          [
            16.973441,
            52.404004,
            96.544829
          ],
          [
            16.973824,
            52.404015,
            96.747405
          ],
          [
            16.974207,
            52.404019,
            96.627026
          ],
          [
            16.974575,
            52.403963,
            96.506369
          ],
          [
            16.9749,
            52.403876,
            96.394362
          ],
          [
            16.975305,
            52.403841,
            96.263443
          ],
          [
            16.975653,
            52.403903,
            96.149432
          ],
          [
            16.975978,
            52.403947,
            96.044772
          ],
          [
            16.976293,
            52.403926,
            95.945153
          ],
          [
            16.97661,
            52.403838,
            95.745226
          ],
          [
            16.976936,
            52.403807,
            95.429935
          ],
          [
            16.977253,
            52.403767,
            95.118987
          ],
          [
            16.977403,
            52.403605,
            94.821127
          ],
          [
            16.977423,
            52.403367,
            94.451159
          ],
          [
            16.977601,
            52.403211,
            94.145316
          ],
          [
            16.97793,
            52.403165,
            93.824348
          ],
          [
            16.97824,
            52.40321,
            93.521699
          ],
          [
            16.978537,
            52.403263,
            93.228457
          ],
          [
            16.978855,
            52.403222,
            93.02188
          ],
          [
            16.979103,
            52.403066,
            92.89623
          ],
          [
            16.979436,
            52.40294,
            92.756587
          ],
          [
            16.979791,
            52.402843,
            92.61991
          ],
          [
            16.980135,
            52.402737,
            92.484493
          ],
          [
            16.980479,
            52.402609,
            92.343007
          ],
          [
            16.980858,
            52.40253,
            92.202206
          ],
          [
            16.981222,
            52.402475,
            92.070328
          ],
          [
            16.981578,
            52.402435,
            92.093117
          ],
          [
            16.981964,
            52.402388,
            92.143262
          ],
          [
            16.982356,
            52.402331,
            92.194673
          ],
          [
            16.982768,
            52.402284,
            92.248093
          ],
          [
            16.983167,
            52.402243,
            92.299647
          ],
          [
            16.983559,
            52.402203,
            92.350287
          ],
          [
            16.983945,
            52.402167,
            92.400048
          ],
          [
            16.984338,
            52.40212,
            92.394661
          ],
          [
            16.984735,
            52.402076,
            92.316003
          ],
          [
            16.985122,
            52.402057,
            92.24014
          ],
          [
            16.98537,
            52.402168,
            92.179352
          ],
          [
            16.98568,
            52.402229,
            92.11394
          ],
          [
            16.985994,
            52.402199,
            92.051732
          ],
          [
            16.986362,
            52.40218,
            91.979375
          ],
          [
            16.986693,
            52.402149,
            91.913616
          ],
          [
            16.986994,
            52.402107,
            91.853644
          ],
          [
            16.987286,
            52.402051,
            91.813147
          ],
          [
            16.987591,
            52.40193,
            91.764151
          ],
          [
            16.987765,
            52.401771,
            91.722373
          ],
          [
            16.987807,
            52.401572,
            91.678768
          ],
          [
            16.987823,
            52.40137,
            91.634827
          ],
          [
            16.98774,
            52.40118,
            91.592151
          ],
          [
            16.987686,
            52.400976,
            91.54697
          ],
          [
            16.987667,
            52.400765,
            91.50117
          ],
          [
            16.987607,
            52.400562,
            91.598831
          ],
          [
            16.98755,
            52.400369,
            92.311768
          ],
          [
            16.987647,
            52.400197,
            92.999214
          ],
          [
            16.98782,
            52.400029,
            93.72152
          ],
          [
            16.987991,
            52.399869,
            94.415784
          ],
          [
            16.988204,
            52.399726,
            95.129206
          ],
          [
            16.988489,
            52.399826,
            95.895261
          ],
          [
            16.988716,
            52.399808,
            96.643773
          ],
          [
            16.988891,
            52.399615,
            97.444577
          ],
          [
            16.989122,
            52.399435,
            97.820576
          ],
          [
            16.989319,
            52.399295,
            97.419242
          ],
          [
            16.989511,
            52.399124,
            96.970883
          ],
          [
            16.989735,
            52.398946,
            96.485771
          ],
          [
            16.989961,
            52.398805,
            96.058882
          ],
          [
            16.99014,
            52.398656,
            95.659234
          ],
          [
            16.990379,
            52.398503,
            95.202144
          ],
          [
            16.990558,
            52.398339,
            94.776191
          ],
          [
            16.990689,
            52.398148,
            94.32857
          ],
          [
            16.990874,
            52.397979,
            94.019372
          ],
          [
            16.99105,
            52.39778,
            93.827623
          ],
          [
            16.99109,
            52.397579,
            93.659058
          ],
          [
            16.9913,
            52.397425,
            93.492303
          ],
          [
            16.991514,
            52.397276,
            93.327408
          ],
          [
            16.991528,
            52.397058,
            93.143686
          ],
          [
            16.991719,
            52.396903,
            92.982279
          ],
          [
            16.991834,
            52.396706,
            92.808223
          ],
          [
            16.991938,
            52.396499,
            92.627289
          ],
          [
            16.992071,
            52.396323,
            94.011284
          ],
          [
            16.992347,
            52.396206,
            95.719635
          ],
          [
            16.992645,
            52.396165,
            97.28611
          ],
          [
            16.99295,
            52.396204,
            98.885709
          ],
          [
            16.993293,
            52.396383,
            101.256061
          ],
          [
            16.993465,
            52.396559,
            102.968813
          ],
          [
            16.993571,
            52.396749,
            104.651704
          ],
          [
            16.993778,
            52.396887,
            106.319467
          ],
          [
            16.994078,
            52.396874,
            107.382462
          ],
          [
            16.994308,
            52.396706,
            106.265909
          ],
          [
            16.994578,
            52.396541,
            105.074568
          ],
          [
            16.994912,
            52.396425,
            103.881036
          ],
          [
            16.99525,
            52.396322,
            102.707816
          ],
          [
            16.995634,
            52.396213,
            101.392826
          ],
          [
            16.996038,
            52.396133,
            100.070917
          ],
          [
            16.996373,
            52.396089,
            99.006884
          ],
          [
            16.996721,
            52.396018,
            98.443099
          ],
          [
            16.997057,
            52.395952,
            98.467864
          ],
          [
            16.997359,
            52.39591,
            98.489675
          ],
          [
            16.997784,
            52.39594,
            98.519735
          ],
          [
            16.998113,
            52.395977,
            98.543257
          ],
          [
            16.998476,
            52.395988,
            98.56875
          ],
          [
            16.998819,
            52.395981,
            98.593148
          ],
          [
            16.999131,
            52.39603,
            98.616281
          ],
          [
            16.999463,
            52.396043,
            98.65484
          ],
          [
            16.999831,
            52.396139,
            98.853904
          ],
          [
            17.000166,
            52.396121,
            99.025191
          ],
          [
            17.000523,
            52.396128,
            99.20197
          ],
          [
            17.000926,
            52.396107,
            99.401444
          ],
          [
            17.001243,
            52.39614,
            99.56099
          ],
          [
            17.001664,
            52.396167,
            99.769688
          ],
          [
            17.001966,
            52.396183,
            99.919561
          ],
          [
            17.002366,
            52.396168,
            100.190792
          ],
          [
            17.002726,
            52.396129,
            100.795324
          ],
          [
            17.003017,
            52.39605,
            101.323429
          ],
          [
            17.003254,
            52.395927,
            101.839771
          ],
          [
            17.003558,
            52.395786,
            102.474337
          ],
          [
            17.003886,
            52.395655,
            103.123278
          ],
          [
            17.004194,
            52.39557,
            103.68066
          ],
          [
            17.004588,
            52.395522,
            104.342663
          ],
          [
            17.004949,
            52.395548,
            104.945501
          ],
          [
            17.005282,
            52.395584,
            105.031831
          ],
          [
            17.005638,
            52.395567,
            105.122412
          ],
          [
            17.006008,
            52.395493,
            105.220558
          ],
          [
            17.006305,
            52.39543,
            105.299836
          ],
          [
            17.006639,
            52.395382,
            105.386459
          ],
          [
            17.006956,
            52.395392,
            105.466492
          ],
          [
            17.007288,
            52.395477,
            105.557502
          ],
          [
            17.007628,
            52.395563,
            105.650872
          ],
          [
            17.007957,
            52.395552,
            105.400703
          ],
          [
            17.008339,
            52.395555,
            104.775511
          ],
          [
            17.008695,
            52.395488,
            104.16141
          ],
          [
            17.009056,
            52.395466,
            103.564335
          ],
          [
            17.009441,
            52.395411,
            102.917298
          ],
          [
            17.00975,
            52.395349,
            102.386293
          ],
          [
            17.010109,
            52.395211,
            101.683352
          ],
          [
            17.010424,
            52.395073,
            101.045902
          ],
          [
            17.010726,
            52.394974,
            100.694885
          ],
          [
            17.011112,
            52.394966,
            100.400618
          ],
          [
            17.011477,
            52.394968,
            100.122504
          ],
          [
            17.011808,
            52.39497,
            99.870026
          ],
          [
            17.012293,
            52.395028,
            99.493384
          ],
          [
            17.012742,
            52.395039,
            99.150965
          ],
          [
            17.01307,
            52.395088,
            98.892714
          ],
          [
            17.013419,
            52.395109,
            98.645782
          ],
          [
            17.01376,
            52.39515,
            98.894973
          ],
          [
            17.014127,
            52.395098,
            99.166926
          ],
          [
            17.01449,
            52.395017,
            99.443775
          ],
          [
            17.014666,
            52.394867,
            99.667895
          ],
          [
            17.014473,
            52.394686,
            99.921391
          ],
          [
            17.014253,
            52.394512,
            100.179832
          ],
          [
            17.014158,
            52.394314,
            100.429049
          ],
          [
            17.014177,
            52.394092,
            100.690828
          ],
          [
            17.014239,
            52.393914,
            101.587083
          ],
          [
            17.014298,
            52.39371,
            102.88633
          ],
          [
            17.014388,
            52.393505,
            104.227751
          ],
          [
            17.014566,
            52.393328,
            105.571527
          ],
          [
            17.014819,
            52.393214,
            106.777666
          ],
          [
            17.015137,
            52.393143,
            108.076095
          ],
          [
            17.015333,
            52.39298,
            109.348366
          ],
          [
            17.015634,
            52.39295,
            110.526264
          ],
          [
            17.015942,
            52.392975,
            111.715862
          ],
          [
            17.016319,
            52.393043,
            112.290013
          ],
          [
            17.01667,
            52.393142,
            112.618817
          ],
          [
            17.017004,
            52.393211,
            112.918566
          ],
          [
            17.017354,
            52.39328,
            113.232748
          ],
          [
            17.017749,
            52.393308,
            113.570789
          ],
          [
            17.018123,
            52.393343,
            113.892316
          ],
          [
            17.018322,
            52.393211,
            114.192131
          ],
          [
            17.018365,
            52.392974,
            114.52417
          ],
          [
            17.018379,
            52.392748,
            114.346422
          ],
          [
            17.018409,
            52.392504,
            114.146372
          ],
          [
            17.01846,
            52.392276,
            113.958204
          ],
          [
            17.018492,
            52.392052,
            113.774345
          ],
          [
            17.018552,
            52.391835,
            113.594358
          ],
          [
            17.018611,
            52.391614,
            113.41126
          ],
          [
            17.018664,
            52.391392,
            113.227854
          ],
          [
            17.018707,
            52.391183,
            113.06385
          ],
          [
            17.018751,
            52.390975,
            113.419489
          ],
          [
            17.018944,
            52.390832,
            113.753551
          ],
          [
            17.019291,
            52.390852,
            114.114139
          ],
          [
            17.019702,
            52.390868,
            114.540516
          ],
          [
            17.02008,
            52.390902,
            114.935881
          ],
          [
            17.0205,
            52.390935,
            115.373978
          ],
          [
            17.020864,
            52.390966,
            115.754278
          ],
          [
            17.021225,
            52.390952,
            116.092892
          ],
          [
            17.021598,
            52.390901,
            115.821577
          ],
          [
            17.021927,
            52.390848,
            115.579623
          ],
          [
            17.022266,
            52.390783,
            115.327359
          ],
          [
            17.022641,
            52.390707,
            115.047264
          ],
          [
            17.022987,
            52.390606,
            114.775171
          ],
          [
            17.023289,
            52.390499,
            114.527152
          ],
          [
            17.023574,
            52.390352,
            114.262626
          ],
          [
            17.023866,
            52.390192,
            114.013311
          ],
          [
            17.024148,
            52.390005,
            113.970091
          ],
          [
            17.024358,
            52.389844,
            113.935103
          ],
          [
            17.024553,
            52.389674,
            113.899813
          ],
          [
            17.024774,
            52.389508,
            113.863359
          ],
          [
            17.024986,
            52.389325,
            113.825255
          ],
          [
            17.02517,
            52.389152,
            113.790129
          ],
          [
            17.02539,
            52.38897,
            113.751676
          ],
          [
            17.025585,
            52.388791,
            113.714984
          ],
          [
            17.02578,
            52.388619,
            113.989396
          ],
          [
            17.025962,
            52.388472,
            114.25196
          ],
          [
            17.026175,
            52.388285,
            114.576774
          ],
          [
            17.026389,
            52.388106,
            114.893159
          ],
          [
            17.026609,
            52.38793,
            115.208969
          ],
          [
            17.026818,
            52.387734,
            115.542211
          ],
          [
            17.027009,
            52.387548,
            115.855017
          ],
          [
            17.027211,
            52.387388,
            116.143605
          ],
          [
            17.02739,
            52.387219,
            116.410808
          ],
          [
            17.027693,
            52.387206,
            116.649483
          ],
          [
            17.027956,
            52.387327,
            116.899987
          ],
          [
            17.028189,
            52.38749,
            117.16999
          ],
          [
            17.028449,
            52.387656,
            117.455844
          ],
          [
            17.028734,
            52.387731,
            117.700472
          ],
          [
            17.028988,
            52.387603,
            117.952051
          ],
          [
            17.029248,
            52.387461,
            118.217219
          ],
          [
            17.029453,
            52.387301,
            118.471847
          ],
          [
            17.029675,
            52.387152,
            118.579433
          ],
          [
            17.029861,
            52.386955,
            118.668178
          ],
          [
            17.030006,
            52.38675,
            118.75512
          ],
          [
            17.030096,
            52.386541,
            118.839348
          ],
          [
            17.030138,
            52.386315,
            118.928081
          ],
          [
            17.030136,
            52.386126,
            119.001612
          ],
          [
            17.030108,
            52.385908,
            119.086994
          ],
          [
            17.03014,
            52.385703,
            119.167113
          ],
          [
            17.030183,
            52.385484,
            119.336299
          ],
          [
            17.030217,
            52.385261,
            119.610328
          ],
          [
            17.030262,
            52.385044,
            119.877947
          ],
          [
            17.030313,
            52.384811,
            120.165524
          ],
          [
            17.030325,
            52.384572,
            120.458069
          ],
          [
            17.030341,
            52.384331,
            120.753145
          ],
          [
            17.030345,
            52.384091,
            121.04676
          ],
          [
            17.030355,
            52.38386,
            121.329479
          ],
          [
            17.030367,
            52.383628,
            121.484022
          ],
          [
            17.030407,
            52.383368,
            121.595822
          ],
          [
            17.030428,
            52.383111,
            121.705979
          ],
          [
            17.030473,
            52.382924,
            121.786863
          ],
          [
            17.030488,
            52.382734,
            121.868629
          ],
          [
            17.030506,
            52.382508,
            121.965458
          ],
          [
            17.030519,
            52.382281,
            122.062746
          ],
          [
            17.030478,
            52.382087,
            122.146576
          ],
          [
            17.030441,
            52.381895,
            122.181911
          ],
          [
            17.030456,
            52.381692,
            122.177704
          ],
          [
            17.030499,
            52.381484,
            122.173363
          ],
          [
            17.030507,
            52.381295,
            122.169447
          ],
          [
            17.030535,
            52.381098,
            122.165353
          ],
          [
            17.030558,
            52.380902,
            122.161285
          ],
          [
            17.030588,
            52.380716,
            122.157415
          ],
          [
            17.030616,
            52.380527,
            122.153449
          ],
          [
            17.030639,
            52.380337,
            122.149505
          ],
          [
            17.030669,
            52.380126,
            122.002476
          ],
          [
            17.030683,
            52.379924,
            121.65918
          ],
          [
            17.03077,
            52.379695,
            121.252521
          ],
          [
            17.03115,
            52.37963,
            120.837062
          ],
          [
            17.031492,
            52.379645,
            120.481677
          ],
          [
            17.031863,
            52.379678,
            120.093076
          ],
          [
            17.032212,
            52.379714,
            119.725712
          ],
          [
            17.032556,
            52.379714,
            119.366845
          ],
          [
            17.032887,
            52.379743,
            119.077224
          ],
          [
            17.033257,
            52.379776,
            118.993651
          ],
          [
            17.033642,
            52.379809,
            118.906564
          ],
          [
            17.034007,
            52.37982,
            118.824867
          ],
          [
            17.034345,
            52.379726,
            118.74086
          ],
          [
            17.034469,
            52.379542,
            118.666819
          ],
          [
            17.034521,
            52.379344,
            118.593397
          ],
          [
            17.034585,
            52.379128,
            118.512992
          ],
          [
            17.034648,
            52.378918,
            118.434773
          ],
          [
            17.034736,
            52.378719,
            118.296962
          ],
          [
            17.034807,
            52.378535,
            118.169295
          ],
          [
            17.034887,
            52.378323,
            118.023437
          ],
          [
            17.034916,
            52.378113,
            117.882179
          ],
          [
            17.034986,
            52.377911,
            117.7437
          ],
          [
            17.035015,
            52.377702,
            117.602815
          ],
          [
            17.035071,
            52.377504,
            117.46811
          ],
          [
            17.035131,
            52.377323,
            117.343972
          ],
          [
            17.035181,
            52.377128,
            117.245505
          ],
          [
            17.035228,
            52.376929,
            117.374095
          ],
          [
            17.035307,
            52.3767,
            117.52379
          ],
          [
            17.035358,
            52.37651,
            117.646925
          ],
          [
            17.035431,
            52.376299,
            117.784862
          ],
          [
            17.0355,
            52.376088,
            117.922726
          ],
          [
            17.035554,
            52.375885,
            118.054285
          ],
          [
            17.035626,
            52.375697,
            118.177858
          ],
          [
            17.03571,
            52.375503,
            118.306193
          ],
          [
            17.035727,
            52.375317,
            118.491754
          ],
          [
            17.035778,
            52.375127,
            118.792166
          ],
          [
            17.03582,
            52.37493,
            119.102075
          ],
          [
            17.035844,
            52.374729,
            119.417551
          ],
          [
            17.035905,
            52.374536,
            119.724161
          ],
          [
            17.035951,
            52.374327,
            120.053124
          ],
          [
            17.035991,
            52.374129,
            120.364759
          ],
          [
            17.036028,
            52.373939,
            120.663375
          ],
          [
            17.036105,
            52.373748,
            120.970239
          ],
          [
            17.036144,
            52.373548,
            121.192752
          ],
          [
            17.036181,
            52.373348,
            121.217433
          ],
          [
            17.036246,
            52.373137,
            121.243697
          ],
          [
            17.036291,
            52.372945,
            121.267469
          ],
          [
            17.036336,
            52.372739,
            121.292886
          ],
          [
            17.03639,
            52.372542,
            121.317314
          ],
          [
            17.03645,
            52.372342,
            121.342183
          ],
          [
            17.03652,
            52.372135,
            121.36808
          ],
          [
            17.036518,
            52.371932,
            121.393104
          ],
          [
            17.036578,
            52.37173,
            121.599352
          ],
          [
            17.036643,
            52.371539,
            121.945578
          ],
          [
            17.036691,
            52.371344,
            122.295276
          ],
          [
            17.036732,
            52.371116,
            122.702529
          ],
          [
            17.036786,
            52.370887,
            123.112853
          ],
          [
            17.036844,
            52.370666,
            123.51023
          ],
          [
            17.036915,
            52.370484,
            123.842606
          ],
          [
            17.03696,
            52.37029,
            124.190074
          ],
          [
            17.036983,
            52.370062,
            124.594135
          ],
          [
            17.037034,
            52.369857,
            124.42317
          ],
          [
            17.037081,
            52.369661,
            124.259943
          ],
          [
            17.037091,
            52.369476,
            124.107366
          ],
          [
            17.037132,
            52.369277,
            123.942046
          ],
          [
            17.037168,
            52.369069,
            123.769697
          ],
          [
            17.037174,
            52.368869,
            123.604821
          ],
          [
            17.037132,
            52.368672,
            123.440096
          ],
          [
            17.037087,
            52.368473,
            123.274535
          ],
          [
            17.037016,
            52.368269,
            123.101138
          ],
          [
            17.036909,
            52.368064,
            122.90044
          ],
          [
            17.036842,
            52.36785,
            122.696144
          ],
          [
            17.036775,
            52.367639,
            122.495734
          ],
          [
            17.036717,
            52.367417,
            122.286165
          ],
          [
            17.036655,
            52.367202,
            122.082653
          ],
          [
            17.03661,
            52.366973,
            121.867182
          ],
          [
            17.036511,
            52.366747,
            121.647859
          ],
          [
            17.036428,
            52.366512,
            121.425165
          ],
          [
            17.036341,
            52.366276,
            121.226028
          ],
          [
            17.036272,
            52.366038,
            121.027054
          ],
          [
            17.036179,
            52.36584,
            120.857324
          ],
          [
            17.036128,
            52.365638,
            120.68912
          ],
          [
            17.036069,
            52.365433,
            120.51765
          ],
          [
            17.036,
            52.365216,
            120.335735
          ],
          [
            17.035922,
            52.365001,
            120.154399
          ],
          [
            17.035878,
            52.364791,
            119.980131
          ],
          [
            17.035793,
            52.364605,
            120.131476
          ],
          [
            17.035711,
            52.364379,
            120.380479
          ],
          [
            17.035642,
            52.36416,
            120.62042
          ],
          [
            17.035549,
            52.36394,
            120.864966
          ],
          [
            17.035474,
            52.36375,
            121.075641
          ],
          [
            17.03539,
            52.363522,
            121.327477
          ],
          [
            17.035301,
            52.363334,
            121.537959
          ],
          [
            17.035232,
            52.363139,
            121.752786
          ],
          [
            17.035144,
            52.362956,
            121.855901
          ],
          [
            17.035037,
            52.362767,
            121.74779
          ],
          [
            17.034887,
            52.36259,
            121.640182
          ],
          [
            17.034716,
            52.362417,
            121.531115
          ],
          [
            17.03459,
            52.36223,
            121.421275
          ],
          [
            17.034406,
            52.362012,
            121.288908
          ],
          [
            17.034194,
            52.361788,
            121.149254
          ],
          [
            17.033995,
            52.361556,
            121.007521
          ],
          [
            17.03383,
            52.36135,
            120.972617
          ],
          [
            17.033677,
            52.361188,
            121.124352
          ],
          [
            17.033523,
            52.360996,
            121.297586
          ],
          [
            17.033335,
            52.360753,
            121.515346
          ],
          [
            17.033118,
            52.360555,
            121.708391
          ],
          [
            17.032957,
            52.360344,
            121.897197
          ],
          [
            17.032813,
            52.36018,
            122.047975
          ],
          [
            17.032651,
            52.359983,
            122.226606
          ],
          [
            17.032486,
            52.35982,
            122.366056
          ],
          [
            17.032311,
            52.359625,
            122.020442
          ],
          [
            17.032132,
            52.359428,
            121.67017
          ],
          [
            17.031988,
            52.359265,
            121.382076
          ],
          [
            17.031824,
            52.35911,
            121.092305
          ],
          [
            17.031684,
            52.358942,
            120.799307
          ],
          [
            17.031521,
            52.358768,
            120.487308
          ],
          [
            17.031356,
            52.358589,
            120.167727
          ],
          [
            17.031208,
            52.358419,
            119.868479
          ],
          [
            17.031035,
            52.358256,
            119.594454
          ],
          [
            17.030876,
            52.358063,
            119.89634
          ],
          [
            17.030701,
            52.35787,
            120.204416
          ],
          [
            17.030514,
            52.357668,
            120.529046
          ],
          [
            17.030337,
            52.35746,
            120.856581
          ],
          [
            17.030187,
            52.35728,
            121.138642
          ],
          [
            17.030061,
            52.357115,
            121.392886
          ],
          [
            17.02988,
            52.356891,
            121.74322
          ],
          [
            17.029692,
            52.356685,
            122.072599
          ],
          [
            17.029501,
            52.356458,
            121.613038
          ],
          [
            17.029291,
            52.356266,
            121.152528
          ],
          [
            17.029114,
            52.356068,
            120.702814
          ],
          [
            17.028931,
            52.355867,
            120.244319
          ],
          [
            17.028819,
            52.355681,
            119.848777
          ],
          [
            17.028649,
            52.355513,
            119.45439
          ],
          [
            17.028915,
            52.355393,
            119.049546
          ],
          [
            17.029026,
            52.355309,
            118.711868
          ],
          [
            17.029261,
            52.355137,
            118.362219
          ],
          [
            17.029496,
            52.355011,
            118.137296
          ],
          [
            17.029779,
            52.354875,
            117.878431
          ],
          [
            17.030043,
            52.354756,
            117.642432
          ],
          [
            17.030324,
            52.354626,
            117.388951
          ],
          [
            17.030592,
            52.354483,
            117.13313
          ],
          [
            17.030906,
            52.354325,
            116.840665
          ],
          [
            17.031211,
            52.354181,
            116.563531
          ],
          [
            17.031516,
            52.354033,
            116.21902
          ],
          [
            17.031823,
            52.353887,
            115.771728
          ],
          [
            17.032134,
            52.353743,
            115.322784
          ],
          [
            17.032418,
            52.35361,
            114.911415
          ],
          [
            17.032683,
            52.353473,
            114.512357
          ],
          [
            17.032952,
            52.353347,
            114.12215
          ],
          [
            17.033245,
            52.353216,
            113.704772
          ],
          [
            17.033536,
            52.353082,
            113.285755
          ],
          [
            17.033868,
            52.352934,
            112.792557
          ],
          [
            17.034167,
            52.352774,
            112.28515
          ],
          [
            17.034526,
            52.352597,
            111.697651
          ],
          [
            17.03482,
            52.35244,
            111.200372
          ],
          [
            17.035182,
            52.352273,
            110.622653
          ],
          [
            17.035538,
            52.352105,
            110.049705
          ],
          [
            17.035894,
            52.351941,
            109.48162
          ],
          [
            17.036254,
            52.351757,
            109.13482
          ],
          [
            17.036623,
            52.351577,
            108.938954
          ],
          [
            17.036974,
            52.351414,
            108.756151
          ],
          [
            17.037347,
            52.35125,
            108.565692
          ],
          [
            17.037713,
            52.351119,
            108.389565
          ],
          [
            17.038131,
            52.351044,
            108.208286
          ],
          [
            17.038527,
            52.350993,
            108.040606
          ],
          [
            17.038922,
            52.350929,
            107.766582
          ],
          [
            17.039287,
            52.350879,
            107.513153
          ],
          [
            17.039642,
            52.350821,
            107.264186
          ],
          [
            17.03996,
            52.350773,
            107.04194
          ],
          [
            17.040293,
            52.350722,
            106.809414
          ],
          [
            17.040621,
            52.350654,
            106.573068
          ],
          [
            17.040944,
            52.35061,
            106.348743
          ],
          [
            17.04127,
            52.350565,
            106.1222
          ],
          [
            17.041619,
            52.350504,
            105.806085
          ],
          [
            17.041984,
            52.350443,
            105.44072
          ],
          [
            17.042328,
            52.350393,
            105.099115
          ],
          [
            17.042671,
            52.350338,
            104.756857
          ],
          [
            17.043037,
            52.350304,
            104.399574
          ],
          [
            17.043393,
            52.350246,
            104.043963
          ],
          [
            17.043748,
            52.350185,
            103.68805
          ],
          [
            17.044112,
            52.350127,
            103.324845
          ],
          [
            17.044485,
            52.350067,
            103.412865
          ],
          [
            17.044859,
            52.350009,
            103.732598
          ],
          [
            17.045241,
            52.349957,
            104.056874
          ],
          [
            17.045618,
            52.349905,
            104.377118
          ],
          [
            17.045983,
            52.349841,
            104.691901
          ],
          [
            17.046355,
            52.349786,
            105.009379
          ],
          [
            17.04672,
            52.349745,
            105.317114
          ],
          [
            17.047059,
            52.349712,
            105.601604
          ],
          [
            17.047415,
            52.349683,
            105.493773
          ],
          [
            17.047783,
            52.349634,
            105.317634
          ],
          [
            17.04812,
            52.3496,
            105.158104
          ],
          [
            17.04847,
            52.349559,
            104.991777
          ],
          [
            17.048805,
            52.349524,
            104.833146
          ],
          [
            17.049099,
            52.349477,
            104.691294
          ],
          [
            17.049387,
            52.349386,
            104.53908
          ],
          [
            17.049786,
            52.349308,
            104.343544
          ],
          [
            17.050131,
            52.349227,
            104.259809
          ],
          [
            17.050425,
            52.349152,
            104.249522
          ],
          [
            17.050724,
            52.349085,
            104.239229
          ],
          [
            17.051039,
            52.349019,
            104.228479
          ],
          [
            17.051359,
            52.348952,
            104.217554
          ],
          [
            17.051733,
            52.348889,
            104.205033
          ],
          [
            17.052085,
            52.348818,
            104.193068
          ],
          [
            17.05239,
            52.348767,
            104.182857
          ],
          [
            17.052763,
            52.348684,
            104.184549
          ],
          [
            17.053076,
            52.348619,
            104.287382
          ],
          [
            17.05341,
            52.348552,
            104.396699
          ],
          [
            17.053757,
            52.348473,
            104.511824
          ],
          [
            17.054084,
            52.348416,
            104.617645
          ],
          [
            17.054415,
            52.348314,
            104.733736
          ],
          [
            17.054715,
            52.348214,
            104.84015
          ],
          [
            17.055009,
            52.348152,
            104.937057
          ],
          [
            17.055341,
            52.348057,
            105.051033
          ],
          [
            17.055668,
            52.347959,
            105.127792
          ],
          [
            17.055991,
            52.347852,
            105.188242
          ],
          [
            17.056313,
            52.347762,
            105.246515
          ],
          [
            17.056629,
            52.347656,
            105.305896
          ],
          [
            17.056935,
            52.347554,
            105.363272
          ],
          [
            17.057226,
            52.347484,
            105.414869
          ],
          [
            17.057511,
            52.347391,
            105.468042
          ],
          [
            17.057791,
            52.347304,
            105.519722
          ],
          [
            17.058053,
            52.347207,
            105.570158
          ],
          [
            17.05839,
            52.347112,
            106.609271
          ],
          [
            17.058777,
            52.346996,
            107.836621
          ],
          [
            17.059108,
            52.346891,
            108.896976
          ],
          [
            17.059462,
            52.346809,
            109.973325
          ],
          [
            17.05981,
            52.346693,
            111.101466
          ],
          [
            17.060187,
            52.346589,
            112.277526
          ],
          [
            17.060554,
            52.346457,
            113.489695
          ],
          [
            17.060922,
            52.34637,
            114.224151
          ],
          [
            17.061247,
            52.346289,
            114.642866
          ],
          [
            17.061567,
            52.346222,
            115.046334
          ],
          [
            17.061866,
            52.346169,
            115.417585
          ],
          [
            17.062238,
            52.346093,
            115.885297
          ],
          [
            17.062625,
            52.346014,
            116.372053
          ],
          [
            17.06295,
            52.345948,
            116.780412
          ],
          [
            17.063284,
            52.34589,
            117.194666
          ],
          [
            17.063653,
            52.345812,
            117.6183
          ],
          [
            17.063991,
            52.345755,
            117.951537
          ],
          [
            17.064324,
            52.345712,
            118.275018
          ],
          [
            17.064633,
            52.345626,
            118.600635
          ],
          [
            17.06497,
            52.345535,
            118.968062
          ],
          [
            17.065265,
            52.345486,
            119.258597
          ],
          [
            17.065631,
            52.345424,
            119.61992
          ],
          [
            17.065965,
            52.345333,
            119.968856
          ],
          [
            17.066262,
            52.345289,
            120.244088
          ],
          [
            17.066628,
            52.34522,
            119.976348
          ],
          [
            17.066992,
            52.345162,
            119.713376
          ],
          [
            17.067342,
            52.345099,
            119.45748
          ],
          [
            17.067686,
            52.345013,
            119.197295
          ],
          [
            17.067984,
            52.34497,
            118.983239
          ],
          [
            17.068282,
            52.344884,
            118.752575
          ],
          [
            17.068676,
            52.344832,
            118.466824
          ],
          [
            17.068992,
            52.344768,
            118.234101
          ],
          [
            17.069323,
            52.3447,
            118.378796
          ],
          [
            17.069619,
            52.344639,
            118.579004
          ],
          [
            17.069956,
            52.344625,
            118.79755
          ],
          [
            17.070335,
            52.344559,
            119.050088
          ],
          [
            17.070731,
            52.344487,
            119.315011
          ],
          [
            17.071139,
            52.344416,
            119.586954
          ],
          [
            17.071449,
            52.344353,
            119.796309
          ],
          [
            17.071757,
            52.344302,
            120.000861
          ],
          [
            17.072114,
            52.344228,
            119.753314
          ],
          [
            17.072467,
            52.344173,
            119.287238
          ],
          [
            17.072798,
            52.344123,
            118.850243
          ],
          [
            17.073192,
            52.344059,
            118.32872
          ],
          [
            17.073598,
            52.343977,
            117.781469
          ],
          [
            17.073877,
            52.343922,
            117.381725
          ],
          [
            17.074266,
            52.34392,
            116.875758
          ],
          [
            17.074585,
            52.343872,
            116.455207
          ],
          [
            17.074925,
            52.343849,
            116.019488
          ],
          [
            17.075281,
            52.343793,
            115.552237
          ],
          [
            17.07562,
            52.343739,
            115.106374
          ],
          [
            17.075851,
            52.343609,
            114.702495
          ],
          [
            17.075909,
            52.343417,
            114.293729
          ],
          [
            17.075831,
            52.34324,
            113.907283
          ],
          [
            17.075859,
            52.343016,
            113.431729
          ],
          [
            17.07609,
            52.342841,
            112.963221
          ],
          [
            17.076274,
            52.342692,
            112.574553
          ],
          [
            17.076541,
            52.342577,
            112.850476
          ],
          [
            17.076873,
            52.342485,
            113.160048
          ],
          [
            17.077214,
            52.34243,
            113.458486
          ],
          [
            17.077538,
            52.342392,
            113.737725
          ],
          [
            17.077831,
            52.34233,
            114.002055
          ],
          [
            17.07808,
            52.34221,
            114.270948
          ],
          [
            17.078357,
            52.342052,
            114.59175
          ],
          [
            17.078621,
            52.341907,
            114.892158
          ],
          [
            17.078907,
            52.34178,
            115.096823
          ],
          [
            17.079208,
            52.341759,
            115.162098
          ],
          [
            17.079532,
            52.341818,
            115.234599
          ],
          [
            17.079871,
            52.341885,
            115.311051
          ],
          [
            17.080256,
            52.341937,
            115.395658
          ],
          [
            17.080607,
            52.341874,
            115.474795
          ],
          [
            17.080897,
            52.341732,
            115.554652
          ],
          [
            17.081139,
            52.341601,
            115.623969
          ],
          [
            17.081424,
            52.341444,
            115.699589
          ],
          [
            17.081624,
            52.341275,
            115.726064
          ],
          [
            17.08176,
            52.341082,
            115.75273
          ],
          [
            17.081819,
            52.340817,
            115.786627
          ],
          [
            17.081911,
            52.340612,
            115.813559
          ],
          [
            17.081976,
            52.340379,
            115.84347
          ],
          [
            17.082003,
            52.340144,
            115.873281
          ],
          [
            17.081996,
            52.339945,
            115.89847
          ],
          [
            17.081935,
            52.339759,
            115.922477
          ],
          [
            17.081836,
            52.339536,
            115.916906
          ],
          [
            17.081688,
            52.339316,
            115.910103
          ],
          [
            17.081556,
            52.339128,
            115.904237
          ],
          [
            17.081431,
            52.338944,
            115.898532
          ],
          [
            17.081278,
            52.33876,
            115.892632
          ],
          [
            17.081103,
            52.338529,
            115.885353
          ],
          [
            17.080965,
            52.33833,
            115.879167
          ],
          [
            17.081061,
            52.338278,
            115.873865
          ],
          [
            17.081278,
            52.338344,
            116.081448
          ],
          [
            17.081577,
            52.338273,
            116.413686
          ],
          [
            17.081902,
            52.338189,
            116.779164
          ],
          [
            17.082221,
            52.338093,
            117.147679
          ],
          [
            17.082522,
            52.338008,
            117.491125
          ],
          [
            17.082845,
            52.337922,
            117.856116
          ],
          [
            17.083166,
            52.337826,
            118.226334
          ],
          [
            17.083479,
            52.337713,
            118.60293
          ],
          [
            17.083835,
            52.337605,
            118.870991
          ],
          [
            17.084169,
            52.337476,
            118.654257
          ],
          [
            17.084515,
            52.33736,
            118.437623
          ],
          [
            17.084835,
            52.337271,
            118.244783
          ],
          [
            17.085131,
            52.33718,
            118.06249
          ],
          [
            17.085408,
            52.337095,
            117.892376
          ],
          [
            17.085758,
            52.337004,
            117.683646
          ],
          [
            17.086104,
            52.336918,
            117.478757
          ],
          [
            17.086406,
            52.336828,
            117.323218
          ],
          [
            17.086747,
            52.336762,
            117.568811
          ],
          [
            17.087073,
            52.336662,
            117.819372
          ],
          [
            17.087416,
            52.336572,
            118.075763
          ],
          [
            17.087763,
            52.336485,
            118.33329
          ],
          [
            17.088051,
            52.336386,
            118.560423
          ],
          [
            17.088393,
            52.336311,
            118.8099
          ],
          [
            17.088701,
            52.336244,
            119.035068
          ],
          [
            17.089053,
            52.336134,
            119.306546
          ],
          [
            17.089356,
            52.33605,
            119.366469
          ],
          [
            17.089658,
            52.335962,
            119.408806
          ],
          [
            17.089958,
            52.335872,
            119.45108
          ],
          [
            17.090267,
            52.335803,
            119.492914
          ],
          [
            17.09059,
            52.335745,
            119.535524
          ],
          [
            17.090902,
            52.335677,
            119.577564
          ],
          [
            17.091268,
            52.335578,
            119.62825
          ],
          [
            17.091603,
            52.335492,
            119.67421
          ],
          [
            17.091932,
            52.335413,
            119.676909
          ],
          [
            17.092306,
            52.335322,
            119.611011
          ],
          [
            17.092691,
            52.33524,
            119.544269
          ],
          [
            17.093059,
            52.335149,
            119.479205
          ],
          [
            17.093445,
            52.335062,
            119.411825
          ],
          [
            17.093823,
            52.334963,
            119.344496
          ],
          [
            17.094206,
            52.334872,
            119.277205
          ],
          [
            17.094562,
            52.334785,
            119.214445
          ],
          [
            17.094945,
            52.334684,
            119.147469
          ],
          [
            17.095314,
            52.334586,
            119.082877
          ],
          [
            17.095706,
            52.33448,
            119.014063
          ],
          [
            17.096085,
            52.334393,
            118.949065
          ],
          [
            17.096451,
            52.33427,
            118.881931
          ],
          [
            17.096782,
            52.334172,
            118.822775
          ],
          [
            17.097172,
            52.334055,
            118.753017
          ],
          [
            17.097566,
            52.33396,
            118.870515
          ],
          [
            17.097943,
            52.333869,
            119.002529
          ],
          [
            17.09822,
            52.333799,
            119.100148
          ],
          [
            17.098507,
            52.333713,
            119.204255
          ],
          [
            17.0988,
            52.33364,
            119.307446
          ],
          [
            17.099155,
            52.333555,
            119.431619
          ],
          [
            17.099488,
            52.333463,
            119.550631
          ],
          [
            17.099773,
            52.333397,
            119.649912
          ],
          [
            17.100124,
            52.333293,
            119.586655
          ],
          [
            17.100464,
            52.333218,
            119.394342
          ],
          [
            17.100753,
            52.333143,
            119.226725
          ],
          [
            17.101028,
            52.333054,
            119.061202
          ],
          [
            17.101333,
            52.332963,
            118.880662
          ],
          [
            17.101756,
            52.332849,
            118.634142
          ],
          [
            17.102097,
            52.332784,
            118.443386
          ],
          [
            17.102423,
            52.332673,
            118.244706
          ],
          [
            17.102749,
            52.332579,
            118.224606
          ],
          [
            17.103052,
            52.332512,
            118.394845
          ],
          [
            17.103354,
            52.332432,
            118.568756
          ],
          [
            17.103638,
            52.332373,
            118.727359
          ],
          [
            17.103931,
            52.332295,
            118.896365
          ],
          [
            17.10433,
            52.332204,
            119.121767
          ],
          [
            17.10469,
            52.33211,
            119.32952
          ],
          [
            17.105069,
            52.332024,
            119.543504
          ],
          [
            17.105348,
            52.331947,
            119.708408
          ],
          [
            17.105636,
            52.331883,
            119.915305
          ],
          [
            17.105992,
            52.331769,
            120.186535
          ],
          [
            17.10638,
            52.331683,
            120.465077
          ],
          [
            17.106768,
            52.331594,
            120.744612
          ],
          [
            17.107066,
            52.331522,
            120.960629
          ],
          [
            17.107344,
            52.331436,
            121.171165
          ],
          [
            17.107762,
            52.331346,
            121.469927
          ],
          [
            17.108161,
            52.331247,
            121.567411
          ],
          [
            17.108516,
            52.331151,
            121.216609
          ],
          [
            17.108842,
            52.331079,
            120.903392
          ],
          [
            17.109173,
            52.33101,
            120.587296
          ],
          [
            17.10954,
            52.330938,
            120.238626
          ],
          [
            17.109848,
            52.330891,
            119.951759
          ],
          [
            17.110185,
            52.330845,
            119.639655
          ],
          [
            17.1104,
            52.330707,
            119.325234
          ],
          [
            17.110301,
            52.330474,
            119.041259
          ],
          [
            17.110213,
            52.330221,
            119.214447
          ],
          [
            17.110103,
            52.329982,
            119.380601
          ],
          [
            17.10999,
            52.329735,
            119.552192
          ],
          [
            17.109877,
            52.329503,
            119.714177
          ],
          [
            17.109765,
            52.329277,
            119.872165
          ],
          [
            17.109666,
            52.329059,
            120.023663
          ],
          [
            17.109588,
            52.328832,
            120.178926
          ],
          [
            17.109495,
            52.3286,
            120.332646
          ],
          [
            17.109392,
            52.328364,
            120.487081
          ],
          [
            17.10932,
            52.328149,
            120.626085
          ],
          [
            17.109206,
            52.327907,
            120.78535
          ],
          [
            17.109118,
            52.327648,
            120.952676
          ],
          [
            17.109017,
            52.327434,
            121.094117
          ],
          [
            17.108935,
            52.327258,
            121.210031
          ],
          [
            17.108859,
            52.327078,
            121.327596
          ],
          [
            17.108751,
            52.326879,
            121.525457
          ],
          [
            17.108656,
            52.326698,
            121.723435
          ],
          [
            17.108595,
            52.326506,
            121.92731
          ],
          [
            17.108506,
            52.326322,
            122.127281
          ],
          [
            17.108387,
            52.326075,
            122.395408
          ],
          [
            17.108312,
            52.325859,
            122.62539
          ],
          [
            17.108212,
            52.32562,
            122.882284
          ],
          [
            17.108116,
            52.325405,
            123.1143
          ],
          [
            17.108023,
            52.325214,
            123.270467
          ],
          [
            17.107955,
            52.325029,
            123.355611
          ],
          [
            17.107883,
            52.324814,
            123.454191
          ],
          [
            17.107794,
            52.324609,
            123.549468
          ],
          [
            17.107711,
            52.324403,
            123.64474
          ],
          [
            17.107601,
            52.324189,
            123.745466
          ],
          [
            17.107507,
            52.323932,
            123.863719
          ],
          [
            17.107415,
            52.323703,
            123.969899
          ],
          [
            17.107337,
            52.323505,
            123.887931
          ],
          [
            17.10727,
            52.323298,
            123.243563
          ],
          [
            17.107231,
            52.323059,
            122.510218
          ],
          [
            17.107244,
            52.322789,
            121.68497
          ],
          [
            17.107361,
            52.322506,
            120.793641
          ],
          [
            17.107552,
            52.322228,
            119.872991
          ],
          [
            17.107832,
            52.32197,
            118.924423
          ],
          [
            17.108179,
            52.32174,
            118.737575
          ],
          [
            17.108531,
            52.321537,
            119.032966
          ],
          [
            17.108878,
            52.321336,
            119.324724
          ],
          [
            17.109205,
            52.321148,
            119.598623
          ],
          [
            17.109514,
            52.32098,
            119.850941
          ],
          [
            17.109805,
            52.320824,
            120.087132
          ],
          [
            17.11006,
            52.320656,
            120.31586
          ],
          [
            17.110318,
            52.320487,
            120.082798
          ],
          [
            17.110548,
            52.320366,
            119.845915
          ],
          [
            17.110855,
            52.320178,
            119.507347
          ],
          [
            17.111124,
            52.32003,
            119.225462
          ],
          [
            17.111397,
            52.319852,
            118.912828
          ],
          [
            17.111662,
            52.319693,
            118.622356
          ],
          [
            17.11188,
            52.319557,
            118.379693
          ],
          [
            17.112138,
            52.319414,
            118.10835
          ],
          [
            17.112405,
            52.319262,
            118.254727
          ],
          [
            17.112674,
            52.319101,
            118.517412
          ],
          [
            17.112927,
            52.318957,
            118.758546
          ],
          [
            17.11318,
            52.318797,
            119.013445
          ],
          [
            17.113433,
            52.318655,
            119.253052
          ],
          [
            17.113705,
            52.318507,
            119.507068
          ],
          [
            17.114048,
            52.318313,
            119.83304
          ],
          [
            17.114294,
            52.318179,
            120.063012
          ],
          [
            17.114541,
            52.318042,
            120.244409
          ],
          [
            17.114777,
            52.317908,
            120.409221
          ],
          [
            17.115071,
            52.317749,
            120.609997
          ],
          [
            17.115273,
            52.317607,
            120.767761
          ],
          [
            17.115498,
            52.317464,
            120.933761
          ],
          [
            17.11574,
            52.317334,
            121.098787
          ],
          [
            17.115967,
            52.317197,
            121.261977
          ],
          [
            17.116245,
            52.317028,
            121.462654
          ],
          [
            17.116509,
            52.316879,
            121.521832
          ],
          [
            17.116786,
            52.316715,
            121.078099
          ],
          [
            17.117034,
            52.316573,
            120.68718
          ],
          [
            17.117299,
            52.316417,
            120.263685
          ],
          [
            17.117537,
            52.316251,
            119.848215
          ],
          [
            17.11779,
            52.316094,
            119.433379
          ],
          [
            17.118035,
            52.315964,
            119.060115
          ],
          [
            17.118327,
            52.315801,
            118.605194
          ],
          [
            17.118603,
            52.315639,
            118.281464
          ],
          [
            17.118835,
            52.315491,
            118.666953
          ],
          [
            17.119091,
            52.315353,
            119.059663
          ],
          [
            17.119321,
            52.315221,
            119.422534
          ],
          [
            17.119545,
            52.31508,
            119.792313
          ],
          [
            17.119781,
            52.314951,
            120.156851
          ],
          [
            17.120064,
            52.314791,
            120.600072
          ],
          [
            17.120313,
            52.314657,
            120.98162
          ],
          [
            17.120567,
            52.314508,
            121.386488
          ],
          [
            17.120815,
            52.314357,
            121.610092
          ],
          [
            17.121045,
            52.314209,
            121.619681
          ],
          [
            17.121282,
            52.314088,
            121.628547
          ],
          [
            17.121516,
            52.31394,
            121.638213
          ],
          [
            17.121734,
            52.313804,
            121.647156
          ],
          [
            17.121959,
            52.313666,
            121.656309
          ],
          [
            17.122184,
            52.313508,
            121.666177
          ],
          [
            17.122452,
            52.313365,
            121.67639
          ],
          [
            17.122724,
            52.3132,
            121.687391
          ],
          [
            17.123001,
            52.313035,
            121.489846
          ],
          [
            17.123291,
            52.312876,
            121.227299
          ],
          [
            17.123584,
            52.312702,
            120.951897
          ],
          [
            17.123874,
            52.312528,
            120.678014
          ],
          [
            17.124166,
            52.312357,
            120.405427
          ],
          [
            17.124433,
            52.312196,
            120.152614
          ],
          [
            17.124737,
            52.31202,
            119.870229
          ],
          [
            17.125001,
            52.311864,
            119.762983
          ],
          [
            17.125269,
            52.311711,
            119.926834
          ],
          [
            17.125548,
            52.31155,
            120.097957
          ],
          [
            17.125801,
            52.311407,
            120.251869
          ],
          [
            17.12608,
            52.311245,
            120.423736
          ],
          [
            17.126348,
            52.311084,
            120.591308
          ],
          [
            17.126612,
            52.310926,
            120.756103
          ],
          [
            17.126889,
            52.310774,
            120.922211
          ],
          [
            17.12717,
            52.310604,
            120.951716
          ],
          [
            17.127421,
            52.31043,
            120.808022
          ],
          [
            17.127711,
            52.310269,
            120.659797
          ],
          [
            17.127971,
            52.310105,
            120.51821
          ],
          [
            17.128236,
            52.309957,
            120.382188
          ],
          [
            17.128515,
            52.309803,
            120.239789
          ],
          [
            17.128794,
            52.309641,
            120.0942
          ],
          [
            17.129086,
            52.309473,
            119.942437
          ],
          [
            17.129354,
            52.309322,
            119.849584
          ],
          [
            17.12967,
            52.309148,
            119.759918
          ],
          [
            17.129929,
            52.30899,
            119.682753
          ],
          [
            17.1302,
            52.308826,
            119.602395
          ],
          [
            17.130492,
            52.308663,
            119.51907
          ],
          [
            17.130754,
            52.308493,
            119.438553
          ],
          [
            17.130999,
            52.308322,
            119.360141
          ],
          [
            17.131261,
            52.308164,
            119.283709
          ],
          [
            17.131532,
            52.30803,
            119.232353
          ],
          [
            17.131759,
            52.307891,
            119.185002
          ],
          [
            17.132004,
            52.307757,
            119.136412
          ],
          [
            17.13228,
            52.307599,
            119.080676
          ],
          [
            17.132569,
            52.307471,
            119.028001
          ],
          [
            17.132856,
            52.307318,
            118.971894
          ],
          [
            17.133088,
            52.307182,
            118.924509
          ],
          [
            17.133326,
            52.307047,
            118.87666
          ],
          [
            17.133557,
            52.306913,
            118.880069
          ],
          [
            17.13382,
            52.30677,
            118.941202
          ],
          [
            17.134038,
            52.306638,
            118.994467
          ],
          [
            17.134273,
            52.306516,
            119.048176
          ],
          [
            17.134495,
            52.306369,
            119.105012
          ],
          [
            17.13472,
            52.306236,
            119.159446
          ],
          [
            17.135006,
            52.306084,
            119.225245
          ],
          [
            17.135289,
            52.305921,
            119.292841
          ],
          [
            17.135562,
            52.305752,
            119.360292
          ],
          [
            17.135805,
            52.305612,
            119.030909
          ],
          [
            17.136026,
            52.305479,
            118.70503
          ],
          [
            17.136285,
            52.305352,
            118.356084
          ],
          [
            17.136587,
            52.305166,
            117.905155
          ],
          [
            17.136847,
            52.305007,
            117.518655
          ],
          [
            17.137087,
            52.304861,
            117.162774
          ],
          [
            17.137303,
            52.304713,
            116.821861
          ],
          [
            17.137591,
            52.304556,
            116.416096
          ],
          [
            17.137883,
            52.304419,
            116.484395
          ],
          [
            17.13811,
            52.30428,
            116.778661
          ],
          [
            17.138345,
            52.304131,
            117.089813
          ],
          [
            17.138574,
            52.303979,
            117.399391
          ],
          [
            17.138812,
            52.303855,
            117.685849
          ],
          [
            17.139063,
            52.303694,
            118.01912
          ],
          [
            17.139316,
            52.303547,
            118.338784
          ],
          [
            17.139564,
            52.3034,
            118.65564
          ],
          [
            17.139823,
            52.303244,
            118.967215
          ],
          [
            17.140084,
            52.303105,
            118.978626
          ],
          [
            17.140372,
            52.302924,
            118.992245
          ],
          [
            17.140663,
            52.30276,
            119.005292
          ],
          [
            17.140975,
            52.302582,
            119.019361
          ],
          [
            17.141246,
            52.302426,
            119.031634
          ],
          [
            17.14149,
            52.302288,
            119.042595
          ],
          [
            17.14174,
            52.302156,
            119.0535
          ],
          [
            17.141982,
            52.302014,
            119.039297
          ],
          [
            17.142239,
            52.301862,
            118.799381
          ],
          [
            17.142509,
            52.301694,
            118.540628
          ],
          [
            17.142768,
            52.301522,
            118.284192
          ],
          [
            17.143034,
            52.301372,
            118.041509
          ],
          [
            17.14328,
            52.301222,
            117.807934
          ],
          [
            17.143551,
            52.301061,
            117.554315
          ],
          [
            17.143843,
            52.300904,
            117.29325
          ],
          [
            17.14406,
            52.300763,
            117.098828
          ],
          [
            17.14432,
            52.300618,
            117.28807
          ],
          [
            17.144567,
            52.300486,
            117.464396
          ],
          [
            17.144798,
            52.300337,
            117.645015
          ],
          [
            17.145035,
            52.300176,
            117.83543
          ],
          [
            17.145329,
            52.300016,
            118.046977
          ],
          [
            17.145613,
            52.299854,
            118.257054
          ],
          [
            17.145872,
            52.299714,
            118.442866
          ],
          [
            17.146133,
            52.299564,
            118.635601
          ],
          [
            17.146372,
            52.299431,
            118.767336
          ],
          [
            17.146544,
            52.299282,
            118.879785
          ],
          [
            17.146828,
            52.299126,
            119.022264
          ],
          [
            17.147139,
            52.299007,
            119.159179
          ],
          [
            17.147394,
            52.298827,
            119.30454
          ],
          [
            17.147665,
            52.298666,
            119.445512
          ],
          [
            17.147965,
            52.298463,
            119.612499
          ],
          [
            17.148253,
            52.298291,
            119.762858
          ],
          [
            17.148531,
            52.298143,
            120.00402
          ],
          [
            17.1488,
            52.297991,
            120.24836
          ],
          [
            17.149083,
            52.297822,
            120.512291
          ],
          [
            17.149373,
            52.297658,
            120.775805
          ],
          [
            17.149648,
            52.297487,
            121.037488
          ],
          [
            17.149945,
            52.297319,
            121.307466
          ],
          [
            17.150265,
            52.297141,
            121.596059
          ],
          [
            17.150516,
            52.296985,
            121.745368
          ],
          [
            17.150816,
            52.296812,
            121.783285
          ],
          [
            17.151083,
            52.29666,
            121.816838
          ],
          [
            17.151354,
            52.296517,
            121.849763
          ],
          [
            17.151641,
            52.296347,
            121.886561
          ],
          [
            17.151918,
            52.296171,
            121.923293
          ],
          [
            17.152215,
            52.295998,
            121.961076
          ],
          [
            17.152502,
            52.295857,
            121.994971
          ],
          [
            17.152795,
            52.295694,
            121.977357
          ],
          [
            17.153184,
            52.295616,
            121.946945
          ],
          [
            17.153592,
            52.295564,
            121.916147
          ],
          [
            17.153971,
            52.295512,
            121.887313
          ],
          [
            17.154294,
            52.295445,
            121.862074
          ],
          [
            17.154611,
            52.295383,
            121.837468
          ],
          [
            17.154945,
            52.295313,
            121.811372
          ],
          [
            17.155272,
            52.295251,
            121.78594
          ],
          [
            17.155586,
            52.295177,
            121.80857
          ],
          [
            17.155914,
            52.295098,
            121.836068
          ],
          [
            17.156211,
            52.29503,
            121.860783
          ],
          [
            17.156507,
            52.294973,
            121.884969
          ],
          [
            17.156798,
            52.294906,
            121.909228
          ],
          [
            17.1571,
            52.29485,
            121.933845
          ],
          [
            17.157397,
            52.294801,
            121.957869
          ],
          [
            17.15769,
            52.294708,
            121.983598
          ],
          [
            17.157976,
            52.294625,
            122.008275
          ],
          [
            17.158277,
            52.294541,
            122.120799
          ],
          [
            17.158552,
            52.29446,
            122.244515
          ],
          [
            17.158807,
            52.294361,
            122.366721
          ],
          [
            17.159127,
            52.29425,
            122.515579
          ],
          [
            17.159396,
            52.294146,
            122.644725
          ],
          [
            17.159744,
            52.294042,
            122.80144
          ],
          [
            17.160014,
            52.293949,
            122.926974
          ],
          [
            17.160315,
            52.293823,
            123.074553
          ],
          [
            17.160572,
            52.293691,
            123.218748
          ],
          [
            17.160736,
            52.293536,
            123.491306
          ],
          [
            17.160832,
            52.293335,
            123.793513
          ],
          [
            17.160917,
            52.293159,
            124.05794
          ],
          [
            17.160991,
            52.292956,
            124.357528
          ],
          [
            17.161076,
            52.292739,
            124.679426
          ],
          [
            17.16119,
            52.292537,
            124.987646
          ],
          [
            17.16127,
            52.292335,
            125.287436
          ],
          [
            17.161346,
            52.292146,
            125.568417
          ],
          [
            17.161455,
            52.291928,
            125.742764
          ],
          [
            17.161558,
            52.291713,
            125.581783
          ],
          [
            17.161652,
            52.291483,
            125.411589
          ],
          [
            17.161732,
            52.291259,
            125.247027
          ],
          [
            17.161825,
            52.291048,
            125.090145
          ],
          [
            17.161897,
            52.290853,
            124.946703
          ],
          [
            17.161981,
            52.290649,
            124.795506
          ],
          [
            17.162083,
            52.290431,
            124.632735
          ],
          [
            17.162186,
            52.290206,
            124.410325
          ],
          [
            17.162275,
            52.289984,
            124.012327
          ],
          [
            17.162379,
            52.28978,
            123.64029
          ],
          [
            17.16245,
            52.289573,
            123.272054
          ],
          [
            17.162536,
            52.289342,
            122.859258
          ],
          [
            17.162632,
            52.289132,
            122.479018
          ],
          [
            17.162706,
            52.28891,
            122.082969
          ],
          [
            17.16281,
            52.288697,
            121.695895
          ],
          [
            17.162899,
            52.288475,
            121.408212
          ],
          [
            17.162996,
            52.288258,
            121.599941
          ],
          [
            17.163083,
            52.288018,
            121.809798
          ],
          [
            17.163178,
            52.287796,
            122.005451
          ],
          [
            17.163269,
            52.287575,
            122.200261
          ],
          [
            17.163362,
            52.287354,
            122.394761
          ],
          [
            17.163456,
            52.28716,
            122.567707
          ],
          [
            17.163554,
            52.286944,
            122.75873
          ],
          [
            17.163657,
            52.28673,
            122.975768
          ],
          [
            17.163761,
            52.286516,
            123.280843
          ],
          [
            17.163855,
            52.286316,
            123.565205
          ],
          [
            17.163931,
            52.286109,
            123.855117
          ],
          [
            17.164017,
            52.285902,
            124.14708
          ],
          [
            17.164111,
            52.285672,
            124.471041
          ],
          [
            17.164212,
            52.285473,
            124.755896
          ],
          [
            17.164306,
            52.285289,
            125.019551
          ],
          [
            17.164384,
            52.285065,
            125.332682
          ],
          [
            17.164484,
            52.284865,
            125.582778
          ],
          [
            17.164575,
            52.284676,
            125.814897
          ],
          [
            17.164663,
            52.28448,
            126.053887
          ],
          [
            17.164771,
            52.284286,
            126.295074
          ],
          [
            17.164865,
            52.284059,
            126.570582
          ],
          [
            17.164946,
            52.283872,
            126.798403
          ],
          [
            17.165038,
            52.283673,
            127.0421
          ],
          [
            17.165154,
            52.283445,
            127.322861
          ],
          [
            17.165225,
            52.283238,
            127.417758
          ],
          [
            17.165295,
            52.283046,
            127.274998
          ],
          [
            17.165381,
            52.282845,
            127.124622
          ],
          [
            17.165468,
            52.282628,
            126.962761
          ],
          [
            17.165562,
            52.282425,
            126.810009
          ],
          [
            17.165647,
            52.282206,
            126.647098
          ],
          [
            17.165752,
            52.281992,
            126.485214
          ],
          [
            17.165838,
            52.281787,
            126.331135
          ],
          [
            17.165939,
            52.281589,
            126.180949
          ],
          [
            17.166017,
            52.281394,
            126.000831
          ],
          [
            17.166095,
            52.281186,
            125.808957
          ],
          [
            17.166205,
            52.280941,
            125.580542
          ],
          [
            17.166289,
            52.280721,
            125.377373
          ],
          [
            17.166371,
            52.28051,
            125.182385
          ],
          [
            17.166491,
            52.280282,
            124.966998
          ],
          [
            17.166614,
            52.280056,
            124.752833
          ],
          [
            17.166703,
            52.27982,
            124.499318
          ],
          [
            17.166814,
            52.279598,
            123.97529
          ],
          [
            17.166896,
            52.279368,
            123.443834
          ],
          [
            17.166988,
            52.27912,
            122.869769
          ],
          [
            17.167051,
            52.278883,
            122.327228
          ],
          [
            17.167156,
            52.278693,
            121.874657
          ],
          [
            17.167258,
            52.278466,
            121.343414
          ],
          [
            17.167356,
            52.278243,
            120.822066
          ],
          [
            17.167435,
            52.277983,
            120.542507
          ],
          [
            17.167586,
            52.277778,
            120.620418
          ],
          [
            17.167646,
            52.277579,
            120.690519
          ],
          [
            17.167734,
            52.277384,
            120.760608
          ],
          [
            17.167815,
            52.277192,
            120.829308
          ],
          [
            17.167903,
            52.276995,
            120.900071
          ],
          [
            17.167991,
            52.276801,
            120.969822
          ],
          [
            17.168062,
            52.276597,
            121.042082
          ],
          [
            17.16814,
            52.276392,
            121.115014
          ],
          [
            17.168252,
            52.276213,
            121.08375
          ],
          [
            17.168349,
            52.276012,
            121.034789
          ],
          [
            17.168439,
            52.27577,
            120.976681
          ],
          [
            17.168518,
            52.275582,
            120.931322
          ],
          [
            17.1686,
            52.275365,
            120.879259
          ],
          [
            17.168649,
            52.275166,
            120.832024
          ],
          [
            17.168764,
            52.27498,
            120.78528
          ],
          [
            17.168862,
            52.274786,
            120.737839
          ],
          [
            17.168909,
            52.274575,
            120.789915
          ],
          [
            17.16899,
            52.274364,
            121.083819
          ],
          [
            17.169066,
            52.274176,
            121.345888
          ],
          [
            17.169147,
            52.273996,
            121.598589
          ],
          [
            17.169252,
            52.273793,
            121.886821
          ],
          [
            17.169347,
            52.273591,
            122.171566
          ],
          [
            17.169424,
            52.273409,
            122.425961
          ],
          [
            17.169522,
            52.27321,
            122.707248
          ],
          [
            17.169602,
            52.273002,
            122.996542
          ],
          [
            17.16968,
            52.272799,
            123.111027
          ],
          [
            17.169765,
            52.272594,
            123.059317
          ],
          [
            17.169856,
            52.272393,
            123.008324
          ],
          [
            17.169938,
            52.272198,
            122.959081
          ],
          [
            17.17002,
            52.272004,
            122.910104
          ],
          [
            17.170105,
            52.271816,
            122.862358
          ],
          [
            17.170167,
            52.271607,
            122.810172
          ],
          [
            17.170099,
            52.271417,
            122.761159
          ],
          [
            17.169919,
            52.271236,
            122.708931
          ],
          [
            17.170217,
            52.271211,
            122.697126
          ],
          [
            17.170523,
            52.271155,
            122.697126
          ],
          [
            17.170789,
            52.271116,
            122.697126
          ],
          [
            17.171128,
            52.271021,
            122.697126
          ],
          [
            17.171127,
            52.271031,
            122.697126
          ],
          [
            17.170845,
            52.271109,
            122.697126
          ],
          [
            17.170619,
            52.271233,
            122.697126
          ],
          [
            17.170463,
            52.271398,
            122.697126
          ],
          [
            17.170325,
            52.271575,
            122.697126
          ],
          [
            17.170058,
            52.271618,
            122.697126
          ],
          [
            17.169796,
            52.271723,
            122.697126
          ],
          [
            17.169581,
            52.271836,
            122.697126
          ],
          [
            17.169281,
            52.271831,
            122.697126
          ],
          [
            17.169479,
            52.271827,
            122.697126
          ]
        ]
      }
    }
  ]
}

let day49: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            17.169424,
            52.271813,
            118.81792
          ],
          [
            17.169727,
            52.271773,
            118.81792
          ],
          [
            17.170023,
            52.271714,
            118.81792
          ],
          [
            17.170136,
            52.271549,
            118.81792
          ],
          [
            17.170007,
            52.271363,
            118.81792
          ],
          [
            17.169857,
            52.271202,
            118.742688
          ],
          [
            17.169693,
            52.271005,
            118.519233
          ],
          [
            17.169501,
            52.270813,
            118.291148
          ],
          [
            17.169341,
            52.27061,
            118.063655
          ],
          [
            17.169205,
            52.270417,
            117.850857
          ],
          [
            17.169025,
            52.270202,
            117.606742
          ],
          [
            17.168847,
            52.269991,
            117.367056
          ],
          [
            17.168891,
            52.269746,
            117.116035
          ],
          [
            17.168994,
            52.269571,
            116.834941
          ],
          [
            17.169119,
            52.26935,
            116.299679
          ],
          [
            17.169262,
            52.269158,
            115.818693
          ],
          [
            17.169438,
            52.268984,
            115.351712
          ],
          [
            17.169641,
            52.268794,
            114.834314
          ],
          [
            17.169866,
            52.268604,
            114.29945
          ],
          [
            17.170122,
            52.268459,
            113.810225
          ],
          [
            17.170369,
            52.268283,
            113.281287
          ],
          [
            17.170597,
            52.268163,
            112.880745
          ],
          [
            17.170879,
            52.268043,
            112.62624
          ],
          [
            17.171158,
            52.267856,
            112.321007
          ],
          [
            17.171442,
            52.267716,
            112.052069
          ],
          [
            17.171684,
            52.267556,
            111.7884
          ],
          [
            17.171969,
            52.267374,
            111.484549
          ],
          [
            17.172233,
            52.267174,
            111.174686
          ],
          [
            17.172431,
            52.26703,
            110.947134
          ],
          [
            17.172654,
            52.266849,
            110.734015
          ],
          [
            17.172877,
            52.266638,
            110.725213
          ],
          [
            17.173091,
            52.266467,
            110.717667
          ],
          [
            17.173352,
            52.266278,
            110.708999
          ],
          [
            17.173564,
            52.266101,
            110.701311
          ],
          [
            17.173859,
            52.265977,
            110.69362
          ],
          [
            17.174158,
            52.265848,
            110.685776
          ],
          [
            17.174404,
            52.265721,
            110.678858
          ],
          [
            17.174659,
            52.265592,
            110.73772
          ],
          [
            17.174923,
            52.265482,
            111.157194
          ],
          [
            17.175179,
            52.265372,
            111.567942
          ],
          [
            17.175465,
            52.265255,
            112.019703
          ],
          [
            17.175755,
            52.265115,
            112.504472
          ],
          [
            17.176024,
            52.264989,
            112.951385
          ],
          [
            17.176329,
            52.264853,
            113.447217
          ],
          [
            17.176611,
            52.264754,
            113.876574
          ],
          [
            17.176904,
            52.264661,
            114.310162
          ],
          [
            17.177162,
            52.264557,
            114.720678
          ],
          [
            17.177471,
            52.264418,
            115.237236
          ],
          [
            17.177774,
            52.264313,
            115.706542
          ],
          [
            17.178034,
            52.264181,
            116.161443
          ],
          [
            17.178308,
            52.264062,
            116.614376
          ],
          [
            17.178629,
            52.263943,
            117.119695
          ],
          [
            17.178961,
            52.263801,
            117.665029
          ],
          [
            17.179262,
            52.263677,
            118.153543
          ],
          [
            17.179547,
            52.263558,
            118.474559
          ],
          [
            17.17983,
            52.263453,
            118.433309
          ],
          [
            17.18008,
            52.263327,
            118.392923
          ],
          [
            17.180361,
            52.263199,
            118.349261
          ],
          [
            17.180643,
            52.263094,
            118.308103
          ],
          [
            17.180932,
            52.262979,
            118.2651
          ],
          [
            17.18122,
            52.262867,
            118.222292
          ],
          [
            17.181558,
            52.26275,
            118.173412
          ],
          [
            17.181834,
            52.262639,
            118.13228
          ],
          [
            17.182104,
            52.262522,
            118.210783
          ],
          [
            17.182411,
            52.26242,
            118.342948
          ],
          [
            17.182655,
            52.262302,
            118.460607
          ],
          [
            17.182937,
            52.262174,
            118.593512
          ],
          [
            17.183216,
            52.262071,
            118.71679
          ],
          [
            17.183516,
            52.261937,
            118.857354
          ],
          [
            17.183782,
            52.261831,
            118.977763
          ],
          [
            17.18406,
            52.261721,
            119.10303
          ],
          [
            17.184311,
            52.261597,
            119.225158
          ],
          [
            17.184587,
            52.261475,
            119.368802
          ],
          [
            17.184874,
            52.261376,
            119.508224
          ],
          [
            17.185141,
            52.261244,
            119.65328
          ],
          [
            17.185379,
            52.261123,
            119.784089
          ],
          [
            17.185693,
            52.261001,
            119.941269
          ],
          [
            17.185996,
            52.260892,
            120.089801
          ],
          [
            17.186246,
            52.260777,
            120.221987
          ],
          [
            17.186503,
            52.260655,
            120.359439
          ],
          [
            17.186807,
            52.260544,
            120.46937
          ],
          [
            17.187111,
            52.260423,
            120.446566
          ],
          [
            17.187416,
            52.260286,
            120.422761
          ],
          [
            17.187722,
            52.260143,
            120.398466
          ],
          [
            17.188022,
            52.260021,
            120.375802
          ],
          [
            17.188281,
            52.259907,
            120.35574
          ],
          [
            17.188555,
            52.259812,
            120.335929
          ],
          [
            17.188842,
            52.259728,
            120.31593
          ],
          [
            17.189065,
            52.259584,
            120.295533
          ],
          [
            17.189372,
            52.259471,
            120.319526
          ],
          [
            17.189629,
            52.259353,
            120.35538
          ],
          [
            17.189913,
            52.259259,
            120.391409
          ],
          [
            17.190231,
            52.259128,
            120.434195
          ],
          [
            17.190499,
            52.258985,
            120.473859
          ],
          [
            17.190739,
            52.258851,
            120.510114
          ],
          [
            17.191066,
            52.258767,
            120.549678
          ],
          [
            17.19135,
            52.258673,
            120.586033
          ],
          [
            17.19161,
            52.258531,
            120.639991
          ],
          [
            17.191893,
            52.258412,
            120.758093
          ],
          [
            17.192232,
            52.258304,
            120.888859
          ],
          [
            17.192494,
            52.258184,
            121.000912
          ],
          [
            17.192751,
            52.258059,
            121.113324
          ],
          [
            17.193045,
            52.257956,
            121.229147
          ],
          [
            17.193337,
            52.257825,
            121.353344
          ],
          [
            17.19364,
            52.257699,
            121.47859
          ],
          [
            17.193933,
            52.257555,
            121.607107
          ],
          [
            17.194233,
            52.257423,
            121.54543
          ],
          [
            17.194563,
            52.257311,
            121.456437
          ],
          [
            17.194903,
            52.257172,
            121.360035
          ],
          [
            17.195225,
            52.257042,
            121.269168
          ],
          [
            17.195546,
            52.25692,
            121.180192
          ],
          [
            17.19582,
            52.2568,
            121.100798
          ],
          [
            17.19612,
            52.256692,
            121.018839
          ],
          [
            17.196417,
            52.256568,
            120.933773
          ],
          [
            17.196665,
            52.25642,
            120.625258
          ],
          [
            17.196962,
            52.2563,
            120.298389
          ],
          [
            17.197221,
            52.256188,
            120.005669
          ],
          [
            17.197493,
            52.25606,
            119.690219
          ],
          [
            17.197828,
            52.255945,
            119.337636
          ],
          [
            17.19809,
            52.255848,
            119.056054
          ],
          [
            17.198406,
            52.255726,
            118.711203
          ],
          [
            17.198717,
            52.255564,
            118.334498
          ],
          [
            17.198993,
            52.25548,
            118.335354
          ],
          [
            17.199274,
            52.255357,
            118.510174
          ],
          [
            17.199553,
            52.255234,
            118.684082
          ],
          [
            17.199825,
            52.255112,
            118.854755
          ],
          [
            17.200118,
            52.254969,
            119.044612
          ],
          [
            17.200425,
            52.254848,
            119.230443
          ],
          [
            17.200675,
            52.254723,
            119.393759
          ],
          [
            17.200909,
            52.254598,
            119.55127
          ],
          [
            17.201211,
            52.254467,
            119.721639
          ],
          [
            17.201475,
            52.254341,
            119.733249
          ],
          [
            17.201732,
            52.254232,
            119.74411
          ],
          [
            17.202103,
            52.254024,
            119.761558
          ],
          [
            17.202368,
            52.253887,
            119.773588
          ],
          [
            17.202648,
            52.253772,
            119.785312
          ],
          [
            17.202917,
            52.25363,
            119.797633
          ],
          [
            17.203193,
            52.253508,
            119.809448
          ],
          [
            17.203433,
            52.253386,
            119.820431
          ],
          [
            17.203685,
            52.25325,
            119.872588
          ],
          [
            17.203947,
            52.253137,
            119.929685
          ],
          [
            17.204281,
            52.252997,
            120.001742
          ],
          [
            17.204607,
            52.252878,
            120.069342
          ],
          [
            17.204944,
            52.252789,
            120.134691
          ],
          [
            17.205278,
            52.252725,
            120.197195
          ],
          [
            17.205615,
            52.252663,
            120.259847
          ],
          [
            17.205938,
            52.252607,
            120.31967
          ],
          [
            17.206251,
            52.252526,
            120.253937
          ],
          [
            17.206575,
            52.252461,
            120.094962
          ],
          [
            17.206875,
            52.252405,
            119.948409
          ],
          [
            17.207196,
            52.252342,
            119.791408
          ],
          [
            17.207568,
            52.252291,
            119.613849
          ],
          [
            17.207889,
            52.252213,
            119.453003
          ],
          [
            17.208245,
            52.252155,
            119.281365
          ],
          [
            17.208587,
            52.252096,
            119.11588
          ],
          [
            17.20892,
            52.252046,
            118.984485
          ],
          [
            17.209231,
            52.251987,
            119.039706
          ],
          [
            17.209566,
            52.251917,
            119.099317
          ],
          [
            17.209929,
            52.251894,
            119.161248
          ],
          [
            17.210225,
            52.251787,
            119.219128
          ],
          [
            17.210527,
            52.25171,
            119.274304
          ],
          [
            17.210817,
            52.251644,
            119.326394
          ],
          [
            17.211108,
            52.25159,
            119.377587
          ],
          [
            17.211409,
            52.251533,
            119.430636
          ],
          [
            17.211709,
            52.251479,
            119.54477
          ],
          [
            17.212007,
            52.251416,
            119.876124
          ],
          [
            17.21234,
            52.25136,
            120.239156
          ],
          [
            17.212657,
            52.25131,
            120.583223
          ],
          [
            17.212947,
            52.251246,
            120.90872
          ],
          [
            17.213259,
            52.251191,
            121.249975
          ],
          [
            17.213583,
            52.251125,
            121.609019
          ],
          [
            17.213918,
            52.251061,
            121.977861
          ],
          [
            17.214265,
            52.251003,
            122.356653
          ],
          [
            17.21456,
            52.250931,
            122.54143
          ],
          [
            17.214882,
            52.250887,
            122.493508
          ],
          [
            17.215239,
            52.250819,
            122.43922
          ],
          [
            17.215577,
            52.250755,
            122.387827
          ],
          [
            17.215921,
            52.250687,
            122.335227
          ],
          [
            17.216231,
            52.250644,
            122.288349
          ],
          [
            17.216545,
            52.250578,
            122.240121
          ],
          [
            17.21686,
            52.250529,
            122.192865
          ],
          [
            17.217155,
            52.25046,
            122.146965
          ],
          [
            17.217509,
            52.250387,
            121.978895
          ],
          [
            17.217822,
            52.250312,
            121.792409
          ],
          [
            17.218121,
            52.250201,
            121.597531
          ],
          [
            17.218413,
            52.250078,
            121.400876
          ],
          [
            17.218719,
            52.249949,
            121.194181
          ],
          [
            17.219063,
            52.24981,
            120.965141
          ],
          [
            17.219375,
            52.249652,
            120.73958
          ],
          [
            17.219714,
            52.249521,
            120.516951
          ],
          [
            17.220041,
            52.249382,
            120.24647
          ],
          [
            17.220369,
            52.249244,
            119.972306
          ],
          [
            17.220652,
            52.249102,
            119.72071
          ],
          [
            17.220942,
            52.248961,
            119.466075
          ],
          [
            17.221226,
            52.24884,
            119.227729
          ],
          [
            17.22152,
            52.248715,
            118.979887
          ],
          [
            17.221854,
            52.248559,
            118.690265
          ],
          [
            17.22215,
            52.248439,
            118.517034
          ],
          [
            17.222206,
            52.248461,
            118.719586
          ],
          [
            17.222176,
            52.248474,
            118.930679
          ],
          [
            17.222433,
            52.248363,
            119.132259
          ],
          [
            17.222737,
            52.24826,
            119.353267
          ],
          [
            17.223061,
            52.24814,
            119.594156
          ],
          [
            17.223368,
            52.248043,
            119.814003
          ],
          [
            17.223654,
            52.247942,
            120.024179
          ],
          [
            17.223941,
            52.247848,
            120.231215
          ],
          [
            17.224216,
            52.247745,
            120.16097
          ],
          [
            17.224518,
            52.247648,
            119.673202
          ],
          [
            17.224781,
            52.247557,
            119.239422
          ],
          [
            17.225049,
            52.247462,
            118.796143
          ],
          [
            17.22534,
            52.247383,
            118.340889
          ],
          [
            17.225643,
            52.247279,
            117.843905
          ],
          [
            17.225948,
            52.247166,
            117.333964
          ],
          [
            17.226265,
            52.24707,
            116.828258
          ],
          [
            17.226605,
            52.246961,
            116.279463
          ],
          [
            17.226923,
            52.24685,
            116.586363
          ],
          [
            17.227246,
            52.246741,
            117.168291
          ],
          [
            17.227558,
            52.246636,
            117.729804
          ],
          [
            17.227853,
            52.246521,
            118.282107
          ],
          [
            17.228134,
            52.246405,
            118.816782
          ],
          [
            17.22842,
            52.24629,
            119.357192
          ],
          [
            17.22873,
            52.246174,
            119.930139
          ],
          [
            17.229069,
            52.246054,
            120.547939
          ],
          [
            17.229404,
            52.245923,
            120.979408
          ],
          [
            17.229724,
            52.245791,
            121.283962
          ],
          [
            17.230045,
            52.245667,
            121.583478
          ],
          [
            17.230364,
            52.245534,
            121.888048
          ],
          [
            17.230681,
            52.245402,
            122.190657
          ],
          [
            17.230977,
            52.245273,
            122.477397
          ],
          [
            17.231271,
            52.245159,
            122.752263
          ],
          [
            17.231616,
            52.245028,
            123.07263
          ],
          [
            17.231936,
            52.244898,
            123.040911
          ],
          [
            17.23223,
            52.244781,
            122.979642
          ],
          [
            17.232549,
            52.244644,
            122.911561
          ],
          [
            17.232871,
            52.244501,
            122.842029
          ],
          [
            17.233189,
            52.244371,
            122.774938
          ],
          [
            17.233516,
            52.244242,
            122.706976
          ],
          [
            17.233835,
            52.244126,
            122.642153
          ],
          [
            17.234147,
            52.243981,
            122.608517
          ],
          [
            17.234417,
            52.24388,
            122.683005
          ],
          [
            17.234684,
            52.243772,
            122.758408
          ],
          [
            17.234998,
            52.243644,
            122.847243
          ],
          [
            17.235307,
            52.243518,
            122.934639
          ],
          [
            17.235612,
            52.243378,
            123.024766
          ],
          [
            17.23598,
            52.243247,
            123.124938
          ],
          [
            17.236274,
            52.243146,
            123.204353
          ],
          [
            17.236545,
            52.243019,
            123.271506
          ],
          [
            17.236817,
            52.242907,
            123.151549
          ],
          [
            17.237029,
            52.242774,
            123.040445
          ],
          [
            17.237304,
            52.242648,
            122.914763
          ],
          [
            17.23759,
            52.242523,
            122.785852
          ],
          [
            17.23791,
            52.242427,
            122.655426
          ],
          [
            17.238192,
            52.242316,
            122.532649
          ],
          [
            17.238459,
            52.242207,
            122.414557
          ],
          [
            17.238761,
            52.242084,
            122.281765
          ],
          [
            17.239098,
            52.241952,
            122.308199
          ],
          [
            17.239388,
            52.241827,
            122.501503
          ],
          [
            17.239726,
            52.241714,
            122.711059
          ],
          [
            17.239994,
            52.241594,
            122.891725
          ],
          [
            17.240281,
            52.24148,
            123.078172
          ],
          [
            17.240538,
            52.241372,
            123.247797
          ],
          [
            17.240876,
            52.241268,
            123.454372
          ],
          [
            17.241228,
            52.241183,
            123.660458
          ],
          [
            17.241527,
            52.241045,
            123.684558
          ],
          [
            17.241828,
            52.240931,
            123.309201
          ],
          [
            17.242135,
            52.24082,
            122.931315
          ],
          [
            17.242415,
            52.240708,
            122.576751
          ],
          [
            17.242744,
            52.240588,
            122.169374
          ],
          [
            17.243008,
            52.2405,
            121.850743
          ],
          [
            17.243309,
            52.240372,
            121.461734
          ],
          [
            17.243578,
            52.240262,
            121.118601
          ],
          [
            17.24392,
            52.24014,
            120.698959
          ],
          [
            17.244255,
            52.240033,
            120.155074
          ],
          [
            17.244567,
            52.239917,
            119.627976
          ],
          [
            17.244871,
            52.239823,
            119.13587
          ],
          [
            17.245126,
            52.23971,
            118.681285
          ],
          [
            17.245441,
            52.239601,
            118.158341
          ],
          [
            17.245733,
            52.239496,
            117.669236
          ],
          [
            17.246021,
            52.239399,
            117.194213
          ],
          [
            17.24635,
            52.239286,
            116.648878
          ],
          [
            17.246685,
            52.239146,
            116.422427
          ],
          [
            17.246973,
            52.239054,
            116.390884
          ],
          [
            17.247254,
            52.238928,
            116.357055
          ],
          [
            17.247544,
            52.238827,
            116.32464
          ],
          [
            17.247887,
            52.238698,
            116.285544
          ],
          [
            17.248155,
            52.238604,
            116.255557
          ],
          [
            17.248467,
            52.238493,
            116.220496
          ],
          [
            17.248742,
            52.2384,
            116.189992
          ],
          [
            17.249031,
            52.2383,
            116.185269
          ],
          [
            17.249308,
            52.2382,
            116.312667
          ],
          [
            17.249582,
            52.238084,
            116.444588
          ],
          [
            17.249887,
            52.237965,
            116.589407
          ],
          [
            17.250162,
            52.237862,
            116.717074
          ],
          [
            17.250516,
            52.237732,
            116.88056
          ],
          [
            17.250805,
            52.237606,
            117.021396
          ],
          [
            17.251104,
            52.237512,
            117.154599
          ],
          [
            17.251446,
            52.237391,
            117.311115
          ],
          [
            17.251706,
            52.237296,
            117.627126
          ],
          [
            17.251995,
            52.237179,
            118.01578
          ],
          [
            17.252336,
            52.237053,
            118.463705
          ],
          [
            17.252616,
            52.236941,
            118.839645
          ],
          [
            17.252905,
            52.236823,
            119.230905
          ],
          [
            17.253205,
            52.236733,
            119.605767
          ],
          [
            17.253539,
            52.236621,
            120.033012
          ],
          [
            17.253785,
            52.236497,
            120.394497
          ],
          [
            17.254095,
            52.236413,
            120.612459
          ],
          [
            17.254388,
            52.236304,
            120.590638
          ],
          [
            17.254698,
            52.236203,
            120.568246
          ],
          [
            17.254987,
            52.236096,
            120.546748
          ],
          [
            17.255269,
            52.236004,
            120.526408
          ],
          [
            17.255554,
            52.235912,
            120.505903
          ],
          [
            17.255836,
            52.235797,
            120.484284
          ],
          [
            17.256183,
            52.235663,
            120.458172
          ],
          [
            17.256464,
            52.235551,
            120.436834
          ],
          [
            17.256741,
            52.235446,
            120.411449
          ],
          [
            17.257017,
            52.235326,
            120.384425
          ],
          [
            17.257296,
            52.235235,
            120.359047
          ],
          [
            17.257654,
            52.235137,
            120.327717
          ],
          [
            17.257956,
            52.235001,
            120.297789
          ],
          [
            17.258247,
            52.234886,
            120.270141
          ],
          [
            17.258546,
            52.234793,
            120.24336
          ],
          [
            17.258829,
            52.234686,
            120.216809
          ],
          [
            17.259104,
            52.234577,
            120.240825
          ],
          [
            17.259381,
            52.234476,
            120.356074
          ],
          [
            17.259689,
            52.234362,
            120.484685
          ],
          [
            17.259963,
            52.234255,
            120.600831
          ],
          [
            17.260282,
            52.234174,
            120.72459
          ],
          [
            17.260568,
            52.234064,
            120.845388
          ],
          [
            17.260868,
            52.233955,
            120.970066
          ],
          [
            17.26117,
            52.233844,
            121.096087
          ],
          [
            17.261444,
            52.233712,
            121.221423
          ],
          [
            17.261776,
            52.233604,
            121.384268
          ],
          [
            17.262097,
            52.233493,
            121.550918
          ],
          [
            17.262411,
            52.23338,
            121.715684
          ],
          [
            17.262743,
            52.233259,
            121.890213
          ],
          [
            17.262945,
            52.23311,
            122.041177
          ],
          [
            17.263261,
            52.233038,
            122.197836
          ],
          [
            17.263562,
            52.232962,
            122.345788
          ],
          [
            17.263825,
            52.232849,
            122.490967
          ],
          [
            17.264132,
            52.232739,
            122.625234
          ],
          [
            17.264402,
            52.232641,
            122.7178
          ],
          [
            17.264706,
            52.232558,
            122.816364
          ],
          [
            17.264993,
            52.232452,
            122.915216
          ],
          [
            17.265104,
            52.232276,
            123.007942
          ],
          [
            17.265358,
            52.232155,
            123.11049
          ],
          [
            17.265682,
            52.232109,
            123.208598
          ],
          [
            17.265998,
            52.23202,
            123.313102
          ],
          [
            17.266041,
            52.231817,
            123.41171
          ],
          [
            17.266368,
            52.231811,
            123.533453
          ],
          [
            17.266683,
            52.231725,
            123.66957
          ],
          [
            17.26698,
            52.231604,
            123.804924
          ],
          [
            17.267249,
            52.2315,
            123.925265
          ],
          [
            17.267555,
            52.231414,
            124.052566
          ],
          [
            17.267859,
            52.23136,
            124.172179
          ],
          [
            17.268135,
            52.231237,
            124.30167
          ],
          [
            17.268383,
            52.231098,
            124.428965
          ],
          [
            17.268667,
            52.231018,
            124.547137
          ],
          [
            17.268957,
            52.230963,
            124.353077
          ],
          [
            17.269255,
            52.230869,
            124.137153
          ],
          [
            17.269537,
            52.23077,
            123.93011
          ],
          [
            17.269843,
            52.230645,
            123.696093
          ],
          [
            17.270109,
            52.230524,
            123.485258
          ],
          [
            17.270399,
            52.230421,
            123.272025
          ],
          [
            17.270692,
            52.230303,
            123.048796
          ],
          [
            17.27103,
            52.230205,
            122.810741
          ],
          [
            17.271308,
            52.230106,
            122.899515
          ],
          [
            17.271588,
            52.230103,
            123.454256
          ],
          [
            17.271914,
            52.230102,
            124.059839
          ],
          [
            17.272242,
            52.230062,
            124.651102
          ],
          [
            17.272558,
            52.230044,
            125.21226
          ],
          [
            17.272877,
            52.230002,
            125.797504
          ],
          [
            17.273054,
            52.229937,
            126.341218
          ],
          [
            17.273312,
            52.230028,
            126.937891
          ],
          [
            17.273607,
            52.230012,
            127.502834
          ],
          [
            17.273896,
            52.229929,
            127.878076
          ],
          [
            17.274168,
            52.229814,
            127.899748
          ],
          [
            17.274479,
            52.229753,
            127.9211
          ],
          [
            17.274788,
            52.229634,
            127.944991
          ],
          [
            17.275062,
            52.229548,
            127.965776
          ],
          [
            17.27532,
            52.229419,
            127.988038
          ],
          [
            17.275564,
            52.229289,
            128.009305
          ],
          [
            17.275873,
            52.229196,
            128.031799
          ],
          [
            17.276176,
            52.229135,
            128.052647
          ],
          [
            17.276426,
            52.228999,
            127.966587
          ],
          [
            17.276687,
            52.228875,
            127.793
          ],
          [
            17.276993,
            52.228772,
            127.610628
          ],
          [
            17.277293,
            52.228674,
            127.433276
          ],
          [
            17.277564,
            52.228562,
            127.261855
          ],
          [
            17.277846,
            52.228444,
            127.083513
          ],
          [
            17.278153,
            52.228322,
            126.891627
          ],
          [
            17.278425,
            52.228185,
            126.707838
          ],
          [
            17.278709,
            52.22807,
            126.531308
          ],
          [
            17.278988,
            52.22794,
            126.503653
          ],
          [
            17.279303,
            52.227829,
            126.474933
          ],
          [
            17.279558,
            52.227719,
            126.450223
          ],
          [
            17.279842,
            52.227657,
            126.424525
          ],
          [
            17.280032,
            52.227482,
            126.397438
          ],
          [
            17.280315,
            52.227361,
            126.370194
          ],
          [
            17.280591,
            52.227223,
            126.34207
          ],
          [
            17.280919,
            52.227069,
            126.309464
          ],
          [
            17.281246,
            52.22694,
            126.338671
          ],
          [
            17.281578,
            52.226801,
            126.397228
          ],
          [
            17.28188,
            52.226649,
            126.454122
          ],
          [
            17.282163,
            52.226516,
            126.506051
          ],
          [
            17.282445,
            52.226352,
            126.56281
          ],
          [
            17.282712,
            52.226157,
            126.623301
          ],
          [
            17.282904,
            52.225965,
            126.67703
          ],
          [
            17.283051,
            52.225732,
            126.678814
          ],
          [
            17.283268,
            52.225566,
            126.412483
          ],
          [
            17.283424,
            52.225392,
            126.164409
          ],
          [
            17.283697,
            52.225345,
            125.91241
          ],
          [
            17.283915,
            52.225516,
            125.641144
          ],
          [
            17.284261,
            52.225485,
            125.34935
          ],
          [
            17.28458,
            52.225352,
            125.053855
          ],
          [
            17.284891,
            52.225222,
            124.764953
          ],
          [
            17.285194,
            52.225075,
            124.47138
          ],
          [
            17.285515,
            52.224928,
            124.237032
          ],
          [
            17.285847,
            52.22479,
            124.002437
          ],
          [
            17.286103,
            52.224645,
            123.797234
          ],
          [
            17.286361,
            52.224563,
            123.608139
          ],
          [
            17.286656,
            52.224438,
            123.398576
          ],
          [
            17.286905,
            52.224338,
            123.224624
          ],
          [
            17.28728,
            52.224202,
            122.970016
          ],
          [
            17.287608,
            52.224077,
            122.752428
          ],
          [
            17.287877,
            52.223969,
            122.643935
          ],
          [
            17.288163,
            52.223862,
            122.530772
          ],
          [
            17.288456,
            52.223779,
            122.421871
          ],
          [
            17.288749,
            52.223705,
            122.314973
          ],
          [
            17.28903,
            52.223617,
            122.208389
          ],
          [
            17.289382,
            52.223543,
            122.082869
          ],
          [
            17.289766,
            52.22344,
            121.941348
          ],
          [
            17.290106,
            52.223351,
            121.816636
          ],
          [
            17.290398,
            52.223258,
            121.527886
          ],
          [
            17.290669,
            52.223172,
            121.157554
          ],
          [
            17.290969,
            52.223073,
            120.744263
          ],
          [
            17.291253,
            52.222984,
            120.357563
          ],
          [
            17.291559,
            52.222879,
            119.932185
          ],
          [
            17.291873,
            52.222788,
            119.511096
          ],
          [
            17.292202,
            52.222678,
            119.056774
          ],
          [
            17.292508,
            52.222585,
            118.641826
          ],
          [
            17.292834,
            52.222458,
            118.227135
          ],
          [
            17.293133,
            52.222332,
            118.358189
          ],
          [
            17.293417,
            52.222208,
            118.483846
          ],
          [
            17.293716,
            52.222097,
            118.609734
          ],
          [
            17.293998,
            52.221996,
            118.727369
          ],
          [
            17.294299,
            52.221889,
            118.852688
          ],
          [
            17.294628,
            52.221781,
            118.987114
          ],
          [
            17.294927,
            52.221658,
            119.116811
          ],
          [
            17.295259,
            52.22153,
            119.258085
          ],
          [
            17.295562,
            52.2214,
            119.146867
          ],
          [
            17.29587,
            52.221284,
            119.010141
          ],
          [
            17.29616,
            52.221154,
            118.874218
          ],
          [
            17.296455,
            52.221039,
            118.741986
          ],
          [
            17.296749,
            52.220921,
            118.609059
          ],
          [
            17.297033,
            52.220802,
            118.478885
          ],
          [
            17.29734,
            52.220682,
            118.341087
          ],
          [
            17.297611,
            52.220579,
            118.220486
          ],
          [
            17.297873,
            52.220471,
            117.873008
          ],
          [
            17.298159,
            52.220379,
            117.292645
          ],
          [
            17.298448,
            52.220265,
            116.674972
          ],
          [
            17.298773,
            52.220134,
            115.976079
          ],
          [
            17.29911,
            52.219999,
            115.252776
          ],
          [
            17.29945,
            52.219873,
            114.538972
          ],
          [
            17.299785,
            52.219732,
            113.808134
          ],
          [
            17.300109,
            52.219609,
            113.121927
          ],
          [
            17.300391,
            52.21951,
            113.072742
          ],
          [
            17.30065,
            52.219404,
            113.367984
          ],
          [
            17.300919,
            52.219314,
            113.658586
          ],
          [
            17.301201,
            52.219217,
            113.965739
          ],
          [
            17.301488,
            52.219092,
            114.299856
          ],
          [
            17.301804,
            52.21897,
            114.654006
          ],
          [
            17.302172,
            52.218834,
            115.061693
          ],
          [
            17.302436,
            52.218717,
            115.37089
          ],
          [
            17.302705,
            52.218603,
            115.687293
          ],
          [
            17.303005,
            52.218498,
            116.219471
          ],
          [
            17.303318,
            52.218373,
            116.794304
          ],
          [
            17.303645,
            52.218236,
            117.403424
          ],
          [
            17.303966,
            52.218113,
            117.986031
          ],
          [
            17.304281,
            52.217983,
            118.569998
          ],
          [
            17.304597,
            52.217857,
            119.149821
          ],
          [
            17.304901,
            52.21774,
            119.701825
          ],
          [
            17.305233,
            52.21766,
            120.329116
          ],
          [
            17.305589,
            52.21766,
            121.526285
          ],
          [
            17.305861,
            52.217762,
            122.603038
          ],
          [
            17.306099,
            52.217913,
            123.75044
          ],
          [
            17.306332,
            52.218069,
            124.905311
          ],
          [
            17.306565,
            52.218225,
            126.060348
          ],
          [
            17.306794,
            52.218391,
            127.247402
          ],
          [
            17.307022,
            52.218557,
            128.432289
          ],
          [
            17.307239,
            52.218727,
            129.610981
          ],
          [
            17.307483,
            52.218893,
            129.943308
          ],
          [
            17.307716,
            52.219082,
            129.842801
          ],
          [
            17.30796,
            52.219276,
            129.73899
          ],
          [
            17.308205,
            52.219447,
            129.642541
          ],
          [
            17.308467,
            52.219635,
            129.537746
          ],
          [
            17.308726,
            52.219819,
            129.43476
          ],
          [
            17.308968,
            52.219996,
            129.336843
          ],
          [
            17.309187,
            52.220166,
            129.244876
          ],
          [
            17.309465,
            52.220338,
            128.858267
          ],
          [
            17.309847,
            52.220333,
            128.475873
          ],
          [
            17.310185,
            52.220244,
            128.116579
          ],
          [
            17.310531,
            52.22017,
            127.758629
          ],
          [
            17.310929,
            52.220083,
            127.345641
          ],
          [
            17.311286,
            52.220003,
            126.974427
          ],
          [
            17.311608,
            52.219935,
            126.641354
          ],
          [
            17.311926,
            52.219867,
            126.35286
          ],
          [
            17.312244,
            52.219793,
            126.224437
          ],
          [
            17.31254,
            52.219734,
            126.107106
          ],
          [
            17.312861,
            52.21966,
            125.97783
          ],
          [
            17.313215,
            52.219577,
            125.834959
          ],
          [
            17.313539,
            52.219505,
            125.704692
          ],
          [
            17.313872,
            52.219422,
            125.569103
          ],
          [
            17.314194,
            52.219365,
            125.442695
          ],
          [
            17.314514,
            52.219304,
            125.316374
          ],
          [
            17.314871,
            52.219228,
            125.358041
          ],
          [
            17.315184,
            52.219168,
            125.466919
          ],
          [
            17.315487,
            52.219094,
            125.574972
          ],
          [
            17.315795,
            52.219032,
            125.682358
          ],
          [
            17.316098,
            52.21895,
            125.792137
          ],
          [
            17.316401,
            52.218883,
            125.898848
          ],
          [
            17.316684,
            52.218823,
            125.998041
          ],
          [
            17.317101,
            52.218731,
            126.144984
          ],
          [
            17.317412,
            52.218658,
            126.234376
          ],
          [
            17.317757,
            52.218586,
            126.124171
          ],
          [
            17.318087,
            52.218515,
            126.018472
          ],
          [
            17.318411,
            52.21844,
            125.913786
          ],
          [
            17.318746,
            52.218358,
            125.804765
          ],
          [
            17.319091,
            52.218287,
            125.694714
          ],
          [
            17.319456,
            52.218207,
            125.577537
          ],
          [
            17.319815,
            52.218129,
            125.46225
          ],
          [
            17.320159,
            52.218067,
            125.345476
          ],
          [
            17.320511,
            52.217989,
            124.941276
          ],
          [
            17.320874,
            52.217909,
            124.524878
          ],
          [
            17.321243,
            52.217824,
            124.099231
          ],
          [
            17.321629,
            52.217742,
            123.657795
          ],
          [
            17.32202,
            52.217653,
            123.20757
          ],
          [
            17.322415,
            52.217571,
            122.757307
          ],
          [
            17.322809,
            52.217485,
            122.305833
          ],
          [
            17.323181,
            52.217408,
            121.897638
          ],
          [
            17.323582,
            52.217329,
            121.466142
          ],
          [
            17.323957,
            52.217236,
            121.051833
          ],
          [
            17.324371,
            52.217155,
            120.60648
          ],
          [
            17.324778,
            52.217076,
            120.168662
          ],
          [
            17.325182,
            52.216987,
            119.728966
          ],
          [
            17.325582,
            52.2169,
            119.293933
          ],
          [
            17.326006,
            52.216839,
            119.490615
          ],
          [
            17.326406,
            52.216771,
            119.882955
          ],
          [
            17.326739,
            52.216714,
            120.210184
          ],
          [
            17.327044,
            52.216649,
            120.515366
          ],
          [
            17.327416,
            52.216579,
            120.883279
          ],
          [
            17.327713,
            52.216518,
            121.179316
          ],
          [
            17.328045,
            52.216436,
            121.517756
          ],
          [
            17.328386,
            52.216371,
            121.855894
          ],
          [
            17.328706,
            52.216317,
            121.60189
          ],
          [
            17.329033,
            52.21627,
            121.074636
          ],
          [
            17.329349,
            52.216202,
            120.548093
          ],
          [
            17.329647,
            52.216152,
            120.06154
          ],
          [
            17.329993,
            52.216085,
            119.491814
          ],
          [
            17.330331,
            52.216027,
            118.940373
          ],
          [
            17.330671,
            52.215961,
            118.380088
          ],
          [
            17.330977,
            52.215888,
            117.86114
          ],
          [
            17.331302,
            52.215812,
            117.378301
          ],
          [
            17.331634,
            52.215754,
            117.835875
          ],
          [
            17.331972,
            52.215697,
            118.300441
          ],
          [
            17.332285,
            52.215641,
            118.733524
          ],
          [
            17.332612,
            52.215583,
            119.184656
          ],
          [
            17.332924,
            52.215518,
            119.622373
          ],
          [
            17.333254,
            52.215451,
            120.083066
          ],
          [
            17.333579,
            52.21539,
            120.533515
          ],
          [
            17.333909,
            52.215328,
            120.990937
          ],
          [
            17.334207,
            52.215258,
            121.361201
          ],
          [
            17.334557,
            52.215185,
            121.701759
          ],
          [
            17.334887,
            52.215111,
            122.025402
          ],
          [
            17.335207,
            52.215044,
            122.336851
          ],
          [
            17.33553,
            52.214979,
            122.649946
          ],
          [
            17.335888,
            52.214918,
            122.9927
          ],
          [
            17.336276,
            52.214876,
            123.355557
          ],
          [
            17.336595,
            52.214823,
            123.659953
          ],
          [
            17.336931,
            52.214759,
            123.964085
          ],
          [
            17.33729,
            52.214683,
            124.142246
          ],
          [
            17.337605,
            52.214618,
            124.298219
          ],
          [
            17.337966,
            52.214559,
            124.473788
          ],
          [
            17.338268,
            52.214496,
            124.623383
          ],
          [
            17.338578,
            52.214432,
            124.777045
          ],
          [
            17.338907,
            52.214359,
            124.941142
          ],
          [
            17.339218,
            52.214304,
            125.092911
          ],
          [
            17.339539,
            52.214245,
            125.25081
          ],
          [
            17.339917,
            52.21418,
            125.658509
          ],
          [
            17.340259,
            52.2141,
            126.162421
          ],
          [
            17.340612,
            52.214029,
            126.673814
          ],
          [
            17.340957,
            52.213971,
            127.166284
          ],
          [
            17.34127,
            52.213883,
            127.640345
          ],
          [
            17.34157,
            52.213733,
            128.174694
          ],
          [
            17.341848,
            52.213566,
            128.710577
          ],
          [
            17.342104,
            52.213419,
            129.193575
          ],
          [
            17.342345,
            52.213285,
            129.492
          ],
          [
            17.342563,
            52.213147,
            129.694304
          ],
          [
            17.34281,
            52.212998,
            129.918003
          ],
          [
            17.343059,
            52.212853,
            130.139678
          ],
          [
            17.343299,
            52.21271,
            130.355872
          ],
          [
            17.343549,
            52.21257,
            130.574422
          ],
          [
            17.343812,
            52.212425,
            130.802716
          ],
          [
            17.344076,
            52.212287,
            131.026761
          ],
          [
            17.344332,
            52.212131,
            131.259421
          ],
          [
            17.344566,
            52.211979,
            131.465955
          ],
          [
            17.344826,
            52.211838,
            131.676337
          ],
          [
            17.345075,
            52.211703,
            131.877513
          ],
          [
            17.345311,
            52.211562,
            132.07697
          ],
          [
            17.345543,
            52.211433,
            132.266729
          ],
          [
            17.345858,
            52.211264,
            132.520091
          ],
          [
            17.346129,
            52.211105,
            132.747112
          ],
          [
            17.346397,
            52.210947,
            132.972278
          ],
          [
            17.346644,
            52.210806,
            132.809267
          ],
          [
            17.346894,
            52.210665,
            132.499508
          ],
          [
            17.34714,
            52.210547,
            132.212482
          ],
          [
            17.34746,
            52.210532,
            131.918532
          ],
          [
            17.347805,
            52.210547,
            131.603194
          ],
          [
            17.348138,
            52.210563,
            131.298625
          ],
          [
            17.348492,
            52.210597,
            130.970029
          ],
          [
            17.348844,
            52.210612,
            130.647912
          ],
          [
            17.349195,
            52.210653,
            130.314846
          ],
          [
            17.349536,
            52.210684,
            129.928702
          ],
          [
            17.349873,
            52.210719,
            129.545922
          ],
          [
            17.350217,
            52.210749,
            129.156465
          ],
          [
            17.35056,
            52.210782,
            128.76556
          ],
          [
            17.350896,
            52.210804,
            128.387122
          ],
          [
            17.351233,
            52.210832,
            128.005789
          ],
          [
            17.351548,
            52.210856,
            127.650273
          ],
          [
            17.351886,
            52.210871,
            127.268521
          ],
          [
            17.352224,
            52.210902,
            127.028452
          ],
          [
            17.352547,
            52.210937,
            126.95049
          ],
          [
            17.352895,
            52.210949,
            126.867576
          ],
          [
            17.353235,
            52.210988,
            126.785355
          ],
          [
            17.353574,
            52.211012,
            126.704196
          ],
          [
            17.353932,
            52.21105,
            126.617845
          ],
          [
            17.354274,
            52.211087,
            126.535225
          ],
          [
            17.354639,
            52.211109,
            126.447991
          ],
          [
            17.355009,
            52.211124,
            126.371751
          ],
          [
            17.355378,
            52.211149,
            126.387037
          ],
          [
            17.355722,
            52.211183,
            126.401384
          ],
          [
            17.356075,
            52.2112,
            126.415971
          ],
          [
            17.356404,
            52.211237,
            126.429748
          ],
          [
            17.35677,
            52.211269,
            126.444974
          ],
          [
            17.357098,
            52.211293,
            126.458575
          ],
          [
            17.357427,
            52.211315,
            126.472205
          ],
          [
            17.357785,
            52.211342,
            126.48706
          ],
          [
            17.358131,
            52.211364,
            126.464441
          ],
          [
            17.358464,
            52.211399,
            126.429568
          ],
          [
            17.358788,
            52.21141,
            126.396089
          ],
          [
            17.359126,
            52.211433,
            126.360984
          ],
          [
            17.359452,
            52.211467,
            126.326842
          ],
          [
            17.359794,
            52.211497,
            126.2912
          ],
          [
            17.360144,
            52.211516,
            126.254948
          ],
          [
            17.360494,
            52.211556,
            126.218163
          ],
          [
            17.360836,
            52.211581,
            126.249055
          ],
          [
            17.361159,
            52.211606,
            126.622492
          ],
          [
            17.361472,
            52.21164,
            126.988729
          ],
          [
            17.361782,
            52.211658,
            127.34586
          ],
          [
            17.362102,
            52.211693,
            127.71854
          ],
          [
            17.362442,
            52.211715,
            128.110521
          ],
          [
            17.36276,
            52.211774,
            128.491522
          ],
          [
            17.363072,
            52.211823,
            128.861787
          ],
          [
            17.363415,
            52.211879,
            129.269706
          ],
          [
            17.363734,
            52.211954,
            129.7445
          ],
          [
            17.364058,
            52.211996,
            130.412949
          ],
          [
            17.364399,
            52.212055,
            131.126282
          ],
          [
            17.364707,
            52.212114,
            131.775928
          ],
          [
            17.365019,
            52.212175,
            132.437092
          ],
          [
            17.365347,
            52.212235,
            133.12761
          ],
          [
            17.36567,
            52.212296,
            133.808991
          ],
          [
            17.365987,
            52.212367,
            134.488699
          ],
          [
            17.36631,
            52.212427,
            135.168183
          ],
          [
            17.366627,
            52.212493,
            135.660708
          ],
          [
            17.366967,
            52.212569,
            136.041586
          ],
          [
            17.367297,
            52.212634,
            136.40605
          ],
          [
            17.367629,
            52.212693,
            136.770764
          ],
          [
            17.367939,
            52.21274,
            137.113071
          ],
          [
            17.368258,
            52.212789,
            137.458819
          ],
          [
            17.36858,
            52.212848,
            137.814671
          ],
          [
            17.368927,
            52.212899,
            138.189709
          ],
          [
            17.369248,
            52.21297,
            138.544638
          ],
          [
            17.369582,
            52.213008,
            137.787266
          ],
          [
            17.369896,
            52.213012,
            137.078607
          ],
          [
            17.370225,
            52.21308,
            136.302387
          ],
          [
            17.370537,
            52.213146,
            135.564228
          ],
          [
            17.370875,
            52.213189,
            134.792552
          ],
          [
            17.371251,
            52.213237,
            133.934439
          ],
          [
            17.371594,
            52.213287,
            133.147048
          ],
          [
            17.371926,
            52.21335,
            132.370687
          ],
          [
            17.372251,
            52.213416,
            132.041037
          ],
          [
            17.372578,
            52.21346,
            132.113435
          ],
          [
            17.372916,
            52.21352,
            132.189461
          ],
          [
            17.373264,
            52.213595,
            132.269404
          ],
          [
            17.37362,
            52.213643,
            132.34835
          ],
          [
            17.373982,
            52.213698,
            132.428909
          ],
          [
            17.37436,
            52.213763,
            132.513806
          ],
          [
            17.374727,
            52.213845,
            132.59834
          ],
          [
            17.375089,
            52.213922,
            132.513538
          ],
          [
            17.375437,
            52.213983,
            132.296282
          ],
          [
            17.375778,
            52.214063,
            132.077809
          ],
          [
            17.376146,
            52.214119,
            131.851032
          ],
          [
            17.376512,
            52.214179,
            131.62451
          ],
          [
            17.376884,
            52.214224,
            131.397749
          ],
          [
            17.377245,
            52.214284,
            131.174012
          ],
          [
            17.377617,
            52.214338,
            130.945427
          ],
          [
            17.37798,
            52.21439,
            130.529321
          ],
          [
            17.378317,
            52.214431,
            130.074452
          ],
          [
            17.378637,
            52.214477,
            129.638094
          ],
          [
            17.37895,
            52.214535,
            129.204444
          ],
          [
            17.379307,
            52.214556,
            128.729729
          ],
          [
            17.37961,
            52.214576,
            128.326184
          ],
          [
            17.379905,
            52.214605,
            127.93
          ],
          [
            17.3802,
            52.214631,
            127.534138
          ],
          [
            17.380555,
            52.214639,
            127.061858
          ],
          [
            17.380857,
            52.214639,
            126.637176
          ],
          [
            17.381206,
            52.21466,
            126.137008
          ],
          [
            17.381562,
            52.214615,
            125.620043
          ],
          [
            17.381859,
            52.214479,
            125.087149
          ],
          [
            17.382084,
            52.214298,
            124.556984
          ],
          [
            17.382232,
            52.2141,
            124.051432
          ],
          [
            17.382332,
            52.213902,
            123.57043
          ],
          [
            17.382447,
            52.213721,
            123.119609
          ],
          [
            17.38259,
            52.213505,
            123.023396
          ],
          [
            17.382721,
            52.213301,
            123.444441
          ],
          [
            17.382949,
            52.213138,
            123.854411
          ],
          [
            17.383222,
            52.212992,
            124.277999
          ],
          [
            17.383473,
            52.212864,
            124.661652
          ],
          [
            17.38374,
            52.212786,
            125.007897
          ],
          [
            17.384077,
            52.212769,
            125.408705
          ],
          [
            17.384401,
            52.212787,
            125.790704
          ],
          [
            17.38479,
            52.212801,
            126.246996
          ],
          [
            17.385202,
            52.212863,
            126.62051
          ],
          [
            17.385493,
            52.212895,
            126.879581
          ],
          [
            17.385786,
            52.21293,
            127.141124
          ],
          [
            17.38613,
            52.212961,
            127.446195
          ],
          [
            17.386556,
            52.213015,
            127.827414
          ],
          [
            17.386915,
            52.213057,
            128.147592
          ],
          [
            17.387278,
            52.21312,
            128.478467
          ],
          [
            17.387698,
            52.213154,
            128.874268
          ],
          [
            17.387999,
            52.213209,
            129.415409
          ],
          [
            17.388367,
            52.21325,
            130.060023
          ],
          [
            17.388757,
            52.213291,
            130.743202
          ],
          [
            17.389091,
            52.213331,
            131.330705
          ],
          [
            17.389423,
            52.213365,
            131.911462
          ],
          [
            17.389773,
            52.213419,
            132.540539
          ],
          [
            17.390078,
            52.213487,
            133.105658
          ],
          [
            17.390368,
            52.213578,
            133.668687
          ],
          [
            17.390689,
            52.213567,
            133.491947
          ],
          [
            17.39099,
            52.213609,
            132.914954
          ],
          [
            17.391296,
            52.213653,
            132.329098
          ],
          [
            17.39168,
            52.213678,
            131.603766
          ],
          [
            17.392042,
            52.213703,
            130.925735
          ],
          [
            17.392401,
            52.21373,
            130.253287
          ],
          [
            17.392709,
            52.213766,
            129.670355
          ],
          [
            17.393009,
            52.213797,
            129.104259
          ],
          [
            17.39333,
            52.213816,
            128.504614
          ],
          [
            17.393651,
            52.213825,
            128.40404
          ],
          [
            17.393977,
            52.213815,
            128.380285
          ],
          [
            17.394303,
            52.213788,
            128.356457
          ],
          [
            17.394635,
            52.213757,
            128.332121
          ],
          [
            17.395009,
            52.213744,
            128.304877
          ],
          [
            17.39536,
            52.213733,
            128.279423
          ],
          [
            17.395712,
            52.213711,
            128.253798
          ],
          [
            17.396065,
            52.213699,
            128.228179
          ],
          [
            17.396439,
            52.213675,
            128.108547
          ],
          [
            17.396799,
            52.213655,
            127.855219
          ],
          [
            17.397134,
            52.213641,
            127.620174
          ],
          [
            17.397489,
            52.21362,
            127.368711
          ],
          [
            17.397856,
            52.213603,
            127.111173
          ],
          [
            17.398203,
            52.213584,
            126.86741
          ],
          [
            17.398547,
            52.213566,
            126.625803
          ],
          [
            17.398903,
            52.213559,
            126.374891
          ],
          [
            17.399243,
            52.213533,
            126.154749
          ],
          [
            17.399579,
            52.213528,
            126.124212
          ],
          [
            17.399921,
            52.213517,
            126.093111
          ],
          [
            17.400238,
            52.213476,
            126.063598
          ],
          [
            17.400571,
            52.213412,
            126.031803
          ],
          [
            17.400889,
            52.213355,
            126.001585
          ],
          [
            17.401204,
            52.213303,
            125.971916
          ],
          [
            17.401505,
            52.213223,
            125.942057
          ],
          [
            17.401844,
            52.213162,
            125.909926
          ],
          [
            17.402158,
            52.213085,
            126.053939
          ],
          [
            17.40253,
            52.213019,
            126.534695
          ],
          [
            17.402859,
            52.212952,
            126.965141
          ],
          [
            17.403163,
            52.212875,
            127.373487
          ],
          [
            17.403508,
            52.212804,
            127.82541
          ],
          [
            17.40385,
            52.212746,
            128.266512
          ],
          [
            17.40419,
            52.21267,
            128.715785
          ],
          [
            17.404496,
            52.212602,
            129.120084
          ],
          [
            17.404816,
            52.212535,
            129.533516
          ],
          [
            17.405153,
            52.212467,
            129.41899
          ],
          [
            17.405501,
            52.212407,
            129.302412
          ],
          [
            17.405864,
            52.21232,
            129.176306
          ],
          [
            17.406213,
            52.212267,
            129.060274
          ],
          [
            17.406573,
            52.212193,
            128.937836
          ],
          [
            17.406919,
            52.212128,
            128.821141
          ],
          [
            17.407281,
            52.212054,
            128.69806
          ],
          [
            17.407653,
            52.211979,
            128.570415
          ],
          [
            17.408014,
            52.211891,
            128.435309
          ],
          [
            17.408367,
            52.211833,
            128.308232
          ],
          [
            17.408679,
            52.211769,
            128.193807
          ],
          [
            17.408979,
            52.211717,
            128.085344
          ],
          [
            17.409324,
            52.211642,
            127.95797
          ],
          [
            17.409668,
            52.211593,
            127.834934
          ],
          [
            17.409962,
            52.211533,
            127.727171
          ],
          [
            17.410263,
            52.211465,
            127.615621
          ],
          [
            17.41054,
            52.211395,
            127.647376
          ],
          [
            17.41085,
            52.211331,
            127.80795
          ],
          [
            17.411196,
            52.211259,
            127.987757
          ],
          [
            17.41149,
            52.211206,
            128.138219
          ],
          [
            17.411802,
            52.211136,
            128.301334
          ],
          [
            17.412134,
            52.211071,
            128.472418
          ],
          [
            17.412445,
            52.210993,
            128.637374
          ],
          [
            17.412738,
            52.210928,
            128.79035
          ],
          [
            17.413028,
            52.210866,
            128.941126
          ],
          [
            17.413348,
            52.210798,
            128.969327
          ],
          [
            17.413704,
            52.210743,
            128.897862
          ],
          [
            17.414037,
            52.210671,
            128.829144
          ],
          [
            17.414393,
            52.21059,
            128.755126
          ],
          [
            17.414767,
            52.210526,
            128.679496
          ],
          [
            17.4151,
            52.210462,
            128.611512
          ],
          [
            17.415451,
            52.210395,
            128.539859
          ],
          [
            17.41581,
            52.210325,
            128.466504
          ],
          [
            17.41612,
            52.210276,
            128.372494
          ],
          [
            17.416423,
            52.2102,
            128.247936
          ],
          [
            17.416728,
            52.210145,
            128.126967
          ],
          [
            17.417033,
            52.210066,
            128.000997
          ],
          [
            17.417316,
            52.209968,
            127.877313
          ],
          [
            17.417579,
            52.209871,
            127.760251
          ],
          [
            17.417893,
            52.209737,
            127.614691
          ],
          [
            17.418246,
            52.209591,
            127.452655
          ],
          [
            17.418566,
            52.209465,
            127.301017
          ],
          [
            17.418892,
            52.209323,
            127.068431
          ],
          [
            17.419196,
            52.209196,
            126.854418
          ],
          [
            17.419488,
            52.209074,
            126.648712
          ],
          [
            17.419743,
            52.20895,
            126.459075
          ],
          [
            17.420011,
            52.208827,
            126.264364
          ],
          [
            17.420334,
            52.208714,
            126.047918
          ],
          [
            17.420657,
            52.20858,
            125.82092
          ],
          [
            17.420989,
            52.208451,
            125.603204
          ],
          [
            17.421309,
            52.208322,
            125.492366
          ],
          [
            17.421626,
            52.208196,
            125.382717
          ],
          [
            17.421935,
            52.208089,
            125.280207
          ],
          [
            17.422244,
            52.207964,
            125.173242
          ],
          [
            17.422586,
            52.207836,
            125.057485
          ],
          [
            17.422914,
            52.207699,
            124.942812
          ],
          [
            17.423238,
            52.207558,
            124.82805
          ],
          [
            17.423554,
            52.207422,
            124.553431
          ],
          [
            17.423933,
            52.207272,
            123.9972
          ],
          [
            17.424323,
            52.207127,
            123.433684
          ],
          [
            17.424734,
            52.206957,
            122.822253
          ],
          [
            17.425163,
            52.206785,
            122.190222
          ],
          [
            17.425574,
            52.206608,
            121.570911
          ],
          [
            17.425975,
            52.206449,
            121.059987
          ],
          [
            17.426375,
            52.20628,
            120.742744
          ],
          [
            17.426762,
            52.206133,
            120.445446
          ],
          [
            17.427151,
            52.205991,
            120.149725
          ],
          [
            17.427494,
            52.205856,
            119.883468
          ],
          [
            17.427808,
            52.205719,
            119.631301
          ],
          [
            17.428132,
            52.205576,
            119.370586
          ],
          [
            17.428434,
            52.20546,
            119.233588
          ],
          [
            17.428725,
            52.205341,
            119.238899
          ],
          [
            17.429037,
            52.205217,
            119.244532
          ],
          [
            17.429351,
            52.205098,
            119.250125
          ],
          [
            17.429652,
            52.204985,
            119.255472
          ],
          [
            17.429957,
            52.204865,
            119.260964
          ],
          [
            17.430278,
            52.20475,
            119.266609
          ],
          [
            17.430612,
            52.204649,
            119.272255
          ],
          [
            17.430953,
            52.204606,
            119.287697
          ],
          [
            17.4313,
            52.204604,
            119.324914
          ],
          [
            17.431636,
            52.204651,
            119.3619
          ],
          [
            17.431969,
            52.204631,
            119.400324
          ],
          [
            17.432278,
            52.204658,
            119.433777
          ],
          [
            17.432673,
            52.204693,
            119.476514
          ],
          [
            17.433067,
            52.204746,
            119.519727
          ],
          [
            17.433424,
            52.204783,
            119.558536
          ],
          [
            17.433745,
            52.204786,
            119.627983
          ],
          [
            17.434093,
            52.204804,
            120.129281
          ],
          [
            17.434468,
            52.20484,
            120.674346
          ],
          [
            17.434851,
            52.204885,
            121.235523
          ],
          [
            17.435217,
            52.204889,
            121.760878
          ],
          [
            17.435594,
            52.204931,
            122.31078
          ],
          [
            17.435966,
            52.204976,
            122.854958
          ],
          [
            17.436348,
            52.204989,
            123.404014
          ],
          [
            17.436715,
            52.205013,
            123.97089
          ],
          [
            17.437097,
            52.205043,
            124.679784
          ],
          [
            17.437458,
            52.205073,
            125.352726
          ],
          [
            17.437858,
            52.205117,
            126.100646
          ],
          [
            17.438236,
            52.205133,
            126.798104
          ],
          [
            17.438589,
            52.205168,
            127.456277
          ],
          [
            17.438921,
            52.205222,
            128.092829
          ],
          [
            17.43928,
            52.205225,
            128.759219
          ],
          [
            17.439697,
            52.205224,
            128.854829
          ],
          [
            17.439993,
            52.205219,
            128.26624
          ],
          [
            17.440289,
            52.205246,
            127.674482
          ],
          [
            17.4406,
            52.205279,
            127.049908
          ],
          [
            17.440961,
            52.205307,
            126.329941
          ],
          [
            17.44126,
            52.20533,
            125.733128
          ],
          [
            17.441663,
            52.205363,
            124.929222
          ],
          [
            17.442022,
            52.20539,
            124.213801
          ],
          [
            17.442382,
            52.205416,
            123.497139
          ],
          [
            17.442808,
            52.205443,
            123.116219
          ],
          [
            17.443105,
            52.205465,
            122.892014
          ],
          [
            17.443475,
            52.205512,
            122.607708
          ],
          [
            17.443815,
            52.205548,
            122.349267
          ],
          [
            17.444116,
            52.205563,
            122.122781
          ],
          [
            17.444433,
            52.205581,
            121.884294
          ],
          [
            17.444754,
            52.205623,
            121.638049
          ],
          [
            17.445107,
            52.205648,
            121.371849
          ],
          [
            17.445461,
            52.205644,
            121.14801
          ],
          [
            17.445818,
            52.205684,
            120.997906
          ],
          [
            17.446154,
            52.205701,
            120.858275
          ],
          [
            17.446464,
            52.205728,
            120.728783
          ],
          [
            17.446779,
            52.20566,
            120.590085
          ],
          [
            17.447047,
            52.205745,
            120.463921
          ],
          [
            17.447343,
            52.205788,
            120.337896
          ],
          [
            17.446902,
            52.205689,
            120.141361
          ],
          [
            17.44695,
            52.205488,
            120.003723
          ],
          [
            17.447078,
            52.20528,
            119.855306
          ],
          [
            17.447169,
            52.205084,
            119.718698
          ],
          [
            17.447289,
            52.20488,
            119.574006
          ],
          [
            17.447389,
            52.204682,
            119.435782
          ],
          [
            17.447478,
            52.204476,
            119.293643
          ],
          [
            17.447598,
            52.204275,
            119.150602
          ],
          [
            17.44786,
            52.204138,
            119.008502
          ],
          [
            17.448235,
            52.204133,
            118.854778
          ],
          [
            17.448628,
            52.204147,
            119.054351
          ],
          [
            17.449015,
            52.204158,
            119.490912
          ],
          [
            17.449415,
            52.204186,
            119.944399
          ],
          [
            17.449807,
            52.204201,
            120.387061
          ],
          [
            17.45021,
            52.204229,
            120.843913
          ],
          [
            17.450609,
            52.204269,
            121.299324
          ],
          [
            17.451034,
            52.204301,
            121.782866
          ],
          [
            17.45143,
            52.204336,
            122.122044
          ],
          [
            17.451746,
            52.204363,
            122.191118
          ],
          [
            17.452086,
            52.204409,
            122.266765
          ],
          [
            17.452414,
            52.204415,
            122.337789
          ],
          [
            17.452745,
            52.204445,
            122.410228
          ],
          [
            17.453064,
            52.204476,
            122.480143
          ],
          [
            17.453397,
            52.204508,
            122.553096
          ],
          [
            17.453726,
            52.204537,
            122.625044
          ],
          [
            17.454065,
            52.204546,
            122.69849
          ],
          [
            17.454378,
            52.204569,
            122.44024
          ],
          [
            17.45476,
            52.204602,
            121.764165
          ],
          [
            17.455071,
            52.2046,
            121.215467
          ],
          [
            17.455437,
            52.204609,
            120.575853
          ],
          [
            17.455757,
            52.204656,
            119.998368
          ],
          [
            17.456114,
            52.204677,
            119.363885
          ],
          [
            17.456428,
            52.204694,
            118.813238
          ],
          [
            17.456731,
            52.204678,
            118.281679
          ],
          [
            17.457111,
            52.204719,
            117.610144
          ],
          [
            17.457409,
            52.204752,
            117.744195
          ],
          [
            17.457744,
            52.204769,
            117.892519
          ],
          [
            17.458112,
            52.204802,
            118.056704
          ],
          [
            17.458447,
            52.204836,
            118.206501
          ],
          [
            17.458779,
            52.204853,
            118.353665
          ],
          [
            17.459099,
            52.204888,
            118.497756
          ],
          [
            17.459415,
            52.204911,
            118.638424
          ],
          [
            17.459717,
            52.204923,
            118.771992
          ],
          [
            17.460084,
            52.204939,
            118.916058
          ],
          [
            17.460415,
            52.204991,
            118.98067
          ],
          [
            17.460722,
            52.205004,
            119.039076
          ],
          [
            17.461051,
            52.205048,
            119.102506
          ],
          [
            17.461373,
            52.205079,
            119.163848
          ],
          [
            17.461687,
            52.205105,
            119.223486
          ],
          [
            17.462003,
            52.205114,
            119.283316
          ],
          [
            17.462389,
            52.205119,
            119.356128
          ],
          [
            17.462725,
            52.205149,
            119.420155
          ],
          [
            17.463058,
            52.205168,
            119.724988
          ],
          [
            17.463392,
            52.205208,
            120.335052
          ],
          [
            17.463725,
            52.205237,
            120.93787
          ],
          [
            17.464036,
            52.205276,
            121.507543
          ],
          [
            17.464416,
            52.205295,
            122.191479
          ],
          [
            17.464774,
            52.205321,
            122.838176
          ],
          [
            17.4651,
            52.20534,
            123.428434
          ],
          [
            17.465453,
            52.205384,
            124.07433
          ],
          [
            17.465864,
            52.205444,
            124.681463
          ],
          [
            17.466254,
            52.205464,
            124.48019
          ],
          [
            17.466635,
            52.205505,
            124.281397
          ],
          [
            17.467043,
            52.2055,
            124.067854
          ],
          [
            17.467486,
            52.205508,
            123.840015
          ],
          [
            17.467894,
            52.205515,
            123.628586
          ],
          [
            17.468313,
            52.20553,
            123.412911
          ],
          [
            17.468733,
            52.205519,
            123.177064
          ],
          [
            17.469106,
            52.205573,
            122.607244
          ],
          [
            17.469415,
            52.205604,
            122.142481
          ],
          [
            17.469754,
            52.205631,
            121.635062
          ],
          [
            17.470056,
            52.205649,
            121.183009
          ],
          [
            17.470391,
            52.205682,
            120.677947
          ],
          [
            17.470724,
            52.205693,
            120.18294
          ],
          [
            17.471019,
            52.20573,
            119.735894
          ],
          [
            17.471399,
            52.205769,
            119.163683
          ],
          [
            17.471762,
            52.205796,
            118.832872
          ],
          [
            17.472135,
            52.20581,
            118.789055
          ],
          [
            17.472467,
            52.205827,
            118.749504
          ],
          [
            17.472775,
            52.205853,
            118.712955
          ],
          [
            17.473135,
            52.205877,
            118.670471
          ],
          [
            17.473498,
            52.205898,
            118.627706
          ],
          [
            17.47387,
            52.205926,
            118.583771
          ],
          [
            17.474232,
            52.205954,
            118.540976
          ],
          [
            17.474535,
            52.205974,
            118.51806
          ],
          [
            17.474879,
            52.206002,
            118.744321
          ],
          [
            17.475238,
            52.206031,
            118.980416
          ],
          [
            17.475569,
            52.20604,
            119.19742
          ],
          [
            17.475912,
            52.206057,
            119.421796
          ],
          [
            17.476271,
            52.206085,
            119.658443
          ],
          [
            17.476597,
            52.206126,
            119.875443
          ],
          [
            17.476905,
            52.206169,
            120.081918
          ],
          [
            17.477225,
            52.206164,
            120.290623
          ],
          [
            17.477547,
            52.206176,
            120.506013
          ],
          [
            17.477858,
            52.206191,
            120.722681
          ],
          [
            17.478191,
            52.206221,
            120.955728
          ],
          [
            17.478537,
            52.206247,
            121.199099
          ],
          [
            17.478873,
            52.206248,
            121.432707
          ],
          [
            17.47922,
            52.206272,
            121.674498
          ],
          [
            17.479539,
            52.206273,
            121.89549
          ],
          [
            17.479984,
            52.206304,
            122.205933
          ],
          [
            17.480306,
            52.206327,
            122.430842
          ],
          [
            17.48063,
            52.206337,
            122.723887
          ],
          [
            17.480938,
            52.206355,
            123.010455
          ],
          [
            17.481247,
            52.206383,
            123.299804
          ],
          [
            17.481637,
            52.206383,
            123.661006
          ],
          [
            17.481939,
            52.206405,
            123.942677
          ],
          [
            17.48236,
            52.206445,
            124.337434
          ],
          [
            17.482785,
            52.206478,
            124.734296
          ],
          [
            17.483188,
            52.206503,
            125.109538
          ],
          [
            17.483595,
            52.206524,
            125.134011
          ],
          [
            17.484012,
            52.20653,
            125.088777
          ],
          [
            17.484403,
            52.206568,
            125.045837
          ],
          [
            17.484817,
            52.206603,
            125.000509
          ],
          [
            17.485231,
            52.206615,
            124.955528
          ],
          [
            17.485647,
            52.20663,
            124.910264
          ],
          [
            17.486056,
            52.206645,
            124.865804
          ],
          [
            17.486456,
            52.206609,
            124.350751
          ],
          [
            17.486703,
            52.206431,
            123.684837
          ],
          [
            17.48688,
            52.206267,
            123.125909
          ],
          [
            17.48706,
            52.206091,
            122.535702
          ],
          [
            17.487255,
            52.20592,
            121.941991
          ],
          [
            17.487479,
            52.205727,
            121.268681
          ],
          [
            17.487689,
            52.205553,
            120.653846
          ],
          [
            17.487749,
            52.205362,
            120.098548
          ],
          [
            17.487764,
            52.205142,
            119.619043
          ],
          [
            17.487775,
            52.204922,
            119.331883
          ],
          [
            17.487781,
            52.204687,
            119.025174
          ],
          [
            17.487802,
            52.204465,
            118.735056
          ],
          [
            17.487899,
            52.204266,
            118.461583
          ],
          [
            17.488084,
            52.204093,
            118.191229
          ],
          [
            17.488278,
            52.203933,
            117.930959
          ],
          [
            17.488505,
            52.203763,
            117.644393
          ],
          [
            17.488781,
            52.203563,
            117.538889
          ],
          [
            17.489028,
            52.203373,
            118.018825
          ],
          [
            17.489236,
            52.203225,
            118.404912
          ],
          [
            17.48942,
            52.20306,
            118.803619
          ],
          [
            17.489331,
            52.202865,
            119.208503
          ],
          [
            17.489187,
            52.202692,
            119.593147
          ],
          [
            17.489066,
            52.202493,
            120.012711
          ],
          [
            17.48897,
            52.202295,
            120.420683
          ],
          [
            17.488846,
            52.202108,
            120.821195
          ],
          [
            17.488807,
            52.201905,
            120.836933
          ],
          [
            17.488661,
            52.201726,
            120.681106
          ],
          [
            17.488513,
            52.20156,
            120.533789
          ],
          [
            17.48849,
            52.201349,
            120.368921
          ],
          [
            17.488406,
            52.201155,
            120.21265
          ],
          [
            17.488317,
            52.200939,
            120.039199
          ],
          [
            17.488207,
            52.200763,
            119.892376
          ],
          [
            17.488158,
            52.200528,
            119.707922
          ],
          [
            17.488068,
            52.200293,
            119.405988
          ],
          [
            17.487971,
            52.200044,
            118.415236
          ],
          [
            17.487758,
            52.19989,
            117.629642
          ],
          [
            17.488038,
            52.199773,
            116.81036
          ],
          [
            17.488162,
            52.199624,
            116.032521
          ],
          [
            17.48825,
            52.199434,
            115.263214
          ],
          [
            17.488349,
            52.199235,
            114.458836
          ],
          [
            17.488432,
            52.199059,
            113.750525
          ],
          [
            17.488547,
            52.198851,
            112.901591
          ],
          [
            17.488653,
            52.198651,
            112.633917
          ],
          [
            17.488805,
            52.198413,
            112.707407
          ],
          [
            17.488947,
            52.198206,
            112.771987
          ],
          [
            17.489083,
            52.198009,
            112.834286
          ],
          [
            17.48929,
            52.197815,
            112.901099
          ],
          [
            17.489556,
            52.197663,
            112.965172
          ],
          [
            17.489791,
            52.197502,
            113.02728
          ],
          [
            17.490048,
            52.19737,
            113.086374
          ],
          [
            17.490321,
            52.197238,
            113.106936
          ],
          [
            17.490537,
            52.197071,
            113.096078
          ],
          [
            17.49075,
            52.196896,
            113.084954
          ],
          [
            17.490963,
            52.196738,
            113.074512
          ],
          [
            17.491164,
            52.196598,
            113.065011
          ],
          [
            17.491379,
            52.19642,
            113.053726
          ],
          [
            17.491592,
            52.196245,
            113.0426
          ],
          [
            17.491832,
            52.196072,
            113.03103
          ],
          [
            17.492073,
            52.195882,
            113.052001
          ],
          [
            17.492323,
            52.1957,
            113.191258
          ],
          [
            17.49257,
            52.195518,
            113.329827
          ],
          [
            17.49281,
            52.195334,
            113.467694
          ],
          [
            17.493047,
            52.195158,
            113.601295
          ],
          [
            17.493279,
            52.19497,
            113.739382
          ],
          [
            17.493497,
            52.194791,
            113.870715
          ],
          [
            17.493753,
            52.194616,
            114.008273
          ],
          [
            17.494002,
            52.194461,
            114.38454
          ],
          [
            17.49423,
            52.19428,
            115.058051
          ],
          [
            17.494427,
            52.194098,
            115.700458
          ],
          [
            17.494642,
            52.193918,
            116.356932
          ],
          [
            17.494815,
            52.193732,
            116.986754
          ],
          [
            17.4951,
            52.193611,
            117.61827
          ],
          [
            17.495228,
            52.193303,
            118.559667
          ],
          [
            17.495421,
            52.193106,
            119.237794
          ],
          [
            17.495577,
            52.192929,
            119.504292
          ],
          [
            17.49577,
            52.192734,
            119.706285
          ],
          [
            17.495945,
            52.192528,
            119.912108
          ],
          [
            17.496128,
            52.192318,
            120.122943
          ],
          [
            17.496344,
            52.192106,
            120.344285
          ],
          [
            17.496531,
            52.191911,
            120.544737
          ],
          [
            17.496713,
            52.191703,
            120.753778
          ],
          [
            17.496914,
            52.1915,
            120.954749
          ],
          [
            17.49709,
            52.191306,
            120.900765
          ],
          [
            17.497254,
            52.191112,
            120.847732
          ],
          [
            17.497425,
            52.190945,
            120.799916
          ],
          [
            17.497578,
            52.190784,
            120.754723
          ],
          [
            17.497723,
            52.190623,
            120.710129
          ],
          [
            17.497908,
            52.19043,
            120.655793
          ],
          [
            17.498063,
            52.190232,
            120.602538
          ],
          [
            17.498236,
            52.19006,
            120.553438
          ],
          [
            17.498398,
            52.189864,
            120.400987
          ],
          [
            17.498551,
            52.189689,
            120.119819
          ],
          [
            17.498718,
            52.189514,
            119.832698
          ],
          [
            17.498862,
            52.189339,
            119.555122
          ],
          [
            17.499071,
            52.189146,
            119.226997
          ],
          [
            17.499214,
            52.188941,
            118.911077
          ],
          [
            17.499436,
            52.188734,
            118.560042
          ],
          [
            17.499633,
            52.18852,
            118.212057
          ],
          [
            17.499855,
            52.188284,
            117.968835
          ],
          [
            17.500046,
            52.188052,
            117.956899
          ],
          [
            17.50029,
            52.187815,
            117.944027
          ],
          [
            17.500532,
            52.187572,
            117.930932
          ],
          [
            17.50072,
            52.187362,
            117.919931
          ],
          [
            17.500892,
            52.187143,
            117.908769
          ],
          [
            17.501119,
            52.186919,
            117.896652
          ],
          [
            17.501316,
            52.186716,
            117.951929
          ],
          [
            17.501518,
            52.186507,
            118.081464
          ],
          [
            17.501716,
            52.186293,
            118.212648
          ],
          [
            17.501859,
            52.186101,
            118.325315
          ],
          [
            17.50206,
            52.185898,
            118.451946
          ],
          [
            17.502247,
            52.18568,
            118.583522
          ],
          [
            17.502428,
            52.185481,
            118.705013
          ],
          [
            17.50261,
            52.185284,
            118.825757
          ],
          [
            17.502789,
            52.185079,
            119.010093
          ],
          [
            17.502958,
            52.184889,
            119.195598
          ],
          [
            17.503156,
            52.184696,
            119.390823
          ],
          [
            17.503373,
            52.184489,
            119.601433
          ],
          [
            17.503548,
            52.184293,
            119.793008
          ],
          [
            17.503712,
            52.184127,
            119.959234
          ],
          [
            17.503929,
            52.183935,
            120.15922
          ],
          [
            17.504202,
            52.183808,
            120.340649
          ],
          [
            17.504493,
            52.183632,
            120.288931
          ],
          [
            17.504817,
            52.183472,
            120.156022
          ],
          [
            17.505085,
            52.183393,
            120.061204
          ],
          [
            17.505461,
            52.183358,
            119.940063
          ],
          [
            17.505858,
            52.183298,
            119.8098
          ],
          [
            17.506165,
            52.183262,
            119.710391
          ],
          [
            17.506495,
            52.183231,
            119.603875
          ],
          [
            17.506827,
            52.183186,
            119.49559
          ],
          [
            17.507145,
            52.183142,
            119.434129
          ],
          [
            17.507478,
            52.183122,
            119.397133
          ],
          [
            17.50786,
            52.183081,
            119.354276
          ],
          [
            17.508205,
            52.183038,
            119.315209
          ],
          [
            17.508542,
            52.18299,
            119.276986
          ],
          [
            17.508942,
            52.182935,
            119.231655
          ],
          [
            17.5093,
            52.182904,
            119.191655
          ],
          [
            17.509622,
            52.182847,
            119.154616
          ],
          [
            17.509959,
            52.182817,
            119.229462
          ],
          [
            17.510299,
            52.18277,
            119.467255
          ],
          [
            17.510659,
            52.182733,
            119.715955
          ],
          [
            17.511015,
            52.182691,
            119.963129
          ],
          [
            17.511348,
            52.182636,
            120.198098
          ],
          [
            17.511683,
            52.182582,
            120.434099
          ],
          [
            17.512055,
            52.182529,
            120.694497
          ],
          [
            17.512412,
            52.182478,
            120.944257
          ],
          [
            17.512785,
            52.18244,
            121.036572
          ],
          [
            17.513146,
            52.182389,
            120.698683
          ],
          [
            17.513529,
            52.182335,
            120.34024
          ],
          [
            17.513935,
            52.182287,
            119.962984
          ],
          [
            17.514336,
            52.182231,
            119.58779
          ],
          [
            17.514761,
            52.182186,
            119.194322
          ],
          [
            17.515158,
            52.182143,
            118.826621
          ],
          [
            17.515529,
            52.182096,
            118.481074
          ],
          [
            17.515905,
            52.182046,
            118.344341
          ],
          [
            17.51631,
            52.18199,
            118.214829
          ],
          [
            17.516725,
            52.18193,
            118.081406
          ],
          [
            17.517091,
            52.181824,
            117.954981
          ],
          [
            17.51742,
            52.181701,
            117.834772
          ],
          [
            17.517708,
            52.18158,
            117.725866
          ],
          [
            17.518033,
            52.181469,
            117.609575
          ],
          [
            17.518375,
            52.18135,
            117.582568
          ],
          [
            17.518705,
            52.181224,
            117.676925
          ],
          [
            17.519043,
            52.181108,
            117.770936
          ],
          [
            17.519388,
            52.181,
            117.865031
          ],
          [
            17.519752,
            52.180872,
            117.967132
          ],
          [
            17.520122,
            52.180743,
            118.070513
          ],
          [
            17.520488,
            52.180627,
            118.170515
          ],
          [
            17.520823,
            52.180511,
            118.246885
          ],
          [
            17.521186,
            52.180403,
            118.197776
          ],
          [
            17.521524,
            52.180277,
            118.149578
          ],
          [
            17.521888,
            52.180183,
            118.101408
          ],
          [
            17.522223,
            52.180081,
            118.055825
          ],
          [
            17.522531,
            52.180012,
            118.015868
          ],
          [
            17.522873,
            52.179951,
            117.97249
          ],
          [
            17.52323,
            52.179915,
            117.928367
          ],
          [
            17.523598,
            52.179862,
            117.948371
          ],
          [
            17.523971,
            52.17978,
            118.141486
          ],
          [
            17.524343,
            52.17972,
            118.328803
          ],
          [
            17.524717,
            52.179705,
            118.512243
          ],
          [
            17.525083,
            52.179644,
            118.696931
          ],
          [
            17.52547,
            52.179582,
            118.891715
          ],
          [
            17.525854,
            52.179508,
            119.08817
          ],
          [
            17.526225,
            52.179482,
            119.270194
          ],
          [
            17.526585,
            52.179466,
            119.303815
          ],
          [
            17.526916,
            52.17945,
            119.277468
          ],
          [
            17.527308,
            52.179438,
            119.246322
          ],
          [
            17.527693,
            52.179416,
            119.215618
          ],
          [
            17.528077,
            52.179393,
            119.18498
          ],
          [
            17.528482,
            52.179377,
            119.152696
          ],
          [
            17.528893,
            52.179372,
            119.120043
          ],
          [
            17.52928,
            52.179362,
            119.111201
          ],
          [
            17.52966,
            52.179347,
            119.444524
          ],
          [
            17.530038,
            52.179325,
            119.776823
          ],
          [
            17.530449,
            52.179307,
            120.137442
          ],
          [
            17.530843,
            52.179302,
            120.482561
          ],
          [
            17.531217,
            52.179278,
            120.812138
          ],
          [
            17.531614,
            52.179272,
            121.159729
          ],
          [
            17.532,
            52.179265,
            121.498054
          ],
          [
            17.532358,
            52.179235,
            121.513982
          ],
          [
            17.532742,
            52.179237,
            121.201609
          ],
          [
            17.533117,
            52.179224,
            120.897913
          ],
          [
            17.533524,
            52.179213,
            120.568507
          ],
          [
            17.533917,
            52.179201,
            120.250308
          ],
          [
            17.534327,
            52.179176,
            119.916966
          ],
          [
            17.534699,
            52.179172,
            119.616036
          ],
          [
            17.535077,
            52.179156,
            119.309261
          ],
          [
            17.535471,
            52.179129,
            119.075032
          ],
          [
            17.535877,
            52.179116,
            118.841705
          ],
          [
            17.536259,
            52.179092,
            118.621349
          ],
          [
            17.536658,
            52.17907,
            118.391429
          ],
          [
            17.537027,
            52.179054,
            118.178727
          ],
          [
            17.537402,
            52.179069,
            117.96293
          ],
          [
            17.537807,
            52.179066,
            117.730432
          ],
          [
            17.538225,
            52.179052,
            117.793502
          ],
          [
            17.538586,
            52.179038,
            118.139546
          ],
          [
            17.538947,
            52.179021,
            118.485913
          ],
          [
            17.539335,
            52.179008,
            118.857526
          ],
          [
            17.539664,
            52.178989,
            119.173406
          ],
          [
            17.540039,
            52.178974,
            119.532738
          ],
          [
            17.540406,
            52.178954,
            119.884947
          ],
          [
            17.54076,
            52.178944,
            120.225452
          ],
          [
            17.541112,
            52.178919,
            120.444916
          ],
          [
            17.541488,
            52.178905,
            120.531481
          ],
          [
            17.54188,
            52.178907,
            120.621364
          ],
          [
            17.542256,
            52.1789,
            120.707579
          ],
          [
            17.542606,
            52.178891,
            120.787851
          ],
          [
            17.542961,
            52.178862,
            120.869897
          ],
          [
            17.543347,
            52.178857,
            120.958438
          ],
          [
            17.543687,
            52.178851,
            121.03636
          ],
          [
            17.544103,
            52.178846,
            121.312246
          ],
          [
            17.544488,
            52.178821,
            121.705947
          ],
          [
            17.544842,
            52.178813,
            122.066237
          ],
          [
            17.545231,
            52.178791,
            122.464118
          ],
          [
            17.545573,
            52.178695,
            122.84714
          ],
          [
            17.545948,
            52.178568,
            123.283353
          ],
          [
            17.546314,
            52.178441,
            123.711072
          ],
          [
            17.546677,
            52.178329,
            124.007572
          ],
          [
            17.547015,
            52.178201,
            123.654916
          ],
          [
            17.547394,
            52.178074,
            123.273575
          ],
          [
            17.54776,
            52.17794,
            122.897146
          ],
          [
            17.548114,
            52.177809,
            122.531674
          ],
          [
            17.548461,
            52.177692,
            122.181888
          ],
          [
            17.548792,
            52.177586,
            121.852172
          ],
          [
            17.549138,
            52.177458,
            121.49535
          ],
          [
            17.549459,
            52.177326,
            120.847988
          ],
          [
            17.549758,
            52.1772,
            120.220841
          ],
          [
            17.550033,
            52.177097,
            119.663327
          ],
          [
            17.550286,
            52.176974,
            119.09887
          ],
          [
            17.550499,
            52.176801,
            118.48777
          ],
          [
            17.550732,
            52.176619,
            117.834883
          ],
          [
            17.550958,
            52.176467,
            117.252811
          ],
          [
            17.55117,
            52.17632,
            116.698724
          ],
          [
            17.551418,
            52.176153,
            116.340234
          ],
          [
            17.551648,
            52.176012,
            116.238195
          ],
          [
            17.551918,
            52.175816,
            116.106925
          ],
          [
            17.552098,
            52.175672,
            116.013308
          ],
          [
            17.552314,
            52.17552,
            115.910043
          ],
          [
            17.552573,
            52.175356,
            115.792961
          ],
          [
            17.552793,
            52.175211,
            115.691634
          ],
          [
            17.553077,
            52.17503,
            115.563096
          ],
          [
            17.553305,
            52.174875,
            115.425513
          ],
          [
            17.553563,
            52.174694,
            115.154092
          ],
          [
            17.553749,
            52.174525,
            114.924198
          ],
          [
            17.553947,
            52.174352,
            114.685569
          ],
          [
            17.554213,
            52.174182,
            114.41936
          ],
          [
            17.554482,
            52.174021,
            114.159403
          ],
          [
            17.554749,
            52.173872,
            113.908744
          ],
          [
            17.555007,
            52.173679,
            113.626392
          ],
          [
            17.555304,
            52.173508,
            113.301702
          ],
          [
            17.555589,
            52.173307,
            112.882789
          ],
          [
            17.555866,
            52.173112,
            112.475637
          ],
          [
            17.556116,
            52.172918,
            112.08698
          ],
          [
            17.556373,
            52.172731,
            111.702685
          ],
          [
            17.556657,
            52.172544,
            111.300315
          ],
          [
            17.55692,
            52.172354,
            110.907943
          ],
          [
            17.557166,
            52.172178,
            110.623189
          ],
          [
            17.557457,
            52.17201,
            110.602238
          ],
          [
            17.557695,
            52.171825,
            110.582095
          ],
          [
            17.557932,
            52.171651,
            110.562716
          ],
          [
            17.558165,
            52.171477,
            110.543467
          ],
          [
            17.55842,
            52.171304,
            110.523511
          ],
          [
            17.558674,
            52.171143,
            110.504355
          ],
          [
            17.558958,
            52.170961,
            110.482811
          ],
          [
            17.559222,
            52.170772,
            111.13752
          ],
          [
            17.559483,
            52.170608,
            112.17859
          ],
          [
            17.559762,
            52.170437,
            113.277126
          ],
          [
            17.56002,
            52.170276,
            114.302086
          ],
          [
            17.560261,
            52.170117,
            115.288904
          ],
          [
            17.560494,
            52.169955,
            116.27082
          ],
          [
            17.560724,
            52.169785,
            117.275167
          ],
          [
            17.561018,
            52.169602,
            118.44476
          ],
          [
            17.56138,
            52.169441,
            118.25538
          ],
          [
            17.561638,
            52.16924,
            117.829351
          ],
          [
            17.561897,
            52.169103,
            117.480236
          ],
          [
            17.562168,
            52.168935,
            117.087879
          ],
          [
            17.562425,
            52.168779,
            116.719766
          ],
          [
            17.562695,
            52.168603,
            116.318431
          ],
          [
            17.56304,
            52.168406,
            115.838122
          ],
          [
            17.563375,
            52.168222,
            115.720445
          ],
          [
            17.563738,
            52.168025,
            115.838331
          ],
          [
            17.564031,
            52.167839,
            115.94063
          ],
          [
            17.564335,
            52.167631,
            116.051158
          ],
          [
            17.564694,
            52.167493,
            116.153903
          ],
          [
            17.564989,
            52.167322,
            116.252379
          ],
          [
            17.565272,
            52.167171,
            116.343345
          ],
          [
            17.565535,
            52.167003,
            116.216826
          ],
          [
            17.565789,
            52.166835,
            116.023453
          ],
          [
            17.566024,
            52.166679,
            115.844184
          ],
          [
            17.566291,
            52.166543,
            115.663799
          ],
          [
            17.566574,
            52.166415,
            115.48193
          ],
          [
            17.566882,
            52.166238,
            115.263632
          ],
          [
            17.567196,
            52.16607,
            115.047551
          ],
          [
            17.567476,
            52.165904,
            114.865368
          ],
          [
            17.567778,
            52.165755,
            115.796052
          ],
          [
            17.568062,
            52.16561,
            116.680626
          ],
          [
            17.568391,
            52.165481,
            117.614897
          ],
          [
            17.568688,
            52.165341,
            118.510878
          ],
          [
            17.569028,
            52.165211,
            119.469432
          ],
          [
            17.569368,
            52.165093,
            120.404004
          ],
          [
            17.569693,
            52.164965,
            121.327857
          ],
          [
            17.569965,
            52.164848,
            121.894405
          ],
          [
            17.570253,
            52.164722,
            121.995003
          ],
          [
            17.570533,
            52.164596,
            122.093703
          ],
          [
            17.570838,
            52.164489,
            122.193567
          ],
          [
            17.57112,
            52.164366,
            122.291886
          ],
          [
            17.571419,
            52.164232,
            122.397135
          ],
          [
            17.571669,
            52.164104,
            122.489909
          ],
          [
            17.571966,
            52.163948,
            122.601043
          ],
          [
            17.572238,
            52.163763,
            122.660449
          ],
          [
            17.572481,
            52.163567,
            122.451416
          ],
          [
            17.572729,
            52.163392,
            122.254469
          ],
          [
            17.572944,
            52.163181,
            122.043251
          ],
          [
            17.573131,
            52.162975,
            121.842769
          ],
          [
            17.573297,
            52.162774,
            121.651339
          ],
          [
            17.573483,
            52.162598,
            121.473263
          ],
          [
            17.573656,
            52.162418,
            121.295877
          ],
          [
            17.573823,
            52.16223,
            121.149845
          ],
          [
            17.573873,
            52.16202,
            121.086064
          ],
          [
            17.573819,
            52.161812,
            121.022833
          ],
          [
            17.57372,
            52.161613,
            120.96037
          ],
          [
            17.573656,
            52.161399,
            120.895024
          ],
          [
            17.573578,
            52.1612,
            120.833595
          ],
          [
            17.573493,
            52.160998,
            120.770952
          ],
          [
            17.573406,
            52.160774,
            120.701822
          ],
          [
            17.573327,
            52.160558,
            120.63524
          ],
          [
            17.573253,
            52.160357,
            120.434782
          ],
          [
            17.573151,
            52.160152,
            120.213169
          ],
          [
            17.573056,
            52.159921,
            119.966838
          ],
          [
            17.572968,
            52.159692,
            119.723174
          ],
          [
            17.572859,
            52.159452,
            119.465259
          ],
          [
            17.572772,
            52.159216,
            119.215088
          ],
          [
            17.572643,
            52.158972,
            118.949757
          ],
          [
            17.57255,
            52.15872,
            118.736353
          ],
          [
            17.572445,
            52.158463,
            118.630027
          ],
          [
            17.572328,
            52.158192,
            118.517534
          ],
          [
            17.572228,
            52.157931,
            118.409985
          ],
          [
            17.572132,
            52.157664,
            118.300274
          ],
          [
            17.572033,
            52.157404,
            118.193004
          ],
          [
            17.571946,
            52.157162,
            118.093599
          ],
          [
            17.571813,
            52.156919,
            117.829931
          ],
          [
            17.571732,
            52.156707,
            117.501827
          ],
          [
            17.571631,
            52.156502,
            117.177874
          ],
          [
            17.571549,
            52.156318,
            116.890558
          ],
          [
            17.571476,
            52.1561,
            116.555384
          ],
          [
            17.571434,
            52.155893,
            116.241238
          ],
          [
            17.571436,
            52.155683,
            115.924544
          ],
          [
            17.571499,
            52.155482,
            115.616052
          ],
          [
            17.571562,
            52.155276,
            115.296929
          ],
          [
            17.571693,
            52.155089,
            114.963713
          ],
          [
            17.571866,
            52.154898,
            114.60562
          ],
          [
            17.572078,
            52.154726,
            114.251995
          ],
          [
            17.572294,
            52.154535,
            113.871421
          ],
          [
            17.572514,
            52.15439,
            113.547007
          ],
          [
            17.572752,
            52.154237,
            113.200554
          ],
          [
            17.572966,
            52.15408,
            112.865469
          ],
          [
            17.573189,
            52.153926,
            112.528109
          ],
          [
            17.573441,
            52.153762,
            112.210901
          ],
          [
            17.573667,
            52.153598,
            111.935536
          ],
          [
            17.573906,
            52.153453,
            111.670301
          ],
          [
            17.574139,
            52.153292,
            111.394854
          ],
          [
            17.574411,
            52.153122,
            111.08931
          ],
          [
            17.574638,
            52.152968,
            110.823722
          ],
          [
            17.574896,
            52.152823,
            110.549146
          ],
          [
            17.575131,
            52.15265,
            110.260574
          ],
          [
            17.575357,
            52.152492,
            110.057787
          ],
          [
            17.575597,
            52.152354,
            109.96626
          ],
          [
            17.575849,
            52.152177,
            109.860057
          ],
          [
            17.576098,
            52.152004,
            109.755873
          ],
          [
            17.576385,
            52.15183,
            109.644132
          ],
          [
            17.576694,
            52.15165,
            109.526128
          ],
          [
            17.576963,
            52.151469,
            109.415561
          ],
          [
            17.577222,
            52.151288,
            109.30672
          ],
          [
            17.577467,
            52.151126,
            109.108515
          ],
          [
            17.577737,
            52.150948,
            108.857521
          ],
          [
            17.578001,
            52.150787,
            108.621808
          ],
          [
            17.578253,
            52.150614,
            108.382324
          ],
          [
            17.578516,
            52.150438,
            108.135626
          ],
          [
            17.578786,
            52.150262,
            107.886122
          ],
          [
            17.579038,
            52.1501,
            107.654914
          ],
          [
            17.579293,
            52.14993,
            107.419936
          ],
          [
            17.57955,
            52.149783,
            107.272662
          ],
          [
            17.579801,
            52.149616,
            107.116714
          ],
          [
            17.580037,
            52.149466,
            106.973885
          ],
          [
            17.580307,
            52.149309,
            106.817514
          ],
          [
            17.580588,
            52.149145,
            106.654971
          ],
          [
            17.580874,
            52.148991,
            106.495491
          ],
          [
            17.581157,
            52.148846,
            106.340847
          ],
          [
            17.581419,
            52.148701,
            106.193844
          ],
          [
            17.581702,
            52.148562,
            106.068896
          ],
          [
            17.581979,
            52.148419,
            105.944133
          ],
          [
            17.582264,
            52.148284,
            105.820036
          ],
          [
            17.582528,
            52.148146,
            105.700492
          ],
          [
            17.582791,
            52.148009,
            105.581518
          ],
          [
            17.583055,
            52.147872,
            105.462346
          ],
          [
            17.583337,
            52.147733,
            105.337676
          ],
          [
            17.583605,
            52.147598,
            105.21812
          ],
          [
            17.583869,
            52.147446,
            105.328674
          ],
          [
            17.584163,
            52.147312,
            105.515276
          ],
          [
            17.584403,
            52.147183,
            105.677763
          ],
          [
            17.584668,
            52.147055,
            105.849479
          ],
          [
            17.584923,
            52.146901,
            106.032527
          ],
          [
            17.5852,
            52.146742,
            106.225736
          ],
          [
            17.585452,
            52.146591,
            106.405085
          ],
          [
            17.585715,
            52.146453,
            106.581354
          ],
          [
            17.58593,
            52.146314,
            106.531042
          ],
          [
            17.586186,
            52.146187,
            106.108048
          ],
          [
            17.586419,
            52.14606,
            105.709356
          ],
          [
            17.586664,
            52.14594,
            105.308194
          ],
          [
            17.58693,
            52.145793,
            104.850483
          ],
          [
            17.587161,
            52.14563,
            104.400553
          ],
          [
            17.587291,
            52.145431,
            103.952958
          ],
          [
            17.587454,
            52.145237,
            103.498251
          ],
          [
            17.587588,
            52.14507,
            103.110465
          ],
          [
            17.58776,
            52.144863,
            103.297682
          ],
          [
            17.587897,
            52.144668,
            103.818904
          ],
          [
            17.588008,
            52.144428,
            104.431713
          ],
          [
            17.588157,
            52.144242,
            104.940355
          ],
          [
            17.588383,
            52.144067,
            105.490493
          ],
          [
            17.588672,
            52.144135,
            106.005673
          ],
          [
            17.588867,
            52.144328,
            106.56253
          ],
          [
            17.589018,
            52.144516,
            107.076754
          ],
          [
            17.589189,
            52.144677,
            107.612544
          ],
          [
            17.589395,
            52.144849,
            108.301589
          ],
          [
            17.58955,
            52.145018,
            108.925112
          ],
          [
            17.589742,
            52.145195,
            109.607048
          ],
          [
            17.589916,
            52.145363,
            110.2476
          ],
          [
            17.590124,
            52.14551,
            110.874907
          ],
          [
            17.59026,
            52.145675,
            111.468181
          ],
          [
            17.590419,
            52.145838,
            112.077417
          ],
          [
            17.590603,
            52.146011,
            112.739861
          ],
          [
            17.590788,
            52.146184,
            113.276568
          ],
          [
            17.590981,
            52.146365,
            113.669482
          ],
          [
            17.591131,
            52.146535,
            114.01818
          ],
          [
            17.591315,
            52.146717,
            114.404194
          ],
          [
            17.591476,
            52.146875,
            114.740106
          ],
          [
            17.591668,
            52.147063,
            115.139693
          ],
          [
            17.59185,
            52.147225,
            115.493895
          ],
          [
            17.592006,
            52.147404,
            115.859345
          ],
          [
            17.592164,
            52.147582,
            116.224326
          ],
          [
            17.592309,
            52.147751,
            116.573078
          ],
          [
            17.59246,
            52.147911,
            116.913531
          ],
          [
            17.592672,
            52.148106,
            117.345113
          ],
          [
            17.592831,
            52.148278,
            117.709918
          ],
          [
            17.593012,
            52.148453,
            118.091464
          ],
          [
            17.593196,
            52.148636,
            118.4879
          ],
          [
            17.593387,
            52.148806,
            118.867984
          ],
          [
            17.593566,
            52.148985,
            119.254797
          ],
          [
            17.593733,
            52.149196,
            119.628923
          ],
          [
            17.593914,
            52.149384,
            119.127088
          ],
          [
            17.594099,
            52.149579,
            118.609148
          ],
          [
            17.594281,
            52.149771,
            118.098822
          ],
          [
            17.594482,
            52.149974,
            117.552364
          ],
          [
            17.594727,
            52.150203,
            116.923436
          ],
          [
            17.594885,
            52.15038,
            116.459615
          ],
          [
            17.595066,
            52.150539,
            116.008672
          ],
          [
            17.595257,
            52.150728,
            115.53609
          ],
          [
            17.595446,
            52.150921,
            115.594013
          ],
          [
            17.595647,
            52.151122,
            115.654689
          ],
          [
            17.595825,
            52.15135,
            115.719733
          ],
          [
            17.596022,
            52.151551,
            115.780087
          ],
          [
            17.596203,
            52.151742,
            115.836923
          ],
          [
            17.596365,
            52.151922,
            115.88991
          ],
          [
            17.596574,
            52.152108,
            115.948028
          ],
          [
            17.596713,
            52.152273,
            115.999467
          ],
          [
            17.596895,
            52.152476,
            116.291072
          ],
          [
            17.597059,
            52.152654,
            116.548122
          ],
          [
            17.597212,
            52.152856,
            116.829162
          ],
          [
            17.597358,
            52.153061,
            117.11038
          ],
          [
            17.597482,
            52.153233,
            117.346807
          ],
          [
            17.597595,
            52.153405,
            117.579919
          ],
          [
            17.597723,
            52.153578,
            117.818754
          ],
          [
            17.59787,
            52.153754,
            118.067397
          ],
          [
            17.59808,
            52.15389,
            118.240375
          ],
          [
            17.59836,
            52.153997,
            118.159151
          ],
          [
            17.598706,
            52.154102,
            118.064126
          ],
          [
            17.599053,
            52.154178,
            117.973245
          ],
          [
            17.599383,
            52.154298,
            117.878823
          ],
          [
            17.599665,
            52.154374,
            117.803037
          ],
          [
            17.599942,
            52.154458,
            117.726825
          ],
          [
            17.600209,
            52.154547,
            117.6519
          ],
          [
            17.60045,
            52.15466,
            117.577226
          ],
          [
            17.600674,
            52.15481,
            117.522132
          ],
          [
            17.600905,
            52.154969,
            117.49455
          ],
          [
            17.601172,
            52.155131,
            117.464823
          ],
          [
            17.601412,
            52.15527,
            117.438739
          ],
          [
            17.601713,
            52.155399,
            117.409653
          ],
          [
            17.601953,
            52.155525,
            117.384678
          ],
          [
            17.602197,
            52.155677,
            117.357177
          ],
          [
            17.602447,
            52.15578,
            117.333145
          ],
          [
            17.602714,
            52.155902,
            117.30683
          ],
          [
            17.602948,
            52.156043,
            117.073163
          ],
          [
            17.603277,
            52.156204,
            116.729085
          ],
          [
            17.603493,
            52.156341,
            116.475077
          ],
          [
            17.603759,
            52.156471,
            116.195141
          ],
          [
            17.60409,
            52.156585,
            115.88484
          ],
          [
            17.604444,
            52.156727,
            115.538881
          ],
          [
            17.604841,
            52.15682,
            115.19107
          ],
          [
            17.60519,
            52.156898,
            114.922768
          ],
          [
            17.605539,
            52.156931,
            115.167701
          ],
          [
            17.605925,
            52.157015,
            115.450096
          ],
          [
            17.606286,
            52.157084,
            115.709973
          ],
          [
            17.606645,
            52.157146,
            115.966398
          ],
          [
            17.607024,
            52.157226,
            116.242402
          ],
          [
            17.60742,
            52.15731,
            116.530311
          ],
          [
            17.607833,
            52.157371,
            116.82386
          ],
          [
            17.608221,
            52.157431,
            116.807167
          ],
          [
            17.608594,
            52.15748,
            116.639144
          ],
          [
            17.608975,
            52.157516,
            116.469346
          ],
          [
            17.609394,
            52.157558,
            116.282383
          ],
          [
            17.609755,
            52.157599,
            116.120712
          ],
          [
            17.610095,
            52.157629,
            115.969408
          ],
          [
            17.610464,
            52.157654,
            115.805836
          ],
          [
            17.61078,
            52.157689,
            115.664287
          ],
          [
            17.611091,
            52.15773,
            115.300688
          ],
          [
            17.611445,
            52.157744,
            114.816718
          ],
          [
            17.611778,
            52.157758,
            114.361554
          ],
          [
            17.612148,
            52.157771,
            113.855884
          ],
          [
            17.612506,
            52.157785,
            113.365155
          ],
          [
            17.612867,
            52.157771,
            112.871942
          ],
          [
            17.613177,
            52.157733,
            112.440926
          ],
          [
            17.613551,
            52.157711,
            111.928601
          ],
          [
            17.613916,
            52.157682,
            111.527911
          ],
          [
            17.614301,
            52.157661,
            111.260053
          ],
          [
            17.614686,
            52.157618,
            110.988835
          ],
          [
            17.615099,
            52.157595,
            110.701456
          ],
          [
            17.615514,
            52.157581,
            110.413432
          ],
          [
            17.615918,
            52.15755,
            110.131174
          ],
          [
            17.616328,
            52.15754,
            109.846606
          ],
          [
            17.616743,
            52.157509,
            109.635844
          ],
          [
            17.61714,
            52.157482,
            109.851119
          ],
          [
            17.617572,
            52.157458,
            110.084177
          ],
          [
            17.617957,
            52.157438,
            110.291607
          ],
          [
            17.618336,
            52.157418,
            110.495908
          ],
          [
            17.618668,
            52.157361,
            110.681047
          ],
          [
            17.618985,
            52.157274,
            110.867615
          ],
          [
            17.619351,
            52.157187,
            111.078651
          ],
          [
            17.61971,
            52.157107,
            111.256455
          ],
          [
            17.620067,
            52.157031,
            111.408517
          ],
          [
            17.620397,
            52.156942,
            111.553541
          ],
          [
            17.620758,
            52.156847,
            111.711667
          ],
          [
            17.62109,
            52.156775,
            111.853492
          ],
          [
            17.621443,
            52.156707,
            112.002447
          ],
          [
            17.621744,
            52.156632,
            112.133282
          ],
          [
            17.622074,
            52.156558,
            112.274815
          ],
          [
            17.622434,
            52.156485,
            112.420765
          ],
          [
            17.622784,
            52.156401,
            112.558439
          ],
          [
            17.623123,
            52.156347,
            112.686625
          ],
          [
            17.623415,
            52.156288,
            112.799514
          ],
          [
            17.623712,
            52.156218,
            112.916027
          ],
          [
            17.624031,
            52.156143,
            113.041291
          ],
          [
            17.624356,
            52.15609,
            113.164388
          ],
          [
            17.62463,
            52.156014,
            113.274464
          ],
          [
            17.624982,
            52.155943,
            113.410112
          ],
          [
            17.625338,
            52.155866,
            113.35499
          ],
          [
            17.625701,
            52.155793,
            113.271271
          ],
          [
            17.62607,
            52.155712,
            113.185474
          ],
          [
            17.626431,
            52.155637,
            113.102043
          ],
          [
            17.626786,
            52.155545,
            113.017692
          ],
          [
            17.627178,
            52.155468,
            112.927514
          ],
          [
            17.627551,
            52.155393,
            112.841597
          ],
          [
            17.62792,
            52.155329,
            113.015925
          ],
          [
            17.628264,
            52.155253,
            113.667917
          ],
          [
            17.628607,
            52.155177,
            114.318458
          ],
          [
            17.628939,
            52.155111,
            114.940699
          ],
          [
            17.62929,
            52.155044,
            115.596183
          ],
          [
            17.629643,
            52.154975,
            116.257008
          ],
          [
            17.629999,
            52.154896,
            116.932024
          ],
          [
            17.630377,
            52.154814,
            117.648246
          ],
          [
            17.630764,
            52.154722,
            118.169612
          ],
          [
            17.631132,
            52.154636,
            118.46309
          ],
          [
            17.631488,
            52.154545,
            118.750468
          ],
          [
            17.631823,
            52.154486,
            119.010331
          ],
          [
            17.632169,
            52.154416,
            119.281841
          ],
          [
            17.632519,
            52.154333,
            119.561499
          ],
          [
            17.632876,
            52.154243,
            119.849431
          ],
          [
            17.633225,
            52.154162,
            120.127817
          ],
          [
            17.633536,
            52.154092,
            120.056622
          ],
          [
            17.633821,
            52.154019,
            119.874408
          ],
          [
            17.634134,
            52.153968,
            119.683482
          ],
          [
            17.634443,
            52.153884,
            119.484022
          ],
          [
            17.634774,
            52.153817,
            119.27849
          ],
          [
            17.635116,
            52.153729,
            119.059781
          ],
          [
            17.635462,
            52.153669,
            118.84772
          ],
          [
            17.635779,
            52.153571,
            118.638457
          ],
          [
            17.636056,
            52.153495,
            118.490641
          ],
          [
            17.636482,
            52.153416,
            119.10198
          ],
          [
            17.636785,
            52.153367,
            119.531965
          ],
          [
            17.637098,
            52.153302,
            119.98535
          ],
          [
            17.637411,
            52.153194,
            120.484349
          ],
          [
            17.637764,
            52.153142,
            120.983437
          ],
          [
            17.638111,
            52.153056,
            121.49755
          ],
          [
            17.638415,
            52.152986,
            121.943828
          ],
          [
            17.638727,
            52.152927,
            122.392911
          ],
          [
            17.639051,
            52.152867,
            122.44614
          ],
          [
            17.639384,
            52.152785,
            122.385702
          ],
          [
            17.639745,
            52.152712,
            122.321648
          ],
          [
            17.640111,
            52.152618,
            122.254805
          ],
          [
            17.640443,
            52.152547,
            122.195408
          ],
          [
            17.640787,
            52.152458,
            122.132516
          ],
          [
            17.641115,
            52.15236,
            122.070816
          ],
          [
            17.641462,
            52.152286,
            122.008941
          ],
          [
            17.641805,
            52.152217,
            121.634411
          ],
          [
            17.642176,
            52.152142,
            121.149849
          ],
          [
            17.64252,
            52.152078,
            120.703679
          ],
          [
            17.642831,
            52.152006,
            120.291404
          ],
          [
            17.643195,
            52.151908,
            119.796752
          ],
          [
            17.643541,
            52.151841,
            119.343413
          ],
          [
            17.643836,
            52.151779,
            118.956625
          ],
          [
            17.644202,
            52.151686,
            118.465093
          ],
          [
            17.64461,
            52.1516,
            117.289115
          ],
          [
            17.644915,
            52.151525,
            116.276129
          ],
          [
            17.64522,
            52.151443,
            115.249133
          ],
          [
            17.645519,
            52.151373,
            114.263344
          ],
          [
            17.645858,
            52.151311,
            113.171989
          ],
          [
            17.646187,
            52.151201,
            112.013822
          ],
          [
            17.646508,
            52.151115,
            110.935415
          ],
          [
            17.64681,
            52.151021,
            109.892433
          ],
          [
            17.647168,
            52.150924,
            109.490763
          ],
          [
            17.647526,
            52.150852,
            109.757984
          ],
          [
            17.647805,
            52.150785,
            109.970034
          ],
          [
            17.648116,
            52.150745,
            110.194943
          ],
          [
            17.648408,
            52.150692,
            110.410558
          ],
          [
            17.648805,
            52.150633,
            110.699962
          ],
          [
            17.649171,
            52.150583,
            110.965362
          ],
          [
            17.649489,
            52.150537,
            111.196707
          ],
          [
            17.649779,
            52.150493,
            111.408279
          ],
          [
            17.650124,
            52.150436,
            111.63644
          ],
          [
            17.650464,
            52.150373,
            111.863725
          ],
          [
            17.650801,
            52.150321,
            112.085087
          ],
          [
            17.651154,
            52.150273,
            112.315952
          ],
          [
            17.651535,
            52.150235,
            112.561846
          ],
          [
            17.651922,
            52.150198,
            112.811391
          ],
          [
            17.652307,
            52.150141,
            113.063539
          ],
          [
            17.652742,
            52.150101,
            113.327001
          ],
          [
            17.653128,
            52.150014,
            113.517173
          ],
          [
            17.653532,
            52.149948,
            113.710069
          ],
          [
            17.653945,
            52.149894,
            113.904784
          ],
          [
            17.654348,
            52.149814,
            114.100409
          ],
          [
            17.654735,
            52.149746,
            114.286192
          ],
          [
            17.65513,
            52.149668,
            114.477523
          ],
          [
            17.655503,
            52.149604,
            114.640504
          ],
          [
            17.655869,
            52.149546,
            114.697666
          ],
          [
            17.656268,
            52.149492,
            114.759451
          ],
          [
            17.656684,
            52.149436,
            114.823847
          ],
          [
            17.657093,
            52.149364,
            114.888194
          ],
          [
            17.657488,
            52.149318,
            114.949187
          ],
          [
            17.65786,
            52.149262,
            115.007109
          ],
          [
            17.658215,
            52.14919,
            115.063669
          ],
          [
            17.658584,
            52.149114,
            115.057678
          ],
          [
            17.658928,
            52.149089,
            115.036967
          ],
          [
            17.659318,
            52.14902,
            115.012604
          ],
          [
            17.659717,
            52.148947,
            114.98772
          ],
          [
            17.660098,
            52.148885,
            114.964164
          ],
          [
            17.660479,
            52.148795,
            114.939687
          ],
          [
            17.66085,
            52.148756,
            114.917146
          ],
          [
            17.661202,
            52.148797,
            114.976681
          ],
          [
            17.661536,
            52.148912,
            115.303835
          ],
          [
            17.661912,
            52.14904,
            115.670736
          ],
          [
            17.662282,
            52.149136,
            116.013749
          ],
          [
            17.662675,
            52.149242,
            116.380266
          ],
          [
            17.663036,
            52.14935,
            116.722908
          ],
          [
            17.663411,
            52.149481,
            117.091986
          ],
          [
            17.663741,
            52.149625,
            117.386803
          ],
          [
            17.664078,
            52.149722,
            117.269869
          ],
          [
            17.664424,
            52.149829,
            117.148158
          ],
          [
            17.664775,
            52.149953,
            117.020516
          ],
          [
            17.665156,
            52.150078,
            116.884925
          ],
          [
            17.665505,
            52.150211,
            116.755893
          ],
          [
            17.665881,
            52.150292,
            116.630247
          ],
          [
            17.666223,
            52.150385,
            116.512821
          ],
          [
            17.666545,
            52.150516,
            115.979706
          ],
          [
            17.666842,
            52.150688,
            115.274945
          ],
          [
            17.667164,
            52.150899,
            114.462196
          ],
          [
            17.667498,
            52.151111,
            113.631177
          ],
          [
            17.667798,
            52.151312,
            112.864734
          ],
          [
            17.668033,
            52.151497,
            112.204478
          ],
          [
            17.668295,
            52.151649,
            111.579717
          ],
          [
            17.668538,
            52.151803,
            111.638074
          ],
          [
            17.668759,
            52.151945,
            111.900911
          ],
          [
            17.668987,
            52.152118,
            112.198091
          ],
          [
            17.669264,
            52.152259,
            112.493601
          ],
          [
            17.669484,
            52.152399,
            112.753313
          ],
          [
            17.669697,
            52.152561,
            113.031394
          ],
          [
            17.669948,
            52.152722,
            113.328939
          ],
          [
            17.670218,
            52.152928,
            113.682005
          ],
          [
            17.670463,
            52.153084,
            114.002053
          ],
          [
            17.67065,
            52.153234,
            114.303575
          ],
          [
            17.670859,
            52.153381,
            114.614832
          ],
          [
            17.671158,
            52.15353,
            114.993463
          ],
          [
            17.671373,
            52.153678,
            115.30976
          ],
          [
            17.671586,
            52.153843,
            115.645512
          ],
          [
            17.671806,
            52.153993,
            115.968002
          ],
          [
            17.672062,
            52.154161,
            116.335917
          ],
          [
            17.672312,
            52.15432,
            116.689886
          ],
          [
            17.672535,
            52.154446,
            117.108228
          ],
          [
            17.672814,
            52.154626,
            117.670484
          ],
          [
            17.673114,
            52.154812,
            118.262754
          ],
          [
            17.673331,
            52.154992,
            118.769513
          ],
          [
            17.673569,
            52.155148,
            119.25338
          ],
          [
            17.673813,
            52.15531,
            119.752709
          ],
          [
            17.674022,
            52.155445,
            120.174182
          ],
          [
            17.674248,
            52.155606,
            120.65507
          ],
          [
            17.674495,
            52.155764,
            121.012068
          ],
          [
            17.674696,
            52.155918,
            121.301978
          ],
          [
            17.674901,
            52.156062,
            121.578618
          ],
          [
            17.675134,
            52.156215,
            121.881614
          ],
          [
            17.675378,
            52.15639,
            122.21499
          ],
          [
            17.675624,
            52.156535,
            122.517835
          ],
          [
            17.67585,
            52.156685,
            122.813439
          ],
          [
            17.676072,
            52.156839,
            123.11149
          ],
          [
            17.676317,
            52.157014,
            123.250146
          ],
          [
            17.676556,
            52.157173,
            122.761734
          ],
          [
            17.676827,
            52.157341,
            122.229054
          ],
          [
            17.677081,
            52.157507,
            121.71561
          ],
          [
            17.677292,
            52.157658,
            121.267208
          ],
          [
            17.677516,
            52.157807,
            120.810416
          ],
          [
            17.677758,
            52.157938,
            120.360855
          ],
          [
            17.678002,
            52.158105,
            119.855445
          ],
          [
            17.678242,
            52.158278,
            119.343186
          ],
          [
            17.6785,
            52.158451,
            119.09899
          ],
          [
            17.678745,
            52.158632,
            118.869317
          ],
          [
            17.678979,
            52.158826,
            118.633652
          ],
          [
            17.679207,
            52.158993,
            118.420561
          ],
          [
            17.67945,
            52.15914,
            118.216426
          ],
          [
            17.679686,
            52.159294,
            118.010287
          ],
          [
            17.679911,
            52.159465,
            117.795479
          ],
          [
            17.68015,
            52.159644,
            117.569638
          ],
          [
            17.680357,
            52.159787,
            117.762303
          ],
          [
            17.680587,
            52.159958,
            118.004185
          ],
          [
            17.680792,
            52.160126,
            118.233148
          ],
          [
            17.681017,
            52.160274,
            118.454044
          ],
          [
            17.681257,
            52.160421,
            118.681079
          ],
          [
            17.681466,
            52.160569,
            118.894996
          ],
          [
            17.681671,
            52.160738,
            119.124876
          ],
          [
            17.681892,
            52.160913,
            119.366467
          ],
          [
            17.682157,
            52.161093,
            119.278325
          ],
          [
            17.682421,
            52.161242,
            118.723326
          ],
          [
            17.682633,
            52.16139,
            118.227714
          ],
          [
            17.68286,
            52.161561,
            117.67296
          ],
          [
            17.683069,
            52.161704,
            117.189791
          ],
          [
            17.683309,
            52.161851,
            116.666373
          ],
          [
            17.683561,
            52.16204,
            116.050539
          ],
          [
            17.68376,
            52.16223,
            115.482333
          ],
          [
            17.68388,
            52.162419,
            114.958625
          ],
          [
            17.683992,
            52.16268,
            114.043389
          ],
          [
            17.684134,
            52.16294,
            113.114186
          ],
          [
            17.684262,
            52.163236,
            112.078272
          ],
          [
            17.684458,
            52.163543,
            110.963293
          ],
          [
            17.684771,
            52.163816,
            109.826767
          ],
          [
            17.685181,
            52.164003,
            108.887784
          ],
          [
            17.685596,
            52.164076,
            108.731225
          ],
          [
            17.685948,
            52.164185,
            108.585367
          ],
          [
            17.686268,
            52.164306,
            108.449072
          ],
          [
            17.686562,
            52.164409,
            108.325872
          ],
          [
            17.686841,
            52.164511,
            108.20801
          ],
          [
            17.687119,
            52.16461,
            108.091044
          ],
          [
            17.687467,
            52.164744,
            107.942084
          ],
          [
            17.687768,
            52.164838,
            107.808124
          ],
          [
            17.68807,
            52.16488,
            107.653046
          ],
          [
            17.688359,
            52.164728,
            107.448142
          ],
          [
            17.688663,
            52.16472,
            107.299525
          ],
          [
            17.68897,
            52.164724,
            107.151246
          ],
          [
            17.688792,
            52.164756,
            107.010375
          ],
          [
            17.689107,
            52.164733,
            106.855751
          ],
          [
            17.689332,
            52.164866,
            106.699979
          ],
          [
            17.689596,
            52.164996,
            106.536438
          ],
          [
            17.689714,
            52.165177,
            106.714866
          ],
          [
            17.689936,
            52.165318,
            107.453508
          ],
          [
            17.690115,
            52.165478,
            108.186948
          ],
          [
            17.690298,
            52.165724,
            109.215578
          ],
          [
            17.690452,
            52.165896,
            109.954488
          ],
          [
            17.690611,
            52.166075,
            110.726386
          ],
          [
            17.690775,
            52.166255,
            111.506588
          ],
          [
            17.690921,
            52.166435,
            112.263588
          ],
          [
            17.691042,
            52.166607,
            112.969708
          ],
          [
            17.691096,
            52.166796,
            113.731922
          ],
          [
            17.691037,
            52.166992,
            114.548725
          ],
          [
            17.690708,
            52.167104,
            115.517771
          ],
          [
            17.69037,
            52.167154,
            116.386433
          ],
          [
            17.690016,
            52.167151,
            117.267528
          ],
          [
            17.6897,
            52.167199,
            118.076452
          ],
          [
            17.689377,
            52.167225,
            118.894623
          ],
          [
            17.689228,
            52.167053,
            119.684854
          ],
          [
            17.688921,
            52.167082,
            120.480401
          ],
          [
            17.688574,
            52.167132,
            121.339321
          ],
          [
            17.688232,
            52.167116,
            122.194608
          ],
          [
            17.687918,
            52.167137,
            122.965337
          ],
          [
            17.687749,
            52.16726,
            123.673216
          ],
          [
            17.687744,
            52.167164,
            124.41474
          ],
          [
            17.688021,
            52.167092,
            125.160058
          ],
          [
            17.688341,
            52.167121,
            125.945875
          ],
          [
            17.688458,
            52.16734,
            126.858727
          ],
          [
            17.688539,
            52.167537,
            127.533337
          ],
          [
            17.688644,
            52.167724,
            127.389547
          ],
          [
            17.68872,
            52.167916,
            127.257613
          ],
          [
            17.688815,
            52.16811,
            127.122683
          ],
          [
            17.688916,
            52.168332,
            126.967958
          ],
          [
            17.68901,
            52.168555,
            126.814472
          ],
          [
            17.689105,
            52.168764,
            126.669952
          ],
          [
            17.6892,
            52.168972,
            126.525888
          ],
          [
            17.689257,
            52.16916,
            126.398518
          ],
          [
            17.689344,
            52.169351,
            126.305695
          ],
          [
            17.689405,
            52.169555,
            126.229749
          ],
          [
            17.689495,
            52.169756,
            126.153577
          ],
          [
            17.689589,
            52.169946,
            126.080972
          ],
          [
            17.689728,
            52.170187,
            125.987534
          ],
          [
            17.689887,
            52.170388,
            125.905246
          ],
          [
            17.69016,
            52.17047,
            125.834927
          ],
          [
            17.690453,
            52.170381,
            125.760998
          ],
          [
            17.690775,
            52.170237,
            125.538117
          ],
          [
            17.69102,
            52.170127,
            125.102709
          ],
          [
            17.691256,
            52.170014,
            124.673533
          ],
          [
            17.691596,
            52.169856,
            124.062256
          ],
          [
            17.691857,
            52.169729,
            123.584837
          ],
          [
            17.692146,
            52.169594,
            123.062682
          ],
          [
            17.692403,
            52.169448,
            122.557533
          ],
          [
            17.692664,
            52.169327,
            122.088293
          ],
          [
            17.692905,
            52.169199,
            121.631485
          ],
          [
            17.693172,
            52.169088,
            121.153227
          ],
          [
            17.693443,
            52.168945,
            120.615361
          ],
          [
            17.693744,
            52.168812,
            120.057425
          ],
          [
            17.694034,
            52.168686,
            119.520832
          ],
          [
            17.694323,
            52.168536,
            118.950657
          ],
          [
            17.694626,
            52.168387,
            118.366383
          ],
          [
            17.694943,
            52.168241,
            117.770333
          ],
          [
            17.69526,
            52.168098,
            117.178712
          ],
          [
            17.695573,
            52.167946,
            116.880613
          ],
          [
            17.695878,
            52.167798,
            116.644095
          ],
          [
            17.696187,
            52.167644,
            116.401954
          ],
          [
            17.696477,
            52.167492,
            116.169964
          ],
          [
            17.696803,
            52.167328,
            115.913472
          ],
          [
            17.69711,
            52.167145,
            115.653014
          ],
          [
            17.697395,
            52.166947,
            115.391095
          ],
          [
            17.697611,
            52.166777,
            114.939391
          ],
          [
            17.697846,
            52.166605,
            114.289122
          ],
          [
            17.698137,
            52.166587,
            113.614199
          ],
          [
            17.698259,
            52.166779,
            113.019178
          ],
          [
            17.698275,
            52.167017,
            112.333404
          ],
          [
            17.698253,
            52.167239,
            111.694111
          ],
          [
            17.698243,
            52.16747,
            111.028004
          ],
          [
            17.698281,
            52.167703,
            110.3545
          ],
          [
            17.698312,
            52.167924,
            110.050823
          ],
          [
            17.698413,
            52.168129,
            109.928584
          ],
          [
            17.698709,
            52.16823,
            109.809747
          ],
          [
            17.699012,
            52.168289,
            109.699711
          ],
          [
            17.699294,
            52.168363,
            109.593491
          ],
          [
            17.699608,
            52.168448,
            109.474266
          ],
          [
            17.699883,
            52.168579,
            109.353706
          ],
          [
            17.699872,
            52.168648,
            109.240337
          ],
          [
            17.699588,
            52.168568,
            109.131976
          ],
          [
            17.699791,
            52.168723,
            108.586727
          ],
          [
            17.700007,
            52.16887,
            108.000443
          ],
          [
            17.700212,
            52.16904,
            107.374608
          ],
          [
            17.700398,
            52.169205,
            106.778517
          ],
          [
            17.700213,
            52.169034,
            106.1708
          ],
          [
            17.700088,
            52.168818,
            105.492456
          ],
          [
            17.700076,
            52.168615,
            104.890093
          ],
          [
            17.700362,
            52.168698,
            104.314796
          ],
          [
            17.700665,
            52.16874,
            103.829543
          ],
          [
            17.700376,
            52.168663,
            104.075467
          ],
          [
            17.700015,
            52.16859,
            104.367835
          ],
          [
            17.699719,
            52.168485,
            104.630698
          ],
          [
            17.699606,
            52.168339,
            104.864341
          ],
          [
            17.69992,
            52.168281,
            105.116187
          ],
          [
            17.700247,
            52.168226,
            105.376493
          ],
          [
            17.700579,
            52.168106,
            105.672904
          ],
          [
            17.700793,
            52.167976,
            105.903988
          ],
          [
            17.70109,
            52.167818,
            106.253365
          ],
          [
            17.701415,
            52.167665,
            106.659056
          ],
          [
            17.701674,
            52.167535,
            106.991526
          ],
          [
            17.701995,
            52.167417,
            107.363691
          ],
          [
            17.702309,
            52.16732,
            107.711706
          ],
          [
            17.702642,
            52.167233,
            108.070686
          ],
          [
            17.702894,
            52.167122,
            108.379487
          ],
          [
            17.703084,
            52.166959,
            108.707136
          ],
          [
            17.703365,
            52.16683,
            108.832818
          ],
          [
            17.703649,
            52.166734,
            108.493785
          ],
          [
            17.703978,
            52.166645,
            108.116612
          ],
          [
            17.704307,
            52.166583,
            107.752233
          ],
          [
            17.704651,
            52.166642,
            107.369616
          ],
          [
            17.70489,
            52.16681,
            106.984846
          ],
          [
            17.705063,
            52.167002,
            106.611155
          ],
          [
            17.705272,
            52.167223,
            106.175839
          ],
          [
            17.705438,
            52.167412,
            105.940993
          ],
          [
            17.705742,
            52.167579,
            106.287225
          ],
          [
            17.706101,
            52.16768,
            106.614854
          ],
          [
            17.706424,
            52.167733,
            106.895622
          ],
          [
            17.706727,
            52.167821,
            107.173676
          ],
          [
            17.707018,
            52.167915,
            107.446776
          ],
          [
            17.707295,
            52.168013,
            107.712795
          ],
          [
            17.707531,
            52.168142,
            107.975166
          ],
          [
            17.707778,
            52.16829,
            108.261635
          ],
          [
            17.708017,
            52.16846,
            108.360875
          ],
          [
            17.708302,
            52.168632,
            108.421788
          ],
          [
            17.708558,
            52.168797,
            108.478086
          ],
          [
            17.708785,
            52.168925,
            108.524876
          ],
          [
            17.709003,
            52.169071,
            108.573858
          ],
          [
            17.709237,
            52.169209,
            108.623076
          ],
          [
            17.709463,
            52.16937,
            108.675592
          ],
          [
            17.709652,
            52.169546,
            108.727716
          ],
          [
            17.709812,
            52.169708,
            108.80851
          ],
          [
            17.709964,
            52.169898,
            108.979596
          ],
          [
            17.710166,
            52.170103,
            109.173802
          ],
          [
            17.710335,
            52.1703,
            109.35371
          ],
          [
            17.710606,
            52.170502,
            109.565481
          ],
          [
            17.71078,
            52.170647,
            109.711011
          ],
          [
            17.710975,
            52.170796,
            109.865482
          ],
          [
            17.711179,
            52.170942,
            110.021151
          ],
          [
            17.711417,
            52.171076,
            110.181498
          ],
          [
            17.711691,
            52.171182,
            110.01047
          ],
          [
            17.711989,
            52.171237,
            109.768304
          ],
          [
            17.712303,
            52.171244,
            109.524116
          ],
          [
            17.712631,
            52.171205,
            109.264264
          ],
          [
            17.712943,
            52.171106,
            108.991188
          ],
          [
            17.713328,
            52.171003,
            108.664093
          ],
          [
            17.713649,
            52.17091,
            108.388135
          ],
          [
            17.713984,
            52.170833,
            108.109776
          ],
          [
            17.714333,
            52.170702,
            108.139223
          ],
          [
            17.714587,
            52.170585,
            108.487776
          ],
          [
            17.714818,
            52.170412,
            108.887774
          ],
          [
            17.715019,
            52.170275,
            109.217828
          ],
          [
            17.715219,
            52.170131,
            109.557154
          ],
          [
            17.715414,
            52.169991,
            109.886539
          ],
          [
            17.715623,
            52.169803,
            110.293652
          ],
          [
            17.715822,
            52.169628,
            110.675717
          ],
          [
            17.715952,
            52.169444,
            111.035058
          ],
          [
            17.716155,
            52.169289,
            110.872448
          ],
          [
            17.716318,
            52.169121,
            110.464029
          ],
          [
            17.716513,
            52.168936,
            110.003173
          ],
          [
            17.716665,
            52.16876,
            109.584135
          ],
          [
            17.71683,
            52.168602,
            109.191721
          ],
          [
            17.71699,
            52.168408,
            108.73577
          ],
          [
            17.717171,
            52.168236,
            108.308026
          ],
          [
            17.717331,
            52.168062,
            107.888994
          ],
          [
            17.717489,
            52.167887,
            107.471081
          ],
          [
            17.717671,
            52.167709,
            107.377093
          ],
          [
            17.717843,
            52.167549,
            107.357859
          ],
          [
            17.718006,
            52.167377,
            107.337907
          ],
          [
            17.718209,
            52.167204,
            107.316519
          ],
          [
            17.718385,
            52.167036,
            107.296462
          ],
          [
            17.718551,
            52.166833,
            107.273644
          ],
          [
            17.71865,
            52.166622,
            107.251257
          ],
          [
            17.718602,
            52.166432,
            107.231806
          ],
          [
            17.718606,
            52.166215,
            107.23053
          ],
          [
            17.718662,
            52.165995,
            107.319399
          ],
          [
            17.718805,
            52.165751,
            107.421964
          ],
          [
            17.718958,
            52.165554,
            107.508266
          ],
          [
            17.719073,
            52.165368,
            107.586919
          ],
          [
            17.719185,
            52.165192,
            107.661717
          ],
          [
            17.719343,
            52.164973,
            107.7567
          ],
          [
            17.719473,
            52.164768,
            107.843657
          ],
          [
            17.719609,
            52.164557,
            107.937253
          ],
          [
            17.71971,
            52.164381,
            108.044913
          ],
          [
            17.719771,
            52.164189,
            108.158142
          ],
          [
            17.719725,
            52.16399,
            108.274253
          ],
          [
            17.719697,
            52.163779,
            108.396409
          ],
          [
            17.719699,
            52.16358,
            108.511229
          ],
          [
            17.719704,
            52.163375,
            108.62952
          ],
          [
            17.719705,
            52.163175,
            108.745004
          ],
          [
            17.719719,
            52.16297,
            108.863387
          ],
          [
            17.719728,
            52.162779,
            108.971209
          ],
          [
            17.719717,
            52.162535,
            109.078383
          ],
          [
            17.719721,
            52.162313,
            109.175879
          ],
          [
            17.719715,
            52.162117,
            109.261976
          ],
          [
            17.719719,
            52.161883,
            109.364754
          ],
          [
            17.719734,
            52.161684,
            109.452313
          ],
          [
            17.719729,
            52.161458,
            109.551628
          ],
          [
            17.719736,
            52.161238,
            109.648255
          ],
          [
            17.719738,
            52.161048,
            109.731856
          ],
          [
            17.719734,
            52.160828,
            109.448352
          ],
          [
            17.719753,
            52.160624,
            109.088497
          ],
          [
            17.719761,
            52.160399,
            108.69198
          ],
          [
            17.719752,
            52.160156,
            108.263555
          ],
          [
            17.719633,
            52.159948,
            107.865137
          ],
          [
            17.719347,
            52.159865,
            107.523312
          ],
          [
            17.719043,
            52.15973,
            107.116613
          ],
          [
            17.718755,
            52.159638,
            106.764752
          ],
          [
            17.718463,
            52.159555,
            106.624126
          ],
          [
            17.718165,
            52.159451,
            106.706349
          ],
          [
            17.717847,
            52.159376,
            106.787879
          ],
          [
            17.717565,
            52.159295,
            106.862653
          ],
          [
            17.717287,
            52.159169,
            106.945694
          ],
          [
            17.717161,
            52.158996,
            107.020578
          ],
          [
            17.717121,
            52.158783,
            107.104234
          ],
          [
            17.717096,
            52.158567,
            107.188705
          ],
          [
            17.717048,
            52.158346,
            107.275685
          ],
          [
            17.717035,
            52.158142,
            107.479939
          ],
          [
            17.716999,
            52.157938,
            107.708458
          ],
          [
            17.716949,
            52.157722,
            107.951455
          ],
          [
            17.716926,
            52.157512,
            108.185887
          ],
          [
            17.716914,
            52.157313,
            108.408006
          ],
          [
            17.716884,
            52.157113,
            108.631667
          ],
          [
            17.716823,
            52.156888,
            108.886116
          ],
          [
            17.716739,
            52.156699,
            109.104325
          ],
          [
            17.716627,
            52.156486,
            109.365289
          ],
          [
            17.716939,
            52.156477,
            109.633794
          ],
          [
            17.717324,
            52.156552,
            109.955008
          ],
          [
            17.717721,
            52.156601,
            110.276056
          ],
          [
            17.718023,
            52.156643,
            110.520935
          ],
          [
            17.71837,
            52.156691,
            110.802133
          ],
          [
            17.718786,
            52.156696,
            111.131243
          ],
          [
            17.71911,
            52.156682,
            111.388019
          ],
          [
            17.719493,
            52.156673,
            111.605938
          ],
          [
            17.719849,
            52.156671,
            111.596956
          ],
          [
            17.720262,
            52.156667,
            111.586539
          ],
          [
            17.720559,
            52.156692,
            111.578974
          ],
          [
            17.720874,
            52.156685,
            111.571021
          ],
          [
            17.72124,
            52.156661,
            111.561719
          ],
          [
            17.721543,
            52.156624,
            111.553922
          ],
          [
            17.721852,
            52.156613,
            111.546088
          ],
          [
            17.722142,
            52.156573,
            111.538605
          ],
          [
            17.722477,
            52.156534,
            111.575225
          ],
          [
            17.722878,
            52.15648,
            111.66327
          ],
          [
            17.723228,
            52.156455,
            111.738802
          ],
          [
            17.723563,
            52.156428,
            111.81122
          ],
          [
            17.723898,
            52.156408,
            111.883397
          ],
          [
            17.724262,
            52.156378,
            111.962258
          ],
          [
            17.724603,
            52.156358,
            112.035737
          ],
          [
            17.724983,
            52.156334,
            112.117786
          ],
          [
            17.725338,
            52.156292,
            112.192741
          ],
          [
            17.725678,
            52.156284,
            112.259835
          ],
          [
            17.726003,
            52.156258,
            112.325769
          ],
          [
            17.726341,
            52.156202,
            112.394718
          ],
          [
            17.726663,
            52.156168,
            112.459376
          ],
          [
            17.726988,
            52.156138,
            112.524085
          ],
          [
            17.727317,
            52.156107,
            112.590219
          ],
          [
            17.727669,
            52.156071,
            112.660974
          ],
          [
            17.728033,
            52.15605,
            112.732981
          ],
          [
            17.728391,
            52.156046,
            112.710774
          ],
          [
            17.728711,
            52.155997,
            112.68057
          ],
          [
            17.729099,
            52.155957,
            112.644398
          ],
          [
            17.729401,
            52.155901,
            112.615505
          ],
          [
            17.729757,
            52.155879,
            112.581865
          ],
          [
            17.730115,
            52.155863,
            112.548537
          ],
          [
            17.73043,
            52.155837,
            112.519302
          ],
          [
            17.730827,
            52.155794,
            112.482384
          ],
          [
            17.731172,
            52.15577,
            112.314276
          ],
          [
            17.731539,
            52.155746,
            112.062423
          ],
          [
            17.731956,
            52.155723,
            111.774991
          ],
          [
            17.732291,
            52.155708,
            111.545869
          ],
          [
            17.732633,
            52.15568,
            111.306579
          ],
          [
            17.733004,
            52.155676,
            111.053463
          ],
          [
            17.733366,
            52.155624,
            110.799463
          ],
          [
            17.73369,
            52.155577,
            110.571674
          ],
          [
            17.734,
            52.155546,
            110.478274
          ],
          [
            17.734318,
            52.155487,
            110.486204
          ],
          [
            17.73465,
            52.155479,
            110.493949
          ],
          [
            17.735011,
            52.155476,
            110.502377
          ],
          [
            17.735375,
            52.155433,
            110.511014
          ],
          [
            17.735734,
            52.155373,
            110.519711
          ],
          [
            17.736043,
            52.155368,
            110.526911
          ],
          [
            17.736368,
            52.155314,
            110.534757
          ],
          [
            17.736682,
            52.155277,
            110.542238
          ],
          [
            17.737093,
            52.155249,
            110.988559
          ],
          [
            17.737437,
            52.155219,
            111.370194
          ],
          [
            17.737779,
            52.155198,
            111.747629
          ],
          [
            17.738216,
            52.155178,
            112.228768
          ],
          [
            17.738613,
            52.155114,
            112.680384
          ],
          [
            17.73894,
            52.155092,
            113.041825
          ],
          [
            17.739295,
            52.15506,
            113.436474
          ],
          [
            17.739655,
            52.155026,
            113.832618
          ],
          [
            17.740023,
            52.154988,
            114.220055
          ],
          [
            17.740372,
            52.154946,
            114.589927
          ],
          [
            17.740703,
            52.154931,
            114.934368
          ],
          [
            17.741029,
            52.154894,
            115.282164
          ],
          [
            17.741358,
            52.154858,
            115.62893
          ],
          [
            17.741687,
            52.154833,
            115.973193
          ],
          [
            17.742005,
            52.154793,
            116.311815
          ],
          [
            17.742365,
            52.154752,
            116.698082
          ],
          [
            17.742724,
            52.154735,
            116.596958
          ],
          [
            17.743107,
            52.154733,
            116.292577
          ],
          [
            17.743447,
            52.154703,
            116.019515
          ],
          [
            17.743866,
            52.154671,
            115.684052
          ],
          [
            17.744283,
            52.154598,
            115.339548
          ],
          [
            17.744645,
            52.15457,
            115.049685
          ],
          [
            17.745053,
            52.154538,
            114.72214
          ],
          [
            17.745451,
            52.154491,
            114.565555
          ],
          [
            17.74579,
            52.154491,
            114.907505
          ],
          [
            17.746117,
            52.154477,
            115.232394
          ],
          [
            17.74649,
            52.154441,
            115.604632
          ],
          [
            17.746884,
            52.154405,
            115.995316
          ],
          [
            17.747215,
            52.154387,
            116.322107
          ],
          [
            17.747605,
            52.154357,
            116.707841
          ],
          [
            17.747971,
            52.154306,
            117.075998
          ],
          [
            17.748318,
            52.154246,
            117.350005
          ],
          [
            17.748682,
            52.154246,
            117.35304
          ],
          [
            17.748991,
            52.154196,
            117.355706
          ],
          [
            17.749311,
            52.154172,
            117.3584
          ],
          [
            17.749618,
            52.154154,
            117.360975
          ],
          [
            17.749944,
            52.154154,
            117.363707
          ],
          [
            17.750236,
            52.154115,
            117.3662
          ],
          [
            17.750561,
            52.154065,
            117.368995
          ],
          [
            17.75086,
            52.154035,
            117.371523
          ],
          [
            17.751166,
            52.15399,
            117.353268
          ],
          [
            17.751523,
            52.153927,
            117.189425
          ],
          [
            17.751825,
            52.153892,
            117.053982
          ],
          [
            17.752177,
            52.153829,
            116.892275
          ],
          [
            17.75252,
            52.153756,
            116.73185
          ],
          [
            17.752893,
            52.153693,
            116.561345
          ],
          [
            17.753271,
            52.153625,
            116.387649
          ],
          [
            17.753602,
            52.153698,
            116.218406
          ],
          [
            17.753789,
            52.153884,
            116.023808
          ],
          [
            17.753961,
            52.154036,
            115.648673
          ],
          [
            17.754109,
            52.154205,
            115.259539
          ],
          [
            17.754294,
            52.154408,
            114.788224
          ],
          [
            17.754485,
            52.1546,
            114.331466
          ],
          [
            17.75468,
            52.154787,
            113.881061
          ],
          [
            17.754835,
            52.154968,
            113.466691
          ],
          [
            17.755005,
            52.155134,
            113.069416
          ],
          [
            17.755161,
            52.155321,
            112.643596
          ],
          [
            17.755319,
            52.155487,
            112.33921
          ],
          [
            17.755539,
            52.155708,
            112.059353
          ],
          [
            17.755723,
            52.155923,
            111.796931
          ],
          [
            17.755886,
            52.156087,
            111.589365
          ],
          [
            17.756055,
            52.156287,
            111.345793
          ],
          [
            17.756277,
            52.156488,
            111.083047
          ],
          [
            17.756488,
            52.156702,
            110.812736
          ],
          [
            17.7567,
            52.156918,
            110.54027
          ],
          [
            17.756916,
            52.157138,
            110.471685
          ],
          [
            17.757088,
            52.15734,
            110.448474
          ],
          [
            17.757302,
            52.157516,
            110.426078
          ],
          [
            17.757515,
            52.157715,
            110.401331
          ],
          [
            17.757838,
            52.157771,
            110.380146
          ],
          [
            17.758135,
            52.157818,
            110.360989
          ],
          [
            17.75842,
            52.157877,
            110.342201
          ],
          [
            17.758724,
            52.157928,
            110.322515
          ],
          [
            17.759025,
            52.157981,
            110.411238
          ],
          [
            17.759331,
            52.15804,
            110.685599
          ],
          [
            17.759649,
            52.15809,
            110.96667
          ],
          [
            17.759952,
            52.158135,
            111.233399
          ],
          [
            17.760367,
            52.158213,
            111.605216
          ],
          [
            17.760662,
            52.158262,
            111.866651
          ],
          [
            17.761078,
            52.158316,
            112.231095
          ],
          [
            17.761394,
            52.158362,
            112.508929
          ],
          [
            17.761699,
            52.158405,
            112.776619
          ],
          [
            17.762068,
            52.158465,
            112.887265
          ],
          [
            17.762381,
            52.158529,
            112.955611
          ],
          [
            17.762683,
            52.158574,
            113.020012
          ],
          [
            17.762971,
            52.158627,
            113.082296
          ],
          [
            17.763266,
            52.158674,
            113.145437
          ],
          [
            17.763623,
            52.15872,
            113.221001
          ],
          [
            17.764039,
            52.158795,
            113.31095
          ],
          [
            17.76443,
            52.158858,
            113.394938
          ],
          [
            17.764729,
            52.158886,
            113.478769
          ],
          [
            17.765025,
            52.15893,
            113.583192
          ],
          [
            17.765393,
            52.158995,
            113.714487
          ],
          [
            17.765689,
            52.159049,
            113.821324
          ],
          [
            17.76598,
            52.159084,
            113.922943
          ],
          [
            17.766264,
            52.159145,
            114.026065
          ],
          [
            17.76659,
            52.159197,
            114.141506
          ],
          [
            17.766916,
            52.159247,
            114.256842
          ],
          [
            17.767273,
            52.159304,
            114.383249
          ],
          [
            17.767576,
            52.159333,
            114.405941
          ],
          [
            17.767941,
            52.159388,
            114.353221
          ],
          [
            17.768374,
            52.159464,
            114.290007
          ],
          [
            17.768692,
            52.159531,
            114.242854
          ],
          [
            17.769002,
            52.159561,
            114.1985
          ],
          [
            17.769316,
            52.159613,
            114.15288
          ],
          [
            17.769638,
            52.159677,
            114.105426
          ],
          [
            17.769945,
            52.159723,
            114.061118
          ],
          [
            17.770259,
            52.159773,
            114.017847
          ],
          [
            17.770566,
            52.159832,
            114.003294
          ],
          [
            17.770884,
            52.159885,
            113.988386
          ],
          [
            17.771224,
            52.159934,
            113.972587
          ],
          [
            17.771552,
            52.159982,
            113.957302
          ],
          [
            17.771861,
            52.160022,
            113.943007
          ],
          [
            17.772163,
            52.160071,
            113.928858
          ],
          [
            17.772542,
            52.160121,
            113.911318
          ],
          [
            17.772859,
            52.160158,
            113.896588
          ],
          [
            17.773215,
            52.160217,
            113.886677
          ],
          [
            17.773558,
            52.160282,
            113.887701
          ],
          [
            17.773878,
            52.16032,
            113.888632
          ],
          [
            17.774244,
            52.16038,
            113.889713
          ],
          [
            17.774589,
            52.160441,
            113.890739
          ],
          [
            17.774951,
            52.160507,
            113.891816
          ],
          [
            17.775279,
            52.160563,
            113.892788
          ],
          [
            17.775596,
            52.160627,
            113.893742
          ],
          [
            17.775908,
            52.160681,
            113.892829
          ],
          [
            17.776236,
            52.160718,
            113.831869
          ],
          [
            17.776559,
            52.160772,
            113.77075
          ],
          [
            17.776875,
            52.16083,
            113.710557
          ],
          [
            17.777166,
            52.160869,
            113.656188
          ],
          [
            17.777467,
            52.160923,
            113.598946
          ],
          [
            17.777859,
            52.16097,
            113.525965
          ],
          [
            17.778215,
            52.16103,
            113.458539
          ],
          [
            17.778522,
            52.161091,
            113.399631
          ],
          [
            17.778827,
            52.161158,
            113.295351
          ],
          [
            17.779126,
            52.161234,
            113.097935
          ],
          [
            17.779414,
            52.161308,
            112.907684
          ],
          [
            17.779695,
            52.161356,
            112.729052
          ],
          [
            17.779997,
            52.161412,
            112.536722
          ],
          [
            17.780327,
            52.161505,
            112.315508
          ],
          [
            17.780659,
            52.161573,
            112.102093
          ],
          [
            17.78095,
            52.161631,
            111.915741
          ],
          [
            17.781297,
            52.161718,
            111.687189
          ],
          [
            17.781636,
            52.161797,
            111.662479
          ],
          [
            17.781986,
            52.161868,
            111.847872
          ],
          [
            17.782377,
            52.16195,
            112.055866
          ],
          [
            17.782722,
            52.16204,
            112.244655
          ],
          [
            17.783067,
            52.162096,
            112.423914
          ],
          [
            17.783412,
            52.162166,
            112.606469
          ],
          [
            17.783701,
            52.162227,
            112.760357
          ],
          [
            17.784053,
            52.162313,
            112.950759
          ],
          [
            17.784398,
            52.162392,
            113.248429
          ],
          [
            17.784744,
            52.162458,
            113.659917
          ],
          [
            17.785065,
            52.162547,
            114.060166
          ],
          [
            17.785427,
            52.162614,
            114.489561
          ],
          [
            17.785799,
            52.162645,
            114.918795
          ],
          [
            17.786225,
            52.162623,
            115.404283
          ],
          [
            17.786589,
            52.162563,
            115.832437
          ],
          [
            17.786901,
            52.162518,
            116.196517
          ],
          [
            17.787271,
            52.162473,
            116.292892
          ],
          [
            17.787584,
            52.162438,
            116.17178
          ],
          [
            17.787926,
            52.162403,
            116.039659
          ],
          [
            17.788249,
            52.16235,
            115.912341
          ],
          [
            17.788625,
            52.16229,
            115.764483
          ],
          [
            17.789,
            52.162258,
            115.619834
          ],
          [
            17.789419,
            52.162216,
            115.457635
          ],
          [
            17.789794,
            52.162193,
            115.314212
          ],
          [
            17.790157,
            52.162128,
            115.003035
          ],
          [
            17.790454,
            52.162118,
            114.678051
          ],
          [
            17.790827,
            52.162094,
            114.268429
          ],
          [
            17.791204,
            52.162053,
            113.851419
          ],
          [
            17.791575,
            52.16201,
            113.44088
          ],
          [
            17.791982,
            52.161997,
            112.997728
          ],
          [
            17.792367,
            52.161964,
            112.574549
          ],
          [
            17.792765,
            52.161914,
            112.132615
          ],
          [
            17.793175,
            52.16186,
            112.212601
          ],
          [
            17.79355,
            52.161796,
            112.362788
          ],
          [
            17.793847,
            52.161745,
            112.4818
          ],
          [
            17.79421,
            52.161716,
            112.623046
          ],
          [
            17.794512,
            52.161696,
            112.740245
          ],
          [
            17.794874,
            52.161667,
            112.88111
          ],
          [
            17.795285,
            52.161626,
            113.041783
          ],
          [
            17.795706,
            52.161581,
            113.210008
          ],
          [
            17.796004,
            52.16156,
            113.447079
          ],
          [
            17.79637,
            52.161521,
            113.74237
          ],
          [
            17.79674,
            52.161476,
            114.041312
          ],
          [
            17.797102,
            52.16144,
            114.331566
          ],
          [
            17.797397,
            52.161412,
            114.567459
          ],
          [
            17.797839,
            52.161379,
            114.919329
          ],
          [
            17.798198,
            52.161368,
            115.203397
          ],
          [
            17.798569,
            52.161329,
            115.500927
          ],
          [
            17.798954,
            52.161306,
            115.788309
          ],
          [
            17.799261,
            52.161282,
            116.01686
          ],
          [
            17.799619,
            52.161219,
            116.293487
          ],
          [
            17.799994,
            52.161188,
            116.572968
          ],
          [
            17.800374,
            52.161117,
            116.872537
          ],
          [
            17.800806,
            52.161103,
            117.192421
          ],
          [
            17.801214,
            52.161083,
            117.494651
          ],
          [
            17.801577,
            52.161073,
            117.677257
          ],
          [
            17.802008,
            52.161095,
            117.643299
          ],
          [
            17.802339,
            52.161117,
            117.617105
          ],
          [
            17.802651,
            52.161145,
            117.592347
          ],
          [
            17.803046,
            52.161164,
            117.561212
          ],
          [
            17.803427,
            52.161209,
            117.530748
          ],
          [
            17.803835,
            52.161264,
            117.497899
          ],
          [
            17.804243,
            52.161326,
            117.464895
          ],
          [
            17.804642,
            52.161418,
            117.51887
          ],
          [
            17.804964,
            52.161523,
            117.594885
          ],
          [
            17.805298,
            52.161643,
            117.675651
          ],
          [
            17.805572,
            52.161814,
            117.758475
          ],
          [
            17.805775,
            52.161993,
            117.832601
          ],
          [
            17.806031,
            52.162094,
            117.901189
          ],
          [
            17.806197,
            52.16193,
            117.967033
          ],
          [
            17.806345,
            52.161769,
            118.029996
          ],
          [
            17.80643,
            52.161597,
            118.098153
          ],
          [
            17.806468,
            52.161411,
            118.169884
          ],
          [
            17.806718,
            52.161315,
            118.239064
          ],
          [
            17.806985,
            52.161312,
            118.307165
          ],
          [
            17.807306,
            52.161301,
            118.382397
          ],
          [
            17.807499,
            52.161154,
            118.453407
          ],
          [
            17.807421,
            52.161338,
            118.525569
          ],
          [
            17.807243,
            52.161481,
            118.596645
          ],
          [
            17.80695,
            52.161542,
            118.668127
          ],
          [
            17.806668,
            52.16164,
            118.743145
          ],
          [
            17.806454,
            52.161766,
            118.743181
          ],
          [
            17.806594,
            52.16159,
            118.743181
          ],
          [
            17.806887,
            52.161518,
            118.743181
          ],
          [
            17.807175,
            52.161465,
            118.743181
          ],
          [
            17.807385,
            52.161331,
            118.743181
          ],
          [
            17.808216,
            52.161316,
            118.743181
          ],
          [
            17.808463,
            52.161295,
            118.743181
          ],
          [
            17.808784,
            52.161318,
            118.743181
          ],
          [
            17.809066,
            52.161267,
            118.743181
          ],
          [
            17.809041,
            52.161266,
            118.743181
          ],
          [
            17.809339,
            52.161203,
            118.743181
          ],
          [
            17.809233,
            52.161275,
            118.743181
          ]
        ]
      }
    }
  ]
}

let day50: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            17.807695,
            52.161518,
            119.861283
          ],
          [
            17.807313,
            52.161484,
            119.861283
          ],
          [
            17.806996,
            52.161527,
            119.861283
          ],
          [
            17.806687,
            52.16156,
            119.861283
          ],
          [
            17.806432,
            52.161683,
            119.861283
          ],
          [
            17.806129,
            52.161657,
            119.694382
          ],
          [
            17.806061,
            52.161827,
            119.425164
          ],
          [
            17.805864,
            52.16196,
            119.165468
          ],
          [
            17.805909,
            52.162193,
            118.815128
          ],
          [
            17.806071,
            52.162369,
            118.527461
          ],
          [
            17.806234,
            52.162573,
            118.204234
          ],
          [
            17.806391,
            52.162735,
            117.935787
          ],
          [
            17.806543,
            52.162909,
            117.654981
          ],
          [
            17.806704,
            52.163109,
            117.337581
          ],
          [
            17.806863,
            52.163306,
            117.451008
          ],
          [
            17.807002,
            52.163502,
            117.613282
          ],
          [
            17.807169,
            52.163703,
            117.784311
          ],
          [
            17.807331,
            52.163892,
            117.946139
          ],
          [
            17.807476,
            52.164082,
            118.105169
          ],
          [
            17.807638,
            52.16427,
            118.266331
          ],
          [
            17.807824,
            52.164477,
            118.445461
          ],
          [
            17.808007,
            52.164703,
            118.636827
          ],
          [
            17.808203,
            52.164926,
            118.647263
          ],
          [
            17.808387,
            52.165119,
            118.627721
          ],
          [
            17.808567,
            52.165348,
            118.605533
          ],
          [
            17.808688,
            52.165565,
            118.585516
          ],
          [
            17.808764,
            52.165752,
            118.56869
          ],
          [
            17.80884,
            52.16594,
            118.551783
          ],
          [
            17.80893,
            52.166158,
            118.532156
          ],
          [
            17.808984,
            52.166371,
            118.513338
          ],
          [
            17.809059,
            52.166557,
            118.53076
          ],
          [
            17.809146,
            52.1668,
            118.568664
          ],
          [
            17.809226,
            52.167019,
            118.602932
          ],
          [
            17.809305,
            52.167253,
            118.639344
          ],
          [
            17.809363,
            52.167456,
            118.670736
          ],
          [
            17.809422,
            52.167635,
            118.698557
          ],
          [
            17.8095,
            52.167818,
            118.727377
          ],
          [
            17.809607,
            52.168067,
            118.766598
          ],
          [
            17.809762,
            52.16827,
            118.830932
          ],
          [
            17.809907,
            52.168469,
            118.920625
          ],
          [
            17.810076,
            52.16867,
            119.013744
          ],
          [
            17.810226,
            52.168833,
            119.090764
          ],
          [
            17.810424,
            52.16906,
            119.196821
          ],
          [
            17.81063,
            52.169276,
            119.299868
          ],
          [
            17.810853,
            52.169513,
            119.41247
          ],
          [
            17.811013,
            52.16971,
            119.503079
          ],
          [
            17.811184,
            52.169868,
            119.430648
          ],
          [
            17.811331,
            52.170033,
            119.307358
          ],
          [
            17.811519,
            52.17024,
            119.15201
          ],
          [
            17.811689,
            52.170407,
            119.022923
          ],
          [
            17.811893,
            52.170637,
            118.85123
          ],
          [
            17.812054,
            52.170795,
            118.729019
          ],
          [
            17.812255,
            52.171012,
            118.565345
          ],
          [
            17.812406,
            52.171171,
            118.444706
          ],
          [
            17.812562,
            52.171335,
            118.329905
          ],
          [
            17.812722,
            52.171499,
            118.256093
          ],
          [
            17.812886,
            52.171667,
            118.180407
          ],
          [
            17.813077,
            52.17183,
            118.10293
          ],
          [
            17.813261,
            52.172015,
            118.019303
          ],
          [
            17.813423,
            52.172172,
            117.947409
          ],
          [
            17.813591,
            52.17234,
            117.871364
          ],
          [
            17.81378,
            52.172541,
            117.781828
          ],
          [
            17.813999,
            52.172715,
            117.696947
          ],
          [
            17.81417,
            52.172884,
            117.609318
          ],
          [
            17.814386,
            52.173069,
            117.489697
          ],
          [
            17.814609,
            52.173259,
            117.36652
          ],
          [
            17.814829,
            52.17345,
            117.243719
          ],
          [
            17.815017,
            52.173608,
            117.140706
          ],
          [
            17.815297,
            52.173819,
            116.997828
          ],
          [
            17.815487,
            52.174001,
            116.884349
          ],
          [
            17.815674,
            52.174192,
            116.767326
          ],
          [
            17.81584,
            52.174345,
            116.663815
          ],
          [
            17.816023,
            52.174489,
            116.548534
          ],
          [
            17.816185,
            52.174641,
            116.433905
          ],
          [
            17.816404,
            52.174868,
            116.267357
          ],
          [
            17.816592,
            52.175103,
            116.102118
          ],
          [
            17.816715,
            52.175271,
            115.985827
          ],
          [
            17.816817,
            52.175447,
            115.867851
          ],
          [
            17.816947,
            52.175612,
            115.752106
          ],
          [
            17.817053,
            52.175799,
            115.626956
          ],
          [
            17.817154,
            52.175983,
            115.76375
          ],
          [
            17.817304,
            52.176182,
            116.172481
          ],
          [
            17.817419,
            52.176386,
            116.574874
          ],
          [
            17.817546,
            52.176603,
            117.004292
          ],
          [
            17.817676,
            52.1768,
            117.40038
          ],
          [
            17.817817,
            52.177034,
            117.86502
          ],
          [
            17.817957,
            52.177284,
            118.357312
          ],
          [
            17.818086,
            52.177488,
            118.764934
          ],
          [
            17.818239,
            52.17771,
            119.124127
          ],
          [
            17.818478,
            52.177803,
            119.373613
          ],
          [
            17.818821,
            52.17772,
            119.666252
          ],
          [
            17.819129,
            52.177662,
            119.921975
          ],
          [
            17.819455,
            52.177609,
            120.189589
          ],
          [
            17.819781,
            52.177552,
            120.458599
          ],
          [
            17.820126,
            52.177473,
            120.751265
          ],
          [
            17.820493,
            52.177435,
            121.047082
          ],
          [
            17.820854,
            52.177387,
            121.215819
          ],
          [
            17.821281,
            52.177371,
            121.101859
          ],
          [
            17.821703,
            52.17736,
            120.989401
          ],
          [
            17.822018,
            52.177349,
            120.905459
          ],
          [
            17.822404,
            52.17734,
            120.802511
          ],
          [
            17.822746,
            52.177323,
            120.711136
          ],
          [
            17.823071,
            52.177308,
            120.624249
          ],
          [
            17.823403,
            52.177299,
            120.535817
          ],
          [
            17.823752,
            52.177287,
            120.430628
          ],
          [
            17.824106,
            52.177281,
            120.288333
          ],
          [
            17.824468,
            52.177263,
            120.142482
          ],
          [
            17.824796,
            52.17726,
            120.010755
          ],
          [
            17.825137,
            52.177247,
            119.873572
          ],
          [
            17.825446,
            52.177219,
            119.747857
          ],
          [
            17.825833,
            52.177217,
            119.592115
          ],
          [
            17.826155,
            52.177218,
            119.46269
          ],
          [
            17.826479,
            52.177204,
            119.332257
          ],
          [
            17.82682,
            52.177194,
            119.344976
          ],
          [
            17.827185,
            52.177163,
            119.432978
          ],
          [
            17.827533,
            52.177163,
            119.516215
          ],
          [
            17.827896,
            52.177134,
            119.603825
          ],
          [
            17.828238,
            52.177108,
            119.686133
          ],
          [
            17.828566,
            52.177083,
            119.765068
          ],
          [
            17.828883,
            52.177042,
            119.842479
          ],
          [
            17.829232,
            52.177008,
            119.927007
          ],
          [
            17.829563,
            52.176944,
            120.052439
          ],
          [
            17.829875,
            52.176861,
            120.302279
          ],
          [
            17.830203,
            52.176782,
            120.561049
          ],
          [
            17.830509,
            52.176716,
            120.799376
          ],
          [
            17.830838,
            52.176643,
            121.057126
          ],
          [
            17.83113,
            52.176565,
            121.291296
          ],
          [
            17.831503,
            52.176497,
            121.577052
          ],
          [
            17.831791,
            52.176427,
            121.804547
          ],
          [
            17.832136,
            52.176329,
            122.083758
          ],
          [
            17.832544,
            52.176253,
            122.027575
          ],
          [
            17.832877,
            52.176158,
            121.904398
          ],
          [
            17.833174,
            52.176089,
            121.797865
          ],
          [
            17.833463,
            52.176007,
            121.691045
          ],
          [
            17.833796,
            52.175917,
            121.568996
          ],
          [
            17.834111,
            52.175816,
            121.449384
          ],
          [
            17.834456,
            52.175752,
            121.328154
          ],
          [
            17.834805,
            52.175687,
            121.205516
          ],
          [
            17.835103,
            52.175602,
            121.190046
          ],
          [
            17.835396,
            52.175535,
            121.239205
          ],
          [
            17.835708,
            52.175453,
            121.292566
          ],
          [
            17.836021,
            52.175377,
            121.345478
          ],
          [
            17.836307,
            52.175302,
            121.394496
          ],
          [
            17.836614,
            52.175227,
            121.446439
          ],
          [
            17.836935,
            52.175167,
            121.499222
          ],
          [
            17.837271,
            52.175069,
            121.557953
          ],
          [
            17.837634,
            52.174993,
            121.618375
          ],
          [
            17.837953,
            52.174924,
            121.545348
          ],
          [
            17.838273,
            52.174857,
            121.466164
          ],
          [
            17.838608,
            52.174756,
            121.378948
          ],
          [
            17.838959,
            52.174666,
            121.289816
          ],
          [
            17.839327,
            52.174553,
            121.193614
          ],
          [
            17.839697,
            52.174478,
            121.102504
          ],
          [
            17.840055,
            52.174397,
            121.013348
          ],
          [
            17.840414,
            52.174301,
            120.972717
          ],
          [
            17.840755,
            52.174229,
            121.200687
          ],
          [
            17.841056,
            52.174165,
            121.401007
          ],
          [
            17.841402,
            52.174082,
            121.634482
          ],
          [
            17.841768,
            52.173991,
            121.882694
          ],
          [
            17.842153,
            52.173914,
            122.137158
          ],
          [
            17.842503,
            52.173829,
            122.373798
          ],
          [
            17.842785,
            52.17377,
            122.561127
          ],
          [
            17.84316,
            52.173674,
            122.750915
          ],
          [
            17.843448,
            52.173598,
            122.60876
          ],
          [
            17.843742,
            52.173533,
            122.467014
          ],
          [
            17.844095,
            52.173442,
            122.293422
          ],
          [
            17.844455,
            52.173342,
            122.114093
          ],
          [
            17.844749,
            52.173268,
            121.969978
          ],
          [
            17.845058,
            52.173199,
            121.820797
          ],
          [
            17.845364,
            52.173109,
            121.666946
          ],
          [
            17.845681,
            52.17303,
            121.51183
          ],
          [
            17.845986,
            52.172949,
            121.390605
          ],
          [
            17.846319,
            52.172879,
            121.285113
          ],
          [
            17.846642,
            52.172806,
            121.181913
          ],
          [
            17.84695,
            52.172723,
            121.081082
          ],
          [
            17.847283,
            52.172653,
            120.97556
          ],
          [
            17.847624,
            52.172574,
            120.866235
          ],
          [
            17.847977,
            52.172482,
            120.751293
          ],
          [
            17.848325,
            52.172401,
            120.639634
          ],
          [
            17.848671,
            52.172319,
            120.673911
          ],
          [
            17.848972,
            52.172255,
            120.913199
          ],
          [
            17.849272,
            52.172163,
            121.16528
          ],
          [
            17.849594,
            52.172112,
            121.416792
          ],
          [
            17.849962,
            52.172038,
            121.70655
          ],
          [
            17.850296,
            52.17195,
            121.978519
          ],
          [
            17.850587,
            52.171861,
            122.22186
          ],
          [
            17.850916,
            52.171798,
            122.479733
          ],
          [
            17.851223,
            52.171742,
            122.719514
          ],
          [
            17.851616,
            52.171638,
            122.980601
          ],
          [
            17.851987,
            52.171551,
            123.214148
          ],
          [
            17.852343,
            52.171478,
            123.436126
          ],
          [
            17.852656,
            52.171419,
            123.628725
          ],
          [
            17.852987,
            52.171342,
            123.83691
          ],
          [
            17.853339,
            52.171246,
            124.063474
          ],
          [
            17.853716,
            52.171175,
            124.295412
          ],
          [
            17.854122,
            52.171141,
            124.504016
          ],
          [
            17.854423,
            52.171115,
            124.563425
          ],
          [
            17.854771,
            52.171088,
            124.631981
          ],
          [
            17.855169,
            52.171055,
            124.710483
          ],
          [
            17.855557,
            52.171016,
            124.787349
          ],
          [
            17.85596,
            52.17097,
            124.867473
          ],
          [
            17.856386,
            52.170941,
            124.951375
          ],
          [
            17.856746,
            52.170907,
            125.022672
          ],
          [
            17.85711,
            52.170872,
            124.945176
          ],
          [
            17.857406,
            52.170801,
            124.730346
          ],
          [
            17.857668,
            52.170669,
            124.503194
          ],
          [
            17.857943,
            52.170496,
            124.239069
          ],
          [
            17.858174,
            52.170318,
            123.990295
          ],
          [
            17.858415,
            52.170147,
            123.74346
          ],
          [
            17.858699,
            52.169944,
            123.451278
          ],
          [
            17.858965,
            52.169769,
            123.189863
          ],
          [
            17.859253,
            52.1696,
            123.247457
          ],
          [
            17.85958,
            52.169464,
            123.476152
          ],
          [
            17.859911,
            52.16932,
            123.711027
          ],
          [
            17.860243,
            52.169174,
            123.94747
          ],
          [
            17.86054,
            52.169037,
            124.162564
          ],
          [
            17.860788,
            52.168929,
            124.339281
          ],
          [
            17.861066,
            52.168838,
            124.521665
          ],
          [
            17.861356,
            52.168765,
            124.70357
          ],
          [
            17.861656,
            52.16869,
            124.871695
          ],
          [
            17.861951,
            52.168631,
            125.015176
          ],
          [
            17.862246,
            52.168574,
            125.15821
          ],
          [
            17.862542,
            52.168506,
            125.304362
          ],
          [
            17.862838,
            52.168468,
            125.444295
          ],
          [
            17.863165,
            52.168421,
            125.599754
          ],
          [
            17.863544,
            52.168379,
            125.778175
          ],
          [
            17.863852,
            52.168356,
            125.921884
          ],
          [
            17.864174,
            52.168345,
            126.071004
          ],
          [
            17.864512,
            52.168331,
            126.27742
          ],
          [
            17.864829,
            52.168337,
            126.518152
          ],
          [
            17.865183,
            52.168341,
            126.786934
          ],
          [
            17.865536,
            52.168338,
            127.054907
          ],
          [
            17.865899,
            52.168325,
            127.330849
          ],
          [
            17.866265,
            52.168314,
            127.609058
          ],
          [
            17.866629,
            52.168292,
            127.887031
          ],
          [
            17.867,
            52.168291,
            128.168597
          ],
          [
            17.86737,
            52.168287,
            128.369816
          ],
          [
            17.867746,
            52.168274,
            128.348373
          ],
          [
            17.868105,
            52.168263,
            128.327919
          ],
          [
            17.868467,
            52.168262,
            128.307322
          ],
          [
            17.86883,
            52.168255,
            128.286643
          ],
          [
            17.869179,
            52.16824,
            128.266729
          ],
          [
            17.869565,
            52.168237,
            128.244766
          ],
          [
            17.869919,
            52.168227,
            128.224591
          ],
          [
            17.870277,
            52.168223,
            128.213079
          ],
          [
            17.87062,
            52.168217,
            128.232821
          ],
          [
            17.870954,
            52.168206,
            128.25207
          ],
          [
            17.87131,
            52.168203,
            128.272559
          ],
          [
            17.871648,
            52.168212,
            128.292024
          ],
          [
            17.871993,
            52.168212,
            128.311873
          ],
          [
            17.872351,
            52.168206,
            128.332478
          ],
          [
            17.872733,
            52.168185,
            128.354622
          ],
          [
            17.873108,
            52.168162,
            128.376376
          ],
          [
            17.87348,
            52.168156,
            128.106336
          ],
          [
            17.873859,
            52.168151,
            127.817307
          ],
          [
            17.874248,
            52.168144,
            127.520668
          ],
          [
            17.874622,
            52.168133,
            127.234989
          ],
          [
            17.874993,
            52.168116,
            126.95138
          ],
          [
            17.875354,
            52.1681,
            126.675479
          ],
          [
            17.87572,
            52.168095,
            126.396488
          ],
          [
            17.876079,
            52.168103,
            126.139509
          ],
          [
            17.876421,
            52.168098,
            126.09922
          ],
          [
            17.876766,
            52.16809,
            126.058892
          ],
          [
            17.877132,
            52.168081,
            126.016102
          ],
          [
            17.87748,
            52.16809,
            125.975416
          ],
          [
            17.877858,
            52.168081,
            125.931225
          ],
          [
            17.878234,
            52.168074,
            125.887166
          ],
          [
            17.87863,
            52.168054,
            125.840625
          ],
          [
            17.87901,
            52.168042,
            125.754409
          ],
          [
            17.879379,
            52.168041,
            125.246569
          ],
          [
            17.879757,
            52.168007,
            124.720905
          ],
          [
            17.88014,
            52.168001,
            124.193436
          ],
          [
            17.880519,
            52.167998,
            123.670826
          ],
          [
            17.880899,
            52.167999,
            123.147855
          ],
          [
            17.881282,
            52.168006,
            122.620408
          ],
          [
            17.881656,
            52.16802,
            122.104548
          ],
          [
            17.882024,
            52.168011,
            121.828203
          ],
          [
            17.882376,
            52.168008,
            122.010123
          ],
          [
            17.88272,
            52.167999,
            122.187978
          ],
          [
            17.88306,
            52.168005,
            122.363699
          ],
          [
            17.883397,
            52.168011,
            122.537967
          ],
          [
            17.883768,
            52.168016,
            122.729634
          ],
          [
            17.884077,
            52.168017,
            122.889254
          ],
          [
            17.884394,
            52.168007,
            123.053245
          ],
          [
            17.884781,
            52.167983,
            123.254161
          ],
          [
            17.885165,
            52.167978,
            123.472824
          ],
          [
            17.885466,
            52.167979,
            123.646549
          ],
          [
            17.885846,
            52.167991,
            123.866358
          ],
          [
            17.886174,
            52.167999,
            124.055847
          ],
          [
            17.886532,
            52.16798,
            124.263277
          ],
          [
            17.886842,
            52.167971,
            124.44246
          ],
          [
            17.88719,
            52.167966,
            124.643363
          ],
          [
            17.887542,
            52.167986,
            124.848185
          ],
          [
            17.887932,
            52.167977,
            124.802238
          ],
          [
            17.888299,
            52.16797,
            124.446967
          ],
          [
            17.88867,
            52.167962,
            124.087777
          ],
          [
            17.889025,
            52.167954,
            123.744039
          ],
          [
            17.889355,
            52.167966,
            123.424158
          ],
          [
            17.889694,
            52.167987,
            123.094443
          ],
          [
            17.890024,
            52.168021,
            122.770299
          ],
          [
            17.89037,
            52.168086,
            122.420058
          ],
          [
            17.890719,
            52.168149,
            122.044742
          ],
          [
            17.891044,
            52.168225,
            121.594318
          ],
          [
            17.891399,
            52.168286,
            121.117039
          ],
          [
            17.891762,
            52.168333,
            120.636107
          ],
          [
            17.892123,
            52.168357,
            120.164936
          ],
          [
            17.89254,
            52.168356,
            119.623601
          ],
          [
            17.893006,
            52.168363,
            119.020115
          ],
          [
            17.893489,
            52.168362,
            118.394545
          ],
          [
            17.893993,
            52.168369,
            118.125681
          ],
          [
            17.894374,
            52.168377,
            117.949622
          ],
          [
            17.894787,
            52.168364,
            117.758672
          ],
          [
            17.895199,
            52.168327,
            117.565953
          ],
          [
            17.895558,
            52.168292,
            117.398028
          ],
          [
            17.895898,
            52.168268,
            117.23998
          ],
          [
            17.896236,
            52.168267,
            117.083862
          ],
          [
            17.896569,
            52.168239,
            117.296599
          ],
          [
            17.896932,
            52.168199,
            118.254577
          ],
          [
            17.897282,
            52.168174,
            119.164758
          ],
          [
            17.897636,
            52.168156,
            120.082444
          ],
          [
            17.897973,
            52.168146,
            120.954519
          ],
          [
            17.898344,
            52.168136,
            121.914293
          ],
          [
            17.898706,
            52.168109,
            122.857489
          ],
          [
            17.899072,
            52.168086,
            123.80784
          ],
          [
            17.899464,
            52.168061,
            124.692673
          ],
          [
            17.899825,
            52.168055,
            125.156858
          ],
          [
            17.900133,
            52.168056,
            125.553129
          ],
          [
            17.900463,
            52.168063,
            125.97752
          ],
          [
            17.900785,
            52.168072,
            126.393227
          ],
          [
            17.901122,
            52.168081,
            126.826728
          ],
          [
            17.901483,
            52.16809,
            127.291433
          ],
          [
            17.90187,
            52.168088,
            127.78895
          ],
          [
            17.902122,
            52.168232,
            128.231753
          ],
          [
            17.902452,
            52.168209,
            128.168284
          ],
          [
            17.90261,
            52.168178,
            128.065472
          ],
          [
            17.90295,
            52.168248,
            127.843423
          ],
          [
            17.903261,
            52.16822,
            127.649556
          ],
          [
            17.903569,
            52.168324,
            127.425659
          ],
          [
            17.903603,
            52.168526,
            127.21942
          ],
          [
            17.903623,
            52.168754,
            126.989763
          ],
          [
            17.903816,
            52.16892,
            126.783514
          ],
          [
            17.904106,
            52.169039,
            126.554221
          ],
          [
            17.904495,
            52.169091,
            126.548215
          ],
          [
            17.904889,
            52.169135,
            126.581671
          ],
          [
            17.905296,
            52.169173,
            126.616047
          ],
          [
            17.905619,
            52.169192,
            126.643144
          ],
          [
            17.905937,
            52.169165,
            126.66995
          ],
          [
            17.906315,
            52.169155,
            126.701537
          ],
          [
            17.906625,
            52.169128,
            126.727677
          ],
          [
            17.906935,
            52.169095,
            126.753948
          ],
          [
            17.907253,
            52.169049,
            126.807012
          ],
          [
            17.90756,
            52.16901,
            126.873335
          ],
          [
            17.907883,
            52.168988,
            126.942079
          ],
          [
            17.908198,
            52.168968,
            127.009094
          ],
          [
            17.908562,
            52.168912,
            127.088494
          ],
          [
            17.908862,
            52.168877,
            127.153097
          ],
          [
            17.909168,
            52.168842,
            127.218948
          ],
          [
            17.909494,
            52.168808,
            127.2889
          ],
          [
            17.909789,
            52.168771,
            127.352594
          ],
          [
            17.910098,
            52.168738,
            127.354249
          ],
          [
            17.9104,
            52.168712,
            127.296949
          ],
          [
            17.910707,
            52.168685,
            127.238732
          ],
          [
            17.91113,
            52.168641,
            127.158211
          ],
          [
            17.911433,
            52.168603,
            127.099823
          ],
          [
            17.911856,
            52.168549,
            127.018445
          ],
          [
            17.912252,
            52.168503,
            126.94277
          ],
          [
            17.912665,
            52.168437,
            126.862663
          ],
          [
            17.913063,
            52.168392,
            126.812127
          ],
          [
            17.913472,
            52.168353,
            126.775946
          ],
          [
            17.91378,
            52.16833,
            126.748644
          ],
          [
            17.91417,
            52.168291,
            126.714103
          ],
          [
            17.914469,
            52.16826,
            126.687595
          ],
          [
            17.914781,
            52.168213,
            126.659471
          ],
          [
            17.915071,
            52.168166,
            126.633247
          ],
          [
            17.915447,
            52.168149,
            126.600291
          ],
          [
            17.915751,
            52.16811,
            126.537109
          ],
          [
            17.91605,
            52.168072,
            126.314936
          ],
          [
            17.916375,
            52.168036,
            126.074242
          ],
          [
            17.916717,
            52.168001,
            125.82194
          ],
          [
            17.917054,
            52.167965,
            125.573051
          ],
          [
            17.9174,
            52.167935,
            125.318522
          ],
          [
            17.917739,
            52.167891,
            125.066396
          ],
          [
            17.918084,
            52.167835,
            124.806736
          ],
          [
            17.918466,
            52.167793,
            124.524362
          ],
          [
            17.918848,
            52.167757,
            124.118992
          ],
          [
            17.919242,
            52.167706,
            123.645899
          ],
          [
            17.919634,
            52.167657,
            123.175517
          ],
          [
            17.920043,
            52.167612,
            122.687368
          ],
          [
            17.920467,
            52.167561,
            122.179723
          ],
          [
            17.920925,
            52.167513,
            121.633708
          ],
          [
            17.921385,
            52.16746,
            121.083772
          ],
          [
            17.921875,
            52.167406,
            120.770081
          ],
          [
            17.922371,
            52.167329,
            120.494563
          ],
          [
            17.922869,
            52.167272,
            120.22186
          ],
          [
            17.92335,
            52.167188,
            119.952459
          ],
          [
            17.923758,
            52.167081,
            119.713522
          ],
          [
            17.924081,
            52.16698,
            119.518336
          ],
          [
            17.924354,
            52.16689,
            119.644277
          ],
          [
            17.924596,
            52.166786,
            120.156416
          ],
          [
            17.924862,
            52.166686,
            120.696538
          ],
          [
            17.925166,
            52.166569,
            121.318063
          ],
          [
            17.925472,
            52.166455,
            121.937899
          ],
          [
            17.925795,
            52.166349,
            122.573186
          ],
          [
            17.92612,
            52.166248,
            123.204951
          ],
          [
            17.92646,
            52.166133,
            123.877512
          ],
          [
            17.926765,
            52.166034,
            124.476017
          ],
          [
            17.927096,
            52.165932,
            124.637434
          ],
          [
            17.927452,
            52.165811,
            124.796403
          ],
          [
            17.927826,
            52.165691,
            124.961429
          ],
          [
            17.92814,
            52.165573,
            125.105709
          ],
          [
            17.928476,
            52.165426,
            125.266972
          ],
          [
            17.928827,
            52.165251,
            125.443644
          ],
          [
            17.92915,
            52.165095,
            125.604432
          ],
          [
            17.929378,
            52.164973,
            125.45593
          ],
          [
            17.929672,
            52.16483,
            125.11293
          ],
          [
            17.929906,
            52.164717,
            124.840663
          ],
          [
            17.930162,
            52.164603,
            124.551433
          ],
          [
            17.930512,
            52.164438,
            124.147901
          ],
          [
            17.930813,
            52.164309,
            123.811906
          ],
          [
            17.931063,
            52.164176,
            123.509051
          ],
          [
            17.931393,
            52.164012,
            123.11963
          ],
          [
            17.931636,
            52.163896,
            123.116593
          ],
          [
            17.931898,
            52.163785,
            123.476322
          ],
          [
            17.9322,
            52.163631,
            123.91986
          ],
          [
            17.932536,
            52.163498,
            124.373612
          ],
          [
            17.932818,
            52.163444,
            124.707371
          ],
          [
            17.933129,
            52.163391,
            125.07192
          ],
          [
            17.933456,
            52.163369,
            125.443369
          ],
          [
            17.933843,
            52.163315,
            125.891963
          ],
          [
            17.934159,
            52.163276,
            126.256125
          ],
          [
            17.934508,
            52.163239,
            127.020851
          ],
          [
            17.934879,
            52.163186,
            127.86156
          ],
          [
            17.935246,
            52.163147,
            128.682884
          ],
          [
            17.935626,
            52.163112,
            129.530229
          ],
          [
            17.935996,
            52.16306,
            130.367518
          ],
          [
            17.936381,
            52.163024,
            131.22656
          ],
          [
            17.936756,
            52.162979,
            132.069321
          ],
          [
            17.937137,
            52.162918,
            132.646625
          ],
          [
            17.937537,
            52.162868,
            132.230385
          ],
          [
            17.93791,
            52.162812,
            131.839075
          ],
          [
            17.938284,
            52.162774,
            131.452748
          ],
          [
            17.938649,
            52.162729,
            131.073435
          ],
          [
            17.939015,
            52.162681,
            130.691307
          ],
          [
            17.939401,
            52.162633,
            130.28992
          ],
          [
            17.939777,
            52.162585,
            129.898555
          ],
          [
            17.940139,
            52.162534,
            129.729314
          ],
          [
            17.940523,
            52.162482,
            129.69079
          ],
          [
            17.9409,
            52.162446,
            129.653412
          ],
          [
            17.941276,
            52.16241,
            129.616137
          ],
          [
            17.941658,
            52.162358,
            129.57781
          ],
          [
            17.942038,
            52.162315,
            129.539962
          ],
          [
            17.942433,
            52.162274,
            129.500721
          ],
          [
            17.942795,
            52.162229,
            129.464498
          ],
          [
            17.943149,
            52.162179,
            129.407832
          ],
          [
            17.943499,
            52.162146,
            129.352752
          ],
          [
            17.943851,
            52.1621,
            129.296701
          ],
          [
            17.944211,
            52.162064,
            129.239963
          ],
          [
            17.944579,
            52.162024,
            129.18182
          ],
          [
            17.944923,
            52.161985,
            129.127393
          ],
          [
            17.945298,
            52.161924,
            129.067025
          ],
          [
            17.945664,
            52.161883,
            129.00905
          ],
          [
            17.946043,
            52.161845,
            129.081497
          ],
          [
            17.946403,
            52.161804,
            129.152199
          ],
          [
            17.946777,
            52.161742,
            129.227046
          ],
          [
            17.947143,
            52.1617,
            129.298927
          ],
          [
            17.947488,
            52.161649,
            129.367453
          ],
          [
            17.947846,
            52.161622,
            129.437135
          ],
          [
            17.948205,
            52.161586,
            129.507444
          ],
          [
            17.948536,
            52.161545,
            129.572632
          ],
          [
            17.948893,
            52.161498,
            129.118586
          ],
          [
            17.949261,
            52.161461,
            128.641897
          ],
          [
            17.949636,
            52.161401,
            128.146483
          ],
          [
            17.950038,
            52.161361,
            127.625747
          ],
          [
            17.950448,
            52.161294,
            127.08339
          ],
          [
            17.950865,
            52.161255,
            126.544217
          ],
          [
            17.95127,
            52.161196,
            126.012155
          ],
          [
            17.95168,
            52.16114,
            126.011445
          ],
          [
            17.952121,
            52.161086,
            126.313912
          ],
          [
            17.952529,
            52.161057,
            126.591731
          ],
          [
            17.952958,
            52.161094,
            126.883267
          ],
          [
            17.953397,
            52.161146,
            127.183735
          ],
          [
            17.953793,
            52.161219,
            127.461677
          ],
          [
            17.95418,
            52.161283,
            127.731082
          ],
          [
            17.954536,
            52.161326,
            127.6775
          ],
          [
            17.954896,
            52.161381,
            127.509914
          ],
          [
            17.955262,
            52.161422,
            127.341941
          ],
          [
            17.955577,
            52.161473,
            127.194646
          ],
          [
            17.955916,
            52.161521,
            127.03756
          ],
          [
            17.956242,
            52.161564,
            126.886957
          ],
          [
            17.956588,
            52.161619,
            126.725471
          ],
          [
            17.956925,
            52.16167,
            126.568758
          ],
          [
            17.957262,
            52.161716,
            126.383895
          ],
          [
            17.957592,
            52.161755,
            126.159319
          ],
          [
            17.9579,
            52.161803,
            125.946879
          ],
          [
            17.958213,
            52.161844,
            125.733037
          ],
          [
            17.958521,
            52.161886,
            125.522258
          ],
          [
            17.958846,
            52.161925,
            125.301012
          ],
          [
            17.95917,
            52.161969,
            125.079316
          ],
          [
            17.959513,
            52.162013,
            124.845108
          ],
          [
            17.959859,
            52.162068,
            124.60614
          ],
          [
            17.96018,
            52.162125,
            124.445998
          ],
          [
            17.960517,
            52.162196,
            124.321956
          ],
          [
            17.960887,
            52.162245,
            124.190189
          ],
          [
            17.961219,
            52.162277,
            124.073146
          ],
          [
            17.961532,
            52.162318,
            123.960812
          ],
          [
            17.96183,
            52.162358,
            123.854589
          ],
          [
            17.96223,
            52.162407,
            123.71251
          ],
          [
            17.962619,
            52.162461,
            123.573483
          ],
          [
            17.963024,
            52.162532,
            123.883458
          ],
          [
            17.963383,
            52.162587,
            124.627379
          ],
          [
            17.963718,
            52.162644,
            125.328585
          ],
          [
            17.964141,
            52.162713,
            126.211355
          ],
          [
            17.964523,
            52.16279,
            127.019102
          ],
          [
            17.964936,
            52.162833,
            127.860902
          ],
          [
            17.965233,
            52.162884,
            128.480473
          ],
          [
            17.965604,
            52.16293,
            129.240818
          ],
          [
            17.965973,
            52.162998,
            129.535984
          ],
          [
            17.966282,
            52.163049,
            129.690648
          ],
          [
            17.96665,
            52.163102,
            129.873354
          ],
          [
            17.966935,
            52.163143,
            130.015692
          ],
          [
            17.967233,
            52.163199,
            130.166448
          ],
          [
            17.967533,
            52.163263,
            130.32026
          ],
          [
            17.967856,
            52.163311,
            130.480939
          ],
          [
            17.968158,
            52.163346,
            130.629515
          ],
          [
            17.968493,
            52.163397,
            130.796515
          ],
          [
            17.968797,
            52.163449,
            131.093104
          ],
          [
            17.969124,
            52.163498,
            131.414445
          ],
          [
            17.969452,
            52.163548,
            131.737145
          ],
          [
            17.969806,
            52.163601,
            132.085617
          ],
          [
            17.97012,
            52.163654,
            132.396613
          ],
          [
            17.970443,
            52.163725,
            132.724145
          ],
          [
            17.970768,
            52.16378,
            133.046093
          ],
          [
            17.971089,
            52.163816,
            133.358856
          ],
          [
            17.971396,
            52.163868,
            133.57076
          ],
          [
            17.971695,
            52.163921,
            133.431535
          ],
          [
            17.971998,
            52.163974,
            133.290746
          ],
          [
            17.972325,
            52.164019,
            133.141163
          ],
          [
            17.972669,
            52.164077,
            132.981985
          ],
          [
            17.97298,
            52.164151,
            132.832989
          ],
          [
            17.9733,
            52.164198,
            132.686006
          ],
          [
            17.973615,
            52.164234,
            132.542982
          ],
          [
            17.973966,
            52.164257,
            132.38522
          ],
          [
            17.974288,
            52.164307,
            132.152461
          ],
          [
            17.974612,
            52.164356,
            131.774991
          ],
          [
            17.974933,
            52.164403,
            131.401718
          ],
          [
            17.975266,
            52.164459,
            131.011096
          ],
          [
            17.975592,
            52.164505,
            130.632828
          ],
          [
            17.975898,
            52.164551,
            130.276555
          ],
          [
            17.976189,
            52.164593,
            129.938096
          ],
          [
            17.976494,
            52.164641,
            129.582013
          ],
          [
            17.976796,
            52.16468,
            129.2328
          ],
          [
            17.977093,
            52.164726,
            128.994118
          ],
          [
            17.9774,
            52.164767,
            129.064266
          ],
          [
            17.977769,
            52.16482,
            129.149114
          ],
          [
            17.978066,
            52.164879,
            129.218789
          ],
          [
            17.97837,
            52.164932,
            129.289441
          ],
          [
            17.978733,
            52.164985,
            129.372706
          ],
          [
            17.979098,
            52.165032,
            129.455926
          ],
          [
            17.979455,
            52.165083,
            129.537722
          ],
          [
            17.97982,
            52.165139,
            129.622053
          ],
          [
            17.98011,
            52.165197,
            129.708108
          ],
          [
            17.980413,
            52.165256,
            129.799532
          ],
          [
            17.980777,
            52.165304,
            129.906124
          ],
          [
            17.981128,
            52.16536,
            130.010152
          ],
          [
            17.981494,
            52.165408,
            130.117351
          ],
          [
            17.981915,
            52.165467,
            130.241213
          ],
          [
            17.982261,
            52.165512,
            130.342602
          ],
          [
            17.98256,
            52.165555,
            130.430604
          ],
          [
            17.982905,
            52.165574,
            130.433707
          ],
          [
            17.983299,
            52.165615,
            130.364514
          ],
          [
            17.983722,
            52.165635,
            130.291056
          ],
          [
            17.984125,
            52.165665,
            130.220743
          ],
          [
            17.984471,
            52.165665,
            130.160833
          ],
          [
            17.984874,
            52.165671,
            130.090793
          ],
          [
            17.985244,
            52.165687,
            130.026368
          ],
          [
            17.985569,
            52.165722,
            129.968943
          ],
          [
            17.98588,
            52.165733,
            129.876501
          ],
          [
            17.986264,
            52.165737,
            129.755599
          ],
          [
            17.986634,
            52.165768,
            129.638442
          ],
          [
            17.986944,
            52.165779,
            129.540703
          ],
          [
            17.987258,
            52.165773,
            129.442148
          ],
          [
            17.987557,
            52.165749,
            129.347521
          ],
          [
            17.987858,
            52.165711,
            129.251078
          ],
          [
            17.988177,
            52.165677,
            129.149398
          ],
          [
            17.988477,
            52.165646,
            129.053953
          ],
          [
            17.98881,
            52.165587,
            128.697511
          ],
          [
            17.989123,
            52.165548,
            128.341811
          ],
          [
            17.989421,
            52.165489,
            127.993142
          ],
          [
            17.989725,
            52.165417,
            127.630283
          ],
          [
            17.989989,
            52.165318,
            127.285761
          ],
          [
            17.990236,
            52.165186,
            126.921036
          ],
          [
            17.990472,
            52.165043,
            126.551598
          ],
          [
            17.990712,
            52.164897,
            126.175058
          ],
          [
            17.990922,
            52.164742,
            125.808213
          ],
          [
            17.991156,
            52.16459,
            125.338652
          ],
          [
            17.991354,
            52.164431,
            124.881443
          ],
          [
            17.991625,
            52.164261,
            124.338128
          ],
          [
            17.991837,
            52.164111,
            123.884439
          ],
          [
            17.992091,
            52.163956,
            123.381377
          ],
          [
            17.992325,
            52.163791,
            122.881553
          ],
          [
            17.992562,
            52.163637,
            122.397867
          ],
          [
            17.99279,
            52.163477,
            121.911939
          ],
          [
            17.993033,
            52.163331,
            121.746007
          ],
          [
            17.993268,
            52.163158,
            121.912085
          ],
          [
            17.993527,
            52.16298,
            122.088272
          ],
          [
            17.993803,
            52.162819,
            122.260534
          ],
          [
            17.994053,
            52.162643,
            122.432851
          ],
          [
            17.994297,
            52.162474,
            122.599466
          ],
          [
            17.994544,
            52.162315,
            122.761376
          ],
          [
            17.99479,
            52.162155,
            122.923579
          ],
          [
            17.995028,
            52.161987,
            122.948785
          ],
          [
            17.995277,
            52.16182,
            122.862497
          ],
          [
            17.995553,
            52.161663,
            122.774248
          ],
          [
            17.995755,
            52.161502,
            122.69683
          ],
          [
            17.996003,
            52.161341,
            122.612398
          ],
          [
            17.99625,
            52.161175,
            122.526432
          ],
          [
            17.996483,
            52.161018,
            122.445516
          ],
          [
            17.996698,
            52.160858,
            122.366495
          ],
          [
            17.996926,
            52.160702,
            122.249113
          ],
          [
            17.997155,
            52.160539,
            122.040553
          ],
          [
            17.997435,
            52.160393,
            121.822
          ],
          [
            17.997675,
            52.160234,
            121.611976
          ],
          [
            17.99791,
            52.160071,
            121.400982
          ],
          [
            17.99814,
            52.159921,
            121.201384
          ],
          [
            17.99839,
            52.159739,
            120.970679
          ],
          [
            17.998638,
            52.159567,
            120.748115
          ],
          [
            17.998913,
            52.159389,
            120.394107
          ],
          [
            17.999174,
            52.159205,
            119.676238
          ],
          [
            17.999432,
            52.159036,
            118.994823
          ],
          [
            17.999679,
            52.158872,
            118.337064
          ],
          [
            17.999943,
            52.158698,
            117.637543
          ],
          [
            18.000209,
            52.158512,
            116.909424
          ],
          [
            18.000477,
            52.158308,
            116.137476
          ],
          [
            18.000822,
            52.158093,
            115.256828
          ],
          [
            18.001184,
            52.157877,
            114.610597
          ],
          [
            18.001558,
            52.157635,
            113.913076
          ],
          [
            18.001912,
            52.157384,
            113.22079
          ],
          [
            18.002297,
            52.157134,
            112.50341
          ],
          [
            18.002669,
            52.156878,
            111.787983
          ],
          [
            18.002998,
            52.156646,
            111.65865
          ],
          [
            18.003325,
            52.156452,
            111.866025
          ],
          [
            18.003626,
            52.156245,
            112.072355
          ],
          [
            18.003912,
            52.156052,
            112.266111
          ],
          [
            18.004182,
            52.155872,
            112.447774
          ],
          [
            18.00444,
            52.155699,
            112.621943
          ],
          [
            18.004695,
            52.155529,
            112.794061
          ],
          [
            18.004965,
            52.155351,
            112.877282
          ],
          [
            18.005212,
            52.155172,
            112.903837
          ],
          [
            18.005471,
            52.154993,
            112.930942
          ],
          [
            18.005744,
            52.154826,
            112.957719
          ],
          [
            18.006009,
            52.154661,
            112.983949
          ],
          [
            18.006298,
            52.154527,
            113.009141
          ],
          [
            18.006594,
            52.154444,
            113.031763
          ],
          [
            18.006918,
            52.154382,
            113.055357
          ],
          [
            18.007245,
            52.154308,
            113.205912
          ],
          [
            18.007577,
            52.154259,
            113.414829
          ],
          [
            18.007915,
            52.154187,
            113.633785
          ],
          [
            18.00825,
            52.154128,
            113.847042
          ],
          [
            18.008603,
            52.154058,
            114.074017
          ],
          [
            18.008932,
            52.153996,
            114.28465
          ],
          [
            18.009257,
            52.153943,
            114.490571
          ],
          [
            18.009581,
            52.15388,
            114.69891
          ],
          [
            18.009975,
            52.153821,
            114.894358
          ],
          [
            18.010302,
            52.153735,
            114.984472
          ],
          [
            18.010618,
            52.153667,
            115.06932
          ],
          [
            18.010934,
            52.153606,
            115.153233
          ],
          [
            18.011238,
            52.153533,
            115.235978
          ],
          [
            18.011533,
            52.153475,
            115.314528
          ],
          [
            18.011815,
            52.15342,
            115.389489
          ],
          [
            18.012147,
            52.153362,
            115.477714
          ],
          [
            18.012435,
            52.153304,
            115.554976
          ],
          [
            18.012741,
            52.153252,
            115.809733
          ],
          [
            18.013034,
            52.153207,
            116.258414
          ],
          [
            18.013372,
            52.153132,
            116.791229
          ],
          [
            18.013684,
            52.153054,
            117.290554
          ],
          [
            18.013991,
            52.152974,
            117.785807
          ],
          [
            18.01431,
            52.152928,
            118.271824
          ],
          [
            18.014637,
            52.152871,
            118.776167
          ],
          [
            18.014969,
            52.152819,
            119.284334
          ],
          [
            18.015319,
            52.152782,
            119.814432
          ],
          [
            18.015654,
            52.152714,
            119.955326
          ],
          [
            18.016005,
            52.152649,
            119.970938
          ],
          [
            18.016352,
            52.152592,
            119.986228
          ],
          [
            18.016676,
            52.152533,
            120.00061
          ],
          [
            18.017003,
            52.152465,
            120.015297
          ],
          [
            18.017341,
            52.152403,
            120.030337
          ],
          [
            18.017661,
            52.152338,
            120.044681
          ],
          [
            18.018002,
            52.15227,
            120.059932
          ],
          [
            18.018352,
            52.152194,
            119.799448
          ],
          [
            18.018682,
            52.152122,
            119.228663
          ],
          [
            18.019048,
            52.15205,
            118.603713
          ],
          [
            18.019424,
            52.15198,
            117.965157
          ],
          [
            18.019796,
            52.151914,
            117.334929
          ],
          [
            18.02019,
            52.151836,
            116.661857
          ],
          [
            18.020571,
            52.151751,
            116.003051
          ],
          [
            18.020953,
            52.151683,
            115.355918
          ],
          [
            18.021364,
            52.151621,
            115.242767
          ],
          [
            18.021781,
            52.151542,
            115.173527
          ],
          [
            18.022165,
            52.151464,
            115.109352
          ],
          [
            18.022535,
            52.15139,
            115.047605
          ],
          [
            18.022926,
            52.151315,
            114.982606
          ],
          [
            18.023309,
            52.151254,
            114.919737
          ],
          [
            18.023694,
            52.151177,
            114.855491
          ],
          [
            18.024034,
            52.151104,
            114.734331
          ],
          [
            18.0244,
            52.151003,
            114.572642
          ],
          [
            18.024765,
            52.150895,
            114.409448
          ],
          [
            18.025141,
            52.150807,
            114.247285
          ],
          [
            18.025545,
            52.150808,
            114.084476
          ],
          [
            18.025961,
            52.150838,
            113.915721
          ],
          [
            18.026345,
            52.150875,
            113.759166
          ],
          [
            18.026727,
            52.150919,
            113.790594
          ],
          [
            18.027122,
            52.150965,
            114.162932
          ],
          [
            18.027541,
            52.151015,
            114.558276
          ],
          [
            18.027946,
            52.151071,
            114.942921
          ],
          [
            18.028395,
            52.151101,
            115.362834
          ],
          [
            18.028817,
            52.151068,
            115.756906
          ],
          [
            18.029224,
            52.151034,
            116.137414
          ],
          [
            18.029624,
            52.151005,
            116.324091
          ],
          [
            18.03001,
            52.15099,
            116.193506
          ],
          [
            18.030387,
            52.150965,
            116.065807
          ],
          [
            18.030752,
            52.150949,
            115.942575
          ],
          [
            18.031136,
            52.150921,
            115.812296
          ],
          [
            18.03151,
            52.150889,
            115.685128
          ],
          [
            18.03186,
            52.150857,
            115.565908
          ],
          [
            18.032222,
            52.150832,
            115.443026
          ],
          [
            18.032585,
            52.150811,
            115.511044
          ],
          [
            18.032937,
            52.150786,
            115.734433
          ],
          [
            18.033287,
            52.150753,
            115.957683
          ],
          [
            18.033605,
            52.15071,
            116.163282
          ],
          [
            18.033896,
            52.150638,
            116.3611
          ],
          [
            18.034179,
            52.150555,
            116.56003
          ],
          [
            18.034488,
            52.150402,
            116.811879
          ],
          [
            18.03472,
            52.150273,
            117.009274
          ],
          [
            18.034948,
            52.150137,
            117.209761
          ],
          [
            18.035177,
            52.149996,
            117.322629
          ],
          [
            18.035428,
            52.149866,
            117.424584
          ],
          [
            18.035668,
            52.149725,
            117.527247
          ],
          [
            18.0359,
            52.149571,
            117.632883
          ],
          [
            18.036136,
            52.149429,
            117.735001
          ],
          [
            18.036396,
            52.14926,
            117.852017
          ],
          [
            18.036663,
            52.149111,
            117.96358
          ],
          [
            18.03692,
            52.148965,
            118.071837
          ],
          [
            18.037213,
            52.148799,
            117.988954
          ],
          [
            18.037448,
            52.148662,
            117.713461
          ],
          [
            18.037777,
            52.14846,
            117.318016
          ],
          [
            18.038021,
            52.148325,
            117.03881
          ],
          [
            18.038331,
            52.148154,
            116.68378
          ],
          [
            18.038604,
            52.148007,
            116.375161
          ],
          [
            18.038863,
            52.147858,
            116.073473
          ],
          [
            18.039132,
            52.147719,
            115.774562
          ],
          [
            18.039444,
            52.147584,
            115.988321
          ],
          [
            18.039775,
            52.147456,
            116.553122
          ],
          [
            18.040065,
            52.147379,
            117.009841
          ],
          [
            18.040381,
            52.147458,
            117.530015
          ],
          [
            18.040576,
            52.14763,
            118.022829
          ],
          [
            18.040816,
            52.147802,
            118.556951
          ],
          [
            18.041123,
            52.147934,
            119.098001
          ],
          [
            18.041451,
            52.148026,
            119.618853
          ],
          [
            18.041766,
            52.14815,
            120.065914
          ],
          [
            18.042014,
            52.148305,
            120.405695
          ],
          [
            18.042244,
            52.148467,
            120.741814
          ],
          [
            18.042435,
            52.148655,
            121.088568
          ],
          [
            18.042561,
            52.148867,
            121.442215
          ],
          [
            18.042653,
            52.149048,
            121.739182
          ],
          [
            18.042799,
            52.149263,
            122.103578
          ],
          [
            18.042918,
            52.149448,
            122.414688
          ],
          [
            18.043096,
            52.149675,
            122.930631
          ],
          [
            18.043378,
            52.149839,
            123.698095
          ],
          [
            18.043662,
            52.150017,
            124.49973
          ],
          [
            18.043949,
            52.150196,
            125.307702
          ],
          [
            18.04422,
            52.15038,
            126.105571
          ],
          [
            18.044509,
            52.150555,
            126.908799
          ],
          [
            18.044794,
            52.150719,
            127.679968
          ],
          [
            18.045079,
            52.150889,
            128.464477
          ],
          [
            18.045306,
            52.15106,
            128.500976
          ],
          [
            18.045601,
            52.151243,
            128.527
          ],
          [
            18.045902,
            52.151393,
            128.551081
          ],
          [
            18.046144,
            52.151562,
            128.573825
          ],
          [
            18.046376,
            52.151733,
            128.596363
          ],
          [
            18.046618,
            52.151876,
            128.617255
          ],
          [
            18.046895,
            52.152063,
            128.642822
          ],
          [
            18.047153,
            52.152227,
            128.738073
          ],
          [
            18.047411,
            52.152414,
            129.120114
          ],
          [
            18.047638,
            52.152575,
            129.451231
          ],
          [
            18.047831,
            52.152758,
            129.791461
          ],
          [
            18.048103,
            52.152929,
            130.16563
          ],
          [
            18.048234,
            52.153127,
            130.515114
          ],
          [
            18.048301,
            52.153321,
            130.823448
          ],
          [
            18.048624,
            52.153233,
            131.179027
          ],
          [
            18.049071,
            52.153204,
            131.406133
          ],
          [
            18.049326,
            52.153311,
            131.324959
          ],
          [
            18.049617,
            52.153409,
            131.235503
          ],
          [
            18.049937,
            52.153433,
            131.150721
          ],
          [
            18.050275,
            52.153453,
            131.061592
          ],
          [
            18.050585,
            52.153515,
            130.975171
          ],
          [
            18.050581,
            52.153722,
            130.885654
          ],
          [
            18.050485,
            52.153843,
            130.827099
          ],
          [
            18.050665,
            52.153668,
            130.729377
          ],
          [
            18.050822,
            52.153556,
            130.537129
          ],
          [
            18.051112,
            52.153676,
            130.148718
          ],
          [
            18.051307,
            52.153825,
            129.803955
          ],
          [
            18.051597,
            52.153956,
            129.405295
          ],
          [
            18.051836,
            52.154102,
            129.03184
          ],
          [
            18.052077,
            52.154272,
            128.625482
          ],
          [
            18.052348,
            52.15445,
            128.186141
          ],
          [
            18.05262,
            52.154619,
            127.757682
          ],
          [
            18.052923,
            52.154761,
            127.374025
          ],
          [
            18.053208,
            52.154929,
            127.092301
          ],
          [
            18.053431,
            52.155092,
            126.845873
          ],
          [
            18.053642,
            52.155223,
            126.632948
          ],
          [
            18.053896,
            52.155428,
            126.33511
          ],
          [
            18.054123,
            52.155588,
            126.086769
          ],
          [
            18.054413,
            52.155737,
            125.818732
          ],
          [
            18.054667,
            52.155879,
            125.574984
          ],
          [
            18.054878,
            52.15601,
            125.367798
          ],
          [
            18.055086,
            52.156143,
            125.50099
          ],
          [
            18.055344,
            52.156302,
            125.663049
          ],
          [
            18.055631,
            52.156484,
            125.845713
          ],
          [
            18.055926,
            52.156657,
            126.026368
          ],
          [
            18.056176,
            52.156817,
            126.186557
          ],
          [
            18.056371,
            52.156964,
            126.323356
          ],
          [
            18.05665,
            52.157139,
            126.499978
          ],
          [
            18.056889,
            52.157284,
            126.648739
          ],
          [
            18.057176,
            52.157459,
            126.849837
          ],
          [
            18.057465,
            52.157636,
            127.054696
          ],
          [
            18.057721,
            52.157813,
            127.248661
          ],
          [
            18.057987,
            52.157989,
            127.444922
          ],
          [
            18.058226,
            52.158141,
            127.617754
          ],
          [
            18.058485,
            52.158305,
            127.804527
          ],
          [
            18.058733,
            52.158465,
            127.985594
          ],
          [
            18.058978,
            52.158605,
            128.13492
          ],
          [
            18.059222,
            52.158818,
            128.146497
          ],
          [
            18.059447,
            52.158997,
            128.156575
          ],
          [
            18.059727,
            52.159156,
            128.166991
          ],
          [
            18.060024,
            52.159298,
            128.177322
          ],
          [
            18.060227,
            52.159441,
            128.185769
          ],
          [
            18.060537,
            52.159638,
            128.197942
          ],
          [
            18.060753,
            52.159769,
            128.206229
          ],
          [
            18.061003,
            52.159941,
            128.152175
          ],
          [
            18.061272,
            52.1601,
            127.915821
          ],
          [
            18.061533,
            52.160241,
            127.695971
          ],
          [
            18.061817,
            52.160412,
            127.445278
          ],
          [
            18.06211,
            52.160594,
            127.181855
          ],
          [
            18.062396,
            52.160784,
            126.916282
          ],
          [
            18.06265,
            52.160937,
            126.691998
          ],
          [
            18.062896,
            52.161106,
            126.459
          ],
          [
            18.063152,
            52.161264,
            126.365333
          ],
          [
            18.063419,
            52.161407,
            126.362625
          ],
          [
            18.063643,
            52.161537,
            126.360255
          ],
          [
            18.063892,
            52.161667,
            126.357755
          ],
          [
            18.064155,
            52.161768,
            126.355387
          ],
          [
            18.064426,
            52.161864,
            126.352989
          ],
          [
            18.064692,
            52.161965,
            126.350602
          ],
          [
            18.064964,
            52.162059,
            126.348219
          ],
          [
            18.06529,
            52.162155,
            126.345459
          ],
          [
            18.065577,
            52.162236,
            126.349978
          ],
          [
            18.065839,
            52.162339,
            126.358097
          ],
          [
            18.066161,
            52.162442,
            126.367579
          ],
          [
            18.066434,
            52.162564,
            126.376395
          ],
          [
            18.066758,
            52.162661,
            126.385828
          ],
          [
            18.067116,
            52.162781,
            126.396471
          ],
          [
            18.067392,
            52.162941,
            126.406529
          ],
          [
            18.067741,
            52.163059,
            126.416927
          ],
          [
            18.068093,
            52.163197,
            126.310707
          ],
          [
            18.068465,
            52.163327,
            126.127345
          ],
          [
            18.068719,
            52.163424,
            125.999168
          ],
          [
            18.06898,
            52.16353,
            125.865072
          ],
          [
            18.069303,
            52.163627,
            125.710704
          ],
          [
            18.069584,
            52.163733,
            125.568431
          ],
          [
            18.06987,
            52.163828,
            125.428833
          ],
          [
            18.070138,
            52.163932,
            125.29282
          ],
          [
            18.070465,
            52.164047,
            125.218709
          ],
          [
            18.070758,
            52.164134,
            125.437725
          ],
          [
            18.071113,
            52.164272,
            125.719625
          ],
          [
            18.071389,
            52.16436,
            125.92914
          ],
          [
            18.071707,
            52.164469,
            126.173542
          ],
          [
            18.072035,
            52.164571,
            126.420241
          ],
          [
            18.072301,
            52.164666,
            126.627199
          ],
          [
            18.072581,
            52.164764,
            126.843439
          ],
          [
            18.072832,
            52.164879,
            127.053818
          ],
          [
            18.073152,
            52.164998,
            127.201835
          ],
          [
            18.073468,
            52.165112,
            127.301251
          ],
          [
            18.073837,
            52.165244,
            127.417055
          ],
          [
            18.074202,
            52.165382,
            127.533237
          ],
          [
            18.074527,
            52.165476,
            127.630844
          ],
          [
            18.074859,
            52.165583,
            127.732433
          ],
          [
            18.075185,
            52.165683,
            127.831157
          ],
          [
            18.075533,
            52.165823,
            127.954904
          ],
          [
            18.075792,
            52.165915,
            128.085656
          ],
          [
            18.07611,
            52.166028,
            128.246036
          ],
          [
            18.076428,
            52.166121,
            128.399997
          ],
          [
            18.076689,
            52.166226,
            128.536281
          ],
          [
            18.076958,
            52.166327,
            128.673981
          ],
          [
            18.077218,
            52.166414,
            128.80347
          ],
          [
            18.077499,
            52.16652,
            128.947968
          ],
          [
            18.077794,
            52.166617,
            129.094048
          ],
          [
            18.078068,
            52.166715,
            129.119775
          ],
          [
            18.07839,
            52.166826,
            128.605193
          ],
          [
            18.078675,
            52.166921,
            128.153384
          ],
          [
            18.078932,
            52.167024,
            127.725592
          ],
          [
            18.079208,
            52.167119,
            127.284063
          ],
          [
            18.079486,
            52.167207,
            126.843579
          ],
          [
            18.079778,
            52.167293,
            126.392168
          ],
          [
            18.080055,
            52.167395,
            125.941435
          ],
          [
            18.080331,
            52.167507,
            125.479964
          ],
          [
            18.080669,
            52.167621,
            125.00425
          ],
          [
            18.081033,
            52.167741,
            124.632393
          ],
          [
            18.081285,
            52.167839,
            124.36176
          ],
          [
            18.081627,
            52.167951,
            124.01299
          ],
          [
            18.081904,
            52.168044,
            123.729019
          ],
          [
            18.082177,
            52.168129,
            123.453713
          ],
          [
            18.082452,
            52.168225,
            123.168943
          ],
          [
            18.082728,
            52.168306,
            122.891853
          ],
          [
            18.083067,
            52.168427,
            122.539161
          ],
          [
            18.08332,
            52.168532,
            122.421691
          ],
          [
            18.083627,
            52.168641,
            122.331131
          ],
          [
            18.083951,
            52.168742,
            122.23839
          ],
          [
            18.084246,
            52.168882,
            122.143171
          ],
          [
            18.084539,
            52.168985,
            122.05675
          ],
          [
            18.084828,
            52.169141,
            121.958143
          ],
          [
            18.085097,
            52.169293,
            121.864812
          ],
          [
            18.085372,
            52.169465,
            121.764581
          ],
          [
            18.085634,
            52.169653,
            121.775555
          ],
          [
            18.085925,
            52.169855,
            121.835505
          ],
          [
            18.086112,
            52.170006,
            121.877652
          ],
          [
            18.086395,
            52.170205,
            121.936412
          ],
          [
            18.086675,
            52.170391,
            121.992679
          ],
          [
            18.086926,
            52.170569,
            122.045015
          ],
          [
            18.087147,
            52.170725,
            122.090954
          ],
          [
            18.087325,
            52.170881,
            122.133278
          ],
          [
            18.087524,
            52.171029,
            122.210365
          ],
          [
            18.087724,
            52.171172,
            122.288021
          ],
          [
            18.087995,
            52.171357,
            122.390551
          ],
          [
            18.088285,
            52.171541,
            122.496231
          ],
          [
            18.088551,
            52.171749,
            122.605288
          ],
          [
            18.088822,
            52.171938,
            122.70921
          ],
          [
            18.089108,
            52.172151,
            122.82316
          ],
          [
            18.089372,
            52.172309,
            122.839376
          ],
          [
            18.089582,
            52.17247,
            122.758448
          ],
          [
            18.089821,
            52.172634,
            122.672071
          ],
          [
            18.090068,
            52.17282,
            122.577633
          ],
          [
            18.090308,
            52.173014,
            122.482039
          ],
          [
            18.090556,
            52.173196,
            122.388938
          ],
          [
            18.090839,
            52.173377,
            122.290442
          ],
          [
            18.091103,
            52.173542,
            122.199704
          ],
          [
            18.091364,
            52.173705,
            122.157146
          ],
          [
            18.091624,
            52.173894,
            122.135129
          ],
          [
            18.09186,
            52.174082,
            122.113988
          ],
          [
            18.092114,
            52.174264,
            122.092657
          ],
          [
            18.092371,
            52.174444,
            122.071346
          ],
          [
            18.092642,
            52.174638,
            122.0486
          ],
          [
            18.092895,
            52.174841,
            122.025836
          ],
          [
            18.093168,
            52.175046,
            121.964383
          ],
          [
            18.093404,
            52.175217,
            121.85599
          ],
          [
            18.093682,
            52.175402,
            121.734147
          ],
          [
            18.093935,
            52.175585,
            121.618152
          ],
          [
            18.094186,
            52.175767,
            121.502927
          ],
          [
            18.094449,
            52.17594,
            121.388349
          ],
          [
            18.094705,
            52.176135,
            121.267333
          ],
          [
            18.094991,
            52.176319,
            121.144452
          ],
          [
            18.095295,
            52.176481,
            121.0802
          ],
          [
            18.095599,
            52.176669,
            121.012904
          ],
          [
            18.095861,
            52.176822,
            120.956388
          ],
          [
            18.096171,
            52.176997,
            120.890687
          ],
          [
            18.096493,
            52.177172,
            120.823617
          ],
          [
            18.096799,
            52.177343,
            120.759098
          ],
          [
            18.09711,
            52.177497,
            120.696729
          ],
          [
            18.09737,
            52.177681,
            120.587536
          ],
          [
            18.097658,
            52.17778,
            120.485482
          ],
          [
            18.097964,
            52.177933,
            120.364862
          ],
          [
            18.098261,
            52.178088,
            120.245757
          ],
          [
            18.098526,
            52.178258,
            120.128706
          ],
          [
            18.098793,
            52.178453,
            120.001888
          ],
          [
            18.09903,
            52.178621,
            119.891174
          ],
          [
            18.099276,
            52.178832,
            119.761036
          ],
          [
            18.099512,
            52.17904,
            119.630422
          ],
          [
            18.099723,
            52.179223,
            119.514891
          ],
          [
            18.099966,
            52.17944,
            119.378949
          ],
          [
            18.100156,
            52.179616,
            119.270142
          ],
          [
            18.100394,
            52.179792,
            119.152274
          ],
          [
            18.100556,
            52.179952,
            119.055186
          ],
          [
            18.100757,
            52.180132,
            118.942678
          ],
          [
            18.100934,
            52.180285,
            118.940055
          ],
          [
            18.101125,
            52.180445,
            119.423589
          ],
          [
            18.101307,
            52.180604,
            119.896982
          ],
          [
            18.101525,
            52.180797,
            120.468348
          ],
          [
            18.10178,
            52.181005,
            121.101665
          ],
          [
            18.102041,
            52.181168,
            121.657586
          ],
          [
            18.102345,
            52.181339,
            122.274813
          ],
          [
            18.102587,
            52.181517,
            122.839826
          ],
          [
            18.102804,
            52.181681,
            123.348116
          ],
          [
            18.103071,
            52.181835,
            123.866066
          ],
          [
            18.103311,
            52.181992,
            124.358229
          ],
          [
            18.103507,
            52.182133,
            124.781964
          ],
          [
            18.103823,
            52.182186,
            125.286354
          ],
          [
            18.10389,
            52.182391,
            125.771729
          ],
          [
            18.104091,
            52.182538,
            126.211968
          ],
          [
            18.104347,
            52.182695,
            126.719763
          ],
          [
            18.104584,
            52.182884,
            127.265126
          ],
          [
            18.104807,
            52.183053,
            126.943863
          ],
          [
            18.105086,
            52.18319,
            126.443853
          ],
          [
            18.105379,
            52.183361,
            125.877592
          ],
          [
            18.105629,
            52.18351,
            125.390512
          ],
          [
            18.105889,
            52.183671,
            124.873643
          ],
          [
            18.106129,
            52.183812,
            124.409506
          ],
          [
            18.106411,
            52.183957,
            123.89413
          ],
          [
            18.106683,
            52.184108,
            123.38206
          ],
          [
            18.10698,
            52.184264,
            122.842528
          ],
          [
            18.107241,
            52.184443,
            122.303606
          ],
          [
            18.107499,
            52.184623,
            121.765003
          ],
          [
            18.107768,
            52.184755,
            121.290315
          ],
          [
            18.108098,
            52.184919,
            120.705729
          ],
          [
            18.108393,
            52.185049,
            120.205675
          ],
          [
            18.10868,
            52.185203,
            119.679931
          ],
          [
            18.109014,
            52.185367,
            119.311389
          ],
          [
            18.10924,
            52.185495,
            119.579375
          ],
          [
            18.109482,
            52.185609,
            119.844435
          ],
          [
            18.109796,
            52.185776,
            120.206277
          ],
          [
            18.110086,
            52.185902,
            120.516286
          ],
          [
            18.1104,
            52.186011,
            120.830105
          ],
          [
            18.110789,
            52.186119,
            121.200953
          ],
          [
            18.111107,
            52.186222,
            121.514557
          ],
          [
            18.11143,
            52.186331,
            121.802572
          ],
          [
            18.111714,
            52.186432,
            121.936971
          ],
          [
            18.11201,
            52.186546,
            122.080014
          ],
          [
            18.112299,
            52.18665,
            122.217439
          ],
          [
            18.112568,
            52.18677,
            122.35358
          ],
          [
            18.112872,
            52.186886,
            122.500134
          ],
          [
            18.11316,
            52.187018,
            122.647272
          ],
          [
            18.113455,
            52.187134,
            122.790755
          ],
          [
            18.113724,
            52.18725,
            122.925387
          ],
          [
            18.114016,
            52.187363,
            122.965852
          ],
          [
            18.114306,
            52.187463,
            122.953365
          ],
          [
            18.114597,
            52.187588,
            122.940023
          ],
          [
            18.114882,
            52.187694,
            122.92751
          ],
          [
            18.115146,
            52.187795,
            122.915833
          ],
          [
            18.115425,
            52.187897,
            122.903642
          ],
          [
            18.115695,
            52.188019,
            122.891048
          ],
          [
            18.115933,
            52.188165,
            122.878396
          ],
          [
            18.116136,
            52.188316,
            122.866339
          ],
          [
            18.116307,
            52.188518,
            122.937352
          ],
          [
            18.116467,
            52.18873,
            123.025452
          ],
          [
            18.116604,
            52.188905,
            123.098772
          ],
          [
            18.11673,
            52.189073,
            123.168464
          ],
          [
            18.116857,
            52.189249,
            123.241031
          ],
          [
            18.117028,
            52.189405,
            123.311956
          ],
          [
            18.11715,
            52.189584,
            123.385055
          ],
          [
            18.117282,
            52.189747,
            123.453826
          ],
          [
            18.117435,
            52.189912,
            123.525425
          ],
          [
            18.117607,
            52.190138,
            123.172927
          ],
          [
            18.117742,
            52.190311,
            122.828207
          ],
          [
            18.117862,
            52.19049,
            122.480548
          ],
          [
            18.11801,
            52.190663,
            122.12971
          ],
          [
            18.118161,
            52.19083,
            121.786288
          ],
          [
            18.118339,
            52.191038,
            121.364402
          ],
          [
            18.118518,
            52.191201,
            121.011415
          ],
          [
            18.118728,
            52.191372,
            120.626951
          ],
          [
            18.118963,
            52.19154,
            120.316094
          ],
          [
            18.119207,
            52.19168,
            120.335533
          ],
          [
            18.119445,
            52.191824,
            120.354928
          ],
          [
            18.119706,
            52.191988,
            120.376605
          ],
          [
            18.119969,
            52.192159,
            120.39887
          ],
          [
            18.120224,
            52.19229,
            120.41817
          ],
          [
            18.120468,
            52.19242,
            120.436979
          ],
          [
            18.120726,
            52.192566,
            120.457341
          ],
          [
            18.120977,
            52.192694,
            120.476298
          ],
          [
            18.121227,
            52.192829,
            120.371209
          ],
          [
            18.121485,
            52.19296,
            120.214468
          ],
          [
            18.121739,
            52.193125,
            120.041458
          ],
          [
            18.121992,
            52.193258,
            119.88559
          ],
          [
            18.122244,
            52.193373,
            119.738693
          ],
          [
            18.122525,
            52.193546,
            119.552456
          ],
          [
            18.122769,
            52.193674,
            119.402067
          ],
          [
            18.123017,
            52.193813,
            119.244978
          ],
          [
            18.123249,
            52.193952,
            119.096384
          ],
          [
            18.123508,
            52.194097,
            118.965631
          ],
          [
            18.123741,
            52.194235,
            118.844983
          ],
          [
            18.123999,
            52.194349,
            118.72653
          ],
          [
            18.124264,
            52.19447,
            118.603518
          ],
          [
            18.124544,
            52.194578,
            118.479608
          ],
          [
            18.124835,
            52.194673,
            118.356694
          ],
          [
            18.125152,
            52.194784,
            118.220797
          ],
          [
            18.12548,
            52.194901,
            118.079523
          ],
          [
            18.125813,
            52.194998,
            118.297153
          ],
          [
            18.12612,
            52.19509,
            118.763919
          ],
          [
            18.12639,
            52.195214,
            119.230422
          ],
          [
            18.126717,
            52.195316,
            119.731432
          ],
          [
            18.127018,
            52.195411,
            120.195165
          ],
          [
            18.127319,
            52.195509,
            120.66082
          ],
          [
            18.127712,
            52.195574,
            121.22101
          ],
          [
            18.128076,
            52.195575,
            121.719837
          ],
          [
            18.128421,
            52.195553,
            122.038663
          ],
          [
            18.128767,
            52.195524,
            122.078064
          ],
          [
            18.129109,
            52.195475,
            122.117714
          ],
          [
            18.129485,
            52.19553,
            122.161429
          ],
          [
            18.129824,
            52.195596,
            122.201563
          ],
          [
            18.130098,
            52.195671,
            122.235441
          ],
          [
            18.130384,
            52.195757,
            122.271391
          ],
          [
            18.130737,
            52.195847,
            122.314525
          ],
          [
            18.131021,
            52.19593,
            122.350028
          ],
          [
            18.131317,
            52.196029,
            122.439646
          ],
          [
            18.131631,
            52.19611,
            122.539537
          ],
          [
            18.13192,
            52.196218,
            122.638732
          ],
          [
            18.132228,
            52.196295,
            122.736309
          ],
          [
            18.132543,
            52.196323,
            122.8297
          ],
          [
            18.132844,
            52.1963,
            122.918733
          ],
          [
            18.133139,
            52.196264,
            123.006858
          ],
          [
            18.133433,
            52.196228,
            123.094714
          ],
          [
            18.133729,
            52.196221,
            123.18188
          ],
          [
            18.134071,
            52.196293,
            123.163217
          ],
          [
            18.134381,
            52.196333,
            123.096707
          ],
          [
            18.134702,
            52.196373,
            123.028014
          ],
          [
            18.135018,
            52.196419,
            122.959844
          ],
          [
            18.135336,
            52.196449,
            122.892372
          ],
          [
            18.135655,
            52.1965,
            122.823241
          ],
          [
            18.135959,
            52.196556,
            122.756649
          ],
          [
            18.136277,
            52.196612,
            122.687252
          ],
          [
            18.136613,
            52.196682,
            122.612766
          ],
          [
            18.136924,
            52.196761,
            122.770266
          ],
          [
            18.137243,
            52.196835,
            122.980654
          ],
          [
            18.137552,
            52.196938,
            123.197003
          ],
          [
            18.13785,
            52.197018,
            123.397075
          ],
          [
            18.138132,
            52.197106,
            123.5923
          ],
          [
            18.138418,
            52.197229,
            123.807159
          ],
          [
            18.138679,
            52.19736,
            124.015287
          ],
          [
            18.13894,
            52.197468,
            124.211593
          ],
          [
            18.139203,
            52.197587,
            124.398722
          ],
          [
            18.139463,
            52.1977,
            124.249659
          ],
          [
            18.139788,
            52.197797,
            124.077856
          ],
          [
            18.140096,
            52.197934,
            123.89992
          ],
          [
            18.140352,
            52.19804,
            123.755325
          ],
          [
            18.140752,
            52.198134,
            123.554975
          ],
          [
            18.141033,
            52.198198,
            123.414115
          ],
          [
            18.141323,
            52.198278,
            123.264852
          ],
          [
            18.141599,
            52.198353,
            123.122626
          ],
          [
            18.141882,
            52.198444,
            123.031543
          ],
          [
            18.142217,
            52.198534,
            123.025542
          ],
          [
            18.142512,
            52.198621,
            123.020167
          ],
          [
            18.142816,
            52.198719,
            123.014532
          ],
          [
            18.143104,
            52.198796,
            123.009329
          ],
          [
            18.143382,
            52.198864,
            123.004403
          ],
          [
            18.143677,
            52.198942,
            122.999065
          ],
          [
            18.143951,
            52.199038,
            122.993885
          ],
          [
            18.144227,
            52.199108,
            122.988965
          ],
          [
            18.144498,
            52.199202,
            123.099527
          ],
          [
            18.144788,
            52.199283,
            123.446135
          ],
          [
            18.14509,
            52.199335,
            123.787255
          ],
          [
            18.145428,
            52.199444,
            124.20238
          ],
          [
            18.14579,
            52.199562,
            124.647963
          ],
          [
            18.146152,
            52.199636,
            125.062423
          ],
          [
            18.146545,
            52.199691,
            125.501477
          ],
          [
            18.146957,
            52.19972,
            125.951755
          ],
          [
            18.147387,
            52.199693,
            126.217386
          ],
          [
            18.147761,
            52.199671,
            126.292239
          ],
          [
            18.148062,
            52.199639,
            126.353176
          ],
          [
            18.148374,
            52.199621,
            126.415621
          ],
          [
            18.148682,
            52.199593,
            126.477647
          ],
          [
            18.148985,
            52.199572,
            126.5384
          ],
          [
            18.149408,
            52.19954,
            126.623306
          ],
          [
            18.149716,
            52.199508,
            126.685571
          ],
          [
            18.150108,
            52.199494,
            126.759602
          ],
          [
            18.150425,
            52.199467,
            126.78818
          ],
          [
            18.150769,
            52.199454,
            126.818958
          ],
          [
            18.151102,
            52.199419,
            126.849124
          ],
          [
            18.151453,
            52.19941,
            126.880503
          ],
          [
            18.15179,
            52.199388,
            126.910888
          ],
          [
            18.152107,
            52.199349,
            126.93976
          ],
          [
            18.152429,
            52.199319,
            126.968842
          ],
          [
            18.152799,
            52.199416,
            127.004785
          ],
          [
            18.152997,
            52.199293,
            127.096218
          ],
          [
            18.153406,
            52.199252,
            127.266303
          ],
          [
            18.153821,
            52.199213,
            127.439439
          ],
          [
            18.154241,
            52.199191,
            127.612432
          ],
          [
            18.154645,
            52.19916,
            127.779696
          ],
          [
            18.155006,
            52.19913,
            127.929215
          ],
          [
            18.155388,
            52.199099,
            128.087357
          ],
          [
            18.155764,
            52.199133,
            128.213192
          ],
          [
            18.156131,
            52.199141,
            128.15033
          ],
          [
            18.156458,
            52.199062,
            128.088474
          ],
          [
            18.156851,
            52.199043,
            128.021717
          ],
          [
            18.157233,
            52.199003,
            127.956103
          ],
          [
            18.157625,
            52.198973,
            127.889227
          ],
          [
            18.158027,
            52.198948,
            127.82083
          ],
          [
            18.158415,
            52.198903,
            127.753988
          ],
          [
            18.158817,
            52.198874,
            127.905092
          ],
          [
            18.159226,
            52.198847,
            128.214729
          ],
          [
            18.159624,
            52.198825,
            128.515461
          ],
          [
            18.160012,
            52.198786,
            128.81138
          ],
          [
            18.160389,
            52.19876,
            129.096879
          ],
          [
            18.160796,
            52.198722,
            129.406702
          ],
          [
            18.161185,
            52.198706,
            129.700269
          ],
          [
            18.161559,
            52.19866,
            129.883814
          ],
          [
            18.161898,
            52.198566,
            129.625471
          ],
          [
            18.162289,
            52.198571,
            129.353548
          ],
          [
            18.162691,
            52.198602,
            129.072235
          ],
          [
            18.162984,
            52.1985,
            128.830698
          ],
          [
            18.163149,
            52.198346,
            128.621956
          ],
          [
            18.163347,
            52.198149,
            128.359836
          ],
          [
            18.163531,
            52.197981,
            128.130544
          ],
          [
            18.163693,
            52.197823,
            127.918889
          ],
          [
            18.163897,
            52.197653,
            127.742174
          ],
          [
            18.164089,
            52.197471,
            127.567229
          ],
          [
            18.164264,
            52.197305,
            127.407329
          ],
          [
            18.164458,
            52.197124,
            127.232552
          ],
          [
            18.164655,
            52.196943,
            127.056953
          ],
          [
            18.164871,
            52.19675,
            126.868065
          ],
          [
            18.165089,
            52.196563,
            126.682183
          ],
          [
            18.165302,
            52.196384,
            126.503379
          ],
          [
            18.165506,
            52.196214,
            126.204397
          ],
          [
            18.165678,
            52.196028,
            125.833413
          ],
          [
            18.165912,
            52.195832,
            125.411981
          ],
          [
            18.166122,
            52.195648,
            125.022299
          ],
          [
            18.1663,
            52.195455,
            124.638168
          ],
          [
            18.166514,
            52.195278,
            124.256093
          ],
          [
            18.16674,
            52.195085,
            123.844471
          ],
          [
            18.166971,
            52.19489,
            123.426805
          ],
          [
            18.167189,
            52.194703,
            123.426299
          ],
          [
            18.167396,
            52.194526,
            123.549106
          ],
          [
            18.16761,
            52.194358,
            123.669373
          ],
          [
            18.167815,
            52.194184,
            123.790155
          ],
          [
            18.168028,
            52.194014,
            123.910825
          ],
          [
            18.168233,
            52.193846,
            124.028936
          ],
          [
            18.168406,
            52.193682,
            124.138836
          ],
          [
            18.168608,
            52.193532,
            124.248318
          ],
          [
            18.168822,
            52.193362,
            124.373888
          ],
          [
            18.169015,
            52.193198,
            124.506529
          ],
          [
            18.169203,
            52.193053,
            124.628302
          ],
          [
            18.169375,
            52.192892,
            124.755244
          ],
          [
            18.169597,
            52.19269,
            124.915163
          ],
          [
            18.169842,
            52.192478,
            125.085789
          ],
          [
            18.170062,
            52.192282,
            125.241841
          ],
          [
            18.170265,
            52.192108,
            125.382154
          ],
          [
            18.170493,
            52.191929,
            125.541089
          ],
          [
            18.170673,
            52.19178,
            125.776506
          ],
          [
            18.170855,
            52.19163,
            126.01598
          ],
          [
            18.171085,
            52.191448,
            126.307887
          ],
          [
            18.17129,
            52.191291,
            126.563577
          ],
          [
            18.171496,
            52.191104,
            126.849769
          ],
          [
            18.17171,
            52.190968,
            127.089674
          ],
          [
            18.171904,
            52.190809,
            127.34234
          ],
          [
            18.172107,
            52.190657,
            127.591459
          ],
          [
            18.172259,
            52.190485,
            127.785913
          ],
          [
            18.17244,
            52.190317,
            127.684772
          ],
          [
            18.172643,
            52.190139,
            127.575659
          ],
          [
            18.172869,
            52.189953,
            127.459145
          ],
          [
            18.173052,
            52.1898,
            127.363834
          ],
          [
            18.173257,
            52.189613,
            127.250446
          ],
          [
            18.173462,
            52.18946,
            127.150834
          ],
          [
            18.173684,
            52.189286,
            127.039867
          ],
          [
            18.173915,
            52.189115,
            126.928312
          ],
          [
            18.174128,
            52.188939,
            126.902783
          ],
          [
            18.174331,
            52.18876,
            126.909874
          ],
          [
            18.174519,
            52.188594,
            126.916437
          ],
          [
            18.174727,
            52.188431,
            126.923157
          ],
          [
            18.17496,
            52.188257,
            126.930476
          ],
          [
            18.17522,
            52.188063,
            126.938632
          ],
          [
            18.175476,
            52.187875,
            126.946599
          ],
          [
            18.175674,
            52.187724,
            126.9529
          ],
          [
            18.175897,
            52.187542,
            126.819211
          ],
          [
            18.176104,
            52.187381,
            126.604823
          ],
          [
            18.176298,
            52.187233,
            126.406217
          ],
          [
            18.176553,
            52.187064,
            126.16448
          ],
          [
            18.176804,
            52.186877,
            125.910996
          ],
          [
            18.177015,
            52.186744,
            125.716848
          ],
          [
            18.177243,
            52.186596,
            125.503807
          ],
          [
            18.177469,
            52.186439,
            125.284801
          ],
          [
            18.177712,
            52.186268,
            125.125787
          ],
          [
            18.177953,
            52.186093,
            125.565295
          ],
          [
            18.178222,
            52.185924,
            126.017465
          ],
          [
            18.178446,
            52.185776,
            126.404162
          ],
          [
            18.178727,
            52.185604,
            126.870617
          ],
          [
            18.178944,
            52.185414,
            127.315937
          ],
          [
            18.179142,
            52.185233,
            127.733143
          ],
          [
            18.179353,
            52.185074,
            128.128941
          ],
          [
            18.179568,
            52.184903,
            128.547466
          ],
          [
            18.179795,
            52.184714,
            129.080019
          ],
          [
            18.179998,
            52.184537,
            129.570556
          ],
          [
            18.180175,
            52.184357,
            130.046842
          ],
          [
            18.180331,
            52.184173,
            130.517171
          ],
          [
            18.180473,
            52.183985,
            130.986586
          ],
          [
            18.180566,
            52.183753,
            131.52843
          ],
          [
            18.180757,
            52.183608,
            131.994737
          ],
          [
            18.181112,
            52.183611,
            132.492298
          ],
          [
            18.181471,
            52.183612,
            132.484566
          ],
          [
            18.181813,
            52.183574,
            132.351992
          ],
          [
            18.182126,
            52.183577,
            132.232294
          ],
          [
            18.182469,
            52.183619,
            132.098994
          ],
          [
            18.182823,
            52.183654,
            131.962351
          ],
          [
            18.183139,
            52.183673,
            131.840669
          ],
          [
            18.183488,
            52.183666,
            131.707155
          ],
          [
            18.183825,
            52.183673,
            131.578059
          ],
          [
            18.184197,
            52.183653,
            131.498043
          ],
          [
            18.184553,
            52.183666,
            131.572033
          ],
          [
            18.184852,
            52.183678,
            131.634291
          ],
          [
            18.185188,
            52.183731,
            131.705804
          ],
          [
            18.185489,
            52.183731,
            131.768037
          ],
          [
            18.185809,
            52.183691,
            131.836813
          ],
          [
            18.18614,
            52.183713,
            131.905702
          ],
          [
            18.186469,
            52.183693,
            131.973806
          ],
          [
            18.186773,
            52.183685,
            132.037097
          ],
          [
            18.18709,
            52.183736,
            132.077596
          ],
          [
            18.187382,
            52.183784,
            132.070262
          ],
          [
            18.187709,
            52.183791,
            132.062309
          ],
          [
            18.188038,
            52.183828,
            132.0542
          ],
          [
            18.188325,
            52.183895,
            132.046754
          ],
          [
            18.188577,
            52.183997,
            132.039267
          ],
          [
            18.188845,
            52.184107,
            132.031449
          ],
          [
            18.189102,
            52.184254,
            132.022884
          ],
          [
            18.189326,
            52.184405,
            132.014684
          ],
          [
            18.189564,
            52.184537,
            131.95809
          ],
          [
            18.189885,
            52.184587,
            131.816507
          ],
          [
            18.190208,
            52.184593,
            131.68003
          ],
          [
            18.190555,
            52.184626,
            131.531638
          ],
          [
            18.190894,
            52.184637,
            131.387957
          ],
          [
            18.191348,
            52.184641,
            131.195549
          ],
          [
            18.191691,
            52.184633,
            131.050569
          ],
          [
            18.192029,
            52.184622,
            130.907587
          ],
          [
            18.192439,
            52.184626,
            130.85327
          ],
          [
            18.192815,
            52.184617,
            131.218514
          ],
          [
            18.193209,
            52.184604,
            131.601759
          ],
          [
            18.193518,
            52.184599,
            131.901831
          ],
          [
            18.193836,
            52.184587,
            132.211205
          ],
          [
            18.194148,
            52.184566,
            132.516094
          ],
          [
            18.19446,
            52.184541,
            132.821541
          ],
          [
            18.194768,
            52.184524,
            133.121709
          ],
          [
            18.195082,
            52.184509,
            133.427418
          ],
          [
            18.195445,
            52.184488,
            133.58322
          ],
          [
            18.195842,
            52.184471,
            133.50143
          ],
          [
            18.196176,
            52.184481,
            133.431301
          ],
          [
            18.196536,
            52.184488,
            133.357078
          ],
          [
            18.196949,
            52.184466,
            133.271841
          ],
          [
            18.197287,
            52.184424,
            133.200954
          ],
          [
            18.19764,
            52.184392,
            133.127464
          ],
          [
            18.198043,
            52.184378,
            133.044467
          ],
          [
            18.19844,
            52.184351,
            133.125182
          ],
          [
            18.198851,
            52.184334,
            133.302396
          ],
          [
            18.199284,
            52.184324,
            133.488771
          ],
          [
            18.199716,
            52.184314,
            133.6749
          ],
          [
            18.200143,
            52.184288,
            133.860347
          ],
          [
            18.200521,
            52.184274,
            134.023245
          ],
          [
            18.200821,
            52.184249,
            134.153525
          ],
          [
            18.20112,
            52.184235,
            134.27903
          ],
          [
            18.201485,
            52.18423,
            134.342104
          ],
          [
            18.201789,
            52.1842,
            134.395437
          ],
          [
            18.202094,
            52.184192,
            134.448319
          ],
          [
            18.202398,
            52.184171,
            134.501177
          ],
          [
            18.202715,
            52.184144,
            134.556548
          ],
          [
            18.203032,
            52.184118,
            134.611842
          ],
          [
            18.203353,
            52.184083,
            134.668197
          ],
          [
            18.203662,
            52.184056,
            134.722131
          ],
          [
            18.203975,
            52.184024,
            134.777307
          ],
          [
            18.204297,
            52.183991,
            134.897724
          ],
          [
            18.204664,
            52.183943,
            135.045174
          ],
          [
            18.204981,
            52.183922,
            135.170351
          ],
          [
            18.205313,
            52.183902,
            135.301319
          ],
          [
            18.205661,
            52.183867,
            135.439767
          ],
          [
            18.206013,
            52.183829,
            135.58011
          ],
          [
            18.206368,
            52.183795,
            135.721232
          ],
          [
            18.206733,
            52.183761,
            135.866192
          ],
          [
            18.207098,
            52.183725,
            135.832084
          ],
          [
            18.207471,
            52.183689,
            135.63145
          ],
          [
            18.207866,
            52.18366,
            135.420041
          ],
          [
            18.208253,
            52.183631,
            135.212766
          ],
          [
            18.208626,
            52.183599,
            135.012641
          ],
          [
            18.208998,
            52.183558,
            134.81103
          ],
          [
            18.209383,
            52.183525,
            134.604471
          ],
          [
            18.209752,
            52.183497,
            134.406847
          ],
          [
            18.210111,
            52.183465,
            134.325789
          ],
          [
            18.210463,
            52.183448,
            134.267257
          ],
          [
            18.210815,
            52.183427,
            134.208598
          ],
          [
            18.211147,
            52.183403,
            134.153162
          ],
          [
            18.211472,
            52.183375,
            134.098712
          ],
          [
            18.211782,
            52.183353,
            134.046967
          ],
          [
            18.212089,
            52.183318,
            133.995173
          ],
          [
            18.212386,
            52.183299,
            133.945676
          ],
          [
            18.212814,
            52.18329,
            134.030227
          ],
          [
            18.213252,
            52.18325,
            134.694022
          ],
          [
            18.213614,
            52.183235,
            135.236862
          ],
          [
            18.213918,
            52.183218,
            135.69354
          ],
          [
            18.214287,
            52.183214,
            136.245847
          ],
          [
            18.214633,
            52.183187,
            136.768084
          ],
          [
            18.214929,
            52.183061,
            137.32271
          ],
          [
            18.214993,
            52.182813,
            137.938794
          ],
          [
            18.214906,
            52.182563,
            137.566438
          ],
          [
            18.215037,
            52.182287,
            135.833784
          ],
          [
            18.215086,
            52.182064,
            134.477462
          ],
          [
            18.215183,
            52.181846,
            133.114663
          ],
          [
            18.215299,
            52.181618,
            131.674712
          ],
          [
            18.215459,
            52.181414,
            130.283364
          ],
          [
            18.215672,
            52.181388,
            128.868702
          ],
          [
            18.215962,
            52.18147,
            127.668066
          ],
          [
            18.216304,
            52.181492,
            126.857967
          ],
          [
            18.216678,
            52.181498,
            126.088518
          ],
          [
            18.217064,
            52.181482,
            125.29287
          ],
          [
            18.217412,
            52.18149,
            124.576674
          ],
          [
            18.217752,
            52.181477,
            123.875188
          ],
          [
            18.218082,
            52.18149,
            123.194743
          ],
          [
            18.218407,
            52.181493,
            122.524868
          ],
          [
            18.218724,
            52.181487,
            121.871433
          ],
          [
            18.219019,
            52.181433,
            121.589797
          ],
          [
            18.219325,
            52.181416,
            122.116352
          ],
          [
            18.219633,
            52.181431,
            122.645778
          ],
          [
            18.219988,
            52.181436,
            123.253729
          ],
          [
            18.220418,
            52.181436,
            123.989808
          ],
          [
            18.220789,
            52.181441,
            124.625118
          ],
          [
            18.221089,
            52.181444,
            125.138903
          ],
          [
            18.221388,
            52.181438,
            125.65207
          ],
          [
            18.221764,
            52.181438,
            126.296302
          ],
          [
            18.222075,
            52.181476,
            126.587396
          ],
          [
            18.222373,
            52.181436,
            126.790588
          ],
          [
            18.222675,
            52.181376,
            127.002104
          ],
          [
            18.222915,
            52.181221,
            127.236273
          ],
          [
            18.223191,
            52.181214,
            127.502665
          ],
          [
            18.223481,
            52.181154,
            127.717679
          ],
          [
            18.223784,
            52.18105,
            127.948352
          ],
          [
            18.224039,
            52.1811,
            128.160577
          ],
          [
            18.224298,
            52.181199,
            128.365989
          ],
          [
            18.224602,
            52.181166,
            129.098402
          ],
          [
            18.224788,
            52.181339,
            129.980452
          ],
          [
            18.224765,
            52.181583,
            130.919935
          ],
          [
            18.224827,
            52.181818,
            131.83185
          ],
          [
            18.224912,
            52.18201,
            132.594413
          ],
          [
            18.225055,
            52.182215,
            133.447789
          ],
          [
            18.225215,
            52.182405,
            134.2687
          ],
          [
            18.225402,
            52.182578,
            135.06302
          ],
          [
            18.225634,
            52.182752,
            135.780224
          ],
          [
            18.22588,
            52.182936,
            136.494159
          ],
          [
            18.226104,
            52.183137,
            137.224468
          ],
          [
            18.226304,
            52.183316,
            137.875713
          ],
          [
            18.226556,
            52.183531,
            138.67199
          ],
          [
            18.226788,
            52.183743,
            139.440706
          ],
          [
            18.226994,
            52.183916,
            140.099822
          ],
          [
            18.227204,
            52.184127,
            140.575268
          ],
          [
            18.227467,
            52.184331,
            140.288477
          ],
          [
            18.227699,
            52.18454,
            140.009539
          ],
          [
            18.227947,
            52.184735,
            139.737478
          ],
          [
            18.228211,
            52.184882,
            139.495381
          ],
          [
            18.228516,
            52.185011,
            139.245525
          ],
          [
            18.228782,
            52.185116,
            139.032016
          ],
          [
            18.229073,
            52.185219,
            138.804954
          ],
          [
            18.229334,
            52.185187,
            138.458172
          ],
          [
            18.229546,
            52.18504,
            137.970743
          ],
          [
            18.229802,
            52.184909,
            137.474305
          ],
          [
            18.23008,
            52.18476,
            136.927824
          ],
          [
            18.230383,
            52.184631,
            136.38171
          ],
          [
            18.23074,
            52.18451,
            135.774916
          ],
          [
            18.231055,
            52.184451,
            135.284788
          ],
          [
            18.231339,
            52.184311,
            134.745531
          ],
          [
            18.231581,
            52.184183,
            134.400019
          ],
          [
            18.231841,
            52.184055,
            134.969502
          ],
          [
            18.232069,
            52.183929,
            135.507356
          ],
          [
            18.23234,
            52.183839,
            136.033636
          ],
          [
            18.232587,
            52.183721,
            136.596592
          ],
          [
            18.232423,
            52.183572,
            137.103557
          ],
          [
            18.232279,
            52.183406,
            137.626679
          ],
          [
            18.23202,
            52.183361,
            138.155911
          ],
          [
            18.231692,
            52.183385,
            138.72032
          ],
          [
            18.231382,
            52.18335,
            139.267863
          ],
          [
            18.230913,
            52.183411,
            138.973732
          ],
          [
            18.230439,
            52.183544,
            138.608248
          ],
          [
            18.23074,
            52.1834,
            138.160188
          ],
          [
            18.230727,
            52.183497,
            137.769192
          ],
          [
            18.232493,
            52.18385,
            136.34966
          ],
          [
            18.232686,
            52.183996,
            136.105354
          ],
          [
            18.232885,
            52.184163,
            135.834624
          ],
          [
            18.233046,
            52.184342,
            135.568637
          ],
          [
            18.233237,
            52.184505,
            135.307724
          ],
          [
            18.233046,
            52.184667,
            135.039207
          ],
          [
            18.232772,
            52.184805,
            134.202806
          ],
          [
            18.232506,
            52.184957,
            133.257732
          ],
          [
            18.232224,
            52.185053,
            132.427246
          ],
          [
            18.23194,
            52.185177,
            131.529551
          ],
          [
            18.23164,
            52.185303,
            130.593276
          ],
          [
            18.231466,
            52.185478,
            129.718471
          ],
          [
            18.231148,
            52.185552,
            128.833628
          ],
          [
            18.230839,
            52.185588,
            128.023612
          ],
          [
            18.230505,
            52.185631,
            127.396357
          ],
          [
            18.230148,
            52.185669,
            127.230508
          ],
          [
            18.229944,
            52.185809,
            127.074016
          ],
          [
            18.229698,
            52.185964,
            126.910912
          ],
          [
            18.229694,
            52.186149,
            126.772354
          ],
          [
            18.229685,
            52.186351,
            126.62144
          ],
          [
            18.229753,
            52.186597,
            126.435018
          ],
          [
            18.229877,
            52.186767,
            126.294256
          ],
          [
            18.230081,
            52.186956,
            126.124302
          ],
          [
            18.230274,
            52.187142,
            126.617323
          ],
          [
            18.230481,
            52.187281,
            127.096665
          ],
          [
            18.230757,
            52.187417,
            127.650346
          ],
          [
            18.231056,
            52.187518,
            128.183388
          ],
          [
            18.231301,
            52.187653,
            128.697881
          ],
          [
            18.231578,
            52.18776,
            129.209076
          ],
          [
            18.23182,
            52.187905,
            129.742747
          ],
          [
            18.232044,
            52.188068,
            130.295257
          ],
          [
            18.232248,
            52.188199,
            130.672114
          ],
          [
            18.232286,
            52.18839,
            130.553138
          ],
          [
            18.232137,
            52.188547,
            130.44236
          ],
          [
            18.231841,
            52.188625,
            130.32391
          ],
          [
            18.231754,
            52.188823,
            130.200664
          ],
          [
            18.231685,
            52.189048,
            130.063906
          ],
          [
            18.231696,
            52.189261,
            129.936619
          ],
          [
            18.231755,
            52.189472,
            129.808608
          ],
          [
            18.231893,
            52.189676,
            129.675814
          ],
          [
            18.232022,
            52.189897,
            130.094142
          ],
          [
            18.232137,
            52.190125,
            130.951045
          ],
          [
            18.23224,
            52.190337,
            131.745467
          ],
          [
            18.232367,
            52.190556,
            132.580065
          ],
          [
            18.232517,
            52.190717,
            133.246795
          ],
          [
            18.23268,
            52.19088,
            133.932891
          ],
          [
            18.232912,
            52.191047,
            134.720436
          ],
          [
            18.233142,
            52.191228,
            135.5438
          ],
          [
            18.233365,
            52.191411,
            135.97457
          ],
          [
            18.233594,
            52.191584,
            135.71603
          ],
          [
            18.233835,
            52.191762,
            135.446863
          ],
          [
            18.234078,
            52.191926,
            135.189579
          ],
          [
            18.234312,
            52.192095,
            134.932339
          ],
          [
            18.234498,
            52.192281,
            134.678852
          ],
          [
            18.23474,
            52.192477,
            134.393671
          ],
          [
            18.234991,
            52.192703,
            134.076618
          ],
          [
            18.235155,
            52.192858,
            134.008993
          ],
          [
            18.235388,
            52.193078,
            134.071697
          ],
          [
            18.235568,
            52.193267,
            134.124011
          ],
          [
            18.235782,
            52.193463,
            134.180387
          ],
          [
            18.235982,
            52.193635,
            134.230904
          ],
          [
            18.236224,
            52.193767,
            134.278378
          ],
          [
            18.236371,
            52.193951,
            134.327685
          ],
          [
            18.236572,
            52.194122,
            134.378066
          ],
          [
            18.23679,
            52.194297,
            134.348082
          ],
          [
            18.237012,
            52.19446,
            134.15058
          ],
          [
            18.237203,
            52.194625,
            133.962357
          ],
          [
            18.237436,
            52.194766,
            133.774152
          ],
          [
            18.237568,
            52.194944,
            133.592316
          ],
          [
            18.237776,
            52.195117,
            133.392388
          ],
          [
            18.237984,
            52.195289,
            133.193113
          ],
          [
            18.238199,
            52.195471,
            132.98409
          ],
          [
            18.238422,
            52.195661,
            132.766363
          ],
          [
            18.238657,
            52.195884,
            133.128796
          ],
          [
            18.23888,
            52.196091,
            133.530791
          ],
          [
            18.23913,
            52.19627,
            133.916015
          ],
          [
            18.23931,
            52.196464,
            134.27754
          ],
          [
            18.239494,
            52.196657,
            134.64024
          ],
          [
            18.239708,
            52.196863,
            135.035868
          ],
          [
            18.239879,
            52.197072,
            135.414817
          ],
          [
            18.24001,
            52.197267,
            135.681274
          ],
          [
            18.240318,
            52.197327,
            135.765755
          ],
          [
            18.240481,
            52.19749,
            135.845944
          ],
          [
            18.240671,
            52.197649,
            135.927857
          ],
          [
            18.240852,
            52.197829,
            136.015772
          ],
          [
            18.24108,
            52.198017,
            136.113122
          ],
          [
            18.241305,
            52.19821,
            136.211702
          ],
          [
            18.241541,
            52.198411,
            136.314711
          ],
          [
            18.241736,
            52.198593,
            136.391817
          ],
          [
            18.241978,
            52.198788,
            136.108748
          ],
          [
            18.242221,
            52.198995,
            135.814087
          ],
          [
            18.24244,
            52.199211,
            135.519744
          ],
          [
            18.242639,
            52.199361,
            135.296198
          ],
          [
            18.242819,
            52.199522,
            135.070302
          ],
          [
            18.243055,
            52.199697,
            134.807974
          ],
          [
            18.243294,
            52.199886,
            134.531562
          ],
          [
            18.243422,
            52.200103,
            134.236763
          ],
          [
            18.243666,
            52.200258,
            133.910588
          ],
          [
            18.24394,
            52.200441,
            133.535733
          ],
          [
            18.244195,
            52.200615,
            133.182649
          ],
          [
            18.244426,
            52.20077,
            132.865784
          ],
          [
            18.244696,
            52.200936,
            132.51187
          ],
          [
            18.244972,
            52.201093,
            132.16327
          ],
          [
            18.245228,
            52.201259,
            131.818488
          ],
          [
            18.245513,
            52.20143,
            131.596525
          ],
          [
            18.245828,
            52.20159,
            131.563801
          ],
          [
            18.246159,
            52.201691,
            131.534318
          ],
          [
            18.246462,
            52.201769,
            131.508111
          ],
          [
            18.246801,
            52.201854,
            131.478881
          ],
          [
            18.247125,
            52.201911,
            131.45184
          ],
          [
            18.247468,
            52.20198,
            131.423043
          ],
          [
            18.24779,
            52.20208,
            131.394255
          ],
          [
            18.248075,
            52.202205,
            131.253758
          ],
          [
            18.24831,
            52.202358,
            130.920547
          ],
          [
            18.248487,
            52.202523,
            130.607628
          ],
          [
            18.24862,
            52.202698,
            130.301583
          ],
          [
            18.248748,
            52.202905,
            129.948669
          ],
          [
            18.248868,
            52.20312,
            129.585603
          ],
          [
            18.249033,
            52.203318,
            129.232252
          ],
          [
            18.249319,
            52.203516,
            128.81182
          ],
          [
            18.249539,
            52.203662,
            128.494955
          ],
          [
            18.249865,
            52.203807,
            128.088749
          ],
          [
            18.250264,
            52.203961,
            127.613693
          ],
          [
            18.250587,
            52.204077,
            127.236201
          ],
          [
            18.250859,
            52.204183,
            126.911443
          ],
          [
            18.251165,
            52.204294,
            126.553204
          ],
          [
            18.251452,
            52.204397,
            126.217966
          ],
          [
            18.25176,
            52.204516,
            125.851134
          ],
          [
            18.252078,
            52.204622,
            125.424123
          ],
          [
            18.252382,
            52.204696,
            124.872098
          ],
          [
            18.252735,
            52.204696,
            124.275746
          ],
          [
            18.253136,
            52.20465,
            123.587398
          ],
          [
            18.253465,
            52.204612,
            123.021136
          ],
          [
            18.253778,
            52.204587,
            122.488697
          ],
          [
            18.254069,
            52.20467,
            121.91696
          ],
          [
            18.254009,
            52.204893,
            121.274364
          ],
          [
            18.253986,
            52.20513,
            120.619235
          ],
          [
            18.25401,
            52.205383,
            120.496776
          ],
          [
            18.254026,
            52.205592,
            120.395696
          ],
          [
            18.254066,
            52.205832,
            120.27908
          ],
          [
            18.254088,
            52.206056,
            120.170667
          ],
          [
            18.254117,
            52.206248,
            120.077264
          ],
          [
            18.254173,
            52.206463,
            119.972071
          ],
          [
            18.25421,
            52.206696,
            119.858965
          ],
          [
            18.254235,
            52.206922,
            119.749861
          ],
          [
            18.254275,
            52.207141,
            119.68683
          ],
          [
            18.254315,
            52.207409,
            119.609846
          ],
          [
            18.254342,
            52.207645,
            119.54216
          ],
          [
            18.254384,
            52.207867,
            119.478307
          ],
          [
            18.25442,
            52.208093,
            119.413443
          ],
          [
            18.254464,
            52.208307,
            119.351832
          ],
          [
            18.254482,
            52.20852,
            119.290907
          ],
          [
            18.254683,
            52.208665,
            119.23503
          ],
          [
            18.254568,
            52.208846,
            118.879397
          ],
          [
            18.254544,
            52.209045,
            118.525811
          ],
          [
            18.254626,
            52.209252,
            118.147384
          ],
          [
            18.254687,
            52.209445,
            117.797248
          ],
          [
            18.254641,
            52.209636,
            117.4326
          ],
          [
            18.254341,
            52.209668,
            117.097807
          ],
          [
            18.254033,
            52.209681,
            116.762391
          ],
          [
            18.253939,
            52.209568,
            116.414503
          ],
          [
            18.254061,
            52.209671,
            116.056408
          ],
          [
            18.254381,
            52.20969,
            116.414399
          ],
          [
            18.254559,
            52.20983,
            116.826433
          ],
          [
            18.254492,
            52.210042,
            117.234685
          ],
          [
            18.254516,
            52.210254,
            117.643918
          ],
          [
            18.254716,
            52.210444,
            118.071878
          ],
          [
            18.254816,
            52.210645,
            118.468984
          ],
          [
            18.254935,
            52.21082,
            118.827433
          ],
          [
            18.255051,
            52.211004,
            119.20022
          ],
          [
            18.255192,
            52.211183,
            119.657256
          ],
          [
            18.25525,
            52.211359,
            120.206097
          ],
          [
            18.255199,
            52.211569,
            120.855498
          ],
          [
            18.255202,
            52.211777,
            121.494849
          ],
          [
            18.255173,
            52.211983,
            122.126122
          ],
          [
            18.25518,
            52.212178,
            122.721678
          ],
          [
            18.254901,
            52.212292,
            123.391297
          ],
          [
            18.254749,
            52.212425,
            123.973009
          ],
          [
            18.254774,
            52.212624,
            124.582369
          ],
          [
            18.254801,
            52.212824,
            124.92593
          ],
          [
            18.254458,
            52.212848,
            124.903527
          ],
          [
            18.254274,
            52.212889,
            124.890765
          ],
          [
            18.254054,
            52.21587,
            120.443343
          ],
          [
            18.25395,
            52.216087,
            119.940145
          ],
          [
            18.253845,
            52.216323,
            120.023163
          ],
          [
            18.253751,
            52.216562,
            120.10656
          ],
          [
            18.253658,
            52.216812,
            120.193544
          ],
          [
            18.253545,
            52.217017,
            120.267911
          ],
          [
            18.253487,
            52.217233,
            120.343366
          ],
          [
            18.25345,
            52.217442,
            120.415236
          ],
          [
            18.253532,
            52.217626,
            120.48357
          ],
          [
            18.25345,
            52.217819,
            120.579694
          ],
          [
            18.253463,
            52.21799,
            120.768737
          ],
          [
            18.253638,
            52.218139,
            120.956359
          ],
          [
            18.25343,
            52.218358,
            121.199008
          ],
          [
            18.253259,
            52.218566,
            121.422834
          ],
          [
            18.253115,
            52.218763,
            121.62955
          ],
          [
            18.252964,
            52.218963,
            121.840581
          ],
          [
            18.25285,
            52.219195,
            122.072631
          ],
          [
            18.252749,
            52.219419,
            122.315692
          ],
          [
            18.252632,
            52.219623,
            122.647903
          ],
          [
            18.252518,
            52.219817,
            122.963892
          ],
          [
            18.252424,
            52.22002,
            123.287179
          ],
          [
            18.252358,
            52.22023,
            123.614281
          ],
          [
            18.252257,
            52.220422,
            123.9231
          ],
          [
            18.252161,
            52.22065,
            124.283992
          ],
          [
            18.252067,
            52.220848,
            124.60332
          ],
          [
            18.251964,
            52.221086,
            124.982119
          ],
          [
            18.251907,
            52.2213,
            124.591881
          ],
          [
            18.251842,
            52.221479,
            124.205351
          ],
          [
            18.251806,
            52.221691,
            123.754386
          ],
          [
            18.251727,
            52.221885,
            123.332522
          ],
          [
            18.251609,
            52.222129,
            122.794918
          ],
          [
            18.251486,
            52.222337,
            122.328619
          ],
          [
            18.251488,
            52.22256,
            121.858403
          ],
          [
            18.251546,
            52.222758,
            121.434394
          ],
          [
            18.251756,
            52.222981,
            121.60675
          ],
          [
            18.251997,
            52.223139,
            122.126566
          ],
          [
            18.252276,
            52.22333,
            122.744565
          ],
          [
            18.252583,
            52.223504,
            123.359978
          ],
          [
            18.252918,
            52.223662,
            123.9824
          ],
          [
            18.253242,
            52.223797,
            124.559178
          ],
          [
            18.253539,
            52.223949,
            125.129149
          ],
          [
            18.253827,
            52.224075,
            125.660779
          ],
          [
            18.254097,
            52.22418,
            126.177502
          ],
          [
            18.254369,
            52.224279,
            126.688617
          ],
          [
            18.254662,
            52.224409,
            127.273308
          ],
          [
            18.255001,
            52.22453,
            127.907163
          ],
          [
            18.255286,
            52.224664,
            128.487725
          ],
          [
            18.25557,
            52.224774,
            129.032475
          ],
          [
            18.255822,
            52.224878,
            129.523429
          ],
          [
            18.256098,
            52.224995,
            130.065726
          ],
          [
            18.256369,
            52.225123,
            130.66428
          ],
          [
            18.256669,
            52.225242,
            131.320442
          ],
          [
            18.256942,
            52.225358,
            131.931481
          ],
          [
            18.25721,
            52.22549,
            132.563067
          ],
          [
            18.257485,
            52.225607,
            133.177675
          ],
          [
            18.257725,
            52.225725,
            133.742692
          ],
          [
            18.258006,
            52.225832,
            134.350696
          ],
          [
            18.258294,
            52.225952,
            134.990111
          ],
          [
            18.25857,
            52.22608,
            135.62582
          ],
          [
            18.258867,
            52.226176,
            136.599689
          ],
          [
            18.259142,
            52.226308,
            137.644069
          ],
          [
            18.259386,
            52.226456,
            138.673979
          ],
          [
            18.259686,
            52.226565,
            139.717086
          ],
          [
            18.259999,
            52.226691,
            140.836618
          ],
          [
            18.260268,
            52.226811,
            141.835323
          ],
          [
            18.260561,
            52.226906,
            142.828849
          ],
          [
            18.260847,
            52.227017,
            143.849671
          ],
          [
            18.261144,
            52.227136,
            144.606031
          ],
          [
            18.261437,
            52.22721,
            144.926148
          ],
          [
            18.261727,
            52.22729,
            145.247559
          ],
          [
            18.262076,
            52.227326,
            145.60476
          ],
          [
            18.262429,
            52.227364,
            145.966774
          ],
          [
            18.262764,
            52.22738,
            146.305839
          ],
          [
            18.263121,
            52.227424,
            146.673735
          ],
          [
            18.263505,
            52.227441,
            147.062047
          ],
          [
            18.263904,
            52.227421,
            147.374803
          ],
          [
            18.264269,
            52.227386,
            147.114422
          ],
          [
            18.264688,
            52.227344,
            146.815209
          ],
          [
            18.265055,
            52.227323,
            146.554714
          ],
          [
            18.265369,
            52.227311,
            146.332945
          ],
          [
            18.265776,
            52.227272,
            146.041751
          ],
          [
            18.266193,
            52.227248,
            145.746424
          ],
          [
            18.266556,
            52.227232,
            145.490013
          ],
          [
            18.266933,
            52.227225,
            145.208522
          ],
          [
            18.267285,
            52.227212,
            144.927087
          ],
          [
            18.267406,
            52.22742,
            144.639607
          ],
          [
            18.26779,
            52.227419,
            144.333078
          ],
          [
            18.268106,
            52.227411,
            144.079865
          ],
          [
            18.268417,
            52.227402,
            143.83171
          ],
          [
            18.268783,
            52.227376,
            143.537036
          ],
          [
            18.269151,
            52.227389,
            143.241918
          ],
          [
            18.269472,
            52.227386,
            142.995312
          ],
          [
            18.269804,
            52.227376,
            142.871739
          ],
          [
            18.270133,
            52.227386,
            142.749274
          ],
          [
            18.270487,
            52.227388,
            142.617684
          ],
          [
            18.270833,
            52.227375,
            142.488664
          ],
          [
            18.271188,
            52.227391,
            142.356356
          ],
          [
            18.271527,
            52.227378,
            142.229943
          ],
          [
            18.27188,
            52.2274,
            142.097889
          ],
          [
            18.272182,
            52.227408,
            141.985107
          ],
          [
            18.272331,
            52.227555,
            141.897286
          ],
          [
            18.272537,
            52.22771,
            141.856684
          ],
          [
            18.272702,
            52.227932,
            141.807247
          ],
          [
            18.272876,
            52.228137,
            141.760109
          ],
          [
            18.272952,
            52.228323,
            141.721274
          ],
          [
            18.273284,
            52.228354,
            141.662641
          ],
          [
            18.273259,
            52.22849,
            141.608865
          ],
          [
            18.273116,
            52.228611,
            141.56965
          ],
          [
            18.27341,
            52.228632,
            141.560395
          ],
          [
            18.273444,
            52.228684,
            141.589381
          ],
          [
            18.273208,
            52.228601,
            141.618459
          ],
          [
            18.272976,
            52.228319,
            141.666378
          ],
          [
            18.272857,
            52.228143,
            141.695757
          ],
          [
            18.272743,
            52.227957,
            141.728067
          ],
          [
            18.272677,
            52.22777,
            141.757099
          ],
          [
            18.272404,
            52.227621,
            141.79129
          ],
          [
            18.272335,
            52.227429,
            141.825596
          ],
          [
            18.271996,
            52.227439,
            142.255283
          ],
          [
            18.271682,
            52.227362,
            142.685279
          ],
          [
            18.271385,
            52.227382,
            143.064169
          ],
          [
            18.271028,
            52.227376,
            143.516566
          ],
          [
            18.270715,
            52.227381,
            143.913877
          ],
          [
            18.270356,
            52.227378,
            144.368434
          ],
          [
            18.270035,
            52.227392,
            144.775903
          ],
          [
            18.269697,
            52.227387,
            145.203992
          ],
          [
            18.269351,
            52.227395,
            145.555971
          ],
          [
            18.269012,
            52.227387,
            145.627792
          ],
          [
            18.268698,
            52.227394,
            145.694308
          ],
          [
            18.268394,
            52.227394,
            145.758845
          ],
          [
            18.268048,
            52.227399,
            145.832131
          ],
          [
            18.267695,
            52.227413,
            145.907135
          ],
          [
            18.267364,
            52.227407,
            145.977296
          ],
          [
            18.26724,
            52.227227,
            146.046963
          ],
          [
            18.266889,
            52.227257,
            146.122054
          ],
          [
            18.266554,
            52.227249,
            146.171908
          ],
          [
            18.266212,
            52.22724,
            146.197774
          ],
          [
            18.265864,
            52.22726,
            146.224181
          ],
          [
            18.265524,
            52.227247,
            146.249914
          ],
          [
            18.265191,
            52.227267,
            146.275199
          ],
          [
            18.264831,
            52.227287,
            146.302562
          ],
          [
            18.264486,
            52.227329,
            146.329135
          ],
          [
            18.264094,
            52.227384,
            146.359516
          ],
          [
            18.263734,
            52.227434,
            146.281542
          ],
          [
            18.26336,
            52.227453,
            145.754088
          ],
          [
            18.262932,
            52.227422,
            145.147447
          ],
          [
            18.262562,
            52.227383,
            144.61989
          ],
          [
            18.262229,
            52.227336,
            144.139774
          ],
          [
            18.261876,
            52.227296,
            143.635444
          ],
          [
            18.261452,
            52.227222,
            143.013848
          ],
          [
            18.261127,
            52.227128,
            142.507825
          ],
          [
            18.260831,
            52.227029,
            141.940426
          ],
          [
            18.260515,
            52.226911,
            141.205304
          ],
          [
            18.260269,
            52.226807,
            140.611714
          ],
          [
            18.259994,
            52.226697,
            139.956425
          ],
          [
            18.259703,
            52.226565,
            139.234606
          ],
          [
            18.259385,
            52.226424,
            138.454267
          ],
          [
            18.259056,
            52.226276,
            137.642535
          ],
          [
            18.258769,
            52.226137,
            136.915877
          ],
          [
            18.258438,
            52.22601,
            136.190538
          ],
          [
            18.258118,
            52.225887,
            135.571403
          ],
          [
            18.25778,
            52.225731,
            134.879064
          ],
          [
            18.257424,
            52.225559,
            134.137656
          ],
          [
            18.257026,
            52.225399,
            133.359176
          ],
          [
            18.256648,
            52.22523,
            132.593949
          ],
          [
            18.256273,
            52.225089,
            131.874395
          ],
          [
            18.2559,
            52.224925,
            131.090925
          ],
          [
            18.25551,
            52.224767,
            130.276194
          ],
          [
            18.255142,
            52.22459,
            129.460308
          ],
          [
            18.254726,
            52.224423,
            128.593879
          ],
          [
            18.254385,
            52.224279,
            127.871686
          ],
          [
            18.254054,
            52.224136,
            127.165223
          ],
          [
            18.253726,
            52.224006,
            126.501593
          ],
          [
            18.253422,
            52.223889,
            126.308069
          ],
          [
            18.253129,
            52.22375,
            126.107952
          ],
          [
            18.252844,
            52.223612,
            125.911807
          ],
          [
            18.252552,
            52.223483,
            125.717502
          ],
          [
            18.252275,
            52.223325,
            125.51348
          ],
          [
            18.252028,
            52.223187,
            125.333137
          ],
          [
            18.251837,
            52.223007,
            125.144201
          ],
          [
            18.25165,
            52.222838,
            124.963953
          ],
          [
            18.251578,
            52.222646,
            124.784367
          ],
          [
            18.251535,
            52.222443,
            124.597094
          ],
          [
            18.251612,
            52.222233,
            124.399879
          ],
          [
            18.25168,
            52.22204,
            124.219239
          ],
          [
            18.251778,
            52.221852,
            124.037971
          ],
          [
            18.251822,
            52.221595,
            123.801202
          ],
          [
            18.251861,
            52.221378,
            123.601471
          ],
          [
            18.251912,
            52.2212,
            123.435861
          ],
          [
            18.252006,
            52.220988,
            123.278933
          ],
          [
            18.252068,
            52.220804,
            123.270317
          ],
          [
            18.252181,
            52.220557,
            123.258398
          ],
          [
            18.252283,
            52.220344,
            123.248175
          ],
          [
            18.252381,
            52.22012,
            123.237541
          ],
          [
            18.252504,
            52.219868,
            123.225456
          ],
          [
            18.252615,
            52.219639,
            123.214502
          ],
          [
            18.252765,
            52.219433,
            123.204133
          ],
          [
            18.252864,
            52.219217,
            123.076055
          ],
          [
            18.253004,
            52.218962,
            122.770646
          ],
          [
            18.253178,
            52.218734,
            122.484706
          ],
          [
            18.253323,
            52.218521,
            122.222672
          ],
          [
            18.253467,
            52.218326,
            121.977591
          ],
          [
            18.253653,
            52.218134,
            121.723718
          ],
          [
            18.253654,
            52.217953,
            121.487
          ],
          [
            18.253336,
            52.217856,
            121.233811
          ],
          [
            18.253367,
            52.217637,
            121.055075
          ],
          [
            18.253377,
            52.217394,
            120.899262
          ],
          [
            18.253465,
            52.217209,
            120.776413
          ],
          [
            18.25351,
            52.217018,
            120.652498
          ],
          [
            18.253619,
            52.216816,
            120.516688
          ],
          [
            18.253712,
            52.216588,
            120.366858
          ],
          [
            18.253801,
            52.216368,
            120.222356
          ],
          [
            18.253908,
            52.216128,
            120.063731
          ],
          [
            18.254011,
            52.215877,
            119.968784
          ],
          [
            18.254104,
            52.215656,
            119.914345
          ],
          [
            18.254169,
            52.215432,
            119.859995
          ],
          [
            18.254262,
            52.215229,
            119.809697
          ],
          [
            18.254348,
            52.215035,
            119.761754
          ],
          [
            18.254391,
            52.214847,
            119.716435
          ],
          [
            18.254478,
            52.214668,
            119.67189
          ],
          [
            18.254568,
            52.214439,
            119.615356
          ],
          [
            18.25467,
            52.214205,
            119.779706
          ],
          [
            18.254758,
            52.214018,
            120.160637
          ],
          [
            18.254831,
            52.213818,
            120.561119
          ],
          [
            18.254815,
            52.213623,
            120.944132
          ],
          [
            18.254776,
            52.213397,
            121.388315
          ],
          [
            18.254767,
            52.213172,
            121.828132
          ],
          [
            18.254783,
            52.212916,
            122.329338
          ],
          [
            18.25459,
            52.212824,
            122.737279
          ],
          [
            18.254239,
            52.212803,
            123.055003
          ],
          [
            18.254419,
            52.212852,
            122.893766
          ],
          [
            18.254735,
            52.212839,
            122.643488
          ],
          [
            18.254728,
            52.212645,
            122.392537
          ],
          [
            18.254724,
            52.212432,
            122.119501
          ],
          [
            18.254683,
            52.212224,
            121.850964
          ],
          [
            18.254549,
            52.212037,
            121.588107
          ],
          [
            18.254534,
            52.211852,
            121.350632
          ],
          [
            18.254486,
            52.211647,
            121.085163
          ],
          [
            18.254417,
            52.211468,
            120.84915
          ],
          [
            18.25442,
            52.21125,
            120.672937
          ],
          [
            18.25438,
            52.21104,
            120.528393
          ],
          [
            18.25438,
            52.210831,
            120.385105
          ],
          [
            18.254388,
            52.210586,
            120.217416
          ],
          [
            18.25443,
            52.210347,
            120.053029
          ],
          [
            18.254498,
            52.210123,
            119.897031
          ],
          [
            18.254564,
            52.209902,
            119.743418
          ],
          [
            18.254635,
            52.209682,
            119.59004
          ],
          [
            18.254791,
            52.209513,
            119.227139
          ],
          [
            18.255156,
            52.209458,
            118.739193
          ],
          [
            18.255499,
            52.209479,
            118.299354
          ],
          [
            18.255833,
            52.209474,
            117.872909
          ],
          [
            18.256141,
            52.209468,
            117.4787
          ],
          [
            18.25652,
            52.209458,
            116.994636
          ],
          [
            18.256899,
            52.209454,
            116.510825
          ],
          [
            18.257262,
            52.209466,
            116.046223
          ],
          [
            18.257648,
            52.209473,
            115.862666
          ],
          [
            18.258031,
            52.209497,
            115.946981
          ],
          [
            18.258365,
            52.209473,
            116.020626
          ],
          [
            18.258703,
            52.209462,
            116.094792
          ],
          [
            18.25902,
            52.209392,
            116.169263
          ],
          [
            18.259291,
            52.209238,
            116.25032
          ],
          [
            18.259569,
            52.209092,
            116.330523
          ],
          [
            18.25979,
            52.208914,
            116.411017
          ],
          [
            18.260054,
            52.208745,
            116.831283
          ],
          [
            18.260351,
            52.208856,
            117.581777
          ],
          [
            18.260565,
            52.209046,
            118.39546
          ],
          [
            18.260887,
            52.209182,
            119.239185
          ],
          [
            18.261243,
            52.209325,
            120.145015
          ],
          [
            18.261584,
            52.209413,
            120.9325
          ],
          [
            18.261857,
            52.209506,
            121.597561
          ],
          [
            18.262187,
            52.209592,
            122.360159
          ],
          [
            18.26252,
            52.209673,
            122.396412
          ],
          [
            18.262817,
            52.209753,
            121.879663
          ],
          [
            18.263006,
            52.209598,
            121.405206
          ],
          [
            18.263286,
            52.209583,
            120.924757
          ],
          [
            18.263366,
            52.209742,
            120.425405
          ],
          [
            18.263603,
            52.209581,
            119.88309
          ],
          [
            18.263917,
            52.209507,
            119.367011
          ],
          [
            18.264329,
            52.209515,
            118.751804
          ],
          [
            18.264678,
            52.209437,
            118.283935
          ],
          [
            18.265052,
            52.209401,
            118.099732
          ],
          [
            18.265429,
            52.209384,
            117.916848
          ],
          [
            18.265803,
            52.209366,
            117.734467
          ],
          [
            18.266149,
            52.209334,
            117.56443
          ],
          [
            18.2665,
            52.209329,
            117.394568
          ],
          [
            18.266846,
            52.209309,
            117.226486
          ],
          [
            18.267212,
            52.209316,
            117.049461
          ],
          [
            18.26758,
            52.209343,
            116.881887
          ],
          [
            18.267897,
            52.209405,
            116.773281
          ],
          [
            18.26822,
            52.209543,
            116.645512
          ],
          [
            18.268485,
            52.209718,
            116.51902
          ],
          [
            18.268742,
            52.209879,
            116.399703
          ],
          [
            18.268958,
            52.210042,
            116.28844
          ],
          [
            18.269209,
            52.210183,
            116.177965
          ],
          [
            18.269465,
            52.210353,
            116.05535
          ],
          [
            18.269713,
            52.210506,
            115.972021
          ],
          [
            18.269879,
            52.210675,
            116.115087
          ],
          [
            18.269985,
            52.210869,
            116.263077
          ],
          [
            18.270035,
            52.211059,
            116.402432
          ],
          [
            18.270083,
            52.211254,
            116.545138
          ],
          [
            18.270129,
            52.211452,
            116.689769
          ],
          [
            18.270204,
            52.211655,
            116.840297
          ],
          [
            18.270288,
            52.211853,
            116.988243
          ],
          [
            18.270349,
            52.212066,
            117.144632
          ],
          [
            18.270437,
            52.212259,
            117.318917
          ],
          [
            18.270497,
            52.212453,
            117.583203
          ],
          [
            18.270623,
            52.212661,
            117.879699
          ],
          [
            18.270709,
            52.212844,
            118.134203
          ],
          [
            18.27079,
            52.213038,
            118.401791
          ],
          [
            18.270858,
            52.213252,
            118.693699
          ],
          [
            18.270924,
            52.213478,
            119.000733
          ],
          [
            18.270958,
            52.213736,
            119.347206
          ],
          [
            18.270908,
            52.213925,
            119.603382
          ],
          [
            18.270806,
            52.214116,
            119.47593
          ],
          [
            18.270667,
            52.21431,
            119.234959
          ],
          [
            18.270512,
            52.214498,
            118.995137
          ],
          [
            18.27046,
            52.214701,
            118.759586
          ],
          [
            18.270537,
            52.214898,
            118.52626
          ],
          [
            18.270752,
            52.215048,
            118.297632
          ],
          [
            18.27104,
            52.215138,
            118.072283
          ],
          [
            18.271335,
            52.215218,
            117.846449
          ],
          [
            18.271618,
            52.215314,
            117.620117
          ],
          [
            18.271909,
            52.215423,
            117.87173
          ],
          [
            18.272204,
            52.215512,
            118.128807
          ],
          [
            18.272504,
            52.215586,
            118.380427
          ],
          [
            18.272793,
            52.215679,
            118.634436
          ],
          [
            18.273094,
            52.21576,
            118.890204
          ],
          [
            18.273382,
            52.215861,
            119.148368
          ],
          [
            18.273689,
            52.215949,
            119.412124
          ],
          [
            18.273975,
            52.216039,
            119.662287
          ],
          [
            18.274278,
            52.216143,
            119.879253
          ],
          [
            18.274615,
            52.216236,
            119.753703
          ],
          [
            18.274895,
            52.216314,
            119.648702
          ],
          [
            18.275229,
            52.216354,
            119.532901
          ],
          [
            18.275573,
            52.216396,
            119.413597
          ],
          [
            18.275911,
            52.21643,
            119.297174
          ],
          [
            18.276244,
            52.216478,
            119.181048
          ],
          [
            18.276588,
            52.216517,
            119.062272
          ],
          [
            18.276921,
            52.216527,
            118.949078
          ],
          [
            18.277248,
            52.216504,
            118.671415
          ],
          [
            18.277581,
            52.216459,
            118.251548
          ],
          [
            18.277916,
            52.216423,
            117.832111
          ],
          [
            18.278256,
            52.216392,
            117.408916
          ],
          [
            18.278585,
            52.216357,
            116.998192
          ],
          [
            18.278912,
            52.216303,
            116.581321
          ],
          [
            18.279277,
            52.216285,
            116.130822
          ],
          [
            18.279646,
            52.216246,
            115.670268
          ],
          [
            18.279978,
            52.216233,
            115.298111
          ],
          [
            18.280406,
            52.21617,
            115.473509
          ],
          [
            18.280734,
            52.216154,
            115.60453
          ],
          [
            18.281026,
            52.216112,
            115.724041
          ],
          [
            18.281384,
            52.216068,
            115.869594
          ],
          [
            18.281696,
            52.216035,
            115.995848
          ],
          [
            18.282008,
            52.216016,
            116.120698
          ],
          [
            18.282378,
            52.216003,
            116.268833
          ],
          [
            18.282732,
            52.21603,
            116.411897
          ],
          [
            18.283057,
            52.216077,
            116.673834
          ],
          [
            18.283406,
            52.216143,
            117.035061
          ],
          [
            18.283742,
            52.216218,
            117.388819
          ],
          [
            18.284033,
            52.21631,
            117.712809
          ],
          [
            18.284307,
            52.216409,
            118.027439
          ],
          [
            18.284657,
            52.216525,
            118.421019
          ],
          [
            18.284952,
            52.216639,
            118.766348
          ],
          [
            18.285239,
            52.216744,
            119.096925
          ],
          [
            18.285509,
            52.216871,
            119.327509
          ],
          [
            18.285811,
            52.216963,
            119.172793
          ],
          [
            18.286136,
            52.216997,
            119.021366
          ],
          [
            18.286482,
            52.217013,
            118.862169
          ],
          [
            18.286799,
            52.216967,
            118.711565
          ],
          [
            18.287158,
            52.216917,
            118.542025
          ],
          [
            18.28747,
            52.216852,
            118.390132
          ],
          [
            18.287835,
            52.216802,
            118.218704
          ],
          [
            18.288181,
            52.216757,
            118.056609
          ],
          [
            18.288533,
            52.216709,
            118.019263
          ],
          [
            18.288876,
            52.216659,
            118.023765
          ],
          [
            18.289207,
            52.216622,
            118.028056
          ],
          [
            18.289547,
            52.216583,
            118.032473
          ],
          [
            18.289917,
            52.216547,
            118.037261
          ],
          [
            18.290274,
            52.216558,
            118.041822
          ],
          [
            18.290629,
            52.216587,
            118.046389
          ],
          [
            18.290974,
            52.216637,
            118.050909
          ],
          [
            18.291273,
            52.216659,
            117.978514
          ],
          [
            18.291591,
            52.216688,
            117.777699
          ],
          [
            18.291911,
            52.216715,
            117.575381
          ],
          [
            18.292231,
            52.216744,
            117.371931
          ],
          [
            18.292533,
            52.216772,
            117.179066
          ],
          [
            18.292839,
            52.216769,
            116.983466
          ],
          [
            18.29316,
            52.216791,
            116.781791
          ],
          [
            18.293469,
            52.216794,
            116.588612
          ],
          [
            18.293846,
            52.216836,
            116.346782
          ],
          [
            18.294169,
            52.216842,
            116.250728
          ],
          [
            18.294521,
            52.216818,
            116.340269
          ],
          [
            18.294866,
            52.216791,
            116.429011
          ],
          [
            18.295199,
            52.216752,
            116.514995
          ],
          [
            18.295521,
            52.216678,
            116.602017
          ],
          [
            18.295835,
            52.216609,
            116.686663
          ],
          [
            18.296144,
            52.216553,
            116.76813
          ],
          [
            18.296451,
            52.216462,
            116.854347
          ],
          [
            18.296765,
            52.216384,
            116.940251
          ],
          [
            18.297077,
            52.216297,
            116.88368
          ],
          [
            18.29736,
            52.216212,
            116.786405
          ],
          [
            18.297658,
            52.216145,
            116.688247
          ],
          [
            18.298019,
            52.216062,
            116.569022
          ],
          [
            18.298321,
            52.215987,
            116.468462
          ],
          [
            18.298613,
            52.215909,
            116.370073
          ],
          [
            18.298915,
            52.215828,
            116.268033
          ],
          [
            18.299225,
            52.215749,
            116.164225
          ],
          [
            18.299556,
            52.215679,
            116.057724
          ],
          [
            18.299891,
            52.215606,
            116.345939
          ],
          [
            18.300241,
            52.215521,
            116.650674
          ],
          [
            18.300574,
            52.215449,
            116.936232
          ],
          [
            18.300903,
            52.215368,
            117.222943
          ],
          [
            18.301221,
            52.215288,
            117.501301
          ],
          [
            18.301532,
            52.215211,
            117.772952
          ],
          [
            18.301854,
            52.215139,
            118.050366
          ],
          [
            18.302188,
            52.21509,
            118.328515
          ],
          [
            18.302546,
            52.215055,
            118.506155
          ],
          [
            18.302864,
            52.215047,
            118.60812
          ],
          [
            18.303266,
            52.215058,
            118.73716
          ],
          [
            18.303576,
            52.215044,
            118.83675
          ],
          [
            18.303959,
            52.215039,
            118.959842
          ],
          [
            18.304295,
            52.215051,
            119.067671
          ],
          [
            18.304679,
            52.215032,
            119.191975
          ],
          [
            18.305075,
            52.215034,
            119.318956
          ],
          [
            18.305479,
            52.215043,
            118.66364
          ],
          [
            18.305867,
            52.215028,
            117.528179
          ],
          [
            18.306275,
            52.21502,
            116.335549
          ],
          [
            18.306642,
            52.215026,
            115.263353
          ],
          [
            18.306959,
            52.215092,
            114.285725
          ],
          [
            18.307368,
            52.215141,
            113.068769
          ],
          [
            18.307776,
            52.215233,
            111.791355
          ],
          [
            18.308142,
            52.215301,
            110.859794
          ],
          [
            18.308496,
            52.21542,
            111.306921
          ],
          [
            18.308816,
            52.215527,
            111.710684
          ],
          [
            18.309197,
            52.215585,
            112.143929
          ],
          [
            18.309485,
            52.215679,
            112.50404
          ],
          [
            18.309826,
            52.215755,
            112.906547
          ],
          [
            18.310219,
            52.215786,
            113.344656
          ],
          [
            18.310526,
            52.215772,
            113.684761
          ],
          [
            18.310897,
            52.215762,
            114.081724
          ],
          [
            18.311226,
            52.21573,
            114.351323
          ],
          [
            18.311559,
            52.215668,
            114.632868
          ],
          [
            18.311843,
            52.215581,
            114.890121
          ],
          [
            18.312166,
            52.215532,
            115.159298
          ],
          [
            18.312488,
            52.215482,
            115.428073
          ],
          [
            18.312818,
            52.215436,
            115.701908
          ],
          [
            18.313143,
            52.215399,
            115.969712
          ],
          [
            18.313483,
            52.215337,
            116.256698
          ],
          [
            18.313913,
            52.215294,
            116.556734
          ],
          [
            18.314333,
            52.21523,
            116.809076
          ],
          [
            18.314728,
            52.215176,
            117.045045
          ],
          [
            18.315128,
            52.215098,
            117.290033
          ],
          [
            18.315417,
            52.215033,
            117.470139
          ],
          [
            18.315712,
            52.21496,
            117.65566
          ],
          [
            18.316061,
            52.214897,
            117.868531
          ],
          [
            18.316416,
            52.21483,
            118.086873
          ],
          [
            18.316817,
            52.214767,
            118.318256
          ],
          [
            18.317228,
            52.214689,
            118.556392
          ],
          [
            18.317531,
            52.214648,
            118.728063
          ],
          [
            18.317817,
            52.214584,
            118.896507
          ],
          [
            18.318105,
            52.214518,
            119.066838
          ],
          [
            18.318477,
            52.214462,
            119.278776
          ],
          [
            18.318783,
            52.214396,
            119.458267
          ],
          [
            18.319094,
            52.214323,
            119.642515
          ],
          [
            18.319419,
            52.214283,
            119.682142
          ],
          [
            18.319741,
            52.214239,
            119.483973
          ],
          [
            18.320065,
            52.214195,
            119.284689
          ],
          [
            18.320375,
            52.21415,
            119.093578
          ],
          [
            18.320722,
            52.214094,
            118.878166
          ],
          [
            18.321074,
            52.214026,
            118.655646
          ],
          [
            18.321368,
            52.213978,
            118.473013
          ],
          [
            18.321721,
            52.213921,
            118.254098
          ],
          [
            18.322021,
            52.213859,
            118.0642
          ],
          [
            18.322323,
            52.213804,
            118.04243
          ],
          [
            18.322671,
            52.213741,
            118.124433
          ],
          [
            18.322992,
            52.213686,
            118.199933
          ],
          [
            18.323287,
            52.21361,
            118.272247
          ],
          [
            18.323603,
            52.213561,
            118.346181
          ],
          [
            18.323894,
            52.213515,
            118.414226
          ],
          [
            18.324197,
            52.213459,
            118.485711
          ],
          [
            18.324551,
            52.213402,
            118.56838
          ],
          [
            18.324926,
            52.213326,
            118.657596
          ],
          [
            18.325122,
            52.213124,
            118.536663
          ],
          [
            18.325068,
            52.212898,
            118.415749
          ],
          [
            18.325015,
            52.212686,
            118.302249
          ],
          [
            18.324936,
            52.212465,
            118.182218
          ],
          [
            18.324861,
            52.21224,
            118.060555
          ],
          [
            18.324821,
            52.212014,
            117.940227
          ],
          [
            18.324776,
            52.211826,
            117.839673
          ],
          [
            18.324733,
            52.211628,
            117.733928
          ],
          [
            18.324673,
            52.211423,
            118.08117
          ],
          [
            18.324628,
            52.211197,
            118.616142
          ],
          [
            18.324581,
            52.211012,
            119.055994
          ],
          [
            18.324547,
            52.210799,
            119.558711
          ],
          [
            18.324526,
            52.210612,
            119.998997
          ],
          [
            18.324481,
            52.210399,
            120.504042
          ],
          [
            18.324459,
            52.210157,
            121.073561
          ],
          [
            18.3247,
            52.210053,
            121.539274
          ],
          [
            18.32506,
            52.210001,
            121.880436
          ],
          [
            18.325394,
            52.20994,
            121.692284
          ],
          [
            18.32572,
            52.209899,
            121.512611
          ],
          [
            18.326042,
            52.209839,
            121.330895
          ],
          [
            18.326381,
            52.209786,
            121.141834
          ],
          [
            18.326707,
            52.209747,
            120.962563
          ],
          [
            18.327041,
            52.209694,
            120.776337
          ],
          [
            18.327415,
            52.209631,
            120.566985
          ],
          [
            18.327762,
            52.209579,
            120.373925
          ],
          [
            18.328087,
            52.209517,
            120.312382
          ],
          [
            18.32846,
            52.209457,
            120.265103
          ],
          [
            18.328816,
            52.209411,
            120.220491
          ],
          [
            18.329164,
            52.209349,
            120.176062
          ],
          [
            18.329547,
            52.209323,
            120.128825
          ],
          [
            18.329927,
            52.209278,
            120.081383
          ],
          [
            18.330317,
            52.20922,
            120.032134
          ],
          [
            18.330651,
            52.209153,
            119.98901
          ],
          [
            18.331022,
            52.2091,
            119.616328
          ],
          [
            18.331366,
            52.209047,
            119.266159
          ],
          [
            18.331666,
            52.209002,
            118.961517
          ],
          [
            18.331993,
            52.208959,
            118.631542
          ],
          [
            18.332302,
            52.208922,
            118.321015
          ],
          [
            18.332618,
            52.208868,
            117.997109
          ],
          [
            18.332924,
            52.208799,
            117.675355
          ],
          [
            18.333234,
            52.208754,
            117.360986
          ],
          [
            18.333589,
            52.20871,
            117.104269
          ],
          [
            18.333909,
            52.208655,
            117.14185
          ],
          [
            18.334213,
            52.208622,
            117.176849
          ],
          [
            18.334581,
            52.208561,
            117.219895
          ],
          [
            18.334886,
            52.208509,
            117.255641
          ],
          [
            18.335287,
            52.208438,
            117.303054
          ],
          [
            18.335623,
            52.208394,
            117.341975
          ],
          [
            18.335974,
            52.208345,
            117.382816
          ],
          [
            18.33638,
            52.208302,
            117.437788
          ],
          [
            18.336772,
            52.208264,
            117.571066
          ],
          [
            18.337171,
            52.208219,
            117.707685
          ],
          [
            18.337548,
            52.208123,
            117.845288
          ],
          [
            18.337623,
            52.20791,
            117.966429
          ],
          [
            18.337802,
            52.207718,
            118.089202
          ],
          [
            18.338002,
            52.207544,
            118.20589
          ],
          [
            18.338196,
            52.207351,
            118.330109
          ],
          [
            18.33839,
            52.207129,
            118.61078
          ],
          [
            18.338541,
            52.206949,
            118.997576
          ],
          [
            18.338706,
            52.206718,
            119.47935
          ],
          [
            18.338895,
            52.206497,
            119.955831
          ],
          [
            18.339095,
            52.206281,
            120.430102
          ],
          [
            18.339265,
            52.206062,
            120.894545
          ],
          [
            18.339448,
            52.205843,
            121.365087
          ],
          [
            18.339643,
            52.205646,
            121.807863
          ],
          [
            18.339952,
            52.205525,
            121.440187
          ],
          [
            18.340299,
            52.205429,
            120.983538
          ],
          [
            18.340644,
            52.20532,
            120.518311
          ],
          [
            18.341006,
            52.205212,
            120.035268
          ],
          [
            18.341346,
            52.205142,
            119.605351
          ],
          [
            18.341725,
            52.205083,
            119.135836
          ],
          [
            18.342132,
            52.20504,
            118.640792
          ],
          [
            18.342531,
            52.205013,
            118.513916
          ],
          [
            18.342934,
            52.204998,
            119.046965
          ],
          [
            18.343234,
            52.204938,
            119.463533
          ],
          [
            18.343562,
            52.204847,
            119.938924
          ],
          [
            18.343954,
            52.204754,
            120.49421
          ],
          [
            18.34432,
            52.204668,
            121.01162
          ],
          [
            18.344648,
            52.204605,
            121.465735
          ],
          [
            18.345013,
            52.204526,
            121.977497
          ],
          [
            18.345372,
            52.204443,
            122.394673
          ],
          [
            18.345704,
            52.204392,
            122.70351
          ],
          [
            18.346027,
            52.204327,
            123.013603
          ],
          [
            18.346399,
            52.204242,
            123.371817
          ],
          [
            18.346796,
            52.204159,
            123.750427
          ],
          [
            18.347155,
            52.204059,
            124.106226
          ],
          [
            18.347491,
            52.203988,
            124.427111
          ],
          [
            18.347835,
            52.203892,
            124.768151
          ],
          [
            18.348067,
            52.203989,
            124.61364
          ],
          [
            18.34802,
            52.204214,
            124.301647
          ],
          [
            18.348035,
            52.204442,
            123.985849
          ],
          [
            18.348088,
            52.204681,
            123.654541
          ],
          [
            18.348167,
            52.204871,
            123.384979
          ],
          [
            18.34825,
            52.205093,
            123.072163
          ],
          [
            18.348571,
            52.205106,
            122.796642
          ],
          [
            18.348966,
            52.20505,
            122.455047
          ],
          [
            18.349326,
            52.205003,
            122.375699
          ],
          [
            18.349692,
            52.205008,
            122.371495
          ],
          [
            18.350044,
            52.204978,
            122.36741
          ],
          [
            18.350396,
            52.204937,
            122.363273
          ],
          [
            18.350759,
            52.204901,
            122.359052
          ],
          [
            18.351197,
            52.204893,
            122.354021
          ],
          [
            18.35156,
            52.204845,
            122.349758
          ],
          [
            18.351897,
            52.204823,
            122.345845
          ],
          [
            18.35222,
            52.204864,
            121.603032
          ],
          [
            18.352569,
            52.2048,
            120.617027
          ],
          [
            18.352892,
            52.204712,
            119.660925
          ],
          [
            18.353269,
            52.204633,
            118.575687
          ],
          [
            18.353589,
            52.204612,
            117.706072
          ],
          [
            18.353889,
            52.204554,
            116.830983
          ],
          [
            18.354224,
            52.204469,
            115.846341
          ],
          [
            18.354544,
            52.204401,
            114.927299
          ],
          [
            18.354855,
            52.204372,
            114.653839
          ],
          [
            18.355232,
            52.204355,
            115.359572
          ],
          [
            18.355576,
            52.204331,
            116.003051
          ],
          [
            18.355954,
            52.204273,
            116.731687
          ],
          [
            18.356307,
            52.204203,
            117.421399
          ],
          [
            18.356683,
            52.204135,
            118.150246
          ],
          [
            18.357047,
            52.204112,
            118.830367
          ],
          [
            18.357396,
            52.204083,
            119.485989
          ],
          [
            18.357707,
            52.204045,
            119.862753
          ],
          [
            18.358067,
            52.204031,
            119.836766
          ],
          [
            18.358435,
            52.204013,
            119.810153
          ],
          [
            18.35878,
            52.203967,
            119.784547
          ],
          [
            18.359089,
            52.203824,
            119.756624
          ],
          [
            18.359406,
            52.203691,
            119.728918
          ],
          [
            18.359698,
            52.203556,
            119.702572
          ],
          [
            18.359978,
            52.203392,
            119.674671
          ],
          [
            18.360202,
            52.20322,
            119.607233
          ],
          [
            18.360417,
            52.20304,
            119.476204
          ],
          [
            18.360731,
            52.202984,
            119.351604
          ],
          [
            18.361064,
            52.203002,
            119.232696
          ],
          [
            18.361454,
            52.20304,
            119.092175
          ],
          [
            18.361809,
            52.2031,
            118.961211
          ],
          [
            18.362215,
            52.20321,
            118.80329
          ],
          [
            18.362502,
            52.203306,
            118.687006
          ],
          [
            18.362778,
            52.203403,
            118.832043
          ],
          [
            18.36308,
            52.203536,
            119.516674
          ],
          [
            18.363321,
            52.203644,
            120.065621
          ],
          [
            18.363639,
            52.20376,
            120.746398
          ],
          [
            18.363955,
            52.203872,
            121.42108
          ],
          [
            18.364207,
            52.203985,
            121.995341
          ],
          [
            18.364499,
            52.204119,
            122.666064
          ],
          [
            18.364828,
            52.204229,
            123.355454
          ],
          [
            18.365157,
            52.204341,
            124.003725
          ],
          [
            18.365421,
            52.204454,
            123.869538
          ],
          [
            18.365682,
            52.204553,
            123.741869
          ],
          [
            18.366019,
            52.204633,
            123.591597
          ],
          [
            18.366356,
            52.204695,
            123.445063
          ],
          [
            18.366733,
            52.20473,
            123.286067
          ],
          [
            18.367108,
            52.204752,
            123.12933
          ],
          [
            18.367523,
            52.204781,
            122.955653
          ],
          [
            18.367927,
            52.204777,
            122.786321
          ],
          [
            18.368338,
            52.204767,
            122.558483
          ],
          [
            18.368681,
            52.204721,
            122.36394
          ],
          [
            18.369069,
            52.204711,
            122.148538
          ],
          [
            18.369463,
            52.204691,
            121.929692
          ],
          [
            18.369851,
            52.204675,
            121.714274
          ],
          [
            18.370217,
            52.20466,
            121.511095
          ],
          [
            18.370615,
            52.204639,
            121.289489
          ],
          [
            18.37101,
            52.204611,
            121.35221
          ],
          [
            18.371399,
            52.204596,
            121.760419
          ],
          [
            18.371807,
            52.204574,
            122.1892
          ],
          [
            18.372165,
            52.204576,
            122.566695
          ],
          [
            18.372461,
            52.204571,
            122.877737
          ],
          [
            18.372822,
            52.204537,
            123.261099
          ],
          [
            18.373255,
            52.204519,
            123.718813
          ],
          [
            18.373617,
            52.204483,
            124.10351
          ],
          [
            18.373984,
            52.204449,
            124.021437
          ],
          [
            18.374374,
            52.204441,
            123.669527
          ],
          [
            18.374701,
            52.204386,
            123.360466
          ],
          [
            18.375075,
            52.204369,
            123.021321
          ],
          [
            18.375383,
            52.204321,
            122.733794
          ],
          [
            18.375692,
            52.204273,
            122.446397
          ],
          [
            18.376016,
            52.204233,
            122.148204
          ],
          [
            18.376337,
            52.204193,
            121.852734
          ],
          [
            18.376665,
            52.204158,
            121.556345
          ],
          [
            18.376981,
            52.204131,
            121.294692
          ],
          [
            18.377299,
            52.204094,
            121.028257
          ],
          [
            18.377674,
            52.204048,
            120.7128
          ],
          [
            18.377971,
            52.204013,
            120.464462
          ],
          [
            18.378381,
            52.203977,
            120.124215
          ],
          [
            18.378768,
            52.20393,
            119.800271
          ],
          [
            18.379094,
            52.203902,
            119.530525
          ],
          [
            18.379417,
            52.203859,
            119.259745
          ],
          [
            18.379715,
            52.203848,
            119.069893
          ],
          [
            18.380071,
            52.203799,
            118.865678
          ],
          [
            18.380434,
            52.203769,
            118.660976
          ],
          [
            18.380793,
            52.203723,
            118.455944
          ],
          [
            18.381092,
            52.203699,
            118.287405
          ],
          [
            18.381407,
            52.203661,
            118.108002
          ],
          [
            18.381724,
            52.203614,
            117.925249
          ],
          [
            18.382042,
            52.203618,
            117.745155
          ],
          [
            18.38241,
            52.203663,
            117.575182
          ],
          [
            18.382771,
            52.203751,
            117.954086
          ],
          [
            18.383064,
            52.20382,
            118.260435
          ],
          [
            18.383363,
            52.20388,
            118.567031
          ],
          [
            18.383761,
            52.203984,
            118.988725
          ],
          [
            18.384049,
            52.204058,
            119.294847
          ],
          [
            18.384316,
            52.204139,
            119.585284
          ],
          [
            18.384613,
            52.204217,
            119.900114
          ],
          [
            18.384927,
            52.204282,
            120.223026
          ],
          [
            18.38521,
            52.204376,
            120.418796
          ],
          [
            18.385493,
            52.204469,
            120.442782
          ],
          [
            18.385871,
            52.20454,
            120.472295
          ],
          [
            18.38626,
            52.204592,
            120.502217
          ],
          [
            18.386648,
            52.204578,
            120.531323
          ],
          [
            18.387018,
            52.20457,
            120.559137
          ],
          [
            18.387443,
            52.204577,
            120.590885
          ],
          [
            18.387852,
            52.20458,
            120.621546
          ],
          [
            18.388207,
            52.204575,
            120.648746
          ],
          [
            18.388522,
            52.204587,
            120.673044
          ],
          [
            18.388941,
            52.204614,
            120.705451
          ],
          [
            18.389359,
            52.204626,
            120.737702
          ],
          [
            18.389765,
            52.204633,
            120.768937
          ],
          [
            18.390078,
            52.204637,
            120.793028
          ],
          [
            18.390438,
            52.20465,
            120.820778
          ],
          [
            18.390751,
            52.20465,
            120.844843
          ],
          [
            18.391064,
            52.204649,
            120.979469
          ],
          [
            18.391419,
            52.204667,
            121.206335
          ],
          [
            18.391843,
            52.204685,
            121.477073
          ],
          [
            18.392264,
            52.204703,
            121.74658
          ],
          [
            18.392563,
            52.204711,
            121.937544
          ],
          [
            18.392975,
            52.204726,
            122.20035
          ],
          [
            18.393365,
            52.204751,
            122.450678
          ],
          [
            18.393624,
            52.20488,
            122.665
          ],
          [
            18.393817,
            52.205045,
            123.008398
          ],
          [
            18.394025,
            52.20525,
            123.475585
          ],
          [
            18.394225,
            52.205456,
            123.939507
          ],
          [
            18.394434,
            52.205648,
            124.386643
          ],
          [
            18.394605,
            52.205842,
            124.813335
          ],
          [
            18.394817,
            52.206033,
            125.260828
          ],
          [
            18.395047,
            52.20625,
            125.762031
          ],
          [
            18.39527,
            52.206478,
            126.160193
          ],
          [
            18.395515,
            52.206684,
            125.874926
          ],
          [
            18.395714,
            52.206866,
            125.628895
          ],
          [
            18.395922,
            52.207086,
            125.34425
          ],
          [
            18.396162,
            52.207293,
            125.060129
          ],
          [
            18.396379,
            52.207502,
            124.782835
          ],
          [
            18.3966,
            52.207698,
            124.516271
          ],
          [
            18.396826,
            52.207899,
            124.243124
          ],
          [
            18.397015,
            52.208129,
            124.021066
          ],
          [
            18.397269,
            52.208332,
            123.815172
          ],
          [
            18.397482,
            52.208545,
            123.614017
          ],
          [
            18.397681,
            52.20873,
            123.435746
          ],
          [
            18.397894,
            52.208937,
            123.238858
          ],
          [
            18.398083,
            52.209127,
            123.059838
          ],
          [
            18.398292,
            52.209322,
            122.872142
          ],
          [
            18.398491,
            52.209508,
            122.671176
          ],
          [
            18.398695,
            52.209683,
            122.423085
          ],
          [
            18.39889,
            52.209884,
            122.15322
          ],
          [
            18.399086,
            52.210089,
            121.879146
          ],
          [
            18.399287,
            52.210266,
            121.630404
          ],
          [
            18.39948,
            52.210448,
            121.380004
          ],
          [
            18.399662,
            52.210629,
            121.134049
          ],
          [
            18.399838,
            52.210786,
            120.914326
          ],
          [
            18.399987,
            52.210966,
            120.681046
          ],
          [
            18.400209,
            52.211152,
            120.722448
          ],
          [
            18.400408,
            52.211337,
            120.776525
          ],
          [
            18.400597,
            52.21152,
            120.829397
          ],
          [
            18.400786,
            52.211699,
            120.88142
          ],
          [
            18.401006,
            52.211924,
            120.94553
          ],
          [
            18.401196,
            52.212117,
            121.00055
          ],
          [
            18.401382,
            52.212311,
            121.055455
          ],
          [
            18.401571,
            52.212497,
            121.109031
          ],
          [
            18.401779,
            52.212709,
            121.174754
          ],
          [
            18.402017,
            52.212916,
            121.241882
          ],
          [
            18.402205,
            52.213098,
            121.298984
          ],
          [
            18.402434,
            52.213309,
            121.36616
          ],
          [
            18.402654,
            52.21349,
            121.426003
          ],
          [
            18.402876,
            52.21366,
            121.483772
          ],
          [
            18.403097,
            52.213842,
            121.543912
          ],
          [
            18.403375,
            52.214019,
            121.609438
          ],
          [
            18.403622,
            52.214203,
            121.673553
          ],
          [
            18.403865,
            52.21438,
            121.735805
          ],
          [
            18.404102,
            52.214545,
            121.795077
          ],
          [
            18.404337,
            52.214731,
            121.858469
          ],
          [
            18.404574,
            52.214914,
            121.921335
          ],
          [
            18.404789,
            52.215093,
            121.981159
          ],
          [
            18.405087,
            52.215272,
            122.050035
          ],
          [
            18.405357,
            52.215467,
            122.133326
          ],
          [
            18.405626,
            52.215684,
            122.227679
          ],
          [
            18.40583,
            52.215904,
            122.315313
          ],
          [
            18.405988,
            52.216123,
            122.398233
          ],
          [
            18.406117,
            52.216316,
            122.470479
          ],
          [
            18.406237,
            52.21651,
            122.542421
          ],
          [
            18.40635,
            52.216711,
            122.616033
          ],
          [
            18.406501,
            52.216912,
            122.692096
          ],
          [
            18.406621,
            52.217114,
            122.736851
          ],
          [
            18.406746,
            52.217299,
            122.778555
          ],
          [
            18.407079,
            52.217477,
            122.839283
          ],
          [
            18.40743,
            52.217438,
            122.885661
          ],
          [
            18.407711,
            52.217279,
            122.934449
          ],
          [
            18.407933,
            52.217135,
            122.975627
          ],
          [
            18.408142,
            52.216983,
            123.016949
          ],
          [
            18.40834,
            52.216957,
            123.0548
          ],
          [
            18.408661,
            52.216924,
            122.863027
          ],
          [
            18.408738,
            52.216733,
            122.617301
          ],
          [
            18.408741,
            52.216553,
            122.391806
          ],
          [
            18.408589,
            52.216393,
            122.160312
          ],
          [
            18.408442,
            52.216233,
            121.930802
          ],
          [
            18.408279,
            52.216075,
            121.697368
          ],
          [
            18.408145,
            52.215916,
            121.471424
          ],
          [
            18.408022,
            52.215743,
            121.235588
          ],
          [
            18.407927,
            52.215566,
            121.002843
          ],
          [
            18.407778,
            52.215543,
            120.918496
          ],
          [
            18.40765,
            52.215736,
            121.388626
          ],
          [
            18.407655,
            52.215923,
            121.824011
          ],
          [
            18.407713,
            52.216099,
            122.232026
          ],
          [
            18.407841,
            52.216287,
            122.692348
          ],
          [
            18.407946,
            52.216472,
            123.134364
          ],
          [
            18.408018,
            52.216656,
            123.561502
          ],
          [
            18.408096,
            52.216854,
            124.021299
          ],
          [
            18.407965,
            52.216674,
            124.467376
          ],
          [
            18.407836,
            52.216475,
            124.877825
          ],
          [
            18.407758,
            52.216277,
            124.877825
          ],
          [
            18.407652,
            52.2161,
            124.877825
          ],
          [
            18.407614,
            52.215801,
            124.877825
          ],
          [
            18.40784,
            52.215716,
            124.877825
          ],
          [
            18.408103,
            52.215796,
            124.877825
          ],
          [
            18.408254,
            52.215956,
            124.877825
          ],
          [
            18.408202,
            52.215979,
            124.877825
          ],
          [
            18.408256,
            52.215962,
            124.877825
          ],
          [
            18.408314,
            52.21604,
            124.877825
          ]
        ]
      }
    }
  ]
}

let day51: any = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            18.40833,
            52.216008,
            117.375651
          ],
          [
            18.408149,
            52.215843,
            117.375651
          ],
          [
            18.407967,
            52.215699,
            117.375651
          ],
          [
            18.407666,
            52.215728,
            117.375651
          ],
          [
            18.407569,
            52.215885,
            117.375651
          ],
          [
            18.407717,
            52.216054,
            117.328262
          ],
          [
            18.407851,
            52.216231,
            117.159869
          ],
          [
            18.407891,
            52.216418,
            116.998893
          ],
          [
            18.407975,
            52.21659,
            116.843256
          ],
          [
            18.408109,
            52.216762,
            116.680114
          ],
          [
            18.407881,
            52.21689,
            116.518447
          ],
          [
            18.407759,
            52.217056,
            116.360064
          ],
          [
            18.407748,
            52.217242,
            116.201113
          ],
          [
            18.407542,
            52.217392,
            116.030795
          ],
          [
            18.407282,
            52.217493,
            115.866164
          ],
          [
            18.406989,
            52.21756,
            116.100339
          ],
          [
            18.40694,
            52.217736,
            116.446129
          ],
          [
            18.407096,
            52.217929,
            116.79005
          ],
          [
            18.407178,
            52.218107,
            117.086262
          ],
          [
            18.407303,
            52.218302,
            117.421099
          ],
          [
            18.407483,
            52.218471,
            117.743505
          ],
          [
            18.407787,
            52.218602,
            118.107313
          ],
          [
            18.40809,
            52.218728,
            118.465633
          ],
          [
            18.408362,
            52.218845,
            118.763246
          ],
          [
            18.408681,
            52.218953,
            118.993351
          ],
          [
            18.409028,
            52.219082,
            119.249575
          ],
          [
            18.409367,
            52.219204,
            119.498036
          ],
          [
            18.409633,
            52.219331,
            119.711836
          ],
          [
            18.409993,
            52.219426,
            119.959832
          ],
          [
            18.410266,
            52.219539,
            120.167894
          ],
          [
            18.410507,
            52.219655,
            120.361395
          ],
          [
            18.410768,
            52.219762,
            120.559688
          ],
          [
            18.411077,
            52.219871,
            120.527562
          ],
          [
            18.411424,
            52.219952,
            120.485585
          ],
          [
            18.411793,
            52.219957,
            120.443635
          ],
          [
            18.412154,
            52.219862,
            120.399336
          ],
          [
            18.412505,
            52.219761,
            120.355747
          ],
          [
            18.412827,
            52.219696,
            120.317668
          ],
          [
            18.413238,
            52.219638,
            120.27024
          ],
          [
            18.413549,
            52.21962,
            120.242396
          ],
          [
            18.413834,
            52.219568,
            120.364289
          ],
          [
            18.414133,
            52.219452,
            120.509703
          ],
          [
            18.41436,
            52.219295,
            120.650536
          ],
          [
            18.414595,
            52.219114,
            120.805386
          ],
          [
            18.414872,
            52.218933,
            120.971523
          ],
          [
            18.415181,
            52.218776,
            121.136089
          ],
          [
            18.415524,
            52.218655,
            121.298605
          ],
          [
            18.415901,
            52.218552,
            121.449939
          ],
          [
            18.416258,
            52.218487,
            121.505112
          ],
          [
            18.416557,
            52.218459,
            121.549972
          ],
          [
            18.416848,
            52.21839,
            121.596564
          ],
          [
            18.417087,
            52.218273,
            121.642223
          ],
          [
            18.417291,
            52.218126,
            121.688897
          ],
          [
            18.417545,
            52.21802,
            121.734533
          ],
          [
            18.417829,
            52.217935,
            121.781372
          ],
          [
            18.418189,
            52.217861,
            121.837602
          ],
          [
            18.418497,
            52.217794,
            121.814553
          ],
          [
            18.418791,
            52.217689,
            121.5508
          ],
          [
            18.419064,
            52.217576,
            121.296041
          ],
          [
            18.419314,
            52.217447,
            121.04345
          ],
          [
            18.419564,
            52.217331,
            120.801742
          ],
          [
            18.419806,
            52.217213,
            120.563455
          ],
          [
            18.420033,
            52.217069,
            120.311689
          ],
          [
            18.420241,
            52.216919,
            120.063937
          ],
          [
            18.420483,
            52.216749,
            119.77953
          ],
          [
            18.420712,
            52.216566,
            119.792806
          ],
          [
            18.420939,
            52.216384,
            120.212663
          ],
          [
            18.421144,
            52.21623,
            120.577105
          ],
          [
            18.421373,
            52.216106,
            120.920816
          ],
          [
            18.421636,
            52.215992,
            121.283185
          ],
          [
            18.421911,
            52.2159,
            121.634999
          ],
          [
            18.422191,
            52.215816,
            121.984944
          ],
          [
            18.422473,
            52.215719,
            122.348535
          ],
          [
            18.422716,
            52.215587,
            122.713941
          ],
          [
            18.422924,
            52.215448,
            122.942391
          ],
          [
            18.423151,
            52.215308,
            123.024573
          ],
          [
            18.423418,
            52.215114,
            123.130247
          ],
          [
            18.423601,
            52.214914,
            123.22611
          ],
          [
            18.423706,
            52.21471,
            123.315345
          ],
          [
            18.4238,
            52.2145,
            123.406134
          ],
          [
            18.423793,
            52.214215,
            123.524941
          ],
          [
            18.423674,
            52.213975,
            123.629395
          ],
          [
            18.423567,
            52.213757,
            123.75369
          ],
          [
            18.423599,
            52.213519,
            123.895782
          ],
          [
            18.4237,
            52.213339,
            124.008877
          ],
          [
            18.423878,
            52.21317,
            124.128298
          ],
          [
            18.424125,
            52.212997,
            124.264849
          ],
          [
            18.424374,
            52.212871,
            124.382413
          ],
          [
            18.424691,
            52.21275,
            124.518475
          ],
          [
            18.425017,
            52.212671,
            124.64602
          ],
          [
            18.425352,
            52.2126,
            124.620946
          ],
          [
            18.425662,
            52.212544,
            124.377949
          ],
          [
            18.425962,
            52.212464,
            124.132279
          ],
          [
            18.42625,
            52.212396,
            123.900417
          ],
          [
            18.426548,
            52.212342,
            123.666979
          ],
          [
            18.426894,
            52.212261,
            123.388811
          ],
          [
            18.427272,
            52.212196,
            123.094022
          ],
          [
            18.427599,
            52.212118,
            122.828641
          ],
          [
            18.427937,
            52.212055,
            122.563381
          ],
          [
            18.428272,
            52.211979,
            122.366084
          ],
          [
            18.428608,
            52.211909,
            122.184049
          ],
          [
            18.428931,
            52.211844,
            122.009611
          ],
          [
            18.429285,
            52.211786,
            121.821536
          ],
          [
            18.429631,
            52.211718,
            121.635136
          ],
          [
            18.42997,
            52.211659,
            121.454289
          ],
          [
            18.430279,
            52.211573,
            121.279619
          ],
          [
            18.430619,
            52.211518,
            121.099233
          ],
          [
            18.430946,
            52.21146,
            120.917131
          ],
          [
            18.431278,
            52.2114,
            120.724979
          ],
          [
            18.431573,
            52.211336,
            120.551203
          ],
          [
            18.431958,
            52.211255,
            120.325189
          ],
          [
            18.432198,
            52.211133,
            120.148994
          ],
          [
            18.432299,
            52.210938,
            119.962931
          ],
          [
            18.432328,
            52.210752,
            119.793413
          ],
          [
            18.432349,
            52.210523,
            119.585406
          ],
          [
            18.432417,
            52.210336,
            119.410541
          ],
          [
            18.432572,
            52.210166,
            119.504568
          ],
          [
            18.432811,
            52.210016,
            119.653633
          ],
          [
            18.433058,
            52.209895,
            119.790933
          ],
          [
            18.433342,
            52.209774,
            119.940667
          ],
          [
            18.433587,
            52.209656,
            120.07566
          ],
          [
            18.43384,
            52.209537,
            120.213748
          ],
          [
            18.434073,
            52.209423,
            120.342998
          ],
          [
            18.434342,
            52.209285,
            120.4949
          ],
          [
            18.434567,
            52.209153,
            120.629855
          ],
          [
            18.434774,
            52.209019,
            120.639645
          ],
          [
            18.435021,
            52.208834,
            120.611936
          ],
          [
            18.435201,
            52.208678,
            120.589691
          ],
          [
            18.435428,
            52.208489,
            120.562435
          ],
          [
            18.435595,
            52.208319,
            120.539376
          ],
          [
            18.435753,
            52.208149,
            120.516693
          ],
          [
            18.4359,
            52.207973,
            120.493771
          ],
          [
            18.436042,
            52.20779,
            120.47027
          ],
          [
            18.436173,
            52.207619,
            120.448366
          ],
          [
            18.4363,
            52.207454,
            119.813379
          ],
          [
            18.436452,
            52.20727,
            119.090145
          ],
          [
            18.436578,
            52.207091,
            118.407395
          ],
          [
            18.436723,
            52.20691,
            117.700793
          ],
          [
            18.436897,
            52.206693,
            116.853929
          ],
          [
            18.437013,
            52.206525,
            116.2149
          ],
          [
            18.437203,
            52.206356,
            115.492559
          ],
          [
            18.437429,
            52.206164,
            114.663429
          ],
          [
            18.437634,
            52.206007,
            114.394418
          ],
          [
            18.43788,
            52.205821,
            115.479703
          ],
          [
            18.438099,
            52.205661,
            116.42734
          ],
          [
            18.438304,
            52.205503,
            117.34263
          ],
          [
            18.438557,
            52.205319,
            118.433691
          ],
          [
            18.438736,
            52.205163,
            119.298937
          ],
          [
            18.438933,
            52.205006,
            120.197594
          ],
          [
            18.43912,
            52.204845,
            121.093433
          ],
          [
            18.439293,
            52.204681,
            121.978683
          ],
          [
            18.439409,
            52.204495,
            122.368208
          ],
          [
            18.439508,
            52.204307,
            122.470834
          ],
          [
            18.439602,
            52.204117,
            122.573944
          ],
          [
            18.439706,
            52.203926,
            122.678401
          ],
          [
            18.439799,
            52.20374,
            122.779359
          ],
          [
            18.439896,
            52.20352,
            122.897608
          ],
          [
            18.440022,
            52.203313,
            123.012404
          ],
          [
            18.44008,
            52.20306,
            123.144949
          ],
          [
            18.440188,
            52.202883,
            123.215073
          ],
          [
            18.440268,
            52.202698,
            122.973541
          ],
          [
            18.440384,
            52.202496,
            122.704182
          ],
          [
            18.440471,
            52.202303,
            122.452349
          ],
          [
            18.440584,
            52.20211,
            122.193635
          ],
          [
            18.44068,
            52.201928,
            121.95307
          ],
          [
            18.440749,
            52.201725,
            121.692229
          ],
          [
            18.440873,
            52.201533,
            121.431861
          ],
          [
            18.440956,
            52.201348,
            121.190534
          ],
          [
            18.441053,
            52.201151,
            120.996685
          ],
          [
            18.44116,
            52.200956,
            121.147121
          ],
          [
            18.441241,
            52.200757,
            121.296997
          ],
          [
            18.441321,
            52.200577,
            121.433315
          ],
          [
            18.44143,
            52.200406,
            121.567468
          ],
          [
            18.441529,
            52.200228,
            121.705027
          ],
          [
            18.441626,
            52.20004,
            121.849667
          ],
          [
            18.441714,
            52.199861,
            121.98627
          ],
          [
            18.441872,
            52.199653,
            122.15498
          ],
          [
            18.44226,
            52.199553,
            122.451144
          ],
          [
            18.442569,
            52.199502,
            122.863197
          ],
          [
            18.442917,
            52.199466,
            123.317387
          ],
          [
            18.44325,
            52.199429,
            123.752881
          ],
          [
            18.443565,
            52.199406,
            124.160944
          ],
          [
            18.443857,
            52.199364,
            124.547465
          ],
          [
            18.444177,
            52.199339,
            124.963019
          ],
          [
            18.444526,
            52.199292,
            125.423766
          ],
          [
            18.444834,
            52.199255,
            125.827501
          ],
          [
            18.445158,
            52.19923,
            125.923384
          ],
          [
            18.445481,
            52.199209,
            125.61275
          ],
          [
            18.445788,
            52.199167,
            125.311531
          ],
          [
            18.446106,
            52.199133,
            125.002553
          ],
          [
            18.446439,
            52.199094,
            124.677683
          ],
          [
            18.446758,
            52.199068,
            124.369735
          ],
          [
            18.447061,
            52.199037,
            124.075943
          ],
          [
            18.447392,
            52.199015,
            123.756428
          ],
          [
            18.447711,
            52.198969,
            123.441124
          ],
          [
            18.448031,
            52.198918,
            123.277949
          ],
          [
            18.448363,
            52.198893,
            123.332656
          ],
          [
            18.448708,
            52.198859,
            123.389779
          ],
          [
            18.449046,
            52.198839,
            123.44532
          ],
          [
            18.449362,
            52.198806,
            123.497737
          ],
          [
            18.449688,
            52.198776,
            123.551694
          ],
          [
            18.450008,
            52.198737,
            123.605118
          ],
          [
            18.450336,
            52.198698,
            123.659739
          ],
          [
            18.450728,
            52.198663,
            123.724498
          ],
          [
            18.451043,
            52.198635,
            123.916817
          ],
          [
            18.451369,
            52.198586,
            124.157285
          ],
          [
            18.451704,
            52.198545,
            124.402077
          ],
          [
            18.452051,
            52.1985,
            124.656649
          ],
          [
            18.452354,
            52.198465,
            124.878613
          ],
          [
            18.452698,
            52.198441,
            125.126588
          ],
          [
            18.453037,
            52.198399,
            125.37453
          ],
          [
            18.453387,
            52.198366,
            125.628163
          ],
          [
            18.45373,
            52.198326,
            125.82886
          ],
          [
            18.454048,
            52.198295,
            125.785538
          ],
          [
            18.454372,
            52.198269,
            125.741393
          ],
          [
            18.454699,
            52.198237,
            125.696827
          ],
          [
            18.455023,
            52.198204,
            125.6526
          ],
          [
            18.455349,
            52.198203,
            125.608724
          ],
          [
            18.455678,
            52.198208,
            125.564445
          ],
          [
            18.456007,
            52.198215,
            125.520101
          ],
          [
            18.456325,
            52.198253,
            125.476478
          ],
          [
            18.456662,
            52.198277,
            125.455968
          ],
          [
            18.457022,
            52.1983,
            125.517295
          ],
          [
            18.457392,
            52.198361,
            125.582094
          ],
          [
            18.457714,
            52.198418,
            125.638811
          ],
          [
            18.458122,
            52.198504,
            125.711887
          ],
          [
            18.458395,
            52.198582,
            125.762866
          ],
          [
            18.458682,
            52.198649,
            125.814836
          ],
          [
            18.459025,
            52.198746,
            125.878723
          ],
          [
            18.459318,
            52.198811,
            125.931486
          ],
          [
            18.459632,
            52.198856,
            126.149936
          ],
          [
            18.459987,
            52.198921,
            126.428027
          ],
          [
            18.4604,
            52.198974,
            126.743969
          ],
          [
            18.46083,
            52.199004,
            127.068937
          ],
          [
            18.46125,
            52.198974,
            127.385565
          ],
          [
            18.461612,
            52.198939,
            127.659884
          ],
          [
            18.461919,
            52.198906,
            127.893488
          ],
          [
            18.462318,
            52.198878,
            128.131621
          ],
          [
            18.46265,
            52.198864,
            128.121515
          ],
          [
            18.462952,
            52.198838,
            128.11225
          ],
          [
            18.463287,
            52.198816,
            128.10201
          ],
          [
            18.463582,
            52.198781,
            128.092877
          ],
          [
            18.463885,
            52.198757,
            128.083599
          ],
          [
            18.464205,
            52.198733,
            128.073777
          ],
          [
            18.464565,
            52.198702,
            128.062735
          ],
          [
            18.464933,
            52.198679,
            128.051442
          ],
          [
            18.465247,
            52.198644,
            128.002672
          ],
          [
            18.465601,
            52.198604,
            127.857716
          ],
          [
            18.465918,
            52.198574,
            127.728631
          ],
          [
            18.466211,
            52.198537,
            127.607898
          ],
          [
            18.466528,
            52.198514,
            127.479213
          ],
          [
            18.466844,
            52.198488,
            127.350905
          ],
          [
            18.467135,
            52.198452,
            127.231275
          ],
          [
            18.467438,
            52.198426,
            127.107868
          ],
          [
            18.46773,
            52.198393,
            126.988398
          ],
          [
            18.468046,
            52.198372,
            126.859548
          ],
          [
            18.468415,
            52.198353,
            126.69795
          ],
          [
            18.468725,
            52.198333,
            126.561914
          ],
          [
            18.469046,
            52.198313,
            126.420939
          ],
          [
            18.469372,
            52.198289,
            126.277679
          ],
          [
            18.469686,
            52.198268,
            126.13982
          ],
          [
            18.470076,
            52.198245,
            125.968826
          ],
          [
            18.470446,
            52.198204,
            125.804774
          ],
          [
            18.470766,
            52.19817,
            125.663039
          ],
          [
            18.471084,
            52.198151,
            125.385413
          ],
          [
            18.471382,
            52.198132,
            124.956034
          ],
          [
            18.471759,
            52.1981,
            124.41054
          ],
          [
            18.472078,
            52.198079,
            123.950694
          ],
          [
            18.472387,
            52.198069,
            123.507231
          ],
          [
            18.472697,
            52.198061,
            123.061676
          ],
          [
            18.473063,
            52.198071,
            122.536585
          ],
          [
            18.473376,
            52.19808,
            122.086835
          ],
          [
            18.473671,
            52.198106,
            121.659273
          ],
          [
            18.474005,
            52.198109,
            121.468313
          ],
          [
            18.474328,
            52.198121,
            121.678702
          ],
          [
            18.474641,
            52.198131,
            121.884705
          ],
          [
            18.474983,
            52.198154,
            122.10981
          ],
          [
            18.475302,
            52.198157,
            122.317374
          ],
          [
            18.475617,
            52.198178,
            122.523202
          ],
          [
            18.475971,
            52.19822,
            122.757433
          ],
          [
            18.476282,
            52.198234,
            122.960047
          ],
          [
            18.476594,
            52.198271,
            123.166844
          ],
          [
            18.476917,
            52.198279,
            123.254007
          ],
          [
            18.47725,
            52.198282,
            123.18173
          ],
          [
            18.477574,
            52.198307,
            123.1109
          ],
          [
            18.47795,
            52.198334,
            123.028714
          ],
          [
            18.47831,
            52.198378,
            122.948915
          ],
          [
            18.478635,
            52.198477,
            122.869515
          ],
          [
            18.478997,
            52.198615,
            122.776702
          ],
          [
            18.479266,
            52.198702,
            122.710753
          ],
          [
            18.479661,
            52.198776,
            122.524635
          ],
          [
            18.480083,
            52.198862,
            122.089235
          ],
          [
            18.480384,
            52.198898,
            121.789706
          ],
          [
            18.480683,
            52.19895,
            121.485601
          ],
          [
            18.481034,
            52.198983,
            121.138718
          ],
          [
            18.48141,
            52.198986,
            120.770362
          ],
          [
            18.481781,
            52.198969,
            120.406882
          ],
          [
            18.482157,
            52.198926,
            120.032884
          ],
          [
            18.482527,
            52.198866,
            119.988103
          ],
          [
            18.482832,
            52.198802,
            120.513485
          ],
          [
            18.483126,
            52.198725,
            121.034497
          ],
          [
            18.483412,
            52.198641,
            121.551335
          ],
          [
            18.483804,
            52.198531,
            122.254447
          ],
          [
            18.484107,
            52.198431,
            122.815266
          ],
          [
            18.484393,
            52.198332,
            123.350544
          ],
          [
            18.484674,
            52.198202,
            123.927865
          ],
          [
            18.484905,
            52.19807,
            124.442597
          ],
          [
            18.485235,
            52.197901,
            124.231501
          ],
          [
            18.485452,
            52.197774,
            123.950386
          ],
          [
            18.485692,
            52.197651,
            123.657212
          ],
          [
            18.485995,
            52.197498,
            123.28954
          ],
          [
            18.486286,
            52.197349,
            122.934355
          ],
          [
            18.486532,
            52.197224,
            122.634496
          ],
          [
            18.486794,
            52.197054,
            122.27712
          ],
          [
            18.487026,
            52.196934,
            121.992397
          ],
          [
            18.48725,
            52.196809,
            121.884923
          ],
          [
            18.487513,
            52.196654,
            122.102808
          ],
          [
            18.487777,
            52.196499,
            122.321206
          ],
          [
            18.488011,
            52.196386,
            122.49914
          ],
          [
            18.488266,
            52.196231,
            122.714177
          ],
          [
            18.488583,
            52.196058,
            122.967639
          ],
          [
            18.488906,
            52.195888,
            123.221991
          ],
          [
            18.489216,
            52.195735,
            123.459809
          ],
          [
            18.489573,
            52.195614,
            123.832618
          ],
          [
            18.489929,
            52.195503,
            124.299705
          ],
          [
            18.49028,
            52.195407,
            124.749239
          ],
          [
            18.490641,
            52.195303,
            125.215951
          ],
          [
            18.491009,
            52.195212,
            125.679998
          ],
          [
            18.49139,
            52.195114,
            126.163567
          ],
          [
            18.491783,
            52.19503,
            126.650407
          ],
          [
            18.492137,
            52.194995,
            126.989959
          ],
          [
            18.49249,
            52.19497,
            126.930159
          ],
          [
            18.492796,
            52.194951,
            126.878374
          ],
          [
            18.493153,
            52.194944,
            126.81808
          ],
          [
            18.493454,
            52.194907,
            126.766418
          ],
          [
            18.493753,
            52.194873,
            126.71519
          ],
          [
            18.494064,
            52.194851,
            126.662489
          ],
          [
            18.494399,
            52.194829,
            126.605707
          ],
          [
            18.494732,
            52.194821,
            126.549638
          ],
          [
            18.495034,
            52.194793,
            126.51982
          ],
          [
            18.49535,
            52.194769,
            126.608605
          ],
          [
            18.495662,
            52.194743,
            126.696271
          ],
          [
            18.496041,
            52.194713,
            126.802699
          ],
          [
            18.496352,
            52.194697,
            126.889625
          ],
          [
            18.496728,
            52.194664,
            126.995369
          ],
          [
            18.497047,
            52.194653,
            127.08459
          ],
          [
            18.497346,
            52.194617,
            127.169889
          ],
          [
            18.49766,
            52.194599,
            127.257789
          ],
          [
            18.497982,
            52.194589,
            127.318402
          ],
          [
            18.4983,
            52.194567,
            127.300626
          ],
          [
            18.498599,
            52.194523,
            127.283519
          ],
          [
            18.498922,
            52.194489,
            127.26532
          ],
          [
            18.499231,
            52.194441,
            127.247597
          ],
          [
            18.499534,
            52.194387,
            127.230077
          ],
          [
            18.499828,
            52.194334,
            127.213062
          ],
          [
            18.50018,
            52.194239,
            127.191677
          ],
          [
            18.500488,
            52.194161,
            127.17313
          ],
          [
            18.500823,
            52.194089,
            127.254772
          ],
          [
            18.501129,
            52.19402,
            127.501426
          ],
          [
            18.501454,
            52.193951,
            127.761618
          ],
          [
            18.501779,
            52.193894,
            128.017487
          ],
          [
            18.502083,
            52.193817,
            128.266483
          ],
          [
            18.502436,
            52.19375,
            128.547064
          ],
          [
            18.502753,
            52.1937,
            128.794748
          ],
          [
            18.503035,
            52.193632,
            129.02406
          ],
          [
            18.503368,
            52.193573,
            129.28632
          ],
          [
            18.503735,
            52.193524,
            129.491757
          ],
          [
            18.504165,
            52.193497,
            129.683498
          ],
          [
            18.504606,
            52.193473,
            129.879891
          ],
          [
            18.504968,
            52.193452,
            130.041204
          ],
          [
            18.505316,
            52.193435,
            130.19611
          ],
          [
            18.505645,
            52.193416,
            130.34271
          ],
          [
            18.506029,
            52.19339,
            130.514163
          ],
          [
            18.506372,
            52.193383,
            130.666398
          ],
          [
            18.506719,
            52.193364,
            130.413963
          ],
          [
            18.507092,
            52.193343,
            130.093927
          ],
          [
            18.507418,
            52.193337,
            129.815473
          ],
          [
            18.507752,
            52.193327,
            129.530565
          ],
          [
            18.508088,
            52.193315,
            129.243569
          ],
          [
            18.508463,
            52.193307,
            128.92376
          ],
          [
            18.508846,
            52.193286,
            128.596221
          ],
          [
            18.509227,
            52.193281,
            128.271433
          ],
          [
            18.5096,
            52.193316,
            128.364256
          ],
          [
            18.509956,
            52.193365,
            128.607464
          ],
          [
            18.510295,
            52.193416,
            128.839295
          ],
          [
            18.510661,
            52.193483,
            129.093144
          ],
          [
            18.511066,
            52.193556,
            129.373523
          ],
          [
            18.511442,
            52.193627,
            129.634916
          ],
          [
            18.511833,
            52.193686,
            129.902716
          ],
          [
            18.512133,
            52.193738,
            130.109809
          ],
          [
            18.51243,
            52.193777,
            130.167929
          ],
          [
            18.512738,
            52.193815,
            130.21033
          ],
          [
            18.513085,
            52.193848,
            130.257538
          ],
          [
            18.513398,
            52.193889,
            130.300583
          ],
          [
            18.513743,
            52.193944,
            130.348599
          ],
          [
            18.514135,
            52.193977,
            130.401852
          ],
          [
            18.514467,
            52.194015,
            130.447293
          ],
          [
            18.514848,
            52.194057,
            130.499335
          ],
          [
            18.515181,
            52.194088,
            130.400655
          ],
          [
            18.5155,
            52.194111,
            130.112672
          ],
          [
            18.515816,
            52.194137,
            129.826343
          ],
          [
            18.516134,
            52.194189,
            129.531395
          ],
          [
            18.51644,
            52.194211,
            129.255293
          ],
          [
            18.516742,
            52.194249,
            128.978763
          ],
          [
            18.517052,
            52.194286,
            128.69567
          ],
          [
            18.517375,
            52.194313,
            128.40353
          ],
          [
            18.517741,
            52.194371,
            128.064758
          ],
          [
            18.518055,
            52.194404,
            127.912246
          ],
          [
            18.518347,
            52.194454,
            127.948958
          ],
          [
            18.518674,
            52.194492,
            127.98924
          ],
          [
            18.518989,
            52.19453,
            128.028135
          ],
          [
            18.519293,
            52.194573,
            128.065925
          ],
          [
            18.519653,
            52.194632,
            128.111012
          ],
          [
            18.519968,
            52.194664,
            128.149643
          ],
          [
            18.520271,
            52.194705,
            128.187272
          ],
          [
            18.520573,
            52.194752,
            128.224959
          ],
          [
            18.520859,
            52.194806,
            128.399808
          ],
          [
            18.521223,
            52.19484,
            129.071355
          ],
          [
            18.521549,
            52.194886,
            129.681656
          ],
          [
            18.521956,
            52.194944,
            130.442871
          ],
          [
            18.522355,
            52.194991,
            131.183493
          ],
          [
            18.522717,
            52.195035,
            131.85691
          ],
          [
            18.523113,
            52.195067,
            132.584603
          ],
          [
            18.523514,
            52.195089,
            133.31786
          ],
          [
            18.523913,
            52.195114,
            133.896625
          ],
          [
            18.524337,
            52.195108,
            134.409919
          ],
          [
            18.5247,
            52.195123,
            134.850165
          ],
          [
            18.525072,
            52.195118,
            135.3006
          ],
          [
            18.525365,
            52.195139,
            135.657547
          ],
          [
            18.525732,
            52.195152,
            136.102383
          ],
          [
            18.526165,
            52.195171,
            136.62873
          ],
          [
            18.526604,
            52.195176,
            137.141326
          ],
          [
            18.527035,
            52.195187,
            136.974607
          ],
          [
            18.527402,
            52.19519,
            136.832771
          ],
          [
            18.527772,
            52.195185,
            136.689712
          ],
          [
            18.528178,
            52.195198,
            136.532589
          ],
          [
            18.52861,
            52.195205,
            136.365573
          ],
          [
            18.528915,
            52.195211,
            136.24763
          ],
          [
            18.529291,
            52.195228,
            136.10189
          ],
          [
            18.529586,
            52.195224,
            135.97494
          ],
          [
            18.53,
            52.1952,
            135.727741
          ],
          [
            18.53036,
            52.195159,
            135.510469
          ],
          [
            18.530708,
            52.195103,
            135.297014
          ],
          [
            18.531061,
            52.19502,
            135.072749
          ],
          [
            18.531435,
            52.194927,
            134.833346
          ],
          [
            18.531802,
            52.19485,
            134.602942
          ],
          [
            18.532162,
            52.194765,
            134.374052
          ],
          [
            18.532452,
            52.194708,
            134.222216
          ],
          [
            18.532833,
            52.194628,
            134.071422
          ],
          [
            18.53323,
            52.194532,
            133.9116
          ],
          [
            18.53352,
            52.194464,
            133.795196
          ],
          [
            18.533878,
            52.194388,
            133.653341
          ],
          [
            18.534261,
            52.19429,
            133.497949
          ],
          [
            18.534651,
            52.19419,
            133.339524
          ],
          [
            18.535051,
            52.194111,
            133.182215
          ],
          [
            18.535381,
            52.194033,
            133.161185
          ],
          [
            18.535769,
            52.193941,
            133.146051
          ],
          [
            18.536125,
            52.193856,
            133.132152
          ],
          [
            18.536416,
            52.193795,
            133.120939
          ],
          [
            18.536781,
            52.193725,
            133.107018
          ],
          [
            18.537112,
            52.193653,
            133.094215
          ],
          [
            18.537393,
            52.193587,
            133.08324
          ],
          [
            18.537804,
            52.193484,
            133.067074
          ],
          [
            18.5381,
            52.193414,
            132.919419
          ],
          [
            18.538419,
            52.193338,
            132.75193
          ],
          [
            18.53874,
            52.193271,
            132.58596
          ],
          [
            18.539032,
            52.193196,
            132.431013
          ],
          [
            18.539355,
            52.193126,
            132.263468
          ],
          [
            18.539648,
            52.193048,
            132.107246
          ],
          [
            18.540015,
            52.192977,
            131.918975
          ],
          [
            18.540315,
            52.192912,
            131.763333
          ],
          [
            18.540621,
            52.192832,
            131.631773
          ],
          [
            18.540913,
            52.192773,
            131.63299
          ],
          [
            18.541191,
            52.192702,
            131.634182
          ],
          [
            18.541486,
            52.192558,
            131.635685
          ],
          [
            18.541735,
            52.192336,
            131.637425
          ],
          [
            18.541908,
            52.192167,
            131.638713
          ],
          [
            18.542069,
            52.191986,
            131.640047
          ],
          [
            18.542269,
            52.191781,
            131.641591
          ],
          [
            18.54248,
            52.191604,
            131.643008
          ],
          [
            18.542671,
            52.191391,
            131.735403
          ],
          [
            18.542912,
            52.19117,
            131.844989
          ],
          [
            18.543084,
            52.190989,
            131.931283
          ],
          [
            18.543251,
            52.190791,
            132.02316
          ],
          [
            18.543417,
            52.190587,
            132.117073
          ],
          [
            18.543596,
            52.190391,
            132.209616
          ],
          [
            18.543773,
            52.190174,
            132.309602
          ],
          [
            18.543933,
            52.18997,
            132.395712
          ],
          [
            18.544052,
            52.189756,
            132.453558
          ],
          [
            18.544179,
            52.189541,
            132.512001
          ],
          [
            18.544321,
            52.189314,
            132.574141
          ],
          [
            18.544446,
            52.189082,
            132.636581
          ],
          [
            18.544584,
            52.188854,
            132.698725
          ],
          [
            18.544722,
            52.188619,
            132.762565
          ],
          [
            18.544856,
            52.188389,
            132.824981
          ],
          [
            18.544951,
            52.188187,
            132.944179
          ],
          [
            18.545026,
            52.187961,
            133.113425
          ],
          [
            18.545049,
            52.187722,
            133.288971
          ],
          [
            18.545065,
            52.187472,
            133.472866
          ],
          [
            18.545079,
            52.187215,
            133.66157
          ],
          [
            18.545103,
            52.187023,
            133.802801
          ],
          [
            18.545095,
            52.186835,
            133.940731
          ],
          [
            18.54515,
            52.186629,
            134.09411
          ],
          [
            18.545227,
            52.186431,
            133.980655
          ],
          [
            18.545412,
            52.186231,
            133.601893
          ],
          [
            18.545599,
            52.186027,
            133.217382
          ],
          [
            18.54579,
            52.185841,
            132.856245
          ],
          [
            18.545966,
            52.185664,
            132.514919
          ],
          [
            18.546158,
            52.185501,
            132.184254
          ],
          [
            18.546358,
            52.185314,
            131.815669
          ],
          [
            18.546604,
            52.185164,
            131.466056
          ],
          [
            18.546862,
            52.184976,
            131.14811
          ],
          [
            18.547098,
            52.184812,
            131.000689
          ],
          [
            18.547302,
            52.184667,
            130.871636
          ],
          [
            18.547494,
            52.184522,
            130.745539
          ],
          [
            18.547742,
            52.184355,
            130.593216
          ],
          [
            18.547958,
            52.184217,
            130.464114
          ],
          [
            18.548266,
            52.18403,
            130.284872
          ],
          [
            18.548487,
            52.183898,
            130.157396
          ],
          [
            18.548689,
            52.183756,
            130.030428
          ],
          [
            18.548883,
            52.183618,
            130.00865
          ],
          [
            18.549136,
            52.18345,
            130.031147
          ],
          [
            18.549375,
            52.183278,
            130.053357
          ],
          [
            18.549564,
            52.183137,
            130.071299
          ],
          [
            18.549785,
            52.182992,
            130.090804
          ],
          [
            18.550002,
            52.182845,
            130.110292
          ],
          [
            18.550206,
            52.1827,
            130.129126
          ],
          [
            18.550436,
            52.182558,
            130.148796
          ],
          [
            18.550648,
            52.18241,
            130.168155
          ],
          [
            18.550876,
            52.182273,
            130.365267
          ],
          [
            18.551088,
            52.18214,
            130.602832
          ],
          [
            18.551324,
            52.182004,
            130.856466
          ],
          [
            18.551654,
            52.181879,
            131.16018
          ],
          [
            18.552021,
            52.181745,
            131.495399
          ],
          [
            18.552311,
            52.181654,
            131.750738
          ],
          [
            18.55259,
            52.181571,
            131.994163
          ],
          [
            18.552906,
            52.181461,
            132.280581
          ],
          [
            18.553234,
            52.181364,
            132.522667
          ],
          [
            18.553599,
            52.181261,
            132.696076
          ],
          [
            18.553907,
            52.181155,
            132.848584
          ],
          [
            18.554214,
            52.181032,
            133.006689
          ],
          [
            18.554533,
            52.180929,
            133.162182
          ],
          [
            18.554859,
            52.180828,
            133.319477
          ],
          [
            18.555225,
            52.180707,
            133.498569
          ],
          [
            18.555542,
            52.180584,
            133.660122
          ],
          [
            18.555896,
            52.180479,
            133.797593
          ],
          [
            18.556253,
            52.180367,
            133.913514
          ],
          [
            18.556631,
            52.180253,
            134.035334
          ],
          [
            18.556997,
            52.180133,
            134.155696
          ],
          [
            18.557358,
            52.180016,
            134.273732
          ],
          [
            18.557663,
            52.17992,
            134.372844
          ],
          [
            18.558015,
            52.179818,
            134.485452
          ],
          [
            18.558342,
            52.179694,
            134.611667
          ],
          [
            18.558343,
            52.179502,
            134.795758
          ],
          [
            18.558344,
            52.179286,
            134.996449
          ],
          [
            18.558665,
            52.179208,
            135.191011
          ],
          [
            18.558979,
            52.179119,
            135.384648
          ],
          [
            18.559211,
            52.179208,
            135.560172
          ],
          [
            18.559466,
            52.17925,
            135.731516
          ],
          [
            18.559798,
            52.179219,
            135.923463
          ],
          [
            18.560096,
            52.17915,
            136.102157
          ],
          [
            18.560379,
            52.179052,
            136.310576
          ],
          [
            18.560703,
            52.178964,
            136.582968
          ],
          [
            18.560993,
            52.178851,
            136.845824
          ],
          [
            18.561306,
            52.178778,
            137.102064
          ],
          [
            18.561628,
            52.178707,
            137.363839
          ],
          [
            18.56198,
            52.178612,
            137.658133
          ],
          [
            18.562369,
            52.178511,
            137.981299
          ],
          [
            18.562654,
            52.178433,
            138.220121
          ],
          [
            18.562947,
            52.178353,
            138.43749
          ],
          [
            18.563235,
            52.178276,
            138.151833
          ],
          [
            18.563542,
            52.178197,
            137.849417
          ],
          [
            18.563853,
            52.178107,
            137.53668
          ],
          [
            18.564139,
            52.178032,
            137.254233
          ],
          [
            18.564422,
            52.177951,
            136.969801
          ],
          [
            18.564726,
            52.177814,
            136.626702
          ],
          [
            18.565006,
            52.177659,
            136.28418
          ],
          [
            18.565221,
            52.177525,
            136.005536
          ],
          [
            18.56551,
            52.177392,
            135.986577
          ],
          [
            18.565742,
            52.177258,
            136.488721
          ],
          [
            18.565984,
            52.17714,
            136.975919
          ],
          [
            18.566215,
            52.177017,
            137.458566
          ],
          [
            18.566536,
            52.176845,
            138.13089
          ],
          [
            18.566854,
            52.176693,
            138.769295
          ],
          [
            18.567154,
            52.176546,
            139.374351
          ],
          [
            18.567436,
            52.176388,
            139.977191
          ],
          [
            18.567726,
            52.17623,
            140.388487
          ],
          [
            18.56801,
            52.176098,
            140.316864
          ],
          [
            18.568281,
            52.175957,
            140.245405
          ],
          [
            18.568552,
            52.175832,
            140.177112
          ],
          [
            18.568868,
            52.17566,
            140.092185
          ],
          [
            18.569166,
            52.175509,
            140.014453
          ],
          [
            18.569424,
            52.175314,
            139.932096
          ],
          [
            18.569626,
            52.175146,
            139.863703
          ],
          [
            18.569803,
            52.174999,
            139.758746
          ],
          [
            18.570029,
            52.174793,
            139.473009
          ],
          [
            18.5702,
            52.17462,
            139.240293
          ],
          [
            18.57044,
            52.174431,
            138.964883
          ],
          [
            18.570592,
            52.174256,
            138.735392
          ],
          [
            18.57068,
            52.174057,
            138.495089
          ],
          [
            18.570734,
            52.173845,
            138.246842
          ],
          [
            18.570792,
            52.17365,
            138.017578
          ],
          [
            18.570766,
            52.173462,
            137.800671
          ],
          [
            18.570736,
            52.173248,
            138.009472
          ],
          [
            18.570694,
            52.173011,
            138.358873
          ],
          [
            18.570661,
            52.172794,
            138.678295
          ],
          [
            18.570621,
            52.172566,
            139.014588
          ],
          [
            18.570618,
            52.172319,
            139.376618
          ],
          [
            18.570729,
            52.172266,
            139.656429
          ],
          [
            18.570752,
            52.172508,
            140.011818
          ],
          [
            18.570814,
            52.172759,
            140.384415
          ],
          [
            18.571162,
            52.172848,
            139.977985
          ],
          [
            18.571485,
            52.172917,
            139.600653
          ],
          [
            18.571794,
            52.172986,
            139.238153
          ],
          [
            18.572111,
            52.173045,
            138.872857
          ],
          [
            18.572439,
            52.173118,
            138.488157
          ],
          [
            18.572751,
            52.173186,
            138.122607
          ],
          [
            18.573059,
            52.173259,
            137.758613
          ],
          [
            18.573399,
            52.173326,
            137.364946
          ],
          [
            18.573771,
            52.173329,
            136.943778
          ],
          [
            18.574043,
            52.173177,
            136.535382
          ],
          [
            18.574252,
            52.172962,
            136.093926
          ],
          [
            18.574424,
            52.172739,
            135.658711
          ],
          [
            18.574591,
            52.172512,
            135.218921
          ],
          [
            18.574739,
            52.172299,
            134.81087
          ],
          [
            18.574888,
            52.172094,
            134.415081
          ],
          [
            18.574971,
            52.171905,
            134.07011
          ],
          [
            18.575105,
            52.171729,
            134.22567
          ],
          [
            18.575245,
            52.171533,
            134.571492
          ],
          [
            18.575352,
            52.171348,
            134.891154
          ],
          [
            18.575482,
            52.171158,
            135.224003
          ],
          [
            18.575609,
            52.170969,
            135.55428
          ],
          [
            18.575757,
            52.170769,
            135.909441
          ],
          [
            18.575884,
            52.170562,
            136.267606
          ],
          [
            18.576022,
            52.170347,
            136.640862
          ],
          [
            18.576199,
            52.170102,
            136.809877
          ],
          [
            18.576385,
            52.169857,
            136.609585
          ],
          [
            18.576541,
            52.169609,
            136.412681
          ],
          [
            18.576724,
            52.169345,
            136.199915
          ],
          [
            18.576855,
            52.169121,
            136.023529
          ],
          [
            18.57699,
            52.168925,
            135.865891
          ],
          [
            18.577072,
            52.16873,
            135.716292
          ],
          [
            18.577162,
            52.168531,
            135.56316
          ],
          [
            18.577231,
            52.168318,
            136.235537
          ],
          [
            18.577283,
            52.168122,
            136.863582
          ],
          [
            18.577347,
            52.167909,
            137.547861
          ],
          [
            18.577415,
            52.167715,
            138.174646
          ],
          [
            18.577506,
            52.167519,
            138.818897
          ],
          [
            18.577612,
            52.167341,
            139.417445
          ],
          [
            18.577739,
            52.167147,
            140.078029
          ],
          [
            18.577892,
            52.166947,
            140.776265
          ],
          [
            18.578013,
            52.166743,
            141.191247
          ],
          [
            18.57811,
            52.166549,
            141.047822
          ],
          [
            18.578213,
            52.166381,
            140.920542
          ],
          [
            18.578342,
            52.1662,
            140.780955
          ],
          [
            18.578459,
            52.165997,
            140.628553
          ],
          [
            18.578649,
            52.165744,
            140.431539
          ],
          [
            18.578807,
            52.165514,
            140.255087
          ],
          [
            18.57893,
            52.165332,
            140.115857
          ],
          [
            18.579084,
            52.165109,
            139.960437
          ],
          [
            18.579213,
            52.164912,
            139.901536
          ],
          [
            18.579345,
            52.164681,
            139.83353
          ],
          [
            18.579436,
            52.16447,
            139.773022
          ],
          [
            18.579541,
            52.164268,
            139.714155
          ],
          [
            18.579629,
            52.164067,
            139.656457
          ],
          [
            18.579692,
            52.163858,
            139.597299
          ],
          [
            18.579789,
            52.163639,
            139.534371
          ],
          [
            18.579916,
            52.163394,
            139.399374
          ],
          [
            18.580022,
            52.163154,
            138.839187
          ],
          [
            18.580131,
            52.162917,
            138.284391
          ],
          [
            18.580261,
            52.162686,
            137.733803
          ],
          [
            18.580346,
            52.162452,
            137.193696
          ],
          [
            18.580465,
            52.16223,
            136.667182
          ],
          [
            18.580564,
            52.161989,
            136.106932
          ],
          [
            18.580695,
            52.161735,
            135.506691
          ],
          [
            18.580836,
            52.161484,
            135.173442
          ],
          [
            18.580936,
            52.161209,
            134.867314
          ],
          [
            18.581061,
            52.160935,
            134.558169
          ],
          [
            18.58119,
            52.160674,
            134.26194
          ],
          [
            18.581278,
            52.160433,
            133.993685
          ],
          [
            18.581383,
            52.160222,
            133.753951
          ],
          [
            18.581472,
            52.160021,
            133.527752
          ],
          [
            18.581551,
            52.159799,
            133.642851
          ],
          [
            18.581656,
            52.159589,
            133.867894
          ],
          [
            18.581762,
            52.159333,
            134.138604
          ],
          [
            18.581863,
            52.159156,
            134.330762
          ],
          [
            18.581939,
            52.158981,
            134.51646
          ],
          [
            18.582044,
            52.158744,
            134.768867
          ],
          [
            18.582185,
            52.158519,
            135.015788
          ],
          [
            18.5823,
            52.158274,
            135.277007
          ],
          [
            18.58241,
            52.158059,
            134.958413
          ],
          [
            18.582535,
            52.157845,
            134.546977
          ],
          [
            18.582622,
            52.157659,
            134.196226
          ],
          [
            18.582698,
            52.157449,
            133.806986
          ],
          [
            18.582774,
            52.157262,
            133.458272
          ],
          [
            18.58288,
            52.157059,
            133.072271
          ],
          [
            18.582984,
            52.156837,
            132.654156
          ],
          [
            18.583067,
            52.156615,
            132.241926
          ],
          [
            18.583186,
            52.156385,
            132.025283
          ],
          [
            18.583297,
            52.156163,
            131.975305
          ],
          [
            18.583412,
            52.155944,
            131.925765
          ],
          [
            18.583513,
            52.15574,
            131.879878
          ],
          [
            18.583611,
            52.155534,
            131.833687
          ],
          [
            18.583705,
            52.155313,
            131.784491
          ],
          [
            18.583817,
            52.155104,
            131.737138
          ],
          [
            18.583943,
            52.154887,
            131.687555
          ],
          [
            18.584018,
            52.154681,
            131.669921
          ],
          [
            18.584111,
            52.154458,
            131.673869
          ],
          [
            18.584229,
            52.15423,
            131.677972
          ],
          [
            18.584326,
            52.153999,
            131.682066
          ],
          [
            18.584449,
            52.153753,
            131.68648
          ],
          [
            18.584552,
            52.153546,
            131.690193
          ],
          [
            18.584671,
            52.153303,
            131.694547
          ],
          [
            18.584748,
            52.153058,
            131.704509
          ],
          [
            18.58486,
            52.152822,
            131.868008
          ],
          [
            18.584967,
            52.152645,
            131.993484
          ],
          [
            18.585056,
            52.152442,
            132.133223
          ],
          [
            18.585141,
            52.152231,
            132.277672
          ],
          [
            18.585255,
            52.152024,
            132.42292
          ],
          [
            18.58534,
            52.15183,
            132.556439
          ],
          [
            18.585431,
            52.15165,
            132.681807
          ],
          [
            18.585488,
            52.151464,
            132.807657
          ],
          [
            18.585591,
            52.151255,
            133.15381
          ],
          [
            18.585687,
            52.15105,
            133.780717
          ],
          [
            18.585798,
            52.150808,
            134.522877
          ],
          [
            18.585902,
            52.150579,
            135.222215
          ],
          [
            18.586022,
            52.150347,
            135.937906
          ],
          [
            18.586141,
            52.150125,
            136.624716
          ],
          [
            18.586251,
            52.149902,
            137.311696
          ],
          [
            18.586367,
            52.149682,
            137.991659
          ],
          [
            18.58646,
            52.149467,
            138.388072
          ],
          [
            18.586565,
            52.149263,
            138.669417
          ],
          [
            18.586671,
            52.149049,
            138.964342
          ],
          [
            18.58677,
            52.148838,
            139.253111
          ],
          [
            18.586885,
            52.148616,
            139.560149
          ],
          [
            18.586976,
            52.148383,
            139.875307
          ],
          [
            18.587054,
            52.148134,
            140.208685
          ],
          [
            18.587166,
            52.147926,
            140.496798
          ],
          [
            18.587257,
            52.147741,
            140.668089
          ],
          [
            18.587339,
            52.147519,
            140.847232
          ],
          [
            18.587447,
            52.147321,
            141.011543
          ],
          [
            18.58755,
            52.14712,
            141.177449
          ],
          [
            18.587631,
            52.146925,
            141.335809
          ],
          [
            18.58772,
            52.146732,
            141.494198
          ],
          [
            18.587812,
            52.146553,
            141.641937
          ],
          [
            18.587937,
            52.146339,
            141.820841
          ],
          [
            18.588037,
            52.146136,
            141.922617
          ],
          [
            18.588128,
            52.145918,
            141.68629
          ],
          [
            18.588242,
            52.145707,
            141.452619
          ],
          [
            18.588338,
            52.145503,
            141.22954
          ],
          [
            18.588433,
            52.14528,
            140.98749
          ],
          [
            18.58854,
            52.145075,
            140.761348
          ],
          [
            18.588644,
            52.144895,
            140.560709
          ],
          [
            18.588751,
            52.144689,
            140.333646
          ],
          [
            18.588859,
            52.144492,
            140.115287
          ],
          [
            18.588963,
            52.144292,
            140.480988
          ],
          [
            18.5891,
            52.144089,
            141.017559
          ],
          [
            18.589234,
            52.143893,
            141.53685
          ],
          [
            18.589331,
            52.14369,
            142.053078
          ],
          [
            18.589423,
            52.14349,
            142.560452
          ],
          [
            18.589512,
            52.143301,
            143.043203
          ],
          [
            18.589605,
            52.143124,
            143.497082
          ],
          [
            18.589733,
            52.142943,
            143.981255
          ],
          [
            18.589834,
            52.142746,
            144.466623
          ],
          [
            18.589946,
            52.142539,
            144.603373
          ],
          [
            18.590085,
            52.142306,
            144.758946
          ],
          [
            18.590157,
            52.142108,
            144.886804
          ],
          [
            18.590275,
            52.141899,
            145.025435
          ],
          [
            18.590379,
            52.141682,
            145.167192
          ],
          [
            18.590517,
            52.141437,
            145.329717
          ],
          [
            18.590656,
            52.141196,
            145.4904
          ],
          [
            18.590808,
            52.140951,
            145.481549
          ],
          [
            18.590928,
            52.140743,
            145.263656
          ],
          [
            18.591005,
            52.140534,
            145.052384
          ],
          [
            18.591122,
            52.140329,
            144.838102
          ],
          [
            18.591263,
            52.140104,
            144.60013
          ],
          [
            18.591389,
            52.139882,
            144.368367
          ],
          [
            18.591528,
            52.139657,
            144.131136
          ],
          [
            18.591653,
            52.139472,
            143.933656
          ],
          [
            18.591764,
            52.139287,
            143.735852
          ],
          [
            18.591892,
            52.139053,
            143.481432
          ],
          [
            18.591994,
            52.138855,
            143.267314
          ],
          [
            18.592092,
            52.138659,
            143.0556
          ],
          [
            18.592211,
            52.138472,
            142.848733
          ],
          [
            18.592318,
            52.138263,
            142.621727
          ],
          [
            18.59245,
            52.138075,
            142.410274
          ],
          [
            18.592575,
            52.137899,
            142.212235
          ],
          [
            18.592762,
            52.137673,
            141.972213
          ],
          [
            18.59295,
            52.137482,
            142.237995
          ],
          [
            18.593143,
            52.137283,
            142.513737
          ],
          [
            18.59331,
            52.137121,
            142.742235
          ],
          [
            18.593494,
            52.136966,
            142.970771
          ],
          [
            18.593722,
            52.136791,
            143.237838
          ],
          [
            18.593904,
            52.136642,
            143.459617
          ],
          [
            18.59415,
            52.136487,
            143.717802
          ],
          [
            18.594469,
            52.136307,
            144.034519
          ],
          [
            18.594703,
            52.136181,
            144.020101
          ],
          [
            18.594991,
            52.13604,
            143.881211
          ],
          [
            18.595286,
            52.135907,
            143.74353
          ],
          [
            18.595594,
            52.135775,
            143.601892
          ],
          [
            18.595848,
            52.135659,
            143.482545
          ],
          [
            18.596208,
            52.135508,
            143.318537
          ],
          [
            18.596487,
            52.135372,
            143.183481
          ],
          [
            18.596573,
            52.135164,
            143.051922
          ],
          [
            18.596719,
            52.134987,
            143.078941
          ],
          [
            18.59704,
            52.134907,
            143.224567
          ],
          [
            18.597288,
            52.13474,
            143.378841
          ],
          [
            18.597502,
            52.134573,
            143.523832
          ],
          [
            18.597721,
            52.134399,
            143.674231
          ],
          [
            18.597961,
            52.134205,
            143.840521
          ],
          [
            18.598195,
            52.134029,
            143.995542
          ],
          [
            18.598424,
            52.133841,
            144.155771
          ],
          [
            18.598671,
            52.13365,
            144.281977
          ],
          [
            18.598941,
            52.133467,
            144.379058
          ],
          [
            18.599204,
            52.133272,
            144.47841
          ],
          [
            18.599455,
            52.133083,
            144.57403
          ],
          [
            18.599709,
            52.13289,
            144.671326
          ],
          [
            18.599897,
            52.132719,
            144.752261
          ],
          [
            18.600094,
            52.132567,
            144.828541
          ],
          [
            18.600307,
            52.132421,
            144.905441
          ],
          [
            18.600545,
            52.132237,
            145.307255
          ],
          [
            18.600754,
            52.132071,
            145.781478
          ],
          [
            18.600955,
            52.131925,
            146.213897
          ],
          [
            18.601163,
            52.131766,
            146.674288
          ],
          [
            18.601404,
            52.131601,
            147.174457
          ],
          [
            18.601667,
            52.131397,
            147.762712
          ],
          [
            18.601875,
            52.131202,
            148.288652
          ],
          [
            18.602086,
            52.130974,
            148.881451
          ],
          [
            18.602239,
            52.130778,
            149.239763
          ],
          [
            18.602414,
            52.130558,
            149.598387
          ],
          [
            18.602582,
            52.130329,
            149.966564
          ],
          [
            18.602731,
            52.130117,
            150.305779
          ],
          [
            18.602914,
            52.129937,
            150.616812
          ],
          [
            18.603174,
            52.129772,
            150.953248
          ],
          [
            18.603497,
            52.129632,
            151.309194
          ],
          [
            18.603837,
            52.129514,
            151.616777
          ],
          [
            18.60418,
            52.129408,
            151.534382
          ],
          [
            18.604487,
            52.129301,
            151.458637
          ],
          [
            18.60484,
            52.129185,
            151.372572
          ],
          [
            18.605217,
            52.129064,
            151.281065
          ],
          [
            18.605595,
            52.128945,
            151.189781
          ],
          [
            18.605868,
            52.128842,
            151.12103
          ],
          [
            18.606197,
            52.128728,
            151.039922
          ],
          [
            18.606479,
            52.128625,
            150.859536
          ],
          [
            18.606762,
            52.128525,
            150.504291
          ],
          [
            18.607056,
            52.128419,
            150.133571
          ],
          [
            18.607341,
            52.128321,
            149.77839
          ],
          [
            18.607679,
            52.128191,
            149.344352
          ],
          [
            18.60797,
            52.128079,
            148.969269
          ],
          [
            18.608299,
            52.127958,
            148.552185
          ],
          [
            18.608604,
            52.127857,
            148.175143
          ],
          [
            18.608925,
            52.127737,
            147.82675
          ],
          [
            18.609247,
            52.127633,
            147.968319
          ],
          [
            18.609538,
            52.127494,
            148.11179
          ],
          [
            18.609877,
            52.127361,
            148.268308
          ],
          [
            18.610252,
            52.127238,
            148.433825
          ],
          [
            18.610575,
            52.127128,
            148.577747
          ],
          [
            18.610897,
            52.127015,
            148.722062
          ],
          [
            18.611218,
            52.126883,
            148.872735
          ],
          [
            18.61154,
            52.126768,
            148.913024
          ],
          [
            18.611872,
            52.126653,
            148.829497
          ],
          [
            18.612201,
            52.126517,
            148.742661
          ],
          [
            18.612524,
            52.126402,
            148.66087
          ],
          [
            18.612817,
            52.126295,
            148.586223
          ],
          [
            18.613107,
            52.126202,
            148.514581
          ],
          [
            18.613443,
            52.126085,
            148.430008
          ],
          [
            18.613755,
            52.125975,
            148.351207
          ],
          [
            18.614077,
            52.125873,
            148.135269
          ],
          [
            18.614394,
            52.125777,
            147.776295
          ],
          [
            18.614699,
            52.125668,
            147.417921
          ],
          [
            18.615011,
            52.125573,
            147.064047
          ],
          [
            18.615315,
            52.125457,
            146.699934
          ],
          [
            18.615651,
            52.125345,
            146.307531
          ],
          [
            18.615975,
            52.125251,
            145.943478
          ],
          [
            18.616327,
            52.125168,
            145.560604
          ],
          [
            18.616725,
            52.125058,
            145.168168
          ],
          [
            18.617102,
            52.124963,
            144.851813
          ],
          [
            18.617389,
            52.124887,
            144.60921
          ],
          [
            18.617707,
            52.124814,
            144.345725
          ],
          [
            18.618006,
            52.12474,
            144.09512
          ],
          [
            18.618347,
            52.124643,
            143.802158
          ],
          [
            18.618659,
            52.124584,
            143.548783
          ],
          [
            18.619054,
            52.124539,
            143.236868
          ],
          [
            18.619382,
            52.124486,
            142.89615
          ],
          [
            18.619696,
            52.124435,
            142.423601
          ],
          [
            18.620073,
            52.12441,
            141.871263
          ],
          [
            18.620412,
            52.124361,
            141.364566
          ],
          [
            18.62075,
            52.124319,
            140.862437
          ],
          [
            18.621059,
            52.124292,
            140.408385
          ],
          [
            18.621383,
            52.124261,
            139.930497
          ],
          [
            18.621693,
            52.124274,
            139.475912
          ],
          [
            18.62204,
            52.12429,
            138.967435
          ],
          [
            18.622384,
            52.124322,
            138.805418
          ],
          [
            18.622727,
            52.124359,
            138.814666
          ],
          [
            18.623056,
            52.124387,
            138.823487
          ],
          [
            18.623363,
            52.124403,
            138.831671
          ],
          [
            18.623742,
            52.124397,
            138.841739
          ],
          [
            18.624133,
            52.124392,
            138.852127
          ],
          [
            18.624563,
            52.124393,
            138.863546
          ],
          [
            18.624991,
            52.124396,
            138.874949
          ],
          [
            18.625422,
            52.124397,
            138.617957
          ],
          [
            18.625878,
            52.1244,
            138.282382
          ],
          [
            18.626344,
            52.124428,
            137.93781
          ],
          [
            18.626806,
            52.124446,
            137.597047
          ],
          [
            18.62724,
            52.124499,
            137.271517
          ],
          [
            18.627647,
            52.124566,
            136.961525
          ],
          [
            18.628067,
            52.124638,
            136.551282
          ],
          [
            18.628469,
            52.124727,
            135.891862
          ],
          [
            18.628807,
            52.124878,
            135.247184
          ],
          [
            18.629156,
            52.125042,
            134.569348
          ],
          [
            18.629518,
            52.125209,
            133.869868
          ],
          [
            18.629903,
            52.125369,
            133.152827
          ],
          [
            18.630252,
            52.12553,
            132.478761
          ],
          [
            18.630586,
            52.125669,
            132.232797
          ],
          [
            18.63092,
            52.125785,
            132.282388
          ],
          [
            18.631255,
            52.125872,
            132.32937
          ],
          [
            18.631618,
            52.125976,
            132.381125
          ],
          [
            18.631969,
            52.126066,
            132.430263
          ],
          [
            18.632297,
            52.126141,
            132.475475
          ],
          [
            18.632619,
            52.12621,
            132.519576
          ],
          [
            18.632916,
            52.126289,
            132.561485
          ],
          [
            18.633208,
            52.126414,
            132.497514
          ],
          [
            18.633508,
            52.126525,
            132.346856
          ],
          [
            18.633795,
            52.126635,
            132.201387
          ],
          [
            18.634088,
            52.126745,
            132.053722
          ],
          [
            18.634377,
            52.126843,
            131.911766
          ],
          [
            18.6347,
            52.12694,
            131.75708
          ],
          [
            18.635019,
            52.127063,
            131.595073
          ],
          [
            18.635361,
            52.127161,
            131.432679
          ],
          [
            18.635676,
            52.127266,
            131.291605
          ],
          [
            18.636009,
            52.127329,
            131.185673
          ],
          [
            18.636358,
            52.127392,
            131.075689
          ],
          [
            18.636694,
            52.127507,
            130.957561
          ],
          [
            18.637092,
            52.127577,
            130.832649
          ],
          [
            18.637475,
            52.12768,
            130.70589
          ],
          [
            18.637771,
            52.127735,
            130.61206
          ],
          [
            18.638125,
            52.127816,
            130.498156
          ],
          [
            18.638517,
            52.12792,
            130.456743
          ],
          [
            18.63882,
            52.127992,
            130.481118
          ],
          [
            18.639118,
            52.128071,
            130.505559
          ],
          [
            18.639429,
            52.128148,
            130.530979
          ],
          [
            18.639765,
            52.128242,
            130.558766
          ],
          [
            18.64012,
            52.128338,
            130.587854
          ],
          [
            18.640438,
            52.128402,
            130.612954
          ],
          [
            18.640731,
            52.128482,
            130.636979
          ],
          [
            18.640918,
            52.128343,
            130.674664
          ],
          [
            18.640758,
            52.12816,
            130.786167
          ],
          [
            18.640599,
            52.127985,
            130.892224
          ],
          [
            18.640435,
            52.127817,
            130.99593
          ],
          [
            18.64026,
            52.127625,
            131.112462
          ],
          [
            18.640135,
            52.127424,
            131.226355
          ],
          [
            18.639946,
            52.127288,
            131.321682
          ],
          [
            18.639753,
            52.127138,
            131.423023
          ],
          [
            18.639546,
            52.126958,
            131.539619
          ],
          [
            18.639331,
            52.126791,
            131.799575
          ],
          [
            18.639116,
            52.126647,
            132.267703
          ],
          [
            18.638937,
            52.126486,
            132.733097
          ],
          [
            18.638688,
            52.12632,
            133.271431
          ],
          [
            18.638478,
            52.126173,
            133.738745
          ],
          [
            18.638243,
            52.126024,
            134.233227
          ],
          [
            18.638141,
            52.125855,
            134.68844
          ],
          [
            18.638323,
            52.126071,
            135.273316
          ],
          [
            18.63853,
            52.126213,
            135.731947
          ],
          [
            18.638798,
            52.126136,
            136.055993
          ],
          [
            18.639098,
            52.12607,
            136.31942
          ],
          [
            18.639401,
            52.126057,
            136.570863
          ],
          [
            18.639855,
            52.126003,
            136.958969
          ],
          [
            18.64018,
            52.125988,
            137.228569
          ],
          [
            18.640489,
            52.125974,
            137.486013
          ],
          [
            18.640801,
            52.125913,
            137.757355
          ],
          [
            18.641128,
            52.125885,
            138.030369
          ],
          [
            18.641423,
            52.125833,
            138.284063
          ],
          [
            18.641408,
            52.125845,
            137.947335
          ],
          [
            18.641099,
            52.125867,
            137.516529
          ],
          [
            18.640785,
            52.125923,
            137.063957
          ],
          [
            18.640433,
            52.125957,
            136.572011
          ],
          [
            18.640103,
            52.12599,
            136.110848
          ],
          [
            18.639795,
            52.126043,
            135.669164
          ],
          [
            18.639475,
            52.126076,
            135.221529
          ],
          [
            18.639136,
            52.126094,
            134.752014
          ],
          [
            18.638788,
            52.126128,
            134.28793
          ],
          [
            18.638584,
            52.126232,
            134.557696
          ],
          [
            18.638287,
            52.12604,
            134.944182
          ],
          [
            18.638077,
            52.125866,
            135.258931
          ],
          [
            18.637892,
            52.125714,
            135.534715
          ],
          [
            18.637684,
            52.125556,
            135.83022
          ],
          [
            18.637488,
            52.125374,
            136.147335
          ],
          [
            18.637288,
            52.125211,
            136.44394
          ],
          [
            18.637103,
            52.125059,
            136.719779
          ],
          [
            18.636916,
            52.124917,
            137.084989
          ],
          [
            18.636665,
            52.124765,
            137.739069
          ],
          [
            18.636482,
            52.124614,
            138.308051
          ],
          [
            18.636307,
            52.124467,
            138.858754
          ],
          [
            18.636063,
            52.124288,
            139.563973
          ],
          [
            18.635796,
            52.124121,
            140.271789
          ],
          [
            18.635557,
            52.123935,
            140.987621
          ],
          [
            18.635337,
            52.123764,
            141.646154
          ],
          [
            18.635102,
            52.123584,
            142.353773
          ],
          [
            18.634917,
            52.123408,
            143.357106
          ],
          [
            18.634679,
            52.123251,
            144.384916
          ],
          [
            18.634433,
            52.123085,
            145.459979
          ],
          [
            18.634253,
            52.122924,
            146.396393
          ],
          [
            18.634041,
            52.122765,
            147.380643
          ],
          [
            18.634115,
            52.122552,
            148.433336
          ],
          [
            18.634193,
            52.122347,
            149.441786
          ],
          [
            18.634272,
            52.122149,
            150.418302
          ],
          [
            18.634338,
            52.121961,
            150.955255
          ],
          [
            18.634428,
            52.121747,
            150.988563
          ],
          [
            18.63454,
            52.121543,
            151.02099
          ],
          [
            18.634646,
            52.121332,
            151.05426
          ],
          [
            18.634742,
            52.121131,
            151.085872
          ],
          [
            18.634796,
            52.120907,
            151.120015
          ],
          [
            18.634896,
            52.120682,
            151.15514
          ],
          [
            18.635015,
            52.120445,
            151.192507
          ],
          [
            18.635119,
            52.120251,
            150.891821
          ],
          [
            18.635196,
            52.120061,
            149.903839
          ],
          [
            18.635271,
            52.11986,
            148.863553
          ],
          [
            18.635379,
            52.119662,
            147.809384
          ],
          [
            18.635455,
            52.119444,
            146.683732
          ],
          [
            18.635547,
            52.11922,
            145.516011
          ],
          [
            18.635646,
            52.118995,
            144.338603
          ],
          [
            18.635789,
            52.118705,
            142.810456
          ],
          [
            18.635917,
            52.118446,
            141.544173
          ],
          [
            18.636008,
            52.118242,
            140.625473
          ],
          [
            18.636068,
            52.118031,
            139.696993
          ],
          [
            18.636146,
            52.117837,
            138.829611
          ],
          [
            18.636269,
            52.117629,
            137.870522
          ],
          [
            18.636345,
            52.117403,
            136.868549
          ],
          [
            18.636433,
            52.117181,
            135.873965
          ],
          [
            18.636488,
            52.116926,
            134.75916
          ],
          [
            18.636564,
            52.116701,
            134.347389
          ],
          [
            18.636757,
            52.116549,
            134.342151
          ],
          [
            18.637093,
            52.116531,
            134.336683
          ],
          [
            18.637426,
            52.116564,
            134.331221
          ],
          [
            18.637792,
            52.116591,
            134.325262
          ],
          [
            18.638138,
            52.116621,
            134.319604
          ],
          [
            18.638572,
            52.116618,
            134.312584
          ],
          [
            18.638904,
            52.116651,
            134.307123
          ],
          [
            18.639263,
            52.116674,
            134.481953
          ],
          [
            18.639571,
            52.116706,
            134.861197
          ],
          [
            18.639918,
            52.116759,
            135.296458
          ],
          [
            18.640243,
            52.116817,
            135.707735
          ],
          [
            18.640594,
            52.116874,
            136.148827
          ],
          [
            18.640935,
            52.11692,
            136.573643
          ],
          [
            18.641281,
            52.116968,
            137.004623
          ],
          [
            18.641629,
            52.117023,
            137.440876
          ],
          [
            18.641962,
            52.117084,
            137.854026
          ],
          [
            18.642284,
            52.11713,
            137.145397
          ],
          [
            18.642617,
            52.117186,
            136.407092
          ],
          [
            18.642974,
            52.11723,
            135.62914
          ],
          [
            18.643322,
            52.11727,
            134.872199
          ],
          [
            18.6437,
            52.117292,
            134.060813
          ],
          [
            18.644057,
            52.117317,
            133.290758
          ],
          [
            18.644438,
            52.117307,
            132.476095
          ],
          [
            18.644817,
            52.117249,
            131.637143
          ],
          [
            18.644981,
            52.117128,
            131.531796
          ],
          [
            18.645261,
            52.117044,
            131.455555
          ],
          [
            18.645556,
            52.117,
            131.381245
          ],
          [
            18.64585,
            52.117031,
            131.306319
          ],
          [
            18.646176,
            52.117009,
            131.22626
          ],
          [
            18.646503,
            52.116941,
            131.141804
          ],
          [
            18.64686,
            52.116879,
            131.050157
          ],
          [
            18.647236,
            52.116843,
            130.957248
          ],
          [
            18.647612,
            52.116846,
            130.900931
          ],
          [
            18.647908,
            52.116862,
            130.947046
          ],
          [
            18.648287,
            52.116904,
            131.00611
          ],
          [
            18.648592,
            52.116962,
            131.055139
          ],
          [
            18.648936,
            52.11706,
            131.113363
          ],
          [
            18.649252,
            52.117152,
            131.167003
          ],
          [
            18.649577,
            52.11726,
            131.223589
          ],
          [
            18.649876,
            52.117359,
            131.27565
          ],
          [
            18.650192,
            52.117442,
            131.32864
          ],
          [
            18.650486,
            52.117551,
            131.145473
          ],
          [
            18.650773,
            52.117654,
            130.932716
          ],
          [
            18.651072,
            52.11775,
            130.716844
          ],
          [
            18.65136,
            52.117792,
            130.510764
          ],
          [
            18.65157,
            52.117629,
            130.294219
          ],
          [
            18.651813,
            52.117497,
            130.086679
          ],
          [
            18.652088,
            52.117367,
            129.864201
          ],
          [
            18.652341,
            52.117225,
            129.644623
          ],
          [
            18.652603,
            52.117088,
            129.429423
          ],
          [
            18.652847,
            52.11695,
            129.244303
          ],
          [
            18.653154,
            52.116802,
            129.026585
          ],
          [
            18.653453,
            52.116663,
            128.817497
          ],
          [
            18.653719,
            52.116514,
            128.616669
          ],
          [
            18.653987,
            52.116361,
            128.412527
          ],
          [
            18.654262,
            52.116222,
            128.214024
          ],
          [
            18.654551,
            52.116084,
            128.009982
          ],
          [
            18.654818,
            52.115944,
            127.83557
          ],
          [
            18.655104,
            52.115809,
            127.904329
          ],
          [
            18.655373,
            52.115682,
            127.969028
          ],
          [
            18.65564,
            52.11556,
            128.032468
          ],
          [
            18.655924,
            52.115424,
            128.101114
          ],
          [
            18.656205,
            52.115281,
            128.170675
          ],
          [
            18.656487,
            52.115142,
            128.2396
          ],
          [
            18.656787,
            52.114999,
            128.312063
          ],
          [
            18.657079,
            52.114852,
            128.384034
          ],
          [
            18.657353,
            52.114717,
            128.376358
          ],
          [
            18.657606,
            52.114551,
            128.362822
          ],
          [
            18.657921,
            52.114411,
            128.348601
          ],
          [
            18.658202,
            52.114268,
            128.335239
          ],
          [
            18.658478,
            52.114116,
            128.321689
          ],
          [
            18.658702,
            52.113961,
            128.309324
          ],
          [
            18.658908,
            52.113767,
            128.295496
          ],
          [
            18.65907,
            52.11356,
            128.28181
          ],
          [
            18.659143,
            52.113337,
            128.604944
          ],
          [
            18.659216,
            52.113136,
            128.909294
          ],
          [
            18.659249,
            52.11294,
            129.199963
          ],
          [
            18.65927,
            52.112711,
            129.538829
          ],
          [
            18.659305,
            52.112459,
            129.912443
          ],
          [
            18.6593,
            52.112215,
            130.272459
          ],
          [
            18.659307,
            52.11203,
            130.545389
          ],
          [
            18.65933,
            52.111798,
            130.890924
          ],
          [
            18.659383,
            52.111589,
            130.879045
          ],
          [
            18.65941,
            52.1114,
            130.821676
          ],
          [
            18.659445,
            52.111167,
            130.751122
          ],
          [
            18.659462,
            52.110934,
            130.680823
          ],
          [
            18.659489,
            52.110711,
            130.613417
          ],
          [
            18.659508,
            52.110488,
            130.546096
          ],
          [
            18.659531,
            52.110301,
            130.489574
          ],
          [
            18.659542,
            52.110104,
            130.430096
          ],
          [
            18.659559,
            52.109908,
            130.34966
          ],
          [
            18.659564,
            52.109694,
            130.219676
          ],
          [
            18.659574,
            52.109479,
            130.08909
          ],
          [
            18.659545,
            52.10926,
            129.955679
          ],
          [
            18.659539,
            52.109017,
            129.808066
          ],
          [
            18.659497,
            52.108768,
            129.655631
          ],
          [
            18.659438,
            52.108527,
            129.50754
          ],
          [
            18.659397,
            52.108295,
            129.365858
          ],
          [
            18.659315,
            52.108092,
            129.467501
          ],
          [
            18.659223,
            52.107906,
            129.791688
          ],
          [
            18.659159,
            52.107712,
            130.121727
          ],
          [
            18.659088,
            52.107476,
            130.521973
          ],
          [
            18.65903,
            52.107256,
            130.89361
          ],
          [
            18.658996,
            52.107051,
            131.237364
          ],
          [
            18.658996,
            52.106857,
            131.560939
          ],
          [
            18.659079,
            52.106662,
            131.897375
          ],
          [
            18.659192,
            52.106487,
            132.211939
          ],
          [
            18.659335,
            52.106288,
            132.089056
          ],
          [
            18.659548,
            52.106149,
            131.847841
          ],
          [
            18.659819,
            52.106005,
            131.56961
          ],
          [
            18.660061,
            52.105881,
            131.325148
          ],
          [
            18.660317,
            52.105768,
            131.080616
          ],
          [
            18.660562,
            52.105644,
            130.834317
          ],
          [
            18.660821,
            52.105507,
            130.568579
          ],
          [
            18.661097,
            52.105372,
            130.292538
          ],
          [
            18.661402,
            52.105212,
            130.040683
          ],
          [
            18.66166,
            52.105038,
            130.12874
          ],
          [
            18.661866,
            52.104848,
            130.214534
          ],
          [
            18.662032,
            52.104661,
            130.294235
          ],
          [
            18.662162,
            52.104448,
            130.379359
          ],
          [
            18.6623,
            52.104254,
            130.45893
          ],
          [
            18.662384,
            52.104052,
            130.536946
          ],
          [
            18.662503,
            52.10384,
            130.620867
          ],
          [
            18.662598,
            52.103626,
            130.702982
          ],
          [
            18.662659,
            52.103416,
            130.762845
          ],
          [
            18.662678,
            52.103198,
            130.824217
          ],
          [
            18.662693,
            52.102997,
            130.880805
          ],
          [
            18.662641,
            52.102782,
            130.941769
          ],
          [
            18.66255,
            52.102551,
            131.008424
          ],
          [
            18.662403,
            52.102338,
            131.074178
          ],
          [
            18.662297,
            52.102138,
            131.133205
          ],
          [
            18.66218,
            52.101918,
            131.198132
          ],
          [
            18.662037,
            52.10172,
            130.957677
          ],
          [
            18.661879,
            52.101521,
            130.676522
          ],
          [
            18.661662,
            52.101361,
            130.411987
          ],
          [
            18.661431,
            52.101189,
            130.12877
          ],
          [
            18.661171,
            52.101038,
            129.849447
          ],
          [
            18.660889,
            52.100918,
            129.581708
          ],
          [
            18.660613,
            52.100791,
            129.31264
          ],
          [
            18.660363,
            52.100685,
            129.075601
          ],
          [
            18.6601,
            52.100552,
            129.016981
          ],
          [
            18.659845,
            52.100411,
            129.250213
          ],
          [
            18.659564,
            52.100208,
            129.547073
          ],
          [
            18.659392,
            52.100044,
            129.762957
          ],
          [
            18.659234,
            52.099828,
            130.025864
          ],
          [
            18.659101,
            52.099661,
            130.231633
          ],
          [
            18.659018,
            52.099437,
            130.485845
          ],
          [
            18.658949,
            52.099256,
            130.691649
          ],
          [
            18.658903,
            52.099066,
            130.904441
          ],
          [
            18.658886,
            52.098875,
            131.193958
          ],
          [
            18.658877,
            52.098687,
            131.480974
          ],
          [
            18.658895,
            52.098466,
            131.818788
          ],
          [
            18.658924,
            52.098272,
            132.116072
          ],
          [
            18.658924,
            52.098041,
            132.469089
          ],
          [
            18.658929,
            52.097839,
            132.777604
          ],
          [
            18.658946,
            52.097632,
            133.094289
          ],
          [
            18.658951,
            52.097435,
            133.394951
          ],
          [
            18.658929,
            52.097246,
            133.685698
          ],
          [
            18.658949,
            52.097054,
            133.996005
          ],
          [
            18.658925,
            52.096858,
            134.313141
          ],
          [
            18.658926,
            52.096674,
            134.609572
          ],
          [
            18.658939,
            52.096475,
            134.930452
          ],
          [
            18.658953,
            52.096274,
            135.25464
          ],
          [
            18.658946,
            52.09608,
            135.567316
          ],
          [
            18.658956,
            52.095857,
            135.926711
          ],
          [
            18.658948,
            52.095606,
            136.331156
          ],
          [
            18.658938,
            52.095335,
            136.501091
          ],
          [
            18.658946,
            52.095145,
            136.427212
          ],
          [
            18.658957,
            52.094875,
            136.322174
          ],
          [
            18.658969,
            52.09469,
            136.250183
          ],
          [
            18.658978,
            52.094496,
            136.174613
          ],
          [
            18.65894,
            52.09428,
            136.090034
          ],
          [
            18.658904,
            52.094062,
            136.004804
          ],
          [
            18.658847,
            52.093836,
            135.915619
          ],
          [
            18.658807,
            52.093605,
            135.550946
          ],
          [
            18.658802,
            52.093355,
            134.51937
          ],
          [
            18.6588,
            52.093138,
            133.621937
          ],
          [
            18.65886,
            52.092903,
            132.639635
          ],
          [
            18.658931,
            52.092681,
            131.706126
          ],
          [
            18.659017,
            52.092488,
            130.878688
          ],
          [
            18.659209,
            52.092291,
            129.931289
          ],
          [
            18.659455,
            52.092118,
            128.982247
          ],
          [
            18.659716,
            52.091969,
            128.592999
          ],
          [
            18.660013,
            52.091843,
            129.005915
          ],
          [
            18.660283,
            52.091731,
            129.378184
          ],
          [
            18.660552,
            52.091617,
            129.752321
          ],
          [
            18.660834,
            52.09151,
            130.131024
          ],
          [
            18.661128,
            52.091361,
            130.567053
          ],
          [
            18.661401,
            52.091225,
            130.968682
          ],
          [
            18.661659,
            52.09111,
            131.333275
          ],
          [
            18.661958,
            52.090996,
            131.736191
          ],
          [
            18.662253,
            52.090878,
            131.622807
          ],
          [
            18.662541,
            52.090749,
            131.448528
          ],
          [
            18.662839,
            52.090627,
            131.273414
          ],
          [
            18.663113,
            52.090507,
            131.10836
          ],
          [
            18.663387,
            52.090374,
            130.937525
          ],
          [
            18.663675,
            52.09025,
            130.765436
          ],
          [
            18.663959,
            52.090127,
            130.595574
          ],
          [
            18.664229,
            52.089996,
            130.427101
          ],
          [
            18.664508,
            52.089877,
            130.490418
          ],
          [
            18.664805,
            52.089758,
            130.783763
          ],
          [
            18.66511,
            52.089634,
            131.0863
          ],
          [
            18.665392,
            52.089512,
            131.371524
          ],
          [
            18.665682,
            52.089391,
            131.661428
          ],
          [
            18.665967,
            52.089267,
            131.950402
          ],
          [
            18.666267,
            52.089132,
            132.257968
          ],
          [
            18.666567,
            52.089012,
            132.554012
          ],
          [
            18.666847,
            52.088898,
            132.724798
          ],
          [
            18.667172,
            52.088767,
            132.514029
          ],
          [
            18.667515,
            52.088665,
            132.307685
          ],
          [
            18.667812,
            52.0886,
            132.136961
          ],
          [
            18.668116,
            52.088546,
            131.965514
          ],
          [
            18.668436,
            52.088507,
            131.78865
          ],
          [
            18.668806,
            52.088494,
            131.587903
          ],
          [
            18.669194,
            52.088474,
            131.376923
          ],
          [
            18.669518,
            52.08847,
            131.201411
          ],
          [
            18.669851,
            52.088473,
            131.195129
          ],
          [
            18.670227,
            52.088477,
            131.211691
          ],
          [
            18.67062,
            52.088478,
            131.229123
          ],
          [
            18.670859,
            52.088335,
            131.244897
          ],
          [
            18.670857,
            52.088109,
            131.26115
          ],
          [
            18.67085,
            52.087864,
            131.278714
          ],
          [
            18.670868,
            52.087617,
            131.29644
          ],
          [
            18.670874,
            52.087362,
            131.461581
          ],
          [
            18.670881,
            52.087105,
            132.195674
          ],
          [
            18.670885,
            52.086889,
            132.812405
          ],
          [
            18.670882,
            52.086677,
            133.418245
          ],
          [
            18.670886,
            52.086411,
            134.178002
          ],
          [
            18.670873,
            52.086161,
            134.892399
          ],
          [
            18.670865,
            52.085912,
            135.604952
          ],
          [
            18.670894,
            52.085672,
            136.292163
          ],
          [
            18.670916,
            52.085406,
            136.30258
          ],
          [
            18.670928,
            52.085172,
            136.144332
          ],
          [
            18.670926,
            52.084925,
            135.977473
          ],
          [
            18.670943,
            52.084676,
            135.808984
          ],
          [
            18.670944,
            52.084438,
            135.648195
          ],
          [
            18.670933,
            52.084208,
            135.491939
          ],
          [
            18.67089,
            52.08402,
            135.361191
          ],
          [
            18.670708,
            52.083872,
            135.210413
          ],
          [
            18.670964,
            52.08363,
            134.464143
          ],
          [
            18.670949,
            52.083434,
            133.957475
          ],
          [
            18.670919,
            52.083242,
            133.459905
          ],
          [
            18.670941,
            52.083038,
            132.932348
          ],
          [
            18.670934,
            52.082839,
            132.418039
          ],
          [
            18.67092,
            52.082628,
            131.873248
          ],
          [
            18.670917,
            52.082427,
            131.353855
          ],
          [
            18.67092,
            52.08222,
            130.81916
          ],
          [
            18.670983,
            52.082013,
            130.731269
          ],
          [
            18.671065,
            52.081779,
            131.005432
          ],
          [
            18.671125,
            52.081562,
            131.257124
          ],
          [
            18.671195,
            52.081332,
            131.524709
          ],
          [
            18.671242,
            52.081103,
            131.788628
          ],
          [
            18.671287,
            52.080865,
            132.063045
          ],
          [
            18.671306,
            52.080631,
            132.331053
          ],
          [
            18.671311,
            52.08042,
            132.572339
          ],
          [
            18.671293,
            52.080202,
            132.692329
          ],
          [
            18.671282,
            52.079981,
            132.756753
          ],
          [
            18.671264,
            52.079735,
            132.828617
          ],
          [
            18.671263,
            52.079495,
            132.898575
          ],
          [
            18.671234,
            52.079239,
            132.973643
          ],
          [
            18.671245,
            52.079039,
            133.031944
          ],
          [
            18.671291,
            52.078817,
            133.097203
          ],
          [
            18.671332,
            52.078599,
            133.161141
          ],
          [
            18.671382,
            52.078384,
            133.464235
          ],
          [
            18.671447,
            52.078168,
            133.82124
          ],
          [
            18.671532,
            52.077948,
            134.187884
          ],
          [
            18.671672,
            52.077691,
            134.627298
          ],
          [
            18.671799,
            52.077431,
            135.067741
          ],
          [
            18.671903,
            52.077219,
            135.426761
          ],
          [
            18.672016,
            52.076991,
            135.813038
          ],
          [
            18.672065,
            52.076801,
            136.087218
          ],
          [
            18.672104,
            52.076544,
            136.091628
          ],
          [
            18.672105,
            52.076291,
            136.095952
          ],
          [
            18.672122,
            52.0761,
            136.099221
          ],
          [
            18.672163,
            52.075847,
            136.103568
          ],
          [
            18.672258,
            52.075605,
            136.107828
          ],
          [
            18.672382,
            52.075353,
            136.112327
          ],
          [
            18.672472,
            52.075167,
            136.115644
          ],
          [
            18.6726,
            52.074978,
            136.142582
          ],
          [
            18.672728,
            52.074749,
            136.206903
          ],
          [
            18.672839,
            52.074527,
            136.268577
          ],
          [
            18.672954,
            52.074314,
            136.328193
          ],
          [
            18.673055,
            52.074132,
            136.37925
          ],
          [
            18.673167,
            52.07391,
            136.441049
          ],
          [
            18.673267,
            52.073731,
            136.491353
          ],
          [
            18.673446,
            52.073544,
            136.549024
          ],
          [
            18.673603,
            52.073358,
            136.523066
          ],
          [
            18.673778,
            52.073195,
            136.137026
          ],
          [
            18.673989,
            52.07305,
            135.752948
          ],
          [
            18.674221,
            52.072934,
            135.389707
          ],
          [
            18.674478,
            52.072777,
            134.948289
          ],
          [
            18.67468,
            52.072634,
            134.574382
          ],
          [
            18.674856,
            52.072467,
            134.181478
          ],
          [
            18.674986,
            52.072294,
            133.80525
          ],
          [
            18.675091,
            52.07208,
            133.363412
          ],
          [
            18.675183,
            52.071891,
            133.025446
          ],
          [
            18.675231,
            52.071673,
            132.911687
          ],
          [
            18.675303,
            52.07149,
            132.814123
          ],
          [
            18.675383,
            52.071302,
            132.713457
          ],
          [
            18.675474,
            52.071108,
            132.608989
          ],
          [
            18.675578,
            52.070918,
            132.505177
          ],
          [
            18.675656,
            52.070731,
            132.405166
          ],
          [
            18.675758,
            52.070514,
            132.288139
          ],
          [
            18.675835,
            52.070302,
            132.175759
          ],
          [
            18.675948,
            52.070098,
            132.197486
          ],
          [
            18.676056,
            52.069885,
            132.391857
          ],
          [
            18.676145,
            52.069683,
            132.574231
          ],
          [
            18.676296,
            52.069444,
            132.797309
          ],
          [
            18.67649,
            52.069243,
            133.001254
          ],
          [
            18.676681,
            52.069025,
            133.216524
          ],
          [
            18.676857,
            52.068829,
            133.411178
          ],
          [
            18.677045,
            52.068629,
            133.612758
          ],
          [
            18.677223,
            52.068433,
            133.73863
          ],
          [
            18.677365,
            52.068221,
            133.831927
          ],
          [
            18.677509,
            52.06801,
            133.925064
          ],
          [
            18.677655,
            52.067796,
            134.019539
          ],
          [
            18.67781,
            52.0676,
            134.108234
          ],
          [
            18.677927,
            52.067422,
            134.186428
          ],
          [
            18.678034,
            52.067214,
            134.275253
          ],
          [
            18.678184,
            52.067009,
            134.366805
          ],
          [
            18.678302,
            52.066803,
            134.569242
          ],
          [
            18.678448,
            52.066632,
            134.841446
          ],
          [
            18.678578,
            52.066461,
            135.107462
          ],
          [
            18.678764,
            52.066269,
            135.423059
          ],
          [
            18.678919,
            52.0661,
            135.69689
          ],
          [
            18.679065,
            52.065938,
            135.958005
          ],
          [
            18.679209,
            52.065778,
            136.215777
          ],
          [
            18.679377,
            52.06562,
            136.482861
          ],
          [
            18.679602,
            52.065397,
            136.852715
          ],
          [
            18.679791,
            52.065197,
            136.689206
          ],
          [
            18.679934,
            52.065036,
            136.407466
          ],
          [
            18.68012,
            52.06483,
            136.045742
          ],
          [
            18.680325,
            52.064587,
            135.625083
          ],
          [
            18.680479,
            52.064412,
            135.319117
          ],
          [
            18.680629,
            52.064244,
            135.02478
          ],
          [
            18.680807,
            52.064043,
            134.673374
          ],
          [
            18.680966,
            52.063865,
            134.361354
          ],
          [
            18.681149,
            52.063633,
            134.485495
          ],
          [
            18.681288,
            52.063458,
            134.900803
          ],
          [
            18.68143,
            52.063292,
            135.30136
          ],
          [
            18.681655,
            52.063084,
            135.8341
          ],
          [
            18.681816,
            52.062924,
            136.236063
          ],
          [
            18.681979,
            52.062726,
            136.709037
          ],
          [
            18.682195,
            52.062504,
            137.260543
          ],
          [
            18.682376,
            52.062308,
            137.740928
          ],
          [
            18.682542,
            52.06212,
            137.916972
          ],
          [
            18.682682,
            52.061958,
            137.700741
          ],
          [
            18.682791,
            52.061779,
            137.475476
          ],
          [
            18.682887,
            52.061534,
            137.177947
          ],
          [
            18.682953,
            52.061348,
            136.953561
          ],
          [
            18.68303,
            52.061137,
            136.697775
          ],
          [
            18.683149,
            52.060899,
            136.40417
          ],
          [
            18.683331,
            52.060648,
            136.080203
          ],
          [
            18.683519,
            52.060437,
            135.813368
          ],
          [
            18.683768,
            52.060233,
            135.566444
          ],
          [
            18.684008,
            52.060063,
            135.347969
          ],
          [
            18.684306,
            52.059894,
            135.106496
          ],
          [
            18.684577,
            52.059768,
            134.903809
          ],
          [
            18.684803,
            52.059643,
            134.722516
          ],
          [
            18.685084,
            52.05951,
            134.511209
          ],
          [
            18.685393,
            52.059372,
            134.283841
          ],
          [
            18.685715,
            52.059219,
            134.188056
          ],
          [
            18.685976,
            52.059078,
            134.246858
          ],
          [
            18.686166,
            52.058937,
            134.297154
          ],
          [
            18.686411,
            52.058722,
            134.369312
          ],
          [
            18.686586,
            52.058571,
            134.420242
          ],
          [
            18.686855,
            52.058362,
            134.49384
          ],
          [
            18.687111,
            52.058242,
            134.548768
          ],
          [
            18.687431,
            52.058228,
            134.603268
          ],
          [
            18.687796,
            52.058246,
            134.687889
          ],
          [
            18.688168,
            52.058265,
            134.84341
          ],
          [
            18.688541,
            52.058287,
            134.999619
          ],
          [
            18.688911,
            52.05832,
            135.155547
          ],
          [
            18.689277,
            52.058348,
            135.309218
          ],
          [
            18.689646,
            52.05838,
            135.464414
          ],
          [
            18.689988,
            52.058397,
            135.607324
          ],
          [
            18.690301,
            52.058405,
            135.737849
          ],
          [
            18.690617,
            52.058409,
            135.869546
          ],
          [
            18.690956,
            52.058443,
            136.016841
          ],
          [
            18.691302,
            52.058446,
            136.164737
          ],
          [
            18.691625,
            52.058393,
            136.307565
          ],
          [
            18.691879,
            52.058271,
            136.445322
          ],
          [
            18.692099,
            52.058129,
            136.581485
          ],
          [
            18.692354,
            52.057948,
            136.7478
          ],
          [
            18.692568,
            52.057811,
            136.880543
          ],
          [
            18.692818,
            52.057661,
            137.029656
          ],
          [
            18.693036,
            52.05752,
            137.086635
          ],
          [
            18.693236,
            52.057368,
            137.002443
          ],
          [
            18.693466,
            52.057227,
            136.916432
          ],
          [
            18.693665,
            52.057085,
            136.835798
          ],
          [
            18.693904,
            52.056904,
            136.735499
          ],
          [
            18.694156,
            52.056717,
            136.631017
          ],
          [
            18.694362,
            52.056586,
            136.552631
          ],
          [
            18.694577,
            52.056438,
            136.466982
          ],
          [
            18.694812,
            52.056289,
            136.377694
          ],
          [
            18.695097,
            52.056111,
            136.40605
          ],
          [
            18.695355,
            52.055929,
            136.496533
          ],
          [
            18.695569,
            52.055772,
            136.573307
          ],
          [
            18.695822,
            52.055596,
            136.661286
          ],
          [
            18.696071,
            52.055427,
            136.746701
          ],
          [
            18.696289,
            52.055292,
            136.817953
          ],
          [
            18.696503,
            52.055132,
            136.895888
          ],
          [
            18.696721,
            52.054975,
            136.973691
          ],
          [
            18.696929,
            52.054821,
            137.114898
          ],
          [
            18.697134,
            52.054674,
            137.335889
          ],
          [
            18.697354,
            52.054522,
            137.568657
          ],
          [
            18.697591,
            52.054352,
            137.824628
          ],
          [
            18.697758,
            52.054195,
            138.03877
          ],
          [
            18.69801,
            52.054025,
            138.301276
          ],
          [
            18.698219,
            52.053878,
            138.524161
          ],
          [
            18.698453,
            52.053751,
            138.743197
          ],
          [
            18.698686,
            52.053609,
            138.973468
          ],
          [
            18.698884,
            52.053472,
            139.060779
          ],
          [
            18.699088,
            52.053329,
            139.044943
          ],
          [
            18.699295,
            52.053161,
            139.027405
          ],
          [
            18.699478,
            52.052992,
            139.010479
          ],
          [
            18.699608,
            52.052809,
            138.993867
          ],
          [
            18.699741,
            52.052588,
            138.974257
          ],
          [
            18.699837,
            52.052403,
            138.958097
          ],
          [
            18.699925,
            52.052209,
            138.941343
          ],
          [
            18.700007,
            52.052029,
            138.925778
          ],
          [
            18.700071,
            52.051809,
            138.703319
          ],
          [
            18.700149,
            52.051562,
            138.334435
          ],
          [
            18.700232,
            52.051342,
            138.002934
          ],
          [
            18.700313,
            52.051095,
            137.633221
          ],
          [
            18.700334,
            52.050859,
            137.286237
          ],
          [
            18.70029,
            52.050642,
            136.965683
          ],
          [
            18.700236,
            52.050412,
            136.624965
          ],
          [
            18.700171,
            52.050171,
            136.287197
          ],
          [
            18.700049,
            52.049934,
            136.382856
          ],
          [
            18.699984,
            52.049704,
            136.47274
          ],
          [
            18.699882,
            52.049461,
            136.569326
          ],
          [
            18.699825,
            52.049237,
            136.656616
          ],
          [
            18.69975,
            52.049008,
            136.746575
          ],
          [
            18.699698,
            52.048791,
            136.830979
          ],
          [
            18.699615,
            52.048583,
            136.913659
          ],
          [
            18.699578,
            52.048398,
            136.943144
          ],
          [
            18.699528,
            52.048176,
            136.677957
          ],
          [
            18.69949,
            52.047922,
            136.376132
          ],
          [
            18.699486,
            52.047657,
            136.062075
          ],
          [
            18.699469,
            52.047444,
            135.80962
          ],
          [
            18.69948,
            52.047262,
            135.593588
          ],
          [
            18.699487,
            52.047039,
            135.329172
          ],
          [
            18.699485,
            52.04681,
            135.057646
          ],
          [
            18.699504,
            52.046554,
            134.863016
          ],
          [
            18.699505,
            52.046333,
            134.908949
          ],
          [
            18.699553,
            52.046105,
            134.956731
          ],
          [
            18.69956,
            52.045883,
            135.002958
          ],
          [
            18.699567,
            52.04564,
            135.05351
          ],
          [
            18.699591,
            52.045414,
            135.100542
          ],
          [
            18.699624,
            52.045154,
            135.154699
          ],
          [
            18.69963,
            52.044894,
            135.208694
          ],
          [
            18.699641,
            52.044679,
            135.12349
          ],
          [
            18.699645,
            52.04445,
            134.984125
          ],
          [
            18.699626,
            52.04426,
            134.868402
          ],
          [
            18.699642,
            52.044037,
            134.73259
          ],
          [
            18.699691,
            52.043815,
            134.596419
          ],
          [
            18.699704,
            52.043606,
            134.468841
          ],
          [
            18.699699,
            52.043379,
            134.330858
          ],
          [
            18.699692,
            52.043179,
            134.208915
          ],
          [
            18.699721,
            52.042989,
            134.177876
          ],
          [
            18.699751,
            52.042794,
            134.354306
          ],
          [
            18.699748,
            52.042585,
            134.542921
          ],
          [
            18.699762,
            52.042391,
            134.718196
          ],
          [
            18.6998,
            52.042204,
            134.887961
          ],
          [
            18.699853,
            52.042013,
            135.062613
          ],
          [
            18.699924,
            52.041824,
            135.237351
          ],
          [
            18.700004,
            52.041602,
            135.442583
          ],
          [
            18.700082,
            52.041426,
            135.607008
          ],
          [
            18.700186,
            52.041244,
            135.767605
          ],
          [
            18.700306,
            52.041029,
            135.892754
          ],
          [
            18.700408,
            52.040846,
            135.998782
          ],
          [
            18.700516,
            52.040669,
            136.102603
          ],
          [
            18.700681,
            52.040468,
            136.226665
          ],
          [
            18.701014,
            52.04039,
            136.346748
          ],
          [
            18.701389,
            52.040369,
            136.473639
          ],
          [
            18.701791,
            52.040327,
            136.611145
          ],
          [
            18.702087,
            52.040291,
            136.712835
          ],
          [
            18.702525,
            52.040221,
            136.856505
          ],
          [
            18.702932,
            52.040185,
            136.985629
          ],
          [
            18.703168,
            52.040032,
            137.095374
          ],
          [
            18.703328,
            52.039794,
            137.226803
          ],
          [
            18.703437,
            52.039552,
            137.355213
          ],
          [
            18.703577,
            52.039341,
            137.471492
          ],
          [
            18.703687,
            52.039168,
            137.566804
          ],
          [
            18.703833,
            52.038993,
            137.647182
          ],
          [
            18.703946,
            52.038738,
            137.622993
          ],
          [
            18.704039,
            52.038531,
            137.603291
          ],
          [
            18.704065,
            52.038319,
            137.583837
          ],
          [
            18.704094,
            52.03805,
            137.559169
          ],
          [
            18.704106,
            52.03782,
            137.538103
          ],
          [
            18.704086,
            52.037587,
            137.516743
          ],
          [
            18.704089,
            52.037395,
            137.499167
          ],
          [
            18.704076,
            52.037202,
            137.474221
          ],
          [
            18.704056,
            52.036992,
            137.421979
          ],
          [
            18.704063,
            52.036758,
            137.363912
          ],
          [
            18.704067,
            52.036527,
            137.306509
          ],
          [
            18.704124,
            52.036334,
            137.257821
          ],
          [
            18.704191,
            52.036098,
            137.198371
          ],
          [
            18.704295,
            52.03591,
            137.149088
          ],
          [
            18.704401,
            52.035728,
            137.1011
          ],
          [
            18.704548,
            52.035506,
            137.041467
          ],
          [
            18.704695,
            52.035305,
            136.906327
          ],
          [
            18.704849,
            52.035122,
            136.777134
          ],
          [
            18.705032,
            52.034919,
            136.631615
          ],
          [
            18.705186,
            52.034746,
            136.507749
          ],
          [
            18.705338,
            52.034578,
            136.38703
          ],
          [
            18.705489,
            52.034401,
            136.261638
          ],
          [
            18.705666,
            52.034242,
            136.140827
          ],
          [
            18.705817,
            52.034073,
            136.019907
          ],
          [
            18.706002,
            52.03388,
            135.955186
          ],
          [
            18.706177,
            52.033686,
            136.14065
          ],
          [
            18.706335,
            52.033523,
            136.299469
          ],
          [
            18.7065,
            52.033319,
            136.489939
          ],
          [
            18.706658,
            52.03312,
            136.675168
          ],
          [
            18.706821,
            52.032962,
            136.831626
          ],
          [
            18.706992,
            52.032797,
            136.9952
          ],
          [
            18.707149,
            52.032614,
            137.168598
          ],
          [
            18.707265,
            52.032414,
            137.346108
          ],
          [
            18.707373,
            52.03223,
            137.327802
          ],
          [
            18.707442,
            52.032044,
            137.179352
          ],
          [
            18.707516,
            52.031856,
            137.028929
          ],
          [
            18.707535,
            52.031666,
            136.881348
          ],
          [
            18.707565,
            52.031465,
            136.724844
          ],
          [
            18.707553,
            52.031254,
            136.561136
          ],
          [
            18.707483,
            52.031027,
            136.38195
          ],
          [
            18.707367,
            52.030815,
            136.208535
          ],
          [
            18.707259,
            52.03061,
            136.041408
          ],
          [
            18.707088,
            52.030411,
            136.082784
          ],
          [
            18.706928,
            52.030224,
            136.147958
          ],
          [
            18.70677,
            52.030035,
            136.213512
          ],
          [
            18.706631,
            52.02986,
            136.273585
          ],
          [
            18.706455,
            52.029669,
            136.341296
          ],
          [
            18.706285,
            52.029485,
            136.406609
          ],
          [
            18.706076,
            52.029263,
            136.485733
          ],
          [
            18.70592,
            52.029072,
            136.551655
          ],
          [
            18.70574,
            52.028864,
            136.710884
          ],
          [
            18.705552,
            52.028645,
            136.924251
          ],
          [
            18.705386,
            52.028439,
            137.121914
          ],
          [
            18.705187,
            52.028216,
            137.340593
          ],
          [
            18.705001,
            52.027997,
            137.553343
          ],
          [
            18.704788,
            52.027801,
            137.756143
          ],
          [
            18.704607,
            52.027586,
            137.964334
          ],
          [
            18.704433,
            52.027372,
            138.058721
          ],
          [
            18.704244,
            52.027154,
            137.778369
          ],
          [
            18.704061,
            52.026961,
            137.52481
          ],
          [
            18.703895,
            52.026753,
            137.261359
          ],
          [
            18.703779,
            52.026518,
            136.982679
          ],
          [
            18.703708,
            52.026265,
            136.691289
          ],
          [
            18.703653,
            52.026016,
            136.405974
          ],
          [
            18.703638,
            52.025759,
            136.114139
          ],
          [
            18.703683,
            52.025514,
            136.355291
          ],
          [
            18.703745,
            52.025299,
            136.63059
          ],
          [
            18.703841,
            52.025074,
            136.923857
          ],
          [
            18.703938,
            52.024828,
            137.243154
          ],
          [
            18.704013,
            52.024635,
            137.493588
          ],
          [
            18.70409,
            52.024445,
            137.740316
          ],
          [
            18.704193,
            52.024219,
            138.036447
          ],
          [
            18.704284,
            52.024036,
            138.277615
          ],
          [
            18.70437,
            52.023845,
            138.398672
          ],
          [
            18.704443,
            52.023658,
            138.467754
          ],
          [
            18.704538,
            52.023468,
            138.539541
          ],
          [
            18.704619,
            52.023282,
            138.608712
          ],
          [
            18.7047,
            52.023061,
            138.690158
          ],
          [
            18.70475,
            52.022866,
            138.761072
          ],
          [
            18.704829,
            52.02268,
            138.830136
          ],
          [
            18.704925,
            52.022473,
            138.907589
          ],
          [
            18.705007,
            52.022276,
            138.980643
          ],
          [
            18.705106,
            52.022035,
            138.970871
          ],
          [
            18.705191,
            52.021854,
            138.950913
          ],
          [
            18.70525,
            52.021674,
            138.931449
          ],
          [
            18.705331,
            52.02148,
            138.910198
          ],
          [
            18.70542,
            52.02126,
            138.88618
          ],
          [
            18.705504,
            52.02108,
            138.866338
          ],
          [
            18.705618,
            52.020863,
            138.842045
          ],
          [
            18.70592,
            52.02068,
            138.813954
          ],
          [
            18.706284,
            52.020612,
            138.641502
          ],
          [
            18.706565,
            52.020522,
            138.399382
          ],
          [
            18.706824,
            52.020422,
            138.165481
          ],
          [
            18.707096,
            52.020289,
            137.899966
          ],
          [
            18.707358,
            52.020153,
            137.638003
          ],
          [
            18.707564,
            52.020002,
            137.391909
          ],
          [
            18.707726,
            52.019792,
            137.102919
          ],
          [
            18.707826,
            52.019612,
            136.866556
          ],
          [
            18.707891,
            52.01942,
            136.622816
          ],
          [
            18.707982,
            52.019214,
            136.401954
          ],
          [
            18.708032,
            52.01902,
            136.209537
          ],
          [
            18.70808,
            52.018812,
            136.003761
          ],
          [
            18.708103,
            52.01861,
            135.805303
          ],
          [
            18.708106,
            52.018379,
            135.578413
          ],
          [
            18.708107,
            52.018178,
            135.381514
          ],
          [
            18.708116,
            52.017987,
            135.194308
          ],
          [
            18.708104,
            52.017788,
            134.999255
          ],
          [
            18.708118,
            52.01756,
            134.814592
          ],
          [
            18.708128,
            52.017329,
            134.865752
          ],
          [
            18.708138,
            52.017099,
            134.916611
          ],
          [
            18.708158,
            52.016856,
            134.970376
          ],
          [
            18.708174,
            52.016618,
            135.023003
          ],
          [
            18.708163,
            52.016429,
            135.06479
          ],
          [
            18.708157,
            52.016238,
            135.106997
          ],
          [
            18.70814,
            52.016044,
            135.149958
          ],
          [
            18.708169,
            52.015836,
            135.196073
          ],
          [
            18.708156,
            52.015638,
            135.624504
          ],
          [
            18.708219,
            52.015403,
            136.253566
          ],
          [
            18.708321,
            52.015223,
            136.756966
          ],
          [
            18.708434,
            52.015009,
            137.351244
          ],
          [
            18.708584,
            52.014779,
            138.005704
          ],
          [
            18.708723,
            52.014573,
            138.595157
          ],
          [
            18.70887,
            52.014366,
            139.192697
          ],
          [
            18.709052,
            52.014135,
            139.870947
          ],
          [
            18.709236,
            52.01399,
            140.137281
          ],
          [
            18.70945,
            52.01385,
            140.367978
          ],
          [
            18.709685,
            52.013723,
            140.598988
          ],
          [
            18.709921,
            52.013598,
            140.829301
          ],
          [
            18.710165,
            52.013448,
            141.084046
          ],
          [
            18.710423,
            52.013297,
            141.347079
          ],
          [
            18.710681,
            52.013136,
            141.618628
          ],
          [
            18.710912,
            52.013002,
            141.853415
          ],
          [
            18.711178,
            52.012831,
            142.094383
          ],
          [
            18.711431,
            52.012661,
            141.88662
          ],
          [
            18.711659,
            52.012514,
            141.704044
          ],
          [
            18.711883,
            52.012373,
            141.52707
          ],
          [
            18.712181,
            52.012179,
            141.287171
          ],
          [
            18.71237,
            52.012025,
            141.113904
          ],
          [
            18.712542,
            52.011851,
            140.93114
          ],
          [
            18.7127,
            52.011684,
            140.75696
          ],
          [
            18.712894,
            52.011468,
            140.535013
          ],
          [
            18.713025,
            52.011301,
            140.475091
          ],
          [
            18.713155,
            52.011134,
            140.444691
          ],
          [
            18.713314,
            52.010971,
            140.413462
          ],
          [
            18.713481,
            52.010799,
            140.380553
          ],
          [
            18.713641,
            52.010631,
            140.348585
          ],
          [
            18.713848,
            52.010452,
            140.311555
          ],
          [
            18.714167,
            52.010357,
            140.275512
          ],
          [
            18.71448,
            52.010286,
            140.241807
          ],
          [
            18.714849,
            52.010206,
            140.20333
          ],
          [
            18.715141,
            52.010142,
            140.195152
          ],
          [
            18.715415,
            52.010055,
            140.186961
          ],
          [
            18.715673,
            52.009914,
            140.177846
          ],
          [
            18.715902,
            52.009723,
            140.167661
          ],
          [
            18.716149,
            52.009545,
            140.157623
          ],
          [
            18.716367,
            52.009378,
            140.148438
          ],
          [
            18.716524,
            52.009214,
            140.140228
          ],
          [
            18.716679,
            52.009048,
            140.131975
          ],
          [
            18.716846,
            52.008865,
            139.978057
          ],
          [
            18.717024,
            52.008682,
            139.60277
          ],
          [
            18.717281,
            52.008487,
            139.162431
          ],
          [
            18.71753,
            52.00837,
            138.823263
          ],
          [
            18.717849,
            52.00827,
            138.437244
          ],
          [
            18.71815,
            52.008171,
            138.069343
          ],
          [
            18.718442,
            52.008079,
            137.715613
          ],
          [
            18.718743,
            52.007985,
            137.351659
          ],
          [
            18.719036,
            52.007901,
            137.001194
          ],
          [
            18.719353,
            52.007809,
            136.804143
          ],
          [
            18.719639,
            52.007714,
            136.632714
          ],
          [
            18.71994,
            52.007631,
            136.458552
          ],
          [
            18.720246,
            52.007541,
            136.280044
          ],
          [
            18.72053,
            52.007458,
            136.114319
          ],
          [
            18.720973,
            52.007399,
            135.874659
          ],
          [
            18.721384,
            52.007373,
            135.656614
          ],
          [
            18.721692,
            52.007341,
            135.492191
          ],
          [
            18.721993,
            52.007316,
            135.460042
          ],
          [
            18.722284,
            52.00728,
            135.491538
          ],
          [
            18.722643,
            52.007256,
            135.529993
          ],
          [
            18.722948,
            52.007234,
            135.562419
          ],
          [
            18.72325,
            52.00721,
            135.594554
          ],
          [
            18.723663,
            52.007141,
            135.639737
          ],
          [
            18.723961,
            52.00709,
            135.672356
          ],
          [
            18.724291,
            52.006977,
            135.71281
          ],
          [
            18.724549,
            52.006885,
            135.744252
          ],
          [
            18.724868,
            52.006754,
            135.936723
          ],
          [
            18.725151,
            52.006649,
            136.111357
          ],
          [
            18.725434,
            52.00652,
            136.297482
          ],
          [
            18.725713,
            52.006415,
            136.470309
          ],
          [
            18.72598,
            52.006303,
            136.641266
          ],
          [
            18.726287,
            52.006179,
            136.835322
          ],
          [
            18.726568,
            52.006047,
            137.022164
          ],
          [
            18.726879,
            52.00591,
            137.224275
          ],
          [
            18.727176,
            52.005801,
            137.319065
          ],
          [
            18.727492,
            52.005709,
            137.363765
          ],
          [
            18.727867,
            52.005646,
            137.413415
          ],
          [
            18.728221,
            52.005606,
            137.45932
          ],
          [
            18.728576,
            52.005554,
            137.505856
          ],
          [
            18.728932,
            52.005536,
            137.551419
          ],
          [
            18.729247,
            52.00551,
            137.591938
          ],
          [
            18.729622,
            52.005478,
            137.640403
          ],
          [
            18.729923,
            52.005445,
            137.705553
          ],
          [
            18.730261,
            52.0054,
            137.821595
          ],
          [
            18.730563,
            52.005351,
            137.926611
          ],
          [
            18.730761,
            52.005206,
            138.030086
          ],
          [
            18.730865,
            52.004951,
            138.173563
          ],
          [
            18.730945,
            52.004737,
            138.293335
          ],
          [
            18.731006,
            52.004506,
            138.420934
          ],
          [
            18.731126,
            52.004311,
            138.53542
          ],
          [
            18.731329,
            52.004148,
            138.645219
          ],
          [
            18.731595,
            52.004037,
            138.674195
          ],
          [
            18.731896,
            52.003943,
            138.70461
          ],
          [
            18.73219,
            52.003855,
            138.734019
          ],
          [
            18.732522,
            52.003761,
            138.766897
          ],
          [
            18.732825,
            52.003685,
            138.796331
          ],
          [
            18.733103,
            52.003604,
            138.824
          ],
          [
            18.733392,
            52.003512,
            138.853369
          ],
          [
            18.733668,
            52.003411,
            138.882296
          ],
          [
            18.733939,
            52.003252,
            138.824304
          ],
          [
            18.734242,
            52.003048,
            138.465203
          ],
          [
            18.734473,
            52.002887,
            138.185864
          ],
          [
            18.734658,
            52.002741,
            137.944832
          ],
          [
            18.734857,
            52.002588,
            137.690199
          ],
          [
            18.735035,
            52.002423,
            137.432926
          ],
          [
            18.735157,
            52.002252,
            137.189138
          ],
          [
            18.735263,
            52.002068,
            136.935434
          ],
          [
            18.735366,
            52.001849,
            136.639234
          ],
          [
            18.735478,
            52.001675,
            136.628571
          ],
          [
            18.735576,
            52.00146,
            136.724969
          ],
          [
            18.735685,
            52.001285,
            136.806011
          ],
          [
            18.735776,
            52.001108,
            136.886182
          ],
          [
            18.735877,
            52.000918,
            136.972445
          ],
          [
            18.735978,
            52.000686,
            137.076328
          ],
          [
            18.736087,
            52.000504,
            137.160049
          ],
          [
            18.736205,
            52.000314,
            137.247845
          ],
          [
            18.736319,
            52.000113,
            137.340059
          ],
          [
            18.736455,
            51.999913,
            137.912903
          ],
          [
            18.736547,
            51.999719,
            138.481976
          ],
          [
            18.736656,
            51.999542,
            139.014161
          ],
          [
            18.736743,
            51.999357,
            139.554867
          ],
          [
            18.736817,
            51.999153,
            140.142409
          ],
          [
            18.736935,
            51.998943,
            140.7662
          ],
          [
            18.737061,
            51.998726,
            141.413372
          ],
          [
            18.73719,
            51.998516,
            142.043686
          ],
          [
            18.737309,
            51.99833,
            142.272954
          ],
          [
            18.737411,
            51.998154,
            141.965719
          ],
          [
            18.737511,
            51.997961,
            141.632451
          ],
          [
            18.737599,
            51.99778,
            141.322078
          ],
          [
            18.737684,
            51.997599,
            141.01139
          ],
          [
            18.737773,
            51.997384,
            140.645703
          ],
          [
            18.737891,
            51.997167,
            140.268982
          ],
          [
            18.738016,
            51.99696,
            139.90612
          ],
          [
            18.738132,
            51.996741,
            139.527756
          ],
          [
            18.738266,
            51.996523,
            139.366314
          ],
          [
            18.738381,
            51.99634,
            139.284701
          ],
          [
            18.738512,
            51.996153,
            139.20014
          ],
          [
            18.738602,
            51.995965,
            139.118721
          ],
          [
            18.738708,
            51.995791,
            139.041493
          ],
          [
            18.738862,
            51.995587,
            138.948065
          ],
          [
            18.738999,
            51.995382,
            138.855997
          ],
          [
            18.739117,
            51.99518,
            138.766791
          ],
          [
            18.739206,
            51.994992,
            138.740674
          ],
          [
            18.739303,
            51.994807,
            139.150118
          ],
          [
            18.739388,
            51.994618,
            139.563101
          ],
          [
            18.739509,
            51.994414,
            140.020965
          ],
          [
            18.739617,
            51.994222,
            140.448768
          ],
          [
            18.739736,
            51.994016,
            140.909281
          ],
          [
            18.739873,
            51.993789,
            141.419717
          ],
          [
            18.739963,
            51.993581,
            141.881722
          ],
          [
            18.740067,
            51.993395,
            142.296807
          ],
          [
            18.740194,
            51.993188,
            142.478827
          ],
          [
            18.740307,
            51.992951,
            142.473916
          ],
          [
            18.740447,
            51.992738,
            142.469356
          ],
          [
            18.740562,
            51.99255,
            142.465362
          ],
          [
            18.740698,
            51.992337,
            142.460782
          ],
          [
            18.740779,
            51.992134,
            142.456635
          ],
          [
            18.740862,
            51.991945,
            142.45275
          ],
          [
            18.74101,
            51.991749,
            142.448458
          ],
          [
            18.741114,
            51.991558,
            142.32484
          ],
          [
            18.74123,
            51.991362,
            141.948339
          ],
          [
            18.741356,
            51.991132,
            141.511763
          ],
          [
            18.741457,
            51.990944,
            141.155644
          ],
          [
            18.74156,
            51.990761,
            140.80614
          ],
          [
            18.741664,
            51.990576,
            140.454218
          ],
          [
            18.741779,
            51.990365,
            140.054013
          ],
          [
            18.741883,
            51.990151,
            139.65237
          ],
          [
            18.741946,
            51.989961,
            139.303437
          ],
          [
            18.741964,
            51.989767,
            139.135635
          ],
          [
            18.741937,
            51.989564,
            139.026621
          ],
          [
            18.741911,
            51.989295,
            138.882374
          ],
          [
            18.741861,
            51.989032,
            138.740627
          ],
          [
            18.741849,
            51.988804,
            138.618408
          ],
          [
            18.741829,
            51.988577,
            138.496581
          ],
          [
            18.741791,
            51.988391,
            138.396188
          ],
          [
            18.741783,
            51.988203,
            138.295512
          ],
          [
            18.741748,
            51.987944,
            138.203184
          ],
          [
            18.741718,
            51.987737,
            138.147631
          ],
          [
            18.741709,
            51.987524,
            138.090669
          ],
          [
            18.741691,
            51.987292,
            138.028598
          ],
          [
            18.741684,
            51.987053,
            137.964718
          ],
          [
            18.741653,
            51.986814,
            137.900514
          ],
          [
            18.741637,
            51.986575,
            137.836591
          ],
          [
            18.741622,
            51.986339,
            137.773475
          ],
          [
            18.741571,
            51.986113,
            137.882735
          ],
          [
            18.741552,
            51.985855,
            138.020635
          ],
          [
            18.741513,
            51.985623,
            138.145226
          ],
          [
            18.7415,
            51.985381,
            138.27452
          ],
          [
            18.741462,
            51.98516,
            138.393225
          ],
          [
            18.741466,
            51.984936,
            138.512901
          ],
          [
            18.741436,
            51.984689,
            138.645154
          ],
          [
            18.741392,
            51.984446,
            138.608835
          ],
          [
            18.741363,
            51.984195,
            138.256555
          ],
          [
            18.741347,
            51.983979,
            137.953842
          ],
          [
            18.741353,
            51.983753,
            137.637593
          ],
          [
            18.741298,
            51.983511,
            137.295366
          ],
          [
            18.741273,
            51.983322,
            137.028721
          ],
          [
            18.741256,
            51.983138,
            136.769999
          ],
          [
            18.741324,
            51.982893,
            136.422299
          ],
          [
            18.741444,
            51.982661,
            136.354368
          ],
          [
            18.741549,
            51.98242,
            136.726482
          ],
          [
            18.741654,
            51.9822,
            137.068497
          ],
          [
            18.741751,
            51.981972,
            137.420439
          ],
          [
            18.74185,
            51.981761,
            137.749661
          ],
          [
            18.741935,
            51.981568,
            138.047973
          ],
          [
            18.742031,
            51.981347,
            138.38922
          ],
          [
            18.74214,
            51.9811,
            138.770944
          ],
          [
            18.742225,
            51.980866,
            139.16506
          ],
          [
            18.742327,
            51.980694,
            139.480746
          ],
          [
            18.7424,
            51.980484,
            139.850996
          ],
          [
            18.742516,
            51.980309,
            140.176871
          ],
          [
            18.742625,
            51.980122,
            140.519914
          ],
          [
            18.742721,
            51.97994,
            140.849837
          ],
          [
            18.742824,
            51.979708,
            141.265383
          ],
          [
            18.742915,
            51.979511,
            141.618636
          ],
          [
            18.743014,
            51.979322,
            141.961163
          ],
          [
            18.743115,
            51.979143,
            141.779794
          ],
          [
            18.743207,
            51.978924,
            141.488723
          ],
          [
            18.743279,
            51.978733,
            141.236819
          ],
          [
            18.743374,
            51.978534,
            140.970297
          ],
          [
            18.743469,
            51.978315,
            140.679095
          ],
          [
            18.743588,
            51.978102,
            140.389707
          ],
          [
            18.743693,
            51.977892,
            140.10545
          ],
          [
            18.743777,
            51.977692,
            139.840004
          ],
          [
            18.743889,
            51.977503,
            139.697455
          ],
          [
            18.743974,
            51.977289,
            139.727961
          ],
          [
            18.744069,
            51.977077,
            139.758471
          ],
          [
            18.74417,
            51.976857,
            139.790178
          ],
          [
            18.744275,
            51.976635,
            139.822195
          ],
          [
            18.744364,
            51.976445,
            139.849568
          ],
          [
            18.744458,
            51.97626,
            139.876402
          ],
          [
            18.744574,
            51.976072,
            139.904255
          ],
          [
            18.744684,
            51.975854,
            139.938972
          ],
          [
            18.744784,
            51.97567,
            140.074357
          ],
          [
            18.744901,
            51.975408,
            140.264505
          ],
          [
            18.744986,
            51.975158,
            140.442485
          ],
          [
            18.745089,
            51.974968,
            140.582337
          ],
          [
            18.745182,
            51.974777,
            140.721252
          ],
          [
            18.745269,
            51.974593,
            140.85498
          ],
          [
            18.745378,
            51.974404,
            140.994861
          ],
          [
            18.745441,
            51.974216,
            141.12859
          ],
          [
            18.745549,
            51.97399,
            141.081788
          ],
          [
            18.745562,
            51.973781,
            140.933265
          ],
          [
            18.745455,
            51.973584,
            140.785067
          ],
          [
            18.745292,
            51.973419,
            140.648272
          ],
          [
            18.745089,
            51.973254,
            140.501588
          ],
          [
            18.744881,
            51.973082,
            140.349709
          ],
          [
            18.744669,
            51.97294,
            140.21297
          ],
          [
            18.744452,
            51.972803,
            140.077436
          ],
          [
            18.744289,
            51.972648,
            139.945992
          ],
          [
            18.744094,
            51.972497,
            139.94905
          ],
          [
            18.743879,
            51.972304,
            140.003446
          ],
          [
            18.743667,
            51.972143,
            140.051595
          ],
          [
            18.743471,
            51.971989,
            140.097047
          ],
          [
            18.743272,
            51.97183,
            140.144084
          ],
          [
            18.743083,
            51.971683,
            140.187634
          ],
          [
            18.742883,
            51.971529,
            140.233538
          ],
          [
            18.742615,
            51.97134,
            140.292042
          ],
          [
            18.74244,
            51.971186,
            140.34284
          ],
          [
            18.742259,
            51.971041,
            140.473144
          ],
          [
            18.742026,
            51.970863,
            140.635913
          ],
          [
            18.741826,
            51.970673,
            140.797125
          ],
          [
            18.741716,
            51.970497,
            140.933691
          ],
          [
            18.742034,
            51.970394,
            141.093945
          ],
          [
            18.742406,
            51.970317,
            141.266088
          ],
          [
            18.742804,
            51.970219,
            141.45415
          ],
          [
            18.743191,
            51.970113,
            141.650254
          ],
          [
            18.743546,
            51.970007,
            141.888656
          ],
          [
            18.743834,
            51.969947,
            142.07245
          ],
          [
            18.744118,
            51.969866,
            142.261538
          ],
          [
            18.744448,
            51.969768,
            142.483094
          ],
          [
            18.744822,
            51.969687,
            142.723259
          ],
          [
            18.745143,
            51.969618,
            142.928814
          ],
          [
            18.745438,
            51.969554,
            143.117848
          ],
          [
            18.745749,
            51.969479,
            143.319755
          ],
          [
            18.746027,
            51.96941,
            143.22152
          ],
          [
            18.74637,
            51.969313,
            142.936984
          ],
          [
            18.74667,
            51.969243,
            142.696288
          ],
          [
            18.746966,
            51.969176,
            142.459738
          ],
          [
            18.747263,
            51.969111,
            142.223311
          ],
          [
            18.747545,
            51.969029,
            141.989388
          ],
          [
            18.747847,
            51.96895,
            141.743252
          ],
          [
            18.748154,
            51.968859,
            141.487176
          ],
          [
            18.748465,
            51.968782,
            141.235305
          ],
          [
            18.748777,
            51.968704,
            141.122032
          ],
          [
            18.74913,
            51.968628,
            141.033571
          ],
          [
            18.749413,
            51.968558,
            140.961455
          ],
          [
            18.749715,
            51.968493,
            140.885797
          ],
          [
            18.750071,
            51.968403,
            140.794753
          ],
          [
            18.750372,
            51.968339,
            140.719433
          ],
          [
            18.750685,
            51.968256,
            140.638833
          ],
          [
            18.750949,
            51.968177,
            140.569431
          ],
          [
            18.751329,
            51.968072,
            140.663664
          ],
          [
            18.751676,
            51.967997,
            141.247317
          ],
          [
            18.75201,
            51.96791,
            141.822574
          ],
          [
            18.752372,
            51.967814,
            142.447599
          ],
          [
            18.7527,
            51.967733,
            143.00893
          ],
          [
            18.753088,
            51.967643,
            143.667138
          ],
          [
            18.753492,
            51.967545,
            144.355669
          ],
          [
            18.753765,
            51.96748,
            144.820187
          ],
          [
            18.754139,
            51.967375,
            145.081355
          ],
          [
            18.754453,
            51.967292,
            145.012767
          ],
          [
            18.754815,
            51.967187,
            144.93245
          ],
          [
            18.755046,
            51.967038,
            144.863924
          ],
          [
            18.75528,
            51.966917,
            144.799116
          ],
          [
            18.755626,
            51.966878,
            144.728501
          ],
          [
            18.75596,
            51.966846,
            144.66065
          ],
          [
            18.756275,
            51.96681,
            144.596227
          ],
          [
            18.756611,
            51.966764,
            144.527853
          ],
          [
            18.756922,
            51.966725,
            144.468085
          ],
          [
            18.757237,
            51.966687,
            144.407638
          ],
          [
            18.757598,
            51.966654,
            144.338905
          ],
          [
            18.757947,
            51.966614,
            144.271835
          ],
          [
            18.758272,
            51.96657,
            144.209172
          ],
          [
            18.758613,
            51.966538,
            144.144159
          ],
          [
            18.758939,
            51.9665,
            144.081655
          ],
          [
            18.759249,
            51.966453,
            144.021528
          ],
          [
            18.759578,
            51.966428,
            144.001937
          ],
          [
            18.759897,
            51.966395,
            144.026828
          ],
          [
            18.76024,
            51.966365,
            144.053493
          ],
          [
            18.76057,
            51.966329,
            144.079296
          ],
          [
            18.760903,
            51.966284,
            144.105558
          ],
          [
            18.761229,
            51.966254,
            144.130921
          ],
          [
            18.761579,
            51.966207,
            144.158483
          ],
          [
            18.761939,
            51.96617,
            144.186574
          ],
          [
            18.762314,
            51.966135,
            144.200784
          ],
          [
            18.762677,
            51.966082,
            143.968976
          ],
          [
            18.763062,
            51.966029,
            143.723986
          ],
          [
            18.763422,
            51.965992,
            143.496904
          ],
          [
            18.76377,
            51.965942,
            143.275006
          ],
          [
            18.764126,
            51.965897,
            143.049366
          ],
          [
            18.764512,
            51.965862,
            142.807121
          ],
          [
            18.764902,
            51.965817,
            142.56076
          ],
          [
            18.76527,
            51.965778,
            142.40681
          ],
          [
            18.765621,
            51.965738,
            142.422745
          ],
          [
            18.765977,
            51.965688,
            142.438936
          ],
          [
            18.766349,
            51.965631,
            142.455937
          ],
          [
            18.766726,
            51.965608,
            142.472735
          ],
          [
            18.767129,
            51.965554,
            142.491022
          ],
          [
            18.767547,
            51.965506,
            142.509919
          ],
          [
            18.767957,
            51.965464,
            142.528348
          ],
          [
            18.768353,
            51.965413,
            142.23375
          ],
          [
            18.76876,
            51.96536,
            141.874871
          ],
          [
            18.769144,
            51.965321,
            141.538791
          ],
          [
            18.769549,
            51.965258,
            141.178429
          ],
          [
            18.769945,
            51.965202,
            140.827163
          ],
          [
            18.770354,
            51.965164,
            140.470308
          ],
          [
            18.770754,
            51.965111,
            140.117274
          ],
          [
            18.771155,
            51.965071,
            139.925046
          ],
          [
            18.771558,
            51.965027,
            139.799226
          ],
          [
            18.771964,
            51.964998,
            139.673443
          ],
          [
            18.77237,
            51.964987,
            139.54841
          ],
          [
            18.772768,
            51.964991,
            139.426035
          ],
          [
            18.773177,
            51.965027,
            139.299046
          ],
          [
            18.773564,
            51.965065,
            139.177268
          ],
          [
            18.773929,
            51.965125,
            139.153638
          ],
          [
            18.774306,
            51.965205,
            139.23771
          ],
          [
            18.774698,
            51.965293,
            139.325978
          ],
          [
            18.775101,
            51.965381,
            139.416341
          ],
          [
            18.775504,
            51.96546,
            139.505543
          ],
          [
            18.77592,
            51.965546,
            139.598154
          ],
          [
            18.776373,
            51.965605,
            139.695841
          ],
          [
            18.776799,
            51.965679,
            139.855093
          ],
          [
            18.77722,
            51.965777,
            140.05735
          ],
          [
            18.777625,
            51.965871,
            140.251858
          ],
          [
            18.778033,
            51.965946,
            140.443203
          ],
          [
            18.778352,
            51.966009,
            140.593757
          ],
          [
            18.778684,
            51.966063,
            140.748128
          ],
          [
            18.779091,
            51.966121,
            140.937038
          ],
          [
            18.779472,
            51.96618,
            141.155974
          ],
          [
            18.77984,
            51.966263,
            141.435546
          ],
          [
            18.780232,
            51.966337,
            141.727578
          ],
          [
            18.78063,
            51.966421,
            142.028366
          ],
          [
            18.781032,
            51.966506,
            142.331083
          ],
          [
            18.781395,
            51.966592,
            142.608582
          ],
          [
            18.781788,
            51.96666,
            142.899671
          ],
          [
            18.782152,
            51.96671,
            143.081381
          ],
          [
            18.782496,
            51.966781,
            142.8404
          ],
          [
            18.782846,
            51.966851,
            142.596153
          ],
          [
            18.783188,
            51.966913,
            142.35956
          ],
          [
            18.783558,
            51.966969,
            142.106544
          ],
          [
            18.783905,
            51.967029,
            141.867305
          ],
          [
            18.784252,
            51.967094,
            141.626522
          ],
          [
            18.784627,
            51.967187,
            141.358249
          ],
          [
            18.784978,
            51.967263,
            141.217599
          ],
          [
            18.785321,
            51.96731,
            141.32227
          ],
          [
            18.785671,
            51.967363,
            141.429642
          ],
          [
            18.786026,
            51.967397,
            141.537587
          ],
          [
            18.786392,
            51.967364,
            141.650636
          ],
          [
            18.786611,
            51.96751,
            141.747096
          ],
          [
            18.786935,
            51.967603,
            141.854135
          ],
          [
            18.787269,
            51.967691,
            141.962587
          ],
          [
            18.787593,
            51.967748,
            142.06855
          ],
          [
            18.787905,
            51.967798,
            142.22668
          ],
          [
            18.788225,
            51.967846,
            142.388326
          ],
          [
            18.788527,
            51.967899,
            142.542443
          ],
          [
            18.788896,
            51.967969,
            142.731827
          ],
          [
            18.789186,
            51.968033,
            142.882937
          ],
          [
            18.789574,
            51.968104,
            143.0817
          ],
          [
            18.78986,
            51.968169,
            143.23123
          ],
          [
            18.79017,
            51.968206,
            143.386214
          ],
          [
            18.790485,
            51.96828,
            143.60837
          ],
          [
            18.790809,
            51.968351,
            143.921269
          ],
          [
            18.791164,
            51.968389,
            144.24957
          ],
          [
            18.791519,
            51.968432,
            144.579325
          ],
          [
            18.79187,
            51.968509,
            144.918625
          ],
          [
            18.792236,
            51.96859,
            145.272599
          ],
          [
            18.792592,
            51.96865,
            145.608563
          ],
          [
            18.792952,
            51.968724,
            145.953868
          ],
          [
            18.793342,
            51.968812,
            146.086511
          ],
          [
            18.793683,
            51.968889,
            145.988668
          ],
          [
            18.793982,
            51.968931,
            145.905742
          ],
          [
            18.794356,
            51.968985,
            145.802085
          ],
          [
            18.794769,
            51.969059,
            145.686204
          ],
          [
            18.795113,
            51.969123,
            145.589375
          ],
          [
            18.795467,
            51.969181,
            145.490672
          ],
          [
            18.795824,
            51.969242,
            145.390864
          ],
          [
            18.796108,
            51.969299,
            145.583508
          ],
          [
            18.796445,
            51.969362,
            146.055463
          ],
          [
            18.796773,
            51.969315,
            146.517347
          ],
          [
            18.796972,
            51.96936,
            146.975661
          ],
          [
            18.797158,
            51.969537,
            147.465007
          ],
          [
            18.79744,
            51.969602,
            147.868518
          ],
          [
            18.797742,
            51.969646,
            148.284117
          ],
          [
            18.79807,
            51.969728,
            148.758889
          ],
          [
            18.798382,
            51.969773,
            149.189465
          ],
          [
            18.798707,
            51.969816,
            149.107068
          ],
          [
            18.799036,
            51.969906,
            148.903542
          ],
          [
            18.799367,
            51.969972,
            148.706861
          ],
          [
            18.799695,
            51.97003,
            148.51392
          ],
          [
            18.800023,
            51.970078,
            148.323003
          ],
          [
            18.800347,
            51.970115,
            148.136002
          ],
          [
            18.800675,
            51.970176,
            147.941704
          ],
          [
            18.800984,
            51.970141,
            147.752499
          ],
          [
            18.801022,
            51.969955,
            147.57121
          ],
          [
            18.80106,
            51.969722,
            147.296254
          ],
          [
            18.801092,
            51.969526,
            147.065288
          ],
          [
            18.801148,
            51.969325,
            146.826168
          ],
          [
            18.801225,
            51.969095,
            146.550833
          ],
          [
            18.801332,
            51.968911,
            146.321412
          ],
          [
            18.801495,
            51.968734,
            146.080948
          ],
          [
            18.801669,
            51.968569,
            145.850136
          ],
          [
            18.801883,
            51.968418,
            145.614222
          ],
          [
            18.802069,
            51.968276,
            145.558401
          ],
          [
            18.802278,
            51.968124,
            145.678002
          ],
          [
            18.802508,
            51.967978,
            145.799852
          ],
          [
            18.802714,
            51.967825,
            145.918899
          ],
          [
            18.802963,
            51.967665,
            146.051639
          ],
          [
            18.803226,
            51.967495,
            146.192442
          ],
          [
            18.803466,
            51.967356,
            146.314031
          ],
          [
            18.803706,
            51.967224,
            146.432742
          ],
          [
            18.803966,
            51.967052,
            146.573474
          ],
          [
            18.80418,
            51.966909,
            146.890156
          ],
          [
            18.804442,
            51.966741,
            147.288205
          ],
          [
            18.804685,
            51.966602,
            147.637425
          ],
          [
            18.804968,
            51.966471,
            148.010387
          ],
          [
            18.805256,
            51.966338,
            148.389163
          ],
          [
            18.805538,
            51.966191,
            148.777887
          ],
          [
            18.80582,
            51.966047,
            149.163407
          ],
          [
            18.806088,
            51.965924,
            149.515852
          ],
          [
            18.806393,
            51.965794,
            149.696235
          ],
          [
            18.806713,
            51.965713,
            149.757295
          ],
          [
            18.807041,
            51.965618,
            149.821298
          ],
          [
            18.807366,
            51.965547,
            149.882196
          ],
          [
            18.807667,
            51.965464,
            149.940651
          ],
          [
            18.808003,
            51.965385,
            150.004166
          ],
          [
            18.808306,
            51.965309,
            150.061916
          ],
          [
            18.808616,
            51.965242,
            150.119929
          ],
          [
            18.808958,
            51.965155,
            150.202608
          ],
          [
            18.809295,
            51.965085,
            150.332763
          ],
          [
            18.80961,
            51.965001,
            150.458521
          ],
          [
            18.809951,
            51.964911,
            150.594349
          ],
          [
            18.810271,
            51.964841,
            150.718656
          ],
          [
            18.810552,
            51.964764,
            150.831863
          ],
          [
            18.810812,
            51.964658,
            150.94593
          ],
          [
            18.811106,
            51.964598,
            151.059327
          ],
          [
            18.811431,
            51.964496,
            151.192971
          ],
          [
            18.811769,
            51.964405,
            151.346708
          ],
          [
            18.812087,
            51.964303,
            151.50509
          ],
          [
            18.812415,
            51.964203,
            151.666577
          ],
          [
            18.812771,
            51.964107,
            151.838217
          ],
          [
            18.81314,
            51.964,
            152.018245
          ],
          [
            18.813498,
            51.963895,
            152.193247
          ],
          [
            18.813851,
            51.963801,
            152.363319
          ],
          [
            18.8142,
            51.963716,
            152.517925
          ],
          [
            18.814501,
            51.963674,
            152.259928
          ],
          [
            18.814805,
            51.963638,
            152.000196
          ],
          [
            18.815159,
            51.963609,
            151.70167
          ],
          [
            18.815528,
            51.963577,
            151.38944
          ],
          [
            18.815903,
            51.963551,
            151.073099
          ],
          [
            18.816217,
            51.963509,
            150.802468
          ],
          [
            18.81654,
            51.963441,
            150.517103
          ],
          [
            18.816829,
            51.963362,
            150.252677
          ],
          [
            18.817161,
            51.9633,
            150.03716
          ],
          [
            18.817476,
            51.963228,
            149.927317
          ],
          [
            18.817791,
            51.963127,
            149.810868
          ],
          [
            18.818087,
            51.96306,
            149.707624
          ],
          [
            18.818387,
            51.962965,
            149.597333
          ],
          [
            18.818693,
            51.962861,
            149.483033
          ],
          [
            18.81897,
            51.962749,
            149.37469
          ],
          [
            18.81927,
            51.962619,
            149.254669
          ],
          [
            18.819609,
            51.962512,
            149.128979
          ],
          [
            18.819921,
            51.962399,
            148.856329
          ],
          [
            18.820223,
            51.962316,
            148.607548
          ],
          [
            18.8205,
            51.962177,
            148.338694
          ],
          [
            18.820828,
            51.962039,
            148.039687
          ],
          [
            18.821112,
            51.961919,
            147.780637
          ],
          [
            18.821418,
            51.961795,
            147.504969
          ],
          [
            18.821723,
            51.961684,
            147.238498
          ],
          [
            18.822043,
            51.96156,
            146.954133
          ],
          [
            18.82235,
            51.961456,
            146.672925
          ],
          [
            18.822663,
            51.961345,
            146.381811
          ],
          [
            18.822989,
            51.961224,
            146.074794
          ],
          [
            18.823294,
            51.961114,
            145.789907
          ],
          [
            18.823606,
            51.960975,
            145.479496
          ],
          [
            18.823979,
            51.960849,
            145.136582
          ],
          [
            18.824327,
            51.960709,
            144.801381
          ],
          [
            18.82468,
            51.960571,
            144.56196
          ],
          [
            18.825039,
            51.960432,
            144.503448
          ],
          [
            18.825403,
            51.960293,
            144.444368
          ],
          [
            18.825765,
            51.960164,
            144.386654
          ],
          [
            18.826042,
            51.960026,
            144.337295
          ],
          [
            18.826349,
            51.95993,
            144.289798
          ],
          [
            18.826647,
            51.959801,
            144.239555
          ],
          [
            18.826982,
            51.959677,
            144.185629
          ],
          [
            18.827324,
            51.959551,
            144.303394
          ],
          [
            18.827582,
            51.959435,
            144.415144
          ],
          [
            18.827912,
            51.959306,
            144.55186
          ],
          [
            18.828192,
            51.959194,
            144.668697
          ],
          [
            18.828464,
            51.959071,
            144.786877
          ],
          [
            18.828799,
            51.958921,
            144.931692
          ],
          [
            18.829155,
            51.95876,
            145.086168
          ],
          [
            18.829439,
            51.958574,
            145.239731
          ],
          [
            18.829658,
            51.958406,
            145.394646
          ],
          [
            18.829872,
            51.958237,
            145.548913
          ],
          [
            18.830062,
            51.958092,
            145.682983
          ],
          [
            18.830276,
            51.957917,
            145.840948
          ],
          [
            18.830535,
            51.957736,
            146.014562
          ],
          [
            18.830845,
            51.957691,
            146.155812
          ],
          [
            18.831162,
            51.957654,
            146.299683
          ],
          [
            18.831482,
            51.957634,
            146.442496
          ],
          [
            18.831837,
            51.957592,
            146.276135
          ],
          [
            18.832215,
            51.957584,
            145.942707
          ],
          [
            18.832523,
            51.957575,
            145.672284
          ],
          [
            18.832895,
            51.95756,
            145.344701
          ],
          [
            18.83327,
            51.957568,
            145.015815
          ],
          [
            18.833591,
            51.957531,
            144.72879
          ],
          [
            18.83397,
            51.957486,
            144.390479
          ],
          [
            18.834285,
            51.957468,
            144.112778
          ],
          [
            18.834595,
            51.957456,
            144.013112
          ],
          [
            18.834955,
            51.957448,
            144.27426
          ],
          [
            18.835257,
            51.957419,
            144.496011
          ],
          [
            18.835568,
            51.957417,
            144.721543
          ],
          [
            18.835888,
            51.957395,
            144.954551
          ],
          [
            18.836213,
            51.957385,
            145.190633
          ],
          [
            18.836575,
            51.957369,
            145.452906
          ],
          [
            18.836904,
            51.957336,
            145.693872
          ],
          [
            18.837246,
            51.95733,
            145.941119
          ],
          [
            18.837596,
            51.957309,
            146.07866
          ],
          [
            18.837944,
            51.957293,
            146.136451
          ],
          [
            18.838307,
            51.957266,
            146.196977
          ],
          [
            18.838655,
            51.957245,
            146.254819
          ],
          [
            18.839002,
            51.957221,
            146.312578
          ],
          [
            18.839347,
            51.957188,
            146.370751
          ],
          [
            18.839687,
            51.957185,
            146.427181
          ],
          [
            18.840055,
            51.957181,
            146.48835
          ],
          [
            18.84041,
            51.95718,
            146.58813
          ],
          [
            18.840762,
            51.957159,
            146.765094
          ],
          [
            18.841134,
            51.957119,
            146.954048
          ],
          [
            18.841458,
            51.957061,
            147.122851
          ],
          [
            18.841752,
            51.957015,
            147.27444
          ],
          [
            18.842051,
            51.956995,
            147.424764
          ],
          [
            18.842361,
            51.956945,
            147.584908
          ],
          [
            18.842666,
            51.956886,
            147.745206
          ],
          [
            18.843021,
            51.956844,
            147.925884
          ],
          [
            18.843428,
            51.956792,
            148.242984
          ],
          [
            18.843717,
            51.956724,
            148.511265
          ],
          [
            18.84407,
            51.956646,
            148.836571
          ],
          [
            18.844361,
            51.956589,
            149.101655
          ],
          [
            18.844712,
            51.956547,
            149.411064
          ],
          [
            18.845112,
            51.95649,
            149.766325
          ],
          [
            18.845533,
            51.956416,
            150.145216
          ],
          [
            18.845872,
            51.956374,
            150.445043
          ],
          [
            18.84626,
            51.956327,
            150.688929
          ],
          [
            18.846574,
            51.956241,
            150.880471
          ],
          [
            18.846883,
            51.956165,
            151.066314
          ],
          [
            18.847233,
            51.956109,
            151.268102
          ],
          [
            18.847631,
            51.956042,
            151.498553
          ],
          [
            18.847924,
            51.955968,
            151.675467
          ],
          [
            18.84827,
            51.955938,
            151.870413
          ],
          [
            18.848658,
            51.955886,
            152.091779
          ],
          [
            18.849023,
            51.9558,
            152.138204
          ],
          [
            18.849415,
            51.955721,
            152.138723
          ],
          [
            18.849708,
            51.955677,
            152.139101
          ],
          [
            18.850002,
            51.955622,
            152.139487
          ],
          [
            18.850315,
            51.955569,
            152.139895
          ],
          [
            18.850633,
            51.955523,
            152.140305
          ],
          [
            18.850944,
            51.955444,
            152.140728
          ],
          [
            18.851318,
            51.955362,
            152.14123
          ],
          [
            18.851644,
            51.955321,
            151.955344
          ],
          [
            18.851962,
            51.955284,
            151.51136
          ],
          [
            18.852269,
            51.955235,
            151.076747
          ],
          [
            18.852618,
            51.955157,
            150.566088
          ],
          [
            18.852952,
            51.955096,
            150.088627
          ],
          [
            18.853304,
            51.955027,
            149.582119
          ],
          [
            18.853648,
            51.954971,
            149.094204
          ],
          [
            18.853947,
            51.954916,
            148.666631
          ],
          [
            18.854282,
            51.954878,
            148.199702
          ],
          [
            18.854624,
            51.954825,
            148.844929
          ],
          [
            18.854965,
            51.95477,
            149.641958
          ],
          [
            18.855266,
            51.954697,
            150.376919
          ],
          [
            18.855574,
            51.954678,
            151.07718
          ],
          [
            18.855935,
            51.954619,
            151.922421
          ],
          [
            18.856298,
            51.954565,
            152.777049
          ],
          [
            18.856591,
            51.954526,
            153.454703
          ],
          [
            18.85696,
            51.954484,
            154.30492
          ],
          [
            18.857309,
            51.954445,
            154.573029
          ],
          [
            18.857648,
            51.954315,
            154.160399
          ],
          [
            18.857943,
            51.954189,
            153.791615
          ],
          [
            18.858208,
            51.954055,
            153.439408
          ],
          [
            18.858457,
            51.953942,
            153.121168
          ],
          [
            18.858741,
            51.953811,
            152.756342
          ],
          [
            18.859016,
            51.953681,
            152.4
          ],
          [
            18.859274,
            51.953574,
            152.080476
          ],
          [
            18.85955,
            51.953461,
            151.741327
          ],
          [
            18.859846,
            51.953334,
            151.682119
          ],
          [
            18.860114,
            51.95322,
            151.628662
          ],
          [
            18.860378,
            51.95311,
            151.576339
          ],
          [
            18.860641,
            51.953009,
            151.525468
          ],
          [
            18.860915,
            51.952904,
            151.472443
          ],
          [
            18.861192,
            51.95279,
            151.417653
          ],
          [
            18.861447,
            51.952674,
            151.36553
          ],
          [
            18.861716,
            51.952564,
            151.312531
          ],
          [
            18.861987,
            51.952444,
            151.290807
          ],
          [
            18.862266,
            51.952326,
            151.608276
          ],
          [
            18.86253,
            51.952212,
            151.911409
          ],
          [
            18.862785,
            51.9521,
            152.205181
          ],
          [
            18.863045,
            51.95198,
            152.510844
          ],
          [
            18.863379,
            51.951843,
            152.887667
          ],
          [
            18.863681,
            51.95171,
            153.235935
          ],
          [
            18.863947,
            51.951596,
            153.539877
          ],
          [
            18.864211,
            51.951473,
            153.851705
          ],
          [
            18.864471,
            51.951351,
            154.0926
          ],
          [
            18.864759,
            51.95124,
            154.278809
          ],
          [
            18.865071,
            51.951109,
            154.486903
          ],
          [
            18.865324,
            51.95101,
            154.651388
          ],
          [
            18.865628,
            51.950874,
            154.857318
          ],
          [
            18.865894,
            51.950763,
            155.033475
          ],
          [
            18.866176,
            51.950653,
            155.216426
          ],
          [
            18.866443,
            51.95055,
            155.389122
          ],
          [
            18.866685,
            51.950427,
            155.561145
          ],
          [
            18.866939,
            51.950324,
            155.689393
          ],
          [
            18.867235,
            51.950185,
            155.831326
          ],
          [
            18.867493,
            51.950065,
            155.955162
          ],
          [
            18.867734,
            51.949952,
            156.070665
          ],
          [
            18.867988,
            51.949849,
            156.186969
          ],
          [
            18.868293,
            51.949733,
            156.323666
          ],
          [
            18.868565,
            51.949618,
            156.449623
          ],
          [
            18.868817,
            51.949515,
            156.565525
          ],
          [
            18.869164,
            51.949389,
            156.706411
          ],
          [
            18.86943,
            51.949305,
            156.586751
          ],
          [
            18.869703,
            51.949224,
            156.467162
          ],
          [
            18.870014,
            51.949165,
            156.33811
          ],
          [
            18.870397,
            51.949195,
            156.185617
          ],
          [
            18.870752,
            51.949252,
            156.040877
          ],
          [
            18.871109,
            51.949286,
            155.898488
          ],
          [
            18.871475,
            51.949322,
            155.751999
          ],
          [
            18.871842,
            51.949321,
            155.606828
          ],
          [
            18.87216,
            51.949347,
            155.463028
          ],
          [
            18.872466,
            51.949396,
            155.312405
          ],
          [
            18.872781,
            51.949433,
            155.159458
          ],
          [
            18.873115,
            51.949465,
            154.998276
          ],
          [
            18.873452,
            51.94949,
            154.835816
          ],
          [
            18.873798,
            51.949505,
            154.67053
          ],
          [
            18.874132,
            51.949539,
            154.508959
          ],
          [
            18.874459,
            51.949578,
            154.350218
          ],
          [
            18.874807,
            51.949597,
            154.183272
          ],
          [
            18.875159,
            51.949619,
            154.351806
          ],
          [
            18.87552,
            51.949648,
            154.548159
          ],
          [
            18.875861,
            51.94968,
            154.734402
          ],
          [
            18.876219,
            51.949739,
            154.934087
          ],
          [
            18.876591,
            51.949733,
            155.135501
          ],
          [
            18.876951,
            51.949777,
            155.333445
          ],
          [
            18.87732,
            51.949807,
            155.533984
          ],
          [
            18.877676,
            51.949834,
            155.72798
          ],
          [
            18.878028,
            51.94988,
            155.446334
          ],
          [
            18.878387,
            51.9499,
            155.117757
          ],
          [
            18.878681,
            51.949899,
            154.848785
          ],
          [
            18.879001,
            51.9499,
            154.557526
          ],
          [
            18.879337,
            51.949942,
            154.245565
          ],
          [
            18.879682,
            51.949955,
            153.930936
          ],
          [
            18.880034,
            51.949985,
            153.607125
          ],
          [
            18.880414,
            51.950012,
            153.25881
          ],
          [
            18.880769,
            51.95003,
            153.132879
          ],
          [
            18.881111,
            51.950054,
            153.219724
          ],
          [
            18.88148,
            51.950089,
            153.313637
          ],
          [
            18.881824,
            51.950095,
            153.400314
          ],
          [
            18.882167,
            51.950137,
            153.488253
          ],
          [
            18.882498,
            51.950164,
            153.572214
          ],
          [
            18.882821,
            51.950196,
            153.654564
          ],
          [
            18.88316,
            51.950225,
            153.740636
          ],
          [
            18.883501,
            51.950267,
            153.836544
          ],
          [
            18.883817,
            51.950284,
            154.058618
          ],
          [
            18.884131,
            51.950308,
            154.280413
          ],
          [
            18.884481,
            51.950325,
            154.526119
          ],
          [
            18.884848,
            51.950339,
            154.783798
          ],
          [
            18.885195,
            51.950363,
            155.028793
          ],
          [
            18.885557,
            51.950383,
            155.283155
          ],
          [
            18.88587,
            51.950366,
            155.504322
          ],
          [
            18.886205,
            51.95037,
            155.738841
          ],
          [
            18.886534,
            51.950374,
            155.934261
          ],
          [
            18.886856,
            51.95041,
            156.086289
          ],
          [
            18.88718,
            51.950424,
            156.237502
          ],
          [
            18.887498,
            51.95044,
            156.385749
          ],
          [
            18.887813,
            51.950476,
            156.534749
          ],
          [
            18.888131,
            51.950501,
            156.683801
          ],
          [
            18.888463,
            51.950519,
            156.838731
          ],
          [
            18.888772,
            51.950533,
            156.983071
          ],
          [
            18.889125,
            51.950547,
            157.147595
          ],
          [
            18.889448,
            51.950578,
            157.09179
          ],
          [
            18.889772,
            51.950601,
            156.842399
          ],
          [
            18.890099,
            51.950608,
            156.591441
          ],
          [
            18.890451,
            51.950641,
            156.318782
          ],
          [
            18.890791,
            51.950674,
            156.055751
          ],
          [
            18.891123,
            51.950683,
            155.801778
          ],
          [
            18.891428,
            51.950706,
            155.566792
          ],
          [
            18.89174,
            51.950707,
            155.327431
          ],
          [
            18.892044,
            51.950719,
            155.094603
          ],
          [
            18.892366,
            51.950754,
            154.98822
          ],
          [
            18.892676,
            51.950773,
            154.983892
          ],
          [
            18.893002,
            51.950794,
            154.979335
          ],
          [
            18.89333,
            51.950818,
            154.974743
          ],
          [
            18.893651,
            51.950829,
            154.97027
          ],
          [
            18.89398,
            51.950863,
            154.965634
          ],
          [
            18.894293,
            51.9509,
            154.961189
          ],
          [
            18.894683,
            51.950944,
            154.955586
          ],
          [
            18.895004,
            51.951008,
            154.950898
          ],
          [
            18.895316,
            51.951033,
            154.855394
          ],
          [
            18.895652,
            51.95108,
            154.735886
          ],
          [
            18.896002,
            51.951102,
            154.613117
          ],
          [
            18.896322,
            51.951155,
            154.497792
          ],
          [
            18.896624,
            51.95117,
            154.392873
          ],
          [
            18.896938,
            51.951227,
            154.279038
          ],
          [
            18.897286,
            51.951259,
            154.15708
          ],
          [
            18.89763,
            51.951296,
            154.035822
          ],
          [
            18.89797,
            51.951337,
            153.978089
          ],
          [
            18.898332,
            51.951388,
            154.162903
          ],
          [
            18.89869,
            51.951442,
            154.346269
          ],
          [
            18.899019,
            51.95146,
            154.510711
          ],
          [
            18.899357,
            51.951508,
            154.683509
          ],
          [
            18.899691,
            51.95157,
            154.857071
          ],
          [
            18.900021,
            51.951607,
            155.02492
          ],
          [
            18.900338,
            51.95164,
            155.184846
          ],
          [
            18.900695,
            51.951663,
            155.36416
          ],
          [
            18.901024,
            51.951698,
            155.145046
          ],
          [
            18.901353,
            51.951752,
            154.838957
          ],
          [
            18.901648,
            51.951778,
            154.571027
          ],
          [
            18.901977,
            51.951818,
            154.269525
          ],
          [
            18.902298,
            51.951858,
            153.974301
          ],
          [
            18.902663,
            51.9519,
            153.633636
          ],
          [
            18.902977,
            51.951934,
            153.346982
          ],
          [
            18.903294,
            51.951965,
            153.058385
          ],
          [
            18.903626,
            51.951992,
            152.76139
          ],
          [
            18.903933,
            51.951996,
            152.579188
          ],
          [
            18.90424,
            51.952007,
            152.39674
          ],
          [
            18.904557,
            51.952014,
            152.207913
          ],
          [
            18.904878,
            51.952003,
            152.017222
          ],
          [
            18.905271,
            51.952003,
            151.784138
          ],
          [
            18.905644,
            51.951985,
            151.562079
          ],
          [
            18.905954,
            51.951931,
            151.370651
          ],
          [
            18.90629,
            51.951913,
            151.170584
          ],
          [
            18.906652,
            51.95193,
            151.074217
          ],
          [
            18.906957,
            51.951972,
            151.150966
          ],
          [
            18.907283,
            51.952046,
            151.236371
          ],
          [
            18.907588,
            51.952151,
            151.322177
          ],
          [
            18.907894,
            51.952232,
            151.403916
          ],
          [
            18.908176,
            51.952317,
            151.480996
          ],
          [
            18.908468,
            51.952427,
            151.565024
          ],
          [
            18.908782,
            51.952529,
            151.652146
          ],
          [
            18.909101,
            51.952599,
            151.735689
          ],
          [
            18.909439,
            51.952722,
            151.974576
          ],
          [
            18.909754,
            51.952788,
            152.207539
          ],
          [
            18.910134,
            51.952874,
            152.490812
          ],
          [
            18.910497,
            51.952962,
            152.763766
          ],
          [
            18.910859,
            51.953019,
            153.02602
          ],
          [
            18.911148,
            51.953122,
            153.260633
          ],
          [
            18.911438,
            51.953214,
            153.488984
          ],
          [
            18.911799,
            51.953278,
            153.751916
          ],
          [
            18.912091,
            51.953347,
            154.172018
          ],
          [
            18.912395,
            51.953433,
            154.677761
          ],
          [
            18.912725,
            51.953528,
            155.22821
          ],
          [
            18.913032,
            51.953624,
            155.750324
          ],
          [
            18.913356,
            51.953722,
            156.295938
          ],
          [
            18.913675,
            51.953793,
            156.809617
          ],
          [
            18.913991,
            51.953889,
            157.342271
          ],
          [
            18.914297,
            51.95398,
            157.855737
          ],
          [
            18.914606,
            51.954062,
            158.075881
          ],
          [
            18.914938,
            51.954164,
            157.603767
          ],
          [
            18.915231,
            51.95424,
            157.206426
          ],
          [
            18.915624,
            51.954336,
            156.678375
          ],
          [
            18.915973,
            51.954416,
            156.213125
          ],
          [
            18.916259,
            51.954514,
            155.799944
          ],
          [
            18.916414,
            51.954717,
            155.339468
          ],
          [
            18.916533,
            51.95497,
            154.805524
          ],
          [
            18.91661,
            51.955185,
            154.421146
          ],
          [
            18.916661,
            51.955373,
            154.152942
          ],
          [
            18.916696,
            51.955562,
            153.885219
          ],
          [
            18.916772,
            51.955816,
            153.522085
          ],
          [
            18.916844,
            51.956031,
            153.21348
          ],
          [
            18.916911,
            51.956253,
            152.89592
          ],
          [
            18.91701,
            51.956495,
            152.544662
          ],
          [
            18.917039,
            51.956714,
            152.235888
          ],
          [
            18.91721,
            51.956854,
            152.218672
          ],
          [
            18.917519,
            51.956843,
            152.977543
          ],
          [
            18.91785,
            51.956817,
            153.789034
          ],
          [
            18.918182,
            51.956799,
            154.596655
          ],
          [
            18.918536,
            51.956802,
            155.453653
          ],
          [
            18.918899,
            51.956779,
            156.336981
          ],
          [
            18.919291,
            51.95676,
            157.288976
          ],
          [
            18.919715,
            51.956728,
            158.322994
          ],
          [
            18.920019,
            51.956704,
            159.066107
          ],
          [
            18.920351,
            51.956682,
            158.839709
          ],
          [
            18.920713,
            51.956667,
            158.544251
          ],
          [
            18.921078,
            51.956625,
            158.241638
          ],
          [
            18.92144,
            51.956578,
            157.941098
          ],
          [
            18.921792,
            51.956557,
            157.653788
          ],
          [
            18.922124,
            51.956529,
            157.381137
          ],
          [
            18.922451,
            51.956533,
            157.115422
          ],
          [
            18.922803,
            51.956519,
            156.828839
          ],
          [
            18.923139,
            51.956494,
            156.687589
          ],
          [
            18.92347,
            51.956481,
            156.6241
          ],
          [
            18.923834,
            51.956467,
            156.553972
          ],
          [
            18.924183,
            51.956448,
            156.48692
          ],
          [
            18.924544,
            51.956433,
            156.417622
          ],
          [
            18.924892,
            51.956391,
            156.349676
          ],
          [
            18.925224,
            51.956351,
            156.284931
          ],
          [
            18.925574,
            51.9563,
            156.21567
          ],
          [
            18.925925,
            51.956238,
            156.222618
          ],
          [
            18.926245,
            51.956138,
            156.369278
          ],
          [
            18.926577,
            51.956092,
            156.508612
          ],
          [
            18.926905,
            51.956001,
            156.655668
          ],
          [
            18.927233,
            51.955956,
            156.793026
          ],
          [
            18.927576,
            51.955934,
            156.934034
          ],
          [
            18.927947,
            51.955897,
            157.087781
          ],
          [
            18.928323,
            51.955858,
            157.243663
          ],
          [
            18.928676,
            51.955847,
            157.374212
          ],
          [
            18.929047,
            51.95583,
            157.441105
          ],
          [
            18.929408,
            51.955808,
            157.506389
          ],
          [
            18.929754,
            51.955785,
            157.569152
          ],
          [
            18.930086,
            51.955767,
            157.6291
          ],
          [
            18.930425,
            51.955751,
            157.690273
          ],
          [
            18.930758,
            51.955729,
            157.750497
          ],
          [
            18.931106,
            51.955697,
            157.813855
          ],
          [
            18.931447,
            51.955689,
            157.875435
          ],
          [
            18.931795,
            51.955659,
            157.733767
          ],
          [
            18.932151,
            51.955642,
            157.538122
          ],
          [
            18.932499,
            51.955606,
            157.344755
          ],
          [
            18.932859,
            51.95559,
            157.146684
          ],
          [
            18.933222,
            51.955564,
            156.946408
          ],
          [
            18.933593,
            51.955551,
            156.74278
          ],
          [
            18.933934,
            51.955517,
            156.553468
          ],
          [
            18.93427,
            51.955501,
            156.368801
          ],
          [
            18.934603,
            51.955478,
            156.288795
          ],
          [
            18.934939,
            51.955465,
            156.288688
          ],
          [
            18.935295,
            51.955435,
            156.288575
          ],
          [
            18.935649,
            51.955436,
            156.288462
          ],
          [
            18.935992,
            51.95542,
            156.288353
          ],
          [
            18.936366,
            51.95538,
            156.288233
          ],
          [
            18.936707,
            51.955365,
            156.288124
          ],
          [
            18.937054,
            51.95534,
            156.288014
          ],
          [
            18.937374,
            51.955321,
            156.268069
          ],
          [
            18.93771,
            51.955306,
            156.162941
          ],
          [
            18.938061,
            51.95529,
            156.053161
          ],
          [
            18.938392,
            51.955266,
            155.949248
          ],
          [
            18.938725,
            51.955253,
            155.845015
          ],
          [
            18.939081,
            51.955214,
            155.732231
          ],
          [
            18.939409,
            51.955188,
            155.628908
          ],
          [
            18.939738,
            51.955161,
            155.52528
          ],
          [
            18.940073,
            51.955142,
            155.420239
          ],
          [
            18.940401,
            51.955099,
            155.281229
          ],
          [
            18.940738,
            51.955079,
            155.11716
          ],
          [
            18.94108,
            51.955073,
            154.951432
          ],
          [
            18.94141,
            51.955073,
            154.791549
          ],
          [
            18.94174,
            51.955044,
            154.629916
          ],
          [
            18.942074,
            51.955044,
            154.468043
          ],
          [
            18.94236,
            51.955119,
            154.315176
          ],
          [
            18.9425,
            51.955323,
            154.137159
          ],
          [
            18.942543,
            51.95552,
            153.980937
          ],
          [
            18.942611,
            51.955732,
            153.933649
          ],
          [
            18.9427,
            51.955916,
            153.903271
          ],
          [
            18.942803,
            51.95611,
            153.870972
          ],
          [
            18.943018,
            51.956263,
            153.83786
          ],
          [
            18.943314,
            51.956259,
            153.808109
          ],
          [
            18.943631,
            51.956215,
            153.776444
          ],
          [
            18.943981,
            51.956177,
            153.741621
          ],
          [
            18.944332,
            51.956167,
            153.707367
          ],
          [
            18.94467,
            51.956141,
            153.606606
          ],
          [
            18.944966,
            51.956088,
            153.241584
          ],
          [
            18.945271,
            51.956075,
            152.879564
          ],
          [
            18.945571,
            51.956049,
            152.520566
          ],
          [
            18.945885,
            51.956012,
            152.141914
          ],
          [
            18.946194,
            51.955968,
            151.766122
          ],
          [
            18.946539,
            51.955935,
            151.352594
          ],
          [
            18.946909,
            51.95591,
            150.910317
          ],
          [
            18.947219,
            51.955872,
            150.534842
          ],
          [
            18.947561,
            51.955851,
            150.206051
          ],
          [
            18.947928,
            51.9558,
            150.118546
          ],
          [
            18.948268,
            51.955744,
            150.036636
          ],
          [
            18.94865,
            51.955712,
            149.947027
          ],
          [
            18.948993,
            51.955679,
            149.86627
          ],
          [
            18.949349,
            51.955641,
            149.782239
          ],
          [
            18.949692,
            51.955615,
            149.701903
          ],
          [
            18.950049,
            51.955589,
            149.618281
          ],
          [
            18.950396,
            51.955558,
            149.615243
          ],
          [
            18.95076,
            51.955539,
            150.19201
          ],
          [
            18.951127,
            51.955511,
            150.778498
          ],
          [
            18.95149,
            51.955493,
            151.355189
          ],
          [
            18.951846,
            51.955488,
            151.918734
          ],
          [
            18.952171,
            51.955472,
            152.433647
          ],
          [
            18.952508,
            51.95544,
            152.972006
          ],
          [
            18.952831,
            51.955401,
            153.49172
          ],
          [
            18.953194,
            51.955374,
            154.069366
          ],
          [
            18.953576,
            51.955355,
            153.795195
          ],
          [
            18.953885,
            51.95533,
            153.451893
          ],
          [
            18.954244,
            51.955303,
            153.056825
          ],
          [
            18.954615,
            51.955275,
            152.648464
          ],
          [
            18.954971,
            51.955224,
            152.248125
          ],
          [
            18.95534,
            51.955192,
            151.840318
          ],
          [
            18.955685,
            51.955177,
            151.462425
          ],
          [
            18.956029,
            51.955159,
            151.082979
          ],
          [
            18.956343,
            51.955132,
            150.813044
          ],
          [
            18.956664,
            51.955068,
            150.567012
          ],
          [
            18.956989,
            51.955011,
            150.31978
          ],
          [
            18.957296,
            51.954977,
            150.092412
          ],
          [
            18.957628,
            51.954945,
            149.847413
          ],
          [
            18.95797,
            51.954904,
            149.593433
          ],
          [
            18.958298,
            51.954875,
            149.351842
          ],
          [
            18.958611,
            51.954834,
            149.118512
          ],
          [
            18.958953,
            51.95478,
            148.861037
          ],
          [
            18.959278,
            51.954752,
            148.960602
          ],
          [
            18.959597,
            51.954711,
            149.091577
          ],
          [
            18.959891,
            51.954675,
            149.21231
          ],
          [
            18.960248,
            51.954645,
            149.358287
          ],
          [
            18.96058,
            51.954599,
            149.494936
          ],
          [
            18.960875,
            51.954573,
            149.614706
          ],
          [
            18.961198,
            51.954523,
            149.749173
          ],
          [
            18.96153,
            51.954479,
            149.886001
          ],
          [
            18.961858,
            51.954452,
            150.006523
          ],
          [
            18.96218,
            51.954416,
            149.903863
          ],
          [
            18.962484,
            51.954385,
            149.807318
          ],
          [
            18.962819,
            51.95435,
            149.700647
          ],
          [
            18.963138,
            51.954303,
            149.597302
          ],
          [
            18.963454,
            51.954273,
            149.496791
          ],
          [
            18.96375,
            51.954237,
            149.401542
          ],
          [
            18.964074,
            51.954199,
            149.297457
          ],
          [
            18.96439,
            51.954156,
            149.196071
          ],
          [
            18.964717,
            51.954115,
            149.108239
          ],
          [
            18.965041,
            51.95408,
            149.288301
          ],
          [
            18.965388,
            51.954033,
            149.482612
          ],
          [
            18.965718,
            51.95399,
            149.667056
          ],
          [
            18.966042,
            51.953954,
            149.847368
          ],
          [
            18.966369,
            51.953921,
            150.028618
          ],
          [
            18.966713,
            51.953879,
            150.220394
          ],
          [
            18.967054,
            51.953831,
            150.411714
          ],
          [
            18.967388,
            51.9538,
            150.596416
          ],
          [
            18.967693,
            51.953749,
            150.620921
          ],
          [
            18.968002,
            51.953706,
            150.455766
          ],
          [
            18.968331,
            51.953643,
            150.276178
          ],
          [
            18.968644,
            51.953603,
            150.109325
          ],
          [
            18.968953,
            51.953588,
            149.947749
          ],
          [
            18.969263,
            51.953541,
            149.781256
          ],
          [
            18.969584,
            51.95351,
            149.611768
          ],
          [
            18.969904,
            51.953448,
            149.436713
          ],
          [
            18.970224,
            51.953408,
            149.266461
          ],
          [
            18.970548,
            51.95339,
            149.145865
          ],
          [
            18.970892,
            51.953353,
            149.082252
          ],
          [
            18.971216,
            51.953305,
            149.021568
          ],
          [
            18.971526,
            51.953259,
            148.963515
          ],
          [
            18.971842,
            51.953239,
            148.905648
          ],
          [
            18.972208,
            51.953189,
            148.837397
          ],
          [
            18.972504,
            51.953151,
            148.782347
          ],
          [
            18.972823,
            51.953124,
            148.72368
          ],
          [
            18.973142,
            51.953088,
            148.664452
          ],
          [
            18.973473,
            51.953068,
            148.763443
          ],
          [
            18.973775,
            51.953036,
            148.948572
          ],
          [
            18.974049,
            51.952975,
            149.130185
          ],
          [
            18.974061,
            51.95274,
            149.362224
          ],
          [
            18.974009,
            51.952509,
            149.590983
          ],
          [
            18.97395,
            51.952284,
            149.814546
          ],
          [
            18.973887,
            51.952055,
            150.042486
          ],
          [
            18.973829,
            51.951815,
            150.280339
          ],
          [
            18.973734,
            51.951608,
            150.343179
          ],
          [
            18.973705,
            51.951423,
            150.216782
          ],
          [
            18.973664,
            51.951201,
            150.064735
          ],
          [
            18.973591,
            51.950976,
            149.90869
          ],
          [
            18.973534,
            51.950766,
            149.763429
          ],
          [
            18.97349,
            51.950527,
            149.59978
          ],
          [
            18.973443,
            51.950303,
            149.446123
          ],
          [
            18.973365,
            51.950056,
            149.274996
          ],
          [
            18.973301,
            51.949819,
            149.13421
          ],
          [
            18.973252,
            51.949565,
            149.017122
          ],
          [
            18.973223,
            51.949326,
            148.907148
          ],
          [
            18.973162,
            51.949087,
            148.796326
          ],
          [
            18.973047,
            51.948867,
            148.690541
          ],
          [
            18.972971,
            51.948629,
            148.579516
          ],
          [
            18.972904,
            51.948417,
            148.480639
          ],
          [
            18.972872,
            51.948171,
            148.367619
          ],
          [
            18.972833,
            51.947962,
            148.51598
          ],
          [
            18.97276,
            51.94772,
            148.723036
          ],
          [
            18.972713,
            51.947513,
            148.898594
          ],
          [
            18.972658,
            51.94731,
            149.072013
          ],
          [
            18.972617,
            51.947092,
            149.25657
          ],
          [
            18.972548,
            51.946839,
            149.472094
          ],
          [
            18.972491,
            51.946591,
            149.682477
          ],
          [
            18.972359,
            51.946353,
            149.786945
          ],
          [
            18.972122,
            51.946141,
            149.11473
          ],
          [
            18.971924,
            51.94596,
            148.545069
          ],
          [
            18.971717,
            51.945795,
            147.9973
          ],
          [
            18.971505,
            51.945616,
            147.41758
          ],
          [
            18.971319,
            51.945429,
            146.845952
          ],
          [
            18.971119,
            51.945248,
            146.275077
          ],
          [
            18.970916,
            51.945061,
            145.688419
          ],
          [
            18.970736,
            51.944878,
            145.174466
          ],
          [
            18.970533,
            51.94471,
            145.106375
          ],
          [
            18.970328,
            51.944524,
            145.033184
          ],
          [
            18.97015,
            51.944329,
            144.960158
          ],
          [
            18.969982,
            51.944139,
            144.889251
          ],
          [
            18.969794,
            51.943938,
            144.813741
          ],
          [
            18.969845,
            51.943742,
            144.74464
          ],
          [
            18.970104,
            51.943575,
            144.669552
          ],
          [
            18.970371,
            51.943424,
            144.596956
          ],
          [
            18.970699,
            51.943245,
            144.853892
          ],
          [
            18.970997,
            51.943098,
            145.080338
          ],
          [
            18.971284,
            51.942917,
            145.323789
          ],
          [
            18.971511,
            51.942797,
            145.500902
          ],
          [
            18.971757,
            51.942673,
            145.689015
          ],
          [
            18.971975,
            51.942548,
            145.865265
          ],
          [
            18.97224,
            51.942444,
            146.0514
          ],
          [
            18.972518,
            51.942364,
            146.232968
          ],
          [
            18.97283,
            51.942304,
            146.523694
          ],
          [
            18.973266,
            51.942259,
            147.03204
          ],
          [
            18.973638,
            51.942245,
            147.460209
          ],
          [
            18.973935,
            51.942248,
            147.801569
          ],
          [
            18.974265,
            51.942264,
            148.181842
          ],
          [
            18.97458,
            51.942268,
            148.544456
          ],
          [
            18.974873,
            51.942276,
            148.882133
          ],
          [
            18.975232,
            51.942275,
            149.294552
          ],
          [
            18.975577,
            51.942297,
            149.697125
          ],
          [
            18.975884,
            51.942289,
            150.093608
          ],
          [
            18.976316,
            51.942284,
            150.651002
          ],
          [
            18.976657,
            51.942286,
            151.091111
          ],
          [
            18.976961,
            51.942277,
            151.48537
          ],
          [
            18.977256,
            51.94225,
            151.870424
          ],
          [
            18.977671,
            51.94225,
            152.406831
          ],
          [
            18.978075,
            51.942251,
            152.929529
          ],
          [
            18.978433,
            51.942256,
            153.391635
          ],
          [
            18.97879,
            51.942242,
            153.195162
          ],
          [
            18.97909,
            51.942242,
            152.967133
          ],
          [
            18.979393,
            51.942235,
            152.737157
          ],
          [
            18.979705,
            51.942232,
            152.500574
          ],
          [
            18.980017,
            51.942223,
            152.26346
          ],
          [
            18.980339,
            51.942208,
            152.01794
          ],
          [
            18.980652,
            51.942201,
            151.780516
          ],
          [
            18.98096,
            51.942206,
            151.546832
          ],
          [
            18.981269,
            51.94222,
            151.311943
          ],
          [
            18.981557,
            51.942149,
            151.163314
          ],
          [
            18.981797,
            51.941997,
            151.053569
          ],
          [
            18.981976,
            51.941823,
            150.946503
          ],
          [
            18.981879,
            51.941597,
            150.821405
          ],
          [
            18.981672,
            51.941426,
            150.710865
          ],
          [
            18.981469,
            51.941241,
            150.595137
          ],
          [
            18.981315,
            51.941037,
            150.478168
          ],
          [
            18.981267,
            51.940823,
            150.366398
          ],
          [
            18.981241,
            51.940606,
            150.146949
          ],
          [
            18.981397,
            51.940402,
            149.734399
          ],
          [
            18.981607,
            51.940235,
            149.352579
          ],
          [
            18.981682,
            51.940052,
            149.010666
          ],
          [
            18.981704,
            51.939826,
            148.603585
          ],
          [
            18.981798,
            51.939598,
            148.179358
          ],
          [
            18.981925,
            51.939369,
            147.74285
          ],
          [
            18.982144,
            51.939189,
            147.336167
          ],
          [
            18.982382,
            51.939015,
            147.207143
          ],
          [
            18.982583,
            51.938816,
            147.651071
          ],
          [
            18.982814,
            51.938662,
            148.050421
          ],
          [
            18.983016,
            51.938513,
            148.418683
          ],
          [
            18.983214,
            51.938316,
            148.857935
          ],
          [
            18.983392,
            51.938144,
            149.244285
          ],
          [
            18.983589,
            51.937951,
            149.676557
          ],
          [
            18.983766,
            51.937786,
            150.053195
          ],
          [
            18.983973,
            51.937629,
            150.436328
          ],
          [
            18.984232,
            51.937529,
            150.835112
          ],
          [
            18.984541,
            51.937608,
            151.261003
          ],
          [
            18.984804,
            51.937711,
            151.648868
          ],
          [
            18.985084,
            51.937835,
            152.079307
          ],
          [
            18.985378,
            51.937954,
            152.517162
          ],
          [
            18.985685,
            51.938073,
            152.968785
          ],
          [
            18.985976,
            51.938225,
            153.449251
          ],
          [
            18.986286,
            51.938341,
            153.901562
          ],
          [
            18.986619,
            51.938462,
            153.910264
          ],
          [
            18.986886,
            51.93856,
            153.648015
          ],
          [
            18.987149,
            51.938663,
            153.386535
          ],
          [
            18.987463,
            51.938785,
            153.073923
          ],
          [
            18.987797,
            51.93891,
            152.746024
          ],
          [
            18.988056,
            51.939027,
            152.476083
          ],
          [
            18.988311,
            51.939113,
            152.227304
          ],
          [
            18.98802,
            51.939014,
            151.945239
          ],
          [
            18.988048,
            51.938834,
            151.673822
          ],
          [
            18.988253,
            51.93866,
            151.268764
          ],
          [
            18.988459,
            51.938485,
            150.852528
          ],
          [
            18.98871,
            51.938301,
            150.389663
          ],
          [
            18.988944,
            51.938135,
            149.96548
          ],
          [
            18.989217,
            51.937971,
            149.513083
          ],
          [
            18.98947,
            51.937807,
            149.077646
          ],
          [
            18.989703,
            51.937626,
            148.633057
          ],
          [
            18.989948,
            51.937463,
            148.205464
          ],
          [
            18.990249,
            51.937299,
            148.185959
          ],
          [
            18.990567,
            51.937149,
            148.179499
          ],
          [
            18.990914,
            51.936998,
            148.172648
          ],
          [
            18.99122,
            51.93685,
            148.166361
          ],
          [
            18.991549,
            51.936682,
            148.159474
          ],
          [
            18.991827,
            51.936546,
            148.153753
          ],
          [
            18.992112,
            51.936437,
            148.148312
          ],
          [
            18.992361,
            51.936326,
            148.286854
          ],
          [
            18.992577,
            51.936178,
            148.669883
          ],
          [
            18.992789,
            51.93602,
            149.063152
          ],
          [
            18.993031,
            51.935848,
            149.499833
          ],
          [
            18.993208,
            51.935657,
            149.922711
          ],
          [
            18.993403,
            51.935462,
            150.362117
          ],
          [
            18.99355,
            51.935251,
            150.802414
          ],
          [
            18.9937,
            51.935062,
            151.206008
          ],
          [
            18.993828,
            51.934854,
            151.65871
          ],
          [
            18.993886,
            51.934658,
            152.287019
          ],
          [
            18.993936,
            51.934474,
            152.876056
          ],
          [
            18.994005,
            51.934276,
            153.513974
          ],
          [
            18.994177,
            51.934085,
            154.213284
          ],
          [
            18.994543,
            51.934035,
            154.959082
          ],
          [
            18.994909,
            51.934046,
            155.672926
          ],
          [
            18.995267,
            51.934074,
            156.373878
          ],
          [
            18.995566,
            51.934086,
            156.9559
          ],
          [
            18.995887,
            51.934099,
            157.370452
          ],
          [
            18.996206,
            51.934131,
            157.588582
          ],
          [
            18.99652,
            51.934164,
            157.803819
          ],
          [
            18.996858,
            51.934199,
            158.035056
          ],
          [
            18.997209,
            51.93421,
            158.272146
          ],
          [
            18.997569,
            51.934242,
            158.517757
          ],
          [
            18.997902,
            51.934257,
            158.743122
          ],
          [
            18.998226,
            51.934258,
            158.961694
          ],
          [
            18.998558,
            51.934296,
            159.189493
          ],
          [
            18.998861,
            51.934318,
            158.971479
          ],
          [
            18.999168,
            51.934349,
            158.654736
          ],
          [
            18.999518,
            51.934384,
            158.293787
          ],
          [
            18.999898,
            51.934373,
            157.906108
          ],
          [
            19.000214,
            51.934386,
            157.583315
          ],
          [
            19.000522,
            51.93443,
            157.260952
          ],
          [
            19.000853,
            51.934479,
            156.914259
          ],
          [
            19.001168,
            51.934544,
            156.575047
          ],
          [
            19.001497,
            51.934609,
            156.21947
          ],
          [
            19.001818,
            51.934665,
            155.843083
          ],
          [
            19.002151,
            51.93472,
            155.453777
          ],
          [
            19.002449,
            51.934779,
            155.100498
          ],
          [
            19.002792,
            51.934864,
            154.681928
          ],
          [
            19.003065,
            51.93493,
            154.351076
          ],
          [
            19.003429,
            51.935006,
            153.916881
          ],
          [
            19.00372,
            51.935112,
            153.535404
          ],
          [
            19.004038,
            51.93522,
            153.125809
          ],
          [
            19.004397,
            51.935336,
            152.939371
          ],
          [
            19.00464,
            51.935441,
            152.909877
          ],
          [
            19.004913,
            51.935548,
            152.87775
          ],
          [
            19.005182,
            51.935669,
            152.844291
          ],
          [
            19.005509,
            51.935715,
            152.810945
          ],
          [
            19.005882,
            51.93566,
            152.772765
          ],
          [
            19.006299,
            51.935579,
            152.729114
          ],
          [
            19.006683,
            51.935486,
            152.688131
          ],
          [
            19.006981,
            51.935385,
            152.44464
          ],
          [
            19.007292,
            51.935293,
            152.075686
          ],
          [
            19.007502,
            51.935103,
            151.676701
          ],
          [
            19.007627,
            51.934924,
            151.338734
          ],
          [
            19.007827,
            51.93471,
            150.910315
          ],
          [
            19.008066,
            51.934558,
            150.543143
          ],
          [
            19.00834,
            51.934432,
            150.175515
          ],
          [
            19.008624,
            51.93431,
            149.805409
          ],
          [
            19.008953,
            51.934195,
            149.87491
          ],
          [
            19.009322,
            51.93409,
            150.744468
          ],
          [
            19.009637,
            51.933975,
            151.527218
          ],
          [
            19.009962,
            51.933857,
            152.333471
          ],
          [
            19.010252,
            51.933759,
            153.040316
          ],
          [
            19.010534,
            51.933632,
            153.786819
          ],
          [
            19.010842,
            51.933507,
            154.575251
          ],
          [
            19.011172,
            51.933395,
            155.380408
          ],
          [
            19.011491,
            51.933252,
            156.040895
          ],
          [
            19.011788,
            51.933136,
            156.474564
          ],
          [
            19.012048,
            51.933049,
            156.839993
          ],
          [
            19.012362,
            51.93293,
            157.295372
          ],
          [
            19.012664,
            51.932819,
            157.729279
          ],
          [
            19.012915,
            51.932698,
            158.130163
          ],
          [
            19.013175,
            51.932608,
            158.500071
          ],
          [
            19.013527,
            51.932461,
            159.024426
          ],
          [
            19.013841,
            51.932363,
            159.3688
          ],
          [
            19.014149,
            51.932257,
            159.236144
          ],
          [
            19.01449,
            51.932159,
            159.094884
          ],
          [
            19.014762,
            51.932075,
            158.980562
          ],
          [
            19.015119,
            51.931982,
            158.834959
          ],
          [
            19.015484,
            51.931887,
            158.686208
          ],
          [
            19.015821,
            51.931773,
            158.541709
          ],
          [
            19.016158,
            51.931693,
            158.406071
          ],
          [
            19.016506,
            51.931622,
            158.26981
          ],
          [
            19.016889,
            51.931502,
            158.116997
          ],
          [
            19.017269,
            51.931401,
            157.969799
          ],
          [
            19.017598,
            51.931313,
            157.842228
          ],
          [
            19.017989,
            51.931183,
            157.68405
          ],
          [
            19.018367,
            51.931078,
            157.536093
          ],
          [
            19.018731,
            51.930971,
            157.392613
          ],
          [
            19.019122,
            51.930899,
            157.25766
          ],
          [
            19.01947,
            51.930858,
            157.267346
          ],
          [
            19.01991,
            51.93085,
            157.278905
          ],
          [
            19.020218,
            51.930827,
            157.287059
          ],
          [
            19.02054,
            51.930843,
            157.295554
          ],
          [
            19.020918,
            51.930882,
            157.305666
          ],
          [
            19.021213,
            51.93091,
            157.313512
          ],
          [
            19.021521,
            51.930917,
            157.321611
          ],
          [
            19.021904,
            51.930955,
            157.33179
          ],
          [
            19.022258,
            51.930965,
            157.528024
          ],
          [
            19.022672,
            51.930973,
            157.806094
          ],
          [
            19.023039,
            51.930997,
            158.05311
          ],
          [
            19.023341,
            51.931009,
            158.255697
          ],
          [
            19.023653,
            51.931015,
            158.465708
          ],
          [
            19.023982,
            51.931026,
            158.686261
          ],
          [
            19.024302,
            51.931033,
            158.900692
          ],
          [
            19.02463,
            51.931041,
            159.120469
          ],
          [
            19.02495,
            51.931105,
            159.24764
          ],
          [
            19.02528,
            51.931188,
            159.09698
          ],
          [
            19.025607,
            51.931271,
            158.947509
          ],
          [
            19.025916,
            51.931323,
            158.809158
          ],
          [
            19.026258,
            51.931333,
            158.664369
          ],
          [
            19.026622,
            51.931343,
            158.51037
          ],
          [
            19.026964,
            51.93133,
            158.365553
          ],
          [
            19.0273,
            51.931298,
            158.221855
          ],
          [
            19.027601,
            51.931286,
            158.094192
          ],
          [
            19.027919,
            51.931235,
            158.254776
          ],
          [
            19.028241,
            51.931219,
            158.533583
          ],
          [
            19.028565,
            51.931197,
            158.814028
          ],
          [
            19.028885,
            51.931186,
            159.089386
          ],
          [
            19.029214,
            51.931175,
            159.37323
          ],
          [
            19.029521,
            51.931171,
            159.637153
          ],
          [
            19.029856,
            51.931157,
            159.926885
          ],
          [
            19.0302,
            51.931138,
            160.226321
          ],
          [
            19.030545,
            51.931136,
            160.524049
          ],
          [
            19.030881,
            51.931102,
            160.561444
          ],
          [
            19.031226,
            51.931092,
            160.56464
          ],
          [
            19.03159,
            51.93108,
            160.567986
          ],
          [
            19.031946,
            51.931072,
            160.571255
          ],
          [
            19.032289,
            51.93106,
            160.574406
          ],
          [
            19.03263,
            51.931053,
            160.577538
          ],
          [
            19.032991,
            51.93102,
            160.580894
          ],
          [
            19.033336,
            51.930985,
            160.584102
          ],
          [
            19.033717,
            51.930976,
            160.590837
          ],
          [
            19.034115,
            51.930967,
            160.599941
          ],
          [
            19.034502,
            51.930944,
            160.608829
          ],
          [
            19.034881,
            51.930922,
            160.617536
          ],
          [
            19.035284,
            51.93091,
            160.62676
          ],
          [
            19.035702,
            51.930893,
            160.636342
          ],
          [
            19.036169,
            51.930864,
            160.647071
          ],
          [
            19.036597,
            51.930855,
            160.705669
          ],
          [
            19.037012,
            51.930839,
            160.812994
          ],
          [
            19.037457,
            51.930811,
            160.928501
          ],
          [
            19.037895,
            51.930781,
            161.042389
          ],
          [
            19.038348,
            51.930757,
            161.15975
          ],
          [
            19.038746,
            51.93073,
            161.263228
          ],
          [
            19.039152,
            51.930696,
            161.369271
          ],
          [
            19.039562,
            51.930684,
            161.329812
          ],
          [
            19.03997,
            51.930662,
            161.216521
          ],
          [
            19.040346,
            51.930661,
            161.112573
          ],
          [
            19.040731,
            51.93062,
            161.003575
          ],
          [
            19.041119,
            51.930616,
            160.89632
          ],
          [
            19.041483,
            51.930611,
            160.795675
          ],
          [
            19.041801,
            51.930574,
            160.7061
          ],
          [
            19.042112,
            51.930557,
            160.619779
          ],
          [
            19.042477,
            51.930525,
            161.020337
          ],
          [
            19.042877,
            51.930495,
            161.60126
          ],
          [
            19.043223,
            51.930495,
            162.099695
          ],
          [
            19.043577,
            51.93049,
            162.609587
          ],
          [
            19.04394,
            51.930487,
            163.136699
          ],
          [
            19.044303,
            51.930485,
            163.660263
          ],
          [
            19.044658,
            51.930464,
            164.174526
          ],
          [
            19.045012,
            51.930443,
            164.686642
          ],
          [
            19.045318,
            51.930451,
            164.764398
          ],
          [
            19.04564,
            51.930428,
            164.714964
          ],
          [
            19.045948,
            51.930402,
            164.667549
          ],
          [
            19.046345,
            51.930378,
            164.60672
          ],
          [
            19.046676,
            51.930357,
            164.55558
          ],
          [
            19.047038,
            51.930324,
            164.499778
          ],
          [
            19.047397,
            51.930293,
            164.444499
          ],
          [
            19.047765,
            51.930256,
            164.387637
          ],
          [
            19.04813,
            51.930219,
            164.268972
          ],
          [
            19.048486,
            51.930174,
            164.064518
          ],
          [
            19.048863,
            51.930136,
            163.849612
          ],
          [
            19.04923,
            51.93009,
            163.638953
          ],
          [
            19.049588,
            51.930039,
            163.432492
          ],
          [
            19.049965,
            51.930009,
            163.218558
          ],
          [
            19.050323,
            51.929966,
            163.013263
          ],
          [
            19.050704,
            51.929919,
            162.794897
          ],
          [
            19.051068,
            51.929854,
            162.639669
          ],
          [
            19.051439,
            51.929804,
            162.518469
          ],
          [
            19.051817,
            51.929755,
            162.395358
          ],
          [
            19.052174,
            51.929717,
            162.279937
          ],
          [
            19.052538,
            51.929674,
            162.161873
          ],
          [
            19.052905,
            51.929612,
            162.040403
          ],
          [
            19.053282,
            51.929552,
            161.916265
          ],
          [
            19.05368,
            51.929507,
            161.78711
          ],
          [
            19.054083,
            51.929478,
            161.319101
          ],
          [
            19.054518,
            51.929466,
            160.814305
          ],
          [
            19.05497,
            51.929437,
            160.287792
          ],
          [
            19.055431,
            51.929411,
            159.751566
          ],
          [
            19.055867,
            51.929371,
            159.240679
          ],
          [
            19.056285,
            51.929321,
            158.741845
          ],
          [
            19.056664,
            51.929231,
            158.419852
          ],
          [
            19.057011,
            51.929158,
            158.458426
          ],
          [
            19.057346,
            51.929081,
            158.49602
          ],
          [
            19.057693,
            51.928988,
            158.535853
          ],
          [
            19.05803,
            51.928894,
            158.574802
          ],
          [
            19.05834,
            51.928782,
            158.612596
          ],
          [
            19.058564,
            51.928628,
            158.647895
          ],
          [
            19.058788,
            51.928444,
            158.687135
          ],
          [
            19.059019,
            51.928262,
            158.974243
          ],
          [
            19.059212,
            51.928092,
            159.718022
          ],
          [
            19.059435,
            51.927936,
            160.463062
          ],
          [
            19.059763,
            51.927799,
            161.339407
          ],
          [
            19.060097,
            51.927708,
            162.148556
          ],
          [
            19.060437,
            51.927647,
            162.930209
          ],
          [
            19.06074,
            51.927601,
            163.620093
          ],
          [
            19.060849,
            51.927441,
            164.351833
          ],
          [
            19.060837,
            51.927251,
            165.034165
          ],
          [
            19.060788,
            51.927324,
            165.335233
          ],
          [
            19.060817,
            51.927539,
            165.71466
          ],
          [
            19.061104,
            51.927575,
            166.067191
          ],
          [
            19.061414,
            51.927511,
            166.418966
          ],
          [
            19.061733,
            51.927429,
            166.792335
          ],
          [
            19.062051,
            51.927376,
            167.147176
          ],
          [
            19.062347,
            51.927283,
            167.505242
          ],
          [
            19.062649,
            51.927209,
            167.85648
          ],
          [
            19.062959,
            51.927153,
            168.204061
          ],
          [
            19.06329,
            51.927086,
            168.589297
          ],
          [
            19.063632,
            51.927031,
            168.982728
          ],
          [
            19.063926,
            51.926931,
            169.356815
          ],
          [
            19.064333,
            51.926766,
            170.038052
          ],
          [
            19.064646,
            51.926679,
            170.420207
          ],
          [
            19.064961,
            51.926553,
            170.838348
          ],
          [
            19.065226,
            51.926452,
            171.1863
          ],
          [
            19.065512,
            51.926351,
            171.532002
          ],
          [
            19.065804,
            51.926215,
            171.477534
          ],
          [
            19.066075,
            51.926075,
            171.424912
          ],
          [
            19.066353,
            51.925889,
            171.363856
          ],
          [
            19.066553,
            51.92574,
            171.317109
          ],
          [
            19.066757,
            51.925593,
            171.27038
          ],
          [
            19.066981,
            51.925449,
            171.222183
          ],
          [
            19.067202,
            51.925306,
            171.174479
          ],
          [
            19.067429,
            51.92514,
            171.122066
          ],
          [
            19.067674,
            51.924979,
            170.986302
          ],
          [
            19.067921,
            51.924817,
            170.792346
          ],
          [
            19.068163,
            51.924664,
            170.606098
          ],
          [
            19.0684,
            51.924509,
            170.42045
          ],
          [
            19.068629,
            51.924369,
            170.246992
          ],
          [
            19.068812,
            51.924222,
            170.085501
          ],
          [
            19.069016,
            51.924076,
            169.917364
          ],
          [
            19.069223,
            51.923914,
            169.737591
          ],
          [
            19.069432,
            51.923771,
            169.569851
          ],
          [
            19.069634,
            51.923604,
            169.609128
          ],
          [
            19.069825,
            51.923451,
            169.697289
          ],
          [
            19.070025,
            51.923299,
            169.786706
          ],
          [
            19.070222,
            51.923106,
            169.890842
          ],
          [
            19.070306,
            51.922889,
            169.994579
          ],
          [
            19.07027,
            51.922664,
            170.097846
          ],
          [
            19.070166,
            51.922411,
            170.217041
          ],
          [
            19.070128,
            51.922174,
            170.325829
          ],
          [
            19.070122,
            51.921938,
            170.373414
          ],
          [
            19.070172,
            51.92172,
            170.397641
          ],
          [
            19.070344,
            51.921508,
            170.423694
          ],
          [
            19.070552,
            51.921316,
            170.44909
          ],
          [
            19.070759,
            51.921103,
            170.476395
          ],
          [
            19.070961,
            51.920898,
            170.50278
          ],
          [
            19.071167,
            51.92068,
            170.530508
          ],
          [
            19.07135,
            51.920495,
            170.558045
          ],
          [
            19.071563,
            51.920279,
            170.628285
          ],
          [
            19.071746,
            51.920099,
            170.687404
          ],
          [
            19.071981,
            51.9199,
            170.755847
          ],
          [
            19.072219,
            51.919732,
            170.817836
          ],
          [
            19.072453,
            51.91956,
            170.880228
          ],
          [
            19.072696,
            51.919401,
            170.940931
          ],
          [
            19.072926,
            51.919252,
            170.998105
          ],
          [
            19.073146,
            51.919106,
            171.056202
          ],
          [
            19.073373,
            51.918957,
            171.196934
          ],
          [
            19.073602,
            51.918791,
            171.346985
          ],
          [
            19.073857,
            51.918628,
            171.502954
          ],
          [
            19.074107,
            51.918459,
            171.660556
          ],
          [
            19.074364,
            51.918275,
            171.827714
          ],
          [
            19.074635,
            51.918108,
            171.990607
          ],
          [
            19.074878,
            51.917947,
            172.142127
          ],
          [
            19.07514,
            51.917788,
            172.307122
          ],
          [
            19.075387,
            51.917627,
            172.618344
          ],
          [
            19.075651,
            51.917479,
            172.931005
          ],
          [
            19.075974,
            51.91733,
            173.280662
          ],
          [
            19.076277,
            51.917222,
            173.583744
          ],
          [
            19.076622,
            51.917117,
            173.91692
          ],
          [
            19.076976,
            51.917023,
            174.250821
          ],
          [
            19.077354,
            51.916922,
            174.607578
          ],
          [
            19.077695,
            51.91684,
            174.655199
          ],
          [
            19.078023,
            51.916757,
            174.206951
          ],
          [
            19.078375,
            51.916681,
            173.733813
          ],
          [
            19.078759,
            51.916603,
            173.221105
          ],
          [
            19.079072,
            51.916524,
            172.792644
          ],
          [
            19.079447,
            51.916447,
            172.292454
          ],
          [
            19.079796,
            51.916371,
            171.823344
          ],
          [
            19.080151,
            51.91638,
            171.372462
          ],
          [
            19.080492,
            51.916457,
            171.208788
          ],
          [
            19.080827,
            51.916551,
            171.38335
          ],
          [
            19.081199,
            51.916587,
            171.56224
          ],
          [
            19.081545,
            51.916603,
            171.726432
          ],
          [
            19.081861,
            51.916653,
            171.880813
          ],
          [
            19.08231,
            51.916716,
            172.098782
          ],
          [
            19.082599,
            51.916745,
            172.237663
          ],
          [
            19.082901,
            51.916801,
            172.386869
          ],
          [
            19.083221,
            51.91687,
            172.698842
          ],
          [
            19.083537,
            51.916926,
            173.45207
          ],
          [
            19.083849,
            51.916967,
            174.183483
          ],
          [
            19.084184,
            51.917006,
            174.964917
          ],
          [
            19.08452,
            51.917053,
            175.75422
          ],
          [
            19.084846,
            51.917144,
            176.575475
          ],
          [
            19.085135,
            51.917239,
            177.32571
          ],
          [
            19.085449,
            51.91729,
            178.069609
          ],
          [
            19.085775,
            51.917234,
            178.901725
          ],
          [
            19.085806,
            51.917048,
            179.241725
          ],
          [
            19.085821,
            51.916856,
            179.334297
          ],
          [
            19.085867,
            51.916631,
            179.443393
          ],
          [
            19.085846,
            51.916413,
            179.548464
          ],
          [
            19.08587,
            51.916161,
            179.669738
          ],
          [
            19.085899,
            51.915975,
            179.75952
          ],
          [
            19.085958,
            51.915743,
            179.872337
          ],
          [
            19.085997,
            51.915511,
            179.98447
          ],
          [
            19.086045,
            51.915284,
            179.942499
          ],
          [
            19.08606,
            51.915084,
            179.692512
          ],
          [
            19.086096,
            51.914873,
            179.427428
          ],
          [
            19.08613,
            51.914643,
            179.139009
          ],
          [
            19.086152,
            51.914436,
            178.878606
          ],
          [
            19.086205,
            51.914203,
            178.584823
          ],
          [
            19.086275,
            51.913992,
            178.315298
          ],
          [
            19.086377,
            51.913729,
            177.977681
          ],
          [
            19.086471,
            51.913499,
            177.849354
          ],
          [
            19.086548,
            51.913278,
            177.945625
          ],
          [
            19.086621,
            51.913078,
            178.032881
          ],
          [
            19.086698,
            51.912874,
            178.122093
          ],
          [
            19.086772,
            51.912664,
            178.213597
          ],
          [
            19.086854,
            51.912449,
            178.307617
          ],
          [
            19.086941,
            51.912247,
            178.396719
          ],
          [
            19.087018,
            51.912042,
            178.486284
          ],
          [
            19.087106,
            51.911832,
            178.582732
          ],
          [
            19.087191,
            51.91163,
            178.729062
          ],
          [
            19.087271,
            51.911428,
            178.875094
          ],
          [
            19.087348,
            51.91122,
            179.02508
          ],
          [
            19.08744,
            51.910998,
            179.185759
          ],
          [
            19.087521,
            51.910801,
            179.328347
          ],
          [
            19.087601,
            51.910588,
            179.481654
          ],
          [
            19.087685,
            51.910385,
            179.62856
          ],
          [
            19.087768,
            51.910176,
            179.779619
          ],
          [
            19.087825,
            51.90998,
            180.091211
          ],
          [
            19.08789,
            51.909739,
            180.603182
          ],
          [
            19.087979,
            51.909519,
            181.078818
          ],
          [
            19.088101,
            51.909288,
            181.588627
          ],
          [
            19.088179,
            51.909048,
            182.101788
          ],
          [
            19.088258,
            51.908822,
            182.586322
          ],
          [
            19.088363,
            51.908575,
            183.121483
          ],
          [
            19.088458,
            51.908336,
            183.606223
          ],
          [
            19.088543,
            51.908083,
            183.665151
          ],
          [
            19.088625,
            51.90787,
            183.715088
          ],
          [
            19.088738,
            51.907617,
            183.77493
          ],
          [
            19.088838,
            51.907355,
            183.836327
          ],
          [
            19.088932,
            51.907099,
            183.896228
          ],
          [
            19.088996,
            51.906873,
            183.948544
          ],
          [
            19.089083,
            51.906659,
            183.998854
          ],
          [
            19.089152,
            51.90648,
            183.977683
          ],
          [
            19.089227,
            51.90629,
            183.922566
          ],
          [
            19.089305,
            51.906104,
            183.868379
          ],
          [
            19.089371,
            51.905915,
            183.813805
          ],
          [
            19.089446,
            51.905711,
            183.754835
          ],
          [
            19.089488,
            51.905529,
            183.703027
          ],
          [
            19.08959,
            51.905329,
            183.643759
          ],
          [
            19.089667,
            51.905148,
            183.590991
          ],
          [
            19.089755,
            51.90496,
            183.535832
          ],
          [
            19.089838,
            51.904777,
            183.546931
          ],
          [
            19.089941,
            51.904594,
            183.642882
          ],
          [
            19.090051,
            51.904375,
            183.756516
          ],
          [
            19.090158,
            51.904181,
            183.858016
          ],
          [
            19.090256,
            51.903982,
            183.961108
          ],
          [
            19.090349,
            51.903797,
            184.057115
          ],
          [
            19.090455,
            51.903568,
            184.175329
          ],
          [
            19.090579,
            51.903388,
            184.272203
          ],
          [
            19.09069,
            51.903179,
            184.381142
          ],
          [
            19.090805,
            51.903005,
            184.106802
          ],
          [
            19.090894,
            51.902822,
            183.753532
          ],
          [
            19.091035,
            51.902608,
            183.326407
          ],
          [
            19.091163,
            51.902369,
            182.861013
          ],
          [
            19.09125,
            51.902191,
            182.517257
          ],
          [
            19.091341,
            51.901993,
            182.136317
          ],
          [
            19.091425,
            51.901785,
            181.738731
          ],
          [
            19.091517,
            51.901585,
            181.354108
          ],
          [
            19.091639,
            51.901391,
            181.113572
          ],
          [
            19.091732,
            51.9012,
            181.268195
          ],
          [
            19.091833,
            51.901011,
            181.421827
          ],
          [
            19.091957,
            51.900815,
            181.584369
          ],
          [
            19.09207,
            51.900608,
            181.753194
          ],
          [
            19.092167,
            51.900395,
            181.923992
          ],
          [
            19.092289,
            51.900188,
            182.094099
          ],
          [
            19.092384,
            51.899983,
            182.2587
          ],
          [
            19.092487,
            51.899785,
            182.419256
          ],
          [
            19.092607,
            51.899593,
            182.48491
          ],
          [
            19.0927,
            51.899418,
            182.515335
          ],
          [
            19.092792,
            51.899246,
            182.545291
          ],
          [
            19.092913,
            51.899035,
            182.582263
          ],
          [
            19.092989,
            51.898803,
            182.621434
          ],
          [
            19.093084,
            51.898627,
            182.652075
          ],
          [
            19.093207,
            51.898446,
            182.684491
          ],
          [
            19.093335,
            51.89822,
            182.724032
          ],
          [
            19.093444,
            51.898006,
            182.731789
          ],
          [
            19.093564,
            51.89779,
            182.522626
          ],
          [
            19.093662,
            51.897614,
            182.352226
          ],
          [
            19.093799,
            51.897399,
            182.140688
          ],
          [
            19.093889,
            51.897216,
            181.96557
          ],
          [
            19.093997,
            51.897024,
            181.77939
          ],
          [
            19.094095,
            51.896819,
            181.583356
          ],
          [
            19.0942,
            51.89662,
            181.391724
          ],
          [
            19.094301,
            51.896422,
            181.201581
          ],
          [
            19.094382,
            51.896231,
            181.031587
          ],
          [
            19.094507,
            51.896034,
            180.861556
          ],
          [
            19.094623,
            51.895841,
            180.696199
          ],
          [
            19.094736,
            51.895642,
            180.526397
          ],
          [
            19.09485,
            51.895436,
            180.351495
          ],
          [
            19.09495,
            51.89524,
            180.186436
          ],
          [
            19.095052,
            51.895059,
            180.031985
          ],
          [
            19.09516,
            51.894882,
            179.880077
          ],
          [
            19.095274,
            51.894667,
            179.698371
          ],
          [
            19.095397,
            51.894412,
            180.002613
          ],
          [
            19.095541,
            51.894158,
            180.407141
          ],
          [
            19.095669,
            51.893938,
            180.758458
          ],
          [
            19.095803,
            51.893726,
            181.101203
          ],
          [
            19.095912,
            51.893526,
            181.418358
          ],
          [
            19.096044,
            51.893289,
            181.795029
          ],
          [
            19.096127,
            51.893117,
            182.066317
          ],
          [
            19.096219,
            51.892939,
            182.347212
          ],
          [
            19.096336,
            51.892731,
            181.876845
          ],
          [
            19.096466,
            51.892516,
            181.331353
          ],
          [
            19.096541,
            51.892325,
            180.864192
          ],
          [
            19.096649,
            51.892096,
            180.297126
          ],
          [
            19.096765,
            51.891886,
            179.769749
          ],
          [
            19.096863,
            51.891671,
            179.237512
          ],
          [
            19.097001,
            51.891465,
            178.707217
          ],
          [
            19.097099,
            51.891247,
            178.168641
          ],
          [
            19.097211,
            51.891033,
            177.904558
          ],
          [
            19.097337,
            51.890826,
            177.68835
          ],
          [
            19.097437,
            51.890631,
            177.488674
          ],
          [
            19.097532,
            51.890445,
            177.298139
          ],
          [
            19.097627,
            51.890257,
            177.105909
          ],
          [
            19.097721,
            51.890057,
            176.902452
          ],
          [
            19.097818,
            51.889863,
            176.704268
          ],
          [
            19.097931,
            51.889674,
            176.507619
          ],
          [
            19.098046,
            51.889492,
            176.308098
          ],
          [
            19.098154,
            51.889296,
            176.019095
          ],
          [
            19.098229,
            51.889099,
            175.736711
          ],
          [
            19.098343,
            51.888895,
            175.436003
          ],
          [
            19.098423,
            51.888688,
            175.139668
          ],
          [
            19.098525,
            51.888496,
            174.85823
          ],
          [
            19.098637,
            51.888319,
            174.593545
          ],
          [
            19.098737,
            51.888141,
            174.331141
          ],
          [
            19.098833,
            51.887962,
            174.068624
          ],
          [
            19.098928,
            51.887788,
            173.827437
          ],
          [
            19.099041,
            51.887569,
            173.736113
          ],
          [
            19.099178,
            51.887313,
            173.62897
          ],
          [
            19.099264,
            51.887133,
            173.554389
          ],
          [
            19.099364,
            51.886932,
            173.470659
          ],
          [
            19.099505,
            51.886713,
            173.376991
          ],
          [
            19.099629,
            51.886495,
            173.285116
          ],
          [
            19.099745,
            51.886269,
            173.190865
          ],
          [
            19.099869,
            51.88604,
            173.099596
          ],
          [
            19.099985,
            51.885824,
            173.027064
          ],
          [
            19.100109,
            51.885617,
            172.956723
          ],
          [
            19.100227,
            51.885399,
            172.88346
          ],
          [
            19.10032,
            51.885194,
            172.815567
          ],
          [
            19.10043,
            51.884985,
            172.745524
          ],
          [
            19.100543,
            51.884771,
            172.673786
          ],
          [
            19.100674,
            51.88456,
            172.601766
          ],
          [
            19.100797,
            51.884337,
            172.764707
          ],
          [
            19.100921,
            51.884121,
            173.622872
          ],
          [
            19.101048,
            51.883925,
            174.41336
          ],
          [
            19.101136,
            51.883743,
            175.124465
          ],
          [
            19.101247,
            51.883547,
            175.902331
          ],
          [
            19.101313,
            51.883354,
            176.640618
          ],
          [
            19.101417,
            51.883159,
            177.409408
          ],
          [
            19.101555,
            51.882962,
            178.216247
          ],
          [
            19.101785,
            51.882796,
            179.035751
          ],
          [
            19.101987,
            51.882631,
            179.651622
          ],
          [
            19.102111,
            51.882421,
            180.235996
          ],
          [
            19.102171,
            51.882214,
            180.786958
          ],
          [
            19.102246,
            51.882013,
            181.335638
          ],
          [
            19.102417,
            51.881819,
            181.912979
          ],
          [
            19.102602,
            51.881647,
            182.452812
          ],
          [
            19.102772,
            51.881464,
            183.004388
          ],
          [
            19.102935,
            51.881279,
            183.555361
          ],
          [
            19.103106,
            51.8811,
            184.011488
          ],
          [
            19.103305,
            51.880903,
            184.176338
          ],
          [
            19.103497,
            51.880701,
            184.342652
          ],
          [
            19.103697,
            51.880497,
            184.511973
          ],
          [
            19.103903,
            51.880297,
            184.680343
          ],
          [
            19.104108,
            51.880096,
            184.848999
          ],
          [
            19.104312,
            51.879904,
            185.012208
          ],
          [
            19.104525,
            51.879702,
            185.183361
          ],
          [
            19.104732,
            51.879482,
            185.275571
          ],
          [
            19.104937,
            51.879266,
            185.307568
          ],
          [
            19.105116,
            51.879089,
            185.334263
          ],
          [
            19.105389,
            51.87886,
            185.370752
          ],
          [
            19.105543,
            51.878668,
            185.398158
          ],
          [
            19.105744,
            51.878475,
            185.427483
          ],
          [
            19.105939,
            51.878274,
            185.457435
          ],
          [
            19.106131,
            51.878076,
            185.486929
          ],
          [
            19.106319,
            51.877887,
            185.514593
          ],
          [
            19.106483,
            51.877711,
            185.539909
          ],
          [
            19.106638,
            51.87755,
            185.563224
          ],
          [
            19.106808,
            51.87739,
            185.587063
          ],
          [
            19.106983,
            51.877196,
            185.614719
          ],
          [
            19.107162,
            51.877013,
            185.641365
          ],
          [
            19.107324,
            51.876863,
            185.663807
          ],
          [
            19.107533,
            51.87667,
            185.692736
          ],
          [
            19.107714,
            51.876471,
            185.674495
          ],
          [
            19.107877,
            51.876305,
            185.598299
          ],
          [
            19.108027,
            51.876139,
            185.523273
          ],
          [
            19.108188,
            51.875976,
            185.447959
          ],
          [
            19.108386,
            51.875753,
            185.347963
          ],
          [
            19.108558,
            51.875514,
            185.245416
          ],
          [
            19.108765,
            51.875325,
            185.155835
          ],
          [
            19.108939,
            51.87517,
            185.081889
          ],
          [
            19.109126,
            51.875013,
            185.005188
          ],
          [
            19.10929,
            51.874855,
            184.854526
          ],
          [
            19.109444,
            51.874681,
            184.693577
          ],
          [
            19.109617,
            51.874515,
            184.534432
          ],
          [
            19.109813,
            51.874353,
            184.371374
          ],
          [
            19.109991,
            51.874173,
            184.20152
          ],
          [
            19.110168,
            51.874005,
            184.040012
          ],
          [
            19.110332,
            51.873844,
            183.886037
          ],
          [
            19.110486,
            51.873676,
            183.730551
          ],
          [
            19.110669,
            51.873471,
            183.544104
          ],
          [
            19.110851,
            51.8733,
            183.404519
          ],
          [
            19.111027,
            51.873125,
            183.264421
          ],
          [
            19.111195,
            51.872949,
            183.125478
          ],
          [
            19.111374,
            51.872773,
            182.984136
          ],
          [
            19.111562,
            51.872596,
            182.84006
          ],
          [
            19.111751,
            51.872407,
            182.68895
          ],
          [
            19.111933,
            51.872206,
            182.532335
          ],
          [
            19.112117,
            51.872013,
            182.379923
          ],
          [
            19.112279,
            51.871829,
            182.170144
          ],
          [
            19.112474,
            51.871648,
            181.918037
          ],
          [
            19.112659,
            51.871468,
            181.670638
          ],
          [
            19.112826,
            51.871292,
            181.43406
          ],
          [
            19.112989,
            51.871104,
            181.186425
          ],
          [
            19.113174,
            51.870922,
            180.937276
          ],
          [
            19.113376,
            51.870744,
            180.685155
          ],
          [
            19.113507,
            51.870558,
            180.449922
          ],
          [
            19.113656,
            51.870392,
            180.241367
          ],
          [
            19.113868,
            51.870201,
            180.152695
          ],
          [
            19.114065,
            51.870012,
            180.066517
          ],
          [
            19.114292,
            51.869816,
            179.973853
          ],
          [
            19.114458,
            51.869648,
            179.898535
          ],
          [
            19.114609,
            51.869473,
            179.822438
          ],
          [
            19.11482,
            51.869271,
            179.730425
          ],
          [
            19.114991,
            51.86908,
            179.646896
          ],
          [
            19.115181,
            51.868921,
            179.571246
          ],
          [
            19.115352,
            51.868738,
            179.410503
          ],
          [
            19.115523,
            51.868576,
            179.250192
          ],
          [
            19.115684,
            51.868417,
            179.094752
          ],
          [
            19.11583,
            51.868246,
            178.934304
          ],
          [
            19.115989,
            51.868068,
            178.765739
          ],
          [
            19.116164,
            51.867887,
            178.590872
          ],
          [
            19.116322,
            51.867721,
            178.430988
          ],
          [
            19.116503,
            51.86754,
            178.254657
          ],
          [
            19.116678,
            51.867366,
            178.084884
          ],
          [
            19.116841,
            51.867186,
            177.730937
          ],
          [
            19.117004,
            51.867027,
            177.39012
          ],
          [
            19.11718,
            51.866856,
            177.023244
          ],
          [
            19.117352,
            51.866692,
            176.669176
          ],
          [
            19.117514,
            51.866503,
            176.282029
          ],
          [
            19.117696,
            51.866339,
            175.921826
          ],
          [
            19.117879,
            51.866159,
            175.535456
          ],
          [
            19.118043,
            51.865978,
            175.1598
          ],
          [
            19.118233,
            51.865805,
            174.785541
          ],
          [
            19.118393,
            51.865619,
            174.464744
          ],
          [
            19.118574,
            51.865438,
            174.144128
          ],
          [
            19.118716,
            51.865264,
            173.850495
          ],
          [
            19.11889,
            51.865095,
            173.548696
          ],
          [
            19.119061,
            51.864924,
            173.245825
          ],
          [
            19.119187,
            51.864746,
            172.951646
          ],
          [
            19.119267,
            51.864558,
            172.657443
          ],
          [
            19.119275,
            51.864367,
            172.369503
          ],
          [
            19.11923,
            51.864126,
            172.205259
          ],
          [
            19.119187,
            51.863927,
            172.528963
          ],
          [
            19.119181,
            51.863739,
            172.8364
          ],
          [
            19.119175,
            51.863548,
            173.147481
          ],
          [
            19.11914,
            51.863321,
            173.515257
          ],
          [
            19.119118,
            51.863118,
            173.843589
          ],
          [
            19.119087,
            51.862889,
            174.214051
          ],
          [
            19.119062,
            51.86267,
            174.567939
          ],
          [
            19.119031,
            51.862438,
            174.943915
          ],
          [
            19.119012,
            51.862219,
            174.956943
          ],
          [
            19.118991,
            51.862002,
            174.905741
          ],
          [
            19.118994,
            51.861773,
            174.851804
          ],
          [
            19.118979,
            51.861564,
            174.802514
          ],
          [
            19.11896,
            51.861355,
            174.753178
          ],
          [
            19.118916,
            51.861126,
            174.698863
          ],
          [
            19.118886,
            51.860891,
            174.643342
          ],
          [
            19.118851,
            51.860668,
            174.590562
          ],
          [
            19.118808,
            51.860448,
            174.277997
          ],
          [
            19.118772,
            51.860219,
            173.85585
          ],
          [
            19.118746,
            51.859985,
            173.425629
          ],
          [
            19.118726,
            51.859725,
            172.948041
          ],
          [
            19.118706,
            51.859478,
            172.493879
          ],
          [
            19.118671,
            51.859237,
            172.049808
          ],
          [
            19.118643,
            51.858998,
            171.609947
          ],
          [
            19.118605,
            51.858766,
            171.360953
          ],
          [
            19.118577,
            51.85852,
            171.756066
          ],
          [
            19.118543,
            51.858275,
            172.150071
          ],
          [
            19.118502,
            51.858053,
            172.50804
          ],
          [
            19.118465,
            51.857807,
            172.903894
          ],
          [
            19.118414,
            51.857564,
            173.297079
          ],
          [
            19.11841,
            51.857374,
            173.60159
          ],
          [
            19.118378,
            51.857156,
            173.953998
          ],
          [
            19.118371,
            51.85689,
            174.144751
          ],
          [
            19.118345,
            51.856639,
            174.118825
          ],
          [
            19.118308,
            51.856394,
            174.093508
          ],
          [
            19.118305,
            51.856157,
            174.069063
          ],
          [
            19.118269,
            51.855913,
            174.043854
          ],
          [
            19.118228,
            51.85567,
            174.018716
          ],
          [
            19.118198,
            51.855429,
            173.993848
          ],
          [
            19.118141,
            51.855162,
            174.008841
          ],
          [
            19.11813,
            51.854942,
            174.109522
          ],
          [
            19.118103,
            51.85473,
            174.20681
          ],
          [
            19.11807,
            51.854498,
            174.313317
          ],
          [
            19.11804,
            51.854278,
            174.414295
          ],
          [
            19.118024,
            51.85409,
            174.500381
          ],
          [
            19.118021,
            51.853846,
            174.61211
          ],
          [
            19.118039,
            51.853633,
            174.710046
          ],
          [
            19.118185,
            51.853377,
            174.814904
          ],
          [
            19.118302,
            51.853211,
            174.855334
          ],
          [
            19.118495,
            51.853023,
            174.905022
          ],
          [
            19.11864,
            51.852855,
            174.947507
          ],
          [
            19.118827,
            51.852698,
            174.991008
          ],
          [
            19.118998,
            51.852506,
            175.040003
          ],
          [
            19.119218,
            51.852295,
            175.096007
          ],
          [
            19.119437,
            51.852076,
            175.153447
          ],
          [
            19.119639,
            51.851892,
            175.200594
          ],
          [
            19.119843,
            51.851708,
            175.225819
          ],
          [
            19.120035,
            51.851475,
            175.255418
          ],
          [
            19.12022,
            51.851287,
            175.280303
          ],
          [
            19.120407,
            51.851077,
            175.307414
          ],
          [
            19.120591,
            51.850867,
            175.334432
          ],
          [
            19.120684,
            51.850626,
            175.362464
          ],
          [
            19.120767,
            51.850422,
            175.386259
          ],
          [
            19.120874,
            51.850247,
            175.479643
          ],
          [
            19.120982,
            51.850046,
            175.78279
          ],
          [
            19.121047,
            51.849798,
            176.142957
          ],
          [
            19.120957,
            51.849584,
            176.460233
          ],
          [
            19.120769,
            51.849355,
            176.828733
          ],
          [
            19.120612,
            51.849197,
            177.094134
          ],
          [
            19.120447,
            51.849,
            177.412017
          ],
          [
            19.120286,
            51.848802,
            177.729188
          ],
          [
            19.120145,
            51.848637,
            177.985581
          ],
          [
            19.11999,
            51.848466,
            178.121212
          ],
          [
            19.119847,
            51.848298,
            178.252532
          ],
          [
            19.119719,
            51.848123,
            178.385404
          ],
          [
            19.119527,
            51.847896,
            178.562611
          ],
          [
            19.119354,
            51.847678,
            178.730926
          ],
          [
            19.11917,
            51.84746,
            178.901047
          ],
          [
            19.118966,
            51.84724,
            179.076596
          ],
          [
            19.118768,
            51.847001,
            179.212523
          ],
          [
            19.11858,
            51.846767,
            179.180822
          ],
          [
            19.118426,
            51.84658,
            179.155368
          ],
          [
            19.118229,
            51.846351,
            179.123888
          ],
          [
            19.118087,
            51.84618,
            179.100546
          ],
          [
            19.117897,
            51.845945,
            179.068649
          ],
          [
            19.1177,
            51.845721,
            179.037719
          ],
          [
            19.117557,
            51.845531,
            179.012292
          ],
          [
            19.117415,
            51.845339,
            178.824304
          ],
          [
            19.117239,
            51.845134,
            178.492762
          ],
          [
            19.117072,
            51.844942,
            178.18171
          ],
          [
            19.116939,
            51.844763,
            177.901049
          ],
          [
            19.116785,
            51.844568,
            177.591805
          ],
          [
            19.116658,
            51.844395,
            177.321086
          ],
          [
            19.11648,
            51.844199,
            177.000543
          ],
          [
            19.116303,
            51.844028,
            176.710586
          ],
          [
            19.116151,
            51.843866,
            176.443683
          ],
          [
            19.115974,
            51.843693,
            176.580467
          ],
          [
            19.115821,
            51.843497,
            176.733609
          ],
          [
            19.115669,
            51.843321,
            176.873877
          ],
          [
            19.11552,
            51.843132,
            177.021598
          ],
          [
            19.115353,
            51.842938,
            177.175991
          ],
          [
            19.115192,
            51.842774,
            177.31145
          ],
          [
            19.115021,
            51.842554,
            177.483171
          ],
          [
            19.114874,
            51.842366,
            177.629876
          ],
          [
            19.114707,
            51.842192,
            177.84015
          ],
          [
            19.114526,
            51.842016,
            178.130712
          ],
          [
            19.114376,
            51.84184,
            178.408121
          ],
          [
            19.114225,
            51.841651,
            178.70167
          ],
          [
            19.114029,
            51.841437,
            179.044125
          ],
          [
            19.113839,
            51.841243,
            179.360835
          ],
          [
            19.113653,
            51.841059,
            179.664125
          ],
          [
            19.11345,
            51.840829,
            180.028991
          ],
          [
            19.113275,
            51.840642,
            180.017959
          ],
          [
            19.113049,
            51.840435,
            179.477425
          ],
          [
            19.11284,
            51.840227,
            178.947466
          ],
          [
            19.112687,
            51.840062,
            178.535553
          ],
          [
            19.112534,
            51.839898,
            178.125684
          ],
          [
            19.112365,
            51.839731,
            177.699266
          ],
          [
            19.112196,
            51.839556,
            177.257596
          ],
          [
            19.112042,
            51.839375,
            176.814454
          ],
          [
            19.111859,
            51.839189,
            176.343187
          ],
          [
            19.111695,
            51.839021,
            175.797476
          ],
          [
            19.111538,
            51.838834,
            175.201113
          ],
          [
            19.11134,
            51.838627,
            174.520397
          ],
          [
            19.111141,
            51.838431,
            173.866754
          ],
          [
            19.110927,
            51.838241,
            173.212619
          ],
          [
            19.110764,
            51.838049,
            172.599496
          ],
          [
            19.110615,
            51.837867,
            172.023004
          ],
          [
            19.110457,
            51.837664,
            171.386659
          ],
          [
            19.110246,
            51.837481,
            170.940495
          ],
          [
            19.110086,
            51.837319,
            170.615237
          ],
          [
            19.10992,
            51.837127,
            170.238118
          ],
          [
            19.109726,
            51.836928,
            169.837295
          ],
          [
            19.109492,
            51.836697,
            169.369959
          ],
          [
            19.109291,
            51.836487,
            168.950933
          ],
          [
            19.109087,
            51.836242,
            168.478959
          ],
          [
            19.108881,
            51.836051,
            168.316885
          ],
          [
            19.108682,
            51.835843,
            169.291831
          ],
          [
            19.108484,
            51.835643,
            170.238537
          ],
          [
            19.108296,
            51.835445,
            171.164758
          ],
          [
            19.108104,
            51.835225,
            172.173263
          ],
          [
            19.107924,
            51.835013,
            173.139252
          ],
          [
            19.107739,
            51.834818,
            174.05187
          ],
          [
            19.10754,
            51.834617,
            175.002593
          ],
          [
            19.107349,
            51.834403,
            176.010562
          ],
          [
            19.107181,
            51.834184,
            177.025088
          ],
          [
            19.106977,
            51.833962,
            178.093347
          ],
          [
            19.106835,
            51.833765,
            179.01032
          ],
          [
            19.106667,
            51.833581,
            179.896267
          ],
          [
            19.106479,
            51.833381,
            180.864009
          ],
          [
            19.106292,
            51.833181,
            181.832638
          ],
          [
            19.106108,
            51.83299,
            182.762849
          ],
          [
            19.105883,
            51.832753,
            182.634096
          ],
          [
            19.105724,
            51.832574,
            182.371244
          ],
          [
            19.105552,
            51.832371,
            182.076416
          ],
          [
            19.105343,
            51.832156,
            181.754066
          ],
          [
            19.105113,
            51.831933,
            181.414024
          ],
          [
            19.104952,
            51.831768,
            181.166177
          ],
          [
            19.104808,
            51.831602,
            180.92319
          ],
          [
            19.104644,
            51.83142,
            180.6557
          ],
          [
            19.104502,
            51.831233,
            179.936792
          ],
          [
            19.104326,
            51.831055,
            179.153952
          ],
          [
            19.104111,
            51.830858,
            178.261873
          ],
          [
            19.103903,
            51.830659,
            177.3719
          ],
          [
            19.103721,
            51.830425,
            176.396589
          ],
          [
            19.103537,
            51.830224,
            175.529618
          ],
          [
            19.103359,
            51.83004,
            174.725043
          ],
          [
            19.103165,
            51.829856,
            173.900587
          ],
          [
            19.102952,
            51.829685,
            173.862402
          ],
          [
            19.102792,
            51.82951,
            173.848578
          ],
          [
            19.10263,
            51.829335,
            173.834748
          ],
          [
            19.102472,
            51.829149,
            173.820352
          ],
          [
            19.102307,
            51.828982,
            173.806947
          ],
          [
            19.102156,
            51.828809,
            173.793444
          ],
          [
            19.102011,
            51.8286,
            173.777811
          ],
          [
            19.101815,
            51.828421,
            173.762871
          ],
          [
            19.101626,
            51.828232,
            173.730771
          ],
          [
            19.101445,
            51.828002,
            173.66303
          ],
          [
            19.101256,
            51.827784,
            173.597523
          ],
          [
            19.101043,
            51.827576,
            173.532139
          ],
          [
            19.100895,
            51.827384,
            173.475797
          ],
          [
            19.100677,
            51.827157,
            173.40581
          ],
          [
            19.100473,
            51.826959,
            173.343632
          ],
          [
            19.100263,
            51.826759,
            173.280478
          ],
          [
            19.100088,
            51.826576,
            173.404796
          ],
          [
            19.099905,
            51.826379,
            173.549984
          ],
          [
            19.099759,
            51.826179,
            173.689903
          ],
          [
            19.099597,
            51.826019,
            173.810251
          ],
          [
            19.099452,
            51.825848,
            173.933323
          ],
          [
            19.099275,
            51.825666,
            174.068754
          ],
          [
            19.099086,
            51.825486,
            174.20572
          ],
          [
            19.098894,
            51.825281,
            174.356904
          ],
          [
            19.098718,
            51.825096,
            174.311288
          ],
          [
            19.098564,
            51.82493,
            174.115304
          ],
          [
            19.098346,
            51.824717,
            173.856621
          ],
          [
            19.09817,
            51.824496,
            173.60365
          ],
          [
            19.097938,
            51.824294,
            173.349632
          ],
          [
            19.097758,
            51.824101,
            173.121338
          ],
          [
            19.097602,
            51.823925,
            172.915521
          ],
          [
            19.097444,
            51.823742,
            172.702814
          ],
          [
            19.097258,
            51.823553,
            172.824596
          ],
          [
            19.097086,
            51.823361,
            173.342084
          ],
          [
            19.096899,
            51.823165,
            173.878626
          ],
          [
            19.096721,
            51.822974,
            174.398571
          ],
          [
            19.096539,
            51.822779,
            174.92938
          ],
          [
            19.096373,
            51.822599,
            175.418212
          ],
          [
            19.096207,
            51.822404,
            175.937757
          ],
          [
            19.096024,
            51.822209,
            176.469647
          ],
          [
            19.09584,
            51.822006,
            177.008827
          ],
          [
            19.095657,
            51.8218,
            177.536227
          ],
          [
            19.095468,
            51.821597,
            178.061704
          ],
          [
            19.095288,
            51.821406,
            178.55777
          ],
          [
            19.095099,
            51.821204,
            179.081286
          ],
          [
            19.09489,
            51.82098,
            179.661603
          ],
          [
            19.094694,
            51.820772,
            180.201655
          ],
          [
            19.094492,
            51.820561,
            180.752942
          ],
          [
            19.094298,
            51.820353,
            181.285199
          ],
          [
            19.094092,
            51.820147,
            181.820325
          ],
          [
            19.093892,
            51.819924,
            182.383731
          ],
          [
            19.093705,
            51.819732,
            182.879008
          ],
          [
            19.093497,
            51.819512,
            183.442038
          ],
          [
            19.093321,
            51.819336,
            183.899224
          ],
          [
            19.093159,
            51.819133,
            184.400598
          ],
          [
            19.092947,
            51.818917,
            184.725184
          ],
          [
            19.092792,
            51.818756,
            184.378264
          ],
          [
            19.092603,
            51.818602,
            184.020208
          ],
          [
            19.092441,
            51.818428,
            183.645869
          ],
          [
            19.092286,
            51.818225,
            183.231316
          ],
          [
            19.092104,
            51.818034,
            182.821899
          ],
          [
            19.091873,
            51.817828,
            182.357104
          ],
          [
            19.091665,
            51.817575,
            181.833454
          ],
          [
            19.091462,
            51.817334,
            181.474281
          ],
          [
            19.091273,
            51.81714,
            181.384792
          ],
          [
            19.091053,
            51.816924,
            181.283967
          ],
          [
            19.090879,
            51.816722,
            181.19362
          ],
          [
            19.090705,
            51.816508,
            181.099014
          ],
          [
            19.090515,
            51.816294,
            181.002616
          ],
          [
            19.090309,
            51.81607,
            180.900831
          ],
          [
            19.090121,
            51.81587,
            180.809519
          ],
          [
            19.08995,
            51.815644,
            181.548393
          ],
          [
            19.089736,
            51.81545,
            182.299459
          ],
          [
            19.089558,
            51.815246,
            183.040195
          ],
          [
            19.08939,
            51.815071,
            183.690678
          ],
          [
            19.089166,
            51.81486,
            184.49706
          ],
          [
            19.088996,
            51.814679,
            185.174424
          ],
          [
            19.088821,
            51.814471,
            185.924978
          ],
          [
            19.088643,
            51.814292,
            186.556097
          ],
          [
            19.088448,
            51.814084,
            186.657792
          ],
          [
            19.088251,
            51.813879,
            186.758155
          ],
          [
            19.088079,
            51.813695,
            186.847552
          ],
          [
            19.087904,
            51.813495,
            186.943201
          ],
          [
            19.087719,
            51.813295,
            187.040232
          ],
          [
            19.087535,
            51.813106,
            187.133025
          ],
          [
            19.087378,
            51.812899,
            187.229194
          ],
          [
            19.087209,
            51.812705,
            187.274617
          ],
          [
            19.087022,
            51.812527,
            187.100514
          ],
          [
            19.086822,
            51.812332,
            186.91224
          ],
          [
            19.086643,
            51.812129,
            186.723642
          ],
          [
            19.08642,
            51.811906,
            186.509861
          ],
          [
            19.086203,
            51.811682,
            186.296929
          ],
          [
            19.085987,
            51.811471,
            186.09331
          ],
          [
            19.085845,
            51.811302,
            185.93769
          ],
          [
            19.08562,
            51.811081,
            185.835654
          ],
          [
            19.08545,
            51.810881,
            185.829737
          ],
          [
            19.085232,
            51.810689,
            185.823592
          ],
          [
            19.08502,
            51.81047,
            185.816918
          ],
          [
            19.084878,
            51.810301,
            185.811929
          ],
          [
            19.084728,
            51.810146,
            185.807206
          ],
          [
            19.084555,
            51.809962,
            185.801637
          ],
          [
            19.084358,
            51.809766,
            185.795586
          ],
          [
            19.084207,
            51.809573,
            185.759278
          ],
          [
            19.084028,
            51.809374,
            185.674761
          ],
          [
            19.08382,
            51.809176,
            185.587225
          ],
          [
            19.083635,
            51.808952,
            185.493962
          ],
          [
            19.083434,
            51.808737,
            185.401715
          ],
          [
            19.083248,
            51.808536,
            185.315856
          ],
          [
            19.083063,
            51.808333,
            185.22945
          ],
          [
            19.082879,
            51.808149,
            185.149171
          ],
          [
            19.082707,
            51.807969,
            185.240958
          ],
          [
            19.082517,
            51.807769,
            185.424995
          ],
          [
            19.082337,
            51.807578,
            185.601457
          ],
          [
            19.082132,
            51.807372,
            185.79365
          ],
          [
            19.081927,
            51.807173,
            185.98147
          ],
          [
            19.081742,
            51.806977,
            186.161565
          ],
          [
            19.081538,
            51.806775,
            186.350536
          ],
          [
            19.081361,
            51.806593,
            186.519063
          ],
          [
            19.081211,
            51.806402,
            186.588617
          ],
          [
            19.081071,
            51.806222,
            186.63093
          ],
          [
            19.080876,
            51.80604,
            186.677255
          ],
          [
            19.080701,
            51.805842,
            186.725049
          ],
          [
            19.080541,
            51.805637,
            186.773264
          ],
          [
            19.080337,
            51.805429,
            186.824913
          ],
          [
            19.080127,
            51.805223,
            186.876493
          ],
          [
            19.079938,
            51.805022,
            186.925802
          ],
          [
            19.079799,
            51.804844,
            187.205752
          ],
          [
            19.079626,
            51.804644,
            187.58928
          ],
          [
            19.079433,
            51.804433,
            188.000046
          ],
          [
            19.07921,
            51.804214,
            188.438126
          ],
          [
            19.079067,
            51.803973,
            188.874034
          ],
          [
            19.078862,
            51.80379,
            189.251682
          ],
          [
            19.078671,
            51.803597,
            189.634906
          ],
          [
            19.078478,
            51.803434,
            189.969047
          ],
          [
            19.078333,
            51.803256,
            189.526895
          ],
          [
            19.078187,
            51.803075,
            189.078506
          ],
          [
            19.078036,
            51.802869,
            188.576505
          ],
          [
            19.077835,
            51.802705,
            188.120275
          ],
          [
            19.077592,
            51.802505,
            187.565135
          ],
          [
            19.077422,
            51.802275,
            187.001525
          ],
          [
            19.077273,
            51.802091,
            186.545315
          ],
          [
            19.077081,
            51.801891,
            186.02951
          ],
          [
            19.076935,
            51.801721,
            185.945456
          ],
          [
            19.076774,
            51.801514,
            185.891361
          ],
          [
            19.076569,
            51.801342,
            185.840913
          ],
          [
            19.076429,
            51.801177,
            185.796963
          ],
          [
            19.07625,
            51.800971,
            185.741894
          ],
          [
            19.076094,
            51.800819,
            185.699477
          ],
          [
            19.075926,
            51.800627,
            185.648051
          ],
          [
            19.07578,
            51.800447,
            185.600568
          ],
          [
            19.075624,
            51.800273,
            185.618817
          ],
          [
            19.075424,
            51.800086,
            185.944509
          ],
          [
            19.075262,
            51.799905,
            186.245254
          ],
          [
            19.075108,
            51.799726,
            186.5404
          ],
          [
            19.074963,
            51.799521,
            186.865457
          ],
          [
            19.074828,
            51.799311,
            187.195517
          ],
          [
            19.074666,
            51.799143,
            187.480069
          ],
          [
            19.074493,
            51.79895,
            187.800814
          ],
          [
            19.074299,
            51.798744,
            188.147651
          ],
          [
            19.074124,
            51.798568,
            188.000775
          ],
          [
            19.073939,
            51.798359,
            187.778715
          ],
          [
            19.073775,
            51.79819,
            187.59516
          ],
          [
            19.073576,
            51.797977,
            187.365973
          ],
          [
            19.073389,
            51.797799,
            187.167248
          ],
          [
            19.073242,
            51.79764,
            186.996077
          ],
          [
            19.07311,
            51.797466,
            186.817015
          ],
          [
            19.072963,
            51.797301,
            186.641578
          ],
          [
            19.07279,
            51.797093,
            186.497771
          ],
          [
            19.072627,
            51.796896,
            186.489894
          ],
          [
            19.07248,
            51.796736,
            186.483327
          ],
          [
            19.072257,
            51.796494,
            186.473374
          ],
          [
            19.072097,
            51.79632,
            186.466251
          ],
          [
            19.071878,
            51.796073,
            186.456224
          ],
          [
            19.07173,
            51.795906,
            186.449442
          ],
          [
            19.071572,
            51.795732,
            186.442325
          ],
          [
            19.071403,
            51.795554,
            186.472827
          ],
          [
            19.071239,
            51.795384,
            186.619434
          ],
          [
            19.071095,
            51.795205,
            186.767866
          ],
          [
            19.070929,
            51.795038,
            186.91342
          ],
          [
            19.070785,
            51.794868,
            187.055585
          ],
          [
            19.070614,
            51.794675,
            187.218565
          ],
          [
            19.07042,
            51.794497,
            187.377662
          ],
          [
            19.070257,
            51.794293,
            187.546994
          ],
          [
            19.070079,
            51.794094,
            187.715439
          ],
          [
            19.069894,
            51.793869,
            187.863796
          ],
          [
            19.069694,
            51.793674,
            187.985679
          ],
          [
            19.069498,
            51.793443,
            188.123096
          ],
          [
            19.06933,
            51.79324,
            188.243302
          ],
          [
            19.069113,
            51.793007,
            188.385073
          ],
          [
            19.068945,
            51.792816,
            188.499707
          ],
          [
            19.068749,
            51.792599,
            188.630663
          ],
          [
            19.068559,
            51.792379,
            188.617255
          ],
          [
            19.068386,
            51.792183,
            188.367407
          ],
          [
            19.068182,
            51.791995,
            188.114043
          ],
          [
            19.068003,
            51.79179,
            187.853364
          ],
          [
            19.067831,
            51.791588,
            187.597731
          ],
          [
            19.067652,
            51.791394,
            187.347817
          ],
          [
            19.067448,
            51.791175,
            187.065008
          ],
          [
            19.067295,
            51.791016,
            186.857933
          ],
          [
            19.06716,
            51.790855,
            186.669968
          ],
          [
            19.06696,
            51.790637,
            186.475868
          ],
          [
            19.066761,
            51.790401,
            186.269684
          ],
          [
            19.066568,
            51.790221,
            186.102115
          ],
          [
            19.066375,
            51.790015,
            185.917031
          ],
          [
            19.066237,
            51.78984,
            185.766231
          ],
          [
            19.066062,
            51.789645,
            185.593496
          ],
          [
            19.065917,
            51.789456,
            185.431485
          ],
          [
            19.065781,
            51.78929,
            185.29551
          ],
          [
            19.065582,
            51.789089,
            185.176272
          ],
          [
            19.0654,
            51.78888,
            185.05616
          ],
          [
            19.065229,
            51.78872,
            184.959124
          ],
          [
            19.065089,
            51.788549,
            184.862157
          ],
          [
            19.064939,
            51.788376,
            184.762846
          ],
          [
            19.064775,
            51.788211,
            184.664559
          ],
          [
            19.064603,
            51.788029,
            184.557878
          ],
          [
            19.064466,
            51.787856,
            184.460353
          ],
          [
            19.064275,
            51.787664,
            184.186426
          ],
          [
            19.064075,
            51.787435,
            183.672338
          ],
          [
            19.063951,
            51.787254,
            183.284109
          ],
          [
            19.063797,
            51.787075,
            182.883833
          ],
          [
            19.063648,
            51.786891,
            182.477254
          ],
          [
            19.063465,
            51.786705,
            182.047404
          ],
          [
            19.063324,
            51.786536,
            181.665009
          ],
          [
            19.063175,
            51.786336,
            181.228066
          ],
          [
            19.062998,
            51.78615,
            180.749054
          ],
          [
            19.062884,
            51.785961,
            179.922195
          ],
          [
            19.062765,
            51.785714,
            178.865509
          ],
          [
            19.062704,
            51.785476,
            177.877825
          ],
          [
            19.062636,
            51.785186,
            176.67674
          ],
          [
            19.062593,
            51.78489,
            175.458677
          ],
          [
            19.062589,
            51.784598,
            174.262272
          ],
          [
            19.062556,
            51.78433,
            173.412467
          ],
          [
            19.062559,
            51.784081,
            173.191675
          ],
          [
            19.062572,
            51.783857,
            172.993576
          ],
          [
            19.062584,
            51.783618,
            172.782259
          ],
          [
            19.062605,
            51.783406,
            172.594554
          ],
          [
            19.062642,
            51.783193,
            172.405233
          ],
          [
            19.062705,
            51.782995,
            172.226821
          ],
          [
            19.062767,
            51.782816,
            172.065019
          ],
          [
            19.062837,
            51.782564,
            172.009721
          ],
          [
            19.062919,
            51.78235,
            172.439331
          ],
          [
            19.062757,
            51.782257,
            172.810147
          ],
          [
            19.062869,
            51.782347,
            173.235248
          ],
          [
            19.062912,
            51.782345,
            173.613271
          ],
          [
            19.062781,
            51.782232,
            174.040436
          ],
          [
            19.062524,
            51.782303,
            174.404803
          ],
          [
            19.062801,
            51.782233,
            174.766765
          ],
          [
            19.062995,
            51.782066,
            175.193415
          ],
          [
            19.06307,
            51.781846,
            175.370427
          ],
          [
            19.063155,
            51.781652,
            175.324909
          ],
          [
            19.063222,
            51.78144,
            175.275989
          ],
          [
            19.063299,
            51.78122,
            175.225014
          ],
          [
            19.063368,
            51.780988,
            175.171589
          ],
          [
            19.063426,
            51.780764,
            175.120196
          ],
          [
            19.063514,
            51.780522,
            175.063995
          ],
          [
            19.0636,
            51.780287,
            175.009406
          ],
          [
            19.063681,
            51.780035,
            174.986388
          ],
          [
            19.063739,
            51.779787,
            174.980642
          ],
          [
            19.063831,
            51.779544,
            174.974923
          ],
          [
            19.063898,
            51.779316,
            174.969611
          ],
          [
            19.063978,
            51.779081,
            174.964107
          ],
          [
            19.064064,
            51.778845,
            174.958561
          ],
          [
            19.064137,
            51.778627,
            174.953458
          ],
          [
            19.064215,
            51.778426,
            174.941116
          ],
          [
            19.064329,
            51.778223,
            174.855449
          ],
          [
            19.064388,
            51.778024,
            174.774418
          ],
          [
            19.064426,
            51.7778,
            174.684763
          ],
          [
            19.064504,
            51.777575,
            174.593164
          ],
          [
            19.064566,
            51.777371,
            174.510483
          ],
          [
            19.064649,
            51.777145,
            174.41817
          ],
          [
            19.064725,
            51.77691,
            174.322624
          ],
          [
            19.064782,
            51.776685,
            174.226739
          ],
          [
            19.064835,
            51.776472,
            173.775975
          ],
          [
            19.064872,
            51.77628,
            173.371571
          ],
          [
            19.065137,
            51.776171,
            172.919981
          ],
          [
            19.065465,
            51.776153,
            172.493379
          ],
          [
            19.065778,
            51.776113,
            172.079477
          ],
          [
            19.066099,
            51.776025,
            171.621642
          ],
          [
            19.06645,
            51.775999,
            171.160473
          ],
          [
            19.0668,
            51.776002,
            170.706165
          ],
          [
            19.06709,
            51.775959,
            170.726377
          ],
          [
            19.067425,
            51.775874,
            171.508032
          ],
          [
            19.067715,
            51.775788,
            172.206085
          ],
          [
            19.068002,
            51.77571,
            172.889741
          ],
          [
            19.06832,
            51.775614,
            173.656398
          ],
          [
            19.068587,
            51.775506,
            174.344872
          ],
          [
            19.068892,
            51.775412,
            175.081877
          ],
          [
            19.069208,
            51.775335,
            175.820819
          ],
          [
            19.069554,
            51.775229,
            176.653884
          ],
          [
            19.069854,
            51.775101,
            176.645638
          ],
          [
            19.070135,
            51.774985,
            176.543772
          ],
          [
            19.07052,
            51.774878,
            176.416052
          ],
          [
            19.070822,
            51.774786,
            176.314584
          ],
          [
            19.071138,
            51.774661,
            176.201405
          ],
          [
            19.071447,
            51.774571,
            176.098454
          ],
          [
            19.071757,
            51.774465,
            175.991642
          ],
          [
            19.072045,
            51.77438,
            175.895427
          ],
          [
            19.072336,
            51.774272,
            174.920576
          ],
          [
            19.072656,
            51.77414,
            173.443784
          ],
          [
            19.072901,
            51.773937,
            171.828174
          ],
          [
            19.073086,
            51.773736,
            170.391556
          ],
          [
            19.073284,
            51.773562,
            169.071831
          ],
          [
            19.073447,
            51.773393,
            167.849411
          ],
          [
            19.07365,
            51.773222,
            166.533105
          ],
          [
            19.073822,
            51.773037,
            165.210034
          ],
          [
            19.074006,
            51.772866,
            164.711038
          ],
          [
            19.074213,
            51.77269,
            164.698974
          ],
          [
            19.074418,
            51.77252,
            164.687221
          ],
          [
            19.074609,
            51.77234,
            164.675304
          ],
          [
            19.07477,
            51.772158,
            164.663815
          ],
          [
            19.07501,
            51.771973,
            164.650684
          ],
          [
            19.075227,
            51.771787,
            164.637988
          ],
          [
            19.075387,
            51.771596,
            164.626077
          ],
          [
            19.07555,
            51.771395,
            165.034482
          ],
          [
            19.075729,
            51.771198,
            166.105631
          ],
          [
            19.075915,
            51.771014,
            167.132723
          ],
          [
            19.07608,
            51.77084,
            168.087738
          ],
          [
            19.07628,
            51.770648,
            169.170375
          ],
          [
            19.076469,
            51.770433,
            170.328769
          ],
          [
            19.076647,
            51.770246,
            171.355878
          ],
          [
            19.076822,
            51.770075,
            172.313933
          ],
          [
            19.077017,
            51.769847,
            173.386151
          ],
          [
            19.077199,
            51.769641,
            174.087327
          ],
          [
            19.077432,
            51.769446,
            174.81176
          ],
          [
            19.077595,
            51.769243,
            175.488623
          ],
          [
            19.077776,
            51.769043,
            176.173341
          ],
          [
            19.077958,
            51.768854,
            176.830241
          ],
          [
            19.078157,
            51.768678,
            177.471552
          ],
          [
            19.078361,
            51.768496,
            178.132804
          ],
          [
            19.078538,
            51.768309,
            178.511479
          ],
          [
            19.078693,
            51.768126,
            178.537073
          ],
          [
            19.078846,
            51.767942,
            178.562705
          ],
          [
            19.079048,
            51.76774,
            178.592125
          ],
          [
            19.079302,
            51.767537,
            178.62392
          ],
          [
            19.079532,
            51.767329,
            178.655111
          ],
          [
            19.079727,
            51.767133,
            178.6836
          ],
          [
            19.079931,
            51.766934,
            178.712767
          ],
          [
            19.080145,
            51.766729,
            178.750424
          ],
          [
            19.080348,
            51.766529,
            178.790273
          ],
          [
            19.080526,
            51.766356,
            178.824873
          ],
          [
            19.080714,
            51.766163,
            178.862893
          ],
          [
            19.080926,
            51.765985,
            178.900199
          ],
          [
            19.081082,
            51.765805,
            178.934675
          ],
          [
            19.081249,
            51.765637,
            178.967952
          ],
          [
            19.081448,
            51.765454,
            179.005165
          ],
          [
            19.081658,
            51.765266,
            179.263973
          ],
          [
            19.081847,
            51.765059,
            179.799767
          ],
          [
            19.082025,
            51.764863,
            180.305921
          ],
          [
            19.082227,
            51.76467,
            180.823693
          ],
          [
            19.082417,
            51.764467,
            181.352313
          ],
          [
            19.08263,
            51.764278,
            181.871112
          ],
          [
            19.082849,
            51.764087,
            182.399208
          ],
          [
            19.083026,
            51.763903,
            182.881283
          ],
          [
            19.083208,
            51.76371,
            183.069257
          ],
          [
            19.083385,
            51.763538,
            183.060768
          ],
          [
            19.083557,
            51.763366,
            183.052344
          ],
          [
            19.083774,
            51.763191,
            183.043162
          ],
          [
            19.08396,
            51.763002,
            183.033952
          ],
          [
            19.084184,
            51.762804,
            183.023892
          ],
          [
            19.084395,
            51.762611,
            183.014192
          ],
          [
            19.084616,
            51.762439,
            183.005045
          ],
          [
            19.084789,
            51.762274,
            182.831691
          ],
          [
            19.084997,
            51.762096,
            182.359383
          ],
          [
            19.085207,
            51.761909,
            181.869805
          ],
          [
            19.085425,
            51.76174,
            181.404097
          ],
          [
            19.085611,
            51.761569,
            180.960818
          ],
          [
            19.085812,
            51.761392,
            180.495726
          ],
          [
            19.086024,
            51.76119,
            179.977885
          ],
          [
            19.086233,
            51.760995,
            179.474793
          ],
          [
            19.086456,
            51.760819,
            179.164422
          ],
          [
            19.086669,
            51.760636,
            179.271983
          ],
          [
            19.086916,
            51.760485,
            179.374625
          ],
          [
            19.087228,
            51.760371,
            179.481769
          ],
          [
            19.087551,
            51.760252,
            179.592808
          ],
          [
            19.087873,
            51.760142,
            179.701351
          ],
          [
            19.088196,
            51.760041,
            179.80816
          ],
          [
            19.088496,
            51.759952,
            179.906331
          ],
          [
            19.088811,
            51.759865,
            180.04202
          ],
          [
            19.089139,
            51.759773,
            180.358119
          ],
          [
            19.089481,
            51.759673,
            180.690126
          ],
          [
            19.089853,
            51.759565,
            181.050865
          ],
          [
            19.090227,
            51.759445,
            181.420653
          ],
          [
            19.09057,
            51.759296,
            181.788648
          ],
          [
            19.090849,
            51.759145,
            182.114209
          ],
          [
            19.091114,
            51.759009,
            182.416775
          ],
          [
            19.091454,
            51.758849,
            182.48469
          ],
          [
            19.091734,
            51.758725,
            182.41584
          ],
          [
            19.092068,
            51.758591,
            182.336292
          ],
          [
            19.092418,
            51.758462,
            182.25488
          ],
          [
            19.092766,
            51.758342,
            182.175264
          ],
          [
            19.093131,
            51.75821,
            182.090745
          ],
          [
            19.093492,
            51.758073,
            182.006111
          ],
          [
            19.093854,
            51.757967,
            181.994564
          ],
          [
            19.09416,
            51.757851,
            182.064157
          ],
          [
            19.094495,
            51.757741,
            182.137531
          ],
          [
            19.094763,
            51.757645,
            182.19742
          ],
          [
            19.095146,
            51.757517,
            182.281598
          ],
          [
            19.095454,
            51.757406,
            182.350526
          ],
          [
            19.095729,
            51.757319,
            182.410309
          ],
          [
            19.095999,
            51.757232,
            182.469186
          ],
          [
            19.096324,
            51.757137,
            182.530072
          ],
          [
            19.096612,
            51.757095,
            182.556196
          ],
          [
            19.096895,
            51.757042,
            182.582265
          ],
          [
            19.097255,
            51.756984,
            182.615379
          ],
          [
            19.097637,
            51.756934,
            182.64985
          ],
          [
            19.097931,
            51.756892,
            182.676447
          ],
          [
            19.098305,
            51.756832,
            182.710521
          ],
          [
            19.0987,
            51.756775,
            182.746283
          ],
          [
            19.099073,
            51.756721,
            182.769711
          ],
          [
            19.099436,
            51.756654,
            182.504529
          ],
          [
            19.099803,
            51.75658,
            182.234376
          ],
          [
            19.100174,
            51.756515,
            181.96447
          ],
          [
            19.100505,
            51.756446,
            181.720185
          ],
          [
            19.100887,
            51.756375,
            181.440039
          ],
          [
            19.101237,
            51.756323,
            181.188305
          ],
          [
            19.101636,
            51.756248,
            180.896745
          ],
          [
            19.102041,
            51.756176,
            180.859083
          ],
          [
            19.102435,
            51.756091,
            181.08374
          ],
          [
            19.102774,
            51.756022,
            181.275742
          ],
          [
            19.103115,
            51.755955,
            181.468235
          ],
          [
            19.103516,
            51.75586,
            181.699648
          ],
          [
            19.103876,
            51.755727,
            181.925599
          ],
          [
            19.104234,
            51.755587,
            182.153438
          ],
          [
            19.104538,
            51.755444,
            182.257679
          ],
          [
            19.1049,
            51.755298,
            182.002972
          ],
          [
            19.105229,
            51.755166,
            181.771681
          ],
          [
            19.105565,
            51.755008,
            181.523008
          ],
          [
            19.105845,
            51.754897,
            181.326397
          ],
          [
            19.106175,
            51.754757,
            181.0907
          ],
          [
            19.106508,
            51.754639,
            180.864154
          ],
          [
            19.106813,
            51.754519,
            180.651161
          ],
          [
            19.107108,
            51.754406,
            180.763038
          ],
          [
            19.10735,
            51.754294,
            180.954562
          ],
          [
            19.107649,
            51.754169,
            181.183317
          ],
          [
            19.107978,
            51.754046,
            181.426949
          ],
          [
            19.108299,
            51.753916,
            181.670086
          ],
          [
            19.108551,
            51.753822,
            181.856578
          ],
          [
            19.108824,
            51.753714,
            182.062119
          ],
          [
            19.109119,
            51.753578,
            182.295257
          ],
          [
            19.109419,
            51.753466,
            182.46638
          ],
          [
            19.109676,
            51.753357,
            182.532847
          ],
          [
            19.109922,
            51.753239,
            182.599145
          ],
          [
            19.110228,
            51.753112,
            182.677669
          ],
          [
            19.110519,
            51.752971,
            182.756379
          ],
          [
            19.110764,
            51.75287,
            182.819152
          ],
          [
            19.111025,
            51.752773,
            182.884136
          ],
          [
            19.11134,
            51.752631,
            182.967116
          ],
          [
            19.111607,
            51.75253,
            183.033739
          ],
          [
            19.11187,
            51.752425,
            183.299629
          ],
          [
            19.112196,
            51.752298,
            183.776991
          ],
          [
            19.112451,
            51.752181,
            184.170284
          ],
          [
            19.112716,
            51.752082,
            184.554082
          ],
          [
            19.113019,
            51.751946,
            185.017961
          ],
          [
            19.113322,
            51.751818,
            185.473168
          ],
          [
            19.113577,
            51.751705,
            185.861853
          ],
          [
            19.113876,
            51.751589,
            186.299201
          ],
          [
            19.114197,
            51.751466,
            186.644833
          ],
          [
            19.114462,
            51.751339,
            186.590086
          ],
          [
            19.114715,
            51.751232,
            186.540143
          ],
          [
            19.115028,
            51.751137,
            186.483395
          ],
          [
            19.115325,
            51.751002,
            186.423408
          ],
          [
            19.115601,
            51.750883,
            186.368096
          ],
          [
            19.115912,
            51.750737,
            186.304277
          ],
          [
            19.116243,
            51.750571,
            186.234929
          ],
          [
            19.116516,
            51.750393,
            186.183441
          ],
          [
            19.116692,
            51.750178,
            186.172932
          ],
          [
            19.116767,
            51.749962,
            186.163313
          ],
          [
            19.116868,
            51.749776,
            186.154774
          ],
          [
            19.116984,
            51.749554,
            186.14462
          ],
          [
            19.117089,
            51.749316,
            186.133883
          ],
          [
            19.117188,
            51.749102,
            186.124196
          ],
          [
            19.117261,
            51.748876,
            186.114165
          ],
          [
            19.11739,
            51.748636,
            186.188453
          ],
          [
            19.117517,
            51.748393,
            186.382134
          ],
          [
            19.117639,
            51.748137,
            186.584517
          ],
          [
            19.117758,
            51.747891,
            186.779648
          ],
          [
            19.117876,
            51.747633,
            186.982956
          ],
          [
            19.117959,
            51.747456,
            187.122673
          ],
          [
            19.118049,
            51.747249,
            187.285177
          ],
          [
            19.118148,
            51.747022,
            187.463446
          ],
          [
            19.118226,
            51.746833,
            187.383918
          ],
          [
            19.118334,
            51.746615,
            187.276171
          ],
          [
            19.118408,
            51.746422,
            187.182429
          ],
          [
            19.118492,
            51.746234,
            187.090295
          ],
          [
            19.118597,
            51.745987,
            186.969167
          ],
          [
            19.118693,
            51.745747,
            186.852264
          ],
          [
            19.118813,
            51.745508,
            186.734028
          ],
          [
            19.118967,
            51.74527,
            186.636778
          ],
          [
            19.119117,
            51.745082,
            186.801268
          ],
          [
            19.119265,
            51.744907,
            186.956455
          ],
          [
            19.119414,
            51.744743,
            187.104073
          ],
          [
            19.119571,
            51.744539,
            187.281775
          ],
          [
            19.119791,
            51.744269,
            187.521849
          ],
          [
            19.120189,
            51.744262,
            187.715564
          ],
          [
            19.120497,
            51.744254,
            187.865375
          ],
          [
            19.120516,
            51.744337,
            188.018179
          ],
          [
            19.120156,
            51.744309,
            188.064753
          ],
          [
            19.119841,
            51.744239,
            188.097011
          ],
          [
            19.119548,
            51.744182,
            188.12668
          ],
          [
            19.119255,
            51.744092,
            188.158264
          ],
          [
            19.118999,
            51.743997,
            188.187005
          ],
          [
            19.119004,
            51.74399,
            188.217954
          ],
          [
            19.118816,
            51.743832,
            188.249422
          ],
          [
            19.118846,
            51.743818,
            188.285831
          ],
          [
            19.119129,
            51.743922,
            188.360016
          ],
          [
            19.119429,
            51.74403,
            188.6685
          ],
          [
            19.119737,
            51.744136,
            188.981715
          ],
          [
            19.120054,
            51.744178,
            189.279438
          ],
          [
            19.120327,
            51.744004,
            189.628263
          ],
          [
            19.120601,
            51.743828,
            189.979148
          ],
          [
            19.120877,
            51.743663,
            190.320157
          ],
          [
            19.121177,
            51.743507,
            190.668493
          ],
          [
            19.121393,
            51.743373,
            190.882408
          ],
          [
            19.121617,
            51.743234,
            190.811218
          ],
          [
            19.121891,
            51.74307,
            190.725674
          ],
          [
            19.122115,
            51.742937,
            190.656004
          ],
          [
            19.122301,
            51.742784,
            190.586569
          ],
          [
            19.122494,
            51.742637,
            190.517836
          ],
          [
            19.122739,
            51.74245,
            190.430539
          ],
          [
            19.122944,
            51.742293,
            190.357256
          ],
          [
            19.123139,
            51.742124,
            190.281947
          ],
          [
            19.123348,
            51.741969,
            190.282939
          ],
          [
            19.123566,
            51.741821,
            190.371963
          ],
          [
            19.123759,
            51.741659,
            190.461415
          ],
          [
            19.123955,
            51.741495,
            190.552085
          ],
          [
            19.124096,
            51.741293,
            190.649914
          ],
          [
            19.124253,
            51.741093,
            190.748793
          ],
          [
            19.124406,
            51.74089,
            190.848341
          ],
          [
            19.12454,
            51.740718,
            190.933211
          ],
          [
            19.124692,
            51.740504,
            191.03715
          ],
          [
            19.124833,
            51.740333,
            190.887843
          ],
          [
            19.12496,
            51.740147,
            190.718358
          ],
          [
            19.125112,
            51.739893,
            190.490938
          ],
          [
            19.125258,
            51.739697,
            190.309724
          ],
          [
            19.125439,
            51.73947,
            190.096891
          ],
          [
            19.125636,
            51.739255,
            189.889423
          ],
          [
            19.125844,
            51.739073,
            189.702175
          ],
          [
            19.126096,
            51.738872,
            189.528016
          ],
          [
            19.126369,
            51.738674,
            189.509355
          ],
          [
            19.126588,
            51.738542,
            189.495794
          ],
          [
            19.126874,
            51.738337,
            189.47638
          ],
          [
            19.127116,
            51.738174,
            189.460513
          ],
          [
            19.127326,
            51.738023,
            189.446226
          ],
          [
            19.127559,
            51.737866,
            189.430928
          ],
          [
            19.12782,
            51.737686,
            189.413586
          ],
          [
            19.128046,
            51.737522,
            189.389443
          ],
          [
            19.128252,
            51.737359,
            189.347081
          ],
          [
            19.128462,
            51.737182,
            189.302128
          ],
          [
            19.128666,
            51.736991,
            189.255228
          ],
          [
            19.128872,
            51.736817,
            189.211051
          ],
          [
            19.129093,
            51.736623,
            189.162432
          ],
          [
            19.129264,
            51.736461,
            189.122821
          ],
          [
            19.129427,
            51.736266,
            189.077784
          ],
          [
            19.129631,
            51.736093,
            189.036954
          ],
          [
            19.129826,
            51.735896,
            189.175839
          ],
          [
            19.130047,
            51.735687,
            189.326064
          ],
          [
            19.130194,
            51.735476,
            189.464173
          ],
          [
            19.130374,
            51.735277,
            189.601261
          ],
          [
            19.130557,
            51.735083,
            189.736334
          ],
          [
            19.130767,
            51.734859,
            189.892312
          ],
          [
            19.130913,
            51.73468,
            190.012934
          ],
          [
            19.131077,
            51.7345,
            190.102171
          ],
          [
            19.131235,
            51.734326,
            190.028584
          ],
          [
            19.131438,
            51.734134,
            189.943987
          ],
          [
            19.131589,
            51.733926,
            189.859931
          ],
          [
            19.13174,
            51.733756,
            189.78841
          ],
          [
            19.131917,
            51.733587,
            189.714131
          ],
          [
            19.132094,
            51.733413,
            189.638315
          ],
          [
            19.132277,
            51.733245,
            189.5636
          ],
          [
            19.132449,
            51.733095,
            189.495784
          ],
          [
            19.132645,
            51.732898,
            189.599096
          ],
          [
            19.132799,
            51.732732,
            189.843347
          ],
          [
            19.132951,
            51.732553,
            190.101556
          ],
          [
            19.133089,
            51.732387,
            190.339732
          ],
          [
            19.133252,
            51.732212,
            190.597461
          ],
          [
            19.133393,
            51.732041,
            190.843286
          ],
          [
            19.133538,
            51.731879,
            191.079568
          ],
          [
            19.133662,
            51.731712,
            191.314052
          ],
          [
            19.133837,
            51.731508,
            191.610003
          ],
          [
            19.13401,
            51.731314,
            191.866526
          ],
          [
            19.134212,
            51.731098,
            192.127287
          ],
          [
            19.134396,
            51.730919,
            192.349506
          ],
          [
            19.134603,
            51.730749,
            192.571984
          ],
          [
            19.134802,
            51.730562,
            192.809387
          ],
          [
            19.135009,
            51.730378,
            193.04365
          ],
          [
            19.13522,
            51.730191,
            193.282132
          ],
          [
            19.1355,
            51.730008,
            193.545892
          ],
          [
            19.135752,
            51.729817,
            193.720688
          ],
          [
            19.135975,
            51.729626,
            193.851603
          ],
          [
            19.136195,
            51.729422,
            193.987913
          ],
          [
            19.136379,
            51.729243,
            194.105737
          ],
          [
            19.136577,
            51.729078,
            194.219864
          ],
          [
            19.13674,
            51.728915,
            194.326363
          ],
          [
            19.136973,
            51.728725,
            194.458817
          ],
          [
            19.137225,
            51.72854,
            194.59325
          ],
          [
            19.137438,
            51.728354,
            194.589117
          ],
          [
            19.137676,
            51.728153,
            194.538048
          ],
          [
            19.137903,
            51.727978,
            194.492061
          ],
          [
            19.13809,
            51.727802,
            194.448861
          ],
          [
            19.138277,
            51.727624,
            194.405347
          ],
          [
            19.138496,
            51.727432,
            194.357184
          ],
          [
            19.138711,
            51.727242,
            194.309648
          ],
          [
            19.138907,
            51.727091,
            194.269958
          ],
          [
            19.13866,
            51.7271,
            193.942221
          ],
          [
            19.138401,
            51.726901,
            193.337111
          ],
          [
            19.138109,
            51.726722,
            192.734688
          ],
          [
            19.137847,
            51.726551,
            192.176436
          ],
          [
            19.137581,
            51.72641,
            191.663017
          ],
          [
            19.137225,
            51.726334,
            191.059363
          ],
          [
            19.136897,
            51.726368,
            190.55487
          ],
          [
            19.13659,
            51.726364,
            190.103672
          ],
          [
            19.136364,
            51.72625,
            189.997979
          ],
          [
            19.1365,
            51.726291,
            189.997979
          ],
          [
            19.136718,
            51.726374,
            189.997979
          ],
          [
            19.136657,
            51.726359,
            189.997979
          ],
          [
            19.136685,
            51.726362,
            189.997979
          ],
          [
            19.137047,
            51.726312,
            189.997979
          ],
          [
            19.136975,
            51.72628,
            189.997979
          ],
          [
            19.136979,
            51.726384,
            189.997979
          ],
          [
            19.136919,
            51.726394,
            189.997979
          ]
        ]
      }
    }
  ]
}

stepsGeojson.push(day1)
stepsGeojson.push(day2)
stepsGeojson.push(day3)
stepsGeojson.push(day4)
stepsGeojson.push(day5)
stepsGeojson.push(day6)
stepsGeojson.push(day7)
stepsGeojson.push(day9)
stepsGeojson.push(day12)
stepsGeojson.push(day13)
stepsGeojson.push(day14)
stepsGeojson.push(day15)
stepsGeojson.push(day16)
stepsGeojson.push(day17)
stepsGeojson.push(day18)
stepsGeojson.push(day19)
stepsGeojson.push(day20)
stepsGeojson.push(day21)
stepsGeojson.push(day22)
stepsGeojson.push(day23)
stepsGeojson.push(day24)
stepsGeojson.push(day25)
stepsGeojson.push(day27)
stepsGeojson.push(day28)
stepsGeojson.push(day29)
stepsGeojson.push(day30)
stepsGeojson.push(day31)
stepsGeojson.push(day32)
stepsGeojson.push(day33)
stepsGeojson.push(day34)
stepsGeojson.push(day35)
stepsGeojson.push(day36)
stepsGeojson.push(day37)
stepsGeojson.push(day38)
stepsGeojson.push(day39)
stepsGeojson.push(day40)
stepsGeojson.push(day41)
stepsGeojson.push(day42)
stepsGeojson.push(day43)
stepsGeojson.push(day44)
stepsGeojson.push(day45)
stepsGeojson.push(day46)
stepsGeojson.push(day48)
stepsGeojson.push(day49)
stepsGeojson.push(day50)
stepsGeojson.push(day51)

export { stepsGeojson };


